webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2961)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionDropDown__ = __webpack_require__(2263);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_0__ActionDropDown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Attachments__ = __webpack_require__(476);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_1__Attachments__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuditFields__ = __webpack_require__(2273);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_2__AuditFields__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Authorized__ = __webpack_require__(190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Authorized__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_3__Authorized__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AuthorizedOwner__ = __webpack_require__(768);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_4__AuthorizedOwner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ApprovalLabel__ = __webpack_require__(2265);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_5__ApprovalLabel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(2276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_6__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DetailTable_CheckForDetail__ = __webpack_require__(485);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_7__DetailTable_CheckForDetail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Delete__ = __webpack_require__(484);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_8__Delete__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DetailTable_DetailTable__ = __webpack_require__(776);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_9__DetailTable_DetailTable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DetailTable_Detail__ = __webpack_require__(152);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_10__DetailTable_Detail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ErrorBoundary__ = __webpack_require__(175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_11__ErrorBoundary__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__InventoryStatusCell__ = __webpack_require__(281);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_12__InventoryStatusCell__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ConfirmAction__ = __webpack_require__(191);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_13__ConfirmAction__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SearchFilter__ = __webpack_require__(2386);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_14__SearchFilter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__NavLink__ = __webpack_require__(2356);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_15__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DashedSeparator__ = __webpack_require__(279);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_16__DashedSeparator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LaunchModal__ = __webpack_require__(2343);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_17__LaunchModal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Modal__ = __webpack_require__(16);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_18__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AutoComplete__ = __webpack_require__(769);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_19__AutoComplete__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ConfirmDelete__ = __webpack_require__(342);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_20__ConfirmDelete__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Tag__ = __webpack_require__(2404);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_21__Tag__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ExternalLink__ = __webpack_require__(780);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_22__ExternalLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DropDown__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_23__DropDown__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_23__DropDown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Section__ = __webpack_require__(93);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_24__Section__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ShippingAddressTable__ = __webpack_require__(495);
/* unused harmony reexport ShippingAddressTable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ShippingSection__ = __webpack_require__(214);
/* unused harmony reexport ShippingSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__MonthSelect__ = __webpack_require__(2354);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_27__MonthSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__FilterSelect__ = __webpack_require__(2297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_28__FilterSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__FilterTag__ = __webpack_require__(2299);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_29__FilterTag__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Icon__ = __webpack_require__(792);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_30__Icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__IconText__ = __webpack_require__(2339);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_31__IconText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__IconReceived__ = __webpack_require__(2338);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_32__IconReceived__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__LinkedTableRow__ = __webpack_require__(2347);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_33__LinkedTableRow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__StatusTags__ = __webpack_require__(817);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_34__StatusTags__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_34__StatusTags__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__PurchaseOrderLineItemStatusCell__ = __webpack_require__(493);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_35__PurchaseOrderLineItemStatusCell__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__LineItemQtyCell__ = __webpack_require__(2344);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_36__LineItemQtyCell__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__RecordPager__ = __webpack_require__(284);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_37__RecordPager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Edit__ = __webpack_require__(2292);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_38__Edit__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Notes__ = __webpack_require__(802);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_39__Notes__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__NoteTooltip__ = __webpack_require__(65);
/* unused harmony reexport AuditedNoteTooltip */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_40__NoteTooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_40__NoteTooltip__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Search__ = __webpack_require__(2384);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_41__Search__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_41__Search__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__ClipboardCopy__ = __webpack_require__(339);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_42__ClipboardCopy__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Forms__ = __webpack_require__(8);
/* unused harmony reexport ShippingMethod */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Stat__ = __webpack_require__(2394);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_44__Stat__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__StatsTooltip_CompanyStats_CompanyStatsTooltip__ = __webpack_require__(2396);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_45__StatsTooltip_CompanyStats_CompanyStatsTooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__StatsTooltip_CompanyStats_Detail__ = __webpack_require__(813);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_46__StatsTooltip_CompanyStats_Detail__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_46__StatsTooltip_CompanyStats_Detail__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_46__StatsTooltip_CompanyStats_Detail__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__StatsTooltip_PartStats_PartStatsTooltip__ = __webpack_require__(2399);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_47__StatsTooltip_PartStats_PartStatsTooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__StatsTooltip_PartStats_Detail__ = __webpack_require__(814);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_48__StatsTooltip_PartStats_Detail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__StatsTooltip_InventoryStats_Detail__ = __webpack_require__(2398);
/* unused harmony reexport InventoryStatsDetail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__CompanyName__ = __webpack_require__(2288);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_50__CompanyName__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__PartNumber__ = __webpack_require__(804);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_51__PartNumber__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__TierTypeIcon__ = __webpack_require__(2406);
/* unused harmony reexport TierTypeIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__LocationFlag__ = __webpack_require__(351);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_53__LocationFlag__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__DataTables__ = __webpack_require__(775);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_54__DataTables__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_54__DataTables__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__PoCode__ = __webpack_require__(2380);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_55__PoCode__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__ToggleButton__ = __webpack_require__(2408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_56__ToggleButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Warning__ = __webpack_require__(498);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_57__Warning__["a"]; });



























































/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ACCOUNT_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return AIRCRAFT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return ADJUSTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return ADJUSTMENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return AS_REMOVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ATTACHMENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ATTACHMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return AUTO_ADJUST_SRP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return AWB_NUMBER; });
/* unused harmony export BEYOND_REPAIR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return BUY_AR_FOR_STOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return BUYER_CREDIT_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return CREDIT_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CAN_EXCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CARRIER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CLEAR_FILTERS_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return CONSIGNOR_PERCENTAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CREATED_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CREATED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CREATED_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CUSTOMER_PO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CUSTOMER_PURCHASE_ORDER_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return DAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return DEFAULT_HAZMAT_FEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return DEFAULT_NO_FAULT_FOUND_FEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return EXCHANGE_CREDIT_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return FREIGHT_COMPLETE_RESTRICTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return FUZZY_SIMILARITY_PERCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return LABEL_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return MIN_MANAGED_REPAIR_FEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return EXPECTED_QUANTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return FILE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return FILE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return FOB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return INVOICED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return QUANTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return QUANTITY_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return COMPANY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CONTACT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return DISABLE_QB_SYNC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return END_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return EXCHANGE_CORE_DUE_DAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ID; });
/* unused harmony export INSPECTED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return INVENTORY_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return INVENTORY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return LINE_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return LOGO_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return MARKUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return MINIMUM_EXCHANGE_SRP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return MINIMUM_REPAIR_FEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return MIN_OUTRIGHT_VALUE_FOR_EXCHANGE_CONSIDERATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return MONTHS; });
/* unused harmony export NEW */
/* unused harmony export NON_QUALIFIER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return NOT_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return OUTRIGHT_SALE; });
/* unused harmony export OVERHAULED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return PAYMENT_TERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return PURCHASE_ORDERS_QUICKBOOKS_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return QTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return QUICKBOOKS_INVENTORY_TRACKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return QUICKBOOKS_CUSTOMER_PURCHASE_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return REDUCE_COST_AT_SALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return REDUCE_REPAIR_COST_AT_SALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return REFERENCE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return REFERENCE_NUMBER_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return REFERENCE_RECORD_LINE_ITEM_TYPE; });
/* unused harmony export REPAIRED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return REPAIRS_FROM_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return RESERVE_FOR_SELLER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SERVICEABLE_TOOLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return SENT_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SHIPPING_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SHIPPING_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return SHIPPED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SHIPPING_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SHIPPING_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SHIP_TO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return SHIP_TO_SHIPPING_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SHIP_TO_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return SHIP_TO_CUSTOMER_ADDRESS_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SHIP_TO_COMPANY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SHIP_TO_ADDRESS_PHONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SHIP_TO_COMPANY_ADDRESS_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return SHIP_TO_FOB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return SHIP_TO_SHIPPING_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SHIP_TO_LOCATION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return SMALL_FILE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return SMALL_VERSION_CREATED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return SOLD_INVENTORY_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return START_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return SUBTOTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return SYNC_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return TIER_TYPE_WARNING_LIMITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return ULTIMATE_CONSIGNEE_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return FREIGHT_FORWARDER_ADDRESS; });
/* unused harmony export FREIGHT_FORWARDER_NAME */
/* unused harmony export FREIGHT_FORWARDER_EMAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return UPDATED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return UPDATED_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return TENANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return TOTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UUID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return WARRANTY_CONSIDERATION; });
/* unused harmony export WARRANTY_REQUESTED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return RETURN_TO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return RETURN_TO_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return RETURN_TO_FOB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return RETURN_TO_COMPANY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return RETURN_TO_COMPANY_ADDRESS_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return RETURN_TO_SHIPPING_ADDRESS_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return RETURN_TO_CUSTOMER_ADDRESS_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return RETURN_TO_LOCATION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return RETURN_TO_SHIPPING_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return RETURN_TO_SHIPPING_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return PHONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return PHONE1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return PASSWORD_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return PURCHASE_ORDER_BCC_EMAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CARE_OF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return COMPANY_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CONTACT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CONTACT_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return REGION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return LINE1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return LINE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return POSTAL_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return RECEIVING_BANK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return INTERMEDIARY_BANK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return ABA_ROUTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return ACH_ROUTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return SWIFT_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return BENEFICIARY_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return IBAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return ADDRESS_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CONDITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CONDITIONS_WITH_SERVICEABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DISCREET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return LABEL_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_BASE; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _CONDITIONS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ACCOUNT_NUMBER = "account_number";
var ADD = "Add";
var ADDRESS = "address";
var AIRCRAFT_ID = "aircraft_id";
var ADJUSTMENT = "adjustment";
var ADJUSTMENT_TYPE = "adjustment_type";
var AS_REMOVED = "as_removed";
var ATTACHMENT_TYPE = "attachment_type";
var ATTACHMENTS = "attachments";
var AUTO_ADJUST_SRP = "auto_adjust_srp";
var AWB_NUMBER = "awb_number";
var BEYOND_REPAIR = "beyond_econ_repair";
var BUY_AR_FOR_STOCK = "buyer_ar_for_stock";
var BUYER_CREDIT_PCT = "buyer_credit_pct";
var CANCELLED = "cancelled";
var CREDIT_REQUESTED = "credit_requested";
var CAN_EXCHANGE = "can_exchange";
var CARRIER = "carrier";
var CLEAR_FILTERS_TEXT = "Clear Filters - Show All";
var CODE = "code";
var COST = "cost";
var CONSIGNOR_PERCENTAGE = "consignor_percentage";
var CREATED_BY_ID = "created_by_id";
var CREATED_AT = "created_at";
var CREATED_BY = "created_by";
var CUSTOMER_PO = "customer_po";
var CUSTOMER_PURCHASE_ORDER_NUMBER = "customer_purchase_order_number";
var DAYS = "days";
var DEFAULT_HAZMAT_FEE = "default_hazmat_fee";
var DEFAULT_NO_FAULT_FOUND_FEE = "default_no_fault_found_fee";
var EXCHANGE_CREDIT_PCT = "exchange_credit_pct";
var FREIGHT_COMPLETE_RESTRICTION = "freight_complete_restriction";
var FUZZY_SIMILARITY_PERCENT = "fuzzy_similarity_percent";
var LABEL_SIZE = "label_size";
var MIN_MANAGED_REPAIR_FEE = "min_managed_repair_fee";
var EXPECTED_QUANTITY = "expected_quantity";
var FILE_SIZE = "file_size";
var FILE_URL = "file_url";
var FOB = "fob";
var INVOICED = "invoiced";
var QUANTITY = "quantity";
var QUANTITY_RECEIVED = "quantity_received";
var COMPANY_ID = "company_id";
var CONTACT_ID = "contact_id";
var DISABLED = "disabled";
var DISABLE_QB_SYNC = "disable_qb_sync";
var ENABLED = "enabled";
var END_DATE = "end_date";
var EXCHANGE_CORE_DUE_DAYS = "exchange_core_due_days";
var FILTERS = "filters";
var ID = "id";
var INSPECTED = "inspected";
var INVENTORY_ACCOUNT = "inventory_account";
var INVENTORY_ID = "inventory_id";
var LINE_ITEMS = "line_items";
var LOGO_URL = "logo_url";
var MARKUP = "markup";
var MINIMUM_EXCHANGE_SRP = "minimum_exchange_srp";
var MINIMUM_REPAIR_FEE = "minimum_repair_fee";
var MIN_OUTRIGHT_VALUE_FOR_EXCHANGE_CONSIDERATION = "min_outright_value_for_exchange_consideration";
var MONTH = "month";
var MONTHS = "months";
var NEW = "new_item";
var NON_QUALIFIER = "NON_QUALIFIER";
var NOTES = "notes";
var NOT_RECEIVED = "not_received";
var OUTRIGHT_SALE = "outright_sale";
var OVERHAULED = "overhauled";
var PAYMENT_TERMS = "payment_terms";
var PURCHASE_ORDERS_QUICKBOOKS_TYPE = "purchase_orders_quickbooks_type";

var QTY = "qty";
var QUICKBOOKS_INVENTORY_TRACKING = "quickbooks_inventory_tracking";
var QUICKBOOKS_CUSTOMER_PURCHASE_FIELD = "quickbooks_customer_purchase_field";
var REDUCE_COST_AT_SALE = "reduce_cost_at_sale";
var REDUCE_REPAIR_COST_AT_SALE = "reduce_repair_cost_at_sale";
var RECEIVED = "received";
var REFERENCE_NUMBER = "reference_number";
var REFERENCE_NUMBER_LABEL = "Ref #";
var REFERENCE_RECORD_LINE_ITEM_TYPE = "reference_record_line_item_type";
var REPAIRED = "repaired";
var REPAIRS_FROM_EMAIL = "repairs_from_email";
var RESERVE_FOR_SELLER_ID = "reserve_for_seller_id";
var SERVICEABLE_TOOLING = "serviceable_tooling";
var SETTINGS = "settings";
var SENT_EMAIL = "sent_email";
var SHIPPING_OPTIONS = "shipping_options";
var SHIPPING_TYPE = "shipping_type";
var SHIPPED = "shipped";
var SHIPPING_ADDRESS = "shipping_address";
var SHIPPING_METHOD = "shipping_method";
var SHIP_TO = "ship_to";
var SHIP_TO_SHIPPING_METHOD = "ship_to_shipping_method";
var SHIP_TO_TYPE = "ship_to_type";
var SHIP_TO_CUSTOMER_ADDRESS_ID = "ship_to_customer_address_id";
var SHIP_TO_COMPANY_ID = "ship_to_company_id";
var SHIP_TO_ADDRESS_PHONE = "ship_to_address_phone";
var SHIP_TO_COMPANY_ADDRESS_ID = "ship_to_company_address_id";
var SHIP_TO_FOB = "ship_to_fob";
var SHIP_TO_SHIPPING_ADDRESS = "ship_to_shipping_address";
var SHIP_TO_LOCATION_ID = "ship_to_location_id";
var SMALL_FILE_URL = "small_file_url";
var SMALL_VERSION_CREATED_AT = "small_version_created_at";
var SOLD_INVENTORY_ITEM = "sold_inventory_item";
var START_DATE = "start_date";
var SUBTOTAL = "subtotal";
var SYNC_DATE = "sync_date";
var TIER_TYPE_WARNING_LIMITS = "tier_type_warning_limits";
var ULTIMATE_CONSIGNEE_ADDRESS = "ultimate_consignee_address";
var FREIGHT_FORWARDER_ADDRESS = "freight_forwarder_address";
var FREIGHT_FORWARDER_NAME = "freight_forwarder_name";
var FREIGHT_FORWARDER_EMAIL = "freight_forwarder_email";
var UPDATED_AT = "updated_at";
var UPDATED_BY = "updated_by";
var TENANT = "tenant";
var TYPE = "type";
var TOTAL = "total";
var UUID = "uuid";
var WARRANTY_CONSIDERATION = "warranty_consideration";
var WARRANTY_REQUESTED = "warranty_requested";
var YEAR = "year";

var RETURN_TO = "return_to";
var RETURN_TO_TYPE = "return_to_type";
var RETURN_TO_FOB = "return_to_fob";
var RETURN_TO_COMPANY_ID = "return_to_company_id";
var RETURN_TO_COMPANY_ADDRESS_ID = "return_to_company_address_id";
var RETURN_TO_SHIPPING_ADDRESS_ID = "return_to_shipping_address_id";
var RETURN_TO_CUSTOMER_ADDRESS_ID = "return_to_customer_address_id";
var RETURN_TO_LOCATION_ID = "return_to_location_id";
var RETURN_TO_SHIPPING_ADDRESS = "return_to_shipping_address";
var RETURN_TO_SHIPPING_METHOD = "return_to_shipping_method";

var NAME = "name";
var PHONE = "phone";
var PHONE1 = "phone1";
var EMAIL = "email";
var PASSWORD = "password";
var PASSWORD_CONFIRMATION = "password_confirmation";
var PURCHASE_ORDER_BCC_EMAILS = "purchase_order_bcc_emails";

var CARE_OF = "care_of";
var COMPANY = "company";
var COMPANY_NAME = "company_name";
var CONTACT_NAME = "contact_name";
var CONTACT_EMAIL = "contact_email";
var COUNTRY = "country";
var REGION = "region";
var LINE1 = "line1";
var LINE2 = "line2";
var CITY = "city";
var STATE = "state";
var POSTAL_CODE = "postal_code";

var RECEIVING_BANK_NAME = "receiving_bank_name";
var INTERMEDIARY_BANK = "intermediary_bank";
var ABA_ROUTING = "aba_routing";
var ACH_ROUTING = "ach_routing";
var SWIFT_CODE = "swift_code";
var BENEFICIARY_ACCOUNT = "beneficiary_account";
var IBAN = "iban";

var ADDRESS_FIELDS = [CARE_OF, COMPANY_NAME, CONTACT_NAME, COUNTRY, LINE1, LINE2, CITY, STATE, POSTAL_CODE];

var CONDITIONS = (_CONDITIONS = {}, _defineProperty(_CONDITIONS, NEW, {
  abbrev: "NE",
  label: "New",
  default_warranty: "1 year"
}), _defineProperty(_CONDITIONS, OVERHAULED, {
  abbrev: "OH",
  label: "Overhauled",
  default_warranty: "1 year"
}), _defineProperty(_CONDITIONS, REPAIRED, {
  abbrev: "SV",
  label: "Repaired",
  default_warranty: "6 months"
}), _defineProperty(_CONDITIONS, INSPECTED, {
  abbrev: "BT",
  label: "Inspected",
  default_warranty: "30 days"
}), _defineProperty(_CONDITIONS, AS_REMOVED, {
  abbrev: "AR",
  label: "As Removed"
}), _defineProperty(_CONDITIONS, BEYOND_REPAIR, {
  abbrev: "BR",
  label: "Beyond Repair"
}), _CONDITIONS);

var CONDITIONS_WITH_SERVICEABLE = _extends({}, CONDITIONS, _defineProperty({}, SERVICEABLE_TOOLING, {
  abbrev: "SV",
  label: "Serviceable Tooling",
  default_warranty: "30 days"
}));

var DISCREET = "discreet";

var LABEL_SIZES = [{ text: '4" x 6" (10.15cm x 15.25cm)', value: "4x6" }, { text: '3" x 4" (7.62cm x 10.15cm)', value: "3x4" }];

var API_BASE = window.location.origin.includes("localhost") || window.location.origin.includes("ngrok") ? "https://rql.aero-zone.com/v1" : window.location.origin + "/v1";

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.10';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Gets the value at `key`, unless `key` is "__proto__".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function safeGet(object, key) {
    return key == '__proto__'
      ? undefined
      : object[key];
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127), __webpack_require__(262)(module)))

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accordion__ = __webpack_require__(2973);
/* unused harmony reexport Accordion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Alert__ = __webpack_require__(2974);
/* unused harmony reexport Alert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Badge__ = __webpack_require__(2975);
/* unused harmony reexport Badge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Breadcrumb__ = __webpack_require__(2976);
/* unused harmony reexport Breadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BreadcrumbItem__ = __webpack_require__(1074);
/* unused harmony reexport BreadcrumbItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(309);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonGroup__ = __webpack_require__(578);
/* unused harmony reexport ButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonToolbar__ = __webpack_require__(2977);
/* unused harmony reexport ButtonToolbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Carousel__ = __webpack_require__(2978);
/* unused harmony reexport Carousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(1075);
/* unused harmony reexport CarouselItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Checkbox__ = __webpack_require__(2980);
/* unused harmony reexport Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Clearfix__ = __webpack_require__(2981);
/* unused harmony reexport Clearfix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CloseButton__ = __webpack_require__(579);
/* unused harmony reexport CloseButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ControlLabel__ = __webpack_require__(2983);
/* unused harmony reexport ControlLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Col__ = __webpack_require__(2982);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_14__Col__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Collapse__ = __webpack_require__(580);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_15__Collapse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Dropdown__ = __webpack_require__(394);
/* unused harmony reexport Dropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DropdownButton__ = __webpack_require__(2984);
/* unused harmony reexport DropdownButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Fade__ = __webpack_require__(395);
/* unused harmony reexport Fade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Form__ = __webpack_require__(2986);
/* unused harmony reexport Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FormControl__ = __webpack_require__(2987);
/* unused harmony reexport FormControl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FormGroup__ = __webpack_require__(2990);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_21__FormGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Glyphicon__ = __webpack_require__(581);
/* unused harmony reexport Glyphicon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Grid__ = __webpack_require__(1077);
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__HelpBlock__ = __webpack_require__(2991);
/* unused harmony reexport HelpBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Image__ = __webpack_require__(2992);
/* unused harmony reexport Image */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__InputGroup__ = __webpack_require__(2993);
/* unused harmony reexport InputGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Jumbotron__ = __webpack_require__(2996);
/* unused harmony reexport Jumbotron */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Label__ = __webpack_require__(2997);
/* unused harmony reexport Label */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ListGroup__ = __webpack_require__(2998);
/* unused harmony reexport ListGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ListGroupItem__ = __webpack_require__(1078);
/* unused harmony reexport ListGroupItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Media__ = __webpack_require__(582);
/* unused harmony reexport Media */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__MenuItem__ = __webpack_require__(3005);
/* unused harmony reexport MenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Modal__ = __webpack_require__(3006);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_33__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ModalBody__ = __webpack_require__(1079);
/* unused harmony reexport ModalBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ModalFooter__ = __webpack_require__(1080);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_35__ModalFooter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ModalHeader__ = __webpack_require__(1081);
/* unused harmony reexport ModalHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ModalTitle__ = __webpack_require__(1082);
/* unused harmony reexport ModalTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Nav__ = __webpack_require__(1083);
/* unused harmony reexport Nav */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Navbar__ = __webpack_require__(3009);
/* unused harmony reexport Navbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__NavbarBrand__ = __webpack_require__(1085);
/* unused harmony reexport NavbarBrand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__NavDropdown__ = __webpack_require__(3008);
/* unused harmony reexport NavDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__NavItem__ = __webpack_require__(1084);
/* unused harmony reexport NavItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Overlay__ = __webpack_require__(1086);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_43__Overlay__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__OverlayTrigger__ = __webpack_require__(3013);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_44__OverlayTrigger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__PageHeader__ = __webpack_require__(3014);
/* unused harmony reexport PageHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__PageItem__ = __webpack_require__(3015);
/* unused harmony reexport PageItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Pager__ = __webpack_require__(3016);
/* unused harmony reexport Pager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Pagination__ = __webpack_require__(3017);
/* unused harmony reexport Pagination */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__PaginationButton__ = __webpack_require__(1088);
/* unused harmony reexport PaginationButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Panel__ = __webpack_require__(3018);
/* unused harmony reexport Panel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__PanelGroup__ = __webpack_require__(1089);
/* unused harmony reexport PanelGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Popover__ = __webpack_require__(3019);
/* unused harmony reexport Popover */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ProgressBar__ = __webpack_require__(3020);
/* unused harmony reexport ProgressBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Radio__ = __webpack_require__(3021);
/* unused harmony reexport Radio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ResponsiveEmbed__ = __webpack_require__(3022);
/* unused harmony reexport ResponsiveEmbed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Row__ = __webpack_require__(3023);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_56__Row__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__SafeAnchor__ = __webpack_require__(163);
/* unused harmony reexport SafeAnchor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__SplitButton__ = __webpack_require__(3024);
/* unused harmony reexport SplitButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Tab__ = __webpack_require__(3026);
/* unused harmony reexport Tab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__TabContainer__ = __webpack_require__(583);
/* unused harmony reexport TabContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__TabContent__ = __webpack_require__(584);
/* unused harmony reexport TabContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Table__ = __webpack_require__(3027);
/* unused harmony reexport Table */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__TabPane__ = __webpack_require__(1090);
/* unused harmony reexport TabPane */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Tabs__ = __webpack_require__(3028);
/* unused harmony reexport Tabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Thumbnail__ = __webpack_require__(3029);
/* unused harmony reexport Thumbnail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ToggleButton__ = __webpack_require__(1091);
/* unused harmony reexport ToggleButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__ToggleButtonGroup__ = __webpack_require__(3030);
/* unused harmony reexport ToggleButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Tooltip__ = __webpack_require__(3031);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_68__Tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Well__ = __webpack_require__(3032);
/* unused harmony reexport Well */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__utils__ = __webpack_require__(3036);
/* unused harmony reexport utils */















































































































































/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pubsub_js__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pubsub_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pubsub_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_parts_api__ = __webpack_require__(2126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__session__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* unused harmony export adapter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleSubmissionError; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













var adapter = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_10__constants__["d" /* API_BASE */],
  timeout: 35000,
  withCredentials: true,
  headers: {
    Accept: "application/json"
  }
});

var releaseIdInterceptor = function releaseIdInterceptor(response) {
  if (response.headers && response.headers["x-release-id"]) {
    __WEBPACK_IMPORTED_MODULE_1_pubsub_js___default.a.publish("releaseId.read", response.headers["x-release-id"]);
  }
  return response;
};

adapter.interceptors.response.use(releaseIdInterceptor);

adapter.interceptors.response.use(undefined, function (error) {
  if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(error, "response.status") === 403) {
    __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Unauthorized", "Sorry, you're not authorized to perform this action.");
  }

  return Promise.reject(error);
});

adapter.interceptors.response.use(undefined, function (error) {
  if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(error, "response.status") === 500) {
    __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Error", "An unexpected error occurred.");
  }

  return Promise.reject(error);
});

adapter.interceptors.response.use(undefined, function (error) {
  if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(error, "response.status") === 422 && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(error, "response.data.errors")) {
    // handle invalid reserve items gracefully
    var responseURL = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(error, "response.request.responseURL");

    if (responseURL.includes("cart_items")) {
      __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Error", __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(error, "response.data.message"));
    }

    if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(error, "response.data.errors.status") || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(error, "response.data.errors.repair_status")) {
      __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Error", "Action cannot be performed on inventory");
    }

    // Assign ActiveRecord "base" error messages to redux-form's special "_errors" key.
    var errors = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(error, "response.data.errors");

    Object.keys(errors).forEach(function (errorKey) {
      if (errorKey === "base") {
        errors._error = errors.base; // eslint-disable-line no-underscore-dangle
      } else if (errorKey.endsWith(".base")) {
        var withoutBase = errorKey.substring(0, errorKey.indexOf(".base"));
        errors[withoutBase + "._error"] = errors[withoutBase + ".base"];
      }
    });

    throw new __WEBPACK_IMPORTED_MODULE_2_redux_form__["SubmissionError"](__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.zipObjectDeep(Object.keys(errors), Object.values(errors)));
  }

  return Promise.reject(error);
});

var handleSubmissionError = function handleSubmissionError(error) {
  if (error instanceof __WEBPACK_IMPORTED_MODULE_2_redux_form__["SubmissionError"]) {
    var keys = Object.keys(error.errors);
    var msg = keys.map(function (k) {
      if (k === "base") return null;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["a" /* properCaseField */])(k) + ": " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["b" /* toSentence */])(error.errors[k]);
    }).filter(function (f) {
      return f;
    });
    __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Error", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["b" /* toSentence */])(msg));
  } else {
    // Handle other errors
    throw error;
  }
};

adapter.interceptors.response.use(function (config) {
  return config;
}, function (error) {
  if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(error, "response.status") === 408 || error.code === "ECONNABORTED") {
    // Normalize error code for timeouts so our forms can properly handle them without knowing specific HTTP status and error codes.
    return Promise.reject(Object.assign({}, error, { code: "TIMEOUT" }));
  }
  return Promise.reject(error);
});

adapter.interceptors.response.use(undefined, function (error) {
  if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(error, "response.status") === 401) {
    __WEBPACK_IMPORTED_MODULE_1_pubsub_js___default.a.publish("session.expired");
    __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Session Expired", "Your session has expired. Please log in again to continue.");

    return Promise.resolve(error);
  }

  if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(error, "response.status") === 418) {
    return Promise.reject(error.response.data);
  }

  if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(error, "response.status") === 501 && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(error, "response.data.errors")) {
    return Promise.reject(error.response.data);
  }

  return Promise.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = ({
  accountingLogs: {
    search: function search() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        page: 1,
        limit: 20,
        sort: "id",
        reverse: true,
        filter: true
      };
      return adapter.post("/accounting_logs/search", {
        search: params
      });
    }
  },
  aircrafts: {
    search: function search(_search) {
      return adapter.post("/aircraft/search", { search: _search });
    }
  },
  applications: {
    delete: function _delete(id) {
      return adapter.delete("/applications/" + id);
    }
  },
  appSetting: {
    index: function index() {
      return adapter.get("/app_setting");
    },
    update: function update(data) {
      return adapter.put("/app_setting", { app_setting: data }).then(function (resp) {
        __WEBPACK_IMPORTED_MODULE_9__session__["a" /* default */].setSettings(resp.data.settings);
        return resp;
      });
    }
  },
  consignments: {
    create: function create(params) {
      return adapter.post("/consignments", { consignment: params });
    },
    export: function _export(params) {
      return adapter.get("/consignments/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_query_string__["stringify"])(params));
    },
    import: function _import(id, params) {
      return adapter.post("/consignments/" + id + "/import", { consignment: params });
    },
    inventories: {
      search: function search(id, _search2) {
        return adapter.post("/consignments/" + id + "/inventories/search", { search: _search2 });
      }
    },
    lineItems: {
      search: function search(id, _search3) {
        return adapter.post("/consignments/" + id + "/line_items/search", { search: _search3 });
      }
    },
    report: function report(data) {
      return adapter.post("/consignments/report", { data: data });
    },
    search: function search(_search4) {
      return adapter.post("/consignments/search", { search: _search4 });
    },
    show: function show(id) {
      return adapter.get("/consignments/" + id);
    },
    update: function update(id, params) {
      return adapter.put("/consignments/" + id, { consignment: params });
    }
  },
  engines: {
    search: function search(_search5) {
      return adapter.post("/engines/search", { search: _search5 });
    }
  },
  session: {
    authenticate: function authenticate(_ref) {
      var email = _ref.email,
          password = _ref.password,
          push_id = _ref.push_id;
      return adapter.post("/session", { email: email, password: password, push_id: push_id }).then(function (resp) {
        __WEBPACK_IMPORTED_MODULE_9__session__["a" /* default */].login(resp.data.user, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(resp, "data.settings.settings"));
        return resp;
      });
    },
    verifyPush: function verifyPush(_ref2) {
      var email = _ref2.email,
          password = _ref2.password,
          pushIds = _ref2.pushIds;
      return adapter.post("/session/verify_push", {
        email: email,
        password: password,
        push_ids: pushIds
      });
    },
    logout: function logout() {
      return adapter.delete("/session");
    },
    parts: function parts() {
      return adapter.get("/session/parts");
    },
    tenant: function tenant() {
      return adapter.get("/session/tenant");
    }
  },
  commercialInvoices: {
    create: function create(data) {
      return adapter.post("/commercial_invoices", { commercial_invoice: data });
    }
  },
  commissions: {
    export: function _export(params) {
      return adapter.get("/commissions/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_query_string__["stringify"])(params));
    },
    search: function search(params) {
      return adapter.post("/commissions/search", {
        search: _extends({}, params, { reverse: true })
      });
    },
    payAll: function payAll(data) {
      return adapter.post("/commissions/pay_all", {
        commissions: data
      });
    },
    update: function update(id, data) {
      return adapter.put("/commissions/" + id, { commission: data });
    }
  },
  incomingQuotes: {
    customerFind: function customerFind(id, code) {
      return adapter.get("/customers/" + id + "/find_incoming_quote?c=" + code);
    },
    customerUpdate: function customerUpdate(id, data) {
      return adapter.put("/customers/" + id + "/incoming_quote", { incoming_quote: data });
    },
    export: function _export(params) {
      return adapter.get("/incoming_quotes/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_query_string__["stringify"])(params));
    },
    update: function update(id, data) {
      return adapter.put("/incoming_quotes/" + id, { incoming_quote: data });
    },
    upload: function upload(filename) {
      return adapter.get("/customers/upload", { params: { filename: filename } });
    },
    search: function search(params) {
      return adapter.post("/incoming_quotes/search", { search: params });
    },
    send: function send(id, data) {
      return adapter.post("/incoming_quotes/" + id + "/send_pdf", {
        incoming_quote: data
      });
    },
    show: function show(id) {
      var presenter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      return adapter.get("/incoming_quotes/" + id + (presenter ? "?presenter=" + presenter : ""));
    },
    delete: function _delete(id) {
      return adapter.delete("/incoming_quotes/" + id);
    },
    convertToPurchaseOrder: function convertToPurchaseOrder(quoteId, data) {
      return adapter.post("/incoming_quotes/" + quoteId + "/purchase_orders/copy_quote", {
        purchase_order: data
      });
    },
    lineItems: {
      convertToOutgoingQuote: function convertToOutgoingQuote(quoteId, data) {
        return adapter.post("/incoming_quote_line_items/" + quoteId + "/convert_to_outgoing_quote", {
          incoming_quote: data
        });
      },
      create: function create(id, item) {
        return adapter.post("/incoming_quotes/" + id + "/incoming_quote_line_items", {
          incoming_quote_line_item: item
        });
      },
      import: function _import(id, data) {
        return adapter.put("incoming_quotes/" + id + "/incoming_quote_line_items/import", {
          incoming_quote: data
        });
      },
      search: function search(id, _search6) {
        return adapter.post("incoming_quotes/" + id + "/incoming_quote_line_items/search", {
          search: _search6
        });
      },
      update: function update(itemID, item) {
        return adapter.put("incoming_quote_line_items/" + itemID, {
          incoming_quote_line_item: item
        });
      },
      delete: function _delete(id) {
        return adapter.delete("/incoming_quote_line_items/" + id);
      }
    }
  },
  integrations: {
    quickbooks: {
      oauth: function oauth(id) {
        return adapter.get("/integrations/quickbooks_oauth/oauth?location_id=" + encodeURIComponent(id));
      },
      redirect: function redirect(data) {
        return adapter.post("/integrations/quickbooks_oauth/redirect", {
          quickbooks: data
        });
      }
    }
  },
  locations: {
    locationSetting: {
      quickbooksLocationSetting: function quickbooksLocationSetting(locationId) {
        return adapter.get("/locations/" + locationId + "/location_setting/quickbooks_location_setting");
      },
      show: function show(locationId) {
        return adapter.get("/locations/" + locationId + "/location_setting");
      },
      update: function update(locationId, params, defaultAccount) {
        return adapter.put("/locations/" + locationId + "/location_setting", {
          location_setting: {
            settings: params,
            default_quickbooks_account: defaultAccount
          }
        });
      }
    },
    quickbooks: {
      accounts: {
        search: function search(locationId, filter) {
          return adapter.post("/locations/" + locationId + "/quickbooks_accounts/search", {
            search: { filter: filter }
          });
        }
      },
      customers: {
        search: function search(locationId, filter) {
          return adapter.post("locations/" + locationId + "/quickbooks_customers/search", {
            search: { filter: filter }
          });
        }
      },
      items: {
        search: function search(locationId, filter) {
          var types = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          return adapter.post("locations/" + locationId + "/quickbooks_items/search", {
            search: { filter: filter, types: types }
          });
        }
      },
      preferences: {
        search: function search(locationId, filter) {
          return adapter.post("locations/" + locationId + "/quickbooks_preferences/search", {
            search: { filter: filter }
          });
        }
      },
      resync: function resync(locationId) {
        return adapter.post("/quickbooks/locations/" + locationId + "/resync");
      },
      vendors: {
        search: function search(locationId, filter) {
          return adapter.post("/locations/" + locationId + "/quickbooks_vendors/search", {
            search: { filter: filter }
          });
        }
      }
    },
    search: function search() {
      return adapter.post("/locations/search");
    }
  },
  managedRepairOrders: {
    create: function create(data) {
      return adapter.post("/managed_repair_orders", { managed_repair_order: data });
    },
    lineItems: {
      bulkUpdate: function bulkUpdate(id, data) {
        return adapter.put("/managed_repair_orders/" + id + "/line_items/bulk_update", {
          managed_repair_order: data
        });
      },
      create: function create(id, item) {
        return adapter.post("/managed_repair_orders/" + id + "/line_items", {
          line_item: item
        });
      },
      returnToCustomer: function returnToCustomer(id) {
        return adapter.post("/managed_repair_order_line_items/" + id + "/return_to_customer");
      },
      update: function update(id, item) {
        return adapter.put("/managed_repair_order_line_items/" + id, {
          line_item: item
        });
      }
    },
    search: function search(params) {
      return adapter.post("/managed_repair_order_line_items/search", {
        search: params
      });
    },
    sync: function sync(id) {
      return adapter.post("/managed_repair_orders/" + id + "/sync");
    },
    show: function show(id) {
      return adapter.get("/managed_repair_orders/" + id);
    },
    update: function update(id, data) {
      return adapter.put("/managed_repair_orders/" + id, {
        managed_repair_order: data
      });
    }
  },
  outgoingQuotes: {
    autoFollowup: function autoFollowup(id, params) {
      return adapter.post("/outgoing_quotes/" + id + "/auto_followup", {
        outgoing_quote: params
      });
    },
    create: function create(data) {
      return adapter.post("/outgoing_quotes", { outgoing_quote: data });
    },
    export: function _export(params) {
      return adapter.get("/outgoing_quotes/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_query_string__["stringify"])(params));
    },
    update: function update(id, data) {
      return adapter.put("/outgoing_quotes/" + id, { outgoing_quote: data });
    },
    search: function search(params) {
      return adapter.post("/outgoing_quotes/search", { search: params });
    },
    send: function send(id, data) {
      return adapter.post("/outgoing_quotes/" + id + "/send_pdf", {
        outgoing_quote: data
      });
    },
    show: function show(id) {
      return adapter.get("/outgoing_quotes/" + id);
    },
    lineItems: {
      create: function create(id, item) {
        return adapter.post("/outgoing_quotes/" + id + "/outgoing_quote_line_items", {
          outgoing_quote_line_item: item
        });
      },
      import: function _import(id, data) {
        return adapter.put("outgoing_quotes/" + id + "/outgoing_quote_line_items/import", {
          outgoing_quote: data
        });
      },
      update: function update(itemId, item) {
        return adapter.put("outgoing_quote_line_items/" + itemId, {
          outgoing_quote_line_item: item
        });
      },
      delete: function _delete(id) {
        return adapter.delete("outgoing_quote_line_items/" + id);
      }
    }
  },
  parts: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__modules_parts_api__["a" /* default */])(adapter),
  password: {
    reset: function reset(data) {
      return adapter.post("/password/reset", { user: data });
    },
    forgot: function forgot(email) {
      return adapter.post("/password/forgot", { user: { email: email } });
    }
  },
  repairOrders: {
    cancel: function cancel(id, cancellationReason) {
      return adapter.post("/repair_orders/" + id + "/toggle_cancelled", {
        repair_order: { cancellation_reason: cancellationReason }
      });
    },
    convert: function convert(data) {
      return adapter.post("/repair_orders/convert", { repair_order: data });
    },
    export: function _export(params) {
      return adapter.get("/repair_orders/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_query_string__["stringify"])(params));
    },
    find: function find(id) {
      return adapter.get("/repair_orders/" + id + "/find");
    },
    update: function update(id, data) {
      return adapter.put("/repair_orders/" + id, { repair_order: data });
    },
    previewQuote: function previewQuote(id) {
      return adapter.get("/repair_orders/" + id + "/preview_quote_email");
    },
    previewRequest: function previewRequest(id) {
      return adapter.get("/repair_orders/" + id + "/preview_request_email");
    },
    search: function search(params) {
      return adapter.post("/repair_orders/search", { search: params });
    },
    sync: function sync(id) {
      return adapter.post("/repair_orders/" + id + "/sync");
    },
    orderSearch: function orderSearch(params) {
      return adapter.post("/repair_orders/order_search", { search: params });
    },
    preview: function preview(id, _ref3) {
      var type = _ref3.type;
      return adapter.get("/repair_orders/" + id + "/preview_email?type=" + type);
    },
    send: function send(id, data) {
      return adapter.post("/repair_orders/" + id + "/send_pdf", { email: data });
    },
    show: function show(id) {
      return adapter.get("/repair_orders/" + id);
    },
    sendRepairOrderEmail: function sendRepairOrderEmail(id, data) {
      return adapter.post("/repair_orders/" + id + "/send_ro_email", { email: data });
    },
    lineItems: {
      approve: function approve(id, data) {
        return adapter.post("/repair_order_line_items/" + id + "/approve_final_evaluation", { line_item: data });
      },
      bulkUpdate: function bulkUpdate(repairOrderId, data) {
        return adapter.post("/repair_orders/" + repairOrderId + "/line_items/bulk_update", {
          repair_order: data
        });
      },
      cancelVendorRmaRequest: function cancelVendorRmaRequest(id) {
        return adapter.post("/repair_order_line_items/" + id + "/cancel_vendor_rma_request");
      },
      cancel: function cancel(id, reason) {
        return adapter.put("/repair_order_line_items/" + id, {
          line_item: { cancelled: true, cancellation_reason: reason }
        });
      },
      create: function create(id, item) {
        return adapter.post("/repair_orders/" + id + "/line_items", { line_item: item });
      },
      deleteExpectedComponent: function deleteExpectedComponent(id) {
        return adapter.delete("/repair_order_line_items/" + id + "/delete_expected_component");
      },
      import: function _import(id, data) {
        return adapter.put("/repair_orders/" + id + "/line_items/import", {
          line_item: data
        });
      },
      removeMainComponent: function removeMainComponent(id) {
        return adapter.post("/repair_order_line_items/" + id + "/remove_main_component");
      },
      requiredComponents: {
        create: function create(id, item) {
          return adapter.post("/repair_order_line_items/" + id + "/required_component_quotes", { required_component_quote: item });
        },
        search: function search(id, params) {
          return adapter.post("/repair_order_line_items/" + id + "/required_component_quotes/search", {
            search: params
          });
        }
      },
      update: function update(id, item) {
        return adapter.put("/repair_order_line_items/" + id, { line_item: item });
      },
      search: function search(id, params) {
        return adapter.post("/repair_orders/" + id + "/line_items/search", {
          search: params
        });
      },
      shopAssistCostItem: function shopAssistCostItem(id, params) {
        return adapter.post("/repair_order_line_items/" + id + "/shop_assist_cost_savings", { line_item: params });
      },
      shopAssistItems: function shopAssistItems(params) {
        return adapter.post("/repair_order_line_items/shop_assist_line_items", {
          search: params
        });
      },
      transfer: function transfer(id, params) {
        return adapter.post("/repair_order_line_items/" + id + "/transfer", {
          line_item: params
        });
      },
      vendorRmaRequest: function vendorRmaRequest(id, params) {
        return adapter.post("/repair_order_line_items/" + id + "/vendor_rma_request", {
          line_item: params
        });
      }
    }
  },
  repairQuotes: {
    create: function create(params) {
      return adapter.post("/repair_quotes", { repair_quote: params });
    },
    delete: function _delete(id) {
      return adapter.delete("/repair_quotes/" + id);
    },
    update: function update(id, params) {
      return adapter.put("/repair_quotes/" + id, { repair_quote: params });
    },
    show: function show(id) {
      return adapter.get("/repair_quotes/" + id);
    },
    preview: function preview(id) {
      return adapter.get("/repair_quotes/" + id + "/preview_email");
    },
    send: function send(id, data) {
      return adapter.post("/repair_quotes/" + id + "/send_email", { email: data });
    }
  },
  returnedConsignment: {
    show: function show(id) {
      return adapter.get("/returned_consignments/" + id);
    }
  },
  returnToCustomerRecords: {
    show: function show(id) {
      return adapter.get("/return_to_customer_records/" + id);
    }
  },
  alternates: {
    update: function update(id, alternate) {
      return adapter.put("/alternates/" + id, { alternate: alternate });
    },
    delete: function _delete(id) {
      return adapter.delete("/alternates/" + id);
    }
  },
  companies: {
    aircrafts: {
      create: function create(companyId, params) {
        return adapter.post("/companies/" + companyId + "/aircrafts", { aircraft: params });
      },
      delete: function _delete(companyId, aircraftId) {
        return adapter.delete("/companies/" + companyId + "/aircrafts/" + aircraftId);
      },
      search: function search(companyId, _search7) {
        return adapter.post("/companies/" + companyId + "/aircrafts/search", { search: _search7 });
      }
    },
    create: function create(company) {
      return adapter.post("/companies", { company: company });
    },
    export: function _export(params) {
      return adapter.get("/companies/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_query_string__["stringify"])(params));
    },
    search: function search(params) {
      return adapter.post("/companies/search", { search: params });
    },
    searchWithAddress: function searchWithAddress(params) {
      return adapter.post("/companies/search", {
        search: Object.assign({ search_billing_address: true }, params)
      });
    },
    sendUltimateConsigneeForm: function sendUltimateConsigneeForm(id, params) {
      return adapter.post("/companies/" + id + "/send_ultimate_consignee_form", {
        email: params
      });
    },
    show: function show(id) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "detail";
      return adapter.get("/companies/" + id + "?type=" + type);
    },
    update: function update(id, company) {
      return adapter.put("/companies/" + id, { company: company });
    },
    contacts: {
      search: function search(companyId, params) {
        return adapter.post("companies/" + companyId + "/contacts/search", {
          search: Object.assign({ type: "detail" }, params)
        });
      },
      create: function create(companyId, contact) {
        return adapter.post("/companies/" + companyId + "/contacts", { contact: contact });
      }
    },
    parts: {
      history: function history(companyId, partIds) {
        return adapter.get("/companies/" + companyId + "/parts/history?part_ids=" + partIds.join(","));
      }
    },
    physicalAddresses: {
      search: function search(companyId, params) {
        return adapter.post("companies/" + companyId + "/physical_addresses/search", {
          search: Object.assign({ type: "detail" }, params)
        });
      },
      create: function create(id, address) {
        return adapter.post("/companies/" + id + "/physical_addresses", {
          physical_address: address
        });
      }
    },
    rankingStats: function rankingStats(_ref4) {
      var endDate = _ref4.endDate,
          startDate = _ref4.startDate;
      return adapter.get("companies/ranking_stats", {
        params: { end_date: endDate, start_date: startDate }
      });
    },
    relatedCompanies: {
      create: function create(id, relatedCompany) {
        return adapter.post("/companies/" + id + "/related_companies", {
          related_company: relatedCompany
        });
      },
      search: function search(companyId, params) {
        return adapter.post("companies/" + companyId + "/related_companies/search", {
          search: params
        });
      }
    },
    shippingMethods: {
      search: function search(companyId, params) {
        return adapter.post("companies/" + companyId + "/shipping_methods/search", {
          search: Object.assign({ type: "detail" }, params)
        });
      },
      create: function create(id, shippingMethod) {
        return adapter.post("/companies/" + id + "/shipping_methods", {
          shipping_method: shippingMethod
        });
      }
    },
    repairStationStatusLastVerified: function repairStationStatusLastVerified(id, params) {
      return adapter.put("/companies/" + id + "/repair_station_status_last_verified_details", { company: params });
    },
    vendorStatusLastVerified: function vendorStatusLastVerified(id, params) {
      return adapter.put("/companies/" + id + "/vendor_status_last_verified_details", {
        company: params
      });
    }
  },
  users: {
    create: function create(user) {
      return adapter.post("/users", { user: user });
    },
    enableMfa: function enableMfa(id) {
      return adapter.post("/users/" + id + "/enable_mfa");
    },
    search: function search(params) {
      return adapter.post("/users/search", { search: params });
    },
    show: function show(id) {
      return adapter.get("/users/" + id);
    },
    update: function update(id, user) {
      return adapter.put("/users/" + id, { user: user });
    },
    requestVerification: function requestVerification(id) {
      return adapter.post("/users/" + id + "/send_verification_request");
    },
    verifyEmail: function verifyEmail(id, data) {
      return adapter.post("/users/" + id + "/verify_email", { user: data });
    }
  },
  notifications: {
    search: function search() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        page: 1,
        limit: 20,
        sort: "id",
        reverse: true,
        filter: true
      };
      return adapter.post("/notifications/search", {
        search: params
      });
    },
    update: function update(id, notification) {
      return adapter.put("/notifications/" + id, { notification: notification });
    },
    markAllRead: function markAllRead(search) {
      return adapter.put("/notifications/mark_all_read", { search: search });
    }
  },
  attachments: {
    list: function list(id, type) {
      return adapter.post(type + "/" + id + "/attachments/search", {
        search: { limit: 100, sort: "id" }
      });
    },
    create: function create(id, type, attachment) {
      return adapter.post("/" + type + "/" + id + "/attachments", { attachment: attachment });
    },
    upload: function upload(filename) {
      return adapter.get("/attachments/upload", { params: { filename: filename } });
    },
    update: function update(id, attachment) {
      return adapter.put("/attachments/" + id, { attachment: attachment });
    },
    destroy: function destroy(id) {
      return adapter.delete("/attachments/" + id);
    },
    toS3: function toS3(url, file) {
      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(url, file, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
    }
  },
  notes: {
    index: function index(id, type, notesType) {
      return adapter.post("/" + type + "/" + id + "/notes/search", {
        search: { limit: 100, notes_type: notesType }
      });
    },
    create: function create(id, type, note) {
      return adapter.post("/" + type + "/" + id + "/notes", { note: note });
    },
    update: function update(id, type, note) {
      return adapter.put("/" + type + "/" + id + "/notes/" + note.id, { note: note });
    },
    delete: function _delete(id, type, note) {
      return adapter.delete("/" + type + "/" + id + "/notes/" + note.id);
    }
  },
  shippingMethods: {
    update: function update(shippingMethod) {
      return adapter.put("shipping_methods/" + shippingMethod.id, {
        shipping_method: shippingMethod
      });
    },
    destroy: function destroy(id) {
      return adapter.delete("shipping_methods/" + id);
    }
  },
  contacts: {
    list: function list(params) {
      return adapter.get("/contacts", { params: params });
    },
    update: function update(contact) {
      return adapter.put("contacts/" + contact.id, { contact: contact });
    },
    destroy: function destroy(id) {
      return adapter.delete("/contacts/" + id);
    }
  },
  customerRmas: {
    cancel: function cancel(id) {
      return adapter.post("/customer_rmas/" + id + "/cancel");
    },
    search: function search(params) {
      return adapter.post("/customer_rmas/search", { search: params });
    },
    export: function _export(params) {
      return adapter.get("/customer_rmas/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_query_string__["stringify"])(params));
    },
    send: function send(id, params) {
      return adapter.post("/customer_rmas/" + id + "/send_pdf", { email: params });
    }
  },
  inventories: {
    applyLotCost: function applyLotCost(id, params) {
      return adapter.post("/inventories/" + id + "/apply_lot_cost", { inventory: params });
    },
    assignExchange: function assignExchange(id, params) {
      return adapter.post("/inventories/" + id + "/assign_exchange", { inventory: params });
    },
    attachments: {
      search: function search(id) {
        return adapter.post("/inventories/" + id + "/attachments/search_all", {
          search: { limit: 50 }
        });
      }
    },
    bulkUpdate: function bulkUpdate(params) {
      return adapter.post("inventories/bulk_update", { inventories: params });
    },
    cancelConsignment: function cancelConsignment(id, params) {
      return adapter.post("inventories/" + id + "/cancel_consignment", {
        consignment: params
      });
    },
    deleteInventory: function deleteInventory(id) {
      return adapter.delete("inventories/" + id);
    },
    export: function _export(params) {
      return adapter.get("/inventories/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_query_string__["stringify"])(params));
    },
    print: function print(id) {
      return adapter.post("inventories/" + id + "/print");
    },
    reclaim: function reclaim(id) {
      return adapter.post("inventories/" + id + "/reclaim");
    },
    requestScrapAtShop: function requestScrapAtShop(id, params) {
      return adapter.post("inventories/" + id + "/request_scrap_at_shop", {
        email: params
      });
    },
    returnToCustomer: function returnToCustomer(id, inventory) {
      return adapter.post("/inventories/" + id + "/return_to_customer", { inventory: inventory });
    },
    search: function search(params) {
      return adapter.post("/inventories/search", { search: params });
    },
    stats: function stats(params) {
      return adapter.post("/inventories/stats", { search: params });
    },
    statsPerBuyer: function statsPerBuyer() {
      return adapter.post("/inventories/stats_per_buyer");
    },
    update: function update(id, inventory) {
      return adapter.put("/inventories/" + id, { inventory: inventory });
    },
    show: function show(id) {
      var recordPagerContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "part";
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "detail";
      return adapter.get("inventories/" + id + "?record_pager_context=" + recordPagerContext + "&presenter_type=" + type);
    },
    vendorRmas: {
      create: function create(id, rma) {
        return adapter.post("inventories/" + id + "/vendor_rmas", { rma: rma });
      },
      search: function search(params) {
        return adapter.post("/vendor_rmas/search", { search: params });
      }
    },
    returnToCustomerRecords: {
      create: function create(id, params) {
        return adapter.post("inventories/" + id + "/return_to_customer_records", {
          return_to_customer_record: params
        });
      }
    },
    transfers: {
      create: function create(id, transferToLocationId, outgoingAwbNumber, specialInstructions) {
        return adapter.post("/inventories/" + id + "/transfers", {
          inventory_transfer_order: {
            transfer_to_location_id: transferToLocationId,
            outgoing_awb_number: outgoingAwbNumber,
            special_instructions: specialInstructions
          }
        });
      },
      delete: function _delete(id, transferId) {
        return adapter.delete("/inventories/" + id + "/transfers/" + transferId);
      }
    },
    reserveForSale: function reserveForSale(id, inventory) {
      return adapter.post("/inventories/" + id + "/reserve_for_sale", { inventory: inventory });
    },
    reserveForRepair: function reserveForRepair(id) {
      return adapter.post("/inventories/" + id + "/reserve_for_repair");
    },
    split: function split(id, inventory) {
      return adapter.post("/inventories/" + id + "/split", { inventory: inventory });
    },
    togglePick: function togglePick(id, params) {
      return adapter.post("/inventories/" + id + "/toggle_pick", { order: params });
    },
    unreserveForRepair: function unreserveForRepair(id) {
      return adapter.post("inventories/" + id + "/unreserve_repair");
    },
    unreserveForSale: function unreserveForSale(id) {
      return adapter.post("inventories/" + id + "/unreserve_sale");
    },
    costAdjustments: {
      cancel: function cancel(id) {
        return adapter.post("/cost_adjustments/" + id + "/cancel");
      },
      create: function create(id, costAdjustment) {
        return adapter.post("/inventories/" + id + "/cost_adjustments", {
          cost_adjustment: costAdjustment
        });
      }
    },
    dummy: {
      create: function create(id, dummy) {
        return adapter.post("/inventories/" + id + "/dummy", { dummy_inventory: dummy });
      },
      destroy: function destroy(id) {
        return adapter.delete("/inventories/" + id + "/dummy");
      },
      update: function update(id, dummy) {
        return adapter.put("/inventories/" + id + "/dummy", { dummy_inventory: dummy });
      }
    },
    repairOrdersCart: {
      search: function search(params) {
        return adapter.post("/repair_order_cart_items/search", { search: params });
      },
      create: function create(id) {
        return adapter.post("/inventories/" + id + "/repair_order_cart_items");
      },
      delete: function _delete(id) {
        return adapter.delete("/inventories/" + id + "/repair_order_cart_items");
      },
      clearCart: function clearCart() {
        return adapter.post("/repair_order_cart_items/clear_cart");
      }
    },
    saleOrdersCart: {
      search: function search(params) {
        return adapter.post("/sales_order_cart_items/search", { search: params });
      },
      create: function create(id) {
        return adapter.post("/inventories/" + id + "/sales_order_cart_items");
      },
      delete: function _delete(id) {
        return adapter.delete("/inventories/" + id + "/sales_order_cart_items");
      },
      clearCart: function clearCart() {
        return adapter.post("/sales_order_cart_items/clear_cart");
      }
    },
    searchReservedForRepair: function searchReservedForRepair(params) {
      return adapter.post("/inventories/search", {
        search: _extends({}, params, {
          presenter_type: "detail",
          repair_status: [__WEBPACK_IMPORTED_MODULE_6__modules_inventories_constants__["a" /* RESERVE_FOR_REPAIR */], __WEBPACK_IMPORTED_MODULE_6__modules_inventories_constants__["b" /* RESERVE_FOR_SHOP_ASSIST */]].join(","),
          source: "repair_cart",
          sort: "reserved_for_repair_on"
        })
      });
    },
    searchReservedForSale: function searchReservedForSale(params) {
      return adapter.post("/inventories/search", {
        search: _extends({}, params, {
          status: "reserve_for_sale,on_order_for_sale",
          reserved_for_user: true,
          placeholder_reserved_for_sale: true,
          sort: "reserved_for_sale_on"
        })
      });
    },
    undoScrap: function undoScrap(id) {
      return adapter.post("inventories/" + id + "/undo_scrap");
    }
  },
  lots: {
    cancel: function cancel(id, cancellationReason) {
      return adapter.post("/lots/" + id + "/cancel", {
        lot: { cancellation_reason: cancellationReason }
      });
    },
    costAdjustments: {
      create: function create(id, costAdjustment) {
        return adapter.post("/lots/" + id + "/lot_cost_adjustments", {
          lot_cost_adjustment: costAdjustment
        });
      }
    },
    create: function create(lot) {
      return adapter.post("/lots", { lot: lot });
    },
    export: function _export(id) {
      return adapter.get("/lots/" + id + "/export");
    },
    search: function search(params) {
      return adapter.post("/lots/search", { search: params });
    },
    show: function show(id) {
      return adapter.get("/lots/" + id);
    },
    sync: function sync(id) {
      return adapter.post("/lots/" + id + "/sync");
    },
    update: function update(id, lot) {
      return adapter.put("/lots/" + id, { lot: lot });
    },
    lineItems: {
      create: function create(id, lineItem) {
        return adapter.post("lots/" + id + "/line_items", { line_item: lineItem });
      },
      import: function _import(id, data) {
        return adapter.put("lots/" + id + "/line_items/import", { lot: data });
      },
      search: function search(id, _search8) {
        return adapter.post("lots/" + id + "/line_items/search", { search: _search8 });
      },
      update: function update(itemID, item) {
        return adapter.put("lot_line_items/" + itemID, { line_item: item });
      }
    },
    receivingRecords: {
      search: function search(lotId, _search9) {
        return adapter.post("/lots/" + lotId + "/receiving_records/search", { search: _search9 });
      }
    },
    setTraceHold: function setTraceHold(id, traceApproval) {
      return adapter.post("/lots/" + id + "/set_trace_hold", {
        lot: { trace_approved: traceApproval }
      });
    }
  },
  mistakeShipments: {
    search: function search(params) {
      return adapter.post("/mistake_shipments/search", {
        search: params
      });
    },
    show: function show(id) {
      return adapter.get("/mistake_shipments/" + id);
    },
    update: function update(id, data) {
      return adapter.put("/mistake_shipments/" + id, { mistake_shipment: data });
    }
  },
  physicalAddresses: {
    update: function update(physicalAddress) {
      return adapter.put("addresses/" + physicalAddress.id, _extends({}, physicalAddress));
    },
    destroy: function destroy(id) {
      return adapter.delete("/addresses/" + id);
    }
  },
  purchaseOrders: {
    create: function create(purchaseOrder) {
      return adapter.post("/purchase_orders", { purchase_order: purchaseOrder });
    },
    search: function search(params) {
      return adapter.post("/purchase_orders/search", { search: params });
    },
    setTraceHold: function setTraceHold(id, traceApproval) {
      return adapter.post("/purchase_orders/" + id + "/set_trace_hold", {
        purchase_order: { trace_approved: traceApproval }
      });
    },
    show: function show(id) {
      return adapter.get("/purchase_orders/" + id);
    },
    sync: function sync(id) {
      return adapter.post("/purchase_orders/" + id + "/sync");
    },
    update: function update(id, purchaseOrder) {
      return adapter.put("/purchase_orders/" + id, { purchase_order: purchaseOrder });
    },
    updateQcStatus: function updateQcStatus(id, params) {
      return adapter.post("/purchase_orders/" + id + "/update_qc_status", {
        purchase_order: params
      });
    },
    preview: function preview(id, params) {
      return adapter.get("/purchase_orders/" + id + "/preview_email?" + new URLSearchParams(params).toString());
    },
    send: function send(id, data) {
      return adapter.post("/purchase_orders/" + id + "/send_pdf", { email: data });
    },
    sendNotice: function sendNotice(id, data) {
      return adapter.post("/purchase_orders/" + id + "/send_cancellation_notice", {
        email: data
      });
    },
    cancel: function cancel(id, cancellationReason) {
      return adapter.post("/purchase_orders/" + id + "/toggle_cancelled", {
        purchase_order: { cancellation_reason: cancellationReason }
      });
    },
    lineItems: {
      bulkUpdate: function bulkUpdate(purchaseOrderId, params) {
        return adapter.post("/purchase_orders/" + purchaseOrderId + "/line_items/bulk_update", { purchase_order: params });
      },
      create: function create(id, item) {
        return adapter.post("/purchase_orders/" + id + "/line_items", { line_item: item });
      },
      exchange: function exchange(id) {
        return adapter.post("/purchase_order_line_items/" + id + "/exchange");
      },
      exchangeReversal: function exchangeReversal(id) {
        return adapter.post("/purchase_order_line_items/" + id + "/exchange_reversal");
      },
      export: function _export(params) {
        return adapter.get("/purchase_order_line_items/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_query_string__["stringify"])(params));
      },
      outright: function outright(id) {
        return adapter.post("/purchase_order_line_items/" + id + "/outright");
      },
      update: function update(itemID, item) {
        return adapter.put("purchase_order_line_items/" + itemID, { line_item: item });
      }
    },
    receivedCores: {
      search: function search(purchaseOrderId, _search10) {
        return adapter.post("/purchase_orders/" + purchaseOrderId + "/received_cores/search", { search: _search10 });
      }
    },
    receivingRecords: {
      search: function search(purchaseOrderId, _search11) {
        return adapter.post("/purchase_orders/" + purchaseOrderId + "/receiving_records/search", { search: _search11 });
      }
    }
  },
  purchaseOrderLineItems: {
    assignableExchangeSearch: function assignableExchangeSearch() {
      return adapter.post("/purchase_order_line_items/assignable_exchange_search");
    }
  },
  receivingRecord: {
    create: function create(receivingRecord) {
      return adapter.post("/receiving_records", {
        receiving_record: receivingRecord
      });
    },
    export: function _export(params) {
      return adapter.get("/receiving_records/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_query_string__["stringify"])(params));
    },
    save: function save(id, params) {
      return adapter.put("/receiving_records/" + id + "/save", {
        receiving_record: params
      });
    },
    update: function update(id, receivingRecord) {
      return adapter.put("/receiving_records/" + id, {
        receiving_record: receivingRecord
      });
    },
    updateQcStatus: function updateQcStatus(id, params) {
      return adapter.put("/receiving_records/" + id + "/update_qc_status", {
        receiving_record: params
      });
    },
    show: function show(id) {
      return adapter.get("/receiving_records/" + id);
    },
    search: function search(params) {
      return adapter.post("/receiving_records/search", {
        search: _extends({ sort: "created_at" }, params, { reverse: true })
      });
    },
    unreceive: function unreceive(id) {
      return adapter.post("/receiving_records/" + id + "/unreceive");
    }
  },
  rejectedCores: {
    search: function search(params) {
      return adapter.post("/rejected_cores/search", {
        search: params
      });
    },
    show: function show(id) {
      return adapter.get("/rejected_cores/" + id);
    },
    update: function update(id, data) {
      return adapter.put("/rejected_cores/" + id, { rejected_core: data });
    }
  },
  relatedCompanies: {
    destroy: function destroy(id) {
      return adapter.delete("/related_companies/" + id);
    },
    update: function update(id, relatedCompany) {
      return adapter.put("related_companies/" + id, {
        related_company: relatedCompany
      });
    }
  },
  rmas: {
    search: function search(params) {
      return adapter.post("/rmas/search", { search: params });
    },
    show: function show(id) {
      return adapter.get("/rmas/" + id);
    },
    sync: function sync(id) {
      return adapter.post("/rmas/" + id + "/sync");
    },
    update: function update(id, data) {
      return adapter.put("/rmas/" + id, { rma: data });
    }
  },
  shipments: {
    create: function create(shipment) {
      return adapter.post("/shipments", { shipment: shipment });
    },
    export: function _export(params) {
      return adapter.get("/shipments/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_query_string__["stringify"])(params));
    },
    lineItems: {
      search: function search(id, params) {
        return adapter.post("/shipments/" + id + "/line_items/search", { search: params });
      }
    },
    reversal: function reversal(id) {
      return adapter.post("/shipments/" + id + "/reversal");
    },
    search: function search(params) {
      return adapter.post("/shipments/search", { search: params });
    },
    show: function show(id) {
      return adapter.get("/shipments/" + id);
    },
    stats: function stats() {
      return adapter.get("/shipments/stats");
    },
    toggleCheck: function toggleCheck(id) {
      return adapter.post("/shipments/" + id + "/toggle_check");
    },
    update: function update(id, data) {
      return adapter.put("/shipments/" + id, { shipment: data });
    }
  },
  tenant: {
    create: function create() {
      return adapter.post("/tenant");
    },
    find: function find() {
      return adapter.get("/tenant");
    }
  },
  transfers: {
    show: function show(id) {
      return adapter.get("/transfers/" + id);
    }
  },
  vendorRmas: {
    cancel: function cancel(id) {
      return adapter.post("/vendor_rmas/" + id + "/cancel");
    },
    search: function search(params) {
      return adapter.post("/vendor_rmas/search", { search: params });
    },
    update: function update(id, data) {
      return adapter.put("/vendor_rmas/" + id, { rma: data });
    },
    export: function _export(params) {
      return adapter.get("/vendor_rmas/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_query_string__["stringify"])(params));
    }
  },
  discrepancy: {
    create: function create(id, bulk) {
      return adapter.post("receiving_records/" + id + "/discrepancies", { bulk: bulk });
    },
    update: function update(discrepancyId, discrepancy) {
      return adapter.put("discrepancies/" + discrepancyId, discrepancy);
    },
    resolve: function resolve(id, data) {
      return adapter.post("discrepancies/" + id + "/resolve", data);
    }
  },
  orders: {
    search: function search(params) {
      return adapter.post("/orders/search", { search: params });
    },
    warehouse_pick: function warehouse_pick(id, order) {
      return adapter.put("/orders/" + id + "/warehouse_pick", { order: order });
    }
  },
  salesCart: {
    show: function show() {
      return adapter.get("/sales_cart");
    }
  },
  salesOrders: {
    cachedShow: function cachedShow(id) {
      return adapter.get("/sales_orders/" + id + "/cached_show");
    },
    cancellationReversal: function cancellationReversal(id) {
      return adapter.post("sales_orders/" + id + "/cancellation_reversal");
    },
    cocSearch: function cocSearch(id) {
      return adapter.post("sales_orders/" + id + "/coc_search");
    },
    commercialInvoice: {
      save: function save(id, data) {
        return adapter.post("sales_orders/" + id + "/commercial_invoice/save", {
          commercial_invoice: data
        });
      }
    },
    convert: function convert(data) {
      return adapter.post("/sales_orders/convert", { sales_order: data });
    },
    convertFromOutgoingQuote: function convertFromOutgoingQuote(data) {
      return adapter.post("/sales_orders/convert_from_outgoing_quote", {
        sales_order: data
      });
    },
    convertWithDummy: function convertWithDummy(data) {
      return adapter.post("/sales_orders/convert_with_dummy", { sales_order: data });
    },
    createCoc: function createCoc(id, params) {
      return adapter.post("/sales_orders/" + id + "/create_certificate_of_conformance", {
        sales_order: params
      });
    },
    search: function search(params) {
      return adapter.post("/sales_orders/search", { search: params });
    },
    show: function show(id) {
      var presenter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      return adapter.get("/sales_orders/" + id + (presenter ? "?presenter=" + presenter : ""));
    },
    sync: function sync(id) {
      return adapter.post("/sales_orders/" + id + "/sync");
    },
    syncCoreRepairCharges: function syncCoreRepairCharges(id) {
      return adapter.post("/sales_orders/" + id + "/sync_core_repair_charges");
    },
    update: function update(id, data) {
      return adapter.put("/sales_orders/" + id, { sales_order: data });
    },
    lineItems: {
      bulkUpdate: function bulkUpdate(salesOrderId, params) {
        return adapter.post("/sales_orders/" + salesOrderId + "/line_items/bulk_update", {
          sales_order: params
        });
      },
      cocPermissions: function cocPermissions(id) {
        return adapter.get("/sales_order_line_items/" + id + "/coc_permissions");
      },
      export: function _export(params) {
        return adapter.get("/sales_order_line_items/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_query_string__["stringify"])(params));
      },
      search: function search(salesOrderId, params) {
        return adapter.post("/sales_orders/" + salesOrderId + "/line_items/search", {
          search: params
        });
      },
      sendExchangeAgreement: function sendExchangeAgreement(id) {
        return adapter.post("/sales_order_line_items/" + id + "/send_exchange_agreement_pdf");
      },
      sendQualityControlDocuments: function sendQualityControlDocuments(id, params) {
        return adapter.post("/sales_order_line_items/" + id + "/send_quality_control_documents_pdf", {
          sales_order: params
        });
      },
      cancel: function cancel(id, reason, sendCancellationEmail) {
        return adapter.put("/sales_order_line_items/" + id, {
          line_item: {
            cancelled: true,
            cancellation_reason: reason,
            send_cancellation_email: sendCancellationEmail
          }
        });
      },
      cancelConsignment: function cancelConsignment(id) {
        return adapter.post("/sales_order_line_items/" + id + "/cancel_consignment");
      },
      returnCoreToCustomer: function returnCoreToCustomer(id) {
        return adapter.post("/sales_order_line_items/" + id + "/return_core");
      },
      cancelOutrightSale: function cancelOutrightSale(id) {
        return adapter.post("/sales_order_line_items/" + id + "/cancel_outright_sale");
      },
      cancelSubsequentExchange: function cancelSubsequentExchange(id) {
        return adapter.post("/sales_order_line_items/" + id + "/cancel_subsequent_exchange");
      },
      cancellationReversal: function cancellationReversal(id) {
        return adapter.post("/sales_order_line_items/" + id + "/cancellation_reversal");
      },
      convertToExchange: function convertToExchange(id, data) {
        return adapter.post("/sales_order_line_items/" + id + "/convert_to_exchange", {
          line_item: data
        });
      },
      exchange: function exchange(id, data) {
        return adapter.post("/sales_order_line_items/" + id + "/exchange", {
          line_item: data
        });
      },
      exchangeReversal: function exchangeReversal(id) {
        return adapter.post("/sales_order_line_items/" + id + "/exchange_reversal");
      },
      internalOutrightSale: function internalOutrightSale(id, data) {
        return adapter.post("sales_order_line_items/" + id + "/internal_outright_sale", {
          line_item: data
        });
      },
      outrightSale: function outrightSale(id, data) {
        return adapter.post("sales_order_line_items/" + id + "/outright_sale", {
          line_item: data
        });
      },
      create: function create(salesOrderId, data) {
        return adapter.post("/sales_orders/" + salesOrderId + "/line_items", {
          line_item: data
        });
      },
      update: function update(id, data) {
        return adapter.put("/sales_order_line_items/" + id, { line_item: data });
      },
      customerRmas: {
        create: function create(id, data) {
          return adapter.post("/sales_order_line_items/" + id + "/customer_rmas", {
            rma: data
          });
        }
      }
    },
    send: function send(id) {
      return adapter.post("/sales_orders/" + id + "/send_pdf");
    },
    sendWeightDims: function sendWeightDims(id, data) {
      return adapter.post("/sales_orders/" + id + "/send_weight_dims_pdf", {
        sales_order: data
      });
    },
    cancel: function cancel(id, params) {
      return adapter.post("/sales_orders/" + id + "/toggle_cancelled", {
        sales_order: params
      });
    }
  },
  reports: {
    buyer_stats: {
      search: function search(params) {
        return adapter.post("/buyer_stats/search", { search: params });
      }
    },
    purchases_report: {
      search: function search(params) {
        return adapter.post("/purchases_report/search", { search: params });
      }
    },
    sales_report: {
      search: function search(params) {
        return adapter.post("/sales_report/search", { search: params });
      }
    },
    depreciations: {
      search: function search(startTime, endTime, locationId) {
        return adapter.post("/monthly_depreciations/search", {
          search: {
            start_time: startTime,
            end_time: endTime,
            location_id: locationId
          }
        });
      },
      searchPerLocation: function searchPerLocation(startTime, endTime) {
        return adapter.post("/monthly_depreciations/search_per_location", {
          search: {
            start_time: startTime,
            end_time: endTime
          }
        });
      }
    },
    purchases: {
      search: function search(startTime, endTime, locationId) {
        return adapter.post("/monthly_purchases/search", {
          search: {
            start_time: startTime,
            end_time: endTime,
            location_id: locationId
          }
        });
      },
      searchPerLocation: function searchPerLocation(startTime, endTime) {
        return adapter.post("/monthly_purchases/search_per_location", {
          search: {
            start_time: startTime,
            end_time: endTime
          }
        });
      }
    },
    sales: {
      search: function search(startTime, endTime) {
        return adapter.post("/monthly_sales/search", {
          search: { start_time: startTime, end_time: endTime }
        });
      }
    },
    part_stats: {
      search: function search(id) {
        return adapter.get("/parts/" + id + "/stats");
      }
    },
    company_stats: {
      search: function search(id) {
        return adapter.get("/companies/" + id + "/stats");
      }
    },
    high_scores: {
      sales_stats: function sales_stats(params) {
        return adapter.post("/reports/sales_stats", {
          search: params
        });
      }
    },
    search: function search(params) {
      return adapter.post("/reports/search", { search: params });
    }
  },
  restrictedEntities: {
    addressSearch: function addressSearch(params) {
      return adapter.post("/restricted_entities/address_search", { search: params });
    },
    search: function search(params) {
      return adapter.post("/restricted_entities/search", { search: params });
    }
  },
  outboundOrders: {
    export: function _export(params) {
      return adapter.get("/outbound_orders/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_query_string__["stringify"])(params));
    },
    search: function search(params) {
      return adapter.post("/outbound_orders/search", { search: params });
    }
  },
  shoppingList: {
    search: function search(params) {
      return adapter.post("/shopping_lists/search", { search: params });
    }
  },
  dashboard: function dashboard() {
    return adapter.get("/dashboard");
  },
  quarterlyGoals: {
    create: function create(data) {
      return adapter.post("/quarterly_goals", { quarterly_goal: data });
    },
    update: function update(id, data) {
      return adapter.put("/quarterly_goals/" + id, { quarterly_goal: data });
    },
    search: function search(params) {
      return adapter.post("/quarterly_goals/search", { search: params });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form__ = __webpack_require__(791);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppForm__ = __webpack_require__(344);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__AppForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormInput__ = __webpack_require__(784);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__FormInput__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_2__FormInput__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_2__FormInput__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NumberInput__ = __webpack_require__(2324);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__NumberInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select__ = __webpack_require__(2333);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__Select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Check__ = __webpack_require__(346);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__Check__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__Check__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Save__ = __webpack_require__(2330);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_6__Save__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FileInput__ = __webpack_require__(2314);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_7__FileInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AsyncField__ = __webpack_require__(2303);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_8__AsyncField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormTypes__ = __webpack_require__(78);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_9__FormTypes__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MonthYearField__ = __webpack_require__(789);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_10__MonthYearField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PhoneNumberField__ = __webpack_require__(2326);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_11__PhoneNumberField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NSNField__ = __webpack_require__(2323);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_12__NSNField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CageField__ = __webpack_require__(2310);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_13__CageField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ECCNField__ = __webpack_require__(2312);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_14__ECCNField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__UNCodeField__ = __webpack_require__(2335);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_15__UNCodeField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AutoCompleteField__ = __webpack_require__(2304);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_16__AutoCompleteField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AutoCompleteUserInputField__ = __webpack_require__(2306);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_17__AutoCompleteUserInputField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__CurrencyField__ = __webpack_require__(176);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_18__CurrencyField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__BaseErrors__ = __webpack_require__(2308);
/* unused harmony reexport BaseErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Errors__ = __webpack_require__(487);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_20__Errors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__RadioGroupField__ = __webpack_require__(2328);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_21__RadioGroupField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__formField__ = __webpack_require__(142);
/* unused harmony reexport FormField */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__FormRow__ = __webpack_require__(26);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_23__FormRow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__disabledInputs__ = __webpack_require__(2336);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_24__disabledInputs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__hiddenInputs__ = __webpack_require__(490);
/* unused harmony reexport hiddenInputs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Footer__ = __webpack_require__(2315);
/* unused harmony reexport Footer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__FormSections_ShippingMethod__ = __webpack_require__(785);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_27__FormSections_ShippingMethod__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ScheduleBOrHTCodeField__ = __webpack_require__(2332);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_28__ScheduleBOrHTCodeField__["a"]; });































































/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = properCase;
/* harmony export (immutable) */ __webpack_exports__["a"] = properCaseField;
/* harmony export (immutable) */ __webpack_exports__["f"] = spaceBetweenCaps;
/* unused harmony export getInitials */
/* harmony export (immutable) */ __webpack_exports__["d"] = getFirstNameLastInitial;
/* harmony export (immutable) */ __webpack_exports__["e"] = truncate;
/* harmony export (immutable) */ __webpack_exports__["b"] = toSentence;
function properCase(text) {
  if (text === null) {
    return null;
  }
  return text.split("_").map(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }).join(" ");
}

function properCaseField(text) {
  if (text === null) {
    return null;
  }

  if (text === "srp_condition") return "SRP Condition";
  return properCase(text);
}

function spaceBetweenCaps(text) {
  if (text === null) return null;

  return text.replace(/([A-Z])/g, " $1");
}

function getInitials(name) {
  if (name === null) {
    return null;
  }

  return name.split(" ").map(function (str) {
    return str.charAt(0).toUpperCase();
  }).join("");
}

function getFirstNameLastInitial(name) {
  if (!name) {
    return null;
  }

  var nameArray = name.split(" ");
  nameArray[1] = nameArray[1].charAt(0).toUpperCase();

  return nameArray.join(" ");
}

function truncate(text, targetLength) {
  var truncText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "...";

  if (!text && text !== 0) {
    return null;
  }
  if (text.toString().length > targetLength) {
    return "" + text.toString().substring(0, targetLength - 1) + truncText;
  }
  return text;
}

function toSentence(arr) {
  var divider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "and";

  return arr.reduce(function (prev, curr, i) {
    return prev + curr + (i === arr.length - 2 ? " " + divider + " " : ", ");
  }, "").slice(0, -2);
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Receiving_constants__ = __webpack_require__(34);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return INVENTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return AS_IS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return AIRCRAFT_REFERENCE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return AIRCRAFT_TAIL_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CONDITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return CONSIGNED_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return CONSIGNMENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return COST_PER_UNIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return CORE_RETURN_SERIAL_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return DO_NOT_EXCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DO_NOT_SELL_REASON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return EXCHANGE_SRP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FLAT_EXCHANGE_SRP; });
/* unused harmony export EXCHANGE_SERIAL_NUMBER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return EXPIRATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return FREIGHT_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return FINAL_FREIGHT_CONFIRMED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return INTERNAL_OUTRIGHT_SALES_ITEM_ID; });
/* unused harmony export MOST_RECENT_SALES_ORDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return LAST_SRP_REASON_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return LEAD_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return LEAD_TIME_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return LISTING_OVERRIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return MANAGED_REPAIR_IN_PROGRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return MANAGED_REPAIR_REPAIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return ORIGINAL_COST_PER_UNIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PART_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REPAIR_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SERIAL_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SRP_CONDITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return SRP_REASON_CHANGED; });
/* unused harmony export SRP_REASON_CHANGED_LABEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return SELLABLE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return STORE_OWNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return STORE_OWNER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return STORE_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return STORE_LOCATION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SUGGESTED_RETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TAG_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TAGGED_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return TAGGED_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return TAGGED_BY_HOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return TRACED_TO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return TOTAL_HOURS_REMAINING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return TOTAL_CYCLES_REMAINING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return TRACE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return TRANSFER_TO_LOCATION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return UNSELLABLE_PER_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return WARRANTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return WARRANTY_OVERRIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return WAREHOUSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return OVERHAULED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REPAIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return INSPECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NEW_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return AS_REMOVED; });
/* unused harmony export BEYOND_REPAIR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return PARTS_UNIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return SCRAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return UNDO_SCRAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return IN_STOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return CORE_RETURNED_TO_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CUSTOMER_RMA_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return DISCREPANCY_REPORTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return AWAITING_SCRAP_REPORT_AT_SHOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return AWAITING_SCRAP_REPORT_LOCAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return AT_SHOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CORE_RETURN_RECEIVED; });
/* unused harmony export CORE_RETURN_REJECTED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return EXCHANGE_GONE_OUTRIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return GONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return ON_ORDER_FOR_SALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return OUT_ON_EXCHANGE; });
/* unused harmony export TRANSFER_USA_BOUND */
/* unused harmony export TRANSFER_IRE_BOUND */
/* unused harmony export TRANSFER_SGP_BOUND */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return INTERNAL_OUTRIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return QC_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return RECLAIMED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return NO_WORK_PERFORMED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return REPAIR_EVALUATION_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return REPAIR_EVALUATION_RECEIVED; });
/* unused harmony export RETURNING_FROM_SHOP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return REPAIRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return RESERVE_FOR_SALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return RETURNING_TO_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return RMA_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return SALES_ORDER_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return SCRAP_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESERVE_FOR_REPAIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return REPAIR_AND_HOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return REPAIR_AND_HOLD_LEAD_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return REPAIR_EVALUATION_APPROVED; });
/* unused harmony export RETURNING_ASSIGNED_CORE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return RETURNED_CONSIGNMENT; });
/* unused harmony export RETURNING_CONSIGNMENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESERVE_FOR_SHOP_ASSIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return WORKING_TO_SAVE_UNIT; });
/* unused harmony export UNIT_RETURNED_TO_CUSTOMER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return UNDER_REVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return QC_HOLD; });
/* unused harmony export PASS */
/* unused harmony export RETURNING_FROM_SHOP_TO_CUSTOMER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return VENDOR_RMA_REQUESTED; });
/* unused harmony export VENDOR_RMA_IN_PROGRESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return DO_NOT_SELL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return DO_NOT_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return ASA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return FAA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return EASA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CAAC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return TCCA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return UK_CAA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return OTHER_TAG_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return WARE_HOUSE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DO_NOT_SELL_REASON_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return IMPERFECT_TRACE_REASONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return TAG_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return FLAG_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return REPAIR_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return CURRENTLY_REPAIRING_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CURRENTLY_TRANSFERRING_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return QC_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return INVENTORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return COST_ADJUSTMENT_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return CANCELLABLE_COST_ADJUSTMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRACEABILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TAG_COPIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return PHOTOS; });
/* unused harmony export EXTERNAL_LINK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return OTHER; });
/* unused harmony export BACK_TO_BIRTH */
/* unused harmony export REMOVAL_TAG */
/* unused harmony export NON_USE_NON_INSTALL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return ATTACHMENT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return TRACE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return APPLY_LOT_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return ASSIGN_EXCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CANCEL_CONSIGNMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CREATE_COMMERCIAL_INVOICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CREATE_DUMMY_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return DOWNLOAD_SCRAP_CERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return PRINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return PURCHASED_FOR_EXCHANGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return REMOVE_EMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return REQUEST_SCRAP_AT_SHOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return RESERVE_INV_FOR_SALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return RESERVE_INV_FOR_REPAIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return RETURN_TO_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return RETURN_TO_CUSTOMER_V2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return RETURN_TO_STOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return RETURN_CORE_TO_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return UNRESERVE_REPAIR; });
/* unused harmony export UPDATE_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return UPDATE_SRP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return UPDATE_QC_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return SCRAP_REPORT_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return SCRAP_INV_LOCALLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return SCRAP_AT_SHOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return SPLIT_INVENTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return TRANSFER_INVENTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return CANCEL_TRANSFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return CANCEL_MOD_TO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CREATE_VENDOR_RMA; });
/* unused harmony export CONDITION_WARRANTIES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return WARRANTY_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return SRP_CHANGE_REASONS; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _TAG_TYPES, _FLAG_TYPES, _STATUSES, _REPAIR_STATUSES, _QC_STATUSES, _condition, _ATTACHMENT_TYPES, _CONDITION_WARRANTIES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var INVENTORY = "inventory";

var AS_IS = "as_is";
var AIRCRAFT_REFERENCE_NUMBER = "aircraft_reference_number";
var AIRCRAFT_TAIL_NUMBER = "aircraft_tail_number";
var CONDITION = "condition";
var CONSIGNED_DATE = "consigned_date";
var CONSIGNMENT_TYPE = "consignment_type";
var COST_PER_UNIT = "cost_per_unit";
var CORE_RETURN_SERIAL_NUMBER = "core_return_serial_number";
var DO_NOT_EXCHANGE = "do_not_exchange";
var DO_NOT_SELL_REASON = "do_not_sell_reason";
var EXCHANGE_SRP = "exchange_srp";
var FLAT_EXCHANGE_SRP = "flat_exchange_srp";
var EXCHANGE_SERIAL_NUMBER = "exchange_serial_number";
var EXPIRATION = "expiration";
var FREIGHT_COMPLETE = "freight_complete";
var FINAL_FREIGHT_CONFIRMED = "final_freight_confirmed";
var INTERNAL_OUTRIGHT_SALES_ITEM_ID = "internal_outright_sales_item_id";
var MOST_RECENT_SALES_ORDER = "most_recent_sales_order";
var LOCATION = "location";
var LAST_SRP_REASON_CHANGED = "last_srp_reason_changed";
var LEAD_TIME = "lead_time";
var LEAD_TIME_LABEL = "Lead Time (Days)";
var LISTING_OVERRIDE = "listing_override";
var MANAGED_REPAIR_IN_PROGRESS = "managed_repair_in_progress";
var MANAGED_REPAIR_REPAIRED = "managed_repair_repaired";
var ORIGINAL_COST_PER_UNIT = "original_cost_per_unit";
var PART_ID = "part_id";
var REPAIR_STATUS = "repair_status";
var SERIAL_NUMBER = "serial_number";
var SRP_CONDITION = "srp_condition";
var SRP_REASON_CHANGED = "srp_reason_changed";
var SRP_REASON_CHANGED_LABEL = "SRP Reason Changed";
var SELLABLE_STATUS = "sellable_status";
var STORE_OWNER = "store_owner";
var STORE_OWNER_ID = "store_owner_id";
var STORE_LOCATION = "store_location";
var STORE_LOCATION_ID = "store_location_id";
var SUGGESTED_RETAIL = "suggested_retail";
var TAG_DATE = "tag_date";
var TAGGED_BY = "tagged_by";
var TAGGED_BY_ID = "tagged_by_id";
var TAGGED_BY_HOLD = "tagged_by_hold";
var TRACED_TO = "traced_to";
var TOTAL_HOURS_REMAINING = "total_hours_remaining";
var TOTAL_CYCLES_REMAINING = "total_cycles_remaining";
var TRACE_TYPE = "trace_type";
var TRANSFER_TO_LOCATION_ID = "transfer_to_location_id";
var UNSELLABLE_PER_USER = "unsellable_per_user";
var WARRANTY = "warranty";
var WARRANTY_OVERRIDE = "warranty_override";
var WAREHOUSE = "warehouse";

var OVERHAULED = "overhauled";
var REPAIRED = "repaired";
var INSPECTED = "inspected";
var NEW_ITEM = "new_item";
var AS_REMOVED = "as_removed";
var BEYOND_REPAIR = "beyond_econ_repair";
var PARTS_UNIT = "parts_unit";
var SCRAP = "scrap";
var UNDO_SCRAP = "scrap";

var IN_STOCK = "in_stock";
var CORE_RETURNED_TO_CUSTOMER = "core_returned_to_customer";
var CUSTOMER_RMA_REQUESTED = "customer_rma_requested";
var DISCREPANCY_REPORTED = "discrepancy_reported";
var AWAITING_SCRAP_REPORT_AT_SHOP = "awaiting_scrap_report_at_shop";
var AWAITING_SCRAP_REPORT_LOCAL = "awaiting_scrap_report_local";
var AT_SHOP = "at_shop";
var CORE_RETURN_RECEIVED = "core_return_received";
var CORE_RETURN_REJECTED = "core_return_rejected";
var EXCHANGE_GONE_OUTRIGHT = "exchange_gone_outright";
var GONE = "gone";
var ON_ORDER_FOR_SALE = "on_order_for_sale";
var OUT_ON_EXCHANGE = "out_on_exchange";
var TRANSFER_USA_BOUND = "transfer_usa_bound";
var TRANSFER_IRE_BOUND = "transfer_ireland_bound";
var TRANSFER_SGP_BOUND = "transfer_singapore_bound";
var INTERNAL_OUTRIGHT = "internal_outright";
var QC_STATUS = "qc_status";
var RECLAIMED = "reclaimed";
var NO_WORK_PERFORMED = "no_work_performed";
var REPAIR_EVALUATION_REJECTED = "repair_evaluation_rejected";
var REPAIR_EVALUATION_RECEIVED = "repair_evaluation_received";
var RETURNING_FROM_SHOP = "returning_from_shop";
var REPAIRING = "repairing";
var RESERVE_FOR_SALE = "reserve_for_sale";
var RETURNING_TO_CUSTOMER = "returning_to_customer";
var RMA_RECEIVED = "rma_received";
var SALES_ORDER_CREATED = "sales_order_created";
var SCRAP_REPORT = "scrap_report";
var RESERVE_FOR_REPAIR = "reserve_for_repair";
var REPAIR_AND_HOLD = "repair_and_hold";
var REPAIR_AND_HOLD_LEAD_TIME = "repair_and_hold_lead_time";
var REPAIR_EVALUATION_APPROVED = "repair_evaluation_approved";
var RETURNING_ASSIGNED_CORE = "returning_assigned_core";
var RETURNED_CONSIGNMENT = "returned_consignment";
var RETURNING_CONSIGNMENT = "returning_consignment";
var RESERVE_FOR_SHOP_ASSIST = "reserve_for_shop_assist";
var STATUS = "status";
var WORKING_TO_SAVE_UNIT = "working_to_save_unit";
var UNIT_RETURNED_TO_CUSTOMER = "unit_returned_to_customer";
var UNDER_REVIEW = "under_review";
var QC_HOLD = "qc_hold";
var PASS = "pass";
var RETURNING_FROM_SHOP_TO_CUSTOMER = "returning_from_shop_to_customer";
var VENDOR_RMA_REQUESTED = "vendor_rma_requested";
var VENDOR_RMA_IN_PROGRESS = "vendor_rma_in_progress";

var DO_NOT_SELL = "do_not_sell";
var LIST = "list";
var DO_NOT_LIST = "do_not_list";

var ASA = "asa";
var FAA = "faa";
var EASA = "easa";
var CAAC = "caac";
var TCCA = "tcca";
var UK_CAA = "uk_caa";
var OTHER_TAG_TYPE = "other_tag_type";
var IMPERFECT_TRACE = "imperfect_trace";
var DER = "der";
var PMA = "pma";
var MODIFIED = "modified";
var WARE_HOUSE_ID = "ware_house_id";

var DO_NOT_SELL_REASON_OPTIONS = [{ value: "hold_for_airline_customer", text: "Hold for Airline Customer" }, { value: "special_project", text: "Special Project" }, { value: "see_buyer_for_more_info", text: "See Buyer for More Info" }];

var IMPERFECT_TRACE_REASONS = {
  missing_accompanying_shop_report: {
    label: "Missing accompanying shop report"
  },
  missing_links: {
    label: "Missing link/s"
  },
  missing_nis: {
    label: "Missing NIS"
  },
  missing_removal_tag: {
    label: "Missing removal tag"
  },
  other: {
    label: "Other"
  }
};

var TAG_TYPES = (_TAG_TYPES = {}, _defineProperty(_TAG_TYPES, ASA, {
  label: "ASA"
}), _defineProperty(_TAG_TYPES, FAA, {
  label: "FAA"
}), _defineProperty(_TAG_TYPES, EASA, {
  label: "EASA"
}), _defineProperty(_TAG_TYPES, CAAC, {
  label: "CAAC"
}), _defineProperty(_TAG_TYPES, TCCA, {
  label: "TCCA"
}), _defineProperty(_TAG_TYPES, UK_CAA, {
  label: "UK CAA"
}), _TAG_TYPES);

var FLAG_TYPES = (_FLAG_TYPES = {}, _defineProperty(_FLAG_TYPES, IMPERFECT_TRACE, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_text__["c" /* properCase */])(IMPERFECT_TRACE),
  subLabel: function subLabel(inventory) {
    return inventory[__WEBPACK_IMPORTED_MODULE_3__companies_constants__["a" /* IMPERFECT_TRACE_REASON */]] && IMPERFECT_TRACE_REASONS[inventory[__WEBPACK_IMPORTED_MODULE_3__companies_constants__["a" /* IMPERFECT_TRACE_REASON */]]].label;
  }
}), _defineProperty(_FLAG_TYPES, DER, {
  label: "DER"
}), _defineProperty(_FLAG_TYPES, PMA, {
  label: "PMA"
}), _defineProperty(_FLAG_TYPES, MODIFIED, {
  label: "Modified"
}), _defineProperty(_FLAG_TYPES, __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["a" /* INCIDENT */], {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["a" /* INCIDENT */])
}), _FLAG_TYPES);

var STATUSES = (_STATUSES = {}, _defineProperty(_STATUSES, IN_STOCK, {
  label: "In Stock"
}), _defineProperty(_STATUSES, AWAITING_SCRAP_REPORT_AT_SHOP, {
  label: "Awaiting Scrap Report - At Shop"
}), _defineProperty(_STATUSES, AWAITING_SCRAP_REPORT_LOCAL, {
  label: "Awaiting Scrap Report - Local"
}), _defineProperty(_STATUSES, CORE_RETURN_RECEIVED, {
  label: "Core Return Received"
}), _defineProperty(_STATUSES, CUSTOMER_RMA_REQUESTED, {
  label: "Customer RMA Requested"
}), _defineProperty(_STATUSES, REPAIRING, {
  label: "Repairing"
}), _defineProperty(_STATUSES, RESERVE_FOR_SALE, {
  label: "Reserve For Sale"
}), _defineProperty(_STATUSES, RETURNING_TO_CUSTOMER, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_text__["c" /* properCase */])(RETURNING_TO_CUSTOMER)
}), _defineProperty(_STATUSES, RETURNING_ASSIGNED_CORE, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_text__["c" /* properCase */])(RETURNING_ASSIGNED_CORE)
}), _defineProperty(_STATUSES, RETURNING_CONSIGNMENT, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_text__["c" /* properCase */])(RETURNING_CONSIGNMENT)
}), _defineProperty(_STATUSES, RMA_RECEIVED, {
  label: "RMA Received"
}), _defineProperty(_STATUSES, SALES_ORDER_CREATED, {
  label: "Sales Order Created"
}), _defineProperty(_STATUSES, ON_ORDER_FOR_SALE, {
  label: "On Order For Sale"
}), _defineProperty(_STATUSES, OUT_ON_EXCHANGE, {
  label: "Out on Exchange"
}), _defineProperty(_STATUSES, GONE, {
  label: "Gone (Out of Stock)"
}), _defineProperty(_STATUSES, TRANSFER_USA_BOUND, {
  label: "Transfer USA Bound"
}), _defineProperty(_STATUSES, TRANSFER_IRE_BOUND, {
  label: "Transfer Ireland Bound"
}), _defineProperty(_STATUSES, TRANSFER_SGP_BOUND, {
  label: "Transfer Singapore Bound"
}), _defineProperty(_STATUSES, DISCREPANCY_REPORTED, {
  label: "Discrepancy Reported"
}), _defineProperty(_STATUSES, OUT_ON_EXCHANGE, {
  label: "Out On Exchange"
}), _defineProperty(_STATUSES, VENDOR_RMA_REQUESTED, {
  label: "Vendor Rma Requested"
}), _defineProperty(_STATUSES, VENDOR_RMA_IN_PROGRESS, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_text__["c" /* properCase */])(VENDOR_RMA_IN_PROGRESS)
}), _STATUSES);

var REPAIR_STATUSES = (_REPAIR_STATUSES = {}, _defineProperty(_REPAIR_STATUSES, AT_SHOP, {
  label: "At Shop"
}), _defineProperty(_REPAIR_STATUSES, INTERNAL_OUTRIGHT, {
  label: "Internal Outright"
}), _defineProperty(_REPAIR_STATUSES, EXCHANGE_GONE_OUTRIGHT, {
  label: "Exchange Gone Outright"
}), _defineProperty(_REPAIR_STATUSES, REPAIR_EVALUATION_REJECTED, {
  label: "Repair Evaluation Rejected"
}), _defineProperty(_REPAIR_STATUSES, WORKING_TO_SAVE_UNIT, {
  label: "Working To Save Unit"
}), _defineProperty(_REPAIR_STATUSES, REPAIR_EVALUATION_APPROVED, {
  label: "Repair Evaluation Approved"
}), _defineProperty(_REPAIR_STATUSES, REPAIR_AND_HOLD, {
  label: "Repair And Hold"
}), _defineProperty(_REPAIR_STATUSES, RESERVE_FOR_REPAIR, {
  label: "Reserve for Repair"
}), _defineProperty(_REPAIR_STATUSES, RESERVE_FOR_SHOP_ASSIST, {
  label: "Reserve For Shop Assist"
}), _defineProperty(_REPAIR_STATUSES, RETURNING_FROM_SHOP, {
  label: "Returning From Shop"
}), _defineProperty(_REPAIR_STATUSES, RETURNING_FROM_SHOP_TO_CUSTOMER, {
  label: "Returning From Shop To Customer"
}), _defineProperty(_REPAIR_STATUSES, REPAIRED, {
  label: "Repaired"
}), _defineProperty(_REPAIR_STATUSES, CORE_RETURNED_TO_CUSTOMER, {
  label: "Core Returned To Customer"
}), _REPAIR_STATUSES);

var CURRENTLY_REPAIRING_STATUSES = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_removeKey__["a" /* default */])(REPAIR_STATUSES, REPAIRED);

var CURRENTLY_TRANSFERRING_STATUSES = [TRANSFER_IRE_BOUND, TRANSFER_SGP_BOUND, TRANSFER_USA_BOUND];

var QC_STATUSES = (_QC_STATUSES = {}, _defineProperty(_QC_STATUSES, UNDER_REVIEW, {
  label: "Under Review"
}), _defineProperty(_QC_STATUSES, QC_HOLD, {
  label: "QC Hold"
}), _defineProperty(_QC_STATUSES, PASS, {
  label: "Pass"
}), _QC_STATUSES);

var INVENTORIES = {
  condition: (_condition = {}, _defineProperty(_condition, OVERHAULED, {
    abbrev: "OH",
    label: "Overhauled"
  }), _defineProperty(_condition, REPAIRED, {
    abbrev: "SV",
    label: "Repaired"
  }), _defineProperty(_condition, INSPECTED, {
    abbrev: "BT",
    label: "Inspected"
  }), _defineProperty(_condition, NEW_ITEM, {
    abbrev: "NE",
    label: "New"
  }), _defineProperty(_condition, AS_REMOVED, {
    abbrev: "AR",
    label: "As Removed"
  }), _defineProperty(_condition, BEYOND_REPAIR, {
    abbrev: "BR",
    label: "Beyond Repair"
  }), _defineProperty(_condition, PARTS_UNIT, {
    abbrev: "PU",
    label: "Parts Unit"
  }), _defineProperty(_condition, SCRAP, {
    abbrev: "SC",
    label: "Scrap"
  }), _defineProperty(_condition, __WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__["a" /* SERVICEABLE_TOOLING */], {
    abbrev: "SV",
    label: "Serviceable Tooling"
  }), _condition),
  listing_override: {
    false: {
      label: "Do Not List"
    },
    true: {
      label: "List"
    }
  }
};

var COST_ADJUSTMENT_OPTIONS = {
  neg_exchange_2nd: {
    label: "2nd Exchange Cost Adjustment (-)",
    cancellable: true,
    abbrev: "2Exch (-)",
    inventory_only: true
  },
  pos_exchange_2nd_reversal: {
    label: "2nd Exchange Reversal Cost Adjustment (+)",
    cancellable: true,
    abbrev: "2ExchRev (+)",
    inventory_only: true
  },
  neg_exchange_3rd: {
    label: "3rd Exchange Cost Adjustment (-)",
    cancellable: true,
    abbrev: "3Exch (-)",
    inventory_only: true
  },
  pos_exchange_3rd_reversal: {
    label: "3rd Exchange Reversal Cost Adjustment (+)",
    cancellable: true,
    abbrev: "3ExchRev (+)",
    inventory_only: true
  },
  pos_assigned_core_return: {
    label: "Assigned Core Return (+)",
    abbrev: "Asgnd Core Return (+)",
    cancellable: true,
    inventory_only: true
  },
  neg_assigned_core_return: {
    label: "Assigned Core Return (-)",
    abbrev: "Asgnd Core Return (-)",
    cancellable: true,
    inventory_only: true
  },
  neg_credit_exchange_sale: {
    label: "Cancelled Outright Sale (Exch Credited) (-)",
    cancellable: true,
    abbrev: "CnclOutRt (ExchCred) (-)",
    inventory_only: true
  },
  pos_cancelled_sales_order: {
    label: "Cancelled Sales Order (+)",
    abbrev: "Cncl SO (+)",
    cancellable: true,
    inventory_only: true
  },
  neg_cancelled_sales_order: {
    label: "Cancelled Sales Order (-)",
    abbrev: "Cncl SO (-)",
    cancellable: true,
    inventory_only: true
  },
  pos_container_fee: {
    label: "Container Fee (+)",
    abbrev: "CntrFee (+)",
    cancellable: true
  },
  neg_core_return_cost_savings: {
    label: "Core Return Cost Savings (-)",
    cancellable: true,
    abbrev: "CoreRt (-)",
    inventory_only: true
  },
  neg_core_return_fee_savings: {
    label: "Core Return Fee Savings (-)",
    abbrev: "Core Return Fee (-)",
    cancellable: true,
    inventory_only: true
  },
  pos_consignor_cost: {
    label: "Consignor's Cost (+)",
    abbrev: "Consignor Cost",
    cancellable: true
  },
  neg_po_credit: {
    label: "Credit Amount (PO) (-)",
    cancellable: true,
    abbrev: "CredAmt PO (-)"
  },
  neg_ro_credit: {
    label: "Credit Amount (RO) (-)",
    abbrev: "CredAmt RO (-)",
    cancellable: true,
    inventory_only: true
  },
  neg_so_credit: {
    label: "Credit Amount (SO) (-)",
    abbrev: "CredAmt SO (-)",
    cancellable: true,
    inventory_only: true
  },
  pos_customer_rma_credit: {
    label: "Customer RMA Credit (+)",
    cancellable: true,
    abbrev: "CustRMA Cred (+)"
  },
  pos_customer_partial_credit: {
    label: "Customer Partial Credit (+)",
    cancellable: true,
    abbrev: "CustPrtl Cred (+)"
  },
  pos_customs_duties_taxes: {
    label: "Customs, Duties & Taxes (+)",
    abbrev: "CustDutTx (+)",
    cancellable: true
  },
  pos_customs_handling_processing_fees: {
    label: "Customs Handling/Processing Fees (+)",
    abbrev: "Cst Hndl/Prcs Fee (+)",
    cancellable: true
  },
  neg_credit_po_exchange_sale: {
    label: "Credit PO Exchange Sale (-)",
    cancellable: true,
    abbrev: "Credit PO Exch",
    inventory_only: true
  },
  pos_credit_exchange_sale: {
    label: "Credited Exchange Sale (+)",
    cancellable: true,
    abbrev: "CnclExchSO (+)",
    inventory_only: true
  },
  neg_depreciation: {
    label: function label(subtype) {
      return "Depreciation " + (subtype && "(" + subtype + ") " || "") + "(-)";
    },
    cancellable: true,
    abbrev: "Dep (-)"
  },
  pos_evaluation_fee: {
    label: "Evaluation Fee (+)",
    cancellable: true,
    abbrev: "EvFee (+)",
    inventory_only: true
  },
  neg_exchange: {
    label: "Exchange Cost Adjustment (-)",
    cancellable: true,
    abbrev: "Exch (-)",
    inventory_only: true
  },
  neg_exchange_gone_outright: {
    label: "Exchange Gone Outright (SO) (-)",
    cancellable: true,
    abbrev: "ExchGOR SO (-)",
    inventory_only: true
  },
  pos_exchange_reversal: {
    label: "Exchange Reversal (+)",
    cancellable: true,
    abbrev: "ExchRev (+)",
    inventory_only: true
  },
  pos_finders_fee: {
    label: "Finders Fee (+)",
    abbrev: "FndrFee (+)",
    cancellable: true,
    inventory_only: true
  },
  pos_handling_fee: {
    label: "Handling Fee (+)",
    abbrev: "HndlFee (+)",
    cancellable: true
  },
  pos_hazmat_fee: {
    label: "Hazmat Fee (+)",
    abbrev: "Hzmt (+)",
    cancellable: true
  },
  pos_po_incoming_freight: {
    label: "Incoming Freight (PO) (+)",
    abbrev: "IncFrgt PO (+)",
    cancellable: true
  },
  neg_po_incoming_freight: {
    label: "Incoming Freight (PO) (-)",
    abbrev: "Inc Frgt PO (-)",
    cancellable: true
  },
  pos_ro_incoming_freight: {
    label: "Incoming Freight (RO) (+)",
    abbrev: "IncFrgt RO (+)",
    cancellable: true
  },
  neg_ro_incoming_freight: {
    label: "Incoming Freight (RO) (-)",
    abbrev: "Inc Frgt (-)",
    cancellable: true
  },
  pos_rma_incoming_freight: {
    label: "Incoming Freight (RMA) (+)",
    abbrev: "IncFrgt RMA (+)",
    cancellable: true
  },
  neg_internal_outright: {
    label: "Internal Outright (-)",
    cancellable: true,
    abbrev: "IntOut (-)"
  },
  pos_inventory_transfer: {
    label: "Inventory Transfer (+)",
    abbrev: "InvTran (+)",
    cancellable: true
  },
  pos_lot_cost: {
    label: "Lot Cost (+)",
    abbrev: "Lot Cost (+)"
  },
  neg_lot_cost: {
    label: "Lot Cost (-)",
    abbrev: "Lot Cost (-)"
  },
  pos_miscellaneous: {
    label: "Miscellaneous (+)",
    abbrev: "Miscellaneous (+)",
    cancellable: true
  },
  pos_mistake_correction: {
    label: "Mistake Correction (+)",
    abbrev: "MstkCorr (+)",
    cancellable: true
  },
  neg_mistake_correction: {
    label: "Mistake Correction (-)",
    abbrev: "MstkCorr (-)",
    cancellable: true
  },
  pos_rma_outgoing_freight: {
    label: "Outgoing Freight (RMA) (+)",
    cancellable: true,
    abbrev: "OutFrgt RMA (+)"
  },
  pos_ro_outgoing_freight: {
    label: "Outgoing Freight (RO) (+)",
    abbrev: "OutFrgt RO (+)",
    cancellable: true
  },
  pos_po_outright_sale: {
    label: "Outright Purchase (PO) (+)",
    abbrev: "Outright PO (+)",
    cancellable: true,
    inventory_only: true
  },
  neg_partial_credit_request_rma: {
    label: "Partial Credit (PO) (-)",
    cancellable: true,
    abbrev: "Prtl Cred PO (-)"
  },
  neg_partial_credit_from_vendor: {
    label: "Partial Credit From Vendor (-)",
    cancellable: true,
    abbrev: "PrtCred Vendor (-)"
  },
  pos_sale_from_partial_customer_rma: {
    label: "Partially Returned SO (+)",
    cancellable: true,
    abbrev: "Prtl Ret. SO (+)"
  },
  neg_previously_written_down: {
    label: "Previously Written Down (-)",
    cancellable: true,
    abbrev: "PrevWrtDwn (-)"
  },
  neg_pro_bono_writedown: {
    label: "Pro Bono Depreciation (-)",
    abbrev: "ProBono Depr (-)",
    cancellable: true
  },
  pos_repair_assist_fee: {
    label: "Repair Assist Fee (+)",
    cancellable: true,
    abbrev: "RepAsstFee (+)"
  },
  pos_sale_from_customer_rma: {
    label: "Returned SO (+)",
    cancellable: true,
    abbrev: "Returned SO (+)"
  },
  pos_ro_repair: {
    label: function label(subtype) {
      return (subtype && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_text__["c" /* properCase */])(subtype) + " " || "Repair Cost (RO)") + " (+)";
    },
    cancellable: true,
    abbrev: "RepCost RO (+)"
  },
  pos_sale: {
    label: "Sale Reversal (+)",
    cancellable: true,
    abbrev: "Sale Rev (+)"
  },
  pos_shop_assist: {
    label: "Shop Assist (+)",
    abbrev: "ShpAsst (+)",
    cancellable: true,
    inventory_only: true
  },
  neg_shop_assist: {
    label: "Shop Assist (-)",
    abbrev: "ShpAsst (-)",
    cancellable: true,
    inventory_only: true
  },
  neg_shop_assist_cost_savings_transferred: {
    label: "Shop Assist Savings Transferred (-)",
    abbrev: "ShpAsst Savings (-)",
    cancellable: true,
    inventory_only: true
  },
  neg_sale: {
    label: function label(subtype) {
      return "Sold " + (subtype && "(" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_text__["c" /* properCase */])(subtype) + ") " || "") + "(-)";
    },
    cancellable: true,
    abbrev: "Sold (-)"
  },
  pos_teardown_cost_transfer: {
    label: "Teardown Cost Transfer (+)",
    cancellable: true,
    abbrev: "Teardown (+)"
  },
  neg_teardown_cost_transfer: {
    label: "Teardown Cost Transfer (-)",
    abbrev: "Teardown (-)",
    cancellable: true
  },
  neg_vendor_rma_credit_issued: {
    label: "Vendor RMA Credit Issued (-)",
    cancellable: true,
    abbrev: "VndRMA Cred Iss (-)"
  },
  pos_warranty_non_reimbursed: {
    label: "Warranty Non-Reimbursed (+)",
    cancellable: true,
    abbrev: "Wrnty NR (+)"
  },
  neg_warranty_non_reimbursed: {
    label: "Warranty Non-Reimbursed (-)",
    cancellable: true,
    abbrev: "Wrnty NR (-)"
  }
};

var CANCELLABLE_COST_ADJUSTMENTS = Object.keys(COST_ADJUSTMENT_OPTIONS).filter(function (k) {
  return COST_ADJUSTMENT_OPTIONS[k].cancellable;
});

var TRACEABILITY = "traceability";
var TAG_COPIES = "tag_copies";
var PHOTOS = "photos";
var EXTERNAL_LINK = "external_link";
var OTHER = "other";
var BACK_TO_BIRTH = "back_to_birth";
var REMOVAL_TAG = "removal_tag";
var NON_USE_NON_INSTALL = "non_use_non_install";

var ATTACHMENT_TYPES = (_ATTACHMENT_TYPES = {}, _defineProperty(_ATTACHMENT_TYPES, BACK_TO_BIRTH, {
  label: "Back To Birth Documents"
}), _defineProperty(_ATTACHMENT_TYPES, TAG_COPIES, {
  label: "Tag Copies"
}), _defineProperty(_ATTACHMENT_TYPES, TRACEABILITY, {
  label: "Traceability"
}), _defineProperty(_ATTACHMENT_TYPES, "data_plate_dom_photos", {
  label: "Data Plate / DOM Photos"
}), _defineProperty(_ATTACHMENT_TYPES, EXTERNAL_LINK, {
  label: "External Link"
}), _defineProperty(_ATTACHMENT_TYPES, "commercial_invoice", {
  label: "Commercial Invoice"
}), _defineProperty(_ATTACHMENT_TYPES, NON_USE_NON_INSTALL, {
  label: "Non-Use / Non-Install Statement for Returns"
}), _defineProperty(_ATTACHMENT_TYPES, "final_packaging_photos", {
  label: "Photos - Final Packaging"
}), _defineProperty(_ATTACHMENT_TYPES, PHOTOS, {
  label: "Photos - Receiving Inspection"
}), _defineProperty(_ATTACHMENT_TYPES, __WEBPACK_IMPORTED_MODULE_6__Receiving_constants__["a" /* PHOTOS_RECEIVING_PACKAGING_INSPECTION */], {
  label: "Photos - Receiving Packaging Inspection"
}), _defineProperty(_ATTACHMENT_TYPES, "photos_receiving_inspection", {
  label: "Photos - Shipping Inspection"
}), _defineProperty(_ATTACHMENT_TYPES, REMOVAL_TAG, {
  label: "Removal Tag"
}), _defineProperty(_ATTACHMENT_TYPES, "shipping_checklist", {
  label: "Shipping Checklist"
}), _defineProperty(_ATTACHMENT_TYPES, "other", {
  label: "Other"
}), _ATTACHMENT_TYPES);

var TRACE_TYPES = {
  121: {
    label: "121",
    abbrev: "121"
  },
  125: {
    label: "125",
    abbrev: "125"
  },
  129: {
    label: "129",
    abbrev: "129"
  },
  135: {
    label: "135",
    abbrev: "135"
  },
  145: {
    label: "145",
    abbrev: "145"
  },
  part_91: {
    label: "Part 91",
    abbrev: "Part91"
  },
  foreign_part_91: {
    label: "Foreign Part 91",
    abbrev: "FrgnPrt91"
  },
  certificate_of_conformance: {
    label: "C of C Only",
    abbrev: "C of C"
  },
  foreign_operator: {
    label: "Foreign Operator",
    abbrev: "FrgnOp"
  },
  foreign_repair_station: {
    label: "Foreign Repair Station",
    abbrev: "Frgn145"
  },
  ntr: {
    label: "No Trace",
    abbrev: "NoTrace"
  },
  oem: {
    label: "OEM",
    abbrev: "OEM"
  },
  unknown: {
    label: "Unknown",
    abbrev: "UNK"
  }
};

var APPLY_LOT_COST = "apply-lot-cost";
var ASSIGN_EXCHANGE = "assign-exchange";
var CANCEL_CONSIGNMENT = "cancel-consignment";
var CREATE_COMMERCIAL_INVOICE = "create-commercial-invoice";
var CREATE_DUMMY_RECORD = "create-dummy";
var DOWNLOAD_SCRAP_CERT = "download-scrap-cert";
var PRINT = "print";
var PURCHASED_FOR_EXCHANGE_ID = "purchased_for_exchange_id";
var REMOVE_EMA = "remove-ema";
var REQUEST_SCRAP_AT_SHOP = "request-scrap-at-shop";
var RESERVE_INV_FOR_SALE = "reserve-for-sale";
var RESERVE_INV_FOR_REPAIR = "reserve-for-repair";
var RETURN_TO_CUSTOMER = "return-to-customer";
var RETURN_TO_CUSTOMER_V2 = "return-to-customer-v2";
var RETURN_TO_STOCK = "return-to-stock";
var RETURN_CORE_TO_CUSTOMER = "return-core-to-customer";
var UNRESERVE_REPAIR = "unreserve-for-repair";
var UPDATE_STATUS = "update-status";
var UPDATE_SRP = "update-srp-status";
var UPDATE_QC_STATUS = "update-qc-status";
var SCRAP_REPORT_RECEIVED = "scrap-report-received";
var SCRAP_INV_LOCALLY = "scrap-locally";
var SCRAP_AT_SHOP = "scrap-at-shop";
var SPLIT_INVENTORY = "split-inventory";
var TRANSFER_INVENTORY = "transfer-inventory";
var CANCEL_TRANSFER = "cancel-transfer";
var CANCEL_MOD_TO = "cancel-mod-to";
var CREATE_VENDOR_RMA = "create-vendor-rma";

var CONDITION_WARRANTIES = (_CONDITION_WARRANTIES = {}, _defineProperty(_CONDITION_WARRANTIES, NEW_ITEM, "1 year"), _defineProperty(_CONDITION_WARRANTIES, OVERHAULED, "1 year"), _defineProperty(_CONDITION_WARRANTIES, REPAIRED, "6 months"), _defineProperty(_CONDITION_WARRANTIES, INSPECTED, "30 days"), _defineProperty(_CONDITION_WARRANTIES, AS_REMOVED, "No warranty, 30 days inspection"), _defineProperty(_CONDITION_WARRANTIES, BEYOND_REPAIR, ""), _CONDITION_WARRANTIES);

var WARRANTY_OPTIONS = ["30 days", "60 days", "90 days", "120 days", "6 months", "1 year", "18 months", "24 months", "36 months", "Warranty by MRO", "No warranty", "No warranty, 30 days inspection"];

var ANNIV = "ANNIV";
var ARC = "ARC";
var DARC = "DARC";
var MAPS = "MAPS";
var NAP = "NAP";
var PFONQ = "P-FONQ";
var QUUC = "QUUC";
var SOCS = "SOCS";

var SRP_CHANGE_REASONS = [SOCS, DARC, ARC, QUUC, ANNIV, MAPS, NAP, PFONQ, OTHER].reduce(function (acc, field) {
  return _extends({}, acc, _defineProperty({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["upperCase"])(field), { label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["upperCase"])(field) }));
}, {});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_arrays__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(41);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return AIRLINE_SERVICES_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return AS_IS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BOOKMARKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return BUYING_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return BUYER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CACHED_SALES_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CAN_ADD_COMPANIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CAN_UPDATE_COMPANIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CAN_DELETE_RECEIVING_RECORD_ATTACHMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CAN_EDIT_DO_NOT_EXCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CAN_OVERRIDE_LISTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CAN_RELEASE_SHIPMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CAN_RELEASE_ACCOUNTING_HOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CAN_RELEASE_CORE_RETURN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CO_BUYER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CO_BUYER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return COMMISSION_CREDIT_PERCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EMAIL_VERIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return EXPORT_LIMIT; });
/* unused harmony export RELEASE_EXPORT_COMPLIANCE_HOLD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REPAIR_CART_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SALES_CART_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return TEAM_LEADER_CREDIT_PERCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return TEAM_LEADER_COMMISSION_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return TEAM_MEMBERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return THIRD_BUYER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return THIRD_BUYER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return USER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return EXCHANGE_COMMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return FIRST_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FULL_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return LAST_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return MANAGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return NOTIFICATION_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return PERMISSIONS; });
/* unused harmony export REPAIR_ORDER_CART_ITEMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return RESET_PASSWORD_TOKEN; });
/* unused harmony export SALES_ORDER_CART_ITEMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SUBROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return HIGH_CONFIDENCE_BUYER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ACCOUNTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return BUYER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return QUALITY_CONTROL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SALES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return REPAIR; });
/* unused harmony export REPAIRS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return WAREHOUSE; });
/* unused harmony export ACCOUNTING_ADMIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return ACCOUNTING_MANAGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return BUYER_MANAGER; });
/* unused harmony export PURCHASING */
/* unused harmony export PURCHASING_MANAGER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return QUALITY_CONTROL_MANAGER; });
/* unused harmony export QUALITY_CONTROL_EXPEDITOR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return QUALITY_CONTROL_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SALES_MANAGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return WAREHOUSE_BASIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return WAREHOUSE_EXPERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return WAREHOUSE_MANAGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return WAREHOUSE_LOGISTICS_DIRECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return USER_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SUBROLES_BY_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SUBROLES; });
/* unused harmony export NOT_APPROVER */
/* unused harmony export RESIDENT_EXPERT_APPROVER */
/* unused harmony export APPROVER */
/* unused harmony export SUPER_APPROVER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return PO_APPROVAL_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return NOTIFICATION_ROLES_ARRAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CAN_ADD_UPDATE_APPLICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CAN_ADD_UPDATE_PARTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CAN_EXPORT_COMPANIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CAN_MERGE_PART_NUMBERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CAN_RELEASE_QC_HOLD; });
/* unused harmony export CAN_VIEW_ACTIVE_PARTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CAN_RELEASE_EXPORT_COMPLIANCE_HOLD; });
/* unused harmony export CAN_VIEW_ALL_COMMISSIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CAN_VIEW_ALL_INVENTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CAN_VIEW_INFOTRADER_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CAN_VIEW_UPDATE_ALL_RESERVED_FOR_SALE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RECEIVING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CREATE_POS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CREATE_COC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CREATE_COMMERCIAL_INVOICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CREATE_PACKING_SLIP; });
/* unused harmony export CREATE_ROS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CREATE_IQS_OQS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CREATE_VENDOR_RMAS; });
/* unused harmony export PERMISSIONS_ARRAY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return ROLES_WITHOUT_ADMIN_WH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return ROLES_WITH_PERMISSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return SUBROLES_WITH_PERMISSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return PERMISSIONS_OPTIONS; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _USER_ROLES, _ACCOUNTING, _QUALITY_CONTROL, _WAREHOUSE, _SUBROLES_BY_ROLE, _PO_APPROVAL_ROLES, _ROLES_WITH_PERMISSIO, _SUBROLES_WITH_PERMIS, _map$reduce;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var USER = "user";

var AIRLINE_SERVICES_NOTIFICATION = "airline_services_notification";
var AS_IS = "as_is";
var ACTIVE = "active";
var BOOKMARKS = "bookmarks";
var BUYING_LIMIT = "buying_limit";
var BUYER_ID = "buyer_id";
var CACHED_SALES_CART = "cachedSalesCart";
var CAN_ADD_COMPANIES = "can_add_companies";
var CAN_UPDATE_COMPANIES = "can_update_companies";
var CAN_DELETE_RECEIVING_RECORD_ATTACHMENTS = "can_delete_receiving_record_attachments";
var CAN_EDIT_DO_NOT_EXCHANGE = "can_edit_do_not_exchange";
var CAN_OVERRIDE_LISTING = "can_override_listing";
var CAN_RELEASE_SHIPMENT = "can_release_shipment";
var CAN_RELEASE_ACCOUNTING_HOLD = "can_release_accounting_hold";
var CAN_RELEASE_CORE_RETURN = "can_release_core_return";
var CO_BUYER = "co_buyer";
var CO_BUYER_ID = "co_buyer_id";
var COMMISSION_CREDIT_PERCENT = "commission_credit_percent";
var EMAIL = "email";
var EMAIL_VERIFIED = "email_verified";
var EXPORT_LIMIT = 1875;
var RELEASE_EXPORT_COMPLIANCE_HOLD = "release_export_compliance_hold";
var REPAIR_CART_ITEMS = "repairCartItems";
var SALES_CART_ITEMS = "salesCartItems";
var TEAM_LEADER_CREDIT_PERCENT = "team_leader_credit_percent";
var TEAM_LEADER_COMMISSION_ENABLED = "team_leader_commission_enabled";
var TEAM_MEMBERS = "team_members";
var THIRD_BUYER = "third_buyer";
var THIRD_BUYER_ID = "third_buyer_id";
var USER_ID = "user_id";
var EXCHANGE_COMMISSIONS = "exchange_commissions";
var FIRST_NAME = "first_name";
var FULL_NAME = "full_name";
var ID = "id";
var LAST_NAME = "last_name";
var MANAGER = "manager";
var ROLE = "role";
var NOTIFICATION_ROLES = "notification_roles";
var PERMISSIONS = "permissions";
var REPAIR_ORDER_CART_ITEMS = "repair_order_cart_items";
var RESET_PASSWORD_TOKEN = "reset_password_token";
var SALES_ORDER_CART_ITEMS = "sales_order_cart_items";
var SUBROLE = "subrole";
var HIGH_CONFIDENCE_BUYER = "high_confidence_buyer";

var ADMIN = "admin";
var ACCOUNTING = "accounting";
var BUYER = "buyer";
var QUALITY_CONTROL = "quality_control";
var SALES = "sales";
var REPAIR = "repair";
var REPAIRS = "repairs";
var WAREHOUSE = "warehouse";

var ACCOUNTING_ADMIN = "accounting_admin";
var ACCOUNTING_MANAGER = "accounting_manager";
var BUYER_MANAGER = "buyer_manager";
var PURCHASING = "purchasing";
var PURCHASING_MANAGER = "purchasing_manager";
var QUALITY_CONTROL_MANAGER = "quality_control_manager";
var QUALITY_CONTROL_EXPEDITOR = "quality_control_expeditor";
var QUALITY_CONTROL_ADMIN = "quality_control_admin";
var SALES_MANAGER = "sales_manager";
var WAREHOUSE_BASIC = "warehouse_basic";
var WAREHOUSE_EXPERT = "warehouse_expert";
var WAREHOUSE_MANAGER = "warehouse_manager";
var WAREHOUSE_LOGISTICS_DIRECTOR = "warehouse_logistics_director";

var ROLES = [ADMIN, ACCOUNTING, QUALITY_CONTROL, SALES, WAREHOUSE, REPAIR];

var USER_ROLES = (_USER_ROLES = {}, _defineProperty(_USER_ROLES, ACCOUNTING, { label: "Accounting" }), _defineProperty(_USER_ROLES, ADMIN, { label: "Admin" }), _defineProperty(_USER_ROLES, QUALITY_CONTROL, { label: "Quality Control" }), _defineProperty(_USER_ROLES, REPAIR, { label: "Repair" }), _defineProperty(_USER_ROLES, SALES, { label: "Sales" }), _defineProperty(_USER_ROLES, WAREHOUSE, { label: "Warehouse" }), _USER_ROLES);

var SUBROLES_BY_ROLE = (_SUBROLES_BY_ROLE = {}, _defineProperty(_SUBROLES_BY_ROLE, ACCOUNTING, (_ACCOUNTING = {}, _defineProperty(_ACCOUNTING, ACCOUNTING_ADMIN, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* subroleLabel */])(ACCOUNTING, ACCOUNTING_ADMIN)
}), _defineProperty(_ACCOUNTING, ACCOUNTING_MANAGER, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* subroleLabel */])(ACCOUNTING, ACCOUNTING_MANAGER)
}), _ACCOUNTING)), _defineProperty(_SUBROLES_BY_ROLE, QUALITY_CONTROL, (_QUALITY_CONTROL = {}, _defineProperty(_QUALITY_CONTROL, QUALITY_CONTROL_ADMIN, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* subroleLabel */])(QUALITY_CONTROL, QUALITY_CONTROL_ADMIN)
}), _defineProperty(_QUALITY_CONTROL, QUALITY_CONTROL_MANAGER, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* subroleLabel */])(QUALITY_CONTROL, QUALITY_CONTROL_MANAGER)
}), _defineProperty(_QUALITY_CONTROL, QUALITY_CONTROL_EXPEDITOR, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* subroleLabel */])(QUALITY_CONTROL, QUALITY_CONTROL_EXPEDITOR)
}), _QUALITY_CONTROL)), _defineProperty(_SUBROLES_BY_ROLE, WAREHOUSE, (_WAREHOUSE = {}, _defineProperty(_WAREHOUSE, WAREHOUSE_BASIC, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* subroleLabel */])(WAREHOUSE, WAREHOUSE_BASIC)
}), _defineProperty(_WAREHOUSE, WAREHOUSE_EXPERT, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* subroleLabel */])(WAREHOUSE, WAREHOUSE_EXPERT)
}), _defineProperty(_WAREHOUSE, WAREHOUSE_MANAGER, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* subroleLabel */])(WAREHOUSE, WAREHOUSE_MANAGER)
}), _defineProperty(_WAREHOUSE, WAREHOUSE_LOGISTICS_DIRECTOR, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* subroleLabel */])(WAREHOUSE, WAREHOUSE_LOGISTICS_DIRECTOR)
}), _WAREHOUSE)), _defineProperty(_SUBROLES_BY_ROLE, PURCHASING, _defineProperty({}, PURCHASING_MANAGER, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* subroleLabel */])(PURCHASING, PURCHASING_MANAGER)
})), _defineProperty(_SUBROLES_BY_ROLE, SALES, _defineProperty({}, SALES_MANAGER, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* subroleLabel */])(SALES, SALES_MANAGER)
})), _SUBROLES_BY_ROLE);

var SUBROLES = [ACCOUNTING_MANAGER, QUALITY_CONTROL_MANAGER, QUALITY_CONTROL_EXPEDITOR, QUALITY_CONTROL_ADMIN, WAREHOUSE_BASIC, WAREHOUSE_EXPERT, WAREHOUSE_MANAGER, WAREHOUSE_LOGISTICS_DIRECTOR];

var NOT_APPROVER = "not_approver";
var RESIDENT_EXPERT_APPROVER = "resident_expert_approver";
var APPROVER = "approver";
var SUPER_APPROVER = "super_approver";

var PO_APPROVAL_ROLES = (_PO_APPROVAL_ROLES = {}, _defineProperty(_PO_APPROVAL_ROLES, NOT_APPROVER, {
  label: "None"
}), _defineProperty(_PO_APPROVAL_ROLES, RESIDENT_EXPERT_APPROVER, {
  label: "Resident Expert Approver (up to $50k)"
}), _defineProperty(_PO_APPROVAL_ROLES, APPROVER, {
  label: "Standard Approver (up to $100k)"
}), _defineProperty(_PO_APPROVAL_ROLES, SUPER_APPROVER, {
  label: "Super Approver ($100k+)"
}), _PO_APPROVAL_ROLES);

var NOTIFICATION_ROLES_ARRAY = [ACCOUNTING_ADMIN, ACCOUNTING, ACCOUNTING_MANAGER, PURCHASING, PURCHASING_MANAGER, QUALITY_CONTROL, QUALITY_CONTROL_EXPEDITOR, QUALITY_CONTROL_ADMIN, QUALITY_CONTROL_MANAGER, REPAIR, SALES, SALES_MANAGER, WAREHOUSE, WAREHOUSE_BASIC, WAREHOUSE_EXPERT, WAREHOUSE_MANAGER, WAREHOUSE_LOGISTICS_DIRECTOR];

var CAN_ADD_UPDATE_APPLICATIONS = "can_add_update_applications";
var CAN_ADD_UPDATE_PARTS = "can_add_update_parts";
var CAN_EXPORT_COMPANIES = "can_export_companies";
var CAN_MERGE_PART_NUMBERS = "can_merge_part_numbers";
var CAN_RELEASE_QC_HOLD = "can_release_qc_hold";
var CAN_VIEW_ACTIVE_PARTS = "can_view_active_parts";
var CAN_RELEASE_EXPORT_COMPLIANCE_HOLD = "can_release_export_compliance_hold";
var CAN_VIEW_ALL_COMMISSIONS = "can_view_all_commissions";
var CAN_VIEW_ALL_INVENTORY = "can_view_all_inventory";
var CAN_VIEW_INFOTRADER_SETTINGS = "can_view_infotrader_settings";
var CAN_VIEW_UPDATE_ALL_RESERVED_FOR_SALE_LIST = "can_view_update_all_reserved_for_sale_list";
var RECEIVING = "receiving";
var CREATE_POS = "create_pos";
var CREATE_COC = "create_coc";
var CREATE_COMMERCIAL_INVOICE = "create_commercial_invoice";
var CREATE_PACKING_SLIP = "create_packing_slip";
var CREATE_ROS = "create_ros";
var CREATE_IQS_OQS = "create_iqs_oqs";
var CREATE_VENDOR_RMAS = "create_vendor_rmas";

var PERMISSIONS_ARRAY = [CAN_ADD_UPDATE_PARTS];

var ROLES_WITHOUT_ADMIN_WH = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_arrays__["a" /* removeItems */])(ROLES, ADMIN, WAREHOUSE);

var ROLES_WITH_PERMISSION = (_ROLES_WITH_PERMISSIO = {}, _defineProperty(_ROLES_WITH_PERMISSIO, ACCOUNTING, [ACCOUNTING]), _defineProperty(_ROLES_WITH_PERMISSIO, CAN_ADD_UPDATE_APPLICATIONS, [QUALITY_CONTROL, SALES]), _defineProperty(_ROLES_WITH_PERMISSIO, CAN_ADD_COMPANIES, [QUALITY_CONTROL]), _defineProperty(_ROLES_WITH_PERMISSIO, CAN_UPDATE_COMPANIES, [QUALITY_CONTROL]), _defineProperty(_ROLES_WITH_PERMISSIO, CAN_ADD_UPDATE_PARTS, [SALES]), _defineProperty(_ROLES_WITH_PERMISSIO, CAN_MERGE_PART_NUMBERS, []), _defineProperty(_ROLES_WITH_PERMISSIO, CAN_RELEASE_ACCOUNTING_HOLD, [ACCOUNTING]), _defineProperty(_ROLES_WITH_PERMISSIO, CAN_RELEASE_EXPORT_COMPLIANCE_HOLD, [QUALITY_CONTROL]), _defineProperty(_ROLES_WITH_PERMISSIO, CAN_RELEASE_QC_HOLD, [QUALITY_CONTROL]), _defineProperty(_ROLES_WITH_PERMISSIO, CAN_VIEW_ACTIVE_PARTS, [CAN_VIEW_ACTIVE_PARTS]), _defineProperty(_ROLES_WITH_PERMISSIO, CAN_VIEW_ALL_INVENTORY, [QUALITY_CONTROL, ACCOUNTING]), _defineProperty(_ROLES_WITH_PERMISSIO, CREATE_COMMERCIAL_INVOICE, [ADMIN]), _defineProperty(_ROLES_WITH_PERMISSIO, CREATE_POS, ROLES_WITHOUT_ADMIN_WH), _defineProperty(_ROLES_WITH_PERMISSIO, CREATE_VENDOR_RMAS, ROLES_WITHOUT_ADMIN_WH), _defineProperty(_ROLES_WITH_PERMISSIO, CREATE_IQS_OQS, [SALES, REPAIR]), _defineProperty(_ROLES_WITH_PERMISSIO, QUALITY_CONTROL, [QUALITY_CONTROL]), _defineProperty(_ROLES_WITH_PERMISSIO, RECEIVING, [QUALITY_CONTROL, WAREHOUSE, REPAIR]), _defineProperty(_ROLES_WITH_PERMISSIO, CREATE_PACKING_SLIP, [WAREHOUSE_MANAGER, WAREHOUSE_LOGISTICS_DIRECTOR, WAREHOUSE_EXPERT, QUALITY_CONTROL]), _defineProperty(_ROLES_WITH_PERMISSIO, CREATE_COC, [QUALITY_CONTROL]), _defineProperty(_ROLES_WITH_PERMISSIO, REPAIR, [REPAIR]), _defineProperty(_ROLES_WITH_PERMISSIO, SALES, [SALES]), _ROLES_WITH_PERMISSIO);

var SUBROLES_WITH_PERMISSION = (_SUBROLES_WITH_PERMIS = {}, _defineProperty(_SUBROLES_WITH_PERMIS, CREATE_PACKING_SLIP, [WAREHOUSE_MANAGER, WAREHOUSE_LOGISTICS_DIRECTOR, WAREHOUSE_EXPERT]), _defineProperty(_SUBROLES_WITH_PERMIS, CAN_VIEW_ALL_COMMISSIONS, [ACCOUNTING_ADMIN, ACCOUNTING_MANAGER]), _defineProperty(_SUBROLES_WITH_PERMIS, CREATE_COMMERCIAL_INVOICE, [WAREHOUSE_EXPERT, WAREHOUSE_MANAGER, WAREHOUSE_LOGISTICS_DIRECTOR]), _SUBROLES_WITH_PERMIS);

var PERMISSIONS_OPTIONS_UNSORTED = [CAN_DELETE_RECEIVING_RECORD_ATTACHMENTS, CAN_EXPORT_COMPANIES, CAN_RELEASE_ACCOUNTING_HOLD, CAN_RELEASE_CORE_RETURN, CAN_MERGE_PART_NUMBERS, CAN_OVERRIDE_LISTING, ACCOUNTING, QUALITY_CONTROL, QUALITY_CONTROL_MANAGER, RECEIVING, WAREHOUSE_MANAGER].map(function (a) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_forms__["b" /* arrayToManipulatedOptions */])([a], function (text) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_formatters_text__["c" /* properCase */])(text.replace("can_", ""));
  })[0];
}).reduce(function (agg, obj) {
  return _extends({}, agg, _defineProperty({}, obj.value, obj));
}, (_map$reduce = {}, _defineProperty(_map$reduce, CAN_ADD_UPDATE_APPLICATIONS, {
  value: CAN_ADD_UPDATE_APPLICATIONS,
  text: "Add / Update Applications"
}), _defineProperty(_map$reduce, CAN_ADD_UPDATE_PARTS, {
  value: CAN_ADD_UPDATE_PARTS,
  text: "Add / Update Parts"
}), _defineProperty(_map$reduce, CAN_ADD_COMPANIES, {
  value: CAN_ADD_COMPANIES,
  text: "Add Companies"
}), _defineProperty(_map$reduce, CAN_UPDATE_COMPANIES, {
  value: CAN_UPDATE_COMPANIES,
  text: "Update Companies"
}), _defineProperty(_map$reduce, CAN_EDIT_DO_NOT_EXCHANGE, {
  value: CAN_EDIT_DO_NOT_EXCHANGE,
  text: "Do Not Exchange"
}), _defineProperty(_map$reduce, CAN_EXPORT_COMPANIES, {
  value: CAN_EXPORT_COMPANIES,
  text: "Export Companies"
}), _defineProperty(_map$reduce, CAN_VIEW_ALL_COMMISSIONS, {
  value: CAN_VIEW_ALL_COMMISSIONS,
  text: "View All Commissions"
}), _defineProperty(_map$reduce, CAN_VIEW_ALL_INVENTORY, {
  value: CAN_VIEW_ALL_INVENTORY,
  text: "View All Inventory"
}), _defineProperty(_map$reduce, CAN_VIEW_INFOTRADER_SETTINGS, {
  value: CAN_VIEW_INFOTRADER_SETTINGS,
  text: "View InfoTrader Settings"
}), _defineProperty(_map$reduce, CAN_VIEW_UPDATE_ALL_RESERVED_FOR_SALE_LIST, {
  value: CAN_VIEW_UPDATE_ALL_RESERVED_FOR_SALE_LIST,
  text: "View / Update All Reserved For Sale List"
}), _defineProperty(_map$reduce, CAN_RELEASE_QC_HOLD, {
  value: CAN_RELEASE_QC_HOLD,
  text: "Release QC Hold"
}), _defineProperty(_map$reduce, CAN_VIEW_ACTIVE_PARTS, {
  value: CAN_VIEW_ACTIVE_PARTS,
  text: "View Active Parts / Sellable Qty"
}), _defineProperty(_map$reduce, CREATE_IQS_OQS, {
  value: CREATE_IQS_OQS,
  text: "Create IQs/OQs"
}), _defineProperty(_map$reduce, CREATE_POS, {
  value: CREATE_POS,
  text: "Create POs"
}), _defineProperty(_map$reduce, CREATE_COC, {
  value: CREATE_COC,
  text: "Create COC"
}), _defineProperty(_map$reduce, CREATE_COMMERCIAL_INVOICE, {
  value: CREATE_COMMERCIAL_INVOICE,
  text: "Create Commercial Invoice"
}), _defineProperty(_map$reduce, CREATE_PACKING_SLIP, {
  value: CREATE_PACKING_SLIP,
  text: "Create Packing Slip"
}), _defineProperty(_map$reduce, CREATE_VENDOR_RMAS, {
  value: CREATE_VENDOR_RMAS,
  text: "Create Vend RMAs"
}), _defineProperty(_map$reduce, CAN_RELEASE_EXPORT_COMPLIANCE_HOLD, {
  value: CAN_RELEASE_EXPORT_COMPLIANCE_HOLD,
  text: "Release Export Compliance Hold"
}), _defineProperty(_map$reduce, REPAIR, {
  value: REPAIRS,
  text: "Add / Update Repairs"
}), _defineProperty(_map$reduce, SALES, {
  value: SALES,
  text: "Add / Update Sales"
}), _map$reduce));

var PERMISSIONS_OPTIONS = Object.keys(PERMISSIONS_OPTIONS_UNSORTED).sort(function (a, b) {
  var nameA = PERMISSIONS_OPTIONS_UNSORTED[a].text;
  var nameB = PERMISSIONS_OPTIONS_UNSORTED[b].text;

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
}).reduce(function (obj, key) {
  obj[key] = PERMISSIONS_OPTIONS_UNSORTED[key];
  return obj;
}, {});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__(2958)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(262)(module)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react_16_shim__ = __webpack_require__(2352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__(2351);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header__ = __webpack_require__(2350);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Header__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer__ = __webpack_require__(2349);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Body__ = __webpack_require__(352);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__Body__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Close__ = __webpack_require__(2348);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__Close__["a"]; });













/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__connectRecord__ = __webpack_require__(823);
/* unused harmony reexport connectRecord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loadRecord__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__loadRecord__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createNew__ = __webpack_require__(2428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__createNew__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__importNew__ = __webpack_require__(2430);
/* unused harmony reexport importNew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authorization__ = __webpack_require__(2427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_4__authorization__["a"]; });
/* unused harmony reexport authorizedIf */
/* unused harmony reexport disabled */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_4__authorization__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__launchModal__ = __webpack_require__(499);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__launchModal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toggle__ = __webpack_require__(2436);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_6__toggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dismissible__ = __webpack_require__(825);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__dismissible__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_7__dismissible__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dropdown__ = __webpack_require__(2429);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withFilters__ = __webpack_require__(2439);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_9__withFilters__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__withFormFields__ = __webpack_require__(121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_10__withFormFields__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__withFieldsFromForm__ = __webpack_require__(826);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_11__withFieldsFromForm__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withErrorBoundary__ = __webpack_require__(2438);
/* unused harmony reexport withErrorBoundary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__translateProps__ = __webpack_require__(193);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_13__translateProps__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__linkTo__ = __webpack_require__(2431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_14__linkTo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__dataManager__ = __webpack_require__(824);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_15__dataManager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__onChange__ = __webpack_require__(2434);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_16__onChange__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__toggleSwitch__ = __webpack_require__(2437);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_17__toggleSwitch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__renderIf__ = __webpack_require__(356);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_18__renderIf__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__manageFields__ = __webpack_require__(2432);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_19__manageFields__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__tabulateImmutable__ = __webpack_require__(2435);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_20__tabulateImmutable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__miniTable__ = __webpack_require__(2433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_21__miniTable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__withPolling__ = __webpack_require__(2440);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_22__withPolling__["a"]; });
























/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(60);
var core = __webpack_require__(156);
var hide = __webpack_require__(123);
var redefine = __webpack_require__(124);
var ctx = __webpack_require__(146);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DO_NOT_SHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return DROPSHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return USA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return IRE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return SGP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return APPROVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return AS_REMOVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ALTERNATE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return ALLOCATE_TO_SO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return ALLOW_SENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return AMOUNT_PAID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return AMOUNT_INSURED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return ASSIGNED_CORE_RETURN_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ASSIGNED_CORE_RETURN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BUYING_STORE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CANCELLATION_REASON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CAP_AMOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CAP_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CONTAINER_FEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_DUE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_REPAIR_FEE_NOT_TO_EXCEED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DIM_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return EVALUATION_PERIOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EXPECTED_SERIAL_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EXTERNAL_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return HAZMAT_FEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INCIDENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return INTERNAL_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return INSURANCE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return INVOICE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return PERCENT_INSURED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PORTAL_PURCHASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PURCHASE_FOR_STOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PURCHASE_FOR_REPAIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PURCHASE_FOR_SALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PURCHASE_FOR_REPAIR_ASSIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PAYMENT_TERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PREFERRED_REPAIR_STATION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PREFERRED_REPAIR_STATION_HOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return PURCHASED_FOR_SOLI_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return QC_HOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return RESERVE_FOR_SALE_QUANTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return REQUIRES_APPROVAL; });
/* unused harmony export REQUIRES_APPROVAL_EXCEPT_TRACE_HOLD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return TOOL_USED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return TRACE_HOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return TRACE_HOLD_APPROVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return VENDOR_CORE_REPAIR_INVOICE_AMOUNT_PAID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return VENDOR_CORE_REPAIR_INVOICE_DUE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return VENDOR_CORE_REPAIR_INVOICE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return VENDOR_CORE_REPAIR_INVOICE_PAID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return BUYER_CREDIT_PCT_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DO_NOT_SHIP_REASONS; });
/* unused harmony export REPAIR */
/* unused harmony export OVERHAUL */
/* unused harmony export BENCH_TEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return PURCHASE_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CAP_TYPES; });
/* unused harmony export TOOLS_USED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CANCELLATION_REASONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return ATTACHMENT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return WARRANTY_PERIOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return PURCHASE_ORDER_QUICKBOOKS_TYPES; });
var _CAP_TYPES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var COMPANY = "company";
var DO_NOT_SHIP = "do_not_ship";
var DROPSHIP = "dropship";
var USA = "USA";
var IRE = "IRE";
var SGP = "SGP";
var APPROVED = "approved";
var AS_REMOVED = "as_removed";

var ALTERNATE_ID = "alternate_id";
var ALLOCATE_TO_SO = "allocate_to_so";
var ALLOW_SENDING = "allow_sending";
var AMOUNT_PAID = "amount_paid";
var AMOUNT_INSURED = "amount_insured";
var ASSIGNED_CORE_RETURN_ID = "assigned_core_return_id";
var ASSIGNED_CORE_RETURN = "assigned_core_return";
var BUYING_STORE_ID = "buying_store_id";
var CANCELLATION_REASON = "cancellation_reason";
var CAP_AMOUNT = "cap_amount";
var CAP_TYPE = "cap_type";
var CONTAINER_FEE = "container_fee";
var CORE_DUE_DATE = "core_due_date";
var CORE_REPAIR_FEE_NOT_TO_EXCEED = "core_repair_fee_not_to_exceed";
var DIM_WEIGHT = "dim_weight";
var EVALUATION_PERIOD = "evaluation_period";
var EXPECTED_SERIAL_NUMBER = "expected_serial_number";
var EXTERNAL_NOTE = "external_note";
var HAZMAT_FEE = "hazmat_fee";
var INCIDENT = "incident";
var INTERNAL_NOTE = "internal_note";
var INSURANCE_TYPE = "insurance_type";
var INVOICE_NUMBER = "invoice_number";
var PERCENT_INSURED = "percent_insured";
var PORTAL_PURCHASE = "portal_purchase";
var PURCHASE_FOR_STOCK = "purchase_for_stock";
var PURCHASE_FOR_REPAIR = "purchase_for_repair";
var PURCHASE_FOR_SALE = "purchase_for_sale";
var PURCHASE_FOR_REPAIR_ASSIST = "purchase_for_repair_assist";
var PAYMENT_TERMS = "payment_terms";
var PREFERRED_REPAIR_STATION_ID = "preferred_repair_station_id";
var PREFERRED_REPAIR_STATION_HOLD = "preferred_repair_station_hold";
var PURCHASED_FOR_SOLI_ID = "purchased_for_soli_id";
var QC_HOLD = "qc_hold";
var REJECTED = "rejected";
var RESERVE_FOR_SALE_QUANTITY = "reserve_for_sale_quantity";
var REQUIRES_APPROVAL = "requires_approval";
var REQUIRES_APPROVAL_EXCEPT_TRACE_HOLD = "requires_approval_except_trace_hold";
var TOOL_USED = "tool_used";
var TRACE_HOLD = "trace_hold";
var TRACE_HOLD_APPROVED = "trace_hold_approved";
var VENDOR_CORE_REPAIR_INVOICE_AMOUNT_PAID = "vendor_core_repair_invoice_amount_paid";
var VENDOR_CORE_REPAIR_INVOICE_DUE_DATE = "vendor_core_repair_invoice_due_date";
var VENDOR_CORE_REPAIR_INVOICE_NUMBER = "vendor_core_repair_invoice_number";
var VENDOR_CORE_REPAIR_INVOICE_PAID = "vendor_core_repair_invoice_paid";

var REQUIRES_8130_3 = "requires_8130_3";
var REQUIRES_TRACE_DOCUMENTATION = "requires_trace_documentation";
var REQUIRES_WEIGHT_AND_DIMS = "requires_weight_and_dims";
var REQUIRES_PICTURE = "requires_picture";
var TBD = "tbd";

var BUYER_CREDIT_PCT_OPTIONS = [{ text: "75%", value: "75.0" }, { text: "50%", value: "50.0" }, { text: "25%", value: "25.0" }];

var DO_NOT_SHIP_REASONS = [REQUIRES_8130_3, REQUIRES_TRACE_DOCUMENTATION, REQUIRES_WEIGHT_AND_DIMS, REQUIRES_PICTURE, TBD];

var REPAIR = "repair";
var OVERHAUL = "overhaul";
var BENCH_TEST = "bench_test";
var PURCHASE_ORDER = "purchase_order";

var CAP_TYPES = (_CAP_TYPES = {}, _defineProperty(_CAP_TYPES, REPAIR, {
  label: "Repair"
}), _defineProperty(_CAP_TYPES, OVERHAUL, {
  label: "Overhaul"
}), _defineProperty(_CAP_TYPES, BENCH_TEST, {
  label: "Bench Test"
}), _CAP_TYPES);

var TOOLS_USED = [{ value: "my_shopping_list", text: "My Shopping List" }, { value: "parts_watch", text: "Parts Watch" }, { value: "dcr", text: "DCR" }, { value: "nplb", text: "NPLB" }, { value: "piss", text: "PISS" }, { value: "other", text: "Other" }];

var CANCELLATION_REASONS = [{
  value: "cancelled_by_vendor_or_previously_sold",
  text: "Cancelled by Vendor or Prev. Sold"
}, { value: "cancelled_by_tenant", text: "Cancelled by Us" }, { value: "part_deemed_ber", text: "Part Deemed B.E.R" }, { value: "unacceptable_documentation", text: "Unacceptable Documentation" }, { value: "vendor_cant_find", text: "Vendor Can't Find" }, { value: "unethical_behavior_detected", text: "Unethical Behavior Detected" }, { value: "unknown", text: "No Explanation/Unknown" }];

var ATTACHMENT_TYPES = {
  customer_purchase_order: {
    label: "Customer Purchase Order"
  },
  vendor_correspondence: {
    label: "Vendor Correspondence"
  },
  traceability: {
    label: "Traceability"
  },
  tag_copies: {
    label: "Tag Copies"
  },
  packing_slip: {
    label: "Packing Slip"
  },
  photos: {
    label: "Photos"
  },
  signed_exchange_agreement: {
    label: "Signed Exchange Agreement"
  },
  external_link: {
    label: "External Link"
  },
  end_user_agreement: {
    label: "End User Agreement"
  }
};

var WARRANTY_PERIOD = {
  thirty_days: {
    label: "30 Days"
  },
  sixty_days: {
    label: "60 Days"
  },
  ninety_days: {
    label: "90 Days"
  },
  one_hundred_twenty_days: {
    label: "120 Days"
  },
  six_months: {
    label: "6 Months"
  },
  one_year: {
    label: "1 Year"
  },
  eighteen_months: {
    label: "18 Months"
  },
  twenty_four_months: {
    label: "24 Months"
  },
  thirty_six_months: {
    label: "36 Months"
  },
  warranty_by_mro: {
    label: "Warranty by MRO"
  },
  no_warranty: {
    label: "No Warranty"
  },
  no_warranty_thirty_day_inspection: {
    label: "No Warranty, 30 Day Inspection"
  }
};

var PURCHASE_ORDER_QUICKBOOKS_TYPES = [{ text: "Bill", value: "bill" }, { text: "Purchase Order", value: "purchase_order" }];

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_currency_formatter__ = __webpack_require__(2720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_currency_formatter__);
/* harmony export (immutable) */ __webpack_exports__["a"] = dollars;
/* harmony export (immutable) */ __webpack_exports__["b"] = calculateCost;


function dollars(decimal) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var displayBlank = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (displayBlank && !decimal) {
    return null;
  }

  var amount = decimal || 0;
  return __WEBPACK_IMPORTED_MODULE_0_currency_formatter___default.a.format(amount, { code: "USD", precision: precision });
}

function calculateCost(qty, costUnit) {
  return dollars(parseFloat(qty) * parseFloat(costUnit)) || "$0.00";
}

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony export (immutable) */ __webpack_exports__["g"] = monthYear;
/* harmony export (immutable) */ __webpack_exports__["h"] = monthFullYear;
/* harmony export (immutable) */ __webpack_exports__["f"] = monthFullYearHyphen;
/* harmony export (immutable) */ __webpack_exports__["i"] = dateFormFormat;
/* harmony export (immutable) */ __webpack_exports__["b"] = shortDate;
/* harmony export (immutable) */ __webpack_exports__["c"] = shortDateYY;
/* harmony export (immutable) */ __webpack_exports__["a"] = shortDateYYandTime;
/* harmony export (immutable) */ __webpack_exports__["j"] = timeStamp;
/* harmony export (immutable) */ __webpack_exports__["e"] = shortDateAndTimestamp;
/* harmony export (immutable) */ __webpack_exports__["d"] = alphaMonthYear;


function monthYear(timestamp) {
  if (!timestamp) return null;
  return timestamp && __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).format("MM/YY");
}

function monthFullYear(timestamp) {
  return timestamp && __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).format("MM/YYYY");
}

function monthFullYearHyphen(timestamp) {
  return timestamp && __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).format("MM-YYYY");
}

function dateFormFormat(timestamp) {
  return timestamp && __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).format("YYYY-MM-DD");
}

function shortDate(timestamp) {
  return timestamp && __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).format("MM/DD/YYYY");
}

function shortDateYY(timestamp) {
  return timestamp && __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).format("MM/DD/YY");
}

function shortDateYYandTime(timestamp) {
  if (!timestamp) return "";
  return timestamp && __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).format("MM/DD/YY h:mm A");
}

function timeStamp(timestamp) {
  return timestamp && __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).format("h:mm A");
}

function shortDateAndTimestamp(timestamp) {
  return timestamp && __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).format("MM/DD/YYYY h:mm A");
}

function alphaMonthYear(timestamp) {
  return timestamp && __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).format("MMMM YYYY");
}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AIRLINE_END_USER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return ASA_APPROVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return BILLING_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CAAC_APPROVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return COMPANY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CUSTOMER_CREDIT_TERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DO_NOT_EXCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return EASA_APPROVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return END_USER_AGREEMENT_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return EXPORT_APPROVAL_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return EXPORT_COMPLIANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return FAA_APPROVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return FAX; });
/* unused harmony export FREIGHT_FORWARDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return IMPERFECT_TRACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IMPERFECT_TRACE_REASON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return INTERNAL_NOTE; });
/* unused harmony export LEASING_COMPANY */
/* unused harmony export OEM */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return RELATED_COMPANY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REPAIR_STATION; });
/* unused harmony export REPAIR_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return WEBSITE; });
/* unused harmony export MRO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return SECOND_QC_EXPORT_COMPLIANCE_REMINDER_SENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return THIRD_QC_EXPORT_COMPLIANCE_REMINDER_SENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return TCCA_APPROVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return UK_CAA_APPROVED; });
/* unused harmony export AFTER_MARKET */
/* unused harmony export DISTRIBUTION */
/* unused harmony export GOVT_MILITARY */
/* unused harmony export OTHER_NA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return OTHER_APPROVED; });
/* unused harmony export PMA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PHYSICAL_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return ULTIMATE_CONSIGNEE_CCS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return ULTIMATE_CONSIGNEE_FORM_BODY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return ULTIMATE_CONSIGNEE_FORM_SUBJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return ULTIMATE_CONSIGNEE_FORM_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return VENDOR_CREDIT_TERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return VENDOR_TRACE_PREAPPROVAL_REQUIRED; });
/* unused harmony export STRICT_TYPES */
/* unused harmony export APPROVAL_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return COMPANY_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CONTACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NO_BIZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return OUT_OF_BIZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return OBSOLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREDIT_HOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return LIABILITIES_OWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return PURCHASES_OWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return LIABILITIES_TO_BE_OWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MANAGER_CONSENT_NEEDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return MANDATORY_ADDITIONAL_VERBIAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return REPAIR_LIABILITIES_OWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return REPAIR_STATION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return VENDOR_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return COMPANY_STATUSES; });
/* unused harmony export PASS */
/* unused harmony export FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return PASS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SALUTATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return NOT_APPROVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return APPROVAL_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return APPROVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CAN_APPROVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DENIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return APPROVAL_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return REPAIR_STATION_APPROVAL_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return NET_30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return NET_60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return NET_45; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return NET_15; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return NET_10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return NET_5; });
/* unused harmony export DUE_UPON_RECEIPT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CREDIT_CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return WIRE_IN_ADVANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CHECK_IN_ADVANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return VENDOR_TERMS; });
/* unused harmony export PO_VENDOR_TERMS */
/* unused harmony export CREDIT_REFERENCES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return ATTACHMENT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return BLANKET_EXCHANGE_AGREEMENT; });
var _APPROVAL_TYPES, _COMPANY_TYPES, _COMPANY_STATUSES, _PASS_FAIL, _APPROVAL_STATUSES, _VENDOR_TERMS, _PO_VENDOR_TERMS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AIRLINE_END_USER = "airline_end_user";
var ASA_APPROVED = "asa_approved";
var BILLING_ADDRESS = "billing_address";
var CAAC_APPROVED = "caac_approved";
var COMPANY_TYPE = "company_type";
var CUSTOMER_CREDIT_TERMS = "customer_credit_terms";
var DER = "der";
var DO_NOT_EXCHANGE = "do_not_exchange";
var EASA_APPROVED = "easa_approved";
var END_USER_AGREEMENT_REQUESTED = "end_user_agreement_requested";
var EXPORT_APPROVAL_REQUIRED = "export_approval_required";
var EXPORT_COMPLIANT = "export_compliant";
var FAA_APPROVED = "faa_approved";
var FAX = "fax";
var FREIGHT_FORWARDER = "freight_forwarder";
var IMPERFECT_TRACE = "imperfect_trace";
var IMPERFECT_TRACE_REASON = "imperfect_trace_reason";
var INTERNAL_NOTE = "internal_note";
var LEASING_COMPANY = "leasing_company";
var OEM = "oem";
var RELATED_COMPANY_ID = "related_company_id";
var REPAIR_STATION = "repair_station";
var REPAIR_STATUS = "repair_status";
var STATUS = "status";
var WEBSITE = "website";
var MRO = "mro";
var SECOND_QC_EXPORT_COMPLIANCE_REMINDER_SENT = "second_qc_export_compliance_reminder_sent";
var THIRD_QC_EXPORT_COMPLIANCE_REMINDER_SENT = "third_qc_export_compliance_reminder_sent";
var TCCA_APPROVED = "tcca_approved";
var UK_CAA_APPROVED = "uk_caa_approved";
var AFTER_MARKET = "after_market";
var DISTRIBUTION = "distribution";
var GOVT_MILITARY = "govt_military";
var OTHER_NA = "other";
var OTHER_APPROVED = "other_approved";
var PMA = "pma";
var PHYSICAL_ADDRESS = "physical_address";
var ULTIMATE_CONSIGNEE_CCS = "ultimate_consignee_ccs";
var ULTIMATE_CONSIGNEE_FORM_BODY = "ultimate_consignee_form_body";
var ULTIMATE_CONSIGNEE_FORM_SUBJECT = "ultimate_consignee_form_subject";
var ULTIMATE_CONSIGNEE_FORM_URL = "ultimate_consignee_form_url";
var VENDOR_CREDIT_TERMS = "vendor_credit_terms";
var VENDOR_TRACE_PREAPPROVAL_REQUIRED = "vendor_trace_preapproval_required";

var STRICT_TYPES = _defineProperty({}, IMPERFECT_TRACE, {
  label: "Imperfect Trace"
});

var APPROVAL_TYPES = (_APPROVAL_TYPES = {}, _defineProperty(_APPROVAL_TYPES, DER, {
  label: "DER"
}), _defineProperty(_APPROVAL_TYPES, PMA, {
  label: "PMA"
}), _APPROVAL_TYPES);

var COMPANY_TYPES = (_COMPANY_TYPES = {}, _defineProperty(_COMPANY_TYPES, AFTER_MARKET, {
  label: "After Market"
}), _defineProperty(_COMPANY_TYPES, AIRLINE_END_USER, {
  label: "Airline/End-User"
}), _defineProperty(_COMPANY_TYPES, DISTRIBUTION, {
  label: "Distribution"
}), _defineProperty(_COMPANY_TYPES, FREIGHT_FORWARDER, {
  label: "Freight Forwarder"
}), _defineProperty(_COMPANY_TYPES, GOVT_MILITARY, {
  label: "Government/Military"
}), _defineProperty(_COMPANY_TYPES, LEASING_COMPANY, {
  label: "Leasing Company"
}), _defineProperty(_COMPANY_TYPES, MRO, {
  label: "MRO"
}), _defineProperty(_COMPANY_TYPES, OEM, {
  label: "OEM"
}), _defineProperty(_COMPANY_TYPES, PMA, {
  label: "PMA"
}), _defineProperty(_COMPANY_TYPES, REPAIR_STATION, {
  label: "Repair Station"
}), _defineProperty(_COMPANY_TYPES, OTHER_NA, {
  label: "Other"
}), _COMPANY_TYPES);

var COMPANY = "company";
var CONTACT = "contact";
var NO_BIZ = "do_not_do_business";
var OUT_OF_BIZ = "out_of_business";
var ACTIVE = "active";
var OBSOLETE = "obsolete";
var CREDIT_HOLD = "credit_hold";
var LIABILITIES_OWED = "liabilities_owed";
var PURCHASES_OWED = "purchases_owed";
var LIABILITIES_TO_BE_OWED = "liabilities_to_be_owed";
var MANAGER_CONSENT_NEEDED = "manager_consent_needed";
var MANDATORY_ADDITIONAL_VERBIAGE = "mandatory_additional_verbiage";
var REPAIR_LIABILITIES_OWED = "repair_liabilities_owed";
var REPAIR_STATION_STATUS = "repair_station_status";
var VENDOR_STATUS = "vendor_status";

var COMPANY_STATUSES = (_COMPANY_STATUSES = {}, _defineProperty(_COMPANY_STATUSES, NO_BIZ, {
  label: "Do Not Do Business"
}), _defineProperty(_COMPANY_STATUSES, OUT_OF_BIZ, {
  label: "Out of Business"
}), _defineProperty(_COMPANY_STATUSES, ACTIVE, {
  label: "Active"
}), _defineProperty(_COMPANY_STATUSES, OBSOLETE, {
  label: "Obsolete"
}), _defineProperty(_COMPANY_STATUSES, CREDIT_HOLD, {
  label: "Credit Hold"
}), _COMPANY_STATUSES);

var PASS = "true";
var FAIL = "false";

var PASS_FAIL = (_PASS_FAIL = {}, _defineProperty(_PASS_FAIL, PASS, {
  label: "PASS"
}), _defineProperty(_PASS_FAIL, FAIL, {
  label: "FAIL"
}), _PASS_FAIL);

var SALUTATIONS = [{ text: "Mr.", value: "Mr." }, { text: "Mrs.", value: "Mrs." }, { text: "Ms.", value: "Ms." }];

var NOT_APPROVED = "not_approved";
var APPROVAL_REQUESTED = "approval_requested";
var PENDING = "pending";
var APPROVED = "approved";
var CAN_APPROVE = "can_approve";
var DENIED = "denied";

var APPROVAL_STATUSES = (_APPROVAL_STATUSES = {}, _defineProperty(_APPROVAL_STATUSES, NOT_APPROVED, {
  label: "Not Approved",
  selectableStatuses: []
}), _defineProperty(_APPROVAL_STATUSES, APPROVAL_REQUESTED, {
  label: "Approval Requested",
  selectableStatuses: [APPROVAL_REQUESTED, PENDING, APPROVED, DENIED],
  selectableRepairStatus: [MANAGER_CONSENT_NEEDED]
}), _defineProperty(_APPROVAL_STATUSES, PENDING, {
  label: "Pending",
  selectableStatuses: [PENDING, APPROVED, DENIED],
  selectableRepairStatus: [MANAGER_CONSENT_NEEDED]
}), _defineProperty(_APPROVAL_STATUSES, APPROVED, {
  label: "Approved",
  selectableStatuses: [APPROVED, DENIED],
  selectableRepairStatus: [MANAGER_CONSENT_NEEDED]
}), _defineProperty(_APPROVAL_STATUSES, DENIED, {
  label: "Denied",
  selectableStatuses: [APPROVED, DENIED],
  selectableRepairStatus: [MANAGER_CONSENT_NEEDED]
}), _APPROVAL_STATUSES);

var REPAIR_STATION_APPROVAL_STATUSES = Object.assign(APPROVAL_STATUSES, _defineProperty({}, MANAGER_CONSENT_NEEDED, {
  label: "Mgmt. Consent Needed",
  selectableStatuses: [APPROVED, DENIED, MANAGER_CONSENT_NEEDED],
  selectableRepairStatus: []
}));

var NET_30 = "net_30";
var NET_60 = "net_60";
var NET_45 = "net_45";
var NET_15 = "net_15";
var NET_10 = "net_10";
var NET_5 = "net_5";
var DUE_UPON_RECEIPT = "due_upon_receipt";
var CREDIT_CARD = "credit_card";
var WIRE_IN_ADVANCE = "wire_in_advance";
var CHECK_IN_ADVANCE = "check_in_advance";

var VENDOR_TERMS = (_VENDOR_TERMS = {}, _defineProperty(_VENDOR_TERMS, NET_60, {
  label: "Net-60"
}), _defineProperty(_VENDOR_TERMS, NET_45, {
  label: "Net-45"
}), _defineProperty(_VENDOR_TERMS, NET_30, {
  label: "Net-30"
}), _defineProperty(_VENDOR_TERMS, NET_15, {
  label: "Net-15"
}), _defineProperty(_VENDOR_TERMS, NET_10, {
  label: "Net-10"
}), _defineProperty(_VENDOR_TERMS, NET_5, {
  label: "Net-5"
}), _defineProperty(_VENDOR_TERMS, DUE_UPON_RECEIPT, {
  label: "Due upon receipt"
}), _defineProperty(_VENDOR_TERMS, CREDIT_CARD, {
  label: "Credit card"
}), _defineProperty(_VENDOR_TERMS, WIRE_IN_ADVANCE, {
  label: "Wire in advance"
}), _defineProperty(_VENDOR_TERMS, CHECK_IN_ADVANCE, {
  label: "Check in advance"
}), _VENDOR_TERMS);

var PO_VENDOR_TERMS = (_PO_VENDOR_TERMS = {}, _defineProperty(_PO_VENDOR_TERMS, NET_30, {
  label: "Net-30"
}), _defineProperty(_PO_VENDOR_TERMS, NET_60, {
  label: "Net-60"
}), _defineProperty(_PO_VENDOR_TERMS, NET_45, {
  label: "Net-45"
}), _defineProperty(_PO_VENDOR_TERMS, NET_15, {
  label: "Net-15"
}), _defineProperty(_PO_VENDOR_TERMS, NET_10, {
  label: "Net-10"
}), _defineProperty(_PO_VENDOR_TERMS, NET_5, {
  label: "Net-5"
}), _defineProperty(_PO_VENDOR_TERMS, DUE_UPON_RECEIPT, {
  label: "Due upon receipt"
}), _defineProperty(_PO_VENDOR_TERMS, CREDIT_CARD, {
  label: "Credit card"
}), _defineProperty(_PO_VENDOR_TERMS, WIRE_IN_ADVANCE, {
  label: "Wire in advance"
}), _defineProperty(_PO_VENDOR_TERMS, CHECK_IN_ADVANCE, {
  label: "Check in advance"
}), _PO_VENDOR_TERMS);
var CREDIT_REFERENCES = "credit_references";

var ATTACHMENT_TYPES = {
  approved_vendors_list: {
    label: "Approved Vendors List"
  },
  blanket_exchange_agreement: {
    label: "Blanket Exchange Agreement"
  },
  business_license: {
    label: "Business License"
  },
  capabilities_list: {
    label: "Capabilities List"
  },
  certificate_of_status_form: {
    label: "Certificate of Status Form (W-8/BEN)"
  },
  certifications: {
    label: "Certifications"
  },
  consolidated_list_view_verification: {
    label: "Consolidated List View Verification"
  },
  signed_consignment_agreement: {
    label: "Consignment Agreement"
  },
  signed_credit_application: {
    label: "Credit Application"
  },
  credit_references: {
    label: "Credit References"
  },
  signed_customer_service_agreement: {
    label: "Customer Service Agreement"
  },
  dispute_correspondences: {
    label: "Dispute Correspondences"
  },
  signed_end_user_agreement: {
    label: "End-User Agreement"
  },
  external_link: {
    label: "External Link"
  },
  financials: {
    label: "Financials"
  },
  identification: {
    label: "Identification (current, gov't issued)"
  },
  kyc_form: {
    label: "Know Your Customer Form"
  },
  resale_certificate: {
    label: "Resale Certificate"
  },
  supplier_evaluation: {
    label: "Supplier Evaluation"
  },
  tax_excemption_certificate: {
    label: "Tax Excemption Certificate"
  },
  tax_identification_form: {
    label: "Tax Identification Form (W-9)"
  },
  trade_partners_shipment_records_search: {
    label: "Trade Partners Shipment Records Search"
  },
  website_address: {
    label: "Website Address"
  },
  wire_detail_information: {
    label: "Wire Detail Information"
  }
};

var BLANKET_EXCHANGE_AGREEMENT = "blanket_exchange_agreement";

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return POUNDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return KILOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return KG_PER_LB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ECCN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SCHEDULE_B_OR_HT_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return HTSUS_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return HTSUS_CODE_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return WEIGHT_OZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return WEIGHT_UNIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return NET_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return NET_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return NET_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return NET_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return NET_WEIGHT_OZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return NET_WEIGHT_UNIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return HIGHER_ASSEMBLY_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return LOWER_ASSEMBLY_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return ENGINE_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return AIRCRAFT_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return APPLICABLE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return AUTO_ADJUST_SRP_EXCLUSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CATALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CATALOG_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CLASSIFIED_MEMO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COUNTRY_OF_MFG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return DOM_LIFE_YEARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return DOM_SENSITIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return ESD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return EAR99; });
/* unused harmony export EXPENDABLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SNCHK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return EUROPEAN_COMMERCE_CONTROL_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return EXPORT_COMPLIANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HAZMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BIO_HAZMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return IMPORTANT_MEMO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return LLP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return MANUFACTURER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return MASTER_PART_LOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return MILITARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return MLP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return NSN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return PART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PART_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return PART_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return PASS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return PERMANENT_EXTERNAL_NOTE_FOR_OQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return PURCHASED_AT; });
/* unused harmony export ROTABLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SELLABLE_QUANTITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return SHELF_LIFE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return SPECIAL_CONTAINER_REQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return SPECIAL_CONTAINER_REQ_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return SPECIAL_CONTAINER_FEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return TIER_TYPE; });
/* unused harmony export TOOLING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return TOOLING_PART_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return TOOLING_PART_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return TOTAL_CYCLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return TOTAL_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return UNITED_NATIONS_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return UPDATED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return WARRANTY_OVERRIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ATL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BTL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BBTL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ZTL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SATL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return NON_QUALIFIER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return TIER_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return TIER_TO_STAR_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APPLICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return EXACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return FULLY_INTERCHANGEABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return REPLACES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return REPLACED_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return MODIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return MODEL_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return OEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return PMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return ANOMALY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return NATIONAL_STOCK_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return UNKNOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return ALTERNATE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return ALTERNATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return ATTACHMENT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return TIER_TYPES_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return REPAIR_QUOTE_WARRANTY_PERIODS; });
var _TIER_TO_STAR_MAP, _APPLICATIONS, _ALTERNATES, _TIER_TYPES_MAP;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var POUNDS = "lb";
var KILOS = "kg";
var KG_PER_LB = 0.453592;

var ECCN = "european_commerce_control_number";
var SCHEDULE_B_OR_HT_CODE = "schedule_b_or_ht_code";
var HTSUS_CODE = "htsus_code";
var HTSUS_CODE_LABEL = "Harmonized Tariff (HT) Code";

var WIDTH = "width";
var HEIGHT = "height";
var LENGTH = "length";
var WEIGHT = "weight";
var WEIGHT_OZ = "weight_oz";
var WEIGHT_UNIT = "weight_unit";

var NET_WIDTH = "net_width";
var NET_HEIGHT = "net_height";
var NET_LENGTH = "net_length";
var NET_WEIGHT = "net_weight";
var NET_WEIGHT_OZ = "net_weight_oz";
var NET_WEIGHT_UNIT = "net_weight_unit";

var HIGHER_ASSEMBLY_APPLICATION = "HigherAssemblyApplication";
var LOWER_ASSEMBLY_APPLICATION = "LowerAssemblyApplication";
var ENGINE_APPLICATION = "EngineApplication";
var AIRCRAFT_APPLICATION = "AircraftApplication";

var APPLICABLE_ID = "applicable_id";
var AUTO_ADJUST_SRP_EXCLUSION = "auto_adjust_srp_exclusion";
var CAGE = "cage";
var CATALOG = "catalog";
var CATALOG_URL = "catalog_url";
var CLASSIFIED_MEMO = "classified_memo";
var COUNTRY_OF_MFG = "country_of_mfg";
var DESCRIPTION = "description";
var DOM = "dom";
var DOM_LIFE_YEARS = "dom_life_years";
var DOM_SENSITIVE = "dom_sensitive";
var ESD = "esd";
var EAR99 = "EAR99";
var EXPENDABLE = "expendable";
var SNCHK = "SNCHK";
var EUROPEAN_COMMERCE_CONTROL_NUMBER = "european_commerce_control_number";
var EXPORT_COMPLIANCE = "export_compliance";
var HAZMAT = "hazmat";
var BIO_HAZMAT = "bio_hazmat";
var IMPORTANT_MEMO = "important_memo";
var LLP = "llp";
var MANUFACTURER = "manufacturer";
var MASTER_PART_LOCK = "master_part_lock";
var MILITARY = "military";
var MLP = "manufacturer_list_price";
var NSN = "national_stock_number";
var PART = "part";
var PART_NUMBER = "part_number";
var PART_DESCRIPTION = "part_description";
var PASS_FAIL = "pass_fail";
var PERMANENT_EXTERNAL_NOTE_FOR_OQ = "outgoing_quote_external_note";
var PURCHASED_AT = "purchased_at";
var ROTABLE = "rotable";
var SELLABLE_QUANTITIES = "sellable_quantities";
var SHELF_LIFE = "shelf_life";
var SPECIAL_CONTAINER_REQ = "special_container_req";
var SPECIAL_CONTAINER_REQ_LABEL = "Special Container Required";
var SPECIAL_CONTAINER_FEE = "special_container_fee";
var TIER_TYPE = "tier_type";
var TOOLING = "tooling";
var TOOLING_PART_TYPE = "tooling_part_type";

var TOOLING_PART_TYPES = [ROTABLE, EXPENDABLE, TOOLING];
var TOTAL_CYCLES = "total_cycles";
var TOTAL_HOURS = "total_hours";
var UNITED_NATIONS_CODE = "united_nations_code";
var UPDATED_AT = "updated_at";
var WARRANTY_OVERRIDE = "warranty_override";

var ATL = "ATL";
var BTL = "BTL";
var BBTL = "BBTL";
var ZTL = "ZTL";
var SATL = "SATL";
var NON_QUALIFIER = "NON_QUALIFIER";

var TIER_TYPES = [SATL, ATL, BTL, BBTL, ZTL, NON_QUALIFIER];

var TIER_TO_STAR_MAP = (_TIER_TO_STAR_MAP = {}, _defineProperty(_TIER_TO_STAR_MAP, SATL, "5_star"), _defineProperty(_TIER_TO_STAR_MAP, ATL, "4_star"), _defineProperty(_TIER_TO_STAR_MAP, BTL, "3_star"), _defineProperty(_TIER_TO_STAR_MAP, BBTL, "2_star"), _defineProperty(_TIER_TO_STAR_MAP, ZTL, "1_star"), _defineProperty(_TIER_TO_STAR_MAP, NON_QUALIFIER, NON_QUALIFIER.toLowerCase()), _TIER_TO_STAR_MAP);

var APPLICATIONS = (_APPLICATIONS = {}, _defineProperty(_APPLICATIONS, HIGHER_ASSEMBLY_APPLICATION, {
  label: "Higher Assembly",
  applicationResourceName: "higher_assembly_applications",
  applicableResourceName: "parts",
  formResourceName: "higher_assembly_application",
  searchFilterParam: "part_number"
}), _defineProperty(_APPLICATIONS, LOWER_ASSEMBLY_APPLICATION, {
  label: "Lower Assembly",
  applicationResourceName: "lower_assembly_applications",
  applicableResourceName: "parts",
  formResourceName: "lower_assembly_application",
  searchFilterParam: "part_number"
}), _defineProperty(_APPLICATIONS, ENGINE_APPLICATION, {
  label: "Engine/APU",
  applicationResourceName: "engine_applications",
  applicableResourceName: "engines",
  formResourceName: "engine_application",
  searchFilterParam: "filter"
}), _defineProperty(_APPLICATIONS, AIRCRAFT_APPLICATION, {
  label: "Aircraft",
  applicationResourceName: "aircraft_applications",
  applicableResourceName: "aircraft",
  formResourceName: "aircraft_application",
  searchFilterParam: "filter"
}), _APPLICATIONS);

var EXACT = "exact";
var FULLY_INTERCHANGEABLE = "fully_interchangeable";
var REPLACES = "replaces";
var REPLACED_BY = "replaced_by";
var MODIFICATION = "modification";
var MODEL_NUMBER = "model_number";
var OEM = "oem";
var PMA = "pma";
var ANOMALY = "anomaly";
var NATIONAL_STOCK_NUMBER = "national_stock_number";
var UNKNOWN = "unknown";

var ALTERNATE_TYPES = [EXACT, FULLY_INTERCHANGEABLE, OEM, REPLACES, REPLACED_BY, MODIFICATION, MODEL_NUMBER, PMA, ANOMALY, UNKNOWN];

var ALTERNATES = (_ALTERNATES = {}, _defineProperty(_ALTERNATES, EXACT, {
  label: "Exact"
}), _defineProperty(_ALTERNATES, FULLY_INTERCHANGEABLE, {
  label: "Fully Interchangeable"
}), _defineProperty(_ALTERNATES, REPLACES, {
  label: "Replaces"
}), _defineProperty(_ALTERNATES, REPLACED_BY, {
  label: "Replaced By"
}), _defineProperty(_ALTERNATES, MODIFICATION, {
  label: "Modification"
}), _defineProperty(_ALTERNATES, MODEL_NUMBER, {
  label: "Model No."
}), _defineProperty(_ALTERNATES, OEM, {
  label: "OEM"
}), _defineProperty(_ALTERNATES, PMA, {
  label: "PMA"
}), _defineProperty(_ALTERNATES, ANOMALY, {
  label: "Anomaly"
}), _defineProperty(_ALTERNATES, NATIONAL_STOCK_NUMBER, {
  label: "National Stock Number"
}), _defineProperty(_ALTERNATES, UNKNOWN, {
  label: "Unknown"
}), _ALTERNATES);

var ATTACHMENT_TYPES = {
  airline_requirements: {
    label: "Airline Requirements"
  },
  mod_sheets: {
    label: "Mod Sheets"
  },
  cmm_ipc: {
    label: "CMM / IPC"
  },
  ads_sbs: {
    label: "AD's / SB's"
  },
  interchangeability_ref: {
    label: "Interchangeability Ref."
  },
  msds: {
    label: "MSDS"
  },
  sales_brochure: {
    label: "Sales Literature / OEM Brochure"
  },
  stock_photo: {
    label: "Stock Photo (can be used for advertisements, etc.)"
  },
  external_link: {
    label: "External Link"
  }
};

var TIER_TYPES_MAP = (_TIER_TYPES_MAP = {}, _defineProperty(_TIER_TYPES_MAP, SATL, "5-Star"), _defineProperty(_TIER_TYPES_MAP, ATL, "4-Star"), _defineProperty(_TIER_TYPES_MAP, BTL, "3-Star"), _defineProperty(_TIER_TYPES_MAP, BBTL, "2-Star"), _defineProperty(_TIER_TYPES_MAP, ZTL, "1-Star"), _TIER_TYPES_MAP);

var REPAIR_QUOTE_WARRANTY_PERIODS = {
  thirty_days: {
    label: "30 Days"
  },
  sixty_days: {
    label: "60 Days"
  },
  ninety_days: {
    label: "90 Days"
  },
  one_hundred_twenty_days: {
    label: "120 Days"
  },
  six_months: {
    label: "6 Months"
  },
  one_year: {
    label: "1 Year"
  },
  eighteen_months: {
    label: "18 Months"
  },
  twenty_four_months: {
    label: "24 Months"
  },
  thirty_six_months: {
    label: "36 Months"
  },
  no_warranty: {
    label: "No Warranty"
  }
};

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validation__ = __webpack_require__(630);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__validation__["a"]; });
/* unused harmony reexport defineValidator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__asyncValidation__ = __webpack_require__(1233);
/* unused harmony reexport asyncValidator */





/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_email_validator__ = __webpack_require__(2745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_email_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_email_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatters_text__ = __webpack_require__(11);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return required; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return requiredUnlessUploaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return requiredAllowZero; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return matches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isValidEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isNumeric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isBool; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return mustBeOne; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return isInteger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return lengthIsEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isGreaterThanOrEqualTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isLessThanOrEqualTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return maxLengthOfText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return isLessThan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isGreaterThan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isBetween; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return matchesPattern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return requiredIfAnyDefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return requiredIfFieldGreaterThan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return requiresAtLeast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return customerRmaRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return validateCompanyStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return includesField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return passFailValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return shipToCompanyIsNoBiz; });





var required = function required(val) {
  return !val && "Required" || undefined;
};

var requiredUnlessUploaded = function requiredUnlessUploaded(val, values) {
  return !values.uploaded && !val && "required" || undefined;
};

var requiredAllowZero = function requiredAllowZero(val) {
  return !val && val !== 0 && "Required" || undefined;
};

var matches = function matches(field) {
  return function (val, values) {
    if (val !== values[field]) {
      return "Does not match";
    }

    return undefined;
  };
};

var isValidEmail = function isValidEmail(val) {
  if (val && val.split(",").some(function (e) {
    return !__WEBPACK_IMPORTED_MODULE_0_email_validator___default.a.validate(e.trim());
  })) {
    return "Invalid email address";
  }

  return undefined;
};

var isNumeric = function isNumeric(val) {
  if (val && isNaN(val)) {
    return "Please enter a number";
  }

  return undefined;
};

var isBool = function isBool(val) {
  if (![false, true, "false", "true"].includes(val)) {
    return "Required";
  }

  return undefined;
};

var mustBeOne = function mustBeOne(val) {
  if (Number(val) === 1) {
    return undefined;
  }

  return "Must equal 1";
};

var isInteger = function isInteger(val) {
  if (val && !/^\d+$/.test(val)) {
    return "Please enter an integer";
  }

  return undefined;
};

var lengthIsEqual = function lengthIsEqual(gteVal) {
  return function (val) {
    if (val && gteVal !== val.length) {
      return "Character length must equal " + gteVal;
    }

    return undefined;
  };
};

var isGreaterThanOrEqualTo = function isGreaterThanOrEqualTo(gteVal) {
  return function (val) {
    if (val && parseFloat(val) < gteVal) {
      return "Please enter a number greater than or equal to " + gteVal;
    }

    return undefined;
  };
};

var isLessThanOrEqualTo = function isLessThanOrEqualTo(lteVal) {
  return function (val) {
    if (val && parseFloat(val) > lteVal) {
      return "Please enter a number less than or equal to " + lteVal;
    }

    return undefined;
  };
};

var maxLengthOfText = function maxLengthOfText(mVal) {
  return function (val) {
    if (val && val.length > mVal) {
      return "Max length is " + mVal;
    }

    return undefined;
  };
};

var isLessThan = function isLessThan(lessThanVal) {
  return function (val) {
    if (val && parseFloat(val) >= lessThanVal) {
      return "Please enter a number less than " + lessThanVal;
    }

    return undefined;
  };
};

var isGreaterThan = function isGreaterThan(greaterThanVal) {
  return function (val) {
    if (val && parseFloat(val) <= greaterThanVal) {
      return "Please enter a number greater than " + greaterThanVal;
    }

    return undefined;
  };
};

var isBetween = function isBetween(min, max) {
  return function (val) {
    if (val && (parseFloat(val) < min || parseFloat(val) > max)) {
      return "Please enter a number between " + min + " and " + max;
    }

    return undefined;
  };
};

var matchesPattern = function matchesPattern(regex) {
  return function (val) {
    if (val && !regex.test(val)) {
      return "is invalid";
    }

    return undefined;
  };
};

var requiredIfAnyDefined = function requiredIfAnyDefined() {
  for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
    fields[_key] = arguments[_key];
  }

  return function (val, values) {
    if (!val && fields.some(function (f) {
      return values[f];
    })) {
      return "Required";
    }

    return undefined;
  };
};

var requiredIfFieldGreaterThan = function requiredIfFieldGreaterThan(field, value) {
  return function (val, values) {
    if (!val && values[field] && values[field] > value) {
      return "Required when " + field + " is greater than " + value;
    }

    return undefined;
  };
};

var requiresAtLeast = function requiresAtLeast() {
  for (var _len2 = arguments.length, fields = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    fields[_key2 - 1] = arguments[_key2];
  }

  var atLeast = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return function (val, values) {
    if (!(fields.filter(function (f) {
      return !(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(values[f]) && values[f] !== true);
    }).length >= atLeast)) {
      return "Requires at least " + atLeast + " field of " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatters_text__["b" /* toSentence */])(fields.map(function (f) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatters_text__["c" /* properCase */])(f);
      }), "or");
    }

    return undefined;
  };
};

var customerRmaRequest = function customerRmaRequest() {
  for (var _len3 = arguments.length, fields = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    fields[_key3 - 1] = arguments[_key3];
  }

  var atLeast = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return function (val, values) {
    if (!(fields.filter(function (f) {
      return !(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(values[f]) && values[f] !== true);
    }).length >= atLeast)) {
      return "When Customer requests an RMA, at least " + atLeast + " of the following fields must be selected: " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatters_text__["b" /* toSentence */])(fields.map(function (f) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatters_text__["c" /* properCase */])(f);
      }), "or");
    }

    return undefined;
  };
};

var validateCompanyStatus = function validateCompanyStatus(company) {
  if (company && company.status === __WEBPACK_IMPORTED_MODULE_1__modules_companies_constants__["b" /* NO_BIZ */]) return "Invalid Company";
  return undefined;
};

var includesField = function includesField(validValues) {
  return function (val) {
    if (!validValues.includes(val)) {
      return "Must have one of " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatters_text__["b" /* toSentence */])(validValues.map(function (f) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatters_text__["c" /* properCase */])(f);
      }), "or");
    }

    return undefined;
  };
};

var passFailValidation = function passFailValidation(val) {
  if (val && Number(val) > 0) {
    return "not allowed on pass / fail part";
  }

  return undefined;
};

var shipToCompanyIsNoBiz = function shipToCompanyIsNoBiz(val) {
  if (val) return "Company is flagged as 'Do Not Do Business'.";

  return undefined;
};

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decorators_translateProps__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decorators_translateProps__["a" /* default */])(function () {
  return {
    className: "row-col-gutters-half"
  };
})(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Row */]));

/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return AFTER_INTERNAL_OUTRIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return ASKING_INTERNAL_OUTRIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return ASKING_EXPECTED_COMPONENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return OVERHAULED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return REPAIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return INSPECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NEW_ITEM; });
/* unused harmony export AS_REMOVED */
/* unused harmony export BEYOND_REPAIR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CORE_RETURN_FEE_SAVINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return ESTIMATED_LEAD_TIME; });
/* unused harmony export EXPECTED_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return LABOR_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return OUTSIDE_LABOR_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return PART_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PARTIAL_CREDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PARTIAL_CREDIT_AMOUNT; });
/* unused harmony export PARTS_UNIT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return REMOVE_EXPECTED_COMPONENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return REMAINING_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return REPAIR_AND_HOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return REPAIR_AND_HOLD_LEAD_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RMA_REQUEST_TYPE; });
/* unused harmony export SCRAP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return SHOP_ASSIST_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return TRANSFER_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CLOSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CORE_RETURN_DATE; });
/* unused harmony export CORE_RETURN_RECEIVED_DATE_LABEL */
/* unused harmony export CORE_RETURN_DUE_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CORE_REPAIR_INVOICES_PAID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_DUE_DAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CORE_EXPECTED_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return DATE_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return EVAL_DUE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PURCHASE_FOR_EXCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return INCOMING_AWB_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MOD_TO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MOD_TO_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return OPENED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return REQUESTED; });
/* unused harmony export REPAIR_LINE_ITEMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return ACTION_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return APPROVAL_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CORE_REPAIR_HOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return EVAL_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return EXCHANGE_GONE_OUTRIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return EVALUATION_CHARGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return EXPECTED_SERIAL_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return FINAL_EVALUATION_APPROVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return INTERNAL_OUTRIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return NOT_TO_EXCEED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return ORIGINAL_EVALUATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return BENCH_TEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return EXPECTED_COMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EXCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return OVERHAUL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return RECOVERED_REPAIR_FROM_INTERNAL_OUTRIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return REPAIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return RETURNED_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SHOP_ASSIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TEARDOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return WARRANTY_CONSIDERATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return ACTIONS_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return AWAITING_TO_SHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return NO_WORK_PERFORMED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REPAIR_EVALUATION_APPROVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return REPAIR_AWAITING_EVALUATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return REPAIR_EVALUATION_REJECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return WORKING_TO_SAVE_UNIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return REPAIR_EVALUATION_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return UNIT_RETURNED_TO_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return APPROVAL_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return EVAL_STATUS_BADGE_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return APPROVED; });
/* unused harmony export PENDING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return DENIED; });
/* unused harmony export APPROVAL_OPTIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return APPROVE_OR_DENY_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return REPAIR_STATION_WARRANTY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return WARRANTY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ATTACHMENT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return AMOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return NONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return PERCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return INSURANCE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return REASONS_FOR_RETURN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return getConditionLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getConditionAbbrev; });
var _condition, _ACTIONS_REQUESTED, _APPROVAL_STATUSES, _EVAL_STATUS_BADGE_CO, _APPROVAL_OPTIONS, _INSURANCE_TYPES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var AFTER_INTERNAL_OUTRIGHT = "after_internal_outright";
var ASKING_INTERNAL_OUTRIGHT = "asking_internal_outright";
var ASKING_EXPECTED_COMPONENTS = "asking_expected_components";
var OVERHAULED = "overhauled";
var REPAIRED = "repaired";
var INSPECTED = "inspected";
var NEW_ITEM = "new_item";
var AS_REMOVED = "as_removed";
var BEYOND_REPAIR = "beyond_econ_repair";
var CORE_RETURN_FEE_SAVINGS = "core_return_fee_savings";
var ESTIMATED_LEAD_TIME = "estimated_lead_time";
var EXPECTED_DATE = "expected_date";
var LABOR_COST = "labor_cost";
var OUTSIDE_LABOR_COST = "outside_labor_cost";
var PART_COST = "part_cost";
var PARTIAL_CREDIT = "partial_credit";
var PARTIAL_CREDIT_AMOUNT = "partial_credit_amount";
var PARTS_UNIT = "parts_unit";
var REMOVE_EXPECTED_COMPONENTS = "remove_expected_components";
var REMAINING_COST = "remaining_cost";
var REPAIR_AND_HOLD = "repair_and_hold";
var REPAIR_AND_HOLD_LEAD_TIME = "repair_and_hold_lead_time";
var RMA_REQUEST_TYPE = "rma_request_type";
var SCRAP = "scrap";
var SHOP_ASSIST_COST = "shop_assist_cost";
var TRANSFER_COST = "transfer_cost";

var CANCELLED = "cancelled";
var CLOSED = "closed";
var CORE_RETURN_DATE = "core_return_date";
var CORE_RETURN_RECEIVED_DATE_LABEL = "core_return_received_date";
var CORE_RETURN_DUE_DATE = "core_return_due_date";
var CORE_REPAIR_INVOICES_PAID = "core_repair_invoices_paid";
var CORE_DUE_DAYS = "core_due_days";
var CORE_EXPECTED_DATE = "core_expected_date";
var DATE_RECEIVED = "date_received";
var EVAL_DUE_DATE = "eval_due_date";
var PURCHASE_FOR_EXCHANGE = "purchase_for_exchange";
var INCOMING_AWB_NUMBER = "incoming_awb_number";
var MOD_TO = "mod_to";
var MOD_TO_ID = "mod_to_id";
var OPENED = "opened";
var REQUESTED = "requested";

var REPAIR_LINE_ITEMS = {
  condition: (_condition = {}, _defineProperty(_condition, OVERHAULED, {
    abbrev: "OH",
    label: "Overhauled"
  }), _defineProperty(_condition, REPAIRED, {
    abbrev: "SV",
    label: "Repaired"
  }), _defineProperty(_condition, INSPECTED, {
    abbrev: "BT",
    label: "Inspected"
  }), _defineProperty(_condition, NEW_ITEM, {
    abbrev: "NE",
    label: "New"
  }), _defineProperty(_condition, AS_REMOVED, {
    abbrev: "AR",
    label: "As Removed"
  }), _defineProperty(_condition, BEYOND_REPAIR, {
    abbrev: "BR",
    label: "Beyond Repair"
  }), _defineProperty(_condition, PARTS_UNIT, {
    abbrev: "PU",
    label: "Parts Unit"
  }), _defineProperty(_condition, SCRAP, {
    abbrev: "SC",
    label: "Scrap"
  }), _defineProperty(_condition, __WEBPACK_IMPORTED_MODULE_1__IncomingQuotes_constants__["a" /* SERVICEABLE_TOOLING */], {
    abbrev: "SV",
    label: "Serviceable Tooling"
  }), _condition)
};

var ACTION_REQUESTED = "action_requested";
var APPROVAL_STATUS = "approval_status";
var CORE_REPAIR_HOLD = "core_repair_hold";
var EVAL_STATUS = "eval_status";
var EXCHANGE_GONE_OUTRIGHT = "exchange_gone_outright";
var EVALUATION_CHARGE = "evaluation_charge";
var EXPECTED_SERIAL_NUMBER = "expected_serial_number";
var FINAL_EVALUATION_APPROVED = "final_evaluation_approved";
var INTERNAL_OUTRIGHT = "internal_outright";
var NOT_TO_EXCEED = "not_to_exceed";
var ORIGINAL_EVALUATION = "original_evaluation";
var BENCH_TEST = "bench_test";
var EXPECTED_COMPONENT = "expected_component";
var EXCHANGE = "exchange";
var OVERHAUL = "overhaul";
var RECOVERED_REPAIR_FROM_INTERNAL_OUTRIGHT = "recovered_repair_from_internal_outright";
var REPAIR = "repair";
var RETURNED_DATE = "returned_date";
var SHOP_ASSIST = "shop_assist";
var TEARDOWN = "teardown";
var WARRANTY_CONSIDERATION = "warranty_consideration";

var ACTIONS_REQUESTED = (_ACTIONS_REQUESTED = {}, _defineProperty(_ACTIONS_REQUESTED, BENCH_TEST, {
  label: "Bench Test",
  abbrev: "BT"
}), _defineProperty(_ACTIONS_REQUESTED, REPAIR, {
  label: "Repair",
  abbrev: "SV"
}), _defineProperty(_ACTIONS_REQUESTED, OVERHAUL, {
  label: "Overhaul",
  abbrev: "OH"
}), _defineProperty(_ACTIONS_REQUESTED, WARRANTY_CONSIDERATION, {
  label: "Warranty Consideration",
  abbrev: "WC"
}), _defineProperty(_ACTIONS_REQUESTED, SHOP_ASSIST, {
  label: "Shop Assist",
  abbrev: "SA"
}), _defineProperty(_ACTIONS_REQUESTED, TEARDOWN, {
  label: "Teardown",
  abbrev: "TD"
}), _defineProperty(_ACTIONS_REQUESTED, EXPECTED_COMPONENT, {
  label: "Expected Sub-Component",
  abbrev: "EC"
}), _ACTIONS_REQUESTED);

var AWAITING_TO_SHIP = "awaiting_to_ship";
var NO_WORK_PERFORMED = "no_work_performed";
var REPAIR_EVALUATION_APPROVED = "repair_evaluation_approved";
var REPAIR_AWAITING_EVALUATION = "repair_awaiting_evaluation";
var REPAIR_EVALUATION_REJECTED = "repair_evaluation_rejected";
var WORKING_TO_SAVE_UNIT = "working_to_save_unit";
var REPAIR_EVALUATION_RECEIVED = "repair_evaluation_received";
var UNIT_RETURNED_TO_CUSTOMER = "unit_returned_to_customer";

var APPROVAL_STATUSES = (_APPROVAL_STATUSES = {}, _defineProperty(_APPROVAL_STATUSES, AWAITING_TO_SHIP, {
  label: "Awaiting To Ship"
}), _defineProperty(_APPROVAL_STATUSES, REPAIR_AWAITING_EVALUATION, {
  label: "Awaiting Eval."
}), _defineProperty(_APPROVAL_STATUSES, REPAIR_EVALUATION_RECEIVED, {
  label: "Eval. Received"
}), _defineProperty(_APPROVAL_STATUSES, REPAIR_EVALUATION_APPROVED, {
  label: "Eval. Approved"
}), _defineProperty(_APPROVAL_STATUSES, REPAIR_EVALUATION_REJECTED, {
  label: "Eval. Rejected"
}), _defineProperty(_APPROVAL_STATUSES, NO_WORK_PERFORMED, {
  label: "No Work Performed"
}), _defineProperty(_APPROVAL_STATUSES, WORKING_TO_SAVE_UNIT, {
  label: "Working to Save Unit"
}), _defineProperty(_APPROVAL_STATUSES, UNIT_RETURNED_TO_CUSTOMER, {
  label: "Unit Returned To Customer"
}), _APPROVAL_STATUSES);

var EVAL_STATUS_BADGE_CONTENT = (_EVAL_STATUS_BADGE_CO = {}, _defineProperty(_EVAL_STATUS_BADGE_CO, AWAITING_TO_SHIP, {
  icon: "fa fa-fw fa-truck",
  text: "text-warning",
  label: "Awaiting To Ship",
  abbrev: "Aw To Ship"
}), _defineProperty(_EVAL_STATUS_BADGE_CO, NO_WORK_PERFORMED, {
  icon: "fa fa-fw fa-minus-square",
  text: "text-warning",
  label: "No Work Performed",
  abbrev: "No Work"
}), _defineProperty(_EVAL_STATUS_BADGE_CO, REPAIR_EVALUATION_APPROVED, {
  icon: "fa fa-fw fa-check",
  text: "text-success",
  label: "Eval. Approved",
  abbrev: "Eval Appr"
}), _defineProperty(_EVAL_STATUS_BADGE_CO, REPAIR_AWAITING_EVALUATION, {
  icon: "fa fa-fw fa-clock-o",
  text: "text-warning",
  label: "Awaiting Eval.",
  abbrev: "Aw Eval"
}), _defineProperty(_EVAL_STATUS_BADGE_CO, WORKING_TO_SAVE_UNIT, {
  icon: "fa fa-fw fa-clock-o",
  text: "text-warning",
  label: "Working to Save Unit",
  abbrev: "WTSU"
}), _defineProperty(_EVAL_STATUS_BADGE_CO, REPAIR_EVALUATION_RECEIVED, {
  icon: "fa fa-fw fa-clock-o",
  text: "text-warning",
  label: "Eval. Received",
  abbrev: "Eval Rec"
}), _defineProperty(_EVAL_STATUS_BADGE_CO, REPAIR_EVALUATION_REJECTED, {
  icon: "fa fa-fw fa-warning",
  text: "text-danger",
  label: "Eval. Rejected",
  abbrev: "Eval Rej"
}), _defineProperty(_EVAL_STATUS_BADGE_CO, UNIT_RETURNED_TO_CUSTOMER, {
  icon: "fa fa-fw fa-undo",
  text: "text-warning",
  label: "Returned To Customer",
  abbrev: "Returned To Cus"
}), _EVAL_STATUS_BADGE_CO);

var APPROVED = "approved";
var PENDING = "pending";
var DENIED = "denied";

var APPROVAL_OPTIONS = (_APPROVAL_OPTIONS = {}, _defineProperty(_APPROVAL_OPTIONS, APPROVED, {
  label: "Approved"
}), _defineProperty(_APPROVAL_OPTIONS, PENDING, {
  label: "Pending"
}), _defineProperty(_APPROVAL_OPTIONS, DENIED, {
  label: "Denied"
}), _APPROVAL_OPTIONS);

var APPROVE_OR_DENY_OPTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_removeKey__["a" /* default */])(APPROVAL_OPTIONS, PENDING);
var REPAIR_STATION_WARRANTY_STATUS = "repair_station_warranty_status";
var WARRANTY_STATUS = "warranty_status";

var ATTACHMENT_TYPES = {
  approved_original_evaluation: {
    label: "Approved Original Evaluation"
  },
  denied_original_evaluation: {
    label: "Denied Original Evaluation"
  },
  repair_evaluation: {
    label: "Repair Evaluation"
  },
  photos_from_repair_station: {
    label: "Photos - From Repair Station"
  },
  external_link: {
    label: "External Link"
  },
  original_evaluation: {
    label: "Original Evaluation"
  },
  repair_station_correspondence: {
    label: "Repair Station Correspondence"
  },
  other: {
    label: "Other"
  }
};

var AMOUNT = "Amount";
var NONE = "None";
var PERCENT = "Percent";

var INSURANCE_TYPES = (_INSURANCE_TYPES = {}, _defineProperty(_INSURANCE_TYPES, AMOUNT, {
  key: "amount_insured"
}), _defineProperty(_INSURANCE_TYPES, NONE, {
  value: "Do Not Insure"
}), _defineProperty(_INSURANCE_TYPES, PERCENT, {
  key: "percent_insured"
}), _INSURANCE_TYPES);

var REASONS_FOR_RETURN = [{
  value: "failed_test_or_install",
  text: "Unit failed at test or install"
}, {
  value: "no_longer_required",
  text: "Unit no longer required"
}, {
  value: "wrong_unit_ordered",
  text: "Wrong unit ordered"
}, {
  value: "failed_inspection",
  text: "Unit failed incoming inspection"
}, {
  value: "condition_rejection",
  text: "Unit is rejected due to condition but will be accepted back without sending to shop"
}, {
  value: "other",
  text: "Other"
}];

var getConditionLabel = function getConditionLabel(condition) {
  if (!condition) return null;
  return REPAIR_LINE_ITEMS.condition[condition].label;
};

var getConditionAbbrev = function getConditionAbbrev(condition) {
  if (!condition) return null;
  return REPAIR_LINE_ITEMS.condition[condition].abbrev;
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(3039);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(3038);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(585);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(585);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ACCOUNTING_HOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return AFTER_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ATTACH_CERTIFICATE_OF_CONFORMANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ATTACH_PACKING_SLIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return BROKERED_EXCHANGE; });
/* unused harmony export DENIED_PARTY_HOLD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISCREET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return EXPORT_COMPLIANCE_HOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return INVOICE_PAID_DATE; });
/* unused harmony export CORE_REPAIR_CHARGES_INVOICED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CORE_REPAIR_INVOICE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CORE_REPAIR_INVOICE_PAID; });
/* unused harmony export CORE_REPAIR_INVOICE_DUE_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CORE_REPAIR_INVOICE_AMOUNT_PAID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CONTINGENT_ON_PASSING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CREDIT_EXCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CREDIT_TERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CUMULATIVE_COST_PER_UNIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CUSTOMER_DISPLAYED_SUBTOTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CUSTOMER_TO_PROVIDE_OWN_PAPERWORK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PICTURES_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CONDITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return DOLLARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return EXCHANGE_AGREEMENT_HOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return EXCHANGE_EVAL_IN_PROGRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return EXCHANGE_SPECIAL_INSTRUCTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return EXCHANGE_SALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return EXCHANGE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return EXPECTED_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FLAT_EXCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FLAT_EXCHANGE_FEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return LABOR_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return OUTRIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return OUTRIGHT_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return OUTSIDE_LABOR_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return PAID_IN_FULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return PERCENTAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PART_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CUSTOMER_QC_PREAPPROVAL_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REASON; });
/* unused harmony export REASON_FOR_HOLD */
/* unused harmony export REASON_FOR_RELEASE */
/* unused harmony export RELEASE_FOR_SHIPMENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return RELEASED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return RELEASE_FOR_SHIPMENT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return REPAIR_FEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return REPAIR_ADMIN_CHARGE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return REPAIR_ADMINISTRATION_CHARGE_DOLLARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return REPAIR_ADMINISTRATION_CHARGE_PERCENTAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return REPAIR_ADMINISTRATION_FEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return SALES_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SECOND_SELLER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SELLER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return SEND_CANCELLATION_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SEND_SALES_ORDER_ACKNOWLEDGEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SHIP_TO_COMPANY_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SHIPPED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SEND_SALES_ORDER_ACKNOWLEDGEMENT_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SPECIAL_INSTRUCTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return condition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CANCELLATION_REASONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ATTACHMENT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return NOT_EXCHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SECOND_EXCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return THIRD_EXCHANGE; });
/* unused harmony export EXCHANGE_PERCENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return THIRD_EXCHANGE_PERCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return EXCHANGE_CONFIG; });
var _EXCHANGE_CONFIG;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var ACCOUNTING_HOLD = "accounting_hold";
var AFTER_HOURS = "after_hours";
var ATTACH_CERTIFICATE_OF_CONFORMANCE = "attach_certificate_of_conformance";
var ATTACH_PACKING_SLIP = "attach_packing_slip";
var BROKERED_EXCHANGE = "brokered_exchange";
var DENIED_PARTY_HOLD = "denied_party_hold";
var DISCREET = "discreet";
var EXPORT_COMPLIANCE_HOLD = "export_compliance_hold";
var INVOICE_PAID_DATE = "invoice_paid_date";
var CORE_REPAIR_CHARGES_INVOICED = "core_repair_charges_invoiced";
var CORE_REPAIR_INVOICE_NUMBER = "core_repair_invoice_number";
var CORE_REPAIR_INVOICE_PAID = "core_repair_invoice_paid";
var CORE_REPAIR_INVOICE_DUE_DATE = "core_repair_invoice_due_date";
var CORE_REPAIR_INVOICE_AMOUNT_PAID = "core_repair_invoice_amount_paid";
var CONTINGENT_ON_PASSING = "contingent_on_passing";
var CREDIT_EXCHANGE = "credit_exchange";
var CREDIT_TERMS = "credit_terms";
var CUMULATIVE_COST_PER_UNIT = "cumulative_cost_per_unit";
var CUSTOMER_DISPLAYED_SUBTOTAL = "customer_displayed_subtotal";
var CUSTOMER_TO_PROVIDE_OWN_PAPERWORK = "customer_to_provide_own_paperwork";
var PICTURES_REQUIRED = "pictures_required";
var CONDITIONS = __WEBPACK_IMPORTED_MODULE_0__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].condition;
var DOLLARS = "dollars";
var EXCHANGE_AGREEMENT_HOLD = "exchange_agreement_hold";
var EXCHANGE_EVAL_IN_PROGRESS = "exchange_eval_in_progress";
var EXCHANGE_SPECIAL_INSTRUCTIONS = "exchange_special_instructions";
var EXCHANGE_SALE = "exchange_sale";
var EXCHANGE_TYPE = "exchange_type";
var EXPECTED_DATE = "expected_date";
var FLAT_EXCHANGE = "flat_exchange";
var FLAT_EXCHANGE_FEE = "flat_exchange_fee";
var LABOR_COST = "labor_cost";
var OUTRIGHT = "outright";
var OUTRIGHT_VALUE = "outright_value";
var OUTSIDE_LABOR_COST = "outside_labor_cost";
var PAID_IN_FULL = "paid_in_full";
var PERCENTAGE = "percentage";
var PART_COST = "part_cost";
var CUSTOMER_QC_PREAPPROVAL_REQUIRED = "customer_qc_preapproval_required";
var REASON = "reason";
var REASON_FOR_HOLD = "reason_for_hold";
var REASON_FOR_RELEASE = "reason_for_release";
var RELEASE_FOR_SHIPMENT = "release_for_shipment";
var RELEASED = "released";
var RELEASE_FOR_SHIPMENT_DETAILS = "release_for_shipment_details";
var REPAIR_FEE = "repair_fee";
var REPAIR_ADMIN_CHARGE_TYPE = "repair_admin_charge_type";
var REPAIR_ADMINISTRATION_CHARGE_DOLLARS = "repair_administration_charge_dollars";
var REPAIR_ADMINISTRATION_CHARGE_PERCENTAGE = "repair_administration_charge_percentage";
var REPAIR_ADMINISTRATION_FEE = "repair_administration_fee";
var SALES_ORDER = "sales_order";
var SECOND_SELLER_ID = "second_seller_id";
var SELLER_ID = "seller_id";
var SEND_CANCELLATION_EMAIL = "send_cancellation_email";
var SEND_SALES_ORDER_ACKNOWLEDGEMENT = "send_sales_order_acknowledgement";
var SHIP_TO_COMPANY_DISABLED = "ship_to_company_disabled";
var SHIPPED_AT = "shipped_at";

var SEND_SALES_ORDER_ACKNOWLEDGEMENT_LABEL = "Send SO Acknowledgment";

var SPECIAL_INSTRUCTIONS = "special_instructions";

var condition = function condition(cond) {
  return CONDITIONS[cond] || {};
};

var CANCELLATION_REASONS = [{
  value: "failed_test_or_install",
  text: "Unit failed at test or install"
}, {
  value: "cancelled_purchase_order",
  text: "Cancelled Purchase Order"
}, {
  value: "cannot_accept_paperwork",
  text: "Cannot accept paperwork"
}, {
  value: "no_longer_required",
  text: "Unit no longer required"
}, {
  value: "wrong_unit_ordered",
  text: "Wrong unit ordered"
}, {
  value: "failed_inspection",
  text: "Unit failed incoming inspection"
}, {
  value: "export_compliance_caution",
  text: "Export Compliance Caution"
}, {
  value: "dom_not_acceptable_to_customer",
  text: "DOM not acceptable to customer"
}, {
  value: "der_rejected",
  text: "DER/s rejected"
}, {
  value: "nonpayment",
  text: "Non-payment"
}, {
  value: "qc_paperwork_rejected",
  text: "QC Paperwork was rejected"
}, {
  value: "tags_rejected",
  text: "Tags were rejected"
}, {
  value: "repair_station_rejected",
  text: "Repair Station was rejected"
}, {
  value: "time",
  text: "Unable to provide in a timely manner"
}, {
  value: "cancelled_by_customer",
  text: "Our customer's customer cancelled on them"
}, {
  value: "unacceptable_pictures",
  text: "Rejected due to pictures being unacceptable"
}, {
  value: "other",
  text: "Other"
}];

var ATTACHMENT_TYPES = {
  commercial_invoice: {
    label: "Commercial Invoice"
  },
  core_return_paperwork: {
    label: "Core Return Paperwork"
  },
  credit_card_form: {
    label: "Credit Card Form"
  },
  customer_correspondence: {
    label: "Customer Correspondence"
  },
  customers_discreet_paperwork: {
    label: "Discreet Paperwork"
  },
  customer_purchase_order: {
    label: "Customer Purchase Order"
  },
  dangerous_goods_declaration: {
    label: "Dangerous Goods Declaration (DGD)"
  },
  end_user_agreement: {
    label: "End User Agreement"
  },
  external_link: {
    label: "External Link"
  },
  final_trace_paperwork: {
    label: "Final Trace Paperwork"
  },
  material_certification: {
    label: "Material Certification"
  },
  photos_final_packaging: {
    label: "Photos - Final Packaging"
  },
  photos_shipping_inspection: {
    label: "Photos - Shipping Inspection"
  },
  packing_slip: {
    label: "Packing Slip"
  },
  rma_pre_authorization_form: {
    label: "RMA Pre-Authorization Form"
  },
  shippers_letter_of_instruction: {
    label: "Shipper's Letter of Instruction"
  },
  shipping_checklist: {
    label: "Shipping Checklist"
  },
  signed_exchange_agreement: {
    label: "Signed Exchange Agreement"
  },
  signed_pick_up_receipt: {
    label: "Signed Pick Up Receipt"
  },
  supplied_awb_bol: {
    label: "Supplied AWB/BOL"
  }
};

var NOT_EXCHANGED = "not_exchanged";
var SECOND_EXCHANGE = "second_exchange";
var THIRD_EXCHANGE = "third_exchange";

var EXCHANGE_PERCENT = 0.5;
var THIRD_EXCHANGE_PERCENT = 0.75;

var base = "Are you sure you want to";

var EXCHANGE_CONFIG = (_EXCHANGE_CONFIG = {}, _defineProperty(_EXCHANGE_CONFIG, NOT_EXCHANGED, {
  text: "Create Second Exchange",
  actionText: base + " initiate a second exchange?"
}), _defineProperty(_EXCHANGE_CONFIG, SECOND_EXCHANGE, {
  text: "Create Third Exchange",
  actionText: base + " initiate a third exchange?"
}), _EXCHANGE_CONFIG);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1093);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Lots_constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return PO; });
/* unused harmony export RO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RMA; });
/* unused harmony export SO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return TRANSFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MISTAKE_SHIPMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SHIPMENT; });
/* unused harmony export CORE_RETURN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CONSIGNMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CONSIGNMENT_BUYER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CONSIGNMENT_BUYER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CONSIGNMENT_CO_BUYER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CONSIGNMENT_CO_BUYER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CONSIGNMENT_LINE_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CONSIGNMENT_REFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CONSIGNMENT_REFERENCE_COMPANY; });
/* unused harmony export CONSIGNMENT_REFERENCE_COMPANY_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CONSIGNMENT_REFERENCE_COMPANY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CONSIGNOR_PERCENTAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return DISCREPANCY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return EMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return EXPORT_HOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return NEW_COMPANY_HOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return REASON_FOR_RESOLUTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return VIRTUALLY_RECEIVING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return RECEIVING_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return REASON_FOR_RESOLUTION_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SETTABLE_RECEIVING_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AS_REMOVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BEYOND_ECON_REPAIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return INSPECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return OVERHAULED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PARTS_UNIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return RECEIVING_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVED_VIRTUALLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return REPAIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SCRAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CONDITION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return TAG_DATE_CONDITIONS; });
/* unused harmony export PASS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return QC_HOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return UNDER_REVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return QC_STATUS_TYPES; });
/* unused harmony export EXPIRING_SOON */
/* unused harmony export SHIPPING_DAMAGE_TO_PACKAGE */
/* unused harmony export SHIPPING_DAMAGE_TO_PART */
/* unused harmony export UNIT_PACKAGED_INCORRECTLY */
/* unused harmony export DAMAGE_TO_PART */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DISCREPANCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PART_NUMBER_DISCREPANCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SERIAL_NUMBER_DISCREPANCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CONDITION_DISCREPANCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return TAGGED_BY_DISCREPANCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RECEIVING_STORE_INCORRECT; });
/* unused harmony export MISSING_SAFETY_WIRE */
/* unused harmony export ASSEMBLED_LOOSELY */
/* unused harmony export DISASSEMBLED */
/* unused harmony export MISSING_PARTS */
/* unused harmony export MISSING_DATA_PLATE */
/* unused harmony export MISSING_SIGNATURE_OR_NAME */
/* unused harmony export MISSING_WORK_ORDER */
/* unused harmony export NO_DUAL_RELEASE */
/* unused harmony export MISSING_PAPERWORK */
/* unused harmony export COVERS_CAPS_PLUGS_FILTERS_MISSING */
/* unused harmony export OTHER */
/* unused harmony export EXTRA_PARTS_ATTACHED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DISCREPANCY_TYPES; });
/* unused harmony export DATA_PLATE_DOM_PHOTOS */
/* unused harmony export PHOTOS_RECEIVING_INSPECTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PHOTOS_RECEIVING_PACKAGING_INSPECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ATTACHMENT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return RECORD_TYPES; });
/* unused harmony export ACTION_CONDITIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return RECEIVING_CHECKLIST_QUESTIONS; });
var _RECEIVING_TYPES, _CONDITION_TYPES, _QC_STATUS_TYPES, _DISCREPANCY_TYPES, _ATTACHMENT_TYPES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var PO = "po";
var RO = "ro";
var RMA = "rma";
var SO = "so";
var TRANSFER = "transfer";
var MISTAKE_SHIPMENT = "mistake_shipment";
var SHIPMENT = "shipment";
var CORE_RETURN = "core_return";
var CONSIGNMENT = "consignment";
var CONSIGNMENT_BUYER = "consignment_buyer";
var CONSIGNMENT_BUYER_ID = "consignment_buyer_id";
var CONSIGNMENT_CO_BUYER = "consignment_co_buyer";
var CONSIGNMENT_CO_BUYER_ID = "consignment_co_buyer_id";
var CONSIGNMENT_LINE_ITEM = "consignment_line_item";
var CONSIGNMENT_REFERENCE = "consignment_reference";
var CONSIGNMENT_REFERENCE_COMPANY = "consignment_reference_company";
var CONSIGNMENT_REFERENCE_COMPANY_TYPE = "consignment_reference_company";
var CONSIGNMENT_REFERENCE_COMPANY_ID = "consignment_reference_company_id";
var CONSIGNOR_PERCENTAGE = "consignor_percentage";
var DISCREPANCY_TYPE = "discrepancy_type";
var EMA = "ema";
var EXPORT_HOLD = "export_hold";
var NEW_COMPANY_HOLD = "new_company_hold";
var REASON_FOR_RESOLUTION = "reason_for_resolution";
var VIRTUALLY_RECEIVING = "virtually_receiving";

var RECEIVING_TYPES = (_RECEIVING_TYPES = {}, _defineProperty(_RECEIVING_TYPES, EMA, {
  label: "EMA",
  link: "purchase-orders"
}), _defineProperty(_RECEIVING_TYPES, __WEBPACK_IMPORTED_MODULE_1__Lots_constants__["a" /* LOT */], {
  label: "Lot",
  link: "lots"
}), _defineProperty(_RECEIVING_TYPES, __WEBPACK_IMPORTED_MODULE_1__Lots_constants__["b" /* LOT_LINE_ITEM */], {
  label: "Lot",
  link: "lots"
}), _defineProperty(_RECEIVING_TYPES, __WEBPACK_IMPORTED_MODULE_1__Lots_constants__["c" /* MANAGED_REPAIR_ORDER */], {
  label: "MR",
  link: "managed-repair-orders"
}), _defineProperty(_RECEIVING_TYPES, PO, {
  label: "PO",
  link: "purchase-orders"
}), _defineProperty(_RECEIVING_TYPES, RO, {
  label: "RO",
  link: "repair-orders"
}), _defineProperty(_RECEIVING_TYPES, SO, {
  label: "SO",
  link: "sales-orders"
}), _defineProperty(_RECEIVING_TYPES, RMA, {
  label: "RMA",
  link: "rmas"
}), _defineProperty(_RECEIVING_TYPES, MISTAKE_SHIPMENT, {
  label: "Mistake Shipment",
  link: "mistake-shipments"
}), _defineProperty(_RECEIVING_TYPES, CORE_RETURN, {
  label: "Core Return"
}), _defineProperty(_RECEIVING_TYPES, CONSIGNMENT, {
  label: "Consignment",
  link: "purchase-orders"
}), _defineProperty(_RECEIVING_TYPES, TRANSFER, {
  label: "TR"
}), _RECEIVING_TYPES);

var REASON_FOR_RESOLUTION_OPTIONS = ["Requested Paperwork", "Requested Revised Paperwork", "Requested Warranty / RMA", "Non - Discrepancy", "Other"];

var SETTABLE_RECEIVING_TYPES = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["pick"])(RECEIVING_TYPES, MISTAKE_SHIPMENT, CONSIGNMENT, EMA, __WEBPACK_IMPORTED_MODULE_1__Lots_constants__["b" /* LOT_LINE_ITEM */]);

var AS_REMOVED = "as_removed";
var BEYOND_ECON_REPAIR = "beyond_econ_repair";
var INSPECTED = "inspected";
var NEW = "new_item";
var OVERHAULED = "overhauled";
var PARTS_UNIT = "parts_unit";
var RECEIVING_TYPE = "receiving_type";
var RECEIVED_VIRTUALLY = "received_virtually";
var REPAIRED = "repaired";

var SCRAP = "scrap";

var CONDITION_TYPES = (_CONDITION_TYPES = {}, _defineProperty(_CONDITION_TYPES, AS_REMOVED, {
  label: "As Removed",
  abbrev: "AR"
}), _defineProperty(_CONDITION_TYPES, BEYOND_ECON_REPAIR, {
  label: "Beyond Econ. Repair",
  abbrev: "BR"
}), _defineProperty(_CONDITION_TYPES, INSPECTED, {
  label: "Inspected",
  abbrev: "BT"
}), _defineProperty(_CONDITION_TYPES, NEW, {
  label: "New",
  abbrev: "NE"
}), _defineProperty(_CONDITION_TYPES, OVERHAULED, {
  label: "Overhauled",
  abbrev: "OH"
}), _defineProperty(_CONDITION_TYPES, PARTS_UNIT, {
  label: "Parts Unit",
  abbrev: "PU"
}), _defineProperty(_CONDITION_TYPES, REPAIRED, {
  label: "Repaired",
  abbrev: "SV"
}), _defineProperty(_CONDITION_TYPES, SCRAP, {
  label: "Scrap",
  abbrev: "SC"
}), _defineProperty(_CONDITION_TYPES, __WEBPACK_IMPORTED_MODULE_3__IncomingQuotes_constants__["a" /* SERVICEABLE_TOOLING */], {
  label: "Serviceable Tooling",
  abbrev: "SV"
}), _CONDITION_TYPES);

var TAG_DATE_CONDITIONS = [OVERHAULED, REPAIRED, INSPECTED];

var PASS = "pass";
var QC_HOLD = "qc_hold";
var UNDER_REVIEW = "under_review";

var QC_STATUS_TYPES = (_QC_STATUS_TYPES = {}, _defineProperty(_QC_STATUS_TYPES, PASS, {
  label: "Pass"
}), _defineProperty(_QC_STATUS_TYPES, QC_HOLD, {
  label: "QC Hold"
}), _QC_STATUS_TYPES);

var EXPIRING_SOON = "expiring_soon";
var SHIPPING_DAMAGE_TO_PACKAGE = "shipping_damage_to_the_package";
var SHIPPING_DAMAGE_TO_PART = "shipping_damage_to_the_part";
var UNIT_PACKAGED_INCORRECTLY = "unit_packaged_incorrectly";
var DAMAGE_TO_PART = "damage_to_the_part";

var DISCREPANCY = "discrepancy";
var PART_NUMBER_DISCREPANCY = "part_number_discrepancy";
var SERIAL_NUMBER_DISCREPANCY = "serial_number_discrepancy";
var CONDITION_DISCREPANCY = "condition_discrepancy";
var TAGGED_BY_DISCREPANCY = "tagged_by_discrepancy";
var RECEIVING_STORE_INCORRECT = "receiving_store_incorrect";
var MISSING_SAFETY_WIRE = "missing_safety_wire";
var ASSEMBLED_LOOSELY = "assembled_loosely";
var DISASSEMBLED = "disassembled";
var MISSING_PARTS = "missing_parts";
var MISSING_DATA_PLATE = "missing_data_plate";
var MISSING_SIGNATURE_OR_NAME = "missing_signature_or_name";
var MISSING_WORK_ORDER = "missing_work_order";
var NO_DUAL_RELEASE = "no_dual_release";
var MISSING_PAPERWORK = "missing_paperwork";
var COVERS_CAPS_PLUGS_FILTERS_MISSING = "covers_caps_plugs_and_or_fittings_missing";
var OTHER = "other";
var EXTRA_PARTS_ATTACHED = "extra_parts_attached";

var DISCREPANCY_TYPES = (_DISCREPANCY_TYPES = {}, _defineProperty(_DISCREPANCY_TYPES, ASSEMBLED_LOOSELY, {
  label: "Assembled loosely"
}), _defineProperty(_DISCREPANCY_TYPES, CONDITION_DISCREPANCY, {
  label: "Condition discrepancy"
}), _defineProperty(_DISCREPANCY_TYPES, COVERS_CAPS_PLUGS_FILTERS_MISSING, {
  label: "Covers, caps, plugs or filters missing"
}), _defineProperty(_DISCREPANCY_TYPES, DAMAGE_TO_PART, {
  label: "Damage to the part"
}), _defineProperty(_DISCREPANCY_TYPES, DISASSEMBLED, {
  label: "Disassembled"
}), _defineProperty(_DISCREPANCY_TYPES, EXPIRING_SOON, {
  label: "Expired/Soon to expire"
}), _defineProperty(_DISCREPANCY_TYPES, EXTRA_PARTS_ATTACHED, {
  label: "Extra part/s attached"
}), _defineProperty(_DISCREPANCY_TYPES, MISSING_DATA_PLATE, {
  label: "Missing data plate"
}), _defineProperty(_DISCREPANCY_TYPES, MISSING_PAPERWORK, {
  label: "Missing paperwork"
}), _defineProperty(_DISCREPANCY_TYPES, MISSING_PARTS, {
  label: "Missing parts"
}), _defineProperty(_DISCREPANCY_TYPES, MISSING_SAFETY_WIRE, {
  label: "Missing safety wire"
}), _defineProperty(_DISCREPANCY_TYPES, MISSING_SIGNATURE_OR_NAME, {
  label: "Missing signature or name"
}), _defineProperty(_DISCREPANCY_TYPES, MISSING_WORK_ORDER, {
  label: "Missing work order"
}), _defineProperty(_DISCREPANCY_TYPES, NO_DUAL_RELEASE, {
  label: "No dual release"
}), _defineProperty(_DISCREPANCY_TYPES, PART_NUMBER_DISCREPANCY, {
  label: "Part number discrepancy"
}), _defineProperty(_DISCREPANCY_TYPES, RECEIVING_STORE_INCORRECT, {
  label: "Receiving Store Location Incorrect"
}), _defineProperty(_DISCREPANCY_TYPES, SERIAL_NUMBER_DISCREPANCY, {
  label: "Serial number discrepancy"
}), _defineProperty(_DISCREPANCY_TYPES, SHIPPING_DAMAGE_TO_PACKAGE, {
  label: "Shipping damage to the package"
}), _defineProperty(_DISCREPANCY_TYPES, SHIPPING_DAMAGE_TO_PART, {
  label: "Shipping damage to the part"
}), _defineProperty(_DISCREPANCY_TYPES, TAGGED_BY_DISCREPANCY, {
  label: "Tagged By Discrepancy"
}), _defineProperty(_DISCREPANCY_TYPES, UNIT_PACKAGED_INCORRECTLY, {
  label: "Unit packaged incorrectly"
}), _defineProperty(_DISCREPANCY_TYPES, OTHER, {
  label: "Other"
}), _DISCREPANCY_TYPES);

var DATA_PLATE_DOM_PHOTOS = "data_plate_dom_photos";
var PHOTOS_RECEIVING_INSPECTION = "photos_receiving_inspection";
var PHOTOS_RECEIVING_PACKAGING_INSPECTION = "photos_receiving_packaging_inspection";

var ATTACHMENT_TYPES = (_ATTACHMENT_TYPES = {}, _defineProperty(_ATTACHMENT_TYPES, DATA_PLATE_DOM_PHOTOS, {
  label: "Data Plate / DOM Photos"
}), _defineProperty(_ATTACHMENT_TYPES, PHOTOS_RECEIVING_INSPECTION, {
  label: "Photos - Receiving Inspection"
}), _defineProperty(_ATTACHMENT_TYPES, PHOTOS_RECEIVING_PACKAGING_INSPECTION, {
  label: "Photos - Receiving Packaging Inspection"
}), _defineProperty(_ATTACHMENT_TYPES, __WEBPACK_IMPORTED_MODULE_2__inventories_constants__["c" /* TAG_COPIES */], {
  label: "Tag Copies"
}), _defineProperty(_ATTACHMENT_TYPES, __WEBPACK_IMPORTED_MODULE_2__inventories_constants__["d" /* TRACEABILITY */], {
  label: "Traceability"
}), _ATTACHMENT_TYPES);

var RECORD_TYPES = {
  purchase_order_line_item: {
    label: "PO"
  },
  rma: {
    label: "RMA"
  },
  sales_order_line_item: {
    label: "SO"
  },
  managed_repair_order_line_item: {
    label: "MRO"
  },
  repair_order_line_item: {
    label: "RO"
  },
  inventory_transfer_order: {
    label: "TR"
  }
};

var ACTION_CONDITIONS = {
  repair: "repaired",
  overhaul: "overhauled",
  bench_test: "inspected",
  tear_down: "parts_unit"
};

var RECEIVING_CHECKLIST_QUESTIONS = {
  shipped_properly: "Shipped properly, packaged under ATA-300 Spec. guidelines and there is no visible damage to the package",
  vendor_packing_list_included: "Unit/s accompanied with vendor’s packing list referencing accurate part number, serial number, quantity, and condition",
  packing_list_and_tags_match: "Unit/s packing list and tag documents (if applicable) match data plate",
  passed_damage_inspection: "Unit/s inspected to be free of corrosion, pitting, contamination, leakage, and/or missing parts and there is no visible damage",
  release_certificate_included: "Serviceable item/s have authorized release certificates and all plugs & fittings, and openings are covered to prevent leakage or contamination"
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(3085);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(3086);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(1112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(3087);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(3088);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(3089);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(3090);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(1113);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(592);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(3091);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(3092);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(3093);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(3094);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toastr = exports.reducer = exports.actions = undefined;

var _ReduxToastr = __webpack_require__(3063);

var _ReduxToastr2 = _interopRequireDefault(_ReduxToastr);

var _actions = __webpack_require__(1104);

var ReduxToastrActions = _interopRequireWildcard(_actions);

var _reducer = __webpack_require__(1105);

var _reducer2 = _interopRequireDefault(_reducer);

var _toastrEmitter = __webpack_require__(1106);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ReduxToastr2.default;
var actions = exports.actions = ReduxToastrActions;
var reducer = exports.reducer = _reducer2.default;
var toastr = exports.toastr = _toastrEmitter.toastrEmitter;

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useCurrentUser__ = __webpack_require__(51);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__useCurrentUser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useDebounce__ = __webpack_require__(201);
/* unused harmony reexport useDebounce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useDispatch__ = __webpack_require__(623);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__useDispatch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__useScrollToOnMount__ = __webpack_require__(1229);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__useScrollToOnMount__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useActiveDemeritsColor__ = __webpack_require__(1227);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__useActiveDemeritsColor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__useRejectedCore__ = __webpack_require__(624);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__useRejectedCore__["a"]; });













/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyleConfig__ = __webpack_require__(106);
/* harmony export (immutable) */ __webpack_exports__["e"] = prefix;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bsClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return bsStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return bsSizes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getClassSet;
/* harmony export (immutable) */ __webpack_exports__["a"] = splitBsProps;
/* harmony export (immutable) */ __webpack_exports__["g"] = splitBsPropsAndOmit;
/* unused harmony export addStyle */
/* unused harmony export _curry */


// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.






function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];
    if (typeof last === 'function') {
      return fn.apply(undefined, args);
    }
    return function (Component) {
      return fn.apply(undefined, args.concat([Component]));
    };
  };
}

function prefix(props, variant) {
  !(props.bsClass != null) ?  false ? invariant(false, 'A `bsClass` prop is required for this component') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  return props.bsClass + (variant ? '-' + variant : '');
}

var bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});

  propTypes.bsClass = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
  defaultProps.bsClass = defaultClass;

  return Component;
});

var bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};

  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });

  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(existing);

  // expose the values on the propType function for documentation
  Component.STYLES = propType._values = existing;

  Component.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});

var bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};

  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });

  var values = [];
  existing.forEach(function (size) {
    var mappedSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["a" /* SIZE_MAP */][size];
    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });

  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(values);
  propType._values = values;

  // expose the values on the propType function for documentation
  Component.SIZES = existing;

  Component.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }
    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});

function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["a" /* SIZE_MAP */][props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });

  var elementProps = {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */
function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}

var _curry = curry;

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_formatters_text__ = __webpack_require__(11);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OVERHAULED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REPAIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return INSPECTED; });
/* unused harmony export NEW */
/* unused harmony export AS_REMOVED */
/* unused harmony export BEYOND_REPAIR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SERVICEABLE_TOOLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return STANDARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NO_QUOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return AWAITING_REPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return NOT_AWAITING_REPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return MAKE_OFFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AS_IS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return EXCHANGE_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return INCIDENT_RELATED; });
/* unused harmony export NONE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return OFFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PARTIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PURCHASE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PURCHASE_STATUS_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RFQ_AS_ALT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SEND_QUOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INCOMING_LINE_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PURCHASE_STATUS_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ATTACHMENT_TYPES; });
var _condition, _quoteType;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var OVERHAULED = "overhauled";
var REPAIRED = "repaired";
var INSPECTED = "inspected";
var NEW = "new_item";
var AS_REMOVED = "as_removed";
var BEYOND_REPAIR = "beyond_econ_repair";
var SERVICEABLE_TOOLING = "serviceable_tooling";

var MODIFIED = "modified";
var STANDARD = "standard";
var NO_QUOTE = "no_quote";
var AWAITING_REPLY = "awaiting_reply";
var NOT_AWAITING_REPLY = "not_awaiting_reply";
var MAKE_OFFER = "make_offer";
var AS_IS = "as_is";
var EXCHANGE_ONLY = "exchange_only";
var FULL = "full";
var INCIDENT_RELATED = "incident_related";
var NONE = "none";
var OFFER = "offer";
var PARTIAL = "partial";
var PURCHASE_STATUS = "purchase_status";
var PURCHASE_STATUS_LABEL = "Purchase Qty Remaining";
var RFQ_AS_ALT_ID = "rfq_as_alt_id";
var SEND_QUOTE = "send_quote";

var INCOMING_LINE_ITEMS = {
  condition: (_condition = {}, _defineProperty(_condition, OVERHAULED, {
    abbrev: "OH",
    label: "Overhauled"
  }), _defineProperty(_condition, REPAIRED, {
    abbrev: "SV",
    label: "Repaired"
  }), _defineProperty(_condition, INSPECTED, {
    abbrev: "BT",
    label: "Inspected"
  }), _defineProperty(_condition, NEW, {
    abbrev: "NE",
    label: "New"
  }), _defineProperty(_condition, AS_REMOVED, {
    abbrev: "AR",
    label: "As Removed"
  }), _defineProperty(_condition, BEYOND_REPAIR, {
    abbrev: "BR",
    label: "Beyond Repair"
  }), _defineProperty(_condition, SERVICEABLE_TOOLING, {
    abbrev: "SV",
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_formatters_text__["c" /* properCase */])(SERVICEABLE_TOOLING)
  }), _condition),
  quoteType: (_quoteType = {}, _defineProperty(_quoteType, STANDARD, {
    label: "Standard",
    abbrev: "Std"
  }), _defineProperty(_quoteType, NO_QUOTE, {
    label: "No Quote",
    abbrev: "NQ"
  }), _defineProperty(_quoteType, AWAITING_REPLY, {
    label: "Awaiting Reply",
    abbrev: "Awaiting"
  }), _defineProperty(_quoteType, NOT_AWAITING_REPLY, {
    label: "Rfq Closed",
    abbrev: "RfqClosed"
  }), _defineProperty(_quoteType, MAKE_OFFER, {
    label: "Make Offer",
    abbrev: "MakeOffer"
  }), _defineProperty(_quoteType, AS_IS, {
    label: "As Is",
    abbrev: "As Is"
  }), _defineProperty(_quoteType, INCIDENT_RELATED, {
    label: "Incident Related",
    abbrev: "Incident"
  }), _defineProperty(_quoteType, EXCHANGE_ONLY, {
    label: "Exchange Only",
    abbrev: "Exch Only"
  }), _defineProperty(_quoteType, OFFER, {
    label: "Offer",
    abbrev: "Offer"
  }), _quoteType),
  traceTypes: {
    121: {
      label: "121",
      abbrev: "121"
    },
    125: {
      label: "125",
      abbrev: "125"
    },
    129: {
      label: "129",
      abbrev: "129"
    },
    135: {
      label: "135",
      abbrev: "135"
    },
    145: {
      label: "145",
      abbrev: "145"
    },
    part_91: {
      label: "Part 91",
      abbrev: "Part91"
    },
    foreign_part_91: {
      label: "Foreign Part 91",
      abbrev: "FrgnPrt91"
    },
    certificate_of_conformance: {
      label: "C of C Only",
      abbrev: "C of C"
    },
    foreign_operator: {
      label: "Foreign Operator",
      abbrev: "FrgnOp"
    },
    foreign_repair_station: {
      label: "Foreign Repair Station",
      abbrev: "Frgn145"
    },
    ntr: {
      label: "No Trace",
      abbrev: "NoTrace"
    },
    oem: {
      label: "OEM",
      abbrev: "OEM"
    },
    unknown: {
      label: "Unknown",
      abbrev: "UNK"
    }
  }
};

var PURCHASE_STATUS_OPTIONS = [{ value: PARTIAL, text: "Partial Purchase" }, { value: FULL, text: "Full Purchase " }];

var ATTACHMENT_TYPES = {
  tag_copies: {
    label: "Tag Copies"
  },
  traceability: {
    label: "Traceability"
  },
  photos: {
    label: "Photos"
  },
  vendor_correspondence: {
    label: "Vendor Correspondence"
  },
  external_link: {
    label: "External Link"
  }
};

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_formatters_text__ = __webpack_require__(11);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subroleLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return hasSubRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasAnyOfSubroles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasAnyOfRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hasAnyOfRolesOrSubroles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return disableIfHasAnyOfRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return disableIfHasAnyOfSubroles; });
/* unused harmony export disableIfHasAnyOfRolesOrSubroles */



var subroleLabel = function subroleLabel(role, subrole) {
  if (!subrole) return null;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_formatters_text__["c" /* properCase */])(subrole.replace(role + "_", ""));
};

var hasRole = function hasRole() {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var role = arguments[1];
  return user.role === role || user.permissions && user.permissions.includes(role) || user.role === __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* ADMIN */];
};

var hasPermission = function hasPermission(user, permission) {
  return user.permissions && user.permissions.includes(permission) || user.role === __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* ADMIN */];
};

var hasSubRole = function hasSubRole(user, subrole) {
  return user.subrole === subrole || user.permissions && user.permissions.includes(subrole);
};

var hasAnyOfSubroles = function hasAnyOfSubroles(user, subroles) {
  var hasPermissions = user.permissions ? user.permissions.filter(function (p) {
    return subroles.includes(p);
  }) : [];
  return subroles.includes(user.subrole) || hasPermissions.length > 0 || user.role === __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* ADMIN */];
};

var hasAnyOfRoles = function hasAnyOfRoles(user, roles) {
  var hasPermissions = user.permissions ? user.permissions.filter(function (p) {
    return roles.includes(p);
  }) : [];

  return roles.includes(user.role) || hasPermissions.length > 0 || user.role === __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* ADMIN */];
};

var hasAnyOfRolesOrSubroles = function hasAnyOfRolesOrSubroles(user, roles, subroles) {
  return hasAnyOfRoles(user, roles) || hasAnyOfSubroles(user, subroles);
};

var disableIfHasAnyOfRoles = function disableIfHasAnyOfRoles(user, roles) {
  if (user.role === __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* ADMIN */]) return false;
  var otherRolesNotInSelectedRoles = roles && __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* ROLES */].filter(function (a) {
    return !roles.some(function (s) {
      return s.includes(a);
    });
  });

  var otherRoles = user.permissions && roles ? user.permissions.filter(function (a) {
    return __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* ROLES */].includes(a) && otherRolesNotInSelectedRoles.includes(a);
  }) : [];

  return roles && roles.includes(user.role) && otherRoles.length === 0;
};

var disableIfHasAnyOfSubroles = function disableIfHasAnyOfSubroles(user, subroles) {
  if (user.role === __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* ADMIN */]) return false;
  var otherRolesNotInSubroles = subroles && __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* ROLES */].filter(function (a) {
    return !subroles.some(function (s) {
      return s.includes(a);
    });
  });

  var otherRolesAndSubroles = user.permissions && subroles ? user.permissions.filter(function (a) {
    return __WEBPACK_IMPORTED_MODULE_0__constants__["w" /* SUBROLES */].includes(a) && !subroles.includes(a) || __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* ROLES */].includes(a) && otherRolesNotInSubroles.includes(a);
  }) : [];

  return subroles && subroles.includes(user.subrole) && otherRolesAndSubroles.length === 0;
};

var disableIfHasAnyOfRolesOrSubroles = function disableIfHasAnyOfRolesOrSubroles(user) {
  var roles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var subroles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (user.role === __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* ADMIN */]) return false;

  var otherRolesNotInSubroles = __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* ROLES */].filter(function (a) {
    return !subroles.some(function (s) {
      return s.includes(a);
    });
  });

  var otherRolesNotInRoles = __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* ROLES */].filter(function (r) {
    return !roles.includes(r);
  });

  var otherRolesAndSubroles = user.permissions && subroles ? user.permissions.filter(function (a) {
    return __WEBPACK_IMPORTED_MODULE_0__constants__["w" /* SUBROLES */].includes(a) && !subroles.includes(a) || __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* ROLES */].includes(a) && otherRolesNotInSubroles.includes(a) && otherRolesNotInRoles.includes(a);
  }) : [];

  return (subroles.includes(user.subrole) || roles.includes(user.role)) && otherRolesAndSubroles.length === 0;
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(3044)();
}


/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatters_text__ = __webpack_require__(11);
/* harmony export (immutable) */ __webpack_exports__["a"] = toOptions;
/* harmony export (immutable) */ __webpack_exports__["f"] = arrayToOptions;
/* harmony export (immutable) */ __webpack_exports__["e"] = arrayToProperCasedOptions;
/* harmony export (immutable) */ __webpack_exports__["d"] = arrayToProperCasedOptionsWithCurrentValue;
/* harmony export (immutable) */ __webpack_exports__["b"] = arrayToManipulatedOptions;
/* harmony export (immutable) */ __webpack_exports__["c"] = addressesToOptions;


function toOptions(map) {
  var textField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "label";

  return Object.keys(map).map(function (t) {
    var text = textField ? map[t][textField] : map[t];
    return { value: t, text: text };
  });
}

function arrayToOptions(map) {
  return map.map(function (text) {
    return { value: text, text: text };
  });
}

function arrayToProperCasedOptions(map) {
  return map.map(function (text) {
    return { value: text, text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatters_text__["c" /* properCase */])(text) };
  });
}

function arrayToProperCasedOptionsWithCurrentValue(map, currentValue) {
  if (!currentValue || map.includes(currentValue)) {
    return map.map(function (text) {
      return { value: text, text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatters_text__["c" /* properCase */])(text) };
    });
  }

  return map.map(function (text) {
    return { value: text, text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatters_text__["c" /* properCase */])(text) };
  }).concat([{ value: currentValue, text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatters_text__["c" /* properCase */])(currentValue) }]);
}

function arrayToManipulatedOptions(map) {
  var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0__formatters_text__["c" /* properCase */];

  return map.map(function (text) {
    return { value: text, text: func(text) };
  });
}

function addressesToOptions(addresses) {
  var formatted = function formatted(_ref) {
    var line1 = _ref.line1,
        line2 = _ref.line2,
        city = _ref.city,
        state = _ref.state,
        zip = _ref.postal_code,
        country = _ref.country,
        co = _ref.care_of;
    return "" + (co ? "c/o " + co + ", " : "") + line1 + (line2 ? " " + line2 : "") + ", " + city + ", " + state + " " + zip + ", " + country;
  }; // eslint-disable-line prefer-template

  return addresses.map(function (a) {
    return {
      value: a.id,
      text: formatted(a)
    };
  });
}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_helpers__ = __webpack_require__(79);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return AS_REMOVED; });
/* unused harmony export BEYOND_REPAIR */
/* unused harmony export INSPECTED */
/* unused harmony export NEW */
/* unused harmony export OVERHAULED */
/* unused harmony export REPAIRED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return AOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return AS_IS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return ASSIGN_TO_ME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return ATTACHMENT_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return AUTO_FOLLOWUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return AUTO_FOLLOWUP_DAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return AWAITING_INFO_TO_COMPLETE; });
/* unused harmony export CORE_VALUE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return LOCKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return OUTRIGHT_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EXCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EXCHANGE_FEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EXCHANGE_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FOLLOW_UP_FEEDBACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return HAS_FOLLOW_UP_FEEDBACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return INCLUDE_DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return INVENTORY_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return INVENTORY_ATTACHMENT_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOOKING_FOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MAKE_OFFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NO_QUOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return NO_INTEREST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return OFFER; });
/* unused harmony export OUTGOING_QUOTE_LINE_ITEM */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRICE_PER_UNIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return QUOTE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SELL_AS_ALT_ID; });
/* unused harmony export SEND_QUOTE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return STANDARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return WARRANTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ATTACH_TRACEABILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ATTACH_TAG_COPIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PRICE_PER_UNIT_OPTIONAL_QUOTE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FOLLOW_UP_FEEDBACKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OUTGOING_LINE_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return ATTACHMENT_TYPES; });
var _condition, _quoteType;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var AS_REMOVED = "as_removed";
var BEYOND_REPAIR = "beyond_econ_repair";
var INSPECTED = "inspected";
var NEW = "new_item";
var OVERHAULED = "overhauled";
var REPAIRED = "repaired";

var AOG = "aog";
var AS_IS = "as_is";
var ASSIGN_TO_ME = "assign_to_me";
var ATTACHMENT_IDS = "attachment_ids";
var AUTO_FOLLOWUP = "auto_followup";
var AUTO_FOLLOWUP_DAYS = "auto_followup_days";
var AWAITING_INFO_TO_COMPLETE = "awaiting_info_to_complete";
var CORE_VALUE = "core_value";
var LOCKED = "locked";
var OUTRIGHT_VALUE = "outright_value";
var EXCHANGE = "exchange";
var EXCHANGE_FEE = "exchange_fee";
var EXCHANGE_ONLY = "exchange_only";
var FOLLOW_UP_FEEDBACK = "follow_up_feedback";
var HAS_FOLLOW_UP_FEEDBACK = "has_feedback";
var INCLUDE_DOM = "include_dom";
var INVENTORY_IDS = "inventory_ids";
var INVENTORY_ATTACHMENT_IDS = "inventory_attachment_ids";
var LOOKING_FOR = "looking_for";
var MAKE_OFFER = "make_offer";
var NO_QUOTE = "no_quote";
var NO_INTEREST = "no_interest";
var OFFER = "offer";
var OUTGOING_QUOTE_LINE_ITEM = "outgoing_quote_line_item";
var PRICE_PER_UNIT = "price_per_unit";
var QUOTE_TYPE = "quote_type";
var SELL_AS_ALT_ID = "sell_as_alt_id";
var SEND_QUOTE = "send_quote";
var STANDARD = "standard";
var WARRANTY = "warranty";

var ATTACH_TRACEABILITY = "attach_traceability";
var ATTACH_TAG_COPIES = "attach_tag_copies";

var PRICE_PER_UNIT_OPTIONAL_QUOTE_TYPES = [AWAITING_INFO_TO_COMPLETE, NO_QUOTE, OFFER, MAKE_OFFER, EXCHANGE_ONLY];

var OTHER = "other";
var REPAIR_STATION_NOT_APPROVED = "repair_station_not_approved";
var RFQ_IS_STILL_OPEN = "rfq_is_still_open";
var UNACCEPTABLE_TRACE = "unacceptable_trace";
var UNDESIRABLE_CONDITION = "undesirable_condition";
var PRICE_IS_TOO_HIGH = "price_is_too_high";

var FOLLOW_UP_FEEDBACKS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_helpers__["b" /* arrayToOptions */])([REPAIR_STATION_NOT_APPROVED, RFQ_IS_STILL_OPEN, UNACCEPTABLE_TRACE, UNDESIRABLE_CONDITION, PRICE_IS_TOO_HIGH, OTHER]);

var OUTGOING_LINE_ITEMS = {
  condition: (_condition = {}, _defineProperty(_condition, OVERHAULED, {
    abbrev: "OH",
    label: "Overhauled"
  }), _defineProperty(_condition, REPAIRED, {
    abbrev: "SV",
    label: "Repaired"
  }), _defineProperty(_condition, INSPECTED, {
    abbrev: "BT",
    label: "Inspected"
  }), _defineProperty(_condition, NEW, {
    abbrev: "NE",
    label: "New"
  }), _defineProperty(_condition, AS_REMOVED, {
    abbrev: "AR",
    label: "As Removed"
  }), _defineProperty(_condition, BEYOND_REPAIR, {
    abbrev: "BR",
    label: "Beyond Repair"
  }), _condition),
  quoteType: (_quoteType = {}, _defineProperty(_quoteType, STANDARD, {
    label: "Standard",
    abbrev: "Std"
  }), _defineProperty(_quoteType, NO_QUOTE, {
    label: "No Quote",
    abbrev: "NQ"
  }), _defineProperty(_quoteType, AS_IS, {
    label: "As Is",
    abbrev: "As Is"
  }), _defineProperty(_quoteType, MAKE_OFFER, {
    label: "Make Offer",
    abbrev: "MakeOffer"
  }), _defineProperty(_quoteType, AWAITING_INFO_TO_COMPLETE, {
    label: "Awaiting Info To Complete",
    abbrev: "Awaiting"
  }), _defineProperty(_quoteType, OFFER, {
    label: "Offer",
    abbrev: "Offer"
  }), _defineProperty(_quoteType, EXCHANGE_ONLY, {
    label: "Exchange",
    abbrev: "Exch"
  }), _defineProperty(_quoteType, AOG, {
    label: "After-Hours AOG",
    abbrev: "AfterHrs"
  }), _quoteType),
  traceTypes: {
    121: {
      label: "121",
      abbrev: "121"
    },
    125: {
      label: "125",
      abbrev: "125"
    },
    129: {
      label: "129",
      abbrev: "129"
    },
    135: {
      label: "135",
      abbrev: "135"
    },
    145: {
      label: "145",
      abbrev: "145"
    },
    part_91: {
      label: "Part 91",
      abbrev: "Part91"
    },
    foreign_part_91: {
      label: "Foreign Part 91",
      abbrev: "FrgnPrt91"
    },
    certificate_of_conformance: {
      label: "C of C Only",
      abbrev: "C of C"
    },
    foreign_operator: {
      label: "Foreign Operator",
      abbrev: "FrgnOp"
    },
    foreign_repair_station: {
      label: "Foreign Repair Station",
      abbrev: "Frgn145"
    },
    ntr: {
      label: "No Trace",
      abbrev: "NoTrace"
    },
    oem: {
      label: "OEM",
      abbrev: "OEM"
    },
    unknown: {
      label: "Unknown",
      abbrev: "UNK"
    }
  }
};

var ATTACHMENT_TYPES = {
  tag_copies: {
    label: "Tag Copies"
  },
  traceability: {
    label: "Traceability"
  },
  photos: {
    label: "Photos"
  },
  customer_correspondence: {
    label: "Customer Correspondence"
  }
};

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony export (immutable) */ __webpack_exports__["a"] = DropDownItem;




function DropDownItem(_ref, context) {
  var onClick = _ref.onClick,
      children = _ref.children,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled;

  var click = function click(e) {
    e.stopPropagation();
    onClick();
    if (context && context.close) context.close();
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "li",
    {
      onClick: disabled ? function () {} : click,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ disabled: disabled })
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "a",
      {
        className: "btn-link",
        role: "button",
        style: { cursor: disabled ? "not-allowed" : "pointer" }
      },
      children
    )
  );
}

DropDownItem.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)])
};

DropDownItem.contextTypes = { close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func };

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_constants__ = __webpack_require__(13);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WithCurrentUser; });





/* harmony default export */ __webpack_exports__["b"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session && state.session.get(__WEBPACK_IMPORTED_MODULE_3__users_constants__["a" /* USER */]).toJS(),
    settings: state.session && state.session.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* SETTINGS */]) && state.session.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* SETTINGS */]).toJS()
  };
}));

var WithCurrentUser = {
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    buying_limit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    can_override_listing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    can_release_shipment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    created_at: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    created_by: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    created_by_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    email: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    first_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    last_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    manager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    next_record_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    po_approval_role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    previous_record_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    updated_at: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    updated_by: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    updated_by_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  settings: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony export (immutable) */ __webpack_exports__["a"] = withFieldAccessors;




function withFieldAccessors(Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state, ownProps) {
    return {
      getFieldValue: function getFieldValue(field) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_form__["formValueSelector"])(ownProps.formName || ownProps.form)(state, field);
      },
      getInitialFieldValue: function getInitialFieldValue(field) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_form__["getFormInitialValues"])(ownProps.formName || ownProps.form)(state), field);
      }
    };
  }, function (dispatch, ownProps) {
    return {
      setFieldValue: function setFieldValue(field) {
        return function (val) {
          return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_form__["change"])(ownProps.formName || ownProps.form, field, val));
        };
      }
    };
  })(Component);
}

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__constants__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__onSuccess__ = __webpack_require__(627);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__onSuccess__["a"]; });




/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(149);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["t"]; });


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["a"] = useCurrentUser;
/* harmony export (immutable) */ __webpack_exports__["b"] = useSettings;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultStoreLocation; });




function useCurrentUser() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* default */])().getState().session.get(__WEBPACK_IMPORTED_MODULE_1__modules_users_constants__["a" /* USER */]).toJS();
}

function useSettings() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* default */])().getState().session.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* SETTINGS */]).toJS();
}

var defaultStoreLocation = function defaultStoreLocation(currentUser) {
  return currentUser.tenant.locations_count === 1 ? currentUser.locations[0].id : undefined;
};

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FilterSelect__ = __webpack_require__(2372);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__FilterSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MonthSelect__ = __webpack_require__(2373);
/* unused harmony reexport MonthSelect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pagination__ = __webpack_require__(2374);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__Pagination__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchableFilterSelect__ = __webpack_require__(2376);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__SearchableFilterSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchFilter__ = __webpack_require__(2375);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__SearchFilter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TitleWithFilters__ = __webpack_require__(2377);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__TitleWithFilters__["a"]; });







/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = Warning;



function Warning(_ref) {
  var children = _ref.children,
      _ref$enableIcon = _ref.enableIcon,
      enableIcon = _ref$enableIcon === undefined ? true : _ref$enableIcon,
      _ref$warningType = _ref.warningType,
      warningType = _ref$warningType === undefined ? "warning" : _ref$warningType;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "center-block alert alert-" + warningType },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "media" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "media-left" },
        enableIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-warning text-" + warningType })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "media-body" },
        children
      )
    )
  );
}

Warning.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)]),
  warningType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropDown__ = __webpack_require__(779);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__DropDown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DropDownItem__ = __webpack_require__(46);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__DropDownItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ImprovedDropDown__ = __webpack_require__(486);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__ImprovedDropDown__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__ImprovedDropDown__["b"]; });
/* unused harmony reexport ImprovedDropDownModal */









/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withSalesOrder__ = __webpack_require__(329);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withSalesOrder__["a"]; });



/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pojo;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function pojo(obj) {
  var pick = function pick() {
    for (var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++) {
      keys[_key] = arguments[_key];
    }

    return keys.reduce(function (final, k) {
      return _extends({}, final, _defineProperty({}, k, obj[k]));
    }, {});
  };

  return { pick: pick };
}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(68);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  company: "companies",
  consignment: "consignments",
  part: "parts",
  incomingQuote: "incoming_quotes",
  outgoingQuote: "outgoing_quotes",
  lot: "lots",
  managedRepairOrder: "managed_repair_orders",
  purchaseOrder: "purchase_orders",
  receivingRecord: "receiving_records",
  repairOrder: "repair_orders",
  rma: "rmas",
  inventory: "inventories",
  mistakeShipment: "mistake_shipments",
  salesOrder: "sales_orders",
  shipment: "shipments"
});

/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_submission_constants__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__parts_components_Detail_PurchaseOrders_Create_Create__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actionTypes__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pagination__ = __webpack_require__(443);
/* unused harmony export create */
/* harmony export (immutable) */ __webpack_exports__["j"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["k"] = approve;
/* harmony export (immutable) */ __webpack_exports__["l"] = setTraceHold;
/* harmony export (immutable) */ __webpack_exports__["i"] = show;
/* harmony export (immutable) */ __webpack_exports__["h"] = update;
/* harmony export (immutable) */ __webpack_exports__["n"] = updateQcStatus;
/* harmony export (immutable) */ __webpack_exports__["o"] = bulkUpdateLineItems;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchLineItems; });
/* harmony export (immutable) */ __webpack_exports__["d"] = addLineItem;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateLineItem;
/* harmony export (immutable) */ __webpack_exports__["e"] = searchAlternates;
/* harmony export (immutable) */ __webpack_exports__["c"] = searchBuyers;
/* harmony export (immutable) */ __webpack_exports__["a"] = searchCompanies;
/* harmony export (immutable) */ __webpack_exports__["f"] = searchRepairStations;
/* harmony export (immutable) */ __webpack_exports__["m"] = sync;













function refreshPurchaseOrderAndLineItems(dispatch, purchaseOrderID) {
  return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].purchaseOrders.show(purchaseOrderID).then(function (resp) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_10__actionTypes__["a" /* SET */], purchaseOrder: resp.data });
    dispatch(__WEBPACK_IMPORTED_MODULE_11__pagination__["a" /* purchaseOrderLineItems */].pageActions.expire());
  });
}

var getPurchaseOrderDetailId = function getPurchaseOrderDetailId(getState) {
  return getState().purchaseOrderDetail.getIn(["purchaseOrder", "id"]);
};

function create(data) {
  return function (dispatch, getState) {
    var partFromState = getState().partDetail.get("part");

    if (data.contact_id === "Add") {
      data.contact_id = null;
    }

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].purchaseOrders.create(data).then(function (resp) {
      var id = resp.data.id;
      var part = data.persistPart ? partFromState.toJS() : {};
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["push"])({
        pathname: "/purchase-orders/" + id,
        state: { part: part, open: true, id: id }
      }));
      return __WEBPACK_IMPORTED_MODULE_3__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function cancel(reason) {
  return function (dispatch, getState) {
    var purchaseOrderID = getState().purchaseOrderDetail.getIn(["purchaseOrder", "id"]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].purchaseOrders.cancel(purchaseOrderID, reason).then(function () {
      refreshPurchaseOrderAndLineItems(dispatch, purchaseOrderID);
      return Promise.resolve();
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__["toastr"].error("Error", __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(error, "errors.base[0]"), error.message);
    });
  };
}

function approve() {
  return function (dispatch, getState) {
    var purchaseOrderID = getPurchaseOrderDetailId(getState);
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].purchaseOrders.update(purchaseOrderID, { approved: true }).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_10__actionTypes__["a" /* SET */],
        purchaseOrder: resp.data
      });
      return __WEBPACK_IMPORTED_MODULE_3__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function setTraceHold(val) {
  return function (dispatch, getState) {
    var purchaseOrderID = getPurchaseOrderDetailId(getState);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].purchaseOrders.setTraceHold(purchaseOrderID, val).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_10__actionTypes__["a" /* SET */],
        purchaseOrder: resp.data
      });

      __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__["toastr"].success("Success", val ? "Approved Trace Hold" : "Rejected Trace Hold, Notification has been sent to Buyer.");

      return __WEBPACK_IMPORTED_MODULE_3__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function show(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].purchaseOrders.show(id).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_10__actionTypes__["a" /* SET */],
        purchaseOrder: resp.data
      });
    });
  };
}

function update(data) {
  return function (dispatch, getState) {
    var purchaseOrderID = getState().purchaseOrderDetail.getIn(["purchaseOrder", __WEBPACK_IMPORTED_MODULE_8__constants__["b" /* ID */]]);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__parts_components_Detail_PurchaseOrders_Create_Create__["a" /* modifyFormDataForContact */])(data);

    if (data.shipping_type && data.shipping_type !== __WEBPACK_IMPORTED_MODULE_7__constants__["d" /* DO_NOT_SHIP */]) {
      __WEBPACK_IMPORTED_MODULE_7__constants__["e" /* DO_NOT_SHIP_REASONS */].forEach(function (field) {
        data[field] = false;
      });
    }

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].purchaseOrders.update(purchaseOrderID, data).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_10__actionTypes__["a" /* SET */],
        purchaseOrder: resp.data
      });
      dispatch(__WEBPACK_IMPORTED_MODULE_11__pagination__["a" /* purchaseOrderLineItems */].pageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_3__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function updateQcStatus(data) {
  return function (dispatch, getState) {
    var purchaseOrderID = getState().purchaseOrderDetail.getIn(["purchaseOrder", "id"]);
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].purchaseOrders.updateQcStatus(purchaseOrderID, data).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_10__actionTypes__["a" /* SET */],
        purchaseOrder: resp.data
      });
      dispatch(__WEBPACK_IMPORTED_MODULE_11__pagination__["a" /* purchaseOrderLineItems */].pageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_3__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function bulkUpdateLineItems(data) {
  return function (dispatch, getState) {
    var purchaseOrderID = getState().purchaseOrderDetail.getIn(["purchaseOrder", "id"]);
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].purchaseOrders.lineItems.bulkUpdate(purchaseOrderID, data).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_10__actionTypes__["a" /* SET */],
        purchaseOrder: resp.data
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__pagination__["b" /* expireReceivedCores */])());
      dispatch(__WEBPACK_IMPORTED_MODULE_11__pagination__["a" /* purchaseOrderLineItems */].pageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_3__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

var searchLineItems = function searchLineItems(pageInfo) {
  return function (dispatch, getState) {
    var results = getState().purchaseOrderDetail.getIn(["purchaseOrder", "line_items"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])()).toJS();
    var _pageInfo$query = pageInfo.query,
        limit = _pageInfo$query.limit,
        page = _pageInfo$query.page;

    var data = {
      total_count: results.length,
      results: results.slice(limit * page - limit, page * limit)
    };

    return Promise.resolve({ data: data });
  };
};

function addLineItem(values, purchaseOrderId, afterCreate) {
  return function (dispatch, getState) {
    var poId = purchaseOrderId || getState().purchaseOrderDetail.getIn(["purchaseOrder", "id"]);

    if (!values.purchase_for_sale) {
      values.reserve_for_seller_id = null;
    }

    if (values.displayCoBuyerFields) {
      values.add_co_buyer = true;
    }

    if (values.displayThirdBuyerFields) {
      values.add_third_buyer = true;
    }

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].purchaseOrders.lineItems.create(poId, values).then(function () {
      if (afterCreate) {
        afterCreate();
      } else {
        refreshPurchaseOrderAndLineItems(dispatch, poId);
      }
      return __WEBPACK_IMPORTED_MODULE_3__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function updateLineItem(lineItemId, values) {
  return function (dispatch, getState) {
    var purchaseOrderID = getState().purchaseOrderDetail.getIn(["purchaseOrder", "id"]);

    if (!values.purchase_for_sale && values.reserve_for_seller_id) {
      values.reserve_for_seller_id = null;
    }

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].purchaseOrders.lineItems.update(lineItemId, values).then(function () {
      refreshPurchaseOrderAndLineItems(dispatch, purchaseOrderID);
      return __WEBPACK_IMPORTED_MODULE_3__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function searchAlternates(partId) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.alternates.search(partId, { page: 1, limit: 10 }).then(function (resp) {
      return resp.data.results;
    });
  };
}

function searchBuyers(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].users.search({ active: true, filter: filter, page: 1, limit: 10 }).then(function (resp) {
      return Promise.resolve(resp.data.results);
    });
  };
}

function searchCompanies(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].companies.search({
      cached: true,
      filter: filter,
      status: [__WEBPACK_IMPORTED_MODULE_5__companies_constants__["c" /* ACTIVE */], __WEBPACK_IMPORTED_MODULE_5__companies_constants__["b" /* NO_BIZ */], __WEBPACK_IMPORTED_MODULE_5__companies_constants__["d" /* CREDIT_HOLD */]].join(","),
      sort: "name",
      reverse: false,
      page: 1,
      limit: 20
    }).then(function (resp) {
      return Promise.resolve(resp.data.results);
    });
  };
}

function searchRepairStations(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].companies.search({
      filter: filter,
      repair_station: true,
      page: 1,
      limit: 10
    }).then(function (resp) {
      return Promise.resolve(resp.data.results);
    });
  };
}

function sync() {
  return function (dispatch, getState) {
    var purchaseOrderID = getState().purchaseOrderDetail.getIn(["purchaseOrder", "id"]);
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].purchaseOrders.sync(purchaseOrderID).then(function () {
      __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__["toastr"].success("SUCCESS", "Successfully Synced.");

      return __WEBPACK_IMPORTED_MODULE_3__lib_submission_constants__["a" /* SUCCESS */];
    }).catch(function (response) {
      __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__["toastr"].error("ERROR", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(response, "errors", "Sync Failed"));
    });
  };
}

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(3220);
var objectAssign = __webpack_require__(391);
var decodeComponent = __webpack_require__(2723);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_formatters_text__ = __webpack_require__(11);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return AIRCRAFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return APU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ENGINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return LANDING_GEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return OTHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AMOUNT_PAID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return COST_SPLIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return COST_SPLIT_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return INVOICE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return INVOICE_DUE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return INVOICE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return INVOICE_PAID_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return LOT_CODE; });
/* unused harmony export LOT_PO_NUMBER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LOT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return LOT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return LOT_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOT_LINE_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return LOT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return LOT_LINE_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MANAGED_REPAIR_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ORIGINAL_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PORTAL_PURCHASE; });
/* unused harmony export REFERENCE_NUMBER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHIP_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return AS_IS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ATTACHMENT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LOT_TYPES; });
var _LOT_TYPES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var AIRCRAFT = "aircraft";
var APU = "apu";
var ENGINE = "engine";
var LANDING_GEAR = "landing_gear";
var OTHER = "other";

var AMOUNT_PAID = "amount_paid";
var COST_SPLIT = "cost_split";
var COST_SPLIT_LABEL = "Applied Cost Perc. (%)";
var INVOICE_DATE = "invoice_date";
var INVOICE_DUE_DATE = "invoice_due_date";
var INVOICE_NUMBER = "invoice_number";
var INVOICE_PAID_DATE = "invoice_paid_date";
var LOT_CODE = "lot_code";
var LOT_PO_NUMBER = "lot_po_number";
var LOT_TYPE = "lot_type";
var LOT_NAME = "lot_name";
var LOT_PRICE = "lot_price";
var LOT = "lot";
var LOT_LINE_ITEM = "lot_line_item";
var LOT_ID = "lot_id";
var LOT_LINE_ITEMS = "lot_line_items";
var MANAGED_REPAIR_ORDER = "mro";
var ORIGINAL_COST = "original_cost";
var PORTAL_PURCHASE = "portal_purchase";
var REFERENCE_NUMBER = "reference_number";
var SHIP_DATE = "ship_date";
var AS_IS = "as_is";

var ATTACHMENT_TYPES = {
  vendor_correspondence: {
    label: "Vendor Correspondence"
  },
  traceability: {
    label: "Traceability"
  },
  tag_copies: {
    label: "Tag Copies"
  },
  packing_slip: {
    label: "Packing Slip"
  },
  photos: {
    label: "Photos"
  },
  external_link: {
    label: "External Link"
  },
  end_user_agreement: {
    label: "End User Agreement"
  }
};

var LOT_TYPES = (_LOT_TYPES = {}, _defineProperty(_LOT_TYPES, AIRCRAFT, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_formatters_text__["c" /* properCase */])(AIRCRAFT),
  value: AIRCRAFT
}), _defineProperty(_LOT_TYPES, APU, {
  label: APU.toUpperCase(),
  value: APU
}), _defineProperty(_LOT_TYPES, ENGINE, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_formatters_text__["c" /* properCase */])(ENGINE),
  value: ENGINE
}), _defineProperty(_LOT_TYPES, LANDING_GEAR, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_formatters_text__["c" /* properCase */])(LANDING_GEAR),
  value: LANDING_GEAR
}), _defineProperty(_LOT_TYPES, OTHER, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_formatters_text__["c" /* properCase */])(OTHER),
  value: OTHER
}), _LOT_TYPES);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AuditedNoteTooltip__ = __webpack_require__(104);
/* unused harmony reexport AuditedNoteTooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NoteTooltip__ = __webpack_require__(120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__NoteTooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NoteTooltipTableCell__ = __webpack_require__(800);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__NoteTooltipTableCell__["a"]; });







/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_recordCollector__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_search__ = __webpack_require__(475);
/* harmony export (immutable) */ __webpack_exports__["b"] = paginationGroup;
/* harmony export (immutable) */ __webpack_exports__["a"] = createPaginatedList;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





function fetchList(list, getId) {
  return function (_ref) {
    var query = _ref.query;
    return function (_, getState) {
      var id = getId(getState());

      if (list.collect) {
        var endpoint = function endpoint(page, limit) {
          return list.api(id, _extends({}, query, { page: page, limit: limit }));
        };

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_recordCollector__["a" /* default */])(endpoint).then(function (results) {
          return {
            data: {
              results: results,
              total_count: results.length
            }
          };
        });
      }

      return list.api(id, query);
    };
  };
}

function paginationGroup(_ref2) {
  var groupName = _ref2.groupName,
      getId = _ref2.getId,
      locate = _ref2.locate;

  for (var _len = arguments.length, definitions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    definitions[_key - 1] = arguments[_key];
  }

  return definitions.map(function (def) {
    var key = def.key,
        _def$settings = def.settings,
        settings = _def$settings === undefined ? {} : _def$settings;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["createPaginator"])(_extends({
      listId: groupName + "/" + key,
      fetch: fetchList(def, getId),
      locator: locate(def),
      maxPages: 15
    }, settings));
  });
}

function debounce(asyncAction) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

  var timer = null;

  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    clearTimeout(timer);

    return function (dispatch) {
      return new Promise(function (resolve) {
        timer = setTimeout(function () {
          resolve(dispatch(asyncAction.apply(undefined, args)));
        }, ms);
      });
    };
  };
}

function createPaginatedList(options) {
  var listId = options.listId,
      fetch = options.fetch,
      stateLocator = options.stateLocator,
      forceDebounce = options.forceDebounce,
      paginatorOptions = _objectWithoutProperties(options, ["listId", "fetch", "stateLocator", "forceDebounce"]);

  var listSearch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions_search__["a" /* default */])(listId, fetch, stateLocator);

  var search = forceDebounce ? debounce(listSearch.search) : listSearch.search;

  return _extends({}, listSearch, {
    paginator: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["createPaginator"])(_extends({
      listId: listId,
      fetch: search,
      locator: listSearch.stateLocator
    }, paginatorOptions))
  });
}

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 69 */,
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Nav_SaleOrdersCart_actions__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actionTypes__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pagination__ = __webpack_require__(330);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reservedForSaleInventoryActions; });
/* unused harmony export reservedForSaleSearch */
/* unused harmony export setReservedFilter */
/* unused harmony export set */
/* unused harmony export setSalesOrderWithAllLineItems */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return expireLineItems; });
/* harmony export (immutable) */ __webpack_exports__["c"] = fetch;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchSalesOrderWithAllLineItems;
/* harmony export (immutable) */ __webpack_exports__["p"] = bulkUpdateLineItems;
/* harmony export (immutable) */ __webpack_exports__["d"] = update;
/* harmony export (immutable) */ __webpack_exports__["f"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["q"] = addItemToCartAndRefreshList;
/* harmony export (immutable) */ __webpack_exports__["t"] = convertSo;
/* harmony export (immutable) */ __webpack_exports__["r"] = convertDummySo;
/* harmony export (immutable) */ __webpack_exports__["h"] = createCustomerRma;
/* harmony export (immutable) */ __webpack_exports__["l"] = createOutrightSale;
/* harmony export (immutable) */ __webpack_exports__["m"] = updateLineItem;
/* harmony export (immutable) */ __webpack_exports__["j"] = convertToExchange;
/* harmony export (immutable) */ __webpack_exports__["k"] = createInternalOutrightSale;
/* harmony export (immutable) */ __webpack_exports__["g"] = soCancellationReversal;
/* harmony export (immutable) */ __webpack_exports__["s"] = validateContact;
/* harmony export (immutable) */ __webpack_exports__["o"] = sync;
/* harmony export (immutable) */ __webpack_exports__["n"] = syncCoreRepairCharges;
/* harmony export (immutable) */ __webpack_exports__["i"] = exchange;











var reservedForSaleInventoryActions = __WEBPACK_IMPORTED_MODULE_9__pagination__["a" /* reservedForSaleInventory */].pageActions,
    reservedForSaleSearch = __WEBPACK_IMPORTED_MODULE_9__pagination__["a" /* reservedForSaleInventory */].search,
    setReservedFilter = __WEBPACK_IMPORTED_MODULE_9__pagination__["a" /* reservedForSaleInventory */].setFilter;



function set(salesOrder) {
  return { type: __WEBPACK_IMPORTED_MODULE_8__actionTypes__["a" /* SET */], salesOrder: salesOrder };
}

function setSalesOrderWithAllLineItems(salesOrderWithAllLineItems) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_8__actionTypes__["b" /* SET_SALES_ORDER_WITH_ALL_LINE_ITEMS */],
    salesOrderWithAllLineItems: salesOrderWithAllLineItems
  };
}

var expireLineItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__["composables"])({
  listId: "salesOrders/lineItems"
}).expire;

function fetch(id, presenter) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.show(id, presenter).then(function (_ref) {
      var data = _ref.data;

      dispatch(set(data));
      dispatch(expireLineItems());
      return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function fetchSalesOrderWithAllLineItems(id, cached) {
  return function (dispatch) {
    if (cached) {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.cachedShow(id).then(function (_ref2) {
        var data = _ref2.data;

        dispatch(setSalesOrderWithAllLineItems(data));
        return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
      });
    }
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.show(id).then(function (_ref3) {
      var data = _ref3.data;

      dispatch(setSalesOrderWithAllLineItems(data));
      return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function bulkUpdateLineItems(data) {
  return function (dispatch, getState) {
    var salesOrderID = getState().salesOrderDetail.getIn(["salesOrder", "id"]);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.lineItems.bulkUpdate(salesOrderID, data).then(function (_ref4) {
      var salesOrder = _ref4.data;

      dispatch(set(salesOrder));
      dispatch(setSalesOrderWithAllLineItems(salesOrder));
      dispatch(expireLineItems());
      return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function update(data) {
  return function (dispatch, getState) {
    var id = getState().salesOrderDetail.getIn(["salesOrder", "id"]);

    if (data.contact_id === "Add") {
      data.contact_id = null;
    }

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.update(id, data).then(function (_ref5) {
      var salesOrder = _ref5.data;

      dispatch(set(salesOrder));
      dispatch(expireLineItems());
      dispatch(fetchSalesOrderWithAllLineItems(id));
      return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function cancel(id, params, close) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.cancel(id, params).then(function (_ref6) {
      var data = _ref6.data;

      dispatch(set(data));
      dispatch(expireLineItems());
      if (close) close();

      return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function addItemToCartAndRefreshList(id) {
  return function (dispatch) {
    var addItem = function addItem() {
      return new Promise(function (resolve, __) {
        resolve(dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__Nav_SaleOrdersCart_actions__["a" /* create */])(id)));
      });
    };

    addItem().then(function () {
      dispatch(reservedForSaleInventoryActions.expire());
    });
  };
}

function convertSo(data) {
  return function (dispatch) {
    if (data.contact_id === "Add") {
      data.contact_id = null;
    }
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.convert(data).then(function (resp) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["push"])({ pathname: "/sales-orders/" + resp.data.uuid }));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__session_actions__["refreshCarts"])());
      return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function convertDummySo(data) {
  return function (dispatch) {
    if (data.contact_id === "Add") {
      data.contact_id = null;
    }
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.convertWithDummy(data).then(function (resp) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["push"])({ pathname: "/sales-orders/" + resp.data.uuid }));
      return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function createCustomerRma(id, data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.lineItems.customerRmas.create(id, data).then(function (resp) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["push"])({ pathname: "/rmas/" + resp.data.id }));
      return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function createOutrightSale(id, data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.lineItems.outrightSale(id, data).then(function (resp) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["push"])({ pathname: "/sales-orders/" + resp.data.sales_order_id }));
      return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function updateLineItem(id, data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.lineItems.update(id, data).then(function (resp) {
      dispatch(fetch(resp.data.sales_order_id));
      return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function convertToExchange(id, data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.lineItems.convertToExchange(id, data).then(function (resp) {
      dispatch(set(resp.data));
      dispatch(expireLineItems());
      return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function createInternalOutrightSale(id, data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.lineItems.internalOutrightSale(id, data).then(function (resp) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["push"])({ pathname: "/sales-orders/" + resp.data.sales_order_id }));
      return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function soCancellationReversal(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.cancellationReversal(id).then(function (_ref7) {
      var data = _ref7.data;

      dispatch(set(data));
      dispatch(expireLineItems());
      return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function validateContact(_ref8) {
  var _ref8$contact = _ref8.contact,
      contact = _ref8$contact === undefined ? {} : _ref8$contact,
      companyId = _ref8.company_id,
      _ref8$contact_id = _ref8.contact_id,
      contactId = _ref8$contact_id === undefined ? null : _ref8$contact_id;
  var email = contact.email;


  if (email && contactId === "Add" && companyId) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].companies.contacts.search(companyId, { email: email }).then(function (resp) {
      if (resp.data.total_count > 0) {
        var errors = {
          contact: {
            email: ["Already Exists For Customer"]
          }
        };

        throw errors;
      }
    });
  }
  return Promise.resolve();
}

function sync() {
  return function (dispatch, getState) {
    var id = getState().salesOrderDetail.getIn(["salesOrder", "id"]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.sync(id).then(function () {
      __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].success("SUCCESS", "Successfully Synced.");
      dispatch(fetchSalesOrderWithAllLineItems(id, false));
      return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
    }).catch(function (response) {
      __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].error("ERROR", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(response, "errors", "Sync Failed"));
    });
  };
}

function syncCoreRepairCharges() {
  return function (dispatch, getState) {
    var id = getState().salesOrderDetail.getIn(["salesOrder", "id"]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.syncCoreRepairCharges(id).then(function () {
      __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].success("SUCCESS", "Successfully Synced.");
      dispatch(fetchSalesOrderWithAllLineItems(id, false));
      return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
    }).catch(function (response) {
      __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].error("ERROR", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(response, "errors", "Sync Failed"));
    });
  };
}

function exchange(lineItem, params) {
  return function (dispatch) {
    var exchangePromise = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].salesOrders.lineItems.exchange(lineItem.id, params);

    exchangePromise.then(function (_ref9) {
      var data = _ref9.data;

      // Extract salesOrderId based on the provided criteria
      var salesOrderId = void 0;
      if (data.third_exchange_item) {
        salesOrderId = data.third_exchange_item.id;
      } else if (data.second_exchange_item) {
        salesOrderId = data.second_exchange_item.id;
      }

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["push"])({ pathname: "/sales-orders/" + salesOrderId }));

      return __WEBPACK_IMPORTED_MODULE_5__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(273);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["t"]; });


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = roundUp;
/* harmony export (immutable) */ __webpack_exports__["c"] = displayDecimal;
/* harmony export (immutable) */ __webpack_exports__["e"] = displayInt;
/* harmony export (immutable) */ __webpack_exports__["f"] = displayFloat;
/* harmony export (immutable) */ __webpack_exports__["a"] = percent;
/* harmony export (immutable) */ __webpack_exports__["d"] = decimalField;
function roundUp(num, precision) {
  if (num === null) {
    return null;
  }
  return Math.ceil(num * precision) / precision;
}

function displayDecimal(num, precision) {
  if (num === null) {
    return null;
  }
  return parseFloat(Math.round(num * precision) / precision);
}

function displayInt(int) {
  return int && int.toFixed(0) || 0;
}

function displayFloat(float) {
  return float && float.toFixed(2) || 0;
}

function percent(int, total) {
  if (int === 0) return "0%";
  if (!int) return null;
  return (int / total * 100).toFixed(0) + "%";
}

function decimalField(val) {
  if (!val) return val;
  if (!val.includes(".")) return val;

  return displayFloat(parseFloat(val));
}

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DHL */
/* unused harmony export FEDEX */
/* unused harmony export UPS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OTHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TBD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INTERNAL_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NOTE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DEFAULT_CARRIERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CARRIERS; });
var _CARRIERS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DHL = "dhl";
var FEDEX = "fedex";
var UPS = "ups";
var OTHER = "other";
var TBD = "tbd";

var NOTE = "note";
var INTERNAL_NOTE = "internal_note";
var NOTE_TYPE = "note_type";

var DEFAULT_CARRIERS = [FEDEX, UPS, DHL];

var CARRIERS = (_CARRIERS = {}, _defineProperty(_CARRIERS, DHL, {
  label: "DHL",
  shippingMethods: {
    dhl_express: { label: "DHL Express" },
    envelope: { label: "Envelope", deprecated: true },
    express_worldwide: { label: "Express Worldwide" },
    standard: { label: "Standard", deprecated: true },
    dhl_domestic_express: {
      label: "DHL Domestic Express-by 6pm (within Ireland only)"
    }
  }
}), _defineProperty(_CARRIERS, FEDEX, {
  label: "FedEx",
  shippingMethods: {
    "1_day_freight": { label: "1-Day Freight" },
    "1_day_freight_over_150_lbs": {
      label: "1-Day Freight (over 150 lbs.)",
      deprecated: true
    },
    "1_day_priority_overnight": {
      label: "1 Day Priority Overnight (By 10AM)",
      deprecated: true
    },
    "1_day_standard_overnight": {
      label: "1 Day Standard Overnight (By 5PM)",
      deprecated: true
    },
    "2_day": { label: "2-Day" },
    "2_day_air_am": { label: "2-Day AM" },
    "2_day_economy": { label: "2 Day Economy", deprecated: true },
    "2_day_freight": { label: "2-Day Freight" },
    "2_day_freight_over_150_lbs": {
      label: "2-Day Freight (over 150 lbs.)",
      deprecated: true
    },
    "3_day_express_saver": { label: "3-Day Express Saver" },
    "3_day_freight": { label: "3-Day Freight" },
    "3_day_freight_over_150_lbs": {
      label: "3-Day Freight (over 150 lbs.)",
      deprecated: true
    },
    express_envelope: { label: "Express (Envelope)", deprecated: true },
    first_overnight: { label: "First Overnight" },
    first_overnight_freight: { label: "First Overnight Freight" },
    freight_economy_ltl: { label: "Freight® Economy LTL" },
    freight_priority_ltl: { label: "Freight® Priority LTL" },
    ground: { label: "Ground" },
    international_ground: { label: "International Ground" },
    international_economy_freight: {
      label: "International Economy Freight"
    },
    international_first: { label: "International First" },
    international_freight: { label: "International Priority Freight" },
    intl_economy: {
      label: "International Economy"
    },
    intl_priority: {
      label: "International Priority"
    },
    intl_standard: {
      label: "Intl Standard [only valid when shipping outside of U.S.]",
      deprecated: true
    },
    priority_overnight: { label: "Priority Overnight" },
    saturday_delivery: { label: "Saturday Delivery" },
    standard_overnight: { label: "Standard Overnight" }
  }
}), _defineProperty(_CARRIERS, UPS, {
  label: "UPS",
  shippingMethods: {
    "2nd_day_air_am": { label: "2nd Day Air AM" },
    "2nd_day_air": { label: "2nd Day Air" },
    "2nd_day_air_freight_g": { label: "2nd Day Air Freight Guaranteed" },
    "2nd_day_air_freight_ngs": {
      label: "2nd Day Air Freight Non-Guaranteed"
    },
    "2nd_day_air_standard": {
      label: "2nd Day Air Standard (by end-of-day)",
      deprecated: true
    },
    "3rd_day_air_freight_g": { label: "3rd Day Air Freight Guaranteed" },
    "3rd_day_air_freight_ngs": {
      label: "3rd Day Air Freight Non-Guaranteed"
    },
    "3rd_day_select": { label: "3 Day Select" },
    air_freight_premium_direct: { label: "Air Freight Premium Direct" },
    air_freight_direct: { label: "Air Freight Direct" },
    air_freight_consolidated: { label: "Air Freight Consolidated" },
    express_saver: {
      label: "Express Saver"
    },
    freight_LTL: { label: "Freight LTL" },
    freight_LTL_g: { label: "Freight LTL Guaranteed" },
    freight_LTL_g_am: { label: "Freight LTL Guaranteed AM" },
    ground: { label: "Ground" },
    intl_express_freight_ltl_g: {
      label: "Intl Express Freight LTL Guaranteed",
      deprecated: true
    },
    intl_express_freight_ltl_ngs: {
      label: "Intl Express Freight  LTL Non-Guaranteed",
      deprecated: true
    },
    next_day_air_early_am: { label: "Next Day Air Early" },
    next_day_air: { label: "Next Day Air" },
    next_day_air_freight_g: { label: "Next Day Air Freight Guaranteed" },
    next_day_air_freight_ngs: {
      label: "Next Day Air Freight Non-Guaranteed"
    },
    next_day_air_saver: {
      label: "Next Day Air Saver"
    },
    next_day_air_standard: {
      label: "Next Day Air Standard (by Noon)",
      deprecated: true
    },
    saturday_delivery: {
      label: "Saturday Delivery"
    },
    standard: {
      label: "Standard"
    },
    standard_ground_to_ca: {
      label: "Standard Ground to Canada (by end-of-day)",
      deprecated: true
    },
    worldwide_expedited: {
      label: "Worldwide Expedited"
    },
    worldwide_express: {
      label: "Worldwide Express"
    },
    worldwide_express_plus: {
      label: "Worldwide Express Plus"
    },
    worldwide_express_std: {
      label: "Worldwide Express Std",
      deprecated: true
    },
    worldwide_saver: {
      label: "Worldwide Saver",
      deprecated: true
    },
    worldwide_express_freight_midday: {
      label: "Worldwide Express Freight Midday"
    },
    worldwide_express_freight: {
      label: "Worldwide Express Freight"
    },
    worldwide_saver_express: {
      label: "Worldwide Saver (Express)"
    }
  }
}), _defineProperty(_CARRIERS, TBD, {
  label: "TBD",
  shippingMethods: {
    dim_weight: {
      label: "TBD"
    }
  }
}), _defineProperty(_CARRIERS, OTHER, {
  label: "Other",
  shippingMethods: {
    courier_pick_up_lazer_ship: { label: "Courier Pick-Up - Lazer Ship" },
    courier_pick_up_sterling: { label: "Courier Pick-Up - Sterling" },
    courier_pick_up_unknown: { label: "Courier Pick-Up - Unknown" },
    hand_delivery: { label: "Hand Delivery" },
    no_charge: { label: "No Freight Charge - Customer to Pay" },
    other: { label: "Other" },
    release_ownership_at_shop: { label: "Release Ownership At Shop" },
    will_call: { label: "Will Call - Customer Pick-Up" }
  }
}), _CARRIERS);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgnosticLoader__ = __webpack_require__(2411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__AgnosticLoader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RecordLoader__ = __webpack_require__(2420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__RecordLoader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Toggle__ = __webpack_require__(2421);
/* unused harmony reexport Toggle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dismissible__ = __webpack_require__(2416);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Dismissible__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DataTable__ = __webpack_require__(2414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__DataTable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ToggleSwitch__ = __webpack_require__(2422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__ToggleSwitch__["a"]; });







/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchesBoolean;
/* harmony export (immutable) */ __webpack_exports__["b"] = matchesString;
/* harmony export (immutable) */ __webpack_exports__["c"] = matchesInt;
/* unused harmony export includesVal */
function matchesBoolean(matchValue) {
  return function (val) {
    return val !== undefined && val.toString() === matchValue.toString();
  };
}

function matchesString(matchValue) {
  return function (val) {
    return val === matchValue;
  };
}

function matchesInt(matchValue) {
  return function (val) {
    return val === matchValue;
  };
}

function includesVal(matchValue) {
  return function (val) {
    return val && val.includes(matchValue);
  };
}

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CUSTOMER_RMA_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return VENDOR_RMA_TYPE; });
/* unused harmony export APPROVED_STATUS */
/* unused harmony export DENIED_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return COST_ADJUSTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CHARGE_NO_FAULT_FOUND_FEE; });
/* unused harmony export CREDIT_AMOUNT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CREDIT_DENIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CREDIT_ISSUED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREDIT_REQUESTED; });
/* unused harmony export CUSTOMER_RMAS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CUSTOMER_RMA_CREDIT_AMOUNT; });
/* unused harmony export FULL_CREDIT_AMOUNT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FULL_CREDIT_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return NO_FAULT_FOUND_FEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return NO_FAULT_FOUND_FEE_INVOICED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return WARRANTY_CHARGES_INVOICED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return WARRANTY_CONSIDERATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return WARRANTY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return VENDOR_RMA_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VENDOR_WARRANTY_AMOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VENDOR_WARRANTY_AMOUNT_PAID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REPAIR_STATION_WARRANTY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return WARRANTY_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ATTACHMENT_TYPES; });
/* unused harmony export RECORD_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REASONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CUSTOMER_RMA_REASONS; });
/* unused harmony export CANCELLATION_REASONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return PARTIAL_CREDIT_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PARTIAL_CREDIT_AMT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return PARTIAL_CREDIT_ACCEPTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PARTIAL_CREDIT_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return PARTIAL_CREDIT_DENIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return PARTIAL_CREDIT_CLOSED_BEFORE_REPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return PARTIAL_CREDIT_STATUSES; });
var _WARRANTY_STATUSES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CUSTOMER_RMA_TYPE = "CustomerRma";
var VENDOR_RMA_TYPE = "VendorRma";
var APPROVED_STATUS = "approved";
var DENIED_STATUS = "denied";

var COST_ADJUSTMENT = "cost_adjustment";
var CHARGE_NO_FAULT_FOUND_FEE = "charge_no_fault_found_fee";
var CREDIT_AMOUNT = "credit_amount";
var CREDIT_DENIED = "credit_denied";
var CREDIT_ISSUED = "credit_issued";
var CREDIT_REQUESTED = "credit_requested";
var CUSTOMER_RMAS = "customer_rmas";
var CUSTOMER_RMA_CREDIT_AMOUNT = "customer_rma_credit_amount";
var FULL_CREDIT_AMOUNT = "full_credit_amount";
var FULL_CREDIT_REQUESTED = "full_credit_requested";
var NO_FAULT_FOUND_FEE = "no_fault_found_fee";
var NO_FAULT_FOUND_FEE_INVOICED = "no_fault_found_fee_invoiced";
var WARRANTY_CHARGES_INVOICED = "warranty_charges_invoiced";
var WARRANTY_CONSIDERATION = "warranty_consideration";
var WARRANTY_STATUS = "warranty_status";
var VENDOR_RMA_NUMBER = "vendor_rma_number";
var VENDOR_WARRANTY_AMOUNT = "vendor_warranty_amount";
var VENDOR_WARRANTY_AMOUNT_PAID = "vendor_warranty_amount_paid";
var REPAIR_STATION_WARRANTY_STATUS = "repair_station_warranty_status";

var WARRANTY_STATUSES = (_WARRANTY_STATUSES = {}, _defineProperty(_WARRANTY_STATUSES, APPROVED_STATUS, {
  label: "Approved"
}), _defineProperty(_WARRANTY_STATUSES, DENIED_STATUS, {
  label: "Denied"
}), _WARRANTY_STATUSES);

var ATTACHMENT_TYPES = {
  vendor: {
    vendor_full_credit_request: {
      label: "Vendor Full Credit Request"
    },
    vendor_partial_credit_request: {
      label: "Vendor Partial Credit Request"
    },
    rma_approval_form: {
      label: "RMA Approval Form"
    },
    other: {
      label: "Other"
    }
  },
  customer: {
    customer_rma_approval_form: {
      label: "Customer RMA Approval Form"
    },
    customer_full_credit_request: {
      label: "Customer Full Credit Request"
    },
    customer_partial_credit_request: {
      label: "Customer Partial Credit Request"
    },
    customer_correspondence: {
      label: "Customer Correspondence"
    },
    failure_report: {
      label: "Failure Report"
    },
    other: {
      label: "Other"
    }
  }
};

var RECORD_TYPES = {
  SalesOrder: "SO",
  RepairOrder: "RO"
};

var REASONS = {
  failed_test_or_install: {
    label: "Unit failed at test or install"
  },
  no_longer_required: {
    label: "Unit no longer required"
  },
  wrong_unit_ordered: {
    label: "Wrong unit ordered"
  },
  failed_inspection: {
    label: "Unit failed incoming inspection"
  },
  condition: {
    label: "Unit is rejected due to condition"
  },
  ber_at_shop: {
    label: "BER At Shop"
  },
  vendor_to_send_to_shop: {
    label: "Vendor to send to shop"
  },
  other: {
    label: "Other"
  }
};

var CUSTOMER_RMA_REASONS = {
  failed_test_or_install: {
    label: "Unit failed at test or install"
  },
  no_longer_required: {
    label: "Unit no longer required"
  },
  wrong_unit_ordered: {
    label: "Wrong unit ordered"
  },
  failed_inspection: {
    label: "Unit failed incoming inspection"
  },
  condition: {
    label: "Unit is rejected due to condition"
  },
  cannot_accept_paperwork: {
    label: "Cannot accept paperwork"
  },
  unit_failed_during_operation: {
    label: "Unit failed during operation"
  },
  other: {
    label: "Other"
  }
};

var CANCELLATION_REASONS = [{
  value: "failed_test_or_install",
  text: "Unit failed at test or install"
}, {
  value: "no_longer_required",
  text: "Unit no longer required"
}, {
  value: "wrong_unit_ordered",
  text: "Wrong unit ordered"
}, {
  value: "failed_inspection",
  text: "Unit failed incoming inspection unit is rejected due to condition and we will accept the unit back and stock without sending to the shop."
}, {
  value: "other",
  text: "Other"
}];

var PARTIAL_CREDIT_STATUS = "partial_credit_status";
var PARTIAL_CREDIT_AMT = "partial_credit_amt";
var REQUESTED = "requested";
var PARTIAL_CREDIT_ACCEPTED = "accepted";
var PARTIAL_CREDIT_REQUESTED = "partial_credit_requested";
var PARTIAL_CREDIT_DENIED = "denied";
var PARTIAL_CREDIT_CLOSED_BEFORE_REPLY = "ro_closed_before_vendor_reply";

var PARTIAL_CREDIT_STATUSES = {
  requested: "Requested",
  accepted: "Accepted",
  denied: "Denied",
  ro_closed_before_vendor_reply: "RO Closed Before Vendor Reply"
};

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Warning_Warning__ = __webpack_require__(53);
/* harmony export (immutable) */ __webpack_exports__["a"] = ConfirmAction;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();






function ConfirmAction(_ref) {
  var onConfirm = _ref.onConfirm,
      open = _ref.open,
      close = _ref.close,
      children = _ref.children,
      _ref$warningWrapper = _ref.warningWrapper,
      warningWrapper = _ref$warningWrapper === undefined ? true : _ref$warningWrapper,
      _ref$btnClass = _ref.btnClass,
      btnClass = _ref$btnClass === undefined ? "btn-primary" : _ref$btnClass,
      _ref$btnText = _ref.btnText,
      btnText = _ref$btnText === undefined ? "Okay" : _ref$btnText,
      _ref$showButton = _ref.showButton,
      showButton = _ref$showButton === undefined ? true : _ref$showButton,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === undefined ? "Cancel" : _ref$cancelText,
      _ref$icon = _ref.icon,
      icon = _ref$icon === undefined ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" }) : _ref$icon,
      _ref$message = _ref.message,
      message = _ref$message === undefined ? "Are you sure you want to do this?" : _ref$message,
      _ref$modalSize = _ref.modalSize,
      modalSize = _ref$modalSize === undefined ? "modal-sm" : _ref$modalSize;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      disabled = _useState2[0],
      setDisabled = _useState2[1];

  var confirm = function confirm() {
    setDisabled(true);
    onConfirm();
    close();
    setDisabled(false);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: modalSize },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Are You Sure?"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modal__["e" /* Body */],
      null,
      warningWrapper ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__Warning_Warning__["a" /* default */],
        null,
        children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          " ",
          message
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          " ",
          message
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { type: "button", className: "btn btn-default", onClick: close },
        cancelText
      ),
      showButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: "btn " + btnClass,
          onClick: confirm,
          disabled: disabled
        },
        icon,
        " ",
        btnText
      )
    )
  );
}

ConfirmAction.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  warningWrapper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  btnClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  btnText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cancelText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)]),
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modalSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stringInput", function() { return stringInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "numericInput", function() { return numericInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "boolInput", function() { return boolInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "malleable", function() { return malleable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "objectInput", function() { return objectInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "meta", function() { return meta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modalForm", function() { return modalForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formField", function() { return formField; });


var stringInput = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var numericInput = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var boolInput = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var malleable = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]),
  onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var objectInput = function objectInput(objShape) {
  return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape(objShape),
    onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
  });
};

var meta = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  invalid: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  touched: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  error: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string)
});

var modalForm = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};

var formField = function formField(t) {
  return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    meta: meta,
    input: t
  });
};

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SalesDashboard_constants__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony export (immutable) */ __webpack_exports__["d"] = warrantyForCondition;
/* harmony export (immutable) */ __webpack_exports__["e"] = setLeadTime;
/* harmony export (immutable) */ __webpack_exports__["f"] = setTagDate;
/* harmony export (immutable) */ __webpack_exports__["h"] = setTraceTo;
/* harmony export (immutable) */ __webpack_exports__["g"] = setTraceType;
/* harmony export (immutable) */ __webpack_exports__["q"] = correctSerialText;
/* harmony export (immutable) */ __webpack_exports__["a"] = getPartNumberColorClassNameByTierType;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return transformOQInputValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return transformOQOutputValues; });
/* unused harmony export setOffer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return arrayToOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hasCreditAndWarranty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return rmaIsClosed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return hasWarrantyAndNotCredit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getCreditRequestedWarrantyRmas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getWarrantyAndNotCreditRmas; });
/* harmony export (immutable) */ __webpack_exports__["n"] = setDateLabel;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getCarrierLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getShippingMethod; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











function warrantyForCondition(condition, part, tagDate, inventory) {
  var defaultCondition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks_useCurrentUser__["b" /* useSettings */])()[condition + "_warranty"] || null;
  if ([__WEBPACK_IMPORTED_MODULE_3__inventories_constants__["g" /* NEW_ITEM */], __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["h" /* REPAIRED */], __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["i" /* OVERHAULED */]].includes(condition) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(inventory, __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["j" /* REPAIR_STATUS */]) !== __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["k" /* REPAIR_AND_HOLD */]) {
    var months = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks_useCurrentUser__["b" /* useSettings */])().tag_date_months_for_warranty || null;
    if (months && tagDate && __WEBPACK_IMPORTED_MODULE_0_moment___default()(tagDate).isBefore(__WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(Number(months), "month"))) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks_useCurrentUser__["b" /* useSettings */])().tag_date_warranty;
    }
    // For a nil tagDate or one older than 2 years
    return defaultCondition;
  }

  return defaultCondition;
}

function toString(number) {
  if (!number) return "";
  return String(number);
}

function setLeadTime(inv) {
  if (inv.repair_status === __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["k" /* REPAIR_AND_HOLD */]) {
    return toString(inv.repair_and_hold_lead_time);
  } else if (inv.repair_status === __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["l" /* AT_SHOP */]) {
    return toString(inv.repair_estimated_lead_time);
  } else if (inv.status === __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["m" /* OUT_ON_EXCHANGE */]) {
    return "30";
  }
  return inv.status === "in_stock" ? "0" : null;
}

function setTagDate(inv) {
  if (inv.status === __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["m" /* OUT_ON_EXCHANGE */]) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1, "month").format("YYYY-MM-DD");
  }

  return inv.tag_date;
}

function setTraceTo(inv) {
  if (inv.status === __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["m" /* OUT_ON_EXCHANGE */]) {
    return "";
  }

  return inv.traced_to;
}

function setTraceType(inv) {
  if (inv.status === __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["m" /* OUT_ON_EXCHANGE */]) {
    return "";
  }

  return inv.trace_type;
}

function correctSerialText(inventory) {
  return "Please reidentify Serial # " + inventory.serial_number + ". The correct Serial # appears to be " + inventory.correct_serial_number;
}

function getPartNumberColorClassNameByTierType(tierType) {
  return __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
    "text-light-purple": tierType === __WEBPACK_IMPORTED_MODULE_4__parts_constants__["b" /* SATL */],
    "text-green": tierType === __WEBPACK_IMPORTED_MODULE_4__parts_constants__["c" /* ATL */],
    "text-teal": tierType === __WEBPACK_IMPORTED_MODULE_4__parts_constants__["d" /* ZTL */],
    "text-yellow": tierType === __WEBPACK_IMPORTED_MODULE_4__parts_constants__["e" /* BTL */],
    "text-red": tierType === __WEBPACK_IMPORTED_MODULE_4__parts_constants__["f" /* BBTL */]
  });
}

var transformOQInputValues = function transformOQInputValues(lineItem) {
  return Object.assign({}, lineItem, {
    offer: setOffer(lineItem),
    other: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(lineItem.other_tag_type)
  });
};

var transformOQOutputValues = function transformOQOutputValues(lineItem) {
  return Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["omit"])(lineItem, ["offer"]), {
    no_interest: lineItem.offer === "no_interest",
    looking_for: lineItem.offer === "looking_for"
  });
};

function setOffer(lineItem) {
  if (lineItem.no_interest) {
    return "no_interest";
  } else if (lineItem.looking_for) {
    return "looking_for";
  }
  return "";
}

var arrayToOptions = function arrayToOptions(array) {
  return array.reduce(function (acc, field) {
    return _extends({}, acc, _defineProperty({}, field, { label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(field), value: field }));
  }, {});
};

var hasCreditAndWarranty = function hasCreditAndWarranty(inv) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(inv, path + ".credit_requested") && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(inv, path + ".warranty_consideration");
};

var rmaIsClosed = function rmaIsClosed(inv) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(inv, path) && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(inv, path + ".closed_date");
};

var hasWarrantyAndNotCredit = function hasWarrantyAndNotCredit(inv) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return !__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(inv, path + ".credit_requested") && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(inv, path + ".warranty_consideration");
};

var getCreditRequestedWarrantyRmas = function getCreditRequestedWarrantyRmas(lineItems) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return lineItems.filter(function (inv) {
    return hasCreditAndWarranty(inv, path);
  });
};

var getWarrantyAndNotCreditRmas = function getWarrantyAndNotCreditRmas(lineItems) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return lineItems.filter(function (inv) {
    return hasWarrantyAndNotCredit(inv, path);
  });
};

function setDateLabel(startDate, endDate, label) {
  if (!startDate && !endDate) return null;
  return label === __WEBPACK_IMPORTED_MODULE_6__SalesDashboard_constants__["a" /* CUSTOM_RANGE */] || label === undefined ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate).format("MMMM DD YYYY") + " " + ("- " + __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate).format("MMMM DD YYYY")) : label;
}

var getCarrierLabel = function getCarrierLabel(carrier) {
  return __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* CARRIERS */][carrier].label;
};

var getShippingMethod = function getShippingMethod(carrier, shippingMethod) {
  return __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* CARRIERS */][carrier].shippingMethods[shippingMethod].label;
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(576);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(369)('wks');
var uid = __webpack_require__(228);
var Symbol = __webpack_require__(60).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DetailTable__ = __webpack_require__(776);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DetailTable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Detail__ = __webpack_require__(152);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Detail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CheckForDetail__ = __webpack_require__(485);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__CheckForDetail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SpecialInstructions__ = __webpack_require__(2290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__SpecialInstructions__["a"]; });









/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DROPSHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REPAIR_STATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TENANT_LOCATION; });
/* unused harmony export SHIPPING_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return shipToOptions; });
var CUSTOMER = "customer";
var COMPANY = "company";
var DROPSHIP = "dropship";
var REPAIR_STATION = "repair_station";
var TENANT_LOCATION = "tenant_location";

var SHIPPING_TYPES = [CUSTOMER, COMPANY, DROPSHIP, REPAIR_STATION];

var shipToOptions = [{
  text: "Customer Physical Address",
  value: CUSTOMER
}, {
  text: "Company",
  value: COMPANY
}, {
  text: "Other",
  value: DROPSHIP
}];

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Nav_RepairOrdersCart_actions__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actionTypes__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pagination__ = __webpack_require__(272);
/* unused harmony export search */
/* unused harmony export setFilter */
/* unused harmony export pageActions */
/* unused harmony export expireLineItems */
/* unused harmony export lineItemsPageActions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reservedForRepairInventoryActions; });
/* unused harmony export reservedForRepairSearch */
/* unused harmony export setReservedFilter */
/* harmony export (immutable) */ __webpack_exports__["f"] = searchOpenRO;
/* harmony export (immutable) */ __webpack_exports__["e"] = getLineItems;
/* harmony export (immutable) */ __webpack_exports__["u"] = addItemToCartAndRefreshList;
/* harmony export (immutable) */ __webpack_exports__["d"] = createROLineItem;
/* harmony export (immutable) */ __webpack_exports__["i"] = cancelROLineItem;
/* harmony export (immutable) */ __webpack_exports__["o"] = removeMainComponent;
/* harmony export (immutable) */ __webpack_exports__["m"] = requestVendorRma;
/* harmony export (immutable) */ __webpack_exports__["k"] = deleteExpectedComponent;
/* harmony export (immutable) */ __webpack_exports__["j"] = cancelRequestVendorRma;
/* unused harmony export approveROLineItem */
/* harmony export (immutable) */ __webpack_exports__["n"] = transferRoLineItem;
/* harmony export (immutable) */ __webpack_exports__["v"] = convertRo;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateROLineItem;
/* harmony export (immutable) */ __webpack_exports__["p"] = cancel;
/* unused harmony export show */
/* harmony export (immutable) */ __webpack_exports__["c"] = find;
/* harmony export (immutable) */ __webpack_exports__["a"] = update;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return bulkUpdateSelectedLineItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return bulkUpdateLineItems; });
/* harmony export (immutable) */ __webpack_exports__["l"] = createRequiredComponent;
/* harmony export (immutable) */ __webpack_exports__["h"] = shopAssistCostSavings;
/* harmony export (immutable) */ __webpack_exports__["r"] = importLineItems;
/* harmony export (immutable) */ __webpack_exports__["s"] = sync;











var search = __WEBPACK_IMPORTED_MODULE_9__pagination__["a" /* default */].search,
    setFilter = __WEBPACK_IMPORTED_MODULE_9__pagination__["a" /* default */].setFilter,
    pageActions = __WEBPACK_IMPORTED_MODULE_9__pagination__["a" /* default */].pageActions;



var expireLineItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__orange_marmalade_paginate_this__["composables"])({
  listId: "repairOrders/lineItems"
}).expire;

var lineItemsPageActions = __WEBPACK_IMPORTED_MODULE_9__pagination__["b" /* repairOrderLineItems */].pageActions;

var reservedForRepairInventoryActions = __WEBPACK_IMPORTED_MODULE_9__pagination__["c" /* reservedForRepairInventory */].pageActions,
    reservedForRepairSearch = __WEBPACK_IMPORTED_MODULE_9__pagination__["c" /* reservedForRepairInventory */].search,
    setReservedFilter = __WEBPACK_IMPORTED_MODULE_9__pagination__["c" /* reservedForRepairInventory */].setFilter;



function searchOpenRO(filter, excludeId) {
  return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.orderSearch({ received: false, filter: filter }).then(function (_ref) {
    var results = _ref.data.results;
    return results.filter(function (i) {
      return i.id !== excludeId;
    });
  });
}

function getLineItems(id) {
  return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.show(id).then(function (_ref2) {
    var lineItems = _ref2.data.line_items;
    return Promise.resolve(lineItems);
  });
}

function refreshRepairOrderAndLineItems(dispatch, repairOrderID) {
  return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.show(repairOrderID).then(function (resp) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_8__actionTypes__["a" /* SET */], repairOrder: resp.data });
    dispatch(expireLineItems());
  });
}

function addItemToCartAndRefreshList(id) {
  return function (dispatch) {
    var addItem = function addItem() {
      return new Promise(function (resolve, __) {
        resolve(dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Nav_RepairOrdersCart_actions__["a" /* create */])(id)));
      });
    };

    addItem().then(function () {
      dispatch(reservedForRepairInventoryActions.expire());
    });
  };
}

function createROLineItem(data) {
  return function (dispatch, getState) {
    var repairOrderId = getState().repairOrderDetail.getIn(["repairOrder", "id"]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.lineItems.create(repairOrderId, data).then(function () {
      refreshRepairOrderAndLineItems(dispatch, repairOrderId);
      return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function cancelROLineItem(id, reason) {
  return function (dispatch, getState) {
    var repairOrderId = getState().repairOrderDetail.getIn(["repairOrder", "id"]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.lineItems.cancel(id, reason).then(function () {
      return refreshRepairOrderAndLineItems(dispatch, repairOrderId);
    });
  };
}

function removeMainComponent(id) {
  return function (dispatch, getState) {
    var repairOrderId = getState().repairOrderDetail.getIn(["repairOrder", "id"]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.lineItems.removeMainComponent(id).then(function () {
      return refreshRepairOrderAndLineItems(dispatch, repairOrderId);
    });
  };
}

function requestVendorRma(id, data, close) {
  return function (dispatch, getState) {
    var repairOrderId = getState().repairOrderDetail.getIn(["repairOrder", "id"]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.lineItems.vendorRmaRequest(id, data).then(function () {
      close();
      refreshRepairOrderAndLineItems(dispatch, repairOrderId);
    });
  };
}

function deleteExpectedComponent(id) {
  return function (dispatch, getState) {
    var repairOrderId = getState().repairOrderDetail.getIn(["repairOrder", "id"]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.lineItems.deleteExpectedComponent(id).then(function () {
      return refreshRepairOrderAndLineItems(dispatch, repairOrderId);
    });
  };
}

function cancelRequestVendorRma(id) {
  return function (dispatch, getState) {
    var repairOrderId = getState().repairOrderDetail.getIn(["repairOrder", "id"]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.lineItems.cancelVendorRmaRequest(id).then(function () {
      return refreshRepairOrderAndLineItems(dispatch, repairOrderId);
    });
  };
}

function approveROLineItem(id, data) {
  var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  return function (dispatch, getState) {
    var repairOrderId = getState().repairOrderDetail.getIn(["repairOrder", "id"]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.lineItems.approve(id, data).then(function () {
      refreshRepairOrderAndLineItems(dispatch, repairOrderId);
      cb();
      __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success("Approved", "Final approval successful");
    }).catch(function (error) {
      var errorMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(error, "errors.estimated_lead_time") && "Estimated Lead Time is Required." || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(error, "errors.base[0]") || error.message;
      if (errorMessage) __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error("Error", errorMessage);
    });
  };
}

function transferRoLineItem(id, data) {
  var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.lineItems.transfer(id, data).then(function (_ref3) {
      var newRepair = _ref3.data;

      cb();
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["push"])({ pathname: "/repair-orders/" + newRepair.id }));
      return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function convertRo(data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.convert(data).then(function (_ref4) {
      var uuid = _ref4.data.uuid;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["push"])({ pathname: "/repair-orders/" + uuid }));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__session_actions__["refreshCarts"])());
      dispatch(reservedForRepairInventoryActions.expire());
      return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function updateROLineItem(id, data) {
  return function (dispatch, getState) {
    var repairOrderId = getState().repairOrderDetail.getIn(["repairOrder", "id"]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.lineItems.update(id, data).then(function () {
      refreshRepairOrderAndLineItems(dispatch, repairOrderId);
      return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error("Error", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(error, "errors.base[0]"));
    });
  };
}

function cancel(data) {
  return function (dispatch, getState) {
    var repairOrderId = getState().repairOrderDetail.getIn(["repairOrder", "id"]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.cancel(repairOrderId, data).then(function () {
      refreshRepairOrderAndLineItems(dispatch, repairOrderId);
      return Promise.resolve();
    }).catch(function (err) {
      return Promise.reject(err);
    });
  };
}

function show(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.show(id).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_8__actionTypes__["a" /* SET */],
        repairOrder: resp.data
      });
    });
  };
}

function find(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.find(id).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_8__actionTypes__["a" /* SET */],
        repairOrder: resp.data
      });
    });
  };
}

function update(data) {
  return function (dispatch, getState) {
    var repairOrderID = getState().repairOrderDetail.getIn(["repairOrder", "id"]);

    if (data.contact_id === "Add") {
      data.contact_id = null;
    }

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.update(repairOrderID, data).then(function () {
      refreshRepairOrderAndLineItems(dispatch, repairOrderID);

      return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

var bulkUpdateSelectedLineItems = function bulkUpdateSelectedLineItems(selectedItems) {
  return function (data) {
    return function (dispatch, getState) {
      var repairOrderID = getState().repairOrderDetail.getIn(["repairOrder", "id"]);

      data.line_items = data.line_items.filter(function (l) {
        return selectedItems.includes(l.id);
      });

      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.lineItems.bulkUpdate(repairOrderID, data).then(function (resp) {
        dispatch({
          type: __WEBPACK_IMPORTED_MODULE_8__actionTypes__["a" /* SET */],
          repairOrder: resp.data
        });
        refreshRepairOrderAndLineItems(dispatch, repairOrderID);
        return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
      }).catch(function (err) {
        return Promise.reject(err);
      });
    };
  };
};

var bulkUpdateLineItems = function bulkUpdateLineItems(data) {
  return function (dispatch, getState) {
    var repairOrderID = getState().repairOrderDetail.getIn(["repairOrder", "id"]);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.lineItems.bulkUpdate(repairOrderID, data).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_8__actionTypes__["a" /* SET */],
        repairOrder: resp.data
      });
      dispatch(lineItemsPageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
};

function createRequiredComponent(repairItemId, data) {
  return function (dispatch, getState) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.lineItems.requiredComponents.create(repairItemId, data).then(function () {
      var repairOrderID = getState().repairOrderDetail.getIn(["repairOrder", "id"]);
      refreshRepairOrderAndLineItems(dispatch, repairOrderID);
      return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function shopAssistCostSavings(repairItemId, data) {
  return function (dispatch, getState) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.lineItems.shopAssistCostItem(repairItemId, data).then(function () {
      var repairOrderID = getState().repairOrderDetail.getIn(["repairOrder", "id"]);
      refreshRepairOrderAndLineItems(dispatch, repairOrderID);
      return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function importLineItems(values) {
  return function (dispatch, getState) {
    var repairOrderID = getState().repairOrderDetail.getIn(["repairOrder", "id"]);
    var repairOrderUUID = getState().repairOrderDetail.getIn(["repairOrder", "uuid"]);
    var fileName = values.file.name;

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].attachments.upload(values.file.name).then(function (resp) {
      var _resp$data = resp.data,
          key = _resp$data.key,
          url = _resp$data.url;

      var formattedAttachment = {
        name: fileName,
        key: key
      };

      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].attachments.toS3(url, values.file).then(function () {
        return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.lineItems.import(repairOrderID, formattedAttachment).then(function () {
          refreshRepairOrderAndLineItems(dispatch, repairOrderUUID);
          __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].info("Processing", "Importing.");
          return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
        });
      }).catch(function (e) {
        return Promise.reject(e);
      });
    });
  };
}

function sync() {
  return function (dispatch, getState) {
    var repairOrderID = getState().repairOrderDetail.getIn(["repairOrder", "id"]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.sync(repairOrderID).then(function () {
      __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success("SUCCESS", "Successfully Synced.");

      return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
    }).catch(function (response) {
      __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].error("ERROR", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(response, "errors", "Sync Failed"));
    });
  };
}

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__session_actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_zebra_print__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parts_pagination__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actionTypes__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pagination__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(12);
/* unused harmony export search */
/* unused harmony export setFilter */
/* unused harmony export pageActions */
/* unused harmony export partInventoriesPageActions */
/* harmony export (immutable) */ __webpack_exports__["v"] = assignExchange;
/* unused harmony export updateSeller */
/* harmony export (immutable) */ __webpack_exports__["i"] = update;
/* harmony export (immutable) */ __webpack_exports__["s"] = bulkUpdate;
/* harmony export (immutable) */ __webpack_exports__["n"] = reclaim;
/* harmony export (immutable) */ __webpack_exports__["e"] = reserveForRepair;
/* harmony export (immutable) */ __webpack_exports__["f"] = reserveForSale;
/* unused harmony export updateWithId */
/* harmony export (immutable) */ __webpack_exports__["b"] = transfer;
/* harmony export (immutable) */ __webpack_exports__["k"] = cancelTransfer;
/* harmony export (immutable) */ __webpack_exports__["j"] = cancelModTo;
/* harmony export (immutable) */ __webpack_exports__["m"] = unreserveForSale;
/* harmony export (immutable) */ __webpack_exports__["w"] = applyLotCost;
/* harmony export (immutable) */ __webpack_exports__["r"] = print;
/* harmony export (immutable) */ __webpack_exports__["p"] = unreserveForRepair;
/* harmony export (immutable) */ __webpack_exports__["l"] = deleteInventory;
/* harmony export (immutable) */ __webpack_exports__["y"] = show;
/* harmony export (immutable) */ __webpack_exports__["B"] = addCostAdjustment;
/* harmony export (immutable) */ __webpack_exports__["x"] = cancelCostAdjustment;
/* harmony export (immutable) */ __webpack_exports__["h"] = upload;
/* harmony export (immutable) */ __webpack_exports__["o"] = returnCoreToCustomer;
/* harmony export (immutable) */ __webpack_exports__["q"] = returnConsignment;
/* harmony export (immutable) */ __webpack_exports__["d"] = createDummy;
/* harmony export (immutable) */ __webpack_exports__["A"] = updateDummy;
/* harmony export (immutable) */ __webpack_exports__["z"] = destroyDummy;
/* harmony export (immutable) */ __webpack_exports__["g"] = splitInventory;
/* harmony export (immutable) */ __webpack_exports__["c"] = createVendorRma;
/* harmony export (immutable) */ __webpack_exports__["u"] = returnToCustomer;
/* harmony export (immutable) */ __webpack_exports__["t"] = returnToCustomerV2;
/* harmony export (immutable) */ __webpack_exports__["a"] = undoScrap;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














var search = __WEBPACK_IMPORTED_MODULE_10__pagination__["a" /* default */].search,
    setFilter = __WEBPACK_IMPORTED_MODULE_10__pagination__["a" /* default */].setFilter,
    pageActions = __WEBPACK_IMPORTED_MODULE_10__pagination__["a" /* default */].pageActions;

var partInventoriesPageActions = __WEBPACK_IMPORTED_MODULE_8__parts_pagination__["c" /* partInventories */].pageActions;



function refreshInventories(dispatch, inventoryID) {
  return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.show(inventoryID).then(function (resp) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["a" /* SET */], inventory: resp.data });
  });
}

function assignExchange(data) {
  return function (dispatch, getState) {
    var inventoryID = data.id || getState().inventoryDetail.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ID */]]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.assignExchange(inventoryID, data).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["a" /* SET */],
        inventory: resp.data
      });
      dispatch(pageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function updateSeller(id, data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.update(id, data).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["a" /* SET */],
        inventory: resp.data
      });
      dispatch(pageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function update(data) {
  return function (dispatch, getState) {
    var inventoryID = data.id || getState().inventoryDetail.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ID */]]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.update(inventoryID, data).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["a" /* SET */],
        inventory: resp.data
      });
      dispatch(pageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function bulkUpdate(data) {
  return function (dispatch, getState) {
    var inventoryID = getState().inventoryDetail.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ID */]]);
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.bulkUpdate(data).then(function () {
      dispatch(pageActions.expire());
      refreshInventories(dispatch, inventoryID);
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function reclaim() {
  return function (dispatch, getState) {
    var inventoryID = getState().inventoryDetail.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ID */]]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.reclaim(inventoryID).then(function () {
      dispatch(pageActions.expire());
      refreshInventories(dispatch, inventoryID);
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function reserveForRepair(id) {
  return function (dispatch, getState) {
    var inventoryID = id || getState().inventoryDetail.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ID */]]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.reserveForRepair(inventoryID).then(function () {
      dispatch(pageActions.expire());
      dispatch(partInventoriesPageActions.expire());
      refreshInventories(dispatch, inventoryID);
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    }).catch(function (error) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* handleSubmissionError */])(error);
    });
  };
}

function reserveForSale(data) {
  return function (dispatch, getState) {
    var inventoryID = data.id || getState().inventoryDetail.getIn(["inventory", "id"]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.reserveForSale(inventoryID, data).then(function () {
      dispatch(pageActions.expire());
      refreshInventories(dispatch, inventoryID);
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function updateWithId(id, data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.update(id, data).then(function () {
      dispatch(pageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function transfer(id, transferToLocationId, outgoingAwbNumber, specialInstructions) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.transfers.create(id, transferToLocationId, outgoingAwbNumber, specialInstructions).then(function () {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["b" /* SET_MODAL */], showModal: true });
      dispatch(pageActions.expire());
      refreshInventories(dispatch, id);
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function cancelTransfer(id, transferId) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.transfers.delete(id, transferId).then(function () {
      dispatch(pageActions.expire());
      refreshInventories(dispatch, id);
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function cancelModTo(id) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.update(id, _extends({ mod_to_id: null }, data)).then(function () {
      dispatch(pageActions.expire());
      refreshInventories(dispatch, id);
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function unreserveForSale() {
  return function (dispatch, getState) {
    var inventoryID = getState().inventoryDetail.getIn(["inventory", "id"]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.unreserveForSale(inventoryID).then(function (resp) {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["a" /* SET */], inventory: resp.data });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__session_actions__["refreshCarts"])());
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    }).catch(function (err) {
      var srpErr = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(err, "errors.srp_condition") || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(err, "errors.srp_condition");
      if (srpErr) {
        __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__["toastr"].error("Error", "SRP Details are required prior to returning to stock");
      } else {
        throw err;
      }
    });
  };
}

function applyLotCost(data) {
  return function (dispatch, getState) {
    var inventoryID = getState().inventoryDetail.getIn(["inventory", "id"]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.applyLotCost(inventoryID, data).then(function (resp) {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["a" /* SET */], inventory: resp.data });
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function print(data, id) {
  return function (dispatch, getState) {
    var inventoryID = getState().inventoryDetail.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ID */]]) || id;
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.print(inventoryID, data).then(function (resp) {
      if (!data.include_company_name) {
        resp.data.company_name = null;
      }

      if (data.notes) {
        data.notes = resp.data.notes;
      } else {
        data.notes = null;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_zebra_print__["a" /* print */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_zebra_print__["b" /* label */])(_extends({}, resp.data, data)));
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function unreserveForRepair() {
  return function (dispatch, getState) {
    var inventoryID = getState().inventoryDetail.getIn(["inventory", "id"]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.unreserveForRepair(inventoryID).then(function (resp) {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["a" /* SET */], inventory: resp.data });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__session_actions__["refreshCarts"])());
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function deleteInventory(data) {
  return function (dispatch, getState) {
    var inventoryID = data.id || getState().inventoryDetail.getIn(["inventory", "id"]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.deleteInventory(inventoryID).then(function (resp) {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["a" /* SET */], inventory: resp.data });
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function show(id) {
  return function (dispatch, getState) {
    var inventoryContext = getState().router.location.pathname.includes("all") ? "all" : "part";
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.show(id, inventoryContext).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["a" /* SET */],
        inventory: resp.data
      });

      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function addCostAdjustment(data, props) {
  return function (dispatch, getState) {
    var inventoryID = getState().inventoryDetail.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* INVENTORY */], "id"]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.costAdjustments.create(inventoryID, data).then(function (resp) {
      if (resp.data.inventory_id === inventoryID) {
        refreshInventories(dispatch, inventoryID);
        props.setAskedInternalOutright(!getState().inventoryDetail.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_11__constants__["_25" /* INTERNAL_OUTRIGHT_SALES_ITEM_ID */]]));
      } else {
        __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__["toastr"].warning("Warning", "Cost Adjustment will be added to repaired inventory related to shop assist.");
      }
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function cancelCostAdjustment(id) {
  return function (dispatch, getState) {
    var inventoryID = getState().inventoryDetail.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* INVENTORY */], "id"]);
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.costAdjustments.cancel(id).then(function () {
      refreshInventories(dispatch, inventoryID);
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__["toastr"].error("Error", __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(error, "errors.base[0]"));
    });
  };
}

function upload(data) {
  var file = data.scrap_report;
  return function (dispatch, getState) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].attachments.upload(file.name).then(function (resp) {
      var inventoryID = getState().inventoryDetail.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* INVENTORY */], "id"]);
      var _resp$data = resp.data,
          key = _resp$data.key,
          url = _resp$data.url;

      var inventory = { scrap_report: key };

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].attachments.toS3(url, file).then(function () {
        return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.update(inventoryID, inventory).then(function (createResp) {
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["a" /* SET */],
            inventory: createResp.data
          });
          return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
        });
      });
    });
  };
}

function returnCoreToCustomer() {
  return function (dispatch, getState) {
    var salesOrderLineItemId = getState().inventoryDetail.getIn(["inventory", "most_recent_sales_order_line_item", "id"]);

    var code = getState().inventoryDetail.getIn(["inventory", "most_recent_sales_order_line_item", "sales_order_code"]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].salesOrders.lineItems.returnCoreToCustomer(salesOrderLineItemId).then(function (resp) {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["a" /* SET */], inventory: resp.data });
      __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__["toastr"].success("Success", "A Note has been created under Exchange " + code + ", to indicate that the core has been rejected");
    });
  };
}

function returnConsignment(data) {
  return function (dispatch, getState) {
    var inventoryId = getState().inventoryDetail.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ID */]]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.cancelConsignment(inventoryId, data).then(function (resp) {
      refreshInventories(dispatch, resp.data.id);
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function createDummy(data) {
  return function (dispatch, getState) {
    var inventoryId = getState().inventoryDetail.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* INVENTORY */], "id"]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.dummy.create(inventoryId, data).then(function (resp) {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["c" /* SET_DUMMY */], dummy: resp.data });
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function updateDummy(data) {
  return function (dispatch, getState) {
    var inventoryId = getState().inventoryDetail.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* INVENTORY */], "id"]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.dummy.update(inventoryId, data).then(function (resp) {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["c" /* SET_DUMMY */], dummy: resp.data });
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function destroyDummy() {
  return function (dispatch, getState) {
    var inventoryId = getState().inventoryDetail.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* INVENTORY */], "id"]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.dummy.destroy(inventoryId).then(function () {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["d" /* DESTROY_DUMMY */] });
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function splitInventory(data) {
  return function (dispatch, getState) {
    var inventoryId = getState().inventoryDetail.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* INVENTORY */], "id"]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.split(inventoryId, data).then(function () {
      refreshInventories(dispatch, inventoryId);
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function createVendorRma(data) {
  return function (dispatch, getState) {
    var inventoryId = getState().inventoryDetail.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* INVENTORY */], "id"]);
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.vendorRmas.create(inventoryId, data).then(function (resp) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["push"])({ pathname: "/rmas/" + resp.data.id }));
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function returnToCustomer(id, data) {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.returnToCustomer(id, data).then(function () {
      refreshInventories(dispatch, id);
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function returnToCustomerV2(id, data) {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.returnToCustomerRecords.create(id, data).then(function () {
      refreshInventories(dispatch, id);
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function undoScrap(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.undoScrap(id).then(function () {
      refreshInventories(dispatch, id);
      return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__["toastr"].error("Error", __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(error, "errors.base[0]"));
    });
  };
}

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__ = __webpack_require__(34);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CONDITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CONSIGNEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ROUTED_EXPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return USPPI; });
/* unused harmony export RESELLER */
/* unused harmony export DIRECT_CONSUMER */
/* unused harmony export GOVERNMENT_ENTITY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REPAIR_AND_RETURN; });
/* unused harmony export OTHER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OUTGOING_AWB_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return READ_ONLY_COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return READ_ONLY_COMPANY_UUID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return READ_ONLY_INVENTORY_UUID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return READ_ONLY_PART_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return READ_ONLY_PART_UUID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return READ_ONLY_SERIAL_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SHIP_MULTIPLE_ITEM_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ATTACHMENT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return LINK_MAPPINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CONDITION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return REPAIR_ORDER_CONSIGNEE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CONSIGNEE_TYPES; });
var _ATTACHMENT_TYPES, _CONDITION_TYPES, _CONSIGNEE_TYPES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var CONDITIONS = __WEBPACK_IMPORTED_MODULE_1__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].condition;
var CONSIGNEE = "consignee";
var EIN = "ein";
var ROUTED_EXPORT = "routed_export";
var USPPI = "usppi";

var RESELLER = "reseller";
var DIRECT_CONSUMER = "direct_consumer";
var GOVERNMENT_ENTITY = "government_entity";
var REPAIR_AND_RETURN = "repair_and_return";
var OTHER = "other";

var OUTGOING_AWB_NUMBER = "outgoing_awb_number";
var READ_ONLY_COMPANY = "read_only_company";
var READ_ONLY_COMPANY_UUID = "read_only_company_uuid";
var READ_ONLY_INVENTORY_UUID = "read_only_inventory_uuid";
var READ_ONLY_PART_NUMBER = "read_only_part_number";
var READ_ONLY_PART_UUID = "read_only_part_uuid";
var READ_ONLY_SERIAL_NUMBER = "read_only_serial_number";
var SHIP_MULTIPLE_ITEM_IDS = "ship_multiple_item_ids";

var ATTACHMENT_TYPES = (_ATTACHMENT_TYPES = {
  commercial_invoice: {
    label: "Commercial Invoice"
  },
  data_plate_dom_photos: {
    label: "Data Plate / DOM Photos"
  },
  external_link: {
    label: "External Link"
  },
  final_packaging_photos: {
    label: "Photos - Final Packaging"
  },
  photos_receiving_inspection: {
    label: "Photos - Shipping Inspection"
  }
}, _defineProperty(_ATTACHMENT_TYPES, __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__["a" /* PHOTOS_RECEIVING_PACKAGING_INSPECTION */], {
  label: "Photos - Shipping Packaging Inspection"
}), _defineProperty(_ATTACHMENT_TYPES, "shipping_checklist", {
  label: "Shipping Checklist"
}), _ATTACHMENT_TYPES);

var LINK_MAPPINGS = {
  MR: "managed-repair-orders",
  MS: "mistake-shipments",
  RC: "inventories",
  PO: "purchase-orders",
  RMA: "rmas",
  RCORE: "purchase-orders",
  RO: "repair-orders",
  SO: "sales-orders",
  S: "shipping"
};

var CONDITION_TYPES = (_CONDITION_TYPES = {}, _defineProperty(_CONDITION_TYPES, __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__["f" /* AS_REMOVED */], {
  label: "As Removed",
  abbrev: "AR"
}), _defineProperty(_CONDITION_TYPES, __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__["g" /* BEYOND_ECON_REPAIR */], {
  label: "Beyond Econ. Repair",
  abbrev: "BR"
}), _defineProperty(_CONDITION_TYPES, __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__["h" /* INSPECTED */], {
  label: "Inspected",
  abbrev: "BT"
}), _defineProperty(_CONDITION_TYPES, __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__["i" /* NEW */], {
  label: "New",
  abbrev: "NE"
}), _defineProperty(_CONDITION_TYPES, __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__["j" /* OVERHAULED */], {
  label: "Overhauled",
  abbrev: "OH"
}), _defineProperty(_CONDITION_TYPES, __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__["k" /* PARTS_UNIT */], {
  label: "Parts Unit",
  abbrev: "PU"
}), _defineProperty(_CONDITION_TYPES, __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__["l" /* REPAIRED */], {
  label: "Repaired",
  abbrev: "SV"
}), _CONDITION_TYPES);

var REPAIR_ORDER_CONSIGNEE_TYPES = _defineProperty({}, REPAIR_AND_RETURN, { label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_formatters_text__["c" /* properCase */])(REPAIR_AND_RETURN) });

var CONSIGNEE_TYPES = (_CONSIGNEE_TYPES = {}, _defineProperty(_CONSIGNEE_TYPES, RESELLER, { label: "Reseller" }), _defineProperty(_CONSIGNEE_TYPES, DIRECT_CONSUMER, { label: "Direct Consumer" }), _defineProperty(_CONSIGNEE_TYPES, GOVERNMENT_ENTITY, { label: "Government Entity" }), _defineProperty(_CONSIGNEE_TYPES, OTHER, { label: "Other/Unknown" }), _CONSIGNEE_TYPES);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function MultiLocationFeature(_ref) {
  var children = _ref.children;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__hooks__["a" /* useCurrentUser */])();

  if (currentUser.locations.length > 1) {
    return children;
  }

  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (MultiLocationFeature);

MultiLocationFeature.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)])
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(66)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(57);
var IE8_DOM_DEFINE = __webpack_require__(850);
var toPrimitive = __webpack_require__(160);
var dP = Object.defineProperty;

exports.f = __webpack_require__(89) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(159);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pagination__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parts_components_Detail_PurchaseOrders_Create_Create__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony export (immutable) */ __webpack_exports__["h"] = setTraceHold;
/* harmony export (immutable) */ __webpack_exports__["e"] = addCostAdjustment;
/* harmony export (immutable) */ __webpack_exports__["d"] = addLineItem;
/* harmony export (immutable) */ __webpack_exports__["k"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["l"] = create;
/* harmony export (immutable) */ __webpack_exports__["g"] = searchBuyers;
/* harmony export (immutable) */ __webpack_exports__["f"] = searchCompanies;
/* harmony export (immutable) */ __webpack_exports__["m"] = searchLots;
/* harmony export (immutable) */ __webpack_exports__["b"] = show;
/* harmony export (immutable) */ __webpack_exports__["c"] = updateLineItem;
/* harmony export (immutable) */ __webpack_exports__["j"] = importLineItems;
/* harmony export (immutable) */ __webpack_exports__["a"] = update;
/* harmony export (immutable) */ __webpack_exports__["i"] = sync;













function refreshLotAndLineItems(dispatch, lotId) {
  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].lots.show(lotId).then(function (resp) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* SET */], lot: resp.data });
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__pagination__["b" /* expireLineItems */])());
  });
}

function setTraceHold(val) {
  return function (dispatch, getState) {
    var lotID = getState().lotDetail.getIn([__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* LOT */], __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]]);

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].lots.setTraceHold(lotID, val).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* SET */],
        lot: resp.data
      });

      __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__["toastr"].success("Success", val ? "Approved Trace Hold" : "Rejected Trace Hold, Notification has been sent to Buyer.");

      return __WEBPACK_IMPORTED_MODULE_3__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function addCostAdjustment(data) {
  return function (dispatch, getState) {
    var lot = getState().lotDetail.get(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* LOT */]);

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].lots.costAdjustments.create(lot.get(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]), data).then(function () {
      refreshLotAndLineItems(dispatch, lot.get(__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* UUID */]));

      return __WEBPACK_IMPORTED_MODULE_3__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function addLineItem(values, lotId, afterCreate) {
  return function (dispatch, getState) {
    var lot = getState().lotDetail.get(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* LOT */]);
    var id = lotId || lot.get(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]);

    if (!values.purchase_for_sale) {
      values.reserve_for_seller_id = null;
    }

    if (values.displayCoBuyerFields) {
      values.add_co_buyer = true;
    }

    if (values.displayThirdBuyerFields) {
      values.add_third_buyer = true;
    }

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].lots.lineItems.create(id, values).then(function () {
      if (afterCreate) {
        afterCreate();
      } else {
        refreshLotAndLineItems(dispatch, lot.get(__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* UUID */]));
      }
      return __WEBPACK_IMPORTED_MODULE_3__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function cancel(reason) {
  return function (dispatch, getState) {
    var lot = getState().lotDetail.get(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* LOT */]);

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].lots.cancel(lot.get(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]), reason).then(function () {
      refreshLotAndLineItems(dispatch, lot.get(__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* UUID */]));
      return Promise.resolve();
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__["toastr"].error("Error", __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(error, "errors.base[0]"), error.message);
    });
  };
}

function create(data) {
  return function (dispatch) {
    if (data.contact_id === "Add") {
      data.contact_id = null;
    }

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].lots.create(data).then(function (resp) {
      var id = resp.data.uuid;
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"])({
        pathname: "/lots/" + id
      }));
      return __WEBPACK_IMPORTED_MODULE_3__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function searchBuyers(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].users.search({ active: true, filter: filter, page: 1, limit: 10 }).then(function (resp) {
      return Promise.resolve(resp.data.results);
    });
  };
}

function searchCompanies(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].companies.search({
      filter: filter,
      status: [__WEBPACK_IMPORTED_MODULE_9__companies_constants__["c" /* ACTIVE */], __WEBPACK_IMPORTED_MODULE_9__companies_constants__["b" /* NO_BIZ */], __WEBPACK_IMPORTED_MODULE_9__companies_constants__["d" /* CREDIT_HOLD */]].join(","),
      sort: "name",
      reverse: false,
      page: 1,
      limit: 20
    }).then(function (resp) {
      return Promise.resolve(resp.data.results);
    });
  };
}

function searchLots(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].lots.search({
      filter: filter
    }).then(function (resp) {
      return resp.data.results;
    });
  };
}

function show(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].lots.show(id).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* SET */],
        lot: resp.data
      });
    });
  };
}

function updateLineItem(lineItemId, values) {
  return function (dispatch, getState) {
    var lotId = getState().lotDetail.getIn([__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* LOT */], __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* UUID */]]);

    if (!values.purchase_for_sale && values.reserve_for_seller_id) {
      values.reserve_for_seller_id = null;
    }

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].lots.lineItems.update(lineItemId, values).then(function () {
      refreshLotAndLineItems(dispatch, lotId);
      return __WEBPACK_IMPORTED_MODULE_3__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function importLineItems(values) {
  return function (dispatch, getState) {
    var lot = getState().lotDetail.get(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* LOT */]);
    var fileName = values.file.name;

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.upload(values.file.name).then(function (resp) {
      var _resp$data = resp.data,
          key = _resp$data.key,
          url = _resp$data.url;

      var formattedAttachment = {
        name: fileName,
        key: key
      };

      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.toS3(url, values.file).then(function () {
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].lots.lineItems.import(lot.get(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]), formattedAttachment).then(function () {
          refreshLotAndLineItems(dispatch, lot.get(__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* UUID */]));
          __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__["toastr"].info("Processing", "Importing Lots.");
          return __WEBPACK_IMPORTED_MODULE_3__lib_submission__["a" /* SUCCESS */];
        });
      }).catch(function (e) {
        return Promise.reject(e);
      });
    });
  };
}

function update(data) {
  return function (dispatch, getState) {
    var lot = getState().lotDetail.get(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* LOT */]);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__parts_components_Detail_PurchaseOrders_Create_Create__["a" /* modifyFormDataForContact */])(data);

    if (data.shipping_type && data.shipping_type !== __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_constants__["d" /* DO_NOT_SHIP */]) {
      __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_constants__["e" /* DO_NOT_SHIP_REASONS */].forEach(function (field) {
        data[field] = false;
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].lots.update(lot.get(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]), data).then(function () {
      refreshLotAndLineItems(dispatch, lot.get(__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* UUID */]));
      return __WEBPACK_IMPORTED_MODULE_3__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function sync() {
  return function (dispatch, getState) {
    var lotId = getState().lotDetail.getIn(["lot", "id"]);
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].lots.sync(lotId).then(function () {
      __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__["toastr"].success("SUCCESS", "Successfully Synced.");

      return __WEBPACK_IMPORTED_MODULE_3__lib_submission__["a" /* SUCCESS */];
    }).catch(function (response) {
      __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__["toastr"].error("ERROR", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(response, "errors", "Sync Failed"));
    });
  };
}

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Section__ = __webpack_require__(2387);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Section__["a"]; });



/***/ }),
/* 94 */,
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actionTypes__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__session_actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pagination__ = __webpack_require__(500);
/* unused harmony export search */
/* unused harmony export setFilter */
/* unused harmony export pageActions */
/* harmony export (immutable) */ __webpack_exports__["h"] = searchUsers;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return searchRoleUsers; });
/* harmony export (immutable) */ __webpack_exports__["i"] = searchAllUsers;
/* harmony export (immutable) */ __webpack_exports__["g"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = enableMfa;
/* harmony export (immutable) */ __webpack_exports__["j"] = reset;
/* harmony export (immutable) */ __webpack_exports__["k"] = forgot;
/* harmony export (immutable) */ __webpack_exports__["d"] = sendVerificationRequest;
/* harmony export (immutable) */ __webpack_exports__["a"] = show;
/* harmony export (immutable) */ __webpack_exports__["e"] = verify;
/* harmony export (immutable) */ __webpack_exports__["b"] = update;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











var search = __WEBPACK_IMPORTED_MODULE_8__pagination__["a" /* pagination */].search,
    setFilter = __WEBPACK_IMPORTED_MODULE_8__pagination__["a" /* pagination */].setFilter,
    pageActions = __WEBPACK_IMPORTED_MODULE_8__pagination__["a" /* pagination */].pageActions;



function searchUsers(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].users.search({ filter: filter, active: true, page: 1, limit: 10 }).then(function (resp) {
      return Promise.resolve(resp.data.results);
    });
  };
}

var searchRoleUsers = function searchRoleUsers(roles) {
  return function (filter) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].users.search({ filter: filter, roles: roles, active: true, page: 1, limit: 10 }).then(function (resp) {
      return Promise.resolve(resp.data.results);
    });
  };
};

function searchAllUsers() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].users.search(params).then(function (resp) {
      return Promise.resolve(resp.data.results);
    });
  };
}

function create(data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].users.create(data).then(function () {
      dispatch(pageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function enableMfa() {
  return function (dispatch, getState) {
    var userId = getState().userDetail.getIn([__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* UUID */]]);

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].users.enableMfa(userId).then(function () {
      __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].success("Please check your email to enable MFA.");

      return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function reset(data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].password.reset(data).then(function () {
      __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].success("Success", "Password Reset.");
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["push"])({ pathname: "/login" }));
    }).catch(function () {
      __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Something went wrong.");
    });
  };
}

function forgot(data) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].password.forgot(data.email).then(function () {
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
    }).catch(function () {
      __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Something went wrong.");
    });
  };
}

function sendVerificationRequest() {
  return function (dispatch, getState) {
    var userId = getState().userDetail.getIn([__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* UUID */]]);

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].users.requestVerification(userId).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_6__actionTypes__["a" /* SET */],
        user: resp.data
      });

      return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function show(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].users.show(id).then(function (resp) {
      return dispatch({
        type: __WEBPACK_IMPORTED_MODULE_6__actionTypes__["a" /* SET */],
        user: resp.data
      });
    });
  };
}

function verify(data) {
  return function (dispatch, getState) {
    var userId = getState().userDetail.getIn([__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* UUID */]]);

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].users.verifyEmail(userId, data).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_6__actionTypes__["a" /* SET */],
        user: resp.data
      });

      return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function update(data) {
  return function (dispatch, getState) {
    var userId = getState().userDetail.getIn([__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ID */]]);
    var payload = _extends({}, data);
    if (data.buying_limit !== undefined) {
      payload = _extends({}, data, {
        buying_limit: Number(data.buying_limit)
      });
    }
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].users.update(userId, payload).then(function (resp) {
      var currentUser = getState().session.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* USER */]);
      if (currentUser.get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ID */]) === userId) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__session_actions__["update"])(resp.data));
      }

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_6__actionTypes__["a" /* SET */],
        user: resp.data
      });
      dispatch(pageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
    });
  };
}

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeKeys;
function removeKey(object, key) {
  var newObj = Object.assign({}, object);
  delete newObj[key];
  return newObj;
}

function removeKeys(object, keys) {
  var newObj = Object.assign({}, object);
  keys.forEach(function (k) {
    return delete newObj[k];
  });
  return newObj;
}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(157);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ __webpack_exports__["a"] = (createChainedFunction);

/***/ }),
/* 99 */,
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SUCCESS; });
var SUCCESS = "submission/SUCCESS";

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return AVG_OVERHAUL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return AVG_REPAIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return AVG_TEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AWAITING_REPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return BER_RATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return EVALUATION_FEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return QUOTE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NO_CAPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return REPAIR_QUOTE_LINE_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return STANDARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OVERHAUL_TAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REPAIR_TAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TEST_TAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TURNAROUND_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return QUOTE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return QUOTE_TYPES_ABBREV; });
var _QUOTE_TYPES_ABBREV;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var AVG_OVERHAUL = "avg_overhaul";
var AVG_REPAIR = "avg_repair";
var AVG_TEST = "avg_test";
var AWAITING_REPLY = "awaiting_reply";
var BER_RATE = "ber_rate";
var EVALUATION_FEE = "evaluation_fee";
var QUOTE_TYPE = "quote_type";
var NO_CAPES = "no_capes";
var REPAIR_QUOTE_LINE_ITEM = "repair_quote_line_item";
var STANDARD = "standard";
var OVERHAUL_TAT = "overhaul_tat";
var REPAIR_TAT = "repair_tat";
var TEST_TAT = "test_tat";
var TURNAROUND_TIME = "turnaround_time";
var QUOTE_TYPES = [NO_CAPES, AWAITING_REPLY, STANDARD];
var QUOTE_TYPES_ABBREV = (_QUOTE_TYPES_ABBREV = {}, _defineProperty(_QUOTE_TYPES_ABBREV, __WEBPACK_IMPORTED_MODULE_0__IncomingQuotes_constants__["j" /* NO_QUOTE */], "NQ"), _defineProperty(_QUOTE_TYPES_ABBREV, NO_CAPES, "NoCapes"), _defineProperty(_QUOTE_TYPES_ABBREV, AWAITING_REPLY, "Awaiting"), _defineProperty(_QUOTE_TYPES_ABBREV, STANDARD, "Std"), _QUOTE_TYPES_ABBREV);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Receiving_constants__ = __webpack_require__(34);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CANCELLATION_REASONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CONSIGNMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SO_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RO_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PO_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRANSFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MRO_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REJECTED_CORE_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RETURNED_CONSIGNMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RETURNED_CORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RETURN_TO_CUSTOMER_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return INVENTORY_TRANSFER_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return RMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MISTAKE; });
/* unused harmony export LINE_ITEM_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return itemInfo; });
/* unused harmony export ATTACHMENT_TYPES */
var _LINE_ITEM_TYPES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var CANCELLATION_REASONS = [{ value: "previously_sold", text: "Previously Sold" }, { value: "part_deemed_ber", text: "Part Deemed B.E.R" }, { value: "vendor_cant_find", text: "Vendor Can't Find" }, { value: "unethical_behavior_detected", text: "Unethical Behavior Detected" }, { value: "cancelled_by_tenant", text: "Cancelled by Us" }, { value: "unknown", text: "Unknown" }];

var CONSIGNMENT = "consignment";
var SO_ITEM = "sales_order_line_item";
var RO_ITEM = "repair_order_line_item";
var PO_ITEM = "purchase_order_line_item";
var TRANSFER = "inventory_transfer_order";
var MRO_ITEM = "managed_repair_order_line_item";
var REJECTED_CORE_ORDER = "rejected_core_order";
var RETURNED_CONSIGNMENT = "returned_consignment";
var RETURNED_CORE = "returned_core";
var RETURN_TO_CUSTOMER_RECORD = "return_to_customer_record";
var INVENTORY_TRANSFER_ORDER = "inventory_transfer_order";
var RMA = "rma";
var MISTAKE = "mistake_shipment";

var LINE_ITEM_TYPES = (_LINE_ITEM_TYPES = {}, _defineProperty(_LINE_ITEM_TYPES, PO_ITEM, {
  abbrev: "PO"
}), _defineProperty(_LINE_ITEM_TYPES, MISTAKE, {
  abbrev: "MS"
}), _defineProperty(_LINE_ITEM_TYPES, MRO_ITEM, {
  abbrev: "MR"
}), _defineProperty(_LINE_ITEM_TYPES, RETURNED_CONSIGNMENT, {
  abbrev: "RC"
}), _defineProperty(_LINE_ITEM_TYPES, RETURNED_CORE, {
  abbrev: "RCORE"
}), _defineProperty(_LINE_ITEM_TYPES, SO_ITEM, {
  abbrev: "SO"
}), _defineProperty(_LINE_ITEM_TYPES, RO_ITEM, {
  abbrev: "RO"
}), _defineProperty(_LINE_ITEM_TYPES, TRANSFER, {
  abbrev: "TR"
}), _defineProperty(_LINE_ITEM_TYPES, RMA, {
  abbrev: "RMA"
}), _defineProperty(_LINE_ITEM_TYPES, REJECTED_CORE_ORDER, {
  abbrev: "SO"
}), _defineProperty(_LINE_ITEM_TYPES, __WEBPACK_IMPORTED_MODULE_0__Receiving_constants__["e" /* SHIPMENT */], {
  abbrev: "S"
}), _LINE_ITEM_TYPES);

var itemInfo = function itemInfo(t) {
  return LINE_ITEM_TYPES[t] || {};
};

var ATTACHMENT_TYPES = {
  placeholder_one: {
    label: "Placeholder One"
  },
  placeholder_two: {
    label: "Placeholder Two"
  },
  placeholder_three: {
    label: "Placeholder Three"
  }
};

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_omit__ = __webpack_require__(2952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inventories_constants__ = __webpack_require__(12);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return shouldSetQcPreapproval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return displayCustRmaWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExchangeIcon; });
/* unused harmony export getParentExchange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isLastExchange; });
/* unused harmony export salesOrderLastExchange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return shipToCountryIsNotUSA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return transformSO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return mapSOToForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return mapROToForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return feeTableHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dropShip; });
/* unused harmony export salesOrderMissingFields */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var shouldSetQcPreapproval = function shouldSetQcPreapproval(company, salesItem) {
  var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  var companyToInvMapping = {
    imperfect_trace: "imperfect_trace",
    no_ders_accepted: "der",
    no_pmas_accepted: "pma"
  };

  var shouldSet = false;
  Object.keys(companyToInvMapping).forEach(function (k) {
    if (company[k] && salesItem[companyToInvMapping[k]]) {
      cb();
      shouldSet = true;
    }
  });

  return shouldSet;
};

var displayCustRmaWarning = function displayCustRmaWarning(_ref) {
  var _ref$customer_rmas = _ref.customer_rmas,
      customerRmas = _ref$customer_rmas === undefined ? [] : _ref$customer_rmas;
  return customerRmas.filter(function (c) {
    return !c.cancelled;
  }).length > 0;
};

var ExchangeIcon = function ExchangeIcon(_ref2) {
  var lineItem = _ref2.lineItem;

  var exchangeTypes = [{ key: "exchange_type", value: null, text: 1 }, { key: __WEBPACK_IMPORTED_MODULE_4__constants__["e" /* FLAT_EXCHANGE */], value: true, text: "F" }, { key: "exchange_type", value: __WEBPACK_IMPORTED_MODULE_4__constants__["l" /* SECOND_EXCHANGE */], text: 2 }, { key: "exchange_type", value: __WEBPACK_IMPORTED_MODULE_4__constants__["m" /* THIRD_EXCHANGE */], text: 3 }, { key: __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["_37" /* EXCHANGE_GONE_OUTRIGHT */], value: true, text: "O" }, { key: __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["_38" /* INTERNAL_OUTRIGHT */], value: true, text: "io" }];

  var filteredVal = exchangeTypes.filter(function (f) {
    return lineItem[f.key] === f.value && (lineItem.exchange_sale || lineItem.exchange_gone_outright || lineItem[__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["_38" /* INTERNAL_OUTRIGHT */]] || lineItem[__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* FLAT_EXCHANGE */]]);
  });

  if (filteredVal.length === 0) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    "span",
    { className: "fa-stack fa-1x" },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i", { className: "fa fa-lg fa-circle text-success" }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      "span",
      { className: "fa fa-stack-1x exchange-circle-text" },
      filteredVal[filteredVal.length - 1].text
    )
  );
};

ExchangeIcon.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({ exchange_sale: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool, exchange_type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string })
};

var getParentExchange = function getParentExchange(salesOrder) {
  return salesOrder.get("line_items").find(function (i) {
    return i.get("parent_exchange_item");
  });
};

var isLastExchange = function isLastExchange(lineItem) {
  return lineItem.exchange_sale && !lineItem.second_exchange_item_id && !lineItem.exchange_type || lineItem.exchange_type === __WEBPACK_IMPORTED_MODULE_4__constants__["l" /* SECOND_EXCHANGE */] && !lineItem.third_exchange_item_id || lineItem.exchange_type === __WEBPACK_IMPORTED_MODULE_4__constants__["m" /* THIRD_EXCHANGE */];
};

var salesOrderLastExchange = function salesOrderLastExchange(salesOrder) {
  return salesOrder.line_items.find(function (l) {
    return isLastExchange(l);
  });
};

var shipToCountryIsNotUSA = function shipToCountryIsNotUSA(values, shippingToAddress) {
  return values.ship_to_type && values.ship_to_type !== "dropship" && shippingToAddress && shippingToAddress.country && shippingToAddress.country !== "US" || values.ship_to_type === "dropship" && __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(values, "ship_to_shipping_address.country") && __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(values, "ship_to_shipping_address.country") !== "US";
};

var transformSO = function transformSO(_ref3) {
  var final_destination_address = _ref3.final_destination_address,
      values = _objectWithoutProperties(_ref3, ["final_destination_address"]);

  return _extends({}, values, {
    final_destination_address: __WEBPACK_IMPORTED_MODULE_3_lodash_omit___default()(final_destination_address, ["company_name"]),
    final_destination_company_name: __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(final_destination_address, "company_name")
  });
};


var mapSOToForm = function mapSOToForm(_ref4) {
  var final_destination_company_name = _ref4.final_destination_company_name,
      final_destination_address = _ref4.final_destination_address,
      salesOrder = _objectWithoutProperties(_ref4, ["final_destination_company_name", "final_destination_address"]);

  return _extends({}, salesOrder, {
    customer_po: salesOrder.customer_purchase_order_number,
    final_destination_address: Object.assign({}, final_destination_address, {
      company_name: final_destination_company_name
    })
  });
};


var mapROToForm = function mapROToForm(_ref5) {
  var ship_to_address = _ref5.ship_to_address,
      repairOrder = _objectWithoutProperties(_ref5, ["ship_to_address"]);

  return _extends({}, repairOrder, {
    final_destination_address: Object.assign({}, ship_to_address, {
      company_name: repairOrder.company && repairOrder.company.name
    })
  });
};


var feeTableHeader = function feeTableHeader(results) {
  if (results.some(function (item) {
    return item.flat_exchange && !item.internal_outright && !item.exchange_gone_outright;
  })) {
    return "Flat Exchange Fee";
  } else if (results.some(function (item) {
    return item.exchange_sale;
  })) {
    return "Exchange Fee";
  }
  return "Sales EA.";
};

var getCost = function getCost(lineItem) {
  // flat exchanges display additional est. repair cost to user in order to
  // display what the item will actually cost vs discounted price
  if (lineItem.flat_exchange) return Number(lineItem.cost) + Number(lineItem.repair_fee);

  if (lineItem.exchange_sale) return lineItem.cost;

  return lineItem.cumulative_cost_per_unit;
};

var dropShip = function dropShip(type) {
  return ["repair_station", "customer", "company", "dropship"].includes(type);
};

var salesOrderMissingFields = function salesOrderMissingFields(contact, company) {
  return company && !company.billing_address || contact && company && ([company.phone, contact.phone1].filter(function (f) {
    return f;
  }).length === 0 || !contact.email || !contact.name);
};

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NoteTooltip__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__ = __webpack_require__(21);
/* harmony export (immutable) */ __webpack_exports__["a"] = AuditedNoteTooltip;






function AuditedNoteTooltip(_ref) {
  var field = _ref.field,
      obj = _ref.obj,
      _ref$includeTime = _ref.includeTime,
      includeTime = _ref$includeTime === undefined ? false : _ref$includeTime,
      _ref$notePrefix = _ref.notePrefix,
      notePrefix = _ref$notePrefix === undefined ? "" : _ref$notePrefix,
      _ref$placement = _ref.placement,
      placement = _ref$placement === undefined ? "right" : _ref$placement;

  if ([undefined, null].includes(obj[field]) || !obj[field + "_audit"]) {
    return null;
  }

  var timeFunc = includeTime ? __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["a" /* shortDateYYandTime */] : __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["b" /* shortDate */];

  var approvalText = notePrefix + "Updated by " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(obj, field + "_audit.updated_by.full_name") + " on " + timeFunc(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(obj, field + "_audit.updated_at"));

  var reason = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(obj, field + "_audit.reason");

  if (reason) {
    approvalText += " | " + reason;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__NoteTooltip__["a" /* default */], {
    color: "rgba(255, 255, 255, 0.25)",
    note: approvalText,
    placement: placement,
    icon: "fa-info-circle"
  });
}

AuditedNoteTooltip.propTypes = {
  field: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  obj: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 105 */,
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIZE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DEVICE_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return State; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Style; });
var Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};

var SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};

var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];

var State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};

var Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actionTypes__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pagination__ = __webpack_require__(683);
/* unused harmony export set */
/* harmony export (immutable) */ __webpack_exports__["b"] = fetch;
/* unused harmony export search */
/* unused harmony export setFilter */
/* unused harmony export pageActions */
/* unused harmony export sync */
/* harmony export (immutable) */ __webpack_exports__["a"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = download;
/* harmony export (immutable) */ __webpack_exports__["f"] = cancelVendorRma;
/* harmony export (immutable) */ __webpack_exports__["d"] = cancelCustomerRma;
/* harmony export (immutable) */ __webpack_exports__["c"] = vendorRmaUpdate;








function set(rma) {
  return { type: __WEBPACK_IMPORTED_MODULE_5__actionTypes__["a" /* SET */], rma: rma };
}

function fetch(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].rmas.show(id).then(function (_ref) {
      var data = _ref.data;
      return dispatch(set(data));
    });
  };
}

var search = __WEBPACK_IMPORTED_MODULE_6__pagination__["a" /* default */].search,
    setFilter = __WEBPACK_IMPORTED_MODULE_6__pagination__["a" /* default */].setFilter,
    pageActions = __WEBPACK_IMPORTED_MODULE_6__pagination__["a" /* default */].pageActions;



function sync() {
  return function (dispatch, getState) {
    var id = getState().rmaDetail.getIn(["rma", "id"]);
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].rmas.sync(id).then(function () {
      __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].success("SUCCESS", "Successfully Synced.");

      return __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__["a" /* SUCCESS */];
    }).catch(function () {
      __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("ERROR", "Sync Failed");
    });
  };
}

function update(data, setForceOpenShipTo) {
  return function (dispatch, getState) {
    var id = getState().rmaDetail.getIn(["rma", "id"]);
    var updatedVendorRmaNumber = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(getState().rmaDetail.getIn(["rma", __WEBPACK_IMPORTED_MODULE_3__constants__["k" /* VENDOR_RMA_NUMBER */]])) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(data[__WEBPACK_IMPORTED_MODULE_3__constants__["k" /* VENDOR_RMA_NUMBER */]]);
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].rmas.update(id, data).then(function (_ref2) {
      var rma = _ref2.data;

      dispatch(set(rma));
      if (updatedVendorRmaNumber && setForceOpenShipTo) {
        setForceOpenShipTo(true);
      }
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function download(data, url) {
  return function (dispatch, getState) {
    var id = getState().rmaDetail.getIn(["rma", "id"]);
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].rmas.update(id, data).then(function (_ref3) {
      var rma = _ref3.data;

      dispatch(set(rma));
      window.location.assign(url);
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function cancelVendorRma() {
  return function (dispatch, getState) {
    var id = getState().rmaDetail.getIn(["rma", "id"]);
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].vendorRmas.cancel(id).then(function (_ref4) {
      var data = _ref4.data;

      dispatch(set(data));
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function cancelCustomerRma() {
  return function (dispatch, getState) {
    var id = getState().rmaDetail.getIn(["rma", "id"]);
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].customerRmas.cancel(id).then(function (_ref5) {
      var data = _ref5.data;

      dispatch(set(data));
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__["a" /* SUCCESS */];
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Error", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(err, "errors.base", []).join(","));
    });
  };
}

function vendorRmaUpdate(data, setForceOpenShipTo) {
  return function (dispatch, getState) {
    var id = getState().rmaDetail.getIn(["rma", "id"]);
    var updatedVendorRmaNumber = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(getState().rmaDetail.getIn(["rma", __WEBPACK_IMPORTED_MODULE_3__constants__["k" /* VENDOR_RMA_NUMBER */]])) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(data[__WEBPACK_IMPORTED_MODULE_3__constants__["k" /* VENDOR_RMA_NUMBER */]]);
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].vendorRmas.update(id, data).then(function (_ref6) {
      var rma = _ref6.data;

      dispatch(set(rma));
      if (updatedVendorRmaNumber && setForceOpenShipTo) {
        setForceOpenShipTo(true);
      }
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_pagination__ = __webpack_require__(67);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return partInventories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return incomingQuotesPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return outgoingQuotesPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return lotsPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return purchaseOrdersPagination; });
/* unused harmony export managedRepairsPagination */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return repairQuotesPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return salesOrdersPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return partsPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();





var partInventories = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_pagination__["a" /* createPaginatedList */])({
  listId: "part/inventories",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.inventories.search,
  stateLocator: function stateLocator(state) {
    return state.partPagination.inventories;
  }
});

var incomingQuotesPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_pagination__["a" /* createPaginatedList */])({
  listId: "part/incomingQuoteLineItems",
  fetch: function fetch(id, search) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.incomingQuoteLineItems.search(id, search);
  },
  stateLocator: function stateLocator(state) {
    return state.partPagination.incomingQuoteLineItems;
  }
});

var outgoingQuotesPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_pagination__["a" /* createPaginatedList */])({
  listId: "part/outgoingQuoteLineItems",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.outgoingQuoteLineItems.search_grouped,
  stateLocator: function stateLocator(state) {
    return state.partPagination.outgoingQuoteLineItems;
  }
});

var lotsPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_pagination__["a" /* createPaginatedList */])({
  listId: "part/lotLineItems",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.lotLineItems.search,
  stateLocator: function stateLocator(state) {
    return state.partPagination.lotLineItems;
  }
});

var purchaseOrdersPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_pagination__["a" /* createPaginatedList */])({
  listId: "part/purchaseOrderLineItems",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.purchaseOrderAndLots.search,
  stateLocator: function stateLocator(state) {
    return state.partPagination.purchaseOrderLineItems;
  }
});

var managedRepairsPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_pagination__["a" /* createPaginatedList */])({
  listId: "part/managedRepairLineItems",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.managedRepairOrderLineItems,
  stateLocator: function stateLocator(state) {
    return state.partPagination.managedRepairOrderLineItems;
  }
});

var repairQuotesPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_pagination__["a" /* createPaginatedList */])({
  listId: "part/repairQuoteLineItems",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.repairQuoteLineItems.search,
  stateLocator: function stateLocator(state) {
    return state.partPagination.repairQuoteLineItems;
  },
  initialSettings: {
    sort: "updated_at"
  }
});

var salesOrdersPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_pagination__["a" /* createPaginatedList */])({
  listId: "part/salesOrderLineItems",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.salesOrderLineItems.search,
  stateLocator: function stateLocator(state) {
    return state.partPagination.salesOrderLineItems;
  }
});

var partsPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_pagination__["a" /* createPaginatedList */])({
  forceDebounce: true,
  listId: "parts",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.search,
  stateLocator: function stateLocator(state) {
    return state.partPagination.main;
  },
  initialSettings: {
    sort: "base_part_number"
  }
});

var partsApi = function partsApi(key) {
  return function (id, _ref) {
    var page = _ref.page,
        limit = _ref.limit;
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts[key].list(id, page, limit);
  };
};

var config = function config(key) {
  var collect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var endpoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : partsApi(key);
  return {
    key: key,
    collect: collect,
    api: endpoint
  };
};

var _paginationGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_pagination__["b" /* paginationGroup */])({
  groupName: "part",
  getId: function getId(state) {
    return state.partDetail.getIn(["part", "id"]);
  },
  locate: function locate(_ref2) {
    var key = _ref2.key;
    return function (state) {
      return state.partPagination[key];
    };
  }
}, config("applications"), config("alternates", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.alternates.search), config("incomingQuoteLineItems", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.incomingQuoteLineItems.search), config("detailIncomingQuoteLineItems", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.incomingQuoteLineItems.search), config("outgoingQuoteLineItems", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.outgoingQuoteLineItems.search_grouped), config("detailOutgoingQuoteLineItems", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.outgoingQuoteLineItems.search), config("inventories", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.inventories.search), config("lotLineItems", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.lotLineItems.search), config("managedRepairOrderLineItems", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.managedRepairOrderLineItems.search), config("purchaseOrderLineItems", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.purchaseOrderAndLots.search), config("repairOrderLineItems", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.repairOrderLineItems.search), config("repairQuoteLineItems", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.repairQuoteLineItems.search), config("detailPurchaseOrderLineItems", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.purchaseOrderLineItems.search), config("salesOrderLineItems", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.salesOrderLineItems.search), config("detailSalesOrderLineItems", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.salesOrderLineItems.search)),
    _paginationGroup2 = _slicedToArray(_paginationGroup, 15),
    applications = _paginationGroup2[0],
    alternates = _paginationGroup2[1],
    incomingQuoteLineItems = _paginationGroup2[2],
    detailIncomingQuoteLineItems = _paginationGroup2[3],
    outgoingQuoteLineItems = _paginationGroup2[4],
    detailOutgoingQuoteLineItems = _paginationGroup2[5],
    inventories = _paginationGroup2[6],
    lotLineItems = _paginationGroup2[7],
    managedRepairOrderLineItems = _paginationGroup2[8],
    purchaseOrderLineItems = _paginationGroup2[9],
    repairOrderLineItems = _paginationGroup2[10],
    repairQuoteLineItems = _paginationGroup2[11],
    detailPurchaseOrderLineItems = _paginationGroup2[12],
    salesOrderLineItems = _paginationGroup2[13],
    detailSalesOrderLineItems = _paginationGroup2[14];

/* harmony default export */ __webpack_exports__["j"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  main: partsPagination.paginator,
  applications: applications,
  alternates: alternates,
  incomingQuoteLineItems: incomingQuoteLineItems,
  detailIncomingQuoteLineItems: detailIncomingQuoteLineItems,
  outgoingQuoteLineItems: outgoingQuoteLineItems,
  detailOutgoingQuoteLineItems: detailOutgoingQuoteLineItems,
  inventories: inventories,
  lotLineItems: lotLineItems,
  managedRepairOrderLineItems: managedRepairOrderLineItems,
  purchaseOrderLineItems: purchaseOrderLineItems,
  repairOrderLineItems: repairOrderLineItems,
  repairQuoteLineItems: repairQuoteLineItems,
  detailPurchaseOrderLineItems: detailPurchaseOrderLineItems,
  salesOrderLineItems: salesOrderLineItems,
  detailSalesOrderLineItems: detailSalesOrderLineItems
}));

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(17);
/* unused harmony export DropDown */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DropDown = function (_Component) {
  _inherits(DropDown, _Component);

  function DropDown() {
    _classCallCheck(this, DropDown);

    return _possibleConstructorReturn(this, (DropDown.__proto__ || Object.getPrototypeOf(DropDown)).apply(this, arguments));
  }

  _createClass(DropDown, [{
    key: "getChildContext",
    value: function getChildContext() {
      return { close: this.props.close };
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          menuClass = _props.menuClass,
          children = _props.children,
          visible = _props.visible,
          toggle = _props.toggle,
          _props$label = _props.label,
          label = _props$label === undefined ? "Actions" : _props$label;


      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("dropdown", { open: visible });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: classes },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          { className: "btn btn-info", onClick: toggle },
          label,
          "\xA0\xA0",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-caret-down" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ul",
          { className: "dropdown-menu " + menuClass },
          children
        )
      );
    }
  }]);

  return DropDown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DropDown.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  menuClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element)]),
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.label
};
DropDown.defaultProps = {
  label: "Actions"
};
DropDown.childContextTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["g" /* dismissible */])(DropDown));

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Notes_isInternalOrExternalNote__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(338);
/* harmony export (immutable) */ __webpack_exports__["d"] = createNoteReducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return notesInitialState; });
/* harmony export (immutable) */ __webpack_exports__["c"] = createAttachmentReducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return attachmentsInitialState; });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






//
// Notes
//
var noteStateKey = function noteStateKey(action) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_Notes_isInternalOrExternalNote__["a" /* default */])(action.notesType)) {
    return action.notesType + "_note";
  }

  return "notes";
};

var getNotes = function getNotes(state, action) {
  var _state$merge;

  return state.merge((_state$merge = {}, _defineProperty(_state$merge, noteStateKey(action), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()), _defineProperty(_state$merge, "notesLoading", true), _state$merge));
};

var setNotes = function setNotes(state, action) {
  var _state$merge2;

  return state.merge((_state$merge2 = {}, _defineProperty(_state$merge2, noteStateKey(action), action.notes), _defineProperty(_state$merge2, "notesLoading", false), _state$merge2));
};

var addNote = function addNote(state, action) {
  var note = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])().merge(action.note);
  var notesKey = noteStateKey(action);
  var notes = state.get(notesKey).unshift(note);
  return state.merge(_defineProperty({}, notesKey, notes));
};

var updateNote = function updateNote(state, action) {
  var notesKey = noteStateKey(action);
  var notes = state.get(notesKey);
  var updatedNotes = notes.map(function (note) {
    if (note.get("id") === action.note.id) {
      return note.merge(action.note);
    }
    return note;
  });

  return state.merge(_defineProperty({}, notesKey, updatedNotes));
};

var removeNote = function removeNote(state, action) {
  var notesKey = noteStateKey(action);
  var updatedNotes = state.get(notesKey).filter(function (note) {
    return note.get("id") !== action.id;
  });
  return state.merge(_defineProperty({}, notesKey, updatedNotes));
};

function createNoteReducer(resource) {
  var _ref;

  var actionType = function actionType(t) {
    return t + "_" + resource;
  };
  return _ref = {}, _defineProperty(_ref, actionType(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["d" /* ADD_NOTE */]), addNote), _defineProperty(_ref, actionType(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["b" /* GET_NOTES */]), getNotes), _defineProperty(_ref, actionType(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["c" /* SET_NOTES */]), setNotes), _defineProperty(_ref, actionType(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* UPDATE_NOTE */]), updateNote), _defineProperty(_ref, actionType(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["e" /* REMOVE_NOTE */]), removeNote), _ref;
}

var notesInitialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  notes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  internal_notes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  external_notes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  notesLoading: false
});

//
// Attachments
//
var getAttachments = function getAttachments(state) {
  return state.merge({ attachments: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(), attachmentsLoading: true });
};

var setAttachments = function setAttachments(state, action) {
  return state.merge({ attachments: action.attachments, attachmentsLoading: false });
};

var addAttachment = function addAttachment(state, action) {
  var attachment = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])().merge(action.attachment);
  var attachments = state.get("attachments").push(attachment);
  return state.merge({ attachments: attachments });
};

var updateAttachment = function updateAttachment(state, action) {
  var attachments = state.get("attachments");
  var updatedAttachments = attachments.map(function (attachment) {
    if (attachment.get("id") === action.attachment.id) {
      return attachment.merge(action.attachment);
    }
    return attachment;
  });

  return state.merge({ attachments: updatedAttachments });
};

var removeAttachment = function removeAttachment(state, action) {
  var updatedAttachments = state.get("attachments").filter(function (attachment) {
    return attachment.get("id") !== action.id;
  });
  return state.merge({ attachments: updatedAttachments });
};

function createAttachmentReducer(resource) {
  var _ref2;

  var actionType = function actionType(t) {
    return t + "_" + resource;
  };
  return _ref2 = {}, _defineProperty(_ref2, actionType(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["h" /* ADD_ATTACHMENT */]), addAttachment), _defineProperty(_ref2, actionType(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["f" /* GET_ATTACHMENTS */]), getAttachments), _defineProperty(_ref2, actionType(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["g" /* SET_ATTACHMENTS */]), setAttachments), _defineProperty(_ref2, actionType(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["i" /* UPDATE_ATTACHMENT */]), updateAttachment), _defineProperty(_ref2, actionType(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["j" /* REMOVE_ATTACHMENT */]), removeAttachment), _ref2;
}

var attachmentsInitialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  attachments: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  attachmentsLoading: false
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 112 */,
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_components_HoverFlag__ = __webpack_require__(209);
/* harmony export (immutable) */ __webpack_exports__["a"] = AsIsFlag;




function AsIsFlag(_ref) {
  var className = _ref.className,
      lineItem = _ref.lineItem;

  if (!lineItem.as_is) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__parts_components_HoverFlag__["a" /* default */], { className: className, text: "As-is", abbr: "AI", inline: true });
}

AsIsFlag.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    as_is: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })
};

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pagination__ = __webpack_require__(430);
/* harmony export (immutable) */ __webpack_exports__["c"] = addLineItem;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return bulkUpdateLineItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchLineItems; });
/* harmony export (immutable) */ __webpack_exports__["d"] = show;
/* harmony export (immutable) */ __webpack_exports__["a"] = searchCompanies;
/* unused harmony export searchFreightForwarderCompanies */
/* harmony export (immutable) */ __webpack_exports__["h"] = sync;
/* harmony export (immutable) */ __webpack_exports__["g"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateLineItem;
/* harmony export (immutable) */ __webpack_exports__["f"] = returnToCustomer;









function refreshManagedRepairOrderAndLineItems(dispatch, mroId) {
  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].managedRepairOrders.show(mroId).then(function (resp) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* SET */], managedRepairOrder: resp.data });
    dispatch(__WEBPACK_IMPORTED_MODULE_7__pagination__["a" /* managedRepairOrderLineItems */].pageActions.expire());
  });
}

function addLineItem(values, mroId, afterCreate) {
  return function (dispatch, getState) {
    var id = mroId || getState().mroDetail.getIn(["managedRepairOrder", "id"]);

    if (values.displayCoBuyerFields) {
      values.add_co_buyer = true;
    }

    if (values.displayThirdBuyerFields) {
      values.add_third_buyer = true;
    }

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].managedRepairOrders.lineItems.create(id, values).then(function () {
      if (afterCreate) {
        afterCreate();
      } else {
        refreshManagedRepairOrderAndLineItems(dispatch, id);
      }
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
    });
  };
}

var bulkUpdateLineItems = function bulkUpdateLineItems(data) {
  return function (dispatch, getState) {
    var repairOrderID = getState().mroDetail.getIn(["managedRepairOrder", "id"]);

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].managedRepairOrders.lineItems.bulkUpdate(repairOrderID, data).then(function () {
      refreshManagedRepairOrderAndLineItems(dispatch, repairOrderID);
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
    });
  };
};

var searchLineItems = function searchLineItems(pageInfo) {
  return function (dispatch, getState) {
    var results = getState().mroDetail.getIn(["managedRepairOrder", "line_items"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])()).toJS();
    var _pageInfo$query = pageInfo.query,
        limit = _pageInfo$query.limit,
        page = _pageInfo$query.page;

    var data = {
      total_count: results.length,
      results: results.slice(limit * page - limit, page * limit)
    };

    return Promise.resolve({ data: data });
  };
};

function show(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].managedRepairOrders.show(id).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* SET */],
        managedRepairOrder: resp.data
      });
    });
  };
}

function searchCompanies(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].companies.search({
      filter: filter,
      status: [__WEBPACK_IMPORTED_MODULE_4__companies_constants__["c" /* ACTIVE */], __WEBPACK_IMPORTED_MODULE_4__companies_constants__["b" /* NO_BIZ */], __WEBPACK_IMPORTED_MODULE_4__companies_constants__["d" /* CREDIT_HOLD */]].join(","),
      sort: "name",
      reverse: false,
      page: 1,
      limit: 20
    }).then(function (resp) {
      return Promise.resolve(resp.data.results);
    });
  };
}

function searchFreightForwarderCompanies(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].companies.search({
      filter: filter,
      sort: "name",
      reverse: false,
      page: 1,
      company_type: "freight_forwarder",
      limit: 20
    }).then(function (resp) {
      return Promise.resolve(resp.data.results);
    });
  };
}

function sync() {
  return function (dispatch, getState) {
    var repairOrderID = getState().mroDetail.getIn(["managedRepairOrder", "id"]);
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].managedRepairOrders.sync(repairOrderID).then(function () {
      __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].success("SUCCESS", "Successfully Synced.");
      refreshManagedRepairOrderAndLineItems(dispatch, repairOrderID);

      return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
    }).catch(function (response) {
      __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].error("ERROR", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["get"])(response, "errors", "Sync Failed"));
    });
  };
}

function update(data) {
  return function (dispatch, getState) {
    var mroID = getState().mroDetail.getIn(["managedRepairOrder", "id"]);

    if (data.contact_id === "Add") {
      data.contact_id = null;
    }

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].managedRepairOrders.update(mroID, data).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* SET */],
        managedRepairOrder: resp.data
      });
      dispatch(__WEBPACK_IMPORTED_MODULE_7__pagination__["a" /* managedRepairOrderLineItems */].pageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function updateLineItem(lineItemId, values) {
  return function (dispatch, getState) {
    var mroId = getState().mroDetail.getIn(["managedRepairOrder", "id"]);

    if (!values.purchase_for_sale && values.reserve_for_seller_id) {
      values.reserve_for_seller_id = null;
    }

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].managedRepairOrders.lineItems.update(lineItemId, values).then(function () {
      refreshManagedRepairOrderAndLineItems(dispatch, mroId);
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function returnToCustomer(lineItemId) {
  return function (dispatch, getState) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].managedRepairOrders.lineItems.returnToCustomer(lineItemId).then(function () {
      var mroId = getState().mroDetail.getIn(["managedRepairOrder", "id"]);
      refreshManagedRepairOrderAndLineItems(dispatch, mroId);
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
    });
  };
}

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_actions_search__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Orders_shared_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shipping_actions__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cable__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dashboard_pagination__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actionTypes__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pagination__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__inventories_constants__ = __webpack_require__(12);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return subscribe; });
/* unused harmony export pageActions */
/* unused harmony export stateLocator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return discrepanciesPageActions; });
/* harmony export (immutable) */ __webpack_exports__["b"] = show;
/* harmony export (immutable) */ __webpack_exports__["c"] = update;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateQCStatus;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildAttachments;
/* harmony export (immutable) */ __webpack_exports__["n"] = save;
/* harmony export (immutable) */ __webpack_exports__["m"] = create;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return resolveDiscrepancy; });
/* harmony export (immutable) */ __webpack_exports__["l"] = resetDiscrepancies;
/* harmony export (immutable) */ __webpack_exports__["f"] = createDiscrepancy;
/* harmony export (immutable) */ __webpack_exports__["e"] = editDiscrepancy;
/* harmony export (immutable) */ __webpack_exports__["h"] = destroyAttachment;
/* harmony export (immutable) */ __webpack_exports__["k"] = unsubscribe;
/* unused harmony export reloadSilent */
/* unused harmony export onDisconnect */


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _discrepancyMap;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



















var pageActions = __WEBPACK_IMPORTED_MODULE_15__pagination__["a" /* receivingRecordsSearch */].pageActions,
    stateLocator = __WEBPACK_IMPORTED_MODULE_15__pagination__["a" /* receivingRecordsSearch */].stateLocator;


var _createSearch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_actions_search__["a" /* default */])("discrepancies");

var discrepanciesPageActions = _createSearch.pageActions;



function show(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].receivingRecord.show(id).then(function (resp) {
      return dispatch({
        type: __WEBPACK_IMPORTED_MODULE_13__actionTypes__["a" /* SET */],
        receivingRecord: resp.data
      });
    });
  };
}

function update(data) {
  return function (dispatch, getState) {
    var receivingRecordID = getState().receivingRecordDetail.getIn(["receivingRecord", "id"]);
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].receivingRecord.update(receivingRecordID, data).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_13__actionTypes__["a" /* SET */],
        receivingRecord: resp.data
      });
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function updateQCStatus(data) {
  return function (dispatch, getState) {
    var receivingRecordID = getState().receivingRecordDetail.getIn(["receivingRecord", "id"]);
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].receivingRecord.updateQcStatus(receivingRecordID, data).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_13__actionTypes__["a" /* SET */],
        receivingRecord: resp.data
      });

      return __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function buildAttachmentFiles(attachment) {
  var fileName = "" + (+new Date() - Math.floor(Math.random() * 10000000000)) + attachment.file.name;
  return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].attachments.upload(fileName).then(function (resp) {
    var _resp$data = resp.data,
        key = _resp$data.key,
        url = _resp$data.url;

    var formattedAttachment = {
      attachment_type: attachment.attachment_type,
      name: fileName,
      key: key
    };
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].attachments.toS3(url, attachment.file).then(function () {
      return Promise.resolve(formattedAttachment);
    }).catch(function (e) {
      return Promise.reject(e);
    });
  });
}

function buildDiscrepancyFiles(file) {
  var fileName = "" + (+new Date() - Math.floor(Math.random() * 10000000000)) + file.name;
  return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].attachments.upload(fileName).then(function (resp) {
    var _resp$data2 = resp.data,
        key = _resp$data2.key,
        url = _resp$data2.url;

    var formattedAttachment = {
      attachment_type: __WEBPACK_IMPORTED_MODULE_14__constants__["m" /* DISCREPANCY */],
      name: fileName,
      key: key
    };
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].attachments.toS3(url, file).then(function () {
      return Promise.resolve(formattedAttachment);
    }).catch(function (e) {
      return Promise.reject(e);
    });
  });
}

function buildAttachments() {
  var attachment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (attachment.uploaded) {
    return Promise.resolve(attachment);
  }

  return new Promise(function (resolve, _) {
    return buildAttachmentFiles(attachment).then(function (file) {
      resolve(file);
    }).catch(function (e) {
      return Promise.reject(e);
    });
  });
}

var discrepancyMap = (_discrepancyMap = {
  part_id: {
    discrepancy_type: __WEBPACK_IMPORTED_MODULE_14__constants__["n" /* PART_NUMBER_DISCREPANCY */]
  }
}, _defineProperty(_discrepancyMap, __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["n" /* CONDITION */], {
  discrepancy_type: __WEBPACK_IMPORTED_MODULE_14__constants__["o" /* CONDITION_DISCREPANCY */]
}), _defineProperty(_discrepancyMap, __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["o" /* SERIAL_NUMBER */], {
  discrepancy_type: __WEBPACK_IMPORTED_MODULE_14__constants__["p" /* SERIAL_NUMBER_DISCREPANCY */]
}), _defineProperty(_discrepancyMap, __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["p" /* TAGGED_BY */], {
  discrepancy_type: __WEBPACK_IMPORTED_MODULE_14__constants__["q" /* TAGGED_BY_DISCREPANCY */]
}), _defineProperty(_discrepancyMap, __WEBPACK_IMPORTED_MODULE_9__constants__["o" /* SHIPPING_TYPE */], {
  discrepancy_type: __WEBPACK_IMPORTED_MODULE_14__constants__["r" /* RECEIVING_STORE_INCORRECT */]
}), _discrepancyMap);

function isDiscrepancy(key, formData, lineItem) {
  if (!lineItem) return null;
  var type = lineItem && lineItem.type;
  if ((key === __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["n" /* CONDITION */] || key === __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["o" /* SERIAL_NUMBER */]) && type === __WEBPACK_IMPORTED_MODULE_2__Orders_shared_constants__["e" /* SO_ITEM */]) {
    return false;
  }

  if (key === __WEBPACK_IMPORTED_MODULE_9__constants__["o" /* SHIPPING_TYPE */]) {
    if (lineItem[__WEBPACK_IMPORTED_MODULE_9__constants__["o" /* SHIPPING_TYPE */]] !== __WEBPACK_IMPORTED_MODULE_10__shared_components_ShippingSection_shippingTypes__["a" /* TENANT_LOCATION */]) return false;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, "ship_to_location.id") !== __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__hooks__["a" /* useCurrentUser */])().location_id;
  }

  if (key === __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["p" /* TAGGED_BY */] && type !== __WEBPACK_IMPORTED_MODULE_2__Orders_shared_constants__["a" /* PO_ITEM */]) {
    return false;
  }

  if (key === __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["o" /* SERIAL_NUMBER */] && type === "Rma") {
    return false;
  }

  var defaultValue = lineItem[key];

  if (key === __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["q" /* PART_ID */] && lineItem.type === __WEBPACK_IMPORTED_MODULE_2__Orders_shared_constants__["b" /* RO_ITEM */]) {
    if (lineItem.approval_status === __WEBPACK_IMPORTED_MODULE_12__RepairOrders_constants__["a" /* REPAIR_EVALUATION_APPROVED */] && lineItem.mod_to_id) {
      return formData.part_id !== lineItem.mod_to_id;
    }

    return formData.part_id !== lineItem.part_id;
  }

  if (lineItem.type === __WEBPACK_IMPORTED_MODULE_2__Orders_shared_constants__["a" /* PO_ITEM */]) {
    if (key === __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["q" /* PART_ID */]) {
      return ![lineItem.part_id, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, "alternate.alternate_part_id"), lineItem.mod_to_id].includes(formData.part_id);
    } else if (key === __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["o" /* SERIAL_NUMBER */]) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(lineItem[__WEBPACK_IMPORTED_MODULE_7__PurchaseOrders_constants__["b" /* EXPECTED_SERIAL_NUMBER */]])) {
        return formData.serial_number !== lineItem[__WEBPACK_IMPORTED_MODULE_7__PurchaseOrders_constants__["b" /* EXPECTED_SERIAL_NUMBER */]];
      }
      return false;
    }
  }

  if ([__WEBPACK_IMPORTED_MODULE_16__inventories_constants__["q" /* PART_ID */], __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["o" /* SERIAL_NUMBER */]].includes(key) && lineItem.type === __WEBPACK_IMPORTED_MODULE_2__Orders_shared_constants__["b" /* RO_ITEM */] && lineItem.mod_to_id === formData.part_id) {
    return false;
  }

  return lineItem[key] && formData[key] !== defaultValue;
}

function buildAutomaticDiscrepancies(formData) {
  var lineItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return [__WEBPACK_IMPORTED_MODULE_16__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["q" /* PART_ID */], __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["o" /* SERIAL_NUMBER */], __WEBPACK_IMPORTED_MODULE_9__constants__["o" /* SHIPPING_TYPE */], __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["p" /* TAGGED_BY */]].filter(function (key) {
    return isDiscrepancy(key, formData, lineItem);
  }).map(function (type) {
    return Object.assign(discrepancyMap[type], { attachments: [] });
  });
}

function save(_ref) {
  var id = _ref.id,
      formData = _ref.formData;

  var dash = formData.received_virtually ? __WEBPACK_IMPORTED_MODULE_8__Dashboard_pagination__["a" /* virtualReceivingDashboardOrders */] : __WEBPACK_IMPORTED_MODULE_8__Dashboard_pagination__["b" /* receivingDashboardOrders */];

  return function (dispatch) {
    return Promise.all((formData.attachments || []).map(function (attachment) {
      return attachment.files.map(function (f) {
        return _extends({
          file: f
        }, attachment);
      });
    }).flat().map(buildAttachments)).then(function (attachments) {
      var formattedData = Object.assign({}, formData, {
        attachments: attachments
      });
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].receivingRecord.save(id, formattedData).then(function () {
        dispatch(dash.pageActions.expire());
        return __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__["a" /* SUCCESS */];
      });
    });
  };
}

function create(_ref2) {
  var formData = _ref2.formData,
      lineItem = _ref2.lineItem;

  return function (dispatch) {
    return Promise.all((formData.attachments || []).map(function (attachment) {
      return (attachment.files || [{}]).map(function (f) {
        return _extends({
          file: f
        }, attachment);
      });
    }).flat().map(buildAttachments)).then(function (attachments) {
      var discrepancies = buildAutomaticDiscrepancies(formData, lineItem);
      var formattedData = Object.assign({}, formData, {
        attachments: attachments,
        discrepancies: discrepancies
      });

      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].receivingRecord.create(formattedData).then(function (_ref3) {
        var data = _ref3.data;

        dispatch({
          type: __WEBPACK_IMPORTED_MODULE_13__actionTypes__["a" /* SET */],
          receivingRecord: data
        });

        var anyCheckListFalse = ["shipped_properly", "vendor_packing_list_included", "packing_list_and_tags_match", "passed_damage_inspection", "release_certificate_included"].some(function (f) {
          return !data[f];
        });

        if ((data.discrepancies.length > 0 || (!data.received_virtually || data.reference_record_line_item_type === "InventoryTransferOrder") && anyCheckListFalse) && ![__WEBPACK_IMPORTED_MODULE_14__constants__["s" /* EMA */], __WEBPACK_IMPORTED_MODULE_14__constants__["d" /* MISTAKE_SHIPMENT */]].includes(formData.receiving_type)) {
          dispatch({
            type: __WEBPACK_IMPORTED_MODULE_13__actionTypes__["b" /* SET_DISCREPANCIES */],
            discrepancies: data.discrepancies
          });
          dispatch({ type: __WEBPACK_IMPORTED_MODULE_13__actionTypes__["c" /* SET_MODAL */], showModal: true });
        }
        if (formData.reported) {
          dispatch({ type: __WEBPACK_IMPORTED_MODULE_13__actionTypes__["c" /* SET_MODAL */], showModal: true });
        }
        return __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__["a" /* SUCCESS */];
      });
    }).catch(function (e) {
      return Promise.reject(e);
    });
  };
}

function buildDiscrepancies(discrepancy) {
  return new Promise(function (resolve, _) {
    if (!discrepancy.files) {
      resolve(Object.assign({}, discrepancy, { attachments: [] }));
    } else {
      Promise.all(discrepancy.files.map(buildDiscrepancyFiles)).then(function (attachments) {
        resolve(Object.assign({}, discrepancy, { attachments: attachments }));
      }).catch(function (e) {
        return Promise.reject(e);
      });
    }
  });
}

function refreshReceivingAndDiscrepancies(dispatch, receivingRecordId) {
  return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].receivingRecord.show(receivingRecordId).then(function (resp) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_13__actionTypes__["a" /* SET */],
      receivingRecord: resp.data
    });
    dispatch(discrepanciesPageActions.expire());
  });
}

var resolveDiscrepancy = function resolveDiscrepancy(discrepancy) {
  return function (dispatch, getState) {
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].discrepancy.resolve(discrepancy.id, discrepancy).then(function () {
      var receivingRecordID = getState().receivingRecordDetail.getIn(["receivingRecord", "id"]);
      refreshReceivingAndDiscrepancies(dispatch, receivingRecordID);
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
};

function resetDiscrepancies() {
  return function (dispatch) {
    return dispatch({ type: __WEBPACK_IMPORTED_MODULE_13__actionTypes__["d" /* REMOVE_DISCREPANCIES */] });
  };
}

function createDiscrepancy(data) {
  return function (dispatch, getState) {
    var receivingRecordID = getState().receivingRecordDetail.getIn(["receivingRecord", "id"]);
    return Promise.all(data.discrepancies.map(buildDiscrepancies)).then(function (discrepancies) {
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].discrepancy.create(receivingRecordID, { discrepancies: discrepancies }).then(function () {
        refreshReceivingAndDiscrepancies(dispatch, receivingRecordID);
        resetDiscrepancies();
        return __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__["a" /* SUCCESS */];
      }).catch(function (e) {
        return Promise.reject(e);
      });
    });
  };
}

function editDiscrepancy(discrepancy) {
  return function (dispatch, getState) {
    var receivingRecordID = getState().receivingRecordDetail.getIn(["receivingRecord", "id"]);
    return buildDiscrepancies(discrepancy).then(function (formattedDiscrepancy) {
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].discrepancy.update(formattedDiscrepancy.id, { discrepancy: formattedDiscrepancy }).then(function () {
        refreshReceivingAndDiscrepancies(dispatch, receivingRecordID);
        return __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__["a" /* SUCCESS */];
      }).catch(function (e) {
        return Promise.reject(e);
      });
    });
  };
}

function destroyAttachment(id) {
  return function (dispatch, getState) {
    var receivingRecordID = getState().receivingRecordDetail.getIn(["receivingRecord", "id"]);
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].attachments.destroy(id).then(function () {
      refreshReceivingAndDiscrepancies(dispatch, receivingRecordID);
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

var channel = null;

function unsubscribe() {
  return function () {
    if (channel) {
      channel.unsubscribe();
      channel = null;
    }
  };
}

function reloadSilent() {
  return function (dispatch, getState) {
    var currentState = getState();
    var paginator = stateLocator(currentState);
    var filters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shipping_actions__["b" /* buildFilters */])(paginator);

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].receivingRecord.search(filters).then(function (_ref4) {
      var data = _ref4.data;

      dispatch(pageActions.resetResults(data.results));
    });
  };
}

function onDisconnect() {
  return unsubscribe();
}

function subscribe() {
  var _onReceive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reloadSilent;

  return function (dispatch) {
    if (!channel) {
      var _createChannel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__cable__["b" /* createChannel */])(),
          listen = _createChannel.listen;

      channel = listen("ReceivingRecordsChannel", {
        onDisconnect: onDisconnect,
        onReceive: function onReceive(data) {
          if (["CREATE"].includes(data.action)) {
            dispatch(_onReceive(data));
          }
        }
      });
    }
  };
}

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
// TODO: This module should be ElementChildren, and should use named exports.



/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */
function map(children, func, context) {
  var index = 0;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return child;
    }

    return func.call(context, child, index++);
  });
}

/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */
function forEach(children, func, context) {
  var index = 0;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    func.call(context, child, index++);
  });
}

/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */
function count(children) {
  var result = 0;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    ++result;
  });

  return result;
}

/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */
function filter(children, func, context) {
  var index = 0;
  var result = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result.push(child);
    }
  });

  return result;
}

function find(children, func, context) {
  var index = 0;
  var result = undefined;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = child;
    }
  });

  return result;
}

function every(children, func, context) {
  var index = 0;
  var result = true;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (!func.call(context, child, index++)) {
      result = false;
    }
  });

  return result;
}

function some(children, func, context) {
  var index = 0;
  var result = false;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = true;
    }
  });

  return result;
}

function toArray(children) {
  var result = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    result.push(child);
  });

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  map: map,
  forEach: forEach,
  count: count,
  find: find,
  filter: filter,
  every: every,
  some: some,
  toArray: toArray
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony export (immutable) */ __webpack_exports__["b"] = countryCode;
/* harmony export (immutable) */ __webpack_exports__["d"] = countryName;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESTRICTED_COUNTRIES; });


// Data borrowed from country-list: https://github.com/fannarsh/country-list
var countries = [{ code: "AD", name: "Andorra", region: "Africa" }, { code: "AF", name: "Afghanistan", region: "Asia/Pacific" }, { code: "AG", name: "Antigua and Barbuda", region: "Asia/Pacific" }, { code: "AI", name: "Anguilla", region: "Asia/Pacific" }, { code: "AL", name: "Albania", region: "Europe" }, { code: "AM", name: "Armenia", region: "Asia/Pacific" }, { code: "AO", name: "Angola", region: "Africa" }, { code: "AQ", name: "Antarctica", region: "Antartica" }, { code: "AR", name: "Argentina", region: "Central/South America" }, { code: "AS", name: "American Samoa", region: "Asia/Pacific" }, { code: "AT", name: "Austria", region: "Asia/Pacific" }, { code: "AU", name: "Australia", region: "Asia/Pacific" }, { code: "AW", name: "Aruba", region: "Central/South America" }, { code: "AX", name: "Åland Islands", region: "Europe" }, { code: "AZ", name: "Azerbaijan", region: "Middle East" }, { code: "BA", name: "Bosnia and Herzegovina", region: "Europe" }, { code: "BB", name: "Barbados", region: "North America" }, { code: "BD", name: "Bangladesh", region: "Asia/Pacific" }, { code: "BE", name: "Belgium", region: "Europe" }, { code: "BF", name: "Burkina Faso", region: "Africa" }, { code: "BG", name: "Bulgaria", region: "Eastern Europe" }, { code: "BH", name: "Bahrain", region: "Asia/Pacific" }, { code: "BI", name: "Burundi", region: "Africa" }, { code: "BJ", name: "Benin", region: "Africa" }, { code: "BL", name: "Saint Barthélemy", region: "Central/South America" }, { code: "BM", name: "Bermuda", region: "North America" }, { code: "BN", name: "Brunei Darussalam", region: "Asia/Pacific" }, {
  code: "BO",
  name: "Bolivia, Plurinational State of",
  region: "Central/South America"
}, {
  code: "BQ",
  name: "Bonaire, Sint Eustatius and Saba",
  region: "Central/South America"
}, { code: "BR", name: "Brazil", region: "Central/South America" }, { code: "BS", name: "Bahamas", region: "North America" }, { code: "BT", name: "Bhutan", region: "Asia/Pacific" }, { code: "BV", name: "Bouvet Island", region: "Africa" }, { code: "BW", name: "Botswana", region: "Africa" }, { code: "BY", name: "Belarus", region: "Eastern Europe", restricted: true }, { code: "BZ", name: "Belize", region: "Central/South America" }, { code: "CA", name: "Canada", region: "North America" }, {
  code: "CC",
  name: "Cocos (Keeling) Islands",
  region: "Central/South America"
}, { code: "CD", name: "Congo, Democratic Republic of the", region: "Africa" }, { code: "CF", name: "Central African Republic", region: "Africa" }, { code: "CG", name: "Congo", region: "Africa" }, { code: "CH", name: "Switzerland", region: "Europe" }, { code: "CI", name: "Côte d'Ivoire", region: "Africa" }, { code: "CK", name: "Cook Islands", region: "Asia/Pacific" }, { code: "CL", name: "Chile", region: "Central/South America" }, { code: "CM", name: "Cameroon", region: "Africa" }, { code: "CN", name: "China", region: "Asia/Pacific" }, { code: "CO", name: "Colombia", region: "Central/South America" }, { code: "CR", name: "Costa Rica", region: "Central/South America" }, {
  code: "CU",
  name: "Cuba",
  region: "Central/South America",
  restricted: true
}, { code: "CV", name: "Cabo Verde", region: "Africa" }, { code: "CW", name: "Curaçao", region: "Central/South America" }, { code: "CX", name: "Christmas Island", region: "Asia/Pacific" }, { code: "CY", name: "Cyprus", region: "Eastern Europe" }, { code: "CZ", name: "Czechia", region: "Europe" }, { code: "DE", name: "Germany", region: "Europe" }, { code: "DJ", name: "Djibouti", region: "Africa" }, { code: "DK", name: "Denmark", region: "Europe" }, { code: "DM", name: "Dominica", region: "Central/South America" }, { code: "DO", name: "Dominican Republic", region: "Central/South" }, { code: "DZ", name: "Algeria", region: "Africa" }, { code: "EC", name: "Ecuador", region: "Central/South America" }, { code: "EE", name: "Estonia", region: "Europe" }, { code: "EG", name: "Egypt", region: "Africa" }, { code: "EH", name: "Western Sahara", region: "Africa" }, { code: "ER", name: "Eritrea", region: "Africa" }, { code: "ES", name: "Spain", region: "Europe" }, { code: "ET", name: "Ethiopia", region: "Africa" }, { code: "FI", name: "Finland", region: "Europe" }, { code: "FJ", name: "Fiji", region: "Asia/Pacific" }, {
  code: "FK",
  name: "Falkland Islands (Malvinas)",
  region: "Central/South America"
}, {
  code: "FM",
  name: "Micronesia, Federated States of",
  region: "Asia/Pacific"
}, { code: "FO", name: "Faroe Islands", region: "Europe" }, { code: "FR", name: "France", region: "Europe" }, { code: "GA", name: "Gabon", region: "Africa" }, {
  code: "GB",
  name: "United Kingdom of Great Britain and Northern Ireland",
  region: "Europe"
}, { code: "GD", name: "Grenada", region: "Central/South America" }, { code: "GE", name: "Georgia", region: "Eastern Europe" }, { code: "GF", name: "French Guiana", region: "Central/South America" }, { code: "GG", name: "Guernsey", region: "Europe" }, { code: "GH", name: "Ghana", region: "Africa" }, { code: "GI", name: "Gibraltar", region: "Europe" }, { code: "GL", name: "Greenland", region: "Europe" }, { code: "GM", name: "Gambia", region: "Africa" }, { code: "GN", name: "Guinea", region: "Africa" }, { code: "GP", name: "Guadeloupe", region: "Central/South America" }, { code: "GQ", name: "Equatorial Guinea", region: "Africa" }, { code: "GR", name: "Greece", region: "Europe" }, {
  code: "GS",
  name: "South Georgia and the South Sandwich Islands",
  region: "Central/South America"
}, { code: "GT", name: "Guatemala", region: "Central/South America" }, { code: "GU", name: "Guam", region: "Asia/Pacific" }, { code: "GW", name: "Guinea-Bissau", region: "Africa" }, { code: "GY", name: "Guyana", region: "Central/South America" }, { code: "HK", name: "Hong Kong", region: "Asia/Pacific" }, {
  code: "HM",
  name: "Heard Island and McDonald Islands",
  region: "Asia/Pacific"
}, { code: "HN", name: "Honduras", region: "Central/South America" }, { code: "HR", name: "Croatia", region: "Eastern Europe" }, { code: "HT", name: "Haiti", region: "Central/South America" }, { code: "HU", name: "Hungary", region: " Eastern Europe" }, { code: "ID", name: "Indonesia", region: "Asia/Pacific" }, { code: "IRE", name: "Ireland", region: "Europe" }, { code: "IL", name: "Israel", region: "Middle East" }, { code: "IM", name: "Isle of Man", region: "Europe" }, { code: "IN", name: "India", region: "Asia/Pacific" }, {
  code: "IO",
  name: "British Indian Ocean Territory",
  region: "Asia/Pacific"
}, { code: "IQ", name: "Iraq", region: "Middle East" }, {
  code: "IR",
  name: "Iran, Islamic Republic of",
  region: "Middle East",
  restricted: true
}, { code: "IS", name: "Iceland", region: "Europe" }, { code: "IT", name: "Italy", region: "Europe" }, { code: "JE", name: "Jersey", region: "Europe" }, { code: "JM", name: "Jamaica", region: "North America" }, { code: "JO", name: "Jordan", region: "Middle East" }, { code: "JP", name: "Japan", region: "Asia/Pacific" }, { code: "KE", name: "Kenya", region: "Africa" }, { code: "KG", name: "Kyrgyzstan", region: "Asia/Pacific" }, { code: "KH", name: "Cambodia", region: "Asia/Pacific" }, { code: "KI", name: "Kiribati", region: "Asia/Pacific" }, { code: "KM", name: "Comoros", region: "Africa" }, {
  code: "KN",
  name: "Saint Kitts and Nevis",
  region: "Central/South America"
}, {
  code: "KP",
  name: "Korea, Democratic People's Republic of",
  region: "Asia/Pacific",
  restricted: true
}, { code: "KR", name: "Korea, Republic of", region: "Asia/Pacific" }, { code: "XK", name: "Kosovo", region: "Europe" }, { code: "KW", name: "Kuwait", region: "Middle East" }, { code: "KY", name: "Cayman Islands", region: "Central/South America" }, { code: "KZ", name: "Kazakhstan", region: "Asia/Pacific" }, {
  code: "LA",
  name: "Lao People's Democratic Republic",
  region: "Asia/Pacific"
}, { code: "LB", name: "Lebanon", region: "Middle East" }, { code: "LC", name: "Saint Lucia", region: "Central/South America" }, { code: "LI", name: "Liechtenstein", region: "Europe" }, { code: "LK", name: "Sri Lanka", region: "Asia/Pacific" }, { code: "LR", name: "Liberia", region: "Africa" }, { code: "LS", name: "Lesotho", region: "Africa" }, { code: "LT", name: "Lithuania", region: "Eastern Europe" }, { code: "LU", name: "Luxembourg", region: "Europe" }, { code: "LV", name: "Latvia", region: "Eastern Europe" }, { code: "LY", name: "Libya", region: "Africa" }, { code: "MA", name: "Morocco", region: "Africa" }, { code: "MC", name: "Monaco", region: "Europe" }, { code: "MD", name: "Moldova, Republic of", region: "Eastern Europe" }, { code: "ME", name: "Montenegro", region: "Eastern Europe" }, {
  code: "MF",
  name: "Saint Martin, (French part)",
  region: "Central/South America"
}, { code: "MG", name: "Madagascar", region: "Africa" }, { code: "MH", name: "Marshall Islands", region: "Asia/Pacific" }, { code: "MK", name: "North Macedonia", region: "Eastern Europe" }, { code: "ML", name: "Mali", region: "Africa" }, { code: "MM", name: "Myanmar", region: "Asia/Pacific" }, { code: "MN", name: "Mongolia", region: "Asia/Pacific" }, { code: "MO", name: "Macao", region: "Asia/Pacific" }, { code: "MP", name: "Northern Mariana Islands", region: "Asia/Pacific" }, { code: "MQ", name: "Martinique", region: "Central/South America" }, { code: "MR", name: "Mauritania", region: "Asia/Pacific" }, { code: "MS", name: "Montserrat", region: "Central/South America" }, { code: "MT", name: "Malta", region: "Europe" }, { code: "MU", name: "Mauritius", region: "Africa" }, { code: "MV", name: "Maldives", region: "Asia/Pacific" }, { code: "MW", name: "Malawi", region: "Africa" }, { code: "MX", name: "Mexico", region: "North America" }, { code: "MY", name: "Malaysia", region: "Asia/Pacific" }, { code: "MZ", name: "Mozambique", region: "Africa" }, { code: "NA", name: "Namibia", region: "Africa" }, { code: "NC", name: "New Caledonia", region: "Asia/Pacific" }, { code: "NE", name: "Niger", region: "Africa" }, { code: "NF", name: "Norfolk Island", region: "Asia/Pacific" }, { code: "NG", name: "Nigeria", region: "Africa" }, { code: "NI", name: "Nicaragua", region: "Central/South America" }, { code: "NL", name: "Netherlands", region: "Europe" }, { code: "NO", name: "Norway", region: "Europe" }, { code: "NP", name: "Nepal", region: "Asia/Pacific" }, { code: "NR", name: "Nauru", region: "Asia/Pacific" }, { code: "NU", name: "Niue", region: "Asia/Pacific" }, { code: "NZ", name: "New Zealand", region: "Asia/Pacific" }, { code: "OM", name: "Oman", region: "Middle East" }, { code: "PA", name: "Panama", region: "Central/South America" }, { code: "PE", name: "Peru", region: "Central/South America" }, { code: "PF", name: "French Polynesia", region: "Asia/Pacific" }, { code: "PG", name: "Papua New Guinea", region: "Asia/Pacific" }, { code: "PH", name: "Philippines", region: "Asia/Pacific" }, { code: "PK", name: "Pakistan", region: "Asia/Pacific" }, { code: "PL", name: "Poland", region: "Eastern Europe" }, { code: "PM", name: "Saint Pierre and Miquelon", region: "North America" }, { code: "PN", name: "Pitcairn", region: "Central/South America" }, { code: "PR", name: "Puerto Rico", region: "Central/South America" }, { code: "PS", name: "Palestine, State of", region: "Middle East" }, { code: "PT", name: "Portugal", region: "Europe" }, { code: "PW", name: "Palau", region: "Asia/Pacific" }, { code: "PY", name: "Paraguay", region: "Central/South America" }, { code: "QA", name: "Qatar", region: "Middle East" }, { code: "RE", name: "Réunion", region: "Africa" }, { code: "RO", name: "Romania", region: "Eastern Europe" }, { code: "RS", name: "Serbia", region: "Eastern Europe" }, {
  code: "RU",
  name: "Russian Federation",
  region: "Eastern Europe",
  restricted: true
}, { code: "RW", name: "Rwanda", region: "Africa" }, { code: "SA", name: "Saudi Arabia", region: "Middle East" }, { code: "SB", name: "Solomon Islands", region: "Asia/Pacific" }, { code: "SC", name: "Seychelles", region: "Africa" }, { code: "SD", name: "Sudan", region: "Africa" }, { code: "SE", name: "Sweden", region: "Europe" }, { code: "SG", name: "Singapore", region: "Asia/Pacific" }, {
  code: "SH",
  name: "Saint Helena, Ascension and Tristan da Cunha",
  region: "Central/South America"
}, { code: "SI", name: "Slovenia", region: "Eastern Europe" }, { code: "SJ", name: "Svalbard and Jan Mayen", region: "Europe" }, { code: "SK", name: "Slovakia", region: "Europe" }, { code: "SL", name: "Sierra Leone", region: "Africa" }, { code: "SM", name: "San Marino", region: "Europe" }, { code: "SN", name: "Senegal", region: "Africa" }, { code: "SO", name: "Somalia", region: "Africa" }, { code: "SR", name: "Suriname", region: "Asia/Pacific" }, { code: "SS", name: "South Sudan", region: "Africa" }, { code: "ST", name: "Sao Tome and Principe", region: "Africa" }, { code: "SV", name: "El Salvador", region: "Central/South America" }, { code: "SX", name: "Sint Maarten, (Dutch part)", region: "Europe" }, {
  code: "SY",
  name: "Syrian Arab Republic",
  region: "Middle East",
  restricted: true
}, { code: "SZ", name: "Eswatini", region: "Africa" }, { code: "TC", name: "Turks and Caicos Islands", region: "North America" }, { code: "AE", name: "United Arab Emirates", region: "Middle East" }, { code: "TD", name: "Chad", region: "Africa" }, { code: "TF", name: "French Southern Territories", region: "Asia/Pacific" }, { code: "TG", name: "Togo", region: "Africa" }, { code: "TH", name: "Thailand", region: "Asia/Pacific" }, { code: "TJ", name: "Tajikistan", region: "Asia/Pacific" }, { code: "TK", name: "Tokelau", region: "Asia/Pacific" }, { code: "TL", name: "Timor-Leste", region: "Asia/Pacific" }, { code: "TM", name: "Turkmenistan", region: "Asia/Pacific" }, { code: "TN", name: "Tunisia", region: "Africa" }, { code: "TO", name: "Tonga", region: "Asia/Pacific" }, { code: "TR", name: "Turkey", region: "Middle East" }, { code: "TT", name: "Trinidad and Tobago", region: "Central/South America" }, { code: "TV", name: "Tuvalu", region: "Asia/Pacific" }, { code: "TW", name: "Taiwan, Province of China", region: "Asia/Pacific" }, { code: "TZ", name: "Tanzania, United Republic of", region: "Africa" }, { code: "UA", name: "Ukraine", region: "Eastern Europe" }, { code: "UG", name: "Uganda", region: "Africa" }, {
  code: "UM",
  name: "United States Minor Outlying Islands",
  region: "North America"
}, { code: "UY", name: "Uruguay", region: "Central/South America" }, { code: "UZ", name: "Uzbekistan", region: "Asia/Pacific" }, { code: "VA", name: "Holy See", region: "Europe" }, {
  code: "VC",
  name: "Saint Vincent and the Grenadines",
  region: "Central/South America"
}, {
  code: "VE",
  name: "Venezuela, Bolivarian Republic of",
  region: "Central/South America",
  restricted: true
}, {
  code: "VG",
  name: "Virgin Islands, British",
  region: "Central/South America"
}, { code: "VI", name: "Virgin Islands, U.S.", region: "Central/South America" }, { code: "VN", name: "Viet Nam", region: "Asia/Pacific" }, { code: "VU", name: "Vanuatu", region: "Asia/Pacific" }, { code: "WF", name: "Wallis and Futuna", region: "Asia/Pacific" }, { code: "WS", name: "Samoa", region: "Asia/Pacific" }, { code: "YE", name: "Yemen", region: "Middle East" }, { code: "YT", name: "Mayotte", region: "Africa" }, { code: "ZA", name: "South Africa", region: "Africa" }, { code: "ZM", name: "Zambia", region: "Africa" }, { code: "ZW", name: "Zimbabwe", region: "Africa" }].sort(function (a, b) {
  return a.name.localeCompare(b.name);
});

var allCountries = [{ code: "US", name: "United States of America", region: "North America" }].concat(countries);

var countriesKeyedByCode = null;

function countriesByCode() {
  // Memoize countriesKeyedByCode
  if (!countriesKeyedByCode) {
    countriesKeyedByCode = allCountries.reduce(function (result, c) {
      return result.set(c.code, c.name);
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).toJS();
  }

  return countriesKeyedByCode;
}

var countriesKeyedByName = null;

function countriesByName() {
  if (!countriesKeyedByName) {
    countriesKeyedByName = countries.reduce(function (result, c) {
      return result.set(c.name, c.code);
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).toJS();
  }

  return countriesKeyedByName;
}

function countryCode(name) {
  return countriesByName()[name] || name;
}

function countryName(code) {
  return countriesByCode()[code] || code;
}

var RESTRICTED_COUNTRIES = allCountries.filter(function (c) {
  return c.restricted;
});

/* harmony default export */ __webpack_exports__["a"] = (allCountries);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShippingFields__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ShippingFields__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShipToFields__ = __webpack_require__(661);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__ShipToFields__["a"]; });
/* unused harmony reexport SHIPPING_TYPES */







/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectPrimaryContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return contactSelectList; });



var PORTAL_PURCHASE_OPTION = {
  text: "Portal Purchase",
  value: __WEBPACK_IMPORTED_MODULE_0__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */]
};

var selectPrimaryContact = function selectPrimaryContact(contacts)
// eslint-disable-next-line consistent-return
{
  var change = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var handleEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  if (!contacts) return null;

  var primaryContact = contacts.filter(function (c) {
    return c.primary;
  })[0];
  if (primaryContact) {
    change(primaryContact.id);
    handleEmail(primaryContact.email);
  }
};

var contactSelectList = function contactSelectList(contacts) {
  var allowPortalPurchase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var options = [{
    text: "+ Add a Contact",
    value: "Add"
  }];

  var displayEmail = function displayEmail(val) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(val) ? " <" + val + ">" : null;
  };
  if (allowPortalPurchase) {
    options = options.concat([PORTAL_PURCHASE_OPTION]);
  }
  return contacts.map(function (val) {
    return {
      text: "" + val.name + displayEmail(val.email),
      value: val.id
    };
  }).concat(options);
};

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = NoteTooltip;




function NoteTooltip(_ref) {
  var className = _ref.className,
      color = _ref.color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? "17px" : _ref$height,
      _ref$hideTooltip = _ref.hideTooltip,
      hideTooltip = _ref$hideTooltip === undefined ? false : _ref$hideTooltip,
      _ref$icon = _ref.icon,
      icon = _ref$icon === undefined ? "fa-info-circle" : _ref$icon,
      note = _ref.note,
      placement = _ref.placement,
      url = _ref.url,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick;

  /* eslint react/no-danger: 0 */
  var tooltip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["b" /* Tooltip */],
    { className: "in" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: note } })
  );

  if (hideTooltip) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw " + icon + " " + className, style: { color: color } });
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* OverlayTrigger */],
    { placement: placement, overlay: tooltip, onClick: onClick },
    url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: url, alt: note, height: height, className: className }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw " + icon + " " + className, style: { color: color } })
  );
}

NoteTooltip.defaultProps = {
  placement: "left",
  className: "",
  icon: "fa-sticky-note",
  color: "#ff9800"
};

NoteTooltip.propTypes = {
  placement: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  note: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  icon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  hideTooltip: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  url: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translateProps__ = __webpack_require__(193);
/* harmony export (immutable) */ __webpack_exports__["a"] = withFormFields;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return withFormFieldsByKey; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





function withFormFields(Component) {
  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  function WithFormFields(_ref) {
    var rest = _objectWithoutProperties(_ref, []);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Fields"], _extends({ names: fields, component: Component }, rest));
  }

  return WithFormFields;
}

var withFormFieldsByKey = function withFormFieldsByKey(Component) {
  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var TranslatedComp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__translateProps__["a" /* default */])(function (props) {
    return Object.keys(fields).reduce(function (prev, current) {
      return _extends({}, prev, _defineProperty({}, fields[current], props[current]));
    }, {});
  })(Component);

  return withFormFields(TranslatedComp, Object.keys(fields));
};

/***/ }),
/* 122 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(90);
var createDesc = __webpack_require__(224);
module.exports = __webpack_require__(89) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(60);
var hide = __webpack_require__(123);
var has = __webpack_require__(122);
var SRC = __webpack_require__(228)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(156).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
var fails = __webpack_require__(66);
var defined = __webpack_require__(157);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(921);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = groupBy;
/* harmony export (immutable) */ __webpack_exports__["b"] = findMatch;
/* harmony export (immutable) */ __webpack_exports__["c"] = compact;
/* harmony export (immutable) */ __webpack_exports__["d"] = remove;
/* harmony export (immutable) */ __webpack_exports__["a"] = removeItems;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function groupBy(array, prop) {
  return array.reduce(function (groups, item) {
    var key = item[prop];
    var items = groups[key] || [];

    return _extends({}, groups, _defineProperty({}, key, items.concat(item)));
  }, {});
}

function findMatch(array, word) {
  return array.filter(function (a) {
    return a.indexOf(word) > 0;
  })[0];
}

function compact(array) {
  return array.filter(function (x) {
    return x;
  });
}

function remove(array, key) {
  var newArr = array.slice(0);
  var index = newArr.indexOf(key);
  newArr.splice(index, 1);

  return newArr;
}

function removeItems(arr) {
  var newArr = arr.slice(0);

  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  keys.forEach(function (k) {
    newArr = remove(newArr, k);
  });

  return newArr;
}

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony export (immutable) */ __webpack_exports__["b"] = isLessThan36HoursAgo;
/* harmony export (immutable) */ __webpack_exports__["e"] = isLessThan24HoursAgo;
/* harmony export (immutable) */ __webpack_exports__["a"] = addDays;
/* harmony export (immutable) */ __webpack_exports__["c"] = monthsAgo;
/* harmony export (immutable) */ __webpack_exports__["d"] = daysAgo;


function isLessThan36HoursAgo(timestamp) {
  if (!timestamp) return false;

  var THIRTY_SIX_HOURS = 60 * 60 * 1000 * 36;
  return new Date() - new Date(timestamp) < THIRTY_SIX_HOURS;
}

function isLessThan24HoursAgo(timestamp) {
  if (!timestamp) return false;

  var TWENTY_FOUR_HOURS = 60 * 60 * 1000 * 24;
  return new Date() - new Date(timestamp) < TWENTY_FOUR_HOURS;
}

function addDays(date, days) {
  if (!date || !days) return null;

  var newDate = new Date(date);
  return newDate.setTime(newDate.getTime() + days * 86400000);
}

function monthsAgo(number) {
  if (!number) return null;

  return __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(number, "months");
}

function daysAgo(number) {
  if (!number) return null;

  return __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(number, "days");
}

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__session__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__channels_notification__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actionTypes__ = __webpack_require__(276);
/* harmony export (immutable) */ __webpack_exports__["login"] = login;
/* harmony export (immutable) */ __webpack_exports__["update"] = update;
/* harmony export (immutable) */ __webpack_exports__["clear"] = clear;
/* harmony export (immutable) */ __webpack_exports__["expire"] = expire;
/* harmony export (immutable) */ __webpack_exports__["refreshCarts"] = refreshCarts;
/* harmony export (immutable) */ __webpack_exports__["setCarts"] = setCarts;
/* harmony export (immutable) */ __webpack_exports__["logout"] = logout;
/* harmony export (immutable) */ __webpack_exports__["loginError"] = loginError;
/* harmony export (immutable) */ __webpack_exports__["setPushId"] = setPushId;
/* harmony export (immutable) */ __webpack_exports__["authenticate"] = authenticate;












function login(user, settings) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__channels_notification__["a" /* subscribe */])();

  var fullName = user.full_name,
      email = user.email,
      created_at = user.created_at,
      hash = user.intercom_hash;


  window.Intercom("boot", {
    api_base: "https://api-iam.intercom.io",
    app_id: "uo2xpwcp",
    name: fullName,
    email: email,
    user_hash: hash,
    created_at: created_at
  });

  return {
    type: __WEBPACK_IMPORTED_MODULE_10__actionTypes__["a" /* LOGIN */],
    user: user,
    settings: settings
  };
}

function update(user) {
  var fullName = user.full_name,
      email = user.email,
      created_at = user.created_at,
      hash = user.intercom_hash;


  window.Intercom("boot", {
    api_base: "https://api-iam.intercom.io",
    app_id: "uo2xpwcp",
    name: fullName,
    email: email,
    user_hash: hash,
    created_at: created_at
  });

  return {
    type: __WEBPACK_IMPORTED_MODULE_10__actionTypes__["b" /* UPDATE */],
    user: user
  };
}

function clear() {
  return { type: __WEBPACK_IMPORTED_MODULE_10__actionTypes__["c" /* CLEAR */] };
}

function expire() {
  return function (dispatch) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__channels_notification__["b" /* unsubscribe */])();
    __WEBPACK_IMPORTED_MODULE_5__session__["a" /* default */].logout();
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["push"])("/login"));
    dispatch(clear());
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__["expireAll"])());
  };
}

function refreshCarts() {
  return function (dispatch, getState) {
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].users.show(getState().session.getIn([__WEBPACK_IMPORTED_MODULE_9__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_8__constants__["c" /* UUID */]])).then(function (_ref) {
      var user = _ref.data;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_10__actionTypes__["d" /* REFRESH_CARTS */],
        user: user
      });
    });
  };
}

function setCarts(_ref2) {
  var bookmarks = _ref2.bookmarks,
      repairCartItems = _ref2.repairCartItems,
      salesCartItems = _ref2.salesCartItems;

  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_10__actionTypes__["e" /* SET_CARTS */],
      bookmarks: bookmarks,
      repairCartItems: repairCartItems,
      salesCartItems: salesCartItems
    });
  };
}

function logout() {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].session.logout().then(function () {
      return dispatch(expire());
    });
  };
}

function loginError(message) {
  return { type: __WEBPACK_IMPORTED_MODULE_10__actionTypes__["f" /* LOGIN_ERROR */], message: message };
}

function setPushId(pushId) {
  return { type: __WEBPACK_IMPORTED_MODULE_10__actionTypes__["g" /* PUSH_ID */], pushId: pushId };
}

function initializeRollbarForUser(user) {
  if (true) {
    try {
      // eslint-disable-next-line
      Rollbar.configure({
        payload: {
          person: {
            id: user.id,
            username: user.full_name,
            email: user.email
          }
        }
      });
    } catch (ex) {
      // eslint-disable-next-line
      console.log("Unable to initialize Rollbar for user");
    }
  }
}

function authenticate(user) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].session.authenticate(user).then(function (resp) {
      dispatch(login(resp.data.user, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(resp, "data.settings.settings", {})));

      var _resp$data$user = resp.data.user,
          bookmarks = _resp$data$user.bookmarks,
          repairCartItems = _resp$data$user.repair_order_cart_items,
          salesCartItems = _resp$data$user.sales_order_cart_items;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_10__actionTypes__["e" /* SET_CARTS */],
        bookmarks: bookmarks,
        repairCartItems: repairCartItems,
        salesCartItems: salesCartItems
      });

      var message = "Welcome, " + resp.data.user.full_name + ".";

      var path = "/";
      if (resp.data.user.password_reset_at) {
        var diff = __WEBPACK_IMPORTED_MODULE_7_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_7_moment___default()(resp.data.user.password_reset_at), "days");

        var _resp$data$user2 = resp.data.user,
            fullName = _resp$data$user2.full_name,
            email = _resp$data$user2.email,
            created_at = _resp$data$user2.created_at,
            hash = _resp$data$user2.intercom_hash;


        if (!["development", "staging"].includes("production")) {
          /* eslint-disable no-undef */
          Upscope("updateConnection", {
            uniqueId: resp.data.user.id,
            identities: [fullName, email]
          });
        }

        window.Intercom("boot", {
          api_base: "https://api-iam.intercom.io",
          app_id: "uo2xpwcp",
          name: fullName,
          email: email,
          user_hash: hash,
          created_at: created_at
        });

        var daysUntilExpiration = 90 - diff;

        if (daysUntilExpiration <= 5) {
          path = "/users/" + resp.data.user.uuid;
          __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].error("PLEASE RESET YOUR PASSWORD OR YOU WILL BE LOCKED OUT IN " + daysUntilExpiration + " DAY/S.");
        } else {
          message += "You have " + daysUntilExpiration + " days until your password expires.";
          __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].success("Logged In", message);
        }
      }

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["push"])(path));

      initializeRollbarForUser(resp.data.user);
    }).catch(function (err) {
      if (err.status === 418) {
        dispatch(setPushId(err.push_id));
      } else {
        dispatch(loginError(err.response.data.message));
      }
    });
  };
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(293);
var createDesc = __webpack_require__(224);
var toIObject = __webpack_require__(134);
var toPrimitive = __webpack_require__(160);
var has = __webpack_require__(122);
var IE8_DOM_DEFINE = __webpack_require__(850);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(89) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(122);
var toObject = __webpack_require__(97);
var IE_PROTO = __webpack_require__(533)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(292);
var defined = __webpack_require__(157);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actioncable__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actioncable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_actioncable__);
/* harmony export (immutable) */ __webpack_exports__["a"] = initialize;
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["b"] = createChannel;


var connection = null;

var socket =  false ? process.env.WEBSOCKET : "wss://" + window.location.host.replace("www.", "") + "/websocket";

function initialize(store) {
  if (!connection) {
    connection = {
      store: store,
      cable: __WEBPACK_IMPORTED_MODULE_0_actioncable___default.a.createConsumer(socket)
    };
  }
}

function cable() {
  if (!connection) {
    throw new Error("Connection not established");
  }

  return connection;
}

function createChannel() {
  var bridge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cable();

  function disconnect() {
    var onDisconnect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

    return function disconnected() {
      this.unsubscribe();
      onDisconnect(bridge.store);
    };
  }

  function listen(name, _ref) {
    var _ref$onDisconnect = _ref.onDisconnect,
        onDisconnect = _ref$onDisconnect === undefined ? function () {} : _ref$onDisconnect,
        _ref$onReceive = _ref.onReceive,
        onReceive = _ref$onReceive === undefined ? function () {} : _ref$onReceive;

    return bridge.cable.subscriptions.create(name, {
      disconnected: disconnect(onDisconnect),
      received: onReceive
    });
  }

  return { listen: listen, disconnect: disconnect };
}

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrays__ = __webpack_require__(129);
/* harmony export (immutable) */ __webpack_exports__["a"] = fobFormat;
/* harmony export (immutable) */ __webpack_exports__["c"] = addressFormat;
/* harmony export (immutable) */ __webpack_exports__["b"] = addressFormatDropDown;



function fobFormat(address) {
  return address ? [address.city, address.state, address.country].join("-") : "";
}

function addressFormat(address) {
  return address ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__arrays__["c" /* compact */])([address.company_name, address.care_of, address.line1, address.line2, (address.city || "") + ", " + (address.state || "") + " " + (address.postal_code || ""), address.country]).map(function (a, idx) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { key: idx },
      a,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)
    );
  }) : "";
}

function addressFormatDropDown(address) {
  return address ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__arrays__["c" /* compact */])([address.company_name, address.care_of, address.line1, address.line2, (address.city || "") + ", " + (address.state || "") + " " + (address.postal_code || ""), address.country]).join(" ") : "";
}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pagination__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actionTypes__ = __webpack_require__(425);
/* unused harmony export setIncomingQuoteWithAllLineItems */
/* harmony export (immutable) */ __webpack_exports__["b"] = show;
/* harmony export (immutable) */ __webpack_exports__["h"] = fetchIncomingQuoteWithAllLineItems;
/* harmony export (immutable) */ __webpack_exports__["k"] = getCompany;
/* harmony export (immutable) */ __webpack_exports__["i"] = importLineItems;
/* harmony export (immutable) */ __webpack_exports__["a"] = importOutgoingQuoteLineItems;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateIncomingQuote;
/* harmony export (immutable) */ __webpack_exports__["f"] = convertToOutgoingQuote;
/* harmony export (immutable) */ __webpack_exports__["d"] = createIncomingQuoteLineItem;
/* harmony export (immutable) */ __webpack_exports__["j"] = deleteIncomingQuote;
/* harmony export (immutable) */ __webpack_exports__["c"] = updateIncomingQuoteLineItem;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteIncomingQuoteLineItem;
/* harmony export (immutable) */ __webpack_exports__["l"] = convertQuoteToPurchaseOrder;











function setIncomingQuoteWithAllLineItems(incomingQuoteWithAllLineItems) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["a" /* SET_INCOMING_QUOTE_WITH_ALL_LINE_ITEMS */],
    incomingQuoteWithAllLineItems: incomingQuoteWithAllLineItems
  };
}

function show(id, type) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].incomingQuotes.show(id, type).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["b" /* SET */],
        incomingQuote: resp.data
      });
      if (!type) {
        dispatch(setIncomingQuoteWithAllLineItems(resp.data));
      }
      return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function fetchIncomingQuoteWithAllLineItems(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].incomingQuotes.show(id).then(function (_ref) {
      var data = _ref.data;

      dispatch(setIncomingQuoteWithAllLineItems(data));
      return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function getCompany(id) {
  return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].companies.show(id).then(function (resp) {
    return Promise.resolve(resp.data);
  });
}

function importLineItems(values) {
  return function (dispatch, getState) {
    var id = getState().incomingQuoteDetail.getIn(["incomingQuote", __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]]);
    var fileName = values.file.name;

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].attachments.upload(values.file.name).then(function (resp) {
      var _resp$data = resp.data,
          key = _resp$data.key,
          url = _resp$data.url;

      var formattedAttachment = {
        name: fileName,
        key: key,
        quote_type: values.quote_type
      };

      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].attachments.toS3(url, values.file).then(function () {
        return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].incomingQuotes.lineItems.import(id, formattedAttachment).then(function () {
          show(id);
          __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].info("Processing", "Importing Incoming Quote.");
          return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
        });
      }).catch(function (e) {
        return Promise.reject(e);
      });
    });
  };
}

function importOutgoingQuoteLineItems(values) {
  return function (dispatch, getState) {
    var id = getState().outgoingQuoteDetail.getIn(["outgoingQuote", __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]]);
    var fileName = values.file.name;

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].attachments.upload(values.file.name).then(function (resp) {
      var _resp$data2 = resp.data,
          key = _resp$data2.key,
          url = _resp$data2.url;

      var formattedAttachment = {
        name: fileName,
        key: key,
        quote_type: values.quote_type
      };

      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].attachments.toS3(url, values.file).then(function () {
        return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].outgoingQuotes.lineItems.import(id, formattedAttachment).then(function () {
          show(id);
          __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].info("Processing", "Importing Outgoing Quote.");
          return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
        });
      }).catch(function (e) {
        return Promise.reject(e);
      });
    });
  };
}

function updateIncomingQuote(data) {
  return function (dispatch, getState) {
    var quoteID = getState().incomingQuoteDetail.getIn(["incomingQuote", __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]]);

    var uuid = getState().incomingQuoteDetail.getIn(["incomingQuote", __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* UUID */]]);

    if (data.contact_id === __WEBPACK_IMPORTED_MODULE_5__constants__["F" /* ADD */]) {
      data.contact_id = null;
    }

    if (data.contact_id === __WEBPACK_IMPORTED_MODULE_6__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */]) {
      data.contact_id = null;
      data.portal_purchase = true;
    }

    if (data.contact_id || data.contact && data.contact.email) {
      data.portal_purchase = false;
    }

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].incomingQuotes.update(quoteID, data).then(function () {
      dispatch(show(uuid, "no_lines"));
      dispatch(__WEBPACK_IMPORTED_MODULE_8__pagination__["a" /* incomingQuotePagination */].pageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function convertToOutgoingQuote(id, params) {
  return function (dispatch) {
    if (params.contact_id === __WEBPACK_IMPORTED_MODULE_5__constants__["F" /* ADD */]) {
      params.contact_id = null;
    }
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].incomingQuotes.lineItems.convertToOutgoingQuote(id, params).then(function (_ref2) {
      var data = _ref2.data;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["push"])("/outgoing-quotes/" + data.uuid));
    });
  };
}

function createIncomingQuoteLineItem(data) {
  return function (dispatch, getState) {
    var quoteID = getState().incomingQuoteDetail.getIn(["incomingQuote", "id"]);

    var uuid = getState().incomingQuoteDetail.getIn(["incomingQuote", __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* UUID */]]);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].incomingQuotes.lineItems.create(quoteID, data).then(function () {
      dispatch(show(uuid));
      dispatch(fetchIncomingQuoteWithAllLineItems(uuid));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__pagination__["b" /* expireLineItems */])());
      return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function deleteIncomingQuote() {
  return function (dispatch, getState) {
    var quoteID = getState().incomingQuoteDetail.getIn(["incomingQuote", "id"]);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].incomingQuotes.delete(quoteID).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["push"])("/incoming-quotes"));
      return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function updateIncomingQuoteLineItem(data, itemID) {
  return function (dispatch, getState) {
    var quoteID = getState().incomingQuoteDetail.getIn(["incomingQuote", "id"]);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].incomingQuotes.lineItems.update(itemID, data).then(function () {
      dispatch(show(quoteID));
      dispatch(fetchIncomingQuoteWithAllLineItems(quoteID));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__pagination__["b" /* expireLineItems */])());
      return __WEBPACK_IMPORTED_MODULE_4__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function deleteIncomingQuoteLineItem(id) {
  return function (dispatch, getState) {
    var quoteID = getState().incomingQuoteDetail.getIn(["incomingQuote", "id"]);
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].incomingQuotes.lineItems.delete(id).then(function () {
      dispatch(show(quoteID));
      dispatch(fetchIncomingQuoteWithAllLineItems(quoteID));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__pagination__["b" /* expireLineItems */])());
    });
  };
}

function convertQuoteToPurchaseOrder(itemIds) {
  return function (dispatch, getState) {
    var quoteId = getState().incomingQuoteDetail.getIn(["incomingQuote", "id"]);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].incomingQuotes.convertToPurchaseOrder(quoteId, itemIds).then(function (_ref3) {
      var data = _ref3.data;
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["push"])("/purchase-orders/" + data.uuid));
    }).catch(function (err) {
      // Its possible to submit a subset of the line items list, so we need to perform a small
      // transformation on the errors returned from server before handing them off to redux-form.
      // This ensures the server-side errors are properly matched up with their form fields.

      if (!err.errors.line_items || err.errors.line_items.length === 0) {
        throw new __WEBPACK_IMPORTED_MODULE_1_redux_form__["SubmissionError"](err.errors);
      }

      // Clone the server-side error map so we can safely modify it by filling in any gaps between
      // error indexes with null values.
      var modifiedErrors = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(err.errors).toJS();
      var includedLineItemxIdx = 0;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])("incomingQuoteConvertToPurchaseOrders")(getState(), "line_items").forEach(function (item, idx) {
        if (item.included) {
          modifiedErrors.line_items[idx] = err.errors.line_items[includedLineItemxIdx];
          includedLineItemxIdx += 1;
        } else {
          modifiedErrors.line_items[idx] = null;
        }
      });

      throw new __WEBPACK_IMPORTED_MODULE_1_redux_form__["SubmissionError"](modifiedErrors);
    });
  };
}

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormSections__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_arrays__ = __webpack_require__(129);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













function ShippingFields(_ref) {
  var children = _ref.children,
      _ref$doNotShip = _ref.doNotShip,
      doNotShip = _ref$doNotShip === undefined ? false : _ref$doNotShip,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$required = _ref.required,
      required = _ref$required === undefined ? true : _ref$required,
      _ref$ship_to_fields_r = _ref.ship_to_fields_required,
      shipToFieldsRequired = _ref$ship_to_fields_r === undefined ? true : _ref$ship_to_fields_r,
      _ref$renderCarrier = _ref.renderCarrier,
      renderCarrier = _ref$renderCarrier === undefined ? true : _ref$renderCarrier,
      _ref$setTenantAccount = _ref.setTenantAccount,
      setTenantAccount = _ref$setTenantAccount === undefined ? false : _ref$setTenantAccount,
      _ref$enableReturnToTy = _ref.enableReturnToType,
      enableReturnToType = _ref$enableReturnToTy === undefined ? true : _ref$enableReturnToTy,
      _ref$rmaRequestForm = _ref.rmaRequestForm,
      rmaRequestForm = _ref$rmaRequestForm === undefined ? false : _ref$rmaRequestForm,
      props = _objectWithoutProperties(_ref, ["children", "doNotShip", "disabled", "required", "ship_to_fields_required", "renderCarrier", "setTenantAccount", "enableReturnToType", "rmaRequestForm"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["b" /* ShipToFields */], _extends({}, props, {
          required: shipToFieldsRequired,
          disabled: disabled,
          enableReturnToType: enableReturnToType,
          rmaRequestForm: rmaRequestForm
        }))
      )
    ),
    children,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["m" /* DashedSeparator */], null),
    renderCarrier && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_redux_form__["FormSection"],
      { name: props.shippingMethod },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormSections__["a" /* ShippingMethod */], {
        setTenantAccount: setTenantAccount,
        required: required,
        disabled: disabled,
        doNotShip: doNotShip
      })
    )
  );
}

ShippingFields.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element)]),
  doNotShip: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  renderCarrier: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  ship_to_fields_required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  setTenantAccount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  shippingMethod: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var selector = function selector(form) {
  for (var _len = arguments.length, other = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    other[_key - 1] = arguments[_key];
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(form).apply(undefined, other);
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state, ownProps) {
  return {
    doNotShip: selector(ownProps.formName, state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_arrays__["b" /* findMatch */])(ownProps.shippingFields, "type")) === __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__["d" /* DO_NOT_SHIP */],
    country: selector(ownProps.formName, state, ownProps.shippingAddressField + ".country"),
    city: selector(ownProps.formName, state, ownProps.shippingAddressField + ".city"),
    province: selector(ownProps.formName, state, ownProps.shippingAddressField + ".state")
  };
})(ShippingFields));

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formField__ = __webpack_require__(142);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rounder; });
/* unused harmony export NumberInput */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var rounder = function rounder(value) {
  var roundDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "2";
  return value && value.toString() ? Number(value).toFixed(roundDigits) : null;
};

var NumberInput = function (_React$Component) {
  _inherits(NumberInput, _React$Component);

  function NumberInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NumberInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NumberInput.__proto__ || Object.getPrototypeOf(NumberInput)).call.apply(_ref, [this].concat(args))), _this), _this.roundValue = function (value) {
      var change = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var roundedVal = rounder(value, _this.props.roundDigits);
      _this.props.input.onChange(roundedVal);

      if (change) {
        _this.props.input.onBlur(roundedVal);
      }
    }, _this.handleBlur = function (e) {
      var value = e.target.value;
      _this.roundValue(value);
    }, _this.numberInputOnWheelPreventChange = function (e) {
      e.target.blur();
      e.stopPropagation();
      setTimeout(function () {
        e.target && e.target.focus();
      }, 0);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NumberInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var value = this.props.input.value;
      this.roundValue(value, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          type = _props.type,
          className = _props.className,
          input = _props.input,
          autoComplete = _props.autoComplete,
          readOnly = _props.readOnly,
          disabled = _props.disabled,
          inputProps = _props.inputProps;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({
        type: type,
        autoComplete: autoComplete,
        id: input.name,
        className: "form-control " + className,
        readOnly: readOnly,
        disabled: disabled
      }, input, inputProps, {
        onBlur: this.handleBlur,
        onWheel: this.numberInputOnWheelPreventChange
      }));
    }
  }]);

  return NumberInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formField__["a" /* default */])(NumberInput));

NumberInput.defaultProps = {
  type: "number",
  className: "",
  autoComplete: "off",
  readOnly: false,
  disabled: false,
  roundDigits: 2,
  inputProps: {}
};

NumberInput.propTypes = {
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
  }).isRequired,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  roundDigits: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    min: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
    max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
    placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
  })
};

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* unused harmony export FormField */
/* harmony export (immutable) */ __webpack_exports__["a"] = formField;




function FormField(_ref) {
  var input = _ref.input,
      meta = _ref.meta,
      label = _ref.label,
      required = _ref.required,
      addon = _ref.addon,
      append = _ref.append,
      children = _ref.children,
      labelChildren = _ref.labelChildren;

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("form-group", {
    "has-error": meta.touched && meta.invalid
  });
  var asterisk = required && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "sup",
    { className: "small text-danger" },
    "*"
  );

  var errors = meta.touched && meta.invalid && meta.error.map(function (m) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "help-block", key: m },
      m
    );
  });

  var getAddOns = function getAddOns() {
    if (addon) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "input-group" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "input-group-addon" },
          addon
        ),
        children
      );
    }

    if (append) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "input-group" },
        children,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "input-group-addon" },
          append
        )
      );
    }

    return children;
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: classes },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "label",
        { className: "control-label", htmlFor: input.name },
        label,
        asterisk,
        labelChildren
      ),
      getAddOns(),
      errors
    )
  );
}

FormField.propTypes = {
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired }).isRequired,
  meta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
  }).isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  labelChildren: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  append: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function formField(Component) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      FormField,
      props,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, props)
    );
  };
}

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NoteTooltip_NoteTooltip__ = __webpack_require__(120);
/* harmony export (immutable) */ __webpack_exports__["a"] = LocationFlag;










var Badge = function Badge(_ref) {
  var consignmentType = _ref.consignmentType,
      consignorCost = _ref.consignorCost,
      tooltip = _ref.tooltip;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["a" /* OverlayTrigger */],
    { placement: "top", overlay: tooltip },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      {
        className: "badge",
        style: {
          backgroundColor: consignorCost > 0 ? "#cc7a00" : "#757575"
        }
      },
      consignmentType === "consignment" ? "CONS" : "EMA"
    )
  );
};

var ConsignmentToolTip = function ConsignmentToolTip(_ref2) {
  var consignmentType = _ref2.consignmentType,
      inventory = _ref2.inventory;

  var consignorCost = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(inventory, "consignor_cost");
  var consignmentReference = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(inventory, "consignment_reference");
  var consignorCostTooltip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["b" /* Tooltip */],
    { className: "in" },
    "Cons Ref #: " + consignmentReference + " | Consignor Cost is " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(consignorCost) + "."
  );
  var consignmentReferenceTooltip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["b" /* Tooltip */],
    { className: "in" },
    "Cons Ref #: " + consignmentReference
  );

  if (!consignorCost || consignorCost <= 0) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Badge, {
      consignmentType: consignmentType,
      consignorCost: consignorCost,
      tooltip: consignmentReferenceTooltip
    });
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["a" /* OverlayTrigger */],
    { placement: "top", overlay: consignorCostTooltip },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      {
        className: "badge",
        style: {
          backgroundColor: consignorCost > 0 ? "#cc7a00" : "#757575"
        }
      },
      consignmentType === "consignment" ? "CONS" : "EMA"
    )
  );
};

function LocationFlag(_ref3) {
  var inventory = _ref3.inventory,
      location = _ref3.location,
      transferStatus = _ref3.transferStatus,
      wareHouseId = _ref3.wareHouseId,
      _ref3$consignment_typ = _ref3.consignment_type,
      consignmentType = _ref3$consignment_typ === undefined ? undefined : _ref3$consignment_typ;

  if (__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["e" /* CURRENTLY_TRANSFERRING_STATUSES */].includes(transferStatus)) {
    var displayInTransferStatusLabel = __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["f" /* STATUSES */][transferStatus] && __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["f" /* STATUSES */][transferStatus].label;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__NoteTooltip__["a" /* NoteTooltip */], {
      icon: "fa-2x fa-plane",
      note: displayInTransferStatusLabel,
      color: "#FFFFFF"
    });
  }

  if (consignmentType) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConsignmentToolTip, {
      consignmentType: consignmentType,
      inventory: inventory
    });
  }

  if (!location) return null;

  if (wareHouseId) {
    var wareHouses = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["a" /* useCurrentUser */])(), "tenant.ware_houses", []);

    if (wareHouses.length > 0) {
      var wareHouse = wareHouses.find(function (w) {
        return w.id === wareHouseId;
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__NoteTooltip_NoteTooltip__["a" /* default */], {
        url: "https://info-trader-assets.s3.us-east-2.amazonaws.com/locations/" + location + "/flag.png",
        note: wareHouse.name,
        height: "auto"
      });
    }
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "https://info-trader-assets.s3.us-east-2.amazonaws.com/locations/" + location + "/flag.png",
    alt: location
  });
}

LocationFlag.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  consignment_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  transferStatus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return percentFormatter; });
/* unused harmony export dollarFormatter */
/* unused harmony export numberFormatter */
/* harmony export (immutable) */ __webpack_exports__["a"] = number;
/* harmony export (immutable) */ __webpack_exports__["b"] = dollar;
/* harmony export (immutable) */ __webpack_exports__["d"] = percent;
/* harmony export (immutable) */ __webpack_exports__["c"] = numberAndPercent;
/* harmony export (immutable) */ __webpack_exports__["e"] = dollarAndPercent;


var percentFormatter = function percentFormatter(v) {
  return __WEBPACK_IMPORTED_MODULE_0_numeral___default()(v).format("(0,0.[0])") + "%";
};

var dollarFormatter = function dollarFormatter(v) {
  return __WEBPACK_IMPORTED_MODULE_0_numeral___default()(v).format("($0,0)");
};

var numberFormatter = function numberFormatter(v) {
  return __WEBPACK_IMPORTED_MODULE_0_numeral___default()(v).format("(0,0.[0])");
};

function number(amount) {
  if (amount === undefined) {
    return "-";
  }
  if (isNaN(amount)) {
    return amount;
  }
  return numberFormatter(amount);
}

function dollar(amount) {
  if (amount === undefined) {
    return "-";
  }
  return dollarFormatter(amount);
}

function percent(amount) {
  if (amount === undefined) {
    return "-";
  }
  return percentFormatter(amount);
}

function numberAndPercent(volumeAmount, percentAmount) {
  if (volumeAmount === undefined || percentAmount === undefined) {
    return "-";
  }
  return numberFormatter(volumeAmount) + " (" + percentFormatter(percentAmount) + ")";
}

function dollarAndPercent(volumeAmount, percentAmount) {
  if (volumeAmount === undefined || percentAmount === undefined) {
    return "-";
  }
  return dollarFormatter(volumeAmount) + " (" + percentFormatter(percentAmount) + ")";
}

/***/ }),
/* 145 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(111);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(66);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cable__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Subscription_actionTypes__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actionTypes__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pagination__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__incomingQuotes__ = __webpack_require__(334);
/* unused harmony reexport incomingQuoteActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__outgoingQuotes__ = __webpack_require__(2123);
/* unused harmony reexport outgoingQuoteActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__managedRepairOrders__ = __webpack_require__(2122);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__managedRepairOrders__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__repairOrders__ = __webpack_require__(2124);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_14__repairOrders__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__salesOrders__ = __webpack_require__(2125);
/* unused harmony reexport salesOrderActions */
/* unused harmony export partsAlternatesActions */
/* harmony export (immutable) */ __webpack_exports__["q"] = create;
/* harmony export (immutable) */ __webpack_exports__["c"] = show;
/* harmony export (immutable) */ __webpack_exports__["r"] = searchPartsByStatus;
/* harmony export (immutable) */ __webpack_exports__["j"] = update;
/* harmony export (immutable) */ __webpack_exports__["g"] = searchInventories;
/* harmony export (immutable) */ __webpack_exports__["s"] = searchOutgoingQuoteLineItems;
/* unused harmony export searchIncomingQuoteLineItems */
/* harmony export (immutable) */ __webpack_exports__["n"] = searchParts;
/* harmony export (immutable) */ __webpack_exports__["b"] = searchPoParts;
/* harmony export (immutable) */ __webpack_exports__["k"] = searchMatchingPartNumbers;
/* harmony export (immutable) */ __webpack_exports__["o"] = createAlternate;
/* harmony export (immutable) */ __webpack_exports__["m"] = updateAlternate;
/* harmony export (immutable) */ __webpack_exports__["l"] = deleteAlternate;
/* harmony export (immutable) */ __webpack_exports__["e"] = searchCompanies;
/* harmony export (immutable) */ __webpack_exports__["h"] = searchQuoteCompanies;
/* unused harmony export searchPartNumber */
/* harmony export (immutable) */ __webpack_exports__["t"] = globalPartsSearch;
/* harmony export (immutable) */ __webpack_exports__["a"] = searchContacts;
/* harmony export (immutable) */ __webpack_exports__["i"] = subscribe;
/* harmony export (immutable) */ __webpack_exports__["p"] = importParts;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
























var partsAlternatesActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__["actionFactory"])("part/alternates");

function create(part) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.create(part).then(function (_ref) {
      var data = _ref.data;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["a" /* SET */],
        part: data
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"])("/parts/" + data.uuid));
    });
  };
}

function show(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.show(id).then(function (resp) {
      return dispatch({
        type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["a" /* SET */],
        part: resp.data
      });
    });
  };
}

function searchPartsByStatus(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.search({
      part_number: filter,
      repair_status: "reserve_for_repair,reserve_for_shop_assist",
      search_type: "search"
    }).then(function (resp) {
      return resp.data.results;
    });
  };
}

function createCatalogUrl(file) {
  if (!file) {
    return Promise.resolve(null);
  }

  var fileName = "" + (+new Date() - Math.floor(Math.random() * 10000000000)) + file.name;

  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.upload(fileName).then(function (resp) {
    var _resp$data = resp.data,
        key = _resp$data.key,
        url = _resp$data.url;


    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.toS3(url, file).then(function () {
      return Promise.resolve(key);
    }).catch(function (e) {
      return Promise.reject(e);
    });
  });
}

function update(data) {
  return function (dispatch, getState) {
    var partID = getState().partDetail.getIn([__WEBPACK_IMPORTED_MODULE_6__constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_7__constants__["b" /* ID */]]);

    return createCatalogUrl(data.file).then(function (catalogKey) {
      if (catalogKey) {
        data[__WEBPACK_IMPORTED_MODULE_6__constants__["C" /* CATALOG */]] = catalogKey;
        data.file = null;
      }

      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.update(partID, data).then(function (resp) {
        dispatch({
          type: __WEBPACK_IMPORTED_MODULE_9__actionTypes__["a" /* SET */],
          part: resp.data
        });
        dispatch(__WEBPACK_IMPORTED_MODULE_10__pagination__["b" /* partsPagination */].pageActions.expire());
        dispatch({
          type: __WEBPACK_IMPORTED_MODULE_5__Subscription_actionTypes__["a" /* SUBSCRIPTION_NOTIFICATION */],
          Inventory: {
            stale: true
          }
        });
        return __WEBPACK_IMPORTED_MODULE_3__lib_submission__["a" /* SUCCESS */];
      });
    });
  };
}

function searchInventories(partId) {
  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.inventories.search(partId, filters).then(function (resp) {
      return resp.data.results;
    });
  };
}

function searchOutgoingQuoteLineItems(partId) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.outgoingQuoteLineItems.search(partId).then(function (resp) {
      return resp.data.results;
    });
  };
}

function searchIncomingQuoteLineItems(partId) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.incomingQuoteLineItems.search(partId).then(function (resp) {
      return resp.data.results;
    });
  };
}

function searchParts(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.search({
      part_number: filter,
      search_type: "search"
    }).then(function (resp) {
      return resp.data.results;
    });
  };
}

function searchPoParts(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.poPartSearch({ part_number: filter }).then(function (resp) {
      return resp.data.results;
    });
  };
}

function searchMatchingPartNumbers(partNumber) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.search({
      part_number: partNumber,
      search_type: "matching_part_number",
      limit: 2
    }).then(function (resp) {
      return resp.data.results;
    });
  };
}

function createAlternate(id, data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.alternates.create(id, data).then(function () {
      dispatch(partsAlternatesActions.expire());
      dispatch(show(id));
      return __WEBPACK_IMPORTED_MODULE_3__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function updateAlternate(id, data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].alternates.update(id, data).then(function (resp) {
      dispatch(partsAlternatesActions.expire());
      dispatch(show(resp.data.part_id));
      return __WEBPACK_IMPORTED_MODULE_3__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function deleteAlternate(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].alternates.delete(id).then(function () {
      return dispatch(partsAlternatesActions.expire());
    });
  };
}

function searchCompanies() {
  return function (name) {
    return function () {
      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].companies.search({
        filter: name,
        status: "active,do_not_do_business",
        sort: "name",
        reverse: false,
        limit: 20
      }).then(function (resp) {
        return resp.data.results;
      });
    };
  };
}

function searchQuoteCompanies() {
  return function (name) {
    return function () {
      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].companies.search({
        cached: true,
        filter: name,
        status: "active,credit_hold,do_not_do_business",
        sort: "name",
        reverse: false,
        limit: 20
      }).then(function (resp) {
        return resp.data.results;
      });
    };
  };
}

function searchPartNumber() {
  return function (partNumber) {
    return function () {
      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.search({
        filter: partNumber,
        limit: 6
      }).then(function (resp) {
        return resp.data.results;
      });
    };
  };
}

function globalPartsSearch(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.search({ filter: filter, sort: "base_part_number", reverse: false, limit: 15 }).then(function (resp) {
      return resp.data.results;
    });
  };
}

function searchContacts(companyId) {
  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].companies.contacts.search(companyId, {
    active: true,
    cached: true,
    page: 1,
    limit: 1000,
    sort: "name",
    reverse: false
  }).then(function (resp) {
    return Promise.resolve(resp.data.results);
  });
}

function subscribe(partId) {
  return function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cable__["b" /* createChannel */])().listen({ channel: "PartsChannel", id: partId }, {
      onReceive: function onReceive(data) {
        dispatch(_defineProperty({
          type: __WEBPACK_IMPORTED_MODULE_5__Subscription_actionTypes__["a" /* SUBSCRIPTION_NOTIFICATION */]
        }, data, {
          stale: true
        }));
      }
    });
  };
}

function importParts(values) {
  return function () {
    var fileName = values.file.name;

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.upload(values.file.name).then(function (resp) {
      var _resp$data2 = resp.data,
          key = _resp$data2.key,
          url = _resp$data2.url;

      var formattedAttachment = {
        name: fileName,
        key: key
      };

      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.toS3(url, values.file).then(function () {
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.import(formattedAttachment).then(function () {
          __WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__["toastr"].info("Processing", "Importing Parts.");
          return __WEBPACK_IMPORTED_MODULE_3__lib_submission__["a" /* SUCCESS */];
        });
      }).catch(function (e) {
        return Promise.reject(e);
      });
    });
  };
}

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var styles = {
  container: {
    width: "100%",
    borderBottom: "1px solid rgba(0, 0, 0, 0.25)"
  },
  title: {
    paddingBottom: 10,
    borderBottom: "1px solid rgba(0, 0, 0, 0.25)",
    marginBottom: 10
  }
};

/* harmony default export */ __webpack_exports__["a"] = (styles);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CompanyAddressWarning__ = __webpack_require__(2286);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CompanyAddressWarning__["a"]; });



/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = Row;



function Row(_ref) {
  var label = _ref.label,
      value = _ref.value,
      _ref$renderIfPresent = _ref.renderIfPresent,
      renderIfPresent = _ref$renderIfPresent === undefined ? false : _ref$renderIfPresent,
      _ref$align = _ref.align,
      align = _ref$align === undefined ? "text-right" : _ref$align;

  if (renderIfPresent) {
    if (!value) return false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "th",
      { className: align },
      label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      value
    )
  );
}

Row.propTypes = {
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)]),
  renderIfPresent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 153 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(511)('wks');
var uid = __webpack_require__(357);
var Symbol = __webpack_require__(195).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(146);
var IObject = __webpack_require__(292);
var toObject = __webpack_require__(97);
var toLength = __webpack_require__(91);
var asc = __webpack_require__(518);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 156 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 157 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(18);
var core = __webpack_require__(156);
var fails = __webpack_require__(66);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 159 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(68);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 161 */,
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(925);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);









var propTypes = {
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  /**
   * this is sort of silly but needed for Button
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */

var SafeAnchor = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SafeAnchor);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  SafeAnchor.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        disabled = _props.disabled,
        href = _props.href,
        onClick = _props.onClick;


    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  SafeAnchor.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        disabled = _props2.disabled,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['componentClass', 'disabled']);

    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button';
      // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')
      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ pointerEvents: 'none' }, props.style);
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      onClick: this.handleClick
    }));
  };

  return SafeAnchor;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SafeAnchor.propTypes = propTypes;
SafeAnchor.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (SafeAnchor);

/***/ }),
/* 164 */,
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory__ = __webpack_require__(2756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_logger__ = __webpack_require__(3198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_thunk__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducers__ = __webpack_require__(2472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__middleware_syncSearchStateWithUrl__ = __webpack_require__(631);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return history; });
/* harmony export (immutable) */ __webpack_exports__["a"] = create;










var history = __WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory___default()();
var router = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["routerMiddleware"])(history);

var skipLoggingActionTypes = ["@@redux-form/REGISTER_FIELD", "@@redux-form/UNREGISTER_FIELD"];

var stateTransformer = function stateTransformer(state) {
  if (!(state instanceof Object)) {
    return state;
  }

  var newState = {};

  Object.keys(state).forEach(function (key) {
    if (__WEBPACK_IMPORTED_MODULE_3_immutable__["Iterable"].isIterable(state[key])) {
      newState[key] = state[key].toJS();
    } else {
      newState[key] = stateTransformer(state[key]);
    }
  });

  return newState;
};

var logger = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_logger__["createLogger"])({
  diff: true,
  collapsed: true,
  predicate: function predicate(getState, action) {
    return skipLoggingActionTypes.indexOf(action.type) === -1;
  },
  stateTransformer: stateTransformer
});

var store = null;

// eslint-disable-next-line
var composeEnhancer = global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ // eslint-disable-line
: __WEBPACK_IMPORTED_MODULE_0_redux__["compose"];

function create() {
  if (!store) {
    var storeCreator =  true ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"])(router, __WEBPACK_IMPORTED_MODULE_4_redux_thunk___default.a, __WEBPACK_IMPORTED_MODULE_7__middleware_syncSearchStateWithUrl__["c" /* default */]) : composeEnhancer(applyMiddleware(router, thunk, syncSearchStateWithUrl, logger));

    store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_6__reducers__["a" /* default */], storeCreator);
  }

  return store;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(127)))

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(1326);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPeriodFilters; });




var getPeriodFilters = function getPeriodFilters(_ref) {
  var period = _ref.period,
      report = _ref.report,
      currentUser = _ref.currentUser;

  var endTime = new Date();
  var filters = {
    start_time: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* LAUNCH_DATE */],
    end_time: endTime,
    user_id: undefined
  };

  if (period === "18-months") {
    filters.start_time = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(18, "months");
  }

  if (report === "my-scores") {
    filters.user_id = currentUser.id;
  }

  return filters;
};

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShippingPreference__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SalesOrders_helpers__ = __webpack_require__(103);
/* harmony export (immutable) */ __webpack_exports__["a"] = ShippingAddress;










function ShippingAddress(_ref) {
  var record = _ref.record,
      shippingType = _ref.shippingType,
      _ref$renderPreference = _ref.renderPreferences,
      renderPreferences = _ref$renderPreference === undefined ? true : _ref$renderPreference,
      _ref$shippingMethod = _ref.shippingMethod,
      shippingMethod = _ref$shippingMethod === undefined ? null : _ref$shippingMethod;

  var shippingAddress = record.get(shippingType + "_address") || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])();

  var shipToShippingType = record.get(shippingType + "_type");
  var method = shippingMethod || record.get(shippingType + "_shipping_method") || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])();
  var fob = record.get(shippingType + "_fob");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        record.get(shippingType + "_company") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Company"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["w" /* CompanyName */], {
              company: record.toJS()[shippingType + "_company"]
            })
          )
        ),
        shippingAddress.get(__WEBPACK_IMPORTED_MODULE_6__constants__["x" /* COMPANY_NAME */]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__SalesOrders_helpers__["b" /* dropShip */])(shipToShippingType) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Company"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            shippingAddress.get(__WEBPACK_IMPORTED_MODULE_6__constants__["x" /* COMPANY_NAME */])
          )
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_DetailTable__["b" /* Detail */], {
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["E" /* CONTACT_NAME */]),
          value: shippingAddress.get(__WEBPACK_IMPORTED_MODULE_6__constants__["E" /* CONTACT_NAME */])
        })],
        shippingAddress.get(__WEBPACK_IMPORTED_MODULE_6__constants__["D" /* CARE_OF */]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__SalesOrders_helpers__["b" /* dropShip */])(shipToShippingType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "c/o"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            shippingAddress.get(__WEBPACK_IMPORTED_MODULE_6__constants__["D" /* CARE_OF */])
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Address Line"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              shippingAddress.get(__WEBPACK_IMPORTED_MODULE_6__constants__["s" /* LINE1 */]),
              shippingAddress.get(__WEBPACK_IMPORTED_MODULE_6__constants__["t" /* LINE2 */]) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), shippingAddress.get(__WEBPACK_IMPORTED_MODULE_6__constants__["t" /* LINE2 */])]
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "City"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              shippingAddress.get(__WEBPACK_IMPORTED_MODULE_6__constants__["u" /* CITY */])
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "State/ Province/ Region"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              shippingAddress.get(__WEBPACK_IMPORTED_MODULE_6__constants__["v" /* STATE */])
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "ZIP/ Postal Code"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              shippingAddress.get(__WEBPACK_IMPORTED_MODULE_6__constants__["w" /* POSTAL_CODE */])
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Country"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              shippingAddress.get(__WEBPACK_IMPORTED_MODULE_6__constants__["r" /* COUNTRY */])
            )
          )
        ),
        fob && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "FOB"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            fob
          )
        )
      )
    ),
    renderPreferences && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ShippingPreference__["a" /* ShippingPreference */], { shippingMethod: method.toJS() }),
    record.get("code").slice(0, 2) === "MS" && record.get("shipped") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Outgoing AWB #"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            record.toJS().outgoing_awb_number
          )
        )
      )
    )
  );
}

ShippingAddress.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  renderPreferences: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shippingMethod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__ = __webpack_require__(11);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getExchange; });
/* unused harmony export totalCost */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return totalCostEvalColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return extCostEvalColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return totalRepairOrderCost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return coreReturnFeeSavingsVal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return calculateSubtotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ExchangeIcon; });












var getCap = function getCap(lineItem) {
  var doNotSell = lineItem.getIn([__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_57" /* SELLABLE_STATUS */]]) === __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["X" /* DO_NOT_SELL */];
  return __WEBPACK_IMPORTED_MODULE_0_classnames___default()({
    "green-table-cap": lineItem.get(__WEBPACK_IMPORTED_MODULE_6__constants__["s" /* APPROVAL_STATUS */]) === __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* REPAIR_EVALUATION_APPROVED */] && !lineItem.get(__WEBPACK_IMPORTED_MODULE_5__constants__["_26" /* RECEIVED */]),
    "danger-table-cap": doNotSell && !lineItem.get(__WEBPACK_IMPORTED_MODULE_5__constants__["_26" /* RECEIVED */]),
    "warning-table-cap": !doNotSell && !lineItem.get(__WEBPACK_IMPORTED_MODULE_5__constants__["_26" /* RECEIVED */])
  });
};

var getExchange = function getExchange(lineItem) {
  return lineItem.get("exchange") && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle text-success" });
};

var totalCost = function totalCost(line) {
  return line.approval_status === __WEBPACK_IMPORTED_MODULE_6__constants__["t" /* REPAIR_EVALUATION_REJECTED */] ? line.evaluation_charge : line.charges_per_part;
};

var totalCostEvalColumn = function totalCostEvalColumn(line) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(totalCost(line));
};

var extCostEvalColumn = function extCostEvalColumn(line) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(totalCost(line) * Number(line.quantity));
};

var totalRepairOrderCost = function totalRepairOrderCost(results) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(results.reduce(function (sum, result) {
    return sum + extCostEvalColumn(result);
  }, 0));
};

var coreReturnFeeSavingsVal = function coreReturnFeeSavingsVal(doNotExceed, subtotal) {
  return Number(doNotExceed) - Number(parseFloat(subtotal));
};

var calculateSubtotal = function calculateSubtotal(getField) {
  return function (fields, val) {
    return fields.reduce(function (agg, field) {
      return agg + Number(getField(field));
    }, 0) + Number(val);
  };
};

var ExchangeIcon = function ExchangeIcon(_ref) {
  var lineItem = _ref.lineItem;

  var exchangeTypes = [{
    key: "previous_exchange_details." + __WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__["q" /* EXCHANGE_TYPE */],
    value: null,
    text: 1,
    hover: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["c" /* EXCHANGE */])
  }, {
    key: __WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__["e" /* FLAT_EXCHANGE */],
    value: true,
    text: "F",
    hover: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__["e" /* FLAT_EXCHANGE */])
  }, {
    key: "previous_exchange_details." + __WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__["q" /* EXCHANGE_TYPE */],
    value: __WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__["l" /* SECOND_EXCHANGE */],
    text: 2,
    hover: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__["l" /* SECOND_EXCHANGE */])
  }, {
    key: "previous_exchange_details." + __WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__["q" /* EXCHANGE_TYPE */],
    value: __WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__["m" /* THIRD_EXCHANGE */],
    text: 3,
    hover: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__["m" /* THIRD_EXCHANGE */])
  }, {
    key: __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* EXCHANGE_GONE_OUTRIGHT */],
    value: true,
    text: "O",
    hover: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["u" /* EXCHANGE_GONE_OUTRIGHT */])
  }, {
    key: __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_38" /* INTERNAL_OUTRIGHT */],
    value: true,
    text: "io",
    hover: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_38" /* INTERNAL_OUTRIGHT */])
  }, {
    key: "inventory.reclaimed",
    value: true,
    text: "R",
    hover: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_58" /* RECLAIMED */])
  }];

  var filteredVal = exchangeTypes.filter(function (f) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, f.key) === f.value;
  });

  if (filteredVal.length === 0) {
    return null;
  }

  var val = filteredVal[filteredVal.length - 1];

  /* eslint react/no-danger: 0 */
  var tooltip = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["b" /* Tooltip */],
    { className: "in" },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: val.hover } })
  );

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["a" /* OverlayTrigger */],
    { placement: "top", overlay: tooltip },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      "span",
      { className: "fa-stack fa-1x" },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("i", { className: "fa fa-lg fa-circle text-success" }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        "span",
        { className: "fa fa-stack-1x exchange-circle-text" },
        val.text
      )
    )
  );
};

ExchangeIcon.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(1941);
/* harmony export (immutable) */ __webpack_exports__["a"] = subscribeTo;
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var withSubscription = function withSubscription(WrappedComponent) {
  var WithSubscription = function (_React$Component) {
    _inherits(WithSubscription, _React$Component);

    function WithSubscription() {
      _classCallCheck(this, WithSubscription);

      return _possibleConstructorReturn(this, (WithSubscription.__proto__ || Object.getPrototypeOf(WithSubscription)).apply(this, arguments));
    }

    _createClass(WithSubscription, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        if (nextProps.stale && !nextProps.loading) {
          this.props.refresh().then(function () {
            _this2.props.setFresh();
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, this.props);
      }
    }]);

    return WithSubscription;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  WithSubscription.propTypes = {
    refresh: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    setFresh: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired
  };


  return WithSubscription;
};

function subscribeTo(key) {
  return function (Component) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
      return {
        stale: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(state.subscriptions.toJS(), key + ".stale", false)
      };
    }, function (dispatch) {
      return {
        setFresh: function setFresh() {
          return dispatch(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* setFresh */](key));
        }
      };
    })(withSubscription(Component));
  };
}

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(36);
/* harmony export (immutable) */ __webpack_exports__["a"] = totalHoursRemaining;
/* harmony export (immutable) */ __webpack_exports__["b"] = totalCyclesRemaining;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return inventoryTaggedBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isManagedRepair; });




function totalHoursRemaining(part, totalHours) {
  if (!part.total_hours) return 0;

  return Number(part.total_hours) - Number(totalHours);
}

function totalCyclesRemaining(part, totalCycles) {
  if (!part.total_cycles) return 0;

  return Number(part.total_cycles) - Number(totalCycles);
}

var inventoryTaggedBy = function inventoryTaggedBy(inventory) {
  if (inventory.repair_order_tagged_by) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
      { to: "/companies/" + inventory.repair_order_tagged_by.uuid },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_formatters_text__["e" /* truncate */])("@ " + inventory.repair_order_tagged_by.name, 25)
    );
  } else if (inventory.tagged_by_uuid) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
      { to: "/companies/" + inventory.tagged_by_uuid },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_formatters_text__["e" /* truncate */])(inventory.tagged_by, 25)
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_formatters_text__["e" /* truncate */])(inventory.tagged_by, 25)
  );
};

var isManagedRepair = function isManagedRepair(inventory) {
  return inventory.managed_repair_in_progress || inventory.managed_repair_repaired;
};

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModifiedFlag__ = __webpack_require__(2226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__ModifiedFlag__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModifiedFlag_style__ = __webpack_require__(2227);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ModifiedFlag_style__["a"]; });



/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SellableQty__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["a"] = BackToPart;











function BackToPart(_ref) {
  var part = _ref.part;

  var classes = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_helpers__["a" /* getPartNumberColorClassNameByTierType */])(part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["O" /* TIER_TYPE */])));
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "page-header page-header-bar" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h1",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "with-padding" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
          { to: "/parts/" + part.get(__WEBPACK_IMPORTED_MODULE_9__constants__["c" /* UUID */]) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-long-arrow-left" }),
          "\xA0",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: classes },
            part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["w" /* PART_NUMBER */])
          ),
          "\xA0"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["E" /* ClipboardCopy */], { name: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["w" /* PART_NUMBER */]), type: "PN" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "small text-muted" },
          part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["u" /* DESCRIPTION */])
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["f" /* PartStatsTooltip */], { part: part.toJS() }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SellableQty__["a" /* default */], { quantities: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["P" /* SELLABLE_QUANTITIES */]) })
      )
    )
  );
}

BackToPart.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]).isRequired
};

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shipping_constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Orders_shared_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ShippingSection_shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_pojos__ = __webpack_require__(56);
/* unused harmony export getEin */
/* unused harmony export getPhysicalAddress */
/* unused harmony export getUltimateAddress */
/* unused harmony export getCustomerPO */
/* unused harmony export getPrice */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setInvoiceInitialValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SHIPPING_CHECKLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEND_WEIGHTS_AND_DIMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COMMERCIAL_INVOICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COMMERCIAL_INVOICE_LINE_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_OR_REPLACE_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DOWNLOAD_PACKING_SLIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return showFormFunc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return addLineItemsFunc; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











var getEin = function getEin(salesOrder, repairOrder) {
  if (salesOrder && salesOrder.line_items) {
    var locationId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(salesOrder, "line_items[0].inventory.store_location_id", "");

    var location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["a" /* useCurrentUser */])().locations.filter(function (l) {
      return locationId === l.id;
    })[0];
    if (location) {
      return location.tax_id_number;
    }
  } else if (repairOrder && repairOrder.line_items) {
    var _locationId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(repairOrder, "line_items[0].inventory.store_location_id", "");
    var _location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["a" /* useCurrentUser */])().locations.filter(function (l) {
      return _locationId === l.id;
    })[0];
    if (_location) {
      return _location.tax_id_number;
    }
  }

  return null;
};

var getPhysicalAddress = function getPhysicalAddress(salesOrder, _repairOrder) {
  if (salesOrder) {
    var shipToAddress = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(salesOrder, "ship_to_address");
    var shipToCustomer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(salesOrder, __WEBPACK_IMPORTED_MODULE_1__constants__["q" /* SHIP_TO_TYPE */]) === __WEBPACK_IMPORTED_MODULE_7__ShippingSection_shippingTypes__["b" /* CUSTOMER */];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["merge"])({
      company_id: shipToCustomer ? salesOrder.company_id : (salesOrder, "ship_to_company.id"),
      company_name: shipToCustomer ? salesOrder.company_name : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(salesOrder, "ship_to_company.name")
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_pojos__["a" /* default */])(shipToAddress || {}).pick(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* COUNTRY */], __WEBPACK_IMPORTED_MODULE_1__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_1__constants__["t" /* LINE2 */], __WEBPACK_IMPORTED_MODULE_1__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_1__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_1__constants__["w" /* POSTAL_CODE */]));
  }

  return {};
};

var getUltimateAddress = function getUltimateAddress(salesOrder, repairOrder) {
  if (salesOrder && salesOrder.line_items) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(salesOrder, "final_destination_address", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_pojos__["a" /* default */])(salesOrder || {}).pick(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* COUNTRY */], __WEBPACK_IMPORTED_MODULE_1__constants__["x" /* COMPANY_NAME */], __WEBPACK_IMPORTED_MODULE_1__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_1__constants__["t" /* LINE2 */], __WEBPACK_IMPORTED_MODULE_1__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_1__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_1__constants__["w" /* POSTAL_CODE */]));
  } else if (repairOrder && repairOrder.line_items) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["merge"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(repairOrder, "repair_station_physical_address", {}), {
      company_name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(repairOrder, "company.name")
    });
  }

  return null;
};

var getCustomerPO = function getCustomerPO(shippingRecord, salesOrder, repairOrder) {
  return shippingRecord && shippingRecord[__WEBPACK_IMPORTED_MODULE_1__constants__["y" /* CUSTOMER_PURCHASE_ORDER_NUMBER */]] || salesOrder && salesOrder[__WEBPACK_IMPORTED_MODULE_1__constants__["y" /* CUSTOMER_PURCHASE_ORDER_NUMBER */]] || repairOrder && repairOrder[__WEBPACK_IMPORTED_MODULE_1__constants__["z" /* CODE */]];
};

var parseSavedLineItem = function parseSavedLineItem(salesOrder, item) {
  var savedLineItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(salesOrder, "commercial_invoice." + __WEBPACK_IMPORTED_MODULE_1__constants__["A" /* LINE_ITEMS */], []).filter(function (l) {
    return Number(l.part_id) === Number(item.part.id) && l.serial_number === item.serial_number;
  })[0] || {};

  if (savedLineItem.weight) savedLineItem.weight = Number(savedLineItem.weight);

  return savedLineItem;
};

var getPrice = function getPrice(salesOrder, repairOrder, lineItem) {
  if (salesOrder && salesOrder.id) {
    return lineItem && lineItem.exchange_sale ? lineItem.exchange_fee : lineItem && lineItem.sale_price;
  } else if (repairOrder && repairOrder.id) {
    return lineItem && lineItem.subtotal;
  }

  return null;
};

var setInvoiceInitialValues = function setInvoiceInitialValues(_ref) {
  var lineItems = _ref.lineItems,
      shippingRecord = _ref.shippingRecord,
      salesOrder = _ref.salesOrder,
      repairOrder = _ref.repairOrder;

  var record = void 0;

  if (salesOrder && salesOrder.id) {
    record = salesOrder;
  } else if (repairOrder && repairOrder.id) {
    record = repairOrder;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["merge"])({
    sales_order_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(salesOrder, "id"),
    repair_order_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(repairOrder, "id"),
    cargo_screening_consent: true,
    customer_po: getCustomerPO(shippingRecord, salesOrder, repairOrder),
    consignee: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(shippingRecord, __WEBPACK_IMPORTED_MODULE_1__constants__["p" /* TYPE */]) === __WEBPACK_IMPORTED_MODULE_6__Orders_shared_constants__["b" /* RO_ITEM */] ? __WEBPACK_IMPORTED_MODULE_4__Shipping_constants__["j" /* REPAIR_AND_RETURN */] : null,
    discreet: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(record, __WEBPACK_IMPORTED_MODULE_1__constants__["l" /* DISCREET */]) || false,
    ein: getEin(salesOrder, repairOrder),
    hazmat: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(record, __WEBPACK_IMPORTED_MODULE_1__constants__["A" /* LINE_ITEMS */], []).filter(function (l) {
      return lineItems.map(function (i) {
        return i.id;
      }).includes(l.inventory_id);
    }).some(function (l) {
      return l.hazmat;
    }),
    weight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(shippingRecord, __WEBPACK_IMPORTED_MODULE_2__parts_constants__["j" /* WEIGHT */]),
    weight_unit: "lb",
    freight_forwarder_address: getPhysicalAddress(salesOrder, repairOrder),
    ultimate_consignee_address: getUltimateAddress(salesOrder, repairOrder),
    ultimate_consignee_name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(record, "final_destination_name"),
    ultimate_consignee_email: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(record, "final_destination_email"),
    ultimate_consignee_phone: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(record, "final_destination_phone"),
    ultimate_consignee_reference: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(record, "final_destination_reference"),
    line_items: lineItems && lineItems.map(function (item) {
      var recordLine = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(record, __WEBPACK_IMPORTED_MODULE_1__constants__["A" /* LINE_ITEMS */], []).filter(function (l) {
        return l.inventory_id === item.id;
      })[0];

      var savedLineItem = parseSavedLineItem(salesOrder, item);

      var lineItem = _extends({
        part_id: item.part.id,
        serial_number: item.serial_number,
        condition: item.condition,
        weight: item.part.net_weight,
        weight_unit: item.part.net_weight_unit || "lb",
        weight_oz: item.part.net_weight_oz
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_pojos__["a" /* default */])(item.part).pick(__WEBPACK_IMPORTED_MODULE_2__parts_constants__["g" /* COUNTRY_OF_MFG */], __WEBPACK_IMPORTED_MODULE_2__parts_constants__["u" /* DESCRIPTION */], __WEBPACK_IMPORTED_MODULE_2__parts_constants__["v" /* HTSUS_CODE */], __WEBPACK_IMPORTED_MODULE_2__parts_constants__["w" /* PART_NUMBER */], __WEBPACK_IMPORTED_MODULE_2__parts_constants__["x" /* SCHEDULE_B_OR_HT_CODE */], __WEBPACK_IMPORTED_MODULE_2__parts_constants__["y" /* ECCN */]), savedLineItem, {
        quantity: Number(item.quantity) + Number(item.expected_quantity),
        price: getPrice(salesOrder, repairOrder, recordLine)
      });

      if (shippingRecord && salesOrder) {
        lineItem.sales_order_line_item_id = recordLine && recordLine.id;
        lineItem.inventory_id = item.id;
      } else if (shippingRecord && repairOrder) {
        lineItem.repair_order_line_item_id = recordLine && recordLine.id;
      } else {
        lineItem.inventory_id = item.id;
      }

      if (lineItem[__WEBPACK_IMPORTED_MODULE_2__parts_constants__["y" /* ECCN */]] && ["7A994", "9A991", "9A991"].includes(lineItem[__WEBPACK_IMPORTED_MODULE_2__parts_constants__["y" /* ECCN */]])) {
        lineItem[__WEBPACK_IMPORTED_MODULE_2__parts_constants__["x" /* SCHEDULE_B_OR_HT_CODE */]] = "8803.30.0030";
      }

      return lineItem;
    })
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_removeKey__["a" /* default */])(salesOrder.commercial_invoice, __WEBPACK_IMPORTED_MODULE_1__constants__["A" /* LINE_ITEMS */]) || {});
};

var SHIPPING_CHECKLIST = "Shipping Details";
var SEND_WEIGHTS_AND_DIMS = "Send Weight and Dims";
var COMMERCIAL_INVOICE = "Commercial Invoice";
var COMMERCIAL_INVOICE_LINE_ITEMS = "CommercialInvoiceLineItems";
var SAVE_OR_REPLACE_FORM = "SaveOrReplaceForm";
var DOWNLOAD_PACKING_SLIP = "Download Packing Slip";

var showFormFunc = function showFormFunc(_ref2) {
  var salesOrder = _ref2.salesOrder,
      repairOrder = _ref2.repairOrder,
      setCurrentForm = _ref2.setCurrentForm;
  return function () {
    if (salesOrder.line_items && salesOrder.line_items && salesOrder.line_items.length > 1) {
      setCurrentForm(COMMERCIAL_INVOICE_LINE_ITEMS);
    } else if (repairOrder && repairOrder.line_items && repairOrder.line_items.length > 1) {
      setCurrentForm(COMMERCIAL_INVOICE_LINE_ITEMS);
    } else {
      setCurrentForm(COMMERCIAL_INVOICE);
    }
  };
};

var addLineItemsFunc = function addLineItemsFunc(_ref3) {
  var setLineItems = _ref3.setLineItems,
      setCurrentForm = _ref3.setCurrentForm;
  return function (selectedLineItems) {
    setLineItems(selectedLineItems.map(function (l) {
      return l.inventory;
    }));
    setCurrentForm(COMMERCIAL_INVOICE);
  };
};

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_daterangepicker__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);






function Picker(_ref) {
  var setFilter = _ref.pageActions.setFilter,
      paginator = _ref.paginator;

  var params = paginator.get(__WEBPACK_IMPORTED_MODULE_4__constants__["_29" /* FILTERS */]).toJS();

  var start = params.start_date && __WEBPACK_IMPORTED_MODULE_3_moment___default()(params.start_date);
  var end = params.end_date && __WEBPACK_IMPORTED_MODULE_3_moment___default()(params.end_date);

  var handleCallback = function handleCallback(startVal, endVal) {
    setFilter(__WEBPACK_IMPORTED_MODULE_4__constants__["_30" /* START_DATE */], startVal.isValid() ? startVal : null);
    setFilter(__WEBPACK_IMPORTED_MODULE_4__constants__["_31" /* END_DATE */], endVal.isValid() ? endVal : null);
  };

  var handleCancel = function handleCancel(ev, picker) {
    setFilter(__WEBPACK_IMPORTED_MODULE_4__constants__["_30" /* START_DATE */], null);
    setFilter(__WEBPACK_IMPORTED_MODULE_4__constants__["_31" /* END_DATE */], null);
    picker.val("");
  };

  var label = start && start.isValid() && end && end.isValid() ? start.format("MMMM D, YYYY") + " - " + end.format("MMMM D, YYYY") : null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_daterangepicker__["a" /* default */],
    {
      initialSettings: {
        startDate: start && start.toDate() || __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(30, __WEBPACK_IMPORTED_MODULE_4__constants__["_32" /* DAYS */]).toDate(),
        endDate: end && end.toDate() || __WEBPACK_IMPORTED_MODULE_3_moment___default()().toDate(),
        locale: {
          cancelLabel: "Clear"
        },
        alwaysShowCalendars: true,
        ranges: {
          Today: [__WEBPACK_IMPORTED_MODULE_3_moment___default()().toDate(), __WEBPACK_IMPORTED_MODULE_3_moment___default()().toDate()],
          Yesterday: [__WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, __WEBPACK_IMPORTED_MODULE_4__constants__["_32" /* DAYS */]).toDate(), __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, __WEBPACK_IMPORTED_MODULE_4__constants__["_32" /* DAYS */]).toDate()],
          "Last 7 Days": [__WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(6, __WEBPACK_IMPORTED_MODULE_4__constants__["_32" /* DAYS */]).toDate(), __WEBPACK_IMPORTED_MODULE_3_moment___default()().toDate()],
          "Last 30 Days": [__WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(29, __WEBPACK_IMPORTED_MODULE_4__constants__["_32" /* DAYS */]).toDate(), __WEBPACK_IMPORTED_MODULE_3_moment___default()().toDate()],
          "This Month": [__WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf(__WEBPACK_IMPORTED_MODULE_4__constants__["_33" /* MONTH */]).toDate(), __WEBPACK_IMPORTED_MODULE_3_moment___default()().endOf(__WEBPACK_IMPORTED_MODULE_4__constants__["_33" /* MONTH */]).toDate()],
          "Last Month": [__WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, __WEBPACK_IMPORTED_MODULE_4__constants__["_33" /* MONTH */]).startOf(__WEBPACK_IMPORTED_MODULE_4__constants__["_33" /* MONTH */]).toDate(), __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, __WEBPACK_IMPORTED_MODULE_4__constants__["_33" /* MONTH */]).endOf(__WEBPACK_IMPORTED_MODULE_4__constants__["_33" /* MONTH */]).toDate()]
        }
      },
      onCallback: handleCallback,
      onCancel: handleCancel
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "input-group-btn" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { type: "button", className: "btn btn-success " },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-calendar" }),
        "\xA0",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          label
        ),
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-caret-down" })
      )
    )
  );
}

Picker.propTypes = {
  pageActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  paginator: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map)
};

/* harmony default export */ __webpack_exports__["a"] = (Picker);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ErrorBoundary__ = __webpack_require__(2294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ErrorBoundary__["a"]; });



/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CurrencyField__ = __webpack_require__(347);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CurrencyField__["a"]; });



/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__companies_constants__ = __webpack_require__(22);









function PaymentTerms(_ref) {
  var getInitialFieldValue = _ref.getInitialFieldValue;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hooks__["a" /* useCurrentUser */])();
  var paymentTerms = currentUser.tenant.payment_terms || Object.keys(__WEBPACK_IMPORTED_MODULE_7__companies_constants__["i" /* VENDOR_TERMS */]);
  var initialValue = getInitialFieldValue ? getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["h" /* PAYMENT_TERMS */]) : null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["h" /* PAYMENT_TERMS */],
    component: __WEBPACK_IMPORTED_MODULE_3__Forms__["c" /* Select */],
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["h" /* PAYMENT_TERMS */]),
    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_forms__["d" /* arrayToProperCasedOptionsWithCurrentValue */])(paymentTerms, initialValue)
  });
}

/* harmony default export */ __webpack_exports__["a"] = (PaymentTerms);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__connectRecord__ = __webpack_require__(823);
/* harmony export (immutable) */ __webpack_exports__["a"] = loadRecord;



/* Use this to automatically fetch a record when your component
 * mounts if the record is not already at the specified location
 * in the store. This decorator relies on a convention where the
 * assuming that the name of the reducer will match the name of the
 * property that identifies the record. It also assumes that your
 * component is being rendered with react-router, and that the route
 * contains an id parameter identifying the record to be fetched.
 */
function loadRecord(options) {
  var Container = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__connectRecord__["a" /* default */])(options);

  return function (Component) {
    return function (props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Container,
        props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, props)
      );
    };
  };
}

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(871);
var $export = __webpack_require__(18);
var shared = __webpack_require__(369)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(874))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(89)) {
  var LIBRARY = __webpack_require__(220);
  var global = __webpack_require__(60);
  var fails = __webpack_require__(66);
  var $export = __webpack_require__(18);
  var $typed = __webpack_require__(371);
  var $buffer = __webpack_require__(539);
  var ctx = __webpack_require__(146);
  var anInstance = __webpack_require__(218);
  var propertyDesc = __webpack_require__(224);
  var hide = __webpack_require__(123);
  var redefineAll = __webpack_require__(225);
  var toInteger = __webpack_require__(159);
  var toLength = __webpack_require__(91);
  var toIndex = __webpack_require__(869);
  var toAbsoluteIndex = __webpack_require__(227);
  var toPrimitive = __webpack_require__(160);
  var has = __webpack_require__(122);
  var classof = __webpack_require__(291);
  var isObject = __webpack_require__(68);
  var toObject = __webpack_require__(97);
  var isArrayIter = __webpack_require__(525);
  var create = __webpack_require__(221);
  var getPrototypeOf = __webpack_require__(133);
  var gOPN = __webpack_require__(222).f;
  var getIterFn = __webpack_require__(542);
  var uid = __webpack_require__(228);
  var wks = __webpack_require__(81);
  var createArrayMethod = __webpack_require__(155);
  var createArrayIncludes = __webpack_require__(358);
  var speciesConstructor = __webpack_require__(370);
  var ArrayIterators = __webpack_require__(543);
  var Iterators = __webpack_require__(253);
  var $iterDetect = __webpack_require__(364);
  var setSpecies = __webpack_require__(226);
  var arrayFill = __webpack_require__(517);
  var arrayCopyWithin = __webpack_require__(842);
  var $DP = __webpack_require__(90);
  var $GOPD = __webpack_require__(132);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__ = __webpack_require__(19);







var LocationRadioField = function LocationRadioField(_ref) {
  var currentUser = _ref.currentUser,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? "Buying Store" : _ref$label,
      _ref$name = _ref.name,
      name = _ref$name === undefined ? __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["g" /* BUYING_STORE_ID */] : _ref$name,
      _ref$required = _ref.required,
      required = _ref$required === undefined ? true : _ref$required;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
    disabled: disabled,
    name: name,
    label: label,
    component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["m" /* RadioGroupField */],
    options: currentUser.locations.map(function (l) {
      return {
        value: l.id,
        text: l.name
      };
    }),
    required: required
  });
};

LocationRadioField.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__["b" /* default */])(LocationRadioField));

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__session_actionTypes__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pagination__ = __webpack_require__(435);
/* unused harmony export search */
/* unused harmony export setFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pageActions; });
/* harmony export (immutable) */ __webpack_exports__["h"] = convertFromOutgoingQuote;
/* harmony export (immutable) */ __webpack_exports__["i"] = setFollowUp;
/* harmony export (immutable) */ __webpack_exports__["a"] = sendEmail;
/* harmony export (immutable) */ __webpack_exports__["c"] = show;
/* unused harmony export getCompany */
/* harmony export (immutable) */ __webpack_exports__["g"] = updateOutgoingQuote;
/* harmony export (immutable) */ __webpack_exports__["d"] = createOutgoingQuoteLineItem;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateOutgoingQuoteLineItem;
/* harmony export (immutable) */ __webpack_exports__["f"] = deleteOutgoingQuoteLineItem;
/* unused harmony export send */







var search = __WEBPACK_IMPORTED_MODULE_5__pagination__["a" /* default */].search,
    setFilter = __WEBPACK_IMPORTED_MODULE_5__pagination__["a" /* default */].setFilter,
    pageActions = __WEBPACK_IMPORTED_MODULE_5__pagination__["a" /* default */].pageActions;



function convertFromOutgoingQuote(params, history) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].salesOrders.convertFromOutgoingQuote(params).then(function (_ref) {
      var data = _ref.data;

      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__session_actionTypes__["h" /* REFRESH_CACHED_SALES_CARTS */],
        cachedSalesCart: data.cached_sales_cart,
        salesCartItems: data.sales_order_cart_items
      });
      history.push("/sales-orders/reserved");
    });
  };
}

function setFollowUp(id, params, close) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].outgoingQuotes.autoFollowup(id, params).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* SET */],
        outgoingQuote: resp.data
      });
      close();
      __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].success("Success", "Follow Up Scheduled.");
    });
  };
}

function sendEmail(id, params, close) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].outgoingQuotes.send(id, params).then(function (resp) {
      close();
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* SET */],
        outgoingQuote: resp.data
      });
      __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].success("Success", "Quote queued to be sent.");
    }).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].error("Error", "Could not send quote. Please refresh page and try again.");
    });
  };
}

function show(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].outgoingQuotes.show(id).then(function (resp) {
      return dispatch({
        type: __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* SET */],
        outgoingQuote: resp.data
      });
    });
  };
}

function getCompany(id) {
  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].companies.show(id).then(function (resp) {
    return Promise.resolve(resp.data);
  });
}

function updateOutgoingQuote(data) {
  return function (dispatch, getState) {
    var quoteID = getState().outgoingQuoteDetail.getIn(["outgoingQuote", "id"]);

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].outgoingQuotes.update(quoteID, data).then(function () {
      dispatch(show(quoteID));
      dispatch(pageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function createOutgoingQuoteLineItem(data) {
  return function (dispatch, getState) {
    var quoteID = getState().outgoingQuoteDetail.getIn(["outgoingQuote", "id"]);

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].outgoingQuotes.lineItems.create(quoteID, data).then(function () {
      dispatch(show(quoteID));
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function updateOutgoingQuoteLineItem(data, itemID) {
  return function (dispatch, getState) {
    var quoteID = getState().outgoingQuoteDetail.getIn(["outgoingQuote", "id"]);

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].outgoingQuotes.lineItems.update(itemID, data).then(function () {
      dispatch(show(quoteID));
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function deleteOutgoingQuoteLineItem(id) {
  return function (dispatch, getState) {
    var quoteID = getState().outgoingQuoteDetail.getIn(["outgoingQuote", "id"]);
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].outgoingQuotes.lineItems.delete(id).then(function () {
      return dispatch(show(quoteID));
    });
  };
}

function send() {
  return function (_, getState) {
    var outgoingQuoteID = getState().outgoingQuoteDetail.getIn(["outgoingQuote", "id"]);
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].outgoingQuotes.send(outgoingQuoteID).then(function () {
      return Promise.resolve();
    }).catch(function (err) {
      return Promise.reject(err);
    });
  };
}

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* unused harmony export InStockWarning */
/* unused harmony export StoreLocationWarning */
/* harmony export (immutable) */ __webpack_exports__["f"] = StoreOwnerWarning;
/* unused harmony export allRepairingOrAllInStock */
/* harmony export (immutable) */ __webpack_exports__["a"] = NoPmaNoDerWarning;
/* harmony export (immutable) */ __webpack_exports__["b"] = TraceTypeWarning;
/* harmony export (immutable) */ __webpack_exports__["d"] = WarrantyMinimumWarning;
/* harmony export (immutable) */ __webpack_exports__["h"] = CreditLimitWarning;
/* harmony export (immutable) */ __webpack_exports__["c"] = StrictTraceWarning;
/* harmony export (immutable) */ __webpack_exports__["e"] = BlanketExchangeAgreementWarning;
/* harmony export (immutable) */ __webpack_exports__["g"] = DiscreetWarning;
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }










function InStockWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Sales Order contains parts that are in stock and repairing. Please ensure all items are in the same state in your cart before proceeding."
  );
}

function StoreLocationWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Sales order contains items from different store locations. Please ensure all items in your cart belong to the same store location and owner before proceeding."
  );
}

function StoreOwnerWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Sales order contains items from different store owners. Please ensure all items in your cart belong to the same store location and owner before proceeding."
  );
}

function allRepairingOrAllInStock(inventories) {
  return inventories.every(function (i) {
    return i.repairing;
  }) || inventories.every(function (i) {
    return !i.repairing;
  });
}

function NoPmaNoDerWarning(_ref) {
  var company = _ref.company,
      _ref$inventories = _ref.inventories,
      inventories = _ref$inventories === undefined ? [] : _ref$inventories;

  if ((__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(company, "no_pmas_accepted") || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(company, "no_ders_accepted")) && inventories.some(function (i) {
    return i.pma || i.der;
  })) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
      null,
      "Warning: This Customer does not usually accept PMA/DER Parts."
    );
  }

  return null;
}

NoPmaNoDerWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    no_ders_accepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    no_pmas_accepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  inventories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    der: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }))
};

function TraceTypeWarning(_ref2) {
  var company = _ref2.company,
      inventories = _ref2.inventories;

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(company, "unaccepted_trace_types")) return null;

  if (inventories.some(function (i) {
    return company.unaccepted_trace_types.includes(i.trace_type);
  })) {
    var traceTypes = inventories.map(function (i) {
      return i.trace_type;
    });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
      null,
      "Warning: This customer does not usually accept units with trace types of",
      " ",
      company.unaccepted_trace_types.filter(function (t) {
        return traceTypes.includes(t);
      }).map(function (t) {
        return __WEBPACK_IMPORTED_MODULE_3__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes[t].label;
      }).join(", ")
    );
  }

  return null;
}

TraceTypeWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    unaccepted_trace_types: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
  }),
  inventories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ trace_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string }))
};

function WarrantyMinimumWarning(_ref3) {
  var company = _ref3.company,
      lineItems = _ref3.lineItems;

  if (!company) return null;

  var warranties = lineItems.map(function (l) {
    switch (l.warranty) {
      case "30 days":
        return 30;
      case "6 mos.":
        return 6 * 30;
      case "1 year":
        return 365;
      default:
        return null;
    }
  }).filter(function (l) {
    return l;
  });

  if (warranties.length === 0) return null;

  var lowestWarranty = Math.min.apply(Math, _toConsumableArray(warranties));
  if (Number(company.warranty_minimum) > 0 && lowestWarranty > 0 && lowestWarranty < company.warranty_minimum) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
      null,
      "This Customer does not usually accept units with warranty periods less than ",
      company.warranty_minimum,
      " days."
    );
  }

  return null;
}

WarrantyMinimumWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    warranty_minimum: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  lineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    warranty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }))
};

function CreditLimitWarning(_ref4) {
  var company = _ref4.company,
      lineItems = _ref4.lineItems,
      customerCreditTerm = _ref4.customerCreditTerm;

  if (!company) return null;

  var balance = parseFloat(company.outstanding_balance);
  var creditLimit = parseFloat(company.customer_credit_limit || 0);

  var lineItemBalance = lineItems.reduce(function (acc, l) {
    var val = l.exchange_sale ? parseFloat(l.exchange_fee || 0) : parseInt(l.quantity, 10) * parseFloat(l.price_per_unit || 0);
    return val + acc;
  }, 0);

  if (balance + lineItemBalance > creditLimit && ![__WEBPACK_IMPORTED_MODULE_4__companies_constants__["r" /* CREDIT_CARD */], __WEBPACK_IMPORTED_MODULE_4__companies_constants__["s" /* WIRE_IN_ADVANCE */]].includes(customerCreditTerm)) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
      { warningType: "danger" },
      "Exceeds Credit Limit Notification: This order will put ",
      company.name,
      " ",
      "over their Credit Limit and place the order on Accounting Hold. Continuing with this SO will send an `Exceeds Credit Limit` Notification to Accounting."
    );
  }
  return null;
}

CreditLimitWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    customer_credit_limit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    outstanding_balance: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  lineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape),
  customerCreditTerm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

function StrictTraceWarning(_ref5) {
  var company = _ref5.company,
      inventories = _ref5.inventories;

  var strictTraceRequired = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(company, "imperfect_trace") && inventories.some(function (i) {
    return i.imperfect_trace;
  });
  if (!strictTraceRequired) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Warning: This item is flagged as Imperfect Trace and " + company.name + " has Imperfect Trace\n      Requirements. Please confirm they'll accept or consider quoting another\n      line item (if avail.)"
  );
}

StrictTraceWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    imperfect_trace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  inventories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ imperfect_trace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool }))
};

function BlanketExchangeAgreementWarning(_ref6) {
  var company = _ref6.company,
      exchangeSale = _ref6.exchangeSale;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(company, "blanket_exchange_agreement") && exchangeSale) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
      null,
      "Blanket Exchange Agreement on file. Only create an Exchange Agreement if T&Cs are out of the ordinary for this sale."
    );
  }

  return null;
}

BlanketExchangeAgreementWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    blanket_exchange_agreement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  exchangeSale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function DiscreetWarning(_ref7) {
  var carrier = _ref7.carrier,
      discreet = _ref7.discreet,
      shippingType = _ref7.shippingType;

  if (discreet) return null;
  if (!shippingType && !carrier) return null;
  if (carrier && carrier !== __WEBPACK_IMPORTED_MODULE_6__shared_constants__["d" /* OTHER */]) return null;
  if (shippingType && ![__WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingSection_shippingTypes__["d" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingSection_shippingTypes__["e" /* DROPSHIP */]].includes(shippingType)) return null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Please confirm that this order is NOT meant to ship DISCREET"
  );
}

DiscreetWarning.propTypes = {
  carrier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  discreet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shippingTypes__ = __webpack_require__(720);
/* harmony export (immutable) */ __webpack_exports__["a"] = validateShippingFields;
/* harmony export (immutable) */ __webpack_exports__["b"] = validateForShippingType;







function validateShippingFields(shippingType, values, form) {
  var validateShippingMethod = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var shipToType = values[shippingType + "_type"];
  form.validate(shippingType + "_type").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);

  if (shipToType === __WEBPACK_IMPORTED_MODULE_5__shippingTypes__["a" /* COMPANY */]) {
    form.validate(shippingType + "_company_id", shippingType + "_company_address_id").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  } else if (shipToType === __WEBPACK_IMPORTED_MODULE_5__shippingTypes__["b" /* DROPSHIP */]) {
    form.validateChild(shippingType + "_shipping_address", function (address) {
      address.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["x" /* COMPANY_NAME */], __WEBPACK_IMPORTED_MODULE_2__constants__["r" /* COUNTRY */], __WEBPACK_IMPORTED_MODULE_2__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_2__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_2__constants__["w" /* POSTAL_CODE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    });
  } else if (shipToType === __WEBPACK_IMPORTED_MODULE_5__shippingTypes__["c" /* CUSTOMER */]) {
    if (values.physical_address && values.physical_address.line1) {
      form.validateChild(__WEBPACK_IMPORTED_MODULE_3__companies_constants__["l" /* PHYSICAL_ADDRESS */], function (address) {
        address.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["r" /* COUNTRY */], __WEBPACK_IMPORTED_MODULE_2__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_2__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_2__constants__["w" /* POSTAL_CODE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      });
    } else {
      form.validate(shippingType + "_customer_address_id").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }
  } else if (shipToType === __WEBPACK_IMPORTED_MODULE_5__shippingTypes__["d" /* REPAIR_STATION */]) {
    form.validate("repair_station_physical_address_id").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  }

  if (validateShippingMethod) {
    form.validateChild(shippingType + "_shipping_method", function (method) {
      method.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* CARRIER */], __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* SHIPPING_METHOD */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    });
  }
}

function validateForShippingType(shippingType) {
  return function (values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
      validateShippingFields(shippingType, values, form);
    });
  };
}

/* harmony default export */ __webpack_exports__["c"] = (function (values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    validateShippingFields(__WEBPACK_IMPORTED_MODULE_2__constants__["B" /* SHIP_TO */], values, form);

    form.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["t" /* SHIP_TO_COMPANY_DISABLED */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["t" /* shipToCompanyIsNoBiz */]);
  });
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cable__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Receiving_actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrders_actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pagination__ = __webpack_require__(456);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return subscribe; });
/* unused harmony export dashboardPageActions */
/* unused harmony export stateLocator */
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony export (immutable) */ __webpack_exports__["c"] = save;
/* harmony export (immutable) */ __webpack_exports__["g"] = toggleAsyncPicked;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildFilters;
/* harmony export (immutable) */ __webpack_exports__["d"] = reloadSilent;
/* harmony export (immutable) */ __webpack_exports__["f"] = unsubscribe;
/* unused harmony export onDisconnect */


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var dashboardPageActions = __WEBPACK_IMPORTED_MODULE_5__pagination__["a" /* default */].pageActions,
    stateLocator = __WEBPACK_IMPORTED_MODULE_5__pagination__["a" /* default */].stateLocator;



function create(_ref) {
  var formData = _ref.formData;

  return function (dispatch) {
    return Promise.all((formData.attachments || []).map(function (attachment) {
      return (attachment.files || [{}]).map(function (f) {
        return _extends({
          file: f
        }, attachment);
      });
    }).flat().map(__WEBPACK_IMPORTED_MODULE_3__Receiving_actions__["a" /* buildAttachments */])).then(function (attachments) {
      var shipment = Object.assign({}, formData, {
        attachments: attachments
      });
      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].shipments.create(shipment).then(function () {
        dispatch(reloadSilent());
        return __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__["a" /* SUCCESS */];
      });
    }).catch(function (e) {
      return Promise.reject(e);
    });
  };
}

function save(id, formData) {
  return function (dispatch) {
    return Promise.all((formData.attachments || []).map(function (attachment) {
      attachment.files = attachment.files || [{}];

      return attachment.files.map(function (f) {
        return _extends({
          file: f
        }, attachment);
      });
    }).flat().map(__WEBPACK_IMPORTED_MODULE_3__Receiving_actions__["a" /* buildAttachments */])).then(function (attachments) {
      var formattedData = Object.assign({}, formData, {
        attachments: attachments
      });
      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].orders.warehouse_pick(id, formattedData).then(function () {
        dispatch(reloadSilent());
        return __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__["a" /* SUCCESS */];
      });
    });
  };
}

function toggleAsyncPicked(order) {
  var serializedUser = JSON.parse(window.localStorage.getItem("user"));

  var data = {
    picked: !order.picked,
    picked_details: {
      picked_at: new Date(),
      picked_by: {
        id: !order.picked && serializedUser.id,
        name: serializedUser.full_name
      }
    }
  };
  return dashboardPageActions.updateAsync(order.id, data, __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].inventories.togglePick(order.order_id, { type: order.type }));
}

var channel = null;

function buildFilters(paginator) {
  var params = paginator.get("filters").toJS();
  var limit = paginator.get("pageSize");
  var page = paginator.get("page");

  return _extends({ limit: limit, page: page }, params);
}

function reloadSilent() {
  var salesOrderDetail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return function (dispatch, getState) {
    if (salesOrderDetail) {
      var salesOrderID = getState().salesOrderDetail.getIn(["salesOrder", "id"]);

      if (salesOrderID) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__SalesOrders_actions__["a" /* fetchSalesOrderWithAllLineItems */])(salesOrderID));
      }
    }
    var currentState = getState();
    var paginator = stateLocator(currentState);
    var filters = buildFilters(paginator);

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].outboundOrders.search(filters).then(function (_ref2) {
      var data = _ref2.data;

      dispatch(dashboardPageActions.resetResults(data.results));
    });
  };
}

function unsubscribe() {
  return function () {
    if (channel) {
      channel.unsubscribe();
      channel = null;
    }
  };
}

function onDisconnect() {
  return unsubscribe();
}

function subscribe() {
  var _onReceive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reloadSilent;

  return function (dispatch) {
    if (!channel) {
      var _createChannel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cable__["b" /* createChannel */])(),
          listen = _createChannel.listen;

      channel = listen("OutboundOrdersChannel", {
        onDisconnect: onDisconnect,
        onReceive: function onReceive(data) {
          if (["SHIPPED", "CREATE", "UPDATED"].includes(data.action)) {
            dispatch(_onReceive());
          }
        }
      });
    }
  };
}

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Authorized__ = __webpack_require__(478);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Authorized__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Forbidden__ = __webpack_require__(277);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Forbidden__["a"]; });



/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmAction__ = __webpack_require__(77);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ConfirmAction__["a"]; });



/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AutoComplete_AutoComplete__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formField__ = __webpack_require__(142);
/* unused harmony export AutoCompleteInput */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AutoCompleteInput = function (_React$Component) {
  _inherits(AutoCompleteInput, _React$Component);

  function AutoCompleteInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AutoCompleteInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AutoCompleteInput.__proto__ || Object.getPrototypeOf(AutoCompleteInput)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function () {
      _this.props.input.onChange(null);
    }, _this.onSelect = function (item) {
      var _this$props = _this.props,
          input = _this$props.input,
          onItemSelected = _this$props.onItemSelected;

      var value = item && item.id || null;

      input.onChange(value);
      input.onBlur(value);
      if (onItemSelected) onItemSelected(item);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AutoCompleteInput, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          addon = _props.addon,
          autoFocus = _props.autoFocus,
          search = _props.search,
          selectedItem = _props.selectedItem,
          _props$formatItem = _props.formatItem,
          formatItem = _props$formatItem === undefined ? function (item) {
        return item && item.id;
      } : _props$formatItem,
          _props$placeholder = _props.placeholder,
          placeholder = _props$placeholder === undefined ? "" : _props$placeholder,
          input = _props.input,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled,
          allowUserInput = _props.allowUserInput,
          watch = _props.watch,
          forceClear = _props.forceClear,
          meta = _props.meta;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AutoComplete_AutoComplete__["a" /* default */], {
        autoFocus: autoFocus,
        search: search,
        onSelect: this.onSelect,
        format: formatItem,
        hasId: allowUserInput ? true : !!input.value,
        value: selectedItem && formatItem(selectedItem),
        placeholder: placeholder,
        disabled: disabled,
        addon: addon,
        watch: watch,
        forceClear: forceClear,
        meta: meta
      });
    }
  }]);

  return AutoCompleteInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formField__["a" /* default */])(AutoCompleteInput));

AutoCompleteInput.propTypes = {
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onItemSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectedItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  formatItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  forceClear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  allowUserInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  watch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony export (immutable) */ __webpack_exports__["a"] = translateProps;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var noSelector = function noSelector() {
  return {};
};

var defaultOptions = {
  erase: false
};

function translateProps() {
  var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noSelector;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;

  var originalProps = function originalProps(props) {
    if (options.erase) {
      return {};
    }

    return props;
  };

  return function (Component) {
    return function (props) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, originalProps(props), translate.apply(undefined, [props].concat(args))));
    };
  };
}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(195);
var core = __webpack_require__(153);
var ctx = __webpack_require__(503);
var hide = __webpack_require__(251);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(81)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(123)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(228)('meta');
var isObject = __webpack_require__(68);
var has = __webpack_require__(122);
var setDesc = __webpack_require__(90).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(66)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony export (immutable) */ __webpack_exports__["a"] = useDebounce;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



function useDebounce(delay) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(values),
      _useState2 = _slicedToArray(_useState, 2),
      debouncedValue = _useState2[0],
      setDebouncedValue = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(values);
    }, delay);

    return function () {
      clearTimeout(handler);
    };
  }, [].concat(values));

  return debouncedValue;
}

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Nav_Notifications_actions__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return expireNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return expireSearchNotifications; });
/* unused harmony export removeAsync */
/* harmony export (immutable) */ __webpack_exports__["d"] = markDeleted;
/* harmony export (immutable) */ __webpack_exports__["a"] = markRead;
/* harmony export (immutable) */ __webpack_exports__["e"] = markAllRead;




var _composables = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["composables"])({
  listId: "notifications"
});

var expireNotifications = _composables.expire;


var _composables2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["composables"])({
  listId: "searchNotifications"
});

var expireSearchNotifications = _composables2.expire,
    removeAsync = _composables2.removeAsync;



function markDeleted(noteId) {
  return function (dispatch) {
    return dispatch(removeAsync(noteId, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].notifications.update(noteId, { deleted_at: new Date() }).then(function () {
      dispatch(expireNotifications());
      return dispatch(__WEBPACK_IMPORTED_MODULE_1__Nav_Notifications_actions__["a" /* expire */]());
    }), false));
  };
}

function markRead(noteId) {
  return function (dispatch) {
    return dispatch(removeAsync(noteId, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].notifications.update(noteId, { read: true }).then(function () {
      dispatch(expireNotifications());
      return dispatch(__WEBPACK_IMPORTED_MODULE_1__Nav_Notifications_actions__["a" /* expire */]());
    }), false));
  };
}

function markAllRead(filters) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].notifications.markAllRead(filters).then(function () {
      dispatch(expireNotifications());
      dispatch(expireSearchNotifications());
      dispatch(__WEBPACK_IMPORTED_MODULE_1__Nav_Notifications_actions__["a" /* expire */]());
    });
  };
}

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CoBuyersFields_CoBuyersFields__ = __webpack_require__(324);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__CoBuyersFields_CoBuyersFields__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CoBuyersFields_BuyerField__ = __webpack_require__(323);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__CoBuyersFields_BuyerField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PurchaseForFields__ = __webpack_require__(446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__PurchaseForFields__["a"]; });







/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__companies_constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["d"] = validateConditionFields;
/* harmony export (immutable) */ __webpack_exports__["a"] = validatePurchaseForFields;
/* harmony export (immutable) */ __webpack_exports__["b"] = validatePurchaseForSaleFields;
/* harmony export (immutable) */ __webpack_exports__["c"] = validateShippingFields;







function validateConditionFields(values, form) {
  if ([__WEBPACK_IMPORTED_MODULE_2__IncomingQuotes_constants__["g" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_2__IncomingQuotes_constants__["h" /* INSPECTED */], __WEBPACK_IMPORTED_MODULE_2__IncomingQuotes_constants__["i" /* REPAIRED */]].includes(values.condition)) {
    form.validate(__WEBPACK_IMPORTED_MODULE_3__inventories_constants__["x" /* TAG_DATE */]).required();
  }

  if ([__WEBPACK_IMPORTED_MODULE_2__IncomingQuotes_constants__["g" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_2__IncomingQuotes_constants__["h" /* INSPECTED */], __WEBPACK_IMPORTED_MODULE_2__IncomingQuotes_constants__["i" /* REPAIRED */]].includes(values.condition)) {
    form.validate(__WEBPACK_IMPORTED_MODULE_3__inventories_constants__["p" /* TAGGED_BY */]).required();
  }
}

function validatePurchaseForFields(values, form) {
  form.validate("_error").satisfies(function () {
    if (!(values.purchase_for_repair_assist || values.purchase_for_repair || values.purchase_for_sale || values.purchase_for_stock)) {
      return "At least 1 Purchase For selection is required";
    }

    return null;
  });
}

function validatePurchaseForSaleFields(values, form) {
  if (values.purchase_for_sale) {
    form.validate("reserve_for_seller_id", "reserve_for_sale_quantity").required();
    form.validate("reserve_for_sale_quantity").satisfies(__WEBPACK_IMPORTED_MODULE_0__lib_validation_rules__["f" /* isGreaterThan */](0));

    if (values.quantity) {
      form.validate("reserve_for_sale_quantity").satisfies(__WEBPACK_IMPORTED_MODULE_0__lib_validation_rules__["k" /* isLessThanOrEqualTo */](values.quantity));
    }
  }
}

function validateShippingFields(values, form) {
  form.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["o" /* SHIPPING_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_0__lib_validation_rules__["a" /* required */]);

  if (values.shipping_type === __WEBPACK_IMPORTED_MODULE_1__constants__["K" /* COMPANY */]) {
    form.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */]).required();
  }

  if (values.shipping_type === __WEBPACK_IMPORTED_MODULE_1__constants__["L" /* DROPSHIP */]) {
    form.validateChild(__WEBPACK_IMPORTED_MODULE_4__constants__["I" /* SHIPPING_ADDRESS */], function (a) {
      a.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_4__constants__["w" /* POSTAL_CODE */], __WEBPACK_IMPORTED_MODULE_4__constants__["r" /* COUNTRY */]).required();
    });
  }

  if (values.shipping_type === __WEBPACK_IMPORTED_MODULE_5__companies_constants__["f" /* REPAIR_STATION */]) {
    form.validate("repair_station_physical_address_id").required();
  }

  if (values.shipping_type === __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* DO_NOT_SHIP */]) {
    form.validate("_error").satisfies(function () {
      if (!__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* DO_NOT_SHIP_REASONS */].some(function (field) {
        return values[field];
      })) {
        return "At least 1 DO NOT SHIP REASON selection is required";
      }

      return null;
    });
  } else {
    form.validateChild(__WEBPACK_IMPORTED_MODULE_4__constants__["g" /* SHIPPING_METHOD */], function (s) {
      s.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* CARRIER */], __WEBPACK_IMPORTED_MODULE_4__constants__["g" /* SHIPPING_METHOD */]).satisfies(__WEBPACK_IMPORTED_MODULE_0__lib_validation_rules__["a" /* required */]);
    });
  }
}

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withRma__ = __webpack_require__(271);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withRma__["a"]; });



/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony export (immutable) */ __webpack_exports__["a"] = DoNotDoBusinessWarning;






function DoNotDoBusinessWarning(_ref) {
  var company = _ref.company;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(company, "status") === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* NO_BIZ */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Warning_Warning__["a" /* default */],
    null,
    "This Company has been flagged as `Do Not Do Business`. Please select another Company or select `Cancel`."
  );
}

DoNotDoBusinessWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony export (immutable) */ __webpack_exports__["a"] = RestrictedEntityWarning;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








function RestrictedEntityWarning(_ref) {
  var _ref$allContacts = _ref.allContacts,
      allContacts = _ref$allContacts === undefined ? false : _ref$allContacts,
      company = _ref.company,
      contactId = _ref.contactId,
      name = _ref.name,
      requireApproval = _ref.requireApproval;

  if (!company && !name || company && !company.name) return null;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      restrictedEntities = _useState2[0],
      setRestrictedEntities = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var params = { all_contacts: allContacts };
    if (company) {
      params.company_id = company.id;
    } else if (name) {
      params.name = name;
    }

    if (contactId) {
      params.contact_id = contactId;
    }

    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].restrictedEntities.search(params).then(function (resp) {
      if (Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(resp, "data.total", 0)) > 0) {
        setRestrictedEntities(resp.data.results);
      } else {
        setRestrictedEntities(null);
      }
    });
  }, [company, contactId, name]);

  if (!restrictedEntities) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Warning: Similar entity name in US Gov't Screening List:",
    " ",
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["b" /* toSentence */])(restrictedEntities.map(function (f) {
      return f.name;
    })),
    ".",
    " ",
    requireApproval && "Pre-Approval Required."
  );
}

RestrictedEntityWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
  }),
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__ = __webpack_require__(11);










function TagTypes(_ref) {
  var faa = _ref.faa.input,
      easa = _ref.easa.input,
      uk_caa = _ref.uk_caa,
      caac = _ref.caac.input,
      tcca = _ref.tcca.input,
      other = _ref.other.input,
      otherTagType = _ref.other_tag_type.input,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      getFieldValue = _ref.getFieldValue,
      setFieldValue = _ref.setFieldValue,
      _ref$required = _ref.required,
      required = _ref$required === undefined ? false : _ref$required;

  // eslint-disable-next-line
  var ukCaaInput = uk_caa ? uk_caa.input : null;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group", style: { cursor: "pointer" } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { className: "control-label", htmlFor: "tag_type" },
      "Release Type ",
      required && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "sup",
        { className: "small text-danger" },
        "*"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        id: "tag_type",
        className: "btn-group btn-group-justified",
        "data-toggle": "buttons"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */], {
        input: faa,
        label: __WEBPACK_IMPORTED_MODULE_3__constants__["H" /* FAA */].toUpperCase(),
        disabled: disabled,
        icon: "fa-check-circle"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */], {
        input: easa,
        label: __WEBPACK_IMPORTED_MODULE_3__constants__["I" /* EASA */].toUpperCase(),
        disabled: disabled,
        icon: "fa-check-circle"
      }),
      ukCaaInput && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */], {
        input: ukCaaInput,
        label: __WEBPACK_IMPORTED_MODULE_3__constants__["L" /* UK_CAA */].replace("_", " ").toUpperCase(),
        disabled: disabled,
        icon: "fa-check-circle"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */], {
        input: tcca,
        label: __WEBPACK_IMPORTED_MODULE_3__constants__["K" /* TCCA */].toUpperCase(),
        disabled: disabled,
        icon: "fa-check-circle"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */], {
        input: caac,
        label: __WEBPACK_IMPORTED_MODULE_3__constants__["J" /* CAAC */].toUpperCase(),
        disabled: disabled,
        icon: "fa-check-circle"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */], {
        input: other,
        label: __WEBPACK_IMPORTED_MODULE_3__constants__["M" /* OTHER */].toUpperCase(),
        disabled: disabled,
        onChange: function onChange(val) {
          if (!val) setFieldValue(otherTagType.name)("");
        },
        icon: "fa-check-circle"
      })
    )
  ), !getFieldValue(other.name) ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormRow__["a" /* default */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 5 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
        component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["d" /* FormInput */],
        disabled: disabled,
        name: __WEBPACK_IMPORTED_MODULE_3__constants__["N" /* OTHER_TAG_TYPE */],
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_3__constants__["N" /* OTHER_TAG_TYPE */]),
        maxLength: 10,
        max: 10
      })
    )
  )];
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(TagTypes));

TagTypes.propTypes = {
  caac: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  easa: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  uk_caa: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  faa: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  tcca: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  other: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  other_tag_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HoverFlag__ = __webpack_require__(2209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__HoverFlag__["a"]; });


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Notes_resourceToStateKey__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Authorized__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ImagePortal_ImagePortal__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_bytes__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions_attachments__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__EditAttachment__ = __webpack_require__(2271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__AddAttachment__ = __webpack_require__(2266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Delete__ = __webpack_require__(2270);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Attachments; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









 // TODO: Move this file to a better shared location!














var Attachments = function (_React$Component) {
  _inherits(Attachments, _React$Component);

  function Attachments() {
    _classCallCheck(this, Attachments);

    var _this = _possibleConstructorReturn(this, (Attachments.__proto__ || Object.getPrototypeOf(Attachments)).call(this));

    _this.state = {
      deleteOpen: false,
      openPortal: false
    };

    _this.openDeleteModal = function () {
      return _this.setState({ deleteOpen: true });
    };

    _this.openPortal = function (url) {
      return function () {
        return _this.setState({ openPortal: !_this.state.openPortal, url: url });
      };
    };

    _this.renderRow = function (attachment) {
      var url = attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_3" /* FILE_URL */]) || attachment.get("link_url");
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          isInventory = _this$props.isInventory;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */]) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_4" /* SMALL_VERSION_CREATED_AT */]) && attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["n" /* ATTACHMENT_TYPE */]).includes("photo") ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
            alt: attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["S" /* NAME */]),
            src: attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_5" /* SMALL_FILE_URL */]),
            style: {
              cursor: "pointer",
              height: "50px",
              paddingTop: "10px",
              paddingLeft: "10px"
            },
            onClick: _this.openPortal(attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_3" /* FILE_URL */]))
          }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            null,
            "\xA0\xA0"
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7____["r" /* ExternalLink */],
            { url: url },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "fa fa-download" })
          )] : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7____["r" /* ExternalLink */],
            { url: url },
            attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["S" /* NAME */])
          )
        ),
        _this.props.referenceOptions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_6" /* REFERENCE_NUMBER */])
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["n" /* ATTACHMENT_TYPE */]) && function () {
            var typeLabel = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(Object.assign(_this.props.attachmentTypes, {
              other: {
                label: "Other"
              }
            }), attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["n" /* ATTACHMENT_TYPE */]) + ".label");
            var description = attachment.get(__WEBPACK_IMPORTED_MODULE_16__parts_constants__["u" /* DESCRIPTION */]) || "";
            return [typeLabel, description].filter(function (f) {
              return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(f);
            }).join(" - ");
          }()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["truncate"])(attachment.get(__WEBPACK_IMPORTED_MODULE_16__parts_constants__["u" /* DESCRIPTION */]), 30)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__["b" /* shortDate */])(attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_7" /* CREATED_AT */]))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          attachment.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["_8" /* CREATED_BY */], __WEBPACK_IMPORTED_MODULE_12__users_constants__["f" /* FULL_NAME */]])
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_bytes__["a" /* convertByteToMB */])(attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_9" /* FILE_SIZE */]))
        ),
        !isInventory && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__Authorized__["a" /* default */],
            {
              authorizedIf: function authorizedIf(user) {
                return user.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */]) === attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_10" /* CREATED_BY_ID */]) || user.get(__WEBPACK_IMPORTED_MODULE_12__users_constants__["D" /* PERMISSIONS */]).includes(__WEBPACK_IMPORTED_MODULE_12__users_constants__["H" /* CAN_DELETE_RECEIVING_RECORD_ATTACHMENTS */]) && _this.props.resourceType === __WEBPACK_IMPORTED_MODULE_15__types_resourceTypes__["a" /* default */].receivingRecord;
              }
            },
            !disabled && !isInventory && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Delete__["a" /* default */], {
              attachment: attachment,
              resourceType: _this.props.resourceType
            }),
            isInventory && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__DropDown__["b" /* default */],
              {
                icon: "fa fa-fw fa-ellipsis-v",
                menuClass: "dropdown-menu-right"
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__DropDown__["a" /* DropDownItem */],
                { onClick: function onClick() {} },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__EditAttachment__["a" /* default */], {
                  id: attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */]),
                  attachmentType: attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["n" /* ATTACHMENT_TYPE */]),
                  resourceType: _this.props.resourceType
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Delete__["a" /* default */], {
                  label: "Delete",
                  attachment: attachment,
                  resourceType: _this.props.resourceType
                })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          !disabled && !isInventory && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__DropDown__["b" /* default */],
            {
              icon: "fa fa-fw fa-ellipsis-v",
              menuClass: "dropdown-menu-right"
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__DropDown__["a" /* DropDownItem */],
              { onClick: function onClick() {} },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__EditAttachment__["a" /* default */], {
                id: attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */]),
                attachmentType: attachment.get(__WEBPACK_IMPORTED_MODULE_11__constants__["n" /* ATTACHMENT_TYPE */]),
                attachmentTypes: _this.props.attachmentTypes,
                resourceType: _this.props.resourceType
              })
            )
          )
        )
      );
    };

    _this.handleDeleteAttachment = _this.handleDeleteAttachment.bind(_this);
    return _this;
  }

  _createClass(Attachments, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.preloaded) return;
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__actions_attachments__["a" /* getAttachments */])(this.props.resource.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */]), this.props.resourceType));
    }
  }, {
    key: "handleDeleteAttachment",
    value: function handleDeleteAttachment() {
      this.openDeleteModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$attachments = _props.attachments,
          attachments = _props$attachments === undefined ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])() : _props$attachments,
          attachmentTypes = _props.attachmentTypes,
          disabled = _props.disabled,
          isLoading = _props.isLoading,
          multiple = _props.multiple,
          resource = _props.resource,
          resourceType = _props.resourceType,
          title = _props.title;

      var handleKeyDown = function handleKeyDown(event) {
        if (event.key === "Escape") {
          _this2.setState({ openPortal: false });
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { tabIndex: 0, onKeyDown: handleKeyDown },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          title || "Attachments",
          !disabled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__AddAttachment__["a" /* default */], {
            attachmentTypes: attachmentTypes,
            multiple: multiple,
            resourceType: resourceType,
            resourceId: resource.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */]),
            referenceOptions: this.props.referenceOptions
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ImagePortal_ImagePortal__["a" /* default */], {
          setOpen: this.openPortal(),
          url: this.state.url,
          open: this.state.openPortal,
          name: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["Y" /* PHOTOS */]
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7____["s" /* DataTable */].Mini,
          { loading: isLoading },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7____["s" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Name"
            ),
            this.props.referenceOptions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Ref #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Type"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Desc"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Date Added"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Added By"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "File Size"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7____["s" /* DataTable */].Body,
            null,
            attachments.map(this.renderRow).toJS()
          )
        )
      );
    }
  }]);

  return Attachments;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Attachments.propTypes = _extends({
  attachmentTypes: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object),
  attachments: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"]),
  dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  isInventory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  preloaded: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  resourceType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  resource: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),
  referenceOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})),
  title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
}, __WEBPACK_IMPORTED_MODULE_9__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state, ownProps) {
  return {
    attachments: state[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__Notes_resourceToStateKey__["a" /* default */])(ownProps.resourceType)].get("attachments"),
    isLoading: state[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__Notes_resourceToStateKey__["a" /* default */])(ownProps.resourceType)].get("attachmentsLoading"),
    id: ownProps.resource.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */])
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__session_decorators_withCurrentUser__["b" /* default */])(Attachments)));

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm hr-dashed margin-top-none" });
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = ExternalLink;



function ExternalLink(_ref) {
  var url = _ref.url,
      children = _ref.children,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style;

  if (!url) {
    return false;
  }

  var href = url.match(/^(http|https):\/\//i) ? url : "http://" + url;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "a",
    { href: href, rel: "noopener noreferrer", target: "_blank", style: style },
    children || url
  );
}

ExternalLink.propTypes = {
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)])
};

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LineItemStatusCell__ = __webpack_require__(2345);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LineItemStatusCell__["a"]; });



/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShippingSection__ = __webpack_require__(812);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__ShippingSection__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ShippingSection__["a"]; });





/***/ }),
/* 215 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(249);
var IE8_DOM_DEFINE = __webpack_require__(831);
var toPrimitive = __webpack_require__(514);
var dP = Object.defineProperty;

exports.f = __webpack_require__(250) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(832);
var defined = __webpack_require__(504);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(146);
var call = __webpack_require__(853);
var isArrayIter = __webpack_require__(525);
var anObject = __webpack_require__(57);
var toLength = __webpack_require__(91);
var getIterFn = __webpack_require__(542);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(57);
var dPs = __webpack_require__(859);
var enumBugKeys = __webpack_require__(521);
var IE_PROTO = __webpack_require__(533)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(520)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(523).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(861);
var hiddenKeys = __webpack_require__(521).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(861);
var enumBugKeys = __webpack_require__(521);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(124);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(60);
var dP = __webpack_require__(90);
var DESCRIPTORS = __webpack_require__(89);
var SPECIES = __webpack_require__(81)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(159);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 228 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
module.exports = exports["default"];

/***/ }),
/* 230 */,
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(2882),
    getValue = __webpack_require__(2904);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 232 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 233 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 234 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(94);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(229);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(72);
/* unused harmony export poundsToKilograms */
/* unused harmony export kilogramsToPounds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calculateValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateNetValue; });
/* harmony export (immutable) */ __webpack_exports__["b"] = conversionUnit;
/* harmony export (immutable) */ __webpack_exports__["d"] = conversionUnitAbbrev;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var poundsToKilograms = function poundsToKilograms(lbs) {
  return 0.4536 * lbs;
};

var kilogramsToPounds = function kilogramsToPounds(kg) {
  return kg / 0.4536;
};

var ozToKilograms = function ozToKilograms(oz) {
  return oz * 0.0283495;
};

var calculateValue = function calculateValue(unit) {
  var _map;

  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (!unit) {
    return null;
  }
  var map = (_map = {}, _defineProperty(_map, __WEBPACK_IMPORTED_MODULE_0__modules_parts_constants__["z" /* POUNDS */], poundsToKilograms(value)), _defineProperty(_map, __WEBPACK_IMPORTED_MODULE_0__modules_parts_constants__["A" /* KILOS */], kilogramsToPounds(value)), _map);

  return Math.ceil(map[unit]);
};

var calculateNetValue = function calculateNetValue(unit, value, ozValue) {
  var _map2;

  if (!unit) return null;

  var map = (_map2 = {}, _defineProperty(_map2, __WEBPACK_IMPORTED_MODULE_0__modules_parts_constants__["z" /* POUNDS */], poundsToKilograms(value) + ozToKilograms(Number(ozValue))), _defineProperty(_map2, __WEBPACK_IMPORTED_MODULE_0__modules_parts_constants__["A" /* KILOS */], kilogramsToPounds(value)), _map2);

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["c" /* displayDecimal */])(map[unit], 1000);
};

function conversionUnit(unit) {
  if (!unit) {
    return null;
  }
  return unit === __WEBPACK_IMPORTED_MODULE_0__modules_parts_constants__["z" /* POUNDS */] ? "Kilograms" : "Pounds";
}

function conversionUnitAbbrev(unit) {
  if (!unit) {
    return null;
  }
  return unit === __WEBPACK_IMPORTED_MODULE_0__modules_parts_constants__["z" /* POUNDS */] ? "kg" : "lb";
}

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return states; });
var states = [{ value: "AL", text: "Alabama" }, { value: "AK", text: "Alaska" }, { value: "AZ", text: "Arizona" }, { value: "AR", text: "Arkansas" }, { value: "CA", text: "California" }, { value: "CO", text: "Colorado" }, { value: "CT", text: "Connecticut" }, { value: "DE", text: "Delaware" }, { value: "DC", text: "District Of Columbia" }, { value: "FL", text: "Florida" }, { value: "GA", text: "Georgia" }, { value: "HI", text: "Hawaii" }, { value: "ID", text: "Idaho" }, { value: "IL", text: "Illinois" }, { value: "IN", text: "Indiana" }, { value: "IA", text: "Iowa" }, { value: "KS", text: "Kansas" }, { value: "KY", text: "Kentucky" }, { value: "LA", text: "Louisiana" }, { value: "ME", text: "Maine" }, { value: "MD", text: "Maryland" }, { value: "MA", text: "Massachusetts" }, { value: "MI", text: "Michigan" }, { value: "MN", text: "Minnesota" }, { value: "MS", text: "Mississippi" }, { value: "MO", text: "Missouri" }, { value: "MT", text: "Montana" }, { value: "NE", text: "Nebraska" }, { value: "NV", text: "Nevada" }, { value: "NH", text: "New Hampshire" }, { value: "NJ", text: "New Jersey" }, { value: "NM", text: "New Mexico" }, { value: "NY", text: "New York" }, { value: "NC", text: "North Carolina" }, { value: "ND", text: "North Dakota" }, { value: "OH", text: "Ohio" }, { value: "OK", text: "Oklahoma" }, { value: "OR", text: "Oregon" }, { value: "PA", text: "Pennsylvania" }, { value: "RI", text: "Rhode Island" }, { value: "SC", text: "South Carolina" }, { value: "SD", text: "South Dakota" }, { value: "TN", text: "Tennessee" }, { value: "TX", text: "Texas" }, { value: "UT", text: "Utah" }, { value: "VT", text: "Vermont" }, { value: "VA", text: "Virginia" }, { value: "WA", text: "Washington" }, { value: "WV", text: "West Virginia" }, { value: "WI", text: "Wisconsin" }, { value: "WY", text: "Wyoming" }];

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ATTACHMENT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MANAGED_REPAIR_ORDER; });
var ATTACHMENT_TYPES = {
  vendor_correspondence: {
    label: "Vendor Correspondence"
  },
  traceability: {
    label: "Traceability"
  },
  tag_copies: {
    label: "Tag Copies"
  },
  packing_slip: {
    label: "Packing Slip"
  },
  photos: {
    label: "Photos"
  },
  signed_exchange_agreement: {
    label: "Signed Exchange Agreement"
  },
  external_link: {
    label: "External Link"
  },
  end_user_agreement: {
    label: "End User Agreement"
  }
};

var MANAGED_REPAIR_ORDER = "managed_repair_order";

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_CurrencyField_CurrencyField__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony export (immutable) */ __webpack_exports__["a"] = InvoiceSection;











function InvoiceSection(_ref) {
  var disabled = _ref.disabled,
      hidden = _ref.hidden,
      orderType = _ref.orderType;

  if (hidden) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h4",
      null,
      "Billing"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__["N" /* INVOICE_NUMBER */],
          component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["d" /* FormInput */],
          label: "Invoice #",
          disabled: disabled
        })
      ),
      orderType === __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__["x" /* PURCHASE_ORDER */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          type: "date",
          name: "invoice_due_date",
          component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["d" /* FormInput */],
          label: "Invoice Due Date",
          disabled: disabled
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          type: "date",
          name: __WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__["g" /* INVOICE_PAID_DATE */],
          component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["d" /* FormInput */],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__["g" /* INVOICE_PAID_DATE */]),
          disabled: disabled
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__["O" /* AMOUNT_PAID */],
          component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_CurrencyField_CurrencyField__["a" /* default */],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__["O" /* AMOUNT_PAID */]),
          disabled: disabled
        })
      )
    )
  );
}

InvoiceSection.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hidden: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  orderType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Locations_components_ToolsUsedDropDown__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Orders_shared_InvoiceSection__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__SRPConditionMismatchWarning__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lib_time__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__shared_TierTypeExchangeSrpWarning__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__inventories_helpers__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Shipping_constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__inventories_components_EditInventory_TagTypes__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__shared_components_NoteTooltip_AuditedNoteTooltip__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__PartSummary__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__validate__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__shared_components_DashedSeparator_DashedSeparator__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__DomLifeWarning__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__shared_PreviousSrpConditionWarning__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__shared_TierTypePurchaseWarning__ = __webpack_require__(1574);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SRP_CONDITION_OPTIONS; });
/* unused harmony export conditionOptions */
/* unused harmony export exchangeSrpValidated */
/* harmony export (immutable) */ __webpack_exports__["c"] = exchangeSrpNotAllowed;
/* harmony export (immutable) */ __webpack_exports__["d"] = ExchangeSrpWarning;
/* unused harmony export DOMIsRequiredWarning */
/* harmony export (immutable) */ __webpack_exports__["e"] = UnauthorizedRepairStationSelectedWarning;
/* unused harmony export PurchaseForSaleQuantityWarning */
/* unused harmony export SixMonthsOldTagDateWarning */
/* harmony export (immutable) */ __webpack_exports__["h"] = UnauthorizedPreferredRepairStationSelectedWarning;
/* harmony export (immutable) */ __webpack_exports__["g"] = LineHazmatFields;
/* harmony export (immutable) */ __webpack_exports__["f"] = AsIsField;
/* unused harmony export tagDateIsOlder */
/* unused harmony export Form */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















































var formName = "purchaseOrderLineItem";

var SRP_CONDITION_OPTIONS = [{ value: "overhauled", text: "Overhauled" }, { value: "repaired", text: "Repaired" }, { value: "inspected", text: "Inspected" }, { value: "new_item", text: "New" }, { value: "as_removed", text: "As Removed" }, { value: "beyond_econ_repair", text: "Beyond Econ Repair" }];

var conditionOptions = function conditionOptions(part) {
  return [{ value: "overhauled", text: "Overhauled" }, { value: "repaired", text: "Repaired" }, { value: "inspected", text: "Inspected" }, { value: "new_item", text: "New" }, { value: "as_removed", text: "As Removed" }, { value: "beyond_econ_repair", text: "Beyond Econ Repair" }, part && part.tooling_part_type ? { value: "serviceable_tooling", text: "Serviceable Tooling" } : null].filter(function (f) {
    return f;
  });
};

function InsuranceTypeField(_ref) {
  var amountInsured = _ref.amount_insured,
      percentInsured = _ref.percent_insured,
      insuranceType = _ref.insurance_type,
      disabled = _ref.disabled;

  var activePercent = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "Percent"
  });
  var activeAmount = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "Amount"
  });
  var activeNone = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "None"
  });

  var handleInsuranceTypeChange = function handleInsuranceTypeChange(newVal) {
    return function () {
      if (disabled) return;
      insuranceType.input.onChange(newVal);
      if (newVal === "Amount") {
        percentInsured.input.onChange(null);
      } else if (newVal === "Percent") {
        amountInsured.input.onChange(null);
      } else {
        amountInsured.input.onChange(null);
        percentInsured.input.onChange(null);
      }
    };
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group", style: { marginBottom: 20 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { className: "control-label", htmlFor: "insurance_type" },
      "Insurance"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "btn-group btn-group-justified", role: "group" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activeNone,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("None")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Do Not Insure"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activeAmount,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("Amount")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Amount"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activePercent,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("Percent")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Percent"
      )
    )
  );
}

InsuranceTypeField.propTypes = {
  amount_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  percent_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  insurance_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function AmountInsuredFields(_ref2) {
  var amount = _ref2.amount,
      disabled = _ref2.disabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "col-md-4" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
      name: amount.input.name,
      label: "Insurance Amount",
      disabled: disabled,
      required: true
    })
  );
}

AmountInsuredFields.propTypes = {
  amount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function exchangeSrpValidated(selectedLineItem) {
  // Validate Exchange SRP if the line item is new (undefined) or if it was
  // created after 2019-06-14
  return selectedLineItem === undefined || __WEBPACK_IMPORTED_MODULE_8_moment___default()(selectedLineItem.createdAt).isAfter(__WEBPACK_IMPORTED_MODULE_8_moment___default()("2019-06-14 07:00:00"));
}

function exchangeSrpNotAllowed(part) {
  return part && part.pass_fail;
}

function ExchangeSrpWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_42__shared_components_Warning_Warning__["a" /* default */],
    null,
    "This part is flagged as a pass/fail item. An Exchange is not allowed."
  );
}

function DOMIsRequiredWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_42__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Part is DOM Sensitive. DOM Required."
  );
}

function UnauthorizedRepairStationSelectedWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_42__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Note: This Repair Station is not approved. Unless you are reserving this unit for repair to a different repair station, PO will require management approval before you are able to send PO."
  );
}

function PurchaseForSaleQuantityWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_42__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Please ensure all items on PO are purchased for sale. If not, separate them into different line items."
  );
}

function SixMonthsOldTagDateWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_42__shared_components_Warning_Warning__["a" /* default */],
    null,
    "This purchase is for TAG DATE older than 6 months. Manager Approval will be required."
  );
}

function UnauthorizedPreferredRepairStationSelectedWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_42__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Note: This Repair Station is not approved. PO will require management approval before you are able to send PO."
  );
}

function PercentInsuredFields(_ref3) {
  var percent = _ref3.percent,
      cost = _ref3.cost,
      quantity = _ref3.quantity,
      disabled = _ref3.disabled;

  var costValue = cost.input.value || 0;
  var quantityValue = quantity.input.value || 0;
  var percentValue = percent.input.value || 0;
  var subtotal = parseFloat(costValue) * parseFloat(quantityValue);
  var insuranceAmount = Math.ceil(subtotal * percentValue) / 100;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
    { md: 12 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
          name: percent.input.name,
          label: "Insurance Percent",
          component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["h" /* NumberInput */],
          parse: function parse(value) {
            return value && parseInt(value, 10);
          },
          addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-percent" }),
          disabled: disabled,
          required: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "insurance_type" },
            "Insurance Amount"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "input-group-addon" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-dollar" })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
              className: "form-control",
              type: "text",
              value: insuranceAmount,
              disabled: true,
              readOnly: true
            })
          )
        )
      )
    )
  );
}

PercentInsuredFields.propTypes = {
  percent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function InsuranceFields(_ref4) {
  var amountInsured = _ref4.amount_insured,
      percentInsured = _ref4.percent_insured,
      insuranceType = _ref4.insurance_type,
      cost = _ref4.cost,
      quantity = _ref4.quantity,
      disabled = _ref4.disabled;

  if (insuranceType.input.value === "Amount") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AmountInsuredFields, { amount: amountInsured, disabled: disabled });
  } else if (insuranceType.input.value === "Percent") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PercentInsuredFields, {
      insuranceType: insuranceType,
      percent: percentInsured,
      cost: cost,
      quantity: quantity,
      disabled: disabled
    });
  }

  return null;
}

InsuranceFields.propTypes = {
  amount_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  percent_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  insurance_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

function LineHazmatFields(_ref5) {
  var hazmat = _ref5.hazmat,
      bio_hazmat = _ref5.bio_hazmat,
      disabled = _ref5.disabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group btn-group-justified", "data-toggle": "buttons" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */], {
      input: hazmat.input,
      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__parts_constants__["h" /* HAZMAT */]),
      icon: "fa-warning",
      disabled: disabled
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */], {
      input: bio_hazmat.input,
      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__parts_constants__["i" /* BIO_HAZMAT */]),
      icon: "fa-flask",
      disabled: disabled
    })
  );
}

LineHazmatFields.propTypes = {
  hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  bio_hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function AsIsField(_ref6) {
  var asIs = _ref6.as_is,
      condition = _ref6.condition,
      evaluationPeriod = _ref6.evaluation_period,
      purchaseForStock = _ref6.purchase_for_stock,
      disabled = _ref6.disabled;

  var handleChange = function handleChange(val) {
    asIs.input.onChange(val);
    if (val === true) {
      evaluationPeriod.input.onChange(0);
    } else {
      evaluationPeriod.input.onChange(30);

      if (condition.input.value === __WEBPACK_IMPORTED_MODULE_12__constants__["i" /* AS_REMOVED */]) {
        purchaseForStock.input.onChange(false);
      }
    }
  };

  var input = _extends({}, asIs.input, { onChange: handleChange });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group btn-group-justified", "data-toggle": "buttons" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */], {
      input: input,
      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["c" /* AS_IS */]),
      icon: "fa-check-circle",
      disabled: disabled
    })
  );
}

AsIsField.propTypes = {
  as_is: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  evaluation_period: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  purchase_for_stock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function tagDateIsOlder(tagDate) {
  return __WEBPACK_IMPORTED_MODULE_8_moment___default()().diff(tagDate, "months") > 6;
}

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref7;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref7 = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref7, [this].concat(args))), _this), _this.state = {
      alternateOptions: []
    }, _this.fetchAlternates = function (partId) {
      if (!partId) return;
      _this.props.searchAlternates(partId).then(function (results) {
        return _this.setState({
          alternateOptions: results.map(function (item) {
            return {
              text: item.name,
              value: item.id
            };
          })
        });
      });
    }, _this.calculateExpectedDate = function (leadTimeDays, date) {
      date.setDate(date.getDate() + leadTimeDays);
      return date.toISOString().split("T")[0]; // Format date as YYYY-MM-DD
    }, _this.calculateDifferenceInDays = function (startDate, endDate) {
      var diffInTime = endDate.getTime() - startDate.getTime();
      return Math.round(diffInTime / (1000 * 3600 * 24));
    }, _this.handleDateChange = function (val) {
      var selectedDate = new Date(val);
      var today = _this.props.selectedLineItem ? new Date(_this.props.selectedLineItem.created_at) : new Date();
      today.setHours(0, 0, 0, 0);

      var leadTime = _this.calculateDifferenceInDays(today, selectedDate);

      _this.props.setLeadTime(leadTime);
    }, _this.handlePartSelected = function (part) {
      _this.props.setSelectedPart(part);
      _this.props.resetAlternatePartField();
      if (part) {
        if (exchangeSrpNotAllowed(part)) {
          _this.props.resetExchangeSrpField();
        }
        _this.props.setHazardFields(part);
        _this.props.setHeavyPackage(part);
        _this.fetchAlternates(part.id);

        _this.props.change(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["s" /* TOTAL_HOURS_REMAINING */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__inventories_helpers__["a" /* totalHoursRemaining */])(part, Number(_this.props.getFieldValue(__WEBPACK_IMPORTED_MODULE_13__parts_constants__["E" /* TOTAL_HOURS */]))));

        _this.props.change(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["t" /* TOTAL_CYCLES_REMAINING */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__inventories_helpers__["b" /* totalCyclesRemaining */])(part, Number(_this.props.getFieldValue(__WEBPACK_IMPORTED_MODULE_13__parts_constants__["F" /* TOTAL_CYCLES */]))));

        if (part.dom_sensitive) {
          _this.props.change(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */], 1);
        }
      }
    }, _this.searchCompanies = function (filter) {
      return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].companies.search({
        filter: filter,
        page: 1,
        limit: 20
      }).then(function (resp) {
        return resp.data.results;
      });
    }, _this.handleTaggedBy = function (company) {
      var _this$props = _this.props,
          setTaggedById = _this$props.setTaggedById,
          setTaggedByHold = _this$props.setTaggedByHold;


      if (company && company.id) {
        setTaggedById(company.id);
        setTaggedByHold(company.repair_station_status !== __WEBPACK_IMPORTED_MODULE_23__companies_constants__["j" /* APPROVED */]);
      } else {
        setTaggedByHold(false);
      }
    }, _this.handlePreferredRepairStation = function (company) {
      var setPreferredRepairStationHold = _this.props.setPreferredRepairStationHold;


      if (company && company.id) {
        setPreferredRepairStationHold(company.repair_station_status !== __WEBPACK_IMPORTED_MODULE_23__companies_constants__["j" /* APPROVED */]);
      }
    }, _this.resetPreferredRepairStation = function () {
      var resetPreferredRepairStation = _this.props.resetPreferredRepairStation;


      resetPreferredRepairStation();

      _this.setState({ selectedPreferredRepairStation: null });
    }, _this.toggleBuyer = function (buyer) {
      return _this.setState(buyer);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.lineItem) {
        var id = this.props.lineItem.part_id;
        var part = this.props.lineItem.part;
        var coBuyer = this.props.lineItem.co_buyer;
        var thirdBuyer = this.props.lineItem.third_buyer;

        if (part) {
          this.props.setHazardFields(part);
          this.props.setHeavyPackage(part);
          this.fetchAlternates(part.id);
        }

        this.props.setPartId(id);
        this.props.setSelectedPart(part);
        this.setState({
          selectedCoBuyer: coBuyer,
          selectedThirdBuyer: thirdBuyer
        });
      }

      this.setState({
        selectedReserveForSeller: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(this.props.lineItem, "reserve_for_seller") || this.props.currentUser
      });

      if (this.props.selectedLineItem) {
        var _props$selectedLineIt = this.props.selectedLineItem,
            _part = _props$selectedLineIt.part,
            modTo = _props$selectedLineIt.mod_to,
            co_buyer = _props$selectedLineIt.co_buyer,
            third_buyer = _props$selectedLineIt.third_buyer,
            preferredRepairStation = _props$selectedLineIt.preferred_repair_station,
            reserveForSeller = _props$selectedLineIt.reserve_for_seller;


        this.setState({
          selectedModTo: modTo,
          selectedPart: _part,
          selectedCoBuyer: co_buyer,
          selectedThirdBuyer: third_buyer,
          selectedPreferredRepairStation: preferredRepairStation,
          selectedReserveForSeller: reserveForSeller || this.props.currentUser
        });
        if (exchangeSrpNotAllowed(_part)) {
          this.props.resetExchangeSrpField();
        }
        this.props.setSelectedPart(_part);
        this.fetchAlternates(_part.id);
      }
      var defaultLeadTime = this.props.initialValues.lead_time || 0;

      var initialExpectedDate = this.calculateExpectedDate(defaultLeadTime, this.props.selectedLineItem ? new Date(this.props.selectedLineItem.created_at) : new Date());
      this.props.setExpectedDate(initialExpectedDate);
    }
  }, {
    key: "inventoryLocked",
    value: function inventoryLocked(field) {
      var _EXCHANGE_SRP$QUANTIT;

      var _props = this.props,
          currentUser = _props.currentUser,
          selectedLineItem = _props.selectedLineItem,
          selectedPart = _props.selectedPart;


      if (!selectedLineItem) return false;

      var buyerId = selectedLineItem.buyer.id,
          coBuyerId = selectedLineItem.co_buyer_id,
          thirdBuyerId = selectedLineItem.third_buyer_id;


      var userCanEdit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_19__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_19__users_constants__["m" /* ACCOUNTING */]]) || [buyerId, coBuyerId, thirdBuyerId].includes(currentUser.id);

      var received = selectedLineItem.received || selectedLineItem.quantity_received > 0;

      var defaultPermission = received || !userCanEdit || selectedLineItem.cancelled;
      if (!field || selectedLineItem.cancelled) {
        return defaultPermission;
      }

      return (_EXCHANGE_SRP$QUANTIT = {}, _defineProperty(_EXCHANGE_SRP$QUANTIT, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["u" /* EXCHANGE_SRP */], !(userCanEdit || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_19__users_constants__["k" /* SALES */])) || selectedLineItem.received || exchangeSrpNotAllowed(selectedPart)), _defineProperty(_EXCHANGE_SRP$QUANTIT, __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */], selectedLineItem.cancelled || !userCanEdit), _defineProperty(_EXCHANGE_SRP$QUANTIT, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["v" /* SUGGESTED_RETAIL */], !(userCanEdit || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_19__users_constants__["k" /* SALES */])) || selectedLineItem.received), _defineProperty(_EXCHANGE_SRP$QUANTIT, __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */], selectedLineItem.consignment_type !== __WEBPACK_IMPORTED_MODULE_18__Receiving_constants__["t" /* CONSIGNMENT */] && defaultPermission), _EXCHANGE_SRP$QUANTIT)[field];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          getFieldValue = _props2.getFieldValue,
          buyerCreditPct = _props2.buyerCreditPct,
          currentUser = _props2.currentUser,
          capType = _props2.capType,
          condition = _props2.condition,
          containerFee = _props2.containerFee,
          cost = _props2.cost,
          displaySrpInventoryTable = _props2.displaySrpInventoryTable,
          showExpectedDateField = _props2.showExpectedDateField,
          getInitialFieldValue = _props2.getInitialFieldValue,
          paid = _props2.paid,
          quantity = _props2.quantity,
          searchBuyers = _props2.searchBuyers,
          searchParts = _props2.searchParts,
          searchRepairStations = _props2.searchRepairStations,
          selectedLineItem = _props2.selectedLineItem,
          setFieldValue = _props2.setFieldValue,
          shippingType = _props2.shippingType,
          hazmatFee = _props2.hazmatFee,
          markedHazardous = _props2.markedHazardous,
          purchaseForStock = _props2.purchaseForStock,
          srpCondition = _props2.srpCondition,
          srp = _props2.srp,
          getField = _props2.getField,
          modalMode = _props2.modalMode,
          renderFooter = _props2.renderFooter,
          selectedPart = _props2.selectedPart,
          domLifeYears = _props2.domLifeYears,
          llp = _props2.llp,
          modTo = _props2.modTo,
          dom = _props2.dom;


      var buyerCreditPctOptions = [{ text: "75%", value: "75.0" }, { text: "50%", value: "50.0" }, { text: "25%", value: "25.0" }];
      var cancelled = selectedLineItem && selectedLineItem.cancelled;
      var assignedCoreReturn = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.props.selectedLineItem, __WEBPACK_IMPORTED_MODULE_12__constants__["j" /* ASSIGNED_CORE_RETURN */]);

      var received = selectedLineItem && Number(getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */])) <= Number(selectedLineItem.quantity_received);

      var _state = this.state,
          selectedModTo = _state.selectedModTo,
          selectedCoBuyer = _state.selectedCoBuyer,
          selectedThirdBuyer = _state.selectedThirdBuyer,
          selectedPreferredRepairStation = _state.selectedPreferredRepairStation,
          selectedReserveForSeller = _state.selectedReserveForSeller,
          alternateOptions = _state.alternateOptions;


      var locked = this.inventoryLocked();
      var leadTimeLocked = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_19__users_constants__["p" /* QUALITY_CONTROL */]) ? false : locked;
      var formProps = _extends({}, this.props, {
        editable: !(locked && this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]) && this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["v" /* SUGGESTED_RETAIL */])) || cancelled
      });

      var taggedByHold = getFieldValue(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["w" /* TAGGED_BY_HOLD */]);
      var preferredRepairStationHold = getFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["k" /* PREFERRED_REPAIR_STATION_HOLD */]);

      var showTagDateWarning = purchaseForStock && tagDateIsOlder(getFieldValue(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["x" /* TAG_DATE */]));

      var skipFieldsRequiredForPurchaseFor = getFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["l" /* PURCHASE_FOR_REPAIR_ASSIST */]) || getFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["m" /* PURCHASE_FOR_SALE */]) && Number(getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */])) === Number(getFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["n" /* RESERVE_FOR_SALE_QUANTITY */]));

      var clearPurchaseFor = function clearPurchaseFor(val, fields) {
        if (!val) return null;
        return fields.forEach(function (f) {
          return _this2.props.setFieldValue(f)(false);
        });
      };
      var minOutrightValueForExchangeSettings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_39__hooks_useCurrentUser__["b" /* useSettings */])().min_outright_value_for_exchange_consideration;
      var minOutrightValueForExchangeConsideration = parseFloat(minOutrightValueForExchangeSettings);
      var suggestedRetail = getFieldValue(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["v" /* SUGGESTED_RETAIL */]) || 0;
      var shouldCheckMinValue = minOutrightValueForExchangeSettings !== null && minOutrightValueForExchangeSettings !== undefined;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["e" /* Form */],
        _extends({}, formProps, { modal: modalMode }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["e" /* Form */].Body,
          null,
          purchaseForStock && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(srpCondition) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(condition) && srpCondition !== condition && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__SRPConditionMismatchWarning__["a" /* SRPConditionMismatchWarning */], null),
          exchangeSrpNotAllowed(selectedPart) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExchangeSrpWarning, null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46__shared_TierTypePurchaseWarning__["a" /* default */], {
            part: selectedPart,
            cost: getField(__WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */]),
            quantity: getField(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]),
            initialQuantity: getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */])
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: modalMode ? 8 : 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: "row row-col-gutters-half",
                  style: { marginTop: "26px" }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["q" /* PART_ID */],
                    label: "Part #",
                    placeholder: "Type a part's number...",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["n" /* AutoCompleteField */],
                    search: searchParts,
                    selectedItem: selectedPart,
                    formatItem: function formatItem(result) {
                      return result && result.part_number;
                    },
                    onItemSelected: function onItemSelected(i) {
                      return i && _this2.handlePartSelected(i);
                    },
                    disabled: locked,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["o" /* ALTERNATE_ID */],
                    label: "Buy As Alternate",
                    placeholder: "Type a part's number...",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: alternateOptions,
                    addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-exchange" }),
                    disabled: alternateOptions.length === 0
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                    { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["c" /* EXCHANGE */]) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["d" /* PURCHASE_FOR_EXCHANGE */],
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["c" /* EXCHANGE */]),
                      icon: "fa-check-circle",
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                      disabled: selectedPart && selectedPart.pass_fail || locked,
                      onChange: function onChange(_evt, val) {
                        if (val) {
                          [__WEBPACK_IMPORTED_MODULE_12__constants__["p" /* PURCHASE_FOR_REPAIR */], __WEBPACK_IMPORTED_MODULE_12__constants__["q" /* PURCHASE_FOR_STOCK */], __WEBPACK_IMPORTED_MODULE_12__constants__["l" /* PURCHASE_FOR_REPAIR_ASSIST */]].forEach(function (f) {
                            return setFieldValue(f)(false);
                          });
                          if (Number(getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */])) === 1) {
                            setFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["n" /* RESERVE_FOR_SALE_QUANTITY */])(1);
                          }

                          setFieldValue(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["e" /* CORE_DUE_DAYS */])(30);
                          var days = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__lib_time__["a" /* addDays */])(new Date(), 30);
                          setFieldValue(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["f" /* CORE_RETURN_DATE */])(new Date(days).toISOString().split("T")[0]);
                        }
                      }
                    })
                  )
                ),
                getFieldValue(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["d" /* PURCHASE_FOR_EXCHANGE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                    { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_29__SalesOrders_constants__["e" /* FLAT_EXCHANGE */]) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_29__SalesOrders_constants__["e" /* FLAT_EXCHANGE */],
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_29__SalesOrders_constants__["e" /* FLAT_EXCHANGE */]),
                      icon: "fa-check-circle",
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */]
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["n" /* CONDITION */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: conditionOptions(selectedPart),
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["n" /* CONDITION */]),
                    disabled: locked,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    label: ["QTY", selectedPart && selectedPart.dom_sensitive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__shared_components__["j" /* NoteTooltip */], {
                      color: "rgba(255, 255, 255, 0.25)",
                      icon: "fa-info-circle",
                      placement: "top",
                      note: "PN's labeled DOM sensitive must be purchased one per line item."
                    })],
                    type: "number",
                    disabled: this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]) || selectedPart && selectedPart.dom_sensitive,
                    required: true,
                    onBlur: function onBlur(_ev, qty) {
                      if (Number(qty) !== 1) {
                        setFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["b" /* EXPECTED_SERIAL_NUMBER */])(null);
                      }
                      if (Number(qty) === 1 && getFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["m" /* PURCHASE_FOR_SALE */])) {
                        setFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["n" /* RESERVE_FOR_SALE_QUANTITY */])(1);
                      }
                    },
                    inputProps: {
                      min: 0
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */],
                    label: getFieldValue(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["d" /* PURCHASE_FOR_EXCHANGE */]) ? "Outright Price" : "Cost/Unit",
                    disabled: this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */]) && this.props.currentUser.role !== "admin" || paid,
                    required: true
                  })
                ),
                getFieldValue(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["d" /* PURCHASE_FOR_EXCHANGE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_27__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */],
                    label: getFieldValue(__WEBPACK_IMPORTED_MODULE_29__SalesOrders_constants__["e" /* FLAT_EXCHANGE */]) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_29__SalesOrders_constants__["f" /* FLAT_EXCHANGE_FEE */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_27__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */]),
                    disabled: selectedPart && selectedPart.pass_fail || locked,
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["y" /* EXPIRATION */],
                    label: "Expiration Date",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    type: "date",
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: "warranty_period",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__constants__["r" /* WARRANTY_PERIOD */]),
                    label: "Warranty Period",
                    disabled: locked && received
                  })
                ),
                getFieldValue(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["d" /* PURCHASE_FOR_EXCHANGE */]) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["e" /* CORE_DUE_DAYS */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["e" /* CORE_DUE_DAYS */]),
                    onChange: function onChange(_evt, val) {
                      if (val) {
                        var days = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__lib_time__["a" /* addDays */])(new Date(), Number(val));
                        setFieldValue(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["f" /* CORE_RETURN_DATE */])(new Date(days).toISOString().split("T")[0]);
                      }
                    },
                    required: true
                  })
                ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["s" /* CORE_DUE_DATE */]),
                    name: __WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["f" /* CORE_RETURN_DATE */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    type: "date",
                    required: true
                  })
                ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    label: "Avg Repair (NTX)",
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["t" /* CORE_REPAIR_FEE_NOT_TO_EXCEED */],
                    required: getFieldValue(__WEBPACK_IMPORTED_MODULE_29__SalesOrders_constants__["e" /* FLAT_EXCHANGE */])
                  })
                )]
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 5 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "label",
                      { htmlFor: "warnings", className: "control-label" },
                      "Line Hazmat"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Fields"], {
                      names: [__WEBPACK_IMPORTED_MODULE_13__parts_constants__["h" /* HAZMAT */], __WEBPACK_IMPORTED_MODULE_13__parts_constants__["i" /* BIO_HAZMAT */]],
                      component: LineHazmatFields,
                      disabled: locked
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "label",
                      { htmlFor: __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["c" /* AS_IS */], className: "control-label" },
                      "As Is"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Fields"], {
                      names: [__WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["c" /* AS_IS */], __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_12__constants__["u" /* EVALUATION_PERIOD */], __WEBPACK_IMPORTED_MODULE_12__constants__["q" /* PURCHASE_FOR_STOCK */]],
                      component: AsIsField,
                      disabled: locked
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                    { title: "Heavy Package / DIM WT", justified: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_12__constants__["v" /* DIM_WEIGHT */],
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                      label: "Hvy Pkg / DIM",
                      icon: "fa-check-circle",
                      disabled: locked
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                    { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["a" /* INCIDENT */]), justified: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_12__constants__["a" /* INCIDENT */],
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["a" /* INCIDENT */]),
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                      icon: "fa-check-circle",
                      disabled: locked
                    })
                  )
                )
              ),
              selectedModTo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_42__shared_components_Warning_Warning__["a" /* default */],
                null,
                "SRP Info will be applied to PN ",
                selectedModTo.part_number
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                    { title: "Do Not Exchange", justified: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_23__companies_constants__["k" /* DO_NOT_EXCHANGE */],
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_23__companies_constants__["k" /* DO_NOT_EXCHANGE */]),
                      disabled: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__users_helpers__["e" /* hasPermission */])(currentUser, __WEBPACK_IMPORTED_MODULE_19__users_constants__["A" /* CAN_EDIT_DO_NOT_EXCHANGE */]),
                      onChange: function onChange(_ev, val) {
                        if (val) setFieldValue(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["u" /* EXCHANGE_SRP */])("");
                      },
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */]
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                    { title: "Do Not Sell!", justified: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["z" /* UNSELLABLE_PER_USER */],
                      component: function component(props) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */], _extends({}, props, { icon: "fa-diamond" }));
                      },
                      label: "Do Not Sell!"
                    })
                  )
                ),
                getFieldValue(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["z" /* UNSELLABLE_PER_USER */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["A" /* DO_NOT_SELL_REASON */],
                    label: "Reason for Do Not Sell?",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["B" /* DO_NOT_SELL_REASON_OPTIONS */],
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__DomLifeWarning__["a" /* default */], {
                part: selectedPart,
                domFromLineItem: getField(__WEBPACK_IMPORTED_MODULE_13__parts_constants__["G" /* DOM */])
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__shared_PreviousSrpConditionWarning__["a" /* PreviousSrpConditionWarning */], {
                displayInventory: displaySrpInventoryTable,
                srpCondition: srpCondition,
                srp: srp,
                partId: selectedPart.id
              }),
              showTagDateWarning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SixMonthsOldTagDateWarning, null),
              taggedByHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnauthorizedRepairStationSelectedWarning, null),
              Number(quantity) > 1 && getFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["m" /* PURCHASE_FOR_SALE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PurchaseForSaleQuantityWarning, null),
              selectedPart.dom_sensitive && __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(dom) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DOMIsRequiredWarning, null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared__["a" /* PurchaseForFields */], {
                clearPurchaseFor: clearPurchaseFor,
                formName: formName,
                getFieldValue: getFieldValue,
                selectedReserveForSeller: selectedReserveForSeller,
                searchBuyers: searchBuyers,
                setFieldValue: setFieldValue,
                shippingType: shippingType,
                disabled: locked,
                qtyDisabled: this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]),
                condition: condition,
                onPurchaseForStockChange: this.resetPreferredRepairStation,
                onPurchaseForSaleChange: function onPurchaseForSaleChange(val) {
                  if (val && Number(getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */])) === 1) {
                    setFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["n" /* RESERVE_FOR_SALE_QUANTITY */])(1);
                  }
                  if (!val) setFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["n" /* RESERVE_FOR_SALE_QUANTITY */])("");
                },
                onPurchaseForRepair: function onPurchaseForRepair(v) {
                  if (v && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(_this2.props.purchaseOrder, __WEBPACK_IMPORTED_MODULE_6__constants__["o" /* SHIPPING_TYPE */]) === __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* COMPANY */]) {
                    _this2.setState({
                      selectedPreferredRepairStation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(_this2.props.purchaseOrder, "ship_to_company")
                    });
                    setFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["w" /* PREFERRED_REPAIR_STATION_ID */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(_this2.props.purchaseOrder, "ship_to_company_id"));
                  }
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__shared_TierTypeExchangeSrpWarning__["a" /* default */], {
                part: selectedPart,
                exchangeSrp: getFieldValue(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["u" /* EXCHANGE_SRP */]),
                srp: getFieldValue(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["v" /* SUGGESTED_RETAIL */])
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["C" /* SRP_CONDITION */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: conditionOptions(selectedPart),
                    label: "SRP Condition",
                    disabled: locked,
                    required: !skipFieldsRequiredForPurchaseFor
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["v" /* SUGGESTED_RETAIL */],
                    label: "SRP",
                    disabled: this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["v" /* SUGGESTED_RETAIL */]),
                    required: !skipFieldsRequiredForPurchaseFor
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["u" /* EXCHANGE_SRP */],
                    label: getFieldValue(__WEBPACK_IMPORTED_MODULE_29__SalesOrders_constants__["e" /* FLAT_EXCHANGE */]) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["D" /* FLAT_EXCHANGE_SRP */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["u" /* EXCHANGE_SRP */]),
                    disabled: this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["u" /* EXCHANGE_SRP */]) || exchangeSrpNotAllowed(selectedPart) || getFieldValue(__WEBPACK_IMPORTED_MODULE_23__companies_constants__["k" /* DO_NOT_EXCHANGE */]),
                    required: (!shouldCheckMinValue || suggestedRetail >= minOutrightValueForExchangeConsideration) && exchangeSrpValidated(selectedLineItem) && !exchangeSrpNotAllowed(selectedPart) && ![__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["g" /* NEW_ITEM */], __WEBPACK_IMPORTED_MODULE_12__constants__["i" /* AS_REMOVED */]].includes(getFieldValue(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["n" /* CONDITION */])) && !getFieldValue(__WEBPACK_IMPORTED_MODULE_23__companies_constants__["k" /* DO_NOT_EXCHANGE */]) && !skipFieldsRequiredForPurchaseFor && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(selectedPart, __WEBPACK_IMPORTED_MODULE_13__parts_constants__["H" /* TOOLING_PART_TYPE */])
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["r" /* MonthYearField */], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["x" /* TAG_DATE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["x" /* TAG_DATE */]),
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    required: __WEBPACK_IMPORTED_MODULE_18__Receiving_constants__["u" /* TAG_DATE_CONDITIONS */].includes(condition),
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["p" /* TAGGED_BY */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["p" /* TAGGED_BY */]),
                    placeholder: "Search by a company's name",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["s" /* AutoCompleteUserInputField */],
                    required: __WEBPACK_IMPORTED_MODULE_18__Receiving_constants__["u" /* TAG_DATE_CONDITIONS */].includes(condition),
                    search: this.searchCompanies,
                    selectedItem: selectedLineItem && selectedLineItem.tagged_by,
                    handleTaggedBy: function handleTaggedBy(result) {
                      return _this2.handleTaggedBy(result);
                    },
                    formatItem: function formatItem(result) {
                      return ((typeof result === "undefined" ? "undefined" : _typeof(result)) === "object" ? result.name : result) || "";
                    },
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__Locations_components_ToolsUsedDropDown__["a" /* default */], {
                    disabled: locked,
                    selectedLineItem: selectedLineItem,
                    notRequired: getFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["l" /* PURCHASE_FOR_REPAIR_ASSIST */])
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["r" /* MonthYearField */], {
                    name: "dom",
                    label: "DOM",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    required: domLifeYears && llp || selectedPart.dom_sensitive,
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["E" /* TRACE_TYPE */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes),
                    label: "Expected Trace Type",
                    disabled: locked && received,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["F" /* TRACED_TO */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    label: "Expected Trace To",
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  !showExpectedDateField && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["G" /* LEAD_TIME */],
                    label: "Lead Time (Days)",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    disabled: leadTimeLocked,
                    required: true
                  }),
                  showExpectedDateField && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: "expected_date",
                    label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                      null,
                      "Expected Date",
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], {
                        obj: selectedLineItem,
                        field: "lead_time",
                        includeTime: true
                      })
                    ),
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    onChange: function onChange(e, val) {
                      return _this2.handleDateChange(val);
                    },
                    type: "date"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["d" /* PURCHASE_STATUS */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["e" /* PURCHASE_STATUS_OPTIONS */],
                    label: __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["f" /* PURCHASE_STATUS_LABEL */],
                    required: !getFieldValue(__WEBPACK_IMPORTED_MODULE_18__Receiving_constants__["t" /* CONSIGNMENT */])
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["b" /* EXPECTED_SERIAL_NUMBER */],
                    label: "Expected Serial #",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    disabled: received || Number(quantity) !== 1
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                    { justified: true, title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["h" /* MOD_TO */]) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["h" /* MOD_TO */],
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["h" /* MOD_TO */]),
                      icon: "fa-check-circle",
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                      disabled: locked || !getFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["p" /* PURCHASE_FOR_REPAIR */])
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
                  { "in": modTo || false, unmountOnExit: true },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                    { md: 4 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["i" /* MOD_TO_ID */],
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["h" /* MOD_TO */]),
                      placeholder: "Type a part's number...",
                      selectedItem: selectedModTo,
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["n" /* AutoCompleteField */],
                      onItemSelected: function onItemSelected(item) {
                        return item && _this2.setState({ selectedModTo: item });
                      },
                      search: searchParts,
                      formatItem: function formatItem(result) {
                        return result && result.part_number;
                      },
                      disabled: locked
                    })
                  )
                )
              ),
              selectedPart && selectedPart.llp && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_13__parts_constants__["E" /* TOTAL_HOURS */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__parts_constants__["E" /* TOTAL_HOURS */]),
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["h" /* NumberInput */],
                    roundDigits: 0,
                    onChange: function onChange(_e, val) {
                      return _this2.props.change(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["s" /* TOTAL_HOURS_REMAINING */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__inventories_helpers__["a" /* totalHoursRemaining */])(selectedPart, val));
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_13__parts_constants__["F" /* TOTAL_CYCLES */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__parts_constants__["F" /* TOTAL_CYCLES */]),
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["h" /* NumberInput */],
                    roundDigits: 0,
                    onChange: function onChange(_e, val) {
                      return _this2.props.change(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["t" /* TOTAL_CYCLES_REMAINING */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__inventories_helpers__["b" /* totalCyclesRemaining */])(selectedPart, val));
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["s" /* TOTAL_HOURS_REMAINING */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["s" /* TOTAL_HOURS_REMAINING */]),
                    disabled: true,
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["h" /* NumberInput */],
                    roundDigits: 0
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["t" /* TOTAL_CYCLES_REMAINING */],
                    disabled: true,
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["t" /* TOTAL_CYCLES_REMAINING */]),
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["h" /* NumberInput */],
                    roundDigits: 0
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 12 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Fields"], {
                    component: __WEBPACK_IMPORTED_MODULE_36__inventories_components_EditInventory_TagTypes__["a" /* default */],
                    names: [__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["L" /* UK_CAA */], __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["M" /* OTHER */], __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["N" /* OTHER_TAG_TYPE */]],
                    formName: formName,
                    disabled: locked
                  })
                )
              ),
              this.props.showBuyers && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  null,
                  "Buyers"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                    { md: 5 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: "read_only_buyer",
                      label: "Buyer",
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                      disabled: true,
                      required: true
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                    { md: 3 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_6__constants__["G" /* BUYER_CREDIT_PCT */],
                      className: "text-right",
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                      options: buyerCreditPctOptions,
                      prompt: false,
                      label: "Buyer Credit",
                      disabled: locked,
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared__["b" /* CoBuyersFields */], {
                    toggleBuyer: this.toggleBuyer,
                    buyerCreditPct: buyerCreditPct,
                    selectedCoBuyer: selectedCoBuyer,
                    selectedThirdBuyer: selectedThirdBuyer,
                    numberOfBuyers: [getFieldValue(__WEBPACK_IMPORTED_MODULE_19__users_constants__["z" /* CO_BUYER_ID */]), getFieldValue(__WEBPACK_IMPORTED_MODULE_19__users_constants__["y" /* THIRD_BUYER_ID */])].filter(function (s) {
                      return s;
                    }).length + 1,
                    searchBuyers: searchBuyers,
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Orders_shared_InvoiceSection__["a" /* default */], {
                hidden: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_19__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_19__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_19__users_constants__["l" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_19__users_constants__["k" /* SALES */]]),
                disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_19__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_19__users_constants__["l" /* REPAIR */]]),
                orderType: __WEBPACK_IMPORTED_MODULE_12__constants__["x" /* PURCHASE_ORDER */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null),
              preferredRepairStationHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnauthorizedPreferredRepairStationSelectedWarning, null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Shipping & Repairs"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                selectedLineItem && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["W" /* AWB_NUMBER */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    label: "AWB #",
                    disabled: received
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["y" /* CONTAINER_FEE */],
                    label: "Container/Crate Fee",
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["z" /* HAZMAT_FEE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["z" /* HAZMAT_FEE */]),
                    disabled: locked,
                    required: markedHazardous
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["w" /* PREFERRED_REPAIR_STATION_ID */],
                    label: "Suggested Repair Station",
                    placeholder: "Type a vendor's name or code...",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["n" /* AutoCompleteField */],
                    search: searchRepairStations,
                    selectedItem: selectedPreferredRepairStation,
                    formatItem: function formatItem(result) {
                      return result && result.name;
                    },
                    disabled: locked || purchaseForStock,
                    watch: purchaseForStock ? selectedPreferredRepairStation : undefined,
                    required: this.repairStationRequired,
                    onItemSelected: this.handlePreferredRepairStation
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["u" /* EVALUATION_PERIOD */],
                    type: "number",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    disabled: locked,
                    label: "Eval. Period"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["A" /* CAP_TYPE */],
                    className: "text-right",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__constants__["B" /* CAP_TYPES */]),
                    label: "Repair/Overhaul Cap"
                  })
                ),
                capType && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["C" /* CAP_AMOUNT */],
                    label: __WEBPACK_IMPORTED_MODULE_12__constants__["B" /* CAP_TYPES */][capType].label + " Cap Amount",
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 12 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Fields"], {
                    names: [__WEBPACK_IMPORTED_MODULE_12__constants__["D" /* AMOUNT_INSURED */], __WEBPACK_IMPORTED_MODULE_12__constants__["E" /* PERCENT_INSURED */], __WEBPACK_IMPORTED_MODULE_12__constants__["F" /* INSURANCE_TYPE */]],
                    component: InsuranceTypeField,
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Fields"], {
                  names: [__WEBPACK_IMPORTED_MODULE_12__constants__["D" /* AMOUNT_INSURED */], __WEBPACK_IMPORTED_MODULE_12__constants__["E" /* PERCENT_INSURED */], __WEBPACK_IMPORTED_MODULE_12__constants__["F" /* INSURANCE_TYPE */], __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */], __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]],
                  component: InsuranceFields,
                  disabled: locked
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Notes"
              ),
              getFieldValue(__WEBPACK_IMPORTED_MODULE_23__companies_constants__["k" /* DO_NOT_EXCHANGE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_42__shared_components_Warning_Warning__["a" /* default */],
                null,
                "Must have a valid reason for Do Not Exchange to continue."
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["G" /* INTERNAL_NOTE */],
                    required: getFieldValue(__WEBPACK_IMPORTED_MODULE_23__companies_constants__["k" /* DO_NOT_EXCHANGE */]),
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["G" /* INTERNAL_NOTE */]),
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["l" /* TextArea */],
                    rows: 5,
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["c" /* EXTERNAL_NOTE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["c" /* EXTERNAL_NOTE */]),
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["l" /* TextArea */],
                    rows: 5,
                    disabled: locked
                  })
                )
              ),
              cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["H" /* CANCELLATION_REASON */],
                    className: "text-right",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: __WEBPACK_IMPORTED_MODULE_12__constants__["I" /* CANCELLATION_REASONS */],
                    prompt: false,
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["H" /* CANCELLATION_REASON */])
                  })
                )
              )
            ),
            modalMode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__PartSummary__["a" /* default */], {
                part: selectedPart,
                cost: cost,
                quantity: quantity,
                lineItem: this.props.selectedLineItem,
                hazmatFee: hazmatFee,
                containerFee: containerFee
              }),
              assignedCoreReturn && this.props.selectedLineItem.core_return_date && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "well" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h6",
                  { className: "h4" },
                  "Core Return Details"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-condensed table-padding-horizonal-none margin-bottom-none" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tbody",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tr",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        "Core Return Date"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        { className: "text-right" },
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__lib_formatters_date__["b" /* shortDate */])(this.props.selectedLineItem.core_return_date)
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tr",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        "Core Return Serial #"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        { className: "text-right" },
                        assignedCoreReturn.serial_number
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tr",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        "Core Return Condition"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        { className: "text-right" },
                        __WEBPACK_IMPORTED_MODULE_35__Shipping_constants__["k" /* CONDITIONS */][assignedCoreReturn.condition].label
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        renderFooter && renderFooter(formProps)
      );
    }
  }, {
    key: "repairStationRequired",
    get: function get() {
      var _props3 = this.props,
          purchaseForRepair = _props3.purchaseForRepair,
          condition = _props3.condition,
          getField = _props3.getField;


      return purchaseForRepair || condition === __WEBPACK_IMPORTED_MODULE_12__constants__["i" /* AS_REMOVED */] && !getField(__WEBPACK_IMPORTED_MODULE_12__constants__["m" /* PURCHASE_FOR_SALE */]) && !getField(__WEBPACK_IMPORTED_MODULE_12__constants__["q" /* PURCHASE_FOR_STOCK */]);
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setTaggedById: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setTaggedByHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  showBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cap_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    co_buyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    third_buyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    part_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  renderFooter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  resetAlternatePartField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetExchangeSrpField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchAlternates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchParts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchRepairStations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setExpectedDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setLeadTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setHeavyPackage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setHazardFields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setPartId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  domLifeYears: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  llp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectedPart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  setSelectedPart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setPreferredRepairStationHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetPreferredRepairStation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
Form.defaultProps = {
  modalMode: true,
  showBuyers: true
};
var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    getFieldValue: function getFieldValue(field) {
      return selector(state, field);
    },
    getInitialFieldValue: function getInitialFieldValue(field) {
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["getFormInitialValues"])(formName)(state), field);
    },
    buyerCreditPct: selector(state, __WEBPACK_IMPORTED_MODULE_6__constants__["G" /* BUYER_CREDIT_PCT */]),
    capType: selector(state, __WEBPACK_IMPORTED_MODULE_12__constants__["A" /* CAP_TYPE */]),
    cost: selector(state, __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */]),
    quantity: selector(state, __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]),
    condition: selector(state, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["n" /* CONDITION */]),
    srpCondition: selector(state, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["C" /* SRP_CONDITION */]),
    srp: selector(state, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["v" /* SUGGESTED_RETAIL */]),
    minExchangeSrp: state.session.getIn([__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_6__constants__["X" /* MINIMUM_EXCHANGE_SRP */]]),
    exchangeSRP: selector(state, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["u" /* EXCHANGE_SRP */]),
    asIs: selector(state, __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["c" /* AS_IS */]),
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_19__users_constants__["a" /* USER */]).toJS(),
    purchaseOrder: state.purchaseOrderDetail.get("purchaseOrder").toJS(),
    hazmatFee: selector(state, __WEBPACK_IMPORTED_MODULE_12__constants__["z" /* HAZMAT_FEE */]),
    containerFee: selector(state, __WEBPACK_IMPORTED_MODULE_12__constants__["y" /* CONTAINER_FEE */]),
    markedHazardous: selector(state, __WEBPACK_IMPORTED_MODULE_13__parts_constants__["h" /* HAZMAT */]),
    modTo: selector(state, __WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["h" /* MOD_TO */]),
    purchaseForStock: selector(state, __WEBPACK_IMPORTED_MODULE_12__constants__["q" /* PURCHASE_FOR_STOCK */]),
    purchaseForRepair: selector(state, __WEBPACK_IMPORTED_MODULE_12__constants__["p" /* PURCHASE_FOR_REPAIR */]),
    dom: selector(state, __WEBPACK_IMPORTED_MODULE_13__parts_constants__["G" /* DOM */]),
    getField: function getField(field) {
      return selector(state, field);
    }
  };
}, function (dispatch) {
  return {
    resetAlternatePartField: function resetAlternatePartField() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_12__constants__["o" /* ALTERNATE_ID */], null));
    },
    resetExchangeSrpField: function resetExchangeSrpField() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["u" /* EXCHANGE_SRP */], null));
    },
    changeExchangeSrpField: function changeExchangeSrpField(value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["u" /* EXCHANGE_SRP */], value));
    },
    setPartId: function setPartId(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["q" /* PART_ID */], id));
    },
    setHazardFields: function setHazardFields(part) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_13__parts_constants__["i" /* BIO_HAZMAT */], part.bio_hazmat));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_13__parts_constants__["h" /* HAZMAT */], part.hazmat));
    },
    setHeavyPackage: function setHeavyPackage(part) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_12__constants__["v" /* DIM_WEIGHT */], part.dim_weight));
    },
    searchAlternates: function searchAlternates(partId) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_15__actions__["e" /* searchAlternates */](partId));
    },
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_15__actions__["c" /* searchBuyers */](filter));
    },
    searchParts: function searchParts(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_16__parts_actions__["a" /* searchPoParts */](filter));
    },
    searchRepairStations: function searchRepairStations(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_15__actions__["f" /* searchRepairStations */](filter));
    },
    resetForm: function resetForm(id) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["replace"])("/purchase-orders/" + id));
    },
    setExpectedDate: function setExpectedDate(date) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, "expected_date", date));
    },
    setLeadTime: function setLeadTime(leadTime) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["G" /* LEAD_TIME */], leadTime));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, field, val));
      };
    },
    setTaggedById: function setTaggedById(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["O" /* TAGGED_BY_ID */], id));
    },
    setTaggedByHold: function setTaggedByHold(hold) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["w" /* TAGGED_BY_HOLD */], hold));
    },
    setPreferredRepairStationHold: function setPreferredRepairStationHold(hold) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, "preferred_repair_station_hold", hold));
    },
    resetPreferredRepairStation: function resetPreferredRepairStation() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, "preferred_repair_station_id", ""));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_41__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = StatusTags;



function StatusTags(_ref) {
  var hold = _ref.hold,
      discrepancies = _ref.discrepancies,
      underReview = _ref.underReview;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    hold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "label label-danger", style: { marginRight: 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-pause" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        "On Hold"
      )
    ),
    underReview && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "label label-warning", style: { marginRight: 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-pause" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        "Under Review"
      )
    ),
    discrepancies && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "label label-danger" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-warning" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        "Disc. Reported"
      )
    )
  );
}

StatusTags.propTypes = {
  hold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  discrepancies: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  underReview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* unused harmony export Badge */
/* harmony export (immutable) */ __webpack_exports__["a"] = StatusBadge;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var Badge = function Badge(_ref) {
  var abbrev = _ref.abbrev,
      text = _ref.text,
      icon = _ref.icon,
      label = _ref.label,
      shouldAbbrev = _ref.shouldAbbrev;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: text },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: icon }),
    shouldAbbrev && abbrev ? abbrev : label
  );
};

Badge.propTypes = {
  abbrev: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  shouldAbbrev: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var EvaluationStatusBadge = function EvaluationStatusBadge(_ref2) {
  var lineItem = _ref2.lineItem,
      shouldAbbrev = _ref2.shouldAbbrev;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Badge, _extends({
    shouldAbbrev: shouldAbbrev
  }, __WEBPACK_IMPORTED_MODULE_3__constants__["q" /* EVAL_STATUS_BADGE_CONTENT */][lineItem.approval_status]));
};

EvaluationStatusBadge.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  shouldAbbrev: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function StatusBadge(_ref3) {
  var _ref3$lineItem = _ref3.lineItem,
      lineItem = _ref3$lineItem === undefined ? {} : _ref3$lineItem,
      _ref3$shouldAbbrev = _ref3.shouldAbbrev,
      shouldAbbrev = _ref3$shouldAbbrev === undefined ? false : _ref3$shouldAbbrev;

  if (lineItem.action_requested === __WEBPACK_IMPORTED_MODULE_3__constants__["r" /* SHOP_ASSIST */]) {
    return null;
  } else if (lineItem.scrap_report) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Badge, { text: "text-danger", icon: "fa fa-fw fa-trash", label: "Scrapped" });
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "inventory.repair_status") === __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_47" /* CORE_RETURNED_TO_CUSTOMER */]) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Badge, {
      text: "text-danger",
      icon: "fa fa-fw fa-undo",
      label: "Core Returned To Customer"
    });
  } else if ([__WEBPACK_IMPORTED_MODULE_5__shared_components_ShippingSection_shippingTypes__["a" /* TENANT_LOCATION */]].includes(lineItem.return_to_type) && lineItem.received && (lineItem.exchange_gone_outright || lineItem.internal_outright)) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Badge, {
      text: "text-danger",
      icon: "fa fa-fw fa-undo",
      label: "Core Returned From Shop"
    });
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EvaluationStatusBadge, { lineItem: lineItem, shouldAbbrev: shouldAbbrev });
}

StatusBadge.propTypes = {
  shouldAbbrev: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_countries__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_regions__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_states__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AddressFields; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var countryOptions = __WEBPACK_IMPORTED_MODULE_6__lib_countries__["a" /* default */].map(function (c) {
  return { value: c.code, text: c.name };
});
var regionOptions = __WEBPACK_IMPORTED_MODULE_7__lib_regions__["a" /* default */].map(function (c) {
  return { value: c.name, text: c.name };
});

var renderStateField = function renderStateField(country, path, stateProvinceRequired, disabled) {
  return country === "US" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
    name: path + ".state",
    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
    options: __WEBPACK_IMPORTED_MODULE_8__lib_states__["a" /* states */],
    label: "State/Province",
    required: stateProvinceRequired,
    disabled: disabled
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
    name: path + ".state",
    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
    label: "State/Province",
    required: stateProvinceRequired,
    disabled: disabled
  });
};

var AddressFields = function (_React$Component) {
  _inherits(AddressFields, _React$Component);

  function AddressFields() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddressFields);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddressFields.__proto__ || Object.getPrototypeOf(AddressFields)).call.apply(_ref, [this].concat(args))), _this), _this.onChangeCountry = function (_, country) {
      var _this$props = _this.props,
          path = _this$props.path,
          setFieldValue = _this$props.setFieldValue,
          showRegion = _this$props.showRegion;


      if (country && setFieldValue && showRegion) {
        setFieldValue([path, __WEBPACK_IMPORTED_MODULE_9__constants__["Q" /* REGION */]].filter(function (f) {
          return f;
        }).join("."), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6__lib_countries__["a" /* default */].find(function (c) {
          return c.code === country;
        }), __WEBPACK_IMPORTED_MODULE_9__constants__["Q" /* REGION */]));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddressFields, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.resetState && this.props.country && this.props.resetStateField && nextProps.country !== this.props.country) {
        this.props.resetStateField();
      }
      if (this.props.setFOB && (nextProps.city !== this.props.city || nextProps.province !== this.props.province || nextProps.country !== this.props.country)) {
        this.props.setFOB([nextProps.city, nextProps.province, nextProps.country].join("-"));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          path = _props.path,
          country = _props.country,
          addCompanyName = _props.addCompanyName,
          _props$showCareOf = _props.showCareOf,
          showCareOf = _props$showCareOf === undefined ? true : _props$showCareOf,
          showRegion = _props.showRegion,
          _props$stateProvinceR = _props.stateProvinceRequired,
          stateProvinceRequired = _props$stateProvinceR === undefined ? false : _props$stateProvinceR,
          disabled = _props.disabled;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        addCompanyName && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "col-md-12" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: path + ".company_name",
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              label: "Company Name",
              disabled: disabled
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "col-md-6" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_9__constants__["r" /* COUNTRY */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
              label: "Country",
              options: countryOptions,
              disabled: disabled,
              onChange: this.onChangeCountry,
              required: true
            })
          ),
          showRegion && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "col-md-6" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_9__constants__["Q" /* REGION */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
              label: "Region",
              options: regionOptions,
              disabled: disabled
            })
          )
        ),
        showCareOf && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "col-md-6" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: path + ".care_of",
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              label: "C/O",
              disabled: disabled
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "col-md-6" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_9__constants__["s" /* LINE1 */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              label: "Address Line 1",
              disabled: disabled,
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "col-md-6" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_9__constants__["t" /* LINE2 */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              label: "Address Line 2",
              disabled: disabled
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "col-md-5" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_9__constants__["u" /* CITY */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              label: "City",
              disabled: disabled,
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "col-md-4" },
            renderStateField(country, path, stateProvinceRequired, disabled)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "col-md-3" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_9__constants__["w" /* POSTAL_CODE */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              label: "Zip/Postal Code",
              disabled: disabled,
              required: true
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "col-md-5" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_9__constants__["R" /* PHONE */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              label: "phone"
            })
          )
        )
      );
    }
  }]);

  return AddressFields;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    resetStateField: function resetStateField() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["change"])(ownProps.formName, ownProps.path + ".state", ""));
    },
    setFieldValue: function setFieldValue(field, value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["change"])(ownProps.formName, field, value));
    }
  };
})(AddressFields));

AddressFields.propTypes = {
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  country: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  showRegion: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  resetState: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  province: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  city: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  addCompanyName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  resetStateField: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  setFOB: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  showCareOf: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  stateProvinceRequired: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* unused harmony export getLineItemAndCost */
/* unused harmony export costWarningText */
/* harmony export (immutable) */ __webpack_exports__["c"] = CostWarning;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RepairAndHold; });
/* harmony export (immutable) */ __webpack_exports__["b"] = Warnings;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function getLineItemAndCost(inventory) {
  var lineItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(inventory, "repair_order_line_items[0]");
  if (!lineItem) return [null, null];
  if (lineItem.exchange) return [null, null];
  var totalCost = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(parseFloat(lineItem.labor_cost || 0) + parseFloat(lineItem.outside_labor_cost || 0) + parseFloat(lineItem.part_cost || 0));

  return [lineItem, totalCost];
}

var costWarningText = function costWarningText(cost) {
  return "Warning: Cost does not yet reflect repair expense. Estimated Total Repair Cost: " + cost + ".";
};

function CostWarning(_ref) {
  var inventory = _ref.inventory;

  var _getLineItemAndCost = getLineItemAndCost(inventory),
      _getLineItemAndCost2 = _slicedToArray(_getLineItemAndCost, 2),
      lineItem = _getLineItemAndCost2[0],
      totalCost = _getLineItemAndCost2[1];

  if (!lineItem) return null;

  var showWarning = lineItem.approval_status === __WEBPACK_IMPORTED_MODULE_5__constants__["Q" /* REPAIR_EVALUATION_APPROVED */] && !lineItem.exchange && lineItem.original_evaluation && !lineItem.final_evaluation_approved;

  return showWarning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-condensed" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Warning_Warning__["a" /* default */],
          null,
          costWarningText(totalCost)
        )
      )
    )
  );
}

CostWarning.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    repair_order_line_item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      labor_cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
      outside_labor_cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
      part_cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
    }).isRequired
  }).isRequired
};

var RepairAndHold = function RepairAndHold(_ref2) {
  var inventory = _ref2.inventory,
      _ref2$label = _ref2.label,
      label = _ref2$label === undefined ? "Repair & Hold" : _ref2$label;

  if (__WEBPACK_IMPORTED_MODULE_5__constants__["k" /* REPAIR_AND_HOLD */] !== inventory.repair_status) {
    return null;
  }

  var RepairAndHoldBadge = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label label-warning" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-wrench" }),
    "\xA0\xA0",
    label
  );

  var _getLineItemAndCost3 = getLineItemAndCost(inventory),
      _getLineItemAndCost4 = _slicedToArray(_getLineItemAndCost3, 2),
      lineItem = _getLineItemAndCost4[0],
      totalCost = _getLineItemAndCost4[1];

  if (!lineItem) {
    return RepairAndHoldBadge;
  }

  var tooltip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["b" /* Tooltip */],
    { id: inventory.id },
    costWarningText(totalCost)
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["a" /* OverlayTrigger */],
    { placement: "right", overlay: tooltip, animation: true },
    RepairAndHoldBadge
  );
};

RepairAndHold.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

function Warnings(_ref3) {
  var inventory = _ref3.inventory;

  var hasCreditIssued = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(inventory, "most_recent_customer_rma.credit_issued");

  var hasCreditDenied = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(inventory, "most_recent_customer_rma.credit_denied");

  var hasWarrantyConsideration = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(inventory, "most_recent_customer_rma.warranty_consideration");

  var hasCreditRequested = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(inventory, "most_recent_customer_rma.credit_requested");

  var hasWarrantyStatus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(inventory, "most_recent_customer_rma.warranty_status");

  var activeRma = (hasCreditRequested || hasWarrantyConsideration) && !hasCreditDenied && !hasCreditIssued && !hasWarrantyStatus;

  var discrepancies = !inventory.discrepancies_resolved && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label label-danger" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-warning" }),
    "\xA0\xA0Disc. Reported"
  );

  var customerRMA = activeRma && inventory.status !== __WEBPACK_IMPORTED_MODULE_5__constants__["R" /* CUSTOMER_RMA_REQUESTED */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label label-danger" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cog" }),
    "\xA0\xA0Cust. RMA"
  );

  var qcHold = inventory.qc_status === __WEBPACK_IMPORTED_MODULE_5__constants__["S" /* QC_HOLD */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label label-danger" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-pause" }),
    "\xA0\xA0QC Hold"
  );

  var rmaRequested = inventory.status === __WEBPACK_IMPORTED_MODULE_5__constants__["R" /* CUSTOMER_RMA_REQUESTED */] && !hasCreditIssued && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label label-danger" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cog" }),
    "\xA0\xA0Cust. RMA Requested"
  );

  var underReview = inventory.qc_status === __WEBPACK_IMPORTED_MODULE_5__constants__["T" /* UNDER_REVIEW */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label label-warning" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-pause" }),
    "\xA0\xA0Under Review"
  );

  var inTransfer = inventory.active_transfer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label label-warning" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-plane" }),
    "\xA0\xA0In Transfer"
  );

  var doNotExchange = (inventory.do_not_exchange || inventory.part && inventory.part.pass_fail || inventory.do_not_exchange_due_to_outright_value) && inventory.condition !== "as_removed" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label label-danger" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-times-circle-o" }),
    "\xA0\xA0DO NOT EXCHANGE"
  );

  var doNotSell = inventory.unsellable_per_user && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label label-warning" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-diamond" }),
    "\xA0\xA0DO NOT SELL!"
  );

  var reclaimed = inventory.reclaimed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label label-warning" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-superpowers" }),
    "\xA0\xA0RECLAIMED"
  );

  var outright = inventory.exchange_gone_outright && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label label-warning" },
    "\xA0EXCHANGE GONE OUTRIGHT"
  );

  var consignment = (inventory.consignment_type || inventory.consigned_date) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["p" /* StatusTag */], {
    key: "consignment",
    display: "warning",
    title: inventory.consignment_type ? inventory.consignment_type.toUpperCase() : "CONSIGNMENT",
    icon: "location-arrow"
  });

  var coreReturn = inventory.returned_core_for_exchange_id && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label label-success", style: { marginRight: "10px" } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-reply" }),
    "\xA0\xA0Core Return"
  );

  var consignmentCancelled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(inventory, "consignment_details.cancelled") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["p" /* StatusTag */], { icon: "ban", title: "Consignment Cancelled" });

  var managedRepair = (inventory.managed_repair_repaired || inventory.managed_repair_in_progress) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["p" /* StatusTag */], { icon: "recycle", title: "Managed Repair", display: "success" });

  var internalOutright = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(inventory, "sales_order_line_items", []).some(function (item) {
    return item.internal_outright;
  }) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["p" /* StatusTag */], { icon: "check", title: "Internal Outright", display: "success" });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    internalOutright,
    customerRMA,
    coreReturn,
    consignment,
    consignmentCancelled,
    discrepancies,
    doNotExchange,
    doNotSell,
    outright,
    qcHold,
    reclaimed,
    rmaRequested,
    underReview,
    inTransfer,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RepairAndHold, { inventory: inventory }),
    managedRepair
  );
}

Warnings.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    qc_status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    discrepancies_resolved: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
  })
};

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(338);
/* harmony export (immutable) */ __webpack_exports__["a"] = getAttachments;
/* harmony export (immutable) */ __webpack_exports__["d"] = upload;
/* harmony export (immutable) */ __webpack_exports__["c"] = multiUpload;
/* harmony export (immutable) */ __webpack_exports__["e"] = update;
/* harmony export (immutable) */ __webpack_exports__["b"] = link;
/* harmony export (immutable) */ __webpack_exports__["f"] = destroyAttachment;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var actionFactory = function actionFactory(t, r) {
  return t + "_" + r;
};

function getAttachments(id, resourceType) {
  return function (dispatch) {
    dispatch({
      type: [actionFactory(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["f" /* GET_ATTACHMENTS */], resourceType)]
    });

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.list(id, resourceType).then(function (resp) {
      return dispatch({
        type: [actionFactory(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["g" /* SET_ATTACHMENTS */], resourceType)],
        attachments: resp.data.results
      });
    });
  };
}

function upload(id, resourceType, _ref) {
  var file = _ref.file,
      attachment_type = _ref.attachment_type,
      description = _ref.description,
      reference_number = _ref.reference_number;

  var fileName = "" + (+new Date() - Math.floor(Math.random() * 10000000000)) + file.name;
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.upload(fileName).then(function (resp) {
      var _resp$data = resp.data,
          key = _resp$data.key,
          url = _resp$data.url;

      var attachment = {
        description: description,
        name: fileName,
        key: key,
        attachment_type: attachment_type,
        reference_number: reference_number
      };

      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.toS3(url, file).then(function () {
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.create(id, resourceType, attachment).then(function (createResp) {
          dispatch({
            type: [actionFactory(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["h" /* ADD_ATTACHMENT */], resourceType)],
            attachment: createResp.data
          });
          return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
        });
      });
    });
  };
}

var sanitizeFileName = function sanitizeFileName(name) {
  return name.replace(/[^0-9a-zA-Z! _\\.\\*'\\(\\)\\-]/g, "");
};

function multiUpload(id, resourceType, fileData) {
  var promises = fileData.file.map(function (f) {
    var fileName = "" + (+new Date() - Math.floor(Math.random() * 10000000000)) + sanitizeFileName(f.name);
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.upload(fileName).then(function (_ref2) {
      var data = _ref2.data;
      return {
        description: fileData.description,
        file: f,
        name: fileName,
        key: data.key,
        url: data.url,
        attachment_type: fileData.attachment_type,
        reference_number: fileData.reference_number
      };
    });
  });

  var files = Promise.all(promises);

  return function (dispatch) {
    return files.then(function (values) {
      return values.forEach(function (_ref3) {
        var name = _ref3.name,
            key = _ref3.key,
            attachment_type = _ref3.attachment_type,
            description = _ref3.description,
            file = _ref3.file,
            url = _ref3.url,
            reference_number = _ref3.reference_number;
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.toS3(url, file).then(function () {
          var attachment = {
            name: name,
            key: key,
            attachment_type: attachment_type,
            reference_number: reference_number,
            description: description
          };
          return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.create(id, resourceType, attachment).then(function (createResp) {
            dispatch({
              type: [actionFactory(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["h" /* ADD_ATTACHMENT */], resourceType)],
              attachment: createResp.data
            });
            return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
          });
        });
      });
    });
  };
}

function update(id, resourceType, data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.update(id, data).then(function (resp) {
      dispatch({
        type: [actionFactory(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["i" /* UPDATE_ATTACHMENT */], resourceType)],
        attachment: resp.data
      });
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function link(id, resourceType, attachment) {
  var data = _extends({}, attachment, {
    name: attachment.link_url,
    attachment_type: "external_link"
  });

  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.create(id, resourceType, data).then(function (resp) {
      dispatch({
        type: [actionFactory(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["h" /* ADD_ATTACHMENT */], resourceType)],
        attachment: resp.data
      });
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function destroyAttachment(id, resourceType) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.destroy(id).then(function () {
      dispatch({
        type: [actionFactory(__WEBPACK_IMPORTED_MODULE_2__actionTypes__["j" /* REMOVE_ATTACHMENT */], resourceType)],
        id: id
      });
    });
  };
}

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var disabledStyle = {
  color: "rgba(255, 255, 255, 0.5)",
  cursor: "not-allowed"
};

var RecordPager = function (_Component) {
  _inherits(RecordPager, _Component);

  function RecordPager() {
    _classCallCheck(this, RecordPager);

    return _possibleConstructorReturn(this, (RecordPager.__proto__ || Object.getPrototypeOf(RecordPager)).apply(this, arguments));
  }

  _createClass(RecordPager, [{
    key: "renderPrevious",
    value: function renderPrevious() {
      var _props = this.props,
          record = _props.record,
          baseUrl = _props.baseUrl,
          getUrl = _props.getUrl;

      var previousId = record.get("previous_record_id");

      return previousId ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
        { to: getUrl(baseUrl, previousId) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-angle-left" })
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-angle-left", style: disabledStyle });
    }
  }, {
    key: "renderNext",
    value: function renderNext() {
      var _props2 = this.props,
          record = _props2.record,
          baseUrl = _props2.baseUrl,
          getUrl = _props2.getUrl;

      var nextId = record.get("next_record_id");

      return nextId ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
        { to: getUrl(baseUrl, nextId) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-angle-right" })
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-angle-right", style: disabledStyle });
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "page-header-pagination", style: { marginLeft: "-5px" } },
        "\xA0",
        this.renderPrevious(),
        "\xA0\xA0",
        this.renderNext(),
        "\xA0"
      );
    }
  }]);

  return RecordPager;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (RecordPager);


RecordPager.propTypes = {
  baseUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  getUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

RecordPager.defaultProps = {
  getUrl: function getUrl(baseUrl, id) {
    return baseUrl + "/" + id;
  }
};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(252);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(286)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(216);
var createDesc = __webpack_require__(290);
module.exports = __webpack_require__(250) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(90).f;
var has = __webpack_require__(122);
var TAG = __webpack_require__(81)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
var defined = __webpack_require__(157);
var fails = __webpack_require__(66);
var spaces = __webpack_require__(537);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(68);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(181);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM2.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);

  return false;
}
module.exports = exports['default'];

/***/ }),
/* 258 */,
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(307),
    getRawTag = __webpack_require__(2903),
    objectToString = __webpack_require__(2931);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2483), __esModule: true };

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.toastrWarn = toastrWarn;
exports.createReducer = createReducer;
exports.isBrowser = isBrowser;
exports.keyCode = keyCode;
exports.mapToToastrMessage = mapToToastrMessage;
exports.guid = guid;
exports.onCSSTransitionEnd = onCSSTransitionEnd;
exports.preventDuplication = preventDuplication;
exports.updateConfig = updateConfig;
exports._bind = _bind;

var _config = __webpack_require__(589);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function whichAnimationEvent() {
  var t = void 0;
  var el = document.createElement('fakeelement');

  var transitions = {
    animation: 'animationend',
    oanimation: 'oanimationend',
    MSAnimation: 'MSAnimationEnd',
    webkitAnimation: 'webkitAnimationEnd'
  };

  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}

function isString(obj) {
  if (typeof obj == 'string') {
    return true;
  }
  return false;
}

function toastrWarn(message) {
  if (true) {
    return null;
  }
  console.warn('[react-redux-toastr] ' + message);
}

function createReducer(initialState, fnMap) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var _ref = arguments[1];
    var type = _ref.type,
        payload = _ref.payload;

    var handle = fnMap[type];
    return handle ? handle(state, payload) : state;
  };
}

function isBrowser() {
  if (typeof window !== 'undefined') {
    return true;
  }
  return false;
}

function keyCode(e) {
  return e.which ? e.which : e.keyCode;
}

function mapToToastrMessage(type, array) {
  var obj = {};
  obj.type = type;
  obj.position = _config2.default.position;

  obj.options = array.filter(function (item) {
    return (typeof item === 'undefined' ? 'undefined' : _typeof(item)) == 'object';
  })[0] || {};

  if (obj.options.hasOwnProperty('position')) {
    obj.position = obj.options.position;
  }

  if (!obj.options.hasOwnProperty('removeOnHover')) {
    obj.options.removeOnHover = true;
    if (type === 'message') {
      obj.options.removeOnHover = false;
    }
  }

  if (!obj.options.hasOwnProperty('showCloseButton')) {
    obj.options.showCloseButton = true;
  }

  if (type === 'message' && !obj.options.hasOwnProperty('timeOut')) {
    obj.options.timeOut = 0;
  }

  if (isString(array[0]) && isString(array[1])) {
    obj.title = array[0];
    obj.message = array[1];
  } else if (isString(array[0]) && !isString(array[1])) {
    obj.title = array[0];
  } else {
    obj.message = array[0];
  }

  return obj;
}

function guid() {
  var r = function r() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  };
  return r() + r() + r() + '-' + r() + '_' + r() + '-' + r() + '_' + r() + r() + r();
}

function onCSSTransitionEnd(node, callback) {
  // if css animation is failed - dispatch event manually
  var animationEnd = whichAnimationEvent();
  var timeoutId = setTimeout(function () {
    var e = new Event(animationEnd);
    toastrWarn('The toastr box was closed automatically, please check \'transitionOut\' prop value');
    node.dispatchEvent(e);
  }, _config2.default.maxAnimationDelay);

  var runOnce = function runOnce(e) {
    clearTimeout(timeoutId);
    // stopPropagation is not working in IE11 and Edge, the transitionend from the Button.js is waiting
    // on the confirm animation to end first and not the Button.js
    e.stopPropagation();
    node.removeEventListener(animationEnd, runOnce);
    callback && callback(e);
  };
  node.addEventListener(animationEnd, runOnce);
}

function preventDuplication(currentData, newObjec) {
  var hasDuplication = false;
  currentData.forEach(function (item) {
    // If the toastr options implicitly specify not to prevent duplicates then skip
    if (item.options.preventDuplicates === false) return;
    // Because the toastr has a unic id we will check by the title and message.
    if (item.title === newObjec.title && item.message === newObjec.message && item.type === newObjec.type) {
      hasDuplication = true;
    }
  });
  return hasDuplication;
}

function updateConfig(obj) {
  Object.keys(_config2.default).forEach(function (key) {
    if (obj.hasOwnProperty(key)) {
      _config2.default[key] = obj[key];
    }
  });
}

function _bind(strinOrAray, scope) {
  var array = strinOrAray;
  if (!Array.isArray(strinOrAray)) {
    array = strinOrAray.split(' ');
  }
  return array.map(function (item) {
    return scope[item] = scope[item].bind(scope);
  });
}

/***/ }),
/* 262 */,
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pagination__ = __webpack_require__(420);
/* harmony export (immutable) */ __webpack_exports__["b"] = update;
/* harmony export (immutable) */ __webpack_exports__["d"] = searchCommissions;
/* harmony export (immutable) */ __webpack_exports__["c"] = payAllCommissions;
/* harmony export (immutable) */ __webpack_exports__["a"] = toggleLock;





function update(commissionId, data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].commissions.update(commissionId, data).then(function () {
      dispatch(__WEBPACK_IMPORTED_MODULE_3__pagination__["a" /* default */].pageActions.expire());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reset"])("updateCommissionForm"));
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function searchCommissions() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].commissions.search(filters).then(function (resp) {
      return resp.data.results;
    });
  };
}

function payAllCommissions() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].commissions.payAll(data).then(function () {
      dispatch(__WEBPACK_IMPORTED_MODULE_3__pagination__["a" /* default */].pageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function toggleLock(commission) {
  var serializedUser = JSON.parse(window.localStorage.getItem("user"));
  var data = {
    locked: !commission.locked,
    locked_audit: {
      updated_at: new Date(),
      updated_by: {
        id: serializedUser.id,
        full_name: serializedUser.full_name
      }
    }
  };

  return __WEBPACK_IMPORTED_MODULE_3__pagination__["a" /* default */].pageActions.updateAsync(commission.id, data, __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].commissions.update(commission.id, data));
}

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOCATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCATION_ID; });
var LOCATIONS = "locations";
var LOCATION_ID = "location_id";

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_pagination__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createStore__ = __webpack_require__(165);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return lotsPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return expireLineItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return lotLineItemsPagination; });
/* unused harmony export receivingRecords */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









var lotsPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "lots",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].lots.search,
  stateLocator: function stateLocator(state) {
    return state.lots.main;
  }
});

var expireLineItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__["composables"])({
  listId: "lots/lineItems"
}).expire;

var lotLineItemsPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "lots/lineItems",
  stateLocator: function stateLocator(state) {
    return state.lots.lineItems;
  },
  initialSettings: {
    pageSize: 15
  },
  fetch: function fetch(search) {
    var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__createStore__["a" /* default */])().getState().lotDetail.getIn(["lot", __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* ID */]]);
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].lots.lineItems.search(id, search);
  }
});

var _paginationGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["b" /* paginationGroup */])({
  groupName: "lots",
  getId: function getId(state) {
    return state.lotDetail.getIn(["lot", __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* ID */]]);
  },
  locate: function locate(_ref) {
    var key = _ref.key;
    return function (state) {
      return state.lots[key];
    };
  }
}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__parts_pagination__["a" /* config */])("receivingRecords", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].lots.receivingRecords.search)),
    _paginationGroup2 = _slicedToArray(_paginationGroup, 1);

var receivingRecords = _paginationGroup2[0];



/* harmony default export */ __webpack_exports__["d"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux__["combineReducers"])({
  main: lotsPagination.paginator,
  receivingRecords: receivingRecords,
  lineItems: lotLineItemsPagination.paginator
}));

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_constants__ = __webpack_require__(73);
/* harmony export (immutable) */ __webpack_exports__["a"] = ShippingPreference;




function ShippingPreference(_ref) {
  var shippingMethod = _ref.shippingMethod;

  if (!shippingMethod) {
    return null;
  }

  var formattedShippingMethod = shippingMethod.carrier && __WEBPACK_IMPORTED_MODULE_2__shared_constants__["a" /* CARRIERS */][shippingMethod.carrier] && __WEBPACK_IMPORTED_MODULE_2__shared_constants__["a" /* CARRIERS */][shippingMethod.carrier].shippingMethods[shippingMethod.shipping_method] && __WEBPACK_IMPORTED_MODULE_2__shared_constants__["a" /* CARRIERS */][shippingMethod.carrier].shippingMethods[shippingMethod.shipping_method].label;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-condensed" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Carrier"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          shippingMethod.carrier && __WEBPACK_IMPORTED_MODULE_2__shared_constants__["a" /* CARRIERS */][shippingMethod.carrier] && __WEBPACK_IMPORTED_MODULE_2__shared_constants__["a" /* CARRIERS */][shippingMethod.carrier].label
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Method"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          formattedShippingMethod || shippingMethod.shipping_method
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Account #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          shippingMethod.carrier && shippingMethod.account_number
        )
      )
    )
  );
}

ShippingPreference.propTypes = {
  shippingMethod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    account_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    carrier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    shipping_method: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_CurrencyField__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OfferFields__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__inventories_components_EditInventory_TagTypes__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_components_NoteTooltip_NoteTooltip__ = __webpack_require__(120);
/* harmony export (immutable) */ __webpack_exports__["c"] = warrantyForCondition;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return copyFromInventoryFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return copyFromInventoryFieldsOnOQ; });
/* harmony export (immutable) */ __webpack_exports__["b"] = PartDetails;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
























function warrantyForCondition(condition, part, tagDate, inventory, quoteType) {
  if (part && part.pass_fail) {
    return "30 days";
  }

  var defaultWarranty = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shared_helpers__["d" /* warrantyForCondition */])(condition, part, tagDate, inventory);

  var months = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__hooks_useCurrentUser__["b" /* useSettings */])().tag_date_months_for_warranty || null;
  if (months && tagDate && __WEBPACK_IMPORTED_MODULE_19_moment___default()(tagDate).isBefore(__WEBPACK_IMPORTED_MODULE_19_moment___default()().subtract(Number(months), "month"))) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__hooks_useCurrentUser__["b" /* useSettings */])().tag_date_warranty;
  }

  if (quoteType === __WEBPACK_IMPORTED_MODULE_7__constants__["n" /* AS_IS */]) {
    return "No Warranty, unit sold as-is.";
  }

  var settings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__hooks_useCurrentUser__["b" /* useSettings */])();

  if (settings && settings[condition + "_warranty"]) {
    return settings[condition + "_warranty"];
  }

  if (inventory) {
    if ([__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["h" /* REPAIRED */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["P" /* INSPECTED */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["i" /* OVERHAULED */]].includes(inventory.condition)) {
      if (inventory.warranty_override) {
        return inventory.warranty_override;
      } else if (part.warranty_override) {
        return part.warranty_override;
      }
    } else if (inventory.condition === __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["g" /* NEW_ITEM */] && inventory.warranty_override) {
      return inventory.warranty_override;
    } else if (inventory.condition === __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["g" /* NEW_ITEM */]) {
      return defaultWarranty;
    }
  }

  return defaultWarranty;
}

var copyFromInventoryFields = {
  caac: function caac(inv) {
    return inv.caac;
  },
  condition: function condition(inv) {
    return inv.srp_condition;
  },
  dom: function dom(inv, _quoteType, part) {
    return part.dom_sensitive ? inv.dom : null;
  },
  easa: function easa(inv) {
    return inv.easa;
  },
  faa: function faa(inv) {
    return inv.faa;
  },
  uk_caa: function uk_caa(inv) {
    return inv.uk_caa;
  },
  lead_time: __WEBPACK_IMPORTED_MODULE_12__shared_helpers__["e" /* setLeadTime */],
  price_per_unit: function price_per_unit(inv, quoteType) {
    return inv.condition === __WEBPACK_IMPORTED_MODULE_14__Receiving_constants__["g" /* BEYOND_ECON_REPAIR */] || quoteType === __WEBPACK_IMPORTED_MODULE_7__constants__["o" /* MAKE_OFFER */] ? null : inv.suggested_retail;
  },
  exchange_fee: function exchange_fee(inv, quoteType, part, canExchange) {
    if (part && part.pass_fail || inv.condition === __WEBPACK_IMPORTED_MODULE_14__Receiving_constants__["g" /* BEYOND_ECON_REPAIR */] || !canExchange || quoteType === __WEBPACK_IMPORTED_MODULE_7__constants__["o" /* MAKE_OFFER */]) {
      return "";
    }
    return inv.exchange_srp;
  },
  other: function other(inv) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(inv.other_tag_type);
  },
  other_tag_type: function other_tag_type(inv) {
    return inv.other_tag_type;
  },
  quantity: function quantity(inv) {
    return inv.quantity || 0;
  },
  serial_number: function serial_number(inv) {
    return inv.serial_number;
  },
  tag_date: __WEBPACK_IMPORTED_MODULE_12__shared_helpers__["f" /* setTagDate */],
  tagged_by: function tagged_by(inv) {
    return inv.tagged_by;
  },
  tcca: function tcca(inv) {
    return inv.tcca;
  },
  trace_type: __WEBPACK_IMPORTED_MODULE_12__shared_helpers__["g" /* setTraceType */],
  traced_to: __WEBPACK_IMPORTED_MODULE_12__shared_helpers__["h" /* setTraceTo */],
  warranty: function warranty(inv, quoteType, part) {
    return warrantyForCondition(inv.srp_condition, part, inv.tag_date, inv, quoteType);
  }
};

var copyFromInventoryFieldsOnOQ = _extends({}, copyFromInventoryFields, {
  condition: function condition(inv) {
    if (inv.condition === __WEBPACK_IMPORTED_MODULE_14__Receiving_constants__["g" /* BEYOND_ECON_REPAIR */]) {
      return inv.condition;
    }

    return inv.srp_condition;
  },
  tagged_by: function tagged_by(inv) {
    if (inv.status !== __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["k" /* REPAIR_AND_HOLD */]) {
      return inv.tagged_by;
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(inv, "most_recent_repair_order.company.name");
  },
  total_cycles_remaining: function total_cycles_remaining(inv) {
    var totalCycles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(inv, "part.total_cycles");
    if (totalCycles && inv.total_cycles) {
      return Number(totalCycles) - Number(inv.total_cycles);
    }

    return null;
  },
  total_hours_remaining: function total_hours_remaining(inv) {
    var totalHours = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(inv, "part.total_hours");
    if (totalHours && inv.total_cycles) {
      return Number(totalHours) - Number(inv.total_hours);
    }

    return null;
  }
});

var hasDisabledFields = function hasDisabledFields(disabledFields) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isPlainObject"])(disabledFields)) {
    return false;
  }

  return function (fieldName) {
    return Boolean(disabledFields[fieldName]);
  };
};

function PartDetails(_ref) {
  var canExchange = _ref.canExchange,
      disableTagType = _ref.disableTagType,
      formName = _ref.formName,
      formSection = _ref.formSection,
      getFieldValue = _ref.getFieldValue,
      resetFields = _ref.resetFields,
      setFieldValue = _ref.setFieldValue,
      quoteType = _ref.quoteType,
      handleQuantityChanged = _ref.handleQuantityChanged,
      part = _ref.part,
      selectedInventories = _ref.selectedInventories,
      doNotExchangeInventoryLineItem = _ref.doNotExchangeInventoryLineItem,
      setWarrantyField = _ref.setWarrantyField,
      _ref$inventoryIds = _ref.inventoryIds,
      inventoryIds = _ref$inventoryIds === undefined ? [] : _ref$inventoryIds,
      passFail = _ref.passFail,
      children = _ref.children,
      disabled = _ref.disabled;

  var isDisabled = hasDisabledFields(disabled);
  var doNotExchange = selectedInventories && selectedInventories.length > 0 && selectedInventories.filter(function (f) {
    return f;
  }).every(function (t) {
    return t.do_not_exchange;
  });

  var sectionName = function sectionName(name) {
    return [formSection, name].filter(function (f) {
      return f;
    }).join(".");
  };
  var SELECTABLE_CONDITIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(part, __WEBPACK_IMPORTED_MODULE_17__parts_constants__["H" /* TOOLING_PART_TYPE */]) ? __WEBPACK_IMPORTED_MODULE_10__constants__["_27" /* CONDITIONS_WITH_SERVICEABLE */] : __WEBPACK_IMPORTED_MODULE_10__constants__["_36" /* CONDITIONS */];

  var minOutrightVal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__hooks_useCurrentUser__["b" /* useSettings */])()[__WEBPACK_IMPORTED_MODULE_10__constants__["_22" /* MIN_OUTRIGHT_VALUE_FOR_EXCHANGE_CONSIDERATION */]];

  var renderExchangeFeeNoteTooltip = function renderExchangeFeeNoteTooltip() {
    var reasons = [];
    if (doNotExchangeInventoryLineItem) {
      reasons.push("<li>due to manual restriction set to inv. record</li>");
    }
    if (passFail) {
      reasons.push("<li>due to pass/fail nature</li>");
    }
    if (doNotExchange) {
      reasons.push("<li>due to manual restriction set to inv. record</li>");
    }
    if (Number(getFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* PRICE_PER_UNIT */])) < Number(minOutrightVal)) {
      reasons.push("<li>Price Per Unit under " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_currency__["a" /* dollars */])(minOutrightVal) + "</li>");
    }

    if (reasons.length === 0) return null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__shared_components_NoteTooltip_NoteTooltip__["a" /* default */], {
      placement: "right",
      icon: "fa-lg fa-info-circle",
      color: "rgba(255, 77, 77, 0.5)",
      note: "Exchange Fee is disabled due to the following reasons:" + "<br/>" + ("<ul>" + reasons.join("") + "</ul>")
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["n" /* CONDITION */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_forms__["a" /* toOptions */])(SELECTABLE_CONDITIONS),
            onChange: function onChange(e) {
              return setWarrantyField(warrantyForCondition(e.target.value, part, null, null, quoteType));
            },
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["n" /* CONDITION */]),
            disabled: inventoryIds.length > 1,
            required: inventoryIds.length <= 1
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 2 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_10__constants__["j" /* QUANTITY */],
            label: "QTY",
            onChange: function onChange() {
              return handleQuantityChanged();
            },
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["h" /* NumberInput */],
            roundDigits: 0,
            inputProps: { min: 0 },
            disabled: inventoryIds.length > 1,
            required: inventoryIds.length <= 1
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_CurrencyField__["a" /* default */], {
            name: __WEBPACK_IMPORTED_MODULE_7__constants__["b" /* PRICE_PER_UNIT */],
            label: quoteType === __WEBPACK_IMPORTED_MODULE_7__constants__["j" /* EXCHANGE_ONLY */] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["x" /* OUTRIGHT_VALUE */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* PRICE_PER_UNIT */]),
            onBlur: function onBlur(_, val) {
              if (minOutrightVal && Number(minOutrightVal) > Number(val)) {
                setFieldValue(sectionName(__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* EXCHANGE_FEE */]))(null);
              }
            },
            required: !__WEBPACK_IMPORTED_MODULE_7__constants__["w" /* PRICE_PER_UNIT_OPTIONAL_QUOTE_TYPES */].includes(quoteType),
            readOnly: quoteType === __WEBPACK_IMPORTED_MODULE_7__constants__["o" /* MAKE_OFFER */],
            disabled: quoteType === __WEBPACK_IMPORTED_MODULE_7__constants__["o" /* MAKE_OFFER */] || isDisabled(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* PRICE_PER_UNIT */])
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_CurrencyField__["a" /* default */], {
            name: __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* EXCHANGE_FEE */],
            label: ["Exch Fee", renderExchangeFeeNoteTooltip()],
            readOnly: quoteType === __WEBPACK_IMPORTED_MODULE_7__constants__["h" /* NO_QUOTE */],
            disabled: doNotExchangeInventoryLineItem || passFail || [__WEBPACK_IMPORTED_MODULE_7__constants__["o" /* MAKE_OFFER */], __WEBPACK_IMPORTED_MODULE_7__constants__["h" /* NO_QUOTE */]].includes(quoteType) || isDisabled(__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* EXCHANGE_FEE */]) || !canExchange || part && part.pass_fail || doNotExchange || minOutrightVal && Number(minOutrightVal) > getFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* PRICE_PER_UNIT */]),
            required: quoteType === __WEBPACK_IMPORTED_MODULE_7__constants__["j" /* EXCHANGE_ONLY */]
          })
        )
      )
    ),
    quoteType === __WEBPACK_IMPORTED_MODULE_7__constants__["q" /* OFFER */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__OfferFields__["a" /* default */], { resetFields: resetFields }),
    children,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed", style: { marginBottom: 15 } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["E" /* TRACE_TYPE */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_7__constants__["c" /* OUTGOING_LINE_ITEMS */].traceTypes),
            disabled: inventoryIds.length > 1,
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["E" /* TRACE_TYPE */])
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["F" /* TRACED_TO */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["F" /* TRACED_TO */]),
            disabled: inventoryIds.length > 1
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["r" /* MonthYearField */], {
            name: __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["x" /* TAG_DATE */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["x" /* TAG_DATE */]),
            disabled: inventoryIds.length > 1
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["p" /* TAGGED_BY */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["p" /* TAGGED_BY */]),
            disabled: inventoryIds.length > 1
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["r" /* MonthYearField */], {
            name: __WEBPACK_IMPORTED_MODULE_17__parts_constants__["G" /* DOM */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: __WEBPACK_IMPORTED_MODULE_17__parts_constants__["G" /* DOM */].toUpperCase(),
            disabled: inventoryIds.length > 0 || getFieldValue(__WEBPACK_IMPORTED_MODULE_10__constants__["_21" /* INVENTORY_ID */])
          }),
          (inventoryIds.length === 1 || getFieldValue(__WEBPACK_IMPORTED_MODULE_10__constants__["_21" /* INVENTORY_ID */])) && part && selectedInventories[0] && selectedInventories[0].dom && !part.dom_sensitive && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            type: "checkbox",
            style: { marginLeft: "10px" },
            checked: getFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["y" /* INCLUDE_DOM */]),
            onClick: function onClick() {
              var includeDom = getFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["y" /* INCLUDE_DOM */]);
              if (!includeDom) {
                setFieldValue(sectionName(__WEBPACK_IMPORTED_MODULE_17__parts_constants__["G" /* DOM */]))(selectedInventories[0][__WEBPACK_IMPORTED_MODULE_17__parts_constants__["G" /* DOM */]]);
              } else {
                setFieldValue(sectionName(__WEBPACK_IMPORTED_MODULE_17__parts_constants__["G" /* DOM */]))(null);
              }
              setFieldValue(sectionName(__WEBPACK_IMPORTED_MODULE_7__constants__["y" /* INCLUDE_DOM */]))(!includeDom);
            }
          }), " Include DOM"]
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["o" /* SERIAL_NUMBER */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: "Serial #",
            disabled: inventoryIds.length > 1
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 5 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["g" /* WARRANTY */]),
            name: __WEBPACK_IMPORTED_MODULE_7__constants__["g" /* WARRANTY */],
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_forms__["f" /* arrayToOptions */])(__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_59" /* WARRANTY_OPTIONS */]),
            disabled: inventoryIds.length > 1
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["G" /* LEAD_TIME */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["h" /* NumberInput */],
            label: ["Days Lead Time", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__shared_components_NoteTooltip_NoteTooltip__["a" /* default */], {
              color: "rgba(255, 255, 255, 0.25)",
              icon: "fa-info-circle",
              note: "0 = In Stock"
            })],
            roundDigits: 0
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Fields"], {
          disabled: disableTagType,
          names: [__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["L" /* UK_CAA */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["M" /* OTHER */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["N" /* OTHER_TAG_TYPE */]],
          component: __WEBPACK_IMPORTED_MODULE_16__inventories_components_EditInventory_TagTypes__["a" /* default */],
          formName: formName
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
          { checkGroupStyles: { marginTop: 0 }, justified: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_7__constants__["z" /* HAS_FOLLOW_UP_FEEDBACK */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["d" /* FOLLOW_UP_FEEDBACK */]),
            onChange: function onChange(_, val) {
              if (!val) setFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["d" /* FOLLOW_UP_FEEDBACK */])(null);
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 6 },
        getFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["z" /* HAS_FOLLOW_UP_FEEDBACK */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["d" /* FOLLOW_UP_FEEDBACK */]),
            name: __WEBPACK_IMPORTED_MODULE_7__constants__["d" /* FOLLOW_UP_FEEDBACK */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_7__constants__["A" /* FOLLOW_UP_FEEDBACKS */])
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* FormGroup */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: "ships_from", component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */], label: "fob" })
    )
  );
}

PartDetails.propTypes = {
  canExchange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disableTagType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  formName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  formSection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetFields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inventoryIds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pass_fail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  quoteType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  handleQuantityChanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedInventories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
  setWarrantyField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  passFail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    price_per_unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    exchange_fee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })
};

PartDetails.defaultProps = {
  disabled: {
    price_per_unit: false,
    exchange_fee: false
  }
};

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parts_components_ModifiedFlag__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__inventories_components_Detail_Warnings__ = __webpack_require__(246);
/* unused harmony export SelectInventoryTable */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var SelectInventoryTable = function (_Component) {
  _inherits(SelectInventoryTable, _Component);

  function SelectInventoryTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectInventoryTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectInventoryTable.__proto__ || Object.getPrototypeOf(SelectInventoryTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inventories: []
    }, _this.setInventory = function (partId) {
      var addRecord = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _this$props = _this.props,
          searchInventories = _this$props.searchInventories,
          filter = _this$props.filter,
          _this$props$selectedI = _this$props.selectedInventory,
          selectedInventory = _this$props$selectedI === undefined ? {} : _this$props$selectedI;

      _this.search = searchInventories(partId, filter).then(function (resp) {
        if (selectedInventory.id && addRecord) {
          var containsInv = resp.some(function (inv) {
            return inv.id === selectedInventory.id;
          });
          if (!containsInv) {
            resp.unshift(selectedInventory);
          }
        }
        _this.updateState({ inventories: resp });
      });
    }, _this.updateState = function (nextStateUpdate) {
      if (_this.mounted) {
        _this.setState(nextStateUpdate);
      }
    }, _this.renderRow = function (inventory, i, modal) {
      var _this$props2 = _this.props,
          choosable = _this$props2.choosable,
          onInventorySelected = _this$props2.onInventorySelected,
          inventoryIds = _this$props2.inventoryIds,
          displayQuantity = _this$props2.displayQuantity,
          quoteType = _this$props2.quoteType;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: i },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: modal ? {} : { backgroundColor: "#383838" } },
          i + 1
        ),
        choosable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components__["D" /* InventoryStatusCell */],
          { inventory: inventory },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            type: "checkbox",
            className: "radio-inline",
            checked: inventoryIds && inventoryIds.includes(inventory.id),
            onChange: function onChange() {
              return onInventorySelected(inventory);
            },
            disabled: quoteType === __WEBPACK_IMPORTED_MODULE_11__constants__["h" /* NO_QUOTE */]
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          inventory.serial_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: __WEBPACK_IMPORTED_MODULE_8__parts_components_ModifiedFlag__["a" /* columnStyle */].flagColumn },
          inventory.modified && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__parts_components_ModifiedFlag__["b" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["r" /* INVENTORIES */], "condition." + inventory.condition + ".abbrev")
        ),
        displayQuantity && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          inventory.quantity
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__inventories_components_Detail_Warnings__["a" /* RepairAndHold */], { inventory: inventory }),
          inventory.status !== __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["k" /* REPAIR_AND_HOLD */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_date__["d" /* alphaMonthYear */])(inventory.tag_date)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-center" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["o" /* LocationFlag */], { location: inventory.store_location_id })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          inventory.cost_per_unit && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_currency__["a" /* dollars */])(inventory.cost_per_unit, 0)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          inventory.exchange_srp && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_currency__["a" /* dollars */])(inventory.exchange_srp, 0)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          inventory.suggested_retail && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_currency__["a" /* dollars */])(inventory.suggested_retail, 0)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["G" /* NoteTooltipTableCell */], {
          note: inventory.important_note,
          color: "#f44336",
          className: "td-shrink-icon text-left"
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectInventoryTable, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.part) {
        this.props.change("outgoing_quote_line_item.inventory_ids", []);
        this.setInventory(this.props.part.id);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.part && nextProps.part !== this.props.part) {
        this.setInventory(nextProps.part.id, false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.onInventorySelected(null);
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          inventoryIds = _props.inventoryIds,
          modal = _props.modal,
          choosable = _props.choosable,
          onInventorySelected = _props.onInventorySelected,
          displayQuantity = _props.displayQuantity;

      var className = __WEBPACK_IMPORTED_MODULE_4_classnames___default()("table table-striped table-numbered", {
        "table-hover": choosable
      });

      if (this.state.inventories.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "well well-lg text-center" },
          "No Inventory Available"
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "table",
        { className: className },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            choosable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Serial #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "CD"
            ),
            displayQuantity && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "QTY"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tag Date"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-center" },
                "Store Loc"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Cost"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Exch SRP"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "SRP"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tbody",
          null,
          this.state.inventories.map(function (inv, idx) {
            return _this2.renderRow(inv, idx, modal);
          }),
          choosable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { style: modal ? {} : { backgroundColor: "#383838" } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              { className: "text-center" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                type: "radio",
                name: "inventory_ids",
                className: "radio-inline",
                checked: inventoryIds && inventoryIds.length === 0,
                onChange: function onChange() {
                  return onInventorySelected(null);
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              {
                colSpan: "10",
                style: { marginBottom: "2px", verticalAlign: "baseline" }
              },
              "Don't quote from a specific inventory item"
            )
          )
        )
      );
    }
  }]);

  return SelectInventoryTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SelectInventoryTable.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired
  }),
  onInventorySelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  searchInventories: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  filter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  inventoryIds: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  selectedInventory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  modal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  change: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  choosable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  displayQuantity: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  quoteType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
SelectInventoryTable.defaultProps = {
  choosable: true,
  displayQuantity: true,
  onInventorySelected: function onInventorySelected() {
    return null;
  },
  change: function change() {
    return null;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    searchInventories: function searchInventories(partId, filter) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__parts_actions__["f" /* searchInventories */])(partId, filter));
    }
  };
})(SelectInventoryTable));

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony export (immutable) */ __webpack_exports__["a"] = withPurchaseOrder;


function withPurchaseOrder(Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
    return {
      purchaseOrder: state.purchaseOrderDetail.get("purchaseOrder")
    };
  })(Component);
}

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SalesOrders_constants__ = __webpack_require__(32);
/* unused harmony export isLastExchange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return purchaseOrderLastExchange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayCost; });


var isLastExchange = function isLastExchange(lineItem) {
  return lineItem.purchase_for_exchange && !lineItem.second_exchange_item_id && !lineItem.exchange_type || lineItem.exchange_type === __WEBPACK_IMPORTED_MODULE_0__SalesOrders_constants__["l" /* SECOND_EXCHANGE */] && !lineItem.third_exchange_item_id || lineItem.exchange_type === __WEBPACK_IMPORTED_MODULE_0__SalesOrders_constants__["m" /* THIRD_EXCHANGE */];
};

var purchaseOrderLastExchange = function purchaseOrderLastExchange(purchaseOrder) {
  return purchaseOrder.line_items.find(function (l) {
    return isLastExchange(l);
  });
};

var displayCost = function displayCost(lineItem) {
  return lineItem.purchase_for_exchange && !lineItem.outright ? lineItem.exchange_fee : lineItem.cost;
};

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony export (immutable) */ __webpack_exports__["a"] = withRma;


function withRma(Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
    return {
      rma: state.rmaDetail.get("rma")
    };
  })(Component);
}

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createStore__ = __webpack_require__(165);
/* unused harmony export searchLineItems */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return repairOrderLineItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reservedForRepairInventory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return repairOrdersPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return repairOrderLineItemsPagination; });







var searchLineItems = function searchLineItems(pageInfo) {
  return function (dispatch, getState) {
    var results = getState().repairOrderDetail.getIn(["repairOrder", "line_items"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()).toJS();
    var _pageInfo$query = pageInfo.query,
        limit = _pageInfo$query.limit,
        page = _pageInfo$query.page;

    var data = {
      total_count: results.length,
      results: results.slice(limit * page - limit, page * limit)
    };

    return Promise.resolve({ data: data });
  };
};

var repairOrderLineItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "repairOrderLineItems",
  fetch: searchLineItems,
  initialSettings: {
    pageSize: 5
  }
});

var reservedForRepairInventory = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "reservedForRepairInventory",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.searchReservedForRepair
});

var repairOrdersPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "repairOrders/search",
  stateLocator: function stateLocator(state) {
    return state.repairOrders.search;
  },
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].repairOrders.search,
  initialSettings: {
    sort: "created_at",
    sortReverse: true
  }
});

var repairOrderLineItemsPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "repairOrders/lineItems",
  stateLocator: function stateLocator(state) {
    return state.repairOrders.lineItems;
  },
  initialSettings: {
    pageSize: 15
  },
  fetch: function fetch(search) {
    var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__createStore__["a" /* default */])().getState().repairOrderDetail.getIn(["repairOrder", __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ID */]]);
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].repairOrders.lineItems.search(id, search);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["combineReducers"])({
  search: repairOrdersPagination.paginator,
  lineItems: repairOrderLineItemsPagination.paginator
}));

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pagination__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aircrafts_actions__ = __webpack_require__(1951);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_6__aircrafts_actions__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_6__aircrafts_actions__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__contacts_actions__ = __webpack_require__(1952);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_7__contacts_actions__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__contacts_actions__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_7__contacts_actions__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PhysicalAddresses_actions__ = __webpack_require__(1948);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_8__PhysicalAddresses_actions__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_8__PhysicalAddresses_actions__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_8__PhysicalAddresses_actions__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RelatedCompanies_actions__ = __webpack_require__(1949);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__RelatedCompanies_actions__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_9__RelatedCompanies_actions__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_9__RelatedCompanies_actions__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ShippingMethods_actions__ = __webpack_require__(1950);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__ShippingMethods_actions__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__ShippingMethods_actions__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_10__ShippingMethods_actions__["c"]; });
/* unused harmony export search */
/* unused harmony export setFilter */
/* harmony export (immutable) */ __webpack_exports__["e"] = show;
/* harmony export (immutable) */ __webpack_exports__["d"] = update;
/* harmony export (immutable) */ __webpack_exports__["c"] = create;
/* harmony export (immutable) */ __webpack_exports__["b"] = validateContact;
/* harmony export (immutable) */ __webpack_exports__["a"] = searchRepairStationCompanies;
/* harmony export (immutable) */ __webpack_exports__["h"] = searchCompanies;







var search = __WEBPACK_IMPORTED_MODULE_5__pagination__["a" /* companiesPagination */].search,
    setFilter = __WEBPACK_IMPORTED_MODULE_5__pagination__["a" /* companiesPagination */].setFilter;








function show(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].companies.show(id).then(function (resp) {
      return dispatch({
        type: __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* SET */],
        company: resp.data
      });
    });
  };
}

function update(data) {
  return function (dispatch, getState) {
    var companyId = getState().companyDetail.getIn(["company", "id"]);

    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].companies.update(companyId, data).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* SET */],
        company: resp.data
      });
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function create(data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].companies.create(data).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* SET */],
        company: resp.data
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["push"])("/companies/" + resp.data.id));
    });
  };
}

function validateContact(_ref, _action, _props) {
  var _ref$contact = _ref.contact,
      contact = _ref$contact === undefined ? {} : _ref$contact,
      _ref$contact_id = _ref.contact_id,
      contactId = _ref$contact_id === undefined ? null : _ref$contact_id;
  var email = contact.email;

  if (!email || email.includes("+demo") || ["Add", __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */]].includes(contactId) && contactId) {
    return Promise.resolve();
  }

  return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].contacts.list({ email: email }).then(function (resp) {
    if (resp.data.total_count > 0) {
      var errors = {
        contact: {
          email: ["Already taken"]
        }
      };

      return Promise.reject(errors);
    }
    return null;
  });
}

function searchRepairStationCompanies() {
  return function (name) {
    return function () {
      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].companies.search({
        cached: true,
        filter: name,
        status: "active,credit_hold,do_not_do_business",
        type: "simple",
        limit: 20
      }).then(function (resp) {
        return resp.data.results;
      });
    };
  };
}

function searchCompanies(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].companies.search({
      filter: filter,
      sort: "name",
      reverse: false,
      page: 1,
      limit: 20
    }).then(function (resp) {
      return Promise.resolve(resp.data.results);
    });
  };
}

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AS_REMOVED */
/* unused harmony export INSPECTED */
/* unused harmony export NEW_ITEM */
/* unused harmony export OVERHAULED */
/* unused harmony export REPAIRED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONDITION_TYPES; });
var _CONDITION_TYPES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AS_REMOVED = "as_removed";
var INSPECTED = "inspected";
var NEW_ITEM = "new_item";
var OVERHAULED = "overhauled";
var REPAIRED = "repaired";

var CONDITION_TYPES = (_CONDITION_TYPES = {}, _defineProperty(_CONDITION_TYPES, AS_REMOVED, {
  label: "As Removed"
}), _defineProperty(_CONDITION_TYPES, INSPECTED, {
  label: "Inspected"
}), _defineProperty(_CONDITION_TYPES, NEW_ITEM, {
  label: "New"
}), _defineProperty(_CONDITION_TYPES, OVERHAULED, {
  label: "Overhauled"
}), _defineProperty(_CONDITION_TYPES, REPAIRED, {
  label: "Repaired"
}), _CONDITION_TYPES);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_LocationFlag__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony export (immutable) */ __webpack_exports__["a"] = SellableQty;







var locationFlagCount = function locationFlagCount(locationId, quantities) {
  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(locationId) ? "N/A" : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_LocationFlag__["a" /* default */], { location: locationId }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    quantities.get(locationId) || 0,
    " "
  )];
};

var locationFlags = function locationFlags(quantities) {
  return Object.keys(quantities.toJS()).map(function (locationId) {
    return locationFlagCount(locationId, quantities);
  });
};

function SellableQty(_ref) {
  var quantities = _ref.quantities,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style;

  if (quantities.size === 0) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "pull-right", style: style },
    "Sellable Quantity: ",
    locationFlags(quantities)
  );
}

SellableQty.propTypes = {
  quantities: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOGIN_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PUSH_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REFRESH_CARTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REFRESH_CACHED_SALES_CARTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_CARTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_LOCATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_SETTINGS; });
var LOGIN = "sessions/LOGIN";
var UPDATE = "sessions/UPDATE";
var LOGIN_ERROR = "sessions/LOGIN_ERROR";
var PUSH_ID = "sessions/PUSH_ID";
var CLEAR = "sessions/CLEAR";
var REFRESH_CARTS = "sessions/REFRESH_CARTS";
var REFRESH_CACHED_SALES_CARTS = "sessions/REFRESH_CACHED_SALES_CARTS";
var SET_CARTS = "sessions/SET_CARTS";
var SET_LOCATIONS = "sessions/SET_LOCATIONS";
var SET_SETTINGS = "sessions/SET_SETTINGS";

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__users_constants__ = __webpack_require__(13);



function Forbidden(_ref) {
  var forbidden = _ref.forbidden,
      children = _ref.children;

  return forbidden ? false : children;
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state, ownProps) {
  var userRole = state.session.getIn([__WEBPACK_IMPORTED_MODULE_1__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_1__users_constants__["h" /* ROLE */]]);
  var subRole = state.session.getIn([__WEBPACK_IMPORTED_MODULE_1__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_1__users_constants__["C" /* SUBROLE */]]);
  var permissions = state.session.getIn([__WEBPACK_IMPORTED_MODULE_1__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_1__users_constants__["D" /* PERMISSIONS */]]);
  var userId = state.session.getIn([__WEBPACK_IMPORTED_MODULE_1__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_1__users_constants__["_27" /* ID */]]);

  var otherRoles = permissions && ownProps.roles ? permissions.toJS().filter(function (a) {
    return __WEBPACK_IMPORTED_MODULE_1__users_constants__["v" /* ROLES */].includes(a) && !ownProps.roles.includes(a);
  }) : [];

  var otherRolesNotInSubroles = ownProps.subroles && __WEBPACK_IMPORTED_MODULE_1__users_constants__["v" /* ROLES */].filter(function (a) {
    return !ownProps.subroles.some(function (s) {
      return s.includes(a);
    });
  });

  var otherSubroles = permissions && ownProps.subroles ? permissions.toJS().filter(function (a) {
    return __WEBPACK_IMPORTED_MODULE_1__users_constants__["w" /* SUBROLES */].includes(a) && !ownProps.subroles.includes(a) || __WEBPACK_IMPORTED_MODULE_1__users_constants__["v" /* ROLES */].includes(a) && otherRolesNotInSubroles.includes(a);
  }) : [];

  var hasSubrole = ownProps.subroles && ownProps.subroles.includes(subRole) && otherSubroles.length === 0;

  var isBuyerOrCoBuyer = ownProps.buyerId === userId || ownProps.coBuyerId === userId;

  return {
    forbidden: !isBuyerOrCoBuyer && (ownProps.roles && ownProps.roles.includes(userRole) && otherRoles.length === 0 || hasSubrole)
  };
})(Forbidden));

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_autocomplete__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var debounceTimeout = 400;

var AutoComplete = function (_Component) {
  _inherits(AutoComplete, _Component);

  function AutoComplete(props) {
    _classCallCheck(this, AutoComplete);

    var _this = _possibleConstructorReturn(this, (AutoComplete.__proto__ || Object.getPrototypeOf(AutoComplete)).call(this));

    _this.refresh = function (e, value) {
      var onSelect = _this.props.onSelect;


      if (_this.state.selected) {
        onSelect(null, value);
      }

      _this.setState({ value: value || "", selected: null });
      _this.updateResults(value);
    };

    _this.updateResults = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (value) {
      if (value) {
        _this.waitingFor = value;

        _this.props.search(value).then(function (results) {
          if (value === _this.waitingFor) {
            _this.setState({ results: results, open: true });
          }
        });
      } else {
        _this.setState({ results: [], open: false, value: value || "" });
      }
    }, debounceTimeout);

    _this.select = function (value, result) {
      var onSelect = _this.props.onSelect;


      _this.setState({
        selected: result,
        value: value || "",
        results: [],
        open: false
      });

      onSelect(result);
    };

    _this.clearIfValueNotSelected = function (ev) {
      var changed = ev.target.value !== _this.props.value || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(ev.target.value);

      if (!_this.props.hasId && !_this.props.allowUserInput && changed) {
        _this.setState({
          value: ""
        });
      }

      if (_this.props.allowUserInput && !_this.state.selected) {
        _this.props.onSelect(_this.state.value);
      } else if (!_this.props.allowUserInput && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(ev.target.value)) {
        _this.props.onSelect(null);
      }
    };

    _this.renderMenu = function (items) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", { className: "dropdown", children: items });
    };

    _this.renderItem = function (item, isHighlighted) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        { key: item.id, className: isHighlighted ? "selected" : "" },
        _this.props.format(item)
      );
    };

    _this.state = {
      value: props.value || "",
      results: [],
      selected: null,
      open: false,
      forceClear: Number(props.forceClear)
    };
    return _this;
  }

  _createClass(AutoComplete, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({ value: nextProps.value || "" });
      }

      if (nextProps.watch !== this.props.watch) {
        this.setState({ results: [], value: "" });
      }

      if (nextProps.forceClear !== undefined && Number(nextProps.forceClear) !== Number(this.state.forceClear)) {
        this.setState({ value: "", forceClear: Number(nextProps.forceClear) });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          autoFocus = _props.autoFocus,
          renderItem = _props.renderItem,
          placeholder = _props.placeholder,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled,
          _props$className = _props.className,
          className = _props$className === undefined ? "autocomplete" : _props$className,
          _props$selectOnBlur = _props.selectOnBlur,
          selectOnBlur = _props$selectOnBlur === undefined ? true : _props$selectOnBlur;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_autocomplete___default.a, {
        value: this.state.value,
        items: this.state.results,
        getItemValue: this.props.format,
        onSelect: this.select,
        onChange: this.refresh,
        renderMenu: this.renderMenu,
        renderItem: renderItem || this.renderItem,
        wrapperStyle: {},
        wrapperProps: { className: className },
        autoHighlight: true,
        selectOnBlur: selectOnBlur,
        inputProps: {
          autoFocus: autoFocus,
          className: "form-control",
          placeholder: placeholder,
          onBlur: this.clearIfValueNotSelected,
          selectOnBlur: selectOnBlur,
          disabled: disabled
        },
        renderInput: function renderInput(inputProps) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({}, inputProps, { autoComplete: "new-password" }));
        }
      });
    }
  }]);

  return AutoComplete;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AutoComplete.propTypes = {
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  watch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hasId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectOnBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  allowUserInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  forceClear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  meta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};
AutoComplete.defaultProps = {
  onSelect: function onSelect() {},
  hasId: true
};
/* harmony default export */ __webpack_exports__["a"] = (AutoComplete);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DashedSeparator__ = __webpack_require__(211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DashedSeparator__["a"]; });



/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShippingMethod__ = __webpack_require__(785);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ShippingMethod__["a"]; });



/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InventoryStatusCell__ = __webpack_require__(797);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InventoryStatusCell__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__InventoryStatusCell__["b"]; });





/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getNoteBodyFieldName__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_notes__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actionTypes__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__resourceToStateKey__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Note__ = __webpack_require__(2369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Header__ = __webpack_require__(2365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__HeaderImportant__ = __webpack_require__(2366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__HeaderMinor__ = __webpack_require__(2367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HeaderTrace__ = __webpack_require__(2368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__EditNote_EditNote__ = __webpack_require__(2363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ViewNote_ViewNote__ = __webpack_require__(2371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ConfirmDelete_ConfirmDelete__ = __webpack_require__(773);
/* unused harmony export Notes */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var Notes = function (_React$Component) {
  _inherits(Notes, _React$Component);

  function Notes() {
    _classCallCheck(this, Notes);

    var _this = _possibleConstructorReturn(this, (Notes.__proto__ || Object.getPrototypeOf(Notes)).call(this));

    _this.state = {
      selectedNote: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),
      editNoteModalOpen: false,
      viewNoteModalOpen: false,
      deleteOpen: false
    };

    _this.deleteNote = function (note) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          resource = _this$props.resource,
          resourceType = _this$props.resourceType,
          notesType = _this$props.notesType;


      dispatch(__WEBPACK_IMPORTED_MODULE_8__actions_notes__["a" /* removeNote */](resource.get(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ID */]), resourceType, note, notesType));
    };

    _this.openEditNotesModal = function () {
      return _this.setState({ editNoteModalOpen: true });
    };

    _this.openViewNotesModal = function () {
      return _this.setState({ viewNoteModalOpen: true });
    };

    _this.openDeleteModal = function () {
      return _this.setState({ deleteOpen: true });
    };

    _this.closeEditNotesModal = function () {
      return _this.setState({ editNoteModalOpen: false });
    };

    _this.closeViewNotesModal = function () {
      return _this.setState({ viewNoteModalOpen: false });
    };

    _this.closeDeleteModal = function () {
      return _this.setState({ deleteOpen: false });
    };

    _this.handleEditNote = _this.handleEditNote.bind(_this);
    _this.handleViewNote = _this.handleViewNote.bind(_this);
    _this.handleDeleteNote = _this.handleDeleteNote.bind(_this);
    _this.toggleAction = _this.toggleAction.bind(_this);
    return _this;
  }

  _createClass(Notes, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          dispatch = _props.dispatch,
          resource = _props.resource,
          resourceType = _props.resourceType,
          notesType = _props.notesType;


      dispatch(__WEBPACK_IMPORTED_MODULE_8__actions_notes__["b" /* getNotes */](resource.get(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ID */]), resourceType, notesType));
    }
  }, {
    key: "handleEditNote",
    value: function handleEditNote(note) {
      this.setState({ selectedNote: note });
      this.openEditNotesModal();
    }
  }, {
    key: "handleViewNote",
    value: function handleViewNote(note) {
      this.setState({ selectedNote: note });
      this.openViewNotesModal();
    }
  }, {
    key: "handleDeleteNote",
    value: function handleDeleteNote(note) {
      this.setState({ selectedNote: note });
      this.openDeleteModal();
    }
  }, {
    key: "toggleAction",
    value: function toggleAction(note, key) {
      var _setState;

      this.setState((_setState = {}, _defineProperty(_setState, key, !this.state[key]), _defineProperty(_setState, "selectedNote", note), _setState));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          additionalActions = _props2.additionalActions,
          filter = _props2.filter,
          resource = _props2.resource,
          resourceType = _props2.resourceType,
          isLoading = _props2.isLoading,
          notesType = _props2.notesType;

      var allNotes = this.props.notes;
      var notes = allNotes.filter(function (n) {
        return !n.get("trace");
      });

      if (filter) notes = notes.filter(function (n) {
        return filter(n);
      });

      var _state = this.state,
          selectedNote = _state.selectedNote,
          editNoteModalOpen = _state.editNoteModalOpen,
          viewNoteModalOpen = _state.viewNoteModalOpen,
          deleteOpen = _state.deleteOpen;

      var importantNote = notes.find(function (n) {
        return n.get("important") === true;
      });
      var minorNote = notes.find(function (n) {
        return n.get("minor") === true;
      });

      var traceNotes = allNotes.filter(function (n) {
        return n.get("trace");
      });

      if (importantNote !== undefined) {
        notes = notes.splice(notes.indexOf(importantNote), 1);
      }
      if (minorNote !== undefined) {
        notes = notes.splice(notes.indexOf(minorNote), 1);
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        resourceType === __WEBPACK_IMPORTED_MODULE_4__types_resourceTypes__["a" /* default */].inventory && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__HeaderImportant__["a" /* default */], _extends({}, this.props, {
          important: importantNote !== undefined
        })), importantNote && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Note__["a" /* default */], {
          additionalActions: additionalActions,
          key: importantNote.get(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ID */]),
          note: importantNote,
          resourceID: resource.get(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ID */]),
          onEditNote: this.handleEditNote,
          onViewNote: this.handleViewNote,
          onDeleteNote: this.handleDeleteNote,
          toggleAction: this.toggleAction,
          notesType: notesType
        })],
        resourceType === __WEBPACK_IMPORTED_MODULE_4__types_resourceTypes__["a" /* default */].receivingRecord && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__HeaderMinor__["a" /* default */], _extends({}, this.props, { minor: minorNote !== undefined })), minorNote && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Note__["a" /* default */], {
          additionalActions: additionalActions,
          key: minorNote.get(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ID */]),
          note: minorNote,
          resourceID: resource.get(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ID */]),
          onEditNote: this.handleEditNote,
          onViewNote: this.handleViewNote,
          onDeleteNote: this.handleDeleteNote,
          notesType: notesType
        })],
        this.props.trace && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__HeaderTrace__["a" /* default */], this.props),
        resourceType !== __WEBPACK_IMPORTED_MODULE_4__types_resourceTypes__["a" /* default */].receivingRecord && !this.props.trace && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Header__["a" /* default */], this.props),
        isLoading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "panel panel-default panel-note animate-row",
          style: { height: "80px" }
        }),
        !isLoading && notes.size === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: "80px", visibility: "hidden" } }),
        resourceType !== __WEBPACK_IMPORTED_MODULE_4__types_resourceTypes__["a" /* default */].receivingRecord && !this.props.trace && notes.map(function (note) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Note__["a" /* default */], {
            additionalActions: additionalActions,
            key: note.get(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ID */]),
            note: note,
            resourceID: resource.get(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ID */]),
            onViewNote: _this2.handleViewNote,
            onEditNote: _this2.handleEditNote,
            onDeleteNote: _this2.handleDeleteNote,
            notesType: notesType,
            toggleAction: _this2.toggleAction
          });
        }),
        this.props.trace && traceNotes.map(function (note) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Note__["a" /* default */], {
            additionalActions: additionalActions,
            key: note.get(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ID */]),
            note: note,
            resourceID: resource.get(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ID */]),
            onViewNote: _this2.handleViewNote,
            onEditNote: _this2.handleEditNote,
            onDeleteNote: _this2.handleDeleteNote,
            notesType: notesType
          });
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ViewNote_ViewNote__["a" /* default */], {
          note: selectedNote,
          resourceID: resource.get(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ID */]),
          resourceType: resourceType,
          open: viewNoteModalOpen,
          close: this.closeViewNotesModal,
          notesType: notesType
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__EditNote_EditNote__["a" /* default */], {
          note: selectedNote,
          resourceID: resource.get(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ID */]),
          resourceType: resourceType,
          open: editNoteModalOpen,
          close: this.closeEditNotesModal,
          notesType: notesType
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_18__ConfirmDelete_ConfirmDelete__["a" /* default */],
          {
            onConfirm: function onConfirm() {
              return _this2.deleteNote(selectedNote);
            },
            close: this.closeDeleteModal,
            open: deleteOpen
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          " Are you sure you want to delete this?"
        ),
        additionalActions && additionalActions.map(function (action) {
          var open = _this2.state["" + action.key];
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7____["i" /* ConfirmAction */], {
            open: open,
            close: function close() {
              return _this2.setState(_defineProperty({}, action.key, !open));
            },
            onConfirm: function onConfirm() {
              return action.onConfirm(_this2.props.updateNote)(selectedNote);
            }
          });
        })
      );
    }
  }]);

  return Notes;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Notes.propTypes = {
  additionalActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  filter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  trace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  resourceType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  notesType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  resource: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]).isRequired,
  notes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"]),
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

Notes.defaultProps = {
  notesType: ""
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state, ownProps) {
  return {
    notes: state[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__resourceToStateKey__["a" /* default */])(ownProps.resourceType)].get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getNoteBodyFieldName__["a" /* default */])(ownProps.notesType, "notes"), []),
    isLoading: state[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__resourceToStateKey__["a" /* default */])(ownProps.resourceType)].get("notesLoading"),
    id: ownProps.resource.get(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ID */])
  };
}, function (dispatch, ownProps) {
  return {
    updateNote: function updateNote(data) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_8__actions_notes__["c" /* actionFactory */](__WEBPACK_IMPORTED_MODULE_9__actionTypes__["a" /* UPDATE_NOTE */], ownProps.resourceType),
        note: data,
        notesType: ownProps.resourceType
      });
    },
    dispatch: dispatch
  };
})(Notes));

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ClipboardCopy__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers__ = __webpack_require__(79);











function PartNumber(_ref) {
  var part = _ref.part,
      statsTooltip = _ref.statsTooltip,
      className = _ref.className,
      showIcon = _ref.showIcon,
      icon = _ref.icon,
      showClipBoard = _ref.showClipBoard;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()("align_middle", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers__["a" /* getPartNumberColorClassNameByTierType */])(part.tier_type));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: {
        display: "inline-flex",
        alignItems: "center",
        whiteSpace: "nowrap"
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],
      {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        to: "/parts/" + (part.uuid || part.id),
        className: className
      },
      showIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        icon
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: classes },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["trim"])(part.part_number)
      )
    ),
    showClipBoard && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        style: { paddingLeft: 5, display: "inline-block" }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ClipboardCopy__["a" /* default */], { name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["trim"])(part.part_number), type: "Part" })
    ),
    statsTooltip && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "align-middle", style: { paddingLeft: 5 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["f" /* PartStatsTooltip */], { part: part })
    )
  );
}

PartNumber.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    part_number: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  }).isRequired,
  statsTooltip: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  showIcon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  icon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element
};

PartNumber.defaultProps = {
  statsTooltip: true,
  showIcon: false
};

var ifHasPartValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__decorators__["a" /* renderIf */])(function (_ref2) {
  var part = _ref2.part;
  return part && Object.keys(part).length;
});

/* harmony default export */ __webpack_exports__["a"] = (ifHasPartValues(PartNumber));

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RecordPager__ = __webpack_require__(248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RecordPager__["a"]; });



/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_helpers__ = __webpack_require__(41);
/* harmony export (immutable) */ __webpack_exports__["b"] = Stars;
var _tierTypeScore;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var tierTypeScore = (_tierTypeScore = {}, _defineProperty(_tierTypeScore, __WEBPACK_IMPORTED_MODULE_3__parts_constants__["b" /* SATL */], 5), _defineProperty(_tierTypeScore, __WEBPACK_IMPORTED_MODULE_3__parts_constants__["c" /* ATL */], 4), _defineProperty(_tierTypeScore, __WEBPACK_IMPORTED_MODULE_3__parts_constants__["e" /* BTL */], 3), _defineProperty(_tierTypeScore, __WEBPACK_IMPORTED_MODULE_3__parts_constants__["f" /* BBTL */], 2), _defineProperty(_tierTypeScore, __WEBPACK_IMPORTED_MODULE_3__parts_constants__["d" /* ZTL */], 1), _tierTypeScore);

function getKeyByValue(object, value) {
  return Object.keys(object).find(function (key) {
    return object[key] === value;
  });
}

function Stars(_ref) {
  var tierType = _ref.tierType,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      updatePart = _ref.updatePart,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? true : _ref$disabled,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? "" : _ref$size;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__hooks_useCurrentUser__["a" /* default */])();
  var canClick = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_8__users_constants__["k" /* SALES */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__users_helpers__["g" /* hasSubRole */])(currentUser, [__WEBPACK_IMPORTED_MODULE_8__users_constants__["_11" /* BUYER_MANAGER */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["S" /* SALES_MANAGER */]]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__users_helpers__["e" /* hasPermission */])(currentUser, __WEBPACK_IMPORTED_MODULE_8__users_constants__["_7" /* CAN_ADD_UPDATE_PARTS */]) && !disabled;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* getPartNumberColorClassNameByTierType */])(tierType), {
    clickable: canClick
  });

  var _onClick = canClick ? updatePart : function () {};

  var stars = Array.from({ length: 5 }, function (_, i) {
    if (i < (tierTypeScore[tierType] || 0)) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
        className: "fa fa-star " + size,
        onClick: function onClick() {
          return _onClick(getKeyByValue(tierTypeScore, i + 1));
        }
      });
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
      className: "fa fa-star-o " + size,
      onClick: function onClick() {
        return _onClick(getKeyByValue(tierTypeScore, i + 1));
      }
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "score-wrap " + classes, style: style },
    stars
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    updatePart: function updatePart(tierType) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_actions__["j" /* update */])({ tier_type: tierType === ownProps.tierType ? null : tierType }));
    }
  };
})(Stars));

Stars.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  size: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  tierType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  updatePart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(836);
var enumBugKeys = __webpack_require__(505);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 289 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(145);
var TAG = __webpack_require__(81)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(145);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 293 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;
function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}
module.exports = exports["default"];

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offset;

var _contains = __webpack_require__(257);

var _contains2 = _interopRequireDefault(_contains);

var _isWindow = __webpack_require__(294);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(229);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function offset(node) {
  var doc = (0, _ownerDocument2.default)(node),
      win = (0, _isWindow2.default)(doc),
      docElem = doc && doc.documentElement,
      box = { top: 0, left: 0, height: 0, width: 0 };

  if (!doc) return;

  // Make sure it's not a disconnected DOM node
  if (!(0, _contains2.default)(docElem, node)) return box;

  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();

  // IE8 getBoundingClientRect doesn't support width & height
  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };

  return box;
}
module.exports = exports['default'];

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_fast_compare__ = __webpack_require__(3053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_fast_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_deepmerge__ = __webpack_require__(2724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_clone__ = __webpack_require__(2850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_toPath__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_warning__ = __webpack_require__(3224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hoist_non_react_statics__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_es_cloneDeep__ = __webpack_require__(2851);
/* unused harmony export ErrorMessage */
/* unused harmony export FastField */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Field; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FieldArray; });
/* unused harmony export Form */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Formik; });
/* unused harmony export FormikConsumer */
/* unused harmony export FormikContext */
/* unused harmony export FormikProvider */
/* unused harmony export connect */
/* unused harmony export getActiveElement */
/* unused harmony export getIn */
/* unused harmony export insert */
/* unused harmony export isEmptyArray */
/* unused harmony export isEmptyChildren */
/* unused harmony export isFunction */
/* unused harmony export isInputEvent */
/* unused harmony export isInteger */
/* unused harmony export isNaN */
/* unused harmony export isObject */
/* unused harmony export isPromise */
/* unused harmony export isString */
/* unused harmony export move */
/* unused harmony export prepareDataForValidation */
/* unused harmony export replace */
/* unused harmony export setIn */
/* unused harmony export setNestedObjectValues */
/* unused harmony export swap */
/* unused harmony export useField */
/* unused harmony export useFormik */
/* unused harmony export useFormikContext */
/* unused harmony export validateYupSchema */
/* unused harmony export withFormik */
/* unused harmony export yupToFormErrors */










function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/** @private is the value an empty array? */

var isEmptyArray = function isEmptyArray(value) {
  return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */

var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};
/** @private is the given object an Object? */

var isObject = function isObject(obj) {
  return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */

var isInteger = function isInteger(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */

var isString = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */
// eslint-disable-next-line no-self-compare

var isNaN$1 = function isNaN(obj) {
  return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */

var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].count(children) === 0;
};
/** @private is the given object/value a promise? */

var isPromise = function isPromise(value) {
  return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */

var isInputEvent = function isInputEvent(value) {
  return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */

function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
/**
 * Deeply get a value from an object via its path.
 */

function getIn(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }

  var path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_toPath__["a" /* default */])(key);

  while (obj && p < path.length) {
    obj = obj[path[p++]];
  } // check if path is not in the end


  if (p !== path.length && !obj) {
    return def;
  }

  return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */

function setIn(obj, path, value) {
  var res = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_clone__["a" /* default */])(obj); // this keeps inheritance when obj is a class

  var resVal = res;
  var i = 0;
  var pathArray = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_toPath__["a" /* default */])(path);

  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn(obj, pathArray.slice(0, i + 1));

    if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_clone__["a" /* default */])(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  } // Return original object if new value is the same as current


  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }

  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  } // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.


  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }

  return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */

function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }

  if (response === void 0) {
    response = {};
  }

  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var val = object[k];

    if (isObject(val)) {
      if (!visited.get(val)) {
        visited.set(val, true); // In order to keep array values consistent for both dot path  and
        // bracket syntax, we need to check if this is an array so that
        // this will output  { friends: [true] } and not { friends: { "0": true } }

        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }

  return response;
}

var FormikContext = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
  var formik = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(FormikContext);
  !!!formik ?  false ? invariant(false, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_tiny_warning__["a" /* default */])(false) : void 0;
  return formik;
}

function formikReducer(state, msg) {
  switch (msg.type) {
    case 'SET_VALUES':
      return _extends({}, state, {
        values: msg.payload
      });

    case 'SET_TOUCHED':
      return _extends({}, state, {
        touched: msg.payload
      });

    case 'SET_ERRORS':
      if (__WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default()(state.errors, msg.payload)) {
        return state;
      }

      return _extends({}, state, {
        errors: msg.payload
      });

    case 'SET_STATUS':
      return _extends({}, state, {
        status: msg.payload
      });

    case 'SET_ISSUBMITTING':
      return _extends({}, state, {
        isSubmitting: msg.payload
      });

    case 'SET_ISVALIDATING':
      return _extends({}, state, {
        isValidating: msg.payload
      });

    case 'SET_FIELD_VALUE':
      return _extends({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_TOUCHED':
      return _extends({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_ERROR':
      return _extends({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });

    case 'RESET_FORM':
      return _extends({}, state, msg.payload);

    case 'SET_FORMIK_STATE':
      return msg.payload(state);

    case 'SUBMIT_ATTEMPT':
      return _extends({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });

    case 'SUBMIT_FAILURE':
      return _extends({}, state, {
        isSubmitting: false
      });

    case 'SUBMIT_SUCCESS':
      return _extends({}, state, {
        isSubmitting: false
      });

    default:
      return state;
  }
} // Initial empty states // objects


var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange,
      validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange,
      _ref$validateOnBlur = _ref.validateOnBlur,
      validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur,
      _ref$validateOnMount = _ref.validateOnMount,
      validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount,
      isInitialValid = _ref.isInitialValid,
      _ref$enableReinitiali = _ref.enableReinitialize,
      enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali,
      onSubmit = _ref.onSubmit,
      rest = _objectWithoutPropertiesLoose(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);

  var props = _extends({
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onSubmit: onSubmit
  }, rest);

  var initialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(props.initialValues);
  var initialErrors = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(props.initialErrors || emptyErrors);
  var initialTouched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(props.initialTouched || emptyTouched);
  var initialStatus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(props.initialStatus);
  var isMounted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  var fieldRegistry = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({});

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      !(typeof isInitialValid === 'undefined') ? process.env.NODE_ENV !== "production" ? invariant(false, 'isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.') : invariant(false) : void 0; // eslint-disable-next-line
    }, []);
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);

  var _React$useReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(formikReducer, {
    values: props.initialValues,
    errors: props.initialErrors || emptyErrors,
    touched: props.initialTouched || emptyTouched,
    status: props.initialStatus,
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  }),
      state = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var runValidateHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (values, field) {
    return new Promise(function (resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);

      if (maybePromisedErrors == null) {
        // use loose null check here on purpose
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function (errors) {
          resolve(errors || emptyErrors);
        }, function (actualException) {
          if (false) {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", actualException);
          }

          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  /**
   * Run validation against a Yup schema and optionally run a function if successful
   */

  var runValidationSchema = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (values, field) {
    var validationSchema = props.validationSchema;
    var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function (resolve, reject) {
      promise.then(function () {
        resolve(emptyErrors);
      }, function (err) {
        // Yup will throw a validation error if validation fails. We catch those and
        // resolve them into Formik errors. We can sniff if something is a Yup error
        // by checking error.name.
        // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
        if (err.name === 'ValidationError') {
          resolve(yupToFormErrors(err));
        } else {
          // We throw any other errors
          if (false) {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", err);
          }

          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (field, value) {
    return new Promise(function (resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function (f) {
      return isFunction(fieldRegistry.current[f].validate);
    }); // Construct an array with all of the field validation functions

    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return runSingleFieldLevelValidation(f, getIn(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')]; // use special case ;)

    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }

        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }

        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]); // Run all validations and return the result

  var runAllValidations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function (_ref2) {
      var fieldErrors = _ref2[0],
          schemaErrors = _ref2[1],
          validateErrors = _ref2[2];
      var combinedErrors = __WEBPACK_IMPORTED_MODULE_2_deepmerge__["a" /* default */].all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge: arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]); // Run all validations methods and update state accordingly

  var validateFormWithHighPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }

    dispatch({
      type: 'SET_ISVALIDATING',
      payload: true
    });
    return runAllValidations(values).then(function (combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
        dispatch({
          type: 'SET_ERRORS',
          payload: combinedErrors
        });
      }

      return combinedErrors;
    });
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (validateOnMount && isMounted.current === true && __WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default()(initialValues.current, props.initialValues)) {
      validateFormWithHighPriority(initialValues.current);
    }
  }, [validateOnMount, validateFormWithHighPriority]);
  var resetForm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;

    var dispatchFn = function dispatchFn() {
      dispatch({
        type: 'RESET_FORM',
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors: errors,
          touched: touched,
          status: status,
          values: values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
        }
      });
    };

    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);

      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (isMounted.current === true && !__WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default()(initialValues.current, props.initialValues)) {
      if (enableReinitialize) {
        initialValues.current = props.initialValues;
        resetForm();

        if (validateOnMount) {
          validateFormWithHighPriority(initialValues.current);
        }
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithHighPriority]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !__WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default()(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: 'SET_ERRORS',
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !__WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default()(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: 'SET_TOUCHED',
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !__WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default()(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: 'SET_STATUS',
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function (name) {
    // This will efficiently validate a single field by avoiding state
    // changes if the validation function is synchronous. It's different from
    // what is called when using validateForm.
    if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
      var value = getIn(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);

      if (isPromise(maybePromise)) {
        // Only flip isValidating if the function is async.
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: true
        });
        return maybePromise.then(function (x) {
          return x;
        }).then(function (error) {
          dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: 'SET_ISVALIDATING',
            payload: false
          });
        });
      } else {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: 'SET_ISVALIDATING',
        payload: true
      });
      return runValidationSchema(state.values, name).then(function (x) {
        return x;
      }).then(function (error) {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: getIn(error, name)
          }
        });
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
      });
    }

    return Promise.resolve();
  });
  var registerField = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate: validate
    };
  }, []);
  var unregisterField = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function (touched, shouldValidate) {
    dispatch({
      type: 'SET_TOUCHED',
      payload: touched
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var setErrors = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (errors) {
    dispatch({
      type: 'SET_ERRORS',
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function (values, shouldValidate) {
    var resolvedValues = isFunction(values) ? values(state.values) : values;
    dispatch({
      type: 'SET_VALUES',
      payload: resolvedValues
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
  });
  var setFieldError = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (field, value) {
    dispatch({
      type: 'SET_FIELD_ERROR',
      payload: {
        field: field,
        value: value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function (field, value, shouldValidate) {
    dispatch({
      type: 'SET_FIELD_VALUE',
      payload: {
        field: field,
        value: value
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
  });
  var executeChange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (eventOrTextValue, maybePath) {
    // By default, assume that the first argument is a string. This allows us to use
    // handleChange with React Native and React Native Web's onChangeText prop which
    // provides just the value of the input.
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
    // so we handle like we would a normal HTML change event.

    if (!isString(eventOrTextValue)) {
      // If we can, persist the event
      // @see https://reactjs.org/docs/events.html#event-pooling
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }

      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type,
          name = target.name,
          id = target.id,
          value = target.value,
          checked = target.checked,
          outerHTML = target.outerHTML,
          options = target.options,
          multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;

      if (!field && "production" !== "production") {
        warnAboutMissingIdentifier({
          htmlContent: outerHTML,
          documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
          handlerName: 'handleChange'
        });
      }

      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
      ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
      ? getSelectedValues(options) : value;
    }

    if (field) {
      // Set form fields by name
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function (eventOrPath) {
    if (isString(eventOrPath)) {
      return function (event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function (field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }

    dispatch({
      type: 'SET_FIELD_TOUCHED',
      payload: {
        field: field,
        value: touched
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var executeBlur = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e, path) {
    if (e.persist) {
      e.persist();
    }

    var _e$target = e.target,
        name = _e$target.name,
        id = _e$target.id,
        outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;

    if (!field && "production" !== "production") {
      warnAboutMissingIdentifier({
        htmlContent: outerHTML,
        documentationAnchorLink: 'handleblur-e-any--void',
        handlerName: 'handleBlur'
      });
    }

    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function (eventOrString) {
    if (isString(eventOrString)) {
      return function (event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (stateOrCb) {
    if (isFunction(stateOrCb)) {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (status) {
    dispatch({
      type: 'SET_STATUS',
      payload: status
    });
  }, []);
  var setSubmitting = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (isSubmitting) {
    dispatch({
      type: 'SET_ISSUBMITTING',
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function () {
    dispatch({
      type: 'SUBMIT_ATTEMPT'
    });
    return validateFormWithHighPriority().then(function (combinedErrors) {
      // In case an error was thrown and passed to the resolved Promise,
      // `combinedErrors` can be an instance of an Error. We need to check
      // that and abort the submit.
      // If we don't do that, calling `Object.keys(new Error())` yields an
      // empty array, which causes the validation to pass and the form
      // to be submitted.
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;

      if (isActuallyValid) {
        // Proceed with submit...
        //
        // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
        // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
        // This would be fine in simple cases, but make it impossible to disable submit
        // buttons where people use callbacks or promises as side effects (which is basically
        // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
        //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
        // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
        // cleanup of isSubmitting on behalf of the consumer.
        var promiseOrUndefined;

        try {
          promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
          // via setSubmitting(false)

          if (promiseOrUndefined === undefined) {
            return;
          }
        } catch (error) {
          throw error;
        }

        return Promise.resolve(promiseOrUndefined).then(function (result) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_SUCCESS'
            });
          }

          return result;
        })["catch"](function (_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_FAILURE'
            }); // This is a legit error rejected by the onSubmit fn
            // so we don't want to break the promise chain

            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        // ^^^ Make sure Formik is still mounted before updating state
        dispatch({
          type: 'SUBMIT_FAILURE'
        }); // throw combinedErrors;

        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }

      return;
    });
  });
  var handleSubmit = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    } // Warn if form submission is triggered by a <button> without a
    // specified `type` attribute during development. This mitigates
    // a common gotcha in forms with both reset and submit buttons,
    // where the dev forgets to add type="button" to the reset button.


    if (false) {
      // Safely get the active element (works with IE)
      var activeElement = getActiveElement();

      if (activeElement !== null && activeElement instanceof HTMLButtonElement) {
        !(activeElement.attributes && activeElement.attributes.getNamedItem('type')) ? process.env.NODE_ENV !== "production" ? invariant(false, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : invariant(false) : void 0;
      }
    }

    submitForm()["catch"](function (reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm: resetForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    setErrors: setErrors,
    setFieldError: setFieldError,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    setFormikState: setFormikState,
    submitForm: submitForm
  };
  var executeSubmit = useEventCallback(function () {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    }

    resetForm();
  });
  var getFieldMeta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name) {
    return {
      value: getIn(state.values, name),
      error: getIn(state.errors, name),
      touched: !!getIn(state.touched, name),
      initialValue: getIn(initialValues.current, name),
      initialTouched: !!getIn(initialTouched.current, name),
      initialError: getIn(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (nameOrOptions) {
    var isAnObject = isObject(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn(state.values, name);
    var field = {
      name: name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };

    if (isAnObject) {
      var type = nameOrOptions.type,
          valueProp = nameOrOptions.value,
          is = nameOrOptions.as,
          multiple = nameOrOptions.multiple;

      if (type === 'checkbox') {
        if (valueProp === undefined) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === 'radio') {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === 'select' && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }

    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return !__WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default()(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);

  var ctx = _extends({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    resetForm: resetForm,
    setErrors: setErrors,
    setFormikState: setFormikState,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    submitForm: submitForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    isValid: isValid,
    dirty: dirty,
    unregisterField: unregisterField,
    registerField: registerField,
    getFieldProps: getFieldProps,
    getFieldMeta: getFieldMeta,
    getFieldHelpers: getFieldHelpers,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  });

  return ctx;
}
function Formik(props) {
  var formikbag = useFormik(props);
  var component = props.component,
      children = props.children,
      render = props.render,
      innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useImperativeHandle"])(innerRef, function () {
    return formikbag;
  });

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      !!props.render ? process.env.NODE_ENV !== "production" ? invariant(false, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : invariant(false) : void 0; // eslint-disable-next-line
    }, []);
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(FormikProvider, {
    value: formikbag
  }, component ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, formikbag) : render ? render(formikbag) : children // children come last, always called
  ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children) : null : null);
}

function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent,
      documentationAnchorLink = _ref4.documentationAnchorLink,
      handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */


function yupToFormErrors(yupError) {
  var errors = {};

  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }

    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }

      var err = _ref5;

      if (!getIn(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }

  return errors;
}
/**
 * Validate a yup schema.
 */

function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }

  var normalizedValues = prepareDataForValidation(values);
  return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
    abortEarly: false,
    context: context || normalizedValues
  });
}
/**
 * Recursively prepare values.
 */

function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};

  for (var k in values) {
    if (Object.prototype.hasOwnProperty.call(values, k)) {
      var key = String(k);

      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function (value) {
          if (Array.isArray(value) === true || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__["a" /* default */])(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== '' ? value : undefined;
          }
        });
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__["a" /* default */])(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== '' ? values[key] : undefined;
      }
    }
  }

  return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */

function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function merge(e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_deepmerge__["a" /* default */])(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_deepmerge__["a" /* default */])(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}
/** Return multi select values based on an array of options */


function getSelectedValues(options) {
  return Array.from(options).filter(function (el) {
    return el.selected;
  }).map(function (el) {
    return el.value;
  });
}
/** Return the next value for a checkbox */


function getValueForCheckbox(currentValue, checked, valueProp) {
  // If the current value was a boolean, return a boolean
  if (typeof currentValue === 'boolean') {
    return Boolean(checked);
  } // If the currentValue was not a boolean we want to return an array


  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;

  if (!Array.isArray(currentValue)) {
    // eslint-disable-next-line eqeqeq
    if (!valueProp || valueProp == 'true' || valueProp == 'false') {
      return Boolean(checked);
    }
  } else {
    // If the current value is already an array, use it
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values


  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  } // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values


  if (!isValueInArray) {
    return currentArrayOfValues;
  } // If the checkbox was unchecked and the value is in the array, remove the value and return the array


  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85


var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

function useEventCallback(fn) {
  var ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(void 0, args);
  }, []);
}

function useField(propsOrFieldName) {
  var formik = useFormikContext();
  var getFieldProps = formik.getFieldProps,
      getFieldMeta = formik.getFieldMeta,
      getFieldHelpers = formik.getFieldHelpers,
      registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>

  var props = isAnObject ? propsOrFieldName : {
    name: propsOrFieldName
  };
  var fieldName = props.name,
      validateFn = props.validate;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (fieldName) {
      registerField(fieldName, {
        validate: validateFn
      });
    }

    return function () {
      if (fieldName) {
        unregisterField(fieldName);
      }
    };
  }, [registerField, unregisterField, fieldName, validateFn]);

  if (false) {
    !formik ? process.env.NODE_ENV !== "production" ? invariant(false, 'useField() / <Field /> must be used underneath a <Formik> component or withFormik() higher order component') : invariant(false) : void 0;
  }

  !fieldName ?  false ? invariant(false, 'Invalid field name. Either pass `useField` a string or an object containing a `name` key.') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_tiny_warning__["a" /* default */])(false) : void 0;
  var fieldHelpers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return getFieldHelpers(fieldName);
  }, [getFieldHelpers, fieldName]);
  return [getFieldProps(props), getFieldMeta(fieldName), fieldHelpers];
}
function Field(_ref) {
  var validate = _ref.validate,
      name = _ref.name,
      render = _ref.render,
      children = _ref.children,
      is = _ref.as,
      component = _ref.component,
      props = _objectWithoutPropertiesLoose(_ref, ["validate", "name", "render", "children", "as", "component"]);

  var _useFormikContext = useFormikContext(),
      formik = _objectWithoutPropertiesLoose(_useFormikContext, ["validate", "validationSchema"]);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      !!render ? process.env.NODE_ENV !== "production" ? invariant(false, "<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name=\"" + name + "\" render={({field, form}) => ...} /> with <Field name=\"" + name + "\">{({field, form, meta}) => ...}</Field>") : invariant(false) : void 0;
      !!(is && children && isFunction(children)) ? process.env.NODE_ENV !== "production" ? invariant(false, 'You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.') : invariant(false) : void 0;
      !!(component && children && isFunction(children)) ? process.env.NODE_ENV !== "production" ? invariant(false, 'You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.') : invariant(false) : void 0;
      !!(render && children && !isEmptyChildren(children)) ? process.env.NODE_ENV !== "production" ? invariant(false, 'You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored') : invariant(false) : void 0; // eslint-disable-next-line
    }, []);
  } // Register field and field-level validation with parent <Formik>


  var registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    registerField(name, {
      validate: validate
    });
    return function () {
      unregisterField(name);
    };
  }, [registerField, unregisterField, name, validate]);
  var field = formik.getFieldProps(_extends({
    name: name
  }, props));
  var meta = formik.getFieldMeta(name);
  var legacyBag = {
    field: field,
    form: formik
  };

  if (render) {
    return render(_extends({}, legacyBag, {
      meta: meta
    }));
  }

  if (isFunction(children)) {
    return children(_extends({}, legacyBag, {
      meta: meta
    }));
  }

  if (component) {
    // This behavior is backwards compat with earlier Formik 0.9 to 1.x
    if (typeof component === 'string') {
      var innerRef = props.innerRef,
          rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({
        ref: innerRef
      }, field, rest), children);
    } // We don't pass `meta` for backwards compat


    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({
      field: field,
      form: formik
    }, props), children);
  } // default to input here so we can check for both `as` and `children` above


  var asElement = is || 'input';

  if (typeof asElement === 'string') {
    var _innerRef = props.innerRef,
        _rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(asElement, _extends({
      ref: _innerRef
    }, field, _rest), children);
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(asElement, _extends({}, field, props), children);
}

var Form = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (props, ref) {
  // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
  // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
  var action = props.action,
      rest = _objectWithoutPropertiesLoose(props, ["action"]);

  var _action = action != null ? action : '#';

  var _useFormikContext = useFormikContext(),
      handleReset = _useFormikContext.handleReset,
      handleSubmit = _useFormikContext.handleSubmit;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("form", Object.assign({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form.displayName = 'Form';

/**
 * A public higher-order component to access the imperative API
 */

function withFormik(_ref) {
  var _ref$mapPropsToValues = _ref.mapPropsToValues,
      mapPropsToValues = _ref$mapPropsToValues === void 0 ? function (vanillaProps) {
    var val = {};

    for (var k in vanillaProps) {
      if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') {
        // @todo TypeScript fix
        val[k] = vanillaProps[k];
      }
    }

    return val;
  } : _ref$mapPropsToValues,
      config = _objectWithoutPropertiesLoose(_ref, ["mapPropsToValues"]);

  return function createFormik(Component$1) {
    var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
    /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */

    var C = /*#__PURE__*/function (_React$Component) {
      _inheritsLoose(C, _React$Component);

      function C() {
        var _this;

        _this = _React$Component.apply(this, arguments) || this;

        _this.validate = function (values) {
          return config.validate(values, _this.props);
        };

        _this.validationSchema = function () {
          return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
        };

        _this.handleSubmit = function (values, actions) {
          return config.handleSubmit(values, _extends({}, actions, {
            props: _this.props
          }));
        };
        /**
         * Just avoiding a render callback for perf here
         */


        _this.renderFormComponent = function (formikProps) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Component$1, Object.assign({}, _this.props, formikProps));
        };

        return _this;
      }

      var _proto = C.prototype;

      _proto.render = function render() {
        var _this$props = this.props,
            props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Formik, Object.assign({}, props, config, {
          validate: config.validate && this.validate,
          validationSchema: config.validationSchema && this.validationSchema,
          initialValues: mapPropsToValues(this.props),
          initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
          initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
          initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
          onSubmit: this.handleSubmit,
          children: this.renderFormComponent
        }));
      };

      return C;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    C.displayName = "WithFormik(" + componentDisplayName + ")";
    return __WEBPACK_IMPORTED_MODULE_7_hoist_non_react_statics___default()(C, Component$1 // cast type to ComponentClass (even if SFC)
    );
  };
}

/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */

function connect(Comp) {
  var C = function C(props) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(FormikConsumer, null, function (formik) {
      !!!formik ?  false ? invariant(false, "Formik context is undefined, please verify you are rendering <Form>, <Field>, <FastField>, <FieldArray>, or your custom context-using component as a child of a <Formik> component. Component name: " + Comp.name) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_tiny_warning__["a" /* default */])(false) : void 0;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Comp, Object.assign({}, props, {
        formik: formik
      }));
    });
  };

  var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
  // For example, <Field.WrappedComponent /> gets us <FieldInner/>

  C.WrappedComponent = Comp;
  C.displayName = "FormikConnect(" + componentDisplayName + ")";
  return __WEBPACK_IMPORTED_MODULE_7_hoist_non_react_statics___default()(C, Comp // cast type to ComponentClass (even if SFC)
  );
}

/**
 * Some array helpers!
 */

var move = function move(array, from, to) {
  var copy = copyArrayLike(array);
  var value = copy[from];
  copy.splice(from, 1);
  copy.splice(to, 0, value);
  return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
  var copy = copyArrayLike(arrayLike);
  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};
var insert = function insert(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy.splice(index, 0, value);
  return copy;
};
var replace = function replace(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy[index] = value;
  return copy;
};

var copyArrayLike = function copyArrayLike(arrayLike) {
  if (!arrayLike) {
    return [];
  } else if (Array.isArray(arrayLike)) {
    return [].concat(arrayLike);
  } else {
    var maxIndex = Object.keys(arrayLike).map(function (key) {
      return parseInt(key);
    }).reduce(function (max, el) {
      return el > max ? el : max;
    }, 0);
    return Array.from(_extends({}, arrayLike, {
      length: maxIndex + 1
    }));
  }
};

var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
  var fn = typeof alteration === 'function' ? alteration : defaultFunction;
  return function (data) {
    if (Array.isArray(data) || isObject(data)) {
      var clone = copyArrayLike(data);
      return fn(clone);
    } // This can be assumed to be a primitive, which
    // is a case for top level validation errors


    return data;
  };
};

var FieldArrayInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FieldArrayInner, _React$Component);

  function FieldArrayInner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.updateArrayField = function (fn, alterTouched, alterErrors) {
      var _this$props = _this.props,
          name = _this$props.name,
          setFormikState = _this$props.formik.setFormikState;
      setFormikState(function (prevState) {
        var updateErrors = createAlterationHandler(alterErrors, fn);
        var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
        // otherwise it causes an error with unshift.

        var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
        var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
        var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;

        if (isEmptyArray(fieldError)) {
          fieldError = undefined;
        }

        if (isEmptyArray(fieldTouched)) {
          fieldTouched = undefined;
        }

        return _extends({}, prevState, {
          values: values,
          errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
          touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
        });
      });
    };

    _this.push = function (value) {
      return _this.updateArrayField(function (arrayLike) {
        return [].concat(copyArrayLike(arrayLike), [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash_es_cloneDeep__["a" /* default */])(value)]);
      }, false, false);
    };

    _this.handlePush = function (value) {
      return function () {
        return _this.push(value);
      };
    };

    _this.swap = function (indexA, indexB) {
      return _this.updateArrayField(function (array) {
        return swap(array, indexA, indexB);
      }, true, true);
    };

    _this.handleSwap = function (indexA, indexB) {
      return function () {
        return _this.swap(indexA, indexB);
      };
    };

    _this.move = function (from, to) {
      return _this.updateArrayField(function (array) {
        return move(array, from, to);
      }, true, true);
    };

    _this.handleMove = function (from, to) {
      return function () {
        return _this.move(from, to);
      };
    };

    _this.insert = function (index, value) {
      return _this.updateArrayField(function (array) {
        return insert(array, index, value);
      }, function (array) {
        return insert(array, index, null);
      }, function (array) {
        return insert(array, index, null);
      });
    };

    _this.handleInsert = function (index, value) {
      return function () {
        return _this.insert(index, value);
      };
    };

    _this.replace = function (index, value) {
      return _this.updateArrayField(function (array) {
        return replace(array, index, value);
      }, false, false);
    };

    _this.handleReplace = function (index, value) {
      return function () {
        return _this.replace(index, value);
      };
    };

    _this.unshift = function (value) {
      var length = -1;

      _this.updateArrayField(function (array) {
        var arr = array ? [value].concat(array) : [value];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      });

      return length;
    };

    _this.handleUnshift = function (value) {
      return function () {
        return _this.unshift(value);
      };
    };

    _this.handleRemove = function (index) {
      return function () {
        return _this.remove(index);
      };
    };

    _this.handlePop = function () {
      return function () {
        return _this.pop();
      };
    }; // We need TypeScript generics on these, so we'll bind them in the constructor
    // @todo Fix TS 3.2.1


    _this.remove = _this.remove.bind(_assertThisInitialized(_this));
    _this.pop = _this.pop.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = FieldArrayInner.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.validateOnChange && this.props.formik.validateOnChange && !__WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default()(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) {
      this.props.formik.validateForm(this.props.formik.values);
    }
  };

  _proto.remove = function remove(index) {
    // We need to make sure we also remove relevant pieces of `touched` and `errors`
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var copy = array ? copyArrayLike(array) : [];

      if (!result) {
        result = copy[index];
      }

      if (isFunction(copy.splice)) {
        copy.splice(index, 1);
      } // if the array only includes undefined values we have to return an empty array


      return isFunction(copy.every) ? copy.every(function (v) {
        return v === undefined;
      }) ? [] : copy : copy;
    }, true, true);
    return result;
  };

  _proto.pop = function pop() {
    // Remove relevant pieces of `touched` and `errors` too!
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var tmp = array.slice();

      if (!result) {
        result = tmp && tmp.pop && tmp.pop();
      }

      return tmp;
    }, true, true);
    return result;
  };

  _proto.render = function render() {
    var arrayHelpers = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    };

    var _this$props2 = this.props,
        component = _this$props2.component,
        render = _this$props2.render,
        children = _this$props2.children,
        name = _this$props2.name,
        _this$props2$formik = _this$props2.formik,
        restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, ["validate", "validationSchema"]);

    var props = _extends({}, arrayHelpers, {
      form: restOfFormik,
      name: name
    });

    return component ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, props) : render ? render(props) : children // children come last, always called
    ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children) : null : null;
  };

  return FieldArrayInner;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FieldArrayInner.defaultProps = {
  validateOnChange: true
};
var FieldArray = /*#__PURE__*/connect(FieldArrayInner);

var ErrorMessageImpl = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorMessageImpl, _React$Component);

  function ErrorMessageImpl() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ErrorMessageImpl.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) {
      return true;
    } else {
      return false;
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        component = _this$props.component,
        formik = _this$props.formik,
        render = _this$props.render,
        children = _this$props.children,
        name = _this$props.name,
        rest = _objectWithoutPropertiesLoose(_this$props, ["component", "formik", "render", "children", "name"]);

    var touch = getIn(formik.touched, name);
    var error = getIn(formik.errors, name);
    return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, rest, error) : error : null;
  };

  return ErrorMessageImpl;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var ErrorMessage = /*#__PURE__*/connect(ErrorMessageImpl);

/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */

var FastFieldInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FastFieldInner, _React$Component);

  function FastFieldInner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var render = props.render,
        children = props.children,
        component = props.component,
        is = props.as,
        name = props.name;
    !!render ?  false ? invariant(false, "<FastField render> has been deprecated. Please use a child callback function instead: <FastField name={" + name + "}>{props => ...}</FastField> instead.") : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_tiny_warning__["a" /* default */])(false) : void 0;
    !!(component && render) ?  false ? invariant(false, 'You should not use <FastField component> and <FastField render> in the same <FastField> component; <FastField component> will be ignored') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_tiny_warning__["a" /* default */])(false) : void 0;
    !!(is && children && isFunction(children)) ?  false ? invariant(false, 'You should not use <FastField as> and <FastField children> as a function in the same <FastField> component; <FastField as> will be ignored.') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_tiny_warning__["a" /* default */])(false) : void 0;
    !!(component && children && isFunction(children)) ?  false ? invariant(false, 'You should not use <FastField component> and <FastField children> as a function in the same <FastField> component; <FastField component> will be ignored.') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_tiny_warning__["a" /* default */])(false) : void 0;
    !!(render && children && !isEmptyChildren(children)) ?  false ? invariant(false, 'You should not use <FastField render> and <FastField children> in the same <FastField> component; <FastField children> will be ignored') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_tiny_warning__["a" /* default */])(false) : void 0;
    return _this;
  }

  var _proto = FastFieldInner.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    if (this.props.shouldUpdate) {
      return this.props.shouldUpdate(props, this.props);
    } else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) {
      return true;
    } else {
      return false;
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    // Register the Field with the parent Formik. Parent will cycle through
    // registered Field's validate fns right prior to submit
    this.props.formik.registerField(this.props.name, {
      validate: this.props.validate
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.name !== prevProps.name) {
      this.props.formik.unregisterField(prevProps.name);
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }

    if (this.props.validate !== prevProps.validate) {
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.formik.unregisterField(this.props.name);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        name = _this$props.name,
        render = _this$props.render,
        is = _this$props.as,
        children = _this$props.children,
        component = _this$props.component,
        formik = _this$props.formik,
        props = _objectWithoutPropertiesLoose(_this$props, ["validate", "name", "render", "as", "children", "component", "shouldUpdate", "formik"]);

    var restOfFormik = _objectWithoutPropertiesLoose(formik, ["validate", "validationSchema"]);

    var field = formik.getFieldProps(_extends({
      name: name
    }, props));
    var meta = {
      value: getIn(formik.values, name),
      error: getIn(formik.errors, name),
      touched: !!getIn(formik.touched, name),
      initialValue: getIn(formik.initialValues, name),
      initialTouched: !!getIn(formik.initialTouched, name),
      initialError: getIn(formik.initialErrors, name)
    };
    var bag = {
      field: field,
      meta: meta,
      form: restOfFormik
    };

    if (render) {
      return render(bag);
    }

    if (isFunction(children)) {
      return children(bag);
    }

    if (component) {
      // This behavior is backwards compat with earlier Formik 0.9 to 1.x
      if (typeof component === 'string') {
        var innerRef = props.innerRef,
            rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({
          ref: innerRef
        }, field, rest), children);
      } // We don't pass `meta` for backwards compat


      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({
        field: field,
        form: formik
      }, props), children);
    } // default to input here so we can check for both `as` and `children` above


    var asElement = is || 'input';

    if (typeof asElement === 'string') {
      var _innerRef = props.innerRef,
          _rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(asElement, _extends({
        ref: _innerRef
      }, field, _rest), children);
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(asElement, _extends({}, field, props), children);
  };

  return FastFieldInner;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var FastField = /*#__PURE__*/connect(FastFieldInner);


//# sourceMappingURL=formik.esm.js.map


/***/ }),
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(162);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(919),
    baseAssignValue = __webpack_require__(920);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SafeAnchor__ = __webpack_require__(163);
















var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  componentClass: __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default.a,
  href: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  /**
   * Defines HTML button type attribute
   * @defaultValue 'button'
   */
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['button', 'reset', 'submit'])
};

var defaultProps = {
  active: false,
  block: false,
  disabled: false
};

var Button = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Button, _React$Component);

  function Button() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Button);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, elementProps.disabled && 'disabled')
    }));
  };

  Button.prototype.renderButton = function renderButton(_ref, className) {
    var componentClass = _ref.componentClass,
        elementProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['componentClass']);

    var Component = componentClass || 'button';

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, elementProps, {
      type: elementProps.type || 'button',
      className: className
    }));
  };

  Button.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        active = _props.active,
        block = _props.block,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'block', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {
      active: active
    }, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'block')] = block, _extends2));
    var fullClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes);

    if (elementProps.href) {
      return this.renderAnchor(elementProps, fullClassName);
    }

    return this.renderButton(elementProps, fullClassName);
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsClass */])('btn', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["b" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["b" /* Size */].XSMALL], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* bsStyles */])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* State */]), [__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].PRIMARY, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].LINK]), __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].DEFAULT, Button))));

/***/ }),
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createUncontrollable = __webpack_require__(3225);

var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mixin = {
  shouldComponentUpdate: function shouldComponentUpdate() {
    //let the forceUpdate trigger the update
    return !this._notifying;
  }
};

function set(component, propName, handler, value, args) {
  if (handler) {
    component._notifying = true;
    handler.call.apply(handler, [component, value].concat(args));
    component._notifying = false;
  }

  component._values[propName] = value;

  if (!component.unmounted) component.forceUpdate();
}

exports.default = (0, _createUncontrollable2.default)(mixin, set);
module.exports = exports['default'];

/***/ }),
/* 315 */,
/* 316 */,
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actionTypes__ = __webpack_require__(637);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = importLineItems;
/* harmony export (immutable) */ __webpack_exports__["e"] = searchBuyers;
/* harmony export (immutable) */ __webpack_exports__["d"] = searchCompanies;
/* harmony export (immutable) */ __webpack_exports__["b"] = show;
/* harmony export (immutable) */ __webpack_exports__["c"] = update;









function create(data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].consignments.create(data).then(function (resp) {
      var id = resp.data.id;
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"])({
        pathname: "/consignments/" + id
      }));
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function importLineItems(values) {
  return function (dispatch, getState) {
    var id = getState().consignmentDetail.getIn([__WEBPACK_IMPORTED_MODULE_6__Receiving_constants__["t" /* CONSIGNMENT */], __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ID */]]);
    var fileName = values.file.name;

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.upload(values.file.name).then(function (resp) {
      var _resp$data = resp.data,
          key = _resp$data.key,
          url = _resp$data.url;

      var formattedAttachment = {
        name: fileName,
        key: key
      };

      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].attachments.toS3(url, values.file).then(function () {
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].consignments.import(id, formattedAttachment).then(function () {
          show(id);
          __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].info("Processing", "Importing Consignment.");
          return __WEBPACK_IMPORTED_MODULE_2__lib_submission__["a" /* SUCCESS */];
        });
      }).catch(function (e) {
        return Promise.reject(e);
      });
    });
  };
}

function searchBuyers(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].users.search({ active: true, filter: filter, page: 1, limit: 10 }).then(function (resp) {
      return Promise.resolve(resp.data.results);
    });
  };
}

function searchCompanies(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].companies.search({
      filter: filter,
      status: [__WEBPACK_IMPORTED_MODULE_1__companies_constants__["c" /* ACTIVE */], __WEBPACK_IMPORTED_MODULE_1__companies_constants__["b" /* NO_BIZ */], __WEBPACK_IMPORTED_MODULE_1__companies_constants__["d" /* CREDIT_HOLD */]].join(","),
      sort: "name",
      reverse: false,
      page: 1,
      limit: 20
    }).then(function (resp) {
      return Promise.resolve(resp.data.results);
    });
  };
}

function show(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].consignments.show(id).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_7__actionTypes__["a" /* SET */],
        consignment: resp.data
      });
    });
  };
}

function update(data) {
  return function (dispatch, getState) {
    var id = getState().consignmentDetail.getIn(["consignment", "id"]);

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].consignments.update(id, data).then(function (_ref) {
      var consignment = _ref.data;

      dispatch({ type: __WEBPACK_IMPORTED_MODULE_7__actionTypes__["a" /* SET */], consignment: consignment });
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission__["a" /* SUCCESS */];
    });
  };
}

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createStore__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__);
/* unused harmony export incomingQuoteLineItemsPagination */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return expireLineItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return incomingQuotePagination; });







var incomingQuoteLineItemsPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "incomingQuotes/lineItems",
  stateLocator: function stateLocator(state) {
    return state.incomingQuotes.lineItems;
  },
  initialSettings: {
    pageSize: 15
  },
  fetch: function fetch(search) {
    var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__createStore__["a" /* default */])().getState().incomingQuoteDetail.getIn(["incomingQuote", __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ID */]]);
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].incomingQuotes.lineItems.search(id, search);
  }
});

var expireLineItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__["composables"])({
  listId: "incomingQuotes/lineItems"
}).expire;

var incomingQuotePagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "incomingQuotes",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].incomingQuotes.search,
  stateLocator: function stateLocator(state) {
    return state.incomingQuotes.main;
  },
  forceDebounce: true
});

/* harmony default export */ __webpack_exports__["c"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux__["combineReducers"])({
  main: incomingQuotePagination.paginator,
  lineItems: incomingQuoteLineItemsPagination.paginator
}));

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_components_HoverFlag__ = __webpack_require__(209);
/* harmony export (immutable) */ __webpack_exports__["a"] = IncidentRelatedFlag;




function IncidentRelatedFlag(_ref) {
  var lineItem = _ref.lineItem;

  if (!lineItem.incident_related) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__parts_components_HoverFlag__["a" /* default */], { text: "Incident Related", abbr: "IR", inline: true });
}

IncidentRelatedFlag.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    incident_related: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })
};

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parts_components_HoverFlag__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_NoteTooltip_NoteTooltip__ = __webpack_require__(120);
/* harmony export (immutable) */ __webpack_exports__["a"] = LookingForFlags;






function LookingForFlags(_ref) {
  var lineItem = _ref.lineItem;

  if (lineItem.locked) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_NoteTooltip_NoteTooltip__["a" /* default */], {
      color: "white",
      note: "Locked By " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, "locked_audit.updated_by.full_name"),
      icon: "fa-lock"
    });
  }

  if (lineItem.looking_for) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__parts_components_HoverFlag__["a" /* default */], { text: __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* LOOKING_FOR */], abbr: "LF", inline: true });
  }

  return null;
}

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shipping_actions__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cable__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pagination__ = __webpack_require__(438);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return subscribe; });
/* unused harmony export set */
/* unused harmony export search */
/* unused harmony export setFilter */
/* unused harmony export stateLocator */
/* unused harmony export dashboardPageActions */
/* harmony export (immutable) */ __webpack_exports__["f"] = reloadShippingSilent;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetch;
/* harmony export (immutable) */ __webpack_exports__["b"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = toggleCheck;
/* harmony export (immutable) */ __webpack_exports__["d"] = unsubscribe;
/* unused harmony export onDisconnect */








function set(shipment) {
  return { type: __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* SET */], shipment: shipment };
}

var search = __WEBPACK_IMPORTED_MODULE_5__pagination__["a" /* shipmentsPagination */].search,
    setFilter = __WEBPACK_IMPORTED_MODULE_5__pagination__["a" /* shipmentsPagination */].setFilter,
    stateLocator = __WEBPACK_IMPORTED_MODULE_5__pagination__["a" /* shipmentsPagination */].stateLocator,
    dashboardPageActions = __WEBPACK_IMPORTED_MODULE_5__pagination__["a" /* shipmentsPagination */].pageActions;



function reloadShippingSilent() {
  return function (dispatch, getState) {
    var currentState = getState();
    var paginator = stateLocator(currentState);
    var filters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Shipping_actions__["b" /* buildFilters */])(paginator);

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].shipments.search(filters).then(function (_ref) {
      var data = _ref.data;

      dispatch(dashboardPageActions.resetResults(data.results));
    });
  };
}

function fetch(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].shipments.show(id).then(function (_ref2) {
      var data = _ref2.data;
      return dispatch(set(data));
    });
  };
}

function update(id, data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].shipments.update(id, data).then(function (resp) {
      dispatch(set(resp.data));
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function toggleCheck(shipment) {
  var serializedUser = JSON.parse(window.localStorage.getItem("user"));

  var data = {
    checked_by_full_name: serializedUser.full_name,
    checked_at: shipment.checked ? null : new Date(),
    checked: !shipment.checked,
    checked_by_id: shipment.checked ? null : serializedUser.id,
    updated_at: new Date(),
    updated_by: {
      id: serializedUser.id,
      name: serializedUser.full_name
    }
  };

  return dashboardPageActions.updateAsync(shipment.id, data, __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].shipments.toggleCheck(shipment.id));
}

var channel = null;

function unsubscribe() {
  return function () {
    if (channel) {
      channel.unsubscribe();
      channel = null;
    }
  };
}

function onDisconnect() {
  return unsubscribe();
}

function subscribe() {
  var _onReceive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reloadShippingSilent();

  return function (dispatch) {
    if (!channel) {
      var _createChannel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cable__["b" /* createChannel */])(),
          listen = _createChannel.listen;

      channel = listen("ShipmentsChannel", {
        onDisconnect: onDisconnect,
        onReceive: function onReceive(data) {
          if (["CREATE"].includes(data.action)) {
            dispatch(_onReceive(data));
          }
        }
      });
    }
  };
}

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withShipment__ = __webpack_require__(1516);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withShipment__["a"]; });



/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony export (immutable) */ __webpack_exports__["a"] = BuyerField;





function BuyerField(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? "Buyer" : _ref$label,
      _ref$name = _ref.name,
      name = _ref$name === undefined ? "buyer_id" : _ref$name,
      _ref$onItemSelected = _ref.onItemSelected,
      onItemSelected = _ref$onItemSelected === undefined ? function () {} : _ref$onItemSelected,
      _ref$required = _ref.required,
      required = _ref$required === undefined ? true : _ref$required,
      searchBuyers = _ref.searchBuyers,
      selectedBuyer = _ref.selectedBuyer;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
    name: name,
    disabled: disabled,
    label: label,
    placeholder: "Search by name...",
    component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["n" /* AutoCompleteField */],
    search: searchBuyers,
    selectedItem: selectedBuyer,
    onItemSelected: onItemSelected,
    formatItem: function formatItem(result) {
      return result && result.full_name;
    },
    required: required
  });
}

BuyerField.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onItemSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CoBuyerField__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThirdBuyerField__ = __webpack_require__(1572);
/* unused harmony export createBuyersContext */








var createBuyersContext = function createBuyersContext(selectedCoBuyer, selectedThirdBuyer, toggleBuyer) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({
    selectedCoBuyer: selectedCoBuyer,
    selectedThirdBuyer: selectedThirdBuyer,
    toggleBuyer: toggleBuyer
  });
};

function CoBuyersFields(_ref) {
  var buyerCreditPct = _ref.buyerCreditPct,
      _ref$colSize = _ref.colSize,
      colSize = _ref$colSize === undefined ? 6 : _ref$colSize,
      disabled = _ref.disabled,
      numberOfBuyers = _ref.numberOfBuyers,
      searchBuyers = _ref.searchBuyers,
      selectedCoBuyer = _ref.selectedCoBuyer,
      selectedThirdBuyer = _ref.selectedThirdBuyer,
      toggleBuyer = _ref.toggleBuyer;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
    { md: colSize },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CoBuyerField__["a" /* default */], {
      buyerCreditPct: buyerCreditPct,
      searchBuyers: searchBuyers,
      selectedCoBuyer: selectedCoBuyer,
      selectedThirdBuyer: selectedThirdBuyer,
      disabled: disabled,
      numberOfBuyers: numberOfBuyers,
      toggleBuyer: toggleBuyer
    })
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
    { md: colSize },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ThirdBuyerField__["a" /* default */], {
      buyerCreditPct: buyerCreditPct,
      disabled: disabled,
      numberOfBuyers: numberOfBuyers,
      searchBuyers: searchBuyers,
      selectedCoBuyer: selectedCoBuyer,
      selectedThirdBuyer: selectedThirdBuyer,
      toggleBuyer: toggleBuyer
    })
  )];
}

CoBuyersFields.propTypes = {
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  numberOfBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedCoBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  selectedThirdBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* searchBuyers */](filter));
    }
  };
})(CoBuyersFields));

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExchangeIcon; });





var ExchangeIcon = function ExchangeIcon(_ref) {
  var lineItem = _ref.lineItem;

  var exchangeTypes = [{ key: __WEBPACK_IMPORTED_MODULE_0__SalesOrders_constants__["q" /* EXCHANGE_TYPE */], value: null, text: 1 }, { key: __WEBPACK_IMPORTED_MODULE_0__SalesOrders_constants__["e" /* FLAT_EXCHANGE */], value: true, text: "F" }, { key: __WEBPACK_IMPORTED_MODULE_0__SalesOrders_constants__["q" /* EXCHANGE_TYPE */], value: __WEBPACK_IMPORTED_MODULE_0__SalesOrders_constants__["l" /* SECOND_EXCHANGE */], text: 2 }, { key: __WEBPACK_IMPORTED_MODULE_0__SalesOrders_constants__["q" /* EXCHANGE_TYPE */], value: __WEBPACK_IMPORTED_MODULE_0__SalesOrders_constants__["m" /* THIRD_EXCHANGE */], text: 3 }, { key: __WEBPACK_IMPORTED_MODULE_0__SalesOrders_constants__["r" /* OUTRIGHT */], value: true, text: "O" }, { key: __WEBPACK_IMPORTED_MODULE_1__inventories_constants__["_38" /* INTERNAL_OUTRIGHT */], value: true, text: "io" }];

  var filteredVal = exchangeTypes.filter(function (f) {
    return lineItem[f.key] === f.value && lineItem.purchase_for_exchange;
  });

  if (filteredVal.length === 0) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    "span",
    { className: "fa-stack fa-1x" },
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", { className: "fa fa-lg fa-circle text-success" }),
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      "span",
      { className: "fa fa-stack-1x exchange-circle-text" },
      filteredVal[filteredVal.length - 1].text
    )
  );
};

ExchangeIcon.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({ purchase_for_exchange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, exchange_type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string })
};

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__decorators__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_ExternalLink_ExternalLink__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Form__ = __webpack_require__(1590);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PDF_TYPES; });
/* unused harmony export PrintRma */











var PDF_TYPES = {
  damage: {
    label: "RMA Request for Damage"
  },
  discrepancy: {
    label: "RMA Request for Discrepancy"
  },
  insufficient_trace: {
    label: "RMA Request for Insufficient Trace"
  },
  ber: {
    label: "RMA Request for BER"
  },
  credit: {
    label: "RMA Request for Credit"
  },
  warranty: {
    label: "RMA Request for Warranty Consideration"
  },
  credit_warranty: {
    label: "RMA Request for Credit and Warranty Consideration"
  }
};

function PrintRma(_ref) {
  var pdfType = _ref.pdfType,
      rma = _ref.rma;

  var initialValues = { rma_discrepancy: rma.get("rma_discrepancy") };
  var url = rma.get("type") === "CustomerRma" ? __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* API_BASE */] + "/customer_rmas/" + rma.get("id") + "/download_customer_rma_request_form?type=" + pdfType : __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* API_BASE */] + "/vendor_rmas/" + rma.get("id") + "/download_vendor_rma_request_form?type=" + pdfType;

  if (pdfType === "discrepancy") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_containers__["a" /* ToggleSwitch */],
      null,
      function (visible, open, close) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__shared_components__["l" /* DropDownItem */],
          { onClick: open },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: "file-text-o", fixed: true }),
          "\xA0Download ",
          PDF_TYPES[pdfType].label,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__shared_components__["C" /* Modal */],
            { open: visible, close: close, dialogClass: "modal-lg" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["b" /* Header */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["c" /* Close */], { close: close }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                { className: "modal-title" },
                "Enter Discrepancy Information"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Form__["a" /* default */], { close: close, initialValues: initialValues, url: url })
          )
        );
      }
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "li",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components_ExternalLink_ExternalLink__["a" /* default */],
      { url: url },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: "file-text-o", fixed: true }),
      "\xA0Download ",
      PDF_TYPES[pdfType].label
    )
  );
}

PrintRma.propTypes = {
  pdfType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

var isVendorRma = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var rma = _ref2.rma;
  return rma.get("type") === "VendorRma" || rma.get("type") === "CustomerRma";
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__decorators__["a" /* withRma */])(isVendorRma(PrintRma)));

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return receivingDashboardOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return virtualReceivingDashboardOrders; });



var receivingDashboardOrders = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "receivingDashboardOrders",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].orders.search,
  initialSettings: {
    filters: {
      virtual_receiving: false
    }
  }
});

var virtualReceivingDashboardOrders = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "virtualReceivingDashboardOrders",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].orders.search,
  initialSettings: {
    filters: {
      virtual_receiving: true
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdditionalDetails__ = __webpack_require__(719);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AdditionalDetails__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validate__ = __webpack_require__(188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__validate__["c"]; });





/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(70);
/* harmony export (immutable) */ __webpack_exports__["a"] = withSalesOrder;



function withSalesOrder(Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
    return {
      salesOrder: state.salesOrderDetail.get("salesOrder")
    };
  }, {
    updateSalesOrder: __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* update */],
    refresh: __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* fetch */],
    expireLineItems: __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* expireLineItems */],
    cancel: __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* cancel */],
    reverseCancellation: __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* soCancellationReversal */]
  })(Component);
}

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createStore__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return salesOrdersPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reservedForSaleInventory; });
/* unused harmony export salesOrderLineItemsPagination */






var salesOrdersPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["a" /* createPaginatedList */])({
  listId: "salesOrders/search",
  fetch: __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].salesOrders.search,
  stateLocator: function stateLocator(state) {
    return state.salesOrders.search;
  },
  initialSettings: {
    sort: "created_at",
    sortReverse: true
  }
});

var reservedForSaleInventory = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["a" /* createPaginatedList */])({
  listId: "reservedForSaleInventory",
  fetch: __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].inventories.searchReservedForSale
});

var salesOrderLineItemsPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["a" /* createPaginatedList */])({
  listId: "salesOrders/lineItems",
  stateLocator: function stateLocator(state) {
    return state.salesOrders.lineItems;
  },
  initialSettings: {
    pageSize: 15,
    sort: "cancelled",
    sortReverse: true
  },
  fetch: function fetch(search) {
    var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__createStore__["a" /* default */])().getState().salesOrderDetail.getIn(["salesOrder", __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ID */]]);
    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].salesOrders.lineItems.search(id, search);
  }
});

/* harmony default export */ __webpack_exports__["c"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  search: salesOrdersPagination.paginator,
  lineItems: salesOrderLineItemsPagination.paginator
}));

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_RestrictedContactWarning__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SearchCompanyField__ = __webpack_require__(332);
/* unused harmony export SearchCompany */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

















function SearchCompany(props) {
  var allowPortalPurchase = props.allowPortalPurchase,
      contact = props.contact,
      contacts = props.contacts,
      fetchContacts = props.fetchContacts,
      getFieldValue = props.getFieldValue,
      onCompanySelected = props.onCompanySelected,
      selectedCompany = props.selectedCompany,
      companySearch = props.companySearch,
      handleEmail = props.handleEmail,
      _props$type = props.type,
      type = _props$type === undefined ? "default" : _props$type,
      _props$disabledFields = props.disabledFields,
      disabledFields = _props$disabledFields === undefined ? {} : _props$disabledFields;

  var addContact = contact === "Add";
  var portalPurchase = contact === __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */];
  var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers__["b" /* contactSelectList */])(contacts, allowPortalPurchase);

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedContact = _useState2[0],
      setSelectedContact = _useState2[1];

  var handleCompanySelected = function handleCompanySelected(result) {
    onCompanySelected(result);
    fetchContacts(result.id);
  };

  var findContactEmail = function findContactEmail(e) {
    var contactEmail = contacts.find(function (x) {
      return x.id === Number(e.target.value);
    });
    if (contactEmail && handleEmail) {
      handleEmail(contactEmail.email);
    }
  };

  var newEmail = function newEmail(e) {
    if (handleEmail) {
      handleEmail(e.target.value);
    }
  };

  var contactName = contact === "Add" && getFieldValue([__WEBPACK_IMPORTED_MODULE_11__constants__["g" /* CONTACT */], __WEBPACK_IMPORTED_MODULE_4__constants__["S" /* NAME */]].join(".")) ? getFieldValue([__WEBPACK_IMPORTED_MODULE_11__constants__["g" /* CONTACT */], __WEBPACK_IMPORTED_MODULE_4__constants__["S" /* NAME */]].join(".")) : selectedContact && selectedContact.name;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], {
          autoFocus: true,
          names: [__WEBPACK_IMPORTED_MODULE_4__constants__["N" /* COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["O" /* CONTACT_ID */]],
          component: __WEBPACK_IMPORTED_MODULE_14__SearchCompanyField__["a" /* default */],
          companySearch: companySearch,
          onResultSelected: handleCompanySelected,
          selectedCompany: selectedCompany,
          placeholder: "Search by typing a company's name or code",
          type: type,
          required: true,
          disabled: disabledFields.company_id
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_4__constants__["O" /* CONTACT_ID */],
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
            options: options,
            label: "Contact",
            onChange: function onChange(e) {
              props.clearNewContact && props.clearNewContact();
              findContactEmail(e);
              setSelectedContact(e.target.value);
            },
            required: true,
            disabled: disabledFields.contact_id
          })
        )
      )
    ),
    portalPurchase && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
            disabled: selectedCompany && selectedCompany.website,
            name: "company.website",
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__constants__["e" /* WEBSITE */]),
            required: true
          })
        )
      )
    ),
    addContact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: "contact.name",
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
            label: "Contact Name",
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: "contact.email",
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
            label: "Contact Email",
            onChange: newEmail,
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["p" /* PhoneNumberField */], {
          name: "contact.phone1",
          component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
          label: "Phone Number 1",
          type: "tel"
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_RestrictedContactWarning__["a" /* default */], { contact: contactName })
      )
    )
  );
}

SearchCompany.propTypes = {
  allowPortalPurchase: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  contact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fetchContacts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onCompanySelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  contacts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
  companySearch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  handleEmail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledFields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

var selector = function selector(form) {
  for (var _len = arguments.length, other = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    other[_key - 1] = arguments[_key];
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(form).apply(undefined, other);
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state, ownProps) {
  return {
    contact: selector(ownProps.formName, state, __WEBPACK_IMPORTED_MODULE_4__constants__["O" /* CONTACT_ID */])
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(SearchCompany)));

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchCompanyName__ = __webpack_require__(2036);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SearchCompanyField = function (_React$Component) {
  _inherits(SearchCompanyField, _React$Component);

  function SearchCompanyField(props) {
    _classCallCheck(this, SearchCompanyField);

    var _this = _possibleConstructorReturn(this, (SearchCompanyField.__proto__ || Object.getPrototypeOf(SearchCompanyField)).call(this));

    _this.onChange = function () {
      _this.props.company_id.input.onChange(null);
      _this.props.contact_id.input.onChange(null);
    };

    _this.onSelect = function (result, value) {
      var _this$props = _this.props,
          company_id = _this$props.company_id,
          contact_id = _this$props.contact_id,
          onResultSelected = _this$props.onResultSelected;


      var id = result ? result.id : null;
      company_id.input.onChange(id);
      company_id.input.onBlur(id);

      var val = result ? null : value;
      contact_id.input.onChange(val);
      contact_id.input.onBlur(val);

      _this.setState({ selected: result });

      if (result) onResultSelected(result);
    };

    _this.state = {
      selected: props.selectedCompany
    };
    return _this;
  }

  _createClass(SearchCompanyField, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SearchCompanyName__["a" /* default */], _extends({
        company: this.state.selected,
        onSelect: this.onSelect
      }, this.props));
    }
  }]);

  return SearchCompanyField;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (SearchCompanyField);


SearchCompanyField.propTypes = {
  company_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  contact_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  onResultSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(22);





function DoNotExchangeWarning(_ref) {
  var company = _ref.company;

  if (!company) return null;
  if (!company[__WEBPACK_IMPORTED_MODULE_3__constants__["k" /* DO_NOT_EXCHANGE */]]) return null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components__["n" /* Warning */],
    null,
    "This company is flagged with a do not exchange restriction."
  );
}

DoNotExchangeWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (DoNotExchangeWarning);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Detail_PurchaseOrders_Create_Create__ = __webpack_require__(336);
/* unused harmony export pageActions */
/* harmony export (immutable) */ __webpack_exports__["b"] = createIncomingQuote;
/* harmony export (immutable) */ __webpack_exports__["a"] = bulkCreateIncomingQuote;







var pageActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["composables"])({
  listId: "part/incomingQuoteLineItems"
});

function createIncomingQuote(data) {
  var afterCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  return function (dispatch, getState) {
    var partId = getState().partDetail.getIn([__WEBPACK_IMPORTED_MODULE_3__constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ID */]]);
    if (!partId) {
      partId = data.incoming_quote_line_item.part_id;
    }

    if (data.company && data.company.website && ![__WEBPACK_IMPORTED_MODULE_4__constants__["S" /* NAME */], __WEBPACK_IMPORTED_MODULE_4__constants__["T" /* EMAIL */]].some(function (f) {
      return data.contact && data.contact[f];
    })) {
      data.portal_purchase = true;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__components_Detail_PurchaseOrders_Create_Create__["a" /* modifyFormDataForContact */])(data);

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].parts.incomingQuotes.create(partId, data).then(function (resp) {
      afterCreate(resp.data, data.send_quote);
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function bulkCreateIncomingQuote(data) {
  return function (dispatch, getState) {
    var partId = getState().partDetail.getIn([__WEBPACK_IMPORTED_MODULE_3__constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ID */]]);
    if (!partId) {
      partId = data.incoming_quote_line_item.part_id;
    }

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].parts.incomingQuotes.bulkCreate(partId, data).then(function () {
      return __WEBPACK_IMPORTED_MODULE_1__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Subscription_withSubscription__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_LineItemStatusCell__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__HoverFlag__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OutgoingQuotes_shared_OutgoingQuoteNote__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_shared_LookingForFlags__ = __webpack_require__(320);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineItemsTable; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var LineItemsTable = function (_Component) {
  _inherits(LineItemsTable, _Component);

  function LineItemsTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LineItemsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LineItemsTable.__proto__ || Object.getPrototypeOf(LineItemsTable)).call.apply(_ref, [this].concat(args))), _this), _this.renderRow = function (lineItem, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__shared_components__["A" /* LinkedTableRow */],
        {
          disabled: _this.props.disableRowNav,
          to: "/outgoing-quotes/" + lineItem.quote_uuid,
          key: lineItem.id
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          {
            style: {
              backgroundColor: _this.props.inForm ? "#383838" : "#292929"
            }
          },
          i + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__shared_components_LineItemStatusCell__["a" /* default */],
          { lineItem: lineItem },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: lineItem.updated_tracked_fields_at && "text-yellow" },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["c" /* shortDateYY */])(lineItem.updated_tracked_fields_at || lineItem.created_at)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["w" /* CompanyName */], { flattenedCompany: lineItem, truncateAt: 18 })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          lineItem.created_by && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.created_by.full_name)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          __WEBPACK_IMPORTED_MODULE_9__OutgoingQuotes_constants__["c" /* OUTGOING_LINE_ITEMS */].quoteType[lineItem.quote_type].abbrev
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["g" /* monthYear */])(lineItem.tag_date)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          lineItem.condition && __WEBPACK_IMPORTED_MODULE_14__constants__["_27" /* CONDITIONS_WITH_SERVICEABLE */][lineItem.condition].abbrev
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          lineItem.quantity
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right padding-right-zero" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_shared_LookingForFlags__["a" /* LookingForFlags */], { lineItem: lineItem }),
          lineItem.no_interest && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__HoverFlag__["a" /* default */], { text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_9__OutgoingQuotes_constants__["r" /* NO_INTEREST */]), abbr: "NI", inline: true })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          {
            className: "text-center padding-horizontal-zero",
            style: { paddingLeft: 0, paddingRight: 0 }
          },
          lineItem.price_per_unit && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(lineItem.price_per_unit)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__OutgoingQuotes_shared_OutgoingQuoteNote__["a" /* default */], { lineItem: lineItem })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LineItemsTable, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          results = _props.results;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__shared_components__["s" /* DataTable */].Mini,
        { loading: loading, numbered: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__shared_components__["s" /* DataTable */].Head,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Date"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Customer"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Created By"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Type"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "Tag Date"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "CD"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "QTY"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-right" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "Price/Unit"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__shared_components__["s" /* DataTable */].Body,
          null,
          results.map(this.renderRow)
        )
      );
    }
  }]);

  return LineItemsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LineItemsTable.propTypes = {
  disableRowNav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    outgoing_quote_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    quote_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    company_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    price_per_unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    no_interest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    looking_for: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })).isRequired,
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
var withResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["n" /* miniTable */])(function (_ref2) {
  var match = _ref2.match,
      _ref2$pageSize = _ref2.pageSize,
      pageSize = _ref2$pageSize === undefined ? 5 : _ref2$pageSize;
  return __WEBPACK_IMPORTED_MODULE_12__api__["a" /* default */].parts.outgoingQuoteLineItems.search_grouped(match.params.id, {
    limit: pageSize
  });
});

/* harmony default export */ __webpack_exports__["b"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(withResults(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__Subscription_withSubscription__["a" /* default */])("OutgoingQuoteLineItem")(LineItemsTable))));

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PurchaseOrders_actionTypes__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CreateOrder__ = __webpack_require__(2184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CreateLineItem__ = __webpack_require__(2183);
/* harmony export (immutable) */ __webpack_exports__["b"] = Create;
/* harmony export (immutable) */ __webpack_exports__["a"] = modifyFormDataForContact;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();












function Create(_ref) {
  var close = _ref.close,
      part = _ref.part;

  var _useCreateOnSubmit = useCreateOnSubmit(),
      onSubmit = _useCreateOnSubmit.onSubmit,
      createdPurchaseOrder = _useCreateOnSubmit.createdPurchaseOrder;

  if (createdPurchaseOrder) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CreateLineItem__["a" /* default */], {
      close: close,
      part: part,
      purchaseOrder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(createdPurchaseOrder)
    });
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CreateOrder__["a" /* default */], { part: part, close: close, onSubmit: onSubmit });
}

Create.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

// Custom hooks
function useCreateOnSubmit() {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      createdPurchaseOrder = _useState2[0],
      setCreatedPurchaseOrder = _useState2[1];

  var onSubmit = function onSubmit(formData) {
    modifyFormDataForContact(formData);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].purchaseOrders.create(formData).then(function (resp) {
      var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__hooks__["b" /* useDispatch */])();
      setCreatedPurchaseOrder(resp.data);
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_7__PurchaseOrders_actionTypes__["a" /* SET */],
        purchaseOrder: resp.data
      });
    });
  };

  return {
    onSubmit: onSubmit,
    createdPurchaseOrder: createdPurchaseOrder
  };
}

function modifyFormDataForContact(formData) {
  if (formData.contact_id === __WEBPACK_IMPORTED_MODULE_4__constants__["F" /* ADD */]) {
    formData.contact_id = null;
    formData.portal_purchase = false;
  }

  if (formData.contact_id === __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */]) {
    formData.contact_id = null;
    formData.portal_purchase = true;
  }

  if (formData.contact_id) {
    formData.portal_purchase = false;
  }
}

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Subscription_withSubscription__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_SalesOrderLineItemStatusCell__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SalesOrders_helpers__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Table; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











 // <--- Added for brokeredSale only






var formatPrice = function formatPrice(value) {
  if (value >= 1000) {
    return "$" + Math.floor(value).toLocaleString();
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(value);
};

var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.renderRow = function (lineItem, i) {
      var brokeredSale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["get"])(lineItem, "inventory.brokered_sale", false);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__shared_components__["A" /* LinkedTableRow */],
        {
          key: i,
          to: "/sales-orders/" + lineItem.sales_order_uuid,
          cancelled: lineItem.cancelled || lineItem.credit_exchange
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          i + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__shared_components_SalesOrderLineItemStatusCell__["a" /* default */],
          {
            shipped: lineItem.shipped,
            cancelled: lineItem.cancelled
          },
          lineItem.after_hours && !lineItem.internal_outright && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["F" /* IconText */], { note: "After Hours", margin: "5px", icon: "fa-clock-o" }),
          lineItem.customer_rmas.filter(function (c) {
            return !c.cancelled;
          }).length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["F" /* IconText */], { note: "Cust. RMA", margin: "5px", icon: "fa-cog" }),
          lineItem.internal_outright && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["F" /* IconText */], { text: "io", note: "Internal Outright" }),
          brokeredSale && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["F" /* IconText */], {
            note: "Brokered",
            icon: "fa-bolt",
            margin: "5px",
            color: "#4787F8" // Force a lighter blue
            , iconSize: "fa-stack-1x"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["c" /* shortDateYY */])(lineItem.created_at)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["w" /* CompanyName */], { flattenedCompany: lineItem, truncateAt: 18 })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          lineItem.seller && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.seller.full_name)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          lineItem.serial_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          lineItem.condition && __WEBPACK_IMPORTED_MODULE_8__SalesOrders_constants__["h" /* CONDITIONS */][lineItem.condition].abbrev
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__SalesOrders_helpers__["a" /* ExchangeIcon */], { lineItem: lineItem })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          lineItem.quantity
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          lineItem.exchange_sale ? formatPrice(lineItem.exchange_fee) : formatPrice(lineItem.price_per_unit)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          (lineItem.internal_note || lineItem.external_note) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
            note: [lineItem.internal_note, lineItem.external_note].filter(function (n) {
              return n !== null && n !== "";
            }).join(" | "),
            className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()({ "link-muted": lineItem.cancelled })
          })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          results = _props.results;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__shared_components__["s" /* DataTable */].Mini,
        { loading: loading, numbered: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__shared_components__["s" /* DataTable */].Head,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Date"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Customer"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "SELLER"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "SN"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "CD"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Exch"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "QTY"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Price/Unit"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Note"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__shared_components__["s" /* DataTable */].Body,
          null,
          results.map(this.renderRow)
        )
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Table.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    created_at: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string }),
    buyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string }),
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })).isRequired,
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
var withResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["n" /* miniTable */])(function (_ref2, params) {
  var match = _ref2.match;
  return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* default */].parts.salesOrderLineItems.search(match.params.id, params);
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(withResults(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__Subscription_withSubscription__["a" /* default */])("SalesOrderLineItem")(Table))));

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REMOVE_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_ATTACHMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_ATTACHMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ADD_ATTACHMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_ATTACHMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REMOVE_ATTACHMENT; });
var GET_NOTES = "notes/GET";
var SET_NOTES = "notes/SET";
var ADD_NOTE = "notes/ADD";
var UPDATE_NOTE = "notes/EDIT";
var REMOVE_NOTE = "notes/REMOVE";

var GET_ATTACHMENTS = "attachments/GET";
var SET_ATTACHMENTS = "attachments/SET";
var ADD_ATTACHMENT = "attachments/ADD";
var UPDATE_ATTACHMENT = "attachments/EDIT";
var REMOVE_ATTACHMENT = "attachments/REMOVE";

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ClipboardCopy__ = __webpack_require__(2277);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ClipboardCopy__["a"]; });



/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(16);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var LineItemsForm = function (_Component) {
  _inherits(LineItemsForm, _Component);

  function LineItemsForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LineItemsForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LineItemsForm.__proto__ || Object.getPrototypeOf(LineItemsForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedLineItems: []
    }, _this.onItemSelected = function (lineItem) {
      if (lineItem.id === null) {
        return;
      }

      var selectedLineItems = _this.state.selectedLineItems;

      var array = [].concat(_toConsumableArray(selectedLineItems));
      var index = array.indexOf(lineItem);
      if (index !== -1) {
        array.splice(index, 1);
        _this.setState({ selectedLineItems: array });
      } else {
        _this.setState({
          selectedLineItems: selectedLineItems.concat([lineItem])
        });
      }
    }, _this.renderRow = function (lineItem, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: i },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: { backgroundColor: "#383838" } },
          i + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: { marginBottom: "6px" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            name: "line_items",
            type: "checkbox",
            onChange: function onChange() {
              return _this.onItemSelected(lineItem);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.part.part_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.serial_number
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LineItemsForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          close = _props.close,
          handleSubmit = _props.handleSubmit,
          addLineItems = _props.addLineItems,
          lineItems = _props.lineItems;
      var selectedLineItems = this.state.selectedLineItems;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "form",
        { onSubmit: handleSubmit },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__Modal__["e" /* Body */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "table",
            { className: "table table-striped table-hover table-numbered" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "thead",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Part Number"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Serial Number"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tbody",
              null,
              lineItems.map(function (inv, idx) {
                return _this2.renderRow(inv, idx);
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__Modal__["d" /* Footer */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            { type: "button", className: "btn btn-default", onClick: close },
            "Cancel"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            {
              type: "button",
              className: "btn btn-success",
              onClick: function onClick(e) {
                e.preventDefault();
                addLineItems(selectedLineItems);
              }
            },
            "Create Commercial Invoice"
          )
        )
      );
    }
  }]);

  return LineItemsForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LineItemsForm.propTypes = {
  lineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  addLineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (LineItemsForm);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Form__ = __webpack_require__(480);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Form__["a"]; });



/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmDelete__ = __webpack_require__(773);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ConfirmDelete__["a"]; });



/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CommercialInvoice_Form_FormSections_AddressFields__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CommercialInvoice_Form_FormSections_Contact__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ShippingSection_shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SalesOrders_components_shared_FormSections_ShippingSection_shippingTypes__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ShippingSection_ShipToOther__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__RestictedAddressWarning_RestrictedAddressWarning__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__SalesOrders_helpers__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__FinalDestinationWarning__ = __webpack_require__(782);
/* unused harmony export FinalDestinationFields */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























var FINAL_DESTINATION_ADDRESS = "final_destination_address";

var FinalDestinationFields = function (_React$Component) {
  _inherits(FinalDestinationFields, _React$Component);

  function FinalDestinationFields() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FinalDestinationFields);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FinalDestinationFields.__proto__ || Object.getPrototypeOf(FinalDestinationFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = { invalidCompany: false, sameAsAbove: false }, _this.setFinalDestination = function (setFieldValue, companyId, addressId, contactId) {
      __WEBPACK_IMPORTED_MODULE_13__api__["a" /* default */].companies.show(companyId, "all_associations").then(function (_ref2) {
        var _finalToCustomerTrans;

        var data = _ref2.data;

        var address = data.physical_addresses.filter(function (a) {
          return a.id === Number(addressId);
        })[0];

        setFieldValue(FINAL_DESTINATION_ADDRESS + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["x" /* COMPANY_NAME */])(data.name);
        if (address) {
          var _id = address.id,
              _coName = address.company_name,
              fields = _objectWithoutProperties(address, ["id", "company_name"]);

          Object.keys(fields).forEach(function (field) {
            return setFieldValue(FINAL_DESTINATION_ADDRESS + "." + field)(address[field]);
          });
        }

        var contact = data.contacts.filter(function (c) {
          return c.id === parseFloat(contactId);
        })[0];

        var finalToCustomerTranslation = (_finalToCustomerTrans = {
          name: __WEBPACK_IMPORTED_MODULE_10__constants__["S" /* NAME */]
        }, _defineProperty(_finalToCustomerTrans, __WEBPACK_IMPORTED_MODULE_10__constants__["R" /* PHONE */], __WEBPACK_IMPORTED_MODULE_10__constants__["_54" /* PHONE1 */]), _defineProperty(_finalToCustomerTrans, "email", __WEBPACK_IMPORTED_MODULE_10__constants__["T" /* EMAIL */]), _finalToCustomerTrans);

        if (contact) {
          var _fields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_pojos__["a" /* default */])(contact).pick(__WEBPACK_IMPORTED_MODULE_10__constants__["S" /* NAME */], __WEBPACK_IMPORTED_MODULE_10__constants__["_54" /* PHONE1 */], __WEBPACK_IMPORTED_MODULE_10__constants__["T" /* EMAIL */]);
          var phoneVal = _fields[__WEBPACK_IMPORTED_MODULE_10__constants__["_54" /* PHONE1 */]] || data.phone;

          Object.keys(finalToCustomerTranslation).forEach(function (field) {
            if (field === __WEBPACK_IMPORTED_MODULE_10__constants__["R" /* PHONE */]) {
              setFieldValue("final_destination_phone")(phoneVal);
            } else {
              setFieldValue("final_destination_" + field)(_fields[finalToCustomerTranslation[field]]);
            }
          });
        }
      });
    }, _this.setSameAsAbove = function (ev) {
      ev.preventDefault();
      var _this$props = _this.props,
          getField = _this$props.getField,
          setFieldValue = _this$props.setFieldValue;

      var shipToType = getField(__WEBPACK_IMPORTED_MODULE_10__constants__["q" /* SHIP_TO_TYPE */]);

      var sameAsAbove = _this.state.sameAsAbove;
      _this.setState({ sameAsAbove: !sameAsAbove });
      if (sameAsAbove) {
        __WEBPACK_IMPORTED_MODULE_10__constants__["_55" /* ADDRESS_FIELDS */].forEach(function (field) {
          return setFieldValue(FINAL_DESTINATION_ADDRESS + "." + field)("");
        });

        return;
      }

      if (shipToType === __WEBPACK_IMPORTED_MODULE_11__ShippingSection_shippingTypes__["b" /* CUSTOMER */]) {
        var companyId = getField(__WEBPACK_IMPORTED_MODULE_10__constants__["N" /* COMPANY_ID */]);
        var contactId = getField(__WEBPACK_IMPORTED_MODULE_10__constants__["O" /* CONTACT_ID */]);
        var addressId = getField(__WEBPACK_IMPORTED_MODULE_10__constants__["_2" /* SHIP_TO_CUSTOMER_ADDRESS_ID */]);

        if (companyId && addressId) {
          _this.setFinalDestination(setFieldValue, companyId, addressId, contactId);
        } else if (companyId && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_lodash__["isEmpty"])(getField([__WEBPACK_IMPORTED_MODULE_18__companies_constants__["l" /* PHYSICAL_ADDRESS */], __WEBPACK_IMPORTED_MODULE_10__constants__["s" /* LINE1 */]].join(".")))) {
          __WEBPACK_IMPORTED_MODULE_10__constants__["_55" /* ADDRESS_FIELDS */].forEach(function (f) {
            setFieldValue(FINAL_DESTINATION_ADDRESS + "." + f)(getField(__WEBPACK_IMPORTED_MODULE_18__companies_constants__["l" /* PHYSICAL_ADDRESS */] + "." + f));
          });
        }
      }

      if (shipToType === __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__["K" /* COMPANY */]) {
        var _companyId = getField(__WEBPACK_IMPORTED_MODULE_10__constants__["J" /* SHIP_TO_COMPANY_ID */]);
        var _addressId = getField(__WEBPACK_IMPORTED_MODULE_10__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */]);

        _this.setFinalDestination(setFieldValue, _companyId, _addressId);
      }

      if (shipToType === __WEBPACK_IMPORTED_MODULE_16__SalesOrders_components_shared_FormSections_ShippingSection_shippingTypes__["b" /* DROPSHIP */]) {
        __WEBPACK_IMPORTED_MODULE_10__constants__["_55" /* ADDRESS_FIELDS */].forEach(function (field) {
          return setFieldValue(FINAL_DESTINATION_ADDRESS + "." + field)(getField("ship_to_shipping_address." + field));
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FinalDestinationFields, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          getField = _props.getField,
          formName = _props.formName,
          showWarning = _props.showWarning;


      var finalDestinationCountry = getField(FINAL_DESTINATION_ADDRESS + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["r" /* COUNTRY */]);

      var addressFields = [__WEBPACK_IMPORTED_MODULE_10__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_10__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_10__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_10__constants__["w" /* POSTAL_CODE */], __WEBPACK_IMPORTED_MODULE_10__constants__["r" /* COUNTRY */]].reduce(function (final, f) {
        return _extends({}, final, _defineProperty({}, f, getField(FINAL_DESTINATION_ADDRESS + "." + f)));
      }, {});

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        this.shipToCountryIsInvalid && showWarning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__FinalDestinationWarning__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["m" /* DashedSeparator */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Final Destination",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            {
              style: { marginLeft: 10 },
              className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("btn btn-success btn-sm", {
                "btn-hollow": !this.state.sameAsAbove
              }),
              onClick: this.setSameAsAbove
            },
            "Same As Above"
          )
        ),
        getField(__WEBPACK_IMPORTED_MODULE_10__constants__["q" /* SHIP_TO_TYPE */]) === __WEBPACK_IMPORTED_MODULE_16__SalesOrders_components_shared_FormSections_ShippingSection_shippingTypes__["b" /* DROPSHIP */] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ShippingSection_ShipToOther__["a" /* default */], { section: FINAL_DESTINATION_ADDRESS }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CommercialInvoice_Form_FormSections_AddressFields__["a" /* default */], {
          path: FINAL_DESTINATION_ADDRESS,
          formName: formName,
          country: finalDestinationCountry,
          addCompanyName: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CommercialInvoice_Form_FormSections_Contact__["a" /* default */], { path: "final_destination" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: "final_destination_reference",
              label: "Ref#",
              component: __WEBPACK_IMPORTED_MODULE_7__Forms__["d" /* FormInput */]
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__RestictedAddressWarning_RestrictedAddressWarning__["a" /* default */], addressFields)
          )
        )
      );
    }
  }, {
    key: "shipToCountryIsInvalid",
    get: function get() {
      var _props2 = this.props,
          getField = _props2.getField,
          shippingToAddress = _props2.shippingToAddress;


      var fields = [__WEBPACK_IMPORTED_MODULE_10__constants__["q" /* SHIP_TO_TYPE */], "ship_to_shipping_address"];
      var values = fields.reduce(function (allValues, fieldName) {
        return _extends({}, allValues, _defineProperty({}, fieldName, getField(fieldName)));
      }, {});

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__SalesOrders_helpers__["h" /* shipToCountryIsNotUSA */])(values, shippingToAddress);
    }
  }]);

  return FinalDestinationFields;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FinalDestinationFields.propTypes = {
  formName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  showWarning: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getField: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  shippingToAddress: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    country: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  })
};

FinalDestinationFields.defaultProps = {
  getField: function getField() {
    return null;
  },
  shippingToAddress: {
    country: ""
  },
  showWarning: false
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function (state, props) {
  var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["formValueSelector"])(props.formName);

  return {
    getField: function getField(field) {
      return selector(state, field);
    }
  };
}, function (dispatch, props) {
  return {
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return props.change(field, val);
      };
    }
  };
})(FinalDestinationFields));

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Errors__ = __webpack_require__(487);
/* harmony export (immutable) */ __webpack_exports__["c"] = Cancel;
/* unused harmony export Submit */
/* harmony export (immutable) */ __webpack_exports__["b"] = AdditionalButtons;
/* unused harmony export DefaultControls */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







function Cancel(_ref) {
  var close = _ref.close,
      editable = _ref.editable;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    { type: "button", className: "btn btn-default", onClick: close },
    editable ? "Cancel" : "Close"
  );
}

Cancel.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  editable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function Submit(_ref2) {
  var disabled = _ref2.disabled,
      submitting = _ref2.submitting,
      submitTimeout = _ref2.submitTimeout,
      editable = _ref2.editable,
      onClick = _ref2.onClick,
      _ref2$text = _ref2.text,
      text = _ref2$text === undefined ? "Save" : _ref2$text,
      _ref2$submittingText = _ref2.submittingText,
      submittingText = _ref2$submittingText === undefined ? "Saving" : _ref2$submittingText;

  return editable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    {
      onClick: onClick,
      disabled: disabled || submitting || submitTimeout,
      type: "submit",
      className: "btn btn-primary"
    },
    submitting && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cog fa-spin fa-fw fa-lg" }),
    submitting ? " " + submittingText : text
  );
}

Submit.propTypes = {
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  editable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function AdditionalButtons(_ref3) {
  var children = _ref3.children;

  return children;
}

function DefaultControls(_ref4) {
  var disabled = _ref4.disabled,
      editable = _ref4.editable,
      errorMessages = _ref4.errorMessages,
      footer = _ref4.footer,
      submitting = _ref4.submitting,
      submitFailed = _ref4.submitFailed,
      submitSucceeded = _ref4.submitSucceeded,
      submitTimeout = _ref4.submitTimeout,
      close = _ref4.close,
      modal = _ref4.modal,
      buttonText = _ref4.buttonText;

  var errors = void 0;
  if (submitTimeout) {
    errors = ["The request timed out. Please refresh page and check to see if expected records were updated before resubmitting."];
  } else {
    errors = errorMessages;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__Modal__["d" /* Footer */],
    { style: modal ? {} : { paddingRight: 0 } },
    (submitFailed || submitTimeout) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Errors__["a" /* default */], { errors: errors }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Cancel, { close: close, editable: editable }),
    footer,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Submit, {
      disabled: disabled,
      submitting: submitting,
      submitSucceeded: submitSucceeded,
      submitTimeout: submitTimeout,
      editable: editable,
      text: buttonText
    })
  );
}

DefaultControls.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  errorMessages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  editable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  footer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  submitFailed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  submitSucceeded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  submitTimeout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref5;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref5 = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref5, [this].concat(args))), _this), _this.state = {
      submitTimeout: false
    }, _this.handleSubmitError = function (error) {
      if (error.code === "TIMEOUT") {
        _this.setState({ submitTimeout: true });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          close = _props.close,
          handleSubmit = _props.handleSubmit,
          modal = _props.modal;
      var submitTimeout = this.state.submitTimeout;

      var submit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_submission__["b" /* onSuccess */])(handleSubmit, close, this.props, this.handleSubmitError);
      var body = children[0] || children;
      var footer = children[1] || null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "form",
        { onSubmit: submit },
        modal ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__Modal__["e" /* Body */],
          null,
          body.props.children
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          body.props.children
        ),
        footer && footer.type !== AdditionalButtons && footer || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DefaultControls, _extends({}, this.props, {
          submitTimeout: submitTimeout,
          footer: footer
        }))
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element)]),
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  modal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Form.Body = __WEBPACK_IMPORTED_MODULE_3__Modal__["e" /* Body */];
Form.Footer = __WEBPACK_IMPORTED_MODULE_3__Modal__["d" /* Footer */];
Form.Cancel = Cancel;
Form.Submit = Submit;
Form.DefaultControls = DefaultControls;
Form.AdditionalButtons = AdditionalButtons;
/* harmony default export */ __webpack_exports__["a"] = (Form);


Form.defaultProps = {
  editable: true,
  modal: true
};

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NoteTooltip_NoteTooltip__ = __webpack_require__(120);
/* harmony export (immutable) */ __webpack_exports__["a"] = CheckGroup;





function CheckGroup(_ref) {
  var info = _ref.info,
      title = _ref.title,
      children = _ref.children,
      _ref$justified = _ref.justified,
      justified = _ref$justified === undefined ? false : _ref$justified,
      checkGroupStyles = _ref.checkGroupStyles;

  var groupClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn-group", {
    "btn-group-justified": justified
  });

  var infoIcon = info ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__NoteTooltip_NoteTooltip__["a" /* default */], {
    color: "rgba(255, 255, 255, 0.25)",
    icon: "fa-info-circle",
    note: info
  }) : null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group", style: checkGroupStyles },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { htmlFor: title },
      title,
      infoIcon
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: groupClasses, "data-toggle": "buttons" },
      children
    )
  );
}

CheckGroup.propTypes = {
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element)]),
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element)]),
  justified: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  checkGroupStyles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Check__ = __webpack_require__(783);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Check__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CheckGroup__ = __webpack_require__(345);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__CheckGroup__["a"]; });





/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(8);
/* harmony export (immutable) */ __webpack_exports__["a"] = CurrencyField;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var handleKeyPress = function handleKeyPress(event) {
  if (event.keyCode === 38 || event.keyCode === 40) {
    event.preventDefault();
  }
};

var defaultInputProps = {
  min: 0,
  step: "0.01",
  onKeyDown: handleKeyPress
};

function CurrencyField(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  var inputProps = props.inputProps,
      rest = _objectWithoutProperties(props, ["inputProps"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], _extends({
    type: "number",
    addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-dollar" }),
    className: "text-right",
    component: __WEBPACK_IMPORTED_MODULE_3____["h" /* NumberInput */],
    inputProps: Object.assign({}, defaultInputProps, inputProps)
  }, rest));
}

CurrencyField.defaultProps = {
  inputProps: {}
};

CurrencyField.propTypes = {
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony export (immutable) */ __webpack_exports__["a"] = MonthYearField;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var normalize = function normalize(value) {
  return value ? value + "-01" : "";
};
var format = function format(value) {
  return value ? value.slice(0, -3) : "";
};

function MonthYearField(props) {
  var rest = _objectWithoutProperties(props, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], _extends({ type: "month", normalize: normalize, format: format }, rest));
}

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = IconText;




function IconText(_ref) {
  var note = _ref.note,
      placement = _ref.placement,
      text = _ref.text,
      margin = _ref.margin,
      icon = _ref.icon,
      iconSize = _ref.iconSize,
      color = _ref.color;

  var tooltip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["b" /* Tooltip */],
    null,
    note
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* OverlayTrigger */],
    { placement: placement, overlay: tooltip },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      {
        className: "fa-stack fa-1x",
        style: { marginRight: margin, fontSize: "10px" }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa " + icon + " " + iconSize, style: { color: color } }),
      text && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "fa fa-stack-1x exchange-circle-text" },
        text
      )
    )
  );
}

IconText.defaultProps = {
  placement: "top",
  icon: "fa-circle",
  margin: "0",
  iconSize: "fa-stack-1x",
  color: "#000000"
};

IconText.propTypes = {
  placement: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  note: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  text: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  margin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  icon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  iconSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = LineItemQtyCell;




function LineItemQtyCell(_ref) {
  var lineItem = _ref.lineItem,
      hideTooltip = _ref.hideTooltip,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? "PO" : _ref$type;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    lineItem.purchase_status === "full" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["j" /* NoteTooltip */], {
      icon: "fa-check-square",
      placement: "top",
      note: type === "PO" ? "Full Purchase" : "Full Qty Purchase",
      color: "#4CAF50",
      hideTooltip: hideTooltip
    }),
    lineItem.purchase_status === "partial" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["j" /* NoteTooltip */], {
      icon: "fa-star-half-o",
      placement: "top",
      note: type === "PO" ? "Entire quantity not purchased from this vendor" : "Partial Purchase",
      color: "#FF9800",
      hideTooltip: hideTooltip
    })
  );
}

LineItemQtyCell.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  hideTooltip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LocationFlag__ = __webpack_require__(143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LocationFlag__["a"]; });



/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bootstrap__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_bootstrap__["g" /* Modal */].Body);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateNote__ = __webpack_require__(2361);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var NewNote = function (_React$Component) {
  _inherits(NewNote, _React$Component);

  function NewNote() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NewNote);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewNote.__proto__ || Object.getPrototypeOf(NewNote)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.close = function () {
      return _this.setState({ open: false });
    }, _this.open = function () {
      return _this.setState({ open: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NewNote, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          id = _props.id,
          resourceType = _props.resourceType,
          important = _props.important,
          _props$initialValues = _props.initialValues,
          initialValues = _props$initialValues === undefined ? {} : _props$initialValues,
          minor = _props.minor,
          trace = _props.trace,
          notesType = _props.notesType;
      var open = this.state.open;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          onClick: this.open,
          className: "btn btn-primary btn-hollow pull-right"
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
        "Add",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CreateNote__["a" /* default */], {
          close: this.close,
          open: open,
          resourceID: id,
          resourceType: resourceType,
          important: important,
          minor: minor,
          trace: trace,
          notesType: notesType,
          initialValues: initialValues
        })
      );
    }
  }]);

  return NewNote;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NewNote.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  important: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  initialValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  minor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  trace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  resourceType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  notesType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (NewNote);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony export (immutable) */ __webpack_exports__["a"] = DetailStat;




var headerStyles = {
  marginTop: 0,
  marginBottom: 0
};

var labelStyles = {
  fontSize: 13,
  fontStyle: "italic",
  marginBottom: 10
};

function DetailStat(_ref) {
  var label = _ref.label,
      value = _ref.value,
      offset = _ref.offset;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
    { md: 2, sm: 2, smOffset: offset, mdOffset: offset },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "text-center", style: { marginBottom: 0 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h2",
        { style: headerStyles },
        value
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        { className: "lead text-muted", style: labelStyles },
        label
      )
    )
  );
}

DetailStat.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ModalLauncher = function (_Component) {
  _inherits(ModalLauncher, _Component);

  function ModalLauncher() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ModalLauncher);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalLauncher.__proto__ || Object.getPrototypeOf(ModalLauncher)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.open = function () {
      return _this.setState({ open: true });
    }, _this.close = function () {
      if (_this.mounted) {
        _this.setState({ open: false });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ModalLauncher, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "button",
    value: function button() {
      var _props = this.props,
          disabled = _props.disabled,
          modal = _props.modal,
          buttonClass = _props.buttonClass,
          buttonIcon = _props.buttonIcon,
          text = _props.text;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          onClick: this.open,
          disabled: disabled,
          className: "btn " + buttonClass,
          type: "button"
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw " + buttonIcon }),
        text,
        modal(this.state.open, this.close, this.props)
      );
    }
  }, {
    key: "link",
    value: function link() {
      var _props2 = this.props,
          modal = _props2.modal,
          text = _props2.text;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { onClick: this.open },
        text,
        modal(this.state.open, this.close, this.props)
      );
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.link) {
        return this.link();
      }

      return this.button();
    }
  }]);

  return ModalLauncher;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ModalLauncher.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  buttonClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  buttonIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ModalLauncher.defaultProps = {
  text: " Add",
  buttonClass: "btn-info",
  buttonIcon: "fa-plus",
  disabled: false
};
/* harmony default export */ __webpack_exports__["a"] = (ModalLauncher);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony export (immutable) */ __webpack_exports__["a"] = renderIf;


function renderIf(condition) {
  return function (Component) {
    return function (props) {
      if (condition(props)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, props);
      }

      return false;
    };
  };
}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(134);
var toLength = __webpack_require__(91);
var toAbsoluteIndex = __webpack_require__(227);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(60);
var $export = __webpack_require__(18);
var redefine = __webpack_require__(124);
var redefineAll = __webpack_require__(225);
var meta = __webpack_require__(197);
var forOf = __webpack_require__(219);
var anInstance = __webpack_require__(218);
var isObject = __webpack_require__(68);
var fails = __webpack_require__(66);
var $iterDetect = __webpack_require__(364);
var setToStringTag = __webpack_require__(254);
var inheritIfRequired = __webpack_require__(524);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(123);
var redefine = __webpack_require__(124);
var fails = __webpack_require__(66);
var defined = __webpack_require__(157);
var wks = __webpack_require__(81);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(57);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(145);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(68);
var cof = __webpack_require__(145);
var MATCH = __webpack_require__(81)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(81)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(220) || !__webpack_require__(66)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(60)[K];
});


/***/ }),
/* 366 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(18);
var aFunction = __webpack_require__(111);
var ctx = __webpack_require__(146);
var forOf = __webpack_require__(219);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(18);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(60);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(57);
var aFunction = __webpack_require__(111);
var SPECIES = __webpack_require__(81)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(60);
var hide = __webpack_require__(123);
var uid = __webpack_require__(228);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(181);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var on = function on() {};
if (_inDOM2.default) {
  on = function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

exports.default = on;
module.exports = exports['default'];

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = style;

var _camelizeStyle = __webpack_require__(879);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

var _hyphenateStyle = __webpack_require__(2741);

var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);

var _getComputedStyle2 = __webpack_require__(2736);

var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);

var _removeStyle = __webpack_require__(2737);

var _removeStyle2 = _interopRequireDefault(_removeStyle);

var _properties = __webpack_require__(878);

var _isTransform = __webpack_require__(2738);

var _isTransform2 = _interopRequireDefault(_isTransform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];
    if (!value && value !== 0) {
      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
    } else if ((0, _isTransform2.default)(key)) {
      transforms += key + '(' + value + ') ';
    } else {
      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
    }
  });

  if (transforms) {
    css += _properties.transform + ': ' + transforms + ';';
  }

  node.style.cssText += ';' + css;
}
module.exports = exports['default'];

/***/ }),
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(2918),
    listCacheDelete = __webpack_require__(2919),
    listCacheGet = __webpack_require__(2920),
    listCacheHas = __webpack_require__(2921),
    listCacheSet = __webpack_require__(2922);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(573);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(2916);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(231);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(259),
    isObject = __webpack_require__(233);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(259),
    isObjectLike = __webpack_require__(234);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 391 */,
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(576);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}
module.exports = exports['default'];

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_keycode__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_uncontrollable__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_warning__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ButtonGroup__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__ = __webpack_require__(2985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__ = __webpack_require__(3033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_ValidComponentChildren__ = __webpack_require__(116);


























var TOGGLE_ROLE = __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__["a" /* default */].defaultProps.bsRole;
var MENU_ROLE = __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__["a" /* default */].defaultProps.bsRole;

var propTypes = {
  /**
   * The menu will open above the dropdown button, instead of below it.
   */
  dropup: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * An html id attribute, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number])),

  componentClass: __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType___default.a,

  /**
   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
   * @type {node}
   */
  children: __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__["a" /* requiredRoles */])(TOGGLE_ROLE, MENU_ROLE), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__["b" /* exclusiveRoles */])(MENU_ROLE)),

  /**
   * Whether or not component is disabled.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * Align the menu to the right side of the Dropdown toggle
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */
  open: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  defaultOpen: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```js
   * function(Boolean isOpen, Object event, { String source }) {}
   * ```
   * @controllable open
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * A callback fired when a menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
   * a menu button.
   */
  role: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,

  /**
   * Which event when fired outside the component will cause it to be closed
   */
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOf(['click', 'mousedown']),

  /**
   * @private
   */
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func
};

var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_17__ButtonGroup__["a" /* default */]
};

var Dropdown = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Dropdown, _React$Component);

  function Dropdown(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Dropdown);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);

    _this._focusInDropdown = false;
    _this.lastOpenEventType = null;
    return _this;
  }

  Dropdown.prototype.componentDidMount = function componentDidMount() {
    this.focusNextOnOpen();
  };

  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!nextProps.open && this.props.open) {
      this._focusInDropdown = __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains___default()(__WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.menu), __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement___default()(document));
    }
  };

  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var open = this.props.open;

    var prevOpen = prevProps.open;

    if (open && !prevOpen) {
      this.focusNextOnOpen();
    }

    if (!open && prevOpen) {
      // if focus hasn't already moved from the menu let's return it
      // to the toggle
      if (this._focusInDropdown) {
        this._focusInDropdown = false;
        this.focus();
      }
    }
  };

  Dropdown.prototype.handleClick = function handleClick(event) {
    if (this.props.disabled) {
      return;
    }

    this.toggleOpen(event, { source: 'click' });
  };

  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
    if (this.props.disabled) {
      return;
    }

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.down:
        if (!this.props.open) {
          this.toggleOpen(event, { source: 'keydown' });
        } else if (this.menu.focusNext) {
          this.menu.focusNext();
        }
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.tab:
        this.handleClose(event, { source: 'keydown' });
        break;
      default:
    }
  };

  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
    var open = !this.props.open;

    if (open) {
      this.lastOpenEventType = eventDetails.source;
    }

    if (this.props.onToggle) {
      this.props.onToggle(open, event, eventDetails);
    }
  };

  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
    if (!this.props.open) {
      return;
    }

    this.toggleOpen(event, eventDetails);
  };

  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
    var menu = this.menu;

    if (!menu.focusNext) {
      return;
    }

    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
      menu.focusNext();
    }
  };

  Dropdown.prototype.focus = function focus() {
    var toggle = __WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.toggle);

    if (toggle && toggle.focus) {
      toggle.focus();
    }
  };

  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
    var _this2 = this;

    var ref = function ref(c) {
      _this2.toggle = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
      ref: ref,
      bsClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["e" /* prefix */])(props, 'toggle'),
      onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onClick, this.handleClick),
      onKeyDown: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, this.handleKeyDown)
    }));
  };

  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
    var _this3 = this;

    var id = _ref.id,
        onSelect = _ref.onSelect,
        rootCloseEvent = _ref.rootCloseEvent,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['id', 'onSelect', 'rootCloseEvent']);

    var ref = function ref(c) {
      _this3.menu = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
      ref: ref,
      labelledBy: id,
      bsClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["e" /* prefix */])(props, 'menu'),
      onClose: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onClose, this.handleClose),
      onSelect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, function (key, event) {
        return _this3.handleClose(event, { source: 'select' });
      }),
      rootCloseEvent: rootCloseEvent
    }));
  };

  Dropdown.prototype.render = function render() {
    var _classes,
        _this4 = this;

    var _props = this.props,
        Component = _props.componentClass,
        id = _props.id,
        dropup = _props.dropup,
        disabled = _props.disabled,
        pullRight = _props.pullRight,
        open = _props.open,
        onSelect = _props.onSelect,
        role = _props.role,
        bsClass = _props.bsClass,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);

    delete props.onToggle;

    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);

    if (dropup) {
      classes[bsClass] = false;
      classes.dropup = true;
    }

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_23__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        switch (child.props.bsRole) {
          case TOGGLE_ROLE:
            return _this4.renderToggle(child, {
              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
            });
          case MENU_ROLE:
            return _this4.renderMenu(child, {
              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onSelect: onSelect, rootCloseEvent: rootCloseEvent
            });
          default:
            return child;
        }
      })
    );
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["c" /* bsClass */])('dropdown', Dropdown);

var UncontrolledDropdown = __WEBPACK_IMPORTED_MODULE_15_uncontrollable___default()(Dropdown, { open: 'onToggle' });

UncontrolledDropdown.Toggle = __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__["a" /* default */];
UncontrolledDropdown.Menu = __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (UncontrolledDropdown);

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Transition__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Transition__);









var propTypes = {
  /**
   * Show the component; triggers the fade in or fade out animation
   */
  'in': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is faded out
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Run the fade in animation when the component mounts, if it is initially
   * shown
   */
  transitionAppear: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Duration of the fade animation in milliseconds, to ensure that finishing
   * callbacks are fired even if the original browser transition end events are
   * canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,

  /**
   * Callback fired before the component fades in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to fade in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired after the has component faded in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired before the component fades out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to fade out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired after the component has faded out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};

var defaultProps = {
  'in': false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  transitionAppear: false
};

var Fade = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Fade, _React$Component);

  function Fade() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Fade);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Fade.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Transition___default.a, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(this.props.className, 'fade'),
      enteredClassName: 'in',
      enteringClassName: 'in'
    }));
  };

  return Fade;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony export (immutable) */ __webpack_exports__["a"] = splitComponentProps;

function splitComponentProps(props, Component) {
  var componentPropTypes = Component.propTypes;

  var parentProps = {};
  var childProps = {};

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (componentPropTypes[propName]) {
      parentProps[propName] = propValue;
    } else {
      childProps[propName] = propValue;
    }
  });

  return [parentProps, childProps];
}

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(372);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(544);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getContainer;

var _reactDom = __webpack_require__(94);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(1103);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(3068)();
}


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(3099)();
}


/***/ }),
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomFromSeed = __webpack_require__(3218);

var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var alphabet;
var previousSeed;

var shuffled;

function reset() {
    shuffled = false;
}

function setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if (alphabet !== ORIGINAL) {
            alphabet = ORIGINAL;
            reset();
        }
        return;
    }

    if (_alphabet_ === alphabet) {
        return;
    }

    if (_alphabet_.length !== ORIGINAL.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    }

    var unique = _alphabet_.split('').filter(function(item, ind, arr){
       return ind !== arr.lastIndexOf(item);
    });

    if (unique.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    }

    alphabet = _alphabet_;
    reset();
}

function characters(_alphabet_) {
    setCharacters(_alphabet_);
    return alphabet;
}

function setSeed(seed) {
    randomFromSeed.seed(seed);
    if (previousSeed !== seed) {
        reset();
        previousSeed = seed;
    }
}

function shuffle() {
    if (!alphabet) {
        setCharacters(ORIGINAL);
    }

    var sourceArray = alphabet.split('');
    var targetArray = [];
    var r = randomFromSeed.nextValue();
    var characterIndex;

    while (sourceArray.length > 0) {
        r = randomFromSeed.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}

function getShuffled() {
    if (shuffled) {
        return shuffled;
    }
    shuffled = shuffle();
    return shuffled;
}

/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */
function lookup(index) {
    var alphabetShuffled = getShuffled();
    return alphabetShuffled[index];
}

module.exports = {
    characters: characters,
    seed: setSeed,
    lookup: lookup,
    shuffled: getShuffled
};


/***/ }),
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_RepairOrders_actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_session_actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cable__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actionTypes__ = __webpack_require__(1217);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony export (immutable) */ __webpack_exports__["b"] = destroy;
/* harmony export (immutable) */ __webpack_exports__["c"] = clearCart;
/* harmony export (immutable) */ __webpack_exports__["d"] = subscribe;







function create(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.repairOrdersCart.create(id).then(function (_ref) {
      var data = _ref.data;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__modules_session_actions__["refreshCarts"])());
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_5__actionTypes__["a" /* ADD */], repairOrderCartItems: data });
      __WEBPACK_IMPORTED_MODULE_0_react_redux_toastr__["toastr"].success("Success", "Item successfully added to cart.");
    });
  };
}

function destroy(inventoryId) {
  return function (dispatch) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_5__actionTypes__["b" /* REMOVE */], id: inventoryId });
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.repairOrdersCart.delete(inventoryId).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__modules_session_actions__["refreshCarts"])());
      dispatch(__WEBPACK_IMPORTED_MODULE_2__modules_RepairOrders_actions__["b" /* reservedForRepairInventoryActions */].expire());
    });
  };
}

function clearCart() {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.repairOrdersCart.clearCart().then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__modules_session_actions__["refreshCarts"])());
      dispatch(__WEBPACK_IMPORTED_MODULE_2__modules_RepairOrders_actions__["b" /* reservedForRepairInventoryActions */].expire());
    });
  };
}

function subscribe() {
  return function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cable__["b" /* createChannel */])().listen("RepairCartChannel", {
      onReceive: function onReceive(data) {
        if (data === "UPDATE") {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__modules_session_actions__["refreshCarts"])());
        }
      }
    });
  };
}

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_SalesOrders_actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_session_actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cable__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actionTypes__ = __webpack_require__(1220);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony export (immutable) */ __webpack_exports__["b"] = destroy;
/* harmony export (immutable) */ __webpack_exports__["c"] = clearCart;
/* harmony export (immutable) */ __webpack_exports__["d"] = subscribe;







function create(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].inventories.saleOrdersCart.create(id).then(function (_ref) {
      var data = _ref.data;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__modules_session_actions__["refreshCarts"])());
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_5__actionTypes__["a" /* ADD */], saleOrderCartItems: data });
      __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success("Success", "Item successfully added to cart.");
    });
  };
}

function destroy(inventoryId) {
  return function (dispatch) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_5__actionTypes__["b" /* REMOVE */], id: inventoryId });
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].inventories.saleOrdersCart.delete(inventoryId).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__modules_session_actions__["refreshCarts"])());
      dispatch(__WEBPACK_IMPORTED_MODULE_2__modules_SalesOrders_actions__["b" /* reservedForSaleInventoryActions */].expire());
    });
  };
}

function clearCart() {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].inventories.saleOrdersCart.clearCart().then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__modules_session_actions__["refreshCarts"])());
      dispatch(__WEBPACK_IMPORTED_MODULE_2__modules_SalesOrders_actions__["b" /* reservedForSaleInventoryActions */].expire());
    });
  };
}

function subscribe() {
  return function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cable__["b" /* createChannel */])().listen("SalesCartChannel", {
      onReceive: function onReceive(data) {
        if (data === "UPDATE") {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__modules_session_actions__["refreshCarts"])());
          dispatch(__WEBPACK_IMPORTED_MODULE_2__modules_SalesOrders_actions__["b" /* reservedForSaleInventoryActions */].expire());
        }
      }
    });
  };
}

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = string;
function string(s) {
  var empty = function empty() {
    return !s || !s.trim();
  };

  return { empty: empty };
}

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "approvedRepairStations",
  fetch: function fetch(params) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].companies.search(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(params, {
      repair_station: true,
      sort: "name",
      reverse: false
    }));
  }
}));

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "approvedVendors",
  fetch: function fetch(params) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].companies.search(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(params, {
      vendor_status: "approved",
      sort: "name",
      reverse: false
    }));
  }
}));

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REVERSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SEND_NOTIFICATION; });
var REVERSED = "reversed";
var PAID = "paid";
var PENDING = "pending";
var SEND_NOTIFICATION = "send_notification";

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "commissions",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].commissions.search,
  initialSettings: {
    sort: "created_at"
  }
}));

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createStore__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(99);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consignmentInventoriesPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return consignmentLineItemsPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return consignmentsPagination; });







var consignmentInventoriesPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["a" /* createPaginatedList */])({
  listId: "consignments/inventories",
  stateLocator: function stateLocator(state) {
    return state.consignments.inventories;
  },
  initialSettings: {
    pageSize: 15
  },
  fetch: function fetch(search) {
    var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__createStore__["a" /* default */])().getState().consignmentDetail.getIn([__WEBPACK_IMPORTED_MODULE_4__Receiving_constants__["t" /* CONSIGNMENT */], __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ID */]]);
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].consignments.inventories.search(id, search);
  }
});

var consignmentLineItemsPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["a" /* createPaginatedList */])({
  listId: "consignments/lineItems",
  stateLocator: function stateLocator(state) {
    return state.consignments.lineItems;
  },
  initialSettings: {
    pageSize: 15
  },
  fetch: function fetch(search) {
    var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__createStore__["a" /* default */])().getState().consignmentDetail.getIn([__WEBPACK_IMPORTED_MODULE_4__Receiving_constants__["t" /* CONSIGNMENT */], __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ID */]]);
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].consignments.lineItems.search(id, search);
  }
});

var consignmentsPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["a" /* createPaginatedList */])({
  listId: "consignments",
  stateLocator: function stateLocator(state) {
    return state.consignments.main;
  },
  fetch: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].consignments.search
});

/* harmony default export */ __webpack_exports__["d"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux__["combineReducers"])({
  main: consignmentsPagination.paginator,
  inventories: consignmentInventoriesPagination.paginator,
  lineItems: consignmentLineItemsPagination.paginator
}));

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(40);
/* harmony export (immutable) */ __webpack_exports__["a"] = IncomingQuoteTypeSelect;









function IncomingQuoteTypeSelect(_ref) {
  var cost = _ref.cost,
      quantity = _ref.quantity,
      exchange_fee = _ref.exchange_fee,
      quoteTypes = _ref.quoteTypes,
      _ref$setFieldValue = _ref.setFieldValue,
      setFieldValue = _ref$setFieldValue === undefined ? function () {
    return function () {};
  } : _ref$setFieldValue;

  var handleChange = function handleChange(ev) {
    var newQuoteType = ev.target.value;

    if ([__WEBPACK_IMPORTED_MODULE_7__constants__["q" /* MAKE_OFFER */], __WEBPACK_IMPORTED_MODULE_7__constants__["j" /* NO_QUOTE */], __WEBPACK_IMPORTED_MODULE_7__constants__["n" /* AWAITING_REPLY */]].includes(newQuoteType)) {
      cost.input.onChange(0);
    }

    if (newQuoteType !== __WEBPACK_IMPORTED_MODULE_7__constants__["n" /* AWAITING_REPLY */]) {
      setFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["o" /* SEND_QUOTE */])(false);
    }

    if (newQuoteType === __WEBPACK_IMPORTED_MODULE_7__constants__["j" /* NO_QUOTE */]) {
      quantity.input.onChange("0");
    }

    if (newQuoteType !== __WEBPACK_IMPORTED_MODULE_7__constants__["p" /* EXCHANGE_ONLY */]) {
      exchange_fee.input.onChange(null);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_5__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */],
    component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["c" /* Select */],
    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["a" /* toOptions */])(quoteTypes),
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_5__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */]),
    prompt: null,
    onChange: handleChange,
    required: true
  });
}

IncomingQuoteTypeSelect.propTypes = {
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  exchange_fee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  quoteTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_CurrencyField__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony export (immutable) */ __webpack_exports__["a"] = PartDetails;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();




















function PartDetails(_ref) {
  var quoteType = _ref.quoteType,
      part = _ref.part,
      taggedBy = _ref.taggedBy;

  var options = [{ value: "overhauled", text: "Overhauled" }, { value: "repaired", text: "Repaired" }, { value: "inspected", text: "Inspected" }, { value: "new_item", text: "New" }, { value: "as_removed", text: "As Removed" }, { value: "beyond_econ_repair", text: "Beyond Econ Repair" }];

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(taggedBy),
      _useState2 = _slicedToArray(_useState, 2),
      selectedTaggedBy = _useState2[0],
      setTaggedBy = _useState2[1];

  var alternateOptions = function alternateOptions(alternateParts) {
    return alternateParts.get("alternates").toJS().map(function (val) {
      return {
        text: val.name,
        value: val.id
      };
    });
  };

  var searchCompanies = function searchCompanies(filter) {
    return __WEBPACK_IMPORTED_MODULE_14__api__["a" /* default */].companies.search({
      filter: filter,
      status: [__WEBPACK_IMPORTED_MODULE_15__companies_constants__["c" /* ACTIVE */], __WEBPACK_IMPORTED_MODULE_15__companies_constants__["d" /* CREDIT_HOLD */]].join(","),
      page: 1,
      limit: 20
    }).then(function (resp) {
      return resp.data.results;
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["n" /* CONDITION */],
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
            options: options,
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["n" /* CONDITION */]),
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
        { md: 2 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_13__constants__["j" /* QUANTITY */],
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
            label: "QTY",
            type: "number",
            required: true,
            inputProps: {
              min: 0,
              onKeyDown: function onKeyDown(e) {
                if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                  e.preventDefault();
                }
              },
              onWheel: function onWheel(e) {
                return e.target.blur();
              }
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_CurrencyField__["a" /* default */], {
            name: __WEBPACK_IMPORTED_MODULE_13__constants__["V" /* COST */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["V" /* COST */]),
            required: quoteType !== __WEBPACK_IMPORTED_MODULE_6__constants__["n" /* AWAITING_REPLY */] && quoteType !== __WEBPACK_IMPORTED_MODULE_6__constants__["p" /* EXCHANGE_ONLY */],
            readOnly: quoteType === __WEBPACK_IMPORTED_MODULE_6__constants__["q" /* MAKE_OFFER */],
            disabled: quoteType === __WEBPACK_IMPORTED_MODULE_6__constants__["q" /* MAKE_OFFER */] || quoteType === __WEBPACK_IMPORTED_MODULE_6__constants__["n" /* AWAITING_REPLY */]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_CurrencyField__["a" /* default */], {
            name: __WEBPACK_IMPORTED_MODULE_12__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */],
            label: "Exch Fee",
            required: quoteType === __WEBPACK_IMPORTED_MODULE_6__constants__["p" /* EXCHANGE_ONLY */],
            disabled: quoteType === __WEBPACK_IMPORTED_MODULE_6__constants__["n" /* AWAITING_REPLY */]
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["G" /* LEAD_TIME */],
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
            label: "Lead Time (Days)",
            type: "number",
            required: [__WEBPACK_IMPORTED_MODULE_6__constants__["p" /* EXCHANGE_ONLY */], __WEBPACK_IMPORTED_MODULE_6__constants__["k" /* STANDARD */]].includes(quoteType),
            inputProps: {
              min: 0,
              onKeyDown: function onKeyDown(e) {
                if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                  e.preventDefault();
                }
              },
              onWheel: function onWheel(e) {
                return e.target.blur();
              }
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_17__PurchaseOrders_constants__["b" /* EXPECTED_SERIAL_NUMBER */],
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
            label: "Expected Serial #"
          })
        )
      ),
      part && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_6__constants__["r" /* RFQ_AS_ALT_ID */],
            label: "RFQ as Alt",
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
            options: alternateOptions(part)
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__OutgoingQuotes_constants__["g" /* WARRANTY */]),
            name: __WEBPACK_IMPORTED_MODULE_12__OutgoingQuotes_constants__["g" /* WARRANTY */],
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_forms__["f" /* arrayToOptions */])(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["_59" /* WARRANTY_OPTIONS */])
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed", style: { marginBottom: 15 } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["E" /* TRACE_TYPE */],
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes),
            label: "Expected Trace Type"
          })
        )
      ),
      " ",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["F" /* TRACED_TO */],
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
            label: "Expected Trace To"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
        { md: 2 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
          { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["l" /* INCIDENT_RELATED */]) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_6__constants__["l" /* INCIDENT_RELATED */],
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
            label: "IR \xA0\xA0\xA0\xA0"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
        { md: 2 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
          { title: "As Is" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: __WEBPACK_IMPORTED_MODULE_6__constants__["c" /* AS_IS */], component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */], label: "As-is" })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["s" /* AutoCompleteUserInputField */],
            formatItem: function formatItem(result) {
              return result && result.name || result;
            },
            handleTaggedBy: function handleTaggedBy(item) {
              return setTaggedBy(item);
            },
            selectedItem: selectedTaggedBy,
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["p" /* TAGGED_BY */]),
            name: __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["p" /* TAGGED_BY */],
            placeholder: "Search by a company's name",
            search: searchCompanies
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["r" /* MonthYearField */], {
            name: __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["x" /* TAG_DATE */],
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["x" /* TAG_DATE */])
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["r" /* MonthYearField */], { name: "dom", component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */], label: "DOM" })
        )
      )
    ),
    [__WEBPACK_IMPORTED_MODULE_15__companies_constants__["o" /* MANAGER_CONSENT_NEEDED */], __WEBPACK_IMPORTED_MODULE_15__companies_constants__["n" /* DENIED */]].includes(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(selectedTaggedBy, __WEBPACK_IMPORTED_MODULE_15__companies_constants__["q" /* REPAIR_STATION_STATUS */])) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_16__shared_components_Warning_Warning__["a" /* default */],
      null,
      "The Repair Station has a status of",
      " ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(selectedTaggedBy, __WEBPACK_IMPORTED_MODULE_15__companies_constants__["q" /* REPAIR_STATION_STATUS */]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
          { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["s" /* MODIFIED */]) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_6__constants__["s" /* MODIFIED */],
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["s" /* MODIFIED */])
          })
        )
      )
    )
  );
}

PartDetails.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Map),
  quoteType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  taggedBy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony export (immutable) */ __webpack_exports__["a"] = validateLineItem;
/* harmony export (immutable) */ __webpack_exports__["b"] = validate;







function validateLineItem(lineItem, values) {
  var fieldPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var quoteType = fieldPrefix ? values[fieldPrefix] && values[fieldPrefix].quote_type : values.quote_type;

  if (quoteType !== __WEBPACK_IMPORTED_MODULE_1__constants__["j" /* NO_QUOTE */]) {
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["f" /* isGreaterThan */](0));
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_3__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
  }
  if (![__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* NO_QUOTE */], __WEBPACK_IMPORTED_MODULE_1__constants__["p" /* EXCHANGE_ONLY */]].includes(quoteType)) {
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["V" /* COST */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0));
  }

  if (quoteType === __WEBPACK_IMPORTED_MODULE_1__constants__["p" /* EXCHANGE_ONLY */]) {
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_5__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
  }

  if ([__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* STANDARD */], __WEBPACK_IMPORTED_MODULE_1__constants__["p" /* EXCHANGE_ONLY */]].includes(quoteType)) {
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["G" /* LEAD_TIME */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["g" /* requiredAllowZero */]);
  }

  if (![__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* NO_QUOTE */], __WEBPACK_IMPORTED_MODULE_1__constants__["n" /* AWAITING_REPLY */], __WEBPACK_IMPORTED_MODULE_1__constants__["q" /* MAKE_OFFER */], __WEBPACK_IMPORTED_MODULE_1__constants__["p" /* EXCHANGE_ONLY */]].includes(quoteType)) {
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["V" /* COST */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["f" /* isGreaterThan */](0.0));
  }
}

function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate("part_id", __WEBPACK_IMPORTED_MODULE_5__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    validateLineItem(form, values);
  });
}

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_INCOMING_QUOTE_WITH_ALL_LINE_ITEMS; });
var SET = "incomingQuotes/SET";
var SET_INCOMING_QUOTE_WITH_ALL_LINE_ITEMS = "incomingQuoteWithAllLineItemsDetail/SET";

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__ = __webpack_require__(47);








var ReduxFormLocationDropdown = function ReduxFormLocationDropdown(_ref) {
  var currentUser = _ref.currentUser,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? "Select Location" : _ref$label,
      _ref$name = _ref.name,
      name = _ref$name === undefined ? __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* LOCATION_ID */] : _ref$name,
      _ref$required = _ref.required,
      required = _ref$required === undefined ? false : _ref$required;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
      disabled: disabled,
      name: name,
      component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
      label: label,
      options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(currentUser, "locations", []).map(function (l) {
        return {
          text: l.name,
          value: l.id
        };
      }),
      required: required
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["b" /* default */])(ReduxFormLocationDropdown));

ReduxFormLocationDropdown.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








var ToolsUsedDropDown = function ToolsUsedDropDown(_ref) {
  var currentUser = _ref.currentUser,
      disabled = _ref.disabled,
      selectedLineItem = _ref.selectedLineItem,
      _ref$name = _ref.name,
      name = _ref$name === undefined ? __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["J" /* TOOL_USED */] : _ref$name,
      _ref$notRequired = _ref.notRequired,
      notRequired = _ref$notRequired === undefined ? false : _ref$notRequired;

  var options = currentUser.tenant.tools_used.map(function (k) {
    return {
      value: k,
      text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(k).toUpperCase()
    };
  });

  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
    name: name,
    component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["c" /* Select */],
    options: options,
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["J" /* TOOL_USED */]),
    disabled: disabled,
    required: !selectedLineItem && !notRequired
  });
};

ToolsUsedDropDown.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({}).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  selectedLineItem: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({}),
  notRequired: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__session_decorators_withCurrentUser__["b" /* default */])(ToolsUsedDropDown));

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_shared__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__PurchaseForFields__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Orders_shared_InvoiceSection__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__PurchaseOrders_components_Detail_SRPConditionMismatchWarning__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__PurchaseOrders_components_Detail_LineItemsTable_Form__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__PurchaseOrders_shared_PreviousSrpConditionWarning__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__PurchaseOrders_components_Detail_LineItemsTable_DomLifeWarning__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__PartSummary__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__validate__ = __webpack_require__(1387);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SRP_CONDITION_OPTIONS; });
/* unused harmony export DOMIsRequiredWarning */
/* unused harmony export UnauthorizedRepairStationSelectedWarning */
/* unused harmony export SixMonthsOldTagDateWarning */
/* unused harmony export UnauthorizedPreferredRepairStationSelectedWarning */
/* unused harmony export AsIsField */
/* unused harmony export tagDateIsOlder */
/* unused harmony export Form */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







































var formName = "lotLineItems";

var SRP_CONDITION_OPTIONS = [{ value: "overhauled", text: "Overhauled" }, { value: "repaired", text: "Repaired" }, { value: "inspected", text: "Inspected" }, { value: "new_item", text: "New" }, { value: "as_removed", text: "As Removed" }, { value: "beyond_econ_repair", text: "Beyond Econ Repair" }, { value: "serviceable_tooling", text: "Serviceable Tooling" }];

function InsuranceTypeField(_ref) {
  var amountInsured = _ref.amount_insured,
      percentInsured = _ref.percent_insured,
      insuranceType = _ref.insurance_type,
      disabled = _ref.disabled;

  var activePercent = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "Percent"
  });
  var activeAmount = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "Amount"
  });
  var activeNone = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "None"
  });

  var handleInsuranceTypeChange = function handleInsuranceTypeChange(newVal) {
    return function () {
      if (disabled) return;
      insuranceType.input.onChange(newVal);
      if (newVal === "Amount") {
        percentInsured.input.onChange(null);
      } else if (newVal === "Percent") {
        amountInsured.input.onChange(null);
      } else {
        amountInsured.input.onChange(null);
        percentInsured.input.onChange(null);
      }
    };
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group", style: { marginBottom: 20 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { className: "control-label", htmlFor: "insurance_type" },
      "Insurance"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "btn-group btn-group-justified", role: "group" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activeNone,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("None")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Do Not Insure"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activeAmount,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("Amount")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Amount"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activePercent,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("Percent")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Percent"
      )
    )
  );
}

InsuranceTypeField.propTypes = {
  amount_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  percent_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  insurance_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function AmountInsuredFields(_ref2) {
  var amount = _ref2.amount,
      disabled = _ref2.disabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "col-md-4" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
      name: amount.input.name,
      label: "Insurance Amount",
      disabled: disabled,
      required: true
    })
  );
}

AmountInsuredFields.propTypes = {
  amount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function DOMIsRequiredWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_32__shared_components__["n" /* Warning */],
    null,
    "Part is DOM Sensitive. DOM Required."
  );
}

function UnauthorizedRepairStationSelectedWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_32__shared_components__["n" /* Warning */],
    null,
    "Note: This Repair Station is not approved. Unless you are reserving this unit for repair to a different repair station, PO will require management approval before you are able to send PO."
  );
}

function SixMonthsOldTagDateWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_32__shared_components__["n" /* Warning */],
    null,
    "This purchase is for TAG DATE older than 6 months. Manager Approval will be required."
  );
}

function UnauthorizedPreferredRepairStationSelectedWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_32__shared_components__["n" /* Warning */],
    null,
    "Note: This Repair Station is not approved. PO will require management approval before you are able to send PO."
  );
}

function PercentInsuredFields(_ref3) {
  var percent = _ref3.percent,
      cost = _ref3.cost,
      quantity = _ref3.quantity,
      disabled = _ref3.disabled;

  var costValue = cost.input.value || 0;
  var quantityValue = quantity.input.value || 0;
  var percentValue = percent.input.value || 0;
  var subtotal = parseFloat(costValue) * parseFloat(quantityValue);
  var insuranceAmount = Math.ceil(subtotal * percentValue) / 100;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
    { md: 12 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
          name: percent.input.name,
          label: "Insurance Percent",
          component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["h" /* NumberInput */],
          parse: function parse(value) {
            return value && parseInt(value, 10);
          },
          addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-percent" }),
          disabled: disabled,
          required: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "insurance_type" },
            "Insurance Amount"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "input-group-addon" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-dollar" })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
              className: "form-control",
              type: "text",
              value: insuranceAmount,
              disabled: true,
              readOnly: true
            })
          )
        )
      )
    )
  );
}

PercentInsuredFields.propTypes = {
  percent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function InsuranceFields(_ref4) {
  var amountInsured = _ref4.amount_insured,
      percentInsured = _ref4.percent_insured,
      insuranceType = _ref4.insurance_type,
      cost = _ref4.cost,
      quantity = _ref4.quantity,
      disabled = _ref4.disabled;

  if (insuranceType.input.value === "Amount") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AmountInsuredFields, { amount: amountInsured, disabled: disabled });
  } else if (insuranceType.input.value === "Percent") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PercentInsuredFields, {
      insuranceType: insuranceType,
      percent: percentInsured,
      cost: cost,
      quantity: quantity,
      disabled: disabled
    });
  }

  return null;
}

InsuranceFields.propTypes = {
  amount_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  percent_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  insurance_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

function LineHazmatFields(_ref5) {
  var hazmat = _ref5.hazmat,
      bio_hazmat = _ref5.bio_hazmat,
      disabled = _ref5.disabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group btn-group-justified", "data-toggle": "buttons" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */], {
      input: hazmat.input,
      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__parts_constants__["h" /* HAZMAT */]),
      icon: "fa-warning",
      disabled: disabled
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */], {
      input: bio_hazmat.input,
      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__parts_constants__["i" /* BIO_HAZMAT */]),
      icon: "fa-flask",
      disabled: disabled
    })
  );
}

LineHazmatFields.propTypes = {
  hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  bio_hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function AsIsField(_ref6) {
  var asIs = _ref6.as_is,
      condition = _ref6.condition,
      evaluationPeriod = _ref6.evaluation_period,
      purchaseForStock = _ref6.purchase_for_stock,
      disabled = _ref6.disabled;

  var handleChange = function handleChange(val) {
    asIs.input.onChange(val);
    if (val === true) {
      evaluationPeriod.input.onChange(0);
    } else {
      evaluationPeriod.input.onChange(30);

      if (condition.input.value === __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["i" /* AS_REMOVED */]) {
        purchaseForStock.input.onChange(false);
      }
    }
  };

  var input = _extends({}, asIs.input, { onChange: handleChange });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group btn-group-justified", "data-toggle": "buttons" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */], {
      input: input,
      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["c" /* AS_IS */]),
      icon: "fa-check-circle",
      disabled: disabled
    })
  );
}

AsIsField.propTypes = {
  as_is: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  evaluation_period: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  purchase_for_stock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function tagDateIsOlder(tagDate) {
  return __WEBPACK_IMPORTED_MODULE_8_moment___default()().diff(tagDate, "months") > 6;
}

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref7;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref7 = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref7, [this].concat(args))), _this), _this.state = {
      alternateOptions: []
    }, _this.fetchAlternates = function (partId) {
      if (!partId) return;
      _this.props.searchAlternates(partId).then(function (results) {
        return _this.setState({
          alternateOptions: results.map(function (item) {
            return {
              text: item.name,
              value: item.id
            };
          })
        });
      });
    }, _this.handlePartSelected = function (part) {
      _this.props.setSelectedPart(part);
      _this.props.resetAlternatePartField();
      if (part) {
        _this.props.setHazardFields(part);
        _this.props.setHeavyPackage(part);
        _this.fetchAlternates(part.id);

        if (part.tooling_part_type) {
          _this.props.setFieldValue(__WEBPACK_IMPORTED_MODULE_22__inventories_constants__["n" /* CONDITION */])(__WEBPACK_IMPORTED_MODULE_6__constants__["U" /* SERVICEABLE_TOOLING */]);
        }
      }
    }, _this.searchCompanies = function (filter) {
      return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].companies.search({
        repair_station: true,
        filter: filter,
        status: [__WEBPACK_IMPORTED_MODULE_24__companies_constants__["c" /* ACTIVE */], __WEBPACK_IMPORTED_MODULE_24__companies_constants__["d" /* CREDIT_HOLD */]].join(","),
        page: 1,
        limit: 20
      }).then(function (resp) {
        return resp.data.results;
      });
    }, _this.handleTaggedBy = function (company) {
      var _this$props = _this.props,
          setTaggedById = _this$props.setTaggedById,
          setTaggedByHold = _this$props.setTaggedByHold;


      if (company && company.id) {
        setTaggedById(company.id);
        setTaggedByHold(company.repair_station_status !== __WEBPACK_IMPORTED_MODULE_24__companies_constants__["j" /* APPROVED */]);
      } else {
        setTaggedByHold(false);
      }
    }, _this.handlePreferredRepairStation = function (company) {
      var setPreferredRepairStationHold = _this.props.setPreferredRepairStationHold;


      if (company && company.id) {
        setPreferredRepairStationHold(company.repair_station_status !== __WEBPACK_IMPORTED_MODULE_24__companies_constants__["j" /* APPROVED */]);
      }
    }, _this.resetPreferredRepairStation = function () {
      var resetPreferredRepairStation = _this.props.resetPreferredRepairStation;


      resetPreferredRepairStation();

      _this.setState({ selectedPreferredRepairStation: null });
    }, _this.toggleBuyer = function (buyer) {
      return _this.setState(buyer);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.lineItem) {
        var id = this.props.lineItem.part_id;
        var part = this.props.lineItem.part;
        var coBuyer = this.props.lineItem.co_buyer;
        var thirdBuyer = this.props.lineItem.third_buyer;

        if (part) {
          this.props.setHazardFields(part);
          this.props.setHeavyPackage(part);
          this.fetchAlternates(part.id);
        }

        this.props.setPartId(id);
        this.props.setSelectedPart(part);
        this.setState({
          selectedCoBuyer: coBuyer,
          selectedThirdBuyer: thirdBuyer
        });
      }

      this.setState({
        selectedReserveForSeller: this.props.currentUser
      });

      if (this.props.selectedLineItem) {
        var _props$selectedLineIt = this.props.selectedLineItem,
            _part = _props$selectedLineIt.part,
            modTo = _props$selectedLineIt.mod_to,
            co_buyer = _props$selectedLineIt.co_buyer,
            third_buyer = _props$selectedLineIt.third_buyer,
            preferredRepairStation = _props$selectedLineIt.preferred_repair_station,
            reserveForSeller = _props$selectedLineIt.reserve_for_seller;


        this.setState({
          selectedModTo: modTo,
          selectedPart: _part,
          selectedCoBuyer: co_buyer,
          selectedThirdBuyer: third_buyer,
          selectedPreferredRepairStation: preferredRepairStation,
          selectedReserveForSeller: reserveForSeller || this.props.currentUser
        });
        this.props.setSelectedPart(_part);
        this.fetchAlternates(_part.id);
      }
    }
  }, {
    key: "inventoryLocked",
    value: function inventoryLocked(field) {
      var _EXCHANGE_SRP$QUANTIT;

      var _props = this.props,
          currentUser = _props.currentUser,
          selectedLineItem = _props.selectedLineItem;

      if (!selectedLineItem) return false;

      var buyerId = selectedLineItem.buyer_id,
          coBuyerId = selectedLineItem.co_buyer_id;


      var userCanEdit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_20__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_20__users_constants__["m" /* ACCOUNTING */]]) || [buyerId, coBuyerId].includes(currentUser.id);

      var received = selectedLineItem.received || selectedLineItem.quantity_received > 0;

      var defaultPermission = received || !userCanEdit || selectedLineItem.cancelled;
      if (!field || selectedLineItem.cancelled) {
        return defaultPermission;
      }

      return (_EXCHANGE_SRP$QUANTIT = {}, _defineProperty(_EXCHANGE_SRP$QUANTIT, __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["u" /* EXCHANGE_SRP */], !(userCanEdit || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_20__users_constants__["k" /* SALES */])) || selectedLineItem.received), _defineProperty(_EXCHANGE_SRP$QUANTIT, __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */], selectedLineItem.cancelled || !userCanEdit), _defineProperty(_EXCHANGE_SRP$QUANTIT, __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["v" /* SUGGESTED_RETAIL */], !(userCanEdit || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_20__users_constants__["k" /* SALES */])) || selectedLineItem.received), _defineProperty(_EXCHANGE_SRP$QUANTIT, __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */], selectedLineItem.consignment_type !== __WEBPACK_IMPORTED_MODULE_18__Receiving_constants__["t" /* CONSIGNMENT */] && defaultPermission), _EXCHANGE_SRP$QUANTIT)[field];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          getFieldValue = _props2.getFieldValue,
          buyerCreditPct = _props2.buyerCreditPct,
          currentUser = _props2.currentUser,
          capType = _props2.capType,
          condition = _props2.condition,
          containerFee = _props2.containerFee,
          cost = _props2.cost,
          displaySrpInventoryTable = _props2.displaySrpInventoryTable,
          lot = _props2.lot,
          quantity = _props2.quantity,
          searchBuyers = _props2.searchBuyers,
          searchParts = _props2.searchParts,
          searchRepairStations = _props2.searchRepairStations,
          selectedLineItem = _props2.selectedLineItem,
          setFieldValue = _props2.setFieldValue,
          shippingType = _props2.shippingType,
          hazmatFee = _props2.hazmatFee,
          markedHazardous = _props2.markedHazardous,
          purchaseForStock = _props2.purchaseForStock,
          srpCondition = _props2.srpCondition,
          srp = _props2.srp,
          getField = _props2.getField,
          modalMode = _props2.modalMode,
          renderFooter = _props2.renderFooter,
          selectedPart = _props2.selectedPart,
          domLifeYears = _props2.domLifeYears,
          llp = _props2.llp,
          modTo = _props2.modTo,
          dom = _props2.dom;


      var buyerCreditPctOptions = [{ text: "75%", value: "75.0" }, { text: "50%", value: "50.0" }, { text: "25%", value: "25.0" }];
      var cancelled = selectedLineItem && selectedLineItem.cancelled;
      var _state = this.state,
          selectedModTo = _state.selectedModTo,
          selectedCoBuyer = _state.selectedCoBuyer,
          selectedThirdBuyer = _state.selectedThirdBuyer,
          selectedPreferredRepairStation = _state.selectedPreferredRepairStation,
          selectedReserveForSeller = _state.selectedReserveForSeller,
          alternateOptions = _state.alternateOptions;


      var locked = this.inventoryLocked();
      var leadTimeLocked = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_20__users_constants__["p" /* QUALITY_CONTROL */]) ? false : locked;
      var formProps = _extends({}, this.props, {
        editable: !(locked && this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]) && this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_22__inventories_constants__["v" /* SUGGESTED_RETAIL */])) || cancelled
      });

      var taggedByHold = getFieldValue("tagged_by_hold");
      var preferredRepairStationHold = getFieldValue("preferred_repair_station_hold");

      var showTagDateWarning = purchaseForStock && tagDateIsOlder(getFieldValue(__WEBPACK_IMPORTED_MODULE_22__inventories_constants__["x" /* TAG_DATE */]));

      var clearPurchaseFor = function clearPurchaseFor(val, fields) {
        if (!val) return null;
        return fields.forEach(function (f) {
          return _this2.props.setFieldValue(f)(false);
        });
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["e" /* Form */],
        _extends({}, formProps, { modal: modalMode }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["e" /* Form */].Body,
          null,
          purchaseForStock && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(srpCondition) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(condition) && srpCondition !== condition && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__PurchaseOrders_components_Detail_SRPConditionMismatchWarning__["a" /* SRPConditionMismatchWarning */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: modalMode ? 8 : 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: "row row-col-gutters-half",
                  style: { marginTop: "26px" }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["q" /* PART_ID */],
                    label: "Part #",
                    placeholder: "Type a part's number...",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["n" /* AutoCompleteField */],
                    search: searchParts,
                    selectedItem: selectedPart,
                    formatItem: function formatItem(result) {
                      return result && result.part_number;
                    },
                    onItemSelected: function onItemSelected(i) {
                      return i && _this2.handlePartSelected(i);
                    },
                    disabled: locked,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["o" /* ALTERNATE_ID */],
                    label: "Buy As Alternate",
                    placeholder: "Type a part's number...",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: alternateOptions,
                    addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-exchange" }),
                    disabled: alternateOptions.length === 0
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__shared_components__["m" /* DashedSeparator */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["n" /* CONDITION */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: SRP_CONDITION_OPTIONS,
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_22__inventories_constants__["n" /* CONDITION */]),
                    disabled: locked,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    label: "QTY",
                    type: "number",
                    disabled: this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]),
                    required: true,
                    onBlur: function onBlur(_ev, qty) {
                      if (Number(qty) > 1) {
                        setFieldValue(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["b" /* EXPECTED_SERIAL_NUMBER */])("NSN");
                      } else {
                        setFieldValue(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["b" /* EXPECTED_SERIAL_NUMBER */])(null);
                      }
                      if (Number(qty) === 1 && getFieldValue(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["m" /* PURCHASE_FOR_SALE */])) {
                        setFieldValue(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["n" /* RESERVE_FOR_SALE_QUANTITY */])(1);
                      }
                    },
                    inputProps: {
                      min: 0
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */],
                    label: "Cost/Unit",
                    disabled: this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */]),
                    required: Number(lot.cost_split) === 0
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["y" /* EXPIRATION */],
                    label: "Expiration Date",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    type: "date",
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__shared_components__["m" /* DashedSeparator */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 5 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "label",
                      { htmlFor: "warnings", className: "control-label" },
                      "Line Hazmat"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Fields"], {
                      names: [__WEBPACK_IMPORTED_MODULE_13__parts_constants__["h" /* HAZMAT */], __WEBPACK_IMPORTED_MODULE_13__parts_constants__["i" /* BIO_HAZMAT */]],
                      component: LineHazmatFields,
                      disabled: locked
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "label",
                      { htmlFor: __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["c" /* AS_IS */], className: "control-label" },
                      "As Is"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Fields"], {
                      names: [__WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["c" /* AS_IS */], __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["u" /* EVALUATION_PERIOD */], __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["q" /* PURCHASE_FOR_STOCK */]],
                      component: AsIsField,
                      disabled: locked
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                    { title: "Heavy Package / DIM WT", justified: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["v" /* DIM_WEIGHT */],
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                      label: "Hvy Pkg / DIM",
                      icon: "fa-check-circle",
                      disabled: locked
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                    { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["a" /* INCIDENT */]), justified: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["a" /* INCIDENT */],
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["a" /* INCIDENT */]),
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                      icon: "fa-check-circle",
                      disabled: locked
                    })
                  )
                )
              ),
              selectedModTo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_32__shared_components__["n" /* Warning */],
                null,
                "SRP Info will be applied to PN ",
                selectedModTo.part_number
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                    { title: "Do Not Sell!", justified: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["z" /* UNSELLABLE_PER_USER */],
                      component: function component(props) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */], _extends({}, props, { icon: "fa-diamond" }));
                      },
                      label: "Do Not Sell!"
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__PurchaseOrders_components_Detail_LineItemsTable_DomLifeWarning__["a" /* default */], {
                part: selectedPart,
                domFromLineItem: getField(__WEBPACK_IMPORTED_MODULE_13__parts_constants__["G" /* DOM */])
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__PurchaseOrders_shared_PreviousSrpConditionWarning__["a" /* PreviousSrpConditionWarning */], {
                displayInventory: displaySrpInventoryTable,
                srpCondition: srpCondition,
                srp: srp,
                partId: selectedPart.id
              }),
              showTagDateWarning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SixMonthsOldTagDateWarning, null),
              taggedByHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnauthorizedRepairStationSelectedWarning, null),
              selectedPart.dom_sensitive && __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(dom) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DOMIsRequiredWarning, null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__PurchaseForFields__["a" /* default */], {
                clearPurchaseFor: clearPurchaseFor,
                formName: formName,
                getFieldValue: getFieldValue,
                selectedReserveForSeller: selectedReserveForSeller,
                searchBuyers: searchBuyers,
                setFieldValue: setFieldValue,
                shippingType: shippingType,
                disabled: locked,
                qtyDisabled: this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]),
                condition: condition,
                onPurchaseForStockChange: this.resetPreferredRepairStation,
                onPurchaseForSaleChange: function onPurchaseForSaleChange(val) {
                  if (val && Number(getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */])) === 1) {
                    setFieldValue(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["n" /* RESERVE_FOR_SALE_QUANTITY */])(1);
                  }
                  if (!val) setFieldValue(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["n" /* RESERVE_FOR_SALE_QUANTITY */])("");
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["C" /* SRP_CONDITION */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: SRP_CONDITION_OPTIONS,
                    label: "SRP Condition",
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["v" /* SUGGESTED_RETAIL */],
                    label: "SRP",
                    disabled: this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_22__inventories_constants__["v" /* SUGGESTED_RETAIL */])
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["u" /* EXCHANGE_SRP */],
                    label: getFieldValue(__WEBPACK_IMPORTED_MODULE_28__SalesOrders_constants__["e" /* FLAT_EXCHANGE */]) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_22__inventories_constants__["D" /* FLAT_EXCHANGE_SRP */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_22__inventories_constants__["u" /* EXCHANGE_SRP */]),
                    disabled: this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_22__inventories_constants__["u" /* EXCHANGE_SRP */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__PurchaseOrders_components_Detail_LineItemsTable_Form__["c" /* exchangeSrpNotAllowed */])(selectedPart)
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["r" /* MonthYearField */], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["x" /* TAG_DATE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_22__inventories_constants__["x" /* TAG_DATE */]),
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    required: __WEBPACK_IMPORTED_MODULE_18__Receiving_constants__["u" /* TAG_DATE_CONDITIONS */].includes(condition),
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["p" /* TAGGED_BY */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_22__inventories_constants__["p" /* TAGGED_BY */]),
                    placeholder: "Search by a company's name",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["s" /* AutoCompleteUserInputField */],
                    required: __WEBPACK_IMPORTED_MODULE_18__Receiving_constants__["u" /* TAG_DATE_CONDITIONS */].includes(condition),
                    search: this.searchCompanies,
                    selectedItem: selectedLineItem && selectedLineItem.tagged_by,
                    handleTaggedBy: function handleTaggedBy(result) {
                      return _this2.handleTaggedBy(result);
                    },
                    formatItem: function formatItem(result) {
                      return ((typeof result === "undefined" ? "undefined" : _typeof(result)) === "object" ? result.name : result) || "";
                    },
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["r" /* MonthYearField */], {
                    name: __WEBPACK_IMPORTED_MODULE_13__parts_constants__["G" /* DOM */],
                    label: __WEBPACK_IMPORTED_MODULE_13__parts_constants__["G" /* DOM */].toUpperCase(),
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    required: domLifeYears && llp || selectedPart.dom_sensitive,
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["E" /* TRACE_TYPE */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes),
                    label: "Expected Trace Type",
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["F" /* TRACED_TO */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    label: "Expected Trace To",
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["G" /* LEAD_TIME */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    label: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["_78" /* LEAD_TIME_LABEL */],
                    disabled: leadTimeLocked,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["d" /* PURCHASE_STATUS */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["e" /* PURCHASE_STATUS_OPTIONS */],
                    label: __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["f" /* PURCHASE_STATUS_LABEL */]
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["b" /* EXPECTED_SERIAL_NUMBER */],
                    label: "Expected Serial #",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    disabled: selectedLineItem && selectedLineItem.received || Number(quantity) !== 1
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                    { justified: true, title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_25__RepairOrders_constants__["h" /* MOD_TO */]) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_25__RepairOrders_constants__["h" /* MOD_TO */],
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_25__RepairOrders_constants__["h" /* MOD_TO */]),
                      icon: "fa-check-circle",
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                      disabled: locked || !getFieldValue(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["p" /* PURCHASE_FOR_REPAIR */])
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
                  { "in": modTo || false, unmountOnExit: true },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                    { md: 4 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_25__RepairOrders_constants__["i" /* MOD_TO_ID */],
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_25__RepairOrders_constants__["h" /* MOD_TO */]),
                      placeholder: "Type a part's number...",
                      selectedItem: selectedModTo,
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["n" /* AutoCompleteField */],
                      onItemSelected: function onItemSelected(item) {
                        return item && _this2.setState({ selectedModTo: item });
                      },
                      search: searchParts,
                      formatItem: function formatItem(result) {
                        return result && result.part_number;
                      },
                      disabled: locked
                    })
                  )
                )
              ),
              this.props.showBuyers && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__shared_components__["m" /* DashedSeparator */], null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  null,
                  "Buyers"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                    { md: 5 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: "read_only_buyer",
                      label: "Buyer",
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                      disabled: true,
                      required: true
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                    { md: 3 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_6__constants__["G" /* BUYER_CREDIT_PCT */],
                      className: "text-right",
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                      options: buyerCreditPctOptions,
                      prompt: false,
                      label: "Buyer Credit",
                      disabled: locked,
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_shared__["b" /* CoBuyersFields */], {
                    toggleBuyer: this.toggleBuyer,
                    buyerCreditPct: buyerCreditPct,
                    selectedCoBuyer: selectedCoBuyer,
                    selectedThirdBuyer: selectedThirdBuyer,
                    numberOfBuyers: [getFieldValue(__WEBPACK_IMPORTED_MODULE_20__users_constants__["z" /* CO_BUYER_ID */]), getFieldValue(__WEBPACK_IMPORTED_MODULE_20__users_constants__["y" /* THIRD_BUYER_ID */])].filter(function (s) {
                      return s;
                    }).length + 1,
                    searchBuyers: searchBuyers,
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Orders_shared_InvoiceSection__["a" /* default */], {
                hidden: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_20__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_20__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_20__users_constants__["l" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_20__users_constants__["k" /* SALES */]]),
                disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_20__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_20__users_constants__["l" /* REPAIR */]]),
                orderType: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["x" /* PURCHASE_ORDER */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__shared_components__["m" /* DashedSeparator */], null),
              preferredRepairStationHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnauthorizedPreferredRepairStationSelectedWarning, null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Shipping & Repairs"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                selectedLineItem && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["W" /* AWB_NUMBER */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    label: "AWB #",
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["y" /* CONTAINER_FEE */],
                    label: "Container/Crate Fee",
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["z" /* HAZMAT_FEE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]),
                    disabled: locked,
                    required: markedHazardous
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["w" /* PREFERRED_REPAIR_STATION_ID */],
                    label: "Suggested Repair Station",
                    placeholder: "Type a vendor's name or code...",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["n" /* AutoCompleteField */],
                    search: searchRepairStations,
                    selectedItem: selectedPreferredRepairStation,
                    formatItem: function formatItem(result) {
                      return result && result.name;
                    },
                    disabled: locked || purchaseForStock,
                    watch: purchaseForStock ? selectedPreferredRepairStation : undefined,
                    required: this.repairStationRequired,
                    onItemSelected: this.handlePreferredRepairStation
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["u" /* EVALUATION_PERIOD */],
                    type: "number",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    disabled: locked,
                    label: "Eval. Period"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["A" /* CAP_TYPE */],
                    className: "text-right",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["B" /* CAP_TYPES */]),
                    label: "Repair/Overhaul Cap"
                  })
                ),
                capType && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["C" /* CAP_AMOUNT */],
                    label: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["B" /* CAP_TYPES */][capType].label + " Cap Amount",
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 12 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Fields"], {
                    names: [__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["D" /* AMOUNT_INSURED */], __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["E" /* PERCENT_INSURED */], __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["F" /* INSURANCE_TYPE */]],
                    component: InsuranceTypeField,
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Fields"], {
                  names: [__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["D" /* AMOUNT_INSURED */], __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["E" /* PERCENT_INSURED */], __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["F" /* INSURANCE_TYPE */], __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */], __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]],
                  component: InsuranceFields,
                  disabled: locked
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__shared_components__["m" /* DashedSeparator */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Notes"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["G" /* INTERNAL_NOTE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["G" /* INTERNAL_NOTE */]),
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["l" /* TextArea */],
                    rows: 5,
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */]),
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["l" /* TextArea */],
                    rows: 5,
                    disabled: locked
                  })
                )
              ),
              cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["H" /* CANCELLATION_REASON */],
                    className: "text-right",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["I" /* CANCELLATION_REASONS */],
                    prompt: false,
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["H" /* CANCELLATION_REASON */])
                  })
                )
              )
            ),
            modalMode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__PartSummary__["a" /* default */], {
                part: selectedPart,
                cost: cost,
                quantity: quantity,
                lineItem: this.props.selectedLineItem,
                hazmatFee: hazmatFee,
                containerFee: containerFee
              })
            )
          )
        ),
        renderFooter && renderFooter(formProps)
      );
    }
  }, {
    key: "repairStationRequired",
    get: function get() {
      var _props3 = this.props,
          purchaseForRepair = _props3.purchaseForRepair,
          condition = _props3.condition,
          getField = _props3.getField;


      return purchaseForRepair || condition === __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["i" /* AS_REMOVED */] && !getField(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["m" /* PURCHASE_FOR_SALE */]) && !getField(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["q" /* PURCHASE_FOR_STOCK */]);
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setTaggedById: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setTaggedByHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  showBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cap_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    co_buyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    third_buyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    part_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  renderFooter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  resetAlternatePartField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetExchangeSrpField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchAlternates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchParts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchRepairStations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setHeavyPackage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setHazardFields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setPartId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  domLifeYears: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  llp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectedPart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  setSelectedPart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setPreferredRepairStationHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetPreferredRepairStation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
Form.defaultProps = {
  modalMode: true,
  showBuyers: true
};
var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    getFieldValue: function getFieldValue(field) {
      return selector(state, field);
    },
    getInitialFieldValue: function getInitialFieldValue(field) {
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["getFormInitialValues"])(formName)(state), field);
    },
    buyerCreditPct: selector(state, __WEBPACK_IMPORTED_MODULE_6__constants__["G" /* BUYER_CREDIT_PCT */]),
    capType: selector(state, __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["A" /* CAP_TYPE */]),
    cost: selector(state, __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */]),
    quantity: selector(state, __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]),
    condition: selector(state, __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["n" /* CONDITION */]),
    srpCondition: selector(state, __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["C" /* SRP_CONDITION */]),
    srp: selector(state, __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["v" /* SUGGESTED_RETAIL */]),
    minExchangeSrp: state.session.getIn([__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_6__constants__["X" /* MINIMUM_EXCHANGE_SRP */]]),
    exchangeSRP: selector(state, __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["u" /* EXCHANGE_SRP */]),
    asIs: selector(state, __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["c" /* AS_IS */]),
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_20__users_constants__["a" /* USER */]).toJS(),
    lot: state.lotDetail.get(__WEBPACK_IMPORTED_MODULE_30__constants__["a" /* LOT */]).toJS(),
    hazmatFee: selector(state, __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]),
    containerFee: selector(state, __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["y" /* CONTAINER_FEE */]),
    markedHazardous: selector(state, __WEBPACK_IMPORTED_MODULE_13__parts_constants__["h" /* HAZMAT */]),
    modTo: selector(state, __WEBPACK_IMPORTED_MODULE_25__RepairOrders_constants__["h" /* MOD_TO */]),
    purchaseForStock: selector(state, __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["q" /* PURCHASE_FOR_STOCK */]),
    purchaseForRepair: selector(state, __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["p" /* PURCHASE_FOR_REPAIR */]),
    dom: selector(state, __WEBPACK_IMPORTED_MODULE_13__parts_constants__["G" /* DOM */]),
    getField: function getField(field) {
      return selector(state, field);
    }
  };
}, function (dispatch) {
  return {
    resetAlternatePartField: function resetAlternatePartField() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["o" /* ALTERNATE_ID */], null));
    },
    resetExchangeSrpField: function resetExchangeSrpField() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["u" /* EXCHANGE_SRP */], null));
    },
    changeExchangeSrpField: function changeExchangeSrpField(value) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["u" /* EXCHANGE_SRP */], value));
    },
    setPartId: function setPartId(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["q" /* PART_ID */], id));
    },
    setHazardFields: function setHazardFields(part) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_13__parts_constants__["i" /* BIO_HAZMAT */], part.bio_hazmat));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_13__parts_constants__["h" /* HAZMAT */], part.hazmat));
    },
    setHeavyPackage: function setHeavyPackage(part) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["v" /* DIM_WEIGHT */], part.dim_weight));
    },
    searchAlternates: function searchAlternates(partId) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_actions__["e" /* searchAlternates */](partId));
    },
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_actions__["c" /* searchBuyers */](filter));
    },
    searchParts: function searchParts(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_16__parts_actions__["a" /* searchPoParts */](filter));
    },
    searchRepairStations: function searchRepairStations(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_actions__["f" /* searchRepairStations */](filter));
    },
    resetForm: function resetForm(id) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["replace"])("/lots/" + id));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, field, val));
      };
    },
    setTaggedById: function setTaggedById(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["O" /* TAGGED_BY_ID */], id));
    },
    setTaggedByHold: function setTaggedByHold(hold) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, "tagged_by_hold", hold));
    },
    setPreferredRepairStationHold: function setPreferredRepairStationHold(hold) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, "preferred_repair_station_hold", hold));
    },
    resetPreferredRepairStation: function resetPreferredRepairStation() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_redux_form__["change"])(formName, "preferred_repair_station_id", ""));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_36__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_constants__ = __webpack_require__(23);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;







function validate(values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["q" /* PART_ID */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_3__constants__["_28" /* MARKUP */], __WEBPACK_IMPORTED_MODULE_3__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_3__constants__["G" /* BUYER_CREDIT_PCT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);

    form.validate(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["G" /* LEAD_TIME */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["g" /* requiredAllowZero */]);
    form.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["f" /* isGreaterThan */](0));
    form.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["_28" /* MARKUP */], __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["E" /* PERCENT_INSURED */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["h" /* isBetween */](1, 100));

    if (props && props.domLifeYears && props.llp || props.selectedPart && props.selectedPart.dom_sensitive) {
      form.validate(__WEBPACK_IMPORTED_MODULE_5__parts_constants__["G" /* DOM */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if (props.selectedPart && props.selectedPart.hazmat) {
      form.validate(__WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0));
    }

    form.validate(__WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["w" /* PREFERRED_REPAIR_STATION_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);

    if ([__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["i" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["P" /* INSPECTED */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["h" /* REPAIRED */]].includes(values.condition)) {
      form.validate(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["x" /* TAG_DATE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      form.validate(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["p" /* TAGGED_BY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }
  });
}

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(114);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return managedRepairOrderLineItems; });




var managedRepairOrderLineItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "managedRepairOrderLineItems",
  fetch: __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* searchLineItems */],
  initialSettings: {
    pageSize: 5
  }
});

/* harmony default export */ __webpack_exports__["b"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "managedRepairOrders",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].managedRepairOrders.search,
  initialSettings: {
    sort: "created_at",
    sortReverse: true
  }
}));

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(36);
/* harmony export (immutable) */ __webpack_exports__["a"] = PartSummary;










function HazmatWarning(_ref) {
  var bioHazmat = _ref.bio_hazmat,
      hazmat = _ref.hazmat;

  var warnings = [];
  if (hazmat) {
    warnings.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__parts_constants__["h" /* HAZMAT */]));
  }

  if (bioHazmat) {
    warnings.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__parts_constants__["i" /* BIO_HAZMAT */]));
  }

  if (warnings.length === 0) {
    return false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components__["n" /* Warning */],
    null,
    "This line item is marked: ",
    warnings.join(", ")
  );
}

HazmatWarning.propTypes = {
  hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bio_hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function PartSummary(_ref2) {
  var part = _ref2.part,
      quantity = _ref2.quantity,
      cost = _ref2.cost,
      lineItem = _ref2.lineItem,
      hazmatFee = _ref2.hazmatFee,
      containerFee = _ref2.containerFee;

  var calculateCost = function calculateCost(qty, costUnit) {
    var fees = parseFloat(hazmatFee || 0) + parseFloat(containerFee || 0);
    if (fees > 0) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(parseFloat(qty) * parseFloat(costUnit) + fees) || "$0.00";
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(parseFloat(qty) * parseFloat(costUnit)) || "$0.00";
  };

  var reason = __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["I" /* CANCELLATION_REASONS */].find(function (x) {
    return x.value === (lineItem && lineItem.cancellation_reason);
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "well" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h6",
      { className: "h4" },
      "Part Summary"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed table-padding-horizonal-none margin-bottom-none" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Part #",
            part && part.part_number
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            cost
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { colSpan: "2" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "em",
              { className: "text-muted" },
              part && part.description
            )
          )
        ),
        lineItem && lineItem.repair_order_line_item && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Repair:"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_router_dom__["a" /* Link */],
              {
                to: "/repair-orders/" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "repair_order_line_item.repair_order.uuid")
              },
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "repair_order_line_item.repair_order.code")
            )
          )
        ),
        hazmatFee && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Hazmat Fee: "
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            parseFloat(hazmatFee).toFixed(2)
          )
        ),
        containerFee && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Container/Crate Fee: "
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            parseFloat(containerFee).toFixed(2)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "QTY"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            quantity
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { colSpan: "2" },
            HazmatWarning(lineItem || {})
          )
        )
      )
    ),
    lineItem && lineItem.cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { style: { color: "#f44336" } },
        "Cancellation Reason:"
      ),
      " ",
      reason.text,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed table-padding-horizonal-none" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              { className: "h4 margin-top-none margin-bottom-none" },
              "Total"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              { className: "h4 margin-top-none margin-bottom-none" },
              calculateCost(quantity, cost)
            )
          )
        )
      )
    )
  );
}

PartSummary.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  hazmatFee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerFee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return residentExpertSearch; });





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "shoppingLists",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].shoppingList.search,
  initialSettings: {
    sort: "most_recent_sale_date"
  }
}));

var residentExpertSearch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "residentExpertSearch",
  fetch: function fetch(params) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].shoppingList.search(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(params, {
      resident_expert_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hooks__["a" /* useCurrentUser */])().id
    }));
  },
  initialSettings: {
    sort: "tier_type",
    reverse: true
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Table__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MarkAllRead_MarkAllRead__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pagination__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PaginationController__ = __webpack_require__(1455);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filters; });
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

















var defaultFilters = {
  all_oqs_quoted_3_times: undefined,
  company: undefined,
  customer_rma: undefined,
  part: undefined,
  incoming_quote: undefined,
  inventory: undefined,
  outgoing_quote: undefined,
  purchase_order: undefined,
  received_order: undefined,
  repair: undefined,
  sales_admin: undefined,
  sales_order: undefined,
  vendor_rma: undefined,
  filter: undefined
};

var NotificationIcon = function NotificationIcon(_ref) {
  var icon = _ref.icon,
      title = _ref.title;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "i",
    { className: "fa fa-" + icon },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      {
        style: {
          fontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif"
        }
      },
      " ",
      "- ",
      title
    )
  );
};

NotificationIcon.propTypes = {
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var UrlIcon = function UrlIcon(_ref2) {
  var url = _ref2.url,
      title = _ref2.title;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { display: "inline-block" } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: url, height: "17px", alt: title }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      null,
      "\xA0-\xA0",
      title
    )
  );
};

UrlIcon.propTypes = {
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var filters = [{
  key: "part",
  label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotificationIcon, { title: "Parts", icon: "cogs" }),
  filters: _extends({}, defaultFilters, { part: true })
}, {
  key: "incoming_quote",
  label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotificationIcon, { icon: "quote-left", title: "Incoming Quotes" }),
  filters: _extends({}, defaultFilters, { incoming_quote: true })
}, {
  key: "inventory",
  label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UrlIcon, {
    url: "https://aero-zone-assets.s3.amazonaws.com/inventory.png",
    title: "Inventory"
  }),
  filters: _extends({}, defaultFilters, { inventory: true })
}, {
  key: "outgoing_quote",
  label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotificationIcon, { icon: "quote-right", title: "Outgoing Quotes" }),
  filters: _extends({}, defaultFilters, { outgoing_quote: true })
}, {
  key: "purchase_order",
  label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotificationIcon, { icon: "shopping-cart", title: "Purchase Orders" }),
  filters: _extends({}, defaultFilters, { purchase_order: true })
}, {
  key: "sales_order",
  label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotificationIcon, { icon: "dollar", title: "Sales Orders" }),
  filters: _extends({}, defaultFilters, { sales_order: true })
}, {
  key: "repair",
  label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotificationIcon, { icon: "wrench", title: "Repairs" }),
  filters: _extends({}, defaultFilters, { repair: true })
}, {
  key: "customer_rma",
  label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotificationIcon, { icon: "cog", title: "Customer RMAs" }),
  filters: _extends({}, defaultFilters, { customer_rma: true })
}, {
  key: "vendor_rma",
  label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotificationIcon, { icon: "shield", title: "Vendor RMAs" }),
  filters: _extends({}, defaultFilters, { vendor_rma: true })
}, {
  key: "company",
  label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotificationIcon, { icon: "building", title: "Companies" }),
  filters: _extends({}, defaultFilters, { company: true })
}, {
  key: "received_order",
  label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotificationIcon, { icon: "truck", title: "Received Orders" }),
  filters: _extends({}, defaultFilters, { received_order: true })
}, {
  key: "sales_admin",
  label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotificationIcon, { icon: "vcard", title: "Sales Admin Notifications" }),
  filters: _extends({}, defaultFilters, { sales_admin: true }),
  withAuthorization: { roles: [__WEBPACK_IMPORTED_MODULE_6__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_6__users_constants__["m" /* ACCOUNTING */]] }
}, {
  key: "read",
  label: "Read",
  filters: { read: true }
}, {
  key: "read",
  label: "Unread",
  filters: { read: false }
}, {
  key: "all",
  label: "All Notifications",
  filters: _extends({}, defaultFilters)
}];

var filterTags = [{
  label: "Show Parts",
  key: "part"
}, {
  label: "Show Incoming Quotes",
  key: "incoming_quote"
}, {
  label: "Show Inventory",
  key: "inventory"
}, {
  label: "Show Outgoing Quotes",
  key: "outgoing_quote"
}, {
  label: "Show Purchase Orders",
  key: "purchase_order"
}, {
  label: "Show Sales Orders",
  key: "sales_order"
}, {
  label: "Show Repairs",
  key: "repair"
}, {
  label: "Show Customer RMA and Warranties",
  key: "customer_rma"
}, {
  label: "Show Received Orders",
  key: "received_order"
}, {
  label: "Show Companies",
  key: "company"
}, {
  label: "Show Vendor Rmas",
  key: "vendor_rma"
}, {
  label: "Sales Admin Notifications",
  key: "sales_admin"
}, {
  label: "Read",
  key: "read",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Unread",
  key: "read",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_filters__["a" /* matchesBoolean */])(false)
}];

function Search() {
  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__hooks__["a" /* useCurrentUser */])();

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      users = _useState2[0],
      setUsers = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].users.search({ active: true, limit: 1000, sort: __WEBPACK_IMPORTED_MODULE_6__users_constants__["K" /* LAST_NAME */], reverse: false }).then(function (_ref3) {
      var data = _ref3.data;

      setUsers(data.results);
      return function cleanup() {};
    });
  }, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_13__pagination__["a" /* default */], syncWithUrl: true },
    function (searchProps) {
      var filtersSet = searchProps.paginator.toJS().filters;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__PaginationController__["a" /* default */], _extends({}, searchProps, { limit: 20 })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { display: "inline-block" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
            title: "Notifications",
            filters: filterTags.concat(users.map(function (u) {
              return {
                key: "user_id",
                label: u.full_name,
                matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_filters__["c" /* matchesInt */])(u.id)
              };
            }))
          }))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group-searchbar", style: { float: "right" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { float: "right", paddingRight: "30px" } },
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["isEmpty"])(filtersSet.user_id) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__MarkAllRead_MarkAllRead__["a" /* default */], _extends({ filters: filtersSet }, searchProps)),
              currentUser.role === __WEBPACK_IMPORTED_MODULE_6__users_constants__["i" /* ADMIN */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
                filters: users.map(function (u) {
                  return {
                    key: "user_id",
                    label: u.full_name,
                    filters: { user_id: u.id }
                  };
                }),
                title: "User",
                right: true
              })),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, { filters: filters, right: true }))
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Table__["a" /* default */], _extends({}, searchProps, { filtersSet: filtersSet })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__["Paginator"], _extends({}, searchProps, { listId: "searchNotifications" }))
      );
    }
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined)(Search));

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["a"] = Contact;




function Contact(_ref) {
  var contact = _ref.contact;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-condensed" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Contact"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          contact && contact.get(__WEBPACK_IMPORTED_MODULE_2__constants__["S" /* NAME */])
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Contact Email"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { href: "mailto:" + (contact && contact.get(__WEBPACK_IMPORTED_MODULE_2__constants__["T" /* EMAIL */])) },
            contact && contact.get(__WEBPACK_IMPORTED_MODULE_2__constants__["T" /* EMAIL */])
          )
        )
      )
    )
  );
}

Contact.propTypes = {
  contact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_pagination__ = __webpack_require__(67);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["a" /* createPaginatedList */])({
  listId: "outgoingQuotes",
  fetch: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].outgoingQuotes.search,
  initialSettings: {
    sort: "created_at",
    sortReverse: true
  }
}));

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);







/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var lineItem = _ref.lineItem;

  var followUpFeedback = lineItem[__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* FOLLOW_UP_FEEDBACK */]] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])("" + lineItem[__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* FOLLOW_UP_FEEDBACK */]] + (lineItem.internal_note ? ":" : "") + " " + (lineItem.internal_note ? lineItem.internal_note : "") + " " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["a" /* shortDateYYandTime */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, "internal_note_audit.updated_at")));

  var noteProps = {
    note: [followUpFeedback || lineItem.internal_note, lineItem.external_note].filter(function (f) {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(f);
    }).join(" | "),
    color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(lineItem[__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* FOLLOW_UP_FEEDBACK */]]) ? undefined : "#f44336"
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["G" /* NoteTooltipTableCell */], noteProps);
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["a"] = OutgoingQuoteTypeSelect;










function OutgoingQuoteTypeSelect(_ref) {
  var _ref$change = _ref.change,
      change = _ref$change === undefined ? function () {} : _ref$change,
      condition = _ref.condition,
      inventoryId = _ref.inventory_id,
      offer = _ref.offer,
      price_per_unit = _ref.price_per_unit,
      quantity = _ref.quantity,
      exchange_fee = _ref.exchange_fee,
      price = _ref.price,
      quoteTypes = _ref.quoteTypes,
      tagDate = _ref.tag_date,
      taggedBy = _ref.tagged_by,
      traceType = _ref.trace_type,
      tracedTo = _ref.traced_to,
      warranty = _ref.warranty;

  var minOutrightVal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__hooks_useCurrentUser__["b" /* useSettings */])()[__WEBPACK_IMPORTED_MODULE_8__constants__["_22" /* MIN_OUTRIGHT_VALUE_FOR_EXCHANGE_CONSIDERATION */]];

  var handleChange = function handleChange(ev) {
    var newQuoteType = ev.target.value;

    if (offer) {
      offer.input.onChange(null);
    }

    if ([__WEBPACK_IMPORTED_MODULE_5__constants__["j" /* EXCHANGE_ONLY */], __WEBPACK_IMPORTED_MODULE_5__constants__["o" /* MAKE_OFFER */], __WEBPACK_IMPORTED_MODULE_5__constants__["h" /* NO_QUOTE */], __WEBPACK_IMPORTED_MODULE_5__constants__["E" /* AWAITING_INFO_TO_COMPLETE */]].includes(newQuoteType)) {
      price_per_unit.input.onChange(null);
    } else if ([__WEBPACK_IMPORTED_MODULE_5__constants__["k" /* AOG */], __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* STANDARD */]].includes(newQuoteType)) {
      price_per_unit.input.onChange(price);
    }

    if (newQuoteType === __WEBPACK_IMPORTED_MODULE_5__constants__["q" /* OFFER */]) {
      change("send_quote", false);
    }

    if (newQuoteType === __WEBPACK_IMPORTED_MODULE_5__constants__["h" /* NO_QUOTE */]) {
      quantity.input.onChange(0);
      [condition, inventoryId, traceType, tagDate, taggedBy, tracedTo].forEach(function (f) {
        return f.input.onChange(null);
      });
    }

    if (newQuoteType !== __WEBPACK_IMPORTED_MODULE_5__constants__["j" /* EXCHANGE_ONLY */]) {
      exchange_fee.input.onChange(null);
    }

    if (minOutrightVal && Number(minOutrightVal) > price || newQuoteType === __WEBPACK_IMPORTED_MODULE_5__constants__["o" /* MAKE_OFFER */]) {
      exchange_fee.input.onChange(null);
    }

    if (newQuoteType === __WEBPACK_IMPORTED_MODULE_5__constants__["n" /* AS_IS */]) {
      warranty.input.onChange("No Warranty, unit sold as-is.");
    } else {
      warranty.input.onChange(null);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_5__constants__["f" /* QUOTE_TYPE */],
    component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["c" /* Select */],
    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["a" /* toOptions */])(quoteTypes),
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_5__constants__["f" /* QUOTE_TYPE */]),
    prompt: null,
    onChange: handleChange,
    required: true
  });
}

OutgoingQuoteTypeSelect.propTypes = {
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  change: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  inventory_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  price_per_unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  tag_date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  tagged_by: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  trace_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  traced_to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  exchange_fee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  quoteTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  warranty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_pagination__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Receiving_constants__ = __webpack_require__(34);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shipmentsPagination; });
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








var SHIPMENTS = "shipments";

var shipmentsPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["a" /* createPaginatedList */])({
  listId: SHIPMENTS,
  fetch: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].shipments.search,
  stateLocator: function stateLocator(state) {
    return state.shipmentsPagination.main;
  }
});

var _paginationGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["b" /* paginationGroup */])({
  groupName: SHIPMENTS,
  getId: function getId(state) {
    return state.shipmentDetail.getIn([__WEBPACK_IMPORTED_MODULE_5__Receiving_constants__["e" /* SHIPMENT */], __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* ID */]]);
  },
  locate: function locate(_ref) {
    var key = _ref.key;
    return function (state) {
      return state.shipmentsPagination[key];
    };
  }
}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__parts_pagination__["a" /* config */])("lineItems", false, __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].shipments.lineItems.search)),
    _paginationGroup2 = _slicedToArray(_paginationGroup, 1),
    lineItems = _paginationGroup2[0];

/* harmony default export */ __webpack_exports__["b"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux__["combineReducers"])({
  main: shipmentsPagination.paginator,
  lineItems: lineItems
}));

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
var SET = "purchaseOrders/SET";

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Warning__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);





function renderWarning(_ref) {
  var part = _ref.part,
      domFromLineItem = _ref.domFromLineItem;

  if (!part || !part.dom_life_years || !part.llp || !domFromLineItem) return false;
  var today = new Date().getTime();
  var dom = new Date(domFromLineItem).getTime();
  var yearsRemaining = (today - dom) / (24 * 60 * 60 * 365 * 1000);
  return today > dom && yearsRemaining >= part.dom_life_years * 0.6;
}

function DomLifeWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Warning__["a" /* Warning */],
    null,
    "The DOM Life for this item is less than 40% and will require Manager Approval"
  );
}

DomLifeWarning.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    dom_life_years: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    llp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
  }).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var part = _ref2.part,
      domFromLineItem = _ref2.domFromLineItem;
  return renderWarning({ part: part, domFromLineItem: domFromLineItem });
})(DomLifeWarning));

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = SRPConditionMismatchWarning;



function SRPConditionMismatchWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components__["n" /* Warning */],
    null,
    "Warning \u2013 For units purchased FOR STOCK, Condition and SRP Condition must match."
  );
}

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Orders_shared_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Warning; });
/* harmony export (immutable) */ __webpack_exports__["b"] = Warnings;







var Warning = function Warning(_ref) {
  var label = _ref.label,
      icon = _ref.icon,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? "danger" : _ref$type;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label label-" + type, style: { marginLeft: "5px" } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-" + icon }),
    "\xA0\xA0",
    label
  );
};

Warning.propTypes = {
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

function Warnings(_ref2) {
  var purchaseOrder = _ref2.purchaseOrder;

  var ema = purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_5__constants__["A" /* LINE_ITEMS */]).some(function (l) {
    return l.get(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_71" /* CONSIGNMENT_TYPE */]) === __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__["s" /* EMA */];
  });
  var consignment = purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_5__constants__["A" /* LINE_ITEMS */]).some(function (l) {
    return l.get(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_71" /* CONSIGNMENT_TYPE */]) === __WEBPACK_IMPORTED_MODULE_3__Orders_shared_constants__["l" /* CONSIGNMENT */];
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_5__constants__["_38" /* CANCELLED */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Warning, { label: "Cancelled", icon: "ban" }),
    ema && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Warning, {
      label: __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__["s" /* EMA */].toUpperCase(),
      icon: "location-arrow",
      type: "warning"
    }),
    consignment && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Warning, {
      label: __WEBPACK_IMPORTED_MODULE_3__Orders_shared_constants__["l" /* CONSIGNMENT */].toUpperCase(),
      icon: "location-arrow",
      type: "warning"
    })
  );
}

Warnings.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_pagination__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(62);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return purchaseOrdersPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return expireReceivedCores; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return purchaseOrderLineItems; });
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









var purchaseOrdersPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "purchaseOrders",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].purchaseOrders.search,
  forceDebounce: true,
  stateLocator: function stateLocator(state) {
    return state.purchaseOrdersPagination.main;
  }
});

var expireReceivedCores = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__["composables"])({
  listId: "purchaseOrders/receivedCores"
}).expire;

var purchaseOrderLineItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "purchaseOrderLineItems",
  fetch: __WEBPACK_IMPORTED_MODULE_6__actions__["b" /* searchLineItems */],
  initialSettings: {
    pageSize: 5
  }
});

var _paginationGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["b" /* paginationGroup */])({
  groupName: "purchaseOrders",
  getId: function getId(state) {
    return state.purchaseOrderDetail.getIn(["purchaseOrder", __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* ID */]]);
  },
  locate: function locate(_ref) {
    var key = _ref.key;
    return function (state) {
      return state.purchaseOrdersPagination[key];
    };
  }
}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__parts_pagination__["a" /* config */])("receivingRecords", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].purchaseOrders.receivingRecords.search), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__parts_pagination__["a" /* config */])("receivedCores", false, __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].purchaseOrders.receivedCores.search)),
    _paginationGroup2 = _slicedToArray(_paginationGroup, 2),
    receivingRecords = _paginationGroup2[0],
    receivedCores = _paginationGroup2[1];

/* harmony default export */ __webpack_exports__["d"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux__["combineReducers"])({
  main: purchaseOrdersPagination.paginator,
  receivingRecords: receivingRecords,
  receivedCores: receivedCores
}));

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Warning_Warning__ = __webpack_require__(53);





function BioHazmatWarning(_ref) {
  var parts = _ref.parts,
      shippingType = _ref.shippingType;

  if (shippingType === __WEBPACK_IMPORTED_MODULE_2__shared_components_ShippingSection_shippingTypes__["a" /* TENANT_LOCATION */] && parts && parts.some(function (p) {
    return p.bio_hazmat;
  })) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Warning_Warning__["a" /* default */],
      { warningType: "danger" },
      "Part is labeled bio-hazardous. If in as removed condition, please consider shipping directly to repair station."
    );
  }

  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (BioHazmatWarning);

BioHazmatWarning.propTypes = {
  parts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_DataTables__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parts_components_ModifiedFlag__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inventories_components_Detail_Warnings__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__hooks_useDebounce__ = __webpack_require__(201);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PreviousSrpConditionWarning; });
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();















var SrpWarning = function SrpWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Warning: Your SRP does not match the next inventory item with matching conditions. Please try and keep pricing uniform."
  );
};

var PreviousSrpConditionWarning = function PreviousSrpConditionWarning(_ref) {
  var displayInventory = _ref.displayInventory,
      excludeInventoryId = _ref.excludeInventoryId,
      srpCondition = _ref.srpCondition,
      srp = _ref.srp,
      partId = _ref.partId;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      inventories = _useState2[0],
      setInventories = _useState2[1];

  var debouncedSearchArgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__hooks_useDebounce__["a" /* default */])(500, srpCondition, partId, srp);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (debouncedSearchArgs.filter(function (arg) {
      return ![undefined, null].includes(arg);
    }).length > 2) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].inventories.search({
        exclude_inventory_id: excludeInventoryId,
        part_id: debouncedSearchArgs[1],
        matching_condition: debouncedSearchArgs[0],
        ranking: true,
        limit: 3
      }).then(function (res) {
        setInventories(res.data.results);
      });
    }

    return function cleanup() {};
  }, debouncedSearchArgs);

  if (inventories.length > 0 && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(srp) && parseFloat(srp) !== parseFloat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(inventories, "[0]." + __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["v" /* SUGGESTED_RETAIL */]))) {
    if (displayInventory) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SrpWarning, null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Next In Line"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_DataTables__["a" /* DataTable */].Mini,
          { noMargin: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_DataTables__["a" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Serial Number"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "CD"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tag Date"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Store Location"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Cost/Unit"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Exch SRP"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "SRP"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_DataTables__["a" /* DataTable */].Body,
            null,
            inventories.map(function (inventory) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  inventory.serial_number
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  { style: __WEBPACK_IMPORTED_MODULE_7__parts_components_ModifiedFlag__["a" /* columnStyle */].conditionColumn },
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["r" /* INVENTORIES */], "condition." + inventory.condition + ".abbrev")
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__inventories_components_Detail_Warnings__["a" /* RepairAndHold */], { inventory: inventory }),
                  inventory.status !== __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["k" /* REPAIR_AND_HOLD */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_date__["d" /* alphaMonthYear */])(inventory.tag_date)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  { className: "text-center" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["o" /* LocationFlag */], { location: inventory.store_location_id })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  { className: "text-right" },
                  inventory.cost_per_unit && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_currency__["a" /* dollars */])(inventory.cost_per_unit)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  { className: "text-right" },
                  inventory.exchange_srp && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_currency__["a" /* dollars */])(inventory.exchange_srp)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  { className: "text-right" },
                  inventory.suggested_retail && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_currency__["a" /* dollars */])(inventory.suggested_retail)
                )
              );
            })
          )
        )
      );
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SrpWarning, null);
  }
  if (inventories.length !== 0) setInventories([]);

  return null;
};

PreviousSrpConditionWarning.propTypes = {
  displayInventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  excludeInventoryId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  partId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  srpCondition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  srp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SalesOrders_constants__ = __webpack_require__(32);
/* harmony export (immutable) */ __webpack_exports__["b"] = ReserveForSaleFields;
/* harmony export (immutable) */ __webpack_exports__["a"] = PurchaseForFields;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



















function PurchaseForCheckboxes(_ref) {
  var asIs = _ref.asIs,
      stock = _ref.purchase_for_stock.input,
      assist = _ref.purchase_for_repair_assist.input,
      sale = _ref.purchase_for_sale.input,
      repair = _ref.purchase_for_repair.input,
      clearPurchaseFor = _ref.clearPurchaseFor,
      clearReserveForSaleQty = _ref.clearReserveForSaleQty,
      disabled = _ref.disabled,
      shippingType = _ref.shippingType,
      condition = _ref.condition,
      onPurchaseForStockChange = _ref.onPurchaseForStockChange,
      onPurchaseForSaleChange = _ref.onPurchaseForSaleChange,
      onPurchaseForRepair = _ref.onPurchaseForRepair;

  var settings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__hooks_useCurrentUser__["b" /* useSettings */])();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group", style: { cursor: "pointer" } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { className: "control-label", htmlFor: "purchase_for" },
      "Purchase For ",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "sup",
        { className: "small text-danger" },
        "*"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        id: "purchase_for",
        className: "btn-group btn-group-justified",
        "data-toggle": "buttons"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["b" /* Check */], {
        input: stock,
        label: "Stock",
        icon: "fa-check-circle",
        disabled: disabled || [__WEBPACK_IMPORTED_MODULE_5__constants__["K" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_5__constants__["L" /* DROPSHIP */]].includes(shippingType) || condition === __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* AS_REMOVED */] && !asIs && !stock.value && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_10__constants__["Y" /* BUY_AR_FOR_STOCK */]),
        onChange: function onChange(ev) {
          onPurchaseForStockChange(ev);
          clearPurchaseFor(ev, [sale.name, repair.name, assist.name]);
          clearReserveForSaleQty(ev);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["b" /* Check */], {
        disabled: disabled,
        input: assist,
        label: "Repair Assist",
        icon: "fa-check-circle",
        onChange: function onChange(ev) {
          clearPurchaseFor(ev, [sale.name, repair.name, stock.name]);
          clearReserveForSaleQty(ev);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["b" /* Check */], {
        input: repair,
        disabled: disabled,
        label: "Reserve for Repair",
        icon: "fa-check-circle",
        onChange: function onChange(ev) {
          clearPurchaseFor(ev, [stock.name, assist.name]);
          clearReserveForSaleQty(ev);
          onPurchaseForRepair(ev);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["b" /* Check */], {
        disabled: disabled,
        input: sale,
        label: "Reserve for Sale",
        icon: "fa-check-circle",
        onChange: function onChange(ev) {
          clearPurchaseFor(ev, [stock.name, assist.name]);
          clearReserveForSaleQty(!ev);
          onPurchaseForSaleChange(ev);
        }
      })
    )
  );
}

PurchaseForCheckboxes.propTypes = {
  asIs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  clearPurchaseFor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  clearReserveForSaleQty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  purchase_for_stock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["o" /* FormTypes */].boolInput.isRequired
  }),
  purchase_for_repair_assist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["o" /* FormTypes */].boolInput.isRequired
  }),
  purchase_for_sale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ input: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["o" /* FormTypes */].boolInput.isRequired }),
  purchase_for_repair: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["o" /* FormTypes */].boolInput.isRequired
  }),
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onPurchaseForSaleChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onPurchaseForStockChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

PurchaseForCheckboxes.defaultProps = {
  onPurchaseForStockChange: function onPurchaseForStockChange() {
    return null;
  }
};

function PlaceholderSalesItems(_ref2) {
  var lineItems = _ref2.lineItems,
      getField = _ref2.getField,
      prefix = _ref2.prefix,
      setField = _ref2.setField;

  if (!lineItems) return null;
  if (lineItems.length === 0) return null;

  var fieldName = function fieldName(name) {
    return [prefix, name].filter(function (i) {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(i);
    }).join(".");
  };

  var setValues = function setValues(lineItem) {
    var _mapping;

    var mapping = (_mapping = {}, _defineProperty(_mapping, __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["u" /* EXCHANGE_SRP */], lineItem.exchange_fee), _defineProperty(_mapping, __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["v" /* SUGGESTED_RETAIL */], lineItem.price_per_unit), _defineProperty(_mapping, __WEBPACK_IMPORTED_MODULE_5__constants__["n" /* RESERVE_FOR_SALE_QUANTITY */], lineItem.quantity === 1 ? 1 : null), _mapping);
    Object.keys(mapping).forEach(function (f) {
      setField(fieldName(f))(mapping[f]);
    });
  };

  var renderRow = function renderRow(lineItem, i) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      { key: i },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { style: { backgroundColor: "#383838" } },
        i + 1
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-center" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          type: "radio",
          name: __WEBPACK_IMPORTED_MODULE_5__constants__["P" /* PURCHASED_FOR_SOLI_ID */],
          className: "radio-inline",
          checked: lineItem.id === getField(fieldName(__WEBPACK_IMPORTED_MODULE_5__constants__["P" /* PURCHASED_FOR_SOLI_ID */])),
          onChange: function onChange() {
            var field = fieldName(__WEBPACK_IMPORTED_MODULE_5__constants__["P" /* PURCHASED_FOR_SOLI_ID */]);
            setField(field)(lineItem.id);
            setValues(lineItem);
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_date__["c" /* shortDateYY */])(lineItem.created_at)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        lineItem.part.part_number
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        lineItem.sales_order_code
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        lineItem.condition && __WEBPACK_IMPORTED_MODULE_16__SalesOrders_constants__["h" /* CONDITIONS */][lineItem.condition].abbrev
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        lineItem.exchange_sale ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_currency__["a" /* dollars */])(lineItem.exchange_fee) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_currency__["a" /* dollars */])(lineItem.price_per_unit)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        lineItem.quantity
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.seller.full_name)
      )
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "col-md-12 reset-panel-table" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-striped table-hover table-numbered" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "thead",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Reserved At"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Part #"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "SO #"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "CD"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Price"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "QTY"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Reserved For"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        lineItems.map(renderRow)
      )
    )
  );
}

function ReserveForSaleFields(_ref3) {
  var getFieldValue = _ref3.getFieldValue,
      purchase_for_sale = _ref3.purchase_for_sale,
      prefix = _ref3.prefix,
      searchBuyers = _ref3.searchBuyers,
      selectedReserveForSeller = _ref3.selectedReserveForSeller,
      setFieldValue = _ref3.setFieldValue,
      disabled = _ref3.disabled,
      qtyDisabled = _ref3.qtyDisabled;

  if (!purchase_for_sale.input.value) {
    return false;
  }

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      placeholderSalesItems = _useState2[0],
      setPlaceholderSalesItems = _useState2[1];

  var allocateToSo = getFieldValue([prefix, __WEBPACK_IMPORTED_MODULE_5__constants__["Q" /* ALLOCATE_TO_SO */]].filter(function (f) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(f);
  }).join("."));

  var partId = getFieldValue([prefix, __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["q" /* PART_ID */]].filter(function (f) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(f);
  }).join("."));

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (partId) {
      var params = { placeholder: true, part_id: partId, limit: 100 };
      var currentPlaceHolderId = getFieldValue([prefix, __WEBPACK_IMPORTED_MODULE_5__constants__["P" /* PURCHASED_FOR_SOLI_ID */]].filter(function (f) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(f);
      }).join("."));

      if (currentPlaceHolderId) {
        params.current_placeholder_id = currentPlaceHolderId;
      }

      __WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].salesOrders.search(params).then(function (_ref4) {
        var data = _ref4.data;

        setPlaceholderSalesItems(data.results);
      });
    } else {
      setPlaceholderSalesItems([]);
    }

    return function cleanup() {};
  }, [partId]);

  var hasPlaceholders = placeholderSalesItems.length > 0;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__["a" /* default */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 4 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
        name: __WEBPACK_IMPORTED_MODULE_10__constants__["Z" /* RESERVE_FOR_SELLER_ID */],
        label: "Reserve for Salesperson",
        placeholder: "Search by name...",
        component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["n" /* AutoCompleteField */],
        search: searchBuyers,
        selectedItem: selectedReserveForSeller,
        formatItem: function formatItem(result) {
          return result && result.full_name;
        },
        disabled: disabled,
        required: true
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 4 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
        name: __WEBPACK_IMPORTED_MODULE_5__constants__["n" /* RESERVE_FOR_SALE_QUANTITY */],
        component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["d" /* FormInput */],
        label: "Reserve QTY",
        type: "number",
        disabled: qtyDisabled,
        required: true,
        inputProps: {
          min: 1
        }
      })
    ),
    hasPlaceholders && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["a" /* CheckGroup */],
        { title: "Allocate to Existing SO" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
          component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["b" /* Check */],
          name: __WEBPACK_IMPORTED_MODULE_5__constants__["Q" /* ALLOCATE_TO_SO */],
          label: "Allocate to Existing SO",
          disabled: !hasPlaceholders,
          onChange: function onChange(_ev, val) {
            if (!val) {
              setFieldValue([prefix, __WEBPACK_IMPORTED_MODULE_5__constants__["P" /* PURCHASED_FOR_SOLI_ID */]].filter(function (f) {
                return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(f);
              }).join("."))(null);
            }
          }
        })
      )
    )
  ), allocateToSo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__["a" /* default */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PlaceholderSalesItems, {
      prefix: prefix,
      getField: getFieldValue,
      lineItems: placeholderSalesItems,
      setField: setFieldValue
    })
  )];
}

ReserveForSaleFields.propTypes = {
  purchase_for_sale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["o" /* FormTypes */].boolInput.isRequired
  }),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  qtyDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectedReserveForSeller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

function PurchaseForFields(_ref5) {
  var _ref5$clearPurchaseFo = _ref5.clearPurchaseFor,
      clearPurchaseFor = _ref5$clearPurchaseFo === undefined ? function () {} : _ref5$clearPurchaseFo,
      _ref5$prefix = _ref5.prefix,
      prefix = _ref5$prefix === undefined ? "" : _ref5$prefix,
      searchBuyers = _ref5.searchBuyers,
      selectedReserveForSeller = _ref5.selectedReserveForSeller,
      shippingType = _ref5.shippingType,
      disabled = _ref5.disabled,
      _ref5$getFieldValue = _ref5.getFieldValue,
      getFieldValue = _ref5$getFieldValue === undefined ? function () {} : _ref5$getFieldValue,
      qtyDisabled = _ref5.qtyDisabled,
      condition = _ref5.condition,
      onPurchaseForRepair = _ref5.onPurchaseForRepair,
      onPurchaseForStockChange = _ref5.onPurchaseForStockChange,
      onPurchaseForSaleChange = _ref5.onPurchaseForSaleChange,
      setFieldValue = _ref5.setFieldValue;

  var clearReserveForSaleQty = function clearReserveForSaleQty(ev) {
    if (ev) {
      var field = [prefix, __WEBPACK_IMPORTED_MODULE_5__constants__["n" /* RESERVE_FOR_SALE_QUANTITY */]].filter(function (f) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(f);
      }).join(".");
      setFieldValue(field)(0);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_redux_form__["FormSection"],
    { name: prefix },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Fields"], {
          names: [__WEBPACK_IMPORTED_MODULE_5__constants__["q" /* PURCHASE_FOR_STOCK */], __WEBPACK_IMPORTED_MODULE_5__constants__["l" /* PURCHASE_FOR_REPAIR_ASSIST */], __WEBPACK_IMPORTED_MODULE_5__constants__["m" /* PURCHASE_FOR_SALE */], __WEBPACK_IMPORTED_MODULE_5__constants__["p" /* PURCHASE_FOR_REPAIR */]],
          asIs: getFieldValue([prefix, __WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_constants__["c" /* AS_IS */]].filter(function (f) {
            return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(f);
          }).join(".")),
          clearPurchaseFor: clearPurchaseFor,
          component: PurchaseForCheckboxes,
          shippingType: shippingType,
          disabled: disabled,
          condition: condition,
          onPurchaseForStockChange: onPurchaseForStockChange,
          onPurchaseForSaleChange: onPurchaseForSaleChange,
          onPurchaseForRepair: onPurchaseForRepair,
          required: true,
          clearReserveForSaleQty: clearReserveForSaleQty
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Fields"], {
      component: ReserveForSaleFields,
      disabled: disabled,
      getFieldValue: getFieldValue,
      setFieldValue: setFieldValue,
      names: [__WEBPACK_IMPORTED_MODULE_5__constants__["m" /* PURCHASE_FOR_SALE */]],
      partId: getFieldValue([prefix, __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["q" /* PART_ID */]].filter(function (f) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(f);
      }).join(".")),
      prefix: prefix,
      qtyDisabled: qtyDisabled,
      searchBuyers: searchBuyers,
      selectedReserveForSeller: selectedReserveForSeller
    })
  );
}

PurchaseForFields.propTypes = {
  clearPurchaseFor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  prefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  qtyDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedReserveForSeller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onPurchaseForRepair: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onPurchaseForSaleChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onPurchaseForStockChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

PurchaseForCheckboxes.defaultProps = {
  onPurchaseForStockChange: function onPurchaseForStockChange() {
    return null;
  },
  onPurchaseForSaleChange: function onPurchaseForSaleChange() {
    return null;
  }
};

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_actions_search__ = __webpack_require__(475);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return receivingRecordsSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return discrepancies; });





var searchDiscrepancies = function searchDiscrepancies(pageInfo) {
  return function (dispatch, getState) {
    var results = getState().receivingRecordDetail.getIn(["receivingRecord", "discrepancies"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).toJS();
    var _pageInfo$query = pageInfo.query,
        limit = _pageInfo$query.limit,
        page = _pageInfo$query.page;

    var data = {
      total_count: results.length,
      results: results.slice(limit * page - limit, page * limit)
    };

    return Promise.resolve({ data: data });
  };
};

var receivingRecordsSearch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_actions_search__["a" /* default */])("receivingRecords", __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].receivingRecord.search);

/* harmony default export */ __webpack_exports__["c"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["createPaginator"])({
  listId: receivingRecordsSearch.listId,
  fetch: receivingRecordsSearch.search
}));

var discrepancies = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["createPaginator"])({
  listId: "discrepancies",
  fetch: searchDiscrepancies,
  initialSettings: {
    pageSize: 5
  }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__ = __webpack_require__(11);
/* harmony export (immutable) */ __webpack_exports__["a"] = SalesCount;
/* harmony export (immutable) */ __webpack_exports__["b"] = SaleLinesCount;
/* unused harmony export SalesSum */
/* harmony export (immutable) */ __webpack_exports__["c"] = GrossSalesSum;
/* harmony export (immutable) */ __webpack_exports__["e"] = SalesSumProjection;
/* harmony export (immutable) */ __webpack_exports__["i"] = ProfitSumProjection;
/* harmony export (immutable) */ __webpack_exports__["f"] = SalesSumProjectionNA;
/* harmony export (immutable) */ __webpack_exports__["d"] = SalesProfit;
/* harmony export (immutable) */ __webpack_exports__["g"] = SalesPercentProfit;
/* harmony export (immutable) */ __webpack_exports__["h"] = SalesPercentGoal;






var salesSum = function salesSum(data) {
  return data.sellers.reduce(function (sum, result) {
    return sum + result.total_sales;
  }, 0);
};

var profit = function profit(data) {
  return data.sellers.reduce(function (sum, result) {
    return sum + result.total_profit;
  }, 0);
};

var percentProfit = function percentProfit(data) {
  return salesSum(data) !== 0 ? profit(data) / salesSum(data) : 0;
};

function SalesCount(_ref) {
  var data = _ref.data,
      dateLabel = _ref.dateLabel;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["H" /* Stat */], {
    label: "# Sales - " + dateLabel,
    value: __WEBPACK_IMPORTED_MODULE_1_numeral___default()(data.num_sales).format("(0,0)")
  });
}

SalesCount.propTypes = {
  dateLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}))
};

function SaleLinesCount(_ref2) {
  var data = _ref2.data,
      dateLabel = _ref2.dateLabel;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["H" /* Stat */], {
    label: "# SO Lines - " + dateLabel,
    value: __WEBPACK_IMPORTED_MODULE_1_numeral___default()(data.num_line_items).format("(0,0)")
  });
}

SaleLinesCount.propTypes = {
  dateLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}))
};

function SalesSum(_ref3) {
  var data = _ref3.data,
      dateLabel = _ref3.dateLabel;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["H" /* Stat */], {
    label: "$ Bookings - " + dateLabel,
    value: __WEBPACK_IMPORTED_MODULE_1_numeral___default()(salesSum(data)).format("($0,0)")
  });
}

SalesSum.propTypes = {
  dateLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}))
};

GrossSalesSum.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}))
};

function GrossSalesSum(_ref4) {
  var data = _ref4.data,
      dateLabel = _ref4.dateLabel;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["H" /* Stat */], {
    label: "$ Sales - " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(dateLabel),
    value: __WEBPACK_IMPORTED_MODULE_1_numeral___default()(data.gross_sales).format("($0,0)")
  });
}

GrossSalesSum.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})),
  dateLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

function SalesSumProjection(_ref5) {
  var data = _ref5.data,
      dateLabel = _ref5.dateLabel;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["H" /* Stat */], {
    label: "$ Sales On Track For - " + dateLabel,
    value: __WEBPACK_IMPORTED_MODULE_1_numeral___default()(data.sales_projection).format("($0,0)")
  });
}

function ProfitSumProjection(_ref6) {
  var data = _ref6.data,
      dateLabel = _ref6.dateLabel;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["H" /* Stat */], {
    label: "$ Profit On Track For - " + dateLabel,
    value: __WEBPACK_IMPORTED_MODULE_1_numeral___default()(data.profit_projection).format("($0,0)")
  });
}

ProfitSumProjection.propTypes = {
  dateLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}))
};

SalesSumProjection.propTypes = {
  dateLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}))
};

function SalesSumProjectionNA(_ref7) {
  var dateLabel = _ref7.dateLabel;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["H" /* Stat */], { label: "$ Sales On Track For - " + dateLabel, value: "N/A" });
}

SalesSumProjectionNA.propTypes = {
  dateLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

function SalesProfit(_ref8) {
  var data = _ref8.data,
      dateLabel = _ref8.dateLabel;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["H" /* Stat */], {
    label: "$ Profit - " + dateLabel,
    value: __WEBPACK_IMPORTED_MODULE_1_numeral___default()(profit(data)).format("($0,0")
  });
}

SalesProfit.propTypes = {
  dateLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}))
};

function SalesPercentProfit(_ref9) {
  var data = _ref9.data,
      dateLabel = _ref9.dateLabel;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["H" /* Stat */], {
    label: "% Profit - " + dateLabel,
    value: __WEBPACK_IMPORTED_MODULE_1_numeral___default()(percentProfit(data)).format("(0.0%)")
  });
}

SalesPercentProfit.propTypes = {
  dateLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}))
};

function SalesPercentGoal(_ref10) {
  var data = _ref10.data,
      dateLabel = _ref10.dateLabel;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["H" /* Stat */], {
    label: "% of Goal - " + dateLabel,
    value: __WEBPACK_IMPORTED_MODULE_1_numeral___default()(data.sales_percent_goal).format("(0.0%)")
  });
}

SalesPercentGoal.propTypes = {
  dateLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}))
};

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_SALES_ORDER_WITH_ALL_LINE_ITEMS; });
/* unused harmony export CANCEL_LINE_ITEM */
var SET = "salesOrderDetail/SET";
var SET_SALES_ORDER_WITH_ALL_LINE_ITEMS = "salesOrderWithAllLineItemsDetail/SET";
var CANCEL_LINE_ITEM = "salesOrderDetail/CANCEL_LINE_ITEM";

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_time__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function ExistingQuoteWarning(_ref) {
  var part = _ref.part,
      company = _ref.company,
      sellerId = _ref.sellerId;

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(company, __WEBPACK_IMPORTED_MODULE_7__constants__["b" /* ID */]) || !part) return null;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      quotes = _useState2[0],
      setQuotes = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.outgoingQuoteLineItems.search(part.id, {
      company_id: company.id,
      created_after: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_time__["d" /* daysAgo */])(30)
    }).then(function (resp) {
      setQuotes(resp.data.results.filter(function (q) {
        return Number(sellerId) !== Number(q.created_by_id);
      }));
    });

    return function cleanup() {};
  }, [part.id, company.id, sellerId]);

  if (quotes.length === 0) return null;
  var quote = quotes[0];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components__["n" /* Warning */],
        null,
        "This part number has already been quoted to ",
        company.name,
        " in the last 30 days. It was last quoted by ",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(quote, "created_by.full_name"),
        " to",
        " ",
        company.name,
        " on ",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__["b" /* shortDate */])(quote.created_at),
        "."
      )
    )
  );
}

ExistingQuoteWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  part: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  sellerId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (ExistingQuoteWarning);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CustomerSection__ = __webpack_require__(1923);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__CustomerSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validate__ = __webpack_require__(452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__validate__["a"]; });





/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(32);
/* harmony export (immutable) */ __webpack_exports__["b"] = validateCustomerFields;






function validateCustomerFields(values, form) {
  if (values.contact_id === "Add") {
    form.validateChild(__WEBPACK_IMPORTED_MODULE_3__companies_constants__["g" /* CONTACT */], function (contactForm) {
      contactForm.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["T" /* EMAIL */], __WEBPACK_IMPORTED_MODULE_2__constants__["S" /* NAME */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      contactForm.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["T" /* EMAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["b" /* isValidEmail */]);
    });
  }
  return form.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["N" /* COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_2__constants__["O" /* CONTACT_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["_0" /* CREDIT_TERMS */], __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* CUSTOMER_PURCHASE_ORDER_NUMBER */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
}

/* harmony default export */ __webpack_exports__["a"] = (function (values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    validateCustomerFields(values, form);
  });
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony export (immutable) */ __webpack_exports__["a"] = validateSellerFields;


function validateSellerFields(values, form) {
  form.validate("seller_credit_percent").required();
}

/* unused harmony default export */ var _unused_webpack_default_export = (function (values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    validateSellerFields(values, form);
  });
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(32);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();











function DoNotDoBusinessShippingWarning(_ref) {
  var shipToCompanyId = _ref.ship_to_company_id.input.value,
      shipToCompanyDisabled = _ref.ship_to_company_disabled;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      shipToCompany = _useState2[0],
      setShipToCompany = _useState2[1];

  var setShipToCompanyDisabled = function setShipToCompanyDisabled(val) {
    if (shipToCompanyDisabled) {
      shipToCompanyDisabled.input.onChange(val);
    }
  };

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (["", null, undefined].includes(shipToCompanyId)) {
      setShipToCompany(null);
      setShipToCompanyDisabled(false);
    } else {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].companies.show(shipToCompanyId).then(function (_ref2) {
        var data = _ref2.data;

        setShipToCompany(data);
        if (data.status === __WEBPACK_IMPORTED_MODULE_3__companies_constants__["b" /* NO_BIZ */]) setShipToCompanyDisabled(true);
      });
    }

    return function cleanup() {};
  }, [shipToCompanyId]);

  if (!shipToCompany) return null;
  if (shipToCompany.status !== __WEBPACK_IMPORTED_MODULE_3__companies_constants__["b" /* NO_BIZ */]) return null;
  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_8__constants__["t" /* SHIP_TO_COMPANY_DISABLED */],
    component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["b" /* Check */],
    style: { display: "none" }
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components_Warning_Warning__["a" /* default */],
    { warningType: "danger" },
    "This Company has been flagged as 'Do Not Do Business'. Please select another Company or select 'Cancel'."
  )];
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["q" /* withFormFields */])(DoNotDoBusinessShippingWarning, [__WEBPACK_IMPORTED_MODULE_5__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_8__constants__["t" /* SHIP_TO_COMPANY_DISABLED */]]));

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_submission_onSuccess__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_countries__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SalesOrders_components_shared_FormSections_ShippingSection_AdditionalDetails__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Receiving_components_shared_FormSections_AttachmentListSection__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__parts_components_shared_FormSections_WeightAndDimensionsSection__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_NetWeightAndDimsFormRow_NetWeightAndDimsFormRow__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__shared_components_CommercialInvoice_helpers__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__shared_components_Forms_FormLink_FormLink__ = __webpack_require__(2318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Save__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ShipMultipleRecordsTable__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__validate__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__shared_decorators_withFieldsFromForm__ = __webpack_require__(826);
/* unused harmony export formName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleCopy; });
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




































var formName = "createShippingRecord";

var ShippingMethodWarning = function ShippingMethodWarning(_ref) {
  var shippingMethod = _ref.shippingMethod,
      carrier = _ref.carrier,
      method = _ref.method;

  if (!shippingMethod) return null;

  if (shippingMethod.carrier === carrier && shippingMethod.shipping_method === method) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_17__shared_components_Warning_Warning__["a" /* default */],
    null,
    "SHIPPING CARRIER OR METHOD DO NOT MATCH SALES ORDER. PLEASE VERIFY."
  );
};

ShippingMethodWarning.propTypes = {
  shippingMethod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  carrier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  method: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var hasShippingMethod = function hasShippingMethod(type) {
  return ["managed_repair_order_line_item", "mistake_shipment", __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["a" /* PO_ITEM */], "rejected_core_order", __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["b" /* RO_ITEM */], __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["c" /* RETURNED_CONSIGNMENT */], __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["d" /* RETURNED_CORE */], "rma", __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["e" /* SO_ITEM */], __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["f" /* TRANSFER */]].includes(type);
};

function HazmatFields(_ref2) {
  var hazmat = _ref2.hazmat,
      bio_hazmat = _ref2.bio_hazmat;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { htmlFor: "warnings", className: "control-label" },
      "Line Hazmat"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        id: "warnings",
        className: "btn-group btn-group-justified",
        "data-toggle": "buttons"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */], { input: hazmat.input, label: "Hazmat", icon: "fa-warning" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */], { input: bio_hazmat.input, label: "Bio-Hazmat", icon: "fa-flask" })
    )
  );
}

function PrintPackingSlip(_ref3) {
  var packingUrl = _ref3.packingUrl,
      shippingRecord = _ref3.shippingRecord;

  return shippingRecord.release_for_shipment ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "a",
    {
      href: packingUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "btn btn-success",
      style: { paddingLeft: "5px", paddingRight: "5px" }
    },
    "Print packing slip"
  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    { type: "button", disabled: true, className: "btn btn-success" },
    "Print Packing Slip"
  );
}

PrintPackingSlip.propTypes = {
  packingUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  shippingRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

HazmatFields.propTypes = {
  hazmat: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormTypes__["boolInput"]).isRequired,
  bio_hazmat: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormTypes__["boolInput"]).isRequired
};

var orBlank = function orBlank(val) {
  return val || "";
};

var SimpleCopy = function SimpleCopy(_ref4) {
  var value = _ref4.value;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "fa fa-copy",
    style: {
      cursor: "pointer",
      marginLeft: "7px",
      zIndex: 1000
    },
    onClick: function onClick() {
      navigator.clipboard.writeText(value || "");
    }
  });
};

SimpleCopy.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

function Form(props) {
  var accountNumber = props.accountNumber,
      carrier = props.carrier,
      getField = props.getField,
      handleSubmit = props.handleSubmit,
      close = props.close,
      onSubmit = props.onSubmit,
      submitting = props.submitting,
      discreet = props.discreet,
      errorMessages = props.errorMessages,
      length = props.length,
      width = props.width,
      weight = props.weight,
      weightUnit = props.weightUnit,
      countryOfMfg = props.countryOfMfg,
      height = props.height,
      outgoingAwbNumber = props.outgoingAwbNumber,
      parentRecord = props.parentRecord,
      submitFailed = props.submitFailed,
      shippingRecord = props.shippingRecord,
      shippingMethod = props.shippingMethod,
      setCurrentForm = props.setCurrentForm,
      setWeightsAndDims = props.setWeightsAndDims,
      loadingParentRecord = props.loadingParentRecord,
      multipleShipments = props.multipleShipments,
      setPackingUrl = props.setPackingUrl,
      shippingAddressWarning = props.shippingAddressWarning,
      packingUrl = props.packingUrl;


  var countryOptions = __WEBPACK_IMPORTED_MODULE_12__lib_countries__["a" /* default */].map(function (c) {
    return {
      value: c.code,
      text: c.name
    };
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    setPackingUrl(__WEBPACK_IMPORTED_MODULE_20__constants__["d" /* API_BASE */].replace("/v1", "") + shippingRecord.packing_slip_url + "?allow_warehouse_basic=true&account_number=" + (accountNumber || "") + "&carrier=" + (carrier || "") + "&shipping_method=" + (shippingMethod || "") + (discreet ? "&discreet=true" : "") + "&inventory_id=" + shippingRecord.inventory_id + "\n                &weight=" + (weight || "") + "&weight_unit=" + (weightUnit || "") + "&length=" + (length || "") + "&width=" + (width || "") + "&height=" + (height || "") + "&country_of_mfg=" + orBlank(countryOfMfg) + "&outgoing_awb_number=" + orBlank(outgoingAwbNumber));

    return function cleanup() {};
  }, [shippingRecord.packing_slip_url, accountNumber, carrier, shippingMethod, discreet, shippingRecord.inventory_id, weight, weightUnit, length, outgoingAwbNumber, width, height, countryOfMfg]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Body,
      null,
      ![__WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["e" /* SO_ITEM */], __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["b" /* RO_ITEM */], __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["g" /* MRO_ITEM */], __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["f" /* TRANSFER */]].includes(shippingRecord.type) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_21__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_24__shared_components_Forms_FormLink_FormLink__["a" /* default */],
            {
              label: "Part #",
              addons: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimpleCopy, { value: getField(__WEBPACK_IMPORTED_MODULE_10__constants__["a" /* READ_ONLY_PART_NUMBER */]) })
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__shared_components__["h" /* PartNumber */], {
              part: {
                part_number: getField(__WEBPACK_IMPORTED_MODULE_10__constants__["a" /* READ_ONLY_PART_NUMBER */]),
                uuid: getField(__WEBPACK_IMPORTED_MODULE_10__constants__["b" /* READ_ONLY_PART_UUID */])
              },
              statsTooltip: false
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_24__shared_components_Forms_FormLink_FormLink__["a" /* default */],
            { label: "Serial #" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_25_react_router_dom__["a" /* Link */],
              { to: "/inventories/" + getField(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* READ_ONLY_INVENTORY_UUID */]) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                null,
                getField(__WEBPACK_IMPORTED_MODULE_10__constants__["d" /* READ_ONLY_SERIAL_NUMBER */])
              )
            )
          )
        )
      ),
      (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(shippingRecord, "parent.id") || shippingRecord.type === __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["f" /* TRANSFER */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__ShipMultipleRecordsTable__["a" /* default */], {
        formName: formName,
        orderId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(shippingRecord, "parent.id") || shippingRecord.id,
        type: shippingRecord.type
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_24__shared_components_Forms_FormLink_FormLink__["a" /* default */],
            {
              label: __WEBPACK_IMPORTED_MODULE_20__constants__["i" /* COMPANY */],
              addons: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimpleCopy, { value: getField(__WEBPACK_IMPORTED_MODULE_10__constants__["e" /* READ_ONLY_COMPANY */]) })
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_25_react_router_dom__["a" /* Link */],
              { to: "/companies/" + getField(__WEBPACK_IMPORTED_MODULE_10__constants__["f" /* READ_ONLY_COMPANY_UUID */]) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                null,
                getField(__WEBPACK_IMPORTED_MODULE_10__constants__["e" /* READ_ONLY_COMPANY */])
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: "read_only_customer_po",
            label: ["Customer PO #", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimpleCopy, { value: getField("read_only_customer_po") })],
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
            disabled: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            {
              className: "control-label",
              htmlFor: "read_only_customer_name"
            },
            "Cust Contact"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            className: "form-control",
            name: "read_only_customer_name",
            type: "text",
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(parentRecord, "contact.name"),
            disabled: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_24__shared_components_Forms_FormLink_FormLink__["a" /* default */],
            {
              label: "Customer e-mail",
              addons: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimpleCopy, { value: getField("read_only_customer_email") })
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "a",
              { href: "mailto:" + getField("read_only_customer_email") },
              getField("read_only_customer_email")
            )
          )
        )
      ),
      shippingRecord.type === __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["e" /* SO_ITEM */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: "read_only_salesperson",
            label: "Salesperson",
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
            disabled: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], {
            name: "read_only_sales_ea",
            label: "Sales EA",
            inputProps: { disabled: true }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
            options: countryOptions,
            name: __WEBPACK_IMPORTED_MODULE_19__parts_constants__["g" /* COUNTRY_OF_MFG */],
            label: "Ctry of Mfg"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        null,
        "Gross (Package) Weight & Dims"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__parts_components_shared_FormSections_WeightAndDimensionsSection__["a" /* default */], {
        dimensionsRequired: !shippingRecord[__WEBPACK_IMPORTED_MODULE_23__Receiving_constants__["b" /* RECEIVED_VIRTUALLY */]],
        weightRequired: !shippingRecord[__WEBPACK_IMPORTED_MODULE_23__Receiving_constants__["b" /* RECEIVED_VIRTUALLY */]],
        weightLabel: "Gross (Package) Weight"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_NetWeightAndDimsFormRow_NetWeightAndDimsFormRow__["a" /* default */], { getField: getField }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
      parentRecord && shippingRecord.type === __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["e" /* SO_ITEM */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShippingMethodWarning, {
        shippingMethod: parentRecord.ship_to_shipping_method,
        carrier: getField([__WEBPACK_IMPORTED_MODULE_20__constants__["g" /* SHIPPING_METHOD */], __WEBPACK_IMPORTED_MODULE_20__constants__["e" /* CARRIER */]].join(".")),
        method: getField([__WEBPACK_IMPORTED_MODULE_20__constants__["g" /* SHIPPING_METHOD */], __WEBPACK_IMPORTED_MODULE_20__constants__["g" /* SHIPPING_METHOD */]].join("."))
      }),
      shippingRecord && hasShippingMethod(shippingRecord.type) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_redux_form__["FormSection"],
        { name: __WEBPACK_IMPORTED_MODULE_20__constants__["g" /* SHIPPING_METHOD */] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["g" /* ShippingMethod */], {
          disabled: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__users_helpers__["a" /* hasAnyOfSubroles */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__hooks__["a" /* useCurrentUser */])(), [__WEBPACK_IMPORTED_MODULE_9__users_constants__["s" /* WAREHOUSE_MANAGER */], __WEBPACK_IMPORTED_MODULE_9__users_constants__["t" /* WAREHOUSE_EXPERT */], __WEBPACK_IMPORTED_MODULE_9__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */], __WEBPACK_IMPORTED_MODULE_9__users_constants__["n" /* QUALITY_CONTROL_MANAGER */]]),
          required: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
        { className: "row-col-gutters-half" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_10__constants__["g" /* OUTGOING_AWB_NUMBER */],
            label: ["Outgoing AWB #", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimpleCopy, { value: getField(__WEBPACK_IMPORTED_MODULE_10__constants__["g" /* OUTGOING_AWB_NUMBER */]) })],
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
            required: true
          })
        ),
        (!multipleShipments || multipleShipments.length < 2) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_20__constants__["j" /* QUANTITY */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_20__constants__["j" /* QUANTITY */]),
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["h" /* NumberInput */],
            roundDigits: 0,
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], { names: [__WEBPACK_IMPORTED_MODULE_19__parts_constants__["h" /* HAZMAT */], __WEBPACK_IMPORTED_MODULE_19__parts_constants__["i" /* BIO_HAZMAT */]], component: HazmatFields })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__SalesOrders_components_shared_FormSections_ShippingSection_AdditionalDetails__["a" /* default */], {
        lineItem: shippingRecord,
        showDiscreet: shippingRecord.type !== __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["a" /* PO_ITEM */]
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["FieldArray"], {
        name: __WEBPACK_IMPORTED_MODULE_20__constants__["k" /* ATTACHMENTS */],
        component: __WEBPACK_IMPORTED_MODULE_14__Receiving_components_shared_FormSections_AttachmentListSection__["a" /* default */],
        attachmentTypes: __WEBPACK_IMPORTED_MODULE_10__constants__["h" /* ATTACHMENT_TYPES */],
        getField: getField
      }),
      shippingAddressWarning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_17__shared_components_Warning_Warning__["a" /* default */],
        null,
        "A Primary Shipping Address for the Customer is necessary to allow for creation of the Commercial Invoice."
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Footer,
      null,
      submitFailed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["i" /* Errors */], { errors: errorMessages }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_18__shared_components__["b" /* Authorized */],
        { roles: [__WEBPACK_IMPORTED_MODULE_9__users_constants__["j" /* WAREHOUSE */]] },
        shippingRecord.type === __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["e" /* SO_ITEM */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            className: "btn btn-primary",
            type: "button",
            disabled: !shippingRecord.release_for_shipment,
            onClick: function onClick(e) {
              var _setWeightsAndDims;

              e.preventDefault();
              setWeightsAndDims((_setWeightsAndDims = {
                weight_unit: props.weightUnit
              }, _defineProperty(_setWeightsAndDims, __WEBPACK_IMPORTED_MODULE_19__parts_constants__["j" /* WEIGHT */], Number(props[__WEBPACK_IMPORTED_MODULE_19__parts_constants__["j" /* WEIGHT */]])), _defineProperty(_setWeightsAndDims, __WEBPACK_IMPORTED_MODULE_19__parts_constants__["k" /* WIDTH */], Number(props[__WEBPACK_IMPORTED_MODULE_19__parts_constants__["k" /* WIDTH */]])), _defineProperty(_setWeightsAndDims, __WEBPACK_IMPORTED_MODULE_19__parts_constants__["l" /* LENGTH */], Number(props[__WEBPACK_IMPORTED_MODULE_19__parts_constants__["l" /* LENGTH */]])), _defineProperty(_setWeightsAndDims, __WEBPACK_IMPORTED_MODULE_19__parts_constants__["m" /* HEIGHT */], Number(props[__WEBPACK_IMPORTED_MODULE_19__parts_constants__["m" /* HEIGHT */]])), _setWeightsAndDims));
              setCurrentForm(__WEBPACK_IMPORTED_MODULE_22__shared_components_CommercialInvoice_helpers__["a" /* SEND_WEIGHTS_AND_DIMS */]);
            }
          },
          "Send Wt & DIMs"
        )
      ),
      shippingRecord.type === __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["b" /* RO_ITEM */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        {
          href: __WEBPACK_IMPORTED_MODULE_20__constants__["d" /* API_BASE */] + "/repair_orders/" + shippingRecord.parent.id + "/download",
          target: "_blank",
          rel: "noopener noreferrer",
          className: "btn btn-success",
          style: { paddingLeft: "5px", paddingRight: "5px" }
        },
        "Print RO"
      ),
      shippingRecord.can_print_packing_slip && (!loadingParentRecord && parentRecord && ![__WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["b" /* RO_ITEM */], __WEBPACK_IMPORTED_MODULE_23__Receiving_constants__["c" /* RMA */], __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["h" /* REJECTED_CORE_ORDER */], __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["i" /* RETURN_TO_CUSTOMER_RECORD */], __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["c" /* RETURNED_CONSIGNMENT */]].includes(shippingRecord.type) && parentRecord.line_items.length > 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          className: "btn btn-success",
          type: "button",
          onClick: function onClick() {
            return setCurrentForm(__WEBPACK_IMPORTED_MODULE_22__shared_components_CommercialInvoice_helpers__["b" /* DOWNLOAD_PACKING_SLIP */]);
          },
          disabled: !shippingRecord.release_for_shipment
        },
        "Print Packing Slip"
      ) : !loadingParentRecord && shippingRecord.type !== __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["b" /* RO_ITEM */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrintPackingSlip, {
        shippingRecord: shippingRecord,
        packingUrl: packingUrl
      })) || shippingRecord.type === __WEBPACK_IMPORTED_MODULE_23__Receiving_constants__["d" /* MISTAKE_SHIPMENT */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrintPackingSlip, {
        shippingRecord: shippingRecord,
        packingUrl: __WEBPACK_IMPORTED_MODULE_20__constants__["d" /* API_BASE */] + "/mistake_shipments/" + shippingRecord.order_id + "/download_packing_slip"
      }) || shippingRecord.type === __WEBPACK_IMPORTED_MODULE_23__Receiving_constants__["e" /* SHIPMENT */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrintPackingSlip, {
        shippingRecord: shippingRecord,
        packingUrl: __WEBPACK_IMPORTED_MODULE_20__constants__["d" /* API_BASE */] + "/shipments/" + shippingRecord.order_id + "/download_packing_slip"
      }) || shippingRecord.type !== __WEBPACK_IMPORTED_MODULE_32__Orders_shared_constants__["b" /* RO_ITEM */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          className: "btn btn-success",
          style: { paddingLeft: "5px", paddingRight: "5px" },
          disabled: true
        },
        "Print packing slip"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: "btn btn-default",
          style: { paddingLeft: "5px", paddingRight: "5px" },
          onClick: close
        },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__Save__["a" /* default */], props),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          disabled: submitting || !shippingRecord.release_for_shipment,
          className: "btn btn-primary",
          style: { paddingLeft: "5px", paddingRight: "5px" },
          onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_submission_onSuccess__["a" /* default */])(handleSubmit(function (values) {
            return onSubmit({
              formData: _extends({}, values),
              lineItem: shippingRecord
            });
          }), close, props)
        },
        submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cog fa-spin fa-fw fa-lg" }) : "Ship"
      )
    )
  );
}

Form.propTypes = {
  accountNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  carrier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  errorMessages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  length: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  countryOfMfg: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  weight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  weightUnit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  discreet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  loadingParentRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  outgoingAwbNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  packingUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  parentRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  setCurrentForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitFailed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  shippingRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  shippingMethod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["b"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    getField: function getField(field) {
      return selector(state, field);
    }
  };
}, {
  onSubmit: __WEBPACK_IMPORTED_MODULE_11__actions__["a" /* create */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_31__validate__["a" /* default */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__shared_decorators_withFieldsFromForm__["a" /* withFieldsFromFormWithKeys */])(formName, {
  accountNumber: "shipping_method.account_number",
  carrier: "shipping_method.carrier",
  countryOfMfg: __WEBPACK_IMPORTED_MODULE_19__parts_constants__["g" /* COUNTRY_OF_MFG */],
  discreet: __WEBPACK_IMPORTED_MODULE_20__constants__["l" /* DISCREET */],
  length: __WEBPACK_IMPORTED_MODULE_19__parts_constants__["l" /* LENGTH */],
  outgoingAwbNumber: __WEBPACK_IMPORTED_MODULE_10__constants__["g" /* OUTGOING_AWB_NUMBER */],
  width: __WEBPACK_IMPORTED_MODULE_19__parts_constants__["k" /* WIDTH */],
  weight: __WEBPACK_IMPORTED_MODULE_19__parts_constants__["j" /* WEIGHT */],
  weightUnit: __WEBPACK_IMPORTED_MODULE_19__parts_constants__["n" /* WEIGHT_UNIT */],
  height: __WEBPACK_IMPORTED_MODULE_19__parts_constants__["m" /* HEIGHT */],
  shippingMethod: "shipping_method.shipping_method",
  multipleShipments: __WEBPACK_IMPORTED_MODULE_10__constants__["i" /* SHIP_MULTIPLE_ITEM_IDS */]
})(Form))));

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "outboundOrders",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].outboundOrders.search
}));

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SUBSCRIPTION_NOTIFICATION; });
var SUBSCRIPTION_NOTIFICATION = "SUBSCRIPTION_NOTIFICATION";

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return companiesPagination; });
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();





var _locate = function _locate(name) {
  return function (state) {
    return state.companyPagination[name];
  };
};

var companiesPagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["a" /* createPaginatedList */])({
  listId: "companies",
  fetch: __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].companies.searchWithAddress,
  stateLocator: _locate("main"),
  forceDebounce: true,
  initialSettings: {
    sort: "name"
  }
});

var companiesApi = function companiesApi(key) {
  return function (id, _ref) {
    var page = _ref.page,
        limit = _ref.limit;
    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].companies[key].search(id, { page: page, limit: limit });
  };
};

var config = function config(key) {
  return { key: key, collect: true, api: companiesApi(key) };
};

var _paginationGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["b" /* paginationGroup */])({
  groupName: "company",
  getId: function getId(state) {
    return state.companyDetail.getIn(["company", "id"]);
  },
  locate: function locate(_ref2) {
    var key = _ref2.key;
    return _locate(key);
  }
}, config("aircrafts"), config("contacts"), config("physicalAddresses"), config("relatedCompanies"), config("shippingMethods")),
    _paginationGroup2 = _slicedToArray(_paginationGroup, 5),
    aircrafts = _paginationGroup2[0],
    contacts = _paginationGroup2[1],
    physicalAddresses = _paginationGroup2[2],
    relatedCompanies = _paginationGroup2[3],
    shippingMethods = _paginationGroup2[4];

/* harmony default export */ __webpack_exports__["b"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  main: companiesPagination.paginator,
  aircrafts: aircrafts,
  contacts: contacts,
  physicalAddresses: physicalAddresses,
  relatedCompanies: relatedCompanies,
  shippingMethods: shippingMethods
}));

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parts_actions_actions__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_RestrictedEntityWarning__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CreateCompany__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SearchCompany__ = __webpack_require__(331);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var FormToggle = function (_Component) {
  _inherits(FormToggle, _Component);

  function FormToggle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FormToggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormToggle.__proto__ || Object.getPrototypeOf(FormToggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      companyToggleType: "existing",
      selectedCompany: null,
      contacts: []
    }, _this.handleExistingCompanyClick = function (ev) {
      _this.props.clearCompany();
      _this.setState({ companyToggleType: "existing" });
      ev.preventDefault();
    }, _this.handleNewCompanyClick = function (ev) {
      ev.preventDefault();
      _this.setState({
        companyToggleType: "new",
        selectedCompany: null,
        contacts: []
      });
      _this.props.clearCompany();
      _this.props.onCompanySelected(null);
    }, _this.handleCompanySelected = function (company) {
      _this.setState({ selectedCompany: company });
      _this.props.onCompanySelected(company);

      if (company) {
        _this.fetchContacts(company.id);
      } else {
        _this.setState({ contacts: [] });
      }
    }, _this.fetchContacts = function (value) {
      if (!value) {
        return null;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__parts_actions_actions__["a" /* searchContacts */])(value).then(function () {
        var vals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        _this.setState({ contacts: vals });
        if (_this.props.setPrimaryContact) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* selectPrimaryContact */])(vals, _this.props.setFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["O" /* CONTACT_ID */]), _this.handleEmail);
        }
      });
    }, _this.handleEmail = function (email) {
      if (_this.props.handleEmail) {
        _this.props.handleEmail(email);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FormToggle, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          allowPortalPurchase = _props.allowPortalPurchase,
          getFieldValue = _props.getFieldValue;
      var _state = this.state,
          companyToggleType = _state.companyToggleType,
          selectedCompany = _state.selectedCompany;

      var activeExisting = __WEBPACK_IMPORTED_MODULE_4_classnames___default()("btn btn-default", {
        active: companyToggleType === "existing"
      });
      var activeNew = __WEBPACK_IMPORTED_MODULE_4_classnames___default()("btn btn-default", {
        active: companyToggleType === "new"
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 9 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group", style: { marginBottom: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "btn-group btn-group-justified", role: "group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "col-md-6", style: { padding: 0, margin: 0 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    {
                      className: activeExisting,
                      onClick: this.handleExistingCompanyClick,
                      type: "button",
                      style: { width: "100%" }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
                    "\xA0\xA0Choose Existing Company"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "col-md-6", style: { padding: 0, margin: 0 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    {
                      className: activeNew,
                      type: "button",
                      onClick: this.handleNewCompanyClick,
                      style: { width: "100%" }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
                    "\xA0\xA0Create New Company"
                  )
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          companyToggleType === "existing" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__SearchCompany__["a" /* default */], _extends({}, this.props, { // overrides companySearch api call here if defined
            selectedCompany: selectedCompany,
            contacts: this.state.contacts,
            fetchContacts: this.fetchContacts,
            onCompanySelected: this.handleCompanySelected,
            handleEmail: this.handleEmail
          })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__CreateCompany__["a" /* default */], {
            getFieldValue: getFieldValue,
            handleEmail: this.handleEmail,
            allowPortalPurchase: allowPortalPurchase
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_RestrictedEntityWarning__["a" /* default */], {
              company: selectedCompany,
              name: getFieldValue(__WEBPACK_IMPORTED_MODULE_9__constants__["p" /* COMPANY */] + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["S" /* NAME */]),
              contactId: getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["O" /* CONTACT_ID */])
            })
          )
        )
      );
    }
  }]);

  return FormToggle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FormToggle.propTypes = {
  allowPortalPurchase: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  clearCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  clearCompanyId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  companySearch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onCompanySelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setPrimaryContact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
FormToggle.defaultProps = {
  onCompanySelected: function onCompanySelected() {},
  setPrimaryContact: true
};


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state, ownProps) {
  return {
    getFieldValue: function getFieldValue(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(ownProps.formName)(state, field);
    }
  };
}, function (dispatch, ownProps) {
  return {
    clearCompany: function clearCompany() {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(ownProps.formName, __WEBPACK_IMPORTED_MODULE_9__constants__["p" /* COMPANY */], {}));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(ownProps.formName, __WEBPACK_IMPORTED_MODULE_9__constants__["g" /* CONTACT */], {}));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(ownProps.formName, __WEBPACK_IMPORTED_MODULE_6__constants__["N" /* COMPANY_ID */], null));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(ownProps.formName, __WEBPACK_IMPORTED_MODULE_6__constants__["O" /* CONTACT_ID */], null));
    },
    clearCompanyId: function clearCompanyId() {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(ownProps.formName, __WEBPACK_IMPORTED_MODULE_9__constants__["p" /* COMPANY */], {}));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(ownProps.formName, __WEBPACK_IMPORTED_MODULE_9__constants__["g" /* CONTACT */], {}));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(ownProps.formName, __WEBPACK_IMPORTED_MODULE_6__constants__["N" /* COMPANY_ID */], null));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(ownProps.formName, __WEBPACK_IMPORTED_MODULE_6__constants__["O" /* CONTACT_ID */], null));
    },
    clearNewContact: function clearNewContact() {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(ownProps.formName, __WEBPACK_IMPORTED_MODULE_9__constants__["g" /* CONTACT */], {}));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(ownProps.formName, field, val));
      };
    }
  };
})(FormToggle));

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony export (immutable) */ __webpack_exports__["a"] = ActiveDemeritCompanyWarning;




function ActiveDemeritCompanyWarning(_ref) {
  var company = _ref.company;

  if (company && company.demerits >= 4) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Warning_Warning__["a" /* default */],
      null,
      "Due to 4 or more Active Demerits within the last 24 months, this Vendor will require QC Pre-Approval. A notification will be sent to QC for Pre-approval"
    );
  }

  return null;
}

ActiveDemeritCompanyWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_useDebounce__ = __webpack_require__(201);
/* harmony export (immutable) */ __webpack_exports__["a"] = RestrictedContactWarning;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









function RestrictedContactWarning(_ref) {
  var contact = _ref.contact,
      requireApproval = _ref.requireApproval;

  if (!contact) return null;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      restrictedEntities = _useState2[0],
      setRestrictedEntities = _useState2[1];

  var args = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__hooks_useDebounce__["a" /* default */])(500, contact);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var params = {};
    if (contact) {
      params.name = contact;
    }

    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].restrictedEntities.search(params).then(function (resp) {
      if (Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(resp, "data.total", 0)) > 0) {
        setRestrictedEntities(resp.data.results);
      } else {
        setRestrictedEntities(null);
      }
    });
  }, [args]);

  if (!restrictedEntities) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Warning: Similar entity name in US Gov't Screening List for selected Contact: ",
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["b" /* toSentence */])(restrictedEntities.map(function (f) {
      return f.name;
    })),
    ".",
    " ",
    requireApproval && "Pre-Approval Required."
  );
}

RestrictedContactWarning.propTypes = {
  contact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_DUMMY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DESTROY_DUMMY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_MODAL; });
var SET = "inventories/SET";
var SET_DUMMY = "inventories/SET_DUMMY";
var DESTROY_DUMMY = "inventories/DESTROY_DUMMY";
var SET_MODAL = "inventories/SET_MODAL";

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_AppForm__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MinimumSrpWarning__ = __webpack_require__(2105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__validate__ = __webpack_require__(2097);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return shouldShowWarning; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var AdjustedLast30DaysWarning = function AdjustedLast30DaysWarning(_ref) {
  var selected = _ref.selected,
      _ref$inventory = _ref.inventory,
      suggestedRetailAudit = _ref$inventory.suggested_retail_audit,
      serialNumber = _ref$inventory.serial_number;

  if (selected && suggestedRetailAudit && __WEBPACK_IMPORTED_MODULE_1_moment___default()(suggestedRetailAudit.updated_at).isAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(30, "day"))) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components__["n" /* Warning */],
      null,
      "SRP for SN ",
      serialNumber,
      " has been updated within 30 days."
    );
  }

  return null;
};

var shouldShowWarning = function shouldShowWarning(_ref2) {
  var inventory = _ref2.inventory,
      suggestedRetail = _ref2.suggestedRetail;

  var lineItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(inventory, "repair_order_line_items[0]");
  if (!lineItem) return null;
  var repairCost = parseFloat(lineItem.labor_cost) + parseFloat(lineItem.outside_labor_cost) + parseFloat(lineItem.part_cost);

  return inventory.repair_status === __WEBPACK_IMPORTED_MODULE_12__constants__["k" /* REPAIR_AND_HOLD */] && Number(repairCost) > 0 && repairCost > Number(suggestedRetail);
};

var RepairWarning = function RepairWarning(_ref3) {
  var selected = _ref3.selected,
      suggestedRetail = _ref3.suggestedRetail,
      inventory = _ref3.inventory;

  if (!selected) return null;

  if (shouldShowWarning({ inventory: inventory, suggestedRetail: suggestedRetail })) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components__["n" /* Warning */],
      { warningType: "danger" },
      "SRP must be greater than the current estimated repair cost."
    );
  }

  return null;
};

RepairWarning.propTypes = {
  selected: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  suggestedRetail: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  inventory: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({})
};

AdjustedLast30DaysWarning.propTypes = {
  selected: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({ suggested_retail_audit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}) })
};

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref4, [this].concat(args))), _this), _this.toggleInventory = function (id, item) {
      var inventoriesSelected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["xor"])(_this.props.inventoriesSelected, [id]);
      _this.props.setInventoriesSelected(inventoriesSelected);
      if (!inventoriesSelected.includes(id)) {
        [__WEBPACK_IMPORTED_MODULE_12__constants__["v" /* SUGGESTED_RETAIL */], __WEBPACK_IMPORTED_MODULE_12__constants__["u" /* EXCHANGE_SRP */], __WEBPACK_IMPORTED_MODULE_12__constants__["C" /* SRP_CONDITION */]].forEach(function (f) {
          var field = item + "." + f;
          _this.props.change(field, _this.props.getInitialFieldValue(field));
        });
      }
    }, _this.toggleCondition = function (condition) {
      var selectedIds = _this.props.inventories.filter(function (i) {
        return i.srp_condition === condition;
      }).map(function (i) {
        return i.id;
      });

      _this.props.setInventoriesSelected(selectedIds);
    }, _this.handleTopLevelFormChange = function (ev, field) {
      var val = ev.target.value;
      _this.props.inventories.forEach(function (i, idx) {
        if (_this.props.inventoriesSelected.includes(i.id)) {
          _this.props.change("inventories[" + idx + "]." + field, val);
        }
      });
    }, _this.renderLineItems = function (_ref5) {
      var fields = _ref5.fields,
          canEditSrpReason = _ref5.canEditSrpReason;
      return fields.map(function (item) {
        var currentExchangeSrp = _this.props.getFieldValue(item + ".exchange_srp");

        var suggestedRetail = _this.props.getFieldValue(item + "." + __WEBPACK_IMPORTED_MODULE_12__constants__["v" /* SUGGESTED_RETAIL */]);

        var inventory = _this.props.inventories.find(function (i) {
          return i.id === _this.props.getFieldValue(item + ".id");
        });

        if (!inventory) return null;
        var selected = _this.props.inventoriesSelected.includes(inventory.id);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          { key: inventory.id, className: "striped" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__shared_components__["D" /* InventoryStatusCell */],
            { inventory: inventory },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
              type: "checkbox",
              className: "radio-inline",
              style: { marginLeft: 10 },
              checked: selected,
              onChange: function onChange() {
                return _this.toggleInventory(inventory.id, item);
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { style: { paddingLeft: 10 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["q" /* FormRow */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__MinimumSrpWarning__["a" /* default */], { value: currentExchangeSrp }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AdjustedLast30DaysWarning, {
                selected: selected,
                inventory: inventory
              }),
              Object.keys(__WEBPACK_IMPORTED_MODULE_17__constants__["a" /* displayFields */]).slice(0, 4).map(function (k) {
                if (k === __WEBPACK_IMPORTED_MODULE_12__constants__["C" /* SRP_CONDITION */]) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                    { md: 3 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                      name: item + "." + k,
                      component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["c" /* Select */],
                      options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__constants__["r" /* INVENTORIES */].condition),
                      label: "SRP Condition"
                    })
                  );
                }
                var FieldComponent = k === __WEBPACK_IMPORTED_MODULE_12__constants__["x" /* TAG_DATE */] ? __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["r" /* MonthYearField */] : __WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldComponent, {
                    component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */],
                    name: item + "." + k,
                    label: __WEBPACK_IMPORTED_MODULE_17__constants__["a" /* displayFields */][k].label,
                    type: __WEBPACK_IMPORTED_MODULE_17__constants__["a" /* displayFields */][k].type,
                    disabled: ![__WEBPACK_IMPORTED_MODULE_12__constants__["v" /* SUGGESTED_RETAIL */], __WEBPACK_IMPORTED_MODULE_12__constants__["u" /* EXCHANGE_SRP */]].includes(k)
                  })
                );
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["q" /* FormRow */],
              null,
              Object.keys(__WEBPACK_IMPORTED_MODULE_17__constants__["a" /* displayFields */]).slice(4).map(function (k) {
                if (k === __WEBPACK_IMPORTED_MODULE_12__constants__["C" /* SRP_CONDITION */]) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                    { md: 3 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                      name: item + "." + k,
                      component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["c" /* Select */],
                      options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__constants__["r" /* INVENTORIES */].condition),
                      label: "SRP Condition"
                    })
                  );
                }

                if (k === __WEBPACK_IMPORTED_MODULE_12__constants__["_55" /* SRP_REASON_CHANGED */]) {
                  if (!canEditSrpReason) return null;
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                    { md: 3 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                      name: item + "." + k,
                      component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["c" /* Select */],
                      label: "Reason for SRP Change",
                      options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__constants__["_56" /* SRP_CHANGE_REASONS */])
                    })
                  );
                }

                var FieldComponent = k === __WEBPACK_IMPORTED_MODULE_12__constants__["x" /* TAG_DATE */] ? __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["r" /* MonthYearField */] : __WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldComponent, {
                    component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */],
                    name: item + "." + k,
                    label: __WEBPACK_IMPORTED_MODULE_17__constants__["a" /* displayFields */][k].label,
                    type: __WEBPACK_IMPORTED_MODULE_17__constants__["a" /* displayFields */][k].type,
                    disabled: ![__WEBPACK_IMPORTED_MODULE_12__constants__["v" /* SUGGESTED_RETAIL */], __WEBPACK_IMPORTED_MODULE_12__constants__["u" /* EXCHANGE_SRP */]].includes(k)
                  })
                );
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RepairWarning, {
              selected: selected,
              suggestedRetail: suggestedRetail,
              inventory: inventory
            })
          )
        );
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.setInventoriesSelected(this.props.inventories.map(function (i) {
        return i.id;
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var role = this.props.role;


      var canEditSrpReason = [__WEBPACK_IMPORTED_MODULE_14__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_14__users_constants__["p" /* QUALITY_CONTROL */]].includes(role);

      var colLength = canEditSrpReason ? 3 : 4;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_AppForm__["a" /* default */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_AppForm__["a" /* default */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["q" /* FormRow */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                { md: colLength },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                  component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */],
                  name: "srp",
                  label: "Update SRP",
                  type: "number",
                  onChange: function onChange(e) {
                    return _this2.handleTopLevelFormChange(e, __WEBPACK_IMPORTED_MODULE_12__constants__["v" /* SUGGESTED_RETAIL */]);
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                { md: colLength },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                  component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */],
                  name: __WEBPACK_IMPORTED_MODULE_12__constants__["u" /* EXCHANGE_SRP */],
                  label: "Update Exchange SRP",
                  type: "number",
                  onChange: function onChange(e) {
                    return _this2.handleTopLevelFormChange(e, __WEBPACK_IMPORTED_MODULE_12__constants__["u" /* EXCHANGE_SRP */]);
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                { md: colLength },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                  component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["c" /* Select */],
                  name: __WEBPACK_IMPORTED_MODULE_12__constants__["C" /* SRP_CONDITION */],
                  options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__constants__["r" /* INVENTORIES */].condition),
                  label: "Toggle By SRP Condition",
                  onChange: function onChange(e) {
                    return _this2.toggleCondition(e.target.value);
                  }
                })
              ),
              canEditSrpReason && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                { md: colLength },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                  component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["c" /* Select */],
                  name: __WEBPACK_IMPORTED_MODULE_12__constants__["_55" /* SRP_REASON_CHANGED */],
                  label: "Reason for SRP Change",
                  options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__constants__["_56" /* SRP_CHANGE_REASONS */]),
                  onChange: function onChange(e) {
                    return _this2.handleTopLevelFormChange(e, __WEBPACK_IMPORTED_MODULE_12__constants__["_55" /* SRP_REASON_CHANGED */]);
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["m" /* DashedSeparator */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "table",
              { className: "table table-striped table-numbered margin-bottom-none" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tbody",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["FieldArray"], {
                  name: "inventories",
                  component: this.renderLineItems,
                  canEditSrpReason: canEditSrpReason
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  change: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  getFieldValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  getInitialFieldValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  invalid: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  inventories: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape),
  inventoriesSelected: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number),
  setInventoriesSelected: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired
};

var formName = "editSrps";

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    getFieldValue: function getFieldValue(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_form__["formValueSelector"])(formName)(state, field);
    },
    getInitialFieldValue: function getInitialFieldValue(field) {
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_form__["getFormInitialValues"])(formName)(state), field);
    },
    role: state.session.getIn([__WEBPACK_IMPORTED_MODULE_14__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_14__users_constants__["h" /* ROLE */]]),
    minExchangeSrp: state.session.getIn([__WEBPACK_IMPORTED_MODULE_16__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_16__constants__["X" /* MINIMUM_EXCHANGE_SRP */]])
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__actions__["s" /* bulkUpdate */])({
        inventories: data.inventories.filter(function (i) {
          return ownProps.inventoriesSelected.includes(i.id);
        })
      })).then(function () {
        ownProps.close();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__["toastr"].error("Error", error.message);
      });
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_form__["reduxForm"])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_18__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Action__ = __webpack_require__(739);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__Action__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CancelConsignment_CancelConsignment__ = __webpack_require__(2055);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__CancelConsignment_CancelConsignment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(2098);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__config__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UpdateQCStatus__ = __webpack_require__(2094);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__UpdateQCStatus__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ScrapReportReceived__ = __webpack_require__(2082);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__ScrapReportReceived__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SplitInventory__ = __webpack_require__(2085);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__SplitInventory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EditReserveForSeller__ = __webpack_require__(2070);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__EditReserveForSeller__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReserveForRepair__ = __webpack_require__(2076);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__ReserveForRepair__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CreateDummy__ = __webpack_require__(2059);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__CreateDummy__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CreateVendorRma__ = __webpack_require__(2065);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_9__CreateVendorRma__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Transfer__ = __webpack_require__(2089);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__Transfer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CreateCommercialInvoice__ = __webpack_require__(737);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_11__CreateCommercialInvoice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__UndoScrap__ = __webpack_require__(2091);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_12__UndoScrap__["a"]; });



























/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "inventorySearch",
  fetch: function fetch(params) {
    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].inventories.search(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["merge"])({ presenter_type: "search" }, params || {}));
  },
  forceDebounce: true,
  stateLocator: function stateLocator(state) {
    return state.inventoryPagination;
  },
  initialSettings: {
    sortReverse: true,
    sort: "date_received",
    presenter_type: "search"
  }
}));

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(149);
/* unused harmony export partsApplicationsActions */
/* harmony export (immutable) */ __webpack_exports__["b"] = createApplication;
/* harmony export (immutable) */ __webpack_exports__["c"] = searchApplicables;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteApplication;





var partsApplicationsActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__["actionFactory"])("part/applications");

function createApplication(partId, type, data) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.applications.of(type).create(partId, data).then(function () {
      dispatch(partsApplicationsActions.expire());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* show */])(partId));
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function searchApplicables(type, part) {
  return function (filter) {
    return function () {
      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.applications.of(type).applicables(filter).then(function (resp) {
        return resp.data.results.filter(function (r) {
          return r.id !== part.id;
        });
      });
    };
  };
}

function deleteApplication(id, partId) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].applications.delete(id).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* show */])(partId));
      return dispatch(partsApplicationsActions.expire());
    });
  };
}

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Subscription_withSubscription__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_LineItemStatusCell__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ModifiedFlag__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__IncomingQuotes_shared_IncidentRelatedFlag__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__IncomingQuotes_shared_AsIsFlag__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineItemsTable; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var LineItemsTable = function (_Component) {
  _inherits(LineItemsTable, _Component);

  function LineItemsTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LineItemsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LineItemsTable.__proto__ || Object.getPrototypeOf(LineItemsTable)).call.apply(_ref, [this].concat(args))), _this), _this.renderRow = function (lineItem, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__shared_components__["A" /* LinkedTableRow */],
        {
          key: lineItem.id,
          className: "clickable",
          to: "/incoming-quotes/" + lineItem.quote_uuid
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          {
            style: {
              backgroundColor: _this.props.inForm ? "#383838" : "#292929"
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { whiteSpace: "nowrap" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { textAlign: "right" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["I" /* LineItemQtyCell */], { lineItem: lineItem, showFull: true, type: "IQ" }),
              i + 1
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_LineItemStatusCell__["a" /* default */],
          { lineItem: lineItem },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: lineItem.updated_tracked_fields_at && "text-yellow" },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["c" /* shortDateYY */])(lineItem.updated_tracked_fields_at || lineItem.created_at)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["w" /* CompanyName */], {
            flattenedCompany: lineItem,
            truncateAt: _this.props.inForm ? 8 : 18
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["e" /* truncate */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["d" /* getFirstNameLastInitial */])(__WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(lineItem, "buyer.full_name")), 14)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          __WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].quoteType[lineItem.quote_type].abbrev
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          lineItem.trace_type && __WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes[lineItem.trace_type].abbrev
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["g" /* monthYear */])(lineItem.tag_date)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.modified && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ModifiedFlag__["b" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          lineItem.condition && lineItem.quote_type !== __WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_constants__["j" /* NO_QUOTE */] && __WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].condition[lineItem.condition].abbrev,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__IncomingQuotes_shared_IncidentRelatedFlag__["a" /* IncidentRelatedFlag */], { lineItem: lineItem }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__IncomingQuotes_shared_AsIsFlag__["a" /* AsIsFlag */], { lineItem: lineItem, className: "m-l-5" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          lineItem.quantity
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["e" /* truncate */])(lineItem.lead_time, 3)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          lineItem.cost ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(lineItem.cost) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(lineItem.exchange_fee)
        ),
        !_this.props.inForm && (lineItem.quote_type === "awaiting_reply" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], {
          note: [lineItem.notes, lineItem.external_note].filter(function (n) {
            return n !== null && n !== "";
          }).join(" | "),
          className: __WEBPACK_IMPORTED_MODULE_17_classnames___default()({ "link-muted": lineItem.cancelled })
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], { note: lineItem.notes }))
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LineItemsTable, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          inForm = _props.inForm,
          results = _props.results,
          limitResults = _props.limitResults;

      var modifiedResults = limitResults ? results.slice(0, 3) : results;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__shared_components__["s" /* DataTable */].Mini,
        { loading: this.props.loading, numbered: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__shared_components__["s" /* DataTable */].Head,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Date"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Vendor"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Buyer"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Type"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Trace"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "Tag Date"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "CD"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "QTY"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "LT"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Exch/Cost"
          ),
          !inForm && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__shared_components__["s" /* DataTable */].Body,
          null,
          modifiedResults.map(this.renderRow)
        )
      );
    }
  }]);

  return LineItemsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LineItemsTable.propTypes = {
  inForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    incoming_quote_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    quote_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    dom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    company_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    legacy_company_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })).isRequired,
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  limitResults: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
var withResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["n" /* miniTable */])(function (_ref2, params) {
  var match = _ref2.match;
  return __WEBPACK_IMPORTED_MODULE_12__api__["a" /* default */].parts.incomingQuoteLineItems.search(match.params.id, Object.assign(params, { sort: __WEBPACK_IMPORTED_MODULE_14__constants__["_7" /* CREATED_AT */] }));
});

/* harmony default export */ __webpack_exports__["b"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(withResults(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__Subscription_withSubscription__["a" /* default */])("IncomingQuoteLineItem")(LineItemsTable))));

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return partDimsText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return partDimsCMText; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Dimensions;






var cmFormat = function cmFormat(val) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__["b" /* roundUp */])(val * 2.54, 1) + "cm";
};

var partDimsText = function partDimsText(_ref) {
  var part = _ref.part;
  return part.length + "\" x " + part.width + "\" x " + part.height + "\"";
};

var partDimsCMText = function partDimsCMText(_ref2) {
  var part = _ref2.part;
  return cmFormat(part.length) + " x " + cmFormat(part.width) + " x " + cmFormat(part.height);
};

function Dimensions(_ref3) {
  var part = _ref3.part,
      _ref3$showWarning = _ref3.showWarning,
      showWarning = _ref3$showWarning === undefined ? false : _ref3$showWarning;

  var activeExisting = __WEBPACK_IMPORTED_MODULE_1_classnames___default()({ "text-highlight": showWarning });
  if (part.height) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: activeExisting },
        showWarning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: "warning" }),
          "\xA0\xA0"
        ),
        partDimsText({ part: part })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        { className: activeExisting },
        partDimsCMText({ part: part })
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null);
}

Dimensions.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    length: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }),
  showWarning: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__ = __webpack_require__(72);
/* harmony export (immutable) */ __webpack_exports__["a"] = CentimeterDimensions;




function dimension(fieldValue, label, placeholder) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "col-md-4" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "label",
        { className: "control-label sr-only", htmlFor: label + "_cm" },
        placeholder
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "number",
        min: "0",
        value: fieldValue,
        disabled: true,
        className: "form-control",
        style: { padding: "6px 4px" },
        placeholder: placeholder
      })
    )
  );
}

function CentimeterDimensions(_ref) {
  var _ref$length = _ref.length,
      length = _ref$length === undefined ? 0 : _ref$length,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 0 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 0 : _ref$height;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group margin-bottom-none" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { className: "control-label", htmlFor: "dimensions" },
      "Dimensions in CM (L \xD7 W \xD7 H)"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { id: "dimensions", className: "row row-col-gutters-half" },
      dimension(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["b" /* roundUp */])(length * 2.54, 1) || null, "Length", "L"),
      dimension(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["b" /* roundUp */])(width * 2.54, 1) || null, "Width", "W"),
      dimension(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["b" /* roundUp */])(height * 2.54, 1) || null, "Height", "H")
    )
  );
}

CentimeterDimensions.propTypes = {
  length: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators_withFormFields__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* unused harmony export Dimensions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NetDimensions; });
var _withFormFieldsByKey;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









function dimension(field, label, placeholder) {
  var input = field.input,
      meta = field.meta;

  var hasError = meta.touched && meta.invalid;
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("form-group", {
    "has-error": hasError
  });

  var errors = hasError && meta.error.map(function (m) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "help-block", key: m },
      m
    );
  });

  var onChange = function onChange(e) {
    var val = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(e.target.value) ? null : e.target.value;
    input.onChange(val);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "col-md-4" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: classes },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "label",
        { className: "control-label sr-only", htmlFor: input.name },
        placeholder
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({
        type: "number",
        min: "0",
        id: input.name
      }, input, {
        className: "form-control",
        placeholder: placeholder,
        onChange: onChange,
        onBlur: onChange
      })),
      errors
    )
  );
}

function Dimensions(_ref) {
  var length = _ref.length,
      width = _ref.width,
      height = _ref.height,
      required = _ref.required;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group margin-bottom-none" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { className: "control-label", htmlFor: "dimensions" },
      "Dimensions (L\" \xD7 W\" \xD7 H\")",
      required && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "sup",
        { className: "small text-danger" },
        "*"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { id: "dimensions", className: "row row-col-gutters-half" },
      dimension(length, "Length", "L", required),
      dimension(width, "Width", "W", required),
      dimension(height, "Height", "H", required)
    )
  );
}

var Dimension = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  input: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["stringInput"].isRequired,
  meta: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["meta"]
});

Dimensions.propTypes = {
  length: Dimension.isRequired,
  width: Dimension.isRequired,
  height: Dimension.isRequired,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["b"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators_withFormFields__["a" /* default */])(Dimensions, [__WEBPACK_IMPORTED_MODULE_5__constants__["l" /* LENGTH */], __WEBPACK_IMPORTED_MODULE_5__constants__["k" /* WIDTH */], __WEBPACK_IMPORTED_MODULE_5__constants__["m" /* HEIGHT */]]));

var NetDimensions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators_withFormFields__["b" /* withFormFieldsByKey */])(Dimensions, (_withFormFieldsByKey = {}, _defineProperty(_withFormFieldsByKey, __WEBPACK_IMPORTED_MODULE_5__constants__["p" /* NET_LENGTH */], __WEBPACK_IMPORTED_MODULE_5__constants__["l" /* LENGTH */]), _defineProperty(_withFormFieldsByKey, __WEBPACK_IMPORTED_MODULE_5__constants__["q" /* NET_WIDTH */], __WEBPACK_IMPORTED_MODULE_5__constants__["k" /* WIDTH */]), _defineProperty(_withFormFieldsByKey, __WEBPACK_IMPORTED_MODULE_5__constants__["r" /* NET_HEIGHT */], __WEBPACK_IMPORTED_MODULE_5__constants__["m" /* HEIGHT */]), _withFormFieldsByKey));

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators_withFormFields__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ConvertedWeight__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Weight__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Dimensions__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CentimeterDimensions__ = __webpack_require__(469);
/* unused harmony export WeightAndDimensionsSection */












function WeightAndDimensionsSection(_ref) {
  var width = _ref.width,
      height = _ref.height,
      length = _ref.length,
      weight = _ref.weight,
      weight_unit = _ref.weight_unit,
      dimensionsRequired = _ref.dimensionsRequired,
      weightRequired = _ref.weightRequired,
      _ref$weightLabel = _ref.weightLabel,
      weightLabel = _ref$weightLabel === undefined ? "Weight" : _ref$weightLabel;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Weight__["a" /* default */], { required: weightRequired, label: weightLabel })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ConvertedWeight__["a" /* default */], {
        unit: weight_unit.input.value,
        weight: weight.input.value
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
      { md: 4 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Dimensions__["b" /* default */], { required: dimensionsRequired })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CentimeterDimensions__["a" /* default */], {
        width: width.input.value,
        height: height.input.value,
        length: length.input.value
      })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators_withFormFields__["a" /* default */])(WeightAndDimensionsSection, [__WEBPACK_IMPORTED_MODULE_6__constants__["k" /* WIDTH */], __WEBPACK_IMPORTED_MODULE_6__constants__["m" /* HEIGHT */], __WEBPACK_IMPORTED_MODULE_6__constants__["l" /* LENGTH */], __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* WEIGHT */], __WEBPACK_IMPORTED_MODULE_6__constants__["n" /* WEIGHT_UNIT */]]));

WeightAndDimensionsSection.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["malleable"]).isRequired,
  height: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["malleable"]).isRequired,
  length: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["malleable"]).isRequired,
  weight: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["malleable"]).isRequired,
  weight_unit: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["stringInput"]).isRequired,
  weightLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dimensionsRequired: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  weightRequired: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);





var PartHazmatWarning = function PartHazmatWarning(_ref) {
  var hazmat = _ref.hazmat,
      hazmatFee = _ref.hazmatFee;
  return hazmat && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(hazmatFee) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["n" /* Warning */],
    { warningType: "danger" },
    "Part labeled as HazMat. Please consider HazMat Fee."
  );
};

PartHazmatWarning.propTypes = {
  hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hazmatFee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["a"] = (PartHazmatWarning);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators_withFormFields__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_weight__ = __webpack_require__(238);
/* unused harmony export Weight */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Weight = function (_Component) {
  _inherits(Weight, _Component);

  function Weight() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Weight);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Weight.__proto__ || Object.getPrototypeOf(Weight)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.setPounds = function () {
      if (_this.props.weight_unit.input.value !== __WEBPACK_IMPORTED_MODULE_3__constants__["z" /* POUNDS */]) {
        _this.props.weight.input.onChange(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_weight__["c" /* calculateValue */])(__WEBPACK_IMPORTED_MODULE_3__constants__["A" /* KILOS */], Number(_this.props.weight.input.value)));
      }

      _this.props.weight_unit.input.onChange(__WEBPACK_IMPORTED_MODULE_3__constants__["z" /* POUNDS */]);
      _this.close();
    }, _this.setKilos = function () {
      if (_this.props.weight_unit.input.value !== __WEBPACK_IMPORTED_MODULE_3__constants__["A" /* KILOS */]) {
        _this.props.weight.input.onChange(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_weight__["c" /* calculateValue */])(__WEBPACK_IMPORTED_MODULE_3__constants__["z" /* POUNDS */], Number(_this.props.weight.input.value)));
      }

      _this.props.weight_unit.input.onChange(__WEBPACK_IMPORTED_MODULE_3__constants__["A" /* KILOS */]);
      _this.close();
    }, _this.updateWeight = function (e) {
      _this.props.weight.input.onChange(e.target.value);
      _this.close();
    }, _this.toggle = function () {
      return _this.setState({ open: !_this.state.open });
    }, _this.close = function () {
      return _this.setState({ open: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Weight, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$label = _props.label,
          label = _props$label === undefined ? "Weight" : _props$label,
          required = _props.required,
          weight = _props.weight,
          unit = _props.weight_unit;
      var open = this.state.open;
      var _weight$meta = weight.meta,
          touched = _weight$meta.touched,
          invalid = _weight$meta.invalid,
          error = _weight$meta.error;

      var hasError = touched && invalid;

      var formGroupClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("form-group", {
        "has-error": hasError
      });

      var inputGroupClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("input-group-btn dropdown", { open: open });

      var errors = hasError && error.map(function (m) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "help-block", key: m },
          m
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: formGroupClasses },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { htmlFor: weight.input.name, className: "control-label" },
          label,
          required && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "sup",
            { className: "small text-danger" },
            "*"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({
            type: "number",
            className: "form-control"
          }, weight.input, {
            onChange: this.updateWeight
          })),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "input-group-addon" },
            unit.input.value
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: inputGroupClasses },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              {
                type: "button",
                className: "btn btn-default dropdown-toggle",
                onClick: this.toggle
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-caret-down" })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "ul",
              { className: "dropdown-menu dropdown-menu-right" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "button",
                  {
                    type: "button",
                    className: "btn btn-link",
                    onClick: this.setPounds
                  },
                  "Standard (Lbs.)"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "button",
                  {
                    type: "button",
                    className: "btn btn-link",
                    onClick: this.setKilos
                  },
                  "Metric (Kgs.)"
                )
              )
            )
          )
        ),
        errors
      );
    }
  }]);

  return Weight;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Weight.propTypes = {
  weight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__["stringInput"].isRequired,
    meta: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__["meta"].isRequired
  }).isRequired,
  weight_unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__["stringInput"].isRequired
  }).isRequired,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators_withFormFields__["a" /* default */])(Weight, [__WEBPACK_IMPORTED_MODULE_3__constants__["j" /* WEIGHT */], __WEBPACK_IMPORTED_MODULE_3__constants__["n" /* WEIGHT_UNIT */]]));

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return actionFactory; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getNotes;
/* harmony export (immutable) */ __webpack_exports__["e"] = createNote;
/* harmony export (immutable) */ __webpack_exports__["d"] = editNote;
/* harmony export (immutable) */ __webpack_exports__["a"] = removeNote;





var actionFactory = function actionFactory(t, r) {
  return t + "_" + r;
};

function getNotes(id, type, notesType) {
  return function (dispatch) {
    dispatch({
      type: [actionFactory(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["b" /* GET_NOTES */], type)],
      notesType: notesType
    });

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].notes.index(id, type, notesType).then(function (resp) {
      return dispatch({
        type: [actionFactory(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["c" /* SET_NOTES */], type)],
        notes: resp.data.results,
        notesType: notesType
      });
    });
  };
}

function createNote(id, type, data, notesType) {
  var note = Object.assign({}, data);

  if (notesType === "internal") {
    note.internal_note = true;
  } else if (notesType === "external") {
    note.external_note = true;
  } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(notesType)) {
    note.note_type = notesType;
  }

  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].notes.create(id, type, note).then(function (resp) {
      dispatch({
        type: [actionFactory(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["d" /* ADD_NOTE */], type)],
        note: resp.data,
        notesType: notesType
      });
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function editNote(id, type, data, notesType) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].notes.update(id, type, data).then(function (resp) {
      dispatch({
        type: [actionFactory(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* UPDATE_NOTE */], type)],
        note: resp.data,
        notesType: notesType
      });
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

function removeNote(id, type, note, notesType) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].notes.delete(id, type, note.toJS()).then(function () {
      dispatch({
        type: [actionFactory(__WEBPACK_IMPORTED_MODULE_1__actionTypes__["e" /* REMOVE_NOTE */], type)],
        id: note.get("id"),
        notesType: notesType
      });
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission_constants__["a" /* SUCCESS */];
    });
  };
}

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__);
/* harmony export (immutable) */ __webpack_exports__["a"] = search;


function search(listId, searchApi, stateLocator) {
  var pageActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["composables"])({ listId: listId });
  var defaultStateLocator = function defaultStateLocator(state) {
    return state[listId];
  };

  return {
    search: function search(pageInfo) {
      return function () {
        return searchApi(pageInfo.query);
      };
    },
    setFilter: function setFilter(k, v) {
      return pageActions.setFilter(k, v);
    },
    setFilters: function setFilters(filters) {
      return pageActions.setFilters(filters);
    },
    setLimit: function setLimit(size) {
      return pageActions.setPageSize(size);
    },
    setPage: function setPage(page) {
      return pageActions.goTo(parseInt(page, 10));
    },
    stateLocator: stateLocator || defaultStateLocator,
    pageActions: pageActions,
    listId: listId
  };
}

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Attachments__ = __webpack_require__(210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Attachments__["a"]; });



/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return modifiedAt; });
/* unused harmony export modifiedBy */





var modifiedAt = function modifiedAt(time) {
  return time ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(time).format("MMM D YYYY, h:mm:ss a") : "Unknown";
};

var modifiedBy = function modifiedBy(name) {
  return name || "System";
};

var createdBy = function createdBy(record) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    "Created: ",
    modifiedAt(record.getIn(["created_at"])),
    " by",
    " ",
    modifiedBy(record.getIn(["created_by", "full_name"]))
  );
};

var updatedBy = function updatedBy(record) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    "Last Edited: ",
    modifiedAt(record.getIn(["updated_at"])),
    " by",
    " ",
    modifiedBy(record.getIn(["updated_by", "full_name"]))
  );
};

var divider = function divider(multiLine) {
  return multiLine ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    "\xA0",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-long-arrow-right" }),
    "\xA0"
  );
};

var AuditFields = function AuditFields(_ref) {
  var record = _ref.record,
      multiLine = _ref.multiLine;

  var showUpdatedBy = record.getIn(["updated_at"]) !== record.getIn(["created_at"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "p",
    { className: "text-muted small" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "em",
      null,
      createdBy(record),
      showUpdatedBy && divider(multiLine),
      showUpdatedBy && updatedBy(record)
    )
  );
};

AuditFields.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  multiLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (AuditFields);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




function Authorized(_ref) {
  var authorized = _ref.authorized,
      children = _ref.children;

  return authorized ? children : false;
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state, ownProps) {
  var user = state.session.get(__WEBPACK_IMPORTED_MODULE_1__users_constants__["a" /* USER */]);
  var userRole = user.get(__WEBPACK_IMPORTED_MODULE_1__users_constants__["h" /* ROLE */]);
  var userSubRole = user.get(__WEBPACK_IMPORTED_MODULE_1__users_constants__["C" /* SUBROLE */]);
  var userPermissions = user.get(__WEBPACK_IMPORTED_MODULE_1__users_constants__["D" /* PERMISSIONS */]);

  var otherRoles = userPermissions && ownProps.roles ? userPermissions.toJS().filter(function (a) {
    return ownProps.roles.includes(a);
  }) : [];

  var hasRole = [__WEBPACK_IMPORTED_MODULE_1__users_constants__["i" /* ADMIN */]].concat(ownProps.roles).includes(userRole) || otherRoles.length > 0;

  var otherSubroles = userPermissions && ownProps.subroles ? userPermissions.toJS().filter(function (a) {
    return ownProps.subroles.includes(a);
  }) : [];

  var hasUserSubRole = ownProps.subroles && (ownProps.subroles.includes(userSubRole) || otherSubroles.length > 0);

  var isManager = state.session.getIn([__WEBPACK_IMPORTED_MODULE_1__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_1__users_constants__["E" /* MANAGER */]]);
  var hasOverriddenPermission = ownProps.permissions && user.get(__WEBPACK_IMPORTED_MODULE_1__users_constants__["D" /* PERMISSIONS */]) && ownProps.permissions.some(function (f) {
    return user.get(__WEBPACK_IMPORTED_MODULE_1__users_constants__["D" /* PERMISSIONS */]).includes(f);
  });

  var roleHasPermission = Object.keys(__WEBPACK_IMPORTED_MODULE_1__users_constants__["F" /* PERMISSIONS_OPTIONS */]).map(function (f) {
    var val = __WEBPACK_IMPORTED_MODULE_1__users_constants__["G" /* ROLES_WITH_PERMISSION */][f] && __WEBPACK_IMPORTED_MODULE_1__users_constants__["G" /* ROLES_WITH_PERMISSION */][f].includes(userRole);

    return {
      permissions: {
        label: f,
        value: val
      }
    };
  });
  var setPermision = roleHasPermission.filter(function (f) {
    return f.permissions.value === true && ownProps.permissions && ownProps.permissions.includes(f.permissions.label);
  });

  return {
    authorized: hasRole || hasUserSubRole || ownProps.allowManagers && isManager || ownProps.authorizedIf && ownProps.authorizedIf(user) || hasOverriddenPermission || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(setPermision)
  };
})(Authorized));

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);








var CommercialDiscreetButton = function CommercialDiscreetButton(_ref) {
  var display = _ref.display,
      getCommercialInvoiceField = _ref.getCommercialInvoiceField,
      setCommercialInvoiceField = _ref.setCommercialInvoiceField;

  var setDiscreet = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    setCommercialInvoiceField(__WEBPACK_IMPORTED_MODULE_5__constants__["l" /* DISCREET */], !getCommercialInvoiceField(__WEBPACK_IMPORTED_MODULE_5__constants__["l" /* DISCREET */]));
  });

  var discreetClass = __WEBPACK_IMPORTED_MODULE_6_classnames___default()("btn btn-danger", {
    "btn-hollow": !getCommercialInvoiceField(__WEBPACK_IMPORTED_MODULE_5__constants__["l" /* DISCREET */])
  });

  if (!display) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: discreetClass, onClick: setDiscreet },
    "Discreet Commercial Invoice"
  );
};

CommercialDiscreetButton.propTypes = {
  display: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  getCommercialInvoiceField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setCommercialInvoiceField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    getCommercialInvoiceField: function getCommercialInvoiceField(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(__WEBPACK_IMPORTED_MODULE_4__Form__["c" /* COMMERCIAL_INVOICE_FORM */])(state, field);
    }
  };
}, function (dispatch) {
  return {
    setCommercialInvoiceField: function setCommercialInvoiceField(field, val) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(__WEBPACK_IMPORTED_MODULE_4__Form__["c" /* COMMERCIAL_INVOICE_FORM */], field, val));
    }
  };
})(CommercialDiscreetButton));

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shipping_constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_countries__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Save__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FormSections_validate__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FormSections_AddressFields__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__FormSections_FreightForwarderAddressFields__ = __webpack_require__(2281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__FormSections_Contact__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__FormSections_PartDetails__ = __webpack_require__(2284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__FormSections_InvoiceWeight__ = __webpack_require__(2282);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMMERCIAL_INVOICE_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REPLACE_PDF; });
/* unused harmony export Form */
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




























var usppiOptions = function usppiOptions(routedExport) {
  return [{ value: true, text: "Seller is USPPI" }, {
    value: false,
    text: "Cust. will need to contact Acting Freight Forwarder and authorize by email or POA"
  }].sort(function () {
    return routedExport ? -1 : 0;
  });
};

var options = [{ value: true, text: "Yes" }, { value: false, text: "No" }];

var consigneeNote = "<div style=\"margin:10px\"><div>&bull;Direct Consumer - a non-government institution, enterprise, or company that will consume or use the exported good as a consumable, for its own internal processes, as an input to the production.</div><br />\n<div>&bull;Government Entity - a government-owned or government-controlled agency, institution, enterprise, or company.</div><br />\n<div>&bull;Reseller - a non-government reseller, retailer, wholesaler, distributor, distribution center or trading company.</div><br />\n<div>&bull;Other/Unknown - an entity not previously indicated, as defined above, or whose ultimate consignee type is not known at the time of export</div></div>";

var usppiNote = "<div style=\"margin:10px\"><div>USPPI - U.S. Principal Party in Interest</div><br />\n<div>If sale is a routed export, customer will need to contact the Freight Forwarder with a written authorization or a Power of Attorney (POA).</div></div>";

var COMMERCIAL_INVOICE_FORM = "commercialInvoice";
var REPLACE_PDF = "replace_pdf";

function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_11__Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__Forms__["e" /* Form */].Body,
      null,
      ["true", true].includes(props.getField(__WEBPACK_IMPORTED_MODULE_15__parts_constants__["h" /* HAZMAT */])) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Warning_Warning__["a" /* default */],
        null,
        "Warning! This part is marked as Hazmat."
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_7__Shipping_constants__["l" /* EIN */],
            label: __WEBPACK_IMPORTED_MODULE_7__Shipping_constants__["l" /* EIN */],
            component: __WEBPACK_IMPORTED_MODULE_11__Forms__["d" /* FormInput */],
            required: true,
            disabled: !props.discreet
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            component: __WEBPACK_IMPORTED_MODULE_11__Forms__["c" /* Select */],
            options: options,
            onChange: function onChange(ev, val) {
              return val && props.setFieldValue(__WEBPACK_IMPORTED_MODULE_7__Shipping_constants__["m" /* USPPI */])(val);
            },
            name: __WEBPACK_IMPORTED_MODULE_7__Shipping_constants__["n" /* ROUTED_EXPORT */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__Shipping_constants__["n" /* ROUTED_EXPORT */]),
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            component: __WEBPACK_IMPORTED_MODULE_11__Forms__["c" /* Select */],
            options: options,
            name: __WEBPACK_IMPORTED_MODULE_15__parts_constants__["h" /* HAZMAT */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_15__parts_constants__["h" /* HAZMAT */]),
            prompt: false,
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { style: { float: "right" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NoteTooltip__["a" /* NoteTooltip */], {
              note: consigneeNote,
              placement: "right",
              icon: "fa-info-circle",
              color: "rgba(255, 255, 255, 0.25)"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_7__Shipping_constants__["o" /* CONSIGNEE */],
            label: "Consignee Type",
            component: __WEBPACK_IMPORTED_MODULE_11__Forms__["c" /* Select */],
            disabled: props.repairOrderId,
            options: props.salesOrderId ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_7__Shipping_constants__["p" /* CONSIGNEE_TYPES */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_7__Shipping_constants__["q" /* REPAIR_ORDER_CONSIGNEE_TYPES */]),
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_13__constants__["_13" /* CUSTOMER_PO */],
            label: "Cust PO#",
            component: __WEBPACK_IMPORTED_MODULE_11__Forms__["d" /* FormInput */],
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__FormSections_InvoiceWeight__["a" /* default */], { label: "Package Gross Weight" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_18__constants__["a" /* CARGO_SCREENING_CONSENT */]),
            name: __WEBPACK_IMPORTED_MODULE_18__constants__["a" /* CARGO_SCREENING_CONSENT */],
            component: __WEBPACK_IMPORTED_MODULE_11__Forms__["c" /* Select */],
            options: options,
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { style: { float: "right" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NoteTooltip__["a" /* NoteTooltip */], {
              note: usppiNote,
              placement: "right",
              icon: "fa-info-circle",
              color: "rgba(255, 255, 255, 0.25)"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_7__Shipping_constants__["m" /* USPPI */],
            label: __WEBPACK_IMPORTED_MODULE_7__Shipping_constants__["m" /* USPPI */].toUpperCase(),
            component: __WEBPACK_IMPORTED_MODULE_11__Forms__["c" /* Select */],
            options: usppiOptions([true, "true"].includes(props.getField(__WEBPACK_IMPORTED_MODULE_7__Shipping_constants__["n" /* ROUTED_EXPORT */]))),
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        null,
        "Freight Forwarder"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__FormSections_FreightForwarderAddressFields__["a" /* default */], {
        path: "freight_forwarder_address",
        formName: COMMERCIAL_INVOICE_FORM,
        freightForwarder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(props, "initialValues.freight_forwarder_address"),
        country: props.getField("freight_forwarder_address.country"),
        required: true
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "freight_forwarder_reference",
            label: "Ref#",
            component: __WEBPACK_IMPORTED_MODULE_11__Forms__["d" /* FormInput */]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
      __WEBPACK_IMPORTED_MODULE_12__lib_countries__["c" /* RESTRICTED_COUNTRIES */].some(function (f) {
        return f.code === props.getField("ultimate_consignee_address.country");
      }) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Warning_Warning__["a" /* default */],
        null,
        "This Country is on the embargoed list. Licensing will be requried to continue. Please contact Logistics Director or Export Compliance Officer prior to processing of Commercial Invoice."
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        null,
        "Ultimate Consignee"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__FormSections_AddressFields__["a" /* default */], {
        path: "ultimate_consignee_address",
        formName: "CommercialInvoiceForm",
        country: props.getField("ultimate_consignee_address.country"),
        addCompanyName: true,
        required: true
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__FormSections_Contact__["a" /* default */], { path: "ultimate_consignee" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "ultimate_consignee_reference",
            label: "Ref#",
            component: __WEBPACK_IMPORTED_MODULE_11__Forms__["d" /* FormInput */]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */],
            component: __WEBPACK_IMPORTED_MODULE_11__Forms__["l" /* TextArea */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */]),
            rows: "5",
            cols: "50",
            maxLength: 230
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        null,
        "Parts"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["FieldArray"], {
        name: __WEBPACK_IMPORTED_MODULE_13__constants__["A" /* LINE_ITEMS */],
        component: __WEBPACK_IMPORTED_MODULE_24__FormSections_PartDetails__["a" /* default */],
        getField: props.getField
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__Forms__["e" /* Form */].Footer,
      null,
      props.submitFailed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Forms__["i" /* Errors */], { errors: props.errorMessages }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Forms__["e" /* Form */].Cancel, {
        close: function close() {
          return props.setCurrentForm && props.setCurrentForm(__WEBPACK_IMPORTED_MODULE_17__helpers__["c" /* SHIPPING_CHECKLIST */]) || props.close();
        },
        editable: true
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Save__["a" /* default */], _extends({
        formName: COMMERCIAL_INVOICE_FORM
      }, props, {
        salesOrderId: props.salesOrderId
      })),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["i" /* Button */],
        { type: "submit", bsStyle: "success" },
        "Download"
      )
    )
  );
}

Form.propTypes = {};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])(COMMERCIAL_INVOICE_FORM);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    getField: function getField(field) {
      return selector(state, field);
    }
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function () {
      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data) {
        var _ref2, invoice;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(ownProps.salesOrderId && !ownProps.outbound && data.has_commercial_invoice_attachment)) {
                  _context.next = 4;
                  break;
                }

                ownProps.setCurrentForm && ownProps.setCurrentForm(__WEBPACK_IMPORTED_MODULE_17__helpers__["d" /* SAVE_OR_REPLACE_FORM */]);
                _context.next = 11;
                break;

              case 4:
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].commercialInvoices.create(data);

              case 6:
                _ref2 = _context.sent;
                invoice = _ref2.data;

                window.location.href = __WEBPACK_IMPORTED_MODULE_13__constants__["d" /* API_BASE */] + "/commercial_invoices/" + invoice.id + "/download_commercial_invoice";
                ownProps.setCurrentForm ? ownProps.setCurrentForm(__WEBPACK_IMPORTED_MODULE_17__helpers__["c" /* SHIPPING_CHECKLIST */]) : ownProps.close();

                ownProps.resetForm();

              case 11:
                return _context.abrupt("return", Promise.resolve());

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function onSubmit(_x) {
        return _ref.apply(this, arguments);
      };
    }(),
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["change"])(COMMERCIAL_INVOICE_FORM, field, val));
      };
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__Forms__["j" /* form */])({
  form: COMMERCIAL_INVOICE_FORM,
  validate: __WEBPACK_IMPORTED_MODULE_20__FormSections_validate__["a" /* default */]
})(Form)));

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_countries__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_states__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return countryOptions; });
/* unused harmony export AddressFields */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var countryOptions = __WEBPACK_IMPORTED_MODULE_6__lib_countries__["a" /* default */].map(function (c) {
  return {
    value: c.code,
    text: c.name
  };
});

var renderStateField = function renderStateField(country, path, required) {
  return country === "US" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
    name: path + "." + __WEBPACK_IMPORTED_MODULE_9__constants__["v" /* STATE */],
    component: __WEBPACK_IMPORTED_MODULE_5__Forms__["c" /* Select */],
    options: __WEBPACK_IMPORTED_MODULE_7__lib_states__["a" /* states */],
    label: "State/Province",
    required: required
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
    name: path + "." + __WEBPACK_IMPORTED_MODULE_9__constants__["v" /* STATE */],
    component: __WEBPACK_IMPORTED_MODULE_5__Forms__["d" /* FormInput */],
    label: "State/Province"
  });
};

var AddressFields = function (_React$Component) {
  _inherits(AddressFields, _React$Component);

  function AddressFields() {
    _classCallCheck(this, AddressFields);

    return _possibleConstructorReturn(this, (AddressFields.__proto__ || Object.getPrototypeOf(AddressFields)).apply(this, arguments));
  }

  _createClass(AddressFields, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.country && nextProps.country !== this.props.country) {
        this.props.resetStateField();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          path = _props.path,
          country = _props.country,
          required = _props.required;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_9__constants__["x" /* COMPANY_NAME */],
              component: __WEBPACK_IMPORTED_MODULE_5__Forms__["d" /* FormInput */],
              label: "Company Name",
              required: required
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_9__constants__["r" /* COUNTRY */],
              component: __WEBPACK_IMPORTED_MODULE_5__Forms__["c" /* Select */],
              label: "Country",
              options: countryOptions,
              required: required
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_9__constants__["s" /* LINE1 */],
              component: __WEBPACK_IMPORTED_MODULE_5__Forms__["d" /* FormInput */],
              label: "Address Line 1",
              required: required
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_9__constants__["t" /* LINE2 */],
              component: __WEBPACK_IMPORTED_MODULE_5__Forms__["d" /* FormInput */],
              label: "Address Line 2"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 5 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_9__constants__["u" /* CITY */],
              component: __WEBPACK_IMPORTED_MODULE_5__Forms__["d" /* FormInput */],
              label: "City",
              required: required
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 4 },
            renderStateField(country, path, required)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_9__constants__["w" /* POSTAL_CODE */],
              component: __WEBPACK_IMPORTED_MODULE_5__Forms__["d" /* FormInput */],
              label: "Zip/Postal Code",
              required: required
            })
          )
        )
      );
    }
  }]);

  return AddressFields;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    resetStateField: function resetStateField() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["change"])(ownProps.formName, ownProps.path + ".state", ""));
    }
  };
})(AddressFields));

AddressFields.propTypes = {
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  country: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  resetStateField: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  required: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* unused harmony export Contact */






function Contact(_ref) {
  var path = _ref.path,
      required = _ref.required;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
          name: path + "_name",
          component: __WEBPACK_IMPORTED_MODULE_2__Forms__["d" /* FormInput */],
          label: "Contact Name",
          required: required
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
          name: path + "_phone",
          component: __WEBPACK_IMPORTED_MODULE_2__Forms__["d" /* FormInput */],
          label: "Contact Telephone"
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
          name: path + "_email",
          component: __WEBPACK_IMPORTED_MODULE_2__Forms__["d" /* FormInput */],
          label: "Contact Email",
          required: required
        })
      )
    )
  );
}

Contact.propTypes = {
  path: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Contact);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(2);
/* unused harmony export Delete */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Delete = function (_Component) {
  _inherits(Delete, _Component);

  function Delete() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Delete);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Delete.__proto__ || Object.getPrototypeOf(Delete)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.open = function (e) {
      e.stopPropagation();
      _this.setState({ open: true });
    }, _this.close = function () {
      return _this.setState({ open: false });
    }, _this.destroy = function () {
      var _this$props = _this.props,
          id = _this$props.id,
          destroy = _this$props.destroy;

      destroy(id);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Delete, [{
    key: "render",
    value: function render() {
      var primary = this.props.primary;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-right" },
        !primary && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          { className: "btn-link", onClick: this.open },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "text-danger" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-close" })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3____["q" /* ConfirmDelete */],
          {
            onConfirm: this.destroy,
            close: this.close,
            open: this.state.open
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          " Are you sure you want to delete this?"
        )
      );
    }
  }]);

  return Delete;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Delete.propTypes = {
  primary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  destroy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    destroy: function destroy(id) {
      return dispatch(ownProps.deleteAction(id));
    }
  };
})(Delete));

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Delete__ = __webpack_require__(483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Delete__["a"]; });



/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Detail__ = __webpack_require__(152);
/* harmony export (immutable) */ __webpack_exports__["a"] = CheckForDetail;





function CheckForDetail(_ref) {
  var value = _ref.value,
      label = _ref.label,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? "text-success" : _ref$className,
      _ref$icon = _ref.icon,
      icon = _ref$icon === undefined ? "check" : _ref$icon,
      _ref$text = _ref.text,
      text = _ref$text === undefined ? "Yes" : _ref$text;

  var display = value && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["k" /* Icon */], { name: icon }),
    " ",
    text
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Detail__["a" /* default */], { label: label, value: display });
}

CheckForDetail.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_domHelpers__ = __webpack_require__(625);
/* harmony export (immutable) */ __webpack_exports__["b"] = ImprovedDropDownItem;
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var context = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({
  activeModalId: "",
  openModal: function openModal() {},
  closeModal: function closeModal() {}
});
var Provider = context.Provider,
    Consumer = context.Consumer;

var ImprovedDropDown = function (_React$Component) {
  _inherits(ImprovedDropDown, _React$Component);

  function ImprovedDropDown() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ImprovedDropDown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImprovedDropDown.__proto__ || Object.getPrototypeOf(ImprovedDropDown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false,
      activeModalId: null
    }, _this.onClickAway = function (e) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_domHelpers__["a" /* default */])(_this.content).contains(e.target)) {
        _this.closeModal();
      }
    }, _this.openModal = function (ev, newModalId) {
      ev.stopPropagation();
      ev.preventDefault();
      _this.setState({
        activeModalId: newModalId,
        open: _this.listen(false)
      });
    }, _this.closeModal = function (ev) {
      if (ev) {
        ev.stopPropagation();
        ev.preventDefault();
      }

      _this.setState({
        activeModalId: null,
        open: _this.listen(false)
      });
    }, _this.toggleOpen = function (ev) {
      ev.stopPropagation();
      ev.preventDefault();
      _this.setState(function (state) {
        return { open: _this.listen(!state.open) };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ImprovedDropDown, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("click", this.onClickAway);
    }
  }, {
    key: "listen",
    value: function listen() {
      var on = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (on) {
        document.addEventListener("click", this.onClickAway);
      } else {
        document.removeEventListener("click", this.onClickAway);
      }

      return on;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          _props$menuClass = _props.menuClass,
          menuClass = _props$menuClass === undefined ? "dropdown-menu-right" : _props$menuClass,
          _props$icon = _props.icon,
          icon = _props$icon === undefined ? "fa fa-fw fa-ellipsis-v" : _props$icon,
          _props$buttonClasses = _props.buttonClasses,
          buttonClasses = _props$buttonClasses === undefined ? "btn-link" : _props$buttonClasses,
          buttonText = _props.buttonText,
          _props$dropdownStyles = _props.dropdownStyles,
          dropdownStyles = _props$dropdownStyles === undefined ? {} : _props$dropdownStyles,
          _props$containerClass = _props.containerClasses,
          containerClasses = _props$containerClass === undefined ? {} : _props$containerClass,
          _props$iconStyles = _props.iconStyles,
          iconStyles = _props$iconStyles === undefined ? {} : _props$iconStyles;
      var _state = this.state,
          open = _state.open,
          activeModalId = _state.activeModalId;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Provider,
        {
          value: {
            activeModalId: activeModalId,
            openModal: this.openModal,
            closeModal: this.closeModal
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("dropdown", { open: open }, containerClasses),
            style: dropdownStyles
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            { className: buttonClasses, onClick: this.toggleOpen },
            buttonText || null,
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: icon, style: iconStyles })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "ul",
            {
              className: "dropdown-menu " + menuClass,
              ref: function ref(node) {
                _this2.content = node;
              }
            },
            children
          )
        )
      );
    }
  }]);

  return ImprovedDropDown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ImprovedDropDown);


ImprovedDropDown.propTypes = {
  buttonText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  menuClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  iconStyles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element)]),
  containerClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  dropdownStyles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  buttonClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

function ImprovedDropDownItem(_ref2) {
  var id = _ref2.id,
      label = _ref2.label,
      faIcon = _ref2.faIcon,
      renderActive = _ref2.renderActive,
      _ref2$hideIf = _ref2.hideIf,
      hideIf = _ref2$hideIf === undefined ? false : _ref2$hideIf,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === undefined ? false : _ref2$disabled;

  if (hideIf) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Consumer,
    null,
    function (_ref3) {
      var openModal = _ref3.openModal,
          closeModal = _ref3.closeModal,
          activeModalId = _ref3.activeModalId;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        {
          onClick: function onClick(ev) {
            return openModal(ev, id);
          },
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ disabled: disabled })
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "a",
          {
            className: "btn-link",
            role: "button",
            style: { cursor: disabled ? "not-allowed" : "pointer" }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-" + faIcon }),
          "\xA0",
          label
        ),
        activeModalId === id &&
        // Inject open/close props into a cloned instance of our renderActive component.
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(renderActive, {
          open: true,
          close: closeModal
        })
      );
    }
  );
}

ImprovedDropDownItem.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  faIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideIf: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  renderActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shortid__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shortid__);
/* harmony export (immutable) */ __webpack_exports__["a"] = Errors;




var messageMap = function messageMap(message) {
  if (message === "Purchased at Required") {
    return "Date of Price (DOP) Required";
  }
  return message.replace("srp", "SRP");
};

function Errors(_ref) {
  var errors = _ref.errors;

  if (errors && errors.length > 0) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "alert alert-danger text-left" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        { style: { fontWeight: "bold" } },
        "One or more errors were encountered:"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "ul",
        null,
        errors.map(function (e) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            { key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shortid__["generate"])() },
            messageMap(e)
          );
        })
      )
    );
  }

  return null;
}

Errors.propTypes = {
  errors: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
};

Errors.defaultProps = {
  errors: {}
};

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formField__ = __webpack_require__(142);
/* harmony export (immutable) */ __webpack_exports__["b"] = FormInput;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





function FormInput(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === undefined ? "text" : _ref$type,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? "" : _ref$className,
      input = _ref.input,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === undefined ? "off" : _ref$autoComplete,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === undefined ? false : _ref$readOnly,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$inputProps = _ref.inputProps,
      inputProps = _ref$inputProps === undefined ? {} : _ref$inputProps;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({
    type: type,
    autoComplete: autoComplete,
    id: input.name,
    className: "form-control " + className,
    readOnly: readOnly,
    disabled: disabled
  }, input, inputProps));
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formField__["a" /* default */])(FormInput));

FormInput.propTypes = {
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired }).isRequired,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    min: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
    max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
    placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
  })
};

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_components_shared_Dimensions__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_components_shared_CentimeterDimensions__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parts_components_shared_NetWeight__ = __webpack_require__(764);








/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var getField = _ref.getField;
  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "h4",
    null,
    "Net (Part) Weight & Dims"
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__FormRow__["a" /* default */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__parts_components_shared_NetWeight__["a" /* default */], null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__parts_components_shared_Dimensions__["a" /* NetDimensions */], null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__parts_components_shared_CentimeterDimensions__["a" /* default */], {
        length: getField(__WEBPACK_IMPORTED_MODULE_5__parts_constants__["p" /* NET_LENGTH */]),
        height: getField(__WEBPACK_IMPORTED_MODULE_5__parts_constants__["r" /* NET_HEIGHT */]),
        width: getField(__WEBPACK_IMPORTED_MODULE_5__parts_constants__["q" /* NET_WIDTH */])
      })
    )
  )];
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony export (immutable) */ __webpack_exports__["a"] = hiddenInputs;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function hiddenInputs(components) {
  return function (hidden) {
    return Object.entries(components).reduce(function (enhanced, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          name = _ref2[0],
          C = _ref2[1];

      return _extends({}, enhanced, _defineProperty({}, name, function (props) {
        return hidden ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(C, props);
      }));
    }, {});
  };
}

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony export (immutable) */ __webpack_exports__["a"] = Icon;




function Icon(_ref) {
  var name = _ref.name,
      _ref$fixed = _ref.fixed,
      fixed = _ref$fixed === undefined ? false : _ref$fixed;

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("fa fa-" + name, {
    "fa-fw": fixed
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: classes });
}

Icon.propTypes = { name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired, fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool };

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_resourceTypes__ = __webpack_require__(58);
/* harmony export (immutable) */ __webpack_exports__["a"] = resourceTypeToStateKey;
var _map;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var map = (_map = {}, _defineProperty(_map, __WEBPACK_IMPORTED_MODULE_1__types_resourceTypes__["a" /* default */].company, "companyDetail"), _defineProperty(_map, __WEBPACK_IMPORTED_MODULE_1__types_resourceTypes__["a" /* default */].part, "partDetail"), _defineProperty(_map, __WEBPACK_IMPORTED_MODULE_1__types_resourceTypes__["a" /* default */].rma, "rmaDetail"), _defineProperty(_map, __WEBPACK_IMPORTED_MODULE_1__types_resourceTypes__["a" /* default */].incomingQuote, "incomingQuoteDetail"), _defineProperty(_map, __WEBPACK_IMPORTED_MODULE_1__types_resourceTypes__["a" /* default */].inventory, "inventoryDetail"), _defineProperty(_map, __WEBPACK_IMPORTED_MODULE_1__types_resourceTypes__["a" /* default */].lot, "lotDetail"), _defineProperty(_map, __WEBPACK_IMPORTED_MODULE_1__types_resourceTypes__["a" /* default */].outgoingQuote, "outgoingQuoteDetail"), _defineProperty(_map, __WEBPACK_IMPORTED_MODULE_1__types_resourceTypes__["a" /* default */].managedRepairOrder, "mroDetail"), _defineProperty(_map, __WEBPACK_IMPORTED_MODULE_1__types_resourceTypes__["a" /* default */].purchaseOrder, "purchaseOrderDetail"), _defineProperty(_map, __WEBPACK_IMPORTED_MODULE_1__types_resourceTypes__["a" /* default */].receivingRecord, "receivingRecordDetail"), _defineProperty(_map, __WEBPACK_IMPORTED_MODULE_1__types_resourceTypes__["a" /* default */].repairOrder, "repairOrderDetail"), _defineProperty(_map, __WEBPACK_IMPORTED_MODULE_1__types_resourceTypes__["a" /* default */].salesOrder, "salesOrderDetail"), _defineProperty(_map, __WEBPACK_IMPORTED_MODULE_1__types_resourceTypes__["a" /* default */].shipment, "shipmentDetail"), _map);

function resourceTypeToStateKey(resourceType) {
  return map[resourceType] || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["camelCase"])(resourceType.slice(0, -1)) + "Detail";
}

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PurchaseOrderLineItemStatusCell__ = __webpack_require__(2381);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PurchaseOrderLineItemStatusCell__["a"]; });



/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony export (immutable) */ __webpack_exports__["a"] = RestrictedAddressWarning;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









function RestrictedAddressWarning(_ref) {
  var line1 = _ref.line1,
      city = _ref.city,
      state = _ref.state,
      postalCode = _ref.postal_code,
      country = _ref.country,
      requireApproval = _ref.requireApproval;

  var addressParams = {
    line1: line1,
    city: city,
    state: state,
    postal_code: postalCode,
    country: country
  };

  if (Object.entries(addressParams).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 1),
        key = _ref3[0];

    return key !== __WEBPACK_IMPORTED_MODULE_4__constants__["v" /* STATE */];
  }).some(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        _ = _ref5[0],
        value = _ref5[1];

    return !value;
  })) return null;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      restrictedAddresses = _useState2[0],
      setRestrictedAddresses = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].restrictedEntities.addressSearch(addressParams).then(function (resp) {
      if (Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(resp, "data.total", 0)) > 0) {
        setRestrictedAddresses(resp.data.results);
      } else {
        setRestrictedAddresses(null);
      }
    });
  }, [line1, city, state, postalCode, country]);

  if (!restrictedAddresses) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Warning: Similar entity address in US Gov't Screening List: $",
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["b" /* toSentence */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["flatten"])(restrictedAddresses.map(function (r) {
      return r.individual_address;
    }))),
    " ",
    requireApproval && "Preapproval Required."
  );
}

RestrictedAddressWarning.propTypes = {
  line1: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  city: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  state: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  postal_code: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  country: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShippingAddressTable__ = __webpack_require__(2389);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ShippingAddressTable__["a"]; });



/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_daterangepicker__ = __webpack_require__(577);






function SimpleDateRangePicker(_ref) {
  var handleDateChange = _ref.handleDateChange,
      _ref$defaultLast30Day = _ref.defaultLast30Days,
      defaultLast30Days = _ref$defaultLast30Day === undefined ? true : _ref$defaultLast30Day;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_daterangepicker__["a" /* default */],
    {
      initialSettings: {
        startDate: defaultLast30Days && __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(29, __WEBPACK_IMPORTED_MODULE_3__constants__["_32" /* DAYS */]).toDate(),
        endDate: defaultLast30Days && __WEBPACK_IMPORTED_MODULE_2_moment___default()().toDate(),
        ranges: {
          Today: [__WEBPACK_IMPORTED_MODULE_2_moment___default()().toDate(), __WEBPACK_IMPORTED_MODULE_2_moment___default()().toDate()],
          Yesterday: [__WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, __WEBPACK_IMPORTED_MODULE_3__constants__["_32" /* DAYS */]).toDate(), __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, __WEBPACK_IMPORTED_MODULE_3__constants__["_32" /* DAYS */]).toDate()],
          "Last 7 Days": [__WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(6, __WEBPACK_IMPORTED_MODULE_3__constants__["_32" /* DAYS */]).toDate(), __WEBPACK_IMPORTED_MODULE_2_moment___default()().toDate()],
          "Last 30 Days": [__WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(29, __WEBPACK_IMPORTED_MODULE_3__constants__["_32" /* DAYS */]).toDate(), __WEBPACK_IMPORTED_MODULE_2_moment___default()().toDate()],
          "This Month": [__WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf(__WEBPACK_IMPORTED_MODULE_3__constants__["_33" /* MONTH */]).toDate(), __WEBPACK_IMPORTED_MODULE_2_moment___default()().endOf(__WEBPACK_IMPORTED_MODULE_3__constants__["_33" /* MONTH */]).toDate()],
          "Last Month": [__WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, __WEBPACK_IMPORTED_MODULE_3__constants__["_33" /* MONTH */]).startOf(__WEBPACK_IMPORTED_MODULE_3__constants__["_33" /* MONTH */]), __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, __WEBPACK_IMPORTED_MODULE_3__constants__["_33" /* MONTH */]).endOf(__WEBPACK_IMPORTED_MODULE_3__constants__["_33" /* MONTH */])]
        }
      },
      onCallback: handleDateChange
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "input-group-btn" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { type: "button", className: "btn btn-success " },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-calendar" }),
        "\xA0",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Select Date"
        ),
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-caret-down" })
      )
    )
  );
}

SimpleDateRangePicker.propTypes = {
  defaultLast30Days: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  handleDateChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SimpleDateRangePicker);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = Stat;



function Stat(_ref) {
  var label = _ref.label,
      value = _ref.value,
      labelFontSize = _ref.labelFontSize;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "text-center" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      { className: "margin-bottom-none", style: { fontSize: labelFontSize } },
      value
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      { className: "lead text-muted", style: { fontSize: 14 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "em",
        null,
        label
      )
    )
  );
}

Stat.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelFontSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Stat.defaultProps = {
  labelFontSize: "24px"
};

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Warning__ = __webpack_require__(53);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Warning__["a"]; });



/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_ModalLauncher__ = __webpack_require__(355);
/* harmony export (immutable) */ __webpack_exports__["a"] = launchModal;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function launchModal(modal) {
  var Launcher = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__containers_ModalLauncher__["a" /* default */];

  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Launcher, _extends({}, props, { modal: modal }));
  };
}

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pagination; });




var pagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["a" /* createPaginatedList */])({
  listId: "users",
  fetch: __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].users.search,
  forceDebounce: true,
  stateLocator: function stateLocator(state) {
    return state.users.main;
  },
  initialSettings: {
    sort: "first_name"
  }
});

/* harmony default export */ __webpack_exports__["b"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  main: pagination.paginator
}));

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_users_constants__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(user, settings) {
    window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__modules_users_constants__["a" /* USER */], JSON.stringify(user));
    if (settings) window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SETTINGS */], JSON.stringify(settings));
  },
  setBookmarks: function setBookmarks(bookmarks) {
    window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__modules_users_constants__["d" /* BOOKMARKS */], JSON.stringify(bookmarks));
  },
  setSettings: function setSettings(settings) {
    window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SETTINGS */], JSON.stringify(settings));
  },
  setRepairCartItems: function setRepairCartItems(repairCartItems) {
    window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__modules_users_constants__["c" /* REPAIR_CART_ITEMS */], JSON.stringify(repairCartItems));
  },
  setSalesCartItems: function setSalesCartItems(salesCartItems) {
    window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__modules_users_constants__["b" /* SALES_CART_ITEMS */], JSON.stringify(salesCartItems));
  },
  logout: function logout() {
    [__WEBPACK_IMPORTED_MODULE_1__modules_users_constants__["d" /* BOOKMARKS */], __WEBPACK_IMPORTED_MODULE_1__modules_users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_1__modules_users_constants__["c" /* REPAIR_CART_ITEMS */], __WEBPACK_IMPORTED_MODULE_1__modules_users_constants__["b" /* SALES_CART_ITEMS */]].forEach(function (f) {
      return window.localStorage.removeItem(f);
    });
  }
});

/***/ }),
/* 502 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(2486);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 504 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 505 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(249);
var dPs = __webpack_require__(2501);
var enumBugKeys = __webpack_require__(505);
var IE_PROTO = __webpack_require__(510)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(830)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(2492).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 508 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(216).f;
var has = __webpack_require__(215);
var TAG = __webpack_require__(154)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(511)('keys');
var uid = __webpack_require__(357);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(195);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 512 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(504);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(252);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(195);
var core = __webpack_require__(153);
var LIBRARY = __webpack_require__(506);
var wksExt = __webpack_require__(516);
var defineProperty = __webpack_require__(216).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(154);


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(97);
var toAbsoluteIndex = __webpack_require__(227);
var toLength = __webpack_require__(91);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(2520);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(90);
var createDesc = __webpack_require__(224);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(68);
var document = __webpack_require__(60).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 521 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(81)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(60).document;
module.exports = document && document.documentElement;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(68);
var setPrototypeOf = __webpack_require__(532).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(253);
var ITERATOR = __webpack_require__(81)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(221);
var descriptor = __webpack_require__(224);
var setToStringTag = __webpack_require__(254);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(123)(IteratorPrototype, __webpack_require__(81)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(220);
var $export = __webpack_require__(18);
var redefine = __webpack_require__(124);
var hide = __webpack_require__(123);
var has = __webpack_require__(122);
var Iterators = __webpack_require__(253);
var $iterCreate = __webpack_require__(526);
var setToStringTag = __webpack_require__(254);
var getPrototypeOf = __webpack_require__(133);
var ITERATOR = __webpack_require__(81)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 528 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 529 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(60);
var macrotask = __webpack_require__(538).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(145)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(111);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(68);
var anObject = __webpack_require__(57);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(146)(Function.call, __webpack_require__(132).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(369)('keys');
var uid = __webpack_require__(228);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(159);
var defined = __webpack_require__(157);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(363);
var defined = __webpack_require__(157);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(159);
var defined = __webpack_require__(157);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(146);
var invoke = __webpack_require__(851);
var html = __webpack_require__(523);
var cel = __webpack_require__(520);
var global = __webpack_require__(60);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(145)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(60);
var DESCRIPTORS = __webpack_require__(89);
var LIBRARY = __webpack_require__(220);
var $typed = __webpack_require__(371);
var hide = __webpack_require__(123);
var redefineAll = __webpack_require__(225);
var fails = __webpack_require__(66);
var anInstance = __webpack_require__(218);
var toInteger = __webpack_require__(159);
var toLength = __webpack_require__(91);
var toIndex = __webpack_require__(869);
var gOPN = __webpack_require__(222).f;
var dP = __webpack_require__(90).f;
var arrayFill = __webpack_require__(517);
var setToStringTag = __webpack_require__(254);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(60);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(60);
var core = __webpack_require__(156);
var LIBRARY = __webpack_require__(220);
var wksExt = __webpack_require__(870);
var defineProperty = __webpack_require__(90).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(291);
var ITERATOR = __webpack_require__(81)('iterator');
var Iterators = __webpack_require__(253);
module.exports = __webpack_require__(156).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(196);
var step = __webpack_require__(854);
var Iterators = __webpack_require__(253);
var toIObject = __webpack_require__(134);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(527)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(181);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var off = function off() {};
if (_inDOM2.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

exports.default = off;
module.exports = exports['default'];

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(294);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;

  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}
module.exports = exports['default'];

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 547 */,
/* 548 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

exports = module.exports = function(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}


/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(231),
    root = __webpack_require__(162);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 564 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 565 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(232),
    isKey = __webpack_require__(2915),
    stringToPath = __webpack_require__(2941),
    toString = __webpack_require__(2957);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(2870);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(929);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(2874),
    stubArray = __webpack_require__(936);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(2865),
    Map = __webpack_require__(563),
    Promise = __webpack_require__(2867),
    Set = __webpack_require__(2868),
    WeakMap = __webpack_require__(2871),
    baseGetTag = __webpack_require__(259),
    toSource = __webpack_require__(931);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 571 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(925);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(262)(module)))

/***/ }),
/* 573 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(389),
    isLength = __webpack_require__(934);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(917),
    baseKeys = __webpack_require__(2885),
    isArrayLike = __webpack_require__(574);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_daterangepicker__ = __webpack_require__(2475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_daterangepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_daterangepicker__);
/* unused harmony export DateRangePicker */




/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var DateRangePicker = /** @class */ (function (_super) {
    __extends(DateRangePicker, _super);
    function DateRangePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = null;
        _this.$picker = null;
        return _this;
    }
    DateRangePicker.prototype.componentDidMount = function () {
        var _this = this;
        // initialize daterangepicker
        this.$picker = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.ref);
        this.$picker.daterangepicker(this.props.initialSettings, this.handleCallback.bind(this));
        // attach event listeners
        ['Show', 'Hide', 'ShowCalendar', 'HideCalendar', 'Apply', 'Cancel'].forEach(function (event) {
            var _a;
            var lcase = event.toLowerCase();
            (_a = _this.$picker) === null || _a === void 0 ? void 0 : _a.on(lcase + '.daterangepicker', _this.makeEventHandler('on' + event));
        });
    };
    DateRangePicker.prototype.componentWillUnmount = function () {
        var _a, _b;
        (_b = (_a = this.$picker) === null || _a === void 0 ? void 0 : _a.data('daterangepicker')) === null || _b === void 0 ? void 0 : _b.remove();
    };
    DateRangePicker.prototype.handleCallback = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (typeof this.props.onCallback === 'function') {
            (_a = this.props).onCallback.apply(_a, args);
        }
    };
    DateRangePicker.prototype.makeEventHandler = function (eventType) {
        var _this = this;
        var onEvent = this.props.onEvent;
        return function (event, picker) {
            if (typeof onEvent === 'function') {
                onEvent(event, picker);
            }
            if (typeof _this.props[eventType] === 'function') {
                _this.props[eventType](event, picker);
            }
        };
    };
    DateRangePicker.prototype.setStartDate = function (dateOrString) {
        var _a, _b;
        (_b = (_a = this.$picker) === null || _a === void 0 ? void 0 : _a.data('daterangepicker')) === null || _b === void 0 ? void 0 : _b.setStartDate(dateOrString);
    };
    DateRangePicker.prototype.setEndDate = function (dateOrString) {
        var _a, _b;
        (_b = (_a = this.$picker) === null || _a === void 0 ? void 0 : _a.data('daterangepicker')) === null || _b === void 0 ? void 0 : _b.setEndDate(dateOrString);
    };
    DateRangePicker.prototype.render = function () {
        var _this = this;
        var childElement = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(childElement, {
            ref: function (el) { return (_this.ref = el); },
        });
    };
    return DateRangePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

/* harmony default export */ __webpack_exports__["a"] = (DateRangePicker);

//# sourceMappingURL=index.es.js.map


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Button__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(39);













var propTypes = {
  vertical: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  justified: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Display block buttons; only useful when used with the "vertical" prop.
   * @type {bool}
   */
  block: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, function (_ref) {
    var block = _ref.block,
        vertical = _ref.vertical;
    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
  })
};

var defaultProps = {
  block: false,
  justified: false,
  vertical: false
};

var ButtonGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ButtonGroup, _React$Component);

  function ButtonGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ButtonGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ButtonGroup.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        block = _props.block,
        justified = _props.justified,
        vertical = _props.vertical,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['block', 'justified', 'vertical', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps)] = !vertical, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'vertical')] = vertical, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'justified')] = justified, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_9__Button__["a" /* default */].defaultProps, 'block')] = block, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsClass */])('btn-group', ButtonGroup));

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

var defaultProps = {
  label: 'Close'
};

var CloseButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(CloseButton, _React$Component);

  function CloseButton() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CloseButton);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  CloseButton.prototype.render = function render() {
    var _props = this.props,
        label = _props.label,
        onClick = _props.onClick;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'button',
      {
        type: 'button',
        className: 'close',
        onClick: onClick
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        label
      )
    );
  };

  return CloseButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (CloseButton);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_style__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_overlays_lib_Transition__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_overlays_lib_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_overlays_lib_Transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(98);














var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

function getDimensionValue(dimension, elem) {
  var value = elem['offset' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(dimension)];
  var margins = MARGINS[dimension];

  return value + parseInt(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default()(elem, margins[0]), 10) + parseInt(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default()(elem, margins[1]), 10);
}

var propTypes = {
  /**
   * Show the component; triggers the expand or collapse animation
   */
  'in': __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is collapsed
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Run the expand animation when the component mounts, if it is initially
   * shown
   */
  transitionAppear: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Duration of the collapse animation in milliseconds, to ensure that
   * finishing callbacks are fired even if the original browser transition end
   * events are canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,

  /**
   * Callback fired before the component expands
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to expand
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component has expanded
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired before the component collapses
   */
  onExit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component has collapsed
   */
  onExited: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * The dimension used when collapsing, or a function that returns the
   * dimension
   *
   * _Note: Bootstrap only partially supports 'width'!
   * You will need to supply your own CSS animation for the `.width` CSS class._
   */
  dimension: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['height', 'width']), __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func]),

  /**
   * Function that returns the height or width of the animating DOM node
   *
   * Allows for providing some custom logic for how much the Collapse component
   * should animate in its specified dimension. Called with the current
   * dimension prop value and the DOM node.
   */
  getDimensionValue: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * ARIA role of collapsible element
   */
  role: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  'in': false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  transitionAppear: false,

  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Collapse, _React$Component);

  function Collapse(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Collapse);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleEnter = _this.handleEnter.bind(_this);
    _this.handleEntering = _this.handleEntering.bind(_this);
    _this.handleEntered = _this.handleEntered.bind(_this);
    _this.handleExit = _this.handleExit.bind(_this);
    _this.handleExiting = _this.handleExiting.bind(_this);
    return _this;
  }

  /* -- Expanding -- */


  Collapse.prototype.handleEnter = function handleEnter(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = '0';
  };

  Collapse.prototype.handleEntering = function handleEntering(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
  };

  Collapse.prototype.handleEntered = function handleEntered(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = null;
  };

  /* -- Collapsing -- */


  Collapse.prototype.handleExit = function handleExit(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
    triggerBrowserReflow(elem);
  };

  Collapse.prototype.handleExiting = function handleExiting(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = '0';
  };

  Collapse.prototype._dimension = function _dimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  };

  // for testing


  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    return elem['scroll' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(dimension)] + 'px';
  };

  Collapse.prototype.render = function render() {
    var _props = this.props,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);

    delete props.dimension;
    delete props.getDimensionValue;

    var handleEnter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter);
    var handleEntering = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEntering, onEntering);
    var handleEntered = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEntered, onEntered);
    var handleExit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExit, onExit);
    var handleExiting = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExiting, onExiting);

    var classes = {
      width: this._dimension() === 'width'
    };

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_overlays_lib_Transition___default.a, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      'aria-expanded': props.role ? props['in'] : null,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
      exitedClassName: 'collapse',
      exitingClassName: 'collapsing',
      enteredClassName: 'collapse in',
      enteringClassName: 'collapsing',
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: handleEntered,
      onExit: handleExit,
      onExiting: handleExiting
    }));
  };

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











var propTypes = {
  /**
   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
   */
  glyph: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
};

var Glyphicon = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Glyphicon, _React$Component);

  function Glyphicon() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Glyphicon);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Glyphicon.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        glyph = _props.glyph,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['glyph', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, glyph)] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Glyphicon;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Glyphicon.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('glyphicon', Glyphicon));

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MediaBody__ = __webpack_require__(2999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MediaHeading__ = __webpack_require__(3000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MediaLeft__ = __webpack_require__(3001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MediaList__ = __webpack_require__(3002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MediaListItem__ = __webpack_require__(3003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__MediaRight__ = __webpack_require__(3004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__ = __webpack_require__(39);

















var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Media = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Media, _React$Component);

  function Media() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Media);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Media.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Media;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Media.propTypes = propTypes;
Media.defaultProps = defaultProps;

Media.Heading = __WEBPACK_IMPORTED_MODULE_9__MediaHeading__["a" /* default */];
Media.Body = __WEBPACK_IMPORTED_MODULE_8__MediaBody__["a" /* default */];
Media.Left = __WEBPACK_IMPORTED_MODULE_10__MediaLeft__["a" /* default */];
Media.Right = __WEBPACK_IMPORTED_MODULE_13__MediaRight__["a" /* default */];
Media.List = __WEBPACK_IMPORTED_MODULE_11__MediaList__["a" /* default */];
Media.ListItem = __WEBPACK_IMPORTED_MODULE_12__MediaListItem__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["c" /* bsClass */])('media', Media));

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);








var TAB = 'tab';
var PANE = 'pane';

var idPropType = __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]);

var propTypes = {
  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: function id(props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(undefined, [props].concat(args));

      if (!error && !props.id) {
        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
      }
    }

    return error;
  },


  /**
   * A function that takes an `eventKey` and `type` and returns a unique id for
   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
   * function, meaning it should always return the _same_ id for the same set
   * of inputs. The default value requires that an `id` to be set for the
   * `<TabContainer>`.
   *
   * The `type` argument will either be `"tab"` or `"pane"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * A callback fired when a tab is selected.
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * The `eventKey` of the currently active tab.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};

var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
  })
};

var TabContainer = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(TabContainer, _React$Component);

  function TabContainer() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TabContainer);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  TabContainer.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        activeKey = _props.activeKey,
        onSelect = _props.onSelect,
        generateChildId = _props.generateChildId,
        id = _props.id;


    var getId = generateChildId || function (key, type) {
      return id ? id + '-' + type + '-' + key : null;
    };

    return {
      $bs_tabContainer: {
        activeKey: activeKey,
        onSelect: onSelect,
        getTabId: function getTabId(key) {
          return getId(key, TAB);
        },
        getPaneId: function getPaneId(key) {
          return getId(key, PANE);
        }
      }
    };
  };

  TabContainer.prototype.render = function render() {
    var _props2 = this.props,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['children']);

    delete props.generateChildId;
    delete props.onSelect;
    delete props.activeKey;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children), props);
  };

  return TabContainer;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

TabContainer.propTypes = propTypes;
TabContainer.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(TabContainer, { activeKey: 'onSelect' }));

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);












var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,

  /**
   * Sets a default animation strategy for all children `<TabPane>`s. Use
   * `false` to disable, `true` to enable the default `<Fade>` animation or any
   * `<Transition>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when they are no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  componentClass: 'div',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
  })
};

var childContextTypes = {
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired
  })
};

var TabContent = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TabContent, _React$Component);

  function TabContent(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabContent);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
    _this.handlePaneExited = _this.handlePaneExited.bind(_this);

    // Active entries in state will be `null` unless `animation` is set. Need
    // to track active child in case keys swap and the active child changes
    // but the active key does not.
    _this.state = {
      activeKey: null,
      activeChild: null
    };
    return _this;
  }

  TabContent.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        animation = _props.animation,
        mountOnEnter = _props.mountOnEnter,
        unmountOnExit = _props.unmountOnExit;


    var stateActiveKey = this.state.activeKey;
    var containerActiveKey = this.getContainerActiveKey();

    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;

    return {
      $bs_tabContent: {
        bsClass: bsClass,
        animation: animation,
        activeKey: activeKey,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        onPaneEnter: this.handlePaneEnter,
        onPaneExited: this.handlePaneExited,
        exiting: exiting
      }
    };
  };

  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!nextProps.animation && this.state.activeChild) {
      this.setState({ activeKey: null, activeChild: null });
    }
  };

  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
    if (!this.props.animation) {
      return false;
    }

    // It's possible that this child should be transitioning out.
    if (childKey !== this.getContainerActiveKey()) {
      return false;
    }

    this.setState({
      activeKey: childKey,
      activeChild: child
    });

    return true;
  };

  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
    // This might happen as everything is unmounting.
    if (this.isUnmounted) {
      return;
    }

    this.setState(function (_ref) {
      var activeChild = _ref.activeChild;

      if (activeChild !== child) {
        return null;
      }

      return {
        activeKey: null,
        activeChild: null
      };
    });
  };

  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
    var tabContainer = this.context.$bs_tabContainer;
    return tabContainer && tabContainer.activeKey;
  };

  TabContent.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        className = _props2.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['componentClass', 'className']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content'))
    }));
  };

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

TabContent.propTypes = propTypes;
TabContent.defaultProps = defaultProps;
TabContent.contextTypes = contextTypes;
TabContent.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('tab', TabContent));

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(3041);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(3040);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(94);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _componentOrElement = __webpack_require__(399);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _ownerDocument = __webpack_require__(235);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _getContainer = __webpack_require__(398);

var _getContainer2 = _interopRequireDefault(_getContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {

      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();
        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget);
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _this.getOverlayDOMNode = function () {
      if (!_this._isMounted) {
        throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
      }

      if (_this._overlayInstance) {
        return _reactDom2.default.findDOMNode(_this._overlayInstance);
      }

      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      this._renderOverlay();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._renderOverlay();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this._overlayTarget && nextProps.container !== this.props.container) {
        this._portalContainerNode.removeChild(this._overlayTarget);
        this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
        this._portalContainerNode.appendChild(this._overlayTarget);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
      this._unrenderOverlay();
      this._unmountOverlayTarget();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func])
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _contains = __webpack_require__(257);

var _contains2 = _interopRequireDefault(_contains);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(94);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(397);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(235);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, (RootCloseWrapper.__proto__ || Object.getPrototypeOf(RootCloseWrapper)).call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  _createClass(RootCloseWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.disabled) {
        this.addEventListeners();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!this.props.disabled && prevProps.disabled) {
        this.addEventListeners();
      } else if (this.props.disabled && !prevProps.disabled) {
        this.removeEventListeners();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!this.props.disabled) {
        this.removeEventListeners();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _on = __webpack_require__(372);

var _on2 = _interopRequireDefault(_on);

var _properties = __webpack_require__(878);

var _properties2 = _interopRequireDefault(_properties);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(94);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var transitionEndEvent = _properties2.default.end;

var UNMOUNTED = exports.UNMOUNTED = 0;
var EXITED = exports.EXITED = 1;
var ENTERING = exports.ENTERING = 2;
var ENTERED = exports.ENTERED = 3;
var EXITING = exports.EXITING = 4;

/**
 * The Transition component lets you define and run css transitions with a simple declarative api.
 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
 * but is specifically optimized for transitioning a single child "in" or "out".
 *
 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
 * The extensive set of lifecycle callbacks means you have control over
 * the transitioning now at each step of the way.
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this, props, context));

    _this.updateStatus = function () {
      if (_this.nextStatus !== null) {
        (function () {
          // nextStatus will always be ENTERING or EXITING.
          _this.cancelNextCallback();
          var node = _reactDom2.default.findDOMNode(_this);

          if (_this.nextStatus === ENTERING) {
            _this.props.onEnter(node);

            _this.safeSetState({ status: ENTERING }, function () {
              _this.props.onEntering(node);

              _this.onTransitionEnd(node, function () {
                _this.safeSetState({ status: ENTERED }, function () {
                  _this.props.onEntered(node);
                });
              });
            });
          } else {
            _this.props.onExit(node);

            _this.safeSetState({ status: EXITING }, function () {
              _this.props.onExiting(node);

              _this.onTransitionEnd(node, function () {
                _this.safeSetState({ status: EXITED }, function () {
                  _this.props.onExited(node);
                });
              });
            });
          }

          _this.nextStatus = null;
        })();
      } else if (_this.props.unmountOnExit && _this.state.status === EXITED) {
        _this.setState({ status: UNMOUNTED });
      }
    };

    _this.cancelNextCallback = function () {
      if (_this.nextCallback !== null) {
        _this.nextCallback.cancel();
        _this.nextCallback = null;
      }
    };

    _this.safeSetState = function (nextState, callback) {
      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      _this.setState(nextState, _this.setNextCallback(callback));
    };

    _this.setNextCallback = function (callback) {
      var active = true;

      _this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this.nextCallback = null;

          callback(event);
        }
      };

      _this.nextCallback.cancel = function () {
        active = false;
      };

      return _this.nextCallback;
    };

    _this.onTransitionEnd = function (node, handler) {
      _this.setNextCallback(handler);

      if (node) {
        (0, _on2.default)(node, transitionEndEvent, _this.nextCallback);
        setTimeout(_this.nextCallback, _this.props.timeout);
      } else {
        setTimeout(_this.nextCallback, 0);
      }
    };

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (props.transitionAppear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  _createClass(Transition, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateStatus();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var status = this.state.status;


      if (nextProps.in) {
        if (status === UNMOUNTED) {
          this.setState({ status: EXITED });
        }
        if (status !== ENTERING && status !== ENTERED) {
          this.nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          this.nextStatus = EXITING;
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateStatus();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.cancelNextCallback();
    }
  }, {
    key: 'render',
    value: function render() {
      var status = this.state.status;
      if (status === UNMOUNTED) {
        return null;
      }

      var _props = this.props;
      var children = _props.children;
      var className = _props.className;

      var childProps = _objectWithoutProperties(_props, ['children', 'className']);

      Object.keys(Transition.propTypes).forEach(function (key) {
        return delete childProps[key];
      });

      var transitionClassName = void 0;
      if (status === EXITED) {
        transitionClassName = this.props.exitedClassName;
      } else if (status === ENTERING) {
        transitionClassName = this.props.enteringClassName;
      } else if (status === ENTERED) {
        transitionClassName = this.props.enteredClassName;
      } else if (status === EXITING) {
        transitionClassName = this.props.exitingClassName;
      }

      var child = _react2.default.Children.only(children);
      return _react2.default.cloneElement(child, _extends({}, childProps, {
        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
      }));
    }
  }]);

  return Transition;
}(_react2.default.Component);

Transition.propTypes = {
  /**
   * Show the component; triggers the enter or exit animation
   */
  in: _propTypes2.default.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: _propTypes2.default.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is not shown
   */
  unmountOnExit: _propTypes2.default.bool,

  /**
   * Run the enter animation when the component mounts, if it is initially
   * shown
   */
  transitionAppear: _propTypes2.default.bool,

  /**
   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
   * transition indefinately if the browser transitionEnd events are
   * canceled or interrupted.
   *
   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
   * setting this to the duration of your animation (or a bit above it).
   */
  timeout: _propTypes2.default.number,

  /**
   * CSS class or classes applied when the component is exited
   */
  exitedClassName: _propTypes2.default.string,
  /**
   * CSS class or classes applied while the component is exiting
   */
  exitingClassName: _propTypes2.default.string,
  /**
   * CSS class or classes applied when the component is entered
   */
  enteredClassName: _propTypes2.default.string,
  /**
   * CSS class or classes applied while the component is entering
   */
  enteringClassName: _propTypes2.default.string,

  /**
   * Callback fired before the "entering" classes are applied
   */
  onEnter: _propTypes2.default.func,
  /**
   * Callback fired after the "entering" classes are applied
   */
  onEntering: _propTypes2.default.func,
  /**
   * Callback fired after the "enter" classes are applied
   */
  onEntered: _propTypes2.default.func,
  /**
   * Callback fired before the "exiting" classes are applied
   */
  onExit: _propTypes2.default.func,
  /**
   * Callback fired after the "exiting" classes are applied
   */
  onExiting: _propTypes2.default.func,
  /**
   * Callback fired after the "exited" classes are applied
   */
  onExited: _propTypes2.default.func
};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.displayName = 'Transition';

Transition.defaultProps = {
  in: false,
  unmountOnExit: false,
  transitionAppear: false,

  timeout: 5000,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

exports.default = Transition;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var toastr = {
  maxAnimationDelay: 6000,
  newestOnTop: true,
  position: 'top-right',
  preventDuplicates: true
};

exports.default = toastr;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_TOASTR = exports.ADD_TOASTR = '@ReduxToastr/toastr/ADD';
var REMOVE_TOASTR = exports.REMOVE_TOASTR = '@ReduxToastr/toastr/REMOVE';
var CLEAN_TOASTR = exports.CLEAN_TOASTR = '@ReduxToastr/toastr/CLEAN';
var SHOW_CONFIRM = exports.SHOW_CONFIRM = '@ReduxToastr/confirm/SHOW';
var HIDE_CONFIRM = exports.HIDE_CONFIRM = '@ReduxToastr/confirm/HIDE';
var REMOVE_BY_TYPE = exports.REMOVE_BY_TYPE = '@ReduxToastr/toastr/REMOVE_BY_TYPE';
// before add a new transition - check its presence in src/styles/animations.scss
var TRANSITIONS = exports.TRANSITIONS = {
  in: ['bounceIn', 'bounceInDown', 'fadeIn'],
  out: ['bounceOut', 'bounceOutUp', 'fadeOut']
};

/***/ }),
/* 591 */,
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(402);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_session_actions__ = __webpack_require__(131);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony export (immutable) */ __webpack_exports__["b"] = destroy;





function create(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.bookmarks.create(id).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__modules_session_actions__["refreshCarts"])());
      __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].success("Success", "Part successfully added to Bookmarks.");
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].error("Error", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(err, "errors.base[0]"));
    });
  };
}

function destroy(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].parts.bookmarks.destroy(id).then(function () {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__modules_session_actions__["refreshCarts"])());
    });
  };
}

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REMOVE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EXPIRE; });
var ADD = "notifications/ADD";
var REMOVE = "notifications/REMOVE";
var REMOVE_ALL = "notifications/REMOVE_ALL";
var SET_ALL = "notifications/SET_ALL";
var EXPIRE = "notifications/EXPIRE";

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cable__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_Notifications_actions__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(621);
/* unused harmony export setAll */
/* harmony export (immutable) */ __webpack_exports__["b"] = fetch;
/* unused harmony export remove */
/* harmony export (immutable) */ __webpack_exports__["d"] = markRead;
/* harmony export (immutable) */ __webpack_exports__["c"] = onDelete;
/* harmony export (immutable) */ __webpack_exports__["a"] = expire;
/* harmony export (immutable) */ __webpack_exports__["e"] = subscribe;





var notificationExists = function notificationExists(id, notifications) {
  return notifications.map(function (n) {
    return n.id;
  }).find(function (i) {
    return i === id;
  });
};

function setAll(results, totalCount, unreadCount) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* SET_ALL */],
    notifications: results,
    totalCount: totalCount,
    unreadCount: unreadCount
  };
}

function fetch(params) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].notifications.search(params).then(function (_ref) {
      var data = _ref.data;

      dispatch(setAll(data.results, data.total_count, data.data.unread_count));
    });
  };
}

function remove(noteId) {
  return { type: __WEBPACK_IMPORTED_MODULE_3__actionTypes__["b" /* REMOVE */], id: noteId };
}

function markRead(noteId) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].notifications.update(noteId, { read: true }).then(function () {
      dispatch(__WEBPACK_IMPORTED_MODULE_2__modules_Notifications_actions__["b" /* expireNotifications */]());
      dispatch(__WEBPACK_IMPORTED_MODULE_2__modules_Notifications_actions__["c" /* expireSearchNotifications */]());
      dispatch(fetch({
        page: 1,
        limit: 20,
        sort: "id",
        reverse: true,
        filter: true
      }));
    });
  };
}

function onDelete(noteId) {
  return function (dispatch) {
    dispatch(remove(noteId));

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].notifications.update(noteId, { deleted_at: new Date() }).then(function () {
      dispatch(__WEBPACK_IMPORTED_MODULE_2__modules_Notifications_actions__["b" /* expireNotifications */]());
      dispatch(__WEBPACK_IMPORTED_MODULE_2__modules_Notifications_actions__["c" /* expireSearchNotifications */]());
    });
  };
}

function expire() {
  return { type: __WEBPACK_IMPORTED_MODULE_3__actionTypes__["c" /* EXPIRE */] };
}

function subscribe() {
  return function (dispatch, getState) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cable__["b" /* createChannel */])().listen("NotificationChannel", {
      onReceive: function onReceive(data) {
        var notifications = getState().notifications.get("notifications").toJS();

        if (data.action === "ADD") {
          if (!notificationExists(data.notification.id, notifications)) {
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_3__actionTypes__["d" /* ADD */],
              notification: data.notification
            });

            var results = getState().searchNotifications.get("results").toJS();

            if (results && results.length === 20) {
              results.pop();
            }

            dispatch({
              type: "@@paginate-this/RESET_RESULTS_searchNotifications",
              results: [data.notification].concat(results)
            });
          }
        } else if (data.action === "REMOVE") {
          if (notificationExists(data.notification.id, notifications)) {
            dispatch(remove(data.notification.id));
            dispatch(__WEBPACK_IMPORTED_MODULE_2__modules_Notifications_actions__["b" /* expireNotifications */]());
            dispatch(__WEBPACK_IMPORTED_MODULE_2__modules_Notifications_actions__["c" /* expireSearchNotifications */]());
          }
        } else if (data.action === "REMOVE_ALL") {
          dispatch(__WEBPACK_IMPORTED_MODULE_2__modules_Notifications_actions__["b" /* expireNotifications */]());
          dispatch(__WEBPACK_IMPORTED_MODULE_2__modules_Notifications_actions__["c" /* expireSearchNotifications */]());
        }
      }
    });
  };
}

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(165);
/* harmony export (immutable) */ __webpack_exports__["a"] = useDispatch;


function useDispatch() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* default */])().dispatch;
}

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(165);
/* harmony export (immutable) */ __webpack_exports__["a"] = useRejectedCore;


function useRejectedCore() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* default */])().getState().rejectedCoreDetail.get("rejectedCore").toJS();
}

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrap;
function wrap(element) {
  function contains(el) {
    if (element === el) {
      return true;
    }

    if (!el.parentElement) {
      return false;
    }

    return contains(el.parentElement);
  }

  return { contains: contains };
}

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = recordCollector;
var perPage = 100;

/*
 * This serves to retrieve all records from a paginated endpoint. It does
 * this by requesting pages until it receives an empty response. Example
 * usage:
 *
 * componentWillMount() {
 *  recordCollector(api).then(records => this.setState({ records }));
 * }
 */
function recordCollector(api) {
  var page = 1;
  var records = [];

  var crank = function crank() {
    return api(page, perPage).then(function (resp) {
      var results = resp.data.results;


      records = records.concat(results);

      if (results.length === perPage) {
        page += 1;
        return crank();
      }

      return records;
    });
  };

  return crank().then(function () {
    return records;
  });
}

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(100);
/* harmony export (immutable) */ __webpack_exports__["a"] = onSuccess;


function onSuccess(submit, callback) {
  var formProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var onError = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

  return function (e) {
    // We've had issues with folks clicking submit buttons multiple times thus
    // creating duplicate records. This is a final safe-guard to ensure a single
    // form can only be successfully submitted once.
    if (formProps.submitSucceeded) {
      return false;
    }
    var submitResult = submit(e);

    if (!submitResult.then) {
      return false;
    }

    return submitResult.then(function (resp) {
      if (resp === __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SUCCESS */]) {
        callback();
      }
    }).catch(onError);
  };
}

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
function throttle(f, ms) {
  var timer = null;

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timer);

    return new Promise(function (resolve) {
      timer = setTimeout(function () {
        resolve(f.apply(undefined, args));
      }, ms);
    });
  };
}

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateUUID;
function generateUUID() {
  // Public Domain/MIT
  var d = new Date().getTime(); // Timestamp
  var d2 = typeof performance !== "undefined" && performance.now && performance.now() * 1000 || 0; // Time in microseconds since page-load or 0 if unsupported
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16; // random number between 0 and 16
    if (d > 0) {
      // eslint-disable-next-line no-bitwise
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      // Use microseconds since page-load if supported
      // eslint-disable-next-line no-bitwise
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    // eslint-disable-next-line no-bitwise
    return (c === "x" ? r : r & 0x3 | 0x8).toString(16);
  });
}

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rules__ = __webpack_require__(1234);
/* unused harmony export defineValidator */
/* harmony export (immutable) */ __webpack_exports__["a"] = validator;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable */


var customRules = {};

function defineValidator(_ref) {
  var name = _ref.name,
      rule = _ref.rule;

  customRules[name] = { rule: rule };
}

defineValidator({ name: "required", rule: __WEBPACK_IMPORTED_MODULE_0__rules__["a" /* required */] });
defineValidator({ name: "isNumeric", rule: __WEBPACK_IMPORTED_MODULE_0__rules__["b" /* numeric */] });

defineValidator({
  name: "matches",
  rule: __WEBPACK_IMPORTED_MODULE_0__rules__["c" /* matches */]
});

function validator() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var validations = arguments[1];
  var translator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (message) {
    return message;
  };

  var errors = {};

  function validateFields(rules, fields) {
    fields.forEach(function (f) {
      rules.forEach(function (rule) {
        var error = rule(values[f], values);
        if (error) {
          errors[f] = (errors[f] || []).concat(translator(error, f));
        }
      });
    });
  }

  function customValidator(fields) {
    return Object.keys(customRules).reduce(function (v, name) {
      var config = customRules[name];
      var validation = function validation() {
        var rule = arguments.length ? config.rule.apply(config, arguments) : config.rule;
        return validateFields([rule], fields);
      };

      return _extends(_defineProperty({}, name, validation), v);
    }, {
      satisfies: function satisfies() {
        for (var _len = arguments.length, rules = Array(_len), _key = 0; _key < _len; _key++) {
          rules[_key] = arguments[_key];
        }

        return validateFields(rules, fields);
      }
    });
  }

  var v = {
    validateChild: function validateChild(field, childValidations) {
      var childTranslator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : translator;

      var childErrors = validator(values[field] || {}, childValidations, childTranslator);

      if (Object.keys(childErrors).length > 0) {
        errors[field] = childErrors;
      }
    },
    validateChildren: function validateChildren(field, childValidations) {
      var childTranslator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : translator;

      var childErrors = (values[field] || []).map(function (v) {
        return validator(v, childValidations, childTranslator);
      });
      if (childErrors.some(function (e) {
        return Object.keys(e).length > 0;
      })) {
        errors[field] = childErrors;
      }
    },
    validate: function validate() {
      for (var _len2 = arguments.length, fields = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        fields[_key2] = arguments[_key2];
      }

      return customValidator(fields);
    }
  };

  validations(v, values);

  return errors;
}

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony export (immutable) */ __webpack_exports__["a"] = registerSearch;
/* harmony export (immutable) */ __webpack_exports__["b"] = unregisterSearch;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var searches = {};

function registerSearch(search) {
  searches[search.listId] = search;
}

function unregisterSearch(search) {
  delete searches[search.listId];
}

var updateHistory = function updateHistory(filters) {
  var existingFilters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_query_string__["parse"])(window.location.search);
  var updatedFilters = _extends({}, existingFilters, filters);
  var paramsStr = Object.keys(updatedFilters).length > 0 ? "?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_query_string__["stringify"])(updatedFilters) : "";

  window.history.pushState(null, null, paramsStr);
};

var debounceUpdateHistory = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (field, value) {
  updateHistory(_defineProperty({ page: 1 }, field, value));
}, 300);

// Redux middleware that keeps URL params and browser history in sync with various paginate-this actions.
var syncSearchStateWithUrl = function syncSearchStateWithUrl(store) {
  return function (next) {
    return function (action) {
      var state = store.getState();

      Object.keys(searches).forEach(function (listId) {
        var search = searches[listId];

        switch (action.type) {
          case "@@paginate-this/GO_TO_PAGE_" + search.listId:
            updateHistory({ page: action.page });
            break;
          case "@@paginate-this/NEXT_PAGE_" + search.listId:
            updateHistory({ page: search.stateLocator(state).get("page") + 1 });
            break;
          case "@@paginate-this/PREVIOUS_PAGE_" + search.listId:
            updateHistory({ page: search.stateLocator(state).get("page") - 1 });
            break;
          case "@@paginate-this/SET_FILTER_" + search.listId:
            debounceUpdateHistory(action.field, action.value);
            break;
          case "@@paginate-this/SET_FILTERS_" + search.listId:
            updateHistory(_extends({ page: 1 }, action.filters));
            break;
          default:
        }
      });

      return next(action);
    };
  };
};

/* harmony default export */ __webpack_exports__["c"] = (syncSearchStateWithUrl);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_pagination__ = __webpack_require__(67);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["a" /* createPaginatedList */])({
  listId: "searchAccountingLogs",
  fetch: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].accountingLogs.search,
  stateLocator: function stateLocator(state) {
    return state.searchAccountingLogs;
  },
  initialSettings: {
    sort: "id",
    sortReverse: true,
    filters: {
      filter: true
    }
  }
}));

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "consignmentReports",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].consignments.report
}));

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pagination; });




var pagination = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["a" /* createPaginatedList */])({
  listId: "reports",
  fetch: __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reports.search,
  stateLocator: function stateLocator(state) {
    return state.reports.main;
  }
});

/* harmony default export */ __webpack_exports__["b"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  main: pagination.paginator
}));

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cable__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__session_actionTypes__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* unused harmony export unsubscribe */
/* unused harmony export onDisconnect */
/* unused harmony export refreshAppSettings */
/* harmony export (immutable) */ __webpack_exports__["a"] = subscribe;






var channel = null;

function unsubscribe() {
  if (channel) {
    channel.unsubscribe();
    channel = null;
  }
}

function onDisconnect() {
  return unsubscribe();
}

function refreshAppSettings() {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].locations.search().then(function (_ref) {
      var data = _ref.data;

      var locations = data.results;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].appSetting.index().then(function (response) {
        dispatch({
          type: __WEBPACK_IMPORTED_MODULE_3__session_actionTypes__["i" /* SET_SETTINGS */],
          settings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(response.data, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* SETTINGS */]),
          locations: locations
        });
      });
    });
  };
}

function subscribe() {
  return function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cable__["b" /* createChannel */])().listen("SessionChannel", {
      onDisconnect: onDisconnect,
      onReceive: function onReceive() {
        dispatch(refreshAppSettings());
      }
    });
  };
}

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components_NoteTooltip_AuditedNoteTooltip__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RowActions__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions__ = __webpack_require__(263);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return costAdjLabel; });


















function StatusBadge(_ref) {
  var status = _ref.status;

  switch (status) {
    case "paid":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "label label-success" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check" }),
        "\xA0\xA0 Paid"
      );
    case "pending":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "label label-warning" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-pause" }),
        "\xA0\xA0 Pending"
      );
    case "bad_debt":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "label label-danger" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-warning" }),
        "\xA0\xA0 Bad Debt"
      );
    case "reversed":
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "label label-success" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check" }),
        "\xA0\xA0 Reversed"
      );
    default:
      return false;
  }
}

StatusBadge.propTypes = {
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var costAdjLabel = function costAdjLabel(c, depreciationCommission) {
  if (depreciationCommission) {
    return "Depreciation (-)";
  } else if (c.cost_adjustment_id) {
    return __WEBPACK_IMPORTED_MODULE_13__inventories_constants__["_77" /* COST_ADJUSTMENT_OPTIONS */][c.adjustment_type].abbrev;
  } else if (c.reversal) {
    return "SO Credit";
  }

  if (c.managed_repair_order_line_item_id) {
    return "MRO";
  }
  return "SO";
};

function Row(_ref2) {
  var commission = _ref2.commission,
      canEdit = _ref2.canEdit,
      pushHistory = _ref2.pushHistory,
      setCommission = _ref2.setCommission,
      setUpdateStatusModalOpen = _ref2.setUpdateStatusModalOpen,
      setUpdateOverrideOpen = _ref2.setUpdateOverrideOpen;

  var c = commission;

  var depreciationCommission = !c.reference_cost_adj_sales_item_id && c.cost_adjustment_id;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { key: c.id, className: "clickable", onClick: function onClick() {
        return pushHistory(c);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["c" /* shortDateYY */])(c.sales_date)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(c, "sales_order.code", __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(c, "managed_repair_order.code"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      costAdjLabel(c, depreciationCommission)
    ),
    canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      c.team_leader && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components__["j" /* NoteTooltip */], { icon: "fa-users", note: "Team Leader" }),
        "\xA0\xA0"
      ),
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["d" /* getFirstNameLastInitial */])(c.employee.full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components__["w" /* CompanyName */], { flattenedCompany: c })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components__["h" /* PartNumber */], {
        part: {
          id: c.part_id,
          part_number: c.part_number,
          tier_type: c.part_tier_type,
          uuid: c.part_uuid
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          to: "/inventories/" + (c.inventory.uuid || c.inventory_id)
        },
        c.serial_number
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["z" /* condition */])(c.condition).abbrev
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_currency__["a" /* dollars */])(c.cost)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      c.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_currency__["a" /* dollars */])(c.sale_price)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_currency__["a" /* dollars */])(c.profit)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      c.seller && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["d" /* getFirstNameLastInitial */])(c.seller.full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["d" /* getFirstNameLastInitial */])(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(c, "buyer.full_name"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["d" /* getFirstNameLastInitial */])(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(c, "co_buyer.full_name"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["d" /* getFirstNameLastInitial */])(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(c, "third_buyer.full_name"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      c.customer_purchase_order_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      c.invoice_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["c" /* shortDateYY */])(depreciationCommission ? c.created_at : c.invoice_paid_date)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["c" /* shortDateYY */])(c.paid_date)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StatusBadge, { status: c.status }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], { obj: c, field: "status" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_number__["c" /* displayDecimal */])(c.sales_credit_percent || c.credit_percent, 10),
      "%"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_currency__["a" /* dollars */])(c.sales_credit)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_currency__["a" /* dollars */])(c.profit_credit)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      c.total_commission && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_currency__["a" /* dollars */])(c.total_commission),
      " ",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], { obj: c, field: "overridden_value" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      c.freight_complete || c.cost_adjustment_id ? "Yes" : "No"
    ),
    canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__RowActions__["a" /* default */], {
        commission: c,
        setCommission: setCommission,
        setUpdateStatusModalOpen: setUpdateStatusModalOpen,
        setUpdateOverrideOpen: setUpdateOverrideOpen
      })
    )
  );
}

function LockedButton(_ref3) {
  var commission = _ref3.commission,
      onClick = _ref3.onClick;

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
    "text-danger": commission.locked && !commission.commissions_paid,
    "text-success": !commission.locked && !commission.commissions_paid,
    "text-muted": commission.commissions_paid
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    {
      className: classes,
      onClick: commission.commissions_paid ? function (e) {
        return e.stopPropagation();
      } : onClick
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components__["k" /* Icon */], { name: commission.locked ? "lock" : "unlock" })
  );
}

LockedButton.propTypes = {
  commission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

Row.propTypes = {
  canEdit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  commission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    customer_paid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    locked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    profit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    profit_credit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    sale_price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    sales_date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    sales_order_code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    positive_credit_percent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    seller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    }).isRequired,
    serial_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    sales_credit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    total_commission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  manager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    toggleLock: function toggleLock(commission) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__actions__["a" /* toggleLock */])(commission));
    },
    pushHistory: function pushHistory(commission) {
      var url = commission.cost_adjustment_id ? "/inventories/" + (commission.inventory.uuid || commission.inventory_id) : "/sales-orders/" + commission.sales_order.uuid;

      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["push"])(url));
    }
  };
})(Row));

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
var SET = "consignments/SET";

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "customerRmas",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].customerRmas.search
}));

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = DepreciationsSum;





var depreciationsSum = function depreciationsSum(data, country) {
  var field = (country ? country.toLowerCase() : "total") + "_depreciations";
  var writeDownField = (country ? country.toLowerCase() : "total") + "_write_downs";

  return data.reduce(function (sum, result) {
    return sum + Number(result[field]) + Number(result[writeDownField]);
  }, 0);
};

var label = function label(country) {
  return country ? country.toUpperCase() : "Total";
};

function DepreciationsSum(_ref) {
  var data = _ref.data,
      dateLabel = _ref.dateLabel,
      country = _ref.country;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["H" /* Stat */], {
    label: "$ Depreciations " + label(country, dateLabel),
    value: __WEBPACK_IMPORTED_MODULE_1_numeral___default()(depreciationsSum(data, country)).format("($0,0)"),
    labelFontSize: "44px"
  });
}

DepreciationsSum.propTypes = {
  country: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  dateLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}))
};

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__IncomingQuoteTypeSelect__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__parts_components_Detail_IncomingQuotes_LineItemsTable__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__parts_components_Detail_SalesOrders_Table__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__parts_components_Detail_PurchaseOrders_Table__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Total__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_shared_SelectInventoryTable__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__parts_components_Detail_IncomingQuotes_Create_ExistingQuoteWarning__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_time__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__inventories_components_EditInventory_TagTypes__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__PartDetails__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__parts_components_shared_SellableQty__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__validate__ = __webpack_require__(424);
/* unused harmony export Form */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


































var FORM_NAME = "incomingQuoteDetailAddPart";

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedPart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(_this.props.selectedLineItem, __WEBPACK_IMPORTED_MODULE_26__parts_constants__["B" /* PART */]),
      recentIQs: [],
      recentSOs: [],
      recentPOs: [],
      alternateOptions: [],
      recentCompanyQuotes: []
    }, _this.searchParts = function (filter) {
      return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].parts.searchPartsAndAlternates({
        part_number: filter,
        search_type: "search",
        sold_recently_status: true
      }).then(function (resp) {
        return resp.data.results;
      });
    }, _this.fetchAlternateOptions = function (partId, defaultAlt) {
      if (partId) {
        return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].parts.alternates.search(partId).then(function (resp) {
          var vals = resp.data.results;
          var opts = vals.map(function (val) {
            return {
              text: val.name,
              value: val.id
            };
          });

          return _this.setState({ alternateOptions: opts }, function () {
            if (defaultAlt) {
              _this.props.change("rfq_as_alt_id", defaultAlt.id);
            }
          });
        });
      }

      return null;
    }, _this.handlePartSelected = function (partOrAlt) {
      var part = {
        part_number: partOrAlt.base_part_number,
        id: partOrAlt.id
      };
      _this.setState({ selectedPart: part });

      if (_this.props.setPart) {
        _this.props.setPart(part);
      }

      var alt = partOrAlt.alternate ? { id: partOrAlt.alternate_id, part_number: partOrAlt.part_number } : null;

      _this.fetchAlternateOptions(part.id, alt);

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].parts.incomingQuoteLineItems.search(part.id, { limit: 5 }).then(function (_ref2) {
        var recentIQs = _ref2.data.results;

        var filteredIQs = recentIQs.filter(function (quote) {
          return !_this.props.selectedLineItem || _this.props.selectedLineItem.id !== quote.id;
        });
        _this.setState({ recentIQs: filteredIQs });
      });

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].parts.purchaseOrderAndLots.search(part.id, { limit: 3 }).then(function (_ref3) {
        var recentPOs = _ref3.data.results;

        _this.setState({ recentPOs: recentPOs });
      });

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].parts.salesOrderLineItems.search(part.id, { limit: 3 }).then(function (_ref4) {
        var recentSOs = _ref4.data.results;

        _this.setState({ recentSOs: recentSOs });
      });

      _this.fetchRecentCompanyQuotes(part.id);
    }, _this.fetchRecentCompanyQuotes = function (partId) {
      var _this$props = _this.props,
          companyId = _this$props.companyId,
          selectedLineItem = _this$props.selectedLineItem;


      if (partId && companyId) {
        __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].parts.incomingQuoteLineItems.search(partId, { limit: 5, company_id: companyId }).then(function (res) {
          var filteredQuotes = res.data.results.filter(function (quote) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_time__["b" /* isLessThan36HoursAgo */])(quote.created_at) && (!selectedLineItem || selectedLineItem.id !== quote.id);
          });

          _this.setState({ recentCompanyQuotes: filteredQuotes });
        });
      }
    }, _this.formatPartSearch = function (part) {
      if (part.alternate) {
        return part.part_number + " - " + part.base_part_number;
      }

      return part.part_number;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.selectedLineItem && this.props.selectedLineItem.part) {
        var part = this.props.selectedLineItem.part;
        part.base_part_number = part.part_number;
        this.handlePartSelected(part);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.selectedLineItem && nextProps.selectedLineItem !== this.props.selectedLineItem) {
        this.setState({ selectedPart: nextProps.selectedLineItem.part });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          quantity = _props.quantity,
          cost = _props.cost,
          quoteType = _props.quoteType,
          _props$quoteTypes = _props.quoteTypes,
          quoteTypes = _props$quoteTypes === undefined ? __WEBPACK_IMPORTED_MODULE_13__constants__["b" /* INCOMING_LINE_ITEMS */].quoteType : _props$quoteTypes;
      var _state = this.state,
          selectedPart = _state.selectedPart,
          recentPOs = _state.recentPOs,
          recentIQs = _state.recentIQs,
          recentSOs = _state.recentSOs,
          alternateOptions = _state.alternateOptions,
          recentCompanyQuotes = _state.recentCompanyQuotes;


      var notesColumnClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()({
        "col-md-12": quoteType !== __WEBPACK_IMPORTED_MODULE_13__constants__["n" /* AWAITING_REPLY */],
        "col-md-6": quoteType === __WEBPACK_IMPORTED_MODULE_13__constants__["n" /* AWAITING_REPLY */]
      });

      var types = Object.assign({}, quoteTypes);

      if (quoteType !== __WEBPACK_IMPORTED_MODULE_13__constants__["l" /* INCIDENT_RELATED */]) {
        delete types.incident_related;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "nav nav-tabs" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              null,
              "Quote Type & Part Number"
            )
          ),
          recentCompanyQuotes.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__parts_components_Detail_IncomingQuotes_Create_ExistingQuoteWarning__["a" /* default */], { quote: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])(recentCompanyQuotes[0]) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_21__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["e" /* Col */],
              { md: 8 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: "row row-col-gutters-half",
                  style: { marginTop: "26px" }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], {
                    names: [__WEBPACK_IMPORTED_MODULE_19__constants__["V" /* COST */], __WEBPACK_IMPORTED_MODULE_19__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_20__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */]],
                    component: __WEBPACK_IMPORTED_MODULE_9__IncomingQuoteTypeSelect__["a" /* default */],
                    quoteTypes: types
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                      autoFocus: true,
                      name: __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["q" /* PART_ID */],
                      label: "Part #",
                      placeholder: "Type a part's name of ID number...",
                      component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["n" /* AutoCompleteField */],
                      search: this.searchParts,
                      formatItem: this.formatPartSearch,
                      selectedItem: selectedPart,
                      onItemSelected: function onItemSelected(i) {
                        return i && _this2.handlePartSelected(i);
                      },
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                      name: "rfq_as_alt_id",
                      label: "RFQ as Alt",
                      component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["c" /* Select */],
                      options: alternateOptions
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__parts_components_shared_SellableQty__["a" /* default */], {
                quantities: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(selectedPart, __WEBPACK_IMPORTED_MODULE_26__parts_constants__["P" /* SELLABLE_QUANTITIES */], {})))
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                { className: "margin-bottom-30 line-height-2" },
                "Next Available Inventory"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_redux_form__["FormSection"],
                  { name: "ingoing_quote_line_item" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_shared_SelectInventoryTable__["a" /* default */], {
                    filter: {
                      limit: "5",
                      sellable_status: [__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["U" /* LIST */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["W" /* DO_NOT_LIST */]].join(",")
                    },
                    part: selectedPart,
                    choosable: false,
                    modal: false,
                    displayQuantity: false
                  })
                )
              ),
              quoteType !== __WEBPACK_IMPORTED_MODULE_13__constants__["j" /* NO_QUOTE */] && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  null,
                  "Part Details"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__PartDetails__["a" /* default */], {
                  quoteType: quoteType,
                  taggedBy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(this.props.selectedLineItem, __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["p" /* TAGGED_BY */])
                })
              ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_21__shared_components_Forms_FormRow__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["e" /* Col */],
                  { md: 12 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], {
                    component: __WEBPACK_IMPORTED_MODULE_24__inventories_components_EditInventory_TagTypes__["a" /* default */],
                    names: [__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["L" /* UK_CAA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["M" /* OTHER */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["N" /* OTHER_TAG_TYPE */]],
                    formName: FORM_NAME
                  })
                )
              )],
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Most Recent Incoming Quotes"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__parts_components_Detail_IncomingQuotes_LineItemsTable__["a" /* LineItemsTable */], { results: recentIQs, disableRowNav: true, inForm: true }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Most Recent Sales Orders"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__parts_components_Detail_SalesOrders_Table__["b" /* Table */], { results: recentSOs, disableRowNav: true }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Most Recent Purchase Orders"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__parts_components_Detail_PurchaseOrders_Table__["b" /* Table */], { results: recentPOs, disableRowNav: true }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_21__shared_components_Forms_FormRow__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: notesColumnClassName },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                      name: "notes",
                      component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["l" /* TextArea */],
                      label: "Note (Applied to the line item)"
                    })
                  )
                ),
                quoteType === __WEBPACK_IMPORTED_MODULE_13__constants__["n" /* AWAITING_REPLY */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: notesColumnClassName },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_25__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */],
                      component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["l" /* TextArea */],
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_25__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */])
                    })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Total__["a" /* default */], { part: selectedPart, quantity: quantity, cost: cost })
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  quoteType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  companyId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  quoteTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  selectedLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  searchParts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setPart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(FORM_NAME);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    quantity: selector(state, __WEBPACK_IMPORTED_MODULE_19__constants__["j" /* QUANTITY */]),
    cost: selector(state, __WEBPACK_IMPORTED_MODULE_19__constants__["V" /* COST */]),
    quoteType: selector(state, __WEBPACK_IMPORTED_MODULE_20__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */]),
    companyId: state.incomingQuoteDetail.getIn(["incomingQuote", __WEBPACK_IMPORTED_MODULE_23__companies_constants__["p" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_19__constants__["b" /* ID */]])
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_30__validate__["b" /* default */]
})(Form)));

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_DateRangePicker_DateRangePicker__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Table__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pagination__ = __webpack_require__(318);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INCOMING_QUOTE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INCOMING_QUOTE_FILTER_TAGS; });
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






















var defaultFilters = {
  awaiting_reply: undefined,
  awaiting_reply_72: undefined,
  current_user: undefined,
  end_date: undefined,
  quote_type: undefined,
  start_date: undefined
};

var INCOMING_QUOTE_FILTERS = [{
  label: "My Incoming Quotes",
  filters: { current_user: true }
}, {
  label: "All Incoming Quotes",
  filters: defaultFilters
}, {
  label: "Standard",
  filters: {
    quote_type: __WEBPACK_IMPORTED_MODULE_10__constants__["k" /* STANDARD */]
  }
}, {
  label: "Awaiting Reply (All)",
  filters: {
    quote_type: undefined,
    awaiting_reply: true,
    awaiting_reply_72: undefined
  }
}, {
  label: "Awaiting Reply (72 hours old)",
  filters: {
    quote_type: undefined,
    awaiting_reply_72: true,
    awaiting_reply: undefined
  },
  exclude_parts_view: true
}, {
  label: "All Offers Made",
  filters: _extends({}, defaultFilters, { quote_type: __WEBPACK_IMPORTED_MODULE_10__constants__["m" /* OFFER */] })
}];

var INCOMING_QUOTE_FILTER_TAGS = [{
  label: "Show My IQs",
  key: "current_user"
}, {
  label: "Awaiting Reply (All)",
  key: "awaiting_reply"
}, {
  label: "Awaiting Reply (72 hours old)",
  key: "awaiting_reply_72"
}, {
  label: "All Offers Made",
  key: "quote_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_10__constants__["m" /* OFFER */])
}, {
  label: "Standard Quotes",
  key: "quote_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_10__constants__["k" /* STANDARD */])
}];

var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = searchProps.paginator.get("filters").toJS();
  var incomingQuotesTotalCount = searchProps.paginator.get("totalCount");

  params.total_count = incomingQuotesTotalCount;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        if (incomingQuotesTotalCount > __WEBPACK_IMPORTED_MODULE_16__users_constants__["_6" /* EXPORT_LIMIT */]) {
          __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].info("Processing");
          __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].incomingQuotes.export(params).then(function () {
            return __WEBPACK_IMPORTED_MODULE_14__lib_submission__["a" /* SUCCESS */];
          });
        } else {
          window.open(__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* API_BASE */] + "/incoming_quotes/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_query_string__["stringify"])(params), "_blank");
          __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].success("Processing Incoming Quotes Report. Please wait for the PDF to generate.");
        }
      }
    },
    "Export"
  );
};

var meetsExportCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var searchProps = _ref2.searchProps;

  var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__hooks_useCurrentUser__["a" /* default */])();
  return searchProps.paginator.get("totalCount") <= 450 || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__users_helpers__["d" /* hasRole */])(user, __WEBPACK_IMPORTED_MODULE_16__users_constants__["i" /* ADMIN */]);
});

var DecoratedExportButton = meetsExportCriteria(ExportButton);

function IncomingQuoteSearch(_ref3) {
  var pushHistory = _ref3.pushHistory;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      buyersFilter = _useState2[0],
      setBuyersFilter = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState4 = _slicedToArray(_useState3, 2),
      buyersTags = _useState4[0],
      setBuyersTags = _useState4[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].users.search({
      all_buyers: true,
      page: 1,
      sort: "first_name",
      reverse: false,
      limit: 1000
    }).then(function (resp) {
      var buyers = resp.data.results;

      // Build filter options for the buyer dropdown
      var buyersOptions = buyers.map(function (b) {
        return {
          label: b.full_name,
          filters: { buyer_id: b.id }
        };
      });

      // Build tags for the TitleWithFilters
      // Note: We now use key: "buyer_id" to match the actual filter key.
      var tags = buyers.map(function (b) {
        return {
          label: b.full_name,
          key: "buyer_id",
          matchesTarget: function matchesTarget(value) {
            return parseInt(value, 10) === b.id;
          }
        };
      });

      setBuyersFilter([{
        label: "View All",
        filters: { buyer_id: undefined }
      }].concat(_toConsumableArray(buyersOptions)));

      setBuyersTags(tags);
    }).catch(function () {
      __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Error", "Failed to fetch buyers.");
    });
  }, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_19__pagination__["a" /* incomingQuotePagination */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a vendor name, incoming quote number, part number, buyer, or date created...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/incoming-quotes/" + r.incoming_quote_id);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DecoratedExportButton, { searchProps: searchProps }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_DateRangePicker_DateRangePicker__["a" /* default */], searchProps),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
              title: "Buyer",
              filters: buyersFilter,
              right: true
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
              title: "Incoming Quotes",
              filters: INCOMING_QUOTE_FILTERS,
              right: true
            }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "Incoming Quotes",
          filters: [].concat(INCOMING_QUOTE_FILTER_TAGS, _toConsumableArray(buyersTags)) // Combine filters
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

IncomingQuoteSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(IncomingQuoteSearch));

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_EmailLink_EmailLink__ = __webpack_require__(2293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = Total;







function Total(_ref) {
  var part = _ref.part,
      quantity = _ref.quantity,
      cost = _ref.cost,
      email = _ref.email;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "well" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h6",
      { className: "h4" },
      "Summary"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed table-padding-horizonal-none margin-bottom-none" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(email) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Email: ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_EmailLink_EmailLink__["a" /* default */], { email: email })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { whiteSpace: "nowrap" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["h" /* PartNumber */], { part: part }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["E" /* ClipboardCopy */], {
                name: part && part.part_number,
                type: "PN",
                handleClick: function handleClick() {
                  return navigator.clipboard.writeText(part.part_number);
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "em",
              { className: "text-muted" },
              part && part.description
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { className: "text-right" })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed table-padding-horizonal-none" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              { className: "h4 margin-top-none margin-bottom-none" },
              "Total"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              { className: "h4 margin-top-none margin-bottom-none" },
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["b" /* calculateCost */])(quantity, cost)
            )
          )
        )
      )
    )
  );
}

Total.propTypes = {
  email: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  part: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    part_number: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    description: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  }),
  quantity: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  cost: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number])
};

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__session_decorators_withCurrentUser__ = __webpack_require__(47);





var LocationsDropDown = function LocationsDropDown(_ref) {
  var currentUser = _ref.currentUser,
      handleChange = _ref.handleChange,
      selectedLocation = _ref.selectedLocation;

  if (currentUser.locations.length === 1) {
    return null;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "select",
      {
        className: "form-control",
        name: __WEBPACK_IMPORTED_MODULE_2__inventories_constants__["_0" /* LOCATION */],
        value: selectedLocation && selectedLocation.id,
        onChange: function onChange(e) {
          return handleChange(e.target.value);
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "option",
        { value: "" },
        "Select Location"
      ),
      currentUser.locations.map(function (l) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "option",
          { key: l.id, value: l.id },
          l.name
        );
      })
    )
  );
};

LocationsDropDown.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  handleChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedLocation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__session_decorators_withCurrentUser__["b" /* default */])(LocationsDropDown));

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
var SET = "lots/SET";

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony export (immutable) */ __webpack_exports__["a"] = withLot;


function withLot(Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
    return {
      lot: state.lotDetail.get("lot")
    };
  })(Component);
}

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parts_actions_actions__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Locations_components_BuyingStoreRadioField__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__companies_helpers__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__PurchaseOrders_shared_CoBuyersFields_CoBuyersFields__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_components_PaymentTerms_PaymentTerms__ = __webpack_require__(177);
/* unused harmony export DetailFields */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var DetailFields = function (_React$Component) {
  _inherits(DetailFields, _React$Component);

  function DetailFields() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DetailFields);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DetailFields.__proto__ || Object.getPrototypeOf(DetailFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      contacts: []
    }, _this.fetchContacts = function (value) {
      if (!value) {
        return null;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__parts_actions_actions__["a" /* searchContacts */])(value).then(function () {
        var vals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        _this.setState({ contacts: vals });

        if (_this.props.setPrimaryContact) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__companies_helpers__["a" /* selectPrimaryContact */])(vals, _this.props.setField(__WEBPACK_IMPORTED_MODULE_11__constants__["O" /* CONTACT_ID */]));
        }
      });
    }, _this.handleCompanyChange = function (result) {
      if (_this.props.setSelectedCompany) _this.props.setSelectedCompany(result);

      if (_this.props.notifyForm) _this.props.notifyForm(result);

      if (result) {
        var address = result.primary_physical_address;
        var formattedAddress = address ? [address.city, address.state, address.country].join("-") : "";
        _this.props.setField(__WEBPACK_IMPORTED_MODULE_11__constants__["H" /* FOB */])(formattedAddress);
        if (_this.props.setPaymentTerms) _this.props.setPaymentTerms(result.vendor_credit_terms);
        _this.fetchContacts(result.id);
      } else {
        _this.setState({ contacts: [] });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DetailFields, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.lot && this.props.lot.company) {
        this.fetchContacts(this.props.lot.company.id);
        var _props = this.props,
            selectedCoBuyer = _props.selectedCoBuyer,
            selectedThirdBuyer = _props.selectedThirdBuyer;

        this.setState({
          selectedCoBuyer: selectedCoBuyer,
          selectedThirdBuyer: selectedThirdBuyer
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          contacts = _state.contacts,
          selectedCompany = _state.selectedCompany,
          selectedCoBuyer = _state.selectedCoBuyer,
          selectedThirdBuyer = _state.selectedThirdBuyer;
      var _props2 = this.props,
          contact = _props2.contact,
          currentUser = _props2.currentUser,
          getField = _props2.getField,
          getInitialFieldValue = _props2.getInitialFieldValue,
          lot = _props2.lot,
          searchCompanies = _props2.searchCompanies,
          selectedBuyer = _props2.selectedBuyer,
          searchBuyers = _props2.searchBuyers,
          setField = _props2.setField,
          buyerCreditPct = _props2.buyerCreditPct;

      var buyerCreditPctOptions = [{ text: "75%", value: "75.0" }, { text: "50%", value: "50.0" }, { text: "25%", value: "25.0" }];
      var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__companies_helpers__["b" /* contactSelectList */])(contacts, true);
      var company = selectedCompany || lot && lot.company;
      var toggleBuyer = function toggleBuyer(buyer) {
        return _this2.setState(buyer);
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row row-col-gutters-half" },
          currentUser.tenant.locations_count !== 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 5 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Locations_components_BuyingStoreRadioField__["a" /* default */], null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_14__users_constants__["x" /* BUYER_ID */],
              label: "Buyer",
              placeholder: "Search by name...",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["n" /* AutoCompleteField */],
              search: searchBuyers,
              selectedItem: selectedBuyer,
              formatItem: function formatItem(result) {
                return result && result.full_name;
              },
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_11__constants__["G" /* BUYER_CREDIT_PCT */],
              className: "text-right",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
              onChange: function onChange(_ev, val) {
                if (["25.0", "50.0", null].includes(val)) {
                  setField(__WEBPACK_IMPORTED_MODULE_14__users_constants__["y" /* THIRD_BUYER_ID */])(null);
                  toggleBuyer({ selectedThirdBuyer: null });
                }
              },
              options: buyerCreditPctOptions,
              label: "Buyer Credit",
              required: true
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PurchaseOrders_shared_CoBuyersFields_CoBuyersFields__["a" /* default */], {
            buyerCreditPct: buyerCreditPct,
            searchBuyers: searchBuyers,
            selectedCoBuyer: selectedCoBuyer,
            selectedThirdBuyer: selectedThirdBuyer,
            toggleBuyer: toggleBuyer,
            numberOfBuyers: [getField(__WEBPACK_IMPORTED_MODULE_14__users_constants__["z" /* CO_BUYER_ID */]), getField(__WEBPACK_IMPORTED_MODULE_14__users_constants__["y" /* THIRD_BUYER_ID */])].filter(function (s) {
              return s;
            }).length + 1
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["m" /* DashedSeparator */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_11__constants__["N" /* COMPANY_ID */],
              label: "Vendor",
              labelChildren: company && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["g" /* CompanyStatsTooltip */], { company: company })
              ),
              placeholder: "Search by typing a company's name or code",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["n" /* AutoCompleteField */],
              search: searchCompanies,
              formatItem: function formatItem(result) {
                return result.name + " (" + __WEBPACK_IMPORTED_MODULE_6__companies_constants__["h" /* APPROVAL_STATUSES */][result.vendor_status].label + ")";
              },
              onItemSelected: function onItemSelected(i) {
                return i && _this2.handleCompanyChange(i);
              },
              selectedItem: company,
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_11__constants__["O" /* CONTACT_ID */],
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
              options: options,
              label: "Vendor Contact",
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components_PaymentTerms_PaymentTerms__["a" /* default */], { getInitialFieldValue: getInitialFieldValue })
          )
        ),
        contact === __WEBPACK_IMPORTED_MODULE_17__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
                disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lodash__["get"])(company, __WEBPACK_IMPORTED_MODULE_6__companies_constants__["e" /* WEBSITE */]),
                name: "company.website",
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__companies_constants__["e" /* WEBSITE */]),
                required: true
              })
            )
          )
        ),
        contact === "Add" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "contact.name",
                component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
                label: "Contact Name",
                required: true
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "contact.email",
                component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
                label: "Contact Email",
                required: true
              })
            )
          )
        )
      );
    }
  }]);

  return DetailFields;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DetailFields.propTypes = {
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  contact: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  currentUser: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  getField: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  lot: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object),
  searchBuyers: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  searchCompanies: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  notifyForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  setPaymentTerms: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  selectedBuyer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object),
  selectedCoBuyer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object),
  selectedThirdBuyer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object),
  setField: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  setPrimaryContact: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  setSelectedCompany: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
DetailFields.defaultProps = {
  setPrimaryContact: true
};
var selector = function selector(form) {
  for (var _len2 = arguments.length, other = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    other[_key2 - 1] = arguments[_key2];
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(form).apply(undefined, other);
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state, ownProps) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_14__users_constants__["a" /* USER */]).toJS(),
    buyerCreditPct: selector(ownProps.formName, state, __WEBPACK_IMPORTED_MODULE_11__constants__["G" /* BUYER_CREDIT_PCT */]),
    contact: selector(ownProps.formName, state, __WEBPACK_IMPORTED_MODULE_11__constants__["O" /* CONTACT_ID */]),
    getField: function getField(field) {
      return selector(ownProps.formName, state, field);
    },
    getInitialFieldValue: function getInitialFieldValue(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lodash__["get"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["getFormInitialValues"])(ownProps.formName)(state), field);
    }
  };
}, function (dispatch, ownProps) {
  return {
    searchCompanies: function searchCompanies(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8__actions__["f" /* searchCompanies */](filter));
    },
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8__actions__["g" /* searchBuyers */](filter));
    },
    setField: function setField(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(ownProps.formName, field, val));
      };
    }
  };
})(DetailFields));

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
var SET = "managedRepairOrders/SET";

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["a"] = initialValues;



function initialValues(lineItem, currentUser, mro) {
  var values = {
    buyer_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(mro, "buyer.id"),
    request_vendor_approval: false,
    request_shop_approval: false,
    same_as_billing: true,
    evaluation_period: 30,
    reserve_for_seller_id: currentUser.id,
    read_only_buyer: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(mro, "buyer.full_name"),
    insurance_type: "None",
    cancelled: false,
    part: {
      pass_fail: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(lineItem, "part.pass_fail")
    },
    purchase_for_sale: false,
    purchase_for_stock: false,
    purchase_for_repair: false,
    purchase_for_repair_assist: false,
    preferred_repair_station_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(mro, __WEBPACK_IMPORTED_MODULE_1__constants__["q" /* SHIP_TO_TYPE */]) === __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* COMPANY */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(mro, "ship_to_company_id"),
    buyer_credit_pct: 75,
    tagged_by: undefined,
    tagged_by_id: undefined,
    tagged_by_hold: false
  };

  values.buyer_credit_pct = mro.buyer_credit_pct;
  values.co_buyer_id = mro.co_buyer_id;
  values.third_buyer_id = mro.third_buyer_id;
  if (lineItem) {
    lineItem.co_buyer = mro.co_buyer;
    lineItem.third_buyer = mro.third_buyer;
  }

  return values;
}

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
var SET = "mistakeShipments/SET";

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_submission__ = __webpack_require__(49);
/* harmony export (immutable) */ __webpack_exports__["a"] = show;
/* harmony export (immutable) */ __webpack_exports__["b"] = update;




function show(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].mistakeShipments.show(id).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* SET */],
        mistakeShipment: resp.data
      });
    });
  };
}

function update(data) {
  return function (dispatch, getState) {
    var id = getState().mistakeShipmentDetail.getIn(["mistakeShipment", "id"]);

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].mistakeShipments.update(id, data).then(function (_ref) {
      var mistakeShipment = _ref.data;

      dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* SET */], mistakeShipment: mistakeShipment });
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission__["a" /* SUCCESS */];
    });
  };
}

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTACHMENT_TYPES; });
var ATTACHMENT_TYPES = {
  photos: {
    label: "Photos"
  }
};

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony export (immutable) */ __webpack_exports__["a"] = withMistakeShipment;


function withMistakeShipment(Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
    return {
      mistakeShipment: state.mistakeShipmentDetail.get("mistakeShipment")
    };
  })(Component);
}

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_pagination__ = __webpack_require__(67);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["a" /* createPaginatedList */])({
  listId: "mistakeShipments",
  fetch: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].mistakeShipments.search
}));

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MarkAllRead__ = __webpack_require__(1453);
/* harmony export (immutable) */ __webpack_exports__["a"] = ConfirmModal;





function ConfirmModal(_ref) {
  var open = _ref.open,
      close = _ref.close,
      onConfirm = _ref.onConfirm,
      prompt = _ref.prompt;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MarkAllRead__["a" /* Header */], { close: close }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MarkAllRead__["b" /* Body */], { prompt: prompt }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MarkAllRead__["c" /* Footer */], { close: close, onConfirm: onConfirm })
  );
}

ConfirmModal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  prompt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators_renderIf__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmModal__ = __webpack_require__(654);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function MarkAllRead(_ref) {
  var markAllRead = _ref.markAllRead,
      props = _objectWithoutProperties(_ref, ["markAllRead"]);

  var filters = props.filters;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      confirmOpen = _useState2[0],
      setConfirmOpen = _useState2[1];

  var onClick = function onClick(e) {
    e.stopPropagation();
    markAllRead(filters);
    setConfirmOpen(false);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "input-group-btn" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      { className: "btn btn-danger", onClick: function onClick() {
          return setConfirmOpen(true);
        } },
      "Delete All"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ConfirmModal__["a" /* default */], {
      open: confirmOpen,
      close: function close() {
        return setConfirmOpen(false);
      },
      onConfirm: onClick,
      prompt: ["Warning: This will delete your notifications. Are you sure you want to continue?", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "(Note: If results are filtered, only filtered notifications will be deleted.)"]
    })
  );
}

MarkAllRead.propTypes = {
  filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  }).isRequired).isRequired,
  markAllRead: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators_renderIf__["a" /* default */])(function (_ref2) {
  var results = _ref2.results;
  return results && results.length;
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { markAllRead: __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* markAllRead */] })(MarkAllRead)));

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(202);







var PartLink = function PartLink(_ref) {
  var markNotificationRead = _ref.markNotificationRead,
      notificationId = _ref.notificationId,
      partId = _ref.partId,
      partNumber = _ref.partNumber,
      part = _ref.part,
      tierType = _ref.tierType,
      uuid = _ref.uuid;

  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_helpers__["a" /* getPartNumberColorClassNameByTierType */])(part && part.tier_type || tierType);

  var id = uuid || part && part.uuid || partId || part && part.id;
  var numb = partNumber || part && part.part_number;

  if (!id) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: classes },
    "PN-",
    numb
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    {
      onClick: function onClick(e) {
        e.stopPropagation();
        markNotificationRead && markNotificationRead(notificationId);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
      { to: "/parts/" + id },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: classes || "text-orange" },
        "PN-",
        numb
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    markNotificationRead: function markNotificationRead(noteId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* markRead */])(noteId));
    }
  };
})(PartLink));

PartLink.propTypes = {
  markNotificationRead: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  notificationId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  part: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}),
  partId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  partNumber: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  tierType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  uuid: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
};

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_humanize_string__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_humanize_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_humanize_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Search_InventoryLink__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers__ = __webpack_require__(1460);


















var toInventoryConditionLabel = function toInventoryConditionLabel(key) {
  return __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["r" /* INVENTORIES */].condition[key].label.toLowerCase();
};

var normalizeChangedKey = function normalizeChangedKey(key) {
  if (key === __WEBPACK_IMPORTED_MODULE_9__parts_constants__["G" /* DOM */]) {
    return String(key).toUpperCase();
  }

  return __WEBPACK_IMPORTED_MODULE_6_humanize_string___default()(key);
};

var normalizeChangeValue = function normalizeChangeValue(key, value) {
  if (key === __WEBPACK_IMPORTED_MODULE_9__parts_constants__["G" /* DOM */]) {
    var dom = __WEBPACK_IMPORTED_MODULE_4_moment___default()(value);

    if (dom.isValid()) {
      return dom.format("YYYY-MM");
    }
  }

  return value || "blank";
};

var CompanyLink = function CompanyLink(_ref) {
  var company = _ref.company;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
    { to: "/companies/" + company.id },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["e" /* truncate */])(company.name, 20)
    )
  );
};

CompanyLink.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

var getChangedDetails = function getChangedDetails(notification) {
  var conditionKeys = [__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["C" /* SRP_CONDITION */]];

  return Object.keys(notification.details.changes).map(function (key) {
    var fromValue = normalizeChangeValue(key, notification.details.changes[key][1]);
    var toValue = normalizeChangeValue(key, notification.details.changes[key][0]);

    if (conditionKeys.find(function (k) {
      return k === key;
    }) === undefined) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { key: key },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
        normalizeChangedKey(key),
        " changed from ",
        fromValue,
        " to ",
        toValue
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { key: key },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_6_humanize_string___default()(key),
      " changed from",
      " ",
      fromValue && toInventoryConditionLabel(fromValue),
      " to",
      " ",
      toValue && toInventoryConditionLabel(toValue)
    );
  });
};

var NOTIFICATION_TYPES = {
  Company: {
    company_approved_status: {
      icon: "fa-building",
      url: function url(notification) {
        return "/companies/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        var message = [];
        if (notification.details.vendor_status) {
          message.push("approved vendor");
        }

        if (notification.details.repair_station_status) {
          message.push("approved repair station");
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.name"),
          " added to the",
          " ",
          message.join(" / "),
          " list."
        );
      }
    },
    no_recent_sale_for_end_user_company: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/companies/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.name,
          " hasn't purchased a part in 90 days."
        );
      }
    },
    outgoing_quote_terms_not_exist: {
      icon: "fa-building",
      url: function url(notification) {
        return "/companies/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.details.contact.name,
          " at ",
          notification.notifier.name,
          ", has requested a quote for the first time. Please consider requesting credit references from",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { href: "mailto:" + notification.details.contact.email },
            notification.details.contact.email
          ),
          "."
        );
      }
    },
    credit_references_updated: {
      icon: "fa-building",
      url: function url(notification) {
        return "/companies/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Credit References have been uploaded for your review for Company --",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            notification.notifier.name
          ),
          "."
        );
      }
    },
    lot_missing_quickbooks_company: {
      icon: "fa-building",
      url: function url(notification) {
        return "/companies/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.details.lot.uuid,
            path: "lots",
            id: notification.details.lot.uuid,
            displayText: notification.details.lot.code
          }),
          " ",
          "was created for ",
          notification.notifier.name,
          " which has no matching name in Accounting."
        );
      }
    },
    repairs_missing_quickbooks_company: {
      icon: "fa-building",
      url: function url(notification) {
        return "/companies/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.details.repair_order.uuid,
            path: "repair-orders",
            id: notification.details.repair_order.uuid,
            displayText: notification.details.repair_order.code
          }),
          " ",
          "was created for ",
          notification.notifier.name,
          " which has no matching name in Accounting."
        );
      }
    },
    missing_accounting_vendor_integration: {
      icon: "fa-building",
      url: function url(notification) {
        return "/companies/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            id: notification.details.purchase_order.uuid,
            path: "purchase-orders",
            displayText: notification.details.purchase_order.code
          }),
          " ",
          "was created for ",
          notification.notifier.name,
          " which has no matching name in accounting."
        );
      }
    },
    missing_quickbooks_company: {
      icon: "fa-building",
      url: function url(notification) {
        return "/companies/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.details.sales_order.uuid,
            path: "sales-orders",
            id: notification.details.sales_order.uuid,
            displayText: notification.details.sales_order.code
          }),
          " ",
          "was created for ",
          notification.notifier.name,
          " which has no matching name in Accounting."
        );
      }
    },
    vendor_approval_request: {
      icon: "fa-building",
      url: function url(notification) {
        return "/companies/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.created_by.full_name,
          " requested vendor approval for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            id: notification.notifier.uuid,
            path: "companies",
            displayText: notification.notifier.name
          }),
          "."
        );
      }
    },
    vendor_approval_request_reminder: {
      icon: "fa-building",
      url: function url(notification) {
        return "/companies/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "One week since vendor approval requested for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            id: notification.notifier.uuid,
            path: "companies",
            displayText: notification.notifier.name
          }),
          "."
        );
      }
    },
    repair_station_approval_request: {
      icon: "fa-building",
      url: function url(notification) {
        return "/companies/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.created_by.full_name,
          " requested repair station approval",
          " ",
          "for ",
          notification.notifier.name,
          "."
        );
      }
    },
    repair_station_approval_request_reminder: {
      icon: "fa-building",
      url: function url(notification) {
        return "/companies/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "One week since repair station approval was requested for",
          " ",
          notification.notifier.name,
          "."
        );
      }
    },
    vendor_approval_status_change: {
      icon: "fa-building",
      url: function url(notification) {
        return "/companies/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.created_by.full_name,
          " updated vendor approval status for",
          " ",
          notification.notifier.name,
          "."
        );
      }
    },
    repair_station_approval_status_change: {
      icon: "fa-building",
      url: function url(notification) {
        return "/companies/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.created_by.full_name,
          " updated repair station approval status for ",
          notification.notifier.name,
          "."
        );
      }
    },
    qc_export_compliance_reminder: {
      icon: "fa-building",
      url: function url(notification) {
        return "/companies/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "One week since request for export compliance for",
          " ",
          notification.notifier.name,
          "."
        );
      }
    }
  },
  Consignment: {
    consignment_import_failed: {
      icon: "fa-handshake-o",
      url: function url(notification) {
        return "/consignments/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Consignment Import Failed.",
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.processing_error") ? "Processing error please check file type." : "",
          "."
        );
      }
    },
    consignment_import_succeeded: {
      icon: "fa-handshake-o",
      url: function url(notification) {
        return "/consignments/" + notification.notifier.uuid;
      },
      message: function message() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Consignment Import Succeeded."
        );
      }
    }
  },
  Inventory: {
    inventory_condition_does_not_match_srp: {
      iconUrl: "https://aero-zone-assets.s3.amazonaws.com/inventory.png",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], { part: notification.notifier.part }),
          " condition does not match the inventory SRP condition."
        );
      }
    },
    lot_repair_order: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            part: notification.details.part,
            partId: notification.details.part.id,
            partNumber: notification.details.part.part_number
          }),
          " ",
          "/",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Search_InventoryLink__["a" /* default */], {
            notificationId: notification.id,
            id: notification.details.inventory.id,
            serialNumber: notification.details.inventory.serial_number
          }),
          "requires SRP Price & Condition."
        );
      }
    },
    beyond_econ_repair_condition_change: {
      iconUrl: "https://aero-zone-assets.s3.amazonaws.com/inventory.png",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part
          }),
          " ",
          "SN-",
          notification.notifier.serial_number,
          " condition updated from",
          " ",
          toInventoryConditionLabel(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.previous_condition")),
          ". Please relocate to applicable stock location."
        );
      }
    },
    ema_reserved_for_sale: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "EMA",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part
          }),
          " ",
          "reserved for sale. Please request QC documents (if applicable)."
        );
      }
    },
    inventory_expiration: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part
          }),
          " ",
          "SN-",
          notification.notifier.serial_number,
          " is set to expire at the end of next month. Please consider for repair or segregation."
        );
      }
    },
    inventory_added_to_reserve_list: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Inventory added to Sales Cart."
        );
      }
    },
    notify_po_received_with_existing_so: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part
          }),
          " ",
          "arrived into ",
          notification.details.store_location,
          " stock today tied to",
          " ",
          notification.details.sales_order.code,
          ". Please prepare QC documents."
        );
      }
    },
    request_scrap_at_shop_reminder: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Still awaiting confirmation of scrap at shop from",
          " ",
          notification.details.repair_order.company.name,
          " for PN",
          " ",
          notification.notifier.part.part_number,
          " SN",
          " ",
          notification.notifier.serial_number,
          "."
        );
      }
    },
    srp_below_combined_cost_and_repair_cost: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "SRP Warning: SRP dropped below cost plus estimated repair for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part.id
          }),
          " ",
          "SN-",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.serial_number"),
          "."
        );
      }
    },
    verify_repair_station_approval_status: {
      icon: "fa-truck",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        var company = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.tagged_by", __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "company.name"));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], { part: notification.notifier.part }),
          " received with approval certs by\xA0",
          company,
          ". Please verify approval status for ",
          company,
          "."
        );
      }
    },
    reserved_po_received_and_passes_qc: {
      icon: "fa-wrench",
      url: function url() {
        return "/repair-orders/reserved";
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part
          }),
          " ",
          "from ",
          notification.details.purchase_order_code,
          " passes QC inspection, please proceed to create RO."
        );
      }
    },
    exchange_received_and_passes_qc: {
      icon: "fa-wrench",
      url: function url() {
        return "/repair-orders/reserved";
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part
          }),
          " ",
          "from",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "sales-orders",
            displayText: "SO-" + notification.details.sales_order.code,
            id: notification.details.sales_order.uuid
          }),
          " ",
          "passes QC inspection, please proceed to create RO."
        );
      }
    },
    inventory_condition_change_to_unsellable: {
      iconUrl: "https://aero-zone-assets.s3.amazonaws.com/inventory.png",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            null,
            "Condition for",
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
              notificationId: notification.id,
              part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part")
            }),
            " ",
            "SN-",
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.serial_number"),
            " changed to",
            " ",
            toInventoryConditionLabel(notification.notifier.condition),
            ". Please relocate to applicable stock location."
          )
        );
      }
    },
    reserved_po_with_mod_to_received_and_passes_qc: {
      icon: "fa-wrench",
      url: function url() {
        return "/repair-orders/reserved";
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part")
          }),
          " ",
          "from ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.purchase_order_code"),
          " passes QC inspection. Please proceed to create RO for mod to",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.mod_to")
          }),
          " ",
          "from",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part")
          }),
          "."
        );
      }
    },
    ro_received_without_mod: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Repair Order received without modification to PN:",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.mod_to")
          }),
          "."
        );
      }
    },
    qc_status: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "An item from ",
          notification.details.purchase_order_code,
          ", for which you were a Buyer, has been escalated to QC Hold."
        );
      }
    },
    sales_order_for_active_repair_cancelled: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "sales-orders",
            displayText: notification.details.sales_order.code,
            id: notification.details.sales_order.id || notification.details.sales_order.uuid
          }),
          " ",
          "cancelled. Please review",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part"),
            notificationId: notification.id,
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part.part_number"),
            partId: notification.notifier.part_id
          }),
          " ",
          "SN-",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.serial_number"),
          " from open",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "repair-orders",
            displayText: notification.details.repair_order.code,
            id: notification.details.repair_order.id || notification.details.repair_order.uuid
          }),
          "."
        );
      }
    },
    sales_item_for_active_repair_cancelled: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part"),
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part.part_number"),
            partId: notification.notifier.part_id
          }),
          " ",
          "from",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "sales-orders",
            displayText: notification.details.sales_order.code,
            id: notification.details.sales_order.uuid || notification.details.sales_order.id
          }),
          " ",
          "cancelled. Please review open",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "repair-orders",
            displayText: notification.details.repair_order.code,
            id: notification.details.repair_order.uuid || notification.details.repair_order.id
          }),
          "."
        );
      }
    },
    write_up_an_internal_outright_sale: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.sales_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "This exchange has been marked for an Internal Outright. Please create",
          " ",
          "an Internal Outright Sale for this Core.",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Part:",
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
              notificationId: notification.id,
              part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part"),
              partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part.part_number"),
              partId: notification.notifier.part_id
            }),
            " ",
            "- SN: - SN: ",
            notification.notifier.serial_number
          ),
          "."
        );
      }
    },
    write_up_an_exchange_gone_outright_sale: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.details.sales_order.id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "This exchange has Gone Outright. Please create an Outright Sale for this part.",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
              notificationId: notification.id,
              part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part"),
              partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part.part_number"),
              partId: notification.notifier.part_id
            }),
            " ",
            "- SN: ",
            notification.notifier.serial_number
          ),
          "."
        );
      }
    },
    outright_sale_being_written_for_part: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.details.sales_order.id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Exchange Sale for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            notification.details.sales_order.code
          ),
          " has gone outright!."
        );
      }
    },
    outright_sale_created: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/reports/commissions?filter=" + notification.details.sales_order.code;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Congrats!",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "sales-orders",
            displayText: notification.details.sales_order.code,
            id: notification.details.sales_order.uuid
          }),
          " ",
          "created."
        );
      }
    },
    received_transfer: {
      iconUrl: "https://aero-zone-assets.s3.amazonaws.com/inventory.png",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part"),
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part.part_number"),
            partId: notification.notifier.part_id
          }),
          " ",
          "SN-",
          notification.notifier.serial_number,
          " received from inventory transfer."
        );
      }
    },
    partially_received_transfer: {
      iconUrl: "https://aero-zone-assets.s3.amazonaws.com/inventory.png",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part"),
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part.part_number"),
            partId: notification.notifier.part_id
          }),
          " ",
          "SN-",
          notification.notifier.serial_number,
          " partially received from inventory transfer."
        );
      }
    },
    sales_order_has_been_created_for_item_being_repaired: {
      icon: "fa-dollar",
      url: function url(notification) {
        return notification.details ? "/sales-orders/" + notification.details.sales_order.id : "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        var salesOrderCode = notification.details ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "strong",
          null,
          "(",
          notification.details.sales_order.code,
          ") "
        ) : "";
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "A sales order ",
          salesOrderCode,
          "has been created for:",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
              notificationId: notification.id,
              part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part"),
              partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part.part_number"),
              partId: notification.notifier.part_id
            }),
            " ",
            "- SN: ",
            notification.notifier.serial_number
          ),
          " ",
          "which is being repaired."
        );
      }
    },
    inventory_condition_change_to_scrap: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part"),
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part.part_number"),
            partId: notification.notifier.part_id
          }),
          " ",
          "SN-",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.serial_number"),
          " scrapped and remaining cost depreciated."
        );
      }
    },
    inventory_srp_reduction: {
      icon: "fa-quote-right",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "SRP reduction for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part"),
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part.part_number"),
            partId: notification.notifier.part_id
          }),
          ". Please follow up with your customer."
        );
      }
    }
  },
  Lot: {
    expect_paperwork_for_vendor: {
      iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg___default.a,
      url: function url(notification) {
        return "/lots/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " created to an unapproved vendor. Please review vendor status and trace."
        );
      }
    },
    denied_vendor_status: {
      iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg___default.a,
      url: function url(notification) {
        return "/lots/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " placed and ",
          notification.details.company,
          " ",
          "has a denied vendor status. Please approve trace and reevaluate vendor status."
        );
      }
    },
    lot_cancelled: {
      iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg___default.a,
      url: function url(notification) {
        return "/lots/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.details && notification.details.buying_store ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            notification.details.buying_store,
            " "
          ) : "",
          notification.notifier.code,
          " cancelled by",
          " ",
          notification.created_by.full_name,
          "."
        );
      }
    },
    lot_cost_changed: {
      iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg___default.a,
      url: function url(notification) {
        return "/lots/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.name,
          " from",
          " ",
          notification.details && notification.details.buying_store ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            notification.details.buying_store,
            " "
          ) : "",
          notification.notifier.code,
          " to ",
          notification.details.company_name,
          " ",
          "changed from ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(notification.details.previous_value),
          " to",
          " ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(notification.details.current_value),
          " by",
          " ",
          notification.details.updated_by,
          "."
        );
      }
    },
    lot_change_do_not_ship_reminder: {
      iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg___default.a,
      url: function url(notification) {
        return "/lots/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " is awaiting completed Ship To instructions."
        );
      }
    },
    must_receive_virtually: {
      iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg___default.a,
      url: function url() {
        return "/dashboard/virtual-receiving";
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            id: notification.notifier.uuid,
            displayText: notification.notifier.code,
            path: "lots"
          }),
          " ",
          "requires virtual receiving."
        );
      }
    },
    must_receive_virtually_updated: {
      iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg___default.a,
      url: function url() {
        return "/dashboard/virtual-receiving";
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " updated and requires virtual receiving."
        );
      }
    },
    import_failed: {
      iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg___default.a,
      url: function url(notification) {
        return "/lots/" + notification.notifier.lot.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Lot Import Failed.",
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.processing_error") ? "Processing error please check file type." : ""
        );
      }
    },
    import_succeeded: {
      iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg___default.a,
      url: function url(notification) {
        return "/lots/" + notification.notifier.lot.uuid;
      },
      message: function message() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Lot Import Succeeded."
        );
      }
    },
    lot_trace_hold_approved: {
      iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg___default.a,
      url: function url(notification) {
        return "/lots/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Trace for ",
          notification.notifier.code,
          " approved. Please send purchase order to ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.company_name"),
          "."
        );
      }
    },
    lot_trace_hold: {
      iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg___default.a,
      url: function url(notification) {
        return "/lots/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " to",
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.company.name"),
          " requires trace approval."
        );
      }
    },
    lot_trace_hold_rejected: {
      iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg___default.a,
      url: function url(notification) {
        return "/lots/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Trace for ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            notification.notifier.code
          ),
          " has been denied by ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.rejected_by"),
          " and order to",
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.company_name"),
          " should be rejected."
        );
      }
    }
  },
  Location: {
    quickbooks_authentication_error: {
      icon: "fa-dollar",
      url: function url() {
        return "/integrations";
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Please reauthorize quickbooks for ",
          notification.details.name,
          " location and resync."
        );
      }
    }
  },
  LotLineItem: {
    difference_in_received_inventory_item: {
      iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg___default.a,
      url: function url(notification) {
        return "/lots/" + notification.notifier.lot.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part_id
          }),
          " ",
          "received with these differences: ",
          getChangedDetails(notification),
          "."
        );
      }
    },
    difference_in_partially_received_inventory_item: {
      iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg___default.a,
      url: function url(notification) {
        return "/lots/" + notification.notifier.lot.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part_id
          }),
          " ",
          "partially received with these differences:",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          getChangedDetails(notification),
          "."
        );
      }
    },
    first_lpo_part_received: {
      iconUrl: __WEBPACK_IMPORTED_MODULE_11__assets_images_lot_svg___default.a,
      url: function url(notification) {
        return "/lots/" + notification.notifier.lot.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "First part of ",
          notification.notifier.lot.code,
          " has been received."
        );
      }
    }
  },
  MistakeShipment: {
    mistake_shipment_missing_ship_to: {
      icon: "fa-exclamation-triangle",
      url: function url(notification) {
        return "/mistake-shipments/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Mistake Shipment for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part"),
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part.part_number"),
            partId: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part.id")
          }),
          " ",
          "/ SN ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.serial_number"),
          " does not have a Shipping Address."
        );
      }
    }
  },
  OutgoingQuote: {
    restricted_entity: {
      icon: "fa-quote-left",
      url: function url(notification) {
        return "/outgoing-quotes/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Warning: Similar entity name in US Gov't Screening List:",
          " ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helpers__["a" /* restrictedEntityToSentence */])(notification.details),
          "."
        );
      }
    }
  },
  OutgoingQuoteLineItem: {
    airline_rfq_received: {
      icon: "fa-quote-right",
      url: function url(notification) {
        return "/outgoing-quotes/" + notification.notifier.outgoing_quote_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.outgoing_quote.code"),
          " Airline RFQ received from ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.company.name"),
          " for Stock",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part"),
            partId: notification.notifier.part_id,
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part.part_number")
          }),
          "."
        );
      }
    },
    inventory_srp_reduction_below_offer: {
      icon: "fa-quote-right",
      url: function url(notification) {
        return "/outgoing-quotes/" + notification.notifier.outgoing_quote_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "SRP reduction for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part"),
            partId: notification.notifier.part_id,
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part.part_number")
          }),
          " ",
          "is at or below offer made to you. Please follow up with your customer."
        );
      }
    },
    offer_made: {
      icon: "fa-quote-right",
      url: function url(notification) {
        return "/outgoing-quotes/" + notification.notifier.outgoing_quote_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part"),
            partId: notification.notifier.part_id,
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part.part_number")
          }),
          " ",
          "received an offer of ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(notification.details.price),
          "."
        );
      }
    },
    outgoing_quote_follow_up_feedback_added: {
      icon: "fa-quote-right",
      url: function url(notification) {
        return "/outgoing-quotes/" + notification.details.outgoing_quote.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Follow up feedback entered for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.part")
          }),
          "."
        );
      }
    },
    outgoing_quote_reminder: {
      icon: "fa-quote-right",
      url: function url(notification) {
        return "/outgoing-quotes/" + notification.notifier.outgoing_quote_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Please follow up with your customer for",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            " OQ-",
            notification.notifier.outgoing_quote_id
          ),
          "."
        );
      }
    },
    quote_no_longer_sellable: {
      icon: "fa-quote-right",
      url: function url(notification) {
        return "/outgoing-quotes/" + notification.notifier.outgoing_quote_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], { part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part") }),
          " has been sold. You quoted it recently. Please review."
        );
      }
    },
    repeated_outgoing_quote: {
      icon: "fa-quote-right",
      url: function url(notification) {
        return "/parts/" + notification.notifier.part_id + "/outgoing-quote-line-items";
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part"),
            partId: notification.notifier.part_id,
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part.part_number")
          }),
          " ",
          "quoted at least 3 times in 24 hours. Please follow up with your customer."
        );
      }
    },
    sellable_inventory_available_for_no_quote: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/parts/" + notification.notifier.part_id + "/outgoing-quote-line-items";
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.part"),
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.part.part_number"),
            partId: notification.notifier.part_id
          }),
          " ",
          "now in stock. You recently No Quoted",
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.company.name"),
          "."
        );
      }
    }
  },
  Part: {
    automatic_srp_adjustment_anniv: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/parts/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        var part = notification.notifier;

        var monthsAgo = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.months_ago");
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "SRP automatic adjustment: ",
          monthsAgo,
          "-month anniversary date for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: part,
            partId: notification.notifier.uuid,
            partNumber: part.part_number
          }),
          "."
        );
      }
    },
    notify_missing_eccn_details: {
      icon: "fa-truck",
      url: function url(notification) {
        return "/parts/" + notification.details.part.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.details.part,
            partNumber: notification.details.part.part_number,
            partId: notification.details.part.id
          }),
          " ",
          "received and missing ECCN details."
        );
      }
    },
    automatic_srp_adjustment_socs: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/parts/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        var part = notification.notifier;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "SRP automatic adjustment: An order for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: part,
            partId: notification.notifier.uuid,
            partNumber: part.part_number
          }),
          " ",
          "may have been missed."
        );
      }
    },
    automatic_srp_adjustment_maps: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/parts/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        var part = notification.notifier;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "SRP automatic adjustment:",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: part,
            partId: notification.notifier.uuid,
            partNumber: part.part_number
          }),
          " ",
          "has no outgoing quote activity."
        );
      }
    },
    looking_for_quote_resident_expert: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/outgoing-quotes/" + (notification.details.outgoing_quote.uuid || notification.details.outgoing_quote.id);
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Resident Expert: ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.company.name"),
          " is looking for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier"),
            partId: notification.notifier.id,
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part_number")
          }),
          "."
        );
      }
    },
    no_quote_with_resident_expert: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/outgoing-quotes/" + (notification.details.outgoing_quote.uuid || notification.details.outgoing_quote.id);
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Resident Expert:",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier"),
            partId: notification.notifier.id,
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part_number")
          }),
          " ",
          "was recently \u2018No Quoted\u2019 to",
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.company.name"),
          "."
        );
      }
    },
    missed_srp_adjustment_anniv: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/parts/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        var part = notification.notifier;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Anniversary: PN",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: part,
            partId: notification.notifier.uuid,
            partNumber: part.part_number
          }),
          ". Review recommended for possible SRP adjustment."
        );
      }
    },
    missed_srp_adjustment_socs: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/parts/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        var part = notification.notifier;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "SRP automatic adjustment: An order for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: part,
            partId: notification.notifier.uuid,
            partNumber: part.part_number
          }),
          " ",
          "may have been missed ."
        );
      }
    },
    missed_srp_adjustment_maps: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/parts/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        var part = notification.notifier;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "There has been no outgoing quote activity for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: part,
            partId: part.id,
            partNumber: part.part_number
          }),
          ". Please review for SRP adjustment."
        );
      }
    },
    nap_reshop_reminder: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/parts/" + notification.notifier.uuid + "/incoming-quote-line-items";
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Neglected Parts Reminder: Please shop",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier,
            partNumber: notification.notifier.part_number,
            partId: notification.notifier.uuid
          }),
          "."
        );
      }
    },
    out_of_stock_check_repairs: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/parts/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "We are sold out of",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            part: notification.notifier,
            partNumber: notification.notifier.part_number,
            partId: notification.notifier.uuid
          }),
          ". Please review Internal Outright/s for possible return."
        );
      }
    },
    out_of_stock_check_working_to_save: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/parts/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            part: notification.notifier,
            partNumber: notification.notifier.part_number,
            partId: notification.notifier.uuid
          }),
          " ",
          "is sold out. Please review for stock replenishment."
        );
      }
    },
    purchase_consideration: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/sales-orders/" + (notification.details.sales_order_uuid || notification.details.sales_order_id);
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Please shop",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier,
            partNumber: notification.notifier.part_number,
            partId: notification.notifier.uuid
          }),
          " ",
          "for ",
          notification.details.store_location,
          " store."
        );
      }
    },
    srp_market_warning_notification: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/parts/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier,
            partNumber: notification.notifier.part_number,
            partId: notification.notifier.uuid
          }),
          " ",
          "had an incoming quote entered for less than your SRP."
        );
      }
    }
  },
  PurchaseOrder: {
    change_do_not_ship_reminder: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " is awaiting completed Ship To instructions."
        );
      }
    },
    consignment_created: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " created associated with",
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.company.name"),
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.consignment_type", "consignment"),
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.consignment_reference"),
          "."
        );
      }
    },
    ema_with_no_consignor_percentage_notification_sold: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "sales-orders",
            displayText: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.sales_order.code"),
            id: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.sales_order.id")
          }),
          " ",
          "for an EMA has triggered a $0 PO to be created. Please adjust the PO Price and send the Purchase Order to",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CompanyLink, { company: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.consignor") }),
          "."
        );
      }
    },
    denied_vendor_status: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " placed and ",
          notification.details.company,
          " ",
          "has a denied vendor status. Please approve trace and reevaluate vendor status."
        );
      }
    },
    expect_paperwork_for_vendor: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " created to an unapproved vendor. Please review vendor status and trace."
        );
      }
    },
    restricted_entity: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Purchase Order flagged a name possibly matching entity from Gov't Screening List: ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helpers__["a" /* restrictedEntityToSentence */])(notification.details),
          "."
        );
      }
    },
    must_receive_virtually: {
      icon: "fa-shopping-cart",
      url: function url() {
        return "/dashboard/virtual-receiving";
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            id: notification.notifier.uuid,
            displayText: notification.notifier.code,
            path: "purchase-orders"
          }),
          " ",
          "requires virtual receiving."
        );
      }
    },
    must_receive_virtually_updated: {
      icon: "fa-shopping-cart",
      url: function url() {
        return "/dashboard/virtual-receiving";
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " updated and requires virtual receiving."
        );
      }
    },
    purchase_order_cancelled: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.details && notification.details.buying_store ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            notification.details.buying_store,
            " "
          ) : "",
          notification.notifier.code,
          " cancelled by",
          " ",
          notification.created_by.full_name,
          "."
        );
      }
    },
    purchase_order_quantity_changed: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.details.part,
            partNumber: notification.details.part_number,
            partId: notification.details.part_id
          }),
          " ",
          "from",
          " ",
          notification.details && notification.details.buying_store ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            notification.details.buying_store,
            " "
          ) : "",
          notification.notifier.code,
          " to ",
          notification.details.company_name,
          " ",
          "changed from QTY ",
          notification.details.previous_value,
          " to QTY",
          " ",
          notification.details.current_value,
          " by",
          " ",
          notification.details.updated_by || notification.created_by.full_name,
          "."
        );
      }
    },
    purchase_order_cost_changed: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.details.part,
            partNumber: notification.details.part_number,
            partId: notification.details.part_id
          }),
          " ",
          "from",
          " ",
          notification.details && notification.details.buying_store ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            notification.details.buying_store,
            " "
          ) : "",
          notification.notifier.code,
          " to ",
          notification.details.company_name,
          " ",
          "changed from ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(notification.details.previous_value),
          " to",
          " ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(notification.details.current_value),
          " by",
          " ",
          notification.details.updated_by,
          "."
        );
      }
    },
    purchase_order_with_demerits: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            notification.notifier.code
          ),
          " has been issued to a vendor with 4 or more active demerits in the last 24 months. The order will require QC Approval, before allowing",
          " ",
          notification.created_by.full_name,
          " to send PO."
        );
      }
    },
    purchase_order_shipping_type_change: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        var reason = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.reason");
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "purchase-orders",
            id: notification.notifier.uuid,
            displayText: notification.notifier.code
          }),
          " ",
          "will require ",
          reason === "requires_8130_3" && "8130-3",
          reason === "requires_trace_documentation" && "trace",
          reason === "requires_weight_and_dims" && "weight/dim",
          reason === "requires_picture" && "picture",
          " approval prior to shipping."
        );
      }
    },
    received_and_not_approved_vendor: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " received without vendor status approval. Please review."
        );
      }
    },
    trace_hold: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " to",
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.company.name"),
          " requires trace approval."
        );
      }
    },
    trace_hold_approved: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Trace for ",
          notification.notifier.code,
          " approved. Please send purchase order to ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.company_name"),
          "."
        );
      }
    },
    trace_hold_rejected: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Trace for ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            notification.notifier.code
          ),
          " has been denied by ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.rejected_by"),
          " and order to",
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.company_name"),
          " should be rejected."
        );
      }
    }
  },
  PurchaseOrderLineItem: {
    cancelled_consignment: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/parts/" + notification.notifier.part_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Consignment ",
          notification.notifier.purchase_order.code,
          " to",
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.company"),
          " cancelled. Please review."
        );
      }
    },
    received_reserved_inventory_item: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.purchase_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Reserved",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part_id
          }),
          " ",
          "received. Please create sales order."
        );
      }
    },
    requires_approval: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.purchase_order.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            part: notification.details.part,
            partNumber: notification.details.part_number,
            partId: notification.details.part_id
          }),
          " ",
          "SN-",
          notification.notifier.serial_number,
          " purchased by",
          " ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["d" /* getFirstNameLastInitial */])(notification.details.buyer),
          " was received but still requires PO approval."
        );
      }
    },
    partially_received_reserved_inventory_item: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.purchase_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.purchase_order.code,
          ", reserved for you, was partially received as expected."
        );
      }
    },
    difference_in_received_inventory_item: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.purchase_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part_id
          }),
          " ",
          "received with these differences: ",
          getChangedDetails(notification),
          "."
        );
      }
    },
    difference_in_partially_received_inventory_item: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.purchase_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part_id
          }),
          " ",
          "partially received with these differences:",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          getChangedDetails(notification),
          "."
        );
      }
    },
    expected_date_updated: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.purchase_order_id;
      },
      message: function message(notification) {
        var code = notification.details.purchase_order_code;
        var who = notification.created_by.full_name;
        var date = notification.details.new_date;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Expected Date for ",
          code,
          " has been updated by ",
          who,
          date ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            " to ",
            date,
            "."
          ) : "."
        );
      }
    },
    must_split_received_inventory_in_order_to_reserve_for_repair: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.purchase_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
              notificationId: notification.id,
              part: notification.notifier.part,
              partNumber: notification.notifier.part.part_number,
              partId: notification.notifier.part_id
            }),
            " ",
            "from ",
            notification.notifier.purchase_order.code
          ),
          ", reserved for repair, was received with more than one item. Please split inventory to reserve for repair."
        );
      }
    },
    on_order_item_received: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/dashboard/shipping?filter=" + __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.sales_order_code");
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.purchase_order.code,
          " on order for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            displayText: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.sales_order_code"),
            path: "sales-orders",
            id: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.sales_order_id")
          }),
          " ",
          "received. Please prepare for shipment."
        );
      }
    },
    purchase_order_item_condition_mismatch: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        if (!notification.details) {
          return "/purchase-orders/" + notification.notifier.purchase_order_id;
        }
        return "/inventories/" + notification.details.inventory.id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part_id
          }),
          " ",
          "received is not matching SRP condition."
        );
      }
    },
    purchase_order_line_item_cancelled: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.purchase_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part_id
          }),
          " ",
          notification.notifier.serial_number && " SN-\n          " + notification.notifier.serial_number,
          " ",
          "from ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.purchase_order.buying_store"),
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.purchase_order.code"),
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.purchase_order.company.name") && "to " + __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.purchase_order.company.name"),
          " ",
          "has been cancelled by ",
          notification.created_by.full_name,
          "."
        );
      }
    },
    first_time_part_number_used: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/parts/" + notification.notifier.part_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Please review",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part_id
          }),
          " ",
          "purchased for the first time on",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            displayText: notification.notifier.purchase_order.code,
            id: notification.notifier.purchase_order_id,
            path: "purchase-orders"
          }),
          " ",
          "for pertinent logistics data."
        );
      }
    },
    purchase_order_dim_weight: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/purchase-orders/" + notification.notifier.purchase_order.id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Please review ",
          notification.notifier.purchase_order.code,
          " for possible",
          " ",
          "weights and dims factor."
        );
      }
    }
  },
  IncomingQuote: {
    customer_replied_to_iq: {
      icon: "fa-quote-left",
      url: function url(notification) {
        return "/incoming-quotes/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.company.name,
          " has replied to RFQ",
          " ",
          notification.notifier.code,
          ". Please Review."
        );
      }
    },
    import_failed: {
      icon: "fa-quote-left",
      url: function url(notification) {
        return "/incoming-quotes/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Incoming Quote Failed.",
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.processing_error") ? "Processing error please check file type." : "",
          "."
        );
      }
    },
    import_succeeded: {
      icon: "fa-quote-left",
      url: function url(notification) {
        return "/incoming-quotes/" + notification.notifier.uuid;
      },
      message: function message() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Incoming Quote Import Succeeded."
        );
      }
    },
    incoming_quote_awaiting_reply: {
      icon: "fa-quote-left",
      url: function url(notification) {
        return "/incoming-quotes/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        var parts = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.parts");
        var partsArray = parts && parts.map(function (p, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], { notificationId: notification.id, part: p }),
            index === parts.length - 1 ? "" : ", "
          );
        });

        if ((partsArray || []).length > 1) {
          var lastElem = partsArray.pop();
          partsArray = partsArray.concat(["and ", lastElem]);
        }
        var companyText = notification.notifier.company ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
          null,
          "\xA0from",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            id: notification.notifier.company.uuid,
            path: "companies",
            displayText: notification.notifier.company.name
          }),
          " "
        ) : "";

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          companyText,
          [" for "].concat(partsArray),
          " still 'Awaiting Reply'."
        );
      }
    },
    restricted_entity: {
      icon: "fa-quote-left",
      url: function url(notification) {
        return "/incoming-quotes/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Warning: Similar entity name in US Gov't Screening List:",
          " ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helpers__["a" /* restrictedEntityToSentence */])(notification.details),
          "."
        );
      }
    }
  },
  ManagedRepairOrder: {
    managed_repair_ready_to_invoice: {
      icon: "fa-recycle",
      url: function url(notification) {
        return "/managed-repair-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Managed Repair ",
          notification.notifier.code,
          " is ready to be invoiced to",
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.managed_repair.company.name"),
          "."
        );
      }
    }
  },
  ReceivingRecord: {
    discrepancy: {
      icon: "fa-truck",
      url: function url(notification) {
        return "/receiving/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Discrepancy created for receiving record ",
          notification.notifier.code,
          "."
        );
      }
    },
    validate_and_enter_tagged_by: {
      icon: "fa-truck",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.inventories[0].id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Please validate and enter Tagged By on recently received unit",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part_id
          }),
          " ",
          "/ SN-",
          notification.notifier.serial_number,
          "."
        );
      }
    },
    verify_repair_station_approval_status: {
      icon: "fa-truck",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.inventories[0].id;
      },
      message: function message(notification) {
        var company = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.tagged_by", __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "company.name"));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], { part: notification.notifier.part }),
          " received with approval certs by\xA0",
          company,
          ". Please verify approval status for ",
          company,
          "."
        );
      }
    },
    core_return_exchange_check_warranty: {
      icon: "fa-truck",
      url: function url(notification) {
        return "/inventories/" + __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.inventory_id");
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Same",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Search_InventoryLink__["a" /* default */], {
            notificationId: notification.id,
            id: notification.notifier.uuid,
            serialNumber: notification.notifier.serial_number
          }),
          " ",
          "received against exchange",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "sales-orders",
            id: notification.details.sales_order_id,
            displayText: notification.details.sales_order_code
          }),
          ". Please evaluate."
        );
      }
    },
    tagged_by_mismatch_on_purchase_order_line_item_receiving_record: {
      icon: "fa-truck",
      url: function url(notification) {
        return "/inventories/" + __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.inventory_id");
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part_id
          }),
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Search_InventoryLink__["a" /* default */], {
            notificationId: notification.id,
            id: notification.notifier.uuid,
            serialNumber: notification.notifier.serial_number
          }),
          " ",
          "received tagged by",
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.notifier.tagged_by.name"),
          " instead of expected tagged by",
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.reference_record_line_item.tagged_by.name"),
          ". Please consider for QC Hold."
        );
      }
    },
    process_quality_control_documentation: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.sales_order.id");
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part_id
          }),
          " ",
          "arrived into ",
          notification.details.inventory.store_location,
          " stock",
          " ",
          "today tied to ",
          notification.details.sales_order.code,
          ". Please prepare",
          " ",
          "QC Documents."
        );
      }
    }
  },
  RepairOrderLineItem: {
    repair_order_line_item_has_been_rejected: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/repair-orders/" + notification.notifier.repair_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            part: notification.details.part,
            partNumber: notification.details.part.part_number,
            partId: notification.details.id
          }),
          " ",
          "from ",
          notification.details.repair_order_code,
          " has been rejected at",
          " ",
          notification.details.company_name,
          ". Please Review."
        );
      }
    },
    exchange_core_return_requote: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/repair-orders/" + notification.details.ro_id;
      },
      message: function message(notification) {
        var details = notification.details;
        var changeMessage = "";

        if (details.labor_cost_change) {
          changeMessage += "labor cost from $" + details.labor_cost_change.labor_original + " to $" + details.labor_cost_change.labor_new;
        }

        if (details.part_cost_change) {
          if (changeMessage.length > 0) changeMessage += " and ";
          changeMessage += "part cost from $" + details.part_cost_change.part_original + " to $" + details.part_cost_change.part_new;
        }

        if (details.outside_labor_cost_change) {
          if (changeMessage.length > 0) changeMessage += " and ";
          changeMessage += "outside labor cost from $" + details.outside_labor_cost_change.outside_labor_original + " to $" + details.outside_labor_cost_change.outside_labor_new;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Please review and process possible requote for ",
          changeMessage,
          " for",
          " ",
          notification.notifier.repair_order_code,
          " for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            id: notification.details.so_id,
            path: "sales-orders",
            displayText: notification.details.sales_order_code
          }),
          "."
        );
      }
    },
    customer_rma_cancelled: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/repair-orders/" + notification.notifier.repair_order_uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            notification.notifier.repair_order_code
          ),
          " for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part_id
          }),
          " ",
          "customer RMA cancelled. Please review."
        );
      }
    },
    process_internal_outright: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.details.sales_order.id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Please process internal outright for",
          " ",
          notification.details.sales_order.code,
          "."
        );
      }
    },
    repair_evaluation_received_for_international_repair: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/repair-orders/" + notification.notifier.repair_order_uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.repair_order_code,
          " repair evaluation received for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part_id
          }),
          ". Please review shipping instructions and applicable import declaration."
        );
      }
    },
    stale_expected_date: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/repair-orders/" + notification.notifier.repair_order_uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Expected Date for ",
          notification.notifier.repair_order_code,
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part_id
          }),
          " ",
          "has expired. Please update expected date."
        );
      }
    },
    exceeds_average_repair_fee: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "repair-orders/" + notification.notifier.repair_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Original Eval for the flat exchange",
          " ",
          notification.details.sales_order_code,
          " exceeded the Avg Repair Fee (NTX) by ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(notification.details.exceeded_repair_by),
          ". Please review and invoice customer, if applicable."
        );
      }
    },
    repair_line_item_rejected: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/repair-orders/" + notification.notifier.repair_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Original Evaluation is available for",
          " ",
          notification.notifier.repair_order_code,
          " and is eligible to go",
          " ",
          "outright. Please review ",
          notification.notifier.repair_order_code,
          " to",
          " ",
          "determine next steps."
        );
      }
    },
    partial_credit_notification: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.inventory_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Please review",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part"),
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part_number"),
            partId: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.part_id")
          }),
          " / ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Search_InventoryLink__["a" /* default */], {
            notificationId: notification.id,
            id: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.inventory_id"),
            serialNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.serial_number")
          }),
          " ",
          "on",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "repair-orders",
            id: notification.notifier.repair_order_id,
            displayText: notification.notifier.repair_order_code
          }),
          " ",
          "for a partial credit or RMA request."
        );
      }
    },
    vendor_rma_requested: {
      icon: "fa-shield",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.inventory_id;
      },
      message: function message(notification) {
        var partialCredit = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.rma_request_type") === __WEBPACK_IMPORTED_MODULE_15__RepairOrders_constants__["k" /* PARTIAL_CREDIT */];

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Please request a",
          " ",
          partialCredit ? "Partial Credit of " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.partial_credit_amount")) : "Vendor RMA",
          " ",
          "for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "repair-orders",
            displayText: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.repair_order.code"),
            id: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.repair_order.id")
          }),
          "."
        );
      }
    },
    repair_order_item_condition_mismatch: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.inventory_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part_id
          }),
          " ",
          "received is not matching SRP condition."
        );
      }
    },
    vendor_rma_cancelled: {
      icon: "fa-shield",
      url: function url(notification) {
        return "repair-orders/" + notification.notifier.repair_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.repair_order_code,
          " for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.notifier.part,
            partNumber: notification.notifier.part.part_number,
            partId: notification.notifier.part_id
          }),
          " ",
          "vendor RMA cancelled. Please review."
        );
      }
    }
  },
  RepairOrder: {
    core_repair_order_awaiting_approval: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "repair-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.part")
          }),
          " ",
          "core return received for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            displayText: notification.details.sales_order.code,
            path: "sales-orders",
            id: notification.details.sales_order.uuid
          }),
          ". Repair Order created to ",
          notification.details.company.name,
          ". Please review and approve."
        );
      }
    },
    import_failed: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/repair-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Expected Components Import Failed",
          " ",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.processing_error") ? "Processing error please check file type." : "",
          "."
        );
      }
    },
    import_succeeded: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/repair-orders/" + notification.notifier.uuid;
      },
      message: function message() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Expected Components Import Succeeded."
        );
      }
    },
    repair_order_awaiting_approval: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/repair-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " requires approval. Please review."
        );
      }
    },
    repair_order_with_demerits: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/repair-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " has been issued to a vendor with 4 or more active demerits in the last 24 months. The order will require QC Approval, before allowing ",
          notification.created_by.full_name,
          " to send RO."
        );
      }
    },
    still_awaiting_evaluation: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/repair-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Evaluation Received 21 days ago for ",
          notification.notifier.code,
          " and no status change. Please review."
        );
      }
    }
  },
  Rma: {
    charge_no_fault_found_fee: {
      icon: "fa-cog",
      url: function url(notification) {
        return "/rmas/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "No fault found for warranty ",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "rmas",
            displayText: notification.notifier.code,
            id: notification.notifier.uuid
          }),
          ". ",
          "Please charge ",
          notification.details.company.name,
          " with no fault found fee of ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(notification.notifier.no_fault_found_fee),
          "."
        );
      }
    },
    created_customer_rma: {
      icon: "fa-cog",
      url: function url(notification) {
        return "/rmas/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Customer",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "rmas",
            displayText: notification.notifier.code,
            id: notification.notifier.uuid
          }),
          " ",
          "created for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            displayText: notification.details.sales_order.code,
            id: notification.details.sales_order.id,
            path: "sales-orders"
          }),
          "."
        );
      }
    },
    customer_rma_received: {
      icon: "fa-cog",
      url: function url(notification) {
        return "/rmas/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            partId: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.part_id"),
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.part_number")
          }),
          " ",
          "received for customer",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "rmas",
            displayText: notification.notifier.code,
            id: notification.notifier.uuid
          }),
          "."
        );
      }
    },
    issue_credit: {
      icon: "fa-cog",
      url: function url(notification) {
        return "/rmas/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Customer ",
          notification.notifier.code,
          " received. Please issue credit."
        );
      }
    },
    issue_restocking_fee: {
      icon: "fa-cog",
      url: function url(notification) {
        return "/rmas/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Customer ",
          notification.notifier.code,
          " received. Please issue credit and charge restocking fee."
        );
      }
    },
    customer_rma_received_create_warranty_consideration_repair_orders: {
      icon: "fa-cog",
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            displayText: notification.notifier.code,
            path: "rmas",
            id: notification.notifier.uuid
          }),
          " ",
          "with a warranty consideration received. Please create the RO (if applicable)."
        );
      },
      url: function url(notification) {
        return "/inventories/" + notification.notifier.sales_item.inventory_id;
      }
    },
    process_warranty_charges_for_customer_rma: {
      icon: "fa-cog",
      url: function url(notification) {
        return "/rmas/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Please process warranty charges for customer",
          " ",
          notification.notifier.code,
          "."
        );
      }
    },
    process_credit_warranty_charges: {
      icon: "fa-cog",
      url: function url(notification) {
        return "/rmas/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Customer ",
          notification.notifier.code,
          " is eligible to process credit and warranty charges. Please review."
        );
      }
    },
    process_credit_for_customer_rma: {
      icon: "fa-cog",
      url: function url(notification) {
        return "/rmas/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Customer ",
          notification.notifier.code,
          " is eligible to process credit. Please review."
        );
      }
    },
    vendor_rma_manually_cancelled: {
      icon: "fa-shield",
      url: function url(notification) {
        return "/rmas/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Vendor ",
          notification.notifier.code,
          " cancelled for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "purchase-orders",
            id: notification.notifier.reference_record_id,
            displayText: notification.notifier.reference_record_code
          }),
          ". Please review."
        );
      }
    },
    vendor_rma_number_received: {
      icon: "fa-shield",
      url: function url(notification) {
        return "/rmas/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Vendor ",
          notification.notifier.code,
          " received for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "purchase-orders",
            id: notification.notifier.reference_record_id,
            displayText: notification.notifier.reference_record_code
          }),
          ". Please review."
        );
      }
    },
    vendor_rma_partial_credit_requested: {
      icon: "fa-shield",
      url: function url(notification) {
        return "/rmas/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Vendor ",
          notification.notifier.code,
          " partial credit accepted for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "purchase-orders",
            id: notification.notifier.reference_record_id,
            displayText: notification.notifier.reference_record_code
          }),
          ". Please review."
        );
      }
    },
    vendor_rma_partial_credit_accepted_repair_notification: {
      icon: "fa-shield",
      url: function url(notification) {
        return "/rmas/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "repair-orders",
            id: notification.details.repair_order.uuid,
            displayText: notification.details.repair_order.code
          }),
          " ",
          "for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.part")
          }),
          " ",
          "Vendor ",
          notification.notifier.code,
          " partial credit accepted. Please review."
        );
      }
    },
    vendor_rma_partial_credit_accepted: {
      icon: "fa-shield",
      url: function url(notification) {
        return "/rmas/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Vendor ",
          notification.notifier.code,
          " partial credit accepted for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "purchase-orders",
            id: notification.notifier.reference_record_id,
            displayText: notification.notifier.reference_record_code
          }),
          ". Please review."
        );
      }
    },
    vendor_rma_partial_credit_denied: {
      icon: "fa-shield",
      url: function url(notification) {
        return "/rmas/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Vendor ",
          notification.notifier.code,
          " partial credit denied for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "purchase-orders",
            id: notification.notifier.reference_record_id,
            displayText: notification.notifier.reference_record_code
          }),
          ". Please review."
        );
      }
    },
    vendor_rma_partial_credit_denied_repair_notification: {
      icon: "fa-shield",
      url: function url(notification) {
        return "/rmas/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "repair-orders",
            id: notification.details.repair_order.uuid,
            displayText: notification.details.repair_order.code
          }),
          " ",
          "for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.part")
          }),
          " ",
          "Vendor ",
          notification.notifier.code,
          " partial credit denied. Please review."
        );
      }
    },
    vendor_rma_credit_denied: {
      icon: "fa-shield",
      url: function url(notification) {
        return "/rmas/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Vendor ",
          notification.notifier.code,
          " denied for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "purchase-orders",
            id: notification.notifier.reference_record_id,
            displayText: notification.notifier.reference_record_code
          }),
          ". Please review."
        );
      }
    }
  },
  SalesOrder: {
    accounting_hold_released: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " has been released from accounting hold."
        );
      }
    },
    awb_bol_added_to_brokered_exchange: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "AWB/BOL has been added to brokered ",
          notification.notifier.code,
          ". Please invoice."
        );
      }
    },
    brokered_sale_cancellation_notification_for_seller: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "SO-",
          notification.details.sales_order.id,
          " to",
          " ",
          notification.details.sales_order.company.name,
          " for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.part")
          }),
          " ",
          "was part of a brokered sale and has been cancelled by",
          " ",
          notification.details.cancelled_by.full_name,
          ". Please update",
          " ",
          notification.details.sales_order.contact.name,
          " and cancel or recreate sale with new unit."
        );
      }
    },
    brokered_sale_cancellation_notification_for_accounting: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "SO-",
          notification.details.sales_order.id,
          " to",
          " ",
          notification.details.sales_order.company.name,
          " for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.part"),
            partId: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.part.id"),
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.part.part_number")
          }),
          " ",
          "was part of a brokered sale and has been cancelled by",
          " ",
          notification.details.cancelled_by.full_name,
          ". Please update your accounting records."
        );
      }
    },
    commercial_invoice_attached: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Commercial invoice attached to ",
          notification.notifier.code,
          ". Please review."
        );
      }
    },
    contingent_on_passing_rejected: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Evaluation for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            id: notification.details.repair_order.uuid,
            path: "repair-orders",
            displayText: notification.details.repair_order.code
          }),
          " ",
          "has been Rejected for ",
          notification.notifier.code,
          ". Please review and cancel Sales Order if necessary."
        );
      }
    },
    credit_card_form_attached: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Credit card form attached to ",
          notification.notifier.code,
          ". Please review."
        );
      }
    },
    customer_discreet_paperwork_available: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/dashboard/shipping?filter=" + notification.notifier.code + "&page=1";
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Discreet paperwork for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            displayText: notification.notifier.code,
            path: "sales-orders",
            id: notification.notifier.uuid
          }),
          " ",
          "uploaded. Please attach paperwork and complete order."
        );
      }
    },
    accounting_has_approved_and_released_so: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " is released from accounting hold. Please review."
        );
      }
    },
    customer_expects_paperwork: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " requires QC documents approval prior to",
          " ",
          "shipment."
        );
      }
    },
    contact_customer_to_provide_weight_and_dims: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/dashboard/shipping?filter=" + notification.notifier.code + "&page=1";
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Contact customer to provide weight and dims for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            displayText: notification.notifier.code,
            path: "sales-orders",
            id: notification.notifier.uuid
          }),
          "."
        );
      }
    },
    first_sales_order_to_customer: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            displayText: notification.notifier.code,
            path: "sales-orders",
            id: notification.notifier.uuid
          }),
          " ",
          "has been created for a new customer:",
          " ",
          notification.notifier.company_name,
          "."
        );
      }
    },
    new_sales_order_with_line_item_on_qc_hold: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/inventories/" + notification.details.inventory_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "sales-orders",
            id: notification.notifier.uuid,
            displayText: notification.notifier.code
          }),
          " ",
          "is on QC Hold due to expiration for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.part"),
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.part_number"),
            partId: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.part_id")
          }),
          " ",
          "SN-",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.serial_number"),
          ". Please review."
        );
      }
    },
    update_shipping_from_tbd: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " is still missing shipping information.",
          " ",
          "Please follow up with your customer."
        );
      }
    },
    request_delivery_method_from_wh_team: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Email customer to provide Shipping and Carrier instructions for",
          " ",
          notification.notifier.code,
          "."
        );
      }
    },
    restricted_address: {
      icon: "fa-quote-left",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Sales Order flagged an address possibly matching entity from Gov't Screening List:",
          " ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helpers__["b" /* restrictedAddressesToSentence */])(notification.details),
          ". Pre-Approval Required."
        );
      }
    },
    restricted_entity: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Sales Order flagged a name possibly matching entity from Gov't Screening List: ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helpers__["a" /* restrictedEntityToSentence */])(notification.details),
          ". Pre-Approval Required."
        );
      }
    },
    discreet_shipping_selected: {
      icon: "fa-dollar",
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " for ",
          notification.details.company.name,
          " ",
          "updated to Discreet Drop-Shipment."
        );
      },
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      }
    },
    discreet_shipping_unselected: {
      icon: "fa-dollar",
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " for ",
          notification.details.company.name,
          " ",
          "is no longer Discreet Drop-Shipment."
        );
      },
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      }
    },
    export_compliance: {
      icon: "fa-building",
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            id: notification.notifier.uuid,
            displayText: notification.notifier.code,
            path: "sales-orders"
          }),
          " ",
          "for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            id: notification.notifier.company_id,
            path: "companies",
            displayText: notification.notifier.company_name
          }),
          " ",
          "is not Export Compliant."
        );
      },
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      }
    },
    export_compliance_hold_added: {
      icon: "fa-dollar",
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " is on export compliance hold."
        );
      },
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      }
    },
    overdue_core_return: {
      icon: "fa-dollar",
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Core Return for Exchange ",
          notification.notifier.code,
          " is overdue. Please bill ",
          notification.details.company,
          " an additional exchange fee."
        );
      },
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      }
    },
    sales_order_created: {
      icon: "fa-dollar",
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Congrats!",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "sales-orders",
            displayText: notification.notifier.code,
            id: notification.notifier.uuid
          }),
          " ",
          "created."
        );
      },
      url: function url(notification) {
        return "/reports/commissions?filter=" + notification.notifier.code;
      }
    },
    sales_order_cancelled: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "sales-orders",
            displayText: notification.notifier.code,
            id: notification.notifier.uuid
          }),
          " ",
          "cancelled."
        );
      }
    },
    sales_order_shipping_info_changed: {
      icon: "fa-dollar",
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Shipping details changed for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            id: notification.notifier.uuid,
            path: "sales-orders",
            displayText: notification.notifier.code
          }),
          "."
        );
      },
      url: function url(notification) {
        return "/dashboard/shipping?filter=" + notification.notifier.code;
      }
    },
    send_packet_to_customer_within_one_hour: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " created. Please prepare QC documents for",
          " ",
          notification.notifier.company_name,
          "."
        );
      }
    },
    set_accounting_hold: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        var message = [];
        if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.exceeds_credit_limit")) {
          message.push("for exceeding credit limit");
        }

        if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.repairing")) {
          message.push("due to unit is located at shop");
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            displayText: notification.notifier.company_name,
            id: notification.notifier.company_id,
            path: "companies"
          }),
          " ",
          "is on accounting hold ",
          message.join(" and "),
          ". Please review."
        );
      }
    },
    sales_order_reopened: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.notifier.code,
          " reinstated. Please review and prepare QC",
          " ",
          "documents, if applicable."
        );
      }
    },
    core_return_not_received: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Core Return AWB # entered on",
          " ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_date__["a" /* shortDateYYandTime */])(notification.details.core_return_awb_number_updated_at),
          " ",
          "and core is still not received. Please follow up with Customer."
        );
      }
    },
    monitored_fields_changed: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "For ",
          notification.notifier.code,
          ",",
          " ",
          notification.details.fields.sentence,
          " changed",
          " ",
          notification.details.part_numbers.count > 0 ? " for " + notification.details.part_numbers.sentence : "",
          "."
        );
      }
    },
    company_name_changed: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.uuid;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "For ",
          notification.notifier.code,
          ", customer name updated from",
          " ",
          notification.details.previous_name,
          " to",
          " ",
          notification.details.current_name,
          "."
        );
      }
    }
  },
  Report: {
    report_processed: {
      icon: "fa-file",
      url: function url() {
        return "/reports";
      },
      message: function message() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Report has finished processing."
        );
      }
    }
  },
  SalesOrderLineItem: {
    eval_approved_for_ro_with_mod_to: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.sales_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Repair Evaluation Approved for",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.part"),
            partId: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.inventory.part_id"),
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.inventory.part_number")
          }),
          "with a Mod To of",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.mod_to"),
            partId: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.mod_to.part_id"),
            partNumber: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.mod_to.part_number")
          }),
          "."
        );
      }
    },
    exchange_core_received_returned_to_stock: {
      icon: "fa-truck",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.inventory_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Core received for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "sales-orders",
            displayText: notification.notifier.sales_order_code,
            id: notification.notifier.sales_order_id
          }),
          " ",
          "returned to stock. Please confirm exchange is closed."
        );
      }
    },
    inventory_on_order_for_sale_arrived: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.sales_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.details.part
          }),
          " ",
          "arrived to ",
          notification.details.store_location,
          " stock tied to",
          " ",
          notification.notifier.sales_order_code,
          ". Please review."
        );
      }
    },
    process_core_repair_charges: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.sales_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Please process core repair charges for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "repair-orders",
            id: notification.details.repair_order.id,
            displayText: notification.details.repair_order.code
          }),
          " ",
          "for ",
          notification.notifier.sales_order_code,
          "."
        );
      }
    },
    repair_line_item_exchange_gone_outright: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.sales_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Original Evaluation exceeds outright value for",
          " ",
          notification.notifier.sales_order_code,
          ". Please review."
        );
      }
    },
    repairs_consideration: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/parts/" + notification.details.part_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Please consider sending",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.details.part,
            partId: notification.details.part_id,
            partNumber: notification.details.part_number
          }),
          " ",
          "for repair evaluation."
        );
      }
    },
    subsequent_exchange_created: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.sales_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.details.exchange_type,
          " exchange fee created for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.details.part,
            partId: notification.details.part_id,
            partNumber: notification.details.part_number
          }),
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Search_InventoryLink__["a" /* default */], {
            notificationId: notification.id,
            id: notification.details.inventory_id,
            serialNumber: notification.details.serial_number
          }),
          "."
        );
      }
    },
    purchase_consideration: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.sales_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Purchase Consideration: Please consider shopping",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.details.part,
            partId: notification.details.part_id,
            partNumber: notification.details.part_number
          }),
          " ",
          "for ",
          notification.details.store_location,
          " Store."
        );
      }
    },
    transfer_consideration: {
      icon: "fa-cogs",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.sales_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Transfer Consideration: Please consider transferring",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.details.part,
            partId: notification.details.part_id,
            partNumber: notification.details.part_number
          }),
          " ",
          "to ",
          notification.details.store_location,
          " Store."
        );
      }
    },
    shop_return_consideration: {
      icon: "fa-wrench",
      url: function url(notification) {
        return "/parts/" + notification.details.part_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Please consider bringing",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.details.part,
            partId: notification.details.part_id,
            partNumber: notification.details.part_number
          }),
          " ",
          "back from repair."
        );
      }
    },
    purchase_order_changed_for_sales_item: {
      icon: "fa-shopping-cart",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.sales_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Purchase Order ",
            notification.details.purchase_order_code,
            " for Sales Order #",
            notification.details.sales_order_code,
            " for",
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
              notificationId: notification.id,
              part: notification.details.part,
              partId: notification.details.part_id,
              partNumber: notification.details.part_number
            }),
            " "
          ),
          ", was changed with these differences:",
          getChangedDetails(notification),
          "."
        );
      }
    },
    exchange_core_received: {
      icon: "fa-truck",
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Core received for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "sales-orders",
            id: notification.notifier.sales_order_id,
            displayText: notification.notifier.sales_order_code
          }),
          ". Please review."
        );
      },
      url: function url(notification) {
        return "/inventories/" + notification.notifier.inventory_id;
      }
    },
    repair_order_associated_with_an_open_sales_order_received: {
      icon: "fa-dollar",
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          notification.details.repair_order.code,
          " on order for",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            displayText: notification.notifier.sales_order_code,
            id: notification.notifier.sales_order_id,
            path: "sales-orders"
          }),
          " ",
          "received. Please prepare for shipment."
        );
      },
      url: function url(notification) {
        return "/dashboard/shipping?filter=" + notification.notifier.sales_order_code;
      }
    },
    core_received_part_mismatch: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/inventories/" + notification.notifier.inventory_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Core for ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "SO-",
            notification.notifier.sales_order_code
          ),
          " ",
          "was received with different PN as compared to the sold unit.",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          "Please re-evaluate SRP Condition and SRP."
        );
      }
    },
    write_up_an_internal_outright_sale: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.sales_order_id");
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "This exchange has been marked for an Internal Outright. Please create",
          " ",
          "an Internal Outright Sale for this Core.",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
              notificationId: notification.id,
              part: notification.details.part,
              partId: notification.details.part_id,
              partNumber: notification.details.part_number
            }),
            " ",
            "- SN: ",
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.serial_number")
          ),
          "."
        );
      }
    },
    internal_outright_sale_created: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/reports/commissions?filter=" + __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.sales_order.code", __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.sales_order_code"));
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Congrats!",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Search_ItemLink__["a" /* default */], {
            notificationId: notification.id,
            path: "sales-orders",
            displayText: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.sales_order.code", notification.notifier.sales_order_code),
            id: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.sales_order.uuid", __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "notifier.sales_order_id"))
          }),
          " ",
          "created!."
        );
      }
    },
    sales_order_line_item_cancelled: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.sales_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.details.part,
            partId: notification.details.part_id,
            partNumber: notification.details.part_number
          }),
          " ",
          "SN-",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.serial_number"),
          " from",
          " ",
          notification.notifier.sales_order_code,
          " cancelled."
        );
      }
    },
    core_return_not_received: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.sales_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Core Return AWB # entered on",
          " ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_date__["a" /* shortDateYYandTime */])(notification.details.core_return_awb_number_updated_at),
          " ",
          "and core is still not received. Please review."
        );
      }
    },
    sales_order_line_item_created: {
      icon: "fa-dollar",
      url: function url(notification) {
        return "/sales-orders/" + notification.notifier.sales_order_id;
      },
      message: function message(notification) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "For ",
          notification.notifier.sales_order_code,
          ",",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Search_PartLink__["a" /* default */], {
            notificationId: notification.id,
            part: notification.details.part,
            partId: notification.details.part_id,
            partNumber: notification.details.part_number
          }),
          " ",
          "SN-",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(notification, "details.serial_number"),
          " has been added."
        );
      }
    }
  },
  Tenant: {
    commission_paid: {
      icon: "fa-dollar",
      url: function url() {
        return "/reports/commissions?status=paid";
      },
      message: function message() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Commission has been processed for you today. Please review."
        );
      }
    },
    import_succeeded: {
      icon: "fa-cogs",
      url: function url() {
        return "/parts";
      },
      message: function message() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Part Import Succeeded."
        );
      }
    },
    import_failed: {
      icon: "fa-cogs",
      url: function url() {
        return "/parts";
      },
      message: function message() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Part Import Failed."
        );
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (NOTIFICATION_TYPES);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_pagination__ = __webpack_require__(67);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["a" /* createPaginatedList */])({
  listId: "searchNotifications",
  fetch: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].notifications.search,
  stateLocator: function stateLocator(state) {
    return state.searchNotifications;
  },
  initialSettings: {
    sort: "id",
    sortReverse: true,
    filters: {
      filter: true
    }
  }
}));

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditInvoiceDetailsForm__ = __webpack_require__(1461);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EditInvoiceDetailsForm__["a"]; });


/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_address__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_CompanyAddressWarning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_FormRow__ = __webpack_require__(26);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var CompanyAddress = function (_Component) {
  _inherits(CompanyAddress, _Component);

  function CompanyAddress(props) {
    _classCallCheck(this, CompanyAddress);

    var _this = _possibleConstructorReturn(this, (CompanyAddress.__proto__ || Object.getPrototypeOf(CompanyAddress)).call(this, props));

    _this.onChangeAddress = function (address) {
      var onChangeAddress = _this.props.onChangeAddress;


      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isFunction"])(onChangeAddress)) {
        onChangeAddress(address);
      }
    };

    _this.fetchAddresses = function (companyId, primaryAddressIdValue, setFOB) {
      return companyId && __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].companies.physicalAddresses.search(companyId, {
        page: 1,
        limit: 100,
        sort: "primary",
        reverse: true
      }).then(function (_ref) {
        var results = _ref.data.results;

        if (_this.mounted) {
          var _this$props = _this.props,
              input = _this$props.addressId.input,
              onChangeAddress = _this$props.onChangeAddress,
              addressPh = _this$props.addressPh;

          addressPh && results[0].phone && addressPh.input.onChange(results[0].phone);
          input.onChange(primaryAddressIdValue || results[0].id);

          if (results.length > 0) {
            input.onChange(primaryAddressIdValue || results[0].id);

            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isFunction"])(onChangeAddress)) {
              onChangeAddress(results[0]);
            }

            _this.setState({ addresses: results });
            return setFOB && setFOB(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_address__["a" /* fobFormat */])(primaryAddressIdValue || results[0]));
          }
        }
        return null;
      });
    };

    _this.fetchShippingPreferences = function (companyId) {
      return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].companies.shippingMethods.search(companyId, {
        page: 1,
        limit: 100
      }).then(function (_ref2) {
        var results = _ref2.data.results;

        if (_this.mounted) {
          var onChangeShippingPreference = _this.props.onChangeShippingPreference;


          if (results.length > 0) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isFunction"])(onChangeShippingPreference)) {
              onChangeShippingPreference(results[0]);
            }
          }
        }
        return null;
      });
    };

    _this.handleCompanySelected = function (result) {
      var _this$props2 = _this.props,
          addressId = _this$props2.addressId,
          setFOB = _this$props2.setFOB,
          addressPh = _this$props2.addressPh;


      addressId.input.onChange(null);
      _this.onChangeAddress(null);
      addressPh && addressPh.input.onChange(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(result, "primary_physical_address.phone") || result.phone);

      _this.setState({
        selectedCompany: result,
        invalidCompany: !!result && (!result.primary_physical_address || !result.billing_address)
      });

      if (result) {
        _this.fetchAddresses(result.id, null, setFOB);
      }
    };

    _this.state = {
      selectedCompany: props.selectedCompany,
      addresses: [],
      invalidCompany: false
    };
    return _this;
  }

  _createClass(CompanyAddress, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var selectedCompany = this.state.selectedCompany;
      var _props = this.props,
          companyId = _props.companyId,
          addressId = _props.addressId,
          onChangeShippingPreference = _props.onChangeShippingPreference;

      this.mounted = true;

      if (selectedCompany) {
        this.fetchAddresses(selectedCompany.id, addressId.input.value, false);

        if (companyId.input.value !== selectedCompany.id) {
          companyId.input.onChange(selectedCompany.id);
        }

        if (onChangeShippingPreference && selectedCompany.id) {
          this.fetchShippingPreferences(selectedCompany.id);
        }
      }

      this.onChangeAddress(null);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          searchCompanies = _props2.searchCompanies,
          companyId = _props2.companyId,
          addressId = _props2.addressId,
          addressPh = _props2.addressPh,
          disabled = _props2.disabled,
          _props2$required = _props2.required,
          required = _props2$required === undefined ? true : _props2$required;
      var _state = this.state,
          addresses = _state.addresses,
          selectedCompany = _state.selectedCompany,
          invalidCompany = _state.invalidCompany;

      var companyIdInput = companyId.input;
      var addressIdInput = addressId.input;
      var addressPhInput = addressPh && addressPh.input;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        invalidCompany && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_CompanyAddressWarning__["a" /* default */], { company: selectedCompany }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: companyIdInput.name,
              label: "Ship To Company Name",
              placeholder: "Search by typing a company's name or code",
              component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["n" /* AutoCompleteField */],
              search: searchCompanies,
              formatItem: function formatItem(result) {
                return result && result.name;
              },
              selectedItem: selectedCompany,
              onItemSelected: function onItemSelected(i) {
                return i && _this2.handleCompanySelected(i);
              },
              required: required,
              disabled: disabled
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: addressIdInput.name,
              label: "Ship To Company Address",
              component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
              options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_forms__["c" /* addressesToOptions */])(addresses),
              prompt: false,
              disabled: invalidCompany || disabled,
              required: required
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_FormRow__["a" /* default */],
          null,
          addressPhInput && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: addressPhInput.name,
              label: "Ship To Company Phone",
              component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */]
            })
          )
        )
      );
    }
  }]);

  return CompanyAddress;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CompanyAddress.propTypes = {
  addressId: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["o" /* FormTypes */].formField(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["o" /* FormTypes */].malleable).isRequired,
  companyId: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["o" /* FormTypes */].formField(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["o" /* FormTypes */].malleable).isRequired,
  addressPh: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["o" /* FormTypes */].formField(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["o" /* FormTypes */].malleable),
  required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  searchCompanies: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  setFOB: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onChangeAddress: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  selectedCompany: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired
  }),
  disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    searchCompanies: function searchCompanies(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_actions__["a" /* searchCompanies */](filter));
    }
  };
})(CompanyAddress));

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_arrays__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_address__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__companies_components_AddressFields__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Locations_components_ShippingRadioGroupField__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Lots_constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DoNotShipReasonFields__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CompanyFields__ = __webpack_require__(1462);
/* unused harmony export SHIPPING_TYPES */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






















var SHIPPING_TYPES = {
  company: {
    label: "Company"
  },
  dropship: {
    label: "Other"
  },
  do_not_ship: {
    label: "Do Not Ship"
  },
  repair_station: {
    label: "Repair Station Address"
  }
};

function ToggledShipToFields(props) {
  var shipToCompany = props.shipToCompany,
      country = props.country,
      city = props.city,
      disabled = props.disabled,
      province = props.province,
      formName = props.formName,
      onChangeShippingPreference = props.onChangeShippingPreference,
      _props$repairStationO = props.repairStationOptions,
      repairStationOptions = _props$repairStationO === undefined ? [] : _props$repairStationO,
      setFOB = props.setFOB,
      shippingFields = props.shippingFields,
      _props$shippingAddres = props.shippingAddressField,
      shippingAddressField = _props$shippingAddres === undefined ? __WEBPACK_IMPORTED_MODULE_13__constants__["I" /* SHIPPING_ADDRESS */] : _props$shippingAddres,
      _props$required = props.required,
      required = _props$required === undefined ? true : _props$required,
      _props$enableReturnTo = props.enableReturnToType,
      enableReturnToType = _props$enableReturnTo === undefined ? true : _props$enableReturnTo;

  var shippingTypeField = props[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_arrays__["b" /* findMatch */])(props.shippingFields, "type")];
  var shippingType = shippingTypeField.input.value;

  var addressOptions = repairStationOptions.map(function (a) {
    return {
      text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_address__["b" /* addressFormatDropDown */])(a),
      value: a.id
    };
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    shippingFields.includes(__WEBPACK_IMPORTED_MODULE_13__constants__["H" /* FOB */]) === true && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16_react_bootstrap__["e" /* Col */],
        { md: 7 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_13__constants__["H" /* FOB */],
          component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
          label: __WEBPACK_IMPORTED_MODULE_13__constants__["H" /* FOB */].toUpperCase(),
          required: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16_react_bootstrap__["e" /* Col */],
        { md: 5 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_15__Lots_constants__["d" /* SHIP_DATE */],
          component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
          type: "date",
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_15__Lots_constants__["d" /* SHIP_DATE */]),
          disabled: disabled
        })
      )
    ),
    shippingType === __WEBPACK_IMPORTED_MODULE_11__shared_components_ShippingSection_shippingTypes__["d" /* COMPANY */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], {
      component: __WEBPACK_IMPORTED_MODULE_19__CompanyFields__["a" /* default */],
      formName: formName,
      names: shippingFields,
      onChangeShippingPreference: onChangeShippingPreference,
      selectedCompany: shipToCompany,
      setFOB: setFOB,
      required: true,
      disabled: disabled
    }),
    shippingType === __WEBPACK_IMPORTED_MODULE_11__shared_components_ShippingSection_shippingTypes__["e" /* DROPSHIP */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__companies_components_AddressFields__["a" /* default */], {
      formName: formName,
      path: shippingAddressField,
      country: country,
      city: city,
      setFOB: setFOB,
      province: province,
      addCompanyName: true,
      required: required,
      disabled: disabled
    }),
    shippingType === __WEBPACK_IMPORTED_MODULE_18__companies_constants__["f" /* REPAIR_STATION */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: "repair_station_physical_address_id",
          component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["c" /* Select */],
          options: addressOptions,
          label: "Repair Station Address",
          required: true,
          prompt: false
        })
      )
    ),
    shippingType === __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["d" /* DO_NOT_SHIP */] && enableReturnToType && formName !== "rmaReturnToDetails" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], {
      names: [shippingTypeField.input.name].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["e" /* DO_NOT_SHIP_REASONS */])),
      component: __WEBPACK_IMPORTED_MODULE_17__DoNotShipReasonFields__["a" /* default */],
      required: required
    })
  );
}

ToggledShipToFields.propTypes = {
  country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  city: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  province: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  formName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  setFOB: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  repairStationOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shippingAddressField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  shippingFields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  shipToCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

function ShipToFields(props) {
  var shippingType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_arrays__["b" /* findMatch */])(props.shippingFields, "type");
  var shippingTypeLabel = shippingType === __WEBPACK_IMPORTED_MODULE_13__constants__["o" /* SHIPPING_TYPE */] ? "Ship To" : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(shippingType);

  var shippingTypes = props.shippingTypes.reduce(function (types, t) {
    types[t] = SHIPPING_TYPES[t];
    return types;
  }, {});

  var required = props.rmaRequestForm || shippingType === "return_to_type" ? false : props.required;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
      name: shippingType,
      label: shippingTypeLabel,
      component: __WEBPACK_IMPORTED_MODULE_10__Locations_components_ShippingRadioGroupField__["a" /* default */],
      options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_forms__["a" /* toOptions */])(shippingTypes),
      required: required,
      disabled: props.disabled,
      setFieldValue: props.setFieldValue,
      getFieldValue: props.getFieldValue,
      hasLocations: props.hasLocations,
      locationFieldName: props.locationFieldName
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], _extends({
      names: [shippingType],
      component: ToggledShipToFields
    }, props))
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(ShipToFields));

ShipToFields.defaultProps = {
  hasLocations: true,
  shippingTypes: [__WEBPACK_IMPORTED_MODULE_11__shared_components_ShippingSection_shippingTypes__["d" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_11__shared_components_ShippingSection_shippingTypes__["e" /* DROPSHIP */], __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["d" /* DO_NOT_SHIP */]],
  locationFieldName: __WEBPACK_IMPORTED_MODULE_13__constants__["P" /* SHIP_TO_LOCATION_ID */]
};

ShipToFields.propTypes = {
  hasLocations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  locationFieldName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shippingFields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  shippingTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
};

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SelectAttachmentTable__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_components_Notes_resourceToStateKey__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__parts_components_Detail_OutgoingQuotes_SelectImages__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__RepairQuotes_constants__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions__ = __webpack_require__(186);
/* unused harmony export Form */
























var FORM_NAME = "send-outgoing-quote";

var excludedQuoteTypes = [__WEBPACK_IMPORTED_MODULE_10__constants__["E" /* AWAITING_INFO_TO_COMPLETE */], __WEBPACK_IMPORTED_MODULE_10__constants__["q" /* OFFER */]];

function filteredLineItems(quote) {
  return quote.get("outgoing_quote_line_items").toJS().filter(function (i) {
    return !excludedQuoteTypes.includes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(i, __WEBPACK_IMPORTED_MODULE_21__RepairQuotes_constants__["n" /* QUOTE_TYPE */]));
  });
}

function LineItems(_ref) {
  var fields = _ref.fields,
      lineItems = _ref.lineItems,
      smallForm = _ref.smallForm;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tbody",
    null,
    fields.map(function (item, idx) {
      var lineItem = lineItems[idx];
      var traceability = lineItem.traceability_attachment;
      var tagCopies = lineItem.tag_copies_attachment && lineItem.inventory.repair_status !== __WEBPACK_IMPORTED_MODULE_13__RepairOrders_constants__["n" /* REPAIR_AND_HOLD */] && lineItem.inventory.status !== __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["_60" /* REPAIRING */];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: "item-" + lineItem.id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          {
            className: "text-right",
            style: { verticalAlign: "top", paddingTop: 8, paddingLeft: 10 }
          },
          idx + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { className: "float-left" },
                lineItem.part.part_number,
                " | Serial #\xA0",
                lineItem.serial_number,
                " |\xA0",
                __WEBPACK_IMPORTED_MODULE_10__constants__["c" /* OUTGOING_LINE_ITEMS */].quoteType[lineItem.quote_type].label
              )
            )
          ),
          !smallForm && [!traceability && !tagCopies && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "em",
                null,
                "No attachments available for this item."
              )
            )
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
            null,
            (traceability || tagCopies) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["a" /* CheckGroup */],
                { title: "Attachments", justified: true },
                traceability && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: item + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["t" /* ATTACH_TRACEABILITY */],
                  component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__constants__["t" /* ATTACH_TRACEABILITY */])
                }),
                tagCopies && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: item + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["m" /* ATTACH_TAG_COPIES */],
                  component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__constants__["m" /* ATTACH_TAG_COPIES */])
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["a" /* CheckGroup */],
                { title: "Hazmat", justified: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: item + ".show_hazmat_warning",
                  component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
                  label: "Show Hazmat Warning"
                })
              )
            )
          )],
          smallForm && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
            null,
            !traceability && !tagCopies && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "em",
                null,
                "No attachments available for this item."
              )
            ),
            (traceability || tagCopies) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 9 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["a" /* CheckGroup */],
                { title: "Attachments", justified: true },
                traceability && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: item + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["t" /* ATTACH_TRACEABILITY */],
                  component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__constants__["t" /* ATTACH_TRACEABILITY */])
                }),
                tagCopies && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: item + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["m" /* ATTACH_TAG_COPIES */],
                  component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__constants__["m" /* ATTACH_TAG_COPIES */])
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["a" /* CheckGroup */],
                { title: "Hazmat", justified: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: item + ".show_hazmat_warning",
                  component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
                  label: "Show Hazmat"
                })
              )
            )
          ),
          traceability && tagCopies && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
            null,
            traceability && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3, style: { marginTop: 0 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__shared_components__["r" /* ExternalLink */],
                { url: traceability.public_download_url },
                "Download Traceability"
              )
            ),
            tagCopies && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3, style: { marginTop: 0 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__shared_components__["r" /* ExternalLink */],
                { url: tagCopies.public_download_url },
                "Download Tag Copies"
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__parts_components_Detail_OutgoingQuotes_SelectImages__["a" /* default */], {
                formSection: item,
                formName: FORM_NAME,
                inventory: lineItem.inventory
              })
            )
          )
        )
      );
    })
  );
}

LineItems.propTypes = {
  lineItems: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Array),
  fields: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    map: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  }),
  smallForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

function Form(_ref2) {
  var attachments = _ref2.attachments,
      close = _ref2.close,
      getFieldValue = _ref2.getFieldValue,
      handleSubmit = _ref2.handleSubmit,
      invalid = _ref2.invalid,
      setFieldValue = _ref2.setFieldValue,
      submitting = _ref2.submitting,
      quote = _ref2.quote,
      modal = _ref2.modal,
      smallForm = _ref2.smallForm;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */],
    { handleSubmit: handleSubmit, modal: modal },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "to", label: "To:", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "cc", label: "CC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "bcc", label: "BCC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Attachments"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "table",
              { className: "table table-striped table-numbered margin-bottom-none" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["FieldArray"], {
                name: __WEBPACK_IMPORTED_MODULE_12__constants__["A" /* LINE_ITEMS */],
                component: LineItems,
                lineItems: filteredLineItems(quote),
                smallForm: smallForm
              })
            )
          )
        )
      ),
      attachments && attachments.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__SelectAttachmentTable__["a" /* default */], {
            attachments: attachments,
            getFieldValue: getFieldValue,
            setFieldValue: setFieldValue
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */].Footer,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* Button */],
        { onClick: close },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* Button */],
        {
          type: "submit",
          bsStyle: "primary",
          disabled: invalid || submitting
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["k" /* Icon */], { name: "envelope", fixed: true }),
        "\xA0",
        submitting ? "Sending..." : "Send Quote"
      )
    )
  );
}

Form.propTypes = {
  attachments: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Array),
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getFieldValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  invalid: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  quote: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    get: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    getIn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  }),
  modal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  smallForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state, props) {
  return {
    attachments: state[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__shared_components_Notes_resourceToStateKey__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_18__shared_types_resourceTypes__["a" /* default */].outgoingQuote)].get(__WEBPACK_IMPORTED_MODULE_12__constants__["k" /* ATTACHMENTS */]).toJS(),
    initialValues: {
      attachment_ids: [],
      to: props.quote.getIn([__WEBPACK_IMPORTED_MODULE_15__companies_constants__["g" /* CONTACT */], __WEBPACK_IMPORTED_MODULE_12__constants__["T" /* EMAIL */]]),
      bcc: props.currentUser.email,
      line_items: filteredLineItems(props.quote).map(function (item) {
        return {
          id: item.id,
          attach_traceability: false,
          attach_tag_copies: !!item.tag_copies_attachment && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(item, "inventory.condition") !== __WEBPACK_IMPORTED_MODULE_10__constants__["F" /* AS_REMOVED */],
          inventory_attachment_ids: [],
          show_hazmat_warning: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(item, "part.hazmat")
        };
      })
    }
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__actions__["a" /* sendEmail */])(ownProps.quote.get(__WEBPACK_IMPORTED_MODULE_12__constants__["b" /* ID */]), data, ownProps.close));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: function validate(values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_validate_this__["a" /* validator */])(values, function (f) {
      f.validate("body", "to").satisfies(__WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["a" /* required */]);
      f.validate("to", "cc", "bcc").satisfies(__WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["b" /* isValidEmail */]);
    });
  }
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);







var Row = function Row(_ref) {
  var attachment = _ref.attachment,
      ids = _ref.ids,
      setFieldValue = _ref.setFieldValue;

  var toggle = function toggle() {
    if (ids.includes(attachment.id)) {
      var index = ids.indexOf(attachment.id);
      ids.splice(index, 1);
      setFieldValue(__WEBPACK_IMPORTED_MODULE_3__constants__["G" /* ATTACHMENT_IDS */])(ids);
    } else {
      ids.push(attachment.id);
      setFieldValue(__WEBPACK_IMPORTED_MODULE_3__constants__["G" /* ATTACHMENT_IDS */])(ids);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "checkbox",
        selected: ids.includes(attachment.id),
        onClick: toggle
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      attachment.name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(__WEBPACK_IMPORTED_MODULE_3__constants__["H" /* ATTACHMENT_TYPES */], __WEBPACK_IMPORTED_MODULE_4__SalesOrders_constants__["s" /* ATTACHMENT_TYPES */]), attachment.attachment_type + ".label")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      attachment.description
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(attachment.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(attachment, "created_by.full_name")
    )
  );
};

Row.propTypes = {
  attachment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  ids: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var SelectAttachmentTable = function SelectAttachmentTable(_ref2) {
  var attachments = _ref2.attachments,
      getFieldValue = _ref2.getFieldValue,
      setFieldValue = _ref2.setFieldValue;

  var ids = getFieldValue(__WEBPACK_IMPORTED_MODULE_3__constants__["G" /* ATTACHMENT_IDS */]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    {
      className: "table table-striped table-hover table-numbered",
      style: { marginTop: 20 }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Name"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Type"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Description"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Date Added"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Added By"
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      attachments.map(function (a) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row, { attachment: a, ids: ids, setFieldValue: setFieldValue });
      })
    )
  );
};

SelectAttachmentTable.propTypes = {
  attachments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SelectAttachmentTable);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
var SET = "outgoingQuotes/SET";

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_constants__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = ExistingQuoteWarning;






function ExistingQuoteWarning(_ref) {
  var quote = _ref.quote;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "center-block alert alert-info" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "media" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "media-left" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-warning text-info" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "media-body" },
        "The part number has already been quoted to ",
        quote.get("company_name"),
        " ",
        "within the last 36 hours. It was quoted by",
        " ",
        quote.getIn([__WEBPACK_IMPORTED_MODULE_3__constants__["_8" /* CREATED_BY */], __WEBPACK_IMPORTED_MODULE_4__users_constants__["f" /* FULL_NAME */]]),
        " to ",
        quote.get(__WEBPACK_IMPORTED_MODULE_3__constants__["E" /* CONTACT_NAME */]),
        " on",
        " ",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__["e" /* shortDateAndTimestamp */])(quote.get(__WEBPACK_IMPORTED_MODULE_3__constants__["_7" /* CREATED_AT */])),
        ". If you think it might be for the same order, please transfer to",
        " ",
        quote.getIn([__WEBPACK_IMPORTED_MODULE_3__constants__["_8" /* CREATED_BY */], __WEBPACK_IMPORTED_MODULE_4__users_constants__["f" /* FULL_NAME */]]),
        "."
      )
    )
  );
}

ExistingQuoteWarning.propTypes = {
  quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
    })
  })
};

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RepairOrders_constants__ = __webpack_require__(28);
/* harmony export (immutable) */ __webpack_exports__["a"] = validateLineItem;
/* harmony export (immutable) */ __webpack_exports__["b"] = validate;








function validateLineItem(lineItem, values) {
  var fieldPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var getFieldVal = function getFieldVal(field) {
    return fieldPrefix ? values[fieldPrefix] && values[fieldPrefix][field] : values[field];
  };

  var quoteType = getFieldVal(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* QUOTE_TYPE */]);

  var inventoryIds = getFieldVal("inventory_ids");

  if (quoteType !== __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* NO_QUOTE */] && (!inventoryIds || inventoryIds && inventoryIds.length <= 1)) {
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["f" /* isGreaterThan */](0));
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["n" /* CONDITION */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
  }

  if (quoteType === __WEBPACK_IMPORTED_MODULE_1__constants__["j" /* EXCHANGE_ONLY */]) {
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* EXCHANGE_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["f" /* isGreaterThan */](0), __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);

    lineItem.validate(__WEBPACK_IMPORTED_MODULE_6__RepairOrders_constants__["e" /* CORE_DUE_DAYS */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0), __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["k" /* isLessThanOrEqualTo */](100));
  }

  lineItem.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["N" /* OTHER_TAG_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["o" /* maxLengthOfText */](30));

  if (!__WEBPACK_IMPORTED_MODULE_1__constants__["w" /* PRICE_PER_UNIT_OPTIONAL_QUOTE_TYPES */].includes(quoteType) && ![__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* NO_INTEREST */], __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* LOOKING_FOR */]].some(function (f) {
    return values[f];
  })) {
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* PRICE_PER_UNIT */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
  }

  if (getFieldVal(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FOLLOW_UP_FEEDBACK */]) === __WEBPACK_IMPORTED_MODULE_3__shared_constants__["d" /* OTHER */]) {
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_3__shared_constants__["c" /* INTERNAL_NOTE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
  }
}

function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["q" /* PART_ID */], __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* QUOTE_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    validateLineItem(form, values);
  });
}

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inventories_constants__ = __webpack_require__(12);
/* harmony export (immutable) */ __webpack_exports__["a"] = Total;






function Total(_ref) {
  var part = _ref.part,
      quantity = _ref.quantity,
      pricePerUnit = _ref.pricePerUnit,
      totalCyclesRemaining = _ref.totalCyclesRemaining,
      totalHoursRemaining = _ref.totalHoursRemaining;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "well" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h6",
      { className: "h4" },
      "Outgoing Quote Summary"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed table-padding-horizonal-none margin-bottom-none" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Part #",
            part && part.part_number,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "em",
              { className: "text-muted" },
              part && part.description
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { className: "text-right" })
        ),
        totalCyclesRemaining && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["t" /* TOTAL_CYCLES_REMAINING */])
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            totalCyclesRemaining
          )
        ),
        totalHoursRemaining && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["s" /* TOTAL_HOURS_REMAINING */])
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            totalHoursRemaining
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed table-padding-horizonal-none" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              { className: "h4 margin-top-none margin-bottom-none" },
              "Total"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              { className: "h4 margin-top-none margin-bottom-none" },
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["b" /* calculateCost */])(quantity, pricePerUnit)
            )
          )
        )
      )
    )
  );
}

Total.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    part_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  pricePerUnit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  totalCyclesRemaining: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  totalHoursRemaining: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleRepairItem; });



var handleRepairItem = function handleRepairItem(_ref) {
  var inventoryDetails = _ref.inventoryDetails,
      change = _ref.change,
      getNameFromSection = _ref.getNameFromSection;

  if (inventoryDetails.repairing) {
    var leadTime = inventoryDetails.repair_and_hold_lead_time || inventoryDetails.repair_estimated_lead_time;

    change(getNameFromSection(__WEBPACK_IMPORTED_MODULE_0__inventories_constants__["p" /* TAGGED_BY */]), inventoryDetails.most_recent_repair_order.company.name);
    change(getNameFromSection(__WEBPACK_IMPORTED_MODULE_0__inventories_constants__["G" /* LEAD_TIME */]), leadTime);

    if (inventoryDetails.repairing && !inventoryDetails.tag_date) {
      var today = __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(leadTime, "days").format("YYYY-MM-DD");
      change(getNameFromSection(__WEBPACK_IMPORTED_MODULE_0__inventories_constants__["x" /* TAG_DATE */]), today);
    } else {
      change(getNameFromSection(__WEBPACK_IMPORTED_MODULE_0__inventories_constants__["x" /* TAG_DATE */]), inventoryDetails.tag_date);
    }
  }
};

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PurchasedPartWarning__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QuotedPartWarning__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ExistingQuoteWarning__ = __webpack_require__(665);






/* harmony default export */ __webpack_exports__["a"] = (function (mostRecentQuotes, companyPartHistory) {
  if (companyPartHistory.purchased_part) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PurchasedPartWarning__["a" /* default */], companyPartHistory);
  } else if (companyPartHistory.quoted_part) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__QuotedPartWarning__["a" /* default */], companyPartHistory);
  } else if (mostRecentQuotes.length > 0) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ExistingQuoteWarning__["a" /* default */], { quote: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(mostRecentQuotes[0]) });
  }

  return null;
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
var SET = "shipmentDetail/SET";

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECORD_TYPES; });
var RECORD_TYPES = {
  SalesOrder: "SO",
  RepairOrder: "RO",
  InventoryTransferOrder: "TR",
  ManagedRepairOrder: "MR",
  PurchaseOrder: "CR",
  ReturnedCore: "CR",
  Rma: "RMA",
  ReturnToCustomerRecord: "RMA",
  ReturnedConsignment: "RC"
};

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__decorators_withPurchaseOrder__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__ = __webpack_require__(32);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isLastExchange; });
/* unused harmony export Exchange */
/* unused harmony export exchange */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














var isLastExchange = function isLastExchange(lineItem) {
  return lineItem.purchase_for_exchange && !lineItem.second_exchange_item_id && !lineItem.exchange_type || lineItem.exchange_type === __WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["l" /* SECOND_EXCHANGE */] && !lineItem.third_exchange_item_id || lineItem.exchange_type === __WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["m" /* THIRD_EXCHANGE */];
};

function Exchange(_ref) {
  var outright = _ref.outright,
      creatingOutright = _ref.creatingOutright,
      open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["k" /* Icon */], { name: "shopping-cart", fixed: true }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "with-padding" },
      "Convert to Outright"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["i" /* ConfirmAction */], {
      onConfirm: function onConfirm() {
        return outright();
      },
      close: close,
      open: creatingOutright
    })
  );
}

Exchange.propTypes = _extends({
  outright: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  creatingOutright: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  confirmConfig: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_8__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

var withExchange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var itemId = _ref2.lineItem.id,
      close = _ref2.close,
      pushHistory = _ref2.pushHistory;
  return {
    outright: function outright() {
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].purchaseOrders.lineItems.outright(itemId).then(function (_ref3) {
        var id = _ref3.data.id;

        pushHistory({ pathname: "/purchase-orders/" + id });
        close();
      });
    }
  };
});

var meetsExchangeCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["a" /* renderIf */])(function (_ref4) {
  var lineItem = _ref4.lineItem,
      role = _ref4.currentUser.role;
  return [__WEBPACK_IMPORTED_MODULE_9__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_9__users_constants__["m" /* ACCOUNTING */]].includes(role) && !lineItem.cancelled && !lineItem.shipped && lineItem.received && lineItem.purchase_for_exchange && isLastExchange(lineItem);
});

var exchange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__decorators_withPurchaseOrder__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["e" /* toggleSwitch */])("creatingOutright")(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__session_decorators_withCurrentUser__["b" /* default */])(withExchange(meetsExchangeCriteria(Exchange)))));

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"] })(exchange));

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(1543);
/* harmony export (immutable) */ __webpack_exports__["a"] = SendModal;






function SendModal(_ref) {
  var purchaseOrder = _ref.purchaseOrder,
      visible = _ref.visible,
      close = _ref.close,
      invoiceToIre = _ref.invoiceToIre;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: visible, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Are You Sure?"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], {
      close: close,
      purchaseOrderId: purchaseOrder.get("id"),
      invoiceToIre: invoiceToIre
    })
  );
}

SendModal.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired,
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  invoiceToIre: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_validations__ = __webpack_require__(204);
/* harmony export (immutable) */ __webpack_exports__["b"] = validate;
/* harmony export (immutable) */ __webpack_exports__["a"] = validateShipping;




function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate("buying_store", "company_id", "contact_id", "payment_terms").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    if (values.buyer_credit_pct <= 50.0) {
      v.validate("co_buyer_id").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if (values.buyer_credit_pct <= 37.5) {
      v.validate("third_buyer_id").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }
  });
}

function validateShipping(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_validations__["c" /* validateShippingFields */])(values, v);
  });
}

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parts_actions_actions__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Locations_components_BuyingStoreRadioField__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__companies_helpers__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__companies_shared_components_RestrictedEntityWarning__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__companies_shared_components_RestrictedContactWarning__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_components_PaymentTerms_PaymentTerms__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CoBuyersFields_CoBuyersFields__ = __webpack_require__(324);
/* unused harmony export DetailFields */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
























var DetailFields = function (_React$Component) {
  _inherits(DetailFields, _React$Component);

  function DetailFields() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DetailFields);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DetailFields.__proto__ || Object.getPrototypeOf(DetailFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      contacts: []
    }, _this.fetchContacts = function (value) {
      if (!value) {
        return null;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__parts_actions_actions__["a" /* searchContacts */])(value).then(function () {
        var vals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        _this.setState({ contacts: vals });

        if (_this.props.setPrimaryContact) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__companies_helpers__["a" /* selectPrimaryContact */])(vals, _this.props.setField(__WEBPACK_IMPORTED_MODULE_11__constants__["O" /* CONTACT_ID */]));
        }
      });
    }, _this.handleCompanyChange = function (result) {
      if (_this.props.setSelectedCompany) _this.props.setSelectedCompany(result);
      _this.setState({ selectedCompany: result });

      if (_this.props.notifyForm) _this.props.notifyForm(result);

      if (result) {
        var address = result.primary_physical_address;
        var formattedAddress = address ? [address.city, address.state, address.country].join("-") : "";
        _this.props.setField(__WEBPACK_IMPORTED_MODULE_11__constants__["H" /* FOB */])(formattedAddress);
        if (_this.props.setPaymentTerms) _this.props.setPaymentTerms(result.vendor_credit_terms);
        _this.fetchContacts(result.id);
      } else {
        _this.setState({ contacts: [] });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DetailFields, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.purchaseOrder && this.props.purchaseOrder.company) {
        this.fetchContacts(this.props.purchaseOrder.company.id);
        var _props = this.props,
            selectedCoBuyer = _props.selectedCoBuyer,
            selectedThirdBuyer = _props.selectedThirdBuyer;

        this.setState({
          selectedCoBuyer: selectedCoBuyer,
          selectedThirdBuyer: selectedThirdBuyer
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          contacts = _state.contacts,
          selectedCompany = _state.selectedCompany,
          selectedCoBuyer = _state.selectedCoBuyer,
          selectedThirdBuyer = _state.selectedThirdBuyer;
      var _props2 = this.props,
          contact = _props2.contact,
          currentUser = _props2.currentUser,
          getField = _props2.getField,
          getInitialFieldValue = _props2.getInitialFieldValue,
          purchaseOrder = _props2.purchaseOrder,
          searchCompanies = _props2.searchCompanies,
          selectedBuyer = _props2.selectedBuyer,
          searchBuyers = _props2.searchBuyers,
          setField = _props2.setField,
          buyerCreditPct = _props2.buyerCreditPct;

      var buyerCreditPctOptions = [{ text: "75%", value: "75.0" }, { text: "50%", value: "50.0" }, { text: "25%", value: "25.0" }];
      var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__companies_helpers__["b" /* contactSelectList */])(contacts, true);
      var company = selectedCompany || purchaseOrder && purchaseOrder.company;
      var toggleBuyer = function toggleBuyer(buyer) {
        return _this2.setState(buyer);
      };
      var contactName = contact === "Add" && getField([__WEBPACK_IMPORTED_MODULE_6__companies_constants__["g" /* CONTACT */], __WEBPACK_IMPORTED_MODULE_11__constants__["S" /* NAME */]].join(".")) ? getField([__WEBPACK_IMPORTED_MODULE_6__companies_constants__["g" /* CONTACT */], __WEBPACK_IMPORTED_MODULE_11__constants__["S" /* NAME */]].join(".")) : contact && contact.name;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row row-col-gutters-half" },
          currentUser.tenant.locations_count !== 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 5 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Locations_components_BuyingStoreRadioField__["a" /* default */], null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_14__users_constants__["x" /* BUYER_ID */],
              label: "Buyer",
              placeholder: "Search by name...",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["n" /* AutoCompleteField */],
              search: searchBuyers,
              selectedItem: selectedBuyer,
              formatItem: function formatItem(result) {
                return result && result.full_name;
              },
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_11__constants__["G" /* BUYER_CREDIT_PCT */],
              className: "text-right",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
              onChange: function onChange(_ev, val) {
                if (["25.0", "50.0", null].includes(val)) {
                  setField(__WEBPACK_IMPORTED_MODULE_14__users_constants__["y" /* THIRD_BUYER_ID */])(null);
                  toggleBuyer({ selectedThirdBuyer: null });
                }
              },
              options: buyerCreditPctOptions,
              label: "Buyer Credit",
              required: true
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__CoBuyersFields_CoBuyersFields__["a" /* default */], {
            buyerCreditPct: buyerCreditPct,
            searchBuyers: searchBuyers,
            selectedCoBuyer: selectedCoBuyer,
            selectedThirdBuyer: selectedThirdBuyer,
            toggleBuyer: toggleBuyer,
            numberOfBuyers: [getField(__WEBPACK_IMPORTED_MODULE_14__users_constants__["z" /* CO_BUYER_ID */]), getField(__WEBPACK_IMPORTED_MODULE_14__users_constants__["y" /* THIRD_BUYER_ID */])].filter(function (s) {
              return s;
            }).length + 1
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["m" /* DashedSeparator */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_11__constants__["N" /* COMPANY_ID */],
              label: "Vendor",
              labelChildren: company && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                "\xA0\xA0",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["g" /* CompanyStatsTooltip */], { company: company })
              ),
              placeholder: "Search by typing a company's name or code",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["n" /* AutoCompleteField */],
              search: searchCompanies,
              formatItem: function formatItem(result) {
                return result.name + " (" + __WEBPACK_IMPORTED_MODULE_6__companies_constants__["h" /* APPROVAL_STATUSES */][result.vendor_status].label + ")";
              },
              onItemSelected: function onItemSelected(i) {
                return i && _this2.handleCompanyChange(i);
              },
              selectedItem: company,
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_11__constants__["O" /* CONTACT_ID */],
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
              options: options,
              label: "Vendor Contact",
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components_PaymentTerms_PaymentTerms__["a" /* default */], { getInitialFieldValue: getInitialFieldValue })
          )
        ),
        contact === __WEBPACK_IMPORTED_MODULE_20__constants__["f" /* PORTAL_PURCHASE */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
                disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lodash__["get"])(company, __WEBPACK_IMPORTED_MODULE_6__companies_constants__["e" /* WEBSITE */]),
                name: "company.website",
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__companies_constants__["e" /* WEBSITE */]),
                required: true
              })
            )
          )
        ),
        contact === "Add" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "contact.name",
                component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
                label: "Contact Name",
                required: true
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "contact.email",
                component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
                label: "Contact Email",
                required: true
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["p" /* PhoneNumberField */], {
                name: "contact.phone1",
                component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
                label: "Phone Number 1",
                type: "tel"
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__companies_shared_components_RestrictedEntityWarning__["a" /* default */], {
              allContacts: true,
              company: company,
              requireApproval: true
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__companies_shared_components_RestrictedContactWarning__["a" /* default */], { contact: contactName })
          )
        )
      );
    }
  }]);

  return DetailFields;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DetailFields.propTypes = {
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  contact: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  currentUser: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  getField: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object),
  searchBuyers: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  searchCompanies: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  notifyForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  setPaymentTerms: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  selectedBuyer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object),
  selectedCoBuyer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object),
  selectedThirdBuyer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object),
  setField: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  setPrimaryContact: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  setSelectedCompany: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
DetailFields.defaultProps = {
  setPrimaryContact: true
};
var selector = function selector(form) {
  for (var _len2 = arguments.length, other = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    other[_key2 - 1] = arguments[_key2];
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(form).apply(undefined, other);
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state, ownProps) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_14__users_constants__["a" /* USER */]).toJS(),
    buyerCreditPct: selector(ownProps.formName, state, __WEBPACK_IMPORTED_MODULE_11__constants__["G" /* BUYER_CREDIT_PCT */]),
    contact: selector(ownProps.formName, state, __WEBPACK_IMPORTED_MODULE_11__constants__["O" /* CONTACT_ID */]),
    getField: function getField(field) {
      return selector(ownProps.formName, state, field);
    },
    getInitialFieldValue: function getInitialFieldValue(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lodash__["get"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["getFormInitialValues"])(ownProps.formName || ownProps.form)(state), field);
    }
  };
}, function (dispatch, ownProps) {
  return {
    searchCompanies: function searchCompanies(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* searchCompanies */](filter));
    },
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8__actions__["c" /* searchBuyers */](filter));
    },
    setField: function setField(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(ownProps.formName, field, val));
      };
    }
  };
})(DetailFields));

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_constants__ = __webpack_require__(23);






var Stars = function Stars() {
  var stars = Array.from({ length: 5 }, function (_, _i) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-star", ariaHidden: true });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      className: "score-wrap text-light-purple",
      style: { display: "inline" }
    },
    stars
  );
};

var TierTypeExchangeSrpWarning = function TierTypeExchangeSrpWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components__["n" /* Warning */],
    null,
    "Recommend 15% Exchange SRP minimum for ",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Stars, null),
    " part."
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["a" /* renderIf */])(function (_ref) {
  var part = _ref.part,
      srp = _ref.srp,
      exchangeSrp = _ref.exchangeSrp;
  return part && part.tier_type === __WEBPACK_IMPORTED_MODULE_4__parts_constants__["b" /* SATL */] && srp && !part.pass_fail && (!exchangeSrp || Number(exchangeSrp) < Number(srp) * 0.15);
})(TierTypeExchangeSrpWarning));

TierTypeExchangeSrpWarning.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return purchasesSum; });
/* harmony export (immutable) */ __webpack_exports__["a"] = PurchasesCount;
/* harmony export (immutable) */ __webpack_exports__["d"] = SrpTotal;
/* harmony export (immutable) */ __webpack_exports__["e"] = TotalRealized;
/* harmony export (immutable) */ __webpack_exports__["f"] = TotalRealizedPercent;
/* harmony export (immutable) */ __webpack_exports__["b"] = PurchaseLinesCount;
/* harmony export (immutable) */ __webpack_exports__["h"] = PurchasesSum;
/* harmony export (immutable) */ __webpack_exports__["g"] = LotPurchasesSum;







var purchasesSum = function purchasesSum(data, country) {
  var field = (country ? country.toLowerCase() : "total") + "_purchases";
  var poTotal = data.buyers.reduce(function (sum, result) {
    return sum + result[field];
  }, 0);
  if (country) return poTotal;
  return poTotal + Number(data.lot_purchases_total);
};

var totalRealizedSum = function totalRealizedSum(data) {
  return data.buyers.reduce(function (sum, result) {
    return sum + result.total_realized;
  }, 0);
};

var srpSum = function srpSum(data) {
  return data.buyers.reduce(function (sum, result) {
    return sum + result.total_srp;
  }, 0);
};

function PurchasesCount(_ref) {
  var data = _ref.data;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["H" /* Stat */], {
    label: "# Purchases",
    value: __WEBPACK_IMPORTED_MODULE_1_numeral___default()(data.num_purchases).format("(0,0)")
  });
}

PurchasesCount.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}))
};

function SrpTotal(_ref2) {
  var data = _ref2.data;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["H" /* Stat */], { label: "$ SRP Total", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(srpSum(data), 0) });
}

SrpTotal.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    total_srp: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired
  })
};

function TotalRealized(_ref3) {
  var data = _ref3.data;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["H" /* Stat */], {
    label: "# Total Realized",
    value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(totalRealizedSum(data), 0)
  });
}

TotalRealized.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    total_realized: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired
  })
};

function TotalRealizedPercent(_ref4) {
  var data = _ref4.data;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["H" /* Stat */], {
    label: "% Realized",
    value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__["a" /* percent */])(totalRealizedSum(data), purchasesSum(data))
  });
}

TotalRealizedPercent.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    total_realized: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
    total_purchased: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired
  })
};

function PurchaseLinesCount(_ref5) {
  var data = _ref5.data;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["H" /* Stat */], {
    label: "# PO Lines",
    value: __WEBPACK_IMPORTED_MODULE_1_numeral___default()(data.num_line_items).format("(0,0)")
  });
}

PurchaseLinesCount.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}))
};

function PurchasesSum(_ref6) {
  var data = _ref6.data,
      country = _ref6.country;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["H" /* Stat */], {
    label: "$ Purchases " + (country ? country.toUpperCase() : "Total"),
    value: __WEBPACK_IMPORTED_MODULE_1_numeral___default()(purchasesSum(data, country)).format("($0,0)")
  });
}

PurchasesSum.propTypes = {
  country: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    num_purchases: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
    num_line_items: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
    buyers: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf({})
  })
};

function LotPurchasesSum(_ref7) {
  var data = _ref7.data;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["H" /* Stat */], {
    label: "$ Lot Purchases Total",
    value: __WEBPACK_IMPORTED_MODULE_1_numeral___default()(data.lot_purchases_total).format("($0,0)")
  });
}

LotPurchasesSum.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    num_purchases: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
    num_line_items: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
    buyers: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf({})
  })
};

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "purchasesReport",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].reports.purchases_report.search,
  initialSettings: {
    sort: "name",
    limit: 10000
  }
}));

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
var SET = "rmaDetail/SET";

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__companies_shared_SearchCompany__ = __webpack_require__(2038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_forms__ = __webpack_require__(44);
/* harmony export (immutable) */ __webpack_exports__["a"] = Form;










function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
        { className: "row-col-gutters-half" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            component: __WEBPACK_IMPORTED_MODULE_5__companies_shared_SearchCompany__["a" /* default */],
            name: "company_id",
            company: props.rma.toJS().company
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: "reason",
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
            label: "Reason",
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_forms__["a" /* toOptions */])(props.rma.get("type") === "VendorRma" ? __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* REASONS */] : __WEBPACK_IMPORTED_MODULE_6__constants__["l" /* CUSTOMER_RMA_REASONS */]),
            prompt: false,
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
        { className: "row-col-gutters-half" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6 },
          props.rma.get("type") === "CustomerRma" && props.customerRmaReasons === "other" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: "other_reason",
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
            label: "Other-Reason",
            required: true
          }) : "",
          props.rma.get("type") === "VendorRma" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
            name: "vendor_rma_number",
            label: "Vendor RMA Number"
          }) : ""
        )
      )
    )
  );
}

Form.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
};

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* unused harmony export validateShippingFields */
/* harmony export (immutable) */ __webpack_exports__["a"] = validateForShippingType;




function validateShippingFields(shippingType, values, form) {
  var shipToType = values[shippingType + "_type"];
  form.validate(shippingType + "_type").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);

  if (shipToType === __WEBPACK_IMPORTED_MODULE_2__shared_components_ShippingSection_shippingTypes__["d" /* COMPANY */]) {
    form.validate(shippingType + "_company_id", shippingType + "_company_address_id").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  } else if (shipToType === __WEBPACK_IMPORTED_MODULE_2__shared_components_ShippingSection_shippingTypes__["e" /* DROPSHIP */]) {
    form.validateChild(shippingType + "_shipping_address", function (address) {
      address.validate("country", "line1", "city", "postal_code").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    });
  } else if (shipToType === __WEBPACK_IMPORTED_MODULE_2__shared_components_ShippingSection_shippingTypes__["b" /* CUSTOMER */]) {
    form.validate(shippingType + "_customer_address_id").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  } else if (shipToType === __WEBPACK_IMPORTED_MODULE_2__shared_components_ShippingSection_shippingTypes__["f" /* REPAIR_STATION */]) {
    form.validate("repair_station_physical_address_id").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  }
}

function validateForShippingType(shippingType) {
  return function (values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
      validateShippingFields(shippingType, values, form);
    });
  };
}

/* harmony default export */ __webpack_exports__["b"] = (function (values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    validateShippingFields("ship_to", values, form);
  });
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Form__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inventories_components_Detail_RecentOrderRow__ = __webpack_require__(742);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return finalWarrantyApproval; });
/* harmony export (immutable) */ __webpack_exports__["b"] = WarrantyConsideration;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














var finalWarrantyApproval = function finalWarrantyApproval(rma) {
  if ([null, ""].includes(rma.warranty_status)) return null;
  return rma.warranty_status && rma.repair_station_warranty_status === __WEBPACK_IMPORTED_MODULE_6__companies_constants__["n" /* DENIED */] && rma.warranty_status === __WEBPACK_IMPORTED_MODULE_6__companies_constants__["n" /* DENIED */] ? __WEBPACK_IMPORTED_MODULE_6__companies_constants__["n" /* DENIED */] : __WEBPACK_IMPORTED_MODULE_6__companies_constants__["j" /* APPROVED */];
};

function WarrantyConsideration(_ref) {
  var rma = _ref.rma;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(rma, "inventory.managed_repair_in_progress")) return null;
  var title = rma.type === "CustomerRma" ? "Edit Warranty Consideration Details" : "Edit Vendor Warranty Consideration Details";

  var vendorWarrantyAmount = parseFloat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(rma, __WEBPACK_IMPORTED_MODULE_8__constants__["d" /* VENDOR_WARRANTY_AMOUNT */], 0));
  var vendorWarrantyAmountPaid = parseFloat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(rma, __WEBPACK_IMPORTED_MODULE_8__constants__["e" /* VENDOR_WARRANTY_AMOUNT_PAID */], 0));

  var initialValues = _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_pojos__["a" /* default */])(rma).pick(__WEBPACK_IMPORTED_MODULE_8__constants__["d" /* VENDOR_WARRANTY_AMOUNT */], __WEBPACK_IMPORTED_MODULE_8__constants__["e" /* VENDOR_WARRANTY_AMOUNT_PAID */], __WEBPACK_IMPORTED_MODULE_8__constants__["f" /* WARRANTY_CHARGES_INVOICED */], __WEBPACK_IMPORTED_MODULE_8__constants__["g" /* WARRANTY_CONSIDERATION */], __WEBPACK_IMPORTED_MODULE_8__constants__["h" /* WARRANTY_STATUS */], __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* REPAIR_STATION_WARRANTY_STATUS */]), {
    warranty_amount_paid: vendorWarrantyAmountPaid >= vendorWarrantyAmount
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Section__["a" /* default */],
      {
        title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["g" /* WARRANTY_CONSIDERATION */]),
        modal: {
          title: title,
          content: function content(close) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Form__["a" /* default */], { close: close, rma: rma, initialValues: initialValues });
          }
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["a" /* DetailTable */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], {
          label: "Warranty Consd Req?",
          value: rma.warranty_consideration
        }),
        rma.warranty_consideration && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], {
            label: "Warranty Charges",
            value: rma.warranty_charges_invoiced
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__inventories_components_Detail_RecentOrderRow__["a" /* default */], {
            record: rma,
            type: "warranty_consideration_repair_item",
            rootLink: "repair-orders",
            title: "Warranty Consideration RO"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
            label: "Warranty Status",
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["B" /* ApprovalLabel */], { status: rma.warranty_status })
          }),
          rma.type === "CustomerRma" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
            label: "Rep. Station Warranty",
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["B" /* ApprovalLabel */], {
              status: rma.repair_station_warranty_status
            })
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
            label: "Final Warranty Approval",
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["B" /* ApprovalLabel */], { status: finalWarrantyApproval(rma) })
          })
        )
      )
    )
  );
}

WarrantyConsideration.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    warranty_consideration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    warranty_status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    repair_station_warranty_status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired
};

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "rmas",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].rmas.search
}));

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Locations_constants__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Form__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Orders_shared_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__RepairOrders_constants__ = __webpack_require__(28);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NSN_ABBREV; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var InventoryTransferOrder = "InventoryTransferOrder";
var NSN_ABBREV = "NSN";

var Create = function (_React$Component) {
  _inherits(Create, _React$Component);

  function Create() {
    _classCallCheck(this, Create);

    return _possibleConstructorReturn(this, (Create.__proto__ || Object.getPrototypeOf(Create)).apply(this, arguments));
  }

  _createClass(Create, [{
    key: "render",

    // ADD more types as we continue to add modules
    value: function render() {
      var mapType = {
        consignment_line_item: "ConsignmentLineItem",
        rma: "Rma",
        lot: "Lot",
        lot_line_item: "LotLineItem",
        managed_repair_order_line_item: "ManagedRepairOrderLineItem",
        purchase_order_line_item: "PurchaseOrderLineItem",
        repair_order_line_item: "RepairOrderLineItem",
        sales_order_line_item: "SalesOrderLineItem",
        inventory_transfer_order: InventoryTransferOrder
      };

      var receivingType = {
        consignment_line_item: "consignment",
        sales_order_line_item: "so",
        lot: "lot",
        lot_line_item: "lot_line_item",
        managed_repair_order_line_item: "mro",
        purchase_order_line_item: "po",
        repair_order_line_item: "ro",
        inventory_transfer_order: "transfer"
      };
      var _props = this.props,
          open = _props.open,
          close = _props.close,
          currentUser = _props.currentUser,
          receivingRecord = _props.receivingRecord,
          removeItem = _props.removeItem,
          virtual = _props.virtual;


      var requiredKeys = [__WEBPACK_IMPORTED_MODULE_9__constants__["W" /* AWB_NUMBER */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_6__constants__["F" /* CONSIGNMENT_REFERENCE */], __WEBPACK_IMPORTED_MODULE_7__parts_constants__["G" /* DOM */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["b" /* EXPECTED_SERIAL_NUMBER */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_0" /* LOCATION */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["x" /* TAG_DATE */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["p" /* TAGGED_BY */], __WEBPACK_IMPORTED_MODULE_14__shared_constants__["d" /* OTHER */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["N" /* OTHER_TAG_TYPE */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["q" /* PART_ID */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["E" /* TRACE_TYPE */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["F" /* TRACED_TO */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_97" /* WARE_HOUSE_ID */], __WEBPACK_IMPORTED_MODULE_6__constants__["S" /* VIRTUALLY_RECEIVING */]];
      var buildInitialValues = function buildInitialValues() {
        return receivingRecord && requiredKeys.reduce(function (acc, item) {
          acc[item] = receivingRecord[item];
          return acc;
        }, {});
      };

      var buildNetWeightAndDims = function buildNetWeightAndDims() {
        return [__WEBPACK_IMPORTED_MODULE_7__parts_constants__["_10" /* CAGE */], __WEBPACK_IMPORTED_MODULE_7__parts_constants__["o" /* NET_WEIGHT */], __WEBPACK_IMPORTED_MODULE_7__parts_constants__["s" /* NET_WEIGHT_OZ */], __WEBPACK_IMPORTED_MODULE_7__parts_constants__["p" /* NET_LENGTH */], __WEBPACK_IMPORTED_MODULE_7__parts_constants__["q" /* NET_WIDTH */], __WEBPACK_IMPORTED_MODULE_7__parts_constants__["r" /* NET_HEIGHT */]].reduce(function (acc, item) {
          acc[item] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, item) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, "part." + item);
          return acc;
        }, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__parts_constants__["t" /* NET_WEIGHT_UNIT */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, "part." + __WEBPACK_IMPORTED_MODULE_7__parts_constants__["t" /* NET_WEIGHT_UNIT */]) || "lb"));
      };

      var buildRecordInitialValues = function buildRecordInitialValues() {
        if (receivingRecord && receivingRecord.type === __WEBPACK_IMPORTED_MODULE_16__Orders_shared_constants__["b" /* RO_ITEM */] && receivingRecord.approval_status === __WEBPACK_IMPORTED_MODULE_17__RepairOrders_constants__["a" /* REPAIR_EVALUATION_APPROVED */]) {
          return {
            tagged_by: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, "company.name"),
            tagged_by_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, "company.id")
          };
        }

        if (receivingRecord && receivingRecord.type === __WEBPACK_IMPORTED_MODULE_16__Orders_shared_constants__["e" /* SO_ITEM */]) {
          return {
            tagged_by: undefined,
            tagged_by_id: undefined,
            tag_date: undefined
          };
        }

        return {};
      };

      var expectedQuantity = receivingRecord && receivingRecord.quantity - receivingRecord.quantity_received;

      var getSerialNumber = function getSerialNumber() {
        if (receivingRecord && receivingRecord.type === __WEBPACK_IMPORTED_MODULE_16__Orders_shared_constants__["e" /* SO_ITEM */]) {
          return "";
        }
        if (expectedQuantity === 1) {
          return receivingRecord.serial_number;
        }
        return NSN_ABBREV;
      };

      var initialValues = _extends({
        attachments: receivingRecord && receivingRecord.attachments || [],
        dom: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_7__parts_constants__["G" /* DOM */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, "line_item.dom"),
        store_location_id: currentUser.getIn([__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_0" /* LOCATION */], __WEBPACK_IMPORTED_MODULE_9__constants__["b" /* ID */]]),
        receiving_type: receivingRecord && receivingType[receivingRecord.type],
        reference_record_line_item_id: receivingRecord && receivingRecord.id,
        quantity: expectedQuantity,
        reference_record_line_item_type: receivingRecord && mapType[receivingRecord.type],
        part: null,
        serial_number: getSerialNumber()
      }, buildInitialValues(), buildNetWeightAndDims(), {
        part_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__helpers__["a" /* isModTo */])(receivingRecord) ? receivingRecord.mod_to_id : receivingRecord && receivingRecord.part_id,
        condition: receivingRecord && receivingRecord.type === __WEBPACK_IMPORTED_MODULE_16__Orders_shared_constants__["e" /* SO_ITEM */] ? __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_39" /* AS_REMOVED */] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["n" /* CONDITION */]),
        consignor_percentage: 0,
        received_virtually: virtual,
        tagged_by_existing_company: true,
        location: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_6__constants__["S" /* VIRTUALLY_RECEIVING */]) ? "Dropship" : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_0" /* LOCATION */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, "line_item.expected_location"),
        shipped_properly: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, "shipped_properly", false),
        vendor_packing_list_included: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, "vendor_packing_list_included", false),
        packing_list_and_tags_match: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, "packing_list_and_tags_match", false),
        passed_damage_inspection: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, "passed_damage_inspection", false),
        release_certificate_included: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, "release_certificate_included", false)
      }, buildRecordInitialValues(), {
        tagged_by_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["p" /* TAGGED_BY */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, "line_item.tagged_by"),
        ware_house_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_97" /* WARE_HOUSE_ID */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, "line_item.expected_ware_house_id"),
        internal_note: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, "line_item.internal_note", "")
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["a" /* Modal */],
          { open: open, close: close, dialogClass: "modal-lg" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["c" /* Close */], { close: close }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Receiving Checklist ",
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(receivingRecord, "reference_number")
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Form__["a" /* default */], {
            close: close,
            removeItem: removeItem,
            initialValues: receivingRecord ? initialValues : {
              store_location_id: currentUser.get(__WEBPACK_IMPORTED_MODULE_11__Locations_constants__["a" /* LOCATION_ID */]),
              quantity: 1
            },
            selectedBuyer: currentUser.toJS(),
            receivingRecord: receivingRecord,
            lockFields: receivingRecord && mapType[receivingRecord.type] === InventoryTransferOrder,
            virtualReceiving: virtual && receivingRecord && mapType[receivingRecord.type] !== InventoryTransferOrder,
            enableReinitialize: true
          })
        )
      );
    }
  }]);

  return Create;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Create.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  currentUser: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  receivingRecord: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  removeItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  virtual: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_10__users_constants__["a" /* USER */])
  };
})(Create));

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form__ = __webpack_require__(1651);







function CreateDiscrepancy(_ref) {
  var open = _ref.open,
      close = _ref.close,
      discrepancies = _ref.discrepancies,
      receivingRecord = _ref.receivingRecord;

  var initialValues = {
    read_only_part_number: receivingRecord.getIn(["part", "part_number"]),
    read_only_serial_number: receivingRecord.get("serial_number"),
    discrepancies: discrepancies && discrepancies.toJS()
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-md" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Add a Discrepancy"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Form__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      discrepancies: discrepancies.toJS(),
      enableReinitialize: true
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    receivingRecord: state.receivingRecordDetail.get("receivingRecord"),
    discrepancies: state.receivingRecordDetail.get("discrepancies")
  };
})(CreateDiscrepancy));

CreateDiscrepancy.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  receivingRecord: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  discrepancies: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])
};

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(34);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;



function validateItem(item) {
  item.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["E" /* DISCREPANCY_TYPE */]).required();
}

function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validateChildren("discrepancies", validateItem);
  });
}

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_INVENTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_DISCREPANCIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REMOVE_DISCREPANCIES; });
var SET = "receivingRecord/SET";
var SET_INVENTORY = "receivingRecord/SET_INVENTORY";
var SET_MODAL = "receivingRecord/SET_MODAL";
var SET_DISCREPANCIES = "receivingRecord/SET_DISCREPANCIES";
var REMOVE_DISCREPANCIES = "receivingRecord/REMOVE_DISCREPANCIES";

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony export (immutable) */ __webpack_exports__["a"] = Attachment;







function Attachment(_ref) {
  var fields = _ref.fields,
      attachmentTypes = _ref.attachmentTypes,
      getField = _ref.getField;

  var moreThanOne = fields.length >= 1;
  var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["a" /* toOptions */])(attachmentTypes);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    fields.map(function (attachment, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { key: "attachment-" + (attachment + index) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h5",
          { className: "h4" },
          "Attachment #",
          index + 1,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            {
              type: "button",
              className: "btn btn-xs btn-default btn-hollow pull-right",
              onClick: function onClick() {
                return fields.remove(index);
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
            "\xA0Remove"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
            { md: 8 },
            getField && getField(attachment + ".uploaded") ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "a",
              {
                href: getField(attachment + ".file_url"),
                target: "_blank",
                rel: "noopener noreferrer"
              },
              getField(attachment + ".name")
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: attachment + ".files",
              component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["k" /* FileInput */],
              label: "Upload Attachment",
              multiple: true,
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: attachment + ".attachment_type",
              component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["c" /* Select */],
              label: "Attachment Type",
              options: options,
              required: true
            })
          )
        )
      );
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        type: "button",
        onClick: function onClick() {
          return fields.push({ attachment_type: "photos_receiving_inspection" });
        },
        className: "btn btn-primary btn-hollow",
        style: { marginTop: 5, marginBottom: 15 }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
      " ",
      moreThanOne ? "Add another attachment" : "Add attachment"
    )
  );
}

Attachment.defaultProps = {
  attachmentTypes: [],
  fields: []
};

Attachment.propTypes = {
  fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    length: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }),
  attachmentTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Array),
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["a"] = validateAttachment;



function validateAttachment(attachment) {
  attachment.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* ATTACHMENT_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_0__lib_validation_rules__["a" /* required */]);
  attachment.validate("file").satisfies(__WEBPACK_IMPORTED_MODULE_0__lib_validation_rules__["c" /* requiredUnlessUploaded */]);
}

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Orders_shared_constants__ = __webpack_require__(102);
/* harmony export (immutable) */ __webpack_exports__["a"] = isModTo;


function isModTo(receivingRecord) {
  return receivingRecord && receivingRecord.type === __WEBPACK_IMPORTED_MODULE_0__Orders_shared_constants__["b" /* RO_ITEM */] && receivingRecord.mod_to_id;
}

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
var SET = "rejectedCores/SET";

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_submission__ = __webpack_require__(49);
/* harmony export (immutable) */ __webpack_exports__["a"] = show;
/* harmony export (immutable) */ __webpack_exports__["b"] = update;




function show(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].rejectedCores.show(id).then(function (resp) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* SET */],
        rejectedCore: resp.data
      });
    });
  };
}

function update(data) {
  return function (dispatch, getState) {
    var id = getState().rejectedCoreDetail.getIn(["rejectedCore", "id"]);

    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].rejectedCores.update(id, data).then(function (_ref) {
      var rejectedCore = _ref.data;

      dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* SET */], rejectedCore: rejectedCore });
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission__["a" /* SUCCESS */];
    });
  };
}

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_pagination__ = __webpack_require__(67);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_pagination__["a" /* createPaginatedList */])({
  listId: "rejectedCores",
  fetch: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].rejectedCores.search
}));

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
var SET = "repairOrders/SET";

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SalesOrders_components_shared_FormSections_ShippingSection_validate__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* unused harmony export validRepairAssist */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validReturnToForWarranty; });
/* harmony export (immutable) */ __webpack_exports__["b"] = validate;









var validRepairAssist = function validRepairAssist(val, values) {
  if (!val) return undefined;
  if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(values, "inventory.purchase_order_line_item.purchase_for_repair_assist") && (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(values, "inventory.srp_condition")) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(values, "inventory.suggested_retail")))) {
    return "Purchased For Repair Assist.  Please add Inventory SRP Condition and SRP before continuing.";
  }

  return undefined;
};

var validReturnToForWarranty = function validReturnToForWarranty(val, values) {
  var creditRequestedRmas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_helpers__["l" /* getCreditRequestedWarrantyRmas */])(values.line_items, "inventory.most_recent_customer_rma");

  var code = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(creditRequestedRmas, "[0].inventory.most_recent_customer_rma.code");

  if (creditRequestedRmas.length > 0 && [__WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingSection_shippingTypes__["d" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingSection_shippingTypes__["e" /* DROPSHIP */]].includes(val)) {
    return "You must first remove the open credit request from Cust " + code + " before you can return it to the Customer or an address other than our Store Location/s";
  }

  return undefined;
};

function validate(values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["N" /* COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_5__constants__["O" /* CONTACT_ID */], __WEBPACK_IMPORTED_MODULE_5__constants__["M" /* PAYMENT_TERMS */], __WEBPACK_IMPORTED_MODULE_5__constants__["_20" /* SHIP_TO_FOB */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);

    if (values.contact_id === "Add") {
      form.validateChild("contact", function (contactForm) {
        contactForm.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["T" /* EMAIL */], __WEBPACK_IMPORTED_MODULE_5__constants__["S" /* NAME */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
        contactForm.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["T" /* EMAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["b" /* isValidEmail */]);
      });
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__SalesOrders_components_shared_FormSections_ShippingSection_validate__["a" /* validateShippingFields */])("ship_to", values, form);

    if (values.line_items.some(function (i) {
      return i.action_requested === __WEBPACK_IMPORTED_MODULE_4__constants__["l" /* WARRANTY_CONSIDERATION */];
    })) {
      form.validate("return_to_type").satisfies(function (val) {
        return validReturnToForWarranty(val, values);
      });
    }

    if (props.selectedCompany) {
      form.validate("company_id").satisfies(function () {
        return __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["d" /* validateCompanyStatus */](props.selectedCompany);
      });
    }

    if (values.line_items.filter(function (i) {
      return i.action_requested === __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* TEARDOWN */];
    }).length > 1) {
      form.validateChildren("line_items", function (item) {
        item.validate("action_requested").satisfies(function () {
          return "Please separate parts being sent for teardown to individual Repair Orders.";
        });
      });
    }
  });
}

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_time__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validate__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__parts_actions_actions__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Orders_shared_InvoiceSection__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__inventories_components_EditInventory_TagTypes__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Shipping_constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__helpers__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__FormSections_RequiredComponents_RequiredComponents__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__FormSections__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Summary__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Warnings__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__shared_components_Warning_Warning__ = __webpack_require__(53);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }































var FORM_NAME = "repairOrderLineItem";

function AskIfAfterInternalOutright(props) {
  var selected = props.getFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["C" /* AFTER_INTERNAL_OUTRIGHT */]);

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_28__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Please confirm if the Parts & Labor charges associated to this record should be applied as new cost (After Internal Outright) or as old cost (Before Internal Outright)."
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group", style: { marginLeft: 10 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        className: "btn btn-default " + (selected && "active"),
        type: "button",
        onClick: function onClick() {
          props.change(__WEBPACK_IMPORTED_MODULE_14__constants__["C" /* AFTER_INTERNAL_OUTRIGHT */], true);
          props.setAskedInternalOutright(true);
        }
      },
      "After Internal Outright"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        className: "btn btn-default " + (!selected && "active"),
        type: "button",
        onClick: function onClick() {
          return props.setAskedInternalOutright(false);
        }
      },
      "Before Internal Outright"
    )
  )];
}

function AskIfRemovingExpectedComponents(props) {
  var selected = props.getFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["D" /* REMOVE_EXPECTED_COMPONENTS */]);

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_28__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Would you like to keep or cancel all subcomponents?"
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { display: "flex", justifyContent: "center" } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "btn-group", style: { marginLeft: 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          className: "btn btn-primary " + (!selected && "active"),
          type: "button",
          onClick: function onClick() {
            props.change(__WEBPACK_IMPORTED_MODULE_14__constants__["D" /* REMOVE_EXPECTED_COMPONENTS */], false);
          }
        },
        "Keep"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          className: "btn btn-primary " + (selected && "active"),
          type: "button",
          onClick: function onClick() {
            return props.change(__WEBPACK_IMPORTED_MODULE_14__constants__["D" /* REMOVE_EXPECTED_COMPONENTS */], true);
          }
        },
        "Remove"
      )
    )
  )];
}

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedInventory: {}
    }, _this.notifyForm = function (item) {
      _this.setState({ selectedInventory: item });
    }, _this.handleLeadTimeChange = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var days = e.target && e.target.value;
      if (days) {
        var leadDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_time__["a" /* addDays */])(new Date(), days);
        _this.props.change("expected_date", new Date(leadDate).toISOString().split("T")[0]);
      }
    }, _this.handleActionChange = function (action) {
      if (action === __WEBPACK_IMPORTED_MODULE_14__constants__["z" /* EXPECTED_COMPONENT */]) {
        _this.props.change(__WEBPACK_IMPORTED_MODULE_14__constants__["s" /* APPROVAL_STATUS */], __WEBPACK_IMPORTED_MODULE_14__constants__["B" /* REPAIR_AWAITING_EVALUATION */]);
        [__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["M" /* OTHER */]].forEach(function (f) {
          return _this.props.change("" + f, _this.props.repairOrder.get("company").get(f + "_approved") || false);
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var lineItem = this.props.lineItem;

      if (lineItem) {
        this.setState({ selectedInventory: lineItem });
        if (lineItem.estimated_lead_time && !lineItem.expected_date) {
          var addLeadDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_time__["a" /* addDays */])(new Date(), lineItem.estimated_lead_time);
          this.props.change(__WEBPACK_IMPORTED_MODULE_21__SalesOrders_constants__["n" /* EXPECTED_DATE */], new Date(addLeadDate).toISOString().split("T")[0]);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          lineItem = _props.lineItem,
          modTo = _props.modTo,
          part = _props.part,
          queryParts = _props.queryParts,
          queryPartsByStatus = _props.queryPartsByStatus,
          shopAssistRepairOrder = _props.shopAssistRepairOrder,
          setFieldValue = _props.setFieldValue,
          getFieldValue = _props.getFieldValue,
          getInitialFieldValue = _props.getInitialFieldValue,
          searchInventories = _props.searchInventories,
          _props$editing = _props.editing,
          editing = _props$editing === undefined ? false : _props$editing,
          _props$readOnly = _props.readOnly,
          readOnly = _props$readOnly === undefined ? false : _props$readOnly,
          repairOrder = _props.repairOrder,
          shouldAskInternalOutright = _props.shouldAskInternalOutright,
          subrole = _props.subrole;
      var selectedInventory = this.state.selectedInventory;

      var requestedAction = getFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["E" /* ACTION_REQUESTED */]);
      var hasRepairItem = repairOrder.get(__WEBPACK_IMPORTED_MODULE_20__constants__["A" /* LINE_ITEMS */]).some(function (i) {
        return [__WEBPACK_IMPORTED_MODULE_14__constants__["F" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_14__constants__["G" /* BENCH_TEST */], __WEBPACK_IMPORTED_MODULE_14__constants__["H" /* OVERHAUL */]].includes(i.get(__WEBPACK_IMPORTED_MODULE_14__constants__["E" /* ACTION_REQUESTED */]));
      });
      var hasTeardown = repairOrder.get(__WEBPACK_IMPORTED_MODULE_20__constants__["A" /* LINE_ITEMS */]).some(function (i) {
        return i.get(__WEBPACK_IMPORTED_MODULE_14__constants__["E" /* ACTION_REQUESTED */]) === __WEBPACK_IMPORTED_MODULE_14__constants__["b" /* TEARDOWN */];
      });

      var hasExpectedComponent = repairOrder.get(__WEBPACK_IMPORTED_MODULE_20__constants__["A" /* LINE_ITEMS */]).some(function (i) {
        return i.get(__WEBPACK_IMPORTED_MODULE_14__constants__["E" /* ACTION_REQUESTED */]) === __WEBPACK_IMPORTED_MODULE_14__constants__["z" /* EXPECTED_COMPONENT */];
      });

      var hasGoneOutright = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__helpers__["a" /* getOutrightVal */])(getFieldValue);

      var exchange = selectedInventory.inventory && selectedInventory.inventory.exchange_eval_in_progress || hasGoneOutright;

      var outrightValue = getFieldValue("inventory.most_recent_sales_order.outright_value");

      var originalEvalGreaterThanOutrightVal = getFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["I" /* ORIGINAL_EVALUATION */]) && outrightValue && parseFloat(getFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["I" /* ORIGINAL_EVALUATION */])) > parseFloat(outrightValue);

      var filteredActions = __WEBPACK_IMPORTED_MODULE_14__constants__["J" /* ACTIONS_REQUESTED */];
      if (!editing) {
        filteredActions = hasTeardown ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_removeKey__["a" /* default */])(filteredActions, __WEBPACK_IMPORTED_MODULE_14__constants__["b" /* TEARDOWN */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_removeKey__["a" /* default */])(filteredActions, __WEBPACK_IMPORTED_MODULE_14__constants__["z" /* EXPECTED_COMPONENT */]);
        filteredActions = hasRepairItem ? filteredActions : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_removeKey__["a" /* default */])(filteredActions, __WEBPACK_IMPORTED_MODULE_14__constants__["r" /* SHOP_ASSIST */]);
      } else if (getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["E" /* ACTION_REQUESTED */]) === __WEBPACK_IMPORTED_MODULE_14__constants__["b" /* TEARDOWN */]) {
        filteredActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_removeKey__["b" /* removeKeys */])(filteredActions, [__WEBPACK_IMPORTED_MODULE_14__constants__["z" /* EXPECTED_COMPONENT */], __WEBPACK_IMPORTED_MODULE_14__constants__["l" /* WARRANTY_CONSIDERATION */], __WEBPACK_IMPORTED_MODULE_14__constants__["r" /* SHOP_ASSIST */]]);
      }

      var originalEval = getFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["I" /* ORIGINAL_EVALUATION */]);
      var approvalStatus = getFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["s" /* APPROVAL_STATUS */]);
      var warehouseDirector = subrole === __WEBPACK_IMPORTED_MODULE_11__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */];
      var isConsignment = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(lineItem, "inventory.consignment_type");
      var canEditOutgoingAwb = approvalStatus !== __WEBPACK_IMPORTED_MODULE_14__constants__["K" /* AWAITING_TO_SHIP */] || isConsignment;

      var forceAskIfInternalOutright = !getFieldValue("asking_internal_outright") && !getFieldValue(__WEBPACK_IMPORTED_MODULE_20__constants__["_26" /* RECEIVED */]) && shouldAskInternalOutright && approvalStatus === __WEBPACK_IMPORTED_MODULE_14__constants__["a" /* REPAIR_EVALUATION_APPROVED */] && [__WEBPACK_IMPORTED_MODULE_21__SalesOrders_constants__["p" /* LABOR_COST */], __WEBPACK_IMPORTED_MODULE_21__SalesOrders_constants__["o" /* PART_COST */]].some(function (f) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(getFieldValue(f)) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(getInitialFieldValue(f));
      }) && getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["_38" /* INTERNAL_OUTRIGHT */]) && !getFieldValue(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["_38" /* INTERNAL_OUTRIGHT */]);

      var forceAskIfCancellingTeardown = !getFieldValue(__WEBPACK_IMPORTED_MODULE_20__constants__["_26" /* RECEIVED */]) && hasExpectedComponent && getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["E" /* ACTION_REQUESTED */]) === __WEBPACK_IMPORTED_MODULE_14__constants__["b" /* TEARDOWN */] && getFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["E" /* ACTION_REQUESTED */]) !== __WEBPACK_IMPORTED_MODULE_14__constants__["b" /* TEARDOWN */];

      var askingInternalOutright = getFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["L" /* ASKING_INTERNAL_OUTRIGHT */]);
      var askingExpectedComponents = getFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["M" /* ASKING_EXPECTED_COMPONENTS */]);
      var setAskedInternalOutright = function setAskedInternalOutright(val) {
        return setFieldValue("asked_internal_outright", val);
      };

      var parseValue = function parseValue(value) {
        return value === "" ? 0 : value;
      };

      var formatValue = function formatValue(value) {
        return value === 0 ? "" : value;
      };

      var parseDateValue = function parseDateValue(value) {
        return value === "" ? "" : value;
      };

      var formatDateValue = function formatDateValue(value) {
        return value === "" ? "" : value;
      };

      if (askingInternalOutright) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["e" /* Form */],
          _extends({}, this.props, { editable: !readOnly }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["e" /* Form */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AskIfAfterInternalOutright, {
              getFieldValue: getFieldValue,
              change: setFieldValue,
              setAskedInternalOutright: setAskedInternalOutright
            })
          )
        );
      }

      if (askingExpectedComponents) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["e" /* Form */],
          _extends({}, this.props, { editable: !readOnly }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["e" /* Form */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AskIfRemovingExpectedComponents, {
              getFieldValue: getFieldValue,
              change: setFieldValue
            })
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["e" /* Form */],
        _extends({}, this.props, { editable: !readOnly }),
        [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__Warnings__["a" /* CapAmountWarning */], { originalEval: originalEval, lineItem: lineItem }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "nav nav-tabs" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              null,
              "Action Requested"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 8 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "tab-content" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { role: "tabpanel", className: "tab-pane active" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__FormSections__["a" /* ActionRequestedSection */], {
                    onActionChange: function onActionChange(ev, action) {
                      return _this2.handleActionChange(action);
                    },
                    change: this.props.change,
                    exchange: exchange,
                    editing: editing,
                    formName: "repairOrderLineItem",
                    outrightValue: outrightValue,
                    originalEvalGreaterThanOutrightVal: originalEvalGreaterThanOutrightVal,
                    shopAssistRepairOrder: shopAssistRepairOrder,
                    setField: setFieldValue,
                    getField: getFieldValue,
                    getInitialFieldValue: getInitialFieldValue,
                    disabled: readOnly || warehouseDirector,
                    repairOrder: repairOrder,
                    actions: filteredActions,
                    tierType: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(part, __WEBPACK_IMPORTED_MODULE_19__parts_constants__["O" /* TIER_TYPE */])
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["q" /* FormRow */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                      { md: 12 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Fields"], {
                        names: [__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["L" /* UK_CAA */], __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["M" /* OTHER */], __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["N" /* OTHER_TAG_TYPE */]],
                        component: __WEBPACK_IMPORTED_MODULE_18__inventories_components_EditInventory_TagTypes__["a" /* default */],
                        formName: FORM_NAME,
                        required: ![__WEBPACK_IMPORTED_MODULE_14__constants__["t" /* REPAIR_EVALUATION_REJECTED */], __WEBPACK_IMPORTED_MODULE_14__constants__["N" /* NO_WORK_PERFORMED */]].includes(approvalStatus)
                      })
                    )
                  ),
                  requestedAction && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__FormSections__["b" /* PartDetailsSection */], {
                    modTo: modTo,
                    part: part,
                    queryParts: queryParts,
                    queryPartsByStatus: queryPartsByStatus,
                    searchInventories: searchInventories,
                    setField: setFieldValue,
                    getField: getFieldValue,
                    notifyForm: this.notifyForm,
                    requestedAction: requestedAction,
                    editing: editing,
                    disabled: readOnly || warehouseDirector
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__FormSections__["c" /* ExpectedComponentSection */], {
                    formName: FORM_NAME,
                    disabled: readOnly || warehouseDirector,
                    requestedAction: requestedAction
                  }),
                  requestedAction && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__FormSections__["d" /* CostSection */], {
                    lineItem: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_immutable__["Map"])(selectedInventory),
                    disabled: warehouseDirector,
                    getField: getFieldValue,
                    requestedAction: requestedAction,
                    setFieldValue: setFieldValue
                  }),
                  requestedAction && requestedAction !== __WEBPACK_IMPORTED_MODULE_14__constants__["r" /* SHOP_ASSIST */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["q" /* FormRow */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                        { md: 4 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "div",
                          { className: "form-group" },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                            name: "work_order_number",
                            component: __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["d" /* FormInput */],
                            label: "Work Order Number",
                            disabled: readOnly || warehouseDirector
                          })
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                        { md: 4 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "div",
                          { className: "form-group" },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                            name: __WEBPACK_IMPORTED_MODULE_14__constants__["O" /* ESTIMATED_LEAD_TIME */],
                            component: __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["d" /* FormInput */],
                            label: "Est. Lead Time",
                            parse: parseValue,
                            format: formatValue,
                            disabled: readOnly || warehouseDirector || getFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["n" /* REPAIR_AND_HOLD */]),
                            onChange: this.handleLeadTimeChange
                          })
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                        { md: 4 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "div",
                          { className: "form-group" },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                            name: __WEBPACK_IMPORTED_MODULE_21__SalesOrders_constants__["n" /* EXPECTED_DATE */],
                            component: __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["d" /* FormInput */],
                            label: "Expected Date",
                            parse: parseDateValue,
                            format: formatDateValue,
                            disabled: readOnly || warehouseDirector || getFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["n" /* REPAIR_AND_HOLD */]),
                            type: "date"
                          })
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["q" /* FormRow */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                        { md: 4 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                          name: __WEBPACK_IMPORTED_MODULE_14__constants__["P" /* EVAL_DUE_DATE */],
                          component: __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["d" /* FormInput */],
                          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_14__constants__["P" /* EVAL_DUE_DATE */]),
                          disabled: readOnly || warehouseDirector,
                          type: "date"
                        })
                      ),
                      canEditOutgoingAwb && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                        { md: 4 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                          name: __WEBPACK_IMPORTED_MODULE_22__Shipping_constants__["g" /* OUTGOING_AWB_NUMBER */],
                          component: __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["d" /* FormInput */],
                          label: "Outgoing AWB Number",
                          disabled: approvalStatus !== __WEBPACK_IMPORTED_MODULE_14__constants__["a" /* REPAIR_EVALUATION_APPROVED */] && approvalStatus !== __WEBPACK_IMPORTED_MODULE_14__constants__["t" /* REPAIR_EVALUATION_REJECTED */] && !isConsignment
                        })
                      ),
                      requestedAction !== __WEBPACK_IMPORTED_MODULE_14__constants__["z" /* EXPECTED_COMPONENT */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                        { md: 3 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                          name: "date_out",
                          label: "Ship Date",
                          component: __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["d" /* FormInput */],
                          type: "date",
                          disabled: true
                        })
                      )
                    )
                  ),
                  requestedAction && (exchange || readOnly) && requestedAction !== __WEBPACK_IMPORTED_MODULE_14__constants__["z" /* EXPECTED_COMPONENT */] && requestedAction !== __WEBPACK_IMPORTED_MODULE_14__constants__["b" /* TEARDOWN */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__FormSections__["e" /* ExchangeSection */], {
                    getField: getFieldValue,
                    getInitialFieldValue: getInitialFieldValue,
                    originalEvalGreaterThanOutrightVal: originalEvalGreaterThanOutrightVal,
                    requestedAction: requestedAction,
                    disabled: warehouseDirector
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10__shared_components__["b" /* Authorized */],
                    { roles: [__WEBPACK_IMPORTED_MODULE_11__users_constants__["m" /* ACCOUNTING */]] },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Orders_shared_InvoiceSection__["a" /* default */], null)
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__FormSections_RequiredComponents_RequiredComponents__["a" /* default */], {
                    company: repairOrder.get(__WEBPACK_IMPORTED_MODULE_20__constants__["i" /* COMPANY */]).toJS(),
                    lineItem: lineItem,
                    getFieldValue: getFieldValue
                  }),
                  requestedAction && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__FormSections__["f" /* NotesSection */], { disabled: readOnly })
                )
              )
            ),
            editing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Summary__["a" /* default */], {
                getField: getFieldValue,
                lineItem: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_immutable__["fromJS"])(selectedInventory),
                repairOrder: repairOrder
              })
            )
          )
        ), forceAskIfInternalOutright && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["e" /* Form */].Footer,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* Button */],
            { onClick: this.props.close },
            "Cancel"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* Button */],
            {
              type: "button",
              bsStyle: "primary",
              onClick: function onClick() {
                return setFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["L" /* ASKING_INTERNAL_OUTRIGHT */], true);
              }
            },
            "Save"
          )
        ), forceAskIfCancellingTeardown && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["e" /* Form */].Footer,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* Button */],
            { onClick: this.props.close },
            "Cancel"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* Button */],
            {
              type: "button",
              bsStyle: "primary",
              onClick: function onClick() {
                return setFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["M" /* ASKING_EXPECTED_COMPONENTS */], true);
              }
            },
            "Save"
          )
        )].filter(function (f) {
          return f;
        })
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  change: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  getFieldValue: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  getInitialFieldValue: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  queryParts: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  queryPartsByStatus: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  searchInventories: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  modTo: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  editing: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  readOnly: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  part: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({}),
  shopAssistRepairOrder: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({}),
  lineItem: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    final_evaluation_approved_on: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
  }),
  repairOrder: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_6_immutable__["Map"])
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    subrole: state.session.getIn([__WEBPACK_IMPORTED_MODULE_11__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_11__users_constants__["C" /* SUBROLE */]]),
    getFieldValue: function getFieldValue(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["formValueSelector"])(FORM_NAME)(state, field);
    },
    getInitialFieldValue: function getInitialFieldValue(field) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["getFormInitialValues"])(FORM_NAME)(state), field);
    },
    displayShipmentUpdateReminder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__helpers__["b" /* getDisplayShipmentVal */])(FORM_NAME, state)
  };
}, function (dispatch) {
  return {
    queryParts: function queryParts(filter) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__parts_actions_actions__["n" /* searchParts */])(filter));
    },
    queryPartsByStatus: function queryPartsByStatus(filter) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__parts_actions_actions__["r" /* searchPartsByStatus */])(filter));
    },
    searchInventories: function searchInventories(partId, filters) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__parts_actions_actions__["g" /* searchInventories */])(partId, filters));
    },
    setFieldValue: function setFieldValue(field, val) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["change"])(FORM_NAME, field, val));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_9__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_decorators_translateProps__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inventories_components_EditInventory_ConditionWarning__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RMAsAndWarranties_constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ROLineItemsTable__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ExchangeWarning__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__InternalOutrightConsiderationWarning__ = __webpack_require__(1698);
/* harmony export (immutable) */ __webpack_exports__["a"] = ActionFormSection;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return approvalStatuses; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }























var getFieldName = function getFieldName() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  var name = arguments[1];

  if (index !== undefined) {
    return "line_items[" + index + "]." + name;
  }
  return name;
};

function ActionFormSection(_ref) {
  var _WARRANTY_CONSIDERATI;

  var action = _ref.action,
      change = _ref.change,
      exchange = _ref.exchange,
      setField = _ref.setField,
      getField = _ref.getField,
      getInitialFieldValue = _ref.getInitialFieldValue,
      editing = _ref.editing,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$warehouseDirecto = _ref.warehouseDirector,
      warehouseDirector = _ref$warehouseDirecto === undefined ? false : _ref$warehouseDirecto,
      _ref$showEvaluationFi = _ref.showEvaluationFields,
      showEvaluationFields = _ref$showEvaluationFi === undefined ? true : _ref$showEvaluationFi,
      index = _ref.index,
      originalEvalGreaterThanOutrightVal = _ref.originalEvalGreaterThanOutrightVal,
      outrightValue = _ref.outrightValue,
      shopAssistRepairOrder = _ref.shopAssistRepairOrder,
      nested = _ref.nested,
      repairOrder = _ref.repairOrder,
      tierType = _ref.tierType;

  var evalFields = showEvaluationFields && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EvaluationFields, {
    change: change,
    exchange: exchange,
    getField: getField,
    getInitialFieldValue: getInitialFieldValue,
    disabled: disabled,
    warehouseDirector: warehouseDirector,
    index: index,
    outrightValue: outrightValue,
    originalEvalGreaterThanOutrightVal: originalEvalGreaterThanOutrightVal,
    setField: setField,
    tierType: tierType,
    showExceedField: [__WEBPACK_IMPORTED_MODULE_8__constants__["F" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_8__constants__["H" /* OVERHAUL */], __WEBPACK_IMPORTED_MODULE_8__constants__["G" /* BENCH_TEST */]].includes(action)
  });

  if ([__WEBPACK_IMPORTED_MODULE_8__constants__["G" /* BENCH_TEST */], __WEBPACK_IMPORTED_MODULE_8__constants__["z" /* EXPECTED_COMPONENT */], __WEBPACK_IMPORTED_MODULE_8__constants__["H" /* OVERHAUL */], __WEBPACK_IMPORTED_MODULE_8__constants__["F" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_8__constants__["b" /* TEARDOWN */]].includes(action)) {
    return editing || getField(__WEBPACK_IMPORTED_MODULE_8__constants__["E" /* ACTION_REQUESTED */]) === __WEBPACK_IMPORTED_MODULE_8__constants__["z" /* EXPECTED_COMPONENT */] ? evalFields : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
      { key: "original-eval-field" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], {
          name: getFieldName(index, __WEBPACK_IMPORTED_MODULE_8__constants__["_6" /* NOT_TO_EXCEED */]),
          label: "" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_6" /* NOT_TO_EXCEED */]),
          disabled: disabled || getField(getFieldName(index, __WEBPACK_IMPORTED_MODULE_17__SalesOrders_constants__["e" /* FLAT_EXCHANGE */]))
        })
      )
    );
  }

  return (_WARRANTY_CONSIDERATI = {}, _defineProperty(_WARRANTY_CONSIDERATI, __WEBPACK_IMPORTED_MODULE_8__constants__["l" /* WARRANTY_CONSIDERATION */], __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    evalFields,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WarrantyFields, {
      getField: getField,
      index: index,
      editing: editing,
      disabled: disabled || warehouseDirector
    })
  )), _defineProperty(_WARRANTY_CONSIDERATI, __WEBPACK_IMPORTED_MODULE_8__constants__["r" /* SHOP_ASSIST */], __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShopAssistCost, {
      setField: setField,
      getField: getField,
      index: index,
      shopAssistRepairOrder: shopAssistRepairOrder,
      nested: nested,
      repairOrder: repairOrder,
      disabled: disabled || warehouseDirector
    })
  )), _defineProperty(_WARRANTY_CONSIDERATI, __WEBPACK_IMPORTED_MODULE_8__constants__["G" /* BENCH_TEST */], __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null)), _WARRANTY_CONSIDERATI)[action];
}

ActionFormSection.propTypes = {
  action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  exchange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  setField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getInitialFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  shopAssistRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  nested: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  warehouseDirector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  originalEvalGreaterThanOutrightVal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outrightValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  showEvaluationFields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  repairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

var withApprovalStatus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_decorators_translateProps__["a" /* default */])(function (_ref2) {
  var getField = _ref2.getField;
  return {
    approvalStatus: getField(__WEBPACK_IMPORTED_MODULE_8__constants__["s" /* APPROVAL_STATUS */])
  };
});

var evaluationFeeField = function evaluationFeeField(_ref3) {
  var disabled = _ref3.disabled,
      approvalStatus = _ref3.approvalStatus;
  return approvalStatus === __WEBPACK_IMPORTED_MODULE_8__constants__["t" /* REPAIR_EVALUATION_REJECTED */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], {
    name: __WEBPACK_IMPORTED_MODULE_8__constants__["_7" /* EVALUATION_CHARGE */],
    label: "Evaluation Fee",
    disabled: disabled,
    required: true
  });
};

var EvaluationFeeField = withApprovalStatus(evaluationFeeField);

var approvalStatuses = function approvalStatuses(approvalStatus, originalEval, actionRequested) {
  if (approvalStatus === __WEBPACK_IMPORTED_MODULE_8__constants__["_8" /* UNIT_RETURNED_TO_CUSTOMER */]) {
    return __WEBPACK_IMPORTED_MODULE_8__constants__["_9" /* APPROVAL_STATUSES */];
  } else if (approvalStatus === __WEBPACK_IMPORTED_MODULE_8__constants__["K" /* AWAITING_TO_SHIP */]) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_removeKey__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_9" /* APPROVAL_STATUSES */], __WEBPACK_IMPORTED_MODULE_8__constants__["_8" /* UNIT_RETURNED_TO_CUSTOMER */]);
  } else if ([__WEBPACK_IMPORTED_MODULE_8__constants__["z" /* EXPECTED_COMPONENT */], __WEBPACK_IMPORTED_MODULE_8__constants__["_8" /* UNIT_RETURNED_TO_CUSTOMER */]].includes(actionRequested) || approvalStatus === __WEBPACK_IMPORTED_MODULE_8__constants__["_8" /* UNIT_RETURNED_TO_CUSTOMER */]) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_removeKey__["b" /* removeKeys */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_9" /* APPROVAL_STATUSES */], [__WEBPACK_IMPORTED_MODULE_8__constants__["K" /* AWAITING_TO_SHIP */], __WEBPACK_IMPORTED_MODULE_8__constants__["_8" /* UNIT_RETURNED_TO_CUSTOMER */]]);
  } else if (originalEval) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_removeKey__["b" /* removeKeys */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_9" /* APPROVAL_STATUSES */], [__WEBPACK_IMPORTED_MODULE_8__constants__["K" /* AWAITING_TO_SHIP */], __WEBPACK_IMPORTED_MODULE_8__constants__["_8" /* UNIT_RETURNED_TO_CUSTOMER */]]);
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_removeKey__["b" /* removeKeys */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_9" /* APPROVAL_STATUSES */], [__WEBPACK_IMPORTED_MODULE_8__constants__["K" /* AWAITING_TO_SHIP */], __WEBPACK_IMPORTED_MODULE_8__constants__["_8" /* UNIT_RETURNED_TO_CUSTOMER */]]);
};

function EvaluationFields(_ref4) {
  var change = _ref4.change,
      exchange = _ref4.exchange,
      getField = _ref4.getField,
      getInitialFieldValue = _ref4.getInitialFieldValue,
      disabled = _ref4.disabled,
      warehouseDirector = _ref4.warehouseDirector,
      index = _ref4.index,
      outrightValue = _ref4.outrightValue,
      setField = _ref4.setField,
      tierType = _ref4.tierType,
      originalEvalGreaterThanOutrightVal = _ref4.originalEvalGreaterThanOutrightVal,
      showExceedField = _ref4.showExceedField;

  var handleApprovalStatusChange = function handleApprovalStatusChange(event, newValue) {
    if (newValue === __WEBPACK_IMPORTED_MODULE_8__constants__["t" /* REPAIR_EVALUATION_REJECTED */]) {
      change(__WEBPACK_IMPORTED_MODULE_8__constants__["s" /* APPROVAL_STATUS */], __WEBPACK_IMPORTED_MODULE_8__constants__["t" /* REPAIR_EVALUATION_REJECTED */]);
      [__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["M" /* OTHER */]].forEach(function (field) {
        change(field, false);
      });
    }
  };

  var filteredOptions = approvalStatuses(getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["s" /* APPROVAL_STATUS */]), getField(__WEBPACK_IMPORTED_MODULE_8__constants__["I" /* ORIGINAL_EVALUATION */]), getField(__WEBPACK_IMPORTED_MODULE_8__constants__["E" /* ACTION_REQUESTED */]));

  var tagDateRequiredConditions = [__WEBPACK_IMPORTED_MODULE_8__constants__["_10" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_8__constants__["_11" /* INSPECTED */], __WEBPACK_IMPORTED_MODULE_8__constants__["_12" /* REPAIRED */]];
  var hasFlatExchange = getField("inventory.most_recent_sales_order.flat_exchange");

  var changeOriginalEval = function changeOriginalEval(approvalStatus) {
    if (approvalStatus === __WEBPACK_IMPORTED_MODULE_8__constants__["B" /* REPAIR_AWAITING_EVALUATION */]) {
      change(__WEBPACK_IMPORTED_MODULE_8__constants__["I" /* ORIGINAL_EVALUATION */], "0.00");
    }
  };
  var subtotal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["d" /* calculateSubtotal */])(getField);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], {
          name: __WEBPACK_IMPORTED_MODULE_8__constants__["I" /* ORIGINAL_EVALUATION */],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["I" /* ORIGINAL_EVALUATION */]),
          required: [__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* REPAIR_EVALUATION_APPROVED */], __WEBPACK_IMPORTED_MODULE_8__constants__["Q" /* REPAIR_EVALUATION_RECEIVED */]].includes(getField(__WEBPACK_IMPORTED_MODULE_8__constants__["s" /* APPROVAL_STATUS */])),
          disabled: disabled || warehouseDirector,
          onChange: function onChange(_e, val) {
            if (exchange && !getField(__WEBPACK_IMPORTED_MODULE_17__SalesOrders_constants__["e" /* FLAT_EXCHANGE */])) {
              setField(__WEBPACK_IMPORTED_MODULE_8__constants__["_3" /* CORE_RETURN_FEE_SAVINGS */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers__["e" /* coreReturnFeeSavingsVal */])(val, subtotal([__WEBPACK_IMPORTED_MODULE_8__constants__["_0" /* LABOR_COST */], __WEBPACK_IMPORTED_MODULE_8__constants__["_1" /* OUTSIDE_LABOR_COST */], __WEBPACK_IMPORTED_MODULE_8__constants__["_2" /* PART_COST */]], 0)));
            }
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_8__constants__["s" /* APPROVAL_STATUS */],
          component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
          options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["a" /* toOptions */])(filteredOptions),
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_13" /* EVAL_STATUS */]),
          required: true,
          disabled: disabled || warehouseDirector || getField(__WEBPACK_IMPORTED_MODULE_8__constants__["V" /* INTERNAL_OUTRIGHT */]) && !getField(__WEBPACK_IMPORTED_MODULE_8__constants__["_14" /* RECOVERED_REPAIR_FROM_INTERNAL_OUTRIGHT */]) || getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["s" /* APPROVAL_STATUS */]) === __WEBPACK_IMPORTED_MODULE_8__constants__["K" /* AWAITING_TO_SHIP */],
          onChange: function onChange(ev, val) {
            changeOriginalEval(val);
            handleApprovalStatusChange(ev, val);
          }
        })
      ),
      showExceedField && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], {
          name: getFieldName(index, __WEBPACK_IMPORTED_MODULE_8__constants__["_6" /* NOT_TO_EXCEED */]),
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_6" /* NOT_TO_EXCEED */]),
          disabled: disabled || warehouseDirector || hasFlatExchange
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EvaluationFeeField, {
          getField: getField,
          disabled: warehouseDirector
        })
      ),
      originalEvalGreaterThanOutrightVal && getField("inventory.exchange_eval_in_progress") && getField(__WEBPACK_IMPORTED_MODULE_8__constants__["s" /* APPROVAL_STATUS */]) === __WEBPACK_IMPORTED_MODULE_8__constants__["t" /* REPAIR_EVALUATION_REJECTED */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ExchangeWarning__["a" /* default */], null)
      ),
      getField(__WEBPACK_IMPORTED_MODULE_8__constants__["c" /* EXCHANGE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__InternalOutrightConsiderationWarning__["a" /* default */], {
        actionRequested: getField(__WEBPACK_IMPORTED_MODULE_8__constants__["E" /* ACTION_REQUESTED */]),
        condition: getField("inventory." + __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["n" /* CONDITION */]),
        inventoryId: getField("inventory_id"),
        outrightValue: outrightValue,
        originalEval: getField(__WEBPACK_IMPORTED_MODULE_8__constants__["I" /* ORIGINAL_EVALUATION */]),
        partId: getField(__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["q" /* PART_ID */]),
        tierType: tierType
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
      null,
      getField(__WEBPACK_IMPORTED_MODULE_8__constants__["s" /* APPROVAL_STATUS */]) === __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* REPAIR_EVALUATION_APPROVED */] && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: [__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["n" /* CONDITION */]].join("."),
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])([__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["n" /* CONDITION */]].join("_")),
          component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
          options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["r" /* INVENTORIES */].condition),
          disabled: disabled || warehouseDirector,
          required: true
        })
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["r" /* MonthYearField */], {
            name: __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["x" /* TAG_DATE */],
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["x" /* TAG_DATE */]),
            disabled: disabled || warehouseDirector || getField(__WEBPACK_IMPORTED_MODULE_8__constants__["n" /* REPAIR_AND_HOLD */]),
            required: tagDateRequiredConditions.includes(getField([__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["n" /* CONDITION */]].join("."))) && !getField(__WEBPACK_IMPORTED_MODULE_8__constants__["n" /* REPAIR_AND_HOLD */])
          })
        )
      )],
      getField(__WEBPACK_IMPORTED_MODULE_8__constants__["E" /* ACTION_REQUESTED */]) === __WEBPACK_IMPORTED_MODULE_8__constants__["z" /* EXPECTED_COMPONENT */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_8__constants__["U" /* EXPECTED_SERIAL_NUMBER */],
          component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["U" /* EXPECTED_SERIAL_NUMBER */]),
          required: true
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__inventories_components_EditInventory_ConditionWarning__["a" /* default */], {
      inventoryCondition: getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["n" /* CONDITION */]),
      condition: getField(__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["n" /* CONDITION */]),
      canClose: false
    })
  );
}

EvaluationFields.propTypes = {
  change: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  exchange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getInitialFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  warehouseDirector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showExceedField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  outrightValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  originalEvalGreaterThanOutrightVal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tierType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var ShopAssistCost = function (_React$Component) {
  _inherits(ShopAssistCost, _React$Component);

  function ShopAssistCost() {
    var _ref5;

    var _temp, _this, _ret;

    _classCallCheck(this, ShopAssistCost);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref5 = ShopAssistCost.__proto__ || Object.getPrototypeOf(ShopAssistCost)).call.apply(_ref5, [this].concat(args))), _this), _this.state = {
      selectedRO: {},
      lineItems: []
    }, _this.handleROSelected = function (ro) {
      _this.setState({ selectedRO: ro });
      if (ro && ro.id) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__actions__["e" /* getLineItems */])(ro.id).then(function (resp) {
          _this.setState({ lineItems: resp || [] });
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ShopAssistCost, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.shopAssistRepairOrder) {
        this.handleROSelected(this.props.shopAssistRepairOrder);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          selectedRO = _state.selectedRO,
          lineItems = _state.lineItems;
      var _props = this.props,
          setField = _props.setField,
          getField = _props.getField,
          nested = _props.nested,
          index = _props.index,
          disabled = _props.disabled,
          repairOrder = _props.repairOrder;

      var baseName = "shop_assist_repair_order_id";

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
          { key: "ro_search_field" },
          !nested && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            null,
            "Higher Assembly"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: getFieldName(index, baseName),
              label: "RO #",
              placeholder: "Type a Repair Order's code...",
              component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["n" /* AutoCompleteField */],
              search: function search(filter) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__actions__["f" /* searchOpenRO */])(filter, repairOrder && repairOrder.get(__WEBPACK_IMPORTED_MODULE_16__constants__["b" /* ID */]));
              },
              selectedItem: selectedRO,
              formatItem: function formatItem(result) {
                return result && result.code;
              },
              onItemSelected: function onItemSelected(i) {
                return i && _this2.handleROSelected(i);
              },
              disabled: disabled,
              required: true
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
          { key: "part_results" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
            { md: 12 },
            lineItems.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ROLineItemsTable__["a" /* default */], {
              results: lineItems,
              index: index,
              setField: setField,
              getField: getField,
              nested: nested,
              disabled: disabled
            })
          )
        ),
        !nested && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
          { key: "shop_assist_costs" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], {
              name: getFieldName(index, "original_piece_part_cost"),
              label: "Original PP Cost From Eval",
              disabled: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], {
              name: getFieldName(index, "final_piece_part_cost"),
              label: "Final PP Cost",
              disabled: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], {
              name: getFieldName(index, "core_return_cost_savings"),
              label: "Core Return Cost Savings",
              disabled: true
            })
          )
        )
      );
    }
  }]);

  return ShopAssistCost;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ShopAssistCost.propTypes = {
  shopAssistRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  nested: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  repairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

var warrantyRequired = function warrantyRequired(idx, getField) {
  return getField(getFieldName(idx, "customer_rma_id")) && [__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* REPAIR_EVALUATION_APPROVED */], __WEBPACK_IMPORTED_MODULE_8__constants__["t" /* REPAIR_EVALUATION_REJECTED */]].includes(getField(getFieldName(idx, __WEBPACK_IMPORTED_MODULE_8__constants__["s" /* APPROVAL_STATUS */])));
};

var WarrantyFields = function WarrantyFields(_ref6) {
  var index = _ref6.index,
      _ref6$disabled = _ref6.disabled,
      disabled = _ref6$disabled === undefined ? false : _ref6$disabled,
      editing = _ref6.editing,
      getField = _ref6.getField;
  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "row row-col-gutters-half", key: "warranty_1" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 6 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
        name: getFieldName(index, "reason_for_return"),
        component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
        options: __WEBPACK_IMPORTED_MODULE_8__constants__["_15" /* REASONS_FOR_RETURN */],
        label: "Reason For Return",
        disabled: disabled
      })
    ),
    editing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
        name: getFieldName(index, __WEBPACK_IMPORTED_MODULE_14__RMAsAndWarranties_constants__["h" /* WARRANTY_STATUS */]),
        required: warrantyRequired(index, getField),
        component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
        options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_16" /* APPROVE_OR_DENY_OPTIONS */]),
        label: "Warranty",
        disabled: disabled
      })
    ),
    editing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
        name: getFieldName(index, __WEBPACK_IMPORTED_MODULE_8__constants__["_17" /* REPAIR_STATION_WARRANTY_STATUS */]),
        required: warrantyRequired(index, getField),
        component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
        options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_16" /* APPROVE_OR_DENY_OPTIONS */]),
        label: "Repair Station Warranty",
        disabled: disabled
      })
    )
  )];
};

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Orders_shared_ShippingFields__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators_withFieldAccessors__ = __webpack_require__(48);









function ShippingSection(_ref) {
  var formName = _ref.formName,
      hasLocations = _ref.hasLocations,
      lineItem = _ref.lineItem,
      displayShipmentUpdateReminder = _ref.displayShipmentUpdateReminder,
      disabled = _ref.disabled,
      _ref$shippingTypes = _ref.shippingTypes,
      shippingTypes = _ref$shippingTypes === undefined ? [__WEBPACK_IMPORTED_MODULE_5__companies_constants__["p" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_6__shared_components_ShippingSection_shippingTypes__["e" /* DROPSHIP */]] : _ref$shippingTypes,
      _ref$ship_to_fields_r = _ref.ship_to_fields_required,
      shipToFieldsRequired = _ref$ship_to_fields_r === undefined ? true : _ref$ship_to_fields_r;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h5",
      { className: "h4", key: "shipping-form-header" },
      "RETURNING"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "row row-col-gutters-half" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Orders_shared_ShippingFields__["a" /* default */], {
          formName: formName,
          shippingFields: [__WEBPACK_IMPORTED_MODULE_4__constants__["C" /* RETURN_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_4__constants__["_42" /* RETURN_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["_43" /* RETURN_TO_COMPANY_ADDRESS_ID */]],
          shippingTypes: shippingTypes,
          shippingType: __WEBPACK_IMPORTED_MODULE_4__constants__["_39" /* RETURN_TO */],
          shippingMethod: __WEBPACK_IMPORTED_MODULE_4__constants__["_41" /* RETURN_TO_SHIPPING_METHOD */],
          shippingAddressField: __WEBPACK_IMPORTED_MODULE_4__constants__["_44" /* RETURN_TO_SHIPPING_ADDRESS */],
          shipToCompany: lineItem && lineItem.return_to_company,
          ship_to_fields_required: shipToFieldsRequired,
          required: false,
          disabled: disabled,
          locationFieldName: __WEBPACK_IMPORTED_MODULE_4__constants__["_25" /* RETURN_TO_LOCATION_ID */],
          hasLocations: hasLocations
        })
      )
    ),
    displayShipmentUpdateReminder && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components__["n" /* Warning */],
      null,
      "Remember to send customer an email with AWB# and shipment details."
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(ShippingSection));

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CostSection__ = __webpack_require__(1700);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__CostSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ExchangeSection__ = __webpack_require__(1701);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__ExchangeSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExpectedComponentSection__ = __webpack_require__(1702);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__ExpectedComponentSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotesSection__ = __webpack_require__(1703);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__NotesSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShippingSection_ShippingSection__ = __webpack_require__(698);
/* unused harmony reexport ShippingSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ActionRequested_ActionRequestedSection__ = __webpack_require__(1696);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__ActionRequested_ActionRequestedSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PartDetailsSection_PartDetailsSection__ = __webpack_require__(1705);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__PartDetailsSection_PartDetailsSection__["a"]; });















/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cancel__ = __webpack_require__(1712);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Cancel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfirmModal__ = __webpack_require__(1713);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__ConfirmModal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Body__ = __webpack_require__(1711);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__Body__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer__ = __webpack_require__(1714);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header__ = __webpack_require__(1715);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__Header__["a"]; });











/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(28);
/* harmony export (immutable) */ __webpack_exports__["a"] = ReturnRepairItem;







function ReturnRepairItem(_ref) {
  var toggleReturnModal = _ref.toggleReturnModal,
      lineItem = _ref.lineItem;

  if (![__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_65" /* REPAIR_EVALUATION_REJECTED */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */], __WEBPACK_IMPORTED_MODULE_5__constants__["N" /* NO_WORK_PERFORMED */]].includes(lineItem.approval_status) && lineItem.action_requested !== __WEBPACK_IMPORTED_MODULE_5__constants__["r" /* SHOP_ASSIST */]) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: toggleReturnModal },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "undo", fixed: true }),
    lineItem.received ? "Edit Return Details" : "Return Repair Item"
  );
}

ReturnRepairItem.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  toggleReturnModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(1728);
/* harmony export (immutable) */ __webpack_exports__["a"] = ReturnRepairItemModal;





function ReturnRepairItemModal(_ref) {
  var open = _ref.open,
      close = _ref.close,
      lineItem = _ref.lineItem;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-md" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        lineItem.received ? "Edit Return Details" : "Return Repair Item"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], {
      close: close,
      enableReinitialize: true,
      lineItem: lineItem,
      initialValues: lineItem
    })
  );
}

ReturnRepairItemModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip_NoteTooltip__ = __webpack_require__(120);







var StatusNote = function StatusNote(_ref) {
  var lineItem = _ref.lineItem;

  var text = [];

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "inventory.repair_status") === __WEBPACK_IMPORTED_MODULE_3__constants__["n" /* REPAIR_AND_HOLD */]) {
    text.push("Repair & Hold");
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "inventory.status") === __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["V" /* RESERVE_FOR_SALE */]) {
    text.push("Reserved For Sale");
  }

  if (lineItem.customer_rma_requested) {
    text.push("RMA");
  }
  if (text.length === 0) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip_NoteTooltip__["a" /* default */], { note: text.join(", "), icon: "fa-comment" });
};

/* harmony default export */ __webpack_exports__["a"] = (StatusNote);

StatusNote.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StatusNote__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StatusBadges__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_hiddenInputs__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_PartNumber_PartNumber__ = __webpack_require__(283);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Table; });
/* unused harmony export RepairTable */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var hiddenEnhancer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_hiddenInputs__["a" /* default */])({
  HiddenTh: function HiddenTh(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "th",
      props,
      props.children
    );
  },
  HiddenTd: function HiddenTd(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      props,
      props.children
    );
  }
});

var Table = function (_React$Component) {
  _inherits(Table, _React$Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.clickable = __WEBPACK_IMPORTED_MODULE_1_classnames___default()({ clickable: !_this.props.disabled }), _this.renderRow = function (lineItem, i, HiddenTd) {
      var startColumns = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var endColumns = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        {
          key: i,
          className: _this.clickable,
          onClick: function onClick() {
            if (!_this.props.disabled) {
              _this.props.onItemClick(lineItem);
            }
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          i + 1
        ),
        Object.keys(startColumns).map(function (k) {
          var Component = startColumns[k];
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, { lineItem: lineItem })
          );
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_PartNumber_PartNumber__["a" /* default */], {
            part: {
              id: lineItem.part_id,
              part_number: lineItem.part.part_number,
              uuid: lineItem.part.uuid
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.inventory ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
            { to: "/inventories/" + lineItem.inventory.uuid },
            lineItem.original_serial_number || lineItem.serial_number
          ) : lineItem.original_serial_number || lineItem.serial_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          HiddenTd,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_PartNumber_PartNumber__["a" /* default */], { part: lineItem.mod_to })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_5__constants__["J" /* ACTIONS_REQUESTED */][lineItem.action_requested].label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__StatusNote__["a" /* default */], { lineItem: lineItem })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          HiddenTd,
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__StatusBadges__["a" /* default */], { lineItem: lineItem })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            HiddenTd,
            { className: "text-center" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["o" /* LocationFlag */], {
              location: lineItem.return_to_location_id,
              unknownFlag: false
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          HiddenTd,
          { className: "text-success text-center" },
          lineItem.exchange && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__helpers__["b" /* ExchangeIcon */], { lineItem: lineItem })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.work_order_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constants__["p" /* getConditionAbbrev */])(lineItem.condition_sent)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constants__["p" /* getConditionAbbrev */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "inventory.condition"))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["c" /* shortDateYY */])(lineItem.eval_due_date)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["c" /* shortDateYY */])(lineItem.expected_date)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          lineItem.quantity
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          lineItem.received && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "text-muted spacing-right" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["k" /* Icon */], { name: "cloud-download" }),
            " "
          ),
          lineItem.quantity_received
        ),
        Object.keys(endColumns).map(function (k) {
          var Component = endColumns[k];
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-center" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, { lineItem: lineItem })
          );
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          results = _props.results,
          _props$startColumns = _props.startColumns,
          startColumns = _props$startColumns === undefined ? {} : _props$startColumns,
          _props$endColumns = _props.endColumns,
          endColumns = _props$endColumns === undefined ? {} : _props$endColumns;

      var _hiddenEnhancer = hiddenEnhancer(results.some(function (r) {
        return r.action_requested === "shop_assist";
      })),
          HiddenTd = _hiddenEnhancer.HiddenTd,
          HiddenTh = _hiddenEnhancer.HiddenTh;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        RepairTable,
        {
          HiddenTh: HiddenTh,
          startColumns: startColumns,
          endColumns: endColumns
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tbody",
          null,
          results.map(function (r, i) {
            return _this2.renderRow(r, i, HiddenTd, startColumns, endColumns);
          })
        )
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

function RepairTable(_ref2) {
  var children = _ref2.children,
      HiddenTh = _ref2.HiddenTh,
      _ref2$startColumns = _ref2.startColumns,
      startColumns = _ref2$startColumns === undefined ? {} : _ref2$startColumns,
      _ref2$endColumns = _ref2.endColumns,
      endColumns = _ref2$endColumns === undefined ? {} : _ref2$endColumns;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-striped table-hover table-numbered" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        Object.keys(startColumns).map(function (k) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            k
          );
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Part #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Serial #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          HiddenTh,
          null,
          "Mod To"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Action Req."
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          HiddenTh,
          { className: "text-center" },
          "Status"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            HiddenTh,
            { className: "text-center" },
            "Return Store"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          HiddenTh,
          { className: "text-center" },
          "Exch"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "WO #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "CD Sent"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Inv CD"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Eval Due"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-center" },
          "Expected"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "QTY"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Rec."
        ),
        Object.keys(endColumns).map(function (k) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            k
          );
        })
      )
    ),
    children
  );
}

RepairTable.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node)]),
  HiddenTh: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node,
  endColumns: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}),
  startColumns: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({})
};

Table.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  endColumns: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}),
  onItemClick: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  results: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({})),
  startColumns: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({})
};

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getLocationsAndReturnToTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOutrightVal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDisplayShipmentVal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDisableReturnFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isDropshipping; });
/* harmony export (immutable) */ __webpack_exports__["f"] = isDropshippedSales;









var getLocationsAndReturnToTypes = function getLocationsAndReturnToTypes(editing, hasGoneOutright, selectedInventory) {
  var returnToTypes = [__WEBPACK_IMPORTED_MODULE_0__PurchaseOrders_constants__["K" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_0__PurchaseOrders_constants__["L" /* DROPSHIP */], __WEBPACK_IMPORTED_MODULE_0__PurchaseOrders_constants__["d" /* DO_NOT_SHIP */]];
  var hasLocations = true;

  var rmaPath = editing ? "inventory.most_recent_customer_rma" : "most_recent_customer_rma";

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_helpers__["i" /* hasCreditAndWarranty */])(selectedInventory, rmaPath) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_helpers__["j" /* rmaIsClosed */])(selectedInventory, rmaPath) && !hasGoneOutright) {
    returnToTypes = [];
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_helpers__["k" /* hasWarrantyAndNotCredit */])(selectedInventory, rmaPath) && !hasGoneOutright) {
    returnToTypes = [__WEBPACK_IMPORTED_MODULE_0__PurchaseOrders_constants__["K" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_0__PurchaseOrders_constants__["L" /* DROPSHIP */]];
    hasLocations = true;
  }

  return [hasLocations, returnToTypes];
};

var getOutrightVal = function getOutrightVal(getFieldValue) {
  return getFieldValue(__WEBPACK_IMPORTED_MODULE_2__constants__["u" /* EXCHANGE_GONE_OUTRIGHT */]) || getFieldValue(__WEBPACK_IMPORTED_MODULE_2__constants__["V" /* INTERNAL_OUTRIGHT */]);
};

var getDisplayShipmentVal = function getDisplayShipmentVal(state, formName) {
  return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["getFormInitialValues"])(formName)(state), __WEBPACK_IMPORTED_MODULE_2__constants__["W" /* INCOMING_AWB_NUMBER */]) && [__WEBPACK_IMPORTED_MODULE_5__constants__["_41" /* RETURN_TO_SHIPPING_METHOD */], __WEBPACK_IMPORTED_MODULE_5__constants__["C" /* RETURN_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_2__constants__["W" /* INCOMING_AWB_NUMBER */], __WEBPACK_IMPORTED_MODULE_5__constants__["_44" /* RETURN_TO_SHIPPING_ADDRESS */], __WEBPACK_IMPORTED_MODULE_5__constants__["_42" /* RETURN_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_5__constants__["_43" /* RETURN_TO_COMPANY_ADDRESS_ID */]].some(function (f) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["isDirty"])(formName)(state, f);
  });
};

var getDisableReturnFields = function getDisableReturnFields(disabled, getField) {
  var approvalStatus = getField(__WEBPACK_IMPORTED_MODULE_2__constants__["s" /* APPROVAL_STATUS */]);
  var repairAndHold = getField(__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["k" /* REPAIR_AND_HOLD */]);
  var finalEval = getField(__WEBPACK_IMPORTED_MODULE_2__constants__["X" /* FINAL_EVALUATION_APPROVED */]);

  return repairAndHold && !finalEval || disabled || ![__WEBPACK_IMPORTED_MODULE_2__constants__["Q" /* REPAIR_EVALUATION_RECEIVED */], __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* REPAIR_EVALUATION_REJECTED */], __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* REPAIR_EVALUATION_APPROVED */], __WEBPACK_IMPORTED_MODULE_2__constants__["N" /* NO_WORK_PERFORMED */]].includes(approvalStatus) && getField(__WEBPACK_IMPORTED_MODULE_2__constants__["E" /* ACTION_REQUESTED */]) !== __WEBPACK_IMPORTED_MODULE_2__constants__["r" /* SHOP_ASSIST */];
};

var isDropshipping = function isDropshipping(_ref) {
  var getFieldValue = _ref.getFieldValue,
      repairItem = _ref.repairItem,
      getInitialFieldValue = _ref.getInitialFieldValue;

  var returnToType = getFieldValue(__WEBPACK_IMPORTED_MODULE_5__constants__["C" /* RETURN_TO_TYPE */]);

  return __WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingSection_shippingTypes__["a" /* TENANT_LOCATION */] !== returnToType && __WEBPACK_IMPORTED_MODULE_0__PurchaseOrders_constants__["d" /* DO_NOT_SHIP */] !== returnToType && !repairItem.received && hasDropshippedOrder(repairItem) && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_2__constants__["W" /* INCOMING_AWB_NUMBER */])) && !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(getFieldValue(__WEBPACK_IMPORTED_MODULE_2__constants__["W" /* INCOMING_AWB_NUMBER */]));
};

function hasDropshippedOrder(repairItem) {
  return isDropshippedSales(repairItem) || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(repairItem, ["inventory", "most_recent_managed_repair"].join(".")) && !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(repairItem, ["inventory", "most_recent_managed_repair", __WEBPACK_IMPORTED_MODULE_5__constants__["_23" /* SHIPPED */]].join("."));
}

function isDropshippedSales(repairItem) {
  return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(repairItem, ["inventory", "most_recent_sales_order"].join(".")) && !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(repairItem, ["inventory", "most_recent_sales_order", __WEBPACK_IMPORTED_MODULE_5__constants__["_23" /* SHIPPED */]].join("."));
}

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BillingForm__ = __webpack_require__(1751);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditBilling;






function EditBilling(_ref) {
  var open = _ref.open,
      close = _ref.close,
      record = _ref.record;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Repair Order Billing Info"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BillingForm__["a" /* default */], { close: close, initialValues: record.toJS(), enableReinitialize: true })
  );
}

EditBilling.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  record: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])
};

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditCompanyForm__ = __webpack_require__(1752);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditCompanyFields;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function EditCompanyFields(_ref) {
  var open = _ref.open,
      close = _ref.close,
      record = _ref.record;

  var initialValues = _extends({
    company_id: record.getIn(["company", "id"]),
    contact_id: record.getIn(["contact", "id"])
  }, record.toJS());
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Repair Order Details"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__EditCompanyForm__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      record: record,
      enableReinitialize: true
    })
  );
}

EditCompanyFields.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(101);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearForNoCapes; });


var clearForNoCapes = function clearForNoCapes(ev, setFieldValue) {
  var quoteType = ev.target.value;
  if ([__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* NO_CAPES */], __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* AWAITING_REPLY */]].includes(quoteType)) {
    [__WEBPACK_IMPORTED_MODULE_0__constants__["k" /* EVALUATION_FEE */], __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* AVG_OVERHAUL */], __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* AVG_TEST */], __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* AVG_REPAIR */], __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* BER_RATE */], __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* TURNAROUND_TIME */]].forEach(function (f) {
      return setFieldValue([__WEBPACK_IMPORTED_MODULE_0__constants__["m" /* REPAIR_QUOTE_LINE_ITEM */], f].join("."))(null);
    });
  }
};

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(101);
/* harmony export (immutable) */ __webpack_exports__["a"] = LineItemStatusCell;




var quoteStyle = function quoteStyle(lineItem) {
  switch (lineItem.quote_type) {
    case __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* NO_CAPES */]:
      return { borderLeft: "3px solid #f44336" };
    default:
      return {};
  }
};

function LineItemStatusCell(_ref) {
  var lineItem = _ref.lineItem,
      children = _ref.children;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { style: quoteStyle(lineItem) },
    children
  );
}

LineItemStatusCell.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)])
};

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CUSTOM_RANGE; });
var CUSTOM_RANGE = "Custom Range";

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "salesReport",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].reports.sales_report.search,
  initialSettings: {
    sort: "name",
    limit: 10000
  }
}));

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* unused harmony export InStockWarning */
/* unused harmony export StoreLocationWarning */
/* unused harmony export StoreOwnerWarning */
/* unused harmony export allRepairingOrAllInStock */
/* unused harmony export NoPmaNoDerWarning */
/* harmony export (immutable) */ __webpack_exports__["a"] = TraceTypeWarning;
/* harmony export (immutable) */ __webpack_exports__["b"] = WarrantyMinimumWarning;
/* harmony export (immutable) */ __webpack_exports__["e"] = CreditLimitWarning;
/* unused harmony export StrictTraceWarning */
/* harmony export (immutable) */ __webpack_exports__["c"] = BlanketExchangeAgreementWarning;
/* unused harmony export ContingentToPassingWarning */
/* harmony export (immutable) */ __webpack_exports__["d"] = DiscreetWarning;
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }










function InStockWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Sales Order contains parts that are in stock and repairing. Please ensure all items are in the same state in your cart before proceeding."
  );
}

function StoreLocationWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Sales order contains items from different store locations. Please ensure all items in your cart belong to the same store location and owner before proceeding."
  );
}

function StoreOwnerWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Sales order contains items from different store owners. Please ensure all items in your cart belong to the same store location and owner before proceeding."
  );
}

function allRepairingOrAllInStock(inventories) {
  return inventories.every(function (i) {
    return i.repairing;
  }) || inventories.every(function (i) {
    return !i.repairing;
  });
}

function NoPmaNoDerWarning(_ref) {
  var company = _ref.company,
      _ref$inventories = _ref.inventories,
      inventories = _ref$inventories === undefined ? [] : _ref$inventories;

  if ((__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(company, "no_pmas_accepted") || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(company, "no_ders_accepted")) && inventories.some(function (i) {
    return i.pma || i.der;
  })) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
      null,
      "Warning: This Customer does not usually accept PMA/DER Parts."
    );
  }

  return null;
}

NoPmaNoDerWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    no_ders_accepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    no_pmas_accepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  inventories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    der: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }))
};

function TraceTypeWarning(_ref2) {
  var company = _ref2.company,
      inventories = _ref2.inventories;

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(company, "unaccepted_trace_types")) return null;

  if (inventories.some(function (i) {
    return company.unaccepted_trace_types.includes(i.trace_type);
  })) {
    var traceTypes = inventories.map(function (i) {
      return i.trace_type;
    });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
      null,
      "Warning: This customer does not usually accept units with trace types of",
      " ",
      company.unaccepted_trace_types.filter(function (t) {
        return traceTypes.includes(t);
      }).map(function (t) {
        return __WEBPACK_IMPORTED_MODULE_3__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes[t].label;
      }).join(", ")
    );
  }

  return null;
}

TraceTypeWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    unaccepted_trace_types: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
  }),
  inventories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ trace_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string }))
};

function WarrantyMinimumWarning(_ref3) {
  var company = _ref3.company,
      lineItems = _ref3.lineItems;

  if (!company) return null;

  var warranties = lineItems.map(function (l) {
    switch (l.warranty) {
      case "30 days":
        return 30;
      case "6 mos.":
        return 6 * 30;
      case "1 year":
        return 365;
      default:
        return null;
    }
  }).filter(function (l) {
    return l;
  });

  if (warranties.length === 0) return null;

  var lowestWarranty = Math.min.apply(Math, _toConsumableArray(warranties));
  if (Number(company.warranty_minimum) > 0 && lowestWarranty > 0 && lowestWarranty < company.warranty_minimum) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
      null,
      "This Customer does not usually accept units with warranty periods less than ",
      company.warranty_minimum,
      " days."
    );
  }

  return null;
}

WarrantyMinimumWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    warranty_minimum: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  lineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    warranty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }))
};

function CreditLimitWarning(_ref4) {
  var company = _ref4.company,
      lineItems = _ref4.lineItems,
      customerCreditTerm = _ref4.customerCreditTerm;

  if (!company) return null;

  var balance = parseFloat(company.outstanding_balance);
  var creditLimit = parseFloat(company.customer_credit_limit || 0);

  var lineItemBalance = lineItems.reduce(function (acc, l) {
    var val = l.exchange_sale ? parseFloat(l.exchange_fee || 0) : parseInt(l.quantity, 10) * parseFloat(l.price_per_unit || 0);
    return val + acc;
  }, 0);

  if (balance + lineItemBalance > creditLimit && ![__WEBPACK_IMPORTED_MODULE_4__companies_constants__["r" /* CREDIT_CARD */], __WEBPACK_IMPORTED_MODULE_4__companies_constants__["s" /* WIRE_IN_ADVANCE */]].includes(customerCreditTerm)) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
      { warningType: "danger" },
      "Exceeds Credit Limit Notification: This order will put ",
      company.name,
      " ",
      "over their Credit Limit and place the order on Accounting Hold. Continuing with this SO will send an `Exceeds Credit Limit` Notification to Accounting."
    );
  }
  return null;
}

CreditLimitWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    customer_credit_limit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    outstanding_balance: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  lineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape),
  customerCreditTerm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

function StrictTraceWarning(_ref5) {
  var company = _ref5.company,
      inventories = _ref5.inventories;

  var strictTraceRequired = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(company, "imperfect_trace") && inventories.some(function (i) {
    return i.imperfect_trace;
  });
  if (!strictTraceRequired) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Warning: This item is flagged as Imperfect Trace and " + company.name + " has Imperfect Trace\n      Requirements. Please confirm they'll accept or consider quoting another\n      line item (if avail.)"
  );
}

StrictTraceWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    imperfect_trace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  inventories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ imperfect_trace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool }))
};

function BlanketExchangeAgreementWarning(_ref6) {
  var company = _ref6.company,
      exchangeSale = _ref6.exchangeSale;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(company, "blanket_exchange_agreement") && exchangeSale) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
      null,
      "Blanket Exchange Agreement on file. Only create an Exchange Agreement if T&Cs are out of the ordinary for this sale."
    );
  }

  return null;
}

BlanketExchangeAgreementWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    blanket_exchange_agreement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  exchangeSale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function ContingentToPassingWarning(_ref7) {
  var item = _ref7.item;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(item, "contingent_on_passing")) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
      null,
      "Warning: Unless Original Repair Estimate is entered, this sales order will only be allowed to be written up as \u2018Contingent to Passing\u2019."
    );
  }

  return null;
}

ContingentToPassingWarning.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    contingent_on_passing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })
};

function DiscreetWarning(_ref8) {
  var carrier = _ref8.carrier,
      discreet = _ref8.discreet,
      shippingType = _ref8.shippingType;

  if (discreet) return null;
  if (!shippingType && !carrier) return null;
  if (carrier && carrier !== __WEBPACK_IMPORTED_MODULE_6__shared_constants__["d" /* OTHER */]) return null;
  if (shippingType && ![__WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingSection_shippingTypes__["d" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingSection_shippingTypes__["e" /* DROPSHIP */]].includes(shippingType)) return null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Please confirm that this order is NOT meant to ship DISCREET"
  );
}

DiscreetWarning.propTypes = {
  carrier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  discreet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




function RepairAdminChargeV2(_ref) {
  var chargeType = _ref.repair_admin_charge_type.input,
      dollars = _ref.repair_administration_charge_dollars.input,
      percentage = _ref.repair_administration_charge_percentage.input;

  var activeClass = function activeClass(type) {
    return __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn btn-default", {
      active: chargeType.value === type
    });
  };

  var handleChange = function handleChange(newVal) {
    return function () {
      if (newVal === chargeType.value) {
        chargeType.onChange(null);
        percentage.onChange(null);
        dollars.onChange(null);
      } else {
        chargeType.onChange(newVal);
        if (newVal === __WEBPACK_IMPORTED_MODULE_1__constants__["J" /* DOLLARS */]) {
          percentage.onChange(null);
        } else if (newVal === __WEBPACK_IMPORTED_MODULE_1__constants__["H" /* PERCENTAGE */]) {
          dollars.onChange(null);
        }
      }
    };
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group", style: { cursor: "pointer" } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { className: "control-label", htmlFor: "purchase_for" },
      "Repair Administration Charge Type"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        id: "purchase_for",
        className: "btn-group btn-group-justified",
        "data-toggle": "buttons"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activeClass(__WEBPACK_IMPORTED_MODULE_1__constants__["H" /* PERCENTAGE */]),
          onClick: handleChange(__WEBPACK_IMPORTED_MODULE_1__constants__["H" /* PERCENTAGE */]),
          key: __WEBPACK_IMPORTED_MODULE_1__constants__["H" /* PERCENTAGE */]
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0Percentage (%)"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activeClass(__WEBPACK_IMPORTED_MODULE_1__constants__["J" /* DOLLARS */]),
          onClick: handleChange(__WEBPACK_IMPORTED_MODULE_1__constants__["J" /* DOLLARS */]),
          key: __WEBPACK_IMPORTED_MODULE_1__constants__["J" /* DOLLARS */]
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0Dollars ($)"
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (RepairAdminChargeV2);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Form__ = __webpack_require__(1836);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Form__["a"]; });



/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(1869);
/* harmony export (immutable) */ __webpack_exports__["a"] = RmaRequestModal;





function RmaRequestModal(_ref) {
  var lineItem = _ref.lineItem,
      open = _ref.open,
      close = _ref.close;

  var initialValues = {
    outright_value: lineItem && lineItem.outright_value,
    subtotal: lineItem && lineItem.subtotal
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Customer RMA Request"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], {
      close: close,
      lineItem: lineItem,
      initialValues: initialValues,
      enableReinitialize: true
    })
  );
}

RmaRequestModal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RmaRequest__ = __webpack_require__(1870);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__RmaRequest__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RmaRequestModal__ = __webpack_require__(715);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__RmaRequestModal__["a"]; });





/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__users_constants__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["searchSellers"] = searchSellers;



function searchSellers(filter) {
  return function () {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].users.search({
      active: true,
      filter: filter,
      page: 1,
      limit: 6,
      roles: [__WEBPACK_IMPORTED_MODULE_1__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_1__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_1__users_constants__["l" /* REPAIR */]],
      subroles: [__WEBPACK_IMPORTED_MODULE_1__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]],
      permissions: [__WEBPACK_IMPORTED_MODULE_1__users_constants__["k" /* SALES */]]
    }).then(function (resp) {
      return Promise.resolve(resp.data.results);
    });
  };
}

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SellersSection__ = __webpack_require__(1924);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SellersSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validate__ = __webpack_require__(453);
/* unused harmony reexport validate */





/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(32);
/* harmony export (immutable) */ __webpack_exports__["a"] = AdditionalDetails;










function AdditionalDetails(_ref) {
  var _ref$lineItem = _ref.lineItem,
      lineItem = _ref$lineItem === undefined ? {} : _ref$lineItem,
      _ref$showSpecialInstr = _ref.showSpecialInstructions,
      showSpecialInstructions = _ref$showSpecialInstr === undefined ? true : _ref$showSpecialInstr,
      _ref$showDiscreet = _ref.showDiscreet,
      showDiscreet = _ref$showDiscreet === undefined ? true : _ref$showDiscreet,
      disablePicturesRequired = _ref.disablePicturesRequired;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    lineItem && lineItem.action_requested !== __WEBPACK_IMPORTED_MODULE_5__RepairOrders_constants__["b" /* TEARDOWN */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__["a" /* default */],
      null,
      showDiscreet && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
          { justified: true, title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* DISCREET */]) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_8__constants__["b" /* DISCREET */],
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* DISCREET */])
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 5 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
          { title: "Customer to Provide Own P/W" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* CUSTOMER_TO_PROVIDE_OWN_PAPERWORK */],
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
            label: "Customer to Provide Own P/W"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
          { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["c" /* PICTURES_REQUIRED */]) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_8__constants__["c" /* PICTURES_REQUIRED */],
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["c" /* PICTURES_REQUIRED */]),
            disabled: disablePicturesRequired
          })
        )
      )
    ),
    showSpecialInstructions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_8__constants__["d" /* SPECIAL_INSTRUCTIONS */],
          component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["l" /* TextArea */],
          label: "Special Instructions (For shipping team)",
          rows: "5",
          cols: "50"
        })
      )
    )
  );
}

AdditionalDetails.propTypes = {
  disablePicturesRequired: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  showDiscreet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showSpecialInstructions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DROPSHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REPAIR_STATION; });
/* unused harmony export SHIPPING_TYPES */
/* unused harmony export shipToOptions */
var CUSTOMER = "customer";
var COMPANY = "company";
var DROPSHIP = "dropship";
var REPAIR_STATION = "repair_station";

var SHIPPING_TYPES = [CUSTOMER, COMPANY, DROPSHIP, REPAIR_STATION];

var shipToOptions = [{
  text: "Customer Physical Address",
  value: CUSTOMER
}, {
  text: "Company",
  value: COMPANY
}, {
  text: "Other",
  value: DROPSHIP
}];

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CustomerSection__ = __webpack_require__(451);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__CustomerSection__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SellersSection__ = __webpack_require__(718);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__SellersSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShippingSection__ = __webpack_require__(328);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__ShippingSection__["a"]; });







/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony export (immutable) */ __webpack_exports__["a"] = ConditionWarning;



function ConditionWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Heads Up! - The condition of this item has been changed from its original condition. Are you sure you want to continue?"
  );
}

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Receiving_components_shared_FormSections_validate__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(87);







/* harmony default export */ __webpack_exports__["a"] = (function (values, props) {
  if (values.picking) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function () {
      return null;
    });
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    if (!props.shippingRecord.received_virtually) {
      form.validate(__WEBPACK_IMPORTED_MODULE_4__parts_constants__["j" /* WEIGHT */], __WEBPACK_IMPORTED_MODULE_4__parts_constants__["l" /* LENGTH */], __WEBPACK_IMPORTED_MODULE_4__parts_constants__["k" /* WIDTH */], __WEBPACK_IMPORTED_MODULE_4__parts_constants__["m" /* HEIGHT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);

      if (values.ship_multiple_item_ids && values.ship_multiple_item_ids.length === 1) {
        form.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      } else if (!values.ship_multiple_item_ids) {
        form.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      }
    }

    form.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["g" /* OUTGOING_AWB_NUMBER */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    form.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["m" /* CONTACT_EMAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["b" /* isValidEmail */]);
    form.validateChildren(__WEBPACK_IMPORTED_MODULE_3__constants__["k" /* ATTACHMENTS */], __WEBPACK_IMPORTED_MODULE_2__Receiving_components_shared_FormSections_validate__["a" /* default */]);

    if (props.isIto) return;
    form.validateChild(__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* SHIPPING_METHOD */], function (method) {
      method.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* CARRIER */], __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* SHIPPING_METHOD */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    });
  });
});

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPGRADE_CHECK; });
var UPGRADE_CHECK = "upgrade/UPGRADE_CHECK";

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cable__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(724);
/* harmony export (immutable) */ __webpack_exports__["a"] = checkForUpgrade;
/* harmony export (immutable) */ __webpack_exports__["b"] = subscribe;





var RELEASE_ID = "";

function checkForUpgrade(releaseId) {
  return function (dispatch) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* UPGRADE_CHECK */],
      upgradeAvailable: releaseId && releaseId !== RELEASE_ID && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(RELEASE_ID)
    });
  };
}

function subscribe() {
  __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].session.tenant().then(function (response) {
    RELEASE_ID = response.headers["x-release-id"];
  });
  return function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cable__["b" /* createChannel */])().listen("UpgradeChannel", {
      onReceive: function onReceive(data) {
        dispatch({
          type: __WEBPACK_IMPORTED_MODULE_3__actionTypes__["a" /* UPGRADE_CHECK */],
          upgradeAvailable: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(RELEASE_ID) && data.release_id && data.release_id !== RELEASE_ID
        });
      }
    });
  };
}

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_pagination__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_pagination__["a" /* createPaginatedList */])({
  listId: "vendorRmas",
  fetch: __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].vendorRmas.search
}));

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
/* unused harmony export CREATE_SHIPPING_METHOD */
/* unused harmony export FETCH_SHIPPING_METHODS */
/* unused harmony export UPDATE_SHIPPING_METHOD */
/* unused harmony export DELETE_SHIPPING_METHOD */
/* unused harmony export CREATE_PHYSICAL_ADDRESS */
/* unused harmony export FETCH_PHYSICAL_ADDRESSES */
/* unused harmony export UPDATE_PHYSICAL_ADDRESS */
/* unused harmony export DELETE_PHYSICAL_ADDRESS */
var SET = "companies/SET";
var CREATE_SHIPPING_METHOD = "companies/CREATE_SHIPPING_METHOD";
var FETCH_SHIPPING_METHODS = "companies/FETCH_SHIPPING_METHODS";
var UPDATE_SHIPPING_METHOD = "companies/UPDATE_SHIPPING_METHOD";
var DELETE_SHIPPING_METHOD = "companies/DELETE_SHIPPING_METHOD";
var CREATE_PHYSICAL_ADDRESS = "companies/CREATE_PHYSICAL_ADDRESS";
var FETCH_PHYSICAL_ADDRESSES = "companies/FETCH_PHYSICAL_ADDRESSES";
var UPDATE_PHYSICAL_ADDRESS = "companies/UPDATE_PHYSICAL_ADDRESS";
var DELETE_PHYSICAL_ADDRESS = "companies/DELETE_PHYSICAL_ADDRESS";

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;



function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate("name", "email").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    v.validate("email").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["b" /* isValidEmail */]);
  });
}

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;



function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate("line1", "city", "state", "postal_code", "country").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;



function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate("shipping_method", "carrier").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["a"] = Status;
var _statusInfo;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var statusInfo = (_statusInfo = {}, _defineProperty(_statusInfo, __WEBPACK_IMPORTED_MODULE_2__constants__["m" /* PENDING */], {
  css: "label-warning",
  icon: "fa-warning",
  text: "Repair Station Pending"
}), _defineProperty(_statusInfo, __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* APPROVED */], {
  css: "label-success",
  icon: "fa-check",
  text: "Repair Station Approved"
}), _defineProperty(_statusInfo, __WEBPACK_IMPORTED_MODULE_2__constants__["n" /* DENIED */], {
  css: "label-danger",
  icon: "fa-times",
  text: "Repair Station Denied"
}), _defineProperty(_statusInfo, __WEBPACK_IMPORTED_MODULE_2__constants__["o" /* MANAGER_CONSENT_NEEDED */], {
  css: "label-warning",
  icon: "fa-check",
  text: "Mgmt. Consent Needed"
}), _statusInfo);

function Status(_ref) {
  var status = _ref.status;

  var info = statusInfo[status];
  if (!info) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null);
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label " + info.css },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa " + info.icon }),
    "\xA0\xA0",
    info.text
  );
}

Status.propTypes = {
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(__WEBPACK_IMPORTED_MODULE_2__constants__["h" /* APPROVAL_STATUSES */])).isRequired
};

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["a"] = Status;
var _statusInfo;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var statusInfo = (_statusInfo = {}, _defineProperty(_statusInfo, __WEBPACK_IMPORTED_MODULE_2__constants__["m" /* PENDING */], {
  css: "label-warning",
  icon: "fa-warning",
  text: "Vendor Pending"
}), _defineProperty(_statusInfo, __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* APPROVED */], {
  css: "label-success",
  icon: "fa-check",
  text: "Vendor Approved"
}), _defineProperty(_statusInfo, __WEBPACK_IMPORTED_MODULE_2__constants__["n" /* DENIED */], {
  css: "label-danger",
  icon: "fa-times",
  text: "Vendor Denied"
}), _statusInfo);

function Status(_ref) {
  var status = _ref.status;

  var info = statusInfo[status];
  if (!info) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null);
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label " + info.css },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa " + info.icon }),
    "\xA0\xA0",
    info.text
  );
}

Status.propTypes = {
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(__WEBPACK_IMPORTED_MODULE_2__constants__["h" /* APPROVAL_STATUSES */])).isRequired
};

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(2033);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Detail__ = __webpack_require__(2014);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Detail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateCompany__ = __webpack_require__(1956);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__CreateCompany__["a"]; });







/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["a"] = PaymentTerms;
/* unused harmony export PaymentTermsField */








function PaymentTerms(_ref) {
  var paymentTerms = _ref.paymentTerms;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])(paymentTerms)
  );
}

PaymentTerms.propTypes = {
  paymentTerms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

function PaymentTermsField(_ref2) {
  var fieldName = _ref2.fieldName,
      label = _ref2.label;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
    name: fieldName,
    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
    label: label,
    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_6__constants__["i" /* VENDOR_TERMS */])
  });
}

PaymentTermsField.propTypes = {
  fieldName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Detail_Header_DropdownActions__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Detail_Header_DropdownActions_Action__ = __webpack_require__(739);
/* harmony export (immutable) */ __webpack_exports__["a"] = Controls;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function Controls(_ref) {
  var inventory = _ref.inventory;

  var config = {
    applyLotCost: __WEBPACK_IMPORTED_MODULE_4__Detail_Header_DropdownActions__["a" /* Config */].applyLotCost,
    reserveForSale: __WEBPACK_IMPORTED_MODULE_4__Detail_Header_DropdownActions__["a" /* Config */].reserveForSale,
    reserveForRepair: __WEBPACK_IMPORTED_MODULE_4__Detail_Header_DropdownActions__["a" /* Config */].reserveForRepair,
    transfer: _extends({}, __WEBPACK_IMPORTED_MODULE_4__Detail_Header_DropdownActions__["a" /* Config */].transfer),
    cancelTransfer: _extends({}, __WEBPACK_IMPORTED_MODULE_4__Detail_Header_DropdownActions__["a" /* Config */].cancelTransfer),
    cancelModTo: _extends({}, __WEBPACK_IMPORTED_MODULE_4__Detail_Header_DropdownActions__["a" /* Config */].cancelModTo),
    deleteInventory: __WEBPACK_IMPORTED_MODULE_4__Detail_Header_DropdownActions__["a" /* Config */].deleteInventory
  };

  var rows = Object.keys(config).map(function (key) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Detail_Header_DropdownActions_Action__["a" /* default */], {
      inventory: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(inventory),
      config: config[key],
      key: "full-view-" + inventory.id + "-" + key
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__["b" /* default */],
      { icon: "fa fa-fw fa-ellipsis-v", menuClass: "dropdown-menu-right" },
      rows
    )
  );
}

Controls.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    reserve_for_seller_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    store_location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired
};

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_time__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(86);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var displayCostAdjLabel = function displayCostAdjLabel(costAdj) {
  var label = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_6__constants__["_77" /* COST_ADJUSTMENT_OPTIONS */], costAdj.adjustment_type + ".label");
  if (typeof label === "function") {
    return label(costAdj.subtype);
  }
  return label;
};

var CostAdjustmentTable = function (_Component) {
  _inherits(CostAdjustmentTable, _Component);

  function CostAdjustmentTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CostAdjustmentTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CostAdjustmentTable.__proto__ || Object.getPrototypeOf(CostAdjustmentTable)).call.apply(_ref, [this].concat(args))), _this), _this.canDelete = function (costAdj) {
      return costAdj.adjustment_type === "neg_depreciation" && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(_this.props.inventory, __WEBPACK_IMPORTED_MODULE_6__constants__["_79" /* SCRAP_REPORT */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_time__["e" /* isLessThan24HoursAgo */])(costAdj.created_at) && __WEBPACK_IMPORTED_MODULE_6__constants__["_80" /* CANCELLABLE_COST_ADJUSTMENTS */].includes(costAdj.adjustment_type);
    }, _this.renderRow = function (r, idx) {
      var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ "text-muted": r.cancelled });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: idx, className: classes },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["b" /* shortDate */])(r.created_at)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.created_by && r.created_by.full_name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          displayCostAdjLabel(r)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__["a" /* dollars */])(r.adjustment)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components__["b" /* Authorized */],
          { roles: [__WEBPACK_IMPORTED_MODULE_8__users_constants__["p" /* QUALITY_CONTROL */]], subroles: [__WEBPACK_IMPORTED_MODULE_8__users_constants__["_2" /* ACCOUNTING_MANAGER */]] },
          _this.canDelete(r) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["Z" /* Delete */], {
            deleteAction: __WEBPACK_IMPORTED_MODULE_10__actions__["x" /* cancelCostAdjustment */],
            id: r.id,
            primary: r.cancelled
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CostAdjustmentTable, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "table",
          { className: "table table-striped table-hover" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Date Created"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Adjusted By"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Adjustment Type"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "Cost Adjustment"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components__["b" /* Authorized */],
                { roles: [__WEBPACK_IMPORTED_MODULE_8__users_constants__["p" /* QUALITY_CONTROL */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tbody",
            null,
            this.props.costAdjustments.map(this.renderRow)
          )
        )
      );
    }
  }]);

  return CostAdjustmentTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CostAdjustmentTable.propTypes = {
  costAdjustments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)).isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};
/* harmony default export */ __webpack_exports__["a"] = (CostAdjustmentTable);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_CommercialInvoice_Form__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_CommercialInvoice_Form_FormSections_LineItemsForm__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_countries__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_pojos__ = __webpack_require__(56);
/* harmony export (immutable) */ __webpack_exports__["a"] = CreateCommercialInvoice;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }













function CreateCommercialInvoice(_ref) {
  var editing = _ref.editing,
      close = _ref.close,
      inventory = _ref.inventory;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      lineItemsForm = _useState2[0],
      setLineItemsForm = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState4 = _slicedToArray(_useState3, 2),
      commercialInvoiceForm = _useState4[0],
      setCommercialInvoiceForm = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState6 = _slicedToArray(_useState5, 2),
      lineItems = _useState6[0],
      setLineItems = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isLoading = _useState8[0],
      setIsLoading = _useState8[1];

  var getLineItems = function getLineItems() {
    setIsLoading(true);
    var inv = inventory.toJS();

    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].inventories.search({
      store_location_id: inv.store_location_id,
      transfer_to_location_id: inv.transfer_to_location_id,
      limit: 100
    }).then(function (resp) {
      var results = resp.data.results;
      if (results.length > 1) {
        setLineItems(results);
        setLineItemsForm(true);
      } else {
        setLineItems(results);
        setCommercialInvoiceForm(true);
      }
      setIsLoading(false);
    });
  };

  var addLineItems = function addLineItems(selectedLineItems) {
    setLineItems([].concat(_toConsumableArray(selectedLineItems)));
    setCommercialInvoiceForm(true);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Create Commercial Invoice"
      )
    ),
    commercialInvoiceForm && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_CommercialInvoice_Form__["a" /* default */], {
      close: close,
      initialValues: initialValues(inventory.toJS(), lineItems),
      selectedLineItems: lineItems,
      hazmat: inventory.getIn(["part", "hazmat"]),
      enableReinitialize: true
    }),
    lineItemsForm && !commercialInvoiceForm && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_CommercialInvoice_Form_FormSections_LineItemsForm__["a" /* default */], {
      close: close,
      addLineItems: addLineItems,
      lineItems: lineItems,
      enableReinitialize: true
    }),
    !commercialInvoiceForm && !lineItemsForm && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: "btn btn-default",
          onClick: function onClick() {
            return close();
          }
        },
        "Cancel"
      ),
      " ",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: "btn btn-success",
          onClick: getLineItems
        },
        isLoading ? "...Loading" : "Yes"
      )
    )
  );
}

CreateCommercialInvoice.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

function getEin(item) {
  var location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__hooks_useCurrentUser__["a" /* default */])().locations.find(function (l) {
    return l.id === item.store_location_id;
  });
  if (location) {
    return location.tax_id_number;
  }

  return "";
}

function getAddress(item) {
  var location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__hooks_useCurrentUser__["a" /* default */])().locations.find(function (l) {
    return l.id === item.store_location_id;
  });

  if (location) {
    var line1 = location.line1,
        line2 = location.line2,
        city = location.city,
        state = location.state,
        country = location.country,
        phone = location.phone,
        postal_code = location.postal_code;


    return {
      company_name: location.entity_name,
      line1: line1,
      line2: line2,
      city: city,
      state: state,
      country: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_countries__["b" /* countryCode */])(country),
      phone: phone,
      postal_code: postal_code
    };
  }

  return null;
}

function initialValues(inventory, lineItems) {
  return {
    cargo_screening_consent: true,
    inventory_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(inventory, "id"),
    ein: getEin(inventory),
    hazmat: lineItems.some(function (i) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(i, "part.hazmat");
    }),
    ultimate_consignee_address: getAddress(inventory),
    weight_unit: "lb",
    line_items: lineItems && lineItems.map(function (item) {
      return _extends({
        condition: item.condition,
        inventory_id: item.id,
        part_id: item.part.id,
        price: item.cost_per_unit,
        quantity: item.quantity,
        serial_number: item.serial_number,
        weight_unit: item.part.net_weight_unit || "lb",
        weight: item.part.net_weight,
        weight_oz: item.part.net_weight_oz
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_pojos__["a" /* default */])(item.part).pick(__WEBPACK_IMPORTED_MODULE_8__parts_constants__["g" /* COUNTRY_OF_MFG */], __WEBPACK_IMPORTED_MODULE_8__parts_constants__["u" /* DESCRIPTION */], __WEBPACK_IMPORTED_MODULE_8__parts_constants__["w" /* PART_NUMBER */], __WEBPACK_IMPORTED_MODULE_8__parts_constants__["K" /* EUROPEAN_COMMERCE_CONTROL_NUMBER */]));
    })
  };
}

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__validate__ = __webpack_require__(2048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(274);














function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_10__constants__["j" /* QUANTITY */],
            label: "QTY",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["h" /* NumberInput */],
            roundDigits: 0,
            inputProps: { min: 0 },
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_7__constants__["n" /* CONDITION */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__constants__["a" /* CONDITION_TYPES */]),
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["n" /* CONDITION */]),
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            label: "SRP",
            name: __WEBPACK_IMPORTED_MODULE_7__constants__["v" /* SUGGESTED_RETAIL */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["h" /* NumberInput */],
            roundDigits: 0,
            inputProps: { min: 0 },
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_9__shared_constants__["e" /* NOTE */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["l" /* TextArea */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_9__shared_constants__["e" /* NOTE */]),
            rows: "5"
          })
        )
      )
    )
  );
}

Form.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(ownProps.submitAction(data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: "dummyInventory",
  validate: __WEBPACK_IMPORTED_MODULE_11__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6____ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CreateInventoryShipment_CreateInventoryShipmentModal__ = __webpack_require__(2060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ApplyLotCost_ApplyLotCost__ = __webpack_require__(2049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Print_Print__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AssignToExchange_AssignToExchange__ = __webpack_require__(2051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RequestScrapAtShop_RequestScrapAtShop__ = __webpack_require__(2074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ReturnToCustomer_ReturnToCustomer__ = __webpack_require__(2078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DownloadScrapReport_DownloadScrapReportModal__ = __webpack_require__(2067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__UpdateSrpStatus_UpdateSrpStatus__ = __webpack_require__(2096);
var _customModal;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


















var customModal = (_customModal = {}, _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_3" /* APPLY_LOT_COST */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ApplyLotCost_ApplyLotCost__["a" /* default */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_4" /* ASSIGN_EXCHANGE */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__AssignToExchange_AssignToExchange__["a" /* default */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_5" /* CANCEL_CONSIGNMENT */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["b" /* CancelConsignment */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_6" /* DOWNLOAD_SCRAP_CERT */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__DownloadScrapReport_DownloadScrapReportModal__["a" /* default */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_7" /* RESERVE_INV_FOR_SALE */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["c" /* EditReserveForSeller */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_8" /* RESERVE_INV_FOR_REPAIR */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["d" /* ReserveForRepair */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_9" /* RETURN_TO_CUSTOMER */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CreateInventoryShipment_CreateInventoryShipmentModal__["a" /* default */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_10" /* RETURN_TO_CUSTOMER_V2 */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ReturnToCustomer_ReturnToCustomer__["a" /* default */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_11" /* UPDATE_QC_STATUS */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["e" /* UpdateQCStatus */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_12" /* UPDATE_SRP */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__UpdateSrpStatus_UpdateSrpStatus__["a" /* default */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_13" /* CREATE_DUMMY_RECORD */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["f" /* CreateDummy */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_14" /* REQUEST_SCRAP_AT_SHOP */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RequestScrapAtShop_RequestScrapAtShop__["a" /* RequestScrapAtShop */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_15" /* SCRAP_REPORT_RECEIVED */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["g" /* ScrapReportReceived */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_16" /* SPLIT_INVENTORY */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["h" /* SplitInventory */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_17" /* CREATE_VENDOR_RMA */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["i" /* CreateVendorRma */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_18" /* TRANSFER_INVENTORY */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["j" /* Transfer */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_19" /* CREATE_COMMERCIAL_INVOICE */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["k" /* CreateCommercialInvoice */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_20" /* PRINT */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Print_Print__["a" /* default */], props);
}), _defineProperty(_customModal, __WEBPACK_IMPORTED_MODULE_5__constants__["_21" /* UNDO_SCRAP */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["l" /* UndoScrap */], props);
}), _customModal);

var Modal = function Modal(props) {
  var _props$config = props.config,
      iconName = _props$config.iconName,
      key = _props$config.key,
      text = _props$config.text,
      confirmText = _props$config.confirmText,
      action = _props$config.action,
      btnClass = _props$config.btnClass,
      cancelText = _props$config.cancelText;

  if (Object.keys(customModal).includes(key)) {
    return customModal[key](props);
  }

  var editing = props.editing,
      close = props.close,
      dispatch = props.dispatch;

  var sendAction = function sendAction() {
    return dispatch(action(props.inventory.toJS()));
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components__["i" /* ConfirmAction */],
    {
      onConfirm: sendAction,
      key: "confirm" + key,
      close: close,
      btnClass: btnClass,
      cancelText: cancelText,
      open: editing,
      icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: iconName, fixed: true }),
      btnText: confirmText
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "strong",
      null,
      "Heads up!"
    ),
    "\xA0",
    text
  );
};

Modal.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    toJS: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  }),
  config: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    key: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    dropDownText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    iconName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  })
};

var Action = function Action(props) {
  var open = props.open,
      _props$config2 = props.config,
      iconName = _props$config2.iconName,
      dropDownText = _props$config2.dropDownText;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components__["l" /* DropDownItem */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: iconName, fixed: true }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "edit-button-padding" },
      dropDownText
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Modal, props)
  );
};

Action.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  config: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    key: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    dropDownText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    iconName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  })
};

var satisfiesRules = function satisfiesRules(record, currentUser) {
  return function (rules) {
    return rules.every(function (rule) {
      return rule(record, currentUser);
    });
  };
};

var withRules = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["a" /* renderIf */])(function (_ref) {
  var _ref$config = _ref.config,
      rules = _ref$config.rules,
      _ref$config$authorize = _ref$config.authorized,
      authorized = _ref$config$authorize === undefined ? function () {
    return true;
  } : _ref$config$authorize,
      inventory = _ref.inventory,
      currentUser = _ref.currentUser;
  return satisfiesRules(inventory.toJS(), currentUser.toJS())(rules) && authorized(currentUser.toJS(), inventory.toJS());
});

var actionWithRules = withRules(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["e" /* toggleSwitch */])("editing")(Action));

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_9__users_constants__["a" /* USER */])
  };
})(actionWithRules));

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(2072);
/* harmony export (immutable) */ __webpack_exports__["a"] = PrintInventory;





function PrintInventory(_ref) {
  var close = _ref.close,
      editing = _ref.editing,
      inventory = _ref.inventory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Inventory Label"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close, inventory: inventory.toJS(), enableReinitialize: true })
  );
}

PrintInventory.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(12);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayFields; });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var displayFields = _defineProperty({
  serial_number: {
    label: "Serial #",
    type: "text"
  },
  display_condition: {
    label: "Condition",
    type: "text"
  },
  purchase_order_code: {
    label: "PO #",
    type: "text"
  },
  tag_date: {
    label: "Tag Date",
    type: "month"
  },
  suggested_retail: {
    label: "SRP",
    type: "number"
  },
  exchange_srp: {
    label: "Exchange SRP",
    type: "number"
  },
  srp_condition: {
    label: "SRP Condition",
    type: "text"
  }
}, __WEBPACK_IMPORTED_MODULE_0__constants__["_55" /* SRP_REASON_CHANGED */], {
  label: "SRP Reason Changed",
  type: "select"
});

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);





function RecentOrderRow(_ref) {
  var record = _ref.record,
      type = _ref.type,
      title = _ref.title,
      rootLink = _ref.rootLink;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "th",
      { className: "text-right" },
      title
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
        { to: "/" + rootLink + "/" + (record[type].uuid || record[type].id) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          record[type].code
        )
      )
    )
  );
}

RecentOrderRow.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  rootLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var record = _ref2.record,
      type = _ref2.type;
  return record[type];
})(RecentOrderRow));

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony export (immutable) */ __webpack_exports__["a"] = ConditionWarning;





function ConditionWarning(_ref) {
  var inventoryCondition = _ref.inventoryCondition,
      condition = _ref.condition,
      _ref$canClose = _ref.canClose,
      canClose = _ref$canClose === undefined ? true : _ref$canClose;

  if (inventoryCondition === __WEBPACK_IMPORTED_MODULE_2__constants__["_52" /* SCRAP */] || condition !== __WEBPACK_IMPORTED_MODULE_2__constants__["_52" /* SCRAP */]) {
    return false;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "alert alert-warning margin-bottom-none" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "media" },
      canClose && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "media-left" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-warning text-warning" }),
        "x"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "media-body" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "strong",
          null,
          "Warning!"
        ),
        " Changing the condition to Scrap will reduce the inventory's cost to $0.00"
      )
    )
  );
}

ConditionWarning.propTypes = {
  inventoryCondition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  condition: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["stringInput"]).isRequired,
  canClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
var SET = "parts/SET";

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);









var formName = "importPartsCSV";

function ImportPartsForm(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components__["n" /* Warning */],
          null,
          "Please use the following column headers for the Parts CSV import:",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "part_number"
          ),
          " (required field: unique identifier for the part. If the exact part number already exists, it will not be imported).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "desc"
          ),
          " (optional field: description).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "mfg"
          ),
          " (optional field: manufacturer).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "application"
          ),
          " (optional field: system will auto-recognize and apply the appropriate Application Type [Engine, Aircraft, or APU]).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "LLP"
          ),
          " (optional field: Life-Limited Part [Yes/No]).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "cage"
          ),
          " (optional field: CAGE code).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "eccn"
          ),
          " (optional field: Export Control Classification Number).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "nsn"
          ),
          " (optional field: National Stock Number).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "list_price"
          ),
          " (optional field: Manufacturer's List Price).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "date_of_price"
          ),
          " (optional field: Date of Price).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "country_of_mfg"
          ),
          " (optional field: Country of Manufacturing).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "haz_mat"
          ),
          " (optional field: Hazardous Material [Yes/No]).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "part_type"
          ),
          " (optional field: Rotable, Expendable, or Tooling).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          "Ensure the import file is in .csv format."
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "file",
            component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["k" /* FileInput */],
            label: "Upload CSV File",
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 8, mdOffset: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            {
              href: "https://info-trader-assets.s3.us-east-2.amazonaws.com/public/InfoTrader_Standard_Import_Parts.csv",
              target: "_blank",
              rel: "noopener noreferrer"
            },
            "Template"
          )
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["p" /* importParts */])(data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["j" /* form */])({
  form: formName
})(ImportPartsForm)));

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_PartTypes_PartTypes__ = __webpack_require__(2378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TotalTimeFields__ = __webpack_require__(2132);
/* unused harmony export Warnings */
/* harmony export (immutable) */ __webpack_exports__["a"] = WarningList;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
















function Warnings(_ref) {
  var formName = _ref.formName,
      hazmat = _ref.hazmat,
      bio = _ref.bio_hazmat,
      llp = _ref.llp,
      pass_fail = _ref.pass_fail,
      military = _ref.military;

  var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__hooks__["a" /* useCurrentUser */])();
  var disableIfWarehouseDirector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__users_helpers__["f" /* disableIfHasAnyOfSubroles */])(user, [__WEBPACK_IMPORTED_MODULE_5__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]);
  var disableIfWhManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__users_helpers__["f" /* disableIfHasAnyOfSubroles */])(user, [__WEBPACK_IMPORTED_MODULE_5__users_constants__["t" /* WAREHOUSE_EXPERT */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["s" /* WAREHOUSE_MANAGER */]]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
          {
            title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["h" /* HAZMAT */]),
            justified: true,
            info: "A hazardous material note will be added to outgoing quote and sales order confirmation emails. Notifies receiving dept."
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */], {
            input: hazmat.input,
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["h" /* HAZMAT */]),
            icon: "fa-warning",
            disabled: disableIfWhManager
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
          {
            title: "Bio-Hazmat",
            justified: true,
            info: "A hazardous material note will be added to outgoing quote and sales order confirmation emails.  POs will recommend shipping AR condition direct to the repair station.  Notifies receiving dept."
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */], {
            input: bio.input,
            label: "Bio-Hazmat",
            icon: "fa-flask",
            disabled: disableIfWhManager
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
          {
            title: "Pass/Fail Item",
            justified: true,
            id: "warnings",
            info: "Disallows exchange outgoing quotes, exchange sales orders and exchange SRPs on POs and inventory. Removes exchange fee from outgoing quote email. Defaults inventory warranty period to 30 days for SV or OH condition."
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */], {
            input: pass_fail.input,
            label: "Pass / Fail",
            icon: "fa-graduation-cap",
            disabled: disableIfWhManager || disableIfWarehouseDirector
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 2 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
          {
            title: __WEBPACK_IMPORTED_MODULE_8__constants__["D" /* LLP */].toUpperCase(),
            justified: true,
            id: "warnings",
            info: "For POs, manager approval required if less than 40% life remaining."
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */], { input: llp.input, label: __WEBPACK_IMPORTED_MODULE_8__constants__["D" /* LLP */].toUpperCase(), icon: "fa-gear" })
        )
      ),
      llp.input.value && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__TotalTimeFields__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
            {
              title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_12" /* SHELF_LIFE */]),
              info: "If tagged, will require expiration date to be entered upon receiving. Notifies receiving dept."
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_8__constants__["_12" /* SHELF_LIFE */],
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_12" /* SHELF_LIFE */])
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
          { title: __WEBPACK_IMPORTED_MODULE_8__constants__["R" /* MILITARY */].toUpperCase(), justified: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */], {
            input: military.input,
            label: __WEBPACK_IMPORTED_MODULE_8__constants__["R" /* MILITARY */].toUpperCase(),
            icon: "fa-fighter-jet"
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 2 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
            {
              title: "Export",
              info: "Places any sale on hold for export compliance review."
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_8__constants__["_13" /* EXPORT_COMPLIANCE */],
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
              label: "Export"
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_PartTypes_PartTypes__["a" /* default */], { formName: formName })
      )
    )
  );
}

var Warning = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  input: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormTypes__["boolInput"].isRequired
});

Warnings.propTypes = {
  hazmat: Warning.isRequired,
  bio_hazmat: Warning.isRequired,
  llp: Warning.isRequired,
  pass_fail: Warning.isRequired,
  military: Warning.isRequired
};

function WarningList(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], _extends({
    names: [__WEBPACK_IMPORTED_MODULE_8__constants__["h" /* HAZMAT */], __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* BIO_HAZMAT */], __WEBPACK_IMPORTED_MODULE_8__constants__["D" /* LLP */], __WEBPACK_IMPORTED_MODULE_8__constants__["U" /* PASS_FAIL */], __WEBPACK_IMPORTED_MODULE_8__constants__["E" /* TOTAL_HOURS */], __WEBPACK_IMPORTED_MODULE_8__constants__["F" /* TOTAL_CYCLES */], __WEBPACK_IMPORTED_MODULE_8__constants__["R" /* MILITARY */]],
    component: Warnings
  }, props));
}

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Search__ = __webpack_require__(2144);
/* harmony export (immutable) */ __webpack_exports__["a"] = Form;








var option = function option(value, text) {
  return { value: value, text: text };
};
var options = __WEBPACK_IMPORTED_MODULE_4__constants__["_36" /* ALTERNATE_TYPES */].map(function (t) {
  return option(t, __WEBPACK_IMPORTED_MODULE_4__constants__["_25" /* ALTERNATES */][t].label);
});

function Form(props) {
  var showPartInput = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(props, "showPartInput", true);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
        name: "alternate_type",
        component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
        label: "Type",
        options: options,
        required: true
      }),
      showPartInput && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], { names: ["alternate_part_id", "label"], component: __WEBPACK_IMPORTED_MODULE_6__Search__["a" /* default */] })
    )
  );
}

Form.propTypes = {
  showPartInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;



function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate("alternate_type").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    form.validate("alternate_part_id", "label").satisfies(function () {
      if (!values.alternate_part_id && !values.label) {
        return "Required";
      }

      return undefined;
    });
  });
}

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_useEventListener__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_ImagePortal_ImagePortal__ = __webpack_require__(793);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();











function Catalog(_ref) {
  var part = _ref.part;

  if (!part.get(__WEBPACK_IMPORTED_MODULE_2__constants__["_8" /* CATALOG_URL */])) return null;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState4 = _slicedToArray(_useState3, 2),
      copying = _useState4[0],
      setCopying = _useState4[1];

  var escHandler = function escHandler(_ref2) {
    var key = _ref2.key;

    if (["27", "Escape"].includes(key) && open) {
      setOpen(false);
    }
  };

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__hooks_useEventListener__["a" /* default */])("keydown", escHandler);

  var copyImage = function copyImage() {
    try {
      var img = new Image();
      var c = document.createElement("canvas");
      var ctx = c.getContext("2d");

      img.onload = function onload() {
        c.width = this.naturalWidth;
        c.height = this.naturalHeight;
        ctx.drawImage(this, 0, 0);
        setCopying(true);
        setTimeout(function () {
          setCopying(false);
        }, 900);
        c.toBlob(function (blob) {
          navigator.clipboard.write([new window.ClipboardItem({
            "image/png": blob
          })]);
        }, "image/png", 0.75);
      };
      img.crossOrigin = "anonymous"; // if from different origin
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].parts.show(part.get(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ID */])).then(function (_ref3) {
        var data = _ref3.data;

        img.src = data[__WEBPACK_IMPORTED_MODULE_2__constants__["_8" /* CATALOG_URL */]];
      });
    } catch (e) {
      //
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { width: "100%", paddingTop: "10px" } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["j" /* NoteTooltip */], {
      icon: "fa-copy",
      color: "white",
      placement: "right",
      className: "clickable",
      onClick: copyImage,
      note: copying ? "Copied!" : "Copy To Clipboard"
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
      src: part.get(__WEBPACK_IMPORTED_MODULE_2__constants__["_8" /* CATALOG_URL */]),
      alt: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_2__constants__["_8" /* CATALOG_URL */]),
      width: 140,
      style: {
        boxShadow: "rgb(0 0 0 / 80%) 4px 12px 17px",
        display: "block",
        margin: "0 auto",
        cursor: "pointer"
      },
      onClick: function onClick() {
        return setOpen(!open);
      }
    }),
    open && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_ImagePortal_ImagePortal__["a" /* default */], {
      setOpen: setOpen,
      name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_2__constants__["_8" /* CATALOG_URL */]),
      url: part.get(__WEBPACK_IMPORTED_MODULE_2__constants__["_8" /* CATALOG_URL */]),
      open: open
    })
  );
}

Catalog.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map)
};

/* harmony default export */ __webpack_exports__["a"] = (Catalog);

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony export (immutable) */ __webpack_exports__["a"] = DoNotDoBusinessWarning;






function DoNotDoBusinessWarning(_ref) {
  var company = _ref.company;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(company, "status") === __WEBPACK_IMPORTED_MODULE_3__companies_constants__["b" /* NO_BIZ */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Warning_Warning__["a" /* default */],
    null,
    "This Company has been flagged as `Do Not Do Business`. Please proceed with caution."
  );
}

DoNotDoBusinessWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["a"] = ExistingQuoteWarning;






function ExistingQuoteWarning(_ref) {
  var quote = _ref.quote;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["n" /* Warning */],
    null,
    "In the last 36 hours, this part number was quoted by",
    " ",
    quote.get(__WEBPACK_IMPORTED_MODULE_4__constants__["E" /* CONTACT_NAME */]),
    " at ",
    quote.get(__WEBPACK_IMPORTED_MODULE_4__constants__["x" /* COMPANY_NAME */]),
    " to",
    " ",
    quote.getIn(["created_by", "full_name"]),
    " at",
    " ",
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__["e" /* shortDateAndTimestamp */])(quote.get(__WEBPACK_IMPORTED_MODULE_4__constants__["_7" /* CREATED_AT */])),
    ". *Please proceed with caution."
  );
}

ExistingQuoteWarning.propTypes = {
  quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
    })
  })
};

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_Total__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__companies_actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__IncomingQuotes_PartDetails__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__IncomingQuotes_IncomingQuoteTypeSelect__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__companies_shared_FindOrCreateCompanyToggle_FormToggle__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_shared_SelectInventoryTable__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_SellableQty__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__users_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib_time__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__DoNotDoBusinessWarning__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__LineItemsTable__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ExistingQuoteWarning__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__validate__ = __webpack_require__(2159);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();





































var formName = "partDetailNewIncomingQuote";

function Form(props) {
  var part = props.part,
      quantity = props.quantity,
      cost = props.cost,
      quoteType = props.quoteType,
      quoteTypes = props.quoteTypes,
      companyId = props.companyId,
      selectedCompany = props.selectedCompany,
      selectedEmail = props.selectedEmail,
      setFieldValue = props.setFieldValue,
      setSelectedCompany = props.setSelectedCompany,
      setSelectedEmail = props.setSelectedEmail,
      modal = props.modal;


  var companyQuotes = useCompanyQuotes(part.get(__WEBPACK_IMPORTED_MODULE_24__constants__["b" /* ID */]), companyId);

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__hooks__["a" /* useCurrentUser */])()),
      _useState2 = _slicedToArray(_useState, 2),
      selectedBuyer = _useState2[0],
      setSelectedBuyer = _useState2[1];

  var recentCompanyQuotes = companyQuotes.filter(function (q) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__lib_time__["b" /* isLessThan36HoursAgo */])(q.created_at);
  });
  var filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return {
      limit: "5",
      sellable_status: [__WEBPACK_IMPORTED_MODULE_25__inventories_constants__["U" /* LIST */], __WEBPACK_IMPORTED_MODULE_25__inventories_constants__["W" /* DO_NOT_LIST */]].join(",")
    };
  }, []);
  var partAsJson = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return part.toJS();
  }, [part]);

  var notesColumnClassName = __WEBPACK_IMPORTED_MODULE_7_classnames___default()({
    "col-md-12": quoteType !== __WEBPACK_IMPORTED_MODULE_20__IncomingQuotes_constants__["n" /* AWAITING_REPLY */],
    "col-md-6": quoteType === __WEBPACK_IMPORTED_MODULE_20__IncomingQuotes_constants__["n" /* AWAITING_REPLY */]
  });

  var onCompanySelected = function onCompanySelected(company) {
    setSelectedCompany(company);
    setFieldValue([__WEBPACK_IMPORTED_MODULE_24__constants__["i" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_29__companies_constants__["e" /* WEBSITE */]].join("."))(company ? company.website : null);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */],
    _extends({}, props, { modal: modal }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__DoNotDoBusinessWarning__["a" /* default */], { company: selectedCompany }),
      recentCompanyQuotes.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__ExistingQuoteWarning__["a" /* default */], { quote: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(recentCompanyQuotes[0]) }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_redux_form__["FormSection"],
                { name: "incoming_quote_line_item" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Fields"], {
                  fieldName: __WEBPACK_IMPORTED_MODULE_23__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */],
                  names: [__WEBPACK_IMPORTED_MODULE_24__constants__["V" /* COST */], __WEBPACK_IMPORTED_MODULE_24__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_23__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */]],
                  component: __WEBPACK_IMPORTED_MODULE_13__IncomingQuotes_IncomingQuoteTypeSelect__["a" /* default */],
                  quoteTypes: quoteTypes,
                  setFieldValue: setFieldValue
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_30__users_constants__["x" /* BUYER_ID */],
                label: "Buyer",
                placeholder: "Search by name...",
                component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["n" /* AutoCompleteField */],
                search: props.searchBuyers,
                selectedItem: selectedBuyer,
                onItemSelected: function onItemSelected(item) {
                  return setSelectedBuyer(item);
                },
                formatItem: function formatItem(result) {
                  return result && result.full_name;
                },
                required: true
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__companies_shared_FindOrCreateCompanyToggle_FormToggle__["a" /* default */], {
            allowPortalPurchase: true,
            companySearch: __WEBPACK_IMPORTED_MODULE_17__actions__["h" /* searchQuoteCompanies */],
            formName: formName,
            handleEmail: setSelectedEmail,
            onCompanySelected: onCompanySelected
          }),
          quoteType === __WEBPACK_IMPORTED_MODULE_20__IncomingQuotes_constants__["n" /* AWAITING_REPLY */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["a" /* CheckGroup */],
                { checkGroupStyles: { marginTop: 0 }, justified: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_20__IncomingQuotes_constants__["o" /* SEND_QUOTE */],
                  component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
                  label: "Send RFQ"
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_SellableQty__["a" /* default */], {
            quantities: part.get(__WEBPACK_IMPORTED_MODULE_21__constants__["P" /* SELLABLE_QUANTITIES */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({})),
            style: { marginTop: 20 }
          }),
          companyQuotes && companyQuotes.length > 0 && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            { className: "margin-bottom-30 line-height-2" },
            "Most Recent Quotes"
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "reset-panel-table" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__LineItemsTable__["a" /* LineItemsTable */], {
              results: companyQuotes,
              limitResults: true,
              loading: false,
              inForm: true
            })
          )],
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            { className: "margin-bottom-30 line-height-2" },
            "Next Available Inventory"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row reset-panel-table" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_redux_form__["FormSection"],
              { name: "ingoing_quote_line_item" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_shared_SelectInventoryTable__["a" /* default */], {
                filter: filter,
                part: partAsJson,
                choosable: false,
                modal: false,
                displayQuantity: false
              })
            )
          ),
          quoteType !== __WEBPACK_IMPORTED_MODULE_20__IncomingQuotes_constants__["j" /* NO_QUOTE */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              null,
              "Part Details"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_redux_form__["FormSection"],
              { name: "incoming_quote_line_item" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__IncomingQuotes_PartDetails__["a" /* default */], { quoteType: quoteType, part: part })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: notesColumnClassName },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_redux_form__["FormSection"],
                  { name: "incoming_quote_line_item" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_24__constants__["_18" /* NOTES */],
                    component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["l" /* TextArea */],
                    label: "Note (Applied to the line item)",
                    rows: 5
                  })
                )
              )
            ),
            quoteType === __WEBPACK_IMPORTED_MODULE_20__IncomingQuotes_constants__["n" /* AWAITING_REPLY */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: notesColumnClassName },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_redux_form__["FormSection"],
                  { name: "incoming_quote_line_item" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_26__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */],
                    component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["l" /* TextArea */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_26__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */]),
                    rows: 5
                  })
                )
              )
            )
          ),
          !modal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "row" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_Total__["a" /* default */], {
                  part: part.toJS(),
                  quantity: quantity,
                  cost: cost,
                  email: selectedEmail
                })
              )
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */].Footer,
      null,
      props.submitFailed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["i" /* Errors */], { errors: props.errorMessages }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */].Cancel, { close: props.close, editable: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */].Submit, {
        disabled: false,
        editable: true,
        submitting: props.submitting,
        onClick: function onClick() {
          return props.setSubmittedWith("save");
        }
      }),
      !modal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */].Submit, {
        disabled: false,
        editable: true,
        submitting: props.submitting,
        text: "Save and Go To Quote",
        onClick: function onClick() {
          return props.setSubmittedWith("save-and-go");
        }
      })
    )
  );
}

Form.propTypes = {
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  quoteType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  quoteTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  companyId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  selectedCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  selectedEmail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setSelectedCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setSelectedEmail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function (state) {
  return {
    quantity: selector(state, "incoming_quote_line_item.quantity"),
    companyId: selector(state, __WEBPACK_IMPORTED_MODULE_24__constants__["N" /* COMPANY_ID */]),
    cost: selector(state, "incoming_quote_line_item.cost"),
    quoteType: selector(state, "incoming_quote_line_item.quote_type"),
    part: state.partDetail.get(__WEBPACK_IMPORTED_MODULE_21__constants__["B" /* PART */]),
    contact: selector(state, __WEBPACK_IMPORTED_MODULE_24__constants__["O" /* CONTACT_ID */])
  };
}, function (dispatch) {
  return {
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_18__users_actions__["h" /* searchUsers */](filter));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_form__["change"])(formName, field, val));
      };
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_33__validate__["a" /* default */],
  asyncValidate: __WEBPACK_IMPORTED_MODULE_11__companies_actions__["b" /* validateContact */],
  asyncBlurFields: ["contact.email"]
})(Form)));

// Custom hooks
function useCompanyQuotes(partId, companyId) {
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState4 = _slicedToArray(_useState3, 2),
      recentCompanyQuotes = _useState4[0],
      setRecentCompanyQuotes = _useState4[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (partId && companyId) {
      __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].parts.incomingQuoteLineItems.search(partId, {
        limit: 5,
        company_id: companyId,
        created_after: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__lib_time__["c" /* monthsAgo */])(18)
      }).then(function (res) {
        setRecentCompanyQuotes(res.data.results);
      });
    }

    return function cleanup() {};
  }, [companyId]);

  return recentCompanyQuotes;
}

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OutgoingQuotes_constants__ = __webpack_require__(45);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();







function ImageOption(_ref) {
  var attachment = _ref.attachment,
      attachmentField = _ref.attachmentField,
      getFieldValue = _ref.getFieldValue,
      onSelect = _ref.onSelect;

  var attachmentIds = getFieldValue(attachmentField) || [];
  var selected = attachmentIds.includes(attachment.id);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: { position: "relative" },
      onClick: function onClick() {
        return onSelect(attachment);
      },
      className: "clickable"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
      alt: attachment.name,
      src: attachment.small_file_url,
      style: { height: "100px", paddingTop: "10px", paddingLeft: "10px" }
    }),
    selected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "fa fa-check-circle",
      style: {
        position: "absolute",
        bottom: "5px",
        left: "15px",
        color: "#4CAF50"
      }
    })
  );
}

ImageOption.propTypes = {
  attachment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  attachmentField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

function SelectImages(_ref2) {
  var formSection = _ref2.formSection,
      inventory = _ref2.inventory,
      setFieldValue = _ref2.setFieldValue,
      getFieldValue = _ref2.getFieldValue;

  if (!inventory) return null;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      attachments = _useState2[0],
      setAttachments = _useState2[1];

  var attachmentField = [formSection, __WEBPACK_IMPORTED_MODULE_4__OutgoingQuotes_constants__["D" /* INVENTORY_ATTACHMENT_IDS */]].filter(function (f) {
    return f;
  }).join(".");

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].inventories.attachments.search(inventory.id).then(function (_ref3) {
      var data = _ref3.data;

      setAttachments(data.results.filter(function (f) {
        return f.small_file_url;
      }));
      setFieldValue(attachmentField)([]);
    });

    return function cleanup() {};
  }, [inventory && inventory.id]);

  var onSelect = function onSelect(attachment) {
    var attachmentIds = getFieldValue(attachmentField) || [];

    if (attachmentIds.includes(attachment.id)) {
      var index = attachmentIds.indexOf(attachment.id);
      attachmentIds.splice(index, 1);
      setFieldValue(attachmentField)(attachmentIds);
    } else {
      attachmentIds.push(attachment.id);
      setFieldValue(attachmentField)(attachmentIds);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { style: { margin: "20px 0" } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h4",
      null,
      "Add Photo Attachments"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { display: "flex", flexWrap: "wrap" } },
      attachments.map(function (attachment) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageOption, {
          attachment: attachment,
          onSelect: onSelect,
          getFieldValue: getFieldValue,
          attachmentField: attachmentField
        });
      })
    )
  );
}

SelectImages.propTypes = {
  formSection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }),
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(SelectImages));

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Subscription_withSubscription__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_PurchaseOrderLineItemStatusCell__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_shared_AsIsFlag__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_shared_helpers__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_shared_ExchangeIcon__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__inventories_constants__ = __webpack_require__(12);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Table; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var formatCost = function formatCost(value) {
  if (value >= 1000) {
    return "$" + Math.floor(value).toLocaleString();
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(value);
};

var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.link = function (type, uuid) {
      if (type === "PurchaseOrder") {
        return "/purchase-orders/" + uuid;
      } else if (type === "Lot") {
        return "/lots/" + uuid;
      } else if (type === "LotLineItem") {
        return "/lots/" + uuid;
      }

      return null;
    }, _this.renderRow = function (lineItem, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components__["A" /* LinkedTableRow */],
        {
          to: _this.link(lineItem.type, lineItem.parent_uuid),
          key: i,
          cancelled: lineItem.cancelled
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { whiteSpace: "nowrap" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { textAlign: "right" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["I" /* LineItemQtyCell */], { lineItem: lineItem }),
              i + 1
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__shared_components_PurchaseOrderLineItemStatusCell__["a" /* default */],
          { lineItem: lineItem },
          lineItem.has_vendor_rma && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["j" /* NoteTooltip */], {
            icon: "fa-shield",
            placement: "top",
            note: "Vendor RMA",
            color: "white"
          }),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["c" /* shortDateYY */])(lineItem.created_at)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["w" /* CompanyName */], { flattenedCompany: lineItem, truncateAt: 18 })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          lineItem.buyer_name && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["e" /* truncate */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.buyer_name), 14)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          lineItem.serial_number || lineItem.expected_serial_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          lineItem.condition && __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["r" /* INVENTORIES */].condition[lineItem.condition].abbrev,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_shared_AsIsFlag__["a" /* AsIsFlag */], { lineItem: lineItem, className: "m-l-5" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_shared_ExchangeIcon__["a" /* ExchangeIcon */], { lineItem: lineItem })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          lineItem.quantity
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          lineItem.lead_time
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_shared_helpers__["a" /* displayCost */])(lineItem) && formatCost(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_shared_helpers__["a" /* displayCost */])(lineItem))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], {
          note: [lineItem.internal_note, lineItem.external_note].filter(function (n) {
            return n !== null && n !== "";
          }).join(" | "),
          className: __WEBPACK_IMPORTED_MODULE_15_classnames___default()({ "link-muted": lineItem.cancelled })
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */].Mini,
        { loading: this.props.loading, numbered: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */].Head,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Date"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Vendor"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Buyer"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "SN"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "CD"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "EXCH"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "QTY"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "LT"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Cost/Unit"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Note"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */].Body,
          null,
          this.props.results.map(this.renderRow)
        )
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Table.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    created_at: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string }),
    buyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string }),
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    has_vendor_rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })).isRequired,
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
var withResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["n" /* miniTable */])(function (_ref2, params) {
  var match = _ref2.match;
  return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].parts.purchaseOrderAndLots.search(match.params.id, params);
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(withResults(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__Subscription_withSubscription__["a" /* default */])("PurchaseOrderLineItem")(Table))));

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__companies_shared_FindOrCreateCompanyToggle_FormToggle__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_CurrencyField__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__companies_actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RepairQuotes_helpers__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__validate__ = __webpack_require__(2192);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

















var FORM_NAME = "repairQuoteForm";

function Form(props) {
  var modal = props.modal,
      submitting = props.submitting,
      getFieldValue = props.getFieldValue,
      setFieldValue = props.setFieldValue;

  var quoteType = getFieldValue([__WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["m" /* REPAIR_QUOTE_LINE_ITEM */], __WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["n" /* QUOTE_TYPE */]].join("."));
  var isNoCape = quoteType === __WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["d" /* NO_CAPES */];
  var isAwaitingReply = quoteType === __WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["e" /* AWAITING_REPLY */];

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["e" /* Form */],
    _extends({}, props, { submitting: submitting, modal: modal }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: [__WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["m" /* REPAIR_QUOTE_LINE_ITEM */], __WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["n" /* QUOTE_TYPE */]].join("."),
            component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["c" /* Select */],
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_forms__["e" /* arrayToProperCasedOptions */])(__WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["o" /* QUOTE_TYPES */]),
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["n" /* QUOTE_TYPE */]),
            onChange: function onChange(ev) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__RepairQuotes_helpers__["a" /* clearForNoCapes */])(ev, setFieldValue);
            },
            required: true
          })
        ),
        quoteType === __WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["e" /* AWAITING_REPLY */] && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["a" /* CheckGroup */],
            { justified: true },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: "sendRfq", component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["b" /* Check */], label: "Send RFQ" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__companies_shared_FindOrCreateCompanyToggle_FormToggle__["a" /* default */], {
        formName: FORM_NAME,
        type: "repairOrder",
        companySearch: __WEBPACK_IMPORTED_MODULE_10__companies_actions__["a" /* searchRepairStationCompanies */],
        setPrimaryContact: true
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr", { className: "hr-sm" }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "h4",
        null,
        "Part Details"
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_redux_form__["FormSection"],
        { name: __WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["m" /* REPAIR_QUOTE_LINE_ITEM */] },
        !isNoCape && [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_CurrencyField__["a" /* default */], {
              name: __WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["h" /* AVG_OVERHAUL */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["h" /* AVG_OVERHAUL */]),
              disabled: isAwaitingReply
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
            { md: 2 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              label: "OH TAT",
              disabled: isAwaitingReply,
              name: __WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["a" /* OVERHAUL_TAT */],
              type: "number",
              className: "text-right",
              component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["h" /* NumberInput */],
              roundDigits: 0
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_CurrencyField__["a" /* default */], {
              name: __WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["i" /* AVG_REPAIR */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["i" /* AVG_REPAIR */]),
              disabled: isAwaitingReply
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
            { md: 2 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              label: "SV TAT",
              disabled: isAwaitingReply,
              name: __WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["b" /* REPAIR_TAT */],
              type: "number",
              className: "text-right",
              component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["h" /* NumberInput */],
              roundDigits: 0
            })
          )
        ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_CurrencyField__["a" /* default */], {
              name: __WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["j" /* AVG_TEST */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["j" /* AVG_TEST */]),
              disabled: isAwaitingReply
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
            { md: 2 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              label: "BT TAT",
              disabled: isAwaitingReply,
              name: __WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["c" /* TEST_TAT */],
              type: "number",
              className: "text-right",
              component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["h" /* NumberInput */],
              roundDigits: 0
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: "warranty_period",
              component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["c" /* Select */],
              options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_13__constants__["Q" /* REPAIR_QUOTE_WARRANTY_PERIODS */]),
              label: "Warranty Period",
              disabled: isAwaitingReply
            })
          )
        ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_CurrencyField__["a" /* default */], {
              name: __WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["k" /* EVALUATION_FEE */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["k" /* EVALUATION_FEE */]),
              disabled: isAwaitingReply
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["d" /* FormInput */],
              name: __WEBPACK_IMPORTED_MODULE_8__RepairQuotes_constants__["l" /* BER_RATE */],
              label: "BER %",
              disabled: isAwaitingReply,
              parse: function parse(value) {
                return value && parseInt(value, 10);
              },
              addon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i", { className: "fa fa-percent" })
            })
          )
        )],
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: __WEBPACK_IMPORTED_MODULE_4__constants__["_18" /* NOTES */], component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["l" /* TextArea */], label: "Note", rows: 5 })
          )
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_14__validate__["a" /* default */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form)));

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_SendEmail_Form__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);





function SendRepairQuoteEmail(props) {
  var close = props.close,
      lineItem = props.lineItem,
      _props$modal = props.modal,
      modal = _props$modal === undefined ? true : _props$modal;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_SendEmail_Form__["a" /* default */], {
    recordId: lineItem.repair_quote_id,
    url: __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairQuotes,
    label: "Request For Repair Quote",
    close: close,
    modal: modal
  });
}

SendRepairQuoteEmail.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  modal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (SendRepairQuoteEmail);

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_CurrencyField__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__companies_helpers__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RepairQuotes_helpers__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__validate__ = __webpack_require__(2198);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();




















var FORM_NAME = "repairQuoteForm";

function Form(props) {
  var getFieldValue = props.getFieldValue,
      repairQuote = props.repairQuote,
      setFieldValue = props.setFieldValue,
      submitting = props.submitting;


  var company = repairQuote && repairQuote.company;
  var contact = getFieldValue(__WEBPACK_IMPORTED_MODULE_3__constants__["O" /* CONTACT_ID */]);

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      contacts = _useState2[0],
      setContacts = _useState2[1];

  var companyId = getFieldValue(__WEBPACK_IMPORTED_MODULE_3__constants__["N" /* COMPANY_ID */]);
  var quoteType = getFieldValue([__WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["m" /* REPAIR_QUOTE_LINE_ITEM */], __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["n" /* QUOTE_TYPE */]].join("."));
  var isNoCape = quoteType === __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["d" /* NO_CAPES */];
  var isAwaitingReply = quoteType === __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["e" /* AWAITING_REPLY */];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    if (companyId) {
      __WEBPACK_IMPORTED_MODULE_12__api__["a" /* default */].companies.contacts.search(companyId, {
        active: true,
        page: 1,
        limit: 1000,
        sort: "name",
        reverse: false
      }).then(function (_ref) {
        var data = _ref.data;
        return setContacts(data.results);
      });
    }
  }, [companyId]);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["e" /* Form */],
    _extends({}, props, { submitting: submitting, modal: props.modal }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: [__WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["m" /* REPAIR_QUOTE_LINE_ITEM */], __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["n" /* QUOTE_TYPE */]].join("."),
            component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["c" /* Select */],
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["e" /* arrayToProperCasedOptions */])(__WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["o" /* QUOTE_TYPES */]),
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["n" /* QUOTE_TYPE */]),
            onChange: function onChange(ev) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__RepairQuotes_helpers__["a" /* clearForNoCapes */])(ev, setFieldValue);
            },
            required: true
          })
        ),
        quoteType === __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["e" /* AWAITING_REPLY */] && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["a" /* CheckGroup */],
            { justified: true },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: "sendRfq", component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["b" /* Check */], label: "Send RFQ" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_3__constants__["N" /* COMPANY_ID */],
            label: "Repair Station",
            labelChildren: company && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,
              null,
              "\xA0\xA0",
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["g" /* CompanyStatsTooltip */], { company: company })
            ),
            placeholder: "Search by typing a company's name or code",
            component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["n" /* AutoCompleteField */],
            search: function search(filter) {
              return __WEBPACK_IMPORTED_MODULE_12__api__["a" /* default */].companies.search({
                filter: filter,
                status: [__WEBPACK_IMPORTED_MODULE_10__companies_constants__["c" /* ACTIVE */], __WEBPACK_IMPORTED_MODULE_10__companies_constants__["d" /* CREDIT_HOLD */]].join(","),
                page: 1,
                limit: 20
              }).then(function (resp) {
                return resp.data.results;
              });
            },
            formatItem: function formatItem(result) {
              return result.name + " (" + __WEBPACK_IMPORTED_MODULE_10__companies_constants__["h" /* APPROVAL_STATUSES */][result.vendor_status].label + ")";
            },
            selectedItem: company,
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_3__constants__["O" /* CONTACT_ID */],
            component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["c" /* Select */],
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__companies_helpers__["b" /* contactSelectList */])(contacts),
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__companies_constants__["g" /* CONTACT */]),
            required: true
          })
        )
      ),
      contact === "Add" && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: "contact.name",
              component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["d" /* FormInput */],
              label: "Contact Name",
              required: true
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: "contact.email",
              component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["d" /* FormInput */],
              label: "Contact Email",
              required: true
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr", { className: "hr-sm" }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "h4",
        null,
        "Part Details"
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_redux_form__["FormSection"],
        { name: __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["m" /* REPAIR_QUOTE_LINE_ITEM */] },
        !isNoCape && [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_CurrencyField__["a" /* default */], {
              name: __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["h" /* AVG_OVERHAUL */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["h" /* AVG_OVERHAUL */]),
              disabled: isAwaitingReply
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
            { md: 1 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              label: "OH TAT",
              name: __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["a" /* OVERHAUL_TAT */],
              type: "number",
              className: "text-right",
              component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["h" /* NumberInput */],
              roundDigits: 0,
              disabled: isAwaitingReply
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_CurrencyField__["a" /* default */], {
              name: __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["i" /* AVG_REPAIR */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["i" /* AVG_REPAIR */]),
              disabled: isAwaitingReply
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
            { md: 1 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              label: "SV TAT",
              name: __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["b" /* REPAIR_TAT */],
              type: "number",
              className: "text-right",
              component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["h" /* NumberInput */],
              roundDigits: 0,
              disabled: isAwaitingReply
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_CurrencyField__["a" /* default */], {
              name: __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["j" /* AVG_TEST */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["j" /* AVG_TEST */]),
              disabled: isAwaitingReply
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
            { md: 1 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              label: "BT TAT",
              name: __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["c" /* TEST_TAT */],
              type: "number",
              className: "text-right",
              component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["h" /* NumberInput */],
              roundDigits: 0,
              disabled: isAwaitingReply
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: "warranty_period",
              component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["c" /* Select */],
              options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_16__constants__["Q" /* REPAIR_QUOTE_WARRANTY_PERIODS */]),
              label: "Warranty Period",
              disabled: isAwaitingReply
            })
          )
        ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_CurrencyField__["a" /* default */], {
              name: __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["k" /* EVALUATION_FEE */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["k" /* EVALUATION_FEE */]),
              disabled: isAwaitingReply
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["d" /* FormInput */],
              name: __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["l" /* BER_RATE */],
              label: "BER %",
              disabled: isAwaitingReply,
              parse: function parse(value) {
                return value && parseInt(value, 10);
              },
              addon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i", { className: "fa fa-percent" })
            })
          )
        )],
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: __WEBPACK_IMPORTED_MODULE_3__constants__["_18" /* NOTES */], component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["l" /* TextArea */], label: "Note", rows: 5 })
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["e" /* Form */].AdditionalButtons,
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: "btn btn-danger",
          style: { paddingLeft: "5px", paddingRight: "5px" },
          onClick: function onClick(e) {
            e.preventDefault();
            __WEBPACK_IMPORTED_MODULE_12__api__["a" /* default */].repairQuotes.delete(repairQuote.id).then(function () {
              __WEBPACK_IMPORTED_MODULE_14_react_redux_toastr__["toastr"].success("Success", repairQuote.code + " successfully removed.");
              props.close();
            });
          }
        },
        "Delete"
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_17__validate__["a" /* default */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form)));

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(23);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;




function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["_2" /* MLP */], __WEBPACK_IMPORTED_MODULE_2__constants__["_3" /* PURCHASED_AT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["p" /* requiredIfAnyDefined */](__WEBPACK_IMPORTED_MODULE_2__constants__["_2" /* MLP */], __WEBPACK_IMPORTED_MODULE_2__constants__["_3" /* PURCHASED_AT */]));

    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["_4" /* SPECIAL_CONTAINER_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["p" /* requiredIfAnyDefined */](__WEBPACK_IMPORTED_MODULE_2__constants__["_5" /* SPECIAL_CONTAINER_REQ */]));

    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["w" /* PART_NUMBER */], __WEBPACK_IMPORTED_MODULE_2__constants__["u" /* DESCRIPTION */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["j" /* WEIGHT */], __WEBPACK_IMPORTED_MODULE_2__constants__["_2" /* MLP */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["q" /* isNumeric */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["f" /* isGreaterThan */](0));
    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["_6" /* UNITED_NATIONS_CODE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["r" /* isInteger */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["s" /* lengthIsEqual */](4));

    if (!["EAR99", "SNCHK"].includes(values[__WEBPACK_IMPORTED_MODULE_2__constants__["K" /* EUROPEAN_COMMERCE_CONTROL_NUMBER */]])) {
      v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["K" /* EUROPEAN_COMMERCE_CONTROL_NUMBER */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["l" /* matchesPattern */](/^[0-9][A-Za-z]\d{3}\.?[a-z]?\.?[0-9]?\.?[a-z]?$/));
    }
    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* LENGTH */], __WEBPACK_IMPORTED_MODULE_2__constants__["k" /* WIDTH */], __WEBPACK_IMPORTED_MODULE_2__constants__["m" /* HEIGHT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["p" /* requiredIfAnyDefined */](__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* LENGTH */], __WEBPACK_IMPORTED_MODULE_2__constants__["k" /* WIDTH */], __WEBPACK_IMPORTED_MODULE_2__constants__["m" /* HEIGHT */]), __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["r" /* isInteger */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["f" /* isGreaterThan */](0));

    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["E" /* TOTAL_HOURS */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["p" /* requiredIfAnyDefined */](__WEBPACK_IMPORTED_MODULE_2__constants__["E" /* TOTAL_HOURS */]), __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["r" /* isInteger */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["h" /* isBetween */](0, 999999));

    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["F" /* TOTAL_CYCLES */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["p" /* requiredIfAnyDefined */](__WEBPACK_IMPORTED_MODULE_2__constants__["F" /* TOTAL_CYCLES */]), __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["r" /* isInteger */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["h" /* isBetween */](0, 999999));

    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["T" /* DOM_LIFE_YEARS */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["p" /* requiredIfAnyDefined */](__WEBPACK_IMPORTED_MODULE_2__constants__["_7" /* DOM_SENSITIVE */]), __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["r" /* isInteger */]);

    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["v" /* HTSUS_CODE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["l" /* matchesPattern */](/^([0-9][A-Z]{1})|([0-9]{4}(.)[0-9]{1,2}(.)[0-9]{0,4})$/));

    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["x" /* SCHEDULE_B_OR_HT_CODE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["l" /* matchesPattern */](/(^[0-9]{4}(.)[0-9]{1,2}(.)[0-9]{0,4})$/));
  });
}

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RepairQuotes_constants__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RepairQuotes_styles__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_StatsTooltip_format__ = __webpack_require__(144);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderQuoteField; });
/* unused harmony export Table */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var tatField = function tatField(lineItem, field) {
  return lineItem[field] || "--";
};

var renderTat = function renderTat(lineItem) {
  return [__WEBPACK_IMPORTED_MODULE_9__RepairQuotes_constants__["a" /* OVERHAUL_TAT */], __WEBPACK_IMPORTED_MODULE_9__RepairQuotes_constants__["b" /* REPAIR_TAT */], __WEBPACK_IMPORTED_MODULE_9__RepairQuotes_constants__["c" /* TEST_TAT */]].map(function (f) {
    return tatField(lineItem, f);
  }).join("/");
};

var RenderQuoteField = function RenderQuoteField(_ref) {
  var lineItem = _ref.lineItem,
      field = _ref.field,
      _ref$formatter = _ref.formatter,
      formatter = _ref$formatter === undefined ? function (f) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(f, 0, true);
  } : _ref$formatter;

  if ([__WEBPACK_IMPORTED_MODULE_9__RepairQuotes_constants__["d" /* NO_CAPES */], __WEBPACK_IMPORTED_MODULE_9__RepairQuotes_constants__["e" /* AWAITING_REPLY */]].includes(lineItem.quote_type)) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null);
  }

  if (field === __WEBPACK_IMPORTED_MODULE_9__RepairQuotes_constants__["f" /* TURNAROUND_TIME */]) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      renderTat(lineItem)
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-right" },
    formatter(lineItem[field])
  );
};

RenderQuoteField.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Map),
  field: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  formatter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

function renderRow(lineItemMap, i, select) {
  var lineItem = lineItemMap.toJS();
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: lineItem.id,
      className: "clickable",
      onClick: function onClick() {
        return select(lineItem);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      i + 1
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__RepairQuotes_styles__["a" /* default */],
      { lineItem: lineItem },
      lineItem.code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        {
          className: lineItem.updated_at !== lineItem.created_at && "text-yellow"
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__["b" /* shortDate */])(lineItem.updated_at || lineItem.created_at)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.created_by.full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_9__RepairQuotes_constants__["g" /* QUOTE_TYPES_ABBREV */][lineItem.quote_type]
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["w" /* CompanyName */], {
        flattenedCompany: lineItem,
        context: "repair",
        truncateAt: 25
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.contact_name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderQuoteField, { lineItem: lineItem, field: __WEBPACK_IMPORTED_MODULE_9__RepairQuotes_constants__["h" /* AVG_OVERHAUL */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderQuoteField, { lineItem: lineItem, field: __WEBPACK_IMPORTED_MODULE_9__RepairQuotes_constants__["i" /* AVG_REPAIR */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderQuoteField, { lineItem: lineItem, field: __WEBPACK_IMPORTED_MODULE_9__RepairQuotes_constants__["j" /* AVG_TEST */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderQuoteField, { lineItem: lineItem, field: __WEBPACK_IMPORTED_MODULE_9__RepairQuotes_constants__["f" /* TURNAROUND_TIME */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderQuoteField, { lineItem: lineItem, field: __WEBPACK_IMPORTED_MODULE_9__RepairQuotes_constants__["k" /* EVALUATION_FEE */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderQuoteField, {
      lineItem: lineItem,
      field: __WEBPACK_IMPORTED_MODULE_9__RepairQuotes_constants__["l" /* BER_RATE */],
      formatter: function formatter(f) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shared_components_StatsTooltip_format__["f" /* percentFormatter */])(f);
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["G" /* NoteTooltipTableCell */], { note: lineItem.notes })
  );
}

var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    _classCallCheck(this, Table);

    return _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
  }

  _createClass(Table, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.setPageSize(25);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          results = _props.results,
          openEditModal = _props.openEditModal,
          setLineItem = _props.setLineItem;


      var selectLineItem = function selectLineItem(lineItem) {
        setLineItem(lineItem);
        openEditModal(true);
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "table",
        { className: "table table-striped table-hover table-numbered" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "RQ #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Date Created"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Created By"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Type"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Repair Station"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Contact"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Avg OH"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Avg SV"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Avg BT"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "TAT"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Eval Fee"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "BER (%)"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tbody",
          null,
          results.map(function (r, i) {
            return renderRow(r, i, selectLineItem);
          })
        )
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Table.propTypes = {
  openEditModal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  setPageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  results: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"]).isRequired,
  setLineItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function () {
  return {
    listId: "part/repairQuoteLineItems"
  };
}, {
  setPageSize: __WEBPACK_IMPORTED_MODULE_5__actions__["c" /* repairOrderActions */].pageActions.setPageSize
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["l" /* tabulateImmutable */])(Table)));

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = Warnings;



var Warning = function Warning(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === undefined ? "10px" : _ref$height,
      icon = _ref.icon,
      label = _ref.label,
      iconUrl = _ref.iconUrl;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label label-danger" },
    iconUrl ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: iconUrl, height: height, alt: iconUrl }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-" + icon }),
    "\xA0\xA0",
    label
  );
};

Warning.propTypes = {
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  iconUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

function Warnings(_ref2) {
  var part = _ref2.part;

  var hazmat = part.hazmat && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Warning, { label: "Hazmat", icon: "warning" });
  var bio = part.bio_hazmat && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Warning, { label: "Bio Hazmat", icon: "flask" });
  var llp = part.llp && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Warning, { label: "LLP", icon: "gear" });
  var shelfLife = part.shelf_life && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Warning, {
    label: "Shelf Life",
    iconUrl: "https://info-trader-assets.s3.us-east-2.amazonaws.com/icons/shelf_life.png",
    height: "12px"
  });
  var exportCompliance = part.export_compliance && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Warning, {
    label: "Export",
    iconUrl: "https://info-trader-assets.s3.us-east-2.amazonaws.com/icons/export_compliance.png"
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    null,
    hazmat,
    bio,
    llp,
    shelfLife,
    exportCompliance
  );
}

Warnings.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    bio_hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    llp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    shelf_life: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
  })
};

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(2251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreatePart__ = __webpack_require__(2133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__CreatePart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateImportParts__ = __webpack_require__(2129);
/* unused harmony reexport CreateImportParts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Detail__ = __webpack_require__(2203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Detail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IncomingQuoteLineItems__ = __webpack_require__(2217);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__IncomingQuoteLineItems__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ManagedRepairOrderLineItems__ = __webpack_require__(2225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__ManagedRepairOrderLineItems__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OutgoingQuoteLineItems__ = __webpack_require__(2230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__OutgoingQuoteLineItems__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PurchaseOrderLineItems__ = __webpack_require__(2235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__PurchaseOrderLineItems__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RepairOrderLineItems__ = __webpack_require__(2239);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_8__RepairOrderLineItems__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RepairQuoteLineItems__ = __webpack_require__(2243);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__RepairQuoteLineItems__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SalesOrderLineItems__ = __webpack_require__(2246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_10__SalesOrderLineItems__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Inventories__ = __webpack_require__(2220);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_11__Inventories__["a"]; });

























/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_weight__ = __webpack_require__(238);
/* harmony export (immutable) */ __webpack_exports__["a"] = ConvertedWeight;




function ConvertedWeight(_ref) {
  var unit = _ref.unit,
      weight = _ref.weight;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { className: "control-label", htmlFor: "read_only_conversion" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_weight__["b" /* conversionUnit */])(unit)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "input-group" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        name: "read_only_conversion",
        className: "form-control",
        type: "text",
        value: weight ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_weight__["c" /* calculateValue */])(unit, weight) : "",
        disabled: true,
        readOnly: true
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "input-group-addon" },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_weight__["d" /* conversionUnitAbbrev */])(unit)
      )
    )
  );
}

ConvertedWeight.propTypes = {
  weight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony export (immutable) */ __webpack_exports__["a"] = Description;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function Description(_ref) {
  var partNumber = _ref.part_number,
      description = _ref.description,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled;

  var field = _extends({}, description.input, {
    onChange: function onChange(e) {
      description.input.onChange(e);
      partNumber.input.onChange(partNumber.input.value);
    }
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["d" /* FormInput */], {
    input: field,
    meta: description.meta,
    label: "Description",
    required: true,
    disabled: disabled
  });
}

var Field = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  input: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["stringInput"].isRequired,
  meta: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["meta"]
});

Description.propTypes = {
  part_number: Field.isRequired,
  description: Field.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators_withFormFields__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_weight__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NetWeight; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var NetWeight = function (_Component) {
  _inherits(NetWeight, _Component);

  function NetWeight() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NetWeight);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NetWeight.__proto__ || Object.getPrototypeOf(NetWeight)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.setPounds = function () {
      if (_this.props.net_weight_unit.input.value !== __WEBPACK_IMPORTED_MODULE_3__constants__["z" /* POUNDS */]) {
        var lbs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_weight__["a" /* calculateNetValue */])(__WEBPACK_IMPORTED_MODULE_3__constants__["A" /* KILOS */], Number(_this.props.net_weight.input.value));
        if (Number(lbs) > 0) {
          var remainder = lbs % 1;
          remainder = (remainder * 16).toFixed(2);
          _this.props.net_weight_oz.input.onChange(remainder);
        }

        _this.props.net_weight.input.onChange(Math.floor(lbs));
      }
      _this.props.net_weight_unit.input.onChange(__WEBPACK_IMPORTED_MODULE_3__constants__["z" /* POUNDS */]);
      _this.close();
    }, _this.setKilos = function () {
      if (_this.props.net_weight_unit.input.value !== __WEBPACK_IMPORTED_MODULE_3__constants__["A" /* KILOS */]) {
        _this.props.net_weight.input.onChange(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_weight__["a" /* calculateNetValue */])(__WEBPACK_IMPORTED_MODULE_3__constants__["z" /* POUNDS */], Number(_this.props.net_weight.input.value), Number(_this.props.net_weight_oz.input.value)));
      }
      _this.props.net_weight_unit.input.onChange(__WEBPACK_IMPORTED_MODULE_3__constants__["A" /* KILOS */]);
      _this.props.net_weight_oz.input.onChange(null);
      _this.close();
    }, _this.updateWeight = function (e) {
      var val = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["isEmpty"])(e.target.value) ? null : Number(e.target.value);
      _this.props.net_weight.input.onChange(val);
      _this.close();
    }, _this.updateOz = function (e) {
      var val = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["isEmpty"])(e.target.value) ? null : e.target.value;
      _this.props.net_weight_oz.input.onChange(val);
      _this.close();
    }, _this.toggle = function () {
      return _this.setState({ open: !_this.state.open });
    }, _this.close = function () {
      return _this.setState({ open: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NetWeight, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$label = _props.label,
          label = _props$label === undefined ? "Weight" : _props$label,
          required = _props.required,
          netWeight = _props.net_weight,
          unit = _props.net_weight_unit,
          netWeightOz = _props.net_weight_oz;
      var open = this.state.open;
      var _netWeight$meta = netWeight.meta,
          touched = _netWeight$meta.touched,
          invalid = _netWeight$meta.invalid,
          error = _netWeight$meta.error;

      var hasError = touched && invalid;

      var formGroupClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("form-group", {
        "has-error": hasError
      });

      var inputGroupClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("input-group-btn dropdown", { open: open });

      var errors = hasError && error.map(function (m) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "help-block", key: m },
          m
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: formGroupClasses },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { htmlFor: netWeight.input.name, className: "control-label" },
          label,
          required && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "sup",
            { className: "small text-danger" },
            "*"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({
            type: "number",
            min: unit.input.value === __WEBPACK_IMPORTED_MODULE_3__constants__["A" /* KILOS */] ? "0.001" : "0",
            step: unit.input.value === __WEBPACK_IMPORTED_MODULE_3__constants__["A" /* KILOS */] ? "0.001" : "1",
            className: "form-control"
          }, netWeight.input, {
            onChange: this.updateWeight,
            onBlur: this.updateWeight
          })),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "input-group-addon" },
            unit.input.value
          ),
          unit.input.value === __WEBPACK_IMPORTED_MODULE_3__constants__["z" /* POUNDS */] && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({
            type: "number",
            className: "form-control",
            step: "0.1",
            min: "0"
          }, netWeightOz.input, {
            onChange: this.updateOz,
            onBlur: this.updateOz
          })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "input-group-addon" },
            "oz"
          )],
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: inputGroupClasses },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              {
                type: "button",
                className: "btn btn-default dropdown-toggle",
                onClick: this.toggle
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-caret-down" })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "ul",
              { className: "dropdown-menu dropdown-menu-right" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "button",
                  {
                    type: "button",
                    className: "btn btn-link",
                    onClick: this.setPounds
                  },
                  "Standard (Lbs.)"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "button",
                  {
                    type: "button",
                    className: "btn btn-link",
                    onClick: this.setKilos
                  },
                  "Metric (Kgs.)"
                )
              )
            )
          )
        ),
        errors
      );
    }
  }]);

  return NetWeight;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

NetWeight.propTypes = {
  net_weight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__["stringInput"].isRequired,
    meta: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__["meta"].isRequired
  }).isRequired,
  net_weight_unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__["stringInput"].isRequired
  }).isRequired,
  net_weight_oz: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__["stringInput"].isRequired
  }).isRequired,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators_withFormFields__["a" /* default */])(NetWeight, [__WEBPACK_IMPORTED_MODULE_3__constants__["o" /* NET_WEIGHT */], __WEBPACK_IMPORTED_MODULE_3__constants__["t" /* NET_WEIGHT_UNIT */], __WEBPACK_IMPORTED_MODULE_3__constants__["s" /* NET_WEIGHT_OZ */]]));

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony export (immutable) */ __webpack_exports__["a"] = PartNumber;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function PartNumber(_ref) {
  var partNumber = _ref.part_number,
      description = _ref.description,
      notify = _ref.notify,
      check = _ref.check,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled;

  var field = _extends({}, partNumber.input, {
    onChange: function onChange(e) {
      partNumber.input.onChange(e);
      description.input.onChange(description.input.value);
    }
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["z" /* AsyncField */], {
    meta: partNumber.meta,
    input: field,
    formComponent: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["d" /* FormInput */],
    label: "Part Number",
    notify: notify,
    check: check,
    disabled: disabled,
    checkOnChange: true,
    required: true
  });
}

var Field = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  input: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["stringInput"].isRequired,
  meta: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormTypes__["meta"]
});

PartNumber.propTypes = {
  part_number: Field.isRequired,
  description: Field.isRequired,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  notify: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_formatters_currency__ = __webpack_require__(20);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displaySrp; });


var displaySrp = function displaySrp(renderDummyValues, inventory) {
  if (inventory.mod_to && inventory.mod_to.id !== inventory.part.id) {
    return "MOD";
  }

  return inventory.suggested_retail && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_formatters_currency__["a" /* dollars */])(renderDummyValues ? inventory.dummy.suggested_retail || inventory.suggested_retail : inventory.suggested_retail);
};

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailTable_Detail__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DashedSeparator_DashedSeparator__ = __webpack_require__(211);
/* harmony export (immutable) */ __webpack_exports__["a"] = ApprovalDetails;






function ApprovalDetails(_ref) {
  var record = _ref.record;

  if (record.approved_by || record.approved_updated_at || !record.approved) {
    return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DashedSeparator_DashedSeparator__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DetailTable_Detail__["a" /* default */], {
          label: "Approved",
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__["b" /* shortDate */])(record.approved_updated_at),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DetailTable_Detail__["a" /* default */], {
          label: "Approved By",
          value: record.approved_by && record.approved_by.full_name,
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DetailTable_Detail__["a" /* default */], {
          label: "Reason For Approval",
          value: record.reason_for_approval && record.reason_for_approval.join("/"),
          renderIfPresent: true
        })
      )
    )];
  }

  return null;
}

ApprovalDetails.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AuthorizedOwner__ = __webpack_require__(2274);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AuthorizedOwner__["a"]; });



/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoComplete__ = __webpack_require__(278);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AutoComplete__["a"]; });



/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__validate__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Form__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_attachments__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types_resourceTypes__ = __webpack_require__(58);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }















function SaveWarning(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2____["n" /* Warning */],
        null,
        "Would you like to replace the previously saved Commercial Invoice?"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__Forms__["e" /* Form */].Footer,
      null,
      props.submitFailed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Forms__["i" /* Errors */], { errors: props.errorMessages }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Forms__["e" /* Form */].Cancel, {
        close: function close() {
          return props.setCurrentForm(__WEBPACK_IMPORTED_MODULE_10__helpers__["e" /* COMMERCIAL_INVOICE */]);
        },
        editable: true
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["i" /* Button */],
        {
          type: "submit",
          onClick: function onClick() {
            return props.setFieldValue(__WEBPACK_IMPORTED_MODULE_8__Form__["b" /* REPLACE_PDF */])(false);
          }
        },
        "No"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["i" /* Button */],
        {
          type: "submit",
          bsStyle: "success",
          onClick: function onClick() {
            return props.setFieldValue(__WEBPACK_IMPORTED_MODULE_8__Form__["b" /* REPLACE_PDF */])(true);
          }
        },
        "Yes"
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    initialValues: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_form__["getFormValues"])(__WEBPACK_IMPORTED_MODULE_8__Form__["c" /* COMMERCIAL_INVOICE_FORM */])(state)
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function () {
      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data) {
        var _ref2, invoice;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].commercialInvoices.create(data);

              case 2:
                _ref2 = _context.sent;
                invoice = _ref2.data;

                window.location.href = __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* API_BASE */] + "/commercial_invoices/" + invoice.id + "/download_commercial_invoice";
                ownProps.setCurrentForm(__WEBPACK_IMPORTED_MODULE_10__helpers__["e" /* COMMERCIAL_INVOICE */]);
                ownProps.close();

                if (data.shipment_id) {
                  dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_attachments__["a" /* getAttachments */])(data.shipment_id, __WEBPACK_IMPORTED_MODULE_12__types_resourceTypes__["a" /* default */].shipment));
                }

                if (data.sales_order_id) {
                  dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions_attachments__["a" /* getAttachments */])(data.sales_order_id, __WEBPACK_IMPORTED_MODULE_12__types_resourceTypes__["a" /* default */].salesOrder));
                }

                ownProps.resetForm();

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function onSubmit(_x) {
        return _ref.apply(this, arguments);
      };
    }(),
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_form__["change"])(__WEBPACK_IMPORTED_MODULE_10__helpers__["d" /* SAVE_OR_REPLACE_FORM */], field, val));
      };
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Forms__["j" /* form */])({
  form: __WEBPACK_IMPORTED_MODULE_10__helpers__["d" /* SAVE_OR_REPLACE_FORM */],
  validate: __WEBPACK_IMPORTED_MODULE_7__validate__["a" /* default */]
})(SaveWarning)));

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shipping_constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);








function validateItem(item, values) {
  item.validate(__WEBPACK_IMPORTED_MODULE_2__parts_constants__["x" /* SCHEDULE_B_OR_HT_CODE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["l" /* matchesPattern */](/\d{4}\.\d{2}\.\d{2,4}/));

  if (![__WEBPACK_IMPORTED_MODULE_2__parts_constants__["L" /* EAR99 */], __WEBPACK_IMPORTED_MODULE_2__parts_constants__["M" /* SNCHK */]].includes(values[__WEBPACK_IMPORTED_MODULE_2__parts_constants__["K" /* EUROPEAN_COMMERCE_CONTROL_NUMBER */]])) {
    item.validate(__WEBPACK_IMPORTED_MODULE_2__parts_constants__["K" /* EUROPEAN_COMMERCE_CONTROL_NUMBER */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["l" /* matchesPattern */](/^[0-9][A-Za-z]\d{3}\.?[a-z]?\.?[0-9]?\.?[a-z]?$/));
  }

  item.validate(__WEBPACK_IMPORTED_MODULE_2__parts_constants__["g" /* COUNTRY_OF_MFG */], __WEBPACK_IMPORTED_MODULE_2__parts_constants__["K" /* EUROPEAN_COMMERCE_CONTROL_NUMBER */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);

  item.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* LICENSE_REQUIRED */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["m" /* isBool */]);
}

/* harmony default export */ __webpack_exports__["a"] = (function (values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_4__Shipping_constants__["o" /* CONSIGNEE */], __WEBPACK_IMPORTED_MODULE_3__constants__["_13" /* CUSTOMER_PO */], __WEBPACK_IMPORTED_MODULE_4__Shipping_constants__["l" /* EIN */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);

    form.validate(__WEBPACK_IMPORTED_MODULE_4__Shipping_constants__["n" /* ROUTED_EXPORT */], __WEBPACK_IMPORTED_MODULE_4__Shipping_constants__["m" /* USPPI */], __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* CARGO_SCREENING_CONSENT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["m" /* isBool */]);

    form.validate(__WEBPACK_IMPORTED_MODULE_2__parts_constants__["h" /* HAZMAT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["m" /* isBool */]);
    form.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["m" /* CONTACT_EMAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["b" /* isValidEmail */]);
    form.validateChild(__WEBPACK_IMPORTED_MODULE_3__constants__["_14" /* FREIGHT_FORWARDER_ADDRESS */], function (method) {
      if ([null, undefined].includes(__WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(values, "freight_forwarder_address.company_name"))) {
        method.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["N" /* COMPANY_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      } else {
        [__WEBPACK_IMPORTED_MODULE_3__constants__["x" /* COMPANY_NAME */], __WEBPACK_IMPORTED_MODULE_3__constants__["r" /* COUNTRY */], __WEBPACK_IMPORTED_MODULE_3__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_3__constants__["u" /* CITY */]].forEach(function (f) {
          return method.validate(f).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
        });

        if (__WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(values, "freight_forwarder_address.country") === "US") {
          [__WEBPACK_IMPORTED_MODULE_3__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_3__constants__["w" /* POSTAL_CODE */]].forEach(function (f) {
            return method.validate(f).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
          });
        }
      }
    });

    form.validateChild(__WEBPACK_IMPORTED_MODULE_3__constants__["_15" /* ULTIMATE_CONSIGNEE_ADDRESS */], function (method) {
      method.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["x" /* COMPANY_NAME */], __WEBPACK_IMPORTED_MODULE_3__constants__["r" /* COUNTRY */], __WEBPACK_IMPORTED_MODULE_3__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_3__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_3__constants__["w" /* POSTAL_CODE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    });

    form.validateChildren(__WEBPACK_IMPORTED_MODULE_3__constants__["A" /* LINE_ITEMS */], validateItem);
  });
});

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CARGO_SCREENING_CONSENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LICENSE_REQUIRED; });
var CARGO_SCREENING_CONSENT = "cargo_screening_consent";
var LICENSE_REQUIRED = "license_required";

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(16);
/* harmony export (immutable) */ __webpack_exports__["a"] = ConfirmDelete;




function ConfirmDelete(_ref) {
  var onConfirm = _ref.onConfirm,
      open = _ref.open,
      close = _ref.close,
      children = _ref.children,
      _ref$message = _ref.message,
      message = _ref$message === undefined ? "Are you sure you want to delete this?" : _ref$message;

  var confirm = function confirm() {
    onConfirm();
    close();
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Are You Sure?"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "alert alert-warning margin-bottom-none" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "media" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "media-left" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-warning text-warning" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "media-body" },
            children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "strong",
                null,
                "Heads up!"
              ),
              " ",
              message
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { type: "button", className: "btn btn-default", onClick: close },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { type: "button", className: "btn btn-danger", onClick: confirm },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-trash" }),
        " Delete"
      )
    )
  );
}

ConfirmDelete.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)]),
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* unused harmony export MiniDataTable */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






function TableHead(_ref) {
  var children = _ref.children;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "thead",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      null,
      children
    )
  );
}

TableHead.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element)
};

function PlaceholderRow() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", { style: { visibility: "hidden", height: "30px" } });
}

function LoadingRows(_ref2) {
  var rows = _ref2.rows,
      columns = _ref2.columns;

  var tableCell = function tableCell(i) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { key: i, colSpan: 1 });
  };

  return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.times(rows, function (i) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      { className: "animate-row", style: { height: 30 }, key: i },
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.times(columns, tableCell)
    );
  });
}

function TableBody(_ref3) {
  var children = _ref3.children,
      isLoading = _ref3.isLoading,
      columnCount = _ref3.columnCount,
      loadingRows = _ref3.loadingRows,
      loadAnimation = _ref3.loadAnimation;

  if (isLoading && loadAnimation) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingRows, { rows: loadingRows, columns: columnCount })
    );
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tbody",
    null,
    children.length > 0 ? children : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PlaceholderRow, null)
  );
}

TableBody.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element),
  isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  columnCount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  loadingRows: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  loadAnimation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

function MiniDataTable(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    DataTable,
    _extends({ loadingRows: 1 }, props, { responsive: false }),
    props.children
  );
}

MiniDataTable.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element)
};

var DataTable = function (_Component) {
  _inherits(DataTable, _Component);

  function DataTable() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, DataTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      loadAnimation: true
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DataTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.refresh) {
        this.intervalId = window.setInterval(function () {
          _this2.setState({ loadAnimation: false });
          _this2.props.refresh.bind(_this2)();
        }, 30000);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.loading === false) {
        this.setState({ loadAnimation: true });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.intervalId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          children = _props.children,
          loading = _props.loading,
          numbered = _props.numbered,
          noMargin = _props.noMargin,
          loadingRows = _props.loadingRows,
          withoutBaseline = _props.withoutBaseline,
          responsive = _props.responsive,
          striped = _props.striped,
          style = _props.style;


      var childrenWithProps = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
          isLoading: loading,
          loadAnimation: _this3.state.loadAnimation,
          columnCount: children[0].props.children.length,
          loadingRows: loadingRows
        });
      });

      var tableClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()("table table-hover", {
        "table-striped": striped,
        "table-numbered": numbered,
        "margin-bottom-none": noMargin,
        "no-baseline": withoutBaseline
      });

      var table = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "table",
        { style: style, className: tableClasses },
        childrenWithProps
      );

      return responsive ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "table-responsive", style: { whiteSpace: "nowrap" } },
        table
      ) : table;
    }
  }]);

  return DataTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DataTable.Mini = MiniDataTable;
DataTable.Head = TableHead;
DataTable.Body = TableBody;
DataTable.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element),
  refresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  loading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  numbered: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  withoutBaseline: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  noMargin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  loadingRows: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (DataTable);


DataTable.defaultProps = {
  numbered: false,
  noMargin: false,
  striped: true,
  withoutBaseline: false,
  responsive: true,
  loadingRows: 15
};

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CheckColumn__ = __webpack_require__(2289);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__CheckColumn__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataTable__ = __webpack_require__(774);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__DataTable__["a"]; });





/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = DetailTable;



function DetailTable(_ref) {
  var children = _ref.children;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-condensed" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      children
    )
  );
}

DetailTable.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element)])
};

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(778);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









function DownloadPackingSlipModal(_ref) {
  var open = _ref.open,
      close = _ref.close,
      record = _ref.record,
      _ref$partKey = _ref.partKey,
      partKey = _ref$partKey === undefined ? "part_number" : _ref$partKey,
      _ref$serialKey = _ref.serialKey,
      serialKey = _ref$serialKey === undefined ? "serial_number" : _ref$serialKey,
      url = _ref.url;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(record.line_items.map(function (l) {
    return l.id;
  })),
      _useState2 = _slicedToArray(_useState, 2),
      lineItemIds = _useState2[0],
      setLineItemIds = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(true),
      _useState4 = _slicedToArray(_useState3, 2),
      includeSoldTo = _useState4[0],
      setIncludeSoldTo = _useState4[1];

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0____["C" /* Modal */],
    { open: open, close: close, dialogClass: "modal-md" },
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Download Packing Slip"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Form__["a" /* default */], {
        record: record,
        close: close,
        includeSoldTo: includeSoldTo,
        setIncludeSoldTo: setIncludeSoldTo,
        lineItemIds: lineItemIds,
        setLineItemIds: setLineItemIds,
        serialKey: serialKey,
        partKey: partKey,
        url: url
      })
    ),
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Forms__["e" /* Form */].Cancel, { close: close, editable: true }),
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Forms__["e" /* Form */].Submit, {
        text: "Download",
        disabled: false,
        editable: true,
        onClick: function onClick() {
          window.open(url + "&" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_query_string__["stringify"])({
            line_item_ids: lineItemIds.join(","),
            include_sold_to: includeSoldTo
          }), "_blank");
          close();
        }
      })
    )
  );
}

DownloadPackingSlipModal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  partKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  record: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Map),
  serialKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  url: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (DownloadPackingSlipModal);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }








function Row(_ref) {
  var lineItem = _ref.lineItem,
      lineItemIds = _ref.lineItemIds,
      partKey = _ref.partKey,
      serialKey = _ref.serialKey,
      setLineItemIds = _ref.setLineItemIds;

  var selectItem = function selectItem(id) {
    var index = lineItemIds.indexOf(id);

    var _lineItemIds = _toArray(lineItemIds),
        arr = _lineItemIds.slice(0);

    if (index !== -1) {
      arr.splice(index, 1);
      setLineItemIds(arr);
    } else {
      setLineItemIds(arr.concat([id]));
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { style: { marginBottom: "6px" } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        name: "line_items",
        type: "checkbox",
        className: "pointer",
        checked: lineItemIds.includes(lineItem.id),
        onChange: function onChange() {
          return selectItem(lineItem.id);
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, partKey)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, serialKey)
    )
  );
}

Row.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  lineItemIds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  partKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  serialKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  setLineItemIds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

function Form(props) {
  var labelClasses = __WEBPACK_IMPORTED_MODULE_5_classnames___default()("btn btn-default", {
    active: props.includeSoldTo
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      {
        className: "table table-striped table-hover table-numbered",
        style: { marginBottom: 0 }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "thead",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Part #"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Serial #"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        props.record.line_items.map(function (l) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row, {
            partKey: props.partKey,
            serialKey: props.serialKey,
            lineItem: l,
            lineItemIds: props.lineItemIds,
            setLineItemIds: props.setLineItemIds
          });
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: "btn-group btn-group-justified",
              "data-toggle": "buttons"
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              { htmlFor: "sold_to", className: labelClasses },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                type: "checkbox",
                id: "sold_to",
                checked: props.includeSoldTo,
                onChange: function onChange() {
                  props.setIncludeSoldTo(!props.includeSoldTo);
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
              "\xA0\xA0Include Sold To"
            )
          )
        )
      )
    )
  );
}

Form.propTypes = {
  lineItemIds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  serialKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  partKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  setLineItemIds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(17);
/* unused harmony export DropDown */





function DropDown(_ref) {
  var icon = _ref.icon,
      menuClass = _ref.menuClass,
      visible = _ref.visible,
      toggle = _ref.toggle,
      children = _ref.children,
      _ref$buttonClasses = _ref.buttonClasses,
      buttonClasses = _ref$buttonClasses === undefined ? "btn-link" : _ref$buttonClasses,
      _ref$dropdownStyles = _ref.dropdownStyles,
      dropdownStyles = _ref$dropdownStyles === undefined ? {} : _ref$dropdownStyles,
      _ref$containerClasses = _ref.containerClasses,
      containerClasses = _ref$containerClasses === undefined ? {} : _ref$containerClasses,
      _ref$iconStyles = _ref.iconStyles,
      iconStyles = _ref$iconStyles === undefined ? {} : _ref$iconStyles;

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("dropdown control-dropdown", { open: visible }, containerClasses);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: classes, style: dropdownStyles },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      { className: buttonClasses, onClick: toggle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: icon, style: iconStyles })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "ul",
      { className: "dropdown-menu " + menuClass },
      children
    )
  );
}

DropDown.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  menuClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  iconStyles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element)]),
  containerClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  dropdownStyles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  buttonClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["c" /* dropdown */])(DropDown));

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExternalLink__ = __webpack_require__(212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ExternalLink__["a"]; });



/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);




var FilterOption = function FilterOption(_ref) {
  var filter = _ref.filter,
      _onClick = _ref.onClick;

  var dropdownItem = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2____["l" /* DropDownItem */],
    {
      key: filter.key || filter.label,
      onClick: function onClick() {
        return _onClick(filter.filters);
      }
    },
    filter.label,
    filter.hr && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed", style: { margin: "5px 0" } })
  )];

  if (filter.withAuthorization) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2____["b" /* Authorized */],
      filter.withAuthorization,
      dropdownItem
    );
  }

  return dropdownItem;
};

FilterOption.propTypes = {
  filter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(),
    withAuthorization: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      roles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
      authorizedIf: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
    })
  }).isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FilterOption);

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Warning_Warning__ = __webpack_require__(53);
/* harmony export (immutable) */ __webpack_exports__["a"] = FinalDestinationWarning;



function FinalDestinationWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__Warning_Warning__["a" /* default */],
    null,
    "For international shipments, please fill out Final Destination fields."
  );
}

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Check = function (_Component) {
  _inherits(Check, _Component);

  function Check() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Check);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Check.__proto__ || Object.getPrototypeOf(Check)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false
    }, _this.onChange = function () {
      var _this$props = _this.props,
          input = _this$props.input,
          onChange = _this$props.onChange;

      var value = !input.value;

      input.onChange(!!value);
      onChange(!!value);
    }, _this.onFocus = function () {
      _this.setState({ focused: true });
    }, _this.onBlur = function () {
      _this.setState({ focused: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Check, [{
    key: "render",
    value: function render() {
      var focused = this.state.focused;
      var _props = this.props,
          input = _props.input,
          label = _props.label,
          icon = _props.icon,
          disabled = _props.disabled,
          style = _props.style;


      var labelClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn btn-default", {
        active: input.value,
        focus: focused,
        disabled: disabled
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "label",
        { className: labelClasses, htmlFor: input.name, style: style },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          type: "checkbox",
          id: input.name,
          checked: input.value,
          onChange: this.onChange,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          disabled: disabled
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg " + icon }),
        "\xA0\xA0",
        label
      );
    }
  }]);

  return Check;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Check.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  }).isRequired
};
Check.defaultProps = {
  icon: "fa-check-circle",
  onChange: function onChange() {
    return null;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Check);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormInput__ = __webpack_require__(488);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LargeInput__ = __webpack_require__(2316);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__LargeInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextArea__ = __webpack_require__(2317);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__TextArea__["a"]; });







/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShippingMethod__ = __webpack_require__(2319);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ShippingMethod__["a"]; });



/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppForm__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(8);
/* harmony export (immutable) */ __webpack_exports__["a"] = FormikFooter;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };






function Submit(_ref) {
  var disabled = _ref.disabled,
      isSubmitting = _ref.isSubmitting,
      submitTimeout = _ref.submitTimeout,
      onClick = _ref.onClick,
      _ref$text = _ref.text,
      text = _ref$text === undefined ? "Save" : _ref$text,
      _ref$submittingText = _ref.submittingText,
      submittingText = _ref$submittingText === undefined ? "Saving" : _ref$submittingText;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    "button",
    {
      onClick: onClick,
      disabled: disabled || isSubmitting || submitTimeout,
      type: "submit",
      className: "btn btn-primary"
    },
    isSubmitting && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("i", { className: "fa fa-cog fa-spin fa-fw fa-lg" }),
    isSubmitting ? " " + submittingText : text
  );
}

function hasArrayOfErrors(obj) {
  if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" && obj !== null) {
    // eslint-disable-next-line no-restricted-syntax
    for (var key in obj) {
      if (Array.isArray(obj[key]) && obj[key].length > 0) {
        return true;
      } else if (_typeof(obj[key]) === "object" && obj[key] !== null) {
        if (hasArrayOfErrors(obj[key])) {
          return true;
        }
      }
    }
  }
  return false;
}

function FormikFooter(_ref2) {
  var disabled = _ref2.disabled,
      editable = _ref2.editable,
      errorMessages = _ref2.errorMessages,
      footer = _ref2.footer,
      handleSubmit = _ref2.handleSubmit,
      isSubmitting = _ref2.isSubmitting,
      setSubmitting = _ref2.setSubmitting,
      submitFailed = _ref2.submitFailed,
      submitSucceeded = _ref2.submitSucceeded,
      submitTimeout = _ref2.submitTimeout,
      close = _ref2.close,
      values = _ref2.values,
      rest = _ref2.rest;

  var errors = void 0;
  if (submitTimeout) {
    errors = ["The request timed out. Please refresh page and check to see if expected records were updated before resubmitting."];
  } else {
    errors = errorMessages;
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0__Modal__["d" /* Footer */],
    null,
    (submitFailed || submitTimeout) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["i" /* Errors */], { errors: errors }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AppForm__["c" /* Cancel */], { close: close, editable: editable }),
    footer,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Submit, {
      disabled: disabled || hasArrayOfErrors(rest.errors),
      isSubmitting: isSubmitting,
      onClick: function onClick(e) {
        e.preventDefault();
        setSubmitting(true);

        handleSubmit().then(function () {
          setSubmitting(false);
          close();
        }).catch(function () {});
      },
      values: values,
      submitSucceeded: submitSucceeded,
      submitTimeout: submitTimeout,
      editable: editable
    })
  );
}

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* unused harmony export FormField */





function FormField(_ref) {
  var field = _ref.field,
      _ref$form = _ref.form,
      touched = _ref$form.touched,
      errors = _ref$form.errors,
      label = _ref.label,
      required = _ref.required,
      addon = _ref.addon,
      append = _ref.append,
      children = _ref.children,
      labelChildren = _ref.labelChildren;

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("form-group", {
    "has-error": __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isArray"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(errors, field.name, [])) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(errors, field.name, []).length > 0
  });
  var asterisk = required && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "sup",
    { className: "small text-danger" },
    "*"
  );

  var jsxErrors = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(touched, field.name) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(errors, field.name) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(errors, field.name).map(function (m) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "help-block", key: m },
      m
    );
  });

  var getAddOns = function getAddOns() {
    if (addon) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "input-group" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "input-group-addon" },
          addon
        ),
        children
      );
    }

    if (append) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "input-group" },
        children,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "input-group-addon" },
          append
        )
      );
    }

    return children;
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: classes },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "label",
        { className: "control-label", htmlFor: field.name },
        label,
        asterisk,
        labelChildren
      ),
      getAddOns(),
      jsxErrors
    )
  );
}

FormField.propTypes = {
  field: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired }).isRequired,
  meta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
  }).isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  labelChildren: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  append: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (FormField);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_formik__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NumberInput_NumberInput__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormField__ = __webpack_require__(787);
/* harmony export (immutable) */ __webpack_exports__["a"] = FormInput;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







function FormInput(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === undefined ? "text" : _ref$type,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? "" : _ref$className,
      name = _ref.name,
      label = _ref.label,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === undefined ? false : _ref$isRequired,
      parse = _ref.parse,
      inputProps = _objectWithoutProperties(_ref, ["type", "className", "name", "label", "disabled", "isRequired", "parse"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_formik__["a" /* Field */],
    { name: name },
    function (_ref2) {
      var field = _ref2.field,
          meta = _ref2.meta,
          childProps = _objectWithoutProperties(_ref2, ["field", "meta"]);

      var onBlur = void 0;
      if (type === "number" && inputProps.step === "0.01") {
        onBlur = function onBlur(ev) {
          ev.target.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__NumberInput_NumberInput__["b" /* rounder */])(ev.target.value);
          field.onBlur(ev);
        };
      } else {
        onBlur = field.onBlur;
      }

      // Handle parsing on change
      var handleChange = function handleChange(ev) {
        var parsedValue = parse ? parse(ev.target.value) : ev.target.value;
        // Create a new event object with the same properties as the original event
        var newEvent = _extends({}, ev, {
          target: _extends({}, ev.target, {
            value: parsedValue,
            name: name // Ensure the name attribute is included
          })
        });
        field.onChange(newEvent); // Pass the new event object to field.onChange
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__FormField__["a" /* default */],
        _extends({}, childProps, {
          field: field,
          label: label,
          required: isRequired
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({
          type: type,
          onChange: handleChange,
          onBlur: onBlur,
          name: name,
          disabled: disabled,
          value: field.value === meta.initialValue && type === "number" && inputProps.step === "0.01" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__NumberInput_NumberInput__["b" /* rounder */])(field.value) : field.value,
          className: "form-control " + className
        }, inputProps))
      );
    }
  );
}

/* unused harmony default export */ var _unused_webpack_default_export = (FormInput);

FormInput.propTypes = {
  parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  input: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({ name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired }).isRequired,
  type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  autoComplete: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  readOnly: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  isRequired: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    min: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
    max: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
    placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number])
  })
};

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MonthYearField__ = __webpack_require__(348);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MonthYearField__["a"]; });



/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formField__ = __webpack_require__(142);
/* harmony export (immutable) */ __webpack_exports__["b"] = Select;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





function renderOption(o) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "option",
    { key: o.value, value: o.value },
    o.text
  );
}

function Select(_ref) {
  var input = _ref.input,
      options = _ref.options,
      _ref$prompt = _ref.prompt,
      prompt = _ref$prompt === undefined ? "(Select one)" : _ref$prompt,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === undefined ? false : _ref$multiple;

  var blank = prompt && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "option",
    { value: "" },
    prompt
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "select",
    _extends({
      className: "form-control"
    }, input, {
      disabled: disabled,
      multiple: multiple
    }),
    blank,
    options.map(renderOption)
  );
}

Select.propTypes = {
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired }).isRequired,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired
  })).isRequired,
  prompt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formField__["a" /* default */])(Select));

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_humanize_string__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_humanize_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_humanize_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flat__ = __webpack_require__(2753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_flat__);
/* harmony export (immutable) */ __webpack_exports__["b"] = submitErrorMsgs;
/* harmony export (immutable) */ __webpack_exports__["a"] = form;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






function humanizeFieldName(str) {
  return __WEBPACK_IMPORTED_MODULE_2_humanize_string___default()(str.split(".").join(" "));
}

function fieldErrorMsgs() {
  var fieldErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var cleanErrors = {};

  (Object.keys(fieldErrors) || []).forEach(function (fieldName) {
    var val = fieldErrors[fieldName];

    if (Array.isArray(val) && val.length > 0 && _typeof(val[0]) === "object") {
      (Object.keys(fieldErrors[fieldName]) || []).forEach(function (fieldIndex) {
        cleanErrors[fieldName + "." + (parseInt(fieldIndex, 10) + 1)] = fieldErrors[fieldName][fieldIndex];
      });
    } else {
      cleanErrors[fieldName] = fieldErrors[fieldName];
    }
  });

  var errors = __WEBPACK_IMPORTED_MODULE_3_flat___default()(cleanErrors, { safe: true });

  return (Object.keys(errors || {}) || []).map(function (fieldName) {
    var errorMsgs = Array.isArray(errors[fieldName]) ? errors[fieldName] : [].map(function (e) {
      return e.toLowerCase();
    }).join(", ");
    var uniqErrorMsgs = Array.from(new Set(errorMsgs));

    return humanizeFieldName(fieldName) + " " + uniqErrorMsgs;
  });
}

function submitErrorMsgs(submitErrors) {
  return (Object.keys(submitErrors || {}) || []).map(function (fieldName) {
    submitErrors[fieldName] = submitErrors[fieldName] || [];
    if (fieldName === "base") {
      return "" + submitErrors[fieldName].join(", ");
    }
    return __WEBPACK_IMPORTED_MODULE_2_humanize_string___default()(fieldName) + " " + submitErrors[fieldName].join(", ");
  });
}

// Enhances reduxForm HoC by adding an errorMessages prop that contains an array
// of formatted error messages for all types of redux-form errors.
function form(props) {
  return function (FormComponent) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
      var baseMsgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["getFormError"])(props.form)(state) || [];
      var syncMsgs = fieldErrorMsgs(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["getFormSyncErrors"])(props.form)(state));
      var asyncMsgs = fieldErrorMsgs(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["getFormAsyncErrors"])(props.form)(state));
      var submitMsgs = submitErrorMsgs(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["getFormSubmitErrors"])(props.form)(state));

      return {
        errorMessages: [].concat(_toConsumableArray(new Set([].concat(syncMsgs, asyncMsgs, submitMsgs, baseMsgs))))
      };
    })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])(_extends({}, props))(FormComponent));
  };
}

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(491);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Icon__["a"]; });



/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Portal__ = __webpack_require__(2418);




function ImagePortal(_ref) {
  var name = _ref.name,
      open = _ref.open,
      url = _ref.url,
      setOpen = _ref.setOpen;

  if (!open || !url) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__containers_Portal__["a" /* default */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "portal-overlay" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { className: "portal-overlay", onClick: function onClick() {
          return setOpen(!open);
        } })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
      alt: name,
      src: url,
      width: "33%",
      style: {
        boxShadow: "0 4px 4px rgba(0, 0, 0, 0.7)",
        zIndex: 2041,
        marginLeft: "33%",
        position: "fixed",
        top: "10%"
      }
    })
  );
}

ImagePortal.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  setOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ImagePortal);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NoteTooltip_NoteTooltip__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__inventories_constants__ = __webpack_require__(12);
/* harmony export (immutable) */ __webpack_exports__["b"] = RepairingIcon;











function RepairingIcon(_ref) {
  var inventory = _ref.inventory;

  var isManagedRepair = inventory.managed_repair_repaired || inventory.managed_repair_in_progress;
  if (inventory.repair_status && inventory.repair_status !== __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["h" /* REPAIRED */] || isManagedRepair) {
    var repairOrderId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(inventory, "repair_order_line_items[0].repair_order_id");

    var awb = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(inventory, "repair_order_line_items[0].incoming_awb_number");

    var carrier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(inventory, "repair_order_line_items[0].return_to_shipping_method.carrier");

    var isIncoming = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(awb);

    var approvalStatusRaw = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(inventory, "repair_order_line_items[0].approval_status");

    var approvalStatus = approvalStatusRaw ? approvalStatusRaw.replace(/_/g, " ") // Replace underscores with spaces
    .replace(/\b\w/g, function (char) {
      return char.toUpperCase();
    }) // Capitalize each word
    : "";

    var text = isManagedRepair ? "Managed Repair In Progress" : "In Repair Process " + approvalStatus;

    var icon = isManagedRepair ? "fa-recycle" : "fa-wrench";

    if (!repairOrderId) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["j" /* NoteTooltip */], { icon: icon, note: text, color: "#FFFFFF" });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],
      { to: "/repair-orders/" + repairOrderId },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["j" /* NoteTooltip */], {
        icon: icon,
        placement: "top",
        note: isIncoming ? "Returning from Repair Process<br />" + (carrier ? carrier.toUpperCase() + " " : "") + "AWB# " + awb : text,
        color: "#FFFFFF"
      })
    );
  }

  return null;
}

RepairingIcon.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    repair_status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.required
  })
};

var getIconColor = function getIconColor(inventory) {
  switch (inventory.listing_override) {
    case true:
      return "#4caf50";
    case false:
      return "red";
    default:
      return "inherit";
  }
};

var getListingText = function getListingText(listingOverride) {
  switch (listingOverride) {
    case true:
      return "Listing Override: LIST FOR SALE";
    case false:
      return "Listing Override: DO NOT LIST";
    default:
      return "";
  }
};

var RenderListingOverrideIcon = function RenderListingOverrideIcon(_ref2) {
  var inventory = _ref2.inventory;

  var iconColor = getIconColor(inventory);
  var text = getListingText(inventory.listing_override);

  switch (inventory.listing_override) {
    case true:
    case false:
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__NoteTooltip_NoteTooltip__["a" /* default */], { color: iconColor, icon: "fa-registered", note: text });
    default:
      return null;
  }
};

var buildNote = function buildNote(inventory, minOutrightValue) {
  var notes = [];

  if (inventory.do_not_exchange) {
    notes.push("Do Not Exchange - Line Item Restriction");
  }
  if (inventory.do_not_exchange_due_to_outright_value) {
    notes.push("Do Not Exchange - Outright Value Under " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(minOutrightValue));
  }
  if (inventory.part.pass_fail) {
    notes.push("Do Not Exchange - Due to Pass Fail");
  }

  return notes.join("<br />");
};

var ConsolidatedIconTooltip = function ConsolidatedIconTooltip(_ref3) {
  var inventory = _ref3.inventory;

  var settings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks_useCurrentUser__["b" /* useSettings */])();
  var minOutrightValue = settings[__WEBPACK_IMPORTED_MODULE_7__constants__["_22" /* MIN_OUTRIGHT_VALUE_FOR_EXCHANGE_CONSIDERATION */]];
  var note = buildNote(inventory, minOutrightValue);
  var condition = inventory.condition;

  return note && condition !== "as_removed" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["j" /* NoteTooltip */], {
    icon: "fa-times-circle-o",
    note: note,
    color: "#f44336",
    placement: "top"
  }) : null;
};

var InventoryListingOverrideCell = function InventoryListingOverrideCell(_ref4) {
  var inventory = _ref4.inventory,
      renderDummyValues = _ref4.renderDummyValues;

  var doNotSellNote = "DO NOT SELL!" + (inventory.do_not_sell_reason ? " " + inventory.do_not_sell_reason : "");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    !renderDummyValues && inventory.reserve_for_seller_id && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["j" /* NoteTooltip */], {
      icon: "fa-lock",
      placement: "top",
      note: "Reserved for Sale",
      color: "#FFFFFF"
    }),
    " ",
    !renderDummyValues && inventory.active_transfer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["j" /* NoteTooltip */], {
      icon: "fa-plane",
      placement: "top",
      note: "Store Transfer",
      color: "#FFFFFF"
    }),
    " ",
    !renderDummyValues && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RepairingIcon, { inventory: inventory }),
    " ",
    !renderDummyValues && inventory.unsellable_per_user && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["j" /* NoteTooltip */], {
      icon: "fa-diamond",
      placement: "top",
      note: doNotSellNote,
      color: "#ecb100"
    }),
    inventory.status === "out_on_exchange" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["j" /* NoteTooltip */], {
      icon: "fa-exchange",
      placement: "top",
      note: "Out on Exchange",
      color: "#FFFFFF"
    }),
    renderDummyValues && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["j" /* NoteTooltip */], { icon: "fa-copy", note: "Dummy Stock Line" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConsolidatedIconTooltip, { inventory: inventory }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderListingOverrideIcon, { inventory: inventory })
  );
};

InventoryListingOverrideCell.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  renderDummyValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (InventoryListingOverrideCell);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InventoryListingOverrideCell__ = __webpack_require__(794);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InventoryListingOverrideCell__["a"]; });



/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InventoryQuantityCell__ = __webpack_require__(2340);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InventoryQuantityCell__["a"]; });



/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventories_constants__ = __webpack_require__(12);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSellableClass; });
/* harmony export (immutable) */ __webpack_exports__["a"] = InventoryStatusCell;





var getSellableClass = function getSellableClass(_ref) {
  var status = _ref.status,
      sellableStatus = _ref.sellable_status;
  return __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
    "green-table-cap": sellableStatus === __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["U" /* LIST */] && status !== __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["V" /* RESERVE_FOR_SALE */],
    "warning-table-cap": sellableStatus === __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["W" /* DO_NOT_LIST */] && status !== __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["V" /* RESERVE_FOR_SALE */],
    "danger-table-cap": sellableStatus === __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["X" /* DO_NOT_SELL */] || status === __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["V" /* RESERVE_FOR_SALE */]
  });
};

function InventoryStatusCell(_ref2) {
  var inventory = _ref2.inventory,
      children = _ref2.children;

  if (!inventory) return null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: getSellableClass(inventory) },
    children
  );
}

InventoryStatusCell.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    sellable_status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)])
};

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InventoryTagDateCell__ = __webpack_require__(2341);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InventoryTagDateCell__["a"]; });



/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AuditFields_AuditFields__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Edit__ = __webpack_require__(2357);









var updatedBy = function updatedBy(record, field) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    "Last Edited: ",
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__AuditFields_AuditFields__["b" /* modifiedAt */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(record, field + "_audit.updated_at")),
    " by",
    " ",
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["d" /* getFirstNameLastInitial */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(record, field + "_audit.updated_by.full_name"))
  );
};

var AuditFields = function AuditFields(_ref) {
  var record = _ref.record,
      field = _ref.field;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "p",
    { className: "text-muted small" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "em",
      null,
      updatedBy(record, field)
    )
  );
};

function Note(_ref2) {
  var header = _ref2.header,
      record = _ref2.record,
      type = _ref2.type,
      update = _ref2.update;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      header,
      type === __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* INTERNAL_NOTE */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Edit__["a" /* EditInternalNote */], {
        record: record,
        update: update,
        spanClass: "",
        text: "Edit",
        buttonIcon: "fa-plus",
        buttonClass: "btn-primary btn-hollow pull-right"
      }),
      type === __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Edit__["b" /* EditExternalNote */], {
        record: record,
        update: update,
        spanClass: "",
        text: "Edit",
        buttonIcon: "fa-plus",
        buttonClass: "btn-primary btn-hollow pull-right"
      })
    ),
    ![null, ""].includes(record[type]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "panel panel-default panel-note" },
      record[type + "_audit"] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "panel-heading" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AuditFields, { record: record, field: type })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "panel-body" },
        record[type]
      )
    )
  );
}

Note.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    internal_note: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external_note: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  update: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Note);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NoteTooltip__ = __webpack_require__(120);
/* harmony export (immutable) */ __webpack_exports__["a"] = NoteTooltipTableCell;




function NoteTooltipTableCell(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? undefined : _ref$color,
      note = _ref.note,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? "text-center td-shrink-icon" : _ref$className;

  return note ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__NoteTooltip__["a" /* default */], { color: color, note: note })
  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null);
}

NoteTooltipTableCell.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  note: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isInternalOrExternalNote__ = __webpack_require__(803);


/* harmony default export */ __webpack_exports__["a"] = (function (notesType) {
  var defaultFieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "body";

  if (notesType && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isInternalOrExternalNote__["a" /* default */])(notesType)) {
    return notesType + "_note";
  }

  return defaultFieldName;
});

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notes__ = __webpack_require__(282);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Notes__["a"]; });



/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (notesType) {
  return ["accounting", "internal", "external"].includes(notesType);
});

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PartNumber__ = __webpack_require__(283);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PartNumber__["a"]; });


/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailTable__ = __webpack_require__(83);
/* harmony export (immutable) */ __webpack_exports__["a"] = PhysicalAddress;




function PhysicalAddress(_ref) {
  var address = _ref.address;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__DetailTable__["a" /* DetailTable */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DetailTable__["b" /* Detail */], { label: "Address Line", value: address.line1 }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DetailTable__["b" /* Detail */], { label: "City", value: address.city }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DetailTable__["b" /* Detail */], { label: "State/ Province/ Region", value: address.state }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DetailTable__["b" /* Detail */], { label: "ZIP/ Postal Code", value: address.postal_code }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DetailTable__["b" /* Detail */], { label: "Country", value: address.country })
  );
}

PhysicalAddress.propTypes = {
  address: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    line1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    city: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    postal_code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RemoveFromQCHold__ = __webpack_require__(2382);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RemoveFromQCHold__["a"]; });


/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SalesOrderLineItemStatusCell__ = __webpack_require__(2383);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SalesOrderLineItemStatusCell__["a"]; });



/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__middleware_syncSearchStateWithUrl__ = __webpack_require__(631);
/* harmony export (immutable) */ __webpack_exports__["a"] = SearchComponent;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SearchPropTypes; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Search = function (_React$Component) {
  _inherits(Search, _React$Component);

  function Search() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Search);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Search.__proto__ || Object.getPrototypeOf(Search)).call.apply(_ref, [this].concat(args))), _this), _this.keyStroke = function (evt) {
      var _this$props = _this.props,
          paginator = _this$props.paginator,
          pageActions = _this$props.pageActions;


      var page = paginator.get("page");

      var totalPages = Math.ceil(paginator.get("totalCount") / paginator.get("pageSize"));

      if (page && page > 1 && evt.ctrlKey && evt.key === "l") {
        pageActions.prev();
        evt.preventDefault();
      }

      if (page && page < totalPages && evt.ctrlKey && evt.key === "r") {
        pageActions.next();
        evt.preventDefault();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Search, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      window.addEventListener("keydown", this.keyStroke);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          search = _props.search,
          syncWithUrl = _props.syncWithUrl;

      if (syncWithUrl) {
        this.initializeSearchFromUrl();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__middleware_syncSearchStateWithUrl__["a" /* registerSearch */])(search);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__middleware_syncSearchStateWithUrl__["b" /* unregisterSearch */])(this.props.search);
      window.removeEventListener("keydown", this.keyStroke);
    }
  }, {
    key: "initializeSearchFromUrl",
    value: function initializeSearchFromUrl() {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          search = _props2.search;

      var _parse = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_query_string__["parse"])(location.search),
          filter = _parse.filter,
          limit = _parse.limit,
          page = _parse.page,
          filters = _objectWithoutProperties(_parse, ["filter", "limit", "page"]);

      if (limit !== undefined) {
        dispatch(search.setLimit(limit));
      }
      if (Object.keys(filters).length > 0) {
        dispatch(search.setFilters(filters));
      }
      if (filter !== undefined) {
        dispatch(search.setFilter("filter", filter));
      }
      if (page !== undefined) {
        dispatch(search.setPage(page));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(_extends({}, this.props));
    }
  }]);

  return Search;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Search.propTypes = {
  search: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  syncWithUrl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  paginator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"]).isRequired,
  pageActions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    next: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    prev: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  }).isRequired
};

function SearchComponent(_ref2) {
  var search = _ref2.search,
      syncWithUrl = _ref2.syncWithUrl,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, ["search", "syncWithUrl", "children"]);

  var WithPaginator = __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__["decorators"].decorate(Search, function (_ref3) {
    var paginator = _ref3.paginator;
    return _extends({
      paginator: paginator,
      children: children,
      search: search,
      syncWithUrl: syncWithUrl
    }, rest);
  });

  var Tabulated = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])()(__WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__["decorators"].tabulate(WithPaginator));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tabulated, { listId: search.listId });
}

SearchComponent.propTypes = {
  search: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  syncWithUrl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

var SearchPropTypes = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
  pageActions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  results: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object)).isRequired
});

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Warning_Warning__ = __webpack_require__(53);
/* unused harmony export Form */
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }














function Form(_ref) {
  var close = _ref.close,
      formWarning = _ref.formWarning,
      handleSubmit = _ref.handleSubmit,
      invalid = _ref.invalid,
      submitting = _ref.submitting,
      label = _ref.label,
      _ref$modal = _ref.modal,
      modal = _ref$modal === undefined ? true : _ref$modal;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "form",
    { onSubmit: handleSubmit, modal: modal },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__Modal__["e" /* Body */],
      null,
      formWarning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__Warning_Warning__["a" /* default */],
        null,
        formWarning
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__Forms__["d" /* FormInput */], name: "to", label: "To:", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__Forms__["d" /* FormInput */], name: "cc", label: "CC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__Forms__["d" /* FormInput */], name: "bcc", label: "BCC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__Forms__["d" /* FormInput */], name: "subject", label: "Subject", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__Forms__["l" /* TextArea */], name: "body", label: "Body", required: true })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
        { onClick: close },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
        {
          type: "submit",
          bsStyle: "primary",
          disabled: invalid || submitting
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7____["k" /* Icon */], { name: "envelope", fixed: true }),
        "\xA0Yes, Send ",
        label
      )
    )
  );
}

Form.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  formWarning: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  modal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var withInitialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__decorators__["m" /* dataManager */])("initialValues", function () {
  var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref3) {
    var recordId = _ref3.recordId,
        url = _ref3.url,
        type = _ref3.type;

    var _ref4, preview;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return url.preview(recordId, { type: type });

          case 2:
            _ref4 = _context.sent;
            preview = _ref4.data;
            return _context.abrupt("return", preview);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (withInitialValues(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reduxForm"])({
  form: "send-form",
  validate: function validate(values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_validate_this__["a" /* validator */])(values, function (form) {
      form.validate("subject", "body", "to").satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["a" /* required */]);
      form.validate("to", "cc", "bcc").satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["b" /* isValidEmail */]);
    });
  },
  onSubmit: function () {
    var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(data, _, props) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return props.url.send(props.recordId, data).then(function () {
                props.close();
                __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__["toastr"].success("Success", "Email processing.");
              }).catch(function () {
                return __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__["toastr"].error("Error", "Could not send email. Please refresh page and try again.");
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function onSubmit(_x2, _x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }()
})(Form)));

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Form__ = __webpack_require__(809);
/* harmony export (immutable) */ __webpack_exports__["a"] = SendEmail;










function SendEmail(_ref) {
  var warning = _ref.warning,
      record = _ref.record,
      label = _ref.label,
      url = _ref.url,
      type = _ref.type;

  if (record.get(__WEBPACK_IMPORTED_MODULE_7__constants__["_38" /* CANCELLED */]) || record.get(__WEBPACK_IMPORTED_MODULE_7__constants__["_26" /* RECEIVED */])) {
    return false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__DropDown_DropDownItem__["a" /* default */],
        { onClick: open },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["k" /* Icon */], { name: "envelope-o", fixed: true }),
        "\xA0Send ",
        label,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__Modal__["a" /* Modal */],
          { open: visible, close: close, dialogClass: "modal-lg" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modal__["c" /* Close */], { close: close }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Are You Sure?"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Form__["a" /* default */], {
            label: label,
            close: close,
            recordId: record.get(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* ID */]),
            url: url,
            type: type,
            formWarning: warning,
            disabledReason: warning
          })
        )
      );
    }
  );
}

SendEmail.propTypes = {
  warning: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_countries__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RestictedAddressWarning_RestrictedAddressWarning__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__State__ = __webpack_require__(2393);
/* harmony export (immutable) */ __webpack_exports__["a"] = ShipToOther;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var countryOptions = __WEBPACK_IMPORTED_MODULE_7__lib_countries__["a" /* default */].map(function (c) {
  return {
    value: c.code,
    text: c.name
  };
});

function ShipToOther(_ref) {
  var getField = _ref.getField,
      _ref$section = _ref.section,
      section = _ref$section === undefined ? "ship_to_shipping_address" : _ref$section;

  var addressFields = getField ? [__WEBPACK_IMPORTED_MODULE_5__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_5__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_5__constants__["w" /* POSTAL_CODE */], __WEBPACK_IMPORTED_MODULE_5__constants__["r" /* COUNTRY */]].reduce(function (final, f) {
    return _extends({}, final, _defineProperty({}, f, getField(section + "." + f)));
  }, {}) : {};

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_redux_form__["FormSection"],
    { name: section },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_5__constants__["x" /* COMPANY_NAME */],
          component: __WEBPACK_IMPORTED_MODULE_3__Forms__["d" /* FormInput */],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_5__constants__["x" /* COMPANY_NAME */]),
          required: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: __WEBPACK_IMPORTED_MODULE_5__constants__["D" /* CARE_OF */], component: __WEBPACK_IMPORTED_MODULE_3__Forms__["d" /* FormInput */], label: "C/O" })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_5__constants__["r" /* COUNTRY */],
          component: __WEBPACK_IMPORTED_MODULE_3__Forms__["c" /* Select */],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_5__constants__["r" /* COUNTRY */]),
          options: countryOptions,
          required: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_5__constants__["E" /* CONTACT_NAME */],
          component: __WEBPACK_IMPORTED_MODULE_3__Forms__["d" /* FormInput */],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_5__constants__["E" /* CONTACT_NAME */]),
          options: countryOptions
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_5__constants__["s" /* LINE1 */],
          component: __WEBPACK_IMPORTED_MODULE_3__Forms__["d" /* FormInput */],
          label: "Address Line 1",
          required: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: __WEBPACK_IMPORTED_MODULE_5__constants__["t" /* LINE2 */], component: __WEBPACK_IMPORTED_MODULE_3__Forms__["d" /* FormInput */], label: "Address Line 2" })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* CITY */],
          component: __WEBPACK_IMPORTED_MODULE_3__Forms__["d" /* FormInput */],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_5__constants__["u" /* CITY */]),
          required: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Fields"], { names: [__WEBPACK_IMPORTED_MODULE_5__constants__["r" /* COUNTRY */], __WEBPACK_IMPORTED_MODULE_5__constants__["v" /* STATE */]], component: __WEBPACK_IMPORTED_MODULE_10__State__["a" /* default */] })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_5__constants__["w" /* POSTAL_CODE */],
          component: __WEBPACK_IMPORTED_MODULE_3__Forms__["d" /* FormInput */],
          label: "Zip/Postal Code",
          required: true
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__RestictedAddressWarning_RestrictedAddressWarning__["a" /* default */], addressFields)
      )
    )
  );
}

ShipToOther.propTypes = {
  section: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Forms_FormSections__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__decorators_withFormFields__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ShipToFields__ = __webpack_require__(2392);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
















function ShippingSection(_ref) {
  var copyBillingAddress = _ref.copyBillingAddress,
      getField = _ref.getField,
      shipToCustomer = _ref.shipToCustomer,
      shipToCompany = _ref.shipToCompany,
      shippingType = _ref.shippingType,
      children = _ref.children,
      setFieldValue = _ref.setFieldValue,
      setFOB = _ref.setFOB,
      returnToType = _ref.return_to_type,
      shipToType = _ref.ship_to_type,
      wtDimsReq = _ref.wtDimsReq,
      beforeShippingMethod = _ref.beforeShippingMethod,
      setShippingToAddress = _ref.setShippingToAddress,
      convertSO = _ref.convertSO,
      preferredShippingMethods = _ref.preferredShippingMethods,
      props = _objectWithoutProperties(_ref, ["copyBillingAddress", "getField", "shipToCustomer", "shipToCompany", "shippingType", "children", "setFieldValue", "setFOB", "return_to_type", "ship_to_type", "wtDimsReq", "beforeShippingMethod", "setShippingToAddress", "convertSO", "preferredShippingMethods"]);

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedMethod = _useState2[0],
      setSelectedMethod = _useState2[1];

  var shipTypeInput = shippingType === __WEBPACK_IMPORTED_MODULE_11__constants__["B" /* SHIP_TO */] ? shipToType : returnToType;

  var handleSelectChange = function handleSelectChange(event) {
    var methodId = event.target.value;
    var method = preferredShippingMethods.find(function (m) {
      return m.id.toString() === methodId;
    });
    setSelectedMethod(method);
  };

  var shippingMethodOptions = preferredShippingMethods.map(function (method) {
    return {
      label: "\n      CARRIER: " + method.carrier.toUpperCase() + "\n      - METHOD: " + method.shipping_method.replace(/_/g, " ").toUpperCase() + "\n      - ACCOUNT #: " + (method.account_number || "N/A"),
      value: method.id.toString()
    };
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { xs: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
          discreet: props.discreet,
          name: shippingType + "_type",
          component: __WEBPACK_IMPORTED_MODULE_5__Forms__["m" /* RadioGroupField */],
          options: props.shipToOptions || __WEBPACK_IMPORTED_MODULE_12__shippingTypes__["c" /* shipToOptions */],
          label: shippingType === __WEBPACK_IMPORTED_MODULE_11__constants__["B" /* SHIP_TO */] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__constants__["B" /* SHIP_TO */]) : "Return To",
          required: true
        })
      )
    ),
    shippingMethodOptions.length > 0 && shippingMethodOptions.length !== 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__Forms_FormRow__["a" /* default */],
      { style: { marginBottom: "15px" } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { xs: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { htmlFor: "preferred_shipping_method" },
          "Preferred Shipping Methods"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "select",
          { className: "form-control", onChange: handleSelectChange },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "option",
            { value: "" },
            "Select one"
          ),
          shippingMethodOptions.map(function (option) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "option",
              { key: option.value, value: option.value },
              option.label
            );
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Fields"], {
      copyBillingAddress: copyBillingAddress,
      component: __WEBPACK_IMPORTED_MODULE_13__ShipToFields__["a" /* default */],
      getFieldValue: getField,
      names: [shippingType + "_type"],
      shipToType: shipTypeInput.input.value,
      setFieldValue: setFieldValue,
      setFOB: setFOB,
      shipToCompany: shipToCompany,
      shipToCustomer: shipToCustomer,
      setShippingToAddress: setShippingToAddress
    }),
    convertSO && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_redux_form__["FormSection"],
      { name: shippingType + "_shipping_method" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Forms_FormSections__["a" /* ShippingMethod */], {
        wtDimsReq: wtDimsReq,
        selectedCarrier: selectedMethod ? selectedMethod.carrier : "",
        selectedShippingMethod: selectedMethod ? selectedMethod.shipping_method : "",
        selectedAccountNumber: selectedMethod ? selectedMethod.account_number : ""
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm hr-dashed margin-top-none" }),
    beforeShippingMethod && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
      null,
      beforeShippingMethod,
      !convertSO && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm hr-dashed margin-top-none" })
    ),
    !convertSO && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_redux_form__["FormSection"],
      { name: shippingType + "_shipping_method" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Forms_FormSections__["a" /* ShippingMethod */], {
        wtDimsReq: wtDimsReq,
        selectedCarrier: selectedMethod ? selectedMethod.carrier : "",
        selectedShippingMethod: selectedMethod ? selectedMethod.shipping_method : "",
        selectedAccountNumber: selectedMethod ? selectedMethod.account_number : ""
      })
    ),
    children
  );
}

ShippingSection.defaultProps = {
  shippingType: __WEBPACK_IMPORTED_MODULE_11__constants__["B" /* SHIP_TO */],
  shipToCompany: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),
  shipToCustomer: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),
  beforeShippingMethod: null,
  preferredShippingMethods: []
};

ShippingSection.propTypes = {
  copyBillingAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  discreet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setFOB: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setShippingToAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)]),
  shipToCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  shipToCustomer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  return_to_type: __WEBPACK_IMPORTED_MODULE_6__Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_6__Forms_FormTypes__["stringInput"]).isRequired,
  ship_to_type: __WEBPACK_IMPORTED_MODULE_6__Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_6__Forms_FormTypes__["stringInput"]).isRequired,
  shipToOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  wtDimsReq: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  beforeShippingMethod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  preferredShippingMethods: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object))
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__decorators_withFormFields__["a" /* default */])(ShippingSection, [__WEBPACK_IMPORTED_MODULE_11__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_11__constants__["C" /* RETURN_TO_TYPE */]]));

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CancellationStatsTooltip__ = __webpack_require__(2395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DetailStat__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__format__ = __webpack_require__(144);
/* harmony export (immutable) */ __webpack_exports__["a"] = Detail;
/* harmony export (immutable) */ __webpack_exports__["c"] = CompanyRepairStatsDetail;
/* harmony export (immutable) */ __webpack_exports__["b"] = CompanyPurchaseStatsDetail;
/* harmony export (immutable) */ __webpack_exports__["d"] = CompanySaleStatsDetail;









var containerStyles = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  paddingTop: 20,
  paddingBottom: 20
};

var statsContainerStyles = {
  width: "100%"
};

var headerStyles = {
  alignSelf: "flex-start",
  margin: 0,
  paddingLeft: 20,
  paddingRight: 20,
  color: "gray",
  minWidth: 90,
  textTransform: "none"
};

var separatorStyles = {
  borderTop: "1px solid rgba(0, 0, 0, 0.15)",
  marginTop: 10,
  marginBottom: 20
};

function Detail(_ref) {
  var stats = _ref.stats,
      context = _ref.context;

  var showRepairStats = context === "repair" || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.some(stats.repairs, function (value) {
    return Math.abs(value) !== 0;
  });
  var showSalesStats = context === "standard" || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.some(stats.sales, function (value) {
    return Math.abs(value) !== 0;
  });
  var showPurchasingStats = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.some(stats.purchases, function (value) {
    return Math.abs(value) !== 0;
  });

  var defaultStats = void 0;
  if (context === "repair") {
    defaultStats = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CompanyRepairStatsDetail, { stats: stats.repairs || {} });
  } else {
    defaultStats = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CompanySaleStatsDetail, { stats: stats.sales || {} });
  }

  var expandedStats = void 0;
  if (context === "repair") {
    expandedStats = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      showPurchasingStats && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { style: separatorStyles }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CompanyPurchaseStatsDetail, { stats: stats.purchases })
      ),
      showSalesStats && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { style: separatorStyles }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CompanySaleStatsDetail, { stats: stats.sales })
      )
    );
  } else {
    expandedStats = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      showPurchasingStats && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { style: separatorStyles }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CompanyPurchaseStatsDetail, { stats: stats.purchases })
      ),
      showRepairStats && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { style: separatorStyles }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CompanyRepairStatsDetail, { stats: stats.repairs })
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    defaultStats,
    expandedStats
  );
}

Detail.propTypes = {
  stats: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  company: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  }),
  context: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["standard", "repair"])
};

function CompanyRepairStatsDetail(_ref2) {
  var stats = _ref2.stats;

  var year = __WEBPACK_IMPORTED_MODULE_4_moment___default()().year();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: containerStyles },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h4",
      { style: headerStyles },
      "Repairs"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: statsContainerStyles },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "# Repairs Sent - " + year,
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["a" /* number */])(stats.repairs_current_year_count),
        offset: 2
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "$ Repairs Sent - " + year,
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["b" /* dollar */])(stats.repairs_current_year_dollars)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "# Repairs Sent - " + (year - 1),
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["a" /* number */])(stats.repairs_last_year_count)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "$ Repairs Sent - " + (year - 1),
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["b" /* dollar */])(stats.repairs_last_year_dollars)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
          label: "# Total Warranties - 12 mos.",
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["c" /* numberAndPercent */])(stats.warranties_12_months_count, stats.warranties_12_months_percent),
          offset: 3
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
          label: "# Warranties Accepted - 12 mos.",
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["c" /* numberAndPercent */])(stats.warranties_approved_12_months_count, stats.warranties_approved_12_months_percent)
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
          label: "# Warranties Denied - 12 mos.",
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["c" /* numberAndPercent */])(stats.warranties_denied_12_months_count, stats.warranties_denied_12_months_percent)
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
          label: "Avg # Days to Eval (Mean)",
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["a" /* number */])(stats.mean_days_to_eval),
          offset: 3,
          smOffset: 3
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
          label: "Avg # Days to Eval (Median)",
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["a" /* number */])(stats.median_days_to_eval)
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
          label: "Avg # Days to Eval (Mode)",
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["a" /* number */])(stats.mode_days_to_eval)
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "# Units in Stock Tagged By",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["a" /* number */])(stats.units_in_stock_tagged_by_qty),
        offset: 4,
        smOffset: 4
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "# Units At Shop",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["a" /* number */])(stats.units_at_shop_qty)
      })
    )
  );
}

CompanyRepairStatsDetail.propTypes = {
  stats: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

function CompanyPurchaseStatsDetail(_ref3) {
  var stats = _ref3.stats;

  var year = __WEBPACK_IMPORTED_MODULE_4_moment___default()().year();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: containerStyles },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h4",
      { style: headerStyles },
      "Purchasing"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: statsContainerStyles },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "IQs - 6 mos.",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["a" /* number */])(stats.iqs_6_months_count),
        offset: 1
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "Purch. by Us - 6 mos.",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["a" /* number */])(stats.purchases_6_months_count)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "IQ/PO Conv. % - 6 mos.",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["d" /* percent */])(stats.po_to_iq_6_months_percent)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "# PO Line Items - 6 mos.",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["a" /* number */])(stats.purchase_items_6_months_count)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: ["# PO Line Items CXL - 6 mos.", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CancellationStatsTooltip__["a" /* default */], { stats: stats })],
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["c" /* numberAndPercent */])(stats.purchase_items_cancelled_6_months_count, stats.purchase_items_cancelled_6_months_percent)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 1, sm: 1 },
        "\xA0"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "Purch. By Us - " + year,
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["b" /* dollar */])(stats.purchases_current_year_dollars),
        offset: 2
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "$ CXL on Us - " + year,
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["e" /* dollarAndPercent */])(stats.purchases_cancelled_current_year_dollars, stats.purchases_cancelled_current_year_dollars_percent)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "Purch. By Us - " + (year - 1),
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["b" /* dollar */])(stats.purchases_last_year_dollars)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "$ CXL on Us - " + (year - 1),
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["e" /* dollarAndPercent */])(stats.purchases_cancelled_last_year_dollars, stats.purchases_cancelled_last_year_dollars_percent)
      })
    )
  );
}

CompanyPurchaseStatsDetail.propTypes = {
  stats: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

function CompanySaleStatsDetail(_ref4) {
  var stats = _ref4.stats;

  var year = __WEBPACK_IMPORTED_MODULE_4_moment___default()().year();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: containerStyles },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h4",
      { style: headerStyles },
      "Sales"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: statsContainerStyles },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "OQs - 6 mos.",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["a" /* number */])(stats.oqs_6_months_count),
        offset: 1
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "Sold by Us - 6 mos.",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["a" /* number */])(stats.sales_6_months_count)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "OQ/SO Conv. % - 6 mos.",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["d" /* percent */])(stats.so_to_oq_6_months_percent)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "# SO Line Items - 6 mos.",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["a" /* number */])(stats.sales_items_6_months_count)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "# SO Line Items CXL - 6 mos.",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["c" /* numberAndPercent */])(stats.sales_items_cancelled_6_months_count, stats.sales_items_cancelled_6_months_percent)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 1, sm: 1 },
        "\xA0"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "Sold By Us - " + year,
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["b" /* dollar */])(stats.sales_current_year_dollars),
        offset: 4
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DetailStat__["a" /* default */], {
        label: "Sold By Us - " + (year - 1),
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__format__["b" /* dollar */])(stats.sales_last_year_dollars)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 4, sm: 4 },
        "\xA0"
      )
    )
  );
}

CompanySaleStatsDetail.propTypes = {
  stats: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailStat__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__format__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony export (immutable) */ __webpack_exports__["a"] = Detail;







var ExpertHeader = function ExpertHeader(_ref) {
  var experts = _ref.experts;

  if (!experts || experts.length === 0) return null;

  var header = experts.length === 1 ? "Resident Expert:" : "Resident Experts:";
  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "h2",
    {
      style: {
        marginTop: 0,
        marginBottom: 0
      }
    },
    header
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "p",
    {
      className: "lead text-blue",
      style: {
        fontSize: 14,
        fontStyle: "italic",
        marginBottom: 10
      }
    },
    experts.join(" / ")
  )];
};

function Detail(_ref2) {
  var stats = _ref2.stats,
      part = _ref2.part;

  var experts = part && [part.getIn(["resident_expert", "full_name"]), part.getIn(["second_resident_expert", "full_name"])].filter(function (n) {
    return n;
  }).map(function (n) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["d" /* getFirstNameLastInitial */])(n);
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 2, sm: 2 },
      part && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExpertHeader, { experts: experts })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DetailStat__["a" /* default */], {
      label: "Sold in 12 mos.",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__format__["a" /* number */])(stats.sold_in_12_months)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DetailStat__["a" /* default */], {
      label: "Sold in 4 mos.",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__format__["a" /* number */])(stats.sold_in_4_months)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DetailStat__["a" /* default */], {
      label: "Avg # Days in Stk",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__format__["a" /* number */])(stats.average_days_in_stock)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DetailStat__["a" /* default */], {
      label: "Avg # OQs pr/mo",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__format__["a" /* number */])(stats.average_oq_per_month)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 2, sm: 2 },
      "\xA0"
    )
  );
}

Detail.propTypes = {
  stats: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    resident_expert: {
      full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }
  })
};

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(16);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var StatTooltip = function (_Component) {
  _inherits(StatTooltip, _Component);

  _createClass(StatTooltip, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      // This will reset stats when entityId is detected to have changed.
      // Common use-case here is clearing previously loaded company stats when the company is changed to a different company.
      if (nextProps.entityId !== prevState.entityId) {
        return { entityId: nextProps.entityId, statsLoaded: false, stats: {} };
      }
      return null;
    }
  }]);

  function StatTooltip(props) {
    _classCallCheck(this, StatTooltip);

    var _this = _possibleConstructorReturn(this, (StatTooltip.__proto__ || Object.getPrototypeOf(StatTooltip)).call(this, props));

    _this.openStatModal = function () {
      _this.setState({ show: false, statModalOpen: true });
    };

    _this.closeStatModal = function () {
      return _this.setState({ statModalOpen: false });
    };

    _this.getTarget = _this.getTarget.bind(_this);
    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.state = {
      entityId: props.entityId,
      statModalOpen: false,
      statsLoaded: false,
      stats: {},
      show: false
    };
    return _this;
  }

  _createClass(StatTooltip, [{
    key: "getTarget",
    value: function getTarget() {
      return this.target;
    }
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      var _this2 = this;

      this.setState({ show: true });

      if (!this.state.statsLoaded) {
        this.props.fetchStats().then(function (stats) {
          _this2.setState({ stats: stats, statsLoaded: true });
        });
      }
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      this.setState({ show: false });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          modalTitle = _props.modalTitle,
          renderStats = _props.renderStats,
          renderModal = _props.renderModal;
      var _state = this.state,
          stats = _state.stats,
          statModalOpen = _state.statModalOpen,
          show = _state.show;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__Modal__["a" /* Modal */],
          {
            open: statModalOpen,
            close: this.closeStatModal,
            dialogClass: "modal-lg"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modal__["c" /* Close */], { close: this.closeStatModal }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              modalTitle
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { margin: 20, marginBottom: 10 } },
            renderModal(stats)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__Modal__["d" /* Footer */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              { className: "btn btn-primary", onClick: this.closeStatModal },
              "Close Stats"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
          onClick: function onClick(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            _this3.openStatModal();
          },
          className: "fa fa-info-circle",
          style: {
            cursor: "pointer",
            color: "rgba(255, 255, 255, 0.25)",
            fontSize: 12
          },
          ref: function ref(button) {
            _this3.target = button;
          },
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["f" /* Overlay */],
          { target: this.getTarget, show: show, placement: "right" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["b" /* Tooltip */],
            {
              id: "stat-tooltip",
              onMouseEnter: this.handleMouseEnter,
              onMouseLeave: this.handleMouseLeave,
              onClick: function onClick() {
                return _this3.openStatModal();
              },
              style: { cursor: "pointer" }
            },
            renderStats(stats),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "a",
              {
                onClick: function onClick() {
                  return _this3.openStatModal();
                },
                style: { cursor: "pointer" }
              },
              "View All Stats"
            )
          )
        )
      );
    }
  }]);

  return StatTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StatTooltip);


StatTooltip.propTypes = {
  fetchStats: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  renderStats: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  renderModal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  modalTitle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  entityId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
};

StatTooltip.defaultProps = {
  modalTitle: "Stats"
};

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = SummaryStat;



function SummaryStat(_ref) {
  var label = _ref.label,
      value = _ref.value;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { style: { fontStyle: "normal", color: "rgba(255, 255, 255, 0.8)" } },
      label,
      ":"
    ),
    " ",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { style: { fontWeight: "bold" } },
      value
    )
  );
}

SummaryStat.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StatusTags__ = __webpack_require__(2402);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__StatusTags__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatusTag__ = __webpack_require__(2401);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__StatusTag__["a"]; });





/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__ = __webpack_require__(21);




var UpdatedTrackedFieldsAt = function UpdatedTrackedFieldsAt(_ref) {
  var record = _ref.record,
      _ref$formatter = _ref.formatter,
      formatter = _ref$formatter === undefined ? __WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__["e" /* shortDateAndTimestamp */] : _ref$formatter;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: record.updated_tracked_fields_at && "text-yellow" },
    formatter(record.updated_tracked_fields_at || record.created_at)
  );
};

UpdatedTrackedFieldsAt.propTypes = {
  formatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (UpdatedTrackedFieldsAt);

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__ = __webpack_require__(11);
/* harmony export (immutable) */ __webpack_exports__["a"] = VendorDetail;









function VendorDetail(_ref) {
  var record = _ref.record;

  var paymentTerms = record.payment_terms;
  var getColor = function getColor() {
    if ([__WEBPACK_IMPORTED_MODULE_3__companies_constants__["x" /* NET_30 */], __WEBPACK_IMPORTED_MODULE_3__companies_constants__["y" /* NET_60 */], __WEBPACK_IMPORTED_MODULE_3__companies_constants__["z" /* NET_45 */], __WEBPACK_IMPORTED_MODULE_3__companies_constants__["A" /* NET_15 */], __WEBPACK_IMPORTED_MODULE_3__companies_constants__["B" /* NET_10 */], __WEBPACK_IMPORTED_MODULE_3__companies_constants__["C" /* NET_5 */], __WEBPACK_IMPORTED_MODULE_3__companies_constants__["r" /* CREDIT_CARD */]].includes(paymentTerms)) {
      return "#4CAF50";
    }
    return "#FF9800";
  };

  var demeritColor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["e" /* useActiveDemeritsColor */])(record.company);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4____["W" /* DetailTable */],
    { className: "table table-condensed" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["S" /* Detail */], { label: "Buyer Name", value: record.buyer.full_name }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["S" /* Detail */], { label: "Buying Store", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(record, "buying_store.name") }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["S" /* Detail */], { label: "Vendor Code", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(record, "company.code") }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["S" /* Detail */], {
      label: "Vendor Name",
      value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["w" /* CompanyName */], { company: record.company })
    }),
    record.company.demerits > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Active Demerits"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { style: { color: demeritColor } },
        record.company.demerits
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["S" /* Detail */], { label: "Vendor Phone", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(record, "company.phone") }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Payment Terms"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { style: { color: getColor() } },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(paymentTerms)
      )
    ),
    record.inventory && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["S" /* Detail */], {
      label: "Received Inventory",
      value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],
        { to: "/inventories/" + record.inventory.uuid },
        record.inventory.serial_number
      )
    })
  );
}

VendorDetail.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalLauncher__ = __webpack_require__(355);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var CreateNew = function (_ModalLauncher) {
  _inherits(CreateNew, _ModalLauncher);

  function CreateNew() {
    _classCallCheck(this, CreateNew);

    return _possibleConstructorReturn(this, (CreateNew.__proto__ || Object.getPrototypeOf(CreateNew)).apply(this, arguments));
  }

  _createClass(CreateNew, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: this.props.spanClass },
        this.button()
      );
    }
  }]);

  return CreateNew;
}(__WEBPACK_IMPORTED_MODULE_1__ModalLauncher__["a" /* default */]);

CreateNew.defaultProps = {
  text: "  Create New",
  buttonClass: "btn-info",
  spanClass: "input-group-btn"
};
/* harmony default export */ __webpack_exports__["a"] = (CreateNew);

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_constants__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = wire;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function wire(roles, prop, Component) {
  var Connected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
    var userRole = state.session.getIn(["user", "role"]);

    return _defineProperty({}, prop, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["i" /* ADMIN */]].concat(roles).includes(userRole));
  })(Component);

  return function (ProtectedComponent) {
    return function (props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Connected,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProtectedComponent, props)
      );
    };
  };
}

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_constants__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = wireIf;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function wireIf(lambda, prop, Component) {
  var Connected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
    var user = state.session.get("user");

    return _defineProperty({}, prop, user.get("role") === __WEBPACK_IMPORTED_MODULE_2__users_constants__["i" /* ADMIN */] || lambda(user));
  })(Component);

  return function (ProtectedComponent) {
    return function (props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Connected,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProtectedComponent, props)
      );
    };
  };
}

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony export (immutable) */ __webpack_exports__["a"] = connectRecord;



function connectRecord(options) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state, ownProps) {
    return {
      record: (state[options.reducer] || state[options.name]).get(options.name),
      id: ownProps.match.params.id
    };
  }, { fetch: options.action })(__WEBPACK_IMPORTED_MODULE_0__containers__["c" /* RecordLoader */]);
}

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_submission__ = __webpack_require__(49);
/* harmony export (immutable) */ __webpack_exports__["a"] = dataManager;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




function dataManager(propName, api) {
  var initialState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return function (Component) {
    return function (_React$Component) {
      _inherits(_class2, _React$Component);

      function _class2() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, _class2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          loading: false,
          result: initialState
        }, _this.load = function () {
          _this.setState({ loading: true });

          return api(_this.props).then(function (result) {
            _this.setState({
              loading: false,
              result: result
            });

            return __WEBPACK_IMPORTED_MODULE_1__lib_submission__["a" /* SUCCESS */];
          });
        }, _this.save = function (result) {
          return _this.setState({ result: result });
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(_class2, [{
        key: "componentWillMount",
        value: function componentWillMount() {
          this.load();
        }
      }, {
        key: "componentProps",
        value: function componentProps() {
          var _state = this.state,
              loading = _state.loading,
              result = _state.result;


          return _extends({}, this.props, _defineProperty({
            loading: loading
          }, propName, result));
        }
      }, {
        key: "render",
        value: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, this.componentProps(), {
            reload: this.load,
            refresh: this.load,
            save: this.save
          }));
        }
      }]);

      return _class2;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
  };
}

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers__ = __webpack_require__(74);
/* harmony export (immutable) */ __webpack_exports__["b"] = dismissible;
/* harmony export (immutable) */ __webpack_exports__["a"] = dismissibleChild;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




function dismissible(Comp) {
  var DismissibleComponent = function (_Dismissible) {
    _inherits(DismissibleComponent, _Dismissible);

    function DismissibleComponent() {
      _classCallCheck(this, DismissibleComponent);

      return _possibleConstructorReturn(this, (DismissibleComponent.__proto__ || Object.getPrototypeOf(DismissibleComponent)).apply(this, arguments));
    }

    _createClass(DismissibleComponent, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            _ = _props.show,
            rest = _objectWithoutProperties(_props, ["show"]);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: { display: "inline" },
            ref: function ref(node) {
              _this2.content = node;
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Comp, _extends({
            visible: this.state.visible,
            open: this.open,
            close: this.close,
            toggle: this.toggle
          }, rest))
        );
      }
    }]);

    return DismissibleComponent;
  }(__WEBPACK_IMPORTED_MODULE_1__containers__["b" /* Dismissible */]);

  return DismissibleComponent;
}

function dismissibleChild(Comp) {
  var DismissibleChild = function (_Dismissible2) {
    _inherits(DismissibleChild, _Dismissible2);

    function DismissibleChild() {
      _classCallCheck(this, DismissibleChild);

      return _possibleConstructorReturn(this, (DismissibleChild.__proto__ || Object.getPrototypeOf(DismissibleChild)).apply(this, arguments));
    }

    _createClass(DismissibleChild, [{
      key: "render",
      value: function render() {
        var _this4 = this;

        var _props2 = this.props,
            _ = _props2.show,
            rest = _objectWithoutProperties(_props2, ["show"]);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Comp, _extends({
          visible: this.state.visible,
          open: this.open,
          close: this.close,
          toggle: this.toggle,
          contentRef: function contentRef(node) {
            _this4.content = node;
          }
        }, rest));
      }
    }]);

    return DismissibleChild;
  }(__WEBPACK_IMPORTED_MODULE_1__containers__["b" /* Dismissible */]);

  return DismissibleChild;
}

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony export (immutable) */ __webpack_exports__["b"] = withFieldsFromForm;
/* harmony export (immutable) */ __webpack_exports__["a"] = withFieldsFromFormWithKeys;



function withFieldsFromForm(form) {
  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return function (Component) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
      var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])(form);
      var stateObj = {};
      fields.forEach(function (f) {
        stateObj[f] = selector(state, f);
      });
      return stateObj;
    })(Component);
  };
}

function withFieldsFromFormWithKeys(form) {
  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (Component) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
      var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])(form);
      var stateObj = {};
      Object.keys(fields).forEach(function (f) {
        stateObj[f] = selector(state, fields[f]);
      });
      return stateObj;
    })(Component);
  };
}

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
var SET = "users/SET";

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AdminFields__ = __webpack_require__(2443);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AdminFields__["a"]; });



/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(2463);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateUser__ = __webpack_require__(2448);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__CreateUser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Detail__ = __webpack_require__(2453);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Detail__["a"]; });







/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(252);
var document = __webpack_require__(195).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(250) && !__webpack_require__(286)(function () {
  return Object.defineProperty(__webpack_require__(830)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(502);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(506);
var $export = __webpack_require__(194);
var redefine = __webpack_require__(838);
var hide = __webpack_require__(251);
var has = __webpack_require__(215);
var Iterators = __webpack_require__(287);
var $iterCreate = __webpack_require__(2496);
var setToStringTag = __webpack_require__(509);
var getPrototypeOf = __webpack_require__(2503);
var ITERATOR = __webpack_require__(154)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(289);
var createDesc = __webpack_require__(290);
var toIObject = __webpack_require__(217);
var toPrimitive = __webpack_require__(514);
var has = __webpack_require__(215);
var IE8_DOM_DEFINE = __webpack_require__(831);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(250) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(836);
var hiddenKeys = __webpack_require__(505).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(215);
var toIObject = __webpack_require__(217);
var arrayIndexOf = __webpack_require__(2488)(false);
var IE_PROTO = __webpack_require__(510)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(288);
var toIObject = __webpack_require__(217);
var isEnum = __webpack_require__(289).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(251);


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(512);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(2505)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(833)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(145);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(97);
var toAbsoluteIndex = __webpack_require__(227);
var toLength = __webpack_require__(91);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(219);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(111);
var toObject = __webpack_require__(97);
var IObject = __webpack_require__(292);
var toLength = __webpack_require__(91);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(111);
var isObject = __webpack_require__(68);
var invoke = __webpack_require__(851);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(90).f;
var create = __webpack_require__(221);
var redefineAll = __webpack_require__(225);
var ctx = __webpack_require__(146);
var anInstance = __webpack_require__(218);
var forOf = __webpack_require__(219);
var $iterDefine = __webpack_require__(527);
var step = __webpack_require__(854);
var setSpecies = __webpack_require__(226);
var DESCRIPTORS = __webpack_require__(89);
var fastKey = __webpack_require__(197).fastKey;
var validate = __webpack_require__(256);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(291);
var from = __webpack_require__(843);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(225);
var getWeak = __webpack_require__(197).getWeak;
var anObject = __webpack_require__(57);
var isObject = __webpack_require__(68);
var anInstance = __webpack_require__(218);
var forOf = __webpack_require__(219);
var createArrayMethod = __webpack_require__(155);
var $has = __webpack_require__(122);
var validate = __webpack_require__(256);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(362);
var isObject = __webpack_require__(68);
var toLength = __webpack_require__(91);
var ctx = __webpack_require__(146);
var IS_CONCAT_SPREADABLE = __webpack_require__(81)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(89) && !__webpack_require__(66)(function () {
  return Object.defineProperty(__webpack_require__(520)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 851 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(68);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(57);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(529);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 856 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 857 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(223);
var gOPS = __webpack_require__(366);
var pIE = __webpack_require__(293);
var toObject = __webpack_require__(97);
var IObject = __webpack_require__(292);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(66)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(90);
var anObject = __webpack_require__(57);
var getKeys = __webpack_require__(223);

module.exports = __webpack_require__(89) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(134);
var gOPN = __webpack_require__(222).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(122);
var toIObject = __webpack_require__(134);
var arrayIndexOf = __webpack_require__(358)(false);
var IE_PROTO = __webpack_require__(533)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(223);
var toIObject = __webpack_require__(134);
var isEnum = __webpack_require__(293).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(222);
var gOPS = __webpack_require__(366);
var anObject = __webpack_require__(57);
var Reflect = __webpack_require__(60).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(60).parseFloat;
var $trim = __webpack_require__(255).trim;

module.exports = 1 / $parseFloat(__webpack_require__(537) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(60).parseInt;
var $trim = __webpack_require__(255).trim;
var ws = __webpack_require__(537);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(57);
var isObject = __webpack_require__(68);
var newPromiseCapability = __webpack_require__(531);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(91);
var repeat = __webpack_require__(536);
var defined = __webpack_require__(157);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(159);
var toLength = __webpack_require__(91);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(81);


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(846);
var validate = __webpack_require__(256);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(359)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(89) && /./g.flags != 'g') __webpack_require__(90).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(361)
});


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(846);
var validate = __webpack_require__(256);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(359)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(155)(0);
var redefine = __webpack_require__(124);
var meta = __webpack_require__(197);
var assign = __webpack_require__(858);
var weak = __webpack_require__(848);
var isObject = __webpack_require__(68);
var fails = __webpack_require__(66);
var validate = __webpack_require__(256);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(359)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = activeElement;

var _ownerDocument = __webpack_require__(229);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function activeElement() {
  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _ownerDocument2.default)();

  try {
    return doc.activeElement;
  } catch (e) {/* ie throws if no active element */}
}
module.exports = exports['default'];

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offsetParent;

var _ownerDocument = __webpack_require__(229);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _style = __webpack_require__(373);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument2.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style2.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}
module.exports = exports['default'];

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(181);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelizeStyleName;

var _camelize = __webpack_require__(2739);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^-ms-/; /**
                          * Copyright 2014-2015, Facebook, Inc.
                          * All rights reserved.
                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
                          */
function camelizeStyleName(string) {
  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
}
module.exports = exports['default'];

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(181);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (recalc) {
  if (!size || recalc) {
    if (_inDOM2.default) {
      var scrollDiv = document.createElement('div');

      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';

      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
};

var _inDOM = __webpack_require__(181);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = void 0;

module.exports = exports['default'];

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2da7c1e9bf1b99addb2da0e188a46dc3.svg";

/***/ }),
/* 883 */,
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var decamelize = __webpack_require__(2722);

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	str = decamelize(str);
	str = str.toLowerCase().replace(/[_-]+/g, ' ').replace(/\s{2,}/g, ' ').trim();
	str = str.charAt(0).toUpperCase() + str.slice(1);

	return str;
};


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.6.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-03-02T17:08Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.6.0",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						// Support: Chrome 86+
						// In Chrome, if an element having a focusout handler is blurred by
						// clicking outside of it, it invokes the handler synchronously. If
						// that handler calls `.remove()` on the element, the data is cleared,
						// leaving `result` undefined. We need to guard against this.
						return result && result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		// Suppress native focus or blur as it's already being fired
		// in leverageNative.
		_default: function() {
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayEach_js__ = __webpack_require__(2771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assignValue_js__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseAssign_js__ = __webpack_require__(2774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseAssignIn_js__ = __webpack_require__(2775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cloneBuffer_js__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__copyArray_js__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__copySymbols_js__ = __webpack_require__(2802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__copySymbolsIn_js__ = __webpack_require__(2803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getAllKeys_js__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__getAllKeysIn_js__ = __webpack_require__(2809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__getTag_js__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__initCloneArray_js__ = __webpack_require__(2819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__initCloneByTag_js__ = __webpack_require__(2820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__initCloneObject_js__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__isArray_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__isBuffer_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__isMap_js__ = __webpack_require__(2858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__isObject_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__isSet_js__ = __webpack_require__(2859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__keys_js__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__keysIn_js__ = __webpack_require__(305);























/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__isObject_js__["a" /* default */])(value)) {
    return value;
  }
  var isArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__isArray_js__["a" /* default */])(value);
  if (isArr) {
    result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__initCloneArray_js__["a" /* default */])(value);
    if (!isDeep) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__copyArray_js__["a" /* default */])(value, result);
    }
  } else {
    var tag = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__getTag_js__["a" /* default */])(value),
        isFunc = tag == funcTag || tag == genTag;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__isBuffer_js__["a" /* default */])(value)) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cloneBuffer_js__["a" /* default */])(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__initCloneObject_js__["a" /* default */])(value);
      if (!isDeep) {
        return isFlat
          ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__copySymbolsIn_js__["a" /* default */])(value, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseAssignIn_js__["a" /* default */])(result, value))
          : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__copySymbols_js__["a" /* default */])(value, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseAssign_js__["a" /* default */])(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__initCloneByTag_js__["a" /* default */])(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__isSet_js__["a" /* default */])(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__isMap_js__["a" /* default */])(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? __WEBPACK_IMPORTED_MODULE_10__getAllKeysIn_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_9__getAllKeys_js__["a" /* default */])
    : (isFlat ? __WEBPACK_IMPORTED_MODULE_21__keysIn_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_20__keys_js__["a" /* default */]);

  var props = isArr ? undefined : keysFunc(value);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__arrayEach_js__["a" /* default */])(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assignValue_js__["a" /* default */])(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseClone);


/***/ }),
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getSymbols_js__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stubArray_js__ = __webpack_require__(914);





/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_3__stubArray_js__["a" /* default */] : function(object) {
  var result = [];
  while (object) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getSymbols_js__["a" /* default */])(object));
    object = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object);
  }
  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbolsIn);


/***/ }),
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(2923),
    mapCacheDelete = __webpack_require__(2924),
    mapCacheGet = __webpack_require__(2925),
    mapCacheHas = __webpack_require__(2926),
    mapCacheSet = __webpack_require__(2927);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(2888),
    isArguments = __webpack_require__(932),
    isArray = __webpack_require__(232),
    isBuffer = __webpack_require__(933),
    isIndex = __webpack_require__(928),
    isTypedArray = __webpack_require__(2949);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 918 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(920),
    eq = __webpack_require__(573);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(924);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(566),
    toKey = __webpack_require__(930);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(564),
    isArray = __webpack_require__(232);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 923 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(231);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127)))

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(922),
    getSymbolsIn = __webpack_require__(927),
    keysIn = __webpack_require__(935);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(564),
    getPrototype = __webpack_require__(568),
    getSymbols = __webpack_require__(569),
    stubArray = __webpack_require__(936);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 928 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 929 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(390);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 931 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(2880),
    isObjectLike = __webpack_require__(234);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(162),
    stubFalse = __webpack_require__(2953);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(262)(module)))

/***/ }),
/* 934 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(917),
    baseKeysIn = __webpack_require__(2886),
    isArrayLike = __webpack_require__(574);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 936 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
            '_'
        ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                '_'
            ),
        },
        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
            '_'
        ),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                '_'
            ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
            '_'
        ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
            '_'
        ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
            '_'
        ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
            '_'
        ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                '_'
            ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
            '_'
        ),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
            '_'
        ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
            '_'
        ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
            '_'
        ),
        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
            '_'
        ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
            '_'
        ),
        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
            '_'
        ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
            '_'
        ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
            '_'
        ),
        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
            '_'
        ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
            ' '
        ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
            '_'
        ),
        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
            '_'
        ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
            '_'
        ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
            '_'
        );

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                '_'
            ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                '_'
            ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
            '_'
        ),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                '_'
            ),
        },
        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
            '_'
        ),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                '_'
            ),
        },
        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
        ' '
    );
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                '_'
            ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
            '_'
        ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
            '_'
        ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                '_'
            ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
                    $0,
                    $1,
                    $2
                ) {
                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                });
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
            '_'
        ),
        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
            '_'
        ),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
            '_'
        ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                '_'
            ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                '_'
            ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
            '_'
        ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
            '_'
        ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
            '_'
        ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
            '_'
        ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
            '_'
        ),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
            '_'
        ),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
            '_'
        ),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
            '_'
        ),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                '_'
            ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
            '_'
        ),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
            '_'
        ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
            '_'
        ),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
            '_'
        ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
            '_'
        ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                '_'
            ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
        },
        weekdays: {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                '_'
            ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
            '_'
        ),
        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
            '_'
        ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
            '_'
        ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
            '_'
        ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'дан',
            dd: translator.translate,
            M: 'месец',
            MM: translator.translate,
            y: 'годину',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
            '_'
        ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
            '_'
        ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
            '_'
        ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
            '_'
        ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                '_'
            ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    return tzl;

})));


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                    '_'
                ),
                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                    '_'
                ),
                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                    '_'
                ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                '_'
            ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
            '_'
        ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
            '_'
        ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(14)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function isObject(what) {
    return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch ({}.toString.call(value)) {
    case '[object Error]': return true;
    case '[object Exception]': return true;
    case '[object DOMException]': return true;
    default: return value instanceof Error;
  }
}

module.exports = {
    isObject: isObject,
    isError: isError
};


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(2971);

var _require = __webpack_require__(94),
    findDOMNode = _require.findDOMNode;

var scrollIntoView = __webpack_require__(2742);

var IMPERATIVE_API = ['blur', 'checkValidity', 'click', 'focus', 'select', 'setCustomValidity', 'setSelectionRange', 'setRangeText'];

function getScrollOffset() {
  return {
    x: window.pageXOffset !== undefined ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft,
    y: window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
  };
}

var Autocomplete = function (_React$Component) {
  _inherits(Autocomplete, _React$Component);

  function Autocomplete(props) {
    _classCallCheck(this, Autocomplete);

    var _this = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, props));

    _this.state = {
      isOpen: false,
      highlightedIndex: null
    };
    _this._debugStates = [];
    _this.ensureHighlightedIndex = _this.ensureHighlightedIndex.bind(_this);
    _this.exposeAPI = _this.exposeAPI.bind(_this);
    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleInputClick = _this.handleInputClick.bind(_this);
    _this.maybeAutoCompleteText = _this.maybeAutoCompleteText.bind(_this);
    return _this;
  }

  _createClass(Autocomplete, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // this.refs is frozen, so we need to assign a new object to it
      this.refs = {};
      this._ignoreBlur = false;
      this._ignoreFocus = false;
      this._scrollOffset = null;
      this._scrollTimer = null;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._scrollTimer);
      this._scrollTimer = null;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.highlightedIndex !== null) {
        this.setState(this.ensureHighlightedIndex);
      }
      if (nextProps.autoHighlight && (this.props.value !== nextProps.value || this.state.highlightedIndex === null)) {
        this.setState(this.maybeAutoCompleteText);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isOpen()) {
        this.setMenuPositions();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.isOpen && !prevState.isOpen || 'open' in this.props && this.props.open && !prevProps.open) this.setMenuPositions();

      this.maybeScrollItemIntoView();
      if (prevState.isOpen !== this.state.isOpen) {
        this.props.onMenuVisibilityChange(this.state.isOpen);
      }
    }
  }, {
    key: 'exposeAPI',
    value: function exposeAPI(el) {
      var _this2 = this;

      this.refs.input = el;
      IMPERATIVE_API.forEach(function (ev) {
        return _this2[ev] = el && el[ev] && el[ev].bind(el);
      });
    }
  }, {
    key: 'maybeScrollItemIntoView',
    value: function maybeScrollItemIntoView() {
      if (this.isOpen() && this.state.highlightedIndex !== null) {
        var itemNode = this.refs['item-' + this.state.highlightedIndex];
        var menuNode = this.refs.menu;
        scrollIntoView(findDOMNode(itemNode), findDOMNode(menuNode), { onlyScrollIfNeeded: true });
      }
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      if (Autocomplete.keyDownHandlers[event.key]) Autocomplete.keyDownHandlers[event.key].call(this, event);else if (!this.isOpen()) {
        this.setState({
          isOpen: true
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      this.props.onChange(event, event.target.value);
    }
  }, {
    key: 'getFilteredItems',
    value: function getFilteredItems(props) {
      var items = props.items;

      if (props.shouldItemRender) {
        items = items.filter(function (item) {
          return props.shouldItemRender(item, props.value);
        });
      }

      if (props.sortItems) {
        items.sort(function (a, b) {
          return props.sortItems(a, b, props.value);
        });
      }

      return items;
    }
  }, {
    key: 'maybeAutoCompleteText',
    value: function maybeAutoCompleteText(state, props) {
      var highlightedIndex = state.highlightedIndex;
      var value = props.value,
          getItemValue = props.getItemValue;

      var index = highlightedIndex === null ? 0 : highlightedIndex;
      var items = this.getFilteredItems(props);
      for (var i = 0; i < items.length; i++) {
        if (props.isItemSelectable(items[index])) break;
        index = (index + 1) % items.length;
      }
      var matchedItem = items[index] && props.isItemSelectable(items[index]) ? items[index] : null;
      if (value !== '' && matchedItem) {
        var itemValue = getItemValue(matchedItem);
        var itemValueDoesMatch = itemValue.toLowerCase().indexOf(value.toLowerCase()) === 0;
        if (itemValueDoesMatch) {
          return { highlightedIndex: index };
        }
      }
      return { highlightedIndex: null };
    }
  }, {
    key: 'ensureHighlightedIndex',
    value: function ensureHighlightedIndex(state, props) {
      if (state.highlightedIndex >= this.getFilteredItems(props).length) {
        return { highlightedIndex: null };
      }
    }
  }, {
    key: 'setMenuPositions',
    value: function setMenuPositions() {
      var node = this.refs.input;
      var rect = node.getBoundingClientRect();
      var computedStyle = global.window.getComputedStyle(node);
      var marginBottom = parseInt(computedStyle.marginBottom, 10) || 0;
      var marginLeft = parseInt(computedStyle.marginLeft, 10) || 0;
      var marginRight = parseInt(computedStyle.marginRight, 10) || 0;
      this.setState({
        menuTop: rect.bottom + marginBottom,
        menuLeft: rect.left + marginLeft,
        menuWidth: rect.width + marginLeft + marginRight
      });
    }
  }, {
    key: 'highlightItemFromMouse',
    value: function highlightItemFromMouse(index) {
      this.setState({ highlightedIndex: index });
    }
  }, {
    key: 'selectItemFromMouse',
    value: function selectItemFromMouse(item) {
      var _this3 = this;

      var value = this.props.getItemValue(item);
      // The menu will de-render before a mouseLeave event
      // happens. Clear the flag to release control over focus
      this.setIgnoreBlur(false);
      this.setState({
        isOpen: false,
        highlightedIndex: null
      }, function () {
        _this3.props.onSelect(value, item);
      });
    }
  }, {
    key: 'setIgnoreBlur',
    value: function setIgnoreBlur(ignore) {
      this._ignoreBlur = ignore;
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var _this4 = this;

      var items = this.getFilteredItems(this.props).map(function (item, index) {
        var element = _this4.props.renderItem(item, _this4.state.highlightedIndex === index, { cursor: 'default' });
        return React.cloneElement(element, {
          onMouseEnter: _this4.props.isItemSelectable(item) ? function () {
            return _this4.highlightItemFromMouse(index);
          } : null,
          onClick: _this4.props.isItemSelectable(item) ? function () {
            return _this4.selectItemFromMouse(item);
          } : null,
          ref: function ref(e) {
            return _this4.refs['item-' + index] = e;
          }
        });
      });
      var style = {
        left: this.state.menuLeft,
        top: this.state.menuTop,
        minWidth: this.state.menuWidth
      };
      var menu = this.props.renderMenu(items, this.props.value, style);
      return React.cloneElement(menu, {
        ref: function ref(e) {
          return _this4.refs.menu = e;
        },
        // Ignore blur to prevent menu from de-rendering before we can process click
        onTouchStart: function onTouchStart() {
          return _this4.setIgnoreBlur(true);
        },
        onMouseEnter: function onMouseEnter() {
          return _this4.setIgnoreBlur(true);
        },
        onMouseLeave: function onMouseLeave() {
          return _this4.setIgnoreBlur(false);
        }
      });
    }
  }, {
    key: 'handleInputBlur',
    value: function handleInputBlur(event) {
      var _this5 = this;

      if (this._ignoreBlur) {
        this._ignoreFocus = true;
        this._scrollOffset = getScrollOffset();
        this.refs.input.focus();
        return;
      }
      var setStateCallback = void 0;
      var highlightedIndex = this.state.highlightedIndex;

      if (this.props.selectOnBlur && highlightedIndex !== null) {
        var items = this.getFilteredItems(this.props);
        var item = items[highlightedIndex];
        var value = this.props.getItemValue(item);
        setStateCallback = function setStateCallback() {
          return _this5.props.onSelect(value, item);
        };
      }
      this.setState({
        isOpen: false,
        highlightedIndex: null
      }, setStateCallback);
      var onBlur = this.props.inputProps.onBlur;

      if (onBlur) {
        onBlur(event);
      }
    }
  }, {
    key: 'handleInputFocus',
    value: function handleInputFocus(event) {
      var _this6 = this;

      if (this._ignoreFocus) {
        this._ignoreFocus = false;
        var _scrollOffset = this._scrollOffset,
            x = _scrollOffset.x,
            y = _scrollOffset.y;

        this._scrollOffset = null;
        // Focus will cause the browser to scroll the <input> into view.
        // This can cause the mouse coords to change, which in turn
        // could cause a new highlight to happen, cancelling the click
        // event (when selecting with the mouse)
        window.scrollTo(x, y);
        // Some browsers wait until all focus event handlers have been
        // processed before scrolling the <input> into view, so let's
        // scroll again on the next tick to ensure we're back to where
        // the user was before focus was lost. We could do the deferred
        // scroll only, but that causes a jarring split second jump in
        // some browsers that scroll before the focus event handlers
        // are triggered.
        clearTimeout(this._scrollTimer);
        this._scrollTimer = setTimeout(function () {
          _this6._scrollTimer = null;
          window.scrollTo(x, y);
        }, 0);
        return;
      }
      this.setState({ isOpen: true });
      var onFocus = this.props.inputProps.onFocus;

      if (onFocus) {
        onFocus(event);
      }
    }
  }, {
    key: 'isInputFocused',
    value: function isInputFocused() {
      var el = this.refs.input;
      return el.ownerDocument && el === el.ownerDocument.activeElement;
    }
  }, {
    key: 'handleInputClick',
    value: function handleInputClick() {
      // Input will not be focused if it's disabled
      if (this.isInputFocused() && !this.isOpen()) this.setState({ isOpen: true });
    }
  }, {
    key: 'composeEventHandlers',
    value: function composeEventHandlers(internal, external) {
      return external ? function (e) {
        internal(e);external(e);
      } : internal;
    }
  }, {
    key: 'isOpen',
    value: function isOpen() {
      return 'open' in this.props ? this.props.open : this.state.isOpen;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.debug) {
        // you don't like it, you love it
        this._debugStates.push({
          id: this._debugStates.length,
          state: this.state
        });
      }

      var inputProps = this.props.inputProps;

      var open = this.isOpen();
      return React.createElement(
        'div',
        _extends({ style: _extends({}, this.props.wrapperStyle) }, this.props.wrapperProps),
        this.props.renderInput(_extends({}, inputProps, {
          role: 'combobox',
          'aria-autocomplete': 'list',
          'aria-expanded': open,
          autoComplete: 'off',
          ref: this.exposeAPI,
          onFocus: this.handleInputFocus,
          onBlur: this.handleInputBlur,
          onChange: this.handleChange,
          onKeyDown: this.composeEventHandlers(this.handleKeyDown, inputProps.onKeyDown),
          onClick: this.composeEventHandlers(this.handleInputClick, inputProps.onClick),
          value: this.props.value
        })),
        open && this.renderMenu(),
        this.props.debug && React.createElement(
          'pre',
          { style: { marginLeft: 300 } },
          JSON.stringify(this._debugStates.slice(Math.max(0, this._debugStates.length - 5), this._debugStates.length), null, 2)
        )
      );
    }
  }]);

  return Autocomplete;
}(React.Component);

Autocomplete.propTypes = {
  /**
   * The items to display in the dropdown menu
   */
  items: PropTypes.array.isRequired,
  /**
   * The value to display in the input field
   */
  value: PropTypes.any,
  /**
   * Arguments: `event: Event, value: String`
   *
   * Invoked every time the user changes the input's value.
   */
  onChange: PropTypes.func,
  /**
   * Arguments: `value: String, item: Any`
   *
   * Invoked when the user selects an item from the dropdown menu.
   */
  onSelect: PropTypes.func,
  /**
   * Arguments: `item: Any, value: String`
   *
   * Invoked for each entry in `items` and its return value is used to
   * determine whether or not it should be displayed in the dropdown menu.
   * By default all items are always rendered.
   */
  shouldItemRender: PropTypes.func,
  /**
   * Arguments: `item: Any`
   *
   * Invoked when attempting to select an item. The return value is used to
   * determine whether the item should be selectable or not.
   * By default all items are selectable.
   */
  isItemSelectable: PropTypes.func,
  /**
   * Arguments: `itemA: Any, itemB: Any, value: String`
   *
   * The function which is used to sort `items` before display.
   */
  sortItems: PropTypes.func,
  /**
   * Arguments: `item: Any`
   *
   * Used to read the display value from each entry in `items`.
   */
  getItemValue: PropTypes.func.isRequired,
  /**
   * Arguments: `item: Any, isHighlighted: Boolean, styles: Object`
   *
   * Invoked for each entry in `items` that also passes `shouldItemRender` to
   * generate the render tree for each item in the dropdown menu. `styles` is
   * an optional set of styles that can be applied to improve the look/feel
   * of the items in the dropdown menu.
   */
  renderItem: PropTypes.func.isRequired,
  /**
   * Arguments: `items: Array<Any>, value: String, styles: Object`
   *
   * Invoked to generate the render tree for the dropdown menu. Ensure the
   * returned tree includes every entry in `items` or else the highlight order
   * and keyboard navigation logic will break. `styles` will contain
   * { top, left, minWidth } which are the coordinates of the top-left corner
   * and the width of the dropdown menu.
   */
  renderMenu: PropTypes.func,
  /**
   * Styles that are applied to the dropdown menu in the default `renderMenu`
   * implementation. If you override `renderMenu` and you want to use
   * `menuStyle` you must manually apply them (`this.props.menuStyle`).
   */
  menuStyle: PropTypes.object,
  /**
   * Arguments: `props: Object`
   *
   * Invoked to generate the input element. The `props` argument is the result
   * of merging `props.inputProps` with a selection of props that are required
   * both for functionality and accessibility. At the very least you need to
   * apply `props.ref` and all `props.on<event>` event handlers. Failing to do
   * this will cause `Autocomplete` to behave unexpectedly.
   */
  renderInput: PropTypes.func,
  /**
   * Props passed to `props.renderInput`. By default these props will be
   * applied to the `<input />` element rendered by `Autocomplete`, unless you
   * have specified a custom value for `props.renderInput`. Any properties
   * supported by `HTMLInputElement` can be specified, apart from the
   * following which are set by `Autocomplete`: value, autoComplete, role,
   * aria-autocomplete. `inputProps` is commonly used for (but not limited to)
   * placeholder, event handlers (onFocus, onBlur, etc.), autoFocus, etc..
   */
  inputProps: PropTypes.object,
  /**
   * Props that are applied to the element which wraps the `<input />` and
   * dropdown menu elements rendered by `Autocomplete`.
   */
  wrapperProps: PropTypes.object,
  /**
   * This is a shorthand for `wrapperProps={{ style: <your styles> }}`.
   * Note that `wrapperStyle` is applied before `wrapperProps`, so the latter
   * will win if it contains a `style` entry.
   */
  wrapperStyle: PropTypes.object,
  /**
   * Whether or not to automatically highlight the top match in the dropdown
   * menu.
   */
  autoHighlight: PropTypes.bool,
  /**
   * Whether or not to automatically select the highlighted item when the
   * `<input>` loses focus.
   */
  selectOnBlur: PropTypes.bool,
  /**
   * Arguments: `isOpen: Boolean`
   *
   * Invoked every time the dropdown menu's visibility changes (i.e. every
   * time it is displayed/hidden).
   */
  onMenuVisibilityChange: PropTypes.func,
  /**
   * Used to override the internal logic which displays/hides the dropdown
   * menu. This is useful if you want to force a certain state based on your
   * UX/business logic. Use it together with `onMenuVisibilityChange` for
   * fine-grained control over the dropdown menu dynamics.
   */
  open: PropTypes.bool,
  debug: PropTypes.bool
};
Autocomplete.defaultProps = {
  value: '',
  wrapperProps: {},
  wrapperStyle: {
    display: 'inline-block'
  },
  inputProps: {},
  renderInput: function renderInput(props) {
    return React.createElement('input', props);
  },
  onChange: function onChange() {},
  onSelect: function onSelect() {},
  isItemSelectable: function isItemSelectable() {
    return true;
  },
  renderMenu: function renderMenu(items, value, style) {
    return React.createElement('div', { style: _extends({}, style, this.menuStyle), children: items });
  },

  menuStyle: {
    borderRadius: '3px',
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
    background: 'rgba(255, 255, 255, 0.9)',
    padding: '2px 0',
    fontSize: '90%',
    position: 'fixed',
    overflow: 'auto',
    maxHeight: '50%' },
  autoHighlight: true,
  selectOnBlur: false,
  onMenuVisibilityChange: function onMenuVisibilityChange() {}
};
Autocomplete.keyDownHandlers = {
  ArrowDown: function ArrowDown(event) {
    event.preventDefault();
    var items = this.getFilteredItems(this.props);
    if (!items.length) return;
    var highlightedIndex = this.state.highlightedIndex;

    var index = highlightedIndex === null ? -1 : highlightedIndex;
    for (var i = 0; i < items.length; i++) {
      var p = (index + i + 1) % items.length;
      if (this.props.isItemSelectable(items[p])) {
        index = p;
        break;
      }
    }
    if (index > -1 && index !== highlightedIndex) {
      this.setState({
        highlightedIndex: index,
        isOpen: true
      });
    }
  },
  ArrowUp: function ArrowUp(event) {
    event.preventDefault();
    var items = this.getFilteredItems(this.props);
    if (!items.length) return;
    var highlightedIndex = this.state.highlightedIndex;

    var index = highlightedIndex === null ? items.length : highlightedIndex;
    for (var i = 0; i < items.length; i++) {
      var p = (index - (1 + i) + items.length) % items.length;
      if (this.props.isItemSelectable(items[p])) {
        index = p;
        break;
      }
    }
    if (index !== items.length) {
      this.setState({
        highlightedIndex: index,
        isOpen: true
      });
    }
  },
  Enter: function Enter(event) {
    var _this7 = this;

    // Key code 229 is used for selecting items from character selectors (Pinyin, Kana, etc)
    if (event.keyCode !== 13) return;
    // In case the user is currently hovering over the menu
    this.setIgnoreBlur(false);
    if (!this.isOpen()) {
      // menu is closed so there is no selection to accept -> do nothing
      return;
    } else if (this.state.highlightedIndex == null) {
      // input has focus but no menu item is selected + enter is hit -> close the menu, highlight whatever's in input
      this.setState({
        isOpen: false
      }, function () {
        _this7.refs.input.select();
      });
    } else {
      // text entered + menu item has been highlighted + enter is hit -> update value to that of selected menu item, close the menu
      event.preventDefault();
      var item = this.getFilteredItems(this.props)[this.state.highlightedIndex];
      var value = this.props.getItemValue(item);
      this.setState({
        isOpen: false,
        highlightedIndex: null
      }, function () {
        //this.refs.input.focus() // TODO: file issue
        _this7.refs.input.setSelectionRange(value.length, value.length);
        _this7.props.onSelect(value, item);
      });
    }
  },
  Escape: function Escape() {
    // In case the user is currently hovering over the menu
    this.setIgnoreBlur(false);
    this.setState({
      highlightedIndex: null,
      isOpen: false
    });
  },
  Tab: function Tab() {
    // In case the user is currently hovering over the menu
    this.setIgnoreBlur(false);
  }
};


module.exports = Autocomplete;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127)))

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(163);











var propTypes = {
  /**
   * If set to true, renders `span` instead of `a`
   */
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * `href` attribute for the inner `a` element
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * `title` attribute for the inner `a` element
   */
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * `target` attribute for the inner `a` element
   */
  target: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  active: false
};

var BreadcrumbItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BreadcrumbItem, _React$Component);

  function BreadcrumbItem() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BreadcrumbItem);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  BreadcrumbItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        href = _props.href,
        title = _props.title,
        target = _props.target,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'href', 'title', 'target', 'className']);

    // Don't try to render these props on non-active <span>.


    var linkProps = { href: href, title: title, target: target };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active }) },
      active ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', props) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, linkProps))
    );
  };

  return BreadcrumbItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbItem);

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_TransitionEvents__ = __webpack_require__(3034);












// TODO: This should use a timeout instead of TransitionEvents, or else just
// not wait until transition end to trigger continuing animations.

var propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['prev', 'next']),
  onAnimateOutEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animateIn: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animateOut: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number
};

var defaultProps = {
  active: false,
  animateIn: false,
  animateOut: false
};

var CarouselItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CarouselItem, _React$Component);

  function CarouselItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CarouselItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);

    _this.state = {
      direction: null
    };

    _this.isUnmounted = false;
    return _this;
  }

  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.active !== nextProps.active) {
      this.setState({ direction: null });
    }
  };

  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var active = this.props.active;

    var prevActive = prevProps.active;

    if (!active && prevActive) {
      __WEBPACK_IMPORTED_MODULE_9__utils_TransitionEvents__["a" /* default */].addEndEventListener(__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this), this.handleAnimateOutEnd);
    }

    if (active !== prevActive) {
      setTimeout(function () {
        return _this2.startAnimation();
      }, 20);
    }
  };

  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
    if (this.isUnmounted) {
      return;
    }

    if (this.props.onAnimateOutEnd) {
      this.props.onAnimateOutEnd(this.props.index);
    }
  };

  CarouselItem.prototype.startAnimation = function startAnimation() {
    if (this.isUnmounted) {
      return;
    }

    this.setState({
      direction: this.props.direction === 'prev' ? 'right' : 'left'
    });
  };

  CarouselItem.prototype.render = function render() {
    var _props = this.props,
        direction = _props.direction,
        active = _props.active,
        animateIn = _props.animateIn,
        animateOut = _props.animateOut,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);

    delete props.onAnimateOutEnd;
    delete props.index;

    var classes = {
      item: true,
      active: active && !animateIn || animateOut
    };
    if (direction && active && animateIn) {
      classes[direction] = true;
    }
    if (this.state.direction && (animateIn || animateOut)) {
      classes[this.state.direction] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CarouselItem.propTypes = propTypes;
CarouselItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (CarouselItem);

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Button__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(39);













var propTypes = {
  noCaret: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  open: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  useAnchor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

var defaultProps = {
  open: false,
  useAnchor: false,
  bsRole: 'toggle'
};

var DropdownToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DropdownToggle, _React$Component);

  function DropdownToggle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DropdownToggle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DropdownToggle.prototype.render = function render() {
    var _props = this.props,
        noCaret = _props.noCaret,
        open = _props.open,
        useAnchor = _props.useAnchor,
        bsClass = _props.bsClass,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);

    delete props.bsRole;

    var Component = useAnchor ? __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_8__Button__["a" /* default */];
    var useCaret = !noCaret;

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    // FIXME: Should this really fall back to `title` as children?

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        role: 'button',
        className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, bsClass),
        'aria-haspopup': true,
        'aria-expanded': open
      }),
      children || props.title,
      useCaret && ' ',
      useCaret && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: 'caret' })
    );
  };

  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsClass */])('dropdown-toggle', DropdownToggle));

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);












var propTypes = {
  /**
   * Turn any fixed-width grid layout into a full-width layout by this property.
   *
   * Adds `container-fluid` class.
   */
  fluid: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * You can use a custom element for this component
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div',
  fluid: false
};

var Grid = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Grid, _React$Component);

  function Grid() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Grid);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Grid.prototype.render = function render() {
    var _props = this.props,
        fluid = _props.fluid,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['fluid', 'componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, fluid && 'fluid');

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('container', Grid));

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(106);













var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  header: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  listItem: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  listItem: false
};

var ListGroupItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ListGroupItem, _React$Component);

  function ListGroupItem() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ListGroupItem);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
    if (__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(header)) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(header, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(header.props.className, headingClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'h4',
      { className: headingClassName },
      header
    );
  };

  ListGroupItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        className = _props.className,
        header = _props.header,
        listItem = _props.listItem,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {
      active: active,
      disabled: disabled
    });

    var Component = void 0;

    if (elementProps.href) {
      Component = 'a';
    } else if (elementProps.onClick) {
      Component = 'button';
      elementProps.type = elementProps.type || 'button';
    } else if (listItem) {
      Component = 'li';
    } else {
      Component = 'span';
    }

    elementProps.className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes);

    // TODO: Deprecate `header` prop.
    if (header) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        Component,
        elementProps,
        this.renderHeader(header, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'heading')),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'p',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'text') },
          children
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      Component,
      elementProps,
      children
    );
  };

  return ListGroupItem;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

ListGroupItem.propTypes = propTypes;
ListGroupItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('list-group-item', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* State */]), ListGroupItem)));

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var ModalBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalBody, _React$Component);

  function ModalBody() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalBody);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalBody.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ModalBody;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('modal-body', ModalBody));

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var ModalFooter = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalFooter, _React$Component);

  function ModalFooter() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalFooter);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalFooter.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ModalFooter;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('modal-footer', ModalFooter));

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CloseButton__ = __webpack_require__(579);













// TODO: `aria-label` should be `closeLabel`.

var propTypes = {
  /**
   * Provides an accessible label for the close
   * button. It is used for Assistive Technology when the label text is not
   * readable.
   */
  closeLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * Specify whether the Component should contain a close button
   */
  closeButton: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * A Callback fired when the close button is clicked. If used directly inside
   * a Modal component, the onHide will automatically be propagated up to the
   * parent Modal `onHide`.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};

var contextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  })
};

var ModalHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalHeader, _React$Component);

  function ModalHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalHeader.prototype.render = function render() {
    var _props = this.props,
        closeLabel = _props.closeLabel,
        closeButton = _props.closeButton,
        onHide = _props.onHide,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['closeLabel', 'closeButton', 'onHide', 'className', 'children']);

    var modal = this.context.$bs_modal;

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      closeButton && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CloseButton__["a" /* default */], {
        label: closeLabel,
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(modal && modal.onHide, onHide)
      }),
      children
    );
  };

  return ModalHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;
ModalHeader.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('modal-header', ModalHeader));

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'h4'
};

var ModalTitle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalTitle, _React$Component);

  function ModalTitle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalTitle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalTitle.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ModalTitle;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalTitle.propTypes = propTypes;
ModalTitle.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('modal-title', ModalTitle));

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(116);

















// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?

// TODO: This `bsStyle` is very unlike the others. Should we rename it?

// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
// Consider renaming or replacing them.

var propTypes = {
  /**
   * Marks the NavItem with a matching `eventKey` as active. Has a
   * higher precedence over `activeHref`.
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,

  /**
   * Marks the child NavItem with a matching `href` prop as active.
   */
  activeHref: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

  /**
   * NavItems are be positioned vertically.
   */
  stacked: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  justified: __WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, function (_ref) {
    var justified = _ref.justified,
        navbar = _ref.navbar;
    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
  }),

  /**
   * A callback fired when a NavItem is selected.
   *
   * ```js
   * function (
   * 	Any eventKey,
   * 	SyntheticEvent event?
   * )
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * ARIA role for the Nav, in the context of a TabContainer, the default will
   * be set to "tablist", but can be overridden by the Nav when set explicitly.
   *
   * When the role is set to "tablist" NavItem focus is managed according to
   * the ARIA authoring practices for tabs:
   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
   */
  role: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

  /**
   * Apply styling an alignment for use in a Navbar. This prop will be set
   * automatically when the Nav is used inside a Navbar.
   */
  navbar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Float the Nav to the right. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Float the Nav to the left. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullLeft: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};

var defaultProps = {
  justified: false,
  pullRight: false,
  pullLeft: false,
  stacked: false
};

var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  }),

  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired
  })
};

var Nav = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Nav, _React$Component);

  function Nav() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Nav);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    if (!this._needsRefocus) {
      return;
    }

    this._needsRefocus = false;

    var children = this.props.children;

    var _getActiveProps = this.getActiveProps(),
        activeKey = _getActiveProps.activeKey,
        activeHref = _getActiveProps.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    });

    var childrenArray = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].toArray(children);
    var activeChildIndex = childrenArray.indexOf(activeChild);

    var childNodes = __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(this).children;
    var activeNode = childNodes && childNodes[activeChildIndex];

    if (!activeNode || !activeNode.firstChild) {
      return;
    }

    activeNode.firstChild.focus();
  };

  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
    var nextActiveChild = void 0;

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.left:
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.up:
        nextActiveChild = this.getNextActiveChild(-1);
        break;
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.right:
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.down:
        nextActiveChild = this.getNextActiveChild(1);
        break;
      default:
        // It was a different key; don't handle this keypress.
        return;
    }

    event.preventDefault();

    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
      onSelect(nextActiveChild.props.eventKey);
    }

    this._needsRefocus = true;
  };

  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
    var _this3 = this;

    var children = this.props.children;

    var validChildren = children.filter(function (child) {
      return child.props.eventKey != null && !child.props.disabled;
    });

    var _getActiveProps2 = this.getActiveProps(),
        activeKey = _getActiveProps2.activeKey,
        activeHref = _getActiveProps2.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this3.isActive(child, activeKey, activeHref);
    });

    // This assumes the active child is not disabled.
    var activeChildIndex = validChildren.indexOf(activeChild);
    if (activeChildIndex === -1) {
      // Something has gone wrong. Select the first valid child we can find.
      return validChildren[0];
    }

    var nextIndex = activeChildIndex + offset;
    var numValidChildren = validChildren.length;

    if (nextIndex >= numValidChildren) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = numValidChildren - 1;
    }

    return validChildren[nextIndex];
  };

  Nav.prototype.getActiveProps = function getActiveProps() {
    var tabContainer = this.context.$bs_tabContainer;

    if (tabContainer) {
       false ? warning(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;

      return tabContainer;
    }

    return this.props;
  };

  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
    var props = _ref2.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    return props.active;
  };

  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
    var _this4 = this;

    if (!tabContainer && navRole !== 'tablist') {
      // No tab props here.
      return null;
    }

    var _child$props = child.props,
        id = _child$props.id,
        controls = _child$props['aria-controls'],
        eventKey = _child$props.eventKey,
        role = _child$props.role,
        onKeyDown = _child$props.onKeyDown,
        tabIndex = _child$props.tabIndex;


    if (tabContainer) {
       false ? warning(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;

      id = tabContainer.getTabId(eventKey);
      controls = tabContainer.getPaneId(eventKey);
    }

    if (navRole === 'tablist') {
      role = role || 'tab';
      onKeyDown = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(function (event) {
        return _this4.handleTabKeyDown(onSelect, event);
      }, onKeyDown);
      tabIndex = active ? tabIndex : -1;
    }

    return {
      id: id,
      role: role,
      onKeyDown: onKeyDown,
      'aria-controls': controls,
      tabIndex: tabIndex
    };
  };

  Nav.prototype.render = function render() {
    var _extends2,
        _this5 = this;

    var _props = this.props,
        stacked = _props.stacked,
        justified = _props.justified,
        onSelect = _props.onSelect,
        propsRole = _props.role,
        propsNavbar = _props.navbar,
        pullRight = _props.pullRight,
        pullLeft = _props.pullLeft,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);

    var tabContainer = this.context.$bs_tabContainer;
    var role = propsRole || (tabContainer ? 'tablist' : null);

    var _getActiveProps3 = this.getActiveProps(),
        activeKey = _getActiveProps3.activeKey,
        activeHref = _getActiveProps3.activeHref;

    delete props.activeKey; // Accessed via this.getActiveProps().
    delete props.activeHref; // Accessed via this.getActiveProps().

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'stacked')] = stacked, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'justified')] = justified, _extends2));

    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
    var pullLeftClassName = void 0;
    var pullRightClassName = void 0;

    if (navbar) {
      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

      classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'nav')] = true;

      pullRightClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'right');
      pullLeftClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'left');
    } else {
      pullRightClassName = 'pull-right';
      pullLeftClassName = 'pull-left';
    }

    classes[pullRightClassName] = pullRight;
    classes[pullLeftClassName] = pullLeft;

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: role,
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        var active = _this5.isActive(child, activeKey, activeHref);
        var childOnSelect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
          active: active,
          activeKey: activeKey,
          activeHref: activeHref,
          onSelect: childOnSelect
        }));
      })
    );
  };

  return Nav;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
Nav.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["c" /* bsClass */])('nav', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["f" /* bsStyles */])(['tabs', 'pills'], Nav)));

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(98);












var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};

var defaultProps = {
  active: false,
  disabled: false
};

var NavItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavItem, _React$Component);

  function NavItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  NavItem.prototype.handleClick = function handleClick(e) {
    if (this.props.onSelect) {
      e.preventDefault();

      if (!this.props.disabled) {
        this.props.onSelect(this.props.eventKey, e);
      }
    }
  };

  NavItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        onClick = _props.onClick,
        className = _props.className,
        style = _props.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'disabled', 'onClick', 'className', 'style']);

    delete props.onSelect;
    delete props.eventKey;

    // These are injected down by `<Nav>` for building `<SubNav>`s.
    delete props.activeKey;
    delete props.activeHref;

    if (!props.role) {
      if (props.href === '#') {
        props.role = 'button';
      }
    } else if (props.role === 'tab') {
      props['aria-selected'] = active;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        role: 'presentation',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        disabled: disabled,
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
      }))
    );
  };

  return NavItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (NavItem);

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
  })
};

var NavbarBrand = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarBrand, _React$Component);

  function NavbarBrand() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarBrand);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarBrand.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'brand');

    if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(children.props.className, className, bsClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName) }),
      children
    );
  };

  return NavbarBrand;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarBrand.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarBrand);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Fade__ = __webpack_require__(395);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default.a.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * A callback invoked by the overlay when it wishes to be hidden. Required if
   * `rootClose` is specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Use animation
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default.a]),

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Sets the direction of the Overlay.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left'])
});

var defaultProps = {
  animation: __WEBPACK_IMPORTED_MODULE_10__Fade__["a" /* default */],
  rootClose: false,
  show: false,
  placement: 'right'
};

var Overlay = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Overlay, _React$Component);

  function Overlay() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Overlay);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Overlay.prototype.render = function render() {
    var _props = this.props,
        animation = _props.animation,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['animation', 'children']);

    var transition = animation === true ? __WEBPACK_IMPORTED_MODULE_10__Fade__["a" /* default */] : animation || null;

    var child = void 0;

    if (!transition) {
      child = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(children, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(children.props.className, 'in')
      });
    } else {
      child = children;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default.a,
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, {
        transition: transition
      }),
      child
    );
  };

  return Overlay;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(98);












var propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  next: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};

var defaultProps = {
  disabled: false,
  previous: false,
  next: false
};

var PagerItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PagerItem, _React$Component);

  function PagerItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PagerItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleSelect = _this.handleSelect.bind(_this);
    return _this;
  }

  PagerItem.prototype.handleSelect = function handleSelect(e) {
    var _props = this.props,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (onSelect || disabled) {
      e.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, e);
    }
  };

  PagerItem.prototype.render = function render() {
    var _props2 = this.props,
        disabled = _props2.disabled,
        previous = _props2.previous,
        next = _props2.next,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);

    delete props.onSelect;
    delete props.eventKey;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { disabled: disabled, previous: previous, next: next }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        disabled: disabled,
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, this.handleSelect)
      }))
    );
  };

  return PagerItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

PagerItem.propTypes = propTypes;
PagerItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (PagerItem);

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(98);













// TODO: This should be `<Pagination.Item>`.

// TODO: This should use `componentClass` like other components.

var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */],
  active: false,
  disabled: false
};

var PaginationButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PaginationButton, _React$Component);

  function PaginationButton(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PaginationButton);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  PaginationButton.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  PaginationButton.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        active = _props2.active,
        disabled = _props2.disabled,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);

    if (Component === __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */]) {
      // Assume that custom components want `eventKey`.
      delete props.eventKey;
    }

    delete props.onSelect;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        disabled: disabled,
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
      }))
    );
  };

  return PaginationButton;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

PaginationButton.propTypes = propTypes;
PaginationButton.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (PaginationButton);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__ = __webpack_require__(116);














var propTypes = {
  accordion: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  defaultActiveKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  role: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  accordion: false
};

// TODO: Use uncontrollable.

var PanelGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(PanelGroup, _React$Component);

  function PanelGroup(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PanelGroup);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleSelect = _this.handleSelect.bind(_this);

    _this.state = {
      activeKey: props.defaultActiveKey
    };
    return _this;
  }

  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
    e.preventDefault();

    if (this.props.onSelect) {
      this.props.onSelect(key, e);
    }

    if (this.state.activeKey === key) {
      key = null;
    }

    this.setState({ activeKey: key });
  };

  PanelGroup.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        accordion = _props.accordion,
        propsActiveKey = _props.activeKey,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['accordion', 'activeKey', 'className', 'children']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['defaultActiveKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeKey = void 0;
    if (accordion) {
      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
      elementProps.role = elementProps.role || 'tablist';
    }

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        var childProps = {
          bsStyle: child.props.bsStyle || bsProps.bsStyle
        };

        if (accordion) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(childProps, {
            headerRole: 'tab',
            panelRole: 'tabpanel',
            collapsible: true,
            expanded: child.props.eventKey === activeKey,
            onSelect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(_this2.handleSelect, child.props.onSelect)
          });
        }

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, childProps);
      })
    );
  };

  return PanelGroup;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

PanelGroup.propTypes = propTypes;
PanelGroup.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('panel-group', PanelGroup));

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Fade__ = __webpack_require__(395);
















var propTypes = {
  /**
   * Uniquely identify the `<TabPane>` among its siblings.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,

  /**
   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
   * `true` to enable the default `<Fade>` animation or any `<Transition>`
   * component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),

  /** @private **/
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /** @private **/
  'aria-labelledby': __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * If not explicitly specified and rendered in the context of a
   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
   * If otherwise not explicitly specified, `tab-pane`.
   */
  bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * Transition onEnter callback when animation is not `false`
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onEntering callback when animation is not `false`
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onEntered callback when animation is not `false`
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExit callback when animation is not `false`
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExiting callback when animation is not `false`
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExited callback when animation is not `false`
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount the tab (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    getTabId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    getPaneId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  }),
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired
  })
};

/**
 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
 * conflict with the top level one.
 */
var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null])
};

var TabPane = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TabPane, _React$Component);

  function TabPane(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabPane);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleEnter = _this.handleEnter.bind(_this);
    _this.handleExited = _this.handleExited.bind(_this);

    _this['in'] = false;
    return _this;
  }

  TabPane.prototype.getChildContext = function getChildContext() {
    return {
      $bs_tabContainer: null
    };
  };

  TabPane.prototype.componentDidMount = function componentDidMount() {
    if (this.shouldBeIn()) {
      // In lieu of the action event firing.
      this.handleEnter();
    }
  };

  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this['in']) {
      if (!this.shouldBeIn()) {
        // We shouldn't be active any more. Notify the parent.
        this.handleExited();
      }
    } else if (this.shouldBeIn()) {
      // We are the active child. Notify the parent.
      this.handleEnter();
    }
  };

  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this['in']) {
      // In lieu of the action event firing.
      this.handleExited();
    }
  };

  TabPane.prototype.handleEnter = function handleEnter() {
    var tabContent = this.context.$bs_tabContent;
    if (!tabContent) {
      return;
    }

    this['in'] = tabContent.onPaneEnter(this, this.props.eventKey);
  };

  TabPane.prototype.handleExited = function handleExited() {
    var tabContent = this.context.$bs_tabContent;
    if (!tabContent) {
      return;
    }

    tabContent.onPaneExited(this);
    this['in'] = false;
  };

  TabPane.prototype.getAnimation = function getAnimation() {
    if (this.props.animation != null) {
      return this.props.animation;
    }

    var tabContent = this.context.$bs_tabContent;
    return tabContent && tabContent.animation;
  };

  TabPane.prototype.isActive = function isActive() {
    var tabContent = this.context.$bs_tabContent;
    var activeKey = tabContent && tabContent.activeKey;

    return this.props.eventKey === activeKey;
  };

  TabPane.prototype.shouldBeIn = function shouldBeIn() {
    return this.getAnimation() && this.isActive();
  };

  TabPane.prototype.render = function render() {
    var _props = this.props,
        eventKey = _props.eventKey,
        className = _props.className,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onExited = _props.onExited,
        propsMountOnEnter = _props.mountOnEnter,
        propsUnmountOnExit = _props.unmountOnExit,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);

    var _context = this.context,
        tabContent = _context.$bs_tabContent,
        tabContainer = _context.$bs_tabContainer;

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['animation']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var active = this.isActive();
    var animation = this.getAnimation();

    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;

    if (!active && !animation && unmountOnExit) {
      return null;
    }

    var Transition = animation === true ? __WEBPACK_IMPORTED_MODULE_12__Fade__["a" /* default */] : animation || null;

    if (tabContent) {
      bsProps.bsClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(tabContent, 'pane');
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {
      active: active
    });

    if (tabContainer) {
       false ? warning(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;

      elementProps.id = tabContainer.getPaneId(eventKey);
      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
    }

    var pane = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'tabpanel',
      'aria-hidden': !active,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));

    if (Transition) {
      var exiting = tabContent && tabContent.exiting;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        Transition,
        {
          'in': active && !exiting,
          onEnter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter),
          onEntering: onEntering,
          onEntered: onEntered,
          onExit: onExit,
          onExiting: onExiting,
          onExited: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExited, onExited),
          mountOnEnter: mountOnEnter,
          unmountOnExit: unmountOnExit
        },
        pane
      );
    }

    return pane;
  };

  return TabPane;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

TabPane.propTypes = propTypes;
TabPane.contextTypes = contextTypes;
TabPane.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsClass */])('tab-pane', TabPane));

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(309);










var propTypes = {
  /**
   * The `<input>` `type`
   * @type {[type]}
   */
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['checkbox', 'radio']),

  /**
   * The HTML input name, used to group like checkboxes or radio buttons together
   * semantically
   */
  name: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
   */
  checked: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * [onChange description]
   */
  onChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  /**
   * The value of the input, and unique identifier in the ToggleButtonGroup
   */
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any.isRequired
};

var ToggleButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ToggleButton, _React$Component);

  function ToggleButton() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ToggleButton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ToggleButton.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        name = _props.name,
        checked = _props.checked,
        type = _props.type,
        onChange = _props.onChange,
        value = _props.value,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'name', 'checked', 'type', 'onChange', 'value']);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        active: !!checked,
        componentClass: 'label'
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', {
        name: name,
        type: type,
        autoComplete: 'off',
        value: value,
        checked: !!checked,
        onChange: onChange
      }),
      children
    );
  };

  return ToggleButton;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ToggleButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (ToggleButton);

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2479), __esModule: true };

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2481), __esModule: true };

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _height = __webpack_require__(2732);

var _height2 = _interopRequireDefault(_height);

var _offset = __webpack_require__(295);

var _offset2 = _interopRequireDefault(_offset);

var _offsetParent = __webpack_require__(877);

var _offsetParent2 = _interopRequireDefault(_offsetParent);

var _scrollTop = __webpack_require__(545);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _requestAnimationFrame = __webpack_require__(880);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(94);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _addEventListener = __webpack_require__(397);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _getDocumentHeight = __webpack_require__(1099);

var _getDocumentHeight2 = _interopRequireDefault(_getDocumentHeight);

var _ownerDocument = __webpack_require__(235);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _ownerWindow = __webpack_require__(1101);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Affix/>` component toggles `position: fixed;` on and off, emulating
 * the effect found with `position: sticky;`.
 */
var Affix = function (_React$Component) {
  _inherits(Affix, _React$Component);

  function Affix(props, context) {
    _classCallCheck(this, Affix);

    var _this = _possibleConstructorReturn(this, (Affix.__proto__ || Object.getPrototypeOf(Affix)).call(this, props, context));

    _this.onWindowScroll = function () {
      _this.onUpdate();
    };

    _this.onDocumentClick = function () {
      (0, _requestAnimationFrame2.default)(function () {
        return _this.onUpdate();
      });
    };

    _this.onUpdate = function () {
      if (!_this._isMounted) {
        return;
      }

      var _this$props = _this.props;
      var offsetTop = _this$props.offsetTop;
      var viewportOffsetTop = _this$props.viewportOffsetTop;

      var scrollTop = (0, _scrollTop2.default)((0, _ownerWindow2.default)(_this));
      var positionTopMin = scrollTop + (viewportOffsetTop || 0);

      if (positionTopMin <= offsetTop) {
        _this.updateState('top', null, null);
        return;
      }

      if (positionTopMin > _this.getPositionTopMax()) {
        if (_this.state.affixed === 'bottom') {
          _this.updateStateAtBottom();
        } else {
          // Setting position away from `fixed` can change the offset parent of
          // the affix, so we can't calculate the correct position until after
          // we've updated its position.
          _this.setState({
            affixed: 'bottom',
            position: 'absolute',
            top: null
          }, function () {
            if (!_this._isMounted) {
              return;
            }

            _this.updateStateAtBottom();
          });
        }
        return;
      }

      _this.updateState('affix', 'fixed', viewportOffsetTop);
    };

    _this.getPositionTopMax = function () {
      var documentHeight = (0, _getDocumentHeight2.default)((0, _ownerDocument2.default)(_this));
      var height = (0, _height2.default)(_reactDom2.default.findDOMNode(_this));

      return documentHeight - height - _this.props.offsetBottom;
    };

    _this.updateState = function (affixed, position, top) {
      if (affixed === _this.state.affixed && position === _this.state.position && top === _this.state.top) {
        return;
      }

      var upperName = affixed === 'affix' ? '' : affixed.charAt(0).toUpperCase() + affixed.substr(1);

      if (_this.props['onAffix' + upperName]) {
        _this.props['onAffix' + upperName]();
      }

      _this.setState({ affixed: affixed, position: position, top: top }, function () {
        if (_this.props['onAffixed' + upperName]) {
          _this.props['onAffixed' + upperName]();
        }
      });
    };

    _this.updateStateAtBottom = function () {
      var positionTopMax = _this.getPositionTopMax();
      var offsetParent = (0, _offsetParent2.default)(_reactDom2.default.findDOMNode(_this));
      var parentTop = (0, _offset2.default)(offsetParent).top;

      _this.updateState('bottom', 'absolute', positionTopMax - parentTop);
    };

    _this.state = {
      affixed: 'top',
      position: null,
      top: null
    };

    _this._needPositionUpdate = false;
    return _this;
  }

  _createClass(Affix, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;

      this._windowScrollListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'scroll', function () {
        return _this2.onWindowScroll();
      });
      this._documentClickListener = (0, _addEventListener2.default)((0, _ownerDocument2.default)(this), 'click', function () {
        return _this2.onDocumentClick();
      });

      this.onUpdate();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this._needPositionUpdate = true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this._needPositionUpdate) {
        this._needPositionUpdate = false;
        this.onUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;

      if (this._windowScrollListener) {
        this._windowScrollListener.remove();
      }
      if (this._documentClickListener) {
        this._documentClickListener.remove();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var child = _react2.default.Children.only(this.props.children);
      var _child$props = child.props;
      var className = _child$props.className;
      var style = _child$props.style;
      var _state = this.state;
      var affixed = _state.affixed;
      var position = _state.position;
      var top = _state.top;

      var positionStyle = { position: position, top: top };

      var affixClassName = void 0;
      var affixStyle = void 0;
      if (affixed === 'top') {
        affixClassName = this.props.topClassName;
        affixStyle = this.props.topStyle;
      } else if (affixed === 'bottom') {
        affixClassName = this.props.bottomClassName;
        affixStyle = this.props.bottomStyle;
      } else {
        affixClassName = this.props.affixClassName;
        affixStyle = this.props.affixStyle;
      }

      return _react2.default.cloneElement(child, {
        className: (0, _classnames2.default)(affixClassName, className),
        style: _extends({}, positionStyle, affixStyle, style)
      });
    }
  }]);

  return Affix;
}(_react2.default.Component);

Affix.propTypes = {
  /**
   * Pixels to offset from top of screen when calculating position
   */
  offsetTop: _propTypes2.default.number,

  /**
   * When affixed, pixels to offset from top of viewport
   */
  viewportOffsetTop: _propTypes2.default.number,

  /**
   * Pixels to offset from bottom of screen when calculating position
   */
  offsetBottom: _propTypes2.default.number,

  /**
   * CSS class or classes to apply when at top
   */
  topClassName: _propTypes2.default.string,

  /**
   * Style to apply when at top
   */
  topStyle: _propTypes2.default.object,

  /**
   * CSS class or classes to apply when affixed
   */
  affixClassName: _propTypes2.default.string,
  /**
   * Style to apply when affixed
   */
  affixStyle: _propTypes2.default.object,

  /**
   * CSS class or classes to apply when at bottom
   */
  bottomClassName: _propTypes2.default.string,

  /**
   * Style to apply when at bottom
   */
  bottomStyle: _propTypes2.default.object,

  /**
   * Callback fired when the right before the `affixStyle` and `affixStyle` props are rendered
   */
  onAffix: _propTypes2.default.func,
  /**
   * Callback fired after the component `affixStyle` and `affixClassName` props have been rendered.
   */
  onAffixed: _propTypes2.default.func,

  /**
   * Callback fired when the right before the `topStyle` and `topClassName` props are rendered
   */
  onAffixTop: _propTypes2.default.func,

  /**
   * Callback fired after the component `topStyle` and `topClassName` props have been rendered.
   */
  onAffixedTop: _propTypes2.default.func,

  /**
   * Callback fired when the right before the `bottomStyle` and `bottomClassName` props are rendered
   */
  onAffixBottom: _propTypes2.default.func,

  /**
   * Callback fired after the component `bottomStyle` and `bottomClassName` props have been rendered.
   */
  onAffixedBottom: _propTypes2.default.func
};

Affix.defaultProps = {
  offsetTop: 0,
  viewportOffsetTop: null,
  offsetBottom: 0
};

exports.default = Affix;
module.exports = exports['default'];

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(69);

var _warning2 = _interopRequireDefault(_warning);

var _componentOrElement = __webpack_require__(399);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _elementType = __webpack_require__(1102);

var _elementType2 = _interopRequireDefault(_elementType);

var _Portal = __webpack_require__(586);

var _Portal2 = _interopRequireDefault(_Portal);

var _ModalManager = __webpack_require__(3055);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _ownerDocument = __webpack_require__(235);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _addEventListener = __webpack_require__(397);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _addFocusListener = __webpack_require__(3057);

var _addFocusListener2 = _interopRequireDefault(_addFocusListener);

var _inDOM = __webpack_require__(181);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _activeElement = __webpack_require__(875);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(257);

var _contains2 = _interopRequireDefault(_contains);

var _getContainer = __webpack_require__(398);

var _getContainer2 = _interopRequireDefault(_getContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint-disable react/prop-types */


var modalManager = new _ModalManager2.default();

/**
 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
 * The Modal component renders its `children` node in front of a backdrop component.
 *
 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
 *
 * - Manages dialog stacking when one-at-a-time just isn't enough.
 * - Creates a backdrop, for disabling interaction below the modal.
 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
 * - It disables scrolling of the page content while open.
 * - Adds the appropriate ARIA roles are automatically.
 * - Easily pluggable animations via a `<Transition/>` component.
 *
 * Note that, in the same way the backdrop element prevents users from clicking or interacting
 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
 * interact with page content while the Modal is open. To do this, we use a common technique of applying
 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
 * React hierarchy (such as the default: document.body).
 */

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'omitProps',
    value: function omitProps(props, propTypes) {

      var keys = Object.keys(props);
      var newProps = {};
      keys.map(function (prop) {
        if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
          newProps[prop] = props[prop];
        }
      });

      return newProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var show = _props.show;
      var container = _props.container;
      var children = _props.children;
      var Transition = _props.transition;
      var backdrop = _props.backdrop;
      var dialogTransitionTimeout = _props.dialogTransitionTimeout;
      var className = _props.className;
      var style = _props.style;
      var onExit = _props.onExit;
      var onExiting = _props.onExiting;
      var onEnter = _props.onEnter;
      var onEntering = _props.onEntering;
      var onEntered = _props.onEntered;


      var dialog = _react2.default.Children.only(children);
      var filteredProps = this.omitProps(this.props, Modal.propTypes);

      var mountModal = show || Transition && !this.state.exited;
      if (!mountModal) {
        return null;
      }

      var _dialog$props = dialog.props;
      var role = _dialog$props.role;
      var tabIndex = _dialog$props.tabIndex;


      if (role === undefined || tabIndex === undefined) {
        dialog = (0, _react.cloneElement)(dialog, {
          role: role === undefined ? 'document' : role,
          tabIndex: tabIndex == null ? '-1' : tabIndex
        });
      }

      if (Transition) {
        dialog = _react2.default.createElement(
          Transition,
          {
            transitionAppear: true,
            unmountOnExit: true,
            'in': show,
            timeout: dialogTransitionTimeout,
            onExit: onExit,
            onExiting: onExiting,
            onExited: this.handleHidden,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered
          },
          dialog
        );
      }

      return _react2.default.createElement(
        _Portal2.default,
        {
          ref: this.setMountNode,
          container: container
        },
        _react2.default.createElement(
          'div',
          _extends({
            ref: this.setModalNode,
            role: role || 'dialog'
          }, filteredProps, {
            style: style,
            className: className
          }),
          backdrop && this.renderBackdrop(),
          dialog
        )
      );
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.show) {
        this.setState({ exited: false });
      } else if (!nextProps.transition) {
        // Otherwise let handleHidden take care of marking exited.
        this.setState({ exited: true });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (!this.props.show && nextProps.show) {
        this.checkForFocus();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      if (this.props.show) {
        this.onShow();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var transition = this.props.transition;


      if (prevProps.show && !this.props.show && !transition) {
        // Otherwise handleHidden will call this.
        this.onHide();
      } else if (!prevProps.show && this.props.show) {
        this.onShow();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props2 = this.props;
      var show = _props2.show;
      var transition = _props2.transition;


      this._isMounted = false;

      if (show || transition && !this.state.exited) {
        this.onHide();
      }
    }

    //instead of a ref, which might conflict with one the parent applied.

  }]);

  return Modal;
}(_react2.default.Component);

Modal.propTypes = _extends({}, _Portal2.default.propTypes, {

  /**
   * Set the visibility of the Modal
   */
  show: _propTypes2.default.bool,

  /**
   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * A callback fired when the Modal is opening.
   */
  onShow: _propTypes2.default.func,

  /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */
  onHide: _propTypes2.default.func,

  /**
   * Include a backdrop component.
   */
  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),

  /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */
  renderBackdrop: _propTypes2.default.func,

  /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   */
  onEscapeKeyUp: _propTypes2.default.func,

  /**
   * A callback fired when the backdrop, if specified, is clicked.
   */
  onBackdropClick: _propTypes2.default.func,

  /**
   * A style object for the backdrop component.
   */
  backdropStyle: _propTypes2.default.object,

  /**
   * A css class or classes for the backdrop component.
   */
  backdropClassName: _propTypes2.default.string,

  /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */
  containerClassName: _propTypes2.default.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: _propTypes2.default.bool,

  /**
   * A `<Transition/>` component to use for the dialog and backdrop components.
   */
  transition: _elementType2.default,

  /**
   * The `timeout` of the dialog transition if specified. This number is used to ensure that
   * transition callbacks are always fired, even if browser transition events are canceled.
   *
   * See the Transition `timeout` prop for more infomation.
   */
  dialogTransitionTimeout: _propTypes2.default.number,

  /**
   * The `timeout` of the backdrop transition if specified. This number is used to
   * ensure that transition callbacks are always fired, even if browser transition events are canceled.
   *
   * See the Transition `timeout` prop for more infomation.
   */
  backdropTransitionTimeout: _propTypes2.default.number,

  /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  enforceFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: _propTypes2.default.bool,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: _propTypes2.default.func,

  /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */
  manager: _propTypes2.default.object.isRequired
});
Modal.defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  onHide: function onHide() {},
  manager: modalManager,
  renderBackdrop: function renderBackdrop(props) {
    return _react2.default.createElement('div', props);
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = { exited: !this.props.show };

  this.renderBackdrop = function () {
    var _props3 = _this2.props;
    var backdropStyle = _props3.backdropStyle;
    var backdropClassName = _props3.backdropClassName;
    var renderBackdrop = _props3.renderBackdrop;
    var Transition = _props3.transition;
    var backdropTransitionTimeout = _props3.backdropTransitionTimeout;


    var backdropRef = function backdropRef(ref) {
      return _this2.backdrop = ref;
    };

    var backdrop = renderBackdrop({
      ref: backdropRef,
      style: backdropStyle,
      className: backdropClassName,
      onClick: _this2.handleBackdropClick
    });

    if (Transition) {
      backdrop = _react2.default.createElement(
        Transition,
        { transitionAppear: true,
          'in': _this2.props.show,
          timeout: backdropTransitionTimeout
        },
        backdrop
      );
    }

    return backdrop;
  };

  this.onShow = function () {
    var doc = (0, _ownerDocument2.default)(_this2);
    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);

    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);

    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);

    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);

    _this2.focus();

    if (_this2.props.onShow) {
      _this2.props.onShow();
    }
  };

  this.onHide = function () {
    _this2.props.manager.remove(_this2);

    _this2._onDocumentKeyupListener.remove();

    _this2._onFocusinListener.remove();

    if (_this2.props.restoreFocus) {
      _this2.restoreLastFocus();
    }
  };

  this.setMountNode = function (ref) {
    _this2.mountNode = ref ? ref.getMountNode() : ref;
  };

  this.setModalNode = function (ref) {
    _this2.modalNode = ref;
  };

  this.handleHidden = function () {
    _this2.setState({ exited: true });
    _this2.onHide();

    if (_this2.props.onExited) {
      var _props4;

      (_props4 = _this2.props).onExited.apply(_props4, arguments);
    }
  };

  this.handleBackdropClick = function (e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    if (_this2.props.onBackdropClick) {
      _this2.props.onBackdropClick(e);
    }

    if (_this2.props.backdrop === true) {
      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyUp = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyUp) {
        _this2.props.onEscapeKeyUp(e);
      }
      _this2.props.onHide();
    }
  };

  this.checkForFocus = function () {
    if (_inDOM2.default) {
      _this2.lastFocus = (0, _activeElement2.default)();
    }
  };

  this.focus = function () {
    var autoFocus = _this2.props.autoFocus;
    var modalContent = _this2.getDialogElement();
    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
    var focusInModal = current && (0, _contains2.default)(modalContent, current);

    if (modalContent && autoFocus && !focusInModal) {
      _this2.lastFocus = current;

      if (!modalContent.hasAttribute('tabIndex')) {
        modalContent.setAttribute('tabIndex', -1);
        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
      }

      modalContent.focus();
    }
  };

  this.restoreLastFocus = function () {
    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
    if (_this2.lastFocus && _this2.lastFocus.focus) {
      _this2.lastFocus.focus();
      _this2.lastFocus = null;
    }
  };

  this.enforceFocus = function () {
    var enforceFocus = _this2.props.enforceFocus;


    if (!enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
      return;
    }

    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
    var modal = _this2.getDialogElement();

    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
      modal.focus();
    }
  };

  this.getDialogElement = function () {
    var node = _this2.modalNode;
    return node && node.lastChild;
  };

  this.isTopModal = function () {
    return _this2.props.manager.isTopModal(_this2);
  };
};

Modal.Manager = _ModalManager2.default;

exports.default = Modal;
module.exports = exports['default'];

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Portal = __webpack_require__(586);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(1098);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(587);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

var _elementType = __webpack_require__(1102);

var _elementType2 = _interopRequireDefault(_elementType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  _createClass(Overlay, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.show) {
        this.setState({ exited: false });
      } else if (!nextProps.transition) {
        // Otherwise let handleHidden take care of marking exited.
        this.setState({ exited: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var container = _props.container;
      var containerPadding = _props.containerPadding;
      var target = _props.target;
      var placement = _props.placement;
      var shouldUpdatePosition = _props.shouldUpdatePosition;
      var rootClose = _props.rootClose;
      var children = _props.children;
      var Transition = _props.transition;

      var props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

      // Don't un-render the overlay while it's transitioning out.


      var mountOverlay = props.show || Transition && !this.state.exited;
      if (!mountOverlay) {
        // Don't bother showing anything if we don't have to.
        return null;
      }

      var child = children;

      // Position is be inner-most because it adds inline styles into the child,
      // which the other wrappers don't forward correctly.
      child = _react2.default.createElement(
        _Position2.default,
        { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
        child
      );

      if (Transition) {
        var onExit = props.onExit;
        var onExiting = props.onExiting;
        var onEnter = props.onEnter;
        var onEntering = props.onEntering;
        var onEntered = props.onEntered;

        // This animates the child node by injecting props, so it must precede
        // anything that adds a wrapping div.

        child = _react2.default.createElement(
          Transition,
          {
            'in': props.show,
            transitionAppear: true,
            onExit: onExit,
            onExiting: onExiting,
            onExited: this.onHiddenListener,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered
          },
          child
        );
      }

      // This goes after everything else because it adds a wrapping div.
      if (rootClose) {
        child = _react2.default.createElement(
          _RootCloseWrapper2.default,
          { onRootClose: props.onHide },
          child
        );
      }

      return _react2.default.createElement(
        _Portal2.default,
        { container: container },
        child
      );
    }
  }]);

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },


  /**
   * A `<Transition/>` component used to animate the overlay changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(94);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _componentOrElement = __webpack_require__(399);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _calculatePosition = __webpack_require__(3058);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(398);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(235);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  _createClass(Position, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updatePosition(this.getTarget());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this._needsFlush = true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this._needsFlush) {
        this._needsFlush = false;
        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var className = _props.className;

      var props = _objectWithoutProperties(_props, ['children', 'className']);

      var _state = this.state;
      var positionLeft = _state.positionLeft;
      var positionTop = _state.positionTop;

      var arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

      // These should not be forwarded to the child.


      delete props.target;
      delete props.container;
      delete props.containerPadding;
      delete props.shouldUpdatePosition;

      var child = _react2.default.Children.only(children);
      return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
        // FIXME: Don't forward `positionLeft` and `positionTop` via both props
        // and `props.style`.
        positionLeft: positionLeft,
        positionTop: positionTop,
        className: (0, _classnames2.default)(className, child.props.className),
        style: _extends({}, child.props.style, {
          left: positionLeft,
          top: positionTop
        })
      }));
    }
  }, {
    key: 'updatePosition',
    value: function updatePosition(target) {
      this._lastTarget = target;

      if (!target) {
        this.setState({
          positionLeft: 0,
          positionTop: 0,
          arrowOffsetLeft: null,
          arrowOffsetTop: null
        });

        return;
      }

      var overlay = _reactDom2.default.findDOMNode(this);
      var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

      this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
    }
  }]);

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (doc) {
  return Math.max(doc.documentElement.offsetHeight || 0, doc.height || 0, doc.body.scrollHeight || 0, doc.body.offsetHeight || 0);
};

module.exports = exports["default"]; /**
                                      * Get the height of the document
                                      *
                                      * @returns {documentHeight: number}
                                      */

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isOverflowing;

var _isWindow = __webpack_require__(294);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(229);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument2.default)(node);
  var win = (0, _isWindow2.default)(doc);
  var fullWidth = win.innerWidth;

  // Support: ie8, no innerWidth
  if (!fullWidth) {
    var documentElementRect = doc.documentElement.getBoundingClientRect();
    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
  }

  return doc.body.clientWidth < fullWidth;
}

function isOverflowing(container) {
  var win = (0, _isWindow2.default)(container);

  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}
module.exports = exports['default'];

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (componentOrElement) {
  return (0, _ownerWindow2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(94);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerWindow = __webpack_require__(2731);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(1103);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeByType = exports.hideConfirm = exports.showConfirm = exports.remove = exports.clean = undefined;
exports.add = add;

var _constants = __webpack_require__(590);

var _utils = __webpack_require__(261);

var _reducer = __webpack_require__(1105);

var _config = __webpack_require__(589);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function add(toastr) {
  if (_config2.default.preventDuplicates && (0, _utils.preventDuplication)(_reducer.toastrsCache, toastr)) {
    return {
      type: _constants.ADD_TOASTR,
      payload: {
        ignoreToastr: true
      }
    };
  }
  return {
    type: _constants.ADD_TOASTR,
    payload: toastr
  };
}

var clean = exports.clean = function clean() {
  return { type: _constants.CLEAN_TOASTR };
};

var remove = exports.remove = function remove(payload) {
  return {
    type: _constants.REMOVE_TOASTR,
    payload: payload
  };
};

var showConfirm = exports.showConfirm = function showConfirm(payload) {
  return {
    type: _constants.SHOW_CONFIRM,
    payload: payload
  };
};

var hideConfirm = exports.hideConfirm = function hideConfirm() {
  return { type: _constants.HIDE_CONFIRM };
};

var removeByType = exports.removeByType = function removeByType(payload) {
  return {
    type: _constants.REMOVE_BY_TYPE,
    payload: payload
  };
};

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toastrsCache = undefined;

var _createReducer;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(261);

var _config = __webpack_require__(589);

var _config2 = _interopRequireDefault(_config);

var _constants = __webpack_require__(590);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// We will cache data so we can check for duplicated before fire the add action.
var toastrsCache = exports.toastrsCache = [];

var initialState = {
  toastrs: [],
  confirm: null
};

exports.default = (0, _utils.createReducer)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _constants.ADD_TOASTR, function (state, toastr) {
  if (toastr.ignoreToastr) {
    return state;
  }

  var newToastr = _extends({
    id: (0, _utils.guid)(),
    position: _config2.default.position
  }, toastr);

  var newState = {};
  if (!_config2.default.newestOnTop) {
    newState = _extends({}, state, {
      toastrs: [].concat(_toConsumableArray(state.toastrs), [newToastr])
    });
  } else {
    newState = _extends({}, state, {
      toastrs: [newToastr].concat(_toConsumableArray(state.toastrs))
    });
  }
  exports.toastrsCache = toastrsCache = newState.toastrs;
  return newState;
}), _defineProperty(_createReducer, _constants.REMOVE_TOASTR, function (state, id) {
  var newState = _extends({}, state, {
    toastrs: state.toastrs.filter(function (toastr) {
      return toastr.id !== id;
    })
  });

  exports.toastrsCache = toastrsCache = newState.toastrs;
  return newState;
}), _defineProperty(_createReducer, _constants.REMOVE_BY_TYPE, function (state, type) {
  var newState = _extends({}, state, {
    toastrs: state.toastrs.filter(function (toastr) {
      return toastr.type !== type;
    })
  });

  exports.toastrsCache = toastrsCache = newState.toastrs;
  return newState;
}), _defineProperty(_createReducer, _constants.CLEAN_TOASTR, function (state) {
  exports.toastrsCache = toastrsCache = [];
  return _extends({}, state, {
    toastrs: []
  });
}), _defineProperty(_createReducer, _constants.SHOW_CONFIRM, function (state, _ref) {
  var id = _ref.id,
      message = _ref.message,
      options = _ref.options;

  return _extends({}, state, {
    confirm: {
      id: id || (0, _utils.guid)(),
      show: true,
      message: message,
      options: options || {}
    }
  });
}), _defineProperty(_createReducer, _constants.HIDE_CONFIRM, function (state) {
  return _extends({}, state, {
    confirm: null
  });
}), _createReducer));

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toastrEmitter = exports.EE = undefined;

var _utils = __webpack_require__(261);

var _eventemitter = __webpack_require__(3067);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emitter = new _eventemitter2.default();

var addToToastr = function addToToastr(type, array) {
  return emitter.emit('add/toastr', (0, _utils.mapToToastrMessage)(type, array));
};

var actions = {};
['light', 'message', 'info', 'success', 'warning', 'error'].forEach(function (item) {
  actions[item] = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return addToToastr(item, args);
  };
});

actions.clean = function () {
  return emitter.emit('clean/toastr');
};

/**
 * @params: can be a ID or a object that with a property type: 'success'
 * and by passing this we will remove all toastr with that type.
 */
actions.removeByType = function (type) {
  return emitter.emit('removeByType/toastr', type);
};

actions.confirm = function () {
  emitter.emit('toastr/confirm', {
    message: arguments.length <= 0 ? undefined : arguments[0],
    options: (arguments.length <= 1 ? undefined : arguments[1]) || {}
  });
};

var EE = exports.EE = emitter;
var toastrEmitter = exports.toastrEmitter = actions;

/***/ }),
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(594);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(3101);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(3102);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(593);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(69);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(3215);


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomByte = __webpack_require__(3217);

function encode(lookup, number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + lookup( ( (number >> (4 * loopCounter)) & 0x0f ) | randomByte() );
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = encode;


/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pubsub_js__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pubsub_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pubsub_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_session_actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_Upgrade_actions__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__globalSettings__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__cable__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__createStore__ = __webpack_require__(165);
/* unused harmony export store */




















if (true) {
  var script = document.createElement("script");
  script.innerHTML = "var _rollbarConfig = {" + ("    accessToken: \"" + "e2ec8b53eff743aaa8a5a465775af8d2" + "\",\n") + "    captureUncaught: true,\n" + "    payload: {\n" + ("        environment: \"" + "production" + "\",\n") + ("        code_version: \"" + "e8bc068e5cd6d98f599c28a03dfa9ec58be79c63" + "\"\n") + "    }\n" + "};\n" + "!function(r){function o(n){if(e[n])return e[n].exports;var t=e[n]={exports:{},id:n,loaded:!1};return r[n].call(t.exports,t,t.exports,o),t.loaded=!0,t.exports}var e={};return o.m=r,o.c=e,o.p=\"\",o(0)}([function(r,o,e){\"use strict\";var n=e(1),t=e(4);_rollbarConfig=_rollbarConfig||{},_rollbarConfig.rollbarJsUrl=_rollbarConfig.rollbarJsUrl||\"https://cdnjs.cloudflare.com/ajax/libs/rollbar.js/2.2.7/rollbar.min.js\",_rollbarConfig.async=void 0===_rollbarConfig.async||_rollbarConfig.async;var a=n.setupShim(window,_rollbarConfig),l=t(_rollbarConfig);window.rollbar=n.Rollbar,a.loadFull(window,document,!_rollbarConfig.async,_rollbarConfig,l)},function(r,o,e){\"use strict\";function n(r){return function(){try{return r.apply(this,arguments)}catch(r){try{console.error(\"[Rollbar]: Internal error\",r)}catch(r){}}}}function t(r,o){this.options=r,this._rollbarOldOnError=null;var e=s++;this.shimId=function(){return e},window&&window._rollbarShims&&(window._rollbarShims[e]={handler:o,messages:[]})}function a(r,o){var e=o.globalAlias||\"Rollbar\";if(\"object\"==typeof r[e])return r[e];r._rollbarShims={},r._rollbarWrappedError=null;var t=new p(o);return n(function(){o.captureUncaught&&(t._rollbarOldOnError=r.onerror,i.captureUncaughtExceptions(r,t,!0),i.wrapGlobals(r,t,!0)),o.captureUnhandledRejections&&i.captureUnhandledRejections(r,t,!0);var n=o.autoInstrument;return(void 0===n||n===!0||\"object\"==typeof n&&n.network)&&r.addEventListener&&(r.addEventListener(\"load\",t.captureLoad.bind(t)),r.addEventListener(\"DOMContentLoaded\",t.captureDomContentLoaded.bind(t))),r[e]=t,t})()}function l(r){return n(function(){var o=this,e=Array.prototype.slice.call(arguments,0),n={shim:o,method:r,args:e,ts:new Date};window._rollbarShims[this.shimId()].messages.push(n)})}var i=e(2),s=0,d=e(3),c=function(r,o){return new t(r,o)},p=d.bind(null,c);t.prototype.loadFull=function(r,o,e,t,a){var l=function(){var o;if(void 0===r._rollbarDidLoad){o=new Error(\"rollbar.js did not load\");for(var e,n,t,l,i=0;e=r._rollbarShims[i++];)for(e=e.messages||[];n=e.shift();)for(t=n.args||[],i=0;i<t.length;++i)if(l=t[i],\"function\"==typeof l){l(o);break}}\"function\"==typeof a&&a(o)},i=!1,s=o.createElement(\"script\"),d=o.getElementsByTagName(\"script\")[0],c=d.parentNode;s.crossOrigin=\"\",s.src=t.rollbarJsUrl,e||(s.async=!0),s.onload=s.onreadystatechange=n(function(){if(!(i||this.readyState&&\"loaded\"!==this.readyState&&\"complete\"!==this.readyState)){s.onload=s.onreadystatechange=null;try{c.removeChild(s)}catch(r){}i=!0,l()}}),c.insertBefore(s,d)},t.prototype.wrap=function(r,o,e){try{var n;if(n=\"function\"==typeof o?o:function(){return o||{}},\"function\"!=typeof r)return r;if(r._isWrap)return r;if(!r._rollbar_wrapped&&(r._rollbar_wrapped=function(){e&&\"function\"==typeof e&&e.apply(this,arguments);try{return r.apply(this,arguments)}catch(e){var o=e;throw\"string\"==typeof o&&(o=new String(o)),o._rollbarContext=n()||{},o._rollbarContext._wrappedSource=r.toString(),window._rollbarWrappedError=o,o}},r._rollbar_wrapped._isWrap=!0,r.hasOwnProperty))for(var t in r)r.hasOwnProperty(t)&&(r._rollbar_wrapped[t]=r[t]);return r._rollbar_wrapped}catch(o){return r}};for(var u=\"log,debug,info,warn,warning,error,critical,global,configure,handleUncaughtException,handleUnhandledRejection,captureDomContentLoaded,captureLoad\".split(\",\"),f=0;f<u.length;++f)t.prototype[u[f]]=l(u[f]);r.exports={setupShim:a,Rollbar:p}},function(r,o){\"use strict\";function e(r,o,e){if(r){var t;\"function\"==typeof o._rollbarOldOnError?t=o._rollbarOldOnError:r.onerror&&!r.onerror.belongsToShim&&(t=r.onerror,o._rollbarOldOnError=t);var a=function(){var e=Array.prototype.slice.call(arguments,0);n(r,o,t,e)};a.belongsToShim=e,r.onerror=a}}function n(r,o,e,n){r._rollbarWrappedError&&(n[4]||(n[4]=r._rollbarWrappedError),n[5]||(n[5]=r._rollbarWrappedError._rollbarContext),r._rollbarWrappedError=null),o.handleUncaughtException.apply(o,n),e&&e.apply(r,n)}function t(r,o,e){if(r){\"function\"==typeof r._rollbarURH&&r._rollbarURH.belongsToShim&&r.removeEventListener(\"unhandledrejection\",r._rollbarURH);var n=function(r){var e=r.reason,n=r.promise,t=r.detail;!e&&t&&(e=t.reason,n=t.promise),o&&o.handleUnhandledRejection&&o.handleUnhandledRejection(e,n)};n.belongsToShim=e,r._rollbarURH=n,r.addEventListener(\"unhandledrejection\",n)}}function a(r,o,e){if(r){var n,t,a=\"EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload\".split(\",\");for(n=0;n<a.length;++n)t=a[n],r[t]&&r[t].prototype&&l(o,r[t].prototype,e)}}function l(r,o,e){if(o.hasOwnProperty&&o.hasOwnProperty(\"addEventListener\")){for(var n=o.addEventListener;n._rollbarOldAdd&&n.belongsToShim;)n=n._rollbarOldAdd;var t=function(o,e,t){n.call(this,o,r.wrap(e),t)};t._rollbarOldAdd=n,t.belongsToShim=e,o.addEventListener=t;for(var a=o.removeEventListener;a._rollbarOldRemove&&a.belongsToShim;)a=a._rollbarOldRemove;var l=function(r,o,e){a.call(this,r,o&&o._rollbar_wrapped||o,e)};l._rollbarOldRemove=a,l.belongsToShim=e,o.removeEventListener=l}}r.exports={captureUncaughtExceptions:e,captureUnhandledRejections:t,wrapGlobals:a}},function(r,o){\"use strict\";function e(r,o){this.impl=r(o,this),this.options=o,n(e.prototype)}function n(r){for(var o=function(r){return function(){var o=Array.prototype.slice.call(arguments,0);if(this.impl[r])return this.impl[r].apply(this.impl,o)}},e=\"log,debug,info,warn,warning,error,critical,global,configure,handleUncaughtException,handleUnhandledRejection,_createItem,wrap,loadFull,shimId,captureDomContentLoaded,captureLoad\".split(\",\"),n=0;n<e.length;n++)r[e[n]]=o(e[n])}e.prototype._swapAndProcessMessages=function(r,o){this.impl=r(this.options);for(var e,n,t;e=o.shift();)n=e.method,t=e.args,this[n]&&\"function\"==typeof this[n]&&(\"captureDomContentLoaded\"===n||\"captureLoad\"===n?this[n].apply(this,[t[0],e.ts]):this[n].apply(this,t));return this},r.exports=e},function(r,o){\"use strict\";r.exports=function(r){return function(o){if(!o&&!window._rollbarInitialized){r=r||{};for(var e,n,t=r.globalAlias||\"Rollbar\",a=window.rollbar,l=function(r){return new a(r)},i=0;e=window._rollbarShims[i++];)n||(n=e.handler),e.handler._swapAndProcessMessages(l,e.messages);window[t]=n,window._rollbarInitialized=!0}}}}]);";
  document.head.appendChild(script);
}

if (!["development", "staging"].includes("production")) {
  var _script = document.createElement("script");

  _script.innerHTML = "(function(w, u, d){var i=function(){i.c(arguments)};i.q=[];i.c=function(args){i.q.push(args)};var l = function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://code.upscope.io/nxejHQRFKi.js';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(typeof u!==\"function\"){w.Upscope=i;l();}})(window, window.Upscope, document);\n \n    Upscope('init');";
  document.head.appendChild(_script);
}
// INTERCOM

var intercomScript = document.createElement("script");

intercomScript.innerHTML = "(function(){var w=window;var ic=w.Intercom;if(typeof ic===\"function\"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/uo2xpwcp';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();";

document.head.appendChild(intercomScript);

var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__createStore__["a" /* default */])();

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__cable__["a" /* initialize */])(store);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__["initializeStore"])(store);

var serializedUser = window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__modules_users_constants__["a" /* USER */]);
var settings = window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* SETTINGS */]);

var salesCartItems = window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__modules_users_constants__["b" /* SALES_CART_ITEMS */]) || "[]";
var repairCartItems = window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__modules_users_constants__["c" /* REPAIR_CART_ITEMS */]) || "[]";
var bookmarks = window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_7__modules_users_constants__["d" /* BOOKMARKS */]) || "[]";

if (serializedUser && settings) {
  store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__modules_session_actions__["login"])(JSON.parse(serializedUser), JSON.parse(settings)));
}

store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__modules_session_actions__["setCarts"])({
  bookmarks: JSON.parse(bookmarks),
  repairCartItems: JSON.parse(repairCartItems),
  salesCartItems: JSON.parse(salesCartItems)
}));

__WEBPACK_IMPORTED_MODULE_4_pubsub_js___default.a.subscribe("session.expired", function () {
  store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__modules_session_actions__["expire"])());
});

__WEBPACK_IMPORTED_MODULE_4_pubsub_js___default.a.subscribe("releaseId.read", function (msg, releaseId) {
  store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__modules_Upgrade_actions__["a" /* checkForUpgrade */])(releaseId));
});

__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_2_react_redux__["Provider"],
  { store: store },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["ConnectedRouter"],
    { history: __WEBPACK_IMPORTED_MODULE_13__createStore__["b" /* history */] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__App__["a" /* default */], null)
  )
), document.getElementById("app"));

/***/ }),
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * accounting.js v0.4.1
 * Copyright 2014 Open Exchange Rates
 *
 * Freely distributable under the MIT license.
 * Portions of accounting.js are inspired or borrowed from underscore.js
 *
 * Full details and documentation:
 * http://openexchangerates.github.io/accounting.js/
 */

(function(root, undefined) {

	/* --- Setup --- */

	// Create the local library object, to be exported or referenced globally later
	var lib = {};

	// Current version
	lib.version = '0.4.1';


	/* --- Exposed settings --- */

	// The library's settings configuration object. Contains default parameters for
	// currency and number formatting
	lib.settings = {
		currency: {
			symbol : "$",		// default currency symbol is '$'
			format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
			decimal : ".",		// decimal point separator
			thousand : ",",		// thousands separator
			precision : 2,		// decimal places
			grouping : 3		// digit grouping (not implemented yet)
		},
		number: {
			precision : 0,		// default precision on numbers is 0
			grouping : 3,		// digit grouping (not implemented yet)
			thousand : ",",
			decimal : "."
		}
	};


	/* --- Internal Helper Methods --- */

	// Store reference to possibly-available ECMAScript 5 methods for later
	var nativeMap = Array.prototype.map,
		nativeIsArray = Array.isArray,
		toString = Object.prototype.toString;

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js
	 */
	function isString(obj) {
		return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
	}

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js, delegates to ECMA5's native Array.isArray
	 */
	function isArray(obj) {
		return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
	}

	/**
	 * Tests whether supplied parameter is a true object
	 */
	function isObject(obj) {
		return obj && toString.call(obj) === '[object Object]';
	}

	/**
	 * Extends an object with a defaults object, similar to underscore's _.defaults
	 *
	 * Used for abstracting parameter handling from API methods
	 */
	function defaults(object, defs) {
		var key;
		object = object || {};
		defs = defs || {};
		// Iterate over object non-prototype properties:
		for (key in defs) {
			if (defs.hasOwnProperty(key)) {
				// Replace values with defaults only if undefined (allow empty/zero values):
				if (object[key] == null) object[key] = defs[key];
			}
		}
		return object;
	}

	/**
	 * Implementation of `Array.map()` for iteration loops
	 *
	 * Returns a new Array as a result of calling `iterator` on each array value.
	 * Defers to native Array.map if available
	 */
	function map(obj, iterator, context) {
		var results = [], i, j;

		if (!obj) return results;

		// Use native .map method if it exists:
		if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);

		// Fallback for native .map:
		for (i = 0, j = obj.length; i < j; i++ ) {
			results[i] = iterator.call(context, obj[i], i, obj);
		}
		return results;
	}

	/**
	 * Check and normalise the value of precision (must be positive integer)
	 */
	function checkPrecision(val, base) {
		val = Math.round(Math.abs(val));
		return isNaN(val)? base : val;
	}


	/**
	 * Parses a format string or object and returns format obj for use in rendering
	 *
	 * `format` is either a string with the default (positive) format, or object
	 * containing `pos` (required), `neg` and `zero` values (or a function returning
	 * either a string or object)
	 *
	 * Either string or format.pos must contain "%v" (value) to be valid
	 */
	function checkCurrencyFormat(format) {
		var defaults = lib.settings.currency.format;

		// Allow function as format parameter (should return string or object):
		if ( typeof format === "function" ) format = format();

		// Format can be a string, in which case `value` ("%v") must be present:
		if ( isString( format ) && format.match("%v") ) {

			// Create and return positive, negative and zero formats:
			return {
				pos : format,
				neg : format.replace("-", "").replace("%v", "-%v"),
				zero : format
			};

		// If no format, or object is missing valid positive value, use defaults:
		} else if ( !format || !format.pos || !format.pos.match("%v") ) {

			// If defaults is a string, casts it to an object for faster checking next time:
			return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
				pos : defaults,
				neg : defaults.replace("%v", "-%v"),
				zero : defaults
			};

		}
		// Otherwise, assume format was fine:
		return format;
	}


	/* --- API Methods --- */

	/**
	 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
	 * Alias: `accounting.parse(string)`
	 *
	 * Decimal must be included in the regular expression to match floats (defaults to
	 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
	 * separator, provide it as the second argument.
	 *
	 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
	 *
	 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
	 */
	var unformat = lib.unformat = lib.parse = function(value, decimal) {
		// Recursively unformat arrays:
		if (isArray(value)) {
			return map(value, function(val) {
				return unformat(val, decimal);
			});
		}

		// Fails silently (need decent errors):
		value = value || 0;

		// Return the value as-is if it's already a number:
		if (typeof value === "number") return value;

		// Default decimal point comes from settings, but could be set to eg. "," in opts:
		decimal = decimal || lib.settings.number.decimal;

		 // Build regex to strip out everything except digits, decimal point and minus sign:
		var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
			unformatted = parseFloat(
				("" + value)
				.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
				.replace(regex, '')         // strip out any cruft
				.replace(decimal, '.')      // make sure decimal point is standard
			);

		// This will fail silently which may cause trouble, let's wait and see:
		return !isNaN(unformatted) ? unformatted : 0;
	};


	/**
	 * Implementation of toFixed() that treats floats more like decimals
	 *
	 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
	 * problems for accounting- and finance-related software.
	 */
	var toFixed = lib.toFixed = function(value, precision) {
		precision = checkPrecision(precision, lib.settings.number.precision);
		var power = Math.pow(10, precision);

		// Multiply up by precision, round accurately, then divide and use native toFixed():
		return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
	};


	/**
	 * Format a number, with comma-separated thousands and custom precision/decimal places
	 * Alias: `accounting.format()`
	 *
	 * Localise by overriding the precision and thousand / decimal separators
	 * 2nd parameter `precision` can be an object matching `settings.number`
	 */
	var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val) {
				return formatNumber(val, precision, thousand, decimal);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(precision) ? precision : {
					precision : precision,
					thousand : thousand,
					decimal : decimal
				}),
				lib.settings.number
			),

			// Clean up precision
			usePrecision = checkPrecision(opts.precision),

			// Do some calc:
			negative = number < 0 ? "-" : "",
			base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
			mod = base.length > 3 ? base.length % 3 : 0;

		// Format the number:
		return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
	};


	/**
	 * Format a number into currency
	 *
	 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
	 * defaults: (0, "$", 2, ",", ".", "%s%v")
	 *
	 * Localise by overriding the symbol, precision, thousand / decimal separators and format
	 * Second param can be an object matching `settings.currency` which is the easiest way.
	 *
	 * To do: tidy up the parameters
	 */
	var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val){
				return formatMoney(val, symbol, precision, thousand, decimal, format);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero):
			formats = checkCurrencyFormat(opts.format),

			// Choose which format to use for this value:
			useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;

		// Return with currency symbol added:
		return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	};


	/**
	 * Format a list of numbers into an accounting column, padding with whitespace
	 * to line up currency symbols, thousand separators and decimals places
	 *
	 * List should be an array of numbers
	 * Second parameter can be an object containing keys that match the params
	 *
	 * Returns array of accouting-formatted number strings of same length
	 *
	 * NB: `white-space:pre` CSS rule is required on the list container to prevent
	 * browsers from collapsing the whitespace in the output strings.
	 */
	lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
		if (!list) return [];

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero), only need pos for now:
			formats = checkCurrencyFormat(opts.format),

			// Whether to pad at start of string or after currency symbol:
			padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,

			// Store value for the length of the longest string in the column:
			maxLength = 0,

			// Format the list according to options, store the length of the longest string:
			formatted = map(list, function(val, i) {
				if (isArray(val)) {
					// Recursively format columns if list is a multi-dimensional array:
					return lib.formatColumn(val, opts);
				} else {
					// Clean up the value
					val = unformat(val);

					// Choose which format to use for this value (pos, neg or zero):
					var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,

						// Format this value, push into formatted list and save the length:
						fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));

					if (fVal.length > maxLength) maxLength = fVal.length;
					return fVal;
				}
			});

		// Pad each number in the list and send back the column of numbers:
		return map(formatted, function(val, i) {
			// Only if this is a string (not a nested array, which would have already been padded):
			if (isString(val) && val.length < maxLength) {
				// Depending on symbol position, pad after symbol or at index 0:
				return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
			}
			return val;
		});
	};


	/* --- Module Definition --- */

	// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
	// Otherwise, just add `accounting` to the global object
	if (true) {
		if (typeof module !== 'undefined' && module.exports) {
			exports = module.exports = lib;
		}
		exports.accounting = lib;
	} else if (typeof define === 'function' && define.amd) {
		// Return the library as an AMD module:
		define([], function() {
			return lib;
		});
	} else {
		// Use accounting.noConflict to restore `accounting` back to its original value.
		// Returns a reference to the library's `accounting` object;
		// e.g. `var numbers = accounting.noConflict();`
		lib.noConflict = (function(oldAccounting) {
			return function() {
				// Reset the value of the root's `accounting` variable:
				root.accounting = oldAccounting;
				// Delete the noConflict method:
				lib.noConflict = undefined;
				// Return reference to the library to re-assign it:
				return lib;
			};
		})(root.accounting);

		// Declare `fx` on the root (global/window) object:
		root['accounting'] = lib;
	}

	// Root will be `window` in browser or `global` on the server:
}(this));


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {
  (function() {
    (function() {
      var slice = [].slice;

      this.ActionCable = {
        INTERNAL: {
          "message_types": {
            "welcome": "welcome",
            "ping": "ping",
            "confirmation": "confirm_subscription",
            "rejection": "reject_subscription"
          },
          "default_mount_path": "/cable",
          "protocols": ["actioncable-v1-json", "actioncable-unsupported"]
        },
        createConsumer: function(url) {
          var ref;
          if (url == null) {
            url = (ref = this.getConfig("url")) != null ? ref : this.INTERNAL.default_mount_path;
          }
          return new ActionCable.Consumer(this.createWebSocketURL(url));
        },
        getConfig: function(name) {
          var element;
          element = document.head.querySelector("meta[name='action-cable-" + name + "']");
          return element != null ? element.getAttribute("content") : void 0;
        },
        createWebSocketURL: function(url) {
          var a;
          if (url && !/^wss?:/i.test(url)) {
            a = document.createElement("a");
            a.href = url;
            a.href = a.href;
            a.protocol = a.protocol.replace("http", "ws");
            return a.href;
          } else {
            return url;
          }
        },
        startDebugging: function() {
          return this.debugging = true;
        },
        stopDebugging: function() {
          return this.debugging = null;
        },
        log: function() {
          var messages;
          messages = 1 <= arguments.length ? slice.call(arguments, 0) : [];
          if (this.debugging) {
            messages.push(Date.now());
            return console.log.apply(console, ["[ActionCable]"].concat(slice.call(messages)));
          }
        }
      };

    }).call(this);
  }).call(this);

  var ActionCable = this.ActionCable;

  (function() {
    (function() {
      var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

      ActionCable.ConnectionMonitor = (function() {
        var clamp, now, secondsSince;

        ConnectionMonitor.pollInterval = {
          min: 3,
          max: 30
        };

        ConnectionMonitor.staleThreshold = 6;

        function ConnectionMonitor(connection) {
          this.connection = connection;
          this.visibilityDidChange = bind(this.visibilityDidChange, this);
          this.reconnectAttempts = 0;
        }

        ConnectionMonitor.prototype.start = function() {
          if (!this.isRunning()) {
            this.startedAt = now();
            delete this.stoppedAt;
            this.startPolling();
            document.addEventListener("visibilitychange", this.visibilityDidChange);
            return ActionCable.log("ConnectionMonitor started. pollInterval = " + (this.getPollInterval()) + " ms");
          }
        };

        ConnectionMonitor.prototype.stop = function() {
          if (this.isRunning()) {
            this.stoppedAt = now();
            this.stopPolling();
            document.removeEventListener("visibilitychange", this.visibilityDidChange);
            return ActionCable.log("ConnectionMonitor stopped");
          }
        };

        ConnectionMonitor.prototype.isRunning = function() {
          return (this.startedAt != null) && (this.stoppedAt == null);
        };

        ConnectionMonitor.prototype.recordPing = function() {
          return this.pingedAt = now();
        };

        ConnectionMonitor.prototype.recordConnect = function() {
          this.reconnectAttempts = 0;
          this.recordPing();
          delete this.disconnectedAt;
          return ActionCable.log("ConnectionMonitor recorded connect");
        };

        ConnectionMonitor.prototype.recordDisconnect = function() {
          this.disconnectedAt = now();
          return ActionCable.log("ConnectionMonitor recorded disconnect");
        };

        ConnectionMonitor.prototype.startPolling = function() {
          this.stopPolling();
          return this.poll();
        };

        ConnectionMonitor.prototype.stopPolling = function() {
          return clearTimeout(this.pollTimeout);
        };

        ConnectionMonitor.prototype.poll = function() {
          return this.pollTimeout = setTimeout((function(_this) {
            return function() {
              _this.reconnectIfStale();
              return _this.poll();
            };
          })(this), this.getPollInterval());
        };

        ConnectionMonitor.prototype.getPollInterval = function() {
          var interval, max, min, ref;
          ref = this.constructor.pollInterval, min = ref.min, max = ref.max;
          interval = 5 * Math.log(this.reconnectAttempts + 1);
          return Math.round(clamp(interval, min, max) * 1000);
        };

        ConnectionMonitor.prototype.reconnectIfStale = function() {
          if (this.connectionIsStale()) {
            ActionCable.log("ConnectionMonitor detected stale connection. reconnectAttempts = " + this.reconnectAttempts + ", pollInterval = " + (this.getPollInterval()) + " ms, time disconnected = " + (secondsSince(this.disconnectedAt)) + " s, stale threshold = " + this.constructor.staleThreshold + " s");
            this.reconnectAttempts++;
            if (this.disconnectedRecently()) {
              return ActionCable.log("ConnectionMonitor skipping reopening recent disconnect");
            } else {
              ActionCable.log("ConnectionMonitor reopening");
              return this.connection.reopen();
            }
          }
        };

        ConnectionMonitor.prototype.connectionIsStale = function() {
          var ref;
          return secondsSince((ref = this.pingedAt) != null ? ref : this.startedAt) > this.constructor.staleThreshold;
        };

        ConnectionMonitor.prototype.disconnectedRecently = function() {
          return this.disconnectedAt && secondsSince(this.disconnectedAt) < this.constructor.staleThreshold;
        };

        ConnectionMonitor.prototype.visibilityDidChange = function() {
          if (document.visibilityState === "visible") {
            return setTimeout((function(_this) {
              return function() {
                if (_this.connectionIsStale() || !_this.connection.isOpen()) {
                  ActionCable.log("ConnectionMonitor reopening stale connection on visibilitychange. visbilityState = " + document.visibilityState);
                  return _this.connection.reopen();
                }
              };
            })(this), 200);
          }
        };

        now = function() {
          return new Date().getTime();
        };

        secondsSince = function(time) {
          return (now() - time) / 1000;
        };

        clamp = function(number, min, max) {
          return Math.max(min, Math.min(max, number));
        };

        return ConnectionMonitor;

      })();

    }).call(this);
    (function() {
      var i, message_types, protocols, ref, supportedProtocols, unsupportedProtocol,
        slice = [].slice,
        bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
        indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

      ref = ActionCable.INTERNAL, message_types = ref.message_types, protocols = ref.protocols;

      supportedProtocols = 2 <= protocols.length ? slice.call(protocols, 0, i = protocols.length - 1) : (i = 0, []), unsupportedProtocol = protocols[i++];

      ActionCable.Connection = (function() {
        Connection.reopenDelay = 500;

        function Connection(consumer) {
          this.consumer = consumer;
          this.open = bind(this.open, this);
          this.subscriptions = this.consumer.subscriptions;
          this.monitor = new ActionCable.ConnectionMonitor(this);
          this.disconnected = true;
        }

        Connection.prototype.send = function(data) {
          if (this.isOpen()) {
            this.webSocket.send(JSON.stringify(data));
            return true;
          } else {
            return false;
          }
        };

        Connection.prototype.open = function() {
          if (this.isActive()) {
            ActionCable.log("Attempted to open WebSocket, but existing socket is " + (this.getState()));
            throw new Error("Existing connection must be closed before opening");
          } else {
            ActionCable.log("Opening WebSocket, current state is " + (this.getState()) + ", subprotocols: " + protocols);
            if (this.webSocket != null) {
              this.uninstallEventHandlers();
            }
            this.webSocket = new WebSocket(this.consumer.url, protocols);
            this.installEventHandlers();
            this.monitor.start();
            return true;
          }
        };

        Connection.prototype.close = function(arg) {
          var allowReconnect, ref1;
          allowReconnect = (arg != null ? arg : {
            allowReconnect: true
          }).allowReconnect;
          if (!allowReconnect) {
            this.monitor.stop();
          }
          if (this.isActive()) {
            return (ref1 = this.webSocket) != null ? ref1.close() : void 0;
          }
        };

        Connection.prototype.reopen = function() {
          var error;
          ActionCable.log("Reopening WebSocket, current state is " + (this.getState()));
          if (this.isActive()) {
            try {
              return this.close();
            } catch (error1) {
              error = error1;
              return ActionCable.log("Failed to reopen WebSocket", error);
            } finally {
              ActionCable.log("Reopening WebSocket in " + this.constructor.reopenDelay + "ms");
              setTimeout(this.open, this.constructor.reopenDelay);
            }
          } else {
            return this.open();
          }
        };

        Connection.prototype.getProtocol = function() {
          var ref1;
          return (ref1 = this.webSocket) != null ? ref1.protocol : void 0;
        };

        Connection.prototype.isOpen = function() {
          return this.isState("open");
        };

        Connection.prototype.isActive = function() {
          return this.isState("open", "connecting");
        };

        Connection.prototype.isProtocolSupported = function() {
          var ref1;
          return ref1 = this.getProtocol(), indexOf.call(supportedProtocols, ref1) >= 0;
        };

        Connection.prototype.isState = function() {
          var ref1, states;
          states = 1 <= arguments.length ? slice.call(arguments, 0) : [];
          return ref1 = this.getState(), indexOf.call(states, ref1) >= 0;
        };

        Connection.prototype.getState = function() {
          var ref1, state, value;
          for (state in WebSocket) {
            value = WebSocket[state];
            if (value === ((ref1 = this.webSocket) != null ? ref1.readyState : void 0)) {
              return state.toLowerCase();
            }
          }
          return null;
        };

        Connection.prototype.installEventHandlers = function() {
          var eventName, handler;
          for (eventName in this.events) {
            handler = this.events[eventName].bind(this);
            this.webSocket["on" + eventName] = handler;
          }
        };

        Connection.prototype.uninstallEventHandlers = function() {
          var eventName;
          for (eventName in this.events) {
            this.webSocket["on" + eventName] = function() {};
          }
        };

        Connection.prototype.events = {
          message: function(event) {
            var identifier, message, ref1, type;
            if (!this.isProtocolSupported()) {
              return;
            }
            ref1 = JSON.parse(event.data), identifier = ref1.identifier, message = ref1.message, type = ref1.type;
            switch (type) {
              case message_types.welcome:
                this.monitor.recordConnect();
                return this.subscriptions.reload();
              case message_types.ping:
                return this.monitor.recordPing();
              case message_types.confirmation:
                return this.subscriptions.notify(identifier, "connected");
              case message_types.rejection:
                return this.subscriptions.reject(identifier);
              default:
                return this.subscriptions.notify(identifier, "received", message);
            }
          },
          open: function() {
            ActionCable.log("WebSocket onopen event, using '" + (this.getProtocol()) + "' subprotocol");
            this.disconnected = false;
            if (!this.isProtocolSupported()) {
              ActionCable.log("Protocol is unsupported. Stopping monitor and disconnecting.");
              return this.close({
                allowReconnect: false
              });
            }
          },
          close: function(event) {
            ActionCable.log("WebSocket onclose event");
            if (this.disconnected) {
              return;
            }
            this.disconnected = true;
            this.monitor.recordDisconnect();
            return this.subscriptions.notifyAll("disconnected", {
              willAttemptReconnect: this.monitor.isRunning()
            });
          },
          error: function() {
            return ActionCable.log("WebSocket onerror event");
          }
        };

        return Connection;

      })();

    }).call(this);
    (function() {
      var slice = [].slice;

      ActionCable.Subscriptions = (function() {
        function Subscriptions(consumer) {
          this.consumer = consumer;
          this.subscriptions = [];
        }

        Subscriptions.prototype.create = function(channelName, mixin) {
          var channel, params, subscription;
          channel = channelName;
          params = typeof channel === "object" ? channel : {
            channel: channel
          };
          subscription = new ActionCable.Subscription(this.consumer, params, mixin);
          return this.add(subscription);
        };

        Subscriptions.prototype.add = function(subscription) {
          this.subscriptions.push(subscription);
          this.consumer.ensureActiveConnection();
          this.notify(subscription, "initialized");
          this.sendCommand(subscription, "subscribe");
          return subscription;
        };

        Subscriptions.prototype.remove = function(subscription) {
          this.forget(subscription);
          if (!this.findAll(subscription.identifier).length) {
            this.sendCommand(subscription, "unsubscribe");
          }
          return subscription;
        };

        Subscriptions.prototype.reject = function(identifier) {
          var i, len, ref, results, subscription;
          ref = this.findAll(identifier);
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            subscription = ref[i];
            this.forget(subscription);
            this.notify(subscription, "rejected");
            results.push(subscription);
          }
          return results;
        };

        Subscriptions.prototype.forget = function(subscription) {
          var s;
          this.subscriptions = (function() {
            var i, len, ref, results;
            ref = this.subscriptions;
            results = [];
            for (i = 0, len = ref.length; i < len; i++) {
              s = ref[i];
              if (s !== subscription) {
                results.push(s);
              }
            }
            return results;
          }).call(this);
          return subscription;
        };

        Subscriptions.prototype.findAll = function(identifier) {
          var i, len, ref, results, s;
          ref = this.subscriptions;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            s = ref[i];
            if (s.identifier === identifier) {
              results.push(s);
            }
          }
          return results;
        };

        Subscriptions.prototype.reload = function() {
          var i, len, ref, results, subscription;
          ref = this.subscriptions;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            subscription = ref[i];
            results.push(this.sendCommand(subscription, "subscribe"));
          }
          return results;
        };

        Subscriptions.prototype.notifyAll = function() {
          var args, callbackName, i, len, ref, results, subscription;
          callbackName = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
          ref = this.subscriptions;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            subscription = ref[i];
            results.push(this.notify.apply(this, [subscription, callbackName].concat(slice.call(args))));
          }
          return results;
        };

        Subscriptions.prototype.notify = function() {
          var args, callbackName, i, len, results, subscription, subscriptions;
          subscription = arguments[0], callbackName = arguments[1], args = 3 <= arguments.length ? slice.call(arguments, 2) : [];
          if (typeof subscription === "string") {
            subscriptions = this.findAll(subscription);
          } else {
            subscriptions = [subscription];
          }
          results = [];
          for (i = 0, len = subscriptions.length; i < len; i++) {
            subscription = subscriptions[i];
            results.push(typeof subscription[callbackName] === "function" ? subscription[callbackName].apply(subscription, args) : void 0);
          }
          return results;
        };

        Subscriptions.prototype.sendCommand = function(subscription, command) {
          var identifier;
          identifier = subscription.identifier;
          return this.consumer.send({
            command: command,
            identifier: identifier
          });
        };

        return Subscriptions;

      })();

    }).call(this);
    (function() {
      ActionCable.Subscription = (function() {
        var extend;

        function Subscription(consumer, params, mixin) {
          this.consumer = consumer;
          if (params == null) {
            params = {};
          }
          this.identifier = JSON.stringify(params);
          extend(this, mixin);
        }

        Subscription.prototype.perform = function(action, data) {
          if (data == null) {
            data = {};
          }
          data.action = action;
          return this.send(data);
        };

        Subscription.prototype.send = function(data) {
          return this.consumer.send({
            command: "message",
            identifier: this.identifier,
            data: JSON.stringify(data)
          });
        };

        Subscription.prototype.unsubscribe = function() {
          return this.consumer.subscriptions.remove(this);
        };

        extend = function(object, properties) {
          var key, value;
          if (properties != null) {
            for (key in properties) {
              value = properties[key];
              object[key] = value;
            }
          }
          return object;
        };

        return Subscription;

      })();

    }).call(this);
    (function() {
      ActionCable.Consumer = (function() {
        function Consumer(url) {
          this.url = url;
          this.subscriptions = new ActionCable.Subscriptions(this);
          this.connection = new ActionCable.Connection(this);
        }

        Consumer.prototype.send = function(data) {
          return this.connection.send(data);
        };

        Consumer.prototype.connect = function() {
          return this.connection.open();
        };

        Consumer.prototype.disconnect = function() {
          return this.connection.close({
            allowReconnect: false
          });
        };

        Consumer.prototype.ensureActiveConnection = function() {
          if (!this.connection.isActive()) {
            return this.connection.open();
          }
        };

        return Consumer;

      })();

    }).call(this);
  }).call(this);

  if (typeof module === "object" && module.exports) {
    module.exports = ActionCable;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (ActionCable),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}).call(this);


/***/ }),
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(2474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_styles_scss__ = __webpack_require__(2747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InfoLogo__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_session_components__ = __webpack_require__(2261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_session_components_ForgotPassword_ForgotPassword__ = __webpack_require__(2254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_session_components_ResetPassword_ResetPassword__ = __webpack_require__(2260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_Customers_IncomingQuote_IncomingQuote__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_Admin_Integrations_QbRedirect__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Layout__ = __webpack_require__(1201);
/* harmony export (immutable) */ __webpack_exports__["a"] = App;













function App() {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    "div",
    { className: "app" },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_router__["Switch"],
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"], { exact: true, path: "/login", component: __WEBPACK_IMPORTED_MODULE_6__modules_session_components__["a" /* Login */] }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"], { exact: true, path: "/forgot-password", component: __WEBPACK_IMPORTED_MODULE_7__modules_session_components_ForgotPassword_ForgotPassword__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"], { exact: true, path: "/reset-password", component: __WEBPACK_IMPORTED_MODULE_8__modules_session_components_ResetPassword_ResetPassword__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"], { path: "/customer-iq", component: __WEBPACK_IMPORTED_MODULE_9__modules_Customers_IncomingQuote_IncomingQuote__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"], { exact: true, path: "/integrations/redirect", component: __WEBPACK_IMPORTED_MODULE_10__modules_Admin_Integrations_QbRedirect__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Route"], { path: "/", component: __WEBPACK_IMPORTED_MODULE_11__Layout__["a" /* default */] })
    ),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default.a, {
      transitionIn: "fadeIn",
      transitionOut: "fadeOut",
      preventDuplicates: true,
      position: "bottom-right"
    }),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__InfoLogo__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { id: "modal-root", style: { position: "absolute", top: 0 } })
  );
}

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_Notifications_components__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_parts_components_PartsCount__ = __webpack_require__(2232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_AccountingLogs_Search_Search__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_QuarterlyGoals_QuarterlyGoals__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_shared_components_Authorized_Forbidden__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_Admin_TierTypeWarningMgmt_TierTypeWarningMgmt__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_Admin_Settings_Settings__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_RemainingInventoryTotals_Table__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_Admin_PartRankings_PartRankings__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_Admin_ApiKeys_ApiKeys__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_Admin_ConsignmentReportCard_ConsignmentReportCard__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_Admin_Integrations_Integrations__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_Admin_CompanyRankings_CompanyRankings__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_Admin_Reports_Search__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_session_actions__ = __webpack_require__(131);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




























function Home(_ref) {
  var currentUser = _ref.currentUser,
      expireSession = _ref.expireSession,
      location = _ref.location;

  var titleText = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__modules_users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["l" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["k" /* SALES */]]) && ![__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["m" /* ACCOUNTING */]].includes(currentUser.role) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__modules_users_helpers__["e" /* hasPermission */])(currentUser, __WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["_26" /* CAN_VIEW_ALL_INVENTORY */]) ? "My Inventory" : "All Inventory";

  if (!currentUser) {
    expireSession();
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
    { style: { marginTop: "30px" } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
      { md: 12 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__modules_parts_components_PartsCount__["a" /* default */], null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "panel panel-default" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "panel-body" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "ul",
            { className: "nav nav-pills nav-stacked" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__modules_shared_components_Authorized_Forbidden__["a" /* default */],
              { subroles: [__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["r" /* WAREHOUSE_BASIC */]] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                  { to: "/inventories" },
                  titleText
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__modules_shared_components__["b" /* Authorized */],
              { roles: [__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["l" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["k" /* SALES */]] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                  { to: "/my-shopping-list" },
                  "My Shopping List"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                  { to: "/resident-expert-parts" },
                  "My Resident Expert Parts"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "li",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                { to: "/dashboard/receiving" },
                "Inbound Orders"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__modules_shared_components__["b" /* Authorized */],
              {
                permissions: [__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["q" /* RECEIVING */]],
                roles: [__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["l" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["j" /* WAREHOUSE */]]
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                  { to: "/dashboard/virtual-receiving" },
                  "Virtual Inbound Orders"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "li",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                { to: "/dashboard/shipping" },
                "Outbound Orders"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__modules_shared_components__["b" /* Authorized */],
              { roles: [] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "a",
                  { href: __WEBPACK_IMPORTED_MODULE_16__constants__["d" /* API_BASE */] + "/outbound_orders/download" },
                  "Download Outbound Orders"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__modules_shared_components_Authorized_Forbidden__["a" /* default */],
              { roles: [__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["j" /* WAREHOUSE */]] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                  { to: "/reports" },
                  "Export Retrieval"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                  { to: "/monthly-purchases" },
                  "Monthly Purchases"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4__modules_shared_components__["b" /* Authorized */],
                { roles: [__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["k" /* SALES */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "li",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                    { to: "/purchases-report" },
                    "Buyer Credit"
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4__modules_shared_components__["b" /* Authorized */],
                { roles: [__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["k" /* SALES */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "li",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                    { to: "/sales-report" },
                    "Seller Credit"
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                  { to: "/monthly-sales" },
                  "Monthly Sales"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__modules_shared_components__["b" /* Authorized */],
              {
                roles: [__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["l" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["m" /* ACCOUNTING */]],
                subroles: [[__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["o" /* QUALITY_CONTROL_ADMIN */], __WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["n" /* QUALITY_CONTROL_MANAGER */]]]
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                  { to: "/monthly-depreciations" },
                  "Monthly Depreciations"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4__modules_shared_components__["b" /* Authorized */],
                { roles: [__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["m" /* ACCOUNTING */]] },
                currentUser.locations && currentUser.locations.some(function (f) {
                  return f.quickbook_realm_id;
                }) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "li",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                    { to: "/accounting-logs" },
                    "Accounting Logs"
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__modules_shared_components__["b" /* Authorized */],
              { roles: [__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["k" /* SALES */]] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                  { to: "/remaining-inventory" },
                  "Remaining Inventory Totals"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__modules_shared_components_Authorized_Forbidden__["a" /* default */],
              { roles: [__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["j" /* WAREHOUSE */]] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__modules_shared_components_Authorized_Forbidden__["a" /* default */],
              { subroles: [__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["r" /* WAREHOUSE_BASIC */]] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                  { to: "/approved-vendors" },
                  "Approved Vendors"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                  { to: "/approved-repair-stations" },
                  "Approved Repair Stations"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "li",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                { to: "/reports/high-scores" },
                "High Scores"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__modules_shared_components__["b" /* Authorized */],
              { roles: [__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["k" /* SALES */]] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                  { to: "/ranking-stats" },
                  "Hot Parts"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "li",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                { to: "/company-ranking-stats" },
                "Top Companies"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__modules_shared_components__["b" /* Authorized */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__modules_QuarterlyGoals_QuarterlyGoals__["a" /* default */], null)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__modules_Admin_TierTypeWarningMgmt_TierTypeWarningMgmt__["a" /* default */], null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__modules_shared_components__["b" /* Authorized */],
              { permissions: [__WEBPACK_IMPORTED_MODULE_6__modules_users_constants__["_28" /* CAN_VIEW_INFOTRADER_SETTINGS */]] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__modules_Admin_Settings_Settings__["a" /* default */], null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__modules_shared_components__["b" /* Authorized */],
              null,
              ["development", "staging"].includes("production") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                  { to: "/integrations" },
                  "Integrations"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
                  { to: "/api-keys" },
                  "API Keys"
                )
              )
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
      { md: 9 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HomeDisplays, { pathname: location && location.pathname })
    )
  );
}

var HomeDisplays = function HomeDisplays(_ref2) {
  var pathname = _ref2.pathname;

  if (pathname === "/remaining-inventory") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__modules_RemainingInventoryTotals_Table__["a" /* default */], null);
  } else if (pathname === "/ranking-stats") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__modules_Admin_PartRankings_PartRankings__["a" /* default */], null);
  } else if (pathname === "/company-ranking-stats") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__modules_Admin_CompanyRankings_CompanyRankings__["a" /* default */], null);
  } else if (pathname === "/api-keys") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__modules_Admin_ApiKeys_ApiKeys__["a" /* default */], null);
  } else if (pathname === "/consignments-report") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__modules_Admin_ConsignmentReportCard_ConsignmentReportCard__["a" /* default */], null);
  } else if (pathname === "/integrations") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__modules_Admin_Integrations_Integrations__["a" /* default */], null);
  } else if (pathname === "/reports") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__modules_Admin_Reports_Search__["a" /* default */], null);
  } else if (pathname === "/accounting-logs") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__modules_AccountingLogs_Search_Search__["a" /* default */], null);
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__modules_Notifications_components__["a" /* Search */], null);
};

HomeDisplays.propTypes = {
  pathname: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    expireSession: function expireSession() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__modules_session_actions__["expire"])());
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__modules_session_decorators_withCurrentUser__["b" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_react_router__["withRouter"])(Home))));

Home.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_7__modules_session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_info_trader_square_gray_png__ = __webpack_require__(2750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_info_trader_square_gray_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_info_trader_square_gray_png__);



/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { position: "fixed", bottom: 10, right: 10 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "a",
      { href: "https://infotrader.aero", target: "_blank", rel: "noopener noreferrer" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: __WEBPACK_IMPORTED_MODULE_1__assets_images_info_trader_square_gray_png___default.a,
        height: 50,
        width: 50,
        style: { cursor: "pointer" },
        alt: "Info Trader"
      })
    )
  );
});

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_Upgrade_actions__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_companies_components__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_parts_components__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_users_components__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_ApprovedVendors_Search_Search__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_ApprovedRepairStations_Search_Search__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_Commissions_components_Search_Search__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_MistakeShipments_components_Detail_Detail__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_Consignments_Detail_Detail__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_PurchaseOrders_components_Search_Search__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_PurchaseOrders_components_Detail_Detail__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_RejectedCores_components_Search_RejectedCoreSearch__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_RejectedCores_components_Detail_Detail__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_RepairOrders_components_Search_RepairOrderSearch__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_RepairOrders_components_Detail_Detail__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_IncomingQuotes_Search_IncomingQuotes__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_IncomingQuotes_Detail_IncomingQuoteDetail__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_inventories_components__ = __webpack_require__(2119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_ManagedRepairOrders_Detail_Detail__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modules_OutgoingQuotes_Search_OutgoingQuotes__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_OutgoingQuotes_Detail_OutgoingQuoteDetail__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modules_Receiving_Dashboard__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__modules_Receiving_Detail__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__modules_Receiving_Search_ReceivingSearch__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__modules_RepairOrders_components_ReserveForRepair__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__modules_SalesOrders_ReserveForSale_ReservedForSaleList__ = __webpack_require__(1777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__modules_Shipping_components_Dashboard__ = __webpack_require__(1940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__modules_MyShoppingList_Search_Search__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__modules_CustomerRmas_components__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__modules_RMAsAndWarranties_components__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__modules_OutgoingShipments_components__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__modules_SalesOrders_components__ = __webpack_require__(1922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__modules_shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__modules_session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__modules_PurchasesReport_Components_Search_Search__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__modules_Lots_Search_Lots__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__modules_MyShoppingList_ResidentExpertSearch_ResidentExpertSearch__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__modules_ManagedRepairOrders_Search_ManagedRepairOrderSearch__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__modules_Lots_Detail_Detail__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__modules_VendorRmas_components__ = __webpack_require__(1947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__modules_parts_components_LotLineItems_LotLineItems__ = __webpack_require__(2221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__modules_Consignments_Search_Consignments__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__modules_SalesDashboard_UserStats_SalesReport__ = __webpack_require__(1768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Home__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Nav__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Sidebar__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__modules_DepreciationsDashboard_Components_Table__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__modules_PurchasesDashboard_Components_Table__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__modules_SalesDashboard_Components_Table__ = __webpack_require__(1766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__modules_shared_components_Authorized_Forbidden__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__modules_MistakeShipments_components_Search_MistakeShipmentSearch__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__modules_HighScores_components_Report__ = __webpack_require__(1311);
/* unused harmony export Layout */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





























































var includesName = function includesName(actualPathName) {
  return function (pathName) {
    return actualPathName.includes(pathName);
  };
};

var navName = function navName(pathName) {
  var includesPath = includesName(pathName);

  switch (pathName) {
    case "/dashboard/receiving":
      return "Inbound Orders";
    case "/dashboard/shipping":
      return "Outbound Orders";
    case "/dashboard/virtual-receiving":
      return "Virtual Inbound Orders";
    default:
      break;
  }

  if (includesPath("part")) {
    return "Parts";
  } else if (includesPath("reports")) {
    return "Reports";
  } else if (includesPath("incoming-quotes")) {
    return "Incoming Quotes";
  } else if (includesPath("outgoing-quotes")) {
    return "Outgoing Quotes";
  } else if (includesPath("companies")) {
    return "Companies";
  } else if (includesPath("mistake-shipments")) {
    return "Mistake Shipments";
  } else if (includesPath("purchase-orders")) {
    return "Purchase Orders";
  } else if (includesPath("rejected-cores")) {
    return "Rejected Cores";
  } else if (includesPath("managed-repair-orders")) {
    return "Managed Repair Orders";
  } else if (includesPath("repair-orders")) {
    return "Repair Orders";
  } else if (includesPath("customer-rmas")) {
    return "Customer RMAs";
  } else if (includesPath("vendor-rmas")) {
    return "Vendor RMAs";
  } else if (includesPath("receiving")) {
    return "Received Orders";
  } else if (includesPath("shipping")) {
    return "Shipped Orders";
  } else if (includesPath("inventories")) {
    return "Inventories";
  } else if (includesPath("sales-orders")) {
    return "Sales Orders";
  } else if (includesPath("users")) {
    return "Users";
  }

  return "Dashboard";
};

var Layout = function (_React$Component) {
  _inherits(Layout, _React$Component);

  function Layout() {
    _classCallCheck(this, Layout);

    return _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).apply(this, arguments));
  }

  _createClass(Layout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.subscribeToUpgradeNotifications();
      this.initializeRollbarForUser();
      if (this.props.currentUser && !this.props.currentUser.get(__WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["e" /* EMAIL_VERIFIED */])) {
        document.body.classList.add("email-warning");
      }

      if (["staging", "development"].includes("production")) {
        document.body.classList.add("development");
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.classList.remove("development");
      document.body.classList.remove("email-warning");
    }
  }, {
    key: "initializeRollbarForUser",
    value: function initializeRollbarForUser() {
      var currentUser = this.props.currentUser;


      if (true) {
        try {
          // eslint-disable-next-line
          Rollbar.configure({
            payload: {
              person: {
                id: currentUser.get(__WEBPACK_IMPORTED_MODULE_39__constants__["b" /* ID */]),
                username: currentUser.get(__WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["f" /* FULL_NAME */]),
                email: currentUser.get(__WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["g" /* EMAIL */])
              }
            }
          });
        } catch (ex) {
          // eslint-disable-next-line
          console.log("Unable to initialize Rollbar for user");
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          currentUser = _props.currentUser,
          location = _props.location;

      var isAdmin = currentUser.get(__WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["h" /* ROLE */]) === __WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["i" /* ADMIN */];
      var currentUserIdMatches = function currentUserIdMatches(route) {
        return route.match.params.id === currentUser.get(__WEBPACK_IMPORTED_MODULE_39__constants__["c" /* UUID */]);
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "layout" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_50__Nav__["a" /* default */], {
          header: navName(location.pathname),
          currentUser: this.props.currentUser
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "container-fluid" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_51__Sidebar__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "main" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_37__modules_shared_components__["a" /* ErrorBoundary */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/", component: __WEBPACK_IMPORTED_MODULE_49__Home__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/accounting-logs", component: __WEBPACK_IMPORTED_MODULE_49__Home__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/company-ranking-stats", component: __WEBPACK_IMPORTED_MODULE_49__Home__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/remaining-inventory", component: __WEBPACK_IMPORTED_MODULE_49__Home__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/ranking-stats", component: __WEBPACK_IMPORTED_MODULE_49__Home__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/api-keys", component: __WEBPACK_IMPORTED_MODULE_49__Home__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/consignments-report", component: __WEBPACK_IMPORTED_MODULE_49__Home__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/integrations", component: __WEBPACK_IMPORTED_MODULE_49__Home__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/reports", component: __WEBPACK_IMPORTED_MODULE_49__Home__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: "/consignments/:id", component: __WEBPACK_IMPORTED_MODULE_13__modules_Consignments_Detail_Detail__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                exact: true,
                path: "/consignments",
                component: __WEBPACK_IMPORTED_MODULE_47__modules_Consignments_Search_Consignments__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                exact: true,
                path: "/resident-expert-parts",
                component: __WEBPACK_IMPORTED_MODULE_42__modules_MyShoppingList_ResidentExpertSearch_ResidentExpertSearch__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                path: "/dashboard/receiving",
                component: __WEBPACK_IMPORTED_MODULE_26__modules_Receiving_Dashboard__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: "/dashboard/shipping", component: __WEBPACK_IMPORTED_MODULE_31__modules_Shipping_components_Dashboard__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_55__modules_shared_components_Authorized_Forbidden__["a" /* default */],
                { roles: [__WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["j" /* WAREHOUSE */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: "/monthly-sales", component: __WEBPACK_IMPORTED_MODULE_54__modules_SalesDashboard_Components_Table__["a" /* Table */] }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                  path: "/monthly-purchases",
                  component: __WEBPACK_IMPORTED_MODULE_53__modules_PurchasesDashboard_Components_Table__["a" /* default */]
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_37__modules_shared_components__["b" /* Authorized */],
                { roles: [__WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["k" /* SALES */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: "/purchases-report", component: __WEBPACK_IMPORTED_MODULE_40__modules_PurchasesReport_Components_Search_Search__["a" /* default */] })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_37__modules_shared_components__["b" /* Authorized */],
                { roles: [__WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["k" /* SALES */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: "/sales-report", component: __WEBPACK_IMPORTED_MODULE_48__modules_SalesDashboard_UserStats_SalesReport__["a" /* default */] })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_37__modules_shared_components__["b" /* Authorized */],
                {
                  roles: [__WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["l" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["m" /* ACCOUNTING */]],
                  subroles: [__WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["n" /* QUALITY_CONTROL_MANAGER */], __WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["o" /* QUALITY_CONTROL_ADMIN */]]
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                  path: "/monthly-depreciations",
                  component: __WEBPACK_IMPORTED_MODULE_52__modules_DepreciationsDashboard_Components_Table__["a" /* Table */]
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_37__modules_shared_components__["b" /* Authorized */],
                {
                  roles: [__WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["j" /* WAREHOUSE */], __WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["l" /* REPAIR */]],
                  permissions: [__WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["q" /* RECEIVING */]]
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                  path: "/dashboard/virtual-receiving",
                  render: function render() {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__modules_Receiving_Dashboard__["a" /* default */], { virtual: true });
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/incoming-quotes", component: __WEBPACK_IMPORTED_MODULE_20__modules_IncomingQuotes_Search_IncomingQuotes__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                path: "/incoming-quotes/:id",
                component: __WEBPACK_IMPORTED_MODULE_21__modules_IncomingQuotes_Detail_IncomingQuoteDetail__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_37__modules_shared_components__["b" /* Authorized */],
                {
                  roles: [__WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["l" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["j" /* WAREHOUSE */]]
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_55__modules_shared_components_Authorized_Forbidden__["a" /* default */],
                  { subroles: [__WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["r" /* WAREHOUSE_BASIC */]] },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                    exact: true,
                    path: "/inventories",
                    component: __WEBPACK_IMPORTED_MODULE_22__modules_inventories_components__["a" /* Search */]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                path: "/inventories/:id/:all?",
                component: __WEBPACK_IMPORTED_MODULE_22__modules_inventories_components__["b" /* Detail */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/outgoing-quotes", component: __WEBPACK_IMPORTED_MODULE_24__modules_OutgoingQuotes_Search_OutgoingQuotes__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                path: "/outgoing-quotes/:id",
                component: __WEBPACK_IMPORTED_MODULE_25__modules_OutgoingQuotes_Detail_OutgoingQuoteDetail__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/purchase-orders", component: __WEBPACK_IMPORTED_MODULE_14__modules_PurchaseOrders_components_Search_Search__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                path: "/purchase-orders/:id",
                component: __WEBPACK_IMPORTED_MODULE_15__modules_PurchaseOrders_components_Detail_Detail__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/companies", component: __WEBPACK_IMPORTED_MODULE_5__modules_companies_components__["a" /* Search */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: "/companies/:id", component: __WEBPACK_IMPORTED_MODULE_5__modules_companies_components__["b" /* Detail */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                exact: true,
                path: "/shipping",
                component: __WEBPACK_IMPORTED_MODULE_35__modules_OutgoingShipments_components__["a" /* Search */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: "/shipping/:id", component: __WEBPACK_IMPORTED_MODULE_35__modules_OutgoingShipments_components__["b" /* Detail */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/lots", component: __WEBPACK_IMPORTED_MODULE_41__modules_Lots_Search_Lots__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/lots/:id", component: __WEBPACK_IMPORTED_MODULE_44__modules_Lots_Detail_Detail__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/parts", component: __WEBPACK_IMPORTED_MODULE_6__modules_parts_components__["a" /* Search */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/parts/:id", component: __WEBPACK_IMPORTED_MODULE_6__modules_parts_components__["b" /* Detail */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                exact: true,
                path: "/managed-repair-orders",
                component: __WEBPACK_IMPORTED_MODULE_43__modules_ManagedRepairOrders_Search_ManagedRepairOrderSearch__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                exact: true,
                path: "/repair-orders",
                component: __WEBPACK_IMPORTED_MODULE_18__modules_RepairOrders_components_Search_RepairOrderSearch__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                exact: true,
                path: "/reports/commissions",
                component: __WEBPACK_IMPORTED_MODULE_11__modules_Commissions_components_Search_Search__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/reports/high-scores", component: __WEBPACK_IMPORTED_MODULE_57__modules_HighScores_components_Report__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/vendor-rmas", component: __WEBPACK_IMPORTED_MODULE_45__modules_VendorRmas_components__["a" /* Search */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                exact: true,
                path: "/my-shopping-list",
                component: __WEBPACK_IMPORTED_MODULE_32__modules_MyShoppingList_Search_Search__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                exact: true,
                path: "/customer-rmas",
                component: __WEBPACK_IMPORTED_MODULE_33__modules_CustomerRmas_components__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                exact: true,
                path: "/mistake-shipments",
                component: __WEBPACK_IMPORTED_MODULE_56__modules_MistakeShipments_components_Search_MistakeShipmentSearch__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                path: "/mistake-shipments/:id",
                component: __WEBPACK_IMPORTED_MODULE_12__modules_MistakeShipments_components_Detail_Detail__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                exact: true,
                path: "/rejected-cores",
                component: __WEBPACK_IMPORTED_MODULE_16__modules_RejectedCores_components_Search_RejectedCoreSearch__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                path: "/rejected-cores/:id",
                component: __WEBPACK_IMPORTED_MODULE_17__modules_RejectedCores_components_Detail_Detail__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: "/rmas/:id", component: __WEBPACK_IMPORTED_MODULE_34__modules_RMAsAndWarranties_components__["a" /* Detail */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/sales-orders", component: __WEBPACK_IMPORTED_MODULE_36__modules_SalesOrders_components__["a" /* Search */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router__["Switch"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                  exact: true,
                  path: "/sales-orders/reserved",
                  component: __WEBPACK_IMPORTED_MODULE_30__modules_SalesOrders_ReserveForSale_ReservedForSaleList__["a" /* default */]
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: "/sales-orders/:id", component: __WEBPACK_IMPORTED_MODULE_36__modules_SalesOrders_components__["b" /* Detail */] })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router__["Switch"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                  exact: true,
                  path: "/repair-orders/reserved",
                  component: __WEBPACK_IMPORTED_MODULE_29__modules_RepairOrders_components_ReserveForRepair__["a" /* default */]
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                  path: "/repair-orders/:id",
                  component: __WEBPACK_IMPORTED_MODULE_19__modules_RepairOrders_components_Detail_Detail__["a" /* default */]
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                exact: true,
                path: "/managed-repair-orders/:id",
                component: __WEBPACK_IMPORTED_MODULE_23__modules_ManagedRepairOrders_Detail_Detail__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/receiving", component: __WEBPACK_IMPORTED_MODULE_28__modules_Receiving_Search_ReceivingSearch__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { exact: true, path: "/receiving/:id", component: __WEBPACK_IMPORTED_MODULE_27__modules_Receiving_Detail__["a" /* default */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: "/parts/:id/inventories", component: __WEBPACK_IMPORTED_MODULE_6__modules_parts_components__["c" /* Inventories */] }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                path: "/parts/:id/incoming-quote-line-items",
                component: __WEBPACK_IMPORTED_MODULE_6__modules_parts_components__["d" /* IncomingQuoteLineItems */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                path: "/parts/:id/outgoing-quote-line-items",
                component: __WEBPACK_IMPORTED_MODULE_6__modules_parts_components__["e" /* OutgoingQuoteLineItems */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                path: "/parts/:id/purchase-order-line-items",
                component: __WEBPACK_IMPORTED_MODULE_6__modules_parts_components__["f" /* PurchaseOrderLineItems */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                path: "/parts/:id/repair-order-line-items",
                component: __WEBPACK_IMPORTED_MODULE_6__modules_parts_components__["g" /* RepairOrderLineItems */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                path: "/parts/:id/lot-line-items",
                component: __WEBPACK_IMPORTED_MODULE_46__modules_parts_components_LotLineItems_LotLineItems__["a" /* default */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                path: "/parts/:id/sales-order-line-items",
                component: __WEBPACK_IMPORTED_MODULE_6__modules_parts_components__["h" /* SalesOrderLineItems */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                path: "/parts/:id/managed-repair-order-line-items",
                component: __WEBPACK_IMPORTED_MODULE_6__modules_parts_components__["i" /* ManagedRepairOrderLineItems */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                path: "/parts/:id/repair-quote-line-items",
                component: __WEBPACK_IMPORTED_MODULE_6__modules_parts_components__["j" /* RepairQuoteLineItems */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                exact: true,
                path: "/users",
                render: function render() {
                  return isAdmin ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_users_components__["a" /* Search */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Redirect"], { to: "/" });
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                path: "/users/:id",
                render: function render(route) {
                  return currentUserIdMatches(route) || isAdmin ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_users_components__["b" /* Detail */], route) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Redirect"], { to: "/" });
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_55__modules_shared_components_Authorized_Forbidden__["a" /* default */],
                { subroles: [__WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["r" /* WAREHOUSE_BASIC */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                  exact: true,
                  path: "/approved-vendors",
                  component: __WEBPACK_IMPORTED_MODULE_9__modules_ApprovedVendors_Search_Search__["a" /* default */]
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
                  exact: true,
                  path: "/approved-repair-stations",
                  component: __WEBPACK_IMPORTED_MODULE_10__modules_ApprovedRepairStations_Search_Search__["a" /* default */]
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Layout;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Layout.propTypes = _extends({
  subscribeToUpgradeNotifications: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_38__modules_session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return { currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["a" /* USER */]) };
}, function (dispatch) {
  return {
    subscribeToUpgradeNotifications: function subscribeToUpgradeNotifications() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__modules_Upgrade_actions__["b" /* subscribe */])());
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(Layout)));

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Item__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(620);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var BookmarkedParts = function (_React$Component) {
  _inherits(BookmarkedParts, _React$Component);

  function BookmarkedParts() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BookmarkedParts);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BookmarkedParts.__proto__ || Object.getPrototypeOf(BookmarkedParts)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function (item, i) {
      var _this$props = _this.props,
          pushHistory = _this$props.pushHistory,
          removeItem = _this$props.removeItem;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Item__["a" /* default */], {
        item: item,
        key: "bookmark-item-" + i,
        destroy: removeItem,
        pushHistory: pushHistory
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BookmarkedParts, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          bookmarks = _props.bookmarks,
          visible = _props.visible,
          toggle = _props.toggle,
          contentRef = _props.contentRef;


      if (bookmarks.length === 0) return null;

      var totalCount = bookmarks.length;

      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("navbar-dropdown-icon bookmarks pointer", {
        open: visible
      });

      var sortedBookmarks = bookmarks.sort(function (a, b) {
        return new Date(b.updated_at) - new Date(a.updated_at);
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        { className: classes, ref: contentRef, id: "bookmarks" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "a",
          {
            className: "dropdown-toggle",
            role: "button",
            onClick: toggle,
            "aria-expanded": "false"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-lg fa-bookmark" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "hidden-md hidden-lg" },
            "\xA0Bookmarks"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "badge" },
            totalCount
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ul",
          { className: "dropdown-menu", role: "menu" },
          sortedBookmarks.map(this.renderItem)
        )
      );
    }
  }]);

  return BookmarkedParts;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  var bookmarks = state.session.get(__WEBPACK_IMPORTED_MODULE_5__modules_users_constants__["d" /* BOOKMARKS */]).toJS();
  return {
    bookmarks: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isArray"])(bookmarks) ? bookmarks : []
  };
}, function (dispatch) {
  return {
    removeItem: function removeItem(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__actions__["b" /* destroy */])(id));
    },
    pushHistory: function pushHistory(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["push"])("/parts/" + id));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__modules_shared_decorators__["v" /* dismissibleChild */])(BookmarkedParts)));

BookmarkedParts.propTypes = {
  bookmarks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
  contentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  removeItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_shared_components_PartNumber__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__ = __webpack_require__(21);
/* harmony export (immutable) */ __webpack_exports__["a"] = Item;





function Item(_ref) {
  var destroy = _ref.destroy,
      item = _ref.item,
      pushHistory = _ref.pushHistory;
  var _item$part = item.part,
      description = _item$part.description,
      id = _item$part.id,
      uuid = _item$part.uuid;

  var handleDelete = function handleDelete(e) {
    e.stopPropagation();
    destroy(id);
  };

  var handleClick = function handleClick(e) {
    e.preventDefault();
    pushHistory(uuid);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "li",
    { className: "cart-item cursor" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "a",
      { onClick: handleClick },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "table",
        { className: "table", style: { marginBottom: 0 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tbody",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components_PartNumber__["a" /* default */], { part: item.part, statsTooltip: false }),
              " "
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              { className: "text-right" },
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__["c" /* shortDateYY */])(item.created_at)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              { className: "td-shrink" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "button",
                {
                  type: "button",
                  className: "close",
                  "aria-label": "Delete",
                  onClick: handleDelete
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close fa-sm" })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              { colSpan: 3, className: "text-center" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "em",
                { className: "text-muted" },
                description
              )
            )
          )
        )
      )
    )
  );
}

Item.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
      description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
      part_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    })
  }),
  destroy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_autocomplete__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var debounceTimeout = 400;

var AutoComplete = function (_Component) {
  _inherits(AutoComplete, _Component);

  function AutoComplete(props) {
    _classCallCheck(this, AutoComplete);

    var _this = _possibleConstructorReturn(this, (AutoComplete.__proto__ || Object.getPrototypeOf(AutoComplete)).call(this));

    _this.onClick = function (e) {
      if (e.target === e.currentTarget) {
        _this.updateResults("");
      }
    };

    _this.onKeyUp = function (e) {
      var _this$state = _this.state,
          value = _this$state.value,
          results = _this$state.results;

      var isEnterKey = e.keyCode === 13;

      _this.setState({ enter: isEnterKey });

      if (!isEnterKey) {
        return;
      }

      if (results.length === 1 && _this.waitingFor === value) {
        _this.select(value, results[0]);
        return;
      }

      var exactMatch = results.find(function (result) {
        return result.part_number === value;
      });

      if (exactMatch) {
        _this.select(value, exactMatch);
      }
    };

    _this.updateResults = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (value) {
      _this.setState({ results: [], open: false });
      // Guard clause: handle case when value is empty or null
      if (!value) {
        _this.waitingFor = "";
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].session.parts().then(function (_ref) {
          var data = _ref.data;

          if (value === _this.waitingFor) {
            _this.setState({ results: data.results, open: true, value: "" });
          }
        });
        return;
      }

      _this.waitingFor = value;

      _this.props.search(value).then(function (results) {
        // Guard clause: ensure that the search result corresponds to the current value
        if (value !== _this.waitingFor) {
          return;
        }
        // Check if enter was pressed
        if (_this.state.enter) {
          // If there is a single result, select it
          if (results.length === 1) {
            _this.select(value, results[0]);
            return;
          }
          // Check for an exact match
          var exactMatch = results.find(function (result) {
            return result.part_number === value;
          });
          if (exactMatch) {
            _this.select(value, exactMatch);
            return;
          }
        }
        // Default: update results
        _this.setState({ results: results, open: true });
      });
    }, debounceTimeout);

    _this.clearIfValueNotSelected = function () {
      if (!_this.props.hasId && !_this.props.allowUserInput) {
        _this.setState({
          value: ""
        });
      }
      if (_this.props.allowUserInput && !_this.state.selected) {
        _this.props.onSelect(_this.state.value);
      }
    };

    _this.select = function (value, result) {
      var onSelect = _this.props.onSelect;


      _this.setState({
        selected: result,
        value: value || "",
        results: [],
        open: false
      });

      onSelect(result);
    };

    _this.refresh = function (e, value) {
      var onSelect = _this.props.onSelect;


      _this.setState({ value: value || "", selected: null });
      onSelect(null, value);
      _this.updateResults(value);
    };

    _this.renderMenu = function (items) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", { className: "dropdown", children: items });
    };

    _this.renderItem = function (item, isHighlighted) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        { key: item.id, className: isHighlighted ? "selected" : "" },
        _this.props.format(item)
      );
    };

    _this.state = {
      value: props.value || "",
      results: [],
      selected: null,
      open: false,
      forceClear: Number(props.forceClear)
    };
    return _this;
  }

  _createClass(AutoComplete, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({ value: nextProps.value || "" });
      }

      if (nextProps.watch !== this.props.watch) {
        this.setState({ results: [], value: "" });
      }

      if (nextProps.forceClear !== undefined && Number(nextProps.forceClear) !== Number(this.state.forceClear)) {
        this.setState({ value: "", forceClear: Number(nextProps.forceClear) });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          autoFocus = _props.autoFocus,
          renderItem = _props.renderItem,
          placeholder = _props.placeholder,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled,
          _props$className = _props.className,
          className = _props$className === undefined ? "autocomplete" : _props$className,
          _props$selectOnBlur = _props.selectOnBlur,
          selectOnBlur = _props$selectOnBlur === undefined ? true : _props$selectOnBlur;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_autocomplete___default.a, {
        value: this.state.value,
        items: this.state.results,
        getItemValue: this.props.format,
        onSelect: this.select,
        onChange: this.refresh,
        renderMenu: this.renderMenu,
        renderItem: renderItem || this.renderItem,
        wrapperStyle: {},
        wrapperProps: { className: className },
        autoHighlight: true,
        selectOnBlur: selectOnBlur,
        inputProps: {
          autoFocus: autoFocus,
          className: "form-control",
          placeholder: placeholder,
          onBlur: this.clearIfValueNotSelected,
          onClick: this.onClick,
          onKeyUp: this.onKeyUp,
          selectOnBlur: selectOnBlur,
          disabled: disabled
        },
        renderInput: function renderInput(inputProps) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({}, inputProps, { autoComplete: "new-password" }));
        }
      });
    }
  }]);

  return AutoComplete;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AutoComplete.propTypes = {
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  watch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hasId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectOnBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  allowUserInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  forceClear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
AutoComplete.defaultProps = {
  onSelect: function onSelect() {},
  hasId: true
};
/* harmony default export */ __webpack_exports__["a"] = (AutoComplete);

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AutoComplete__ = __webpack_require__(1204);








function GlobalSearch(_ref) {
  var search = _ref.search,
      navigate = _ref.navigate;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "navbar-right" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "navbar-form",
        role: "search",
        style: { marginBottom: 0, paddingBottom: 0 }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "input-group" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AutoComplete__["a" /* default */], {
          key: "global-part-search",
          hasId: false,
          search: search,
          onSelect: navigate,
          format: function format() {
            return "";
          } // This will ensure input value is cleared out when item is selected
          , selectOnBlur: false,
          renderItem: function renderItem(item, isHighlighted) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "li",
              { key: item.id, className: isHighlighted ? "selected" : "" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "strong",
                  null,
                  item.part_number,
                  " - ",
                  item.description
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "text-muted" },
                item.alternate_part_numbers && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    "ALTS:"
                  ),
                  " ",
                  item.alternate_part_numbers
                )
              )
            );
          },
          placeholder: "Parts Details Search",
          className: "global-autocomplete"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group-btn" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            { className: "btn btn-default", type: "button" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__modules_shared_components__["k" /* Icon */], { name: "search", fixed: true })
          )
        )
      )
    )
  );
}

GlobalSearch.propTypes = {
  search: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  navigate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    search: function search(filter) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__modules_parts_actions__["s" /* globalPartsSearch */])(filter));
    },
    navigate: function navigate(part) {
      if (part) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"])("/parts/" + part.uuid));
      }
    }
  };
})(GlobalSearch));

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GlobalSearch__ = __webpack_require__(1205);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__GlobalSearch__["a"]; });



/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = Hamburger;



function Hamburger(_ref) {
  var onClick = _ref.onClick;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    { onClick: onClick, type: "button", className: "navbar-toggle" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "sr-only" },
      "Toggle Navigation"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "icon-bar" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "icon-bar" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "icon-bar" })
  );
}

Hamburger.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_users_constants__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = Menu;




function Menu() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "ul",
    { className: "nav navbar-nav visible-xs" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__modules_shared_components__["T" /* Forbidden */],
      { roles: [__WEBPACK_IMPORTED_MODULE_2__modules_users_constants__["j" /* WAREHOUSE */]] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__modules_shared_components__["_8" /* NavLink */], { path: "/parts", icon: "fa-cogs", title: "Parts", listId: "parts" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__modules_shared_components__["b" /* Authorized */],
      {
        roles: __WEBPACK_IMPORTED_MODULE_2__modules_users_constants__["_30" /* ROLES_WITHOUT_ADMIN_WH */],
        subroles: [__WEBPACK_IMPORTED_MODULE_2__modules_users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__modules_shared_components__["_8" /* NavLink */], {
        path: "/incoming-quotes",
        icon: "fa-quote-left",
        title: "Incoming Quotes",
        listId: "incomingQuotes"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__modules_shared_components__["_8" /* NavLink */], {
        path: "/outgoing-quotes",
        icon: "fa-quote-right",
        title: "Outgoing Quotes",
        listId: "outgoingQuotes"
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__modules_shared_components__["T" /* Forbidden */],
      { roles: [__WEBPACK_IMPORTED_MODULE_2__modules_users_constants__["j" /* WAREHOUSE */]] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__modules_shared_components__["_8" /* NavLink */], {
        path: "/purchase-orders",
        icon: "fa-shopping-cart",
        title: "Purchase Orders",
        listId: "purchaseOrders"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__modules_shared_components__["_8" /* NavLink */], {
        path: "/sales-orders",
        icon: "fa-dollar",
        title: "Sales Orders",
        listId: "salesOrders/search"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__modules_shared_components__["_8" /* NavLink */], {
        path: "/repair-orders",
        icon: "fa-wrench",
        title: "Repair Orders",
        listId: "repairOrders"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__modules_shared_components__["_8" /* NavLink */], {
        path: "/customer-rmas",
        icon: "fa-cog",
        title: "Customer RMAs",
        listId: "customerRmas"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__modules_shared_components__["_8" /* NavLink */], {
        path: "/vendor-rmas",
        icon: "fa-shield",
        title: "Vendor RMAs",
        listId: "vendorRmas"
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__modules_shared_components__["_8" /* NavLink */], {
      path: "/receiving",
      icon: "fa-truck",
      title: "Receiving Records",
      listId: "receivingRecords"
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__modules_shared_components__["_8" /* NavLink */], {
      path: "/shipping",
      icon: "fa-external-link",
      title: "Shipped Orders",
      listId: "shipments"
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__modules_shared_components__["T" /* Forbidden */],
      { roles: [__WEBPACK_IMPORTED_MODULE_2__modules_users_constants__["j" /* WAREHOUSE */]] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__modules_shared_components__["_8" /* NavLink */], {
        path: "/companies",
        icon: "fa-building",
        title: "Companies",
        listId: "companies"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__modules_shared_components__["_8" /* NavLink */], { path: "/users", icon: "fa-users", title: "Users", listId: "users" })
    )
  );
}

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BookmarkedParts_BookmarkedParts__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_Admin_sessionChannel__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SessionInfo__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Hamburger__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Menu__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__GlobalSearch__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Notifications__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RepairOrdersCart_Cart__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SaleOrdersCart_Cart__ = __webpack_require__(1218);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var Nav = function (_Component) {
  _inherits(Nav, _Component);

  function Nav() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Nav);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Nav.__proto__ || Object.getPrototypeOf(Nav)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Nav, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.subscribeToSession();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var currentUser = this.props.currentUser;
      var open = this.state.open;

      var classes = __WEBPACK_IMPORTED_MODULE_4_classnames___default()("collapse navbar-collapse", {
        in: open
      });

      var navClasses = __WEBPACK_IMPORTED_MODULE_4_classnames___default()("navbar navbar-default navbar-fixed-top", {
        development: ["staging", "development"].includes("production")
      });

      var toggle = function toggle() {
        return _this2.setState({ open: !open });
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "nav",
        { className: navClasses },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "container-fluid" },
          !this.props.currentUser.get(__WEBPACK_IMPORTED_MODULE_8__modules_users_constants__["e" /* EMAIL_VERIFIED */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "send-email-warning" },
            "Sending emails is disabled. Please contact helpdesk@infotrader.com to verify your email."
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "navbar-header" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Hamburger__["a" /* default */], { onClick: toggle }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
              { to: "/", className: "navbar-brand" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: currentUser.getIn([__WEBPACK_IMPORTED_MODULE_5__constants__["_69" /* TENANT */], __WEBPACK_IMPORTED_MODULE_5__constants__["_99" /* LOGO_URL */]]), alt: "Logo" })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: classes },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h1",
              { className: "navbar-text" },
              this.props.header,
              ["staging", "development"].includes("production") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                null,
                "\xA0",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { className: "badge badge-environment-tag" },
                  "production"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Menu__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "ul",
              { className: "nav navbar-nav navbar-right" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Notifications__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BookmarkedParts_BookmarkedParts__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__RepairOrdersCart_Cart__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__SaleOrdersCart_Cart__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SessionInfo__["a" /* default */], null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__GlobalSearch__["a" /* default */], null)
          )
        )
      );
    }
  }]);

  return Nav;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    subscribeToSession: function subscribeToSession() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__modules_Admin_sessionChannel__["a" /* subscribe */])());
    }
  };
})(Nav));

Nav.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  header: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_Notifications_components_Search_Search__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_shared_components__ = __webpack_require__(2);






var FilterDropdown = function FilterDropdown(_ref) {
  var setFilters = _ref.setFilters,
      title = _ref.title;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__modules_shared_components__["v" /* FilterSelect */], { filters: __WEBPACK_IMPORTED_MODULE_2__modules_Notifications_components_Search_Search__["b" /* filters */], setFilters: setFilters, title: title });
};

FilterDropdown.propTypes = {
  setFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (FilterDropdown);

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_Notifications_notificationTypes__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(59);







function Notification(_ref) {
  var notification = _ref.notification,
      onDelete = _ref.onDelete,
      markRead = _ref.markRead,
      history = _ref.history;

  try {
    var id = notification.id,
        created_at = notification.created_at,
        read = notification.read;
    var _NOTIFICATION_TYPES$n = __WEBPACK_IMPORTED_MODULE_4__modules_Notifications_notificationTypes__["a" /* default */][notification.notifier_type][notification.notification_type],
        icon = _NOTIFICATION_TYPES$n.icon,
        iconUrl = _NOTIFICATION_TYPES$n.iconUrl,
        url = _NOTIFICATION_TYPES$n.url,
        message = _NOTIFICATION_TYPES$n.message;

    var handleDeleteClick = function handleDeleteClick(ev) {
      ev.preventDefault();
      onDelete(id);
    };

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()({ "text-bold": !read });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "li",
      {
        style: {
          cursor: "pointer",
          backgroundColor: read ? "rgba(255, 255, 255, 0.02)" : "rgba(255, 255, 255, 0.1)"
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        {
          onClick: function onClick(ev) {
            ev.preventDefault();
            markRead(notification.id);
            history.push(url(notification));
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            type: "button",
            className: "close",
            "aria-label": "Delete",
            onClick: handleDeleteClick
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "notification-close" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: classes },
          message(notification)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
        iconUrl ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: iconUrl, height: "17px", alt: notification.notifier_type }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw text-muted " + icon }),
        "\xA0",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "em",
          { className: "small text-muted" },
          __WEBPACK_IMPORTED_MODULE_3_moment___default()(created_at).calendar()
        )
      )
    );
  } catch (error) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "li",
      { style: { cursor: "pointer" } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { style: { color: "red" } },
          "Error loading notification type",
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            notification.notification_type
          ),
          ": ",
          error.message
        )
      )
    );
  }
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_router__["withRouter"])(Notification));

Notification.propTypes = {
  notification: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    created_at: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  }).isRequired,
  onDelete: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_Notifications_components_Search_Search__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Notification__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FilterDropdown__ = __webpack_require__(1210);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var getTrueKey = function getTrueKey(obj) {
  return Object.keys(obj).find(function (key) {
    return obj[key];
  });
};

var getIcon = function getIcon(key) {
  if (!key) return "Filters";
  var filter = __WEBPACK_IMPORTED_MODULE_6__modules_Notifications_components_Search_Search__["b" /* filters */].find(function (obj) {
    return obj.key === key;
  });

  return filter && filter.label || "Filters";
};

var Notifications = function (_Component) {
  _inherits(Notifications, _Component);

  function Notifications() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Notifications);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Notifications.__proto__ || Object.getPrototypeOf(Notifications)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      filters: {},
      expanded: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Notifications, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.fetchNotifications();
      this.props.subscribeToNotification();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.stale && !this.props.stale) {
        nextProps.fetchNotifications();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          notifications = _props.notifications,
          onDelete = _props.onDelete,
          markRead = _props.markRead,
          visible = _props.visible,
          toggle = _props.toggle,
          contentRef = _props.contentRef,
          fetchNotifications = _props.fetchNotifications,
          unreadCount = _props.unreadCount;
      var expanded = this.state.expanded;


      var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()("navbar-notifications", { open: visible });

      var expandClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()("navbar-notifications-list", { expanded: expanded });
      var badgeClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()("badge", {
        danger: unreadCount && unreadCount > 0
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        { className: classes, ref: contentRef },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "a",
          {
            id: "notifications",
            className: "dropdown-toggle",
            "data-toggle": "dropdown",
            role: "button",
            onClick: toggle
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-lg fa-bell" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "hidden-md hidden-lg" },
            " Notifications"
          ),
          "\xA0",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: badgeClasses },
            unreadCount
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ul",
          { className: "dropdown-menu notification-panel", role: "menu" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            { className: "text-center" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "row row-col-gutters-half" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "col-xs-12 navbar-notifications-filters" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FilterDropdown__["a" /* default */], {
                  title: getIcon(getTrueKey(this.state.filters)),
                  setFilters: function setFilters(params) {
                    _this2.setState({ filters: params });
                    fetchNotifications(params);
                  }
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            { className: expandClasses },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "ul",
              { className: "dropdown-menu-nested" },
              notifications.map(function (n) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Notification__["a" /* default */], {
                  notification: n,
                  onDelete: onDelete,
                  markRead: markRead
                });
              })
            )
          ),
          notifications.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "a",
              null,
              "You have zero notifications at this time."
            )
          ) || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            {
              onClick: function onClick() {
                return _this2.setState({ expanded: !expanded });
              },
              className: "text-center pointer",
              style: { borderTop: "1px solid rgba(0, 0, 0, 0.1)" }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
              className: "fa fa-caret-" + (expanded ? "up" : "down") + " fa-lg"
            })
          )
        )
      );
    }
  }]);

  return Notifications;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Notifications.propTypes = {
  stale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  fetchNotifications: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  markRead: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  notifications: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Array).isRequired,
  onDelete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  subscribeToNotification: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  unreadCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  contentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__modules_shared_decorators__["v" /* dismissibleChild */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    notifications: state.notifications.get("notifications").toJS(),
    stale: state.notifications.get("stale"),
    unreadCount: state.notifications.get("unreadCount")
  };
}, function (dispatch) {
  return {
    fetchNotifications: function fetchNotifications(params) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* fetch */])(Object.assign(_extends({
        page: 1,
        limit: 20,
        sort: "id",
        reverse: true,
        filter: true
      }, params))));
    },
    onDelete: function onDelete(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* onDelete */])(id));
    },
    markRead: function markRead(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["d" /* markRead */])(id));
    },
    subscribeToNotification: function subscribeToNotification() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["e" /* subscribe */])());
    }
  };
})(Notifications)));

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notifications__ = __webpack_require__(1212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Notifications__["a"]; });



/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(621);
/* unused harmony export initialState */
var _resolveEach;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  notifications: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  totalCount: 0,
  stale: false
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, (_resolveEach = {}, _defineProperty(_resolveEach, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["c" /* EXPIRE */], function (state) {
  return state.set("stale", true);
}), _defineProperty(_resolveEach, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["d" /* ADD */], function (state, action) {
  return state.merge({
    notifications: state.get("notifications").splice(0, 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.notification)),
    totalCount: state.get("totalCount") + 1
  });
}), _defineProperty(_resolveEach, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["b" /* REMOVE */], function (state, action) {
  return state.merge({
    notifications: state.get("notifications").filter(function (n) {
      return n.get("id") !== action.id;
    }),
    totalCount: state.get("totalCount") - 1,
    unreadCount: state.getIn(["data", "unread_count"])
  });
}), _defineProperty(_resolveEach, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["e" /* REMOVE_ALL */], function (state, action) {
  return state.merge({
    notifications: state.get("notifications").filter(function (n) {
      return !action.ids.includes(n.get("id"));
    }),
    totalCount: state.get("totalCount") - action.ids.length
  });
}), _defineProperty(_resolveEach, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* SET_ALL */], function (state, action) {
  return state.merge({
    notifications: action.notifications,
    totalCount: action.totalCount,
    unreadCount: action.unreadCount,
    stale: false
  });
}), _resolveEach)));

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_RepairOrders_components_ConvertToRo_Create__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_shared_components_Authorized__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Item__ = __webpack_require__(1216);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var Cart = function (_React$Component) {
  _inherits(Cart, _React$Component);

  function Cart() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Cart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Cart.__proto__ || Object.getPrototypeOf(Cart)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      convertModalOpen: false,
      clearCartModalOpen: false
    }, _this.openConvertModal = function (e) {
      _this.setState({ convertModalOpen: true });
      _this.props.toggle(e);
    }, _this.closeConvertModal = function () {
      return _this.setState({ convertModalOpen: false });
    }, _this.openClearCartModal = function () {
      return _this.setState({ clearCartModalOpen: true });
    }, _this.closeClearCartModal = function () {
      return _this.setState({ clearCartModalOpen: false });
    }, _this.handleClearCart = function () {
      _this.props.removeAll();
      _this.closeClearCartModal();
    }, _this.renderItem = function (item, i) {
      var _this$props = _this.props,
          pushHistory = _this$props.pushHistory,
          removeItem = _this$props.removeItem;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Item__["a" /* default */], _extends({}, item, {
        key: "cart-item-" + i,
        destroy: removeItem,
        pushHistory: pushHistory
      }));
    }, _this.renderClearCart = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        { className: "cart-item text-center", style: { cursor: "pointer" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            className: "btn btn-danger center-block empty-cart",
            onClick: _this.openClearCartModal
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            null,
            "Empty Cart",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_shared_components__["k" /* Icon */], { name: "shopping-cart" })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__modules_shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
          {
            onConfirm: _this.handleClearCart,
            close: _this.closeClearCartModal,
            open: _this.state.clearCartModalOpen
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          " Are you sure you want to empty your cart?"
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Cart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.subscribeToRepairCart();
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          close = _props.close,
          visible = _props.visible,
          toggle = _props.toggle,
          contentRef = _props.contentRef,
          repairCartItems = _props.repairCartItems;


      if (!repairCartItems) return null;

      var totalCount = repairCartItems.length;

      var classes = __WEBPACK_IMPORTED_MODULE_4_classnames___default()("navbar-dropdown-icon ro-cart", {
        open: visible
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__modules_shared_components_Authorized__["a" /* default */],
        { roles: [__WEBPACK_IMPORTED_MODULE_10__modules_users_constants__["l" /* REPAIR */]] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          { className: classes, ref: contentRef, id: "repairs-cart" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            {
              className: "dropdown-toggle",
              role: "button",
              onClick: toggle,
              "aria-expanded": "false"
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-lg fa-shopping-basket" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "hidden-md hidden-lg" },
              "\xA0Repair Cart"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "badge" },
              totalCount
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "ul",
            { className: "dropdown-menu", role: "menu" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "li",
              { className: "text-center" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "row row-col-gutters-half" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "col-xs-6" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    { onClick: close },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
                      { to: "/repair-orders/reserved" },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "span",
                        { type: "button", className: "btn btn-default btn-block" },
                        "Reserve List"
                      )
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "col-xs-6" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    {
                      type: "button",
                      className: "btn btn-primary btn-block",
                      onClick: this.openConvertModal,
                      disabled: totalCount === 0
                    },
                    "Convert to RO"
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__modules_RepairOrders_components_ConvertToRo_Create__["a" /* default */], {
                open: this.state.convertModalOpen,
                close: this.closeConvertModal,
                lineItems: repairCartItems
              })
            ),
            repairCartItems.map(this.renderItem),
            repairCartItems.length > 0 && this.renderClearCart()
          )
        )
      );
    }
  }]);

  return Cart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Cart.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  contentRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  removeItem: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  removeAll: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  pushHistory: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  loadCart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  totalCount: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired,
  repairCartItems: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({})).isRequired,
  subscribeToRepairCart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  var repairCartItems = state.session.get(__WEBPACK_IMPORTED_MODULE_10__modules_users_constants__["c" /* REPAIR_CART_ITEMS */]).toJS();
  return {
    repairCartItems: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lodash__["isArray"])(repairCartItems) ? repairCartItems : []
  };
}, function (dispatch) {
  return {
    removeItem: function removeItem(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions__["b" /* destroy */])(id));
    },
    removeAll: function removeAll() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions__["c" /* clearCart */])());
    },
    pushHistory: function pushHistory(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"])("/inventories/" + id));
    },
    subscribeToRepairCart: function subscribeToRepairCart() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions__["d" /* subscribe */])());
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__modules_shared_decorators__["v" /* dismissibleChild */])(Cart)));

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = Item;



function Item(_ref) {
  var quantity = _ref.quantity,
      id = _ref.id,
      destroy = _ref.destroy,
      serialNumber = _ref.serial_number,
      _ref$part = _ref.part,
      partNumber = _ref$part.part_number,
      description = _ref$part.description,
      pushHistory = _ref.pushHistory,
      uuid = _ref.uuid;

  var handleDelete = function handleDelete(e) {
    e.stopPropagation();
    destroy(id);
  };

  var handleClick = function handleClick(e) {
    e.preventDefault();
    pushHistory(uuid);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "li",
    { className: "cart-item" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "a",
      { onClick: handleClick },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "table",
        { className: "table", style: { marginBottom: 0 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tbody",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              partNumber
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              { className: "text-right" },
              "QTY: ",
              quantity
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              { className: "td-shrink" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "button",
                {
                  type: "button",
                  className: "close",
                  "aria-label": "Delete",
                  onClick: handleDelete
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              { colSpan: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "em",
                { className: "text-muted " },
                serialNumber
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "em",
                { className: "text-muted" },
                description
              )
            )
          )
        )
      )
    )
  );
}

Item.propTypes = {
  serial_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    part_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }),
  destroy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  uuid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMOVE; });
/* unused harmony export SET_ALL */
var ADD = "repairOrderCart/ADD";
var REMOVE = "repairOrderCart/REMOVE";
var SET_ALL = "repairOrderCart/SET_ALL";

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_SalesOrders_components_ConvertFromCartForm_Create__ = __webpack_require__(1780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Item__ = __webpack_require__(1219);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var Cart = function (_React$Component) {
  _inherits(Cart, _React$Component);

  function Cart() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Cart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Cart.__proto__ || Object.getPrototypeOf(Cart)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      convertModalOpen: false,
      clearCartModalOpen: false
    }, _this.openConvertModal = function (e) {
      _this.setState({ convertModalOpen: true });
      _this.props.toggle(e);
    }, _this.closeConvertModal = function () {
      return _this.setState({ convertModalOpen: false });
    }, _this.openClearCartModal = function () {
      return _this.setState({ clearCartModalOpen: true });
    }, _this.closeClearCartModal = function () {
      return _this.setState({ clearCartModalOpen: false });
    }, _this.handleClearCart = function () {
      _this.props.removeAll();
      _this.closeClearCartModal();
    }, _this.renderItem = function (item, i) {
      var _this$props = _this.props,
          pushHistory = _this$props.pushHistory,
          removeItem = _this$props.removeItem;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Item__["a" /* default */], _extends({}, item, {
        key: "cart-item-" + i,
        destroy: removeItem,
        pushHistory: pushHistory
      }));
    }, _this.renderClearCart = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        { className: "cart-item text-center", style: { cursor: "pointer" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            className: "btn btn-danger center-block empty-cart",
            onClick: _this.openClearCartModal
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            null,
            "Empty Cart",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__modules_shared_components__["k" /* Icon */], { name: "shopping-cart" })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__modules_shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
          {
            onConfirm: _this.handleClearCart,
            close: _this.closeClearCartModal,
            open: _this.state.clearCartModalOpen
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          " Are you sure you want to empty your cart?"
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Cart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.subscribeToSalesCart();
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          close = _props.close,
          visible = _props.visible,
          toggle = _props.toggle,
          contentRef = _props.contentRef,
          salesCartItems = _props.salesCartItems;


      var classes = __WEBPACK_IMPORTED_MODULE_4_classnames___default()("navbar-dropdown-icon so-cart", {
        open: visible
      });

      var totalCount = salesCartItems.length;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__modules_shared_components__["b" /* Authorized */],
        {
          roles: [__WEBPACK_IMPORTED_MODULE_9__modules_users_constants__["k" /* SALES */]],
          permissions: [__WEBPACK_IMPORTED_MODULE_9__modules_users_constants__["_20" /* CAN_VIEW_UPDATE_ALL_RESERVED_FOR_SALE_LIST */]]
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          { className: classes, ref: contentRef, id: "sales-cart" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            {
              className: "dropdown-toggle",
              role: "button",
              onClick: toggle,
              "aria-expanded": "false"
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-lg fa-shopping-cart" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "hidden-md hidden-lg" },
              "\xA0Sale Cart"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "badge" },
              totalCount
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "ul",
            { className: "dropdown-menu", role: "menu" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "li",
              { className: "text-center" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "row row-col-gutters-half" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "col-xs-6" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    { onClick: close },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
                      { to: "/sales-orders/reserved" },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "span",
                        { type: "button", className: "btn btn-default btn-block" },
                        "Reserve List"
                      )
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "col-xs-6" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    {
                      type: "button",
                      className: "btn btn-primary btn-block",
                      onClick: this.openConvertModal,
                      disabled: totalCount === 0
                    },
                    "Convert to SO"
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__modules_SalesOrders_components_ConvertFromCartForm_Create__["a" /* default */], {
                open: this.state.convertModalOpen,
                close: this.closeConvertModal,
                lineItems: salesCartItems
              })
            ),
            salesCartItems.map(this.renderItem),
            salesCartItems.length > 0 && this.renderClearCart()
          )
        )
      );
    }
  }]);

  return Cart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Cart.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  contentRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  removeItem: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  removeAll: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  pushHistory: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  loadCart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  totalCount: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired,
  results: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({})).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  var salesCartItems = state.session.get(__WEBPACK_IMPORTED_MODULE_9__modules_users_constants__["b" /* SALES_CART_ITEMS */]).toJS();
  return {
    salesCartItems: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["isArray"])(salesCartItems) ? salesCartItems : []
  };
}, function (dispatch) {
  return {
    removeItem: function removeItem(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__actions__["b" /* destroy */])(id));
    },
    removeAll: function removeAll() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__actions__["c" /* clearCart */])());
    },
    pushHistory: function pushHistory(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"])("/inventories/" + id));
    },
    subscribeToSalesCart: function subscribeToSalesCart() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__actions__["d" /* subscribe */])());
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__modules_shared_decorators__["v" /* dismissibleChild */])(Cart)));

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = Item;



function Item(_ref) {
  var totalQuantity = _ref.total_quantity,
      id = _ref.id,
      destroy = _ref.destroy,
      serialNumber = _ref.serial_number,
      _ref$part = _ref.part,
      partNumber = _ref$part.part_number,
      description = _ref$part.description,
      pushHistory = _ref.pushHistory,
      uuid = _ref.uuid;

  var handleDelete = function handleDelete(e) {
    e.stopPropagation();
    destroy(id);
  };

  var handleClick = function handleClick(e) {
    e.preventDefault();
    pushHistory(uuid);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "li",
    { className: "cart-item" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "a",
      { onClick: handleClick },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "table",
        { className: "table", style: { marginBottom: 0 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tbody",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              partNumber
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              { className: "text-right" },
              "QTY: ",
              totalQuantity
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              { className: "td-shrink" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "button",
                {
                  type: "button",
                  className: "close",
                  "aria-label": "Delete",
                  onClick: handleDelete
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              { colSpan: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "em",
                { className: "text-muted" },
                serialNumber
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "em",
                { className: "text-muted" },
                description
              )
            )
          )
        )
      )
    )
  );
}

Item.propTypes = {
  serial_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  total_quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    part_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  destroy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  uuid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMOVE; });
/* unused harmony export SET_ALL */
var ADD = "saleOrdersCart/ADD";
var REMOVE = "saleOrdersCart/REMOVE";
var SET_ALL = "saleOrdersCart/SET_ALL";

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_session_components_Logout__ = __webpack_require__(2259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_users_constants__ = __webpack_require__(13);
/* unused harmony export SessionInfo */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SessionInfo = function (_Component) {
  _inherits(SessionInfo, _Component);

  function SessionInfo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SessionInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SessionInfo.__proto__ || Object.getPrototypeOf(SessionInfo)).call.apply(_ref, [this].concat(args))), _this), _this.navToProfile = function () {
      _this.setState({ open: false });
      _this.props.pushHistory("/users/" + _this.props.currentUser.get(__WEBPACK_IMPORTED_MODULE_9__constants__["c" /* UUID */]));
      _this.props.close();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SessionInfo, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState({ open: false });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.currentUser.isEmpty()) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
            { className: "btn btn-primary", to: "/login" },
            "Login"
          )
        );
      }

      var _props = this.props,
          close = _props.close,
          visible = _props.visible,
          toggle = _props.toggle,
          contentRef = _props.contentRef;

      var classes = __WEBPACK_IMPORTED_MODULE_5_classnames___default()({ open: visible });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        { className: classes, ref: contentRef },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "a",
          { onClick: toggle, className: "dropdown-toggle", id: "session-nav" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
            className: "fa fa-user",
            style: { fontSize: "1.75em", lineHeight: ".25em" },
            "aria-hidden": "true"
          }),
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "hidden-xs hidden-sm caret" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ul",
          { className: "dropdown-menu" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "a",
              { onClick: this.navToProfile, type: "button", role: "button" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-btn fa-cog" }),
              " Profile"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            { onClick: close },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
              { to: "/reports/commissions" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-btn fa-percent" }),
              " Commission Report"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_session_components_Logout__["a" /* default */], null)
          )
        )
      );
    }
  }]);

  return SessionInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SessionInfo.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_6_immutable__["Map"]).isRequired,
  pushHistory: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};
SessionInfo.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  contentRef: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  visible: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_10__modules_users_constants__["a" /* USER */])
  };
}, { pushHistory: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__modules_shared_decorators__["v" /* dismissibleChild */])(SessionInfo)));

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Nav__ = __webpack_require__(1209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Nav__["a"]; });



/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_shared_components_Authorized__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_lot_svg__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_lot_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_lot_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_lot_white_svg__ = __webpack_require__(2751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_lot_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_lot_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(36);












var UsersLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__modules_shared_decorators__["i" /* authorized */])()(function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], { path: "/users", icon: "fa-users", title: "Users", listId: "users" });
});

function Sidebar(props) {
  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__hooks__["a" /* useCurrentUser */])();
  var sidebarClasses = __WEBPACK_IMPORTED_MODULE_1_classnames___default()("sidebar sidebar-default sidebar-inverse sidebar-padding-none", {
    development: ["staging", "development"].includes("production"),
    "email-warning": currentUser && !currentUser.email_verified
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: sidebarClasses },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "ul",
      { className: "nav sidebar-nav" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], { path: "/parts", icon: "fa-cogs", title: "Parts", listId: "parts" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__modules_shared_components_Authorized__["a" /* default */],
        {
          roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_4__modules_users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_4__modules_users_constants__["j" /* WAREHOUSE */]),
          subroles: [__WEBPACK_IMPORTED_MODULE_4__modules_users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], {
          path: "/incoming-quotes",
          icon: "fa-quote-left",
          title: "Incoming Quotes",
          listId: "incomingQuotes"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], {
          path: "/outgoing-quotes",
          icon: "fa-quote-right",
          title: "Outgoing Quotes",
          listId: "outgoingQuotes"
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["T" /* Forbidden */],
        { subroles: [__WEBPACK_IMPORTED_MODULE_4__modules_users_constants__["r" /* WAREHOUSE_BASIC */]] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], {
          path: "/purchase-orders",
          icon: "fa-shopping-cart",
          title: "Purchase Orders",
          listId: "purchaseOrders"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], {
          path: "/sales-orders",
          icon: "fa-dollar",
          title: "Sales Orders",
          listId: "salesOrders/search"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], {
          path: "/repair-orders",
          icon: "fa-wrench",
          title: "Repair Orders",
          listId: "repairOrders"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], {
          path: "/managed-repair-orders",
          icon: "fa-recycle",
          title: "Managed Repair Orders",
          listId: "managedRepairOrders"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], {
          path: "/lots",
          svg: props.location.pathname.includes("/lot") ? __WEBPACK_IMPORTED_MODULE_8__assets_images_lot_white_svg___default.a : __WEBPACK_IMPORTED_MODULE_7__assets_images_lot_svg___default.a,
          hoverSvg: __WEBPACK_IMPORTED_MODULE_8__assets_images_lot_white_svg___default.a,
          icon: "fa-lots",
          title: "Lot Orders",
          listId: "lots"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], {
          path: "/consignments",
          icon: "fa-handshake-o",
          title: "Consignments / EMA",
          listId: "consignments"
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__modules_shared_components_Authorized__["a" /* default */],
        {
          roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_4__modules_users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_4__modules_users_constants__["j" /* WAREHOUSE */]),
          subroles: [__WEBPACK_IMPORTED_MODULE_4__modules_users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], {
          path: "/vendor-rmas",
          icon: "fa-shield",
          title: "Vendor RMAs",
          listId: "rmas"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], {
          path: "/customer-rmas",
          icon: "fa-cog",
          title: "Customer RMAs",
          listId: "customerRmas"
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], {
        path: "/receiving",
        icon: "fa-truck",
        title: "Received Orders",
        listId: "receivingRecords"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__modules_shared_components_Authorized__["a" /* default */],
        {
          roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_4__modules_users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_4__modules_users_constants__["j" /* WAREHOUSE */]),
          permissions: [__WEBPACK_IMPORTED_MODULE_4__modules_users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_4__modules_users_constants__["_23" /* CAN_UPDATE_COMPANIES */]],
          subroles: [__WEBPACK_IMPORTED_MODULE_4__modules_users_constants__["t" /* WAREHOUSE_EXPERT */], __WEBPACK_IMPORTED_MODULE_4__modules_users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], {
          path: "/companies",
          icon: "fa-building",
          title: "Companies",
          listId: "companies"
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], {
        path: "/shipping",
        icon: "fa-external-link",
        title: "Shipped Orders",
        listId: "shipments"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UsersLink, null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], {
        path: "/mistake-shipments",
        icon: "fa-exclamation-triangle",
        title: "Mistake Shipments",
        listId: "mistakeShipments"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_shared_components__["_8" /* NavLink */], {
        path: "/rejected-cores",
        icon: "fa-refresh",
        title: "Rejected Cores",
        listId: "rejectedCores"
      })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["c" /* withRouter */])(Sidebar));

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar__ = __webpack_require__(1223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Sidebar__["a"]; });



/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cable__ = __webpack_require__(137);
/* harmony export (immutable) */ __webpack_exports__["b"] = unsubscribe;
/* unused harmony export onDisconnect */
/* harmony export (immutable) */ __webpack_exports__["a"] = subscribe;


var channel = null;

function unsubscribe() {
  if (channel) {
    channel.unsubscribe();
    channel = null;
  }
}

function onDisconnect() {
  return unsubscribe();
}

function subscribe() {
  var connection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cable__["b" /* createChannel */])();

  if (!channel) {
    var listen = connection.listen;


    channel = listen("NotificationChannel", { onDisconnect: onDisconnect });
  }
}

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__(2965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__);



if (true) {
  __WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.config(undefined).install();
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__["configurePageParams"])({
  perPage: "limit",
  sortOrder: "reverse",
  sortReverse: true
});

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var useActiveDemeritsColor = function useActiveDemeritsColor(company) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var demerits = company.demerits;

    if (demerits === 1) {
      return "#4CAF50";
    } else if ([2, 3].includes(demerits)) {
      return "#e9f100";
    } else if (demerits > 3) {
      return "#ea1c0d";
    }

    return "inherit";
  }, [company]);
};

/* harmony default export */ __webpack_exports__["a"] = (useActiveDemeritsColor);

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony export (immutable) */ __webpack_exports__["a"] = useEventListener;


function useEventListener(eventName, handler) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;

  var savedHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    savedHandler.current = handler;
  }, [handler]);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var isSupported = element && element.addEventListener;
    if (!isSupported) return;

    var eventListener = function eventListener(event) {
      return savedHandler.current(event);
    };

    element.addEventListener(eventName, eventListener);

    // eslint-disable-next-line consistent-return
    return function () {
      return element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element] // Re-run if eventName or element changes
  );
}

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony export (immutable) */ __webpack_exports__["a"] = useScrollToOnMount;



// Scrolls to top of active Part Detail form when component is mounted.
function useScrollToOnMount() {
  var ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    if (ref.current) {
      // NOTE: I haven't found a better way to access the underlying DOM node
      // when ref.current returns a Component. ReactDOM.findDOMNode seems to
      // handle both raw elements and Components, so this should be a safe
      // solution other than having to disable eslint rule.
      // eslint-disable-next-line react/no-find-dom-node
      var domNode = __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.findDOMNode(ref.current);
      var newPositionY = domNode.getBoundingClientRect().top + window.scrollY - 70;

      window.scrollTo(0, newPositionY);
    }
    return function () {};
  }, [ref]);

  return ref;
}

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = convertByteToMB;
function convertByteToMB(bytes) {
  if (!bytes) return null;

  return (parseInt(bytes, 10) / 1000000).toFixed(2) + " MB";
}

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getValues;
/* unused harmony export get */
function getValues(map) {
  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  return keys.map(function (k) {
    return map.get(k);
  });
}

var get = function get(p, o) {
  return p.reduce(function (xs, x) {
    return xs && xs[x] ? xs[x] : null;
  }, o);
};

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var regions = [{
  name: "North America"
}, {
  name: "Central/South America"
}, {
  name: "Asia/Pacific"
}, {
  name: "Europe"
}, {
  name: "Eastern Europe"
}, {
  name: "Middle East"
}, {
  name: "Africa"
}, {
  name: "Antartica"
}].sort(function (a, b) {
  return a.name.localeCompare(b.name);
});

/* harmony default export */ __webpack_exports__["a"] = (regions);

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validator */
/* eslint-disable */

function validator(model, validations) {
  var errors = {};

  var applyError = function applyError(f, message) {
    errors[f] = (errors[f] || []).concat(message);
  };

  var validateField = function validateField(rule) {
    return function (f) {
      return rule(f, model).then(function (message) {
        if (message) {
          applyError(f, message);
        }
      });
    };
  };

  var rules = function rules(fields) {
    return {
      satisfies: function satisfies() {
        for (var _len = arguments.length, rules = Array(_len), _key = 0; _key < _len; _key++) {
          rules[_key] = arguments[_key];
        }

        return Promise.all(rules.reduce(function (all, rule) {
          return all.concat(fields.map(validateField(rule)));
        }, []));
      }
    };
  };

  var v = function v() {
    for (var _len2 = arguments.length, facts = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      facts[_key2] = arguments[_key2];
    }

    return Promise.all(facts);
  };
  v.validate = function () {
    for (var _len3 = arguments.length, fields = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      fields[_key3] = arguments[_key3];
    }

    return rules(fields);
  };
  v.validateChild = function (_ref, childValidations) {
    var field = _ref.field,
        _ref$drill = _ref.drill,
        drill = _ref$drill === undefined ? function () {
      return model[field];
    } : _ref$drill;
    return validator(drill(model, field) || {}, childValidations).then(function (childErrors) {
      if (Object.keys(childErrors).length > 0) {
        errors[field] = childErrors;
      }
    });
  };
  v.validateChildren = function (_ref2, childValidations) {
    var field = _ref2.field,
        _ref2$drill = _ref2.drill,
        drill = _ref2$drill === undefined ? function () {
      return model[field];
    } : _ref2$drill;

    var children = (drill(model, field) || []).map(function (v) {
      return validator(v, childValidations);
    });
    return Promise.all(children).then(function (childErrors) {
      if (childErrors.some(function (e) {
        return Object.keys(e).length > 0;
      })) {
        errors[field] = childErrors;
      }
    });
  };

  return validations(v).then(function () {
    return errors;
  });
}

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = required;
/* harmony export (immutable) */ __webpack_exports__["c"] = matches;
/* harmony export (immutable) */ __webpack_exports__["b"] = numeric;
function required(value) {
  if (!value) {
    return "required";
  }

  return undefined;
}

function matches(fieldName) {
  return function (val, values) {
    if (val !== values[fieldName]) {
      return "mismatch";
    }

    return undefined;
  };
}

function numeric(n) {
  if (isNaN(parseFloat(n)) || !isFinite(n)) {
    return "expected_numeric";
  }
  return undefined;
}

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_Shipping_constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return print; });







var noteFunc = function noteFunc(expiration, noteStr, large) {
  if (!noteStr) return "";

  return "^FO" + ("" + (expiration ? "20" : "60")) + "," + (large ? "160" : "50") + "^FDNotes: " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatters_text__["e" /* truncate */])(noteStr || "", large ? 80 : 15) + "^FS";
};

var label = function label(_ref) {
  var cage = _ref.cage,
      companyName = _ref.company_name,
      condition = _ref.condition,
      date = _ref.date_received,
      dom = _ref.dom,
      expiration = _ref.expiration,
      location = _ref.location,
      notes = _ref.notes,
      obtainedFrom = _ref.obtained_from,
      desc = _ref.part_description,
      partNumber = _ref.part_number,
      quantity = _ref.quantity,
      releaseTypes = _ref.release_types,
      serialNumber = _ref.serial_number,
      tagDate = _ref.tag_date,
      taggedBy = _ref.tagged_by,
      traceType = _ref.trace_type;

  var large = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__hooks_useCurrentUser__["b" /* useSettings */])(), __WEBPACK_IMPORTED_MODULE_5__constants__["_12" /* LABEL_SIZE */], "4x6") === "4x6";
  return "\n^XA\n^FWR\n^FX Top section with logo, name and address.\n^CF0,60\n^FO590," + (large ? "160" : "50") + "^FD" + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatters_text__["e" /* truncate */])(companyName, 20) || "") + "^FS\n^CF0,30\n\n^CFA,25\n^FO570," + (large ? "160" : "50") + "^FDDate Received: " + (date || "") + "^FS\n^FO540," + (large ? "160" : "50") + "^FDPart #: " + partNumber + "^FS\n^FO500," + (large ? "160" : "50") + "^FDSN: " + serialNumber + "^FS\n^FO460," + (large ? "160" : "50") + "^FDDesc: " + (desc || "") + "^FS\n^FO420," + (large ? "160" : "50") + "^FDRef #: " + (obtainedFrom || "") + "^FS\n^FO380," + (large ? "160" : "50") + "^FDCD | QTY: " + (__WEBPACK_IMPORTED_MODULE_1__modules_Shipping_constants__["k" /* CONDITIONS */][condition].abbrev || "") + " | " + (quantity || "") + "^FS\n^FO340," + (large ? "160" : "50") + "^FDTag Date: " + (tagDate || "") + "^FS\n^FO300," + (large ? "160" : "50") + "^FDTrace Type: " + (traceType && __WEBPACK_IMPORTED_MODULE_2__modules_inventories_constants__["_26" /* TRACE_TYPES */][traceType].abbrev || "") + "^FS\n^FO260," + (large ? "160" : "50") + "^FDCage: " + (cage || "") + "^FS\n^FO220," + (large ? "160" : "50") + "^FDDOM: " + (dom || "") + "^FS\n^FO180," + (large ? "160" : "50") + "^FDLocation: " + (location || "") + "^FS\n^FO140," + (large ? "160" : "50") + "^FDRelease Type: " + (releaseTypes || "") + "^FS\n^FO100," + (large ? "160" : "50") + "^FDTagged By: " + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatters_text__["e" /* truncate */])(taggedBy, large ? 80 : 15) || "") + "^FS\n" + (expiration ? "^FO60," + (large ? "160" : "50") + "^FDExpires: " + expiration + "^FS" : "") + "\n" + noteFunc(expiration, notes, large) + "\n^XZ";
};

var print = function print(textToPrint) {
  /* eslint-disable-next-line */
  BrowserPrint.getDefaultDevice("printer", function (device) {
    device.send(textToPrint, function (_success) {
      /* eslint-disable-next-line */
      console.log("Sent to printer");
    }, function (error) {
      /* eslint-disable-next-line */
      console.error("Error:" + error);
    });
  });
};

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(59);




var ICON_MAP = {
  Inventory: "fa-cog",
  SalesOrder: "fa-dollar",
  ManagedRepairOrder: "fa-recycle",
  PurchaseOrder: "fa-shopping-cart",
  RepairOrder: "fa-wrench",
  CostAdjustment: "fa-wrench",
  Lot: "fa-shopping-cart"
};

var LINK_MAP = {
  Inventory: "/inventories",
  Lot: "/lots",
  ManagedRepairOrder: "/managed-repair-orders",
  PurchaseOrder: "/purchase-orders",
  RepairOrder: "/repair-orders",
  SalesOrder: "/sales-orders"
};

function Row(_ref) {
  var history = _ref.history,
      log = _ref.log;

  var url = log.reference_record_type === "CostAdjustment" ? "/inventories/" + log.reference_record.inventory_id : LINK_MAP[log.reference_record_type] + "/" + log.reference_record.uuid;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      style: {
        backgroundColor: "rgba(255, 255, 255, 0.1)"
      },
      onClick: function onClick() {
        history.push(url);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw " + ICON_MAP[log.reference_record_type] })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "pull-left" },
        log.message
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "pull-left" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "a",
          {
            href: log.quickbooks_link,
            rel: "noopener noreferrer",
            target: "_blank"
          },
          log.quickbooks_link
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { width: "25%" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "em",
        { className: "small text-muted" },
        __WEBPACK_IMPORTED_MODULE_1_moment___default()(log.created_at).calendar({
          lastWeek: "dddd [at] h:mm a"
        })
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(Row));

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Table__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pagination__ = __webpack_require__(632);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function Search() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_5__pagination__["a" /* default */], syncWithUrl: true },
    function (searchProps) {
      var filtersSet = searchProps.paginator.toJS().filters;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h2",
            null,
            "Accounting Logs"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Table__["a" /* default */], _extends({}, searchProps, { filtersSet: filtersSet })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__["Paginator"], _extends({}, searchProps, { listId: "searchAccountinglogs" }))
      );
    }
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined)(Search));

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Row__ = __webpack_require__(1236);
/* unused harmony export Table */







function Table(_ref) {
  var results = _ref.results,
      isLoading = _ref.isLoading;

  if (isLoading || results.length > 0) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */],
      {
        loading: isLoading,
        withoutBaseline: true,
        responsive: false,
        striped: false
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Head,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Message"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Link"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Date"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Body,
        null,
        results.map(function (r) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Row__["a" /* default */], { log: r });
        })
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "p",
    null,
    "You do not have any logs at this time"
  );
}

Table.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var withListId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["d" /* translateProps */])(function () {
  return { listId: "searchAccountingLogs" };
});

/* harmony default export */ __webpack_exports__["a"] = (withListId(__WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__["decorators"].tabulate(Table)));

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__ = __webpack_require__(21);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();







function ApiKeys() {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      results = _useState2[0],
      setResults = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].tenant.find().then(function (_ref) {
      var data = _ref.data;

      setResults(data || {});

      return function cleanup() {};
    });
  }, []);

  var onClick = function onClick() {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].tenant.create().then(function (_ref2) {
      var data = _ref2.data;

      setResults(data);
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "page-header page-header-bar" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h1",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "btn-group pull-right", style: { marginLeft: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "button",
                {
                  key: "create-api-key",
                  onClick: onClick,
                  className: "btn btn-primary"
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    "Create API Key"
                  )
                )
              )
            ),
            "API KEY",
            " "
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "well" },
        "Please use the following keys using Basic Auth."
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
      null,
      results && results.un && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 3 },
        "Username: ",
        results.un,
        " "
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 2 },
        "PW: ",
        results.pw || "********",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "text-right" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["j" /* NoteTooltip */], {
            placement: "right",
            icon: "fa-info-circle",
            color: "rgba(255, 255, 255, 0.25)",
            note: "For Security purposes we do not allow the password to be displayed.  Please copy the pw and store safely once created."
          })
        )
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 3 },
        "Expires: ",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["b" /* shortDate */])(results.expires_at)
      )]
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (ApiKeys);

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StatsPanel__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SimpleDateRangePicker__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function CompanyRankings(_ref) {
  var endDate = _ref.endDate,
      startDate = _ref.startDate;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState4 = _slicedToArray(_useState3, 2),
      results = _useState4[0],
      setResults = _useState4[1];

  var performRequest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].companies.rankingStats({ endDate: endDate, startDate: startDate }).then(function (_ref2) {
      var data = _ref2.data;

      setResults(data);
      setIsLoading(false);
    });
  }, [endDate, startDate]);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    performRequest();
  }, [endDate, startDate]);

  if (isLoading) return null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StatsPanel__["a" /* default */], {
        title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])("purchased_by_us"),
        results: results.purchased_by_us
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StatsPanel__["a" /* default */], {
        title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])("sold_by_us"),
        results: results.sold_by_us
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StatsPanel__["a" /* default */], {
        title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])("repairs_sent"),
        results: results.repairs_sent
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StatsPanel__["a" /* default */], {
        title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])("sold_by_company_type"),
        results: results.sales_by_company_type
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StatsPanel__["a" /* default */], {
        title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])("sold_by_region"),
        label: "Region",
        results: results.sold_by_region
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StatsPanel__["a" /* default */], {
        title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])("sold_by_country"),
        results: results.sales_by_country
      })
    )
  );
}

var Report = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(function () {
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(12, __WEBPACK_IMPORTED_MODULE_7__constants__["_83" /* MONTHS */]).toDate()),
      _useState6 = _slicedToArray(_useState5, 2),
      startDate = _useState6[0],
      setStartDate = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_1_moment___default()().toDate()),
      _useState8 = _slicedToArray(_useState7, 2),
      endDate = _useState8[0],
      setEndDate = _useState8[1];

  var handleDateChange = function handleDateChange(start, end) {
    setStartDate(start);
    setEndDate(end);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "header-content",
            style: { display: "flex", justifyContent: "space-between" }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h1",
            null,
            "Company Rankings \xA0",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: { marginRight: "10px" } },
              startDate && "- " + __WEBPACK_IMPORTED_MODULE_1_moment___default()(startDate).format("MMMM DD, YYYY"),
              endDate && " - " + __WEBPACK_IMPORTED_MODULE_1_moment___default()(endDate).format("MMMM DD, YYYY")
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { marginLeft: 20, display: "inline-block" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SimpleDateRangePicker__["a" /* default */], { handleDateChange: handleDateChange })
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CompanyRankings, { endDate: endDate, startDate: startDate })
    )
  );
});

/* harmony default export */ __webpack_exports__["a"] = (Report);

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_daterangepicker__ = __webpack_require__(577);






function SimpleDateRangePicker(_ref) {
  var handleDateChange = _ref.handleDateChange;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_daterangepicker__["a" /* default */],
    {
      initialSettings: {
        startDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(12, __WEBPACK_IMPORTED_MODULE_3__constants__["_83" /* MONTHS */]).toDate(),
        endDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()().toDate(),
        ranges: {
          "Last 12 Months": [__WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(12, __WEBPACK_IMPORTED_MODULE_3__constants__["_83" /* MONTHS */]).toDate(), __WEBPACK_IMPORTED_MODULE_2_moment___default()().toDate()],
          "This Year": [__WEBPACK_IMPORTED_MODULE_2_moment___default()().startOf(__WEBPACK_IMPORTED_MODULE_3__constants__["_84" /* YEAR */]).toDate(), __WEBPACK_IMPORTED_MODULE_2_moment___default()().toDate()],
          "Last Year": [__WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, __WEBPACK_IMPORTED_MODULE_3__constants__["_84" /* YEAR */]).startOf(__WEBPACK_IMPORTED_MODULE_3__constants__["_84" /* YEAR */]).toDate(), __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, __WEBPACK_IMPORTED_MODULE_3__constants__["_84" /* YEAR */]).endOf(__WEBPACK_IMPORTED_MODULE_3__constants__["_84" /* YEAR */]).toDate()]
        }
      },
      onCallback: handleDateChange
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "input-group-btn" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { type: "button", className: "btn btn-success " },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-calendar" }),
        "\xA0",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Select Date"
        ),
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-caret-down" })
      )
    )
  );
}

SimpleDateRangePicker.propTypes = {
  handleDateChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SimpleDateRangePicker);

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Table__ = __webpack_require__(1243);





var StatsPanel = function StatsPanel(_ref) {
  var label = _ref.label,
      title = _ref.title,
      results = _ref.results;

  var style = {
    backgroundColor: "#928ff7",
    padding: "0 10px",
    borderRadius: "3px",
    boxShadow: "0 4px 4px rgba(0, 0, 0, 0.5)"
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
    { md: 6 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: style },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h2",
        { style: { lineHeight: "1.8", color: "hsla(0,0%,100%,0.8)" } },
        title
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Table__["a" /* default */], { results: results, label: label })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (StatsPanel);

StatsPanel.defaultProps = {
  report: "company",
  period: "all",
  title: null,
  config: { filters: function filters() {
      return {};
    } }
};

StatsPanel.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
  config: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    request: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }).isRequired
};

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var Table = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(function (_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === undefined ? "Company" : _ref$label,
      _ref$results = _ref.results,
      results = _ref$results === undefined ? [] : _ref$results,
      isLoading = _ref.isLoading,
      refresh = _ref.refresh;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components__["s" /* DataTable */],
    { loading: isLoading, loadingRows: 3, refresh: refresh },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        label
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "# Line Items"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Amount ($)"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            r.uuid ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
              { to: "/companies/" + r.uuid },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { className: "text-orange" },
                r.name
              )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "text-orange" },
              r.name
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["c" /* displayDecimal */])(r.stat, 2)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(r.amount, 2)
          )
        );
      })
    )
  );
});

Table.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_1__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pagination__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(1245);









function ConsignmentReportCard() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_6__pagination__["a" /* default */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h1",
          null,
          "Consignments Report"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

ConsignmentReportCard.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(ConsignmentReportCard));

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);









function renderRow(r) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { key: r.buyer },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["b" /* shortDate */])(r.inception_date)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.consignment_company_name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      r.consignment_reference
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_number__["a" /* percent */])(Number(r.consignor_percentage), 100)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      r.manager
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(r.total_sold)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(r.total_paid_to_consignor)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(r.profit)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      r.cancelled_consignments
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      r.total_line_items_remaining
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      r.total_qty_remaining
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_number__["a" /* percent */])(r.total_realized, r.total_purchases)
    )
  );
}

function Table(_ref) {
  var currentUser = _ref.currentUser,
      isLoading = _ref.isLoading,
      pageActions = _ref.pageActions,
      results = _ref.results;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Row */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */],
          { loading: isLoading, refresh: pageActions.expire },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Inception Date"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Consignor"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Consignment Ref #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Consignor Perc (%)"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Manager"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Total Sold"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Total Paid To Consignor"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Total Earned"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Total Canceled"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Total Lines Items Remaining"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Total Quantities Remaining"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Body,
            null,
            results.map(function (r) {
              return renderRow(r, currentUser);
            })
          )
        )
      )
    )
  );
}

Table.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["b" /* default */])(Table));

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_Check__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_Check_CheckGroup__ = __webpack_require__(345);
/* harmony export (immutable) */ __webpack_exports__["a"] = AccountSelectionModal;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

















var NON_INVENTORY = "NonInventory";
var SERVICE = "Service";

function SettingsModal(_ref) {
  var closed = _ref.closed,
      close = _ref.close,
      defaultQuickbooksAccount = _ref.defaultQuickbooksAccount,
      locationId = _ref.locationId,
      editing = _ref.editing,
      saveSetting = _ref.saveSetting,
      setDefaultQuickbooksAccount = _ref.setDefaultQuickbooksAccount,
      _ref$settings = _ref.settings,
      settings = _ref$settings === undefined ? {} : _ref$settings,
      _ref$submitting = _ref.submitting,
      submitting = _ref$submitting === undefined ? false : _ref$submitting,
      updateSetting = _ref.updateSetting;

  if (closed) {
    return null;
  }

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      prefs = _useState2[0],
      setPrefs = _useState2[1];

  var search = function search(params) {
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].locations.quickbooks.accounts.search(locationId, params).then(function (_ref2) {
      var data = _ref2.data;
      return data.results;
    });
  };

  var searchItems = function searchItems(types) {
    return function (filter) {
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].locations.quickbooks.items.search(locationId, filter, types).then(function (_ref3) {
        var data = _ref3.data;
        return data.results;
      });
    };
  };

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].locations.quickbooks.preferences.search(locationId).then(function (_ref4) {
      var data = _ref4.data;

      setPrefs(data.results);
      return function cleanup() {};
    }).catch(function (response) {
      __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__["toastr"].error("ERROR", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(response, "errors", "Quickbooks Error."));
    });
  }, [locationId]);

  var inventoryTrackingEnabled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_7__constants__["_74" /* QUICKBOOKS_INVENTORY_TRACKING */]) === __WEBPACK_IMPORTED_MODULE_7__constants__["_75" /* ENABLED */];

  var clearFields = function clearFields() {
    return [__WEBPACK_IMPORTED_MODULE_7__constants__["_76" /* REDUCE_COST_AT_SALE */], __WEBPACK_IMPORTED_MODULE_7__constants__["_77" /* REDUCE_REPAIR_COST_AT_SALE */], __WEBPACK_IMPORTED_MODULE_7__constants__["_78" /* SOLD_INVENTORY_ITEM */], __WEBPACK_IMPORTED_MODULE_7__constants__["_79" /* INVENTORY_ACCOUNT */]].map(function (f) {
      return updateSetting(f, null);
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components__["C" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-md" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Quickbooks Settings"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Settings"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_Check_CheckGroup__["a" /* default */],
            { title: "Default Quickbooks Account" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_Check__["a" /* default */], {
              label: "Default Quickbooks Account",
              onChange: function onChange(val) {
                return setDefaultQuickbooksAccount(val);
              },
              input: {
                name: "default_quickbooks_account",
                value: defaultQuickbooksAccount,
                onChange: function onChange() {}
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "Start Sync Date" },
            "Start Sync Date"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            className: "form-control",
            type: "date",
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, "sync_date"),
            onChange: function onChange(e) {
              return updateSetting("sync_date", e.target.value);
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "Select Type" },
          "Quickbooks Inventory Tracking\xA0",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["j" /* NoteTooltip */], {
            note: "Quickbooks enables automatic tracking of inventory.  Infotrader replaces quickbooks inventory tracking and can automatically enter journal entries.  However if you have inventory tracking enabled, Infotrader will rely on quickbooks inventory adjustments and will notify of differences.  Please review our quickbooks integration guide for further details.",
            icon: "fa-info-circle",
            color: "#545454"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_Check_CheckGroup__["a" /* default */],
            { title: "Use Infotrader Inventory Tracking" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_Check__["a" /* default */], {
              label: "Use Infotrader",
              onChange: function onChange(val) {
                return updateSetting(__WEBPACK_IMPORTED_MODULE_7__constants__["_74" /* QUICKBOOKS_INVENTORY_TRACKING */], val ? __WEBPACK_IMPORTED_MODULE_7__constants__["_80" /* DISABLED */] : __WEBPACK_IMPORTED_MODULE_7__constants__["_75" /* ENABLED */]);
              },
              input: {
                name: __WEBPACK_IMPORTED_MODULE_7__constants__["_74" /* QUICKBOOKS_INVENTORY_TRACKING */],
                value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_7__constants__["_74" /* QUICKBOOKS_INVENTORY_TRACKING */]) === __WEBPACK_IMPORTED_MODULE_7__constants__["_80" /* DISABLED */],
                onChange: function onChange() {
                  clearFields();
                }
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_Check_CheckGroup__["a" /* default */],
            { title: "Track Inventory In Quickbooks" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_Check__["a" /* default */], {
              label: "Track Inventory",
              onChange: function onChange(val) {
                return updateSetting(__WEBPACK_IMPORTED_MODULE_7__constants__["_74" /* QUICKBOOKS_INVENTORY_TRACKING */], val ? __WEBPACK_IMPORTED_MODULE_7__constants__["_75" /* ENABLED */] : __WEBPACK_IMPORTED_MODULE_7__constants__["_80" /* DISABLED */]);
              },
              input: {
                name: __WEBPACK_IMPORTED_MODULE_7__constants__["_74" /* QUICKBOOKS_INVENTORY_TRACKING */],
                value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_7__constants__["_74" /* QUICKBOOKS_INVENTORY_TRACKING */]) === __WEBPACK_IMPORTED_MODULE_7__constants__["_75" /* ENABLED */],
                onChange: function onChange() {
                  clearFields();
                }
              }
            })
          )
        )
      ),
      !inventoryTrackingEnabled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_Check_CheckGroup__["a" /* default */],
            { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["_76" /* REDUCE_COST_AT_SALE */]) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_Check__["a" /* default */], {
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["_76" /* REDUCE_COST_AT_SALE */]),
              onChange: function onChange(val) {
                return updateSetting(__WEBPACK_IMPORTED_MODULE_7__constants__["_76" /* REDUCE_COST_AT_SALE */], val);
              },
              input: {
                name: __WEBPACK_IMPORTED_MODULE_7__constants__["_76" /* REDUCE_COST_AT_SALE */],
                value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_7__constants__["_76" /* REDUCE_COST_AT_SALE */]),
                onChange: function onChange() {}
              }
            })
          )
        )
      ),
      inventoryTrackingEnabled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_Check_CheckGroup__["a" /* default */],
            { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["_77" /* REDUCE_REPAIR_COST_AT_SALE */]) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_Check__["a" /* default */], {
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["_77" /* REDUCE_REPAIR_COST_AT_SALE */]),
              onChange: function onChange(val) {
                return updateSetting(__WEBPACK_IMPORTED_MODULE_7__constants__["_77" /* REDUCE_REPAIR_COST_AT_SALE */], val);
              },
              input: {
                name: __WEBPACK_IMPORTED_MODULE_7__constants__["_77" /* REDUCE_REPAIR_COST_AT_SALE */],
                value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_7__constants__["_77" /* REDUCE_REPAIR_COST_AT_SALE */]),
                onChange: function onChange() {}
              }
            })
          )
        )
      ),
      prefs.length > 0 && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Sales Orders"
        )
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "Customer Ref #" },
          "Customer Ref #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "select",
          {
            className: "form-control",
            id: "applicable-type",
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_7__constants__["_81" /* QUICKBOOKS_CUSTOMER_PURCHASE_FIELD */], null),
            onChange: function onChange(ev) {
              updateSetting(__WEBPACK_IMPORTED_MODULE_7__constants__["_81" /* QUICKBOOKS_CUSTOMER_PURCHASE_FIELD */], ev.target.value);
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "option",
            { value: "" },
            "(Select one)"
          ),
          prefs.map(function (f) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "option",
              { value: f.name },
              f.string_value
            );
          })
        )
      )],
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "Inventory Account" },
          "Inventory Account"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["Q" /* AutoComplete */], {
            format: function format(result) {
              return result.name;
            },
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, "inventory_account.name", null),
            onSelect: function onSelect(val) {
              return updateSetting("inventory_account", val);
            },
            search: search,
            renderItem: function renderItem(item, isHighlighted) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                { key: item.id, className: isHighlighted ? "selected" : "" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    item.fully_qualified_name
                  )
                )
              );
            },
            placeholder: "Search Account"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "Income Account" },
          "Income Account"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["Q" /* AutoComplete */], {
            format: function format(result) {
              return result.name;
            },
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, "income_account.name", null),
            onSelect: function onSelect(val) {
              return updateSetting("income_account", val);
            },
            search: search,
            renderItem: function renderItem(item, isHighlighted) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                { key: item.id, className: isHighlighted ? "selected" : "" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    item.fully_qualified_name
                  )
                )
              );
            },
            placeholder: "Search Account"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "COGS Account" },
          "Cost of Goods Sold Account"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["Q" /* AutoComplete */], {
            format: function format(result) {
              return result.name;
            },
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, "cogs_account.name", null),
            onSelect: function onSelect(val) {
              return updateSetting("cogs_account", val);
            },
            search: search,
            renderItem: function renderItem(item, isHighlighted) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                { key: item.id, className: isHighlighted ? "selected" : "" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    item.fully_qualified_name
                  )
                )
              );
            },
            placeholder: "Search Account"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "Restocking Fee" },
          "Sold Inventory Item"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["Q" /* AutoComplete */], {
            format: function format(result) {
              return result.name;
            },
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, "sold_inventory_item.name", null),
            onSelect: function onSelect(val) {
              return updateSetting(__WEBPACK_IMPORTED_MODULE_7__constants__["_78" /* SOLD_INVENTORY_ITEM */], val);
            },
            search: searchItems(NON_INVENTORY),
            renderItem: function renderItem(item, isHighlighted) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                { key: item.id, className: isHighlighted ? "selected" : "" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    item.name
                  )
                )
              );
            },
            placeholder: "Search Accounts"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "exchange_sales_item" },
          "Exchange Sales Item"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["Q" /* AutoComplete */], {
            format: function format(result) {
              return result.name;
            },
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, "exchange_sales_item.name", null),
            onSelect: function onSelect(val) {
              return updateSetting("exchange_sales_item", val);
            },
            search: searchItems([NON_INVENTORY, SERVICE].join(",")),
            renderItem: function renderItem(item, isHighlighted) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                { key: item.id, className: isHighlighted ? "selected" : "" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    item.name
                  )
                )
              );
            },
            placeholder: "Search Accounts"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "Hazmat Fee" },
          "Core Repair Charge"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["Q" /* AutoComplete */], {
            format: function format(result) {
              return result.name;
            },
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, "core_repair_charge.name", null),
            onSelect: function onSelect(val) {
              return updateSetting("core_repair_charge", val);
            },
            search: searchItems(SERVICE),
            renderItem: function renderItem(item, isHighlighted) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                { key: item.id, className: isHighlighted ? "selected" : "" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    item.name
                  )
                )
              );
            },
            placeholder: "Search Items"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "Hazmat Fee" },
          "Hazmat Fee"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["Q" /* AutoComplete */], {
            format: function format(result) {
              return result.name;
            },
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, "hazmat_fee_item.name", null),
            onSelect: function onSelect(val) {
              return updateSetting("hazmat_fee_item", val);
            },
            search: searchItems([NON_INVENTORY, SERVICE].join(",")),
            renderItem: function renderItem(item, isHighlighted) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                { key: item.id, className: isHighlighted ? "selected" : "" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    item.name
                  )
                )
              );
            },
            placeholder: "Search Items"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "Hazmat Fee" },
          "Container Fee"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["Q" /* AutoComplete */], {
            format: function format(result) {
              return result.name;
            },
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, "container_fee_item.name", null),
            onSelect: function onSelect(val) {
              return updateSetting("container_fee_item", val);
            },
            search: searchItems([NON_INVENTORY, SERVICE].join(",")),
            renderItem: function renderItem(item, isHighlighted) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                { key: item.id, className: isHighlighted ? "selected" : "" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    item.name
                  )
                )
              );
            },
            placeholder: "Search Items"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Purchase Orders"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "purchase_orders" },
          "Quickbooks Type"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "select",
          {
            className: "form-control",
            name: __WEBPACK_IMPORTED_MODULE_7__constants__["_82" /* PURCHASE_ORDERS_QUICKBOOKS_TYPE */],
            onChange: function onChange(e) {
              return updateSetting(__WEBPACK_IMPORTED_MODULE_7__constants__["_82" /* PURCHASE_ORDERS_QUICKBOOKS_TYPE */], e.target.value);
            },
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_7__constants__["_82" /* PURCHASE_ORDERS_QUICKBOOKS_TYPE */])
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "option",
            { value: "" },
            "Select Default"
          ),
          __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_constants__["_5" /* PURCHASE_ORDER_QUICKBOOKS_TYPES */].map(function (r) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "option",
              { key: r.value, value: r.value },
              r.text
            );
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "A/P Account" },
          "Accounts Payable Account"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["Q" /* AutoComplete */], {
            format: function format(result) {
              return result.name;
            },
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, "accounts_payable_account.name", null),
            onSelect: function onSelect(val) {
              return updateSetting("accounts_payable_account", val);
            },
            search: search,
            renderItem: function renderItem(item, isHighlighted) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                { key: item.id, className: isHighlighted ? "selected" : "" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    item.fully_qualified_name
                  )
                )
              );
            },
            placeholder: "Search Account"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "A/P Account" },
          "Purchase Exchange Account"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["Q" /* AutoComplete */], {
            format: function format(result) {
              return result.name;
            },
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, "purchase_exchange_account.name", null),
            onSelect: function onSelect(val) {
              return updateSetting("purchase_exchange_account", val);
            },
            search: search,
            renderItem: function renderItem(item, isHighlighted) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                { key: item.id, className: isHighlighted ? "selected" : "" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    item.fully_qualified_name
                  )
                )
              );
            },
            placeholder: "Search Account"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Repair Orders"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "Repair Account" },
          "Repairs"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["Q" /* AutoComplete */], {
            format: function format(result) {
              return result.name;
            },
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, "repair_account.name", null),
            onSelect: function onSelect(val) {
              return updateSetting("repair_account", val);
            },
            search: search,
            renderItem: function renderItem(item, isHighlighted) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                { key: item.id, className: isHighlighted ? "selected" : "" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    item.fully_qualified_name
                  )
                )
              );
            },
            placeholder: "Search Account"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Managed Repair Orders"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "Restocking Fee" },
          "Managed Repair Item"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["Q" /* AutoComplete */], {
            format: function format(result) {
              return result.name;
            },
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, "managed_repair_item.name", null),
            onSelect: function onSelect(val) {
              return updateSetting("managed_repair_item", val);
            },
            search: searchItems([NON_INVENTORY, SERVICE].join(",")),
            renderItem: function renderItem(item, isHighlighted) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                { key: item.id, className: isHighlighted ? "selected" : "" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    item.name
                  )
                )
              );
            },
            placeholder: "Search Items"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "Repair Account" },
          "Managed Repair Expense Account"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["Q" /* AutoComplete */], {
            format: function format(result) {
              return result.name;
            },
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, "managed_repair_account.name", null),
            onSelect: function onSelect(val) {
              return updateSetting("managed_repair_account", val);
            },
            search: search,
            renderItem: function renderItem(item, isHighlighted) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                { key: item.id, className: isHighlighted ? "selected" : "" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    item.fully_qualified_name
                  )
                )
              );
            },
            placeholder: "Search Account"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Other"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "A/R Account" },
          "A/R Account"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "input-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["Q" /* AutoComplete */], {
            format: function format(result) {
              return result.name;
            },
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(settings, "ar_account.name", null),
            onSelect: function onSelect(val) {
              return updateSetting("ar_account", val);
            },
            search: search,
            renderItem: function renderItem(item, isHighlighted) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "li",
                { key: item.id, className: isHighlighted ? "selected" : "" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    item.fully_qualified_name
                  )
                )
              );
            },
            placeholder: "Search Account"
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Cancel, { close: close, editable: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Submit, {
        disabled: false,
        editable: true,
        submitting: submitting,
        onClick: function onClick() {
          saveSetting();
          close();
        }
      })
    )
  );
}

function AccountSelectionModal(_ref5) {
  var location = _ref5.location;

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      settings = _useState4[0],
      setSetting = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState6 = _slicedToArray(_useState5, 2),
      defaultQuickbooksAccount = _useState6[0],
      setDefaultQuickbooksAccount = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
      _useState8 = _slicedToArray(_useState7, 2),
      closed = _useState8[0],
      toggle = _useState8[1];

  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState10 = _slicedToArray(_useState9, 2),
      submitting = _useState10[0],
      setSubmitting = _useState10[1];

  var _useState11 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
      _useState12 = _slicedToArray(_useState11, 2),
      changes = _useState12[0],
      setChanges = _useState12[1];

  if (!location.quickbook_realm_id) return null;
  if (!location.quickbook_access_token) return null;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].locations.locationSetting.show(location.id).then(function (_ref6) {
      var data = _ref6.data;

      setSetting(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(data, "settings.quickbooks", {}));
      setDefaultQuickbooksAccount(data.default_quickbooks_account);

      return function cleanup() {};
    });
  }, []);

  var saveSetting = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    setSubmitting(true);
    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].locations.locationSetting.update(location.id, { quickbooks: settings }, defaultQuickbooksAccount).then(function (_ref7) {
      var resp = _ref7.data;

      setSubmitting(false);
      setSetting(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(resp, "settings.quickbooks"));
    });
  });

  var updateSetting = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (path, value) {
    setSetting(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["set"])(settings, path, value));
    setChanges(changes + 1);
  }, [settings, changes]);

  if (!settings) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        style: { cursor: "pointer", marginTop: "1rem" },
        onClick: function onClick() {
          return toggle(!closed);
        },
        className: "btn btn-default"
      },
      "Location Settings"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SettingsModal, {
      editing: !closed,
      close: function close() {
        return toggle(true);
      },
      defaultQuickbooksAccount: defaultQuickbooksAccount,
      locationId: location.id,
      settings: settings,
      setDefaultQuickbooksAccount: setDefaultQuickbooksAccount,
      saveSetting: saveSetting,
      submitting: submitting,
      updateSetting: updateSetting,
      changes: changes
    })
  );
}

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LocationPanel__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sessionChannel__ = __webpack_require__(635);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









function Integrations(_ref) {
  var subscribeToLocations = _ref.subscribeToLocations;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      qbUrl = _useState2[0],
      setQbUrl = _useState2[1];

  var locations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hooks__["a" /* useCurrentUser */])().locations;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].integrations.quickbooks.oauth().then(function (resp) {
      subscribeToLocations();
      setQbUrl(resp.data.redirect_uri);

      return function cleanup() {};
    });
  }, []);

  if (!qbUrl) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      "Integrations"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "row" },
      locations.map(function (l) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LocationPanel__["a" /* default */], { location: l, locations: locations });
      })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    subscribeToLocations: function subscribeToLocations() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__sessionChannel__["a" /* subscribe */])());
    }
  };
})(Integrations)));

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccountSelectionModal__ = __webpack_require__(1246);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();






function LocationPanel(_ref) {
  var location = _ref.location,
      locations = _ref.locations;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      qbUrl = _useState2[0],
      setQbUrl = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].integrations.quickbooks.oauth(location.id).then(function (resp) {
      setQbUrl(resp.data.redirect_uri);

      return function cleanup() {};
    });
  }, []);

  if (!qbUrl) return null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "col-sm-2" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "panel panel-default" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "panel-body pointer" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          location.name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
          { to: { pathname: qbUrl }, target: "_blank" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
            src: "https://info-trader-assets.s3.us-east-2.amazonaws.com/logos/quickbooks-logo.png",
            alt: "Quickbooks"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AccountSelectionModal__["a" /* default */], { location: location, locations: locations })
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (LocationPanel);

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_submission__ = __webpack_require__(49);





function QbRedirect(_ref) {
  var location = _ref.location;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var url = new URLSearchParams(location.search);
    var paramsObj = Object.fromEntries(url.entries());
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].integrations.quickbooks.redirect(paramsObj).then(function () {
      return __WEBPACK_IMPORTED_MODULE_3__lib_submission__["a" /* SUCCESS */];
    }).catch(function (_e) {});
  }, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "row" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "col-sm-6 col-sm-offset-3" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "panel panel-default" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "panel-body pointer" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "flex", style: { textAlign: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h2",
                  null,
                  "Integrations"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
                  src: "https://info-trader-assets.s3.us-east-2.amazonaws.com/logos/quickbooks-logo.png",
                  alt: "quickbooks",
                  height: "50px"
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "p",
                  { style: { marginTop: 10 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "fa fa-check" }),
                  "\xA0\xA0Successfully Connected!"
                )
              )
            )
          )
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router__["withRouter"])(QbRedirect));

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StatsPanel__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ActionDropDown_ActionDropDown__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









function PartRankings(_ref) {
  var sellableQty = _ref.sellableQty,
      filter = _ref.filter;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState4 = _slicedToArray(_useState3, 2),
      results = _useState4[0],
      setResults = _useState4[1];

  var performRequest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.rankingStats(sellableQty, filter).then(function (_ref2) {
      var data = _ref2.data;

      setResults(data);
      setIsLoading(false);
    });
  }, [sellableQty, filter]);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    performRequest();
  }, [sellableQty, filter]);

  if (isLoading) return null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StatsPanel__["a" /* default */], {
        title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])("sold_in_12_months"),
        results: results.sold_in_12_months
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StatsPanel__["a" /* default */], {
        title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])("sold_in_4_months"),
        results: results.sold_in_4_months
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StatsPanel__["a" /* default */], {
        title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])("average_days_in_stock"),
        results: results.average_days_in_stock
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StatsPanel__["a" /* default */], {
        title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])("average_oq_per_month"),
        results: results.average_oq_per_month
      })
    )
  );
}

var Report = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(function () {
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState6 = _slicedToArray(_useState5, 2),
      noSellableQty = _useState6[0],
      setNoSellableQty = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState8 = _slicedToArray(_useState7, 2),
      filter = _useState8[0],
      setFilter = _useState8[1];

  var filterTypes = [{
    label: "All",
    func: function func() {
      setNoSellableQty(false);
      setFilter(null);
    }
  }, {
    func: function func() {
      return setNoSellableQty(true);
    },
    label: "No Sellable Qty"
  }, {
    label: "Rotables",
    func: function func() {
      return setFilter("rotable");
    }
  }, {
    label: "Expendables",
    func: function func() {
      return setFilter("expendable");
    }
  }, {
    label: "Tooling",
    func: function func() {
      return setFilter("tooling");
    }
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "page-header page-header-bar" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h1",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "btn-group pull-right", style: { marginLeft: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__shared_components_ActionDropDown_ActionDropDown__["a" /* default */],
                {
                  menuClass: "dropdown-menu-right",
                  style: { cursor: "pointer" },
                  label: "Filter"
                },
                filterTypes.map(function (report) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown_DropDownItem__["a" /* default */],
                    { key: report.value, onClick: report.func },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "span",
                        null,
                        report.label
                      )
                    )
                  );
                })
              )
            ),
            "Part Rankings",
            " ",
            noSellableQty && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              {
                className: "btn btn-xs btn-default",
                onClick: function onClick() {
                  return setNoSellableQty(false);
                }
              },
              "No Sellable Qty ",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-close" })
            ),
            filter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              {
                className: "btn btn-xs btn-default",
                onClick: function onClick() {
                  return setFilter(null);
                }
              },
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])(filter),
              " ",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-close" })
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PartRankings, { sellableQty: noSellableQty, filter: filter })
    )
  );
});

/* harmony default export */ __webpack_exports__["a"] = (Report);

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);





var StatsPanel = function StatsPanel(_ref) {
  var title = _ref.title,
      results = _ref.results;

  var style = {
    backgroundColor: "#928ff7",
    padding: "0 10px",
    borderRadius: "3px",
    boxShadow: "0 4px 4px rgba(0, 0, 0, 0.5)"
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
    { md: 6 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: style },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h2",
        { style: { lineHeight: "1.8", color: "hsla(0,0%,100%,0.8)" } },
        title
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Table__["a" /* default */], { results: results })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (StatsPanel);

StatsPanel.defaultProps = {
  report: "company",
  period: "all",
  title: null,
  config: { filters: function filters() {
      return {};
    } }
};

StatsPanel.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
  config: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    request: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }).isRequired
};

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Notifications_components_Search_PartLink__ = __webpack_require__(656);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var Table = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(function (_ref) {
  var _ref$results = _ref.results,
      results = _ref$results === undefined ? [] : _ref$results,
      isLoading = _ref.isLoading,
      refresh = _ref.refresh;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components__["s" /* DataTable */],
    { loading: isLoading, loadingRows: 3, refresh: refresh },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Desc"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Sellable Qty"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Stat"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Notifications_components_Search_PartLink__["a" /* default */], {
              uuid: r.part_uuid,
              tierType: r.part_tier_type,
              partNumber: r.part_number
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            r.part_description
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            r.sellable_quantity
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["c" /* displayDecimal */])(r.stat, 2)
          )
        );
      })
    )
  );
});

Table.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_1__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pagination__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table__ = __webpack_require__(1254);











function ReportsSearch() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_8__pagination__["a" /* pagination */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h2",
            null,
            "Export Retrieval"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

ReportsSearch.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["a" /* USER */])
  };
}, { pushHistory: __WEBPACK_IMPORTED_MODULE_4_react_router_redux__["push"] })(ReportsSearch));

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









function linkUrl(record) {
  if (record.status === "completed") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["r" /* ExternalLink */],
      { url: record.public_download_url },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        record.name
      )
    );
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    record.name
  );
}

function renderRow(r) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { key: r.id },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      linkUrl(r)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(r.status)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["e" /* shortDateAndTimestamp */])(r.created_at)
    )
  );
}

function Table(_ref) {
  var isLoading = _ref.isLoading,
      results = _ref.results;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */],
    { loading: isLoading },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Name"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Status"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Created At"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(renderRow)
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_5__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"] })(Table));

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_Check_CheckGroup__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_Check_Check__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hooks_useDispatch__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__session_actionTypes__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Locations_constants__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__ = __webpack_require__(11);
/* harmony export (immutable) */ __webpack_exports__["a"] = Settings;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
























function SettingsModal(_ref) {
  var closed = _ref.closed,
      close = _ref.close,
      editing = _ref.editing,
      saveSetting = _ref.saveSetting,
      _ref$locations = _ref.locations,
      locations = _ref$locations === undefined ? [] : _ref$locations,
      _ref$settings = _ref.settings,
      settings = _ref$settings === undefined ? {} : _ref$settings,
      _ref$submitting = _ref.submitting,
      submitting = _ref$submitting === undefined ? false : _ref$submitting,
      updateLocation = _ref.updateLocation,
      updateSetting = _ref.updateSetting;

  if (closed) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "InfoTrader Settings"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_Check_CheckGroup__["a" /* default */],
            {
              title: ["Freight Complete", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__shared_components__["j" /* NoteTooltip */], {
                note: "Do not display commissions in PAY ALL when 'Freight Complete' = No.",
                icon: "fa-info-circle",
                color: "#545454"
              })]
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_Check_Check__["a" /* default */], {
              onChange: function onChange(val) {
                return updateSetting(__WEBPACK_IMPORTED_MODULE_6__constants__["_62" /* FREIGHT_COMPLETE_RESTRICTION */], val);
              },
              input: {
                name: __WEBPACK_IMPORTED_MODULE_6__constants__["_62" /* FREIGHT_COMPLETE_RESTRICTION */],
                value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_6__constants__["_62" /* FREIGHT_COMPLETE_RESTRICTION */]),
                onChange: function onChange() {}
              },
              label: "Yes/No"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_Check_CheckGroup__["a" /* default */],
            { title: "Auto Adjust SRP" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_Check_Check__["a" /* default */], {
              onChange: function onChange(val) {
                return updateSetting(__WEBPACK_IMPORTED_MODULE_6__constants__["_85" /* AUTO_ADJUST_SRP */], val);
              },
              input: {
                name: __WEBPACK_IMPORTED_MODULE_6__constants__["_85" /* AUTO_ADJUST_SRP */],
                value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_6__constants__["_85" /* AUTO_ADJUST_SRP */]),
                onChange: function onChange() {}
              },
              label: "Yes/No"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_Check_CheckGroup__["a" /* default */],
            { title: "Buy AR For Stock" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_Check_Check__["a" /* default */], {
              onChange: function onChange(val) {
                return updateSetting(__WEBPACK_IMPORTED_MODULE_6__constants__["Y" /* BUY_AR_FOR_STOCK */], val);
              },
              input: {
                name: __WEBPACK_IMPORTED_MODULE_6__constants__["Y" /* BUY_AR_FOR_STOCK */],
                value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_6__constants__["Y" /* BUY_AR_FOR_STOCK */]),
                onChange: function onChange() {}
              },
              label: "Yes/No"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "default_buyer_credit" },
            "Default Buyer Credit"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "select",
            {
              className: "form-control",
              name: __WEBPACK_IMPORTED_MODULE_6__constants__["G" /* BUYER_CREDIT_PCT */],
              onChange: function onChange(e) {
                return updateSetting(__WEBPACK_IMPORTED_MODULE_6__constants__["G" /* BUYER_CREDIT_PCT */], e.target.value);
              },
              value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_6__constants__["G" /* BUYER_CREDIT_PCT */])
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "option",
              { value: "" },
              "Select Default"
            ),
            __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["_4" /* BUYER_CREDIT_PCT_OPTIONS */].map(function (r) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "option",
                { key: r.value, value: r.value },
                r.text
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["_34" /* DEFAULT_HAZMAT_FEE */] },
            "Default Hazmat Fee"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            className: "form-control",
            type: "number",
            step: 0.01,
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_6__constants__["_34" /* DEFAULT_HAZMAT_FEE */]),
            onChange: function onChange(e) {
              return updateSetting(__WEBPACK_IMPORTED_MODULE_6__constants__["_34" /* DEFAULT_HAZMAT_FEE */], e.target.value);
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["_86" /* FUZZY_SIMILARITY_PERCENT */] },
            "Fuzzy Similarity %",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__shared_components__["j" /* NoteTooltip */], {
              note: "100% will display only exact matches, blank and zero will disable the feature for restricted entity listings.",
              icon: "fa-info-circle",
              color: "#545454"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            className: "form-control",
            type: "number",
            step: 0.01,
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_6__constants__["_86" /* FUZZY_SIMILARITY_PERCENT */]),
            onChange: function onChange(e) {
              return updateSetting(__WEBPACK_IMPORTED_MODULE_6__constants__["_86" /* FUZZY_SIMILARITY_PERCENT */], e.target.value);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            {
              className: "control-label",
              htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["_61" /* DEFAULT_NO_FAULT_FOUND_FEE */]
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["_61" /* DEFAULT_NO_FAULT_FOUND_FEE */])
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            className: "form-control",
            type: "number",
            step: 0.01,
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_6__constants__["_61" /* DEFAULT_NO_FAULT_FOUND_FEE */]),
            onChange: function onChange(e) {
              return updateSetting(__WEBPACK_IMPORTED_MODULE_6__constants__["_61" /* DEFAULT_NO_FAULT_FOUND_FEE */], e.target.value);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 2, mdOffset: 1 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["_87" /* MIN_MANAGED_REPAIR_FEE */] },
            "Min Managed Repair Fee"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            className: "form-control",
            type: "number",
            step: 0.01,
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_6__constants__["_87" /* MIN_MANAGED_REPAIR_FEE */]),
            onChange: function onChange(e) {
              return updateSetting(__WEBPACK_IMPORTED_MODULE_6__constants__["_87" /* MIN_MANAGED_REPAIR_FEE */], e.target.value);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["_88" /* MINIMUM_REPAIR_FEE */] },
            "Min Repair Admin Fee"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            className: "form-control",
            type: "number",
            step: 0.01,
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_6__constants__["_88" /* MINIMUM_REPAIR_FEE */]),
            onChange: function onChange(e) {
              return updateSetting(__WEBPACK_IMPORTED_MODULE_6__constants__["_88" /* MINIMUM_REPAIR_FEE */], e.target.value);
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h5",
            null,
            "Exchange Sales"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_Check_CheckGroup__["a" /* default */],
            { title: "Can Exchange" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_Check_Check__["a" /* default */], {
              onChange: function onChange(val) {
                return updateSetting(__WEBPACK_IMPORTED_MODULE_6__constants__["_35" /* CAN_EXCHANGE */], val);
              },
              input: {
                name: __WEBPACK_IMPORTED_MODULE_6__constants__["_35" /* CAN_EXCHANGE */],
                value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_6__constants__["_35" /* CAN_EXCHANGE */]),
                onChange: function onChange() {}
              },
              label: "Yes/No"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["X" /* MINIMUM_EXCHANGE_SRP */] },
            "Min Exchange SRP"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            className: "form-control",
            type: "number",
            step: 0.01,
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_6__constants__["X" /* MINIMUM_EXCHANGE_SRP */]),
            onChange: function onChange(e) {
              return updateSetting(__WEBPACK_IMPORTED_MODULE_6__constants__["X" /* MINIMUM_EXCHANGE_SRP */], e.target.value);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["_50" /* EXCHANGE_CREDIT_PCT */] },
            "Cost % Applied to Exch. Transactions"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            className: "form-control",
            type: "number",
            step: 0.01,
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_6__constants__["_50" /* EXCHANGE_CREDIT_PCT */]),
            onChange: function onChange(e) {
              if (e.target.value >= 0 && e.target.value <= 100 || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(e.target.value)) {
                updateSetting(__WEBPACK_IMPORTED_MODULE_6__constants__["_50" /* EXCHANGE_CREDIT_PCT */], e.target.value);
              }
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["_52" /* EXCHANGE_CORE_DUE_DAYS */] },
            "Exchange Core Due Days"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            className: "form-control",
            type: "number",
            step: 0.01,
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_6__constants__["_52" /* EXCHANGE_CORE_DUE_DAYS */]),
            onChange: function onChange(e) {
              updateSetting(__WEBPACK_IMPORTED_MODULE_6__constants__["_52" /* EXCHANGE_CORE_DUE_DAYS */], e.target.value);
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            {
              className: "control-label",
              htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["_22" /* MIN_OUTRIGHT_VALUE_FOR_EXCHANGE_CONSIDERATION */]
            },
            "Min Outright Value for Exch Consideration"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            className: "form-control",
            type: "number",
            step: 0.01,
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_6__constants__["_22" /* MIN_OUTRIGHT_VALUE_FOR_EXCHANGE_CONSIDERATION */]),
            onChange: function onChange(e) {
              updateSetting(__WEBPACK_IMPORTED_MODULE_6__constants__["_22" /* MIN_OUTRIGHT_VALUE_FOR_EXCHANGE_CONSIDERATION */], e.target.value);
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h5",
            null,
            "Shipping Details"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_13__shared_constants__["g" /* DEFAULT_CARRIERS */].map(function (c) {
          var path = __WEBPACK_IMPORTED_MODULE_6__constants__["f" /* SHIPPING_OPTIONS */] + "." + c + ".default_account";
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              { className: "control-label", htmlFor: "default_account" },
              c.toUpperCase() + " Default Account"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
              className: "form-control",
              onChange: function onChange(e) {
                return updateSetting(path, e.target.value);
              },
              value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, path)
            })
          );
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h5",
            null,
            "Resale Tax #"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
        null,
        locations.map(function (l, i) {
          var path = "[" + i + "].resale_number";
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              { className: "control-label", htmlFor: "default_account" },
              l.name.toUpperCase() + " Resale Tax #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
              className: "form-control",
              onChange: function onChange(e) {
                return updateLocation(path, e.target.value);
              },
              value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(locations, path)
            })
          );
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h5",
            null,
            "Inventory Label Paper Size"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "cancellation_reason" },
            "Inventory Label Paper Size"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "select",
            {
              className: "form-control",
              name: __WEBPACK_IMPORTED_MODULE_6__constants__["_12" /* LABEL_SIZE */],
              onChange: function onChange(e) {
                return updateSetting(__WEBPACK_IMPORTED_MODULE_6__constants__["_12" /* LABEL_SIZE */], e.target.value);
              },
              value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_6__constants__["_12" /* LABEL_SIZE */])
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "option",
              { value: "" },
              "Select Default"
            ),
            __WEBPACK_IMPORTED_MODULE_6__constants__["_89" /* LABEL_SIZES */].map(function (r) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "option",
                { key: r.value, value: r.value },
                r.text
              );
            })
          )
        )
      ),
      locations.map(function (l) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h5",
                null,
                "Bank Details for ",
                l.name
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["_90" /* RECEIVING_BANK_NAME */] },
                "Receiving Bank Name"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                className: "form-control",
                type: "text",
                onChange: function onChange(e) {
                  return updateSetting("stores." + l.id + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["_90" /* RECEIVING_BANK_NAME */], e.target.value);
                },
                value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, "stores." + l.id + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["_90" /* RECEIVING_BANK_NAME */])
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["_91" /* INTERMEDIARY_BANK */] },
                "Intermediary Bank"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                className: "form-control",
                type: "text",
                onChange: function onChange(e) {
                  return updateSetting("stores." + l.id + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["_91" /* INTERMEDIARY_BANK */], e.target.value);
                },
                value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, "stores." + l.id + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["_91" /* INTERMEDIARY_BANK */])
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["_92" /* SWIFT_CODE */] },
                "Swift Code"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                className: "form-control",
                type: "text",
                onChange: function onChange(e) {
                  return updateSetting("stores." + l.id + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["_92" /* SWIFT_CODE */], e.target.value);
                },
                value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, "stores." + l.id + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["_92" /* SWIFT_CODE */])
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["_93" /* IBAN */] },
                "IBAN#"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                className: "form-control",
                type: "text",
                onChange: function onChange(e) {
                  return updateSetting("stores." + l.id + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["_93" /* IBAN */], e.target.value);
                },
                value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, "stores." + l.id + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["_93" /* IBAN */])
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["_94" /* ABA_ROUTING */] },
                "ABA / Routing#"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                className: "form-control",
                type: "text",
                onChange: function onChange(e) {
                  return updateSetting("stores." + l.id + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["_94" /* ABA_ROUTING */], e.target.value);
                },
                value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, "stores." + l.id + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["_94" /* ABA_ROUTING */])
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["_95" /* ACH_ROUTING */] },
                "ACH / Routing#"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                className: "form-control",
                type: "text",
                onChange: function onChange(e) {
                  return updateSetting("stores." + l.id + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["_95" /* ACH_ROUTING */], e.target.value);
                },
                value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, "stores." + l.id + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["_95" /* ACH_ROUTING */])
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["_96" /* BENEFICIARY_ACCOUNT */] },
                "Beneficiary Account"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                className: "form-control",
                type: "text",
                onChange: function onChange(e) {
                  return updateSetting("stores." + l.id + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["_96" /* BENEFICIARY_ACCOUNT */], e.target.value);
                },
                value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, "stores." + l.id + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["_96" /* BENEFICIARY_ACCOUNT */])
              })
            )
          )
        );
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h5",
            null,
            "Warranty Period"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 6 },
          Object.keys(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib_removeKey__["b" /* removeKeys */])(__WEBPACK_IMPORTED_MODULE_6__constants__["_27" /* CONDITIONS_WITH_SERVICEABLE */], [__WEBPACK_IMPORTED_MODULE_6__constants__["_97" /* AS_REMOVED */], __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__["g" /* BEYOND_ECON_REPAIR */]])).map(function (c) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                {
                  className: "control-label",
                  htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["_27" /* CONDITIONS_WITH_SERVICEABLE */][c].label
                },
                __WEBPACK_IMPORTED_MODULE_6__constants__["_27" /* CONDITIONS_WITH_SERVICEABLE */][c].label
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "select",
                {
                  className: "form-control",
                  value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, c + "_warranty", __WEBPACK_IMPORTED_MODULE_6__constants__["_27" /* CONDITIONS_WITH_SERVICEABLE */][c].default_warranty),
                  onChange: function onChange(e) {
                    return updateSetting(c + "_warranty", e.target.value);
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "option",
                  { value: "" },
                  "Select Default"
                ),
                __WEBPACK_IMPORTED_MODULE_19__inventories_constants__["_59" /* WARRANTY_OPTIONS */].map(function (f) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "option",
                    { value: f },
                    f
                  );
                })
              )
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { htmlFor: "tag_date_months_for_warranty" },
            "For Tag Dates older than (IN MONTHS)\xA0"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            className: "form-control",
            style: { width: 100 },
            type: "number",
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, "tag_date_months_for_warranty"),
            onChange: function onChange(e) {
              return updateSetting("tag_date_months_for_warranty", e.target.value);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { htmlFor: "tag_date_warranty" },
            "Warranty limited to\xA0"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "select",
            {
              className: "form-control",
              value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, "tag_date_warranty"),
              onChange: function onChange(e) {
                return updateSetting("tag_date_warranty", e.target.value);
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "option",
              { value: "" },
              "Select Default"
            ),
            __WEBPACK_IMPORTED_MODULE_19__inventories_constants__["_59" /* WARRANTY_OPTIONS */].map(function (f) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "option",
                { value: f },
                f
              );
            })
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Cancel, { close: close, editable: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Submit, {
        disabled: false,
        editable: true,
        submitting: submitting,
        onClick: function onClick() {
          saveSetting();
          close();
        }
      })
    )
  );
}

SettingsModal.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  closed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  locations: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})),
  saveSetting: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  settings: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  submitting: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  updateLocation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  updateSetting: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

function Settings() {
  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__hooks__["a" /* useCurrentUser */])();

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(currentUser.locations.map(function (l) {
    return {
      id: l.id,
      name: l.name,
      resale_number: l.resale_number
    };
  })),
      _useState2 = _slicedToArray(_useState, 2),
      locations = _useState2[0],
      setLocations = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState4 = _slicedToArray(_useState3, 2),
      settings = _useState4[0],
      setSetting = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
      _useState6 = _slicedToArray(_useState5, 2),
      closed = _useState6[0],
      toggle = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState8 = _slicedToArray(_useState7, 2),
      submitting = _useState8[0],
      setSubmitting = _useState8[1];

  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
      _useState10 = _slicedToArray(_useState9, 2),
      changes = _useState10[0],
      setChanges = _useState10[1];

  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__hooks_useDispatch__["a" /* default */])();

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].appSetting.index().then(function (_ref2) {
      var data = _ref2.data;

      setSetting(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(data, __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* SETTINGS */]) || {});
      return function cleanup() {};
    });
  }, []);

  var saveSetting = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    setSubmitting(true);
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].appSetting.update({ locations: locations, settings: settings }).then(function (_ref3) {
      var resp = _ref3.data;

      setSubmitting(false);
      setSetting(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(resp, __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* SETTINGS */]));
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_15__session_actionTypes__["i" /* SET_SETTINGS */],
        settings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(resp, __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* SETTINGS */]),
        locations: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(resp, __WEBPACK_IMPORTED_MODULE_16__Locations_constants__["b" /* LOCATIONS */])
      });
    });
  }, [locations, settings, dispatch]);

  var updateSetting = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (path, value) {
    setSetting(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["set"])(settings, path, value));
    setChanges(changes + 1);
  }, [settings, changes]);

  var updateLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (path, value) {
    setLocations(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["set"])(locations, path, value));
    setChanges(changes + 1);
  }, [locations, changes]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "a",
      { style: { cursor: "pointer" }, onClick: function onClick() {
          return toggle(!closed);
        } },
      "InfoTrader Settings"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SettingsModal, {
      editing: !closed,
      close: function close() {
        return toggle(true);
      },
      locations: locations,
      settings: settings,
      saveSetting: saveSetting,
      submitting: submitting,
      updateLocation: updateLocation,
      updateSetting: updateSetting,
      changes: changes
    })
  );
}

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Stars_Stars__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(6);
/* harmony export (immutable) */ __webpack_exports__["a"] = TierTypeWarningMgmt;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();














function TierTypeWarningModal(_ref) {
  var closed = _ref.closed,
      close = _ref.close,
      editing = _ref.editing,
      saveSetting = _ref.saveSetting,
      settings = _ref.settings,
      setSettings = _ref.setSettings,
      _ref$tierTypeLimits = _ref.tierTypeLimits,
      tierTypeLimits = _ref$tierTypeLimits === undefined ? [] : _ref$tierTypeLimits,
      _ref$submitting = _ref.submitting,
      submitting = _ref$submitting === undefined ? false : _ref$submitting,
      updateTierTypeLimits = _ref.updateTierTypeLimits;

  if (closed) {
    return null;
  }

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      partCounts = _useState2[0],
      setPartCounts = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].parts.tierTypeStats().then(function (_ref2) {
      var data = _ref2.data;

      setPartCounts(data);
      return function cleanup() {};
    });
  }, []);

  var renderRow = function renderRow(row, idx) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_helpers__["a" /* getPartNumberColorClassNameByTierType */])(row.tier) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_Stars_Stars__["a" /* default */], { tierType: row.tier }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { style: { color: "white" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            partCounts[__WEBPACK_IMPORTED_MODULE_5__parts_constants__["_37" /* TIER_TO_STAR_MAP */][row.tier]]
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          className: "form-control",
          type: "number",
          step: 0.01,
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(tierTypeLimits, "[" + idx + "].cost"),
          onChange: function onChange(e) {
            return updateTierTypeLimits("[" + idx + "].cost", e.target.value);
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          className: "form-control",
          type: "number",
          step: 1,
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(tierTypeLimits, "[" + idx + "].qty"),
          onChange: function onChange(e) {
            return updateTierTypeLimits("[" + idx + "].qty", e.target.value);
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          className: "form-control",
          type: "number",
          step: 0.01,
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(tierTypeLimits, "[" + idx + "].percent_adjustment"),
          onChange: function onChange(e) {
            return updateTierTypeLimits("[" + idx + "].percent_adjustment", e.target.value);
          }
        })
      )
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Purchase Admin Controls"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "table",
        { className: "table table-striped table-hover table-numbered" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tier Type"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Restriction ($) Limit (<=)"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Total Sellable Qty Restriction Limit (<=)"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "% Adjustment"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tbody",
          null,
          tierTypeLimits.map(renderRow)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            {
              className: "control-label",
              htmlFor: __WEBPACK_IMPORTED_MODULE_8__constants__["_98" /* PURCHASE_ORDER_BCC_EMAILS */]
            },
            "Purchase Order BCC Emails"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            name: __WEBPACK_IMPORTED_MODULE_8__constants__["_98" /* PURCHASE_ORDER_BCC_EMAILS */],
            className: "form-control",
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_8__constants__["_98" /* PURCHASE_ORDER_BCC_EMAILS */]),
            onChange: function onChange(e) {
              settings[__WEBPACK_IMPORTED_MODULE_8__constants__["_98" /* PURCHASE_ORDER_BCC_EMAILS */]] = e.target.value;
              setSettings(settings);
            }
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Cancel, { close: close, editable: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Submit, {
        disabled: false,
        editable: true,
        submitting: submitting,
        onClick: function onClick() {
          saveSetting();
          close();
        }
      })
    )
  );
}

TierTypeWarningModal.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  closed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  saveSetting: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  tierTypeLimits: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  settings: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  setSettings: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  submitting: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  updateTierTypeLimits: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

function TierTypeWarningMgmt() {
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState4 = _slicedToArray(_useState3, 2),
      tierTypeLimits = _useState4[0],
      setTierTypeLimits = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
      _useState6 = _slicedToArray(_useState5, 2),
      closed = _useState6[0],
      toggle = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState8 = _slicedToArray(_useState7, 2),
      settings = _useState8[0],
      setSettings = _useState8[1];

  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState10 = _slicedToArray(_useState9, 2),
      submitting = _useState10[0],
      setSubmitting = _useState10[1];

  var _useState11 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
      _useState12 = _slicedToArray(_useState11, 2),
      changes = _useState12[0],
      setChanges = _useState12[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].appSetting.index().then(function (_ref3) {
      var data = _ref3.data;

      setTierTypeLimits(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(data, __WEBPACK_IMPORTED_MODULE_8__constants__["_0" /* TIER_TYPE_WARNING_LIMITS */]) || __WEBPACK_IMPORTED_MODULE_5__parts_constants__["_38" /* TIER_TYPES */].map(function (tier) {
        return { tier: tier };
      }));

      setSettings(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(data, __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* SETTINGS */]));

      return function cleanup() {};
    });
  }, []);

  var saveSetting = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    setSubmitting(true);
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].appSetting.update({
      tier_type_warning_limits: tierTypeLimits,
      settings: settings
    }).then(function (_ref4) {
      var resp = _ref4.data;

      setSubmitting(false);
      setSettings(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(resp, __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* SETTINGS */]));
      setTierTypeLimits(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(resp, __WEBPACK_IMPORTED_MODULE_8__constants__["_0" /* TIER_TYPE_WARNING_LIMITS */]) || __WEBPACK_IMPORTED_MODULE_5__parts_constants__["_38" /* TIER_TYPES */].map(function (tier) {
        return { tier: tier };
      }));
    });
  });

  var updateTierTypeSetting = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (path, value) {
    setTierTypeLimits(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["set"])(tierTypeLimits, path, value));
    setChanges(changes + 1);
  }, [tierTypeLimits, changes]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "a",
      { style: { cursor: "pointer" }, onClick: function onClick() {
          return toggle(!closed);
        } },
      "Purchase Admin Controls"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TierTypeWarningModal, {
      editing: !closed,
      close: function close() {
        return toggle(true);
      },
      settings: settings,
      tierTypeLimits: tierTypeLimits,
      saveSetting: saveSetting,
      setSettings: setSettings,
      submitting: submitting,
      updateTierTypeLimits: updateTierTypeSetting,
      changes: changes
    })
  );
}

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony export (immutable) */ __webpack_exports__["a"] = searchAircrafts;


function searchAircrafts(filter) {
  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].aircrafts.search({
    filter: filter,
    page: 1,
    limit: 15
  }).then(function (_ref) {
    var data = _ref.data;
    return Promise.resolve(data.results);
  });
}

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pagination__ = __webpack_require__(417);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











function ApprovedRepairStationSearch(_ref) {
  var pushHistory = _ref.pushHistory;

  var filters = [{
    label: "All Repair Stations",
    filters: { repair_station_status: undefined }
  }, {
    label: "Approved Repair Stations",
    filters: { repair_station_status: "approved" }
  }, {
    label: "Denied Repair Stations",
    filters: { repair_station_status: "denied" }
  }, {
    label: "Management Consent Needed",
    filters: { manager_consent_repair_station_status: true }
  }];

  var filterTags = [{
    label: "Repair Station Status",
    key: "repair_station_status"
  }, {
    label: "Management Consent Needed",
    key: "manager_consent_repair_station_status"
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_8__pagination__["a" /* default */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a company name, code, or contact name...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/companies/" + r.id);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, { filters: filters, right: true }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(searchProps.paginator.toJS(), "filters.repair_station_status", "all").toUpperCase() + " REPAIR STATIONS",
          filters: filterTags
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

ApprovedRepairStationSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(ApprovedRepairStationSearch));

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__companies_components_Search_RepairStationStatus__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ToggleButton__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(1262);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














function renderRow(r, currentUser, repairStationStatusLastVerified, pushHistory) {
  var approved = r.repair_station_status === "approved";
  var repairStationStatusUpdatedAt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["c" /* shortDateYY */])(r.repair_station_status_updated_at);
  var repairStationStatusUpdatedBy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(r.repair_station_status_updated_by, "full_name");
  var updatedAt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["e" /* shortDateAndTimestamp */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(r, "repair_station_status_verified_details.updated_at"));
  var updatedBy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(r, "repair_station_status_verified_details.updated_by.name");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: r.id,
      className: "clickable",
      onClick: function onClick() {
        return pushHistory("/companies/" + r.id);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["w" /* CompanyName */], { company: r })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(r, "primary_physical_address.city")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(r, "primary_physical_address.state")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(r, "primary_physical_address.country")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__companies_components_Search_RepairStationStatus__["a" /* default */], { status: r.repair_station_status }),
      repairStationStatusUpdatedAt && repairStationStatusUpdatedBy && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
        note: (approved ? "Approved" : "Denied") + " on " + repairStationStatusUpdatedAt + " by " + repairStationStatusUpdatedBy,
        icon: "fa-info-circle",
        color: "rgba(255, 255, 255, 0.25)",
        placement: "right"
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ToggleButton__["a" /* default */], {
        text: "Verify",
        toggledText: "Re-Verify",
        toggled: r.repair_station_status_verified_details !== null,
        canRemove: true,
        currentUser: currentUser,
        handleClick: function handleClick(e) {
          repairStationStatusLastVerified(r);
          e.stopPropagation();
        }
      }),
      updatedBy && updatedAt && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
        note: "Updated by " + updatedBy + " on " + updatedAt,
        icon: "fa-info-circle",
        color: "rgba(255, 255, 255, 0.25)",
        placement: "right"
      })
    )
  );
}

function Table(_ref) {
  var results = _ref.results,
      pushHistory = _ref.pushHistory,
      isLoading = _ref.isLoading,
      currentUser = _ref.currentUser,
      repairStationStatusLastVerified = _ref.repairStationStatusLastVerified;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */],
    { loading: isLoading },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Name"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "City"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "State"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Country"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Approval Status"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Reverification"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, currentUser, repairStationStatusLastVerified, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  repairStationStatusLastVerified: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_9__session_decorators_withCurrentUser__["a" /* WithCurrentUser */], __WEBPACK_IMPORTED_MODULE_5__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get("user").toJS()
  };
}, function (dispatch, ownProps) {
  return {
    repairStationStatusLastVerified: function repairStationStatusLastVerified(company) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions__["a" /* asyncRepairStationStatusLastVerified */])(company));
    },
    pushHistory: __WEBPACK_IMPORTED_MODULE_1_react_router_redux__["push"],
    refresh: ownProps.pageActions.expire
  };
})(Table));

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_helpers__ = __webpack_require__(41);
/* harmony export (immutable) */ __webpack_exports__["a"] = ToggleButton;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();







function ToggleButton(_ref) {
  var toggled = _ref.toggled,
      handleClick = _ref.handleClick,
      _ref$canRemove = _ref.canRemove,
      canRemove = _ref$canRemove === undefined ? false : _ref$canRemove,
      _ref$text = _ref.text,
      text = _ref$text === undefined ? "Toggle" : _ref$text,
      _ref$toggledText = _ref.toggledText,
      toggledText = _ref$toggledText === undefined ? "Untoggle" : _ref$toggledText,
      currentUser = _ref.currentUser;

  var label = toggled ? toggledText : text;
  var style = {
    color: "#fff",
    borderColor: "#0398db"
  };

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      withEffect = _useState2[0],
      setWithEffect = _useState2[1];

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn btn-xs", __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
    "text-muted": toggled,
    "btn btn-primary": !toggled,
    "btn-default": toggled,
    "with-after-click-effect": withEffect
  }));

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    setTimeout(function () {
      setWithEffect(false);
    }, 3000);
  });

  var handleClickFunc = function handleClickFunc() {
    setWithEffect(true);
    return handleClick();
  };

  var userRoleAllowed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_3__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_3__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_3__users_constants__["l" /* REPAIR */]]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    {
      type: "submit",
      onClick: handleClickFunc,
      style: style,
      disabled: !canRemove || !userRoleAllowed,
      className: classes
    },
    label
  );
}

ToggleButton.propTypes = {
  toggled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  handleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  canRemove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggledText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
var SET = "companies/SET";

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pagination__ = __webpack_require__(417);
/* unused harmony export dashboardPageActions */
/* unused harmony export show */
/* unused harmony export getCompany */
/* unused harmony export repairStationStatusLastVerified */
/* harmony export (immutable) */ __webpack_exports__["a"] = asyncRepairStationStatusLastVerified;




var dashboardPageActions = __WEBPACK_IMPORTED_MODULE_2__pagination__["a" /* default */].pageActions;



function show(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].companies.show(id).then(function (resp) {
      return dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* SET */],
        company: resp.data
      });
    });
  };
}

function getCompany(id) {
  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].companies.show(id).then(function (resp) {
    return Promise.resolve(resp.data);
  });
}

function repairStationStatusLastVerified(_ref) {
  var id = _ref.id;

  var serializedUser = JSON.parse(window.localStorage.getItem("user"));

  var data = {
    repair_station_status_verified_details: {
      updated_at: new Date(),
      updated_by: {
        id: serializedUser.id,
        name: serializedUser.full_name
      }
    }
  };

  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].companies.repairStationStatusLastVerified(id, data).then(function () {
      return dispatch(dashboardPageActions.reload());
    });
  };
}

function asyncRepairStationStatusLastVerified(company) {
  var serializedUser = JSON.parse(window.localStorage.getItem("user"));

  var data = {
    repair_station_status_verified_details: {
      updated_at: new Date(),
      updated_by: {
        id: serializedUser.id,
        name: serializedUser.full_name
      }
    }
  };

  return dashboardPageActions.updateAsync(company.id, data, __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].companies.repairStationStatusLastVerified(company.id, data));
}

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Table__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pagination__ = __webpack_require__(418);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = Object.assign(searchProps.paginator.get("filters").toJS(), {
    vendor_status: "approved",
    sort: "name",
    reverse: false
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        return window.open(__WEBPACK_IMPORTED_MODULE_7__constants__["d" /* API_BASE */] + "/companies/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_query_string__["stringify"])(params), "_blank");
      }
    },
    "Export"
  );
};

ExportButton.propTypes = {
  searchProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    paginator: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map)
  })
};

function ApprovedVendorSearch(_ref2) {
  var pushHistory = _ref2.pushHistory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_9__pagination__["a" /* default */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a company name, code, or contact name...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/companies/" + r.id);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExportButton, { searchProps: searchProps })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, { title: "Approved Vendors" })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

ApprovedVendorSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_4_react_router_redux__["push"] })(ApprovedVendorSearch));

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__companies_components_Search_VendorStatus__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ToggleButton__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(1267);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













function renderRow(r, vendorStatusLastVerified, pushHistory) {
  var approved = r.vendor_status === "approved";
  var vendorStatusUpdatedAt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__["c" /* shortDateYY */])(r.vendor_status_updated_at);
  var vendorStatusUpdatedBy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(r.vendor_status_updated_by, "full_name");
  var updatedAt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__["e" /* shortDateAndTimestamp */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(r, "vendor_status_verified_details.updated_at"));
  var updatedBy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(r, "vendor_status_verified_details.updated_by.name");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: r.id,
      className: "clickable",
      onClick: function onClick() {
        return pushHistory("/companies/" + r.id);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["w" /* CompanyName */], { company: r })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(r, "primary_physical_address.city")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(r, "primary_physical_address.state")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(r, "primary_physical_address.country")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__companies_components_Search_VendorStatus__["a" /* default */], { status: r.vendor_status }),
      vendorStatusUpdatedAt && vendorStatusUpdatedBy && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
        note: (approved ? "Approved" : "Denied") + " on " + vendorStatusUpdatedAt + " by " + vendorStatusUpdatedBy,
        icon: "fa-info-circle",
        color: "rgba(255, 255, 255, 0.25)",
        placement: "right"
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ToggleButton__["a" /* default */], {
        text: "Verify",
        toggledText: "Re-Verify",
        toggled: r.vendor_status_verified_details !== null,
        handleClick: function handleClick() {
          return vendorStatusLastVerified(r);
        }
      }),
      updatedAt && updatedBy && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
        note: "Last verified on " + updatedAt + " by " + updatedBy,
        icon: "fa-info-circle",
        color: "rgba(255, 255, 255, 0.25)",
        placement: "right"
      })
    )
  );
}

function Table(_ref) {
  var results = _ref.results,
      pushHistory = _ref.pushHistory,
      isLoading = _ref.isLoading,
      vendorStatusLastVerified = _ref.vendorStatusLastVerified;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */],
    { loading: isLoading },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Name"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "City"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "State"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Country"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Approval Status"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Reverification"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, vendorStatusLastVerified, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  vendorStatusLastVerified: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_5__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    vendorStatusLastVerified: function vendorStatusLastVerified(company) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* asyncVendorStatusLastVerified */])(company));
    },
    pushHistory: __WEBPACK_IMPORTED_MODULE_1_react_router_redux__["push"]
  };
})(Table));

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony export (immutable) */ __webpack_exports__["a"] = ToggleButton;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();





function ToggleButton(_ref) {
  var toggled = _ref.toggled,
      handleClick = _ref.handleClick,
      _ref$text = _ref.text,
      text = _ref$text === undefined ? "Toggle" : _ref$text,
      _ref$toggledText = _ref.toggledText,
      toggledText = _ref$toggledText === undefined ? "Untoggle" : _ref$toggledText;

  var label = toggled ? toggledText : text;
  var style = {
    color: "#fff",
    borderColor: "#0398db"
  };

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      withEffect = _useState2[0],
      setWithEffect = _useState2[1];

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn btn-xs", __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
    "text-muted": toggled,
    "btn btn-primary": !toggled,
    "btn-default": toggled,
    "with-after-click-effect": withEffect
  }));

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    setTimeout(function () {
      setWithEffect(false);
    }, 3000);
  });

  var handleClickFunc = function handleClickFunc() {
    setWithEffect(true);
    return handleClick();
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    {
      type: "submit",
      onClick: handleClickFunc,
      style: style,
      className: classes
    },
    label
  );
}

ToggleButton.propTypes = {
  toggled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  handleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggledText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET; });
var SET = "companies/SET";

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pagination__ = __webpack_require__(418);
/* unused harmony export dashboardPageActions */
/* unused harmony export show */
/* unused harmony export getCompany */
/* harmony export (immutable) */ __webpack_exports__["a"] = asyncVendorStatusLastVerified;




var dashboardPageActions = __WEBPACK_IMPORTED_MODULE_2__pagination__["a" /* default */].pageActions;



function show(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].companies.show(id).then(function (resp) {
      return dispatch({
        type: __WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* SET */],
        company: resp.data
      });
    });
  };
}

function getCompany(id) {
  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].companies.show(id).then(function (resp) {
    return Promise.resolve(resp.data);
  });
}

function asyncVendorStatusLastVerified(company) {
  var serializedUser = JSON.parse(window.localStorage.getItem("user"));

  var data = {
    vendor_status_verified_details: {
      updated_at: new Date(),
      updated_by: {
        id: serializedUser.id,
        name: serializedUser.full_name
      }
    }
  };

  return dashboardPageActions.updateAsync(company.id, data, __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].companies.vendorStatusLastVerified(company.id, data));
}

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_NoteTooltip_NoteTooltip__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Search_Row__ = __webpack_require__(636);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var CommissionsTable = function (_Component) {
  _inherits(CommissionsTable, _Component);

  function CommissionsTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CommissionsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CommissionsTable.__proto__ || Object.getPrototypeOf(CommissionsTable)).call.apply(_ref, [this].concat(args))), _this), _this.headerRow = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Ref #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Customer"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Source"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Part #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Serial #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Total Commission"
        )
      );
    }, _this.totalRow = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { style: { fontWeight: "bold" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          "Total Paid"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__["a" /* dollars */])(_this.props.commissions.reduce(function (prev, cur) {
            return prev + (_this.props.selectedCommissions && _this.props.selectedCommissions[cur.id] && parseFloat(cur.total_commission));
          }, 0))
        )
      );
    }, _this.renderRow = function (commission, i) {
      var hasActiveRepair = commission.source === "sales_order_line_item" && commission.active_repair_item && commission.inventory.consignment_type && !commission.exchange_sale && !commission.active_repair_item.final_evaluation_approved;

      var depreciationCommission = !commission.reference_cost_adj_sales_item_id && commission.cost_adjustment_id;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: i },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          i + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { display: "grid", gridTemplateColumns: "auto 20px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-9" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group", style: { marginBottom: "0px" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "btn-group", "data-toggle": "buttons" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
                    name: "commissions[" + commission.id.toString() + "]",
                    label: "Pay",
                    disabled: hasActiveRepair
                  })
                )
              )
            ),
            hasActiveRepair && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_NoteTooltip_NoteTooltip__["a" /* default */], {
              placement: "right",
              note: "Please process active repair prior to paying.",
              icon: "fa-info-circle",
              color: "rgba(255, 255, 255, 0.25)"
            }),
            commission.team_leader && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["j" /* NoteTooltip */], { icon: "fa-users", note: "Team Leader" }),
              "\xA0\xA0"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(commission, "sales_order.code", __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(commission, "purchase_order.code"))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["w" /* CompanyName */], { flattenedCompany: commission })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__Search_Row__["b" /* costAdjLabel */])(commission, depreciationCommission)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          commission.part_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          commission.serial_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__["a" /* dollars */])(commission.total_commission)
        )
      );
    }, _this.renderLoadingRow = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { colSpan: 6 },
          "Loading..."
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CommissionsTable, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "table",
        { className: "table table-striped table-hover table-numbered" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "thead",
          null,
          this.headerRow()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tbody",
          null,
          this.props.loading ? this.renderLoadingRow() : this.props.commissions.map(this.renderRow),
          this.totalRow()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "thead",
          null,
          this.headerRow()
        )
      );
    }
  }]);

  return CommissionsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CommissionsTable.propTypes = {};
/* harmony default export */ __webpack_exports__["a"] = (CommissionsTable);


CommissionsTable.propTypes = {
  commissions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  selectedCommissions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CommissionsTable__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(419);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var formName = "payAllCommissions";
var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])(formName);

var hasUnapprovedActiveRepair = function hasUnapprovedActiveRepair(item) {
  return item.source !== "sales_order_line_item" || item.source === "sales_order_line_item" && (!item.active_repair_item || !item.inventory.consignment_type || item.exchange_sale || item.active_repair_item.final_evaluation_approved);
};

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      commissions: [],
      commissionLoading: false
    }, _this.changeEmployee = function (ev) {
      _this.setState({ commissionsLoading: true });

      var freightCompleteRestriction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__hooks_useCurrentUser__["b" /* useSettings */])()[__WEBPACK_IMPORTED_MODULE_6__constants__["_62" /* FREIGHT_COMPLETE_RESTRICTION */]] || false;

      _this.props.searchCommissions(_extends({}, _this.props.initialValues.filters, {
        status: [__WEBPACK_IMPORTED_MODULE_11__constants__["c" /* PENDING */], __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* REVERSED */]].join(","),
        page: 1,
        limit: 10000,
        employee_id: ev.target.value,
        freight_complete: freightCompleteRestriction,
        customer_paid: true,
        shipped: true
      })).then(function (resp) {
        var newComms = {};
        resp.forEach(function (item) {
          newComms[item.id] = hasUnapprovedActiveRepair(item);
        });
        _this.props.change("commissions", newComms);
        _this.setState({ commissions: resp, commissionsLoading: false });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var options = this.props.employees.map(function (employee) {
        return {
          value: employee.id,
          text: employee.full_name
        };
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
        _extends({}, this.props, {
          disabled: !this.props.selectedEmployee || this.state.commissionsLoading === true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: "employee",
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
                options: options,
                label: "Employee",
                onChange: this.changeEmployee,
                required: true
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: "filters.filter",
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                label: "Filter",
                disabled: true
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
              { title: __WEBPACK_IMPORTED_MODULE_11__constants__["d" /* SEND_NOTIFICATION */] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_11__constants__["d" /* SEND_NOTIFICATION */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__constants__["d" /* SEND_NOTIFICATION */])
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CommissionsTable__["a" /* default */], {
            selectedCommissions: this.props.selectedCommissions,
            commissions: this.state.commissions,
            loading: this.state.commissionsLoading
          })
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  employees: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Array),
  initialValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  searchCommissions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedCommissions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  selectedEmployee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  change: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    selectedCommissions: selector(state, "commissions"),
    selectedEmployee: selector(state, "employee")
  };
}, function (dispatch) {
  return {
    searchCommissions: function searchCommissions(params) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["d" /* searchCommissions */])(params));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: formName
})(Form)));

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_containers_ModalLauncher__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PayAll__ = __webpack_require__(1271);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var PayAllCommissions = function (_ModalLauncher) {
  _inherits(PayAllCommissions, _ModalLauncher);

  function PayAllCommissions() {
    _classCallCheck(this, PayAllCommissions);

    return _possibleConstructorReturn(this, (PayAllCommissions.__proto__ || Object.getPrototypeOf(PayAllCommissions)).apply(this, arguments));
  }

  _createClass(PayAllCommissions, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "input-group-btn" },
        this.button(),
        ";"
      );
    }
  }]);

  return PayAllCommissions;
}(__WEBPACK_IMPORTED_MODULE_2__shared_containers_ModalLauncher__["a" /* default */]);

PayAllCommissions.defaultProps = {
  text: "Pay All",
  buttonClass: "btn-info"
};


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_decorators__["f" /* launchModal */])(function (open, close) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PayAll__["a" /* default */], { open: open, close: close });
}, PayAllCommissions));

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(1269);
/* unused harmony export PayAll */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var PayAll = function (_Component) {
  _inherits(PayAll, _Component);

  function PayAll() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PayAll);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PayAll.__proto__ || Object.getPrototypeOf(PayAll)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      employees: []
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PayAll, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.open) {
        this.updateEmployees();
      }
    }
  }, {
    key: "initialValues",
    value: function initialValues() {
      return { filters: this.props.filters, commissions: {} };
    }
  }, {
    key: "updateEmployees",
    value: function updateEmployees() {
      var _this2 = this;

      this.props.searchAllUsers({
        open_commission_users: true,
        commission_filter: this.props.filters.filter,
        page: 1,
        sort: "first_name",
        reverse: false,
        limit: 1000
      }).then(function (resp) {
        _this2.setState({ employees: resp });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          open = _props.open,
          close = _props.close,
          onSubmit = _props.onSubmit;
      var employees = this.state.employees;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
        { dialogClass: "modal-lg", open: open, close: close },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            { className: "modal-title" },
            "Pay All Commissions"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Form__["a" /* default */], {
          initialValues: this.initialValues(),
          employees: employees,
          close: close,
          onSubmit: onSubmit
        })
      );
    }
  }]);

  return PayAll;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PayAll.propTypes = {
  filters: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    filter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  }),
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  searchAllUsers: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    filters: state.commissions.get("filters").toJS()
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* payAllCommissions */])(data));
    },
    searchAllUsers: function searchAllUsers(params) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_actions__["i" /* searchAllUsers */])(params));
    }
  };
})(PayAll));

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(419);








var RowActions = function RowActions(_ref) {
  var commission = _ref.commission,
      setCommission = _ref.setCommission,
      setUpdateStatusModalOpen = _ref.setUpdateStatusModalOpen,
      setUpdateOverrideOpen = _ref.setUpdateOverrideOpen;

  var open = function open() {
    setUpdateStatusModalOpen(true);
    setCommission(commission);
  };

  var openOverrideForm = function openOverrideForm() {
    setUpdateOverrideOpen(true);
    setCommission(commission);
  };

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__hooks__["a" /* useCurrentUser */])();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["b" /* default */],
      { icon: "fa fa-fw fa-ellipsis-v", menuClass: "dropdown-menu-right" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["a" /* DropDownItem */],
        { onClick: open },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "pencil", fixed: true }),
        " Update Status"
      ),
      [__WEBPACK_IMPORTED_MODULE_5__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["m" /* ACCOUNTING */]].includes(currentUser.role) && commission.status !== __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* PAID */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["a" /* DropDownItem */],
        { onClick: openOverrideForm },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "pencil", fixed: true }),
        " Override"
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (RowActions);

RowActions.propTypes = {
  commission: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired
};

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PayAll_OpenPayAll__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_DateRangePicker_DateRangePicker__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Table__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pagination__ = __webpack_require__(420);
/* harmony export (immutable) */ __webpack_exports__["a"] = CommissionsSearch;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



















var defaultFilters = {
  current_user: undefined,
  status: undefined,
  depreciation_only: undefined,
  mro_only: undefined,
  customer_paid: undefined,
  sales_order_only: undefined,
  freight_not_complete: undefined
};

var filters = [{
  label: "Show All",
  filters: _extends({}, defaultFilters)
}, {
  label: "Show Comm. Paid",
  filters: { status: "paid" }
}, {
  label: "Show Comm. Pending",
  filters: { status: "pending,reversed" }
}, {
  label: "Show All Bad Debt",
  filters: { status: "bad_debt" }
}, {
  label: "Show Depreciation Only",
  filters: {
    sales_order_only: undefined,
    mro_only: undefined,
    depreciation_only: true
  }
}, {
  label: "No Depreciations",
  filters: {
    sales_order_only: undefined,
    depreciation_only: false
  }
}, {
  label: "Show MRs Only",
  filters: {
    sales_order_only: undefined,
    depreciation_only: undefined,
    mro_only: true
  }
}, {
  label: "Show SOs Only",
  filters: { depreciation_only: undefined, sales_order_only: true }
}, {
  label: "Show Customer Paid",
  filters: { customer_paid: true }
}, {
  label: "Show Customer Payment Pending",
  filters: { customer_paid: false, depreciation_only: undefined }
}, {
  label: "Show Freight Not Complete",
  filters: { freight_not_complete: true }
}];

var filterTags = [{
  label: "Commission Paid",
  key: "status",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_filters__["b" /* matchesString */])("paid")
}, {
  label: "Commission Pending",
  key: "status",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_filters__["b" /* matchesString */])("pending,reversed")
}, {
  label: "Commission Bad Debt",
  key: "status",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_filters__["b" /* matchesString */])("bad_debt")
}, {
  label: "Depreciation Only",
  key: "depreciation_only",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "No Depreciations",
  key: "depreciation_only",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Sales Order Only",
  key: "sales_order_only"
}, {
  label: "Customer Paid",
  key: "customer_paid",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Customer Payment Pending",
  key: "customer_paid",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Managed Repairs Only",
  key: "mro_only",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Show Freight Not Complete",
  key: "freight_not_complete",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_filters__["a" /* matchesBoolean */])(true)
}];

var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = searchProps.paginator.get("filters").toJS();
  var totalCount = searchProps.paginator.get("totalCount");

  params.total_count = totalCount;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        if (totalCount > __WEBPACK_IMPORTED_MODULE_14__users_constants__["_6" /* EXPORT_LIMIT */]) {
          __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].info("Processing Report.");
          __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].commissions.export(params).then(function () {
            return __WEBPACK_IMPORTED_MODULE_3__lib_submission__["a" /* SUCCESS */];
          });
        } else {
          window.open(__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* API_BASE */] + "/commissions/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_query_string__["stringify"])(params), "_blank");
          __WEBPACK_IMPORTED_MODULE_1_react_redux_toastr__["toastr"].success("Processing Commissions Report. Please wait for the PDF to generate.");
        }
      }
    },
    "Export"
  );
};

var meetsExportCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var searchProps = _ref2.searchProps;

  var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__hooks_useCurrentUser__["a" /* default */])();
  return searchProps.paginator.get("totalCount") <= 450 || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__users_helpers__["d" /* hasRole */])(user, __WEBPACK_IMPORTED_MODULE_14__users_constants__["i" /* ADMIN */]);
});

var DecoratedExportButton = meetsExportCriteria(ExportButton);

function CommissionsSearch() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_16__pagination__["a" /* default */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing any ref number, company name, seller name, serial #, part #, or commission paid date..."
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DecoratedExportButton, { searchProps: searchProps }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_DateRangePicker_DateRangePicker__["a" /* default */], searchProps),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, { filters: filters, right: true })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__shared_components__["b" /* Authorized */],
              { subroles: __WEBPACK_IMPORTED_MODULE_14__users_constants__["_2" /* ACCOUNTING_MANAGER */] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__PayAll_OpenPayAll__["a" /* default */], null)
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "Commission Report",
          filters: filterTags,
          aggregateField: "total_commission"
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UpdateStatusForm__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UpdateCommissionForm__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Row__ = __webpack_require__(636);
/* unused harmony export Table */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();











function Table(_ref) {
  var results = _ref.results,
      isLoading = _ref.isLoading,
      canEdit = _ref.canEdit,
      manager = _ref.manager;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      commission = _useState2[0],
      setCommission = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState4 = _slicedToArray(_useState3, 2),
      updateStatusModalOpen = _useState4[0],
      setUpdateStatusModalOpen = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState6 = _slicedToArray(_useState5, 2),
      updateOverride = _useState6[0],
      setUpdateOverrideOpen = _useState6[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    updateStatusModalOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["C" /* Modal */],
      {
        open: updateStatusModalOpen,
        close: function close() {
          return setUpdateStatusModalOpen(false);
        },
        dialogClass: "modal-sm"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["c" /* Close */], { close: function close() {
            return setUpdateStatusModalOpen(false);
          } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Update Commission Status"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UpdateStatusForm__["a" /* default */], {
        commission: commission,
        close: function close() {
          return setUpdateStatusModalOpen(false);
        },
        enableReinitialize: true
      })
    ),
    updateOverride && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["C" /* Modal */],
      {
        open: updateOverride,
        close: function close() {
          return setUpdateOverrideOpen(false);
        },
        dialogClass: "modal-sm"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["c" /* Close */], { close: function close() {
            return setUpdateOverrideOpen(false);
          } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Override Commission"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__UpdateCommissionForm__["a" /* default */], {
        commission: commission,
        close: function close() {
          return setUpdateOverrideOpen(false);
        },
        enableReinitialize: true
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */],
      { loading: isLoading },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */].Head,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Sale Date"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "SO #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Source"
        ),
        canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Employee"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Company Name"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Part #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Serial #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "CD"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Cost Ea."
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-center" },
          "QTY"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Sale Ea."
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Total Profit"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Seller"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Buyer"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Co-Buyer"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "3rd Buyer"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Cust PO #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Inv #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Cust. Paid"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Com. Paid"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Status"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "% Credit"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Sales Credit"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Profit Credit"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Commission"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-center" },
          "Frt Conf"
        ),
        canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */].Body,
        null,
        results.map(function (r) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Row__["a" /* default */], {
            key: r.id,
            commission: r,
            canEdit: canEdit,
            manager: manager,
            setUpdateStatusModalOpen: setUpdateStatusModalOpen,
            setUpdateOverrideOpen: setUpdateOverrideOpen,
            setCommission: setCommission
          });
        })
      )
    )
  );
}

Table.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  canEdit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  manager: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  var role = state.session.getIn([__WEBPACK_IMPORTED_MODULE_4__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_4__users_constants__["h" /* ROLE */]]);
  var subrole = state.session.getIn([__WEBPACK_IMPORTED_MODULE_4__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_4__users_constants__["C" /* SUBROLE */]]);

  return {
    canEdit: [__WEBPACK_IMPORTED_MODULE_4__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_4__users_constants__["p" /* QUALITY_CONTROL */]].includes(role) || role === __WEBPACK_IMPORTED_MODULE_4__users_constants__["m" /* ACCOUNTING */] && subrole === __WEBPACK_IMPORTED_MODULE_4__users_constants__["_2" /* ACCOUNTING_MANAGER */],
    manager: state.session.getIn(["user", "manager"]) || role === __WEBPACK_IMPORTED_MODULE_4__users_constants__["i" /* ADMIN */]
  };
})(Table));

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(263);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var FORM_NAME = "updateCommissionOverrideForm";

var UpdateStatusForm = function (_Component) {
  _inherits(UpdateStatusForm, _Component);

  function UpdateStatusForm() {
    _classCallCheck(this, UpdateStatusForm);

    return _possibleConstructorReturn(this, (UpdateStatusForm.__proto__ || Object.getPrototypeOf(UpdateStatusForm)).apply(this, arguments));
  }

  _createClass(UpdateStatusForm, [{
    key: "render",
    value: function render() {
      var close = this.props.close;


      var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["a" /* useCurrentUser */])();

      if (![__WEBPACK_IMPORTED_MODULE_6__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_6__users_constants__["m" /* ACCOUNTING */]].includes(currentUser.role)) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */],
          this.props,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["f" /* CurrencyField */], {
              inputProps: {
                min: undefined
              },
              name: "overridden_value",
              label: "Override Commission"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["i" /* Button */],
              { onClick: close },
              "Cancel"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["i" /* Button */],
              { type: "submit", bsStyle: "primary" },
              "Save"
            )
          )
        )
      );
    }
  }]);

  return UpdateStatusForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

UpdateStatusForm.propTypes = {
  commission: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }).isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  errorMessages: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  submitFailed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  update: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_7__actions__["b" /* update */](ownProps.commission.id, data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME
})(UpdateStatusForm)));

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(263);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var FORM_NAME = "updateCommissionForm";

var statusOptions = [{ value: "paid", text: "Commission Paid" }, { value: "bad_debt", text: "Bad Debt" }, { value: "reversed", text: "Reversed" }];

var UpdateStatusForm = function (_React$Component) {
  _inherits(UpdateStatusForm, _React$Component);

  function UpdateStatusForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UpdateStatusForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UpdateStatusForm.__proto__ || Object.getPrototypeOf(UpdateStatusForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      status: "paid"
    }, _this.handleSelectChange = function (e) {
      _this.setState({ status: e.target.value });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UpdateStatusForm, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          commission = _props.commission,
          close = _props.close;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */],
          this.props,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              { className: "control-label", htmlFor: "status" },
              "Status"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: "status",
              component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["c" /* Select */],
              options: statusOptions.filter(function (val) {
                return (commission.adjustment_type === "neg_depreciation" || val.value !== "paid" && !commission.invoice_paid_date || commission.invoice_paid_date) && (commission.status === __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* PAID */] && val.value === __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* REVERSED */] || val.value !== __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* REVERSED */]);
              })
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
              { onClick: close },
              "Cancel"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
              { type: "submit", bsStyle: "primary" },
              "Save"
            )
          )
        )
      );
    }
  }]);

  return UpdateStatusForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

UpdateStatusForm.propTypes = {
  commission: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }).isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  errorMessages: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  submitFailed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  update: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_7__actions__["b" /* update */](ownProps.commission.id, data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME
})(UpdateStatusForm)));

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_number__ = __webpack_require__(72);
/* harmony export (immutable) */ __webpack_exports__["a"] = ConsignmentDetailsTable;







function ConsignmentDetailsTable(_ref) {
  var consignment = _ref.consignment;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components__["X" /* Section */],
    { title: "Details", editable: false },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components__["W" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Total Sold",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(consignment, "total_sold"))
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Consignor Percentage",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_number__["a" /* percent */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(consignment, "consignor_percentage"), 100)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Total Paid To Consignor",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(consignment, "total_paid"))
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Profit From Consignment",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(consignment, "profit"))
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Total Line Items Remaining",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(consignment, "total_line_items_remaining")
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Total Quantity Remaining",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(consignment, "total_qty_remaining")
      })
    )
  );
}

ConsignmentDetailsTable.propTypes = {
  consignment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    tag_date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    serial_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MistakeShipments_constants__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_DashedSeparator__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DetailsTable__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Inventories__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ConsignmentDetailTable__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pagination__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components_ActionDropDown_ActionDropDown__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ImportConsignments_ImportConsignments__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__LineItemsTable__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions__ = __webpack_require__(317);



















function Detail(_ref) {
  var consignment = _ref.consignment,
      inventorySearch = _ref.inventorySearch,
      lineItemSearch = _ref.lineItemSearch;

  var parsedConsignment = consignment.toJS();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "page-header page-header-bar" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h1",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "btn-group pull-right", style: { marginLeft: 20 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14__shared_components_ActionDropDown_ActionDropDown__["a" /* default */],
            {
              menuClass: "dropdown-menu-right",
              style: { cursor: "pointer" }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ImportConsignments_ImportConsignments__["a" /* default */], { consignment: consignment.toJS() })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "with-padding" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["J" /* RecordPager */], { baseUrl: "/consignments", record: consignment }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "header-content" },
            consignment.get(__WEBPACK_IMPORTED_MODULE_7__Receiving_constants__["F" /* CONSIGNMENT_REFERENCE */])
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["E" /* ClipboardCopy */], {
            name: consignment.get(__WEBPACK_IMPORTED_MODULE_7__Receiving_constants__["F" /* CONSIGNMENT_REFERENCE */]),
            type: "Consignment"
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "panel panel-default" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "panel-body" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__DetailsTable__["a" /* DetailsTable */], { consignment: parsedConsignment }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ConsignmentDetailTable__["a" /* ConsignmentDetailsTable */], { consignment: parsedConsignment }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DashedSeparator__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["z" /* AuditFields */], { record: consignment, multiLine: true })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
      { md: 9 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__LineItemsTable__["a" /* default */], { consignment: consignment, search: lineItemSearch }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Inventories__["a" /* default */], { consignment: consignment, search: inventorySearch }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["M" /* Notes */], {
        resource: consignment,
        resourceType: __WEBPACK_IMPORTED_MODULE_8__shared_types_resourceTypes__["a" /* default */].consignment,
        resourceKey: "consignment"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["N" /* Attachments */], {
        multiple: true,
        resource: consignment,
        resourceType: __WEBPACK_IMPORTED_MODULE_8__shared_types_resourceTypes__["a" /* default */].consignment,
        resourceKey: "consignment",
        attachmentTypes: __WEBPACK_IMPORTED_MODULE_4__MistakeShipments_constants__["a" /* ATTACHMENT_TYPES */]
      })
    )
  );
}

Detail.propTypes = {
  consignment: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Map)
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    consignment: state.consignmentDetail.get("consignment")
  };
}, function (dispatch) {
  return {
    inventorySearch: function inventorySearch(val) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_13__pagination__["b" /* consignmentInventoriesPagination */].setFilter("filter", val));
    },
    lineItemSearch: function lineItemSearch(val) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_13__pagination__["c" /* consignmentLineItemsPagination */].setFilter("filter", val));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_decorators__["h" /* loadRecord */])({
  reducer: "consignmentDetail",
  name: "consignment",
  action: __WEBPACK_IMPORTED_MODULE_17__actions__["b" /* show */]
})(Detail)));

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EditConsignment_Form__ = __webpack_require__(1280);
/* harmony export (immutable) */ __webpack_exports__["a"] = DetailsTable;













function DetailsTable(_ref) {
  var consignment = _ref.consignment;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components__["X" /* Section */],
    {
      title: "Details",
      editable: true,
      modal: {
        title: "Edit Consignment",
        content: function content(close) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__EditConsignment_Form__["a" /* default */], {
            initialValues: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_pojos__["a" /* default */])(consignment).pick(__WEBPACK_IMPORTED_MODULE_8__users_constants__["x" /* BUYER_ID */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["z" /* CO_BUYER_ID */], __WEBPACK_IMPORTED_MODULE_10__constants__["_73" /* CONSIGNOR_PERCENTAGE */], __WEBPACK_IMPORTED_MODULE_7__PurchaseOrders_constants__["g" /* BUYING_STORE_ID */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["_64" /* STORE_OWNER_ID */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["_27" /* STORE_LOCATION_ID */], __WEBPACK_IMPORTED_MODULE_10__constants__["M" /* PAYMENT_TERMS */]),
            buyer: consignment.buyer,
            coBuyer: consignment.co_buyer,
            company: consignment.company,
            close: close
          });
        }
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components__["W" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "Buyer", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(consignment, "buyer.full_name") }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Co Buyer",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(consignment, "co_buyer.full_name")
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "Company Code", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(consignment, "company.code") }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Company Name",
        value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],
          { to: "/companies/" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(consignment, "company.uuid") },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(consignment, "company.name")
        )
      }),
      " ",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "Company Name", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(consignment, "company.name") }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Company Phone",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(consignment, "company.phone")
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Payment Terms",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_4__companies_constants__["i" /* VENDOR_TERMS */], consignment.payment_terms + ".label")
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Store Owner",
        value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["o" /* LocationFlag */], { location: consignment.store_owner_id })
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Store Location",
        value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["o" /* LocationFlag */], { location: consignment.store_location_id })
      })
    )
  );
}

DetailsTable.propTypes = {
  consignment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    tag_date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    serial_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Locations_components_BuyingStoreRadioField__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_PaymentTerms_PaymentTerms__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hooks__ = __webpack_require__(38);
/* unused harmony export Form */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

















function Form(props) {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.buyer),
      _useState2 = _slicedToArray(_useState, 2),
      selectedBuyer = _useState2[0],
      _setSelectedBuyer = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.coBuyer),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedCoBuyer = _useState4[0],
      _setSelectedCoBuyer = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.company),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedCompany = _useState6[0],
      _setSelectedCompany = _useState6[1];

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__hooks__["a" /* useCurrentUser */])();
  var isAdmin = currentUser && currentUser.role === __WEBPACK_IMPORTED_MODULE_8__users_constants__["i" /* ADMIN */];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_8__users_constants__["x" /* BUYER_ID */],
            label: "Buyer",
            placeholder: "Search by name...",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["n" /* AutoCompleteField */],
            search: props.searchBuyers,
            selectedItem: selectedBuyer,
            formatItem: function formatItem(result) {
              return result && result.full_name;
            },
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_8__users_constants__["z" /* CO_BUYER_ID */],
            label: "Co Buyer",
            placeholder: "Search by name...",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["n" /* AutoCompleteField */],
            search: props.searchBuyers,
            selectedItem: selectedCoBuyer,
            formatItem: function formatItem(result) {
              return result && result.full_name;
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_9__constants__["N" /* COMPANY_ID */],
            label: "Company",
            placeholder: "Search by name...",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["n" /* AutoCompleteField */],
            search: props.searchCompanies,
            selectedItem: selectedCompany,
            formatItem: function formatItem(result) {
              return result && result.name;
            },
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Locations_components_BuyingStoreRadioField__["a" /* default */], { name: __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["_64" /* STORE_OWNER_ID */], label: "Store Owner" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Locations_components_BuyingStoreRadioField__["a" /* default */], {
            name: __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["_27" /* STORE_LOCATION_ID */],
            label: "Store Location"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components_PaymentTerms_PaymentTerms__["a" /* default */], { getInitialFieldValue: props.getInitialFieldValue })
        ),
        isAdmin && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_9__constants__["_73" /* CONSIGNOR_PERCENTAGE */],
            label: "Consignor / EMA %",
            placeholder: "Enter percentage",
            type: "number",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */]
          })
        )
      )
    )
  );
}

Form.propTypes = {
  isLastExchange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nonAccountingUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["c" /* update */](data));
    },
    searchCompanies: function searchCompanies(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["d" /* searchCompanies */](filter));
    },
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["e" /* searchBuyers */](filter));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: "editConsignmentForm"
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_decorators_withFieldAccessors__ = __webpack_require__(48);










var formName = "importConsignments";

function Form(props) {
  var fileLink = "https://info-trader-assets.s3.us-east-2.amazonaws.com/public/InfoTrader_Consignment_Import_Template_v3.csv";
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components__["n" /* Warning */],
          null,
          "Please use the following column headers for the Consignment import:",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "part_number"
          ),
          " (required field: unique identifier for the part).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "serial"
          ),
          " (optional field).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "cond"
          ),
          " (required field: acceptable codes: NE, OH, SV, BT, SV TOOLING, AR, BR. Uppercase or lowercase).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "qty"
          ),
          " (required field: quantity).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "tag_date"
          ),
          " (optional field: can be left blank).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "tagged_by"
          ),
          " (optional field: free text).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "trace_to"
          ),
          " (optional field: maximum of 20 characters; free text).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "trace_type"
          ),
          " (optional field: free text).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "dom"
          ),
          " (optional field: can be left blank).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "wh"
          ),
          " (optional field: can be left blank).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "location"
          ),
          " (optional field: can be left blank).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "note"
          ),
          " (optional field: free text).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          "Ensure the import file is in .csv format."
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "file",
            component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["k" /* FileInput */],
            label: "Upload Attachment",
            required: true
          })
        )
      ),
      fileLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 8, mdOffset: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { href: fileLink, target: "_blank", rel: "noopener noreferrer" },
            "Template"
          )
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["f" /* importLineItems */])(data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["j" /* form */])({
  form: formName
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(1281);
/* harmony export (immutable) */ __webpack_exports__["a"] = ImportConsignments;








function ImportConsignments(_ref) {
  var consignment = _ref.consignment;

  var title = __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(consignment, "consignment_type") === "ema" ? "Import EMA" : "Import Consignment";

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components__["l" /* DropDownItem */],
        { onClick: open },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "shopping-cart", fixed: true }),
        "\xA0",
        title,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
          { open: visible, close: close, dialogClass: "modal-sm" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              title
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Form__["a" /* default */], { close: close, enableReinitialize: true, consignment: consignment })
        )
      );
    }
  );
}

ImportConsignments.propTypes = {
  consignment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IncomingQuotes_shared_AsIsFlag__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Receiving_constants__ = __webpack_require__(34);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var paginatorList = "consignments/inventories";
var ReceivedIcon = function ReceivedIcon(_ref) {
  var quantityReceived = _ref.quantity_received,
      quantity = _ref.quantity;

  if (quantityReceived === quantity) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["U" /* IconReceived */], null);
  }
  return null;
};

ReceivedIcon.propTypes = {
  quantity_received: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  quantity: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
};

var LineItemsTable = function (_Component) {
  _inherits(LineItemsTable, _Component);

  function LineItemsTable() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, LineItemsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = LineItemsTable.__proto__ || Object.getPrototypeOf(LineItemsTable)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      addPartModalOpen: false,
      editPartModalOpen: false,
      searchValue: ""
    }, _this.openEditPartModal = function (lineItem) {
      return _this.setState({
        editPartModalOpen: true,
        selectedLineItem: lineItem
      });
    }, _this.closeEditPartModal = function () {
      return _this.setState({ editPartModalOpen: false });
    }, _this.handleSearchValueChange = function (value) {
      _this.setState({ searchValue: value });
    }, _this.renderRow = function (r, idx) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        {
          key: r.id,
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("clickable", { "text-muted": r.cancelled }),
          onClick: function onClick() {
            return !r.cancelled && _this.openEditPartModal(r);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { whiteSpace: "nowrap" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { textAlign: "right" } },
              idx + 1
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["h" /* PartNumber */], { part: r.part })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.serial_number === "Various" || !r.serial_number && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["isEmpty"])(r.expected_serial_number) ? r.serial_number || r.expected_serial_number : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
            { to: "/inventories/" + r.uuid },
            r.serial_number
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.alternate && (r.alternate.alternate_part_id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["h" /* PartNumber */], {
            part: {
              id: r.alternate.alternate_part_id,
              part_number: r.alternate.name
            }
          }) : r.alternate.name)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.traced_to
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_date__["d" /* alphaMonthYear */])(r.tag_date)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.tagged_by
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          r.lead_time
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_12__Receiving_constants__["x" /* CONDITION_TYPES */][r.condition].label,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__IncomingQuotes_shared_AsIsFlag__["a" /* AsIsFlag */], { lineItem: r, className: "m-l-5" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          r.quantity
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center td-shrink-icon" },
          (r.internal_note || r.external_note) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
            note: [r.internal_note, r.external_note].filter(function (n) {
              return n !== null && n !== "";
            }).join(" | "),
            className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ "link-muted": r.cancelled })
          })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LineItemsTable, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          results = _props.results,
          isLoading = _props.isLoading,
          search = _props.search;
      var searchValue = this.state.searchValue;


      var display = results.length >= 15 || searchValue ? "inline-block" : "none";
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          { style: { marginTop: 26 } },
          "Parts"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { paddingBottom: "10px", display: display, width: "100%" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["t" /* SearchFilter */], {
            onSubmit: search,
            onValueChange: this.handleSearchValueChange,
            placeholder: "Search by Part Number"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Mini,
          { loading: isLoading, numbered: true, noMargin: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Part #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Serial #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Buy As Alt"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Trace To"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tag Date"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tagged By"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["_78" /* LEAD_TIME_LABEL */]
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Condition"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Qty"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-center" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-center" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Body,
            null,
            results.map(this.renderRow)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "nav",
          {
            className: "text-center margin-top-none",
            "aria-label": "Search results pages"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__["Paginator"], { listId: paginatorList })
        )
      );
    }
  }]);

  return LineItemsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LineItemsTable.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object)).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};


var withListId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_decorators__["d" /* translateProps */])(function () {
  return {
    listId: "consignments/inventories"
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withListId(__WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__["decorators"].tabulate(LineItemsTable)));

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IncomingQuotes_shared_AsIsFlag__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Receiving_constants__ = __webpack_require__(34);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var paginatorList = "consignments/lineItems";
var ReceivedIcon = function ReceivedIcon(_ref) {
  var quantityReceived = _ref.quantity_received,
      quantity = _ref.quantity;

  if (quantityReceived === quantity) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["U" /* IconReceived */], null);
  }
  return null;
};

ReceivedIcon.propTypes = {
  quantity_received: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  quantity: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
};

var LineItemsTable = function (_Component) {
  _inherits(LineItemsTable, _Component);

  function LineItemsTable() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, LineItemsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = LineItemsTable.__proto__ || Object.getPrototypeOf(LineItemsTable)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      addPartModalOpen: false,
      editPartModalOpen: false,
      searchValue: ""
    }, _this.openEditPartModal = function (lineItem) {
      return _this.setState({
        editPartModalOpen: true,
        selectedLineItem: lineItem
      });
    }, _this.closeEditPartModal = function () {
      return _this.setState({ editPartModalOpen: false });
    }, _this.handleSearchValueChange = function (value) {
      _this.setState({ searchValue: value });
    }, _this.renderRow = function (r, idx) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        {
          key: r.id,
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("clickable", { "text-muted": r.cancelled }),
          onClick: function onClick() {
            return !r.cancelled && _this.openEditPartModal(r);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { whiteSpace: "nowrap" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { textAlign: "right" } },
              idx + 1
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["h" /* PartNumber */], { part: r.part })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !r.uuid || !r.serial_number && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["isEmpty"])(r.expected_serial_number) ? r.serial_number || r.expected_serial_number : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
            { to: "/inventories/" + r.uuid },
            r.serial_number
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.alternate && (r.alternate.alternate_part_id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["h" /* PartNumber */], {
            part: {
              id: r.alternate.alternate_part_id,
              part_number: r.alternate.name
            }
          }) : r.alternate.name)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.traced_to
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_date__["d" /* alphaMonthYear */])(r.tag_date)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.tagged_by
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          r.lead_time
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_12__Receiving_constants__["x" /* CONDITION_TYPES */][r.condition].label,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__IncomingQuotes_shared_AsIsFlag__["a" /* AsIsFlag */], { lineItem: r, className: "m-l-5" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          r.quantity
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center td-shrink-icon" },
          (r.internal_note || r.external_note) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
            note: [r.internal_note, r.external_note].filter(function (n) {
              return n !== null && n !== "";
            }).join(" | "),
            className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ "link-muted": r.cancelled })
          })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LineItemsTable, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          results = _props.results,
          isLoading = _props.isLoading,
          search = _props.search;
      var searchValue = this.state.searchValue;


      var display = results.length >= 15 || searchValue ? "inline-block" : "none";

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          { style: { marginTop: 26 } },
          "Parts"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { paddingBottom: "10px", display: display, width: "100%" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["t" /* SearchFilter */], {
            onSubmit: search,
            onValueChange: this.handleSearchValueChange,
            placeholder: "Search by Part Number"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Mini,
          { loading: isLoading, numbered: true, noMargin: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Part #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Serial #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Buy As Alt"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Trace To"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tag Date"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tagged By"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["_78" /* LEAD_TIME_LABEL */]
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Condition"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Qty"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-center" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-center" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Body,
            null,
            results.map(this.renderRow)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "nav",
          {
            className: "text-center margin-top-none",
            "aria-label": "Search results pages"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__["Paginator"], { listId: paginatorList })
        )
      );
    }
  }]);

  return LineItemsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LineItemsTable.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object)).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};


var withListId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_decorators__["d" /* translateProps */])(function () {
  return {
    listId: "consignments/lineItems"
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withListId(__WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__["decorators"].tabulate(LineItemsTable)));

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Create_CreateButton__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Table__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pagination__ = __webpack_require__(421);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




















var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = searchProps.paginator.get("filters").toJS();
  var totalCount = searchProps.paginator.get("totalCount");

  params.total_count = totalCount;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        if (totalCount > __WEBPACK_IMPORTED_MODULE_8__users_constants__["_6" /* EXPORT_LIMIT */]) {
          __WEBPACK_IMPORTED_MODULE_13_react_redux_toastr__["toastr"].info("Processing", "Please check your notifications for completion.");
          __WEBPACK_IMPORTED_MODULE_14__api__["a" /* default */].consignments.export(params).then(function () {
            return __WEBPACK_IMPORTED_MODULE_15__lib_submission__["a" /* SUCCESS */];
          });
        } else {
          window.open(__WEBPACK_IMPORTED_MODULE_11__constants__["d" /* API_BASE */] + "/consignments/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_query_string__["stringify"])(params), "_blank");
          __WEBPACK_IMPORTED_MODULE_13_react_redux_toastr__["toastr"].success("Processing Consignments Report. Please wait for the PDF to generate.");
        }
      }
    },
    "Export"
  );
};

var meetsExportCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shared_decorators__["a" /* renderIf */])(function () {
  var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__hooks_useCurrentUser__["a" /* default */])();
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__users_helpers__["d" /* hasRole */])(user, __WEBPACK_IMPORTED_MODULE_8__users_constants__["i" /* ADMIN */]);
});

var DecoratedExportButton = meetsExportCriteria(ExportButton);

function ConsignmentsSearch(_ref2) {
  var pushHistory = _ref2.pushHistory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_17__pagination__["a" /* consignmentsPagination */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a company name or consignment reference",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/consignments/" + r.uuid);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DecoratedExportButton, { searchProps: searchProps }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Create_CreateButton__["a" /* default */], null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Consignments / EMA"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

ConsignmentsSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_1_react_router_redux__["push"] })(ConsignmentsSearch));

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);





var ConsignmentOrEmaRadioField = function ConsignmentOrEmaRadioField(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? "Consignment or EMA" : _ref$label,
      _ref$name = _ref.name,
      name = _ref$name === undefined ? "consignment_type" : _ref$name,
      _ref$required = _ref.required,
      required = _ref$required === undefined ? true : _ref$required,
      _ref$options = _ref.options,
      options = _ref$options === undefined ? [{ value: "consignment", text: "Consignment" }, { value: "ema", text: "EMA" }] : _ref$options;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
    disabled: disabled,
    name: name,
    label: label,
    component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["m" /* RadioGroupField */],
    options: options,
    required: required
  });
};

ConsignmentOrEmaRadioField.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }))
};

/* harmony default export */ __webpack_exports__["a"] = (ConsignmentOrEmaRadioField);

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(1289);
/* harmony export (immutable) */ __webpack_exports__["a"] = CreateConsignment;






function CreateConsignment(_ref) {
  var open = _ref.open,
      close = _ref.close;

  var locationId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hooks__["a" /* useCurrentUser */])().location_id;

  var initialValues = {
    request_vendor_approval: false,
    request_shop_approval: false,
    same_as_billing: true,
    store_owner_id: locationId,
    store_location_id: locationId
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-lg" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Create a Consignment"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], { close: close, initialValues: initialValues })
    )
  );
}

CreateConsignment.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Create__ = __webpack_require__(1287);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_decorators__["j" /* createNew */])(function (open, close) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Create__["a" /* default */], { open: open, close: close });
}));

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_AutoCompleteField_AutoCompleteField__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Locations_components_BuyingStoreRadioField__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PurchaseOrders_shared_CoBuyersFields_BuyerField__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ConsignmentOrEmaRadioField__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__validate__ = __webpack_require__(1290);
/* unused harmony export Form */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();






















function Form(props) {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedConsignmentBuyer = _useState2[0],
      setSelectedConsignmentBuyer = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedConsignmentCoBuyer = _useState4[0],
      setSelectedConsignmentCoBuyer = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedConsignor = _useState6[0],
      setSelectedConsignor = _useState6[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_8__Receiving_constants__["F" /* CONSIGNMENT_REFERENCE */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: "Create Ref #",
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ConsignmentOrEmaRadioField__["a" /* default */], null)
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_8__Receiving_constants__["v" /* CONSIGNMENT_REFERENCE_COMPANY_ID */],
            label: "Consignment Ref Co.",
            placeholder: "Search by a company's name",
            component: __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_AutoCompleteField_AutoCompleteField__["a" /* default */],
            onItemSelected: function onItemSelected(item) {
              return setSelectedConsignor(item);
            },
            search: props.searchCompanies,
            selectedItem: selectedConsignor,
            formatItem: function formatItem(result) {
              return result && result.name;
            },
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["h" /* FormGroup */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              label: "Consignor %",
              name: __WEBPACK_IMPORTED_MODULE_8__Receiving_constants__["I" /* CONSIGNOR_PERCENTAGE */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              type: "number",
              inputProps: {
                min: 0,
                max: 100
              },
              required: true
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["h" /* FormGroup */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__PurchaseOrders_shared_CoBuyersFields_BuyerField__["a" /* default */], {
              label: "Cons. Buyer Credit",
              name: __WEBPACK_IMPORTED_MODULE_11__users_constants__["x" /* BUYER_ID */],
              searchBuyers: props.searchBuyers,
              selectedBuyer: selectedConsignmentBuyer,
              onItemSelected: function onItemSelected(item) {
                return setSelectedConsignmentBuyer(item);
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["h" /* FormGroup */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__PurchaseOrders_shared_CoBuyersFields_BuyerField__["a" /* default */], {
              label: "Cons. Co Buyer Credit",
              name: __WEBPACK_IMPORTED_MODULE_11__users_constants__["z" /* CO_BUYER_ID */],
              required: false,
              searchBuyers: props.searchBuyers,
              selectedBuyer: selectedConsignmentCoBuyer,
              onItemSelected: function onItemSelected(item) {
                return setSelectedConsignmentCoBuyer(item);
              }
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Locations_components_BuyingStoreRadioField__["a" /* default */], {
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["_73" /* STORE_OWNER */]),
            name: __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["_64" /* STORE_OWNER_ID */],
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Locations_components_BuyingStoreRadioField__["a" /* default */], {
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["_74" /* STORE_LOCATION */]),
            name: __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["_27" /* STORE_LOCATION_ID */],
            required: true
          })
        )
      )
    )
  );
}

Form.propTypes = {
  country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var FORM_NAME = "createConsignment";

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["formValueSelector"])(FORM_NAME);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_11__users_constants__["a" /* USER */]),
    condition: selector(state, __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["n" /* CONDITION */])
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* create */](data));
    },
    queryParts: function queryParts(filter) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__parts_actions__["n" /* searchParts */])(filter));
    },
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_actions__["c" /* searchBuyers */](filter));
    },
    searchCompanies: function searchCompanies(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_actions__["a" /* searchCompanies */](filter));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_19__validate__["a" /* default */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventories_constants__ = __webpack_require__(12);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;





function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_2__Receiving_constants__["v" /* CONSIGNMENT_REFERENCE_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__["F" /* CONSIGNMENT_REFERENCE */], __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__["I" /* CONSIGNOR_PERCENTAGE */], __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__["G" /* CONSIGNMENT_BUYER_ID */], __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["_27" /* STORE_LOCATION_ID */], __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["_64" /* STORE_OWNER_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom__ = __webpack_require__(36);













function renderRow(r, pushHistory) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      className: "clickable",
      onClick: function onClick() {
        return pushHistory("/consignments/" + r.uuid);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["b" /* shortDate */])(r.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_router_dom__["a" /* Link */],
        { to: "/companies/" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["get"])(r, "company.uuid") },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["get"])(r, "company.name")
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_router_dom__["a" /* Link */],
        { to: "/consignments/" + r.uuid },
        r.consignment_reference
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_number__["a" /* percent */])(Number(r.consignor_percentage), 100)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["get"])(r, "buyer.full_name")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(r.total_sold)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(r.total_paid)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(r.profit)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      r.consignments_cancelled
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_number__["a" /* percent */])(r.total_realized, r.total_purchases)
    )
  );
}

function Table(_ref) {
  var isLoading = _ref.isLoading,
      pageActions = _ref.pageActions,
      pushHistory = _ref.pushHistory,
      results = _ref.results;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Row */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */],
          { loading: isLoading, refresh: pageActions.expire },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Created At"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Consignor"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Cons / EMA Ref #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Consignor / EMA Perc (%)"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Manager"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Total Sold"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Total Paid To Cons / EMA"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Total Earned"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Total Canceled"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Body,
            null,
            results.map(function (r) {
              return renderRow(r, pushHistory);
            })
          )
        )
      )
    )
  );
}

Table.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_10_react_router_redux__["push"] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["b" /* default */])(Table)));

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCELLATION_REASONS; });
var CANCELLATION_REASONS = [{
  value: "consignor_needed_for_own_use",
  text: "Consignor Needed For Own Use"
}, { value: "consignor_sold", text: "Consignor Sold" }, { value: "consignor_grew_impatient", text: "Consignor Grew Impatient" }, { value: "consignment_cancelled_by_us", text: "Consignment Cancelled By Us" }, { value: "unknown", text: "Unknown/Other" }];

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_reducer__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__ = __webpack_require__(58);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  consignment: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  inventories: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()
}).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["a" /* notesInitialState */]).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["b" /* attachmentsInitialState */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _extends(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* SET */], function (state, action) {
  return state.merge({ consignment: action.consignment });
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["c" /* createAttachmentReducer */])(__WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].consignment), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["d" /* createNoteReducer */])(__WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].consignment))));

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RMAsAndWarranties_actions__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RMAsAndWarranties_constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RMAsAndWarranties_components_Detail_Actions_PrintRma__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RMAsAndWarranties_decorators__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Send_Send__ = __webpack_require__(1297);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var CUSTOMER_PDF_TYPES = ["credit", "warranty", "credit_warranty"];

var Actions = function (_React$Component) {
  _inherits(Actions, _React$Component);

  function Actions() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Actions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Actions.__proto__ || Object.getPrototypeOf(Actions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      cancelModalOpen: false
    }, _this.openModal = function () {
      return _this.setState({ cancelModalOpen: true });
    }, _this.closeModal = function () {
      return _this.setState({ cancelModalOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Actions, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          cancel = _props.cancel,
          rma = _props.rma;
      var cancelModalOpen = this.state.cancelModalOpen;


      var displayCancel = !rma.get(__WEBPACK_IMPORTED_MODULE_6__constants__["_38" /* CANCELLED */]) && !rma.get("closed_date") && !rma.get(__WEBPACK_IMPORTED_MODULE_6__constants__["_26" /* RECEIVED */]) && (rma.get(__WEBPACK_IMPORTED_MODULE_6__constants__["p" /* TYPE */]) !== "CustomerRma" || !rma.get(__WEBPACK_IMPORTED_MODULE_7__RMAsAndWarranties_constants__["u" /* CREDIT_ISSUED */]));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "btn-group pull-right", style: { marginLeft: 20 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components__["Y" /* ActionDropDown */],
            { menuClass: "dropdown-menu-right" },
            CUSTOMER_PDF_TYPES.map(function (t) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Send_Send__["a" /* default */], { type: t });
            }),
            CUSTOMER_PDF_TYPES.map(function (t) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__RMAsAndWarranties_components_Detail_Actions_PrintRma__["a" /* default */], { pdfType: t });
            }),
            displayCancel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__shared_components__["l" /* DropDownItem */],
              { onClick: this.openModal },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
              "\xA0Cancel RMA"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components__["i" /* ConfirmAction */],
          {
            onConfirm: cancel,
            open: cancelModalOpen,
            close: this.closeModal,
            icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" }),
            btnText: "Yes, Cancel RMA"
          },
          "Are you sure you want to cancel this RMA?"
        )
      );
    }
  }]);

  return Actions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Actions.propTypes = {
  cancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map).isRequired
};

var connectedActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    cancel: function cancel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RMAsAndWarranties_actions__["d" /* cancelCustomerRma */])());
    }
  };
})(Actions);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__RMAsAndWarranties_decorators__["a" /* withRma */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var rma = _ref2.rma;
  return !rma.get(__WEBPACK_IMPORTED_MODULE_6__constants__["_38" /* CANCELLED */]);
})(connectedActions)));

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* unused harmony export submitButton */
/* unused harmony export Form */
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }













var FORM_NAME = "sendCustomerRmaForm";

var submitButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  "span",
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["k" /* Icon */], { name: "envelope" }),
  " Yes, Send RMA"
);

function Form(_ref) {
  var close = _ref.close,
      handleSubmit = _ref.handleSubmit,
      modal = _ref.modal;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */],
    {
      handleSubmit: handleSubmit,
      modal: modal,
      close: close,
      buttonText: submitButton
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], name: "to", label: "To:", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], name: "cc", label: "CC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], name: "bcc", label: "BCC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], name: "subject", label: "Subject", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["l" /* TextArea */], name: "body", label: "Body", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
        component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
        name: "type",
        type: "hidden",
        style: { height: 0 }
      })
    )
  );
}

Form.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  modal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state, props) {
  return {
    initialValues: {
      body: "Please find attached " + props.rma.company.name + "'s Return Material Authorization #" + props.rma.code + ".\n\nPlease confirm receipt of this RMA.  Please provide an Airway Bill No. when available.\n\nPLEASE DO NOT INSURE.\n\nThank you for putting trust in " + props.currentUser.tenant.name + ".\n      ",
      cc: props.rma.contact.email,
      subject: props.rma.company.name + " " + props.rma.code,
      type: props.type
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: function validate(values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_validate_this__["a" /* validator */])(values, function (f) {
      f.validate("body", "to").satisfies(__WEBPACK_IMPORTED_MODULE_6__lib_validation_rules__["a" /* required */]);
      f.validate("to", "cc", "bcc").satisfies(__WEBPACK_IMPORTED_MODULE_6__lib_validation_rules__["b" /* isValidEmail */]);
    });
  },
  onSubmit: function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data, _ev, props) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].customerRmas.send(props.rma.id, data).then(function () {
                props.close();
                __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].success("Success", "Documents successfully sent.");
              }).catch(function () {
                return __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Error", "Could not send documents. Please refresh page and try again.");
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function onSubmit(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }()
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RMAsAndWarranties_components_Detail_Actions_PrintRma__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(1295);






function SendModal(_ref) {
  var open = _ref.open,
      close = _ref.close,
      rma = _ref.rma,
      type = _ref.type;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hooks__["a" /* useCurrentUser */])();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Send Request For ",
        __WEBPACK_IMPORTED_MODULE_3__RMAsAndWarranties_components_Detail_Actions_PrintRma__["b" /* PDF_TYPES */][type].label
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], { close: close, currentUser: currentUser, rma: rma, type: type })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (SendModal);

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RMAsAndWarranties_decorators__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RMAsAndWarranties_components_Detail_Actions_PrintRma__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modal__ = __webpack_require__(1296);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









function Send(_ref) {
  var rma = _ref.rma,
      type = _ref.type;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      sendModalVisible = _useState2[0],
      setSendModalIsVisible = _useState2[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setSendModalIsVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["k" /* Icon */], { name: "envelope", fixed: true }),
    "\xA0",
    __WEBPACK_IMPORTED_MODULE_5__RMAsAndWarranties_components_Detail_Actions_PrintRma__["b" /* PDF_TYPES */][type].label,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modal__["a" /* default */], {
      open: sendModalVisible,
      close: function close() {
        return setSendModalIsVisible(false);
      },
      rma: rma.toJS(),
      type: type
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__session_decorators_withCurrentUser__["b" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RMAsAndWarranties_decorators__["a" /* withRma */])(Send)));

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Table__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pagination__ = __webpack_require__(638);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



















var filters = [{
  label: "Only Mine",
  filters: { current_user: true }
}, {
  label: "All",
  filters: { current_user: undefined }
}, {
  label: "Open Warranty Requests",
  filters: { open_warranty_consideration: true }
}, {
  label: "Closed Warranty Requests",
  filters: { open_warranty_consideration: false }
}, {
  label: "Cancelled RMAs",
  filters: { cancelled: true }
}, {
  label: "Open Credit Requests",
  filters: {
    open_credit_requests: true
  }
}, {
  label: "Closed Credit Requests",
  filters: { credit_requested: true, credit_issued: true }
}, {
  label: "No Warranty Requested",
  filters: { warranty_consideration: false }
}, {
  label: "No Credit Requested",
  filters: { credit_requested: false }
}, {
  label: "Cust Warr unit not received",
  filters: { date_in_blank: true }
}, {
  label: "Cust Warr unit received",
  filters: { date_in_blank: false }
}, {
  label: "Received",
  filters: { received: true }
}, {
  label: "Not Received",
  filters: { received: false }
}, {
  label: "No Incoming AWB",
  filters: { incoming_awb_number: false }
}];

var filterTags = [{
  label: "Only Mine",
  key: "current_user"
}, {
  label: "Cancelled",
  key: "cancelled",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Open Warranty Requests",
  key: "open_warranty_consideration",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Closed Warranty Requests",
  key: "open_warranty_consideration",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Open Credit Requests",
  key: "open_credit_requests"
}, {
  label: "Closed Credit Requests",
  key: "credit_issued",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "WC",
  key: "warranty_consideration",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "No Warranty Requested",
  key: "warranty_consideration",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "No Credit Requested",
  key: "credit_requested",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Warr unit not received",
  key: "date_in_blank",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Warr unit received",
  key: "date_in_blank",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Received",
  key: "received",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Received",
  key: "received",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "No Incoming AWB",
  key: "incoming_awb_number",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_filters__["a" /* matchesBoolean */])(false)
}];

var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = searchProps.paginator.get("filters").toJS();
  var totalCount = searchProps.paginator.get("totalCount");

  params.total_count = totalCount;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        if (totalCount > __WEBPACK_IMPORTED_MODULE_9__users_constants__["_6" /* EXPORT_LIMIT */]) {
          __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].info("Processing");
          __WEBPACK_IMPORTED_MODULE_14__api__["a" /* default */].customerRmas.export(params).then(function () {
            return __WEBPACK_IMPORTED_MODULE_11__lib_submission__["a" /* SUCCESS */];
          });
        } else {
          window.open(__WEBPACK_IMPORTED_MODULE_10__constants__["d" /* API_BASE */] + "/customer_rmas/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_query_string__["stringify"])(params), "_blank");
          __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].success("Processing Customer RMA Report. Please wait for the PDF to generate.");
        }
      }
    },
    "Export"
  );
};

var meetsExportCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var searchProps = _ref2.searchProps,
      currentUser = _ref2.currentUser;
  return searchProps.paginator.get("totalCount") <= 450 || currentUser.role === __WEBPACK_IMPORTED_MODULE_9__users_constants__["i" /* ADMIN */];
});

var DecoratedExportButton = meetsExportCriteria(ExportButton);

function RmasSearch(_ref3) {
  var pushHistory = _ref3.pushHistory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_16__pagination__["a" /* default */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing Company Name, RMA Number, Serial Number or Part Number...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/rmas/" + r.id);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DecoratedExportButton, {
              searchProps: searchProps,
              currentUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["a" /* useCurrentUser */])()
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, { filters: filters, right: true }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "Customer RMA",
          filters: filterTags,
          aggregateField: function aggregateField(rma) {
            return rma.sales_item.exchange_sale ? parseFloat(rma.sales_item.exchange_fee) : parseFloat(rma.sales_item.price_per_unit) * parseFloat(rma.sales_item.quantity);
          }
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

RmasSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(RmasSearch));

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__ = __webpack_require__(20);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











var getClass = function getClass(cancelled) {
  return __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
    "danger-table-cap": cancelled
  });
};

function RmaStatusCell(_ref) {
  var cancelled = _ref.cancelled,
      children = _ref.children;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: getClass(cancelled) },
    children
  );
}

RmaStatusCell.propTypes = {
  cancelled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)])
};

function renderRow(r, pushHistory) {
  var rowClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("clickable", { "text-muted": r.cancelled });
  var handleMailto = function handleMailto(e) {
    e.stopPropagation();
  };

  var lineItem = r.sales_item;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: r.id,
      className: rowClasses,
      onClick: function onClick() {
        return pushHistory("/rmas/" + r.uuid);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.reference_record_code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(r.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(r.date_in)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(r.closed_date)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.company_name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.contact_name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.company_phone
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        { href: "mailto:" + r.contact_email, onClick: handleMailto },
        r.contact_email
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["h" /* PartNumber */], { part: r.part })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          to: "/inventories/" + r.inventory.uuid
        },
        r.sales_item && r.sales_item.serial_number
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      lineItem.exchange_sale && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.exchange_fee) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.price_per_unit)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      lineItem.exchange_sale && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.outright_value)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      r.warranty_consideration && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["k" /* Icon */], { name: "check text-success" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      r.credit_requested && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["k" /* Icon */], { name: "check text-success" })
    )
  );
}

function Table(_ref2) {
  var isLoading = _ref2.isLoading,
      pageActions = _ref2.pageActions,
      results = _ref2.results,
      pushHistory = _ref2.pushHistory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */],
    { loading: isLoading, refresh: pageActions.expire },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "RMA #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Ref #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Created"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Received"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Date Closed"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Customer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Contact"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Phone"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Email"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Exch Fee/Sales EA"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Outright Value"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Warr Rqstd"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Credit Rqstd"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_6__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(Table));

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(1298);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });



/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony export (immutable) */ __webpack_exports__["a"] = Attachments;







function Attachments(_ref) {
  var fields = _ref.fields,
      attachmentTypes = _ref.attachmentTypes;

  var moreThanOne = fields.length >= 1;
  var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["a" /* toOptions */])(attachmentTypes);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    fields.map(function (attachment, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { key: "attachment-" + (attachment + index) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h5",
          { className: "h4" },
          "Attachment #",
          index + 1,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            {
              type: "button",
              className: "btn btn-xs btn-default btn-hollow pull-right",
              onClick: function onClick() {
                return fields.remove(index);
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
            "\xA0Remove"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
            { md: 8 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: attachment + ".files",
              component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["k" /* FileInput */],
              label: "Upload Attachment",
              multiple: true,
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: attachment + ".attachment_type",
              component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["c" /* Select */],
              label: "Attachment Type",
              options: options,
              required: true
            })
          )
        )
      );
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        type: "button",
        onClick: function onClick() {
          return fields.push({ attachment_type: "tag_copies" });
        },
        className: "btn btn-primary btn-hollow",
        style: { marginTop: 5, marginBottom: 15 }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
      " ",
      moreThanOne ? "Add another attachment" : "Add attachment"
    )
  );
}

Attachments.defaultProps = {
  attachmentTypes: [],
  fields: []
};

Attachments.propTypes = {
  fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    length: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }),
  attachmentTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Array)
};

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AddAttachments__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validate__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Row__ = __webpack_require__(1304);












var FORM_NAME = "customerRfq";

function Form(props) {
  var incomingQuote = props.incomingQuote,
      quoted = props.quoted;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms_FormRow__["a" /* default */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
      { md: 6, mdOffset: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "panel panel-default" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "panel-body" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["e" /* Form */],
            props,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["e" /* Form */].Body,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms_FormRow__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["d" /* FormInput */],
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["S" /* NAME */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["S" /* NAME */]),
                    disabled: quoted,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["T" /* EMAIL */],
                    component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["d" /* FormInput */],
                    label: __WEBPACK_IMPORTED_MODULE_6__constants__["T" /* EMAIL */],
                    disabled: quoted,
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms_FormRow__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                  { md: 9 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["d" /* FormInput */],
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["x" /* COMPANY_NAME */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["x" /* COMPANY_NAME */]),
                    disabled: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms_FormRow__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["p" /* PhoneNumberField */], {
                    name: "phone1",
                    component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["d" /* FormInput */],
                    disabled: quoted,
                    label: "Phone Number 1"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms_FormRow__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                  { md: 12 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "table",
                    { className: "table table-striped table-numbered margin-bottom-none" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["FieldArray"], {
                      name: __WEBPACK_IMPORTED_MODULE_6__constants__["A" /* LINE_ITEMS */],
                      component: __WEBPACK_IMPORTED_MODULE_10__Row__["a" /* default */],
                      formName: FORM_NAME,
                      incomingQuote: incomingQuote
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms_FormRow__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                  { md: 12 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["FieldArray"], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["k" /* ATTACHMENTS */],
                    component: __WEBPACK_IMPORTED_MODULE_8__AddAttachments__["a" /* default */],
                    attachmentTypes: __WEBPACK_IMPORTED_MODULE_7__IncomingQuotes_constants__["u" /* ATTACHMENT_TYPES */]
                  })
                )
              )
            )
          )
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_9__validate__["a" /* default */]
})(Form));

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RepairQuotes_constants__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Form__ = __webpack_require__(1302);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















function IncomingQuote(params) {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      incomingQuote = _useState2[0],
      setIncomingQuote = _useState2[1];

  var _parse = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_query_string__["parse"])(params.location.search),
      id = _parse.id,
      c = _parse.c,
      noQuote = _parse.no_quote;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!id) return Promise.resolve();

    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].incomingQuotes.customerFind(id, c).then(function (resp) {
      setIncomingQuote(resp.data);
    });

    return function cleanup() {};
  }, [id]);

  if (!incomingQuote) return null;

  var quoted = !!incomingQuote.customer_submitted_at;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h1",
      { className: "text-center" },
      "Request for Quote # ",
      incomingQuote.code
    ),
    quoted && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms_FormRow__["a" /* default */],
      { className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "text-center" },
        "The RFQ above was completed on",
        " ",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_formatters_date__["b" /* shortDate */])(incomingQuote.customer_submitted_at),
        " at",
        " ",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_formatters_date__["j" /* timeStamp */])(incomingQuote.customer_submitted_at),
        "."
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Form__["a" /* default */], {
      disabled: quoted,
      incomingQuote: incomingQuote,
      onSubmit: useOnSubmit(setIncomingQuote),
      noQuote: noQuote,
      quoted: quoted,
      initialValues: {
        id: id,
        c: c,
        name: incomingQuote.contact.name,
        email: incomingQuote.contact.email,
        company_name: incomingQuote.company.name,
        phone1: incomingQuote.company.phone,
        line_items: incomingQuote.incoming_quote_line_items.map(function (i) {
          var _ref;

          var noQuoted = noQuote && !quoted ? (_ref = {}, _defineProperty(_ref, __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["n" /* CONDITION */], null), _defineProperty(_ref, __WEBPACK_IMPORTED_MODULE_8__constants__["j" /* QUANTITY */], null), _defineProperty(_ref, __WEBPACK_IMPORTED_MODULE_9__RepairQuotes_constants__["n" /* QUOTE_TYPE */], __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["j" /* NO_QUOTE */]), _defineProperty(_ref, __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["n" /* CONDITION */], null), _defineProperty(_ref, __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["p" /* TAGGED_BY */], null), _defineProperty(_ref, __WEBPACK_IMPORTED_MODULE_8__constants__["V" /* COST */], null), _defineProperty(_ref, __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["F" /* TRACED_TO */], null), _ref) : {};

          return _extends({}, i, noQuoted);
        })
      }
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_router__["withRouter"])(IncomingQuote));

function buildAttachments() {
  var attachment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (attachment.uploaded) {
    return Promise.resolve(attachment);
  }

  return new Promise(function (resolve, _) {
    return buildAttachmentFiles(attachment).then(function (file) {
      resolve(file);
    }).catch(function (e) {
      return Promise.reject(e);
    });
  });
}

function buildAttachmentFiles(attachment) {
  var fileName = "" + (+new Date() - Math.floor(Math.random() * 10000000000)) + attachment.file.name;
  return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].incomingQuotes.upload(fileName).then(function (resp) {
    var _resp$data = resp.data,
        key = _resp$data.key,
        url = _resp$data.url;

    var formattedAttachment = {
      attachment_type: attachment.attachment_type,
      name: fileName,
      key: key
    };
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].attachments.toS3(url, attachment.file).then(function () {
      return Promise.resolve(formattedAttachment);
    }).catch(function (e) {
      return Promise.reject(e);
    });
  });
}

// Custom hooks
function useOnSubmit(setQuote) {
  var onSubmit = function onSubmit(quote) {
    Promise.all((quote.attachments || []).map(function (attachment) {
      return attachment.files.map(function (f) {
        return _extends({
          file: f
        }, attachment);
      });
    }).flat().map(buildAttachments)).then(function (attachments) {
      var formattedData = Object.assign({}, quote, {
        attachments: attachments
      });
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].incomingQuotes.customerUpdate(quote.id, formattedData).then(function (resp) {
        setQuote(resp.data);
        __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].success("Success", "Quote successfully sent.");
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Error", "An unexpected error occurred.");
      });
    });
  };

  return onSubmit;
}

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inventories_components_Detail_Dummies_constants__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RepairQuotes_constants__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms_MonthYearField__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_Check__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms_Check_CheckGroup__ = __webpack_require__(345);



















function Row(_ref) {
  var fields = _ref.fields,
      incomingQuote = _ref.incomingQuote,
      getFieldValue = _ref.getFieldValue,
      setFieldValue = _ref.setFieldValue;

  var quoteType = function quoteType(item) {
    return getFieldValue(item + ".quote_type");
  };
  var disabled = function disabled(item) {
    return quoteType(item) !== __WEBPACK_IMPORTED_MODULE_11__RepairQuotes_constants__["e" /* AWAITING_REPLY */] || incomingQuote.customer_submitted_at;
  };

  return fields.map(function (item, idx) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_redux_form__["FormSection"],
      { name: item },
      idx !== 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { marginTop: 10 } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_redux_form__["FormSection"],
          { name: __WEBPACK_IMPORTED_MODULE_4__parts_constants__["B" /* PART */] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_4__parts_constants__["w" /* PART_NUMBER */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_4__parts_constants__["w" /* PART_NUMBER */]),
              disabled: true,
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_4__parts_constants__["u" /* DESCRIPTION */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_4__parts_constants__["_39" /* PART_DESCRIPTION */]),
              disabled: true,
              required: true
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_7__constants__["j" /* QUANTITY */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: "Qty",
            required: quoteType(item) !== __WEBPACK_IMPORTED_MODULE_13__IncomingQuotes_constants__["j" /* NO_QUOTE */],
            disabled: disabled(item)
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            disabled: disabled(item),
            name: __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["n" /* CONDITION */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_10__inventories_components_Detail_Dummies_constants__["a" /* CONDITION_TYPES */]),
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["n" /* CONDITION */]),
            required: quoteType(item) !== __WEBPACK_IMPORTED_MODULE_13__IncomingQuotes_constants__["j" /* NO_QUOTE */]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["f" /* CurrencyField */], { name: __WEBPACK_IMPORTED_MODULE_7__constants__["V" /* COST */], label: "Price", disabled: disabled(item) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            disabled: disabled(item),
            name: __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["p" /* TAGGED_BY */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["p" /* TAGGED_BY */])
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__shared_components_Forms_MonthYearField__["a" /* default */], {
            disabled: disabled(item),
            name: __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["x" /* TAG_DATE */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["x" /* TAG_DATE */])
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            disabled: disabled(item),
            name: __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["F" /* TRACED_TO */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["F" /* TRACED_TO */])
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms_Check_CheckGroup__["a" /* default */],
            { title: "No Quote" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_Check__["a" /* default */], {
              onChange: function onChange() {
                var val = quoteType(item) === __WEBPACK_IMPORTED_MODULE_13__IncomingQuotes_constants__["j" /* NO_QUOTE */] ? __WEBPACK_IMPORTED_MODULE_11__RepairQuotes_constants__["e" /* AWAITING_REPLY */] : __WEBPACK_IMPORTED_MODULE_13__IncomingQuotes_constants__["j" /* NO_QUOTE */];
                setFieldValue([item, __WEBPACK_IMPORTED_MODULE_14__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */]].join("."))(val);
                if (val === __WEBPACK_IMPORTED_MODULE_13__IncomingQuotes_constants__["j" /* NO_QUOTE */]) {
                  [__WEBPACK_IMPORTED_MODULE_7__constants__["V" /* COST */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["p" /* TAGGED_BY */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["x" /* TAG_DATE */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["F" /* TRACED_TO */], __WEBPACK_IMPORTED_MODULE_7__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["n" /* CONDITION */]].forEach(function (f) {
                    return setFieldValue([item, f].join("."))(null);
                  });
                }
              },
              input: {
                name: item + ".no_quote",
                value: quoteType(item) === __WEBPACK_IMPORTED_MODULE_13__IncomingQuotes_constants__["j" /* NO_QUOTE */],
                onChange: function onChange() {}
              },
              label: "No Quote",
              disabled: ![__WEBPACK_IMPORTED_MODULE_13__IncomingQuotes_constants__["j" /* NO_QUOTE */], __WEBPACK_IMPORTED_MODULE_11__RepairQuotes_constants__["e" /* AWAITING_REPLY */]].includes(quoteType(item)) || incomingQuote.customer_submitted_at
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_7__constants__["_18" /* NOTES */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["l" /* TextArea */],
            label: "Note",
            rows: 5,
            disabled: disabled(item)
          })
        )
      )
    );
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Row));

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_validate_this__ = __webpack_require__(24);
/* unused harmony export validateLineItem */
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;






function validateLineItem(lineItem, values) {
  var fieldPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var quoteType = fieldPrefix ? values[fieldPrefix].quote_type : values.quote_type;

  if (![__WEBPACK_IMPORTED_MODULE_0__IncomingQuotes_constants__["j" /* NO_QUOTE */], __WEBPACK_IMPORTED_MODULE_0__IncomingQuotes_constants__["n" /* AWAITING_REPLY */]].includes(quoteType)) return;

  if (quoteType !== __WEBPACK_IMPORTED_MODULE_0__IncomingQuotes_constants__["j" /* NO_QUOTE */]) {
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["f" /* isGreaterThan */](0));
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["V" /* COST */], __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_1__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["V" /* COST */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0));
  }
}

function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["S" /* NAME */], __WEBPACK_IMPORTED_MODULE_1__constants__["T" /* EMAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    form.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["T" /* EMAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["b" /* isValidEmail */]);
    form.validateChildren(__WEBPACK_IMPORTED_MODULE_1__constants__["A" /* LINE_ITEMS */], validateLineItem);
  });
}

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Stat_Stat__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Stats__ = __webpack_require__(639);









function HeaderStats(_ref) {
  var currentUser = _ref.currentUser,
      depreciationsData = _ref.depreciationsData;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
    null,
    currentUser.locations.length > 1 && depreciationsData.map(function (l) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 3, lg: 2 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Stat_Stat__["a" /* default */], {
          label: "$ Depreciations " + l.location + " - Today",
          value: __WEBPACK_IMPORTED_MODULE_4_numeral___default()(Number(l.total_depreciations) + Number(l.total_write_downs)).format("($0,0)"),
          labelFontSize: "44px"
        })
      );
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Stats__["a" /* DepreciationsSum */], { dateLabel: "Today", data: depreciationsData })
    )
  );
}

HeaderStats.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  depreciationsData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}))
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__session_decorators_withCurrentUser__["b" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["u" /* withPolling */])(HeaderStats)));

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Stats__ = __webpack_require__(639);










function MonthlyStats(_ref) {
  var currentUser = _ref.currentUser,
      selectedDate = _ref.selectedDate,
      depreciationsData = _ref.depreciationsData;

  var date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(selectedDate).format("MMMM YYYY");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
    null,
    currentUser.locations.length > 1 && depreciationsData.perLocation.map(function (l) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 3, lg: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["H" /* Stat */], {
          label: "$ Depreciations " + l.location,
          value: __WEBPACK_IMPORTED_MODULE_6_numeral___default()(Number(l.total_depreciations) + Number(l.total_write_downs)).format("($0,0)"),
          labelFontSize: "44px"
        })
      );
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Stats__["a" /* DepreciationsSum */], { dateLabel: date, data: depreciationsData })
    )
  );
}

MonthlyStats.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  selectedDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  depreciationsData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}))
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__["b" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators__["u" /* withPolling */])(MonthlyStats)));

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_SimpleDateRangePicker_SimpleDateRangePicker__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Locations_components_LocationsDropDown__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MonthlyStats__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__HeaderStats__ = __webpack_require__(1306);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Table; });
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













function renderRow(r) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { key: r.buyer },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.buyer
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(r.total_depreciations)
    )
  );
}

var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    _classCallCheck(this, Table);

    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this));

    _this.getWriteDownSum = function (monthResults, key) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-right" },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(monthResults.reduce(function (sum, result) {
          return sum + result[key + "_write_downs"];
        }, 0))
      );
    };

    _this.handleDateChange = function (startDate, endDate) {
      _this.setState({
        monthlyDataLoading: true,
        startDate: startDate,
        endDate: endDate
      });

      if (startDate) {
        _this.fetchMonthResults(startDate);
      } else {
        _this.setState({
          monthResults: [],
          monthlyDataLoading: false
        });
      }
    };

    _this.handleLocationChange = function (locationId) {
      _this.setState({
        monthlyDataLoading: true,
        locationId: locationId
      });

      _this.fetchMonthResults(_this.state.selectedDate, locationId);
    };

    _this.fetchMonthResults = _this.fetchMonthResults.bind(_this);
    _this.fetchTodaysResults = _this.fetchTodaysResults.bind(_this);
    _this.state = {
      endDate: __WEBPACK_IMPORTED_MODULE_8_moment___default()().endOf(__WEBPACK_IMPORTED_MODULE_6__constants__["_33" /* MONTH */]),
      monthResults: [],
      todaysResults: [],
      monthlyDataLoading: false,
      startDate: __WEBPACK_IMPORTED_MODULE_8_moment___default()().startOf(__WEBPACK_IMPORTED_MODULE_6__constants__["_33" /* MONTH */])
    };
    return _this;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchTodaysResults();
      this.fetchMonthResults();
    }
  }, {
    key: "fetchTodaysResults",
    value: function fetchTodaysResults() {
      var _this2 = this;

      var _state = this.state,
          endDate = _state.endDate,
          startDate = _state.startDate;


      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reports.depreciations.searchPerLocation(startDate, endDate).then(function (res) {
        _this2.setState({
          todaysResults: res.data,
          monthlyDataLoading: false
        });
      });
    }
  }, {
    key: "fetchMonthResults",
    value: function fetchMonthResults() {
      var _this3 = this;

      var _state2 = this.state,
          endDate = _state2.endDate,
          startDate = _state2.startDate,
          locationId = _state2.locationId;


      Promise.all([__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reports.depreciations.search(startDate, endDate, locationId), __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reports.depreciations.searchPerLocation(startDate, endDate)]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            res = _ref2[0],
            perLocation = _ref2[1];

        var results = res.data.results.filter(function (x) {
          return Math.abs(x.total_depreciations) !== 0 || Math.abs(x.total_write_downs) !== 0;
        });

        _this3.setState({
          monthResults: Object.assign(results, {
            perLocation: perLocation.data
          }),
          monthlyDataLoading: false
        });
      });
    }
  }, {
    key: "reportStartTime",
    value: function reportStartTime(selectedDate) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(selectedDate || this.state.selectedDate).startOf("month").format();
    }
  }, {
    key: "reportEndTime",
    value: function reportEndTime(selectedDate) {
      return (this.reportStartTime(selectedDate) ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.reportStartTime(selectedDate)) : __WEBPACK_IMPORTED_MODULE_8_moment___default()()).endOf("month").format();
    }
  }, {
    key: "render",
    value: function render() {
      var _state3 = this.state,
          endDate = _state3.endDate,
          todaysResults = _state3.todaysResults,
          monthResults = _state3.monthResults,
          monthlyDataLoading = _state3.monthlyDataLoading,
          startDate = _state3.startDate;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__HeaderStats__["a" /* default */], {
          depreciationsData: todaysResults,
          refresh: this.fetchTodaysResults
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Row */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: "page-header monthly-depreciations-header",
                style: { padding: "10px, 30px" }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h1",
                { style: { marginTop: "7px" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { className: "header-content depreciations-header" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    {
                      style: {
                        marginTop: "8px",
                        marginRight: "10px",
                        verticalAlign: "super",
                        display: "flex"
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      null,
                      startDate && "" + __WEBPACK_IMPORTED_MODULE_8_moment___default()(startDate).format("MMMM DD YYYY"),
                      endDate && "- " + __WEBPACK_IMPORTED_MODULE_8_moment___default()(endDate).format("MMMM DD YYYY")
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "div",
                      { style: { marginLeft: "8px" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Locations_components_LocationsDropDown__["a" /* default */], {
                        handleChange: this.handleLocationChange
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: { display: "inline-block" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_SimpleDateRangePicker_SimpleDateRangePicker__["a" /* default */], {
                      handleDateChange: this.handleDateChange
                    }),
                    monthResults.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "a",
                      {
                        href: __WEBPACK_IMPORTED_MODULE_6__constants__["d" /* API_BASE */] + "/monthly_depreciations/download.xls?start_time=" + this.reportStartTime(startDate) + "&end_time=" + this.reportEndTime(endDate) + "&location_id=" + (this.state.locationId || ""),
                        target: "_blank",
                        rel: "noopener noreferrer"
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "button",
                        {
                          className: "btn btn-primary btn-hollow pull-right",
                          type: "button"
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-cloud-download" }),
                        "\xA0\xA0Download Report"
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Row */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */],
              { loading: monthlyDataLoading, loadingRows: 40 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Head,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Name"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "Total Depreciations"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Body,
                null,
                monthResults.map(function (r) {
                  return renderRow(r);
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  { key: "probono" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    "Pro Bono"
                  ),
                  this.getWriteDownSum(monthResults, "total")
                )
              )
            )
          )
        ),
        monthResults.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__MonthlyStats__["a" /* default */], {
          selectedDate: startDate,
          depreciationsData: monthResults,
          refresh: this.fetchMonthResults
        })
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_ActionDropDown_ActionDropDown__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReportData__ = __webpack_require__(1310);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








var reportTypes = [{
  value: "company",
  label: "Company High Scores"
}, {
  value: "my-scores",
  label: "My High Scores"
}];

var filterTypes = [{
  value: "all",
  label: "All History"
}, {
  value: "18-months",
  label: "18 Months"
}];

var Report = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(function () {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])("company"),
      _useState2 = _slicedToArray(_useState, 2),
      currentReport = _useState2[0],
      setCurrentReport = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])("all"),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPeriod = _useState4[0],
      setCurrentPeriod = _useState4[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Row */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "page-header page-header-bar" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h1",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "btn-group pull-right", style: { marginLeft: 20 } },
              false && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3__shared_components_ActionDropDown_ActionDropDown__["a" /* default */],
                {
                  menuClass: "dropdown-menu-right",
                  style: { cursor: "pointer" },
                  label: "Report"
                },
                reportTypes.map(function (report) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDownItem__["a" /* default */],
                    {
                      key: report.value,
                      onClick: function onClick() {
                        return setCurrentReport(report.value);
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      null,
                      currentReport === report.value && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" }),
                      currentReport !== report.value && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                        null,
                        "\xA0\xA0\xA0\xA0"
                      ),
                      " ",
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "span",
                        null,
                        report.label
                      )
                    )
                  );
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "btn-group pull-right", style: { marginLeft: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3__shared_components_ActionDropDown_ActionDropDown__["a" /* default */],
                {
                  menuClass: "dropdown-menu-right",
                  style: { cursor: "pointer" },
                  label: "Filter"
                },
                filterTypes.map(function (report) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDownItem__["a" /* default */],
                    {
                      key: report.value,
                      onClick: function onClick() {
                        return setCurrentPeriod(report.value);
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      null,
                      currentPeriod === report.value && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" }),
                      currentPeriod !== report.value && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                        null,
                        "\xA0\xA0\xA0\xA0"
                      ),
                      " ",
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "span",
                        null,
                        report.label
                      )
                    )
                  );
                })
              )
            ),
            "High Scores"
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ReportData__["a" /* default */], {
      key: currentReport + "." + currentPeriod,
      period: currentPeriod,
      report: currentReport
    })
  );
});

/* harmony default export */ __webpack_exports__["a"] = (Report);

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_chunk__ = __webpack_require__(2942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_chunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_chunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StatsPanel__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reports__ = __webpack_require__(1312);








var ReportData = function ReportData(_ref) {
  var report = _ref.report,
      period = _ref.period;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
    null,
    __WEBPACK_IMPORTED_MODULE_3_lodash_chunk___default()(__WEBPACK_IMPORTED_MODULE_5__reports__["a" /* default */], 3).map(function (reportsChunk, chunkIdx) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
        { key: chunkIdx },
        reportsChunk.map(function (_ref2, idx) {
          var config = _ref2.config,
              title = _ref2.title;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 4, key: idx },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StatsPanel__["a" /* default */], {
              title: title,
              config: config,
              report: report,
              period: period
            })
          );
        })
      );
    })
  );
};

ReportData.propTypes = {
  period: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  report: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (ReportData);

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Report__ = __webpack_require__(1309);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Report__["a"]; });


/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StatsTable_getHighestOverallMonth__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatsTable_getHighestOverallDay__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StatsTable_getHighestNumberOfSalesOneDay__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StatsTable_getHighestIndividualSaleOneMonth__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StatsTable_getHighestIndividualProfit__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StatsTable_getHighestIndividualSale__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StatsTable_getHighestProfitMonth__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StatsTable_getMostExchangTransaction__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StatsTable_getMostExchangeRevenue__ = __webpack_require__(1325);










/* harmony default export */ __webpack_exports__["a"] = ([{
  title: "Highest Overall Month",
  config: __WEBPACK_IMPORTED_MODULE_0__StatsTable_getHighestOverallMonth__
}, {
  title: "Highest Overall Day",
  config: __WEBPACK_IMPORTED_MODULE_1__StatsTable_getHighestOverallDay__
}, {
  title: "Highest # sales in 1 day",
  config: __WEBPACK_IMPORTED_MODULE_2__StatsTable_getHighestNumberOfSalesOneDay__
}, {
  title: "Highest Individual sales (1 mo)",
  config: __WEBPACK_IMPORTED_MODULE_3__StatsTable_getHighestIndividualSaleOneMonth__
}, {
  title: "Highest Individual Profit (1 mo)",
  config: __WEBPACK_IMPORTED_MODULE_4__StatsTable_getHighestIndividualProfit__
}, {
  title: "Highest Individual Sales Credit",
  config: __WEBPACK_IMPORTED_MODULE_5__StatsTable_getHighestIndividualSale__
}, {
  title: "Highest Profit Month",
  config: __WEBPACK_IMPORTED_MODULE_6__StatsTable_getHighestProfitMonth__
}, {
  title: "Most Exchange Transaction Month",
  config: __WEBPACK_IMPORTED_MODULE_7__StatsTable_getMostExchangTransaction__
}, {
  title: "Most Exchange Revenue Month",
  config: __WEBPACK_IMPORTED_MODULE_8__StatsTable_getMostExchangeRevenue__
}]);

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StatsTable_SearchStats__ = __webpack_require__(1315);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var StatsPanel = function StatsPanel(_ref) {
  var report = _ref.report,
      period = _ref.period,
      title = _ref.title,
      config = _ref.config,
      currentUser = _ref.currentUser;

  var filters = config.filters({ period: period, report: report, currentUser: currentUser });
  var style = {
    backgroundColor: config.color || "#928ff7",
    padding: "0 10px",
    borderRadius: "3px",
    boxShadow: "0 4px 4px rgba(0, 0, 0, 0.5)"
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: style },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h2",
        { style: { lineHeight: "1.8", color: "hsla(0,0%,100%,0.8)" } },
        title
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__StatsTable_SearchStats__["a" /* default */], {
      report: report,
      period: period,
      columns: config.columns,
      filters: filters,
      request: config.request
    })
  );
};

StatsPanel.defaultProps = {
  report: "company",
  period: "all",
  title: null,
  config: { filters: function filters() {
      return {};
    } }
};

StatsPanel.propTypes = _extends({
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  report: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  period: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  config: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    request: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }).isRequired
}, __WEBPACK_IMPORTED_MODULE_2__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__session_decorators_withCurrentUser__["b" /* default */])(StatsPanel));

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StatsPanel__ = __webpack_require__(1313);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StatsPanel__["a"]; });


/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table__ = __webpack_require__(1316);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();






function Stats(props) {
  var request = props.request,
      filters = props.filters;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState4 = _slicedToArray(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  var _data$results = data.results,
      results = _data$results === undefined ? [] : _data$results;


  var performRequest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    request(_extends({}, filters, { limit: 3 })).then(function (response) {
      setIsLoading(false);
      setData(response.data);
    });
  }, []);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    performRequest();
  }, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Table__["a" /* default */], _extends({
    isLoading: isLoading,
    results: results,
    refresh: performRequest
  }, props));
}

Stats.propTypes = {
  request: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/* harmony default export */ __webpack_exports__["a"] = (Stats);

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var renderRow = function renderRow(columns) {
  return function (record) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      { key: record.period },
      columns.map(function (column) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { key: column.key },
          typeof column.render === "function" ? column.render(record) : __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(record, column.key)
        );
      })
    );
  };
};

var Table = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(function (_ref) {
  var _ref$results = _ref.results,
      results = _ref$results === undefined ? [] : _ref$results,
      isLoading = _ref.isLoading,
      columns = _ref.columns,
      refresh = _ref.refresh;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */],
    { loading: isLoading, loadingRows: 3, refresh: refresh },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */].Head,
      null,
      columns.map(function (column) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { key: column.key },
          column.label
        );
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(renderRow(columns))
    )
  );
});

Table.propTypes = _extends({
  columns: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    render: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }))
}, __WEBPACK_IMPORTED_MODULE_3__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(166);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "request", function() { return request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "columns", function() { return columns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filters", function() { return filters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return color; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var request = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].reports.high_scores.sales_stats;

var columns = [{
  key: "seller",
  label: "Seller"
}, {
  key: "created_at",
  label: "Period",
  render: function render(record) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(record.period).format("MMM-YY");
  }
}, {
  key: "total_profit",
  label: "Amount",
  render: function render(record) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(record, "total_profit", 0), 0);
  }
}];

var filters = function filters(props) {
  var periodFilters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* getPeriodFilters */])(props);

  return _extends({
    type: "sales_per_user_per_period"
  }, periodFilters, {
    period: "month",
    order: "total_profit"
  });
};

var color = "#4CAF50";

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(166);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "request", function() { return request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "columns", function() { return columns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filters", function() { return filters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return color; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var request = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].reports.high_scores.sales_stats;

var columns = [{
  key: "seller",
  label: "Seller"
}, {
  key: "created_at",
  label: "Created At",
  render: function render(record) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(record.created_at).format("DD-MMM-YY");
  }
}, {
  key: "max_sales_credit",
  label: "Amount",
  render: function render(record) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(record, "total_sales", 0), 0);
  }
}];

var filters = function filters(props) {
  var periodFilters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* getPeriodFilters */])(props);

  return _extends({
    type: "max_credit"
  }, periodFilters, {
    order: "total_sales"
  });
};

var color = "#4CAF50";

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(166);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "request", function() { return request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "columns", function() { return columns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filters", function() { return filters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return color; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var request = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].reports.high_scores.sales_stats;

var columns = [{
  key: "seller",
  label: "Seller"
}, {
  key: "created_at",
  label: "Period",
  render: function render(record) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(record.period).format("MMM-YY");
  }
}, {
  key: "total_sales",
  label: "Amount",
  render: function render(record) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(record, "total_sales", 0), 0);
  }
}];

var filters = function filters(props) {
  var periodFilters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* getPeriodFilters */])(props);

  return _extends({
    type: "sales_per_user_per_period"
  }, periodFilters, {
    period: "month",
    order: "total_sales"
  });
};

var color = "#4CAF50";

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(166);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "request", function() { return request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "columns", function() { return columns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filters", function() { return filters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return color; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var request = __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].reports.high_scores.sales_stats;

var columns = [{
  key: "period",
  label: "Period",
  render: function render(record) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(record.period).format("DD-MMM-YY");
  }
}, {
  key: "number_of_sales",
  label: "# Sales"
}];

var filters = function filters(props) {
  var periodFilters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* getPeriodFilters */])(props);

  return _extends({
    type: "grouped_sales"
  }, periodFilters, {
    period: "day",
    order: "number_of_sales"
  });
};

var color = "#928ff7";

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(166);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "request", function() { return request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "columns", function() { return columns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filters", function() { return filters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return color; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var request = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].reports.high_scores.sales_stats;

var columns = [{
  key: "period",
  label: "Period",
  render: function render(record) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(record.period).format("DD-MMM-YY");
  }
}, {
  key: "total_sales",
  label: "Amount",
  render: function render(record) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(record, "total_sales", 0), 0);
  }
}];

var filters = function filters(props) {
  var periodFilters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* getPeriodFilters */])(props);

  return _extends({
    type: "grouped_sales"
  }, periodFilters, {
    period: "day",
    order: "total_sales"
  });
};

var color = "#928ff7";

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(166);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "request", function() { return request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "columns", function() { return columns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filters", function() { return filters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return color; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var request = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].reports.high_scores.sales_stats;

var columns = [{
  key: "period",
  label: "Period",
  render: function render(record) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(record.period).format("MMM-YY");
  }
}, {
  key: "total_sales",
  label: "Amount",
  render: function render(record) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(record, "total_sales", 0), 0);
  }
}];

var filters = function filters(props) {
  var periodFilters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* getPeriodFilters */])(props);

  return _extends({
    type: "grouped_sales"
  }, periodFilters, {
    period: "month",
    order: "total_sales"
  });
};

var color = "#928ff7";

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(166);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "request", function() { return request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "columns", function() { return columns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filters", function() { return filters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return color; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var request = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].reports.high_scores.sales_stats;

var columns = [{
  key: "created_at",
  label: "Period",
  render: function render(record) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(record.period).format("MMM-YY");
  }
}, {
  key: "total_profit",
  label: "Amount",
  render: function render(record) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(record, "total_profit", 0), 0);
  }
}];

var filters = function filters(props) {
  var periodFilters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* getPeriodFilters */])(props);

  return _extends({
    type: "grouped_sales"
  }, periodFilters, {
    period: "month",
    order: "total_profit"
  });
};

var color = "#2196F3";

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(166);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "request", function() { return request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "columns", function() { return columns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filters", function() { return filters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return color; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var request = __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reports.high_scores.sales_stats;

var columns = [{
  key: "period",
  label: "Period",
  render: function render(record) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(record.period).format("MMM-YY");
  }
}, {
  key: "number_of_sales",
  label: "# Sales",
  render: function render(record) {
    return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(record, "number_of_sales", 0);
  }
}];

var filters = function filters(props) {
  var periodFilters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* getPeriodFilters */])(props);

  return _extends({
    type: "grouped_sales"
  }, periodFilters, {
    period: "month",
    exchange: true,
    order: "number_of_sales"
  });
};

var color = "#2196F3";

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(166);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "request", function() { return request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "columns", function() { return columns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filters", function() { return filters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return color; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var request = __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].reports.high_scores.sales_stats;

var columns = [{
  key: "period",
  label: "Period",
  render: function render(record) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(record.period).format("MMM-YY");
  }
}, {
  key: "total_sales",
  label: "Amount",
  render: function render(record) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(record, "total_sales", 0), 0);
  }
}];

var filters = function filters(props) {
  var periodFilters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* getPeriodFilters */])(props);

  return _extends({
    type: "grouped_sales"
  }, periodFilters, {
    period: "month",
    exchange: true,
    order: "total_sales"
  });
};

var color = "#2196F3";

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LAUNCH_DATE; });
var LAUNCH_DATE = new Date(2018, 4, 1);

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Form__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_pojos__ = __webpack_require__(56);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var convertibleQuoteTypes = [__WEBPACK_IMPORTED_MODULE_19__constants__["k" /* STANDARD */], __WEBPACK_IMPORTED_MODULE_19__constants__["c" /* AS_IS */], __WEBPACK_IMPORTED_MODULE_19__constants__["l" /* INCIDENT_RELATED */], __WEBPACK_IMPORTED_MODULE_19__constants__["p" /* EXCHANGE_ONLY */]];

var ConvertToPurchaseOrder = function (_Component) {
  _inherits(ConvertToPurchaseOrder, _Component);

  function ConvertToPurchaseOrder() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ConvertToPurchaseOrder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConvertToPurchaseOrder.__proto__ || Object.getPrototypeOf(ConvertToPurchaseOrder)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      company: null
    }, _this.handleSubmit = function (values) {
      var includedLineItems = values.line_items.filter(function (i) {
        return i.included;
      });
      var filteredValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(values).merge({ line_items: includedLineItems }).toJS();

      return _this.props.convertToPurchaseOrder(filteredValues);
    }, _this.convertibleLineItems = function () {
      return _this.props.incomingQuote.get("incoming_quote_line_items").filter(function (item) {
        return convertibleQuoteTypes.indexOf(item.get(__WEBPACK_IMPORTED_MODULE_8__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */])) !== -1;
      }).toJS();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ConvertToPurchaseOrder, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var companyId = this.props.incomingQuote.getIn([__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["K" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_13__constants__["b" /* ID */]]);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__actions__["k" /* getCompany */])(companyId).then(function (company) {
        return _this2.setState({ company: company });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          buyerCreditPct = _props.buyerCreditPct,
          currentUser = _props.currentUser,
          incomingQuote = _props.incomingQuote,
          subtotal = _props.subtotal;
      var company = this.state.company;

      var lineItems = this.convertibleLineItems();
      var address = incomingQuote.getIn([__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["K" /* COMPANY */], "primary_physical_address"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])());

      var initialValues = {
        buyer_id: incomingQuote.get(__WEBPACK_IMPORTED_MODULE_11__users_constants__["x" /* BUYER_ID */]),
        buyer_credit_pct: buyerCreditPct,
        buying_store_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__hooks_useCurrentUser__["c" /* defaultStoreLocation */])(currentUser),
        fob: address.size > 0 ? [address.get(__WEBPACK_IMPORTED_MODULE_13__constants__["u" /* CITY */]), address.get(__WEBPACK_IMPORTED_MODULE_13__constants__["v" /* STATE */]), address.get(__WEBPACK_IMPORTED_MODULE_13__constants__["r" /* COUNTRY */])].join("-") : null,
        payment_terms: incomingQuote.getIn([__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["K" /* COMPANY */], "vendor_credit_terms"]),
        line_items: lineItems.map(function (item) {
          return _extends({
            evaluation_period: 30,
            expected_serial_number: Number(item.quantity) === 1 ? item.expected_serial_number : null,
            included: true,
            incoming_quote_line_item_id: item.id,
            other: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lodash__["isEmpty"])(item.other_tag_type),
            reserve_for_seller_id: currentUser.id,
            hazmat: item.part.hazmat,
            srp_condition: item.condition
          }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_pojos__["a" /* default */])(item).pick(__WEBPACK_IMPORTED_MODULE_9__inventories_constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_13__constants__["V" /* COST */], __WEBPACK_IMPORTED_MODULE_10__parts_constants__["G" /* DOM */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["G" /* LEAD_TIME */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["N" /* OTHER_TAG_TYPE */], __WEBPACK_IMPORTED_MODULE_10__parts_constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["q" /* PART_ID */], __WEBPACK_IMPORTED_MODULE_19__constants__["d" /* PURCHASE_STATUS */], __WEBPACK_IMPORTED_MODULE_13__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_13__constants__["_49" /* SUBTOTAL */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["v" /* SUGGESTED_RETAIL */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["O" /* TAGGED_BY_ID */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["x" /* TAG_DATE */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["p" /* TAGGED_BY */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["L" /* UK_CAA */]));
        })
      };

      if (lineItems.length === 0) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_containers__["a" /* ToggleSwitch */],
        null,
        function (visible, open, close) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_DropDown_DropDownItem__["a" /* default */],
            { onClick: open },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["k" /* Icon */], { name: "shopping-cart", fixed: true }),
            "\xA0Convert to PO",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14__shared_components_Modal__["a" /* Modal */],
              { open: visible, close: close, dialogClass: "modal-lg" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_14__shared_components_Modal__["b" /* Header */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components_Modal__["c" /* Close */], { close: close }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  { className: "modal-title" },
                  "Convert Quote to Purchase Order"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Form__["a" /* default */], {
                onSubmit: _this3.handleSubmit,
                initialValues: initialValues,
                close: close,
                lineItems: lineItems,
                subtotal: subtotal,
                company: company,
                incomingQuote: incomingQuote,
                enableReinitialize: true
              })
            )
          );
        }
      );
    }
  }]);

  return ConvertToPurchaseOrder;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ConvertToPurchaseOrder.propTypes = {
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),
  subtotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  incomingQuote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),
  convertToPurchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])("incomingQuoteConvertToPurchaseOrders");

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    buyerCreditPct: state.session.getIn([__WEBPACK_IMPORTED_MODULE_13__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_13__constants__["G" /* BUYER_CREDIT_PCT */]]),
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_11__users_constants__["a" /* USER */]).toJS(),
    subtotal: (selector(state, __WEBPACK_IMPORTED_MODULE_13__constants__["A" /* LINE_ITEMS */]) || []).filter(function (item) {
      return item.included;
    }).reduce(function (total, item) {
      return total + parseFloat(item.cost) * parseFloat(item.quantity);
    }, 0)
  };
}, function (dispatch) {
  return {
    convertToPurchaseOrder: function convertToPurchaseOrder(ids) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__actions__["l" /* convertQuoteToPurchaseOrder */])(ids));
    }
  };
})(ConvertToPurchaseOrder));

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_shared__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Orders_shared_ShippingFields__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_CompanyAddressWarning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Locations_components_BuyingStoreRadioField__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shared_components_PaymentTerms_PaymentTerms__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_shared_BioHazmatWarning__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__validate__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__LineItemRow__ = __webpack_require__(1329);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























var formName = "incomingQuoteConvertToPurchaseOrders";

var legacyWarning = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  "div",
  { className: "alert alert-danger" },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "strong",
    null,
    "Legacy Quote"
  ),
  " Company and contact must be assigned before quote can be converted to purchase order."
);

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.handleTaggedBy = function (company) {
      if (company && company.id) {
        _this.props.change(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["O" /* TAGGED_BY_ID */], company.id);
      }
    }, _this.toggleBuyer = function (buyer) {
      return _this.setState(buyer);
    }, _this.renderItemRows = function (_ref2) {
      var fields = _ref2.fields;
      var _this$props = _this.props,
          lineItems = _this$props.lineItems,
          subtotal = _this$props.subtotal;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        fields.map(function (item, idx) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__LineItemRow__["a" /* default */], {
            handleTaggedBy: _this.handleTaggedBy,
            idx: idx,
            item: item,
            lineItems: lineItems
          });
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          { style: { backgroundColor: "transparent" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right", colSpan: "7" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "margin-top-none margin-bottom-none" },
              "Total:\xA0\xA0",
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(subtotal)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null)
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.shippingType !== this.props.shippingType) {
        var fields = [__WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__["q" /* PURCHASE_FOR_STOCK */], __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__["l" /* PURCHASE_FOR_REPAIR_ASSIST */], __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__["m" /* PURCHASE_FOR_SALE */], __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__["p" /* PURCHASE_FOR_REPAIR */]];
        this.props.lineItemValues.forEach(function (item, i) {
          if (item.included) {
            fields.filter(function (field) {
              return item[field];
            }).forEach(function (field) {
              _this2.props.resetPurchaseFor(i, field);
            });
          }
        });
      }
    }
  }, {
    key: "companyInvalid",
    value: function companyInvalid() {
      return !this.props.company || !this.props.company.primary_physical_address || !this.props.company.billing_address;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          buyerCreditPct = _props.buyerCreditPct,
          company = _props.company,
          currentUser = _props.currentUser,
          getFieldValue = _props.getFieldValue,
          incomingQuote = _props.incomingQuote,
          lineItems = _props.lineItems,
          searchBuyers = _props.searchBuyers,
          setField = _props.setField,
          shippingType = _props.shippingType;


      var showLegacyWarning = !incomingQuote.get(__WEBPACK_IMPORTED_MODULE_7__companies_constants__["p" /* COMPANY */]) || !incomingQuote.get(__WEBPACK_IMPORTED_MODULE_7__companies_constants__["g" /* CONTACT */]) && !incomingQuote.get(__WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */],
        _extends({}, this.props, {
          editable: !showLegacyWarning,
          disabled: this.companyInvalid()
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */].Body,
          null,
          showLegacyWarning && legacyWarning,
          !showLegacyWarning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components_CompanyAddressWarning__["a" /* default */], { company: company }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "nav nav-tabs" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              null,
              "Buying Information"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: "row row-col-gutters-half",
              style: { marginTop: "26px" }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                label: "Vendor",
                name: "read_only_vendor",
                component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */],
                readOnly: true,
                disabled: true,
                inputProps: {
                  value: incomingQuote.getIn([__WEBPACK_IMPORTED_MODULE_7__companies_constants__["p" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_14__constants__["S" /* NAME */]])
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__shared_components_PaymentTerms_PaymentTerms__["a" /* default */], null)
            ),
            currentUser.tenant.locations_count !== 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Locations_components_BuyingStoreRadioField__["a" /* default */], null)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 5 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_shared__["c" /* BuyerField */], {
                searchBuyers: searchBuyers,
                selectedBuyer: incomingQuote.get(__WEBPACK_IMPORTED_MODULE_17__users_constants__["P" /* BUYER */]) && incomingQuote.get(__WEBPACK_IMPORTED_MODULE_17__users_constants__["P" /* BUYER */]).toJS()
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_14__constants__["G" /* BUYER_CREDIT_PCT */],
                className: "text-right",
                component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["c" /* Select */],
                onChange: function onChange(_ev, val) {
                  if (["25.0", "50.0", null].includes(val)) {
                    setField(__WEBPACK_IMPORTED_MODULE_17__users_constants__["y" /* THIRD_BUYER_ID */])(null);
                    _this3.toggleBuyer({ selectedThirdBuyer: null });
                  }
                },
                options: __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__["_4" /* BUYER_CREDIT_PCT_OPTIONS */],
                label: "Buyer Credit",
                required: true
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_shared__["b" /* CoBuyersFields */], {
              buyerCreditPct: buyerCreditPct,
              searchBuyers: searchBuyers,
              selectedCoBuyer: this.state.selectedCoBuyer,
              selectedThirdBuyer: this.state.selectedThirdBuyer,
              numberOfBuyers: [getFieldValue(__WEBPACK_IMPORTED_MODULE_17__users_constants__["z" /* CO_BUYER_ID */]), getFieldValue(__WEBPACK_IMPORTED_MODULE_17__users_constants__["y" /* THIRD_BUYER_ID */])].filter(function (s) {
                return s;
              }).length + 1,
              toggleBuyer: this.toggleBuyer
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "nav nav-tabs" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              null,
              "Shipping Information"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], { name: "fob", component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], label: "FOB", required: true })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                  name: "ship_date",
                  component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */],
                  type: "date",
                  label: "Ship Date"
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { xs: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11__Orders_shared_ShippingFields__["a" /* default */],
                {
                  formName: formName,
                  shippingFields: [__WEBPACK_IMPORTED_MODULE_14__constants__["o" /* SHIPPING_TYPE */], __WEBPACK_IMPORTED_MODULE_14__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_14__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */]],
                  setTenantAccount: true,
                  shippingMethod: __WEBPACK_IMPORTED_MODULE_14__constants__["g" /* SHIPPING_METHOD */],
                  setFOB: setField(__WEBPACK_IMPORTED_MODULE_14__constants__["H" /* FOB */]),
                  shippingAddressField: __WEBPACK_IMPORTED_MODULE_14__constants__["I" /* SHIPPING_ADDRESS */],
                  required: true
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_shared_BioHazmatWarning__["a" /* default */], {
                  parts: lineItems.map(function (l) {
                    return l.part;
                  }),
                  shippingType: getFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["o" /* SHIPPING_TYPE */])
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            null,
            "Confirm Which Parts to Assign to PO"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: "row row-col-gutters-half",
              style: { marginTop: "26px" }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "table",
                { className: "table table-striped table-numbered margin-bottom-none" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["FieldArray"], {
                  name: __WEBPACK_IMPORTED_MODULE_14__constants__["A" /* LINE_ITEMS */],
                  component: this.renderItemRows,
                  shippingType: shippingType
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  getFieldValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  currentUser: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  lineItems: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(Object),
  lineItemValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(Object),
  searchBuyers: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  resetPurchaseFor: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  setField: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  subtotal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
  company: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object),
  incomingQuote: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  shippingType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};


var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    buyerCreditPct: selector(state, __WEBPACK_IMPORTED_MODULE_14__constants__["G" /* BUYER_CREDIT_PCT */]),
    getFieldValue: function getFieldValue(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["formValueSelector"])(formName)(state, field);
    },
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_17__users_constants__["a" /* USER */]).toJS(),
    lineItemValues: selector(state, __WEBPACK_IMPORTED_MODULE_14__constants__["A" /* LINE_ITEMS */]),
    minExchangeSrp: state.session.getIn([__WEBPACK_IMPORTED_MODULE_14__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_14__constants__["X" /* MINIMUM_EXCHANGE_SRP */]]),
    shippingType: selector(state, __WEBPACK_IMPORTED_MODULE_14__constants__["o" /* SHIPPING_TYPE */])
  };
}, function (dispatch) {
  return {
    resetPurchaseFor: function resetPurchaseFor(id, fieldName) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(formName, "line_items[" + id + "]." + fieldName, null));
    },
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_actions__["c" /* searchBuyers */](filter));
    },
    searchRepairStations: function searchRepairStations(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_actions__["f" /* searchRepairStations */](filter));
    },
    setField: function setField(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(formName, field, val));
      };
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_20__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_components_Detail_LineItemsTable_Form__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_components_Detail_SRPConditionMismatchWarning__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_components_Detail_LineItemsTable_DomLifeWarning__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_shared_PurchaseForFields__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Locations_components_ToolsUsedDropDown__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lib_time__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

































var formName = "incomingQuoteConvertToPurchaseOrders";

var LineItemRow = function (_Component) {
  _inherits(LineItemRow, _Component);

  function LineItemRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LineItemRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LineItemRow.__proto__ || Object.getPrototypeOf(LineItemRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedPreferredRepairStation: null
    }, _this.handlePreferredRepairStation = function (company) {
      var _this$props = _this.props,
          setPreferredRepairStationHold = _this$props.setPreferredRepairStationHold,
          item = _this$props.item;


      if (company && company.id) {
        setPreferredRepairStationHold(item, company.repair_station_status !== __WEBPACK_IMPORTED_MODULE_19__companies_constants__["j" /* APPROVED */]);
      }
    }, _this.resetPreferredRepairStation = function () {
      var _this$props2 = _this.props,
          resetPreferredRepairStation = _this$props2.resetPreferredRepairStation,
          item = _this$props2.item;


      resetPreferredRepairStation(item);

      _this.setState({ selectedPreferredRepairStation: null });
    }, _this.searchCompanies = function (filter) {
      return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].companies.search({ filter: filter, page: 1, limit: 20 }).then(function (resp) {
        return resp.data.results;
      });
    }, _this.clearPurchaseFor = function (val, fields) {
      if (!val) return null;
      return fields.forEach(function (f) {
        return _this.props.setFieldValue(f)(false);
      });
    }, _this.handleTaggedBy = function (company) {
      var _this$props3 = _this.props,
          handleTaggedBy = _this$props3.handleTaggedBy,
          setTaggedByHold = _this$props3.setTaggedByHold,
          item = _this$props3.item;


      if (company && company.id) {
        handleTaggedBy(company);
        setTaggedByHold(item, company.repair_station_status !== __WEBPACK_IMPORTED_MODULE_19__companies_constants__["j" /* APPROVED */]);
      } else {
        setTaggedByHold(false);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LineItemRow, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          lineItemValues = _props.lineItemValues,
          searchBuyers = _props.searchBuyers,
          shippingType = _props.shippingType,
          getFieldValue = _props.getFieldValue,
          purchaseForSale = _props.purchaseForSale,
          searchRepairStations = _props.searchRepairStations,
          setFieldValue = _props.setFieldValue,
          purchaseForStock = _props.purchaseForStock,
          srpCondition = _props.srpCondition,
          condition = _props.condition,
          preferredRepairStationHold = _props.preferredRepairStationHold,
          item = _props.item,
          idx = _props.idx,
          taggedByHold = _props.taggedByHold;
      var selectedPreferredRepairStation = this.state.selectedPreferredRepairStation;


      var quoteItem = this.lineItem;
      var altOptions = quoteItem.alternates.map(function (a) {
        return {
          value: a.id,
          text: a.name
        };
      });
      var includedInConversion = lineItemValues && lineItemValues[idx].included;
      var style = { opacity: includedInConversion ? 1 : 0.25 };

      var setField = function setField(name) {
        return [item, name].join(".");
      };
      var capType = getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["A" /* CAP_TYPE */]));
      var qty = getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_18__constants__["j" /* QUANTITY */]));
      var cost = getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_18__constants__["V" /* COST */]));
      var tagRequired = [__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["i" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["P" /* INSPECTED */], __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["h" /* REPAIRED */]].includes(getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["n" /* CONDITION */])));
      var minOutrightValueForExchangeSettings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__hooks_useCurrentUser__["b" /* useSettings */])().min_outright_value_for_exchange_consideration;
      var minOutrightValueForExchangeConsideration = parseFloat(minOutrightValueForExchangeSettings);
      var suggestedRetail = getFieldValue(item + "." + __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["v" /* SUGGESTED_RETAIL */]) || 0;
      var shouldCheckMinValue = minOutrightValueForExchangeSettings !== null && minOutrightValueForExchangeSettings !== undefined;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: "item-" + quoteItem.id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          idx + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          purchaseForStock && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_lodash__["isEmpty"])(srpCondition) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_lodash__["isEmpty"])(condition) && srpCondition !== condition && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_components_Detail_SRPConditionMismatchWarning__["a" /* SRPConditionMismatchWarning */], null),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_components_Detail_LineItemsTable_Form__["c" /* exchangeSrpNotAllowed */])(quoteItem.part) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_components_Detail_LineItemsTable_Form__["d" /* ExchangeSrpWarning */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_components_Detail_LineItemsTable_DomLifeWarning__["a" /* default */], {
            part: quoteItem.part,
            domFromLineItem: getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_21__parts_constants__["G" /* DOM */]))
          }),
          taggedByHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_components_Detail_LineItemsTable_Form__["e" /* UnauthorizedRepairStationSelectedWarning */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "table",
            { className: "table" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tbody",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  { style: { width: "1%" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                    name: item + ".included",
                    component: "input",
                    type: "checkbox"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  { style: style },
                  quoteItem.part.part_number,
                  " |\xA0",
                  __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* INCOMING_LINE_ITEMS */].quoteType[quoteItem.quote_type].label,
                  " ",
                  "in\xA0",
                  __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* INCOMING_LINE_ITEMS */].condition[condition].abbrev,
                  "\xA0 Condition |\xA0",
                  qty,
                  " QTY @ ",
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(cost),
                  "/each"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  { className: "text-right", style: style },
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(Number(qty) * Number(cost))
                )
              ),
              includedInConversion && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_29__shared_components_Forms_FormRow__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        name: setField(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["n" /* CONDITION */]),
                        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["n" /* CONDITION */]),
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["c" /* Select */],
                        options: __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_components_Detail_LineItemsTable_Form__["b" /* SRP_CONDITION_OPTIONS */],
                        required: true
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        name: setField(__WEBPACK_IMPORTED_MODULE_18__constants__["j" /* QUANTITY */]),
                        label: "Qty",
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["d" /* FormInput */],
                        type: "number",
                        onBlur: function onBlur(_ev, val) {
                          if (Number(val) !== 1) {
                            setFieldValue(setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["b" /* EXPECTED_SERIAL_NUMBER */]))(null);
                          }
                          if (Number(val) === 1 && getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["m" /* PURCHASE_FOR_SALE */]))) {
                            setFieldValue(setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["n" /* RESERVE_FOR_SALE_QUANTITY */]))(1);
                          }
                        },
                        required: true
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        name: setField(__WEBPACK_IMPORTED_MODULE_18__constants__["V" /* COST */]),
                        label: getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_23__RepairOrders_constants__["d" /* PURCHASE_FOR_EXCHANGE */])) ? "Outright Price" : "Cost/Unit",
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["d" /* FormInput */],
                        type: "number",
                        required: true
                      })
                    ),
                    getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_23__RepairOrders_constants__["d" /* PURCHASE_FOR_EXCHANGE */])) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["f" /* CurrencyField */], {
                        name: setField(__WEBPACK_IMPORTED_MODULE_27__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */]),
                        label: getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_25__SalesOrders_constants__["e" /* FLAT_EXCHANGE */])) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_25__SalesOrders_constants__["f" /* FLAT_EXCHANGE_FEE */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_27__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */]),
                        disabled: quoteItem.part && quoteItem.part.pass_fail,
                        required: true
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_29__shared_components_Forms_FormRow__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 2 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["a" /* CheckGroup */],
                        { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_23__RepairOrders_constants__["c" /* EXCHANGE */]) },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                          name: setField(__WEBPACK_IMPORTED_MODULE_23__RepairOrders_constants__["d" /* PURCHASE_FOR_EXCHANGE */]),
                          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_23__RepairOrders_constants__["c" /* EXCHANGE */]),
                          icon: "fa-check-circle",
                          component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["b" /* Check */],
                          disabled: quoteItem.part && quoteItem.part.pass_fail,
                          onChange: function onChange(_evt, val) {
                            if (val) {
                              [__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["p" /* PURCHASE_FOR_REPAIR */], __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["q" /* PURCHASE_FOR_STOCK */], __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["l" /* PURCHASE_FOR_REPAIR_ASSIST */]].forEach(function (f) {
                                return setFieldValue(setField(f))(false);
                              });
                              if (Number(getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_18__constants__["j" /* QUANTITY */]))) === 1) {
                                setFieldValue(setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["n" /* RESERVE_FOR_SALE_QUANTITY */]))(1);
                              }
                              setFieldValue(setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["m" /* PURCHASE_FOR_SALE */]))(val);
                              setFieldValue(setField(__WEBPACK_IMPORTED_MODULE_23__RepairOrders_constants__["e" /* CORE_DUE_DAYS */]))(30);
                              var days = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__lib_time__["a" /* addDays */])(new Date(), 30);
                              setFieldValue(setField(__WEBPACK_IMPORTED_MODULE_23__RepairOrders_constants__["f" /* CORE_RETURN_DATE */]))(new Date(days).toISOString().split("T")[0]);
                            }
                          }
                        })
                      )
                    ),
                    getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_23__RepairOrders_constants__["d" /* PURCHASE_FOR_EXCHANGE */])) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 2 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["a" /* CheckGroup */],
                        { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_25__SalesOrders_constants__["e" /* FLAT_EXCHANGE */]) },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                          name: setField(__WEBPACK_IMPORTED_MODULE_25__SalesOrders_constants__["e" /* FLAT_EXCHANGE */]),
                          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_25__SalesOrders_constants__["e" /* FLAT_EXCHANGE */]),
                          icon: "fa-check-circle",
                          component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["b" /* Check */]
                        })
                      )
                    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 2 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        name: setField(__WEBPACK_IMPORTED_MODULE_23__RepairOrders_constants__["e" /* CORE_DUE_DAYS */]),
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["d" /* FormInput */],
                        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_23__RepairOrders_constants__["e" /* CORE_DUE_DAYS */]),
                        onChange: function onChange(_evt, val) {
                          if (val) {
                            var days = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__lib_time__["a" /* addDays */])(new Date(), Number(val));
                            setFieldValue(setField(__WEBPACK_IMPORTED_MODULE_23__RepairOrders_constants__["f" /* CORE_RETURN_DATE */]))(new Date(days).toISOString().split("T")[0]);
                          }
                        },
                        required: true
                      })
                    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["s" /* CORE_DUE_DATE */]),
                        name: setField(__WEBPACK_IMPORTED_MODULE_23__RepairOrders_constants__["f" /* CORE_RETURN_DATE */]),
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["d" /* FormInput */],
                        type: "date",
                        required: true
                      })
                    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["f" /* CurrencyField */], {
                        label: "Avg Repair (NTX)",
                        name: setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["t" /* CORE_REPAIR_FEE_NOT_TO_EXCEED */]),
                        required: getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_25__SalesOrders_constants__["e" /* FLAT_EXCHANGE */]))
                      })
                    )]
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_shared_PurchaseForFields__["a" /* default */], {
                    prefix: "" + item,
                    formName: formName,
                    getFieldValue: getFieldValue,
                    clearPurchaseFor: this.clearPurchaseFor,
                    selectedReserveForSeller: this.props.currentUser,
                    searchBuyers: searchBuyers,
                    setFieldValue: this.props.setFieldValue,
                    shippingType: shippingType,
                    condition: getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["n" /* CONDITION */])),
                    onPurchaseForStockChange: this.resetPreferredRepairStation,
                    onPurchaseForSaleChange: function onPurchaseForSaleChange(val) {
                      var fieldName = setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["n" /* RESERVE_FOR_SALE_QUANTITY */]);
                      if (val && [undefined, 1, "1"].includes(getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_18__constants__["j" /* QUANTITY */])))) {
                        setFieldValue(fieldName)(1);
                      }
                      if (!val) setFieldValue(fieldName)("");
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_29__shared_components_Forms_FormRow__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        name: item + "." + __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["o" /* ALTERNATE_ID */],
                        label: "Buy As Alternate",
                        placeholder: "Type a part's number...",
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["c" /* Select */],
                        options: altOptions,
                        addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-exchange" }),
                        disabled: altOptions.length === 0
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        name: item + "." + __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["C" /* SRP_CONDITION */],
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["c" /* Select */],
                        options: __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_components_Detail_LineItemsTable_Form__["b" /* SRP_CONDITION_OPTIONS */],
                        label: "SRP Condition",
                        required: !purchaseForSale
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["f" /* CurrencyField */], {
                        name: item + "." + __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["v" /* SUGGESTED_RETAIL */],
                        label: "SRP",
                        required: !purchaseForSale
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["f" /* CurrencyField */], {
                        name: item + "." + __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["u" /* EXCHANGE_SRP */],
                        label: "Exchange SRP",
                        required: (!shouldCheckMinValue || suggestedRetail >= minOutrightValueForExchangeConsideration) && !purchaseForSale && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_components_Detail_LineItemsTable_Form__["c" /* exchangeSrpNotAllowed */])(quoteItem.part) && ![__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["g" /* NEW_ITEM */], __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["i" /* AS_REMOVED */]].includes(getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["n" /* CONDITION */]))) && !getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_19__companies_constants__["k" /* DO_NOT_EXCHANGE */])),
                        disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_components_Detail_LineItemsTable_Form__["c" /* exchangeSrpNotAllowed */])(quoteItem.part) || getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_19__companies_constants__["k" /* DO_NOT_EXCHANGE */]))
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_29__shared_components_Forms_FormRow__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "form-group" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["r" /* MonthYearField */], {
                          name: item + "." + __WEBPACK_IMPORTED_MODULE_21__parts_constants__["G" /* DOM */],
                          component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["d" /* FormInput */],
                          label: __WEBPACK_IMPORTED_MODULE_21__parts_constants__["G" /* DOM */].toUpperCase()
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["r" /* MonthYearField */], {
                        name: item + "." + __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["x" /* TAG_DATE */],
                        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["x" /* TAG_DATE */]),
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["d" /* FormInput */],
                        required: tagRequired
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["s" /* AutoCompleteUserInputField */],
                        selectedItem: this.lineItem.tagged_by,
                        formatItem: function formatItem(result) {
                          return ((typeof result === "undefined" ? "undefined" : _typeof(result)) === "object" ? result.name : result) || "";
                        },
                        handleTaggedBy: this.handleTaggedBy,
                        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["p" /* TAGGED_BY */]),
                        name: item + "." + __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["p" /* TAGGED_BY */],
                        placeholder: "Search by a company's name",
                        required: tagRequired,
                        search: this.searchCompanies
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["d" /* FormInput */],
                        label: "Expected Serial #",
                        name: setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["b" /* EXPECTED_SERIAL_NUMBER */]),
                        disabled: Number(qty) !== 1
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_29__shared_components_Forms_FormRow__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 2 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        name: item + "." + __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["G" /* LEAD_TIME */],
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["d" /* FormInput */],
                        label: "Lead Time (Days)",
                        required: true
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        name: setField(__WEBPACK_IMPORTED_MODULE_11__constants__["d" /* PURCHASE_STATUS */]),
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["c" /* Select */],
                        options: __WEBPACK_IMPORTED_MODULE_11__constants__["e" /* PURCHASE_STATUS_OPTIONS */],
                        label: __WEBPACK_IMPORTED_MODULE_11__constants__["f" /* PURCHASE_STATUS_LABEL */],
                        required: true
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 2 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Locations_components_ToolsUsedDropDown__["a" /* default */], { name: setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["J" /* TOOL_USED */]) })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 2 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["a" /* CheckGroup */],
                        { title: "As-is" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_5_redux_form__["FormSection"],
                          { name: item },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Fields"], {
                            names: [__WEBPACK_IMPORTED_MODULE_11__constants__["c" /* AS_IS */], __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["u" /* EVALUATION_PERIOD */], __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["q" /* PURCHASE_FOR_STOCK */]],
                            component: __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_components_Detail_LineItemsTable_Form__["f" /* AsIsField */]
                          })
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 2 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        name: item + ".warranty_period",
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["c" /* Select */],
                        options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["r" /* WARRANTY_PERIOD */]),
                        label: "Warranty Period"
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_29__shared_components_Forms_FormRow__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        name: item + ".preferred_repair_station_id",
                        label: "Suggested Repair Station",
                        placeholder: "Type a vendor's name or code...",
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["n" /* AutoCompleteField */],
                        search: searchRepairStations,
                        selectedItem: selectedPreferredRepairStation,
                        formatItem: function formatItem(result) {
                          return result && result.name;
                        },
                        disabled: purchaseForStock,
                        required: this.repairStationRequired,
                        watch: purchaseForStock && selectedPreferredRepairStation,
                        onItemSelected: this.handlePreferredRepairStation
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        name: setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["u" /* EVALUATION_PERIOD */]),
                        type: "number",
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["d" /* FormInput */],
                        label: "Eval. Period"
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        name: setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["A" /* CAP_TYPE */]),
                        className: "text-right",
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["c" /* Select */],
                        options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["B" /* CAP_TYPES */]),
                        label: "Repair/Overhaul Cap",
                        onChange: function onChange(_, val) {
                          if (!val) {
                            setFieldValue(setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["C" /* CAP_AMOUNT */]))(null);
                          }
                        }
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["f" /* CurrencyField */], {
                        name: setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["C" /* CAP_AMOUNT */]),
                        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["B" /* CAP_TYPES */], capType + ".label", "") + " Cap Amount",
                        disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_lodash__["isEmpty"])(capType)
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_29__shared_components_Forms_FormRow__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 5 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "form-group" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "label",
                          { htmlFor: "warnings", className: "control-label" },
                          "Line Hazmat"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_5_redux_form__["FormSection"],
                          { name: item },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Fields"], {
                            names: [__WEBPACK_IMPORTED_MODULE_21__parts_constants__["h" /* HAZMAT */], __WEBPACK_IMPORTED_MODULE_21__parts_constants__["i" /* BIO_HAZMAT */]],
                            component: __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_components_Detail_LineItemsTable_Form__["g" /* LineHazmatFields */]
                          })
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["a" /* CheckGroup */],
                        { title: "Heavy Package / DIM WT", justified: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                          name: setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["v" /* DIM_WEIGHT */]),
                          component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["b" /* Check */],
                          label: "Hvy Pkg / DIM",
                          icon: "fa-check-circle"
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 2 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["a" /* CheckGroup */],
                        { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["a" /* INCIDENT */]), justified: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                          name: setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["a" /* INCIDENT */]),
                          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["a" /* INCIDENT */]),
                          component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["b" /* Check */],
                          icon: "fa-check-circle"
                        })
                      )
                    ),
                    getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_21__parts_constants__["h" /* HAZMAT */])) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 2 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["f" /* CurrencyField */], {
                        name: setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]),
                        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]),
                        required: true
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_29__shared_components_Forms_FormRow__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["a" /* CheckGroup */],
                        { title: "Do Not Sell!", justified: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                          name: setField(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["z" /* UNSELLABLE_PER_USER */]),
                          component: function component(props) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["b" /* Check */], _extends({}, props, { icon: "fa-diamond" }));
                          },
                          label: "Do Not Sell!"
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["a" /* CheckGroup */],
                        { title: "Do Not Exchange", justified: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                          name: setField(__WEBPACK_IMPORTED_MODULE_19__companies_constants__["k" /* DO_NOT_EXCHANGE */]),
                          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_19__companies_constants__["k" /* DO_NOT_EXCHANGE */]),
                          component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["b" /* Check */],
                          onChange: function onChange(_, val) {
                            if (val) {
                              setFieldValue(setField(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["u" /* EXCHANGE_SRP */]))("");
                            }
                          }
                        })
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_29__shared_components_Forms_FormRow__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 12 },
                      preferredRepairStationHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_components_Detail_LineItemsTable_Form__["h" /* UnauthorizedPreferredRepairStationSelectedWarning */], null)
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_29__shared_components_Forms_FormRow__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 12 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        {
                          className: "form-group",
                          style: { cursor: "pointer" }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "label",
                          { className: "control-label", htmlFor: "tag_type" },
                          "Release Type"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "div",
                          {
                            id: "tag_type",
                            className: "btn-group btn-group-justified",
                            "data-toggle": "buttons"
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                            component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["b" /* Check */],
                            name: setField(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["H" /* FAA */]),
                            label: __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["H" /* FAA */].toUpperCase(),
                            icon: "fa-check-circle"
                          }),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                            component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["b" /* Check */],
                            name: setField(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["I" /* EASA */]),
                            label: __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["I" /* EASA */].toUpperCase(),
                            icon: "fa-check-circle"
                          }),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                            component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["b" /* Check */],
                            name: setField(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["L" /* UK_CAA */]),
                            label: __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["L" /* UK_CAA */].toUpperCase(),
                            icon: "fa-check-circle"
                          }),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                            component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["b" /* Check */],
                            name: setField(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["K" /* TCCA */]),
                            label: __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["K" /* TCCA */].toUpperCase(),
                            icon: "fa-check-circle"
                          }),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                            component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["b" /* Check */],
                            name: setField(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["J" /* CAAC */]),
                            label: __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["J" /* CAAC */].toUpperCase(),
                            icon: "fa-check-circle"
                          }),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                            component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["b" /* Check */],
                            name: setField(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["M" /* OTHER */]),
                            label: __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["M" /* OTHER */].toUpperCase(),
                            onChange: function onChange(val) {
                              if (!val) setFieldValue(setField(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["N" /* OTHER_TAG_TYPE */]))("");
                            },
                            icon: "fa-check-circle"
                          })
                        )
                      ),
                      !getFieldValue(setField(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["M" /* OTHER */])) ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_29__shared_components_Forms_FormRow__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                          { md: 5 },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                            component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["d" /* FormInput */],
                            name: setField(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["N" /* OTHER_TAG_TYPE */]),
                            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_17__inventories_constants__["N" /* OTHER_TAG_TYPE */]),
                            maxLength: 10,
                            max: 10
                          })
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_29__shared_components_Forms_FormRow__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 6 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        name: setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["G" /* INTERNAL_NOTE */]),
                        rows: 5,
                        cols: 50,
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["l" /* TextArea */],
                        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["G" /* INTERNAL_NOTE */])
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                      { md: 6 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        name: setField(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */]),
                        rows: 5,
                        cols: 50,
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["l" /* TextArea */],
                        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */])
                      })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null)
              )
            )
          )
        )
      );
    }
  }, {
    key: "lineItem",
    get: function get() {
      var _props2 = this.props,
          lineItems = _props2.lineItems,
          idx = _props2.idx;


      return lineItems[idx];
    }
  }, {
    key: "repairStationRequired",
    get: function get() {
      var _props3 = this.props,
          purchaseForRepair = _props3.purchaseForRepair,
          condition = _props3.condition,
          getFieldValue = _props3.getFieldValue,
          item = _props3.item;


      return purchaseForRepair || condition === __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["i" /* AS_REMOVED */] && !getFieldValue(item + "." + __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["m" /* PURCHASE_FOR_SALE */]) && !getFieldValue(item + "." + __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["q" /* PURCHASE_FOR_STOCK */]);
    }
  }]);

  return LineItemRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LineItemRow.propTypes = {
  getFieldValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  currentUser: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  lineItems: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(Object),
  lineItemValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(Object),
  searchBuyers: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  shippingType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  searchRepairStations: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  item: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  idx: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
  setPreferredRepairStationHold: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  resetPreferredRepairStation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  handleTaggedBy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  purchaseForSale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  purchaseForStock: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  purchaseForRepair: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  srpCondition: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  condition: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  preferredRepairStationHold: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  setTaggedByHold: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  taggedByHold: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};


var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state, props) {
  return {
    getFieldValue: function getFieldValue(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["formValueSelector"])(formName)(state, field);
    },
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_16__users_constants__["a" /* USER */]).toJS(),
    lineItemValues: selector(state, "line_items"),
    shippingType: selector(state, __WEBPACK_IMPORTED_MODULE_18__constants__["o" /* SHIPPING_TYPE */]),
    purchaseForRepair: selector(state, props.item + ".purchase_for_repair"),
    purchaseForStock: selector(state, props.item + ".purchase_for_stock"),
    purchaseForSale: selector(state, props.item + ".purchase_for_sale"),
    srpCondition: selector(state, props.item + ".srp_condition"),
    condition: selector(state, props.item + ".condition"),
    preferredRepairStationHold: selector(state, props.item + ".preferred_repair_station_hold"),
    taggedByHold: selector(state, props.item + ".tagged_by_hold")
  };
}, function (dispatch) {
  return {
    searchRepairStations: function searchRepairStations(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_actions__["f" /* searchRepairStations */](filter));
    },
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_actions__["c" /* searchBuyers */](filter));
    },
    resetPreferredRepairStation: function resetPreferredRepairStation(item) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(formName, item + ".preferred_repair_station_id", ""));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(formName, field, val));
      };
    },
    setPreferredRepairStationHold: function setPreferredRepairStationHold(item, hold) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(formName, item + ".preferred_repair_station_hold", hold));
    },
    setTaggedByHold: function setTaggedByHold(item, hold) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(formName, item + ".tagged_by_hold", hold));
    }
  };
})(LineItemRow));

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_shared_validations__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;














var validateLineItem = function validateLineItem(props) {
  return function (item, itemValues) {
    if (!itemValues.included) {
      return;
    }

    item.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_7__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_7__constants__["V" /* COST */], __WEBPACK_IMPORTED_MODULE_8__constants__["d" /* PURCHASE_STATUS */], __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["J" /* TOOL_USED */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);

    item.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["G" /* LEAD_TIME */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["g" /* requiredAllowZero */]);

    if (__WEBPACK_IMPORTED_MODULE_11__Receiving_constants__["u" /* TAG_DATE_CONDITIONS */].includes(itemValues.condition)) {
      item.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["p" /* TAGGED_BY */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    }

    if (itemValues.hazmat) {
      item.validate(__WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0));
    }

    if (!(itemValues.purchase_for_sale && Number(itemValues.quantity) === Number(itemValues[__WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["n" /* RESERVE_FOR_SALE_QUANTITY */]]))) {
      item.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["C" /* SRP_CONDITION */], __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["v" /* SUGGESTED_RETAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(itemValues, "part.pass_fail") && ![__WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["i" /* AS_REMOVED */], __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["g" /* NEW_ITEM */]].includes(itemValues.condition) && !itemValues.do_not_exchange) {
        var minOutrightValueForExchangeSettings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__hooks_useCurrentUser__["b" /* useSettings */])().min_outright_value_for_exchange_consideration;
        var suggestedRetail = parseFloat(itemValues.suggested_retail);
        var minOutrightValue = parseFloat(minOutrightValueForExchangeSettings);
        var shouldCheckMinValue = minOutrightValueForExchangeSettings !== null && minOutrightValueForExchangeSettings !== undefined;

        if (!shouldCheckMinValue || suggestedRetail >= minOutrightValue) {
          item.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["u" /* EXCHANGE_SRP */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["f" /* isGreaterThan */](0));
        }
      }
    }

    if (itemValues.purchase_for_stock) {
      item.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["C" /* SRP_CONDITION */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["i" /* matches */](__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["n" /* CONDITION */]));
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(itemValues, "part.dom_life_years") && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(itemValues, "part.llp")) {
      item.validate(__WEBPACK_IMPORTED_MODULE_6__parts_constants__["G" /* DOM */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    }

    if (itemValues.purchase_for_repair || itemValues.condition === __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["i" /* AS_REMOVED */] && !itemValues.purchase_for_sale && !itemValues.purchase_for_stock) {
      item.validate(__WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["w" /* PREFERRED_REPAIR_STATION_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    }

    if (itemValues.purchase_for_exchange) {
      item.validate(__WEBPACK_IMPORTED_MODULE_9__RepairOrders_constants__["e" /* CORE_DUE_DAYS */], __WEBPACK_IMPORTED_MODULE_9__RepairOrders_constants__["f" /* CORE_RETURN_DATE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
      item.validate(__WEBPACK_IMPORTED_MODULE_7__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["j" /* mustBeOne */]);

      if (!itemValues.do_not_exchange) {
        item.validate(__WEBPACK_IMPORTED_MODULE_10__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
      }

      if (itemValues.flat_exchange) {
        item.validate(__WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["t" /* CORE_REPAIR_FEE_NOT_TO_EXCEED */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
      }
    }
    if (itemValues.exchange_srp && props.minExchangeSrp && !itemValues.do_not_exchange) {
      item.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["u" /* EXCHANGE_SRP */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](props.minExchangeSrp));
    } else if (itemValues.exchange_srp && !itemValues.do_not_exchange) {
      item.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["u" /* EXCHANGE_SRP */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["f" /* isGreaterThan */](0));
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_shared_validations__["d" /* validateConditionFields */])(itemValues, item);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_shared_validations__["a" /* validatePurchaseForFields */])(itemValues, item);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_shared_validations__["b" /* validatePurchaseForSaleFields */])(itemValues, item);
  };
};

function validate(values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["h" /* PAYMENT_TERMS */], __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["g" /* BUYING_STORE_ID */], __WEBPACK_IMPORTED_MODULE_7__constants__["G" /* BUYER_CREDIT_PCT */], __WEBPACK_IMPORTED_MODULE_7__constants__["H" /* FOB */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    form.validateChildren(__WEBPACK_IMPORTED_MODULE_7__constants__["A" /* LINE_ITEMS */], validateLineItem(props));
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_shared_validations__["c" /* validateShippingFields */])(values, form);
  });
}

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(139);









function DeleteIncomingQuote(_ref) {
  var incomingQuote = _ref.incomingQuote,
      destroy = _ref.destroy;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components__["R" /* AuthorizedOwner */],
    { record: incomingQuote },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { className: "divider" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_containers__["a" /* ToggleSwitch */],
      null,
      function (visible, open, close) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__["a" /* default */],
          { onClick: open },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "text-danger" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              null,
              "Delete Incoming Quote"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["q" /* ConfirmDelete */],
            { onConfirm: destroy, close: close, open: visible },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              null,
              "Heads up!"
            ),
            " Are you sure you want to delete this?"
          )
        );
      }
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, { destroy: __WEBPACK_IMPORTED_MODULE_7__actions__["j" /* deleteIncomingQuote */] })(DeleteIncomingQuote));

DeleteIncomingQuote.propTypes = {
  incomingQuote: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  destroy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Edit_EditQuote__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(139);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var DetailsTable = function (_React$Component) {
  _inherits(DetailsTable, _React$Component);

  function DetailsTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DetailsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DetailsTable.__proto__ || Object.getPrototypeOf(DetailsTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editOpen: false
    }, _this.openModal = function () {
      _this.setState({ editOpen: true });
    }, _this.closeEditModal = function () {
      _this.setState({ editOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DetailsTable, [{
    key: "render",
    value: function render() {
      var incomingQuote = this.props.incomingQuote;
      var editOpen = this.state.editOpen;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "panel panel-default" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "panel-body" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h2",
            { style: { marginTop: 10 } },
            "Details",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["y" /* EditButton */], { handleClick: this.openModal }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Edit_EditQuote__["a" /* default */], {
              quote: incomingQuote.toJS(),
              updateQuote: __WEBPACK_IMPORTED_MODULE_9__actions__["g" /* updateIncomingQuote */],
              open: editOpen,
              close: this.closeEditModal
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "table",
            { className: "table table-condensed" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tbody",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Buyer"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  incomingQuote.getIn([__WEBPACK_IMPORTED_MODULE_8__users_constants__["P" /* BUYER */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["f" /* FULL_NAME */]])
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Vendor Code"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  incomingQuote.getIn([__WEBPACK_IMPORTED_MODULE_5__constants__["i" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_5__constants__["z" /* CODE */]])
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Vendor Name"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  incomingQuote.getIn([__WEBPACK_IMPORTED_MODULE_5__constants__["i" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]]) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["w" /* CompanyName */], { company: incomingQuote.toJS().company }) : incomingQuote.get("legacy_company_name") + " (LEGACY)"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Vendor Phone"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  incomingQuote.getIn([__WEBPACK_IMPORTED_MODULE_5__constants__["i" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_5__constants__["R" /* PHONE */]])
                )
              ),
              incomingQuote.get(__WEBPACK_IMPORTED_MODULE_7__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Vendor Portal"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["r" /* ExternalLink */], {
                    url: incomingQuote.getIn([__WEBPACK_IMPORTED_MODULE_5__constants__["i" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_6__companies_constants__["e" /* WEBSITE */]])
                  })
                )
              )
            )
          ),
          !incomingQuote.get(__WEBPACK_IMPORTED_MODULE_7__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */]) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["m" /* DashedSeparator */], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "table",
            { className: "table table-condensed" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tbody",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Contact"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  incomingQuote.getIn([__WEBPACK_IMPORTED_MODULE_6__companies_constants__["g" /* CONTACT */], __WEBPACK_IMPORTED_MODULE_5__constants__["S" /* NAME */]])
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Contact Email"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "a",
                    { href: "mailto:" + incomingQuote.getIn([__WEBPACK_IMPORTED_MODULE_6__companies_constants__["g" /* CONTACT */], __WEBPACK_IMPORTED_MODULE_5__constants__["T" /* EMAIL */]]) },
                    incomingQuote.getIn([__WEBPACK_IMPORTED_MODULE_6__companies_constants__["g" /* CONTACT */], __WEBPACK_IMPORTED_MODULE_5__constants__["T" /* EMAIL */]])
                  )
                )
              )
            )
          )],
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["z" /* AuditFields */], { record: incomingQuote, multiLine: true })
        )
      );
    }
  }]);

  return DetailsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DetailsTable);


DetailsTable.propTypes = {
  incomingQuote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form__ = __webpack_require__(1334);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditQuote;







function EditQuote(_ref) {
  var quote = _ref.quote,
      open = _ref.open,
      close = _ref.close,
      updateQuote = _ref.updateQuote;

  var initialValues = {
    buyer_id: quote.buyer_id,
    company_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(quote, "company.id"),
    contact_id: quote.portal_purchase ? __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */] : quote.contact && quote.contact.id,
    company: {
      website: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(quote, "company.website")
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-sm" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Edit Quote Details"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Form__["a" /* default */], {
        quote: quote,
        close: close,
        updateQuote: updateQuote,
        initialValues: initialValues,
        enableReinitialize: true
      })
    )
  );
}

EditQuote.propTypes = {
  quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  updateQuote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__companies_shared_FindOrCreateCompanyToggle_SearchCompanyField__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__companies_actions_actions__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__companies_helpers__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__users_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__validate__ = __webpack_require__(1335);
/* unused harmony export Form */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var FORM_NAME = "editQuote";

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedBuyer: {},
      selectedCompany: {},
      options: [{ text: "+ Add a Contact", value: "Add" }]
    }, _this.fetchContactOptions = function (companyId) {
      if (companyId) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_actions__["g" /* searchContacts */])(companyId).then(function () {
          var vals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

          var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__companies_helpers__["b" /* contactSelectList */])(vals, true);

          return _this.setState({ options: opts });
        });
      }

      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.quote && this.props.quote.company) {
        this.fetchContactOptions(this.props.quote.company.id);
        this.setState({
          selectedBuyer: this.props.quote.buyer,
          selectedCompany: this.props.quote.company
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          quote = _props.quote,
          contact = _props.contact,
          searchBuyers = _props.searchBuyers,
          setFieldValue = _props.setFieldValue;
      var selectedBuyer = this.state.selectedBuyer;

      var addContact = contact === "Add";
      var portalPurchase = contact === __WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */];
      var options = this.state.options;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_17__users_constants__["x" /* BUYER_ID */],
                label: "Buyer",
                placeholder: "Search by name...",
                component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["n" /* AutoCompleteField */],
                search: searchBuyers,
                selectedItem: selectedBuyer,
                onItemSelected: function onItemSelected(item) {
                  return _this2.setState({ selectedBuyer: item });
                },
                formatItem: function formatItem(result) {
                  return result && result.full_name;
                },
                required: true
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], {
                  names: [__WEBPACK_IMPORTED_MODULE_9__constants__["N" /* COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_9__constants__["O" /* CONTACT_ID */]],
                  component: __WEBPACK_IMPORTED_MODULE_7__companies_shared_FindOrCreateCompanyToggle_SearchCompanyField__["a" /* default */],
                  selectedCompany: quote && quote.company,
                  onResultSelected: function onResultSelected(result) {
                    _this2.fetchContactOptions(result.id);
                    _this2.setState({
                      selectedCompany: result
                    });
                    setFieldValue([__WEBPACK_IMPORTED_MODULE_9__constants__["i" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_15__companies_constants__["e" /* WEBSITE */]].join("."))(result.website);
                  },
                  placeholder: "Search by typing a company's name or code",
                  required: true
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_9__constants__["O" /* CONTACT_ID */],
                  component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["c" /* Select */],
                  options: options,
                  label: "Vendor Contact",
                  required: true
                })
              )
            )
          ),
          portalPurchase && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.state, "selectedCompany.website"),
                  name: "company.website",
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_15__companies_constants__["e" /* WEBSITE */]),
                  required: true
                })
              )
            )
          ),
          addContact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    name: "contact.name",
                    component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                    label: "Contact Name",
                    required: true
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    name: "contact.email",
                    component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                    label: "Contact Email",
                    required: true
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  contact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
    })
  })
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(FORM_NAME);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    contact: selector(state, __WEBPACK_IMPORTED_MODULE_9__constants__["O" /* CONTACT_ID */])
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(ownProps.updateQuote(data));
    },
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_16__users_actions__["h" /* searchUsers */](filter));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(FORM_NAME, field, val));
      };
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_18__validate__["a" /* default */],
  asyncValidate: __WEBPACK_IMPORTED_MODULE_8__companies_actions_actions__["b" /* validateContact */],
  asyncBlurFields: ["contact.email"]
})(Form)));

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_constants__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;







function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_5__users_constants__["x" /* BUYER_ID */], __WEBPACK_IMPORTED_MODULE_1__constants__["N" /* COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_1__constants__["O" /* CONTACT_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);

    if (values.contact_id === __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */]) {
      form.validateChild(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* COMPANY */], function (companyForm) {
        companyForm.validate(__WEBPACK_IMPORTED_MODULE_2__companies_constants__["e" /* WEBSITE */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
      });
    }

    if (values.contact_id === __WEBPACK_IMPORTED_MODULE_1__constants__["F" /* ADD */]) {
      form.validateChild(__WEBPACK_IMPORTED_MODULE_2__companies_constants__["g" /* CONTACT */], function (contactForm) {
        contactForm.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["T" /* EMAIL */], __WEBPACK_IMPORTED_MODULE_1__constants__["S" /* NAME */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
        contactForm.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["T" /* EMAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["b" /* isValidEmail */]);
      });
    }
  });
}

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConvertToPurchaseOrder_ConvertToPurchaseOrder__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Send_Send__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DeleteIncomingQuote__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImportIncomingQuote_ImportIncomingQuote__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ActionDropDown_ActionDropDown__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(139);
/* unused harmony export Actions */











function Actions(_ref) {
  var incomingQuote = _ref.incomingQuoteWithAllLineItems;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_ActionDropDown_ActionDropDown__["a" /* default */],
    {
      menuClass: "dropdown-menu-right",
      style: { cursor: "pointer" }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ConvertToPurchaseOrder_ConvertToPurchaseOrder__["a" /* default */], { incomingQuote: incomingQuote }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Send_Send__["a" /* default */], { quote: incomingQuote }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DeleteIncomingQuote__["a" /* default */], { incomingQuote: incomingQuote }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ImportIncomingQuote_ImportIncomingQuote__["a" /* default */], { incomingQuote: incomingQuote })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_router__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(function (state) {
  return {
    incomingQuoteWithAllLineItems: state.incomingQuoteWithAllLineItemsDetail.get("incomingQuoteWithAllLineItems")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_decorators__["h" /* loadRecord */])({
  reducer: "incomingQuoteWithAllLineItemsDetail",
  name: "incomingQuoteWithAllLineItems",
  action: function action(id) {
    return __WEBPACK_IMPORTED_MODULE_9__actions__["h" /* fetchIncomingQuoteWithAllLineItems */](id);
  }
})(Actions))));

Actions.propTypes = {};

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_RecordPager__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Actions__ = __webpack_require__(1336);
/* harmony export (immutable) */ __webpack_exports__["a"] = Header;









function Header(_ref) {
  var incomingQuote = _ref.incomingQuote;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "page-header page-header-bar" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h1",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "btn-group pull-right", style: { marginLeft: 20 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Actions__["a" /* default */], null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "with-padding" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_RecordPager__["a" /* default */], { baseUrl: "/incoming-quotes", record: incomingQuote }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "header-content" },
          incomingQuote.get(__WEBPACK_IMPORTED_MODULE_5__constants__["z" /* CODE */])
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "small text-muted" },
          "Created ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["b" /* shortDate */])(incomingQuote.get(__WEBPACK_IMPORTED_MODULE_5__constants__["_7" /* CREATED_AT */]))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "pull-right" },
          "Total: ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(incomingQuote.get("total"))
        )
      )
    )
  );
}

Header.propTypes = {
  incomingQuote: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])
};

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RepairQuotes_constants__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
















var formName = "importIQItems";

function Form(props) {
  var QUOTE_TYPES = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_removeKey__["b" /* removeKeys */])(__WEBPACK_IMPORTED_MODULE_10__constants__["b" /* INCOMING_LINE_ITEMS */].quoteType, [__WEBPACK_IMPORTED_MODULE_13__RepairQuotes_constants__["e" /* AWAITING_REPLY */], __WEBPACK_IMPORTED_MODULE_10__constants__["l" /* INCIDENT_RELATED */], __WEBPACK_IMPORTED_MODULE_10__constants__["t" /* NOT_AWAITING_REPLY */], __WEBPACK_IMPORTED_MODULE_10__constants__["q" /* MAKE_OFFER */], __WEBPACK_IMPORTED_MODULE_10__constants__["m" /* OFFER */], __WEBPACK_IMPORTED_MODULE_10__constants__["c" /* AS_IS */]]);

  var FILES = {
    exchange_only: "https://info-trader-assets.s3.us-east-2.amazonaws.com/public/Incoming_Quote_Exchange_Quote_Template_v2.csv",
    no_quote: "https://info-trader-assets.s3.us-east-2.amazonaws.com/public/No_Quote_Template.csv",
    standard: "https://info-trader-assets.s3.us-east-2.amazonaws.com/public/Incoming_Quote_Standard_Quote_Template_v2.csv"
  };

  var WARNINGS = {
    exchange_only: "Please label column header: part_number, cond, qty, cost, exchange_fee, tag_date, lead_time, notes. Acceptable condition codes: ne, oh, bt, sv tooling, ar, br. Cost and Exchange Fee can be entered as 0. Tag Date can remain blank.  The date format is MM/DD/YYYY. Import must be in .csv format.",
    no_quote: "Please label column header fields: part_number. The import file\n" + "              must be in .csv format.",
    standard: "Please label column header: part_number, desc, cond, qty, cost, tag_date, lead_time, notes.  Acceptable condition codes: ne, oh, sv, bt, sv tooling, ar, br.  Cost must be greater than 0 and cannot be blank.  Lead time can be entered as 0. tag_date can remain blank.  The date format is MM/DD/YYYY.  Import must be in .csv format."
  };

  var fileLink = FILES[props.getFieldValue(__WEBPACK_IMPORTED_MODULE_11__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */])];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Body,
      null,
      props.getFieldValue(__WEBPACK_IMPORTED_MODULE_11__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components__["n" /* Warning */],
          null,
          WARNINGS[props.getFieldValue(__WEBPACK_IMPORTED_MODULE_11__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */])]
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_11__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */],
            component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["c" /* Select */],
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_forms__["a" /* toOptions */])(QUOTE_TYPES),
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */]),
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "file",
            component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["k" /* FileInput */],
            label: "Upload Attachment",
            required: true
          })
        )
      ),
      fileLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 8, mdOffset: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { href: fileLink, target: "_blank", rel: "noopener noreferrer" },
            "Template"
          )
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["i" /* importLineItems */])(data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["j" /* form */])({
  form: formName
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form__ = __webpack_require__(1338);
/* harmony export (immutable) */ __webpack_exports__["a"] = ImportIncomingQuote;







function ImportIncomingQuote(_ref) {
  var incomingQuote = _ref.incomingQuote;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components__["l" /* DropDownItem */],
        { onClick: open },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "download", fixed: true }),
        "\xA0Import Incoming Quote",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
          { open: visible, close: close, dialogClass: "modal-sm" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Import Incoming Quote"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Form__["a" /* default */], {
            close: close,
            enableReinitialize: true,
            incomingQuote: incomingQuote
          })
        )
      );
    }
  );
}

ImportIncomingQuote.propTypes = {
  incomingQuote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Attachments_Attachments__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Notes_Notes__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LineItems_LineItemsTable__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DetailsTable__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Header_Header__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pagination__ = __webpack_require__(318);
/* unused harmony export Detail */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var legacyWarning = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  "div",
  { className: "alert alert-danger" },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "strong",
    null,
    "Legacy Quote"
  ),
  " Company and contact must be assigned"
);

var Detail = function (_Component) {
  _inherits(Detail, _Component);

  function Detail() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Detail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Detail.__proto__ || Object.getPrototypeOf(Detail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editPartModalOpen: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Detail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.expire();
    }
  }, {
    key: "render",
    value: function render() {
      var incomingQuote = this.props.incomingQuote;

      var showLegacyWarning = !incomingQuote.get(__WEBPACK_IMPORTED_MODULE_10__constants__["i" /* COMPANY */]) || !incomingQuote.get(__WEBPACK_IMPORTED_MODULE_9__companies_constants__["g" /* CONTACT */]) && !incomingQuote.get(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Header_Header__["a" /* default */], { incomingQuote: incomingQuote }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__DetailsTable__["a" /* default */], { incomingQuote: incomingQuote })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["e" /* Col */],
            { md: 9 },
            showLegacyWarning && legacyWarning,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__LineItems_LineItemsTable__["a" /* default */], { quote: incomingQuote }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Notes_Notes__["a" /* default */], {
              resource: incomingQuote,
              resourceType: __WEBPACK_IMPORTED_MODULE_5__shared_types_resourceTypes__["a" /* default */].incomingQuote,
              resourceKey: "incomingQuote"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Attachments_Attachments__["a" /* default */], {
              resource: incomingQuote,
              resourceType: __WEBPACK_IMPORTED_MODULE_5__shared_types_resourceTypes__["a" /* default */].incomingQuote,
              resourceKey: "incomingQuote",
              attachmentTypes: __WEBPACK_IMPORTED_MODULE_8__constants__["u" /* ATTACHMENT_TYPES */],
              multiple: true
            })
          )
        )
      );
    }
  }]);

  return Detail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Detail.propTypes = {
  incomingQuote: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  expire: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    incomingQuote: state.incomingQuoteDetail.get("incomingQuote")
  };
}, function (dispatch) {
  return {
    expire: function expire() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_17__pagination__["a" /* incomingQuotePagination */].pageActions.expire());
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["h" /* loadRecord */])({
  reducer: "incomingQuoteDetail",
  name: "incomingQuote",
  action: function action(id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions__["b" /* show */])(id, "no_lines");
  }
})(Detail)));

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ConvertToOutgoingQuote_ConvertToOutgoingQuoteModal__ = __webpack_require__(1342);











function Controls(_ref) {
  var deleteItem = _ref.deleteItem,
      updateQuoteType = _ref.updateQuoteType,
      lineItem = _ref.lineItem;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__["c" /* ImprovedDropDown */],
    null,
    lineItem.quote_type === __WEBPACK_IMPORTED_MODULE_6__constants__["n" /* AWAITING_REPLY */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
      id: __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* NO_QUOTE */],
      label: "No Quote",
      faIcon: "exchange",
      renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components__["i" /* ConfirmAction */],
        { onConfirm: updateQuoteType, btnText: "Confirm" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          "Are you sure you want to change the Incoming Quote type to \"No Quote\"?"
        )
      )
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
      hideIf: lineItem.quote_type !== __WEBPACK_IMPORTED_MODULE_7__RepairQuotes_constants__["p" /* STANDARD */],
      label: "Convert To Outgoing Quote",
      id: "convert-to-quote",
      faIcon: "refresh",
      renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ConvertToOutgoingQuote_ConvertToOutgoingQuoteModal__["a" /* default */], { lineItem: lineItem })
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
      id: "delete",
      label: "Delete",
      faIcon: "ban",
      renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["q" /* ConfirmDelete */], { onConfirm: deleteItem })
    })
  );
}

Controls.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    quote_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  deleteItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateQuoteType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch, _ref2) {
  var id = _ref2.lineItem.id;
  return {
    deleteItem: function deleteItem() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["e" /* deleteIncomingQuoteLineItem */])(id));
    },
    updateQuoteType: function updateQuoteType() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* updateIncomingQuoteLineItem */])({ quote_type: __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* NO_QUOTE */] }, id));
    }
  };
})(Controls));

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(1343);






function ConvertToOutgoingQuoteModal(_ref) {
  var lineItem = _ref.lineItem,
      open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Convert To Outgoing Quote"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], {
      close: close,
      convertToQuote: __WEBPACK_IMPORTED_MODULE_3__actions__["f" /* convertToOutgoingQuote */],
      lineItem: lineItem
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (ConvertToOutgoingQuoteModal);

ConvertToOutgoingQuoteModal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__companies_shared_FindOrCreateCompanyToggle_SearchCompanyField__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__companies_actions_actions__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__companies_helpers__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components_Forms_CurrencyField__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__validate__ = __webpack_require__(1344);
/* unused harmony export Form */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var FORM_NAME = "convertToOutgoingQuote";

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedCompany: {},
      options: [{ text: "+ Add a Contact", value: "Add" }]
    }, _this.fetchContactOptions = function (companyId) {
      if (companyId) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_actions__["g" /* searchContacts */])(companyId).then(function () {
          var vals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

          var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__companies_helpers__["b" /* contactSelectList */])(vals);
          _this.props.setFieldValue(__WEBPACK_IMPORTED_MODULE_9__constants__["O" /* CONTACT_ID */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(vals.filter(function (v) {
            return v.primary;
          })[0], __WEBPACK_IMPORTED_MODULE_15__users_constants__["_27" /* ID */]));

          return _this.setState({ options: opts });
        });
      }

      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var contact = this.props.contact;

      var addContact = contact === "Add";
      var options = this.state.options;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], {
                  names: [__WEBPACK_IMPORTED_MODULE_9__constants__["N" /* COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_9__constants__["O" /* CONTACT_ID */]],
                  component: __WEBPACK_IMPORTED_MODULE_7__companies_shared_FindOrCreateCompanyToggle_SearchCompanyField__["a" /* default */],
                  onResultSelected: function onResultSelected(result) {
                    _this2.fetchContactOptions(result.id);
                    _this2.setState({
                      selectedCompany: result
                    });
                  },
                  type: "outgoingQuote",
                  placeholder: "Search by typing a company's name or code",
                  required: true
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_9__constants__["O" /* CONTACT_ID */],
                  component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["c" /* Select */],
                  options: options,
                  label: "Customer Contact",
                  required: true
                })
              )
            )
          ),
          addContact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    name: "contact.name",
                    component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                    label: "Contact Name",
                    required: true
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    name: "contact.email",
                    component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                    label: "Contact Email",
                    required: true
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components_Forms_CurrencyField__["a" /* default */], {
            name: __WEBPACK_IMPORTED_MODULE_13__OutgoingQuotes_constants__["b" /* PRICE_PER_UNIT */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__OutgoingQuotes_constants__["b" /* PRICE_PER_UNIT */]),
            required: true
          })
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  contact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
    })
  })
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(FORM_NAME);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    contact: selector(state, __WEBPACK_IMPORTED_MODULE_9__constants__["O" /* CONTACT_ID */])
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(ownProps.convertToQuote(ownProps.lineItem.id, data));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(FORM_NAME, field, val));
      };
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_17__validate__["a" /* default */],
  asyncValidate: __WEBPACK_IMPORTED_MODULE_8__companies_actions_actions__["b" /* validateContact */],
  asyncBlurFields: ["contact.email"]
})(Form)));

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;






function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["N" /* COMPANY_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
    form.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["O" /* CONTACT_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
    form.validate(__WEBPACK_IMPORTED_MODULE_4__OutgoingQuotes_constants__["b" /* PRICE_PER_UNIT */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);

    if (values.contact_id === __WEBPACK_IMPORTED_MODULE_1__constants__["F" /* ADD */]) {
      form.validateChild(__WEBPACK_IMPORTED_MODULE_2__companies_constants__["g" /* CONTACT */], function (contactForm) {
        contactForm.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["T" /* EMAIL */], __WEBPACK_IMPORTED_MODULE_1__constants__["S" /* NAME */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
        contactForm.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["T" /* EMAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["b" /* isValidEmail */]);
      });
    }
  });
}

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parts_New__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_LineItemStatusCell__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__parts_components_ModifiedFlag__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_IncidentRelatedFlag__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_AsIsFlag__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Parts_EditPart__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Controls__ = __webpack_require__(1341);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var paginatorList = "incomingQuotes/lineItems";

var LineItemsTable = function (_Component) {
  _inherits(LineItemsTable, _Component);

  function LineItemsTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LineItemsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LineItemsTable.__proto__ || Object.getPrototypeOf(LineItemsTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editModalOpen: false
    }, _this.openModal = function (lineItem) {
      return _this.setState({ editModalOpen: true, selectedLineItem: lineItem });
    }, _this.closeModal = function () {
      return _this.setState({ editModalOpen: false });
    }, _this.renderRow = function (lineItem, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        {
          key: lineItem.id,
          className: "clickable",
          onClick: function onClick() {
            return _this.openModal(lineItem);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          i + 1,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { style: { position: "absolute", left: 0, marginTop: 0 } },
            lineItem.purchase_status === __WEBPACK_IMPORTED_MODULE_5__constants__["v" /* FULL */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
              icon: "fa-check-square",
              placement: "top",
              note: "Full Qty Purchase",
              color: "#4CAF50"
            }),
            lineItem.purchase_status === __WEBPACK_IMPORTED_MODULE_5__constants__["w" /* PARTIAL */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
              icon: "fa-star-half-o",
              placement: "top",
              note: "Partial Purchase",
              color: "#FF9800"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__shared_components_LineItemStatusCell__["a" /* default */],
          { lineItem: lineItem },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["h" /* PartNumber */], { part: lineItem.part, showClipBoard: true })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* INCOMING_LINE_ITEMS */].quoteType[lineItem.quote_type].abbrev
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(lineItem, "rfq_as_alt.name")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__["h" /* monthFullYear */])(lineItem.dom)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.expected_serial_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.trace_type && __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes[lineItem.trace_type].label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["e" /* truncate */])(lineItem.traced_to, 13)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.tag_date && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__["g" /* monthYear */])(lineItem.tag_date)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["e" /* truncate */])(lineItem.tagged_by, 13)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.modified && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__parts_components_ModifiedFlag__["b" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.condition && lineItem.quote_type !== __WEBPACK_IMPORTED_MODULE_5__constants__["j" /* NO_QUOTE */] && __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* INCOMING_LINE_ITEMS */].condition[lineItem.condition].abbrev,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_AsIsFlag__["a" /* AsIsFlag */], { lineItem: lineItem }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_IncidentRelatedFlag__["a" /* IncidentRelatedFlag */], { lineItem: lineItem })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.quantity
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.lead_time
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(lineItem.exchange_fee)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(lineItem.cost)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["e" /* truncate */])(lineItem.warranty, 20)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], { note: lineItem.notes }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Controls__["a" /* default */], { lineItem: lineItem })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LineItemsTable, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          quote = _props.quote,
          results = _props.results,
          isLoading = _props.isLoading;
      var _state = this.state,
          editModalOpen = _state.editModalOpen,
          selectedLineItem = _state.selectedLineItem;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          { style: { marginTop: 26 } },
          "Parts",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Parts_New__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Parts_EditPart__["a" /* default */], {
            id: quote.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */]),
            open: editModalOpen,
            close: this.closeModal,
            selectedLineItem: selectedLineItem
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Mini,
          { loading: isLoading, numbered: true, noMargin: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Part #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Type"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "RFQ as Alt"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "DOM"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Serial #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Trace Type"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Trace To"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tag Date"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tagged By"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Cond"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "QTY"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "LT"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Exch Fee"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Cost/Unit"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Warranty"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "\xA0"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Body,
            null,
            results.map(this.renderRow),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              { style: { backgroundColor: "transparent" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                { className: "text-right", colSpan: 15 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  { className: "margin-top-none margin-bottom-none" },
                  "Total: ",
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(quote.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_71" /* TOTAL */]))
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "nav",
          {
            className: "text-center margin-top-none",
            "aria-label": "Search results pages"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__orange_marmalade_paginate_this__["Paginator"], { listId: paginatorList })
        )
      );
    }
  }]);

  return LineItemsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LineItemsTable.propTypes = {
  quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    incoming_quote_line_items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
      quote_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
      dom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }))
  }).isRequired
};


var withListId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__shared_decorators__["d" /* translateProps */])(function () {
  return {
    listId: paginatorList
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withListId(__WEBPACK_IMPORTED_MODULE_16__orange_marmalade_paginate_this__["decorators"].tabulate(LineItemsTable)));

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_AutoCompleteField_AutoCompleteField__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* unused harmony export Form */
var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }














function LineItems(_ref) {
  var lineItems = _ref.lineItems;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tbody",
    null,
    lineItems.map(function (item, idx) {
      var lineItem = lineItems[idx];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: "item-" + lineItem.id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          {
            className: "text-right",
            style: { verticalAlign: "top", paddingTop: 8, paddingLeft: 10 }
          },
          idx + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { className: "float-left" },
                lineItem.part.part_number,
                " |\xA0",
                lineItem.part.description,
                " |\xA0",
                __WEBPACK_IMPORTED_MODULE_8__constants__["b" /* INCOMING_LINE_ITEMS */].quoteType[lineItem.quote_type].label
              )
            )
          )
        )
      );
    })
  );
}

LineItems.propTypes = {
  lineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Array),
  fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    map: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  })
};

function Form(_ref2) {
  var close = _ref2.close,
      handleSubmit = _ref2.handleSubmit,
      invalid = _ref2.invalid,
      submitting = _ref2.submitting,
      quote = _ref2.quote,
      modal = _ref2.modal;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      ccContact = _useState2[0],
      setCcContact = _useState2[1];

  var searchContacts = function searchContacts(email) {
    return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].companies.contacts.search(quote.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["i" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */]]), { filter: email }).then(function (resp) {
      return Promise.resolve(resp.data.results);
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */],
    { handleSubmit: handleSubmit, modal: modal },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], name: "to", label: "To:", disabled: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
        name: "cc",
        label: "CC:",
        placeholder: "Search by Email",
        component: __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_AutoCompleteField_AutoCompleteField__["a" /* default */],
        search: searchContacts,
        selectedItem: ccContact,
        formatItem: function formatItem(c) {
          return c.email;
        },
        onItemSelected: function onItemSelected(i) {
          return i && setCcContact(i);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Parts"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
          { className: "row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "table",
              { className: "table table-striped table-numbered margin-bottom-none" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["FieldArray"], {
                name: "line_items",
                component: LineItems,
                lineItems: quote.get("incoming_quote_line_items").toJS()
              })
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Footer,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* Button */],
        { onClick: close },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* Button */],
        {
          type: "submit",
          bsStyle: "primary",
          disabled: invalid || submitting
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["k" /* Icon */], { name: "envelope", fixed: true }),
        "\xA0",
        submitting ? "Sending..." : "Send RFQ"
      )
    )
  );
}

Form.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    get: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    getIn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }),
  modal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state, props) {
  return {
    initialValues: {
      to: props.quote.getIn(["contact", "email"])
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["j" /* form */])({
  form: "send-incoming-quote",
  onSubmit: function () {
    var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data, _, props) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].incomingQuotes.send(props.quote.get("id"), props.values).then(function () {
                props.close();
                __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].success("Success", "RFQ successfully sent.");
              }).catch(function () {
                return __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Error", "Could not send quote. Please refresh page and try again.");
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function onSubmit(_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }()
})(Form)));

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Form__ = __webpack_require__(1346);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













function isAwaitingReply(lineItems) {
  return lineItems.some(function (item) {
    return item.quote_type === __WEBPACK_IMPORTED_MODULE_8__constants__["n" /* AWAITING_REPLY */];
  });
}

function Send(_ref) {
  var quote = _ref.quote,
      currentUser = _ref.currentUser;

  var disabled = !isAwaitingReply(quote.get("incoming_quote_line_items").toJS()) || quote.get(__WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__["a" /* default */],
        { onClick: open, disabled: disabled },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: "envelope-o", fixed: true }),
        "\xA0Send Request For Quote",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["a" /* Modal */],
          { open: visible, close: close, dialogClass: "modal-lg" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["c" /* Close */], { close: close }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Send Request for Quote"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Form__["a" /* default */], { close: close, quote: quote, currentUser: currentUser })
        )
      );
    }
  );
}

Send.propTypes = _extends({
  quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
}, __WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__["b" /* default */])(Send));

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Form__ = __webpack_require__(640);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }











var _INCOMING_LINE_ITEMS$ = __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* INCOMING_LINE_ITEMS */].quoteType,
    _ = _INCOMING_LINE_ITEMS$[__WEBPACK_IMPORTED_MODULE_4__constants__["t" /* NOT_AWAITING_REPLY */]],
    __ = _INCOMING_LINE_ITEMS$[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* AS_IS */]],
    quoteTypes = _objectWithoutProperties(_INCOMING_LINE_ITEMS$, [__WEBPACK_IMPORTED_MODULE_4__constants__["t" /* NOT_AWAITING_REPLY */], __WEBPACK_IMPORTED_MODULE_4__constants__["c" /* AS_IS */]]);

var CreatePart = function CreatePart(props) {
  var close = props.close,
      incomingQuote = props.incomingQuote,
      onSubmit = props.onSubmit,
      open = props.open;

  var initialValues = {
    quote_type: incomingQuote.getIn(["incoming_quote_line_items", 0, __WEBPACK_IMPORTED_MODULE_6__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */]]) || __WEBPACK_IMPORTED_MODULE_4__constants__["k" /* STANDARD */],
    lead_time: incomingQuote.getIn(["incoming_quote_line_items", 0, __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["G" /* LEAD_TIME */]])
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Add a Part"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Form__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      onSubmit: onSubmit,
      quoteTypes: quoteTypes
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* createIncomingQuoteLineItem */])(data));
    }
  };
})(CreatePart));

CreatePart.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  incomingQuote: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Map),
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Form__ = __webpack_require__(640);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












function EditPart(_ref) {
  var open = _ref.open,
      close = _ref.close,
      onSubmit = _ref.onSubmit,
      selectedLineItem = _ref.selectedLineItem;

  var initialValues = _extends({
    other: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["isEmpty"])(selectedLineItem && selectedLineItem.other_tag_type),
    part_id: selectedLineItem && selectedLineItem.part.id
  }, selectedLineItem || {});

  var quoteTypes = selectedLineItem && [__WEBPACK_IMPORTED_MODULE_6__constants__["t" /* NOT_AWAITING_REPLY */], __WEBPACK_IMPORTED_MODULE_6__constants__["c" /* AS_IS */]].includes(selectedLineItem.quote_type) ? __WEBPACK_IMPORTED_MODULE_6__constants__["b" /* INCOMING_LINE_ITEMS */].quoteType : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_removeKey__["b" /* removeKeys */])(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* INCOMING_LINE_ITEMS */].quoteType, [__WEBPACK_IMPORTED_MODULE_6__constants__["t" /* NOT_AWAITING_REPLY */], __WEBPACK_IMPORTED_MODULE_6__constants__["c" /* AS_IS */]]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Part"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Form__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      onSubmit: onSubmit,
      selectedLineItem: selectedLineItem,
      quoteTypes: quoteTypes
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* updateIncomingQuoteLineItem */])(data, ownProps.selectedLineItem.id));
    }
  };
})(EditPart));

EditPart.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  selectedLineItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])
};

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreatePart__ = __webpack_require__(1348);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    id: state.incomingQuoteDetail.getIn(["incomingQuote", "id"]),
    incomingQuote: state.incomingQuoteDetail.get("incomingQuote")
  };
})(function (_ref) {
  var id = _ref.id,
      incomingQuote = _ref.incomingQuote;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["P" /* LaunchModal */], {
    modal: __WEBPACK_IMPORTED_MODULE_3__CreatePart__["a" /* default */],
    buttonClass: "btn-primary btn-hollow pull-right",
    text: "Add Part",
    id: id,
    incomingQuote: incomingQuote
  });
}));

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PartDetails__ = __webpack_require__(423);
/* harmony export (immutable) */ __webpack_exports__["a"] = PartDetailsForm;





function PartDetailsForm(_ref) {
  var cost = _ref.cost,
      quantity = _ref.quantity,
      quoteType = _ref.quoteType,
      selectedPart = _ref.selectedPart,
      taggedBy = _ref.taggedBy;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_redux_form__["FormSection"],
    { name: "" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PartDetails__["a" /* default */], {
      part: selectedPart,
      quantity: quantity,
      cost: cost,
      quoteType: quoteType,
      taggedBy: taggedBy
    })
  );
}

PartDetailsForm.propTypes = {
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  quoteType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  selectedPart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  taggedBy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_AsIsFlag__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__parts_components_ModifiedFlag__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_LineItemStatusCell__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_IncidentRelatedFlag__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(40);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
















function renderRow(r, pushHistory) {
  var part = r.part;

  var condition = __WEBPACK_IMPORTED_MODULE_13__constants__["b" /* INCOMING_LINE_ITEMS */].condition[r.condition];
  var quoteType = __WEBPACK_IMPORTED_MODULE_13__constants__["b" /* INCOMING_LINE_ITEMS */].quoteType[r.quote_type];
  var handleMailto = function handleMailto(e) {
    e.stopPropagation();
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: r.id,
      className: "clickable",
      onClick: function onClick() {
        return pushHistory("/incoming-quotes/" + r.quote_uuid);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__shared_components_LineItemStatusCell__["a" /* default */],
      { lineItem: r },
      r.quote_code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: r.updated_tracked_fields_at && "text-yellow" },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__["a" /* shortDateYYandTime */])(r.updated_tracked_fields_at || r.created_at)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["d" /* getFirstNameLastInitial */])(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(r, "buyer.full_name")), 14)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      quoteType && quoteType.abbrev
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["w" /* CompanyName */], { flattenedCompany: r, truncateAt: 18 })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])(r.contact_name, 17)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        { href: "mailto:" + r.contact_email, onClick: handleMailto },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])(r.contact_email, 13)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      part && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["h" /* PartNumber */], { part: part })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.modified && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__parts_components_ModifiedFlag__["b" /* default */], null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.trace_type && __WEBPACK_IMPORTED_MODULE_13__constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes[r.trace_type].abbrev
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])(r.tagged_by, 17)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__["f" /* monthFullYearHyphen */])(r.tag_date)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      condition && condition.abbrev,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_IncidentRelatedFlag__["a" /* IncidentRelatedFlag */], { lineItem: r }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_AsIsFlag__["a" /* AsIsFlag */], { lineItem: r, className: "m-l-5" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])(r.lead_time, 3)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      r.exchange_fee && r.exchange_fee > 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(r.exchange_fee, 0)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      r.cost && r.cost > 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(r.cost)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(r, "part.sellable_quantity")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])(r.warranty, 18)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["G" /* NoteTooltipTableCell */], { note: r.notes })
  );
}

function Table(_ref) {
  var pushHistory = _ref.pushHistory,
      isLoading = _ref.isLoading,
      pageActions = _ref.pageActions,
      results = _ref.results;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components__["s" /* DataTable */],
    { loading: isLoading, refresh: pageActions.expire },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Quote #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Created/Updated"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Buyer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Type"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Vendor"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Contact"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Email"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Trace"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Tagged By"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Tag Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Cond"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Qty"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "LT"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Exch. Fee"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Cost Per Unit"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Sellable"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Warranty"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_8__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(Table));

/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(425);
/* unused harmony export initialState */
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  incomingQuoteWithAllLineItems: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
});

function setIncomingQuoteWithAllLineItems(state, action) {
  return state.merge({
    incomingQuoteWithAllLineItems: action.incomingQuoteWithAllLineItems
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* SET_INCOMING_QUOTE_WITH_ALL_LINE_ITEMS */], setIncomingQuoteWithAllLineItems)));

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_reducer__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__ = __webpack_require__(58);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  incomingQuote: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  lineItems: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()
}).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["a" /* notesInitialState */]).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["b" /* attachmentsInitialState */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _extends(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["b" /* SET */], function (state, action) {
  return state.merge({ incomingQuote: action.incomingQuote });
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["c" /* createAttachmentReducer */])(__WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].incomingQuote), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["d" /* createNoteReducer */])(__WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].incomingQuote))));

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_formField__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);









function ShippingRadioGroupField(_ref) {
  var currentUser = _ref.currentUser,
      disabled = _ref.disabled,
      input = _ref.input,
      _ref$options = _ref.options,
      options = _ref$options === undefined ? [] : _ref$options,
      setFieldValue = _ref.setFieldValue,
      getFieldValue = _ref.getFieldValue,
      hasLocations = _ref.hasLocations,
      locationFieldName = _ref.locationFieldName;

  var activeClass = function activeClass(type, option) {
    return __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn btn-default", {
      active: input.value === type,
      disabled: disabled || option.disabled
    });
  };

  var handleChange = function handleChange(newVal, locationId) {
    return function () {
      if (["company", "dropship", "do_not_ship"].includes(newVal) && newVal === input.value) {
        return setFieldValue(newVal)(null);
      }

      if (getFieldValue(locationFieldName) === locationId && newVal === "tenant_location") {
        return setFieldValue(locationFieldName)(null);
      }

      input.onChange(newVal);
      if (hasLocations) {
        setFieldValue(locationFieldName)(locationId);
      }
      if (newVal === __WEBPACK_IMPORTED_MODULE_6__PurchaseOrders_constants__["d" /* DO_NOT_SHIP */]) {
        [__WEBPACK_IMPORTED_MODULE_7__constants__["e" /* CARRIER */], __WEBPACK_IMPORTED_MODULE_7__constants__["g" /* SHIPPING_METHOD */]].forEach(function (f) {
          return setFieldValue([__WEBPACK_IMPORTED_MODULE_7__constants__["g" /* SHIPPING_METHOD */], f].join("."))(null);
        });
      }

      return null;
    };
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group btn-group-justified", role: "group" },
    hasLocations && currentUser.locations.map(function (l) {
      var locationFieldValue = getFieldValue(locationFieldName);

      var locationClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn btn-default", {
        active: locationFieldValue === l.id && getFieldValue(input.name) === __WEBPACK_IMPORTED_MODULE_5__shared_components_ShippingSection_shippingTypes__["a" /* TENANT_LOCATION */],
        disabled: disabled
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: locationClass,
          onClick: disabled ? undefined : handleChange(__WEBPACK_IMPORTED_MODULE_5__shared_components_ShippingSection_shippingTypes__["a" /* TENANT_LOCATION */], l.id),
          key: l.id
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0",
        l.name
      );
    }),
    options.map(function (option) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activeClass(option.value, option),
          onClick: disabled || option.disabled ? undefined : handleChange(option.value, null),
          key: option.value
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0",
        option.text
      );
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__["b" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_formField__["a" /* default */])(ShippingRadioGroupField)));

ShippingRadioGroupField.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  hasLocations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  locationFieldName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    isLocation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  })),
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLocationNameById; });


var getLocationNameById = function getLocationNameById(id) {
  if (!id) return null;
  var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__hooks_useCurrentUser__["a" /* default */])();
  return user.locations.filter(function (l) {
    return l.id === id;
  })[0].name;
};

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(1358);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









function Create(_ref) {
  var buyerCreditPct = _ref.buyerCreditPct,
      open = _ref.open,
      close = _ref.close;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks_useCurrentUser__["a" /* default */])();
  var initialValues = {
    buyer_id: currentUser[__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ID */]],
    buyer_credit_pct: buyerCreditPct,
    buying_store_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks_useCurrentUser__["c" /* defaultStoreLocation */])(currentUser)
  };

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCompany = _useState2[0],
      setSelectedCompany = _useState2[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Create a New Lot Purchase Order"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Form__["a" /* default */], {
        close: close,
        initialValues: initialValues,
        selectedBuyer: currentUser,
        selectedCompany: selectedCompany,
        setSelectedCompany: setSelectedCompany
      })
    )
  );
}

Create.propTypes = {
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    buyerCreditPct: state.session.getIn([__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_4__constants__["G" /* BUYER_CREDIT_PCT */]])
  };
})(Create));

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__companies_shared_components_DoNotDoBusinessWarning__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Orders_shared_ShippingFields__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_CompanyAddressWarning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__companies_shared_components_ActiveDemeritCompanyWarning__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__inventories_components_Detail_Dummies_constants__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_DetailFields_DetailFields__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__shared_components_Forms_NumberInput_NumberInput__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__validate__ = __webpack_require__(1360);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var formName = "createLotOrder";
var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])(formName);

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this));

    _this.state = {
      invalidCompany: false,
      company: {}
    };

    _this.notifyForm = function (company) {
      if (company && (!company.primary_physical_address || !company.billing_address)) {
        return _this.setState({ invalidCompany: true, company: company });
      }
      return _this.setState({ invalidCompany: false });
    };

    _this.notifyForm = _this.notifyForm.bind(_this);
    return _this;
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          setSelectedCompany = _props.setSelectedCompany,
          selectedCompany = _props.selectedCompany,
          costSplit = _props.costSplit;
      var _state = this.state,
          invalidCompany = _state.invalidCompany,
          company = _state.company;


      var shouldShowWarning = !(parseInt(costSplit, 10) > 0);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["e" /* Form */],
          _extends({}, this.props, { disabled: invalidCompany }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["e" /* Form */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__companies_shared_components_DoNotDoBusinessWarning__["a" /* default */], { company: selectedCompany }),
            invalidCompany && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_CompanyAddressWarning__["a" /* default */], { company: company }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__companies_shared_components_ActiveDemeritCompanyWarning__["a" /* default */], { company: selectedCompany }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_DetailFields_DetailFields__["a" /* default */], {
              notifyForm: this.notifyForm,
              setPaymentTerms: this.setPaymentTerms,
              selectedBuyer: this.props.selectedBuyer,
              formName: formName,
              setSelectedCompany: setSelectedCompany
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["q" /* FormRow */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_13__constants__["k" /* LOT_TYPE */],
                    component: __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["c" /* Select */],
                    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_13__constants__["l" /* LOT_TYPES */]),
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["k" /* LOT_TYPE */]),
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["S" /* NAME */],
                    component: __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["d" /* FormInput */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["m" /* LOT_NAME */]),
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["_6" /* REFERENCE_NUMBER */],
                    component: __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["d" /* FormInput */],
                    label: "Ref #"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["V" /* COST */],
                    component: __WEBPACK_IMPORTED_MODULE_20__shared_components_Forms_NumberInput_NumberInput__["a" /* default */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["x" /* LOT_PRICE */]),
                    required: true
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["q" /* FormRow */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["n" /* CONDITION */],
                    component: __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["c" /* Select */],
                    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_18__inventories_components_Detail_Dummies_constants__["a" /* CONDITION_TYPES */]),
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_16__inventories_constants__["n" /* CONDITION */])
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                { md: 2 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["a" /* CheckGroup */],
                  { title: "As Is" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: __WEBPACK_IMPORTED_MODULE_13__constants__["y" /* AS_IS */], component: __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["b" /* Check */], label: "As-is" })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["G" /* LEAD_TIME */],
                    component: __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["d" /* FormInput */],
                    label: "Lead Time (Days)",
                    type: "number",
                    inputProps: {
                      min: 0
                    },
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    label: __WEBPACK_IMPORTED_MODULE_13__constants__["n" /* COST_SPLIT_LABEL */],
                    name: __WEBPACK_IMPORTED_MODULE_13__constants__["s" /* COST_SPLIT */],
                    component: __WEBPACK_IMPORTED_MODULE_20__shared_components_Forms_NumberInput_NumberInput__["a" /* default */],
                    roundDigits: 0,
                    type: "number"
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["q" /* FormRow */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["E" /* TRACE_TYPE */],
                  component: __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["c" /* Select */],
                  options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_14__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes),
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_16__inventories_constants__["E" /* TRACE_TYPE */])
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_16__inventories_constants__["F" /* TRACED_TO */],
                  component: __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["d" /* FormInput */],
                  label: "Traced To"
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["m" /* DashedSeparator */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              null,
              "Shipping"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["q" /* FormRow */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    name: "fob",
                    component: __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["d" /* FormInput */],
                    label: "FOB",
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_13__constants__["d" /* SHIP_DATE */],
                    component: __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["d" /* FormInput */],
                    type: "date",
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["d" /* SHIP_DATE */])
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["m" /* DashedSeparator */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Orders_shared_ShippingFields__["a" /* default */], {
              formName: formName,
              path: __WEBPACK_IMPORTED_MODULE_12__constants__["I" /* SHIPPING_ADDRESS */],
              shippingFields: [__WEBPACK_IMPORTED_MODULE_12__constants__["o" /* SHIPPING_TYPE */], __WEBPACK_IMPORTED_MODULE_12__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_12__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */]],
              shippingMethod: __WEBPACK_IMPORTED_MODULE_12__constants__["g" /* SHIPPING_METHOD */],
              shippingAddressField: __WEBPACK_IMPORTED_MODULE_12__constants__["I" /* SHIPPING_ADDRESS */],
              setTenantAccount: true
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              shouldShowWarning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_21__shared_components_Warning_Warning__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "p",
                  null,
                  "Please confirm that this Lot PO does not have an applied cost percentage before moving forward."
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  selectedBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  selectedCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  setSelectedCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  costSplit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    costSplit: selector(state, __WEBPACK_IMPORTED_MODULE_13__constants__["s" /* COST_SPLIT */])
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_5__actions__["l" /* create */](data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_22__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Create__ = __webpack_require__(1357);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_decorators__["j" /* createNew */])(function (open, close) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Create__["a" /* default */], { open: open, close: close });
}));

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_shared_validations__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inventories_constants__ = __webpack_require__(12);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;









function validate(values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate(__WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__["g" /* BUYING_STORE_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["N" /* COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["O" /* CONTACT_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["V" /* COST */], __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["G" /* LEAD_TIME */], __WEBPACK_IMPORTED_MODULE_6__constants__["k" /* LOT_TYPE */], __WEBPACK_IMPORTED_MODULE_4__constants__["S" /* NAME */], __WEBPACK_IMPORTED_MODULE_4__constants__["M" /* PAYMENT_TERMS */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["x" /* BUYER_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["G" /* BUYER_CREDIT_PCT */], __WEBPACK_IMPORTED_MODULE_4__constants__["H" /* FOB */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_shared_validations__["c" /* validateShippingFields */])(values, v);

    v.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["s" /* COST_SPLIT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0), __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["k" /* isLessThanOrEqualTo */](100));

    if (props.selectedCompany) {
      v.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["N" /* COMPANY_ID */]).satisfies(function () {
        return __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["d" /* validateCompanyStatus */](props.selectedCompany);
      });
    }
  });
}

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CostAdjustmentForm__ = __webpack_require__(1362);
/* harmony export (immutable) */ __webpack_exports__["a"] = AddCostAdjustment;





function AddCostAdjustment(_ref) {
  var open = _ref.open,
      close = _ref.close,
      lot = _ref.lot;

  var initialValues = {
    id: lot.id
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Adjust Lot Cost"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CostAdjustmentForm__["a" /* default */], {
      close: close,
      enableReinitialize: true,
      initialValues: initialValues,
      lot: lot
    })
  );
}

AddCostAdjustment.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__validate__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* unused harmony export CostAdjustmentForm */















var LOT_COST_ADJUSTMENT_OPTIONS = Object.keys(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["_77" /* COST_ADJUSTMENT_OPTIONS */]).reduce(function (agg, k) {
  if (!__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["_77" /* COST_ADJUSTMENT_OPTIONS */][k].inventory_only) {
    agg[k] = __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["_77" /* COST_ADJUSTMENT_OPTIONS */][k];
  }

  return agg;
}, {});

function toOptions(map) {
  var textField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "label";

  return Object.keys(map).map(function (t) {
    var text = textField ? map[t][textField] : map[t];
    if (typeof text === "function") {
      return { value: t, text: text() };
    }

    return { value: t, text: text };
  });
}

var CostAdjustmentFields = function CostAdjustmentFields(_ref) {
  var costAdjustedTotal = _ref.costAdjustedTotal,
      adjustmentType = _ref.adjustmentType,
      adjustment = _ref.adjustment,
      totalCost = _ref.totalCost,
      negative = _ref.negative;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
        { md: 7 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_11__constants__["_65" /* ADJUSTMENT_TYPE */],
          component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["c" /* Select */],
          options: toOptions(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_removeKey__["b" /* removeKeys */])(LOT_COST_ADJUSTMENT_OPTIONS, ["neg_warranty_non_reimbursed", "pos_lot_cost", "neg_lot_cost"])),
          label: "Adjustment Type",
          required: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
        { md: 5 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["f" /* CurrencyField */], { name: __WEBPACK_IMPORTED_MODULE_11__constants__["_66" /* ADJUSTMENT */], label: "Cost Adjustment", required: true })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h5",
      { className: "h3 text-left" },
      "Preview: ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(totalCost),
      " ",
      negative ? "-" : "+",
      " ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(adjustment || 0),
      " = \xA0",
      adjustmentType && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(costAdjustedTotal)
    )
  );
};

CostAdjustmentFields.propTypes = {
  costAdjustedTotal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  adjustmentType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  adjustment: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  totalCost: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  negative: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

function CostAdjustmentForm(props) {
  var lot = props.lot,
      adjustment = props.adjustment,
      adjustmentType = props.adjustmentType;

  var totalCost = lot.cost || 0;
  var negative = adjustmentType && adjustmentType.startsWith("neg_");
  var costAdjustedTotal = negative ? totalCost - adjustment || 0 : parseFloat(totalCost) + parseFloat(adjustment) || 0;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CostAdjustmentFields, {
        costAdjustedTotal: costAdjustedTotal,
        adjustmentType: adjustmentType,
        adjustment: adjustment,
        totalCost: totalCost,
        negative: negative
      })
    )
  );
}

CostAdjustmentForm.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  adjustment: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  adjustmentType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])("addCostAdjustment");

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    adjustment: selector(state, __WEBPACK_IMPORTED_MODULE_11__constants__["_66" /* ADJUSTMENT */]),
    adjustmentType: selector(state, __WEBPACK_IMPORTED_MODULE_11__constants__["_65" /* ADJUSTMENT_TYPE */])
  };
}, function (dispatch) {
  return {
    queryUsers: function queryUsers(filter) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_actions__["h" /* searchUsers */])(filter));
    },
    onSubmit: function onSubmit(data, _, props) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_9__actions__["e" /* addCostAdjustment */](data, props));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: "addCostAdjustment",
  validate: __WEBPACK_IMPORTED_MODULE_12__validate__["a" /* default */]
})(CostAdjustmentForm)));

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;




function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["_65" /* ADJUSTMENT_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["_66" /* ADJUSTMENT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction__ = __webpack_require__(191);






function ApproveLot(_ref) {
  var approved = _ref.approved,
      close = _ref.close,
      open = _ref.open,
      approveLot = _ref.approveLot;

  if (approved) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction__["a" /* default */],
    {
      onConfirm: function onConfirm() {
        return approveLot();
      },
      close: close,
      open: open,
      btnClass: "btn-danger",
      btnText: "Yes, Approve Lot",
      icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" })
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "strong",
      null,
      "Heads up!"
    ),
    "\xA0 Are you sure you want to approve this order?"
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    approveLot: function approveLot() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* update */])({ approved: true }));
    }
  };
})(ApproveLot));

ApproveLot.propTypes = {
  approveLot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  approved: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__decorators_withLot__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Form__ = __webpack_require__(1366);
/* unused harmony export Billing */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
















function Billing(_ref) {
  var lot = _ref.lot,
      currentUser = _ref.currentUser;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components_Section__["a" /* default */],
    {
      title: "Billing",
      modal: {
        title: "Edit Billing Details",
        content: function content(close) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Form__["a" /* default */], {
            close: close,
            cost: lot.get(__WEBPACK_IMPORTED_MODULE_11__constants__["q" /* ORIGINAL_COST */]),
            initialValues: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_pojos__["a" /* default */])(lot.toJS()).pick(__WEBPACK_IMPORTED_MODULE_11__constants__["g" /* AMOUNT_PAID */], __WEBPACK_IMPORTED_MODULE_11__constants__["h" /* INVOICE_NUMBER */], __WEBPACK_IMPORTED_MODULE_11__constants__["j" /* INVOICE_PAID_DATE */], __WEBPACK_IMPORTED_MODULE_11__constants__["f" /* INVOICE_DUE_DATE */])
          });
        }
      },
      editable: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_7__users_constants__["m" /* ACCOUNTING */])
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["a" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], { label: "Inv. #", value: lot.get(__WEBPACK_IMPORTED_MODULE_11__constants__["h" /* INVOICE_NUMBER */]) }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
        label: "Inv. Due Date",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(lot.get(__WEBPACK_IMPORTED_MODULE_11__constants__["f" /* INVOICE_DUE_DATE */]))
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
        label: "Inv. Pd Date",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(lot.get(__WEBPACK_IMPORTED_MODULE_11__constants__["j" /* INVOICE_PAID_DATE */]))
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], { label: "Amt Paid", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_currency__["a" /* dollars */])(lot.get(__WEBPACK_IMPORTED_MODULE_11__constants__["g" /* AMOUNT_PAID */])) })
    )
  );
}

Billing.propTypes = _extends({
  lot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
}, __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__decorators_withLot__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["b" /* default */])(Billing)));

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__decorators_withLot__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* unused harmony export Form */














function Form(props) {
  var setToFull = function setToFull(_ev, val) {
    if (val) {
      props.setFieldValue(__WEBPACK_IMPORTED_MODULE_9__constants__["g" /* AMOUNT_PAID */])(props.cost);
      // Get today's date in yyyy-mm-dd format
      var today = new Date().toISOString().split("T")[0];
      props.setFieldValue(__WEBPACK_IMPORTED_MODULE_9__constants__["j" /* INVOICE_PAID_DATE */])(today);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_9__constants__["h" /* INVOICE_NUMBER */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: "Invoice #"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_9__constants__["f" /* INVOICE_DUE_DATE */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            type: "date",
            label: "Invoice Due Date"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_9__constants__["g" /* AMOUNT_PAID */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            type: "number",
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_9__constants__["g" /* AMOUNT_PAID */])
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
            { justified: true, title: "Amt Paid In Full" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: "paid_in_full",
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
              label: "Yes",
              onChange: setToFull
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_9__constants__["j" /* INVOICE_PAID_DATE */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            type: "date",
            label: "Invoice Paid"
          })
        )
      )
    )
  );
}

Form.propTypes = {
  isLastExchange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nonAccountingUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    nonAccountingUser: ![__WEBPACK_IMPORTED_MODULE_7__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["i" /* ADMIN */]].includes(state.session.getIn([__WEBPACK_IMPORTED_MODULE_7__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["h" /* ROLE */]]))
  };
}, {
  onSubmit: __WEBPACK_IMPORTED_MODULE_6__actions__["a" /* update */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__decorators_withLot__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: "lotBillingForm"
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form)))));

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction__ = __webpack_require__(191);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








function CancelLot(_ref) {
  var cancelled = _ref.cancelled,
      close = _ref.close,
      open = _ref.open,
      cancelLot = _ref.cancelLot;

  if (cancelled) return null;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["I" /* CANCELLATION_REASONS */][0].value),
      _useState2 = _slicedToArray(_useState, 2),
      cancellationReason = _useState2[0],
      setCancellationReason = _useState2[1];

  var handleSelectChange = function handleSelectChange(e) {
    setCancellationReason(e.target.value);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction__["a" /* default */],
    {
      onConfirm: function onConfirm() {
        return cancelLot(cancellationReason);
      },
      close: close,
      open: open,
      btnClass: "btn-danger",
      btnText: "Yes, Cancel Lot",
      cancelText: "Do Not Cancel Lot",
      icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" })
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "strong",
      null,
      "Heads up!"
    ),
    "\xA0 Are you sure you want to cancel this order?",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "label",
        { className: "control-label", htmlFor: "cancellation_reason" },
        "Cancellation Reason"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          className: "form-control",
          name: "cancellation_reason",
          onChange: function onChange(e) {
            return handleSelectChange(e);
          }
        },
        __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["I" /* CANCELLATION_REASONS */].map(function (reason) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "option",
            { key: reason.value, value: reason.value },
            reason.text
          );
        })
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    cancelLot: function cancelLot(reason) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["k" /* cancel */])(reason));
    }
  };
})(CancelLot));

CancelLot.propTypes = {
  cancelLot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cancelled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators_loadRecord__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Attachments_Attachments__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Notes_Notes__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_DashedSeparator_DashedSeparator__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components_VendorDetail_VendorDetail__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Orders_shared_ShippingPreference__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__LineItemsTable_LineItemsTable__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Shipping_constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Edit_EditVendor_EditVendor__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ShippingDetails_ShippingDetails__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Edit_EditLot_EditLot__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__shared_components_Note_Note__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Billing_Billing__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__shared_components_ApprovalDetails_ApprovalDetails__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__shared_components_Authorized_Authorized__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__inventories_components_Detail_CostAdjustmentTable_CostAdjustmentTable__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__AddCostAdjustment_AddCostAdjustment__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__shared_components_StatsTooltip_format__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pagination__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__LineItemsTable_Search__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Header__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__LineItemsTable_AddPart_AddPart__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ReceivingRecordsTable_ReceivingRecordsTable__ = __webpack_require__(1389);
/* unused harmony export Detail */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









































var EDIT_LOT_MODAL = "editLotModal";
var EDIT_VENDOR_MODAL = "editVendorModal";
var ADD_PART_MODAL = "addPartModal";
var ADD_COST_ADJUSTMENT_MODAL = "addCostAdjustmentModalOpen";

var Detail = function (_React$Component) {
  _inherits(Detail, _React$Component);

  function Detail() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Detail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Detail.__proto__ || Object.getPrototypeOf(Detail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editModalOpen: false,
      addPartModalOpen: false,
      addCostAdjustmentModalOpen: false,
      editInvoiceModalOpen: false,
      editPartModalOpen: false,
      initialPartFormValues: {}
    }, _this.toggleModal = function (modal) {
      return function () {
        return _this.setState(_defineProperty({}, modal, !_this.state[modal]));
      };
    }, _this.openEditModal = function () {
      _this.setState({ openEditModal: true });
    }, _this.openEditInvoiceModal = function () {
      _this.setState({ editInvoiceModalOpen: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Detail, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.location.state && this.props.location.state.open) {
        this.setState({
          addPartModalOpen: true,
          initialPartFormValues: this.props.location.state.part,
          id: this.props.location.state.id
        });
      }
    }
  }, {
    key: "userCanEdit",
    value: function userCanEdit() {
      var currentUser = this.props.currentUser;

      var lot = this.props.lot.toJS();
      var buyerId = lot.buyer_id,
          coBuyerId = lot.co_buyer_id;


      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__users_helpers__["i" /* hasAnyOfRolesOrSubroles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_7__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["p" /* QUALITY_CONTROL */]], [__WEBPACK_IMPORTED_MODULE_7__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]) || currentUser.id === buyerId || currentUser.id === coBuyerId;
    }
  }, {
    key: "shippingDetailsUnlocked",
    value: function shippingDetailsUnlocked() {
      var currentUser = this.props.currentUser;


      var userCanEdit = this.userCanEdit();
      var isWarehouseManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__users_helpers__["g" /* hasSubRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_7__users_constants__["s" /* WAREHOUSE_MANAGER */]);
      return userCanEdit || isWarehouseManager;
    }
  }, {
    key: "render",
    value: function render() {
      var lot = this.props.lot.toJS();
      var _state = this.state,
          editLotModalOpen = _state[EDIT_LOT_MODAL],
          editVendorModalOpen = _state[EDIT_VENDOR_MODAL],
          addPartModalOpen = _state[ADD_PART_MODAL],
          addCostAdjustmentModalOpen = _state[ADD_COST_ADJUSTMENT_MODAL],
          initialPartFormValues = _state.initialPartFormValues,
          id = _state.id;


      var remainingCost = lot.cost - lot.applied_cost;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__Header__["a" /* default */], { lot: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])(lot), received: lot.received }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "panel panel-default" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "panel-body" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h2",
                  { style: { marginTop: 10 } },
                  "Details",
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["y" /* EditButton */], {
                    handleClick: this.toggleModal(EDIT_VENDOR_MODAL)
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__Edit_EditVendor_EditVendor__["a" /* default */], {
                    lot: lot,
                    open: editVendorModalOpen,
                    close: this.toggleModal(EDIT_VENDOR_MODAL)
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components_VendorDetail_VendorDetail__["a" /* VendorDetail */], { record: lot }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "h2",
                    null,
                    "Lot Details",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["y" /* EditButton */], {
                      handleClick: this.toggleModal(EDIT_LOT_MODAL)
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Edit_EditLot_EditLot__["a" /* default */], {
                      lot: lot,
                      open: editLotModalOpen,
                      close: this.toggleModal(EDIT_LOT_MODAL)
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2__shared_components__["W" /* DetailTable */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["k" /* LOT_TYPE */]),
                      value: __WEBPACK_IMPORTED_MODULE_13__constants__["l" /* LOT_TYPES */][lot.lot_type].label
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["m" /* LOT_NAME */]), value: lot.name }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
                      label: __WEBPACK_IMPORTED_MODULE_18__constants__["_64" /* REFERENCE_NUMBER_LABEL */],
                      value: lot.reference_number
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: __WEBPACK_IMPORTED_MODULE_19__inventories_constants__["_78" /* LEAD_TIME_LABEL */], value: lot.lead_time }),
                    lot.condition && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_19__inventories_constants__["n" /* CONDITION */]),
                      value: __WEBPACK_IMPORTED_MODULE_20__Shipping_constants__["k" /* CONDITIONS */][lot.condition].label
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
                      label: "Original Cost",
                      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_currency__["a" /* dollars */])(lot.original_cost)
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "Total Cost", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_currency__["a" /* dollars */])(lot.cost) }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
                      label: "Applied Cost",
                      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_currency__["a" /* dollars */])(lot.applied_cost)
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
                      label: "Remaining Cost",
                      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_currency__["a" /* dollars */])(remainingCost < 0 ? 0 : remainingCost)
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
                      label: __WEBPACK_IMPORTED_MODULE_13__constants__["n" /* COST_SPLIT_LABEL */],
                      value: lot.cost_split && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__shared_components_StatsTooltip_format__["f" /* percentFormatter */])(lot.cost_split),
                      renderIfPresent: true
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
                      label: "Total Sales",
                      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_currency__["a" /* dollars */])(lot.total_sales)
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
                      label: "Total Profit",
                      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_currency__["a" /* dollars */])(lot.total_profit)
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__shared_components_ApprovalDetails_ApprovalDetails__["a" /* ApprovalDetails */], { record: lot }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__Billing_Billing__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__ShippingDetails_ShippingDetails__["a" /* default */], { lot: lot }),
                lot.shipping_method && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Orders_shared_ShippingPreference__["a" /* ShippingPreference */], { shippingMethod: lot.shipping_method }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["z" /* AuditFields */], { record: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])(lot), multiLine: true })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
            { md: 9 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              { style: { marginTop: 26 } },
              "Cost Adjustments",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_29__shared_components_Authorized_Authorized__["a" /* default */],
                { roles: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["p" /* QUALITY_CONTROL */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "button",
                  {
                    key: "cost-adjustment",
                    type: "button",
                    className: "btn btn-primary btn-hollow pull-right",
                    onClick: this.toggleModal(ADD_COST_ADJUSTMENT_MODAL)
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "i",
                    { className: "fa fa-fw fa-plus" },
                    "\xA0"
                  ),
                  "Add Cost Adjustment"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__AddCostAdjustment_AddCostAdjustment__["a" /* default */], {
                  key: "add-cost-adjustment-modal",
                  close: this.toggleModal(ADD_COST_ADJUSTMENT_MODAL),
                  open: addCostAdjustmentModalOpen,
                  lot: lot
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__inventories_components_Detail_CostAdjustmentTable_CostAdjustmentTable__["a" /* default */], { costAdjustments: lot.lot_cost_adjustments }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              { style: { marginTop: 26 } },
              "Parts",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "button",
                {
                  type: "button",
                  className: "btn btn-primary btn-hollow pull-right",
                  onClick: this.toggleModal(ADD_PART_MODAL)
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "i",
                  { className: "fa fa-fw fa-plus" },
                  "\xA0"
                ),
                "Create New"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__LineItemsTable_AddPart_AddPart__["a" /* default */], {
                open: addPartModalOpen,
                close: this.toggleModal(ADD_PART_MODAL),
                part: initialPartFormValues,
                id: id
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__LineItemsTable_Search__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__LineItemsTable_LineItemsTable__["a" /* default */], { lot: lot }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "row" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
                { sm: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h2",
                  { style: { marginTop: 26 } },
                  "Received"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__ReceivingRecordsTable_ReceivingRecordsTable__["a" /* default */], null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "row" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
                { sm: 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__shared_components_Note_Note__["a" /* default */], {
                  header: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_26__PurchaseOrders_constants__["G" /* INTERNAL_NOTE */]),
                  record: lot,
                  update: __WEBPACK_IMPORTED_MODULE_36__actions__["a" /* update */],
                  type: __WEBPACK_IMPORTED_MODULE_26__PurchaseOrders_constants__["G" /* INTERNAL_NOTE */]
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
                { sm: 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__shared_components_Note_Note__["a" /* default */], {
                  header: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_26__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */]),
                  type: __WEBPACK_IMPORTED_MODULE_26__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */],
                  record: lot,
                  update: __WEBPACK_IMPORTED_MODULE_36__actions__["a" /* update */]
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_Notes_Notes__["a" /* default */], {
              headerLabel: "Follow Up Notes",
              resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])(this.props.lot),
              resourceType: __WEBPACK_IMPORTED_MODULE_10__shared_types_resourceTypes__["a" /* default */].lot,
              resourceKey: "purchaseOrder"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_Notes_Notes__["a" /* default */], {
              resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])(this.props.lot),
              resourceType: __WEBPACK_IMPORTED_MODULE_10__shared_types_resourceTypes__["a" /* default */].lot,
              resourceKey: "lot",
              trace: true
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Attachments_Attachments__["a" /* default */], {
              attachmentTypes: __WEBPACK_IMPORTED_MODULE_13__constants__["o" /* ATTACHMENT_TYPES */],
              multiple: true,
              resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])(lot),
              resourceType: __WEBPACK_IMPORTED_MODULE_10__shared_types_resourceTypes__["a" /* default */].lot,
              resourceKey: "lot"
            })
          )
        )
      );
    }
  }]);

  return Detail;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Detail.propTypes = {
  lot: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"]),
  currentUser: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(Object),
  location: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    state: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
      part: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(Object),
      open: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
      id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
    })
  })
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    lot: state.lotDetail.get(__WEBPACK_IMPORTED_MODULE_13__constants__["a" /* LOT */]),
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["a" /* USER */]).toJS()
  };
}, function (dispatch) {
  return {
    search: function search(val) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_33__pagination__["a" /* lotLineItemsPagination */].setFilter("filter", val));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators_loadRecord__["a" /* default */])({
  reducer: "lotDetail",
  name: "lot",
  action: __WEBPACK_IMPORTED_MODULE_36__actions__["b" /* show */]
})(Detail)));

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony export (immutable) */ __webpack_exports__["a"] = DownloadLot;






function DownloadLot(_ref) {
  var open = _ref.open,
      close = _ref.close,
      lot = _ref.lot;

  var lotId = lot.get("id");

  var handleDownload = function handleDownload(itemized) {
    var downloadUrl = __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* API_BASE */] + "/lots/" + lotId + "/download?itemized=" + itemized;
    window.location.href = downloadUrl;
    close();
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Download Lot PO"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "modal-body text-center" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        "Select the type of Lot PO download:"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: "btn btn-primary",
          onClick: function onClick() {
            return handleDownload(true);
          },
          style: { marginRight: "10px" }
        },
        "Itemized"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: "btn btn-secondary",
          onClick: function onClick() {
            return handleDownload(false);
          },
          style: { backgroundColor: "#6c757d", borderColor: "#6c757d" }
        },
        "Non-Itemized"
      )
    )
  );
}

DownloadLot.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]).isRequired
};

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(1371);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditLot;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function EditLot(_ref) {
  var open = _ref.open,
      close = _ref.close,
      lot = _ref.lot;

  var initialValues = _extends({}, lot, {
    contact: null,
    company_id: lot.company && lot.company.id,
    contact_id: lot.portal_purchase ? __WEBPACK_IMPORTED_MODULE_3__constants__["r" /* PORTAL_PURCHASE */] : lot.contact && lot.contact.id
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Vendor Details"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      lot: lot,
      enableReinitialize: true
    })
  );
}

EditLot.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_NumberInput_NumberInput__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LineItemsTable_Form__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__validate__ = __webpack_require__(1372);
/* unused harmony export Form */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var formName = "editLot";

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      contacts: []
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_8__constants__["k" /* LOT_TYPE */],
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
                  options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_8__constants__["l" /* LOT_TYPES */]),
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["k" /* LOT_TYPE */]),
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_6__constants__["S" /* NAME */],
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["m" /* LOT_NAME */]),
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_6__constants__["_6" /* REFERENCE_NUMBER */],
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                  label: "Ref #"
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_8__constants__["q" /* ORIGINAL_COST */],
                  component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_NumberInput_NumberInput__["a" /* default */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["q" /* ORIGINAL_COST */]),
                  required: true
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  label: __WEBPACK_IMPORTED_MODULE_8__constants__["n" /* COST_SPLIT_LABEL */],
                  name: __WEBPACK_IMPORTED_MODULE_8__constants__["s" /* COST_SPLIT */],
                  component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_NumberInput_NumberInput__["a" /* default */],
                  roundDigits: 0,
                  type: "number"
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["n" /* CONDITION */],
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
                  options: __WEBPACK_IMPORTED_MODULE_14__LineItemsTable_Form__["b" /* SRP_CONDITION_OPTIONS */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["n" /* CONDITION */])
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["G" /* LEAD_TIME */],
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                  label: "Lead Time (Days)",
                  type: "number",
                  inputProps: {
                    min: 0
                  },
                  required: true
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  setLot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  lot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* update */](data));
    },
    setLot: function setLot(val) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_6__constants__["M" /* PAYMENT_TERMS */], val));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_15__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(64);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;





function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["V" /* COST */], __WEBPACK_IMPORTED_MODULE_3__constants__["k" /* LOT_TYPE */], __WEBPACK_IMPORTED_MODULE_2__constants__["S" /* NAME */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(1374);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditVendor;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function EditVendor(_ref) {
  var open = _ref.open,
      close = _ref.close,
      lot = _ref.lot;

  var initialValues = _extends({}, lot, {
    contact: null,
    company_id: lot.company && lot.company.id,
    contact_id: lot.portal_purchase ? __WEBPACK_IMPORTED_MODULE_3__constants__["r" /* PORTAL_PURCHASE */] : lot.contact && lot.contact.id
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Vendor Details"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      lot: lot,
      enableReinitialize: true
    })
  );
}

EditVendor.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_CompanyAddressWarning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_DetailFields_DetailFields__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validate__ = __webpack_require__(1375);
/* unused harmony export Form */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var formName = "editLot";

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      contacts: []
    }, _this.setPaymentTerms = function (val) {
      _this.props.setLot(val);
    }, _this.notifyForm = function (company) {
      return _this.setState({ company: company });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var lot = this.props.lot;
      var company = this.state.company;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_CompanyAddressWarning__["a" /* default */], { company: company }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_DetailFields_DetailFields__["a" /* default */], {
            lot: lot,
            selectedBuyer: lot.buyer,
            selectedCoBuyer: lot.co_buyer,
            selectedThirdBuyer: lot.third_buyer,
            setSelectedCompany: this.notifyForm,
            setPaymentTerms: this.setPaymentTerms,
            formName: formName,
            setPrimaryContact: false
          })
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  setLot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  lot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* update */](data));
    },
    setLot: function setLot(val) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_7__constants__["M" /* PAYMENT_TERMS */], val));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_9__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_shared_validations__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* unused harmony export validateShipping */






function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["N" /* COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["O" /* CONTACT_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["M" /* PAYMENT_TERMS */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    if (values.buyer_credit_pct <= 50.0) {
      v.validate(__WEBPACK_IMPORTED_MODULE_3__users_constants__["z" /* CO_BUYER_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if (values.buyer_credit_pct <= 37.5) {
      v.validate(__WEBPACK_IMPORTED_MODULE_3__users_constants__["y" /* THIRD_BUYER_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }
  });
}

function validateShipping(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_shared_validations__["c" /* validateShippingFields */])(values, v);
  });
}

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_RecordPager_RecordPager__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_ActionDropDown_ActionDropDown__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Orders_shared_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CancelLot_CancelLot__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__MarkLotReceived_MarkLotReceived__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__PurchaseOrders_components_Detail_Warnings__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ApproveLot_ApproveLot__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ImportLineItems_ImportLineItems__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__DownloadLot_DownloadLot__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__SetTraceHold_SetTraceHold__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Sync_Sync__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ToggleQuickbooksSync_ToggleQuickbooksSync__ = __webpack_require__(1396);
/* unused harmony export Header */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






























var exportLotEmail = function exportLotEmail(uuid, lotLineItemTotalCount) {
  if (lotLineItemTotalCount > 100) {
    __WEBPACK_IMPORTED_MODULE_26__api__["a" /* default */].lots.export(uuid).then(function () {
      __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__["toastr"].info("Processing Lot Report. Please check your email.");
    });
  } else {
    window.open(__WEBPACK_IMPORTED_MODULE_9__constants__["d" /* API_BASE */] + "/lots/" + uuid + "/export", "_blank");
    __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__["toastr"].success("Processing Lot Report. Please wait for the PDF to generate.");
  }
};

var ExportButton = function ExportButton(_ref) {
  var lotLineItemTotalCount = _ref.lotLineItemTotalCount;

  var currentUrl = window.location.href;
  var parts = currentUrl.split("/");
  var lotsIndex = parts.findIndex(function (part) {
    return part === "lots";
  });
  var uuid = parts[lotsIndex + 1];

  if (!lotLineItemTotalCount || Number(lotLineItemTotalCount) < 1) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    {
      className: "btn btn-info",
      onClick: function onClick() {
        return exportLotEmail(uuid, lotLineItemTotalCount);
      }
    },
    "Export"
  );
};

var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      approvePOModalOpen: false,
      receivedLotModalOpen: false,
      importModalOpen: false,
      downloadModalOpen: false,
      cancelLotModalOpen: false,
      cancellationReason: __WEBPACK_IMPORTED_MODULE_15__Orders_shared_constants__["k" /* CANCELLATION_REASONS */][0].value
    }, _this.setTraceHold = function (approveTraceHold) {
      var traceHoldSet = _this.props.setTraceHold;


      traceHoldSet(approveTraceHold);
    }, _this.handleSelectChange = function (e) {
      _this.setState({ cancellationReason: e.target.value });
    }, _this.openCancelLotModal = function () {
      return _this.setState({ cancelLotModalOpen: true });
    }, _this.closeCancelLotModal = function () {
      return _this.setState({ cancelLotModalOpen: false });
    }, _this.toggle = function (modalType) {
      return function () {
        return _this.setState(_defineProperty({}, modalType, !_this.state[modalType]));
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          lot = _props.lot,
          _props$received = _props.received,
          received = _props$received === undefined ? false : _props$received,
          lotLineItemTotalCount = _props.lotLineItemTotalCount;
      var _state = this.state,
          approvePOModalOpen = _state.approvePOModalOpen,
          cancelLotModalOpen = _state.cancelLotModalOpen,
          importModalOpen = _state.importModalOpen,
          receivedLotModalOpen = _state.receivedLotModalOpen,
          downloadModalOpen = _state.downloadModalOpen;

      var cancelled = lot.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_38" /* CANCELLED */]);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "page-header page-header-bar" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h1",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: "btn-group pull-right",
              style: { display: "flex", alignItems: "center", marginLeft: 20 }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { marginRight: "10px" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExportButton, { lotLineItemTotalCount: lotLineItemTotalCount })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12__shared_components_ActionDropDown_ActionDropDown__["a" /* default */],
              {
                menuClass: "dropdown-menu-right",
                style: { cursor: "pointer" }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__DownloadLot_DownloadLot__["a" /* default */], {
                open: downloadModalOpen,
                close: this.toggle("downloadModalOpen"),
                lot: lot
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__MarkLotReceived_MarkLotReceived__["a" /* default */], {
                open: receivedLotModalOpen,
                cancelled: lot.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_26" /* RECEIVED */]),
                close: this.toggle("receivedLotModalOpen")
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__CancelLot_CancelLot__["a" /* default */], {
                open: cancelLotModalOpen,
                cancelled: lot.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_38" /* CANCELLED */]),
                close: this.closeCancelLotModal
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__ApproveLot_ApproveLot__["a" /* default */], {
                open: approvePOModalOpen,
                approved: lot.get(__WEBPACK_IMPORTED_MODULE_19__companies_constants__["j" /* APPROVED */]),
                close: this.toggle("approvePOModalOpen")
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ImportLineItems_ImportLineItems__["a" /* default */], {
                close: this.toggle("importModalOpen"),
                open: importModalOpen
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components__["b" /* Authorized */],
                { roles: [__WEBPACK_IMPORTED_MODULE_8__users_constants__["p" /* QUALITY_CONTROL */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__SetTraceHold_SetTraceHold__["a" /* default */], {
                  onConfirm: function onConfirm() {
                    return _this2.setTraceHold(true);
                  },
                  lot: lot,
                  traceApproved: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__SetTraceHold_SetTraceHold__["a" /* default */], {
                  onConfirm: function onConfirm() {
                    return _this2.setTraceHold(false);
                  },
                  lot: lot,
                  traceApproved: false
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components__["b" /* Authorized */],
                { roles: [__WEBPACK_IMPORTED_MODULE_8__users_constants__["m" /* ACCOUNTING */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__ToggleQuickbooksSync_ToggleQuickbooksSync__["a" /* default */], { lot: lot }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__Sync_Sync__["a" /* default */], { lot: lot })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components__["T" /* Forbidden */],
                { roles: [__WEBPACK_IMPORTED_MODULE_8__users_constants__["j" /* WAREHOUSE */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11__shared_components_DropDown_DropDownItem__["a" /* default */],
                  { onClick: this.toggle("downloadModalOpen") },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-print" }),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      null,
                      "Download Lot PO"
                    )
                  )
                ),
                !lot.get("importing") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11__shared_components_DropDown_DropDownItem__["a" /* default */],
                  { onClick: this.toggle("importModalOpen") },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-download" }),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      null,
                      "Import Lots"
                    )
                  )
                ),
                !received && !cancelled && [!lot.get(__WEBPACK_IMPORTED_MODULE_19__companies_constants__["j" /* APPROVED */]) && lot.get(__WEBPACK_IMPORTED_MODULE_19__companies_constants__["D" /* CAN_APPROVE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11__shared_components_DropDown_DropDownItem__["a" /* default */],
                  {
                    onClick: this.toggle("approvePOModalOpen")
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" }),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      null,
                      "Approve Lot"
                    )
                  )
                ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11__shared_components_DropDown_DropDownItem__["a" /* default */],
                  { onClick: this.toggle("receivedLotModalOpen") },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-undo" }),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      null,
                      "Remove Lot From Inbound"
                    )
                  )
                ), !received && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11__shared_components_DropDown_DropDownItem__["a" /* default */],
                  { onClick: this.openCancelLotModal },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    { className: "text-danger" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      null,
                      "Cancel Lot Order"
                    )
                  )
                )]
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "with-padding" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_RecordPager_RecordPager__["a" /* default */], { baseUrl: "/lots", record: lot }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "header-content" },
              lot.get(__WEBPACK_IMPORTED_MODULE_9__constants__["z" /* CODE */])
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["E" /* ClipboardCopy */], { name: lot.get(__WEBPACK_IMPORTED_MODULE_9__constants__["z" /* CODE */]), type: "PO" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "small text-muted" },
              "Created ",
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(lot.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_7" /* CREATED_AT */]))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "pull-right" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                null,
                "Total: ",
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(lot.get(__WEBPACK_IMPORTED_MODULE_9__constants__["V" /* COST */]))
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "alert-group pull-right" },
              !lot.get(__WEBPACK_IMPORTED_MODULE_19__companies_constants__["j" /* APPROVED */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PurchaseOrders_components_Detail_Warnings__["a" /* Warning */], { icon: "pause", label: "Requires Approval" }),
              lot.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_38" /* CANCELLED */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PurchaseOrders_components_Detail_Warnings__["a" /* Warning */], { icon: "ban", label: "Cancelled" })
            )
          )
        )
      );
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    id: state.lotDetail.getIn([__WEBPACK_IMPORTED_MODULE_14__constants__["a" /* LOT */], __WEBPACK_IMPORTED_MODULE_9__constants__["b" /* ID */]]),
    lotLineItemTotalCount: state.lots.lineItems.get("totalCount")
  };
}, function (dispatch) {
  return {
    setTraceHold: function setTraceHold(val) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__actions__["h" /* setTraceHold */])(val));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__session_decorators_withCurrentUser__["b" /* default */])(Header)));

Header.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  lot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),
  received: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  lotLineItemTotalCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  setTraceHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);









var formName = "importLotLineItems";

function ImportLineItemForm(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components__["n" /* Warning */],
          null,
          "Please use the following column headers for the Lot PO import:",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "part_number"
          ),
          " (required field: unique identifier for the part).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "desc"
          ),
          " (optional field: description - include only if the part number is new to the system).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "cond"
          ),
          " (required field: acceptable codes: NE, OH, SV, BT, SV TOOLING, AR, BR. Uppercase or lowercase).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "qty"
          ),
          " (required field: quantity).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "cost"
          ),
          " (optional field: cost of the part can be 0 or left blank).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "tag_date"
          ),
          " (optional field: MM/YY, M/YY, MM/YYYY, M/YYYY).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "tagged_by"
          ),
          " (optional field: free text).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "serial_number"
          ),
          " (optional field).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "trace_to"
          ),
          " (optional field: maximum of 20 characters; free text).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "trace_type"
          ),
          " (optional field: free text).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "dom"
          ),
          " (optional field: MM/YY, M/YY, MM/YYYY, M/YYYY).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "wh"
          ),
          " (optional field: can be left blank).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "location"
          ),
          " (optional field: can be left blank).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "note"
          ),
          " (optional field: free text).",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          "Ensure the import file is in .csv format."
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "file",
            component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["k" /* FileInput */],
            label: "Upload Attachment",
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 8, mdOffset: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            {
              href: "https://info-trader-assets.s3.us-east-2.amazonaws.com/public/InfoTrader_Standard_Lot_Import_Template_v5.csv",
              target: "_blank",
              rel: "noopener noreferrer"
            },
            "Template"
          )
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["j" /* importLineItems */])(data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["j" /* form */])({
  form: formName
})(ImportLineItemForm)));

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ImportLineItemForm__ = __webpack_require__(1377);
/* harmony export (immutable) */ __webpack_exports__["a"] = ImportLineItems;





function ImportLineItems(_ref) {
  var open = _ref.open,
      close = _ref.close,
      lot = _ref.lot;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Import Lot Items"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ImportLineItemForm__["a" /* default */], { close: close, enableReinitialize: true, lot: lot })
  );
}

ImportLineItems.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Form__ = __webpack_require__(428);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


















function AddPart(_ref) {
  var buyerCreditPct = _ref.buyerCreditPct,
      open = _ref.open,
      close = _ref.close,
      _onSubmit = _ref.onSubmit,
      id = _ref.id,
      lot = _ref.lot,
      lineItem = _ref.lineItem,
      currentUser = _ref.currentUser;

  var prevLineItemMap = lot.getIn([__WEBPACK_IMPORTED_MODULE_8__constants__["p" /* LOT_LINE_ITEMS */], 0]);
  var prevLineItem = prevLineItemMap && prevLineItemMap.toJS() || {};

  var initialValues = _extends({
    request_vendor_approval: false,
    request_shop_approval: false,
    same_as_billing: true,
    evaluation_period: 30,
    reserve_for_seller_id: currentUser.get(__WEBPACK_IMPORTED_MODULE_10__constants__["b" /* ID */]),
    read_only_buyer: lot.getIn([__WEBPACK_IMPORTED_MODULE_7__users_constants__["P" /* BUYER */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["f" /* FULL_NAME */]]),
    insurance_type: "None",
    cancelled: false,
    lead_time: lot.get(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["G" /* LEAD_TIME */]),
    as_is: lot.get(__WEBPACK_IMPORTED_MODULE_12__IncomingQuotes_constants__["c" /* AS_IS */]),
    condition: lot.get(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["n" /* CONDITION */]),
    purchase_for_sale: false,
    purchase_for_stock: false,
    purchase_for_repair: false,
    purchase_for_repair_assist: false,
    buyer_credit_pct: buyerCreditPct || 75,
    trace_type: lot.get(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["E" /* TRACE_TYPE */]) || lineItem && lineItem.get(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["E" /* TRACE_TYPE */]),
    traced_to: lot.get(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["F" /* TRACED_TO */]) || lineItem && lineItem.get(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["F" /* TRACED_TO */])
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_pojos__["a" /* default */])(prevLineItem).pick(__WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_constants__["p" /* PURCHASE_FOR_REPAIR */], __WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_constants__["l" /* PURCHASE_FOR_REPAIR_ASSIST */], __WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_constants__["m" /* PURCHASE_FOR_SALE */], __WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_constants__["q" /* PURCHASE_FOR_STOCK */]));

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPart = _useState2[0],
      setSelectedPart = _useState2[1];

  var domLifeYears = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(selectedPart, __WEBPACK_IMPORTED_MODULE_9__parts_constants__["T" /* DOM_LIFE_YEARS */]);
  var llp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(selectedPart, __WEBPACK_IMPORTED_MODULE_9__parts_constants__["D" /* LLP */]);

  initialValues.buyer_credit_pct = lot.get(__WEBPACK_IMPORTED_MODULE_10__constants__["G" /* BUYER_CREDIT_PCT */]);
  initialValues.co_buyer_id = lot.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["z" /* CO_BUYER_ID */]);
  initialValues.third_buyer_id = lot.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["y" /* THIRD_BUYER_ID */]);

  if (lineItem) {
    lineItem.co_buyer = lot.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["_5" /* CO_BUYER */]) && lot.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["_5" /* CO_BUYER */]).toJS();
    lineItem.third_buyer = lot.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["_21" /* THIRD_BUYER */]) && lot.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["_21" /* THIRD_BUYER */]).toJS();
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Add a Part"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Form__["a" /* default */], {
      close: close,
      enableReinitialize: true,
      displaySrpInventoryTable: true,
      initialValues: initialValues,
      selectedPart: selectedPart,
      setSelectedPart: setSelectedPart,
      domLifeYears: domLifeYears,
      llp: llp,
      lineItem: lineItem,
      id: id,
      shippingType: lot.get(__WEBPACK_IMPORTED_MODULE_10__constants__["o" /* SHIPPING_TYPE */]),
      onSubmit: function onSubmit(data) {
        return _onSubmit(data, setSelectedPart);
      }
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    buyerCreditPct: state.session.getIn([__WEBPACK_IMPORTED_MODULE_10__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_10__constants__["G" /* BUYER_CREDIT_PCT */]]),
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["a" /* USER */]),
    lot: state.lotDetail.get(__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* LOT */])
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data, setSelectedPart) {
      setSelectedPart({});
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["d" /* addLineItem */](data));
    }
  };
})(AddPart));

AddPart.propTypes = {
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  close: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  lot: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  lineItem: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}),
  currentUser: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(92);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var CancelModal = function (_React$Component) {
  _inherits(CancelModal, _React$Component);

  function CancelModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CancelModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CancelModal.__proto__ || Object.getPrototypeOf(CancelModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      cancellationReason: "previously_sold"
    }, _this.sendRequestAndClose = function (data) {
      var _this$props = _this.props,
          update = _this$props.update,
          close = _this$props.close,
          lineItem = _this$props.lineItem;


      update(lineItem.id, data);
      close();
    }, _this.handleSelectChange = function (e) {
      _this.setState({ cancellationReason: e.target.value });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CancelModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          lineItem = _props.lineItem,
          open = _props.open,
          close = _props.close;
      var cancellationReason = this.state.cancellationReason;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
        { open: open, close: close, dialogClass: "modal-sm" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            { className: "modal-title" },
            "Cancel Part"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["e" /* Body */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              { className: "control-label", htmlFor: "cancellation_reason" },
              "Cancellation Reason"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "select",
              {
                className: "form-control",
                name: "cancellation_reason",
                onChange: function onChange(e) {
                  return _this2.handleSelectChange(e);
                }
              },
              __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["I" /* CANCELLATION_REASONS */].map(function (reason) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "option",
                  { key: reason.value, value: reason.value },
                  reason.text
                );
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["d" /* Footer */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            { type: "button", className: "btn btn-default", onClick: close },
            "Cancel"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            {
              type: "submit",
              className: "btn btn-primary",
              onClick: function onClick() {
                return _this2.sendRequestAndClose({
                  cancelled: !lineItem.cancelled,
                  cancellation_reason: cancellationReason
                });
              }
            },
            "Save"
          )
        )
      );
    }
  }]);

  return CancelModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CancelModal.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  update: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    update: function update(id, data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["c" /* updateLineItem */])(id, data));
    }
  };
})(CancelModal));

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Form__ = __webpack_require__(428);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














function EditPart(_ref) {
  var open = _ref.open,
      close = _ref.close,
      selectedLineItem = _ref.selectedLineItem,
      onSubmit = _ref.onSubmit,
      lot = _ref.lot,
      currentUser = _ref.currentUser;

  var initialValues = _extends({}, selectedLineItem, {
    displayCoBuyer1: !!(selectedLineItem && selectedLineItem.co_buyer_id),
    displayCoBuyer2: !!(selectedLineItem && selectedLineItem.third_buyer_id),
    created_at: lot.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_7" /* CREATED_AT */]),
    insurance_type: selectedLineItem && selectedLineItem.insurance_type,
    displayCoBuyerFields: !!(selectedLineItem && selectedLineItem.co_buyer_id),
    displayThirdBuyerFields: !!(selectedLineItem && selectedLineItem.third_buyer_id),
    read_only_buyer: lot.getIn([__WEBPACK_IMPORTED_MODULE_7__users_constants__["P" /* BUYER */], "full_name"]),
    reserve_for_seller_id: selectedLineItem && selectedLineItem.reserve_for_seller_id || currentUser.get(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* ID */]),
    tagged_by: selectedLineItem && selectedLineItem.tagged_by,
    tagged_by_id: selectedLineItem && selectedLineItem.tagged_by_id,
    tagged_by_hold: selectedLineItem && selectedLineItem.tagged_by_hold
  });

  var lineItem = {
    co_buyer: lot.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["_5" /* CO_BUYER */]) && lot.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["_5" /* CO_BUYER */]).toJS(),
    third_buyer: lot.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["_21" /* THIRD_BUYER */]) && lot.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["_21" /* THIRD_BUYER */]).toJS()
  };

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(selectedLineItem, __WEBPACK_IMPORTED_MODULE_9__parts_constants__["B" /* PART */], {})),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPart = _useState2[0],
      setSelectedPart = _useState2[1];

  var domLifeYears = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(selectedPart, __WEBPACK_IMPORTED_MODULE_9__parts_constants__["T" /* DOM_LIFE_YEARS */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(initialValues, "part.dom_life_years"));
  var llp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(selectedPart, __WEBPACK_IMPORTED_MODULE_9__parts_constants__["D" /* LLP */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(initialValues, "part.llp"));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Part"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Form__["a" /* default */], {
      onSubmit: onSubmit,
      close: close,
      shippingType: lot.get(__WEBPACK_IMPORTED_MODULE_8__constants__["o" /* SHIPPING_TYPE */]),
      initialValues: initialValues,
      selectedPart: selectedPart,
      setSelectedPart: setSelectedPart,
      domLifeYears: domLifeYears,
      llp: llp,
      lineItem: lineItem,
      enableReinitialize: true,
      selectedLineItem: selectedLineItem
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    lot: state.lotDetail.get(__WEBPACK_IMPORTED_MODULE_10__constants__["a" /* LOT */]),
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["a" /* USER */])
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["c" /* updateLineItem */](ownProps.selectedLineItem.id, data));
    }
  };
})(EditPart));

EditPart.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])
};

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CancelModal__ = __webpack_require__(1380);
/* harmony export (immutable) */ __webpack_exports__["a"] = LineItemControls;





function LineItemControls(_ref) {
  var lineItem = _ref.lineItem;

  var received = lineItem.quantity_received > 0;

  if (received || lineItem.cancelled) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["c" /* ImprovedDropDown */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
        id: "cancel",
        label: "Cancel Line Item",
        faIcon: "ban",
        hideIf: lineItem.cancelled || lineItem.received,
        renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CancelModal__["a" /* default */], { lineItem: lineItem })
      })
    )
  );
}

LineItemControls.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__IncomingQuotes_shared_AsIsFlag__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_shared_helpers__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LineItemControls__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__EditPart_EditPart__ = __webpack_require__(1381);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var paginatorList = "lots/lineItems";
var ReceivedIcon = function ReceivedIcon(_ref) {
  var quantityReceived = _ref.quantity_received,
      quantity = _ref.quantity;

  if (quantityReceived === quantity) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["U" /* IconReceived */], null);
  }
  return null;
};

ReceivedIcon.propTypes = {
  quantity_received: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  quantity: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
};

var LineItemsTable = function (_Component) {
  _inherits(LineItemsTable, _Component);

  function LineItemsTable() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, LineItemsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = LineItemsTable.__proto__ || Object.getPrototypeOf(LineItemsTable)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      addPartModalOpen: false,
      editPartModalOpen: false
    }, _this.openEditPartModal = function (lineItem) {
      return _this.setState({
        editPartModalOpen: true,
        selectedLineItem: lineItem
      });
    }, _this.closeEditPartModal = function () {
      return _this.setState({ editPartModalOpen: false });
    }, _this.profit = function (lineItem) {
      return Number(lineItem.total_sales) - (Number(lineItem.cost) + Number(lineItem.total_cost_adjustments)) * Number(lineItem.quantity);
    }, _this.renderRow = function (r, idx) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        {
          key: r.id,
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("clickable", { "text-muted": r.cancelled }),
          onClick: function onClick() {
            return !r.cancelled && _this.openEditPartModal(r);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { whiteSpace: "nowrap" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { textAlign: "right" } },
              idx + 1
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["h" /* PartNumber */], { part: r.part })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.serial_number === "Various" || !r.inventory_link_id || !r.serial_number && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lodash__["isEmpty"])(r.expected_serial_number) ? r.serial_number || r.expected_serial_number : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
            { to: "/inventories/" + r.inventory_link_id },
            r.serial_number
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.alternate && (r.alternate.alternate_part_id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["h" /* PartNumber */], {
            part: {
              id: r.alternate.alternate_part_id,
              part_number: r.alternate.name
            }
          }) : r.alternate.name)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.trace_type && __WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes[r.trace_type].label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.traced_to
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_date__["d" /* alphaMonthYear */])(r.tag_date)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.tagged_by
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          r.lead_time
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.condition && __WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].condition[r.condition].label,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__IncomingQuotes_shared_AsIsFlag__["a" /* AsIsFlag */], { lineItem: r, className: "m-l-5" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          r.quantity
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReceivedIcon, r),
          " ",
          r.quantity_received
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_shared_helpers__["a" /* displayCost */])(r) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_shared_helpers__["a" /* displayCost */])(r) * Number(r.quantity))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_shared_helpers__["a" /* displayCost */])(r) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])((Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_shared_helpers__["a" /* displayCost */])(r)) + Number(r.total_cost_adjustments)) * Number(r.quantity))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          Number(r.total_sales) !== 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(r.total_sales)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          Number(_this.profit(r)) !== 0 && Number(r.total_sales) !== 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(_this.profit(r))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center td-shrink-icon" },
          (r.internal_note || r.external_note) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
            note: [r.internal_note, r.external_note].filter(function (n) {
              return n !== null && n !== "";
            }).join(" | "),
            className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ "link-muted": r.cancelled })
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center td-shrink-icon" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__LineItemControls__["a" /* LineItemControls */], { lineItem: r })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LineItemsTable, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          lot = _props.lot,
          results = _props.results,
          isLoading = _props.isLoading;
      var _state = this.state,
          editPartModalOpen = _state.editPartModalOpen,
          selectedLineItem = _state.selectedLineItem;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__EditPart_EditPart__["a" /* default */], {
          open: editPartModalOpen,
          close: this.closeEditPartModal,
          selectedLineItem: selectedLineItem
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Mini,
          { loading: isLoading, numbered: true, noMargin: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Part #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Serial #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Buy As Alt"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Exp Trace Type"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Exp Trace To"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tag Date"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tagged By"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              __WEBPACK_IMPORTED_MODULE_13__inventories_constants__["_78" /* LEAD_TIME_LABEL */]
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Condition"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Qty Ord."
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Qty Rec."
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Applied Cost"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Total Cost"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Total Sales"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Profit"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-center" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-center" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Body,
            null,
            results.map(this.renderRow),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              { style: { backgroundColor: "transparent" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                { className: "text-right", colSpan: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  { className: "margin-top-none margin-bottom-none" },
                  "Total: ",
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lot.applied_cost)
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "nav",
          {
            className: "text-center margin-top-none",
            "aria-label": "Search results pages"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__["Paginator"], { listId: paginatorList })
        )
      );
    }
  }]);

  return LineItemsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LineItemsTable.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object)).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};


var withListId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__shared_decorators__["d" /* translateProps */])(function () {
  return {
    listId: "lots/lineItems"
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withListId(__WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__["decorators"].tabulate(LineItemsTable)));

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = PartSummary;









function HazmatWarning(_ref) {
  var bioHazmat = _ref.bio_hazmat,
      hazmat = _ref.hazmat;

  var warnings = [];
  if (hazmat) {
    warnings.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__parts_constants__["h" /* HAZMAT */]));
  }

  if (bioHazmat) {
    warnings.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__parts_constants__["i" /* BIO_HAZMAT */]));
  }

  if (warnings.length === 0) {
    return false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components__["n" /* Warning */],
    null,
    "This line item is marked: ",
    warnings.join(", ")
  );
}

HazmatWarning.propTypes = {
  hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bio_hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function PartSummary(_ref2) {
  var part = _ref2.part,
      quantity = _ref2.quantity,
      cost = _ref2.cost,
      lineItem = _ref2.lineItem,
      hazmatFee = _ref2.hazmatFee,
      containerFee = _ref2.containerFee;

  var calculateCost = function calculateCost(qty, costUnit) {
    var fees = parseFloat(hazmatFee || 0) + parseFloat(containerFee || 0);
    if (fees > 0) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(parseFloat(qty) * parseFloat(costUnit) + fees) || "$0.00";
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(parseFloat(qty) * parseFloat(costUnit)) || "$0.00";
  };

  var reason = __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__["I" /* CANCELLATION_REASONS */].find(function (x) {
    return x.value === (lineItem && lineItem.cancellation_reason);
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "well" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h6",
      { className: "h4" },
      "Lot Summary"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed table-padding-horizonal-none margin-bottom-none" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Part #",
            part && part.part_number
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            cost
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { colSpan: "2" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "em",
              { className: "text-muted" },
              part && part.description
            )
          )
        ),
        hazmatFee && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Hazmat Fee: "
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            parseFloat(hazmatFee).toFixed(2)
          )
        ),
        containerFee && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Container/Crate Fee: "
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            parseFloat(containerFee).toFixed(2)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "QTY"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            quantity
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { colSpan: "2" },
            HazmatWarning(lineItem || {})
          )
        )
      )
    ),
    lineItem && lineItem.cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { style: { color: "#f44336" } },
        "Cancellation Reason:"
      ),
      " ",
      reason.text,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed table-padding-horizonal-none" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              { className: "h4 margin-top-none margin-bottom-none" },
              "Total"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              { className: "h4 margin-top-none margin-bottom-none" },
              calculateCost(quantity, cost)
            )
          )
        )
      )
    ),
    lineItem && lineItem.purchase_for_exchange && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs" }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h6",
      { className: "h4" },
      "Core Return"
    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Core Return AWB #:"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            lineItem.core_return_awb_number
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Core Return Date:"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["b" /* shortDate */])(lineItem.core_return_date)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Core Repair Charges:"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(lineItem.core_repair_charges)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Core Return Serial Number:"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            lineItem.core_return_serial_number
          )
        )
      )
    )]
  );
}

PartSummary.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  hazmatFee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerFee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_shared_PurchaseForFields__ = __webpack_require__(446);
/* harmony export (immutable) */ __webpack_exports__["a"] = PurchaseForFields;











function PurchaseForCheckboxes(_ref) {
  var stock = _ref.purchase_for_stock.input,
      assist = _ref.purchase_for_repair_assist.input,
      sale = _ref.purchase_for_sale.input,
      repair = _ref.purchase_for_repair.input,
      clearPurchaseFor = _ref.clearPurchaseFor,
      clearReserveForSaleQty = _ref.clearReserveForSaleQty,
      disabled = _ref.disabled,
      shippingType = _ref.shippingType,
      onPurchaseForStockChange = _ref.onPurchaseForStockChange,
      onPurchaseForSaleChange = _ref.onPurchaseForSaleChange;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group", style: { cursor: "pointer" } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { className: "control-label", htmlFor: "purchase_for" },
      "Purchase For ",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "sup",
        { className: "small text-danger" },
        "*"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        id: "purchase_for",
        className: "btn-group btn-group-justified",
        "data-toggle": "buttons"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["b" /* Check */], {
        input: stock,
        label: "Stock",
        icon: "fa-check-circle",
        disabled: disabled || [__WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["K" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["L" /* DROPSHIP */]].includes(shippingType),
        onChange: function onChange(ev) {
          onPurchaseForStockChange(ev);
          clearPurchaseFor(ev, [sale.name, repair.name, assist.name]);
          clearReserveForSaleQty(ev);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["b" /* Check */], {
        disabled: disabled,
        input: assist,
        label: "Repair Assist",
        icon: "fa-check-circle",
        onChange: function onChange(ev) {
          clearPurchaseFor(ev, [sale.name, repair.name, stock.name]);
          clearReserveForSaleQty(ev);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["b" /* Check */], {
        disabled: disabled,
        input: sale,
        label: "Reserve for Sale",
        icon: "fa-check-circle",
        onChange: function onChange(ev) {
          clearPurchaseFor(ev, [stock.name, repair.name, assist.name]);
          clearReserveForSaleQty(!ev);
          onPurchaseForSaleChange(ev);
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["b" /* Check */], {
        input: repair,
        disabled: disabled,
        label: "Reserve for Repair",
        icon: "fa-check-circle",
        onChange: function onChange(ev) {
          clearPurchaseFor(ev, [stock.name, sale.name, assist.name]);
          clearReserveForSaleQty(ev);
        }
      })
    )
  );
}

PurchaseForCheckboxes.propTypes = {
  clearPurchaseFor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  clearReserveForSaleQty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  purchase_for_stock: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["o" /* FormTypes */].boolInput.isRequired
  }),
  purchase_for_repair_assist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["o" /* FormTypes */].boolInput.isRequired
  }),
  purchase_for_sale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ input: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["o" /* FormTypes */].boolInput.isRequired }),
  purchase_for_repair: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["o" /* FormTypes */].boolInput.isRequired
  }),
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onPurchaseForSaleChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onPurchaseForStockChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

PurchaseForCheckboxes.defaultProps = {
  onPurchaseForStockChange: function onPurchaseForStockChange() {
    return null;
  }
};

function PurchaseForFields(_ref2) {
  var _ref2$clearPurchaseFo = _ref2.clearPurchaseFor,
      clearPurchaseFor = _ref2$clearPurchaseFo === undefined ? function () {} : _ref2$clearPurchaseFo,
      _ref2$prefix = _ref2.prefix,
      prefix = _ref2$prefix === undefined ? "" : _ref2$prefix,
      searchBuyers = _ref2.searchBuyers,
      selectedReserveForSeller = _ref2.selectedReserveForSeller,
      shippingType = _ref2.shippingType,
      disabled = _ref2.disabled,
      _ref2$getFieldValue = _ref2.getFieldValue,
      getFieldValue = _ref2$getFieldValue === undefined ? function () {} : _ref2$getFieldValue,
      qtyDisabled = _ref2.qtyDisabled,
      condition = _ref2.condition,
      onPurchaseForStockChange = _ref2.onPurchaseForStockChange,
      onPurchaseForSaleChange = _ref2.onPurchaseForSaleChange,
      setFieldValue = _ref2.setFieldValue;

  var clearReserveForSaleQty = function clearReserveForSaleQty(ev) {
    if (ev) {
      var field = [prefix, __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["n" /* RESERVE_FOR_SALE_QUANTITY */]].filter(function (f) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(f);
      }).join(".");
      setFieldValue(field)(0);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_redux_form__["FormSection"],
    { name: prefix },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Fields"], {
          names: [__WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["q" /* PURCHASE_FOR_STOCK */], __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["l" /* PURCHASE_FOR_REPAIR_ASSIST */], __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["m" /* PURCHASE_FOR_SALE */], __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["p" /* PURCHASE_FOR_REPAIR */]],
          asIs: getFieldValue([prefix, __WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_constants__["c" /* AS_IS */]].filter(function (f) {
            return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(f);
          }).join(".")),
          clearPurchaseFor: clearPurchaseFor,
          component: PurchaseForCheckboxes,
          shippingType: shippingType,
          disabled: disabled,
          condition: condition,
          onPurchaseForStockChange: onPurchaseForStockChange,
          onPurchaseForSaleChange: onPurchaseForSaleChange,
          required: true,
          clearReserveForSaleQty: clearReserveForSaleQty
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Fields"], {
      names: [__WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["m" /* PURCHASE_FOR_SALE */]],
      prefix: prefix,
      component: __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_shared_PurchaseForFields__["b" /* ReserveForSaleFields */],
      disabled: disabled,
      getFieldValue: getFieldValue,
      qtyDisabled: qtyDisabled,
      searchBuyers: searchBuyers,
      selectedReserveForSeller: selectedReserveForSeller
    })
  );
}

PurchaseForFields.propTypes = {
  clearPurchaseFor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  prefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  qtyDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedReserveForSeller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onPurchaseForSaleChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onPurchaseForStockChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

PurchaseForCheckboxes.defaultProps = {
  onPurchaseForStockChange: function onPurchaseForStockChange() {
    return null;
  },
  onPurchaseForSaleChange: function onPurchaseForSaleChange() {
    return null;
  }
};

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pagination__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_filters__ = __webpack_require__(75);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











function SearchLotLineItems() {
  var defaultFilters = {
    at_shop: undefined,
    remaining_cost: undefined,
    remaining_inventory: undefined,
    received: undefined,
    sold: undefined
  };

  var filters = [{
    label: "Inventory with Remaining Cost",
    filters: { remaining_cost: true }
  }, {
    label: "Location @ Shop",
    filters: { at_shop: true }
  }, {
    label: "Only Remaining Inventory",
    filters: { remaining_inventory: true, sold: false }
  }, {
    label: "Received",
    filters: { received: true }
  }, {
    label: "Not Received",
    filters: { received: false }
  }, {
    label: "Sold",
    filters: { sold: true, remaining_inventory: false }
  }, {
    label: __WEBPACK_IMPORTED_MODULE_7__constants__["_37" /* CLEAR_FILTERS_TEXT */],
    filters: defaultFilters
  }];

  var filterTags = [{
    label: "Inventory with Remaining Cost",
    key: "remaining_cost"
  }, {
    label: "Location @ Shop",
    key: "at_shop"
  }, {
    label: "Only Remaining Inventory",
    key: "remaining_inventory",
    matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
  }, {
    label: "Received",
    key: "received",
    matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
  }, {
    label: "Not Received",
    key: "received",
    matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(false)
  }, {
    label: "Sold",
    key: "sold",
    matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
  }, {
    label: __WEBPACK_IMPORTED_MODULE_7__constants__["_37" /* CLEAR_FILTERS_TEXT */],
    filters: defaultFilters
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_6__pagination__["a" /* lotLineItemsPagination */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "form-group has-feedback-left",
            style: { position: "relative" }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by part number"
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, { filters: filters, right: true }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, { filters: filterTags }))
      );
    }
  );
}

SearchLotLineItems.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["push"] })(SearchLotLineItems));

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_shared_validations__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;











function validate(values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["q" /* PART_ID */], __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_4__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_4__constants__["G" /* BUYER_CREDIT_PCT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);

    form.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["G" /* LEAD_TIME */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["g" /* requiredAllowZero */]);

    if (Number(props.lot.cost_split) === 0) {
      form.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["V" /* COST */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0));
    }

    if (values.reserve_for_sale_quantity) {
      form.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](values.reserve_for_sale_quantity));
    } else if (values.quantity_received) {
      form.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](values.quantity_received));
    } else {
      form.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["f" /* isGreaterThan */](0));
    }

    form.validate(__WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__["E" /* PERCENT_INSURED */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["h" /* isBetween */](1, 100));

    if (values.hazmat) {
      form.validate(__WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0));
    }

    if (values.purchase_for_stock && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["isEmpty"])(values.srp_condition)) {
      form.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["C" /* SRP_CONDITION */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["i" /* matches */](__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["n" /* CONDITION */]));
    }

    if (props && props.domLifeYears && props.llp || props.selectedPart && props.selectedPart.dom_sensitive) {
      form.validate(__WEBPACK_IMPORTED_MODULE_6__parts_constants__["G" /* DOM */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if ((values.purchase_for_repair || values.condition === __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__["i" /* AS_REMOVED */] && !values.purchase_for_sale && !values.purchase_for_stock) && (props.selectedLineItem && !props.selectedLineItem.consignment || !props.selectedLineItem)) {
      form.validate(__WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__["w" /* PREFERRED_REPAIR_STATION_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if ([__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["i" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["P" /* INSPECTED */], __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["h" /* REPAIRED */]].includes(values.condition)) {
      form.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["x" /* TAG_DATE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      form.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["p" /* TAGGED_BY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if (values.purchase_for_exchange) {
      form.validate(__WEBPACK_IMPORTED_MODULE_7__RepairOrders_constants__["e" /* CORE_DUE_DAYS */], __WEBPACK_IMPORTED_MODULE_7__RepairOrders_constants__["f" /* CORE_RETURN_DATE */], __WEBPACK_IMPORTED_MODULE_8__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      form.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["j" /* mustBeOne */]);

      if (values.flat_exchange) {
        form.validate(__WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__["t" /* CORE_REPAIR_FEE_NOT_TO_EXCEED */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      }
    }

    if (values.exchange_srp && props.minExchangeSrp) {
      form.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["u" /* EXCHANGE_SRP */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](props.minExchangeSrp));
    } else if (values.exchange_srp) {
      form.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["u" /* EXCHANGE_SRP */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["f" /* isGreaterThan */](0));
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_shared_validations__["a" /* validatePurchaseForFields */])(values, form);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_shared_validations__["b" /* validatePurchaseForSaleFields */])(values, form);
  });
}

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction__ = __webpack_require__(191);






function MarkLotReceived(_ref) {
  var received = _ref.received,
      close = _ref.close,
      open = _ref.open,
      markLotReceived = _ref.markLotReceived;

  if (received) return null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction__["a" /* default */],
    {
      onConfirm: function onConfirm() {
        return markLotReceived();
      },
      close: close,
      open: open,
      btnClass: "btn-primary",
      btnText: "Yes, Receive Lot",
      icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-undo" })
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "strong",
      null,
      "Heads up!"
    ),
    "\xA0 Are you sure you want to mark this order as received?"
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    markLotReceived: function markLotReceived() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* update */])({ received: true }));
    }
  };
})(MarkLotReceived));

MarkLotReceived.propTypes = {
  markLotReceived: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  received: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_LocationFlag_LocationFlag__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Receiving_components_shared_StatusTags__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














function Row(_ref) {
  var record = _ref.record,
      statuses = _ref.statuses,
      wareHouses = _ref.wareHouses;

  var warehouse = wareHouses.find(function (w) {
    return w.id === record.ware_house_id;
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { className: "clickable" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          to: "/receiving/" + record.uuid
        },
        record.code
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__["b" /* shortDate */])(record.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["h" /* PartNumber */], { part: record.part })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.inventories.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          to: "/inventories/" + record.inventories[0].uuid
        },
        record.serial_number
      ) : record.serial_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_LocationFlag_LocationFlag__["a" /* default */], {
        location: record.store_location_id,
        wareHouseId: record.ware_house_id
      })
    ),
    wareHouses.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(warehouse, __WEBPACK_IMPORTED_MODULE_11__constants__["S" /* NAME */])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_4__Receiving_constants__["x" /* CONDITION_TYPES */][record.condition].label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      record.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.awb_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Receiving_components_shared_StatusTags__["a" /* default */], statuses)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["G" /* NoteTooltipTableCell */], { note: record.minor_note })
  );
}

Row.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  statuses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

function Table(_ref2) {
  var results = _ref2.results,
      isLoading = _ref2.isLoading;

  var wareHouses = __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__hooks__["a" /* useCurrentUser */])(), "tenant.ware_houses", []);

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */],
    { loading: isLoading },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "REC #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "REC Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Store Loc"
      ),
      wareHouses.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "WH"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "COND Rec"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "QTY Rec"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "AWB #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Status"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Minor Notes"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (record) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row, { key: record.id, record: record, wareHouses: wareHouses });
      })
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "nav",
    {
      className: "text-center margin-top-none",
      "aria-label": "Search results pages"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__orange_marmalade_paginate_this__["Paginator"], { listId: "lots/receivingRecords" })
  )];
}

Table.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var ConnectedTable = __WEBPACK_IMPORTED_MODULE_8__orange_marmalade_paginate_this__["decorators"].tabulate(Table);

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConnectedTable, _extends({ listId: "lots/receivingRecords" }, props));
});

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony export (immutable) */ __webpack_exports__["a"] = SetTraceHold;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function SetTraceHold(_ref) {
  var lot = _ref.lot,
      onConfirm = _ref.onConfirm,
      traceApproved = _ref.traceApproved;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      confirmationIsVisible = _useState2[0],
      setConfirmationVisibility = _useState2[1];

  if (!lot.get(__WEBPACK_IMPORTED_MODULE_6__PurchaseOrders_constants__["S" /* TRACE_HOLD */]) && !lot.get(__WEBPACK_IMPORTED_MODULE_6__PurchaseOrders_constants__["T" /* REJECTED */]) && !lot.get(__WEBPACK_IMPORTED_MODULE_6__PurchaseOrders_constants__["U" /* APPROVED */])) {
    return false;
  }

  var type = traceApproved ? "Approve" : "Reject";
  var icon = traceApproved ? "check" : "ban";

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setConfirmationVisibility(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: icon, fixed: true }),
    "\xA0",
    type,
    " Trace",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setConfirmationVisibility(false);
        },
        open: confirmationIsVisible,
        btnClass: "btn-danger",
        btnText: "Yes, " + type + " Trace",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-" + icon })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to ",
      type,
      " Trace for this PO?"
    )
  );
}

SetTraceHold.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired,
  traceApproved: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(1392);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditShipping;





function EditShipping(_ref) {
  var open = _ref.open,
      close = _ref.close,
      lot = _ref.lot;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Lot Shipping Info"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close, initialValues: lot, lot: lot, enableReinitialize: true })
  );
}

EditShipping.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Orders_shared_ShippingFields_ShippingFields__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__validate__ = __webpack_require__(1393);
/* unused harmony export Form */









var FORM_NAME = "editLotShipping";

function Form(props) {
  var lot = props.lot;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Orders_shared_ShippingFields_ShippingFields__["a" /* default */], {
        shipToCompany: lot.ship_to_company,
        formName: FORM_NAME,
        shippingFields: [__WEBPACK_IMPORTED_MODULE_6__constants__["o" /* SHIPPING_TYPE */], __WEBPACK_IMPORTED_MODULE_6__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_6__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_6__constants__["H" /* FOB */]],
        shippingMethod: __WEBPACK_IMPORTED_MODULE_6__constants__["g" /* SHIPPING_METHOD */],
        shippingAddressField: __WEBPACK_IMPORTED_MODULE_6__constants__["I" /* SHIPPING_ADDRESS */]
      })
    )
  );
}

Form.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    ship_to_company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
  })
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* update */](data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_7__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__companies_constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["a"] = validateShipping;






var validateShippingFields = function validateShippingFields(values, form) {
  form.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* SHIPPING_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);

  if (values.shipping_type === __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__["K" /* COMPANY */]) {
    form.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_1__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */]).required();
  }

  if (values.shipping_type === __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__["L" /* DROPSHIP */]) {
    form.validateChild(__WEBPACK_IMPORTED_MODULE_1__constants__["I" /* SHIPPING_ADDRESS */], function (a) {
      a.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_1__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_1__constants__["w" /* POSTAL_CODE */], __WEBPACK_IMPORTED_MODULE_1__constants__["r" /* COUNTRY */]).required();
    });
  }

  if (values.shipping_type === __WEBPACK_IMPORTED_MODULE_4__companies_constants__["f" /* REPAIR_STATION */]) {
    form.validate("repair_station_physical_address_id").required();
  }

  if (values.shipping_type === __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__["d" /* DO_NOT_SHIP */]) {
    form.validate("_error").satisfies(function () {
      if (!__WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__["e" /* DO_NOT_SHIP_REASONS */].some(function (field) {
        return values[field];
      })) {
        return "At least 1 DO NOT SHIP REASON selection is required";
      }

      return null;
    });
  } else {
    form.validateChild(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* SHIPPING_METHOD */], function (s) {
      s.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* CARRIER */], __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* SHIPPING_METHOD */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    });
  }
};

function validateShipping(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    return validateShippingFields(values, v);
  });
}

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditShipping_EditShipping__ = __webpack_require__(1391);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ShippingDetails = function (_React$Component) {
  _inherits(ShippingDetails, _React$Component);

  function ShippingDetails() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ShippingDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShippingDetails.__proto__ || Object.getPrototypeOf(ShippingDetails)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editShippingModalOpen: false
    }, _this.openShippingModal = function () {
      _this.setState({ editShippingModalOpen: true });
    }, _this.closeShippingModal = function () {
      return _this.setState({ editShippingModalOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ShippingDetails, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          lot = _props.lot,
          _props$unlocked = _props.unlocked,
          unlocked = _props$unlocked === undefined ? true : _props$unlocked;
      var editShippingModalOpen = this.state.editShippingModalOpen;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Shipping",
          unlocked && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["y" /* EditButton */], { handleClick: this.openShippingModal }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EditShipping_EditShipping__["a" /* default */], {
            lot: lot,
            open: editShippingModalOpen,
            close: this.closeShippingModal
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "table",
          { className: "table table-condensed" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tbody",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "FOB"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                null,
                lot.fob
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "Ship Date"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                null,
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__["b" /* shortDate */])(lot.ship_date)
              )
            )
          )
        )
      );
    }
  }]);

  return ShippingDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ShippingDetails);


ShippingDetails.propTypes = {
  lot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  unlocked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__ = __webpack_require__(19);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();














function Sync(_ref) {
  var lot = _ref.lot,
      onConfirm = _ref.onConfirm;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      settings = _useState4[0],
      setSettings = _useState4[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].locations.locationSetting.quickbooksLocationSetting(lot.get(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["g" /* BUYING_STORE_ID */])).then(function (_ref2) {
      var data = _ref2.data;

      setSettings(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["get"])(data, "settings.quickbooks", {}));

      return function cleanup() {};
    });
  }, []);

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["get"])(settings, "accounts_payable_account")) {
    return null;
  }

  var syncDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["get"])(settings, "sync_date");
  var createdAt = __WEBPACK_IMPORTED_MODULE_9_moment___default()(lot.get(__WEBPACK_IMPORTED_MODULE_10__constants__["_7" /* CREATED_AT */]));

  if (syncDate && __WEBPACK_IMPORTED_MODULE_9_moment___default()(syncDate) > __WEBPACK_IMPORTED_MODULE_9_moment___default()(createdAt.format("YYYY-MM-DD"))) {
    return null;
  }

  if (lot.get(__WEBPACK_IMPORTED_MODULE_10__constants__["_46" /* DISABLE_QB_SYNC */])) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: "refresh", fixed: true }),
    "\xA0Sync Accounting",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setVisible(false);
        },
        open: visible,
        btnText: "Yes, Sync w/ Quickbooks",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-refresh" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to sync the Lot?",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        "Please ensure the Vendor has a linked account for the buying store."
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onConfirm: function onConfirm() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["i" /* sync */])());
    }
  };
})(Sync));

Sync.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_constants__ = __webpack_require__(19);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

















function ToggleQuickbooksSync(_ref) {
  var onConfirm = _ref.onConfirm,
      lot = _ref.lot;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      settings = _useState4[0],
      setSettings = _useState4[1];

  var storeOwnerId = lot.get(__WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_constants__["g" /* BUYING_STORE_ID */]);

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__users_helpers__["c" /* hasAnyOfRoles */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks__["a" /* useCurrentUser */])(), [__WEBPACK_IMPORTED_MODULE_9__users_constants__["m" /* ACCOUNTING */]])) {
    return null;
  }

  var createdAt = lot.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_7" /* CREATED_AT */]);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].locations.locationSetting.show(storeOwnerId).then(function (_ref2) {
      var data = _ref2.data;

      setSettings(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(data, "settings.quickbooks", {}));

      return function cleanup() {};
    });
  }, [createdAt]);

  var syncDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_12__constants__["_47" /* SYNC_DATE */]);

  if (!syncDate) return null;

  if (syncDate && __WEBPACK_IMPORTED_MODULE_13_moment___default()(syncDate) <= __WEBPACK_IMPORTED_MODULE_13_moment___default()(createdAt).format("YYYY-MM-DD")) {
    return null;
  }

  var quickbooksDisabled = lot.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_46" /* DISABLE_QB_SYNC */]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: quickbooksDisabled ? "play" : "pause", fixed: true }),
    "\xA0",
    quickbooksDisabled ? "Enable QB Sync" : "Disable QB Sync",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setVisible(false);
        },
        open: visible,
        btnText: quickbooksDisabled ? "Enable QB Sync" : "Disable QB Sync",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-pause" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to",
      " ",
      quickbooksDisabled ? "enable QB Sync" : "disable QB Sync",
      "?"
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onConfirm: function onConfirm() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* update */])({
        disable_qb_sync: !ownProps.lot.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_46" /* DISABLE_QB_SYNC */])
      }));
    }
  };
})(ToggleQuickbooksSync));

ToggleQuickbooksSync.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Create_New__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Table__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pagination__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hooks_useCurrentUser__ = __webpack_require__(51);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }


















var defaultFilters = {
  approved: undefined,
  buying_store_id: undefined,
  cancelled: undefined,
  current_user: undefined,
  invoiced: undefined,
  looking_for: undefined,
  lot_type: undefined,
  no_quote: undefined,
  no_interest: undefined,
  offer: undefined,
  received: undefined,
  trace_hold: undefined
};

var filters = [{
  label: "My LPOs",
  filters: { current_user: true }
}, {
  label: "Received",
  filters: { received: true }
}, {
  label: "Not Received",
  filters: { received: false }
}, {
  label: "Cancelled",
  filters: { cancelled: true }
}, {
  label: "Not Cancelled",
  filters: { cancelled: false }
}, {
  label: "Invoiced",
  filters: { invoiced: true }
}, {
  label: "Not Invoiced",
  filters: { invoiced: false }
}, {
  label: "Synced with Accounting",
  filters: {
    accounting_synced: true
  }
}, {
  label: "Not Synced with Accounting",
  filters: {
    accounting_synced: false
  }
}, {
  label: "Open LPOs Awaiting Trace Pre-approval",
  filters: { trace_hold: true, received: false }
}, {
  label: "Open LPOs Awaiting Purchaser Limit Approval",
  filters: { approved: false }
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["t" /* AIRCRAFT */]),
  filters: _extends({}, defaultFilters, { lot_type: __WEBPACK_IMPORTED_MODULE_7__constants__["t" /* AIRCRAFT */] })
}, {
  label: __WEBPACK_IMPORTED_MODULE_7__constants__["u" /* APU */].toUpperCase(),
  filters: { lot_type: __WEBPACK_IMPORTED_MODULE_7__constants__["u" /* APU */] }
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["v" /* ENGINE */]),
  filters: { lot_type: __WEBPACK_IMPORTED_MODULE_7__constants__["v" /* ENGINE */] }
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["w" /* LANDING_GEAR */]),
  filters: { lot_type: __WEBPACK_IMPORTED_MODULE_7__constants__["w" /* LANDING_GEAR */] }
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["e" /* OTHER */]),
  filters: { lot_type: __WEBPACK_IMPORTED_MODULE_7__constants__["e" /* OTHER */] }
}];

var filterTags = [{
  label: "My LPOs",
  key: "current_user"
}, {
  label: "OQs with Internal Notes",
  key: "has_internal_note"
}, {
  label: "Awaiting Approval",
  key: __WEBPACK_IMPORTED_MODULE_12__companies_constants__["j" /* APPROVED */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["t" /* AIRCRAFT */]),
  key: __WEBPACK_IMPORTED_MODULE_7__constants__["k" /* LOT_TYPE */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_7__constants__["t" /* AIRCRAFT */])
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["u" /* APU */]),
  key: __WEBPACK_IMPORTED_MODULE_7__constants__["k" /* LOT_TYPE */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_7__constants__["u" /* APU */])
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["v" /* ENGINE */]),
  key: __WEBPACK_IMPORTED_MODULE_7__constants__["k" /* LOT_TYPE */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_7__constants__["v" /* ENGINE */])
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["w" /* LANDING_GEAR */]),
  key: __WEBPACK_IMPORTED_MODULE_7__constants__["k" /* LOT_TYPE */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_7__constants__["w" /* LANDING_GEAR */])
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["e" /* OTHER */]),
  key: __WEBPACK_IMPORTED_MODULE_7__constants__["k" /* LOT_TYPE */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_7__constants__["e" /* OTHER */])
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__constants__["_26" /* RECEIVED */]),
  key: __WEBPACK_IMPORTED_MODULE_10__constants__["_26" /* RECEIVED */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Received",
  key: __WEBPACK_IMPORTED_MODULE_10__constants__["_26" /* RECEIVED */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__constants__["_38" /* CANCELLED */]),
  key: __WEBPACK_IMPORTED_MODULE_10__constants__["_38" /* CANCELLED */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Cancelled",
  key: __WEBPACK_IMPORTED_MODULE_10__constants__["_38" /* CANCELLED */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__constants__["_67" /* INVOICED */]),
  key: __WEBPACK_IMPORTED_MODULE_10__constants__["_67" /* INVOICED */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Invoiced",
  key: __WEBPACK_IMPORTED_MODULE_10__constants__["_67" /* INVOICED */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Accounting Synced",
  key: "accounting_synced",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Synced w/ Accounting",
  key: "accounting_synced",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Trace Preapproval Required",
  key: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["S" /* TRACE_HOLD */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["a" /* matchesBoolean */])(true)
}];

function LotsSearch() {
  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__hooks_useCurrentUser__["a" /* default */])();

  var filterTagsWithLocations = currentUser.locations.map(function (l) {
    return {
      label: "Owned by " + l.name,
      key: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["g" /* BUYING_STORE_ID */],
      matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["b" /* matchesString */])(l.id)
    };
  });

  var filtersWithLocations = currentUser.locations.map(function (l, i) {
    return [{
      label: "All Owned By " + l.name,
      filters: { buying_store_id: l.id }
    }, {
      label: "Open LPOs owned by " + l.name,
      filters: _extends({}, defaultFilters, {
        received: false,
        cancelled: false,
        buying_store_id: l.id
      }),
      hr: currentUser.locations.length - 1 === i
    }];
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_14__pagination__["c" /* lotsPagination */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing an LPO #, vendor name or buyer..."
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
              filters: filters.concat.apply(filters, _toConsumableArray(filtersWithLocations)).concat({
                label: __WEBPACK_IMPORTED_MODULE_10__constants__["_37" /* CLEAR_FILTERS_TEXT */],
                filters: _extends({}, defaultFilters)
              }),
              right: true
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Create_New__["a" /* default */], null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "Lot Orders",
          filters: filterTags.concat(filterTagsWithLocations)
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

LotsSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(LotsSearch));

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shipping_constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














function renderRow(r, pushHistory) {
  var remainingCost = r.cost - r.applied_cost;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: r.id,
      className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()("clickable", { "text-muted": r.cancelled }),
      onClick: function onClick() {
        return pushHistory("/lots/" + r.uuid);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["a" /* shortDateYYandTime */])(r.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["a" /* shortDateYYandTime */])(r.date_received)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.company && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["w" /* CompanyName */], { company: r.company, truncateAt: 20 })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.buyer && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["d" /* getFirstNameLastInitial */])(r.buyer.full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.co_buyer && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["d" /* getFirstNameLastInitial */])(r.co_buyer.full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.third_buyer && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["d" /* getFirstNameLastInitial */])(r.third_buyer.full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["o" /* LocationFlag */], { location: r.buying_store_id })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_8__constants__["l" /* LOT_TYPES */][r.lot_type].label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.condition && __WEBPACK_IMPORTED_MODULE_10__Shipping_constants__["k" /* CONDITIONS */][r.condition].label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.reference_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.lead_time
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__["a" /* dollars */])(r.original_cost)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__["a" /* dollars */])(remainingCost < 0 ? 0 : remainingCost)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      r.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["G" /* NoteTooltipTableCell */], { note: r.last_lot_note })
  );
}

function Table(_ref) {
  var pushHistory = _ref.pushHistory,
      isLoading = _ref.isLoading,
      pageActions = _ref.pageActions,
      results = _ref.results;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */],
    { loading: isLoading, refresh: pageActions.expire },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "LO #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Created At"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Received"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Vendor"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Buyer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Co-Buyer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Third Buyer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Store Owner"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Lot Name"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Lot Type"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "CD"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Ref #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "LT"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Original Cost"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Remaining Cost"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "QTY"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Note"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_6__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"] })(Table));

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_reducer__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(644);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  lot: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  lineItems: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  receivingRecords: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()
}).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["a" /* notesInitialState */]).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["b" /* attachmentsInitialState */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _extends(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* SET */], function (state, action) {
  return state.merge({ lot: action.lot });
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["c" /* createAttachmentReducer */])(__WEBPACK_IMPORTED_MODULE_2__shared_types_resourceTypes__["a" /* default */].lot), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["d" /* createNoteReducer */])(__WEBPACK_IMPORTED_MODULE_2__shared_types_resourceTypes__["a" /* default */].lot))));

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








function SelectLot(_ref) {
  var searchLots = _ref.searchLots,
      selectedLot = _ref.selectedLot,
      handleLotSelected = _ref.handleLotSelected;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_3__constants__["z" /* LOT_ID */],
    label: "Lot Name",
    placeholder: "Select Lot",
    component: __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["n" /* AutoCompleteField */],
    onItemSelected: function onItemSelected(i) {
      return i && handleLotSelected(i);
    },
    search: searchLots,
    selectedItem: selectedLot,
    formatItem: function formatItem(result) {
      return result && result.name;
    },
    required: true
  });
}

SelectLot.propTypes = {
  handleLotSelected: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  searchLots: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  selectedLot: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    searchLots: function searchLots(filter) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["m" /* searchLots */])(filter));
    }
  };
})(SelectLot));

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








function SelectLotCode(_ref) {
  var searchLots = _ref.searchLots,
      selectedLot = _ref.selectedLot,
      handleLotSelected = _ref.handleLotSelected;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_3__constants__["A" /* LOT_CODE */],
    label: "LPO Number",
    placeholder: "Select Lot Code",
    component: __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["n" /* AutoCompleteField */],
    onItemSelected: function onItemSelected(i) {
      return i && handleLotSelected(i);
    },
    search: searchLots,
    selectedItem: selectedLot,
    formatItem: function formatItem(result) {
      return result && result.code;
    },
    required: true
  });
}

SelectLotCode.propTypes = {
  handleLotSelected: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  searchLots: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  selectedLot: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    searchLots: function searchLots(filter) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["m" /* searchLots */])(filter));
    }
  };
})(SelectLotCode));

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators_loadRecord__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Orders_shared_Contact__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__companies_shared_components_PaymentTerms__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RepairOrders_components_Edit_EditBilling__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RepairOrders_components_Edit_EditCompanyFields__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ShippingDetails_ShippingDetails__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__EditVendor_EditVendor__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__LineItemsTable_LineItemsTable__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ReturnToShippingDetails_ReturnToShippingDetails__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Header__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__LineItemsTable_Create_Create__ = __webpack_require__(1411);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




























var EDIT_MRO_MODAL_OPEN = "editMroModalOpen";

var Detail = function (_React$Component) {
  _inherits(Detail, _React$Component);

  function Detail() {
    var _ref, _this$state;

    var _temp, _this, _ret;

    _classCallCheck(this, Detail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Detail.__proto__ || Object.getPrototypeOf(Detail)).call.apply(_ref, [this].concat(args))), _this), _this.state = (_this$state = {}, _defineProperty(_this$state, EDIT_MRO_MODAL_OPEN, false), _defineProperty(_this$state, "editPartModalOpen", false), _defineProperty(_this$state, "editReturnToModalOpen", false), _defineProperty(_this$state, "editShipToModalOpen", false), _defineProperty(_this$state, "initialPartFormValues", {}), _this$state), _this.toggleModal = function (modal) {
      return function () {
        return _this.setState(_defineProperty({}, modal, !_this.state[modal]));
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Detail, [{
    key: "render",
    value: function render() {
      var managedRepairOrder = this.props.managedRepairOrder;
      var editMroModalOpen = this.state.editMroModalOpen;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Header__["a" /* default */], { managedRepairOrder: managedRepairOrder }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "panel panel-default" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "panel-body" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h2",
                  null,
                  "Details",
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["y" /* EditButton */], {
                    handleClick: this.toggleModal(EDIT_MRO_MODAL_OPEN)
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__EditVendor_EditVendor__["a" /* default */], {
                    managedRepairOrder: managedRepairOrder.toJS(),
                    open: editMroModalOpen,
                    close: this.toggleModal(EDIT_MRO_MODAL_OPEN)
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-condensed" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tbody",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["S" /* Detail */], {
                      label: "Customer",
                      value: managedRepairOrder.getIn(["company", "code"])
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["S" /* Detail */], {
                      label: "Customer Name",
                      value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["w" /* CompanyName */], {
                        company: managedRepairOrder.toJS().company,
                        context: "repair"
                      })
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["S" /* Detail */], {
                      label: "Rep Station Phone",
                      value: managedRepairOrder.getIn(["company", "phone"])
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Orders_shared_Contact__["a" /* default */], { contact: managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_22__companies_constants__["g" /* CONTACT */]) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-condensed" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tbody",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["S" /* Detail */], {
                      label: "Credit Terms",
                      value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__companies_shared_components_PaymentTerms__["a" /* PaymentTerms */], {
                        paymentTerms: managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_14__constants__["M" /* PAYMENT_TERMS */])
                      })
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_16__ShippingDetails_ShippingDetails__["a" /* default */],
                  {
                    shippingType: __WEBPACK_IMPORTED_MODULE_14__constants__["B" /* SHIP_TO */],
                    managedRepairOrder: managedRepairOrder
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "table",
                    { className: "table table-condensed" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tbody",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["S" /* Detail */], {
                        label: "Insurance",
                        value: insuranceValue(managedRepairOrder)
                      })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ReturnToShippingDetails_ReturnToShippingDetails__["a" /* default */], {
                  managedRepairOrder: managedRepairOrder
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["z" /* AuditFields */], { record: managedRepairOrder, multiLine: true })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 9 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              { style: { marginTop: 26 } },
              "Managed Repair Details",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6__shared_components__["T" /* Forbidden */],
                { roles: [__WEBPACK_IMPORTED_MODULE_12__users_constants__["j" /* WAREHOUSE */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AddPartModal, { managedRepairOrder: managedRepairOrder })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__LineItemsTable_LineItemsTable__["a" /* default */], {
              results: this.props.managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_14__constants__["A" /* LINE_ITEMS */]).toJS()
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["M" /* Notes */], {
              resource: managedRepairOrder,
              resourceType: __WEBPACK_IMPORTED_MODULE_7__shared_types_resourceTypes__["a" /* default */].managedRepairOrder,
              resourceKey: "managedRepairOrder"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["N" /* Attachments */], {
              resource: managedRepairOrder,
              resourceType: __WEBPACK_IMPORTED_MODULE_7__shared_types_resourceTypes__["a" /* default */].managedRepairOrder,
              resourceKey: "managedRepairOrder",
              attachmentTypes: __WEBPACK_IMPORTED_MODULE_17__constants__["b" /* ATTACHMENT_TYPES */],
              multiple: true,
              referenceOptions: [{
                text: managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_14__constants__["z" /* CODE */]),
                value: managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_14__constants__["z" /* CODE */])
              }].concat(_toConsumableArray(managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_14__constants__["A" /* LINE_ITEMS */]).toJS().map(function (l) {
                return {
                  text: "SN-" + l.serial_number,
                  value: "SN-" + l.serial_number
                };
              })))
            })
          )
        )
      );
    }
  }]);

  return Detail;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Detail.propTypes = {
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])
};


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    managedRepairOrder: state.mroDetail.get("managedRepairOrder")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators_loadRecord__["a" /* default */])({
  reducer: "mroDetail",
  name: "managedRepairOrder",
  action: __WEBPACK_IMPORTED_MODULE_23__actions__["d" /* show */]
})(Detail)));

function EditBillingModal(_ref2) {
  var record = _ref2.record;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["P" /* LaunchModal */], {
    modal: __WEBPACK_IMPORTED_MODULE_10__RepairOrders_components_Edit_EditBilling__["a" /* default */],
    buttonClass: "btn btn-primary btn-hollow pull-right",
    buttonIcon: "fa-pencil",
    text: "Edit",
    record: record
  });
}

function insuranceValue(managedRepairOrder) {
  var insuranceType = managedRepairOrder.get("insurance_type");
  if (insuranceType === __WEBPACK_IMPORTED_MODULE_18__RepairOrders_constants__["v" /* NONE */]) {
    return __WEBPACK_IMPORTED_MODULE_18__RepairOrders_constants__["w" /* INSURANCE_TYPES */][__WEBPACK_IMPORTED_MODULE_18__RepairOrders_constants__["v" /* NONE */]].value;
  } else if (insuranceType === __WEBPACK_IMPORTED_MODULE_18__RepairOrders_constants__["x" /* AMOUNT */]) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_currency__["a" /* dollars */])(managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_18__RepairOrders_constants__["w" /* INSURANCE_TYPES */][__WEBPACK_IMPORTED_MODULE_18__RepairOrders_constants__["x" /* AMOUNT */]].key));
  } else if (insuranceType === __WEBPACK_IMPORTED_MODULE_18__RepairOrders_constants__["y" /* PERCENT */]) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_number__["a" /* percent */])(Number(managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_18__RepairOrders_constants__["w" /* INSURANCE_TYPES */][__WEBPACK_IMPORTED_MODULE_18__RepairOrders_constants__["y" /* PERCENT */]].key)), 100);
  }

  return null;
}

EditBillingModal.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}).isRequired
};

function EditCompanyFieldsModal(_ref3) {
  var record = _ref3.record;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["P" /* LaunchModal */], {
    modal: __WEBPACK_IMPORTED_MODULE_11__RepairOrders_components_Edit_EditCompanyFields__["a" /* default */],
    buttonClass: "btn btn-primary btn-hollow pull-right",
    buttonIcon: "fa-pencil",
    text: "Edit",
    record: record
  });
}

EditCompanyFieldsModal.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}).isRequired
};

function AddPartModal(_ref4) {
  var managedRepairOrder = _ref4.managedRepairOrder;

  if (managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_14__constants__["_38" /* CANCELLED */])) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["P" /* LaunchModal */], {
    buttonClass: "btn btn-primary btn-hollow pull-right",
    modal: __WEBPACK_IMPORTED_MODULE_25__LineItemsTable_Create_Create__["a" /* default */],
    managedRepairOrder: managedRepairOrder.toJS(),
    text: "Add Part"
  });
}

AddPartModal.propTypes = {
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}).isRequired
};

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Lots_constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Form__ = __webpack_require__(1404);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditInvoiceDetails;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















function EditInvoiceDetails(_ref) {
  var managedRepairOrder = _ref.managedRepairOrder;

  if (managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_38" /* CANCELLED */])) {
    return false;
  }

  var initialValues = managedRepairOrder.toJS();

  initialValues.line_items = managedRepairOrder.toJS().line_items.map(function (l) {
    return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_pojos__["a" /* default */])(l).pick(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* ID */], __WEBPACK_IMPORTED_MODULE_10__Lots_constants__["f" /* INVOICE_DUE_DATE */], __WEBPACK_IMPORTED_MODULE_10__Lots_constants__["g" /* AMOUNT_PAID */], __WEBPACK_IMPORTED_MODULE_11__parts_constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_10__Lots_constants__["h" /* INVOICE_NUMBER */], __WEBPACK_IMPORTED_MODULE_10__Lots_constants__["i" /* INVOICE_DATE */], __WEBPACK_IMPORTED_MODULE_10__Lots_constants__["j" /* INVOICE_PAID_DATE */]), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_12__SalesOrders_constants__["v" /* PAID_IN_FULL */], Number(l.amount_paid) === Number(l.price)));
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown_DropDownItem__["a" /* default */],
        { onClick: open },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["k" /* Icon */], { name: "dollar", fixed: true }),
        "\xA0Edit Billing",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__["a" /* Modal */],
          { open: visible, close: close, dialogClass: "modal-lg" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__["c" /* Close */], { close: close }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Edit Billing Details"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Form__["a" /* default */], {
            close: close,
            managedRepairOrder: managedRepairOrder.toJS(),
            initialValues: Object.assign(initialValues, {
              invoice_paid_date: null,
              invoice_number: null
            })
          })
        )
      );
    }
  );
}

EditInvoiceDetails.propTypes = {
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
};

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Lots_constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var FORM_NAME = "editMROInvoiceDetails";

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.setToFullVal = function () {
      _this.props.managedRepairOrder.line_items.filter(function (l) {
        return !l.cancelled;
      }).forEach(function (l, idx) {
        _this.setItemToFullVal(idx);
      });
    }, _this.setItemToFullVal = function (idx) {
      var lineItem = _this.props.managedRepairOrder.line_items.filter(function (l) {
        return !l.cancelled;
      })[idx];
      _this.props.change("line_items[" + idx + "]." + __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["O" /* AMOUNT_PAID */], Number(_this.fieldAmount(lineItem)));

      if (!_this.props.getFieldValue("line_items[" + idx + "]." + __WEBPACK_IMPORTED_MODULE_12__Lots_constants__["j" /* INVOICE_PAID_DATE */])) {
        _this.props.change("line_items[" + idx + "]." + __WEBPACK_IMPORTED_MODULE_12__Lots_constants__["j" /* INVOICE_PAID_DATE */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_date__["i" /* dateFormFormat */])(new Date()));
      }
    }, _this.fieldAmount = function (lineItem) {
      return Number(lineItem.price);
    }, _this.handleTopLevelFormChange = function (ev, field) {
      var val = ev.target.value;
      _this.props.managedRepairOrder.line_items.forEach(function (l, idx) {
        _this.props.change("line_items[" + idx + "]." + field, val);
      });
    }, _this.renderLineItems = function (_ref2) {
      var fields = _ref2.fields;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        fields.map(function (item, idx) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            fields.length > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "line-divider" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "row row-col-gutters-half" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                    { md: 2 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                      component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                      name: item + ".part.part_number",
                      label: "Part #",
                      disabled: true
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                    { md: 2 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                      component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                      name: item + ".serial_number",
                      label: "Serial #",
                      disabled: true
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                    { md: 2 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                      component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                      name: item + ".invoice_number",
                      label: "Invoice Number"
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                    { md: 2 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                      component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                      name: item + ".invoice_date",
                      label: "Invoice Date",
                      type: "date"
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                    { md: 2 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                      component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                      name: item + ".invoice_due_date",
                      label: "Invoice Due Date",
                      type: "date"
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                    { md: 2 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                      component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                      name: item + ".invoice_paid_date",
                      label: "Invoice Paid Date",
                      type: "date"
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                    { md: 2 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                      component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */],
                      name: [item, __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["O" /* AMOUNT_PAID */]].join("."),
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["O" /* AMOUNT_PAID */])
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                    { md: 1 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
                      { justified: true, title: "In Full" },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                        name: item + "." + __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__["v" /* PAID_IN_FULL */],
                        component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                        label: "Yes",
                        onChange: function onChange() {
                          return _this.setItemToFullVal(idx);
                        }
                      })
                    )
                  )
                )
              )
            )
          );
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          managedRepairOrder = _props.managedRepairOrder,
          handleSubmit = _props.handleSubmit,
          close = _props.close,
          invalid = _props.invalid,
          submitting = _props.submitting;

      var activeLineItems = managedRepairOrder.line_items.filter(function (l) {
        return !l.cancelled;
      });
      var shouldRenderSection = activeLineItems.length > 1;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "form",
        { onSubmit: handleSubmit },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["e" /* Body */],
          null,
          shouldRenderSection && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
            { className: "row-col-gutters-half" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                name: "invoice_number",
                label: "Invoice Number",
                onChange: function onChange(e) {
                  return _this2.handleTopLevelFormChange(e, "invoice_number");
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                name: "invoice_date",
                label: "Invoice Date",
                type: "date",
                onChange: function onChange(e) {
                  return _this2.handleTopLevelFormChange(e, "invoice_date");
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                name: "invoice_due_date",
                label: "Invoice Due Date",
                type: "date",
                onChange: function onChange(e) {
                  return _this2.handleTopLevelFormChange(e, "invoice_due_date");
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                name: "invoice_paid_date",
                label: "Invoice Paid Date",
                type: "date",
                onChange: function onChange(e) {
                  return _this2.handleTopLevelFormChange(e, "invoice_paid_date");
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
                { justified: true, title: "Amt Paid In Full" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__["v" /* PAID_IN_FULL */],
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                  label: "Yes",
                  onChange: this.setToFullVal
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "table",
            { className: "table table-striped table-numbered margin-bottom-none" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["FieldArray"], {
              name: "line_items",
              component: this.renderLineItems,
              lineItems: managedRepairOrder.line_items
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["d" /* Footer */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["i" /* Button */],
            { onClick: close },
            "Cancel"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["i" /* Button */],
            {
              type: "submit",
              bsStyle: "primary",
              disabled: invalid || submitting
            },
            "\xA0Update Invoice Details"
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  change: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  invalid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  repairOrder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}),
  submitting: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      dispatch(__WEBPACK_IMPORTED_MODULE_8__actions__["i" /* bulkUpdateLineItems */](data)).then(function () {
        ownProps.close();
      }).catch(function (error) {
        if (error.errors) {
          var errorMessage = Object.keys(error.errors).map(function (key) {
            var messages = error.errors[key];
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(key) + " " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["b" /* toSentence */])(messages) + ".";
          }).join(". ");

          __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].error("Error", errorMessage);
        } else {
          __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].error("Error", error.message);
        }
      });
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["reduxForm"])({
  form: FORM_NAME
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditInvoiceDetails__ = __webpack_require__(1403);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EditInvoiceDetails__["a"]; });


/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(1407);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditVendor;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









function EditVendor(_ref) {
  var open = _ref.open,
      close = _ref.close,
      managedRepairOrder = _ref.managedRepairOrder;

  var mro = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_pojos__["a" /* default */])(managedRepairOrder).pick(__WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["g" /* BUYING_STORE_ID */], __WEBPACK_IMPORTED_MODULE_5__constants__["N" /* COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_5__constants__["O" /* CONTACT_ID */], __WEBPACK_IMPORTED_MODULE_5__constants__["M" /* PAYMENT_TERMS */]);

  var initialValues = _extends({}, mro, {
    contact: null,
    company_id: managedRepairOrder.company_id,
    contact_id: managedRepairOrder.contact_id
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Vendor Details"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Form__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      managedRepairOrder: managedRepairOrder,
      enableReinitialize: true
    })
  );
}

EditVendor.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_CompanyAddressWarning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Locations_components_BuyingStoreRadioField__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__companies_helpers__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_components_PaymentTerms_PaymentTerms__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__validate__ = __webpack_require__(1408);
/* unused harmony export Form */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var formName = "editMroVendorDetails";

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      contacts: []
    }, _this.setPaymentTerms = function (val) {
      _this.props.setFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["M" /* PAYMENT_TERMS */])(val);
    }, _this.fetchContacts = function (value) {
      if (!value) {
        return null;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__parts_actions__["g" /* searchContacts */])(value).then(function () {
        var vals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        _this.setState({ contacts: vals });

        if (_this.props.setPrimaryContact) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__companies_helpers__["a" /* selectPrimaryContact */])(vals, _this.props.setField(__WEBPACK_IMPORTED_MODULE_7__constants__["O" /* CONTACT_ID */]));
        }
      });
    }, _this.handleCompanyChange = function (result) {
      if (_this.props.setSelectedCompany) _this.props.setSelectedCompany(result);

      if (_this.props.notifyForm) _this.props.notifyForm(result);

      if (result) {
        var address = result.primary_physical_address;
        var formattedAddress = address ? [address.city, address.state, address.country].join("-") : "";
        _this.props.setFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["H" /* FOB */])(formattedAddress);
        if (_this.props.setPaymentTerms) _this.props.setPaymentTerms(result.vendor_credit_terms);
        _this.fetchContacts(result.id);
      } else {
        _this.setState({ contacts: [] });
      }
    }, _this.notifyForm = function (company) {
      return _this.setState({ company: company });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.managedRepairOrder && this.props.managedRepairOrder.company) {
        this.fetchContacts(this.props.managedRepairOrder.company.id);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          contact = _props.contact,
          managedRepairOrder = _props.managedRepairOrder,
          searchCompanies = _props.searchCompanies,
          getInitialFieldValue = _props.getInitialFieldValue;
      var _state = this.state,
          selectedCompany = _state.selectedCompany,
          contacts = _state.contacts;


      var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__companies_helpers__["b" /* contactSelectList */])(contacts, true);
      var company = selectedCompany || managedRepairOrder && managedRepairOrder.company;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_CompanyAddressWarning__["a" /* default */], { company: company }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_16__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
                  { md: 5 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Locations_components_BuyingStoreRadioField__["a" /* default */], { label: "Managing Store" })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["m" /* DashedSeparator */], null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_7__constants__["N" /* COMPANY_ID */],
                  label: "Vendor",
                  labelChildren: company && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["g" /* CompanyStatsTooltip */], { company: company })
                  ),
                  placeholder: "Search by typing a company's name or code",
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["n" /* AutoCompleteField */],
                  search: searchCompanies,
                  formatItem: function formatItem(result) {
                    return result.name + " (" + __WEBPACK_IMPORTED_MODULE_12__companies_constants__["h" /* APPROVAL_STATUSES */][result.vendor_status].label + ")";
                  },
                  onItemSelected: function onItemSelected(i) {
                    return i && _this2.handleCompanyChange(i);
                  },
                  selectedItem: company,
                  required: true
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_7__constants__["O" /* CONTACT_ID */],
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
                  options: options,
                  label: "Vendor Contact",
                  required: true
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components_PaymentTerms_PaymentTerms__["a" /* default */], { getInitialFieldValue: getInitialFieldValue })
              )
            ),
            contact === __WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                    disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lodash__["get"])(company, __WEBPACK_IMPORTED_MODULE_12__companies_constants__["e" /* WEBSITE */]),
                    name: "company.website",
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__companies_constants__["e" /* WEBSITE */]),
                    required: true
                  })
                )
              )
            ),
            contact === "Add" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    name: "contact.name",
                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                    label: "Contact Name",
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    name: "contact.email",
                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                    label: "Contact Email",
                    required: true
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  setLot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  lot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    contact: selector(state, __WEBPACK_IMPORTED_MODULE_7__constants__["O" /* CONTACT_ID */]),
    getInitialFieldValue: function getInitialFieldValue(field) {
      return __WEBPACK_IMPORTED_MODULE_15_lodash___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["getFormInitialValues"])(formName)(state), field);
    }
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_4__actions__["g" /* update */](data));
    },
    searchCompanies: function searchCompanies(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* searchCompanies */](filter));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])(formName, field, val));
      };
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_20__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_shared_validations__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* unused harmony export validateShipping */






function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["N" /* COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["O" /* CONTACT_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["M" /* PAYMENT_TERMS */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    if (values.buyer_credit_pct <= 50.0) {
      v.validate(__WEBPACK_IMPORTED_MODULE_3__users_constants__["z" /* CO_BUYER_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if (values.buyer_credit_pct <= 37.5) {
      v.validate(__WEBPACK_IMPORTED_MODULE_3__users_constants__["y" /* THIRD_BUYER_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }
  });
}

function validateShipping(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_shared_validations__["c" /* validateShippingFields */])(values, v);
  });
}

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_RecordPager_RecordPager__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_ActionDropDown_ActionDropDown__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ReleaseAccountingHold_ReleaseAccountingHold__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EditInvoiceDetails__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ToggleQuickbooksSync_ToggleQuickbooksSync__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Sync_Sync__ = __webpack_require__(1425);
/* unused harmony export Header */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      sendOrderModalOpen: false,
      cancelOrderModalOpen: false,
      cancellationReason: __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["k" /* CANCELLATION_REASONS */][0].value
    }, _this.onConfirmToRemoveAcctgHold = function () {
      var dispatch = _this.props.dispatch;


      dispatch(__WEBPACK_IMPORTED_MODULE_12__actions__["g" /* update */]({ accounting_hold: false }));
    }, _this.openCancelOrderModal = function () {
      return _this.setState({ cancelOrderModalOpen: true });
    }, _this.closeCancelOrderModal = function () {
      return _this.setState({ cancelOrderModalOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      var managedRepairOrder = this.props.managedRepairOrder;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "page-header page-header-bar" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h1",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "btn-group pull-right", style: { marginLeft: 20 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__shared_components_ActionDropDown_ActionDropDown__["a" /* default */],
              {
                menuClass: "dropdown-menu-right",
                style: { cursor: "pointer" }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ReleaseAccountingHold_ReleaseAccountingHold__["a" /* default */], {
                onConfirm: this.onConfirmToRemoveAcctgHold,
                managedRepairOrder: managedRepairOrder
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__EditInvoiceDetails__["a" /* default */], { managedRepairOrder: managedRepairOrder }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ToggleQuickbooksSync_ToggleQuickbooksSync__["a" /* default */], { managedRepairOrder: managedRepairOrder }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Sync_Sync__["a" /* default */], { managedRepairOrder: managedRepairOrder })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_RecordPager_RecordPager__["a" /* default */], {
            baseUrl: "/managed-repair-orders",
            record: managedRepairOrder
          }),
          "\xA0",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "header-content" },
            managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["z" /* CODE */])
          ),
          "\xA0",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["E" /* ClipboardCopy */], { name: managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["z" /* CODE */]), type: "RO" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "small text-muted" },
            "Created ",
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__["b" /* shortDate */])(managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_7" /* CREATED_AT */]))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "pull-right" },
            managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__["u" /* ACCOUNTING_HOLD */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["p" /* StatusTag */], {
              title: "Accounting Hold",
              icon: "pause",
              display: "warning"
            }),
            managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["A" /* LINE_ITEMS */]).some(function (f) {
              return f.get("return_to_customer_without_repairing");
            }) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["p" /* StatusTag */], { icon: "undo", title: "Returned To Customer" }),
            managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["A" /* LINE_ITEMS */]).some(function (f) {
              return f.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_38" /* CANCELLED */]);
            }) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["p" /* StatusTag */], { icon: "ban", title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_38" /* CANCELLED */]) }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "small text-muted" },
              managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["A" /* LINE_ITEMS */], []).size,
              " Item(s)"
            ),
            "\xA0\xA0\xA0Total: ",
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(managedRepairOrder.get("total"))
          )
        )
      );
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    id: state.mroDetail.getIn(["managedRepairOrder", "id"])
  };
})(Header));

Header.propTypes = {
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmDelete__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);










function Controls(_ref) {
  var cancelItem = _ref.cancelItem,
      lineItem = _ref.lineItem,
      returnItem = _ref.returnItem;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__["c" /* ImprovedDropDown */],
    null,
    !lineItem.cancelled && !lineItem.received && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
      id: "cancel",
      label: "Cancel",
      faIcon: "ban",
      renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmDelete__["a" /* default */], {
        onConfirm: cancelItem,
        message: "Are you sure you want to cancel?"
      })
    }),
    !lineItem.shipped && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "inventory.repair_status") === __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["a" /* RESERVE_FOR_REPAIR */] && lineItem.received && !lineItem.return_to_customer_without_repairing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
      id: "cancel",
      label: "Return To Customer",
      faIcon: "ban",
      renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["i" /* ConfirmAction */], {
        onConfirm: returnItem,
        message: "Are you sure you want to return?"
      })
    })
  );
}

Controls.propTypes = {
  cancelItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  returnItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(undefined, function (dispatch, _ref2) {
  var id = _ref2.lineItem.id;
  return {
    cancelItem: function cancelItem() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["e" /* updateLineItem */])(id, { cancelled: true }));
    },
    returnItem: function returnItem() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["f" /* returnToCustomer */])(id));
    }
  };
})(Controls));

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Form__ = __webpack_require__(1412);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();











function Create(_ref) {
  var open = _ref.open,
      close = _ref.close,
      onSubmit = _ref.onSubmit,
      managedRepairOrder = _ref.managedRepairOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPart = _useState2[0],
      setSelectedPart = _useState2[1];

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__hooks__["a" /* useCurrentUser */])();

  var initialVals = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* initialValues */])(null, currentUser, managedRepairOrder);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-lg" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Add a Part"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Form__["a" /* default */], {
        close: close,
        onSubmit: onSubmit,
        initialValues: initialVals,
        managedRepairOrder: managedRepairOrder,
        setSelectedPart: setSelectedPart,
        selectedPart: selectedPart
      })
    )
  );
}

Create.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["c" /* addLineItem */])(data));
    }
  };
})(Create));

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_shared__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shared_PartSummary__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Orders_shared_InvoiceSection__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__constants__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__validate__ = __webpack_require__(429);
/* unused harmony export SRP_CONDITION_OPTIONS */
/* unused harmony export DOMIsRequiredWarning */
/* unused harmony export UnauthorizedRepairStationSelectedWarning */
/* unused harmony export UnauthorizedPreferredRepairStationSelectedWarning */
/* unused harmony export AsIsField */
/* unused harmony export Form */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
































var formName = "mroLineItemForm";

var SRP_CONDITION_OPTIONS = [{ value: "overhauled", text: "Overhauled" }, { value: "repaired", text: "Repaired" }, { value: "inspected", text: "Inspected" }, { value: "new_item", text: "New" }, { value: "as_removed", text: "As Removed" }, { value: "beyond_econ_repair", text: "Beyond Econ Repair" }];

function InsuranceTypeField(_ref) {
  var amountInsured = _ref.amount_insured,
      percentInsured = _ref.percent_insured,
      insuranceType = _ref.insurance_type,
      disabled = _ref.disabled;

  var activePercent = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "Percent"
  });
  var activeAmount = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "Amount"
  });
  var activeNone = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "None"
  });

  var handleInsuranceTypeChange = function handleInsuranceTypeChange(newVal) {
    return function () {
      if (disabled) return;
      insuranceType.input.onChange(newVal);
      if (newVal === "Amount") {
        percentInsured.input.onChange(null);
      } else if (newVal === "Percent") {
        amountInsured.input.onChange(null);
      } else {
        amountInsured.input.onChange(null);
        percentInsured.input.onChange(null);
      }
    };
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group", style: { marginBottom: 20 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { className: "control-label", htmlFor: "insurance_type" },
      "Insurance"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "btn-group btn-group-justified", role: "group" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activeNone,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("None")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Do Not Insure"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activeAmount,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("Amount")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Amount"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activePercent,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("Percent")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Percent"
      )
    )
  );
}

InsuranceTypeField.propTypes = {
  amount_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  percent_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  insurance_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function AmountInsuredFields(_ref2) {
  var amount = _ref2.amount,
      disabled = _ref2.disabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
    { md: 4 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["f" /* CurrencyField */], {
      name: amount.input.name,
      label: "Insurance Amount",
      disabled: disabled,
      required: true
    })
  );
}

AmountInsuredFields.propTypes = {
  amount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function DOMIsRequiredWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_27__shared_components__["n" /* Warning */],
    null,
    "Part is DOM Sensitive. DOM Required."
  );
}

function UnauthorizedRepairStationSelectedWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_27__shared_components__["n" /* Warning */],
    null,
    "Note: This Repair Station is not approved. Unless you are reserving this unit for repair to a different repair station, PO will require management approval before you are able to send PO."
  );
}

function UnauthorizedPreferredRepairStationSelectedWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_27__shared_components__["n" /* Warning */],
    null,
    "Note: This Repair Station is not approved. PO will require management approval before you are able to send PO."
  );
}

function PercentInsuredFields(_ref3) {
  var percent = _ref3.percent,
      cost = _ref3.cost,
      quantity = _ref3.quantity,
      disabled = _ref3.disabled;

  var costValue = cost.input.value || 0;
  var quantityValue = quantity.input.value || 0;
  var percentValue = percent.input.value || 0;
  var subtotal = parseFloat(costValue) * parseFloat(quantityValue);
  var insuranceAmount = Math.ceil(subtotal * percentValue) / 100;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
    { md: 12 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
          name: percent.input.name,
          label: "Insurance Percent",
          component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["h" /* NumberInput */],
          parse: function parse(value) {
            return value && parseInt(value, 10);
          },
          addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-percent" }),
          disabled: disabled,
          required: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "insurance_type" },
            "Insurance Amount"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "input-group-addon" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-dollar" })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
              className: "form-control",
              type: "text",
              value: insuranceAmount,
              disabled: true,
              readOnly: true
            })
          )
        )
      )
    )
  );
}

PercentInsuredFields.propTypes = {
  percent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function InsuranceFields(_ref4) {
  var amountInsured = _ref4.amount_insured,
      percentInsured = _ref4.percent_insured,
      insuranceType = _ref4.insurance_type,
      cost = _ref4.cost,
      quantity = _ref4.quantity,
      disabled = _ref4.disabled;

  if (insuranceType.input.value === "Amount") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AmountInsuredFields, { amount: amountInsured, disabled: disabled });
  } else if (insuranceType.input.value === "Percent") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PercentInsuredFields, {
      insuranceType: insuranceType,
      percent: percentInsured,
      cost: cost,
      quantity: quantity,
      disabled: disabled
    });
  }

  return null;
}

InsuranceFields.propTypes = {
  amount_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  percent_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  insurance_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

function LineHazmatFields(_ref5) {
  var hazmat = _ref5.hazmat,
      bio_hazmat = _ref5.bio_hazmat,
      disabled = _ref5.disabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group btn-group-justified", "data-toggle": "buttons" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["b" /* Check */], {
      input: hazmat.input,
      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__parts_constants__["h" /* HAZMAT */]),
      icon: "fa-warning",
      disabled: disabled
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["b" /* Check */], {
      input: bio_hazmat.input,
      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__parts_constants__["i" /* BIO_HAZMAT */]),
      icon: "fa-flask",
      disabled: disabled
    })
  );
}

LineHazmatFields.propTypes = {
  hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  bio_hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function AsIsField(_ref6) {
  var asIs = _ref6.as_is,
      evaluationPeriod = _ref6.evaluation_period,
      disabled = _ref6.disabled;

  var handleChange = function handleChange(val) {
    asIs.input.onChange(val);
    if (val === true) {
      evaluationPeriod.input.onChange(0);
    } else {
      evaluationPeriod.input.onChange(30);
    }
  };

  var input = _extends({}, asIs.input, { onChange: handleChange });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group btn-group-justified", "data-toggle": "buttons" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["b" /* Check */], {
      input: input,
      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["c" /* AS_IS */]),
      icon: "fa-check-circle",
      disabled: disabled
    })
  );
}

AsIsField.propTypes = {
  as_is: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  evaluation_period: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref7;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref7 = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref7, [this].concat(args))), _this), _this.state = {
      alternateOptions: [],
      selectedPart: {}
    }, _this.fetchAlternates = function (partId) {
      if (!partId) return;
      _this.props.searchAlternates(partId).then(function (results) {
        return _this.setState({
          alternateOptions: results.map(function (item) {
            return {
              text: item.name,
              value: item.id
            };
          })
        });
      });
    }, _this.handlePartSelected = function (part) {
      _this.props.setSelectedPart(part);
      _this.props.resetAlternatePartField();
      if (part) {
        _this.props.setHazardFields(part);
        _this.props.setHeavyPackage(part);
        _this.fetchAlternates(part.id);
      }
    }, _this.searchCompanies = function (filter) {
      return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].companies.search({
        repair_station: true,
        filter: filter,
        status: [__WEBPACK_IMPORTED_MODULE_23__companies_constants__["c" /* ACTIVE */], __WEBPACK_IMPORTED_MODULE_23__companies_constants__["d" /* CREDIT_HOLD */]].join(","),
        page: 1,
        limit: 20
      }).then(function (resp) {
        return resp.data.results;
      });
    }, _this.handleTaggedBy = function (company) {
      var _this$props = _this.props,
          setTaggedById = _this$props.setTaggedById,
          setTaggedByHold = _this$props.setTaggedByHold;


      if (company && company.id) {
        setTaggedById(company.id);
        setTaggedByHold(company.repair_station_status !== __WEBPACK_IMPORTED_MODULE_23__companies_constants__["j" /* APPROVED */]);
      } else {
        setTaggedByHold(false);
      }
    }, _this.handlePreferredRepairStation = function (company) {
      var setPreferredRepairStationHold = _this.props.setPreferredRepairStationHold;


      if (company && company.id) {
        setPreferredRepairStationHold(company.repair_station_status !== __WEBPACK_IMPORTED_MODULE_23__companies_constants__["j" /* APPROVED */]);
      }
    }, _this.resetPreferredRepairStation = function () {
      var resetPreferredRepairStation = _this.props.resetPreferredRepairStation;


      resetPreferredRepairStation();

      _this.setState({ selectedPreferredRepairStation: null });
    }, _this.toggleBuyer = function (buyer) {
      return _this.setState(buyer);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.lineItem) {
        var id = this.props.lineItem.part_id;
        var part = this.props.lineItem.part;
        var coBuyer = this.props.lineItem.co_buyer;
        var thirdBuyer = this.props.lineItem.third_buyer;

        if (part) {
          this.props.setHazardFields(part);
          this.props.setHeavyPackage(part);
          this.fetchAlternates(part.id);
        }

        this.props.setPartId(id);
        this.props.setSelectedPart(part || {});
        this.setState({
          selectedCoBuyer: coBuyer,
          selectedThirdBuyer: thirdBuyer
        });
      }

      this.setState({
        selectedReserveForSeller: this.props.currentUser
      });

      if (this.props.selectedLineItem) {
        var _props$selectedLineIt = this.props.selectedLineItem,
            _part = _props$selectedLineIt.part,
            modTo = _props$selectedLineIt.mod_to,
            co_buyer = _props$selectedLineIt.co_buyer,
            third_buyer = _props$selectedLineIt.third_buyer,
            preferredRepairStation = _props$selectedLineIt.preferred_repair_station,
            reserveForSeller = _props$selectedLineIt.reserve_for_seller;


        this.setState({
          selectedModTo: modTo,
          selectedPart: _part,
          selectedCoBuyer: co_buyer,
          selectedThirdBuyer: third_buyer,
          selectedPreferredRepairStation: preferredRepairStation,
          selectedReserveForSeller: reserveForSeller || this.props.currentUser
        });

        this.props.setSelectedPart(_part);
        this.fetchAlternates(_part.id);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          getFieldValue = _props.getFieldValue,
          buyerCreditPct = _props.buyerCreditPct,
          currentUser = _props.currentUser,
          capType = _props.capType,
          condition = _props.condition,
          containerFee = _props.containerFee,
          cost = _props.cost,
          quantity = _props.quantity,
          searchBuyers = _props.searchBuyers,
          searchParts = _props.searchParts,
          searchRepairStations = _props.searchRepairStations,
          selectedLineItem = _props.selectedLineItem,
          hazmatFee = _props.hazmatFee,
          markedHazardous = _props.markedHazardous,
          modalMode = _props.modalMode,
          selectedPart = _props.selectedPart,
          domLifeYears = _props.domLifeYears,
          llp = _props.llp,
          modTo = _props.modTo,
          dom = _props.dom;


      var buyerCreditPctOptions = [{ text: "75%", value: "75.0" }, { text: "50%", value: "50.0" }, { text: "25%", value: "25.0" }];
      var _state = this.state,
          selectedBuyer = _state.selectedBuyer,
          selectedModTo = _state.selectedModTo,
          selectedCoBuyer = _state.selectedCoBuyer,
          selectedThirdBuyer = _state.selectedThirdBuyer,
          selectedPreferredRepairStation = _state.selectedPreferredRepairStation,
          alternateOptions = _state.alternateOptions;

      var formProps = _extends({}, this.props);

      var taggedByHold = getFieldValue("tagged_by_hold");
      var domSensitive = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(selectedPart, __WEBPACK_IMPORTED_MODULE_12__parts_constants__["_7" /* DOM_SENSITIVE */]);

      var preferredRepairStationHold = getFieldValue("preferred_repair_station_hold");

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["e" /* Form */],
        _extends({}, formProps, { modal: modalMode }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: modalMode ? 8 : 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: "row row-col-gutters-half",
                  style: { marginTop: "26px" }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["q" /* PART_ID */],
                    label: "Part #",
                    placeholder: "Type a part's number...",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["n" /* AutoCompleteField */],
                    search: searchParts,
                    selectedItem: selectedPart,
                    formatItem: function formatItem(result) {
                      return result && result.part_number;
                    },
                    onItemSelected: function onItemSelected(i) {
                      return i && _this2.handlePartSelected(i);
                    },
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["o" /* ALTERNATE_ID */],
                    label: "Buy As Alternate",
                    placeholder: "Type a part's number...",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["c" /* Select */],
                    options: alternateOptions,
                    addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-exchange" }),
                    disabled: alternateOptions.length === 0
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__shared_components__["m" /* DashedSeparator */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["n" /* CONDITION */],
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["c" /* Select */],
                    options: SRP_CONDITION_OPTIONS,
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["n" /* CONDITION */]),
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */],
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    label: "QTY",
                    type: "number",
                    required: true,
                    inputProps: {
                      min: 0
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["_28" /* MARKUP */]),
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["_28" /* MARKUP */],
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["h" /* NumberInput */],
                    addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-percent" }),
                    type: "number",
                    inputProps: {
                      min: 0,
                      max: 100
                    },
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["y" /* EXPIRATION */],
                    label: "Expiration Date",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    type: "date"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__shared_components__["m" /* DashedSeparator */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 5 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "label",
                      { htmlFor: "warnings", className: "control-label" },
                      "Line Hazmat"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Fields"], {
                      names: [__WEBPACK_IMPORTED_MODULE_12__parts_constants__["h" /* HAZMAT */], __WEBPACK_IMPORTED_MODULE_12__parts_constants__["i" /* BIO_HAZMAT */]],
                      component: LineHazmatFields
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "label",
                      { htmlFor: __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["c" /* AS_IS */], className: "control-label" },
                      "As Is"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Fields"], {
                      names: [__WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["c" /* AS_IS */], __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["u" /* EVALUATION_PERIOD */]],
                      component: AsIsField
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 5 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["a" /* CheckGroup */],
                    { title: "Heavy Package / DIM Weight", justified: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["v" /* DIM_WEIGHT */],
                      component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["b" /* Check */],
                      label: "Hvy Pkg / DIM Weight",
                      icon: "fa-check-circle"
                    })
                  )
                )
              ),
              selectedModTo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_27__shared_components__["n" /* Warning */],
                null,
                "SRP Info will be applied to PN ",
                selectedModTo.part_number
              ),
              taggedByHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnauthorizedRepairStationSelectedWarning, null),
              domSensitive && __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(dom) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DOMIsRequiredWarning, null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["r" /* MonthYearField */], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["x" /* TAG_DATE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["x" /* TAG_DATE */]),
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    required: __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__["u" /* TAG_DATE_CONDITIONS */].includes(condition)
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["p" /* TAGGED_BY */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["p" /* TAGGED_BY */]),
                    placeholder: "Search by a company's name",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["s" /* AutoCompleteUserInputField */],
                    required: __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__["u" /* TAG_DATE_CONDITIONS */].includes(condition),
                    search: this.searchCompanies,
                    selectedItem: selectedLineItem && selectedLineItem.tagged_by,
                    handleTaggedBy: function handleTaggedBy(result) {
                      return _this2.handleTaggedBy(result);
                    },
                    formatItem: function formatItem(result) {
                      return ((typeof result === "undefined" ? "undefined" : _typeof(result)) === "object" ? result.name : result) || "";
                    }
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["r" /* MonthYearField */], {
                    name: "dom",
                    label: "DOM",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    required: domLifeYears && llp || domSensitive
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["E" /* TRACE_TYPE */],
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["c" /* Select */],
                    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes),
                    label: "Expected Trace Type"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["F" /* TRACED_TO */],
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    label: "Expected Trace To"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["G" /* LEAD_TIME */],
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    label: "Lead Time (Days)",
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["a" /* CheckGroup */],
                    { justified: true, title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["h" /* MOD_TO */]) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["h" /* MOD_TO */],
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["h" /* MOD_TO */]),
                      icon: "fa-check-circle",
                      component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["b" /* Check */]
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
                  { "in": modTo || false, unmountOnExit: true },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                    { md: 4 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["i" /* MOD_TO_ID */],
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["h" /* MOD_TO */]),
                      placeholder: "Type a part's number...",
                      selectedItem: selectedModTo,
                      component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["n" /* AutoCompleteField */],
                      onItemSelected: function onItemSelected(item) {
                        return item && _this2.setState({ selectedModTo: item });
                      },
                      search: searchParts,
                      formatItem: function formatItem(result) {
                        return result && result.part_number;
                      }
                    })
                  )
                )
              ),
              selectedPart && selectedPart.llp && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__parts_constants__["E" /* TOTAL_HOURS */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__parts_constants__["E" /* TOTAL_HOURS */]),
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["h" /* NumberInput */],
                    roundDigits: 0
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__parts_constants__["F" /* TOTAL_CYCLES */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__parts_constants__["F" /* TOTAL_CYCLES */]),
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["h" /* NumberInput */],
                    roundDigits: 0
                  })
                )
              ),
              this.props.showBuyers && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__shared_components__["m" /* DashedSeparator */], null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  null,
                  "Buyers"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                    { md: 5 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_shared__["c" /* BuyerField */], {
                      searchBuyers: searchBuyers,
                      selectedBuyer: selectedBuyer,
                      onItemSelected: function onItemSelected(buyer) {
                        return _this2.setState({ selectedBuyer: buyer });
                      }
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                    { md: 3 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_6__constants__["G" /* BUYER_CREDIT_PCT */],
                      className: "text-right",
                      component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["c" /* Select */],
                      options: buyerCreditPctOptions,
                      prompt: false,
                      label: "Buyer Credit",
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_shared__["b" /* CoBuyersFields */], {
                    toggleBuyer: this.toggleBuyer,
                    buyerCreditPct: buyerCreditPct,
                    selectedCoBuyer: selectedCoBuyer,
                    selectedThirdBuyer: selectedThirdBuyer,
                    numberOfBuyers: [getFieldValue(__WEBPACK_IMPORTED_MODULE_19__users_constants__["z" /* CO_BUYER_ID */]), getFieldValue(__WEBPACK_IMPORTED_MODULE_19__users_constants__["y" /* THIRD_BUYER_ID */])].filter(function (s) {
                      return s;
                    }).length + 1,
                    searchBuyers: searchBuyers
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__Orders_shared_InvoiceSection__["a" /* default */], {
                hidden: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_19__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_19__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_19__users_constants__["l" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_19__users_constants__["k" /* SALES */]]),
                disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_19__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_19__users_constants__["l" /* REPAIR */]]),
                orderType: __WEBPACK_IMPORTED_MODULE_28__constants__["a" /* MANAGED_REPAIR_ORDER */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__shared_components__["m" /* DashedSeparator */], null),
              preferredRepairStationHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnauthorizedPreferredRepairStationSelectedWarning, null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Shipping & Repairs"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                selectedLineItem && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["W" /* AWB_NUMBER */],
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    label: "AWB #",
                    disabled: selectedLineItem.received
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["y" /* CONTAINER_FEE */],
                    label: "Container/Crate Fee"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["z" /* HAZMAT_FEE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]),
                    required: markedHazardous
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["w" /* PREFERRED_REPAIR_STATION_ID */],
                    label: "Suggested Repair Station",
                    placeholder: "Type a vendor's name or code...",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["n" /* AutoCompleteField */],
                    search: searchRepairStations,
                    selectedItem: selectedPreferredRepairStation,
                    formatItem: function formatItem(result) {
                      return result && result.name;
                    },
                    required: true,
                    watch: selectedPreferredRepairStation,
                    onItemSelected: this.handlePreferredRepairStation
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["u" /* EVALUATION_PERIOD */],
                    type: "number",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    label: "Eval. Period"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["A" /* CAP_TYPE */],
                    className: "text-right",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["c" /* Select */],
                    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["B" /* CAP_TYPES */]),
                    label: "Repair/Overhaul Cap"
                  })
                ),
                capType && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["C" /* CAP_AMOUNT */],
                    label: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["B" /* CAP_TYPES */][capType].label + " Cap Amount"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 12 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Fields"], {
                    names: [__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["D" /* AMOUNT_INSURED */], __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["E" /* PERCENT_INSURED */], __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["F" /* INSURANCE_TYPE */]],
                    component: InsuranceTypeField
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Fields"], {
                  names: [__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["D" /* AMOUNT_INSURED */], __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["E" /* PERCENT_INSURED */], __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["F" /* INSURANCE_TYPE */], __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */], __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]],
                  component: InsuranceFields
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__shared_components__["m" /* DashedSeparator */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Notes"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["G" /* INTERNAL_NOTE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["G" /* INTERNAL_NOTE */]),
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["l" /* TextArea */],
                    rows: 5
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */]),
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["l" /* TextArea */],
                    rows: 5
                  })
                )
              )
            ),
            modalMode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__shared_PartSummary__["a" /* default */], {
                part: selectedPart,
                cost: cost,
                quantity: quantity,
                lineItem: this.props.selectedLineItem,
                hazmatFee: hazmatFee,
                containerFee: containerFee
              })
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setTaggedById: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setTaggedByHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  showBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cap_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    co_buyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    third_buyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    part_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  renderFooter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  resetAlternatePartField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchAlternates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchParts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchRepairStations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setHeavyPackage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setHazardFields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setPartId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  domLifeYears: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  llp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectedPart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  setSelectedPart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setPreferredRepairStationHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetPreferredRepairStation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
Form.defaultProps = {
  modalMode: true,
  showBuyers: true
};
var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    getFieldValue: function getFieldValue(field) {
      return selector(state, field);
    },
    getInitialFieldValue: function getInitialFieldValue(field) {
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["getFormInitialValues"])(formName)(state), field);
    },
    buyerCreditPct: selector(state, __WEBPACK_IMPORTED_MODULE_6__constants__["G" /* BUYER_CREDIT_PCT */]),
    capType: selector(state, __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["A" /* CAP_TYPE */]),
    cost: selector(state, __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */]),
    quantity: selector(state, __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]),
    condition: selector(state, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["n" /* CONDITION */]),
    minExchangeSrp: state.session.getIn([__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_6__constants__["X" /* MINIMUM_EXCHANGE_SRP */]]),
    exchangeSRP: selector(state, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["u" /* EXCHANGE_SRP */]),
    asIs: selector(state, __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["c" /* AS_IS */]),
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_19__users_constants__["a" /* USER */]).toJS(),
    hazmatFee: selector(state, __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]),
    containerFee: selector(state, __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["y" /* CONTAINER_FEE */]),
    markedHazardous: selector(state, __WEBPACK_IMPORTED_MODULE_12__parts_constants__["h" /* HAZMAT */]),
    modTo: selector(state, __WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["h" /* MOD_TO */]),
    dom: selector(state, __WEBPACK_IMPORTED_MODULE_12__parts_constants__["G" /* DOM */]),
    getField: function getField(field) {
      return selector(state, field);
    }
  };
}, function (dispatch) {
  return {
    resetAlternatePartField: function resetAlternatePartField() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["o" /* ALTERNATE_ID */], null));
    },
    setPartId: function setPartId(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["q" /* PART_ID */], id));
    },
    setHazardFields: function setHazardFields(part) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_12__parts_constants__["i" /* BIO_HAZMAT */], part.bio_hazmat));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_12__parts_constants__["h" /* HAZMAT */], part.hazmat));
    },
    setHeavyPackage: function setHeavyPackage(part) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["v" /* DIM_WEIGHT */], part.dim_weight));
    },
    searchAlternates: function searchAlternates(partId) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_actions__["e" /* searchAlternates */](partId));
    },
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_actions__["c" /* searchBuyers */](filter));
    },
    searchParts: function searchParts(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_15__parts_actions__["a" /* searchPoParts */](filter));
    },
    searchRepairStations: function searchRepairStations(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_actions__["f" /* searchRepairStations */](filter));
    },
    resetForm: function resetForm(id) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["replace"])("/managed-repair-orders/" + id));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, field, val));
      };
    },
    setTaggedById: function setTaggedById(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["O" /* TAGGED_BY_ID */], id));
    },
    setTaggedByHold: function setTaggedByHold(hold) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, "tagged_by_hold", hold));
    },
    setPreferredRepairStationHold: function setPreferredRepairStationHold(hold) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, "preferred_repair_station_hold", hold));
    },
    resetPreferredRepairStation: function resetPreferredRepairStation() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, "preferred_repair_station_id", ""));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_29__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Form__ = __webpack_require__(1414);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












function EditPart(_ref) {
  var open = _ref.open,
      close = _ref.close,
      selectedLineItem = _ref.selectedLineItem,
      onSubmit = _ref.onSubmit,
      managedRepairOrder = _ref.managedRepairOrder,
      currentUser = _ref.currentUser;

  var initialValues = _extends({}, selectedLineItem, {
    displayCoBuyer1: !!(selectedLineItem && selectedLineItem.co_buyer_id),
    displayCoBuyer2: !!(selectedLineItem && selectedLineItem.third_buyer_id),
    created_at: managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_7" /* CREATED_AT */]),
    insurance_type: selectedLineItem && selectedLineItem.insurance_type,
    displayCoBuyerFields: !!(selectedLineItem && selectedLineItem.co_buyer_id),
    displayThirdBuyerFields: !!(selectedLineItem && selectedLineItem.third_buyer_id),
    read_only_buyer: managedRepairOrder.getIn([__WEBPACK_IMPORTED_MODULE_7__users_constants__["P" /* BUYER */], "full_name"]),
    reserve_for_seller_id: selectedLineItem && selectedLineItem.reserve_for_seller_id || currentUser.get(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* ID */]),
    tagged_by: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(selectedLineItem, "tagged_by.name"),
    tagged_by_id: selectedLineItem && selectedLineItem.tagged_by_id,
    tagged_by_hold: selectedLineItem && selectedLineItem.tagged_by_hold
  });

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(selectedLineItem, "part", {})),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPart = _useState2[0],
      setSelectedPart = _useState2[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Part"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Form__["a" /* default */], {
      onSubmit: onSubmit,
      close: close,
      initialValues: initialValues,
      selectedPart: selectedPart,
      setSelectedPart: setSelectedPart,
      enableReinitialize: true,
      selectedLineItem: selectedLineItem
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    managedRepairOrder: state.mroDetail.get("managedRepairOrder"),
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["a" /* USER */])
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["e" /* updateLineItem */](ownProps.selectedLineItem.id, data));
    }
  };
})(EditPart));

EditPart.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])
};

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_shared__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shared_PartSummary__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Locations_components_ToolsUsedDropDown__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Orders_shared_InvoiceSection__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__constants__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__validate__ = __webpack_require__(429);
/* unused harmony export SRP_CONDITION_OPTIONS */
/* unused harmony export DOMIsRequiredWarning */
/* unused harmony export UnauthorizedRepairStationSelectedWarning */
/* unused harmony export UnauthorizedPreferredRepairStationSelectedWarning */
/* unused harmony export AsIsField */
/* unused harmony export Form */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

































var formName = "editMroLineItemForm";

var SRP_CONDITION_OPTIONS = [{ value: "overhauled", text: "Overhauled" }, { value: "repaired", text: "Repaired" }, { value: "inspected", text: "Inspected" }, { value: "new_item", text: "New" }, { value: "as_removed", text: "As Removed" }, { value: "beyond_econ_repair", text: "Beyond Econ Repair" }];

function InsuranceTypeField(_ref) {
  var amountInsured = _ref.amount_insured,
      percentInsured = _ref.percent_insured,
      insuranceType = _ref.insurance_type,
      disabled = _ref.disabled;

  var activePercent = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "Percent"
  });
  var activeAmount = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "Amount"
  });
  var activeNone = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "None"
  });

  var handleInsuranceTypeChange = function handleInsuranceTypeChange(newVal) {
    return function () {
      if (disabled) return;
      insuranceType.input.onChange(newVal);
      if (newVal === "Amount") {
        percentInsured.input.onChange(null);
      } else if (newVal === "Percent") {
        amountInsured.input.onChange(null);
      } else {
        amountInsured.input.onChange(null);
        percentInsured.input.onChange(null);
      }
    };
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group", style: { marginBottom: 20 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { className: "control-label", htmlFor: "insurance_type" },
      "Insurance"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "btn-group btn-group-justified", role: "group" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activeNone,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("None")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Do Not Insure"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activeAmount,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("Amount")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Amount"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activePercent,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("Percent")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Percent"
      )
    )
  );
}

InsuranceTypeField.propTypes = {
  amount_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  percent_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  insurance_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function AmountInsuredFields(_ref2) {
  var amount = _ref2.amount,
      disabled = _ref2.disabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
    { md: 4 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["f" /* CurrencyField */], {
      name: amount.input.name,
      label: "Insurance Amount",
      disabled: disabled,
      required: true
    })
  );
}

AmountInsuredFields.propTypes = {
  amount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function DOMIsRequiredWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_28__shared_components__["n" /* Warning */],
    null,
    "Part is DOM Sensitive. DOM Required."
  );
}

function UnauthorizedRepairStationSelectedWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_28__shared_components__["n" /* Warning */],
    null,
    "Note: This Repair Station is not approved. Unless you are reserving this unit for repair to a different repair station, PO will require management approval before you are able to send PO."
  );
}

function UnauthorizedPreferredRepairStationSelectedWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_28__shared_components__["n" /* Warning */],
    null,
    "Note: This Repair Station is not approved. PO will require management approval before you are able to send PO."
  );
}

function PercentInsuredFields(_ref3) {
  var percent = _ref3.percent;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
    { md: 12 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
          name: percent.input.name,
          label: "Insurance Percent",
          component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["h" /* NumberInput */],
          parse: function parse(value) {
            return value && parseInt(value, 10);
          },
          addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-percent" }),
          required: true
        })
      )
    )
  );
}

PercentInsuredFields.propTypes = {
  percent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

function InsuranceFields(_ref4) {
  var amountInsured = _ref4.amount_insured,
      percentInsured = _ref4.percent_insured,
      insuranceType = _ref4.insurance_type,
      quantity = _ref4.quantity,
      disabled = _ref4.disabled;

  if (insuranceType.input.value === "Amount") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AmountInsuredFields, { amount: amountInsured, disabled: disabled });
  } else if (insuranceType.input.value === "Percent") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PercentInsuredFields, {
      insuranceType: insuranceType,
      percent: percentInsured,
      quantity: quantity,
      disabled: disabled
    });
  }

  return null;
}

InsuranceFields.propTypes = {
  amount_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  percent_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  insurance_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

function LineHazmatFields(_ref5) {
  var hazmat = _ref5.hazmat,
      bio_hazmat = _ref5.bio_hazmat,
      disabled = _ref5.disabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group btn-group-justified", "data-toggle": "buttons" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["b" /* Check */], {
      input: hazmat.input,
      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__parts_constants__["h" /* HAZMAT */]),
      icon: "fa-warning",
      disabled: disabled
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["b" /* Check */], {
      input: bio_hazmat.input,
      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__parts_constants__["i" /* BIO_HAZMAT */]),
      icon: "fa-flask",
      disabled: disabled
    })
  );
}

LineHazmatFields.propTypes = {
  hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  bio_hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function AsIsField(_ref6) {
  var asIs = _ref6.as_is,
      evaluationPeriod = _ref6.evaluation_period,
      disabled = _ref6.disabled;

  var handleChange = function handleChange(val) {
    asIs.input.onChange(val);
    if (val === true) {
      evaluationPeriod.input.onChange(0);
    } else {
      evaluationPeriod.input.onChange(30);
    }
  };

  var input = _extends({}, asIs.input, { onChange: handleChange });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group btn-group-justified", "data-toggle": "buttons" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["b" /* Check */], {
      input: input,
      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["c" /* AS_IS */]),
      icon: "fa-check-circle",
      disabled: disabled
    })
  );
}

AsIsField.propTypes = {
  as_is: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  evaluation_period: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref7;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref7 = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref7, [this].concat(args))), _this), _this.state = {
      alternateOptions: []
    }, _this.fetchAlternates = function (partId) {
      if (!partId) return;
      _this.props.searchAlternates(partId).then(function (results) {
        return _this.setState({
          alternateOptions: results.map(function (item) {
            return {
              text: item.name,
              value: item.id
            };
          })
        });
      });
    }, _this.handlePartSelected = function (part) {
      _this.props.setSelectedPart(part);
      _this.props.resetAlternatePartField();
      if (part) {
        _this.props.setHazardFields(part);
        _this.props.setHeavyPackage(part);
        _this.fetchAlternates(part.id);
      }
    }, _this.searchCompanies = function (filter) {
      return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].companies.search({
        repair_station: true,
        filter: filter,
        status: [__WEBPACK_IMPORTED_MODULE_23__companies_constants__["c" /* ACTIVE */], __WEBPACK_IMPORTED_MODULE_23__companies_constants__["d" /* CREDIT_HOLD */]].join(","),
        page: 1,
        limit: 20
      }).then(function (resp) {
        return resp.data.results;
      });
    }, _this.handleTaggedBy = function (company) {
      var _this$props = _this.props,
          setTaggedById = _this$props.setTaggedById,
          setTaggedByHold = _this$props.setTaggedByHold;

      if (company && company.id) {
        setTaggedById(company.id);
        setTaggedByHold(company.repair_station_status !== __WEBPACK_IMPORTED_MODULE_23__companies_constants__["j" /* APPROVED */]);
      } else {
        setTaggedByHold(false);
      }
    }, _this.handlePreferredRepairStation = function (company) {
      var setPreferredRepairStationHold = _this.props.setPreferredRepairStationHold;


      if (company && company.id) {
        setPreferredRepairStationHold(company.repair_station_status !== __WEBPACK_IMPORTED_MODULE_23__companies_constants__["j" /* APPROVED */]);
      }
    }, _this.resetPreferredRepairStation = function () {
      var resetPreferredRepairStation = _this.props.resetPreferredRepairStation;


      resetPreferredRepairStation();

      _this.setState({ selectedPreferredRepairStation: null });
    }, _this.toggleBuyer = function (buyer) {
      return _this.setState(buyer);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.lineItem) {
        var id = this.props.lineItem.part_id;
        var part = this.props.lineItem.part;
        var buyer = this.props.lineItem.buyer;
        var coBuyer = this.props.lineItem.co_buyer;
        var thirdBuyer = this.props.lineItem.third_buyer;

        if (part) {
          this.props.setHazardFields(part);
          this.props.setHeavyPackage(part);
          this.fetchAlternates(part.id);
        }

        this.props.setPartId(id);
        this.props.setSelectedPart(part);
        this.setState({
          selectedBuyer: buyer,
          selectedCoBuyer: coBuyer,
          selectedThirdBuyer: thirdBuyer
        });
      }

      this.setState({
        selectedReserveForSeller: this.props.currentUser
      });

      if (this.props.selectedLineItem) {
        var _props$selectedLineIt = this.props.selectedLineItem,
            _buyer = _props$selectedLineIt.buyer,
            _part = _props$selectedLineIt.part,
            modTo = _props$selectedLineIt.mod_to,
            co_buyer = _props$selectedLineIt.co_buyer,
            third_buyer = _props$selectedLineIt.third_buyer,
            preferredRepairStation = _props$selectedLineIt.preferred_repair_station,
            reserveForSeller = _props$selectedLineIt.reserve_for_seller;


        this.setState({
          selectedModTo: modTo,
          selectedPart: _part,
          selectedBuyer: _buyer,
          selectedCoBuyer: co_buyer,
          selectedThirdBuyer: third_buyer,
          selectedPreferredRepairStation: preferredRepairStation,
          selectedReserveForSeller: reserveForSeller || this.props.currentUser
        });

        this.props.setSelectedPart(_part);
        this.fetchAlternates(_part.id);
      }
    }
  }, {
    key: "inventoryLocked",
    value: function inventoryLocked(field) {
      var _QUANTITY$SUGGESTED_R;

      var selectedLineItem = this.props.selectedLineItem;

      if (!selectedLineItem) return false;

      var received = selectedLineItem.received || selectedLineItem.quantity_received > 0;

      var defaultPermission = received || selectedLineItem.cancelled;
      if (!field || selectedLineItem.cancelled) {
        return defaultPermission;
      }

      return (_QUANTITY$SUGGESTED_R = {}, _defineProperty(_QUANTITY$SUGGESTED_R, __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */], selectedLineItem.cancelled), _defineProperty(_QUANTITY$SUGGESTED_R, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["v" /* SUGGESTED_RETAIL */], selectedLineItem.received), _defineProperty(_QUANTITY$SUGGESTED_R, __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */], selectedLineItem.consignment_type !== __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__["t" /* CONSIGNMENT */] && defaultPermission), _QUANTITY$SUGGESTED_R)[field];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          getFieldValue = _props.getFieldValue,
          buyerCreditPct = _props.buyerCreditPct,
          currentUser = _props.currentUser,
          capType = _props.capType,
          condition = _props.condition,
          containerFee = _props.containerFee,
          cost = _props.cost,
          quantity = _props.quantity,
          searchBuyers = _props.searchBuyers,
          searchParts = _props.searchParts,
          searchRepairStations = _props.searchRepairStations,
          selectedLineItem = _props.selectedLineItem,
          setFieldValue = _props.setFieldValue,
          hazmatFee = _props.hazmatFee,
          markedHazardous = _props.markedHazardous,
          modalMode = _props.modalMode,
          renderFooter = _props.renderFooter,
          selectedPart = _props.selectedPart,
          domLifeYears = _props.domLifeYears,
          llp = _props.llp,
          modTo = _props.modTo,
          dom = _props.dom;


      var buyerCreditPctOptions = [{ text: "75%", value: "75.0" }, { text: "50%", value: "50.0" }, { text: "25%", value: "25.0" }];
      var cancelled = selectedLineItem && selectedLineItem.cancelled;
      var _state = this.state,
          selectedModTo = _state.selectedModTo,
          selectedBuyer = _state.selectedBuyer,
          selectedCoBuyer = _state.selectedCoBuyer,
          selectedThirdBuyer = _state.selectedThirdBuyer,
          selectedPreferredRepairStation = _state.selectedPreferredRepairStation,
          alternateOptions = _state.alternateOptions;


      var locked = this.inventoryLocked();
      var leadTimeLocked = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_19__users_constants__["p" /* QUALITY_CONTROL */]) ? false : locked;
      var formProps = _extends({}, this.props, {
        editable: !(locked && this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]) && this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["v" /* SUGGESTED_RETAIL */])) || cancelled
      });

      var taggedByHold = getFieldValue("tagged_by_hold");
      var preferredRepairStationHold = getFieldValue("preferred_repair_station_hold");

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["e" /* Form */],
        _extends({}, formProps, { modal: modalMode }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: modalMode ? 8 : 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: "row row-col-gutters-half",
                  style: { marginTop: "26px" }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["q" /* PART_ID */],
                    label: "Part #",
                    placeholder: "Type a part's number...",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["n" /* AutoCompleteField */],
                    search: searchParts,
                    selectedItem: selectedPart,
                    formatItem: function formatItem(result) {
                      return result && result.part_number;
                    },
                    onItemSelected: function onItemSelected(i) {
                      return i && _this2.handlePartSelected(i);
                    },
                    disabled: locked,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["o" /* ALTERNATE_ID */],
                    label: "Buy As Alternate",
                    placeholder: "Type a part's number...",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["c" /* Select */],
                    options: alternateOptions,
                    addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-exchange" }),
                    disabled: alternateOptions.length === 0
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__shared_components__["m" /* DashedSeparator */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["n" /* CONDITION */],
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["c" /* Select */],
                    options: SRP_CONDITION_OPTIONS,
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["n" /* CONDITION */]),
                    disabled: locked,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */],
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    label: "QTY",
                    type: "number",
                    disabled: this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]),
                    required: true,
                    onBlur: function onBlur(_ev, qty) {
                      if (Number(qty) !== 1) {
                        setFieldValue(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["b" /* EXPECTED_SERIAL_NUMBER */])(null);
                      }
                    },
                    inputProps: {
                      min: 0
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["_28" /* MARKUP */]),
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["_28" /* MARKUP */],
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["h" /* NumberInput */],
                    addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-percent" }),
                    type: "number",
                    inputProps: {
                      min: 0,
                      max: 100
                    },
                    disabled: this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_6__constants__["_28" /* MARKUP */]),
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["y" /* EXPIRATION */],
                    label: "Expiration Date",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    type: "date",
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__shared_components__["m" /* DashedSeparator */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 5 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "label",
                      { htmlFor: "warnings", className: "control-label" },
                      "Line Hazmat"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Fields"], {
                      names: [__WEBPACK_IMPORTED_MODULE_12__parts_constants__["h" /* HAZMAT */], __WEBPACK_IMPORTED_MODULE_12__parts_constants__["i" /* BIO_HAZMAT */]],
                      component: LineHazmatFields,
                      disabled: locked
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "label",
                      { htmlFor: __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["c" /* AS_IS */], className: "control-label" },
                      "As Is"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Fields"], {
                      names: [__WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["c" /* AS_IS */], __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["u" /* EVALUATION_PERIOD */]],
                      component: AsIsField,
                      disabled: locked
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 5 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["a" /* CheckGroup */],
                    { title: "Heavy Package / DIM Weight", justified: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["v" /* DIM_WEIGHT */],
                      component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["b" /* Check */],
                      label: "Hvy Pkg / DIM Weight",
                      icon: "fa-check-circle",
                      disabled: locked
                    })
                  )
                )
              ),
              selectedModTo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_28__shared_components__["n" /* Warning */],
                null,
                "SRP Info will be applied to PN ",
                selectedModTo.part_number
              ),
              taggedByHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnauthorizedRepairStationSelectedWarning, null),
              selectedPart.dom_sensitive && __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(dom) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DOMIsRequiredWarning, null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["r" /* MonthYearField */], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["x" /* TAG_DATE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["x" /* TAG_DATE */]),
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    required: __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__["u" /* TAG_DATE_CONDITIONS */].includes(condition),
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["p" /* TAGGED_BY */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_21__inventories_constants__["p" /* TAGGED_BY */]),
                    placeholder: "Search by a company's name",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["s" /* AutoCompleteUserInputField */],
                    required: __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__["u" /* TAG_DATE_CONDITIONS */].includes(condition),
                    search: this.searchCompanies,
                    selectedItem: selectedLineItem && selectedLineItem.tagged_by,
                    handleTaggedBy: function handleTaggedBy(result) {
                      return _this2.handleTaggedBy(result);
                    },
                    formatItem: function formatItem(result) {
                      return ((typeof result === "undefined" ? "undefined" : _typeof(result)) === "object" ? result.name : result) || "";
                    },
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__Locations_components_ToolsUsedDropDown__["a" /* default */], {
                    disabled: locked,
                    selectedLineItem: selectedLineItem
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["r" /* MonthYearField */], {
                    name: "dom",
                    label: "DOM",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    required: domLifeYears && llp || selectedPart.dom_sensitive,
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["E" /* TRACE_TYPE */],
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["c" /* Select */],
                    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes),
                    label: "Expected Trace Type",
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["F" /* TRACED_TO */],
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    label: "Expected Trace To",
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["G" /* LEAD_TIME */],
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    label: "Lead Time (Days)",
                    disabled: leadTimeLocked,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["b" /* EXPECTED_SERIAL_NUMBER */],
                    label: "Expected Serial #",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    disabled: selectedLineItem && selectedLineItem.received || Number(quantity) !== 1
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["a" /* CheckGroup */],
                    { justified: true, title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["h" /* MOD_TO */]) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["h" /* MOD_TO */],
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["h" /* MOD_TO */]),
                      icon: "fa-check-circle",
                      component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["b" /* Check */],
                      disabled: locked
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
                  { "in": modTo || false, unmountOnExit: true },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                    { md: 4 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["i" /* MOD_TO_ID */],
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["h" /* MOD_TO */]),
                      placeholder: "Type a part's number...",
                      selectedItem: selectedModTo,
                      component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["n" /* AutoCompleteField */],
                      onItemSelected: function onItemSelected(item) {
                        return item && _this2.setState({ selectedModTo: item });
                      },
                      search: searchParts,
                      formatItem: function formatItem(result) {
                        return result && result.part_number;
                      },
                      disabled: locked
                    })
                  )
                )
              ),
              selectedPart && selectedPart.llp && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__parts_constants__["E" /* TOTAL_HOURS */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__parts_constants__["E" /* TOTAL_HOURS */]),
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["h" /* NumberInput */],
                    roundDigits: 0
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__parts_constants__["F" /* TOTAL_CYCLES */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__parts_constants__["F" /* TOTAL_CYCLES */]),
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["h" /* NumberInput */],
                    roundDigits: 0
                  })
                )
              ),
              this.props.showBuyers && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__shared_components__["m" /* DashedSeparator */], null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  null,
                  "Buyers"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                    { md: 5 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_shared__["c" /* BuyerField */], {
                      disabled: locked,
                      searchBuyers: searchBuyers,
                      selectedBuyer: selectedBuyer,
                      onItemSelected: function onItemSelected(buyer) {
                        return _this2.setState({ selectedBuyer: buyer });
                      }
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                    { md: 3 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_6__constants__["G" /* BUYER_CREDIT_PCT */],
                      className: "text-right",
                      component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["c" /* Select */],
                      options: buyerCreditPctOptions,
                      prompt: false,
                      label: "Buyer Credit",
                      disabled: locked,
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_shared__["b" /* CoBuyersFields */], {
                    toggleBuyer: this.toggleBuyer,
                    buyerCreditPct: buyerCreditPct,
                    selectedCoBuyer: selectedCoBuyer,
                    selectedThirdBuyer: selectedThirdBuyer,
                    numberOfBuyers: [getFieldValue(__WEBPACK_IMPORTED_MODULE_19__users_constants__["z" /* CO_BUYER_ID */]), getFieldValue(__WEBPACK_IMPORTED_MODULE_19__users_constants__["y" /* THIRD_BUYER_ID */])].filter(function (s) {
                      return s;
                    }).length + 1,
                    searchBuyers: searchBuyers,
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Orders_shared_InvoiceSection__["a" /* default */], {
                hidden: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_19__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_19__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_19__users_constants__["l" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_19__users_constants__["k" /* SALES */]]),
                orderType: __WEBPACK_IMPORTED_MODULE_29__constants__["a" /* MANAGED_REPAIR_ORDER */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__shared_components__["m" /* DashedSeparator */], null),
              preferredRepairStationHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnauthorizedPreferredRepairStationSelectedWarning, null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Shipping & Repairs"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                selectedLineItem && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["W" /* AWB_NUMBER */],
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    label: "AWB #",
                    disabled: selectedLineItem.received
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["y" /* CONTAINER_FEE */],
                    label: "Container/Crate Fee",
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["z" /* HAZMAT_FEE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]),
                    disabled: locked,
                    required: markedHazardous
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["w" /* PREFERRED_REPAIR_STATION_ID */],
                    label: "Suggested Repair Station",
                    placeholder: "Type a vendor's name or code...",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["n" /* AutoCompleteField */],
                    search: searchRepairStations,
                    selectedItem: selectedPreferredRepairStation,
                    formatItem: function formatItem(result) {
                      return result && result.name;
                    },
                    disabled: locked,
                    required: true,
                    watch: selectedPreferredRepairStation,
                    onItemSelected: this.handlePreferredRepairStation
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["u" /* EVALUATION_PERIOD */],
                    type: "number",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["d" /* FormInput */],
                    disabled: locked,
                    label: "Eval. Period"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["A" /* CAP_TYPE */],
                    className: "text-right",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["c" /* Select */],
                    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["B" /* CAP_TYPES */]),
                    label: "Repair/Overhaul Cap"
                  })
                ),
                capType && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["C" /* CAP_AMOUNT */],
                    label: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["B" /* CAP_TYPES */][capType].label + " Cap Amount",
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 12 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Fields"], {
                    names: [__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["D" /* AMOUNT_INSURED */], __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["E" /* PERCENT_INSURED */], __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["F" /* INSURANCE_TYPE */]],
                    component: InsuranceTypeField,
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Fields"], {
                  names: [__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["D" /* AMOUNT_INSURED */], __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["E" /* PERCENT_INSURED */], __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["F" /* INSURANCE_TYPE */], __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]],
                  component: InsuranceFields,
                  disabled: locked
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__shared_components__["m" /* DashedSeparator */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Notes"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["G" /* INTERNAL_NOTE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["G" /* INTERNAL_NOTE */]),
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["l" /* TextArea */],
                    rows: 5,
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */]),
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["l" /* TextArea */],
                    rows: 5,
                    disabled: locked
                  })
                )
              ),
              cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["H" /* CANCELLATION_REASON */],
                    className: "text-right",
                    component: __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["c" /* Select */],
                    options: __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["I" /* CANCELLATION_REASONS */],
                    prompt: false,
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["H" /* CANCELLATION_REASON */])
                  })
                )
              )
            ),
            modalMode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__shared_PartSummary__["a" /* default */], {
                part: selectedPart,
                cost: cost,
                quantity: quantity,
                lineItem: this.props.selectedLineItem,
                hazmatFee: hazmatFee,
                containerFee: containerFee
              })
            )
          )
        ),
        renderFooter && renderFooter(formProps)
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setTaggedById: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setTaggedByHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  showBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cap_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    co_buyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    third_buyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    part_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  renderFooter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  resetAlternatePartField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchAlternates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchParts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchRepairStations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setHeavyPackage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setHazardFields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setPartId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  domLifeYears: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  llp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectedPart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  setSelectedPart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setPreferredRepairStationHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetPreferredRepairStation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
Form.defaultProps = {
  modalMode: true,
  showBuyers: true
};
var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    getFieldValue: function getFieldValue(field) {
      return selector(state, field);
    },
    getInitialFieldValue: function getInitialFieldValue(field) {
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["getFormInitialValues"])(formName)(state), field);
    },
    buyerCreditPct: selector(state, __WEBPACK_IMPORTED_MODULE_6__constants__["G" /* BUYER_CREDIT_PCT */]),
    capType: selector(state, __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["A" /* CAP_TYPE */]),
    cost: selector(state, __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */]),
    quantity: selector(state, __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]),
    condition: selector(state, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["n" /* CONDITION */]),
    minExchangeSrp: state.session.getIn([__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_6__constants__["X" /* MINIMUM_EXCHANGE_SRP */]]),
    exchangeSRP: selector(state, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["u" /* EXCHANGE_SRP */]),
    asIs: selector(state, __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["c" /* AS_IS */]),
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_19__users_constants__["a" /* USER */]).toJS(),
    hazmatFee: selector(state, __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]),
    containerFee: selector(state, __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["y" /* CONTAINER_FEE */]),
    markedHazardous: selector(state, __WEBPACK_IMPORTED_MODULE_12__parts_constants__["h" /* HAZMAT */]),
    modTo: selector(state, __WEBPACK_IMPORTED_MODULE_24__RepairOrders_constants__["h" /* MOD_TO */]),
    dom: selector(state, __WEBPACK_IMPORTED_MODULE_12__parts_constants__["G" /* DOM */]),
    getField: function getField(field) {
      return selector(state, field);
    }
  };
}, function (dispatch) {
  return {
    resetAlternatePartField: function resetAlternatePartField() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["o" /* ALTERNATE_ID */], null));
    },
    setPartId: function setPartId(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["q" /* PART_ID */], id));
    },
    setHazardFields: function setHazardFields(part) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_12__parts_constants__["i" /* BIO_HAZMAT */], part.bio_hazmat));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_12__parts_constants__["h" /* HAZMAT */], part.hazmat));
    },
    setHeavyPackage: function setHeavyPackage(part) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_constants__["v" /* DIM_WEIGHT */], part.dim_weight));
    },
    searchAlternates: function searchAlternates(partId) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_actions__["e" /* searchAlternates */](partId));
    },
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_actions__["c" /* searchBuyers */](filter));
    },
    searchParts: function searchParts(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_15__parts_actions__["a" /* searchPoParts */](filter));
    },
    searchRepairStations: function searchRepairStations(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_actions__["f" /* searchRepairStations */](filter));
    },
    resetForm: function resetForm(id) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["replace"])("/managed-repair-orders/" + id));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, field, val));
      };
    },
    setTaggedById: function setTaggedById(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_21__inventories_constants__["O" /* TAGGED_BY_ID */], id));
    },
    setTaggedByHold: function setTaggedByHold(hold) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, "tagged_by_hold", hold));
    },
    setPreferredRepairStationHold: function setPreferredRepairStationHold(hold) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, "preferred_repair_station_hold", hold));
    },
    resetPreferredRepairStation: function resetPreferredRepairStation() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, "preferred_repair_station_id", ""));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_30__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_shared_AsIsFlag__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_LineItemQtyCell_LineItemQtyCell__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Controls_Controls__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_StatsTooltip_format__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Edit_Edit__ = __webpack_require__(1413);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var paginatorList = "managedRepairOrderLineItems";

var ReceivedIcon = function ReceivedIcon(_ref) {
  var quantityReceived = _ref.quantity_received,
      quantity = _ref.quantity;

  if (quantityReceived === quantity) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["U" /* IconReceived */], null);
  }
  return null;
};

ReceivedIcon.propTypes = {
  quantity_received: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  quantity: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
};

var LineItemsTable = function (_Component) {
  _inherits(LineItemsTable, _Component);

  function LineItemsTable() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, LineItemsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = LineItemsTable.__proto__ || Object.getPrototypeOf(LineItemsTable)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      addPartModalOpen: false,
      editPartModalOpen: false
    }, _this.openEditPartModal = function (lineItem) {
      return _this.setState({
        editPartModalOpen: true,
        selectedLineItem: lineItem
      });
    }, _this.closeEditPartModal = function () {
      return _this.setState({ editPartModalOpen: false });
    }, _this.renderRow = function (r, idx) {
      var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()("clickable", {
        "text-muted": r.cancelled || r.return_to_customer_without_repairing && r.shipped
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        {
          key: r.id,
          className: classes,
          onClick: function onClick() {
            return _this.openEditPartModal(r);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { whiteSpace: "nowrap" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { textAlign: "right" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_LineItemQtyCell_LineItemQtyCell__["a" /* default */], { lineItem: r, showFull: true }),
              idx + 1
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { whiteSpace: "nowrap" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["h" /* PartNumber */], { part: r.part, statsTooltip: true })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(r, "inventory.id") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
            { to: "/inventories/" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(r, "inventory.uuid") },
            r.inventory.serial_number
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.alternate && (r.alternate.alternate_part_id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["h" /* PartNumber */], {
            part: {
              id: r.alternate.alternate_part_id,
              part_number: r.alternate.name
            }
          }) : r.alternate.name)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_date__["d" /* alphaMonthYear */])(r.tag_date)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.tagged_by && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
            { to: "/companies/" + r.tagged_by.uuid },
            r.tagged_by.name
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          r.lead_time
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.condition && __WEBPACK_IMPORTED_MODULE_14__Receiving_constants__["x" /* CONDITION_TYPES */][r.condition].label,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_shared_AsIsFlag__["a" /* AsIsFlag */], { lineItem: r, className: "m-l-5" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          r.quantity_received,
          " ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReceivedIcon, r),
          " "
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(r.cost)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__shared_components_StatsTooltip_format__["f" /* percentFormatter */])(r.markup)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(r.price)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center td-shrink-icon" },
          (r.internal_note || r.external_note) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
            note: [r.internal_note, r.external_note].filter(function (n) {
              return n !== null && n !== "";
            }).join(" | "),
            className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ "link-muted": r.cancelled })
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Controls_Controls__["a" /* default */], { lineItem: r })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LineItemsTable, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          results = _props.results,
          isLoading = _props.isLoading;
      var _state = this.state,
          editPartModalOpen = _state.editPartModalOpen,
          selectedLineItem = _state.selectedLineItem;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Edit_Edit__["a" /* default */], {
          open: editPartModalOpen,
          close: this.closeEditPartModal,
          selectedLineItem: selectedLineItem
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Mini,
          { loading: isLoading, numbered: true, noMargin: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Part #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Serial #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Alt"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tag Date"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tagged By"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Lead Time (Days)"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Condition"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Qty Rec."
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Cost Ea"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Markup"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Price"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "\xA0"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Body,
            null,
            results.map(this.renderRow)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "nav",
          {
            className: "text-center margin-top-none",
            "aria-label": "Search results pages"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__["Paginator"], { listId: paginatorList })
        )
      );
    }
  }]);

  return LineItemsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LineItemsTable.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object)).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (LineItemsTable);

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony export (immutable) */ __webpack_exports__["a"] = ReleaseAccountingHold;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









function ReleaseAccountingHold(_ref) {
  var managedRepairOrder = _ref.managedRepairOrder,
      onConfirm = _ref.onConfirm;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      confirmationIsVisible = _useState2[0],
      setConfirmationVisibility = _useState2[1];

  if (!managedRepairOrder.get("accounting_hold")) {
    return false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setConfirmationVisibility(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "pause", fixed: true }),
    "\xA0Remove Accounting Hold",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setConfirmationVisibility(false);
        },
        open: confirmationIsVisible,
        btnClass: "btn-danger",
        btnText: "Yes, Remove Accounting Hold",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to Remove the Accounting Hold?"
    )
  );
}

ReleaseAccountingHold.propTypes = {
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired,
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Lots_constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(1418);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditShipping;








function EditShipping(_ref) {
  var open = _ref.open,
      close = _ref.close,
      managedRepairOrder = _ref.managedRepairOrder;

  var initialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_pojos__["a" /* default */])(managedRepairOrder).pick(__WEBPACK_IMPORTED_MODULE_3__constants__["_40" /* RETURN_TO_FOB */], __WEBPACK_IMPORTED_MODULE_3__constants__["_41" /* RETURN_TO_SHIPPING_METHOD */], __WEBPACK_IMPORTED_MODULE_3__constants__["C" /* RETURN_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_3__constants__["_42" /* RETURN_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_3__constants__["_43" /* RETURN_TO_COMPANY_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_3__constants__["_44" /* RETURN_TO_SHIPPING_ADDRESS */], __WEBPACK_IMPORTED_MODULE_3__constants__["_45" /* RETURN_TO_SHIPPING_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_5__Lots_constants__["d" /* SHIP_DATE */]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Managed Repair Order Shipping Info"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Form__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      managedRepairOrder: managedRepairOrder,
      enableReinitialize: true
    })
  );
}

EditShipping.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Orders_shared_ShippingFields_ShippingFields__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__validate__ = __webpack_require__(1420);
/* unused harmony export Form */














var FORM_NAME = "editReturnToManagedRepairShipping";

function Form(props) {
  var managedRepairOrder = props.managedRepairOrder;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__Orders_shared_ShippingFields_ShippingFields__["a" /* default */],
        {
          formName: FORM_NAME,
          hasLocations: false,
          shipToCompany: managedRepairOrder.return_to_company,
          shippingFields: [__WEBPACK_IMPORTED_MODULE_6__constants__["C" /* RETURN_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_6__constants__["_42" /* RETURN_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_6__constants__["_43" /* RETURN_TO_COMPANY_ADDRESS_ID */]],
          shippingMethod: __WEBPACK_IMPORTED_MODULE_6__constants__["_41" /* RETURN_TO_SHIPPING_METHOD */],
          shippingTypes: [__WEBPACK_IMPORTED_MODULE_6__constants__["i" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_7__PurchaseOrders_constants__["L" /* DROPSHIP */]],
          shippingAddressField: __WEBPACK_IMPORTED_MODULE_6__constants__["_44" /* RETURN_TO_SHIPPING_ADDRESS */]
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
            { md: 7 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_6__constants__["_40" /* RETURN_TO_FOB */],
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["_40" /* RETURN_TO_FOB */]),
              required: true
            })
          )
        )
      )
    )
  );
}

Form.propTypes = {
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    ship_to_company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
  })
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* update */](data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_12__validate__["a" /* validateShipping */]
})(Form)));

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Orders_shared_ShippingAddress__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditShipping__ = __webpack_require__(1417);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ReturnToShippingDetails = function (_React$Component) {
  _inherits(ReturnToShippingDetails, _React$Component);

  function ReturnToShippingDetails() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReturnToShippingDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReturnToShippingDetails.__proto__ || Object.getPrototypeOf(ReturnToShippingDetails)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editShippingModalOpen: false
    }, _this.openShippingModal = function () {
      _this.setState({ editShippingModalOpen: true });
    }, _this.closeShippingModal = function () {
      return _this.setState({ editShippingModalOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReturnToShippingDetails, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          managedRepairOrder = _props.managedRepairOrder,
          _props$unlocked = _props.unlocked,
          unlocked = _props$unlocked === undefined ? true : _props$unlocked;
      var editShippingModalOpen = this.state.editShippingModalOpen;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Return To Shipping",
          unlocked && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["y" /* EditButton */], { handleClick: this.openShippingModal }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__EditShipping__["a" /* default */], {
            managedRepairOrder: managedRepairOrder.toJS(),
            open: editShippingModalOpen,
            close: this.closeShippingModal
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Orders_shared_ShippingAddress__["a" /* default */], { shippingType: __WEBPACK_IMPORTED_MODULE_3__constants__["_39" /* RETURN_TO */], record: managedRepairOrder })
      );
    }
  }]);

  return ReturnToShippingDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ReturnToShippingDetails);


ReturnToShippingDetails.propTypes = {
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  unlocked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SalesOrders_components_shared_FormSections_ShippingSection_validate__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = validateShipping;





function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate("buying_store", "company_id", "contact_id", "payment_terms").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

function validateShipping(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__SalesOrders_components_shared_FormSections_ShippingSection_validate__["a" /* validateShippingFields */])(__WEBPACK_IMPORTED_MODULE_3__constants__["_39" /* RETURN_TO */], values, v);
  });
}

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form__ = __webpack_require__(1422);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditShipping;







function EditShipping(_ref) {
  var open = _ref.open,
      close = _ref.close,
      managedRepairOrder = _ref.managedRepairOrder;

  var initialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_pojos__["a" /* default */])(managedRepairOrder).pick(__WEBPACK_IMPORTED_MODULE_4__constants__["P" /* SHIP_TO_LOCATION_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_4__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["H" /* FOB */], __WEBPACK_IMPORTED_MODULE_4__constants__["_17" /* SHIP_TO_SHIPPING_ADDRESS */], __WEBPACK_IMPORTED_MODULE_4__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Managed Repair Order Shipping Info"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Form__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      managedRepairOrder: managedRepairOrder,
      enableReinitialize: true
    })
  );
}

EditShipping.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Orders_shared_ShippingFields_ShippingFields__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__validate__ = __webpack_require__(1424);
/* unused harmony export Form */









var FORM_NAME = "editManagedRepairShipping";

function Form(props) {
  var managedRepairOrder = props.managedRepairOrder;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Orders_shared_ShippingFields_ShippingFields__["a" /* default */], {
        shipToCompany: managedRepairOrder.ship_to_company,
        formName: FORM_NAME,
        shippingFields: [__WEBPACK_IMPORTED_MODULE_6__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_6__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_6__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_6__constants__["H" /* FOB */]],
        shippingMethod: __WEBPACK_IMPORTED_MODULE_6__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */],
        shippingAddressField: __WEBPACK_IMPORTED_MODULE_6__constants__["_17" /* SHIP_TO_SHIPPING_ADDRESS */]
      })
    )
  );
}

Form.propTypes = {
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    ship_to_company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
  })
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* update */](data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_7__validate__["a" /* validateShipping */]
})(Form)));

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Orders_shared_ShippingAddress__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditShipping__ = __webpack_require__(1421);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ShippingDetails = function (_React$Component) {
  _inherits(ShippingDetails, _React$Component);

  function ShippingDetails() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ShippingDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShippingDetails.__proto__ || Object.getPrototypeOf(ShippingDetails)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editShippingModalOpen: false
    }, _this.openShippingModal = function () {
      _this.setState({ editShippingModalOpen: true });
    }, _this.closeShippingModal = function () {
      return _this.setState({ editShippingModalOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ShippingDetails, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          managedRepairOrder = _props.managedRepairOrder,
          _props$unlocked = _props.unlocked,
          unlocked = _props$unlocked === undefined ? true : _props$unlocked;
      var editShippingModalOpen = this.state.editShippingModalOpen;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Shipping",
          unlocked && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["y" /* EditButton */], { handleClick: this.openShippingModal }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__EditShipping__["a" /* default */], {
            managedRepairOrder: managedRepairOrder.toJS(),
            open: editShippingModalOpen,
            close: this.closeShippingModal
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Orders_shared_ShippingAddress__["a" /* default */], { shippingType: __WEBPACK_IMPORTED_MODULE_3__constants__["B" /* SHIP_TO */], record: managedRepairOrder })
      );
    }
  }]);

  return ShippingDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ShippingDetails);


ShippingDetails.propTypes = {
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  unlocked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SalesOrders_components_shared_FormSections_ShippingSection_validate__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = validateShipping;





function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate("buying_store", "company_id", "contact_id", "payment_terms").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

function validateShipping(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__SalesOrders_components_shared_FormSections_ShippingSection_validate__["a" /* validateShippingFields */])(__WEBPACK_IMPORTED_MODULE_3__constants__["B" /* SHIP_TO */], values, v);
  });
}

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inventories_constants__ = __webpack_require__(12);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();














function Sync(_ref) {
  var onConfirm = _ref.onConfirm,
      managedRepairOrder = _ref.managedRepairOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      settings = _useState4[0],
      setSettings = _useState4[1];

  var storeOwnerId = managedRepairOrder.getIn([__WEBPACK_IMPORTED_MODULE_10__constants__["A" /* LINE_ITEMS */], 0, __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["_64" /* STORE_OWNER_ID */]]);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (storeOwnerId) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].locations.locationSetting.quickbooksLocationSetting(storeOwnerId).then(function (_ref2) {
        var data = _ref2.data;

        setSettings(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["get"])(data, "settings.quickbooks", {}));

        return function cleanup() {};
      });
    }
  }, [storeOwnerId]);

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["get"])(settings, "accounts_payable_account")) {
    return null;
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["get"])(settings, "inventory_account")) {
    return null;
  }

  var syncDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["get"])(settings, "sync_date");
  var createdAt = __WEBPACK_IMPORTED_MODULE_9_moment___default()(managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_10__constants__["_7" /* CREATED_AT */]));

  if (syncDate && __WEBPACK_IMPORTED_MODULE_9_moment___default()(syncDate) > __WEBPACK_IMPORTED_MODULE_9_moment___default()(createdAt.format("YYYY-MM-DD"))) {
    return null;
  }

  if (managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_10__constants__["_46" /* DISABLE_QB_SYNC */])) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: "refresh", fixed: true }),
    "\xA0Sync Accounting",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setVisible(false);
        },
        open: visible,
        btnText: "Yes, Sync w/ Quickbooks",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-refresh" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to sync the MRO?",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        "Please ensure the Vendor has a linked account for the store owner."
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onConfirm: function onConfirm() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["h" /* sync */])());
    }
  };
})(Sync));

Sync.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__inventories_constants__ = __webpack_require__(12);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

















function ToggleQuickbooksSync(_ref) {
  var onConfirm = _ref.onConfirm,
      managedRepairOrder = _ref.managedRepairOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      settings = _useState4[0],
      setSettings = _useState4[1];

  var storeOwnerId = managedRepairOrder.getIn([__WEBPACK_IMPORTED_MODULE_12__constants__["A" /* LINE_ITEMS */], 0, __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["_64" /* STORE_OWNER_ID */]]);

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__users_helpers__["c" /* hasAnyOfRoles */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks__["a" /* useCurrentUser */])(), [__WEBPACK_IMPORTED_MODULE_9__users_constants__["m" /* ACCOUNTING */]])) {
    return null;
  }

  var createdAt = managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_7" /* CREATED_AT */]);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].locations.locationSetting.show(storeOwnerId).then(function (_ref2) {
      var data = _ref2.data;

      setSettings(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(data, "settings.quickbooks", {}));

      return function cleanup() {};
    });
  }, [createdAt]);

  var syncDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_12__constants__["_47" /* SYNC_DATE */]);

  if (!syncDate) return null;

  if (syncDate && __WEBPACK_IMPORTED_MODULE_13_moment___default()(syncDate) <= __WEBPACK_IMPORTED_MODULE_13_moment___default()(createdAt).format("YYYY-MM-DD")) {
    return null;
  }

  var quickbooksDisabled = managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_46" /* DISABLE_QB_SYNC */]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: quickbooksDisabled ? "play" : "pause", fixed: true }),
    "\xA0",
    quickbooksDisabled ? "Enable QB Sync" : "Disable QB Sync",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setVisible(false);
        },
        open: visible,
        btnText: quickbooksDisabled ? "Enable QB Sync" : "Disable QB Sync",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-pause" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to",
      " ",
      quickbooksDisabled ? "enable QB Sync" : "disable QB Sync",
      "?"
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onConfirm: function onConfirm() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["g" /* update */])({
        disable_qb_sync: !ownProps.managedRepairOrder.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_46" /* DISABLE_QB_SYNC */])
      }));
    }
  };
})(ToggleQuickbooksSync));

ToggleQuickbooksSync.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagination__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Table__ = __webpack_require__(1428);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















var defaultFilters = {
  cancelled: undefined,
  received: undefined,
  shipped: undefined,
  store_owner_id: undefined
};

var filters = [{
  label: "Not Cancelled",
  filters: {
    cancelled: false
  }
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["_26" /* RECEIVED */]),
  filters: {
    received: true
  }
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["_63" /* NOT_RECEIVED */]),
  filters: {
    received: false
  }
}];

var filterTags = [{
  label: "Show Not Cancelled MROs",
  key: "cancelled",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Received",
  key: "received",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Received",
  key: "received",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Invoiced",
  key: "invoiced",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Invoiced",
  key: "invoiced",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Shipped",
  key: "shipped"
}];

function ManagedRepairOrderSearch(_ref) {
  var pushHistory = _ref.pushHistory;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__hooks_useCurrentUser__["a" /* default */])();
  var filterWithLocations = currentUser.locations.map(function (l) {
    return {
      label: "Managed By " + l.name,
      filters: { store_owner_id: l.id }
    };
  });

  var filterTagsWithLocations = currentUser.locations.map(function (l) {
    return {
      label: "Managed by " + l.name,
      key: __WEBPACK_IMPORTED_MODULE_1__inventories_constants__["_64" /* STORE_OWNER_ID */],
      matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_filters__["b" /* matchesString */])(l.id)
    };
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_4__pagination__["b" /* default */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a MRO number, vendor name, vendor number, work order #, part # or part description...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/managed-repair-orders/" + r.managed_repair_order.uuid);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
              filters: filters.concat(filterWithLocations).concat({
                label: __WEBPACK_IMPORTED_MODULE_6__constants__["_37" /* CLEAR_FILTERS_TEXT */],
                filters: defaultFilters
              }),
              right: true
            }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "Managed Repair Orders",
          filters: filterTagsWithLocations.concat(filterTags)
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

ManagedRepairOrderSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_9_react_router_redux__["push"] })(ManagedRepairOrderSearch));

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_formatters_number__ = __webpack_require__(72);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



















function renderRow(result, pushHistory) {
  var lineItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(result);
  var rowClasses = __WEBPACK_IMPORTED_MODULE_6_classnames___default()("clickable", {
    "cancelled-item": lineItem.get(__WEBPACK_IMPORTED_MODULE_13__constants__["_38" /* CANCELLED */])
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: lineItem.get(__WEBPACK_IMPORTED_MODULE_13__constants__["b" /* ID */]),
      className: rowClasses,
      onClick: function onClick() {
        return pushHistory("/managed-repair-orders/" + lineItem.getIn([__WEBPACK_IMPORTED_MODULE_14__constants__["a" /* MANAGED_REPAIR_ORDER */], __WEBPACK_IMPORTED_MODULE_13__constants__["c" /* UUID */]]));
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.getIn([__WEBPACK_IMPORTED_MODULE_14__constants__["a" /* MANAGED_REPAIR_ORDER */], __WEBPACK_IMPORTED_MODULE_13__constants__["z" /* CODE */]]),
      " ",
      lineItem.get(__WEBPACK_IMPORTED_MODULE_13__constants__["_38" /* CANCELLED */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "text-muted" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["k" /* Icon */], { name: "ban" })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["b" /* shortDate */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_13__constants__["_7" /* CREATED_AT */]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["w" /* CompanyName */], {
        flattenedCompany: lineItem.toJS(),
        context: "repair",
        truncateAt: 25
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.getIn([__WEBPACK_IMPORTED_MODULE_12__parts_constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_12__parts_constants__["u" /* DESCRIPTION */]])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["o" /* LocationFlag */], {
        location: lineItem.getIn([__WEBPACK_IMPORTED_MODULE_14__constants__["a" /* MANAGED_REPAIR_ORDER */], __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__["g" /* BUYING_STORE_ID */]])
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["h" /* PartNumber */], { part: lineItem.toJS().part })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          to: "/inventories/" + lineItem.getIn([__WEBPACK_IMPORTED_MODULE_11__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_13__constants__["c" /* UUID */]])
        },
        lineItem.getIn([__WEBPACK_IMPORTED_MODULE_11__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["o" /* SERIAL_NUMBER */]])
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__RepairOrders_constants__["p" /* getConditionAbbrev */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_11__inventories_constants__["n" /* CONDITION */]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.get("subtotal"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_number__["a" /* percent */])(lineItem.get("markup"), 100)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.get("price"))
    )
  );
}

function Table(_ref) {
  var pushHistory = _ref.pushHistory,
      isLoading = _ref.isLoading,
      pageActions = _ref.pageActions,
      results = _ref.results;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */],
    { loading: isLoading, refresh: pageActions.expire },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "RO #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Created"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Company"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Description"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Store Owner"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "CD"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Repair Fee"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Markup"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Managed Repair Fee"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_9__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(undefined, {
  pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"]
})(Table));

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_reducer__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(647);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  managedRepairOrder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
}).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["a" /* notesInitialState */]).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["b" /* attachmentsInitialState */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _extends(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* SET */], function (state, action) {
  return state.merge({ managedRepairOrder: action.managedRepairOrder });
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["c" /* createAttachmentReducer */])(__WEBPACK_IMPORTED_MODULE_2__shared_types_resourceTypes__["a" /* default */].managedRepairOrder), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["d" /* createNoteReducer */])(__WEBPACK_IMPORTED_MODULE_2__shared_types_resourceTypes__["a" /* default */].managedRepairOrder))));

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parts_actions_actions__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Locations_components_BuyingStoreRadioField__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__companies_helpers__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shared_components_CoBuyersFields_CoBuyersFields__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_components_PaymentTerms_PaymentTerms__ = __webpack_require__(177);
/* unused harmony export DetailFields */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var DetailFields = function (_React$Component) {
  _inherits(DetailFields, _React$Component);

  function DetailFields() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DetailFields);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DetailFields.__proto__ || Object.getPrototypeOf(DetailFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      contacts: []
    }, _this.fetchContacts = function (value) {
      if (!value) {
        return null;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__parts_actions_actions__["a" /* searchContacts */])(value).then(function () {
        var vals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        _this.setState({ contacts: vals });

        if (_this.props.setPrimaryContact) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__companies_helpers__["a" /* selectPrimaryContact */])(vals, _this.props.setField(__WEBPACK_IMPORTED_MODULE_11__constants__["O" /* CONTACT_ID */]));
        }
      });
    }, _this.handleCompanyChange = function (result) {
      if (_this.props.setSelectedCompany) _this.props.setSelectedCompany(result);

      if (_this.props.notifyForm) _this.props.notifyForm(result);

      if (result) {
        var address = result.primary_physical_address;
        var formattedAddress = address ? [address.city, address.state, address.country].join("-") : "";
        _this.props.setField(__WEBPACK_IMPORTED_MODULE_11__constants__["H" /* FOB */])(formattedAddress);
        if (_this.props.setPaymentTerms) _this.props.setPaymentTerms(result.vendor_credit_terms);
        _this.fetchContacts(result.id);
      } else {
        _this.setState({ contacts: [] });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DetailFields, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.managedRepairOrder && this.props.managedRepairOrder.company) {
        this.fetchContacts(this.props.managedRepairOrder.company.id);
        var _props = this.props,
            selectedCoBuyer = _props.selectedCoBuyer,
            selectedThirdBuyer = _props.selectedThirdBuyer;

        this.setState({
          selectedCoBuyer: selectedCoBuyer,
          selectedThirdBuyer: selectedThirdBuyer
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          contacts = _state.contacts,
          selectedCompany = _state.selectedCompany,
          selectedCoBuyer = _state.selectedCoBuyer,
          selectedThirdBuyer = _state.selectedThirdBuyer;
      var _props2 = this.props,
          contact = _props2.contact,
          companyType = _props2.companyType,
          currentUser = _props2.currentUser,
          getField = _props2.getField,
          managedRepairOrder = _props2.managedRepairOrder,
          searchCompanies = _props2.searchCompanies,
          selectedBuyer = _props2.selectedBuyer,
          searchBuyers = _props2.searchBuyers,
          setField = _props2.setField,
          buyerCreditPct = _props2.buyerCreditPct;

      var buyerCreditPctOptions = [{ text: "75%", value: "75.0" }, { text: "50%", value: "50.0" }, { text: "25%", value: "25.0" }];
      var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__companies_helpers__["b" /* contactSelectList */])(contacts, true);
      var company = selectedCompany || managedRepairOrder && managedRepairOrder.company;
      var toggleBuyer = function toggleBuyer(buyer) {
        return _this2.setState(buyer);
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
          null,
          currentUser.tenant.locations_count !== 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 5 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Locations_components_BuyingStoreRadioField__["a" /* default */], { label: "Managing Store" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_14__users_constants__["x" /* BUYER_ID */],
              label: "Buyer",
              placeholder: "Search by name...",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["n" /* AutoCompleteField */],
              search: searchBuyers,
              selectedItem: selectedBuyer,
              formatItem: function formatItem(result) {
                return result && result.full_name;
              },
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_11__constants__["G" /* BUYER_CREDIT_PCT */],
              className: "text-right",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
              onChange: function onChange(_ev, val) {
                if (["25.0", "50.0", null].includes(val)) {
                  setField(__WEBPACK_IMPORTED_MODULE_14__users_constants__["y" /* THIRD_BUYER_ID */])(null);
                  toggleBuyer({ selectedThirdBuyer: null });
                }
              },
              options: buyerCreditPctOptions,
              label: "Buyer Credit",
              required: true
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__shared_components_CoBuyersFields_CoBuyersFields__["a" /* default */], {
            buyerCreditPct: buyerCreditPct,
            searchBuyers: searchBuyers,
            selectedCoBuyer: selectedCoBuyer,
            selectedThirdBuyer: selectedThirdBuyer,
            toggleBuyer: toggleBuyer,
            numberOfBuyers: [getField(__WEBPACK_IMPORTED_MODULE_14__users_constants__["z" /* CO_BUYER_ID */]), getField(__WEBPACK_IMPORTED_MODULE_14__users_constants__["y" /* THIRD_BUYER_ID */])].filter(function (s) {
              return s;
            }).length + 1
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["m" /* DashedSeparator */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_11__constants__["N" /* COMPANY_ID */],
              label: companyType,
              labelChildren: company && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["g" /* CompanyStatsTooltip */], { company: company })
              ),
              placeholder: "Search by typing a company's name or code",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["n" /* AutoCompleteField */],
              search: searchCompanies,
              formatItem: function formatItem(result) {
                return result.name + " (" + __WEBPACK_IMPORTED_MODULE_6__companies_constants__["h" /* APPROVAL_STATUSES */][result.vendor_status].label + ")";
              },
              onItemSelected: function onItemSelected(i) {
                return i && _this2.handleCompanyChange(i);
              },
              selectedItem: company,
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_11__constants__["O" /* CONTACT_ID */],
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
              options: options,
              label: companyType + " Contact",
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components_PaymentTerms_PaymentTerms__["a" /* default */], null)
          )
        ),
        contact === __WEBPACK_IMPORTED_MODULE_17__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
                disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lodash__["get"])(company, __WEBPACK_IMPORTED_MODULE_6__companies_constants__["e" /* WEBSITE */]),
                name: "company.website",
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__companies_constants__["e" /* WEBSITE */]),
                required: true
              })
            )
          )
        ),
        contact === "Add" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "contact.name",
                component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
                label: "Contact Name",
                required: true
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "contact.email",
                component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
                label: "Contact Email",
                required: true
              })
            )
          )
        )
      );
    }
  }]);

  return DetailFields;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DetailFields.propTypes = {
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  contact: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  companyType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  currentUser: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  getField: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object),
  searchBuyers: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  searchCompanies: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  notifyForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  setPaymentTerms: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  selectedBuyer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object),
  selectedCoBuyer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object),
  selectedThirdBuyer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object),
  setField: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  setPrimaryContact: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  setSelectedCompany: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
DetailFields.defaultProps = {
  companyType: "Vendor",
  setPrimaryContact: true
};
var selector = function selector(form) {
  for (var _len2 = arguments.length, other = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    other[_key2 - 1] = arguments[_key2];
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(form).apply(undefined, other);
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state, ownProps) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_14__users_constants__["a" /* USER */]).toJS(),
    buyerCreditPct: selector(ownProps.formName, state, __WEBPACK_IMPORTED_MODULE_11__constants__["G" /* BUYER_CREDIT_PCT */]),
    contact: selector(ownProps.formName, state, __WEBPACK_IMPORTED_MODULE_11__constants__["O" /* CONTACT_ID */]),
    getField: function getField(field) {
      return selector(ownProps.formName, state, field);
    }
  };
}, function (dispatch, ownProps) {
  return {
    searchCompanies: function searchCompanies(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_actions__["a" /* searchCompanies */](filter));
    },
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_actions__["c" /* searchBuyers */](filter));
    },
    setField: function setField(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(ownProps.formName, field, val));
      };
    }
  };
})(DetailFields));

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_ActionDropDown_ActionDropDown__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Download__ = __webpack_require__(1432);
/* harmony export (immutable) */ __webpack_exports__["a"] = Actions;





function Actions(_ref) {
  var url = _ref.url;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group pull-right", style: { marginLeft: 20 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_ActionDropDown_ActionDropDown__["a" /* default */],
      { menuClass: "dropdown-menu-right" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Download__["a" /* default */], { url: url })
    )
  );
}

Actions.propTypes = {
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  shipment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_ExternalLink_ExternalLink__ = __webpack_require__(212);
/* unused harmony export Download */





function Download(_ref) {
  var url = _ref.url;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "li",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_ExternalLink_ExternalLink__["a" /* default */],
      { url: url },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: "file-text-o", fixed: true }),
      "\xA0Download Packing Slip"
    )
  );
}

Download.propTypes = {
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Download);

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Actions__ = __webpack_require__(1431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Actions__["a"]; });



/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_DashedSeparator__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Actions__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DetailsTable__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_decorators_loadRecord__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ShipTo__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Orders_shared_ShippingPreference__ = __webpack_require__(266);
















function Detail(_ref) {
  var mistakeShipment = _ref.mistakeShipment;

  var parsedMistakeShipment = mistakeShipment.toJS();
  var id = mistakeShipment.get("id");
  var packingSlipUrl = __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* API_BASE */] + "/mistake_shipments/" + id + "/download_packing_slip";

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "page-header page-header-bar" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h1",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "with-padding" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["J" /* RecordPager */], {
            baseUrl: "/mistake-shipments",
            record: mistakeShipment
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "header-content" },
            mistakeShipment.get("code")
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["E" /* ClipboardCopy */], {
            name: mistakeShipment.get("code"),
            type: "Mistake Shipment"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Actions__["a" /* default */], { url: packingSlipUrl, mistakeShipment: mistakeShipment })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "panel panel-default" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "panel-body" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__DetailsTable__["a" /* DetailsTable */], { mistakeShipment: parsedMistakeShipment }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DashedSeparator__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ShipTo__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Orders_shared_ShippingPreference__["a" /* ShippingPreference */], {
            shippingMethod: parsedMistakeShipment.shipping_method
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DashedSeparator__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["z" /* AuditFields */], { record: mistakeShipment, multiLine: true })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
      { md: 9 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["M" /* Notes */], {
        resource: mistakeShipment,
        resourceType: __WEBPACK_IMPORTED_MODULE_9__shared_types_resourceTypes__["a" /* default */].mistakeShipment,
        resourceKey: "mistakeShipment"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["N" /* Attachments */], {
        multiple: true,
        resource: mistakeShipment,
        resourceType: __WEBPACK_IMPORTED_MODULE_9__shared_types_resourceTypes__["a" /* default */].mistakeShipment,
        resourceKey: "mistakeShipment",
        attachmentTypes: __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ATTACHMENT_TYPES */]
      })
    )
  );
}

Detail.propTypes = {
  mistakeShipment: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Map)
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    mistakeShipment: state.mistakeShipmentDetail.get("mistakeShipment")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_decorators_loadRecord__["a" /* default */])({
  reducer: "mistakeShipmentDetail",
  name: "mistakeShipment",
  action: __WEBPACK_IMPORTED_MODULE_12__actions__["a" /* show */]
})(Detail)));

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Receiving_constants__ = __webpack_require__(34);
/* harmony export (immutable) */ __webpack_exports__["a"] = DetailsTable;






function DetailsTable(_ref) {
  var mistakeShipment = _ref.mistakeShipment;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components__["X" /* Section */],
    { title: "Details", editable: false },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components__["W" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "Type", value: "Mistake Shipment" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Part",
        value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["h" /* PartNumber */], { part: mistakeShipment.part })
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "Serial #", value: mistakeShipment.serial_number }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "Qty", value: mistakeShipment.quantity }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "DOM", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__["h" /* monthFullYear */])(mistakeShipment.dom) }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "EXP", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__["g" /* monthYear */])(mistakeShipment.expiration) }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "Tagged By", value: mistakeShipment.tagged_by }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Store Location",
        value: mistakeShipment.store_location.name
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "Location", value: mistakeShipment.location }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Incoming AWB #",
        value: mistakeShipment.incoming_awb_number
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "Minor Note", value: mistakeShipment.minor_note }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Condition",
        value: __WEBPACK_IMPORTED_MODULE_4__Receiving_constants__["x" /* CONDITION_TYPES */][mistakeShipment.condition].label
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "Tag Date", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__["b" /* shortDate */])(mistakeShipment.tag_date) })
    )
  );
}

DetailsTable.propTypes = {
  mistakeShipment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    tag_date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    serial_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Orders_shared_ShippingAddress__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_PhysicalAddress_PhysicalAddress__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__decorators_withMistakeShipment__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ShipToForm__ = __webpack_require__(1437);











function ShipTo(_ref) {
  var mistakeShipment = _ref.mistakeShipment;

  var initialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_pojos__["a" /* default */])(mistakeShipment.toJS()).pick(__WEBPACK_IMPORTED_MODULE_7__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_7__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_7__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_7__constants__["_17" /* SHIP_TO_SHIPPING_ADDRESS */], __WEBPACK_IMPORTED_MODULE_7__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */]);

  var renderForm = function renderForm(close) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ShipToForm__["a" /* default */], {
      close: close,
      mistakeShipment: mistakeShipment.toJS(),
      initialValues: initialValues
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Section__["a" /* default */],
    {
      title: "Ship To",
      modal: {
        title: "Edit Shipping",
        content: renderForm
      },
      editable: !mistakeShipment.get("shipped")
    },
    !mistakeShipment.get(__WEBPACK_IMPORTED_MODULE_7__constants__["q" /* SHIP_TO_TYPE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_PhysicalAddress_PhysicalAddress__["a" /* PhysicalAddress */], { address: {} }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Orders_shared_ShippingAddress__["a" /* default */], { shippingType: __WEBPACK_IMPORTED_MODULE_7__constants__["B" /* SHIP_TO */], record: mistakeShipment })
  );
}

ShipTo.propTypes = {
  mistakeShipment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__decorators_withMistakeShipment__["a" /* default */])(ShipTo));

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_ShippingSection__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SalesOrders_components_shared_FormSections_ShippingSection__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__decorators_withMistakeShipment__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* unused harmony export Form */
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













function Form(_ref) {
  var mistakeShipment = _ref.mistakeShipment,
      props = _objectWithoutProperties(_ref, ["mistakeShipment"]);

  var shipToOptions = [{
    text: "Company",
    value: __WEBPACK_IMPORTED_MODULE_10__shared_components_ShippingSection_shippingTypes__["d" /* COMPANY */]
  }, {
    text: "Other",
    value: __WEBPACK_IMPORTED_MODULE_10__shared_components_ShippingSection_shippingTypes__["e" /* DROPSHIP */]
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_redux_form__["FormSection"],
        { name: "" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Ship To"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_ShippingSection__["a" /* ShippingSection */], {
          shippingType: "ship_to",
          shipToOptions: shipToOptions,
          shipToCompany: mistakeShipment.get("ship_to_company")
        })
      )
    )
  );
}

Form.propTypes = {
  salesOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, {
  onSubmit: __WEBPACK_IMPORTED_MODULE_8__actions__["b" /* update */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__decorators_withMistakeShipment__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: "mistakeShipmentShipToDetails",
  validate: __WEBPACK_IMPORTED_MODULE_7__SalesOrders_components_shared_FormSections_ShippingSection__["b" /* validate */]
})(Form))));

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pagination__ = __webpack_require__(653);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










function MistakeShipmentSearch(_ref) {
  var pushHistory = _ref.pushHistory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_7__pagination__["a" /* default */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a company name, part # or serial #...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/mistake-shipments/" + r.id);
              }
            }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Mistake Shipments"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

MistakeShipmentSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_1_react_router_redux__["push"] })(MistakeShipmentSearch));

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators_translateProps__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_LocationFlag__ = __webpack_require__(351);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












function BasicRow(_ref) {
  var record = _ref.record,
      handleClick = _ref.handleClick;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { className: "clickable", onClick: handleClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(record.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_LocationFlag__["a" /* default */], { location: record.store_location_id })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["truncate"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(record, "ship_to_company.name"), 17)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["h" /* PartNumber */], { part: record.part })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.serial_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_8__Receiving_constants__["x" /* CONDITION_TYPES */][record.condition].label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      record.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.incoming_awb_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.outgoing_awb_number
    )
  );
}

BasicRow.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  statuses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  handleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators_translateProps__["a" /* default */])(function (_ref2) {
  var record = _ref2.record,
      pushHistory = _ref2.pushHistory;
  return {
    handleClick: function handleClick() {
      return pushHistory("/mistake-shipments/" + record.uuid);
    }
  };
});

var Row = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"] })(withProps(BasicRow));

function Table(_ref3) {
  var isLoading = _ref3.isLoading,
      pageActions = _ref3.pageActions,
      results = _ref3.results;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */],
    { loading: isLoading, refresh: pageActions.expire },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "REC #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "REC Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Store Loc"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Company"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Cond Rec"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "QTY Rec"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Incoming AWB #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Outgoing AWB #"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (record) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row, { key: record.id, record: record });
      })
    )
  );
}

Table.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_4__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"] })(Table));

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_reducer__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__ = __webpack_require__(58);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  mistakeShipment: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
}).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["a" /* notesInitialState */]).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["b" /* attachmentsInitialState */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _extends(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* SET */], function (state, action) {
  return state.merge({ mistakeShipment: action.mistakeShipment });
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["c" /* createAttachmentReducer */])(__WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].mistakeShipment), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["d" /* createNoteReducer */])(__WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].mistakeShipment))));

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Table__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pagination__ = __webpack_require__(432);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












var defaultFilters = {
  no_stock: undefined,
  resident_expert_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__hooks__["a" /* useCurrentUser */])().id,
  tier_type: undefined
};

var orderFilter = {
  sort: "most_recent_sale_date"
};

var filters = [{
  label: "Show All Tier Types",
  filters: _extends({}, defaultFilters, orderFilter)
}, {
  label: "5 Star",
  filters: _extends({}, orderFilter, { tier_type: "SATL" })
}, {
  label: "4 Star",
  filters: _extends({}, orderFilter, { tier_type: "ATL" })
}, {
  label: "3 Star",
  filters: _extends({}, orderFilter, { tier_type: "BTL" })
}, {
  label: "2 Star",
  filters: _extends({}, orderFilter, { tier_type: "BBTL" })
}, {
  label: "1 Star",
  filters: _extends({}, orderFilter, { tier_type: "ZTL" })
}, {
  label: "No Stock",
  filters: { no_stock: true }
}];

var filterTags = [{
  label: "5 Star",
  key: "tier_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])("SATL")
}, {
  label: "4 Star",
  key: "tier_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])("ATL")
}, {
  label: "3 Star",
  key: "tier_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])("BTL")
}, {
  label: "2 Star",
  key: "tier_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])("BBTL")
}, {
  label: "1 Star",
  key: "tier_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])("ZTL")
}, {
  label: "NAP Records",
  key: "nap_records"
}, {
  label: "No Stock",
  key: "no_stock"
}];

function Search(_ref) {
  var pushHistory = _ref.pushHistory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_9__pagination__["b" /* residentExpertSearch */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a Part Number...",
              submitOnSingleResult: function submitOnSingleResult(p) {
                return pushHistory("/parts/" + p.uuid);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, { filters: filters, right: true }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "Resident Expert",
          filters: filterTags
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

Search.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(Search));

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Stars_Stars__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_PartNumber_PartNumber__ = __webpack_require__(283);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













function renderRow(p, pushHistory) {
  var className = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_helpers__["a" /* getPartNumberColorClassNameByTierType */])(p.tier_type_string);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: p.id,
      className: "clickable",
      onClick: function onClick() {
        return pushHistory("/parts/" + p.id);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_PartNumber_PartNumber__["a" /* default */], {
        part: Object.assign(p, { tier_type: p.tier_type_string }),
        className: className,
        showIcon: true
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["c" /* shortDateYY */])(p.most_recent_sale_date)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(p.most_recent_sale_price)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["c" /* shortDateYY */])(p.most_recent_iq_date)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["c" /* shortDateYY */])(p.most_recent_user_iq_date)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Stars_Stars__["a" /* default */], { tierType: p.tier_type_string })
    )
  );
}

function Table(_ref) {
  var results = _ref.results,
      pushHistory = _ref.pushHistory,
      isLoading = _ref.isLoading;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */],
    { loading: isLoading },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part Number"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Most Recent Sales Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Most Recent Sales Price"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Last Incoming Quote"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Last Incoming Quote By Me"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Tier Type"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_4__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_1_react_router_redux__["push"] })(Table));

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);





var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = searchProps.paginator.get("filters").toJS();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        return window.open(__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* API_BASE */] + "/shopping_lists/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_query_string__["stringify"])(params), "_blank");
      }
    },
    "Export"
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ExportButton);

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ExportButton__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Table__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pagination__ = __webpack_require__(432);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












var defaultFilters = {
  tier_type: undefined
};

var orderFilter = {
  sort: "most_recent_sale_date"
};

var filters = [{
  label: "Show All Tier Types",
  filters: _extends({}, defaultFilters, orderFilter)
}, {
  label: "5 Star",
  filters: _extends({}, orderFilter, { tier_type: "SATL" })
}, {
  label: "4 Star",
  filters: _extends({}, orderFilter, { tier_type: "ATL" })
}, {
  label: "3 Star",
  filters: _extends({}, orderFilter, { tier_type: "BTL" })
}, {
  label: "2 Star",
  filters: _extends({}, orderFilter, { tier_type: "BBTL" })
}, {
  label: "1 Star",
  filters: _extends({}, orderFilter, { tier_type: "ZTL" })
}];

var filterTags = [{
  label: "5 Star",
  key: "tier_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])("SATL")
}, {
  label: "4 Star",
  key: "tier_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])("ATL")
}, {
  label: "3 Star",
  key: "tier_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])("BTL")
}, {
  label: "2 Star",
  key: "tier_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])("BBTL")
}, {
  label: "1 Star",
  key: "tier_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])("ZTL")
}, {
  label: "NAP Records",
  key: "nap_records"
}];

function Search(_ref) {
  var pushHistory = _ref.pushHistory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_9__pagination__["a" /* default */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a Part Number...",
              submitOnSingleResult: function submitOnSingleResult(p) {
                return pushHistory("/parts/" + p.id);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ExportButton__["a" /* default */], { searchProps: searchProps }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, { filters: filters, right: true }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "My Shopping List",
          filters: filterTags
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

Search.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(Search));

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Stars_Stars__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_PartNumber_PartNumber__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_currency__ = __webpack_require__(20);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













function renderRow(p, pushHistory) {
  var className = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_helpers__["a" /* getPartNumberColorClassNameByTierType */])(p.tier_type_string);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: p.id,
      className: "clickable",
      onClick: function onClick() {
        return pushHistory("/parts/" + p.id);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_PartNumber_PartNumber__["a" /* default */], {
        part: Object.assign(p, { tier_type: p.tier_type_string }),
        className: className,
        showIcon: true
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["c" /* shortDateYY */])(p.most_recent_sale_date)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_currency__["a" /* dollars */])(p.most_recent_sale_price)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["c" /* shortDateYY */])(p.most_recent_iq_date)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["c" /* shortDateYY */])(p.most_recent_user_iq_date)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Stars_Stars__["a" /* default */], { tierType: p.tier_type_string })
    )
  );
}

function Table(_ref) {
  var results = _ref.results,
      pushHistory = _ref.pushHistory,
      isLoading = _ref.isLoading;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */],
    { loading: isLoading },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part Number"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Most Recent Sales Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Most Recent Sales Price"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Last Incoming Quote"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Last Incoming Quote By Me"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Tier Type"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_4__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_1_react_router_redux__["push"] })(Table));

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ErrorBoundary = function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary(props) {
    _classCallCheck(this, ErrorBoundary);

    var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

    _this.state = { error: null };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      this.setState({ error: error });
      if (true) {
        // eslint-disable-next-line
        Rollbar.error(error);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var error = this.state.error;
      var _props = this.props,
          children = _props.children,
          notification = _props.notification;


      if (error) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: { color: "red" } },
              "Error loading notification type",
              " ",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "strong",
                null,
                notification.notification_type
              ),
              ": ",
              error.message
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null)
        );
      }

      return children;
    }
  }]);

  return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ErrorBoundary);


ErrorBoundary.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)]),
  notification: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    notification_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};

ErrorBoundary.defaultProps = {
  notification: {}
};

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var InventoryLink = function InventoryLink(_ref) {
  var markNotificationRead = _ref.markNotificationRead,
      notificationId = _ref.notificationId,
      id = _ref.id,
      serialNumber = _ref.serialNumber;

  if (!id) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    "span",
    null,
    "SN-",
    serialNumber
  );

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    "span",
    {
      onClick: function onClick(e) {
        e.stopPropagation();
        markNotificationRead(notificationId);
      }
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router_dom__["a" /* Link */],
      { to: "/inventories/" + id },
      "SN-",
      serialNumber
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    markNotificationRead: function markNotificationRead(noteId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* markRead */])(noteId));
    }
  };
})(InventoryLink));

InventoryLink.propTypes = {
  markNotificationRead: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  notificationId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  serialNumber: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
};

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(202);






var ItemLink = function ItemLink(_ref) {
  var markNotificationRead = _ref.markNotificationRead,
      notificationId = _ref.notificationId,
      path = _ref.path,
      id = _ref.id,
      displayText = _ref.displayText;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    {
      onClick: function onClick(e) {
        e.stopPropagation();
        markNotificationRead(notificationId);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
      { to: "/" + path + "/" + id },
      displayText
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    markNotificationRead: function markNotificationRead(noteId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* markRead */])(noteId));
    }
  };
})(ItemLink));

ItemLink.propTypes = {
  markNotificationRead: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  notificationId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  path: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  displayText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony export (immutable) */ __webpack_exports__["a"] = Body;




function Body(_ref) {
  var prompt = _ref.prompt;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["e" /* Body */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "center-block alert alert-warning" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "media" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "media-left" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-warning text-warning" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "media-body" },
            prompt
          )
        )
      )
    )
  );
}

Body.propTypes = {
  prompt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* unused harmony export default */





function Cancel(_ref) {
  var toggle = _ref.toggle;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: toggle },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "ban", fixed: true }),
    "Remove Line Item"
  );
}

Cancel.propTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = Footer;





function Footer(_ref) {
  var close = _ref.close,
      onConfirm = _ref.onConfirm;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["d" /* Footer */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      { type: "button", className: "btn btn-default", onClick: close },
      "Cancel"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      { type: "submit", className: "btn btn-danger", onClick: onConfirm },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "times", fixed: true }),
        "Delete Notifications"
      )
    )
  );
}

Footer.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony export (immutable) */ __webpack_exports__["a"] = Header;




function Header(_ref) {
  var close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h4",
      { className: "modal-title" },
      "Delete Notifications"
    )
  );
}

Header.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarkAllRead__ = __webpack_require__(655);
/* unused harmony reexport MarkAllRead */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cancel__ = __webpack_require__(1450);
/* unused harmony reexport Cancel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfirmModal__ = __webpack_require__(654);
/* unused harmony reexport ConfirmModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Body__ = __webpack_require__(1449);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Body__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer__ = __webpack_require__(1451);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__Footer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Header__ = __webpack_require__(1452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__Header__["a"]; });













/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* unused harmony export MarkRead */






function MarkRead(_ref) {
  var noteId = _ref.noteId,
      markRead = _ref.markRead;

  var onClick = function onClick(e) {
    e.stopPropagation();
    markRead(noteId);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "a",
    { role: "button", className: "text-danger", onClick: onClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: "close", fixed: true })
  );
}

MarkRead.propTypes = {
  noteId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  markRead: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    markRead: function markRead(id) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* markDeleted */](id));
    }
  };
})(MarkRead));

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);




var PaginationController = function PaginationController(_ref) {
  var limit = _ref.limit,
      search = _ref.search,
      dispatch = _ref.dispatch;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var _parse = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_query_string__["parse"])(location.search),
        page = _parse.page;

    dispatch(search.setLimit(limit));
    if (page !== undefined) {
      dispatch(search.setPage(page));
    }
  }, []);

  return null;
};

PaginationController.propTypes = {
  limit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pageActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      reload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
    })
  }).isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

PaginationController.defaultProps = {
  limit: 15
};

/* harmony default export */ __webpack_exports__["a"] = (PaginationController);

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notificationTypes__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MarkRead__ = __webpack_require__(1454);
/* unused harmony export Row */













function Row(_ref) {
  var notification = _ref.notification,
      history = _ref.history,
      markNotificationRead = _ref.markNotificationRead,
      filtersSet = _ref.filtersSet;
  var _NOTIFICATION_TYPES$n = __WEBPACK_IMPORTED_MODULE_4__notificationTypes__["a" /* default */][notification.notifier_type][notification.notification_type],
      icon = _NOTIFICATION_TYPES$n.icon,
      iconUrl = _NOTIFICATION_TYPES$n.iconUrl,
      url = _NOTIFICATION_TYPES$n.url,
      message = _NOTIFICATION_TYPES$n.message;
  var read = notification.read;

  var classes = __WEBPACK_IMPORTED_MODULE_5_classnames___default()("pull-left", { "text-bold": !read });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      style: {
        backgroundColor: read ? "rgba(255, 255, 255, 0.02)" : "rgba(255, 255, 255, 0.1)"
      },
      onClick: function onClick() {
        markNotificationRead(notification.id);
        history.push(url(notification));
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      iconUrl ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: iconUrl,
        height: "17px",
        className: read ? "text-muted" : "",
        alt: notification.notifier_type
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw " + (read ? "text-muted" : "") + " " + icon })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: classes },
        message(notification)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { width: "25%" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "em",
        { className: "small text-muted" },
        __WEBPACK_IMPORTED_MODULE_2_moment___default()(notification.created_at).calendar({
          lastWeek: "dddd [at] h:mm a"
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["isEmpty"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(filtersSet, __WEBPACK_IMPORTED_MODULE_10__users_constants__["M" /* USER_ID */])) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__MarkRead__["a" /* default */], { noteId: notification.id })
    )
  );
}

Row.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  notification: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  markNotificationRead: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* I started using this pattern a while back to make it easier
 * to render rows in our data tables. It makes the Row component
 * cleaner but it adds indirection. I'd like to revisit this problem
 * to see if we can do something more clear and intentional. ~sslotsky
 */

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["d" /* translateProps */])(function (s, filtersSet) {
  return {
    notification: s,
    key: s.id,
    filtersSet: filtersSet
  };
}, {
  erase: true
});

/* harmony default export */ __webpack_exports__["a"] = (withProps(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    markNotificationRead: function markNotificationRead(noteId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions__["a" /* markRead */])(noteId));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_router__["withRouter"])(Row))));

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Row__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ErrorBoundary__ = __webpack_require__(1446);
/* unused harmony export Table */








function Table(_ref) {
  var results = _ref.results,
      isLoading = _ref.isLoading,
      filtersSet = _ref.filtersSet;

  if (isLoading || results.length > 0) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */],
      {
        loading: isLoading,
        withoutBaseline: true,
        responsive: false,
        striped: false
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Head,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Message"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Date"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Body,
        null,
        results.map(function (r) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__ErrorBoundary__["a" /* default */],
            { notification: r, key: r.id },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Row__["a" /* default */])(r, filtersSet)
          );
        })
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "p",
    null,
    "You do not have any notifications at this time"
  );
}

Table.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var withListId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["d" /* translateProps */])(function () {
  return { listId: "searchNotifications" };
});

/* harmony default export */ __webpack_exports__["a"] = (withListId(__WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__["decorators"].tabulate(Table)));

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });


/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(1458);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });


/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_formatters_text__ = __webpack_require__(11);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return restrictedEntityToSentence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return restrictedAddressesToSentence; });



var restrictedEntityToSentence = function restrictedEntityToSentence(details) {
  var results = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(details, "results", []);

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_formatters_text__["b" /* toSentence */])(results.map(function (f) {
    return f.name;
  }));
};

var restrictedAddressesToSentence = function restrictedAddressesToSentence(details) {
  var results = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(details, "results", []);

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_formatters_text__["b" /* toSentence */])(results.map(function (r) {
    return r.individual_address;
  }));
};

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_CurrencyField_CurrencyField__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Lots_constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SalesOrders_components_Detail_Panel_Billing_FirstExchangeWarning__ = __webpack_require__(1882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_constants__ = __webpack_require__(19);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var PAID_IN_FULL = "paid_in_full";

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.setToFullVal = function () {
      var _this$props = _this.props,
          order = _this$props.order,
          _this$props$includeCa = _this$props.includeCancelled,
          includeCancelled = _this$props$includeCa === undefined ? false : _this$props$includeCa;

      var lineItems = includeCancelled ? order.line_items : order.line_items.filter(function (l) {
        return !l.cancelled;
      });

      lineItems.forEach(function (l, idx) {
        _this.props.change("line_items[" + idx + "]." + __WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_constants__["O" /* AMOUNT_PAID */], Number(_this.fieldAmount(l)));
        _this.props.change("line_items[" + idx + "]." + PAID_IN_FULL, true);
        _this.setInvoicePaidDate(idx);
      });
    }, _this.setItemToFullVal = function (idx) {
      var _this$props2 = _this.props,
          order = _this$props2.order,
          _this$props2$includeC = _this$props2.includeCancelled,
          includeCancelled = _this$props2$includeC === undefined ? false : _this$props2$includeC;

      var lineItems = includeCancelled ? order.line_items : order.line_items.filter(function (l) {
        return !l.cancelled;
      });

      var lineItem = lineItems[idx];
      _this.props.change("line_items[" + idx + "]." + __WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_constants__["O" /* AMOUNT_PAID */], Number(_this.fieldAmount(lineItem)));
    }, _this.setInvoicePaidDate = function (idx) {
      var date = __WEBPACK_IMPORTED_MODULE_14_moment___default()().format("YYYY-MM-DD");
      if (!_this.props.getFieldValue("line_items[" + idx + "].invoice_paid_date")) {
        _this.props.change("line_items[" + idx + "].invoice_paid_date", date);
      }
    }, _this.handleAmountFormChange = function (ev, field) {
      var val = ev.target ? ev.target.value : null;
      var date = __WEBPACK_IMPORTED_MODULE_14_moment___default()().format("YYYY-MM-DD");
      if (val) {
        _this.props.change("line_items[" + 0 + "]." + field, date);
      }
    }, _this.handleTopLevelFormChange = function (ev, field) {
      var _this$props3 = _this.props,
          order = _this$props3.order,
          _this$props3$includeC = _this$props3.includeCancelled,
          includeCancelled = _this$props3$includeC === undefined ? false : _this$props3$includeC;

      var val = ev.target.value;

      var lineItems = includeCancelled ? order.line_items : order.line_items.filter(function (l) {
        return !l.cancelled;
      });

      lineItems.forEach(function (l, idx) {
        _this.props.change("line_items[" + idx + "]." + field, val);
      });
    }, _this.fieldAmount = function (lineItem) {
      var orderType = _this.props.orderType;


      if (orderType === __WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_constants__["x" /* PURCHASE_ORDER */]) {
        return lineItem.cost * lineItem.quantity;
      }

      return lineItem.exchange_sale ? lineItem.exchange_fee : lineItem.quantity * lineItem.price_per_unit;
    }, _this.renderLineItems = function (_ref2) {
      var fields = _ref2.fields,
          orderType = _ref2.orderType,
          lineItems = _ref2.lineItems;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        fields.map(function (item, idx) {
          var lineItem = lineItems[idx];
          if (!lineItem) return null;

          var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__hooks__["a" /* useCurrentUser */])();
          var shouldEnterAmount = lineItem[__WEBPACK_IMPORTED_MODULE_10__SalesOrders_constants__["_5" /* BROKERED_EXCHANGE */]] || lineItem[__WEBPACK_IMPORTED_MODULE_10__SalesOrders_constants__["e" /* FLAT_EXCHANGE */]];
          var disabled = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_12__users_constants__["m" /* ACCOUNTING */]);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                    name: item + ".part.part_number",
                    label: "Part Number",
                    disabled: true
                  })
                ),
                _this.props.displaySerial && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                    name: item + ".inventory.serial_number",
                    label: "Serial Number",
                    disabled: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                    name: item + ".invoice_number",
                    label: "Invoice Number"
                  })
                ),
                orderType === __WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_constants__["x" /* PURCHASE_ORDER */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                    name: item + ".invoice_date",
                    label: "Invoice Date",
                    type: "date"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                    name: item + ".invoice_due_date",
                    label: "Invoice Due Date",
                    type: "date"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                    name: item + ".invoice_paid_date",
                    label: "Invoice Paid Date",
                    type: "date"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_CurrencyField_CurrencyField__["a" /* default */],
                    name: [item, __WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_constants__["O" /* AMOUNT_PAID */]].join("."),
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_constants__["O" /* AMOUNT_PAID */])
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
                    { justified: true, title: "Amt Paid In Full" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                      name: item + "." + PAID_IN_FULL,
                      component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                      label: "Yes",
                      onChange: function onChange() {
                        _this.setItemToFullVal(idx);
                        _this.setInvoicePaidDate(idx);
                      }
                    })
                  )
                )
              ),
              lineItem.exchange_sale && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__SalesOrders_components_Detail_Panel_Billing_FirstExchangeWarning__["a" /* default */], { lineItem: lineItem }),
                (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash__["isEmpty"])(lineItem.exchange_type) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash__["isEmpty"])(lineItem.core_repair_invoice_number)) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm", style: { marginTop: 0 } }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                    { md: 2 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                      name: item + ".core_repair_invoice_number",
                      component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                      disabled: disabled,
                      label: "Core Repair Inv. #"
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                    { md: 2 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                      name: item + "." + __WEBPACK_IMPORTED_MODULE_10__SalesOrders_constants__["_4" /* CORE_REPAIR_INVOICE_AMOUNT_PAID */],
                      component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_CurrencyField_CurrencyField__["a" /* default */],
                      disabled: disabled || !shouldEnterAmount,
                      label: "Amount",
                      onChange: function onChange(e) {
                        return _this.handleAmountFormChange(e, __WEBPACK_IMPORTED_MODULE_10__SalesOrders_constants__["P" /* CORE_REPAIR_INVOICE_PAID */]);
                      }
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                    { md: 2 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                      name: item + "." + __WEBPACK_IMPORTED_MODULE_10__SalesOrders_constants__["P" /* CORE_REPAIR_INVOICE_PAID */],
                      component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                      disabled: disabled,
                      type: "date",
                      label: "Core Repair Inv Paid Date"
                    })
                  )
                )
              )
            )
          );
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          order = _props.order,
          orderType = _props.orderType,
          handleSubmit = _props.handleSubmit,
          close = _props.close,
          invalid = _props.invalid,
          submitting = _props.submitting,
          includeCancelled = _props.includeCancelled;


      var relevantLineItems = includeCancelled ? order.line_items : order.line_items.filter(function (l) {
        return orderType === __WEBPACK_IMPORTED_MODULE_10__SalesOrders_constants__["_6" /* SALES_ORDER */] ? !l.cancelled || l.shipped : !l.cancelled;
      });

      var shouldRenderSection = relevantLineItems.length > 1;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "form",
        { onSubmit: handleSubmit },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["e" /* Body */],
          null,
          shouldRenderSection && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                name: "Invoice #",
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_constants__["N" /* INVOICE_NUMBER */]),
                onChange: function onChange(e) {
                  return _this2.handleTopLevelFormChange(e, __WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_constants__["N" /* INVOICE_NUMBER */]);
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_constants__["x" /* PURCHASE_ORDER */] === orderType && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                name: __WEBPACK_IMPORTED_MODULE_15__Lots_constants__["i" /* INVOICE_DATE */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_15__Lots_constants__["i" /* INVOICE_DATE */]),
                type: "date",
                onChange: function onChange(e) {
                  return _this2.handleTopLevelFormChange(e, __WEBPACK_IMPORTED_MODULE_15__Lots_constants__["i" /* INVOICE_DATE */]);
                }
              })
            ),
            [__WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_constants__["x" /* PURCHASE_ORDER */], __WEBPACK_IMPORTED_MODULE_10__SalesOrders_constants__["_6" /* SALES_ORDER */]].includes(orderType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                  name: __WEBPACK_IMPORTED_MODULE_15__Lots_constants__["f" /* INVOICE_DUE_DATE */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_15__Lots_constants__["f" /* INVOICE_DUE_DATE */]),
                  type: "date",
                  onChange: function onChange(e) {
                    return _this2.handleTopLevelFormChange(e, __WEBPACK_IMPORTED_MODULE_15__Lots_constants__["f" /* INVOICE_DUE_DATE */]);
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                { md: 2 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                  name: "invoice_paid_date",
                  label: "Invoice Paid Date",
                  type: "date",
                  onChange: function onChange(e) {
                    return _this2.handleTopLevelFormChange(e, "invoice_paid_date");
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
                { justified: true, title: "Amt Paid In Full" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                  name: PAID_IN_FULL,
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                  label: "Yes",
                  onChange: this.setToFullVal
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "table",
            { className: "table table-striped table-numbered margin-bottom-none" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["FieldArray"], {
              name: "line_items",
              component: this.renderLineItems
              // Pass in the full array (or filtered if !includeCancelled)
              , lineItems: relevantLineItems,
              orderType: orderType
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["d" /* Footer */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["i" /* Button */],
            { onClick: close },
            "Cancel"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["i" /* Button */],
            {
              type: "submit",
              bsStyle: "primary",
              disabled: invalid || submitting
            },
            "\xA0Update Invoice Details"
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  change: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  displaySerial: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  includeCancelled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  invalid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  order: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}),
  orderType: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  submitting: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  getFieldValue: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      dispatch(ownProps.bulkUpdate(data)).then(function () {
        ownProps.close();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].error("Error", error.message);
      });
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["reduxForm"])({
  form: "editInvoiceDetails"
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_arrays__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CompanyAddress__ = __webpack_require__(660);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* DEPRECATED. This now serves as an adapter for the CompanyAddress component.
 * If you're here, you probably want to be there instead.
 */






var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["d" /* translateProps */])(function (_ref) {
  var names = _ref.names,
      props = _objectWithoutProperties(_ref, ["names"]);

  var findInput = function findInput(name) {
    return props[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_arrays__["b" /* findMatch */])(names, name)];
  };
  return {
    shippingType: findInput("type"),
    companyId: findInput("company_id"),
    addressId: findInput("address_id"),
    addressPh: findInput("address_phone")
  };
});

var forCompanyShipping = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var shippingType = _ref2.shippingType;
  return shippingType.input.value === __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* COMPANY */];
});

/* harmony default export */ __webpack_exports__["a"] = (withProps(forCompanyShipping(function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CompanyAddress__["a" /* default */], props);
})));

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_arrays__ = __webpack_require__(129);
/* harmony export (immutable) */ __webpack_exports__["a"] = DoNotShipReasonFields;
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







function DoNotShipReasonFields(_ref) {
  var requires_8130_3 = _ref.requires_8130_3,
      requires_weight_and_dims = _ref.requires_weight_and_dims,
      requires_picture = _ref.requires_picture,
      requires_trace_documentation = _ref.requires_trace_documentation,
      tbd = _ref.tbd,
      rest = _objectWithoutProperties(_ref, ["requires_8130_3", "requires_weight_and_dims", "requires_picture", "requires_trace_documentation", "tbd"]);

  var shippingType = rest[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_arrays__["b" /* findMatch */])(Object.keys(rest), "type")];
  if (shippingType.input.value !== __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__["d" /* DO_NOT_SHIP */]) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "row row-col-gutters-half" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "col-md-12" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "form-group", style: { cursor: "pointer" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "purchase_for" },
          "Do Not Ship Reason ",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "sup",
            { className: "small text-danger" },
            "*"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            id: "purchase_for",
            className: "btn-group btn-group-justified",
            "data-toggle": "buttons"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */], {
            input: requires_8130_3.input,
            label: "8130-3 Approval",
            icon: "fa-check-circle"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */], {
            input: requires_weight_and_dims.input,
            label: "Dim/Wt Approval",
            icon: "fa-check-circle"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */], {
            input: requires_trace_documentation.input,
            label: "Trace Doc Approval",
            icon: "fa-check-circle"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */], {
            input: requires_picture.input,
            label: "Picture Approval",
            icon: "fa-check-circle"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */], { input: tbd.input, label: "TBD", icon: "fa-check-circle" })
        )
      )
    )
  );
}

DoNotShipReasonFields.propTypes = {
  shipping_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  requires_8130_3: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired
  }),
  requires_weight_and_dims: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired
  }),
  requires_picture: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired
  }),
  requires_trace_documentation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired
  }),
  tbd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired
  })
};

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Form__ = __webpack_require__(1465);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













var excludedQuoteTypes = ["awaiting_info_to_complete", "offer"];

function filteredLineItems(quote) {
  return quote.outgoing_quote_line_items.filter(function (i) {
    return !excludedQuoteTypes.includes(i.quote_type);
  });
}

function AutoFollowup(_ref) {
  var quote = _ref.quote,
      currentUser = _ref.currentUser;

  var disabled = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_9__users_constants__["k" /* SALES */]) || quote.cancelled || quote.received || filteredLineItems(quote).length <= 0;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__["a" /* default */],
        { onClick: open, disabled: disabled },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: "repeat", fixed: true }),
        "\xA0Auto Follow Up",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["a" /* Modal */],
          { open: visible, close: close, dialogClass: "modal-lg" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["c" /* Close */], { close: close }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Auto Follow Up"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Form__["a" /* default */], { close: close, quote: quote, currentUser: currentUser })
        )
      );
    }
  );
}

AutoFollowup.propTypes = _extends({
  quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
}, __WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__["b" /* default */])(AutoFollowup));

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_NumberInput_NumberInput__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__validate__ = __webpack_require__(1466);













var formName = "followUpOQForm";

function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["a" /* CheckGroup */],
            {
              title: "Auto Follow Up",
              checkGroupStyles: { marginBottom: 0 },
              justified: true
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* AUTO_FOLLOWUP */],
              component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["b" /* Check */],
              label: "Auto Follow Up",
              onChange: function onChange(_ev, val) {
                if (!val) props.setFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["v" /* AUTO_FOLLOWUP_DAYS */])(null);
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            label: ["# of Days ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["j" /* NoteTooltip */], {
              placement: "right",
              icon: "fa-info-circle",
              color: "rgba(255, 255, 255, 0.25)",
              note: "Range: 1 to 14"
            })],
            name: __WEBPACK_IMPORTED_MODULE_6__constants__["v" /* AUTO_FOLLOWUP_DAYS */],
            required: props.getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["u" /* AUTO_FOLLOWUP */]),
            disabled: !props.getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["u" /* AUTO_FOLLOWUP */]),
            component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_NumberInput_NumberInput__["a" /* default */],
            roundDigits: 0,
            type: "number"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["d" /* FormInput */], name: "to", label: "To:", required: true })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["d" /* FormInput */], name: "cc", label: "CC:" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["d" /* FormInput */], name: "bcc", label: "BCC:" })
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (_, props) {
  return {
    initialValues: {
      auto_followup: props.quote.auto_followup,
      auto_followup_days: props.quote.auto_followup_days,
      to: props.quote.contact.email,
      bcc: props.currentUser.email
    }
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions__["i" /* setFollowUp */])(ownProps.quote.id, data, ownProps.close));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_11__validate__["a" /* default */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(45);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;




function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    if (values.auto_followup) {
      form.validate("to", __WEBPACK_IMPORTED_MODULE_2__constants__["v" /* AUTO_FOLLOWUP_DAYS */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);

      form.validate("to", "cc", "bcc").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["b" /* isValidEmail */]);

      form.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["v" /* AUTO_FOLLOWUP_DAYS */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](1), __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["k" /* isLessThanOrEqualTo */](14));
    }
  });
}

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Form__ = __webpack_require__(1468);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();















function ConvertToSalesOrder(_ref) {
  var history = _ref.history,
      quote = _ref.quote,
      currentUser = _ref.currentUser,
      convertQuote = _ref.convertQuote;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      inventories = _useState2[0],
      setInventories = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var ids = quote.outgoing_quote_line_items.map(function (o) {
      return o.inventory_id;
    }).filter(function (f) {
      return f;
    });

    if (ids.length > 0) {
      __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].inventories.search({
        ids: ids,
        all: true
      }).then(function (_ref2) {
        var results = _ref2.data.results;

        var sortedResult = quote.outgoing_quote_line_items.map(function (o) {
          return results.filter(function (r) {
            return r.id === o.inventory_id;
          })[0];
        }).filter(function (f) {
          return f;
        });
        setInventories(sortedResult);
      });
    } else {
      setInventories([]);
    }
  }, [quote]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      var onClick = quote.outgoing_quote_line_items.length === 1 && inventories.length === 1 ? function () {
        return convertQuote({
          inventory_ids: inventories.map(function (i) {
            return i.id;
          }),
          outgoing_quote_id: quote.id
        });
      } : open;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__["a" /* default */],
        { onClick: onClick, disabled: inventories.length === 0 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: "dollar", fixed: true }),
        "\xA0Convert To Sales Order",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["a" /* Modal */],
          { open: visible, close: close, dialogClass: "modal-lg" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["c" /* Close */], { close: close }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Convert To Sales Order"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Form__["a" /* default */], {
            close: close,
            convertQuote: convertQuote,
            inventories: inventories,
            history: history,
            quote: quote,
            currentUser: currentUser
          })
        )
      );
    }
  );
}

ConvertToSalesOrder.propTypes = _extends({
  quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
}, __WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__["b" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_router__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    convertQuote: function convertQuote(params) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__actions__["h" /* convertFromOutgoingQuote */])(params, ownProps.history));
    }
  };
})(ConvertToSalesOrder))));

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SalesOrders_components_ConvertFromCartForm_Warnings__ = __webpack_require__(187);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedLineItems: [],
      selectAll: false
    }, _this.onItemSelected = function (lineItem) {
      if (lineItem.id === null) {
        return;
      }

      var selectedLineItems = _this.state.selectedLineItems;

      var array = [].concat(_toConsumableArray(selectedLineItems));
      var index = array.indexOf(lineItem);
      if (index !== -1) {
        array.splice(index, 1);
        _this.setState({ selectedLineItems: array, selectAll: false });
      } else {
        _this.setState({
          selectedLineItems: selectedLineItems.concat([lineItem])
        });
      }
    }, _this.selectAll = function () {
      return _this.setState({
        selectedLineItems: _this.props.inventories.filter(function (i) {
          return [__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["U" /* LIST */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["W" /* DO_NOT_LIST */]].includes(i.sellable_status);
        }),
        selectAll: true
      });
    }, _this.renderRow = function (lineItem, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: i },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          i + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: { marginBottom: "6px" } },
          [__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["U" /* LIST */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["W" /* DO_NOT_LIST */]].includes(lineItem.sellable_status) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            name: "line_items",
            type: "checkbox",
            checked: _this.state.selectedLineItems.includes(lineItem),
            onChange: function onChange() {
              return _this.onItemSelected(lineItem);
            }
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["j" /* NoteTooltip */], {
            icon: "fa-lock",
            placement: "top",
            note: "Unavailable",
            color: "rgba(255, 255, 255, 0.25)"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.part.part_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.serial_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.location
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-center" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["o" /* LocationFlag */], { location: lineItem.store_location_id })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-center" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["o" /* LocationFlag */], { location: lineItem.store_owner_id })
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          close = _props.close,
          convertQuote = _props.convertQuote,
          handleSubmit = _props.handleSubmit,
          inventories = _props.inventories,
          quote = _props.quote;
      var selectedLineItems = this.state.selectedLineItems;


      var sameStoreOwner = [0, 1].includes([].concat(_toConsumableArray(new Set(selectedLineItems.map(function (a) {
        return a.store_owner_id;
      })))).length);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "form",
        { onSubmit: handleSubmit },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["e" /* Body */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
            null,
            !sameStoreOwner && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SalesOrders_components_ConvertFromCartForm_Warnings__["f" /* StoreOwnerWarning */], null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "table",
            { className: "table table-striped table-hover table-numbered" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "thead",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                    name: "line_items",
                    type: "checkbox",
                    onChange: this.selectAll,
                    checked: this.state.selectAll
                  }),
                  "\xA0\xA0Select All"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Part Number"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Serial Number"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Location"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-center" },
                    "Store Location"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-center" },
                    "Store Owner"
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tbody",
              null,
              inventories.map(function (inv, idx) {
                return _this2.renderRow(inv, idx);
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["j" /* ModalFooter */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            { type: "button", className: "btn btn-default", onClick: close },
            "Cancel"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            {
              type: "button",
              className: "btn btn-success",
              disabled: !sameStoreOwner,
              onClick: function onClick() {
                convertQuote({
                  inventory_ids: selectedLineItems.map(function (s) {
                    return s.id;
                  }),
                  outgoing_quote_id: quote.id
                });
              }
            },
            "Continue"
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  convertQuote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inventories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Quotes_shared_Edit_EditQuote__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(186);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var DetailsTable = function (_React$Component) {
  _inherits(DetailsTable, _React$Component);

  function DetailsTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DetailsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DetailsTable.__proto__ || Object.getPrototypeOf(DetailsTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editOpen: false
    }, _this.openModal = function () {
      _this.setState({ editOpen: true });
    }, _this.closeEditModal = function () {
      _this.setState({ editOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DetailsTable, [{
    key: "render",
    value: function render() {
      var outgoingQuote = this.props.outgoingQuote;
      var editOpen = this.state.editOpen;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "panel panel-default" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "panel-body" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h2",
            { style: { marginTop: 10 } },
            "Details",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["y" /* EditButton */], { handleClick: this.openModal }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Quotes_shared_Edit_EditQuote__["a" /* default */], {
              quote: outgoingQuote.toJS(),
              open: editOpen,
              updateQuote: __WEBPACK_IMPORTED_MODULE_5__actions__["g" /* updateOutgoingQuote */],
              close: this.closeEditModal
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "table",
            { className: "table table-condensed" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tbody",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Customer Code"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  outgoingQuote.getIn(["company", "code"])
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Customer Name"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  outgoingQuote.getIn(["company", "id"]) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["w" /* CompanyName */], { company: outgoingQuote.toJS().company }) : outgoingQuote.get("legacy_company_name") + " (LEGACY)"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Customer Phone"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  outgoingQuote.getIn(["company", "phone"])
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "table",
            { className: "table table-condensed" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tbody",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Customer Contact"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  outgoingQuote.getIn(["contact", "name"])
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Customer Email"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "a",
                    {
                      href: "mailto:" + outgoingQuote.getIn(["contact", "email"]),
                      onClick: function onClick(e) {
                        return e.stopPropagation();
                      }
                    },
                    outgoingQuote.getIn(["contact", "email"])
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["z" /* AuditFields */], { record: outgoingQuote, multiLine: true })
        )
      );
    }
  }]);

  return DetailsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (DetailsTable);


DetailsTable.propTypes = {
  outgoingQuote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ExternalLink_ExternalLink__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* unused harmony export Download */







function Download(_ref) {
  var url = _ref.url;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "li",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ExternalLink_ExternalLink__["a" /* default */],
      { url: url },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "file-text-o", fixed: true }),
      "\xA0Download OQ"
    )
  );
}

Download.propTypes = {
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var withUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var outgoingQuote = _ref2.outgoingQuote;
  return {
    url: __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* API_BASE */] + "/outgoing_quotes/" + outgoingQuote.get(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]) + "/download"
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withUrl(Download));

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_ActionDropDown_ActionDropDown__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_RecordPager__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ConvertToSalesOrder_ConvertToSalesOrder__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Download_Download__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AutoFollowup_AutoFollowup__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Send__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ImportOutgoingQuote_ImportOutgoingQuote__ = __webpack_require__(1473);
/* harmony export (immutable) */ __webpack_exports__["a"] = Header;














function Header(_ref) {
  var outgoingQuote = _ref.outgoingQuote;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "page-header page-header-bar" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h1",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "with-padding" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_RecordPager__["a" /* default */], { baseUrl: "/outgoing-quotes", record: outgoingQuote }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "header-content" },
          outgoingQuote.get(__WEBPACK_IMPORTED_MODULE_7__constants__["z" /* CODE */])
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "small text-muted" },
          "Created ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(outgoingQuote.get(__WEBPACK_IMPORTED_MODULE_7__constants__["_7" /* CREATED_AT */]))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "btn-group pull-right", style: { marginLeft: 20 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_ActionDropDown_ActionDropDown__["a" /* default */],
            {
              menuClass: "dropdown-menu-right",
              style: { cursor: "pointer" }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Send__["a" /* default */], { quote: outgoingQuote }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__AutoFollowup_AutoFollowup__["a" /* default */], { quote: outgoingQuote.toJS() }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ConvertToSalesOrder_ConvertToSalesOrder__["a" /* default */], { quote: outgoingQuote.toJS() }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Download_Download__["a" /* default */], { outgoingQuote: outgoingQuote }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ImportOutgoingQuote_ImportOutgoingQuote__["a" /* default */], { outgoingQuote: outgoingQuote })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "pull-right" },
          "Total: ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(outgoingQuote.get("total"))
        )
      )
    )
  );
}

Header.propTypes = {
  outgoingQuote: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])
};

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IncomingQuotes_actions__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RepairQuotes_constants__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
















var formName = "importOQItems";

function Form(props) {
  var QUOTE_TYPES = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_removeKey__["b" /* removeKeys */])(__WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].quoteType, [__WEBPACK_IMPORTED_MODULE_13__RepairQuotes_constants__["e" /* AWAITING_REPLY */], __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["l" /* INCIDENT_RELATED */], __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["t" /* NOT_AWAITING_REPLY */], __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["q" /* MAKE_OFFER */], __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["m" /* OFFER */], __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["c" /* AS_IS */], __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["p" /* EXCHANGE_ONLY */]]);

  var FILES = {
    no_quote: "https://info-trader-assets.s3.us-east-2.amazonaws.com/public/No_Quote_Template.csv",
    standard: "https://info-trader-assets.s3.us-east-2.amazonaws.com/public/Blank_Standard_Outgoing_Quote_Template_v2.csv"
  };

  var WARNINGS = {
    no_quote: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      "Please use the following column header fields for the No Quote import:",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "part_number"
      ),
      " (required field).",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      "Ensure the import file is in .csv format."
    ),
    standard: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      "Please use the following column headers for the Standard Outgoing Quote import:",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "part_number"
      ),
      " (required field: unique identifier for the part).",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "serial_number"
      ),
      " (optional field).",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "description"
      ),
      " (optional field: only needed if part_number is new to the system).",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "cond"
      ),
      " (required field: acceptable codes: NE, OH, SV, BT, SV TOOLING, AR, BR).",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "qty"
      ),
      " (required field: quantity).",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "cost"
      ),
      " (optional field: can be 0 or left blank).",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "tag_date"
      ),
      " (optional field: can be left blank; date format is MM/DD/YYYY).",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "lead_time"
      ),
      " (optional field: can be 0 or blank).",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      "Ensure the import file is in .csv format."
    )
  };

  var fileLink = FILES[props.getFieldValue(__WEBPACK_IMPORTED_MODULE_11__constants__["f" /* QUOTE_TYPE */])];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Body,
      null,
      props.getFieldValue(__WEBPACK_IMPORTED_MODULE_11__constants__["f" /* QUOTE_TYPE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components__["n" /* Warning */],
          null,
          WARNINGS[props.getFieldValue(__WEBPACK_IMPORTED_MODULE_11__constants__["f" /* QUOTE_TYPE */])]
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_11__constants__["f" /* QUOTE_TYPE */],
            component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["c" /* Select */],
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_forms__["a" /* toOptions */])(QUOTE_TYPES),
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__constants__["f" /* QUOTE_TYPE */]),
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "file",
            component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["k" /* FileInput */],
            label: "Upload Attachment",
            required: true
          })
        )
      ),
      fileLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 8, mdOffset: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { href: fileLink, target: "_blank", rel: "noopener noreferrer" },
            "Template"
          )
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__IncomingQuotes_actions__["a" /* importOutgoingQuoteLineItems */])(data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["j" /* form */])({
  form: formName
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form__ = __webpack_require__(1472);
/* harmony export (immutable) */ __webpack_exports__["a"] = ImportOutgoingQuote;







function ImportOutgoingQuote(_ref) {
  var outgoingQuote = _ref.outgoingQuote;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components__["l" /* DropDownItem */],
        { onClick: open },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "shopping-cart", fixed: true }),
        "\xA0Import Outgoing Quote",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
          { open: visible, close: close, dialogClass: "modal-sm" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Import Outgoing Quote"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Form__["a" /* default */], {
            close: close,
            enableReinitialize: true,
            outgoingQuote: outgoingQuote
          })
        )
      );
    }
  );
}

ImportOutgoingQuote.propTypes = {
  outgoingQuote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmDelete__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);







function Controls(_ref) {
  var deleteItem = _ref.deleteItem;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["c" /* ImprovedDropDown */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
      id: "delete",
      label: "Delete",
      faIcon: "ban",
      renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmDelete__["a" /* default */], { onConfirm: deleteItem })
    })
  );
}

Controls.propTypes = {
  deleteItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(undefined, function (dispatch, _ref2) {
  var id = _ref2.lineItem.id;
  return {
    deleteItem: function deleteItem() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["f" /* deleteOutgoingQuoteLineItem */])(id));
    }
  };
})(Controls));

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(1477);
/* harmony export (immutable) */ __webpack_exports__["a"] = New;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





function New(_ref) {
  var quote = _ref.quote;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["P" /* LaunchModal */], {
    modal: function modal(props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modal__["a" /* default */], _extends({}, props, { quote: quote }));
    },
    buttonClass: "btn-primary btn-hollow pull-right",
    text: "Add Parts To Quote"
  });
}

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_Total__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_PartDetails__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_OutgoingQuoteTypeSelect__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_warnings__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__parts_components_Detail_OutgoingQuotes_LineItemsTable__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_time__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_SelectInventoryTable__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SalesOrders_components_ConvertFromCartForm_Warnings__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__shared_helpers__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__parts_components_Detail_SalesOrders_Table__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__parts_components_shared_PartHazmatWarning__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__companies_shared_components_DoNotExchangeWarning__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__companies_shared_components_RestrictedEntityWarning__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__validate__ = __webpack_require__(1478);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







































var formName = "partDetailNewOutgoingQuote";

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      contacts: [],
      companyPartHistory: {},
      outgoingQuotes: [],
      quantityChanged: false,
      inventoryPrice: null,
      recentSOs: [],
      selectedInventories: [],
      selectedPart: null
    }, _this.setWarrantyField = function (val) {
      _this.props.change(__WEBPACK_IMPORTED_MODULE_16__constants__["g" /* WARRANTY */], val);
    }, _this.copyInventoryFields = function (inventory) {
      return Object.keys(__WEBPACK_IMPORTED_MODULE_8__shared_PartDetails__["d" /* copyFromInventoryFields */]).forEach(function (field) {
        return _this.props.change(field, __WEBPACK_IMPORTED_MODULE_8__shared_PartDetails__["d" /* copyFromInventoryFields */][field](inventory, _this.props.quoteType, _this.state.selectedPart, _this.props.canExchange && !_this.props.quote.getIn([__WEBPACK_IMPORTED_MODULE_21__PurchaseOrders_constants__["K" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_29__companies_constants__["k" /* DO_NOT_EXCHANGE */]])));
      });
    }, _this.clearFieldsCopiedFromInventory = function () {
      Object.keys(__WEBPACK_IMPORTED_MODULE_8__shared_PartDetails__["d" /* copyFromInventoryFields */]).forEach(function (field) {
        if (field === __WEBPACK_IMPORTED_MODULE_16__constants__["g" /* WARRANTY */] && _this.props.quoteType === __WEBPACK_IMPORTED_MODULE_16__constants__["n" /* AS_IS */]) {
          _this.props.change(field, "No Warranty, unit sold as-is.");
        } else {
          _this.props.change(field, null);
        }
      });

      [__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["I" /* EASA */]].forEach(function (f) {
        return _this.props.change(f, true);
      });
    }, _this.handleInventorySelected = function (inventory) {
      var inventoryIds = _this.props.inventoryIds;
      var selectedInventories = _this.state.selectedInventories;

      if (inventory === null) {
        _this.props.change(__WEBPACK_IMPORTED_MODULE_16__constants__["p" /* INVENTORY_IDS */], []);
        _this.props.change(__WEBPACK_IMPORTED_MODULE_20__constants__["_21" /* INVENTORY_ID */], null);
        _this.clearFieldsCopiedFromInventory();
        return;
      }

      if (inventoryIds.includes(inventory.id)) {
        var index = inventoryIds.indexOf(inventory.id);
        _this.setState({
          selectedInventories: selectedInventories.filter(function (i) {
            return i.id !== inventory.id;
          })
        });
        inventoryIds.splice(index, 1);
        _this.props.change(__WEBPACK_IMPORTED_MODULE_16__constants__["p" /* INVENTORY_IDS */], inventoryIds);
      } else {
        inventoryIds.push(inventory.id);
        _this.setState({
          selectedInventories: selectedInventories.concat([inventory])
        });
        _this.props.change(__WEBPACK_IMPORTED_MODULE_16__constants__["p" /* INVENTORY_IDS */], inventoryIds);
        if (_this.state.inventory !== inventory && inventoryIds.length === 1) {
          _this.copyInventoryFields(inventory);
          __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].inventories.show(inventory.id).then(function (res) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__shared_helpers__["a" /* handleRepairItem */])({
              change: _this.props.change,
              inventoryDetails: res.data,
              getNameFromSection: function getNameFromSection(field) {
                return field;
              }
            });
          });
        }

        if (inventoryIds.length > 1) {
          _this.clearFieldsCopiedFromInventory();
        }
      }
      _this.setState({ quantityChanged: false });
      _this.setState({ inventoryPrice: inventory && inventory.suggested_retail });
    }, _this.handlePartSelected = function (part) {
      _this.setState({ selectedPart: part });
      if (part) {
        _this.props.searchOutgoingQuoteLineItems(part.id).then(function (resp) {
          _this.setState({ outgoingQuotes: resp });
        });

        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].companies.parts.history(_this.props.companyId, [part.id]).then(function (_ref2) {
          var data = _ref2.data;

          _this.setState({
            companyPartHistory: data.results[0] || {}
          });
        });

        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].parts.salesOrderLineItems.search(part.id, { limit: 5 }).then(function (_ref3) {
          var recentSOs = _ref3.data.results;

          _this.setState({ recentSOs: recentSOs });
        });

        if (part.pass_fail) {
          _this.props.change(__WEBPACK_IMPORTED_MODULE_16__constants__["a" /* EXCHANGE_FEE */], "");
          if ([__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["i" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["h" /* REPAIRED */]].includes(_this.props.getFieldValue(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["n" /* CONDITION */]))) {
            _this.props.change(__WEBPACK_IMPORTED_MODULE_16__constants__["g" /* WARRANTY */], "30 days");
          }
        }

        if (part.hazmat) {
          _this.props.change(__WEBPACK_IMPORTED_MODULE_21__PurchaseOrders_constants__["z" /* HAZMAT_FEE */], _this.props.defaultHazmatFee);
        }

        if (part[__WEBPACK_IMPORTED_MODULE_32__parts_constants__["V" /* PERMANENT_EXTERNAL_NOTE_FOR_OQ */]]) {
          _this.props.change(__WEBPACK_IMPORTED_MODULE_21__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */], part[__WEBPACK_IMPORTED_MODULE_32__parts_constants__["V" /* PERMANENT_EXTERNAL_NOTE_FOR_OQ */]]);
        }
      }
    }, _this.handleQuantityChanged = function () {
      if (!_this.state.quantityChanged) _this.props.change(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["o" /* SERIAL_NUMBER */], "");
      _this.setState({ quantityChanged: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "getInventoriesFilter",
    value: function getInventoriesFilter() {
      var quoteType = this.props.quoteType;


      var inventoriesFilter = {
        limit: "10",
        sellable_status: [__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["U" /* LIST */], __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["W" /* DO_NOT_LIST */]].join(",")
      };

      if (quoteType === __WEBPACK_IMPORTED_MODULE_25__IncomingQuotes_constants__["m" /* OFFER */]) {
        inventoriesFilter.or_in_condition = __WEBPACK_IMPORTED_MODULE_18__Receiving_constants__["g" /* BEYOND_ECON_REPAIR */];
      }

      return inventoriesFilter;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          canExchange = _props.canExchange,
          submitting = _props.submitting,
          companyId = _props.companyId,
          getFieldValue = _props.getFieldValue,
          setFieldValue = _props.setFieldValue,
          inventoryIds = _props.inventoryIds,
          quantity = _props.quantity,
          pricePerUnit = _props.pricePerUnit,
          quote = _props.quote,
          quoteType = _props.quoteType,
          _props$quoteTypes = _props.quoteTypes,
          quoteTypes = _props$quoteTypes === undefined ? __WEBPACK_IMPORTED_MODULE_16__constants__["c" /* OUTGOING_LINE_ITEMS */].quoteType : _props$quoteTypes;
      var _state = this.state,
          companyPartHistory = _state.companyPartHistory,
          outgoingQuotes = _state.outgoingQuotes,
          selectedPart = _state.selectedPart,
          selectedInventories = _state.selectedInventories;


      var mostRecentQuotes = outgoingQuotes.filter(function (q) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_time__["b" /* isLessThan36HoursAgo */])(q.created_at) && companyId === q.company_id;
      });

      var company = quote.get(__WEBPACK_IMPORTED_MODULE_21__PurchaseOrders_constants__["K" /* COMPANY */]).toJS();
      var inventoriesFilter = this.getInventoriesFilter();
      var isBERMaterialSelected = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.some(selectedInventories, function (item) {
        return item.condition === __WEBPACK_IMPORTED_MODULE_18__Receiving_constants__["g" /* BEYOND_ECON_REPAIR */];
      });
      var disablePartFields = {
        price_per_unit: isBERMaterialSelected && getFieldValue(__WEBPACK_IMPORTED_MODULE_25__IncomingQuotes_constants__["m" /* OFFER */]) === __WEBPACK_IMPORTED_MODULE_16__constants__["r" /* NO_INTEREST */],
        exchange_fee: isBERMaterialSelected || company[__WEBPACK_IMPORTED_MODULE_29__companies_constants__["k" /* DO_NOT_EXCHANGE */]]
      };
      var altOptions = selectedPart ? selectedPart.alternates.map(function (a) {
        return {
          value: a.id,
          text: a.name
        };
      }) : [];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
        _extends({}, this.props, { submitting: submitting }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__SalesOrders_components_ConvertFromCartForm_Warnings__["a" /* NoPmaNoDerWarning */], {
            company: company,
            inventories: selectedInventories
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__SalesOrders_components_ConvertFromCartForm_Warnings__["b" /* TraceTypeWarning */], {
            company: company,
            inventories: selectedInventories
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__SalesOrders_components_ConvertFromCartForm_Warnings__["d" /* WarrantyMinimumWarning */], {
            company: company,
            lineItems: [{ warranty: getFieldValue(__WEBPACK_IMPORTED_MODULE_16__constants__["g" /* WARRANTY */]) }]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__SalesOrders_components_ConvertFromCartForm_Warnings__["c" /* StrictTraceWarning */], {
            inventories: selectedInventories,
            company: company
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__companies_shared_components_DoNotExchangeWarning__["a" /* default */], { company: company }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__companies_shared_components_RestrictedEntityWarning__["a" /* default */], { company: company }),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared_warnings__["a" /* default */])(mostRecentQuotes, companyPartHistory),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["e" /* Col */],
              { md: 8 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: "row row-col-gutters-half",
                  style: { marginTop: "26px" }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Fields"], {
                    names: [__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_20__constants__["_21" /* INVENTORY_ID */], __WEBPACK_IMPORTED_MODULE_16__constants__["b" /* PRICE_PER_UNIT */], __WEBPACK_IMPORTED_MODULE_20__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["p" /* TAGGED_BY */], __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["x" /* TAG_DATE */], __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["E" /* TRACE_TYPE */], __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["F" /* TRACED_TO */], __WEBPACK_IMPORTED_MODULE_16__constants__["a" /* EXCHANGE_FEE */], __WEBPACK_IMPORTED_MODULE_16__constants__["g" /* WARRANTY */]],
                    component: __WEBPACK_IMPORTED_MODULE_9__shared_OutgoingQuoteTypeSelect__["a" /* default */],
                    quoteTypes: quoteTypes
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                      autoFocus: true,
                      name: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["q" /* PART_ID */],
                      label: "Part #",
                      placeholder: "Type a part's name of ID number...",
                      component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["n" /* AutoCompleteField */],
                      search: this.props.searchParts,
                      formatItem: function formatItem(result) {
                        return result && result.part_number;
                      },
                      selectedItem: selectedPart,
                      onItemSelected: function onItemSelected(i) {
                        return i && _this2.handlePartSelected(i);
                      },
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_16__constants__["s" /* SELL_AS_ALT_ID */],
                      component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["c" /* Select */],
                      label: "Quote as Alt",
                      options: altOptions
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Select From Inventory"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__shared_SelectInventoryTable__["a" /* default */], {
                  key: quoteType,
                  filter: inventoriesFilter,
                  part: selectedPart,
                  inventoryIds: inventoryIds,
                  onInventorySelected: this.handleInventorySelected
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm hr-dashed" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Most Recent Sales Orders"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__parts_components_Detail_SalesOrders_Table__["b" /* Table */], { results: this.state.recentSOs, disableRowNav: true }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Most Recent Outgoing Quotes"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__parts_components_Detail_OutgoingQuotes_LineItemsTable__["a" /* LineItemsTable */], { results: outgoingQuotes, disableRowNav: true }),
              quoteType !== __WEBPACK_IMPORTED_MODULE_16__constants__["h" /* NO_QUOTE */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  null,
                  "Part Details"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8__shared_PartDetails__["b" /* default */],
                  {
                    canExchange: canExchange,
                    formName: formName,
                    getFieldValue: getFieldValue,
                    setFieldValue: setFieldValue,
                    quoteType: quoteType,
                    setWarrantyField: this.setWarrantyField,
                    handleQuantityChanged: this.handleQuantityChanged,
                    inventoryIds: inventoryIds,
                    selectedInventories: selectedInventories,
                    passFail: selectedPart && selectedPart.pass_fail,
                    resetFields: function resetFields() {},
                    part: selectedPart,
                    disabled: disablePartFields
                  },
                  __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedPart, __WEBPACK_IMPORTED_MODULE_32__parts_constants__["h" /* HAZMAT */]) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__parts_components_shared_PartHazmatWarning__["a" /* default */], {
                    hazmat: selectedPart.hazmat,
                    hazmatFee: getFieldValue(__WEBPACK_IMPORTED_MODULE_21__PurchaseOrders_constants__["z" /* HAZMAT_FEE */])
                  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_19__shared_components_Forms_FormRow__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["e" /* Col */],
                      { md: 4 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "form-group" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                          name: __WEBPACK_IMPORTED_MODULE_21__PurchaseOrders_constants__["z" /* HAZMAT_FEE */],
                          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_21__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]),
                          component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                          type: "number",
                          step: 0.01,
                          onBlur: function onBlur(ev, val) {
                            ev.preventDefault();
                            setFieldValue(__WEBPACK_IMPORTED_MODULE_21__PurchaseOrders_constants__["z" /* HAZMAT_FEE */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__lib_formatters_number__["d" /* decimalField */])(val));
                          }
                        })
                      )
                    ),
                    quoteType === __WEBPACK_IMPORTED_MODULE_16__constants__["j" /* EXCHANGE_ONLY */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["e" /* Col */],
                      { md: 4 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_33__RepairOrders_constants__["e" /* CORE_DUE_DAYS */]),
                        name: __WEBPACK_IMPORTED_MODULE_33__RepairOrders_constants__["e" /* CORE_DUE_DAYS */],
                        type: "number",
                        step: 1,
                        component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */]
                      })
                    )
                  )],
                  !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedPart, __WEBPACK_IMPORTED_MODULE_32__parts_constants__["h" /* HAZMAT */]) && quoteType === __WEBPACK_IMPORTED_MODULE_16__constants__["j" /* EXCHANGE_ONLY */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_19__shared_components_Forms_FormRow__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["e" /* Col */],
                      { md: 4 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_33__RepairOrders_constants__["e" /* CORE_DUE_DAYS */]),
                        name: __WEBPACK_IMPORTED_MODULE_33__RepairOrders_constants__["e" /* CORE_DUE_DAYS */],
                        type: "number",
                        step: 1,
                        component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */]
                      })
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
              " ",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_19__shared_components_Forms_FormRow__["a" /* default */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["e" /* Col */],
                    { md: 6 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_21__PurchaseOrders_constants__["G" /* INTERNAL_NOTE */],
                      rows: 5,
                      cols: 50,
                      required: getFieldValue(__WEBPACK_IMPORTED_MODULE_16__constants__["d" /* FOLLOW_UP_FEEDBACK */]) === __WEBPACK_IMPORTED_MODULE_24__shared_constants__["d" /* OTHER */],
                      component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["l" /* TextArea */],
                      label: "Internal Note (Applied to the line item)"
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["e" /* Col */],
                    { md: 6 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_21__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */],
                      rows: 5,
                      cols: 50,
                      component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["l" /* TextArea */],
                      label: "External Note (*visible to Customer*)"
                    })
                  )
                )
              ),
              " "
            ),
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_22_react_bootstrap__["e" /* Col */],
              { md: 4 },
              selectedPart && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_Total__["a" /* default */], {
                part: selectedPart,
                quantity: quantity,
                pricePerUnit: pricePerUnit
              })
            )
          ),
          " "
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  pricePerUnit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  quoteType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  quoteTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  searchParts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchOutgoingQuoteLineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  change: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  companyId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  inventoryIds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number)
};
var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    canExchange: state.session.getIn([__WEBPACK_IMPORTED_MODULE_20__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_20__constants__["_35" /* CAN_EXCHANGE */]]),
    defaultHazmatFee: state.session.getIn([__WEBPACK_IMPORTED_MODULE_20__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_20__constants__["_34" /* DEFAULT_HAZMAT_FEE */]]),
    getFieldValue: function getFieldValue(field) {
      return selector(state, field);
    },
    inventoryIds: selector(state, __WEBPACK_IMPORTED_MODULE_16__constants__["p" /* INVENTORY_IDS */]),
    quantity: selector(state, __WEBPACK_IMPORTED_MODULE_20__constants__["j" /* QUANTITY */]),
    pricePerUnit: selector(state, __WEBPACK_IMPORTED_MODULE_16__constants__["b" /* PRICE_PER_UNIT */]),
    quoteType: selector(state, __WEBPACK_IMPORTED_MODULE_16__constants__["f" /* QUOTE_TYPE */]),
    companyId: state.outgoingQuoteDetail.getIn(["outgoingQuote", __WEBPACK_IMPORTED_MODULE_20__constants__["N" /* COMPANY_ID */]])
  };
}, function (dispatch) {
  return {
    searchParts: function searchParts(filter) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__parts_actions__["n" /* searchParts */])(filter));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["change"])(formName, field, val));
      };
    },
    searchOutgoingQuoteLineItems: function searchOutgoingQuoteLineItems(partId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__parts_actions__["r" /* searchOutgoingQuoteLineItems */])(partId));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_35__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(1476);








function Modal(_ref) {
  var open = _ref.open,
      close = _ref.close,
      onSubmit = _ref.onSubmit,
      quote = _ref.quote;

  var initialValues = {
    quote_type: __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* STANDARD */],
    inventory_ids: [],
    faa: true,
    easa: true
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Add a Part"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Form__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      onSubmit: onSubmit,
      quote: quote
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* createOutgoingQuoteLineItem */])(data));
    }
  };
})(Modal));

Modal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  quote: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Map)
};

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RepairOrders_constants__ = __webpack_require__(28);
/* unused harmony export validateLineItem */
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;










function validateLineItem(lineItem, values) {
  var fieldPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var props = arguments[3];

  var getFieldVal = function getFieldVal(field) {
    return fieldPrefix ? values[fieldPrefix][field] : values[field];
  };

  var quoteType = getFieldVal(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* QUOTE_TYPE */]);

  var inventoryIds = fieldPrefix ? values[fieldPrefix].inventory_ids : values.inventory_ids;

  if (quoteType !== __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* NO_QUOTE */] && (!inventoryIds || inventoryIds && inventoryIds.length <= 1)) {
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["f" /* isGreaterThan */](0));
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["n" /* CONDITION */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
  }

  var company = props.quote.get(__WEBPACK_IMPORTED_MODULE_6__PurchaseOrders_constants__["K" /* COMPANY */]).toJS();

  if (company[__WEBPACK_IMPORTED_MODULE_7__companies_constants__["k" /* DO_NOT_EXCHANGE */]] && quoteType === __WEBPACK_IMPORTED_MODULE_1__constants__["j" /* EXCHANGE_ONLY */]) {
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* QUOTE_TYPE */]).satisfies(function () {
      return "The Company is flagged with a do not exchange restriction";
    });
  }

  if (quoteType === __WEBPACK_IMPORTED_MODULE_1__constants__["j" /* EXCHANGE_ONLY */] && !company[__WEBPACK_IMPORTED_MODULE_7__companies_constants__["k" /* DO_NOT_EXCHANGE */]]) {
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* EXCHANGE_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["f" /* isGreaterThan */](0), __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_8__RepairOrders_constants__["e" /* CORE_DUE_DAYS */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0), __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["k" /* isLessThanOrEqualTo */](100));
  }

  if (!__WEBPACK_IMPORTED_MODULE_1__constants__["w" /* PRICE_PER_UNIT_OPTIONAL_QUOTE_TYPES */].includes(quoteType) && ![__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* NO_INTEREST */], __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* LOOKING_FOR */]].some(function (f) {
    return values[f];
  })) {
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* PRICE_PER_UNIT */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
  }

  if (getFieldVal(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FOLLOW_UP_FEEDBACK */]) === __WEBPACK_IMPORTED_MODULE_5__shared_constants__["d" /* OTHER */]) {
    lineItem.validate(__WEBPACK_IMPORTED_MODULE_5__shared_constants__["c" /* INTERNAL_NOTE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
  }
}

function validate(values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["q" /* PART_ID */], __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* QUOTE_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    validateLineItem(form, values, null, props);
  });
}

/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_LineItemStatusCell__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parts_components_ModifiedFlag__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_OutgoingQuoteNote__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_LookingForFlags__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Create_Create__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_Parts_EditPart__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Controls__ = __webpack_require__(1474);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var InventoryLink = function InventoryLink(_ref) {
  var lineItem = _ref.lineItem;

  var foundInventoryUUID = lineItem.getIn([__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_11__constants__["c" /* UUID */]]);
  var foundInventoryId = lineItem.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_21" /* INVENTORY_ID */]);
  var serial = lineItem.getIn([__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["o" /* SERIAL_NUMBER */]]) || lineItem.get(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["o" /* SERIAL_NUMBER */]);

  if (foundInventoryUUID || foundInventoryId) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          to: "/inventories/" + (foundInventoryUUID || foundInventoryId)
        },
        serial
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    null,
    serial
  );
};

var LineItemsTable = function (_Component) {
  _inherits(LineItemsTable, _Component);

  function LineItemsTable() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, LineItemsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = LineItemsTable.__proto__ || Object.getPrototypeOf(LineItemsTable)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      editModalOpen: false,
      selectedLineItem: null
    }, _this.openModal = function (lineItem) {
      return _this.setState({ editModalOpen: true, selectedLineItem: lineItem });
    }, _this.closeModal = function () {
      return _this.setState({ editModalOpen: false });
    }, _this.renderRow = function (lineItem, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        {
          key: lineItem.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */]),
          className: "clickable",
          onClick: function onClick() {
            return _this.openModal(lineItem);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          i + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_LineItemStatusCell__["a" /* default */],
          { lineItem: lineItem.toJS() },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["h" /* PartNumber */], { part: lineItem.toJS().part, showClipBoard: true })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InventoryLink, { lineItem: lineItem }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.get("sell_as_alt") && (lineItem.getIn(["sell_as_alt", "alternate_part_id"]) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["h" /* PartNumber */], {
            part: {
              id: lineItem.getIn(["sell_as_alt", "alternate_part_id"]),
              part_number: lineItem.getIn(["sell_as_alt", "name"])
            }
          }) : lineItem.getIn(["sell_as_alt", "name"]))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-center" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["o" /* LocationFlag */], {
              location: lineItem.getIn([__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["_27" /* STORE_LOCATION_ID */]])
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* OUTGOING_LINE_ITEMS */].quoteType[lineItem.get(__WEBPACK_IMPORTED_MODULE_5__constants__["f" /* QUOTE_TYPE */])].label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.get(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["E" /* TRACE_TYPE */]) && __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* OUTGOING_LINE_ITEMS */].traceTypes[lineItem.get(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["E" /* TRACE_TYPE */])].label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.get(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["F" /* TRACED_TO */])
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__["d" /* alphaMonthYear */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["x" /* TAG_DATE */]))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.get(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["p" /* TAGGED_BY */])
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: __WEBPACK_IMPORTED_MODULE_8__parts_components_ModifiedFlag__["a" /* columnStyle */].flagColumn },
          lineItem.getIn([__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["_2" /* MODIFIED */]]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__parts_components_ModifiedFlag__["b" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: __WEBPACK_IMPORTED_MODULE_8__parts_components_ModifiedFlag__["a" /* columnStyle */].conditionColumn },
          lineItem.get(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["n" /* CONDITION */]) && __WEBPACK_IMPORTED_MODULE_11__constants__["_27" /* CONDITIONS_WITH_SERVICEABLE */][lineItem.get(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["n" /* CONDITION */])].label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.get(__WEBPACK_IMPORTED_MODULE_11__constants__["j" /* QUANTITY */])
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right padding-right-zero" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_LookingForFlags__["a" /* LookingForFlags */], { lineItem: lineItem.toJS() }),
          lineItem.get(__WEBPACK_IMPORTED_MODULE_5__constants__["e" /* LOOKING_FOR */]) && lineItem.get(__WEBPACK_IMPORTED_MODULE_5__constants__["r" /* NO_INTEREST */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            null,
            "\xA0"
          ),
          lineItem.get(__WEBPACK_IMPORTED_MODULE_5__constants__["r" /* NO_INTEREST */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["F" /* IconText */], { text: "NI", note: __WEBPACK_IMPORTED_MODULE_5__constants__["r" /* NO_INTEREST */] })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center padding-left-zero" },
          lineItem.get(__WEBPACK_IMPORTED_MODULE_5__constants__["f" /* QUOTE_TYPE */]) === __WEBPACK_IMPORTED_MODULE_14__IncomingQuotes_constants__["p" /* EXCHANGE_ONLY */] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* EXCHANGE_FEE */])) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* PRICE_PER_UNIT */]))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_49" /* SUBTOTAL */]))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_OutgoingQuoteNote__["a" /* default */], { lineItem: lineItem.toJS() }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Controls__["a" /* default */], { lineItem: lineItem.toJS() })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LineItemsTable, [{
    key: "render",
    value: function render() {
      var quote = this.props.quote;
      var _state = this.state,
          editModalOpen = _state.editModalOpen,
          selectedLineItem = _state.selectedLineItem;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          { style: { marginTop: 26 } },
          "Parts",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_Parts_EditPart__["a" /* default */], {
            id: quote.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */]),
            open: editModalOpen,
            close: this.closeModal,
            quote: quote,
            selectedLineItem: selectedLineItem
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Create_Create__["a" /* default */], { quote: quote })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "table",
          { className: "table table-striped table-hover table-numbered" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Part #"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Serial Number"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Quote as Alt"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_13__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-center" },
                  "Store Loc"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Quote Type"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Trace Type"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Trace To"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Tag Date"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Tagged By"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Condition"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "QTY"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-right" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "Price Per Unit"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "Subtotal"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "\xA0"
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tbody",
            null,
            quote.get("outgoing_quote_line_items", []).map(this.renderRow),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              { style: { backgroundColor: "transparent" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                { className: "text-right", colSpan: 17 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  { className: "margin-top-none margin-bottom-none" },
                  "Total: ",
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(quote.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_71" /* TOTAL */]))
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LineItemsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LineItemsTable.propTypes = {
  quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    outgoing_quote_line_items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
      quote_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
      dom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }))
  }).isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (LineItemsTable);

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Attachments_Attachments__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Notes_Notes__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LineItems_LineItemsTable__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DetailsTable__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Header__ = __webpack_require__(1471);
/* unused harmony export Detail */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var legacyWarning = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  "div",
  { className: "alert alert-danger" },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "strong",
    null,
    "Legacy Quote"
  ),
  " Company and contact must be assigned"
);

var Detail = function (_Component) {
  _inherits(Detail, _Component);

  function Detail() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Detail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Detail.__proto__ || Object.getPrototypeOf(Detail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editPartModalOpen: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Detail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.expire();
    }
  }, {
    key: "render",
    value: function render() {
      var outgoingQuote = this.props.outgoingQuote;

      var showLegacyWarning = !outgoingQuote.get("company") || !outgoingQuote.get("contact");

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Header__["a" /* default */], { outgoingQuote: outgoingQuote }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "col-md-3" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__DetailsTable__["a" /* default */], { outgoingQuote: outgoingQuote })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "col-md-9" },
            showLegacyWarning && legacyWarning,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LineItems_LineItemsTable__["a" /* default */], { quote: outgoingQuote }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Notes_Notes__["a" /* default */], {
              resource: outgoingQuote,
              resourceType: __WEBPACK_IMPORTED_MODULE_5__shared_types_resourceTypes__["a" /* default */].outgoingQuote,
              resourceKey: "outgoingQuote",
              headerLabel: "Internal Notes",
              notesType: "internal"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Notes_Notes__["a" /* default */], {
              resource: outgoingQuote,
              resourceType: __WEBPACK_IMPORTED_MODULE_5__shared_types_resourceTypes__["a" /* default */].outgoingQuote,
              resourceKey: "outgoingQuote",
              headerLabel: "External Notes",
              notesType: "external"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Attachments_Attachments__["a" /* default */], {
              resource: outgoingQuote,
              resourceType: __WEBPACK_IMPORTED_MODULE_5__shared_types_resourceTypes__["a" /* default */].outgoingQuote,
              resourceKey: "outgoingQuote",
              multiple: true,
              attachmentTypes: __WEBPACK_IMPORTED_MODULE_8__constants__["H" /* ATTACHMENT_TYPES */]
            })
          )
        )
      );
    }
  }]);

  return Detail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Detail.propTypes = {
  outgoingQuote: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  expire: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    outgoingQuote: state.outgoingQuoteDetail.get("outgoingQuote")
  };
}, function (dispatch) {
  return {
    expire: function expire() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_9__actions__["b" /* pageActions */].expire());
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["h" /* loadRecord */])({
  reducer: "outgoingQuoteDetail",
  name: "outgoingQuote",
  action: __WEBPACK_IMPORTED_MODULE_9__actions__["c" /* show */]
})(Detail)));

/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Form__ = __webpack_require__(662);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














var excludedQuoteTypes = ["awaiting_info_to_complete", "offer"];

function filteredLineItems(quote) {
  return quote.get("outgoing_quote_line_items").toJS().filter(function (i) {
    return !excludedQuoteTypes.includes(i.quote_type);
  });
}

function Send(_ref) {
  var quote = _ref.quote,
      currentUser = _ref.currentUser;

  var disabled = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_9__users_constants__["k" /* SALES */]) || quote.get(__WEBPACK_IMPORTED_MODULE_10__constants__["_38" /* CANCELLED */]) || quote.get(__WEBPACK_IMPORTED_MODULE_10__constants__["_26" /* RECEIVED */]) || filteredLineItems(quote).length <= 0;

  var title = "Send" + (quote.get(__WEBPACK_IMPORTED_MODULE_10__constants__["_72" /* SENT_EMAIL */]) ? " Follow-up" : "") + " Outgoing Quote";

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__["a" /* default */],
        { onClick: open, disabled: disabled },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: "envelope-o", fixed: true }),
        "\xA0",
        title,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["a" /* Modal */],
          { open: visible, close: close, dialogClass: "modal-lg" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["c" /* Close */], { close: close }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              title
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Form__["a" /* default */], { close: close, quote: quote, currentUser: currentUser })
        )
      );
    }
  );
}

Send.propTypes = _extends({
  quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
}, __WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__["b" /* default */])(Send));

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Send__ = __webpack_require__(1481);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Send__["a"]; });


/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_DateRangePicker_DateRangePicker__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Table__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pagination__ = __webpack_require__(435);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





















var defaultFilters = {
  current_user: undefined,
  no_quote: undefined,
  offer: undefined,
  looking_for: undefined,
  no_interest: undefined,
  standard: undefined,
  as_is: undefined,
  make_offer: undefined,
  awaiting_info_to_complete: undefined,
  exchange_only: undefined,
  after_hours_aog: undefined,
  sellable_quantity: undefined
};

var defaultFiltersbyAllOffer = {
  no_quote: undefined,
  offer: undefined,
  looking_for: undefined,
  no_interest: undefined
};
var filters = [{
  label: "My Outgoing Quotes",
  filters: _extends({}, defaultFilters, { current_user: true })
}, {
  label: "All No Quotes",
  filters: _extends({}, defaultFilters, { no_quote: true })
}, {
  label: "All Offers",
  filters: _extends({}, defaultFiltersbyAllOffer, {
    offer: true,
    looking_for: false,
    no_interest: false
  })
}, {
  label: "All Offers with Looking For",
  filters: { looking_for: true }
}, {
  label: "All Offers with No Interest",
  filters: { no_interest: true }
}, {
  label: "All Outgoing Quotes",
  filters: defaultFilters
}, {
  label: "Quote Type Standard",
  filters: { standard: true }
}, {
  label: "Quote Type As Is",
  filters: { as_is: true }
}, {
  label: "Quote Type Make Offer",
  filters: { make_offer: true }
}, {
  label: "Quote Type Awaiting Info to Complete",
  filters: { awaiting_info_to_complete: true }
}, {
  label: "Quote Type Exchange Only",
  filters: { exchange_only: true }
}, {
  label: "Quote Type After Hours AOG",
  filters: { after_hours_aog: true }
}, {
  label: "OQs with Internal Notes",
  filters: { has_internal_note: true }
}, {
  label: "All Followed Up On",
  filters: { followed_up: true }
}, {
  label: "Not Followed Up On",
  filters: { followed_up: false }
}, {
  label: "Sellable Quantity",
  filters: { sellable_quantity: true }
}, {
  label: "No Sellable Quantity",
  filters: { sellable_quantity: false }
}];

var filterTags = [{
  label: "OQs with Internal Notes",
  key: "has_internal_note"
}, {
  label: "Show My OQs",
  key: "current_user"
}, {
  label: "Show OQs - Offer",
  key: "offer"
}, {
  label: "Show OQs - No Quote",
  key: "no_quote"
}, {
  label: "Looking For",
  key: "looking_for",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "No Interest",
  key: "no_interest",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "All Followed Up On",
  key: "followed_up",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Followed Up On",
  key: "followed_up",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Quote Type Standard",
  key: "standard",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Quote Type As Is",
  key: "as_is",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Quote Type Make Offer",
  key: "make_offer",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Quote Type Awaiting Info to Complete",
  key: "awaiting_info_to_complete",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Quote Type Exchange Only",
  key: "exchange_only",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Quote Type After Hours AOG",
  key: "after_hours_aog",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Sellable Quantity",
  key: "sellable_quantity",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "No Sellable Quantity",
  key: "sellable_quantity",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(false)
}];

var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = searchProps.paginator.get("filters").toJS();
  var totalCount = searchProps.paginator.get("totalCount");

  params.total_count = totalCount;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        if (totalCount > __WEBPACK_IMPORTED_MODULE_14__users_constants__["_6" /* EXPORT_LIMIT */]) {
          __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].info("Processing Report.");
          __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].outgoingQuotes.export(params).then(function () {
            return __WEBPACK_IMPORTED_MODULE_11__lib_submission__["a" /* SUCCESS */];
          });
        } else {
          window.open(__WEBPACK_IMPORTED_MODULE_6__constants__["d" /* API_BASE */] + "/outgoing_quotes/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_query_string__["stringify"])(params), "_blank");
          __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].success("Processing Outgoing Quotes Report. Please wait for the PDF to generate.");
        }
      }
    },
    "Export"
  );
};

var meetsExportCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var searchProps = _ref2.searchProps;

  var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__hooks_useCurrentUser__["a" /* default */])();
  return searchProps.paginator.get("totalCount") <= __WEBPACK_IMPORTED_MODULE_14__users_constants__["_6" /* EXPORT_LIMIT */] || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__users_helpers__["d" /* hasRole */])(user, __WEBPACK_IMPORTED_MODULE_14__users_constants__["i" /* ADMIN */]);
});

var DecoratedExportButton = meetsExportCriteria(ExportButton);

function QuotesSearch(_ref3) {
  var pushHistory = _ref3.pushHistory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_18__pagination__["a" /* default */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a customer name, outgoing quote number, part number, buyer, seller or date created...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/outgoing-quotes/" + r.outgoing_quote_id);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DecoratedExportButton, { searchProps: searchProps }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components_DateRangePicker_DateRangePicker__["a" /* default */], searchProps),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, { filters: filters, right: true }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "Outgoing Quotes",
          filters: filterTags
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

QuotesSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(QuotesSearch));

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parts_components_HoverFlag__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_UpdatedTrackedFieldsAt_UpdatedTrackedFieldsAt__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_LookingForFlags__ = __webpack_require__(320);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
















function renderRow(r, pushHistory) {
  var handleMailto = function handleMailto(e) {
    e.stopPropagation();
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: r.id,
      className: "clickable",
      onClick: function onClick() {
        return pushHistory("/outgoing-quotes/" + r.quote_uuid);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.quote_code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_UpdatedTrackedFieldsAt_UpdatedTrackedFieldsAt__["a" /* default */], { record: r })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.created_by && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["d" /* getFirstNameLastInitial */])(r.created_by.full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_9__constants__["c" /* OUTGOING_LINE_ITEMS */].quoteType[r.quote_type].label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["w" /* CompanyName */], { flattenedCompany: r, truncateAt: 16 })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["truncate"])(r.contact_name, 14)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        { href: "mailto:" + r.contact_email, onClick: handleMailto },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["truncate"])(r.contact_email, 12)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.serial_number && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["truncate"])(r.serial_number, 12)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["truncate"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["d" /* getFirstNameLastInitial */])(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(r, "buyer.full_name")), 14)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.part && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["h" /* PartNumber */], { part: r.part })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.condition && __WEBPACK_IMPORTED_MODULE_12__constants__["_27" /* CONDITIONS_WITH_SERVICEABLE */][r.condition].label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      r.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right padding-right-zero" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_LookingForFlags__["a" /* LookingForFlags */], { lineItem: r }),
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(r, "no_interest") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__parts_components_HoverFlag__["a" /* default */], { text: "No Interest", abbr: "NI", inline: true })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center padding-horizontal-zero" },
      r.quote_type === __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_constants__["p" /* EXCHANGE_ONLY */] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(r.exchange_fee) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(r.price_per_unit)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(r, "inventory_suggested_retail") && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(r.inventory_suggested_retail)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(r, "part.sellable_quantity")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      !__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(r.follow_up_feedback) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
        note: "Follow Up Feedback: " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(r.follow_up_feedback),
        color: "#f44336"
      })
    )
  );
}

function Table(_ref) {
  var pushHistory = _ref.pushHistory,
      isLoading = _ref.isLoading,
      pageActions = _ref.pageActions,
      results = _ref.results;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */],
    { loading: isLoading, refresh: pageActions.expire },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Quote #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Created By"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Type"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Customer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Contact"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Email"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial Number"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Buyer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Cond"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Qty"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-right" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Price Per Unit"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "SRP"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Sellable"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "FU"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_7__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(Table));

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_reducer__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__ = __webpack_require__(58);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  outgoingQuote: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
}).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["a" /* notesInitialState */]).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["b" /* attachmentsInitialState */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _extends(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* SET */], function (state, action) {
  return state.merge({ outgoingQuote: action.outgoingQuote });
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["c" /* createAttachmentReducer */])(__WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].outgoingQuote), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["d" /* createNoteReducer */])(__WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].outgoingQuote))));

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony export (immutable) */ __webpack_exports__["a"] = OfferFields;









var options = [{
  text: "None",
  value: ""
}, {
  text: "No Interest",
  value: "no_interest"
}, {
  text: "Looking For",
  value: __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* LOOKING_FOR */]
}];

function OfferFields(_ref) {
  var resetFields = _ref.resetFields,
      required = _ref.required,
      disabled = _ref.disabled;

  var onChange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (_, newValue) {
    if (newValue !== __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* LOOKING_FOR */]) {
      resetFields();
    }
  }, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { sm: 8, md: 8 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_5__constants__["q" /* OFFER */],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_5__constants__["q" /* OFFER */]),
          component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["m" /* RadioGroupField */],
          onChange: onChange,
          options: options,
          required: required,
          disabled: disabled
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
          {
            title: "Lock Outgoing Quote",
            info: "Outgoing Quote will be locked for 72 hours."
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_5__constants__["B" /* LOCKED */],
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_5__constants__["C" /* ASSIGN_TO_ME */])
          })
        )
      )
    )
  );
}

OfferFields.propTypes = {
  resetFields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Form__ = __webpack_require__(1488);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













function EditPart(_ref) {
  var _extends2;

  var open = _ref.open,
      close = _ref.close,
      onSubmit = _ref.onSubmit,
      quote = _ref.quote,
      selectedLineItem = _ref.selectedLineItem;

  var initialValues = !selectedLineItem ? {} : _extends((_extends2 = {}, _defineProperty(_extends2, __WEBPACK_IMPORTED_MODULE_7__constants__["z" /* HAS_FOLLOW_UP_FEEDBACK */], selectedLineItem.get(__WEBPACK_IMPORTED_MODULE_7__constants__["d" /* FOLLOW_UP_FEEDBACK */])), _defineProperty(_extends2, "part_id", selectedLineItem.getIn([__WEBPACK_IMPORTED_MODULE_9__parts_constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_8__constants__["b" /* ID */]])), _extends2), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_helpers__["m" /* transformOQInputValues */])(selectedLineItem.toJS()), {
    inventory_id: selectedLineItem.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_21" /* INVENTORY_ID */]) && selectedLineItem.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_21" /* INVENTORY_ID */]).toString(),
    include_dom: !!selectedLineItem.get(__WEBPACK_IMPORTED_MODULE_9__parts_constants__["G" /* DOM */])
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Part"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Form__["a" /* default */], {
      close: close,
      quote: quote,
      initialValues: initialValues,
      onSubmit: onSubmit,
      selectedLineItem: selectedLineItem && selectedLineItem.toJS()
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["e" /* updateOutgoingQuoteLineItem */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_helpers__["c" /* transformOQOutputValues */])(data), ownProps.selectedLineItem.get(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* ID */])));
    }
  };
})(EditPart));

EditPart.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  selectedLineItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])
};

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Total__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PartDetails__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OutgoingQuoteTypeSelect__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__inventories_components_shared_SelectInventoryTable__ = __webpack_require__(2120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_time__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ExistingQuoteWarning__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__parts_components_Detail_OutgoingQuotes_LineItemsTable__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__parts_components_Detail_SalesOrders_Table__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__parts_components_shared_PartHazmatWarning__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__companies_shared_components_DoNotExchangeWarning__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__inventories_helpers__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__companies_shared_components_RestrictedEntityWarning__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__validate__ = __webpack_require__(666);
/* unused harmony export Form */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







































var formName = "partDetailNewOutgoingQuote";

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedPart: _this.props.selectedLineItem && _this.props.selectedLineItem.part,
      outgoingQuotes: [],
      quantityChanged: false,
      recentSOs: [],
      selectedInventory: _this.props.selectedLineItem && _this.props.selectedLineItem.inventory
    }, _this.setWarrantyField = function (val) {
      _this.props.change(__WEBPACK_IMPORTED_MODULE_9__constants__["g" /* WARRANTY */], val);
    }, _this.getInventoriesFilter = function () {
      var quoteType = _this.props.quoteType;


      var inventoriesFilter = {
        sellable_status: [__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["U" /* LIST */], __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["W" /* DO_NOT_LIST */]].join(",")
      };

      if (quoteType === __WEBPACK_IMPORTED_MODULE_20__IncomingQuotes_constants__["m" /* OFFER */]) {
        inventoriesFilter.or_in_condition = __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__["g" /* BEYOND_ECON_REPAIR */];
      }

      return inventoriesFilter;
    }, _this.handleInventorySelected = function (inventory) {
      var defaultWarranty = inventory && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__PartDetails__["c" /* warrantyForCondition */])(inventory.condition, inventory.part, inventory.tag_date);

      if (inventory) {
        _this.setState({ selectedInventory: inventory });

        _this.props.change(__WEBPACK_IMPORTED_MODULE_18__constants__["_21" /* INVENTORY_ID */], inventory.id);
        Object.keys(__WEBPACK_IMPORTED_MODULE_11__PartDetails__["a" /* copyFromInventoryFieldsOnOQ */]).forEach(function (field) {
          return _this.props.change(field, __WEBPACK_IMPORTED_MODULE_11__PartDetails__["a" /* copyFromInventoryFieldsOnOQ */][field](inventory, _this.props.quoteType, _this.state.selectedPart, _this.props.canExchange));
        });

        if (!_this.props.getFieldValue(__WEBPACK_IMPORTED_MODULE_9__constants__["g" /* WARRANTY */])) {
          if ([__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["h" /* REPAIRED */], __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["P" /* INSPECTED */], __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["i" /* OVERHAULED */]].includes(inventory.condition)) {
            if (inventory.warranty_override) {
              _this.props.change(__WEBPACK_IMPORTED_MODULE_9__constants__["g" /* WARRANTY */], inventory.warranty_override);
            } else if (inventory.part.warranty_override) {
              _this.props.change(__WEBPACK_IMPORTED_MODULE_9__constants__["g" /* WARRANTY */], inventory.part.warranty_override);
            } else {
              _this.props.change(__WEBPACK_IMPORTED_MODULE_9__constants__["g" /* WARRANTY */], defaultWarranty);
            }
          } else if (inventory.condition === __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["g" /* NEW_ITEM */] && inventory.warranty_override) {
            _this.props.change(__WEBPACK_IMPORTED_MODULE_9__constants__["g" /* WARRANTY */], inventory.warranty_override);
          } else {
            _this.props.change(__WEBPACK_IMPORTED_MODULE_9__constants__["g" /* WARRANTY */], defaultWarranty);
          }
        }
      } else {
        _this.clearFieldsCopiedFromInventory();
      }

      _this.setState({ quantityChanged: false });
    }, _this.clearFieldsCopiedFromInventory = function () {
      Object.keys(__WEBPACK_IMPORTED_MODULE_11__PartDetails__["a" /* copyFromInventoryFieldsOnOQ */]).forEach(function (field) {
        if (field === __WEBPACK_IMPORTED_MODULE_9__constants__["g" /* WARRANTY */] && _this.props.quoteType === __WEBPACK_IMPORTED_MODULE_9__constants__["n" /* AS_IS */]) {
          _this.props.change(field, "No Warranty, unit sold as-is.");
        } else {
          _this.props.change(field, null);
        }
      });
      _this.props.change(__WEBPACK_IMPORTED_MODULE_18__constants__["_21" /* INVENTORY_ID */], null);

      [__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["I" /* EASA */]].forEach(function (f) {
        return _this.props.change(f, true);
      });
    }, _this.handlePartSelected = function (part) {
      _this.setState({ selectedPart: part });
      if (part) {
        _this.props.searchOutgoingQuoteLineItems(part.id).then(function (resp) {
          var outgoingQuotes = resp.filter(function (quote) {
            return !_this.props.selectedLineItem || _this.props.selectedLineItem.id !== quote.id;
          });
          _this.setState({ outgoingQuotes: outgoingQuotes });
        });

        __WEBPACK_IMPORTED_MODULE_24__api__["a" /* default */].parts.salesOrderLineItems.search(part.id, { limit: 5 }).then(function (_ref2) {
          var recentSOs = _ref2.data.results;

          _this.setState({ recentSOs: recentSOs });
        });

        if (part.pass_fail) {
          _this.props.change(__WEBPACK_IMPORTED_MODULE_9__constants__["a" /* EXCHANGE_FEE */], "");
          if ([__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["i" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["h" /* REPAIRED */]].includes(_this.props.getFieldValue(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["n" /* CONDITION */]))) {
            _this.props.change(__WEBPACK_IMPORTED_MODULE_9__constants__["g" /* WARRANTY */], "30 days");
          }
        }
      }
    }, _this.handleQuantityChanged = function () {
      if (_this.state.mounted) {
        if (!_this.state.quantityChanged) _this.props.change(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["o" /* SERIAL_NUMBER */], "");
        _this.setState({ quantityChanged: true });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.selectedLineItem && this.props.selectedLineItem.part) {
        this.handlePartSelected(this.props.selectedLineItem.part);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      /* eslint-disable */
      this.setState({ mounted: true });
      /* eslint-enable */
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState({ mounted: false });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          canExchange = _props.canExchange,
          company = _props.company,
          getFieldValue = _props.getFieldValue,
          resetFields = _props.resetFields,
          setFieldValue = _props.setFieldValue,
          quantity = _props.quantity,
          pricePerUnit = _props.pricePerUnit,
          quoteType = _props.quoteType,
          companyId = _props.companyId,
          selectedLineItem = _props.selectedLineItem,
          _props$quoteTypes = _props.quoteTypes,
          quoteTypes = _props$quoteTypes === undefined ? __WEBPACK_IMPORTED_MODULE_9__constants__["c" /* OUTGOING_LINE_ITEMS */].quoteType : _props$quoteTypes;
      var _state = this.state,
          outgoingQuotes = _state.outgoingQuotes,
          selectedPart = _state.selectedPart,
          selectedInventory = _state.selectedInventory;


      var recentQuotes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(outgoingQuotes).filter(function (quote) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_time__["b" /* isLessThan36HoursAgo */])(quote.get(__WEBPACK_IMPORTED_MODULE_18__constants__["_7" /* CREATED_AT */])) && companyId === quote.get(__WEBPACK_IMPORTED_MODULE_18__constants__["N" /* COMPANY_ID */]);
      });
      var altOptions = selectedPart ? selectedPart.alternates.map(function (a) {
        return {
          value: a.id,
          text: a.name
        };
      }) : [];
      var inventoriesFilter = this.getInventoriesFilter();
      var isBERMaterialSelected = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(selectedInventory, __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["n" /* CONDITION */]) === __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__["g" /* BEYOND_ECON_REPAIR */];
      var disablePartFields = {
        price_per_unit: isBERMaterialSelected && getFieldValue(__WEBPACK_IMPORTED_MODULE_20__IncomingQuotes_constants__["m" /* OFFER */]) === __WEBPACK_IMPORTED_MODULE_9__constants__["r" /* NO_INTEREST */],
        exchange_fee: isBERMaterialSelected || company[__WEBPACK_IMPORTED_MODULE_29__companies_constants__["k" /* DO_NOT_EXCHANGE */]]
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Body,
          null,
          recentQuotes.size > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ExistingQuoteWarning__["a" /* default */], { quote: recentQuotes.get(0) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__companies_shared_components_RestrictedEntityWarning__["a" /* default */], { company: company }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_21__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_25_react_bootstrap__["e" /* Col */],
              { md: 8 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: "row row-col-gutters-half",
                  style: { marginTop: "26px" }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_25_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Fields"], {
                    names: [__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_18__constants__["_21" /* INVENTORY_ID */], __WEBPACK_IMPORTED_MODULE_20__IncomingQuotes_constants__["m" /* OFFER */], __WEBPACK_IMPORTED_MODULE_9__constants__["b" /* PRICE_PER_UNIT */], __WEBPACK_IMPORTED_MODULE_18__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["p" /* TAGGED_BY */], __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["x" /* TAG_DATE */], __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["E" /* TRACE_TYPE */], __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["F" /* TRACED_TO */], __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* EXCHANGE_FEE */], __WEBPACK_IMPORTED_MODULE_9__constants__["g" /* WARRANTY */]],
                    component: __WEBPACK_IMPORTED_MODULE_12__OutgoingQuoteTypeSelect__["a" /* default */],
                    quoteTypes: quoteTypes
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_25_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["q" /* PART_ID */],
                      label: "Part #",
                      placeholder: "Type a part's name of ID number...",
                      component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["n" /* AutoCompleteField */],
                      search: this.props.searchParts,
                      formatItem: function formatItem(result) {
                        return result && result.part_number;
                      },
                      selectedItem: selectedPart,
                      onItemSelected: function onItemSelected(i) {
                        return i && _this2.handlePartSelected(i);
                      },
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_25_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_9__constants__["s" /* SELL_AS_ALT_ID */],
                      component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
                      label: "Quote as Alt",
                      options: altOptions
                    })
                  )
                )
              ),
              selectedPart && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  null,
                  "Select From Inventory"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__inventories_components_shared_SelectInventoryTable__["a" /* default */], {
                    key: quoteType,
                    filter: inventoriesFilter,
                    part: selectedPart,
                    selectedInventory: selectedLineItem && selectedLineItem.inventory,
                    onInventorySelected: this.handleInventorySelected
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  null,
                  "Most Recent Sales Orders"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__parts_components_Detail_SalesOrders_Table__["b" /* Table */], {
                  results: this.state.recentSOs,
                  disableRowNav: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  null,
                  "Most Recent Outgoing Quotes"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__parts_components_Detail_OutgoingQuotes_LineItemsTable__["a" /* LineItemsTable */], { results: outgoingQuotes, disableRowNav: true })
              ),
              quoteType !== __WEBPACK_IMPORTED_MODULE_9__constants__["h" /* NO_QUOTE */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__companies_shared_components_DoNotExchangeWarning__["a" /* default */], { company: company }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  null,
                  "Part Details"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11__PartDetails__["b" /* default */],
                  {
                    canExchange: canExchange,
                    formName: formName,
                    disableTagType: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(getFieldValue(__WEBPACK_IMPORTED_MODULE_18__constants__["_21" /* INVENTORY_ID */])),
                    getFieldValue: getFieldValue,
                    setFieldValue: setFieldValue,
                    selectedInventories: [selectedLineItem.inventory].filter(function (f) {
                      return f;
                    }),
                    part: selectedPart,
                    quoteType: quoteType,
                    setWarrantyField: this.setWarrantyField,
                    handleQuantityChanged: this.handleQuantityChanged,
                    passFail: selectedPart.pass_fail,
                    resetFields: resetFields,
                    disabled: disablePartFields
                  },
                  __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(selectedPart, __WEBPACK_IMPORTED_MODULE_32__parts_constants__["h" /* HAZMAT */]) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__parts_components_shared_PartHazmatWarning__["a" /* default */], {
                    hazmat: selectedPart.hazmat,
                    hazmatFee: getFieldValue(__WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["z" /* HAZMAT_FEE */])
                  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_21__shared_components_Forms_FormRow__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_25_react_bootstrap__["e" /* Col */],
                      { md: 4 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { className: "form-group" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                          name: __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["z" /* HAZMAT_FEE */],
                          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]),
                          component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                          type: "number",
                          step: 0.01,
                          onBlur: function onBlur(ev, val) {
                            ev.preventDefault();
                            setFieldValue(__WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["z" /* HAZMAT_FEE */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__lib_formatters_number__["d" /* decimalField */])(val));
                          }
                        })
                      )
                    ),
                    quoteType === __WEBPACK_IMPORTED_MODULE_9__constants__["j" /* EXCHANGE_ONLY */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_25_react_bootstrap__["e" /* Col */],
                      { md: 4 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_33__RepairOrders_constants__["e" /* CORE_DUE_DAYS */]),
                        name: __WEBPACK_IMPORTED_MODULE_33__RepairOrders_constants__["e" /* CORE_DUE_DAYS */],
                        type: "number",
                        step: 1,
                        component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */]
                      })
                    )
                  )],
                  !__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(selectedPart, __WEBPACK_IMPORTED_MODULE_32__parts_constants__["h" /* HAZMAT */]) && quoteType === __WEBPACK_IMPORTED_MODULE_9__constants__["j" /* EXCHANGE_ONLY */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_21__shared_components_Forms_FormRow__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_25_react_bootstrap__["e" /* Col */],
                      { md: 4 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_33__RepairOrders_constants__["e" /* CORE_DUE_DAYS */]),
                        name: __WEBPACK_IMPORTED_MODULE_33__RepairOrders_constants__["e" /* CORE_DUE_DAYS */],
                        type: "number",
                        step: 1,
                        component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */]
                      })
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_21__shared_components_Forms_FormRow__["a" /* default */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_25_react_bootstrap__["e" /* Col */],
                    { md: 6 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_19__shared_constants__["c" /* INTERNAL_NOTE */],
                      required: getFieldValue(__WEBPACK_IMPORTED_MODULE_9__constants__["d" /* FOLLOW_UP_FEEDBACK */]) === __WEBPACK_IMPORTED_MODULE_19__shared_constants__["d" /* OTHER */],
                      rows: 5,
                      cols: 50,
                      component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["l" /* TextArea */],
                      label: "Internal Note (Applied to the line item)"
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_25_react_bootstrap__["e" /* Col */],
                    { md: 6 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */],
                      rows: 5,
                      cols: 50,
                      component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["l" /* TextArea */],
                      label: "External Note (*visible to Customer*)"
                    })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_25_react_bootstrap__["e" /* Col */],
              { md: 4 },
              selectedPart && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Total__["a" /* default */], {
                part: selectedPart,
                quantity: quantity,
                pricePerUnit: pricePerUnit,
                totalCyclesRemaining: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__inventories_helpers__["b" /* totalCyclesRemaining */])(selectedPart, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(selectedInventory, __WEBPACK_IMPORTED_MODULE_32__parts_constants__["F" /* TOTAL_CYCLES */])),
                totalHoursRemaining: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__inventories_helpers__["a" /* totalHoursRemaining */])(selectedPart, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(selectedInventory, __WEBPACK_IMPORTED_MODULE_32__parts_constants__["E" /* TOTAL_HOURS */]))
              })
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  resetFields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  searchOutgoingQuoteLineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  pricePerUnit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  quoteType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  quoteTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  change: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  searchParts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  companyId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  disableInventorySync: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    canExchange: state.session.getIn([__WEBPACK_IMPORTED_MODULE_18__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_18__constants__["_35" /* CAN_EXCHANGE */]]),
    getFieldValue: function getFieldValue(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["formValueSelector"])(formName)(state, field);
    },
    quantity: selector(state, __WEBPACK_IMPORTED_MODULE_18__constants__["j" /* QUANTITY */]),
    pricePerUnit: selector(state, __WEBPACK_IMPORTED_MODULE_9__constants__["b" /* PRICE_PER_UNIT */]),
    quoteType: selector(state, __WEBPACK_IMPORTED_MODULE_9__constants__["f" /* QUOTE_TYPE */]),
    companyId: state.outgoingQuoteDetail.getIn(["outgoingQuote", __WEBPACK_IMPORTED_MODULE_18__constants__["N" /* COMPANY_ID */]]),
    company: state.outgoingQuoteDetail.getIn(["outgoingQuote", __WEBPACK_IMPORTED_MODULE_18__constants__["i" /* COMPANY */]]).toJS()
  };
}, function (dispatch) {
  return {
    resetFields: function resetFields() {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_9__constants__["b" /* PRICE_PER_UNIT */], null));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* EXCHANGE_FEE */], null));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["change"])(formName, field, val));
      };
    },
    searchParts: function searchParts(filter) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_actions__["n" /* searchParts */])(filter));
    },
    searchOutgoingQuoteLineItems: function searchOutgoingQuoteLineItems(partId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_actions__["r" /* searchOutgoingQuoteLineItems */])(partId));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_35__validate__["b" /* default */]
})(Form)));

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = PurchasedPartWarning;





function PurchasedPartWarning(_ref) {
  var purchaseCreatedAt = _ref.purchase_created_at,
      purchaserContact = _ref.purchaser_contact,
      purchaserCompany = _ref.purchaser_company,
      purchaser = _ref.purchaser;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "center-block alert alert-danger" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "media" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "media-left" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-warning text-danger" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "media-body" },
        "Unit was purchased from ",
        purchaserCompany,
        " recently! Please be careful quoting.",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { style: { marginLeft: 8 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["j" /* NoteTooltip */], {
            placement: "right",
            icon: "fa-info-circle",
            color: "rgba(255, 255, 255, 0.25)",
            note: "This part number was purchased/received in the last 60 days by\n                      " + purchaser + " from " + purchaserCompany + " / " + purchaserContact + " on\n                      " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__["e" /* shortDateAndTimestamp */])(purchaseCreatedAt) + ".\n                      Please consider contacting Buyer.\n                      Please be careful quoting as they might be pricing us."
          })
        )
      )
    )
  );
}

PurchasedPartWarning.propTypes = {
  purchaser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.required,
  purchaser_company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.required,
  purchase_created_at: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.required,
  purchaser_contact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.required
};

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__ = __webpack_require__(21);
/* harmony export (immutable) */ __webpack_exports__["a"] = QuotedPartWarning;




function QuotedPartWarning(_ref) {
  var quoteCreatedAt = _ref.quote_created_at,
      quoteContactName = _ref.quote_contact,
      quotedCompany = _ref.quoted_company,
      aeroZoneEmployee = _ref.quoter,
      quotedPartType = _ref.quoted_part_type;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "center-block alert alert-iq" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "media" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "media-left" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-warning text-warning" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "media-body" },
        "In the last 14 days, this part number was",
        " ",
        quotedPartType === "no_quote" ? "no quoted" : "quoted",
        " to",
        " ",
        aeroZoneEmployee,
        " by ",
        quoteContactName,
        " at ",
        quotedCompany,
        " on",
        " ",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__["e" /* shortDateAndTimestamp */])(quoteCreatedAt),
        ". Please consider contacting",
        " ",
        aeroZoneEmployee,
        ". *Please be careful quoting as they might be pricing us."
      )
    )
  );
}

QuotedPartWarning.propTypes = {
  quoter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.required,
  quoted_company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.required,
  quote_contact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.required,
  quote_created_at: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.required
};

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Download__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UnShip__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators_renderIf__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_ImprovedDropDown__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreateCommercialInvoice_CreateCommercialInvoice__ = __webpack_require__(1492);








function Actions(_ref) {
  var url = _ref.url,
      shipment = _ref.shipment;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group pull-right", style: { marginLeft: 20 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_ImprovedDropDown__["a" /* default */],
      {
        menuClass: "dropdown-menu-right",
        buttonClasses: "btn btn-info",
        buttonText: "Actions",
        icon: "fa fa-fw fa-caret-down"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Download__["a" /* default */], { url: url }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UnShip__["a" /* default */], { shipment: shipment }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CreateCommercialInvoice_CreateCommercialInvoice__["a" /* default */], { shipment: shipment })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators_renderIf__["a" /* default */])(function (_ref2) {
  var shipment = _ref2.shipment;
  return shipment.get("reference_record_line_item_type") !== "MistakeShipment";
})(Actions));

Actions.propTypes = {
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  shipment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modal__ = __webpack_require__(1493);
/* harmony export (immutable) */ __webpack_exports__["a"] = CreateCommercialInvoice;








function CreateCommercialInvoice(_ref) {
  var shipment = _ref.shipment;

  if (shipment.get("reference_record_type") !== "SalesOrder") {
    return null;
  }

  var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hooks__["a" /* useCurrentUser */])();

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__users_helpers__["a" /* hasAnyOfSubroles */])(user, [__WEBPACK_IMPORTED_MODULE_4__users_constants__["_18" /* CREATE_COMMERCIAL_INVOICE */], __WEBPACK_IMPORTED_MODULE_4__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */], __WEBPACK_IMPORTED_MODULE_4__users_constants__["t" /* WAREHOUSE_EXPERT */]])) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
    faIcon: "dollar",
    label: "Create Commercial Invoice",
    renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modal__["a" /* Modal */], { shippingRecord: shipment.toJS() })
  });
}

CreateCommercialInvoice.propTypes = {
  shipment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_CommercialInvoice_Form__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_CommercialInvoice_Form_FormSections_LineItemsForm__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SalesOrders_helpers__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_CommercialInvoice_Form_CommercialDiscreetButton__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_Form_FormSections_SaveWarning__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_helpers__ = __webpack_require__(173);
/* harmony export (immutable) */ __webpack_exports__["a"] = Modal;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();













function Modal(_ref) {
  var shippingRecord = _ref.shippingRecord,
      open = _ref.open,
      close = _ref.close;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      lineItems = _useState2[0],
      setLineItems = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({ so: [] }),
      _useState4 = _slicedToArray(_useState3, 2),
      salesOrder = _useState4[0],
      setSalesOrder = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_helpers__["e" /* COMMERCIAL_INVOICE */]),
      _useState6 = _slicedToArray(_useState5, 2),
      currentForm = _useState6[0],
      setCurrentForm = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
      _useState8 = _slicedToArray(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].salesOrders.show(shippingRecord.reference_record_id).then(function (resp) {
      setSalesOrder(resp.data);
      var result = resp.data.line_items;
      setLineItems([result[0].inventory]);
      if (result.length > 1) {
        setCurrentForm(__WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_helpers__["f" /* COMMERCIAL_INVOICE_LINE_ITEMS */]);
      }
      setLoading(false);
    });

    return function cleanup() {};
  }, []);

  var invoiceInitialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_helpers__["g" /* setInvoiceInitialValues */])({
    lineItems: lineItems,
    shippingRecord: shippingRecord,
    salesOrder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__SalesOrders_helpers__["g" /* mapSOToForm */])(salesOrder)
  });

  invoiceInitialValues.shipment_id = shippingRecord.id;
  invoiceInitialValues.has_commercial_invoice_attachment = shippingRecord.has_commercial_invoice_attachment;

  if (!shippingRecord.has_commercial_invoice_attachment) {
    invoiceInitialValues.replace_pdf = true;
  }

  var addLineItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_helpers__["h" /* addLineItemsFunc */])({ setLineItems: setLineItems, setCurrentForm: setCurrentForm });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["a" /* Modal */],
    {
      key: shippingRecord.id,
      open: open,
      close: close,
      dialogClass: "modal-lg"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_CommercialInvoice_Form_CommercialDiscreetButton__["a" /* default */], {
        display: currentForm === __WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_helpers__["e" /* COMMERCIAL_INVOICE */]
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Create Commercial Invoice"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Body, {
      close: close,
      addLineItems: addLineItems,
      lineItems: salesOrder.line_items,
      currentForm: currentForm,
      loading: loading,
      salesOrderId: shippingRecord.reference_record_id,
      invoiceInitialValues: invoiceInitialValues,
      hazmat: shippingRecord.hazmat,
      discreet: shippingRecord.discreet,
      setCurrentForm: setCurrentForm
    })
  );
}

var Body = function Body(_ref2) {
  var addLineItems = _ref2.addLineItems,
      close = _ref2.close,
      currentForm = _ref2.currentForm,
      discreet = _ref2.discreet,
      hazmat = _ref2.hazmat,
      lineItems = _ref2.lineItems,
      loading = _ref2.loading,
      invoiceInitialValues = _ref2.invoiceInitialValues,
      salesOrderId = _ref2.salesOrderId,
      setCurrentForm = _ref2.setCurrentForm;

  if (loading) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "animate-form-body" });
  } else if (currentForm === __WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_helpers__["f" /* COMMERCIAL_INVOICE_LINE_ITEMS */]) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_CommercialInvoice_Form_FormSections_LineItemsForm__["a" /* default */], {
      close: close,
      addLineItems: addLineItems,
      lineItems: lineItems,
      enableReinitialize: true
    });
  } else if (currentForm === __WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_helpers__["d" /* SAVE_OR_REPLACE_FORM */]) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_Form_FormSections_SaveWarning__["a" /* default */], { close: close, setCurrentForm: setCurrentForm });
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_CommercialInvoice_Form__["a" /* default */], {
    close: close,
    initialValues: invoiceInitialValues,
    hazmat: hazmat,
    discreet: discreet,
    salesOrderId: salesOrderId,
    enableReinitialize: true,
    setCurrentForm: setCurrentForm
  });
};

Body.propTypes = {
  addLineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  currentForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  discreet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  invoiceInitialValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  lineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
  lineItemsForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  salesOrderId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

Modal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shippingRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_ExternalLink_ExternalLink__ = __webpack_require__(212);
/* unused harmony export Download */





function Download(_ref) {
  var url = _ref.url;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "li",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_ExternalLink_ExternalLink__["a" /* default */],
      { url: url },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: "file-text-o", fixed: true }),
      "\xA0Download Packing Slip"
    )
  );
}

Download.propTypes = {
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Download);

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RepairOrders_constants__ = __webpack_require__(28);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var UnShip = function (_React$Component) {
  _inherits(UnShip, _React$Component);

  function UnShip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UnShip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UnShip.__proto__ || Object.getPrototypeOf(UnShip)).call.apply(_ref, [this].concat(args))), _this), _this.propTypes = {
      pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }, _this.state = {
      open: false
    }, _this.toggleModal = function () {
      return _this.setState({ open: !_this.state.open });
    }, _this.unShip = function () {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].shipments.reversal(_this.props.shipment.get(__WEBPACK_IMPORTED_MODULE_9__constants__["b" /* ID */])).then(function () {
        _this.props.pushHistory("/shipping");
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UnShip, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components__["l" /* DropDownItem */],
        { onClick: this.toggleModal },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
        "\xA0UnShip",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components__["i" /* ConfirmAction */],
          {
            onConfirm: this.unShip,
            close: this.toggleModal,
            open: this.state.open
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          " Are you sure you want to undo this\xA0",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Shipment"
          ),
          "?"
        )
      );
    }
  }]);

  return UnShip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

UnShip.propTypes = {
  shipment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])
};

var forSalesOrdersorRepairOrders = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var shipment = _ref2.shipment;

  var commissionPaid = shipment.getIn(["sales_item", "commission_paid"]);
  var isSO = shipment.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_68" /* REFERENCE_RECORD_LINE_ITEM_TYPE */]) === "SalesOrderLineItem";
  var isRO = shipment.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_68" /* REFERENCE_RECORD_LINE_ITEM_TYPE */]) === "RepairOrderLineItem";

  var isPO = shipment.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_68" /* REFERENCE_RECORD_LINE_ITEM_TYPE */]) === "PurchaseOrderLineItem";
  var repairAwaitingEval = shipment.get("reference_record_line_item_approval_status") === __WEBPACK_IMPORTED_MODULE_10__RepairOrders_constants__["B" /* REPAIR_AWAITING_EVALUATION */];
  var validInventoryStatus = [__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_33" /* GONE */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["m" /* OUT_ON_EXCHANGE */]].includes(shipment.getIn([__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_31" /* STATUS */]]));
  var validInventoryRepairStatus = shipment.getIn([__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["j" /* REPAIR_STATUS */]]) === __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["l" /* AT_SHOP */];
  var roShipped = shipment.get("reference_record_line_item_shipped");

  var validSOPO = (isSO || isPO) && validInventoryStatus;
  var validRO = isRO && repairAwaitingEval && roShipped || isRO && validInventoryRepairStatus;

  return (validRO || validSOPO) && !commissionPaid;
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(forSalesOrdersorRepairOrders(UnShip)));

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Actions__ = __webpack_require__(1491);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Actions__["a"]; });



/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Attachments__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shipping_constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LineItemsTable_LineItemsTable__ = __webpack_require__(1498);
/* harmony export (immutable) */ __webpack_exports__["a"] = Body;









function Body(_ref) {
  var shipment = _ref.shipment;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
    { md: 9 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      { style: { marginTop: 26 } },
      "Parts"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LineItemsTable_LineItemsTable__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Attachments__["a" /* default */], {
      resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(shipment),
      resourceType: __WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].shipment,
      resourceKey: "shipment",
      multiple: true,
      attachmentTypes: __WEBPACK_IMPORTED_MODULE_5__Shipping_constants__["h" /* ATTACHMENT_TYPES */]
    })
  );
}

Body.propTypes = { shipment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired };

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var paginatorList = "shipments/lineItems";

var ReceivedIcon = function ReceivedIcon(_ref) {
  var quantityReceived = _ref.quantity_received,
      quantity = _ref.quantity;

  if (quantityReceived === quantity) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["U" /* IconReceived */], null);
  }
  return null;
};

ReceivedIcon.propTypes = {
  quantity_received: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  quantity: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
};

var LineItemsTable = function (_Component) {
  _inherits(LineItemsTable, _Component);

  function LineItemsTable() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, LineItemsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = LineItemsTable.__proto__ || Object.getPrototypeOf(LineItemsTable)).call.apply(_ref2, [this].concat(args))), _this), _this.renderRow = function (r, idx) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        {
          key: r.id,
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("clickable", { "text-muted": r.cancelled })
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { whiteSpace: "nowrap" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { textAlign: "right" } },
              idx + 1
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["h" /* PartNumber */], { part: r.part })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(r.inventory_link_id) ? r.serial_number : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
            { to: "/inventories/" + r.inventory_link_id },
            r.serial_number
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LineItemsTable, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          results = _props.results,
          isLoading = _props.isLoading;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Mini,
          { loading: isLoading, numbered: true, noMargin: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Part #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Serial #"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Body,
            null,
            results.map(this.renderRow)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "nav",
          {
            className: "text-center margin-top-none",
            "aria-label": "Search results pages"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__["Paginator"], { listId: paginatorList })
        )
      );
    }
  }]);

  return LineItemsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LineItemsTable.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object)).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};


var ConnectedTable = __WEBPACK_IMPORTED_MODULE_4__orange_marmalade_paginate_this__["decorators"].tabulate(LineItemsTable);

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConnectedTable, _extends({ listId: paginatorList }, props));
});

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Body__ = __webpack_require__(1497);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Body__["a"]; });



/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Panel__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Body__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Actions__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Warnings__ = __webpack_require__(1509);
/* unused harmony export Detail */















var DOWNLOAD_MAP = {
  SalesOrder: "sales_orders",
  ManagedRepairOrder: "managed_repair_orders",
  PurchaseOrder: "purchase_orders",
  RepairOrder: "repair_orders",
  ReturnedCore: "returned_cores",
  ReturnToCustomerRecord: "return_to_customer_records",
  Rma: "vendor_rmas"
};

function Detail(_ref) {
  var shipment = _ref.shipment;

  var id = shipment.get("reference_record_id") || shipment.get("reference_record_line_item_id");

  var packingSlipUrl = __WEBPACK_IMPORTED_MODULE_9__constants__["d" /* API_BASE */] + "/" + DOWNLOAD_MAP[shipment.get("reference_record_type") || shipment.get("reference_record_line_item_type")] + "/" + id + "/download_packing_slip?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_query_string__["stringify"])({
    shipment_id: shipment.get(__WEBPACK_IMPORTED_MODULE_9__constants__["b" /* ID */])
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "page-header page-header-bar" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h1",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["J" /* RecordPager */], { baseUrl: "/shipping", record: shipment }),
        "\xA0",
        shipment.get("code"),
        "\xA0",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "small text-muted" },
          "Shipped ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["b" /* shortDate */])(shipment.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_7" /* CREATED_AT */]))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Actions__["a" /* default */], { url: packingSlipUrl, shipment: shipment }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Warnings__["a" /* default */], null)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "row" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Panel__["a" /* default */], { shipment: shipment.toJS() }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Body__["a" /* default */], { shipment: shipment.toJS() })
    )
  );
}

Detail.propTypes = {
  shipment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    shipment: state.shipmentDetail.get("shipment")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["h" /* loadRecord */])({
  reducer: "shipmentDetail",
  name: "shipment",
  action: __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* fetch */]
})(Detail)));

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shipping_components_Dashboard_Create_validate__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parts_components_shared_FormSections_WeightAndDimensionsSection__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(321);
/* unused harmony export Form */












function Form(props) {
  var isManager = props.isManager,
      isBasicWarehouseUser = props.isBasicWarehouseUser,
      isIto = props.isIto;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
        { className: "row-col-gutters-half" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 5 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "read_only_part_number",
            label: "Part #",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            disabled: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "read_only_serial_number",
            label: "Serial #",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            disabled: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__parts_components_shared_FormSections_WeightAndDimensionsSection__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_redux_form__["FormSection"],
        { name: "shipping_method" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["g" /* ShippingMethod */], {
          disabled: !isManager && isBasicWarehouseUser,
          required: !isIto
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
        { className: "row-col-gutters-half" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 5 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "outgoing_awb_number",
            label: "Outgoing AWB #",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */]
          })
        ),
        props.dirty && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 7 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
            { justified: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: "send_shipment_updated_email",
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
              label: "Send Shipment Update Email"
            })
          )
        )
      )
    )
  );
}

Form.propTypes = {
  isManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isBasicWarehouseUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isIto: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])("editShipment");

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    discreet: selector(state, "discreet"),
    accountNumber: selector(state, "shipping_method.account_number"),
    carrier: selector(state, "shipping_method.carrier"),
    isManager: state.session.getIn(["user", "manager"]) || state.session.getIn(["user", "role"]) === __WEBPACK_IMPORTED_MODULE_6__users_constants__["i" /* ADMIN */],
    isBasicWarehouseUser: state.session.getIn(["user", "subrole"]) === __WEBPACK_IMPORTED_MODULE_6__users_constants__["r" /* WAREHOUSE_BASIC */],
    shippingMethod: selector(state, "shipping_method.shipping_method"),
    getField: function getField(field) {
      return selector(state, field);
    }
  };
}, function (dispatch, props) {
  return {
    onSubmit: function onSubmit(val) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__actions__["b" /* update */])(props.shipment.id, val));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: "editShipment",
  validate: __WEBPACK_IMPORTED_MODULE_7__Shipping_components_Dashboard_Create_validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__parts_components_Search_Dimensions__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Orders_shared_ShippingAddress__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__EditShipmentForm__ = __webpack_require__(1501);
/* harmony export (immutable) */ __webpack_exports__["a"] = Panel;

















function Panel(_ref) {
  var _ref$shipment = _ref.shipment,
      shipment = _ref$shipment === undefined ? {} : _ref$shipment;

  var shippingMethod = shipment.shipping_method || {};

  var refId = shipment.reference_record_uuid || shipment.reference_record_id;
  var refs = {
    ReturnedCore: "purchase-orders",
    MistakeShipment: "mistake-shipments",
    PurchaseOrder: "purchase-orders",
    RepairOrder: "repair-orders",
    Rma: "rmas",
    SalesOrder: "sales-orders"
  };

  var carrier = shippingMethod.carrier && __WEBPACK_IMPORTED_MODULE_9__shared_constants__["a" /* CARRIERS */][shippingMethod.carrier];
  var formattedShippingMethod = carrier && carrier.shippingMethods[shipment.shipping_method.shipping_method].label;
  var initialValues = {
    read_only_part_number: shipment.part_number,
    read_only_serial_number: shipment.serial_number,
    outgoing_awb_number: shipment.outgoing_awb_number,
    country_of_mfg: shipment.country_of_mfg,
    hazmat: shipment.hazmat,
    length: shipment.length,
    width: shipment.width,
    height: shipment.height,
    weight: shipment.weight,
    bio_hazmat: shipment.bio_hazmat,
    quantity: shipment.quantity,
    discreet: shipment.discreet,
    customer_to_provide_own_paperwork: shipment.customer_to_provide_own_paperwork,
    reference_record_line_item_id: shipment.reference_record_line_item_id,
    reference_record_line_item_type: shipment.reference_record_line_item_type,
    shipping_method: {
      carrier: shippingMethod.carrier,
      shipping_method: shippingMethod.shipping_method,
      account_number: shippingMethod.account_number
    },
    weight_unit: "lb",
    send_shipment_updated_email: true
  };
  var isIto = shipment.reference_record_type === "InventoryTransferOrder";

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["e" /* Col */],
    { md: 3 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "panel panel-default" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "panel-body" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__shared_components__["X" /* Section */],
          {
            title: "Shipment Details",
            modal: {
              title: "Edit Shipping Details",
              content: function content(close) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__EditShipmentForm__["a" /* default */], {
                  initialValues: initialValues,
                  close: close,
                  shipment: shipment,
                  shippingRecord: shipment,
                  isIto: isIto
                });
              }
            },
            editable: !shipment.cancelled && shipment.reference_record_line_item_type !== "MistakeShipment"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["a" /* DetailTable */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "Customer"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["w" /* CompanyName */], { company: shipment.company })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
              label: "Shipment Type",
              value: __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* RECORD_TYPES */][shipment.reference_record_type]
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
                label: "Store Loc",
                value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["o" /* LocationFlag */], {
                  location: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(shipment, "inventory.store_owner_id")
                })
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "Dimensions"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__parts_components_Search_Dimensions__["a" /* default */], { part: shipment })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "Weight"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                null,
                shipment.weight || "N/A",
                " lb"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "Ref #"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
                  {
                    to: "/" + refs[shipment.reference_record_type] + "/" + refId
                  },
                  shipment.reference_record_code
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "Cust PO#"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                null,
                shipment.customer_po
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], { label: "Out. AWB #", value: shipment.outgoing_awb_number }),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(shipment, "company.phone") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "Customer Ph#"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                null,
                shipment.company.phone
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["a" /* DetailTable */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
              label: "Created By",
              value: shipment.created_by.full_name
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
              label: "Checked By",
              value: shipment.checked_by_full_name
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
              label: "Checked At",
              value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["e" /* shortDateAndTimestamp */])(shipment.checked_at)
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["a" /* DetailTable */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
              label: "Condition",
              value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__SalesOrders_constants__["z" /* condition */])(shipment.condition).label
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], { label: "Qty. Ship.", value: shipment.quantity_shipped }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["c" /* CheckForDetail */], {
              label: "Discreet",
              value: shipment.discreet,
              icon: "eye-slash"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["d" /* SpecialInstructions */], { note: shipment.special_instructions }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["c" /* CheckForDetail */], {
              label: "Cust P/W",
              value: shipment.customer_to_provide_own_paperwork
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Orders_shared_ShippingAddress__["a" /* default */], {
            shippingType: "ship_to",
            record: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(shipment),
            renderPreferences: false
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["a" /* DetailTable */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], { label: "Carrier", value: carrier && carrier.label }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], { label: "Method", value: formattedShippingMethod }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
              label: "Account Number",
              value: shipment.shipping_method && shipment.shipping_method.account_number
            })
          )
        )
      )
    )
  );
}

Panel.propTypes = {
  shipment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired
};

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Panel__ = __webpack_require__(1502);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Panel__["a"]; });



/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decorators__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* unused harmony export AccountHold */






function AccountHold(_ref) {
  var hold = _ref.hold;

  return hold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["p" /* StatusTag */], { title: "Accounting Hold", icon: "pause", display: "warning" });
}

AccountHold.propTypes = {
  hold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var shipment = _ref2.shipment;
  return {
    hold: shipment.get("accounting_hold")
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decorators__["a" /* withShipment */])(withProps(AccountHold)));

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decorators__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* unused harmony export Cancelled */






function Cancelled(_ref) {
  var cancelled = _ref.cancelled;

  return cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["p" /* StatusTag */], { key: "warning", title: "UnShipped", icon: "warning" });
}

Cancelled.propTypes = {
  cancelled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var shipment = _ref2.shipment;
  return {
    cancelled: shipment.get("cancelled")
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decorators__["a" /* withShipment */])(withProps(Cancelled)));

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inventories_constants__ = __webpack_require__(12);
/* unused harmony export QCHold */







function QCHold(_ref) {
  var hold = _ref.hold;

  return hold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["p" /* StatusTag */], { title: "QC Hold", icon: "pause", display: "danger" });
}

QCHold.propTypes = { hold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired };

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var shipment = _ref2.shipment;
  return {
    hold: shipment.getIn(["inventory", "qc_status"]) === __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["S" /* QC_HOLD */]
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withShipment */])(withProps(QCHold)));

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inventories_constants__ = __webpack_require__(12);
/* unused harmony export UnderReview */







function UnderReview(_ref) {
  var review = _ref.review;

  return review && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["p" /* StatusTag */], { title: "Under Review", icon: "search" });
}

UnderReview.propTypes = { review: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired };

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var shipment = _ref2.shipment;
  return {
    review: shipment.getIn(["inventory", "qc_status"]) === __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["T" /* UNDER_REVIEW */]
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withShipment */])(withProps(UnderReview)));

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AccountingHold__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QCHold__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UnderReview__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Cancelled__ = __webpack_require__(1505);
/* harmony export (immutable) */ __webpack_exports__["a"] = Warnings;







function Warnings() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components__["K" /* StatusTags */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AccountingHold__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Cancelled__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__QCHold__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__UnderReview__["a" /* default */], null)
  );
}

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Warnings__ = __webpack_require__(1508);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Warnings__["a"]; });



/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Detail__ = __webpack_require__(1500);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Detail__["a"]; });



/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Stats__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shared_components_DateRangePicker_DateRangePicker__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Table__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pagination__ = __webpack_require__(438);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _defaultFilters;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
























var defaultFilters = (_defaultFilters = {
  checked: undefined,
  dropshipped: undefined,
  end_date: undefined,
  source: undefined,
  start_date: undefined
}, _defineProperty(_defaultFilters, __WEBPACK_IMPORTED_MODULE_15__inventories_constants__["_27" /* STORE_LOCATION_ID */], undefined), _defineProperty(_defaultFilters, "transfer", undefined), _defaultFilters);

var filters = [{
  label: "Checked",
  filters: { checked: true }
}, {
  label: "Unchecked",
  filters: { checked: false }
}, {
  label: "Dropshipped",
  filters: { dropshipped: true }
}, {
  label: "SOs",
  filters: { source: "SalesOrderLineItem" }
}, {
  label: "ROs",
  filters: { source: "RepairOrderLineItem" },
  hr: true
}, {
  label: "All Type 'TR'",
  filters: { transfer: true },
  withAuthorization: {
    authorizedIf: function authorizedIf(user) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__users_helpers__["g" /* hasSubRole */])(user.toJS(), [__WEBPACK_IMPORTED_MODULE_14__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */], __WEBPACK_IMPORTED_MODULE_14__users_constants__["s" /* WAREHOUSE_MANAGER */]]);
    }
  }
}];

var filterTags = [{
  label: "Checked",
  key: "checked",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Unchecked",
  key: "checked",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Transfers",
  key: "transfer"
}, {
  label: "Dropshipped",
  key: "dropshipped"
}, {
  label: "SOs",
  key: "source",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])("SalesOrderLineItem")
}, {
  label: "ROs",
  key: "source",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])("RepairOrderLineItem")
}];

var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = searchProps.paginator.get("filters").toJS();
  var totalCount = searchProps.paginator.get("totalCount");

  params.total_count = totalCount;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        if (totalCount > __WEBPACK_IMPORTED_MODULE_14__users_constants__["_6" /* EXPORT_LIMIT */]) {
          __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].info("Processing Report.");
          __WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].shipments.export(params).then(function () {
            return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
          });
        } else {
          window.open(__WEBPACK_IMPORTED_MODULE_13__constants__["d" /* API_BASE */] + "/shipments/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_query_string__["stringify"])(params), "_blank");
          __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].success("Processing Shipped Orders Report. Please wait for the PDF to generate.");
        }
      }
    },
    "Export"
  );
};

ExportButton.propTypes = {
  searchProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    paginator: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map)
  })
};

var meetsExportCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var searchProps = _ref2.searchProps;

  var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__hooks_useCurrentUser__["a" /* default */])();
  return searchProps.paginator.get("totalCount") <= 450 || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__users_helpers__["d" /* hasRole */])(user, __WEBPACK_IMPORTED_MODULE_14__users_constants__["i" /* ADMIN */]);
});

var DecoratedExportButton = meetsExportCriteria(ExportButton);

function ShipmentsSearch(_ref3) {
  var pushHistory = _ref3.pushHistory,
      subscribeToShipmentsChannel = _ref3.subscribeToShipmentsChannel,
      unsubscribeToShipmentsChannel = _ref3.unsubscribeToShipmentsChannel;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__hooks_useCurrentUser__["a" /* default */])();

  var filterTagsWithLocation = currentUser.locations.map(function (l) {
    return {
      label: "From " + l.name,
      key: __WEBPACK_IMPORTED_MODULE_15__inventories_constants__["_27" /* STORE_LOCATION_ID */],
      matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])(l.id)
    };
  });

  var filtersWithLocations = currentUser.locations.length > 1 ? currentUser.locations.map(function (l, i) {
    return {
      label: "From " + l.name,
      filters: _defineProperty({}, __WEBPACK_IMPORTED_MODULE_15__inventories_constants__["_27" /* STORE_LOCATION_ID */], l.id),
      hr: currentUser.locations.length - 1 === i
    };
  }) : null;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    subscribeToShipmentsChannel();

    return function cleanup() {
      unsubscribeToShipmentsChannel();
    };
  }, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_21__pagination__["a" /* shipmentsPagination */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a part number, awb number, company name, ship date, or any reference number...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/shipping/" + r.id);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DecoratedExportButton, { searchProps: searchProps }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__shared_components_DateRangePicker_DateRangePicker__["a" /* default */], searchProps),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
              filters: filters.concat(filtersWithLocations || []).concat({
                label: __WEBPACK_IMPORTED_MODULE_13__constants__["_37" /* CLEAR_FILTERS_TEXT */],
                filters: _extends({}, defaultFilters)
              }),
              right: true
            }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Stats__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "Shipped Orders",
          filters: filterTags.concat(filterTagsWithLocation)
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

ShipmentsSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    subscribeToShipmentsChannel: function subscribeToShipmentsChannel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__actions__["c" /* subscribe */])());
    },
    unsubscribeToShipmentsChannel: function unsubscribeToShipmentsChannel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__actions__["d" /* unsubscribe */])());
    },
    pushHistory: function pushHistory(path) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"])(path));
    }
  };
})(ShipmentsSearch));

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








function Count(_ref) {
  var data = _ref.data,
      dateLabel = _ref.dateLabel,
      type = _ref.type;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["H" /* Stat */], {
    label: "# Shipments - " + dateLabel,
    value: __WEBPACK_IMPORTED_MODULE_4_numeral___default()(data[type]).format("(0,0)")
  });
}

Count.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  dateLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

function Stats() {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),
      _useState2 = _slicedToArray(_useState, 2),
      stats = _useState2[0],
      setStats = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].shipments.stats().then(function (resp) {
      setStats(resp.data);
    });
  }, []);

  if (!stats) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Count, { dateLabel: "YTD", data: stats, type: "year_to_date" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Count, { dateLabel: "Today", data: stats, type: "today" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Count, { dateLabel: "Current Month", data: stats, type: "current_month" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Count, { dateLabel: "Last 30 Days", data: stats, type: "last_30_days" })
    )
  );
}

Stats.propTypes = {};

/* harmony default export */ __webpack_exports__["a"] = (Stats);

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shipping_actions__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(321);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
















function renderRow(r, pushHistory, currentUser, check) {
  var refId = r.reference_record_uuid || r.reference_record_id;
  var refs = {
    ManagedRepairOrder: "managed-repair-orders",
    MistakeShipment: "mistake-shipments",
    PurchaseOrder: "purchase-orders",
    ReturnedCore: "purchase-orders",
    RepairOrder: "repair-orders",
    Rma: "rmas",
    ReturnToCustomerRecord: "rmas",
    SalesOrder: "sales-orders"
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: r.id,
      className: "clickable " + (r.cancelled && "text-muted"),
      onClick: function onClick() {
        return pushHistory("/shipping/" + r.uuid);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.reference_record_exporting && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
        icon: "fa-globe",
        placement: "top",
        note: "Exporting",
        color: "#FFFFFF"
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__["e" /* shortDateAndTimestamp */])(r.released_at || r.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__["e" /* shortDateAndTimestamp */])(r.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* RECORD_TYPES */][r.reference_record_type || r.reference_record_line_item_type]
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["w" /* CompanyName */], { flattenedCompany: r })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.qc_documents_sent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "label label-success" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check" }),
        "\xA0\xA0 Sent"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      r.formatted_address && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], { note: r.formatted_address, icon: "fa-truck" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["o" /* LocationFlag */], { location: r.store_location_id })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["h" /* PartNumber */], { part: r.part })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.inventory && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          to: "/inventories/" + (r.inventory.uuid || r.inventory.id)
        },
        r.serial_number
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          to: "/" + refs[r.reference_record_type || r.reference_record_line_item_type] + "/" + refId
        },
        r.reference_record_code
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.customer_po ? r.customer_po : "N/A"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["_0" /* CheckColumn */], { checked: r.discreet, icon: "eye-slash", text: "Yes" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__SalesOrders_constants__["z" /* condition */])(r.condition).abbrev
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      r.quantity_shipped
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["e" /* truncate */])(r.outgoing_awb_number, 24)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.checked && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__["e" /* shortDateAndTimestamp */])(r.checked_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.checked && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["d" /* getFirstNameLastInitial */])(r.checked_by_full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.dropshipped ? "Dropshipment" : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["_1" /* ToggleButton */], {
        text: "Day-End Check",
        toggledText: "Uncheck",
        toggled: r.checked,
        canRemove: r.checked_by_id !== currentUser.id || r.checked,
        handleClick: function handleClick(e) {
          e.stopPropagation();
          check(r, currentUser);
        }
      })
    )
  );
}

function Table(_ref) {
  var results = _ref.results,
      pushHistory = _ref.pushHistory,
      check = _ref.check,
      currentUser = _ref.currentUser,
      isLoading = _ref.isLoading,
      subscribeToOrdersChannel = _ref.subscribeToOrdersChannel,
      unsubscribeToOrdersChannel = _ref.unsubscribeToOrdersChannel;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    subscribeToOrdersChannel();

    return function () {
      return unsubscribeToOrdersChannel();
    };
  }, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */],
    { loading: isLoading },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Ship #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Released"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Shipped"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Type"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Company"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Sent QC Docs"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Ship To"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Store Loc"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Ref #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Customer PO#"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Discreet"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "CD Sent"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "QTY SHIPPED"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Outgoing AWB #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Checked At"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Checked By"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, pushHistory, currentUser, check);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_10__session_decorators_withCurrentUser__["a" /* WithCurrentUser */], __WEBPACK_IMPORTED_MODULE_7__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    check: function check(shipment, currentUser) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions__["e" /* toggleCheck */])(shipment, currentUser));
    },
    refresh: ownProps.pageActions.expire,
    pushHistory: function pushHistory(e) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"])(e));
    },
    subscribeToOrdersChannel: function subscribeToOrdersChannel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__Shipping_actions__["e" /* subscribe */])(__WEBPACK_IMPORTED_MODULE_13__actions__["f" /* reloadShippingSilent */]));
    },
    unsubscribeToOrdersChannel: function unsubscribeToOrdersChannel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__Shipping_actions__["f" /* unsubscribe */])());
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__session_decorators_withCurrentUser__["b" /* default */])(Table)));

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(1511);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });



/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(1514);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Detail__ = __webpack_require__(1510);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Detail__["a"]; });





/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony export (immutable) */ __webpack_exports__["a"] = withShipment;


function withShipment(Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
    return {
      shipment: state.shipmentDetail.get("shipment")
    };
  })(Component);
}

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_reducer__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(670);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  shipment: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
}).merge(__WEBPACK_IMPORTED_MODULE_2__shared_reducer__["b" /* attachmentsInitialState */]);

function setShipment(state, action) {
  return state.merge({ shipment: action.shipment });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_reducer__["c" /* createAttachmentReducer */])(__WEBPACK_IMPORTED_MODULE_3__shared_types_resourceTypes__["a" /* default */].shipment), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* SET */], setShipment))));

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__decorators_withPurchaseOrder__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_helpers__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Form__ = __webpack_require__(1519);
/* unused harmony export Billing */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


















function Billing(_ref) {
  var purchaseOrder = _ref.purchaseOrder,
      currentUser = _ref.currentUser;

  var hasPurchaseExchange = purchaseOrder.getIn([__WEBPACK_IMPORTED_MODULE_9__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["_81" /* PURCHASED_FOR_EXCHANGE_ID */]]);

  var hasAssignedCore = purchaseOrder.getIn([__WEBPACK_IMPORTED_MODULE_13__constants__["A" /* LINE_ITEMS */], 0]).get(__WEBPACK_IMPORTED_MODULE_11__constants__["M" /* ASSIGNED_CORE_RETURN_ID */]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components_Section__["a" /* default */],
    {
      title: "Vendor Core Repair",
      modal: {
        title: "Edit Vendor Core Repair Billing Details",
        content: function content(close) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Form__["a" /* default */], {
            close: close,
            hasAssignedCore: hasAssignedCore,
            hasPurchaseExchange: hasPurchaseExchange,
            initialValues: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_pojos__["a" /* default */])(purchaseOrder.toJS()).pick(__WEBPACK_IMPORTED_MODULE_11__constants__["W" /* VENDOR_CORE_REPAIR_INVOICE_NUMBER */], __WEBPACK_IMPORTED_MODULE_11__constants__["X" /* VENDOR_CORE_REPAIR_INVOICE_PAID */], __WEBPACK_IMPORTED_MODULE_11__constants__["Y" /* VENDOR_CORE_REPAIR_INVOICE_DUE_DATE */], __WEBPACK_IMPORTED_MODULE_11__constants__["Z" /* VENDOR_CORE_REPAIR_INVOICE_AMOUNT_PAID */]),
            isLastExchange: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__shared_helpers__["b" /* purchaseOrderLastExchange */])(purchaseOrder.toJS())
          });
        }
      },
      editable: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_7__users_constants__["m" /* ACCOUNTING */])
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["a" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
        label: "Repair Inv. #",
        value: purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_11__constants__["W" /* VENDOR_CORE_REPAIR_INVOICE_NUMBER */])
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
        label: "Repair Inv. Pd Date",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_11__constants__["X" /* VENDOR_CORE_REPAIR_INVOICE_PAID */]))
      })
    )
  );
}

Billing.propTypes = _extends({
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
}, __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["b" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__decorators_withPurchaseOrder__["a" /* default */])(Billing)));

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SalesOrders_components_Detail_Panel_Billing_LastExchangeWarning__ = __webpack_require__(1883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__decorators_withPurchaseOrder__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components__ = __webpack_require__(2);
/* unused harmony export Form */














function Form(props) {
  var disable = props.nonAccountingUser || !props.isLastExchange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SalesOrders_components_Detail_Panel_Billing_LastExchangeWarning__["a" /* default */], { isLastExchange: props.isLastExchange }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_11__constants__["W" /* VENDOR_CORE_REPAIR_INVOICE_NUMBER */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: "Repair Invoice #",
            disabled: disable
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_11__constants__["Y" /* VENDOR_CORE_REPAIR_INVOICE_DUE_DATE */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            type: "date",
            disabled: disable,
            label: "Invoice Due Date"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_11__constants__["Z" /* VENDOR_CORE_REPAIR_INVOICE_AMOUNT_PAID */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            type: "number",
            disabled: disable,
            label: "Amount"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_11__constants__["X" /* VENDOR_CORE_REPAIR_INVOICE_PAID */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            type: "date",
            disabled: disable,
            label: "Invoice Paid"
          })
        )
      ),
      props.hasAssignedCore && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12__shared_components__["n" /* Warning */],
        null,
        "This Repair Invoice is tied to an Exchange PO that was purchased for Stock. The core return was from our inventory. You will need to create a manual Cost Adjustment to the inventory record associated with this Purchase Order."
      )
    )
  );
}

Form.propTypes = {
  isLastExchange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nonAccountingUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    nonAccountingUser: ![__WEBPACK_IMPORTED_MODULE_7__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["i" /* ADMIN */]].includes(state.session.getIn([__WEBPACK_IMPORTED_MODULE_7__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["h" /* ROLE */]]))
  };
}, {
  onSubmit: __WEBPACK_IMPORTED_MODULE_6__actions__["h" /* update */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__decorators_withPurchaseOrder__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: "purchaseOrderBillingDetails"
})(Form))));

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(1522);
/* unused harmony export CancelSendPOModal */






function CancelSendPOModal(_ref) {
  var purchaseOrder = _ref.purchaseOrder,
      visible = _ref.visible,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: visible, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Send Cancellation Notice"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], { close: close, purchaseOrderId: purchaseOrder.get("id") })
  );
}

CancelSendPOModal.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired,
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (CancelSendPOModal);

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_TransitionConfirmAction_TransitionConfirmAction__ = __webpack_require__(2409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CancelSendPOModal__ = __webpack_require__(1520);
/* harmony export (immutable) */ __webpack_exports__["a"] = CancelSendPo;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








function CancelSendPo(_ref) {
  var cancelled = _ref.cancelled,
      cancelPurchaseOrder = _ref.cancelPurchaseOrder,
      purchaseOrder = _ref.purchaseOrder;

  var _useCancelSendPo = useCancelSendPo({
    cancelled: cancelled,
    cancelPurchaseOrder: cancelPurchaseOrder
  }),
      sendModalOpen = _useCancelSendPo.sendModalOpen,
      confirmActionProps = _useCancelSendPo.confirmActionProps,
      handleSendModalClose = _useCancelSendPo.handleSendModalClose;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDownItem__["a" /* default */],
      { onClick: confirmActionProps.openModal },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "text-danger" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
        " ",
        cancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Reverse Cancellation"
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "Cancel PO"
        )
      )
    ),
    sendModalOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CancelSendPOModal__["a" /* default */], {
      purchaseOrder: purchaseOrder,
      visible: sendModalOpen,
      close: handleSendModalClose
    }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_TransitionConfirmAction_TransitionConfirmAction__["a" /* default */],
      confirmActionProps,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads Up!"
      ),
      "\xA0",
      cancelled ? "Are you sure you want to reverse this cancelled order?" : "Cancelling a PO will cancel all line items associated with it.",
      !cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "cancellation_reason" },
          "Cancellation Reason"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "select",
          {
            className: "form-control",
            name: "cancellation_reason",
            onChange: confirmActionProps.handleSelectChange,
            value: confirmActionProps.cancellationReason
          },
          __WEBPACK_IMPORTED_MODULE_4__constants__["I" /* CANCELLATION_REASONS */].map(function (reason) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "option",
              { key: reason.value, value: reason.value },
              reason.text
            );
          })
        )
      ),
      !cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "form-check mt-3",
          style: {
            display: "flex",
            alignItems: "center",
            marginTop: "15px"
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          type: "checkbox",
          className: "form-check-input",
          id: "sendCancellationPO",
          checked: confirmActionProps.sendCancellationPO,
          onChange: confirmActionProps.handleCheckboxChange,
          style: { marginRight: "10px" }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "sendCancellationPO",
            style: { margin: 0, marginTop: "4px" }
          },
          "Send Cancellation PO"
        )
      )
    )
  );
}

function useCancelSendPo(_ref2) {
  var cancelled = _ref2.cancelled,
      cancelPurchaseOrder = _ref2.cancelPurchaseOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      cancelPoModalOpen = _useState2[0],
      setCancelPoModalOpen = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_4__constants__["I" /* CANCELLATION_REASONS */][0].value),
      _useState4 = _slicedToArray(_useState3, 2),
      cancellationReason = _useState4[0],
      setCancellationReason = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState6 = _slicedToArray(_useState5, 2),
      sendModalOpen = _useState6[0],
      setSendModalOpen = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState8 = _slicedToArray(_useState7, 2),
      sendCancellationPO = _useState8[0],
      setSendCancellationPO = _useState8[1];

  var handleSelectChange = function handleSelectChange(e) {
    return setCancellationReason(e.target.value);
  };

  var handleCheckboxChange = function handleCheckboxChange(e) {
    return setSendCancellationPO(e.target.checked);
  };

  var handleCancelPurchaseOrder = function handleCancelPurchaseOrder() {
    return cancelPurchaseOrder(cancellationReason).then(function () {
      setCancelPoModalOpen(false);
      if (!cancelled && sendCancellationPO) {
        setSendModalOpen(true);
      }
    });
  };

  var openModal = function openModal() {
    return setCancelPoModalOpen(true);
  };
  var closeModal = function closeModal() {
    return setCancelPoModalOpen(false);
  };
  var handleSendModalClose = function handleSendModalClose() {
    return setSendModalOpen(false);
  };

  return {
    sendModalOpen: sendModalOpen,
    handleSendModalClose: handleSendModalClose,
    confirmActionProps: {
      open: cancelPoModalOpen,
      close: closeModal,
      onConfirm: handleCancelPurchaseOrder,
      openModal: openModal,
      closeModal: closeModal,
      cancellationReason: cancellationReason,
      sendCancellationPO: sendCancellationPO,
      handleSelectChange: handleSelectChange,
      handleCheckboxChange: handleCheckboxChange,
      btnClass: cancelled ? "btn-primary" : "btn-danger",
      btnText: cancelled ? "Reverse Cancellation" : "Yes, Cancel PO",
      cancelText: cancelled ? "Cancel" : "Do not Cancel PO",
      icon: cancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-refresh" }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" })
    }
  };
}

CancelSendPo.propTypes = {
  cancelled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  cancelPurchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map).isRequired
};

/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__);
/* unused harmony export Form */
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }














function Form(_ref) {
  var close = _ref.close,
      handleSubmit = _ref.handleSubmit,
      invalid = _ref.invalid,
      submitting = _ref.submitting;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "form",
    { onSubmit: handleSubmit },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "to", label: "To:", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "cc", label: "CC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "bcc", label: "BCC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "subject", label: "Subject", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["l" /* TextArea */], name: "body", label: "Body", required: true })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
        { onClick: close },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
        {
          type: "submit",
          bsStyle: "primary",
          disabled: invalid || submitting
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["k" /* Icon */], { name: "envelope", fixed: true }),
        "\xA0Send Cancellation"
      )
    )
  );
}

Form.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var withInitialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["m" /* dataManager */])("initialValues", function () {
  var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref3) {
    var purchaseOrderId = _ref3.purchaseOrderId;

    var _ref4, preview, modifiedPreview;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].purchaseOrders.preview(purchaseOrderId, { type: "cancelled" });

          case 2:
            _ref4 = _context.sent;
            preview = _ref4.data;
            modifiedPreview = _extends({}, preview, {
              subject: preview.subject ? preview.subject + " - Cancelled" : "Cancelled"
            });
            return _context.abrupt("return", modifiedPreview);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (withInitialValues(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reduxForm"])({
  form: "send-purchase-order",
  validate: function validate(values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_validate_this__["a" /* validator */])(values, function (form) {
      form.validate("subject", "body", "to").satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["a" /* required */]);
      form.validate("to", "cc").satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["b" /* isValidEmail */]);
    });
  },
  onSubmit: function () {
    var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(data, _, props) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].purchaseOrders.sendNotice(props.purchaseOrderId, data).then(function () {
                props.close();
                __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__["toastr"].success("Success", "Cancelled PO successfully sent.");
              }).catch(function () {
                return __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__["toastr"].error("Error", "Could not send purchase order. Please refresh page and try again.");
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function onSubmit(_x2, _x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }()
})(Form)));

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_LocationFlag_LocationFlag__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Receiving_components_shared_StatusTags__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LineItemControls__ = __webpack_require__(1524);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













function Row(_ref) {
  var purchaseOrderId = _ref.purchaseOrderId,
      record = _ref.record,
      statuses = _ref.statuses;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { className: "clickable" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          to: "/receiving/" + record.uuid
        },
        record.code
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["b" /* shortDate */])(record.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["h" /* PartNumber */], { part: record.part })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.inventories && record.inventories.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          to: "/inventories/" + record.inventories[0].uuid
        },
        record.serial_number
      ) : record.serial_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_LocationFlag_LocationFlag__["a" /* default */], { location: record.store_location_id })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_5__Receiving_constants__["x" /* CONDITION_TYPES */], "[" + record.condition + "].label")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      record.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.awb_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Receiving_components_shared_StatusTags__["a" /* default */], statuses)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["G" /* NoteTooltipTableCell */], { note: record.minor_note }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center td-shrink-icon" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LineItemControls__["a" /* default */], { lineItem: record, purchaseOrderId: purchaseOrderId })
    )
  );
}

Row.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  statuses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

function Table(_ref2) {
  var results = _ref2.results,
      isLoading = _ref2.isLoading,
      purchaseOrderId = _ref2.purchaseOrderId;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */],
    { loading: isLoading },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "REC #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "REC Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Store Loc"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "COND Rec"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "QTY Rec"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "AWB #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Status"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Minor Notes"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (record) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row, {
          key: record.id,
          record: record,
          purchaseOrderId: purchaseOrderId
        });
      })
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "nav",
    {
      className: "text-center margin-top-none",
      "aria-label": "Search results pages"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__orange_marmalade_paginate_this__["Paginator"], { listId: "purchaseOrders/receivedCores" })
  )];
}

Table.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var ConnectedTable = __WEBPACK_IMPORTED_MODULE_9__orange_marmalade_paginate_this__["decorators"].tabulate(Table);

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConnectedTable, _extends({ listId: "purchaseOrders/receivedCores" }, props));
});

/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DownloadCocModal_DownloadCocModal__ = __webpack_require__(1526);






function LineItemControls(_ref) {
  var lineItem = _ref.lineItem,
      purchaseOrderId = _ref.purchaseOrderId;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["c" /* ImprovedDropDown */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
        id: "download-coc",
        label: "Download CoC",
        faIcon: "download",
        renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DownloadCocModal_DownloadCocModal__["a" /* DownloadCocModal */], {
          lineItem: lineItem,
          purchaseOrderId: purchaseOrderId
        })
      })
    )
  );
}

LineItemControls.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (LineItemControls);

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators_loadRecord__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Attachments_Attachments__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_Notes_Notes__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Orders_shared_Contact__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TraceHoldDetails__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Billing_Billing__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_components_DashedSeparator_DashedSeparator__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ReceivingRecordsTable_ReceivingRecordsTable__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_components_Note__ = __webpack_require__(2360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CoreReceivedTable_CoreReceivedTable__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_components_VendorDetail_VendorDetail__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__shared_components_ApprovalDetails_ApprovalDetails__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__PhysicalAddress__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ShippingAddress__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Orders_shared_ShippingPreference__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ShippingDetails__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Edit_EditPurchaseOrder__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Header__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__LineItemsTable_LineItemsTable__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__LineItemsTable_AddPart_AddPart__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__RejectionDetails__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__constants__ = __webpack_require__(19);
/* unused harmony export Detail */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





































var Detail = function (_React$Component) {
  _inherits(Detail, _React$Component);

  function Detail() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Detail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Detail.__proto__ || Object.getPrototypeOf(Detail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editPOModalOpen: false,
      addPartModalOpen: false,
      editInvoiceModalOpen: false,
      editPartModalOpen: false,
      initialPartFormValues: {}
    }, _this.openEditPOModal = function () {
      _this.setState({ editPOModalOpen: true });
    }, _this.openEditInvoiceModal = function () {
      _this.setState({ editInvoiceModalOpen: true });
    }, _this.openAddPartModal = function () {
      return _this.setState({ addPartModalOpen: true });
    }, _this.closeAddPartModal = function () {
      return _this.setState({ addPartModalOpen: false, initialPartFormValues: null });
    }, _this.closeEditPOModal = function () {
      return _this.setState({ editPOModalOpen: false });
    }, _this.closeEditInvoiceModal = function () {
      return _this.setState({ editInvoiceModalOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Detail, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.location.state && this.props.location.state.open) {
        this.setState({
          addPartModalOpen: true,
          initialPartFormValues: this.props.location.state.part,
          id: this.props.location.state.id
        });
      }
    }
  }, {
    key: "purchaseOrderReceived",
    value: function purchaseOrderReceived() {
      var purchaseOrder = this.props.purchaseOrder.toJS();

      return !!purchaseOrder.line_items.length && purchaseOrder.line_items.every(function (item) {
        return item.quantity === item.quantity_received;
      });
    }
  }, {
    key: "purchaseOrderWithOneOrMoreLineItemsPaid",
    value: function purchaseOrderWithOneOrMoreLineItemsPaid() {
      var purchaseOrder = this.props.purchaseOrder.toJS();

      return !!purchaseOrder.line_items.length && purchaseOrder.line_items.some(function (item) {
        return ![null, undefined].includes(item.amount_paid) && item.amount_paid >= item.cost * item.quantity;
      });
    }
  }, {
    key: "userCanEdit",
    value: function userCanEdit() {
      var currentUser = this.props.currentUser;

      var purchaseOrder = this.props.purchaseOrder.toJS();
      var buyerId = purchaseOrder.buyer_id,
          coBuyerId = purchaseOrder.co_buyer_id,
          thirdBuyerId = purchaseOrder.third_buyer_id;


      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__users_helpers__["i" /* hasAnyOfRolesOrSubroles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_8__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["p" /* QUALITY_CONTROL */]], [__WEBPACK_IMPORTED_MODULE_8__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]) || currentUser.id === buyerId || currentUser.id === coBuyerId || currentUser.id === thirdBuyerId;
    }
  }, {
    key: "inventoryLocked",
    value: function inventoryLocked() {
      var purchaseOrder = this.props.purchaseOrder.toJS();

      var paid = this.purchaseOrderWithOneOrMoreLineItemsPaid();
      var userCanEdit = this.userCanEdit();

      return !userCanEdit || paid || purchaseOrder.cancelled;
    }
  }, {
    key: "shippingDetailsUnlocked",
    value: function shippingDetailsUnlocked() {
      var currentUser = this.props.currentUser;


      var userCanEdit = this.userCanEdit();
      var isWarehouseManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__users_helpers__["g" /* hasSubRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_8__users_constants__["s" /* WAREHOUSE_MANAGER */]);
      return userCanEdit || isWarehouseManager;
    }
  }, {
    key: "render",
    value: function render() {
      var _state = this.state,
          editPOModalOpen = _state.editPOModalOpen,
          addPartModalOpen = _state.addPartModalOpen,
          initialPartFormValues = _state.initialPartFormValues,
          id = _state.id;

      var purchaseOrder = this.props.purchaseOrder.toJS();
      var lineItems = purchaseOrder.line_items;
      var locked = this.inventoryLocked();
      var shippingDetailsUnlocked = this.shippingDetailsUnlocked();
      var received = this.purchaseOrderReceived();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Header__["a" /* default */], { purchaseOrder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_immutable__["fromJS"])(purchaseOrder), received: received }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "panel panel-default" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "panel-body" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h2",
                  { style: { marginTop: 10 } },
                  "Details",
                  !locked && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["y" /* EditButton */], { handleClick: this.openEditPOModal }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__Edit_EditPurchaseOrder__["a" /* default */], {
                    purchaseOrder: purchaseOrder,
                    open: editPOModalOpen,
                    close: this.closeEditPOModal
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__shared_components_VendorDetail_VendorDetail__["a" /* VendorDetail */], { record: purchaseOrder }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__PhysicalAddress__["a" /* PhysicalAddress */], {
                  address: purchaseOrder.company.billing_address
                }),
                !purchaseOrder.portal_purchase && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Orders_shared_Contact__["a" /* default */], { contact: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_immutable__["fromJS"])(purchaseOrder.contact) })],
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__shared_components_ApprovalDetails_ApprovalDetails__["a" /* ApprovalDetails */], { record: purchaseOrder }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__RejectionDetails__["a" /* RejectionDetails */], { purchaseOrder: purchaseOrder }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__TraceHoldDetails__["a" /* TraceHoldDetail */], { purchaseOrder: purchaseOrder }),
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(purchaseOrder, ["line_items[0]", __WEBPACK_IMPORTED_MODULE_13__RepairOrders_constants__["d" /* PURCHASE_FOR_EXCHANGE */]].join(".")) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Billing_Billing__["a" /* default */], null)],
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__ShippingDetails__["a" /* default */], {
                  purchaseOrder: purchaseOrder,
                  unlocked: shippingDetailsUnlocked
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null),
                purchaseOrder.ship_to_address && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__ShippingAddress__["a" /* ShippingAddress */], { purchaseOrder: purchaseOrder }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null),
                purchaseOrder.shipping_method && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__Orders_shared_ShippingPreference__["a" /* ShippingPreference */], {
                  shippingMethod: purchaseOrder.shipping_method,
                  amountInsured: purchaseOrder.amt_insured,
                  pctInsured: purchaseOrder.pct_insured
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["z" /* AuditFields */], { record: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_immutable__["fromJS"])(purchaseOrder), multiLine: true })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 9 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              { style: { marginTop: 26 } },
              "Parts",
              (!locked || this.props.currentUser.role === __WEBPACK_IMPORTED_MODULE_8__users_constants__["i" /* ADMIN */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "button",
                {
                  type: "button",
                  className: "btn btn-primary btn-hollow pull-right",
                  onClick: this.openAddPartModal
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "i",
                  { className: "fa fa-fw fa-plus" },
                  "\xA0"
                ),
                "Add Part"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__LineItemsTable_AddPart_AddPart__["a" /* default */], {
                open: addPartModalOpen,
                close: this.closeAddPartModal,
                paid: this.purchaseOrderWithOneOrMoreLineItemsPaid(),
                part: initialPartFormValues,
                id: id
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__LineItemsTable_LineItemsTable__["a" /* default */], { results: lineItems }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "row" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                { sm: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h2",
                  { style: { marginTop: 26 } },
                  "Received"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ReceivingRecordsTable_ReceivingRecordsTable__["a" /* default */], null)
              )
            ),
            lineItems.length > 0 && lineItems.some(function (f) {
              return f.purchase_for_exchange;
            }) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "row" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                { sm: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h2",
                  { style: { marginTop: 26 } },
                  "Cores Assigned To Return"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__CoreReceivedTable_CoreReceivedTable__["a" /* default */], { purchaseOrderId: purchaseOrder.id })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "row" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                { sm: 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components_Note__["a" /* default */], {
                  header: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_34__constants__["G" /* INTERNAL_NOTE */]),
                  type: __WEBPACK_IMPORTED_MODULE_34__constants__["G" /* INTERNAL_NOTE */],
                  record: purchaseOrder,
                  update: __WEBPACK_IMPORTED_MODULE_24__actions__["h" /* update */]
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                { sm: 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components_Note__["a" /* default */], {
                  header: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_34__constants__["c" /* EXTERNAL_NOTE */]),
                  record: purchaseOrder,
                  type: __WEBPACK_IMPORTED_MODULE_34__constants__["c" /* EXTERNAL_NOTE */],
                  update: __WEBPACK_IMPORTED_MODULE_24__actions__["h" /* update */]
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_Notes_Notes__["a" /* default */], {
              headerLabel: "Follow Up Notes",
              resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_immutable__["fromJS"])(this.props.purchaseOrder),
              resourceType: __WEBPACK_IMPORTED_MODULE_11__shared_types_resourceTypes__["a" /* default */].purchaseOrder,
              resourceKey: "purchaseOrder"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_Notes_Notes__["a" /* default */], {
              resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_immutable__["fromJS"])(this.props.purchaseOrder),
              resourceType: __WEBPACK_IMPORTED_MODULE_11__shared_types_resourceTypes__["a" /* default */].purchaseOrder,
              resourceKey: "purchaseOrder",
              trace: true
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_Attachments_Attachments__["a" /* default */], {
              attachmentTypes: __WEBPACK_IMPORTED_MODULE_34__constants__["V" /* ATTACHMENT_TYPES */],
              multiple: true,
              resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_immutable__["fromJS"])(purchaseOrder),
              resourceType: __WEBPACK_IMPORTED_MODULE_11__shared_types_resourceTypes__["a" /* default */].purchaseOrder,
              resourceKey: "purchaseOrder"
            })
          )
        )
      );
    }
  }]);

  return Detail;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Detail.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_6_immutable__["Map"]),
  currentUser: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(Object),
  location: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    state: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
      part: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(Object),
      open: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
      id: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
    })
  })
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    purchaseOrder: state.purchaseOrderDetail.get("purchaseOrder"),
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_8__users_constants__["a" /* USER */]).toJS()
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators_loadRecord__["a" /* default */])({
  reducer: "purchaseOrderDetail",
  name: "purchaseOrder",
  action: __WEBPACK_IMPORTED_MODULE_24__actions__["i" /* show */]
})(Detail)));

/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(1527);
/* harmony export (immutable) */ __webpack_exports__["a"] = DownloadCocModal;





function DownloadCocModal(_ref) {
  var lineItem = _ref.lineItem,
      open = _ref.open,
      purchaseOrderId = _ref.purchaseOrderId,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-md" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Are You Sure?"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], {
        close: close,
        lineItem: lineItem,
        purchaseOrderId: purchaseOrderId
      })
    )
  );
}

DownloadCocModal.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* unused harmony export Form */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








function Form(_ref) {
  var close = _ref.close,
      lineItem = _ref.lineItem,
      purchaseOrderId = _ref.purchaseOrderId;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(lineItem, "inventories[0].purchase_order_line_item.invoice_number") || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(lineItem, "inventory.purchase_order_line_item.invoice_number")),
      _useState2 = _slicedToArray(_useState, 2),
      sellersContractNumber = _useState2[0],
      setSellersContractNumber = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(lineItem.company_name),
      _useState4 = _slicedToArray(_useState3, 2),
      obtainedFrom = _useState4[0],
      setObtainedFrom = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState6 = _slicedToArray(_useState5, 2),
      referenceNumber = _useState6[0],
      setReferenceNumber = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState8 = _slicedToArray(_useState7, 2),
      certPreparedFor = _useState8[0],
      setCertPreparedFor = _useState8[1];

  var url = void 0;

  if (lineItem.record_type === "ReceivingRecord") {
    url = __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* API_BASE */] + "/sales_order_line_items/" + lineItem.reference_record_line_item_id + ("/download_certificate_of_conformance?received_core=true&obtained_from_type=other&obtained_from_text=" + (obtainedFrom || "") + "&sellers_contract_number=" + (sellersContractNumber || ""));
  } else {
    url = __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* API_BASE */] + "/purchase_orders/" + purchaseOrderId + "/received_cores/" + lineItem.id + ("/download_certificate_of_conformance?received_core=true&obtained_from_type=other&obtained_from_text=" + (obtainedFrom || "") + "&sellers_contract_number=" + (sellersContractNumber || "") + "&cert_prepared_for=" + (certPreparedFor || "") + "&reference_number=" + referenceNumber);
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "obtained_from" },
            "Obtained From"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            type: "text",
            name: "obtained_from",
            className: "form-control",
            value: obtainedFrom,
            onChange: function onChange(e) {
              return setObtainedFrom(e.target.value);
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "sellers_contract_number" },
            "Seller's Contract #:"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            type: "text",
            name: "sellers_contract_number",
            className: "form-control",
            value: sellersContractNumber,
            onChange: function onChange(e) {
              return setSellersContractNumber(e.target.value);
            }
          })
        )
      )
    ),
    lineItem.record_type !== "ReceivingRecord" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "reference_number" },
            "Reference #"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            type: "text",
            name: "reference_number",
            className: "form-control",
            value: referenceNumber,
            onChange: function onChange(e) {
              return setReferenceNumber(e.target.value);
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "cert_prepared_for" },
            "Cert Prepared For"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            type: "text",
            name: "cert_prepared_for",
            className: "form-control",
            value: certPreparedFor,
            onChange: function onChange(e) {
              return setCertPreparedFor(e.target.value);
            }
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "clearfix" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          className: "pull-right btn btn-primary",
          onClick: function onClick() {
            window.open(url, "_blank");
            close();
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "\xA0Download CoC "
        )
      )
    )
  );
}

Form.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Orders_shared_EditInvoiceDetailsForm__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(19);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditInvoiceDetails;












function EditInvoiceDetails(_ref) {
  var purchaseOrder = _ref.purchaseOrder;

  if (purchaseOrder.get("cancelled")) {
    return false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown_DropDownItem__["a" /* default */],
        { onClick: open },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["k" /* Icon */], { name: "dollar", fixed: true }),
        "\xA0Edit Billing",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__["a" /* Modal */],
          { open: visible, close: close, dialogClass: "modal-lg" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__["c" /* Close */], { close: close }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Edit Billing Details"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Orders_shared_EditInvoiceDetailsForm__["a" /* EditInvoiceDetailsForm */], {
            close: close,
            displaySerial: true,
            order: purchaseOrder.toJS(),
            orderType: __WEBPACK_IMPORTED_MODULE_10__constants__["x" /* PURCHASE_ORDER */],
            initialValues: Object.assign(purchaseOrder.toJS(), {
              invoice_paid_date: null,
              invoice_date: null,
              invoice_number: null,
              line_items: purchaseOrder.toJS().line_items.filter(function (l) {
                return !l.cancelled;
              }).map(function (l) {
                return {
                  id: l.id,
                  amount_paid: l.amount_paid,
                  inventory: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(l.inventory, {
                    serial_number: l.serial_number || l.expected_serial_number
                  }),
                  part: l.part,
                  invoice_number: l.invoice_number,
                  invoice_date: l.invoice_date,
                  invoice_paid_date: l.invoice_paid_date,
                  invoice_due_date: l.invoice_due_date
                };
              })
            }),
            bulkUpdate: __WEBPACK_IMPORTED_MODULE_9__actions__["o" /* bulkUpdateLineItems */]
          })
        )
      );
    }
  );
}

EditInvoiceDetails.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
};

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditInvoiceDetails__ = __webpack_require__(1528);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EditInvoiceDetails__["a"]; });


/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_RecordPager_RecordPager__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_components_ActionDropDown_ActionDropDown__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SetTraceHold__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_components_RemoveFromQCHold__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_components_SendEmail_SendEmail__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__UpdateQcStatus_UpdateQcStatus__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Sync_Sync__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ToggleQuickbooksSync_ToggleQuickbooksSync__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__StatusTags__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Warnings__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Send__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__EditInvoiceDetails__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Send_SendModal__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__SendCancelledPo__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__CancelSendPo_CancelSendPo__ = __webpack_require__(1521);
/* unused harmony export Header */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

































var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      approvePOModalOpen: false,
      cancelPOModalOpen: false,
      releaseExportHoldModalOpen: false,
      cancellationReason: __WEBPACK_IMPORTED_MODULE_8__constants__["I" /* CANCELLATION_REASONS */][0].value,
      sendToModalOpen: false,
      showSendCancelledPoModal: false
    }, _this.onConfirmToRemoveFormQCHoldClick = function () {
      var updatePurchaseOrder = _this.props.updatePurchaseOrder;

      updatePurchaseOrder({ qc_hold: false });
    }, _this.setTraceHold = function (approveTraceHold) {
      var traceHoldSet = _this.props.setTraceHold;

      traceHoldSet(approveTraceHold);
    }, _this.openApprovePOModalOpen = function () {
      _this.setState({ approvePOModalOpen: true });
    }, _this.closeApprovePOModalOpen = function () {
      _this.setState({ approvePOModalOpen: false });
    }, _this.openSendToModal = function () {
      _this.setState({ sendToModalOpen: true });
    }, _this.closeSendToModal = function () {
      _this.setState({ sendToModalOpen: false });
    }, _this.handleSelectChange = function (e) {
      _this.setState({ cancellationReason: e.target.value });
    }, _this.openReleaseExportHoldModal = function () {
      return _this.setState({ releaseExportHoldModalOpen: true });
    }, _this.closeReleaseExportHoldModal = function () {
      return _this.setState({ releaseExportHoldModalOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          currentUser = _props.currentUser,
          purchaseOrder = _props.purchaseOrder,
          approvePurchaseOrder = _props.approvePurchaseOrder,
          _props$received = _props.received,
          received = _props$received === undefined ? false : _props$received,
          releaseExportHold = _props.releaseExportHold,
          id = _props.id;
      var _state = this.state,
          approvePOModalOpen = _state.approvePOModalOpen,
          cancelPOModalOpen = _state.cancelPOModalOpen,
          releaseExportHoldModalOpen = _state.releaseExportHoldModalOpen,
          sendToModalOpen = _state.sendToModalOpen,
          showSendCancelledPoModal = _state.showSendCancelledPoModal;

      var url = __WEBPACK_IMPORTED_MODULE_9__constants__["d" /* API_BASE */] + "/purchase_orders/" + id + "/download";
      var cancelled = purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_38" /* CANCELLED */]);
      var lineItems = purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["A" /* LINE_ITEMS */]);
      var fullyReceived = lineItems.size > 0 && lineItems.every(function (item) {
        return item.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_26" /* RECEIVED */]);
      });
      var isInHold = purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["S" /* QC_HOLD */]);
      var buyerId = purchaseOrder.get("buyer_id");
      var coBuyerId = purchaseOrder.get("co_buyer_id");

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "page-header page-header-bar" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__Send_SendModal__["a" /* SendModal */], {
          purchaseOrder: purchaseOrder,
          visible: sendToModalOpen,
          close: this.closeSendToModal
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h1",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "btn-group pull-right", style: { marginLeft: 20 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_15__shared_components_ActionDropDown_ActionDropDown__["a" /* default */],
              {
                menuClass: "dropdown-menu-right",
                style: { cursor: "pointer" }
              },
              !cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12__shared_components_DropDown_DropDownItem__["a" /* default */],
                {
                  onClick: this.openApprovePOModalOpen,
                  disabled: !purchaseOrder.get("can_approve")
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" }),
                "\xA0Approve PO"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6__shared_components__["b" /* Authorized */],
                { roles: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["p" /* QUALITY_CONTROL */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__EditInvoiceDetails__["a" /* default */], { purchaseOrder: purchaseOrder })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                !isInHold && (!purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["S" /* TRACE_HOLD */]) || purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_0" /* TRACE_HOLD_APPROVED */])) && (purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_1" /* ALLOW_SENDING */]) || currentUser.role === __WEBPACK_IMPORTED_MODULE_7__users_constants__["i" /* ADMIN */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                  null,
                  !cancelled && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Send__["a" /* default */], { purchaseOrder: purchaseOrder }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__UpdateQcStatus_UpdateQcStatus__["a" /* default */], { purchaseOrder: purchaseOrder }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "li",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6__shared_components__["r" /* ExternalLink */],
                      { url: url },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["k" /* Icon */], { name: "file-text-o", fixed: true }),
                      "\xA0Download PO"
                    )
                  )]
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6__shared_components__["b" /* Authorized */],
                  {
                    roles: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["p" /* QUALITY_CONTROL */]],
                    subroles: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_12__shared_components_DropDown_DropDownItem__["a" /* default */],
                    { onClick: this.openReleaseExportHoldModal },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" }),
                    "\xA0Release Export Hold"
                  )
                ),
                !isInHold && (!purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["S" /* TRACE_HOLD */]) || purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_0" /* TRACE_HOLD_APPROVED */])) && (purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_1" /* ALLOW_SENDING */]) || currentUser.role === __WEBPACK_IMPORTED_MODULE_7__users_constants__["i" /* ADMIN */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                  null,
                  !cancelled && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components_SendEmail_SendEmail__["a" /* default */], {
                    record: purchaseOrder,
                    label: "request for shipping status",
                    url: __WEBPACK_IMPORTED_MODULE_18__api__["a" /* default */].purchaseOrders,
                    type: "status",
                    warning: purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["o" /* SHIPPING_TYPE */]) === __WEBPACK_IMPORTED_MODULE_8__constants__["d" /* DO_NOT_SHIP */] && "'Do not ship' selected."
                  })]
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6__shared_components__["b" /* Authorized */],
                { roles: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["p" /* QUALITY_CONTROL */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_RemoveFromQCHold__["a" /* default */], {
                  order: purchaseOrder,
                  onConfirm: this.onConfirmToRemoveFormQCHoldClick
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__SetTraceHold__["a" /* default */], {
                  onConfirm: function onConfirm() {
                    return _this2.setTraceHold(true);
                  },
                  purchaseOrder: purchaseOrder,
                  traceApproved: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__SetTraceHold__["a" /* default */], {
                  onConfirm: function onConfirm() {
                    return _this2.setTraceHold(false);
                  },
                  purchaseOrder: purchaseOrder,
                  traceApproved: false
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6__shared_components__["b" /* Authorized */],
                { roles: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["m" /* ACCOUNTING */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__ToggleQuickbooksSync_ToggleQuickbooksSync__["a" /* default */], { purchaseOrder: purchaseOrder }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__Sync_Sync__["a" /* default */], { purchaseOrder: purchaseOrder })
              ),
              !cancelled && !received && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { className: "divider" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6__shared_components__["T" /* Forbidden */],
                {
                  roles: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["j" /* WAREHOUSE */]],
                  buyerId: buyerId,
                  coBuyerId: coBuyerId
                },
                !received && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                  null,
                  cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__SendCancelledPo__["a" /* default */], {
                    purchaseOrder: purchaseOrder,
                    showModal: showSendCancelledPoModal,
                    onClose: function onClose() {
                      return _this2.setState({ showSendCancelledPoModal: false });
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__CancelSendPo_CancelSendPo__["a" /* default */], {
                    cancelled: cancelled,
                    cancelPurchaseOrder: this.props.cancelPurchaseOrder,
                    purchaseOrder: purchaseOrder
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "with-padding" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_RecordPager_RecordPager__["a" /* default */], { baseUrl: "/purchase-orders", record: purchaseOrder }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "header-content" },
              purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["z" /* CODE */])
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["E" /* ClipboardCopy */], { name: purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["z" /* CODE */]), type: "PO" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "small text-muted" },
              "Created ",
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["b" /* shortDate */])(purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_7" /* CREATED_AT */]))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "pull-right" },
              purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["S" /* QC_HOLD */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["p" /* StatusTag */], { title: "QC Hold", icon: "pause", display: "danger" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { className: "small text-muted" },
                purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["A" /* LINE_ITEMS */], []).size,
                " Item(s)"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                null,
                "Total: ",
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__["a" /* dollars */])(purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_71" /* TOTAL */]))
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__StatusTags__["a" /* default */], {
              purchaseOrder: purchaseOrder,
              rejected: purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["T" /* REJECTED */]),
              traceHold: purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["S" /* TRACE_HOLD */]),
              traceHoldApproved: purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_0" /* TRACE_HOLD_APPROVED */]),
              received: fullyReceived,
              requiresApproval: purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_2" /* REQUIRES_APPROVAL */])
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "alert-group pull-right" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__Warnings__["b" /* default */], { purchaseOrder: purchaseOrder })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
          {
            onConfirm: approvePurchaseOrder,
            open: approvePOModalOpen,
            close: this.closeApprovePOModalOpen,
            icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" }),
            btnText: "Yes, Approve PO"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            null,
            "Are you sure you want to approve this PO?"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
          {
            onConfirm: releaseExportHold,
            open: releaseExportHoldModalOpen,
            close: this.closeReleaseExportHoldModal,
            icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" }),
            btnText: "Yes, Release Export Hold"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            null,
            "Are you sure you want to release this Export Hold?"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components__["T" /* Forbidden */],
          { roles: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["j" /* WAREHOUSE */]], buyerId: buyerId, coBuyerId: coBuyerId },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
            {
              onConfirm: this.handleCancelPurchaseOrder,
              close: this.closeCancelPOModal,
              open: cancelPOModalOpen,
              btnClass: cancelled ? "btn-primary" : "btn-danger",
              btnText: cancelled ? "Reverse Cancellation" : "Yes, Cancel PO",
              cancelText: cancelled ? "Cancel" : "Do Not Cancel PO",
              icon: cancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-refresh" }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" })
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              null,
              "Heads up!"
            ),
            "\xA0",
            cancelled ? "Are you sure you want to reverse this cancelled order?" : "Cancelling a PO will cancel all line items associated with it.",
            !cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: "control-label", htmlFor: "cancellation_reason" },
                "Cancellation Reason"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "select",
                {
                  className: "form-control",
                  name: "cancellation_reason",
                  onChange: this.handleSelectChange
                },
                __WEBPACK_IMPORTED_MODULE_8__constants__["I" /* CANCELLATION_REASONS */].map(function (reason) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "option",
                    { key: reason.value, value: reason.value },
                    reason.text
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    id: state.purchaseOrderDetail.getIn(["purchaseOrder", "id"])
  };
}, function (dispatch) {
  return {
    cancelPurchaseOrder: function cancelPurchaseOrder(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions__["j" /* cancel */])(data));
    },
    approvePurchaseOrder: function approvePurchaseOrder() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions__["k" /* approve */])());
    },
    releaseExportHold: function releaseExportHold() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions__["h" /* update */])({ export_hold: false }));
    },
    setTraceHold: function setTraceHold(val) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions__["l" /* setTraceHold */])(val));
    },
    updatePurchaseOrder: function updatePurchaseOrder(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions__["h" /* update */])(data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__session_decorators_withCurrentUser__["b" /* default */])(Header)));

Header.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  received: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  approvePurchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cancelPurchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setTraceHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updatePurchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Form__ = __webpack_require__(242);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();












function AddPart(_ref) {
  var open = _ref.open,
      close = _ref.close,
      paid = _ref.paid,
      onSubmit = _ref.onSubmit,
      part = _ref.part,
      id = _ref.id,
      purchaseOrder = _ref.purchaseOrder,
      currentUser = _ref.currentUser;

  var initialValues = {
    request_vendor_approval: false,
    request_shop_approval: false,
    same_as_billing: true,
    evaluation_period: 30,
    reserve_for_seller_id: currentUser.get(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* ID */]),
    read_only_buyer: purchaseOrder.getIn([__WEBPACK_IMPORTED_MODULE_7__users_constants__["P" /* BUYER */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["f" /* FULL_NAME */]]),
    insurance_type: "None",
    cancelled: false,
    cost: paid ? "0" : undefined,
    purchase_for_sale: false,
    purchase_for_stock: false,
    purchase_for_repair: false,
    purchase_for_repair_assist: false,
    buyer_credit_pct: 75
  };

  var lineItem = part && { part: part, part_id: part.id };

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPart = _useState2[0],
      setSelectedPart = _useState2[1];

  var domLifeYears = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(selectedPart, "dom_life_years");
  var llp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(selectedPart, "llp");

  if (!purchaseOrder.get("buyers_discrepancy")) {
    initialValues.buyer_credit_pct = purchaseOrder.get("buyer_credit_pct");
    initialValues.co_buyer_id = purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["z" /* CO_BUYER_ID */]);
    initialValues.third_buyer_id = purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["y" /* THIRD_BUYER_ID */]);
    if (lineItem) {
      lineItem.co_buyer = purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["_5" /* CO_BUYER */]) && purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["_5" /* CO_BUYER */]).toJS();
      lineItem.third_buyer = purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["_21" /* THIRD_BUYER */]) && purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["_21" /* THIRD_BUYER */]).toJS();
    }
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Add a Part"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Form__["a" /* default */], {
      close: close,
      displaySrpInventoryTable: true,
      initialValues: initialValues,
      selectedPart: selectedPart,
      setSelectedPart: setSelectedPart,
      domLifeYears: domLifeYears,
      llp: llp,
      lineItem: lineItem,
      paid: paid,
      id: id,
      shippingType: purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["o" /* SHIPPING_TYPE */]),
      onSubmit: onSubmit
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    purchaseOrder: state.purchaseOrderDetail.get("purchaseOrder"),
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["a" /* USER */])
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["d" /* addLineItem */](data));
    }
  };
})(AddPart));

AddPart.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  part: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(Object),
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  currentUser: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(62);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var CancelModal = function (_React$Component) {
  _inherits(CancelModal, _React$Component);

  function CancelModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CancelModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CancelModal.__proto__ || Object.getPrototypeOf(CancelModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      cancellationReason: "previously_sold"
    }, _this.sendRequestAndClose = function (data) {
      var _this$props = _this.props,
          update = _this$props.update,
          close = _this$props.close,
          lineItem = _this$props.lineItem;


      update(lineItem.id, data);
      close();
    }, _this.handleSelectChange = function (e) {
      _this.setState({ cancellationReason: e.target.value });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CancelModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          lineItem = _props.lineItem,
          open = _props.open,
          close = _props.close;
      var cancellationReason = this.state.cancellationReason;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
        { open: open, close: close, dialogClass: "modal-sm" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            { className: "modal-title" },
            "Cancel Part"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["e" /* Body */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              { className: "control-label", htmlFor: "cancellation_reason" },
              "Cancellation Reason"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "select",
              {
                className: "form-control",
                name: "cancellation_reason",
                onChange: function onChange(e) {
                  return _this2.handleSelectChange(e);
                }
              },
              __WEBPACK_IMPORTED_MODULE_4__constants__["I" /* CANCELLATION_REASONS */].map(function (reason) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "option",
                  { key: reason.value, value: reason.value },
                  reason.text
                );
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["d" /* Footer */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            { type: "button", className: "btn btn-default", onClick: close },
            "Cancel"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            {
              type: "submit",
              className: "btn btn-primary",
              onClick: function onClick() {
                return _this2.sendRequestAndClose({
                  cancelled: !lineItem.cancelled,
                  cancellation_reason: cancellationReason
                });
              }
            },
            "Save"
          )
        )
      );
    }
  }]);

  return CancelModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CancelModal.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  update: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    update: function update(id, data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["g" /* updateLineItem */])(id, data));
    }
  };
})(CancelModal));

/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inventories_helpers__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_NumberInput_NumberInput__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Form__ = __webpack_require__(242);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















function EditPart(_ref) {
  var _extends2;

  var open = _ref.open,
      close = _ref.close,
      selectedLineItem = _ref.selectedLineItem,
      onSubmit = _ref.onSubmit,
      purchaseOrder = _ref.purchaseOrder,
      currentUser = _ref.currentUser;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(selectedLineItem, "part", {})),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPart = _useState2[0],
      setSelectedPart = _useState2[1];

  var initialValues = _extends({}, selectedLineItem, (_extends2 = {}, _defineProperty(_extends2, __WEBPACK_IMPORTED_MODULE_12__constants__["Q" /* ALLOCATE_TO_SO */], !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(selectedLineItem, __WEBPACK_IMPORTED_MODULE_12__constants__["P" /* PURCHASED_FOR_SOLI_ID */])), _defineProperty(_extends2, "amount_paid", selectedLineItem ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_NumberInput_NumberInput__["b" /* rounder */])(selectedLineItem.amount_paid) : null), _defineProperty(_extends2, "cost", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_NumberInput_NumberInput__["b" /* rounder */])(selectedLineItem && selectedLineItem.cost)), _defineProperty(_extends2, "displayCoBuyer1", !!(selectedLineItem && selectedLineItem.co_buyer_id)), _defineProperty(_extends2, "displayCoBuyer2", !!(selectedLineItem && selectedLineItem.third_buyer_id)), _defineProperty(_extends2, "exchange_srp", selectedLineItem ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_NumberInput_NumberInput__["b" /* rounder */])(selectedLineItem.exchange_srp) : null), _defineProperty(_extends2, "created_at", purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_7" /* CREATED_AT */])), _defineProperty(_extends2, "insurance_type", selectedLineItem && selectedLineItem.insurance_type), _defineProperty(_extends2, "displayCoBuyerFields", !!(selectedLineItem && selectedLineItem.co_buyer_id)), _defineProperty(_extends2, "displayThirdBuyerFields", !!(selectedLineItem && selectedLineItem.third_buyer_id)), _defineProperty(_extends2, "other", !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(selectedLineItem && selectedLineItem.other_tag_type)), _defineProperty(_extends2, "read_only_buyer", purchaseOrder.getIn([__WEBPACK_IMPORTED_MODULE_7__users_constants__["P" /* BUYER */], "full_name"])), _defineProperty(_extends2, "reserve_for_seller_id", selectedLineItem && selectedLineItem.reserve_for_seller_id || currentUser.get(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* ID */])), _defineProperty(_extends2, "suggested_retail", selectedLineItem ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_NumberInput_NumberInput__["b" /* rounder */])(selectedLineItem && selectedLineItem.suggested_retail) : null), _defineProperty(_extends2, "tagged_by", selectedLineItem && selectedLineItem.tagged_by), _defineProperty(_extends2, "tagged_by_id", selectedLineItem && selectedLineItem.tagged_by_id), _defineProperty(_extends2, "tagged_by_hold", selectedLineItem && selectedLineItem.tagged_by_hold), _defineProperty(_extends2, "total_cycles_remaining", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__inventories_helpers__["b" /* totalCyclesRemaining */])(selectedPart, Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(selectedLineItem, __WEBPACK_IMPORTED_MODULE_9__parts_constants__["F" /* TOTAL_CYCLES */])))), _defineProperty(_extends2, "total_hours_remaining", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__inventories_helpers__["a" /* totalHoursRemaining */])(selectedPart, Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(selectedLineItem, __WEBPACK_IMPORTED_MODULE_9__parts_constants__["E" /* TOTAL_HOURS */])))), _extends2));

  var lineItem = {
    co_buyer: purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["_5" /* CO_BUYER */]) && purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["_5" /* CO_BUYER */]).toJS(),
    third_buyer: purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["_21" /* THIRD_BUYER */]) && purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["_21" /* THIRD_BUYER */]).toJS()
  };

  var domLifeYears = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(selectedPart, __WEBPACK_IMPORTED_MODULE_9__parts_constants__["T" /* DOM_LIFE_YEARS */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(initialValues, "part.dom_life_years"));
  var llp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(selectedPart, __WEBPACK_IMPORTED_MODULE_9__parts_constants__["D" /* LLP */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(initialValues, "part.llp"));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Part"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Form__["a" /* default */], {
      onSubmit: onSubmit,
      close: close,
      shippingType: purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["o" /* SHIPPING_TYPE */]),
      initialValues: initialValues,
      selectedPart: selectedPart,
      setSelectedPart: setSelectedPart,
      domLifeYears: domLifeYears,
      llp: llp,
      lineItem: lineItem,
      enableReinitialize: true,
      selectedLineItem: selectedLineItem,
      showExpectedDateField: true
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    purchaseOrder: state.purchaseOrderDetail.get("purchaseOrder"),
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["a" /* USER */])
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["g" /* updateLineItem */](ownProps.selectedLineItem.id, data));
    }
  };
})(EditPart));

EditPart.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])
};

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__decorators_withPurchaseOrder__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Outright_Outright__ = __webpack_require__(672);
/* unused harmony export Exchange */
/* unused harmony export exchange */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















function Exchange(_ref) {
  var exchange = _ref.exchange,
      exchanging = _ref.exchanging,
      open = _ref.open,
      close = _ref.close,
      _ref$confirmConfig = _ref.confirmConfig,
      text = _ref$confirmConfig.text,
      actionText = _ref$confirmConfig.actionText;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["k" /* Icon */], { name: "refresh", fixed: true }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "with-padding" },
      text
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components__["i" /* ConfirmAction */],
      { onConfirm: exchange, close: close, open: exchanging },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up! "
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        actionText
      )
    )
  );
}

Exchange.propTypes = _extends({
  exchange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  exchanging: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  confirmConfig: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_9__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

var withExchange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var _ref2$lineItem = _ref2.lineItem,
      exchangeType = _ref2$lineItem.exchange_type,
      itemId = _ref2$lineItem.id,
      close = _ref2.close,
      pushHistory = _ref2.pushHistory;
  return {
    exchange: function exchange() {
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].purchaseOrders.lineItems.exchange(itemId).then(function (_ref3) {
        var id = _ref3.data.id;

        pushHistory({ pathname: "/purchase-orders/" + id });
        close();
      });
    },
    confirmConfig: exchangeType === null ? __WEBPACK_IMPORTED_MODULE_8__SalesOrders_constants__["V" /* EXCHANGE_CONFIG */][__WEBPACK_IMPORTED_MODULE_8__SalesOrders_constants__["W" /* NOT_EXCHANGED */]] : __WEBPACK_IMPORTED_MODULE_8__SalesOrders_constants__["V" /* EXCHANGE_CONFIG */][__WEBPACK_IMPORTED_MODULE_8__SalesOrders_constants__["l" /* SECOND_EXCHANGE */]]
  };
});

var meetsExchangeCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["a" /* renderIf */])(function (_ref4) {
  var lineItem = _ref4.lineItem,
      role = _ref4.currentUser.role;
  return [__WEBPACK_IMPORTED_MODULE_10__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["m" /* ACCOUNTING */]].includes(role) && !lineItem.cancelled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__Outright_Outright__["b" /* isLastExchange */])(lineItem) && lineItem.exchange_type !== __WEBPACK_IMPORTED_MODULE_8__SalesOrders_constants__["m" /* THIRD_EXCHANGE */];
});

var exchange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__decorators_withPurchaseOrder__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["e" /* toggleSwitch */])("exchanging")(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__session_decorators_withCurrentUser__["b" /* default */])(withExchange(meetsExchangeCriteria(Exchange)))));

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"] })(exchange));

/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Exchange_Exchange__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Outright_Outright__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ReverseExchange_ReverseExchange__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CancelModal__ = __webpack_require__(1532);
/* unused harmony export LineItemControls */












function LineItemControls(_ref) {
  var update = _ref.update,
      lineItem = _ref.lineItem,
      currentUser = _ref.currentUser,
      purchaseOrder = _ref.purchaseOrder;
  var userId = currentUser.id,
      role = currentUser.role;
  var _purchaseOrder$buyer = purchaseOrder.buyer,
      buyerId = _purchaseOrder$buyer.id,
      coBuyerId = _purchaseOrder$buyer.co_buyer_id;

  var userCanEdit = role === __WEBPACK_IMPORTED_MODULE_7__users_constants__["i" /* ADMIN */] || role === __WEBPACK_IMPORTED_MODULE_7__users_constants__["p" /* QUALITY_CONTROL */] || userId === buyerId || userId === coBuyerId;
  var showControls = userCanEdit || lineItem.purchase_for_exchange;

  if (!showControls) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__["c" /* ImprovedDropDown */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
        id: "cancel",
        label: "Cancel Line Item",
        faIcon: "ban",
        hideIf: lineItem.cancelled || lineItem.received || !userCanEdit,
        renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CancelModal__["a" /* default */], { lineItem: lineItem })
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
        id: "uncancel",
        label: "Reverse Cancellation",
        faIcon: "undo",
        hideIf: !lineItem.cancelled || !userCanEdit,
        renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction__["a" /* default */], {
          onConfirm: function onConfirm() {
            return update(lineItem.id, { cancelled: !lineItem.cancelled });
          },
          message: "Are you sure you want to reopen this item?"
        })
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Exchange_Exchange__["a" /* default */], { key: "create-exchange", lineItem: lineItem }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ReverseExchange_ReverseExchange__["a" /* default */], { lineItem: lineItem }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Outright_Outright__["a" /* default */], { lineItem: lineItem })
    )
  );
}

LineItemControls.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,
  update: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object),
  currentUser: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object)
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get("user").toJS(),
    purchaseOrder: state.purchaseOrderDetail.get("purchaseOrder").toJS()
  };
}, function (dispatch) {
  return {
    update: function update(id, data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["g" /* updateLineItem */])(id, data));
    }
  };
})(LineItemControls));

/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_shared_AsIsFlag__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_ExchangeIcon__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_LineItemQtyCell_LineItemQtyCell__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_helpers__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LineItemControls__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__EditPart_EditPart__ = __webpack_require__(1533);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var paginatorList = "purchaseOrderLineItems";

var ReceivedIcon = function ReceivedIcon(_ref) {
  var quantityReceived = _ref.quantity_received,
      quantity = _ref.quantity;

  if (quantityReceived === quantity) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["U" /* IconReceived */], null);
  }
  return null;
};

ReceivedIcon.propTypes = {
  quantity_received: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var LineItemsTable = function (_Component) {
  _inherits(LineItemsTable, _Component);

  function LineItemsTable() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, LineItemsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = LineItemsTable.__proto__ || Object.getPrototypeOf(LineItemsTable)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      addPartModalOpen: false,
      editPartModalOpen: false
    }, _this.openEditPartModal = function (lineItem) {
      return _this.setState({
        editPartModalOpen: true,
        selectedLineItem: lineItem
      });
    }, _this.closeEditPartModal = function () {
      return _this.setState({ editPartModalOpen: false });
    }, _this.renderRow = function (r, idx) {
      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("clickable", {
        "text-muted": r.cancelled
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        {
          key: r.id,
          className: classes,
          onClick: function onClick() {
            return _this.openEditPartModal(r);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { whiteSpace: "nowrap" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { textAlign: "right" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_LineItemQtyCell_LineItemQtyCell__["a" /* default */], { lineItem: r, showFull: true }),
              idx + 1
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components__["_6" /* PurchaseOrderLineItemStatusCell */],
          { lineItem: r },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { display: "flex", alignItems: "center" } },
            r.has_vendor_rma && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
              icon: "fa-shield",
              placement: "top",
              note: "Vendor RMA",
              color: "white",
              style: { marginRight: "5px" }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["h" /* PartNumber */], { part: r.part, statsTooltip: true })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__helpers__["a" /* displayLink */])(r)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.alternate && (r.alternate.alternate_part_id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["h" /* PartNumber */], {
            part: {
              id: r.alternate.alternate_part_id,
              part_number: r.alternate.name
            }
          }) : r.alternate.name)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.trace_type && __WEBPACK_IMPORTED_MODULE_4__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes[r.trace_type].label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.traced_to
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.buyer && r.buyer.full_name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.co_buyer && r.co_buyer.full_name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.third_buyer && r.third_buyer.full_name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_date__["d" /* alphaMonthYear */])(r.tag_date)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.tagged_by
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          r.lead_time
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.condition && __WEBPACK_IMPORTED_MODULE_4__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].condition[r.condition].label,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_shared_AsIsFlag__["a" /* AsIsFlag */], { lineItem: r, className: "m-l-5" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_ExchangeIcon__["a" /* ExchangeIcon */], { lineItem: r })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          r.quantity
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReceivedIcon, r),
          " ",
          r.quantity_received
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shared_helpers__["a" /* displayCost */])(r) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shared_helpers__["a" /* displayCost */])(r))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          r.purchase_for_exchange && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(r.cost)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center td-shrink-icon" },
          (r.internal_note || r.external_note) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
            note: [r.internal_note, r.external_note].filter(function (n) {
              return n !== null && n !== "";
            }).join(" | "),
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ "link-muted": r.cancelled })
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center td-shrink-icon" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__LineItemControls__["a" /* default */], { lineItem: r })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LineItemsTable, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          results = _props.results,
          isLoading = _props.isLoading;
      var _state = this.state,
          editPartModalOpen = _state.editPartModalOpen,
          selectedLineItem = _state.selectedLineItem;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__EditPart_EditPart__["a" /* default */], {
          open: editPartModalOpen,
          close: this.closeEditPartModal,
          selectedLineItem: selectedLineItem
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Mini,
          { loading: isLoading, numbered: true, noMargin: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Part #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Serial #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Buy As Alt"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Exp Trace Type"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Exp Trace To"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Buyer"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Co-Buyer"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Third Buyer"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tag Date"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tagged By"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Lead Time (Days)"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Condition"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Exch"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Qty Ord."
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Qty Rec."
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Exch Fee/Cost Ea"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Outright Value"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-center" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-center" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Body,
            null,
            results.map(this.renderRow)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "nav",
          {
            className: "text-center margin-top-none",
            "aria-label": "Search results pages"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__["Paginator"], { listId: paginatorList })
        )
      );
    }
  }]);

  return LineItemsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LineItemsTable.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (LineItemsTable);

/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = PartSummary;









function HazmatWarning(_ref) {
  var bioHazmat = _ref.bio_hazmat,
      hazmat = _ref.hazmat;

  var warnings = [];
  if (hazmat) {
    warnings.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__parts_constants__["h" /* HAZMAT */]));
  }

  if (bioHazmat) {
    warnings.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__parts_constants__["i" /* BIO_HAZMAT */]));
  }

  if (warnings.length === 0) {
    return false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components__["n" /* Warning */],
    null,
    "This line item is marked: ",
    warnings.join(", ")
  );
}

HazmatWarning.propTypes = {
  hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bio_hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function PartSummary(_ref2) {
  var part = _ref2.part,
      quantity = _ref2.quantity,
      cost = _ref2.cost,
      lineItem = _ref2.lineItem,
      hazmatFee = _ref2.hazmatFee,
      containerFee = _ref2.containerFee;

  var calculateCost = function calculateCost(qty, costUnit) {
    var fees = parseFloat(hazmatFee || 0) + parseFloat(containerFee || 0);
    if (fees > 0) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(parseFloat(qty) * parseFloat(costUnit) + fees) || "$0.00";
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(parseFloat(qty) * parseFloat(costUnit)) || "$0.00";
  };

  var reason = __WEBPACK_IMPORTED_MODULE_3__constants__["I" /* CANCELLATION_REASONS */].find(function (x) {
    return x.value === (lineItem && lineItem.cancellation_reason);
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "well" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h6",
      { className: "h4" },
      "Part Summary"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed table-padding-horizonal-none margin-bottom-none" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Part #",
            part && part.part_number
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            cost
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { colSpan: "2" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "em",
              { className: "text-muted" },
              part && part.description
            )
          )
        ),
        hazmatFee && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Hazmat Fee: "
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            parseFloat(hazmatFee).toFixed(2)
          )
        ),
        containerFee && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Container/Crate Fee: "
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            parseFloat(containerFee).toFixed(2)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "QTY"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            quantity
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { colSpan: "2" },
            HazmatWarning(lineItem || {})
          )
        )
      )
    ),
    lineItem && lineItem.cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { style: { color: "#f44336" } },
        "Cancellation Reason:"
      ),
      " ",
      reason.text,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed table-padding-horizonal-none" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              { className: "h4 margin-top-none margin-bottom-none" },
              "Total"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              { className: "h4 margin-top-none margin-bottom-none" },
              calculateCost(quantity, cost)
            )
          )
        )
      )
    ),
    lineItem && lineItem.purchase_for_exchange && !lineItem[__WEBPACK_IMPORTED_MODULE_3__constants__["M" /* ASSIGNED_CORE_RETURN_ID */]] && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs" }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h6",
      { className: "h4" },
      "Core Return"
    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Core Return AWB #:"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            lineItem.core_return_awb_number
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Core Return Date:"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["b" /* shortDate */])(lineItem.core_return_date)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Core Repair Charges:"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(lineItem.core_repair_charges)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Core Return Serial Number:"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            lineItem.core_return_serial_number
          )
        )
      )
    )]
  );
}

PartSummary.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  hazmatFee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  containerFee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__decorators_withPurchaseOrder__ = __webpack_require__(269);
/* unused harmony export ReverseExchange */
/* unused harmony export exchange */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












function ReverseExchange(_ref) {
  var outright = _ref.outright,
      convertToOutright = _ref.convertToOutright,
      open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["k" /* Icon */], { name: "shopping-cart", fixed: true }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "with-padding" },
      "Convert to Outright"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["i" /* ConfirmAction */], {
      onConfirm: function onConfirm() {
        return outright();
      },
      close: close,
      open: convertToOutright
    })
  );
}

ReverseExchange.propTypes = _extends({
  outright: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  creatingOutright: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  confirmConfig: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_8__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

var withExchange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var _ref2$lineItem = _ref2.lineItem,
      itemId = _ref2$lineItem.id,
      purchaseOrderId = _ref2$lineItem.purchase_order_id,
      close = _ref2.close,
      pushHistory = _ref2.pushHistory;
  return {
    outright: function outright() {
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].purchaseOrders.lineItems.exchangeReversal(itemId).then(function () {
        pushHistory({ pathname: "/purchase-orders/" + purchaseOrderId });
        close();
      });
    }
  };
});

var meetsExchangeReversalCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["a" /* renderIf */])(function (_ref3) {
  var lineItem = _ref3.lineItem;
  return !lineItem.cancelled && !lineItem.shipped && !lineItem.received && lineItem.purchase_for_exchange;
});

var exchange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__decorators_withPurchaseOrder__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["e" /* toggleSwitch */])("convertToOutright")(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__session_decorators_withCurrentUser__["b" /* default */])(meetsExchangeReversalCriteria(withExchange(ReverseExchange)))));

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"] })(exchange));

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_validations__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hooks_useCurrentUser__ = __webpack_require__(51);
/* unused harmony export preferredRepairStationRequiredValidationAfterDate */
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;















var preferredRepairStationRequiredValidationAfterDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()("2020-01-20 07:00:00"); // SHIM

function validate(values, props) {
  // The date the hazmat/exchangeSrp validations were added plus a 7 hour buffer,
  // so essentially 12/12 at midnight AZ time.
  var validationDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()("2018-12-13 07:00:00");
  var exchangeSrpValidationDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()("2019-06-14 07:00:00");
  var createdAt = __WEBPACK_IMPORTED_MODULE_2_moment___default()(values.created_at || new Date());
  var skipValidationForPurchase = values.purchase_for_sale && Number(values.quantity) === Number(values[__WEBPACK_IMPORTED_MODULE_5__constants__["n" /* RESERVE_FOR_SALE_QUANTITY */]]) || values.purchase_for_repair_assist;

  var changes = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.differenceWith(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toPairs(props.initialValues), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toPairs(values), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual);

  if (changes.length === 1 && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(changes, "[0][0]") === "quantity") {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
      if (values.reserve_for_sale_quantity) {
        form.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](values.reserve_for_sale_quantity));
      } else if (values.quantity_received) {
        form.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](values.quantity_received));
      } else {
        form.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["f" /* isGreaterThan */](0));
      }
    });
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    var isConsignment = props.selectedLineItem && props.selectedLineItem.consignment;

    if (!isConsignment) {
      form.validate(__WEBPACK_IMPORTED_MODULE_9__IncomingQuotes_constants__["d" /* PURCHASE_STATUS */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
    }

    if (!(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(values, "part.pass_fail") || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(props, "selectedPart.pass_fail") || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(props, "selectedPart.tooling_part_type")) && createdAt.isAfter(exchangeSrpValidationDate) && !values.do_not_exchange && ![__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["g" /* NEW_ITEM */], __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* AS_REMOVED */]].includes(values.condition) && !skipValidationForPurchase) {
      var minOutrightValueForExchangeSettings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__hooks_useCurrentUser__["b" /* useSettings */])().min_outright_value_for_exchange_consideration;
      var suggestedRetail = parseFloat(values.suggested_retail);
      var minOutrightValue = parseFloat(minOutrightValueForExchangeSettings);
      var shouldCheckMinValue = minOutrightValueForExchangeSettings !== null && minOutrightValueForExchangeSettings !== undefined;

      if (!shouldCheckMinValue || suggestedRetail >= minOutrightValue) {
        form.validate(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["u" /* EXCHANGE_SRP */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["f" /* isGreaterThan */](0));
      }
    }

    form.validate(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["q" /* PART_ID */], __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */], __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_6__constants__["G" /* BUYER_CREDIT_PCT */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);

    form.validate(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["G" /* LEAD_TIME */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["g" /* requiredAllowZero */]);
    form.validate(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["E" /* TRACE_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
    form.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0));
    if (values.reserve_for_sale_quantity) {
      form.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](values.reserve_for_sale_quantity));
    } else if (values.quantity_received) {
      form.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](values.quantity_received));
    } else {
      form.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["f" /* isGreaterThan */](0));
    }

    form.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["E" /* PERCENT_INSURED */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["h" /* isBetween */](1, 100));
    if (!skipValidationForPurchase) {
      form.validate(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["v" /* SUGGESTED_RETAIL */], __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["C" /* SRP_CONDITION */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
    }

    if (!values.purchase_for_repair_assist && !isConsignment) {
      form.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["J" /* TOOL_USED */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
    }

    if (values.hazmat && createdAt.isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()(validationDate))) {
      form.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["z" /* HAZMAT_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0));
    }

    if (values.purchase_for_stock) {
      form.validate(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["C" /* SRP_CONDITION */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["i" /* matches */](__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["n" /* CONDITION */]));
    }

    if (props && props.domLifeYears && props.llp || props.selectedPart && props.selectedPart.dom_sensitive) {
      form.validate(__WEBPACK_IMPORTED_MODULE_8__parts_constants__["G" /* DOM */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
    }

    if ((values.purchase_for_repair || values.condition === __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* AS_REMOVED */] && !values.purchase_for_sale && !values.purchase_for_stock) && createdAt.isAfter(preferredRepairStationRequiredValidationAfterDate) && (props.selectedLineItem && !props.selectedLineItem.consignment || !props.selectedLineItem)) {
      form.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["w" /* PREFERRED_REPAIR_STATION_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
    }

    if ([__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["i" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["P" /* INSPECTED */], __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["h" /* REPAIRED */]].includes(values.condition)) {
      form.validate(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["x" /* TAG_DATE */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
      form.validate(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["p" /* TAGGED_BY */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
    }

    if (values.purchase_for_exchange) {
      form.validate(__WEBPACK_IMPORTED_MODULE_10__RepairOrders_constants__["e" /* CORE_DUE_DAYS */], __WEBPACK_IMPORTED_MODULE_10__RepairOrders_constants__["f" /* CORE_RETURN_DATE */], __WEBPACK_IMPORTED_MODULE_11__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
      form.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["j" /* mustBeOne */]);

      if (values.flat_exchange) {
        form.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["t" /* CORE_REPAIR_FEE_NOT_TO_EXCEED */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
      }
    }

    if (values.exchange_srp && props.minExchangeSrp && !isConsignment) {
      form.validate(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["u" /* EXCHANGE_SRP */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](props.minExchangeSrp));
    } else if (values.exchange_srp && !isConsignment) {
      form.validate(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["u" /* EXCHANGE_SRP */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["f" /* isGreaterThan */](0));
    }

    if (values.do_not_exchange) {
      form.validate(__WEBPACK_IMPORTED_MODULE_12__shared_constants__["c" /* INTERNAL_NOTE */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
    }

    if (values[__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["z" /* UNSELLABLE_PER_USER */]]) {
      form.validate(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["A" /* DO_NOT_SELL_REASON */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_validations__["a" /* validatePurchaseForFields */])(values, form);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_validations__["b" /* validatePurchaseForSaleFields */])(values, form);
  });
}

/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = PhysicalAddress;



function PhysicalAddress(_ref) {
  var address = _ref.address;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-condensed" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Address Line"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          address.line1
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "City"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          address.city
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "State/ Province/ Region"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          address.state
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "ZIP/ Postal Code"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          address.postal_code
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Country"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          address.country
        )
      )
    )
  );
}

PhysicalAddress.propTypes = {
  address: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    line1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    city: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    postal_code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};

/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_LocationFlag_LocationFlag__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Receiving_components_shared_StatusTags__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__orange_marmalade_paginate_this__);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











function Row(_ref) {
  var record = _ref.record,
      statuses = _ref.statuses;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { className: "clickable" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          to: "/receiving/" + record.uuid
        },
        record.code
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__["b" /* shortDate */])(record.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["h" /* PartNumber */], { part: record.part })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.inventories.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          to: "/inventories/" + record.inventories[0].uuid
        },
        record.serial_number
      ) : record.serial_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_LocationFlag_LocationFlag__["a" /* default */], { location: record.store_location_id })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_4__Receiving_constants__["x" /* CONDITION_TYPES */][record.condition].label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      record.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.awb_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Receiving_components_shared_StatusTags__["a" /* default */], statuses)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["G" /* NoteTooltipTableCell */], { note: record.minor_note })
  );
}

Row.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  statuses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

function Table(_ref2) {
  var results = _ref2.results,
      isLoading = _ref2.isLoading;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */],
    { loading: isLoading },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "REC #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "REC Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Store Loc"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "COND Rec"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "QTY Rec"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "AWB #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Status"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Minor Notes"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (record) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row, { key: record.id, record: record });
      })
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "nav",
    {
      className: "text-center margin-top-none",
      "aria-label": "Search results pages"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__orange_marmalade_paginate_this__["Paginator"], { listId: "purchaseOrders/receivingRecords" })
  )];
}

Table.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var ConnectedTable = __WEBPACK_IMPORTED_MODULE_8__orange_marmalade_paginate_this__["decorators"].tabulate(Table);

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConnectedTable, _extends({ listId: "purchaseOrders/receivingRecords" }, props));
});

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DetailTable_Detail__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = RejectionDetails;






function RejectionDetails(_ref) {
  var purchaseOrder = _ref.purchaseOrder;

  if (!purchaseOrder.rejected) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-condensed" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_DetailTable_Detail__["a" /* default */], {
        label: "Rejected At",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__["b" /* shortDate */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(purchaseOrder, "rejection_details.rejected_at")),
        renderIfPresent: true
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_DetailTable_Detail__["a" /* default */], {
        label: "Rejected By",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(purchaseOrder, "rejection_details.rejected_by"),
        renderIfPresent: true
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_DetailTable_Detail__["a" /* default */], {
        label: "Reason For Rejection",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(purchaseOrder, "rejection_details.rejection_reasons", []).join("/"),
        renderIfPresent: true
      })
    )
  );
}

RejectionDetails.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(Object)
};

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__);
/* unused harmony export Form */
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }














function Form(_ref) {
  var close = _ref.close,
      handleSubmit = _ref.handleSubmit,
      invalid = _ref.invalid,
      submitting = _ref.submitting;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "form",
    { onSubmit: handleSubmit },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "to", label: "To:", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "cc", label: "CC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "bcc", label: "BCC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "subject", label: "Subject", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["l" /* TextArea */], name: "body", label: "Body", required: true })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
        {
          onClick: function onClick() {
            close();
          }
        },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
        {
          type: "submit",
          bsStyle: "primary",
          disabled: invalid || submitting
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["k" /* Icon */], { name: "envelope", fixed: true }),
        "\xA0Yes, Send PO"
      )
    )
  );
}

Form.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var withInitialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["m" /* dataManager */])("initialValues", function () {
  var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref3) {
    var purchaseOrderId = _ref3.purchaseOrderId,
        _ref3$invoiceToIre = _ref3.invoiceToIre,
        invoiceToIre = _ref3$invoiceToIre === undefined ? false : _ref3$invoiceToIre;

    var _ref4, preview;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].purchaseOrders.preview(purchaseOrderId, invoiceToIre);

          case 2:
            _ref4 = _context.sent;
            preview = _ref4.data;
            return _context.abrupt("return", Object.assign(preview, { invoice_to_ire: invoiceToIre }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (withInitialValues(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reduxForm"])({
  form: "send-purchase-order",
  validate: function validate(values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_validate_this__["a" /* validator */])(values, function (form) {
      form.validate("subject", "body", "to").satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["a" /* required */]);
      form.validate("to", "cc").satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["b" /* isValidEmail */]);
    });
  },
  onSubmit: function () {
    var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(data, _, props) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].purchaseOrders.send(props.purchaseOrderId, data).then(function () {
                props.close();
                __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__["toastr"].success("Success", "Purchase order successfully sent.");
              }).catch(function () {
                return __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__["toastr"].error("Error", "Could not send purchase order. Please refresh page and try again.");
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function onSubmit(_x2, _x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }()
})(Form)));

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SendModal__ = __webpack_require__(673);
/* harmony export (immutable) */ __webpack_exports__["a"] = Send;









function Send(_ref) {
  var purchaseOrder = _ref.purchaseOrder;

  if (purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_6__constants__["_38" /* CANCELLED */]) || purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_6__constants__["_26" /* RECEIVED */])) {
    return false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__["a" /* default */],
        { onClick: open },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: "envelope-o", fixed: true }),
        "\xA0Send PO",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SendModal__["a" /* SendModal */], {
          purchaseOrder: purchaseOrder,
          visible: visible,
          close: close
        })
      );
    }
  );
}

Send.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
};

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Send__ = __webpack_require__(1544);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Send__["a"]; });


/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__);
/* unused harmony export Form */
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }














function Form(_ref) {
  var close = _ref.close,
      handleSubmit = _ref.handleSubmit,
      invalid = _ref.invalid,
      submitting = _ref.submitting;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "form",
    { onSubmit: handleSubmit },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "to", label: "To:", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "cc", label: "CC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "bcc", label: "BCC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "subject", label: "Subject", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["l" /* TextArea */], name: "body", label: "Body", required: true })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
        {
          onClick: function onClick() {
            close();
          }
        },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
        {
          type: "submit",
          bsStyle: "primary",
          disabled: invalid || submitting
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["k" /* Icon */], { name: "envelope", fixed: true }),
        "\xA0Send Cancellation"
      )
    )
  );
}

Form.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var withInitialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["m" /* dataManager */])("initialValues", function () {
  var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref3) {
    var purchaseOrderId = _ref3.purchaseOrderId,
        _ref3$invoiceToIre = _ref3.invoiceToIre,
        invoiceToIre = _ref3$invoiceToIre === undefined ? false : _ref3$invoiceToIre;

    var _ref4, preview, modifiedPreview;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].purchaseOrders.preview(purchaseOrderId, { type: "cancelled" });

          case 2:
            _ref4 = _context.sent;
            preview = _ref4.data;
            modifiedPreview = _extends({}, preview, {
              subject: preview.subject ? preview.subject + " - Cancelled" : "Cancelled",
              invoice_to_ire: invoiceToIre
            });
            return _context.abrupt("return", modifiedPreview);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (withInitialValues(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reduxForm"])({
  form: "send-purchase-order",
  validate: function validate(values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_validate_this__["a" /* validator */])(values, function (form) {
      form.validate("subject", "body", "to").satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["a" /* required */]);
      form.validate("to", "cc").satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["b" /* isValidEmail */]);
    });
  },
  onSubmit: function () {
    var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(data, _, props) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].purchaseOrders.sendNotice(props.purchaseOrderId, data).then(function () {
                props.close();
                __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__["toastr"].success("Success", "Cancelled PO successfully sent.");
              }).catch(function () {
                return __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__["toastr"].error("Error", "Could not send purchase order. Please refresh page and try again.");
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function onSubmit(_x2, _x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }()
})(Form)));

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SendModal__ = __webpack_require__(1548);
/* harmony export (immutable) */ __webpack_exports__["a"] = SendCancelledPo;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








function SendCancelledPo(_ref) {
  var purchaseOrder = _ref.purchaseOrder,
      onClose = _ref.onClose;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var openModal = function openModal() {
    return setVisible(true);
  };

  var closeModal = function closeModal() {
    setVisible(false);
    onClose();
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__["a" /* default */],
      { onClick: openModal },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "envelope-o", fixed: true }),
      " \xA0Send Cancellation Notice"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SendModal__["a" /* SendModal */], {
      purchaseOrder: purchaseOrder,
      visible: visible,
      close: closeModal
    })
  );
}

SendCancelledPo.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(1546);
/* harmony export (immutable) */ __webpack_exports__["a"] = SendModal;






function SendModal(_ref) {
  var purchaseOrder = _ref.purchaseOrder,
      visible = _ref.visible,
      close = _ref.close,
      invoiceToIre = _ref.invoiceToIre;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: visible, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Are You Sure?"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], {
      close: close,
      purchaseOrderId: purchaseOrder.get("id"),
      invoiceToIre: invoiceToIre
    })
  );
}

SendModal.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired,
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  invoiceToIre: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SendCancelledPo__ = __webpack_require__(1547);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SendCancelledPo__["a"]; });


/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(19);
/* harmony export (immutable) */ __webpack_exports__["a"] = SetTraceHold;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function SetTraceHold(_ref) {
  var purchaseOrder = _ref.purchaseOrder,
      onConfirm = _ref.onConfirm,
      traceApproved = _ref.traceApproved;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      confirmationIsVisible = _useState2[0],
      setConfirmationVisibility = _useState2[1];

  if (!purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_6__constants__["S" /* TRACE_HOLD */]) && !purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_6__constants__["T" /* REJECTED */]) && !purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_6__constants__["U" /* APPROVED */])) {
    return false;
  }

  var type = traceApproved ? "Approve" : "Reject";
  var icon = traceApproved ? "check" : "ban";

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setConfirmationVisibility(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: icon, fixed: true }),
    "\xA0",
    type,
    " Trace",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setConfirmationVisibility(false);
        },
        open: confirmationIsVisible,
        btnClass: "btn-danger",
        btnText: "Yes, " + type + " Trace",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-" + icon })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to ",
      type,
      " Trace for this PO?"
    )
  );
}

SetTraceHold.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired,
  traceApproved: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetTraceHold__ = __webpack_require__(1550);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SetTraceHold__["a"]; });


/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = ShippingAddress;




function ShippingAddress(_ref) {
  var purchaseOrder = _ref.purchaseOrder;
  var shippingAddress = purchaseOrder.ship_to_address;


  var dropShip = function dropShip(type) {
    return ["company", "dropship"].includes(type);
  };
  var shipToShippingType = purchaseOrder.shipping_type;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-condensed" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      purchaseOrder.ship_to_company && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Company"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["w" /* CompanyName */], { company: purchaseOrder.ship_to_company })
        )
      ),
      shippingAddress.company_name && dropShip(shipToShippingType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Company Name"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          shippingAddress.company_name
        )
      ),
      shippingAddress.care_of && dropShip(shipToShippingType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "c/o"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          shippingAddress.care_of
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: "address" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Address Line"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          shippingAddress.line1,
          shippingAddress.line2 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          shippingAddress.line2 && shippingAddress.line2
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: "city" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "City"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          shippingAddress.city
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: "state" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "State/ Province/ Region"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          shippingAddress.state
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: "zip" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "ZIP/ Postal Code"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          shippingAddress.postal_code
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: "country" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Country"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          shippingAddress.country
        )
      )
    )
  );
}

ShippingAddress.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Edit_EditShipping__ = __webpack_require__(1562);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ShippingDetails = function (_React$Component) {
  _inherits(ShippingDetails, _React$Component);

  function ShippingDetails() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ShippingDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShippingDetails.__proto__ || Object.getPrototypeOf(ShippingDetails)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editShippingModalOpen: false
    }, _this.openShippingModal = function () {
      _this.setState({ editShippingModalOpen: true });
    }, _this.closeShippingModal = function () {
      return _this.setState({ editShippingModalOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ShippingDetails, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          purchaseOrder = _props.purchaseOrder,
          _props$unlocked = _props.unlocked,
          unlocked = _props$unlocked === undefined ? true : _props$unlocked;
      var editShippingModalOpen = this.state.editShippingModalOpen;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Shipping",
          unlocked && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["y" /* EditButton */], { handleClick: this.openShippingModal }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Edit_EditShipping__["a" /* default */], {
            purchaseOrder: purchaseOrder,
            open: editShippingModalOpen,
            close: this.closeShippingModal
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "table",
          { className: "table table-condensed" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tbody",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "FOB"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                null,
                purchaseOrder.fob
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "Ship Date"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                null,
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__["b" /* shortDate */])(purchaseOrder.ship_date)
              )
            )
          )
        )
      );
    }
  }]);

  return ShippingDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ShippingDetails);


ShippingDetails.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  unlocked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Warnings__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* harmony export (immutable) */ __webpack_exports__["a"] = StatusTags;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









function StatusTags(_ref) {
  var purchaseOrder = _ref.purchaseOrder,
      requiresApproval = _ref.requiresApproval,
      traceHold = _ref.traceHold,
      received = _ref.received,
      rejected = _ref.rejected,
      traceHoldApproved = _ref.traceHoldApproved;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      coresReceived = _useState2[0],
      setCoresReceived = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].purchaseOrders.receivedCores.search(purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ID */]), {}).then(function (_ref2) {
      var data = _ref2.data;

      setCoresReceived(data.results);
    });
  }, [purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ID */])]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "alert-group pull-right", style: { marginLeft: 15 } },
    traceHold && !traceHoldApproved && !rejected && !received && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Warnings__["a" /* Warning */], { icon: "pause", label: "Trace Approval Required" }),
    !rejected && requiresApproval && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Warnings__["a" /* Warning */], { icon: "pause", label: "PO Requires Approval" }), purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_5__Receiving_constants__["P" /* EXPORT_HOLD */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Warnings__["a" /* Warning */], { icon: "pause", label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_5__Receiving_constants__["P" /* EXPORT_HOLD */]) })],
    received && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "label label-success", style: { marginLeft: "10px" } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check-circle" }),
      "\xA0\xA0Received"
    ),
    coresReceived.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "label label-success", style: { marginLeft: "10px" } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check-circle" }),
      "\xA0\xA0 Core Received"
    )
  );
}

StatusTags.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  received: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  rejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  requiresApproval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  traceHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  traceHoldApproved: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();














function Sync(_ref) {
  var onConfirm = _ref.onConfirm,
      purchaseOrder = _ref.purchaseOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      settings = _useState4[0],
      setSettings = _useState4[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].locations.locationSetting.quickbooksLocationSetting(purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["g" /* BUYING_STORE_ID */])).then(function (_ref2) {
      var data = _ref2.data;

      setSettings(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(data, "settings.quickbooks", {}));

      return function cleanup() {};
    });
  }, []);

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(settings, "accounts_payable_account")) {
    return null;
  }

  var syncDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_11__constants__["_47" /* SYNC_DATE */]);
  var createdAt = __WEBPACK_IMPORTED_MODULE_10_moment___default()(purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_7" /* CREATED_AT */]));

  if (syncDate && __WEBPACK_IMPORTED_MODULE_10_moment___default()(syncDate) > __WEBPACK_IMPORTED_MODULE_10_moment___default()(createdAt.format("YYYY-MM-DD"))) {
    return null;
  }

  if (purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_46" /* DISABLE_QB_SYNC */])) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: "refresh", fixed: true }),
    "\xA0Sync Accounting",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setVisible(false);
        },
        open: visible,
        btnText: "Yes, Sync w/ Quickbooks",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-refresh" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to sync the PO?",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        "Please ensure the Vendor has a linked account for the buying store."
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onConfirm: function onConfirm() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["m" /* sync */])());
    }
  };
})(Sync));

Sync.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(19);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

















function ToggleQuickbooksSync(_ref) {
  var onConfirm = _ref.onConfirm,
      purchaseOrder = _ref.purchaseOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      settings = _useState4[0],
      setSettings = _useState4[1];

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__users_helpers__["c" /* hasAnyOfRoles */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks__["a" /* useCurrentUser */])(), [__WEBPACK_IMPORTED_MODULE_9__users_constants__["m" /* ACCOUNTING */]])) {
    return null;
  }

  var createdAt = purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_7" /* CREATED_AT */]);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].locations.locationSetting.show(purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_14__constants__["g" /* BUYING_STORE_ID */])).then(function (_ref2) {
      var data = _ref2.data;

      setSettings(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(data, "settings.quickbooks", {}));

      return function cleanup() {};
    });
  }, [createdAt]);

  var syncDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_12__constants__["_47" /* SYNC_DATE */]);

  if (!syncDate) return null;

  if (syncDate && __WEBPACK_IMPORTED_MODULE_13_moment___default()(syncDate) <= __WEBPACK_IMPORTED_MODULE_13_moment___default()(createdAt).format("YYYY-MM-DD")) {
    return null;
  }

  var quickbooksDisabled = purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_46" /* DISABLE_QB_SYNC */]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: quickbooksDisabled ? "play" : "pause", fixed: true }),
    "\xA0",
    quickbooksDisabled ? "Enable QB Sync" : "Disable QB Sync",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setVisible(false);
        },
        open: visible,
        btnText: quickbooksDisabled ? "Enable QB Sync" : "Disable QB Sync",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-pause" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to",
      " ",
      quickbooksDisabled ? "enable QB Sync" : "disable QB Sync",
      "?"
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onConfirm: function onConfirm() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["h" /* update */])({ disable_qb_sync: !ownProps.purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_46" /* DISABLE_QB_SYNC */]) }));
    }
  };
})(ToggleQuickbooksSync));

ToggleQuickbooksSync.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_DetailTable_Detail__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip_AuditedNoteTooltip__ = __webpack_require__(104);
/* harmony export (immutable) */ __webpack_exports__["a"] = TraceHoldDetail;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








function TraceHoldDetail(_ref) {
  var purchaseOrder = _ref.purchaseOrder;

  if (purchaseOrder.trace_hold === null || purchaseOrder.trace_hold_approved === null) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-condensed" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components_DetailTable_Detail__["a" /* default */], {
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_4__constants__["S" /* TRACE_HOLD */]),
        value: [purchaseOrder.trace_hold_approved ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_4__constants__["U" /* APPROVED */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_4__constants__["T" /* REJECTED */]), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], {
          field: __WEBPACK_IMPORTED_MODULE_4__constants__["_0" /* TRACE_HOLD_APPROVED */],
          obj: Object.assign(purchaseOrder, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__constants__["_0" /* TRACE_HOLD_APPROVED */], __WEBPACK_IMPORTED_MODULE_4__constants__["_0" /* TRACE_HOLD_APPROVED */] ? __WEBPACK_IMPORTED_MODULE_4__constants__["U" /* APPROVED */] : __WEBPACK_IMPORTED_MODULE_4__constants__["T" /* REJECTED */]))
        })]
      })
    )
  );
}

TraceHoldDetail.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Receiving_constants__ = __webpack_require__(34);









function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "row row-col-gutters-half" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "col-md-12" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: "qc_status",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
              options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_7__Receiving_constants__["O" /* QC_STATUS_TYPES */]),
              label: "QC Status",
              required: true
            })
          )
        )
      )
    )
  );
}

Form.propTypes = {
  referenceNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, { onSubmit: __WEBPACK_IMPORTED_MODULE_6__actions__["n" /* updateQcStatus */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["j" /* form */])({
  form: "updateQCStatus"
})(Form)));

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(1558);
/* harmony export (immutable) */ __webpack_exports__["a"] = QcStatusModal;






function QcStatusModal(_ref) {
  var purchaseOrder = _ref.purchaseOrder,
      visible = _ref.visible,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: visible, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Will Apply to All Items, Are You Sure?"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], { close: close, purchaseOrderId: purchaseOrder.get("id") })
  );
}

QcStatusModal.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired,
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__QcStatusModal__ = __webpack_require__(1559);
/* harmony export (immutable) */ __webpack_exports__["a"] = UpdateQcStatus;









function UpdateQcStatus(_ref) {
  var purchaseOrder = _ref.purchaseOrder;

  if (purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_6__constants__["_38" /* CANCELLED */])) {
    return false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__["a" /* default */],
        { onClick: open },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: "pause", fixed: true }),
        "\xA0Update QC Status",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__QcStatusModal__["a" /* QcStatusModal */], {
          purchaseOrder: purchaseOrder,
          visible: visible,
          close: close
        })
      );
    }
  );
}

UpdateQcStatus.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
};

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(1563);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditPurchaseOrder;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function EditPurchaseOrder(_ref) {
  var open = _ref.open,
      close = _ref.close,
      purchaseOrder = _ref.purchaseOrder;

  var initialValues = _extends({}, purchaseOrder, {
    contact: null,
    company_id: purchaseOrder.company && purchaseOrder.company.id,
    contact_id: purchaseOrder.portal_purchase ? __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* PORTAL_PURCHASE */] : purchaseOrder.contact && purchaseOrder.contact.id
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Purchase Order Details"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      purchaseOrder: purchaseOrder,
      enableReinitialize: true
    })
  );
}

EditPurchaseOrder.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShippingForm__ = __webpack_require__(1564);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditShipping;





function EditShipping(_ref) {
  var open = _ref.open,
      close = _ref.close,
      purchaseOrder = _ref.purchaseOrder;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Purchase Order Shipping Info"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ShippingForm__["a" /* default */], {
      close: close,
      initialValues: purchaseOrder,
      purchaseOrder: purchaseOrder,
      enableReinitialize: true
    })
  );
}

EditShipping.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_DetailFields__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_CompanyAddressWarning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validate__ = __webpack_require__(674);
/* unused harmony export Form */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var formName = "editPurchaseOrder";

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      contacts: []
    }, _this.setPaymentTerms = function (val) {
      _this.props.setPurchaseOrder(val);
    }, _this.notifyForm = function (company) {
      return _this.setState({ company: company });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "renderBuyerDiscrepancyWarning",
    value: function renderBuyerDiscrepancyWarning() {
      if (!this.props.purchaseOrder.buyers_discrepancy) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "alert alert-warning" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-warning" }),
        "\xA0\xA0 One or more Line Items in this PO do not have the same Buyer details. Changing the Buyer details on this form, will update Buyer details on all underlying Line Items."
      );
    }
  }, {
    key: "render",
    value: function render() {
      var purchaseOrder = this.props.purchaseOrder;
      var company = this.state.company;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
          null,
          this.renderBuyerDiscrepancyWarning(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_CompanyAddressWarning__["a" /* default */], { company: company }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_DetailFields__["a" /* default */], {
            purchaseOrder: purchaseOrder,
            selectedBuyer: purchaseOrder.buyer,
            selectedCoBuyer: purchaseOrder.co_buyer,
            selectedThirdBuyer: purchaseOrder.third_buyer,
            setSelectedCompany: this.notifyForm,
            setPaymentTerms: this.setPaymentTerms,
            formName: formName,
            setPrimaryContact: false
          })
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  setPurchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_4__actions__["h" /* update */](data));
    },
    setPurchaseOrder: function setPurchaseOrder(val) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_8__constants__["M" /* PAYMENT_TERMS */], val));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_9__validate__["b" /* default */]
})(Form)));

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Orders_shared_ShippingFields_ShippingFields__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__validate__ = __webpack_require__(674);
/* unused harmony export Form */









var FORM_NAME = "editPOShipping";

function Form(props) {
  var purchaseOrder = props.purchaseOrder;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Orders_shared_ShippingFields_ShippingFields__["a" /* default */], {
        shipToCompany: purchaseOrder.ship_to_company,
        formName: FORM_NAME,
        shippingFields: [__WEBPACK_IMPORTED_MODULE_6__constants__["o" /* SHIPPING_TYPE */], __WEBPACK_IMPORTED_MODULE_6__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_6__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_6__constants__["H" /* FOB */], __WEBPACK_IMPORTED_MODULE_6__constants__["L" /* SHIP_TO_ADDRESS_PHONE */]],
        shippingMethod: __WEBPACK_IMPORTED_MODULE_6__constants__["g" /* SHIPPING_METHOD */],
        shippingAddressField: __WEBPACK_IMPORTED_MODULE_6__constants__["I" /* SHIPPING_ADDRESS */]
      })
    )
  );
}

Form.propTypes = {
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    ship_to_company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
  })
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* update */](data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_7__validate__["a" /* validateShipping */]
})(Form)));

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_components_DateRangePicker_DateRangePicker__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Sum__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Table__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(443);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }























var defaultFilters = {
  buying_store: undefined,
  buying_store_id: undefined,
  cancelled: undefined,
  consignment: undefined,
  core_repair_invoices_paid: undefined,
  current_user: undefined,
  invoiced: undefined,
  not_paid: undefined,
  over_buying_limit: undefined,
  partially_received: undefined,
  purchase_for_exchange: undefined,
  purchase_for_sale: undefined,
  purchase_for_stock: undefined,
  purchase_for_repair: undefined,
  purchase_for_repair_assist: undefined,
  received: undefined,
  shipped: undefined,
  trace_hold: undefined,
  vendor_rma: undefined
};

var filters = [{
  label: "Received and Invoiced",
  filters: _extends({}, defaultFilters, {
    received: true,
    invoiced: true
  })
}, {
  label: "Received and Not Invoiced",
  filters: _extends({}, defaultFilters, {
    received: true,
    invoiced: false
  })
}, {
  label: "---"
}, {
  label: "My POs",
  filters: { current_user: true }
}, {
  label: "Received",
  filters: {
    received: true
  }
}, {
  label: "Partially Received",
  filters: { partially_received: true }
}, {
  label: "Not Received",
  filters: {
    received: false
  }
}, {
  label: "Cancelled",
  filters: {
    cancelled: true
  }
}, {
  label: "Not Cancelled",
  filters: {
    cancelled: false
  }
}, {
  label: "Invoiced",
  filters: {
    invoiced: true
  }
}, {
  label: "Not Invoiced",
  filters: {
    invoiced: false
  }
}, {
  label: "Not Paid / Remaining Balance",
  filters: { not_paid: true }
}, {
  label: "Open POs Awaiting Trace Pre-Approval",
  filters: _extends({}, defaultFilters, {
    trace_hold: true,
    received: false,
    cancelled: false
  })
}, {
  label: "Open POs Awaiting Purchaser Limit Approval",
  filters: _extends({}, defaultFilters, {
    over_buying_limit: true,
    received: false,
    cancelled: false
  })
}, {
  label: "Exchanges",
  filters: {
    purchase_for_exchange: true
  }
}, {
  label: "Purchase For Sale",
  filters: {
    purchase_for_sale: true
  }
}, {
  label: "Purchase For Stock",
  filters: {
    purchase_for_stock: true
  }
}, {
  label: "Purchase For Repair",
  filters: {
    purchase_for_repair: true
  }
}, {
  label: "Purchase For Repair Assist",
  filters: {
    purchase_for_repair_assist: true
  }
}, {
  label: "Cores Returned",
  filters: {
    purchase_for_exchange: true,
    shipped: true
  }
}, {
  label: "Cores Not Returned",
  filters: {
    purchase_for_exchange: true,
    shipped: false
  }
}, {
  label: "Core Repair Invoices Not Paid",
  filters: {
    core_repair_invoices_paid: false,
    purchase_for_exchange: true
  }
}, {
  label: "Vendor RMA",
  filters: {
    vendor_rma: true
  }
}, {
  label: "No Vendor RMA",
  filters: {
    vendor_rma: false
  }
}, {
  label: "Consignment",
  filters: {
    consignment: true
  }
}, {
  label: "Synced with Accounting",
  filters: {
    accounting_synced: true
  }
}, {
  label: "Not Synced with Accounting",
  filters: {
    accounting_synced: false
  }
}];

var filterTags = [{
  label: "Synced with Accounting",
  key: "accounting_synced",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Synced w/ Accounting",
  key: "accounting_synced",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Not Paid / Remaining Balance",
  key: "not_paid",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "My POs",
  key: "current_user"
}, {
  label: "Received",
  key: "received",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Received",
  key: "received",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Invoiced",
  key: "invoiced",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Invoiced",
  key: "invoiced",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Cancelled",
  key: "cancelled",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Cancelled",
  key: "cancelled",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Owned by IRE",
  key: "buying_store",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_10__constants__["_3" /* IRE */].toLowerCase())
}, {
  label: "Partially Received",
  key: "partially_received",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Purchase For Sale",
  key: "purchase_for_sale"
}, {
  label: "Purchase For Stock",
  key: "purchase_for_stock"
}, {
  label: "Purchase For Repair",
  key: "purchase_for_repair"
}, {
  label: "Purchase For Repair Assist",
  key: "purchase_for_repair_assist"
}, {
  label: "Over Buying Limit",
  key: "over_buying_limit",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Trace Hold",
  key: "trace_hold",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Exchanges",
  key: __WEBPACK_IMPORTED_MODULE_11__RepairOrders_constants__["d" /* PURCHASE_FOR_EXCHANGE */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Cores Returned",
  key: __WEBPACK_IMPORTED_MODULE_12__constants__["_23" /* SHIPPED */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Cores Not Returned",
  key: __WEBPACK_IMPORTED_MODULE_12__constants__["_23" /* SHIPPED */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Core Repair Invoices Not Paid",
  key: __WEBPACK_IMPORTED_MODULE_11__RepairOrders_constants__["_27" /* CORE_REPAIR_INVOICES_PAID */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Vendor RMA",
  key: "vendor_rma",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "No Vendor RMA",
  key: "vendor_rma",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Consignment",
  key: "consignment",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}];

var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = searchProps.paginator.get("filters").toJS();
  var purchaseOrderLineItemTotalCount = searchProps.paginator.get("totalCount");

  params.total_count = purchaseOrderLineItemTotalCount;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        if (purchaseOrderLineItemTotalCount > __WEBPACK_IMPORTED_MODULE_14__users_constants__["_6" /* EXPORT_LIMIT */]) {
          __WEBPACK_IMPORTED_MODULE_18_react_redux_toastr__["toastr"].info("Processing Report.");
          __WEBPACK_IMPORTED_MODULE_17__api__["a" /* default */].purchaseOrders.lineItems.export(params).then(function () {
            return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
          });
        } else {
          window.open(__WEBPACK_IMPORTED_MODULE_12__constants__["d" /* API_BASE */] + "/purchase_order_line_items/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_query_string__["stringify"])(params), "_blank");
          __WEBPACK_IMPORTED_MODULE_18_react_redux_toastr__["toastr"].success("Processing Purchase Order Report. Please wait for the PDF to generate.");
        }
      }
    },
    "Export"
  );
};

var meetsExportCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var searchProps = _ref2.searchProps,
      currentUser = _ref2.currentUser;
  return searchProps.paginator.get("totalCount") <= 450 || currentUser.role === __WEBPACK_IMPORTED_MODULE_14__users_constants__["i" /* ADMIN */];
});

var DecoratedExportButton = meetsExportCriteria(ExportButton);

function PurchaseOrdersSearch(_ref3) {
  var pushHistory = _ref3.pushHistory;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__hooks_useCurrentUser__["a" /* default */])();

  var filterTagsWithLocations = currentUser.locations.map(function (l) {
    return {
      label: "Owned by " + l.name,
      key: __WEBPACK_IMPORTED_MODULE_10__constants__["g" /* BUYING_STORE_ID */],
      matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])(l.id)
    };
  });

  var filtersWithLocations = currentUser.locations.map(function (l, i) {
    return [{
      label: "All Owned By " + l.name,
      filters: { buying_store_id: l.id }
    }, {
      label: "Open POs owned by " + l.name,
      filters: _extends({}, defaultFilters, {
        received: false,
        cancelled: false,
        buying_store_id: l.id
      }),
      hr: currentUser.locations.length - 1 === i
    }];
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_20__pagination__["c" /* purchaseOrdersPagination */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a PO number, vendor name, invoice number or buyer...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/purchase-orders/" + r.purchase_order.uuid);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DecoratedExportButton, {
              searchProps: searchProps,
              currentUser: currentUser
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__shared_components_DateRangePicker_DateRangePicker__["a" /* default */], searchProps),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
              filters: filters.concat.apply(filters, _toConsumableArray(filtersWithLocations)).concat({
                label: __WEBPACK_IMPORTED_MODULE_12__constants__["_37" /* CLEAR_FILTERS_TEXT */],
                filters: _extends({}, defaultFilters)
              }),
              right: true
            }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          aggregateField: "subtotal",
          title: "Purchase Orders",
          filters: filterTags.concat(filterTagsWithLocations),
          Sum: __WEBPACK_IMPORTED_MODULE_16__Sum__["a" /* default */]
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

PurchaseOrdersSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(PurchaseOrdersSearch));

/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hooks_useDebounce__ = __webpack_require__(201);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();






function Sum(_ref) {
  var paginator = _ref.paginator;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      sum = _useState2[0],
      setSum = _useState2[1];

  var latestRequestRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(0);

  var debouncedSearchArgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hooks_useDebounce__["a" /* default */])(300, Object.entries(paginator.get("filters").toJS()).flatMap(function (pair) {
    return pair;
  }).join("-"));

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var currentRequest = latestRequestRef.current + 1;
    latestRequestRef.current = currentRequest;

    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].purchaseOrders.search(_extends({
      include_sum: true
    }, paginator.get("filters").toJS())).then(function (_ref2) {
      var data = _ref2.data;

      if (currentRequest === latestRequestRef.current) {
        setSum(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(data, "data.sum"));
      }

      return function cleanup() {};
    });
  }, debouncedSearchArgs);

  if (!sum) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    "/\xA0\xA0",
    sum
  );
}

/* harmony default export */ __webpack_exports__["a"] = (Sum);

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_IconText_IconText__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__IncomingQuotes_shared_AsIsFlag__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_ExchangeIcon__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_DropshipIcon__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



















function renderRow(lineItem, pushHistory) {
  var partiallyReceived = lineItem.quantity_received > 0 && lineItem.quantity_received < lineItem.quantity;

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("clickable", {
    "text-muted": lineItem.cancelled
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: lineItem.id,
      className: classes,
      style: { position: "relative" },
      onClick: function onClick() {
        return pushHistory("/purchase-orders/" + lineItem.purchase_order.uuid);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__shared_DropshipIcon__["a" /* DropshipIcon */], {
        shippingType: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(lineItem, "purchase_order.shipping_type"),
        exporting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(lineItem, "purchase_order.exporting"),
        createdAt: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(lineItem, "purchase_order.created_at")
      }),
      lineItem.purchase_order.code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__["e" /* shortDateAndTimestamp */])(lineItem.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__["b" /* shortDate */])(lineItem.date_received)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.company && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["w" /* CompanyName */], { company: lineItem.company, truncateAt: 20 })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.buyer && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.buyer.full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.co_buyer && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.co_buyer.full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.third_buyer && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.third_buyer.full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.invoice_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_16__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-center" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["o" /* LocationFlag */], {
          location: lineItem.purchase_order.buying_store_id,
          consignment_type: lineItem.consignment_type
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.has_vendor_rma && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_IconText_IconText__["a" /* default */], { icon: "fa-shield", note: "Vendor RMA" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.part && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["h" /* PartNumber */], { part: lineItem.part })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.alternate && lineItem.alternate.name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.condition && __WEBPACK_IMPORTED_MODULE_9__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].condition[lineItem.condition].abbrev,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__IncomingQuotes_shared_AsIsFlag__["a" /* AsIsFlag */], { lineItem: lineItem, className: "m-l-5" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      lineItem.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      lineItem.quantity_received,
      " ",
      partiallyReceived && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-btn fa-adjust" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      lineItem.lead_time
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_ExchangeIcon__["a" /* ExchangeIcon */], { lineItem: lineItem })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(lineItem.purchase_for_exchange && !lineItem.outright ? lineItem.exchange_fee : lineItem.cost)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      lineItem.sellable_quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      [lineItem.purchase_for_repair && "Repair", lineItem.purchase_for_repair_assist && "Assist", lineItem.purchase_for_sale && "Sale", lineItem.purchase_for_stock && "Stock"].filter(Boolean).join(", ")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], { note: lineItem.last_po_note })
  );
}

function Table(_ref) {
  var pushHistory = _ref.pushHistory,
      isLoading = _ref.isLoading,
      pageActions = _ref.pageActions,
      results = _ref.results;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components__["s" /* DataTable */],
    { loading: isLoading, refresh: pageActions.expire },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "PO #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Created"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Received"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Vendor"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Buyer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Co-Buyer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Third Buyer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Inv #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-center" },
          "Store Owner"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Buy As Alt"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "CD"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Qty"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Qty Rec"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "LT"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Exch"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "EXCH FEE/COST EA"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Sellable Qty"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Purchased For"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Note"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_8__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(undefined, {
  pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"]
})(Table));

/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayLink; });




var displayLink = function displayLink(r) {
  return r.serial_number === "Various" || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(r.inventory_link_id) ? r.serial_number || r.expected_serial_number : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
    { to: "/inventories/" + r.inventory_link_id },
    r.serial_number
  );
};

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_reducer__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(439);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  purchaseOrder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
}).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["a" /* notesInitialState */]).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["b" /* attachmentsInitialState */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _extends(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* SET */], function (state, action) {
  return state.merge({ purchaseOrder: action.purchaseOrder });
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["c" /* createAttachmentReducer */])(__WEBPACK_IMPORTED_MODULE_2__shared_types_resourceTypes__["a" /* default */].purchaseOrder), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["d" /* createNoteReducer */])(__WEBPACK_IMPORTED_MODULE_2__shared_types_resourceTypes__["a" /* default */].purchaseOrder))));

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_formField__ = __webpack_require__(142);





function BuyerStoreField(_ref) {
  var input = _ref.input,
      disabled = _ref.disabled;

  var usaClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn btn-default", {
    active: input.value === "USA",
    disabled: disabled
  });
  var ireClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn btn-default", {
    active: input.value === "IRE",
    disabled: disabled
  });
  var sgpClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn btn-default", {
    active: input.value === "SGP",
    disabled: disabled
  });

  var handleBuyerChange = function handleBuyerChange(newVal) {
    return function () {
      return !disabled && input.onChange(newVal);
    };
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group btn-group-justified", role: "group" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: usaClass, onClick: handleBuyerChange("USA") },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
      "\xA0\xA0USA"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: ireClass, onClick: handleBuyerChange("IRE") },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
      "\xA0\xA0IRE"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: sgpClass, onClick: handleBuyerChange("SGP") },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
      "\xA0\xA0SGP"
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_formField__["a" /* default */])(BuyerStoreField));

BuyerStoreField.propTypes = {
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_number__ = __webpack_require__(72);
/* harmony export (immutable) */ __webpack_exports__["a"] = CoBuyerField;







function CoBuyerField(_ref) {
  var buyerCreditPct = _ref.buyerCreditPct,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      numberOfBuyers = _ref.numberOfBuyers,
      searchBuyers = _ref.searchBuyers,
      selectedCoBuyer = _ref.selectedCoBuyer,
      toggleBuyer = _ref.toggleBuyer;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_4__users_constants__["z" /* CO_BUYER_ID */],
    label: "Co-Buyer and Credit",
    placeholder: "Search by name...",
    component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["n" /* AutoCompleteField */],
    search: searchBuyers,
    selectedItem: selectedCoBuyer,
    onItemSelected: function onItemSelected(item) {
      return toggleBuyer({ selectedCoBuyer: item });
    },
    formatItem: function formatItem(result) {
      return result && result.full_name;
    },
    append: selectedCoBuyer ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_number__["c" /* displayDecimal */])(buyerCreditPct / numberOfBuyers, 100),
      "%"
    ) : null,
    disabled: disabled
  });
}

CoBuyerField.propTypes = {
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  numberOfBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedCoBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  toggleBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_constants__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = ThirdBuyerField;






function ThirdBuyerField(_ref) {
  var buyerCreditPct = _ref.buyerCreditPct,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      numberOfBuyers = _ref.numberOfBuyers,
      searchBuyers = _ref.searchBuyers,
      selectedThirdBuyer = _ref.selectedThirdBuyer,
      toggleBuyer = _ref.toggleBuyer;

  if ([25, 50].includes(parseFloat(buyerCreditPct)) || numberOfBuyers < 2) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_4__users_constants__["y" /* THIRD_BUYER_ID */],
    label: "Third Buyer and Credit",
    placeholder: "Search by name...",
    component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["n" /* AutoCompleteField */],
    search: searchBuyers,
    selectedItem: selectedThirdBuyer,
    onItemSelected: function onItemSelected(item) {
      return toggleBuyer({ selectedThirdBuyer: item });
    },
    formatItem: function formatItem(result) {
      return result && result.full_name;
    },
    append: selectedThirdBuyer ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      null,
      parseInt(buyerCreditPct / numberOfBuyers, 10),
      "%"
    ) : null,
    disabled: disabled
  });
}

ThirdBuyerField.propTypes = {
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  numberOfBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedThirdBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  toggleBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = DropshipIcon;






function DropshipIcon(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? "" : _ref$className,
      createdAt = _ref.createdAt,
      exporting = _ref.exporting,
      shippingType = _ref.shippingType;

  if ([__WEBPACK_IMPORTED_MODULE_2__shared_components_ShippingSection_shippingTypes__["a" /* TENANT_LOCATION */], __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* DO_NOT_SHIP */]].includes(shippingType)) return null;

  var domesticFeatureActive = new Date(2024, 9, 31) < new Date(createdAt);

  if (!exporting || !domesticFeatureActive) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { style: { position: "absolute", left: "-21px", top: "8px" } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["j" /* NoteTooltip */], {
        url: "https://info-trader-assets.s3.us-east-2.amazonaws.com/icons/dropship.png",
        note: domesticFeatureActive ? "Domestic Dropship" : "Dropship",
        placement: "top",
        className: className
      })
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { style: { position: "absolute", left: "-21px", top: "8px" } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["j" /* NoteTooltip */], {
      icon: "fa-globe",
      note: "International Dropship",
      placement: "top",
      color: "white",
      className: className
    })
  );
}
DropshipIcon.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony export (immutable) */ __webpack_exports__["a"] = TierTypeWarning;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();











function TierTypeWarning(_ref) {
  var cost = _ref.cost,
      part = _ref.part,
      _ref$quantity = _ref.quantity,
      quantity = _ref$quantity === undefined ? 0 : _ref$quantity,
      _ref$initialQuantity = _ref.initialQuantity,
      initialQuantity = _ref$initialQuantity === undefined ? 0 : _ref$initialQuantity;

  if (!part) {
    return null;
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(cost) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(quantity)) return null;

  var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks_useCurrentUser__["a" /* default */])();

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
      _useState2 = _slicedToArray(_useState, 2),
      sellableQty = _useState2[0],
      setSellableQty = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),
      _useState4 = _slicedToArray(_useState3, 2),
      tierTypeLimits = _useState4[0],
      setTierTypeLimits = _useState4[1];

  var getValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (tierType, field) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(tierTypeLimits.filter(function (t) {
      return t.tier === tierType;
    }), "[0]." + field);
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].appSetting.index().then(function (_ref2) {
      var data = _ref2.data;

      setTierTypeLimits(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(data, __WEBPACK_IMPORTED_MODULE_4__constants__["_0" /* TIER_TYPE_WARNING_LIMITS */]));
    });
  }, [part.id]);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].parts.sellableQuantities(part.id).then(function (_ref3) {
      var data = _ref3.data;

      setSellableQty(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["sum"])(Object.values(data)));
    });
  }, [part.id]);

  if (!tierTypeLimits) return null;

  var action = user.high_confidence_buyer ? "Please reevaluate purchase" : "Manager Approval is required";

  var tier = part.tier_type || __WEBPACK_IMPORTED_MODULE_6__parts_constants__["I" /* NON_QUALIFIER */];
  var showQtyWarning = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(quantity) && getValue(tier, __WEBPACK_IMPORTED_MODULE_4__constants__["_1" /* QTY */]) && sellableQty + parseFloat(quantity) - parseFloat(initialQuantity) > Number(getValue(tier, __WEBPACK_IMPORTED_MODULE_4__constants__["_1" /* QTY */]));

  var showCostWarning = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(cost) && getValue(tier, __WEBPACK_IMPORTED_MODULE_4__constants__["V" /* COST */]) && cost > Number(getValue(tier, __WEBPACK_IMPORTED_MODULE_4__constants__["V" /* COST */]));

  if (showCostWarning || showQtyWarning) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      showQtyWarning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Warning_Warning__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_6__parts_constants__["J" /* TIER_TYPES_MAP */][tier],
        " Warning: This would potentially put us at or over a sellable quantity of ",
        getValue(tier, __WEBPACK_IMPORTED_MODULE_4__constants__["_1" /* QTY */]),
        " units in stock.",
        " ",
        action,
        "."
      ),
      showCostWarning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Warning_Warning__["a" /* default */],
        null,
        "Warning: You are purchasing this at or above cost of",
        " ",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__["a" /* dollars */])(getValue(tier, __WEBPACK_IMPORTED_MODULE_4__constants__["V" /* COST */])),
        ". ",
        action,
        "."
      )
    );
  }

  return null;
}

TierTypeWarning.propTypes = {
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  initialQuantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Stat_Stat__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Stats__ = __webpack_require__(677);









function HeaderStats(_ref) {
  var currentUser = _ref.currentUser,
      purchasesData = _ref.purchasesData;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Stats__["a" /* PurchasesCount */], { dateLabel: "Today", data: purchasesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Stats__["b" /* PurchaseLinesCount */], { dateLabel: "Today", data: purchasesData })
    ),
    currentUser.locations.length > 1 && purchasesData.perLocation.map(function (l) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4, lg: 2 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Stat_Stat__["a" /* default */], {
          label: "$ Purchases " + l.name + " - Today",
          value: __WEBPACK_IMPORTED_MODULE_6_numeral___default()(l.total_purchases).format("($0,0)")
        })
      );
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Stats__["g" /* LotPurchasesSum */], { dateLabel: "Today", data: purchasesData })
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Stats__["h" /* PurchasesSum */], { data: purchasesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Stat_Stat__["a" /* default */], {
        label: "$ Purchased For Stock",
        value: __WEBPACK_IMPORTED_MODULE_6_numeral___default()(purchasesData.purchased_for_stock_or_repair_assist).format("($0,0)")
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Stat_Stat__["a" /* default */], {
        label: "$ Purchased For Repair",
        value: __WEBPACK_IMPORTED_MODULE_6_numeral___default()(purchasesData.purchased_for_repair_total).format("($0,0)")
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Stat_Stat__["a" /* default */], {
        label: "$ Purchased For Sale",
        value: __WEBPACK_IMPORTED_MODULE_6_numeral___default()(purchasesData.purchased_for_sale_total).format("($0,0)")
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Stats__["d" /* SrpTotal */], { data: purchasesData })
    )
  )];
}

HeaderStats.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ locations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})) }),
  purchasesData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}))
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__["b" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["u" /* withPolling */])(HeaderStats)));

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PerLocationModal__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_numeral__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Stats__ = __webpack_require__(677);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();












function MonthlyStats(_ref) {
  var currentUser = _ref.currentUser,
      selectedDate = _ref.selectedDate,
      purchasesData = _ref.purchasesData;

  var date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(selectedDate).format("MMM YYYY");

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Stats__["a" /* PurchasesCount */], { dateLabel: date, data: purchasesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Stats__["b" /* PurchaseLinesCount */], { dateLabel: date, data: purchasesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            textAlign: "center"
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["H" /* Stat */], {
          label: ["$ Purchases Total", currentUser.locations.length > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
            className: "fa fa-info-circle fa-sm pointer",
            onClick: function onClick() {
              return setOpen(true);
            },
            style: { marginLeft: "5px" }
          })].filter(function (f) {
            return f;
          }),
          value: __WEBPACK_IMPORTED_MODULE_8_numeral___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__Stats__["c" /* purchasesSum */])(purchasesData)).format("($0,0)")
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Stats__["d" /* SrpTotal */], { data: purchasesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Stats__["e" /* TotalRealized */], { dateLabel: date, data: purchasesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 1 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Stats__["f" /* TotalRealizedPercent */], { dateLabel: date, data: purchasesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__PerLocationModal__["a" /* default */], {
      purchasesData: purchasesData,
      open: open,
      setOpen: setOpen
    })
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { lgOffset: 2, mdOffset: 5, md: 4, lg: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["H" /* Stat */], {
        label: "$ Purchased For Stock",
        value: __WEBPACK_IMPORTED_MODULE_8_numeral___default()(purchasesData.purchased_for_stock_or_repair_assist).format("($0,0)")
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["H" /* Stat */], {
        label: "$ Purchased For Repair",
        value: __WEBPACK_IMPORTED_MODULE_8_numeral___default()(purchasesData.purchased_for_repair_total).format("($0,0)")
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["H" /* Stat */], {
        label: "$ Purchased For Sale",
        value: __WEBPACK_IMPORTED_MODULE_8_numeral___default()(purchasesData.purchased_for_sale_total).format("($0,0)")
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 4, lg: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Stats__["g" /* LotPurchasesSum */], { dateLabel: date, data: purchasesData })
    )
  )];
}

MonthlyStats.propTypes = {
  selectedDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  purchasesData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}))
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["b" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["u" /* withPolling */])(MonthlyStats)));

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_numeral__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal_Body__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__ = __webpack_require__(26);









function PerLocationModal(_ref) {
  var purchasesData = _ref.purchasesData,
      open = _ref.open,
      setOpen = _ref.setOpen;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
      { open: open, close: function close() {
          return setOpen(false);
        }, dialogClass: "modal-sm" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: function close() {
            return setOpen(false);
          } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Purchases By Location"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal_Body__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__["a" /* default */],
          null,
          purchasesData.perLocation.map(function (l) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
              { md: 4, lg: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["H" /* Stat */], {
                label: "$ Purchases " + l.name,
                value: __WEBPACK_IMPORTED_MODULE_5_numeral___default()(l.total_purchases).format("($0,0)")
              })
            );
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["d" /* Footer */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          { className: "btn btn-primary", onClick: function onClick() {
              return setOpen(false);
            } },
          "Close"
        )
      )
    )
  );
}

PerLocationModal.propTypes = {
  purchasesData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  setOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (PerLocationModal);

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Locations_components_LocationsDropDown__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_SimpleDateRangePicker_SimpleDateRangePicker__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__MonthlyStats__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HeaderStats__ = __webpack_require__(1575);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















function renderRow(r, currentUser) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { key: r.buyer },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_router_dom__["a" /* Link */],
        { to: "/purchases-report?buyer_id=" + r.buyer_id },
        r.buyer
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      r.incoming_quotes_count
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      r.incoming_quotes_complete
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      r.pos_created_count
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      r.po_line_items_count
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_number__["e" /* displayInt */])(r.iq_to_po_conversion_percent),
      " %"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(r.total_purchases, 0)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(r.total_lot_purchases, 0)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(r.total_realized, 0)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_number__["a" /* percent */])(r.total_realized, r.total_purchases)
    ),
    currentUser.tenant.tools_used.map(function (t) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-right" },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_number__["a" /* percent */])(r[t], r.total_tools_used)
      );
    })
  );
}

var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    _classCallCheck(this, Table);

    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this));

    _this.handleDateChange = function (startDate, endDate) {
      _this.setState({
        endDate: endDate,
        monthlyDataLoading: true,
        selectedDate: startDate,
        startDate: startDate
      });

      if (startDate) {
        _this.fetchMonthResults(startDate);
      } else {
        _this.setState({
          monthResults: [],
          monthlyDataLoading: false
        });
      }
    };

    _this.handleLocationChange = function (locationId) {
      _this.setState({
        monthlyDataLoading: true,
        locationId: locationId
      });

      _this.fetchMonthResults(_this.state.selectedDate, locationId);
    };

    _this.fetchMonthResults = _this.fetchMonthResults.bind(_this);
    _this.fetchTodaysResults = _this.fetchTodaysResults.bind(_this);
    _this.state = {
      monthResults: [],
      todaysResults: [],
      monthlyDataLoading: false,
      startDate: __WEBPACK_IMPORTED_MODULE_7_moment___default()().startOf(__WEBPACK_IMPORTED_MODULE_12__constants__["_33" /* MONTH */]),
      endDate: __WEBPACK_IMPORTED_MODULE_7_moment___default()().endOf(__WEBPACK_IMPORTED_MODULE_12__constants__["_33" /* MONTH */])
    };
    return _this;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchTodaysResults();
      this.fetchMonthResults();
    }
  }, {
    key: "fetchTodaysResults",
    value: function fetchTodaysResults() {
      var _this2 = this;

      var startTime = __WEBPACK_IMPORTED_MODULE_7_moment___default()().startOf("day").format();
      var endTime = __WEBPACK_IMPORTED_MODULE_7_moment___default()().endOf("day").format();

      Promise.all([__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reports.purchases.search(startTime, endTime), __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reports.purchases.searchPerLocation(startTime, endTime)]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            res = _ref2[0],
            perLocation = _ref2[1];

        _this2.setState({
          todaysResults: Object.assign(res.data, {
            perLocation: perLocation.data
          }),
          monthlyDataLoading: false
        });
      });
    }
  }, {
    key: "fetchMonthResults",
    value: function fetchMonthResults(selectedDate, locationId) {
      var _this3 = this;

      var _state = this.state,
          startDate = _state.startDate,
          endDate = _state.endDate;


      Promise.all([__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reports.purchases.search(startDate, endDate, locationId), __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reports.purchases.searchPerLocation(startDate, endDate)]).then(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            search = _ref4[0],
            perLocation = _ref4[1];

        var buyers = search.data.buyers;

        _this3.setState({
          monthResults: _extends({}, search.data, { buyers: buyers, perLocation: perLocation.data }),
          monthlyDataLoading: false
        });
      });
    }
  }, {
    key: "reportStartTime",
    value: function reportStartTime(selectedDate) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(selectedDate || this.state.selectedDate).startOf("month").format();
    }
  }, {
    key: "reportEndTime",
    value: function reportEndTime(selectedDate) {
      return (this.reportStartTime(selectedDate) ? __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.reportStartTime(selectedDate)) : __WEBPACK_IMPORTED_MODULE_7_moment___default()()).endOf("month").format();
    }
  }, {
    key: "render",
    value: function render() {
      var _state2 = this.state,
          todaysResults = _state2.todaysResults,
          monthResults = _state2.monthResults,
          monthlyDataLoading = _state2.monthlyDataLoading,
          selectedDate = _state2.selectedDate,
          startDate = _state2.startDate,
          endDate = _state2.endDate;
      var currentUser = this.props.currentUser;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        todaysResults.buyers && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__HeaderStats__["a" /* default */], {
          purchasesData: todaysResults,
          refresh: this.fetchTodaysResults
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Row */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: "page-header monthly-purchases-header",
                style: { padding: "10px, 30px" }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h1",
                { style: { marginTop: "7px" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { className: "header-content" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    { style: { marginRight: "10px", verticalAlign: "super" } },
                    startDate && "" + __WEBPACK_IMPORTED_MODULE_7_moment___default()(startDate).format("MMMM DD YYYY"),
                    endDate && "- " + __WEBPACK_IMPORTED_MODULE_7_moment___default()(endDate).format("MMMM DD YYYY")
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: { display: "inline-block" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_SimpleDateRangePicker_SimpleDateRangePicker__["a" /* default */], {
                      handleDateChange: this.handleDateChange
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { style: { display: "flex" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Locations_components_LocationsDropDown__["a" /* default */], { handleChange: this.handleLocationChange }),
                monthResults.buyers && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "a",
                  {
                    href: __WEBPACK_IMPORTED_MODULE_12__constants__["d" /* API_BASE */] + "/monthly_purchases/download.xls?start_time=" + this.reportStartTime() + "&end_time=" + this.reportEndTime(),
                    target: "_blank",
                    rel: "noopener noreferrer"
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    {
                      className: "btn btn-primary btn-hollow pull-right m-l-5",
                      type: "button"
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-cloud-download" }),
                    "\xA0\xA0Download Report"
                  )
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Row */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */],
              { loading: monthlyDataLoading, loadingRows: 40 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Head,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Name"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "# IQs "
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "# IQ Lines "
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "# POs"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "# PO Lines"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "IQ/PO Conv. %"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "Purchased"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "Lot Purch"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "Total Realized"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "% Realized"
                ),
                currentUser.tenant.tools_used.map(function (t) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(t)
                  );
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Body,
                null,
                monthResults.buyers ? monthResults.buyers.map(function (r) {
                  return renderRow(r, currentUser);
                }) : []
              )
            )
          )
        ),
        monthResults.buyers && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__MonthlyStats__["a" /* default */], {
          selectedDate: selectedDate,
          purchasesData: monthResults,
          refresh: this.fetchMonthResults
        })
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Table.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__session_decorators_withCurrentUser__["b" /* default */])(Table));

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony export (immutable) */ __webpack_exports__["a"] = BuyerReportTable;








var renderDollarValues = function renderDollarValues(report, period, stat) {
  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "current[0]" + stat))
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "past[0]" + stat))
  ), period === "last_year" ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "average[0]" + stat))
  )];
};
var renderPercentValues = function renderPercentValues(report, period, stat) {
  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__["f" /* displayFloat */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "current[0]" + stat)),
    " %"
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__["f" /* displayFloat */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "past[0]" + stat)),
    " %"
  ), period === "last_year" ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__["f" /* displayFloat */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "average[0]" + stat)),
    " %"
  )];
};

var renderValues = function renderValues(report, period, stat) {
  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__["e" /* displayInt */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "current[0]" + stat))
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__["e" /* displayInt */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "past[0]" + stat))
  ), period === "last_year" ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__["f" /* displayFloat */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "average[0]" + stat))
  )];
};

var renderHeader = function renderHeader(period) {
  switch (period) {
    case "week":
      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Current Week"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Last Week"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Last Four Weeks (Avg/Week)"
      )];
    case "month":
      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Current Month"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Last Month"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Current Month (Projected)"
      )];
    case "quarter":
      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Current Quarter"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Last Quarter"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Current Quarter (Projected)"
      )];
    case "year":
      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Current Year"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Last Year"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Current Year (Projected)"
      )];
    case "last_year":
      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Last Year"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Two Years Ago"
      )];
    default:
      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Today"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Yesterday (last working day)"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Current Month (Avg/Working Day)"
      )];
  }
};

function BuyerReportTable(_ref) {
  var results = _ref.results,
      isLoading = _ref.isLoading;

  var _parse = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_query_string__["parse"])(location.search),
      period = _parse.period;

  var report = results[0];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */],
    { loading: isLoading, loadingRows: 11, style: { width: 0 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      renderHeader(period)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Total Purchased ($)"
        ),
        renderDollarValues(report, period, "total_purchases_all")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Total Cancelled ($)"
        ),
        renderDollarValues(report, period, "total_purchases_cancelled")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Total Non-Cancelled ($)"
        ),
        renderDollarValues(report, period, "total_purchases")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Total Lot Purchases ($)"
        ),
        renderDollarValues(report, period, "total_lot_purchases")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "#Incoming Quote Lines Entered"
        ),
        renderValues(report, period, "incoming_quote_lines_entered")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "#Incoming Quote Lines Complete"
        ),
        renderValues(report, period, "incoming_quotes_complete")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "#Incoming Quote Lines Completed (%)"
        ),
        renderPercentValues(report, period, "incoming_quote_lines_complete_percent")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "#PO Lines"
        ),
        renderValues(report, period, "po_line_items_count")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "#PO's Placed"
        ),
        renderValues(report, period, "pos_placed")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "I-Quote to PO Conversion (By Lines) (%)"
        ),
        renderPercentValues(report, period, "iq_to_po_conversion")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "#PO Lines Shared"
        ),
        renderValues(report, period, "po_lines_shared")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "#PO Lines Shared (%)"
        ),
        renderPercentValues(report, period, "po_lines_shared_percent")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "# PO Line Cancellations"
        ),
        renderValues(report, period, "po_line_cancellations")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "PO Cancellation %"
        ),
        renderPercentValues(report, period, "po_cancellation_percent")
      )
    )
  );
}

BuyerReportTable.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony export (immutable) */ __webpack_exports__["a"] = CurrentPurchasesTable;







var renderRow = function renderRow(r, pageActions) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { key: r.buyer },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      {
        className: "btn btn-link text-left",
        style: { textTransform: "none", minWidth: 0 },
        onClick: function onClick() {
          return pageActions.setFilter("buyer_id", r.buyer_id);
        }
      },
      r.buyer
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(r.total_purchases)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(r.total_lot_purchases)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(r.total_purchases_cancelled)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["e" /* displayInt */])(r.incoming_quote_lines_entered)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["e" /* displayInt */])(r.incoming_quotes_complete)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["f" /* displayFloat */])(r.incoming_quote_lines_complete_percent),
      " %"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["e" /* displayInt */])(r.po_line_items_count)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["e" /* displayInt */])(r.pos_placed)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["f" /* displayFloat */])(r.iq_to_po_conversion),
      " %"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["e" /* displayInt */])(r.po_lines_shared)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["f" /* displayFloat */])(r.po_lines_shared_percent),
      " %"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["e" /* displayInt */])(r.po_line_cancellations)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["f" /* displayFloat */])(r.po_cancellation_percent),
      " %"
    )
  );
};

function CurrentPurchasesTable(_ref) {
  var results = _ref.results,
      isLoading = _ref.isLoading,
      pageActions = _ref.pageActions;

  var report = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(results[0], "current");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */],
    { loading: isLoading, loadingRows: 30 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Total Purchased ($)"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Total Lot Purchased ($)"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Total Cancelled ($)"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "#IQs Entered"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "#IQs Completed"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "#IQs Completed (%)"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "#PO Line Items "
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "#PO's Placed"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "IQ-PO Conversion (%)"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "#Shared PO's Items"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "#Shared PO Items (%)"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "# PO Cancellation Items"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "PO Cancellation Items %"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */].Body,
      null,
      report ? report.map(function (r) {
        return renderRow(r, pageActions);
      }) : []
    )
  );
}

CurrentPurchasesTable.propTypes = {
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  pageActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired
};

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CurrentPurchasesTable__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BuyerReportTable__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pagination__ = __webpack_require__(678);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var filters = [{
  label: "Show Today",
  filters: { period: "day" }
}, {
  label: "Show This Week",
  filters: { period: "week" }
}, {
  label: "Show This Month",
  filters: { period: "month" }
}, {
  label: "Show This Quarter",
  filters: { period: "quarter" }
}, {
  label: "Show This Year",
  filters: { period: "year" }
}, {
  label: "Show Last Year",
  filters: { period: "last_year" }
}];

var filterTags = [{
  label: "Today",
  key: "period",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("day")
}, {
  label: "Today",
  key: "period",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(undefined)
}, {
  label: "This Week",
  key: "period",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("week")
}, {
  label: "This Month",
  key: "period",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("month")
}, {
  label: "This Quarter",
  key: "period",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("quarter")
}, {
  label: "This Year",
  key: "period",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("year")
}, {
  label: "Last Year",
  key: "period",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("last_year")
}];

var PurchasesReport = function (_Component) {
  _inherits(PurchasesReport, _Component);

  function PurchasesReport(props) {
    _classCallCheck(this, PurchasesReport);

    var _this = _possibleConstructorReturn(this, (PurchasesReport.__proto__ || Object.getPrototypeOf(PurchasesReport)).call(this, props));

    _this.state = {
      buyersFilter: [],
      buyersTags: []
    };

    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].users.search({
      yearly_buyers: true,
      page: 1,
      sort: "first_name",
      reverse: false,
      limit: 1000
    }).then(function (resp) {
      var buyers = resp.data.results;
      var buyersOptions = buyers.map(function (b) {
        return {
          label: b.full_name,
          filters: { buyer_id: b.id, report_type: "single" }
        };
      });
      var buyersTags = buyers.map(function (b) {
        return {
          label: b.full_name,
          key: "buyer_id",
          matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["a" /* matchesBoolean */])(b.id)
        };
      }).concat([{
        label: "Everyone Combined",
        key: "buyer_id",
        matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("all")
      }]);

      _this.state = {
        buyersFilter: [{
          label: "View All",
          filters: { buyer_id: undefined, report_type: "single" }
        }].concat(buyersOptions).concat([{
          label: "Everyone Combined",
          filters: { buyer_id: "all", report_type: "all" }
        }]),
        buyersTags: buyersTags
      };
    });
    return _this;
  }

  _createClass(PurchasesReport, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components__["c" /* Search */],
        { search: __WEBPACK_IMPORTED_MODULE_8__pagination__["a" /* default */], syncWithUrl: true },
        function (searchProps) {
          var buyerId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_query_string__["parse"])(location.search).buyer_id;
          var title = "Purchase Credit by Buyer";
          if (buyerId) {
            title = "Purchasing Report Card";
          }
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group form-group-searchbar" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: "input-group buyer-stats-filters",
                  style: { width: "240px" }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
                  title: "Period",
                  filters: filters
                })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
                  title: "Buyer",
                  filters: _this2.state.buyersFilter
                }))
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
              title: title,
              filters: filterTags.concat(_this2.state.buyersTags)
            })),
            buyerId !== undefined ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__BuyerReportTable__["a" /* default */], searchProps) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CurrentPurchasesTable__["a" /* default */], searchProps)
          );
        }
      );
    }
  }]);

  return PurchasesReport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PurchasesReport);

/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_submission__ = __webpack_require__(49);
/* unused harmony export EditForm */
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












var formName = "updateQuarterlyGoalForm";

function EditForm(props) {
  var setEditingQuarterlyGoal = props.setEditingQuarterlyGoal;

  var currentYear = __WEBPACK_IMPORTED_MODULE_5_moment___default()().year();
  var years = [0, 1, 2].map(function (n) {
    return {
      text: currentYear + n,
      value: currentYear + n
    };
  });
  var quarters = [1, 2, 3, 4].map(function (n) {
    return { text: "Quarter " + n, value: n };
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "year",
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
            options: years,
            label: "Year",
            required: true,
            disabled: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "quarter",
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
            options: quarters,
            label: "Quarter",
            required: true,
            disabled: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], { name: "amount", label: "Amount", required: true })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */], { md: 4 })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Footer,
      {
        style: {
          width: "calc(100% + 50px)",
          marginLeft: "-25px",
          paddingBottom: "0"
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
        { onClick: function onClick() {
            return setEditingQuarterlyGoal(null);
          } },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
        { type: "submit", bsStyle: "primary" },
        "Save"
      )
    )
  );
}

EditForm.propTypes = {
  setEditingQuarterlyGoal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  quarterlyGoal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    year: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    quarter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    amount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }),
  searchQuarterlyGoals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, {})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["j" /* form */])({
  form: formName,
  onSubmit: function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data, _, props) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].quarterlyGoals.update(props.quarterlyGoal.id, data).then(function () {
                props.searchQuarterlyGoals();
                props.setEditingQuarterlyGoal(false);
                return __WEBPACK_IMPORTED_MODULE_9__lib_submission__["a" /* SUCCESS */];
              }).catch(function () {
                return __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Error", "Couldn't add quarterly goal. Please ensure there is no quarterly goal for the selected year and quarter.");
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function onSubmit(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }()
})(EditForm)));

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_submission__ = __webpack_require__(49);
/* unused harmony export Form */
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












var formName = "createQuarterlyGoalForm";

function Form(props) {
  var setCreatingQuarterlyGoal = props.setCreatingQuarterlyGoal;

  var currentYear = __WEBPACK_IMPORTED_MODULE_5_moment___default()().year();
  var years = [0, 1, 2].map(function (n) {
    return {
      text: currentYear + n,
      value: currentYear + n
    };
  });
  var quarters = [1, 2, 3, 4].map(function (n) {
    return { text: "Quarter " + n, value: n };
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "year",
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
            options: years,
            label: "Year",
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "quarter",
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
            options: quarters,
            label: "Quarter",
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], { name: "amount", label: "Amount", required: true })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */], { md: 4 })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Footer,
      {
        style: {
          width: "calc(100% + 50px)",
          marginLeft: "-25px",
          paddingBottom: "0"
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
        { onClick: function onClick() {
            return setCreatingQuarterlyGoal(false);
          } },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
        { type: "submit", bsStyle: "primary" },
        "Save"
      )
    )
  );
}

Form.propTypes = {
  setCreatingQuarterlyGoal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchQuarterlyGoals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, {})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["j" /* form */])({
  form: formName,
  onSubmit: function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data, _, props) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].quarterlyGoals.create(data).then(function () {
                props.searchQuarterlyGoals();
                props.setCreatingQuarterlyGoal(false);
                return __WEBPACK_IMPORTED_MODULE_9__lib_submission__["a" /* SUCCESS */];
              }).catch(function () {
                return __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Error", "Couldn't add quarterly goal. Please ensure there is no quarterly goal for the selected year and quarter.");
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function onSubmit(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }()
})(Form)));

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Table__ = __webpack_require__(1585);
/* harmony export (immutable) */ __webpack_exports__["a"] = QuarterlyGoals;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








function modalTitle(creating, editing) {
  if (creating) return "Add a Quarterly Goal";
  if (editing) return "Edit Quarterly Goal";
  return "Quarterly Goals";
}

function QuarterlyGoalsModal(_ref) {
  var editing = _ref.editing,
      close = _ref.close,
      goals = _ref.goals,
      searchQuarterlyGoals = _ref.searchQuarterlyGoals;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      creatingQuarterlyGoal = _useState2[0],
      setCreatingQuarterlyGoal = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      editingQuarterlyGoal = _useState4[0],
      setEditingQuarterlyGoal = _useState4[1];

  var title = modalTitle(creatingQuarterlyGoal, editingQuarterlyGoal);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        title
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Table__["a" /* default */], {
        creatingQuarterlyGoal: creatingQuarterlyGoal,
        setCreatingQuarterlyGoal: setCreatingQuarterlyGoal,
        editingQuarterlyGoal: editingQuarterlyGoal,
        setEditingQuarterlyGoal: setEditingQuarterlyGoal,
        searchQuarterlyGoals: searchQuarterlyGoals,
        closeModal: close,
        goals: goals
      })
    ),
    editingQuarterlyGoal || creatingQuarterlyGoal ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["d" /* Footer */], { style: { display: "none" } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* Button */],
        { onClick: close },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* Button */],
        {
          bsStyle: creatingQuarterlyGoal ? "danger" : "primary",
          onClick: function onClick() {
            return setCreatingQuarterlyGoal(!creatingQuarterlyGoal);
          }
        },
        "Add Goal"
      )
    )
  );
}

QuarterlyGoalsModal.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  goals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  searchQuarterlyGoals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

function QuarterlyGoals() {
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState6 = _slicedToArray(_useState5, 2),
      editing = _useState6[0],
      setEditing = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState8 = _slicedToArray(_useState7, 2),
      goals = _useState8[0],
      setGoals = _useState8[1];

  var searchQuarterlyGoals = function searchQuarterlyGoals() {
    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].quarterlyGoals.search({}).then(function (resp) {
      setGoals(resp.data.results);
      setEditing(true);
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "a",
      { style: { cursor: "pointer" }, onClick: searchQuarterlyGoals },
      "Quarterly Goals"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QuarterlyGoalsModal, {
      editing: editing,
      close: function close() {
        return setEditing(false);
      },
      goals: goals,
      searchQuarterlyGoals: searchQuarterlyGoals
    })
  );
}

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EditForm__ = __webpack_require__(1582);
/* harmony export (immutable) */ __webpack_exports__["a"] = Table;








function dropdown(setEditingQuarterlyGoal, r) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    {
      className: "text-center td-shrink-icon",
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["_7" /* DropDown */],
      {
        icon: "fa fa-fw fa-ellipsis-v",
        menuClass: "dropdown-menu-right large"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components__["l" /* DropDownItem */],
        { onClick: function onClick() {
            return setEditingQuarterlyGoal(r);
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "edit", fixed: true }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "with-padding" },
          "Edit"
        )
      )
    )
  );
}

function renderRow(r, mostRecent, setEditingQuarterlyGoal) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { key: r.id },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.year
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      "Quarter ",
      r.quarter
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(r.amount)
    ),
    mostRecent ? dropdown(setEditingQuarterlyGoal, r) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null)
  );
}

function Table(_ref) {
  var creatingQuarterlyGoal = _ref.creatingQuarterlyGoal,
      setCreatingQuarterlyGoal = _ref.setCreatingQuarterlyGoal,
      editingQuarterlyGoal = _ref.editingQuarterlyGoal,
      setEditingQuarterlyGoal = _ref.setEditingQuarterlyGoal,
      searchQuarterlyGoals = _ref.searchQuarterlyGoals,
      goals = _ref.goals;

  var quarter = goals && goals.length > 0 ? [1, 2, 3, 4, 1][__WEBPACK_IMPORTED_MODULE_2_moment___default()().quarter()] : __WEBPACK_IMPORTED_MODULE_2_moment___default()().quarter();
  var year = __WEBPACK_IMPORTED_MODULE_2_moment___default()().quarter() + 1 > 4 ? __WEBPACK_IMPORTED_MODULE_2_moment___default()().year() + 1 : __WEBPACK_IMPORTED_MODULE_2_moment___default()().year();
  var initialValues = {
    year: year,
    quarter: quarter,
    amount: 0
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    !editingQuarterlyGoal && creatingQuarterlyGoal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Form__["a" /* default */], {
      close: function close() {
        return setCreatingQuarterlyGoal(false);
      },
      setCreatingQuarterlyGoal: setCreatingQuarterlyGoal,
      searchQuarterlyGoals: searchQuarterlyGoals,
      initialValues: initialValues,
      enableReinitialize: true
    }),
    editingQuarterlyGoal && !creatingQuarterlyGoal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EditForm__["a" /* default */], {
      close: function close() {
        return setEditingQuarterlyGoal(null);
      },
      setEditingQuarterlyGoal: setEditingQuarterlyGoal,
      quarterlyGoal: editingQuarterlyGoal,
      searchQuarterlyGoals: searchQuarterlyGoals,
      initialValues: {
        year: editingQuarterlyGoal.year,
        quarter: editingQuarterlyGoal.quarter,
        amount: editingQuarterlyGoal.amount
      },
      enableReinitialize: true
    }),
    !editingQuarterlyGoal && !creatingQuarterlyGoal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */],
      { loading: false, refresh: function refresh() {} },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */].Head,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Year"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Quarter"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Amount"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */].Body,
        null,
        goals.map(function (r, idx) {
          return renderRow(r, idx === 1 || idx === 0, setEditingQuarterlyGoal);
        })
      )
    )
  );
}

Table.propTypes = {
  creatingQuarterlyGoal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  setCreatingQuarterlyGoal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  editingQuarterlyGoal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  setEditingQuarterlyGoal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchQuarterlyGoals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  goals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    year: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    quarter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    amount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })
};

/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(1587);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditQuote;






function EditQuote(_ref) {
  var quote = _ref.quote,
      open = _ref.open,
      close = _ref.close,
      updateQuote = _ref.updateQuote;

  var initialValues = {
    company_id: quote && quote.company && quote.company.id,
    contact_id: quote.portal_purchase ? __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */] : quote && quote.contact && quote.contact.id,
    company: {
      website: quote.company && quote.company.website
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-sm" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Edit Quote Details"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], {
        quote: quote,
        close: close,
        updateQuote: updateQuote,
        initialValues: initialValues,
        enableReinitialize: true
      })
    )
  );
}

EditQuote.propTypes = {
  quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  updateQuote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__companies_shared_FindOrCreateCompanyToggle_SearchCompanyField__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__companies_actions_actions__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__companies_helpers__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__companies_shared_components_RestrictedEntityWarning__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__validate__ = __webpack_require__(1588);
/* unused harmony export Form */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var FORM_NAME = "editQuote";

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedCompany: {},
      options: [{ text: "+ Add a Contact", value: "Add" }]
    }, _this.fetchContactOptions = function (companyId) {
      if (companyId) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parts_actions__["g" /* searchContacts */])(companyId).then(function () {
          var vals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

          var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__companies_helpers__["b" /* contactSelectList */])(vals, true);

          return _this.setState({ options: opts });
        });
      }

      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.quote && this.props.quote.company) {
        this.fetchContactOptions(this.props.quote.company.id);
        this.setState({
          selectedCompany: this.props.quote.company
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          quote = _props.quote,
          contact = _props.contact,
          setFieldValue = _props.setFieldValue;

      var addContact = contact === "Add";
      var portalPurchase = contact === __WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */];
      var _state = this.state,
          options = _state.options,
          selectedCompany = _state.selectedCompany;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__companies_shared_components_RestrictedEntityWarning__["a" /* default */], { company: selectedCompany, allContacts: true }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], {
                  names: [__WEBPACK_IMPORTED_MODULE_9__constants__["N" /* COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_9__constants__["O" /* CONTACT_ID */]],
                  component: __WEBPACK_IMPORTED_MODULE_7__companies_shared_FindOrCreateCompanyToggle_SearchCompanyField__["a" /* default */],
                  selectedCompany: quote && quote.company,
                  onResultSelected: function onResultSelected(result) {
                    _this2.fetchContactOptions(result.id);
                    _this2.setState({
                      selectedCompany: result
                    });
                    setFieldValue([__WEBPACK_IMPORTED_MODULE_9__constants__["i" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_15__companies_constants__["e" /* WEBSITE */]].join("."))(result.website);
                  },
                  placeholder: "Search by typing a company's name or code",
                  required: true
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_9__constants__["O" /* CONTACT_ID */],
                  component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["c" /* Select */],
                  options: options,
                  label: "Vendor Contact",
                  required: true
                })
              )
            )
          ),
          portalPurchase && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.state, "selectedCompany.website"),
                  name: "company.website",
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_15__companies_constants__["e" /* WEBSITE */]),
                  required: true
                })
              )
            )
          ),
          addContact && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    name: "contact.name",
                    component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                    label: "Contact Name",
                    required: true
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    name: "contact.email",
                    component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                    label: "Contact Email",
                    required: true
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  contact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
    })
  })
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(FORM_NAME);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    contact: selector(state, __WEBPACK_IMPORTED_MODULE_9__constants__["O" /* CONTACT_ID */])
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(ownProps.updateQuote(data));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(FORM_NAME, field, val));
      };
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_17__validate__["a" /* default */],
  asyncValidate: __WEBPACK_IMPORTED_MODULE_8__companies_actions_actions__["b" /* validateContact */],
  asyncBlurFields: ["contact.email"]
})(Form)));

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;






function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["N" /* COMPANY_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
    form.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["O" /* CONTACT_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);

    if (values.contact_id === __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */]) {
      form.validateChild(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* COMPANY */], function (companyForm) {
        companyForm.validate(__WEBPACK_IMPORTED_MODULE_2__companies_constants__["e" /* WEBSITE */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
      });
    }

    if (values.contact_id === __WEBPACK_IMPORTED_MODULE_1__constants__["F" /* ADD */]) {
      form.validateChild(__WEBPACK_IMPORTED_MODULE_2__companies_constants__["g" /* CONTACT */], function (contactForm) {
        contactForm.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["T" /* EMAIL */], __WEBPACK_IMPORTED_MODULE_1__constants__["S" /* NAME */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
        contactForm.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["T" /* EMAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["b" /* isValidEmail */]);
      });
    }
  });
}

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PrintRma__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__decorators_withRma__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RequestPartialCredit__ = __webpack_require__(1591);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var VENDOR_PDF_TYPES = ["ber", "damage", "discrepancy", "insufficient_trace"];

var Actions = function (_React$Component) {
  _inherits(Actions, _React$Component);

  function Actions() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Actions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Actions.__proto__ || Object.getPrototypeOf(Actions)).call.apply(_ref, [this].concat(args))), _this), _this.state = { cancelModalOpen: false }, _this.openModal = function () {
      return _this.setState({ cancelModalOpen: true });
    }, _this.closeModal = function () {
      return _this.setState({ cancelModalOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Actions, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          cancel = _props.cancel,
          rma = _props.rma;
      var cancelModalOpen = this.state.cancelModalOpen;


      var displayCancel = !rma.get(__WEBPACK_IMPORTED_MODULE_6__constants__["_38" /* CANCELLED */]) && !rma.get("closed_date") && !rma.get(__WEBPACK_IMPORTED_MODULE_6__constants__["_26" /* RECEIVED */]) && (rma.get(__WEBPACK_IMPORTED_MODULE_6__constants__["p" /* TYPE */]) !== "CustomerRma" || !rma.get(__WEBPACK_IMPORTED_MODULE_7__constants__["u" /* CREDIT_ISSUED */]));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "btn-group pull-right", style: { marginLeft: 20 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components__["Y" /* ActionDropDown */],
            { menuClass: "dropdown-menu-right" },
            rma.get(__WEBPACK_IMPORTED_MODULE_6__constants__["p" /* TYPE */]) === "VendorRma" && VENDOR_PDF_TYPES.map(function (t, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PrintRma__["a" /* default */], { key: "vendor-" + index, pdfType: t, rma: rma });
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__RequestPartialCredit__["a" /* default */], null),
            displayCancel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__shared_components__["l" /* DropDownItem */],
              { onClick: this.openModal },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
              "\xA0Cancel RMA"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components__["i" /* ConfirmAction */],
          {
            onConfirm: cancel,
            open: cancelModalOpen,
            close: this.closeModal,
            icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" }),
            btnText: "Yes, Cancel RMA"
          },
          "Are you sure you want to cancel this RMA?"
        )
      );
    }
  }]);

  return Actions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Actions.propTypes = {
  cancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map).isRequired
};

var connectedActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(null, function (dispatch, ownProps) {
  return {
    cancel: function cancel() {
      var cancelAction = ownProps.rma.get(__WEBPACK_IMPORTED_MODULE_6__constants__["p" /* TYPE */]) === "VendorRma" ? __WEBPACK_IMPORTED_MODULE_4__actions__["f" /* cancelVendorRma */] : __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* cancelCustomerRma */];
      return dispatch(cancelAction());
    }
  };
})(Actions);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__decorators_withRma__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var rma = _ref2.rma;
  return !rma.get(__WEBPACK_IMPORTED_MODULE_6__constants__["_38" /* CANCELLED */]);
})(connectedActions)));

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(6);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










function Form(props) {
  var close = props.close,
      handleSubmit = props.handleSubmit,
      reset = props.reset;

  var onCancel = function onCancel() {
    close();
    reset();
  };
  var submit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_submission__["b" /* onSuccess */])(handleSubmit, onCancel, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["e" /* Form */],
    _extends({}, props, { onSubmit: submit }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "col-md-12" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "rma_discrepancy",
            component: __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["l" /* TextArea */],
            label: "Discrepancy Information"
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["e" /* Form */].Footer,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["i" /* Button */],
        { onClick: close },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["i" /* Button */],
        { onClick: function onClick() {
            return submit();
          }, className: "btn btn-success" },
        "Download Vendor RMA"
      )
    )
  );
}

Form.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["e" /* download */](data, ownProps.url));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["j" /* form */])({
  form: "rmaDiscrepancy"
})(Form)));

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__decorators_withRma__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RequestPartialCreditForm__ = __webpack_require__(1592);











var RequestPartialCredit = function RequestPartialCredit(_ref) {
  var visible = _ref.visible,
      open = _ref.open,
      close = _ref.close,
      rma = _ref.rma;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["l" /* DropDownItem */],
      { onClick: open },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
      "\xA0Request Partial Credit"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["a" /* Modal */],
      { open: visible, close: close },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Request Partial Credit"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__RequestPartialCreditForm__["a" /* default */], { rma: rma, close: close })
    )
  );
};

RequestPartialCredit.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map).isRequired,
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var connectedAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    cancel: function cancel() {
      var cancel = ownProps.rma.get(__WEBPACK_IMPORTED_MODULE_7__constants__["p" /* TYPE */]) === "VendorRma" ? __WEBPACK_IMPORTED_MODULE_3__actions__["f" /* cancelVendorRma */] : __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* cancelCustomerRma */];
      return dispatch(cancel());
    }
  };
})(RequestPartialCredit);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__decorators_withRma__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["e" /* toggleSwitch */])("visible")(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var rma = _ref2.rma;
  return rma.get(__WEBPACK_IMPORTED_MODULE_7__constants__["p" /* TYPE */]) === "VendorRma";
})(connectedAction))));

/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validate__ = __webpack_require__(1594);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













function Form(props) {
  var close = props.close,
      handleSubmit = props.handleSubmit,
      reset = props.reset;

  var onCancel = function onCancel() {
    close();
    reset();
  };
  var submit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_submission__["b" /* onSuccess */])(handleSubmit, onCancel, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["e" /* Form */],
    _extends({}, props, { onSubmit: submit }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            required: true,
            name: "partial_credit_amt",
            component: __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["f" /* CurrencyField */],
            label: "Credit Amt"
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["e" /* Form */].Footer,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["i" /* Button */],
        { onClick: close, type: "button" },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["i" /* Button */],
        { onClick: submit, className: "btn btn-success" },
        "Download"
      )
    )
  );
}

Form.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      var url = __WEBPACK_IMPORTED_MODULE_6__constants__["d" /* API_BASE */] + "/vendor_rmas/" + ownProps.rma.get("id") + "/download_partial_credit_request_document";

      return dispatch(__WEBPACK_IMPORTED_MODULE_7__actions__["e" /* download */](data, url));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["j" /* form */])({
  form: "rmaPartialCreditRequest",
  validate: __WEBPACK_IMPORTED_MODULE_9__validate__["a" /* validatePartialCreditRequest */]
})(Form)));

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Actions__ = __webpack_require__(1589);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Actions__["a"]; });



/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = validatePartialCreditRequest;



function validatePartialCreditRequest(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate("partial_credit_amt").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(76);
/* harmony export (immutable) */ __webpack_exports__["a"] = Body;







function Body(_ref) {
  var rma = _ref.rma;

  var attachmentTypes = rma.type === "CustomerRma" ? __WEBPACK_IMPORTED_MODULE_5__constants__["o" /* ATTACHMENT_TYPES */].customer : __WEBPACK_IMPORTED_MODULE_5__constants__["o" /* ATTACHMENT_TYPES */].vendor;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "col-md-9" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["M" /* Notes */], { resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(rma), resourceType: __WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].rma }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["N" /* Attachments */], {
      attachmentTypes: attachmentTypes,
      multiple: true,
      resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(rma),
      resourceType: __WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].rma,
      resourceKey: "rma"
    })
  );
}

Body.propTypes = { rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired };

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Body__ = __webpack_require__(1595);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Body__["a"]; });



/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CustomerRmas_components_Detail_Actions_Actions__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Panel__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Body__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Actions__ = __webpack_require__(1593);
/* unused harmony export Detail */














function Detail(_ref) {
  var rma = _ref.rma;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "page-header page-header-bar" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h1",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["J" /* RecordPager */], { baseUrl: "/rmas", record: rma }),
        "\xA0",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "header-content" },
          rma.get(__WEBPACK_IMPORTED_MODULE_8__constants__["z" /* CODE */])
        ),
        "\xA0",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["E" /* ClipboardCopy */], { name: rma.get(__WEBPACK_IMPORTED_MODULE_8__constants__["z" /* CODE */]), type: "RMA" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "small text-muted" },
          "Created ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__["b" /* shortDate */])(rma.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_7" /* CREATED_AT */]))
        ),
        rma.get(__WEBPACK_IMPORTED_MODULE_8__constants__["p" /* TYPE */]) === "VendorRma" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Actions__["a" /* default */], null),
        rma.get(__WEBPACK_IMPORTED_MODULE_8__constants__["p" /* TYPE */]) === "CustomerRma" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CustomerRmas_components_Detail_Actions_Actions__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Warnings, { rma: rma })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "row" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Panel__["a" /* default */], { rma: rma.toJS() }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Body__["a" /* default */], { rma: rma.toJS() })
    )
  );
}

function Warnings(_ref2) {
  var rma = _ref2.rma;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["K" /* StatusTags */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      rma.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_38" /* CANCELLED */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "label label-danger" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-ban" }),
        "\xA0\xA0Cancelled"
      ),
      rma.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_59" /* CREDIT_REQUESTED */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "label label-danger" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check" }),
        "\xA0\xA0Credit Requested"
      ),
      rma.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_60" /* WARRANTY_CONSIDERATION */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "label label-success" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check" }),
        "\xA0\xA0Warranty Requested"
      )
    )
  );
}

Warnings.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
};

Detail.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    rma: state.rmaDetail.get("rma")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["h" /* loadRecord */])({
  reducer: "rmaDetail",
  name: "rma",
  action: __WEBPACK_IMPORTED_MODULE_7__actions__["b" /* fetch */]
})(Detail)));

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Form__ = __webpack_require__(1599);
/* unused harmony export CustomerRMASection */










function CustomerRMASection(_ref) {
  var rma = _ref.rma;

  var receivedVirt = rma.received_virtually === false && "No" || rma.received_virtually && "Yes" || null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Section__["a" /* default */],
      {
        title: "Customer RMA",
        modal: {
          title: "Edit Customer RMA Details",
          dialogClass: "modal-sm",
          content: function content(close) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Form__["a" /* default */], {
              initialValues: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_pojos__["a" /* default */])(rma).pick("incoming_awb_number"),
              close: close
            });
          }
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["a" /* DetailTable */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], { label: "Date In", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__["b" /* shortDate */])(rma.date_in) }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], { label: "Incoming AWB #", value: rma.incoming_awb_number }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], { label: "Received Virtually", value: receivedVirt }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], { label: "Returning AWB #", value: rma.outgoing_awb_number })
      )
    )
  );
}

CustomerRMASection.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    date_in: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    incoming_awb_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var rma = _ref2.rma;
  return rma.type === __WEBPACK_IMPORTED_MODULE_6__constants__["q" /* CUSTOMER_RMA_TYPE */];
})(CustomerRMASection));

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* unused harmony export Form */






function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
        { className: "row-col-gutters-half" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "incoming_awb_number",
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
            label: "AWB #"
          })
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: "customerRMASection",
  onSubmit: function onSubmit(values, dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* update */])(values));
  }
})(Form));

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CustomerRMASection__ = __webpack_require__(1598);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CustomerRMASection__["a"]; });


/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Form__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_NoteTooltip_AuditedNoteTooltip__ = __webpack_require__(104);
/* harmony export (immutable) */ __webpack_exports__["a"] = CustomerRmaCreditSection;











function FullCreditSection(_ref) {
  var rma = _ref.rma;

  if (!rma.credit_requested) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], {
      label: "Full Credit Requested?",
      value: rma.credit_requested
    })
  );
}

function CustomerRmaCreditSection(_ref2) {
  var rma = _ref2.rma;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(rma, "inventory.managed_repair_in_progress")) return null;
  if (rma.type !== __WEBPACK_IMPORTED_MODULE_6__constants__["q" /* CUSTOMER_RMA_TYPE */]) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Section__["a" /* default */],
      {
        title: "Credit",
        editable: !(rma.type === __WEBPACK_IMPORTED_MODULE_6__constants__["q" /* CUSTOMER_RMA_TYPE */] && rma.sales_item.received && rma.sales_item.exchange_sale),
        modal: {
          title: "Edit Credit Details",
          content: function content(close) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Form__["a" /* default */], {
              initialValues: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_pojos__["a" /* default */])(rma).pick(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* CREDIT_REQUESTED */], __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* CREDIT_ISSUED */], __WEBPACK_IMPORTED_MODULE_6__constants__["v" /* CREDIT_DENIED */], __WEBPACK_IMPORTED_MODULE_6__constants__["w" /* CUSTOMER_RMA_CREDIT_AMOUNT */], __WEBPACK_IMPORTED_MODULE_6__constants__["n" /* PARTIAL_CREDIT_REQUESTED */], __WEBPACK_IMPORTED_MODULE_6__constants__["x" /* PARTIAL_CREDIT_STATUS */], __WEBPACK_IMPORTED_MODULE_6__constants__["c" /* PARTIAL_CREDIT_AMT */]),
              rma: rma,
              close: close
            });
          }
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["a" /* DetailTable */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FullCreditSection, { rma: rma }),
        rma.partial_credit_requested && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], {
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["n" /* PARTIAL_CREDIT_REQUESTED */]),
            value: rma.partial_credit_requested,
            renderIfPresent: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], {
          label: rma.partial_credit_requested ? "Partial Credit Issued?" : "Full Credit Issued?",
          value: rma.credit_issued,
          text: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            "Yes",
            " ",
            rma.credit_issued_audit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], { obj: rma, field: "credit_issued" })
          )
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], {
          label: rma.partial_credit_requested ? "Partial Credit Denied?" : "Full Credit Denied?",
          value: rma.credit_denied
        })
      )
    )
  );
}

CustomerRmaCreditSection.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    credit_requested: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    issue_credit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    credit_issued: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    partial_credit_status: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    partial_credit_amt: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    sales_item: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      received: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
      exchange_sale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
    })
  })
};

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__validate__ = __webpack_require__(1605);
/* unused harmony export Form */












function Form(props) {
  var creditIssued = props.credit_issued,
      creditDenied = props.credit_denied;

  var type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(props, "rma.type");

  var fieldAmount = function fieldAmount() {
    var lineItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(props, "rma.sales_item");

    if (props.getFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["n" /* PARTIAL_CREDIT_REQUESTED */])) {
      return props.getFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["c" /* PARTIAL_CREDIT_AMT */]);
    }

    if (lineItem.exchange_sale) {
      return lineItem.exchange_fee;
    }
    return lineItem.quantity * lineItem.cost_per_unit + Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(props, "rma.cost_adjustments_after_sale"));
  };

  var setToFullVal = function setToFullVal(val) {
    if (type === __WEBPACK_IMPORTED_MODULE_7__constants__["q" /* CUSTOMER_RMA_TYPE */]) {
      props.setFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["w" /* CUSTOMER_RMA_CREDIT_AMOUNT */])(val ? fieldAmount() : null);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
            { title: "Full Credit Requested?", justified: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_7__constants__["b" /* CREDIT_REQUESTED */],
              disabled: props.getFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["n" /* PARTIAL_CREDIT_REQUESTED */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(props, "rma.credit_issued") || creditDenied,
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
              label: "Yes",
              icon: "fa-check-circle"
            })
          )
        ),
        props.getFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* CREDIT_REQUESTED */]) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
            { title: "Full Credit Issued?", justified: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_7__constants__["u" /* CREDIT_ISSUED */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
              label: "Yes",
              onChange: function onChange(_ev, val) {
                return setToFullVal(val);
              },
              icon: "fa-check-circle",
              disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(props, "rma.credit_issued") || creditDenied
            })
          )
        ), creditIssued && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_7__constants__["w" /* CUSTOMER_RMA_CREDIT_AMOUNT */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["h" /* NumberInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["D" /* COST_ADJUSTMENT */]),
            disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(props, "rma.credit_issued"),
            required: true
          })
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
            { title: "Full Credit Denied?", justified: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_7__constants__["v" /* CREDIT_DENIED */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
              label: "Yes",
              icon: "fa-check-circle",
              disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(props, "rma.credit_denied") || creditIssued
            })
          )
        )]
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
            { title: "Partial Credit Requested?", justified: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_7__constants__["n" /* PARTIAL_CREDIT_REQUESTED */],
              disabled: props.getFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* CREDIT_REQUESTED */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(props, "rma.credit_issued") || creditDenied,
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
              label: "Yes",
              icon: "fa-check-circle"
            })
          )
        ),
        props.getFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["n" /* PARTIAL_CREDIT_REQUESTED */]) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
            { title: "Partial Credit Issued?", justified: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_7__constants__["u" /* CREDIT_ISSUED */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
              label: "Yes",
              icon: "fa-check-circle",
              disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(props, "rma.credit_issued") || creditDenied
            })
          )
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            required: true,
            name: __WEBPACK_IMPORTED_MODULE_7__constants__["c" /* PARTIAL_CREDIT_AMT */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["f" /* CurrencyField */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["c" /* PARTIAL_CREDIT_AMT */]),
            disabled: !props.getFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["n" /* PARTIAL_CREDIT_REQUESTED */])
          })
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
            { title: "Partial Credit Denied?", justified: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_7__constants__["v" /* CREDIT_DENIED */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
              label: "Yes",
              icon: "fa-check-circle",
              disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(props, "rma.credit_denied") || creditIssued
            })
          )
        )]
      )
    )
  );
}

var formName = "rmaCredit";

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: formName,
  onSubmit: function onSubmit(values, dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* update */])(values));
  },
  validate: __WEBPACK_IMPORTED_MODULE_10__validate__["a" /* default */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["o" /* withFieldsFromForm */])(formName, [__WEBPACK_IMPORTED_MODULE_7__constants__["v" /* CREDIT_DENIED */], __WEBPACK_IMPORTED_MODULE_7__constants__["u" /* CREDIT_ISSUED */], __WEBPACK_IMPORTED_MODULE_7__constants__["c" /* PARTIAL_CREDIT_AMT */]])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(76);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPartialCreditOptions; });


var getPartialCreditOptions = function getPartialCreditOptions(partialCreditStatus) {
  return [__WEBPACK_IMPORTED_MODULE_0__constants__["B" /* REQUESTED */], __WEBPACK_IMPORTED_MODULE_0__constants__["z" /* PARTIAL_CREDIT_ACCEPTED */], __WEBPACK_IMPORTED_MODULE_0__constants__["A" /* PARTIAL_CREDIT_DENIED */]].concat(partialCreditStatus === __WEBPACK_IMPORTED_MODULE_0__constants__["C" /* PARTIAL_CREDIT_CLOSED_BEFORE_REPLY */] ? [__WEBPACK_IMPORTED_MODULE_0__constants__["C" /* PARTIAL_CREDIT_CLOSED_BEFORE_REPLY */]] : []).map(function (value) {
    return {
      text: __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* PARTIAL_CREDIT_STATUSES */][value],
      value: value
    };
  });
};

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CustomerRmaCreditSection__ = __webpack_require__(1601);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CustomerRmaCreditSection__["a"]; });


/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(76);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;




function validate(values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    if (values.partial_credit_status) {
      form.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* PARTIAL_CREDIT_AMT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if (values.credit_issued && props.rma.type === __WEBPACK_IMPORTED_MODULE_2__constants__["q" /* CUSTOMER_RMA_TYPE */]) {
      form.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["w" /* CUSTOMER_RMA_CREDIT_AMOUNT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }
  });
}

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__EditCustomerDetails__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EditVendorDetails__ = __webpack_require__(1608);
/* unused harmony export RmaPart */
/* harmony export (immutable) */ __webpack_exports__["a"] = Details;
















function RmaPart(_ref) {
  var rma = _ref.rma;

  if (rma.alternate) {
    if (rma.alternate.alternate_part_id) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["h" /* PartNumber */], {
        part: {
          id: rma.alternate.alternate_part_id,
          part_number: rma.alternate.name
        }
      });
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      null,
      rma.alternate.name
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["h" /* PartNumber */], { part: rma.part });
}

RmaPart.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    alternate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
  })
};

function Details(_ref2) {
  var rma = _ref2.rma,
      setForceOpenShipTo = _ref2.setForceOpenShipTo;

  var inventoryLink = "/inventories/" + (rma.inventory.uuid || rma.expected_inventory_id);
  var refId = rma.reference_record_id;
  var customerRma = rma.type === "CustomerRma";

  var refLink = customerRma ? "/sales-orders/" + refId : "/purchase-orders/" + refId;

  if (rma.reference_record_line_item_type === "Lot") {
    refLink = "/lots/" + refId;
  }

  var getReason = function getReason(isCustomerRma) {
    if (isCustomerRma) {
      if (__WEBPACK_IMPORTED_MODULE_9__constants__["l" /* CUSTOMER_RMA_REASONS */][rma.reason].label === "Other" && rma.other_reason) {
        return "" + rma.other_reason;
      }
      return __WEBPACK_IMPORTED_MODULE_9__constants__["l" /* CUSTOMER_RMA_REASONS */][rma.reason].label;
    }
    return __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* REASONS */][rma.reason].label;
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Section__["a" /* default */],
    {
      title: customerRma ? "Customer RMA Details" : "Vendor RMA Details",
      modal: {
        title: customerRma ? "Edit RMA Details" : "Edit Vendor RMA Details",
        dialogClass: "modal-md",
        content: function content(close) {
          return rma.type === "VendorRma" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__EditVendorDetails__["a" /* default */], {
            close: close,
            initialValues: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_pojos__["a" /* default */])(rma).pick("reason", "vendor_rma_number"),
            setForceOpenShipTo: setForceOpenShipTo
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__EditCustomerDetails__["a" /* default */], {
            initialValues: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_pojos__["a" /* default */])(rma).pick("reason", "vendor_rma_number", "other_reason"),
            close: close
          });
        }
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["a" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          customerRma ? "Customer Name" : "Vendor Name"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["w" /* CompanyName */], { company: rma.company })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
        label: customerRma ? "Customer Code" : "Vendor Code",
        value: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(rma, "company.code")
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
        label: "Contact",
        value: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(rma, "sales_order.contact_name")
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
        label: "Contact Email",
        value: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(rma, "sales_order.contact_email")
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], { label: "Part #", value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RmaPart, { rma: rma }) }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], { label: "Part Desc.", value: rma.part.description }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
        label: "Serial #",
        value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
          { to: inventoryLink },
          rma.sales_item ? rma.sales_item.serial_number : rma.inventory.serial_number
        )
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
        label: "Ref #",
        value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
          { to: refLink },
          rma.reference_record_code
        )
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
        label: "Sales Order Price Each",
        value: rma.sales_item ? rma.sales_item.price_per_unit : ""
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
        label: "Customer PO #",
        value: rma.sales_item ? rma.sales_item.sales_order_customer_purchase_order_number : ""
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_73" /* STORE_OWNER */]),
          value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["o" /* LocationFlag */], { location: rma.inventory.store_owner_id })
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
        label: "CD",
        value: rma.inventory.condition && __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["r" /* INVENTORIES */].condition[rma.inventory.condition].label
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], { label: "QTY", value: rma.quantity }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], { label: "RMA Reason", value: getReason(customerRma) }),
      !customerRma && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], { label: "Discrepancy Reason", value: rma.rma_discrepancy }),
      customerRma && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
        label: "Expiration Date",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(rma.expiration_date)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], { label: "Closed Date", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(rma.closed_date) }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
        label: "Cancelled Date",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(rma.cancelled_at),
        renderIfPresent: true
      })
    )
  );
}

Details.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    inventory_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    reference_record_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    reference_record_code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    expiration_date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    reason: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    company_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    company_code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      part_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
      description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    }),
    inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      serial_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
      condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    }).isRequired
  })
};

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__decorators_withRma__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Form__ = __webpack_require__(680);









var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])("rmaCustomerDetails");

function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_validate_this__["a" /* validator */])(values, function (f) {
    if (values.reason === "other") {
      f.validate("other_reason").satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["a" /* required */]);
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__decorators_withRma__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
  return {
    customerRmaReasons: selector(state, "reason")
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["a" /* update */](data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["j" /* form */])({
  form: "rmaCustomerDetails",
  validate: validate
})(__WEBPACK_IMPORTED_MODULE_7__Form__["a" /* default */]))));

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decorators_withRma__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(680);






/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decorators_withRma__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(values) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* update */](values, ownProps.setForceOpenShipTo));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["j" /* form */])({
  form: "rmaVendorDetails"
})(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */]))));

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Details__ = __webpack_require__(1606);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Details__["a"]; });


/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VendorRmaCreditSection__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ShipTo__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReturnTo__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Details__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CustomerRMASection__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__VendorRMASection__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CustomerRmaCreditSection__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__WarrantyConsideration__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Restocking__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RepairDetails__ = __webpack_require__(1612);
/* harmony export (immutable) */ __webpack_exports__["a"] = Panel;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();


















var modifiedAt = function modifiedAt(time) {
  return time ? __WEBPACK_IMPORTED_MODULE_1_moment___default()(time).format("MMM D YYYY, h:mm:ss a") : "Unknown";
};

var modifiedBy = function modifiedBy(name) {
  return name || "System";
};

var createdBy = function createdBy(rma) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    "Created: ",
    modifiedAt(rma.created_at),
    " by",
    " ",
    modifiedBy(rma.created_by.full_name)
  );
};

var updatedBy = function updatedBy(rma) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    "Last Edited: ",
    modifiedAt(rma.updated_at),
    " by",
    " ",
    modifiedBy(rma.updated_by.full_name)
  );
};

function Panel(_ref) {
  var rma = _ref.rma;

  var returningVendorRma = rma.return_to_type || rma.type === "VendorRma" && rma.warranty_consideration && !rma.credit_requested && [__WEBPACK_IMPORTED_MODULE_2__companies_constants__["j" /* APPROVED */], __WEBPACK_IMPORTED_MODULE_3__RepairOrders_constants__["_25" /* DENIED */]].includes(rma.warranty_status);

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      forceOpenShipTo = _useState2[0],
      setForceOpenShipTo = _useState2[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "col-md-3" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "panel panel-default" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "panel-body" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Details__["a" /* default */], { rma: rma, setForceOpenShipTo: setForceOpenShipTo }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CustomerRMASection__["a" /* default */], { rma: rma }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__VendorRMASection__["a" /* default */], { rma: rma }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__RepairDetails__["a" /* default */], { rma: rma }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__CustomerRmaCreditSection__["a" /* default */], { rma: rma }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__VendorRmaCreditSection__["a" /* default */], { rma: rma }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__WarrantyConsideration__["a" /* default */], { rma: rma }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Restocking__["a" /* default */], { rma: rma }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
        rma.type === __WEBPACK_IMPORTED_MODULE_6__constants__["p" /* VENDOR_RMA_TYPE */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ShipTo__["a" /* default */], {
          forceOpen: forceOpenShipTo,
          setForceOpen: setForceOpenShipTo
        }),
        rma.type === __WEBPACK_IMPORTED_MODULE_6__constants__["q" /* CUSTOMER_RMA_TYPE */] || returningVendorRma ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ReturnTo__["a" /* default */], null) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "p",
          { className: "text-muted small" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "em",
            null,
            createdBy(rma),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
            updatedBy(rma)
          )
        )
      )
    )
  );
}

Panel.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({}).isRequired
};

/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);







function RepairDetails(_ref) {
  var rma = _ref.rma;

  var repairItem = rma.repair_order_line_item;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["X" /* Section */],
      { title: "RO #", editable: false },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components__["W" /* DetailTable */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["S" /* Detail */], {
          label: "Code",
          value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
            { to: "/repair-orders/" + repairItem.uuid },
            repairItem.code
          )
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["S" /* Detail */], {
          label: "RO Date Out",
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(repairItem.created_at)
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["S" /* Detail */], {
          label: "RO Date In",
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(repairItem.date_received)
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["S" /* Detail */], {
          label: "Returning AWB #",
          value: repairItem.incoming_awb_number
        })
      )
    )
  );
}

RepairDetails.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    repair_order_line_item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
  })
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var rma = _ref2.rma;
  return !!rma.repair_order_line_item;
})(RepairDetails));

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RepairDetails__ = __webpack_require__(1611);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RepairDetails__["a"]; });



/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* unused harmony export Form */












var restockingFeeOptions = [{ value: false, text: "No" }, { value: true, text: "Yes" }];

function Form(props) {
  var defaultNoFaultFoundFee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__hooks_useCurrentUser__["b" /* useSettings */])(), __WEBPACK_IMPORTED_MODULE_10__constants__["_61" /* DEFAULT_NO_FAULT_FOUND_FEE */]);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
        { className: "row-col-gutters-half" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
            { justified: true, title: "Stock Part?" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: "stock_part", component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */], label: "Yes" })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
            options: restockingFeeOptions,
            name: "charge_restocking_fee",
            label: "Charge Restocking Fee?",
            prompt: false,
            onChange: function onChange(e) {
              return e.currentTarget.blur();
            } // Web browser likes to hold on to focus on select. Force browser to requlinquish focus and return it to the form.
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        name: "charge_restocking_fee",
        component: function component(_ref) {
          var input = _ref.input;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["c" /* Collapse */],
            { "in": !!input.value },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
              { className: "row-col-gutters-half" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["f" /* CurrencyField */], { name: "restocking_fee", label: "Restocking Fee" })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
                  { justified: true, title: "Invoice Restocking Fee?" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                    name: "restocking_fee_issued",
                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                    label: "Yes"
                  })
                )
              )
            )
          );
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
            { justified: true, title: "Charge Customer No Fault Found Fee" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_6__constants__["r" /* CHARGE_NO_FAULT_FOUND_FEE */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
              label: "Yes",
              onChange: function onChange(val) {
                if (val) {
                  props.setFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["t" /* NO_FAULT_FOUND_FEE */])(defaultNoFaultFoundFee);
                } else {
                  props.setFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["t" /* NO_FAULT_FOUND_FEE */])(null);
                }
              }
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        name: __WEBPACK_IMPORTED_MODULE_6__constants__["r" /* CHARGE_NO_FAULT_FOUND_FEE */],
        component: function component(_ref2) {
          var input = _ref2.input;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["c" /* Collapse */],
            { "in": !!input.value },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
              { className: "row-col-gutters-half" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["f" /* CurrencyField */], {
                  name: __WEBPACK_IMPORTED_MODULE_6__constants__["t" /* NO_FAULT_FOUND_FEE */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["t" /* NO_FAULT_FOUND_FEE */])
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
                { md: 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
                  {
                    justified: true,
                    title: "No Fault Found Fee has been invoiced?"
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["s" /* NO_FAULT_FOUND_FEE_INVOICED */],
                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                    label: "Yes"
                  })
                )
              )
            )
          );
        }
      })
    )
  );
}

var formName = "rmaRestocking";
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(values) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* update */])(values));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["change"])(formName, field, val));
      };
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: formName
})(Form)));

/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Form__ = __webpack_require__(1613);
/* unused harmony export Restocking */










function Restocking(_ref) {
  var rma = _ref.rma;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { key: "restocking-dashed-header", className: "hr-xs hr-dashed" }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Section__["a" /* default */],
    {
      title: "Restocking / No Fault Found Fee",
      key: "edit-restocking-modal",
      modal: {
        title: "Edit Restocking Details",
        content: function content(close) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Form__["a" /* default */], {
            initialValues: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_pojos__["a" /* default */])(rma).pick("stock_part", "charge_restocking_fee", __WEBPACK_IMPORTED_MODULE_6__constants__["r" /* CHARGE_NO_FAULT_FOUND_FEE */], "restocking_fee", "restocking_fee_issued", __WEBPACK_IMPORTED_MODULE_6__constants__["s" /* NO_FAULT_FOUND_FEE_INVOICED */], __WEBPACK_IMPORTED_MODULE_6__constants__["t" /* NO_FAULT_FOUND_FEE */]),
            close: close
          });
        }
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["a" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], { label: "Stock Part?", value: rma.stock_part }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], {
        label: "Charge Restocking Fee?",
        value: rma.charge_restocking_fee
      }),
      rma.charge_restocking_fee && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: "Restocking Fee",
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(rma.restocking_fee)
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], {
          label: "Restocking Fee Invoiced?",
          value: rma.restocking_fee_issued
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], {
        label: "Charge No Fault Found Fee?",
        value: rma.charge_no_fault_found_fee
      }),
      rma.charge_no_fault_found_fee && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: "No Fault Found Fee",
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(rma.no_fault_found_fee)
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], {
          label: "No Fault Found Fee Invoiced?",
          value: rma.no_fault_found_fee_invoiced
        })
      )
    )
  )];
}

Restocking.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    stock_part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    charge_restocking_fee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    restocking_fee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    restocking_fee_issued: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var _ref2$rma = _ref2.rma,
      type = _ref2$rma.type,
      refRecordType = _ref2$rma.reference_record_line_item_type;
  return type === __WEBPACK_IMPORTED_MODULE_6__constants__["q" /* CUSTOMER_RMA_TYPE */] || refRecordType === "PurchaseOrderLineLitem";
})(Restocking));

/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Restocking__ = __webpack_require__(1614);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Restocking__["a"]; });


/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__decorators__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Orders_shared_ShippingFields__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ShippingSection_validate__ = __webpack_require__(681);
/* unused harmony export Form */














function Form(props) {
  var rma = props.rma;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_redux_form__["FormSection"],
        { name: "" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Return To"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Orders_shared_ShippingFields__["a" /* default */], {
          shipToCompany: rma.toJS().return_to_company,
          formName: "rmaReturnToDetails",
          shippingFields: [__WEBPACK_IMPORTED_MODULE_11__constants__["C" /* RETURN_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_11__constants__["_42" /* RETURN_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_11__constants__["_43" /* RETURN_TO_COMPANY_ADDRESS_ID */]],
          shippingTypes: [__WEBPACK_IMPORTED_MODULE_9__companies_constants__["p" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["L" /* DROPSHIP */], __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["d" /* DO_NOT_SHIP */]],
          shippingMethod: __WEBPACK_IMPORTED_MODULE_11__constants__["_41" /* RETURN_TO_SHIPPING_METHOD */],
          shippingAddressField: __WEBPACK_IMPORTED_MODULE_11__constants__["_44" /* RETURN_TO_SHIPPING_ADDRESS */],
          required: false,
          locationFieldName: __WEBPACK_IMPORTED_MODULE_11__constants__["_25" /* RETURN_TO_LOCATION_ID */]
        })
      )
    )
  );
}

Form.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, {
  onSubmit: __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* update */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__decorators__["a" /* withRma */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: "rmaReturnToDetails",
  validate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__ShippingSection_validate__["a" /* validateForShippingType */])("return_to")
})(Form))));

/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__decorators__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_ShippingAddressTable__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Form__ = __webpack_require__(1616);
















function ReturnTo(_ref) {
  var rma = _ref.rma;

  var initialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_pojos__["a" /* default */])(rma.toJS()).pick(__WEBPACK_IMPORTED_MODULE_10__constants__["C" /* RETURN_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_10__constants__["_42" /* RETURN_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_10__constants__["_43" /* RETURN_TO_COMPANY_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_10__constants__["_53" /* RETURN_TO_CUSTOMER_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_10__constants__["_25" /* RETURN_TO_LOCATION_ID */], __WEBPACK_IMPORTED_MODULE_10__constants__["_44" /* RETURN_TO_SHIPPING_ADDRESS */], __WEBPACK_IMPORTED_MODULE_10__constants__["_41" /* RETURN_TO_SHIPPING_METHOD */]);
  var renderForm = function renderForm(close) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Form__["a" /* default */], { close: close, rma: rma.toJS(), initialValues: initialValues });
  };

  var dropShip = function dropShip(type) {
    return [__WEBPACK_IMPORTED_MODULE_11__companies_constants__["p" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["L" /* DROPSHIP */]].includes(type);
  };

  // Extract carrier and shipping method from RMA
  var carrier = rma.getIn(["return_to_shipping_method", __WEBPACK_IMPORTED_MODULE_10__constants__["e" /* CARRIER */]], "");
  var shippingMethod = rma.getIn(["return_to_shipping_method", __WEBPACK_IMPORTED_MODULE_10__constants__["g" /* SHIPPING_METHOD */]], "");
  var accountNumber = rma.getIn(["return_to_shipping_method", __WEBPACK_IMPORTED_MODULE_10__constants__["h" /* ACCOUNT_NUMBER */]], "");

  // Lookup label in CARRIERS constant using Lodash get
  var shippingMethodLabel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_13__shared_constants__["a" /* CARRIERS */], [carrier, "shippingMethods", shippingMethod, "label"], "");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components_Section__["a" /* default */],
    {
      title: "Return To",
      modal: {
        title: "Edit RMA - Return To",
        content: renderForm
      }
    },
    dropShip(rma.get(__WEBPACK_IMPORTED_MODULE_10__constants__["C" /* RETURN_TO_TYPE */])) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_ShippingAddressTable__["a" /* ShippingAddressTable */], {
      fob: rma.get(__WEBPACK_IMPORTED_MODULE_10__constants__["_40" /* RETURN_TO_FOB */]),
      address: rma.get("return_to_address"),
      shippingMethod: rma.get(__WEBPACK_IMPORTED_MODULE_10__constants__["_41" /* RETURN_TO_SHIPPING_METHOD */])
    }) || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components__["W" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["S" /* Detail */], {
        label: "Return To",
        value: "" + rma.getIn(["return_to_address", __WEBPACK_IMPORTED_MODULE_10__constants__["S" /* NAME */]], "")
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["S" /* Detail */], {
        label: "Carrier",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])("" + rma.getIn(["return_to_shipping_method", __WEBPACK_IMPORTED_MODULE_10__constants__["e" /* CARRIER */]], ""))
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["S" /* Detail */], { label: "Shipping Method", value: shippingMethodLabel }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["S" /* Detail */], { label: "Account #", value: accountNumber })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" })
  );
}

ReturnTo.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__decorators__["a" /* withRma */])(ReturnTo));

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReturnTo__ = __webpack_require__(1617);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ReturnTo__["a"]; });



/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__decorators__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingSection__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_Errors__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ShippingSection_validate__ = __webpack_require__(681);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















function CustomButton(_ref) {
  var disabled = _ref.disabled,
      submitting = _ref.submitting,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit,
      close = _ref.close,
      copyToRepair = _ref.copyToRepair;

  var saveText = copyToRepair ? "Save And Update RO" : "Save";
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    {
      disabled: disabled || submitting,
      type: "submit",
      className: "btn btn-primary",
      onClick: handleSubmit(function (values) {
        onSubmit(_extends({}, values, {
          copy_address_to_repair: copyToRepair
        })).then(function () {
          close();
          return __WEBPACK_IMPORTED_MODULE_11__lib_submission__["a" /* SUCCESS */];
        });
      })
    },
    submitting && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cog fa-spin fa-fw fa-lg" }),
    submitting ? " Saving" : saveText
  );
}

CustomButton.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  copyToRepair: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

function Form(props) {
  var rma = props.rma,
      close = props.close,
      submitFailed = props.submitFailed,
      errorMessages = props.errorMessages,
      editable = props.editable;

  var shipToOptions = [{
    text: "Company",
    value: __WEBPACK_IMPORTED_MODULE_8__shared_components_ShippingSection_shippingTypes__["d" /* COMPANY */]
  }, {
    text: "Other",
    value: __WEBPACK_IMPORTED_MODULE_8__shared_components_ShippingSection_shippingTypes__["e" /* DROPSHIP */]
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    _extends({}, props, { handleSubmit: function handleSubmit() {} }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_redux_form__["FormSection"],
        { name: "" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Ship To"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingSection__["b" /* default */], {
          shipToOptions: shipToOptions,
          shippingType: "ship_to",
          shipToCustomer: (rma.get("company") || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()).toJS(),
          shipToCompany: rma.get("ship_to_company")
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Footer,
      null,
      submitFailed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_Errors__["a" /* default */], { errors: errorMessages }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Cancel, { close: close, editable: editable }),
      rma.getIn(["repair_order_line_item", "id"]) && !rma.getIn(["repair_order_line_item", "received"]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomButton, _extends({}, props, { copyToRepair: true })),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomButton, props)
    )
  );
}

Form.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, {
  onSubmit: __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* update */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__decorators__["a" /* withRma */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: "rmaShipToDetails",
  validate: __WEBPACK_IMPORTED_MODULE_12__ShippingSection_validate__["b" /* default */]
})(Form))));

/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_maps__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingAddressTable__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_decorators_renderIf__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Form__ = __webpack_require__(1619);












function ShipTo(props) {
  var rma = props.rma;


  var initialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_pojos__["a" /* default */])(rma.toJS()).pick(__WEBPACK_IMPORTED_MODULE_9__constants__["L" /* SHIP_TO_ADDRESS_PHONE */], __WEBPACK_IMPORTED_MODULE_9__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_9__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_9__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_9__constants__["_2" /* SHIP_TO_CUSTOMER_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_9__constants__["_17" /* SHIP_TO_SHIPPING_ADDRESS */], __WEBPACK_IMPORTED_MODULE_9__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */]);

  var renderForm = function renderForm(close) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Form__["a" /* default */], { close: close, rma: rma.toJS(), initialValues: initialValues });
  };

  var fob = rma.get("ship_to_address") && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_maps__["a" /* getValues */])(rma.get("ship_to_address"), "city", "state", "country").join("-");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_Section__["a" /* default */],
    {
      title: "Ship To",
      modal: {
        title: "Edit RMA - Ship To",
        content: renderForm
      },
      editable: true,
      forceOpen: props.forceOpen,
      setForceOpen: props.setForceOpen
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingAddressTable__["a" /* ShippingAddressTable */], {
      fob: fob,
      address: rma.get("ship_to_address"),
      shippingMethod: rma.get("ship_to_shipping_method")
    })
  );
}

ShipTo.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
};

var hasVendorRmaNumber = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_decorators_renderIf__["a" /* default */])(function (_ref) {
  var rma = _ref.rma;
  return (rma.get("vendor_rma_number") || "") !== "";
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withRma */])(hasVendorRmaNumber(ShipTo)));

/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShipTo__ = __webpack_require__(1620);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ShipTo__["a"]; });



/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_NoteTooltip_AuditedNoteTooltip__ = __webpack_require__(104);
/* unused harmony export VendorRMASection */









function VendorRMASection(_ref) {
  var rma = _ref.rma;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Section__["a" /* default */],
      { title: "Vendor RMA", editable: false },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["a" /* DetailTable */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], { label: "Date Shipped", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__["b" /* shortDate */])(rma.date_shipped) }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], { label: "Returning AWB #", value: rma.outgoing_awb_number }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
          label: "Vendor RMA #",
          value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            rma.vendor_rma_number,
            " ",
            rma.vendor_rma_number_audit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], { obj: rma, field: "vendor_rma_number" })
          )
        })
      )
    )
  );
}

VendorRMASection.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    date_shipped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    vendor_rma_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var rma = _ref2.rma;
  return rma.type === __WEBPACK_IMPORTED_MODULE_6__constants__["p" /* VENDOR_RMA_TYPE */];
})(VendorRMASection));

/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VendorRMASection__ = __webpack_require__(1622);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__VendorRMASection__["a"]; });


/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CustomerRmaCreditSection_helpers__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__validate__ = __webpack_require__(1627);
/* unused harmony export Form */



















function CostWarning(_ref) {
  var creditIssued = _ref.creditIssued,
      initialCreditIssued = _ref.initialValues.credit_issued,
      inventory = _ref.inventory,
      type = _ref.type;

  var costPerUnit = parseFloat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(inventory, __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["_54" /* COST_PER_UNIT */], 0));
  var originalCostPerUnit = parseFloat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(inventory, __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["_76" /* ORIGINAL_COST_PER_UNIT */], 0));

  if (type === __WEBPACK_IMPORTED_MODULE_12__constants__["p" /* VENDOR_RMA_TYPE */] && inventory && !initialCreditIssued && creditIssued && costPerUnit > originalCostPerUnit) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Warning_Warning__["a" /* default */],
      null,
      "The credit issued is over the original purchase price by",
      " ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__["a" /* dollars */])(costPerUnit - originalCostPerUnit),
      ". That amount will be applied to a depreciation and a negative commission will be applied to buyer/s. Ok to continue?"
    );
  }

  return null;
}

var unreceivedCustomerRma = function unreceivedCustomerRma(rma) {
  return rma.type === __WEBPACK_IMPORTED_MODULE_12__constants__["q" /* CUSTOMER_RMA_TYPE */] && !rma.received;
};

CostWarning.propTypes = {
  creditIssued: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  initialValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    credit_issued: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    partial_credit_status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

function Form(props) {
  var creditIssued = props.credit_issued,
      creditDenied = props.credit_denied,
      initialValues = props.initialValues,
      change = props.change,
      partialCreditStatus = props.partial_credit_status,
      rma = props.rma,
      rmaRequestType = props.rma_request_type;


  var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__CustomerRmaCreditSection_helpers__["a" /* getPartialCreditOptions */])(partialCreditStatus);
  var finalized = initialValues.credit_issued || initialValues.credit_denied || [__WEBPACK_IMPORTED_MODULE_12__constants__["z" /* PARTIAL_CREDIT_ACCEPTED */], __WEBPACK_IMPORTED_MODULE_12__constants__["A" /* PARTIAL_CREDIT_DENIED */]].includes(initialValues.partial_credit_status);
  var type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(rma, __WEBPACK_IMPORTED_MODULE_15__constants__["p" /* TYPE */]);

  var handleCreditRequestedChange = function handleCreditRequestedChange(event, value) {
    if (!value) {
      change(__WEBPACK_IMPORTED_MODULE_12__constants__["x" /* PARTIAL_CREDIT_STATUS */], "requested");
    } else {
      change(__WEBPACK_IMPORTED_MODULE_12__constants__["x" /* PARTIAL_CREDIT_STATUS */], null);
      change(__WEBPACK_IMPORTED_MODULE_12__constants__["c" /* PARTIAL_CREDIT_AMT */], null);
    }
  };

  var handleRmaRequestTypeChange = function handleRmaRequestTypeChange(ev, value) {
    if (value === __WEBPACK_IMPORTED_MODULE_16__Receiving_constants__["c" /* RMA */]) {
      change(__WEBPACK_IMPORTED_MODULE_12__constants__["x" /* PARTIAL_CREDIT_STATUS */], null);
      change(__WEBPACK_IMPORTED_MODULE_12__constants__["c" /* PARTIAL_CREDIT_AMT */], null);
    } else {
      change(__WEBPACK_IMPORTED_MODULE_12__constants__["b" /* CREDIT_REQUESTED */], null);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CostWarning, {
        inventory: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(rma, "inventory"),
        creditIssued: creditIssued,
        initialValues: initialValues,
        type: type
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__["j" /* RMA_REQUEST_TYPE */],
            label: "Request Type",
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["m" /* RadioGroupField */],
            disabled: finalized,
            onChange: handleRmaRequestTypeChange,
            options: [{
              value: "rma",
              text: "Request RMA"
            }, { value: __WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__["k" /* PARTIAL_CREDIT */], text: "Request Partial Credit" }]
          })
        )
      ),
      rmaRequestType === __WEBPACK_IMPORTED_MODULE_16__Receiving_constants__["c" /* RMA */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
            { title: "Full Credit Requested?", justified: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_12__constants__["b" /* CREDIT_REQUESTED */],
              component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
              label: "Yes",
              icon: "fa-check-circle",
              onChange: handleCreditRequestedChange,
              disabled: finalized
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
            { title: "Full Credit Issued?", justified: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_12__constants__["u" /* CREDIT_ISSUED */],
              component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
              label: "Yes",
              icon: "fa-check-circle",
              disabled: finalized || creditDenied || unreceivedCustomerRma(rma)
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
            { title: "Full Credit Denied?", justified: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_12__constants__["v" /* CREDIT_DENIED */],
              component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
              label: "Yes",
              icon: "fa-check-circle",
              disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(rma, "credit_denied") || creditIssued
            })
          )
        )
      ),
      rmaRequestType === __WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__["k" /* PARTIAL_CREDIT */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_12__constants__["x" /* PARTIAL_CREDIT_STATUS */],
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
            label: "Partial Credit Status",
            options: options,
            disabled: finalized
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            required: true,
            name: __WEBPACK_IMPORTED_MODULE_12__constants__["c" /* PARTIAL_CREDIT_AMT */],
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */],
            label: "Partial Credit Amt",
            disabled: finalized
          })
        )
      )
    )
  );
}

Form.propTypes = {
  credit_issued: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  credit_denied: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  initialValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    credit_issued: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    partial_credit_status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  change: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  partial_credit_status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    received: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    sales_item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    credit_issued: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    credit_denied: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }).isRequired,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var formName = "rmaCredit";

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reduxForm"])({
  form: formName,
  onSubmit: function onSubmit(values, dispatch) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["c" /* vendorRmaUpdate */])(values));
  },
  validate: __WEBPACK_IMPORTED_MODULE_17__validate__["a" /* default */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared_decorators__["o" /* withFieldsFromForm */])(formName, [__WEBPACK_IMPORTED_MODULE_12__constants__["v" /* CREDIT_DENIED */], __WEBPACK_IMPORTED_MODULE_12__constants__["u" /* CREDIT_ISSUED */], __WEBPACK_IMPORTED_MODULE_12__constants__["x" /* PARTIAL_CREDIT_STATUS */], __WEBPACK_IMPORTED_MODULE_12__constants__["c" /* PARTIAL_CREDIT_AMT */], __WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__["j" /* RMA_REQUEST_TYPE */]])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Form__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_NoteTooltip_AuditedNoteTooltip__ = __webpack_require__(104);
/* harmony export (immutable) */ __webpack_exports__["a"] = VendorRmaCreditSection;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














function VendorRmaCreditSection(_ref) {
  var rma = _ref.rma;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(rma, "inventory.managed_repair_in_progress")) return null;
  if (rma.type !== __WEBPACK_IMPORTED_MODULE_7__constants__["p" /* VENDOR_RMA_TYPE */]) return null;
  var partialCreditRequest = Number(rma.partial_credit_amt) > 0;
  var initialValues = Object.assign(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_pojos__["a" /* default */])(rma).pick(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* CREDIT_REQUESTED */], __WEBPACK_IMPORTED_MODULE_7__constants__["u" /* CREDIT_ISSUED */], __WEBPACK_IMPORTED_MODULE_7__constants__["v" /* CREDIT_DENIED */], __WEBPACK_IMPORTED_MODULE_7__constants__["w" /* CUSTOMER_RMA_CREDIT_AMOUNT */], __WEBPACK_IMPORTED_MODULE_7__constants__["x" /* PARTIAL_CREDIT_STATUS */], __WEBPACK_IMPORTED_MODULE_7__constants__["c" /* PARTIAL_CREDIT_AMT */]), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_8__RepairOrders_constants__["j" /* RMA_REQUEST_TYPE */], partialCreditRequest ? __WEBPACK_IMPORTED_MODULE_8__RepairOrders_constants__["k" /* PARTIAL_CREDIT */] : __WEBPACK_IMPORTED_MODULE_9__Receiving_constants__["c" /* RMA */]));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Section__["a" /* default */],
      {
        title: "Credit",
        editable: !(rma.type === __WEBPACK_IMPORTED_MODULE_7__constants__["q" /* CUSTOMER_RMA_TYPE */] && rma.sales_item.received && rma.sales_item.exchange_sale),
        modal: {
          title: "Edit Credit Details",
          content: function content(close) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Form__["a" /* default */], { initialValues: initialValues, rma: rma, close: close });
          }
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["a" /* DetailTable */],
        null,
        !partialCreditRequest && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], {
            label: "Full Credit Requested?",
            value: rma.credit_requested
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], {
            label: "Full Credit Issued?",
            value: rma.credit_issued,
            text: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
              null,
              "Yes",
              " ",
              rma.credit_issued_audit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], { obj: rma, field: "credit_issued" })
            )
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], {
            label: "Full Credit Denied?",
            value: rma.credit_denied
          })
        ),
        partialCreditRequest && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
            label: "Partial Credit Status",
            value: __WEBPACK_IMPORTED_MODULE_7__constants__["y" /* PARTIAL_CREDIT_STATUSES */][rma.partial_credit_status]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
            label: "Partial Credit Amt",
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(rma.partial_credit_amt)
          })
        )
      )
    )
  );
}

VendorRmaCreditSection.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    credit_requested: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    issue_credit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    credit_issued: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    partial_credit_status: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    partial_credit_amt: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    sales_item: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      received: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
      exchange_sale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
    })
  })
};

/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VendorRmaCreditSection__ = __webpack_require__(1625);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__VendorRmaCreditSection__["a"]; });


/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(76);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;




function validate(values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    if (values.partial_credit_status) {
      form.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* PARTIAL_CREDIT_AMT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if (values.credit_issued && props.rma.type === __WEBPACK_IMPORTED_MODULE_2__constants__["q" /* CUSTOMER_RMA_TYPE */]) {
      form.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["w" /* CUSTOMER_RMA_CREDIT_AMOUNT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }
  });
}

/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__companies_constants__ = __webpack_require__(22);
/* unused harmony export Form */
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













function Form(_ref) {
  var rma = _ref.rma,
      warrantyStatus = _ref.warrantyStatus,
      props = _objectWithoutProperties(_ref, ["rma", "warrantyStatus"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
        { className: "row-col-gutters-half" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
            { justified: true, title: "Warranty Consideration?" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: "warranty_consideration",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
              label: "Yes"
            })
          )
        ),
        warrantyStatus === __WEBPACK_IMPORTED_MODULE_10__companies_constants__["n" /* DENIED */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["f" /* CurrencyField */], {
            name: __WEBPACK_IMPORTED_MODULE_6__constants__["e" /* VENDOR_WARRANTY_AMOUNT_PAID */],
            label: "Warranty Amount Paid"
          })
        ),
        !rma.shipped && rma.type === "CustomerRma" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 5 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
            { title: "Warranty Charges Invoiced?", justified: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_6__constants__["f" /* WARRANTY_CHARGES_INVOICED */],
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
              label: "Yes"
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        name: __WEBPACK_IMPORTED_MODULE_7__RepairOrders_constants__["l" /* WARRANTY_CONSIDERATION */],
        component: function component(_ref2) {
          var input = _ref2.input;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
            { "in": !!input.value },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
                { className: "row-col-gutters-half" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["h" /* WARRANTY_STATUS */],
                    component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
                    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* WARRANTY_STATUSES */]),
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["h" /* WARRANTY_STATUS */])
                  })
                ),
                rma.type === "CustomerRma" && !rma.shipped && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* REPAIR_STATION_WARRANTY_STATUS */],
                    component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
                    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* WARRANTY_STATUSES */]),
                    label: "Repair Station Warranty"
                  })
                ),
                warrantyStatus === __WEBPACK_IMPORTED_MODULE_10__companies_constants__["n" /* DENIED */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
                    { justified: true, title: "Warranty Amount Paid?" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                      name: "warranty_amount_paid",
                      component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
                      label: "Yes"
                    })
                  )
                )
              )
            )
          );
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
        { className: "row-col-gutters-half" },
        rma.shipped && warrantyStatus === __WEBPACK_IMPORTED_MODULE_10__companies_constants__["n" /* DENIED */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["f" /* CurrencyField */], {
            name: __WEBPACK_IMPORTED_MODULE_6__constants__["d" /* VENDOR_WARRANTY_AMOUNT */],
            label: "Warranty Amount"
          })
        )
      )
    )
  );
}

var FORM_NAME = "rmaWarrantyConsideration";

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["formValueSelector"])(FORM_NAME);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(function (state) {
  return {
    warrantyStatus: selector(state, __WEBPACK_IMPORTED_MODULE_6__constants__["h" /* WARRANTY_STATUS */])
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(values) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* update */])(values));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME
})(Form)));

/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WarrantyConsideration__ = __webpack_require__(682);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__WarrantyConsideration__["b"]; });


/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Panel__ = __webpack_require__(1610);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Panel__["a"]; });



/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Detail__ = __webpack_require__(1597);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Detail__["a"]; });



/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Detail__ = __webpack_require__(1631);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Detail__["a"]; });



/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_reducer__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(679);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  rma: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
}).merge(__WEBPACK_IMPORTED_MODULE_2__shared_reducer__["a" /* notesInitialState */]).merge(__WEBPACK_IMPORTED_MODULE_2__shared_reducer__["b" /* attachmentsInitialState */]);

function setRma(state, action) {
  return state.merge({ rma: action.rma });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_reducer__["c" /* createAttachmentReducer */])(__WEBPACK_IMPORTED_MODULE_3__shared_types_resourceTypes__["a" /* default */].rma), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_reducer__["d" /* createNoteReducer */])(__WEBPACK_IMPORTED_MODULE_3__shared_types_resourceTypes__["a" /* default */].rma), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* SET */], setRma))));

/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__parts_actions_actions__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_shared_FormSections_AttachmentListSection__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_NetWeightAndDimsFormRow_NetWeightAndDimsFormRow__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Orders_shared_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__PurchaseOrders_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_shared_CoBuyersFields_BuyerField__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__parts_components_Detail_Catalog__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Create__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Locations_components_ReduxFormLocationsDropdown__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__helpers__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__FormSections_LotSection__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__helpers__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__FormFooter__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__inventories_components_EditInventory_TagTypes__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Warnings_DupeWarning__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__FormSections_MistakeShipmentSection__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__validate__ = __webpack_require__(1640);
/* unused harmony export Form */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










































var formName = "createReceivingRecord";

function EmaWarning(_ref) {
  var receivingType = _ref.receivingType;

  if (receivingType !== __WEBPACK_IMPORTED_MODULE_23__constants__["s" /* EMA */]) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_12__shared_components__["n" /* Warning */],
    null,
    "NOTE: Upon Sale of item, PO will be automatically created at which point, once negotiated with Vendor, you will be able to adjust the Purchase Price and send the PO."
  );
}

EmaWarning.propTypes = {
  receivingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

function Quantity(_ref2) {
  var serial_number = _ref2.serial_number,
      setFieldValue = _ref2.setFieldValue,
      quantity = _ref2.quantity,
      receivingType = _ref2.receivingType;

  var handleChange = function handleChange(e) {
    var val = e.target.value;
    if (val < 0) {
      quantity.input.onChange(0);
      setFieldValue(__WEBPACK_IMPORTED_MODULE_19__constants__["j" /* QUANTITY */])(0);
    } else {
      quantity.input.onChange(val);
    }

    if (receivingType === __WEBPACK_IMPORTED_MODULE_23__constants__["T" /* TRANSFER */]) {
      // Serial number should not be editable for transfers
      return;
    }

    if (val > 1) {
      serial_number.input.onChange(__WEBPACK_IMPORTED_MODULE_26__Create__["b" /* NSN_ABBREV */]);
    } else {
      serial_number.input.onChange("");
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
    type: "number",
    name: __WEBPACK_IMPORTED_MODULE_19__constants__["j" /* QUANTITY */],
    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
    label: "Qty Received",
    className: "form-control",
    onChange: handleChange,
    normalize: function normalize(value) {
      return value && value < 0 ? 0 : value;
    },
    parse: function parse(value) {
      return value && parseInt(value, 10);
    },
    required: true
  });
}
Quantity.propTypes = {
  serial_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  receivingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var getWarningMessages = function getWarningMessages(part) {
  var warnings = [];
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(part, __WEBPACK_IMPORTED_MODULE_20__parts_constants__["_14" /* ESD */])) warnings.push("ESD");
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(part, __WEBPACK_IMPORTED_MODULE_20__parts_constants__["_12" /* SHELF_LIFE */])) warnings.push("shelf life");
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(part, __WEBPACK_IMPORTED_MODULE_20__parts_constants__["h" /* HAZMAT */])) warnings.push("hazmat");
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(part, __WEBPACK_IMPORTED_MODULE_20__parts_constants__["i" /* BIO_HAZMAT */])) warnings.push("bio-hazmat");

  return warnings;
};

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
      selectedCompany: null,
      selectedLot: null,
      selectedPart: null,
      selectedConsignor: null,
      selectedConsignmentBuyer: null,
      nextConsignment: null
    }, _this.searchCompanies = function (filter) {
      return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].companies.search({
        filter: filter,
        status: [__WEBPACK_IMPORTED_MODULE_15__companies_constants__["c" /* ACTIVE */], __WEBPACK_IMPORTED_MODULE_15__companies_constants__["d" /* CREDIT_HOLD */]].join(","),
        page: 1,
        limit: 20
      }).then(function (resp) {
        return resp.data.results;
      });
    }, _this.searchConsignment = function (filter) {
      return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].consignments.search({
        filter: filter
      }).then(function (resp) {
        var lastConsignment = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(resp, "data.data.last_consignment");
        if (lastConsignment && !isNaN(Number(lastConsignment))) {
          return [String(Number(lastConsignment) + 1)].concat(resp.data.results);
        }

        return resp.data.results;
      });
    }, _this.formatConsignment = function (result) {
      if ((typeof result === "undefined" ? "undefined" : _typeof(result)) === "object" && result !== null) {
        return result.consignment_reference;
      }

      if (typeof result === "string") {
        return result;
      }

      return null;
    }, _this.selectConsignment = function (result) {
      if ((typeof result === "undefined" ? "undefined" : _typeof(result)) === "object" && result !== null) {
        _this.props.setFieldValue(__WEBPACK_IMPORTED_MODULE_23__constants__["G" /* CONSIGNMENT_BUYER_ID */])(result.buyer_id);
        _this.props.setFieldValue(__WEBPACK_IMPORTED_MODULE_23__constants__["H" /* CONSIGNMENT_CO_BUYER_ID */])(result.co_buyer_id);
        _this.props.setFieldValue(__WEBPACK_IMPORTED_MODULE_23__constants__["I" /* CONSIGNOR_PERCENTAGE */])(result.consignor_percentage);
        _this.props.setFieldValue(__WEBPACK_IMPORTED_MODULE_23__constants__["v" /* CONSIGNMENT_REFERENCE_COMPANY_ID */])(result.company_id);

        _this.setState({
          selectedConsignor: result.company,
          selectedConsignmentBuyer: result.buyer,
          selectedConsignmentCoBuyer: result.co_buyer
        });

        return result.consignment_reference;
      }

      return result;
    }, _this.handleLotSelected = function (selectedLot) {
      return _this.setState({ selectedLot: selectedLot });
    }, _this.handlePartSelected = function (part) {
      _this.setState({ selectedPart: part }, function () {
        _this.props.setFieldValue(__WEBPACK_IMPORTED_MODULE_20__parts_constants__["_10" /* CAGE */])(part.cage);
      });
    }, _this.handleTaggedBy = function (item) {
      if (item && item.id) {
        _this.props.change("tagged_by_existing_company", true);
      }
      if (!item) {
        _this.props.change("tagged_by_existing_company", false);
      }
    }, _this.receiveAnother = function (receivingType) {
      var _this$state = _this.state,
          selectedConsignmentCoBuyer = _this$state.selectedConsignmentCoBuyer,
          selectedConsignmentBuyer = _this$state.selectedConsignmentBuyer,
          selectedConsignor = _this$state.selectedConsignor,
          selectedLot = _this$state.selectedLot,
          selectedPart = _this$state.selectedPart,
          forceClear = _this$state.forceClear;

      _this.setState({
        selectedCompany: null,
        selectedPart: receivingType === __WEBPACK_IMPORTED_MODULE_23__constants__["U" /* PO */] ? selectedPart : null,
        selectedConsignmentCoBuyer: selectedConsignmentCoBuyer,
        selectedConsignmentBuyer: selectedConsignmentBuyer,
        selectedConsignor: selectedConsignor,
        selectedLot: selectedLot,
        forceClear: Number(forceClear) + 1
      });
    }, _this.renderChecklistQuestion = function (attr) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
        { className: "row-col-gutters-half", key: attr },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 1, className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: attr },
            "Agree"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            type: "radio",
            name: attr,
            className: "radio-inline",
            checked: _this.props.getField(attr),
            onChange: function onChange() {
              return _this.props.change(attr, true);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 1, className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: attr },
            "Disagree"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            type: "radio",
            name: attr,
            className: "radio-inline",
            checked: !_this.props.getField(attr),
            onChange: function onChange() {
              return _this.props.change(attr, false);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 10 },
          __WEBPACK_IMPORTED_MODULE_23__constants__["z" /* RECEIVING_CHECKLIST_QUESTIONS */][attr]
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      var receivingRecord = this.props.receivingRecord;

      this.setState({ forceClear: 0 });
      if (receivingRecord) {
        if (receivingRecord.type === __WEBPACK_IMPORTED_MODULE_14__Orders_shared_constants__["b" /* RO_ITEM */] && receivingRecord.approval_status === __WEBPACK_IMPORTED_MODULE_27__RepairOrders_constants__["a" /* REPAIR_EVALUATION_APPROVED */]) {
          [__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["M" /* OTHER */]].forEach(function (f) {
            return _this2.props.change(f, receivingRecord.company[f + "_approved"]);
          });
        }
        if (receivingRecord.type === __WEBPACK_IMPORTED_MODULE_14__Orders_shared_constants__["a" /* PO_ITEM */]) {
          if (receivingRecord.line_item[__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["N" /* OTHER_TAG_TYPE */]]) {
            this.props.setFieldValue(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["M" /* OTHER */])(true);
          }
          [__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["M" /* OTHER */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["N" /* OTHER_TAG_TYPE */]].forEach(function (f) {
            return _this2.props.change(f, receivingRecord.line_item["" + f]);
          });
        }
        var selectedCompany = void 0;
        if (__WEBPACK_IMPORTED_MODULE_14__Orders_shared_constants__["b" /* RO_ITEM */] === receivingRecord.type && receivingRecord.approval_status === __WEBPACK_IMPORTED_MODULE_27__RepairOrders_constants__["a" /* REPAIR_EVALUATION_APPROVED */]) {
          selectedCompany = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_15__companies_constants__["p" /* COMPANY */]);
        } else if (__WEBPACK_IMPORTED_MODULE_14__Orders_shared_constants__["e" /* SO_ITEM */] === receivingRecord.type) {
          selectedCompany = undefined;
        } else if (__WEBPACK_IMPORTED_MODULE_14__Orders_shared_constants__["b" /* RO_ITEM */] !== receivingRecord.type) {
          selectedCompany = receivingRecord;
        }

        this.setState({
          selectedPart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__helpers__["a" /* isModTo */])(receivingRecord) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_27__RepairOrders_constants__["h" /* MOD_TO */]) : receivingRecord,
          selectedCompany: selectedCompany
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          currentUser = _props.currentUser,
          allValues = _props.allValues,
          getInitialFieldValue = _props.getInitialFieldValue,
          getField = _props.getField,
          handleSubmit = _props.handleSubmit,
          submitFailed = _props.submitFailed,
          searchParts = _props.searchParts,
          close = _props.close,
          submitting = _props.submitting,
          condition = _props.condition,
          quantity = _props.quantity,
          receivingRecord = _props.receivingRecord,
          receivingType = _props.receivingType,
          setFieldValue = _props.setFieldValue,
          lockFields = _props.lockFields,
          errorMessages = _props.errorMessages,
          virtualReceiving = _props.virtualReceiving;
      var _state = this.state,
          selectedPart = _state.selectedPart,
          selectedCompany = _state.selectedCompany,
          selectedConsignor = _state.selectedConsignor,
          selectedConsignmentBuyer = _state.selectedConsignmentBuyer,
          selectedConsignmentCoBuyer = _state.selectedConsignmentCoBuyer,
          selectedLot = _state.selectedLot;


      var warningMessages = getWarningMessages(selectedPart);

      var disableReleaseType = function disableReleaseType(event) {
        if ([__WEBPACK_IMPORTED_MODULE_23__constants__["R" /* SCRAP */], __WEBPACK_IMPORTED_MODULE_23__constants__["g" /* BEYOND_ECON_REPAIR */], __WEBPACK_IMPORTED_MODULE_23__constants__["k" /* PARTS_UNIT */], __WEBPACK_IMPORTED_MODULE_23__constants__["f" /* AS_REMOVED */]].includes(event.target.value)) {
          [__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["M" /* OTHER */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["N" /* OTHER_TAG_TYPE */]].map(function (f) {
            return _this3.props.setFieldValue(f)(null);
          });
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Body,
          null,
          warningMessages.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__shared_components__["n" /* Warning */],
            null,
            "Warning! PN is labeled as ",
            warningMessages.join(", "),
            "."
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_FormRow__["a" /* default */],
            null,
            !receivingRecord && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_23__constants__["A" /* RECEIVING_TYPE */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_23__constants__["V" /* SETTABLE_RECEIVING_TYPES */]),
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_23__constants__["A" /* RECEIVING_TYPE */]),
                onChange: function onChange(_ev, type) {
                  setFieldValue(__WEBPACK_IMPORTED_MODULE_23__constants__["A" /* RECEIVING_TYPE */], type);
                  if (type === __WEBPACK_IMPORTED_MODULE_23__constants__["s" /* EMA */]) {
                    setFieldValue(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["_0" /* LOCATION */])(null);
                    setFieldValue(__WEBPACK_IMPORTED_MODULE_23__constants__["I" /* CONSIGNOR_PERCENTAGE */])("0");
                  }
                },
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["q" /* PART_ID */],
                label: "Part #",
                placeholder: "Type a part's name of ID number...",
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["n" /* AutoCompleteField */],
                search: searchParts,
                disabled: lockFields,
                formatItem: function formatItem(result) {
                  return result && result.part_number;
                },
                selectedItem: selectedPart,
                onItemSelected: function onItemSelected(i) {
                  return i && _this3.handlePartSelected(i);
                },
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["o" /* SERIAL_NUMBER */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["o" /* SERIAL_NUMBER */]),
                disabled: parseInt(quantity, 10) > 1 || lockFields,
                required: parseInt(quantity, 10) === 1
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_29__PurchaseOrders_constants__["b" /* EXPECTED_SERIAL_NUMBER */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                disabled: true,
                label: "Exp Serial #"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_20__parts_constants__["_10" /* CAGE */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_20__parts_constants__["_10" /* CAGE */]),
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                disabled: this.props.initialValues[__WEBPACK_IMPORTED_MODULE_20__parts_constants__["_10" /* CAGE */]]
              })
            )
          ),
          !receivingRecord && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__FormSections_LotSection__["a" /* default */], {
            receivingType: receivingType,
            setFieldValue: setFieldValue,
            selectedLot: selectedLot,
            handleLotSelected: this.handleLotSelected
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__Warnings_DupeWarning__["a" /* default */], { receivingRecord: receivingRecord }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["n" /* CONDITION */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_23__constants__["x" /* CONDITION_TYPES */]),
                label: "Condition Received",
                disabled: lockFields,
                onChange: function onChange(e) {
                  return disableReleaseType(e);
                },
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], {
                names: [__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["o" /* SERIAL_NUMBER */], __WEBPACK_IMPORTED_MODULE_19__constants__["j" /* QUANTITY */]],
                component: Quantity,
                setFieldValue: setFieldValue,
                receivingType: receivingRecord && receivingRecord.type,
                lockFields: lockFields
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["r" /* MonthYearField */], {
                name: __WEBPACK_IMPORTED_MODULE_20__parts_constants__["G" /* DOM */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: "DOM",
                required: receivingRecord && receivingRecord.part.dom_sensitive
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["y" /* EXPIRATION */],
                type: "date",
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: "exp",
                required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(receivingRecord, [__WEBPACK_IMPORTED_MODULE_20__parts_constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_20__parts_constants__["_12" /* SHELF_LIFE */]].join(".")) && [__WEBPACK_IMPORTED_MODULE_23__constants__["j" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_23__constants__["l" /* REPAIRED */], __WEBPACK_IMPORTED_MODULE_23__constants__["h" /* INSPECTED */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["g" /* NEW_ITEM */]].includes(condition)
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["r" /* MonthYearField */], {
                name: __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["x" /* TAG_DATE */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["x" /* TAG_DATE */]),
                required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__helpers__["a" /* requireTagDate */])(condition, receivingType)
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["p" /* TAGGED_BY */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["p" /* TAGGED_BY */]),
                placeholder: "Search by a company's name",
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["s" /* AutoCompleteUserInputField */],
                search: this.searchCompanies,
                selectedItem: selectedCompany,
                formatItem: function formatItem(result) {
                  return result && result.name || result.tagged_by;
                },
                handleTaggedBy: this.handleTaggedBy,
                required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__helpers__["b" /* requireTaggedBy */])(condition, receivingType),
                forceClear: this.state.forceClear
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["E" /* TRACE_TYPE */],
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
                  options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_34__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes),
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["E" /* TRACE_TYPE */])
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["F" /* TRACED_TO */],
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["F" /* TRACED_TO */])
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__Locations_components_ReduxFormLocationsDropdown__["a" /* default */], {
                disabled: true,
                name: __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["_27" /* STORE_LOCATION_ID */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["_74" /* STORE_LOCATION */]),
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["_0" /* LOCATION */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["_0" /* LOCATION */]),
                required: receivingType !== __WEBPACK_IMPORTED_MODULE_23__constants__["s" /* EMA */],
                disabled: receivingType === __WEBPACK_IMPORTED_MODULE_23__constants__["s" /* EMA */] || virtualReceiving
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(currentUser, "tenant.ware_houses", []).length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "ware_house_id",
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
                options: currentUser.tenant.ware_houses.map(function (wareHouse) {
                  return {
                    value: wareHouse.id,
                    text: wareHouse.name
                  };
                }),
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])("warehouse")
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], {
                names: [__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["L" /* UK_CAA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["M" /* OTHER */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["N" /* OTHER_TAG_TYPE */]],
                component: __WEBPACK_IMPORTED_MODULE_35__inventories_components_EditInventory_TagTypes__["a" /* default */],
                formName: formName,
                disabled: receivingRecord && [__WEBPACK_IMPORTED_MODULE_23__constants__["R" /* SCRAP */], __WEBPACK_IMPORTED_MODULE_23__constants__["g" /* BEYOND_ECON_REPAIR */], __WEBPACK_IMPORTED_MODULE_23__constants__["k" /* PARTS_UNIT */], __WEBPACK_IMPORTED_MODULE_23__constants__["f" /* AS_REMOVED */]].includes(getField(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["n" /* CONDITION */]))
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: getField(__WEBPACK_IMPORTED_MODULE_15__companies_constants__["u" /* IMPERFECT_TRACE */]) ? 9 : 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
                { justified: true, title: "Flags" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_15__companies_constants__["u" /* IMPERFECT_TRACE */],
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_15__companies_constants__["u" /* IMPERFECT_TRACE */])
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: "der", component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */], label: "DER" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: "pma", component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */], label: "PMA" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: "modified", component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */], label: "Modified" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: "incident", component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */], label: "Incident" })
              )
            ),
            getField(__WEBPACK_IMPORTED_MODULE_15__companies_constants__["u" /* IMPERFECT_TRACE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_15__companies_constants__["a" /* IMPERFECT_TRACE_REASON */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["_62" /* IMPERFECT_TRACE_REASONS */]),
                label: "Imperfect Trace Reason"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: __WEBPACK_IMPORTED_MODULE_19__constants__["W" /* AWB_NUMBER */], component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], label: "Awb #" })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                allowUserInput: true,
                name: __WEBPACK_IMPORTED_MODULE_23__constants__["F" /* CONSIGNMENT_REFERENCE */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["s" /* AutoCompleteUserInputField */],
                label: "Consignment / EMA Ref #",
                selectedItem: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_23__constants__["F" /* CONSIGNMENT_REFERENCE */]),
                search: this.searchConsignment,
                formatItem: this.formatConsignment,
                required: receivingType === __WEBPACK_IMPORTED_MODULE_23__constants__["t" /* CONSIGNMENT */] && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_19__constants__["p" /* TYPE */]),
                disabled: ![__WEBPACK_IMPORTED_MODULE_23__constants__["t" /* CONSIGNMENT */], __WEBPACK_IMPORTED_MODULE_23__constants__["s" /* EMA */]].includes(receivingType) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_19__constants__["p" /* TYPE */]) === __WEBPACK_IMPORTED_MODULE_23__constants__["W" /* CONSIGNMENT_LINE_ITEM */],
                input: {
                  onChange: function onChange(val) {
                    setFieldValue(__WEBPACK_IMPORTED_MODULE_23__constants__["F" /* CONSIGNMENT_REFERENCE */])(val && val.consignment_reference);

                    _this3.selectConsignment(val);
                  },
                  onBlur: function onBlur(val) {
                    return setFieldValue(__WEBPACK_IMPORTED_MODULE_23__constants__["F" /* CONSIGNMENT_REFERENCE */])(val && val.consignment_reference);
                  }
                }
              })
            ),
            [__WEBPACK_IMPORTED_MODULE_23__constants__["t" /* CONSIGNMENT */], __WEBPACK_IMPORTED_MODULE_23__constants__["s" /* EMA */]].includes(receivingType) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_19__constants__["p" /* TYPE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_23__constants__["v" /* CONSIGNMENT_REFERENCE_COMPANY_ID */],
                label: "Consignment / EMA Ref Co.",
                placeholder: "Search by a company's name",
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["n" /* AutoCompleteField */],
                disabled: receivingType === __WEBPACK_IMPORTED_MODULE_23__constants__["t" /* CONSIGNMENT */],
                onItemSelected: function onItemSelected(item) {
                  return _this3.setState({ selectedConsignor: item });
                },
                search: this.searchCompanies,
                selectedItem: selectedConsignor,
                formatItem: function formatItem(result) {
                  return result && result.name;
                },
                required: true
              })
            ),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(receivingRecord, "part.catalog_url") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__parts_components_Detail_Catalog__["a" /* default */], { part: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_immutable__["fromJS"])(receivingRecord.part) })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_FormRow__["a" /* default */],
            null,
            [__WEBPACK_IMPORTED_MODULE_23__constants__["t" /* CONSIGNMENT */], __WEBPACK_IMPORTED_MODULE_23__constants__["s" /* EMA */]].includes(receivingType) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_19__constants__["p" /* TYPE */]) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* FormGroup */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  label: "Consignor / EMA %",
                  name: __WEBPACK_IMPORTED_MODULE_23__constants__["I" /* CONSIGNOR_PERCENTAGE */],
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                  type: "number",
                  inputProps: {
                    min: 0,
                    max: 100
                  },
                  required: true,
                  disabled: receivingType === __WEBPACK_IMPORTED_MODULE_23__constants__["t" /* CONSIGNMENT */]
                })
              )
            ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* FormGroup */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_shared_CoBuyersFields_BuyerField__["a" /* default */], {
                  label: "Cons / EMA Buyer Credit",
                  name: __WEBPACK_IMPORTED_MODULE_23__constants__["G" /* CONSIGNMENT_BUYER_ID */],
                  searchBuyers: this.props.searchBuyers,
                  selectedBuyer: selectedConsignmentBuyer,
                  onItemSelected: function onItemSelected(item) {
                    return _this3.setState({ selectedConsignmentBuyer: item });
                  },
                  disabled: receivingType === __WEBPACK_IMPORTED_MODULE_23__constants__["t" /* CONSIGNMENT */]
                })
              )
            ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* FormGroup */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_shared_CoBuyersFields_BuyerField__["a" /* default */], {
                  label: "Cons / EMA Co Buyer Credit",
                  name: __WEBPACK_IMPORTED_MODULE_23__constants__["H" /* CONSIGNMENT_CO_BUYER_ID */],
                  required: false,
                  searchBuyers: this.props.searchBuyers,
                  selectedBuyer: selectedConsignmentCoBuyer,
                  onItemSelected: function onItemSelected(item) {
                    return _this3.setState({ selectedConsignmentCoBuyer: item });
                  },
                  disabled: receivingType === __WEBPACK_IMPORTED_MODULE_23__constants__["t" /* CONSIGNMENT */]
                })
              )
            )]
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmaWarning, { receivingType: receivingType }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_NetWeightAndDimsFormRow_NetWeightAndDimsFormRow__["a" /* default */], { getField: getField }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "minor_note",
                label: "Minor Notes",
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["l" /* TextArea */],
                rows: 5
              })
            )
          ),
          getField(__WEBPACK_IMPORTED_MODULE_15__companies_constants__["_18" /* INTERNAL_NOTE */]) && getField(__WEBPACK_IMPORTED_MODULE_15__companies_constants__["_18" /* INTERNAL_NOTE */]).trim() !== "" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "internal_note",
                label: "Internal Note",
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["l" /* TextArea */],
                rows: 5,
                disabled: true
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["FieldArray"], {
            attachmentTypes: __WEBPACK_IMPORTED_MODULE_23__constants__["y" /* ATTACHMENT_TYPES */],
            name: __WEBPACK_IMPORTED_MODULE_19__constants__["k" /* ATTACHMENTS */],
            getField: this.props.getField,
            component: __WEBPACK_IMPORTED_MODULE_11__components_shared_FormSections_AttachmentListSection__["a" /* default */]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__FormSections_MistakeShipmentSection__["a" /* default */], {
            formName: formName,
            receivingType: receivingType
          }),
          ![__WEBPACK_IMPORTED_MODULE_23__constants__["s" /* EMA */], __WEBPACK_IMPORTED_MODULE_23__constants__["d" /* MISTAKE_SHIPMENT */]].includes(receivingType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            !virtualReceiving && Object.keys(__WEBPACK_IMPORTED_MODULE_23__constants__["z" /* RECEIVING_CHECKLIST_QUESTIONS */]).map(this.renderChecklistQuestion)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__FormFooter__["a" /* default */], {
          state: this.state,
          allValues: allValues,
          close: close,
          errorMessages: errorMessages,
          getInitialFieldValue: getInitialFieldValue,
          getField: getField,
          handleSubmit: handleSubmit,
          receiveAnother: this.receiveAnother,
          onSubmit: this.props.onSubmit,
          removeItem: this.props.removeItem,
          receivingRecord: receivingRecord,
          reset: this.props.reset,
          save: this.props.save,
          setFieldValue: setFieldValue,
          setState: this.setState,
          submitFailed: submitFailed,
          submitting: submitting,
          propValues: this.props,
          receivingType: receivingType
        })
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  getInitialFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchParts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  receivingRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  errorMessages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.str),
  removeItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitFailed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  lockFields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  virtualReceiving: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_36__users_constants__["a" /* USER */]).toJS(),
    allValues: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["getFormValues"])(formName)(state),
    condition: selector(state, __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["n" /* CONDITION */]),
    getField: function getField(field) {
      return selector(state, field);
    },
    getInitialFieldValue: function getInitialFieldValue(field) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["getFormInitialValues"])(formName)(state), field);
    },
    quantity: selector(state, __WEBPACK_IMPORTED_MODULE_19__constants__["j" /* QUANTITY */]),
    receivingType: selector(state, __WEBPACK_IMPORTED_MODULE_23__constants__["A" /* RECEIVING_TYPE */])
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__actions__["m" /* create */])(data));
    },
    save: function save(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__actions__["n" /* save */])(data));
    },
    searchParts: function searchParts(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_9__parts_actions_actions__["n" /* searchParts */](filter));
    },
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_21__PurchaseOrders_actions__["c" /* searchBuyers */](filter));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(formName, field, val));
      };
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_39__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Lots_constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











function FormFooter(_ref) {
  var allValues = _ref.allValues,
      close = _ref.close,
      getInitialFieldValue = _ref.getInitialFieldValue,
      getField = _ref.getField,
      propValues = _ref.propValues,
      removeItem = _ref.removeItem,
      receiveAnother = _ref.receiveAnother,
      receivingRecord = _ref.receivingRecord,
      reset = _ref.reset,
      save = _ref.save,
      setFieldValue = _ref.setFieldValue,
      submitting = _ref.submitting,
      submitFailed = _ref.submitFailed,
      errorMessages = _ref.errorMessages,
      receivingType = _ref.receivingType,
      handleSubmit = _ref.handleSubmit,
      onSubmit = _ref.onSubmit;

  var hasRemainingQuantity = Number(getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["j" /* QUANTITY */])) - Number(getField(__WEBPACK_IMPORTED_MODULE_8__constants__["j" /* QUANTITY */])) > 0;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(receivingRecord && receivingRecord.quantity_received ? receivingRecord.quantity_received : 0),
      _useState2 = _slicedToArray(_useState, 2),
      localQtyReceived = _useState2[0],
      setLocalQtyReceived = _useState2[1];

  var qtyOrdered = receivingRecord && receivingRecord.quantity ? receivingRecord.quantity : 0;
  var qtyUnreceived = qtyOrdered - localQtyReceived;
  var canReceiveAnother = receivingRecord && qtyUnreceived > 1;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["e" /* Form */].Footer,
    null,
    submitFailed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["i" /* Errors */], { errors: errorMessages }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["e" /* Form */].Cancel, { close: close }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        disabled: submitting || receivingType === __WEBPACK_IMPORTED_MODULE_3__constants__["s" /* EMA */],
        type: "button",
        className: "btn btn-danger",
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_submission__["b" /* onSuccess */])(handleSubmit(function (values) {
          return onSubmit({
            formData: _extends({}, values, {
              reported: true
            }),
            lineItem: receivingRecord
          });
        }), close, propValues)
      },
      "Report Discrepancy"
    ),
    !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(receivingType) && ![__WEBPACK_IMPORTED_MODULE_3__constants__["s" /* EMA */], __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* MISTAKE_SHIPMENT */], __WEBPACK_IMPORTED_MODULE_3__constants__["t" /* CONSIGNMENT */], __WEBPACK_IMPORTED_MODULE_7__Lots_constants__["b" /* LOT_LINE_ITEM */]].includes(receivingType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        className: "btn btn-warning ",
        disabled: submitting,
        type: "button",
        onClick: function onClick() {
          save({
            id: allValues.reference_record_line_item_id,
            formData: allValues
          }).then(function () {
            return close();
          });
        }
      },
      submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cog fa-spin fa-fw fa-lg" }) : "Save"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        disabled: submitting,
        className: "btn btn-success",
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_submission__["b" /* onSuccess */])(handleSubmit(function (values) {
          return onSubmit({
            formData: _extends({}, values),
            lineItem: receivingRecord
          });
        }), function () {
          removeItem(receivingRecord && receivingRecord.id);
          close();
        }, propValues)
      },
      submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cog fa-spin fa-fw fa-lg" }) : "Receive"
    ),
    ([__WEBPACK_IMPORTED_MODULE_3__constants__["t" /* CONSIGNMENT */], __WEBPACK_IMPORTED_MODULE_3__constants__["s" /* EMA */], __WEBPACK_IMPORTED_MODULE_7__Lots_constants__["b" /* LOT_LINE_ITEM */]].includes(receivingType) || receivingType === __WEBPACK_IMPORTED_MODULE_3__constants__["U" /* PO */] && hasRemainingQuantity) && canReceiveAnother && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        disabled: submitting,
        className: "btn btn-success",
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_submission__["b" /* onSuccess */])(handleSubmit(function (values) {
          return onSubmit({
            formData: _extends({}, values),
            lineItem: receivingRecord
          });
        }), function () {
          setLocalQtyReceived(function (prev) {
            return prev + 1;
          });

          var savedVals = [__WEBPACK_IMPORTED_MODULE_3__constants__["G" /* CONSIGNMENT_BUYER_ID */], __WEBPACK_IMPORTED_MODULE_3__constants__["v" /* CONSIGNMENT_REFERENCE_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_3__constants__["I" /* CONSIGNOR_PERCENTAGE */], __WEBPACK_IMPORTED_MODULE_3__constants__["F" /* CONSIGNMENT_REFERENCE */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["M" /* OTHER */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["N" /* OTHER_TAG_TYPE */], __WEBPACK_IMPORTED_MODULE_7__Lots_constants__["z" /* LOT_ID */], __WEBPACK_IMPORTED_MODULE_3__constants__["A" /* RECEIVING_TYPE */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["E" /* TRACE_TYPE */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["F" /* TRACED_TO */]].reduce(function (agg, f) {
            return _extends({}, agg, _defineProperty({}, f, getField(f)));
          }, {});

          if (receivingType === __WEBPACK_IMPORTED_MODULE_7__Lots_constants__["b" /* LOT_LINE_ITEM */]) {
            savedVals[__WEBPACK_IMPORTED_MODULE_8__constants__["W" /* AWB_NUMBER */]] = getField(__WEBPACK_IMPORTED_MODULE_8__constants__["W" /* AWB_NUMBER */]);
          } else if (receivingType === __WEBPACK_IMPORTED_MODULE_3__constants__["U" /* PO */]) {
            savedVals[__WEBPACK_IMPORTED_MODULE_8__constants__["j" /* QUANTITY */]] = 1;
            savedVals[__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["o" /* SERIAL_NUMBER */]] = "";
            Object.keys(__WEBPACK_IMPORTED_MODULE_3__constants__["z" /* RECEIVING_CHECKLIST_QUESTIONS */]).concat([__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_0" /* LOCATION */], __WEBPACK_IMPORTED_MODULE_8__constants__["W" /* AWB_NUMBER */], "reference_record_line_item_id", "reference_record_line_item_type", __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["q" /* PART_ID */]]).forEach(function (k) {
              savedVals[k] = getField(k);
            });
          }

          reset();

          Object.keys(savedVals).forEach(function (k) {
            setFieldValue(k)(savedVals[k]);
          });

          receiveAnother(receivingType);
        }, propValues)
      },
      submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cog fa-spin fa-fw fa-lg" }) : "Receive Another"
    ),
    " "
  );
}

/* harmony default export */ __webpack_exports__["a"] = (FormFooter);

FormFooter.propTypes = {
  allValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  errorMessages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  getInitialFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  propValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  removeItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedConsignmentBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  selectedConsignor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  receiveAnother: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  receivingRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  save: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  submitFailed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  receivingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Lots_shared_SelectLot_SelectLot__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Lots_shared_SelectLotCode_SelectLotCode__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Lots_constants__ = __webpack_require__(64);








function LotSection(_ref) {
  var handleLotSelected = _ref.handleLotSelected,
      selectedLot = _ref.selectedLot,
      receivingType = _ref.receivingType,
      setFieldValue = _ref.setFieldValue;

  if (receivingType !== __WEBPACK_IMPORTED_MODULE_6__Lots_constants__["b" /* LOT_LINE_ITEM */]) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms_FormRow__["a" /* default */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Lots_shared_SelectLot_SelectLot__["a" /* default */], {
        setFieldValue: setFieldValue,
        handleLotSelected: handleLotSelected,
        selectedLot: selectedLot
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Lots_shared_SelectLotCode_SelectLotCode__["a" /* default */], {
        setFieldValue: setFieldValue,
        handleLotSelected: handleLotSelected,
        selectedLot: selectedLot
      })
    )
  );
}

LotSection.propTypes = {
  handleLotSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  receivingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  selectedLot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (LotSection);

/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Orders_shared_ShippingFields_ShippingFields__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);







function MistakeShipmentSection(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["m" /* DashedSeparator */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      "Mistake Shipment Ship To"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Orders_shared_ShippingFields_ShippingFields__["a" /* default */], {
      formName: props.formName,
      hasLocations: false,
      shippingFields: ["ship_to_type", "ship_to_company_id", "ship_to_company_address_id"],
      shippingMethod: "ship_to_shipping_method",
      shippingTypes: ["company", "dropship"],
      shippingAddressField: "ship_to_shipping_address",
      required: false
    })
  );
}

MistakeShipmentSection.propTypes = {
  formName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var isMistakeShipment = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["a" /* renderIf */])(function (_ref) {
  var receivingType = _ref.receivingType;
  return receivingType === __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* MISTAKE_SHIPMENT */];
});

/* harmony default export */ __webpack_exports__["a"] = (isMistakeShipment(MistakeShipmentSection));

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Orders_shared_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__inventories_constants__ = __webpack_require__(12);








function DupeWarning(_ref) {
  var receivingRecord = _ref.receivingRecord;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_2__constants__["p" /* TYPE */]) === __WEBPACK_IMPORTED_MODULE_3__Orders_shared_constants__["e" /* SO_ITEM */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(receivingRecord, "customer_rma.received") === false || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_2__constants__["p" /* TYPE */]) === __WEBPACK_IMPORTED_MODULE_4__constants__["c" /* RMA */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(receivingRecord, "sales_item.exchange_sale") && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(receivingRecord, "sales_item.received")) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["n" /* Warning */],
      null,
      "Warning: Serial #",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["o" /* SERIAL_NUMBER */]),
      " exists more than once in the Inbound. You have selected the",
      " ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(receivingRecord, __WEBPACK_IMPORTED_MODULE_2__constants__["p" /* TYPE */]) === __WEBPACK_IMPORTED_MODULE_4__constants__["c" /* RMA */] ? "RMA" : "SO",
      ". Please verify you selected the correct line item."
    );
  }

  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (DupeWarning);

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Lots_constants__ = __webpack_require__(64);
/* harmony export (immutable) */ __webpack_exports__["a"] = requireTagDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = requireTaggedBy;



function requireTagDate(condition, receivingType) {
  return __WEBPACK_IMPORTED_MODULE_0__constants__["u" /* TAG_DATE_CONDITIONS */].includes(condition) && ![__WEBPACK_IMPORTED_MODULE_0__constants__["t" /* CONSIGNMENT */], __WEBPACK_IMPORTED_MODULE_0__constants__["s" /* EMA */], __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* MISTAKE_SHIPMENT */]].includes(receivingType) || [__WEBPACK_IMPORTED_MODULE_0__constants__["t" /* CONSIGNMENT */], __WEBPACK_IMPORTED_MODULE_0__constants__["s" /* EMA */]].includes(receivingType) && [__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* REPAIRED */], __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* INSPECTED */]].includes(condition);
}

function requireTaggedBy(condition, receivingType) {
  return [__WEBPACK_IMPORTED_MODULE_0__constants__["t" /* CONSIGNMENT */], __WEBPACK_IMPORTED_MODULE_0__constants__["s" /* EMA */], __WEBPACK_IMPORTED_MODULE_1__Lots_constants__["b" /* LOT_LINE_ITEM */]].includes(receivingType) && [__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* REPAIRED */], __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* INSPECTED */]].includes(condition);
}

/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_FormSections_validate__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Orders_shared_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Lots_constants__ = __webpack_require__(64);











/* harmony default export */ __webpack_exports__["a"] = (function (values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["q" /* PART_ID */], __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* RECEIVING_TYPE */], __WEBPACK_IMPORTED_MODULE_7__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["_27" /* STORE_LOCATION_ID */], __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["o" /* SERIAL_NUMBER */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    if (__WEBPACK_IMPORTED_MODULE_5__constants__["u" /* TAG_DATE_CONDITIONS */].includes(values.condition) && ![__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* MISTAKE_SHIPMENT */], __WEBPACK_IMPORTED_MODULE_5__constants__["s" /* EMA */], __WEBPACK_IMPORTED_MODULE_4__Orders_shared_constants__["l" /* CONSIGNMENT */]].includes(values.receiving_type)) {
      form.validate(__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["x" /* TAG_DATE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    }

    if ([__WEBPACK_IMPORTED_MODULE_4__Orders_shared_constants__["l" /* CONSIGNMENT */], __WEBPACK_IMPORTED_MODULE_5__constants__["s" /* EMA */]].includes(values.receiving_type) && [__WEBPACK_IMPORTED_MODULE_5__constants__["j" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_5__constants__["l" /* REPAIRED */], __WEBPACK_IMPORTED_MODULE_5__constants__["h" /* INSPECTED */]].includes(values.condition)) {
      form.validate(__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["x" /* TAG_DATE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    }

    if (values.receiving_type === __WEBPACK_IMPORTED_MODULE_9__Lots_constants__["b" /* LOT_LINE_ITEM */] && [__WEBPACK_IMPORTED_MODULE_5__constants__["j" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_5__constants__["l" /* REPAIRED */], __WEBPACK_IMPORTED_MODULE_5__constants__["h" /* INSPECTED */]].includes(values.condition)) {
      form.validate(__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["p" /* TAGGED_BY */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    }

    if (values.receiving_type !== __WEBPACK_IMPORTED_MODULE_5__constants__["s" /* EMA */]) {
      form.validate(__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["_0" /* LOCATION */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    }

    if (values.receiving_type === __WEBPACK_IMPORTED_MODULE_9__Lots_constants__["a" /* LOT */]) {
      form.validate(__WEBPACK_IMPORTED_MODULE_9__Lots_constants__["z" /* LOT_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    }

    if (__WEBPACK_IMPORTED_MODULE_4__Orders_shared_constants__["l" /* CONSIGNMENT */] === values.receiving_type && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(props, "receivingRecord.type")) form.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["F" /* CONSIGNMENT_REFERENCE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);

    if ([__WEBPACK_IMPORTED_MODULE_4__Orders_shared_constants__["l" /* CONSIGNMENT */], __WEBPACK_IMPORTED_MODULE_5__constants__["s" /* EMA */]].includes(values.receiving_type) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(props, "receivingRecord.type")) {
      form.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["G" /* CONSIGNMENT_BUYER_ID */], __WEBPACK_IMPORTED_MODULE_5__constants__["I" /* CONSIGNOR_PERCENTAGE */], __WEBPACK_IMPORTED_MODULE_5__constants__["v" /* CONSIGNMENT_REFERENCE_COMPANY_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);

      var minValFunc = values.receiving_type === __WEBPACK_IMPORTED_MODULE_5__constants__["s" /* EMA */] ? __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */] : __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["f" /* isGreaterThan */];

      form.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["I" /* CONSIGNOR_PERCENTAGE */]).satisfies(minValFunc(0.0), __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["k" /* isLessThanOrEqualTo */](99));

      if ([__WEBPACK_IMPORTED_MODULE_5__constants__["j" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_5__constants__["l" /* REPAIRED */], __WEBPACK_IMPORTED_MODULE_5__constants__["h" /* INSPECTED */]].includes(values.condition)) {
        form.validate(__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["p" /* TAGGED_BY */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
      }
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(props.receivingRecord, [__WEBPACK_IMPORTED_MODULE_8__parts_constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_8__parts_constants__["_12" /* SHELF_LIFE */]].join(".")) && [__WEBPACK_IMPORTED_MODULE_5__constants__["j" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_5__constants__["l" /* REPAIRED */], __WEBPACK_IMPORTED_MODULE_5__constants__["h" /* INSPECTED */], __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["g" /* NEW_ITEM */]].includes(values.condition)) {
      form.validate(__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["y" /* EXPIRATION */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(props.receivingRecord, [__WEBPACK_IMPORTED_MODULE_8__parts_constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_8__parts_constants__["_7" /* DOM_SENSITIVE */]].join("."))) {
      form.validate(__WEBPACK_IMPORTED_MODULE_8__parts_constants__["G" /* DOM */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    }

    form.validateChildren(__WEBPACK_IMPORTED_MODULE_7__constants__["k" /* ATTACHMENTS */], __WEBPACK_IMPORTED_MODULE_3__components_shared_FormSections_validate__["a" /* default */]);
  });
});

/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Search__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagination__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Detail_Discrepancies_Create__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Create_Create__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(115);
/* unused harmony export Dashboard */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Dashboard = function (_Component) {
  _inherits(Dashboard, _Component);

  function Dashboard(props) {
    _classCallCheck(this, Dashboard);

    var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this));

    _this.state = {
      showModal: false,
      open: false,
      removeItem: function removeItem() {}
    };

    _this.setRemoveItem = function (removeItem) {
      return _this.setState({
        removeItem: removeItem
      });
    };

    _this.open = function () {
      _this.setState({ showModal: true, receivingRecord: null });
    };

    _this.closeModal = function () {
      _this.setState({ showModal: false });
      _this.props.reset();
    };

    _this.openCreate = function () {
      return _this.setState({ open: true });
    };

    _this.openAndSetRecord = function (r) {
      return _this.setState({
        open: true,
        receivingRecord: Object.assign({}, r, {
          virtually_receiving: _this.props.virtual
        })
      });
    };

    _this.close = function () {
      _this.setState({ open: false, receivingRecord: null });
    };

    _this.openAndSetRecord = _this.openAndSetRecord.bind(_this);
    _this.search = props.virtual ? __WEBPACK_IMPORTED_MODULE_4__pagination__["a" /* virtualReceivingDashboardOrders */] : __WEBPACK_IMPORTED_MODULE_4__pagination__["b" /* receivingDashboardOrders */];
    return _this;
  }

  _createClass(Dashboard, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var displayModal = _ref.displayModal;

      if (displayModal) {
        this.setState({ showModal: true });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var virtual = this.props.virtual;
      var _state = this.state,
          showModal = _state.showModal,
          open = _state.open,
          receivingRecord = _state.receivingRecord;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Search__["a" /* Search */], {
          openAndSetRecord: this.openAndSetRecord,
          openCreate: this.openCreate,
          setRemoveItem: this.setRemoveItem,
          virtual: virtual
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Create_Create__["a" /* default */], {
          open: open,
          close: this.close,
          receivingRecord: receivingRecord,
          removeItem: this.state.removeItem,
          virtual: virtual
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Detail_Discrepancies_Create__["a" /* default */], {
          close: this.closeModal,
          open: showModal,
          virtual: virtual
        })
      );
    }
  }]);

  return Dashboard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Dashboard.propTypes = {
  virtual: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  displayModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    displayModal: state.receivingRecordDetail.getIn(["receivingRecord", "showModal"])
  };
}, {
  reset: __WEBPACK_IMPORTED_MODULE_7__actions__["l" /* resetDiscrepancies */]
})(Dashboard));

/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pagination__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(115);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Search; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var filters = [{
  label: "PO's",
  filters: { table: "purchase_order_line_items" }
}, {
  label: "LPO's",
  filters: { table: "lots" }
}, {
  label: "RO's",
  filters: { table: "repair_order_line_items" }
}, {
  label: "Store Transfers",
  filters: { table: "inventory_transfer_orders" }
}, {
  label: "Exchanges",
  filters: { table: "sales_order_line_items" }
}, {
  label: "Managed Repairs",
  filters: { table: "managed_repair_order_line_items" }
}, {
  label: "RMA's",
  filters: { table: "rmas" }
}, {
  label: "In Receiving Process",
  filters: { in_receiving_process: true },
  hr: true
}, {
  label: __WEBPACK_IMPORTED_MODULE_6__constants__["_37" /* CLEAR_FILTERS_TEXT */],
  filters: { table: null, in_receiving_process: undefined }
}];

var filterTags = [{
  label: "PO's",
  key: "table",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["b" /* matchesString */])("purchase_order_line_items")
}, {
  label: "LPO's",
  key: "table",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["b" /* matchesString */])("lots")
}, {
  label: "RO's",
  key: "table",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["b" /* matchesString */])("repair_order_line_items")
}, {
  label: "Store Transfers",
  key: "table",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["b" /* matchesString */])("inventory_transfer_orders")
}, {
  label: "Exchanges",
  key: "table",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["b" /* matchesString */])("sales_order_line_items")
}, {
  label: "Managed Repairs",
  key: "table",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["b" /* matchesString */])("managed_repair_order_line_items")
}, {
  label: "RMA's",
  key: "table",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["b" /* matchesString */])("rmas")
}, {
  label: "In Receiving Process",
  key: "in_receiving_process"
}];

var Search = function (_PureComponent) {
  _inherits(Search, _PureComponent);

  function Search(props) {
    _classCallCheck(this, Search);

    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this));

    _this.search = props.virtual ? __WEBPACK_IMPORTED_MODULE_8__pagination__["a" /* virtualReceivingDashboardOrders */] : __WEBPACK_IMPORTED_MODULE_8__pagination__["b" /* receivingDashboardOrders */];
    return _this;
  }

  _createClass(Search, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          openCreate = _props.openCreate,
          openAndSetRecord = _props.openAndSetRecord,
          setRemoveItem = _props.setRemoveItem,
          virtual = _props.virtual;

      var title = virtual ? "Virtual Inbound Open Orders" : "Inbound Open Orders";

      var filteredFilters = virtual ? filters : filters.filter(function (f) {
        return f.label !== "Show Store Transfers";
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components__["c" /* Search */],
        { search: this.search, syncWithUrl: true },
        function (searchProps) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            setRemoveItem(searchProps.pageActions.removeItem),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "input-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
                  placeholder: "Search by typing a company name, part number, reference number or AWB #..."
                })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
                  filters: filteredFilters,
                  right: true
                })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { className: "input-group-btn" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    {
                      onClick: openCreate,
                      className: "btn btn-info",
                      type: "button"
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
                    "Receive New"
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
              title: title,
              filters: filterTags
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */], _extends({
              openModal: openAndSetRecord
            }, searchProps, {
              virtual: virtual
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["d" /* Pagination */], searchProps)
          );
        }
      );
    }
  }]);

  return Search;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Search.propTypes = {
  openCreate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  openAndSetRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setRemoveItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  virtual: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, {
  reset: __WEBPACK_IMPORTED_MODULE_9__actions__["l" /* resetDiscrepancies */]
})(Search));

/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SalesOrders_helpers__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(34);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













var buildLink = function buildLink(_ref) {
  var parentType = _ref.parent_type,
      parentId = _ref.parent_id,
      type = _ref.type,
      uuid = _ref.uuid,
      id = _ref.id;

  if (type === "rma") {
    return "/rmas/" + (uuid || id);
  }
  return "/" + parentType.replaceAll("_", "-") + "/" + (uuid || parentId);
};

function renderRow(r, openModal, virtual) {
  var qtyOrdered = r.quantity || 0;
  var qtyReceived = r.quantity_received || 0;
  var qtyUnreceived = qtyOrdered - qtyReceived;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { key: r.id, className: "clickable", onClick: function onClick() {
        return openModal(r);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
        { to: buildLink(r) },
        r.reference_number
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["b" /* shortDate */])(r.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["h" /* PartNumber */], {
        part: {
          id: r.part.part_uuid,
          part_number: r.part_number
        },
        statsTooltip: false
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.serial_number ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
        { to: "/inventories/" + r.inventory_id },
        r.serial_number
      ) : r.expected_serial_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.mod_to_id && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["h" /* PartNumber */], { part: r.mod_to, statsTooltip: false })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["o" /* LocationFlag */], { location: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(r, "store.id") })
      )
    ),
    virtual && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.type && __WEBPACK_IMPORTED_MODULE_10__constants__["X" /* RECORD_TYPES */][r.type].label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["w" /* CompanyName */], { company: r.company, statsTooltip: false, truncateAt: 25 })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.awb_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_10__constants__["x" /* CONDITION_TYPES */], r.condition + ".label")
    ),
    !virtual && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      r.exchange_sale && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SalesOrders_helpers__["a" /* ExchangeIcon */], { lineItem: r })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      qtyUnreceived
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      qtyOrdered
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center", style: { position: "relative" } },
      qtyReceived,
      !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(r.receiving_cached_key) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { style: { position: "absolute", right: "10px" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["j" /* NoteTooltip */], {
          note: "Saved Checklist",
          icon: "fa-thumb-tack",
          color: "#2196F3"
        })
      )
    )
  );
}

function Table(_ref2) {
  var openModal = _ref2.openModal,
      isLoading = _ref2.isLoading,
      pageActions = _ref2.pageActions,
      results = _ref2.results,
      virtual = _ref2.virtual;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */],
    { loading: isLoading, refresh: pageActions.expire },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Ref #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Created"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Mod To #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Store Owner"
        )
      ),
      virtual && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Type"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Company"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "AWB #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Condition"
      ),
      !virtual && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Exch Sale"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "QTY Exp"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "QTY Ord"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "QTY Rec"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, openModal, virtual);
      })
    )
  );
}

Table.propTypes = _extends({
  openModal: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_6__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"] })(Table));

/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dashboard__ = __webpack_require__(1641);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dashboard__["a"]; });



/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators_loadRecord__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Attachments_Attachments__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Header__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Discrepancies_Discrepancies__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SideBar__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__QuestionsChecklist__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(34);
















function Detail(_ref) {
  var receivingRecord = _ref.receivingRecord;

  var formVersion = receivingRecord.get("discrepancies_form_version_number");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Header__["a" /* default */], { receivingRecord: receivingRecord }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SideBar__["a" /* default */], { receivingRecord: receivingRecord }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
      { md: 9 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Discrepancies_Discrepancies__["a" /* default */], { formVersion: formVersion }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Attachments_Attachments__["a" /* default */], {
        multiple: true,
        resource: receivingRecord,
        resourceType: __WEBPACK_IMPORTED_MODULE_7__shared_types_resourceTypes__["a" /* default */].receivingRecord,
        resourceKey: "receivingRecord",
        attachmentTypes: __WEBPACK_IMPORTED_MODULE_14__constants__["y" /* ATTACHMENT_TYPES */]
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["M" /* Notes */], {
        resource: receivingRecord,
        resourceType: __WEBPACK_IMPORTED_MODULE_7__shared_types_resourceTypes__["a" /* default */].receivingRecord,
        resourceKey: "receivingRecord"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__QuestionsChecklist__["a" /* default */], { receivingRecord: receivingRecord })
    )
  );
}

Detail.propTypes = {
  receivingRecord: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    receivingRecord: state.receivingRecordDetail.get("receivingRecord")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators_loadRecord__["a" /* default */])({
  reducer: "receivingRecordDetail",
  name: "receivingRecord",
  action: __WEBPACK_IMPORTED_MODULE_13__actions__["b" /* show */]
})(Detail)));

/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(115);
/* unused harmony export AttachmentTag */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var AttachmentTag = function (_Component) {
  _inherits(AttachmentTag, _Component);

  function AttachmentTag() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AttachmentTag);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AttachmentTag.__proto__ || Object.getPrototypeOf(AttachmentTag)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.handleClick = function (e) {
      _this.open();
      e.stopPropagation();
    }, _this.open = function () {
      return _this.setState({ open: true });
    }, _this.close = function () {
      return _this.setState({ open: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AttachmentTag, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          attachment = _props.attachment,
          index = _props.index,
          destroy = _props.destroy;

      var str = "Img #" + (index + 1);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "btn-group", style: { marginRight: "5px" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            className: "btn btn-xs btn-default",
            onClick: function onClick(e) {
              return e.stopPropagation();
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            { href: "" + attachment.file_url },
            str
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__shared_components__["R" /* AuthorizedOwner */],
          { record: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(attachment) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            {
              type: "button",
              className: "btn btn-xs btn-default",
              onClick: this.handleClick
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: { marginLeft: 3 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close text-danger" })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__shared_components__["q" /* ConfirmDelete */],
          {
            onConfirm: function onConfirm() {
              return destroy(attachment.id);
            },
            close: this.close,
            open: this.state.open
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          " Are you sure you want to delete this?"
        )
      );
    }
  }]);

  return AttachmentTag;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AttachmentTag.propTypes = {
  attachment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    file_url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }).isRequired,
  destroy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, {
  destroy: __WEBPACK_IMPORTED_MODULE_5__actions__["h" /* destroyAttachment */]
})(AttachmentTag));

/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDown__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ResolveForm__ = __webpack_require__(1653);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var Controls = function (_Component) {
  _inherits(Controls, _Component);

  function Controls() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Controls);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Controls.__proto__ || Object.getPrototypeOf(Controls)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      resolveModalOpen: false
    }, _this.openResolveModal = function () {
      return _this.setState({ resolveModalOpen: true });
    }, _this.closeResolveModal = function () {
      return _this.setState({ resolveModalOpen: false });
    }, _this.sendRequestAndClose = function (discrepancy) {
      _this.props.resolve(discrepancy.id);
      return _this.closeResolveModal();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Controls, [{
    key: "render",
    value: function render() {
      var resolveModalOpen = this.state.resolveModalOpen;
      var _props = this.props,
          discrepancy = _props.discrepancy,
          openEditModal = _props.openEditModal;

      var initialValues = {
        id: discrepancy.id,
        reason_for_resolution: discrepancy.reason_for_resolution
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDown__["a" /* default */],
        { icon: "fa fa-fw fa-ellipsis-v", menuClass: "dropdown-menu-right" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__["a" /* default */],
          { onClick: openEditModal },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-pencil" }),
          "\xA0Edit"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components__["b" /* Authorized */],
          {
            roles: [__WEBPACK_IMPORTED_MODULE_6__users_constants__["p" /* QUALITY_CONTROL */]],
            authorizedIf: function authorizedIf(user) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__users_helpers__["d" /* hasRole */])(user.toJS(), __WEBPACK_IMPORTED_MODULE_6__users_constants__["l" /* REPAIR */]) && discrepancy.repairs_can_resolve;
            }
          },
          !discrepancy.resolved && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__["a" /* default */],
            { key: "resolve-action", onClick: this.openResolveModal },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" }),
            "Resolve"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["a" /* Modal */],
            {
              open: resolveModalOpen,
              key: "resolve-modal",
              close: this.closeResolveModal,
              dialogClass: "modal-sm"
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["b" /* Header */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["c" /* Close */], { close: this.closeResolveModal }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                { className: "modal-title" },
                "Resolve Discrepancy"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ResolveForm__["a" /* default */], {
              discrepancy: discrepancy,
              closeResolveModal: this.closeResolveModal,
              initialValues: initialValues
            })
          )
        )
      );
    }
  }]);

  return Controls;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Controls);


Controls.propTypes = {
  discrepancy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  resolve: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  openEditModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__New__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Controls__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ResolvedBadge__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UnresolvedBadge__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Edit_EditDiscrepancy__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AttachmentTag__ = __webpack_require__(1646);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var Discrepancies = function (_React$Component) {
  _inherits(Discrepancies, _React$Component);

  function Discrepancies() {
    _classCallCheck(this, Discrepancies);

    var _this = _possibleConstructorReturn(this, (Discrepancies.__proto__ || Object.getPrototypeOf(Discrepancies)).call(this));

    _this.state = {
      editModalOpen: false
    };

    _this.attachments = function (attachments) {
      return attachments.map(function (attachment, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__AttachmentTag__["a" /* default */], { attachment: attachment, index: index });
      });
    };

    _this.openEditModal = function (discrepancy) {
      return _this.setState({ discrepancy: discrepancy, editModalOpen: true });
    };

    _this.closeEditModal = function () {
      return _this.setState({ editModalOpen: false });
    };

    _this.renderRow = function (discrepancy) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        {
          key: discrepancy.id,
          className: "clickable",
          onClick: function onClick() {
            return _this.openEditModal(discrepancy);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["b" /* shortDate */])(discrepancy.created_at)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          discrepancy.created_by.full_name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_7__constants__["B" /* DISCREPANCY_TYPES */][discrepancy.discrepancy_type].label
        ),
        discrepancy.reason ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], {
          className: "text-center",
          note: discrepancy.reason
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          _this.attachments(discrepancy.attachments)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          discrepancy.resolved ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ResolvedBadge__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__UnresolvedBadge__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(discrepancy, "resolved_by.full_name")
        ),
        discrepancy.reason_for_resolution ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], {
          className: "text-center",
          note: discrepancy.reason_for_resolution
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Controls__["a" /* default */], {
            discrepancy: discrepancy,
            openEditModal: function openEditModal() {
              return _this.openEditModal(discrepancy);
            }
          })
        )
      );
    };

    _this.closeEditModal = _this.closeEditModal.bind(_this);
    return _this;
  }

  _createClass(Discrepancies, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          results = _props.results,
          isLoading = _props.isLoading;
      var _state = this.state,
          editModalOpen = _state.editModalOpen,
          discrepancy = _state.discrepancy;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          { style: { marginTop: 26 } },
          "Discrepancies",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__New__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Mini,
          { loading: isLoading, numbered: true, noMargin: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Created On"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Created By"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Discrepancy Type"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Reason for Discrepancy"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Images"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Status"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Resolved By"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Reason for Resolution"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-center" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Body,
            null,
            results.map(this.renderRow)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Edit_EditDiscrepancy__["a" /* default */], {
          open: editModalOpen,
          close: this.closeEditModal,
          discrepancy: discrepancy
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "nav",
          {
            className: "text-center margin-top-none",
            "aria-label": "Search results pages"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__["Paginator"], { listId: "discrepancies" })
        )
      );
    }
  }]);

  return Discrepancies;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Discrepancies.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    discrepancy_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  })),
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var ConnectedTable = __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__["decorators"].tabulate(Discrepancies);

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConnectedTable, _extends({ listId: "discrepancies" }, props));
});

/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(1650);








function EditDiscrepancy(_ref) {
  var open = _ref.open,
      close = _ref.close,
      receivingRecord = _ref.receivingRecord,
      discrepancy = _ref.discrepancy;

  var initialValues = {
    read_only_part_number: receivingRecord.getIn(["part", "part_number"]),
    read_only_serial_number: receivingRecord.get("serial_number"),
    id: discrepancy && discrepancy.id,
    reason: discrepancy && discrepancy.reason,
    discrepancy_type: discrepancy && discrepancy.discrepancy_type,
    reason_for_resolution: discrepancy && discrepancy.reason_for_resolution,
    escalate_discrepancy: discrepancy && discrepancy.escalate_discrepancy
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-md" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit a Discrepancy"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Form__["a" /* default */], {
      close: close,
      discrepancy: discrepancy,
      initialValues: initialValues,
      resolved: discrepancy && discrepancy.resolved,
      receivingRecordType: receivingRecord.getIn(["reference_record_type"])
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    receivingRecord: state.receivingRecordDetail.get("receivingRecord")
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_actions__["g" /* updateLineItem */](ownProps.selectedLineItem.id, data));
    }
  };
})(EditDiscrepancy));

EditDiscrepancy.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  discrepancy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  receivingRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])
};

/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__validate__ = __webpack_require__(686);
/* unused harmony export Form */















function Form(props) {
  var resolved = props.resolved,
      receivingRecordType = props.receivingRecordType;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__hooks__["a" /* useCurrentUser */])();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "read_only_part_number",
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
            label: "Part #",
            disabled: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "read_only_serial_number",
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
            label: "Serial #",
            disabled: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["m" /* DashedSeparator */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
          { md: 5 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "discrepancy_type",
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
            label: "Discrepancy Type",
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_11__constants__["B" /* DISCREPANCY_TYPES */]),
            disabled: true
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "files",
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["k" /* FileInput */],
            label: "Upload Attachment(s)",
            multiple: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "reason",
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["l" /* TextArea */],
            label: "Explain the Discrepancy",
            rows: 5
          })
        )
      ),
      resolved && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["m" /* DashedSeparator */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["d" /* Row */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
            { md: 5 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_11__constants__["C" /* REASON_FOR_RESOLUTION */],
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__constants__["C" /* REASON_FOR_RESOLUTION */]),
              options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_forms__["f" /* arrayToOptions */])(__WEBPACK_IMPORTED_MODULE_11__constants__["D" /* REASON_FOR_RESOLUTION_OPTIONS */]),
              disabled: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_8__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["l" /* REPAIR */]]) && receivingRecordType === "RepairOrder"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */], { md: 6 })
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { onSubmit: __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* editDiscrepancy */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["j" /* form */])({
  form: "editDiscrepancy",
  validate: __WEBPACK_IMPORTED_MODULE_13__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__validate__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(34);
/* unused harmony export Form */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Discrepancy = function (_Component) {
  _inherits(Discrepancy, _Component);

  function Discrepancy() {
    _classCallCheck(this, Discrepancy);

    return _possibleConstructorReturn(this, (Discrepancy.__proto__ || Object.getPrototypeOf(Discrepancy)).apply(this, arguments));
  }

  _createClass(Discrepancy, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.fields.length < 1) {
        this.props.fields.push();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          fields = _props.fields,
          discrepancies = _props.discrepancies;

      var showAddButton = fields.length < 5;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        fields.map(function (discrepancy, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { key: "discrepancy-" + (discrepancy + index) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              { className: "h4" },
              "Discrepancy #",
              index + 1,
              index !== 0 && !discrepancies[index] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "button",
                {
                  type: "button",
                  className: "btn btn-xs btn-default btn-hollow pull-right",
                  onClick: function onClick() {
                    return fields.remove(index);
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
                "\xA0Remove"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "row" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "col-md-5" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "row" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "col-md-12" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                      name: discrepancy + ".discrepancy_type",
                      component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
                      label: "Discrepancy Type",
                      options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_9__constants__["B" /* DISCREPANCY_TYPES */]),
                      disabled: discrepancies[index],
                      required: true
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "col-md-12" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                      name: discrepancy + ".files",
                      component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["k" /* FileInput */],
                      label: "Upload Attachment(s)",
                      multiple: true
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "col-md-6" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: discrepancy + ".reason",
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["l" /* TextArea */],
                  label: "Explain the Discrepancy",
                  rows: 5
                })
              )
            )
          );
        }),
        showAddButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            type: "button",
            onClick: function onClick() {
              return fields.push();
            },
            className: "btn btn-primary btn-hollow",
            style: { marginTop: 5, marginBottom: 15 }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
          " Add another Discrepancy"
        )
      );
    }
  }]);

  return Discrepancy;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Discrepancy.propTypes = {
  discrepancies: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    length: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  })
};

function Form(props) {
  var discrepancies = props.discrepancies;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "row row-col-gutters-half" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "read_only_part_number",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: "Part #",
            disabled: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "read_only_serial_number",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: "Serial #",
            disabled: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["m" /* DashedSeparator */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["FieldArray"], {
        name: "discrepancies",
        discrepancies: discrepancies,
        component: Discrepancy
      })
    )
  );
}

Form.propTypes = {
  discrepancies: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, { onSubmit: __WEBPACK_IMPORTED_MODULE_4__actions__["f" /* createDiscrepancy */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: "addDiscrepancy",
  validate: __WEBPACK_IMPORTED_MODULE_8__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Create__ = __webpack_require__(685);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    id: state.incomingQuoteDetail.getIn(["incomingQuote", "id"])
  };
})(function (_ref) {
  var id = _ref.id;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["P" /* LaunchModal */], {
    modal: __WEBPACK_IMPORTED_MODULE_3__Create__["a" /* default */],
    buttonClass: "btn-primary btn-hollow pull-right",
    text: "Add Discrepancy",
    id: id
  });
}));

/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_forms__ = __webpack_require__(44);
/* unused harmony export Form */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();














var formName = "resolveDiscrepancy";
var REASON_FOR_RESOLUTION_OTHER = "reason_for_resolution_other";

function Form(props) {
  var closeResolveModal = props.closeResolveModal,
      setFieldValue = props.setFieldValue;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      displayField = _useState2[0],
      setDisplayField = _useState2[1];

  var handleChange = function handleChange(ev) {
    var target = ev.target.value;
    if (target === "Other") {
      setDisplayField(true);
    }
    if (target !== "Other") {
      setDisplayField(false);
    }
  };

  var addResolveResolutionOther = function addResolveResolutionOther() {
    if (props.getFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["C" /* REASON_FOR_RESOLUTION */]) === "Other") {
      setFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["C" /* REASON_FOR_RESOLUTION */])(props.getFieldValue(REASON_FOR_RESOLUTION_OTHER));
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_7__constants__["C" /* REASON_FOR_RESOLUTION */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["C" /* REASON_FOR_RESOLUTION */]),
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_forms__["f" /* arrayToOptions */])(__WEBPACK_IMPORTED_MODULE_7__constants__["D" /* REASON_FOR_RESOLUTION_OPTIONS */]),
            onChange: handleChange
          }),
          displayField && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: REASON_FOR_RESOLUTION_OTHER,
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            required: true,
            placeholder: "Please fill out this field....",
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["C" /* REASON_FOR_RESOLUTION */])
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Footer,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            {
              type: "button",
              className: "btn btn-default",
              onClick: closeResolveModal
            },
            "Cancel"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            {
              type: "submit",
              className: "btn btn-primary",
              onClick: addResolveResolutionOther
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-warning" }),
            "\xA0Yes, Resolve Discrepancy"
          )
        )
      )
    )
  );
}

Form.propTypes = {
  closeResolveModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  initialValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    reason_for_resolution: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    getFieldValue: function getFieldValue(field) {
      return selector(state, field);
    }
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["g" /* resolveDiscrepancy */])(data));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])(formName, field, val));
      };
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: function validate(values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_validate_this__["a" /* validator */])(values, function (f) {
      f.validate(__WEBPACK_IMPORTED_MODULE_7__constants__["C" /* REASON_FOR_RESOLUTION */]).satisfies(__WEBPACK_IMPORTED_MODULE_10__lib_validation_rules__["a" /* required */]);
      f.validate(REASON_FOR_RESOLUTION_OTHER).satisfies(__WEBPACK_IMPORTED_MODULE_10__lib_validation_rules__["a" /* required */]);
    });
  }
})(Form)));

/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony export (immutable) */ __webpack_exports__["a"] = ResolvedBadge;


function ResolvedBadge() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "text-success" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" }),
    " Resolved"
  );
}

/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony export (immutable) */ __webpack_exports__["a"] = UnresolvedBadge;


function UnresolvedBadge() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "text-danger" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-warning" }),
    " Unresolved"
  );
}

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validate__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(34);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();














function Form(props) {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
      _useState2 = _slicedToArray(_useState, 2),
      poLineCount = _useState2[0],
      setPoLineCount = _useState2[1];

  var parentRecordType = props.receivingRecord.reference_record_type;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (parentRecordType === "PurchaseOrder") {
      __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].inventories.search({
        limit: 1,
        purchase_order_id: props.receivingRecord.reference_record_id
      }).then(function (_ref) {
        var total = _ref.data.total_count;

        setPoLineCount(total);
      });
    }

    return function cleanup() {};
  }, [props.receivingRecord.id]);

  var showApplyAll = poLineCount > 1 || parentRecordType !== "PurchaseOrder";

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_63" /* QC_STATUS */],
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
              options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_11__constants__["O" /* QC_STATUS_TYPES */]),
              label: "QC Status",
              required: true
            })
          )
        )
      ),
      showApplyAll && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              {
                className: "control-label",
                htmlFor: "bulk_update_qc_status"
              },
              "Apply to All Inventory for " + (props.referenceNumber || props.consignmentReference)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: "btn-group full-width-checkbox",
                "data-toggle": "buttons"
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: "bulk_update_qc_status",
                component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
                label: "Yes"
              })
            )
          )
        )
      )
    )
  );
}

Form.propTypes = {
  referenceNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, { onSubmit: __WEBPACK_IMPORTED_MODULE_10__actions__["i" /* updateQCStatus */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["j" /* form */])({
  form: "updateQCStatus",
  validate: __WEBPACK_IMPORTED_MODULE_9__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inventories_constants__ = __webpack_require__(12);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;




function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_2__inventories_constants__["_63" /* QC_STATUS */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Form__ = __webpack_require__(1660);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }










function Edit(_ref) {
  var _pojo;

  var open = _ref.open,
      close = _ref.close,
      receivingRecord = _ref.receivingRecord;

  var initialValues = (_pojo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_pojos__["a" /* default */])(receivingRecord)).pick.apply(_pojo, _toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_5__constants__["z" /* RECEIVING_CHECKLIST_QUESTIONS */])));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["C" /* Modal */],
    { open: open, close: close, dialogClass: "modal-md" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Receiving Checklist"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Form__["a" /* default */], { close: close, initialValues: initialValues, enableReinitialize: true })
  );
}

Edit.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  receivingRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    receivingRecord: state.receivingRecordDetail.get("receivingRecord").toJS()
  };
})(Edit));

/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Edit__ = __webpack_require__(1658);




/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["P" /* LaunchModal */], {
    modal: __WEBPACK_IMPORTED_MODULE_2__Edit__["a" /* default */],
    buttonClass: "btn-primary btn-hollow pull-right",
    text: "Edit"
  });
});

/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__validate__ = __webpack_require__(1661);









var renderChecklistQuestion = function renderChecklistQuestion(attr, getField, change) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_bootstrap__["d" /* Row */],
    { className: "row-col-gutters-half", key: attr },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_bootstrap__["e" /* Col */],
      { md: 1, className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        "label",
        { className: "control-label", htmlFor: attr },
        "Agree"
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", {
        type: "radio",
        name: attr,
        className: "radio-inline",
        checked: getField(attr),
        onChange: function onChange() {
          return change(attr, true);
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_bootstrap__["e" /* Col */],
      { md: 1, className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        "label",
        { className: "control-label", htmlFor: attr },
        "Disagree"
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", {
        type: "radio",
        name: attr,
        className: "radio-inline",
        checked: !getField(attr),
        onChange: function onChange() {
          return change(attr, false);
        }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_bootstrap__["e" /* Col */],
      { md: 10 },
      __WEBPACK_IMPORTED_MODULE_1__constants__["z" /* RECEIVING_CHECKLIST_QUESTIONS */][attr]
    ),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br", null),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br", null),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br", null)
  );
};

function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Body,
      null,
      Object.keys(__WEBPACK_IMPORTED_MODULE_1__constants__["z" /* RECEIVING_CHECKLIST_QUESTIONS */]).map(function (k) {
        return renderChecklistQuestion(k, props.getField, props.change);
      }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
            name: "question_checklist_change_reason",
            component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["l" /* TextArea */],
            rows: 5,
            label: "Change Reason",
            required: true
          })
        )
      )
    )
  );
}

var FORM_NAME = "editQuestionList";

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function (state) {
  return {
    getField: function getField(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["formValueSelector"])(FORM_NAME)(state, field);
    }
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return Promise.resolve(dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["c" /* update */])(data))).then(function () {
        return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["d" /* discrepanciesPageActions */].expire());
      });
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_7__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;



function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate("question_checklist_change_reason").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony export (immutable) */ __webpack_exports__["a"] = ForgiveDemerit;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









function ForgiveDemerit(_ref) {
  var receivingRecord = _ref.receivingRecord,
      onConfirm = _ref.onConfirm;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      confirmationIsVisible = _useState2[0],
      setConfirmationVisibility = _useState2[1];

  if (!receivingRecord.get("demerit")) {
    return false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setConfirmationVisibility(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "eraser", fixed: true }),
    "\xA0Forgive Demerit",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setConfirmationVisibility(false);
        },
        open: confirmationIsVisible,
        btnClass: "btn-danger",
        btnText: "Yes, Forgive Demerit",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to Forgive Demerit?"
    )
  );
}

ForgiveDemerit.propTypes = {
  receivingRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired,
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ForgiveDemerit__ = __webpack_require__(1662);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ForgiveDemerit__["a"]; });


/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_RecordPager__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_ActionDropDown_ActionDropDown__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_Authorized_Forbidden__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_Authorized_Authorized__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EditQCStatus_Form__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_shared_StatusTags__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Unreceive_Unreceive__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ForgiveDemerit__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions__ = __webpack_require__(115);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var HeaderBar = function (_React$Component) {
  _inherits(HeaderBar, _React$Component);

  function HeaderBar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HeaderBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HeaderBar.__proto__ || Object.getPrototypeOf(HeaderBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      modalOpen: false
    }, _this.onConfirmToForgiveDemeritClick = function () {
      var dispatch = _this.props.dispatch;


      dispatch(__WEBPACK_IMPORTED_MODULE_19__actions__["c" /* update */]({ demerit: false }));
    }, _this.toggleQCModal = function () {
      return _this.setState({ modalOpen: !_this.state.modalOpen });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HeaderBar, [{
    key: "render",
    value: function render() {
      var receivingRecord = this.props.receivingRecord;
      var modalOpen = this.state.modalOpen;

      var status = {
        qc_status: receivingRecord.getIn(["inventories", 0, __WEBPACK_IMPORTED_MODULE_13__inventories_constants__["_63" /* QC_STATUS */]])
      };
      var underReview = receivingRecord.toJS().inventories.some(function (i) {
        return i.qc_status === __WEBPACK_IMPORTED_MODULE_16__constants__["M" /* UNDER_REVIEW */];
      });
      var hasDiscrepancies = !receivingRecord.get("discrepancies_resolved");
      var referenceNumber = receivingRecord.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_6" /* REFERENCE_NUMBER */]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "page-header page-header-bar" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h1",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "btn-group pull-right", style: { marginLeft: 20 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__shared_components_ActionDropDown_ActionDropDown__["a" /* default */],
              {
                menuClass: "dropdown-menu-right",
                style: { cursor: "pointer" }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10__shared_components_Authorized_Forbidden__["a" /* default */],
                { roles: [__WEBPACK_IMPORTED_MODULE_9__users_constants__["j" /* WAREHOUSE */]] },
                receivingRecord.get("reference_record_line_item_type") !== "ManagedRepairOrderLineItem" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7__shared_components_DropDown_DropDownItem__["a" /* default */],
                  { onClick: this.toggleQCModal },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-pause-circle" }),
                  "\xA0Update QC Status"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Unreceive_Unreceive__["a" /* default */], { receivingRecord: receivingRecord }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11__shared_components_Authorized_Authorized__["a" /* default */],
                { roles: [__WEBPACK_IMPORTED_MODULE_9__users_constants__["p" /* QUALITY_CONTROL */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ForgiveDemerit__["a" /* default */], {
                  receivingRecord: receivingRecord,
                  onConfirm: this.onConfirmToForgiveDemeritClick
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "with-padding" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_RecordPager__["a" /* default */], { baseUrl: "/receiving", record: receivingRecord }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "header-content" },
              receivingRecord.get(__WEBPACK_IMPORTED_MODULE_12__constants__["z" /* CODE */])
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "small text-muted" },
              "Received: ",
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(receivingRecord.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_7" /* CREATED_AT */]))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "status-tags alert-group pull-right" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_shared_StatusTags__["a" /* default */], {
                hold: status.qc_status === __WEBPACK_IMPORTED_MODULE_16__constants__["N" /* QC_HOLD */],
                discrepancies: hasDiscrepancies,
                underReview: underReview
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["a" /* Modal */],
          {
            open: modalOpen,
            close: this.toggleQCModal,
            dialogClass: "modal-sm"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["c" /* Close */], { close: this.toggleQCModal }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Update QC Status"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__EditQCStatus_Form__["a" /* default */], {
            close: this.toggleQCModal,
            initialValues: status,
            receivingRecord: receivingRecord.toJS(),
            consignmentReference: receivingRecord.get(__WEBPACK_IMPORTED_MODULE_16__constants__["F" /* CONSIGNMENT_REFERENCE */]),
            referenceNumber: referenceNumber
          })
        )
      );
    }
  }]);

  return HeaderBar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

HeaderBar.propTypes = {
  receivingRecord: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]).isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])()(HeaderBar));

/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditQuestionsChecklist_EditButton__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip_AuditedNoteTooltip__ = __webpack_require__(104);
/* harmony export (immutable) */ __webpack_exports__["a"] = QuestionsChecklist;







function NoLabel() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label label-danger" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-warning" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "with-padding" },
      "No"
    )
  );
}
function YesLabel() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label label-success" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "with-padding" },
      "Yes"
    )
  );
}

function QuestionsChecklist(_ref) {
  var receivingRecord = _ref.receivingRecord;

  var showList = Object.keys(__WEBPACK_IMPORTED_MODULE_3__constants__["z" /* RECEIVING_CHECKLIST_QUESTIONS */]).some(function (key) {
    return typeof receivingRecord.get(key) === "boolean";
  });

  var renderRow = function renderRow(attr, questionText, record) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        record.get(attr) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(YesLabel, null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NoLabel, null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        questionText
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], { obj: record.toJS(), field: attr, placement: "left" })
      )
    );
  };

  if (!showList || receivingRecord.get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* RECEIVED_VIRTUALLY */]) && receivingRecord.get("reference_record_line_item_type") !== "InventoryTransferOrder" || receivingRecord.get(__WEBPACK_IMPORTED_MODULE_3__constants__["A" /* RECEIVING_TYPE */]) === __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* MISTAKE_SHIPMENT */]) return null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      { style: { marginTop: 10 } },
      "Receiving Inspection Checklist",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EditQuestionsChecklist_EditButton__["a" /* default */], null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */].Mini,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */].Head,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Response"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Question"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */].Body,
        null,
        Object.keys(__WEBPACK_IMPORTED_MODULE_3__constants__["z" /* RECEIVING_CHECKLIST_QUESTIONS */]).map(function (key) {
          return renderRow(key, __WEBPACK_IMPORTED_MODULE_3__constants__["z" /* RECEIVING_CHECKLIST_QUESTIONS */][key], receivingRecord);
        })
      )
    )
  );
}

QuestionsChecklist.propTypes = {
  receivingRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired
};

/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Orders_shared_ShippingAddress__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_components_DetailTable_Detail__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Edit_Form__ = __webpack_require__(1669);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var SideBar = function (_React$Component) {
  _inherits(SideBar, _React$Component);

  function SideBar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SideBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SideBar.__proto__ || Object.getPrototypeOf(SideBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editModalOpen: false
    }, _this.openEditModal = function () {
      return _this.setState({ editModalOpen: true });
    }, _this.closeEditModal = function () {
      return _this.setState({ editModalOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SideBar, [{
    key: "render",
    value: function render() {
      var receivingRecord = this.props.receivingRecord;
      var editModalOpen = this.state.editModalOpen;

      var editableFormValues = ["demerit", __WEBPACK_IMPORTED_MODULE_16__constants__["A" /* RECEIVING_TYPE */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["q" /* PART_ID */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["o" /* SERIAL_NUMBER */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_14__companies_constants__["t" /* DER */], __WEBPACK_IMPORTED_MODULE_14__companies_constants__["u" /* IMPERFECT_TRACE */], __WEBPACK_IMPORTED_MODULE_14__companies_constants__["a" /* IMPERFECT_TRACE_REASON */], __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_constants__["a" /* INCIDENT */], __WEBPACK_IMPORTED_MODULE_12__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_10__parts_constants__["G" /* DOM */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["y" /* EXPIRATION */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["x" /* TAG_DATE */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["p" /* TAGGED_BY */], __WEBPACK_IMPORTED_MODULE_12__constants__["W" /* AWB_NUMBER */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["_0" /* LOCATION */], __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["_2" /* MODIFIED */], __WEBPACK_IMPORTED_MODULE_10__parts_constants__["_32" /* PMA */], __WEBPACK_IMPORTED_MODULE_16__constants__["F" /* CONSIGNMENT_REFERENCE */], __WEBPACK_IMPORTED_MODULE_16__constants__["G" /* CONSIGNMENT_BUYER_ID */], __WEBPACK_IMPORTED_MODULE_16__constants__["H" /* CONSIGNMENT_CO_BUYER_ID */], __WEBPACK_IMPORTED_MODULE_16__constants__["I" /* CONSIGNOR_PERCENTAGE */], __WEBPACK_IMPORTED_MODULE_16__constants__["b" /* RECEIVED_VIRTUALLY */]];

      var editInitialValues = editableFormValues.reduce(function (acc, item) {
        acc[item] = receivingRecord.get(item);
        return acc;
      }, {
        read_only_consignment: receivingRecord.get(__WEBPACK_IMPORTED_MODULE_16__constants__["F" /* CONSIGNMENT_REFERENCE */])
      });
      var inventoryId = receivingRecord.getIn(["inventories", 0, __WEBPACK_IMPORTED_MODULE_12__constants__["c" /* UUID */]]);
      var receivingType = receivingRecord.get(__WEBPACK_IMPORTED_MODULE_16__constants__["A" /* RECEIVING_TYPE */]);

      var tagFields = ["pma", "asa", "faa", "easa", "uk_caa", "caac", "tcca"];
      var renderedFields = tagFields.filter(function (field) {
        return receivingRecord.get(field) === true;
      }).map(function (field) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { key: field, className: "badge", style: { marginRight: "5px" } },
          field.replace("_", " ").toUpperCase()
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "panel panel-default" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "panel-body" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              { style: { marginTop: 10 } },
              "Part Details",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["y" /* EditButton */], { handleClick: this.openEditModal })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["a" /* Modal */],
              {
                open: editModalOpen,
                close: this.closeEditModal,
                dialogClass: "modal-md"
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["b" /* Header */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["c" /* Close */], { close: this.closeEditModal }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  { className: "modal-title" },
                  "Edit Details"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Edit_Form__["a" /* default */], {
                close: this.closeEditModal,
                initialValues: editInitialValues,
                receivingType: receivingType,
                selectedPart: receivingRecord.get(__WEBPACK_IMPORTED_MODULE_10__parts_constants__["B" /* PART */]).toJS(),
                receivingRecord: receivingRecord.toJS(),
                taggedBy: receivingRecord.get(__WEBPACK_IMPORTED_MODULE_9__inventories_constants__["p" /* TAGGED_BY */])
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "table",
              { className: "table table-condensed" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tbody",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "Part #"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["h" /* PartNumber */], { part: receivingRecord.toJS().part })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "Part Desc."
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    receivingRecord.getIn(["part", "description"])
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "Serial #"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    inventoryId ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "a",
                      { href: "/inventories/" + inventoryId },
                      receivingRecord.get(__WEBPACK_IMPORTED_MODULE_9__inventories_constants__["o" /* SERIAL_NUMBER */])
                    ) : receivingRecord.get(__WEBPACK_IMPORTED_MODULE_9__inventories_constants__["o" /* SERIAL_NUMBER */])
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "Receiving Type"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    __WEBPACK_IMPORTED_MODULE_16__constants__["J" /* RECEIVING_TYPES */][receivingType].label
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "Received From"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["e" /* truncate */])(receivingRecord.toJS().company_name, 19)
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "REF #"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "a",
                      {
                        href: "/" + __WEBPACK_IMPORTED_MODULE_16__constants__["J" /* RECEIVING_TYPES */][receivingType].link + "/" + (receivingRecord.getIn(["reference_record", __WEBPACK_IMPORTED_MODULE_12__constants__["c" /* UUID */]]) || receivingRecord.get("reference_record_id"))
                      },
                      receivingRecord.get("reference_number")
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "AWB #"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    receivingRecord.get("awb_number")
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed hr-xs" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "table",
              { className: "table table-condensed" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tbody",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "Created By"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    receivingRecord.getIn(["created_by", "full_name"])
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "Buyer/Seller"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    receivingRecord.getIn(["buyer", "full_name"])
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed hr-xs" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "table",
              { className: "table table-condensed" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tbody",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "Store LOC"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    receivingRecord.get("store_location")
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "LOC"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    receivingRecord.get("location")
                  )
                ),
                receivingRecord.getIn(["ware_house", "name"]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__shared_components_DetailTable_Detail__["a" /* default */], {
                  label: "Warehouse",
                  value: receivingRecord.getIn(["ware_house", "name"])
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed hr-xs" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "table",
              { className: "table table-condensed" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tbody",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "CD Rec."
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    __WEBPACK_IMPORTED_MODULE_16__constants__["x" /* CONDITION_TYPES */][receivingRecord.get("condition")].label
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "QTY Rec."
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    receivingRecord.get("quantity")
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "DOM"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["h" /* monthFullYear */])(receivingRecord.get("dom"))
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "EXP"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["b" /* shortDate */])(receivingRecord.get("expiration"))
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "Tag Date"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["g" /* monthYear */])(receivingRecord.get("tag_date"))
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "Tagged By"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    receivingRecord.get("tagged_by")
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "Tag Types"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    renderedFields
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed hr-xs" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "table",
              { className: "table table-condensed" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tbody",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "th",
                    { className: "text-right" },
                    "Consignment Ref #"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    receivingRecord.toJS().consignment ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
                      {
                        to: "/consignments/" + receivingRecord.toJS().consignment.uuid
                      },
                      receivingRecord.get("consignment_reference")
                    ) : receivingRecord.get("consignment_reference")
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Orders_shared_ShippingAddress__["a" /* default */], {
              shippingType: "ship_to",
              record: receivingRecord,
              renderPreferences: false
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["z" /* AuditFields */], { record: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(receivingRecord), multiLine: true })
          )
        )
      );
    }
  }]);

  return SideBar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (SideBar);


SideBar.propTypes = {
  receivingRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
};

/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);










function Unreceive(_ref) {
  var unreceive = _ref.unreceive,
      unreceiving = _ref.unreceiving,
      open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components__["l" /* DropDownItem */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["k" /* Icon */], { name: "undo", fixed: true }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "with-padding" },
      "Unreceive"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components__["i" /* ConfirmAction */],
      { onConfirm: unreceive, close: close, open: unreceiving },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up! "
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        "Are you sure you want to unreceive this record?"
      )
    )
  );
}

Unreceive.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  unreceive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  unreceiving: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var withUnreceive = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var receivingRecord = _ref2.receivingRecord,
      close = _ref2.close,
      pushHistory = _ref2.pushHistory;
  return {
    unreceive: function unreceive() {
      return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].receivingRecord.unreceive(receivingRecord.get("id")).then(function () {
        pushHistory({ pathname: "/receiving" });
        close();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Error", __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(error, "errors.base[0]"));
      });
    }
  };
});

var unreceive = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["e" /* toggleSwitch */])("unreceiving")(withUnreceive(Unreceive));

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(unreceive));

/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Detail__ = __webpack_require__(1645);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Detail__["a"]; });



/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DashedSeparator_DashedSeparator__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_AutoCompleteField_AutoCompleteField__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parts_actions_actions__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_MonthYearField_MonthYearField__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PurchaseOrders_shared_CoBuyersFields_BuyerField__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__PurchaseOrders_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__validate__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions__ = __webpack_require__(115);
/* unused harmony export Form */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



























var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedPart: {},
      selectedTaggedBy: _this.props.taggedBy
    }, _this.setTaggedBy = function (company) {
      _this.setState({ selectedTaggedBy: company });
    }, _this.handlePartSelected = function (part) {
      _this.setState({ selectedPart: part });
    }, _this.searchCompanies = function (filter) {
      return __WEBPACK_IMPORTED_MODULE_19__api__["a" /* default */].companies.search({
        filter: filter,
        status: [__WEBPACK_IMPORTED_MODULE_20__companies_constants__["c" /* ACTIVE */], __WEBPACK_IMPORTED_MODULE_20__companies_constants__["d" /* CREDIT_HOLD */]].join(","),
        page: 1,
        limit: 20
      }).then(function (resp) {
        return resp.data.results;
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.selectedPart) {
        var state = { selectedPart: this.props.selectedPart };

        if (this.props.receivingRecord) {
          state.selectedConsignmentBuyer = this.props.receivingRecord[__WEBPACK_IMPORTED_MODULE_10__constants__["K" /* CONSIGNMENT_BUYER */]];
          state.selectedConsignmentCoBuyer = this.props.receivingRecord[__WEBPACK_IMPORTED_MODULE_10__constants__["L" /* CONSIGNMENT_CO_BUYER */]];

          state.selectedConsignor = this.props.receivingRecord[__WEBPACK_IMPORTED_MODULE_10__constants__["w" /* CONSIGNMENT_REFERENCE_COMPANY */]];
        }

        this.setState(state);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          queryParts = _props.queryParts,
          condition = _props.condition,
          currentUser = _props.currentUser,
          getFieldValue = _props.getFieldValue,
          receivingType = _props.receivingType;
      var _state = this.state,
          selectedPart = _state.selectedPart,
          selectedConsignor = _state.selectedConsignor,
          selectedConsignmentBuyer = _state.selectedConsignmentBuyer,
          selectedConsignmentCoBuyer = _state.selectedConsignmentCoBuyer,
          selectedTaggedBy = _state.selectedTaggedBy;

      var isBasicWarehouseUser = currentUser.get(__WEBPACK_IMPORTED_MODULE_11__users_constants__["h" /* ROLE */]) === __WEBPACK_IMPORTED_MODULE_11__users_constants__["j" /* WAREHOUSE */] && currentUser.get(__WEBPACK_IMPORTED_MODULE_11__users_constants__["C" /* SUBROLE */]) === __WEBPACK_IMPORTED_MODULE_11__users_constants__["r" /* WAREHOUSE_BASIC */];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h2",
            null,
            "Verify Part Details"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_10__constants__["A" /* RECEIVING_TYPE */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_10__constants__["J" /* RECEIVING_TYPES */]),
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__constants__["A" /* RECEIVING_TYPE */]),
                required: true,
                disabled: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 5 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["q" /* PART_ID */],
                label: "Part #",
                placeholder: "Type a part's number...",
                component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_AutoCompleteField_AutoCompleteField__["a" /* default */],
                search: queryParts,
                selectedItem: selectedPart,
                formatItem: function formatItem(result) {
                  return result && result.part_number;
                },
                onItemSelected: function onItemSelected(i) {
                  return i && _this2.handlePartSelected(i);
                },
                disabled: isBasicWarehouseUser,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["o" /* SERIAL_NUMBER */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                label: "Serial #",
                disabled: isBasicWarehouseUser
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["n" /* CONDITION */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_10__constants__["x" /* CONDITION_TYPES */]),
                label: "Condition Received",
                required: true,
                disabled: isBasicWarehouseUser
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_15__constants__["j" /* QUANTITY */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                label: "Qty Received",
                required: true,
                disabled: isBasicWarehouseUser
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_MonthYearField_MonthYearField__["a" /* default */], {
                  name: __WEBPACK_IMPORTED_MODULE_16__parts_constants__["G" /* DOM */],
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                  label: __WEBPACK_IMPORTED_MODULE_16__parts_constants__["G" /* DOM */].toUpperCase(),
                  disabled: isBasicWarehouseUser
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["y" /* EXPIRATION */],
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                  type: "date",
                  label: "Exp",
                  disabled: isBasicWarehouseUser
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_MonthYearField_MonthYearField__["a" /* default */], {
                name: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["x" /* TAG_DATE */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["x" /* TAG_DATE */]),
                required: __WEBPACK_IMPORTED_MODULE_10__constants__["u" /* TAG_DATE_CONDITIONS */].includes(condition),
                disabled: isBasicWarehouseUser
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["s" /* AutoCompleteUserInputField */],
                disabled: isBasicWarehouseUser,
                formatItem: function formatItem(result) {
                  return result && result.name || result;
                },
                handleTaggedBy: function handleTaggedBy(item) {
                  return _this2.setTaggedBy(item);
                },
                selectedItem: selectedTaggedBy,
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["p" /* TAGGED_BY */]),
                name: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["p" /* TAGGED_BY */],
                placeholder: "Search by a company's name",
                search: this.searchCompanies
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: __WEBPACK_IMPORTED_MODULE_15__constants__["W" /* AWB_NUMBER */], component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */], label: "AWB #" })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["_0" /* LOCATION */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["_0" /* LOCATION */]),
                required: true,
                disabled: isBasicWarehouseUser
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: "read_only_consignment",
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                label: "Consignment #",
                disabled: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
                { checkGroupStyles: { marginTop: 0 }, justified: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: "demerit",
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                  label: "Escalate Discrepancy"
                })
              )
            )
          ),
          [__WEBPACK_IMPORTED_MODULE_10__constants__["s" /* EMA */], __WEBPACK_IMPORTED_MODULE_10__constants__["t" /* CONSIGNMENT */]].includes(receivingType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_10__constants__["v" /* CONSIGNMENT_REFERENCE_COMPANY_ID */],
                label: "Consignment Ref Co.",
                placeholder: "Search by a company's name",
                component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_AutoCompleteField_AutoCompleteField__["a" /* default */],
                onItemSelected: function onItemSelected(item) {
                  return _this2.setState({ selectedConsignor: item });
                },
                search: this.searchCompanies,
                selectedItem: selectedConsignor,
                formatItem: function formatItem(result) {
                  return result && result.name;
                },
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["h" /* FormGroup */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  label: "Consignor %",
                  name: __WEBPACK_IMPORTED_MODULE_10__constants__["I" /* CONSIGNOR_PERCENTAGE */],
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                  type: "number",
                  inputProps: {
                    min: 0,
                    max: 100
                  },
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["h" /* FormGroup */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__PurchaseOrders_shared_CoBuyersFields_BuyerField__["a" /* default */], {
                  label: "Cons. Buyer Credit",
                  name: __WEBPACK_IMPORTED_MODULE_10__constants__["G" /* CONSIGNMENT_BUYER_ID */],
                  searchBuyers: this.props.searchBuyers,
                  selectedBuyer: selectedConsignmentBuyer,
                  onItemSelected: function onItemSelected(item) {
                    return _this2.setState({ selectedConsignmentBuyer: item });
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["h" /* FormGroup */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__PurchaseOrders_shared_CoBuyersFields_BuyerField__["a" /* default */], {
                  label: "Cons. Co Buyer Credit",
                  name: __WEBPACK_IMPORTED_MODULE_10__constants__["H" /* CONSIGNMENT_CO_BUYER_ID */],
                  required: false,
                  searchBuyers: this.props.searchBuyers,
                  selectedBuyer: selectedConsignmentCoBuyer,
                  onItemSelected: function onItemSelected(item) {
                    return _this2.setState({ selectedConsignmentCoBuyer: item });
                  }
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: getFieldValue(__WEBPACK_IMPORTED_MODULE_20__companies_constants__["u" /* IMPERFECT_TRACE */]) ? 9 : 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
                { justified: true, title: "Flags" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_20__companies_constants__["u" /* IMPERFECT_TRACE */],
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_20__companies_constants__["u" /* IMPERFECT_TRACE */])
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: "der", component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */], label: "DER" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: "pma", component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */], label: "PMA" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: "modified", component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */], label: "Modified" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: "incident", component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */], label: "Incident" })
              )
            ),
            getFieldValue(__WEBPACK_IMPORTED_MODULE_20__companies_constants__["u" /* IMPERFECT_TRACE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_20__companies_constants__["a" /* IMPERFECT_TRACE_REASON */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["_62" /* IMPERFECT_TRACE_REASONS */]),
                label: "Imperfect Trace Reason"
              })
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}),
  queryParts: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  condition: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  receivingType: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  receivingRecord: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}),
  searchBuyers: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  selectedPart: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    part_number: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
  })
};

var FORM_NAME = "editReceivingRecord";

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_11__users_constants__["a" /* USER */]),
    condition: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])(FORM_NAME)(state, __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["n" /* CONDITION */])
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_24__actions__["c" /* update */](data));
    },
    queryParts: function queryParts(filter) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__parts_actions_actions__["n" /* searchParts */])(filter));
    },
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_18__PurchaseOrders_actions__["c" /* searchBuyers */](filter));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_23__validate__["a" /* default */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(34);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;






function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["A" /* RECEIVING_TYPE */], __WEBPACK_IMPORTED_MODULE_2__inventories_constants__["q" /* PART_ID */], __WEBPACK_IMPORTED_MODULE_2__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_3__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_2__inventories_constants__["_0" /* LOCATION */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_submission__ = __webpack_require__(49);













var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = searchProps.paginator.get("filters").toJS();
  var totalCount = searchProps.paginator.get("totalCount");

  params.total_count = totalCount;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        if (totalCount > __WEBPACK_IMPORTED_MODULE_10__users_constants__["_6" /* EXPORT_LIMIT */]) {
          __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__["toastr"].info("Processing Report.");
          __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].receivingRecord.export(params).then(function () {
            return __WEBPACK_IMPORTED_MODULE_11__lib_submission__["a" /* SUCCESS */];
          });
        } else {
          window.open(__WEBPACK_IMPORTED_MODULE_7__constants__["d" /* API_BASE */] + "/receiving_records/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_query_string__["stringify"])(params), "_blank");
          __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__["toastr"].success("Processing Receiving Report. Please wait for the PDF to generate.");
        }
      }
    },
    "Export"
  );
};

ExportButton.propTypes = {
  searchProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    paginator: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map)
  })
};

var meetsExportCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var searchProps = _ref2.searchProps;

  var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks_useCurrentUser__["a" /* default */])();
  return searchProps.paginator.get("totalCount") <= 450 || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__users_helpers__["d" /* hasRole */])(user, __WEBPACK_IMPORTED_MODULE_10__users_constants__["i" /* ADMIN */]);
});

var DecoratedExportButton = meetsExportCriteria(ExportButton);

/* harmony default export */ __webpack_exports__["a"] = (DecoratedExportButton);

/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_DateRangePicker_DateRangePicker__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ExportButton__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Table__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pagination__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions__ = __webpack_require__(115);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

















var filters = [{
  label: "My Received Orders",
  filters: { current_user_buyer: true }
}, {
  label: "Awaiting QC Review",
  filters: { qc_status: "under_review" }
}, {
  label: "Active QC Holds",
  filters: { qc_status: "qc_hold" }
}, {
  label: "Active Discrepancies",
  filters: { all_discrepancies: undefined, open_discrepancies: true }
}, {
  label: "Consignments",
  filters: { consignment: true }
}, {
  label: "EMAs",
  filters: { ema: true }
}, {
  label: "Show Partially Received",
  filters: { partially_received: true }
}, {
  label: "All ROs",
  filters: { receiving_type: "ro" }
}, {
  label: "All SOs",
  filters: { receiving_type: "so" }
}, {
  label: "All POs",
  filters: { receiving_type: "po" }
}, {
  label: "All LPOs",
  filters: { receiving_type: "lot_line_item" }
}, {
  label: "All RMAs",
  filters: { receiving_type: "rma" }
}, {
  label: "All Demerits",
  filters: { active_demerits: true }
}, {
  label: "All Discrepancies",
  filters: { all_discrepancies: true, open_discrepancies: undefined }
}, {
  label: "Missing ECCN",
  filters: { missing_eccn: true }
}, {
  label: "Received By Me",
  filters: { current_user: true }
}, {
  label: "Reserved For Sale",
  filters: { purchase_for_sale: true }
}, {
  label: "Dropshipments",
  filters: { dropshipment: true },
  hr: true
}, {
  label: __WEBPACK_IMPORTED_MODULE_9__constants__["_37" /* CLEAR_FILTERS_TEXT */],
  filters: {
    all_discrepancies: undefined,
    current_user: undefined,
    current_user_buyer: undefined,
    consignment: undefined,
    dropshipment: undefined,
    ema: undefined,
    end_date: undefined,
    qc_hold: undefined,
    qc_status: undefined,
    open_discrepancies: undefined,
    receiving_type: undefined,
    store_location: undefined,
    active_demerits: undefined,
    start_date: undefined,
    store_location_id: undefined,
    missing_eccn: undefined,
    partially_received: undefined,
    purchase_for_sale: undefined
  }
}];

var filterTags = [{
  label: "All Discrepancies",
  key: "all_discrepancies"
}, {
  label: "Received By Me",
  key: "current_user"
}, {
  label: "My Received Orders",
  key: "current_user_buyer"
}, {
  label: "Active Discrepancies",
  key: "open_discrepancies"
}, {
  label: "Awaiting QC Review",
  key: "qc_status",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_filters__["b" /* matchesString */])("under_review")
}, {
  label: "Show Partially Received",
  key: "partially_received"
}, {
  label: "All ROs",
  key: "receiving_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_filters__["b" /* matchesString */])("ro")
}, {
  label: "All SOs",
  key: "receiving_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_filters__["b" /* matchesString */])("so")
}, {
  label: "All POs",
  key: "receiving_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_filters__["b" /* matchesString */])("po")
}, {
  label: "All LPOs",
  key: "receiving_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_filters__["b" /* matchesString */])("lot_line_item")
}, {
  label: "All RMAs",
  key: "receiving_type",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_filters__["b" /* matchesString */])("rma")
}, {
  label: "Consignment",
  key: "consignment"
}, {
  label: "EMA",
  key: "ema"
}, {
  label: "Active QC Holds",
  key: "qc_status",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["S" /* QC_HOLD */])
}, {
  label: "Missing ECCN",
  key: "missing_eccn"
}, {
  label: "Dropshipments",
  key: "dropshipment"
}, {
  label: "Reserved For Sale",
  key: "purchase_for_sale"
}];

function ReceivingRecordsSearch(_ref) {
  var pushHistory = _ref.pushHistory,
      subscribeToReceivingChannel = _ref.subscribeToReceivingChannel,
      unsubscribeToReceivingChannel = _ref.unsubscribeToReceivingChannel;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__hooks_useCurrentUser__["a" /* default */])();

  var filtersWithLocation = currentUser.locations.map(function (l) {
    return {
      label: "Store Location = " + l.name,
      filters: { store_location_id: l.id }
    };
  });

  var filterTagsWithLocation = currentUser.locations.map(function (l) {
    return {
      label: "Store Location = " + l.name,
      key: __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_27" /* STORE_LOCATION_ID */],
      matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_filters__["b" /* matchesString */])(l.id)
    };
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    subscribeToReceivingChannel();

    return function cleanup() {
      unsubscribeToReceivingChannel();
    };
  }, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_13__pagination__["a" /* receivingRecordsSearch */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a part number, company name, serial number, received date or any ref. number...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/receiving/" + r.uuid);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ExportButton__["a" /* default */], { searchProps: searchProps }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_DateRangePicker_DateRangePicker__["a" /* default */], searchProps),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
              filters: filtersWithLocation.concat(filters),
              right: true
            }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "Received Orders",
          filters: filterTagsWithLocation.concat(filterTags)
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

ReceivingRecordsSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    subscribeToReceivingChannel: function subscribeToReceivingChannel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions__["j" /* subscribe */])());
    },
    unsubscribeToReceivingChannel: function unsubscribeToReceivingChannel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions__["k" /* unsubscribe */])());
    },
    pushHistory: function pushHistory(path) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"])(path));
    }
  };
})(ReceivingRecordsSearch));

/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_decorators_translateProps__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_shared_StatusTags__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_LocationFlag_LocationFlag__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__inventories_components_Search_BuildLink__ = __webpack_require__(2113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__ = __webpack_require__(11);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


















function BasicRow(_ref) {
  var record = _ref.record,
      statuses = _ref.statuses,
      handleClick = _ref.handleClick;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { className: "clickable", onClick: handleClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_date__["b" /* shortDate */])(record.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_10__constants__["J" /* RECEIVING_TYPES */][record.receiving_type].label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["w" /* CompanyName */], { flattenedCompany: record, truncateAt: 18 })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["d" /* getFirstNameLastInitial */])(record.created_by.full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components_LocationFlag_LocationFlag__["a" /* default */], { location: record.store_location_id })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["h" /* PartNumber */], { part: record.part })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.inventories.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          to: "/inventories/" + record.inventories[0].uuid
        },
        record.serial_number
      ) : record.serial_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["e" /* truncate */])(record.part.description, 14)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__inventories_components_Search_BuildLink__["a" /* default */], record),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_10__constants__["x" /* CONDITION_TYPES */][record.condition].abbrev
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      record.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.awb_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.reference_record_invoice_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_shared_StatusTags__["a" /* default */], statuses)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], {
      note: record.discrepancies[record.discrepancies.length - 1] && record.discrepancies[record.discrepancies.length - 1].reason
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], {
      note: record.discrepancies[record.discrepancies.length - 1] && record.discrepancies[record.discrepancies.length - 1].reason_for_resolution
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], { note: record.minor_note })
  );
}

BasicRow.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}),
  statuses: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}),
  handleClick: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

var statuses = function statuses(record) {
  return {
    discrepancies: record.inventories.some(function (i) {
      return !i.discrepancies_resolved;
    }),
    hold: record.inventories.some(function (i) {
      return i.qc_status === __WEBPACK_IMPORTED_MODULE_10__constants__["N" /* QC_HOLD */];
    }),
    underReview: record.inventories.some(function (i) {
      return i.qc_status === __WEBPACK_IMPORTED_MODULE_10__constants__["M" /* UNDER_REVIEW */];
    })
  };
};

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_decorators_translateProps__["a" /* default */])(function (_ref2) {
  var record = _ref2.record,
      pushHistory = _ref2.pushHistory;
  return {
    statuses: _extends({}, statuses(record)),
    handleClick: function handleClick() {
      return pushHistory("/receiving/" + record.uuid);
    }
  };
});

var Row = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"] })(withProps(BasicRow));

function Table(_ref3) {
  var results = _ref3.results,
      isLoading = _ref3.isLoading;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */],
    { loading: isLoading },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "REC #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "REC Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Type"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Company"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Receiver Name"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Store Loc"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Description"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "REF #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "COND Rec"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "QTY Rec"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "AWB #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Inv #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Status"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Discr"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Resol"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Note"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (record) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row, { key: record.id, record: record });
      })
    )
  );
}

Table.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired
  })).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired
};

var Decorated = __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__["decorators"].tabulate(Table);

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Decorated, { listId: "receivingRecords" });
});

/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_reducer__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(687);
/* unused harmony export initialState */
var _extends2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  receivingRecord: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  discrepancies: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()
}).merge(__WEBPACK_IMPORTED_MODULE_2__shared_reducer__["b" /* attachmentsInitialState */]).merge(__WEBPACK_IMPORTED_MODULE_2__shared_reducer__["a" /* notesInitialState */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _extends((_extends2 = {}, _defineProperty(_extends2, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* SET */], function (state, action) {
  return state.merge({ receivingRecord: action.receivingRecord });
}), _defineProperty(_extends2, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["e" /* SET_INVENTORY */], function (state, action) {
  return state.mergeDeep({
    receivingRecord: { inventory: action.inventory }
  });
}), _defineProperty(_extends2, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["b" /* SET_DISCREPANCIES */], function (state, action) {
  return state.merge({ discrepancies: action.discrepancies });
}), _defineProperty(_extends2, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["d" /* REMOVE_DISCREPANCIES */], function (state, _) {
  return state.merge({ discrepancies: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])() });
}), _defineProperty(_extends2, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["c" /* SET_MODAL */], function (state, action) {
  return state.mergeDeep({ receivingRecord: { showModal: action.showModal } });
}), _extends2), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_reducer__["c" /* createAttachmentReducer */])(__WEBPACK_IMPORTED_MODULE_3__shared_types_resourceTypes__["a" /* default */].receivingRecord), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_reducer__["d" /* createNoteReducer */])(__WEBPACK_IMPORTED_MODULE_3__shared_types_resourceTypes__["a" /* default */].receivingRecord))));

/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators_loadRecord__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Orders_shared_ShippingPreference__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ShipTo__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DetailsTable__ = __webpack_require__(1676);












function Detail(_ref) {
  var rejectedCore = _ref.rejectedCore;

  var parsedRejectedCore = rejectedCore.toJS();
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "page-header page-header-bar" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h1",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "with-padding" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["J" /* RecordPager */], { baseUrl: "/rejected-cores", record: rejectedCore }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "header-content" },
            rejectedCore.get(__WEBPACK_IMPORTED_MODULE_6__constants__["z" /* CODE */])
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["E" /* ClipboardCopy */], { name: rejectedCore.get(__WEBPACK_IMPORTED_MODULE_6__constants__["z" /* CODE */]), type: "Rejected Core" })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "panel panel-default" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "panel-body" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__DetailsTable__["a" /* DetailsTable */], { rejectedCore: parsedRejectedCore }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ShipTo__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Orders_shared_ShippingPreference__["a" /* ShippingPreference */], {
            shippingMethod: parsedRejectedCore.shipping_method
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["z" /* AuditFields */], { record: rejectedCore, multiLine: true })
        )
      )
    )
  );
}

Detail.propTypes = {
  rejectedCore: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Map)
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    rejectedCore: state.rejectedCoreDetail.get("rejectedCore")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators_loadRecord__["a" /* default */])({
  reducer: "rejectedCoreDetail",
  name: "rejectedCore",
  action: __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* show */]
})(Detail)));

/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__ = __webpack_require__(21);
/* harmony export (immutable) */ __webpack_exports__["a"] = DetailsTable;





function DetailsTable(_ref) {
  var rejectedCore = _ref.rejectedCore;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components__["X" /* Section */],
    { title: "Details", editable: false },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components__["W" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "Part", value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["h" /* PartNumber */], { part: rejectedCore.part }) }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "Serial #", value: rejectedCore.serial_number }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "Qty", value: rejectedCore.quantity }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], {
        label: "Received Date",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__["b" /* shortDate */])(rejectedCore.created_at)
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["S" /* Detail */], { label: "Location", value: rejectedCore.location })
    )
  );
}

DetailsTable.propTypes = {
  rejectedCore: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    created_at: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    serial_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Orders_shared_ShippingAddress__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_PhysicalAddress_PhysicalAddress__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ShipToForm__ = __webpack_require__(1678);
/* harmony export (immutable) */ __webpack_exports__["a"] = ShipTo;










function ShipTo() {
  var rejectedCore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hooks__["d" /* useRejectedCore */])();

  var initialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_pojos__["a" /* default */])(rejectedCore).pick(__WEBPACK_IMPORTED_MODULE_7__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_7__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_7__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_7__constants__["_17" /* SHIP_TO_SHIPPING_ADDRESS */], __WEBPACK_IMPORTED_MODULE_7__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */]);

  var renderForm = function renderForm(close) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ShipToForm__["a" /* default */], {
      close: close,
      rejectedCore: rejectedCore,
      initialValues: initialValues
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Section__["a" /* default */],
    {
      title: "Ship To",
      modal: {
        title: "Edit Shipping",
        content: renderForm
      },
      editable: !rejectedCore.shipped
    },
    !rejectedCore.ship_to_type && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_PhysicalAddress_PhysicalAddress__["a" /* PhysicalAddress */], { address: {} }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Orders_shared_ShippingAddress__["a" /* default */], { shippingType: __WEBPACK_IMPORTED_MODULE_7__constants__["B" /* SHIP_TO */], record: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(rejectedCore) })
  );
}

/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ShippingSection__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SalesOrders_components_shared_FormSections_ShippingSection__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hooks_useRejectedCore__ = __webpack_require__(624);
/* unused harmony export Form */










function Form(props) {
  var rejectedCore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks_useRejectedCore__["a" /* default */])();
  var shipToOptions = [{
    text: "Company",
    value: __WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingSection_shippingTypes__["d" /* COMPANY */]
  }, {
    text: "Other",
    value: __WEBPACK_IMPORTED_MODULE_7__shared_components_ShippingSection_shippingTypes__["e" /* DROPSHIP */]
  }];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        null,
        "Ship To"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_ShippingSection__["a" /* ShippingSection */], {
        shippingType: "ship_to",
        shipToOptions: shipToOptions,
        shipToCompany: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(rejectedCore.ship_to_company)
      })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, {
  onSubmit: __WEBPACK_IMPORTED_MODULE_6__actions__["b" /* update */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["j" /* form */])({
  form: "rejectedCoreShipToDetails",
  validate: __WEBPACK_IMPORTED_MODULE_5__SalesOrders_components_shared_FormSections_ShippingSection__["b" /* validate */]
})(Form)));

/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pagination__ = __webpack_require__(693);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










function RejectedCoreSearch(_ref) {
  var pushHistory = _ref.pushHistory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_7__pagination__["a" /* default */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a company name, part # or serial #...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/rejected-cores/" + r.id);
              }
            }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Rejected Cores"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

RejectedCoreSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_1_react_router_redux__["push"] })(RejectedCoreSearch));

/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators_translateProps__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shipping_constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_LocationFlag__ = __webpack_require__(351);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














function BasicRow(_ref) {
  var record = _ref.record,
      handleClick = _ref.handleClick;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { className: "clickable", onClick: handleClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__["b" /* shortDate */])(record.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-center" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_LocationFlag__["a" /* default */], { location: record.store_location_id })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(record, "company.name")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["h" /* PartNumber */], { part: record.part })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.serial_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.condition_received && __WEBPACK_IMPORTED_MODULE_9__Shipping_constants__["k" /* CONDITIONS */][record.condition_received].label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      record.location
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      record.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["e" /* truncate */])(record.incoming_awb_number, 14)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["e" /* truncate */])(record.outgoing_awb_number, 14)
    )
  );
}

BasicRow.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  statuses: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  handleClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators_translateProps__["a" /* default */])(function (_ref2) {
  var record = _ref2.record,
      pushHistory = _ref2.pushHistory;
  return {
    handleClick: function handleClick() {
      return pushHistory("/rejected-cores/" + record.uuid);
    }
  };
});

var Row = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(withProps(BasicRow));

function Table(_ref3) {
  var isLoading = _ref3.isLoading,
      pageActions = _ref3.pageActions,
      results = _ref3.results;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */],
    { loading: isLoading, refresh: pageActions.expire },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "RC #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "REC Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-center" },
          "Store Loc"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Company"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Cond Rec"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Location"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "QTY Rec"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Incoming Awb #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Outgoing Awb #"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (record) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row, { key: record.id, record: record });
      })
    )
  );
}

Table.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(Table));

/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(691);
/* unused harmony export initialState */
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  rejectedCore: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* SET */], function (state, action) {
  return state.merge({ rejectedCore: action.rejectedCore });
})));

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_DataTables_DataTable__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_format__ = __webpack_require__(144);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();






/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState4 = _slicedToArray(_useState3, 2),
      results = _useState4[0],
      setResults = _useState4[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].inventories.statsPerBuyer().then(function (_ref) {
      var data = _ref.data;

      setResults(data);
      setLoading(false);
    });
    return function cleanup() {};
  }, []);

  var totalSrp = results.reduce(function (total, row) {
    return total + Number(row.total_srp_buyer_credit);
  }, 0);

  var totalSellableSrp = results.reduce(function (total, row) {
    return total + Number(row.total_sellable_srp_buyer_credit);
  }, 0);

  var totalPns = results.reduce(function (total, row) {
    return total + Number(row.total_pn_count);
  }, 0);

  var totalUniquePns = results.reduce(function (total, row) {
    return total + Number(row.total_unique_pn_count);
  }, 0);

  var totalCost = results.reduce(function (total, row) {
    return total + Number(row.total_buyer_credit);
  }, 0);

  var totalSellableCost = results.reduce(function (total, row) {
    return total + Number(row.total_sellable_buyer_credit);
  }, 0);

  var totalRow = {
    full_name: "Total",
    total_buyer_credit: totalCost,
    total_pn_count: totalPns,
    total_sellable_buyer_credit: totalSellableCost,
    total_sellable_srp_buyer_credit: totalSellableSrp,
    total_srp_buyer_credit: totalSrp,
    total_unique_pn_count: totalUniquePns
  };

  var getPercentOfCost = function getPercentOfCost(row) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_format__["d" /* percent */])(Number(row.total_buyer_credit) / Number(totalCost) * 100);
  };

  var getProfitMargin = function getProfitMargin(row) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_format__["d" /* percent */])((Number(row.total_srp_buyer_credit) - Number(row.total_buyer_credit)) / Number(row.total_srp_buyer_credit) * 100);
  };

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "h2",
    null,
    "Remaining Inventory Totals"
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components_DataTables_DataTable__["a" /* default */],
    { loading: loading },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components_DataTables_DataTable__["a" /* default */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Name"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "% Cost of Total Inventory"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "% Potential Profit Margin"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Total PN Count"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Total Unique PNs"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Remaining Inventory Credit"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Remaining Inventory Credit - Sellable"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Remaining Inventory SRPs"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Remaining Inventory SRPs - Sellable"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components_DataTables_DataTable__["a" /* default */].Body,
      null,
      results && results.concat(totalRow).map(function (r) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            r.full_name
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-center" },
            getPercentOfCost(r)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-center" },
            getProfitMargin(r)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-center" },
            r.total_pn_count
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            r.total_unique_pn_count
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_format__["b" /* dollar */])(r.total_buyer_credit)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-center" },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_format__["b" /* dollar */])(r.total_sellable_buyer_credit)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_format__["b" /* dollar */])(r.total_srp_buyer_credit)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_format__["b" /* dollar */])(r.total_sellable_srp_buyer_credit)
          )
        );
      })
    )
  )];
});

/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Form__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_helpers__ = __webpack_require__(79);
/* harmony export (immutable) */ __webpack_exports__["a"] = Create;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();











function Create(_ref) {
  var open = _ref.open,
      close = _ref.close,
      lineItems = _ref.lineItems;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCompany = _useState2[0],
      setSelectedCompany = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState4 = _slicedToArray(_useState3, 2),
      returnToCompany = _useState4[0],
      setReturnToCompany = _useState4[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    setSelectedCompany(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItems, "[0].managed_repair_details.preferred_repair_station", {}));

    return function cleanup() {};
  }, [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItems, "[0].id")]);

  var getActionRequested = function getActionRequested(item) {
    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, "customer_rma.warranty_consideration") && !__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, "customer_rma.closed_date")) {
      return "warranty_consideration";
    } else if (item.cap_type) {
      return item.cap_type;
    }
    return null;
  };

  var getNotToExceed = function getNotToExceed(item) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, "sales_order_line_item.repair_fee") || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["C" /* CAP_AMOUNT */]);
  };

  var pick = function pick(item) {
    return {
      action_requested: getActionRequested(item),
      caac: !!selectedCompany.caac_approved,
      easa: !!selectedCompany.easa_approved,
      faa: !!selectedCompany.faa_approved,
      reason_for_return: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, "customer_rma.reason"),
      inventory_id: item.id,
      condition: item.condition,
      internal_note: !item.exchange_eval_in_progress ? __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, "purchase_order_line_item.internal_note") : "",
      external_note: item.serial_number_correction_required ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_helpers__["q" /* correctSerialText */])(item) : "",
      flat_exchange: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, "sales_order_line_item.flat_exchange"),
      inventory: {
        suggested_retail: item.suggested_retail,
        srp_condition: item.srp_condition,
        most_recent_customer_rma: {
          code: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, "customer_rma.code"),
          credit_requested: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, "customer_rma.credit_requested")
        },
        purchase_order_line_item: item.purchase_order_line_item
      },
      not_to_exceed: getNotToExceed(item),
      payment_terms: selectedCompany.vendor_credit_terms,
      tcca: !!selectedCompany.tcca_approved
    };
  };

  var storeLocation = lineItems.length > 0 && lineItems[0].store_location;
  var shipToFob = storeLocation && storeLocation.fob;

  var initialValues = {
    line_items: lineItems.map(pick),
    company_id: selectedCompany && selectedCompany.id,
    payment_terms: selectedCompany && selectedCompany.vendor_credit_terms,
    ship_to_type: __WEBPACK_IMPORTED_MODULE_4__companies_constants__["f" /* REPAIR_STATION */],
    ship_to_fob: shipToFob
  };

  if (lineItems.length === 1 && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItems[0], "customer_rma.credit_requested") && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItems[0], "customer_rma.warranty_consideration") && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItems[0], "customer_rma.closed_date")) {
    initialValues.return_to_type = __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* COMPANY */];
    initialValues.return_to_company_id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItems[0], "customer_rma.company.id");
    initialValues.return_to_company_address_id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItems[0], "customer_rma.company.primary_physical_address.id");

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
      setReturnToCompany(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItems[0], "customer_rma.company"));
      return function cleanup() {};
    }, [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItems, "[0].id")]);
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Convert Cart to Repair Order"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Form__["a" /* default */], {
        onSubmit: function onSubmit() {},
        close: close,
        formName: "convertToRO",
        lineItems: lineItems,
        initialValues: initialValues,
        enableReinitialize: true,
        returnToCompany: returnToCompany,
        selectedCompany: selectedCompany,
        setSelectedCompany: setSelectedCompany
      })
    )
  );
}

Create.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}))
};

/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_address__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__companies_shared_components_DoNotDoBusinessWarning__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Orders_shared_ShippingFields__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__companies_shared_FindOrCreateCompanyToggle_SearchCompany__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__companies_actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__parts_actions_actions__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__companies_helpers__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__inventories_components_EditInventory_TagTypes__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__shared_components_PaymentTerms_PaymentTerms__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Detail_LineItems_FormSections__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__validate__ = __webpack_require__(695);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



































var FORM_NAME = "convertToRO";

var LocationWarning = function LocationWarning(_ref) {
  var lineItems = _ref.lineItems;

  var sameStoreOwner = [].concat(_toConsumableArray(new Set(lineItems.map(function (a) {
    return a.store_owner_id;
  })))).length === 1;

  if (sameStoreOwner) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_21__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Repair Order contains items from different store owners. Please ensure all items in your cart belong to the same store owner before proceeding."
  );
};

LocationWarning.propTypes = {
  lineItems: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}))
};

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      contacts: [],
      invalidCompany: false,
      paymentTerms: null
    }, _this.handleCompanySelected = function (company) {
      _this.props.setSelectedCompany(company);
      _this.fetchAddresses(company.id);

      _this.props.setFieldValue(__WEBPACK_IMPORTED_MODULE_25__constants__["M" /* PAYMENT_TERMS */], company.vendor_credit_terms);
    }, _this.fetchAddresses = function (companyId) {
      var updateField = _this.props.change;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].companies.physicalAddresses.search(companyId, {
        page: 1,
        limit: 100,
        sort: "primary",
        reverse: true
      }).then(function (_ref3) {
        var results = _ref3.data.results;

        if (results.length > 0) {
          var primaryAddress = results[0];
          _this.setState({ addresses: results });

          // TODO: COME BACK TO THIS
          updateField("repair_station_physical_address_id", primaryAddress.id);
          updateField(__WEBPACK_IMPORTED_MODULE_25__constants__["_40" /* RETURN_TO_FOB */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_address__["a" /* fobFormat */])(primaryAddress));
        }
      });
    }, _this.fetchContacts = function (value) {
      if (!value) {
        return null;
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__parts_actions_actions__["a" /* searchContacts */])(value).then(function () {
        var vals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        _this.setState({ contacts: vals });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__companies_helpers__["a" /* selectPrimaryContact */])(vals, function (val) {
          return _this.props.change(__WEBPACK_IMPORTED_MODULE_25__constants__["O" /* CONTACT_ID */], val);
        });
      });
    }, _this.handleActionChange = function (action) {
      if (action === __WEBPACK_IMPORTED_MODULE_12__constants__["b" /* TEARDOWN */] && ![__WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["_6" /* USA */], __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["_3" /* IRE */], __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["_7" /* SGP */]].includes(_this.props.getFieldValue(__WEBPACK_IMPORTED_MODULE_25__constants__["C" /* RETURN_TO_TYPE */]))) {
        _this.props.setFieldValue(__WEBPACK_IMPORTED_MODULE_25__constants__["C" /* RETURN_TO_TYPE */], null);
      }
    }, _this.renderLineItems = function (_ref4) {
      var fields = _ref4.fields,
          lineItems = _ref4.lineItems;

      var filteredActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_removeKey__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_12__constants__["J" /* ACTIONS_REQUESTED */], __WEBPACK_IMPORTED_MODULE_12__constants__["z" /* EXPECTED_COMPONENT */]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        fields.map(function (item, idx) {
          var lineItem = lineItems[idx];
          var lineItemLength = lineItems.length;
          var repairStation = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(lineItem, "purchase_order_line_item.preferred_repair_station") || "None";
          var cap = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(lineItem, __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["A" /* CAP_TYPE */]) && "| " + __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["B" /* CAP_TYPES */][__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(lineItem, __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["A" /* CAP_TYPE */])].label + " Cap: " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(lineItem, "cap_amount"));

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            { key: "item-" + lineItem.id },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              idx + 1
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "table",
                { className: "table" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tbody",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    lineItem.part.part_number,
                    " | in\xA0",
                    __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["r" /* INVENTORIES */].condition[lineItem.condition].label,
                    " ",
                    "Condition |",
                    lineItem.quantity,
                    " QTY @",
                    " ",
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.cost_per_unit),
                    " / each ",
                    cap,
                    lineItemLength > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                      "Suggested Repair Station: ",
                      repairStation,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null)
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    { className: "text-right" },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.subtotal)
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tr",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "td",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["q" /* FormRow */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_20_react_bootstrap__["e" /* Col */],
                          { md: 12 },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__Detail_LineItems_FormSections__["a" /* ActionRequestedSection */], {
                            onActionChange: function onActionChange(ev, action) {
                              return _this.handleActionChange(action);
                            },
                            formName: FORM_NAME,
                            index: idx,
                            setField: _this.props.setFieldValue,
                            getField: _this.props.getFieldValue,
                            nested: true,
                            actions: filteredActions,
                            showEvaluationFields: false
                          })
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["q" /* FormRow */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_20_react_bootstrap__["e" /* Col */],
                          { md: 12 },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_redux_form__["FormSection"],
                            { name: "line_items[" + idx + "]" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], {
                              names: [__WEBPACK_IMPORTED_MODULE_11__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["L" /* UK_CAA */], __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["M" /* OTHER */], __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["N" /* OTHER_TAG_TYPE */]],
                              component: __WEBPACK_IMPORTED_MODULE_28__inventories_components_EditInventory_TagTypes__["a" /* default */],
                              formName: FORM_NAME,
                              required: true
                            })
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["q" /* FormRow */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_20_react_bootstrap__["e" /* Col */],
                          { md: 6 },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                            name: "line_items[" + idx + "].internal_note",
                            rows: 5,
                            cols: 50,
                            component: __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["l" /* TextArea */],
                            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_27__shared_constants__["c" /* INTERNAL_NOTE */])
                          })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_20_react_bootstrap__["e" /* Col */],
                          { md: 6 },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                            name: "line_items[" + idx + "].external_note",
                            rows: 5,
                            cols: 50,
                            component: __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["l" /* TextArea */],
                            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */])
                          })
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null)
                  )
                )
              )
            )
          );
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.selectedCompany && this.props.selectedCompany.id) {
        this.handleCompanySelected(this.props.selectedCompany);
        this.fetchContacts(this.props.selectedCompany.id);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          formName = _props.formName,
          lineItems = _props.lineItems,
          getFieldValue = _props.getFieldValue,
          setFieldValue = _props.setFieldValue,
          returnToCompany = _props.returnToCompany,
          selectedCompany = _props.selectedCompany;
      var _state = this.state,
          invalidCompany = _state.invalidCompany,
          addresses = _state.addresses;

      var containsTeardown = lineItems.some(function (i, idx) {
        return getFieldValue("line_items[" + idx + "].action_requested") === __WEBPACK_IMPORTED_MODULE_12__constants__["b" /* TEARDOWN */];
      });
      var returnToTypes = [__WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["K" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["L" /* DROPSHIP */], __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["d" /* DO_NOT_SHIP */]];
      var hasReturnToLocations = true;

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__shared_helpers__["l" /* getCreditRequestedWarrantyRmas */])(lineItems, "customer_rma")) || containsTeardown) {
        returnToTypes = [];
      }

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEmpty"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__shared_helpers__["r" /* getWarrantyAndNotCreditRmas */])(lineItems, "customer_rma"))) {
        returnToTypes = [__WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["K" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["L" /* DROPSHIP */]];
        hasReturnToLocations = false;
      }

      var repairStatus = lineItems && lineItems[0] && [__WEBPACK_IMPORTED_MODULE_12__constants__["a" /* REPAIR_EVALUATION_APPROVED */], __WEBPACK_IMPORTED_MODULE_12__constants__["t" /* REPAIR_EVALUATION_REJECTED */]].includes(lineItems[0].repair_status);

      var firstLineItem = lineItems.length ? lineItems[0] : {};
      var lineItemsLength = lineItems.length;
      var repairStation = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(firstLineItem, "purchase_order_line_item.preferred_repair_station") || "None";

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["e" /* Form */],
        _extends({}, this.props, { disabled: invalidCompany }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__companies_shared_components_DoNotDoBusinessWarning__["a" /* default */], { company: selectedCompany }),
          lineItemsLength === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_20_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_21__shared_components_Warning_Warning__["a" /* default */],
                null,
                "Suggested Repair Station: ",
                repairStation
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_29__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LocationWarning, { lineItems: lineItems })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__companies_shared_FindOrCreateCompanyToggle_SearchCompany__["a" /* default */], {
            companySearch: __WEBPACK_IMPORTED_MODULE_18__companies_actions__["a" /* searchRepairStationCompanies */],
            contacts: this.state.contacts,
            formName: formName,
            fetchContacts: this.fetchContacts,
            selectedCompany: selectedCompany,
            onCompanySelected: this.handleCompanySelected,
            onCompanyToggleTypeChange: this.handleToggleChange,
            type: "repairOrder",
            required: true
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_20_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__shared_components_PaymentTerms_PaymentTerms__["a" /* default */], null)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            null,
            "Ship To"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_20_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_25__constants__["_20" /* SHIP_TO_FOB */],
                  component: __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["d" /* FormInput */],
                  label: "FOB",
                  required: true
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Orders_shared_ShippingFields__["a" /* default */], {
            formName: formName,
            shippingFields: [__WEBPACK_IMPORTED_MODULE_25__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_25__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_25__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */]],
            setFOB: function setFOB(val) {
              return setFieldValue(__WEBPACK_IMPORTED_MODULE_25__constants__["_40" /* RETURN_TO_FOB */], val);
            },
            setTenantAccount: true,
            repairStationOptions: addresses,
            shippingTypes: [__WEBPACK_IMPORTED_MODULE_10__companies_constants__["f" /* REPAIR_STATION */], __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["K" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["L" /* DROPSHIP */]],
            shippingMethod: __WEBPACK_IMPORTED_MODULE_25__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */],
            shippingAddressField: __WEBPACK_IMPORTED_MODULE_25__constants__["_17" /* SHIP_TO_SHIPPING_ADDRESS */],
            hasLocations: false
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            null,
            "Return To"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Orders_shared_ShippingFields__["a" /* default */], {
            formName: formName,
            path: __WEBPACK_IMPORTED_MODULE_25__constants__["_39" /* RETURN_TO */],
            shippingFields: [__WEBPACK_IMPORTED_MODULE_25__constants__["C" /* RETURN_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_25__constants__["_42" /* RETURN_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_25__constants__["_43" /* RETURN_TO_COMPANY_ADDRESS_ID */]],
            shipToCompany: returnToCompany,
            shippingTypes: returnToTypes,
            shippingMethod: __WEBPACK_IMPORTED_MODULE_25__constants__["_41" /* RETURN_TO_SHIPPING_METHOD */],
            shippingAddressField: __WEBPACK_IMPORTED_MODULE_25__constants__["_44" /* RETURN_TO_SHIPPING_ADDRESS */],
            required: false,
            ship_to_fields_required: repairStatus,
            hasLocations: hasReturnToLocations,
            locationFieldName: __WEBPACK_IMPORTED_MODULE_25__constants__["_25" /* RETURN_TO_LOCATION_ID */]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_20_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_25__constants__["_40" /* RETURN_TO_FOB */],
                  component: __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["d" /* FormInput */],
                  label: "Return To FOB",
                  required: true
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: "row row-col-gutters-half",
                style: { marginTop: "26px" }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_20_react_bootstrap__["e" /* Col */],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-striped table-numbered margin-bottom-none" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["FieldArray"], {
                    name: __WEBPACK_IMPORTED_MODULE_25__constants__["A" /* LINE_ITEMS */],
                    component: this.renderLineItems,
                    lineItems: lineItems
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  change: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  formName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  getFieldValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  lineItems: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})),
  setFieldValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  selectedCompany: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object).isRequired,
  setSelectedCompany: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    getFieldValue: function getFieldValue(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(FORM_NAME)(state, field);
    }
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__actions__["v" /* convertRo */])(data));
    },
    queryParts: function queryParts(filter) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__parts_actions_actions__["r" /* searchPartsByStatus */])(filter));
    },
    searchInventories: function searchInventories(partId, filters) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__parts_actions_actions__["g" /* searchInventories */])(partId, filters));
    },
    setFieldValue: function setFieldValue(field, val) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(FORM_NAME, field, val));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_32__validate__["b" /* default */]
})(Form)));

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__inventories_constants__ = __webpack_require__(12);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
















function ConfirmApproval(_ref) {
  var repairOrder = _ref.repairOrder,
      onConfirm = _ref.onConfirm,
      currentUser = _ref.currentUser;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      confirmationIsVisible = _useState2[0],
      setConfirmationVisibility = _useState2[1];

  if (repairOrder.get(__WEBPACK_IMPORTED_MODULE_7__constants__["_5" /* APPROVED */])) {
    return false;
  }

  if (repairOrder.get(__WEBPACK_IMPORTED_MODULE_7__constants__["_23" /* CORE_REPAIR_HOLD */])) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__users_helpers__["e" /* hasPermission */])(currentUser, __WEBPACK_IMPORTED_MODULE_8__users_constants__["_13" /* CAN_RELEASE_CORE_RETURN */]) && repairOrder.getIn([__WEBPACK_IMPORTED_MODULE_11__constants__["A" /* LINE_ITEMS */], 0, __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["x" /* BUYER_ID */]]) !== currentUser.id) {
      return false;
    }
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__users_helpers__["h" /* disableIfHasAnyOfRoles */])(currentUser, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_8__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["l" /* REPAIR */]))) {
    return false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setConfirmationVisibility(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "check", fixed: true }),
    "\xA0Approve RO",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setConfirmationVisibility(false);
        },
        open: confirmationIsVisible,
        btnClass: "btn-success",
        btnText: "Yes, Approve Repair Order",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to approve this Repair Order?"
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["b" /* default */])(ConfirmApproval));

ConfirmApproval.propTypes = {
  repairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired,
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators_loadRecord__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Orders_shared_Contact__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__companies_shared_components_PaymentTerms__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Edit_EditBilling__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Edit_EditCompanyFields__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Teardowns_Subcomponents__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pagination__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ShippingDetails__ = __webpack_require__(1741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Header__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__LineItems_Create__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__LineItems_HigherAssemblyTable__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__LineItems_ShopAssistTable__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__LineItems_DefaultRepairOrderTable__ = __webpack_require__(1694);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





























var Detail = function (_React$Component) {
  _inherits(Detail, _React$Component);

  function Detail() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Detail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Detail.__proto__ || Object.getPrototypeOf(Detail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editPartModalOpen: false,
      editReturnToModalOpen: false,
      editShipToModalOpen: false,
      initialPartFormValues: {}
    }, _this.readOnlyItem = function () {
      var lineItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return lineItem.action_requested === __WEBPACK_IMPORTED_MODULE_20__constants__["r" /* SHOP_ASSIST */] && lineItem.shipped || lineItem.scrap_report || lineItem.action_requested === __WEBPACK_IMPORTED_MODULE_20__constants__["z" /* EXPECTED_COMPONENT */] && lineItem.quantity_received > 0;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Detail, [{
    key: "render",
    value: function render() {
      var repairOrder = this.props.repairOrder;
      var cancelled = repairOrder.get("cancelled");
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__Header__["a" /* default */], { repairOrder: repairOrder }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "col-md-3" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "panel panel-default" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "panel-body" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h2",
                  { style: { marginTop: 10 } },
                  "Details",
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6__shared_components__["T" /* Forbidden */],
                    { roles: [__WEBPACK_IMPORTED_MODULE_12__users_constants__["j" /* WAREHOUSE */]] },
                    !cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EditCompanyFieldsModal, { record: repairOrder })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-condensed" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tbody",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["S" /* Detail */], {
                      label: "Rep Station Code",
                      value: repairOrder.getIn(["company", "code"])
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["S" /* Detail */], {
                      label: "Rep Station Name",
                      value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["w" /* CompanyName */], {
                        company: repairOrder.toJS().company,
                        context: "repair"
                      })
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["S" /* Detail */], {
                      label: "Rep Station Phone",
                      value: repairOrder.getIn(["company", "phone"])
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Teardowns_Subcomponents__["a" /* default */], { repairOrder: repairOrder }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Orders_shared_Contact__["a" /* default */], { contact: repairOrder.get("contact") }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h2",
                  null,
                  "Billing",
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6__shared_components__["b" /* Authorized */],
                    { roles: [__WEBPACK_IMPORTED_MODULE_12__users_constants__["m" /* ACCOUNTING */]] },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6__shared_components__["T" /* Forbidden */],
                      { roles: [__WEBPACK_IMPORTED_MODULE_12__users_constants__["j" /* WAREHOUSE */]] },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EditBillingModal, { record: repairOrder })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-condensed" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tbody",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["S" /* Detail */], {
                      label: "Credit Terms",
                      value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__companies_shared_components_PaymentTerms__["a" /* PaymentTerms */], {
                        paymentTerms: repairOrder.get("payment_terms")
                      })
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_19__ShippingDetails__["a" /* default */],
                  { shippingType: "ship_to", record: repairOrder },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "table",
                    { className: "table table-condensed" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tbody",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["S" /* Detail */], {
                        label: "Insurance",
                        value: insuranceValue(repairOrder)
                      })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ShippingDetails__["a" /* default */], {
                  shippingType: "return_to",
                  record: repairOrder
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["z" /* AuditFields */], { record: repairOrder, multiLine: true })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 9 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              { style: { marginTop: 26 } },
              "Repair Order Details",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6__shared_components__["T" /* Forbidden */],
                { roles: [__WEBPACK_IMPORTED_MODULE_12__users_constants__["j" /* WAREHOUSE */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AddPartModal, { repairOrder: repairOrder })
              )
            ),
            repairOrder.get(__WEBPACK_IMPORTED_MODULE_15__constants__["A" /* LINE_ITEMS */]).size > 15 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__shared_components__["c" /* Search */],
              { search: __WEBPACK_IMPORTED_MODULE_16__pagination__["d" /* repairOrderLineItemsPagination */], syncWithUrl: true },
              function (searchProps) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
                  placeholder: "Search by typing a part number"
                }));
              }
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__LineItems_DefaultRepairOrderTable__["a" /* default */], { repairOrder: repairOrder }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__LineItems_HigherAssemblyTable__["a" /* default */], { repairOrder: repairOrder }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__LineItems_ShopAssistTable__["a" /* default */], { repairOrder: repairOrder }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["M" /* Notes */], {
              resource: repairOrder,
              resourceType: __WEBPACK_IMPORTED_MODULE_7__shared_types_resourceTypes__["a" /* default */].repairOrder,
              resourceKey: "repairOrder"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["N" /* Attachments */], {
              resource: repairOrder,
              resourceType: __WEBPACK_IMPORTED_MODULE_7__shared_types_resourceTypes__["a" /* default */].repairOrder,
              resourceKey: "repairOrder",
              attachmentTypes: __WEBPACK_IMPORTED_MODULE_20__constants__["A" /* ATTACHMENT_TYPES */],
              multiple: true,
              referenceOptions: [{
                text: repairOrder.get(__WEBPACK_IMPORTED_MODULE_15__constants__["z" /* CODE */]),
                value: repairOrder.get(__WEBPACK_IMPORTED_MODULE_15__constants__["z" /* CODE */])
              }].concat(_toConsumableArray(repairOrder.get(__WEBPACK_IMPORTED_MODULE_15__constants__["A" /* LINE_ITEMS */]).toJS().map(function (l) {
                return {
                  text: "SN-" + l.serial_number,
                  value: "SN-" + l.serial_number
                };
              })))
            })
          )
        )
      );
    }
  }]);

  return Detail;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Detail.propTypes = {
  repairOrder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])
};


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    repairOrder: state.repairOrderDetail.get("repairOrder")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators_loadRecord__["a" /* default */])({
  reducer: "repairOrderDetail",
  name: "repairOrder",
  action: __WEBPACK_IMPORTED_MODULE_21__actions__["c" /* find */]
})(Detail)));

function EditBillingModal(_ref2) {
  var record = _ref2.record;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["P" /* LaunchModal */], {
    modal: __WEBPACK_IMPORTED_MODULE_10__Edit_EditBilling__["a" /* default */],
    buttonClass: "btn btn-primary btn-hollow pull-right",
    buttonIcon: "fa-pencil",
    text: "Edit",
    record: record
  });
}

function insuranceValue(repairOrder) {
  var insuranceType = repairOrder.get("insurance_type");
  if (insuranceType === __WEBPACK_IMPORTED_MODULE_20__constants__["v" /* NONE */]) {
    return __WEBPACK_IMPORTED_MODULE_20__constants__["w" /* INSURANCE_TYPES */][__WEBPACK_IMPORTED_MODULE_20__constants__["v" /* NONE */]].value;
  } else if (insuranceType === __WEBPACK_IMPORTED_MODULE_20__constants__["x" /* AMOUNT */]) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_currency__["a" /* dollars */])(repairOrder.get(__WEBPACK_IMPORTED_MODULE_20__constants__["w" /* INSURANCE_TYPES */][__WEBPACK_IMPORTED_MODULE_20__constants__["x" /* AMOUNT */]].key));
  } else if (insuranceType === __WEBPACK_IMPORTED_MODULE_20__constants__["y" /* PERCENT */]) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib_formatters_number__["a" /* percent */])(Number(repairOrder.get(__WEBPACK_IMPORTED_MODULE_20__constants__["w" /* INSURANCE_TYPES */][__WEBPACK_IMPORTED_MODULE_20__constants__["y" /* PERCENT */]].key)), 100);
  }

  return null;
}

EditBillingModal.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}).isRequired
};

function EditCompanyFieldsModal(_ref3) {
  var record = _ref3.record;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["P" /* LaunchModal */], {
    modal: __WEBPACK_IMPORTED_MODULE_11__Edit_EditCompanyFields__["a" /* default */],
    buttonClass: "btn btn-primary btn-hollow pull-right",
    buttonIcon: "fa-pencil",
    text: "Edit",
    record: record
  });
}

EditCompanyFieldsModal.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}).isRequired
};

function AddPartModal(_ref4) {
  var repairOrder = _ref4.repairOrder;

  var tearDown = repairOrder.get("line_items").some(function (l) {
    return l.get("action_requested") === __WEBPACK_IMPORTED_MODULE_20__constants__["b" /* TEARDOWN */];
  });
  var shippedTeardown = repairOrder.get("line_items").some(function (l) {
    return l.get("action_requested") === __WEBPACK_IMPORTED_MODULE_20__constants__["b" /* TEARDOWN */] && l.get("shipped");
  });

  if (!repairOrder.get("cancelled") && tearDown && !shippedTeardown) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["P" /* LaunchModal */], {
    buttonClass: "btn btn-primary btn-hollow pull-right",
    modal: __WEBPACK_IMPORTED_MODULE_23__LineItems_Create__["a" /* default */],
    repairOrder: repairOrder,
    text: "Add Part"
  });
}

AddPartModal.propTypes = {
  repairOrder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}).isRequired
};

/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Form__ = __webpack_require__(1688);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditInvoiceDetails;









function EditInvoiceDetails(_ref) {
  var repairOrder = _ref.repairOrder;

  if (repairOrder.get("cancelled")) {
    return false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__["a" /* default */],
        { onClick: open },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: "dollar", fixed: true }),
        "\xA0Edit Billing",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["a" /* Modal */],
          { open: visible, close: close, dialogClass: "modal-lg" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["c" /* Close */], { close: close }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Edit Billing Details"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Form__["a" /* default */], {
            close: close,
            repairOrder: repairOrder.toJS(),
            initialValues: Object.assign(repairOrder.toJS(), {
              invoice_paid_date: null,
              invoice_number: null
            })
          })
        )
      );
    }
  );
}

EditInvoiceDetails.propTypes = {
  repairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
};

/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms_CurrencyField__ = __webpack_require__(176);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.setToFullVal = function () {
      _this.props.repairOrder.line_items.filter(function (l) {
        return !l.cancelled;
      }).forEach(function (l, idx) {
        _this.props.change("line_items[" + idx + "]." + __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["O" /* AMOUNT_PAID */], Number(_this.fieldAmount(l)));

        _this.props.change("line_items[" + idx + "]." + __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__["v" /* PAID_IN_FULL */], true);
        _this.setInvoicePaidDate(idx);
      });
    }, _this.setItemToFullVal = function (idx) {
      var lineItem = _this.props.repairOrder.line_items.filter(function (l) {
        return !l.cancelled;
      })[idx];
      _this.props.change("line_items[" + idx + "]." + __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["O" /* AMOUNT_PAID */], Number(_this.fieldAmount(lineItem)));
    }, _this.setInvoicePaidDate = function (idx) {
      var date = __WEBPACK_IMPORTED_MODULE_13_moment___default()().format("YYYY-MM-DD");
      if (!_this.props.getFieldValue("line_items[" + idx + "].invoice_paid_date")) {
        _this.props.change("line_items[" + idx + "].invoice_paid_date", date);
      }
    }, _this.fieldAmount = function (lineItem) {
      if (lineItem.approval_status === __WEBPACK_IMPORTED_MODULE_12__constants__["a" /* REPAIR_EVALUATION_APPROVED */]) {
        return [lineItem.part_cost, lineItem.labor_cost, lineItem.outside_labor_cost].reduce(function (partialSum, a) {
          return partialSum + Number(a);
        }, 0);
      } else if (lineItem.approval_status === __WEBPACK_IMPORTED_MODULE_12__constants__["t" /* REPAIR_EVALUATION_REJECTED */]) {
        return Number(lineItem.evaluation_charge);
      }

      return 0;
    }, _this.handleTopLevelFormChange = function (ev, field) {
      var val = ev.target.value;
      _this.props.repairOrder.line_items.forEach(function (l, idx) {
        _this.props.change("line_items[" + idx + "]." + field, val);
      });
    }, _this.renderLineItems = function (_ref2) {
      var fields = _ref2.fields;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        fields.map(function (item, idx) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "row row-col-gutters-half" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                    name: item + ".part.part_number",
                    label: "Part #",
                    disabled: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                    name: item + ".serial_number",
                    label: "Serial #",
                    disabled: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                    name: item + ".invoice_number",
                    label: "Invoice Number"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                    name: item + ".invoice_date",
                    label: "Invoice Date",
                    type: "date"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                    name: item + ".invoice_due_date",
                    label: "Invoice Due Date",
                    type: "date"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                    name: item + ".invoice_paid_date",
                    label: "Invoice Paid Date",
                    type: "date"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms_CurrencyField__["a" /* default */],
                    name: [item, __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["O" /* AMOUNT_PAID */]].join("."),
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["O" /* AMOUNT_PAID */])
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
                  { md: 1 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
                    { justified: true, title: "In Full" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                      name: item + "." + __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__["v" /* PAID_IN_FULL */],
                      component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                      label: "Yes",
                      onChange: function onChange() {
                        _this.setItemToFullVal(idx);
                        _this.setInvoicePaidDate(idx);
                      }
                    })
                  )
                )
              )
            )
          );
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          repairOrder = _props.repairOrder,
          handleSubmit = _props.handleSubmit,
          close = _props.close,
          invalid = _props.invalid,
          submitting = _props.submitting;

      var activeLineItems = repairOrder.line_items.filter(function (l) {
        return !l.cancelled;
      });
      var shouldRenderSection = activeLineItems.length > 1;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "form",
        { onSubmit: handleSubmit },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["e" /* Body */],
          null,
          shouldRenderSection && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
            { className: "row-col-gutters-half" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                name: "invoice_number",
                label: "Invoice Number",
                onChange: function onChange(e) {
                  return _this2.handleTopLevelFormChange(e, "invoice_number");
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                name: "invoice_date",
                label: "Invoice Date",
                type: "date",
                onChange: function onChange(e) {
                  return _this2.handleTopLevelFormChange(e, "invoice_date");
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                name: "invoice_due_date",
                label: "Invoice Due Date",
                type: "date",
                onChange: function onChange(e) {
                  return _this2.handleTopLevelFormChange(e, "invoice_due_date");
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                name: "invoice_paid_date",
                label: "Invoice Paid Date",
                type: "date",
                onChange: function onChange(e) {
                  return _this2.handleTopLevelFormChange(e, "invoice_paid_date");
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
                { justified: true, title: "Amt Paid In Full" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__["v" /* PAID_IN_FULL */],
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                  label: "Yes",
                  onChange: this.setToFullVal
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "table",
            { className: "table table-striped table-numbered margin-bottom-none" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["FieldArray"], {
              name: "line_items",
              component: this.renderLineItems,
              lineItems: repairOrder.line_items
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["d" /* Footer */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["i" /* Button */],
            { onClick: close },
            "Cancel"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["i" /* Button */],
            {
              type: "submit",
              bsStyle: "primary",
              disabled: invalid || submitting
            },
            "\xA0Update Invoice Details"
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  change: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  invalid: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  repairOrder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}),
  submitting: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      dispatch(__WEBPACK_IMPORTED_MODULE_8__actions__["t" /* bulkUpdateLineItems */](data)).then(function () {
        ownProps.close();
      }).catch(function (error) {
        if (error.errors) {
          var errorMessage = Object.keys(error.errors).map(function (key) {
            var messages = error.errors[key];
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(key) + " " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["b" /* toSentence */])(messages) + ".";
          }).join(". ");

          __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].error("Error", errorMessage);
        } else {
          __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].error("Error", error.message);
        }
      });
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["reduxForm"])({
  form: "editInvoiceDetails"
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditInvoiceDetails__ = __webpack_require__(1687);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EditInvoiceDetails__["a"]; });


/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SendRepairOrderDocuments_SendRepairOrderDocuments__ = __webpack_require__(1739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Orders_shared_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_RecordPager_RecordPager__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_ExternalLink_ExternalLink__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_components_ActionDropDown_ActionDropDown__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_components_SendEmail__ = __webpack_require__(2388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Warnings__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ConfirmApproval_ConfirmApproval__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__shared_components_RemoveFromQCHold__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ImportExpectedComponents_ImportExpectdComponents__ = __webpack_require__(1691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__UpdateEvaluationStatus_UpdateEvaluationStatus__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__UpdateEvaluationStatus_UpdateEvaluationStatusModal__ = __webpack_require__(1748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Sync_Sync__ = __webpack_require__(1742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ToggleQuickbooksSync_ToggleQuickbooksSync__ = __webpack_require__(1745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__EditInvoiceDetails__ = __webpack_require__(1689);
/* unused harmony export Header */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
































var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      cancellationReason: __WEBPACK_IMPORTED_MODULE_9__Orders_shared_constants__["k" /* CANCELLATION_REASONS */][0].value,
      cancelOrderModalOpen: false,
      importModalOpen: false,
      sendOrderModalOpen: false,
      toggleApprovalModal: false
    }, _this.onConfirmToRemoveFormQCHoldClick = function () {
      var updateRepairOrder = _this.props.updateRepairOrder;


      updateRepairOrder({ qc_hold: false });
    }, _this.handleSelectChange = function (e) {
      _this.setState({ cancellationReason: e.target.value });
    }, _this.closeCancelOrderModal = function () {
      return _this.setState({ cancelOrderModalOpen: false });
    }, _this.openCancelOrderModal = function () {
      return _this.setState({ cancelOrderModalOpen: true });
    }, _this.openimportModal = function () {
      return _this.setState({ importModalOpen: true });
    }, _this.openApprovalModal = function () {
      return _this.setState({ toggleApprovalModal: true });
    }, _this.toggle = function (modalType) {
      return function () {
        return _this.setState(_defineProperty({}, modalType, !_this.state[modalType]));
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          repairOrder = _props.repairOrder,
          cancelRepairOrder = _props.cancelRepairOrder,
          id = _props.id;
      var _state = this.state,
          cancelOrderModalOpen = _state.cancelOrderModalOpen,
          importModalOpen = _state.importModalOpen,
          toggleApprovalModal = _state.toggleApprovalModal;

      var cancelled = repairOrder.get(__WEBPACK_IMPORTED_MODULE_21__constants__["_38" /* CANCELLED */]);
      var forSecondOpinion = repairOrder.get(__WEBPACK_IMPORTED_MODULE_21__constants__["A" /* LINE_ITEMS */]).some(function (i) {
        return i.get("for_second_opinion");
      });
      var cancellable = repairOrder.get(__WEBPACK_IMPORTED_MODULE_21__constants__["A" /* LINE_ITEMS */]).every(function (i) {
        return i.get("cancellable");
      });

      var lineItemsShipped = repairOrder.get(__WEBPACK_IMPORTED_MODULE_21__constants__["A" /* LINE_ITEMS */]).every(function (i) {
        return i.get(__WEBPACK_IMPORTED_MODULE_21__constants__["_23" /* SHIPPED */]);
      });

      var teardown = repairOrder.toJS().line_items.filter(function (l) {
        return l.action_requested === __WEBPACK_IMPORTED_MODULE_22__constants__["b" /* TEARDOWN */];
      })[0];

      var hasActiveRma = repairOrder.get("active_customer_rma");

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "page-header page-header-bar" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h1",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "btn-group pull-right", style: { marginLeft: 20 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_15__shared_components_ActionDropDown_ActionDropDown__["a" /* default */],
              {
                menuClass: "dropdown-menu-right",
                style: { cursor: "pointer" }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_19__shared_components__["b" /* Authorized */],
                { roles: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["l" /* REPAIR */]], subroles: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["n" /* QUALITY_CONTROL_MANAGER */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__shared_components_RemoveFromQCHold__["a" /* default */], {
                  order: repairOrder,
                  orderType: "RO",
                  onConfirm: this.onConfirmToRemoveFormQCHoldClick
                })
              ),
              !cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_19__shared_components__["b" /* Authorized */],
                  { authorizedIf: function authorizedIf() {
                      return repairOrder.get(__WEBPACK_IMPORTED_MODULE_22__constants__["_5" /* APPROVED */]);
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "li",
                    { key: "download-ro" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_12__shared_components_ExternalLink_ExternalLink__["a" /* default */],
                      {
                        url: __WEBPACK_IMPORTED_MODULE_21__constants__["d" /* API_BASE */] + "/repair_orders/" + id + "/download"
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-file-text-o" }),
                      "\xA0Download RO"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SendRepairOrderDocuments_SendRepairOrderDocuments__["a" /* default */], { repairOrder: repairOrder })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_19__shared_components__["b" /* Authorized */],
                  { roles: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["m" /* ACCOUNTING */]] },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__EditInvoiceDetails__["a" /* default */], { repairOrder: repairOrder })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ConfirmApproval_ConfirmApproval__["a" /* default */], {
                  repairOrder: repairOrder,
                  onConfirm: this.props.approveRepairOrder
                }),
                lineItemsShipped && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_SendEmail__["a" /* default */], {
                    record: repairOrder,
                    label: "request for evaluation",
                    url: __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].repairOrders,
                    type: "quote"
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_SendEmail__["a" /* default */], {
                    record: repairOrder,
                    label: "request for shipping status",
                    url: __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].repairOrders,
                    type: "status"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { className: "divider", key: "ro-divider" })
              ),
              !!teardown && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11__shared_components_DropDown_DropDownItem__["a" /* default */],
                { onClick: this.openimportModal },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-download" }),
                  " ",
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    "Import Expected Sub-Components"
                  )
                )
              ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__UpdateEvaluationStatus_UpdateEvaluationStatus__["a" /* default */], {
                toggleApprovalModal: this.openApprovalModal
              }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { className: "divider", key: "ro-divider" })],
              (cancelled || cancellable) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11__shared_components_DropDown_DropDownItem__["a" /* default */],
                { onClick: this.openCancelOrderModal },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { className: "text-danger" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
                  " ",
                  cancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    "Reopen Order"
                  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    "Cancel Order"
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_19__shared_components__["b" /* Authorized */],
                { roles: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["m" /* ACCOUNTING */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__ToggleQuickbooksSync_ToggleQuickbooksSync__["a" /* default */], { repairOrder: repairOrder }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__Sync_Sync__["a" /* default */], { repairOrder: repairOrder })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_RecordPager_RecordPager__["a" /* default */], { baseUrl: "/repair-orders", record: repairOrder }),
          "\xA0",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "header-content" },
            repairOrder.get(__WEBPACK_IMPORTED_MODULE_21__constants__["z" /* CODE */])
          ),
          "\xA0",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["E" /* ClipboardCopy */], { name: repairOrder.get(__WEBPACK_IMPORTED_MODULE_21__constants__["z" /* CODE */]), type: "RO" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "small text-muted" },
            "Created ",
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(repairOrder.get(__WEBPACK_IMPORTED_MODULE_21__constants__["_7" /* CREATED_AT */]))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "pull-right" },
            repairOrder.get(__WEBPACK_IMPORTED_MODULE_23__inventories_constants__["S" /* QC_HOLD */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["p" /* StatusTag */], { title: "QC Hold", icon: "pause", display: "danger" }),
            " ",
            forSecondOpinion && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["p" /* StatusTag */], {
                title: "Second Opinion",
                icon: "retweet",
                display: "warning"
              }),
              " "
            ),
            hasActiveRma && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "label label-danger" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cog" }),
              "\xA0\xA0Cust. RMA"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "small text-muted" },
              repairOrder.get(__WEBPACK_IMPORTED_MODULE_21__constants__["A" /* LINE_ITEMS */], []).size,
              " Item(s)"
            ),
            "\xA0\xA0Total: ",
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(repairOrder.get("total"))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Warnings__["a" /* default */], { repairOrder: repairOrder })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__ImportExpectedComponents_ImportExpectdComponents__["a" /* default */], {
          close: this.toggle("importModalOpen"),
          open: importModalOpen
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__UpdateEvaluationStatus_UpdateEvaluationStatusModal__["a" /* default */], {
          close: this.toggle("toggleApprovalModal"),
          repairOrder: repairOrder,
          visible: toggleApprovalModal
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
          {
            onConfirm: function onConfirm() {
              return cancelRepairOrder(_this2.state.cancellationReason);
            },
            close: this.closeCancelOrderModal,
            open: cancelOrderModalOpen,
            btnClass: cancelled ? "btn-primary" : "btn-danger",
            btnText: cancelled ? "Reopen Order" : "Yes, Cancel Order",
            cancelText: cancelled ? "Cancel" : "Do Not Cancel Order",
            icon: cancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-refresh" }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" })
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          "\xA0",
          cancelled ? "Are you sure you want to reopen this?" : "Cancelling an RO will cancel all line items associated with it.",
          !cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              { className: "control-label", htmlFor: "cancellation_reason" },
              "Cancellation Reason"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "select",
              {
                className: "form-control",
                name: "cancellation_reason",
                onChange: function onChange(e) {
                  return _this2.handleSelectChange(e);
                }
              },
              __WEBPACK_IMPORTED_MODULE_9__Orders_shared_constants__["k" /* CANCELLATION_REASONS */].map(function (reason) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "option",
                  { key: reason.value, value: reason.value },
                  reason.text
                );
              })
            )
          )
        )
      );
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    id: state.repairOrderDetail.getIn(["repairOrder", "id"])
  };
}, function (dispatch) {
  return {
    cancelRepairOrder: function cancelRepairOrder(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions__["p" /* cancel */])(data));
    },
    updateRepairOrder: function updateRepairOrder(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions__["a" /* update */])(data));
    },
    approveRepairOrder: function approveRepairOrder() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions__["a" /* update */])({ approved: true }));
    }
  };
})(Header));

Header.propTypes = {
  approveRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  repairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  cancelRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ImportExpectedComponentsForm__ = __webpack_require__(1692);
/* harmony export (immutable) */ __webpack_exports__["a"] = ImportExpectdComponents;





function ImportExpectdComponents(_ref) {
  var open = _ref.open,
      close = _ref.close,
      lot = _ref.lot;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Import Components"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ImportExpectedComponentsForm__["a" /* default */], {
      close: close,
      enableReinitialize: true,
      lot: lot
    })
  );
}

ImportExpectdComponents.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lot: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);









var formName = "ImportExpectdComponents";

function ImportExpectedComponentsForm(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components__["n" /* Warning */],
          null,
          "Please label column header fields: part_number, cond, tag_date, original_evaluation, parts_cost, labor_cost, transfer_cost. *fields are mandatory. Acceptable condition codes: ne, oh, sv, sv_tooling, bt, ar, br. If cond. = ar, br, or sv_tooling then tag_date can remain blank. Cost field can entered as 0. Import file must be in .csv format."
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "file",
            component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["k" /* FileInput */],
            label: "Upload Attachment",
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 8, mdOffset: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "a",
            {
              href: "https://info-trader-assets.s3.us-east-2.amazonaws.com/public/InfoTrader_Import_Template_v4.csv",
              target: "_blank",
              rel: "noopener noreferrer"
            },
            "Template"
          )
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["r" /* importLineItems */])(data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["j" /* form */])({
  form: formName
})(ImportExpectedComponentsForm)));

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Form__ = __webpack_require__(696);










function Create(_ref) {
  var open = _ref.open,
      close = _ref.close,
      onSubmit = _ref.onSubmit,
      repairOrder = _ref.repairOrder;

  var teardown = repairOrder.toJS().line_items.filter(function (l) {
    return l.action_requested === __WEBPACK_IMPORTED_MODULE_6__constants__["b" /* TEARDOWN */];
  })[0];
  var remainingCost = 0;
  if (teardown) {
    remainingCost = teardown.remaining_cost;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-lg" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Add a Part"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Form__["a" /* default */], {
        close: close,
        onSubmit: onSubmit,
        initialValues: {
          approval_status: __WEBPACK_IMPORTED_MODULE_6__constants__["B" /* REPAIR_AWAITING_EVALUATION */],
          final_evaluation_approved: false,
          release_for_shipment: false,
          remaining_cost: remainingCost,
          insurance_type: "None"
        },
        repairOrder: repairOrder
      })
    )
  );
}

Create.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  repairOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, { onSubmit: __WEBPACK_IMPORTED_MODULE_5__actions__["d" /* createROLineItem */] })(Create));

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_PartNumber_PartNumber__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StatusNote__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__StatusBadges__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__parts_components_HoverFlag__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__RequiredComponentTooltip__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__LineItemControls__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_components_Forms_hiddenInputs__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Edit__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__constants__ = __webpack_require__(28);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
























var hiddenEnhancer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__shared_components_Forms_hiddenInputs__["a" /* default */])({
  HiddenTh: function HiddenTh(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "th",
      props,
      props.children
    );
  },
  HiddenTd: function HiddenTd(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      props,
      props.children
    );
  }
});

var Table = function Table(props) {
  var clickable = __WEBPACK_IMPORTED_MODULE_8_classnames___default()({ clickable: !props.disabled });

  var renderRow = function renderRow(lineItem, i, HiddenTd, HiddenTeardownTd) {
    var startColumns = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      {
        key: i,
        className: clickable,
        onClick: function onClick() {
          if (!props.disabled) {
            props.onItemClick(lineItem);
          }
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        i + 1
      ),
      Object.keys(startColumns).map(function (k) {
        var Component = startColumns[k];
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { key: k },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, { lineItem: lineItem })
        );
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_PartNumber_PartNumber__["a" /* default */], {
          part: {
            id: lineItem.part_id,
            part_number: lineItem.part.part_number,
            uuid: lineItem.part.uuid
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        lineItem.inventory ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* Link */],
          { to: "/inventories/" + lineItem.inventory.uuid },
          lineItem.original_serial_number || lineItem.serial_number
        ) : lineItem.original_serial_number || lineItem.serial_number
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        HiddenTd,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_PartNumber_PartNumber__["a" /* default */], { part: lineItem.mod_to })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_21__constants__["J" /* ACTIONS_REQUESTED */][lineItem.action_requested].label
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__StatusNote__["a" /* default */], { lineItem: lineItem })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        HiddenTd,
        { className: "text-center" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__StatusBadges__["a" /* default */], { lineItem: lineItem }),
        lineItem.inventory && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "inventory.status") === "sales_order_created" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["j" /* NoteTooltip */], {
          placement: "right",
          icon: "fa-paper-plane",
          note: "Pending Sale"
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__RequiredComponentTooltip__["a" /* default */], { lineItem: lineItem })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          HiddenTd,
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["o" /* LocationFlag */], {
            location: lineItem.return_to_location_id,
            unknownFlag: false
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        HiddenTd,
        { className: "text-success text-center" },
        lineItem.exchange && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* ExchangeIcon */], { lineItem: lineItem })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        lineItem.work_order_number
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__constants__["p" /* getConditionAbbrev */])(lineItem.condition_sent),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "inventory.as_is") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__parts_components_HoverFlag__["a" /* default */], { text: "As-is", abbr: "AI", inline: true })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__constants__["p" /* getConditionAbbrev */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "inventory.condition"))
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-center" },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_date__["c" /* shortDateYY */])(lineItem.eval_due_date)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-center" },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_date__["c" /* shortDateYY */])(lineItem.expected_date)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-right" },
        lineItem.quantity
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-right" },
        lineItem.received && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "text-muted spacing-right" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: "cloud-download" }),
          " "
        ),
        lineItem.quantity_received
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        HiddenTeardownTd,
        { className: "text-right" },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_currency__["a" /* dollars */])(lineItem.transfer_cost * Number(lineItem.quantity))
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-right" },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers__["f" /* totalCostEvalColumn */])(lineItem)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-right" },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers__["g" /* extCostEvalColumn */])(lineItem)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        (lineItem.internal_note || lineItem.external_note) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["j" /* NoteTooltip */], {
          note: [lineItem.internal_note, lineItem.external_note].filter(function (note) {
            return note;
          }).join(" | ")
        })
      ),
      !lineItem.scrap_report && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__LineItemControls__["a" /* default */], {
        lineItem: lineItem,
        returnItemModalOpen: props.returnItemModalOpen,
        toggleReturnModal: function toggleReturnModal() {
          return props.toggleReturnItemModal(lineItem);
        }
      })
    );
  };

  var results = props.results,
      _props$startColumns = props.startColumns,
      startColumns = _props$startColumns === undefined ? {} : _props$startColumns,
      _props$endColumns = props.endColumns,
      endColumns = _props$endColumns === undefined ? {} : _props$endColumns;

  var _hiddenEnhancer = hiddenEnhancer(results.some(function (r) {
    return r.action_requested === __WEBPACK_IMPORTED_MODULE_21__constants__["r" /* SHOP_ASSIST */];
  })),
      HiddenTd = _hiddenEnhancer.HiddenTd,
      HiddenTh = _hiddenEnhancer.HiddenTh;

  var _hiddenEnhancer2 = hiddenEnhancer(!results.some(function (r) {
    return r.action_requested === __WEBPACK_IMPORTED_MODULE_21__constants__["b" /* TEARDOWN */];
  })),
      HiddenTeardownTd = _hiddenEnhancer2.HiddenTd,
      HiddenTeardownTh = _hiddenEnhancer2.HiddenTh;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-striped table-hover table-numbered" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Part #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Serial #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          HiddenTh,
          null,
          "Mod To"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Action Req."
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          HiddenTh,
          { className: "text-center" },
          "Eval Status"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            HiddenTh,
            { className: "text-center" },
            "Return Store"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          HiddenTh,
          { className: "text-center" },
          "Exch"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "WO #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "CD Sent"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Inv CD"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Eval Due"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-center" },
          "Expected"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "QTY"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Rec."
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          HiddenTeardownTh,
          { className: "text-right" },
          "Transfer Cost"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Total Cost/Eval"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Ext Cost/Eval"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      results.map(function (r, i) {
        return renderRow(r, i, HiddenTd, HiddenTeardownTd, startColumns, endColumns);
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { style: { backgroundColor: "transparent" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right", colSpan: 20 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            { className: "margin-top-none margin-bottom-none" },
            "Total: ",
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers__["h" /* totalRepairOrderCost */])(results)
          )
        )
      )
    )
  );
};

var DefaultRepairOrderTable = function DefaultRepairOrderTable(props) {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      returnItemModalOpen = _useState2[0],
      setReturnItemModalOpen = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState4 = _slicedToArray(_useState3, 2),
      modalOpen = _useState4[0],
      setModalOpen = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState6 = _slicedToArray(_useState5, 2),
      lineItem = _useState6[0],
      setLineItem = _useState6[1];

  var openModal = function openModal(l) {
    setModalOpen(true);
    setLineItem(l);
  };

  var closeModal = function closeModal() {
    return setModalOpen(false);
  };

  var toggleReturnItemModal = function toggleReturnItemModal(item) {
    setReturnItemModalOpen(returnItemModalOpen === item.id ? false : item.id);
  };

  var repairOrder = props.repairOrder,
      results = props.results;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Table, {
      results: results,
      onItemClick: openModal,
      returnItemModalOpen: returnItemModalOpen,
      toggleReturnItemModal: toggleReturnItemModal,
      startColumns: {
        "": function _(_ref) {
          var item = _ref.lineItem;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            item.exchange && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["j" /* NoteTooltip */], {
              icon: "fa-exchange",
              placement: "top",
              note: "Core Return",
              color: "#FFFFFF"
            })
          );
        }
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["b" /* Authorized */],
      {
        roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_3__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_3__users_constants__["j" /* WAREHOUSE */]),
        subroles: __WEBPACK_IMPORTED_MODULE_3__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Edit__["a" /* default */], {
        open: modalOpen,
        close: closeModal,
        repairOrder: repairOrder,
        lineItem: lineItem,
        openReturnModal: toggleReturnItemModal
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "nav",
      {
        key: "pagination",
        className: "text-center margin-top-none",
        "aria-label": "Search results pages"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__orange_marmalade_paginate_this__["Paginator"], {
        listId: "repairOrders/lineItems",
        lineItems: results,
        repairOrder: repairOrder
      })
    )
  );
};

DefaultRepairOrderTable.propTypes = {
  repairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

var withListId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["d" /* translateProps */])(function () {
  return {
    listId: "repairOrders/lineItems"
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withListId(__WEBPACK_IMPORTED_MODULE_7__orange_marmalade_paginate_this__["decorators"].tabulate(DefaultRepairOrderTable)));

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Form__ = __webpack_require__(696);
/* unused harmony export Edit */
















var FORM_NAME = "repairOrderLineItem";

function Edit(_ref) {
  var askingAfterInternalOutright = _ref.askingAfterInternalOutright,
      canOverrideReadOnly = _ref.canOverrideReadOnly,
      readOnly = _ref.readOnly,
      open = _ref.open,
      close = _ref.close,
      _ref$lineItem = _ref.lineItem,
      lineItem = _ref$lineItem === undefined ? {} : _ref$lineItem,
      repairOrder = _ref.repairOrder,
      onSubmit = _ref.onSubmit,
      canReleaseForShipment = _ref.canReleaseForShipment;

  var internalOutrightId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "inventory.internal_outright_sales_item_id");
  var mostRecentSalesItemId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "inventory.most_recent_sales_order.sales_item_id");
  var reclaimed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "inventory.reclaimed");

  var shouldAskInternalOutright = internalOutrightId === mostRecentSalesItemId;

  var shopAssistValues = function shopAssistValues() {
    if (lineItem && lineItem.action_requested === __WEBPACK_IMPORTED_MODULE_9__constants__["r" /* SHOP_ASSIST */]) {
      return {
        id: lineItem.shop_assist_repair_order_id,
        code: lineItem.shop_assist_repair_order_code
      };
    }
    return null;
  };
  var filteredInitialValues = canReleaseForShipment ? lineItem : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_removeKey__["a" /* default */])(lineItem, "release_for_shipment");

  filteredInitialValues[__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["M" /* OTHER */]] = filteredInitialValues[__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["N" /* OTHER_TAG_TYPE */]] && filteredInitialValues[__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["N" /* OTHER_TAG_TYPE */]].length > 0;

  filteredInitialValues[__WEBPACK_IMPORTED_MODULE_9__constants__["_3" /* CORE_RETURN_FEE_SAVINGS */]] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers__["e" /* coreReturnFeeSavingsVal */])(lineItem.flat_exchange ? lineItem.not_to_exceed : lineItem.original_evaluation, lineItem.subtotal);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-lg" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          askingAfterInternalOutright ? "Internal Outright Cost Application" : "Edit a Part",
          reclaimed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { style: { marginLeft: "10px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components__["p" /* StatusTag */], {
              display: "warning",
              title: "Reclaimed",
              icon: "superpowers"
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Form__["a" /* default */], {
        onSubmit: onSubmit,
        close: close,
        initialValues: filteredInitialValues,
        repairOrder: repairOrder,
        lineItem: lineItem,
        editing: true,
        readOnly: readOnly && !canOverrideReadOnly,
        shopAssistRepairOrder: shopAssistValues(),
        shouldAskInternalOutright: shouldAskInternalOutright,
        part: {
          id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "part.id"),
          part_number: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "part.part_number"),
          tier_type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "part.tier_type")
        },
        modTo: {
          id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "mod_to.id"),
          part_number: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "mod_to.part_number")
        }
      })
    )
  );
}

Edit.propTypes = {
  askingAfterInternalOutright: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  canOverrideReadOnly: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  readOnly: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  open: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  repairOrder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),
  lineItem: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}),
  canReleaseForShipment: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    askingAfterInternalOutright: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_redux_form__["formValueSelector"])(FORM_NAME)(state, "asking_internal_outright"),
    canReleaseForShipment: state.session.getIn([__WEBPACK_IMPORTED_MODULE_6__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_6__users_constants__["h" /* ROLE */]]) === __WEBPACK_IMPORTED_MODULE_6__users_constants__["i" /* ADMIN */] || state.session.getIn([__WEBPACK_IMPORTED_MODULE_6__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_6__users_constants__["_12" /* CAN_RELEASE_SHIPMENT */]]),
    canOverrideReadOnly: [__WEBPACK_IMPORTED_MODULE_6__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_6__users_constants__["p" /* QUALITY_CONTROL */]].includes(state.session.getIn([__WEBPACK_IMPORTED_MODULE_6__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_6__users_constants__["h" /* ROLE */]])),
    getFieldValue: function getFieldValue(field) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_redux_form__["formValueSelector"])(FORM_NAME)(state, field);
    }
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions__["g" /* updateROLineItem */])(ownProps.lineItem.id, data, ownProps));
    }
  };
})(Edit));

/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ActionFormSection__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(28);
/* harmony export (immutable) */ __webpack_exports__["a"] = ActionRequestedSection;










var getFieldName = function getFieldName(index) {
  if (index !== undefined) {
    return "line_items[" + index + "].action_requested";
  }
  return "action_requested";
};

function ActionRequestedSection(_ref) {
  var actions = _ref.actions,
      change = _ref.change,
      exchange = _ref.exchange,
      setField = _ref.setField,
      getField = _ref.getField,
      getInitialFieldValue = _ref.getInitialFieldValue,
      shopAssistRepairOrder = _ref.shopAssistRepairOrder,
      repairOrder = _ref.repairOrder,
      _ref$index = _ref.index,
      index = _ref$index === undefined ? undefined : _ref$index,
      _ref$editing = _ref.editing,
      editing = _ref$editing === undefined ? false : _ref$editing,
      _ref$nested = _ref.nested,
      nested = _ref$nested === undefined ? false : _ref$nested,
      originalEvalGreaterThanOutrightVal = _ref.originalEvalGreaterThanOutrightVal,
      outrightValue = _ref.outrightValue,
      tierType = _ref.tierType,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$showEvaluationFi = _ref.showEvaluationFields,
      showEvaluationFields = _ref$showEvaluationFi === undefined ? true : _ref$showEvaluationFi,
      _ref$onActionChange = _ref.onActionChange,
      onActionChange = _ref$onActionChange === undefined ? function () {} : _ref$onActionChange;

  var name = getFieldName(index);
  var action = getField(name);
  var isDisabledTeardown = !getField(__WEBPACK_IMPORTED_MODULE_6__constants__["_26" /* RECEIVED */]) && getField(__WEBPACK_IMPORTED_MODULE_8__constants__["E" /* ACTION_REQUESTED */]) === __WEBPACK_IMPORTED_MODULE_8__constants__["b" /* TEARDOWN */] && [__WEBPACK_IMPORTED_MODULE_8__constants__["t" /* REPAIR_EVALUATION_REJECTED */], __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* REPAIR_EVALUATION_APPROVED */]].includes(getField(__WEBPACK_IMPORTED_MODULE_8__constants__["s" /* APPROVAL_STATUS */]));
  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      className: "row row-col-gutters-half",
      style: { marginTop: 10 },
      key: "repairs_0"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 6 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        name: name,
        component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["c" /* Select */],
        options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["a" /* toOptions */])(actions),
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["E" /* ACTION_REQUESTED */]),
        required: true,
        disabled: disabled || editing && (getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["E" /* ACTION_REQUESTED */]) === __WEBPACK_IMPORTED_MODULE_8__constants__["z" /* EXPECTED_COMPONENT */] || isDisabledTeardown),
        onChange: onActionChange
      })
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { key: "repairs_1" },
    action && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ActionFormSection__["a" /* default */], {
      action: action,
      change: change,
      exchange: exchange,
      repairOrder: repairOrder,
      setField: setField,
      getField: getField,
      getInitialFieldValue: getInitialFieldValue,
      editing: editing,
      index: index,
      shopAssistRepairOrder: shopAssistRepairOrder,
      nested: nested,
      originalEvalGreaterThanOutrightVal: originalEvalGreaterThanOutrightVal,
      outrightValue: outrightValue,
      showEvaluationFields: showEvaluationFields,
      tierType: tierType,
      disabled: disabled
    })
  )];
}

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony export (immutable) */ __webpack_exports__["a"] = ExchangeWarning;


function ExchangeWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "row m-r-10" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "col-sm-12" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "alert alert-warning" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "media" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "media-left" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-warning text-warning" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "media-body" },
            "Heads Up - Don't forget to select 'Exchange Gone",
            " ",
            "Outright' button, if applicable, to notify the exchange manager to create the outright sales order."
          )
        )
      )
    )
  );
}

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_history_PathUtils__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(28);
/* harmony export (immutable) */ __webpack_exports__["a"] = InternalOutrightConsiderationWarning;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ACTION_CONDITION_MAP;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var ACTION_CONDITION_MAPPING = (_ACTION_CONDITION_MAP = {}, _defineProperty(_ACTION_CONDITION_MAP, __WEBPACK_IMPORTED_MODULE_8__constants__["G" /* BENCH_TEST */], __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["P" /* INSPECTED */]), _defineProperty(_ACTION_CONDITION_MAP, __WEBPACK_IMPORTED_MODULE_8__constants__["F" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["h" /* REPAIRED */]), _defineProperty(_ACTION_CONDITION_MAP, __WEBPACK_IMPORTED_MODULE_8__constants__["H" /* OVERHAUL */], __WEBPACK_IMPORTED_MODULE_8__constants__["_10" /* OVERHAULED */]), _ACTION_CONDITION_MAP);

function InternalOutrightConsiderationWarning(_ref) {
  var actionRequested = _ref.actionRequested,
      condition = _ref.condition,
      inventoryId = _ref.inventoryId,
      outrightValue = _ref.outrightValue,
      originalEval = _ref.originalEval,
      partId = _ref.partId,
      tierType = _ref.tierType;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      matchedInventory = _useState2[0],
      setMatchedInventory = _useState2[1];

  if (![__WEBPACK_IMPORTED_MODULE_8__constants__["G" /* BENCH_TEST */], __WEBPACK_IMPORTED_MODULE_8__constants__["F" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_8__constants__["H" /* OVERHAUL */]].includes(actionRequested)) return null;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].inventories.search({
      exclude_inventory_id: inventoryId,
      matching_condition: ACTION_CONDITION_MAPPING[actionRequested],
      part_id: partId,
      ranking: true,
      sort: "id",
      sellable_status: [__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["U" /* LIST */], __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["W" /* DO_NOT_LIST */]].join(","),
      limit: 1
    }).then(function (res) {
      setMatchedInventory(res.data.results[0]);
    }).catch(function () {
      return setMatchedInventory(null);
    });

    return function cleanup() {};
  }, [inventoryId, partId, condition]);

  var margin = Math.abs(parseFloat(originalEval) / parseFloat(outrightValue) * 100 - 100);

  var inventorySrp = matchedInventory && matchedInventory.suggested_retail;

  var withinTenPercent = function withinTenPercent() {
    return inventorySrp && Math.abs(parseFloat(originalEval) / parseFloat(inventorySrp) * 100 - 100) < 10;
  };

  var marginBrackets = { ATL: 10, BTL: 20, BBTL: 30, SATL: 10, ZTL: 40 };

  var warningText = "This item qualifies for " + __WEBPACK_IMPORTED_MODULE_3__parts_constants__["J" /* TIER_TYPES_MAP */][tierType] + " and original evaluation is within\n    " + marginBrackets[tierType] + "% of Outright Value.";
  var showWarning = false;

  var hasTierType = [__WEBPACK_IMPORTED_MODULE_3__parts_constants__["c" /* ATL */], __WEBPACK_IMPORTED_MODULE_3__parts_constants__["e" /* BTL */], __WEBPACK_IMPORTED_MODULE_3__parts_constants__["f" /* BBTL */], __WEBPACK_IMPORTED_MODULE_3__parts_constants__["b" /* SATL */], __WEBPACK_IMPORTED_MODULE_3__parts_constants__["d" /* ZTL */]].includes(tierType);

  if (hasTierType && margin <= marginBrackets[tierType]) {
    showWarning = true;
  } else if (!__WEBPACK_IMPORTED_MODULE_6_history_PathUtils__["hasBasename"] && margin <= 50) {
    showWarning = true;
    warningText = "This item does not qualify at any Tier and the original evaluation is within\n      50% of Outright Value.";
  }

  if (withinTenPercent() && !showWarning) {
    showWarning = true;

    warningText = hasTierType ? "This item qualifies for " + __WEBPACK_IMPORTED_MODULE_3__parts_constants__["J" /* TIER_TYPES_MAP */][tierType] + " and original evaluation is within 10% of next matching condition SRP." : "This item does not qualify at any Tier and is within 10% of the next matching condition SRP.";
  }

  if (!showWarning) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "row m-r-10" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { sm: 12 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Warning_Warning__["a" /* default */],
        null,
        warningText + "  This item should be considered for Internal Outright."
      )
    )
  );
}

InternalOutrightConsiderationWarning.propTypes = {
  actionRequested: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  inventoryId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  partId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  outrightValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  originalEval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  tierType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StatusBadges__ = __webpack_require__(244);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ROLineItemsTable = function (_Component) {
  _inherits(ROLineItemsTable, _Component);

  function ROLineItemsTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ROLineItemsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ROLineItemsTable.__proto__ || Object.getPrototypeOf(ROLineItemsTable)).call.apply(_ref, [this].concat(args))), _this), _this.fieldName = function (baseName) {
      if (_this.props.index !== undefined) {
        return "line_items[" + _this.props.index + "]." + baseName;
      }
      return baseName;
    }, _this.handleChange = function (_ref2) {
      var id = _ref2.id;

      _this.props.setField(_this.fieldName("repaired_line_item_id"), id);
    }, _this.renderRow = function (lineItem, i) {
      var lineItemName = _this.props.index !== undefined ? "line_items[" + _this.props.index + "].repaired_line_item_id" : "repaired_line_item_id";
      var disabled = _this.props.disabled;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: i },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          i + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            type: "radio",
            name: "line_items[" + _this.props.index + "][" + lineItem.id + "].read_only_repair_id",
            className: "radio-inline",
            checked: lineItem.id === _this.props.getField(lineItemName),
            onChange: function onChange() {
              return _this.handleChange(lineItem);
            },
            disabled: disabled
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.part.part_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.serial_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_4__constants__["J" /* ACTIONS_REQUESTED */][lineItem.action_requested].label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StatusBadges__["a" /* default */], { status: lineItem.approval_status })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.condition && __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["r" /* INVENTORIES */].condition[lineItem.condition].abbrev
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          lineItem.quantity
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ROLineItemsTable, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          nested = _props.nested,
          _props$results = _props.results,
          results = _props$results === undefined ? [] : _props$results;

      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("table table-striped table-hover table-numbered", {
        nested: nested
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "table",
        { className: classes },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Part #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Serial #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "ACTION REQ."
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Status"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "CD"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "QTY"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tbody",
          null,
          results.filter(function (i) {
            return i.action_requested !== __WEBPACK_IMPORTED_MODULE_4__constants__["r" /* SHOP_ASSIST */];
          }).map(this.renderRow)
        )
      );
    }
  }]);

  return ROLineItemsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ROLineItemsTable.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })).isRequired,
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  nested: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (ROLineItemsTable);

/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators_translateProps__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RepairAndHoldSection__ = __webpack_require__(1706);
/* unused harmony export CostSection */











function CostSection(_ref) {
  var disabled = _ref.disabled,
      evalNotRejected = _ref.evalNotRejected,
      finalEvalApproved = _ref.finalEvalApproved,
      getField = _ref.getField,
      hasAssistItems = _ref.hasAssistItems,
      requestedAction = _ref.requestedAction,
      scrapped = _ref.scrapped,
      setFieldValue = _ref.setFieldValue;

  var subtotal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["d" /* calculateSubtotal */])(getField);

  var coreReturnSavingsComparator = getField(__WEBPACK_IMPORTED_MODULE_8__SalesOrders_constants__["e" /* FLAT_EXCHANGE */]) ? getField(__WEBPACK_IMPORTED_MODULE_6__constants__["_6" /* NOT_TO_EXCEED */]) : getField(__WEBPACK_IMPORTED_MODULE_6__constants__["I" /* ORIGINAL_EVALUATION */]);

  var evalApproved = getField(__WEBPACK_IMPORTED_MODULE_6__constants__["s" /* APPROVAL_STATUS */]) === __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* REPAIR_EVALUATION_APPROVED */];
  var originalEval = getField(__WEBPACK_IMPORTED_MODULE_6__constants__["I" /* ORIGINAL_EVALUATION */]) != null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["q" /* FormRow */],
      null,
      evalNotRejected && !scrapped && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 3, key: "ro-item-part-cost" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["f" /* CurrencyField */], {
          name: __WEBPACK_IMPORTED_MODULE_6__constants__["_2" /* PART_COST */],
          label: "Parts Cost",
          required: evalApproved || originalEval,
          disabled: finalEvalApproved || disabled,
          onChange: function onChange(ev, val) {
            if (getField(__WEBPACK_IMPORTED_MODULE_6__constants__["c" /* EXCHANGE */])) {
              setFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["_3" /* CORE_RETURN_FEE_SAVINGS */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["e" /* coreReturnFeeSavingsVal */])(coreReturnSavingsComparator, subtotal([__WEBPACK_IMPORTED_MODULE_6__constants__["_0" /* LABOR_COST */], __WEBPACK_IMPORTED_MODULE_6__constants__["_1" /* OUTSIDE_LABOR_COST */]], val)));
            }
          }
        })
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 3, key: "ro-item-labor-cost" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["f" /* CurrencyField */], {
          name: __WEBPACK_IMPORTED_MODULE_6__constants__["_0" /* LABOR_COST */],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["_0" /* LABOR_COST */]),
          required: evalApproved || originalEval,
          disabled: finalEvalApproved || disabled,
          onChange: function onChange(ev, val) {
            if (getField(__WEBPACK_IMPORTED_MODULE_6__constants__["c" /* EXCHANGE */])) {
              setFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["_3" /* CORE_RETURN_FEE_SAVINGS */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["e" /* coreReturnFeeSavingsVal */])(coreReturnSavingsComparator, subtotal([__WEBPACK_IMPORTED_MODULE_6__constants__["_1" /* OUTSIDE_LABOR_COST */], __WEBPACK_IMPORTED_MODULE_6__constants__["_2" /* PART_COST */]], val)));
            }
          }
        })
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 3, key: "ro-item-outside-labor-cost" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["f" /* CurrencyField */], {
          name: __WEBPACK_IMPORTED_MODULE_6__constants__["_1" /* OUTSIDE_LABOR_COST */],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["_1" /* OUTSIDE_LABOR_COST */]),
          disabled: finalEvalApproved || disabled,
          onChange: function onChange(ev, val) {
            if (getField(__WEBPACK_IMPORTED_MODULE_6__constants__["c" /* EXCHANGE */])) {
              setFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["_3" /* CORE_RETURN_FEE_SAVINGS */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers__["e" /* coreReturnFeeSavingsVal */])(coreReturnSavingsComparator, subtotal([__WEBPACK_IMPORTED_MODULE_6__constants__["_0" /* LABOR_COST */], __WEBPACK_IMPORTED_MODULE_6__constants__["_2" /* PART_COST */]], val)));
            }
          }
        })
      )],
      hasAssistItems && evalNotRejected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["f" /* CurrencyField */], {
          name: __WEBPACK_IMPORTED_MODULE_6__constants__["_4" /* SHOP_ASSIST_COST */],
          value: getField(__WEBPACK_IMPORTED_MODULE_6__constants__["_4" /* SHOP_ASSIST_COST */]),
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["_4" /* SHOP_ASSIST_COST */]),
          disabled: true,
          readonly: true
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["q" /* FormRow */],
      null,
      requestedAction !== __WEBPACK_IMPORTED_MODULE_6__constants__["r" /* SHOP_ASSIST */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__RepairAndHoldSection__["a" /* default */], {
        disabled: disabled,
        getField: getField,
        setFieldValue: setFieldValue
      })
    )
  );
}

var withApprovalStatus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators_translateProps__["a" /* default */])(function (_ref2) {
  var getField = _ref2.getField,
      lineItem = _ref2.lineItem;
  return {
    evalNotRejected: getField(__WEBPACK_IMPORTED_MODULE_6__constants__["s" /* APPROVAL_STATUS */]) !== __WEBPACK_IMPORTED_MODULE_6__constants__["t" /* REPAIR_EVALUATION_REJECTED */],
    hasAssistItems: lineItem.get("shop_assist_line_items", []).length > 0,
    scrapped: lineItem.get("scrap_report"),
    finalEvalApproved: getField(__WEBPACK_IMPORTED_MODULE_6__constants__["X" /* FINAL_EVALUATION_APPROVED */])
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withApprovalStatus(CostSection));

CostSection.propTypes = {
  evalNotRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hasAssistItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  finalEvalApproved: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  requestedAction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  scrapped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = ExchangeSection;








function ExchangeSection(_ref) {
  var getField = _ref.getField,
      getInitialFieldValue = _ref.getInitialFieldValue,
      requestedAction = _ref.requestedAction,
      originalEvalGreaterThanOutrightVal = _ref.originalEvalGreaterThanOutrightVal,
      disabled = _ref.disabled;

  return requestedAction !== __WEBPACK_IMPORTED_MODULE_3__constants__["r" /* SHOP_ASSIST */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["q" /* FormRow */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed", key: "approvals-dashed" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h5",
      { className: "h4", key: "approval-header" },
      "Exchange"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["q" /* FormRow */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["q" /* FormRow */],
      { key: "exchange_body" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: "btn-group btn-group-justified btn-group-vertical",
              "data-toggle": "buttons"
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_3__constants__["V" /* INTERNAL_OUTRIGHT */],
              component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_3__constants__["V" /* INTERNAL_OUTRIGHT */]),
              icon: "fa-check-circle",
              disabled: disabled || getField(__WEBPACK_IMPORTED_MODULE_3__constants__["_14" /* RECOVERED_REPAIR_FROM_INTERNAL_OUTRIGHT */])
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: "btn-group btn-group-justified btn-group-vertical",
              "data-toggle": "buttons"
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_3__constants__["u" /* EXCHANGE_GONE_OUTRIGHT */],
              component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */],
              disabled: !originalEvalGreaterThanOutrightVal || getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_3__constants__["u" /* EXCHANGE_GONE_OUTRIGHT */]) || disabled,
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_3__constants__["u" /* EXCHANGE_GONE_OUTRIGHT */]),
              icon: "fa-check-circle"
            })
          )
        )
      ),
      getField(__WEBPACK_IMPORTED_MODULE_3__constants__["V" /* INTERNAL_OUTRIGHT */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: "btn-group btn-group-justified btn-group-vertical",
              "data-toggle": "buttons"
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_3__constants__["_14" /* RECOVERED_REPAIR_FROM_INTERNAL_OUTRIGHT */],
              component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */],
              label: ["Recovered Repair", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["j" /* NoteTooltip */], {
                icon: "fa-info-circle",
                placement: "top",
                color: "rgba(255, 255, 255, 0.25)",
                note: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_3__constants__["_14" /* RECOVERED_REPAIR_FROM_INTERNAL_OUTRIGHT */])
              })],
              icon: "fa-check-circle"
            })
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: "btn-group btn-group-justified btn-group-vertical",
              "data-toggle": "buttons"
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: "repair_charges_invoice",
              component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */],
              label: "Repair Charges Invoiced",
              icon: "fa-check-circle",
              disabled: disabled
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: "btn-group btn-group-justified btn-group-vertical",
              "data-toggle": "buttons"
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: "repair_charges_paid",
              component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */],
              label: "Repair Charges Paid",
              icon: "fa-check-circle",
              disabled: disabled
            })
          )
        )
      )
    )
  );
}

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_NoteTooltip_NoteTooltip__ = __webpack_require__(120);











function ExpectedComponentSection(_ref) {
  var disabled = _ref.disabled,
      getInitialFieldValue = _ref.getInitialFieldValue,
      getFieldValue = _ref.getFieldValue,
      setFieldValue = _ref.setFieldValue,
      requestedAction = _ref.requestedAction;

  if (requestedAction !== __WEBPACK_IMPORTED_MODULE_8__constants__["z" /* EXPECTED_COMPONENT */]) {
    return null;
  }

  var setRemainingCost = function setRemainingCost() {
    var initialRemainingCost = getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["_18" /* REMAINING_COST */]);
    var initialTransferCost = getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["T" /* TRANSFER_COST */]) || 0;
    var transferCost = getFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["T" /* TRANSFER_COST */]) || 0;
    var initialQuantity = getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["j" /* QUANTITY */]) || 0;
    var quantity = getFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["j" /* QUANTITY */]) || 0;

    var newval = Number(initialRemainingCost) - Number(transferCost) * Number(quantity) - Number(initialTransferCost) * Number(initialQuantity);

    newval = newval < 0 ? 0 : newval;

    setFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["_18" /* REMAINING_COST */])(newval);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
      { md: 4 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
        name: __WEBPACK_IMPORTED_MODULE_7__constants__["j" /* QUANTITY */],
        component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
        label: "Qty",
        onBlur: setRemainingCost,
        disabled: Number(getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["j" /* QUANTITY */])) > 0,
        required: true
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
      { md: 4 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["f" /* CurrencyField */], {
        name: __WEBPACK_IMPORTED_MODULE_8__constants__["T" /* TRANSFER_COST */],
        label: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["T" /* TRANSFER_COST */]), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_NoteTooltip_NoteTooltip__["a" /* default */], {
          color: "rgba(255, 255, 255, 0.25)",
          icon: "fa-info-circle",
          note: "Please indicate amount of remaining cost to transfer from the main component to this sub-component"
        })],
        onBlur: setRemainingCost,
        disabled: disabled,
        required: [__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* REPAIR_EVALUATION_APPROVED */], __WEBPACK_IMPORTED_MODULE_8__constants__["t" /* REPAIR_EVALUATION_REJECTED */]].includes(getFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["s" /* APPROVAL_STATUS */]))
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
      { md: 4 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
        name: __WEBPACK_IMPORTED_MODULE_8__constants__["_18" /* REMAINING_COST */],
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_18" /* REMAINING_COST */]),
        disabled: true,
        component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["f" /* CurrencyField */]
      })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(ExpectedComponentSection));

ExpectedComponentSection.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  requestedAction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony export (immutable) */ __webpack_exports__["a"] = NotesSection;




function NotesSection(_ref) {
  var disabled = _ref.disabled;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm", key: 0 }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "h5",
    { className: "h4", key: 1 },
    "Notes"
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "row row-col-gutters-half", key: 2 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "col-md-6" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        name: "internal_note",
        rows: 5,
        cols: 50,
        component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["l" /* TextArea */],
        label: "Internal Note",
        disabled: disabled
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "col-md-6" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        name: "external_note",
        rows: 5,
        cols: 50,
        component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["l" /* TextArea */],
        label: "External Note",
        disabled: disabled
      })
    )
  )];
}

/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var InventoryTable = function (_Component) {
  _inherits(InventoryTable, _Component);

  function InventoryTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InventoryTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InventoryTable.__proto__ || Object.getPrototypeOf(InventoryTable)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (_ref2) {
      var id = _ref2.id,
          condition = _ref2.condition,
          correctSerialNumber = _ref2.correct_serial_number,
          quantity = _ref2.quantity,
          incomingAWB = _ref2.incoming_awb_number,
          dateReceived = _ref2.date_received,
          conditionReceived = _ref2.condition_received,
          serialNumber = _ref2.serial_number,
          serialNumberCorrectionRequired = _ref2.serial_number_correction_required;

      _this.props.setField(__WEBPACK_IMPORTED_MODULE_5__constants__["_21" /* INVENTORY_ID */], id);
      _this.props.setField(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["n" /* CONDITION */], condition);
      _this.props.setField("condition_received", conditionReceived);
      _this.props.setField("incoming_awb_number", incomingAWB);
      _this.props.setField("quantity", quantity);
      _this.props.setField("date_received", dateReceived);
      _this.props.setField("cancelled", false);
      if (serialNumberCorrectionRequired) {
        _this.props.setField("external_note", "Please reidentify Serial # " + serialNumber + ". The correct Serial # appears to be " + correctSerialNumber);
      }
    }, _this.renderRow = function (lineItem, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: i },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          i + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            type: "radio",
            name: "read_only_inv",
            className: "radio-inline",
            checked: lineItem.id === _this.props.getField(__WEBPACK_IMPORTED_MODULE_5__constants__["_21" /* INVENTORY_ID */]),
            onChange: function onChange() {
              _this.handleChange(lineItem);
              _this.props.notifyForm(lineItem);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.serial_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.condition && __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["r" /* INVENTORIES */].condition[lineItem.condition].abbrev
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.quantity
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__["d" /* alphaMonthYear */])(lineItem.tag_date)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.srp_condition && __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["r" /* INVENTORIES */].condition[lineItem.srp_condition].abbrev
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          lineItem.suggested_retail && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(lineItem.suggested_retail)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          lineItem.exchange_srp && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(lineItem.exchange_srp)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          lineItem.cost_per_unit && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(lineItem.cost_per_unit)
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InventoryTable, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "col-md-12" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "table",
          { className: "table table-striped table-hover table-numbered" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Serial Number"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "CD"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "QTY"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Tag Date"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "SRP CD"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "SRP"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "Exch SRP"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "Cost EA."
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tbody",
            null,
            this.props.results.map(this.renderRow)
          )
        )
      );
    }
  }]);

  return InventoryTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

InventoryTable.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })).isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (InventoryTable);


InventoryTable.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,
  notifyForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InventoryTable__ = __webpack_require__(1704);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var PartDetailsSection = function (_React$Component) {
  _inherits(PartDetailsSection, _React$Component);

  function PartDetailsSection() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PartDetailsSection);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PartDetailsSection.__proto__ || Object.getPrototypeOf(PartDetailsSection)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedPart: {},
      selectedModTo: {},
      inventory: []
    }, _this.handlePartSelected = function (part) {
      if (part && part.id && _this.props.requestedAction !== __WEBPACK_IMPORTED_MODULE_5__constants__["z" /* EXPECTED_COMPONENT */]) {
        _this.props.searchInventories(part.id, {
          repair_status: "reserve_for_repair,reserve_for_shop_assist",
          sort: "id"
        }).then(function (results) {
          _this.setState({ inventory: results });
        });
      }
      _this.setState({ selectedPart: part });
    }, _this.handleModToSelected = function (part) {
      return _this.setState({ selectedModTo: part });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PartDetailsSection, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.part) {
        this.handlePartSelected(this.props.part);
      }

      if (this.props.modTo) {
        this.handleModToSelected(this.props.modTo);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          queryParts = _props.queryParts,
          queryPartsByStatus = _props.queryPartsByStatus,
          getField = _props.getField,
          setField = _props.setField,
          notifyForm = _props.notifyForm,
          editing = _props.editing,
          disabled = _props.disabled,
          requestedAction = _props.requestedAction;
      var _state = this.state,
          selectedPart = _state.selectedPart,
          selectedModTo = _state.selectedModTo,
          inventory = _state.inventory;

      var searchParts = requestedAction === __WEBPACK_IMPORTED_MODULE_5__constants__["z" /* EXPECTED_COMPONENT */] ? queryParts : queryPartsByStatus;

      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "nav nav-tabs", key: "part_form_header" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Part Details"
        )
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "row row-col-gutters-half",
          style: { marginTop: 10 },
          key: "part_form_1"
        },
        !editing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["q" /* PART_ID */],
            label: "Part #",
            placeholder: "Type a part's number...",
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["n" /* AutoCompleteField */],
            search: searchParts,
            selectedItem: selectedPart,
            disabled: disabled,
            formatItem: function formatItem(result) {
              return result && result.part_number;
            },
            onItemSelected: function onItemSelected(i) {
              return i && _this2.handlePartSelected(i);
            },
            required: true
          })
        ),
        ![__WEBPACK_IMPORTED_MODULE_5__constants__["r" /* SHOP_ASSIST */], __WEBPACK_IMPORTED_MODULE_5__constants__["z" /* EXPECTED_COMPONENT */], __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* TEARDOWN */]].includes(requestedAction) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* MOD_TO_ID */],
            label: "Mod To",
            addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-exchange" }),
            placeholder: "Type a part's number...",
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["n" /* AutoCompleteField */],
            search: queryParts,
            selectedItem: selectedModTo,
            formatItem: function formatItem(result) {
              return result && result.part_number;
            },
            onItemSelected: function onItemSelected(i) {
              return i && _this2.handleModToSelected(i);
            },
            disabled: disabled
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: "btn-group btn-group-justified btn-group-vertical",
                "data-toggle": "buttons"
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: "control-label", htmlFor: "for_second_opinion" },
                "Second Opinion"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: "for_second_opinion",
                  label: "Sending for Second Opinion",
                  component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
                  icon: "fa-check-circle",
                  disabled: disabled
                })
              )
            )
          )
        )
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
        { key: "part_results" },
        inventory.length > 0 && !editing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__InventoryTable__["a" /* default */], {
          results: inventory,
          getField: getField,
          setField: setField,
          notifyForm: notifyForm
        })
      )];
    }
  }]);

  return PartDetailsSection;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (PartDetailsSection);


PartDetailsSection.propTypes = {
  requestedAction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  queryParts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  queryPartsByStatus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  notifyForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchInventories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modTo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(28);











var RepairAndHoldFields = function RepairAndHoldFields(_ref) {
  var disabled = _ref.disabled,
      getField = _ref.getField,
      setFieldValue = _ref.setFieldValue;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 6 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "form-group" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "btn-group btn-group-justified btn-group-vertical",
            "data-toggle": "buttons"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_9__constants__["n" /* REPAIR_AND_HOLD */] },
            "Repair & Hold"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { backgroundColor: "#4CAF50", borderRadius: "5px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_9__constants__["n" /* REPAIR_AND_HOLD */],
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
              label: "Repair & Hold",
              icon: "fa-check-circle",
              disabled: disabled,
              onChange: function onChange(_ev, val) {
                if (val) {
                  [__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["x" /* TAG_DATE */], __WEBPACK_IMPORTED_MODULE_6__SalesOrders_constants__["n" /* EXPECTED_DATE */], __WEBPACK_IMPORTED_MODULE_9__constants__["O" /* ESTIMATED_LEAD_TIME */]].forEach(function (f) {
                    return setFieldValue(f, null);
                  });
                } else {
                  setFieldValue(__WEBPACK_IMPORTED_MODULE_9__constants__["S" /* REPAIR_AND_HOLD_LEAD_TIME */], null);
                }
              }
            })
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 6 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RepairLeadTimeField, { getField: getField, disabled: disabled })
    )
  );
};

var repairLeadTime = function repairLeadTime(_ref2) {
  var disabled = _ref2.disabled,
      repairAndHold = _ref2.repairAndHold;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_9__constants__["S" /* REPAIR_AND_HOLD_LEAD_TIME */],
    component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["h" /* NumberInput */],
    inputProps: {
      max: "99"
    },
    roundDigits: 0,
    label: "Repair & Hold LT",
    required: !!repairAndHold,
    disabled: disabled || !repairAndHold
  });
};

var withRepairAndHold = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["d" /* translateProps */])(function (_ref3) {
  var getField = _ref3.getField;
  return {
    repairAndHold: getField(__WEBPACK_IMPORTED_MODULE_9__constants__["n" /* REPAIR_AND_HOLD */])
  };
});

var RepairLeadTimeField = withRepairAndHold(repairLeadTime);

/* harmony default export */ __webpack_exports__["a"] = (RepairAndHoldFields);

RepairAndHoldFields.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

repairLeadTime.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  repairAndHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ClipboardCopy__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table__ = __webpack_require__(1708);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









function RequiredComponents(_ref) {
  var lineItem = _ref.lineItem,
      getFieldValue = _ref.getFieldValue;

  if (!lineItem) return null;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      requiredComponents = _useState2[0],
      setRequiredComponents = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.lineItems.requiredComponents.search(lineItem.id, { reverse: false }).then(function (_ref2) {
      var data = _ref2.data;

      setRequiredComponents(data.results);
    });

    return function cleanup() {};
  }, [lineItem.id]);

  if (![__WEBPACK_IMPORTED_MODULE_1__inventories_constants__["_65" /* REPAIR_EVALUATION_REJECTED */], __WEBPACK_IMPORTED_MODULE_1__inventories_constants__["_66" /* WORKING_TO_SAVE_UNIT */]].includes(getFieldValue(__WEBPACK_IMPORTED_MODULE_4__constants__["s" /* APPROVAL_STATUS */])) && requiredComponents.length === 0) {
    return null;
  }

  var partNumbers = requiredComponents.map(function (comp) {
    return comp.part.part_number;
  }).join("\n");

  var tooltip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["b" /* Tooltip */],
    { id: "tooltip-copy-all" },
    "Copy all part numbers"
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { sm: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Required Components"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["a" /* OverlayTrigger */],
          { placement: "left", overlay: tooltip },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_ClipboardCopy__["a" /* default */], {
              name: partNumbers,
              handleClick: function handleClick() {
                return navigator.clipboard.writeText(partNumbers);
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Table__["a" /* default */], { requiredComponents: requiredComponents })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (RequiredComponents);

/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RepairQuotes_constants__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_ClipboardCopy__ = __webpack_require__(339);
/* unused harmony export LineItemsTable */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var LineItemsTable = function (_Component) {
  _inherits(LineItemsTable, _Component);

  function LineItemsTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LineItemsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LineItemsTable.__proto__ || Object.getPrototypeOf(LineItemsTable)).call.apply(_ref, [this].concat(args))), _this), _this.renderRow = function (lineItem, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: lineItem.id, className: "clickable" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { whiteSpace: "nowrap" } },
            i + 1
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { whiteSpace: "nowrap" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["h" /* PartNumber */], { part: lineItem.part, statsTooltip: true })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_ClipboardCopy__["a" /* default */], {
            name: lineItem,
            handleClick: function handleClick() {
              return navigator.clipboard.writeText(lineItem.part.part_number);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3__RepairQuotes_constants__["g" /* QUOTE_TYPES_ABBREV */][lineItem.quote_type]
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.condition && __WEBPACK_IMPORTED_MODULE_5__Receiving_constants__["x" /* CONDITION_TYPES */][lineItem.condition].label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          lineItem.quantity
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(lineItem.cost)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["G" /* NoteTooltipTableCell */], { note: lineItem.note })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LineItemsTable, [{
    key: "render",
    value: function render() {
      var requiredComponents = this.props.requiredComponents;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */].Mini,
        { loading: this.props.loading, numbered: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */].Head,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Part #"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Type"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Cond"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "Qty Reqd"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Cost/Unit"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */].Body,
          null,
          requiredComponents.map(this.renderRow)
        )
      );
    }
  }]);

  return LineItemsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LineItemsTable.propTypes = {
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (LineItemsTable);

/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony export (immutable) */ __webpack_exports__["a"] = InsuranceTypeField;
/* harmony export (immutable) */ __webpack_exports__["b"] = InsuranceFields;







function InsuranceTypeField(_ref) {
  var amountInsured = _ref.amount_insured,
      percentInsured = _ref.percent_insured,
      insuranceType = _ref.insurance_type,
      disabled = _ref.disabled;

  var activePercent = __WEBPACK_IMPORTED_MODULE_3_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "Percent"
  });
  var activeAmount = __WEBPACK_IMPORTED_MODULE_3_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "Amount"
  });
  var activeNone = __WEBPACK_IMPORTED_MODULE_3_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "None"
  });

  var handleInsuranceTypeChange = function handleInsuranceTypeChange(newVal) {
    return function () {
      if (disabled) return;
      insuranceType.input.onChange(newVal);
      if (newVal === "Amount") {
        percentInsured.input.onChange(null);
      } else if (newVal === "Percent") {
        amountInsured.input.onChange(null);
      } else {
        amountInsured.input.onChange(null);
        percentInsured.input.onChange(null);
      }
    };
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group", style: { marginBottom: 20 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { className: "control-label", htmlFor: "insurance_type" },
      "Insurance"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "btn-group btn-group-justified", role: "group" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activeNone,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("None")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Do Not Insure"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activeAmount,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("Amount")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Amount"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activePercent,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("Percent")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Percent"
      )
    )
  );
}

InsuranceTypeField.propTypes = {
  amount_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  percent_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  insurance_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function AmountInsuredFields(_ref2) {
  var amount = _ref2.amount,
      disabled = _ref2.disabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "col-md-4" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["f" /* CurrencyField */], {
      name: amount.input.name,
      label: "Insurance Amount",
      disabled: disabled,
      required: true
    })
  );
}

AmountInsuredFields.propTypes = {
  amount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function PercentInsuredFields(_ref3) {
  var percent = _ref3.percent,
      cost = _ref3.cost,
      quantity = _ref3.quantity,
      disabled = _ref3.disabled;

  var costValue = cost.input.value || 0;
  var quantityValue = quantity.input.value || 0;
  var percentValue = percent.input.value || 0;
  var subtotal = parseFloat(costValue) * parseFloat(quantityValue);
  var insuranceAmount = Math.ceil(subtotal * percentValue) / 100;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
    { md: 12 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
          name: percent.input.name,
          label: "Insurance Percent",
          component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["h" /* NumberInput */],
          inputProps: {
            min: "0"
          },
          parse: function parse(value) {
            return value && parseInt(value, 10);
          },
          addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-percent" }),
          disabled: disabled,
          required: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "insurance_type" },
            "Insurance Amount"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "input-group-addon" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-dollar" })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
              className: "form-control",
              type: "text",
              value: insuranceAmount,
              disabled: true,
              readOnly: true
            })
          )
        )
      )
    )
  );
}

PercentInsuredFields.propTypes = {
  percent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function InsuranceFields(_ref4) {
  var amountInsured = _ref4.amount_insured,
      percentInsured = _ref4.percent_insured,
      insuranceType = _ref4.insurance_type,
      partCost = _ref4.part_cost,
      quantity = _ref4.quantity,
      disabled = _ref4.disabled;

  if (insuranceType.input.value === "Amount") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AmountInsuredFields, { amount: amountInsured, disabled: disabled });
  } else if (insuranceType.input.value === "Percent") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PercentInsuredFields, {
      insuranceType: insuranceType,
      percent: percentInsured,
      cost: partCost,
      quantity: quantity,
      disabled: disabled
    });
  }

  return null;
}

InsuranceFields.propTypes = {
  amount_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  percent_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  insurance_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  part_cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/***/ }),
/* 1710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_currency__ = __webpack_require__(20);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();













function HigherAssemblyTable(_ref) {
  var basicRepairOrder = _ref.repairOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      repairOrder = _useState2[0],
      setRepairOrder = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].repairOrders.show(basicRepairOrder.get(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ID */])).then(function (_ref2) {
      var data = _ref2.data;

      var newRepair = _extends({}, data, {
        line_items: data.line_items.filter(function (l) {
          return l.repaired_line_item;
        }).map(function (l) {
          return l.repaired_line_item;
        })
      });
      setRepairOrder(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_immutable__["fromJS"])(newRepair));
    });
  }, [basicRepairOrder.get(__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ID */])]);

  if (!repairOrder) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      { style: { marginTop: 26 } },
      "Higher Assembly Section"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Table__["a" /* Table */], {
      repairOrder: repairOrder,
      results: repairOrder.get("line_items").toJS(),
      startColumns: {
        "RO #": function RO(_ref3) {
          var lineItem = _ref3.lineItem;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],
            { to: "/repair-orders/" + lineItem.repair_order_id },
            lineItem.repair_order_code
          );
        }
      },
      endColumns: {
        "Total Cost": function TotalCost(_ref4) {
          var lineItem = _ref4.lineItem;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_currency__["a" /* dollars */])(Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "subtotal")));
        }
      },
      disabled: true
    })
  );
}

var ifHasShopAssist = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["a" /* renderIf */])(function (_ref5) {
  var repairOrder = _ref5.repairOrder;
  return repairOrder.get("line_items", []).some(function (l) {
    return l.get(__WEBPACK_IMPORTED_MODULE_8__constants__["E" /* ACTION_REQUESTED */]) === __WEBPACK_IMPORTED_MODULE_8__constants__["r" /* SHOP_ASSIST */];
  });
});

/* harmony default export */ __webpack_exports__["a"] = (ifHasShopAssist(HigherAssemblyTable));

HigherAssemblyTable.propTypes = {
  repairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map)
};

/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony export (immutable) */ __webpack_exports__["a"] = Body;




// TBD
var CANCELLATION_REASONS = [{ value: "previously_sold", text: "Previously Sold" }, { value: "part_deemed_ber", text: "Part Deemed B.E.R" }, { value: "vendor_cant_find", text: "Vendor Can't Find" }, { value: "unethical_behavior_detected", text: "Unethical Behavior Detected" }, { value: "cancelled_by_tenant", text: "Cancelled by Us" }, { value: "unknown", text: "Unknown" }];

function Body(_ref) {
  var _ref$reason = _ref.reason,
      reason = _ref$reason === undefined ? CANCELLATION_REASONS[0] : _ref$reason,
      updateReason = _ref.updateReason;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["e" /* Body */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "center-block alert alert-warning" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "media" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "media-left" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-warning text-warning" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "media-body" },
            "Removing this item will permanently remove it from the repair order and return the inventory to the Reserved for Repair list."
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "label",
        { className: "control-label", htmlFor: "cancellation_reason" },
        "Cancellation Reason"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "select",
        {
          className: "form-control",
          name: "cancellation_reason",
          onChange: function onChange(e) {
            return updateReason(e.target.value);
          },
          value: reason
        },
        CANCELLATION_REASONS.map(function (r) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "option",
            { key: r.value, value: r.value },
            r.text
          );
        })
      )
    )
  );
}

Body.propTypes = {
  reason: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  updateReason: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = Cancel;





function Cancel(_ref) {
  var toggle = _ref.toggle;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: toggle },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "ban", fixed: true }),
    "Remove Line Item"
  );
}

Cancel.propTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Cancel__ = __webpack_require__(700);
/* harmony export (immutable) */ __webpack_exports__["a"] = ConfirmModal;





function ConfirmModal(_ref) {
  var onConfirm = _ref.onConfirm,
      close = _ref.close,
      open = _ref.open,
      updateReason = _ref.updateReason,
      reason = _ref.reason;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Cancel__["c" /* Header */], { close: close }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Cancel__["d" /* Body */], { reason: reason, updateReason: updateReason }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Cancel__["e" /* Footer */], { close: close, onConfirm: onConfirm })
  );
}

ConfirmModal.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateReason: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  reason: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = Footer;





function Footer(_ref) {
  var close = _ref.close,
      onConfirm = _ref.onConfirm;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["d" /* Footer */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      { type: "button", className: "btn btn-default", onClick: close },
      "Cancel"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      { type: "submit", className: "btn btn-danger", onClick: onConfirm },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "ban", fixed: true }),
        "Remove Line Item"
      )
    )
  );
}

Footer.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony export (immutable) */ __webpack_exports__["a"] = Header;




function Header(_ref) {
  var close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h4",
      { className: "modal-title" },
      "Remove Line Item"
    )
  );
}

Header.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* unused harmony export canCancelVendorRmaRequest */






function CancelRmaVendorRequest(_ref) {
  var toggleRequestModal = _ref.toggleRequestModal;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: toggleRequestModal },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: "ban", fixed: true }),
    "Cancel Vendor RMA Request"
  );
}

var canCancelVendorRmaRequest = function canCancelVendorRmaRequest(_ref2) {
  var lineItem = _ref2.lineItem;
  return lineItem.vendor_rma_status === "requested";
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["a" /* renderIf */])(canCancelVendorRmaRequest)(CancelRmaVendorRequest));

CancelRmaVendorRequest.propTypes = {
  toggleRequestModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form__ = __webpack_require__(1718);
/* harmony export (immutable) */ __webpack_exports__["a"] = CoreReturnCostSavings;







function CoreReturnCostSavings(_ref) {
  var open = _ref.open,
      close = _ref.close,
      lineItem = _ref.lineItem,
      reload = _ref.reload;

  if (Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "repaired_line_item.part_cost")) === 0 && open) {
    __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Error", "Parts Cost in the Higher Assembly is required to apply Core Return Cost Savings.");

    close();
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Core Return Cost Savings"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Form__["a" /* default */], {
      close: close,
      reload: reload,
      lineItem: lineItem,
      enableReinitialize: true
    })
  );
}

CoreReturnCostSavings.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components__ = __webpack_require__(2);













function Form(props) {
  var originalPPCost = props.originalPPCost,
      lineItem = props.lineItem;


  var costAdjDeduction = originalPPCost - lineItem.inventory_total_cost;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h5",
        { className: "h3 text-center" },
        "This Inventory has a cost of ",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.inventory_total_cost)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6, mdOffset: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: "original_piece_part_cost",
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */],
            label: "Orig. Shop PP Cost"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__shared_components__["n" /* Warning */],
        null,
        "\xA0This will deduct a total of ",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(costAdjDeduction),
        " from",
        " ",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "repaired_line_item.part.part_number"),
        " /",
        " ",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "repaired_line_item.serial_number"),
        " and it will zero out the cost on the Shop Assist Inventory. Continue?"
      )
    )
  );
}

Form.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    received: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.required
  })
};

var formName = "costSavingsForm";
var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    originalPPCost: selector(state, "original_piece_part_cost") || 0
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["h" /* shopAssistCostSavings */](ownProps.lineItem.id, data, ownProps.reload));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: function validate(values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_validate_this__["a" /* validator */])(values, function (f) {
      f.validate("cost_savings").satisfies(__WEBPACK_IMPORTED_MODULE_9__lib_validation_rules__["a" /* required */]);
      f.validate("cost_savings").satisfies(__WEBPACK_IMPORTED_MODULE_9__lib_validation_rules__["q" /* isNumeric */]);
      f.validate("cost_savings").satisfies(__WEBPACK_IMPORTED_MODULE_9__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0));
    });
  }
})(Form)));

/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Transfer_Transfer__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Transfer_TransferModal__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ReturnRepairItem_ReturnRepairItem__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ReturnRepairItem_ReturnRepairItemModal__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RequiredComponents_RequiredComponentModal__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RequiredComponents_RequiredComponent__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__decorators_withRepairOrder__ = __webpack_require__(1761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__RemoveMainComponent_RemoveMainComponent__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__RequestVendorRma_RequestVendorRmaModal__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Cancel__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__RequestVendorRma_RequestVendorRma__ = __webpack_require__(1722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CancelRmaVendorRequest_CancelRmaVendorRequest__ = __webpack_require__(1716);
/* unused harmony export LineItemControls */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var LineItemControls = function (_React$Component) {
  _inherits(LineItemControls, _React$Component);

  function LineItemControls() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LineItemControls);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LineItemControls.__proto__ || Object.getPrototypeOf(LineItemControls)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      cancelRequestModalOpen: false,
      confirmOpen: false,
      approvalModalOpen: false,
      requestModalOpen: false,
      requiredComponentModalOpen: false,
      transferModalOpen: false,
      deleteExpectedComponentModalOpen: false,
      reason: "previously_sold"
    }, _this.updateReason = function (reason) {
      return _this.setState({ reason: reason });
    }, _this.toggleModal = function (type) {
      return _this.setState(_defineProperty({}, type, !_this.state[type]));
    }, _this.handleCancel = function () {
      return _this.props.cancel(_this.props.lineItem.id, _this.state.reason).then(_this.toggleModal("confirmOpen"));
    }, _this.cancelVendorRmaRequest = function () {
      return _this.props.cancelRequestVendorRma(_this.props.lineItem.id).then(_this.toggleModal("cancelRequestModalOpen")).then(function () {
        __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].success("Success", "Vendor RMA Request Cancelled");
      });
    }, _this.cancelExpectedComponent = function () {
      return _this.props.deleteExpectedComponent(_this.props.lineItem.id).then(_this.toggleModal("deleteExpectedComponentModalOpen")).then(function () {
        __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].success("Success", "Removed Expected Component");
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LineItemControls, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          cancelRequestModalOpen = _state.cancelRequestModalOpen,
          confirmOpen = _state.confirmOpen,
          deleteExpectedComponentModalOpen = _state.deleteExpectedComponentModalOpen,
          requestModalOpen = _state.requestModalOpen,
          requiredComponentModalOpen = _state.requiredComponentModalOpen,
          transferModalOpen = _state.transferModalOpen;
      var _props = this.props,
          lineItem = _props.lineItem,
          returnItemModalOpen = _props.returnItemModalOpen,
          toggleReturnModal = _props.toggleReturnModal;


      var displayCancel = lineItem.cancellable && lineItem.action_requested !== __WEBPACK_IMPORTED_MODULE_8__constants__["z" /* EXPECTED_COMPONENT */];

      var canCancelExpectedComponent = lineItem.action_requested === __WEBPACK_IMPORTED_MODULE_8__constants__["z" /* EXPECTED_COMPONENT */] && lineItem.quantity_received === 0;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown__["b" /* default */],
          { icon: "fa fa-fw fa-ellipsis-v", menuClass: "dropdown-menu-right" },
          displayCancel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Cancel__["a" /* Cancel */], { toggle: function toggle() {
              return _this2.toggleModal("confirmOpen");
            } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__RemoveMainComponent_RemoveMainComponent__["a" /* default */], { lineItem: lineItem }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ReturnRepairItem_ReturnRepairItem__["a" /* default */], {
            toggleReturnModal: toggleReturnModal,
            lineItem: lineItem
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__RequestVendorRma_RequestVendorRma__["a" /* default */], {
            toggleRequestModal: function toggleRequestModal() {
              return _this2.toggleModal("requestModalOpen");
            },
            lineItem: lineItem
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__CancelRmaVendorRequest_CancelRmaVendorRequest__["a" /* default */], {
            toggleRequestModal: function toggleRequestModal() {
              return _this2.toggleModal("cancelRequestModalOpen");
            },
            lineItem: lineItem
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Transfer_Transfer__["a" /* default */], {
            lineItem: lineItem,
            open: transferModalOpen,
            toggleRequestModal: function toggleRequestModal() {
              return _this2.toggleModal("transferModalOpen");
            }
          }),
          canCancelExpectedComponent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown__["a" /* DropDownItem */],
            {
              onClick: function onClick() {
                return _this2.toggleModal("deleteExpectedComponentModalOpen");
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["k" /* Icon */], { name: "ban", fixed: true }),
            "Remove Expected Component"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__RequiredComponents_RequiredComponent__["a" /* default */], {
            lineItem: lineItem,
            toggleComponentModal: function toggleComponentModal() {
              return _this2.toggleModal("requiredComponentModalOpen");
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Cancel__["b" /* ConfirmModal */], {
          onConfirm: this.handleCancel,
          updateReason: this.updateReason,
          open: confirmOpen,
          close: function close() {
            return _this2.toggleModal("confirmOpen");
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Transfer_TransferModal__["a" /* default */], {
          close: function close() {
            return _this2.toggleModal("transferModalOpen");
          },
          open: transferModalOpen,
          lineItem: lineItem
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__RequestVendorRma_RequestVendorRmaModal__["a" /* default */], {
          lineItem: lineItem,
          open: requestModalOpen,
          close: function close() {
            return _this2.toggleModal("requestModalOpen");
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__RequiredComponents_RequiredComponentModal__["a" /* default */], {
          lineItem: lineItem,
          repairOrder: this.props.repairOrder,
          open: requiredComponentModalOpen,
          close: function close() {
            return _this2.toggleModal("requiredComponentModalOpen");
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ReturnRepairItem_ReturnRepairItemModal__["a" /* default */], {
          lineItem: lineItem,
          open: returnItemModalOpen === lineItem.id,
          close: toggleReturnModal
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components__["i" /* ConfirmAction */],
          {
            open: cancelRequestModalOpen,
            close: function close() {
              return _this2.toggleModal("cancelRequestModalOpen");
            },
            onConfirm: this.cancelVendorRmaRequest
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            null,
            "Are you sure you want to cancel this Vendor RMA request?"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["i" /* ConfirmAction */], {
          open: deleteExpectedComponentModalOpen,
          close: function close() {
            return _this2.toggleModal("deleteExpectedComponentModalOpen");
          },
          onConfirm: this.cancelExpectedComponent
        })
      );
    }
  }]);

  return LineItemControls;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LineItemControls.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    cancelled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    final_evaluation_approved: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired
  }),
  cancel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  cancelRequestVendorRma: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  deleteExpectedComponent: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  returnItemModalOpen: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  toggleReturnModal: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    cancel: function cancel(id, reason) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions__["i" /* cancelROLineItem */])(id, reason));
    },
    cancelRequestVendorRma: function cancelRequestVendorRma(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions__["j" /* cancelRequestVendorRma */])(id));
    },
    deleteExpectedComponent: function deleteExpectedComponent(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions__["k" /* deleteExpectedComponent */])(id));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__decorators_withRepairOrder__["a" /* default */])(LineItemControls)));

/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_ConfirmAction__ = __webpack_require__(191);
/* unused harmony export canRemoveMainComponent */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();












function RemoveMainComponent(_ref) {
  var confirm = _ref.confirm;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      removalVisibility = _useState2[0],
      setRemovalVisibility = _useState2[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: function onClick() {
        return setRemovalVisibility(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: "ban", fixed: true }),
    "\xA0Main Component Consumed - Remove From Stock",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_ConfirmAction__["a" /* default */],
      {
        onConfirm: confirm,
        close: function close() {
          return setRemovalVisibility(false);
        },
        open: removalVisibility,
        btnClass: "btn-danger",
        btnText: "Yes, Remove Main Component",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to remove this component?"
    )
  );
}

var canRemoveMainComponent = function canRemoveMainComponent(_ref2) {
  var lineItem = _ref2.lineItem;
  return lineItem.action_requested === __WEBPACK_IMPORTED_MODULE_8__constants__["b" /* TEARDOWN */] && !lineItem.received && lineItem.approval_status === __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["_65" /* REPAIR_EVALUATION_REJECTED */];
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["a" /* renderIf */])(canRemoveMainComponent)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    confirm: function confirm() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions__["o" /* removeMainComponent */])(ownProps.lineItem.id));
    }
  };
})(RemoveMainComponent)));

RemoveMainComponent.propTypes = {
  confirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_CurrencyField__ = __webpack_require__(176);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["e" /* Form */],
    _extends({}, props, { buttonText: "Continue" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_9__constants__["j" /* RMA_REQUEST_TYPE */],
            label: "Request Type",
            component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["m" /* RadioGroupField */],
            options: [{
              value: "rma",
              text: "Request RMA"
            }, { value: __WEBPACK_IMPORTED_MODULE_9__constants__["k" /* PARTIAL_CREDIT */], text: "Request Partial Credit" }]
          })
        )
      ),
      props.rmaRequestType === __WEBPACK_IMPORTED_MODULE_9__constants__["k" /* PARTIAL_CREDIT */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
            component: __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_CurrencyField__["a" /* default */],
            name: __WEBPACK_IMPORTED_MODULE_9__constants__["k" /* PARTIAL_CREDIT */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_9__constants__["k" /* PARTIAL_CREDIT */])
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__shared_components__["n" /* Warning */],
            null,
            "This action sends a notification to QC requesting they begin the Vendor RMA or Partial Credit Request process. Are you sure you want to continue?"
          )
        )
      )
    )
  );
}

var formName = "requestVendorRmaForm";
var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(function (state) {
  return {
    rmaRequestType: selector(state, __WEBPACK_IMPORTED_MODULE_9__constants__["j" /* RMA_REQUEST_TYPE */])
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].success("Success", "Vendor RMA Requested");
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions__["m" /* requestVendorRma */])(ownProps.lineItem.id, data, ownProps.close));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["j" /* form */])({
  form: formName
})(Form)));

Form.propTypes = {
  approveROLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(28);
/* unused harmony export canRequestVendorRma */








function RequestVendorRma(_ref) {
  var toggleRequestModal = _ref.toggleRequestModal;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: toggleRequestModal },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: "envelope", fixed: true }),
    "Request Vendor RMA"
  );
}

var canRequestVendorRma = function canRequestVendorRma(_ref2) {
  var lineItem = _ref2.lineItem;
  return [__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["_65" /* REPAIR_EVALUATION_REJECTED */], __WEBPACK_IMPORTED_MODULE_6__constants__["Q" /* REPAIR_EVALUATION_RECEIVED */]].includes(lineItem.approval_status) && !lineItem.final_evaluation_approved && !lineItem.vendor_rma_requested && !lineItem.exchange && ![__WEBPACK_IMPORTED_MODULE_6__constants__["_20" /* REQUESTED */], __WEBPACK_IMPORTED_MODULE_6__constants__["_21" /* OPENED */], __WEBPACK_IMPORTED_MODULE_6__constants__["_22" /* CLOSED */]].includes(lineItem.vendor_rma_status);
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["a" /* renderIf */])(canRequestVendorRma)(RequestVendorRma));

RequestVendorRma.propTypes = {
  toggleRequestModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(1721);
/* harmony export (immutable) */ __webpack_exports__["a"] = RequestVendorRmaModal;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







function RequestVendorRmaModal(_ref) {
  var open = _ref.open,
      close = _ref.close,
      lineItem = _ref.lineItem;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Request Vendor Rma"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], {
      close: close,
      enableReinitialize: true,
      lineItem: lineItem,
      initialValues: _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* RMA_REQUEST_TYPE */], "rma")
    })
  );
}

RequestVendorRmaModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__inventories_components_Detail_Dummies_constants__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__validate__ = __webpack_require__(1727);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _QUOTE_TYPES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




















var FORM_NAME = "requiredComponentForm";

var QUOTE_TYPES = (_QUOTE_TYPES = {}, _defineProperty(_QUOTE_TYPES, __WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_constants__["k" /* STANDARD */], {
  label: "Standard",
  abbrev: "Std"
}), _defineProperty(_QUOTE_TYPES, __WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_constants__["j" /* NO_QUOTE */], {
  label: "No Quote",
  abbrev: "NQ"
}), _QUOTE_TYPES);

function Form(props) {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.company),
      _useState2 = _slicedToArray(_useState, 2),
      company = _useState2[0],
      setCompany = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedPart = _useState4[0],
      setSelectedPart = _useState4[1];

  var searchParts = function searchParts(filter) {
    return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].parts.search({ search_type: "search", part_number: filter }).then(function (_ref) {
      var results = _ref.data.results;
      return results;
    });
  };

  var searchCompanies = function searchCompanies(filter) {
    return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].companies.search({ filter: filter, page: 1, limit: 20 }).then(function (resp) {
      return resp.data.results;
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_4__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_forms__["a" /* toOptions */])(QUOTE_TYPES),
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_4__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */]),
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_9__constants__["N" /* COMPANY_ID */],
            label: "Vendor",
            placeholder: "Search by typing a company's name or code",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["n" /* AutoCompleteField */],
            formatItem: function formatItem(result) {
              return result && result.name;
            },
            search: searchCompanies,
            disabled: true,
            onItemSelected: function onItemSelected(i) {
              return i && setCompany(i);
            },
            selectedItem: company,
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["q" /* PART_ID */],
            label: "Part #",
            placeholder: "Type a part's number...",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["n" /* AutoCompleteField */],
            search: searchParts,
            selectedItem: selectedPart,
            formatItem: function formatItem(result) {
              return result && result.part_number;
            },
            onItemSelected: function onItemSelected(i) {
              return i && setSelectedPart(i);
            },
            required: true
          })
        ),
        props.getFieldValue(__WEBPACK_IMPORTED_MODULE_4__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */]) === __WEBPACK_IMPORTED_MODULE_8__IncomingQuotes_constants__["k" /* STANDARD */] && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["n" /* CONDITION */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__inventories_components_Detail_Dummies_constants__["a" /* CONDITION_TYPES */]),
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__inventories_constants__["n" /* CONDITION */]),
            required: true
          })
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_9__constants__["j" /* QUANTITY */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: "Qty",
            required: true
          })
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["f" /* CurrencyField */], { name: __WEBPACK_IMPORTED_MODULE_9__constants__["V" /* COST */], label: "COST", required: true })
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["G" /* LEAD_TIME */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: "Lead Time (Days)",
            required: true
          })
        )]
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
            { checkGroupStyles: { marginTop: 0 }, justified: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: "create_incoming_quote",
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
              label: "Create Incoming Quote"
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 5 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_14__shared_constants__["e" /* NOTE */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["l" /* TextArea */],
            label: "Note (Applied to the line item)",
            rows: 5
          })
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__actions__["l" /* createRequiredComponent */])(ownProps.lineItem.id, data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_form__["reduxForm"])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_17__validate__["a" /* default */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inventories_constants__ = __webpack_require__(12);
/* harmony export (immutable) */ __webpack_exports__["a"] = RequiredComponent;






function RequiredComponent(_ref) {
  var toggleComponentModal = _ref.toggleComponentModal,
      lineItem = _ref.lineItem;

  if (!lineItem) return null;
  if (![__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_67" /* REPAIR_EVALUATION_RECEIVED */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_68" /* NO_WORK_PERFORMED */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_65" /* REPAIR_EVALUATION_REJECTED */], __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_66" /* WORKING_TO_SAVE_UNIT */]].includes(lineItem.approval_status)) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: toggleComponentModal },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "check", fixed: true }),
    "Create Required Component"
  );
}

RequiredComponent.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  toggleComponentModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(1724);
/* harmony export (immutable) */ __webpack_exports__["a"] = RequiredComponentModal;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function RequiredComponentModal(_ref) {
  var open = _ref.open,
      close = _ref.close,
      lineItem = _ref.lineItem,
      repairOrder = _ref.repairOrder;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-md" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Create Required Component"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], {
      close: close,
      company: repairOrder.get(__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* COMPANY */]).toJS(),
      enableReinitialize: true,
      lineItem: lineItem,
      initialValues: _extends({}, lineItem, {
        create_incoming_quote: true
      })
    })
  );
}

RequiredComponentModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;







function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_1__inventories_constants__["q" /* PART_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);

    if (values.quote_type === __WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__["k" /* STANDARD */]) {
      form.validate(__WEBPACK_IMPORTED_MODULE_1__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_4__constants__["V" /* COST */], __WEBPACK_IMPORTED_MODULE_4__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_2__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */], __WEBPACK_IMPORTED_MODULE_1__inventories_constants__["G" /* LEAD_TIME */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
    }
  });
}

/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormSections_ShippingSection_ShippingSection__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SalesOrders_constants__ = __webpack_require__(32);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



















var FORM_NAME = "updateReturnShipping";

function Form(props) {
  var disabled = props.disabled,
      displayShipmentUpdateReminder = props.displayShipmentUpdateReminder,
      getFieldValue = props.getFieldValue,
      getInitialFieldValue = props.getInitialFieldValue,
      handleSubmit = props.handleSubmit,
      lineItem = props.lineItem,
      setFieldValue = props.setFieldValue;


  var submit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_submission__["b" /* onSuccess */])(handleSubmit, props.close, props);

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      confirmDropship = _useState2[0],
      setConfirmDropship = _useState2[1];

  var hasGoneOutright = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* getOutrightVal */])(getFieldValue);
  var requestedAction = getFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["E" /* ACTION_REQUESTED */]);

  var _getLocationsAndRetur = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["c" /* getLocationsAndReturnToTypes */])(true, hasGoneOutright, lineItem),
      _getLocationsAndRetur2 = _slicedToArray(_getLocationsAndRetur, 2),
      hasLocations = _getLocationsAndRetur2[0],
      returnToTypes = _getLocationsAndRetur2[1];

  var approvalStatus = getFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["s" /* APPROVAL_STATUS */]);
  var disableReturnFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* getDisableReturnFields */])(disabled, getFieldValue);
  var dropshipping = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["e" /* isDropshipping */])({
    getFieldValue: getFieldValue,
    getInitialFieldValue: getInitialFieldValue,
    repairItem: lineItem
  });

  var showWarningStep = dropshipping && !confirmDropship;

  var dropShipText = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["f" /* isDropshippedSales */])(lineItem) ? "sale" : "managed repair";

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["e" /* Form */].Body,
      null,
      confirmDropship && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_15__shared_components__["n" /* Warning */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "p",
          null,
          "Once the Return AWB # is saved for a return repair item that is dropshipped for a pending ",
          dropShipText,
          ", this record will automatically ship in the system."
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "p",
          null,
          "Are you sure you want to continue?"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: confirmDropship && "hidden" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FormSections_ShippingSection_ShippingSection__["a" /* default */], {
          formName: FORM_NAME,
          shippingTypes: returnToTypes,
          getField: getFieldValue,
          lineItem: lineItem,
          ship_to_fields_required: false,
          getInitialField: getInitialFieldValue,
          requestedAction: requestedAction,
          displayShipmentUpdateReminder: displayShipmentUpdateReminder,
          hasLocations: hasLocations
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row row-col-gutters-half", key: "awb-date-section" },
          approvalStatus !== __WEBPACK_IMPORTED_MODULE_8__constants__["K" /* AWAITING_TO_SHIP */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_8__constants__["W" /* INCOMING_AWB_NUMBER */],
              component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["d" /* FormInput */],
              disabled: disableReturnFields,
              label: "Returning AWB #",
              onChange: function onChange(_ev, val) {
                if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["isEmpty"])(val) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["isEmpty"])(getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["W" /* INCOMING_AWB_NUMBER */]))) {
                  setFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["_19" /* RETURNED_DATE */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_date__["i" /* dateFormFormat */])(Date.now()));

                  if (dropshipping) {
                    setFieldValue(__WEBPACK_IMPORTED_MODULE_16__SalesOrders_constants__["x" /* SEND_SALES_ORDER_ACKNOWLEDGEMENT */])(true);
                  }
                }
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_8__constants__["_19" /* RETURNED_DATE */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_19" /* RETURNED_DATE */]),
              component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["d" /* FormInput */],
              type: "date",
              disabled: disableReturnFields
            })
          ),
          dropshipping && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["f" /* isDropshippedSales */])(lineItem) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["a" /* CheckGroup */],
              {
                title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_16__SalesOrders_constants__["y" /* SEND_SALES_ORDER_ACKNOWLEDGEMENT_LABEL */])
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */],
                name: __WEBPACK_IMPORTED_MODULE_16__SalesOrders_constants__["x" /* SEND_SALES_ORDER_ACKNOWLEDGEMENT */],
                label: __WEBPACK_IMPORTED_MODULE_16__SalesOrders_constants__["y" /* SEND_SALES_ORDER_ACKNOWLEDGEMENT_LABEL */]
              })
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["e" /* Form */].Footer,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["i" /* Button */],
        { onClick: props.close },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["i" /* Button */],
        {
          type: "button",
          disabled: props.submitting,
          onClick: showWarningStep ? function () {
            return setConfirmDropship(true);
          } : submit,
          bsStyle: "primary"
        },
        props.submitting && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cog fa-spin fa-fw fa-lg" }),
        props.submitting ? "Saving" : "Save"
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    displayShipmentUpdateReminder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getDisplayShipmentVal */])(FORM_NAME, state)
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["g" /* updateROLineItem */])(ownProps.lineItem.id, data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

Form.propTypes = {
  approveROLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__companies_actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__companies_shared_FindOrCreateCompanyToggle_SearchCompany__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Orders_shared_ShippingFields__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__companies_helpers__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Shipping_constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_components_PaymentTerms_PaymentTerms__ = __webpack_require__(177);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
























var formName = "transferRepairForm";

function Form(props) {
  var setFieldValue = props.setFieldValue;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCompany = _useState2[0],
      setSelectedCompany = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])([]),
      _useState4 = _slicedToArray(_useState3, 2),
      contacts = _useState4[0],
      setContacts = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])([]),
      _useState6 = _slicedToArray(_useState5, 2),
      addresses = _useState6[0],
      setAddresses = _useState6[1];

  var fetchContacts = function fetchContacts(value) {
    if (!value) {
      return null;
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__parts_actions__["g" /* searchContacts */])(value).then(function () {
      var vals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      setContacts(vals);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__companies_helpers__["a" /* selectPrimaryContact */])(vals, setFieldValue(__WEBPACK_IMPORTED_MODULE_13__constants__["O" /* CONTACT_ID */]));
    });
  };

  var fetchAddresses = function fetchAddresses(companyId) {
    __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].companies.physicalAddresses.search(companyId, {
      page: 1,
      limit: 100,
      sort: "primary",
      reverse: true
    }).then(function (_ref) {
      var results = _ref.data.results;

      if (results.length > 0) {
        var primaryAddress = results[0];
        setAddresses(results);

        setFieldValue("repair_station_physical_address_id")(primaryAddress.id);
      }
    });
  };

  var handleCompanySelected = function handleCompanySelected(company) {
    setSelectedCompany(company);
    setFieldValue(__WEBPACK_IMPORTED_MODULE_13__constants__["M" /* PAYMENT_TERMS */])(company.vendor_credit_terms);
    fetchAddresses(company.id);
  };

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__companies_shared_FindOrCreateCompanyToggle_SearchCompany__["a" /* default */], {
        companySearch: __WEBPACK_IMPORTED_MODULE_5__companies_actions__["a" /* searchRepairStationCompanies */],
        contacts: contacts,
        formName: formName,
        fetchContacts: fetchContacts,
        selectedCompany: selectedCompany,
        onCompanySelected: handleCompanySelected,
        type: "repairOrder",
        required: true
      }),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__shared_components_PaymentTerms_PaymentTerms__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_18__Shipping_constants__["g" /* OUTGOING_AWB_NUMBER */],
              component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["d" /* FormInput */],
              label: "AWB Number"
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components__["m" /* DashedSeparator */], null),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        "h4",
        null,
        "Ship To"
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            "div",
            { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_13__constants__["_20" /* SHIP_TO_FOB */],
              component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["d" /* FormInput */],
              label: "FOB",
              required: true
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Orders_shared_ShippingFields__["a" /* default */], {
        formName: formName,
        shippingFields: [__WEBPACK_IMPORTED_MODULE_13__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_13__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_13__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */]],
        setFOB: function setFOB(val) {
          return setFieldValue(__WEBPACK_IMPORTED_MODULE_13__constants__["_40" /* RETURN_TO_FOB */])(val);
        },
        repairStationOptions: addresses,
        shippingTypes: [__WEBPACK_IMPORTED_MODULE_11__companies_constants__["f" /* REPAIR_STATION */], __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__["K" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__["L" /* DROPSHIP */]],
        shippingMethod: __WEBPACK_IMPORTED_MODULE_13__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */],
        shippingAddressField: __WEBPACK_IMPORTED_MODULE_13__constants__["_17" /* SHIP_TO_SHIPPING_ADDRESS */],
        hasLocations: false
      })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* transferRoLineItem */])(ownProps.lineItem.id, data, ownProps.close));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: function validate(values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__lib_validate_this__["a" /* validator */])(values, function (f) {
      f.validate(__WEBPACK_IMPORTED_MODULE_13__constants__["N" /* COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_13__constants__["O" /* CONTACT_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_20__lib_validation_rules__["a" /* required */]);
    });
  }
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

Form.propTypes = {
  approveROLineItem: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* unused harmony export canTransfer */





function Transfer(_ref) {
  var toggleRequestModal = _ref.toggleRequestModal;

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0__shared_components__["l" /* DropDownItem */],
    { onClick: toggleRequestModal },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__shared_components__["k" /* Icon */], { name: "undo", fixed: true }),
    "Drop ship to another repair station"
  );
}

var canTransfer = function canTransfer(_ref2) {
  var lineItem = _ref2.lineItem;
  return lineItem.shipped && !lineItem.received && !lineItem.cancelled && (lineItem.approval_status === "repair_evaluation_rejected" || lineItem.approval_status === "repair_evaluation_approved");
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["a" /* renderIf */])(canTransfer)(Transfer));
Transfer.propTypes = {
  toggleRequestModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_address__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(1729);








function TransferModal(_ref) {
  var open = _ref.open,
      close = _ref.close,
      lineItem = _ref.lineItem,
      repairOrder = _ref.repairOrder;

  var initialValues = {
    ship_to_fob: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_address__["a" /* fobFormat */])(repairOrder.ship_to_address)
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["C" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Drop ship to another Repair Station"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Form__["a" /* default */], {
      close: close,
      enableReinitialize: true,
      lineItem: lineItem,
      repairOrder: repairOrder,
      initialValues: initialValues
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    repairOrder: state.repairOrderDetail.get("repairOrder").toJS()
  };
})(TransferModal));

TransferModal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  repairOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LineItemControls__ = __webpack_require__(1719);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LineItemControls__["a"]; });



/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();







var RequiredComponentTooltip = function RequiredComponentTooltip(_ref) {
  var lineItem = _ref.lineItem;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      requiredComponents = _useState2[0],
      setRequiredComponents = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (lineItem) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].repairOrders.lineItems.requiredComponents.search(lineItem.id, { reverse: false }).then(function (_ref2) {
        var data = _ref2.data;

        setRequiredComponents(data.results);
      });
    }

    return function cleanup() {};
  }, [lineItem && lineItem.id]);
  if (!lineItem) return null;
  if (Number(lineItem.required_component_quotes_count) === 0) return null;

  var hasValidPartNumber = requiredComponents.some(function (component) {
    return component.part && component.part.part_number && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(component.part.part_number);
  });

  if (!hasValidPartNumber) return null;

  var partNumbersString = "PN:<br>" + requiredComponents.sort(function (a, b) {
    return b.part.part_number.localeCompare(a.part.part_number);
  }).map(function (component) {
    return component.part.part_number;
  }).join("<br>");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["j" /* NoteTooltip */], { note: partNumbersString, color: "rgba(255, 0, 0, 1)" });
};

RequiredComponentTooltip.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (RequiredComponentTooltip);

/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LineItemControls_ReturnRepairItem_ReturnRepairItem__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LineItemControls_ReturnRepairItem_ReturnRepairItemModal__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LineItemControls_CoreReturnCostSavings_CoreReturnCostSavingsModal__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Table__ = __webpack_require__(704);
/* unused harmony export allowEditing */
/* unused harmony export ShopAssistColumns */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var allowEditing = function allowEditing(_ref) {
  var exchange = _ref.exchange,
      shipped = _ref.shipped,
      finalEval = _ref.finalEval;
  return exchange && shipped && !finalEval;
};

function LineItemControls(_ref2) {
  var lineItem = _ref2.lineItem;

  if (!lineItem.repaired_line_item) return null;

  var _lineItem$repaired_li = lineItem.repaired_line_item,
      exchange = _lineItem$repaired_li.exchange,
      finalEval = _lineItem$repaired_li.final_evaluation_approved,
      shipped = lineItem.shipped;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      returnItemModal = _useState2[0],
      setReturnItemModal = _useState2[1];

  var toggleReturnModal = function toggleReturnModal() {
    return returnItemModal === lineItem.id ? setReturnItemModal(null) : setReturnItemModal(lineItem.id);
  };

  if (allowEditing({ exchange: exchange, shipped: shipped, finalEval: finalEval })) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_DropDown__["c" /* ImprovedDropDown */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
          label: "Core Return Cost Savings",
          id: "core-return-cost-savings",
          faIcon: "dollar",
          renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LineItemControls_CoreReturnCostSavings_CoreReturnCostSavingsModal__["a" /* default */], { lineItem: lineItem })
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LineItemControls_ReturnRepairItem_ReturnRepairItem__["a" /* default */], {
          toggleReturnModal: toggleReturnModal,
          lineItem: lineItem
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LineItemControls_ReturnRepairItem_ReturnRepairItemModal__["a" /* default */], {
          lineItem: lineItem,
          open: returnItemModal === lineItem.id,
          close: toggleReturnModal
        })
      )
    );
  }

  return null;
}

var ShopAssistColumns = {
  "Orig PP Cost From Eval": function OrigPPCostFromEval(_ref3) {
    var lineItem = _ref3.lineItem;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__["a" /* dollars */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "original_piece_part_cost"));
  },
  "Final PP Cost": function FinalPPCost(_ref4) {
    var lineItem = _ref4.lineItem;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__["a" /* dollars */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "final_piece_part_cost"));
  },
  "Core Return Cost Savings": function CoreReturnCostSavings(_ref5) {
    var lineItem = _ref5.lineItem;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__["a" /* dollars */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "core_return_cost_savings"));
  },
  "": function _(_ref6) {
    var lineItem = _ref6.lineItem;

    if (lineItem.shipped) {
      var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
          _useState4 = _slicedToArray(_useState3, 2),
          returnItemModal = _useState4[0],
          setReturnItemModal = _useState4[1];

      var toggleReturnModal = function toggleReturnModal() {
        return returnItemModal === lineItem.id ? setReturnItemModal(null) : setReturnItemModal(lineItem.id);
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_DropDown__["c" /* ImprovedDropDown */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LineItemControls_ReturnRepairItem_ReturnRepairItem__["a" /* default */], {
          toggleReturnModal: toggleReturnModal,
          lineItem: lineItem
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LineItemControls_ReturnRepairItem_ReturnRepairItemModal__["a" /* default */], {
          lineItem: lineItem,
          open: returnItemModal === lineItem.id,
          close: toggleReturnModal
        })
      );
    }

    return null;
  }
};

LineItemControls.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    exchange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    final_evaluation_approved: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })
};

var ShopAssistTable = function (_React$Component) {
  _inherits(ShopAssistTable, _React$Component);

  function ShopAssistTable() {
    _classCallCheck(this, ShopAssistTable);

    return _possibleConstructorReturn(this, (ShopAssistTable.__proto__ || Object.getPrototypeOf(ShopAssistTable)).apply(this, arguments));
  }

  _createClass(ShopAssistTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.mounted && this.props.partCosts !== nextProps.partCosts) {
        this.props.reload();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          results = _props.results,
          loading = _props.loading;


      if (!results || results.length === 0) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          { style: { marginTop: 26 } },
          "Shop Assist Parts"
        ),
        !loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Table__["a" /* Table */], {
          results: results,
          disabled: true,
          startColumns: {
            "RO #": function RO(_ref7) {
              var lineItem = _ref7.lineItem;
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],
                { to: "/repair-orders/" + lineItem.repair_order_id },
                lineItem.repair_order_code
              );
            },
            "Orig. PN/SN": function OrigPNSN(_ref8) {
              var lineItem = _ref8.lineItem;
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],
                {
                  to: "/inventories/" + __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(lineItem, "repaired_line_item.inventory_id")
                },
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(lineItem, "repaired_line_item.part.part_number"),
                " /",
                " ",
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(lineItem, "repaired_line_item.serial_number")
              );
            }
          },
          endColumns: _extends({}, ShopAssistColumns, {
            " ": function _(_ref9) {
              var lineItem = _ref9.lineItem;
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LineItemControls, { lineItem: lineItem });
            }
          })
        })
      );
    }
  }]);

  return ShopAssistTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["d" /* translateProps */])(function (_ref10) {
  var repairOrder = _ref10.repairOrder;
  return {
    ids: repairOrder.get("line_items").map(function (l) {
      return l.get("id");
    }),
    partCosts: repairOrder.get("line_items").map(function (l) {
      return l.part_cost;
    })
  };
});

var withResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["n" /* miniTable */])(function (_ref11, params) {
  var ids = _ref11.ids;
  return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairOrders.lineItems.shopAssistItems(Object.assign(params, { ids: ids }));
}, 50);

/* harmony default export */ __webpack_exports__["a"] = (withProps(withResults(ShopAssistTable)));

ShopAssistTable.propTypes = {
  reload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Array),
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  partCosts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number)
};

/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Locations_helpers__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_address__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Shipping_constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony export (immutable) */ __webpack_exports__["a"] = Summary;


















function InventorySection(_ref) {
  var lineItem = _ref.lineItem;

  var showEvalPeriod = lineItem.get("evaluation_period") && lineItem.get(__WEBPACK_IMPORTED_MODULE_7__constants__["Y" /* DATE_RECEIVED */]);
  var scrapReport = lineItem.get("scrap_report");
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "em",
      { className: "text-muted" },
      lineItem.getIn(["part", "description"])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Serial #:",
      " ",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
        { to: "/inventories/" + lineItem.getIn(["inventory", "uuid"]) },
        lineItem.get(__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["o" /* SERIAL_NUMBER */])
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Quantity: ",
      lineItem.get("quantity")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Condition Sent: ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__constants__["Z" /* getConditionLabel */])(lineItem.get("condition_sent"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "As-is: ",
      lineItem.getIn(["inventory", "as_is"], false) ? "Yes" : "No"
    ),
    lineItem.get("cap_type") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      __WEBPACK_IMPORTED_MODULE_16__PurchaseOrders_constants__["B" /* CAP_TYPES */][lineItem.get("cap_type")].label,
      " Cap:",
      " ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(lineItem.get("cap_amount"))
    ),
    showEvalPeriod && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Evaluation Period: ",
      lineItem.get("evaluation_period"),
      " days from",
      " ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(lineItem.get("date_inventory_received"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Store Owner: ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__Locations_helpers__["a" /* getLocationNameById */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["_64" /* STORE_OWNER_ID */]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Store Location: ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__Locations_helpers__["a" /* getLocationNameById */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["_27" /* STORE_LOCATION_ID */]))
    ),
    scrapReport && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Scrap Report:",
      " ",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__shared_components__["r" /* ExternalLink */],
        { url: scrapReport },
        "Download Report"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Final Appr. On:",
      " ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(lineItem.get("final_evaluation_approved_on"))
    ),
    (lineItem.get("vendor_rma_status") || "") !== "" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Vendor RMA Status:",
      " " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["c" /* properCase */])(lineItem.get("vendor_rma_status"))
    )
  );
}

InventorySection.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

function OutgoingShipmentSection(_ref2) {
  var lineItem = _ref2.lineItem;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Outgoing AWB #: ",
      lineItem.get(__WEBPACK_IMPORTED_MODULE_15__Shipping_constants__["g" /* OUTGOING_AWB_NUMBER */])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Ship Date: ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(lineItem.get("date_out"))
    )
  );
}

OutgoingShipmentSection.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

function IncomingShipmentSection(_ref3) {
  var lineItem = _ref3.lineItem;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Returning AWB #: ",
      lineItem.get("incoming_awb_number")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Rec Date: ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(lineItem.get("date_received"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Condition Received:",
      " ",
      lineItem.get("condition_received") && __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["r" /* INVENTORIES */].condition[lineItem.get("condition_received")].label
    )
  );
}

IncomingShipmentSection.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

function RecentOrdersSection(_ref4) {
  var lineItem = _ref4.lineItem;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    !lineItem.getIn(["inventory", "managed_repair_repaired"]) && !lineItem.getIn(["inventory", "managed_repair_in_progress"]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        "PO #: "
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["V" /* PoCode */], { inventory: lineItem.get("inventory", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).toJS() })
    ),
    (lineItem.getIn(["inventory", "managed_repair_repaired"]) || lineItem.getIn(["inventory", "managed_repair_in_progress"])) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        "MR #:"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
        {
          to: "/managed-repair-orders/" + lineItem.getIn(["inventory", "managed_repair_details", "uuid"])
        },
        lineItem.getIn(["inventory", "managed_repair_details", "code"])
      )
    ),
    lineItem.getIn(["inventory", "most_recent_sales_order", "id"]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "SO #:",
      " ",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
        {
          to: "/sales-orders/" + lineItem.getIn(["inventory", "most_recent_sales_order", "id"])
        },
        lineItem.getIn(["inventory", "most_recent_sales_order", "code"])
      )
    )
  );
}

RecentOrdersSection.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

function ShopAssistSection(_ref5) {
  var lineItem = _ref5.lineItem;

  var shopAssistItems = lineItem.get("shop_assist_line_items", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()).sortBy(function (i) {
    return i.getIn(["repair_order", "code"]);
  }).toJS();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    lineItem.get("shop_assist_repair_order_id") && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Assists Repair Order:",
      " ",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
        {
          to: "/repair-orders/" + lineItem.get("shop_assist_repair_order_id")
        },
        lineItem.get("shop_assist_repair_order_code")
      )
    )],
    shopAssistItems.length > 0 && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Shop Assist Repair Orders:",
      " ",
      shopAssistItems.map(function (i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
          { to: "/repair-orders/" + i.repair_order.id },
          i.repair_order.code
        );
      }).reduce(function (prev, curr) {
        return [prev, ", ", curr];
      })
    )]
  );
}

ShopAssistSection.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

function ReturnToSection(_ref6) {
  var lineItem = _ref6.lineItem;

  var shippingAddress = lineItem.get("return_to_address");
  var company = lineItem.get("return_to_company");

  if (company) {
    shippingAddress = shippingAddress.set("company_name", company.get("name"));
  }

  if (!shippingAddress) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h6",
      { className: "h4" },
      "Return To Address"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed table-padding-horizonal-none margin-bottom-none" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            shippingAddress && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_address__["c" /* addressFormat */])(shippingAddress.toJS())
          )
        )
      )
    )
  );
}

ReturnToSection.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

function SalesOrderSection(_ref7) {
  var getField = _ref7.getField,
      lineItem = _ref7.lineItem;

  var salesOrder = lineItem.getIn(["inventory", "most_recent_sales_order"]);
  var totalCost = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__helpers__["d" /* calculateSubtotal */])(getField)([__WEBPACK_IMPORTED_MODULE_7__constants__["_0" /* LABOR_COST */], __WEBPACK_IMPORTED_MODULE_7__constants__["_1" /* OUTSIDE_LABOR_COST */], __WEBPACK_IMPORTED_MODULE_7__constants__["_2" /* PART_COST */]], 0);
  if (salesOrder && !salesOrder.get(__WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["w" /* EXCHANGE_SALE */]) && new Date(lineItem.get("created_at")) < new Date(lineItem.getIn(["inventory", "most_recent_sales_order", "created_at"]))) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h6",
        { className: "h4" },
        "Sold At Shop"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        "SO #:",
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
          { to: "/sales-orders/" + salesOrder.get(__WEBPACK_IMPORTED_MODULE_10__constants__["b" /* ID */]) },
          salesOrder.get(__WEBPACK_IMPORTED_MODULE_10__constants__["z" /* CODE */])
        )
      )
    );
  } else if (salesOrder && salesOrder.get(__WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["w" /* EXCHANGE_SALE */])) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h6",
        { className: "h4" },
        salesOrder.get(__WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["e" /* FLAT_EXCHANGE */]) && "Flat ",
        "Exchange SO"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        "SO #:",
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
          { to: "/sales-orders/" + salesOrder.get(__WEBPACK_IMPORTED_MODULE_10__constants__["b" /* ID */]) },
          salesOrder.get(__WEBPACK_IMPORTED_MODULE_10__constants__["z" /* CODE */])
        )
      ),
      totalCost > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        "Core Return Fee Savings:",
        " ",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(getField(__WEBPACK_IMPORTED_MODULE_7__constants__["_3" /* CORE_RETURN_FEE_SAVINGS */]))
      ),
      salesOrder.get("outright_value") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        "Outright Value: ",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(salesOrder.get("outright_value"))
      )
    );
  }
  return null;
}

SalesOrderSection.propTypes = {
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

function Summary(_ref8) {
  var lineItem = _ref8.lineItem,
      getField = _ref8.getField,
      repairOrder = _ref8.repairOrder;

  var cost = [__WEBPACK_IMPORTED_MODULE_7__constants__["_0" /* LABOR_COST */], __WEBPACK_IMPORTED_MODULE_7__constants__["_1" /* OUTSIDE_LABOR_COST */], __WEBPACK_IMPORTED_MODULE_7__constants__["_2" /* PART_COST */], __WEBPACK_IMPORTED_MODULE_7__constants__["_4" /* SHOP_ASSIST_COST */]].map(function (item) {
    return parseFloat(getField(item)) || 0;
  }).reduce(function (sum, value) {
    return sum + value;
  }, 0);
  var quantity = parseInt(lineItem.get("quantity") || 0, 10);
  var subtotal = cost * quantity;
  var withWarranty = getField("action_requested") === __WEBPACK_IMPORTED_MODULE_7__constants__["l" /* WARRANTY_CONSIDERATION */];
  var finalWarrantyStatus = [getField("repair_station_warranty_status"), getField("warranty_status")].every(function (f) {
    return [null, ""].includes(f);
  }) ? null : getField("repair_station_warranty_status") === __WEBPACK_IMPORTED_MODULE_7__constants__["_5" /* APPROVED */] || getField("warranty_status") === __WEBPACK_IMPORTED_MODULE_7__constants__["_5" /* APPROVED */];

  var WarrantyText = function WarrantyText() {
    if (!withWarranty || finalWarrantyStatus === null) return null;

    if (finalWarrantyStatus) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "text-success" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["k" /* Icon */], { name: "check" }),
        " Approved"
      );
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "text-danger" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["k" /* Icon */], { name: "close" }),
      " Denied"
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "well" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h6",
      { className: "h4" },
      "Part Summary"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed table-padding-horizonal-none margin-bottom-none" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Part #: ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["h" /* PartNumber */], { part: lineItem.toJS().part })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "part-summary" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InventorySection, { lineItem: lineItem }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
              withWarranty && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  "Final Warranty Status: ",
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WarrantyText, null)
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
              lineItem.get("action_requested") !== __WEBPACK_IMPORTED_MODULE_7__constants__["z" /* EXPECTED_COMPONENT */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OutgoingShipmentSection, { lineItem: lineItem }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IncomingShipmentSection, { lineItem: lineItem }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
            lineItem.get("action_requested") !== __WEBPACK_IMPORTED_MODULE_7__constants__["z" /* EXPECTED_COMPONENT */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RecentOrdersSection, { lineItem: lineItem }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShopAssistSection, { lineItem: lineItem })
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SalesOrderSection, { lineItem: lineItem, getField: getField }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReturnToSection, { lineItem: lineItem, repairOrder: repairOrder }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-padding-horizonal-none" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              { className: "h4 margin-top-none margin-bottom-none" },
              "Total"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              { className: "h4 margin-top-none margin-bottom-none" },
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(subtotal)
            )
          )
        )
      )
    )
  );
}

Summary.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  repairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Warning__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony export (immutable) */ __webpack_exports__["a"] = CapAmountWarning;






function CapAmountWarning(_ref) {
  var lineItem = _ref.lineItem,
      originalEval = _ref.originalEval;

  if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(lineItem, "cap_amount") && originalEval > parseFloat(lineItem.cap_amount)) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Warning__["a" /* Warning */],
      null,
      "Estimate has come above Repair/Overhaul Cap amount of " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(lineItem.cap_amount) + ". Part should be\n            considered for Partial Credit or RMA Request"
    );
  }

  return null;
}

CapAmountWarning.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    cap_amount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  originalEval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.required
};

/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RMAsAndWarranties_constants__ = __webpack_require__(76);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;










var validReturnToForWarranty = function validReturnToForWarranty(val, props) {
  var path = "lineItem.inventory.most_recent_customer_rma";
  var creditRequestedRma = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(props, path + ".credit_requested") && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(props, path + ".warranty_consideration") && !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(props, path + ".closed_date");

  var code = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(props, "lineItem.inventory.most_recent_customer_rma.code");

  if (creditRequestedRma && [__WEBPACK_IMPORTED_MODULE_4__shared_components_ShippingSection_shippingTypes__["d" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_4__shared_components_ShippingSection_shippingTypes__["e" /* DROPSHIP */]].includes(val)) {
    return "You must first remove the open credit request from Cust " + code + " before you can return it to the Customer or an address other than our Store Location/s";
  }

  return undefined;
};

function validate(values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["E" /* ACTION_REQUESTED */], __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["q" /* PART_ID */], __WEBPACK_IMPORTED_MODULE_2__constants__["s" /* APPROVAL_STATUS */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);

    if (values.action_requested !== __WEBPACK_IMPORTED_MODULE_2__constants__["z" /* EXPECTED_COMPONENT */]) {
      form.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["_21" /* INVENTORY_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if ([__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* REPAIR_EVALUATION_APPROVED */], __WEBPACK_IMPORTED_MODULE_2__constants__["Q" /* REPAIR_EVALUATION_RECEIVED */]].includes(values.approval_status) && values.action_requested !== __WEBPACK_IMPORTED_MODULE_2__constants__["z" /* EXPECTED_COMPONENT */]) {
      form.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["I" /* ORIGINAL_EVALUATION */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if (values.customer_rma_id && [__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* REPAIR_EVALUATION_APPROVED */], __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["_65" /* REPAIR_EVALUATION_REJECTED */]].includes(values.approval_status)) {
      form.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["R" /* WARRANTY_STATUS */], __WEBPACK_IMPORTED_MODULE_8__RMAsAndWarranties_constants__["i" /* REPAIR_STATION_WARRANTY_STATUS */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if (values.repair_and_hold) {
      form.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["S" /* REPAIR_AND_HOLD_LEAD_TIME */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["h" /* isBetween */](0, 99), __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if (values.insurance_type === "Percent") {
      form.validate("percent_insured").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["f" /* isGreaterThan */](0.0));
    }

    if (values.insurance_type === "Amount") {
      form.validate("amount_insured").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["f" /* isGreaterThan */](0.0));
    }

    if (values.action_requested === __WEBPACK_IMPORTED_MODULE_2__constants__["z" /* EXPECTED_COMPONENT */]) {
      if ([__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* REPAIR_EVALUATION_APPROVED */], __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["_65" /* REPAIR_EVALUATION_REJECTED */]].includes(values.approval_status)) {
        form.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["T" /* TRANSFER_COST */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0.0));
      }

      form.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["U" /* EXPECTED_SERIAL_NUMBER */], __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      form.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["f" /* isGreaterThan */](0));
    }

    if (values.approval_status === __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* REPAIR_EVALUATION_APPROVED */]) {
      form.validate(__WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__["p" /* LABOR_COST */], __WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__["o" /* PART_COST */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["g" /* requiredAllowZero */]);
    }

    if (values.original_evaluation != null) {
      form.validate(__WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__["p" /* LABOR_COST */], __WEBPACK_IMPORTED_MODULE_7__SalesOrders_constants__["o" /* PART_COST */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if (![__WEBPACK_IMPORTED_MODULE_2__constants__["u" /* EXCHANGE_GONE_OUTRIGHT */], __WEBPACK_IMPORTED_MODULE_2__constants__["V" /* INTERNAL_OUTRIGHT */]].some(function (f) {
      return values[f];
    })) {
      form.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["C" /* RETURN_TO_TYPE */]).satisfies(function (val) {
        return validReturnToForWarranty(val, props);
      });
    }

    if (values.other) {
      form.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["N" /* OTHER_TAG_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["o" /* maxLengthOfText */](30));
    }
  });
}

/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* unused harmony export submitButton */
/* unused harmony export Form */
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }














var FORM_NAME = "sendRoDocumentsForm";

var submitButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  "span",
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["k" /* Icon */], { name: "envelope" }),
  " Yes, Send RO"
);

function Form(_ref) {
  var close = _ref.close,
      handleSubmit = _ref.handleSubmit,
      modal = _ref.modal;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */],
    {
      handleSubmit: handleSubmit,
      modal: modal,
      close: close,
      buttonText: submitButton
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], name: "to", label: "To:", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], name: "cc", label: "CC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], name: "bcc", label: "BCC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], name: "subject", label: "Subject", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["l" /* TextArea */], name: "body", label: "Body", required: true })
    )
  );
}

Form.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  modal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state, props) {
  return {
    initialValues: {
      body: "Please find attached " + props.repairOrder.company.name + " Repair Order # " + props.repairOrder.code + ". Please confirm receipt of this Repair Order.\n\nDo Not Insure.\n\nPlease email estimate to " + props.currentUser.email + ". Please wait for approval before additional work is performed. Whenever available, please include D.O.M. on the teardown / Inspection Report.",
      to: props.repairOrder.contact.email,
      cc: props.currentUser.email,
      subject: props.repairOrder.company.name + " " + props.repairOrder.code
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: function validate(values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_validate_this__["a" /* validator */])(values, function (f) {
      f.validate("body", "to").satisfies(__WEBPACK_IMPORTED_MODULE_6__lib_validation_rules__["a" /* required */]);
      f.validate("to", "cc", "bcc").satisfies(__WEBPACK_IMPORTED_MODULE_6__lib_validation_rules__["b" /* isValidEmail */]);
    });
  },
  onSubmit: function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data, _ev, props) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].repairOrders.sendRepairOrderEmail(props.repairOrder.id, data).then(function () {
                props.close();
                __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].success("Success", "Documents successfully sent.");
              }).catch(function () {
                return __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Error", "Could not send documents. Please refresh page and try again.");
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function onSubmit(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }()
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SendRepairOrderDocumentsModal__ = __webpack_require__(1740);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();







function SendRepairOrderDocuments(_ref) {
  var repairOrder = _ref.repairOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      roModalIsVisible = _useState2[0],
      setRoModalIsVisible = _useState2[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setRoModalIsVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["k" /* Icon */], { name: "envelope", fixed: true }),
    "\xA0Send RO",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SendRepairOrderDocumentsModal__["a" /* default */], {
      open: roModalIsVisible,
      close: function close() {
        return setRoModalIsVisible(false);
      },
      repairOrder: repairOrder.toJS()
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__session_decorators_withCurrentUser__["b" /* default */])(SendRepairOrderDocuments));

/***/ }),
/* 1740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(1738);





function SendRepairOrderDocumentsModal(_ref) {
  var open = _ref.open,
      close = _ref.close,
      repairOrder = _ref.repairOrder;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hooks__["a" /* useCurrentUser */])();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Are You Sure?"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close, currentUser: currentUser, repairOrder: repairOrder })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (SendRepairOrderDocumentsModal);

/***/ }),
/* 1741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Orders_shared_ShippingAddress__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Authorized__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Edit_EditShipping__ = __webpack_require__(1753);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var returnToWarning = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  "div",
  { className: "alert alert-danger" },
  "NOTE: There is an Open Sales Order applied to at least one item from this Repair Order."
);

var ShippingDetails = function (_React$Component) {
  _inherits(ShippingDetails, _React$Component);

  function ShippingDetails() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ShippingDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShippingDetails.__proto__ || Object.getPrototypeOf(ShippingDetails)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editShippingModalOpen: false
    }, _this.openShippingModal = function () {
      _this.setState({ editShippingModalOpen: true });
    }, _this.closeShippingModal = function () {
      return _this.setState({ editShippingModalOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ShippingDetails, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          record = _props.record,
          shippingType = _props.shippingType;
      var editShippingModalOpen = this.state.editShippingModalOpen;

      var cancelled = record.get("cancelled");
      var hasOpenSalesOrders = shippingType === "return_to" && record.get("line_items", []).filter(function (l) {
        return l.getIn(["inventory", "most_recent_sales_order"]) && !l.getIn(["inventory", "most_recent_sales_order", "shipped"]);
      }).size > 0;

      var returnToDiscrepancy = !record.get(__WEBPACK_IMPORTED_MODULE_7__constants__["A" /* LINE_ITEMS */]).isEmpty() && !record.get(__WEBPACK_IMPORTED_MODULE_7__constants__["A" /* LINE_ITEMS */]).every(function (i) {
        return i.get(__WEBPACK_IMPORTED_MODULE_7__constants__["C" /* RETURN_TO_TYPE */]) === record.get(__WEBPACK_IMPORTED_MODULE_7__constants__["C" /* RETURN_TO_TYPE */]);
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_text__["c" /* properCase */])(shippingType),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Authorized__["a" /* default */],
            {
              roles: __WEBPACK_IMPORTED_MODULE_6__users_constants__["v" /* ROLES */].filter(function (r) {
                return r !== __WEBPACK_IMPORTED_MODULE_6__users_constants__["j" /* WAREHOUSE */];
              }),
              subroles: [__WEBPACK_IMPORTED_MODULE_6__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]
            },
            !cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["y" /* EditButton */], { handleClick: this.openShippingModal }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Edit_EditShipping__["a" /* default */], {
              record: record,
              open: editShippingModalOpen,
              close: this.closeShippingModal,
              shippingType: shippingType,
              required: false,
              returnToDiscrepancy: returnToDiscrepancy
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Orders_shared_ShippingAddress__["a" /* default */], { shippingType: shippingType, record: record }),
        children,
        hasOpenSalesOrders && returnToWarning
      );
    }
  }]);

  return ShippingDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ShippingDetails);


ShippingDetails.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inventories_constants__ = __webpack_require__(12);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();














function Sync(_ref) {
  var onConfirm = _ref.onConfirm,
      repairOrder = _ref.repairOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      settings = _useState4[0],
      setSettings = _useState4[1];

  var storeOwnerId = repairOrder.getIn([__WEBPACK_IMPORTED_MODULE_10__constants__["A" /* LINE_ITEMS */], 0, __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["_64" /* STORE_OWNER_ID */]]);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (storeOwnerId) {
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].locations.locationSetting.quickbooksLocationSetting(storeOwnerId).then(function (_ref2) {
        var data = _ref2.data;

        setSettings(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["get"])(data, "settings.quickbooks", {}));

        return function cleanup() {};
      });
    }
  }, [storeOwnerId]);

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["get"])(settings, "accounts_payable_account")) {
    return null;
  }

  var syncDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["get"])(settings, "sync_date");
  var createdAt = __WEBPACK_IMPORTED_MODULE_9_moment___default()(repairOrder.get(__WEBPACK_IMPORTED_MODULE_10__constants__["_7" /* CREATED_AT */]));

  if (syncDate && __WEBPACK_IMPORTED_MODULE_9_moment___default()(syncDate) > __WEBPACK_IMPORTED_MODULE_9_moment___default()(createdAt.format("YYYY-MM-DD"))) {
    return null;
  }

  if (repairOrder.get(__WEBPACK_IMPORTED_MODULE_10__constants__["_46" /* DISABLE_QB_SYNC */])) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: "refresh", fixed: true }),
    "\xA0Sync Accounting",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setVisible(false);
        },
        open: visible,
        btnText: "Yes, Sync w/ Quickbooks",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-refresh" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to sync the RO?",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        "Please ensure the Vendor has a linked account for the store owner."
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onConfirm: function onConfirm() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["s" /* sync */])());
    }
  };
})(Sync));

Sync.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(27);







var Application = function Application(_ref) {
  var application = _ref.application,
      navToPart = _ref.navToPart;

  var labelClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn btn-xs btn-default", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_helpers__["a" /* getPartNumberColorClassNameByTierType */])(application.tier_type));

  var onLabelClick = function onLabelClick() {};
  var labelColor = "#FFFFFF";

  if (application.applicable_uuid) {
    labelColor = "#FF9800";
    onLabelClick = function onLabelClick() {
      return navToPart(application.applicable_uuid);
    };
  }

  var labelStyle = {
    cursor: onLabelClick ? "pointer" : "default",
    color: labelColor,
    fontSize: "1.25em"
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      className: "btn-group",
      style: { marginBottom: 4, marginRight: 2, width: "100%" }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        style: labelStyle,
        type: "button",
        className: labelClassName,
        onClick: onLabelClick
      },
      application.sellable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["j" /* NoteTooltip */], {
        note: "In Stock",
        url: "https://aero-zone-assets.s3.amazonaws.com/inventory.png"
      }),
      application.label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["E" /* ClipboardCopy */], { name: application.label, type: "PN", iconFontSize: "1em" })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    navToPart: function navToPart(partId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["push"])("/parts/" + partId));
    }
  };
})(Application));

/***/ }),
/* 1744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Application__ = __webpack_require__(1743);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();







var Subcomponents = function Subcomponents(_ref) {
  var repairOrder = _ref.repairOrder;

  var tearDown = repairOrder.get(__WEBPACK_IMPORTED_MODULE_3__constants__["A" /* LINE_ITEMS */]).find(function (l) {
    return l.get(__WEBPACK_IMPORTED_MODULE_1__constants__["E" /* ACTION_REQUESTED */]) === __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* TEARDOWN */];
  });
  if (!tearDown) return null;

  var lineItem = tearDown.toJS();

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      records = _useState2[0],
      setRecords = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].parts.applications.list(lineItem.part_id, 1, 100).then(function (resp) {
      setRecords(resp.data.results.filter(function (l) {
        return l.type === "LowerAssemblyApplication";
      }));
      return function cleanup() {};
    });
  }, [repairOrder.get(__WEBPACK_IMPORTED_MODULE_3__constants__["_48" /* UPDATED_AT */])]);

  if (records.length === 0) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Known Subcomponents"
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      records.map(function (r) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Application__["a" /* default */], { application: r, key: r.id });
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Subcomponents);

/***/ }),
/* 1745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__inventories_constants__ = __webpack_require__(12);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

















function ToggleQuickbooksSync(_ref) {
  var onConfirm = _ref.onConfirm,
      repairOrder = _ref.repairOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      settings = _useState4[0],
      setSettings = _useState4[1];

  var storeOwnerId = repairOrder.getIn([__WEBPACK_IMPORTED_MODULE_12__constants__["A" /* LINE_ITEMS */], 0, __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["_64" /* STORE_OWNER_ID */]]);

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__users_helpers__["c" /* hasAnyOfRoles */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks__["a" /* useCurrentUser */])(), [__WEBPACK_IMPORTED_MODULE_9__users_constants__["m" /* ACCOUNTING */]])) {
    return null;
  }

  var createdAt = repairOrder.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_7" /* CREATED_AT */]);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].locations.locationSetting.show(storeOwnerId).then(function (_ref2) {
      var data = _ref2.data;

      setSettings(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(data, "settings.quickbooks", {}));

      return function cleanup() {};
    });
  }, [createdAt]);

  var syncDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_12__constants__["_47" /* SYNC_DATE */]);

  if (!syncDate) return null;

  if (syncDate && __WEBPACK_IMPORTED_MODULE_13_moment___default()(syncDate) <= __WEBPACK_IMPORTED_MODULE_13_moment___default()(createdAt).format("YYYY-MM-DD")) {
    return null;
  }

  var quickbooksDisabled = repairOrder.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_46" /* DISABLE_QB_SYNC */]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: quickbooksDisabled ? "play" : "pause", fixed: true }),
    "\xA0",
    quickbooksDisabled ? "Enable QB Sync" : "Disable QB Sync",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setVisible(false);
        },
        open: visible,
        btnText: quickbooksDisabled ? "Enable QB Sync" : "Disable QB Sync",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-pause" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to",
      " ",
      quickbooksDisabled ? "enable QB Sync" : "disable QB Sync",
      "?"
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onConfirm: function onConfirm() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* update */])({ disable_qb_sync: !ownProps.repairOrder.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_46" /* DISABLE_QB_SYNC */]) }));
    }
  };
})(ToggleQuickbooksSync));

ToggleQuickbooksSync.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_formik__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormikFormInput_FormInput__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormikFormInput_Select__ = __webpack_require__(2321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__LineItems_FormSections_ActionRequested_ActionFormSection__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_components_Forms_FormikForm_FormikFooter__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__shared_components_Forms_NumberInput_NumberInput__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__RepairQuotes_constants__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Shipping_constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__shared_components_Forms_FormikFormInput_FormikCheck__ = __webpack_require__(2320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__validate__ = __webpack_require__(1749);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






























function LineRow(_ref) {
  var idx = _ref.idx,
      initialValues = _ref.initialValues,
      itemsSelected = _ref.itemsSelected,
      setFieldValue = _ref.setFieldValue,
      values = _ref.values,
      toggleItem = _ref.toggleItem;

  var item = "line_items[" + idx + "]";
  var filteredOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__LineItems_FormSections_ActionRequested_ActionFormSection__["b" /* approvalStatuses */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(initialValues, item + "." + __WEBPACK_IMPORTED_MODULE_13__constants__["s" /* APPROVAL_STATUS */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(values, item + "." + __WEBPACK_IMPORTED_MODULE_13__constants__["I" /* ORIGINAL_EVALUATION */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(values, item + "." + __WEBPACK_IMPORTED_MODULE_13__constants__["E" /* ACTION_REQUESTED */]));

  var approvalStatus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(values, item + "." + __WEBPACK_IMPORTED_MODULE_13__constants__["s" /* APPROVAL_STATUS */]);
  var other = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(values, item + "." + __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["M" /* OTHER */]);
  var prevApprovalStatusRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(approvalStatus);

  var tagRequired = [__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["i" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["P" /* INSPECTED */], __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["h" /* REPAIRED */]].includes(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(values, [item, __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["n" /* CONDITION */]].join("."))) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(values, item + "." + __WEBPACK_IMPORTED_MODULE_13__constants__["n" /* REPAIR_AND_HOLD */]) || approvalStatus === __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */];

  var parseValueToZero = function parseValueToZero(value) {
    return value === "" || value === undefined ? "0" : value;
  };

  var formatValueFromZero = function formatValueFromZero(value) {
    return value === "0" || value === 0 || value === undefined ? "" : value;
  };

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    // Only clear the fields if the approval status has changed from its previous state
    if (approvalStatus !== prevApprovalStatusRef.current) {
      setFieldValue("line_items[" + idx + "].transfer_cost", "");
    }
    // Update the ref to the current status for the next render
    prevApprovalStatusRef.current = approvalStatus;
    if (approvalStatus === "repair_evaluation_rejected") {
      setFieldValue("line_items[" + idx + "].evaluation_charge", "0.00");
    }
  }, [approvalStatus, idx, setFieldValue]);

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
    { key: idx, className: "striped" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 1 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "checkbox",
        className: "radio-inline",
        checked: itemsSelected.includes(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(values, item + ".id")),
        onClick: function onClick() {
          return toggleItem(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(values, item + ".id"), idx);
        },
        style: { marginLeft: 10, marginRight: 10 }
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormikFormInput_FormInput__["a" /* FormInput */], {
        name: "line_items[" + idx + "].part.part_number",
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_17__parts_constants__["w" /* PART_NUMBER */]),
        disabled: true
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormikFormInput_FormInput__["a" /* FormInput */], {
        name: "line_items[" + idx + "].serial_number",
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["o" /* SERIAL_NUMBER */]),
        disabled: true
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormikFormInput_Select__["a" /* default */], {
        name: "line_items[" + idx + "].action_requested",
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["E" /* ACTION_REQUESTED */]),
        options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_13__constants__["J" /* ACTIONS_REQUESTED */]),
        disabled: true
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormikFormInput_Select__["a" /* default */], {
        name: "line_items[" + idx + "].approval_status",
        inputProps: {
          field: {
            onChange: function onChange(ev) {
              if (ev.target.value === __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["_65" /* REPAIR_EVALUATION_REJECTED */]) {
                setFieldValue("line_items[" + idx + "].evaluation_charge", 0);
              }
              setFieldValue("line_items[" + idx + "].approval_status", ev.target.value);
            }
          }
        },
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["s" /* APPROVAL_STATUS */]),
        options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_forms__["a" /* toOptions */])(filteredOptions)
      })
    ),
    approvalStatus !== __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["_65" /* REPAIR_EVALUATION_REJECTED */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 3 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormikFormInput_FormInput__["a" /* FormInput */], {
        name: "line_items[" + idx + "].tag_date",
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["x" /* TAG_DATE */]),
        isRequired: tagRequired,
        type: "month"
      })
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 2, mdOffset: 1 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormikFormInput_FormInput__["a" /* FormInput */], {
        name: "line_items[" + idx + "].original_evaluation",
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["I" /* ORIGINAL_EVALUATION */]),
        step: "0.01",
        type: "number",
        isRequired: [__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */], __WEBPACK_IMPORTED_MODULE_13__constants__["Q" /* REPAIR_EVALUATION_RECEIVED */]].includes(approvalStatus)
      })
    ),
    approvalStatus !== __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["_65" /* REPAIR_EVALUATION_REJECTED */] ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormikFormInput_FormInput__["a" /* FormInput */], {
        name: "line_items[" + idx + "].part_cost",
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["o" /* PART_COST */]),
        type: "number",
        step: "0.01",
        parse: parseValueToZero,
        format: formatValueFromZero,
        isRequired: approvalStatus === __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */]
      })
    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormikFormInput_FormInput__["a" /* FormInput */], {
        name: "line_items[" + idx + "].labor_cost",
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["p" /* LABOR_COST */]),
        step: "0.01",
        type: "number",
        parse: parseValueToZero,
        format: formatValueFromZero,
        isRequired: approvalStatus === __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */]
      })
    )] : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormikFormInput_FormInput__["a" /* FormInput */], {
        name: "line_items[" + idx + "].evaluation_charge",
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_24__RepairQuotes_constants__["k" /* EVALUATION_FEE */]),
        step: "0.01",
        type: "number",
        isRequired: true
      })
    ),
    approvalStatus === __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormikFormInput_FormInput__["a" /* FormInput */], {
        name: "line_items[" + idx + "].transfer_cost",
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["T" /* TRANSFER_COST */]),
        step: "0.01",
        type: "number",
        defaultValue: "0.00"
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormikFormInput_FormInput__["a" /* FormInput */], {
        name: "line_items[" + idx + "].estimated_lead_time",
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["O" /* ESTIMATED_LEAD_TIME */]),
        type: "number"
      })
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 2, mdOffset: 1 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormikFormInput_Select__["a" /* default */], {
        name: "line_items[" + idx + "].inventory.condition",
        label: "Inventory Condition",
        options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_25__Shipping_constants__["r" /* CONDITION_TYPES */]),
        disabled: approvalStatus !== __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */]
      })
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 11, mdOffset: 1 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "form-group", style: { cursor: "pointer" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "tag_type" },
          "Release Type",
          " ",
          approvalStatus === __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "sup",
            { className: "small text-danger" },
            "*"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            id: "tag_type",
            className: "btn-group btn-group-justified",
            "data-toggle": "buttons"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__shared_components_Forms_FormikFormInput_FormikCheck__["a" /* default */], {
            label: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["H" /* FAA */].toUpperCase(),
            name: "line_items[" + idx + "].faa"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__shared_components_Forms_FormikFormInput_FormikCheck__["a" /* default */], {
            label: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["I" /* EASA */].toUpperCase(),
            name: "line_items[" + idx + "].easa"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__shared_components_Forms_FormikFormInput_FormikCheck__["a" /* default */], {
            label: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["K" /* TCCA */].toUpperCase(),
            name: "line_items[" + idx + "].tcca"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__shared_components_Forms_FormikFormInput_FormikCheck__["a" /* default */], {
            label: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["J" /* CAAC */].toUpperCase(),
            name: "line_items[" + idx + "].caac"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__shared_components_Forms_FormikFormInput_FormikCheck__["a" /* default */], {
            label: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["M" /* OTHER */].toUpperCase(),
            name: "line_items[" + idx + "].other"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_formik__["a" /* Field */],
        { name: "line_items[" + idx + "].Tag Type" },
        function (_ref2) {
          var field = _ref2.field,
              form = _ref2.form;

          var jsxErrors = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(form.errors, field.name) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(form.errors, field.name).map(function (m) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "text-danger", key: m },
              m
            );
          });

          return jsxErrors || null;
        }
      )
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
    null,
    other && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
      { md: 2, mdOffset: 1 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormikFormInput_FormInput__["a" /* FormInput */], {
        name: "line_items[" + idx + "]." + __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["N" /* OTHER_TAG_TYPE */],
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["N" /* OTHER_TAG_TYPE */])
      })
    )
  )];
}

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
      itemsSelected: _this.props.itemsSelected
    }, _this.toggleItem = function (setField, initialValues) {
      return function (id, item) {
        var itemsSelected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["xor"])(_this.state.itemsSelected, [id]);

        if (!itemsSelected.includes(id)) {
          [__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["x" /* TAG_DATE */], __WEBPACK_IMPORTED_MODULE_13__constants__["s" /* APPROVAL_STATUS */], __WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["o" /* PART_COST */], __WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["p" /* LABOR_COST */], __WEBPACK_IMPORTED_MODULE_13__constants__["T" /* TRANSFER_COST */], __WEBPACK_IMPORTED_MODULE_13__constants__["O" /* ESTIMATED_LEAD_TIME */], __WEBPACK_IMPORTED_MODULE_13__constants__["I" /* ORIGINAL_EVALUATION */]].forEach(function (f) {
            var field = "line_items[" + item + "]." + f;

            setField(field, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(initialValues, field) || null);
          });
        }

        _this.setState({
          itemsSelected: itemsSelected
        });
      };
    }, _this.handleTopLevelFormChange = function (field, values, initialValues, setFieldValue) {
      return function (ev) {
        var _this$props$includeCa = _this.props.includeCancelled,
            includeCancelled = _this$props$includeCa === undefined ? false : _this$props$includeCa;

        if (!ev.target) return;
        var val = ev.target.value;
        values.line_items.filter(function (l) {
          return includeCancelled || !l.cancelled;
        }).forEach(function (l, idx) {
          if (_this.state.itemsSelected.includes(l.id)) {
            if (field === __WEBPACK_IMPORTED_MODULE_13__constants__["s" /* APPROVAL_STATUS */]) {
              _this.setState({ topLevelApprovalStatus: val });

              var filteredOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__LineItems_FormSections_ActionRequested_ActionFormSection__["b" /* approvalStatuses */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(initialValues, "line_items[" + idx + "]." + __WEBPACK_IMPORTED_MODULE_13__constants__["s" /* APPROVAL_STATUS */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(values, "line_items[" + idx + "]." + __WEBPACK_IMPORTED_MODULE_13__constants__["I" /* ORIGINAL_EVALUATION */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])("line_items[" + idx + "]." + __WEBPACK_IMPORTED_MODULE_13__constants__["E" /* ACTION_REQUESTED */]));

              if (Object.keys(filteredOptions).includes(val) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(values, "line_items[" + idx + "]." + __WEBPACK_IMPORTED_MODULE_13__constants__["V" /* INTERNAL_OUTRIGHT */])) {
                setFieldValue("line_items[" + idx + "]." + field, val);
              }
            } else if (field === "inventory.condition") {
              if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(values, "line_items[" + idx + "]." + __WEBPACK_IMPORTED_MODULE_13__constants__["s" /* APPROVAL_STATUS */]) === __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */]) {
                setFieldValue("line_items[" + idx + "]." + field, val);
              }
            } else {
              var formattedVal = [__WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["o" /* PART_COST */], __WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["p" /* LABOR_COST */], __WEBPACK_IMPORTED_MODULE_13__constants__["T" /* TRANSFER_COST */], __WEBPACK_IMPORTED_MODULE_13__constants__["I" /* ORIGINAL_EVALUATION */]].includes(field) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__shared_components_Forms_NumberInput_NumberInput__["b" /* rounder */])(val) : val;
              if (field === __WEBPACK_IMPORTED_MODULE_13__constants__["T" /* TRANSFER_COST */] && (formattedVal === "" || formattedVal === undefined || formattedVal === null)) {
                return setFieldValue("line_items[" + idx + "]." + field, 0.0);
              }
              setFieldValue("line_items[" + idx + "]." + field, formattedVal);
            }
          }
          return null;
        });
      };
    }, _this.handleAmountFormChange = function (ev, field) {
      var val = ev.target ? ev.target.value : null;
      var date = __WEBPACK_IMPORTED_MODULE_12_moment___default()().format("YYYY-MM-DD");
      if (val) {
        _this.props.change("line_items[" + 0 + "]." + field, date);
      }
    }, _this.allItemsSelected = function (values) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEqual"])(_this.state.itemsSelected.sort(), values.line_items.map(function (l) {
        return l.id;
      }).sort());
    }, _this.selectAll = function (values) {
      if (_this.allItemsSelected(values)) {
        _this.setState({ itemsSelected: [] });
      } else {
        _this.setState({
          itemsSelected: values.line_items.map(function (l) {
            return l.id;
          })
        });
      }
    }, _this.approvalStatuses = Object.keys(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__lib_removeKey__["b" /* removeKeys */])(__WEBPACK_IMPORTED_MODULE_13__constants__["_9" /* APPROVAL_STATUSES */], [__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["_65" /* REPAIR_EVALUATION_REJECTED */], __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */]])), _this.search = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["debounce"])(function (updateValues, val) {
      __WEBPACK_IMPORTED_MODULE_18__api__["a" /* default */].repairOrders.lineItems.search(_this.props.repairOrder.id, {
        limit: 15,
        filter: val,
        approval_status: _this.approvalStatuses.join(","),
        shipped: true,
        simple_presenter: true
      }).then(function (_ref4) {
        var data = _ref4.data;

        updateValues({ line_items: data.results });
        return function cleanup() {};
      });
    }, 500), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          initialValues = _props.initialValues,
          onSubmit = _props.onSubmit;
      var _state = this.state,
          itemsSelected = _state.itemsSelected,
          topLevelApprovalStatus = _state.topLevelApprovalStatus,
          approvalStatus = _state.approvalStatus;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_formik__["b" /* Formik */],
        {
          initialValues: initialValues,
          onSubmit: onSubmit,
          validate: __WEBPACK_IMPORTED_MODULE_27__validate__["a" /* default */]
        },
        function (_ref5) {
          var isSubmitting = _ref5.isSubmitting,
              values = _ref5.values,
              setSubmitting = _ref5.setSubmitting,
              handleSubmit = _ref5.handleSubmit,
              rest = _objectWithoutProperties(_ref5, ["isSubmitting", "values", "setSubmitting", "handleSubmit"]);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */],
            { handleSubmit: onSubmit, close: _this2.props.close },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */].Body,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    { htmlFor: __WEBPACK_IMPORTED_MODULE_13__constants__["s" /* APPROVAL_STATUS */] },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["s" /* APPROVAL_STATUS */])
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "select",
                    {
                      className: "form-control",
                      onChange: _this2.handleTopLevelFormChange(__WEBPACK_IMPORTED_MODULE_13__constants__["s" /* APPROVAL_STATUS */], values, initialValues, rest.setFieldValue)
                    },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_forms__["a" /* toOptions */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__lib_removeKey__["b" /* removeKeys */])(__WEBPACK_IMPORTED_MODULE_13__constants__["_9" /* APPROVAL_STATUSES */], [__WEBPACK_IMPORTED_MODULE_13__constants__["K" /* AWAITING_TO_SHIP */], __WEBPACK_IMPORTED_MODULE_13__constants__["_8" /* UNIT_RETURNED_TO_CUSTOMER */]])).map(function (r) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "option",
                        { key: r.value, value: r.value },
                        r.text
                      );
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    { htmlFor: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["x" /* TAG_DATE */] },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["x" /* TAG_DATE */]),
                    approvalStatus === __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      { style: { color: "red" } },
                      "*"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                    onChange: _this2.handleTopLevelFormChange(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["x" /* TAG_DATE */], values, initialValues, rest.setFieldValue),
                    className: "form-control",
                    name: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["x" /* TAG_DATE */],
                    type: "month"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    { htmlFor: __WEBPACK_IMPORTED_MODULE_13__constants__["I" /* ORIGINAL_EVALUATION */] },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["I" /* ORIGINAL_EVALUATION */]),
                    approvalStatus === __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      { style: { color: "red" } },
                      "*"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                    onChange: _this2.handleTopLevelFormChange(__WEBPACK_IMPORTED_MODULE_13__constants__["I" /* ORIGINAL_EVALUATION */], values, initialValues, rest.setFieldValue),
                    className: "form-control",
                    name: __WEBPACK_IMPORTED_MODULE_13__constants__["I" /* ORIGINAL_EVALUATION */],
                    type: "number"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    { htmlFor: __WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["o" /* PART_COST */] },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["o" /* PART_COST */]),
                    approvalStatus === __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      { style: { color: "red" } },
                      "*"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                    onChange: _this2.handleTopLevelFormChange(__WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["o" /* PART_COST */], values, initialValues, rest.setFieldValue),
                    className: "form-control",
                    name: __WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["o" /* PART_COST */],
                    type: "number"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    { htmlFor: __WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["p" /* LABOR_COST */] },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["p" /* LABOR_COST */]),
                    approvalStatus === __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      { style: { color: "red" } },
                      "*"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                    onChange: _this2.handleTopLevelFormChange(__WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["p" /* LABOR_COST */], values, initialValues, rest.setFieldValue),
                    className: "form-control",
                    name: __WEBPACK_IMPORTED_MODULE_11__SalesOrders_constants__["p" /* LABOR_COST */],
                    type: "number"
                  })
                ),
                approvalStatus === __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    { htmlFor: __WEBPACK_IMPORTED_MODULE_13__constants__["T" /* TRANSFER_COST */] },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["T" /* TRANSFER_COST */])
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                    onChange: _this2.handleTopLevelFormChange(__WEBPACK_IMPORTED_MODULE_13__constants__["T" /* TRANSFER_COST */], values, initialValues, rest.setFieldValue),
                    className: "form-control",
                    name: __WEBPACK_IMPORTED_MODULE_13__constants__["T" /* TRANSFER_COST */],
                    type: "number",
                    defaultValue: "0.00"
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    { htmlFor: __WEBPACK_IMPORTED_MODULE_13__constants__["O" /* ESTIMATED_LEAD_TIME */] },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["O" /* ESTIMATED_LEAD_TIME */])
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                    onChange: _this2.handleTopLevelFormChange(__WEBPACK_IMPORTED_MODULE_13__constants__["O" /* ESTIMATED_LEAD_TIME */], values, initialValues, rest.setFieldValue),
                    className: "form-control",
                    name: __WEBPACK_IMPORTED_MODULE_13__constants__["O" /* ESTIMATED_LEAD_TIME */],
                    type: "number"
                  })
                ),
                topLevelApprovalStatus === __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    { htmlFor: __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["n" /* CONDITION */] },
                    "Inventory Condition"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "select",
                    {
                      className: "form-control",
                      onChange: _this2.handleTopLevelFormChange("inventory.condition", values, initialValues, rest.setFieldValue)
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "option",
                      { value: "" },
                      "Select"
                    ),
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_23__constants__["_36" /* CONDITIONS */]).map(function (r) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "option",
                        { key: r.value, value: r.value },
                        r.text
                      );
                    })
                  )
                ),
                approvalStatus === __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["_65" /* REPAIR_EVALUATION_REJECTED */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    { htmlFor: __WEBPACK_IMPORTED_MODULE_24__RepairQuotes_constants__["k" /* EVALUATION_FEE */] },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_24__RepairQuotes_constants__["k" /* EVALUATION_FEE */])
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                    onChange: _this2.handleTopLevelFormChange(__WEBPACK_IMPORTED_MODULE_13__constants__["_7" /* EVALUATION_CHARGE */], values, initialValues, rest.setFieldValue),
                    className: "form-control",
                    name: __WEBPACK_IMPORTED_MODULE_13__constants__["_7" /* EVALUATION_CHARGE */],
                    type: "number"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 6, style: { paddingTop: 10 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_20__shared_components__["n" /* Warning */],
                    null,
                    "Note: Displaying only results for parts not already approved or rejected."
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    { htmlFor: "Search by PN or SN" },
                    "Search by PN or SN"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                    placeholder: "Search by PN or SN",
                    className: "form-control",
                    onChange: function onChange(ev) {
                      return _this2.search(rest.setValues, ev.target.value);
                    }
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                name: "line_items",
                type: "checkbox",
                onClick: function onClick() {
                  return _this2.selectAll(values);
                },
                checked: itemsSelected.length > 0 && _this2.allItemsSelected(values)
              }),
              "\xA0\xA0Select All ",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "sup",
                null,
                "(Limit 15 Per Update)"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_formik__["c" /* FieldArray */],
                { name: "line_items" },
                function () {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "striped" },
                    values.line_items.map(function (l, idx) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LineRow, {
                        idx: idx,
                        values: values,
                        initialValues: initialValues,
                        itemsSelected: itemsSelected,
                        setFieldValue: rest.setFieldValue,
                        toggleItem: _this2.toggleItem(rest.setFieldValue, initialValues)
                      });
                    })
                  );
                }
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__shared_components_Forms_FormikForm_FormikFooter__["a" /* FormikFooter */], {
              rest: rest,
              setSubmitting: setSubmitting,
              isSubmitting: isSubmitting,
              isValid: rest.isValid,
              values: {
                line_items: values.line_items.filter(function (l) {
                  return itemsSelected.includes(l.id);
                })
              },
              handleSubmit: handleSubmit,
              close: _this2.props.close
            })
          );
        }
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  change: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  includeCancelled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  order: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      dispatch(ownProps.bulkUpdate(data)).then(function () {
        ownProps.close();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].error("Error", error.message);
      });
    }
  };
})(Form));

/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = UpdateEvaluationStatus;





function UpdateEvaluationStatus(_ref) {
  var toggleApprovalModal = _ref.toggleApprovalModal;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: toggleApprovalModal },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "check", fixed: true }),
    "Update Evaluation Status"
  );
}

UpdateEvaluationStatus.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  toggleApprovalModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Form__ = __webpack_require__(1746);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();













function EditEvaluationStatusModal(_ref) {
  var close = _ref.close,
      repairOrder = _ref.repairOrder,
      visible = _ref.visible;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      lineItems = _useState2[0],
      setLineItems = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState4 = _slicedToArray(_useState3, 2),
      itemsSelected = _useState4[0],
      setItemsSelected = _useState4[1];

  var approvalStatuses = Object.keys(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_removeKey__["b" /* removeKeys */])(__WEBPACK_IMPORTED_MODULE_9__constants__["_9" /* APPROVAL_STATUSES */], [__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_65" /* REPAIR_EVALUATION_REJECTED */], __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */]]));

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].repairOrders.lineItems.search(repairOrder.get(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]), {
      limit: 15,
      approval_status: approvalStatuses.join(","),
      shipped: true,
      simple_presenter: true
    }).then(function (_ref2) {
      var data = _ref2.data;

      setLineItems(data.results);
      setItemsSelected(data.results.map(function (l) {
        return l.id;
      }));
      return function cleanup() {};
    });
  }, [repairOrder.get(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]), visible]);

  if (!lineItems) return null;

  var js = repairOrder.toJS();
  js.line_items = lineItems.filter(function (l) {
    return !l.cancelled && ![__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_65" /* REPAIR_EVALUATION_REJECTED */], __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["Q" /* REPAIR_EVALUATION_APPROVED */]].includes(l.approval_status) && l.shipped;
  });

  var hasTeardown = js.line_items.some(function (l) {
    return l.action_requested === __WEBPACK_IMPORTED_MODULE_9__constants__["b" /* TEARDOWN */];
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: visible, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Update Evaluation"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Form__["a" /* default */], {
      close: close,
      hasTeardown: hasTeardown,
      repairOrder: js,
      initialValues: Object.assign(js, {
        approval_status: null,
        condition: null,
        tag_date: null,
        part_cost: null,
        labor_cost: null,
        transfer_cost: null,
        estimated_lead_time: null
      }),
      itemsSelected: itemsSelected,
      setItemsSelected: setItemsSelected,
      bulkUpdate: __WEBPACK_IMPORTED_MODULE_4__actions__["q" /* bulkUpdateSelectedLineItems */](itemsSelected)
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (EditEvaluationStatusModal);

EditEvaluationStatusModal.propTypes = {
  repairOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]).isRequired
};

/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Lots_constants__ = __webpack_require__(64);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;









function validateItem(item, values) {
  item.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["s" /* APPROVAL_STATUS */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);

  if ([__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* REPAIR_EVALUATION_APPROVED */], __WEBPACK_IMPORTED_MODULE_2__constants__["Q" /* REPAIR_EVALUATION_RECEIVED */]].includes(values.approval_status)) {
    item.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["I" /* ORIGINAL_EVALUATION */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
  }

  if (values.approval_status === __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* REPAIR_EVALUATION_APPROVED */]) {
    item.validate(__WEBPACK_IMPORTED_MODULE_4__SalesOrders_constants__["p" /* LABOR_COST */], __WEBPACK_IMPORTED_MODULE_4__SalesOrders_constants__["o" /* PART_COST */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["g" /* requiredAllowZero */]);
  }

  if (values.approval_status === __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* REPAIR_EVALUATION_REJECTED */]) {
    item.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["_7" /* EVALUATION_CHARGE */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["g" /* requiredAllowZero */]);
  }

  if (__WEBPACK_IMPORTED_MODULE_5__Receiving_constants__["u" /* TAG_DATE_CONDITIONS */].includes(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(values, "inventory.condition"))) {
    item.validate(__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["x" /* TAG_DATE */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
  }

  if (values.approval_status === __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* REPAIR_EVALUATION_APPROVED */]) {
    item.validate("Tag Type").satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["n" /* requiresAtLeast */](1, __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_7__Lots_constants__["e" /* OTHER */]));
  }

  if (values.other) {
    item.validate(__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["N" /* OTHER_TAG_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["o" /* maxLengthOfText */](30));
  }
}

function validate(values) {
  var errors = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validateChildren("line_items", validateItem);
  });

  return errors;
}

/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Receiving_constants__ = __webpack_require__(34);









var Warnings = function Warnings(_ref) {
  var repairOrder = _ref.repairOrder;

  var empty = repairOrder.get(__WEBPACK_IMPORTED_MODULE_4__constants__["A" /* LINE_ITEMS */]).isEmpty();
  var finalized = !empty && repairOrder.get(__WEBPACK_IMPORTED_MODULE_4__constants__["A" /* LINE_ITEMS */]).every(function (i) {
    return i.get("final_evaluation_approved");
  });

  var cancelled = repairOrder.get(__WEBPACK_IMPORTED_MODULE_4__constants__["_38" /* CANCELLED */]);

  var customerRmaRequested = !empty && repairOrder.get(__WEBPACK_IMPORTED_MODULE_4__constants__["A" /* LINE_ITEMS */]).toJS().some(function (l) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(l, "inventory.most_recent_customer_rma") && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(l, "inventory.most_recent_customer_rma.cancelled") && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(l, "inventory.most_recent_customer_rma.credit_issued");
  });

  var mro = !empty && repairOrder.get(__WEBPACK_IMPORTED_MODULE_4__constants__["A" /* LINE_ITEMS */]).some(function (l) {
    return l.getIn([__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["_29" /* MANAGED_REPAIR_IN_PROGRESS */]]) || l.getIn([__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["_69" /* MANAGED_REPAIR_REPAIRED */]]);
  });

  var consignment = !empty && repairOrder.get(__WEBPACK_IMPORTED_MODULE_4__constants__["A" /* LINE_ITEMS */]).some(function (l) {
    return l.getIn([__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["_70" /* CONSIGNED_DATE */]]) || l.getIn([__WEBPACK_IMPORTED_MODULE_6__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["_71" /* CONSIGNMENT_TYPE */]]) === __WEBPACK_IMPORTED_MODULE_7__Receiving_constants__["t" /* CONSIGNMENT */];
  });

  var vendorRmaRequestCancelled = repairOrder.get(__WEBPACK_IMPORTED_MODULE_4__constants__["A" /* LINE_ITEMS */]).some(function (i) {
    return i.get("vendor_rma_status") === __WEBPACK_IMPORTED_MODULE_4__constants__["_38" /* CANCELLED */] && !i.get(__WEBPACK_IMPORTED_MODULE_4__constants__["_26" /* RECEIVED */]);
  });

  var customerRmaRequestCancelled = repairOrder.get(__WEBPACK_IMPORTED_MODULE_4__constants__["A" /* LINE_ITEMS */]).some(function (i) {
    return i.get("customer_rma_cancelled");
  });

  var exchangeGoneOutright = repairOrder.get(__WEBPACK_IMPORTED_MODULE_4__constants__["A" /* LINE_ITEMS */]).some(function (i) {
    return i.get("exchange_gone_outright");
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components__["K" /* StatusTags */],
    null,
    exchangeGoneOutright && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["p" /* StatusTag */], {
      display: "success",
      title: "Exchange Gone Outright",
      icon: "check"
    }),
    finalized && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["p" /* StatusTag */], { display: "success", title: "Final Approval", icon: "check" }),
    cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["p" /* StatusTag */], { display: "danger", title: "Cancelled", icon: "ban" }),
    customerRmaRequested && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["p" /* StatusTag */], { display: "danger", title: "Customer RMA", icon: "ban" }),
    vendorRmaRequestCancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["p" /* StatusTag */], { display: "danger", title: "Vendor RMA Cancelled", icon: "ban" }),
    customerRmaRequestCancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["p" /* StatusTag */], { display: "danger", title: "Customer RMA Cancelled", icon: "ban" }),
    !repairOrder.get(__WEBPACK_IMPORTED_MODULE_5__constants__["_5" /* APPROVED */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["p" /* StatusTag */], { display: "danger", title: "Requires Approval", icon: "pause" }),
    consignment && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["p" /* StatusTag */], {
      display: "warning",
      title: "Consignment",
      icon: "location-arrow"
    }),
    mro && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["p" /* StatusTag */], { display: "success", title: "Managed Repair", icon: "recycle" })
  );
};

Warnings.propTypes = {
  repairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map)
};

/* harmony default export */ __webpack_exports__["a"] = (Warnings);

/***/ }),
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_PaymentTerms_PaymentTerms__ = __webpack_require__(177);
/* unused harmony export Form */









var formName = "editROBilling";

function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_PaymentTerms_PaymentTerms__["a" /* default */], { getInitialFieldValue: props.getInitialFieldValue })
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, { onSubmit: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* update */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["j" /* form */])({
  form: formName
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__companies_actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__companies_shared_FindOrCreateCompanyToggle_SearchCompany__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_CompanyAddressWarning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var formName = "updateRepairOrder";

var EditCompanyForm = function (_React$Component) {
  _inherits(EditCompanyForm, _React$Component);

  function EditCompanyForm() {
    _classCallCheck(this, EditCompanyForm);

    var _this = _possibleConstructorReturn(this, (EditCompanyForm.__proto__ || Object.getPrototypeOf(EditCompanyForm)).call(this));

    _this.state = {
      contacts: [],
      invalidCompany: false,
      primaryPhysicalAddress: { value: "", text: "" },
      selectedCompany: null
    };

    _this.notifyForm = function (company) {
      if (company && (!company.primary_physical_address || !company.billing_address)) {
        return _this.setState({ invalidCompany: true, company: company });
      }
      return _this.setState({ invalidCompany: false });
    };

    _this.handleCompanySelected = function (company) {
      _this.setState({ selectedCompany: company });
      _this.fetchAddresses(company.id);
    };

    _this.fetchAddresses = function (companyId) {
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].companies.physicalAddresses.search(companyId, {
        page: 1,
        limit: 100,
        sort: "primary",
        reverse: true
      }).then(function (resp) {
        if (resp.data.results.length > 0) {
          var primaryAddress = resp.data.results[0];
          _this.setState({
            primaryPhysicalAddress: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_forms__["c" /* addressesToOptions */])([primaryAddress])[0]
          });
          _this.props.change("repair_station_physical_address_id", primaryAddress.id);
        } else {
          _this.setState({ primaryPhysicalAddress: { value: "", text: "" } });
        }
      });
    };

    _this.fetchContacts = function (value) {
      if (!value) {
        return null;
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__parts_actions__["g" /* searchContacts */])(value).then(function () {
        var vals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return _this.setState({ contacts: vals });
      });
    };

    _this.notifyForm = _this.notifyForm.bind(_this);
    return _this;
  }

  _createClass(EditCompanyForm, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.record.get(__WEBPACK_IMPORTED_MODULE_15__companies_constants__["p" /* COMPANY */])) {
        this.fetchContacts(this.props.record.getIn([__WEBPACK_IMPORTED_MODULE_15__companies_constants__["p" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_16__constants__["b" /* ID */]]));
        this.fetchAddresses(this.props.record.getIn([__WEBPACK_IMPORTED_MODULE_15__companies_constants__["p" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_16__constants__["b" /* ID */]]));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var record = this.props.record;
      var _state = this.state,
          invalidCompany = _state.invalidCompany,
          selectedCompany = _state.selectedCompany,
          primaryPhysicalAddress = _state.primaryPhysicalAddress;

      var company = selectedCompany || record.get(__WEBPACK_IMPORTED_MODULE_15__companies_constants__["p" /* COMPANY */]) && record.get(__WEBPACK_IMPORTED_MODULE_15__companies_constants__["p" /* COMPANY */]).toJS();
      var hasShippedLineItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["some"])(record.get("line_items").toJS(), function (lineItem) {
        return lineItem.shipped;
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */],
        _extends({}, this.props, { disabled: invalidCompany }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_CompanyAddressWarning__["a" /* default */], { company: company }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__companies_shared_FindOrCreateCompanyToggle_SearchCompany__["a" /* default */], {
            companySearch: __WEBPACK_IMPORTED_MODULE_8__companies_actions__["a" /* searchRepairStationCompanies */],
            contacts: this.state.contacts,
            formName: formName,
            fetchContacts: this.fetchContacts,
            selectedCompany: company,
            onCompanySelected: this.handleCompanySelected,
            onCompanyToggleTypeChange: this.handleToggleChange,
            type: "repairOrder",
            disabledFields: { company_id: hasShippedLineItems }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: "repair_station_physical_address_id",
                  label: "Repair Station Address",
                  component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["c" /* Select */],
                  value: primaryPhysicalAddress,
                  options: [primaryPhysicalAddress],
                  prompt: false,
                  disabled: true,
                  required: true
                })
              )
            )
          )
        )
      );
    }
  }]);

  return EditCompanyForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

EditCompanyForm.propTypes = {
  change: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, { onSubmit: __WEBPACK_IMPORTED_MODULE_7__actions__["a" /* update */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["j" /* form */])({
  form: formName
})(EditCompanyForm)));

/***/ }),
/* 1753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ShippingForm__ = __webpack_require__(1754);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var EditShipping = function (_React$Component) {
  _inherits(EditShipping, _React$Component);

  function EditShipping() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EditShipping);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditShipping.__proto__ || Object.getPrototypeOf(EditShipping)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      addresses: []
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditShipping, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].companies.physicalAddresses.search(this.props.record.getIn([__WEBPACK_IMPORTED_MODULE_5__companies_constants__["p" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_6__constants__["b" /* ID */]]), {
        page: 1,
        limit: 100,
        sort: "primary",
        reverse: true
      }).then(function (_ref2) {
        var results = _ref2.data.results;

        _this2.setState({ addresses: results });
      });
    }
  }, {
    key: "renderReturnToDiscrepancyWarning",
    value: function renderReturnToDiscrepancyWarning() {
      if (this.props.returnToDiscrepancy && this.props.shippingType === __WEBPACK_IMPORTED_MODULE_6__constants__["_39" /* RETURN_TO */]) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "col-md-12" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "alert alert-warning" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-warning" }),
            "\xA0\xA0 One or more Line Items in this RO do not have the same Return details. Changing the Return Shipping Address details on this form, will update Return details on all underlying Line Items."
          )
        );
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          open = _props.open,
          close = _props.close,
          record = _props.record,
          shippingType = _props.shippingType;
      var addresses = this.state.addresses;

      var initialValues = _extends({}, record.toJS(), {
        cost: record.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_2" /* PART_COST */]), // hack for insurance values
        quantity: 1
      });

      var shippingMethod = record.get(shippingType + "_shipping_method");

      if (shippingMethod) {
        initialValues[shippingType + "_shipping_method"] = shippingMethod.toJS();

        initialValues[shippingType + "_type"] = record.get(shippingType + "_type");
        initialValues[shippingType + "_company_address_id"] = record.get(shippingType + "_company_address_id");
        initialValues[shippingType + "_company_id"] = record.get(shippingType + "_type");
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
        { open: open, close: close },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            { className: "modal-title" },
            "Edit ",
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(shippingType),
            " Shipping Info"
          )
        ),
        this.renderReturnToDiscrepancyWarning(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ShippingForm__["a" /* default */], {
          close: close,
          addresses: addresses,
          initialValues: initialValues,
          record: record,
          shippingType: shippingType,
          enableReinitialize: true
        })
      );
    }
  }]);

  return EditShipping;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (EditShipping);


EditShipping.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  record: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]).isRequired,
  shippingType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  returnToDiscrepancy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Orders_shared_ShippingFields__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Detail_LineItems_FormSections_ShippingSection_InsuranceFields__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConvertToRo_validate__ = __webpack_require__(695);
/* unused harmony export Form */


















var formName = "editROShipping";

function Form(props) {
  var record = props.record,
      shippingType = props.shippingType,
      addresses = props.addresses;

  var shipToCompany = record.get(shippingType + "_company") || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_immutable__["Map"])();
  var types = shippingType === "ship_to" ? [__WEBPACK_IMPORTED_MODULE_11__companies_constants__["f" /* REPAIR_STATION */], __WEBPACK_IMPORTED_MODULE_11__companies_constants__["p" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["L" /* DROPSHIP */]] : [__WEBPACK_IMPORTED_MODULE_11__companies_constants__["p" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["L" /* DROPSHIP */], __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["d" /* DO_NOT_SHIP */]];
  var fob = shippingType === "return_to" ? "return_to_fob" : "ship_to_fob";
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "row row-col-gutters-half" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], { name: fob, component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */], label: "FOB", required: true })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Orders_shared_ShippingFields__["a" /* default */], {
        shipToCompany: shipToCompany.toJS(),
        repairStationOptions: addresses,
        formName: formName,
        shippingFields: [shippingType + "_type", shippingType + "_company_id", shippingType + "_company_address_id"],
        shippingTypes: types,
        shippingMethod: shippingType + "_shipping_method",
        shippingAddressField: shippingType + "_shipping_address",
        required: shippingType === __WEBPACK_IMPORTED_MODULE_9__constants__["B" /* SHIP_TO */],
        hasLocations: shippingType !== __WEBPACK_IMPORTED_MODULE_9__constants__["B" /* SHIP_TO */],
        locationFieldName: __WEBPACK_IMPORTED_MODULE_9__constants__["_25" /* RETURN_TO_LOCATION_ID */]
      }),
      shippingType === __WEBPACK_IMPORTED_MODULE_9__constants__["B" /* SHIP_TO */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { key: "insurance-condition-section" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Fields"], {
              names: ["amount_insured", "percent_insured", "insurance_type"],
              component: __WEBPACK_IMPORTED_MODULE_14__Detail_LineItems_FormSections_ShippingSection_InsuranceFields__["a" /* InsuranceTypeField */]
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Fields"], {
            names: ["amount_insured", "percent_insured", "insurance_type", __WEBPACK_IMPORTED_MODULE_10__SalesOrders_constants__["o" /* PART_COST */], __WEBPACK_IMPORTED_MODULE_9__constants__["j" /* QUANTITY */]],
            component: __WEBPACK_IMPORTED_MODULE_14__Detail_LineItems_FormSections_ShippingSection_InsuranceFields__["b" /* InsuranceFields */]
          })
        )
      )
    )
  );
}

Form.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    ship_to_company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
  }),
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  addresses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}))
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(undefined, { onSubmit: __WEBPACK_IMPORTED_MODULE_7__actions__["a" /* update */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: function validate(values, props) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_validate_this__["a" /* validator */])(values, function (f) {
      if (props.shippingType === __WEBPACK_IMPORTED_MODULE_9__constants__["_39" /* RETURN_TO */]) {
        f.validate(__WEBPACK_IMPORTED_MODULE_9__constants__["C" /* RETURN_TO_TYPE */]).satisfies(function (val) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__ConvertToRo_validate__["a" /* validReturnToForWarranty */])(val, props.record.toJS());
        });
      }
    });
  }
})(Form)));

/***/ }),
/* 1755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Search__ = __webpack_require__(1756);
/* harmony export (immutable) */ __webpack_exports__["a"] = ReserveForRepairList;



function ReserveForRepairList() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Search__["a" /* default */], null);
}

/***/ }),
/* 1756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Table__ = __webpack_require__(1757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pagination__ = __webpack_require__(272);
/* harmony export (immutable) */ __webpack_exports__["a"] = RepairOrderSearch;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











var filters = [{
  label: "Show QC Hold",
  filters: { qc_status: "qc_hold" }
}, {
  label: "Show QC Under Review",
  filters: { qc_status: "under_review" }
}, {
  label: "Show Discrepancy Reported",
  filters: { open_discrepancies: true }
}, {
  label: __WEBPACK_IMPORTED_MODULE_6__constants__["_37" /* CLEAR_FILTERS_TEXT */],
  filters: {
    qc_status: undefined,
    open_discrepancies: undefined
  }
}];

var filterTags = [{
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["T" /* UNDER_REVIEW */]),
  key: __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_63" /* QC_STATUS */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["T" /* UNDER_REVIEW */])
}, {
  label: "QC Hold",
  key: __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_63" /* QC_STATUS */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["S" /* QC_HOLD */])
}, {
  label: "Discrepancies Reported",
  key: "open_discrepancies"
}];

function RepairOrderSearch() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_8__pagination__["c" /* reservedForRepairInventory */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a part number or serial number..."
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, { filters: filters, right: true }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "Reserved For Repair",
          filters: filterTags
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Nav_RepairOrdersCart_actions__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Receiving_components_shared_StatusTags__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_LocationFlag_LocationFlag__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__ = __webpack_require__(11);
/* harmony export (immutable) */ __webpack_exports__["a"] = Table;
/* unused harmony export ConnectedButton */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


















var statuses = function statuses(item) {
  return {
    discrepancies: !item.discrepancies_resolved,
    hold: item.qc_status === __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["S" /* QC_HOLD */],
    underReview: item.qc_status === __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["T" /* UNDER_REVIEW */]
  };
};

function Table(_ref) {
  var results = _ref.results,
      isLoading = _ref.isLoading;

  var reference = function reference(item) {
    if (item.lot_id) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],
        { to: "/lots/" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(item, "lot_details.uuid") },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(item, "lot_details.code"),
        " "
      );
    } else if (item.exchange_eval_in_progress) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],
        { to: "/sales-orders/" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(item, "most_recent_sales_order.id") },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(item, "most_recent_sales_order.code"),
        " "
      );
    } else if (item.customer_rma_request_in_progress || item.customer_rma_for_received_exchange_in_progress) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],
        { to: "/rmas/" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(item, "most_recent_customer_rma.id") },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(item, "most_recent_customer_rma.code"),
        " "
      );
    } else if (item.managed_repair_in_progress) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],
        {
          to: "/managed-repair-orders/" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(item, "managed_repair_details.uuid")
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(item, "managed_repair_details.code"),
        " "
      );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["V" /* PoCode */], { inventory: item });
  };

  var renderRow = function renderRow(item) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ "text-muted": item.cart }),
        key: "repair-list-item-" + item.id
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_date__["b" /* shortDate */])(item.reserved_for_repair_on)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["h" /* PartNumber */], { part: item.part })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],
          { to: "/inventories/" + item.uuid },
          item.serial_number
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_date__["b" /* shortDate */])(item.date_received)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        reference(item)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["e" /* truncate */])(item.part.description, 25)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_LocationFlag_LocationFlag__["a" /* default */], {
          location: item.store_owner_id,
          consignment_type: item.consignment_type
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_LocationFlag_LocationFlag__["a" /* default */], { location: item.store_location_id })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["r" /* INVENTORIES */].condition[item.condition].label
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        item.total_quantity
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Receiving_components_shared_StatusTags__["a" /* default */], statuses(item))
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        item.cart && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["d" /* getFirstNameLastInitial */])(item.cart.full_name)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-center td-shrink-icon" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConnectedButton, { reservedBy: item.cart, inventoryId: item.id })
      )
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */],
    { loading: isLoading },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Reserved at"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Received"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "REF #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Description"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Store Owner"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Store Loc"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Condition"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "QTY"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Status"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "In Cart"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-center" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(renderRow)
    )
  );
}

Table.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_9__shared_components__["e" /* SearchPropTypes */]);

var CartButton = function CartButton(_ref2) {
  var reservedBy = _ref2.reservedBy,
      handleClick = _ref2.handleClick,
      currentUser = _ref2.currentUser;

  var isAdmin = currentUser.get(__WEBPACK_IMPORTED_MODULE_13__users_constants__["h" /* ROLE */]) === __WEBPACK_IMPORTED_MODULE_13__users_constants__["i" /* ADMIN */];
  var inCart = !!reservedBy;

  var notDisabled = isAdmin || reservedBy && reservedBy.id === currentUser.get(__WEBPACK_IMPORTED_MODULE_14__constants__["b" /* ID */]);

  var removalText = notDisabled ? "Remove From Cart" : "In Cart";
  var text = inCart ? removalText : "Add to Cart";

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn btn-xs btn-hollow", __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
    "text-muted": inCart,
    "btn-primary": !inCart,
    "btn-default": inCart
  }));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    {
      type: "button",
      onClick: handleClick,
      disabled: !!inCart && !notDisabled,
      className: classes
    },
    text
  );
};

CartButton.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map),
  reservedBy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  handleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var ConnectedButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_13__users_constants__["a" /* USER */])
  };
}, function (dispatch, ownProps) {
  return {
    handleClick: function handleClick() {
      return ownProps.reservedBy ? dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__Nav_RepairOrdersCart_actions__["b" /* destroy */])(ownProps.inventoryId)) : dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions__["u" /* addItemToCartAndRefreshList */])(ownProps.inventoryId));
    }
  };
})(CartButton);

/***/ }),
/* 1758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReservedForRepairList__ = __webpack_require__(1755);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ReservedForRepairList__["a"]; });



/***/ }),
/* 1759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_components_DateRangePicker_DateRangePicker__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Table__ = __webpack_require__(1760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pagination__ = __webpack_require__(272);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
























var defaultFilters = {
  approval_status: undefined,
  awaiting_to_ship: undefined,
  eval_received: undefined,
  expected_date_past_due: undefined,
  evaluation_fees_exist: undefined,
  exchange_gone_outright: undefined,
  final_approval: undefined,
  no_returning_awb: undefined,
  open: undefined,
  my_ros: undefined,
  not_approved: undefined,
  po_not_paid: undefined,
  received: undefined,
  repair_and_hold: undefined,
  invoiced: undefined,
  invoice_unpaid: undefined,
  managed_repairs: undefined,
  open_cores: undefined,
  payables_pending: undefined,
  store_owner: undefined,
  shipped: undefined,
  action_requested: undefined,
  no_listed_inventory: undefined,
  no_work_performed: undefined,
  repair_awaiting_evaluation: undefined,
  repair_evaluation_approved: undefined,
  repair_evaluation_received: undefined,
  repair_evaluation_rejected: undefined,
  store_owner_id: undefined,
  ro_greater_than_zero: undefined,
  teardown: undefined,
  shop_assist: undefined,
  invoice_due_date_within_30_days: undefined,
  not_purchased_as_is: undefined,
  working_to_save_unit: undefined
};

var filters = [{
  label: "Open ROs",
  filters: {
    payables_pending: undefined,
    open: true
  }
}, {
  label: "Open SOs",
  filters: {
    open_sales_orders: true,
    received: false
  }
}, {
  label: "Awaiting RS Approval",
  filters: {
    not_approved: true,
    payables_pending: undefined
  }
}, {
  label: "No Listed Inventory",
  filters: {
    no_listed_inventory: true,
    payables_pending: undefined,
    received: false
  }
}, {
  label: "Vendor Payables Pending",
  filters: {
    invoice_due_date_within_30_days: true,
    not_purchased_as_is: true,
    payables_pending: true,
    po_not_paid: true,
    open: true,
    received: false,
    repair_evaluation_received: true,
    repair_awaiting_evaluation: true,
    shipped: true
  },
  hr: true
}, {
  label: "My ROs",
  filters: {
    payables_pending: undefined,
    my_ros: true
  }
}, {
  label: "Awaiting To Ship To Shop",
  filters: {
    awaiting_to_ship: true,
    shipped: false,
    received: false
  }
}, {
  label: "Awaiting Evaluation",
  filters: {
    repair_awaiting_evaluation: true,
    payables_pending: undefined,
    received: false,
    shipped: true
  }
}, {
  label: "Original Eval Entered",
  filters: {
    eval_received: true,
    payables_pending: undefined
  }
}, {
  label: "Evaluation Received",
  filters: {
    repair_evaluation_received: true,
    payables_pending: undefined,
    shipped: true,
    received: false
  }
}, {
  label: "Evaluation Approved",
  filters: {
    repair_evaluation_approved: true,
    payables_pending: undefined,
    shipped: true,
    received: false
  }
}, {
  label: "Evaluation Rejected",
  filters: {
    repair_evaluation_rejected: true,
    payables_pending: undefined,
    received: false,
    shipped: true
  }
}, {
  label: "No Work Performed",
  filters: {
    no_work_performed: true,
    shipped: true
  }
}, {
  label: "Evaluation Fees",
  filters: {
    evaluation_fees_exist: true
  }
}, {
  label: "Missing Original Eval",
  filters: {
    eval_received: false,
    payables_pending: undefined
  },
  hr: true
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_14__constants__["_26" /* RECEIVED */]),
  filters: {
    received: true
  }
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_14__constants__["_63" /* NOT_RECEIVED */]),
  filters: {
    received: false
  }
}, {
  label: "Received and Not Invoiced",
  filters: {
    payables_pending: undefined,
    received: true,
    invoiced: false
  }
}, {
  label: "Received and Invoiced",
  filters: {
    payables_pending: undefined,
    received: true,
    invoiced: true
  }
}, {
  label: "Invoice Not Paid / Remaining Balance",
  filters: {
    invoice_unpaid: true
  }
}, {
  label: "Synced with Accounting",
  filters: {
    accounting_synced: true
  }
}, {
  label: "Not Synced with Accounting",
  filters: {
    accounting_synced: false
  }
}, {
  label: "Returning From Shop",
  filters: {
    payables_pending: undefined,
    returning_from_shop: true,
    shipped: true,
    received: false
  }
}, {
  label: "Missing Returning AWB",
  filters: {
    no_returning_awb: true,
    payables_pending: undefined,
    received: false,
    shipped: true
  }
}, {
  label: "Ex Date Past Due",
  filters: {
    expected_date_past_due: true
  },
  hr: true
}, {
  label: "Exchange Core Returns",
  filters: {
    cores: true,
    payables_pending: undefined
  }
}, {
  label: "Exchange Gone Outright",
  filters: {
    exchange_gone_outright: true
  }
}, {
  label: "Warranty Considerations",
  filters: {
    action_requested: "warranty_consideration",
    payables_pending: undefined
  }
}, {
  label: "Working to Save Unit",
  filters: {
    working_to_save_unit: true,
    payables_pending: undefined,
    received: false,
    shipped: true
  }
}, {
  label: "Repair & Hold",
  filters: {
    no_returning_awb: true,
    payables_pending: undefined,
    repair_and_hold: true,
    shipped: true,
    received: false
  }
}, {
  label: "Not on Repair & Hold",
  filters: {
    payables_pending: undefined,
    received: false,
    repair_and_hold: false,
    shipped: true
  }
}, {
  label: "Internal Outrights",
  filters: {
    internal_outright: true,
    payables_pending: undefined
  }
}, {
  label: "Second Opinions",
  filters: { payables_pending: undefined, for_second_opinion: true }
}, {
  label: "Managed Repairs",
  filters: {
    managed_repairs: true
  }
}, {
  label: "Awaiting Scrap Report",
  filters: {
    awaiting_scrap: true,
    payables_pending: undefined,
    received: false,
    shipped: true
  }
}, {
  label: "ROs Greater than $0",
  filters: {
    ro_greater_than_zero: true
  }
}, {
  label: "Teardowns",
  filters: {
    teardown: true
  }
}, {
  label: "Shop Assist",
  filters: {
    shop_assist: true
  }
}];

var filterTags = [{
  label: "Accounting Synced",
  key: "accounting_synced",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Synced w/ Accounting",
  key: "accounting_synced",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Show Open ROs",
  key: "open",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "No Listed Inventory",
  key: "no_listed_inventory"
}, {
  label: "Received & Invoiced",
  key: "received_and_invoiced"
}, {
  label: "Invoice Not Paid / Remaining Balance",
  key: "invoice_unpaid",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Internal Outrights",
  key: "internal_outright"
}, {
  label: "Received",
  key: "received",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Received",
  key: "received",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Not R&H",
  key: "repair_and_hold",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Invoiced",
  key: "invoiced",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Ex Date Past Due",
  key: "expected_date_past_due",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Invoiced",
  key: "invoiced",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "No Work Performed",
  key: "no_work_performed"
}, {
  label: "Core Returns",
  key: "open_cores"
}, {
  label: "Core Returns",
  key: "cores"
}, {
  label: "Open SOs",
  key: "open_sales_orders"
}, {
  label: "Orig. Eval Received",
  key: "eval_received",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Missing Orig. Eval",
  key: "eval_received",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Shipped",
  key: "shipped"
}, {
  label: "Awaiting To Ship",
  key: __WEBPACK_IMPORTED_MODULE_15__constants__["K" /* AWAITING_TO_SHIP */]
}, {
  label: "Awaiting Eval.",
  key: __WEBPACK_IMPORTED_MODULE_15__constants__["B" /* REPAIR_AWAITING_EVALUATION */]
}, {
  label: "Eval. Rejected",
  key: __WEBPACK_IMPORTED_MODULE_15__constants__["t" /* REPAIR_EVALUATION_REJECTED */]
}, {
  label: "Working to Save Unit",
  key: __WEBPACK_IMPORTED_MODULE_15__constants__["_26" /* WORKING_TO_SAVE_UNIT */]
}, {
  label: "Eval. Approved",
  key: __WEBPACK_IMPORTED_MODULE_15__constants__["a" /* REPAIR_EVALUATION_APPROVED */]
}, {
  label: "Eval. Received",
  key: __WEBPACK_IMPORTED_MODULE_15__constants__["Q" /* REPAIR_EVALUATION_RECEIVED */]
}, {
  label: "No Returning AWB",
  key: "no_returning_awb"
}, {
  label: "Repair & Hold",
  key: "repair_and_hold",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Evaluation Fees",
  key: "evaluation_fees_exist",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Awaiting Scrap",
  key: "awaiting_scrap"
}, {
  label: "Awaiting RS Approval",
  key: "not_approved",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Returning from Shop",
  key: "returning_from_shop"
}, {
  label: "Shipped To Shop",
  key: "approval_status_not",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_15__constants__["K" /* AWAITING_TO_SHIP */])
}, {
  label: "My ROs",
  key: "my_ros"
}, {
  label: "POs Not Paid",
  key: "po_not_paid"
}, {
  label: "Final Approval",
  key: "final_approval",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Warranty Consideration",
  key: "action_requested",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["b" /* matchesString */])("warranty_consideration")
}, {
  label: "Not Purchased As-Is",
  key: "not_purchased_as_is",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Eval. Not Rejected",
  key: "approval_status_not",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_15__constants__["t" /* REPAIR_EVALUATION_REJECTED */])
}, {
  label: "Invoice Due Date w/i 30 days",
  key: "invoice_due_date_within_30_days",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Second Opinions",
  key: "for_second_opinion",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Managed Repairs",
  key: "managed_repairs"
}, {
  label: "ROs Greater than $0",
  key: "ro_greater_than_zero",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Teardowns",
  key: "teardown",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Shop Assist",
  key: "shop_assist",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Exchange Gone Outright",
  key: "exchange_gone_outright",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["a" /* matchesBoolean */])(true)
}];

var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = searchProps.paginator.get("filters").toJS();
  var total = searchProps.paginator.get("totalCount");

  params.total_count = total;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_13__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        if (total > 200) {
          __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].info("Processing Report.");
          __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].repairOrders.export(params).then(function () {
            return __WEBPACK_IMPORTED_MODULE_9__lib_submission__["a" /* SUCCESS */];
          });
        } else {
          window.open(__WEBPACK_IMPORTED_MODULE_14__constants__["d" /* API_BASE */] + "/repair_orders/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_query_string__["stringify"])(params), "_blank");
          __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].success("Processing Repair Orders Report. Please wait for the PDF to generate.");
        }
      }
    },
    "Export"
  );
};

ExportButton.propTypes = {
  searchProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    paginator: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map)
  })
};

var meetsExportCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var searchProps = _ref2.searchProps;

  var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__hooks_useCurrentUser__["a" /* default */])();
  return searchProps.paginator.get("totalCount") <= 450 || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__users_helpers__["d" /* hasRole */])(user, __WEBPACK_IMPORTED_MODULE_12__users_constants__["i" /* ADMIN */]);
});

var DecoratedExportButton = meetsExportCriteria(ExportButton);

function RepairOrderSearch(_ref3) {
  var pushHistory = _ref3.pushHistory;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__hooks_useCurrentUser__["a" /* default */])();
  var filterWithLocations = currentUser.locations.map(function (l) {
    return {
      label: "Owned By " + l.name,
      filters: { store_owner_id: l.id }
    };
  });

  var filterTagsWithLocations = currentUser.locations.map(function (l) {
    return {
      label: "Owned by " + l.name,
      key: __WEBPACK_IMPORTED_MODULE_17__inventories_constants__["_64" /* STORE_OWNER_ID */],
      matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_filters__["b" /* matchesString */])(l.id)
    };
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_13__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_21__pagination__["e" /* repairOrdersPagination */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a RO #, eval due date, vendor name, vendor #, invoice #, work order#, serial#, part#, buyer, created by or part description...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/repair-orders/" + r.repair_order_uuid);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DecoratedExportButton, { searchProps: searchProps }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components_DateRangePicker_DateRangePicker__["a" /* default */], searchProps),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
              filters: filters.concat(filterWithLocations).concat({
                label: __WEBPACK_IMPORTED_MODULE_14__constants__["_37" /* CLEAR_FILTERS_TEXT */],
                filters: defaultFilters
              }),
              right: true
            }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "Repair Orders",
          filters: filterTagsWithLocations.concat(filterTags),
          aggregateField: "subtotal"
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

RepairOrderSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(RepairOrderSearch));

/***/ }),
/* 1760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Detail_LineItems_StatusBadges__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_components_LocationFlag_LocationFlag__ = __webpack_require__(143);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






















function renderRow(result, pushHistory) {
  var lineItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(result);
  var rowClasses = __WEBPACK_IMPORTED_MODULE_6_classnames___default()("clickable", {
    "cancelled-item": lineItem.get(__WEBPACK_IMPORTED_MODULE_13__constants__["_38" /* CANCELLED */])
  });

  var cap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__helpers__["a" /* getCap */])(lineItem);
  var totalLabor = parseFloat(lineItem.get(__WEBPACK_IMPORTED_MODULE_16__SalesOrders_constants__["p" /* LABOR_COST */]) || 0) + parseFloat(lineItem.get(__WEBPACK_IMPORTED_MODULE_16__SalesOrders_constants__["_7" /* OUTSIDE_LABOR_COST */]) || 0);

  var tooltipText = "";
  if (cap.includes("green-table-cap")) {
    tooltipText = "Approved, pending receipt.";
  } else if (cap.includes("warning-table-cap")) {
    tooltipText = "Sellable, pending receipt";
  } else if (cap.includes("danger-table-cap")) {
    tooltipText = "Do not sell, pending receipt.";
  }

  var tooltip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_17_react_bootstrap__["b" /* Tooltip */],
    null,
    tooltipText
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: lineItem.get(__WEBPACK_IMPORTED_MODULE_13__constants__["b" /* ID */]),
      className: rowClasses,
      onClick: function onClick() {
        return pushHistory("/repair-orders/" + lineItem.get("repair_order_uuid"));
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_17_react_bootstrap__["a" /* OverlayTrigger */],
      { placement: "top", overlay: tooltip },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: cap },
        lineItem.get("repair_order_code"),
        " ",
        lineItem.get(__WEBPACK_IMPORTED_MODULE_13__constants__["_38" /* CANCELLED */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "text-muted" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["k" /* Icon */], { name: "ban" })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__helpers__["b" /* ExchangeIcon */], { lineItem: lineItem.toJS() })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["b" /* shortDate */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_13__constants__["_7" /* CREATED_AT */]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["b" /* shortDate */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_10__constants__["Y" /* DATE_RECEIVED */]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["w" /* CompanyName */], {
        flattenedCompany: lineItem.toJS(),
        context: "repair",
        truncateAt: 25
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components_LocationFlag_LocationFlag__["a" /* default */], { location: lineItem.getIn([__WEBPACK_IMPORTED_MODULE_11__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["_64" /* STORE_OWNER_ID */]]) })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["h" /* PartNumber */], { part: lineItem.toJS().part })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],
      {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        to: "/inventories/" + lineItem.getIn([__WEBPACK_IMPORTED_MODULE_11__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_13__constants__["c" /* UUID */]])
      },
      lineItem.get("original_serial_number") || lineItem.get(__WEBPACK_IMPORTED_MODULE_11__inventories_constants__["o" /* SERIAL_NUMBER */])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.get(__WEBPACK_IMPORTED_MODULE_12__parts_constants__["B" /* PART */]).get(__WEBPACK_IMPORTED_MODULE_12__parts_constants__["u" /* DESCRIPTION */])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__constants__["p" /* getConditionAbbrev */])(lineItem.get("condition_sent"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__constants__["p" /* getConditionAbbrev */])(lineItem.get("inventory_condition"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Detail_LineItems_StatusBadges__["a" /* default */], { lineItem: lineItem.toJS() })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["b" /* shortDate */])(lineItem.get("expected_date"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.get("invoice_number")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["b" /* shortDate */])(lineItem.get("invoice_due_date"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["b" /* shortDate */])(lineItem.get("eval_due_date"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.get("original_evaluation"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_16__SalesOrders_constants__["o" /* PART_COST */]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(totalLabor)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__helpers__["f" /* totalCostEvalColumn */])(lineItem.toJS())
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], { note: lineItem.get("last_ro_note") })
  );
}

function Table(_ref) {
  var pushHistory = _ref.pushHistory,
      isLoading = _ref.isLoading,
      pageActions = _ref.pageActions,
      results = _ref.results;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */],
    { loading: isLoading, refresh: pageActions.expire },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "RO #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Exch"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Created"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Received"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Repair Station"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Store Owner"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Description"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "CD Sent"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Inv CD"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Eval Status"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Expected Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Inv #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Inv Due Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Eval Due Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Original Eval"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Parts"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Labor"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Total/Eval"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Note"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_9__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(undefined, {
  pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"]
})(Table));

/***/ }),
/* 1761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony export (immutable) */ __webpack_exports__["a"] = withRepairOrder;


function withRepairOrder(Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
    return {
      repairOrder: state.repairOrderDetail.get("repairOrder")
    };
  })(Component);
}

/***/ }),
/* 1762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_reducer__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(694);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  repairOrder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
}).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["a" /* notesInitialState */]).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["b" /* attachmentsInitialState */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _extends(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* SET */], function (state, action) {
  return state.merge({ repairOrder: action.repairOrder });
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["c" /* createAttachmentReducer */])(__WEBPACK_IMPORTED_MODULE_2__shared_types_resourceTypes__["a" /* default */].repairOrder), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["d" /* createNoteReducer */])(__WEBPACK_IMPORTED_MODULE_2__shared_types_resourceTypes__["a" /* default */].repairOrder))));

/***/ }),
/* 1763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Stats__ = __webpack_require__(448);






function HeaderStats(_ref) {
  var salesData = _ref.salesData;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 2, mdOffset: 1 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Stats__["a" /* SalesCount */], { dateLabel: "Today", data: salesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Stats__["b" /* SaleLinesCount */], { dateLabel: "Today", data: salesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Stats__["c" /* GrossSalesSum */], { data: salesData, dateLabel: "Today" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Stats__["d" /* SalesProfit */], { dateLabel: "Today", data: salesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Stats__["g" /* SalesPercentProfit */], { dateLabel: "Today", data: salesData })
    )
  );
}

HeaderStats.propTypes = {
  salesData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}))
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["u" /* withPolling */])(HeaderStats));

/***/ }),
/* 1764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Stats__ = __webpack_require__(448);








function MonthlyStats(_ref) {
  var selectedDate = _ref.selectedDate,
      salesData = _ref.salesData,
      customRange = _ref.customRange;

  var date = customRange === __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* CUSTOM_RANGE */] ? __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* CUSTOM_RANGE */] : __WEBPACK_IMPORTED_MODULE_3_moment___default()(selectedDate).format("MMM YYYY");
  var endOfQuarter = __WEBPACK_IMPORTED_MODULE_3_moment___default()(selectedDate).endOf("quarter").toDate();
  var completedQuarter = endOfQuarter < new Date();
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 1, mdOffset: 1 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Stats__["a" /* SalesCount */], { dateLabel: date, data: salesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 1 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Stats__["b" /* SaleLinesCount */], { dateLabel: date, data: salesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 1 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Stats__["c" /* GrossSalesSum */], { dateLabel: date, data: salesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Stats__["d" /* SalesProfit */], { dateLabel: date, data: salesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 2 },
      !completedQuarter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Stats__["e" /* SalesSumProjection */], { dateLabel: date, data: salesData }),
      completedQuarter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Stats__["f" /* SalesSumProjectionNA */], { dateLabel: date })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Stats__["i" /* ProfitSumProjection */], { dateLabel: date, data: salesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 1 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Stats__["g" /* SalesPercentProfit */], { dateLabel: date, data: salesData })
    )
  );
}

MonthlyStats.propTypes = {
  selectedDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customRange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  salesData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}))
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["u" /* withPolling */])(MonthlyStats));

/***/ }),
/* 1765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Stats__ = __webpack_require__(448);







function QuarterlyStats(_ref) {
  var selectedDate = _ref.selectedDate,
      salesData = _ref.salesData;

  var date = "QTD";
  var endOfQuarter = __WEBPACK_IMPORTED_MODULE_3_moment___default()(selectedDate).endOf("quarter").toDate();
  var completedQuarter = endOfQuarter < new Date();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 1, mdOffset: 1 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Stats__["a" /* SalesCount */], { dateLabel: date, data: salesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 1 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Stats__["b" /* SaleLinesCount */], { dateLabel: date, data: salesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 1 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Stats__["c" /* GrossSalesSum */], { dateLabel: date, data: salesData, period: "quarterly" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Stats__["d" /* SalesProfit */], { dateLabel: date, data: salesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 2 },
      !completedQuarter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Stats__["e" /* SalesSumProjection */], { dateLabel: date, data: salesData }),
      completedQuarter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Stats__["f" /* SalesSumProjectionNA */], { dateLabel: date })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 2 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Stats__["g" /* SalesPercentProfit */], { dateLabel: date, data: salesData })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 1 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Stats__["h" /* SalesPercentGoal */], { dateLabel: date, data: salesData })
    )
  );
}

QuarterlyStats.propTypes = {
  selectedDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  salesData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}))
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["u" /* withPolling */])(QuarterlyStats));

/***/ }),
/* 1766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_SimpleDateRangePicker_SimpleDateRangePicker__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MonthlyStats__ = __webpack_require__(1764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__HeaderStats__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__QuarterlyStats__ = __webpack_require__(1765);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Table; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















function renderRow(r) {
  var percentProfit = r.total_sales !== 0 ? r.total_profit / r.total_sales * 100 : 0;
  var percentProfitQuarter = r.total_sales_quarter !== 0 ? r.total_profit_quarter / r.total_sales_quarter * 100 : 0;

  var percentProfitYtd = r.total_sales_ytd !== 0 ? r.total_profit_ytd / r.total_sales_ytd * 100 : 0;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { key: r.seller },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.seller
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(r.total_sales)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(r.total_profit)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      percentProfit ? percentProfit.toFixed(1) : "N/A"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(r.total_sales_quarter)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(r.total_profit_quarter)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      percentProfitQuarter ? percentProfitQuarter.toFixed(1) : "N/A"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(r.total_sales_ytd)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(r.total_profit_ytd)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      percentProfitYtd ? percentProfitYtd.toFixed(1) : "N/A"
    )
  );
}

var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    _classCallCheck(this, Table);

    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this));

    _this.reportTime = function (selectedDate) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(selectedDate).format();
    };

    _this.handleDateChange = function (startDate, endDate, label) {
      _this.setState({
        sellers: {},
        monthlyDataLoading: true,
        startDate: startDate,
        endDate: endDate,
        label: label
      }, function () {
        if (startDate) {
          _this.fetchMonthResults();
          _this.fetchQuarterResults();
          _this.fetchYtdResults();
        } else {
          _this.setState({
            monthResults: [],
            monthlyDataLoading: false
          });
        }
      });
    };

    _this.fetchMonthResults = _this.fetchMonthResults.bind(_this);
    _this.fetchYtdResults = _this.fetchYtdResults.bind(_this);
    _this.fetchTodaysResults = _this.fetchTodaysResults.bind(_this);
    _this.fetchQuarterResults = _this.fetchQuarterResults.bind(_this);
    _this.state = {
      monthResults: [],
      todaysResults: [],
      quarterResults: [],
      ytdResults: [],
      sellers: {},
      monthlyDataLoading: true,
      startDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()().startOf(__WEBPACK_IMPORTED_MODULE_9__constants__["_33" /* MONTH */]).format(),
      endDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()().endOf(__WEBPACK_IMPORTED_MODULE_9__constants__["_33" /* MONTH */]).format()
    };
    return _this;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchTodaysResults();
      this.fetchMonthResults();
      this.fetchQuarterResults();
      this.fetchYtdResults();
    }
  }, {
    key: "fetchTodaysResults",
    value: function fetchTodaysResults() {
      var _this2 = this;

      var startTime = __WEBPACK_IMPORTED_MODULE_5_moment___default()().startOf("day").format();
      var endTime = __WEBPACK_IMPORTED_MODULE_5_moment___default()().endOf("day").format();

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reports.sales.search(startTime, endTime).then(function (res) {
        _this2.setState({
          todaysResults: res.data,
          monthlyDataLoading: false
        });
      });
    }
  }, {
    key: "fetchQuarterResults",
    value: function fetchQuarterResults() {
      var _this3 = this;

      var dateString = this.state.startDate;
      if (!dateString) {
        var d = new Date();
        var month = (d.getMonth() + 1).toString().padStart(2, "0");
        var year = d.getFullYear().toString();
        dateString = year + "-" + month;
      }

      var currentMoment = __WEBPACK_IMPORTED_MODULE_5_moment___default()(dateString, "YYYY-MM");
      var startTime = currentMoment.startOf("quarter").format();
      var endTime = currentMoment.endOf("quarter").format();
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reports.sales.search(startTime, endTime).then(function (res) {
        var sellers = res.data.sellers.filter(function (v) {
          return Math.abs(v.total_sales) + Math.abs(v.total_profit) !== 0;
        });
        var adjustedSellers = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(sellers, function (seller) {
          return {
            id: seller.id,
            seller: seller.seller,
            total_profit_quarter: seller.total_profit,
            total_sales_quarter: seller.total_sales
          };
        });

        _this3.setState(function (state) {
          return {
            sellers: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.values(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.merge({}, __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.keyBy(state.sellers, "id"), __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.keyBy(adjustedSellers, "id"))),
            quarterResults: res.data,
            monthlyDataLoading: false
          };
        });
      });
    }
  }, {
    key: "fetchYtdResults",
    value: function fetchYtdResults() {
      var _this4 = this;

      var dateString = this.state.startDate;
      if (!dateString) {
        var d = new Date();
        var month = (d.getMonth() + 1).toString().padStart(2, "0");
        var year = d.getFullYear().toString();
        dateString = year + "-" + month;
      }

      var currentMoment = __WEBPACK_IMPORTED_MODULE_5_moment___default()(dateString, "YYYY-MM");
      var startTime = currentMoment.startOf("year").format();
      var endTime = currentMoment.endOf("year").format();
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reports.sales.search(startTime, endTime).then(function (res) {
        var sellers = res.data.sellers.filter(function (v) {
          return Math.abs(v.total_sales) + Math.abs(v.total_profit) !== 0;
        });
        var adjustedSellers = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(sellers, function (seller) {
          return {
            id: seller.id,
            seller: seller.seller,
            total_profit_ytd: seller.total_profit,
            total_sales_ytd: seller.total_sales
          };
        });

        _this4.setState(function (state) {
          return {
            sellers: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.values(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.merge({}, __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.keyBy(state.sellers, "id"), __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.keyBy(adjustedSellers, "id"))),
            ytdResults: res.data,
            monthlyDataLoading: false
          };
        });
      });
    }
  }, {
    key: "fetchMonthResults",
    value: function fetchMonthResults() {
      var _this5 = this;

      var _state = this.state,
          endDate = _state.endDate,
          startDate = _state.startDate;


      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reports.sales.search(startDate, endDate).then(function (res) {
        var sellers = res.data.sellers.filter(function (v) {
          return Math.abs(v.total_sales) + Math.abs(v.total_profit) !== 0;
        });

        _this5.setState(function (state) {
          return {
            sellers: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.values(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.merge({}, __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.keyBy(state.sellers, "id"), __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.keyBy(sellers, "id"))),
            monthResults: res.data,
            monthlyDataLoading: false
          };
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _state2 = this.state,
          todaysResults = _state2.todaysResults,
          monthResults = _state2.monthResults,
          quarterResults = _state2.quarterResults,
          label = _state2.label,
          monthlyDataLoading = _state2.monthlyDataLoading,
          sellers = _state2.sellers,
          selectedDate = _state2.selectedDate,
          startDate = _state2.startDate,
          endDate = _state2.endDate;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        todaysResults.sellers && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__HeaderStats__["a" /* default */], {
          salesData: todaysResults,
          refresh: this.fetchTodaysResults
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Row */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: "page-header monthly-sales-header",
                style: { padding: "10px, 30px" }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h1",
                { style: { marginTop: "7px" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { className: "header-content" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    { style: { marginRight: "10px", verticalAlign: "super" } },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_helpers__["n" /* setDateLabel */])(startDate, endDate, label)
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: { display: "inline-block" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_SimpleDateRangePicker_SimpleDateRangePicker__["a" /* default */], {
                      handleDateChange: this.handleDateChange
                    })
                  )
                )
              ),
              monthResults.sellers && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "a",
                {
                  href: __WEBPACK_IMPORTED_MODULE_9__constants__["d" /* API_BASE */] + "/monthly_sales/download.xls?start_time=" + this.reportTime(startDate) + "&end_time=" + this.reportTime(endDate),
                  target: "_blank",
                  rel: "noopener noreferrer",
                  style: { marginTop: "7px" }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "button",
                  {
                    className: "btn btn-primary btn-hollow pull-right",
                    type: "button"
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-cloud-download" }),
                  "\xA0\xA0Download Report"
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Row */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */],
              { loading: monthlyDataLoading, loadingRows: 40 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Head,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Name"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "Total Sales"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "Total Profit"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "Profit %"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "Total Sales QTD"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "Total Profit QTD"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "Profit % QTD"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "Total Sales YTD"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "Total Profit YTD"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  { className: "text-right" },
                  "Profit % YTD"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.size(sellers) > 0 ? __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.orderBy(sellers, function (_ref) {
                  var total_sales = _ref.total_sales;
                  return total_sales || 0;
                }, // eslint-disable-line camelcase
                "desc"), function (r) {
                  return renderRow(r);
                }) : []
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.size(monthResults) > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__MonthlyStats__["a" /* default */], {
          selectedDate: startDate,
          salesData: monthResults,
          customRange: label,
          refresh: this.fetchMonthResults
        }),
        __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.size(quarterResults) > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__QuarterlyStats__["a" /* default */], {
          selectedDate: selectedDate,
          salesData: quarterResults,
          refresh: this.fetchQuarterResults
        })
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SalesOrders_constants__ = __webpack_require__(32);
/* harmony export (immutable) */ __webpack_exports__["a"] = CurrentSalesTable;








var renderRow = function renderRow(r, pageActions) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { key: r.seller },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      {
        className: "btn btn-link text-left",
        style: { textTransform: "none", minWidth: 0 },
        onClick: function onClick() {
          return pageActions.setFilter(__WEBPACK_IMPORTED_MODULE_6__SalesOrders_constants__["C" /* SELLER_ID */], r.seller_id);
        }
      },
      r.seller
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(r.total_sales)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(r.total_sales_credit)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["e" /* displayInt */])(r.outgoing_quotes_count)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["e" /* displayInt */])(r.so_line_items_count)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["f" /* displayFloat */])(r.oq_to_so_conversion),
      " %"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["e" /* displayInt */])(r.so_lines_shared)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_number__["e" /* displayInt */])(r.total_sales_quantity_cancelled)
    )
  );
};

function CurrentSalesTable(_ref) {
  var results = _ref.results,
      isLoading = _ref.isLoading,
      pageActions = _ref.pageActions;

  var report = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(results[0], "current");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */],
    { loading: isLoading, loadingRows: 30 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Total as Seller ($)"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Seller Credit ($)"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "#OQs Entered"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "#SO Line Items "
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "OQ-SO Conversion (%)"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "#Shared SO's"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "# Cancelled SOs"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["s" /* DataTable */].Body,
      null,
      report ? report.map(function (r) {
        return renderRow(r, pageActions);
      }) : []
    )
  );
}

CurrentSalesTable.propTypes = {
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  pageActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired
};

/***/ }),
/* 1768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SellerReportTable__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CurrentSalesTable__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pagination__ = __webpack_require__(711);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var filters = [{
  label: "Show Today",
  filters: { period: "day" }
}, {
  label: "Show This Week",
  filters: { period: "week" }
}, {
  label: "Show This Month",
  filters: { period: "month" }
}, {
  label: "Show This Quarter",
  filters: { period: "quarter" }
}, {
  label: "Show This Year",
  filters: { period: "year" }
}, {
  label: "Show Last Year",
  filters: { period: "last_year" }
}];

var filterTags = [{
  label: "Today",
  key: "period",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("day")
}, {
  label: "Today",
  key: "period",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(undefined)
}, {
  label: "This Week",
  key: "period",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("week")
}, {
  label: "This Month",
  key: "period",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("month")
}, {
  label: "This Quarter",
  key: "period",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("quarter")
}, {
  label: "This Year",
  key: "period",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("year")
}, {
  label: "Last Year",
  key: "period",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("last_year")
}];

var SalesReport = function (_Component) {
  _inherits(SalesReport, _Component);

  function SalesReport(props) {
    _classCallCheck(this, SalesReport);

    var _this = _possibleConstructorReturn(this, (SalesReport.__proto__ || Object.getPrototypeOf(SalesReport)).call(this, props));

    _this.state = {
      sellersFilter: [],
      sellersTags: []
    };

    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].users.search({
      yearly_sellers: true,
      page: 1,
      sort: "first_name",
      reverse: false,
      limit: 1000
    }).then(function (resp) {
      var sellers = resp.data.results;
      var sellersOptions = sellers.map(function (b) {
        return {
          label: b.full_name,
          filters: { seller_id: b.id, report_type: "single" }
        };
      });
      var sellersTags = sellers.map(function (b) {
        return {
          label: b.full_name,
          key: "seller_id",
          matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["a" /* matchesBoolean */])(b.id)
        };
      }).concat([{
        label: "Everyone Combined",
        key: "seller_id",
        matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("all")
      }]);

      _this.setState({
        sellersFilter: [{
          label: "View All",
          filters: { buyer_id: undefined, report_type: "single" }
        }].concat(sellersOptions).concat([{
          label: "Everyone Combined",
          filters: { buyer_id: "all", report_type: "all" }
        }]),
        sellersTags: sellersTags
      });
    });
    return _this;
  }

  _createClass(SalesReport, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components__["c" /* Search */],
        { search: __WEBPACK_IMPORTED_MODULE_8__pagination__["a" /* default */], syncWithUrl: true },
        function (searchProps) {
          var sellerId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_query_string__["parse"])(location.search).seller_id;
          var title = "Sales Credit by Seller";
          if (sellerId) {
            title = "Sales Report Card";
          }
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group form-group-searchbar" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: "input-group buyer-stats-filters",
                  style: { width: "240px" }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
                  title: "Period",
                  filters: filters
                })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
                  title: "Seller",
                  filters: _this2.state.sellersFilter
                }))
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
              title: title,
              filters: filterTags.concat(_this2.state.sellersTags)
            })),
            sellerId !== undefined ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SellerReportTable__["a" /* default */], searchProps) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CurrentSalesTable__["a" /* default */], searchProps)
          );
        }
      );
    }
  }]);

  return SalesReport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SalesReport);

/***/ }),
/* 1769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony export (immutable) */ __webpack_exports__["a"] = SellerReportTable;








var renderDollarValues = function renderDollarValues(report, period, stat) {
  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "current[0]" + stat))
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "past[0]" + stat))
  ), period === "last_year" ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "average[0]" + stat))
  )];
};
var renderPercentValues = function renderPercentValues(report, period, stat) {
  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__["f" /* displayFloat */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "current[0]" + stat)),
    " %"
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__["f" /* displayFloat */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "past[0]" + stat)),
    " %"
  ), period === "last_year" ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__["f" /* displayFloat */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "average[0]" + stat)),
    " %"
  )];
};

var renderValues = function renderValues(report, period, stat) {
  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__["e" /* displayInt */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "current[0]" + stat))
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__["e" /* displayInt */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "past[0]" + stat))
  ), period === "last_year" ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_number__["f" /* displayFloat */])(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(report, "average[0]" + stat))
  )];
};

var renderHeader = function renderHeader(period) {
  switch (period) {
    case "week":
      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Current Week"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Last Week"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Last Four Weeks (Avg/Week)"
      )];
    case "month":
      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Current Month"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Last Month"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Current Month (Projected)"
      )];
    case "quarter":
      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Current Quarter"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Last Quarter"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Current Quarter (Projected)"
      )];
    case "year":
      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Current Year"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Last Year"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Current Year (Projected)"
      )];
    case "last_year":
      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "For Last Year"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Two Years Ago"
      )];
    default:
      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Today"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Yesterday (last working day)"
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Current Month (Avg/Working Day)"
      )];
  }
};

function SellerReportTable(_ref) {
  var results = _ref.results,
      isLoading = _ref.isLoading;

  var _parse = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_query_string__["parse"])(location.search),
      period = _parse.period;

  var report = results[0];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */],
    { loading: isLoading, loadingRows: 11, style: { width: 0 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      renderHeader(period)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Total Sold ($)"
        ),
        renderDollarValues(report, period, "total_sales_all")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Total Cancelled ($)"
        ),
        renderDollarValues(report, period, "total_sales_cancelled")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Total Non-Cancelled ($)"
        ),
        renderDollarValues(report, period, "total_sales")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "#Outgoing Quote Lines Entered"
        ),
        renderValues(report, period, "outgoing_quotes_count")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "#SO Lines"
        ),
        renderValues(report, period, "so_line_items_count")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "#SO's Placed"
        ),
        renderValues(report, period, "sos_placed")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "O-Quote to SO Conversion (By Lines) (%)"
        ),
        renderPercentValues(report, period, "oq_to_so_conversion")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "#SO Lines Shared"
        ),
        renderValues(report, period, "so_lines_shared")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "#SO Lines Shared (%)"
        ),
        renderPercentValues(report, period, "so_lines_shared_percent")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "# SO Line Cancellations"
        ),
        renderValues(report, period, "so_line_cancellations")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "SO Cancellation %"
        ),
        renderPercentValues(report, period, "so_cancellation_percent")
      )
    )
  );
}

SellerReportTable.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Nav_SaleOrdersCart_actions__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);









var CartButton = function CartButton(_ref) {
  var disabled = _ref.disabled,
      item = _ref.item,
      handleClick = _ref.handleClick,
      currentUser = _ref.currentUser;

  var isAdmin = currentUser.get(__WEBPACK_IMPORTED_MODULE_6__users_constants__["h" /* ROLE */]) === __WEBPACK_IMPORTED_MODULE_6__users_constants__["i" /* ADMIN */];
  var hasPermission = (currentUser.get(__WEBPACK_IMPORTED_MODULE_6__users_constants__["D" /* PERMISSIONS */]) || []).includes(__WEBPACK_IMPORTED_MODULE_6__users_constants__["_20" /* CAN_VIEW_UPDATE_ALL_RESERVED_FOR_SALE_LIST */]);
  var inCart = !!item.sales_order_cart_id;

  var notDisabled = currentUser.get(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* ID */]) === item.sales_order_cart_id || isAdmin || hasPermission;

  var removalText = notDisabled ? "Remove From Cart" : "In Cart";
  var text = inCart ? removalText : "Add to Cart";

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn btn-xs btn-hollow", __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
    "text-muted": inCart,
    "btn-primary": !inCart,
    "btn-default": inCart
  }));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    {
      type: "button",
      onClick: handleClick,
      disabled: inCart && !notDisabled || disabled,
      className: classes
    },
    text
  );
};

CartButton.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    sales_order_cart_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }).isRequired,
  handleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_6__users_constants__["a" /* USER */])
  };
}, function (dispatch, ownProps) {
  return {
    handleClick: function handleClick() {
      return ownProps.item.sales_order_cart_id ? dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__Nav_SaleOrdersCart_actions__["b" /* destroy */])(ownProps.item.id)) : dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["q" /* addItemToCartAndRefreshList */])(ownProps.item.id));
    }
  };
})(CartButton));

/***/ }),
/* 1771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(1772);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







function Create(_ref) {
  var open = _ref.open,
      close = _ref.close;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCustomer = _useState2[0],
      setSelectedCustomer = _useState2[1];

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hooks__["a" /* useCurrentUser */])();

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState4 = _slicedToArray(_useState3, 2),
      shippingToAddress = _useState4[0],
      setShippingToAddress = _useState4[1];

  var onShippingAddressChange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (shippingType) {
    return function (address) {
      setShippingToAddress(function (addr) {
        return _extends({}, addr, _defineProperty({}, shippingType, address));
      });
    };
  }, []);

  var onClose = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    close();

    setSelectedCustomer({});
    setShippingToAddress({});
  }, [close]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: onClose, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: onClose }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Create a New Sales Order"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], {
        close: onClose,
        currentUser: currentUser,
        enableReinitialize: true,
        selectedCustomer: selectedCustomer,
        setSelectedCustomer: setSelectedCustomer,
        shippingToAddress: shippingToAddress,
        setShippingToAddress: onShippingAddressChange
      })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (Create);

Create.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_FormSections__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_ShippingSection__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__companies_shared_components_DoNotDoBusinessWarning__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_components_FinalDestination_FinalDestinationFields__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Orders_shared_ShippingFields_ShippingFields__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_shared_Warnings_DoNotDoBusinessShippingWarning__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__validate__ = __webpack_require__(1776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Warnings__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__LineItemFields__ = __webpack_require__(1773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__helpers__ = __webpack_require__(103);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





























var FORM_NAME = "convertDummyToSO";

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = { invalidCompany: false, shipToOptions: __WEBPACK_IMPORTED_MODULE_13__shared_components_ShippingSection_shippingTypes__["c" /* shipToOptions */] }, _this.handleCompanySelected = function (company) {
      _this.props.setSelectedCustomer(company);

      if (!company) return null;

      if (company && company.shipment_methods) {
        var shipmentMethod = company.shipment_methods[0];
        if (!shipmentMethod) return null;

        [__WEBPACK_IMPORTED_MODULE_17__constants__["e" /* CARRIER */], __WEBPACK_IMPORTED_MODULE_17__constants__["g" /* SHIPPING_METHOD */], __WEBPACK_IMPORTED_MODULE_17__constants__["h" /* ACCOUNT_NUMBER */]].forEach(function (f) {
          _this.props.setFieldValue([__WEBPACK_IMPORTED_MODULE_17__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */], f].join("."))(shipmentMethod[f]);
        });
      }

      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$formItems = _props.formItems,
          formItems = _props$formItems === undefined ? [] : _props$formItems,
          canExchange = _props.canExchange,
          getField = _props.getField,
          _props$hasExchange = _props.hasExchange,
          hasExchange = _props$hasExchange === undefined ? false : _props$hasExchange,
          _props$lineItems = _props.lineItems,
          lineItems = _props$lineItems === undefined ? [] : _props$lineItems,
          selectedSeller = _props.selectedSeller,
          setFieldValue = _props.setFieldValue,
          selectedCustomer = _props.selectedCustomer,
          setShippingToAddress = _props.setShippingToAddress;
      var _state = this.state,
          invalidCompany = _state.invalidCompany,
          shipToOptions = _state.shipToOptions;


      var copyBillingAddress = function copyBillingAddress() {
        return [__WEBPACK_IMPORTED_MODULE_17__constants__["r" /* COUNTRY */], __WEBPACK_IMPORTED_MODULE_17__constants__["Q" /* REGION */], __WEBPACK_IMPORTED_MODULE_17__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_17__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_17__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_17__constants__["t" /* LINE2 */], __WEBPACK_IMPORTED_MODULE_17__constants__["w" /* POSTAL_CODE */]].forEach(function (f) {
          setFieldValue([__WEBPACK_IMPORTED_MODULE_20__companies_constants__["l" /* PHYSICAL_ADDRESS */], f].join("."))(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(selectedCustomer, __WEBPACK_IMPORTED_MODULE_20__companies_constants__["w" /* BILLING_ADDRESS */] + "." + f, getField([__WEBPACK_IMPORTED_MODULE_20__companies_constants__["w" /* BILLING_ADDRESS */], f].join("."))));
        });
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["e" /* Form */],
        _extends({}, this.props, { disabled: invalidCompany }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__companies_shared_components_DoNotDoBusinessWarning__["a" /* default */], { company: selectedCustomer }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Warnings__["a" /* TraceTypeWarning */], {
            company: selectedCustomer,
            inventories: lineItems
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Warnings__["b" /* WarrantyMinimumWarning */], {
            company: selectedCustomer,
            lineItems: formItems
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Warnings__["c" /* BlanketExchangeAgreementWarning */], {
            company: selectedCustomer,
            exchangeSale: formItems.some(function (l) {
              return l.exchange_sale;
            })
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            null,
            "Sellers"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_shared_FormSections__["a" /* SellersSection */], { selectedSeller: selectedSeller, disabled: false }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            null,
            "Customer"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_shared_FormSections__["b" /* CustomerSection */], {
            formName: FORM_NAME,
            company: selectedCustomer,
            onCompanySelected: this.handleCompanySelected,
            setFieldValue: setFieldValue,
            getFieldValue: getField,
            setPrimaryContact: false
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            null,
            "Shipping"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { xs: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_17__constants__["_20" /* SHIP_TO_FOB */],
                component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */],
                label: "Ship To FOB"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { xs: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["a" /* CheckGroup */],
                { justified: true, title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_14__constants__["b" /* DISCREET */]) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_14__constants__["b" /* DISCREET */],
                  component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["b" /* Check */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_14__constants__["b" /* DISCREET */])
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Warnings__["d" /* DiscreetWarning */], {
            discreet: getField(__WEBPACK_IMPORTED_MODULE_14__constants__["b" /* DISCREET */]),
            shippingType: getField(__WEBPACK_IMPORTED_MODULE_17__constants__["q" /* SHIP_TO_TYPE */])
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_shared_Warnings_DoNotDoBusinessShippingWarning__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_ShippingSection__["a" /* ShippingSection */], {
            copyBillingAddress: copyBillingAddress,
            discreet: getField(__WEBPACK_IMPORTED_MODULE_14__constants__["b" /* DISCREET */]),
            getField: getField,
            key: selectedCustomer,
            setFieldValue: setFieldValue,
            shipToCustomer: selectedCustomer,
            shipToOptions: shipToOptions,
            setFOB: setFieldValue(__WEBPACK_IMPORTED_MODULE_17__constants__["_40" /* RETURN_TO_FOB */]),
            setShippingToAddress: setShippingToAddress,
            beforeShippingMethod: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__shared_components_FinalDestination_FinalDestinationFields__["a" /* default */], {
              change: this.props.change,
              formName: FORM_NAME,
              shippingToAddress: this.shippingAddress,
              showWarning: true
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Warnings__["d" /* DiscreetWarning */], {
              discreet: getField(__WEBPACK_IMPORTED_MODULE_14__constants__["b" /* DISCREET */]),
              carrier: getField(__WEBPACK_IMPORTED_MODULE_17__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */] + "." + __WEBPACK_IMPORTED_MODULE_17__constants__["e" /* CARRIER */])
            })],
            convertSO: true,
            wtDimsReq: true
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_shared_FormSections__["c" /* AdditionalDetails */], { showDiscreet: false }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              null,
              "Parts"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: "row row-col-gutters-half",
                style: { marginTop: "26px" }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Warnings__["e" /* CreditLimitWarning */], {
                company: selectedCustomer,
                lineItems: formItems,
                customerCreditTerm: getField("credit_terms")
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["FieldArray"], {
                  name: __WEBPACK_IMPORTED_MODULE_17__constants__["A" /* LINE_ITEMS */],
                  component: __WEBPACK_IMPORTED_MODULE_24__LineItemFields__["a" /* default */],
                  canExchange: canExchange,
                  currentUser: this.props.currentUser,
                  lineItems: lineItems,
                  selectedCustomer: selectedCustomer,
                  selectedSeller: selectedSeller,
                  change: this.props.change,
                  getField: getField,
                  shipToAddress: this.shippingAddress
                })
              )
            )
          ),
          hasExchange && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            { key: "return-to-header" },
            "Return To"
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
            { key: "return-to-fob" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { xs: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_17__constants__["_40" /* RETURN_TO_FOB */],
                component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */],
                label: "Return To FOB",
                required: true
              })
            )
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Orders_shared_ShippingFields_ShippingFields__["a" /* default */], {
            key: "return-to-shipping-fields",
            formName: FORM_NAME,
            path: __WEBPACK_IMPORTED_MODULE_17__constants__["_39" /* RETURN_TO */],
            shippingFields: [__WEBPACK_IMPORTED_MODULE_17__constants__["C" /* RETURN_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_17__constants__["_42" /* RETURN_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_17__constants__["_43" /* RETURN_TO_COMPANY_ADDRESS_ID */]],
            renderCarrier: false,
            shippingTypes: [__WEBPACK_IMPORTED_MODULE_17__constants__["i" /* COMPANY */]],
            shippingAddressField: __WEBPACK_IMPORTED_MODULE_17__constants__["_44" /* RETURN_TO_SHIPPING_ADDRESS */],
            required: hasExchange,
            locationFieldName: __WEBPACK_IMPORTED_MODULE_17__constants__["_25" /* RETURN_TO_LOCATION_ID */]
          })]
        )
      );
    }
  }, {
    key: "shippingAddress",
    get: function get() {
      var _props2 = this.props,
          shippingToAddress = _props2.shippingToAddress,
          getField = _props2.getField;


      var shippingType = getField(__WEBPACK_IMPORTED_MODULE_17__constants__["q" /* SHIP_TO_TYPE */]);

      if (!shippingToAddress) {
        return null;
      }

      return shippingToAddress[shippingType];
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  formItems: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({})),
  hasExchange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  lineItems: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    has_active_repair: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    active_repair_ship_to_fob: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
  })),
  returnToType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  selectedSeller: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}),
  setFieldValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  selectedCustomer: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(Object),
  setSelectedCustomer: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  shippingToAddress: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(Object),
  setShippingToAddress: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["formValueSelector"])(FORM_NAME);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    canExchange: state.session.getIn([__WEBPACK_IMPORTED_MODULE_17__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_17__constants__["_35" /* CAN_EXCHANGE */]]),
    hasExchange: (selector(state, __WEBPACK_IMPORTED_MODULE_17__constants__["A" /* LINE_ITEMS */]) || []).some(function (i) {
      return i.exchange_sale;
    }),
    formItems: selector(state, __WEBPACK_IMPORTED_MODULE_17__constants__["A" /* LINE_ITEMS */]),
    returnToType: selector(state, __WEBPACK_IMPORTED_MODULE_17__constants__["C" /* RETURN_TO_TYPE */]),
    selectedSeller: state.session.get(__WEBPACK_IMPORTED_MODULE_18__users_constants__["a" /* USER */]).toJS(),
    initialValues: {
      seller_credit_percent: "25.0",
      seller_id: state.session.getIn([__WEBPACK_IMPORTED_MODULE_18__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_17__constants__["b" /* ID */]]),
      send_sales_order_acknowledgement: true,
      ship_to_type: null,
      line_items: [{ quantity: 1 }]
    },
    getField: function getField(field) {
      return selector(state, field);
    }
  };
}, function (dispatch) {
  return {
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(FORM_NAME, field, val));
      };
    },
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["r" /* convertDummySo */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__helpers__["i" /* transformSO */])(data)));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_22__validate__["a" /* default */],
  asyncValidate: __WEBPACK_IMPORTED_MODULE_6__actions__["s" /* validateContact */],
  asyncBlurFields: ["contact.email", "contact.name", "contact_id"]
})(Form)));

/***/ }),
/* 1773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ConvertFromCartForm_ExistingQuoteWarning__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_formatters_address__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PartField__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__PartFee__ = __webpack_require__(1774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Warnings__ = __webpack_require__(712);
/* harmony export (immutable) */ __webpack_exports__["a"] = LineItemFields;
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






















function LineItemFields(_ref) {
  var canExchange = _ref.canExchange,
      change = _ref.change,
      currentUser = _ref.currentUser,
      fields = _ref.fields,
      getField = _ref.getField,
      selectedCustomer = _ref.selectedCustomer,
      selectedSeller = _ref.selectedSeller,
      shipToAddress = _ref.shipToAddress;

  var changeExchange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (_ev, val) {
    if (val) {
      change(__WEBPACK_IMPORTED_MODULE_8__constants__["C" /* RETURN_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_13__shared_components_ShippingSection_shippingTypes__["a" /* TENANT_LOCATION */]);
      if (shipToAddress) change(__WEBPACK_IMPORTED_MODULE_8__constants__["_40" /* RETURN_TO_FOB */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_address__["a" /* fobFormat */])(shipToAddress));
    } else {
      change("line_items[0].flat_exchange", val);
    }
  });

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-striped table-numbered margin-bottom-none" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      fields.map(function (item, idx) {
        var hazmat = fields.get(idx).hazmat;
        var specialContainer = fields.get(idx).special_container_req;
        var exchange = fields.get(idx).exchange_sale;
        var quantity = Number(fields.get(idx).quantity);

        /* eslint-disable no-unused-vars */

        var _INVENTORIES$conditio = __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["r" /* INVENTORIES */].condition,
            scrap = _INVENTORIES$conditio.scrap,
            parts_unit = _INVENTORIES$conditio.parts_unit,
            filteredConditions = _objectWithoutProperties(_INVENTORIES$conditio, ["scrap", "parts_unit"]);
        /* eslint-enable no-unused-vars */

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          { key: "item-" + idx },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { style: { verticalAlign: "top", paddingTop: "12px" } },
            idx + 1
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "table",
              { className: "table" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tbody",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_ConvertFromCartForm_ExistingQuoteWarning__["a" /* default */], {
                  part: {},
                  company: selectedCustomer,
                  sellerId: getField(__WEBPACK_IMPORTED_MODULE_10__constants__["C" /* SELLER_ID */])
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                        { md: 12 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["c" /* Collapse */],
                          {
                            unmountOnExit: true,
                            "in": parseInt(quantity, 10) === 1
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "div",
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
                              null,
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                                { md: 3 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
                                  { title: "Exchange Sale", justified: true },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                                    name: item + ".exchange_sale",
                                    component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
                                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__constants__["w" /* EXCHANGE_SALE */]),
                                    disabled: !canExchange || getField(item + "." + __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["_71" /* CONSIGNMENT_TYPE */]) === __WEBPACK_IMPORTED_MODULE_9__Receiving_constants__["s" /* EMA */] || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(selectedCustomer, __WEBPACK_IMPORTED_MODULE_16__companies_constants__["k" /* DO_NOT_EXCHANGE */]),
                                    onChange: changeExchange
                                  })
                                )
                              ),
                              exchange && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                                  { md: 3 },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
                                    {
                                      title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__constants__["e" /* FLAT_EXCHANGE */]),
                                      justified: true
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                                      name: item + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["e" /* FLAT_EXCHANGE */],
                                      component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
                                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__constants__["e" /* FLAT_EXCHANGE */])
                                    })
                                  )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                                  { md: 3 },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                                    name: "repair_administration_charge_percentage",
                                    component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
                                    label: "Repair Administration Charge (%)"
                                  })
                                )
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                                { md: 7 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Warnings__["c" /* BlanketExchangeAgreementWarning */], {
                                  company: selectedCustomer,
                                  exchangeSale: exchange
                                })
                              )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["c" /* Collapse */],
                              { "in": exchange, unmountOnExit: true },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                "div",
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
                                  null,
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                                    { md: 3 },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["f" /* CurrencyField */], {
                                      name: item + ".exchange_fee",
                                      label: getField(item + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["e" /* FLAT_EXCHANGE */]) ? "Flat Exchange Fee" : "Exchange Fee",
                                      required: true
                                    })
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                                    { md: 3 },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["f" /* CurrencyField */], {
                                      name: item + ".outright_value",
                                      label: "Outright Value",
                                      required: true
                                    })
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                                    { md: 2 },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                                      name: item + ".core_due_days",
                                      label: "Core Due Days",
                                      component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["h" /* NumberInput */],
                                      roundDigits: 0
                                    })
                                  ),
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                                    { md: 3 },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                                      name: item + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["F" /* REPAIR_FEE */],
                                      label: "Avg Repair (NTX)",
                                      component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
                                      required: getField(item + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["e" /* FLAT_EXCHANGE */])
                                    })
                                  )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
                                  null,
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                                    { md: 12 },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                                      name: item + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["G" /* EXCHANGE_SPECIAL_INSTRUCTIONS */],
                                      component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["l" /* TextArea */],
                                      maxLength: 150,
                                      label: "Special Instructions (To be incl. on Exch. Agreement)",
                                      rows: "5"
                                    })
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__PartField__["a" /* default */], { item: item }),
                      !exchange && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                        { md: 2 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["f" /* CurrencyField */], {
                          name: item + ".price_per_unit",
                          label: "Sales Ea.",
                          required: true
                        })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                        { md: 2 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                          label: "Qty",
                          name: item + "." + __WEBPACK_IMPORTED_MODULE_8__constants__["j" /* QUANTITY */],
                          component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */]
                        })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                        { md: 2 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_3__inventories_constants__["n" /* CONDITION */]),
                          name: item + ".condition",
                          component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
                          required: true,
                          options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_forms__["a" /* toOptions */])(filteredConditions)
                        })
                      )
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PartFee__["a" /* default */], {
                  currentSeller: selectedSeller,
                  currentUser: currentUser,
                  item: item,
                  hazmat: hazmat,
                  specialContainer: specialContainer,
                  change: change,
                  getField: getField,
                  left: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                    { md: 3 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                      label: "Days Lead Time",
                      name: item + ".lead_time",
                      component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */]
                    })
                  )
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "div",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h5",
                        { className: "h4" },
                        "QC Pre-Approval Required"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                          { md: 5 },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
                            {
                              title: "QC Pre-Approval Required",
                              justified: true
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                              name: item + ".customer_qc_preapproval_required",
                              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
                              label: "Required"
                            })
                          )
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "div",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h5",
                        { className: "h4" },
                        "Warranty"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                          { md: 3 },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
                            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__OutgoingQuotes_constants__["g" /* WARRANTY */]),
                            name: item + ".warranty",
                            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_forms__["f" /* arrayToOptions */])(__WEBPACK_IMPORTED_MODULE_3__inventories_constants__["_59" /* WARRANTY_OPTIONS */])
                          })
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        );
      })
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
      { mdOffset: 9, md: 3, style: { paddingTop: 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          onClick: function onClick() {
            return fields.push({ quantity: 1 });
          },
          className: "btn btn-primary btn-hollow",
          style: { marginTop: 5, marginBottom: 15, float: "right" }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
        " Add Part"
      )
    )
  )];
}

LineItemFields.propTypes = {
  canExchange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  change: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  disableCustomerCqcApproval: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  fields: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  getField: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  selectedCustomer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  selectedSeller: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  shipToAddress: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

/***/ }),
/* 1774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components_Forms_FormRow__ = __webpack_require__(26);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var PartFee = function (_React$Component) {
  _inherits(PartFee, _React$Component);

  function PartFee() {
    _classCallCheck(this, PartFee);

    return _possibleConstructorReturn(this, (PartFee.__proto__ || Object.getPrototypeOf(PartFee)).apply(this, arguments));
  }

  _createClass(PartFee, [{
    key: "handleHazmatFee",
    value: function handleHazmatFee(item) {
      if (!this.props.hazmat) {
        var hazmatFee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__hooks_useCurrentUser__["b" /* useSettings */])(), __WEBPACK_IMPORTED_MODULE_13__constants__["_34" /* DEFAULT_HAZMAT_FEE */], 75);
        this.props.change(item + ".hazmat_fee", hazmatFee);
      } else {
        this.props.change(item + ".hazmat_fee", null);
      }
    }
  }, {
    key: "handleContainerFee",
    value: function handleContainerFee(item) {
      if (this.props.specialContainer) {
        this.props.change(item + ".container_fee", null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          currentUser = _props.currentUser,
          item = _props.item,
          part = _props.part,
          hazmat = _props.hazmat,
          specialContainer = _props.specialContainer,
          getField = _props.getField,
          left = _props.left;

      var hazmatSelected = getField(item + "." + __WEBPACK_IMPORTED_MODULE_10__parts_constants__["h" /* HAZMAT */]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          specialContainer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__shared_components_Warning_Warning__["a" /* default */],
                { warningType: "warning" },
                "PN-",
                part.part_number,
                " is flagged as requiring a special container fee of ",
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(part.special_container_fee),
                " and has been auto-populated below."
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14__shared_components_Forms_FormRow__["a" /* default */],
            null,
            left,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
                { title: "Line Hazmat", justified: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: item + "." + __WEBPACK_IMPORTED_MODULE_10__parts_constants__["h" /* HAZMAT */],
                  disabled: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__users_helpers__["d" /* hasRole */])(currentUser || {}, __WEBPACK_IMPORTED_MODULE_7__users_constants__["m" /* ACCOUNTING */]),
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__parts_constants__["h" /* HAZMAT */]),
                  icon: "fa-warning",
                  onChange: function onChange() {
                    return _this2.handleHazmatFee(item);
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
              { "in": hazmat, unmountOnExit: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["f" /* CurrencyField */], {
                    name: item + ".hazmat_fee",
                    label: "Hazmat Fee",
                    required: true
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "label",
                  { htmlFor: "special-container", className: "control-label" },
                  "Special Container"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    id: "special-container",
                    className: "btn-group btn-group-justified",
                    "data-toggle": "buttons"
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                    name: item + ".special_container_req",
                    label: "Special Container Req.",
                    icon: "fa-cube",
                    onChange: function onChange() {
                      return _this2.handleContainerFee(item);
                    }
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
                { "in": specialContainer, unmountOnExit: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["f" /* CurrencyField */], {
                    name: item + ".container_fee",
                    label: "Special Container Fee",
                    required: true
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
                { "in": !hazmatSelected && specialContainer, unmountOnExit: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    {
                      htmlFor: "customer-to-return-container",
                      className: "control-label"
                    },
                    "Customer to Return Container"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    {
                      id: "customer-to-return-container",
                      className: "btn-group btn-group-justified",
                      "data-toggle": "buttons"
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                      component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                      name: item + ".customer_to_return_container",
                      label: "Cust. to Rtrn Cont.",
                      icon: "fa-cube"
                    })
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */], { md: 6 }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
                { "in": hazmatSelected && specialContainer, unmountOnExit: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "label",
                      {
                        htmlFor: "customer-to-return-container",
                        className: "control-label"
                      },
                      "Customer to Return Container"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "div",
                      {
                        id: "customer-to-return-container",
                        className: "btn-group btn-group-justified",
                        "data-toggle": "buttons"
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                        component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                        name: item + ".customer_to_return_container",
                        label: "Cust. to Rtrn Cont.",
                        icon: "fa-cube"
                      })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PartFee;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PartFee.propTypes = {
  currentSeller: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}),
  item: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}),
  part: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}),
  hazmat: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  specialContainer: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  change: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  getField: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  left: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element
};
/* harmony default export */ __webpack_exports__["a"] = (PartFee);

/***/ }),
/* 1775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony export (immutable) */ __webpack_exports__["a"] = PartField;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








function PartField(_ref) {
  var item = _ref.item;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPart = _useState2[0],
      setSelectedPart = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState4 = _slicedToArray(_useState3, 2),
      alternates = _useState4[0],
      setAlternates = _useState4[1];

  var searchParts = function searchParts(filter) {
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].parts.search({
      filter: filter
    }).then(function (resp) {
      return resp.data.results;
    });
  };

  var fetchAlternateOptions = function fetchAlternateOptions(part) {
    setSelectedPart(part);
    if (part) {
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].parts.alternates.search(part.id).then(function (resp) {
        var vals = resp.data.results;
        var opts = vals.map(function (val) {
          return {
            text: val.name,
            value: val.id
          };
        });
        setAlternates(opts);
      });
    }
  };

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
    { md: 2 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
      name: item + "." + __WEBPACK_IMPORTED_MODULE_1__inventories_constants__["q" /* PART_ID */],
      label: "Part #",
      placeholder: "Type a part's name of ID number...",
      component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["n" /* AutoCompleteField */],
      search: searchParts,
      formatItem: function formatItem(result) {
        return result && result.part_number;
      },
      selectedItem: selectedPart,
      onItemSelected: function onItemSelected(i) {
        return i && fetchAlternateOptions(i);
      },
      required: true
    })
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
    { md: 2 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
      name: item + ".sell_as_alt_id",
      component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["c" /* Select */],
      label: "Sell As Alternate",
      options: alternates
    })
  )];
}

/***/ }),
/* 1776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_FormSections_CustomerSection_validate__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_FormSections_SellersSection_validate__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_FormSections_ShippingSection_validate__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inventories_constants__ = __webpack_require__(12);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;













function validateLineItem(item, values) {
  if (values.flat_exchange) {
    item.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["F" /* REPAIR_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["v" /* isLessThan */](values.exchange_fee));
  }
  if (values.exchange_sale) {
    item.validate(__WEBPACK_IMPORTED_MODULE_8__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */], __WEBPACK_IMPORTED_MODULE_5__constants__["E" /* OUTRIGHT_VALUE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  } else {
    item.validate(__WEBPACK_IMPORTED_MODULE_8__OutgoingQuotes_constants__["b" /* PRICE_PER_UNIT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["f" /* isGreaterThan */](0), __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  }

  item.validate(__WEBPACK_IMPORTED_MODULE_11__inventories_constants__["n" /* CONDITION */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  item.validate(__WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["p" /* requiredIfAnyDefined */](__WEBPACK_IMPORTED_MODULE_10__parts_constants__["h" /* HAZMAT */]), __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["q" /* isNumeric */]);
  item.validate(__WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__["y" /* CONTAINER_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["p" /* requiredIfAnyDefined */](__WEBPACK_IMPORTED_MODULE_10__parts_constants__["_5" /* SPECIAL_CONTAINER_REQ */]), __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["q" /* isNumeric */]);
}

function validate(values, props) {
  var hasExchange = values.line_items.some(function (i) {
    return i.exchange_sale;
  });

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    if (hasExchange) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__components_shared_FormSections_ShippingSection_validate__["a" /* validateShippingFields */])(__WEBPACK_IMPORTED_MODULE_6__constants__["_39" /* RETURN_TO */], values, form, false);
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_shared_FormSections_CustomerSection_validate__["b" /* validateCustomerFields */])(values, form);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_shared_FormSections_SellersSection_validate__["a" /* validateSellerFields */])(values, form);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__components_shared_FormSections_ShippingSection_validate__["a" /* validateShippingFields */])(__WEBPACK_IMPORTED_MODULE_6__constants__["B" /* SHIP_TO */], values, form);
    form.validateChildren(__WEBPACK_IMPORTED_MODULE_6__constants__["A" /* LINE_ITEMS */], validateLineItem);

    if (props.selectedCustomer) {
      form.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["N" /* COMPANY_ID */]).satisfies(function () {
        return __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["d" /* validateCompanyStatus */](props.selectedCustomer);
      });
    }
    form.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["t" /* SHIP_TO_COMPANY_DISABLED */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["t" /* shipToCompanyIsNoBiz */]);

    if (props.selectedCustomer && !props.selectedCustomer.billing_address) {
      form.validateChild(__WEBPACK_IMPORTED_MODULE_7__companies_constants__["w" /* BILLING_ADDRESS */], function (billingForm) {
        billingForm.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_6__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_6__constants__["w" /* POSTAL_CODE */], __WEBPACK_IMPORTED_MODULE_6__constants__["r" /* COUNTRY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      });
    }
  });
}

/***/ }),
/* 1777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Search__ = __webpack_require__(1778);
/* harmony export (immutable) */ __webpack_exports__["a"] = ReserveForSaleList;



function ReserveForSaleList() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Search__["a" /* default */], null);
}

/***/ }),
/* 1778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Table__ = __webpack_require__(1779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pagination__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConvertDummyForm_Create__ = __webpack_require__(1771);
/* harmony export (immutable) */ __webpack_exports__["a"] = SaleOrderSearch;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









function SaleOrderSearch() {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalOpen = _useState2[0],
      setModalOpen = _useState2[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components__["b" /* Authorized */],
    { roles: [__WEBPACK_IMPORTED_MODULE_3__users_constants__["k" /* SALES */]], allowManagers: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components__["c" /* Search */],
      { search: __WEBPACK_IMPORTED_MODULE_5__pagination__["a" /* reservedForSaleInventory */], syncWithUrl: true },
      function (searchProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "input-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
                placeholder: "Search by typing a part number or serial number..."
              })),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "input-group-btn" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "button",
                  {
                    onClick: function onClick() {
                      return setModalOpen(true);
                    },
                    className: "btn btn-primary pull-right",
                    type: "button"
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
                  "Create Reserve SO"
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, { title: "Reserved For Sale" })),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ConvertDummyForm_Create__["a" /* default */], { open: modalOpen, close: function close() {
              return setModalOpen(false);
            } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Table__["a" /* default */], searchProps),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components_Pagination__["d" /* Pagination */], searchProps)
        );
      }
    )
  );
}

/***/ }),
/* 1779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_InventoryListingOverrideCell_InventoryListingOverrideCell__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_LocationFlag_LocationFlag__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CartActionButton__ = __webpack_require__(1770);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.renderRow = function (item, isAdmin, currentUser) {
      var cantAddToCart = !isAdmin && item.reserve_for_seller_id !== currentUser.get(__WEBPACK_IMPORTED_MODULE_12__constants__["b" /* ID */]) && !currentUser.get(__WEBPACK_IMPORTED_MODULE_11__users_constants__["D" /* PERMISSIONS */]).includes(__WEBPACK_IMPORTED_MODULE_11__users_constants__["_20" /* CAN_VIEW_UPDATE_ALL_RESERVED_FOR_SALE_LIST */]);

      var inventoryLink = function inventoryLink(i) {
        if (i.placeholder) return i.serial_number;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],
          { to: "/inventories/" + (i.uuid || i.id) },
          i.serial_number
        );
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ "text-muted": item.cart }),
          key: "sale-list-item-" + item.id
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_date__["b" /* shortDate */])(item.reserved_for_sale_on)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["h" /* PartNumber */], { part: item.part })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          inventoryLink(item)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["V" /* PoCode */], { inventory: item })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["e" /* truncate */])(item.part.description, 25)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_LocationFlag_LocationFlag__["a" /* default */], {
            location: item.store_owner_id,
            consignment_type: item.consignment_type
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_LocationFlag_LocationFlag__["a" /* default */], { location: item.store_location_id }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_InventoryListingOverrideCell_InventoryListingOverrideCell__["b" /* RepairingIcon */], { inventory: item })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["r" /* INVENTORIES */].condition[item.condition].label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          item.total_quantity
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["d" /* getFirstNameLastInitial */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["get"])(item, "reserve_for_seller.full_name"))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["d" /* getFirstNameLastInitial */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["get"])(item, "reserved_by.full_name"))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center td-shrink-icon" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__CartActionButton__["a" /* default */], {
            item: item,
            disabled: cantAddToCart || item.placeholder
          })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          isAdmin = _props.isAdmin,
          currentUser = _props.currentUser,
          search = _props.search;


      if (!isAdmin) {
        search.setFilters({ reserve_for_seller_id: currentUser.get("id") });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          currentUser = _props2.currentUser,
          results = _props2.results,
          isAdmin = _props2.isAdmin,
          isLoading = _props2.isLoading;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */],
        { loading: results.length === 0 && isLoading },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Head,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Reserved at"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Part #"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Serial #"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "PO #"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Description"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Store Owner"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Store Loc"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Condition"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "QTY"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Reserved For"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Reserved By"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-center" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Body,
          null,
          results.map(function (item) {
            return _this2.renderRow(item, isAdmin, currentUser);
          })
        )
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Table.propTypes = _extends({
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),
  isAdmin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, __WEBPACK_IMPORTED_MODULE_7__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_11__users_constants__["a" /* USER */]),
    isAdmin: state.session.getIn([__WEBPACK_IMPORTED_MODULE_11__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_11__users_constants__["h" /* ROLE */]]) === __WEBPACK_IMPORTED_MODULE_11__users_constants__["i" /* ADMIN */]
  };
})(Table));

/***/ }),
/* 1780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Form__ = __webpack_require__(1781);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










function Create(_ref) {
  var cachedCart = _ref.cachedCart,
      open = _ref.open,
      close = _ref.close,
      lineItems = _ref.lineItems;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCustomer = _useState2[0],
      setSelectedCustomer = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState4 = _slicedToArray(_useState3, 2),
      preferredShippingMethods = _useState4[0],
      setPreferredShippingMethods = _useState4[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    setSelectedCustomer(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(cachedCart, __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* COMPANY */], null));
  }, [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(cachedCart, "company.id")]);

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState6 = _slicedToArray(_useState5, 2),
      shippingToAddress = _useState6[0],
      setShippingToAddress = _useState6[1];

  var onShippingAddressChange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (shippingType) {
    return function (address) {
      setShippingToAddress(function (addr) {
        return _extends({}, addr, _defineProperty({}, shippingType, address));
      });
    };
  }, []);

  var onClose = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    close();

    setSelectedCustomer({});
    setShippingToAddress({});
  }, [close]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: open, close: onClose, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: onClose }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Create a New Sales Order"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Form__["a" /* default */], {
        close: onClose,
        lineItems: lineItems,
        enableReinitialize: true,
        selectedCustomer: selectedCustomer,
        setSelectedCustomer: setSelectedCustomer,
        shippingToAddress: shippingToAddress,
        setShippingToAddress: onShippingAddressChange,
        preferredShippingMethods: preferredShippingMethods,
        setPreferredShippingMethods: setPreferredShippingMethods
      })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function (state) {
  return {
    cachedCart: state.session.get(__WEBPACK_IMPORTED_MODULE_4__users_constants__["_29" /* CACHED_SALES_CART */]) ? state.session.get(__WEBPACK_IMPORTED_MODULE_4__users_constants__["_29" /* CACHED_SALES_CART */]).toJS() : {}
  };
})(Create));

Create.propTypes = {
  cachedCart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  lineItems: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}))
};

/***/ }),
/* 1781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_FormSections__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_ShippingSection__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__companies_shared_components_DoNotDoBusinessWarning__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_components_FinalDestination_FinalDestinationFields__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Orders_shared_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Orders_shared_ShippingFields_ShippingFields__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__OutgoingQuotes_shared_PartDetails__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__shared_Warnings_DoNotDoBusinessShippingWarning__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__validate__ = __webpack_require__(1784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Warnings__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__shared_Warnings_ConditionWarning__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__LineItemFields__ = __webpack_require__(1782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__helpers__ = __webpack_require__(103);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





































var initialFOB = function initialFOB(lineItem) {
  if (lineItem.has_active_repair) return lineItem.active_repair_ship_to_fob;

  if (lineItem.status === __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["_34" /* ON_ORDER_FOR_SALE */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, [__WEBPACK_IMPORTED_MODULE_21__Orders_shared_constants__["a" /* PO_ITEM */], __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["x" /* PURCHASE_ORDER */], __WEBPACK_IMPORTED_MODULE_19__constants__["o" /* SHIPPING_TYPE */]].join(".")) !== __WEBPACK_IMPORTED_MODULE_15__shared_components_ShippingSection_shippingTypes__["a" /* TENANT_LOCATION */]) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, [__WEBPACK_IMPORTED_MODULE_21__Orders_shared_constants__["a" /* PO_ITEM */], __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["x" /* PURCHASE_ORDER */], __WEBPACK_IMPORTED_MODULE_19__constants__["H" /* FOB */]].join("."));
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, "store_location.fob");
};

var FORM_NAME = "convertToSO";

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = { invalidCompany: false, shipToOptions: __WEBPACK_IMPORTED_MODULE_15__shared_components_ShippingSection_shippingTypes__["c" /* shipToOptions */] }, _this.disableCustomerCqcApproval = function (company, lineItem) {
      var fieldIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (!company || !lineItem) return null;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__helpers__["f" /* shouldSetQcPreapproval */])(company, lineItem, function () {
        if (fieldIndex) {
          _this.props.change(fieldIndex + ".customer_qc_preapproval_required", true);
        }
      });
    }, _this.handleCompanySelected = function (company) {
      _this.props.setSelectedCustomer(company);
      _this.props.setPreferredShippingMethods(company.shipment_methods);

      if (!company) return null;

      _this.props.lineItems.forEach(function (l, i) {
        _this.disableCustomerCqcApproval(company, l, "line_items[" + i + "]");
      });

      if (company && company.shipment_methods) {
        var shipmentMethod = company.shipment_methods[0];
        if (!shipmentMethod) return null;

        [__WEBPACK_IMPORTED_MODULE_19__constants__["e" /* CARRIER */], __WEBPACK_IMPORTED_MODULE_19__constants__["g" /* SHIPPING_METHOD */], __WEBPACK_IMPORTED_MODULE_19__constants__["h" /* ACCOUNT_NUMBER */]].forEach(function (f) {
          _this.props.setFieldValue([__WEBPACK_IMPORTED_MODULE_19__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */], f].join("."))(shipmentMethod[f]);
        });
      }

      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$formItems = _props.formItems,
          formItems = _props$formItems === undefined ? [] : _props$formItems,
          canExchange = _props.canExchange,
          getField = _props.getField,
          _props$hasExchange = _props.hasExchange,
          hasExchange = _props$hasExchange === undefined ? false : _props$hasExchange,
          _props$lineItems = _props.lineItems,
          lineItems = _props$lineItems === undefined ? [] : _props$lineItems,
          selectedSeller = _props.selectedSeller,
          setFieldValue = _props.setFieldValue,
          selectedCustomer = _props.selectedCustomer,
          setShippingToAddress = _props.setShippingToAddress;
      var _state = this.state,
          invalidCompany = _state.invalidCompany,
          shipToOptions = _state.shipToOptions;

      var sameStoreOwner = [].concat(_toConsumableArray(new Set(lineItems.map(function (a) {
        return a.store_owner_id;
      })))).length === 1;

      var formConditions = formItems.map(function (f) {
        return f.condition;
      });
      var itemConditions = lineItems.map(function (f) {
        return f.condition;
      });
      var conditionsMatch = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(itemConditions, formConditions);

      var copyBillingAddress = function copyBillingAddress() {
        return [__WEBPACK_IMPORTED_MODULE_19__constants__["r" /* COUNTRY */], __WEBPACK_IMPORTED_MODULE_19__constants__["Q" /* REGION */], __WEBPACK_IMPORTED_MODULE_19__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_19__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_19__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_19__constants__["t" /* LINE2 */], __WEBPACK_IMPORTED_MODULE_19__constants__["w" /* POSTAL_CODE */]].forEach(function (f) {
          setFieldValue([__WEBPACK_IMPORTED_MODULE_25__companies_constants__["l" /* PHYSICAL_ADDRESS */], f].join("."))(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(selectedCustomer, __WEBPACK_IMPORTED_MODULE_25__companies_constants__["w" /* BILLING_ADDRESS */] + "." + f, getField([__WEBPACK_IMPORTED_MODULE_25__companies_constants__["w" /* BILLING_ADDRESS */], f].join("."))));
        });
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["e" /* Form */],
        _extends({}, this.props, { disabled: invalidCompany }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__companies_shared_components_DoNotDoBusinessWarning__["a" /* default */], { company: selectedCustomer }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_23__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
            null,
            !sameStoreOwner && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Warnings__["f" /* StoreOwnerWarning */], null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Warnings__["a" /* NoPmaNoDerWarning */], {
            company: selectedCustomer,
            inventories: lineItems
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Warnings__["b" /* TraceTypeWarning */], {
            company: selectedCustomer,
            inventories: lineItems
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Warnings__["d" /* WarrantyMinimumWarning */], {
            company: selectedCustomer,
            lineItems: formItems
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Warnings__["e" /* BlanketExchangeAgreementWarning */], {
            company: selectedCustomer,
            exchangeSale: formItems.some(function (l) {
              return l.exchange_sale;
            })
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            null,
            "Sellers"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_FormSections__["a" /* SellersSection */], { selectedSeller: selectedSeller, disabled: false }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            null,
            "Customer"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_FormSections__["b" /* CustomerSection */], {
            formName: FORM_NAME,
            company: selectedCustomer,
            onCompanySelected: this.handleCompanySelected,
            setFieldValue: setFieldValue,
            getFieldValue: getField,
            setPrimaryContact: false
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            null,
            "Shipping"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { xs: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_19__constants__["_20" /* SHIP_TO_FOB */],
                component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */],
                label: "Ship To FOB",
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { xs: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["a" /* CheckGroup */],
                { justified: true, title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_16__constants__["b" /* DISCREET */]) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_16__constants__["b" /* DISCREET */],
                  component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["b" /* Check */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_16__constants__["b" /* DISCREET */])
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Warnings__["g" /* DiscreetWarning */], {
            discreet: getField(__WEBPACK_IMPORTED_MODULE_16__constants__["b" /* DISCREET */]),
            shippingType: getField(__WEBPACK_IMPORTED_MODULE_19__constants__["q" /* SHIP_TO_TYPE */])
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__shared_Warnings_DoNotDoBusinessShippingWarning__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_ShippingSection__["a" /* ShippingSection */], {
            copyBillingAddress: copyBillingAddress,
            discreet: getField(__WEBPACK_IMPORTED_MODULE_16__constants__["b" /* DISCREET */]),
            getField: getField,
            key: selectedCustomer,
            setFieldValue: setFieldValue,
            shipToCustomer: selectedCustomer,
            shipToOptions: shipToOptions,
            setFOB: setFieldValue(__WEBPACK_IMPORTED_MODULE_19__constants__["_40" /* RETURN_TO_FOB */]),
            setShippingToAddress: setShippingToAddress,
            beforeShippingMethod: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_FinalDestination_FinalDestinationFields__["a" /* default */], {
              change: this.props.change,
              formName: FORM_NAME,
              shippingToAddress: this.shippingAddress,
              showWarning: true
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Warnings__["g" /* DiscreetWarning */], {
              discreet: getField(__WEBPACK_IMPORTED_MODULE_16__constants__["b" /* DISCREET */]),
              carrier: getField(__WEBPACK_IMPORTED_MODULE_19__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */] + "." + __WEBPACK_IMPORTED_MODULE_19__constants__["e" /* CARRIER */])
            })],
            convertSO: true,
            wtDimsReq: true,
            preferredShippingMethods: this.props.preferredShippingMethods
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_FormSections__["c" /* AdditionalDetails */], { showDiscreet: false }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              null,
              "Parts"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: "row row-col-gutters-half",
                style: { marginTop: "26px" }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Warnings__["h" /* CreditLimitWarning */], {
                company: selectedCustomer,
                lineItems: formItems,
                customerCreditTerm: getField("credit_terms")
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-striped table-numbered margin-bottom-none" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["FieldArray"], {
                    name: __WEBPACK_IMPORTED_MODULE_19__constants__["A" /* LINE_ITEMS */],
                    component: __WEBPACK_IMPORTED_MODULE_32__LineItemFields__["a" /* default */],
                    canExchange: canExchange,
                    lineItems: lineItems,
                    disableCustomerCqcApproval: this.disableCustomerCqcApproval,
                    selectedCustomer: selectedCustomer,
                    selectedSeller: selectedSeller,
                    change: this.props.change,
                    getField: getField,
                    setFieldValue: setFieldValue,
                    shipToAddress: this.shippingAddress
                  })
                ),
                !conditionsMatch && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                    { md: 12, style: { marginTop: "20px" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__shared_Warnings_ConditionWarning__["a" /* default */], null)
                  )
                )
              )
            )
          ),
          hasExchange && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            { key: "return-to-header" },
            "Return To"
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
            { key: "return-to-fob" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { xs: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_19__constants__["_40" /* RETURN_TO_FOB */],
                component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */],
                label: "Return To FOB",
                required: true
              })
            )
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Orders_shared_ShippingFields_ShippingFields__["a" /* default */], {
            key: "return-to-shipping-fields",
            formName: FORM_NAME,
            path: __WEBPACK_IMPORTED_MODULE_19__constants__["_39" /* RETURN_TO */],
            shippingFields: [__WEBPACK_IMPORTED_MODULE_19__constants__["C" /* RETURN_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_19__constants__["_42" /* RETURN_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_19__constants__["_43" /* RETURN_TO_COMPANY_ADDRESS_ID */]],
            renderCarrier: false,
            shippingTypes: [__WEBPACK_IMPORTED_MODULE_19__constants__["i" /* COMPANY */]],
            shippingAddressField: __WEBPACK_IMPORTED_MODULE_19__constants__["_44" /* RETURN_TO_SHIPPING_ADDRESS */],
            required: hasExchange,
            locationFieldName: __WEBPACK_IMPORTED_MODULE_19__constants__["_25" /* RETURN_TO_LOCATION_ID */]
          })]
        )
      );
    }
  }, {
    key: "shippingAddress",
    get: function get() {
      var _props2 = this.props,
          shippingToAddress = _props2.shippingToAddress,
          getField = _props2.getField;


      var shippingType = getField(__WEBPACK_IMPORTED_MODULE_19__constants__["q" /* SHIP_TO_TYPE */]);

      if (!shippingToAddress) {
        return null;
      }

      return shippingToAddress[shippingType];
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  formItems: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({})),
  hasExchange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  lineItems: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    has_active_repair: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    active_repair_ship_to_fob: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
  })),
  returnToType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  selectedSeller: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}),
  setFieldValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  selectedCustomer: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(Object),
  setSelectedCustomer: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  shippingToAddress: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(Object),
  setShippingToAddress: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["formValueSelector"])(FORM_NAME);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state, props) {
  var cachedCart = state.session.get(__WEBPACK_IMPORTED_MODULE_20__users_constants__["_29" /* CACHED_SALES_CART */]) ? state.session.get(__WEBPACK_IMPORTED_MODULE_20__users_constants__["_29" /* CACHED_SALES_CART */]).toJS() : {};
  var getCachedItem = function getCachedItem(item) {
    if (cachedCart && cachedCart.line_items) {
      var cachedItem = cachedCart.line_items.filter(function (l) {
        return item.id === l.inventory_id;
      })[0];

      return cachedItem || {};
    }

    return {};
  };

  var isFlatExchange = function isFlatExchange(item) {
    var lineItem = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(item, __WEBPACK_IMPORTED_MODULE_21__Orders_shared_constants__["a" /* PO_ITEM */]);
    if (!lineItem) return false;

    return lineItem.flat_exchange && lineItem.purchase_for_sale;
  };

  var hazmatFee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__hooks_useCurrentUser__["b" /* useSettings */])(), __WEBPACK_IMPORTED_MODULE_19__constants__["_34" /* DEFAULT_HAZMAT_FEE */], 75);
  return {
    selectedSeller: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(state.session.toJS(), "salesCartItems[0].reserve_for_seller"),
    canExchange: state.session.getIn([__WEBPACK_IMPORTED_MODULE_19__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_19__constants__["_35" /* CAN_EXCHANGE */]]),
    hasExchange: (selector(state, __WEBPACK_IMPORTED_MODULE_19__constants__["A" /* LINE_ITEMS */]) || []).some(function (i) {
      return i.exchange_sale;
    }),
    formItems: selector(state, __WEBPACK_IMPORTED_MODULE_19__constants__["A" /* LINE_ITEMS */]),
    returnToType: selector(state, __WEBPACK_IMPORTED_MODULE_19__constants__["C" /* RETURN_TO_TYPE */]),
    initialValues: {
      company_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(cachedCart, "company.id"),
      contact_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(cachedCart, "contact.id"),
      credit_terms: cachedCart && cachedCart.customer_credit_terms,
      seller_credit_percent: "25.0",
      seller_id: state.session.getIn([__WEBPACK_IMPORTED_MODULE_20__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_19__constants__["b" /* ID */]]),
      send_sales_order_acknowledgement: true,
      ship_to_type: null,
      ship_to_fob: props.lineItems && props.lineItems[0] && initialFOB(props.lineItems[0]),
      line_items: props.lineItems.map(function (item) {
        return _extends({
          consignment_type: item.consignment_type,
          contingent_on_passing: item.contingent_on_passing,
          lead_time: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__shared_helpers__["e" /* setLeadTime */])(item),
          inventory_id: item.id,
          hazmat: item.part.hazmat,
          hazmat_fee: item.part.hazmat ? hazmatFee : null,
          special_container_req: item.part.special_container_req,
          container_fee: item.part.special_container_fee,
          exchange_sale: !!item.brokered_exchange,
          exchange_fee: item.brokered_exchange ? __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(item, "purchase_order_line_item.exchange_srp") : undefined,
          outright_value: item.brokered_exchange ? __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(item, "purchase_order_line_item.suggested_retail") : undefined,
          flat_exchange: isFlatExchange(item),
          condition: item.condition,
          core_due_days: state.session.getIn([__WEBPACK_IMPORTED_MODULE_19__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_19__constants__["_52" /* EXCHANGE_CORE_DUE_DAYS */]]) || 30,
          quantity: item.total_quantity,
          repair_fee: item.brokered_exchange ? __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(item, "purchase_order_line_item.core_repair_fee_not_to_exceed") : undefined,
          warranty: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__OutgoingQuotes_shared_PartDetails__["c" /* warrantyForCondition */])(item.condition, item.part, item.tag_date, item)
        }, getCachedItem(item));
      })
    },
    getField: function getField(field) {
      return selector(state, field);
    }
  };
}, function (dispatch) {
  return {
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(FORM_NAME, field, val));
      };
    },
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["t" /* convertSo */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__helpers__["i" /* transformSO */])(data)));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_29__validate__["a" /* default */],
  asyncValidate: __WEBPACK_IMPORTED_MODULE_6__actions__["s" /* validateContact */],
  asyncBlurFields: ["contact.email", "contact.name", "contact_id"]
})(Form)));

/***/ }),
/* 1782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components_ShippingSection_shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ExistingQuoteWarning__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_formatters_address__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Detail_Body_LineItems_Form_PartDetails_RepairAdminCharge__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__PartFee__ = __webpack_require__(1783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Warnings__ = __webpack_require__(187);
/* harmony export (immutable) */ __webpack_exports__["a"] = LineItemFields;
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
























function LineItemFields(_ref) {
  var canExchange = _ref.canExchange,
      change = _ref.change,
      fields = _ref.fields,
      getField = _ref.getField,
      lineItems = _ref.lineItems,
      disableCustomerCqcApproval = _ref.disableCustomerCqcApproval,
      selectedCustomer = _ref.selectedCustomer,
      selectedSeller = _ref.selectedSeller,
      shipToAddress = _ref.shipToAddress;

  var changeExchange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (_ev, val) {
    if (val) {
      change(__WEBPACK_IMPORTED_MODULE_9__constants__["C" /* RETURN_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_14__shared_components_ShippingSection_shippingTypes__["a" /* TENANT_LOCATION */]);
      change(__WEBPACK_IMPORTED_MODULE_9__constants__["_25" /* RETURN_TO_LOCATION_ID */], lineItems[0].store_location_id);
      if (shipToAddress) change(__WEBPACK_IMPORTED_MODULE_9__constants__["_40" /* RETURN_TO_FOB */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_address__["a" /* fobFormat */])(shipToAddress));
    } else {
      change("line_items[0].flat_exchange", val);
    }
  }, [change, lineItems, shipToAddress]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tbody",
    null,
    fields.map(function (item, idx) {
      var lineItem = lineItems[idx];
      var hazmat = fields.get(idx).hazmat;
      var specialContainer = fields.get(idx).special_container_req;
      var exchange = fields.get(idx).exchange_sale;
      var altOptions = lineItem.alternates.map(function (a) {
        return {
          value: a.id,
          text: a.name
        };
      });
      var price = (exchange ? fields.get(idx).outright_value : fields.get(idx).price_per_unit) || 0;
      var subtotal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(parseFloat(price) * lineItem.total_quantity);

      /* eslint-disable no-unused-vars */

      var _INVENTORIES$conditio = __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["r" /* INVENTORIES */].condition,
          scrap = _INVENTORIES$conditio.scrap,
          parts_unit = _INVENTORIES$conditio.parts_unit,
          filteredConditions = _objectWithoutProperties(_INVENTORIES$conditio, ["scrap", "parts_unit"]);
      /* eslint-enable no-unused-vars */

      var chargeType = getField(item + ".repair_admin_charge_type");

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: "item-" + lineItem.id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: { verticalAlign: "top", paddingTop: "12px" } },
          idx + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "table",
            { className: "table" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tbody",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ExistingQuoteWarning__["a" /* default */], {
                part: lineItem.part,
                company: selectedCustomer,
                sellerId: getField(item + "." + __WEBPACK_IMPORTED_MODULE_11__constants__["C" /* SELLER_ID */])
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    { className: "float-left" },
                    lineItem.part.part_number,
                    " | serial #\xA0",
                    lineItem.serial_number,
                    " | in\xA0",
                    __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["r" /* INVENTORIES */].condition[lineItem.condition].label,
                    " ",
                    "Condition | SRP ",
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(lineItem.suggested_retail),
                    lineItem.exchange_srp && " | EX SRP " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(lineItem.exchange_srp)
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    { className: "float-right" },
                    subtotal
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                      { md: 12 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["c" /* Collapse */],
                        {
                          "in": parseInt(lineItem.total_quantity, 10) === 1,
                          unmountOnExit: true
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "div",
                          null,
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                              { md: 3 },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
                                { title: "Exchange Sale", justified: true },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                                  name: item + ".exchange_sale",
                                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__constants__["w" /* EXCHANGE_SALE */]),
                                  disabled: !canExchange || getField(item + "." + __WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_71" /* CONSIGNMENT_TYPE */]) === __WEBPACK_IMPORTED_MODULE_10__Receiving_constants__["s" /* EMA */] || lineItem.brokered_exchange || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(selectedCustomer, __WEBPACK_IMPORTED_MODULE_17__companies_constants__["k" /* DO_NOT_EXCHANGE */]) || lineItem.do_not_exchange,
                                  onChange: function onChange(e, val) {
                                    return changeExchange(e, val);
                                  }
                                })
                              )
                            ),
                            exchange && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                              null,
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                                { md: 3 },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
                                  {
                                    title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__constants__["e" /* FLAT_EXCHANGE */]),
                                    justified: true
                                  },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                                    name: item + "." + __WEBPACK_IMPORTED_MODULE_11__constants__["e" /* FLAT_EXCHANGE */],
                                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__constants__["e" /* FLAT_EXCHANGE */]),
                                    disabled: !!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(lineItem, "purchase_order_line_item.flat_exchange")
                                  })
                                )
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_redux_form__["FormSection"],
                                { name: item },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                                  { md: 4 },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Fields"], {
                                    names: [__WEBPACK_IMPORTED_MODULE_11__constants__["T" /* REPAIR_ADMIN_CHARGE_TYPE */], __WEBPACK_IMPORTED_MODULE_11__constants__["I" /* REPAIR_ADMINISTRATION_CHARGE_PERCENTAGE */], __WEBPACK_IMPORTED_MODULE_11__constants__["K" /* REPAIR_ADMINISTRATION_CHARGE_DOLLARS */]],
                                    component: __WEBPACK_IMPORTED_MODULE_18__Detail_Body_LineItems_Form_PartDetails_RepairAdminCharge__["a" /* default */]
                                  })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                                  { md: 2 },
                                  chargeType === __WEBPACK_IMPORTED_MODULE_11__constants__["H" /* PERCENTAGE */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                                    name: __WEBPACK_IMPORTED_MODULE_11__constants__["I" /* REPAIR_ADMINISTRATION_CHARGE_PERCENTAGE */],
                                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                                    label: "Repair Charge (%)"
                                  }),
                                  chargeType === __WEBPACK_IMPORTED_MODULE_11__constants__["J" /* DOLLARS */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                                    name: __WEBPACK_IMPORTED_MODULE_11__constants__["K" /* REPAIR_ADMINISTRATION_CHARGE_DOLLARS */],
                                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                                    label: "Repair Charge ($)"
                                  })
                                )
                              )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                              { md: 7 },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Warnings__["e" /* BlanketExchangeAgreementWarning */], {
                                company: selectedCustomer,
                                exchangeSale: exchange
                              })
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["c" /* Collapse */],
                            { "in": exchange, unmountOnExit: true },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              "div",
                              null,
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                                  { md: 3 },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["f" /* CurrencyField */], {
                                    name: item + ".exchange_fee",
                                    label: getField(item + "." + __WEBPACK_IMPORTED_MODULE_11__constants__["e" /* FLAT_EXCHANGE */]) ? "Flat Exchange Fee" : "Exchange Fee",
                                    required: true
                                  })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                                  { md: 3 },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["f" /* CurrencyField */], {
                                    name: item + ".outright_value",
                                    label: "Outright Value",
                                    required: true
                                  })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                                  { md: 2 },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                                    name: item + ".core_due_days",
                                    label: "Core Due Days",
                                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["h" /* NumberInput */],
                                    roundDigits: 0
                                  })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                                  { md: 3 },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                                    name: item + "." + __WEBPACK_IMPORTED_MODULE_11__constants__["F" /* REPAIR_FEE */],
                                    label: "Avg Repair (NTX)",
                                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                                    required: getField(item + "." + __WEBPACK_IMPORTED_MODULE_11__constants__["e" /* FLAT_EXCHANGE */])
                                  })
                                )
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                                  { md: 12 },
                                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                                    name: item + "." + __WEBPACK_IMPORTED_MODULE_11__constants__["G" /* EXCHANGE_SPECIAL_INSTRUCTIONS */],
                                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["l" /* TextArea */],
                                    maxLength: 150,
                                    label: "Special Instructions (To be incl. on Exch. Agreement)",
                                    rows: "5"
                                  })
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
                    null,
                    !exchange && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["f" /* CurrencyField */], {
                        name: item + ".price_per_unit",
                        label: "Sales Ea.",
                        required: true
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                        label: "Qty",
                        name: item + ".read_only_quantity",
                        component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                        inputProps: { value: lineItem.total_quantity },
                        readOnly: true,
                        disabled: true
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["n" /* CONDITION */]),
                        name: item + ".condition",
                        component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
                        options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_forms__["a" /* toOptions */])(filteredConditions),
                        onChange: function onChange(e) {
                          return change(item + ".warranty", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__shared_helpers__["d" /* warrantyForCondition */])(e.target.value, lineItem.part, lineItem.tag_date));
                        }
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                      { md: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                        name: item + ".sell_as_alt_id",
                        component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
                        label: "Sell As Alternate",
                        options: altOptions
                      })
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__PartFee__["a" /* default */], {
                currentSeller: selectedSeller,
                item: item,
                part: lineItem.part,
                hazmat: hazmat,
                specialContainer: specialContainer,
                change: change,
                getField: getField,
                changeExchange: changeExchange,
                canExchange: canExchange,
                lineItem: lineItem,
                selectedCustomer: selectedCustomer,
                left: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                    label: "Days Lead Time",
                    name: item + ".lead_time",
                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */]
                  })
                )
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "h5",
                      { className: "h4" },
                      "QC Pre-Approval Required"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                        { md: 5 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
                          {
                            title: "QC Pre-Approval Required",
                            justified: true
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                            name: item + "." + __WEBPACK_IMPORTED_MODULE_11__constants__["L" /* CUSTOMER_QC_PREAPPROVAL_REQUIRED */],
                            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                            label: "Required",
                            disabled: disableCustomerCqcApproval(selectedCustomer, lineItem)
                          })
                        )
                      ),
                      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(lineItem, __WEBPACK_IMPORTED_MODULE_11__constants__["_8" /* CONTINGENT_ON_PASSING */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                        { md: 3 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
                          {
                            title: "Contingent To Passing",
                            justified: true
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                            name: item + "." + __WEBPACK_IMPORTED_MODULE_11__constants__["_8" /* CONTINGENT_ON_PASSING */],
                            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                            label: "Contingent To Passing"
                          })
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "h5",
                      { className: "h4" },
                      "Warranty"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                        { md: 3 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
                          component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
                          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__OutgoingQuotes_constants__["g" /* WARRANTY */]),
                          name: item + ".warranty",
                          options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_forms__["f" /* arrayToOptions */])(__WEBPACK_IMPORTED_MODULE_4__inventories_constants__["_59" /* WARRANTY_OPTIONS */])
                        })
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    })
  );
}

LineItemFields.propTypes = {
  canExchange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  change: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  disableCustomerCqcApproval: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  fields: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    map: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    get: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  }).isRequired,
  getField: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  lineItems: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})).isRequired,
  selectedCustomer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  selectedSeller: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  shipToAddress: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

/***/ }),
/* 1783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms_FormRow__ = __webpack_require__(26);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var PartFee = function (_React$Component) {
  _inherits(PartFee, _React$Component);

  function PartFee() {
    _classCallCheck(this, PartFee);

    return _possibleConstructorReturn(this, (PartFee.__proto__ || Object.getPrototypeOf(PartFee)).apply(this, arguments));
  }

  _createClass(PartFee, [{
    key: "handleHazmatFee",
    value: function handleHazmatFee(item) {
      if (!this.props.hazmat) {
        var hazmatFee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__hooks_useCurrentUser__["b" /* useSettings */])(), __WEBPACK_IMPORTED_MODULE_16__constants__["_34" /* DEFAULT_HAZMAT_FEE */], 75);
        this.props.change(item + ".hazmat_fee", hazmatFee);
      } else {
        this.props.change(item + ".hazmat_fee", null);
      }
    }
  }, {
    key: "handleContainerFee",
    value: function handleContainerFee(item) {
      if (this.props.specialContainer) {
        this.props.change(item + ".container_fee", null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          currentSeller = _props.currentSeller,
          item = _props.item,
          part = _props.part,
          hazmat = _props.hazmat,
          specialContainer = _props.specialContainer,
          getField = _props.getField,
          left = _props.left,
          changeExchange = _props.changeExchange,
          canExchange = _props.canExchange,
          lineItem = _props.lineItem,
          selectedCustomer = _props.selectedCustomer;

      var hazmatSelected = getField(item + "." + __WEBPACK_IMPORTED_MODULE_11__parts_constants__["h" /* HAZMAT */]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          specialContainer && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10__shared_components_Warning_Warning__["a" /* default */],
                { warningType: "warning" },
                "PN-",
                part.part_number,
                " is flagged as requiring a special container fee of ",
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_currency__["a" /* dollars */])(part.special_container_fee),
                " and has been auto-populated below."
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms_FormRow__["a" /* default */],
            null,
            left,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
                { title: "Line Hazmat", justified: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: item + "." + __WEBPACK_IMPORTED_MODULE_11__parts_constants__["h" /* HAZMAT */],
                  disabled: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__users_helpers__["d" /* hasRole */])(currentSeller || {}, __WEBPACK_IMPORTED_MODULE_8__users_constants__["m" /* ACCOUNTING */]),
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__parts_constants__["h" /* HAZMAT */]),
                  icon: "fa-warning",
                  onChange: function onChange() {
                    return _this2.handleHazmatFee(item);
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
              { "in": hazmat, unmountOnExit: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                { md: 3 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["f" /* CurrencyField */], {
                    name: item + ".hazmat_fee",
                    label: "Hazmat Fee",
                    required: true
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
                { title: "Sold As Is", justified: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: item + "." + __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["_98" /* AS_IS */],
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                  label: "As-Is / No Returns",
                  onChange: function onChange(event, checked) {
                    changeExchange(event, checked);
                    if (checked) {
                      _this2.props.change(item + ".warranty", "No warranty");
                    }
                  },
                  disabled: !canExchange || getField(item + "." + __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["_71" /* CONSIGNMENT_TYPE */]) === __WEBPACK_IMPORTED_MODULE_12__Receiving_constants__["s" /* EMA */] || lineItem.brokered_exchange || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(selectedCustomer, __WEBPACK_IMPORTED_MODULE_13__companies_constants__["k" /* DO_NOT_EXCHANGE */]) || lineItem.do_not_exchange
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "label",
                  { htmlFor: "special-container", className: "control-label" },
                  "Special Container"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    id: "special-container",
                    className: "btn-group btn-group-justified",
                    "data-toggle": "buttons"
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                    name: item + ".special_container_req",
                    label: "Special Container Req.",
                    icon: "fa-cube",
                    onChange: function onChange() {
                      return _this2.handleContainerFee(item);
                    }
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
                { "in": specialContainer, unmountOnExit: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["f" /* CurrencyField */], {
                    name: item + ".container_fee",
                    label: "Special Container Fee",
                    required: true
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
                { "in": hazmatSelected && specialContainer, unmountOnExit: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "label",
                      {
                        htmlFor: "customer-to-return-container",
                        className: "control-label"
                      },
                      "Customer to Return Container"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "div",
                      {
                        id: "customer-to-return-container",
                        className: "btn-group btn-group-justified",
                        "data-toggle": "buttons"
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                        component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                        name: item + ".customer_to_return_container",
                        label: "Cust. to Rtrn Cont.",
                        icon: "fa-cube"
                      })
                    )
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
                { "in": !hazmatSelected && specialContainer, unmountOnExit: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    {
                      htmlFor: "customer-to-return-container",
                      className: "control-label"
                    },
                    "Customer to Return Container"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    {
                      id: "customer-to-return-container",
                      className: "btn-group btn-group-justified",
                      "data-toggle": "buttons"
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                      component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                      name: item + ".customer_to_return_container",
                      label: "Cust. to Rtrn Cont.",
                      icon: "fa-cube"
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PartFee;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PartFee.propTypes = {
  currentSeller: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}),
  item: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}),
  part: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}),
  hazmat: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  specialContainer: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  change: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  getField: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  left: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element
};
/* harmony default export */ __webpack_exports__["a"] = (PartFee);

/***/ }),
/* 1784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_FormSections_CustomerSection_validate__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_FormSections_SellersSection_validate__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_FormSections_ShippingSection_validate__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__parts_constants__ = __webpack_require__(23);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;












function validateLineItem(item, values) {
  if (values.flat_exchange) {
    item.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["F" /* REPAIR_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["v" /* isLessThan */](values.exchange_fee));
  }

  if (values.repair_admin_charge_type === __WEBPACK_IMPORTED_MODULE_5__constants__["H" /* PERCENTAGE */]) {
    item.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["I" /* REPAIR_ADMINISTRATION_CHARGE_PERCENTAGE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["q" /* isNumeric */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["k" /* isLessThanOrEqualTo */](100), __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](1));
  } else if (values.repair_admin_charge_type === __WEBPACK_IMPORTED_MODULE_5__constants__["J" /* DOLLARS */]) {
    item.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["K" /* REPAIR_ADMINISTRATION_CHARGE_DOLLARS */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["q" /* isNumeric */]);
  }
  if (values.exchange_sale) {
    item.validate(__WEBPACK_IMPORTED_MODULE_8__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */], __WEBPACK_IMPORTED_MODULE_5__constants__["E" /* OUTRIGHT_VALUE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  } else {
    item.validate(__WEBPACK_IMPORTED_MODULE_8__OutgoingQuotes_constants__["b" /* PRICE_PER_UNIT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["f" /* isGreaterThan */](0), __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  }
  item.validate(__WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["p" /* requiredIfAnyDefined */](__WEBPACK_IMPORTED_MODULE_10__parts_constants__["h" /* HAZMAT */]), __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["q" /* isNumeric */]);
  item.validate(__WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__["y" /* CONTAINER_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["p" /* requiredIfAnyDefined */]("special_container_req"), __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["q" /* isNumeric */]);
}

function validate(values, props) {
  var hasExchange = values.line_items.some(function (i) {
    return i.exchange_sale;
  });

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    if (hasExchange) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_FormSections_ShippingSection_validate__["a" /* validateShippingFields */])(__WEBPACK_IMPORTED_MODULE_6__constants__["_39" /* RETURN_TO */], values, form, false);
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_FormSections_CustomerSection_validate__["b" /* validateCustomerFields */])(values, form);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_FormSections_SellersSection_validate__["a" /* validateSellerFields */])(values, form);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_FormSections_ShippingSection_validate__["a" /* validateShippingFields */])(__WEBPACK_IMPORTED_MODULE_6__constants__["B" /* SHIP_TO */], values, form);
    form.validateChildren(__WEBPACK_IMPORTED_MODULE_6__constants__["A" /* LINE_ITEMS */], validateLineItem);

    if (props.selectedCustomer) {
      form.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["N" /* COMPANY_ID */]).satisfies(function () {
        return __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["d" /* validateCompanyStatus */](props.selectedCustomer);
      });
    }
    form.validate(__WEBPACK_IMPORTED_MODULE_5__constants__["t" /* SHIP_TO_COMPANY_DISABLED */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["t" /* shipToCompanyIsNoBiz */]);

    if (props.selectedCustomer && !props.selectedCustomer.billing_address) {
      form.validateChild(__WEBPACK_IMPORTED_MODULE_7__companies_constants__["w" /* BILLING_ADDRESS */], function (billingForm) {
        billingForm.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_6__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_6__constants__["w" /* POSTAL_CODE */], __WEBPACK_IMPORTED_MODULE_6__constants__["r" /* COUNTRY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      });
    }
  });
}

/***/ }),
/* 1785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_ActionDropDown_ActionDropDown__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sync_Sync__ = __webpack_require__(1808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DownloadProForma_DownloadProForma__ = __webpack_require__(1800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CreateCommercialInvoice_CreateCommercialInvoice__ = __webpack_require__(1792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RemoveExportHold_RemoveExportHold__ = __webpack_require__(1807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ExportHold_ExportHold__ = __webpack_require__(1803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DownloadCoC_Download__ = __webpack_require__(1794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SyncCoreRepairCharges_SyncCoreRepairCharges__ = __webpack_require__(1809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__NewCompanyHold_NewCompanyHold__ = __webpack_require__(1804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ToggleQuickbooksSync_ToggleQuickbooksSync__ = __webpack_require__(1810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Cancel_Cancel__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Release__ = __webpack_require__(1805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ReleaseExchangeAgreement__ = __webpack_require__(1806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__AddAccountingHold__ = __webpack_require__(1786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DownloadPackingSlip__ = __webpack_require__(1797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DownloadDiscreetPackingSlip__ = __webpack_require__(1796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__CancellationReversal__ = __webpack_require__(1791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__EditInvoiceDetails_EditInvoiceDetails__ = __webpack_require__(1802);




























function Actions(_ref) {
  var salesOrderWithAllLineItems = _ref.salesOrderWithAllLineItems,
      cancelled = _ref.cancelled;

  var salesOrder = salesOrderWithAllLineItems.toJS();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group pull-right", style: { marginLeft: 20 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_ActionDropDown_ActionDropDown__["a" /* default */],
      { menuClass: "dropdown-menu-right" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components__["b" /* Authorized */],
        { roles: [__WEBPACK_IMPORTED_MODULE_4__users_constants__["m" /* ACCOUNTING */]] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__EditInvoiceDetails_EditInvoiceDetails__["a" /* default */], { salesOrder: salesOrder })
      ),
      !cancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components__["b" /* Authorized */],
          {
            permissions: [__WEBPACK_IMPORTED_MODULE_4__users_constants__["_17" /* CAN_RELEASE_ACCOUNTING_HOLD */]],
            roles: [__WEBPACK_IMPORTED_MODULE_4__users_constants__["m" /* ACCOUNTING */]]
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Release__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ReleaseExchangeAgreement__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__AddAccountingHold__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components__["b" /* Authorized */],
          {
            roles: [__WEBPACK_IMPORTED_MODULE_4__users_constants__["p" /* QUALITY_CONTROL */]],
            subroles: [__WEBPACK_IMPORTED_MODULE_4__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__NewCompanyHold_NewCompanyHold__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RemoveExportHold_RemoveExportHold__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ExportHold_ExportHold__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__DownloadPackingSlip__["a" /* default */], { salesOrder: salesOrder }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__DownloadDiscreetPackingSlip__["a" /* default */], { salesOrder: salesOrder }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DownloadProForma_DownloadProForma__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components__["b" /* Authorized */],
          {
            permissions: [__WEBPACK_IMPORTED_MODULE_4__users_constants__["_14" /* CREATE_COC */]],
            roles: [__WEBPACK_IMPORTED_MODULE_4__users_constants__["p" /* QUALITY_CONTROL */]],
            subroles: [__WEBPACK_IMPORTED_MODULE_4__users_constants__["n" /* QUALITY_CONTROL_MANAGER */]]
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__DownloadCoC_Download__["a" /* default */], { salesOrder: salesOrder })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components__["b" /* Authorized */],
          { roles: [__WEBPACK_IMPORTED_MODULE_4__users_constants__["m" /* ACCOUNTING */]] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ToggleQuickbooksSync_ToggleQuickbooksSync__["a" /* default */], { salesOrder: salesOrder }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Sync_Sync__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__SyncCoreRepairCharges_SyncCoreRepairCharges__["a" /* default */], { salesOrder: salesOrder })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CreateCommercialInvoice_CreateCommercialInvoice__["a" /* default */], { salesOrder: salesOrder }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components__["b" /* Authorized */],
          {
            roles: [__WEBPACK_IMPORTED_MODULE_4__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_4__users_constants__["p" /* QUALITY_CONTROL */]],
            authorizedIf: function authorizedIf(user) {
              return user.get(__WEBPACK_IMPORTED_MODULE_13__constants__["b" /* ID */]) === salesOrder.created_by_id;
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { className: "divider", role: "separator" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Cancel_Cancel__["a" /* default */], { salesOrder: salesOrder })
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components__["T" /* Forbidden */],
        { roles: [__WEBPACK_IMPORTED_MODULE_4__users_constants__["j" /* WAREHOUSE */]] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__CancellationReversal__["a" /* default */], null)
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react_router__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(function (state) {
  return {
    salesOrderWithAllLineItems: state.salesOrderWithAllLineItemsDetail.get("salesOrderWithAllLineItems")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_decorators__["h" /* loadRecord */])({
  reducer: "salesOrderWithAllLineItemsDetail",
  name: "salesOrderWithAllLineItems",
  action: function action(id) {
    return __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* fetchSalesOrderWithAllLineItems */](id, true);
  }
})(Actions))));

Actions.propTypes = {
  cancelled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 1786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(32);
/* unused harmony export AddAccountingHold */








function AddAccountingHold(_ref) {
  var hold = _ref.hold,
      addingHold = _ref.addingHold,
      open = _ref.open,
      close = _ref.close,
      addHold = _ref.addHold;

  return !hold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["i" /* ConfirmAction */],
      {
        key: "confirm",
        open: addingHold,
        close: close,
        btnText: "Yes",
        onConfirm: addHold
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0Place SO on Accounting Hold?"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["k" /* Icon */], { name: "pause", fixed: true }),
    "\xA0Place SO on Accounting Hold"
  );
}

AddAccountingHold.propTypes = {
  hold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addingHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  addHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var salesOrder = _ref2.salesOrder,
      updateSalesOrder = _ref2.updateSalesOrder;
  return {
    addHold: function addHold() {
      return updateSalesOrder({ accounting_hold: true });
    },
    hold: salesOrder.get(__WEBPACK_IMPORTED_MODULE_6__constants__["u" /* ACCOUNTING_HOLD */])
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withSalesOrder */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["e" /* toggleSwitch */])("addingHold")(withProps(AddAccountingHold))));

/***/ }),
/* 1787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Reason__ = __webpack_require__(1788);
/* unused harmony export Cancel */













function Cancel(_ref) {
  var cancelSo = _ref.cancelSo,
      cancelling = _ref.cancelling,
      open = _ref.open,
      close = _ref.close,
      salesOrder = _ref.salesOrder;

  var initialValues = {
    cancellation_reason: __WEBPACK_IMPORTED_MODULE_9__constants__["M" /* CANCELLATION_REASONS */][0].value,
    line_items: salesOrder.line_items.map(function (l) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_pojos__["a" /* default */])(l).pick("id", "inventory");
    })
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Reason__["a" /* default */], {
      initialValues: initialValues,
      visible: cancelling,
      close: close,
      cancel: cancelSo,
      salesOrder: salesOrder
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "text-danger" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["k" /* Icon */], { name: "ban", fixed: true }),
      "\xA0Cancel SO"
    )
  );
}

Cancel.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cancelling: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var ifNoneCancelledOrShipped = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var salesOrder = _ref2.salesOrder;
  return salesOrder.line_items.every(function (l) {
    return !l.cancelled && !l.shipped && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(l, [__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_71" /* CONSIGNMENT_TYPE */]].join("."));
  });
});

/* harmony default export */ __webpack_exports__["a"] = (ifNoneCancelledOrShipped(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["e" /* toggleSwitch */])("cancelling")(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    cancelSo: function cancelSo(reason, sendEmail) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__actions__["f" /* cancel */])(ownProps.salesOrder.id, reason, sendEmail, ownProps.close));
    }
  };
})(Cancel))));

/***/ }),
/* 1788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_components_Detail_LineItemsTable_Form__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__validate__ = __webpack_require__(1789);
/* unused harmony export Reason */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

















function LineItems(_ref) {
  var lineItems = _ref.lineItems,
      fields = _ref.fields;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tbody",
    null,
    fields.map(function (item, idx) {
      var lineItem = lineItems[idx];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: "item-" + lineItem.id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          {
            className: "text-right",
            style: { verticalAlign: "top", paddingTop: 8, paddingLeft: 10 }
          },
          idx + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["d" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { className: "float-left" },
                lineItem.part.part_number,
                " |\xA0",
                lineItem.serial_number
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["f" /* CurrencyField */], {
                name: item + ".inventory." + __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["v" /* SUGGESTED_RETAIL */],
                label: "SRP",
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: item + ".inventory." + __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["C" /* SRP_CONDITION */],
                component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["c" /* Select */],
                options: __WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_components_Detail_LineItemsTable_Form__["b" /* SRP_CONDITION_OPTIONS */],
                label: "SRP Condition",
                required: true
              })
            )
          )
        )
      );
    })
  );
}

function Reason(_ref2) {
  var visible = _ref2.visible,
      close = _ref2.close,
      salesOrder = _ref2.salesOrder,
      props = _objectWithoutProperties(_ref2, ["visible", "close", "salesOrder"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: visible, close: close, dialogClass: "modal-md" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Are You Sure?"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
        _extends({}, props, { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__shared_components__["n" /* Warning */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              null,
              "Heads up!"
            ),
            "\xA0Cancelling a SO will cancel all line items associated with it.",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["d" /* Row */],
              { className: "row-col-gutters-half" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["H" /* CANCELLATION_REASON */],
                  className: "text-right",
                  component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["c" /* Select */],
                  options: __WEBPACK_IMPORTED_MODULE_2__constants__["M" /* CANCELLATION_REASONS */],
                  prompt: false,
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["H" /* CANCELLATION_REASON */])
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            null,
            "Parts"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["d" /* Row */],
            { className: "row-col-gutters-half" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "table",
                { className: "table table-striped table-numbered margin-bottom-none" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["FieldArray"], {
                  name: "line_items",
                  component: LineItems,
                  lineItems: salesOrder.line_items
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["a" /* CheckGroup */],
              { title: "Send Customer Cancellation Email" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_2__constants__["_1" /* SEND_CANCELLATION_EMAIL */],
                component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["b" /* Check */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_2__constants__["_1" /* SEND_CANCELLATION_EMAIL */])
              })
            )
          )
        )
      )
    )
  );
}

Reason.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reason: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  updateReason: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updateEmail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var FORM_NAME = "cancelSalesOrder";

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__actions__["f" /* cancel */])(ownProps.salesOrder.id, data, ownProps.close));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_14__validate__["a" /* default */]
})(Reason)));

/***/ }),
/* 1789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventories_constants__ = __webpack_require__(12);
/* unused harmony export validateLineItem */
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;





function validateLineItem(lineItem) {
  lineItem.validateChild(__WEBPACK_IMPORTED_MODULE_3__inventories_constants__["_24" /* INVENTORY */], function (inventory) {
    inventory.validate(__WEBPACK_IMPORTED_MODULE_3__inventories_constants__["v" /* SUGGESTED_RETAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0));

    inventory.validate(__WEBPACK_IMPORTED_MODULE_3__inventories_constants__["C" /* SRP_CONDITION */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
  });
}

function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validateChildren(__WEBPACK_IMPORTED_MODULE_1__constants__["A" /* LINE_ITEMS */], validateLineItem);
  });
}

/***/ }),
/* 1790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inventories_constants__ = __webpack_require__(12);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }











function ReverseCancellation(_ref) {
  var toggle = _ref.toggle,
      unCancelling = _ref.unCancelling,
      rest = _objectWithoutProperties(_ref, ["toggle", "unCancelling"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: toggle },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Modal, _extends({}, rest, { open: unCancelling })),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "text-danger" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "undo", fixed: true }),
      "\xA0Reverse SO Cancellation"
    )
  );
}

ReverseCancellation.propTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  unCancelling: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

function Modal(_ref2) {
  var open = _ref2.open,
      reverseCancellation = _ref2.reverseCancellation,
      salesOrder = _ref2.salesOrder,
      close = _ref2.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["i" /* ConfirmAction */],
    {
      onConfirm: function onConfirm() {
        return reverseCancellation(salesOrder.get("id"));
      },
      close: close,
      open: open,
      icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "undo", fixed: true }),
      btnText: "Yes, Reverse Cancellation",
      title: "Reverse Cancellation"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "strong",
      null,
      "Heads up!"
    ),
    "\xA0 This will reverse the cancellation of this Sales Order."
  );
}

Modal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reverseCancellation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable___default.a)
};

var ifValid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["a" /* renderIf */])(function (_ref3) {
  var salesOrder = _ref3.salesOrder;
  return salesOrder.get(__WEBPACK_IMPORTED_MODULE_7__constants__["A" /* LINE_ITEMS */], []).every(function (l) {
    return !l.getIn([__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_71" /* CONSIGNMENT_TYPE */]]) && !l.get(__WEBPACK_IMPORTED_MODULE_7__constants__["_58" /* OUTRIGHT_SALE */]);
  });
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__decorators__["a" /* withSalesOrder */])(ifValid(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["e" /* toggleSwitch */])("unCancelling")(ReverseCancellation))));

/***/ }),
/* 1791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(1790);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });



/***/ }),
/* 1792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modal__ = __webpack_require__(1793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function CreateCommercialInvoice(_ref) {
  var salesOrder = _ref.salesOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hooks__["a" /* useCurrentUser */])();

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__users_helpers__["a" /* hasAnyOfSubroles */])(user, [__WEBPACK_IMPORTED_MODULE_4__users_constants__["_18" /* CREATE_COMMERCIAL_INVOICE */], __WEBPACK_IMPORTED_MODULE_4__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */], __WEBPACK_IMPORTED_MODULE_4__users_constants__["t" /* WAREHOUSE_EXPERT */]])) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["k" /* Icon */], { name: "refresh", fixed: true }),
    "\xA0Create Commercial Invoice",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modal__["a" /* Modal */], {
      salesOrder: salesOrder,
      outbound: false,
      open: visible,
      close: function close() {
        return setVisible(false);
      }
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (CreateCommercialInvoice);

CreateCommercialInvoice.propTypes = {
  shipment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_CommercialInvoice_Form__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_CommercialInvoice_Form_FormSections_LineItemsForm__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_CommercialInvoice_Form_CommercialDiscreetButton__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_Form_FormSections_SaveWarning__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_helpers__ = __webpack_require__(173);
/* harmony export (immutable) */ __webpack_exports__["a"] = Modal;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();













function Modal(_ref) {
  var salesOrder = _ref.salesOrder,
      open = _ref.open,
      close = _ref.close;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      lineItems = _useState2[0],
      setLineItems = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState4 = _slicedToArray(_useState3, 2),
      order = _useState4[0],
      setOrder = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_helpers__["e" /* COMMERCIAL_INVOICE */]),
      _useState6 = _slicedToArray(_useState5, 2),
      currentForm = _useState6[0],
      setCurrentForm = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
      _useState8 = _slicedToArray(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].salesOrders.show(salesOrder.id).then(function (resp) {
      var result = resp.data.line_items;
      setOrder(resp.data);
      setLineItems([result[0].inventory]);
      if (result.length > 1) {
        setCurrentForm(__WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_helpers__["f" /* COMMERCIAL_INVOICE_LINE_ITEMS */]);
      }
      setLoading(false);
    });

    return function cleanup() {};
  }, []);

  var invoiceInitialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_helpers__["g" /* setInvoiceInitialValues */])({
    lineItems: lineItems,
    shippingRecord: null,
    salesOrder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers__["g" /* mapSOToForm */])(order)
  });

  invoiceInitialValues.has_commercial_invoice_attachment = order.has_commercial_invoice_attachment;

  if (!order.has_commercial_invoice_attachment) {
    invoiceInitialValues.replace_pdf = true;
  }

  var addLineItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_helpers__["h" /* addLineItemsFunc */])({ setLineItems: setLineItems, setCurrentForm: setCurrentForm });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["a" /* Modal */],
    { key: order.id, open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_CommercialInvoice_Form_CommercialDiscreetButton__["a" /* default */], {
        display: currentForm === __WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_helpers__["e" /* COMMERCIAL_INVOICE */]
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Create Commercial Invoice"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Body, {
      close: close,
      addLineItems: addLineItems,
      lineItems: order.line_items,
      setCurrentForm: setCurrentForm,
      currentForm: currentForm,
      loading: loading,
      salesOrderId: salesOrder.id,
      salesOrderDetail: true,
      invoiceInitialValues: invoiceInitialValues
    })
  );
}

var Body = function Body(_ref2) {
  var addLineItems = _ref2.addLineItems,
      close = _ref2.close,
      currentForm = _ref2.currentForm,
      discreet = _ref2.discreet,
      hazmat = _ref2.hazmat,
      lineItems = _ref2.lineItems,
      loading = _ref2.loading,
      invoiceInitialValues = _ref2.invoiceInitialValues,
      salesOrderDetail = _ref2.salesOrderDetail,
      salesOrderId = _ref2.salesOrderId,
      setCurrentForm = _ref2.setCurrentForm;

  if (loading) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "animate-form-body" });
  } else if (currentForm === __WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_helpers__["f" /* COMMERCIAL_INVOICE_LINE_ITEMS */]) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_CommercialInvoice_Form_FormSections_LineItemsForm__["a" /* default */], {
      close: close,
      addLineItems: addLineItems,
      lineItems: lineItems,
      enableReinitialize: true
    });
  } else if (currentForm === __WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_helpers__["d" /* SAVE_OR_REPLACE_FORM */]) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_Form_FormSections_SaveWarning__["a" /* default */], { close: close, setCurrentForm: setCurrentForm });
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_CommercialInvoice_Form__["a" /* default */], {
    close: close,
    initialValues: invoiceInitialValues,
    hazmat: hazmat,
    discreet: discreet,
    salesOrderDetail: salesOrderDetail,
    salesOrderId: salesOrderId,
    setCurrentForm: setCurrentForm,
    enableReinitialize: true
  });
};

Body.propTypes = {
  addLineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  currentForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  discreet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  invoiceInitialValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  lineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
  lineItemsForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  salesOrderId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

Modal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shippingRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(1795);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









function Download(_ref) {
  var salesOrder = _ref.salesOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      includedItems = _useState2[0],
      setIncludedItems = _useState2[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components__["l" /* DropDownItem */],
        { onClick: open },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: "download", fixed: true }),
        "\xA0Print All CoCs",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
          { open: visible, close: close, dialogClass: "modal-md" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "CoC Obtained From"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["e" /* Body */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Form__["a" /* default */], {
              salesOrder: salesOrder,
              close: close,
              includedItems: includedItems,
              setIncludedItems: setIncludedItems
            })
          )
        )
      );
    }
  );
}

Download.propTypes = {
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withSalesOrder */])(Download));

/***/ }),
/* 1795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_submission_constants__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_formik__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormikFormInput_FormInput__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_FormikForm_FormikFooter__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_arrays__ = __webpack_require__(129);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      results: []
    }, _this.onItemSelected = function (id) {
      var items = _this.props.includedItems.slice(0);
      if (items.includes(id)) {
        items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_arrays__["d" /* remove */])(items, id);
      } else {
        items.push(id);
      }
      _this.props.setIncludedItems(items);
    }, _this.allItemsSelected = function (values) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEqual"])(_this.props.includedItems.sort(), values.coc.map(function (l) {
        return l.sales_order_line_item_id;
      }).sort());
    }, _this.selectAll = function (values) {
      if (_this.allItemsSelected(values)) {
        _this.props.setIncludedItems([]);
      } else {
        _this.props.setIncludedItems(values.coc.map(function (l) {
          return l.sales_order_line_item_id;
        }));
      }
    }, _this.fetch = function (setValues) {
      return function (id) {
        return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].salesOrders.cocSearch(id).then(function (_ref2) {
          var data = _ref2.data;

          _this.props.setIncludedItems(data.results.map(function (l) {
            return l.sales_order_line_item_id;
          }));
          setValues({ coc: data.results });
          return __WEBPACK_IMPORTED_MODULE_7__lib_submission_constants__["a" /* SUCCESS */];
        });
      };
    }, _this.renderCompanyLink = function (item) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["w" /* CompanyName */], { flattenedCompany: item })
      );
    }, _this.renderResultRow = function (item, idx) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: item.sales_order_line_item_id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            type: "checkbox",
            className: "radio-inline",
            checked: _this.props.includedItems.includes(item.sales_order_line_item_id),
            onClick: function onClick() {
              return _this.onItemSelected(item.sales_order_line_item_id);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(item, "record_type"),
          "-",
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(item, "code")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["w" /* CompanyName */], { flattenedCompany: item, truncateAt: 20 })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormikFormInput_FormInput__["a" /* FormInput */], { name: "coc[" + idx + "].obtained_from" })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.loading) return null;

      var _props = this.props,
          includedItems = _props.includedItems,
          salesOrder = _props.salesOrder,
          onSubmit = _props.onSubmit;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_formik__["b" /* Formik */],
        {
          initialValues: {
            coc: [],
            sellersContractNumber: this.props.salesOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["z" /* CODE */])
          },
          onSubmit: onSubmit
        },
        function (_ref3) {
          var isSubmitting = _ref3.isSubmitting,
              values = _ref3.values,
              setSubmitting = _ref3.setSubmitting,
              handleSubmit = _ref3.handleSubmit,
              setValues = _ref3.setValues,
              rest = _objectWithoutProperties(_ref3, ["isSubmitting", "values", "setSubmitting", "handleSubmit", "setValues"]);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__shared_containers__["d" /* AgnosticLoader */],
              {
                fetch: _this2.fetch(setValues),
                id: salesOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["b" /* ID */])
              },
              function (_ref4) {
                var loading = _ref4.loading;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */],
                  { loading: loading, loadingRows: 1 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Head,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "th",
                      { className: "text-center" },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                        name: "line_items",
                        type: "checkbox",
                        onClick: function onClick() {
                          return _this2.selectAll(values);
                        },
                        checked: includedItems.length > 0 && _this2.allItemsSelected(values)
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "th",
                      null,
                      "Code"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "th",
                      null,
                      "Company Name"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "th",
                      null,
                      "Obtained From"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Body,
                    null,
                    values.coc.map(_this2.renderResultRow)
                  )
                );
              }
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["q" /* FormRow */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                { md: 4 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    {
                      className: "control-label",
                      htmlFor: "sellers_contract_number"
                    },
                    "Seller's Contract #:"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_formik__["a" /* Field */], {
                    type: "text",
                    name: "sellers_contract_number",
                    className: "form-control"
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_FormikForm_FormikFooter__["a" /* FormikFooter */], {
              rest: rest,
              setSubmitting: setSubmitting,
              isSubmitting: isSubmitting,
              isValid: rest.isValid,
              values: {
                coc: values.coc.filter(function (l) {
                  return includedItems.includes(l.sales_order_line_item_id);
                })
              },
              handleSubmit: handleSubmit,
              close: _this2.props.close,
              text: "Download CoC"
            })
          );
        }
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.required,
  salesItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map)
};


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(params) {
      params.coc = params.coc.filter(function (coc) {
        return ownProps.includedItems.includes(coc.sales_order_line_item_id);
      });
      var id = ownProps.salesOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["b" /* ID */]);
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].salesOrders.createCoc(id, params).then(function (_ref5) {
        var data = _ref5.data;

        var url = __WEBPACK_IMPORTED_MODULE_9__constants__["d" /* API_BASE */] + "//sales_orders/" + id + "/download_certificate_of_conformance?cache_key=" + data.cache_key;
        window.open(url, "_blank");
      });

      ownProps.close();
    }
  };
})(Form));

/***/ }),
/* 1796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_DownloadPackingSlipModal_DownloadPackingSlipModal__ = __webpack_require__(777);
/* unused harmony export DownloadDiscreetPackingSlip */












function DownloadDiscreetPackingSlip(_ref) {
  var close = _ref.close,
      downloading = _ref.downloading,
      open = _ref.open,
      salesOrder = _ref.salesOrder,
      url = _ref.url;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["b" /* Authorized */],
    {
      roles: [__WEBPACK_IMPORTED_MODULE_6__users_constants__["p" /* QUALITY_CONTROL */]],
      authorizedIf: function authorizedIf() {
        return salesOrder.discreet === true && !salesOrder.accounting_hold && !salesOrder.line_items.some(function (f) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(f, [__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_31" /* STATUS */]].join(".")) === __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_42" /* DISCREPANCY_REPORTED */] || [__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["T" /* UNDER_REVIEW */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["S" /* QC_HOLD */]].includes(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(f, [__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_63" /* QC_STATUS */]].join(".")));
        });
      }
    },
    salesOrder.line_items.size > 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_DropDown_DropDownItem__["a" /* default */],
      {
        onClick: open,
        faIcon: "file-text-o",
        label: "Download Discreet Packing Slip"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_DownloadPackingSlipModal_DownloadPackingSlipModal__["a" /* default */], {
        partKey: "part.part_number",
        record: salesOrder.toJS(),
        open: downloading,
        close: close,
        url: url
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["k" /* Icon */], { name: "file-text-o", fixed: true }),
      "\xA0Download Discreet Packing Slip"
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "li",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components__["r" /* ExternalLink */],
        { url: url },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["k" /* Icon */], { name: "file-text-o", fixed: true }),
        "\xA0Download Discreet Packing Slip"
      )
    )
  );
}

DownloadDiscreetPackingSlip.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  downloading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var withUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var salesOrder = _ref2.salesOrder;
  return {
    url: __WEBPACK_IMPORTED_MODULE_7__constants__["d" /* API_BASE */] + "/sales_orders/" + salesOrder.id + "/download_packing_slip?discreet=true"
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withUrl(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["e" /* toggleSwitch */])("downloading")(DownloadDiscreetPackingSlip)));

/***/ }),
/* 1797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_DownloadPackingSlipModal_DownloadPackingSlipModal__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DownloadPackingSlip_DownloadPackingSlip__ = __webpack_require__(1798);
/* unused harmony export DownloadPackingSlip */














function DownloadPackingSlip(_ref) {
  var close = _ref.close,
      salesOrder = _ref.salesOrder,
      url = _ref.url,
      open = _ref.open,
      downloading = _ref.downloading;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["b" /* Authorized */],
    {
      permissions: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["_19" /* CREATE_PACKING_SLIP */]],
      roles: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["p" /* QUALITY_CONTROL */]],
      subroles: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["t" /* WAREHOUSE_EXPERT */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["s" /* WAREHOUSE_MANAGER */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]],
      authorizedIf: function authorizedIf(user) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__users_helpers__["d" /* hasRole */])(user.toJS(), __WEBPACK_IMPORTED_MODULE_7__users_constants__["l" /* REPAIR */]) && !salesOrder.accounting_hold && !salesOrder.line_items.some(function (f) {
          return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(f, [__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_31" /* STATUS */]].join(".")) === __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_42" /* DISCREPANCY_REPORTED */] || [__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["T" /* UNDER_REVIEW */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["S" /* QC_HOLD */]].includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(f, [__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_63" /* QC_STATUS */]].join(".")));
        });
      }
    },
    salesOrder.line_items.length > 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__shared_components_DropDown_DropDownItem__["a" /* default */],
      {
        onClick: open,
        faIcon: "file-text-o",
        label: "Download Packing Slip"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_DownloadPackingSlipModal_DownloadPackingSlipModal__["a" /* default */], {
        partKey: "part.part_number",
        record: salesOrder,
        open: downloading,
        close: close,
        url: url
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["k" /* Icon */], { name: "file-text-o", fixed: true }),
      "\xA0Download Packing Slip"
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__DownloadPackingSlip_DownloadPackingSlip__["a" /* default */], null)
  );
}

DownloadPackingSlip.propTypes = {
  downloading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])
};

var withUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var salesOrder = _ref2.salesOrder;
  return {
    url: __WEBPACK_IMPORTED_MODULE_6__constants__["d" /* API_BASE */] + "/sales_orders/" + salesOrder.id + "/download_packing_slip?discreet=false"
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withUrl(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["e" /* toggleSwitch */])("downloading")(DownloadPackingSlip)));

/***/ }),
/* 1798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DownloadUrl__ = __webpack_require__(1799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__decorators_withSalesOrder__ = __webpack_require__(329);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();












function DownloadPackingSlip(_ref) {
  var salesOrder = _ref.salesOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
      _useState2 = _slicedToArray(_useState, 2),
      includeSoldTo = _useState2[0],
      setIncludeSoldTo = _useState2[1];

  var labelClasses = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-default", {
    active: includeSoldTo
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components__["l" /* DropDownItem */],
        { onClick: open },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["k" /* Icon */], { name: "file-text-o", fixed: true }),
        "\xA0Download Packing Slip",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["a" /* Modal */],
          { open: visible, close: close, dialogClass: "modal-sm" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Download Packing Slip"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["e" /* Body */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h3",
              { style: { textAlign: "center" } },
              "Include Sold To Company On Packing Slip?"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { width: "40%", margin: "0 auto" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    className: "btn-group btn-group-justified",
                    "data-toggle": "buttons"
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    { htmlFor: "sold_to", className: labelClasses },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                      type: "checkbox",
                      id: "sold_to",
                      checked: includeSoldTo,
                      onChange: function onChange() {
                        setIncludeSoldTo(!includeSoldTo);
                      }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
                    "\xA0\xA0Include Sold To"
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["d" /* Footer */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__DownloadUrl__["a" /* default */], {
              salesOrder: salesOrder,
              includeSoldTo: includeSoldTo,
              close: close
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
              { onClick: close },
              "Cancel"
            )
          )
        )
      );
    }
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__decorators_withSalesOrder__["a" /* default */])(DownloadPackingSlip));

DownloadPackingSlip.propTypes = {
  salesOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]).isRequired
};

/***/ }),
/* 1799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






function DownloadUrl(_ref) {
  var close = _ref.close,
      salesOrder = _ref.salesOrder,
      includeSoldTo = _ref.includeSoldTo;

  var downloadUrl = __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* API_BASE */] + "/sales_orders/" + salesOrder.get("id") + "/download_packing_slip?discreet=false";

  var params = {
    include_sold_to: includeSoldTo
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* Button */],
    {
      bsStyle: "primary",
      onClick: function onClick() {
        window.open(downloadUrl + "&" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_query_string__["stringify"])(params), "_blank");
        close();
      }
    },
    "Download"
  );
}

DownloadUrl.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  salesOrder: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(Map)
};

/* harmony default export */ __webpack_exports__["a"] = (DownloadUrl);

/***/ }),
/* 1800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DownloadUrl__ = __webpack_require__(1801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__decorators_withSalesOrder__ = __webpack_require__(329);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();













function DownloadProForma(_ref) {
  var salesOrder = _ref.salesOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
      _useState2 = _slicedToArray(_useState, 2),
      processingFee = _useState2[0],
      setProcessingFee = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      chargeType = _useState4[0],
      setChargeType = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState6 = _slicedToArray(_useState5, 2),
      chargeValue = _useState6[0],
      setChargeValue = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState8 = _slicedToArray(_useState7, 2),
      note = _useState8[0],
      setNote = _useState8[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components__["l" /* DropDownItem */],
        { onClick: open },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["k" /* Icon */], { name: "dollar", fixed: true }),
        "\xA0Download Pro Forma",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["a" /* Modal */],
          { open: visible, close: close, dialogClass: "modal-sm" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Download Pro Forma"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["e" /* Body */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h3",
              { style: { textAlign: "center" } },
              "Include processing fee?"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { width: "33%", margin: "0 auto" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { htmlFor: "processing-fee" },
                "optional"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "input-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    { className: "input-group-addon" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-dollar" })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                    type: "number",
                    className: "form-control",
                    value: processingFee,
                    onChange: function onChange(ev) {
                      return setProcessingFee(ev.target.value);
                    }
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h3",
              { style: { textAlign: "center" } },
              "Include Additional Charges?"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { width: "100%", margin: "0 auto" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    { htmlFor: "charge-type" },
                    "Charge Type"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "div",
                      { className: "input-group" },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                        type: "text",
                        className: "form-control",
                        value: chargeType,
                        onChange: function onChange(ev) {
                          return setChargeType(ev.target.value);
                        }
                      })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "label",
                    { htmlFor: "charge-value" },
                    "Charge Value"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "div",
                      { className: "input-group" },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "span",
                        { className: "input-group-addon" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-dollar" })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                        type: "number",
                        className: "form-control",
                        value: chargeValue,
                        onChange: function onChange(ev) {
                          return setChargeValue(ev.target.value);
                        }
                      })
                    )
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h3",
              { style: { textAlign: "center" } },
              "Add note?"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { width: "70%", margin: "0 auto" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { htmlFor: "note" },
                "optional"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "input-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", {
                    className: "form-control",
                    rows: 3,
                    cols: 50,
                    value: note,
                    onChange: function onChange(ev) {
                      return setNote(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_text__["e" /* truncate */])(ev.target.value, 100, ""));
                    }
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["d" /* Footer */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
              { onClick: close },
              "Cancel"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DownloadUrl__["a" /* default */], {
              close: close,
              chargeType: chargeType,
              chargeValue: chargeValue,
              salesOrder: salesOrder,
              note: note,
              processingFee: processingFee
            })
          )
        )
      );
    }
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__decorators_withSalesOrder__["a" /* default */])(DownloadProForma));

DownloadProForma.propTypes = {
  salesOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]).isRequired
};

/***/ }),
/* 1801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);







function DownloadUrl(_ref) {
  var close = _ref.close,
      note = _ref.note,
      salesOrder = _ref.salesOrder,
      processingFee = _ref.processingFee,
      chargeType = _ref.chargeType,
      chargeValue = _ref.chargeValue;

  var downloadUrl = __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* API_BASE */] + "/sales_orders/" + salesOrder.get("id") + "/download";

  var params = {
    pro_forma: true
  };

  if (Number(processingFee) > 0) {
    params.processing_fee = processingFee;
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(note)) {
    params.note = note;
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(chargeType) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(chargeValue)) {
    params.charge_type = chargeType;
    params.charge_value = chargeValue;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["i" /* Button */],
    {
      bsStyle: "primary",
      onClick: function onClick() {
        window.open(downloadUrl + "?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_query_string__["stringify"])(params), "_blank");
        close();
      }
    },
    "Download"
  );
}

DownloadUrl.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  note: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  processingFee: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  salesOrder: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(Map)
};

/* harmony default export */ __webpack_exports__["a"] = (DownloadUrl);

/***/ }),
/* 1802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Orders_shared_EditInvoiceDetailsForm__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RepairOrders_constants__ = __webpack_require__(28);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var coreRepairCharge = function coreRepairCharge(lineItem) {
  var originalEval = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, ["most_recent_repair_item", __WEBPACK_IMPORTED_MODULE_10__RepairOrders_constants__["I" /* ORIGINAL_EVALUATION */]].join("."), 0);

  var adminFee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, __WEBPACK_IMPORTED_MODULE_9__constants__["_3" /* REPAIR_ADMINISTRATION_FEE */], 0);

  return Number(originalEval) + Number(adminFee);
};

function EditInvoiceDetails(_ref) {
  var salesOrder = _ref.salesOrder;

  salesOrder.line_items = salesOrder.line_items.map(function (lineItem) {
    var _extends2;

    return _extends({}, lineItem, (_extends2 = {}, _defineProperty(_extends2, __WEBPACK_IMPORTED_MODULE_9__constants__["_4" /* CORE_REPAIR_INVOICE_AMOUNT_PAID */], lineItem[__WEBPACK_IMPORTED_MODULE_9__constants__["_5" /* BROKERED_EXCHANGE */]] || lineItem[__WEBPACK_IMPORTED_MODULE_9__constants__["e" /* FLAT_EXCHANGE */]] ? salesOrder[__WEBPACK_IMPORTED_MODULE_9__constants__["_4" /* CORE_REPAIR_INVOICE_AMOUNT_PAID */]] : coreRepairCharge(lineItem)), _defineProperty(_extends2, __WEBPACK_IMPORTED_MODULE_9__constants__["v" /* PAID_IN_FULL */], Number(lineItem.amount_paid) === Number(lineItem.subtotal)), _extends2));
  });

  if (salesOrder.line_items.filter(function (l) {
    return !l.cancelled || l.shipped;
  }).length === 0) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_containers__["a" /* ToggleSwitch */],
    null,
    function (visible, open, close) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components__["l" /* DropDownItem */],
        { onClick: open },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["k" /* Icon */], { name: "dollar", fixed: true }),
        "\xA0Edit Billing",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["a" /* Modal */],
          { open: visible, close: close, dialogClass: "modal-lg" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Modal__["c" /* Close */], { close: close }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Edit Billing Details"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Orders_shared_EditInvoiceDetailsForm__["a" /* EditInvoiceDetailsForm */], {
            close: close,
            orderType: __WEBPACK_IMPORTED_MODULE_9__constants__["_6" /* SALES_ORDER */],
            displaySerial: true,
            order: salesOrder,
            initialValues: Object.assign(salesOrder, {
              invoice_paid_date: null,
              invoice_number: null
            }),
            includeCancelled: true,
            bulkUpdate: __WEBPACK_IMPORTED_MODULE_7__actions__["p" /* bulkUpdateLineItems */]
          })
        )
      );
    }
  );
}

/* harmony default export */ __webpack_exports__["a"] = (EditInvoiceDetails);

EditInvoiceDetails.propTypes = {
  salesOrder: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]).isRequired
};

/***/ }),
/* 1803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__users_constants__ = __webpack_require__(13);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();














function ExportHold(_ref) {
  var onConfirm = _ref.onConfirm,
      salesOrder = _ref.salesOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  if (salesOrder.get(__WEBPACK_IMPORTED_MODULE_8__Receiving_constants__["P" /* EXPORT_HOLD */])) {
    return null;
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__users_helpers__["i" /* hasAnyOfRolesOrSubroles */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__hooks__["a" /* useCurrentUser */])(), [__WEBPACK_IMPORTED_MODULE_11__users_constants__["p" /* QUALITY_CONTROL */]], [__WEBPACK_IMPORTED_MODULE_11__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]])) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: "pause", fixed: true }),
    "\xA0Place on Denied Party Hold",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setVisible(false);
        },
        open: visible,
        btnText: "Place on Denied Party Hold",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-pause" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to place on Denied Party Hold?"
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onConfirm: function onConfirm() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* update */])({ export_hold: true }));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__decorators__["a" /* withSalesOrder */])(ExportHold)));

ExportHold.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__users_constants__ = __webpack_require__(13);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();














function NewCompanyHold(_ref) {
  var onConfirm = _ref.onConfirm,
      salesOrder = _ref.salesOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  if (!salesOrder.get(__WEBPACK_IMPORTED_MODULE_8__Receiving_constants__["Q" /* NEW_COMPANY_HOLD */])) {
    return null;
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__users_helpers__["i" /* hasAnyOfRolesOrSubroles */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__hooks__["a" /* useCurrentUser */])(), [__WEBPACK_IMPORTED_MODULE_11__users_constants__["p" /* QUALITY_CONTROL */]], [__WEBPACK_IMPORTED_MODULE_11__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]])) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: "check", fixed: true }),
    "\xA0Remove New Cust. Hold",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setVisible(false);
        },
        open: visible,
        btnText: "Remove New Cust. Hold",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-pause" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to remove the New Customer Hold?"
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onConfirm: function onConfirm() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* update */])({ new_company_hold: false }));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__decorators__["a" /* withSalesOrder */])(NewCompanyHold)));

NewCompanyHold.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(32);
/* unused harmony export Release */








function Release(_ref) {
  var hold = _ref.hold,
      releasing = _ref.releasing,
      open = _ref.open,
      close = _ref.close,
      release = _ref.release;

  return hold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["i" /* ConfirmAction */],
      {
        key: "confirm",
        open: releasing,
        close: close,
        btnText: "Release",
        onConfirm: release
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0Release SO from Accounting hold?"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["k" /* Icon */], { name: "play", fixed: true }),
    "\xA0Release From Accounting Hold"
  );
}

Release.propTypes = {
  hold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  releasing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  release: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var salesOrder = _ref2.salesOrder,
      updateSalesOrder = _ref2.updateSalesOrder;
  return {
    release: function release() {
      return updateSalesOrder({ accounting_hold: false });
    },
    hold: salesOrder.get(__WEBPACK_IMPORTED_MODULE_6__constants__["u" /* ACCOUNTING_HOLD */])
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withSalesOrder */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["e" /* toggleSwitch */])("releasing")(withProps(Release))));

/***/ }),
/* 1806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(32);
/* unused harmony export ReleaseExchangeAgreementHold */








function ReleaseExchangeAgreementHold(_ref) {
  var hold = _ref.hold,
      releasing = _ref.releasing,
      open = _ref.open,
      close = _ref.close,
      release = _ref.release;

  return hold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["i" /* ConfirmAction */],
      {
        key: "confirm",
        open: releasing,
        close: close,
        btnText: "Release",
        onConfirm: release
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0Release SO from Exchange Agreement hold?"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["k" /* Icon */], { name: "play", fixed: true }),
    "\xA0Release From Exchange Agreement Hold"
  );
}

ReleaseExchangeAgreementHold.propTypes = {
  hold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  releasing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  release: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var salesOrder = _ref2.salesOrder,
      updateSalesOrder = _ref2.updateSalesOrder;
  return {
    release: function release() {
      return updateSalesOrder({ exchange_agreement_hold: false });
    },
    hold: salesOrder.get(__WEBPACK_IMPORTED_MODULE_6__constants__["_2" /* EXCHANGE_AGREEMENT_HOLD */])
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withSalesOrder */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["e" /* toggleSwitch */])("releasing")(withProps(ReleaseExchangeAgreementHold))));

/***/ }),
/* 1807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Receiving_constants__ = __webpack_require__(34);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();











function RemoveExportHold(_ref) {
  var onConfirm = _ref.onConfirm,
      salesOrder = _ref.salesOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  if (!salesOrder.get(__WEBPACK_IMPORTED_MODULE_8__Receiving_constants__["P" /* EXPORT_HOLD */])) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: "check", fixed: true }),
    "\xA0Remove Denied Party Hold",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setVisible(false);
        },
        open: visible,
        btnText: "Remove Denied Party Hold",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to remove the Denied Party Hold?"
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onConfirm: function onConfirm() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* update */])({ export_hold: false }));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__decorators__["a" /* withSalesOrder */])(RemoveExportHold)));

RemoveExportHold.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__inventories_constants__ = __webpack_require__(12);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();















function Sync(_ref) {
  var onConfirm = _ref.onConfirm,
      salesOrder = _ref.salesOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      settings = _useState4[0],
      setSettings = _useState4[1];

  var locationId = salesOrder.getIn([__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["_73" /* STORE_OWNER */], __WEBPACK_IMPORTED_MODULE_9__constants__["b" /* ID */]]);
  if (!locationId) return null;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].locations.locationSetting.quickbooksLocationSetting(locationId).then(function (_ref2) {
      var data = _ref2.data;

      setSettings(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(data, "settings.quickbooks", {}));

      return function cleanup() {};
    });
  }, []);

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(settings, "ar_account")) {
    return null;
  }

  if (salesOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_46" /* DISABLE_QB_SYNC */])) {
    return null;
  }

  var syncDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(settings, "sync_date");
  var createdAt = __WEBPACK_IMPORTED_MODULE_10_moment___default()(salesOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_7" /* CREATED_AT */]));

  if (syncDate && __WEBPACK_IMPORTED_MODULE_10_moment___default()(syncDate) > __WEBPACK_IMPORTED_MODULE_10_moment___default()(createdAt.format("YYYY-MM-DD"))) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "refresh", fixed: true }),
    "\xA0Sync Accounting",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setVisible(false);
        },
        open: visible,
        btnText: "Yes, Sync w/ Quickbooks",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-refresh" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to sync the SO?",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        "Please ensure the Customer has a linked account for the store location."
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onConfirm: function onConfirm() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["o" /* sync */])());
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__decorators__["a" /* withSalesOrder */])(Sync)));

Sync.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inventories_constants__ = __webpack_require__(12);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();














function SyncCoreRepairCharges(_ref) {
  var onConfirm = _ref.onConfirm,
      salesOrder = _ref.salesOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      settings = _useState4[0],
      setSettings = _useState4[1];

  var locationId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(salesOrder, [__WEBPACK_IMPORTED_MODULE_11__inventories_constants__["_74" /* STORE_LOCATION */], __WEBPACK_IMPORTED_MODULE_8__constants__["b" /* ID */]].join("."));
  if (!locationId) return null;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].locations.locationSetting.quickbooksLocationSetting(locationId).then(function (_ref2) {
      var data = _ref2.data;

      setSettings(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(data, "settings.quickbooks", {}));

      return function cleanup() {};
    });
  }, []);

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(settings, "ar_account")) {
    return null;
  }

  var syncDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(settings, "sync_date");
  var createdAt = __WEBPACK_IMPORTED_MODULE_9_moment___default()(salesOrder.created_at);

  if (salesOrder.line_items.filter(function (l) {
    return Number(l.repair_administration_fee) > 0;
  }).length === 0) {
    return null;
  }

  if (syncDate && __WEBPACK_IMPORTED_MODULE_9_moment___default()(syncDate) > __WEBPACK_IMPORTED_MODULE_9_moment___default()(createdAt.format("YYYY-MM-DD"))) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "refresh", fixed: true }),
    "\xA0Sync Core Repair Charges",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setVisible(false);
        },
        open: visible,
        btnText: "Yes, Sync w/ Quickbooks",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-refresh" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to sync the SO?",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        "Please ensure the Customer has a linked account for the store location."
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onConfirm: function onConfirm() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["n" /* syncCoreRepairCharges */])());
    }
  };
})(SyncCoreRepairCharges));

SyncCoreRepairCharges.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
















function ToggleQuickbooksSync(_ref) {
  var onConfirm = _ref.onConfirm,
      salesOrder = _ref.salesOrder;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      settings = _useState4[0],
      setSettings = _useState4[1];

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__users_helpers__["c" /* hasAnyOfRoles */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks__["a" /* useCurrentUser */])(), [__WEBPACK_IMPORTED_MODULE_9__users_constants__["m" /* ACCOUNTING */]])) {
    return null;
  }

  var locationId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(salesOrder, "store_location.id");
  var createdAt = salesOrder.created_at;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].locations.locationSetting.show(locationId).then(function (_ref2) {
      var data = _ref2.data;

      setSettings(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(data, "settings.quickbooks", {}));

      return function cleanup() {};
    });
  }, [locationId, createdAt]);

  var syncDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_12__constants__["_47" /* SYNC_DATE */]);

  if (!syncDate) return null;

  if (syncDate && __WEBPACK_IMPORTED_MODULE_13_moment___default()(syncDate) <= __WEBPACK_IMPORTED_MODULE_13_moment___default()(createdAt).format("YYYY-MM-DD")) {
    return null;
  }

  var quickbooksDisabled = salesOrder.disable_qb_sync;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setVisible(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: quickbooksDisabled ? "play" : "pause", fixed: true }),
    "\xA0",
    quickbooksDisabled ? "Enable QB Sync" : "Disable QB Sync",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setVisible(false);
        },
        open: visible,
        btnText: quickbooksDisabled ? "Enable QB Sync" : "Disable QB Sync",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-pause" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to",
      " ",
      quickbooksDisabled ? "enable QB Sync" : "disable QB Sync",
      "?"
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onConfirm: function onConfirm() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* update */])({ disable_qb_sync: !ownProps.salesOrder.disable_qb_sync }));
    }
  };
})(ToggleQuickbooksSync));

ToggleQuickbooksSync.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Actions__ = __webpack_require__(1785);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Actions__["a"]; });



/***/ }),
/* 1812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Notes__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Attachments__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_SpecialInstructions__ = __webpack_require__(1926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LineItems_RmaRequest__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__LineItems__ = __webpack_require__(1877);
/* unused harmony export Body */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var Body = function (_Component) {
  _inherits(Body, _Component);

  function Body() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Body);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Body.__proto__ || Object.getPrototypeOf(Body)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      lineItem: null
    }, _this.openRma = function (lineItem) {
      _this.setState({ lineItem: lineItem });
      _this.props.open();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Body, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          creatingRmaRequest = _props.creatingRmaRequest,
          salesOrder = _props.salesOrder,
          close = _props.close;
      var lineItem = this.state.lineItem;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "col-md-9" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__LineItems__["a" /* default */], {
          salesOrder: salesOrder,
          openRma: this.openRma,
          company: salesOrder.company
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Notes__["a" /* default */], {
              resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(salesOrder),
              resourceType: __WEBPACK_IMPORTED_MODULE_5__shared_types_resourceTypes__["a" /* default */].salesOrder
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Notes__["a" /* default */], {
              headerLabel: "Accounting Notes",
              resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(salesOrder),
              resourceType: __WEBPACK_IMPORTED_MODULE_5__shared_types_resourceTypes__["a" /* default */].salesOrder,
              notesType: "accounting"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_SpecialInstructions__["a" /* SpecialInstructions */], {
          resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(salesOrder),
          resourceType: __WEBPACK_IMPORTED_MODULE_5__shared_types_resourceTypes__["a" /* default */].salesOrder
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Attachments__["a" /* default */], {
          attachmentTypes: __WEBPACK_IMPORTED_MODULE_6__constants__["s" /* ATTACHMENT_TYPES */],
          resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(salesOrder),
          resourceType: __WEBPACK_IMPORTED_MODULE_5__shared_types_resourceTypes__["a" /* default */].salesOrder,
          resourceKey: "company",
          multiple: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__LineItems_RmaRequest__["a" /* RmaRequestModal */], {
          open: creatingRmaRequest,
          close: close,
          lineItem: lineItem
        })
      );
    }
  }]);

  return Body;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Body.propTypes = {
  creatingRmaRequest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators__["e" /* toggleSwitch */])("creatingRmaRequest")(Body));

/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_form__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Reason__ = __webpack_require__(1864);
/* unused harmony export Cancel */














function Cancel(_ref) {
  var salesOrder = _ref.salesOrder,
      cancel = _ref.cancel,
      cancelling = _ref.cancelling,
      open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
    "\xA0Cancel Line Item",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Reason__["a" /* default */], {
      salesOrder: salesOrder.toJS(),
      visible: cancelling,
      onSubmit: cancel,
      close: close
    })
  );
}

Cancel.propTypes = {
  cancel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  cancelling: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  salesOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])
};

var withCancel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var lineItem = _ref2.lineItem,
      salesOrder = _ref2.salesOrder,
      refresh = _ref2.refresh,
      expireLineItems = _ref2.expireLineItems,
      close = _ref2.close;
  return {
    cancel: function cancel(reason, sendEmail) {
      return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].salesOrders.lineItems.cancel(lineItem.id, reason, sendEmail).then(function () {
        return refresh(salesOrder.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */])).then(function () {
          expireLineItems();
          close();
        });
      }).catch(function (submitErr) {
        if (submitErr && submitErr.errors) {
          var msg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["b" /* toSentence */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_form__["b" /* submitErrorMsgs */])(submitErr.errors));
          __WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__["toastr"].error("Error", msg);
        } else {
          throw submitErr;
        }
      });
    }
  };
});

var meetsCancellationCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["a" /* renderIf */])(function (_ref3) {
  var _ref3$lineItem = _ref3.lineItem,
      cancelled = _ref3$lineItem.cancelled,
      consignmentType = _ref3$lineItem.inventory.consignment_type;
  return !cancelled && ![__WEBPACK_IMPORTED_MODULE_6__Receiving_constants__["s" /* EMA */], __WEBPACK_IMPORTED_MODULE_6__Receiving_constants__["t" /* CONSIGNMENT */]].includes(consignmentType);
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withSalesOrder */])(meetsCancellationCriteria(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["e" /* toggleSwitch */])("cancelling")(withCancel(Cancel)))));

/***/ }),
/* 1814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Receiving_constants__ = __webpack_require__(34);
/* unused harmony export CancelConsignment */











function CancelConsignment(_ref) {
  var cancel = _ref.cancel,
      cancelling = _ref.cancelling,
      open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components__["l" /* DropDownItem */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components__["k" /* Icon */], { name: "ban", fixed: true }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "with-padding" },
      "Cancel Consignment Sale"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components__["i" /* ConfirmAction */],
      { onConfirm: cancel, close: close, open: cancelling },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up! "
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        "Are you sure you want to cancel this consignment sale?"
      )
    )
  );
}

CancelConsignment.propTypes = {
  cancel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  cancelling: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

var withOutrightCancellation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var _ref2$lineItem = _ref2.lineItem,
      itemId = _ref2$lineItem.id,
      salesOrderId = _ref2$lineItem.sales_order_id,
      commissionPaid = _ref2$lineItem.commission_paid,
      close = _ref2.close,
      expireLineItems = _ref2.expireLineItems,
      refresh = _ref2.refresh;
  return {
    cancel: function cancel() {
      if (commissionPaid) {
        return __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__["toastr"].error("Commission Paid", "Commission for Consignment is paid. Sale cannot be cancelled.");
      }
      return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].salesOrders.lineItems.cancelConsignment(itemId).then(function () {
        refresh(salesOrderId).then(function () {
          expireLineItems();
          close();
        });
      });
    }
  };
});

var meetsCancellationCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["a" /* renderIf */])(function (_ref3) {
  var _ref3$lineItem = _ref3.lineItem,
      cancelled = _ref3$lineItem.cancelled,
      createdById = _ref3$lineItem.created_by_id,
      outrightSale = _ref3$lineItem.outright_sale,
      internalOutright = _ref3$lineItem.internal_outright,
      consignmentType = _ref3$lineItem.inventory.consignment_type,
      _ref3$currentUser = _ref3.currentUser,
      role = _ref3$currentUser.role,
      userId = _ref3$currentUser.id;
  return ([__WEBPACK_IMPORTED_MODULE_8__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["m" /* ACCOUNTING */]].includes(role) || createdById === userId) && !cancelled && !outrightSale && !internalOutright && [__WEBPACK_IMPORTED_MODULE_9__Receiving_constants__["t" /* CONSIGNMENT */], __WEBPACK_IMPORTED_MODULE_9__Receiving_constants__["s" /* EMA */]].includes(consignmentType);
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withSalesOrder */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["e" /* toggleSwitch */])("cancelling")(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__session_decorators_withCurrentUser__["b" /* default */])(withOutrightCancellation(meetsCancellationCriteria(CancelConsignment))))));

/***/ }),
/* 1815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_redux_toastr__);
/* unused harmony export CancelOutrightSale */











function CancelOutrightSale(_ref) {
  var cancel = _ref.cancel,
      cancelling = _ref.cancelling,
      open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["l" /* DropDownItem */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "ban", fixed: true }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "with-padding" },
      "Cancel Outright Sale"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["i" /* ConfirmAction */],
      { onConfirm: cancel, close: close, open: cancelling },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up! "
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        "Are you sure you want to cancel this outright sale?"
      )
    )
  );
}

CancelOutrightSale.propTypes = {
  cancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cancelling: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var withOutrightCancellation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var _ref2$lineItem = _ref2.lineItem,
      itemId = _ref2$lineItem.id,
      salesOrderId = _ref2$lineItem.sales_order_id,
      commissionPaid = _ref2$lineItem.commission_paid,
      close = _ref2.close,
      expireLineItems = _ref2.expireLineItems,
      refresh = _ref2.refresh;
  return {
    cancel: function cancel() {
      if (commissionPaid) {
        return __WEBPACK_IMPORTED_MODULE_9_react_redux_toastr__["toastr"].error("Commission Paid", "Commission for Outright Sale is paid. Sale cannot be cancelled.");
      }
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].salesOrders.lineItems.cancelOutrightSale(itemId).then(function () {
        refresh(salesOrderId).then(function () {
          expireLineItems();
          close();
        });
      });
    }
  };
});

var meetsCancellationCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["a" /* renderIf */])(function (_ref3) {
  var _ref3$lineItem = _ref3.lineItem,
      cancelled = _ref3$lineItem.cancelled,
      createdById = _ref3$lineItem.created_by_id,
      outrightSale = _ref3$lineItem.outright_sale,
      _ref3$lineItem$invent = _ref3$lineItem.inventory,
      repairStatus = _ref3$lineItem$invent.repair_status,
      status = _ref3$lineItem$invent.status,
      _ref3$currentUser = _ref3.currentUser,
      role = _ref3$currentUser.role,
      userId = _ref3$currentUser.id;
  return ([__WEBPACK_IMPORTED_MODULE_8__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["m" /* ACCOUNTING */]].includes(role) || createdById === userId) && !cancelled && (status === __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_33" /* GONE */] || repairStatus === __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_37" /* EXCHANGE_GONE_OUTRIGHT */]) && outrightSale;
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__decorators__["a" /* withSalesOrder */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["e" /* toggleSwitch */])("cancelling")(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["b" /* default */])(withOutrightCancellation(meetsCancellationCriteria(CancelOutrightSale))))));

/***/ }),
/* 1816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CancelOutrightSale__ = __webpack_require__(1815);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CancelOutrightSale__["a"]; });



/***/ }),
/* 1817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__decorators__ = __webpack_require__(55);
/* unused harmony export CancelSubsequentExchange */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













function CancelSubsequentExchange(_ref) {
  var cancel = _ref.cancel,
      cancellingExchange = _ref.cancellingExchange,
      close = _ref.close,
      open = _ref.open;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: "ban", fixed: true }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "with-padding" },
      "Cancel Exchange"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["i" /* ConfirmAction */],
      { onConfirm: cancel, close: close, open: cancellingExchange },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up! "
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        "Are you sure you want to cancel this exchange?"
      )
    )
  );
}

var withExchange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var _ref2$lineItem = _ref2.lineItem,
      itemId = _ref2$lineItem.id,
      commissionPaid = _ref2$lineItem.commission_paid,
      exchangeType = _ref2$lineItem.exchange_type,
      close = _ref2.close,
      refresh = _ref2.refresh,
      salesOrder = _ref2.salesOrder,
      expireLineItems = _ref2.expireLineItems;
  return {
    cancel: function cancel() {
      if (commissionPaid) {
        return __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__["toastr"].error("Commission Paid", "Commission for " + (exchangeType === __WEBPACK_IMPORTED_MODULE_6__constants__["l" /* SECOND_EXCHANGE */] ? "2nd Exchange" : "3rd Exchange") + " SO is paid. Sale cannot be canceled");
      }

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].salesOrders.lineItems.cancelSubsequentExchange(itemId).then(function () {
        refresh(salesOrder.get("id")).then(function () {
          expireLineItems();
          close();
        });
      });
    }
  };
});

var meetsExchangeCancellingCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_decorators__["a" /* renderIf */])(function (_ref3) {
  var _ref3$lineItem = _ref3.lineItem,
      cancelled = _ref3$lineItem.cancelled,
      exchange = _ref3$lineItem.exchange_sale,
      exchangeType = _ref3$lineItem.exchange_type,
      createdById = _ref3$lineItem.created_by_id,
      thirdExchange = _ref3$lineItem.third_exchange_item_id,
      consignmentType = _ref3$lineItem.inventory.consignment_type,
      _ref3$currentUser = _ref3.currentUser,
      role = _ref3$currentUser.role,
      currentUserId = _ref3$currentUser.id;
  return ([__WEBPACK_IMPORTED_MODULE_9__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_9__users_constants__["m" /* ACCOUNTING */]].includes(role) || createdById === currentUserId) && !cancelled && exchange && !consignmentType && (exchangeType === "third_exchange" || exchangeType === "second_exchange" && !thirdExchange);
});

CancelSubsequentExchange.propTypes = _extends({
  open: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__decorators__["a" /* withSalesOrder */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_decorators__["e" /* toggleSwitch */])("cancellingExchange")(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__["b" /* default */])(withExchange(meetsExchangeCancellingCriteria(CancelSubsequentExchange))))));

/***/ }),
/* 1818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CancelSubsequentExchange__ = __webpack_require__(1817);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CancelSubsequentExchange__["a"]; });



/***/ }),
/* 1819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReverseCancellation__ = __webpack_require__(1868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RmaRequest_RmaRequestModal__ = __webpack_require__(715);










function CancelledControls(_ref) {
  var lineItem = _ref.lineItem;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown__["c" /* ImprovedDropDown */],
    { menuClass: "dropdown-menu-right large" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
      id: "reverse-cancellation",
      label: "Reverse Cancellation",
      faIcon: "undo",
      hideIf: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(lineItem, "inventory.status") !== "reserve_for_sale" || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(lineItem, "inventory.consignment_type"),
      renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ReverseCancellation__["a" /* default */], { lineItem: lineItem })
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
      label: "Customer RMA Request",
      id: "customer-rma-request",
      faIcon: "cog",
      hideIf: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(lineItem, "inventory.status") !== "gone",
      renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__RmaRequest_RmaRequestModal__["a" /* default */], { lineItem: lineItem })
    })
  );
}

CancelledControls.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    })
  })
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch, _ref2) {
  var lineItem = _ref2.lineItem,
      salesOrder = _ref2.salesOrder,
      refresh = _ref2.refresh,
      expireLineItems = _ref2.expireLineItems;
  return {
    reverseCancellation: function reverseCancellation() {
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].salesOrders.lineItems.cancellationReversal(lineItem.id).then(function () {
        return refresh(salesOrder.get("id")).then(function () {
          expireLineItems();
          close();
        });
      });
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__decorators__["a" /* withSalesOrder */])(CancelledControls)));

/***/ }),
/* 1820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__ = __webpack_require__(54);
/* harmony export (immutable) */ __webpack_exports__["a"] = ConvertToExchange;




function ConvertToExchange(_ref) {
  var open = _ref.open,
      lineItem = _ref.lineItem;

  if (lineItem.shipped || lineItem.exchange_sale) return null;
  if (lineItem.part.pass_fail) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: function onClick() {
        return open(lineItem);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-dollar" }),
    "\xA0Convert To Exchange"
  );
}

ConvertToExchange.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_address__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_time__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(1822);








function ConvertToExchangeModal(_ref) {
  var open = _ref.open,
      close = _ref.close,
      lineItem = _ref.lineItem,
      salesOrder = _ref.salesOrder;

  var coreDueDays = lineItem.core_due_days || 30;
  var days = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_time__["a" /* addDays */])(new Date(), coreDueDays);

  var initialValues = {
    core_due_days: coreDueDays,
    core_return_date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["i" /* dateFormFormat */])(days),
    return_to_fob: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_address__["a" /* fobFormat */])(salesOrder.ship_to_address)
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Convert To Exchange"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Form__["a" /* default */], {
      close: close,
      lineItem: lineItem,
      salesOrder: salesOrder,
      enableReinitialize: true,
      initialValues: initialValues
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (ConvertToExchangeModal);

ConvertToExchangeModal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ConvertFromCartForm_Warnings__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Orders_shared_ShippingFields_ShippingFields__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_time__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__validate__ = __webpack_require__(1823);



















var FORM_NAME = "convertToExchange";

function Form(props) {
  var flatExchange = props.getFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["e" /* FLAT_EXCHANGE */]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["a" /* CheckGroup */],
            { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["e" /* FLAT_EXCHANGE */]), justified: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_8__constants__["e" /* FLAT_EXCHANGE */],
              component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["b" /* Check */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["e" /* FLAT_EXCHANGE */])
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["f" /* CurrencyField */], {
            required: true,
            name: __WEBPACK_IMPORTED_MODULE_10__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */],
            label: flatExchange ? "Flat Exchange Fee" : "Exchange Fee"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["f" /* CurrencyField */], {
            required: true,
            name: __WEBPACK_IMPORTED_MODULE_8__constants__["E" /* OUTRIGHT_VALUE */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["E" /* OUTRIGHT_VALUE */])
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ConvertFromCartForm_Warnings__["e" /* BlanketExchangeAgreementWarning */], {
          company: props.salesOrder.company,
          exchangeSale: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__["e" /* CORE_DUE_DAYS */],
            component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__["e" /* CORE_DUE_DAYS */]),
            onChange: function onChange(_evt, val) {
              if (val) {
                var days = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_time__["a" /* addDays */])(new Date(), Number(val));
                props.setFieldValue(__WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__["f" /* CORE_RETURN_DATE */])(new Date(days).toISOString().split("T")[0]);
              }
            },
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_16__PurchaseOrders_constants__["s" /* CORE_DUE_DATE */]),
            name: __WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__["f" /* CORE_RETURN_DATE */],
            component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
            type: "date",
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["f" /* CurrencyField */], {
            name: __WEBPACK_IMPORTED_MODULE_8__constants__["F" /* REPAIR_FEE */],
            label: "Avg Repair (NTX)",
            required: flatExchange
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["q" /* FormRow */],
        { className: "row-col-gutters-half" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_8__constants__["G" /* EXCHANGE_SPECIAL_INSTRUCTIONS */],
            component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["l" /* TextArea */],
            label: "Special Instructions (to be incl. on Exch Agreement)",
            maxLength: 150,
            rows: "5",
            cols: "50"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_redux_form__["FormSection"],
        { name: "" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Return To"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Orders_shared_ShippingFields_ShippingFields__["a" /* default */], {
          shipToCompany: props.salesOrder.return_to_company,
          key: "return-to-shipping-fields",
          formName: FORM_NAME,
          path: __WEBPACK_IMPORTED_MODULE_13__constants__["_39" /* RETURN_TO */],
          renderCarrier: false,
          shippingFields: [__WEBPACK_IMPORTED_MODULE_13__constants__["C" /* RETURN_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_13__constants__["_42" /* RETURN_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_13__constants__["_43" /* RETURN_TO_COMPANY_ADDRESS_ID */]],
          shippingTypes: [],
          shippingAddressField: __WEBPACK_IMPORTED_MODULE_13__constants__["_44" /* RETURN_TO_SHIPPING_ADDRESS */],
          locationFieldName: __WEBPACK_IMPORTED_MODULE_13__constants__["_25" /* RETURN_TO_LOCATION_ID */],
          required: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: "return_to_fob",
          component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
          label: "Return To FOB",
          required: true
        })
      )
    )
  );
}

Form.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    received: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.required
  })
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_5__actions__["j" /* convertToExchange */](ownProps.lineItem.id, data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_17__validate__["a" /* validate */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_FormSections_ShippingSection_validate__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_validate_this__ = __webpack_require__(24);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;






function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_validate_this__["a" /* validator */])(values, function (form) {
    if (values.flat_exchange) {
      form.validate(__WEBPACK_IMPORTED_MODULE_0__constants__["F" /* REPAIR_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["v" /* isLessThan */](values.exchange_fee));
    }

    form.validate(__WEBPACK_IMPORTED_MODULE_2__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */], __WEBPACK_IMPORTED_MODULE_0__constants__["E" /* OUTRIGHT_VALUE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_FormSections_ShippingSection_validate__["a" /* validateShippingFields */])("return_to", values, form);
  });
}

/***/ }),
/* 1824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown__ = __webpack_require__(54);







var shouldRenderCreateSecondExchange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["a" /* renderIf */])(function (_ref) {
  var _ref$lineItem = _ref.lineItem,
      cancelled = _ref$lineItem.cancelled,
      shipped = _ref$lineItem.shipped,
      exchangeType = _ref$lineItem.exchange_type,
      exchangeSale = _ref$lineItem.exchange_sale,
      role = _ref.currentUser.role;
  return [__WEBPACK_IMPORTED_MODULE_3__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_3__users_constants__["m" /* ACCOUNTING */]].includes(role) && !cancelled && exchangeSale && (shipped || exchangeType === __WEBPACK_IMPORTED_MODULE_4__constants__["l" /* SECOND_EXCHANGE */]) && exchangeType !== __WEBPACK_IMPORTED_MODULE_4__constants__["m" /* THIRD_EXCHANGE */];
});

function CreateSecondExchange(_ref2) {
  var open = _ref2.open,
      lineItem = _ref2.lineItem;

  var exchangeType = lineItem.exchange_type;
  var actionText = exchangeType ? __WEBPACK_IMPORTED_MODULE_4__constants__["V" /* EXCHANGE_CONFIG */][__WEBPACK_IMPORTED_MODULE_4__constants__["l" /* SECOND_EXCHANGE */]].text : __WEBPACK_IMPORTED_MODULE_4__constants__["V" /* EXCHANGE_CONFIG */][__WEBPACK_IMPORTED_MODULE_4__constants__["W" /* NOT_EXCHANGED */]].text;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: function onClick() {
        return open(lineItem);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-refresh" }),
    "\xA0",
    actionText
  );
}

CreateSecondExchange.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

var ConditionalCreateSecondExchange = shouldRenderCreateSecondExchange(CreateSecondExchange);

/* harmony default export */ __webpack_exports__["a"] = (ConditionalCreateSecondExchange);

/***/ }),
/* 1825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(1826);





function CreateSecondExchangeModal(_ref) {
  var lineItem = _ref.lineItem,
      open = _ref.open,
      close = _ref.close,
      currentUser = _ref.currentUser;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Please Confirm Seller Credit"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], {
      close: close,
      selectedSeller: lineItem.seller,
      lineItem: lineItem,
      currentUser: currentUser,
      initialValues: {
        seller_id: lineItem.seller_id,
        second_seller_id: lineItem.second_seller_id
      }
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (CreateSecondExchangeModal);

CreateSecondExchangeModal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_AutoCompleteField_AutoCompleteField__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_FormSections_SellersSection_actions__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__validate__ = __webpack_require__(1827);
/* unused harmony export ExchangeComp */
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





















var FORM_NAME = "convertToExchange";

function Form(props) {
  var lineItem = props.lineItem,
      searchSellers = props.searchSellers,
      selectedSeller = props.selectedSeller;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_10__constants__["C" /* SELLER_ID */],
            label: "Seller",
            placeholder: "Search by name...",
            component: __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_AutoCompleteField_AutoCompleteField__["a" /* default */],
            search: searchSellers,
            formatItem: function formatItem(result) {
              return result && result.full_name;
            },
            selectedItem: selectedSeller,
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_10__constants__["D" /* SECOND_SELLER_ID */],
            label: "2nd Seller",
            placeholder: "Search by name...",
            component: __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_AutoCompleteField_AutoCompleteField__["a" /* default */],
            search: searchSellers,
            formatItem: function formatItem(result) {
              return result && result.full_name;
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["f" /* CurrencyField */], {
            required: true,
            name: __WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */],
            label: lineItem.flat_exchange ? "Flat Exchange Fee" : "Exchange Fee"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_16__RepairOrders_constants__["e" /* CORE_DUE_DAYS */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_16__RepairOrders_constants__["e" /* CORE_DUE_DAYS */]),
            required: true
          })
        )
      )
    )
  );
}

Form.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    received: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
  }),
  searchSellers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  seller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string })
};

var meetsExchangeCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["a" /* renderIf */])(function (_ref) {
  var _ref$lineItem = _ref.lineItem,
      cancelled = _ref$lineItem.cancelled,
      shipped = _ref$lineItem.shipped,
      exchangeType = _ref$lineItem.exchange_type,
      role = _ref.currentUser.role;
  return [__WEBPACK_IMPORTED_MODULE_11__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_11__users_constants__["m" /* ACCOUNTING */]].includes(role) && !cancelled && (shipped || exchangeType === __WEBPACK_IMPORTED_MODULE_10__constants__["l" /* SECOND_EXCHANGE */]) && exchangeType !== __WEBPACK_IMPORTED_MODULE_10__constants__["m" /* THIRD_EXCHANGE */];
});

var ExchangeComp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__decorators__["a" /* withSalesOrder */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__session_decorators_withCurrentUser__["b" /* default */])(meetsExchangeCriteria(Form)));

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__actions__["i" /* exchange */])(ownProps.lineItem, data, ownProps.close));
    },
    searchSellers: function searchSellers() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_13__shared_FormSections_SellersSection_actions__["searchSellers"].apply(__WEBPACK_IMPORTED_MODULE_13__shared_FormSections_SellersSection_actions__, arguments));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state, ownProps) {
  var _initialValues;

  return {
    initialValues: (_initialValues = {
      seller_id: ownProps.lineItem.seller_id
    }, _defineProperty(_initialValues, __WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */], ownProps.lineItem.flat_exchange ? Number(ownProps.lineItem.exchange_fee) - Number(ownProps.lineItem.repair_fee) : Number(ownProps.lineItem.exchange_fee)), _defineProperty(_initialValues, __WEBPACK_IMPORTED_MODULE_16__RepairOrders_constants__["e" /* CORE_DUE_DAYS */], ownProps.lineItem.core_due_days), _initialValues)
  };
}, mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_18__validate__["a" /* validate */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(ExchangeComp))));

/***/ }),
/* 1827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(32);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;






function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_1__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */], __WEBPACK_IMPORTED_MODULE_3__RepairOrders_constants__["e" /* CORE_DUE_DAYS */], __WEBPACK_IMPORTED_MODULE_4__constants__["C" /* SELLER_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_0__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 1828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(1829);






function Download(_ref) {
  var open = _ref.open,
      close = _ref.close,
      salesItem = _ref.salesItem,
      salesOrder = _ref.salesOrder;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-md" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "CoC Obtained From"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], { salesItem: salesItem, salesOrder: salesOrder, close: close })
    )
  );
}

Download.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  salesItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withSalesOrder */])(Download));

/***/ }),
/* 1829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_submission_constants__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router__ = __webpack_require__(59);
var _this3 = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inventory: {
        purchase_order_line_items: [],
        repair_order_line_items: [],
        sales_order_line_items: []
      },
      mergeItems: false,
      obtainedFrom: { text: null },
      sellersContractNumber: _this.props.salesOrder.get(__WEBPACK_IMPORTED_MODULE_10__constants__["z" /* CODE */])
    }, _this.onItemSelected = function (item, type) {
      item.type = type;
      item.text = null;
      _this.setState({ obtainedFrom: item });

      _this.resetOtherInput();
    }, _this.onFlatItemSelected = function () {
      _this.setState({ obtainedFrom: { type: "other", text: null } });

      _this.resetOtherInput();
    }, _this.onSellersContractUpdated = function (event) {
      _this.setState({ sellersContractNumber: event.target.value });
    }, _this.onObtainedFromOther = function (event) {
      var value = event.target.value;

      _this.setState(function (state) {
        return {
          obtainedFrom: _extends({}, state.obtainedFrom, {
            text: value
          })
        };
      });
    }, _this.resetOtherInput = function () {
      if (_this.otherInput) {
        _this.otherInput.value = "";
      }
    }, _this.fetch = function (id) {
      return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].inventories.show(id, "all", "reference_record_details").then(function (resp) {
        _this.setState({ inventory: resp.data });

        return __WEBPACK_IMPORTED_MODULE_8__lib_submission_constants__["a" /* SUCCESS */];
      });
    }, _this.radioSelect = function (item, type) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "radio",
        name: "obtained_from_id",
        className: "radio-inline",
        checked: _this.state.obtainedFrom.id === item.id,
        onChange: function onChange() {
          return _this.onItemSelected(item, type);
        }
      });
    }, _this.inputRef = function (el) {
      _this.otherInput = el;
    }, _this.renderCompanyLink = function (item) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["w" /* CompanyName */], { flattenedCompany: item })
      );
    }, _this.renderPORow = function (item) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: "po-" + item.id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          _this.radioSelect(item, "purchase_order_line_item")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(item, "purchase_order.code")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["w" /* CompanyName */], { company: item.company })
        )
      );
    }, _this.renderSORow = function (item) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: "so-" + item.id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          _this.radioSelect(item, "sales_order_line_item")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          item.sales_order_code
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          _this.renderCompanyLink(item)
        )
      );
    }, _this.renderRORow = function (item) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: "ro-" + item.id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          _this.radioSelect(item, "repair_order_line_item")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          item.repair_order_code
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          _this.renderCompanyLink(item)
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.loading) return null;

      var _props = this.props,
          _props$permissions = _props.permissions,
          canMerge = _props$permissions.can_merge,
          canPrintMultiple = _props$permissions.can_print_multiple,
          salesItem = _props.salesItem,
          close = _props.close;
      var _state = this.state,
          mergeItems = _state.mergeItems,
          obtainedFrom = _state.obtainedFrom,
          printMultiple = _state.printMultiple,
          sellersContractNumber = _state.sellersContractNumber;


      var obtainedFromId = obtainedFrom.id && obtainedFrom.type !== "other" ? "&obtained_from_id=" + obtainedFrom.id : "";
      var obtainedFromType = obtainedFrom.type ? "&obtained_from_type=" + obtainedFrom.type : "";
      var boxFreeObtainedFromOtherText = obtainedFrom.type === "other" ? "&obtained_from_text=" + obtainedFrom.text : "";
      var merge = mergeItems ? "&merge_items=true" : "";
      var multiple = printMultiple ? "&multiple=true" : "";

      var url = __WEBPACK_IMPORTED_MODULE_10__constants__["d" /* API_BASE */] + "/sales_order_line_items/" + salesItem.id + "/download_certificate_of_conformance?sellers_contract_number=" + encodeURIComponent(sellersContractNumber) + obtainedFromId + obtainedFromType + merge + boxFreeObtainedFromOtherText + multiple;

      var canDownload = obtainedFrom.type !== "other" || obtainedFrom.type === "other" && !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(obtainedFrom.text);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_containers__["d" /* AgnosticLoader */],
          { fetch: this.fetch, id: salesItem.inventory_id },
          function (_ref2) {
            var loading = _ref2.loading;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */],
              { loading: loading, loadingRows: 1 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Head,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Code"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Company Name"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Body,
                null,
                _this2.state.inventory.purchase_order_line_items.map(_this2.renderPORow).concat(_this2.state.inventory.sales_order_line_items.filter(function (s) {
                  return s.exchange_sale && s.id !== salesItem.id;
                }).map(_this2.renderSORow)).concat(_this2.state.inventory.repair_order_line_items.map(_this2.renderRORow)),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    { className: "text-center" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                      type: "radio",
                      name: "obtained_from_id",
                      className: "radio-inline",
                      checked: obtainedFrom.type === "other",
                      onChange: _this2.onFlatItemSelected
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    "Other"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                      ref: _this2.inputRef,
                      type: "text",
                      name: "obtained_from_text",
                      className: "form-control",
                      defaultValue: obtainedFrom.text,
                      disabled: obtainedFrom.type !== "other",
                      onChange: _this2.onObtainedFromOther,
                      required: obtainedFrom.type === "other"
                    })
                  )
                )
              )
            );
          }
        ),
        canMerge && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components__["n" /* Warning */],
          { enableIcon: false },
          "Multiple units belong to the same PN ",
          salesItem.part.part_number,
          " ",
          "and have the same Tag, Trace and Condition information."
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                {
                  className: "control-label",
                  htmlFor: "sellers_contract_number"
                },
                "Seller's Contract #:"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                type: "text",
                name: "sellers_contract_number",
                className: "form-control",
                value: sellersContractNumber,
                onChange: this.onSellersContractUpdated
              })
            )
          ),
          canMerge && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["a" /* CheckGroup */],
              { title: "Do You Want To Merge To 1 CoC?", justified: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                {
                  className: "btn btn-default " + (mergeItems && "active"),
                  htmlFor: "merge_items"
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                  type: "checkbox",
                  id: "merge_items",
                  checked: true,
                  onChange: function onChange() {
                    return _this2.setState({
                      mergeItems: !mergeItems,
                      printMultiple: false
                    });
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
                "\xA0\xA0Merge CoC"
              )
            )
          ),
          canPrintMultiple && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["a" /* CheckGroup */],
              { title: "Print All?", justified: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                {
                  className: "btn btn-default " + (printMultiple && "active"),
                  htmlFor: "print_multiple"
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                  type: "checkbox",
                  id: "print_multiple",
                  checked: true,
                  onChange: function onChange() {
                    return _this2.setState({
                      printMultiple: !printMultiple,
                      mergeItems: false
                    });
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
                "\xA0\xA0Print All"
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "clearfix" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            {
              className: "pull-right btn btn-primary",
              disabled: !canDownload,
              onClick: function onClick() {
                window.open(url, "_blank");
                close();
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              null,
              "\xA0Download CoC/s "
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.required,
  salesItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map)
};


var withPermissions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["m" /* dataManager */])("permissions", function () {
  var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(_ref4) {
    var salesItem = _ref4.salesItem;

    var _ref5, permissions;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].salesOrders.lineItems.cocPermissions(salesItem.id);

          case 2:
            _ref5 = _context.sent;
            permissions = _ref5.data;
            return _context.abrupt("return", permissions);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this3);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react_router__["withRouter"])(withPermissions(Form)));

/***/ }),
/* 1830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Download__ = __webpack_require__(1828);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Download__["a"]; });



/***/ }),
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ExternalLink_ExternalLink__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* unused harmony export DownloadExchangeAgreement */







function DownloadExchangeAgreement(_ref) {
  var url = _ref.url;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "li",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ExternalLink_ExternalLink__["a" /* default */],
      { url: url },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "file-text-o", fixed: true }),
      "\xA0Download Exchange Agreement"
    )
  );
}

DownloadExchangeAgreement.propTypes = {
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var withUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var lineItem = _ref2.lineItem;
  return {
    url: __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* API_BASE */] + "/sales_order_line_items/" + lineItem.id + "/download_exchange_agreement_pdf"
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withUrl(DownloadExchangeAgreement));

/***/ }),
/* 1832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Form__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lineItem__ = __webpack_require__(1878);
/* unused harmony export Edit */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




















function Edit(_ref) {
  var _pojo;

  var editing = _ref.editing,
      close = _ref.close,
      lineItem = _ref.lineItem,
      props = _objectWithoutProperties(_ref, ["editing", "close", "lineItem"]);

  var values = (_pojo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_pojos__["a" /* default */])(lineItem.toJS())).pick.apply(_pojo, _toConsumableArray(__WEBPACK_IMPORTED_MODULE_17__lineItem__["a" /* fields */]));
  var part = lineItem.isEmpty() ? null : lineItem.get("part").toJS();

  var initialValues = _extends({}, values, {
    as_is: lineItem.get(__WEBPACK_IMPORTED_MODULE_10__users_constants__["_15" /* AS_IS */], false),
    exchange_sale: values.exchange_sale,
    core_expected_date: function () {
      var shippedDate = values.shipped_at ? new Date(values.shipped_at) : new Date();
      var coreDueDays = Number.isInteger(values.core_due_days) ? values.core_due_days : 30;
      shippedDate.setDate(shippedDate.getDate() + coreDueDays); // Add the days
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_date__["i" /* dateFormFormat */])(shippedDate);
    }(),
    core_due_days: Number.isInteger(values.core_due_days) ? values.core_due_days : "30",
    container_fee: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(values, __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__["y" /* CONTAINER_FEE */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(part, "special_container_fee", 0)),
    customer_to_return_container: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(values, "customer_to_return_container", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(part, "special_container_req")),
    condition: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(values, __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["n" /* CONDITION */])
  });
  var filteredInitialValues = props.canReleaseForShipment ? initialValues : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_removeKey__["a" /* default */])(initialValues, "release_for_shipment");
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Part"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Form__["a" /* default */], _extends({}, props, {
      close: close,
      editing: editing,
      lineItem: lineItem,
      showTable: false,
      selectedSeller: (lineItem.get("seller") || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()).toJS(),
      selectedSecondSeller: (lineItem.get("second_seller") || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()).toJS(),
      initialValues: filteredInitialValues
    }))
  );
}

Edit.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  canReleaseForShipment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    canReleaseForShipment: state.session.getIn([__WEBPACK_IMPORTED_MODULE_10__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["h" /* ROLE */]]) === __WEBPACK_IMPORTED_MODULE_10__users_constants__["i" /* ADMIN */] || state.session.getIn([__WEBPACK_IMPORTED_MODULE_10__users_constants__["a" /* USER */], "can_release_shipment"]),
    nonAccountingUser: ![__WEBPACK_IMPORTED_MODULE_10__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["i" /* ADMIN */]].includes(state.session.getIn([__WEBPACK_IMPORTED_MODULE_10__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["h" /* ROLE */]])),
    nonQCUser: state.session.getIn([__WEBPACK_IMPORTED_MODULE_10__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["h" /* ROLE */]]) !== __WEBPACK_IMPORTED_MODULE_10__users_constants__["p" /* QUALITY_CONTROL */]
  };
});

var withSubmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var lineItem = _ref2.lineItem;
  return {
    onSubmit: function onSubmit(data) {
      return __WEBPACK_IMPORTED_MODULE_12__api__["a" /* default */].salesOrders.lineItems.update(lineItem.get(__WEBPACK_IMPORTED_MODULE_14__constants__["b" /* ID */]), data);
    }
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__decorators__["a" /* withSalesOrder */])(withSubmit(withProps(Edit))));

/***/ }),
/* 1833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* unused harmony export ExchangeReversal */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











function ExchangeReversal(_ref) {
  var reverse = _ref.reverse,
      reversingExchange = _ref.reversingExchange,
      open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["k" /* Icon */], { name: "undo", fixed: true }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "with-padding" },
      "Convert To Outright SO"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components__["i" /* ConfirmAction */],
      { onConfirm: reverse, close: close, open: reversingExchange },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up! "
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        "Are you sure you want to reverse this exchange?"
      )
    )
  );
}

ExchangeReversal.propTypes = _extends({
  reverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reversingExchange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

var withExchange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var itemId = _ref2.lineItem.id,
      close = _ref2.close,
      refresh = _ref2.refresh,
      salesOrder = _ref2.salesOrder,
      expireLineItems = _ref2.expireLineItems;
  return {
    reverse: function reverse() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].salesOrders.lineItems.exchangeReversal(itemId).then(function () {
        refresh(salesOrder.get("id")).then(function () {
          expireLineItems();
          close();
        });
      });
    }
  };
});

var meetsExchangeReversalCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["a" /* renderIf */])(function (_ref3) {
  var _ref3$lineItem = _ref3.lineItem,
      cancelled = _ref3$lineItem.cancelled,
      shipped = _ref3$lineItem.shipped,
      exchange = _ref3$lineItem.exchange_sale,
      createdById = _ref3$lineItem.created_by_id,
      _ref3$currentUser = _ref3.currentUser,
      role = _ref3$currentUser.role,
      currentUserId = _ref3$currentUser.id;
  return ([__WEBPACK_IMPORTED_MODULE_8__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["m" /* ACCOUNTING */]].includes(role) || createdById === currentUserId) && !cancelled && exchange && !shipped;
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__decorators__["a" /* withSalesOrder */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["e" /* toggleSwitch */])("reversingExchange")(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__["b" /* default */])(withExchange(meetsExchangeReversalCriteria(ExchangeReversal))))));

/***/ }),
/* 1834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(32);
/* harmony export (immutable) */ __webpack_exports__["a"] = CancellationReason;






function CancellationReason() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
          name: "cancellation_reason",
          className: "text-right",
          component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["c" /* Select */],
          options: __WEBPACK_IMPORTED_MODULE_4__constants__["M" /* CANCELLATION_REASONS */],
          prompt: false,
          label: "Cancellation Reason"
        }),
        " "
      )
    )
  );
}

/***/ }),
/* 1835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators_withFormFields__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PartDetails_RepairAdminCharge__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ConvertFromCartForm_Warnings__ = __webpack_require__(187);
/* unused harmony export ExchangeSale */




















var disabledEnhancer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["A" /* disabledInputs */])({
  Check: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
  FormInput: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
  CurrencyField: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["f" /* CurrencyField */],
  NumberInput: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["h" /* NumberInput */]
});

function ExchangeSale(_ref) {
  var activeExchange = _ref.activeExchange,
      cancelled = _ref.cancelled,
      canExchange = _ref.canExchange,
      company = _ref.company,
      exchange_sale = _ref.exchange_sale,
      flatExchange = _ref.flatExchange,
      inventory = _ref.inventory,
      lineItem = _ref.lineItem,
      paid = _ref.paid,
      commissionPaid = _ref.commissionPaid,
      newRecord = _ref.newRecord,
      shipped = _ref.shipped,
      initialDayValue = _ref.initialDayValue,
      setFieldValue = _ref.setFieldValue,
      _ref$canEditPartDetai = _ref.canEditPartDetails,
      canEditPartDetails = _ref$canEditPartDetai === undefined ? true : _ref$canEditPartDetai,
      repairAdminChargeType = _ref.repairAdminChargeType,
      exchangeSaleValue = _ref.exchangeSaleValue;

  var disabled = cancelled || paid;

  var inputs = disabledEnhancer(disabled || !canEditPartDetails);

  var currencyInputs = disabledEnhancer(disabled || !canEditPartDetails || commissionPaid);

  if (!newRecord && !activeExchange) return null;

  var qty = parseInt(inventory.get(__WEBPACK_IMPORTED_MODULE_9__constants__["j" /* QUANTITY */]), 10) + parseInt(inventory.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_51" /* EXPECTED_QUANTITY */]), 10);

  var shipDate = function shipDate() {
    if (lineItem.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_23" /* SHIPPED */])) {
      return lineItem.get(__WEBPACK_IMPORTED_MODULE_8__constants__["R" /* SHIPPED_AT */]) ? new Date(lineItem.get(__WEBPACK_IMPORTED_MODULE_8__constants__["R" /* SHIPPED_AT */])) : new Date();
    }
    return new Date();
  };

  var calculateDueDays = function calculateDueDays(returnDate) {
    var selectedDate = new Date(returnDate);

    var timeDiff = selectedDate.getTime() - shipDate().getTime();
    var dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
    var dayValue = dayDiff + initialDayValue;

    return dayValue >= 0 ? dayValue : 0;
  };

  var handleCoreDueDaysChange = function handleCoreDueDaysChange(event) {
    if (!event.target) return null;
    if (Number(event.target.value) > 0) {
      var priorDate = shipDate();
      var futureDate = new Date(priorDate);
      futureDate.setTime(futureDate.getTime() + Number(event.target.value) * 86400000);
      setFieldValue(__WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__["_24" /* CORE_EXPECTED_DATE */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_date__["i" /* dateFormFormat */])(futureDate));
    }

    return null;
  };

  var handleExpectedDateChange = function handleExpectedDateChange(event) {
    var dueDays = calculateDueDays(event.target.value);
    setFieldValue(__WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__["e" /* CORE_DUE_DAYS */], dueDays);
  };

  var exchange = exchangeSaleValue;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["c" /* Collapse */],
    { "in": qty === 1, unmountOnExit: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h5",
        { className: "h4" },
        "Exchange Sale"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
        null,
        inventory.get(__WEBPACK_IMPORTED_MODULE_8__constants__["S" /* EXCHANGE_EVAL_IN_PROGRESS */]) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 5 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
            {
              title: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["_38" /* INTERNAL_OUTRIGHT */]), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components__["F" /* IconText */], {
                iconSize: "fa-stack-1x",
                icon: "fa-info-circle",
                note: "Create sales order (internal transaction only) to bill repair charges to customer and return core to stock unrepaired"
              })],
              justified: true
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_10__inventories_constants__["_38" /* INTERNAL_OUTRIGHT */],
              component: inputs.Check,
              label: "Yes"
            })
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
              { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["w" /* EXCHANGE_SALE */]), justified: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["w" /* EXCHANGE_SALE */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["w" /* EXCHANGE_SALE */]),
                disabled: disabled || activeExchange || !canExchange
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
              { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["e" /* FLAT_EXCHANGE */]), justified: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["e" /* FLAT_EXCHANGE */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["e" /* FLAT_EXCHANGE */]),
                disabled: disabled || !canExchange || shipped
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 7 },
            newRecord && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ConvertFromCartForm_Warnings__["e" /* BlanketExchangeAgreementWarning */], {
              company: company,
              exchangeSale: exchange_sale.input.value
            })
          )
        )
      ),
      exchange && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Fields"], {
              names: [__WEBPACK_IMPORTED_MODULE_8__constants__["T" /* REPAIR_ADMIN_CHARGE_TYPE */], __WEBPACK_IMPORTED_MODULE_8__constants__["I" /* REPAIR_ADMINISTRATION_CHARGE_PERCENTAGE */], __WEBPACK_IMPORTED_MODULE_8__constants__["K" /* REPAIR_ADMINISTRATION_CHARGE_DOLLARS */]],
              component: __WEBPACK_IMPORTED_MODULE_17__PartDetails_RepairAdminCharge__["a" /* default */]
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
          null,
          repairAdminChargeType === "percentage" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_8__constants__["I" /* REPAIR_ADMINISTRATION_CHARGE_PERCENTAGE */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              label: "Repair Administration Charge (%)",
              required: true
            })
          ),
          repairAdminChargeType === "dollars" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_8__constants__["K" /* REPAIR_ADMINISTRATION_CHARGE_DOLLARS */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              label: "Repair Administration Charge ($)",
              required: true
            })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["c" /* Collapse */],
        { "in": !!exchange_sale.input.value, unmountOnExit: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(currencyInputs.CurrencyField, {
                required: true,
                name: __WEBPACK_IMPORTED_MODULE_12__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */],
                label: flatExchange ? "Flat Exchange Fee" : "Exchange Fee"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(currencyInputs.CurrencyField, {
                required: true,
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["E" /* OUTRIGHT_VALUE */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["E" /* OUTRIGHT_VALUE */])
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__["_24" /* CORE_EXPECTED_DATE */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                type: "date",
                label: "Core Expected Date",
                onChange: handleExpectedDateChange,
                disabled: !lineItem.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_26" /* RECEIVED */])
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__["f" /* CORE_RETURN_DATE */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                type: "date",
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__["f" /* CORE_RETURN_DATE */]),
                disabled: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__["e" /* CORE_DUE_DAYS */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__["e" /* CORE_DUE_DAYS */]),
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["h" /* NumberInput */],
                roundDigits: 0,
                onChange: handleCoreDueDaysChange,
                disabled: lineItem.get(__WEBPACK_IMPORTED_MODULE_9__constants__["_26" /* RECEIVED */])
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(currencyInputs.CurrencyField, {
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["F" /* REPAIR_FEE */],
                label: "Avg Repair (NTX)",
                required: flatExchange
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["q" /* FormRow */],
            { className: "row-col-gutters-half" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["G" /* EXCHANGE_SPECIAL_INSTRUCTIONS */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["l" /* TextArea */],
                label: "Special Instructions (to be incl. on Exch Agreement)",
                maxLength: 150,
                rows: "5",
                cols: "50",
                disabled: !canEditPartDetails
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" })
        )
      )
    )
  );
}

ExchangeSale.propTypes = {
  activeExchange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cancelled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  canExchange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  exchanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  flatExchange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  paid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shipped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  commissionPaid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  exchange_sale: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormTypes__["boolInput"]).isRequired,
  newRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  canEditPartDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  repairAdminChargeType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  exchangeSaleValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["formValueSelector"])("salesOrderLineItem");

var mapStateToProps = function mapStateToProps(state) {
  return {
    repairAdminChargeType: selector(state, "repair_admin_charge_type"),
    exchangeSaleValue: selector(state, __WEBPACK_IMPORTED_MODULE_8__constants__["w" /* EXCHANGE_SALE */])
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_react_redux__["connect"])(mapStateToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators_withFormFields__["a" /* default */])(ExchangeSale, [__WEBPACK_IMPORTED_MODULE_8__constants__["w" /* EXCHANGE_SALE */]])));

/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_FormSections_SellersSection__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_Warnings_ConditionWarning__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ConvertFromCartForm_ExistingQuoteWarning__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__OutgoingQuotes_shared_PartDetails__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__companies_shared_components_RestrictedEntityWarning__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__PartDetails__ = __webpack_require__(1844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ExchangeSale__ = __webpack_require__(1835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Shipping__ = __webpack_require__(1845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Notes__ = __webpack_require__(1837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Summary__ = __webpack_require__(1850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__CancellationReason__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ConvertFromCartForm_Warnings__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__helpers__ = __webpack_require__(103);
/* unused harmony export formName */
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





































var formName = "salesOrderLineItem";

var sep = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" });

function Form(_ref) {
  var activeExchange = _ref.activeExchange,
      condition = _ref.condition,
      currentUser = _ref.currentUser,
      settings = _ref.settings,
      disableQcPreapproval = _ref.disableQcPreapproval,
      exchangeSale = _ref.exchangeSale,
      exchanged = _ref.exchanged,
      flatExchange = _ref.flatExchange,
      getFieldValue = _ref.getFieldValue,
      lineItem = _ref.lineItem,
      _ref$nonAccountingUse = _ref.nonAccountingUser,
      nonAccountingUser = _ref$nonAccountingUse === undefined ? true : _ref$nonAccountingUse,
      salesOrder = _ref.salesOrder,
      selectedInventory = _ref.selectedInventory,
      _ref$showTable = _ref.showTable,
      showTable = _ref$showTable === undefined ? true : _ref$showTable,
      updateInventory = _ref.updateInventory,
      newRecord = _ref.newRecord,
      editing = _ref.editing,
      resetSpecialContainerFeeField = _ref.resetSpecialContainerFeeField,
      props = _objectWithoutProperties(_ref, ["activeExchange", "condition", "currentUser", "settings", "disableQcPreapproval", "exchangeSale", "exchanged", "flatExchange", "getFieldValue", "lineItem", "nonAccountingUser", "salesOrder", "selectedInventory", "showTable", "updateInventory", "newRecord", "editing", "resetSpecialContainerFeeField"]);

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(lineItem.isEmpty() ? null : lineItem.get("part").toJS()),
      _useState2 = _slicedToArray(_useState, 2),
      part = _useState2[0],
      setPart = _useState2[1];

  var cancelled = lineItem.get(__WEBPACK_IMPORTED_MODULE_19__constants__["_38" /* CANCELLED */]);
  var shipped = lineItem.get("shipped");
  var paid = lineItem.get("invoice_paid_date");
  var canEditSeller = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_16__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_16__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_16__users_constants__["p" /* QUALITY_CONTROL */]]) || currentUser.id === lineItem.get(__WEBPACK_IMPORTED_MODULE_21__constants__["C" /* SELLER_ID */]);
  var canEditPartDetails = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_16__users_constants__["k" /* SALES */]);
  var canEditQcPreapproval = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__users_helpers__["i" /* hasAnyOfRolesOrSubroles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_16__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_16__users_constants__["p" /* QUALITY_CONTROL */]], [__WEBPACK_IMPORTED_MODULE_16__users_constants__["t" /* WAREHOUSE_EXPERT */]]);
  var commissionPaid = lineItem.get("commission_paid");

  var editable = canEditSeller || !cancelled && !exchanged && !paid;

  var inventory = selectedInventory ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])(selectedInventory) : lineItem.get(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["_24" /* INVENTORY */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])());

  var company = salesOrder.get(__WEBPACK_IMPORTED_MODULE_19__constants__["i" /* COMPANY */]).toJS();

  var conditionChanged = inventory.get(__WEBPACK_IMPORTED_MODULE_19__constants__["b" /* ID */]) && inventory.get(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["n" /* CONDITION */]) !== condition;

  var setFieldValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (field, newValue) {
    props.setFieldValue(field)(newValue);
  }, []);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */],
    _extends({}, props, { editable: editable || cancelled }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
          { md: 12, style: { marginTop: "10px" } },
          conditionChanged && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_Warnings_ConditionWarning__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__ConvertFromCartForm_Warnings__["a" /* NoPmaNoDerWarning */], {
            company: company,
            inventories: [inventory.toJS]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__ConvertFromCartForm_Warnings__["b" /* TraceTypeWarning */], {
            company: company,
            inventories: [inventory.toJS()]
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__ConvertFromCartForm_Warnings__["e" /* BlanketExchangeAgreementWarning */], {
            company: company,
            exchangeSale: exchangeSale
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__ConvertFromCartForm_ExistingQuoteWarning__["a" /* default */], {
            part: part,
            company: company,
            sellerId: getFieldValue(__WEBPACK_IMPORTED_MODULE_21__constants__["C" /* SELLER_ID */]) || lineItem.get(__WEBPACK_IMPORTED_MODULE_21__constants__["C" /* SELLER_ID */])
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "nav nav-tabs" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Part Details"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "tab-content" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { role: "tabpanel", className: "tab-pane active" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__PartDetails__["a" /* default */], _extends({
                part: part,
                lineItem: lineItem,
                cancelled: cancelled,
                paid: paid,
                commissionPaid: commissionPaid,
                showTable: showTable,
                shipped: shipped,
                exchanged: exchanged,
                onInventorySelected: updateInventory,
                canEditPartDetails: canEditPartDetails,
                canEditQcPreapproval: canEditQcPreapproval,
                disableQcPreapproval: disableQcPreapproval,
                canEditHazmatFlags: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_16__users_constants__["m" /* ACCOUNTING */]),
                formName: formName,
                resetSpecialContainerFeeField: resetSpecialContainerFeeField,
                setPart: setPart
              }, props)),
              sep,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Sellers"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__companies_shared_components_RestrictedEntityWarning__["a" /* default */], {
                company: company,
                allContacts: true,
                requireApproval: true
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_FormSections_SellersSection__["a" /* default */], _extends({
                exchanged: exchanged,
                disabled: !canEditSeller,
                paid: paid
              }, props)),
              sep,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__ExchangeSale__["a" /* default */], {
                activeExchange: activeExchange,
                canExchange: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_19__constants__["_35" /* CAN_EXCHANGE */]),
                flatExchange: flatExchange,
                company: company,
                exchanged: exchanged,
                cancelled: cancelled,
                lineItem: lineItem,
                nonAccountingUser: nonAccountingUser,
                shipped: shipped,
                paid: paid,
                inventory: inventory,
                canEditPartDetails: canEditPartDetails,
                commissionPaid: commissionPaid,
                newRecord: newRecord,
                initialReturnValue: lineItem.get(__WEBPACK_IMPORTED_MODULE_15__RepairOrders_constants__["f" /* CORE_RETURN_DATE */]),
                initialDayValue: lineItem.get(__WEBPACK_IMPORTED_MODULE_15__RepairOrders_constants__["e" /* CORE_DUE_DAYS */]),
                setFieldValue: setFieldValue
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__Shipping__["a" /* default */], {
                exchanged: exchanged,
                cancelled: cancelled,
                paid: paid,
                shipped: shipped,
                canEditPartDetails: canEditPartDetails,
                canEditOutgoingAwb: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_16__users_constants__["m" /* ACCOUNTING */]),
                commissionPaid: commissionPaid,
                part: part
              }),
              sep,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__Notes__["a" /* default */], {
                editing: editing,
                lineItem: lineItem,
                canEditNotes: canEditPartDetails,
                canEditInternalNotes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_16__users_constants__["m" /* ACCOUNTING */])
              }),
              cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__CancellationReason__["a" /* default */], null)
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__Summary__["a" /* default */], { lineItem: lineItem, inventory: inventory })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
          { md: 12, style: { marginTop: "10px" } },
          conditionChanged && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_Warnings_ConditionWarning__["a" /* default */], null)
        )
      )
    )
  );
}

Form.propTypes = _extends({
  activeExchange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  condition: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  exchanged: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  getFieldValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  lineItem: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"]).isRequired,
  nonAccountingUser: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  salesOrder: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"]),
  selectedInventory: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}),
  showTable: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  updateInventory: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  newRecord: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  resetSpecialContainerFeeField: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
}, __WEBPACK_IMPORTED_MODULE_17__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

var validate = function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_validate_this__["a" /* validator */])(values, function (f) {
    if (values.flat_exchange) {
      f.validate(__WEBPACK_IMPORTED_MODULE_21__constants__["F" /* REPAIR_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["a" /* required */]);
    }
    f.validate(__WEBPACK_IMPORTED_MODULE_19__constants__["_21" /* INVENTORY_ID */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["n" /* CONDITION */]).satisfies(__WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["a" /* required */]);
    if (values.exchange_sale) {
      f.validate(__WEBPACK_IMPORTED_MODULE_21__constants__["E" /* OUTRIGHT_VALUE */], __WEBPACK_IMPORTED_MODULE_20__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["a" /* required */]);

      if (values.repair_admin_charge_type === __WEBPACK_IMPORTED_MODULE_21__constants__["H" /* PERCENTAGE */]) {
        f.validate(__WEBPACK_IMPORTED_MODULE_21__constants__["I" /* REPAIR_ADMINISTRATION_CHARGE_PERCENTAGE */]).satisfies(__WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["q" /* isNumeric */], __WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["k" /* isLessThanOrEqualTo */](100), __WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](1));
      } else if (values.repair_admin_charge_type === __WEBPACK_IMPORTED_MODULE_21__constants__["J" /* DOLLARS */]) {
        f.validate(__WEBPACK_IMPORTED_MODULE_21__constants__["K" /* REPAIR_ADMINISTRATION_CHARGE_DOLLARS */]).satisfies(__WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["q" /* isNumeric */]);
      }
    } else {
      f.validate(__WEBPACK_IMPORTED_MODULE_20__OutgoingQuotes_constants__["b" /* PRICE_PER_UNIT */]).satisfies(__WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["a" /* required */]);
    }
    if (values.customer_to_return_container) {
      f.validate(__WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["y" /* CONTAINER_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["a" /* required */]);
    }
    f.validate(__WEBPACK_IMPORTED_MODULE_20__OutgoingQuotes_constants__["b" /* PRICE_PER_UNIT */], "core_repair_charges", __WEBPACK_IMPORTED_MODULE_21__constants__["F" /* REPAIR_FEE */], __WEBPACK_IMPORTED_MODULE_20__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */], __WEBPACK_IMPORTED_MODULE_21__constants__["E" /* OUTRIGHT_VALUE */], __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]).satisfies(__WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["q" /* isNumeric */]);
  });
};

var enhancedForm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: validate,
  onSubmitSuccess: function onSubmitSuccess(_r, _d, _ref2) {
    var salesOrder = _ref2.salesOrder,
        expireLineItems = _ref2.expireLineItems,
        close = _ref2.close,
        refresh = _ref2.refresh;

    refresh(salesOrder.get(__WEBPACK_IMPORTED_MODULE_19__constants__["b" /* ID */])).then(function () {
      expireLineItems();
      close();
    });
  }
});

var withSelectedInventory = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_decorators__["p" /* manageFields */])({
  selectedInventory: null
}, function (_ref3) {
  var updateField = _ref3.updateField,
      newRecord = _ref3.newRecord,
      salesOrder = _ref3.salesOrder;
  return {
    updateInventory: function updateInventory(inventory) {
      var defaultWarranty = inventory && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__OutgoingQuotes_shared_PartDetails__["c" /* warrantyForCondition */])(inventory.condition, inventory.part, inventory.tag_date);

      updateField("selectedInventory")(inventory);

      if (newRecord) {
        var company = salesOrder.get("company").toJS();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__helpers__["f" /* shouldSetQcPreapproval */])(company, inventory, function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])(__WEBPACK_IMPORTED_MODULE_21__constants__["L" /* CUSTOMER_QC_PREAPPROVAL_REQUIRED */], true);
          updateField("disableQcPreapproval")(true);
        });
      }

      if ([__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["h" /* REPAIRED */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["P" /* INSPECTED */], __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["i" /* OVERHAULED */]].includes(inventory.condition)) {
        if (inventory.warranty_override) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["_72" /* WARRANTY */], inventory.warranty_override);
        } else if (inventory.part.warranty_override) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["_72" /* WARRANTY */], inventory.part.warranty_override);
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["_72" /* WARRANTY */], defaultWarranty);
        }
      } else if (inventory.condition === __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["g" /* NEW_ITEM */] && inventory.warranty_override) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["_72" /* WARRANTY */], inventory.warranty_override);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["_72" /* WARRANTY */], defaultWarranty);
      }
    }
  };
});

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])(formName);
var withConditionAndExchangeAndSpecialContainer = function withConditionAndExchangeAndSpecialContainer(Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
    return {
      condition: selector(state, __WEBPACK_IMPORTED_MODULE_18__inventories_constants__["n" /* CONDITION */]),
      exchangeSale: selector(state, __WEBPACK_IMPORTED_MODULE_21__constants__["w" /* EXCHANGE_SALE */]),
      flatExchange: selector(state, __WEBPACK_IMPORTED_MODULE_21__constants__["e" /* FLAT_EXCHANGE */]),
      getFieldValue: function getFieldValue(field) {
        return selector(state, field);
      }
    };
  }, function (dispatch) {
    return {
      resetSpecialContainerFeeField: function resetSpecialContainerFeeField(fee) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_22__PurchaseOrders_constants__["y" /* CONTAINER_FEE */], Number(fee)));
      }
    };
  })(Component);
};

var withExchange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_decorators__["d" /* translateProps */])(function (_ref4) {
  var salesOrder = _ref4.salesOrder,
      lineItem = _ref4.lineItem;
  return {
    exchanged: salesOrder.get("has_exchange"),
    activeExchange: lineItem.get(__WEBPACK_IMPORTED_MODULE_21__constants__["w" /* EXCHANGE_SALE */], false)
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__decorators__["a" /* withSalesOrder */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__session_decorators_withCurrentUser__["b" /* default */])(withConditionAndExchangeAndSpecialContainer(enhancedForm(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(withExchange(withSelectedInventory(Form))))))));

/***/ }),
/* 1837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* unused harmony export Notes */






function Notes(_ref) {
  var canEditNotes = _ref.canEditNotes,
      canEditInternalNotes = _ref.canEditInternalNotes,
      editing = _ref.editing;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    !editing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h5",
      { className: "h4" },
      "Notes"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: "internal_note",
          component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["l" /* TextArea */],
          rows: 5,
          label: "Internal Note",
          disabled: !canEditNotes && !canEditInternalNotes
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: "external_note",
          component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["l" /* TextArea */],
          rows: 5,
          label: "External Note",
          disabled: !canEditNotes
        })
      )
    )
  );
}

Notes.propTypes = {
  canEditNotes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  canEditInternalNotes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Notes);

/***/ }),
/* 1838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip_AuditedNoteTooltip__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__ = __webpack_require__(11);
/* harmony export (immutable) */ __webpack_exports__["a"] = Flags;









function Flags(_ref) {
  var disabled = _ref.disabled,
      hazmatFee = _ref.hazmatFee,
      change = _ref.change,
      canEditQcPreapproval = _ref.canEditQcPreapproval,
      canEditHazmatFlags = _ref.canEditHazmatFlags,
      canEditExportComplianceHold = _ref.canEditExportComplianceHold,
      disableQcPreapproval = _ref.disableQcPreapproval,
      lineItem = _ref.lineItem;

  var handleHazmatFee = function handleHazmatFee() {
    if (!hazmatFee) {
      change("hazmat_fee", "75");
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["a" /* CheckGroup */],
          { title: "Line Hazmat", justified: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "hazmat",
            component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["b" /* Check */],
            label: "Hazmat",
            icon: "fa-warning",
            disabled: disabled || !canEditHazmatFlags,
            onChange: handleHazmatFee
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "bio_hazmat",
            component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["b" /* Check */],
            label: "Bio-Hazmat",
            icon: "fa-flask",
            disabled: disabled || !canEditHazmatFlags,
            onChange: handleHazmatFee
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["a" /* CheckGroup */],
          {
            title: ["QC Pre-Approval", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], {
              field: __WEBPACK_IMPORTED_MODULE_6__constants__["L" /* CUSTOMER_QC_PREAPPROVAL_REQUIRED */],
              obj: lineItem
            })],
            justified: true
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_6__constants__["L" /* CUSTOMER_QC_PREAPPROVAL_REQUIRED */],
            component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["b" /* Check */],
            label: "Required",
            disabled: disabled && !canEditQcPreapproval || disableQcPreapproval
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["a" /* CheckGroup */],
          {
            title: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["U" /* EXPORT_COMPLIANCE_HOLD */]), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], {
              field: __WEBPACK_IMPORTED_MODULE_6__constants__["U" /* EXPORT_COMPLIANCE_HOLD */],
              obj: lineItem
            })],
            justified: true
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_6__constants__["U" /* EXPORT_COMPLIANCE_HOLD */],
            component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["b" /* Check */],
            label: "Required",
            disabled: disabled && !canEditExportComplianceHold
          })
        )
      )
    )
  );
}

Flags.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  change: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  canEditQcPreapproval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  canEditHazmatFlags: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  canEditExportComplianceHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disableQcPreapproval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hazmatFee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* unused harmony export Inventory */









function Inventory(_ref) {
  var inventories = _ref.inventories,
      inventoryId = _ref.inventoryId,
      onSelect = _ref.onSelect,
      disabled = _ref.disabled,
      showTable = _ref.showTable;

  return showTable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-striped table-hover table-numbered" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Serial Number"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "CD"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "QTY"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Tag Date"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "SRP CD"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "SRP"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Exch SRP"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Cost EA."
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      inventories.map(function (lineItem, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          { key: lineItem.id },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            i + 1
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-center" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
              type: "radio",
              name: "read_only_inv",
              className: "radio-inline",
              checked: lineItem.id === inventoryId,
              onChange: function onChange() {
                return onSelect(lineItem);
              },
              disabled: disabled
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            lineItem.serial_number
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            lineItem.condition && __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["r" /* INVENTORIES */].condition[lineItem.condition].abbrev
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            lineItem.quantity
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["d" /* alphaMonthYear */])(lineItem.tag_date)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            lineItem.srp_condition && __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["r" /* INVENTORIES */].condition[lineItem.srp_condition].abbrev
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            lineItem.suggested_retail && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(lineItem.suggested_retail)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            lineItem.exchange_srp && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(lineItem.exchange_srp)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            lineItem.cost_per_unit && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(lineItem.cost_per_unit)
          )
        );
      })
    )
  );
}

Inventory.propTypes = {
  inventories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    serial_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    tag_date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    srp_condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    suggested_retail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    exchange_srp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    cost_per_unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  })).isRequired,
  inventoryId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])("salesOrderLineItem");

var withInventoryId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    inventoryId: selector(state, "inventory_id")
  };
});

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["d" /* translateProps */])(function (props) {
  return {
    onSelect: function onSelect(inventory) {
      var id = inventory.id,
          condition = inventory.condition,
          dim_weight = inventory.dim_weight;

      props.inventory_id.input.onChange(id);
      props.condition.input.onChange(condition);
      props.dim_weight.input.onChange(dim_weight);
      props.onSelect(inventory);
    }
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withInventoryId(withProps(Inventory)));

/***/ }),
/* 1840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_recordCollector__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__PartNumber__ = __webpack_require__(1841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__SellAsAlt__ = __webpack_require__(1843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Inventory__ = __webpack_require__(1839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Flags__ = __webpack_require__(1838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PriceDetails__ = __webpack_require__(1842);
/* unused harmony export PartDetails */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

























var separator = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" });

function PartDetails(_ref) {
  var associations = _ref.associations,
      cancelled = _ref.cancelled,
      canEditPartDetails = _ref.canEditPartDetails,
      canEditQcPreapproval = _ref.canEditQcPreapproval,
      canEditHazmatFlags = _ref.canEditHazmatFlags,
      change = _ref.change,
      condition = _ref.condition,
      showTable = _ref.showTable,
      dimWeight = _ref.dim_weight,
      disableQcPreapproval = _ref.disableQcPreapproval,
      exchanged = _ref.exchanged,
      exchangeSale = _ref.exchange_sale,
      hazmatFee = _ref.hazmatFee,
      inventoryId = _ref.inventoryId,
      lineItem = _ref.lineItem,
      onInventorySelected = _ref.onInventorySelected,
      part = _ref.part,
      paid = _ref.paid,
      commissionPaid = _ref.commissionPaid,
      shipped = _ref.shipped,
      updatePart = _ref.updatePart,
      currentUser = _ref.currentUser;
  var _associations$alterna = associations.alternates,
      alternates = _associations$alterna === undefined ? [] : _associations$alterna,
      _associations$invento = associations.inventories,
      inventories = _associations$invento === undefined ? [] : _associations$invento;

  var partAndInventoryLocked = !lineItem.isEmpty();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { marginTop: "26px" } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__PartNumber__["a" /* default */], {
          part: part,
          onSelect: updatePart,
          note: "To add a Part #, search for a part that is reserved for sale",
          disabled: cancelled || partAndInventoryLocked || exchanged || shipped || paid
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__SellAsAlt__["a" /* default */], {
          alternates: alternates,
          cancelled: cancelled,
          exchanged: exchanged,
          shipped: shipped || paid,
          canEditPartDetails: canEditPartDetails
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Inventory__["a" /* default */], {
          condition: condition,
          showTable: showTable,
          dim_weight: dimWeight,
          disabled: cancelled || partAndInventoryLocked || exchanged || shipped || paid || !canEditPartDetails,
          inventory_id: inventoryId,
          inventories: inventories,
          onSelect: onInventorySelected
        })
      )
    ),
    separator,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__PriceDetails__["a" /* default */], {
      disabledPrice: cancelled || exchanged || paid,
      disabledCondition: cancelled || shipped || exchanged || paid,
      exchangeSale: exchangeSale,
      commissionPaid: commissionPaid
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          component: __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["c" /* Select */],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__OutgoingQuotes_constants__["g" /* WARRANTY */]),
          name: __WEBPACK_IMPORTED_MODULE_12__OutgoingQuotes_constants__["g" /* WARRANTY */],
          options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_forms__["f" /* arrayToOptions */])(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["_59" /* WARRANTY_OPTIONS */]),
          disabled: cancelled || exchanged || paid
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["a" /* CheckGroup */],
          { title: "Sold As Is", justified: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_7__users_constants__["_15" /* AS_IS */],
            component: __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms__["b" /* Check */],
            label: "As-Is / No Returns"
          })
        )
      )
    ),
    separator,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Flags__["a" /* default */], {
      disabled: cancelled || exchanged || shipped || paid || !canEditPartDetails,
      hazmatFee: hazmatFee,
      change: change,
      canEditQcPreapproval: canEditQcPreapproval,
      canEditHazmatFlags: canEditHazmatFlags,
      canEditExportComplianceHold: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_7__users_constants__["p" /* QUALITY_CONTROL */]),
      disableQcPreapproval: disableQcPreapproval,
      lineItem: lineItem.toJS()
    })
  );
}

PartDetails.propTypes = _extends({
  inventoryId: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormTypes__["malleable"]).isRequired,
  condition: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormTypes__["stringInput"]).isRequired,
  exchange_sale: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormTypes__["boolInput"]).isRequired,
  dim_weight: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormTypes__["boolInput"]).isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  }),
  onInventorySelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  updatePart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  canEditPartDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  canEditQcPreapproval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  canEditHazmatFlags: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disableQcPreapproval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  associations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    alternates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
    inventories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}))
  }).isRequired,
  cancelled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  paid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  commissionPaid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shipped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  exchanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showTable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

var loader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["m" /* dataManager */])("associations", function (_ref2) {
  var part = _ref2.part,
      currentUser = _ref2.currentUser;

  if (part) {
    var alternates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_recordCollector__["a" /* default */])(function (page, limit) {
      return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].parts.alternates.search(part.id, { page: page, limit: limit });
    });
    var fetchReservedInventories = function fetchReservedInventories(page, limit) {
      return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].inventories.searchReservedForSale({
        part_id: part.id,
        reserve_for_seller_id: currentUser.id,
        page: page,
        limit: limit
      });
    };

    var inventories = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_recordCollector__["a" /* default */])(fetchReservedInventories);

    return Promise.all([alternates, inventories]).then(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          alt = _ref4[0],
          inv = _ref4[1];

      return {
        alternates: alt,
        inventories: inv
      };
    });
  }

  return Promise.resolve();
});

var partManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["p" /* manageFields */])({});

var listener = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["r" /* onChange */])(function (prevProps, nextProps) {
  if (nextProps.part && (!prevProps.part || nextProps.part.id !== prevProps.part.id)) {
    nextProps.reload();
  }
});

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["d" /* translateProps */])(function (_ref5) {
  var updateField = _ref5.updateField,
      resetSpecialContainerFeeField = _ref5.resetSpecialContainerFeeField,
      setPart = _ref5.setPart,
      associations = _ref5.associations,
      inventory_id = _ref5.inventory_id;
  return {
    updatePart: function updatePart(part) {
      updateField(__WEBPACK_IMPORTED_MODULE_16__parts_constants__["B" /* PART */])(part);
      if (resetSpecialContainerFeeField) resetSpecialContainerFeeField(part.special_container_fee);
      setPart(part);
    },
    associations: associations || {},
    inventoryId: inventory_id
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["q" /* withFormFields */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["b" /* default */])(partManager(loader(listener(withProps(PartDetails))))), ["inventory_id", "condition", "dim_weight", "exchange_sale"]));

/***/ }),
/* 1841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_IconText_IconText__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parts_constants__ = __webpack_require__(23);
/* unused harmony export PartNumber */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











function PartNumber(_ref) {
  var search = _ref.search,
      part = _ref.part,
      onSelect = _ref.onSelect,
      disabled = _ref.disabled,
      note = _ref.note;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_8__parts_constants__["w" /* PART_NUMBER */],
    label: "Part #",
    labelChildren: note ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_IconText_IconText__["a" /* default */], { iconSize: "fa-stack-1x", icon: "fa-info-circle", note: note }) : null,
    placeholder: "Type a part's number...",
    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["n" /* AutoCompleteField */],
    search: search,
    selectedItem: part,
    formatItem: function formatItem(result) {
      return result && result.part_number;
    },
    onItemSelected: function onItemSelected(i) {
      return i && onSelect(i);
    },
    disabled: disabled,
    required: true
  });
}

PartNumber.propTypes = _extends({
  note: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, __WEBPACK_IMPORTED_MODULE_3__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["d" /* translateProps */])(function () {
  return {
    search: function search(filter) {
      return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].parts.search({
        sellable: true,
        part_number: filter
      }).then(function (resp) {
        return resp.data.results;
      });
    }
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withProps(PartNumber));

/***/ }),
/* 1842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_forms__ = __webpack_require__(44);
/* harmony export (immutable) */ __webpack_exports__["a"] = PriceDetails;
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










function PriceDetails(_ref) {
  var disabledCondition = _ref.disabledCondition,
      disabledPrice = _ref.disabledPrice,
      _ref$exchangeSale$inp = _ref.exchangeSale.input.value,
      value = _ref$exchangeSale$inp === undefined ? false : _ref$exchangeSale$inp,
      commissionPaid = _ref.commissionPaid;

  /* eslint-disable no-unused-vars */
  var _INVENTORIES$conditio = __WEBPACK_IMPORTED_MODULE_6__inventories_constants__["r" /* INVENTORIES */].condition,
      scrap = _INVENTORIES$conditio.scrap,
      parts_unit = _INVENTORIES$conditio.parts_unit,
      filteredConditions = _objectWithoutProperties(_INVENTORIES$conditio, ["scrap", "parts_unit"]);
  /* eslint-enable no-unused-vars */


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: "condition",
          component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["c" /* Select */],
          label: "Condition",
          options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_forms__["a" /* toOptions */])(filteredConditions),
          required: true,
          disabled: disabledCondition
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: "lead_time",
          component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["d" /* FormInput */],
          label: "Days Lead Time",
          disabled: disabledPrice
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
        { md: 6 },
        !value && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["f" /* CurrencyField */], {
          name: "price_per_unit",
          label: "Sales Ea.",
          required: true,
          disabled: disabledPrice || commissionPaid
        })
      )
    )
  );
}

PriceDetails.propTypes = {
  disabledCondition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabledPrice: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  exchangeSale: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__["boolInput"]),
  commissionPaid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 1843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OutgoingQuotes_constants__ = __webpack_require__(45);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











function SellAsAlt(_ref) {
  var alternates = _ref.alternates,
      cancelled = _ref.cancelled,
      exchanged = _ref.exchanged,
      currentUser = _ref.currentUser,
      shipped = _ref.shipped,
      _ref$canEditPartDetai = _ref.canEditPartDetails,
      canEditPartDetails = _ref$canEditPartDetai === undefined ? true : _ref$canEditPartDetai;

  var options = alternates.map(function (a) {
    return {
      value: a.id,
      text: a.name
    };
  });
  var disabled = (cancelled || exchanged || shipped || !canEditPartDetails) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__users_helpers__["h" /* disableIfHasAnyOfRoles */])(currentUser, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_4__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_4__users_constants__["p" /* QUALITY_CONTROL */]));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_8__OutgoingQuotes_constants__["s" /* SELL_AS_ALT_ID */],
    component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["c" /* Select */],
    label: "Sell As Alternate",
    options: options,
    disabled: disabled
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__session_decorators_withCurrentUser__["b" /* default */])(SellAsAlt));

SellAsAlt.propTypes = _extends({
  alternates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  })).isRequired,
  cancelled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shipped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  exchanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
}, __WEBPACK_IMPORTED_MODULE_5__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/***/ }),
/* 1844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PartDetails__ = __webpack_require__(1840);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PartDetails__["a"]; });



/***/ }),
/* 1845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(6);
/* unused harmony export Shipping */









function Shipping(_ref) {
  var cancelled = _ref.cancelled,
      exchanged = _ref.exchanged,
      shipped = _ref.shipped,
      paid = _ref.paid,
      commissionPaid = _ref.commissionPaid,
      hazmat = _ref.hazmat,
      biohazmat = _ref.biohazmat,
      canEditPartDetails = _ref.canEditPartDetails,
      canEditOutgoingAwb = _ref.canEditOutgoingAwb,
      part = _ref.part;

  var specialContainerFeeRequired = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(part, "special_container_req");
  var disabled = cancelled || exchanged || shipped || paid || !canEditPartDetails;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h5",
      { className: "h4" },
      "Shipping"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: "outgoing_awb_number",
          component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
          label: "Outgoing AWB #",
          disabled: !canEditOutgoingAwb
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
        { md: 5 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
          { title: "Heavy Package / DIM Weight", justified: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "dim_weight",
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
            label: "Heavy Package / DIM Weight",
            disabled: !canEditPartDetails
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["f" /* CurrencyField */], {
          name: "hazmat_fee",
          label: "Hazmat Fee",
          disabled: disabled || commissionPaid,
          required: hazmat || biohazmat
        })
      )
    ),
    specialContainerFeeRequired && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Warning_Warning__["a" /* default */],
          { warningType: "warning" },
          "PN-",
          part.part_number,
          " is flagged as requiring a special container fee of ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__["a" /* dollars */])(part.special_container_fee),
          " and has been auto-populated below."
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["f" /* CurrencyField */], {
          name: "container_fee",
          label: "Container Fee",
          required: specialContainerFeeRequired,
          disabled: disabled || commissionPaid
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: "core_return_awb_number",
          component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
          label: "Core Return AWB #"
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
        { md: 5 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
          { title: "Customer To Return Container", justified: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "customer_to_return_container",
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
            label: "Customer to Return Container"
          })
        )
      )
    )
  );
}

Shipping.propTypes = {
  cancelled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  exchanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  paid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shipped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  commissionPaid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  biohazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  canEditPartDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  canEditOutgoingAwb: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })
};

/* harmony default export */ __webpack_exports__["a"] = (Shipping);

/***/ }),
/* 1846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OutgoingQuotes_constants__ = __webpack_require__(45);
/* unused harmony export Cost */
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var calculateInventoryCost = function calculateInventoryCost(exchangeSale, exchangeType, exchangeFee, totalCost, lineItemPricePerUnit) {
  var settings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks_useCurrentUser__["b" /* useSettings */])();
  if (exchangeSale) {
    var exchangePercent = exchangeType === __WEBPACK_IMPORTED_MODULE_7__constants__["m" /* THIRD_EXCHANGE */] ? __WEBPACK_IMPORTED_MODULE_7__constants__["Q" /* THIRD_EXCHANGE_PERCENT */] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_9__constants__["_50" /* EXCHANGE_CREDIT_PCT */], 50) / 100.0;
    return exchangeFee * exchangePercent;
  }

  return lineItemPricePerUnit || totalCost;
};

function Cost(_ref) {
  var inventory = _ref.inventory,
      lineItem = _ref.lineItem,
      fields = _objectWithoutProperties(_ref, ["inventory", "lineItem"]);

  var _fields$exchange_sale = fields.exchange_sale.input.value,
      exchangeSale = _fields$exchange_sale === undefined ? false : _fields$exchange_sale,
      exchangeFee = fields.exchange_fee.input.value;


  var exchange = exchangeSale === undefined ? lineItem.get(__WEBPACK_IMPORTED_MODULE_7__constants__["w" /* EXCHANGE_SALE */]) : exchangeSale;
  var label = exchange ? "Exch. Cost:" : "Cost at Time of Sale:";
  var fee = exchangeFee || lineItem.get(__WEBPACK_IMPORTED_MODULE_10__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "p",
    null,
    label,
    " ",
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(calculateInventoryCost(exchange, lineItem.get(__WEBPACK_IMPORTED_MODULE_7__constants__["q" /* EXCHANGE_TYPE */]), fee, inventory.get("total_cost"), lineItem.get("cost_per_unit")))
  );
}

Cost.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]).isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]).isRequired,
  exchange_sale: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormTypes__["boolInput"]).isRequired,
  exchange_fee: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormTypes__["malleable"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["q" /* withFormFields */])(Cost, [__WEBPACK_IMPORTED_MODULE_7__constants__["w" /* EXCHANGE_SALE */], __WEBPACK_IMPORTED_MODULE_10__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */]]));

/***/ }),
/* 1847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony export (immutable) */ __webpack_exports__["a"] = ExchangeLink;





function ExchangeLink(_ref) {
  var item = _ref.item,
      title = _ref.title;

  if (!item) {
    return false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "p",
    null,
    title,
    " ",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
      { to: "/sales-orders/" + item.get("uuid") },
      item.get("code")
    )
  );
}

ExchangeLink.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 1848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* unused harmony export IncomingAWB */






function IncomingAWB(_ref) {
  var lineItem = _ref.lineItem,
      exchangeSale = _ref.exchange_sale.input.value;

  if (!exchangeSale) {
    return false;
  }

  var receivingRecord = lineItem.get("receiving_records", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()).sortBy(function (r) {
    return new Date(r.get("created_at"));
  }).last() || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "Incoming AWB #: ",
      receivingRecord.get("awb_number")
    )
  );
}

IncomingAWB.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired,
  exchange_sale: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__["boolInput"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["q" /* withFormFields */])(IncomingAWB, ["exchange_sale"]));

/***/ }),
/* 1849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RMAsAndWarranties_constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Cost__ = __webpack_require__(1846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__IncomingAWB__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ExchangeLink__ = __webpack_require__(1847);



















function calculateCost() {
  var qty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var pricePerUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var exchangeFee = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var cost = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var baseTotal = parseFloat(qty) * parseFloat(pricePerUnit) || parseFloat(cost);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(parseFloat(exchangeFee) || baseTotal);
}

function hazmatWarnings(isHazmat, isBioHazmat) {
  var warnings = [];
  if (isHazmat) {
    warnings.push("Hazmat");
  }
  if (isBioHazmat) {
    warnings.push("Bio Hazmat");
  }
  if (warnings.length === 0) {
    return false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "alert alert-warning", role: "alert" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "media" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "media-left" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-warning text-warning" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "media-body" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "strong",
          null,
          "Warning!"
        ),
        " This part is marked: ",
        warnings.join(", ")
      )
    )
  );
}

function Summary(_ref) {
  var inventory = _ref.inventory,
      lineItem = _ref.lineItem,
      outgoingAWB = _ref.outgoing_awb_number.input.value,
      exchangeFee = _ref.exchange_fee.input.value,
      exchangeSale = _ref.exchange_sale.input.value,
      coreReturnDate = _ref.core_return_date.input.value;

  var part = lineItem.get(__WEBPACK_IMPORTED_MODULE_12__parts_constants__["B" /* PART */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());
  var reason = __WEBPACK_IMPORTED_MODULE_14__constants__["M" /* CANCELLATION_REASONS */].find(function (x) {
    return x.value === lineItem.get("cancellation_reason");
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "well" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h6",
      { className: "h4" },
      "Part Summary"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed table-padding-horizonal-none margin-bottom-none" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            "Part #: ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["h" /* PartNumber */], { part: part.toJS() })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "part-summary" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "em",
              { className: "text-muted" },
              part.get("description")
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Serial #:",
              " ",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
                { to: "/inventories/" + inventory.get("uuid") },
                lineItem.get("serial_number")
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Quantity: ",
              inventory.get(__WEBPACK_IMPORTED_MODULE_10__constants__["j" /* QUANTITY */])
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Cost__["a" /* default */], { inventory: inventory, lineItem: lineItem }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Cost Per Unit: ",
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_14__constants__["N" /* CUMULATIVE_COST_PER_UNIT */]))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Trace To: ",
              inventory.get(__WEBPACK_IMPORTED_MODULE_13__inventories_constants__["F" /* TRACED_TO */])
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Trace Type: ",
              inventory.get(__WEBPACK_IMPORTED_MODULE_13__inventories_constants__["E" /* TRACE_TYPE */])
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Tagged By: ",
              inventory.get(__WEBPACK_IMPORTED_MODULE_13__inventories_constants__["p" /* TAGGED_BY */])
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Tag Date: ",
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(inventory.get(__WEBPACK_IMPORTED_MODULE_13__inventories_constants__["x" /* TAG_DATE */]))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Store Owner: ",
              inventory.getIn([__WEBPACK_IMPORTED_MODULE_13__inventories_constants__["_73" /* STORE_OWNER */], __WEBPACK_IMPORTED_MODULE_10__constants__["S" /* NAME */]])
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Store Location: ",
              inventory.getIn([__WEBPACK_IMPORTED_MODULE_13__inventories_constants__["_74" /* STORE_LOCATION */], __WEBPACK_IMPORTED_MODULE_10__constants__["S" /* NAME */]])
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Location: ",
              inventory.get(__WEBPACK_IMPORTED_MODULE_13__inventories_constants__["_0" /* LOCATION */])
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Date Out: ",
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(lineItem.get("shipped_at"))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__IncomingAWB__["a" /* default */], { lineItem: lineItem }),
            lineItem.get("customer_rmas") && lineItem.get("customer_rmas").toJS().length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "RMA Reason:",
              " ",
              lineItem.get("customer_rmas").map(function (rma) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  __WEBPACK_IMPORTED_MODULE_7__RMAsAndWarranties_constants__["l" /* CUSTOMER_RMA_REASONS */][rma.get("reason")].label,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)
                );
              })
            ),
            lineItem.get("cancelled") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { style: { color: "#f44336" } },
                "Cancellation Reason:"
              ),
              " ",
              reason.text,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ExchangeLink__["a" /* default */], {
              item: lineItem.get("parent_exchange_item"),
              title: "Original Sales Order"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ExchangeLink__["a" /* default */], {
              item: lineItem.get("second_exchange_item"),
              title: "2nd Exchange"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ExchangeLink__["a" /* default */], {
              item: lineItem.get("third_exchange_item"),
              title: "3rd Exchange"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ExchangeLink__["a" /* default */], {
              item: lineItem.get("reference_exchange_sale_for_outright"),
              title: "Ref. Exch. SO: "
            })
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
    hazmatWarnings(lineItem.getIn([__WEBPACK_IMPORTED_MODULE_12__parts_constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_12__parts_constants__["h" /* HAZMAT */]]), lineItem.getIn([__WEBPACK_IMPORTED_MODULE_12__parts_constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_12__parts_constants__["i" /* BIO_HAZMAT */]])),
    !!exchangeSale && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs" }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h6",
      { className: "h4" },
      "Core Return"
    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-padding-horizonal-none" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "part-summary" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Outgoing AWB #: ",
              outgoingAWB
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Core Return Date: ",
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(coreReturnDate)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Core Repair Charges:",
              " ",
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(lineItem.get("core_repair_charges"))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Core Return Serial Number:",
              " ",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
                {
                  to: "/inventories/" + lineItem.getIn([__WEBPACK_IMPORTED_MODULE_13__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_10__constants__["c" /* UUID */]])
                },
                lineItem.get(__WEBPACK_IMPORTED_MODULE_13__inventories_constants__["_75" /* CORE_RETURN_SERIAL_NUMBER */])
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Core Repair Inv. #: ",
              lineItem.get(__WEBPACK_IMPORTED_MODULE_14__constants__["O" /* CORE_REPAIR_INVOICE_NUMBER */])
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              "Repair Inv. Paid Date:",
              " ",
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_14__constants__["P" /* CORE_REPAIR_INVOICE_PAID */]))
            )
          )
        )
      )
    )],
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-padding-horizonal-none" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              { className: "h4 margin-top-none margin-bottom-none" },
              "Total"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { className: "text-right" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              { className: "h4 margin-top-none margin-bottom-none" },
              calculateCost(inventory.get(__WEBPACK_IMPORTED_MODULE_10__constants__["j" /* QUANTITY */]), lineItem.get(__WEBPACK_IMPORTED_MODULE_11__OutgoingQuotes_constants__["b" /* PRICE_PER_UNIT */]), !!exchangeSale && exchangeFee, inventory.get("total_cost"))
            )
          )
        )
      )
    )
  );
}

Summary.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  outgoing_awb_number: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormTypes__["stringInput"]).isRequired,
  exchange_fee: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormTypes__["stringInput"]).isRequired,
  exchange_sale: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormTypes__["boolInput"]).isRequired,
  core_return_date: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormTypes__["stringInput"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["q" /* withFormFields */])(Summary, ["outgoing_awb_number", "exchange_fee", "core_return_date", "exchange_sale"]));

/***/ }),
/* 1850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Summary__ = __webpack_require__(1849);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Summary__["a"]; });


/***/ }),
/* 1851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__New__ = __webpack_require__(1857);
/* unused harmony export Heading */









function Heading(_ref) {
  var creating = _ref.creating,
      open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "h2",
    { style: { marginTop: 26 } },
    "Parts",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AddPart, { open: open }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__New__["a" /* default */], { creating: creating, close: close })
  );
}

Heading.propTypes = {
  creating: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var Button = function Button(_ref2) {
  var open = _ref2.open;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["T" /* Forbidden */],
    { roles: [__WEBPACK_IMPORTED_MODULE_4__users_constants__["j" /* WAREHOUSE */]] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        type: "button",
        className: "btn btn-primary btn-hollow pull-right",
        onClick: open
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "i",
        { className: "fa fa-fw fa-plus" },
        "\xA0"
      ),
      "Add Part"
    )
  );
};

Button.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var withExchangeAndShipment = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["d" /* translateProps */])(function (_ref3) {
  var salesOrder = _ref3.salesOrder;
  return {
    cancelled: salesOrder.get(__WEBPACK_IMPORTED_MODULE_6__constants__["_38" /* CANCELLED */]),
    exchanged: salesOrder.get("has_exchange"),
    shipped: salesOrder.get(__WEBPACK_IMPORTED_MODULE_6__constants__["_23" /* SHIPPED */])
  };
});

var forOpenItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["a" /* renderIf */])(function (_ref4) {
  var exchanged = _ref4.exchanged,
      shipped = _ref4.shipped,
      cancelled = _ref4.cancelled;
  return !exchanged && !shipped && !cancelled;
});

var AddPart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withSalesOrder */])(withExchangeAndShipment(forOpenItems(Button)));

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["e" /* toggleSwitch */])("creating")(Heading));

/***/ }),
/* 1852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);









function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6, mdOffset: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "outright_value",
            component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["f" /* CurrencyField */],
            label: "Original Evaluation Estimate"
          })
        )
      )
    )
  );
}

Form.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    received: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.required
  })
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_5__actions__["k" /* createInternalOutrightSale */](ownProps.lineItem.id, data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: "internalOutrightSaleForm"
})(Form)));

/***/ }),
/* 1853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__ = __webpack_require__(54);





function InternalOutrightSale(_ref) {
  var open = _ref.open,
      lineItem = _ref.lineItem;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: function onClick() {
        return open(lineItem);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-dollar" }),
    "\xA0Internal Outright Sale"
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var lineItem = _ref2.lineItem;
  return lineItem.most_recent_repair_item && lineItem.most_recent_repair_item.internal_outright && !lineItem.internal_outright_sales_item_id && !lineItem.internal_outright;
})(InternalOutrightSale));

InternalOutrightSale.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Form__ = __webpack_require__(1852);









function InternalOutrightSaleModal(_ref) {
  var visible = _ref.visible,
      close = _ref.close,
      lineItem = _ref.lineItem,
      outright_value = _ref.outright_value;

  var initialValues = {
    outright_value: Number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "most_recent_repair_item.original_evaluation")),
    credit_exchange: false
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["a" /* Modal */],
    { open: visible, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Internal Outright Sale"
      )
    ),
    lineItem.received && lineItem.most_recent_repair_item && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
      { md: 12 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { marginTop: "10px" }, className: "alert alert-warning" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "media" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "media-left" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-warning text-warning" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "media-body" },
            "\xA0Internal Outright Sale is being created from",
            " ",
            lineItem.sales_order_code,
            " for the Original Evaluation estimate of ",
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__["a" /* dollars */])(outright_value),
            " from",
            " ",
            lineItem.most_recent_repair_item.repair_order_code,
            ". Continue?"
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Form__["a" /* default */], {
      close: close,
      lineItem: lineItem,
      initialValues: initialValues,
      enableReinitialize: true
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["o" /* withFieldsFromForm */])("internalOutrightSaleForm", ["outright_value"])(InternalOutrightSaleModal));

InternalOutrightSaleModal.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  outright_value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

/***/ }),
/* 1855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InternalOutrightSale__ = __webpack_require__(1853);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InternalOutrightSale__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InternalOutrightSaleModal__ = __webpack_require__(1854);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__InternalOutrightSaleModal__["a"]; });





/***/ }),
/* 1856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Heading__ = __webpack_require__(1851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Table__ = __webpack_require__(1876);
/* unused harmony export LineItems */







function LineItems(_ref) {
  var afterHours = _ref.afterHours,
      company = _ref.company,
      results = _ref.results,
      isLoading = _ref.isLoading,
      openRma = _ref.openRma,
      salesOrder = _ref.salesOrder;

  var rowIcon = afterHours ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["j" /* NoteTooltip */], {
      icon: "fa-clock-o",
      placement: "top",
      note: "After Hours",
      color: "#FFFFFF"
    })
  ) : null;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Heading__["a" /* default */], { key: "heading" }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Table__["a" /* default */], {
    company: company,
    results: results,
    isLoading: isLoading,
    openRma: openRma,
    key: "table",
    rowIcon: rowIcon,
    salesOrder: salesOrder
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "nav",
    {
      key: "pagination",
      className: "text-center margin-top-none",
      "aria-label": "Search results pages"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__["Paginator"], { listId: "salesOrders/lineItems" })
  )];
}

var withListId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["d" /* translateProps */])(function () {
  return {
    listId: "salesOrders/lineItems"
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withListId(__WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__["decorators"].tabulate(LineItems)));

/***/ }),
/* 1857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Form__ = __webpack_require__(714);
/* unused harmony export New */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }














function New(_ref) {
  var creating = _ref.creating,
      close = _ref.close,
      currentUser = _ref.currentUser,
      props = _objectWithoutProperties(_ref, ["creating", "close", "currentUser"]);

  var settings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__hooks_useCurrentUser__["b" /* useSettings */])();
  var initialValues = {
    seller_credit_percent: "25.0",
    core_due_days: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_9__constants__["_52" /* EXCHANGE_CORE_DUE_DAYS */], 30),
    dim_weight: false,
    exchange_sale: false,
    condition: null
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["a" /* Modal */],
    { open: creating, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Add a Part"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Form__["a" /* default */], _extends({
      initialValues: _extends({}, initialValues, { seller_id: currentUser.id })
    }, props, {
      close: close,
      lineItem: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),
      selectedSeller: currentUser,
      newRecord: true
    }))
  );
}

New.propTypes = _extends({
  creating: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

var withSubmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var salesOrder = _ref2.salesOrder;
  return {
    onSubmit: function onSubmit(data) {
      return __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].salesOrders.lineItems.create(salesOrder.get("id"), data);
    }
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__decorators__["a" /* withSalesOrder */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__["b" /* default */])(withSubmit(New))));

/***/ }),
/* 1858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* unused harmony export NotCompletelyShippedWarning */




function NotCompletelyShippedWarning(_ref) {
  var close = _ref.close,
      warningOpen = _ref.warningOpen;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: warningOpen, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Invalid Action."
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "alert alert-warning margin-bottom-none" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "media" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "media-left" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-warning text-warning" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "media-body" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              null,
              "Partially Shipped"
            ),
            " This sales item has been",
            " ",
            "partially shipped. Completely ship in order to proceed with this action."
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { type: "submit", className: "btn btn-primary", onClick: close },
        "OK"
      )
    )
  );
}

NotCompletelyShippedWarning.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  warningOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (NotCompletelyShippedWarning);

/***/ }),
/* 1859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);









function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
        null,
        !props.lineItem.received && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["a" /* CheckGroup */],
            { title: "Credit Exchange?", justified: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: "credit_exchange", component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["b" /* Check */], label: "Yes" })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6, mdOffset: props.lineItem.received ? 3 : 0 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "outright_value",
            component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["f" /* CurrencyField */],
            label: "Outright Value"
          })
        )
      )
    )
  );
}

Form.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    received: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.required
  })
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_5__actions__["l" /* createOutrightSale */](ownProps.lineItem.id, data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: "outrightSaleForm"
})(Form)));

/***/ }),
/* 1860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__ = __webpack_require__(54);
/* harmony export (immutable) */ __webpack_exports__["a"] = OutrightSale;




function OutrightSale(_ref) {
  var open = _ref.open,
      lineItem = _ref.lineItem;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: function onClick() {
        return open(lineItem);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-dollar" }),
    "\xA0Create Outright Sale"
  );
}

OutrightSale.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(1859);








function OutrightSaleModal(_ref) {
  var visible = _ref.visible,
      close = _ref.close,
      lineItem = _ref.lineItem,
      outright_value = _ref.outright_value;

  var initialValues = {
    outright_value: lineItem.outright_value,
    credit_exchange: false
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: visible, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Outright Sale"
      )
    ),
    lineItem.received && lineItem.most_recent_repair_item && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 12 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { marginTop: "10px" }, className: "alert alert-warning" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "media" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "media-left" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-warning text-warning" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "media-body" },
            "\xA0Outright Sale is being created for Customer from",
            " ",
            lineItem.sales_order_code,
            " for a Sales EA value of",
            " ",
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(outright_value),
            " from",
            " ",
            lineItem.most_recent_repair_item.repair_order_code,
            ". Continue?"
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Form__["a" /* default */], {
      close: close,
      lineItem: lineItem,
      initialValues: initialValues,
      enableReinitialize: true
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["o" /* withFieldsFromForm */])("outrightSaleForm", ["outright_value"])(OutrightSaleModal));

OutrightSaleModal.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  outright_value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

/***/ }),
/* 1862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OutrightSale__ = __webpack_require__(1860);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__OutrightSale__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OutrightSaleModal__ = __webpack_require__(1861);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__OutrightSaleModal__["a"]; });





/***/ }),
/* 1863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












function QcPreapproved(_ref) {
  var lineItem = _ref.lineItem,
      confirm = _ref.confirm,
      confirming = _ref.confirming,
      close = _ref.close,
      open = _ref.open;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks_useCurrentUser__["a" /* default */])();
  if (!lineItem[__WEBPACK_IMPORTED_MODULE_5__constants__["L" /* CUSTOMER_QC_PREAPPROVAL_REQUIRED */]] || currentUser.subrole !== __WEBPACK_IMPORTED_MODULE_9__users_constants__["t" /* WAREHOUSE_EXPERT */]) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["k" /* Icon */], { name: "check", fixed: true }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "with-padding" },
      "QC paperwork approved"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components__["i" /* ConfirmAction */],
      { onConfirm: confirm, close: close, open: confirming },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up! "
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        "Are you sure you want to approve?"
      )
    )
  );
}

QcPreapproved.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  confirm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  confirming: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    confirm: function confirm() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_7__actions__["m" /* updateLineItem */](ownProps.lineItem.id, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__constants__["L" /* CUSTOMER_QC_PREAPPROVAL_REQUIRED */], false)));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["e" /* toggleSwitch */])("confirming")(QcPreapproved)));

/***/ }),
/* 1864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__ = __webpack_require__(19);
/* unused harmony export Reason */







function Reason(_ref) {
  var onSubmit = _ref.onSubmit,
      visible = _ref.visible,
      close = _ref.close,
      reason = _ref.reason,
      sendCancellationEmail = _ref.sendCancellationEmail,
      updateReason = _ref.updateReason,
      submitting = _ref.submitting,
      toggleSubmitting = _ref.toggleSubmitting;

  var submit = function submit() {
    toggleSubmitting();
    return onSubmit(reason, sendCancellationEmail).then(toggleSubmitting);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: visible, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Cancel Part"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "select",
          {
            className: "form-control",
            name: __WEBPACK_IMPORTED_MODULE_5__PurchaseOrders_constants__["H" /* CANCELLATION_REASON */],
            value: reason,
            onChange: function onChange(e) {
              return updateReason(e.target.value);
            }
          },
          __WEBPACK_IMPORTED_MODULE_4__constants__["M" /* CANCELLATION_REASONS */].map(function (r) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "option",
              { key: r.value, value: r.value },
              r.text
            );
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { type: "button", className: "btn btn-default", onClick: close },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "submit",
          className: "btn btn-primary",
          onClick: submit,
          disabled: submitting
        },
        "Save"
      )
    )
  );
}

Reason.propTypes = {
  sendCancellationEmail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  toggleSubmitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reason: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  updateReason: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var withReason = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["p" /* manageFields */])({
  reason: __WEBPACK_IMPORTED_MODULE_4__constants__["M" /* CANCELLATION_REASONS */][0].value,
  sendCancellationEmail: false,
  submitting: false
});

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var updateField = _ref2.updateField,
      toggleField = _ref2.toggleField;
  return {
    toggleSubmitting: toggleField("submitting"),
    updateReason: updateField("reason"),
    updateEmail: updateField("sendCancellationEmail")
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withReason(withProps(Reason)));

/***/ }),
/* 1865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_helpers__ = __webpack_require__(41);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












function ReleaseExportComplianceHold(_ref) {
  var lineItem = _ref.lineItem,
      confirm = _ref.confirm,
      confirming = _ref.confirming,
      close = _ref.close,
      open = _ref.open;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__hooks_useCurrentUser__["a" /* default */])();
  if (!lineItem[__WEBPACK_IMPORTED_MODULE_1__constants__["U" /* EXPORT_COMPLIANCE_HOLD */]] || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__users_helpers__["e" /* hasPermission */])(currentUser, __WEBPACK_IMPORTED_MODULE_2__users_constants__["_16" /* CAN_RELEASE_EXPORT_COMPLIANCE_HOLD */]) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */])) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["l" /* DropDownItem */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "check", fixed: true }),
    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
      "span",
      { className: "with-padding" },
      "Export Hold Released"
    ),
    __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["i" /* ConfirmAction */],
      { onConfirm: confirm, close: close, open: confirming },
      __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        "strong",
        null,
        "Heads up! "
      ),
      __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        "Are you sure you want to release the export hold?"
      )
    )
  );
}

ReleaseExportComplianceHold.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}),
  confirm: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  confirming: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    confirm: function confirm() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["m" /* updateLineItem */](ownProps.lineItem.id, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["U" /* EXPORT_COMPLIANCE_HOLD */], false)));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators__["e" /* toggleSwitch */])("confirming")(ReleaseExportComplianceHold)));

/***/ }),
/* 1866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ExternalLink__ = __webpack_require__(780);
/* harmony export (immutable) */ __webpack_exports__["a"] = RequestPreauthorization;







function RequestPreauthorization(_ref) {
  var salesItem = _ref.salesItem;

  if (!salesItem.shipped) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown_DropDownItem__["a" /* default */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_ExternalLink__["a" /* default */],
      {
        style: { color: "white" },
        url: __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* API_BASE */] + "/sales_order_line_items/" + salesItem.id + "/download_customer_rma_preauthorization_form"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "file-text-o", fixed: true }),
      "\xA0RMA Pre-Authorization Form"
    )
  );
}

RequestPreauthorization.propTypes = {
  salesItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);







function ReverseCancellation(_ref) {
  var open = _ref.open,
      close = _ref.close,
      reverseCancellation = _ref.reverseCancellation;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["i" /* ConfirmAction */],
    {
      onConfirm: reverseCancellation,
      close: close,
      open: open,
      icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "undo", fixed: true }),
      btnText: "Yes, Reverse Cancellation",
      title: "Reverse Cancellation"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "strong",
      null,
      "Heads up!"
    ),
    "\xA0 This will reverse the cancellation of this Sales Order."
  );
}

ReverseCancellation.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reverseCancellation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var withReverseCancellation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var lineItem = _ref2.lineItem,
      salesOrder = _ref2.salesOrder,
      refresh = _ref2.refresh,
      expireLineItems = _ref2.expireLineItems,
      close = _ref2.close;
  return {
    reverseCancellation: function reverseCancellation() {
      return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].salesOrders.lineItems.cancellationReversal(lineItem.id).then(function () {
        return refresh(salesOrder.get("id")).then(function () {
          expireLineItems();
          close();
        });
      });
    }
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decorators__["a" /* withSalesOrder */])(withReverseCancellation(ReverseCancellation)));

/***/ }),
/* 1868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(1867);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });



/***/ }),
/* 1869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Orders_shared_ShippingFields__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RMAsAndWarranties_constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms_NumberInput_NumberInput__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__validate__ = __webpack_require__(1871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__shared_components_Forms_FormRow__ = __webpack_require__(26);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

























var FORM_NAME = "createCustomerRmaForm";

function Form(props) {
  var lineItem = props.lineItem;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      inventory = _useState2[0],
      setInventory = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_18__api__["a" /* default */].inventories.show(lineItem.inventory_id, "all", "rma_request").then(function (_ref) {
      var data = _ref.data;

      setInventory(data);

      return function cleanup() {};
    });
  }, [lineItem.id]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_22__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_22__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_11__constants__["i" /* REASON */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__constants__["i" /* REASON */]),
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_8__RMAsAndWarranties_constants__["l" /* CUSTOMER_RMA_REASONS */]),
                required: true
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_22__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
                { justified: true, title: "WARRANTY CONSIDERATION?" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_13__RepairOrders_constants__["l" /* WARRANTY_CONSIDERATION */],
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                  label: "Yes"
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
                { justified: true, title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__RMAsAndWarranties_constants__["m" /* FULL_CREDIT_REQUESTED */]) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_8__RMAsAndWarranties_constants__["b" /* CREDIT_REQUESTED */],
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                  disabled: lineItem.exchange_sale && lineItem.received,
                  label: "Full Credit",
                  onChange: function onChange(_, val) {
                    if (val) {
                      props.setFieldValue(__WEBPACK_IMPORTED_MODULE_8__RMAsAndWarranties_constants__["n" /* PARTIAL_CREDIT_REQUESTED */])(false);
                    }
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
                { justified: true, title: "Partial Credit Requested" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_8__RMAsAndWarranties_constants__["n" /* PARTIAL_CREDIT_REQUESTED */],
                  disabled: lineItem.exchange_sale && lineItem.received,
                  component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                  label: "Partial Credit",
                  onChange: function onChange(_, val) {
                    if (val) {
                      props.setFieldValue(__WEBPACK_IMPORTED_MODULE_8__RMAsAndWarranties_constants__["b" /* CREDIT_REQUESTED */])(false);
                    }
                  }
                })
              )
            ),
            props.getFieldValue(__WEBPACK_IMPORTED_MODULE_8__RMAsAndWarranties_constants__["n" /* PARTIAL_CREDIT_REQUESTED */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["f" /* CurrencyField */], {
                required: true,
                name: __WEBPACK_IMPORTED_MODULE_8__RMAsAndWarranties_constants__["c" /* PARTIAL_CREDIT_AMT */],
                label: "Partial Credit Amount"
              })
            ),
            props.getFieldValue(__WEBPACK_IMPORTED_MODULE_8__RMAsAndWarranties_constants__["b" /* CREDIT_REQUESTED */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                {
                  className: "control-label",
                  htmlFor: __WEBPACK_IMPORTED_MODULE_8__RMAsAndWarranties_constants__["m" /* FULL_CREDIT_REQUESTED */]
                },
                "Full Credit Amount"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                type: "number",
                disabled: true,
                className: "form-control",
                value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms_NumberInput_NumberInput__["b" /* rounder */])(props.getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["_49" /* SUBTOTAL */]))
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "well" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h6",
              { className: "h4" },
              "Part Summary"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "table",
              { className: "table table-condensed table-padding-horizonal-none margin-bottom-none" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tbody",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    "PN:"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    { className: "text-right" },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "part.part_number")
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    "SN:"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    { className: "text-right" },
                    lineItem.serial_number
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    "Last Tagged By:"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    { className: "text-right" },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(inventory, "previous_tagged_by")
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    "Last Tag Date:"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    { className: "text-right" },
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_date__["c" /* shortDateYY */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(inventory, "previous_tag_date"))
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "tr",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    null,
                    "Store Owner:"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "td",
                    { className: "text-right" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["o" /* LocationFlag */], {
                      location: lineItem.inventory.store_owner_id
                    })
                  )
                )
              )
            )
          )
        )
      ),
      Number(lineItem.quantity) > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_22__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_14__constants__["j" /* QUANTITY */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_14__constants__["j" /* QUANTITY */]),
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */]
          })
        )
      ),
      props.customerRmaReasons === "other" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_22__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
            name: "other_reason",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: "Other-Reason",
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "nav nav-tabs" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Shipping Information"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_22__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Orders_shared_ShippingFields__["a" /* default */], {
            formName: FORM_NAME,
            shippingFields: [__WEBPACK_IMPORTED_MODULE_14__constants__["C" /* RETURN_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_14__constants__["_42" /* RETURN_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_14__constants__["_43" /* RETURN_TO_COMPANY_ADDRESS_ID */]],
            shippingType: __WEBPACK_IMPORTED_MODULE_14__constants__["_39" /* RETURN_TO */],
            shippingTypes: [__WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__["K" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_constants__["L" /* DROPSHIP */]],
            enableReturnToType: false,
            shippingMethod: __WEBPACK_IMPORTED_MODULE_14__constants__["_41" /* RETURN_TO_SHIPPING_METHOD */],
            shippingAddressField: __WEBPACK_IMPORTED_MODULE_14__constants__["_44" /* RETURN_TO_SHIPPING_ADDRESS */],
            locationFieldName: __WEBPACK_IMPORTED_MODULE_14__constants__["_25" /* RETURN_TO_LOCATION_ID */],
            required: false,
            rmaRequestForm: true
          })
        )
      )
    )
  );
}

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["formValueSelector"])(FORM_NAME);

Form.propTypes = {
  props: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    shippingType: selector(state, "shipping_type"),
    customerRmaReasons: selector(state, __WEBPACK_IMPORTED_MODULE_11__constants__["i" /* REASON */])
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_7__actions__["h" /* createCustomerRma */](ownProps.lineItem.id, data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_21__validate__["a" /* validate */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotCompletelyShippedWarning__ = __webpack_require__(1858);
/* unused harmony export RmaRequest */






function RmaRequest(_ref) {
  var lineItem = _ref.lineItem,
      warningOpen = _ref.warningOpen,
      close = _ref.close,
      openRma = _ref.openRma,
      open = _ref.open;

  var completelyShipped = lineItem.quantity === lineItem.quantity_shipped;
  var onClick = completelyShipped ? function () {
    return openRma(lineItem);
  } : open;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: onClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-cog" }),
    "\xA0Customer RMA Request",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NotCompletelyShippedWarning__["a" /* default */], { warningOpen: warningOpen, close: close })
  );
}

RmaRequest.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  openRma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  warningOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["e" /* toggleSwitch */])("warningOpen")(RmaRequest));

/***/ }),
/* 1871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RMAsAndWarranties_constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_constants__ = __webpack_require__(73);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;








function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (f) {
    f.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* REASON */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    f.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["C" /* RETURN_TO_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    if (values.reason === __WEBPACK_IMPORTED_MODULE_6__shared_constants__["d" /* OTHER */]) {
      f.validate("other_reason").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    f.validate(__WEBPACK_IMPORTED_MODULE_4__RepairOrders_constants__["l" /* WARRANTY_CONSIDERATION */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["u" /* customerRmaRequest */](1, __WEBPACK_IMPORTED_MODULE_4__RepairOrders_constants__["l" /* WARRANTY_CONSIDERATION */], __WEBPACK_IMPORTED_MODULE_5__RMAsAndWarranties_constants__["b" /* CREDIT_REQUESTED */], __WEBPACK_IMPORTED_MODULE_5__RMAsAndWarranties_constants__["n" /* PARTIAL_CREDIT_REQUESTED */]));

    if (values.partial_credit_requested) {
      __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */](__WEBPACK_IMPORTED_MODULE_5__RMAsAndWarranties_constants__["c" /* PARTIAL_CREDIT_AMT */]);
    }
  });
}

/***/ }),
/* 1872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__);
/* unused harmony export SendExchangeAgreement */










function SendExchangeAgreement(_ref) {
  var contact = _ref.contact,
      cc = _ref.cc,
      send = _ref.send,
      sending = _ref.sending,
      open = _ref.open,
      close = _ref.close,
      company = _ref.company;

  var primaryEmail = "<" + contact.email + ">";
  var email = cc ? primaryEmail + " (cc: <" + cc + ">)" : primaryEmail;
  var blanketText = company.name + " has a Blanket Exchange Agreement signed on file and ONLY needs one sent if Special Instructions are required. The Exchange Agreement will be sent to " + email;
  var defaultText = "The Exchange Agreement will be sent to " + contact.name + " " + email;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_DropDown__["a" /* DropDownItem */],
    { onClick: open },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-envelope-o" }),
    "\xA0Send Exchange Agreement",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components_ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: send,
        close: close,
        open: sending,
        btnText: "Yes, Send Exchange Agreement",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["k" /* Icon */], { name: "envelope", fixed: true })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0",
      company.blanket_exchange_agreement ? blanketText : defaultText
    )
  );
}

SendExchangeAgreement.propTypes = {
  contact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    email: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  cc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  send: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  sending: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    blanket_exchange_agreement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
  }).isRequired
};

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var lineItem = _ref2.lineItem,
      salesOrder = _ref2.salesOrder,
      close = _ref2.close;
  return {
    send: function send() {
      return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].salesOrders.lineItems.sendExchangeAgreement(lineItem.id).then(function () {
        close();
        __WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__["toastr"].success("Success", "Exchange agreement successfully sent.");
      }).catch(function () {
        return __WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__["toastr"].error("Error", "Could not send exchange agreement. Please refresh page and try again.");
      });
    },
    contact: salesOrder.get("contact").toJS(),
    cc: salesOrder.get("cc_email_address")
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["e" /* toggleSwitch */])("sending")(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decorators__["a" /* withSalesOrder */])(withProps(SendExchangeAgreement))));

/***/ }),
/* 1873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OutgoingQuotes_Detail_Send_SelectAttachmentTable__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__constants__ = __webpack_require__(4);
/* unused harmony export Form */
var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }























var FORM_NAME = "sendQcDocumentsForm";

function Form(_ref) {
  var close = _ref.close,
      getFieldValue = _ref.getFieldValue,
      handleSubmit = _ref.handleSubmit,
      lineItem = _ref.lineItem,
      setFieldValue = _ref.setFieldValue,
      modal = _ref.modal;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      attachments = _useState2[0],
      setAttachments = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState4 = _slicedToArray(_useState3, 2),
      inventoryAttachments = _useState4[0],
      setInventoryAttachments = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
    purchase_order_line_items: [],
    sales_order_line_items: [],
    repair_order_line_items: []
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      inventory = _useState6[0],
      setInventory = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState8 = _slicedToArray(_useState7, 2),
      obtainedFrom = _useState8[0],
      setObtainedFrom = _useState8[1];

  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState10 = _slicedToArray(_useState9, 2),
      obtainedFromType = _useState10[0],
      setObtainedFromType = _useState10[1];

  var sendCoc = getFieldValue(__WEBPACK_IMPORTED_MODULE_15__constants__["A" /* ATTACH_CERTIFICATE_OF_CONFORMANCE */]);

  var onItemSelected = function onItemSelected(item, type) {
    setObtainedFrom(item);
    setObtainedFromType(type);
    setFieldValue("obtained_from_type")(type);
  };

  var radioSelect = function radioSelect(item, type) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
      type: "radio",
      name: "obtained_from_id",
      className: "radio-inline",
      checked: obtainedFrom.id === item.id,
      onChange: function onChange() {
        return onItemSelected(item, type);
      }
    });
  };

  var renderCompanyLink = function renderCompanyLink(item) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["w" /* CompanyName */], { flattenedCompany: item })
    );
  };

  var renderPORow = function renderPORow(item) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      { key: "po-" + item.id },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-center" },
        radioSelect(item, "purchase_order_line_item")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(item, "purchase_order.code")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["w" /* CompanyName */], { company: item.company })
      )
    );
  };

  var renderOtherRow = function renderOtherRow() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-center" },
        radioSelect({ id: "other" }, "other")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        "Other"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */],
          disabled: obtainedFromType !== "other",
          name: "obtained_from_text",
          label: "Obtained From Text",
          required: obtainedFromType === "other"
        })
      )
    );
  };

  var renderSORow = function renderSORow(item) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      { key: "so-" + item.id },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-center" },
        radioSelect(item, "sales_order_line_item")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        item.sales_order_code
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        renderCompanyLink(item)
      )
    );
  };

  var renderRORow = function renderRORow(item) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      { key: "ro-" + item.id },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-center" },
        radioSelect(item, "repair_order_line_item")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        item.repair_order_code
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        renderCompanyLink(item)
      )
    );
  };

  var fetch = function fetch(id) {
    return __WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].inventories.show(id, "all", "reference_record_details").then(function (resp) {
      setInventory(resp.data);

      return __WEBPACK_IMPORTED_MODULE_16__lib_submission__["a" /* SUCCESS */];
    });
  };

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    return fetch(lineItem.inventory_id);
  }, [lineItem.inventory_id]);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    Promise.all([__WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].attachments.list(lineItem.sales_order_id, "sales_orders").then(function (_ref2) {
      var data = _ref2.data;

      setAttachments(data.results);
    }), __WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].attachments.list(lineItem.inventory_id, "inventories").then(function (_ref3) {
      var data = _ref3.data;

      setInventoryAttachments(data.results);
    })]);

    return function cleanup() {};
  }, [lineItem]);
  var obtainedFromId = obtainedFrom.id !== __WEBPACK_IMPORTED_MODULE_19__shared_constants__["d" /* OTHER */] && obtainedFrom.id ? "&obtained_from_id=" + obtainedFrom.id : "";

  var boxFreeObtainedFromOtherText = obtainedFrom.id === __WEBPACK_IMPORTED_MODULE_19__shared_constants__["d" /* OTHER */] ? "&obtained_from_text=" + getFieldValue("obtained_from_text") : "";

  var url = __WEBPACK_IMPORTED_MODULE_20__constants__["d" /* API_BASE */] + "/sales_order_line_items/" + lineItem.id + "/download_certificate_of_conformance?obtained_from_type=" + obtainedFromType + obtainedFromId + boxFreeObtainedFromOtherText;
  var filesNotPresent = [inventory.traceability_attachment, inventory.tag_copies_attachment].filter(function (f) {
    return !f;
  }).length;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */],
    { handleSubmit: handleSubmit, modal: modal, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "to", label: "To:", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "cc", label: "CC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "bcc", label: "BCC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */], name: "subject", label: "Subject", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["l" /* TextArea */], name: "body", label: "Body", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Attachments"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["a" /* CheckGroup */],
              { title: "Attachments", justified: true },
              inventory.traceability_attachment && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "" + __WEBPACK_IMPORTED_MODULE_10__OutgoingQuotes_constants__["t" /* ATTACH_TRACEABILITY */],
                component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__OutgoingQuotes_constants__["t" /* ATTACH_TRACEABILITY */])
              }),
              inventory.tag_copies_attachment && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "" + __WEBPACK_IMPORTED_MODULE_10__OutgoingQuotes_constants__["m" /* ATTACH_TAG_COPIES */],
                component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__OutgoingQuotes_constants__["m" /* ATTACH_TAG_COPIES */])
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_15__constants__["B" /* ATTACH_PACKING_SLIP */],
                component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_15__constants__["B" /* ATTACH_PACKING_SLIP */])
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_15__constants__["A" /* ATTACH_CERTIFICATE_OF_CONFORMANCE */],
                component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
                label: "Attach CoC"
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
          null,
          inventory.traceability_attachment && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
            { md: 2, style: { marginTop: 0 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__shared_components__["r" /* ExternalLink */],
              {
                url: inventory.traceability_attachment.public_download_url
              },
              "Download Traceability"
            )
          ),
          inventory.tag_copies_attachment && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
            { md: 2, style: { marginTop: 0 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__shared_components__["r" /* ExternalLink */],
              {
                url: inventory.tag_copies_attachment.public_download_url
              },
              "Download Tag Copies"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
            { md: 2, mdOffset: filesNotPresent * 2, style: { marginTop: 0 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__shared_components__["r" /* ExternalLink */],
              {
                url: __WEBPACK_IMPORTED_MODULE_20__constants__["d" /* API_BASE */] + "/sales_orders/" + lineItem.sales_order_id + "/download_packing_slip"
              },
              "Download Packing Slip"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
            {
              md: 2,
              mdOffset: filesNotPresent === 1 ? 2 : 0,
              style: { marginTop: 0 }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__shared_components__["r" /* ExternalLink */],
              { url: url },
              "Download CoC"
            )
          )
        ),
        sendCoc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              null,
              "Obtained From"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_17__shared_containers__["d" /* AgnosticLoader */],
              { fetch: fetch, id: lineItem.inventory_id },
              function (_ref4) {
                var loading = _ref4.loading;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8__shared_components__["s" /* DataTable */],
                  { loading: loading, loadingRows: 1 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8__shared_components__["s" /* DataTable */].Head,
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "th",
                      null,
                      "Code"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "th",
                      null,
                      "Company Name"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8__shared_components__["s" /* DataTable */].Body,
                    null,
                    inventory.purchase_order_line_items.map(renderPORow).concat(inventory.sales_order_line_items.filter(function (s) {
                      return s.exchange_sale && s.id !== lineItem.id;
                    }).map(renderSORow)).concat(inventory.repair_order_line_items.map(renderRORow)).concat([renderOtherRow({
                      obtainedFromType: obtainedFromType,
                      onFlatItemSelected: function onFlatItemSelected() {
                        return setObtainedFromType(__WEBPACK_IMPORTED_MODULE_19__shared_constants__["d" /* OTHER */]);
                      },
                      onObtainedFromOther: {}
                    })])
                  )
                );
              }
            )
          )
        )
      ),
      inventoryAttachments && inventoryAttachments.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            null,
            "Inventory Attachments"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__OutgoingQuotes_Detail_Send_SelectAttachmentTable__["a" /* default */], {
            attachments: inventoryAttachments,
            getFieldValue: getFieldValue,
            setFieldValue: setFieldValue
          })
        )
      ),
      attachments && attachments.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            null,
            "Sales Order Attachments"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__OutgoingQuotes_Detail_Send_SelectAttachmentTable__["a" /* default */], {
            attachments: attachments,
            getFieldValue: getFieldValue,
            setFieldValue: setFieldValue
          })
        )
      )
    )
  );
}

Form.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  modal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state, props) {
  var firstName = props.salesOrder.contact.name.split(" ")[0];
  var messageSubject = props.currentUser.tenant.name + " QC Documents For PO# " + props.salesOrder.customer_purchase_order_number;

  var messageBody = "Hello " + firstName + ", \n\nPlease see attached delivery of your QC documents.  Please do not reply to this email.\n\nIf you require any additional information, please contact your representative " + props.salesOrder.seller.email + "\n\nBest regards,";

  if (props.lineItem.customer_qc_preapproval_required) {
    messageSubject = "Trace Paperwork for Pre-Approval for PO# " + props.salesOrder.customer_purchase_order_number;

    messageBody = "Hello " + firstName + ", \n\nPlease see the attached paperwork for pre-approval for the subject PO.\n\nPlease review and advise if acceptable prior to shipment.\n\nPlease note this order will not be shipped until we receive your written approval.\n\nBest regards,";
  }

  var determineCC = function determineCC() {
    if (props.currentUser.email === props.salesOrder.seller.email) {
      if (props.salesOrder) {
        return props.salesOrder.cc_email_address || props.salesOrder.third_contact_email || "";
      }
      return "";
    }
    if (props.salesOrder && props.salesOrder.seller) {
      return props.salesOrder.seller.email || "";
    }
    return "";
  };

  return {
    attachments: [],
    initialValues: {
      attachment_ids: [],
      body: messageBody,
      to: [props.salesOrder.contact.email, props.salesOrder.cc_email_address, props.salesOrder.third_contact_email].filter(Boolean).join(", "),
      cc: determineCC(),
      bcc: __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.uniq([props.currentUser.email, __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.get(props.currentUser, "tenant.quality_control_bcc_emails")].filter(function (f) {
        return f;
      })).join(","),
      subject: messageSubject
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: function validate(values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_validate_this__["a" /* validator */])(values, function (f) {
      f.validate("body", "to").satisfies(__WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["a" /* required */]);
      f.validate("to", "cc", "bcc").satisfies(__WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["b" /* isValidEmail */]);
    });
  },
  onSubmit: function () {
    var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data, _ev, props) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].salesOrders.lineItems.sendQualityControlDocuments(props.lineItem.id, props.values).then(function () {
                props.close();
                __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].success("Success", "Documents successfully sent.");
              }).catch(function () {
                return __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].error("Error", "Could not send documents. Please refresh page and try again.");
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function onSubmit(_x, _x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }()
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 1874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);





function SendQualityControlDocuments(_ref) {
  var open = _ref.open,
      lineItem = _ref.lineItem;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return open(lineItem);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["k" /* Icon */], { name: "envelope", fixed: true }),
    "\xA0Send QC / Trace Docs"
  );
}

/* harmony default export */ __webpack_exports__["a"] = (SendQualityControlDocuments);

SendQualityControlDocuments.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(1873);





function SendQualityControlDocumentsModal(_ref) {
  var open = _ref.open,
      close = _ref.close,
      lineItem = _ref.lineItem,
      salesOrder = _ref.salesOrder;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hooks__["a" /* useCurrentUser */])();
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Choose SO Docs to Send"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], {
      close: close,
      currentUser: currentUser,
      lineItem: lineItem,
      salesOrder: salesOrder
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (SendQualityControlDocumentsModal);

/***/ }),
/* 1876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CancelConsignment_CancelConsignment__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__QcPreapproved_QcPreapproved__ = __webpack_require__(1863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ConvertToExchange_ConvertToExchangeModal__ = __webpack_require__(1821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ConvertToExchange_ConvertToExchange__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__CreateSecondExchange_CreateSecondExchangeModal__ = __webpack_require__(1825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CreateSecondExchange_ConditionalCreateSecondExchange__ = __webpack_require__(1824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ReleaseExportComplianceHold_ReleaseExportComplianceHold__ = __webpack_require__(1865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__SendQualityControlDocuments_SendQualityControlDocuments__ = __webpack_require__(1874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__RequestPreauthorization_RequestPreauthorization__ = __webpack_require__(1866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__SendQualityControlDocuments_SendQualityControlDocumentsModal__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__RmaRequest__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Edit__ = __webpack_require__(1832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ExchangeReversal__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Cancel__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__DownloadCoC__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__DownloadExchangeAgreement__ = __webpack_require__(1831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__SendExchangeAgreement__ = __webpack_require__(1872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__InternalOutrightSale__ = __webpack_require__(1855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__OutrightSale__ = __webpack_require__(1862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__CancelOutrightSale__ = __webpack_require__(1816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__CancelSubsequentExchange__ = __webpack_require__(1818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__CancelledControls__ = __webpack_require__(1819);
/* unused harmony export cancelledStatus */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








































var cancelledStatus = function cancelledStatus(_ref) {
  var cancelled = _ref.cancelled;
  return __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ "danger-table-cap": cancelled });
};

var WarningsIcons = function WarningsIcons(_ref2) {
  var lineItem = _ref2.lineItem;

  var reserveForSale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_lodash__["get"])(lineItem, "inventory.brokered_sale", false);
  var hasHazmat = lineItem.hazmat;
  var hasContainerFee = lineItem.container_fee && parseFloat(lineItem.container_fee) > 0;

  if (!hasHazmat && !hasContainerFee && !reserveForSale) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { style: { display: "flex", alignItems: "center" } },
      hasHazmat && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
        icon: "fa-warning",
        placement: "top",
        note: "Hazmat Fee",
        color: "#f44336",
        style: { marginRight: "5px" } // Add space between the two icons if needed
      }),
      hasContainerFee && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
        icon: "fa-dollar",
        placement: "top",
        note: "Container Fee",
        color: "#2196F3"
      }),
      reserveForSale && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
        icon: "fa-bolt",
        placement: "top",
        note: "Brokered",
        color: "#4787F8"
      })
    )
  );
};

WarningsIcons.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    container_fee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
  }).isRequired
};

var ShippedIcon = function ShippedIcon(_ref3) {
  var convertedFromExchange = _ref3.converted_from_exchange,
      quantity = _ref3.quantity,
      quantityShipped = _ref3.quantity_shipped;

  if (quantity === quantityShipped) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["k" /* Icon */], { name: "truck" });
  }
  if (convertedFromExchange) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["k" /* Icon */], { name: "undo" });
  }
  return null;
};

ShippedIcon.propTypes = {
  converted_from_exchange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  quantity_shipped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var ExchangeSaleIcon = function ExchangeSaleIcon(_ref4) {
  var lineItem = _ref4.lineItem,
      className = _ref4.className;

  if (!lineItem.exchange_sale) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { className: className });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
      icon: "fa-exchange",
      placement: "top",
      note: lineItem.flat_exchange ? "Flat Exchange Sale" : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__constants__["w" /* EXCHANGE_SALE */]),
      color: "#FFFFFF"
    })
  );
};

ExchangeSaleIcon.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    exchange_sale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
  }).isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var TruncatedTableCell = function TruncatedTableCell(_ref5) {
  var string = _ref5.string,
      _ref5$size = _ref5.size,
      size = _ref5$size === undefined ? 20 : _ref5$size;

  if (!string || string && string.length <= size) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    null,
    string
  );
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    null,
    string.slice(0, size) + "..."
  );
};

TruncatedTableCell.propTypes = {
  string: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var OPEN_DOWNLOAD_COC = "openDownloadCoC";
var OPEN_OUTRIGHT = "openOutright";
var OPEN_INTERNAL_OUTRIGHT = "openInternalOutright";
var OPEN_SEND_QC_DOCS = "openSendQcDocs";
var OPEN_CONVERT_TO_EXCHANGE = "openConvertToExchange";
var OPEN_CREATE_SECOND_EXCHANGE = "openCreateSecondExchange";

function renderRow(lineItem, open, index, openRma, openOutright, openInternalOutright, openSendQcDocs, closeOutright, setModalType, rowIcon, company) {
  var cancelled = lineItem.cancelled,
      creditExchange = lineItem.credit_exchange;

  var rowClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()("clickable", {
    "text-muted": cancelled || creditExchange
  });
  var isExchange = lineItem.exchange_sale;

  var lastExchange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helpers__["c" /* isLastExchange */])(lineItem);

  var canRequestRma = lineItem.shipped && (!isExchange || isExchange && lastExchange);

  var displayOutrightSale = !lineItem.inventory.brokered_exchange && (!lineItem.outright_sales_item_id && lastExchange && lineItem.inventory.status === __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["m" /* OUT_ON_EXCHANGE */] || lineItem.most_recent_repair_item && lastExchange && lineItem.most_recent_repair_item.exchange_gone_outright);

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks__["a" /* useCurrentUser */])();
  var condAbbrev = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__constants__["z" /* condition */])(lineItem.condition).abbrev;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { key: lineItem.id, className: rowClasses, onClick: function onClick() {
        return open(lineItem);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      index + 1
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { className: cancelledStatus(lineItem) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WarningsIcons, { lineItem: lineItem }),
    " ",
    rowIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      rowIcon
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helpers__["d" /* displayCustRmaWarning */])(lineItem) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
        icon: "fa-cog",
        placement: "top",
        note: "Cust. RMA",
        color: "#FFFFFF"
      })
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["h" /* PartNumber */], { part: lineItem.part })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.inventory.placeholder ? lineItem.serial_number : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],
        {
          to: "/inventories/" + (lineItem.inventory.uuid || lineItem.inventory_id)
        },
        lineItem.serial_number
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.sell_as_alt && (lineItem.sell_as_alt.alternate_part_id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["h" /* PartNumber */], {
        part: {
          id: lineItem.sell_as_alt.alternate_part_id,
          part_number: lineItem.sell_as_alt.name
        }
      }) : lineItem.sell_as_alt.name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["o" /* LocationFlag */], {
        location: lineItem.inventory.store_owner_id,
        consignment_type: lineItem.inventory.consignment_type,
        consignedDate: lineItem.inventory.consigned_date,
        inventory: lineItem.inventory
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["o" /* LocationFlag */], {
        location: lineItem.inventory.store_location_id,
        transferStatus: lineItem.inventory.transfer_status
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TruncatedTableCell, { string: lineItem.location, size: 13 }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TruncatedTableCell, { string: lineItem.traced_to }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TruncatedTableCell, { string: lineItem.tagged_by, size: 14 }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.outgoing_awb_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      condAbbrev
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__helpers__["a" /* ExchangeIcon */], { lineItem: lineItem })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      lineItem.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      lineItem.quantity_shipped
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_currency__["a" /* dollars */])(lineItem.exchange_sale ? lineItem.exchange_fee : lineItem.price_per_unit)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_lodash__["isEmpty"])(lineItem.internal_note) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_lodash__["isEmpty"])(lineItem.external_note)) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
        note: [lineItem.internal_note, lineItem.external_note].filter(function (n) {
          return n !== null && n !== "";
        }).join(" | "),
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ "link-muted": lineItem.cancelled })
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      {
        className: "text-center td-shrink-icon",
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      },
      !cancelled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown__["b" /* default */],
        {
          icon: "fa fa-fw fa-ellipsis-v",
          menuClass: "dropdown-menu-right large"
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          isExchange && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__SendExchangeAgreement__["a" /* default */], {
              onClick: open,
              lineItem: lineItem,
              company: company
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__DownloadExchangeAgreement__["a" /* default */], { lineItem: lineItem })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__RequestPreauthorization_RequestPreauthorization__["a" /* default */], { salesItem: lineItem }),
          canRequestRma && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__RmaRequest__["b" /* RmaRequest */], { lineItem: lineItem, openRma: openRma }),
          !lineItem.shipped && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__Cancel__["a" /* default */], { lineItem: lineItem }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__InternalOutrightSale__["a" /* default */], {
            lineItem: lineItem,
            open: openInternalOutright
          }),
          displayOutrightSale && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__OutrightSale__["a" /* default */], {
            lineItem: lineItem,
            open: openOutright,
            close: closeOutright
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__ExchangeReversal__["a" /* default */], { lineItem: lineItem }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ConvertToExchange_ConvertToExchange__["a" /* default */], {
            lineItem: lineItem,
            open: function open() {
              return setModalType(OPEN_CONVERT_TO_EXCHANGE, lineItem);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__CancelOutrightSale__["a" /* default */], { lineItem: lineItem }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__CancelSubsequentExchange__["a" /* default */], { lineItem: lineItem }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__CancelConsignment_CancelConsignment__["a" /* default */], { lineItem: lineItem }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__CreateSecondExchange_ConditionalCreateSecondExchange__["a" /* default */], {
            lineItem: lineItem,
            open: function open() {
              return setModalType(OPEN_CREATE_SECOND_EXCHANGE, lineItem);
            },
            currentUser: currentUser
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components__["l" /* DropDownItem */],
            {
              disabled: lineItem.qc_status === __WEBPACK_IMPORTED_MODULE_11__inventories_constants__["S" /* QC_HOLD */],
              onClick: function onClick() {
                return setModalType(OPEN_DOWNLOAD_COC, lineItem);
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__shared_components__["b" /* Authorized */],
              {
                permissions: [__WEBPACK_IMPORTED_MODULE_9__users_constants__["_14" /* CREATE_COC */]],
                roles: [__WEBPACK_IMPORTED_MODULE_9__users_constants__["p" /* QUALITY_CONTROL */]],
                subroles: [__WEBPACK_IMPORTED_MODULE_9__users_constants__["n" /* QUALITY_CONTROL_MANAGER */]]
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["k" /* Icon */], { name: "download", fixed: true }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { className: "with-padding" },
                "Download CoC"
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__QcPreapproved_QcPreapproved__["a" /* default */], { lineItem: lineItem }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__ReleaseExportComplianceHold_ReleaseExportComplianceHold__["a" /* default */], { lineItem: lineItem }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__SendQualityControlDocuments_SendQualityControlDocuments__["a" /* default */], {
            lineItem: lineItem,
            open: openSendQcDocs
          })
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__CancelledControls__["a" /* default */], { lineItem: lineItem })
    )
  );
}

var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    var _ref6;

    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref6 = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref6, [this].concat(args))), _this), _this.state = {
      open: false,
      selectedItem: {},
      modalType: null,
      openOutright: false,
      openInternalOutright: false
    }, _this.open = function (lineItem) {
      return _this.setState({ open: true, selectedItem: lineItem });
    }, _this.close = function () {
      return _this.setState({ open: false });
    }, _this.openModalType = function (type, lineItem) {
      var _this$setState;

      return _this.setState((_this$setState = {}, _defineProperty(_this$setState, type, true), _defineProperty(_this$setState, "selectedItem", lineItem), _defineProperty(_this$setState, "modalType", type), _this$setState));
    }, _this.closeModalType = function (type) {
      var _this$setState2;

      return _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, type, false), _defineProperty(_this$setState2, "modalType", null), _this$setState2));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          company = _props.company,
          results = _props.results,
          isLoading = _props.isLoading,
          openRma = _props.openRma,
          rowIcon = _props.rowIcon,
          salesOrder = _props.salesOrder;
      var _state = this.state,
          selectedItem = _state.selectedItem,
          open = _state.open,
          openOutright = _state.openOutright,
          openInternalOutright = _state.openInternalOutright,
          modalType = _state.modalType;


      var salesEAOrExchFeeColHeader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helpers__["e" /* feeTableHeader */])(results);
      var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks__["a" /* useCurrentUser */])();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components__["T" /* Forbidden */],
          { roles: [__WEBPACK_IMPORTED_MODULE_9__users_constants__["j" /* WAREHOUSE */]] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__Edit__["a" /* default */], {
            editing: open,
            close: this.close,
            salesOrder: salesOrder,
            lineItem: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(selectedItem)
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Mini,
          { loading: isLoading, numbered: true, noMargin: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            rowIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Part #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Serial #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Sell As Alt"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Store Owner"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Store Loc."
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Loc."
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Trace To"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tagged By"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Outgoing AWB #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Cond."
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Exch"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "QTY"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Shipped"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              salesEAOrExchFeeColHeader
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-center" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Body,
            null,
            results.map(function (lineItem, index) {
              return renderRow(lineItem, _this2.open, index, openRma, function (item) {
                return _this2.openModalType(OPEN_OUTRIGHT, item);
              }, function (item) {
                return _this2.openModalType(OPEN_INTERNAL_OUTRIGHT, item);
              }, function (item) {
                return _this2.openModalType(OPEN_SEND_QC_DOCS, item);
              }, function () {
                return _this2.closeModalType(OPEN_OUTRIGHT);
              }, function (type, item) {
                return _this2.openModalType(type, item);
              }, rowIcon, company);
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__OutrightSale__["b" /* OutrightSaleModal */], {
          close: function close() {
            return _this2.closeModalType(OPEN_OUTRIGHT);
          },
          visible: openOutright,
          lineItem: selectedItem
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__InternalOutrightSale__["b" /* InternalOutrightSaleModal */], {
          close: function close() {
            return _this2.closeModalType(OPEN_INTERNAL_OUTRIGHT);
          },
          visible: openInternalOutright,
          lineItem: selectedItem
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__DownloadCoC__["a" /* default */], {
          open: modalType === OPEN_DOWNLOAD_COC,
          close: function close() {
            return _this2.closeModalType(OPEN_DOWNLOAD_COC);
          },
          salesItem: selectedItem,
          salesOrder: salesOrder
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ConvertToExchange_ConvertToExchangeModal__["a" /* default */], {
          open: modalType === OPEN_CONVERT_TO_EXCHANGE,
          close: function close() {
            return _this2.closeModalType(OPEN_CONVERT_TO_EXCHANGE);
          },
          lineItem: selectedItem,
          salesOrder: salesOrder
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__CreateSecondExchange_CreateSecondExchangeModal__["a" /* default */], {
          lineItem: selectedItem,
          open: modalType === OPEN_CREATE_SECOND_EXCHANGE,
          close: function close() {
            return _this2.closeModalType(OPEN_CREATE_SECOND_EXCHANGE);
          },
          currentUser: currentUser
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__SendQualityControlDocuments_SendQualityControlDocumentsModal__["a" /* default */], {
          lineItem: selectedItem,
          open: modalType === OPEN_SEND_QC_DOCS,
          close: function close() {
            return _this2.closeModalType(OPEN_SEND_QC_DOCS);
          },
          salesOrder: salesOrder
        })
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Table);


Table.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  openRma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  rowIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    blanket_exchange_agreement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
  }).isRequired,
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LineItems__ = __webpack_require__(1856);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LineItems__["a"]; });



/***/ }),
/* 1878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* unused harmony export LineItemDetail */








var fields = [__WEBPACK_IMPORTED_MODULE_6__PurchaseOrders_constants__["O" /* AMOUNT_PAID */], __WEBPACK_IMPORTED_MODULE_2__constants__["_21" /* INVENTORY_ID */], "sell_as_alt_id", __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["G" /* LEAD_TIME */], __WEBPACK_IMPORTED_MODULE_4__OutgoingQuotes_constants__["b" /* PRICE_PER_UNIT */], __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["h" /* HAZMAT */], "bio_hazmat", "cancellation_reason", "customer_qc_preapproval_required", __WEBPACK_IMPORTED_MODULE_1__constants__["w" /* EXCHANGE_SALE */], __WEBPACK_IMPORTED_MODULE_1__constants__["G" /* EXCHANGE_SPECIAL_INSTRUCTIONS */], __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FLAT_EXCHANGE */], __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* SPECIAL_INSTRUCTIONS */], "core_due_days", "core_return_date", "core_return_due_date", "core_repair_charges", "repair_fee", "exchange_fee", "outright_value", "internal_outright", "invoice_number", "invoice_paid_date", "outgoing_awb_number", "seller_credit_percent", "dim_weight", "hazmat_fee", "container_fee", "release_for_shipment", __WEBPACK_IMPORTED_MODULE_1__constants__["K" /* REPAIR_ADMINISTRATION_CHARGE_DOLLARS */], __WEBPACK_IMPORTED_MODULE_1__constants__["I" /* REPAIR_ADMINISTRATION_CHARGE_PERCENTAGE */], __WEBPACK_IMPORTED_MODULE_1__constants__["T" /* REPAIR_ADMIN_CHARGE_TYPE */], "internal_note", "external_note", "warranty", "export_compliance_hold", "core_return_awb_number", "container_fee", "customer_to_return_container", "shipped_at"];

var LineItemDetail = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  cancellation_reason: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  condition: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  quantity: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  subtotal: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  internal_note: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  sell_as_alt: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
    part_number: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
  }),
  inventory: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    part: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
      part_number: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
    }).isRequired,
    location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    traced_to: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    tagged_by: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  }).isRequired
});

/***/ }),
/* 1879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Body__ = __webpack_require__(1812);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Body__["a"]; });



/***/ }),
/* 1880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Panel__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Body__ = __webpack_require__(1879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Actions__ = __webpack_require__(1811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Warnings__ = __webpack_require__(1914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Total__ = __webpack_require__(1900);
/* unused harmony export Detail */















function Detail(_ref) {
  var salesOrder = _ref.salesOrder;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "page-header page-header-bar" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h1",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "with-padding" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["J" /* RecordPager */], { baseUrl: "/sales-orders", record: salesOrder }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "header-content" },
            salesOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["z" /* CODE */])
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["E" /* ClipboardCopy */], { name: salesOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["z" /* CODE */]), type: "SO" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "small text-muted" },
            "Created ",
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(salesOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_7" /* CREATED_AT */]))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Actions__["a" /* default */], {
            id: salesOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* ID */]),
            salesOrder: salesOrder,
            cancelled: salesOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_38" /* CANCELLED */])
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Total__["a" /* default */], { salesOrder: salesOrder }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Warnings__["a" /* default */], { salesOrder: salesOrder })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "row" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Panel__["a" /* default */], { salesOrder: salesOrder.toJS() }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Body__["a" /* default */], { salesOrder: salesOrder.toJS() })
    )
  );
}

Detail.propTypes = {
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
};

var loader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["h" /* loadRecord */])({
  reducer: "salesOrderDetail",
  name: "salesOrder",
  action: function action(id) {
    return __WEBPACK_IMPORTED_MODULE_7__actions__["c" /* fetch */](id, "no_lines");
  }
});

/* harmony default export */ __webpack_exports__["a"] = (loader(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__decorators__["a" /* withSalesOrder */])(Detail)));

/***/ }),
/* 1881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Lots_constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(32);
/* unused harmony export Billing */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















function Billing(_ref) {
  var results = _ref.results,
      loading = _ref.loading;

  if (loading) return null;
  var lineItem = results[0];
  if (!lineItem) return null;
  var customerRma = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(lineItem, "customer_rmas[0]", null);
  var isFirstExchange = lineItem[__WEBPACK_IMPORTED_MODULE_12__constants__["w" /* EXCHANGE_SALE */]] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(lineItem.exchange_type) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(lineItem.core_repair_invoice_number);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components_Section__["a" /* default */],
    { title: "Billing", editable: false },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["a" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], { label: "Invoice #", value: lineItem[__WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_constants__["N" /* INVOICE_NUMBER */]] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Invoice Paid Date",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(lineItem[__WEBPACK_IMPORTED_MODULE_9__Lots_constants__["j" /* INVOICE_PAID_DATE */]])
      }),
      customerRma && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Customer RMA #",
        value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "a",
          {
            href: "/rmas/" + customerRma.uuid,
            target: "_blank",
            rel: "noopener noreferrer"
          },
          customerRma.code
        )
      }),
      isFirstExchange && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Cust. Core Repair Inv#",
        value: lineItem[__WEBPACK_IMPORTED_MODULE_12__constants__["O" /* CORE_REPAIR_INVOICE_NUMBER */]]
      }),
      isFirstExchange && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Cust. Rpr Inv Paid Date",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(lineItem[__WEBPACK_IMPORTED_MODULE_12__constants__["P" /* CORE_REPAIR_INVOICE_PAID */]])
      })
    )
  );
}

Billing.propTypes = _extends({
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
}, __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

var withListId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared_decorators__["d" /* translateProps */])(function () {
  return {
    listId: "salesOrders/lineItems"
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["b" /* default */])(withListId(__WEBPACK_IMPORTED_MODULE_11__orange_marmalade_paginate_this__["decorators"].tabulate(Billing))));

/***/ }),
/* 1882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);





var FirstExchangeWarning = function FirstExchangeWarning(_ref) {
  var lineItem = _ref.lineItem;

  if (!lineItem.exchange_sale) return null;
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(lineItem.exchange_type)) return null;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["n" /* Warning */],
    null,
    "Core Repair Invoice must be entered on the first exchange transaction for this item."
  );
};

FirstExchangeWarning.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (FirstExchangeWarning);

/***/ }),
/* 1883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Warning_Warning__ = __webpack_require__(53);




var LastExchangeWarning = function LastExchangeWarning(_ref) {
  var isLastExchange = _ref.isLastExchange;

  if (isLastExchange) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Invoice Paid Date must be entered on the most recent exchange transaction for this item. (i.e. 2nd exch or 3rd exch)."
  );
};

LastExchangeWarning.propTypes = {
  isLastExchange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (LastExchangeWarning);

/***/ }),
/* 1884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Billing__ = __webpack_require__(1881);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Billing__["a"]; });



/***/ }),
/* 1885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__orange_marmalade_paginate_this__);
/* unused harmony export Consignment */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















function Consignment(_ref) {
  var loading = _ref.loading,
      results = _ref.results;

  if (loading) return null;
  var lineItem = results[0];
  if (!lineItem) return null;
  var company = {
    id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, [__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_9__Receiving_constants__["v" /* CONSIGNMENT_REFERENCE_COMPANY_ID */]].join(".")),
    name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, [__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_9__Receiving_constants__["w" /* CONSIGNMENT_REFERENCE_COMPANY */], "name"].join(".")),
    company_type: null
  };

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, [__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_24" /* INVENTORY */], "consignment_type"].join(".")) !== __WEBPACK_IMPORTED_MODULE_9__Receiving_constants__["t" /* CONSIGNMENT */]) {
    return null;
  }

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_Section__["a" /* default */],
    { title: "Consignment", editable: false },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["a" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Consignment Ref. Co",
        value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["w" /* CompanyName */], { company: company })
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Consignment Ref #",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, [__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_9__Receiving_constants__["F" /* CONSIGNMENT_REFERENCE */]].join("."))
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Consignment Split",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_number__["a" /* percent */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, [__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_9__Receiving_constants__["I" /* CONSIGNOR_PERCENTAGE */]].join(".")), 100)
      })
    )
  )];
}

Consignment.propTypes = _extends({
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
}, __WEBPACK_IMPORTED_MODULE_5__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

var withListId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_decorators__["d" /* translateProps */])(function () {
  return {
    listId: "salesOrders/lineItems"
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__session_decorators_withCurrentUser__["b" /* default */])(withListId(__WEBPACK_IMPORTED_MODULE_12__orange_marmalade_paginate_this__["decorators"].tabulate(Consignment))));

/***/ }),
/* 1886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Consignment__ = __webpack_require__(1885);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Consignment__["a"]; });



/***/ }),
/* 1887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_NoteTooltip_NoteTooltip__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__EditDetails__ = __webpack_require__(1888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__ = __webpack_require__(11);
/* unused harmony export Details */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };























function ParentDetails(_ref) {
  var loading = _ref.loading,
      results = _ref.results;

  if (loading) return null;
  var itemWithParentExchange = results.find(function (i) {
    return i.parent_exchange_item;
  });
  if (!itemWithParentExchange) return null;

  var parentExchangeItem = itemWithParentExchange.parent_exchange_item;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "th",
      { className: "text-right" },
      "Original Sales Order"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
        { to: "/sales-orders/" + parentExchangeItem.uuid },
        parentExchangeItem.code
      )
    )
  );
}

var withListId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["d" /* translateProps */])(function () {
  return {
    listId: "salesOrders/lineItems"
  };
});

var ParentDetailsWithResults = withListId(__WEBPACK_IMPORTED_MODULE_17__orange_marmalade_paginate_this__["decorators"].tabulate(ParentDetails));

function Details(_ref2) {
  var salesOrder = _ref2.salesOrder,
      currentUser = _ref2.currentUser;

  var afterHoursText = salesOrder.get("after_hours") ? "Yes" : "No";
  var approvalText = function approvalText(timestamp, approver) {
    return "Updated by " + approver.get("full_name") + " on " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_date__["b" /* shortDate */])(timestamp);
  };
  var company = salesOrder.get("company");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_10__shared_components_Section__["a" /* default */],
    {
      title: "Details",
      modal: {
        title: "Edit Sales Order Details",
        content: function content(close) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__EditDetails__["a" /* default */], {
            initialValues: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_pojos__["a" /* default */])(salesOrder.toJS()).pick(__WEBPACK_IMPORTED_MODULE_16__constants__["N" /* COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_16__constants__["O" /* CONTACT_ID */], "credit_terms", "cc_email_address", "customer_purchase_order_number", __WEBPACK_IMPORTED_MODULE_16__constants__["_46" /* DISABLE_QB_SYNC */], "after_hours", "third_contact_email", "send_sales_order_acknowledgement", __WEBPACK_IMPORTED_MODULE_19__constants__["c" /* PICTURES_REQUIRED */], __WEBPACK_IMPORTED_MODULE_19__constants__["d" /* SPECIAL_INSTRUCTIONS */]),
            close: close
          });
        }
      },
      editable: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__users_helpers__["h" /* disableIfHasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_12__users_constants__["j" /* WAREHOUSE */]]) && (!salesOrder.get(__WEBPACK_IMPORTED_MODULE_16__constants__["_23" /* SHIPPED */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, __WEBPACK_IMPORTED_MODULE_12__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_12__users_constants__["m" /* ACCOUNTING */]))
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["a" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Cust. Code",
        value: salesOrder.getIn(["company", "code"])
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Cust. Name"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["w" /* CompanyName */], { company: salesOrder.toJS().company })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Cust. Phone",
        value: salesOrder.getIn(["company", "phone"])
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Cust. Fax",
        value: salesOrder.getIn(["company", "fax"])
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Cust. Terms",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_formatters_text__["c" /* properCase */])(salesOrder.get("credit_terms"))
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Blanket Exch. Agreement",
        value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          company.get("blanket_exchange_agreement") && company.get("blanket_exchange_agreement_updated_by") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "text-success" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check" }),
              " Approved"
            ),
            "\xA0",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "text-right" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_NoteTooltip_NoteTooltip__["a" /* default */], {
                placement: "right",
                icon: "fa-info-circle",
                color: "rgba(255, 255, 255, 0.25)",
                note: approvalText(company.get("blanket_exchange_agreement_updated_at"), company.get("blanket_exchange_agreement_updated_by"))
              })
            )
          )
        )
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["a" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Cust. Contact",
        value: salesOrder.getIn(["contact", "name"])
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Contact Email",
        value: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "a",
          { href: "mailto:" + salesOrder.getIn(["contact", "email"]) },
          " ",
          salesOrder.getIn(["contact", "email"]),
          " "
        )]
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Contact Email #2",
        value: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "a",
          { href: "mailto:" + salesOrder.get("cc_email_address") },
          " ",
          salesOrder.get("cc_email_address"),
          " "
        )]
      }),
      salesOrder.get("third_contact_email") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Contact Email #3",
        value: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "a",
          { href: "mailto:" + salesOrder.get("third_contact_email") },
          " ",
          salesOrder.get("third_contact_email"),
          " "
        )]
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Cust. PO #",
        value: salesOrder.get("customer_purchase_order_number")
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], { label: "After Hours", value: afterHoursText }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["c" /* CheckForDetail */], {
        label: __WEBPACK_IMPORTED_MODULE_19__constants__["y" /* SEND_SALES_ORDER_ACKNOWLEDGEMENT_LABEL */],
        value: salesOrder.get("send_sales_order_acknowledgement"),
        icon: "eye-slash"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ParentDetailsWithResults, null)
    )
  );
}

Details.propTypes = _extends({
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
}, __WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__session_decorators_withCurrentUser__["b" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__decorators__["a" /* withSalesOrder */])(Details)));

/***/ }),
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decorators_withSalesOrder__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_FormSections_CustomerSection__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form__ = __webpack_require__(1889);







/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decorators_withSalesOrder__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(undefined, {
  onSubmit: __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* update */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["j" /* form */])({
  form: "salesOrderDetails",
  validate: __WEBPACK_IMPORTED_MODULE_3__shared_FormSections_CustomerSection__["a" /* validate */]
})(__WEBPACK_IMPORTED_MODULE_5__Form__["a" /* default */]))));

/***/ }),
/* 1889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_FormSections_CustomerSection__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_helpers__ = __webpack_require__(41);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }














function Form(_ref) {
  var salesOrder = _ref.salesOrder,
      currentUser = _ref.currentUser,
      props = _objectWithoutProperties(_ref, ["salesOrder", "currentUser"]);

  var canEditCompany = salesOrder.get(__WEBPACK_IMPORTED_MODULE_7__constants__["_10" /* CREATED_BY_ID */]) === currentUser.id || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_3__users_constants__["m" /* ACCOUNTING */]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_FormSections_CustomerSection__["b" /* default */], {
        formName: "editSalesOrderCustomer",
        company: salesOrder.toJS().company,
        creditTerms: salesOrder.getIn([__WEBPACK_IMPORTED_MODULE_9__companies_constants__["p" /* COMPANY */], "customer_credit_terms"]),
        afterHours: salesOrder.get(__WEBPACK_IMPORTED_MODULE_8__constants__["Z" /* AFTER_HOURS */]),
        canEditCompany: canEditCompany,
        setFieldValue: function setFieldValue(field) {
          return function (val) {
            return props.change(field, val);
          };
        },
        setPrimaryContact: false
      })
    )
  );
}

Form.propTypes = _extends({
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
}, __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["b" /* default */])(Form));

/***/ }),
/* 1890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Details__ = __webpack_require__(1887);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Details__["a"]; });



/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReleaseDetails_ReleaseDetails__ = __webpack_require__(1892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Details__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Billing__ = __webpack_require__(1884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ShipTo__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ReturnTo__ = __webpack_require__(1895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Consignment__ = __webpack_require__(1886);
/* harmony export (immutable) */ __webpack_exports__["a"] = Panel;












function Panel(_ref) {
  var salesOrder = _ref.salesOrder;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
    { md: 3 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "panel panel-default" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "panel-body" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Details__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ReleaseDetails_ReleaseDetails__["a" /* default */], { salesOrder: salesOrder }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Consignment__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Billing__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ShipTo__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ReturnTo__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["z" /* AuditFields */], { record: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(salesOrder), multiLine: true })
      )
    )
  );
}

Panel.propTypes = {
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired
};

/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(32);
/* unused harmony export Details */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















var UpdatedByDetails = function UpdatedByDetails(_ref) {
  var row = _ref.row;

  if (!row.get(__WEBPACK_IMPORTED_MODULE_12__constants__["X" /* RELEASED */])) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    null,
    "Updated By",
    "   ",
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["d" /* getFirstNameLastInitial */])(row.getIn([__WEBPACK_IMPORTED_MODULE_10__constants__["_57" /* UPDATED_BY */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["f" /* FULL_NAME */]])),
    "\xA0on",
    " ",
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_date__["a" /* shortDateYYandTime */])(row.get(__WEBPACK_IMPORTED_MODULE_10__constants__["_48" /* UPDATED_AT */]))
  );
};

function Details(_ref2) {
  var salesOrder = _ref2.salesOrder;

  var reasons = salesOrder.get(__WEBPACK_IMPORTED_MODULE_12__constants__["Y" /* RELEASE_FOR_SHIPMENT_DETAILS */]);

  if (!reasons) return null;
  if (reasons.length === 0) return null;
  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_Section__["a" /* default */],
    { title: "Release Details", editable: false },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["a" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Reason"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Release Details"
        )
      ),
      reasons.map(function (r) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            r.get(__WEBPACK_IMPORTED_MODULE_11__parts_constants__["u" /* DESCRIPTION */])
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UpdatedByDetails, { row: r })
        );
      })
    )
  )];
}

Details.propTypes = _extends({
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
}, __WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__["b" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__decorators__["a" /* withSalesOrder */])(Details)));

/***/ }),
/* 1893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_FormSections_ShippingSection_validate__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Orders_shared_ShippingFields_ShippingFields__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* unused harmony export Form */












function Form(props) {
  var salesOrder = props.salesOrder,
      _props$hasExchange = props.hasExchange,
      hasExchange = _props$hasExchange === undefined ? false : _props$hasExchange;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_redux_form__["FormSection"],
        { name: "" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Return To"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Orders_shared_ShippingFields_ShippingFields__["a" /* default */], {
          shipToCompany: salesOrder.toJS().return_to_company,
          key: "return-to-shipping-fields",
          formName: "salesOrderReturnToDetails",
          path: __WEBPACK_IMPORTED_MODULE_10__constants__["_39" /* RETURN_TO */],
          renderCarrier: !hasExchange,
          shippingFields: [__WEBPACK_IMPORTED_MODULE_10__constants__["C" /* RETURN_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_10__constants__["_42" /* RETURN_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_10__constants__["_43" /* RETURN_TO_COMPANY_ADDRESS_ID */]],
          shippingMethod: __WEBPACK_IMPORTED_MODULE_10__constants__["_41" /* RETURN_TO_SHIPPING_METHOD */],
          shippingTypes: [],
          shippingAddressField: __WEBPACK_IMPORTED_MODULE_10__constants__["_44" /* RETURN_TO_SHIPPING_ADDRESS */],
          required: hasExchange,
          locationFieldName: __WEBPACK_IMPORTED_MODULE_10__constants__["_25" /* RETURN_TO_LOCATION_ID */]
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
          name: "return_to_fob",
          component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
          label: "Return To FOB",
          required: true
        })
      )
    )
  );
}

Form.propTypes = {
  salesOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  hasExchange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, {
  onSubmit: __WEBPACK_IMPORTED_MODULE_9__actions__["d" /* update */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__decorators__["a" /* withSalesOrder */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: "salesOrderReturnToDetails",
  validate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_FormSections_ShippingSection_validate__["b" /* validateForShippingType */])("return_to")
})(Form))));

/***/ }),
/* 1894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Orders_shared_ShippingAddress__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Form__ = __webpack_require__(1893);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



















function ReturnTo(_ref) {
  var salesOrderWithAllLineItems = _ref.salesOrderWithAllLineItems,
      currentUser = _ref.currentUser;

  var initialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_pojos__["a" /* default */])(salesOrderWithAllLineItems.toJS()).pick(__WEBPACK_IMPORTED_MODULE_11__constants__["C" /* RETURN_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_11__constants__["_40" /* RETURN_TO_FOB */], __WEBPACK_IMPORTED_MODULE_11__constants__["_42" /* RETURN_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_11__constants__["_43" /* RETURN_TO_COMPANY_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_11__constants__["_53" /* RETURN_TO_CUSTOMER_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_11__constants__["_25" /* RETURN_TO_LOCATION_ID */], __WEBPACK_IMPORTED_MODULE_11__constants__["_44" /* RETURN_TO_SHIPPING_ADDRESS */], __WEBPACK_IMPORTED_MODULE_11__constants__["_41" /* RETURN_TO_SHIPPING_METHOD */]);

  var hasExchange = salesOrderWithAllLineItems.get("has_exchange");

  var userCanEditReturnToFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_7__users_constants__["k" /* SALES */]);

  var renderForm = function renderForm(close) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Form__["a" /* default */], {
      close: close,
      salesOrder: salesOrderWithAllLineItems.toJS(),
      initialValues: initialValues,
      renderCarrier: !!hasExchange
    });
  };

  if (!hasExchange) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Section__["a" /* default */],
    {
      title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_11__constants__["_39" /* RETURN_TO */]),
      modal: {
        title: "Edit Sales Order - Return To",
        content: renderForm
      },
      editable: userCanEditReturnToFields && !salesOrderWithAllLineItems.get(__WEBPACK_IMPORTED_MODULE_11__constants__["A" /* LINE_ITEMS */]).some(function (l) {
        return l.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_26" /* RECEIVED */]);
      }) && !salesOrderWithAllLineItems.get(__WEBPACK_IMPORTED_MODULE_11__constants__["A" /* LINE_ITEMS */]).some(function (l) {
        return l.get(__WEBPACK_IMPORTED_MODULE_8__constants__["g" /* INVOICE_PAID_DATE */]);
      })
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Orders_shared_ShippingAddress__["a" /* default */], {
      shippingType: __WEBPACK_IMPORTED_MODULE_11__constants__["_39" /* RETURN_TO */],
      record: salesOrderWithAllLineItems,
      renderPreferences: !hasExchange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null)
  );
}

ReturnTo.propTypes = _extends({
  salesOrderWithAllLineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
}, __WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__session_decorators_withCurrentUser__["b" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_react_router__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_react_redux__["connect"])(function (state) {
  return {
    salesOrderWithAllLineItems: state.salesOrderWithAllLineItemsDetail.get("salesOrderWithAllLineItems")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__shared_decorators__["h" /* loadRecord */])({
  reducer: "salesOrderWithAllLineItemsDetail",
  name: "salesOrderWithAllLineItems",
  action: function action(id) {
    return __WEBPACK_IMPORTED_MODULE_15__actions__["a" /* fetchSalesOrderWithAllLineItems */](id);
  }
})(ReturnTo)))));

/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReturnTo__ = __webpack_require__(1894);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ReturnTo__["a"]; });



/***/ }),
/* 1896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_FormSections_ShippingSection__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_ShippingSection__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_FinalDestination_FinalDestinationFields__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_Warnings_DoNotDoBusinessShippingWarning__ = __webpack_require__(454);
/* unused harmony export Form */


















var FORM_NAME = "salesOrderShipToDetails";

function Form(props) {
  var salesOrderWithAllLineItems = props.salesOrderWithAllLineItems;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_redux_form__["FormSection"],
        { name: "" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Ship To"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_Warnings_DoNotDoBusinessShippingWarning__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__shared_components_ShippingSection__["a" /* ShippingSection */],
          {
            shippingType: __WEBPACK_IMPORTED_MODULE_12__constants__["B" /* SHIP_TO */],
            shipToCustomer: salesOrderWithAllLineItems.get(__WEBPACK_IMPORTED_MODULE_12__constants__["i" /* COMPANY */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()).toJS(),
            shipToCompany: salesOrderWithAllLineItems.get("ship_to_company"),
            beforeShippingMethod: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_FinalDestination_FinalDestinationFields__["a" /* default */], {
              change: props.change,
              formName: FORM_NAME
            }),
            convertSO: false,
            wtDimsReq: true
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm hr-dashed margin-top-none" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { xs: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: "ship_to_fob",
                component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                label: "Ship To FOB",
                required: true
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_FormSections_ShippingSection__["a" /* default */], {
            disablePicturesRequired: salesOrderWithAllLineItems.get(__WEBPACK_IMPORTED_MODULE_12__constants__["A" /* LINE_ITEMS */]).filter(function (l) {
              return !l.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_38" /* CANCELLED */]);
            }).every(function (l) {
              return l.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_23" /* SHIPPED */]);
            })
          })
        )
      )
    )
  );
}

Form.propTypes = {
  salesOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__session_decorators_withCurrentUser__["b" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_react_router__["withRouter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    salesOrderWithAllLineItems: state.salesOrderWithAllLineItemsDetail.get("salesOrderWithAllLineItems")
  };
}, {
  onSubmit: function onSubmit(data) {
    return __WEBPACK_IMPORTED_MODULE_9__actions__["d" /* update */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers__["i" /* transformSO */])(data));
  }
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__shared_decorators__["h" /* loadRecord */])({
  reducer: "salesOrderWithAllLineItemsDetail",
  name: "salesOrderWithAllLineItems",
  action: function action(id) {
    return __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* fetchSalesOrderWithAllLineItems */](id);
  }
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_7__shared_FormSections_ShippingSection__["b" /* validate */]
})(Form))))));

/***/ }),
/* 1897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_strings__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Section__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Orders_shared_ShippingAddress__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_FinalDestination__ = __webpack_require__(2301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Form__ = __webpack_require__(1896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(32);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



















function ShipTo(_ref) {
  var salesOrder = _ref.salesOrder,
      currentUser = _ref.currentUser;

  var initialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_pojos__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helpers__["g" /* mapSOToForm */])(salesOrder.toJS())).pick(__WEBPACK_IMPORTED_MODULE_13__constants__["N" /* COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_13__constants__["O" /* CONTACT_ID */], __WEBPACK_IMPORTED_MODULE_13__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_13__constants__["_20" /* SHIP_TO_FOB */], __WEBPACK_IMPORTED_MODULE_13__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_13__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_13__constants__["_2" /* SHIP_TO_CUSTOMER_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_13__constants__["_17" /* SHIP_TO_SHIPPING_ADDRESS */], __WEBPACK_IMPORTED_MODULE_13__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */], __WEBPACK_IMPORTED_MODULE_13__constants__["l" /* DISCREET */], "customer_to_provide_own_paperwork", __WEBPACK_IMPORTED_MODULE_16__constants__["d" /* SPECIAL_INSTRUCTIONS */], "final_destination_name", "final_destination_phone", "final_destination_email", "final_destination_reference", "final_destination_address", "final_destination_company_name", __WEBPACK_IMPORTED_MODULE_16__constants__["c" /* PICTURES_REQUIRED */]);

  var userCanEditShipToFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__users_helpers__["i" /* hasAnyOfRolesOrSubroles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_5__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["k" /* SALES */]], [__WEBPACK_IMPORTED_MODULE_5__users_constants__["t" /* WAREHOUSE_EXPERT */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["s" /* WAREHOUSE_MANAGER */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]);

  var renderForm = function renderForm(close) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Form__["a" /* default */], {
      close: close,
      salesOrder: salesOrder.toJS(),
      initialValues: initialValues
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components_Section__["a" /* default */],
    {
      title: "Ship To",
      modal: {
        title: "Edit Sales Order - Ship To",
        content: renderForm
      },
      editable: userCanEditShipToFields && !salesOrder.get("partially_shipped")
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["a" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], {
        label: "Discreet",
        value: salesOrder.get("discreet"),
        icon: "eye-slash"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], {
        label: "Special Instructions",
        value: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_strings__["a" /* default */])(salesOrder.get("special_instructions")).empty()
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["c" /* CheckForDetail */], {
        label: "Customer P/W",
        value: salesOrder.get("customer_to_provide_own_paperwork")
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Orders_shared_ShippingAddress__["a" /* default */], { shippingType: __WEBPACK_IMPORTED_MODULE_13__constants__["B" /* SHIP_TO */], record: salesOrder }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_FinalDestination__["a" /* FinalDestinationDetails */], { shippingType: __WEBPACK_IMPORTED_MODULE_13__constants__["B" /* SHIP_TO */], record: salesOrder })
  );
}

ShipTo.propTypes = _extends({
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
}, __WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__["b" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__decorators__["a" /* withSalesOrder */])(ShipTo)));

/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShipTo__ = __webpack_require__(1897);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ShipTo__["a"]; });



/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Panel__ = __webpack_require__(1891);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Panel__["a"]; });



/***/ }),
/* 1900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__);







function Total(_ref) {
  var salesOrder = _ref.salesOrder,
      results = _ref.results,
      loading = _ref.loading;

  if (loading) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "pull-right" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "small text-muted" },
      results.length,
      " Item(s)"
    ),
    "\xA0\xA0Total: ",
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(salesOrder.get("total"))
  );
}

var withListId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["d" /* translateProps */])(function () {
  return {
    listId: "salesOrders/lineItems"
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withListId(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__["decorators"].tabulate(Total)));

Total.propTypes = {
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* unused harmony export AccountHold */






function AccountHold(_ref) {
  var hold = _ref.hold;

  return hold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["p" /* StatusTag */], { key: "warning", title: "Acctg. Hold", icon: "warning" });
}

AccountHold.propTypes = {
  hold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var salesOrder = _ref2.salesOrder;
  return {
    hold: salesOrder.get("accounting_hold")
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decorators__["a" /* withSalesOrder */])(withProps(AccountHold)));

/***/ }),
/* 1902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);




function Consignment(_ref) {
  var lineItems = _ref.lineItems;

  var asIsItem = lineItems.find(function (l) {
    return l.as_is;
  });

  if (asIsItem) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["p" /* StatusTag */], { key: "warning", title: "Sold As-Is", icon: "exclamation-triangle" });
  }

  return null;
}

Consignment.propTypes = {
  lineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    as_is: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Consignment);

/***/ }),
/* 1903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* unused harmony export Cancelled */







function Cancelled(_ref) {
  var cancelled = _ref.cancelled;

  return cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["p" /* StatusTag */], { key: "warning", title: "Cancelled", icon: "warning" });
}

Cancelled.propTypes = {
  cancelled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var salesOrder = _ref2.salesOrder;
  return {
    cancelled: salesOrder.get(__WEBPACK_IMPORTED_MODULE_5__constants__["_38" /* CANCELLED */])
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decorators__["a" /* withSalesOrder */])(withProps(Cancelled)));

/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);




function Consignment(_ref) {
  var lineItems = _ref.lineItems;

  var consignmentType = lineItems.find(function (l) {
    return l.inventory.consignment_type;
  });

  if (consignmentType) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["p" /* StatusTag */], {
      key: "consignment",
      display: "warning",
      title: consignmentType.inventory.consignment_type.toUpperCase(),
      icon: "location-arrow"
    });
  }

  var consigned = lineItems.find(function (l) {
    return l.inventory.consigned_date;
  });

  if (consigned) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["p" /* StatusTag */], {
      key: "consignment",
      display: "warning",
      title: "Consignment",
      icon: "location-arrow"
    });
  }

  return null;
}

Consignment.propTypes = {
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (Consignment);

/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);




function ExchangeAgreementHold(_ref) {
  var salesOrder = _ref.salesOrder;

  var hold = salesOrder.get("exchange_agreement_hold");

  if (hold) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["p" /* StatusTag */], {
      display: "warning",
      title: "Awaiting Exchange Agreement",
      icon: "pause"
    });
  }

  return null;
}

ExchangeAgreementHold.propTypes = {
  salesOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    get: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  }).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ExchangeAgreementHold);

/***/ }),
/* 1906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* unused harmony export ExportComplianceHold */






function ExportComplianceHold(_ref) {
  var hold = _ref.hold;

  return hold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["p" /* StatusTag */], { title: "Export Compl Hold", icon: "pause" });
}

ExportComplianceHold.propTypes = { hold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired };

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var lineItems = _ref2.lineItems;
  return {
    hold: lineItems.filter(function (l) {
      return !l.cancelled;
    }).filter(function (l) {
      return !l.shipped;
    }).some(function (i) {
      return i.export_compliance_hold;
    })
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withSalesOrder */])(withProps(ExportComplianceHold)));

/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Receiving_constants__ = __webpack_require__(34);
/* unused harmony export NewCompanyHold */







function NewCompanyHold(_ref) {
  var hold = _ref.hold;

  return hold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["p" /* StatusTag */], { key: "warning", title: "New Cust. Hold", icon: "warning" });
}

NewCompanyHold.propTypes = {
  hold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var salesOrder = _ref2.salesOrder;
  return {
    hold: salesOrder.get(__WEBPACK_IMPORTED_MODULE_5__Receiving_constants__["Q" /* NEW_COMPANY_HOLD */])
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decorators__["a" /* withSalesOrder */])(withProps(NewCompanyHold)));

/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inventories_constants__ = __webpack_require__(12);
/* unused harmony export QCHold */







function QCHold(_ref) {
  var hold = _ref.hold;

  return hold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["p" /* StatusTag */], { title: "QC Hold", icon: "pause" });
}

QCHold.propTypes = { hold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired };

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var lineItems = _ref2.lineItems;
  return {
    hold: lineItems.filter(function (l) {
      return !l.cancelled;
    }).some(function (i) {
      return i.qc_status === __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["S" /* QC_HOLD */];
    })
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withSalesOrder */])(withProps(QCHold)));

/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* unused harmony export QCPreApproval */






function QCPreApproval(_ref) {
  var hold = _ref.hold;

  return hold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["p" /* StatusTag */], { title: "QC Pre-Approval Required", icon: "pause" });
}

QCPreApproval.propTypes = { hold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired };

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var lineItems = _ref2.lineItems;
  return {
    hold: lineItems.filter(function (l) {
      return !l.cancelled;
    }).some(function (i) {
      return i.customer_qc_preapproval_required;
    })
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withSalesOrder */])(withProps(QCPreApproval)));

/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* unused harmony export RMA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CustomerRmaWarning; });
/* unused harmony export CancelledRma */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CancelledCustomerRmaWarning; });
/* unused harmony export ResolvedRmaTag */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ResolvedRmaWarning; });






function RMA(_ref) {
  var rma = _ref.rma,
      wcAndCreditRequested = _ref.wcAndCreditRequested;

  return rma && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["p" /* StatusTag */], {
    title: "RMA Requested " + (wcAndCreditRequested ? "for WC & Credit" : ""),
    icon: "cog"
  });
}

RMA.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  wcAndCreditRequested: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var lineItems = _ref2.lineItems;
  return {
    rma: lineItems.some(function (lineItem) {
      return lineItem.customer_rmas.some(function (rma) {
        return !rma.cancelled;
      });
    }),
    wcAndCreditRequested: lineItems.filter(function (lineItem) {
      return !lineItem.cancelled;
    }).some(function (lineItem) {
      return lineItem.customer_rmas.some(function (rma) {
        return rma.warranty_consideration && rma.credit_requested && !rma.cancelled;
      });
    }),
    cancelledRma: lineItems.filter(function (lineItem) {
      return !lineItem.cancelled;
    }).some(function (lineItem) {
      return lineItem.customer_rmas.length > 0 && lineItem.customer_rmas.every(function (rma) {
        return rma.cancelled;
      });
    }),
    resolvedRma: lineItems.some(function (lineItem) {
      return lineItem.customer_rmas.some(function (rma) {
        return !rma.cancelled && rma.shipped && rma.outgoing_awb_number;
      });
    })
  };
});

var CustomerRmaWarning = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withSalesOrder */])(withProps(RMA));

function CancelledRma(_ref3) {
  var cancelledRma = _ref3.cancelledRma;

  return cancelledRma && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["p" /* StatusTag */], { title: "Cancelled Customer RMA", icon: "ban" });
}

var CancelledCustomerRmaWarning = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withSalesOrder */])(withProps(CancelledRma));

function ResolvedRmaTag(_ref4) {
  var resolvedRma = _ref4.resolvedRma;

  return resolvedRma && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["p" /* StatusTag */], { title: "Resolved RMA", icon: "check-circle", display: "success" });
}

var ResolvedRmaWarning = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withSalesOrder */])(withProps(ResolvedRmaTag));

/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* unused harmony export Shipped */






function Shipped(_ref) {
  var shipped = _ref.shipped;

  return shipped && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["p" /* StatusTag */], {
    key: "shipped",
    title: "Shipped",
    icon: "check-circle",
    display: "success"
  });
}

Shipped.propTypes = {
  shipped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var salesOrder = _ref2.salesOrder;
  return {
    shipped: salesOrder.get("shipped")
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decorators__["a" /* withSalesOrder */])(withProps(Shipped)));

/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inventories_constants__ = __webpack_require__(12);
/* unused harmony export UnderReview */







function UnderReview(_ref) {
  var review = _ref.review;

  return review && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["p" /* StatusTag */], { title: "Under Review", icon: "search", display: "warning" });
}

UnderReview.propTypes = { review: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired };

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var lineItems = _ref2.lineItems;
  return {
    review: lineItems.filter(function (l) {
      return !l.cancelled;
    }).some(function (i) {
      return i.qc_status === __WEBPACK_IMPORTED_MODULE_5__inventories_constants__["T" /* UNDER_REVIEW */];
    })
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* withSalesOrder */])(withProps(UnderReview)));

/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AsIs__ = __webpack_require__(1902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccountingHold__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ExchangeAgreement__ = __webpack_require__(1905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Cancelled__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__QCHold__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__QCPreApproval__ = __webpack_require__(1909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NewCompanyHold__ = __webpack_require__(1907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ExportComplianceHold__ = __webpack_require__(1906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__UnderReview__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Shipped__ = __webpack_require__(1911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Consignment__ = __webpack_require__(1904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__RMA__ = __webpack_require__(1910);


















function Warnings(_ref) {
  var loading = _ref.loading,
      results = _ref.results,
      salesOrder = _ref.salesOrder;

  if (loading) return null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["K" /* StatusTags */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AsIs__["a" /* default */], { lineItems: results }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AccountingHold__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Cancelled__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Consignment__["a" /* default */], { lineItems: results }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ExportComplianceHold__["a" /* default */], { lineItems: results }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__QCHold__["a" /* default */], { lineItems: results }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__RMA__["a" /* CancelledCustomerRmaWarning */], { lineItems: results }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__RMA__["b" /* CustomerRmaWarning */], { lineItems: results }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NewCompanyHold__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__RMA__["c" /* ResolvedRmaWarning */], { lineItems: results }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__QCPreApproval__["a" /* default */], { lineItems: results }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__UnderReview__["a" /* default */], { lineItems: results }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Shipped__["a" /* default */], null),
    salesOrder.get(__WEBPACK_IMPORTED_MODULE_4__Receiving_constants__["P" /* EXPORT_HOLD */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["p" /* StatusTag */], { title: "Denied Party", icon: "pause" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ExchangeAgreement__["a" /* default */], { salesOrder: salesOrder })
  );
}

var withListId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_decorators__["d" /* translateProps */])(function () {
  return {
    listId: "salesOrders/lineItems"
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withListId(__WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__["decorators"].tabulate(Warnings)));

/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Warnings__ = __webpack_require__(1913);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Warnings__["a"]; });



/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Detail__ = __webpack_require__(1880);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Detail__["a"]; });



/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__StatusTags__ = __webpack_require__(1918);
/* unused harmony export Row */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

















var WarningsIcons = function WarningsIcons(_ref) {
  var lineItem = _ref.lineItem;

  var hasHazmat = lineItem.hazmat;
  var hasBioHazmat = lineItem.bio_hazmat;
  var hasContainerFee = lineItem.container_fee && parseFloat(lineItem.container_fee) > 0;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { style: { display: "flex", alignItems: "center" } },
    hasHazmat && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
      icon: "fa-warning",
      placement: "top",
      note: "Hazmat Fee",
      color: "#f44336",
      style: { marginRight: "3px" }
    }),
    hasContainerFee && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
      icon: "fa-dollar",
      placement: "top",
      note: "Container Fee",
      color: "#2196F3",
      style: { marginRight: "3px" }
    }),
    hasBioHazmat && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
      icon: "fa-flask",
      placement: "top",
      note: "Bio Hazmat",
      color: "#f44336"
    })
  );
};

WarningsIcons.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    container_fee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
  }).isRequired
};

function Row(_ref2) {
  var lineItem = _ref2.lineItem,
      statuses = _ref2.statuses;

  var lastSoNote = lineItem.notes.map(function (n) {
    return n.body;
  }).join("<br/><br/>");
  var pricePerUnit = lineItem.exchange_sale ? lineItem.exchange_fee : lineItem.price_per_unit;
  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__hooks__["a" /* useCurrentUser */])();
  var hasWareHouses = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(currentUser, "tenant.ware_houses", []).length > 0;
  var reserveForSale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, "inventory.brokered_sale", false);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components__["A" /* LinkedTableRow */],
    {
      to: "/sales-orders/" + lineItem.sales_order_uuid,
      className: (lineItem.cancelled || lineItem.credit_exchange) && "text-muted"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.after_hours && !lineItem.internal_outright && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
        icon: "fa-clock-o",
        placement: "top",
        note: "After Hours",
        color: "#4CAF50" // Green color for the clock icon
        , style: { marginRight: "2px" } // Reduced margin for closer spacing
      }),
      lineItem.exporting && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
        icon: "fa-globe",
        placement: "top",
        note: "Exporting",
        color: "#2196F3" // Blue color for the globe icon
      }),
      reserveForSale && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
        icon: "fa-bolt",
        placement: "top",
        note: "Brokered",
        color: "#4787F8"
      })
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers__["d" /* displayCustRmaWarning */])(lineItem) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
        icon: "fa-cog",
        placement: "top",
        note: "Cust. RMA",
        color: "#FFFFFF"
      })
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.sales_order_code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["a" /* shortDateYYandTime */])(lineItem.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["w" /* CompanyName */], { flattenedCompany: lineItem, truncateAt: 25 })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.seller.full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.invoice_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["c" /* shortDateYY */])(lineItem.invoice_paid_date)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.customer_purchase_order_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["o" /* LocationFlag */], {
        location: lineItem.store_owner_id,
        consignment_type: lineItem.inventory.consignment_type,
        consignedDate: lineItem.inventory.consigned_date,
        inventory: lineItem.inventory
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["o" /* LocationFlag */], { location: lineItem.store_location_id })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.location === "Shipped to Customer" ? "Shipped" : lineItem.location
    ),
    hasWareHouses && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.inventory && lineItem.inventory.ware_house_name || ""
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WarningsIcons, { lineItem: lineItem })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["h" /* PartNumber */], { part: lineItem.part })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.sell_as_alt_name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          to: "/inventories/" + (lineItem.inventory.uuid || lineItem.inventory_id)
        },
        lineItem.serial_number
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constants__["z" /* condition */])(lineItem.condition).abbrev
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      lineItem.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__helpers__["a" /* ExchangeIcon */], { lineItem: lineItem })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers__["j" /* getCost */])(lineItem))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(pricePerUnit)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      lineItem.exchange_sale && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(lineItem.outright_value)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(pricePerUnit - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers__["j" /* getCost */])(lineItem))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__StatusTags__["a" /* default */], statuses)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], { note: lastSoNote })
  );
}

Row.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    created_at: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    company_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    contact_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    total: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    seller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    }).isRequired
  }).isRequired,
  statuses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape.isRequired
};

var statuses = function statuses(lineItem) {
  return {
    qcHold: lineItem.qc_status === __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["S" /* QC_HOLD */],
    accHold: lineItem.accounting_hold,
    qcPreapprovalRequired: lineItem.customer_qc_preapproval_required,
    exportHold: lineItem.export_compliance_hold,
    deniedPartyHold: lineItem.export_hold,
    newCompanyHold: lineItem.new_company_hold
  };
};

var withProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["d" /* translateProps */])(function (s) {
  return {
    lineItem: s,
    key: s.id,
    statuses: _extends({}, statuses(s))
  };
}, {
  erase: true
});

/* harmony default export */ __webpack_exports__["a"] = (withProps(Row));

/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_DateRangePicker_DateRangePicker__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Sum__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Table__ = __webpack_require__(1920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pagination__ = __webpack_require__(330);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






















var defaultFilters = {
  brokered: undefined,
  cancelled: undefined,
  consignment: undefined,
  cores_received: undefined,
  current_user: undefined,
  current_user_commissions: undefined,
  customer_rma: undefined,
  exchange_sale: undefined,
  exchange_converted_to_outright: undefined,
  freight_not_complete: undefined,
  invoice_unpaid: undefined,
  qc_hold: undefined,
  shipped: undefined,
  not_shipped: undefined,
  show_invoiced: undefined,
  warranty_consideration: undefined,
  outright_sale: undefined,
  denied_party_hold: undefined,
  new_company_holed: undefined,
  store_id: undefined
};

var baseFilters = [{
  label: "My SOs",
  filters: { current_user: true }
}, {
  label: "My Commissions",
  filters: { current_user_commissions: true }
}, {
  label: "Exchanges",
  filters: { exchange_sale: true }
}, {
  label: "Brokered",
  filters: { brokered: true }
}, {
  label: "Consignments",
  filters: { consignment: true }
}, {
  label: "Core Repair Invoices Not Paid",
  filters: { exchange_sale: true, core_repair_invoices_not_paid: true }
}, {
  label: "Denied Parties Hold",
  filters: { denied_party_hold: true }
}, {
  label: "New Company Hold",
  filters: { new_company_hold: true }
}, {
  label: "Core Repair Inv # Missing",
  filters: {
    exchange_sales: true,
    cores_received: true,
    core_repair_invoice_missing: true
  }
}, {
  label: "Customer Invoices Not Paid",
  filters: { invoice_unpaid: true }
}, {
  label: "Internal Outright",
  filters: { internal_outright: true }
}, {
  label: "Exchange Converted to Outright",
  filters: { exchange_converted_to_outright: true }
}, {
  label: "Exchange Gone Outright",
  filters: { outright_sale: true }
}, {
  label: "Final Freight Not Confirmed",
  filters: { freight_not_complete: true }
}, {
  label: "Invoiced",
  filters: { show_invoiced: true }
}, {
  label: "Not Invoiced",
  filters: { show_invoiced: false }
}, {
  label: "Synced with Accounting",
  filters: {
    accounting_synced: true
  }
}, {
  label: "Not Synced with Accounting",
  filters: {
    accounting_synced: false
  }
}, {
  label: "Not Paid",
  filters: { not_paid: true }
}, {
  label: "Cores Received",
  filters: { cores_received: true, exchange_sale: true }
}, {
  label: "Cores Not Received",
  filters: { cores_received: false, exchange_sale: true }
}, {
  label: "Accounting Hold",
  filters: { accounting_hold: true, cancelled: false }
}, {
  label: "Cancelled",
  filters: { cancelled: true }
}, {
  label: "Not Cancelled",
  filters: { cancelled: false }
}, {
  label: "QC Hold",
  filters: { qc_hold: true }
}, {
  label: "Shipped",
  filters: { shipped: true }
}, {
  label: "Not Shipped",
  filters: { not_shipped: true }
}, {
  label: "Cust Rma",
  filters: { customer_rma: true }
}, {
  label: "No Cust Rma",
  filters: { customer_rma: false }
}, {
  label: "Export Compliance Hold",
  filters: { export_compliance_hold: true }
}, {
  label: "Warnings Only",
  filters: { warnings: true }
}, {
  label: "Warranty Returns",
  filters: { warranty_consideration: true },
  hr: true
}];

var baseFilterTags = [{
  label: "Accounting Hold",
  key: "accounting_hold"
}, {
  label: "Accounting Synced",
  key: "accounting_synced",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Brokered",
  key: "brokered"
}, {
  label: "Not Synced w/ Accounting",
  key: "accounting_synced",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Core Repair Invoices Not Paid",
  key: "core_repair_invoices_not_paid"
}, {
  label: "Core Repair Inv # Missing",
  key: "core_repair_invoice_missing"
}, {
  label: "Customer Invoices Not Paid",
  key: "invoice_unpaid",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Denied Parties Hold",
  key: "denied_party_hold",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "New Company Hold",
  key: "new_company_hold",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "My Sales Orders",
  key: "current_user"
}, {
  label: "Consignments",
  key: "consignment"
}, {
  label: "My Commissions",
  key: "current_user_commissions"
}, {
  label: "Exchanges",
  key: "exchange_sale"
}, {
  label: "Internal Outright",
  key: "internal_outright"
}, {
  label: "Exchange Converted to Outright",
  key: "exchange_converted_to_outright",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Exchange Gone Outright",
  key: "outright_sale"
}, {
  label: "Final Freight Not Confirmed",
  key: "freight_not_complete",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Invoiced",
  key: "show_invoiced",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Invoiced",
  key: "show_invoiced",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Not Paid",
  key: "not_paid",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Cores Received",
  key: "cores_received",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Cores Not Received",
  key: "cores_received",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Cancelled",
  key: "cancelled",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Shipped",
  key: "shipped",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Shipped",
  key: "not_shipped",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "SOs on QC Hold",
  key: "qc_hold",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "SOs on Export Compliance Hold",
  key: "export_compliance_hold"
}, {
  label: "Warnings Only",
  key: "warnings"
}, {
  label: "Not Cancelled",
  key: "cancelled",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Cust RMA",
  key: "customer_rma",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "No Cust RMA",
  key: "customer_rma",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Warranty Returns",
  key: __WEBPACK_IMPORTED_MODULE_14__RepairOrders_constants__["l" /* WARRANTY_CONSIDERATION */]
}];

var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = searchProps.paginator.get("filters").toJS();
  var totalCount = searchProps.paginator.get("totalCount");

  params.total_count = totalCount;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        if (totalCount > 300) {
          __WEBPACK_IMPORTED_MODULE_15_react_redux_toastr__["toastr"].info("Processing");
          __WEBPACK_IMPORTED_MODULE_16__api__["a" /* default */].salesOrders.lineItems.export(params).then(function () {
            return __WEBPACK_IMPORTED_MODULE_6__lib_submission__["a" /* SUCCESS */];
          });
        } else {
          window.open(__WEBPACK_IMPORTED_MODULE_13__constants__["d" /* API_BASE */] + "/sales_order_line_items/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_query_string__["stringify"])(params), "_blank");
          __WEBPACK_IMPORTED_MODULE_15_react_redux_toastr__["toastr"].success("Processing Sales Order Report. Please wait for the PDF to generate.");
        }
      }
    },
    "Export"
  );
};

var meetsExportCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var searchProps = _ref2.searchProps,
      currentUser = _ref2.currentUser;
  return searchProps.paginator.get("totalCount") <= 450 || currentUser.role === __WEBPACK_IMPORTED_MODULE_11__users_constants__["i" /* ADMIN */];
});

var DecoratedExportButton = meetsExportCriteria(ExportButton);

function SalesOrdersSearch(_ref3) {
  var pushHistory = _ref3.pushHistory;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__hooks__["a" /* useCurrentUser */])();

  var locationFilters = [];
  var locationFilterTags = [];

  if (currentUser.locations && currentUser.locations.length > 1) {
    currentUser.locations.forEach(function (loc, index) {
      locationFilters.push({
        label: "All Owned by " + loc.name,
        filters: _extends({}, defaultFilters, {
          store_id: loc.id
        })
      });

      locationFilters.push({
        label: "Open SOs Owned by " + loc.name,
        filters: _extends({}, defaultFilters, {
          store_id: loc.id,
          shipped: false,
          cancelled: false
        }),
        hr: index === currentUser.locations.length - 1
      });

      locationFilterTags.push({
        label: "Owned by " + loc.name,
        key: "store_id",
        matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])(loc.id)
      });
    });
  }

  var allFilters = [].concat(baseFilters, locationFilters, [{
    label: __WEBPACK_IMPORTED_MODULE_13__constants__["_37" /* CLEAR_FILTERS_TEXT */],
    filters: defaultFilters
  }]);

  var allFilterTags = [].concat(baseFilterTags, locationFilterTags);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_19__pagination__["b" /* salesOrdersPagination */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a SO #, customer name, customer PO #, invoice #, consignment ref# or seller...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/sales-orders/" + r.sales_order_id);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DecoratedExportButton, {
              searchProps: searchProps,
              currentUser: currentUser
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_DateRangePicker_DateRangePicker__["a" /* default */], searchProps),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, { filters: allFilters, right: true }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "Sales Orders",
          filters: allFilterTags,
          aggregateField: "subtotal",
          Sum: __WEBPACK_IMPORTED_MODULE_17__Sum__["a" /* default */]
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

SalesOrdersSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(SalesOrdersSearch));

/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = StatusTags;



function StatusTags(_ref) {
  var accHold = _ref.accHold,
      qcHold = _ref.qcHold,
      qcPreapprovalRequired = _ref.qcPreapprovalRequired,
      exportHold = _ref.exportHold,
      deniedPartyHold = _ref.deniedPartyHold,
      newCompanyHold = _ref.newCompanyHold;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    accHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "label label-danger", style: { marginRight: 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-warning" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        "Acc Hold"
      )
    ),
    qcPreapprovalRequired && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "label label-danger", style: { marginRight: 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-pause" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        "QC Pre. Req."
      )
    ),
    exportHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "label label-danger", style: { marginRight: 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-pause" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        "Export Hold"
      )
    ),
    qcHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "label label-danger" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-pause" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        "QC Hold"
      )
    ),
    deniedPartyHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "label label-danger", style: { marginRight: 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-pause" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        "Denied Party Hold"
      )
    ),
    newCompanyHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "label label-danger" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-warning" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "with-padding" },
        "New Company Hold"
      )
    )
  );
}

StatusTags.propTypes = {
  accHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  qcHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  qcPreapprovalRequired: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  exportHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hooks_useDebounce__ = __webpack_require__(201);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();






function Sum(_ref) {
  var paginator = _ref.paginator;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      sum = _useState2[0],
      setSum = _useState2[1];

  var latestRequestRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(0);

  var debouncedSearchArgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hooks_useDebounce__["a" /* default */])(300, Object.entries(paginator.get("filters").toJS()).flatMap(function (pair) {
    return pair;
  }).join("-"));

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var currentRequest = latestRequestRef.current + 1;
    latestRequestRef.current = currentRequest;
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].salesOrders.search(_extends({
      include_sum: true
    }, paginator.get("filters").toJS())).then(function (_ref2) {
      var data = _ref2.data;

      if (currentRequest === latestRequestRef.current) {
        setSum(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(data, "data.sum"));
      }

      return function cleanup() {};
    });
  }, debouncedSearchArgs);

  if (!sum) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    "/\xA0\xA0",
    sum
  );
}

/* harmony default export */ __webpack_exports__["a"] = (Sum);

/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Row__ = __webpack_require__(1916);
/* harmony export (immutable) */ __webpack_exports__["a"] = Table;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function Table(_ref) {
  var isLoading = _ref.isLoading,
      pageActions = _ref.pageActions,
      results = _ref.results;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hooks__["a" /* useCurrentUser */])();
  var hasWareHouses = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(currentUser, "tenant.ware_houses", []).length > 0;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components__["s" /* DataTable */],
    { loading: isLoading, refresh: pageActions.expire },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "SO #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Created"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Customer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Seller"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Inv #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Paid Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Customer PO #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Store Owner"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Store Loc"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Location"
      ),
      hasWareHouses && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "WH #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Warnings"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Sell As Alt"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "CD"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Qty"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Exch"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Cost Per Unit"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Sales EA/Exch Fee"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Outright Value"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Profit"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Status"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Note"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(__WEBPACK_IMPORTED_MODULE_4__Row__["a" /* default */])
    )
  );
}

Table.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_1__shared_components__["e" /* SearchPropTypes */]);

/***/ }),
/* 1921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(1917);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });



/***/ }),
/* 1922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(1921);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Detail__ = __webpack_require__(1915);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Detail__["a"]; });





/***/ }),
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_AutoCompleteField_AutoCompleteField__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_decorators_withFormFields__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__companies_helpers__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__companies_shared_components_MissingFieldsWarning__ = __webpack_require__(2040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__companies_components_AddressFields__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__companies_shared_components_DoNotExchangeWarning__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Warnings_CustomerFullNameRequiredWarning__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__companies_shared_components_RestrictedEntityWarning__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__session_decorators_withCurrentUser__ = __webpack_require__(47);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























var baseOptions = [__WEBPACK_IMPORTED_MODULE_10__companies_constants__["s" /* WIRE_IN_ADVANCE */], __WEBPACK_IMPORTED_MODULE_10__companies_constants__["v" /* CHECK_IN_ADVANCE */], __WEBPACK_IMPORTED_MODULE_10__companies_constants__["r" /* CREDIT_CARD */]];

var CustomerSection = function (_Component) {
  _inherits(CustomerSection, _Component);

  function CustomerSection() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CustomerSection);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CustomerSection.__proto__ || Object.getPrototypeOf(CustomerSection)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      contacts: [],
      terms: baseOptions,
      selectedCompany: null,
      selectedContact: null,
      afterHours: _this.props.afterHours
    }, _this.searchCompanies = function (filter) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "detail";
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].companies.search({ cached: true, filter: filter, page: 1, type: type, limit: 20 }).then(function (resp) {
        return resp.data.results;
      });
    }, _this.searchContacts = function (companyId) {
      if (!companyId) {
        _this.setState({ contacts: [] });
      } else {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].companies.contacts.search(companyId, {
          active: true,
          cached: true,
          page: 1,
          limit: 1000,
          sort: "name",
          reverse: false
        }).then(function (resp) {
          var contacts = resp.data.results;
          _this.setState({ contacts: contacts });
          if (_this.props.setPrimaryContact) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__companies_helpers__["a" /* selectPrimaryContact */])(contacts, _this.props.setFieldValue(__WEBPACK_IMPORTED_MODULE_14__constants__["O" /* CONTACT_ID */]));
          }
        });
      }
    }, _this.handleCompanySelected = function (company) {
      _this.setState({ selectedCompany: company });
      _this.resetTerms();
      _this.props.contact_id.input.onChange(null);
      if (company.customer_credit_terms) {
        _this.updateTerms(company.customer_credit_terms);
      }

      if (_this.props.onCompanySelected) {
        _this.props.onCompanySelected(company);
      }
      _this.searchContacts(company.id);

      if (company.contacts && company.contacts.length > 0) {
        var firstPrimaryContact = company.contacts.find(function (contact) {
          return contact.primary === true;
        });

        if (firstPrimaryContact) {
          _this.props.contact_id.input.onChange(firstPrimaryContact.id);
          _this.setState({ selectedContact: firstPrimaryContact });
        } else {
          _this.setState({ selectedContact: null });
        }
      } else {
        _this.setState({ selectedContact: null });
      }
    }, _this.resetTerms = function () {
      _this.props.credit_terms.input.onChange(null);
      _this.setState({ terms: baseOptions });
    }, _this.addOption = function (option) {
      _this.setState({
        terms: [option].concat(baseOptions)
      });
    }, _this.updateTerms = function (term) {
      _this.addOption(term);
      _this.props.credit_terms.input.onChange(term);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CustomerSection, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _props = this.props,
          company = _props.company,
          creditTerms = _props.creditTerms;


      if (company) {
        this.setState({ selectedCompany: company });
        this.searchContacts(company.id);

        if (company.customer_credit_terms) {
          this.addOption(company.customer_credit_terms);
        }
      }

      if (creditTerms) {
        this.addOption(creditTerms);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          contacts = _state.contacts,
          selectedCompany = _state.selectedCompany,
          selectedContact = _state.selectedContact,
          terms = _state.terms;
      var _props2 = this.props,
          _props2$canEditCompan = _props2.canEditCompany,
          canEditCompany = _props2$canEditCompan === undefined ? true : _props2$canEditCompan,
          value = _props2.contact_id.input.value,
          currentUser = _props2.currentUser,
          formName = _props2.formName,
          getFieldValue = _props2.getFieldValue;


      var paymentTermOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_forms__["d" /* arrayToProperCasedOptionsWithCurrentValue */])(currentUser.tenant.payment_terms || Object.keys(__WEBPACK_IMPORTED_MODULE_10__companies_constants__["i" /* VENDOR_TERMS */]), selectedCompany && selectedCompany.customer_credit_terms);

      var options = paymentTermOptions.filter(function (f) {
        return terms.includes(f.value);
      });
      var contactOptions = (contacts || []).map(function (c) {
        return {
          value: c.id,
          text: c.name
        };
      }).concat({
        text: "+ Add a Contact",
        value: "Add"
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              required: true,
              name: "customer_purchase_order_number",
              component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
              label: "Customer PO#"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__companies_shared_components_MissingFieldsWarning__["a" /* default */], {
          company: selectedCompany,
          contact: selectedContact,
          getFieldValue: getFieldValue
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__companies_shared_components_DoNotExchangeWarning__["a" /* default */], { company: selectedCompany }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Warnings_CustomerFullNameRequiredWarning__["a" /* default */], {
          name: selectedContact && selectedContact.name || getFieldValue("contact.name")
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__companies_shared_components_RestrictedEntityWarning__["a" /* default */], {
          company: selectedCompany,
          allContacts: true,
          requireApproval: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 8 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_14__constants__["N" /* COMPANY_ID */],
              label: "Customer",
              labelChildren: selectedCompany && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                "\xA0\xA0",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["g" /* CompanyStatsTooltip */], { company: selectedCompany })
              ),
              placeholder: "Search by typing a company's name or code",
              component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_AutoCompleteField_AutoCompleteField__["a" /* default */],
              search: function search(filter) {
                return _this2.searchCompanies(filter, "all_associations");
              },
              formatItem: function formatItem(result) {
                return result && result.name;
              },
              onItemSelected: function onItemSelected(i) {
                return i && _this2.handleCompanySelected(i);
              },
              selectedItem: selectedCompany,
              disabled: !canEditCompany,
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_15__constants__["_0" /* CREDIT_TERMS */],
              component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
              label: "Customer Credit Terms",
              options: options,
              required: true
            })
          )
        ),
        selectedCompany && !selectedCompany.billing_address && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Billing Address"
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__companies_components_AddressFields__["a" /* default */], {
          country: getFieldValue([__WEBPACK_IMPORTED_MODULE_10__companies_constants__["w" /* BILLING_ADDRESS */], __WEBPACK_IMPORTED_MODULE_14__constants__["r" /* COUNTRY */]].join(".")),
          path: __WEBPACK_IMPORTED_MODULE_10__companies_constants__["w" /* BILLING_ADDRESS */],
          formName: formName,
          showCareOf: false,
          showRegion: true,
          resetState: true,
          stateProvinceRequired: true
        })],
        selectedCompany && !selectedCompany.phone && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Missing Company Fields"
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 5 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["p" /* PhoneNumberField */], {
              name: __WEBPACK_IMPORTED_MODULE_14__constants__["R" /* PHONE */],
              component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
              label: "Phone Number",
              type: "tel",
              required: true
            })
          )
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Contact"
        )],
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_14__constants__["O" /* CONTACT_ID */],
              component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
              label: "Customer Contact",
              options: contactOptions,
              onChange: function onChange(_, val) {
                var contact = (_this2.state.contacts || []).find(function (c) {
                  return Number(c.id) === Number(val);
                });

                _this2.setState({
                  selectedContact: contact
                });
              },
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: "cc_email_address",
              component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
              label: "Contact Email #2"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: "third_contact_email",
              component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
              label: "Contact Email #3"
            })
          )
        ),
        value === "Add" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_redux_form__["FormSection"],
            { name: __WEBPACK_IMPORTED_MODULE_10__companies_constants__["g" /* CONTACT */] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_14__constants__["S" /* NAME */],
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                  label: "Contact Name",
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_14__constants__["T" /* EMAIL */],
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                  label: "Contact Email",
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["p" /* PhoneNumberField */], {
                  name: "phone1",
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                  label: "Phone Number 1",
                  type: "tel"
                })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
              { justified: true, title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_15__constants__["Z" /* AFTER_HOURS */]) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: __WEBPACK_IMPORTED_MODULE_15__constants__["Z" /* AFTER_HOURS */], component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */], label: "Yes" })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 5 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
              { justified: true, title: "Send SO Acknowledgement" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_15__constants__["x" /* SEND_SALES_ORDER_ACKNOWLEDGEMENT */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                label: "Yes",
                icon: "fa-eye-slash text-success"
              })
            )
          )
        )
      );
    }
  }]);

  return CustomerSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CustomerSection.defaultProps = {
  setPrimaryContact: true
};


CustomerSection.propTypes = {
  afterHours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    customer_credit_terms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  creditTerms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  credit_terms: __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormTypes__["stringInput"]).isRequired,
  canEditCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  contact_id: __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormTypes__["malleable"]).isRequired,
  formName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onCompanySelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setPrimaryContact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__session_decorators_withCurrentUser__["b" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shared_decorators_withFormFields__["a" /* default */])(CustomerSection, [__WEBPACK_IMPORTED_MODULE_15__constants__["_0" /* CREDIT_TERMS */], __WEBPACK_IMPORTED_MODULE_14__constants__["O" /* CONTACT_ID */], __WEBPACK_IMPORTED_MODULE_15__constants__["Z" /* AFTER_HOURS */], __WEBPACK_IMPORTED_MODULE_15__constants__["x" /* SEND_SALES_ORDER_ACKNOWLEDGEMENT */]]))));

/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_AutoCompleteField_AutoCompleteField__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(717);









function SellersSection(_ref) {
  var searchSellers = _ref.searchSellers,
      selectedSeller = _ref.selectedSeller,
      selectedSecondSeller = _ref.selectedSecondSeller,
      disabled = _ref.disabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
      { className: "row-col-gutters-half" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 5 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_6__constants__["C" /* SELLER_ID */],
            label: "Seller",
            placeholder: "Search by name...",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_AutoCompleteField_AutoCompleteField__["a" /* default */],
            search: searchSellers,
            formatItem: function formatItem(result) {
              return result && result.full_name;
            },
            disabled: disabled,
            selectedItem: selectedSeller,
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
        { md: 5 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_6__constants__["D" /* SECOND_SELLER_ID */],
          label: "2nd Seller",
          placeholder: "Search by name...",
          component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_AutoCompleteField_AutoCompleteField__["a" /* default */],
          search: searchSellers,
          selectedItem: selectedSecondSeller,
          formatItem: function formatItem(result) {
            return result && result.full_name;
          },
          disabled: disabled
        })
      )
    )
  );
}

SellersSection.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  searchSellers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedSeller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string }),
  selectedSecondSeller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string })
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { searchSellers: __WEBPACK_IMPORTED_MODULE_7__actions__["searchSellers"] })(SellersSection));

/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_strings__ = __webpack_require__(416);
/* unused harmony export SpecialInstructions */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var SpecialInstructions = function (_React$Component) {
  _inherits(SpecialInstructions, _React$Component);

  function SpecialInstructions() {
    _classCallCheck(this, SpecialInstructions);

    return _possibleConstructorReturn(this, (SpecialInstructions.__proto__ || Object.getPrototypeOf(SpecialInstructions)).apply(this, arguments));
  }

  _createClass(SpecialInstructions, [{
    key: "render",
    value: function render() {
      var resource = this.props.resource;


      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_strings__["a" /* default */])(resource.get("special_instructions")).empty()) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h2",
            null,
            "Special Instructions"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "panel panel-default panel-note",
            style: { marginBottom: 2 }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: "panel-collapse collapse in",
              "aria-labelledby": "headingOne"
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "panel-body", style: { padding: "8px 15px" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                null,
                resource.get("special_instructions")
              )
            )
          )
        )
      );
    }
  }]);

  return SpecialInstructions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SpecialInstructions.propTypes = {
  resource: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SpecialInstructions);

/***/ }),
/* 1926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SpecialInstructions__ = __webpack_require__(1925);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SpecialInstructions__["a"]; });



/***/ }),
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony export (immutable) */ __webpack_exports__["a"] = CustomerFullNameRequiredWarning;



function CustomerFullNameRequiredWarning(_ref) {
  var name = _ref.name;

  if (!name) return null;
  if ([" ", ","].some(function (k) {
    return name.includes(k);
  })) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components_Warning_Warning__["a" /* default */],
    null,
    "To complete this transaction, the customer contact selected must have a first and last name. Please change or edit contact name to continue."
  );
}

/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_reducer__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(449);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  salesOrder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
}).merge(__WEBPACK_IMPORTED_MODULE_2__shared_reducer__["a" /* notesInitialState */]).merge(__WEBPACK_IMPORTED_MODULE_2__shared_reducer__["b" /* attachmentsInitialState */]);

function setSalesOrder(state, action) {
  return state.merge({ salesOrder: action.salesOrder });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_reducer__["d" /* createNoteReducer */])(__WEBPACK_IMPORTED_MODULE_3__shared_types_resourceTypes__["a" /* default */].salesOrder), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_reducer__["c" /* createAttachmentReducer */])(__WEBPACK_IMPORTED_MODULE_3__shared_types_resourceTypes__["a" /* default */].salesOrder), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* SET */], setSalesOrder))));

/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(449);
/* unused harmony export initialState */
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  salesOrderWithAllLineItems: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
});

function setSalesOrderWithAllLineItems(state, action) {
  return state.merge({
    salesOrderWithAllLineItems: action.salesOrderWithAllLineItems
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["b" /* SET_SALES_ORDER_WITH_ALL_LINE_ITEMS */], setSalesOrderWithAllLineItems)));

/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create__ = __webpack_require__(1931);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var CreateShippingContainer = function (_Component) {
  _inherits(CreateShippingContainer, _Component);

  function CreateShippingContainer() {
    _classCallCheck(this, CreateShippingContainer);

    var _this = _possibleConstructorReturn(this, (CreateShippingContainer.__proto__ || Object.getPrototypeOf(CreateShippingContainer)).call(this));

    _this.state = {
      open: false
    };

    _this.openAndSetRecord = function (record) {
      return _this.setState({
        open: true,
        shippingRecord: Object.assign({}, record)
      });
    };

    _this.close = function () {
      _this.setState({ open: false, shippingRecord: null });
    };

    _this.openAndSetRecord = _this.openAndSetRecord.bind(_this);
    return _this;
  }

  _createClass(CreateShippingContainer, [{
    key: "render",
    value: function render() {
      var _state = this.state,
          open = _state.open,
          shippingRecord = _state.shippingRecord;


      if (!open) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Create__["a" /* default */], { open: open, close: this.close, shippingRecord: shippingRecord });
    }
  }]);

  return CreateShippingContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (CreateShippingContainer);

/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_helpers__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_CommercialInvoice_Form_FormSections_LineItemsForm__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_Form__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_CommercialInvoice_Form_CommercialDiscreetButton__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SalesOrders_helpers__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DownloadPackingSlip_DownloadPackingSlip__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__shared_components_Modal_Body__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Form__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__SendWeightDimsForm__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ShipTo__ = __webpack_require__(1935);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mapType, _downloadMapType;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



































var mapType = (_mapType = {}, _defineProperty(_mapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["l" /* CONSIGNMENT */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["l" /* CONSIGNMENT */])), _defineProperty(_mapType, __WEBPACK_IMPORTED_MODULE_26__inventories_constants__["_96" /* RETURNED_CONSIGNMENT */], "ReturnedConsignment"), _defineProperty(_mapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["i" /* RETURN_TO_CUSTOMER_RECORD */], "ReturnToCustomerRecord"), _defineProperty(_mapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["j" /* INVENTORY_TRANSFER_ORDER */], "InventoryTransferOrder"), _defineProperty(_mapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["h" /* REJECTED_CORE_ORDER */], "RejectedCoreOrder"), _defineProperty(_mapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["d" /* RETURNED_CORE */], "ReturnedCore"), _defineProperty(_mapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["b" /* RO_ITEM */], "RepairOrderLineItem"), _defineProperty(_mapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["n" /* RMA */], "VendorRma"), _defineProperty(_mapType, "mistake_shipment", "MistakeShipment"), _defineProperty(_mapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["g" /* MRO_ITEM */], "ManagedRepairOrderLineItem"), _defineProperty(_mapType, __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__["e" /* SHIPMENT */], "Inventory"), _defineProperty(_mapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["e" /* SO_ITEM */], "SalesOrderLineItem"), _defineProperty(_mapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["a" /* PO_ITEM */], "PurchaseOrderLineItem"), _mapType);

var downloadMapType = (_downloadMapType = {}, _defineProperty(_downloadMapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["b" /* RO_ITEM */], "repairOrders"), _defineProperty(_downloadMapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["e" /* SO_ITEM */], "salesOrders"), _defineProperty(_downloadMapType, __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__["d" /* MISTAKE_SHIPMENT */], "mistakeShipments"), _defineProperty(_downloadMapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["g" /* MRO_ITEM */], "managedRepairOrders"), _defineProperty(_downloadMapType, __WEBPACK_IMPORTED_MODULE_26__inventories_constants__["_96" /* RETURNED_CONSIGNMENT */], "returnedConsignment"), _defineProperty(_downloadMapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["a" /* PO_ITEM */], "purchaseOrders"), _defineProperty(_downloadMapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["h" /* REJECTED_CORE_ORDER */], "rejectedCores"), _defineProperty(_downloadMapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["i" /* RETURN_TO_CUSTOMER_RECORD */], "returnToCustomerRecords"), _defineProperty(_downloadMapType, __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["n" /* RMA */], "rmas"), _downloadMapType);

var quantity = function quantity(shippingRecord) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(shippingRecord, "type") === __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["h" /* REJECTED_CORE_ORDER */]) {
    return 1;
  }
  return shippingRecord && shippingRecord.quantity - shippingRecord.quantity_shipped;
};

var salesEA = function salesEA(shippingRecord) {
  return parseFloat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(shippingRecord, __WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_constants__["b" /* PRICE_PER_UNIT */], 0));
};

function Create(_ref) {
  var open = _ref.open,
      close = _ref.close,
      currentUser = _ref.currentUser,
      shippingRecord = _ref.shippingRecord;

  var initialValues = _extends({
    read_only_part_number: shippingRecord && shippingRecord.part_number,
    read_only_part_uuid: shippingRecord && shippingRecord.part_uuid,
    read_only_serial_number: shippingRecord && shippingRecord.serial_number,
    read_only_inventory_uuid: shippingRecord && shippingRecord.inventory_uuid,
    read_only_company: shippingRecord && shippingRecord.type !== __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__["d" /* MISTAKE_SHIPMENT */] && shippingRecord.company_name,
    read_only_company_uuid: shippingRecord && shippingRecord.company_uuid,
    read_only_customer_po: shippingRecord && shippingRecord.customer_purchase_order_number,
    read_only_customer_email: shippingRecord && shippingRecord.customer_email,
    read_only_salesperson: shippingRecord && shippingRecord.seller_name,
    read_only_sales_ea: salesEA(shippingRecord),
    outgoing_awb_number: shippingRecord && shippingRecord.outgoing_awb_number,
    hazmat: !!(shippingRecord && shippingRecord.hazmat),
    bio_hazmat: !!(shippingRecord && shippingRecord.bio_hazmat),
    quantity: quantity(shippingRecord),
    discreet: !!(shippingRecord && shippingRecord.discreet),
    customer_to_provide_own_paperwork: !!(shippingRecord && shippingRecord.customer_to_provide_own_paperwork),
    reference_record_line_item_id: shippingRecord && shippingRecord.type === __WEBPACK_IMPORTED_MODULE_17__Receiving_constants__["e" /* SHIPMENT */] ? shippingRecord.inventory_id : shippingRecord.order_id,
    reference_record_line_item_type: shippingRecord && mapType[shippingRecord.type],
    ship_as_multiple: true,
    line_items: [],
    pictures_required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(shippingRecord, "parent.pictures_required"),
    net_weight_unit: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(shippingRecord, __WEBPACK_IMPORTED_MODULE_11__parts_constants__["t" /* NET_WEIGHT_UNIT */]) || "lb",
    shipping_method: shippingRecord && shippingRecord.shipping_method || shippingRecord.ship_to_shipping_method
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__lib_pojos__["a" /* default */])(shippingRecord || {}).pick(__WEBPACK_IMPORTED_MODULE_16__constants__["k" /* ATTACHMENTS */], __WEBPACK_IMPORTED_MODULE_11__parts_constants__["m" /* HEIGHT */], __WEBPACK_IMPORTED_MODULE_11__parts_constants__["j" /* WEIGHT */], __WEBPACK_IMPORTED_MODULE_11__parts_constants__["k" /* WIDTH */], __WEBPACK_IMPORTED_MODULE_11__parts_constants__["l" /* LENGTH */], __WEBPACK_IMPORTED_MODULE_11__parts_constants__["n" /* WEIGHT_UNIT */], __WEBPACK_IMPORTED_MODULE_11__parts_constants__["o" /* NET_WEIGHT */], __WEBPACK_IMPORTED_MODULE_11__parts_constants__["s" /* NET_WEIGHT_OZ */], __WEBPACK_IMPORTED_MODULE_11__parts_constants__["r" /* NET_HEIGHT */], __WEBPACK_IMPORTED_MODULE_11__parts_constants__["q" /* NET_WIDTH */], __WEBPACK_IMPORTED_MODULE_11__parts_constants__["p" /* NET_LENGTH */], __WEBPACK_IMPORTED_MODULE_11__parts_constants__["g" /* COUNTRY_OF_MFG */], __WEBPACK_IMPORTED_MODULE_16__constants__["_21" /* INVENTORY_ID */], __WEBPACK_IMPORTED_MODULE_27__constants__["i" /* SHIP_MULTIPLE_ITEM_IDS */], __WEBPACK_IMPORTED_MODULE_22__SalesOrders_constants__["d" /* SPECIAL_INSTRUCTIONS */]));

  var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__hooks__["a" /* useCurrentUser */])();

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      sendWtDims = _useState2[0],
      setSendWtDims = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState4 = _slicedToArray(_useState3, 2),
      weightsAndDims = _useState4[0],
      setWeightsAndDims = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_helpers__["c" /* SHIPPING_CHECKLIST */]),
      _useState6 = _slicedToArray(_useState5, 2),
      currentForm = _useState6[0],
      setCurrentForm = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({ so: [] }),
      _useState8 = _slicedToArray(_useState7, 2),
      salesOrder = _useState8[0],
      setSalesOrder = _useState8[1];

  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({ ro: [] }),
      _useState10 = _slicedToArray(_useState9, 2),
      repairOrder = _useState10[0],
      setRepairOrder = _useState10[1];

  var _useState11 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
      _useState12 = _slicedToArray(_useState11, 2),
      loading = _useState12[0],
      setLoading = _useState12[1];

  var _useState13 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState14 = _slicedToArray(_useState13, 2),
      lineItems = _useState14[0],
      setLineItems = _useState14[1];

  var salesOrderId = shippingRecord.type === __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["e" /* SO_ITEM */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(shippingRecord, "parent.id") ? shippingRecord.parent.id : "";

  var repairOrderId = shippingRecord.type === __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["b" /* RO_ITEM */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(shippingRecord, "parent.id") ? shippingRecord.parent.id : "";

  var _useState15 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState16 = _slicedToArray(_useState15, 2),
      parentRecord = _useState16[0],
      setParentRecord = _useState16[1];

  var _useState17 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
      _useState18 = _slicedToArray(_useState17, 2),
      loadingParentRecord = _useState18[0],
      setLoadingParentRecord = _useState18[1];

  var _useState19 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState20 = _slicedToArray(_useState19, 2),
      packingUrl = _useState20[0],
      setPackingUrl = _useState20[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (shippingRecord && shippingRecord.type === __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["e" /* SO_ITEM */]) {
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].salesOrders.show(salesOrderId).then(function (resp) {
        setSalesOrder(resp.data);
        var result = resp.data.line_items;
        setLineItems([result[0].inventory]);
        setLoading(false);
      });
    } else if (shippingRecord && shippingRecord.type === __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["b" /* RO_ITEM */]) {
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].repairOrders.show(repairOrderId).then(function (resp) {
        setRepairOrder(resp.data);
        var result = resp.data.line_items;
        setLineItems([result[0].inventory]);
        setLoading(false);
      });
    }
    return function cleanup() {};
  }, []);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var apiType = downloadMapType[shippingRecord.type];
    if (apiType) {
      var id = shippingRecord.parent && __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["n" /* RMA */] !== shippingRecord.type ? shippingRecord.parent.id : shippingRecord.order_id;
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */][apiType].show(id, "lines_no_details").then(function (resp) {
        setParentRecord(resp.data);
        setLoadingParentRecord(false);
      });
    } else {
      setLoadingParentRecord(false);
    }

    return function cleanup() {};
  }, []);

  var invoiceInitialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_helpers__["g" /* setInvoiceInitialValues */])({
    lineItems: lineItems,
    shippingRecord: shippingRecord,
    salesOrder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__SalesOrders_helpers__["g" /* mapSOToForm */])(salesOrder),
    repairOrder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__SalesOrders_helpers__["k" /* mapROToForm */])(repairOrder)
  });
  var showForm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_helpers__["i" /* showFormFunc */])({
    salesOrder: salesOrder,
    repairOrder: repairOrder,
    setCurrentForm: setCurrentForm
  });

  var addLineItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_helpers__["h" /* addLineItemsFunc */])({
    setLineItems: setLineItems,
    setCurrentForm: setCurrentForm
  });

  var _useState21 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState22 = _slicedToArray(_useState21, 2),
      shippingAddressWarning = _useState22[0],
      setShippingAddressWarning = _useState22[1];

  var checkShipping = function checkShipping() {
    if (!shippingRecord.company_address) {
      setShippingAddressWarning(true);
    } else {
      showForm();
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-lg" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_CommercialInvoice_Form_CommercialDiscreetButton__["a" /* default */], {
          display: currentForm === __WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_helpers__["e" /* COMMERCIAL_INVOICE */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__users_helpers__["a" /* hasAnyOfSubroles */])(user, [__WEBPACK_IMPORTED_MODULE_12__users_constants__["_18" /* CREATE_COMMERCIAL_INVOICE */], __WEBPACK_IMPORTED_MODULE_12__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */], __WEBPACK_IMPORTED_MODULE_12__users_constants__["t" /* WAREHOUSE_EXPERT */]])
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          currentForm.replace("LineItems", ""),
          (__WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["e" /* SO_ITEM */] === shippingRecord.type || __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["b" /* RO_ITEM */] === shippingRecord.type && shippingRecord.exporting) && currentForm === __WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_helpers__["c" /* SHIPPING_CHECKLIST */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_25__shared_components__["b" /* Authorized */],
            {
              subroles: [__WEBPACK_IMPORTED_MODULE_12__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */], __WEBPACK_IMPORTED_MODULE_12__users_constants__["t" /* WAREHOUSE_EXPERT */]],
              permissions: [__WEBPACK_IMPORTED_MODULE_12__users_constants__["_18" /* CREATE_COMMERCIAL_INVOICE */]]
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              {
                type: "button",
                className: "btn btn-success",
                style: { marginLeft: "10px", paddingRight: "5px" },
                onClick: function onClick(e) {
                  e.preventDefault();
                  checkShipping();
                },
                disabled: loading || shippingAddressWarning
              },
              loading ? "...Loading Invoice" : "Commercial Invoice"
            )
          )
        )
      ),
      currentForm === __WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_helpers__["c" /* SHIPPING_CHECKLIST */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_20__shared_components_Modal_Body__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_21__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_19_react_bootstrap__["e" /* Col */],
            { md: 9 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__Form__["b" /* default */], {
              close: close,
              initialValues: initialValues,
              selectedBuyer: currentUser.toJS(),
              shippingRecord: shippingRecord,
              enableReinitialize: true,
              sendWtDims: sendWtDims,
              setSendWtDims: setSendWtDims,
              setWeightsAndDims: setWeightsAndDims,
              parentRecord: parentRecord,
              loadingParentRecord: loadingParentRecord,
              packingUrl: packingUrl,
              setCurrentForm: setCurrentForm,
              shippingAddressWarning: shippingAddressWarning,
              loading: loading,
              showForm: showForm,
              setPackingUrl: setPackingUrl
            })
          ),
          ![__WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["d" /* RETURNED_CORE */], __WEBPACK_IMPORTED_MODULE_30__Orders_shared_constants__["f" /* TRANSFER */]].includes(shippingRecord.type) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_19_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__ShipTo__["a" /* default */], {
              shippingRecord: shippingRecord,
              parentRecord: parentRecord
            })
          )
        )
      ),
      currentForm === __WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_helpers__["a" /* SEND_WEIGHTS_AND_DIMS */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__SendWeightDimsForm__["a" /* default */], {
        close: close,
        initialValues: Object.assign(initialValues, weightsAndDims),
        id: shippingRecord.parent.id,
        weightsAndDims: weightsAndDims,
        enableReinitialize: true,
        setCurrentForm: setCurrentForm,
        itemId: shippingRecord && shippingRecord.order_id
      }),
      [__WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_helpers__["f" /* COMMERCIAL_INVOICE_LINE_ITEMS */], __WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_helpers__["e" /* COMMERCIAL_INVOICE */]].includes(currentForm) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            display: currentForm === __WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_helpers__["e" /* COMMERCIAL_INVOICE */] ? "block" : "none"
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_CommercialInvoice_Form__["a" /* default */], {
          close: close,
          salesOrderId: salesOrderId,
          repairOrderId: repairOrderId,
          setCurrentForm: setCurrentForm,
          initialValues: invoiceInitialValues,
          hazmat: shippingRecord.hazmat,
          discreet: shippingRecord.discreet,
          outbound: true,
          enableReinitialize: true
        })
      ),
      currentForm === __WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_helpers__["f" /* COMMERCIAL_INVOICE_LINE_ITEMS */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_CommercialInvoice_Form_FormSections_LineItemsForm__["a" /* default */], {
        close: close,
        addLineItems: addLineItems,
        lineItems: salesOrder.line_items || repairOrder.line_items,
        enableReinitialize: true
      }),
      currentForm === __WEBPACK_IMPORTED_MODULE_7__shared_components_CommercialInvoice_helpers__["b" /* DOWNLOAD_PACKING_SLIP */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__DownloadPackingSlip_DownloadPackingSlip__["a" /* default */], {
        shippingRecord: shippingRecord,
        record: parentRecord,
        setCurrentForm: setCurrentForm,
        url: packingUrl
      })
    )
  );
}

Create.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  currentUser: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),
  shippingRecord: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_12__users_constants__["a" /* USER */])
  };
})(Create));

/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__ = __webpack_require__(19);












var Save = function Save(props) {
  var formData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_pojos__["a" /* default */])(props.values).pick(__WEBPACK_IMPORTED_MODULE_7__constants__["k" /* ATTACHMENTS */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["i" /* BIO_HAZMAT */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["g" /* COUNTRY_OF_MFG */], __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__["a" /* CUSTOMER_TO_PROVIDE_OWN_PAPERWORK */], __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__["b" /* DISCREET */], __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["h" /* HAZMAT */], __WEBPACK_IMPORTED_MODULE_4__constants__["g" /* OUTGOING_AWB_NUMBER */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["m" /* HEIGHT */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["l" /* LENGTH */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["j" /* WEIGHT */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["n" /* WEIGHT_UNIT */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["k" /* WIDTH */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["o" /* NET_WEIGHT */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["p" /* NET_LENGTH */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["q" /* NET_WIDTH */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["r" /* NET_HEIGHT */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["s" /* NET_WEIGHT_OZ */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["t" /* NET_WEIGHT_UNIT */], __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__["c" /* PICTURES_REQUIRED */], __WEBPACK_IMPORTED_MODULE_7__constants__["g" /* SHIPPING_METHOD */], __WEBPACK_IMPORTED_MODULE_4__constants__["i" /* SHIP_MULTIPLE_ITEM_IDS */], __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__["d" /* SPECIAL_INSTRUCTIONS */]);

  formData[__WEBPACK_IMPORTED_MODULE_7__constants__["p" /* TYPE */]] = props.values.reference_record_line_item_type;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    {
      disabled: props.submitting,
      className: "btn btn-primary",
      style: { paddingLeft: "5px", paddingRight: "5px" },
      onClick: function onClick(e) {
        e.preventDefault();

        props.save(props.values.reference_record_line_item_id, formData).then(function () {
          props.close();
        });
      }
    },
    props.submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cog fa-spin fa-fw fa-lg" }) : "Save"
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state, ownProps) {
  return {
    values: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["getFormValues"])(ownProps.form)(state)
  };
}, function (dispatch) {
  return {
    save: function save(id, data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__actions__["c" /* save */])(id, data));
    }
  };
})(Save));

Save.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  values: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    reference_record_line_item_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    reference_record_line_item_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })
};

/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_CommercialInvoice_helpers__ = __webpack_require__(173);
/* unused harmony export SendWeightDimsForm */
var _this3 = this;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var formName = "send-wt-dims";

var SendWeightDimsForm = function (_Component) {
  _inherits(SendWeightDimsForm, _Component);

  function SendWeightDimsForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SendWeightDimsForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SendWeightDimsForm.__proto__ || Object.getPrototypeOf(SendWeightDimsForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      lineItems: [],
      hasWtDims: true,
      selectedLineItems: []
    }, _this.onItemSelected = function (lineItem) {
      if (lineItem.id === null) {
        _this.props.change(__WEBPACK_IMPORTED_MODULE_10__constants__["A" /* LINE_ITEMS */], []);
        return;
      }

      var lineItemIds = _this.props.lineItemIds;
      var selectedLineItems = _this.state.selectedLineItems;

      if (lineItemIds.includes(lineItem.id)) {
        var index = lineItemIds.indexOf(lineItem.id);
        lineItemIds.splice(index, 1);
        _this.props.change(__WEBPACK_IMPORTED_MODULE_10__constants__["A" /* LINE_ITEMS */], lineItemIds);
        _this.setState({
          selectedLineItems: selectedLineItems.filter(function (item) {
            return item.id !== lineItem.id;
          })
        });
      } else {
        lineItemIds.push(lineItem.id);
        _this.props.change(__WEBPACK_IMPORTED_MODULE_10__constants__["A" /* LINE_ITEMS */], lineItemIds);
        _this.setState({
          selectedLineItems: selectedLineItems.concat([lineItem])
        });
      }
    }, _this.fetchLineItems = function (id) {
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].salesOrders.show(id).then(function (resp) {
        var lineItems = resp.data.line_items;

        var state = lineItems.length === 1 ? { lineItems: lineItems, selectedLineItems: lineItems } : { lineItems: lineItems };

        _this.setState(state, function () {
          if (lineItems.length === 1) {
            _this.props.change(__WEBPACK_IMPORTED_MODULE_10__constants__["A" /* LINE_ITEMS */], lineItems.map(function (l) {
              return l.id;
            }));
          }

          _this.setState({
            hasWtDims: Boolean(lineItems.find(function (item) {
              return item.part.width !== null || item.part.weight !== null;
            }))
          });
        });
      });
    }, _this.renderRow = function (lineItem, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: i },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: { backgroundColor: "#383838" } },
          i + 1
        ),
        lineItem.part.width || lineItem.part.weight || _this.props.weightsAndDims.weight || _this.props.weightsAndDims.width ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: { marginBottom: "6px" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            name: __WEBPACK_IMPORTED_MODULE_10__constants__["A" /* LINE_ITEMS */],
            type: "checkbox",
            checked: _this.state.selectedLineItems.includes(lineItem),
            onChange: function onChange() {
              return _this.onItemSelected(lineItem);
            }
          })
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.part.part_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.serial_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.part.description
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SendWeightDimsForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchLineItems(this.props.id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          submitting = _props.submitting,
          close = _props.close,
          weightsAndDims = _props.weightsAndDims,
          weight = _props.weight,
          handleSubmit = _props.handleSubmit;
      var _state = this.state,
          hasWtDims = _state.hasWtDims,
          lineItems = _state.lineItems,
          selectedLineItems = _state.selectedLineItems;


      var sendOptions = lineItems.length > 1 ? [{ text: "Ship as a single package", value: true }, { text: "Ship in multiple packages", value: false }] : [{ text: "Ship as a single package", value: true }];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "form",
        { onSubmit: handleSubmit },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["e" /* Body */],
          null,
          !hasWtDims && !Object.keys(weightsAndDims).some(function (k) {
            return weightsAndDims[k];
          }) && !weight && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "alert alert-warning", role: "alert" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "media" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "media-left" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-warning text-warning" })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "media-body" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "strong",
                  null,
                  "Warning!"
                ),
                " No WT and DIMs available for this unit."
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "table",
            { className: "table table-striped table-hover table-numbered" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "thead",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Part Number"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Serial Number"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Description"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tbody",
              null,
              lineItems.map(function (inv, idx) {
                return _this2.renderRow(inv, idx);
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
            { className: "row-col-gutters-half" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
              { md: 8 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: "ship_as_multiple",
                label: "Shipping Options",
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["m" /* RadioGroupField */],
                options: sendOptions,
                required: true
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__shared_components_Modal__["d" /* Footer */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            { type: "button", className: "btn btn-default", onClick: close },
            "Cancel"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["i" /* Button */],
            {
              type: "submit",
              bsStyle: "primary",
              disabled: !hasWtDims && !Object.keys(weightsAndDims).some(function (k) {
                return weightsAndDims[k];
              }) && !weight || selectedLineItems.length === 0 || submitting
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["k" /* Icon */], { name: "envelope", fixed: true }),
            "\xA0Yes, Send Wts and Dims"
          )
        )
      );
    }
  }]);

  return SendWeightDimsForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SendWeightDimsForm.propTypes = {
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  lineItemIds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  weightsAndDims: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  weight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  change: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    lineItemIds: selector(state, __WEBPACK_IMPORTED_MODULE_10__constants__["A" /* LINE_ITEMS */])
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reduxForm"])({
  form: formName,
  onSubmit: function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data, _, props) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].salesOrders.sendWeightDims(props.id, props.values).then(function () {
                props.setCurrentForm(__WEBPACK_IMPORTED_MODULE_11__shared_components_CommercialInvoice_helpers__["c" /* SHIPPING_CHECKLIST */]);
                __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__["toastr"].success("Success", "Weight and Dims notification successfully sent.");
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }));

    return function onSubmit(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }()
})(SendWeightDimsForm)));

/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Form__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__inventories_constants__ = __webpack_require__(12);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












function ShipMultipleRecordsTable(_ref) {
  var _uriMap;

  var orderId = _ref.orderId,
      getInitialFieldValue = _ref.getInitialFieldValue,
      setFieldValue = _ref.setFieldValue,
      type = _ref.type;

  if (![__WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["e" /* SO_ITEM */], __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["b" /* RO_ITEM */], __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["g" /* MRO_ITEM */], __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["j" /* INVENTORY_TRANSFER_ORDER */]].includes(type)) return null;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      lineItems = _useState2[0],
      setLineItems = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["i" /* SHIP_MULTIPLE_ITEM_IDS */]) || []),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedLineItems = _useState4[0],
      setSelectedLineItems = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedAll = _useState6[0],
      setSelectedAll = _useState6[1];

  var onItemSelected = function onItemSelected(item) {
    var setItems = [];
    if (selectedLineItems.includes(item.id)) {
      var index = selectedLineItems.indexOf(item.id);
      selectedLineItems.splice(index, 1);
      setItems = selectedLineItems;
      setSelectedLineItems(setItems);
    } else {
      setItems = selectedLineItems.concat(item.id);
      setSelectedLineItems(setItems);
    }
    setFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["i" /* SHIP_MULTIPLE_ITEM_IDS */])(setItems);
  };

  var selectAll = function selectAll() {
    if (selectedAll) {
      setSelectedLineItems([]);
      setFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["i" /* SHIP_MULTIPLE_ITEM_IDS */])([]);
      setSelectedAll(false);
    } else {
      var allItems = lineItems.map(function (l) {
        return l.id;
      });
      setSelectedLineItems(allItems);
      setFieldValue(__WEBPACK_IMPORTED_MODULE_7__constants__["i" /* SHIP_MULTIPLE_ITEM_IDS */])(allItems);
      setSelectedAll(true);
    }
  };

  var uriMap = (_uriMap = {}, _defineProperty(_uriMap, __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["b" /* RO_ITEM */], "repairOrders"), _defineProperty(_uriMap, __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["g" /* MRO_ITEM */], "managedRepairOrders"), _defineProperty(_uriMap, __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["e" /* SO_ITEM */], "salesOrders"), _defineProperty(_uriMap, __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["j" /* INVENTORY_TRANSFER_ORDER */], "transfers"), _uriMap);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */][uriMap[type]].show(orderId, "lines_no_details").then(function (_ref2) {
      var data = _ref2.data;

      var items = data.line_items || data.results;
      setLineItems(items.filter(function (l) {
        return !l.shipped && !l.cancelled;
      }));
      if (items.length === 1) {
        onItemSelected(items[0]);
      }
      return function cleanup() {};
    });
  }, [orderId]);

  if (lineItems.length === 0) return null;

  var renderRow = function renderRow(lineItem, i) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      { key: i },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        i + 1
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { style: { marginBottom: "6px" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          name: __WEBPACK_IMPORTED_MODULE_2__constants__["A" /* LINE_ITEMS */],
          type: "checkbox",
          disabled: lineItems.length === 1,
          checked: selectedLineItems.includes(lineItem.id),
          onChange: function onChange() {
            return onItemSelected(lineItem);
          }
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { style: { position: "relative" } },
        lineItem.part.part_number,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Form__["a" /* SimpleCopy */], { value: lineItem.part.part_number })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        lineItem.serial_number
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        lineItem.condition && __WEBPACK_IMPORTED_MODULE_9__inventories_constants__["r" /* INVENTORIES */].condition[lineItem.condition].abbrev
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        lineItem.quantity
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        lineItem.part.description
      )
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
    { className: "row-col-gutters-half" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
      { md: 12 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        null,
        "Parts"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "table",
        { className: "table table-striped table-hover table-numbered" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                name: "line_items",
                type: "checkbox",
                disabled: lineItems.length === 1,
                onChange: selectAll,
                checked: selectedAll
              }),
              "\xA0\xA0Select All"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Part Number"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Serial#"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Cd"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "QTY"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Description"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tbody",
          null,
          lineItems.map(function (inv, idx) {
            return renderRow(inv, idx);
          })
        )
      )
    )
  );
}

ShipMultipleRecordsTable.propTypes = {
  orderId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getInitialFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(ShipMultipleRecordsTable));

/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesOrders_helpers__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_helpers__ = __webpack_require__(79);







var ShipTo = function ShipTo(_ref) {
  var parentRecord = _ref.parentRecord;

  if (!parentRecord) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "panel panel-default panel-note animate-row",
      style: { height: "330px" }
    });
  }
  var shippingAddress = parentRecord.ship_to_address;
  var shipToShippingMethod = parentRecord.ship_to_shipping_method;
  var shipToShippingType = parentRecord.ship_to_type;

  if (!shippingAddress) return null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "well" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h6",
      { className: "h4" },
      "Shipment Summary"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        shippingAddress[__WEBPACK_IMPORTED_MODULE_2__constants__["x" /* COMPANY_NAME */]] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__SalesOrders_helpers__["b" /* dropShip */])(parentRecord.ship_to_type) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Company:"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            shippingAddress[__WEBPACK_IMPORTED_MODULE_2__constants__["x" /* COMPANY_NAME */]]
          )
        )],
        shippingAddress[__WEBPACK_IMPORTED_MODULE_2__constants__["D" /* CARE_OF */]] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__SalesOrders_helpers__["b" /* dropShip */])(shipToShippingType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "c/o"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            shippingAddress.care_of
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Cust.\xA0Ph"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            parentRecord.company && parentRecord.company.phone || parentRecord.ship_to_company && parentRecord.ship_to_company.phone
          )
        ),
        parentRecord.ship_to_company && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Company"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["w" /* CompanyName */], {
              company: parentRecord.ship_to_company,
              truncateAt: 12
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Address"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            shippingAddress.line1,
            shippingAddress[__WEBPACK_IMPORTED_MODULE_2__constants__["t" /* LINE2 */]] && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), shippingAddress[__WEBPACK_IMPORTED_MODULE_2__constants__["t" /* LINE2 */]]]
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "City"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            shippingAddress[__WEBPACK_IMPORTED_MODULE_2__constants__["u" /* CITY */]]
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "St/Prov"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            shippingAddress[__WEBPACK_IMPORTED_MODULE_2__constants__["v" /* STATE */]]
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "ZIP"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            shippingAddress[__WEBPACK_IMPORTED_MODULE_2__constants__["w" /* POSTAL_CODE */]]
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Country"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            shippingAddress[__WEBPACK_IMPORTED_MODULE_2__constants__["r" /* COUNTRY */]]
          )
        ),
        shipToShippingMethod && parentRecord.code && parentRecord.code.includes("SO") && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Ship To"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_helpers__["o" /* getCarrierLabel */])(shipToShippingMethod.carrier)
          )
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Ship Met"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_helpers__["p" /* getShippingMethod */])(shipToShippingMethod.carrier, shipToShippingMethod.shipping_method)
          )
        )]
      )
    )
  );
};

ShipTo.propTypes = {
  parentRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  shippingRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (ShipTo);

/***/ }),
/* 1936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_containers__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_DateRangePicker_DateRangePicker__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Create_Container__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Table__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ExportButton__ = __webpack_require__(1938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pagination__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions__ = __webpack_require__(189);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var defaultFilters = {
  accounting_hold: undefined,
  courier_pickup: undefined,
  end_date: undefined,
  table: undefined,
  open_exchange: undefined,
  qc_under_review: undefined,
  qc_hold: undefined,
  released: undefined,
  returning_to_customer: undefined,
  store_location: undefined,
  start_date: undefined
};

var filters = [{
  label: "All ROs",
  filters: { table: "repair_order_line_items" }
}, {
  label: "All SOs",
  filters: { table: "sales_order_line_items" }
}, {
  label: "All Transfers",
  filters: { table: "inventory_transfer_orders" }
}, {
  label: "All Other",
  filters: { table: "other" }
}, {
  label: "Exchanges",
  filters: { open_exchange: true }
}, {
  label: "Mistake Shipments",
  filters: { table: "mistake_shipments" }
}, {
  label: "Returning To Customer",
  filters: { table: "shipments" }
}, {
  label: "Dropshipments",
  filters: { virtual_receiving: true }
}, {
  label: "QC Hold",
  filters: { qc_hold: true }
}, {
  label: "QC Under Review",
  filters: { qc_under_review: true }
}, {
  label: "Accounting Hold",
  filters: { accounting_hold: true }
}, {
  label: "Released",
  filters: { released: true }
}, {
  label: "Not Picked",
  filters: { picked: false }
}, {
  label: "Picked",
  filters: { picked: true }
}, {
  label: "Unreleased",
  filters: { released: false }
}, {
  label: "Courier PickUps",
  filters: { courier_pickup: true }
}];

var filterTags = [{
  label: "All ROs",
  key: "table",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["b" /* matchesString */])("repair_order_line_items")
}, {
  label: "All SOs",
  key: "table",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["b" /* matchesString */])("sales_order_line_items")
}, {
  label: "All Transfers",
  key: "table",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["a" /* matchesBoolean */])("inventory_transfer_orders")
}, {
  label: "All Other",
  key: "table",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["b" /* matchesString */])("other")
}, {
  label: "Dropshipments",
  key: "virtual_receiving"
}, {
  label: "Exchanges",
  key: "open_exchange"
}, {
  label: "Returning To Customer",
  key: "table",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["b" /* matchesString */])("shipments")
}, {
  label: "All Mistake Shipments",
  key: "table",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["b" /* matchesString */])("mistake_shipments")
}, {
  label: "QC Hold",
  key: "qc_hold"
}, {
  label: "QC Under Review",
  key: "qc_under_review"
}, {
  label: "Accounting Hold",
  key: "accounting_hold"
}, {
  label: "Released",
  key: "released",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Unreleased",
  key: "released",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Not Picked",
  key: "picked",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Picked",
  key: "picked",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Courier PickUps",
  key: "courier_pickup",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["a" /* matchesBoolean */])(true)
}];

var Dashboard = function (_Component) {
  _inherits(Dashboard, _Component);

  function Dashboard(props) {
    _classCallCheck(this, Dashboard);

    var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));

    _this.openAndSetRecord = function (record) {
      if (_this.createShippingForm) {
        _this.createShippingForm.openAndSetRecord(record);
      }
    };

    _this.createShippingFormRef = function (el) {
      _this.createShippingForm = el;
    };

    _this.openAndSetRecord = _this.openAndSetRecord.bind(_this);
    return _this;
  }

  _createClass(Dashboard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var subscribeToOrdersChannel = this.props.subscribeToOrdersChannel;


      subscribeToOrdersChannel();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var unsubscribeToOrdersChannel = this.props.unsubscribeToOrdersChannel;


      unsubscribeToOrdersChannel();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var currentUser = this.props.currentUser;


      var filterTagsWithLocations = currentUser.toJS().locations.map(function (l) {
        return {
          label: l.name + " Store Location",
          key: __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_27" /* STORE_LOCATION_ID */],
          matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_filters__["b" /* matchesString */])(l.id)
        };
      });

      var filtersWithLocations = currentUser.toJS().locations.map(function (l, i) {
        return {
          label: l.name + " Store Location",
          filters: _defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_27" /* STORE_LOCATION_ID */], l.id),
          hr: currentUser.toJS().locations.length - 1 === i
        };
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components__["c" /* Search */],
          { search: __WEBPACK_IMPORTED_MODULE_14__pagination__["a" /* default */], syncWithUrl: true },
          function (searchProps) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "input-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
                    placeholder: "Search by typing a part number, company name or any reference number..."
                  })),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Create_Container__["a" /* default */], { ref: _this2.createShippingFormRef }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ExportButton__["a" /* default */], { searchProps: searchProps }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_DateRangePicker_DateRangePicker__["a" /* default */], searchProps),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
                    filters: filters.concat(filtersWithLocations).concat({
                      label: __WEBPACK_IMPORTED_MODULE_9__constants__["_37" /* CLEAR_FILTERS_TEXT */],
                      filters: defaultFilters
                    }),
                    right: true
                  }))
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
                title: "Outbound Orders",
                filters: filterTags.concat(filterTagsWithLocations)
              })),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_containers__["e" /* DataTable */], _extends({}, searchProps, {
                component: __WEBPACK_IMPORTED_MODULE_12__Table__["a" /* default */],
                openModal: _this2.openAndSetRecord
              })),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["d" /* Pagination */], searchProps)
            );
          }
        )
      );
    }
  }]);

  return Dashboard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Dashboard.propTypes = {
  subscribeToOrdersChannel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  unsubscribeToOrdersChannel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session && state.session.get(__WEBPACK_IMPORTED_MODULE_8__users_constants__["a" /* USER */])
  };
}, function (dispatch) {
  return {
    subscribeToOrdersChannel: function subscribeToOrdersChannel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__actions__["e" /* subscribe */])());
    },
    unsubscribeToOrdersChannel: function unsubscribeToOrdersChannel() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__actions__["f" /* unsubscribe */])());
    }
  };
})(Dashboard));

/***/ }),
/* 1937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DownloadPackingSlipModal_Form__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_CommercialInvoice_helpers__ = __webpack_require__(173);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();







function DownloadPackingSlip(_ref) {
  var record = _ref.record,
      url = _ref.url,
      setCurrentForm = _ref.setCurrentForm;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(record.line_items.map(function (l) {
    return l.id;
  })),
      _useState2 = _slicedToArray(_useState, 2),
      lineItemIds = _useState2[0],
      setLineItemIds = _useState2[1];

  if (record) {
    return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_DownloadPackingSlipModal_Form__["a" /* default */], {
        setLineItemIds: setLineItemIds,
        lineItemIds: lineItemIds,
        record: record,
        partKey: "part.part_number",
        serialKey: "serial_number"
      })
    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["e" /* Form */].Footer,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["e" /* Form */].Cancel, {
        close: function close() {
          return setCurrentForm(__WEBPACK_IMPORTED_MODULE_4__shared_components_CommercialInvoice_helpers__["c" /* SHIPPING_CHECKLIST */]);
        },
        editable: true
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["e" /* Form */].Submit, {
        text: "Download",
        disabled: false,
        editable: true,
        onClick: function onClick() {
          window.open(url + "&" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_query_string__["stringify"])({
            line_item_ids: lineItemIds.join(",")
          }), "_blank");
          setCurrentForm(__WEBPACK_IMPORTED_MODULE_4__shared_components_CommercialInvoice_helpers__["c" /* SHIPPING_CHECKLIST */]);
        }
      })
    )];
  }
}

/* harmony default export */ __webpack_exports__["a"] = (DownloadPackingSlip);

/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__);







var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = searchProps.paginator.get("filters").toJS();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].outboundOrders.export(params).then(function () {
          __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].info("Processing Report.");
        });
      }
    },
    "Export"
  );
};

ExportButton.propTypes = {
  searchProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    paginator: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map)
  })
};

var meetsExportCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var searchProps = _ref2.searchProps;
  return searchProps.paginator.get("totalCount") <= 100;
});

var DecoratedExportButton = meetsExportCriteria(ExportButton);

/* harmony default export */ __webpack_exports__["a"] = (DecoratedExportButton);

/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_StatusTags__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_LocationFlag_LocationFlag__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components_NoteTooltip_NoteTooltipTableCell__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_components_UpdatedTrackedFieldsAt_UpdatedTrackedFieldsAt__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__inventories_components_Detail_Header_DropdownActions_Print_Print__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions__ = __webpack_require__(189);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

























var abbrev = function abbrev(t) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["m" /* itemInfo */])(t).abbrev || t;
};

var DiscreetAttached = function DiscreetAttached(_ref) {
  var order = _ref.order;

  if (order.discreet_attached) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["F" /* IconText */], {
      note: "Customer's discreet paperwork provided",
      margin: "5px",
      icon: "text-default fa-user-secret"
    });
  }

  return null;
};

DiscreetAttached.propTypes = {
  order: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({})
};

function Table(_ref2) {
  var openModal = _ref2.openModal,
      results = _ref2.results,
      pick = _ref2.pick,
      currentUser = _ref2.currentUser,
      isLoading = _ref2.isLoading;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPrintModalOpen = _useState2[0],
      setIsPrintModalOpen = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      inventory = _useState4[0],
      setInventory = _useState4[1];

  var openOrder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (order) {
    return function (e) {
      e.stopPropagation();
      openModal(order);
    };
  }, []);

  function handlePrintIconClick(e, order) {
    e.preventDefault();
    e.stopPropagation();
    __WEBPACK_IMPORTED_MODULE_20__api__["a" /* default */].inventories.show(order.inventory_id).then(function (response) {
      setInventory(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_immutable__["fromJS"])(response.data));
      setIsPrintModalOpen(true);
    });
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    isPrintModalOpen && inventory && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__inventories_components_Detail_Header_DropdownActions_Print_Print__["a" /* default */], {
      editing: isPrintModalOpen,
      close: function close() {
        return setIsPrintModalOpen(false);
      },
      inventory: inventory
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */],
      { loading: isLoading },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Head,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Ref #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Date Created"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Part #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Serial #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_18__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Store Loc"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Location"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Company"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Cust PO #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Discreet"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Pics Req'd"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Cust P/W"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Carrier"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Outgoing AWB#"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Spec Instr"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Status"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "CD"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "QTY"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "QTY Ship"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Picked At"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Picked By"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { width: "1%" },
          "Print"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { width: "2%" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Body,
        null,
        results.map(function (order) {
          var isMistakeShipment = order.company_name && order.company_name.toLowerCase() === "mistake shipment";
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            {
              className: "clickable",
              key: order.type + "-" + order.order_id + "-" + order.id,
              onClick: openOrder(order)
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              order.exporting && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["j" /* NoteTooltip */], {
                icon: "fa-globe",
                placement: "top",
                note: "Exporting",
                color: "#2196F3"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              (order.parent || [__WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["n" /* RMA */], __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["o" /* MISTAKE */]].includes(order.type)) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],
                {
                  to: "/" + __WEBPACK_IMPORTED_MODULE_10__constants__["s" /* LINK_MAPPINGS */][abbrev(order.type)] + "/" + ([__WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["o" /* MISTAKE */], __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["n" /* RMA */]].includes(order.type) ? order.uuid : order.parent.uuid || order.parent.id)
                },
                [__WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["n" /* RMA */], __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["o" /* MISTAKE */]].includes(order.type) ? abbrev(order.type) + "-" + order.code : order.parent.code
              ),
              order.type === __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["h" /* REJECTED_CORE_ORDER */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],
                { to: "/rejected-cores/" + order.uuid },
                "RC-",
                order.code
              ),
              order.type === __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_96" /* RETURNED_CONSIGNMENT */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                null,
                order.consignment_reference
              ),
              order.type === __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["i" /* RETURN_TO_CUSTOMER_RECORD */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],
                { to: "/inventories/" + order.inventory_uuid },
                "RMA-",
                order.code
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__shared_components_UpdatedTrackedFieldsAt_UpdatedTrackedFieldsAt__["a" /* default */], {
                record: order,
                formatter: __WEBPACK_IMPORTED_MODULE_11__lib_formatters_date__["a" /* shortDateYYandTime */]
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["h" /* PartNumber */], {
                part: {
                  id: order.part_id,
                  part_number: order.part_number,
                  uuid: order.part_uuid
                },
                statsTooltip: false
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              !isMistakeShipment && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],
                {
                  to: "/inventories/" + (order.inventory_uuid || order.inventory_id)
                },
                order.serial_number
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_18__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                { className: "text-center" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_LocationFlag_LocationFlag__["a" /* default */], { location: order.store_location_id })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              order.type === __WEBPACK_IMPORTED_MODULE_5__Orders_shared_constants__["h" /* REJECTED_CORE_ORDER */] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])(order.location, 15) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])(order.inventory_location, 15),
              order.received_virtually && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { style: { marginLeft: 5 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["j" /* NoteTooltip */], { note: "Virtual" })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["w" /* CompanyName */], {
                flattenedCompany: order,
                statsTooltip: false,
                truncateAt: 25
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              order.customer_purchase_order_number
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["_0" /* CheckColumn */], {
              checked: order.discreet,
              icon: "eye-slash",
              text: "Yes"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["_0" /* CheckColumn */], {
              checked: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(order, "parent.pictures_required"),
              colorClass: "text-success text-center",
              icon: "check",
              text: "Yes"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__shared_components__["_0" /* CheckColumn */],
              {
                checked: order.customer_to_provide_own_paperwork,
                icon: "check",
                text: "Yes"
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DiscreetAttached, { order: order })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              { className: order.carrier_does_not_match && "text-yellow" },
              order.carrier && __WEBPACK_IMPORTED_MODULE_17__shared_constants__["a" /* CARRIERS */][order.carrier].label
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])(order.outgoing_awb_number, 15)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components_NoteTooltip_NoteTooltipTableCell__["a" /* default */], { note: order.special_instructions }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "flex-tags" },
                order.export_compliance_hold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_StatusTags__["a" /* StatusTag */], { title: "Export Compliance Hold", icon: "pause" }),
                order.new_company_hold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_StatusTags__["a" /* StatusTag */], { title: "New Cust. Hold", icon: "pause" }),
                order.customer_qc_preapproval_required && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_StatusTags__["a" /* StatusTag */], { title: "QC Pre-Approval Req'd", icon: "pause" }),
                order.export_hold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_StatusTags__["a" /* StatusTag */], { title: "Export Hold", icon: "pause" }),
                order.accounting_hold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_StatusTags__["a" /* StatusTag */], { title: "Accounting Hold", icon: "pause" }),
                (order.qc_status === __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["S" /* QC_HOLD */] || order.qc_hold) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_StatusTags__["a" /* StatusTag */], {
                  title: "QC Hold",
                  icon: "warning",
                  display: "danger"
                }),
                order.qc_status === __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["T" /* UNDER_REVIEW */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_StatusTags__["a" /* StatusTag */], {
                  title: "Under Review",
                  icon: "search",
                  display: "warning"
                }),
                !order.customer_qc_preapproval_required && !order.accounting_hold && !order.new_company_hold && !order.export_compliance_hold && !order.export_hold && order.qc_status !== __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["S" /* QC_HOLD */] && !order.qc_hold && order.qc_status !== __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["T" /* UNDER_REVIEW */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_StatusTags__["a" /* StatusTag */], {
                  title: "Released",
                  icon: "truck",
                  display: "success"
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__["z" /* condition */])(order.condition).abbrev
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              { className: "text-right" },
              order.quantity
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              { className: "text-right" },
              order.quantity_shipped
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              order.picked && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_date__["a" /* shortDateYYandTime */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(order, "picked_details.picked_at"))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              order.picked && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["d" /* getFirstNameLastInitial */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(order, "picked_details.picked_by.name"))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              { className: "center-center" },
              order.inventory_id && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
                className: "fa fa-print",
                onClick: function onClick(e) {
                  return handlePrintIconClick(e, order);
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              { width: "2%", style: { position: "relative" } },
              order.received_virtually ? "Dropshipment" : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["_1" /* ToggleButton */], {
                text: "Pick",
                toggledText: "Unpick",
                toggled: order.picked,
                canRemove: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(order, "picked_details.picked_by.id") !== currentUser.id || order.picked,
                handleClick: function handleClick(e) {
                  pick(order);
                  e.stopPropagation();
                }
              }),
              !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(order.shipping_cached_key) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { style: { position: "absolute", right: "-5px" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["j" /* NoteTooltip */], {
                  note: "Saved Checklist",
                  icon: "fa-thumb-tack",
                  color: "#2196F3"
                })
              )
            )
          );
        })
      )
    )
  );
}

Table.propTypes = _extends({
  openModal: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  pick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  currentUser: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({})
}, __WEBPACK_IMPORTED_MODULE_6__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_16__users_constants__["a" /* USER */]).toJS()
  };
}, function (dispatch, ownProps) {
  return {
    pick: function pick(order) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__actions__["g" /* toggleAsyncPicked */])(order));
    },
    refresh: ownProps.pageActions.expire
  };
})(Table));

/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dashboard__ = __webpack_require__(1936);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dashboard__["a"]; });



/***/ }),
/* 1941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Subscription_actionTypes__ = __webpack_require__(457);
/* harmony export (immutable) */ __webpack_exports__["a"] = setFresh;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function setFresh(key) {
  return function (dispatch) {
    dispatch(_defineProperty({
      type: __WEBPACK_IMPORTED_MODULE_0__Subscription_actionTypes__["a" /* SUBSCRIPTION_NOTIFICATION */]
    }, key, {
      stale: false
    }));
  };
}

/***/ }),
/* 1942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(457);
/* unused harmony export initialState */
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* SUBSCRIPTION_NOTIFICATION */], function (state, action) {
  return state.mergeDeep(action);
})));

/***/ }),
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(724);
/* unused harmony export initialState */
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  upgradeAvailable: false
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* UPGRADE_CHECK */], function (state, action) {
  return state.set("upgradeAvailable", action.upgradeAvailable);
})));

/***/ }),
/* 1944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Table__ = __webpack_require__(1945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pagination__ = __webpack_require__(726);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



















var filters = [{
  label: "Only Mine",
  filters: { current_user: true }
}, {
  label: "All",
  filters: { current_user: undefined }
}, {
  label: "All Cancelled RMAs",
  filters: { cancelled: true }
}, {
  label: "Active Credit Requests",
  filters: { credit_requested: true, credit_issued: false }
}, {
  label: "Resolved Credit Requests",
  filters: { credit_requested: true, credit_issued: true }
}, {
  label: "Not Received",
  filters: { rma_received: false }
}, {
  label: "Warranty Consideration",
  filters: { warranty_consideration: true }
}, {
  label: "No Credit Requested",
  filters: { credit_requested: false }
}, {
  label: "Vendor RMA # Issued",
  filters: { vendor_rma_issued: true }
}, {
  label: "Vendor RMA # Missing",
  filters: { vendor_rma_issued: false }
}, {
  label: "Active Warranty Consideration Requests",
  filters: { active_warranty_consideration_requests: true }
}, {
  label: "Closed Date is BLANK",
  filters: { no_closed_date: true }
}, {
  label: "Partial Credit Requested",
  filters: { partial_credit_status: "requested" }
}, {
  label: "RO Closed Before Vendor Reply",
  filters: {
    partial_credit_status: "ro_closed_before_vendor_reply"
  }
}];

var filterTags = [{
  label: "Only Mine",
  key: "current_user"
}, {
  label: "Cancelled",
  key: "cancelled",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Credit Requested",
  key: "credit_requested",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Open Credit Requests",
  key: "credit_issued",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Resolved Credit Requests",
  key: "credit_issued",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Not Received",
  key: "rma_received",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Warranty Consideration",
  key: "warranty_consideration",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "No Credit Requested",
  key: "credit_requested",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Vendor RMA # Issued",
  key: "vendor_rma_issued",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Active Warranty Consideration Requests",
  key: "active_warranty_consideration_requests",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Vendor RMA # Missing",
  key: "vendor_rma_issued",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Closed Date is BLANK",
  key: "no_closed_date",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Partial Credit Requested",
  key: "partial_credit_status",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["b" /* matchesString */])("requested")
}, {
  label: "RO Closed Before Vendor Reply",
  key: "partial_credit_status",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["b" /* matchesString */])("ro_closed_before_vendor_reply")
}, {
  label: "Open Warranty Requests",
  key: "warranty_requested",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Closed Warranty Requests",
  key: "warranty_requested",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(false)
}];

var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = searchProps.paginator.get("filters").toJS();
  var totalCount = searchProps.paginator.get("totalCount");

  params.total_count = totalCount;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        if (totalCount > __WEBPACK_IMPORTED_MODULE_9__users_constants__["_6" /* EXPORT_LIMIT */]) {
          __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__["toastr"].info("Processing");
          __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].vendorRmas.export(params).then(function () {
            return __WEBPACK_IMPORTED_MODULE_13__lib_submission__["a" /* SUCCESS */];
          });
        } else {
          window.open(__WEBPACK_IMPORTED_MODULE_12__constants__["d" /* API_BASE */] + "/vendor_rmas/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_query_string__["stringify"])(params), "_blank");
          __WEBPACK_IMPORTED_MODULE_11_react_redux_toastr__["toastr"].success("Processing Vendor RMA Report. Please wait for the PDF to generate.");
        }
      }
    },
    "Export"
  );
};

var meetsExportCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var searchProps = _ref2.searchProps,
      currentUser = _ref2.currentUser;
  return searchProps.paginator.get("totalCount") <= 450 || currentUser.role === __WEBPACK_IMPORTED_MODULE_9__users_constants__["i" /* ADMIN */];
});

var DecoratedExportButton = meetsExportCriteria(ExportButton);

function RmasSearch(_ref3) {
  var pushHistory = _ref3.pushHistory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_16__pagination__["a" /* default */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing an RMA Number or Serial Number or Part Number...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/rmas/" + r.uuid);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DecoratedExportButton, {
              searchProps: searchProps,
              currentUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__hooks__["a" /* useCurrentUser */])()
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, { filters: filters, right: true }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "Vendor RMA",
          filters: filterTags
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

RmasSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(RmasSearch));

/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(36);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










function renderRow(r, pushHistory) {
  var handleMailto = function handleMailto(e) {
    e.stopPropagation();
  };

  var rowClasses = __WEBPACK_IMPORTED_MODULE_6_classnames___default()("clickable", { "text-muted": r.cancelled });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: r.id,
      className: rowClasses,
      onClick: function onClick() {
        return pushHistory("/rmas/" + r.uuid);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.reference_record_code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["b" /* shortDate */])(r.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.closed_date && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["b" /* shortDate */])(r.closed_date)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.company_name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.contact_name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.company_phone
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        { href: "mailto:" + r.contact_email, onClick: handleMailto },
        r.contact_email
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["h" /* PartNumber */], { part: r.part }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          to: "/inventories/" + r.inventory.uuid
        },
        r.inventory.serial_number
      )
    )
  );
}

function Table(_ref) {
  var isLoading = _ref.isLoading,
      pageActions = _ref.pageActions,
      results = _ref.results,
      pushHistory = _ref.pushHistory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */],
    { loading: isLoading, refresh: pageActions.expire },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "RMA #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Ref #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Created"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Closed"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Vendor"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Contact"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Phone"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Email"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_5__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"] })(Table));

/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(1944);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });



/***/ }),
/* 1947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(1946);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });



/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_submission__ = __webpack_require__(49);
/* unused harmony export addressPageActions */
/* harmony export (immutable) */ __webpack_exports__["c"] = createPhysicalAddress;
/* harmony export (immutable) */ __webpack_exports__["b"] = updatePhysicalAddress;
/* harmony export (immutable) */ __webpack_exports__["a"] = destroyPhysicalAddress;




var addressPageActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["composables"])({
  listId: "company/physicalAddresses"
});

function createPhysicalAddress(contact) {
  return function (dispatch, getState) {
    var companyId = getState().companyDetail.getIn(["company", "id"]);
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].companies.physicalAddresses.create(companyId, contact).then(function () {
      dispatch(addressPageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function updatePhysicalAddress(contact) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].physicalAddresses.update(contact).then(function () {
      dispatch(addressPageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function destroyPhysicalAddress(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].physicalAddresses.destroy(id).then(function () {
      return dispatch(addressPageActions.expire());
    });
  };
}

/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_submission__ = __webpack_require__(49);
/* unused harmony export relatedCompanyPageActions */
/* harmony export (immutable) */ __webpack_exports__["c"] = createRelatedCompany;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateRelatedCompany;
/* harmony export (immutable) */ __webpack_exports__["a"] = destroyRelatedCompany;




var relatedCompanyPageActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["composables"])({
  listId: "company/relatedCompanies"
});

function createRelatedCompany(relatedCompany) {
  return function (dispatch, getState) {
    var companyId = getState().companyDetail.getIn(["company", "id"]);
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].companies.relatedCompanies.create(companyId, relatedCompany).then(function () {
      dispatch(relatedCompanyPageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function updateRelatedCompany(relatedCompany) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].relatedCompanies.update(relatedCompany).then(function () {
      dispatch(relatedCompanyPageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function destroyRelatedCompany(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].relatedCompanies.destroy(id).then(function () {
      return dispatch(relatedCompanyPageActions.expire());
    });
  };
}

/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_submission__ = __webpack_require__(49);
/* unused harmony export shippingPageActions */
/* harmony export (immutable) */ __webpack_exports__["c"] = createShippingMethod;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateShippingMethod;
/* harmony export (immutable) */ __webpack_exports__["a"] = destroyShippingMethod;




var shippingPageActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["composables"])({
  listId: "company/shippingMethods"
});

function createShippingMethod(shipMethod) {
  return function (dispatch, getState) {
    var companyId = getState().companyDetail.getIn(["company", "id"]);
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].companies.shippingMethods.create(companyId, shipMethod).then(function () {
      dispatch(shippingPageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function updateShippingMethod(shipMethod) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].shippingMethods.update(shipMethod).then(function () {
      dispatch(shippingPageActions.expire());
      return __WEBPACK_IMPORTED_MODULE_2__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function destroyShippingMethod(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].shippingMethods.destroy(id).then(function () {
      return dispatch(shippingPageActions.expire());
    });
  };
}

/***/ }),
/* 1951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["b"] = createAircraft;
/* harmony export (immutable) */ __webpack_exports__["a"] = destroyAircraft;







var pgActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["composables"])({ listId: "company/aircrafts" });

function createAircraft(aircraft) {
  return function (dispatch, getState) {
    var companyId = getState().companyDetail.getIn([__WEBPACK_IMPORTED_MODULE_5__constants__["i" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].companies.aircrafts.create(companyId, aircraft).then(function () {
      dispatch(pgActions.expire());
      return __WEBPACK_IMPORTED_MODULE_4__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function destroyAircraft(id) {
  return function (dispatch, getState) {
    var companyId = getState().companyDetail.getIn([__WEBPACK_IMPORTED_MODULE_5__constants__["i" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]]);
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].companies.aircrafts.delete(companyId, id).then(function () {
      return dispatch(pgActions.expire());
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].error("Error", __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(error, "errors.base[0]"), "Unexpected error");
    });
  };
}

/***/ }),
/* 1952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_submission__ = __webpack_require__(49);
/* unused harmony export pgActions */
/* harmony export (immutable) */ __webpack_exports__["b"] = createContact;
/* harmony export (immutable) */ __webpack_exports__["a"] = updateContact;
/* harmony export (immutable) */ __webpack_exports__["c"] = destroyContact;






var pgActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["composables"])({ listId: "company/contacts" });

function createContact(contact) {
  return function (dispatch, getState) {
    var companyId = getState().companyDetail.getIn(["company", "id"]);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].companies.contacts.create(companyId, contact).then(function () {
      dispatch(pgActions.expire());
      return __WEBPACK_IMPORTED_MODULE_4__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function updateContact(contact) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].contacts.update(contact).then(function () {
      dispatch(pgActions.expire());
      return __WEBPACK_IMPORTED_MODULE_4__lib_submission__["a" /* SUCCESS */];
    });
  };
}

function destroyContact(id) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].contacts.destroy(id).then(function () {
      return dispatch(pgActions.expire());
    }).catch(function (error) {
      // Its possible that the delete will fail due to the contact being associated with other records.
      // This toastr error helps the user understand exactly why the delete failed since there's been confusion on it in the past.
      __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].error("Error", __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(error, "errors.base[0]"), "Unexpected error");
    });
  };
}

/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(1954);
/* harmony export (immutable) */ __webpack_exports__["a"] = CreateCompany;





function CreateCompany(_ref) {
  var open = _ref.open,
      close = _ref.close;

  var initialValues = {
    request_vendor_approval: false,
    request_shop_approval: false,
    same_as_billing: true
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-lg" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Add a Company"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close, initialValues: initialValues })
    )
  );
}

CreateCompany.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormSections__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__validate__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AddressFields__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PhysicalAddress__ = __webpack_require__(1955);
/* unused harmony export Form */

















var FORM_NAME = "createCompany";

function Form(props) {
  var requireContact = !props.getFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["e" /* WEBSITE */]) || [__WEBPACK_IMPORTED_MODULE_10__constants__["S" /* NAME */], __WEBPACK_IMPORTED_MODULE_10__constants__["T" /* EMAIL */]].some(function (f) {
    return !!props.getFieldValue([__WEBPACK_IMPORTED_MODULE_8__constants__["g" /* CONTACT */], f].join("."));
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "row" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "panel panel-default detail-panel" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "panel-body" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["E" /* COMPANY_TYPE */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
                label: "Type",
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_8__constants__["F" /* COMPANY_TYPES */])
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_10__constants__["S" /* NAME */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__constants__["S" /* NAME */]),
                required: true
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["p" /* PhoneNumberField */], {
                name: __WEBPACK_IMPORTED_MODULE_10__constants__["R" /* PHONE */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__constants__["R" /* PHONE */])
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["e" /* WEBSITE */],
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["e" /* WEBSITE */])
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["m" /* DashedSeparator */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h5",
                { className: "h3" },
                "Primary Contact Info"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: [__WEBPACK_IMPORTED_MODULE_8__constants__["g" /* CONTACT */], __WEBPACK_IMPORTED_MODULE_10__constants__["S" /* NAME */]].join("."),
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                label: "Contact Name",
                required: requireContact
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: [__WEBPACK_IMPORTED_MODULE_8__constants__["g" /* CONTACT */], __WEBPACK_IMPORTED_MODULE_10__constants__["T" /* EMAIL */]].join("."),
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                label: "Contact Email",
                required: requireContact
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["p" /* PhoneNumberField */], {
                name: [__WEBPACK_IMPORTED_MODULE_8__constants__["g" /* CONTACT */], __WEBPACK_IMPORTED_MODULE_10__constants__["R" /* PHONE */]].join("."),
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                label: "Contact Phone"
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["m" /* DashedSeparator */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h5",
                { className: "h3" },
                "Status And Approval"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    className: "btn-group btn-group-justified btn-group-vertical",
                    "data-toggle": "buttons"
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                    name: "request_vendor_approval",
                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                    label: "Request Vendor Approval"
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                    name: "request_shop_approval",
                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                    label: "Request Rep Station Approval"
                  })
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["e" /* Col */],
          { md: 8 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h5",
            { className: "h3 modal-body-top" },
            "Billing Address"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__AddressFields__["a" /* default */], {
            path: __WEBPACK_IMPORTED_MODULE_8__constants__["w" /* BILLING_ADDRESS */],
            country: props.country,
            region: props.region,
            formName: FORM_NAME,
            showRegion: true,
            stateProvinceRequired: true
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h5",
            { className: "h3" },
            "Physical Address"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PhysicalAddress__["a" /* default */], { renderCheckbox: true }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h5",
            { className: "h3 modal-body-top" },
            "Shipping Preference"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_redux_form__["FormSection"],
            { name: "shipping_method" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormSections__["a" /* ShippingMethod */], { required: false })
          )
        )
      )
    )
  );
}

Form.propTypes = {
  country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["formValueSelector"])(FORM_NAME);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    country: selector(state, "billing_address.country"),
    getFieldValue: function getFieldValue(field) {
      return selector(state, field);
    }
  };
}, { onSubmit: __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* create */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_13__validate__["a" /* default */],
  asyncValidate: __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* validateContact */],
  asyncBlurFields: ["contact.email"]
})(Form)));

/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AddressFields__ = __webpack_require__(245);
/* unused harmony export PhysicalAddress */








var ToggleAddressFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["s" /* toggle */])(__WEBPACK_IMPORTED_MODULE_6__AddressFields__["a" /* default */]);

function PhysicalAddress(_ref) {
  var sameAsBilling = _ref.sameAsBilling,
      country = _ref.country;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "form-group" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "btn-group", "data-toggle": "buttons" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: "same_as_billing",
          component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
          label: "Same as billing address"
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ToggleAddressFields, {
      path: "physical_address",
      country: country,
      formName: "createCompany",
      open: !sameAsBilling
    })
  );
}

PhysicalAddress.propTypes = {
  sameAsBilling: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])("createCompany");

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    sameAsBilling: selector(state, "same_as_billing"),
    country: selector(state, "physical_address.country")
  };
})(PhysicalAddress));

/***/ }),
/* 1956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateCompany__ = __webpack_require__(1953);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CreateCompany__["a"]; });



/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;





function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["S" /* NAME */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);

    if (!values.website || values.contact && (values.contact.name || values.contact.email)) {
      form.validateChild(__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* CONTACT */], function (contactForm) {
        contactForm.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["S" /* NAME */], __WEBPACK_IMPORTED_MODULE_2__constants__["T" /* EMAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
        contactForm.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["T" /* EMAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["b" /* isValidEmail */]);
      });
    }

    form.validateChild("billing_address", function (billingForm) {
      billingForm.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_2__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_2__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_2__constants__["w" /* POSTAL_CODE */], __WEBPACK_IMPORTED_MODULE_2__constants__["r" /* COUNTRY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["p" /* requiredIfAnyDefined */](__WEBPACK_IMPORTED_MODULE_2__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* LINE2 */], __WEBPACK_IMPORTED_MODULE_2__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_2__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_2__constants__["w" /* POSTAL_CODE */], __WEBPACK_IMPORTED_MODULE_2__constants__["r" /* COUNTRY */]));
    });

    if (!values.same_as_billing) {
      form.validateChild("physical_address", function (physicalForm) {
        physicalForm.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_2__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_2__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_2__constants__["w" /* POSTAL_CODE */], __WEBPACK_IMPORTED_MODULE_2__constants__["r" /* COUNTRY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["p" /* requiredIfAnyDefined */](__WEBPACK_IMPORTED_MODULE_2__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* LINE2 */], __WEBPACK_IMPORTED_MODULE_2__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_2__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_2__constants__["w" /* POSTAL_CODE */], __WEBPACK_IMPORTED_MODULE_2__constants__["r" /* COUNTRY */]));
      });
    }

    form.validateChild("shipping_method", function (shippingForm, _ref) {
      var carrier = _ref.carrier;

      if (carrier) {
        shippingForm.validate("shipping_method").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      }
    });
  });
}

/***/ }),
/* 1958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = ApprovalStatus;



function ApprovalStatus(_ref) {
  var approved = _ref.approved,
      restricted = _ref.restricted;

  if (approved) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "text-success" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check" }),
      "\xA0Approved"
    );
  }

  return restricted ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "text-warning" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-ban" }),
    "\xA0Export Preapproval Req'd"
  ) : null;
}

ApprovalStatus.propTypes = {
  approved: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  restricted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_ConfirmAction__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_DetailTable_CheckForDetail__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_NoteTooltip_AuditedNoteTooltip__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Status__ = __webpack_require__(2011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ApprovalStatus__ = __webpack_require__(1958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DoNotQuote__ = __webpack_require__(1976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PendingStatus__ = __webpack_require__(1984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__VendorApproval__ = __webpack_require__(2013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__EditApprovals__ = __webpack_require__(2019);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var ApprovalsTable = function (_Component) {
  _inherits(ApprovalsTable, _Component);

  function ApprovalsTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ApprovalsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ApprovalsTable.__proto__ || Object.getPrototypeOf(ApprovalsTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editApprovalsModalOpen: false,
      vendorConfirmModalOpen: false,
      stationConfirmModalOpen: false
    }, _this.toggleModalState = function (key) {
      var currentValue = _this.state[key];
      _this.setState(_defineProperty({}, key, !currentValue));
    }, _this.openVendorConfirmModal = function () {
      _this.setState({ vendorConfirmModalOpen: true });
    }, _this.openStationConfirmModal = function () {
      _this.setState({ stationConfirmModalOpen: true });
    }, _this.closeVendorConfirmModal = function () {
      return _this.setState({ vendorConfirmModalOpen: false });
    }, _this.closeStationConfirmModal = function () {
      return _this.setState({ stationConfirmModalOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ApprovalsTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var editApprovalsModalOpen = this.state.editApprovalsModalOpen;
      var company = this.props.company;

      var approvalText = function approvalText(timestamp, approver) {
        return "Updated by " + approver.get("full_name") + " on " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__["b" /* shortDate */])(timestamp);
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          { style: { marginTop: 10 } },
          "Status & Approvals",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_19__shared_components__["b" /* Authorized */],
            {
              permissions: [__WEBPACK_IMPORTED_MODULE_8__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]],
              roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_8__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["j" /* WAREHOUSE */])
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["y" /* EditButton */], {
              handleClick: function handleClick() {
                return _this2.toggleModalState("editApprovalsModalOpen");
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__EditApprovals__["a" /* default */], {
              company: company.toJS(),
              open: editApprovalsModalOpen,
              close: function close() {
                return _this2.toggleModalState("editApprovalsModalOpen");
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_19__shared_components__["W" /* DetailTable */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["S" /* Detail */], {
            label: "Status",
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Status__["a" /* default */], { status: company.get("status") }),
              "\xA0",
              company.get("updated_by") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { className: "text-right" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
                  placement: "right",
                  icon: "fa-info-circle",
                  color: "rgba(255, 255, 255, 0.25)",
                  note: approvalText(company.get("updated_at"), company.get("updated_by"))
                })
              )
            )
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["S" /* Detail */], {
            label: "Vendor",
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__VendorApproval__["a" /* default */], {
                status: company.get("vendor_status"),
                onApprovalRequest: function onApprovalRequest() {
                  return _this2.toggleModalState("vendorConfirmModalOpen");
                }
              }),
              "\xA0",
              company.get("vendor_status_updated_by") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { className: "text-right" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
                  placement: "right",
                  icon: "fa-info-circle",
                  color: "rgba(255, 255, 255, 0.25)",
                  note: approvalText(company.get("vendor_status_updated_at"), company.get("vendor_status_updated_by"))
                })
              )
            )
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["S" /* Detail */], {
            label: "Repair Station",
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__VendorApproval__["a" /* default */], {
                status: company.get("repair_station_status"),
                onApprovalRequest: this.openStationConfirmModal
              }),
              "\xA0",
              company.get("repair_station_status_updated_by") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { className: "text-right" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
                  placement: "right",
                  icon: "fa-info-circle",
                  color: "rgba(255, 255, 255, 0.25)",
                  note: approvalText(company.get("repair_station_status_updated_at"), company.get("repair_station_status_updated_by"))
                })
              )
            )
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["S" /* Detail */], {
            label: "Blanket Exch. Agreement",
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
              null,
              company.get("blanket_exchange_agreement") && company.get("blanket_exchange_agreement_updated_by") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { className: "text-success" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check" }),
                  " Approved"
                ),
                "\xA0",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { className: "text-right" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
                    placement: "right",
                    icon: "fa-info-circle",
                    color: "rgba(255, 255, 255, 0.25)",
                    note: approvalText(company.get("blanket_exchange_agreement_updated_at"), company.get("blanket_exchange_agreement_updated_by"))
                  })
                )
              )
            )
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["S" /* Detail */], {
            label: "Export compliant",
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__PendingStatus__["a" /* default */], {
                pending: !company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["P" /* EXPORT_COMPLIANT */]) && !company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["Q" /* EXPORT_APPROVAL_REQUIRED */]) && company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["R" /* END_USER_AGREEMENT_REQUESTED */])
              }),
              "\xA0",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ApprovalStatus__["a" /* default */], {
                approved: company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["P" /* EXPORT_COMPLIANT */]),
                restricted: company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["Q" /* EXPORT_APPROVAL_REQUIRED */])
              }),
              "\xA0",
              company.get("export_compliant_updated_by") && !company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["Q" /* EXPORT_APPROVAL_REQUIRED */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { className: "text-right" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
                  placement: "right",
                  icon: "fa-info-circle",
                  color: "rgba(255, 255, 255, 0.25)",
                  note: approvalText(company.get("export_compliant_updated_at"), company.get("export_compliant_updated_by"))
                })
              )
            )
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["S" /* Detail */], {
            label: "AC-0056B",
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ApprovalStatus__["a" /* default */], { approved: company.get("asa_approved") }),
              "\xA0",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { className: "text-right" },
                company.get("asa_approved_updated_by") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
                  placement: "right",
                  icon: "fa-info-circle",
                  color: "rgba(255, 255, 255, 0.25)",
                  note: approvalText(company.get("asa_approved_updated_at"), company.get("asa_approved_updated_by"))
                })
              )
            )
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["S" /* Detail */], {
            label: "FAA",
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ApprovalStatus__["a" /* default */], { approved: company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["S" /* FAA_APPROVED */]) })
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["S" /* Detail */], {
            label: "EASA",
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ApprovalStatus__["a" /* default */], { approved: company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["T" /* EASA_APPROVED */]) })
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["S" /* Detail */], {
            label: "UK CAA",
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ApprovalStatus__["a" /* default */], { approved: company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["U" /* UK_CAA_APPROVED */]) }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], {
                obj: company.toJS(),
                field: "uk_caa_approved"
              })
            )
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["S" /* Detail */], {
            label: "CAAC",
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ApprovalStatus__["a" /* default */], { approved: company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["V" /* CAAC_APPROVED */]) })
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["S" /* Detail */], {
            label: "TCCA",
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ApprovalStatus__["a" /* default */], { approved: company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["W" /* TCCA_APPROVED */]) })
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["S" /* Detail */], {
            label: "Other",
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ApprovalStatus__["a" /* default */], { approved: company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["X" /* OTHER_APPROVED */]) }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], {
                obj: company.toJS(),
                field: "other_approval",
                notePrefix: company.get("other_approval") + " by "
              })
            )
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__shared_components__["S" /* Detail */], {
            label: "Do Not Quote",
            value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__DoNotQuote__["a" /* default */], { doNotQuote: company.get("do_not_quote") })
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_DetailTable_CheckForDetail__["a" /* default */], {
            className: "text-danger",
            text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["k" /* DO_NOT_EXCHANGE */]),
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["k" /* DO_NOT_EXCHANGE */]),
            value: company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["k" /* DO_NOT_EXCHANGE */])
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_DetailTable_CheckForDetail__["a" /* default */], {
            className: "text-danger",
            text: "Approval Required",
            label: "Vendor Trace Preapproval",
            value: company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["Y" /* VENDOR_TRACE_PREAPPROVAL_REQUIRED */])
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_DetailTable_CheckForDetail__["a" /* default */], {
            value: company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["Z" /* MANDATORY_ADDITIONAL_VERBIAGE */]),
            label: "PO Mandatory Add'l Verbiage"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__shared_components_ConfirmAction__["a" /* default */],
          {
            onConfirm: this.props.requestVendorApproval,
            close: this.closeVendorConfirmModal,
            open: this.state.vendorConfirmModalOpen
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          " Are you sure you want to request\xA0",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "vendor approval"
          ),
          "?"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__shared_components_ConfirmAction__["a" /* default */],
          {
            onConfirm: this.props.requestStationApproval,
            close: this.closeStationConfirmModal,
            open: this.state.stationConfirmModalOpen
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          " Are you sure you want to request\xA0",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "repair station approval"
          ),
          "?"
        )
      );
    }
  }]);

  return ApprovalsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ApprovalsTable.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  requestVendorApproval: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
  requestStationApproval: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    requestVendorApproval: function requestVendorApproval() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_18__actions__["o" /* update */]({ request_vendor_approval: true }));
    },
    requestStationApproval: function requestStationApproval() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_18__actions__["o" /* update */]({ request_shop_approval: true }));
    }
  };
})(ApprovalsTable));

/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__ = __webpack_require__(11);






// Utility function to remove time from date string
var formatDateWithoutTime = function formatDateWithoutTime(dateStr) {
  var date = new Date(dateStr);
  return isNaN(date) ? dateStr : date.toLocaleDateString(); // Fallback to original if date is invalid
};

var AuditTrail = function AuditTrail(_ref) {
  var company = _ref.company,
      isLoading = _ref.isLoading;

  var renderPreviousValue = function renderPreviousValue(row) {
    if (!row.previous_value) {
      return null;
    }
    return row.action === "business_start_date" ? formatDateWithoutTime(row.previous_value) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(row.previous_value);
  };

  var renderRow = function renderRow(row) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      { key: row.created_at },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        new Date(row.created_at).toLocaleDateString()
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        new Date(row.created_at).toLocaleTimeString()
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(row.action)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        row.created_by && row.created_by.full_name
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        renderPreviousValue(row)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        row.action === "business_start_date" ? formatDateWithoutTime(row.new_value) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(row.new_value)
      )
    );
  };

  var auditTrails = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(company.toJS(), "audit_trails", []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      "Audit Trail"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */].Mini,
      { loading: isLoading },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */].Head,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Date"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Time"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Action"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "User"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Previous Value"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "New Value"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */].Body,
        null,
        auditTrails.length > 0 ? auditTrails.map(renderRow) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            { colSpan: "6", className: "text-center" },
            "No records found."
          )
        )
      )
    )
  );
};

AuditTrail.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    audit_trails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      created_at: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
      action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      created_by: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
      }),
      previous_value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      new_value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }))
  }).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (AuditTrail);

/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AuditTrail__ = __webpack_require__(1960);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AuditTrail__["a"]; });



/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_countries__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Liabilities_Liabilities__ = __webpack_require__(1983);
/* harmony export (immutable) */ __webpack_exports__["a"] = BillingTable;












function BillingTable(_ref) {
  var company = _ref.company;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DetailTable__["b" /* Detail */], {
          label: "Address Line",
          value: company.getIn(["billing_address", __WEBPACK_IMPORTED_MODULE_7__constants__["s" /* LINE1 */]])
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DetailTable__["b" /* Detail */], {
          label: "Address Line 2",
          value: company.getIn(["billing_address", __WEBPACK_IMPORTED_MODULE_7__constants__["t" /* LINE2 */]]),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DetailTable__["b" /* Detail */], {
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["u" /* CITY */]),
          value: company.getIn(["billing_address", __WEBPACK_IMPORTED_MODULE_7__constants__["u" /* CITY */]])
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DetailTable__["b" /* Detail */], {
          label: "State / Province",
          value: company.getIn(["billing_address", __WEBPACK_IMPORTED_MODULE_7__constants__["v" /* STATE */]])
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DetailTable__["b" /* Detail */], {
          label: "Zip / Postal Code",
          value: company.getIn(["billing_address", __WEBPACK_IMPORTED_MODULE_7__constants__["w" /* POSTAL_CODE */]])
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DetailTable__["b" /* Detail */], {
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["r" /* COUNTRY */]),
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_countries__["d" /* countryName */])(company.getIn(["billing_address", __WEBPACK_IMPORTED_MODULE_7__constants__["r" /* COUNTRY */]]))
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DetailTable__["b" /* Detail */], { label: __WEBPACK_IMPORTED_MODULE_7__constants__["Q" /* REGION */], value: company.getIn([__WEBPACK_IMPORTED_MODULE_7__constants__["Q" /* REGION */]]) }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DetailTable__["b" /* Detail */], { label: "EIN #", value: company.get("ein_number") }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DetailTable__["b" /* Detail */], {
          label: "TAX ID #",
          value: company.get("tax_id_number")
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm hr-dashed margin-top-none" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DetailTable__["b" /* Detail */], {
          label: "Vendor Terms",
          value: company.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_11" /* VENDOR_CREDIT_TERMS */]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(company.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_11" /* VENDOR_CREDIT_TERMS */]))
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Vendor limit"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(company.get("vendor_credit_limit"))
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Liabilities_Liabilities__["a" /* Liabilities */], { company: company }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DetailTable__["b" /* Detail */], {
          label: "Currently On Order",
          value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_router_dom__["a" /* Link */],
            {
              to: "/purchase-orders?cancelled=false&page=1&received=false&filter=" + company.get("name")
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(company.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_12" /* LIABILITIES_TO_BE_OWED */]))
          )
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Cust Terms"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            company.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_13" /* CUSTOMER_CREDIT_TERMS */]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(company.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_13" /* CUSTOMER_CREDIT_TERMS */]))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DetailTable__["b" /* Detail */], {
          label: "Cust. Limit",
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(company.get("customer_credit_limit"))
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DetailTable__["b" /* Detail */], {
          label: "Add'l Liabilities",
          value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_router_dom__["a" /* Link */],
            {
              to: "/sales-orders?cancelled=false&cores_received=false&exchange_sale=true&page=1&shipped=true&filter=" + company.get("name")
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_currency__["a" /* dollars */])(company.get("additional_liabilities"))
          )
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DetailTable__["b" /* Detail */], { label: "Resale #", value: company.get("resale_num") }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_DetailTable__["b" /* Detail */], { label: "Vat #", value: company.get("vat_num") })
      )
    )
  );
}

BillingTable.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Controls__ = __webpack_require__(1964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Create_AddContact__ = __webpack_require__(1965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Edit_EditContact__ = __webpack_require__(1968);
/* unused harmony export Contacts */
/* unused harmony export TabulateContacts */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













function renderRow(contact, openEditForm) {
  var handleMailto = function handleMailto(e) {
    e.stopPropagation();
  };
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()("clickable", { "text-muted": !contact.active });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: contact.id,
      className: classes,
      onClick: function onClick() {
        return openEditForm(contact);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      contact.title
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      contact.name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        { href: "mailto:" + contact.email, onClick: handleMailto },
        contact.email
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      contact.position
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      contact.phone1
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      contact.phone2
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      contact.phone3
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      contact.promotion_ok && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-success fa fa-check" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      contact.primary && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-success fa fa-check" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      contact.exchange_manager && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-success fa fa-check" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      contact.active && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-success fa fa-check" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], { note: contact.notes }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center td-shrink-icon" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Controls__["a" /* default */], { contact: contact })
    )
  );
}

var Contacts = function (_Component) {
  _inherits(Contacts, _Component);

  function Contacts() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Contacts);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Contacts.__proto__ || Object.getPrototypeOf(Contacts)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editFormOpen: false,
      selectedContact: {},
      isExpanded: false
    }, _this.openEditForm = function (contact) {
      return _this.setState({ editFormOpen: true, selectedContact: contact });
    }, _this.closeEditForm = function () {
      return _this.setState({ editFormOpen: false });
    }, _this.toggleExpand = function () {
      _this.setState(function (prevState) {
        return { isExpanded: !prevState.isExpanded };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Contacts, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          selectedContact = _state.selectedContact,
          editFormOpen = _state.editFormOpen,
          isExpanded = _state.isExpanded;
      var _props = this.props,
          results = _props.results,
          isLoading = _props.isLoading;

      var sortedResults = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(results, ["primary", "active", "name"], ["desc", "desc", "asc"]);

      var contactsToRender = isExpanded ? sortedResults : sortedResults.slice(0, 8);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Contacts",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["b" /* Authorized */],
            {
              roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_7__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["j" /* WAREHOUSE */]),
              permissions: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]]
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Create_AddContact__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Edit_EditContact__["a" /* default */], {
              open: editFormOpen,
              close: this.closeEditForm,
              contact: selectedContact
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Mini,
          { loading: isLoading },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Salutation"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Name"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Email"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Position/Title"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Phone #1"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Phone #2"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Phone #3"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Promotions OK"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Primary"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Exch. Manager"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Active"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "\xA0"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "\xA0"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Body,
            null,
            contactsToRender.map(function (contact) {
              return renderRow(contact, _this2.openEditForm);
            })
          )
        ),
        results.length > 8 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "expand-button-container" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            {
              className: "btn btn-primary btn-hollow",
              onClick: this.toggleExpand
            },
            isExpanded ? "Collapse" : "Expand"
          )
        )
      );
    }
  }]);

  return Contacts;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Contacts.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
    active: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    name: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    email: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    phone1: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    phone2: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    phone3: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    position: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    primary: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    promotion_ok: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
  })).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired
};

var TabulateContacts = __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__["decorators"].tabulate(Contacts);
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabulateContacts, { listId: "company/contacts" });
});

/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmDelete__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);








function Controls(_ref) {
  var contact = _ref.contact,
      deleteContact = _ref.deleteContact,
      activateContact = _ref.activateContact,
      deactivateContact = _ref.deactivateContact;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["c" /* ImprovedDropDown */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
      id: "delete",
      label: "Delete",
      faIcon: "ban",
      hideIf: contact.primary,
      renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_ConfirmDelete__["a" /* default */], {
        onConfirm: deleteContact,
        message: "This will permanently delete the record and cannot be performed if the contact is associated with one or more other records."
      })
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
      id: "deactivate",
      label: "Deactivate",
      faIcon: "toggle-off",
      hideIf: !contact.active,
      renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction__["a" /* default */], {
        onConfirm: deactivateContact,
        message: !contact.primary ? "This will disable the selection of this contact from orders and quotes." : "Cannot deactivate the primary contact. Please assign a different primary contact before deactivating.",
        btnText: "Deactivate",
        btnClass: "btn-danger",
        showButton: !contact.primary
      })
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_DropDown__["d" /* ImprovedDropDownItem */], {
      id: "activate",
      label: "Activate",
      faIcon: "toggle-on",
      hideIf: contact.active,
      renderActive: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_ConfirmAction__["a" /* default */], {
        onConfirm: activateContact,
        message: "Are you sure you want to activate this contact?",
        btnText: "Activate"
      })
    })
  );
}

Controls.propTypes = {
  contact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    primary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }),
  deleteContact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  activateContact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  deactivateContact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(undefined, function (dispatch, _ref2) {
  var id = _ref2.contact.id;
  return {
    deleteContact: function deleteContact() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_3__actions__["r" /* destroyContact */](id));
    },
    activateContact: function activateContact() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_3__actions__["p" /* updateContact */]({ id: id, active: true }));
    },
    deactivateContact: function deactivateContact() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_3__actions__["p" /* updateContact */]({ id: id, active: false }));
    }
  };
})(Controls));

/***/ }),
/* 1965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreateContact__ = __webpack_require__(1966);
/* unused harmony export AddContact */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AddContact = function (_Component) {
  _inherits(AddContact, _Component);

  function AddContact() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddContact);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddContact.__proto__ || Object.getPrototypeOf(AddContact)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.open = function () {
      return _this.setState({ open: true });
    }, _this.close = function () {
      return _this.setState({ open: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddContact, [{
    key: "render",
    value: function render() {
      var id = this.props.id;
      var open = this.state.open;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "btn-group pull-right" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          { onClick: this.open, className: "btn btn-primary btn-hollow" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
          "Add Contact",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CreateContact__["a" /* default */], { id: id, open: open, close: this.close })
        )
      );
    }
  }]);

  return AddContact;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AddContact.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    id: state.companyDetail.getIn(["company", "id"])
  };
})(AddContact));

/***/ }),
/* 1966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(1967);
/* harmony export (immutable) */ __webpack_exports__["a"] = Create;






function Create(_ref) {
  var id = _ref.id,
      open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-md" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Add a Company Contact"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], {
        id: id,
        close: close,
        initialValues: { title: "", primary: false, promotion_ok: false }
      })
    )
  );
}

Create.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__validate__ = __webpack_require__(728);
/* unused harmony export Form */










function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
      props,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
          { className: "row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 2 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: "title",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
              label: "Salutation",
              options: __WEBPACK_IMPORTED_MODULE_6__constants__["O" /* SALUTATIONS */]
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: "name", component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */], label: "Name", required: true })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { htmlFor: "primary", className: "control-label" },
                "Primary Contact"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: "btn-group full-width-checkbox",
                  "data-toggle": "buttons"
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                  className: "physicalAddressPrimary",
                  name: "primary",
                  component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
                  label: "Yes"
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["a" /* CheckGroup */],
              { justified: true, title: "Exchange Manager" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: "exchange_manager", component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */], label: "Yes" })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["m" /* DashedSeparator */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
          { className: "row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: "position",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
              label: "Position/Title"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 5 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: "email",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
              label: "Email",
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { htmlFor: "promotion_ok", className: "control-label" },
                "Promotions OK"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: "btn-group full-width-checkbox",
                  "data-toggle": "buttons"
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
                  className: "physicalAddressPrimary",
                  name: "promotion_ok",
                  component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
                  label: "Yes"
                })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["m" /* DashedSeparator */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
          { className: "row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["p" /* PhoneNumberField */], {
              name: "phone1",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
              label: "Phone Number 1",
              type: "tel"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["p" /* PhoneNumberField */], {
              name: "phone2",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
              label: "Phone Number 2",
              type: "tel"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["p" /* PhoneNumberField */], {
              name: "phone3",
              component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
              label: "Phone Number 3",
              type: "tel"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
          { className: "row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: "notes", component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["l" /* TextArea */], label: "note" })
          )
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_7__actions__["q" /* createContact */](data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["j" /* form */])({
  form: "createCompanyContact",
  validate: __WEBPACK_IMPORTED_MODULE_8__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(1969);
/* harmony export (immutable) */ __webpack_exports__["a"] = Edit;






function Edit(_ref) {
  var open = _ref.open,
      close = _ref.close,
      contact = _ref.contact;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-md" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Contact"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], {
      close: close,
      initialValues: contact,
      primary: contact.primary,
      active: contact.active,
      enableReinitialize: true
    })
  );
}

Edit.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  contact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired
};

/***/ }),
/* 1969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__validate__ = __webpack_require__(728);
/* unused harmony export Form */












function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
      props,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
          { className: "row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
            { md: 2 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: "title",
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
              label: "Salutation",
              options: __WEBPACK_IMPORTED_MODULE_7__constants__["O" /* SALUTATIONS */]
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: "name", component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */], label: "Name", required: true })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
              { justified: true, title: "Exchange Manager" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: "exchange_manager", component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */], label: "Yes" })
            )
          ),
          !props.primary && props.active && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
              { justified: true, title: "Primary Contact" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: "primary", component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */], label: "Yes" })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["m" /* DashedSeparator */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
          { className: "row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: "position",
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              label: "Position/Title"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
            { md: 5 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_9__constants__["T" /* EMAIL */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              label: __WEBPACK_IMPORTED_MODULE_9__constants__["T" /* EMAIL */],
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
              { justified: true, title: "Promotions OK" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: "promotion_ok", component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */], label: "Yes" })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["m" /* DashedSeparator */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
          { className: "row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["p" /* PhoneNumberField */], {
              name: "phone1",
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              label: "Phone Number 1"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["p" /* PhoneNumberField */], {
              name: "phone2",
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              label: "Phone Number 2"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["p" /* PhoneNumberField */], {
              name: "phone3",
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
              label: "Phone Number 3"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
          { className: "row-col-gutters-half" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: "notes", component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["l" /* TextArea */], label: "note" })
          )
        )
      )
    )
  );
}

Form.propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  primary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8__actions__["p" /* updateContact */](data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: "editCompanyContact",
  validate: __WEBPACK_IMPORTED_MODULE_10__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Contacts__ = __webpack_require__(1963);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Contacts__["a"]; });



/***/ }),
/* 1971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EditCustomerRestrictions__ = __webpack_require__(1972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(22);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomerRestrictionsTable; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var CustomerRestrictionsTable = function (_React$Component) {
  _inherits(CustomerRestrictionsTable, _React$Component);

  function CustomerRestrictionsTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CustomerRestrictionsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CustomerRestrictionsTable.__proto__ || Object.getPrototypeOf(CustomerRestrictionsTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editCustomerRestrictions: false
    }, _this.toggleModalState = function (key) {
      var currentValue = _this.state[key];
      _this.setState(_defineProperty({}, key, !currentValue));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CustomerRestrictionsTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var editCustomerRestrictions = this.state.editCustomerRestrictions;
      var company = this.props.company;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          { style: { marginTop: 10 } },
          "Customer Restrictions",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components__["b" /* Authorized */],
            {
              roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_2__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["j" /* WAREHOUSE */]),
              permissions: [__WEBPACK_IMPORTED_MODULE_2__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]]
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["y" /* EditButton */], {
              handleClick: function handleClick() {
                return _this2.toggleModalState("editCustomerRestrictions");
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EditCustomerRestrictions__["a" /* default */], {
              company: company.toJS(),
              open: editCustomerRestrictions,
              close: function close() {
                return _this2.toggleModalState("editCustomerRestrictions");
              }
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components__["W" /* DetailTable */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["_5" /* CheckForDetail */], {
            label: "No PMAs Accepted",
            value: company.get("no_pmas_accepted"),
            text: ""
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["_5" /* CheckForDetail */], {
            label: "No DERs Accepted",
            value: company.get("no_ders_accepted"),
            text: ""
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["S" /* Detail */], {
            label: "Warranty Minimum",
            value: company.get("warranty_minimum")
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["S" /* Detail */], {
            label: "Unaccepted Trace Types",
            value: company.get("unaccepted_trace_types").toArray().map(function (f) {
              return __WEBPACK_IMPORTED_MODULE_4__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes[f].label;
            }).join(", ")
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["_5" /* CheckForDetail */], {
            label: "Imperfect Trace Req",
            value: company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["u" /* IMPERFECT_TRACE */])
          })
        )
      );
    }
  }]);

  return CustomerRestrictionsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
CustomerRestrictionsTable.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map)
};

/***/ }),
/* 1972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form__ = __webpack_require__(1973);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditCustomerRestrictions;







var initialValues = function initialValues(company) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_pojos__["a" /* default */])(company).pick("imperfect_trace", "no_pmas_accepted", "no_ders_accepted", "warranty_minimum", "unaccepted_trace_types"), company.unaccepted_trace_types.reduce(function (obj, k) {
    obj["trace_type_" + k] = true;
    return obj;
  }, {}));
};

function EditCustomerRestrictions(_ref) {
  var open = _ref.open,
      close = _ref.close,
      company = _ref.company;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Customer Restrictions"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Form__["a" /* default */], {
      company: company,
      close: close,
      initialValues: initialValues(company),
      enableReinitialize: true
    })
  );
}

EditCustomerRestrictions.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IncomingQuotes_constants__ = __webpack_require__(40);
/* unused harmony export Form */









function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["q" /* FormRow */],
        { className: "row row-col-gutters-half" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              { className: "control-label", htmlFor: "none" },
              "Restrictions"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: "btn-group btn-group-justified btn-group-vertical",
                "data-toggle": "buttons"
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "no_pmas_accepted",
                component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["b" /* Check */],
                label: "No PMAs Accepted"
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "no_ders_accepted",
                component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["b" /* Check */],
                label: "No DERs Accepted"
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: "warranty_minimum",
            type: "number",
            component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
            label: "Warranty Minimum"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              { className: "control-label", htmlFor: "none" },
              "Unaccepted Trace Types"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: "btn-group btn-group-justified btn-group-vertical",
                "data-toggle": "buttons"
              },
              Object.keys(__WEBPACK_IMPORTED_MODULE_7__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: "trace_type_" + k,
                  component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["b" /* Check */],
                  label: __WEBPACK_IMPORTED_MODULE_7__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes[k].label
                });
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["a" /* CheckGroup */],
            { justified: true, title: "Imperfect Trace Approval Required" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: "imperfect_trace", component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["b" /* Check */], label: "Yes" })
          )
        )
      )
    )
  );
}

Form.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      data.unaccepted_trace_types = Object.keys(data).filter(function (f) {
        return f.includes("trace_type") && data[f] && f !== "unaccepted_trace_types";
      }).map(function (f) {
        return f.replace("trace_type_", "");
      });
      return dispatch(__WEBPACK_IMPORTED_MODULE_5__actions__["o" /* update */](data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: "editCustomerRestrictions"
})(Form)));

/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_ActionDropDown_ActionDropDown__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Fleets_Fleets__ = __webpack_require__(1979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__RequestUltimateConsignee_RequestUltimateConsignee__ = __webpack_require__(2002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__RequestUltimateConsignee_RequestUltimateConsigneeModal__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Receivables_Receivables__ = __webpack_require__(1992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__RelatedCompanies_RelatedCompanies__ = __webpack_require__(2000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__StatusBadges__ = __webpack_require__(2012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Contacts__ = __webpack_require__(1970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__PhysicalAddresses__ = __webpack_require__(1991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__AuditTrail__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ShippingMethods__ = __webpack_require__(2010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__EditBilling__ = __webpack_require__(2023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__EditCompany__ = __webpack_require__(2027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ApprovalsTable__ = __webpack_require__(1959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__BillingTable__ = __webpack_require__(1962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__DetailsTable__ = __webpack_require__(1975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__actions_actions__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__CustomerRestrictionsTable_CustomerRestrictionsTable__ = __webpack_require__(1971);
/* unused harmony export Details */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







































var ExpertHeader = function ExpertHeader(_ref) {
  var experts = _ref.experts;

  if (!experts || experts.length === 0) return null;

  var header = experts.length === 1 ? "Resident Expert:" : "Resident Experts:";

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      {
        style: {
          marginTop: 0,
          marginBottom: 0
        }
      },
      header
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      {
        className: "lead text-blue",
        style: {
          fontSize: 14,
          fontStyle: "italic",
          marginBottom: 10
        }
      },
      experts.join(" / ")
    )
  );
};

ExpertHeader.propTypes = {
  experts: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(Array)
};

function StatSeparator() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", {
    style: {
      borderTop: "1px solid rgba(0, 0, 0, 0.15)",
      marginTop: 10,
      marginBottom: 20
    }
  });
}

var Details = function (_Component) {
  _inherits(Details, _Component);

  function Details() {
    _classCallCheck(this, Details);

    var _this = _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).call(this));

    _this.toggleModalState = function (key) {
      var currentValue = _this.state[key];
      _this.setState(_defineProperty({}, key, !currentValue));
    };

    _this.toggleStats = function () {
      _this.setState(function (state) {
        return { viewAllStats: !state.viewAllStats };
      });
    };

    _this.fetchCompanyStats.bind(_this);
    _this.state = {
      editCompanyModalOpen: false,
      editBillingModalOpen: false,
      editApprovalsModalOpen: false,
      stationConfirmModalOpen: false,
      vendorConfirmModalOpen: false,
      stats: {},
      viewAllStats: false
    };
    return _this;
  }

  _createClass(Details, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var company = this.props.company;

      this.fetchCompanyStats(company);
    }
  }, {
    key: "fetchCompanyStats",
    value: function fetchCompanyStats(company) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].reports.company_stats.search(company.get(__WEBPACK_IMPORTED_MODULE_17__constants__["b" /* ID */])).then(function (res) {
        _this2.setState({
          stats: res.data
        });
      });
    }
  }, {
    key: "defaultStats",
    value: function defaultStats() {
      var company = this.props.company;
      var stats = this.state.stats;


      if (company.get("repair_station_status") === __WEBPACK_IMPORTED_MODULE_11__constants__["j" /* APPROVED */]) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["_2" /* CompanyRepairStatsDetail */], { stats: stats.repairs || {} });
      } else if (company.get("vendor_status") === __WEBPACK_IMPORTED_MODULE_11__constants__["j" /* APPROVED */]) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["_3" /* CompanyPurchaseStatsDetail */], { stats: stats.purchases || {} });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["_4" /* CompanySaleStatsDetail */], { stats: stats.sales || {} });
    }
  }, {
    key: "showExpandedRepairs",
    value: function showExpandedRepairs() {
      return this.props.company.get(__WEBPACK_IMPORTED_MODULE_11__constants__["q" /* REPAIR_STATION_STATUS */]) !== __WEBPACK_IMPORTED_MODULE_11__constants__["j" /* APPROVED */] && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.some(this.state.stats.repairs, function (value) {
        return Math.abs(value) !== 0;
      });
    }
  }, {
    key: "showExpandedPurchases",
    value: function showExpandedPurchases() {
      return (this.props.company.get(__WEBPACK_IMPORTED_MODULE_11__constants__["q" /* REPAIR_STATION_STATUS */]) === __WEBPACK_IMPORTED_MODULE_11__constants__["j" /* APPROVED */] || this.props.company.get(__WEBPACK_IMPORTED_MODULE_11__constants__["G" /* VENDOR_STATUS */]) !== __WEBPACK_IMPORTED_MODULE_11__constants__["j" /* APPROVED */]) && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.some(this.state.stats.purchases, function (value) {
        return Math.abs(value) !== 0;
      });
    }
  }, {
    key: "showExpandedSales",
    value: function showExpandedSales() {
      return (this.props.company.get(__WEBPACK_IMPORTED_MODULE_11__constants__["q" /* REPAIR_STATION_STATUS */]) === __WEBPACK_IMPORTED_MODULE_11__constants__["j" /* APPROVED */] || this.props.company.get(__WEBPACK_IMPORTED_MODULE_11__constants__["G" /* VENDOR_STATUS */]) === __WEBPACK_IMPORTED_MODULE_11__constants__["j" /* APPROVED */]) && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.some(this.state.stats.sales, function (value) {
        return Math.abs(value) !== 0;
      });
    }
  }, {
    key: "expandedStats",
    value: function expandedStats() {
      var company = this.props.company;
      var stats = this.state.stats;


      var showRepairs = this.showExpandedRepairs();
      var showPurchases = this.showExpandedPurchases();
      var showSales = this.showExpandedSales();

      if (company.get(__WEBPACK_IMPORTED_MODULE_11__constants__["q" /* REPAIR_STATION_STATUS */]) === __WEBPACK_IMPORTED_MODULE_11__constants__["j" /* APPROVED */]) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          showPurchases && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StatSeparator, null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["_3" /* CompanyPurchaseStatsDetail */], { stats: stats.purchases })
          ),
          showSales && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StatSeparator, null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["_4" /* CompanySaleStatsDetail */], { stats: stats.sales })
          )
        );
      } else if (company.get(__WEBPACK_IMPORTED_MODULE_11__constants__["G" /* VENDOR_STATUS */]) === __WEBPACK_IMPORTED_MODULE_11__constants__["j" /* APPROVED */]) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          showSales && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StatSeparator, null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["_4" /* CompanySaleStatsDetail */], { stats: stats.sales })
          ),
          showRepairs && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StatSeparator, null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["_2" /* CompanyRepairStatsDetail */], { stats: stats.repairs })
          )
        );
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        showPurchases && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StatSeparator, null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["_3" /* CompanyPurchaseStatsDetail */], { stats: stats.purchases })
        ),
        showRepairs && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StatSeparator, null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["_2" /* CompanyRepairStatsDetail */], { stats: stats.repairs })
        )
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          company = _props.company,
          currentUser = _props.currentUser;

      var requestApprovalStatuses = [__WEBPACK_IMPORTED_MODULE_11__constants__["H" /* NOT_APPROVED */], __WEBPACK_IMPORTED_MODULE_11__constants__["n" /* DENIED */]];

      var canRequestRepairApproval = requestApprovalStatuses.includes(company.get(__WEBPACK_IMPORTED_MODULE_11__constants__["q" /* REPAIR_STATION_STATUS */]));
      var canRequestVendorApproval = requestApprovalStatuses.includes(company.get(__WEBPACK_IMPORTED_MODULE_11__constants__["G" /* VENDOR_STATUS */]));

      var canRequestUltimateConsigneeForm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(currentUser, [__WEBPACK_IMPORTED_MODULE_17__constants__["_69" /* TENANT */], __WEBPACK_IMPORTED_MODULE_11__constants__["I" /* ULTIMATE_CONSIGNEE_FORM_URL */]].join("."));

      var actionsAvailable = canRequestRepairApproval || canRequestVendorApproval || canRequestUltimateConsigneeForm;
      var _state = this.state,
          editCompanyModalOpen = _state.editCompanyModalOpen,
          editBillingModalOpen = _state.editBillingModalOpen,
          stationConfirmModalOpen = _state.stationConfirmModalOpen,
          ultimateConsigneeOpen = _state.ultimateConsigneeOpen,
          vendorConfirmModalOpen = _state.vendorConfirmModalOpen,
          viewAllStats = _state.viewAllStats;


      var defaultStats = this.defaultStats();
      var expandedStats = this.expandedStats();
      var showExpandCollapse = this.showExpandedRepairs() || this.showExpandedPurchases() || this.showExpandedSales();

      var experts = [company.getIn(["resident_expert", "full_name"]), company.getIn(["second_resident_expert", "full_name"])].filter(function (n) {
        return n;
      }).map(function (n) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["d" /* getFirstNameLastInitial */])(n);
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "page-header page-header-bar" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h1",
            null,
            actionsAvailable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "btn-group pull-right", style: { marginLeft: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_13__shared_components_ActionDropDown_ActionDropDown__["a" /* default */],
                {
                  menuClass: "dropdown-menu-right",
                  style: { cursor: "pointer" }
                },
                canRequestRepairApproval && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_12__shared_components_DropDown_DropDownItem__["a" /* default */],
                  {
                    onClick: function onClick() {
                      return _this3.toggleModalState("stationConfirmModalOpen");
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" }),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      null,
                      "Request Rep Station Approval"
                    )
                  )
                ),
                canRequestVendorApproval && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_12__shared_components_DropDown_DropDownItem__["a" /* default */],
                  {
                    onClick: function onClick() {
                      return _this3.toggleModalState("vendorConfirmModalOpen");
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" }),
                    " ",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "span",
                      null,
                      "Request Vendor Approval"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__RequestUltimateConsignee_RequestUltimateConsignee__["a" /* RequestUltimateConsignee */], {
                  toggle: function toggle() {
                    return _this3.toggleModalState("ultimateConsigneeOpen");
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "with-padding" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["J" /* RecordPager */], { baseUrl: "/companies", record: company }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { className: "header-content" },
                company.get(__WEBPACK_IMPORTED_MODULE_17__constants__["S" /* NAME */])
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["E" /* ClipboardCopy */], { name: company.get(__WEBPACK_IMPORTED_MODULE_17__constants__["S" /* NAME */]), type: "Company" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { className: "small text-muted" },
                company.get(__WEBPACK_IMPORTED_MODULE_17__constants__["z" /* CODE */])
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__StatusBadges__["a" /* default */], { company: company })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "panel panel-default" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "panel-body" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h2",
                { style: { marginTop: 10 } },
                "Details",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_14__shared_components__["b" /* Authorized */],
                  {
                    permissions: [__WEBPACK_IMPORTED_MODULE_15__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_15__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]],
                    roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_15__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_15__users_constants__["j" /* WAREHOUSE */])
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["y" /* EditButton */], {
                    handleClick: function handleClick() {
                      return _this3.toggleModalState("editCompanyModalOpen");
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__EditCompany__["a" /* default */], {
                    company: company.toJS(),
                    open: editCompanyModalOpen,
                    close: function close() {
                      return _this3.toggleModalState("editCompanyModalOpen");
                    }
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__DetailsTable__["a" /* default */], { company: company }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Fleets_Fleets__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h2",
                { style: { marginTop: 10 } },
                "Billing",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_14__shared_components__["b" /* Authorized */],
                  {
                    permissions: [__WEBPACK_IMPORTED_MODULE_15__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_15__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]],
                    roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_15__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_15__users_constants__["j" /* WAREHOUSE */])
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["y" /* EditButton */], {
                    handleClick: function handleClick() {
                      return _this3.toggleModalState("editBillingModalOpen");
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__EditBilling__["a" /* default */], {
                    company: company.toJS(),
                    open: editBillingModalOpen,
                    close: function close() {
                      return _this3.toggleModalState("editBillingModalOpen");
                    }
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__BillingTable__["a" /* default */], { company: company }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__Receivables_Receivables__["a" /* Receivables */], { company: company }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__ApprovalsTable__["a" /* default */], { company: company }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__CustomerRestrictionsTable_CustomerRestrictionsTable__["a" /* CustomerRestrictionsTable */], { company: company }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["z" /* AuditFields */], { record: company, multiLine: true })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 9 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExpertHeader, { experts: experts }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              null,
              "Stats\xA0\xA0",
              showExpandCollapse && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                {
                  style: {
                    fontSize: 10,
                    textTransform: "none",
                    fontWeight: "normal",
                    color: "#FF9800",
                    cursor: "pointer"
                  },
                  onClick: this.toggleStats
                },
                viewAllStats ? "Collapse" : "Expand"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              defaultStats,
              viewAllStats && expandedStats
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__Contacts__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__PhysicalAddresses__["a" /* default */], { region: company.region }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__AuditTrail__["a" /* default */], { company: company }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__ShippingMethods__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__RelatedCompanies_RelatedCompanies__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["d" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["M" /* Notes */], {
                headerLabel: "Company Notes",
                additionalActions: [{
                  key: __WEBPACK_IMPORTED_MODULE_21__shared_constants__["f" /* NOTE_TYPE */],
                  onConfirm: function onConfirm(postConfirm) {
                    return function (note) {
                      return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].notes.update(company.get(__WEBPACK_IMPORTED_MODULE_17__constants__["b" /* ID */]), __WEBPACK_IMPORTED_MODULE_10__shared_types_resourceTypes__["a" /* default */].company, _extends({}, note.toJS(), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_21__shared_constants__["f" /* NOTE_TYPE */], __WEBPACK_IMPORTED_MODULE_15__users_constants__["m" /* ACCOUNTING */]))).then(function (_ref2) {
                        var data = _ref2.data;
                        return postConfirm(data);
                      });
                    };
                  },
                  label: "Move to Accounting"
                }],
                filter: function filter(note) {
                  return !note.get(__WEBPACK_IMPORTED_MODULE_21__shared_constants__["f" /* NOTE_TYPE */]) || note.get(__WEBPACK_IMPORTED_MODULE_21__shared_constants__["f" /* NOTE_TYPE */]) === __WEBPACK_IMPORTED_MODULE_11__constants__["p" /* COMPANY */];
                },
                resource: company,
                resourceType: __WEBPACK_IMPORTED_MODULE_10__shared_types_resourceTypes__["a" /* default */].company,
                resourceKey: __WEBPACK_IMPORTED_MODULE_11__constants__["p" /* COMPANY */]
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["M" /* Notes */], {
                headerLabel: "Accounting Notes",
                resource: company,
                resourceType: __WEBPACK_IMPORTED_MODULE_10__shared_types_resourceTypes__["a" /* default */].company,
                notesType: "accounting"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components__["N" /* Attachments */], {
            attachmentTypes: __WEBPACK_IMPORTED_MODULE_11__constants__["J" /* ATTACHMENT_TYPES */],
            multiple: true,
            resource: company,
            resourceType: __WEBPACK_IMPORTED_MODULE_10__shared_types_resourceTypes__["a" /* default */].company,
            resourceKey: __WEBPACK_IMPORTED_MODULE_11__constants__["p" /* COMPANY */]
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14__shared_components__["i" /* ConfirmAction */],
          {
            onConfirm: this.props.requestVendorApproval,
            close: function close() {
              return _this3.toggleModalState("vendorConfirmModalOpen");
            },
            open: vendorConfirmModalOpen
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          " Are you sure you want to request\xA0",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "vendor approval"
          ),
          "?"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14__shared_components__["i" /* ConfirmAction */],
          {
            onConfirm: this.props.requestStationApproval,
            close: function close() {
              return _this3.toggleModalState("stationConfirmModalOpen");
            },
            open: stationConfirmModalOpen
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          " Are you sure you want to request\xA0",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "repair station approval"
          ),
          "?"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__RequestUltimateConsignee_RequestUltimateConsigneeModal__["a" /* default */], {
          company: company,
          close: function close() {
            return _this3.toggleModalState("ultimateConsigneeOpen");
          },
          open: ultimateConsigneeOpen
        })
      );
    }
  }]);

  return Details;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Details.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),
  requestVendorApproval: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  requestStationApproval: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    company: state.companyDetail.get(__WEBPACK_IMPORTED_MODULE_11__constants__["p" /* COMPANY */])
  };
}, function (dispatch) {
  return {
    requestVendorApproval: function requestVendorApproval() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_34__actions_actions__["d" /* update */]({ request_vendor_approval: true }));
    },
    requestStationApproval: function requestStationApproval() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_34__actions_actions__["d" /* update */]({ request_shop_approval: true }));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_decorators__["h" /* loadRecord */])({
  reducer: "companyDetail",
  name: __WEBPACK_IMPORTED_MODULE_11__constants__["p" /* COMPANY */],
  action: __WEBPACK_IMPORTED_MODULE_9__actions__["d" /* show */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__session_decorators_withCurrentUser__["b" /* default */])(Details))));

/***/ }),
/* 1975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip_AuditedNoteTooltip__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["a"] = DetailsTable;









function DetailsTable(_ref) {
  var company = _ref.company;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["W" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["S" /* Detail */], {
        label: "Type",
        value: company.get("company_type") && __WEBPACK_IMPORTED_MODULE_7__constants__["F" /* COMPANY_TYPES */][company.get("company_type")].label
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["S" /* Detail */], { label: "Cage", value: company.get("cage") }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["S" /* Detail */], { label: "Phone", value: company.get("phone") }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["S" /* Detail */], { label: "fax", value: company.get("fax") }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["S" /* Detail */], {
        label: "Website",
        value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["r" /* ExternalLink */], { url: company.get(__WEBPACK_IMPORTED_MODULE_7__constants__["e" /* WEBSITE */]) })
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
        label: "Imp Memo",
        value: company.get(__WEBPACK_IMPORTED_MODULE_4__parts_constants__["_16" /* IMPORTANT_MEMO */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { style: { color: "#F44336" } },
            company.get(__WEBPACK_IMPORTED_MODULE_4__parts_constants__["_16" /* IMPORTANT_MEMO */])
          ),
          " ",
          company.get(__WEBPACK_IMPORTED_MODULE_4__parts_constants__["_16" /* IMPORTANT_MEMO */] + "_audit") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], {
            obj: company.toJS(),
            field: __WEBPACK_IMPORTED_MODULE_4__parts_constants__["_16" /* IMPORTANT_MEMO */]
          })
        ),
        renderIfPresent: true
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], {
        label: "Clsfd Memo",
        value: company.get(__WEBPACK_IMPORTED_MODULE_4__parts_constants__["_17" /* CLASSIFIED_MEMO */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
          null,
          company.get(__WEBPACK_IMPORTED_MODULE_4__parts_constants__["_17" /* CLASSIFIED_MEMO */]),
          " ",
          company.get(__WEBPACK_IMPORTED_MODULE_4__parts_constants__["_17" /* CLASSIFIED_MEMO */] + "_audit") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], {
            obj: company.toJS(),
            field: __WEBPACK_IMPORTED_MODULE_4__parts_constants__["_17" /* CLASSIFIED_MEMO */]
          })
        ),
        renderIfPresent: true
      })
    )
  );
}

DetailsTable.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

/***/ }),
/* 1976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = DoNotQuote;



function DoNotQuote(_ref) {
  var doNotQuote = _ref.doNotQuote;

  var className = doNotQuote ? "text-danger" : "text-success";

  return doNotQuote && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check" }),
    "\xA0",
    doNotQuote ? "Yes" : "No"
  );
}

DoNotQuote.propTypes = {
  doNotQuote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 1977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(71);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function AircraftTag(props) {
  var aircraft = props.aircraft;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["O" /* Tag */], _extends({}, props, { label: aircraft.model_number }));
}

AircraftTag.propTypes = {
  application: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  navToPart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    destroy: function destroy() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["s" /* destroyAircraft */])(ownProps.aircraft.id));
    }
  };
})(AircraftTag));

/***/ }),
/* 1978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(1980);






function Create(_ref) {
  var open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-sm" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Add a New Aircraft"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (Create);

Create.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table__ = __webpack_require__(1982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__New__ = __webpack_require__(1981);




function Fleets() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      "Fleet",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__New__["a" /* default */], null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Table__["a" /* default */], null)
  );
}

/* harmony default export */ __webpack_exports__["a"] = (Fleets);

/***/ }),
/* 1980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Aircraft_actions__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_AutoCompleteField_AutoCompleteField__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Lots_constants__ = __webpack_require__(64);
/* unused harmony export Form */












var FORM_NAME = "createCompanyAircraft";

function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        label: __WEBPACK_IMPORTED_MODULE_10__Lots_constants__["t" /* AIRCRAFT */],
        name: __WEBPACK_IMPORTED_MODULE_7__constants__["_70" /* AIRCRAFT_ID */],
        component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_AutoCompleteField_AutoCompleteField__["a" /* default */],
        search: __WEBPACK_IMPORTED_MODULE_8__Aircraft_actions__["a" /* searchAircrafts */],
        formatItem: function formatItem(result) {
          return result.model_number;
        }
      })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_3__actions__["t" /* createAircraft */](data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: function validate(values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_validate_this__["a" /* validator */])(values, function (f) {
      f.validate(__WEBPACK_IMPORTED_MODULE_7__constants__["_70" /* AIRCRAFT_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_6__lib_validation_rules__["a" /* required */]);
    });
  }
})(Form)));

/***/ }),
/* 1981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create__ = __webpack_require__(1978);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();




/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    {
      className: "btn btn-primary btn-hollow pull-right",
      onClick: function onClick() {
        return setOpen(true);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
    "New",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Create__["a" /* default */], { close: function close() {
        return setOpen(false);
      }, open: open })
  );
});

/***/ }),
/* 1982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Aircraft__ = __webpack_require__(1977);
/* unused harmony export Table */





function Table(_ref) {
  var results = _ref.results;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-condensed" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { width: "100%" },
          __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(results, [function (r) {
            return r.model_number;
          }]).map(function (r) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Aircraft__["a" /* default */], { aircraft: r, key: r.id });
          })
        )
      )
    )
  );
}

var Decorated = __WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__["decorators"].tabulate(Table);

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Decorated, { listId: "company/aircrafts" });
});

/***/ }),
/* 1983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["a"] = Liabilities;







function Liabilities(_ref) {
  var company = _ref.company;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-condensed" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "We Currently Owe",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_formatters_currency__["a" /* dollars */])(Number(company.get(__WEBPACK_IMPORTED_MODULE_5__constants__["_14" /* LIABILITIES_OWED */])) + Number(company.get(__WEBPACK_IMPORTED_MODULE_5__constants__["_15" /* REPAIR_LIABILITIES_OWED */])))
      })
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: { textAlign: "center", padding: "0 10px" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
            {
              className: "btn btn-xs btn-block btn-default",
              style: { minWidth: "80px" },
              to: "/purchase-orders?not_paid=true&page=1&filter=" + company.get("name")
            },
            "Purchases\xA0",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "text-right" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["j" /* NoteTooltip */], {
                placement: "right",
                icon: "fa-info-circle",
                color: "rgba(255, 255, 255, 0.25)",
                note: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_formatters_currency__["a" /* dollars */])(company.get(__WEBPACK_IMPORTED_MODULE_5__constants__["_16" /* PURCHASES_OWED */]), 0)
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: { textAlign: "center", padding: "0 10px" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
            {
              className: "btn btn-xs btn-block btn-default",
              style: { minWidth: "80px" },
              to: "/repair-orders?invoice_unpaid=true&cancelled=false&page=1&filter=" + company.get("name")
            },
            "Repairs\xA0",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "text-right" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["j" /* NoteTooltip */], {
                placement: "right",
                icon: "fa-info-circle",
                color: "rgba(255, 255, 255, 0.25)",
                note: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_formatters_currency__["a" /* dollars */])(company.get(__WEBPACK_IMPORTED_MODULE_5__constants__["_15" /* REPAIR_LIABILITIES_OWED */]), 0)
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: { textAlign: "center", padding: "0 10px" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
            {
              style: { minWidth: "80px" },
              className: "btn btn-xs btn-block btn-default",
              to: "/lots?invoiced=false&filter=" + company.get("name")
            },
            "Lot Charges\xA0",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "text-right" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["j" /* NoteTooltip */], {
                placement: "right",
                icon: "fa-info-circle",
                color: "rgba(255, 255, 255, 0.25)",
                note: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_formatters_currency__["a" /* dollars */])(company.get("lot_charges"), 0)
              })
            )
          )
        )
      )
    )
  )];
}

/***/ }),
/* 1984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = PendingStatus;



function PendingStatus(_ref) {
  var pending = _ref.pending;

  return pending && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "text-warning" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-hourglass-start" }),
    "\xA0Pending"
  );
}

PendingStatus.propTypes = {
  pending: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(1986);
/* harmony export (immutable) */ __webpack_exports__["a"] = Create;






function Create(_ref) {
  var open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-md" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Add Physical Address"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close, initialValues: { primary: false } })
    )
  );
}

Create.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_countries__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_states__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validate__ = __webpack_require__(729);
/* unused harmony export Form */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var renderStateField = function renderStateField(country) {
  return country === "US" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
    name: "state",
    component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["c" /* Select */],
    options: __WEBPACK_IMPORTED_MODULE_8__lib_states__["a" /* states */],
    label: "State/Province/Region",
    required: true
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
    name: "state",
    component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
    label: "State/Province/Region",
    required: true
  });
};

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      sameAsBillingAddress: true
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.country && nextProps.country !== this.props.country) {
        this.props.resetStateField();
      }
      this.props.requestPrimaryAddress();
    }
  }, {
    key: "toggleBillingAddress",
    value: function toggleBillingAddress() {
      if (this.state.sameAsBillingAddress && this.props.billing) {
        var address = this.props.billing.toJS();
        this.props.initialize(address);
      } else {
        this.props.initialize();
      }
      this.setState(function (state) {
        return {
          sameAsBillingAddress: !state.sameAsBillingAddress
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var countryOptions = __WEBPACK_IMPORTED_MODULE_7__lib_countries__["a" /* default */].map(function (c) {
        return {
          value: c.code,
          text: c.name
        };
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "btn-group", "data-toggle": "buttons" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                onChange: function onChange() {
                  return _this2.toggleBillingAddress();
                },
                name: "same_as_billing",
                component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["b" /* Check */],
                label: "Copy Billing Address"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row row-col-gutters-half" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-9" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: "country",
                component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["c" /* Select */],
                label: "Country",
                options: countryOptions,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-3" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "label",
                  { htmlFor: "primary", className: "control-label" },
                  "Primary Address"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    className: "btn-group full-width-checkbox",
                    "data-toggle": "buttons"
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                    className: "physicalAddressPrimary",
                    name: "primary",
                    component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["b" /* Check */],
                    label: "Yes"
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row row-col-gutters-half" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-6" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], { name: "care_of", component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */], label: "C/O" })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row row-col-gutters-half" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-6" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: "line1",
                component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                label: "Address Line 1",
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-6" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: "line2",
                component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                label: "Address Line 2"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row row-col-gutters-half" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-5" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], { name: "city", component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */], label: "City", required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-4" },
              renderStateField(this.props.country)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-3" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: "postal_code",
                component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                label: "Zip/Postal Code",
                required: true
              })
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  billing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  resetStateField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["formValueSelector"])("createPhysicalAddress");

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    country: selector(state, "country"),
    billing: state.companyDetail.getIn(["company", "billing_address"])
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_5__actions__["n" /* createPhysicalAddress */](data));
    },
    requestPrimaryAddress: function requestPrimaryAddress() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_5__actions__["o" /* update */]());
    },
    resetStateField: function resetStateField() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["change"])("createPhysicalAddress", "state", ""));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: "createPhysicalAddress",
  validate: __WEBPACK_IMPORTED_MODULE_9__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreatePhysicalAddress__ = __webpack_require__(1985);
/* unused harmony export AddContact */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AddContact = function (_Component) {
  _inherits(AddContact, _Component);

  function AddContact() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddContact);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddContact.__proto__ || Object.getPrototypeOf(AddContact)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.open = function () {
      return _this.setState({ open: true });
    }, _this.close = function () {
      return _this.setState({ open: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddContact, [{
    key: "render",
    value: function render() {
      var id = this.props.id;
      var open = this.state.open;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "btn-group pull-right" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          { onClick: this.open, className: "btn btn-primary btn-hollow" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
          "Add Physical Address",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CreatePhysicalAddress__["a" /* default */], { id: id, open: open, close: this.close })
        )
      );
    }
  }]);

  return AddContact;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AddContact.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    id: state.companyDetail.getIn(["company", "id"])
  };
})(AddContact));

/***/ }),
/* 1988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(1989);
/* harmony export (immutable) */ __webpack_exports__["a"] = Edit;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function Edit(_ref) {
  var open = _ref.open,
      close = _ref.close,
      address = _ref.address,
      region = _ref.region;

  var initialValues = _extends({}, address, { region: region });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-md" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Edit Physical Address"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], {
        close: close,
        initialValues: initialValues,
        primary: address.primary
      })
    )
  );
}

Edit.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  address: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  region: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 1989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_countries__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_states__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__validate__ = __webpack_require__(729);
/* unused harmony export Form */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var renderStateField = function renderStateField(country) {
  return country === "US" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
    name: "state",
    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
    options: __WEBPACK_IMPORTED_MODULE_7__lib_states__["a" /* states */],
    label: "State/Province/Region",
    required: true
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
    name: "state",
    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
    label: "State/Province/Region",
    required: true
  });
};

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.country && nextProps.country !== this.props.country) {
        this.props.resetStateField();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          primary = _props.primary,
          country = _props.country;

      var countryOptions = __WEBPACK_IMPORTED_MODULE_6__lib_countries__["a" /* default */].map(function (c) {
        return {
          value: c.code,
          text: c.name
        };
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row row-col-gutters-half" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-9" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "country",
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
                label: "Country",
                options: countryOptions,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-3" },
              !primary && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "label",
                  { htmlFor: "primary", className: "control-label" },
                  "Primary Address"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    className: "btn-group physical-address-primary",
                    "data-toggle": "buttons"
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    className: "physicalAddressPrimary",
                    name: "primary",
                    component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
                    label: "Yes"
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row row-col-gutters-half" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-6" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: "care_of", component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */], label: "C/O" })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row row-col-gutters-half" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-6" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "line1",
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                label: "Address Line 1",
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-6" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "line2",
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                label: "Address Line 2"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row row-col-gutters-half" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-5" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: "city", component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */], label: "City", required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-4" },
              renderStateField(country)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-3" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: "postal_code",
                component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
                label: "Zip/Postal Code",
                required: true
              })
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  resetStateField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  primary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])("editPhysicalAddress");

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return { country: selector(state, "country") };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_4__actions__["m" /* updatePhysicalAddress */](data));
    },
    resetStateField: function resetStateField() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])("editPhysicalAddress", "state", ""));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: "editPhysicalAddress",
  validate: __WEBPACK_IMPORTED_MODULE_8__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Delete_Delete__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Create_NewPhysicalAddress__ = __webpack_require__(1987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Edit_EditPhysicalAddress__ = __webpack_require__(1988);
/* unused harmony export PhysicalAddresses */
/* unused harmony export TabulateAttachments */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var PhysicalAddresses = function (_React$Component) {
  _inherits(PhysicalAddresses, _React$Component);

  function PhysicalAddresses() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PhysicalAddresses);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhysicalAddresses.__proto__ || Object.getPrototypeOf(PhysicalAddresses)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editPhysicalContactModalOpen: false,
      selectedAddress: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()
    }, _this.closePhysicalContactModal = function () {
      return _this.setState({ editPhysicalContactModalOpen: false });
    }, _this.launchModal = function (row) {
      _this.setState({ editPhysicalContactModalOpen: true, selectedAddress: row });
    }, _this.renderRow = function (row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        {
          key: row.id,
          className: "clickable",
          onClick: function onClick() {
            return _this.launchModal(row);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          row.care_of
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          row.line1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          row.line2 || ""
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          row.city
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          row.state
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          row.postal_code
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          row.country
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          row.primary && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-success fa fa-check" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Delete_Delete__["a" /* default */], {
          primary: row.primary,
          id: row.id,
          deleteAction: __WEBPACK_IMPORTED_MODULE_4__actions__["l" /* destroyPhysicalAddress */]
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PhysicalAddresses, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          results = _props.results,
          isLoading = _props.isLoading;
      var _state = this.state,
          editPhysicalContactModalOpen = _state.editPhysicalContactModalOpen,
          selectedAddress = _state.selectedAddress,
          region = _state.region;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Physical Addresses",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["b" /* Authorized */],
            {
              roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_7__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["j" /* WAREHOUSE */]),
              permissions: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]]
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Create_NewPhysicalAddress__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Edit_EditPhysicalAddress__["a" /* default */], {
              open: editPhysicalContactModalOpen,
              close: this.closePhysicalContactModal,
              address: selectedAddress,
              region: region
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Mini,
          { loading: isLoading },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "C/O"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Address Line 1"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Address Line 2"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "City"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "State/Province/Region"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "ZIP/Postal Code"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Country"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Primary"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "\xA0"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Body,
            null,
            results.map(this.renderRow)
          )
        )
      );
    }
  }]);

  return PhysicalAddresses;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PhysicalAddresses.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    care_of: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    line1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    city: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    postal_code: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    primary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var TabulateAttachments = __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__["decorators"].tabulate(PhysicalAddresses);
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabulateAttachments, { listId: "company/physicalAddresses" });
});

/***/ }),
/* 1991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhysicalAddresses__ = __webpack_require__(1990);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PhysicalAddresses__["a"]; });



/***/ }),
/* 1992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony export (immutable) */ __webpack_exports__["a"] = Receivables;






function Receivables(_ref) {
  var company = _ref.company;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-condensed" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_DetailTable__["b" /* Detail */], {
        label: "Cust. Currently Owes",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_formatters_currency__["a" /* dollars */])(company.get("outstanding_balance"))
      })
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: { textAlign: "center", padding: "0 10px" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
            {
              className: "btn btn-xs btn-block btn-default",
              style: { minWidth: "80px" },
              to: "/sales-orders?customer_rma=false&not_paid=true&page=1&shipped=true&filter=" + company.get("name")
            },
            "Sales\xA0",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "text-right" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["j" /* NoteTooltip */], {
                placement: "right",
                icon: "fa-info-circle",
                color: "rgba(255, 255, 255, 0.25)",
                note: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_formatters_currency__["a" /* dollars */])(company.get("sales_outstanding_balance"), 0)
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: { textAlign: "center", padding: "0 10px" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
            {
              className: "btn btn-xs btn-block btn-default",
              style: { minWidth: "80px" },
              to: "/managed-repair-orders?cancelled=false&page=1&shipped=true&filter=" + company.get("name")
            },
            "Managed Repair\xA0",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "text-right" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["j" /* NoteTooltip */], {
                placement: "right",
                icon: "fa-info-circle",
                color: "rgba(255, 255, 255, 0.25)",
                note: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_formatters_currency__["a" /* dollars */])(company.get("managed_repair_charges"), 0)
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: { textAlign: "center", padding: "0 10px" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],
            {
              style: { minWidth: "80px" },
              className: "btn btn-xs btn-block btn-default",
              to: "/sales-orders?cancelled=false&core_repair_invoices_not_paid=true&exchange_sale=true&filter=" + company.get("name")
            },
            "Core Repairs\xA0",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "text-right" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["j" /* NoteTooltip */], {
                placement: "right",
                icon: "fa-info-circle",
                color: "rgba(255, 255, 255, 0.25)",
                note: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_formatters_currency__["a" /* dollars */])(company.get("outstanding_core_repair_charges"), 0)
              })
            )
          )
        )
      )
    )
  )];
}

/***/ }),
/* 1993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(1994);
/* harmony export (immutable) */ __webpack_exports__["a"] = Create;






function Create(_ref) {
  var open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-md" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Add Related Company"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close })
    )
  );
}

Create.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__validate__ = __webpack_require__(1996);
/* unused harmony export Form */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      company: null
    }, _this.handleCompanyChange = function (result) {
      return _this.setState({ company: result });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var searchCompanies = this.props.searchCompanies;
      var company = this.state.company;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_10__constants__["N" /* RELATED_COMPANY_ID */],
                label: "Related Company",
                labelChildren: company && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                  null,
                  "\xA0\xA0",
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["g" /* CompanyStatsTooltip */], { company: company })
                ),
                placeholder: "Search by typing a company's name or code",
                component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["n" /* AutoCompleteField */],
                search: searchCompanies,
                formatItem: function formatItem(result) {
                  return result.name + " (" + __WEBPACK_IMPORTED_MODULE_10__constants__["h" /* APPROVAL_STATUSES */][result.vendor_status].label + ")";
                },
                onItemSelected: function onItemSelected(i) {
                  return i && _this2.handleCompanyChange(i);
                },
                selectedItem: company,
                required: true
              })
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  billing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  resetStateField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_5__actions__["h" /* createRelatedCompany */](data));
    },
    searchCompanies: function searchCompanies(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_5__actions__["g" /* searchCompanies */](filter));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: "createRelatedCompany",
  validate: __WEBPACK_IMPORTED_MODULE_11__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CreateRelatedCompany__ = __webpack_require__(1993);
/* unused harmony export AddRelatedCompany */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var AddRelatedCompany = function (_Component) {
  _inherits(AddRelatedCompany, _Component);

  function AddRelatedCompany() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddRelatedCompany);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddRelatedCompany.__proto__ || Object.getPrototypeOf(AddRelatedCompany)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.open = function () {
      return _this.setState({ open: true });
    }, _this.close = function () {
      return _this.setState({ open: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddRelatedCompany, [{
    key: "render",
    value: function render() {
      var id = this.props.id;
      var open = this.state.open;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "btn-group pull-right" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          { onClick: this.open, className: "btn btn-primary btn-hollow" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
          "Add Related Company",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CreateRelatedCompany__["a" /* default */], { id: id, open: open, close: this.close })
        )
      );
    }
  }]);

  return AddRelatedCompany;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AddRelatedCompany.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    id: state.companyDetail.getIn([__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ID */]])
  };
})(AddRelatedCompany));

/***/ }),
/* 1996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;




function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["N" /* RELATED_COMPANY_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 1997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(1998);
/* harmony export (immutable) */ __webpack_exports__["a"] = Edit;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function Edit(_ref) {
  var open = _ref.open,
      close = _ref.close,
      relatedCompany = _ref.relatedCompany;

  var initialValues = _extends({}, relatedCompany);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-md" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Edit Relted Company"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close, initialValues: initialValues })
    )
  );
}

Edit.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 1998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validate__ = __webpack_require__(1999);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      company: _this.props.company
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var company = this.state.company;
      var searchCompanies = this.props.searchCompanies;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_6__constants__["N" /* RELATED_COMPANY_ID */],
                label: "Related Company",
                labelChildren: company && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                  null,
                  "\xA0\xA0",
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["g" /* CompanyStatsTooltip */], { company: company })
                ),
                placeholder: "Search by typing a company's name or code",
                component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["n" /* AutoCompleteField */],
                search: searchCompanies,
                formatItem: function formatItem(result) {
                  return result.name + " (" + __WEBPACK_IMPORTED_MODULE_6__constants__["h" /* APPROVAL_STATUSES */][result.vendor_status].label + ")";
                },
                onItemSelected: function onItemSelected(i) {
                  return i && _this2.handleCompanyChange(i);
                },
                selectedItem: company,
                required: true
              })
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* updateRelatedCompany */](data));
    },
    searchCompanies: function searchCompanies(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* searchCompanies */](filter));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["j" /* form */])({
  form: "editRelatedCompany",
  validate: __WEBPACK_IMPORTED_MODULE_9__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 1999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;




function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["N" /* RELATED_COMPANY_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 2000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Delete_Delete__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Create_NewRelatedCompany__ = __webpack_require__(1995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Edit_EditRelatedCompany__ = __webpack_require__(1997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(36);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var RelatedCompanies = function (_React$Component) {
  _inherits(RelatedCompanies, _React$Component);

  function RelatedCompanies() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RelatedCompanies);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RelatedCompanies.__proto__ || Object.getPrototypeOf(RelatedCompanies)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editRelatedCompanyModalOpen: false,
      selectedCompany: null
    }, _this.closeRelatedCompanyModal = function () {
      return _this.setState({ editRelatedCompanyModalOpen: false });
    }, _this.launchModal = function (row) {
      _this.setState({ editRelatedCompanyModalOpen: true, selectedCompany: row });
    }, _this.renderRow = function (row) {
      var relatedCompany = row.related_company;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        {
          key: row.id,
          className: "clickable",
          onClick: function onClick() {
            return _this.launchModal(row);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* Link */],
            { to: "/companies/" + relatedCompany.uuid },
            relatedCompany.name
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(relatedCompany, "primary_physical_address.care_of")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(relatedCompany, "primary_physical_address.line1")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(relatedCompany, "primary_physical_address.line2")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(relatedCompany, "primary_physical_address.city")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(relatedCompany, "primary_physical_address.state")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(relatedCompany, "primary_physical_address.postal_code")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(relatedCompany, "primary_physical_address.country")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Delete_Delete__["a" /* default */], { id: row.id, deleteAction: __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* destroyRelatedCompany */] })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RelatedCompanies, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          results = _props.results,
          isLoading = _props.isLoading;
      var _state = this.state,
          editRelatedCompanyModalOpen = _state.editRelatedCompanyModalOpen,
          selectedCompany = _state.selectedCompany;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Related Companies",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["b" /* Authorized */],
            { permissions: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["_22" /* CAN_ADD_COMPANIES */]] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Create_NewRelatedCompany__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Edit_EditRelatedCompany__["a" /* default */], {
              open: editRelatedCompanyModalOpen,
              close: this.closeRelatedCompanyModal,
              relatedCompany: selectedCompany
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Mini,
          { loading: isLoading },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Name"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "C/O"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Address Line 1"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Address Line 2"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "City"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "State/Province/Region"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "ZIP/Postal Code"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Country"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "\xA0"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components__["s" /* DataTable */].Body,
            null,
            results.map(this.renderRow)
          )
        )
      );
    }
  }]);

  return RelatedCompanies;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RelatedCompanies.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    care_of: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    line1: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    city: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    state: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    postal_code: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    country: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    primary: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  })).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};

var TabulateAttachments = __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__["decorators"].tabulate(RelatedCompanies);
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabulateAttachments, { listId: "company/relatedCompanies" });
});

/***/ }),
/* 2001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }














function Form(_ref) {
  var close = _ref.close,
      handleSubmit = _ref.handleSubmit,
      invalid = _ref.invalid,
      submitting = _ref.submitting;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "form",
    { onSubmit: handleSubmit },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */], name: "to", label: "To:", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */], name: "cc", label: "CC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */], name: "bcc", label: "BCC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */], name: "subject", label: "Subject", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["l" /* TextArea */], name: "body", label: "Body", required: true })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* Button */],
        {
          onClick: function onClick() {
            close();
          }
        },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* Button */],
        {
          type: "submit",
          bsStyle: "primary",
          disabled: invalid || submitting
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["k" /* Icon */], { name: "envelope", fixed: true }),
        "\xA0Email Form"
      )
    )
  );
}

Form.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reduxForm"])({
  form: "send-ultimate-consignee",
  validate: function validate(values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_validate_this__["a" /* validator */])(values, function (form) {
      form.validate("subject", "body", "to").satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["a" /* required */]);
      form.validate("to", "cc").satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["b" /* isValidEmail */]);
    });
  },
  onSubmit: function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data, _, props) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].companies.sendUltimateConsigneeForm(props.company.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */]), data).then(function () {
                props.close();
                __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__["toastr"].success("Success", "Form successfully sent.");
              }).catch(function () {
                return __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__["toastr"].error("Error", "Could not send form. Please refresh page and try again.");
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function onSubmit(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }()
})(Form));

/***/ }),
/* 2002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony export (immutable) */ __webpack_exports__["a"] = RequestUltimateConsignee;








function RequestUltimateConsignee(_ref) {
  var toggle = _ref.toggle;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hooks__["a" /* useCurrentUser */])();

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(currentUser, [__WEBPACK_IMPORTED_MODULE_3__constants__["_69" /* TENANT */], __WEBPACK_IMPORTED_MODULE_4__constants__["I" /* ULTIMATE_CONSIGNEE_FORM_URL */]].join(".")))) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_DropDown_DropDownItem__["a" /* default */],
    { onClick: toggle },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" }),
      " ",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        "Request of Blanket Ultimate Consignee Statement"
      )
    )
  );
}

/***/ }),
/* 2003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form__ = __webpack_require__(2001);







function RequestUltimateConsigneeModal(_ref) {
  var close = _ref.close,
      open = _ref.open,
      company = _ref.company;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hooks__["a" /* useCurrentUser */])();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Request Ultimate Consignee Form"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Form__["a" /* default */], {
      company: company,
      close: close,
      initialValues: {
        from: currentUser.email,
        ccs: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(currentUser.tenant, __WEBPACK_IMPORTED_MODULE_4__constants__["K" /* ULTIMATE_CONSIGNEE_CCS */]),
        subject: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(currentUser.tenant, __WEBPACK_IMPORTED_MODULE_4__constants__["L" /* ULTIMATE_CONSIGNEE_FORM_SUBJECT */]),
        body: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(currentUser.tenant, __WEBPACK_IMPORTED_MODULE_4__constants__["M" /* ULTIMATE_CONSIGNEE_FORM_BODY */])
      },
      enableReinitialize: true
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (RequestUltimateConsigneeModal);

/***/ }),
/* 2004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(2005);
/* harmony export (immutable) */ __webpack_exports__["a"] = Create;






function Create(_ref) {
  var open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-sm" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Add Shipping Preference"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close })
    )
  );
}

Create.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormSections__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validate__ = __webpack_require__(730);
/* unused harmony export Form */







function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormSections__["a" /* ShippingMethod */], null)
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    resourceID: state.companyDetail.getIn(["company", "id"])
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["k" /* createShippingMethod */])(data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["j" /* form */])({
  form: "createShippingMethod",
  validate: __WEBPACK_IMPORTED_MODULE_5__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreateShippingMethods__ = __webpack_require__(2004);
/* unused harmony export AddContact */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AddContact = function (_Component) {
  _inherits(AddContact, _Component);

  function AddContact() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddContact);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddContact.__proto__ || Object.getPrototypeOf(AddContact)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.open = function () {
      return _this.setState({ open: true });
    }, _this.close = function () {
      return _this.setState({ open: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddContact, [{
    key: "render",
    value: function render() {
      var id = this.props.id;
      var open = this.state.open;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "btn-group pull-right" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          { onClick: this.open, className: "btn btn-primary btn-hollow" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
          "Add Shipping Preference",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CreateShippingMethods__["a" /* default */], { id: id, open: open, close: this.close })
        )
      );
    }
  }]);

  return AddContact;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AddContact.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    id: state.companyDetail.getIn(["company", "id"])
  };
})(AddContact));

/***/ }),
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(2008);
/* harmony export (immutable) */ __webpack_exports__["a"] = Edit;






function Edit(_ref) {
  var open = _ref.open,
      close = _ref.close,
      shippingMethod = _ref.shippingMethod;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Shipping Preference"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close, initialValues: shippingMethod, enableReinitialize: true })
  );
}

Edit.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  shippingMethod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/***/ }),
/* 2008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormSections__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validate__ = __webpack_require__(730);
/* unused harmony export Form */







function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormSections__["a" /* ShippingMethod */], null)
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    resourceID: state.companyDetail.getIn(["company", "id"])
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["j" /* updateShippingMethod */])(data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["j" /* form */])({
  form: "editShippingMethod",
  validate: __WEBPACK_IMPORTED_MODULE_5__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 2009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Delete__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Create_NewShippingMethod__ = __webpack_require__(2006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Edit_EditShippingMethods__ = __webpack_require__(2007);
/* unused harmony export TabulateAttachments */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var ShippingMethods = function (_React$Component) {
  _inherits(ShippingMethods, _React$Component);

  function ShippingMethods() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ShippingMethods);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShippingMethods.__proto__ || Object.getPrototypeOf(ShippingMethods)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editShippingMethodModalOpen: false,
      deleteOpen: false,
      selectedMethod: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()
    }, _this.shippingMethods = function (carrier, method) {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_9__shared_constants__["a" /* CARRIERS */][carrier], "shippingMethods." + method + ".label");
    }, _this.carrier = function (carrier) {
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_9__shared_constants__["a" /* CARRIERS */][carrier], ["label"]);
    }, _this.openShippingMethodsModal = function (pref) {
      return _this.setState({
        editShippingMethodModalOpen: true,
        selectedMethod: pref
      });
    }, _this.closeShippingMethodsModal = function () {
      return _this.setState({ editShippingMethodModalOpen: false });
    }, _this.renderRow = function (row) {
      var carrier = row.carrier;
      var method = row.shipping_method;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        {
          key: row.id,
          className: "clickable",
          onClick: function onClick() {
            return _this.openShippingMethodsModal(row);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          _this.carrier(row.carrier)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          _this.shippingMethods(carrier, method)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          row.account_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Delete__["a" /* default */], {
          primary: false,
          id: row.id,
          deleteAction: __WEBPACK_IMPORTED_MODULE_5__actions__["i" /* destroyShippingMethod */]
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ShippingMethods, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          results = _props.results,
          isLoading = _props.isLoading;
      var _state = this.state,
          editShippingMethodModalOpen = _state.editShippingMethodModalOpen,
          selectedMethod = _state.selectedMethod;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Shipping Preferences",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components__["b" /* Authorized */],
            {
              roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_8__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["j" /* WAREHOUSE */]),
              permissions: [__WEBPACK_IMPORTED_MODULE_8__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]]
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Create_NewShippingMethod__["a" /* default */], null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Mini,
          { loading: isLoading },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Head,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Carrier"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Method"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Account #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Body,
            null,
            results.map(function (row) {
              return _this2.renderRow(row);
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components__["b" /* Authorized */],
          {
            roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_8__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["j" /* WAREHOUSE */]),
            permissions: [__WEBPACK_IMPORTED_MODULE_8__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_8__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]]
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Edit_EditShippingMethods__["a" /* default */], {
            open: editShippingMethodModalOpen,
            close: this.closeShippingMethodsModal,
            shippingMethod: selectedMethod
          })
        )
      );
    }
  }]);

  return ShippingMethods;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ShippingMethods.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    method: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    carrier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    account_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })).isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var TabulateAttachments = __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__["decorators"].tabulate(ShippingMethods);
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabulateAttachments, { listId: "company/shippingMethods" });
});

/***/ }),
/* 2010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShippingMethods__ = __webpack_require__(2009);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ShippingMethods__["a"]; });



/***/ }),
/* 2011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["a"] = Status;
var _STATUS_LABELS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var STATUS_LABELS = (_STATUS_LABELS = {}, _defineProperty(_STATUS_LABELS, __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* NO_BIZ */], {
  css: "text-danger",
  icon: "fa-warning",
  text: __WEBPACK_IMPORTED_MODULE_2__constants__["_1" /* COMPANY_STATUSES */][__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* NO_BIZ */]].label
}), _defineProperty(_STATUS_LABELS, __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* ACTIVE */], {
  css: "text-success",
  icon: "fa-check",
  text: __WEBPACK_IMPORTED_MODULE_2__constants__["_1" /* COMPANY_STATUSES */][__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* ACTIVE */]].label
}), _defineProperty(_STATUS_LABELS, __WEBPACK_IMPORTED_MODULE_2__constants__["_2" /* OBSOLETE */], {
  css: "text-default",
  icon: "fa-minus-circle",
  text: __WEBPACK_IMPORTED_MODULE_2__constants__["_1" /* COMPANY_STATUSES */][__WEBPACK_IMPORTED_MODULE_2__constants__["_2" /* OBSOLETE */]].label
}), _defineProperty(_STATUS_LABELS, __WEBPACK_IMPORTED_MODULE_2__constants__["_3" /* OUT_OF_BIZ */], {
  css: "text-default",
  icon: "fa-minus-circle",
  text: __WEBPACK_IMPORTED_MODULE_2__constants__["_1" /* COMPANY_STATUSES */][__WEBPACK_IMPORTED_MODULE_2__constants__["_3" /* OUT_OF_BIZ */]].label
}), _defineProperty(_STATUS_LABELS, __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* CREDIT_HOLD */], {
  css: "text-danger",
  icon: "fa-warning",
  text: __WEBPACK_IMPORTED_MODULE_2__constants__["_1" /* COMPANY_STATUSES */][__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* CREDIT_HOLD */]].label
}), _STATUS_LABELS);

function Status(_ref) {
  var status = _ref.status;

  var info = STATUS_LABELS[status];
  if (!info) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      null,
      status
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "" + info.css },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa " + info.icon }),
    "\xA0\xA0",
    info.text
  );
}

Status.propTypes = {
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(__WEBPACK_IMPORTED_MODULE_2__constants__["_1" /* COMPANY_STATUSES */])).isRequired
};

/***/ }),
/* 2012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["a"] = StatusBadges;
var _STATUS_LABELS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var STATUS_FIELDS = ["status", "vendor_status", "repair_station_status"];

var STATUS_LABELS = (_STATUS_LABELS = {}, _defineProperty(_STATUS_LABELS, __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* NO_BIZ */], {
  label: "label-danger",
  text: __WEBPACK_IMPORTED_MODULE_3__constants__["_1" /* COMPANY_STATUSES */][__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* NO_BIZ */]].label
}), _defineProperty(_STATUS_LABELS, __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* CREDIT_HOLD */], {
  label: "label-danger",
  text: __WEBPACK_IMPORTED_MODULE_3__constants__["_1" /* COMPANY_STATUSES */][__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* CREDIT_HOLD */]].label
}), _defineProperty(_STATUS_LABELS, __WEBPACK_IMPORTED_MODULE_3__constants__["_2" /* OBSOLETE */], {
  label: "label-danger",
  text: __WEBPACK_IMPORTED_MODULE_3__constants__["_1" /* COMPANY_STATUSES */][__WEBPACK_IMPORTED_MODULE_3__constants__["_2" /* OBSOLETE */]].label
}), _STATUS_LABELS);

function StatusLabel(_ref) {
  var label = _ref.label,
      text = _ref.text;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "pull-right label " + label },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-warning" }),
    "\xA0\xA0",
    text
  );
}

StatusLabel.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

function StatusBadges(_ref2) {
  var company = _ref2.company;

  var statuses = STATUS_FIELDS.map(function (field) {
    return STATUS_LABELS[company.get(field)];
  }).filter(function (label) {
    return label;
  }) // Remove nulls
  .map(function (label) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StatusLabel, { key: label.text, label: label.label, text: label.text });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "pull-right" },
    statuses
  );
}

StatusBadges.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
};

/***/ }),
/* 2013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["a"] = VendorApproval;
var _STATUS_COMPONENTS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function ApprovalButton(_ref) {
  var _ref$btnClass = _ref.btnClass,
      btnClass = _ref$btnClass === undefined ? "btn-default" : _ref$btnClass,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? true : _ref$disabled,
      _ref$func = _ref.func,
      func = _ref$func === undefined ? function () {} : _ref$func,
      _ref$icon = _ref.icon,
      icon = _ref$icon === undefined ? "bell" : _ref$icon,
      label = _ref.label;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    {
      className: "btn btn-xs btn-block " + btnClass,
      disabled: disabled,
      onClick: func
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "i",
      { className: "fa fa-fw fa-" + icon },
      "\xA0\xA0"
    ),
    label
  );
}

ApprovalButton.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  func: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  btnClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

function Approved(_ref2) {
  var _ref2$label = _ref2.label,
      label = _ref2$label === undefined ? "Approved" : _ref2$label,
      _ref2$type = _ref2.type,
      type = _ref2$type === undefined ? "success" : _ref2$type;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "text-" + type },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check" }),
    "\xA0",
    label
  );
}

Approved.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

function Denied() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "text-danger" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" }),
    "\xA0Denied"
  );
}

var STATUS_COMPONENTS = (_STATUS_COMPONENTS = {}, _defineProperty(_STATUS_COMPONENTS, __WEBPACK_IMPORTED_MODULE_2__constants__["H" /* NOT_APPROVED */], function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ApprovalButton, {
    btnClass: "btn-info",
    disabled: false
    // eslint-disable-next-line react/prop-types
    , func: props.onApprovalRequest,
    icon: "check",
    label: "Request Approval"
  });
}), _defineProperty(_STATUS_COMPONENTS, __WEBPACK_IMPORTED_MODULE_2__constants__["_0" /* APPROVAL_REQUESTED */], function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ApprovalButton, { label: "Requested", icon: "bell" });
}), _defineProperty(_STATUS_COMPONENTS, __WEBPACK_IMPORTED_MODULE_2__constants__["m" /* PENDING */], function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ApprovalButton, { label: "Under Review", icon: "bell" });
}), _defineProperty(_STATUS_COMPONENTS, __WEBPACK_IMPORTED_MODULE_2__constants__["o" /* MANAGER_CONSENT_NEEDED */], function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Approved, { label: "Mgmt. Consent Needed", type: "warning" });
}), _defineProperty(_STATUS_COMPONENTS, __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* APPROVED */], Approved), _defineProperty(_STATUS_COMPONENTS, __WEBPACK_IMPORTED_MODULE_2__constants__["n" /* DENIED */], Denied), _STATUS_COMPONENTS);

function VendorApproval(props) {
  return STATUS_COMPONENTS[props.status](props);
}

VendorApproval.propTypes = {
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(__WEBPACK_IMPORTED_MODULE_2__constants__["h" /* APPROVAL_STATUSES */]))
};

/***/ }),
/* 2014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Detail__ = __webpack_require__(1974);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Detail__["a"]; });



/***/ }),
/* 2015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form__ = __webpack_require__(2016);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditApprovals;







var getYYYYMMFormat = function getYYYYMMFormat(date) {
  return date ? date.slice(0, 10) : null;
};

var initialValues = function initialValues(company) {
  var pickedValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_pojos__["a" /* default */])(company).pick(__WEBPACK_IMPORTED_MODULE_4__constants__["_4" /* ASA_APPROVED */], __WEBPACK_IMPORTED_MODULE_4__constants__["_5" /* BLANKET_EXCHANGE_AGREEMENT */], __WEBPACK_IMPORTED_MODULE_4__constants__["k" /* DO_NOT_EXCHANGE */], __WEBPACK_IMPORTED_MODULE_4__constants__["_6" /* STATUS */], __WEBPACK_IMPORTED_MODULE_4__constants__["q" /* REPAIR_STATION_STATUS */], __WEBPACK_IMPORTED_MODULE_4__constants__["G" /* VENDOR_STATUS */], __WEBPACK_IMPORTED_MODULE_4__constants__["P" /* EXPORT_COMPLIANT */], __WEBPACK_IMPORTED_MODULE_4__constants__["T" /* EASA_APPROVED */], __WEBPACK_IMPORTED_MODULE_4__constants__["R" /* END_USER_AGREEMENT_REQUESTED */], __WEBPACK_IMPORTED_MODULE_4__constants__["S" /* FAA_APPROVED */], __WEBPACK_IMPORTED_MODULE_4__constants__["V" /* CAAC_APPROVED */], __WEBPACK_IMPORTED_MODULE_4__constants__["Q" /* EXPORT_APPROVAL_REQUIRED */], __WEBPACK_IMPORTED_MODULE_4__constants__["W" /* TCCA_APPROVED */], __WEBPACK_IMPORTED_MODULE_4__constants__["X" /* OTHER_APPROVED */], "other_approval", __WEBPACK_IMPORTED_MODULE_4__constants__["_5" /* BLANKET_EXCHANGE_AGREEMENT */], "do_not_quote", __WEBPACK_IMPORTED_MODULE_4__constants__["Z" /* MANDATORY_ADDITIONAL_VERBIAGE */], __WEBPACK_IMPORTED_MODULE_4__constants__["_7" /* SECOND_QC_EXPORT_COMPLIANCE_REMINDER_SENT */], __WEBPACK_IMPORTED_MODULE_4__constants__["_8" /* THIRD_QC_EXPORT_COMPLIANCE_REMINDER_SENT */], __WEBPACK_IMPORTED_MODULE_4__constants__["Y" /* VENDOR_TRACE_PREAPPROVAL_REQUIRED */], "business_start_date", "consolidated_screening_list_verification_passed", "customer_website_review_passed", "research_social_media_networks_and_general_online_search_passed", "trader_partners_shipment_records_search_passed", __WEBPACK_IMPORTED_MODULE_4__constants__["U" /* UK_CAA_APPROVED */]);

  pickedValues.business_start_date = getYYYYMMFormat(pickedValues.business_start_date);

  return pickedValues;
};

function EditApprovals(_ref) {
  var open = _ref.open,
      close = _ref.close,
      company = _ref.company;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Company Status"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Form__["a" /* default */], {
      company: company,
      close: close,
      initialValues: initialValues(company),
      enableReinitialize: true
    })
  );
}

EditApprovals.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_MonthYearField_MonthYearField__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__validate__ = __webpack_require__(2020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__RepairStationApproval__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__VendorApproval__ = __webpack_require__(2018);
/* unused harmony export Form */






















var StatusSelect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_decorators__["t" /* disabledUnless */])(function (user) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__users_helpers__["d" /* hasRole */])(user.toJS(), __WEBPACK_IMPORTED_MODULE_10__users_constants__["m" /* ACCOUNTING */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__users_helpers__["e" /* hasPermission */])(user.toJS(), [__WEBPACK_IMPORTED_MODULE_10__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__users_helpers__["g" /* hasSubRole */])(user.toJS(), __WEBPACK_IMPORTED_MODULE_10__users_constants__["n" /* QUALITY_CONTROL_MANAGER */]);
})(function (props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
    null,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
      { md: 12 },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
        name: __WEBPACK_IMPORTED_MODULE_12__constants__["_6" /* STATUS */],
        component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["c" /* Select */],
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["_6" /* STATUS */]),
        options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__constants__["_1" /* COMPANY_STATUSES */]),
        disabled: props.disabled
      })
    )
  );
});

var ASASelect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_decorators__["t" /* disabledUnless */])(function (user) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__users_helpers__["d" /* hasRole */])(user.toJS(), __WEBPACK_IMPORTED_MODULE_10__users_constants__["p" /* QUALITY_CONTROL */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__users_helpers__["e" /* hasPermission */])(user.toJS(), [__WEBPACK_IMPORTED_MODULE_10__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]]);
})(function (props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_12__constants__["_4" /* ASA_APPROVED */],
    component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
    label: "AC-0056B",
    disabled: props.disabled
  });
});

var BlanketExchangeAgreement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_decorators__["t" /* disabledUnless */])(function (user) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__users_helpers__["e" /* hasPermission */])(user.toJS(), [__WEBPACK_IMPORTED_MODULE_10__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]]);
})(function (props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
    { md: 6 },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      "label",
      {
        className: "control-label",
        style: { display: "flex" },
        htmlFor: "blanket_exchange_agreement"
      },
      "Blanket Exchange Agreement"
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* FormGroup */],
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "div",
        {
          className: "btn-group btn-group-justified btn-group-vertical",
          "data-toggle": "buttons"
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: "blanket_exchange_agreement",
          component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
          label: "Blanket Exchange Agreement",
          disabled: props.disabled
        })
      )
    )
  );
});

var doNotQuoteNote = "To be used only for companies that rarely buy from us or are pricing us.";
var DoNotQuote = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_decorators__["t" /* disabledUnless */])(function (user) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__users_helpers__["e" /* hasPermission */])(user.toJS(), [__WEBPACK_IMPORTED_MODULE_10__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]]);
})(function (props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
    { md: 6 },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      "label",
      { className: "control-label", htmlFor: "do_not_quote" },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "span",
        null,
        "Do Not Quote"
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "span",
        { style: { marginLeft: 5 } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
          note: doNotQuoteNote,
          placement: "left",
          icon: "fa-info-circle",
          color: "rgba(255, 255, 255, 0.25)"
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* FormGroup */],
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "div",
        {
          className: "btn-group btn-group-justified btn-group-vertical",
          "data-toggle": "buttons"
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: "do_not_quote",
          component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
          label: "Do Not Quote",
          disabled: props.disabled
        })
      )
    )
  );
});

var ExportCompliant = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_decorators__["t" /* disabledUnless */])(function (user) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__users_helpers__["d" /* hasRole */])(user.toJS(), __WEBPACK_IMPORTED_MODULE_10__users_constants__["p" /* QUALITY_CONTROL */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__users_helpers__["e" /* hasPermission */])(user.toJS(), [__WEBPACK_IMPORTED_MODULE_10__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]]);
})(function (props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_12__constants__["P" /* EXPORT_COMPLIANT */],
    component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["P" /* EXPORT_COMPLIANT */]),
    disabled: props.disabled,
    onChange: function onChange(val) {
      if (val) {
        props.setFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["Q" /* EXPORT_APPROVAL_REQUIRED */])(false);
        props.setFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["R" /* END_USER_AGREEMENT_REQUESTED */])(false);
      }
    }
  });
});

var TracePreapproval = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_decorators__["t" /* disabledUnless */])(function (user) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__users_helpers__["a" /* hasAnyOfSubroles */])(user.toJS(), [__WEBPACK_IMPORTED_MODULE_10__users_constants__["o" /* QUALITY_CONTROL_ADMIN */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["n" /* QUALITY_CONTROL_MANAGER */]]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__users_helpers__["e" /* hasPermission */])(user.toJS(), [__WEBPACK_IMPORTED_MODULE_10__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]]);
})(function (props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
    { md: 6 },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      "label",
      {
        className: "control-label",
        htmlFor: __WEBPACK_IMPORTED_MODULE_12__constants__["Y" /* VENDOR_TRACE_PREAPPROVAL_REQUIRED */]
      },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "span",
        null,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["Y" /* VENDOR_TRACE_PREAPPROVAL_REQUIRED */])
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* FormGroup */],
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "div",
        {
          className: "btn-group btn-group-justified btn-group-vertical",
          "data-toggle": "buttons"
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_12__constants__["Y" /* VENDOR_TRACE_PREAPPROVAL_REQUIRED */],
          component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["Y" /* VENDOR_TRACE_PREAPPROVAL_REQUIRED */]),
          disabled: props.disabled
        })
      )
    )
  );
});

var parseValue = function parseValue(value) {
  return value === "" ? undefined : value;
};

var formatValue = function formatValue(value) {
  return value === undefined ? "" : value;
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])("editApprovals");

var updatedAtField = function updatedAtField(company, field) {
  var updatedAt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(company, field + "_audit.updated_at");
  if (!updatedAt) return null;
  return "<br />  Updated At " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["a" /* shortDateYYandTime */])(updatedAt);
};

function Form(props) {
  var company = props.company,
      otherApproved = props.otherApproved,
      setFieldValue = props.setFieldValue;


  var ECApprovedBy = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(company, "export_compliant_updated_by.full_name");
  var ECApprovalDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["a" /* shortDateYYandTime */])(company.export_compliant_updated_at);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StatusSelect, null),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__VendorApproval__["a" /* default */], { status: company.vendor_status })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__RepairStationApproval__["a" /* default */], { status: company.repair_station_status })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BlanketExchangeAgreement, null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DoNotQuote, null)
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TracePreapproval, null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_12__constants__["k" /* DO_NOT_EXCHANGE */] },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "span",
              null,
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["k" /* DO_NOT_EXCHANGE */])
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* FormGroup */],
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              {
                className: "btn-group btn-group-justified btn-group-vertical",
                "data-toggle": "buttons"
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_12__constants__["k" /* DO_NOT_EXCHANGE */],
                component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["k" /* DO_NOT_EXCHANGE */])
              })
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* FormGroup */],
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "label",
              { className: "control-label", htmlFor: "none" },
              "Other Approvals"
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              {
                className: "btn-group btn-group-justified btn-group-vertical",
                "data-toggle": "buttons"
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ASASelect, null),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: __WEBPACK_IMPORTED_MODULE_12__constants__["S" /* FAA_APPROVED */], component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */], label: "FAA" }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: __WEBPACK_IMPORTED_MODULE_12__constants__["T" /* EASA_APPROVED */], component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */], label: "EASA" }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: __WEBPACK_IMPORTED_MODULE_12__constants__["V" /* CAAC_APPROVED */], component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */], label: "CAAC" }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: __WEBPACK_IMPORTED_MODULE_12__constants__["W" /* TCCA_APPROVED */], component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */], label: "TCCA" }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_12__constants__["U" /* UK_CAA_APPROVED */],
                component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
                label: "UK CAA"
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: __WEBPACK_IMPORTED_MODULE_12__constants__["X" /* OTHER_APPROVED */], component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */], label: "OTHER" })
            )
          ),
          otherApproved && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* FormGroup */],
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
              name: "other_approval",
              label: "Other approval",
              component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["d" /* FormInput */],
              type: "text"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* FormGroup */],
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "label",
              { className: "control-label", htmlFor: "none" },
              "Export Compliant",
              company.export_compliant && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
                note: "Approved by " + ECApprovedBy + " on " + ECApprovalDate,
                icon: "fa-info-circle",
                color: "rgba(255, 255, 255, 0.25)",
                placement: "right"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              {
                className: "btn-group btn-group-justified btn-group-vertical",
                "data-toggle": "buttons"
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ExportCompliant, { setFieldValue: setFieldValue }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_12__constants__["R" /* END_USER_AGREEMENT_REQUESTED */],
                  component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["R" /* END_USER_AGREEMENT_REQUESTED */]),
                  onChange: function onChange(val) {
                    if (val) {
                      setFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["P" /* EXPORT_COMPLIANT */])(false);
                      setFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["Q" /* EXPORT_APPROVAL_REQUIRED */])(false);
                    }
                  }
                }),
                company.end_user_agreement_requested && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "span",
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
                    note: "Updated by " + __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(company, "end_user_agreement_requested_by.full_name") + " on " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["a" /* shortDateYYandTime */])(company.end_user_agreement_requested_at),
                    icon: "fa-info-circle",
                    color: "rgba(255, 255, 255, 0.25)",
                    placement: "right"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_12__constants__["Q" /* EXPORT_APPROVAL_REQUIRED */],
                  component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["b" /* Check */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["Q" /* EXPORT_APPROVAL_REQUIRED */]),
                  onChange: function onChange(val) {
                    if (val) {
                      setFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["P" /* EXPORT_COMPLIANT */])(false);
                      setFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["R" /* END_USER_AGREEMENT_REQUESTED */])(false);
                    }
                  }
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "span",
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
                    note: "All Sales Orders with company will be placed on Export Compliance Hold for review by QC.",
                    icon: "fa-info-circle",
                    color: "rgba(255, 255, 255, 0.25)",
                    placement: "right"
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* FormGroup */],
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "label",
              { className: "control-label", htmlFor: "none" },
              "Know Your Customer"
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "label",
                { className: "control-label", htmlFor: "none" },
                ["Business Start Date", __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
                  note: "February, 2022: Russian-related sanctions are made effective" + updatedAtField(company, "business_start_date"),
                  icon: "fa-info-circle",
                  color: "rgba(255, 255, 255, 0.25)",
                  placement: "right"
                })]
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                  { md: 12 },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_Forms_MonthYearField_MonthYearField__["a" /* default */], {
                    name: "business_start_date",
                    className: "form-control",
                    component: "input"
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* FormGroup */],
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: "customer_website_review_passed",
                  component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["c" /* Select */],
                  label: ["Customer Website Review", updatedAtField(company, "customer_website_review_passed") ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
                    note: "Customer Website Review" + updatedAtField(company, "customer_website_review_passed"),
                    icon: "fa-info-circle",
                    color: "rgba(255, 255, 255, 0.25)",
                    placement: "right"
                  }) : null],
                  options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__constants__["_9" /* PASS_FAIL */]),
                  parse: parseValue,
                  format: formatValue
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: "consolidated_screening_list_verification_passed",
                  component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["c" /* Select */],
                  label: ["CSLV", __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
                    note: "Consolidated Screening List Verification" + updatedAtField(company, "cslv"),
                    icon: "fa-info-circle",
                    color: "rgba(255, 255, 255, 0.25)",
                    placement: "right"
                  })],
                  options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__constants__["_9" /* PASS_FAIL */]),
                  parse: parseValue,
                  format: formatValue
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: "research_social_media_networks_and_general_online_search_passed",
                  component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["c" /* Select */],
                  label: ["RSMN", __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
                    note: "Research Social Media Networks and General Online Search" + updatedAtField(company, "rsmn"),
                    icon: "fa-info-circle",
                    color: "rgba(255, 255, 255, 0.25)",
                    placement: "right"
                  })],
                  options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__constants__["_9" /* PASS_FAIL */]),
                  parse: parseValue,
                  format: formatValue
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                { md: 12 },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: "trader_partners_shipment_records_search_passed",
                  component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["c" /* Select */],
                  label: ["TPSRS", __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
                    note: "Trade Partners Shipment Records Search" + updatedAtField(company, "tpsrs"),
                    icon: "fa-info-circle",
                    color: "rgba(255, 255, 255, 0.25)",
                    placement: "right"
                  })],
                  options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__constants__["_9" /* PASS_FAIL */]),
                  parse: parseValue,
                  format: formatValue
                })
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_12__constants__["Z" /* MANDATORY_ADDITIONAL_VERBIAGE */],
            component: __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["l" /* TextArea */],
            label: "Mandatory Additional Verbiage for Purchase Orders",
            rows: 5
          })
        )
      )
    )
  );
}

Form.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({}),
  otherApproved: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    otherApproved: selector(state, __WEBPACK_IMPORTED_MODULE_12__constants__["X" /* OTHER_APPROVED */])
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, { onSubmit: __WEBPACK_IMPORTED_MODULE_8__actions__["o" /* update */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_components_Forms__["j" /* form */])({
  form: "editApprovals", // Ensure this matches your form name
  validate: __WEBPACK_IMPORTED_MODULE_18__validate__["a" /* default */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["a"] = RepairStationApproval;










var approvalStatusOptions = function approvalStatusOptions(status) {
  var selectableStatuses = __WEBPACK_IMPORTED_MODULE_8__constants__["_10" /* REPAIR_STATION_APPROVAL_STATUSES */][status].selectableStatuses.concat(__WEBPACK_IMPORTED_MODULE_8__constants__["_10" /* REPAIR_STATION_APPROVAL_STATUSES */][status].selectableRepairStatus);
  return selectableStatuses.map(function (s) {
    return {
      value: s,
      text: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_10" /* REPAIR_STATION_APPROVAL_STATUSES */], s + ".label")
    };
  });
};

var RepairStationStatusSelect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["t" /* disabledUnless */])(function (user) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__users_helpers__["c" /* hasAnyOfRoles */])(user.toJS(), [__WEBPACK_IMPORTED_MODULE_6__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_6__users_constants__["p" /* QUALITY_CONTROL */]]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__users_helpers__["e" /* hasPermission */])(user.toJS(), [__WEBPACK_IMPORTED_MODULE_6__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_6__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]]);
})(function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_8__constants__["q" /* REPAIR_STATION_STATUS */],
    component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
    label: "Repair Station Approval",
    options: approvalStatusOptions(props.status),
    disabled: props.disabled
  });
});

function RequestRepairStationApproval() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { htmlFor: "request_shop_approval" },
      "Repair Station Approval"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "btn-group btn-group-justified btn-group-vertical",
        "data-toggle": "buttons"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
        name: "request_shop_approval",
        component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["b" /* Check */],
        label: "Request Rep Station Approval"
      })
    )
  );
}

function RepairStationApproval(props) {
  return props.status === __WEBPACK_IMPORTED_MODULE_8__constants__["H" /* NOT_APPROVED */] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RequestRepairStationApproval, null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RepairStationStatusSelect, { status: props.status });
}

RepairStationApproval.propTypes = {
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(__WEBPACK_IMPORTED_MODULE_8__constants__["_10" /* REPAIR_STATION_APPROVAL_STATUSES */]))
};

/***/ }),
/* 2018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["a"] = VendorApproval;









var approvalStatusOptions = function approvalStatusOptions(status) {
  var selectableStatuses = __WEBPACK_IMPORTED_MODULE_7__constants__["h" /* APPROVAL_STATUSES */][status].selectableStatuses;
  return selectableStatuses.map(function (s) {
    return {
      value: s,
      text: __WEBPACK_IMPORTED_MODULE_7__constants__["h" /* APPROVAL_STATUSES */][s].label
    };
  });
};

var VendorStatusSelect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["t" /* disabledUnless */])(function (user) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__users_helpers__["c" /* hasAnyOfRoles */])(user.toJS(), [__WEBPACK_IMPORTED_MODULE_4__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_4__users_constants__["p" /* QUALITY_CONTROL */]]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__users_helpers__["e" /* hasPermission */])(user.toJS(), [__WEBPACK_IMPORTED_MODULE_4__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_4__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]]);
})(function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_7__constants__["G" /* VENDOR_STATUS */],
    component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["c" /* Select */],
    label: "Vendor Approval",
    options: approvalStatusOptions(props.status),
    disabled: props.disabled
  });
});

function RequestVendorApproval() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { htmlFor: "request_vendor_approval" },
      "Vendor Approval"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        className: "btn-group btn-group-justified btn-group-vertical",
        "data-toggle": "buttons"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
        name: "request_vendor_approval",
        component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["b" /* Check */],
        label: "Request Approval"
      })
    )
  );
}

function VendorApproval(props) {
  return props.status === __WEBPACK_IMPORTED_MODULE_7__constants__["H" /* NOT_APPROVED */] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RequestVendorApproval, null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VendorStatusSelect, { status: props.status });
}

VendorApproval.propTypes = {
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(__WEBPACK_IMPORTED_MODULE_7__constants__["h" /* APPROVAL_STATUSES */]))
};

/***/ }),
/* 2019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditApprovals__ = __webpack_require__(2015);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EditApprovals__["a"]; });



/***/ }),
/* 2020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;



function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate("status").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 2021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(2022);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditBilling;






function EditBilling(_ref) {
  var open = _ref.open,
      close = _ref.close,
      company = _ref.company;

  if (company.billing_address) {
    company.billing_address.region = company.region;
  }

  company.locations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hooks__["a" /* useCurrentUser */])().locations.map(function (l) {
    var quickbooksVendor = company.quickbooks_vendor[l.id] || {};

    return { id: l.id, quickbooks_vendor: quickbooksVendor };
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Company Billing Information"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], {
      company: company,
      close: close,
      initialValues: company,
      enableReinitialize: true
    })
  );
}

EditBilling.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_DashedSeparator__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__validate__ = __webpack_require__(2024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AddressFields__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants__ = __webpack_require__(22);
/* unused harmony export Form */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var AccountingFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_decorators__["t" /* disabledUnless */])(function (user) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__users_helpers__["d" /* hasRole */])(user.toJS(), __WEBPACK_IMPORTED_MODULE_5__users_constants__["m" /* ACCOUNTING */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__users_helpers__["e" /* hasPermission */])(user.toJS(), [__WEBPACK_IMPORTED_MODULE_5__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]]);
})(function (_ref) {
  var disabled = _ref.disabled,
      getInitialFieldValue = _ref.getInitialFieldValue;

  var paymentTerms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__hooks__["a" /* useCurrentUser */])().tenant.payment_terms || Object.keys(__WEBPACK_IMPORTED_MODULE_19__constants__["i" /* VENDOR_TERMS */]);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_DashedSeparator__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["e" /* Col */],
        { md: 7 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_19__constants__["_11" /* VENDOR_CREDIT_TERMS */],
          component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
          label: "Vendor credit terms",
          disabled: disabled,
          options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_forms__["d" /* arrayToProperCasedOptionsWithCurrentValue */])(paymentTerms, getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_19__constants__["_11" /* VENDOR_CREDIT_TERMS */]))
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["e" /* Col */],
        { md: 5 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], {
          name: "vendor_credit_limit",
          label: "Vendor credit limit",
          inputProps: { disabled: disabled }
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["e" /* Col */],
        { md: 7 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_19__constants__["_13" /* CUSTOMER_CREDIT_TERMS */],
          component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
          label: "Customer credit terms",
          disabled: disabled,
          options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_forms__["d" /* arrayToProperCasedOptionsWithCurrentValue */])(paymentTerms, getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_19__constants__["_13" /* CUSTOMER_CREDIT_TERMS */]))
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["e" /* Col */],
        { md: 5 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], {
          name: "customer_credit_limit",
          label: "Customer credit limit",
          inputProps: { disabled: disabled }
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_DashedSeparator__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: "resale_num",
          component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
          inputProps: { disabled: disabled },
          label: "Resale #"
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: "vat_num",
          component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
          inputProps: { disabled: disabled },
          label: "VAT #"
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: "ein_number", component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], label: "EIN #" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: "tax_id_number", component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], label: "TAX ID #" })
      )
    )
  );
});

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      sameAsPrimaryAddress: true
    }, _this.searchVendors = function (locationId) {
      return function (params) {
        return __WEBPACK_IMPORTED_MODULE_15__api__["a" /* default */].locations.quickbooks.vendors.search(locationId, params).then(function (_ref3) {
          var data = _ref3.data;
          return data.results;
        });
      };
    }, _this.searchCustomers = function (locationId) {
      return function (params) {
        return __WEBPACK_IMPORTED_MODULE_15__api__["a" /* default */].locations.quickbooks.customers.search(locationId, params).then(function (_ref4) {
          var data = _ref4.data;
          return data.results;
        });
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "tooglePrimaryAddress",
    value: function tooglePrimaryAddress() {
      if (this.state.sameAsPrimaryAddress && this.props.primaryAddress) {
        var _props$primaryAddress = this.props.primaryAddress.toJS(),
            country = _props$primaryAddress.country,
            care_of = _props$primaryAddress.care_of,
            line1 = _props$primaryAddress.line1,
            line2 = _props$primaryAddress.line2,
            city = _props$primaryAddress.city,
            state = _props$primaryAddress.state,
            postal_code = _props$primaryAddress.postal_code;

        this.props.change("billing_address.country", country);
        this.props.change("billing_address.care_of", care_of);
        this.props.change("billing_address.line1", line1);
        this.props.change("billing_address.line2", line2);
        this.props.change("billing_address.city", city);
        this.props.change("billing_address.state", state);
        this.props.change("billing_address.postal_code", postal_code);
      } else {
        this.props.reset();
      }
      this.setState(function (currentState) {
        return {
          sameAsPrimaryAddress: !currentState.sameAsPrimaryAddress
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          company = _props.company,
          setFieldValue = _props.setFieldValue;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "btn-group", "data-toggle": "buttons" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                onChange: function onChange() {
                  return _this2.tooglePrimaryAddress();
                },
                name: "same_as_primary_address",
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                label: "Copy Primary Physical Address"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__AddressFields__["a" /* default */], {
            path: "billing_address",
            country: this.props.country,
            region: this.props.region,
            formName: "editBilling",
            showRegion: true,
            resetState: true,
            stateProvinceRequired: true
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountingFields, {
            getInitialFieldValue: this.props.getInitialFieldValue
          }),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__hooks__["a" /* useCurrentUser */])().locations.filter(function (f) {
            return f.quickbook_realm_id || f.quickbooks_desktop_integrated;
          }).map(function (l, idx) {
            return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormRow__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["e" /* Col */],
                { sm: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_redux_form__["FormSection"],
                  { name: "locations[" + idx + "]" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                    name: "id",
                    type: "hidden",
                    style: { height: 0 }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    name: "quickbooks_customer",
                    label: "Quickbooks Customer Account - " + l.entity_name,
                    placeholder: "Search by typing a company's name",
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["n" /* AutoCompleteField */],
                    onItemSelected: function onItemSelected(item) {
                      return setFieldValue("locations[" + idx + "].quickbooks_customer")(item || { id: "remove" });
                    },
                    selectedItem: company.quickbooks_customer[l.id],
                    search: _this2.searchCustomers(l.id),
                    formatItem: function formatItem(result) {
                      return result && result.company_name;
                    }
                  })
                )
              )
            ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormRow__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12_react_bootstrap__["e" /* Col */],
                { sm: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_redux_form__["FormSection"],
                  { name: "locations[" + idx + "]" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                    n: true,
                    ame: "id",
                    type: "hidden",
                    style: { height: 0 }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    name: "quickbooks_vendor",
                    label: "Quickbooks Vendor Account - " + l.entity_name,
                    placeholder: "Search by typing a company's name",
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["n" /* AutoCompleteField */],
                    onItemSelected: function onItemSelected(item) {
                      return setFieldValue("locations[" + idx + "].quickbooks_vendor")(item || { id: "remove" });
                    },
                    selectedItem: company.quickbooks_vendor[l.id],
                    search: _this2.searchVendors(l.id),
                    formatItem: function formatItem(result) {
                      return result && result.company_name;
                    }
                  })
                )
              )
            )];
          })
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  country: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  primaryAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])("editBilling");

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    primaryAddress: state.companyDetail.getIn(["company", "primary_physical_address"]),
    country: selector(state, "billing_address.country")
  };
}, { onSubmit: __WEBPACK_IMPORTED_MODULE_6__actions__["o" /* update */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["j" /* form */])({
  form: "editBilling",
  validate: __WEBPACK_IMPORTED_MODULE_17__validate__["a" /* default */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 2023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditBilling__ = __webpack_require__(2021);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EditBilling__["a"]; });



/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;




function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate("customer_credit_limit").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["f" /* isGreaterThan */](0));
    form.validate("vendor_credit_limit").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["f" /* isGreaterThan */](0));
    form.validateChild("billing_address", function (billingForm) {
      billingForm.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_2__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_2__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_2__constants__["w" /* POSTAL_CODE */], __WEBPACK_IMPORTED_MODULE_2__constants__["r" /* COUNTRY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["p" /* requiredIfAnyDefined */](__WEBPACK_IMPORTED_MODULE_2__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* LINE2 */], __WEBPACK_IMPORTED_MODULE_2__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_2__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_2__constants__["w" /* POSTAL_CODE */], __WEBPACK_IMPORTED_MODULE_2__constants__["r" /* COUNTRY */]));
    });
  });
}

/***/ }),
/* 2025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(2026);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditCompany;





function EditCompany(_ref) {
  var open = _ref.open,
      close = _ref.close,
      company = _ref.company;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Company Details"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close, initialValues: company, enableReinitialize: true })
  );
}

EditCompany.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__validate__ = __webpack_require__(2028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(22);
/* unused harmony export Form */


















var CompanyNameField = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_decorators__["t" /* disabledUnless */])(function (user) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__users_helpers__["c" /* hasAnyOfRoles */])(user.toJS(), [__WEBPACK_IMPORTED_MODULE_4__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_4__users_constants__["p" /* QUALITY_CONTROL */]]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__users_helpers__["e" /* hasPermission */])(user.toJS(), [__WEBPACK_IMPORTED_MODULE_4__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_4__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]]);
})(function (_ref) {
  var disabled = _ref.disabled;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "col-md-6" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
      name: __WEBPACK_IMPORTED_MODULE_13__constants__["S" /* NAME */],
      component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["S" /* NAME */]),
      inputProps: { disabled: disabled },
      required: true
    })
  );
});

function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_16__constants__["E" /* COMPANY_TYPE */],
          component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
          label: "Type",
          options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_16__constants__["F" /* COMPANY_TYPES */])
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["m" /* DashedSeparator */], null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CompanyNameField, null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["u" /* CageField */], {
            name: __WEBPACK_IMPORTED_MODULE_9__parts_constants__["_10" /* CAGE */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_9__parts_constants__["_10" /* CAGE */])
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["m" /* DashedSeparator */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["p" /* PhoneNumberField */], {
            name: __WEBPACK_IMPORTED_MODULE_13__constants__["R" /* PHONE */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["R" /* PHONE */])
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["p" /* PhoneNumberField */], {
            name: __WEBPACK_IMPORTED_MODULE_16__constants__["_17" /* FAX */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_16__constants__["_17" /* FAX */])
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
          { md: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_16__constants__["e" /* WEBSITE */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_16__constants__["e" /* WEBSITE */])
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_9__parts_constants__["_16" /* IMPORTANT_MEMO */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_9__parts_constants__["_16" /* IMPORTANT_MEMO */])
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_9__parts_constants__["_17" /* CLASSIFIED_MEMO */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_9__parts_constants__["_17" /* CLASSIFIED_MEMO */])
          })
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { onSubmit: __WEBPACK_IMPORTED_MODULE_3__actions__["o" /* update */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: "editCompany",
  validate: __WEBPACK_IMPORTED_MODULE_15__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 2027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditCompany__ = __webpack_require__(2025);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EditCompany__["a"]; });



/***/ }),
/* 2028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;



function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate("name").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 2029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["j" /* createNew */])(function (open, close) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["c" /* CreateCompany */], { open: open, close: close });
}));

/***/ }),
/* 2030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Table__ = __webpack_require__(2032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__NewCompany__ = __webpack_require__(2029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(458);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }























var defaultFilters = {
  companies_with_fleet: undefined,
  demerits_past_24_months: undefined,
  repair_station_status: undefined,
  status: undefined,
  do_not_exchange: undefined,
  do_not_quote: undefined,
  blanket_exchange_agreement: undefined,
  search_billing_address: undefined
};

var companyTypeFilters = Object.keys(__WEBPACK_IMPORTED_MODULE_8__constants__["F" /* COMPANY_TYPES */]).map(function (k) {
  return {
    label: __WEBPACK_IMPORTED_MODULE_8__constants__["F" /* COMPANY_TYPES */][k].label,
    filters: { company_type: k }
  };
});

var filters = [{
  label: "Active Demerits",
  filters: { demerits_past_24_months: true }
}, {
  label: "Blanket Exch Agreement",
  filters: { blanket_exchange_agreement: true }
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* NO_BIZ */]),
  filters: { status: __WEBPACK_IMPORTED_MODULE_8__constants__["b" /* NO_BIZ */] }
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_3" /* OUT_OF_BIZ */]),
  filters: { status: __WEBPACK_IMPORTED_MODULE_8__constants__["_3" /* OUT_OF_BIZ */] }
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["c" /* ACTIVE */]),
  filters: { status: __WEBPACK_IMPORTED_MODULE_8__constants__["c" /* ACTIVE */] }
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_2" /* OBSOLETE */]),
  filters: { status: __WEBPACK_IMPORTED_MODULE_8__constants__["_2" /* OBSOLETE */] }
}, {
  label: "Do Not Exchange",
  filters: { do_not_exchange: true }
}, {
  label: "Do Not Quote",
  filters: { do_not_quote: true }
}, {
  label: "Credit Hold",
  filters: { status: __WEBPACK_IMPORTED_MODULE_8__constants__["d" /* CREDIT_HOLD */] }
}, {
  label: "Repair Stations w/ Manager Consent Needed",
  filters: {
    repair_station_status: __WEBPACK_IMPORTED_MODULE_8__constants__["o" /* MANAGER_CONSENT_NEEDED */]
  }
}, {
  label: "Show Companies With Fleet",
  filters: { companies_with_fleet: true },
  hr: true
}, {
  label: __WEBPACK_IMPORTED_MODULE_13__constants__["_37" /* CLEAR_FILTERS_TEXT */],
  filters: defaultFilters
}];

var filterTags = [{
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["d" /* CREDIT_HOLD */]),
  key: __WEBPACK_IMPORTED_MODULE_8__constants__["_6" /* STATUS */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_8__constants__["d" /* CREDIT_HOLD */])
}, {
  label: "Active Demerits",
  key: "demerits_past_24_months",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Do Not Exchange",
  key: "do_not_exchange",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Do Not Quote",
  key: "do_not_quote",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Blanket Exch Agreement",
  key: "blanket_exchange_agreement",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* NO_BIZ */]),
  key: __WEBPACK_IMPORTED_MODULE_8__constants__["_6" /* STATUS */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* NO_BIZ */])
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_3" /* OUT_OF_BIZ */]),
  key: __WEBPACK_IMPORTED_MODULE_8__constants__["_6" /* STATUS */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_3" /* OUT_OF_BIZ */])
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["c" /* ACTIVE */]),
  key: __WEBPACK_IMPORTED_MODULE_8__constants__["_6" /* STATUS */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_8__constants__["c" /* ACTIVE */])
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_2" /* OBSOLETE */]),
  key: __WEBPACK_IMPORTED_MODULE_8__constants__["_6" /* STATUS */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_2" /* OBSOLETE */])
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["o" /* MANAGER_CONSENT_NEEDED */]),
  key: __WEBPACK_IMPORTED_MODULE_8__constants__["q" /* REPAIR_STATION_STATUS */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_8__constants__["o" /* MANAGER_CONSENT_NEEDED */])
}, {
  label: "Companies With Fleet",
  key: "companies_with_fleet"
}].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_8__constants__["F" /* COMPANY_TYPES */]).map(function (k) {
  return {
    label: __WEBPACK_IMPORTED_MODULE_8__constants__["F" /* COMPANY_TYPES */][k].label,
    key: "company_type",
    matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["b" /* matchesString */])(k)
  };
})));

var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = searchProps.paginator.get("filters").toJS();
  var totalCount = searchProps.paginator.get("totalCount");
  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__hooks_useCurrentUser__["a" /* default */])();
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__users_helpers__["e" /* hasPermission */])(currentUser, __WEBPACK_IMPORTED_MODULE_11__users_constants__["_24" /* CAN_EXPORT_COMPANIES */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__users_helpers__["e" /* hasPermission */])(currentUser, __WEBPACK_IMPORTED_MODULE_11__users_constants__["_24" /* CAN_EXPORT_COMPANIES */]) && totalCount > 475 && currentUser.role !== __WEBPACK_IMPORTED_MODULE_11__users_constants__["i" /* ADMIN */]) {
    return null;
  }

  params.total_count = totalCount;
  params.sort = "name";
  params.search_billing_address = true;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        if (totalCount > 475) {
          __WEBPACK_IMPORTED_MODULE_15_react_redux_toastr__["toastr"].info("Processing Report.");
          __WEBPACK_IMPORTED_MODULE_16__api__["a" /* default */].companies.export(params).then(function () {
            return __WEBPACK_IMPORTED_MODULE_17__lib_submission__["a" /* SUCCESS */];
          });
        } else {
          window.open(__WEBPACK_IMPORTED_MODULE_13__constants__["d" /* API_BASE */] + "/companies/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_query_string__["stringify"])(params), "_blank");
          __WEBPACK_IMPORTED_MODULE_15_react_redux_toastr__["toastr"].success("Processing Companies Report. Please wait for the PDF to generate.");
        }
      }
    },
    "Export"
  );
};

var meetsExportCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var searchProps = _ref2.searchProps;

  var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__hooks_useCurrentUser__["a" /* default */])();
  return searchProps.paginator.get("totalCount") <= 450 || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__users_helpers__["d" /* hasRole */])(user, __WEBPACK_IMPORTED_MODULE_11__users_constants__["i" /* ADMIN */]);
});

var DecoratedExportButton = meetsExportCriteria(ExportButton);

function CompaniesSearch(_ref3) {
  var pushHistory = _ref3.pushHistory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* companiesPagination */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a company name, code, contact name, contact email, city, state/province, country, region or fleet type...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/companies/" + r.uuid);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DecoratedExportButton, { searchProps: searchProps }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__["b" /* FilterSelect */], _extends({
              title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["E" /* COMPANY_TYPE */])
            }, searchProps, {
              filters: companyTypeFilters,
              right: true
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, { filters: filters, right: true })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__shared_components__["b" /* Authorized */],
              {
                subroles: [__WEBPACK_IMPORTED_MODULE_11__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]],
                roles: [__WEBPACK_IMPORTED_MODULE_11__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_11__users_constants__["m" /* ACCOUNTING */]],
                permissions: [__WEBPACK_IMPORTED_MODULE_11__users_constants__["_22" /* CAN_ADD_COMPANIES */], __WEBPACK_IMPORTED_MODULE_11__users_constants__["_23" /* CAN_UPDATE_COMPANIES */]]
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__NewCompany__["a" /* default */], null)
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "Companies",
          filters: filterTags
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

CompaniesSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(CompaniesSearch));

/***/ }),
/* 2031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["a"] = Status;
var _statusInfo;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var statusInfo = (_statusInfo = {}, _defineProperty(_statusInfo, __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* NO_BIZ */], {
  css: "label-danger",
  icon: "fa-warning",
  text: __WEBPACK_IMPORTED_MODULE_2__constants__["_1" /* COMPANY_STATUSES */][__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* NO_BIZ */]].label
}), _defineProperty(_statusInfo, __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* ACTIVE */], {
  css: "label-success",
  icon: "fa-check",
  text: __WEBPACK_IMPORTED_MODULE_2__constants__["_1" /* COMPANY_STATUSES */][__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* ACTIVE */]].label
}), _defineProperty(_statusInfo, __WEBPACK_IMPORTED_MODULE_2__constants__["_2" /* OBSOLETE */], {
  css: "label-default",
  icon: "fa-minus-circle",
  text: __WEBPACK_IMPORTED_MODULE_2__constants__["_1" /* COMPANY_STATUSES */][__WEBPACK_IMPORTED_MODULE_2__constants__["_2" /* OBSOLETE */]].label
}), _defineProperty(_statusInfo, __WEBPACK_IMPORTED_MODULE_2__constants__["_3" /* OUT_OF_BIZ */], {
  css: "label-default",
  icon: "fa-minus-circle",
  text: __WEBPACK_IMPORTED_MODULE_2__constants__["_1" /* COMPANY_STATUSES */][__WEBPACK_IMPORTED_MODULE_2__constants__["_3" /* OUT_OF_BIZ */]].label
}), _defineProperty(_statusInfo, __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* CREDIT_HOLD */], {
  css: "label-danger",
  icon: "fa-warning",
  text: __WEBPACK_IMPORTED_MODULE_2__constants__["_1" /* COMPANY_STATUSES */][__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* CREDIT_HOLD */]].label
}), _statusInfo);

function Status(_ref) {
  var status = _ref.status;

  var info = statusInfo[status];
  if (!info) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      null,
      status
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "label " + info.css },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa " + info.icon }),
    "\xA0\xA0",
    info.text
  );
}

Status.propTypes = {
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(__WEBPACK_IMPORTED_MODULE_2__constants__["_1" /* COMPANY_STATUSES */])).isRequired
};

/***/ }),
/* 2032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Status__ = __webpack_require__(2031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RepairStationStatus__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__VendorStatus__ = __webpack_require__(732);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











function renderRow(r, pushHistory) {
  var address = r.primary_physical_address;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: r.id,
      className: "clickable",
      onClick: function onClick() {
        return pushHistory("/companies/" + r.uuid);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["w" /* CompanyName */], { company: r })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      address && address.city + ", " + address.state + ", " + address.country
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Status__["a" /* default */], { status: r.status }),
      "\xA0",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__VendorStatus__["a" /* default */], { status: r.vendor_status }),
      "\xA0",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RepairStationStatus__["a" /* default */], { status: r.repair_station_status })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.region
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["truncate"])(r.fleet, 25)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.phone
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      r.demerits
    )
  );
}

function Table(_ref) {
  var results = _ref.results,
      pushHistory = _ref.pushHistory,
      isLoading = _ref.isLoading;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */],
    { loading: isLoading },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Name"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Code"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Address"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Status"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Region"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Fleet"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Company Phone"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Active Demerits"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_4__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_1_react_router_redux__["push"] })(Table));

/***/ }),
/* 2033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(2030);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });



/***/ }),
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_reducer__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__ = __webpack_require__(58);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  company: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  shippingMethods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  relatedCompanies: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  physicalAddresses: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()
}).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["a" /* notesInitialState */]).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["b" /* attachmentsInitialState */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _extends(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* SET */], function (state, action) {
  return state.merge({ company: action.company });
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["c" /* createAttachmentReducer */])(__WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].company), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["d" /* createNoteReducer */])(__WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].company))));

/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_RestrictedContactWarning__ = __webpack_require__(461);
/* harmony export (immutable) */ __webpack_exports__["a"] = CreateCompany;











function CreateCompany(_ref) {
  var _ref$allowPortalPurch = _ref.allowPortalPurchase,
      allowPortalPurchase = _ref$allowPortalPurch === undefined ? false : _ref$allowPortalPurch,
      _ref$getFieldValue = _ref.getFieldValue,
      getFieldValue = _ref$getFieldValue === undefined ? function () {} : _ref$getFieldValue,
      handleEmail = _ref.handleEmail;

  var requireContact = !allowPortalPurchase || allowPortalPurchase && !getFieldValue([__WEBPACK_IMPORTED_MODULE_8__constants__["i" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_7__constants__["e" /* WEBSITE */]].join(".")) || [__WEBPACK_IMPORTED_MODULE_8__constants__["S" /* NAME */], __WEBPACK_IMPORTED_MODULE_8__constants__["T" /* EMAIL */]].some(function (f) {
    return !!getFieldValue([__WEBPACK_IMPORTED_MODULE_7__constants__["g" /* CONTACT */], f].join("."));
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
        { md: 5 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
          name: "company.name",
          component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["d" /* FormInput */],
          label: "Company Name",
          required: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
          name: "company.website",
          component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["d" /* FormInput */],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__constants__["e" /* WEBSITE */])
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "contact.name",
            component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["d" /* FormInput */],
            label: "Contact Name",
            required: requireContact
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "contact.email",
            component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["d" /* FormInput */],
            label: "Contact Email",
            onChange: function onChange(e) {
              return handleEmail(e.target.value);
            },
            required: requireContact
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["p" /* PhoneNumberField */], {
          name: "contact.phone1",
          component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["d" /* FormInput */],
          label: "Phone Number 1",
          type: "tel"
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_RestrictedContactWarning__["a" /* default */], {
        contact: getFieldValue([__WEBPACK_IMPORTED_MODULE_7__constants__["g" /* CONTACT */], __WEBPACK_IMPORTED_MODULE_8__constants__["S" /* NAME */]].join("."))
      })
    )
  );
}

CreateCompany.propTypes = {
  allowPortalPurchase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getFieldValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  handleEmail: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

/***/ }),
/* 2036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_AutoComplete_AutoComplete__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* unused harmony export SearchCompanyName */








function SearchCompanyName(_ref) {
  var autoFocus = _ref.autoFocus,
      search = _ref.search,
      onSelect = _ref.onSelect,
      selectedCompany = _ref.selectedCompany,
      company = _ref.company,
      _ref$company_id = _ref.company_id,
      _ref$company_id$meta = _ref$company_id.meta,
      touched = _ref$company_id$meta.touched,
      error = _ref$company_id$meta.error,
      invalid = _ref$company_id$meta.invalid,
      value = _ref$company_id.input.value,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? "default" : _ref$type,
      disabled = _ref.disabled;

  var errors = touched && invalid && error.map(function (m) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "help-block", key: m },
      m
    );
  });

  var classes = __WEBPACK_IMPORTED_MODULE_5_classnames___default()({
    "has-error": touched && invalid
  });

  var companyLabels = {
    default: "Vendor",
    outgoingQuote: "Customer",
    repairOrder: "Repair Station",
    salesOrder: "Customer"
  };

  var label = companyLabels[type];
  var tooltipContext = type === "repairOrder" ? "repair" : "standard";

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: classes },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { className: "control-label", htmlFor: "company_id" },
      label,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "sup",
        { className: "small text-danger" },
        "*"
      ),
      company && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        "\xA0\xA0",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["g" /* CompanyStatsTooltip */], { company: company, context: tooltipContext })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_AutoComplete_AutoComplete__["a" /* default */], {
      autoFocus: autoFocus,
      key: "autoCompleteCompany",
      value: selectedCompany ? selectedCompany.name : "",
      hasId: value,
      search: search,
      onSelect: onSelect,
      format: function format(result) {
        return result.name;
      },
      placeholder: "Search by typing a company's name or code",
      disabled: disabled
    }),
    errors
  );
}

SearchCompanyName.propTypes = {
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  company_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    search: function search(filter) {
      var search = ownProps.companySearch || __WEBPACK_IMPORTED_MODULE_3__parts_actions__["d" /* searchCompanies */];
      return dispatch(search()(filter));
    }
  };
})(SearchCompanyName));

/***/ }),
/* 2037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_AutoComplete_AutoComplete__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var SearchCompanyName = function (_React$Component) {
  _inherits(SearchCompanyName, _React$Component);

  function SearchCompanyName() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchCompanyName);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchCompanyName.__proto__ || Object.getPrototypeOf(SearchCompanyName)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedCompany: {}
    }, _this.setCompany = function () {
      return _this.setState({ selectedCompany: _this.props.company });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchCompanyName, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.company) this.setCompany();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          search = _props.search,
          _props$meta = _props.meta,
          touched = _props$meta.touched,
          error = _props$meta.error,
          invalid = _props$meta.invalid,
          _props$input = _props.input,
          value = _props$input.value,
          onChange = _props$input.onChange,
          onBlur = _props$input.onBlur,
          _props$type = _props.type,
          type = _props$type === undefined ? "default" : _props$type;
      var selectedCompany = this.state.selectedCompany;


      var handleCompanySelected = function handleCompanySelected(result) {
        var id = result ? result.id : null;
        onChange(id);
        onBlur(id);

        _this2.setState({ selectedCompany: result });
      };

      var errors = touched && invalid && error.map(function (m) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "help-block", key: m },
          m
        );
      });

      var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
        "has-error": touched && invalid
      });

      var companyLabels = {
        default: "Vendor",
        outgoingQuote: "Customer",
        repairOrder: "Repair Station",
        salesOrder: "Customer"
      };

      var label = companyLabels[type];
      var tooltipContext = type === "repairOrder" ? "repair" : "standard";

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: classes },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "company_id" },
          label,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "sup",
            { className: "small text-danger" },
            "*"
          ),
          selectedCompany && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
            null,
            "\xA0\xA0",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["g" /* CompanyStatsTooltip */], {
              company: selectedCompany,
              context: tooltipContext
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_AutoComplete_AutoComplete__["a" /* default */], {
          key: "autoCompleteCompany",
          value: selectedCompany ? selectedCompany.name : "",
          hasId: value,
          search: search,
          onSelect: handleCompanySelected,
          format: function format(result) {
            return result.name;
          },
          placeholder: "Search by typing a company's name or code"
        }),
        errors
      );
    }
  }]);

  return SearchCompanyName;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SearchCompanyName.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  meta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    search: function search(filter) {
      var search = ownProps.companySearch || __WEBPACK_IMPORTED_MODULE_4__parts_actions__["h" /* searchQuoteCompanies */];
      return dispatch(search()(filter));
    }
  };
})(SearchCompanyName));

/***/ }),
/* 2038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchCompany__ = __webpack_require__(2037);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SearchCompany__["a"]; });



/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony export (immutable) */ __webpack_exports__["a"] = DoNotQuoteWarning;





function DoNotQuoteWarning(_ref) {
  var company = _ref.company;

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(company, "do_not_quote")) return null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Company ",
    company.name,
    " is flagged as rarely buying from us. Please ask them to Make Offer if interested."
  );
}

DoNotQuoteWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    do_not_quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.boolean
  })
};

/***/ }),
/* 2040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["a"] = MissingFieldsWarning;






function MissingFieldsWarning(_ref) {
  var company = _ref.company,
      contact = _ref.contact,
      getFieldValue = _ref.getFieldValue;

  if (!company || !company.id) return null;

  var missing = [];

  var phoneValue = getFieldValue(__WEBPACK_IMPORTED_MODULE_3__constants__["R" /* PHONE */]) || company.phone;
  if (!phoneValue) {
    missing.push("phone number");
  }

  var contactName = contact && contact.name || getFieldValue("contact.name");
  if (!contactName) {
    missing.push("contact name");
  }

  var contactEmail = contact && contact.email || getFieldValue("contact.email");
  if (!contactEmail) {
    missing.push("contact email");
  }

  var line1 = getFieldValue(__WEBPACK_IMPORTED_MODULE_4__constants__["w" /* BILLING_ADDRESS */] + "." + __WEBPACK_IMPORTED_MODULE_3__constants__["s" /* LINE1 */]) || company.billing_address && company.billing_address.line1;
  var city = getFieldValue(__WEBPACK_IMPORTED_MODULE_4__constants__["w" /* BILLING_ADDRESS */] + "." + __WEBPACK_IMPORTED_MODULE_3__constants__["u" /* CITY */]) || company.billing_address && company.billing_address.city;
  var state = getFieldValue(__WEBPACK_IMPORTED_MODULE_4__constants__["w" /* BILLING_ADDRESS */] + "." + __WEBPACK_IMPORTED_MODULE_3__constants__["v" /* STATE */]) || company.billing_address && company.billing_address.state;
  var postalCode = getFieldValue(__WEBPACK_IMPORTED_MODULE_4__constants__["w" /* BILLING_ADDRESS */] + "." + __WEBPACK_IMPORTED_MODULE_3__constants__["w" /* POSTAL_CODE */]) || company.billing_address && company.billing_address.postal_code;
  var country = getFieldValue(__WEBPACK_IMPORTED_MODULE_4__constants__["w" /* BILLING_ADDRESS */] + "." + __WEBPACK_IMPORTED_MODULE_3__constants__["r" /* COUNTRY */]) || company.billing_address && company.billing_address.country;

  if (!line1 || !city || !state || !postalCode || !country) {
    missing.push("complete billing address");
  }

  // If nothing is missing, do not display a warning
  if (!missing.length) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Customer is missing the following required field(s): ",
    missing.join(", "),
    "."
  );
}

MissingFieldsWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  contact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CostAdjustmentForm__ = __webpack_require__(2042);
/* harmony export (immutable) */ __webpack_exports__["a"] = AddCostAdjustment;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();







function AddCostAdjustment(_ref) {
  var open = _ref.open,
      close = _ref.close,
      inventory = _ref.inventory;

  var initialValues = {
    id: inventory.id,
    after_internal_outright: false
  };

  var internalOutrightId = inventory.internal_outright_sales_item_id;
  var mostRecentSalesItemId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(inventory, "most_recent_sales_order_line_item.id");

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(!internalOutrightId || internalOutrightId !== mostRecentSalesItemId),
      _useState2 = _slicedToArray(_useState, 2),
      askedInternalOutright = _useState2[0],
      setAskedInternalOutright = _useState2[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Adjust Inventory Cost"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CostAdjustmentForm__["a" /* default */], {
      askedInternalOutright: askedInternalOutright,
      setAskedInternalOutright: setAskedInternalOutright,
      close: close,
      initialValues: initialValues,
      inventory: inventory,
      enableReinitialize: true
    })
  );
}

AddCostAdjustment.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

/***/ }),
/* 2042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__validate__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_Warning_Warning__ = __webpack_require__(53);
/* unused harmony export AskIfAfterInternalOutright */
/* unused harmony export CostAdjustmentForm */















function toOptions(map) {
  var textField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "label";

  return Object.keys(map).map(function (t) {
    var text = textField ? map[t][textField] : map[t];
    if (typeof text === "function") {
      return { value: t, text: text() };
    }

    return { value: t, text: text };
  });
}

var CostAdjustmentFields = function CostAdjustmentFields(_ref) {
  var costAdjustedTotal = _ref.costAdjustedTotal,
      adjustmentType = _ref.adjustmentType,
      adjustment = _ref.adjustment,
      totalCost = _ref.totalCost,
      negative = _ref.negative;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_12__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
        { md: 7 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: "adjustment_type",
          component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
          options: toOptions(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_removeKey__["b" /* removeKeys */])(__WEBPACK_IMPORTED_MODULE_10__constants__["_77" /* COST_ADJUSTMENT_OPTIONS */], ["neg_warranty_non_reimbursed", "pos_lot_cost", "neg_lot_cost"])),
          label: "Adjustment Type",
          required: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
        { md: 5 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], { name: "adjustment", label: "Cost Adjustment", required: true })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h5",
      { className: "h3 text-left" },
      "Preview: ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(totalCost),
      " ",
      negative ? "-" : "+",
      " ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(adjustment || 0),
      " = \xA0",
      adjustmentType && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(costAdjustedTotal)
    )
  );
};

CostAdjustmentFields.propTypes = {
  costAdjustedTotal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  adjustmentType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  adjustment: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  totalCost: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  negative: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

function AskIfAfterInternalOutright(props) {
  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_13__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Please confirm if this charge that is associated to this record should be applied as new cost (After Internal Outright) or as old cost (Before Internal Outright)"
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group", style: { marginLeft: 10 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        className: "btn btn-default",
        type: "button",
        onClick: function onClick() {
          props.change("after_internal_outright", true);
          props.setAskedInternalOutright(true);
        }
      },
      "After Internal Outright"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        className: "btn btn-primary",
        type: "button",
        onClick: function onClick() {
          return props.setAskedInternalOutright(true);
        }
      },
      "Before Internal Outright"
    )
  )];
}

function CostAdjustmentForm(props) {
  var inventory = props.inventory,
      adjustment = props.adjustment,
      adjustmentType = props.adjustmentType;

  var totalCost = inventory.total_cost || 0;
  var negative = adjustmentType && adjustmentType.startsWith("neg_");
  var costAdjustedTotal = negative ? totalCost - adjustment || 0 : parseFloat(totalCost) + parseFloat(adjustment) || 0;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Body,
      null,
      props.askedInternalOutright ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CostAdjustmentFields, {
        costAdjustedTotal: costAdjustedTotal,
        adjustmentType: adjustmentType,
        adjustment: adjustment,
        totalCost: totalCost,
        negative: negative
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AskIfAfterInternalOutright, props)
    ),
    !props.askedInternalOutright && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null)
  );
}

CostAdjustmentForm.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  adjustment: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  adjustmentType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  askedInternalOutright: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  setAskedInternalOutright: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])("addCostAdjustment");

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    adjustment: selector(state, "adjustment"),
    adjustmentType: selector(state, "adjustment_type")
  };
}, function (dispatch) {
  return {
    queryUsers: function queryUsers(filter) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__users_actions__["h" /* searchUsers */])(filter));
    },
    onSubmit: function onSubmit(data, _, props) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_5__actions__["B" /* addCostAdjustment */](data, props));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["j" /* form */])({
  form: "addCostAdjustment",
  validate: __WEBPACK_IMPORTED_MODULE_11__validate__["a" /* default */]
})(CostAdjustmentForm)));

/***/ }),
/* 2043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;



function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate("adjustment_type").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    v.validate("adjustment").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 2044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(12);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var AuditTrailTable = function (_Component) {
  _inherits(AuditTrailTable, _Component);

  function AuditTrailTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AuditTrailTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AuditTrailTable.__proto__ || Object.getPrototypeOf(AuditTrailTable)).call.apply(_ref, [this].concat(args))), _this), _this.renderRow = function (r, idx) {
      var capitalize = Object.keys(__WEBPACK_IMPORTED_MODULE_4__constants__["_82" /* TAG_TYPES */]).includes(r.action);
      var action = r.action.replace("_uuid", "").replace("_id", "");
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: idx },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__["b" /* shortDate */])(r.created_at)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__["j" /* timeStamp */])(r.created_at)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          capitalize ? action.toUpperCase() : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])(action)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.created_by && r.created_by.full_name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])(r.previous_value)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])(r.new_value)
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AuditTrailTable, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          null,
          "Audit Trail"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "table",
          { className: "table table-striped table-hover margin-bottom-none" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Date"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Time"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Action"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Action By"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Previous Value"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "New Value"
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tbody",
            null,
            this.props.auditTrails.map(this.renderRow)
          )
        )
      );
    }
  }]);

  return AuditTrailTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AuditTrailTable.propTypes = {
  auditTrails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)).isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (AuditTrailTable);

/***/ }),
/* 2045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_decorators_loadRecord__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_Attachments_Attachments__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shared_components_Authorized__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__shared_components_InventoryStatusCell__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__helpers__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__PurchaseDetails__ = __webpack_require__(2106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__shared_components_NoteTooltip_AuditedNoteTooltip__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__AuditTrailTable_AuditTrailTable__ = __webpack_require__(2044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__CostAdjustmentTable_CostAdjustmentTable__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Dummies_Table__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__InventoryStatusLabel__ = __webpack_require__(2103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__AddCostAdjustment_AddCostAdjustment__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ScrapReportStatusLabel__ = __webpack_require__(2107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ListingOverrideLabel__ = __webpack_require__(2104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Header__ = __webpack_require__(2102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__EditInventory__ = __webpack_require__(2111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__RecentOrderRow__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__CreateCommercialInvoice__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Warnings__ = __webpack_require__(246);
/* unused harmony export Detail */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











































var lockedStatuses = [__WEBPACK_IMPORTED_MODULE_16__constants__["V" /* RESERVE_FOR_SALE */], __WEBPACK_IMPORTED_MODULE_16__constants__["_34" /* ON_ORDER_FOR_SALE */], __WEBPACK_IMPORTED_MODULE_16__constants__["_30" /* SALES_ORDER_CREATED */]];

var ModToDetails = function ModToDetails(_ref) {
  var part = _ref.part,
      modTo = _ref.modTo;

  if (!modTo || modTo && modTo.id === part.id) {
    return null;
  }

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], { label: "Mod To", value: modTo.part_number }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_DetailTable__["b" /* Detail */], { label: "Mod From", value: part.part_number })];
};

var LocationCol = function LocationCol(_ref2) {
  var inventory = _ref2.inventory;

  if (inventory.location === "At Shop" && inventory.repair_order_tagged_by) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
      {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        to: "/repair-orders/" + inventory.most_recent_repair_order.uuid
      },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["e" /* truncate */])("" + inventory.repair_order_tagged_by.name, 25)
    );
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["e" /* truncate */])(inventory.location, 12);
};

var ConsignmentSection = function ConsignmentSection(_ref3) {
  var inventory = _ref3.inventory;

  if (!inventory.consignment_reference) return null;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-condensed" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
        label: "Consignment Ref. Co",
        value: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "consignment_reference_company.name")
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
        label: "Consignment Ref #",
        value: inventory.consignment ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
          { to: "/consignments/" + inventory.consignment.uuid },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            null,
            inventory.consignment_reference
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          inventory.consignment_reference
        )
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
        label: "Consignment Split",
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__lib_formatters_number__["a" /* percent */])(inventory.consignor_percentage, 100)
      })
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" })];
};

var Detail = function (_React$Component) {
  _inherits(Detail, _React$Component);

  function Detail() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, Detail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = Detail.__proto__ || Object.getPrototypeOf(Detail)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      costAdjustmentModalOpen: false,
      createDummyModalOpen: false,
      editInventoryModalOpen: false,
      initialPartFormValues: {},
      commercialInvoiceModalOpen: false
    }, _this.open = function () {
      _this.setState({ commercialInvoiceModalOpen: true });
    }, _this.closeCommercialInvoiceModal = function () {
      _this.setState({ commercialInvoiceModalOpen: false });
      _this.props.reset();
    }, _this.openCostAdjustmentModal = function () {
      return _this.setState({ costAdjustmentModalOpen: true });
    }, _this.closeCostAdjustmentModal = function () {
      return _this.setState({ costAdjustmentModalOpen: false });
    }, _this.openEditInventoryModal = function () {
      return _this.setState({ editInventoryModalOpen: true });
    }, _this.closeEditInventoryModal = function () {
      return _this.setState({ editInventoryModalOpen: false });
    }, _this.scrapReportSection = function (inventory) {
      if (!inventory.scrap_report) return null;

      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: "scrap-report-status" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Scrap Report Status"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__ScrapReportStatusLabel__["a" /* default */], {
            scrapReportStatus: inventory.scrap_report_received
          })
        )
      ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: "download-link" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "Scrap Report"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          inventory.scrap_report && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__shared_components__["r" /* ExternalLink */],
            { url: inventory.scrap_report },
            "Download Report"
          )
        )
      )];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Detail, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref5) {
      var displayCommercialInvoiceModal = _ref5.displayCommercialInvoiceModal;

      if (displayCommercialInvoiceModal) {
        this.setState({ commercialInvoiceModalOpen: true });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var inventory = this.props.inventory.toJS();
      var partOfExchange = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "most_recent_sales_order_line_item.exchange_sale");
      var _state = this.state,
          costAdjustmentModalOpen = _state.costAdjustmentModalOpen,
          editInventoryModalOpen = _state.editInventoryModalOpen,
          commercialInvoiceModalOpen = _state.commercialInvoiceModalOpen;
      var currentUser = this.props.currentUser;


      var lockInventory = lockedStatuses.includes(inventory.status) && !partOfExchange;
      var inventoryLocked = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__users_helpers__["h" /* disableIfHasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_17__users_constants__["j" /* WAREHOUSE */]]) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__users_helpers__["g" /* hasSubRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_17__users_constants__["t" /* WAREHOUSE_EXPERT */]) && (!inventory || lockInventory);

      var tagTypes = Object.keys(__WEBPACK_IMPORTED_MODULE_16__constants__["_82" /* TAG_TYPES */]).filter(function (t) {
        return inventory[t];
      }).map(function (t) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "badge", style: { marginRight: "5px" } },
          __WEBPACK_IMPORTED_MODULE_16__constants__["_82" /* TAG_TYPES */][t].label.toUpperCase()
        );
      }).concat(inventory.other_tag_type ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "badge", style: { marginRight: "5px" } },
        inventory.other_tag_type.toUpperCase()
      ) : []);

      var flagTypes = Object.keys(__WEBPACK_IMPORTED_MODULE_16__constants__["_1" /* FLAG_TYPES */]).filter(function (t) {
        return inventory[t];
      }).map(function (t) {
        return [__WEBPACK_IMPORTED_MODULE_16__constants__["_1" /* FLAG_TYPES */][t].label, __WEBPACK_IMPORTED_MODULE_16__constants__["_1" /* FLAG_TYPES */][t].subLabel && __WEBPACK_IMPORTED_MODULE_16__constants__["_1" /* FLAG_TYPES */][t].subLabel(inventory)].filter(function (f) {
          return f;
        }).join(" - ");
      }).join(", ");

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__CreateCommercialInvoice__["a" /* default */], {
          inventory: this.props.inventory,
          close: this.closeCommercialInvoiceModal,
          editing: commercialInvoiceModalOpen
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__Header__["a" /* default */], {
          inventory: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])(inventory),
          inventoryLocked: inventoryLocked
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_21_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                className: "panel panel-default " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__shared_components_InventoryStatusCell__["b" /* getSellableClass */])(inventory) + "-top"
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "panel-body" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h2",
                  { style: { marginTop: 10 } },
                  "Inventory Details",
                  !inventoryLocked && !(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__users_helpers__["g" /* hasSubRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_17__users_constants__["r" /* WAREHOUSE_BASIC */]) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__users_helpers__["e" /* hasPermission */])(currentUser, __WEBPACK_IMPORTED_MODULE_17__users_constants__["_25" /* CAN_OVERRIDE_LISTING */])) && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["y" /* EditButton */], {
                    key: "edit-inventory-button",
                    handleClick: this.openEditInventoryModal
                  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__EditInventory__["a" /* default */], {
                    key: "inventory-edit-modal",
                    open: editInventoryModalOpen,
                    close: this.closeEditInventoryModal,
                    inventory: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])(inventory),
                    lockInventory: lockInventory
                  })]
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-condensed" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tbody",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tr",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "th",
                        { className: "text-right" },
                        "Part #"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["h" /* PartNumber */], { part: inventory.part })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Serial #",
                      value: inventory.serial_number
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Prev. Exch'd SN",
                      value: inventory.exchange_serial_number,
                      renderIfPresent: true
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      value: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "assigned_core_return.serial_number") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
                        {
                          to: "/inventories/" + __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "assigned_core_return.uuid")
                        },
                        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "assigned_core_return.serial_number")
                      ),
                      label: "Core Return SN",
                      renderIfPresent: true
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tr",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "th",
                        { className: "text-right" },
                        "INV Status"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__InventoryStatusLabel__["a" /* default */], { inventory: inventory })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tr",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "th",
                        { className: "text-right" },
                        "Listing Override"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__ListingOverrideLabel__["a" /* default */], {
                          status: inventory.listing_override
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "CD",
                      value: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_16__constants__["r" /* INVENTORIES */], "condition." + inventory.condition + ".label")
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "QTY",
                      value: inventory.total_quantity
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Total Hours",
                      value: inventory.total_hours,
                      renderIfPresent: true
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Total Hours Remaining",
                      value: inventory.total_hours && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__helpers__["a" /* totalHoursRemaining */])(inventory.part, inventory.total_hours),
                      renderIfPresent: true
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Total Cycles",
                      value: inventory.total_cycles,
                      renderIfPresent: true
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Total Cycles Remaining",
                      value: inventory.total_cycles && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__helpers__["b" /* totalCyclesRemaining */])(inventory.part, inventory.total_cycles),
                      renderIfPresent: true
                    })
                  )
                ),
                inventory.active_transfer && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-condensed" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tbody",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Transfer QTY Shipped",
                      value: inventory.active_transfer.quantity_shipped
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Transfer QTY Received",
                      value: inventory.active_transfer.quantity_received
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Transfer Outbound AWB #",
                      value: inventory.active_transfer.latest_awb_number
                    })
                  )
                )],
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-condensed" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tbody",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Buyer Credit",
                      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__lib_formatters_number__["a" /* percent */])(parseFloat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "buyer_credit_pct")), 100)
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Buyer",
                      value: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "buyer.full_name")
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Co-Buyer",
                      value: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "co_buyer.full_name")
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Third Buyer",
                      value: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "third_buyer.full_name")
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-condensed" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tbody",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "SRP",
                      value: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_currency__["a" /* dollars */])(inventory.suggested_retail), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], {
                        field: __WEBPACK_IMPORTED_MODULE_16__constants__["v" /* SUGGESTED_RETAIL */],
                        obj: inventory
                      })]
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "SRP CD",
                      value: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_16__constants__["r" /* INVENTORIES */], "condition." + inventory.srp_condition + ".label")
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Exch. SRP",
                      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_currency__["a" /* dollars */])(inventory.exchange_srp)
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Cost",
                      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_currency__["a" /* dollars */])(inventory.total_cost)
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      renderIfPresent: true,
                      label: "Consignor Cost",
                      value: Number(inventory.consignor_cost) > 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_formatters_currency__["a" /* dollars */])(inventory.consignor_cost) : null
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Final Freight Conf",
                      value: inventory.freight_complete ? "Yes" : "No"
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], { label: "Flags", value: flagTypes }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Warranty Override",
                      value: inventory.warranty_override
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__Warnings__["c" /* CostWarning */], { inventory: inventory }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-condensed" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tbody",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Tag Date",
                      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_date__["g" /* monthYear */])(inventory.tag_date)
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tr",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "th",
                        { className: "text-right" },
                        "Tagged By"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__helpers__["c" /* inventoryTaggedBy */])(inventory)
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Trace To",
                      value: inventory.traced_to
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tr",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "th",
                        { className: "text-right" },
                        "Trace Type"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_19__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */], "traceTypes." + inventory.trace_type + ".label")
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], { label: "Tag Types", value: tagTypes }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModToDetails, {
                      part: inventory.part,
                      modTo: inventory.mod_to
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-condensed" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tbody",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Store Owner",
                      value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["o" /* LocationFlag */], {
                        location: inventory.store_owner_id,
                        consignment_type: inventory.consignment_type,
                        inventory: inventory
                      })
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Store Loc",
                      value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["o" /* LocationFlag */], { location: inventory.store_location_id })
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Loc",
                      value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LocationCol, { inventory: inventory })
                    }),
                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "ware_house.name") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Warehouse",
                      value: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "ware_house.name")
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-condensed" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tbody",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "DOM",
                      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_date__["h" /* monthFullYear */])(inventory.dom)
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Exp",
                      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_date__["b" /* shortDate */])(inventory.expiration)
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConsignmentSection, { inventory: inventory }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-condensed" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tbody",
                    null,
                    this.scrapReportSection(inventory),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tr",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "th",
                        { className: "text-right" },
                        "Received Date"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_date__["b" /* shortDate */])(inventory.date_received)
                      )
                    ),
                    inventory.receiving_records.map(function (recRecord) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "tr",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "th",
                          { className: "text-right" },
                          "Receiving #"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "td",
                          null,
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
                            { to: "/receiving/" + recRecord.uuid },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              "span",
                              null,
                              recRecord.code
                            )
                          ),
                          recRecord.discrepancies.length > 0 && recRecord.discrepancies.some(function (r) {
                            return !r.resolved;
                          }) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            "span",
                            {
                              className: "label label-danger",
                              style: { marginLeft: "5px" }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["j" /* NoteTooltip */], {
                              icon: "fa-warning",
                              color: "rgba(255, 255, 255, 1)",
                              note: "Open Discrepancy",
                              placement: "top"
                            })
                          )
                        )
                      );
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-condensed" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tbody",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__PurchaseDetails__["a" /* default */], { inventory: inventory }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__RecentOrderRow__["a" /* default */], {
                      record: inventory,
                      type: "most_recent_repair_order",
                      title: "Recent RO#",
                      rootLink: "repair-orders"
                    }),
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_removeKey__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_16__constants__["_83" /* CURRENTLY_REPAIRING_STATUSES */], __WEBPACK_IMPORTED_MODULE_16__constants__["a" /* RESERVE_FOR_REPAIR */])[inventory.repair_status] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Repair Station",
                      value: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "most_recent_repair_order.company.name")
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Recent SO #",
                      value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
                        {
                          to: "/sales-orders/" + __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "most_recent_sales_order.uuid", __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "most_recent_customer_rma.exchange_details.sales_order.id", __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "split_rma_inventory_details.most_recent_sales_order_line_item.parent_id")))
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "span",
                          null,
                          __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "most_recent_sales_order.code", __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "most_recent_customer_rma.exchange_details.sales_order.code", __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(inventory, "split_rma_inventory_details.most_recent_sales_order_line_item.code")))
                        )
                      )
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__RecentOrderRow__["a" /* default */], {
                      record: inventory,
                      type: "most_recent_managed_repair_order",
                      title: "Recent MR#",
                      rootLink: "managed-repair-orders"
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__RecentOrderRow__["a" /* default */], {
                      record: inventory,
                      type: "most_recent_cancelled_sales_order",
                      title: "Cancelled SO#",
                      rootLink: "sales-orders"
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__RecentOrderRow__["a" /* default */], {
                      record: inventory,
                      type: "most_recent_vendor_rma",
                      title: "Recent Vendor RMA#",
                      rootLink: "rmas"
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__RecentOrderRow__["a" /* default */], {
                      record: inventory,
                      type: "most_recent_customer_rma",
                      rootLink: "rmas",
                      title: "Recent Cust. RMA#"
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-condensed" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tbody",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_DetailTable_Detail__["a" /* default */], {
                      label: "Split",
                      value: inventory.split_from_inventory_id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
                        {
                          to: "/inventories/" + inventory.split_from_inventory_id
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "span",
                          null,
                          "Yes"
                        )
                      ) : "No"
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["z" /* AuditFields */], { record: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])(inventory), multiLine: true })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_21_react_bootstrap__["e" /* Col */],
            { md: 9 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              { style: { marginTop: 26 } },
              "Cost Adjustments",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_18__shared_components_Authorized__["a" /* default */],
                { roles: [__WEBPACK_IMPORTED_MODULE_17__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_17__users_constants__["p" /* QUALITY_CONTROL */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "button",
                  {
                    key: "cost-adjustment",
                    type: "button",
                    className: "btn btn-primary btn-hollow pull-right",
                    onClick: this.openCostAdjustmentModal
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "i",
                    { className: "fa fa-fw fa-plus" },
                    "\xA0"
                  ),
                  "Add Cost Adjustment"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__AddCostAdjustment_AddCostAdjustment__["a" /* default */], {
                  key: "add-cost-adjustment-modal",
                  close: this.closeCostAdjustmentModal,
                  open: costAdjustmentModalOpen,
                  inventory: inventory
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__CostAdjustmentTable_CostAdjustmentTable__["a" /* default */], {
              costAdjustments: inventory.cost_adjustments,
              inventory: inventory
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["M" /* Notes */], {
              resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])(inventory),
              resourceType: __WEBPACK_IMPORTED_MODULE_12__shared_types_resourceTypes__["a" /* default */].inventory,
              resourceKey: "inventory"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["N" /* Attachments */], {
              title: "Inventory Attachments",
              multiple: true,
              resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])(inventory),
              resourceType: __WEBPACK_IMPORTED_MODULE_12__shared_types_resourceTypes__["a" /* default */].inventory,
              resourceKey: "inventory",
              attachmentTypes: __WEBPACK_IMPORTED_MODULE_16__constants__["Z" /* ATTACHMENT_TYPES */],
              isInventory: true
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_Attachments_Attachments__["b" /* Attachments */], {
              attachments: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])(inventory.receiving_attachments),
              attachmentTypes: __WEBPACK_IMPORTED_MODULE_11__Receiving_constants__["y" /* ATTACHMENT_TYPES */],
              multiple: true,
              title: "Receiving Attachments",
              preloaded: true,
              disabled: true
            }),
            inventory.dummy && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__Dummies_Table__["a" /* default */], { key: "dummy-table", dummy: inventory.dummy }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { key: "dummy-seperator", className: "hr-dashed" })],
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__AuditTrailTable_AuditTrailTable__["a" /* default */], { auditTrails: inventory.audit_trails })
          )
        )
      );
    }
  }]);

  return Detail;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Detail.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}),
  inventory: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"]),
  displayCommercialInvoiceModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  reset: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    inventory: state.inventoryDetail.get("inventory"),
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_17__users_constants__["a" /* USER */]).toJS(),
    displayCommercialInvoiceModal: state.inventoryDetail.getIn(["inventory", "displayCommercialInvoiceModal"])
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_decorators_loadRecord__["a" /* default */])({
  reducer: "inventoryDetail",
  name: "inventory",
  action: __WEBPACK_IMPORTED_MODULE_28__actions__["y" /* show */]
})(Detail)));

/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(86);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditDummy;






function EditDummy(_ref) {
  var open = _ref.open,
      close = _ref.close,
      dummy = _ref.dummy;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Dummy Stock"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], {
      initialValues: dummy,
      close: close,
      submitAction: __WEBPACK_IMPORTED_MODULE_4__actions__["A" /* updateDummy */],
      enableReinitialize: true
    })
  );
}

EditDummy.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  dummy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Delete__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EditDummy__ = __webpack_require__(2046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(86);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Table = function (_React$Component) {
  _inherits(Table, _React$Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editDummyModalOpen: false
    }, _this.openEditDummyModal = function () {
      return _this.setState({ editDummyModalOpen: true });
    }, _this.closeEditDummyModal = function () {
      return _this.setState({ editDummyModalOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var editDummyModalOpen = this.state.editDummyModalOpen;
      var dummy = this.props.dummy;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h2",
          { style: { marginTop: 26 } },
          "Dummy Stock"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "table",
          { className: "table table-striped table-hover margin-bottom-none" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Condition"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Quantity"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Created At"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Created By"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Updated At"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Updated By"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tbody",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              { className: "clickable", onClick: this.openEditDummyModal },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                null,
                __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* CONDITION_TYPES */][dummy.condition].label
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                null,
                dummy.quantity
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                null,
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__["b" /* shortDate */])(dummy.created_at)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                null,
                dummy.created_by && dummy.created_by.full_name
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                null,
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__["b" /* shortDate */])(dummy.updated_at)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "td",
                null,
                dummy.updated_by && dummy.updated_by.full_name
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], { note: dummy.note }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Delete__["a" /* default */], {
                primary: false,
                id: dummy.id,
                deleteAction: __WEBPACK_IMPORTED_MODULE_7__actions__["z" /* destroyDummy */]
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EditDummy__["a" /* default */], {
          dummy: dummy,
          open: editDummyModalOpen,
          close: this.closeEditDummyModal
        })
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Table);


Table.propTypes = {
  dummy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    note: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    created_at: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    updated_at: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    created_by: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    updated_by: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    })
  }).isRequired
};

/***/ }),
/* 2048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;





function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_2__constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_2__constants__["v" /* SUGGESTED_RETAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    v.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_2__constants__["v" /* SUGGESTED_RETAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0));
  });
}

/***/ }),
/* 2049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(2050);






function ApplyLotCost(_ref) {
  var editing = _ref.editing,
      close = _ref.close,
      inventory = _ref.inventory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    {
      key: inventory.get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ID */]),
      open: editing,
      close: close,
      dialogClass: "modal-sm"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Apply Lot Cost"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], { close: close, enableReinitialize: true, inventory: inventory.toJS() })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (ApplyLotCost);

ApplyLotCost.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_decorators_withFieldAccessors__ = __webpack_require__(48);











function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 4, mdOffset: 4 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["f" /* CurrencyField */], { name: __WEBPACK_IMPORTED_MODULE_5__constants__["V" /* COST */], label: "Cost EA" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h5",
          { className: "h3 text-center" },
          "Ext Cost:",
          " ",
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(props.getFieldValue(__WEBPACK_IMPORTED_MODULE_5__constants__["V" /* COST */]) * Number(props.inventory.quantity))
        )
      )
    )
  );
}

Form.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions__["w" /* applyLotCost */])(data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["j" /* form */])({
  form: "applyLotCost"
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 2051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form__ = __webpack_require__(2053);
/* harmony export (immutable) */ __webpack_exports__["a"] = AssignToExchange;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








function AssignToExchange(_ref) {
  var editing = _ref.editing,
      close = _ref.close,
      inventory = _ref.inventory;

  var partId = inventory.get(__WEBPACK_IMPORTED_MODULE_3__constants__["q" /* PART_ID */]);

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      lineItems = _useState2[0],
      setLineItems = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].purchaseOrderLineItems.assignableExchangeSearch().then(function (_ref2) {
      var data = _ref2.data;

      setLineItems(data.results);

      return function cleanup() {};
    });
  }, [partId]);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Assign As Core Return"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Form__["a" /* default */], {
      close: close,
      enableReinitialize: true,
      partId: partId,
      lineItems: lineItems
    })
  );
}

AssignToExchange.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators_withFieldAccessors__ = __webpack_require__(48);





function ExchangesTable(_ref) {
  var getFieldValue = _ref.getFieldValue,
      lineItems = _ref.lineItems,
      setFieldValue = _ref.setFieldValue;

  var FIELD = "purchase_order_line_item_id";

  var renderRow = function renderRow(lineItem, i) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      { key: i },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        i + 1
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          component: "input",
          type: "radio",
          checked: String(lineItem.id) === getFieldValue(FIELD),
          onChange: function onChange() {
            return setFieldValue(FIELD)(lineItem.id);
          },
          name: FIELD,
          className: "radio-inline",
          value: lineItem.id
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        lineItem.part.part_number
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        lineItem.purchase_order.code
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        lineItem.serial_number
      )
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-striped table-hover table-numbered" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "thead",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Part #"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Code"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Serial Number"
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      lineItems.map(renderRow)
    )
  );
}

ExchangesTable.propTypes = {
  filter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  lineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(ExchangesTable));

/***/ }),
/* 2053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ExchangesTable__ = __webpack_require__(2052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__validate__ = __webpack_require__(2054);









var ASSIGN_EXCHANGE_FORM = "assignExchange";

function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ExchangesTable__["a" /* default */], {
            partId: props.partId,
            form: ASSIGN_EXCHANGE_FORM,
            lineItems: props.lineItems
          })
        )
      )
    )
  );
}

Form.propTypes = {
  change: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inventoryQuantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  lineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}))
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["v" /* assignExchange */])(data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["j" /* form */])({
  form: ASSIGN_EXCHANGE_FORM,
  validate: __WEBPACK_IMPORTED_MODULE_7__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 2054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;




function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["_21" /* INVENTORY_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 2055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Form__ = __webpack_require__(2056);
/* harmony export (immutable) */ __webpack_exports__["a"] = CancelConsignment;









function CancelConsignment(_ref) {
  var editing = _ref.editing,
      close = _ref.close,
      inventory = _ref.inventory;

  if (inventory.getIn(["consignment_details", "cancelled"])) return null;
  if (Number(inventory.get(__WEBPACK_IMPORTED_MODULE_3__constants__["_54" /* COST_PER_UNIT */])) > 0) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components__["i" /* ConfirmAction */],
      {
        open: editing,
        close: close,
        onConfirm: close,
        showButton: false
      },
      "You must depreciate remaining cost before you cancel consignment."
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-md" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Cancel Consignment"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Form__["a" /* default */], {
      close: close,
      enableReinitialize: true,
      initialValues: {
        ship_to_company_id: inventory.get(__WEBPACK_IMPORTED_MODULE_5__Receiving_constants__["v" /* CONSIGNMENT_REFERENCE_COMPANY_ID */]),
        ship_to_type: __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* COMPANY */]
      },
      shipToCompany: inventory.get(__WEBPACK_IMPORTED_MODULE_5__Receiving_constants__["w" /* CONSIGNMENT_REFERENCE_COMPANY */]).toJS()
    })
  );
}

CancelConsignment.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Consignments_constants__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Orders_shared_ShippingFields__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__validate__ = __webpack_require__(2057);















var CANCEL_CONSIGNMENT_FORM = "cancelConsignmentForm";

function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__["H" /* CANCELLATION_REASON */],
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["c" /* Select */],
            options: __WEBPACK_IMPORTED_MODULE_8__Consignments_constants__["a" /* CANCELLATION_REASONS */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__["H" /* CANCELLATION_REASON */]),
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Orders_shared_ShippingFields__["a" /* default */], {
        formName: CANCEL_CONSIGNMENT_FORM,
        shipToCompany: props.shipToCompany,
        shippingFields: [__WEBPACK_IMPORTED_MODULE_10__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_10__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_10__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */]],
        shippingTypes: [__WEBPACK_IMPORTED_MODULE_11__companies_constants__["p" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__["L" /* DROPSHIP */]],
        shippingMethod: __WEBPACK_IMPORTED_MODULE_10__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */],
        shippingAddressField: __WEBPACK_IMPORTED_MODULE_10__constants__["_17" /* SHIP_TO_SHIPPING_ADDRESS */],
        required: false,
        hasLocations: false
      })
    )
  );
}

Form.propTypes = {
  change: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inventoryQuantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  lineItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}))
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["q" /* returnConsignment */])(data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["j" /* form */])({
  form: CANCEL_CONSIGNMENT_FORM,
  validate: __WEBPACK_IMPORTED_MODULE_13__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 2057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;





function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["H" /* CANCELLATION_REASON */], __WEBPACK_IMPORTED_MODULE_3__constants__["q" /* SHIP_TO_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 2058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dummies_Form__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(86);
/* harmony export (immutable) */ __webpack_exports__["a"] = CreateDummy;






function CreateDummy(_ref) {
  var editing = _ref.editing,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Create Dummy Stock"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Dummies_Form__["a" /* default */], {
      close: close,
      submitAction: __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* createDummy */],
      enableReinitialize: true
    })
  );
}

CreateDummy.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateDummy__ = __webpack_require__(2058);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CreateDummy__["a"]; });



/***/ }),
/* 2060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(2061);





function CreateInventoryShipmentModal(_ref) {
  var editing = _ref.editing,
      close = _ref.close,
      inventory = _ref.inventory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Create Inventory Shipment"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close, inventory: inventory.toJS(), enableReinitialize: true })
    )
  );
}

CreateInventoryShipmentModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape()
};

/* harmony default export */ __webpack_exports__["a"] = (CreateInventoryShipmentModal);

/***/ }),
/* 2061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Orders_shared_ShippingFields_ShippingFields__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_address__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__validate__ = __webpack_require__(2062);
/* unused harmony export Form */
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














var FORM_NAME = "createInventoryShipmentForm";

function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        "h4",
        null,
        "Ship To"
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Orders_shared_ShippingFields_ShippingFields__["a" /* default */], {
        key: "ship-to-shipping-fields",
        formName: FORM_NAME,
        hasLocations: false,
        path: __WEBPACK_IMPORTED_MODULE_4__constants__["B" /* SHIP_TO */],
        renderCarrier: true,
        shippingFields: [__WEBPACK_IMPORTED_MODULE_4__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_4__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */]],
        shippingMethod: __WEBPACK_IMPORTED_MODULE_4__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */],
        shippingTypes: [__WEBPACK_IMPORTED_MODULE_9__companies_constants__["p" /* COMPANY */]],
        shippingAddressField: __WEBPACK_IMPORTED_MODULE_4__constants__["_17" /* SHIP_TO_SHIPPING_ADDRESS */],
        required: true
      }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["q" /* FormRow */],
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            "div",
            { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_4__constants__["_20" /* SHIP_TO_FOB */],
              component: __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["d" /* FormInput */],
              label: "FOB",
              required: true
            })
          )
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function (state, ownProps) {
  var _initialValues;

  return {
    initialValues: (_initialValues = {}, _defineProperty(_initialValues, __WEBPACK_IMPORTED_MODULE_4__constants__["_20" /* SHIP_TO_FOB */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_address__["a" /* fobFormat */])(ownProps.inventory.store_location)), _defineProperty(_initialValues, __WEBPACK_IMPORTED_MODULE_4__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_9__companies_constants__["p" /* COMPANY */]), _initialValues)
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["u" /* returnToCustomer */](ownProps.inventory.id, data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_10__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 2062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__ = __webpack_require__(25);




/* harmony default export */ __webpack_exports__["a"] = (function (values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_1__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_1__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_1__constants__["_20" /* SHIP_TO_FOB */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);

    form.validateChild(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* SHIPPING_METHOD */], function (s) {
      s.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* CARRIER */], __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* SHIPPING_METHOD */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    });
  });
});

/***/ }),
/* 2063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RMAsAndWarranties_constants__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_CurrencyField__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_Select_Select__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__validate__ = __webpack_require__(2066);
/* unused harmony export Form */

















function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_8__RepairOrders_constants__["j" /* RMA_REQUEST_TYPE */],
            label: "Request Type",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["m" /* RadioGroupField */],
            options: [{
              value: "rma",
              text: "Request RMA"
            }, { value: __WEBPACK_IMPORTED_MODULE_8__RepairOrders_constants__["k" /* PARTIAL_CREDIT */], text: "Request Partial Credit" }]
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_14__SalesOrders_constants__["i" /* REASON */] },
            "Reason"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
            name: "reason",
            component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms_Select_Select__["b" /* Select */],
            label: "Reason",
            options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_7__RMAsAndWarranties_constants__["a" /* REASONS */]),
            required: true
          })
        )
      ),
      !props.managedRepair && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
            { title: "Request Credit", justified: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_7__RMAsAndWarranties_constants__["b" /* CREDIT_REQUESTED */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
              label: "Credit Requested"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["a" /* CheckGroup */],
            { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__RepairOrders_constants__["l" /* WARRANTY_CONSIDERATION */]), justified: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_8__RepairOrders_constants__["l" /* WARRANTY_CONSIDERATION */],
              component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["b" /* Check */],
              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__RepairOrders_constants__["l" /* WARRANTY_CONSIDERATION */])
            })
          )
        )
      ),
      props.rmaRequestType === __WEBPACK_IMPORTED_MODULE_8__RepairOrders_constants__["k" /* PARTIAL_CREDIT */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
            component: __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_CurrencyField__["a" /* default */],
            name: __WEBPACK_IMPORTED_MODULE_7__RMAsAndWarranties_constants__["c" /* PARTIAL_CREDIT_AMT */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__RepairOrders_constants__["m" /* PARTIAL_CREDIT_AMOUNT */])
          })
        )
      )
    )
  );
}

var FORM_NAME = "createVendorRmaForm";

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["formValueSelector"])(FORM_NAME);

Form.propTypes = {
  managedRepair: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    shippingType: selector(state, __WEBPACK_IMPORTED_MODULE_9__constants__["o" /* SHIPPING_TYPE */]),
    rmaRequestType: selector(state, __WEBPACK_IMPORTED_MODULE_8__RepairOrders_constants__["j" /* RMA_REQUEST_TYPE */])
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["c" /* createVendorRma */](data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_15__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 2064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Form__ = __webpack_require__(2063);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










function RmaRequestModal(_ref) {
  var editing = _ref.editing,
      close = _ref.close,
      inventory = _ref.inventory;

  var managedRepair = inventory.get(__WEBPACK_IMPORTED_MODULE_3__constants__["_29" /* MANAGED_REPAIR_IN_PROGRESS */]);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        managedRepair ? "" : "Vendor ",
        "RMA Request"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["e" /* Body */],
      null,
      [__WEBPACK_IMPORTED_MODULE_3__constants__["_30" /* SALES_ORDER_CREATED */], __WEBPACK_IMPORTED_MODULE_3__constants__["V" /* RESERVE_FOR_SALE */]].includes(inventory.get(__WEBPACK_IMPORTED_MODULE_3__constants__["_31" /* STATUS */])) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components_Warning_Warning__["a" /* default */],
        null,
        "Please cancel the existing SO and return to stock before requesting a vendor RMA.",
        " "
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Form__["a" /* default */], {
        close: close,
        managedRepair: managedRepair,
        initialValues: _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__RepairOrders_constants__["j" /* RMA_REQUEST_TYPE */], __WEBPACK_IMPORTED_MODULE_6__Receiving_constants__["c" /* RMA */]),
        enableReinitialize: true
      })
    )
  );
}

RmaRequestModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map)
};

/* harmony default export */ __webpack_exports__["a"] = (RmaRequestModal);

/***/ }),
/* 2065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RmaRequestModal__ = __webpack_require__(2064);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RmaRequestModal__["a"]; });



/***/ }),
/* 2066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (function (values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate("reason").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
});

/***/ }),
/* 2067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* unused harmony export DownloadScrapReportModal */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();












var MUTILATION_REASONS = ["cutting_or_shearing", "crushing_or_shredding", "drilling_or_punching", "grinding_or_abrasion", "torching_or_thermal_mutilation", "notching_or_gouging", "certified_vendor_mutilation", "other"];

function DownloadScrapReportModal(_ref) {
  var editing = _ref.editing,
      close = _ref.close,
      url = _ref.url,
      inventory = _ref.inventory;

  var js = inventory.toJS();

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
    company_name: js.po_vendor_name,
    reference_number: js.purchase_order_code
  }),
      _useState2 = _slicedToArray(_useState, 2),
      settings = _useState2[0],
      setSetting = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
      _useState4 = _slicedToArray(_useState3, 2),
      changes = _useState4[0],
      setChanges = _useState4[1];

  var updateSetting = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (path, value) {
    setSetting(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["set"])(settings, path, value));
    setChanges(changes + 1);
  }, [settings, changes]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Download Certificate of Destruction"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "Company Name" },
            "Company Name"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            className: "form-control",
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(settings, "company_name"),
            onChange: function onChange(e) {
              return updateSetting("company_name", e.target.value);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "Ref" },
            "Reference #"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            className: "form-control",
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(settings, "reference_number"),
            onChange: function onChange(e) {
              return updateSetting("reference_number", e.target.value);
            }
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "attention" },
            "Attention"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            className: "form-control",
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(settings, "attention"),
            onChange: function onChange(e) {
              return updateSetting("attention", e.target.value);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "form_of_mutilation" },
            "Form of Mutilation"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "select",
            {
              className: "form-control",
              id: "form-of-mutilation",
              value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(settings, "form_of_mutilation", null),
              onChange: function onChange(ev) {
                updateSetting("form_of_mutilation", ev.target.value);
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "option",
              { value: "" },
              "(Select one)"
            ),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_forms__["e" /* arrayToProperCasedOptions */])(MUTILATION_REASONS).map(function (o) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "option",
                { value: o.value },
                o.text
              );
            })
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
        {
          onClick: function onClick() {
            close();
          }
        },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Button */],
        {
          type: "submit",
          bsStyle: "primary",
          onClick: function onClick() {
            window.open(url + "?" + new URLSearchParams(settings).toString());
            close();
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["k" /* Icon */], { name: "download", fixed: true }),
        "\xA0Download"
      )
    )
  );
}

DownloadScrapReportModal.propTypes = {
  url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var withUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["d" /* translateProps */])(function (_ref2) {
  var inventory = _ref2.inventory;
  return {
    url: __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* API_BASE */] + "/inventories/" + inventory.get(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ID */]) + "/download_scrap_certificate"
  };
});

/* harmony default export */ __webpack_exports__["a"] = (withUrl(DownloadScrapReportModal));

/***/ }),
/* 2068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReserveForSellerForm__ = __webpack_require__(2069);







function EditReserveForSeller(_ref) {
  var editing = _ref.editing,
      close = _ref.close,
      inventory = _ref.inventory,
      currentUser = _ref.currentUser;

  var initialValues = {
    id: inventory.get("id"),
    reserve_for_seller_id: inventory.get("reserve_for_seller_id") || currentUser.get("id"),
    quantity: inventory.get("quantity") === 1 ? 1 : null
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["a" /* Modal */],
    {
      key: inventory.get("id"),
      open: editing,
      close: close,
      dialogClass: "modal-sm"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Reserve For Sale"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ReserveForSellerForm__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      selectedSeller: inventory.get("reserve_for_seller") || currentUser.toJS(),
      enableReinitialize: true
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get("user")
  };
})(EditReserveForSeller));

EditReserveForSeller.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  currentUser: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),
  inventory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({})
};

/***/ }),
/* 2069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__validate__ = __webpack_require__(2071);
/* unused harmony export ReserveForSellerForm */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ReserveForSellerForm = function (_Component) {
  _inherits(ReserveForSellerForm, _Component);

  function ReserveForSellerForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReserveForSellerForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReserveForSellerForm.__proto__ || Object.getPrototypeOf(ReserveForSellerForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedSeller: {}
    }, _this.handleSellerSelected = function (seller) {
      _this.setState({ selectedSeller: seller });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReserveForSellerForm, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.selectedSeller) {
        this.setState({ selectedSeller: this.props.selectedSeller });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-12" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: "reserve_for_seller_id",
                label: "Reserve For Seller",
                placeholder: "Search by Name",
                component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["n" /* AutoCompleteField */],
                search: this.props.queryUsers,
                selectedItem: this.state.selectedSeller,
                formatItem: function formatItem(result) {
                  return result && result.full_name;
                },
                onItemSelected: function onItemSelected(i) {
                  return i && _this2.handleSellerSelected(i);
                },
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "col-md-12" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: "quantity",
                label: "Reserve Qty",
                type: "number",
                component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                required: true
              })
            )
          )
        )
      );
    }
  }]);

  return ReserveForSellerForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ReserveForSellerForm.propTypes = {
  queryUsers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedSeller: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    queryUsers: function queryUsers(filter) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_actions__["h" /* searchUsers */])(filter));
    },
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_4__actions__["f" /* reserveForSale */](data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: "editInventorySeller",
  validate: __WEBPACK_IMPORTED_MODULE_7__validate__["a" /* default */]
})(ReserveForSellerForm)));

/***/ }),
/* 2070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditReserveForSeller__ = __webpack_require__(2068);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EditReserveForSeller__["a"]; });



/***/ }),
/* 2071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;



function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate("reserve_for_seller_id", "quantity").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 2072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormInput_FormInput__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(12);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

















function Form(_ref) {
  var inventory = _ref.inventory,
      props = _objectWithoutProperties(_ref, ["inventory"]);

  var OBTAINED_FROM = "obtained_from";

  var onObtainedFromOther = function onObtainedFromOther(event) {
    var value = event.target.value;

    props.change(OBTAINED_FROM, value);
  };

  var radioSelect = function radioSelect(item) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
      type: "radio",
      name: OBTAINED_FROM,
      className: "radio-inline",
      checked: props.getFieldValue(OBTAINED_FROM) === item.code,
      onChange: function onChange() {
        return props.change(OBTAINED_FROM, item.code);
      }
    });
  };

  var renderPORow = function renderPORow(item) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      { key: "po-" + item.id },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-center" },
        radioSelect(item, "purchase_order_line_item")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(item, "code")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null)
    );
  };

  var renderSORow = function renderSORow(item) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      { key: "so-" + item.id },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-center" },
        radioSelect(item, "sales_order_line_item")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        item.code
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null)
    );
  };

  var renderRORow = function renderRORow(item) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tr",
      { key: "ro-" + item.id },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-center" },
        radioSelect(item, "repair_order_line_item")
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        item.code
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null)
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__shared_components__["s" /* DataTable */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__shared_components__["s" /* DataTable */].Head,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Code"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__shared_components__["s" /* DataTable */].Body,
              null,
              [inventory.most_recent_purchase_order].filter(function (r) {
                return r;
              }).map(renderPORow).concat([inventory.most_recent_sales_order].filter(function (r) {
                return r;
              }).map(renderSORow)).concat([inventory.most_recent_repair_order].filter(function (r) {
                return r;
              }).map(renderRORow)),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "tr",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", { className: "text-center" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  "Other"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "td",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormInput_FormInput__["b" /* FormInput */],
                    name: OBTAINED_FROM,
                    className: "form-control",
                    onChange: onObtainedFromOther
                  })
                )
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["a" /* CheckGroup */],
              { title: "Include Company Name In Label" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["Field"], {
                name: "include_company_name",
                component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["x" /* COMPANY_NAME */])
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "form-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["a" /* CheckGroup */],
              { title: "Include Inventory Notes" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["_18" /* NOTES */],
                component: __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["b" /* Check */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["_18" /* NOTES */])
              })
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" })
      )
    )
  );
}

Form.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function () {
  return {
    initialValues: {
      include_company_name: true,
      notes: true
    }
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions__["r" /* print */])(data, __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(ownProps, [__WEBPACK_IMPORTED_MODULE_14__constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_13__constants__["b" /* ID */]].join("."))));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_components_Forms__["j" /* form */])({
  form: "printInventoryForm"
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 2073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actionTypes__ = __webpack_require__(462);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
















var FORM_NAME = "request-scrap-at-shop";

function Form(_ref) {
  var close = _ref.close,
      handleSubmit = _ref.handleSubmit,
      invalid = _ref.invalid,
      submitting = _ref.submitting;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "form",
    { onSubmit: handleSubmit },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__["e" /* Body */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */], name: "to", label: "To:", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */], name: "cc", label: "CC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */], name: "bcc", label: "BCC:" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["d" /* FormInput */], name: "subject", label: "Subject", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["l" /* TextArea */], name: "body", label: "Body", required: true })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components_Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* Button */],
        {
          onClick: function onClick() {
            close();
          }
        },
        "Cancel"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* Button */],
        {
          type: "submit",
          bsStyle: "primary",
          disabled: invalid || submitting
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["k" /* Icon */], { name: "envelope", fixed: true }),
        "\xA0Yes, Send Email"
      )
    )
  );
}

Form.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reduxForm"])({
  form: FORM_NAME,
  validate: function validate(values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_validate_this__["a" /* validator */])(values, function (form) {
      form.validate("subject", "body", "to").satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["a" /* required */]);
      form.validate("to", "cc").satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["b" /* isValidEmail */]);
    });
  },
  onSubmit: function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(params, _, props) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].inventories.requestScrapAtShop(props.inventory.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */]), params).then(function (_ref3) {
                var data = _ref3.data;

                var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__hooks__["b" /* useDispatch */])();
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_13__actionTypes__["a" /* SET */], inventory: data });
                props.close();
                __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__["toastr"].success("Success", "Email successfully sent.");
              }).catch(function () {
                return __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__["toastr"].error("Error", "Could not send email. Please refresh page and try again.");
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function onSubmit(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }()
})(Form));

/***/ }),
/* 2074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Form__ = __webpack_require__(2073);
/* harmony export (immutable) */ __webpack_exports__["a"] = RequestScrapAtShop;










function RequestScrapAtShop(_ref) {
  var close = _ref.close,
      editing = _ref.editing,
      inventory = _ref.inventory;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hooks__["a" /* useCurrentUser */])();

  var code = inventory.getIn(["most_recent_repair_order", __WEBPACK_IMPORTED_MODULE_5__constants__["z" /* CODE */]]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components__["C" /* Modal */],
    { open: editing, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Request Scrap Certificate"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Form__["a" /* default */], {
      close: close,
      initialValues: {
        from: currentUser.email,
        to: inventory.getIn(["most_recent_repair_order", __WEBPACK_IMPORTED_MODULE_7__companies_constants__["g" /* CONTACT */], __WEBPACK_IMPORTED_MODULE_5__constants__["T" /* EMAIL */]]),
        cc: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(currentUser.tenant, __WEBPACK_IMPORTED_MODULE_5__constants__["_19" /* REPAIRS_FROM_EMAIL */]),
        subject: code + " Request for Scrap",
        body: "Hi " + inventory.getIn(["most_recent_repair_order", __WEBPACK_IMPORTED_MODULE_7__companies_constants__["g" /* CONTACT */], __WEBPACK_IMPORTED_MODULE_5__constants__["S" /* NAME */]]) + ",\n\nPlease scrap PN " + inventory.getIn(["part", "part_number"]) + " SN " + inventory.get(__WEBPACK_IMPORTED_MODULE_6__constants__["o" /* SERIAL_NUMBER */]) + " from " + code + " and send back Scrap Certificate at your earliest convenience.\n\nThank you,\n\n" + currentUser.full_name
      },
      inventory: inventory,
      enableReinitialize: true
    })
  );
}

/***/ }),
/* 2075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);







function ReserveForRepair(_ref) {
  var editing = _ref.editing,
      close = _ref.close,
      update = _ref.update,
      inventory = _ref.inventory;

  var isBrokered = inventory && inventory.get("brokered_exchange");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["i" /* ConfirmAction */],
    {
      onConfirm: update,
      close: close,
      open: editing,
      icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "wrench", fixed: true }),
      btnText: "Reserve"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "strong",
      null,
      "Heads up!"
    ),
    " \xA0",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      null,
      "Are you sure you'd like to reserve this item for repair?"
    ),
    isBrokered && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      { style: { color: "red", marginTop: "1rem" } },
      "NOTE: This unit is from a Brokered Exchange Transaction"
    )
  );
}

ReserveForRepair.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  update: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    get: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  })
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    update: function update() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["e" /* reserveForRepair */])(ownProps.inventory && ownProps.inventory.get(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */])));
    }
  };
})(ReserveForRepair));

/***/ }),
/* 2076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReserveForRepair__ = __webpack_require__(2075);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ReserveForRepair__["a"]; });



/***/ }),
/* 2077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Orders_shared_ShippingFields__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_address__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__validate__ = __webpack_require__(2079);
/* unused harmony export Form */
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















var FORM_NAME = "return-to-customer-record-form";

function Form(props) {
  var inventory = props.inventory,
      setFieldValue = props.setFieldValue;


  var rma = inventory.most_recent_customer_rma;

  var onChangeShippingPreference = function onChangeShippingPreference(shippingMethod) {
    [__WEBPACK_IMPORTED_MODULE_10__constants__["e" /* CARRIER */], __WEBPACK_IMPORTED_MODULE_10__constants__["g" /* SHIPPING_METHOD */], __WEBPACK_IMPORTED_MODULE_10__constants__["h" /* ACCOUNT_NUMBER */]].forEach(function (f) {
      setFieldValue(__WEBPACK_IMPORTED_MODULE_10__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */] + "." + f)(shippingMethod[f]);
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_redux_form__["FormSection"],
        { name: "" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Ship To"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Orders_shared_ShippingFields__["a" /* default */], {
          shipToCompany: rma.company,
          formName: FORM_NAME,
          hasLocations: false,
          onChangeShippingPreference: onChangeShippingPreference,
          shippingFields: [__WEBPACK_IMPORTED_MODULE_10__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_10__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_10__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */]],
          shippingTypes: [__WEBPACK_IMPORTED_MODULE_8__companies_constants__["p" /* COMPANY */], __WEBPACK_IMPORTED_MODULE_9__PurchaseOrders_constants__["L" /* DROPSHIP */]],
          shippingMethod: __WEBPACK_IMPORTED_MODULE_10__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */],
          shippingAddressField: __WEBPACK_IMPORTED_MODULE_10__constants__["_17" /* SHIP_TO_SHIPPING_ADDRESS */],
          required: false
        })
      )
    )
  );
}

Form.propTypes = {
  rma: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state, ownProps) {
  var _initialValues;

  return {
    initialValues: (_initialValues = {}, _defineProperty(_initialValues, __WEBPACK_IMPORTED_MODULE_10__constants__["_20" /* SHIP_TO_FOB */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_address__["a" /* fobFormat */])(ownProps.inventory.store_location)), _defineProperty(_initialValues, __WEBPACK_IMPORTED_MODULE_10__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_8__companies_constants__["p" /* COMPANY */]), _initialValues)
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_7__actions__["t" /* returnToCustomerV2 */](ownProps.inventory.id, data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_13__validate__["a" /* default */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 2078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(2077);
/* harmony export (immutable) */ __webpack_exports__["a"] = ReturnToCustomer;





function ReturnToCustomer(_ref) {
  var editing = _ref.editing,
      close = _ref.close,
      inventory = _ref.inventory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Return To Customer"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close, inventory: inventory.toJS(), enableReinitialize: true })
  );
}

ReturnToCustomer.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__ = __webpack_require__(19);





/* harmony default export */ __webpack_exports__["a"] = (function (values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* SHIP_TO_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);

    if (values.ship_to_type === __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* COMPANY */]) {
      form.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_1__constants__["J" /* SHIP_TO_COMPANY_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    }

    if (values.ship_to_type === __WEBPACK_IMPORTED_MODULE_3__PurchaseOrders_constants__["L" /* DROPSHIP */]) {
      form.validateChild(__WEBPACK_IMPORTED_MODULE_1__constants__["I" /* SHIPPING_ADDRESS */], function (s) {
        s.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* COUNTRY */], __WEBPACK_IMPORTED_MODULE_1__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_1__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_1__constants__["w" /* POSTAL_CODE */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
      });
    }

    form.validateChild(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* SHIPPING_METHOD */], function (s) {
      s.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* CARRIER */], __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* SHIPPING_METHOD */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    });
  });
});

/***/ }),
/* 2080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ScrapReportReceivedForm__ = __webpack_require__(2081);
/* harmony export (immutable) */ __webpack_exports__["a"] = ScrapReportReceived;





function ScrapReportReceived(_ref) {
  var editing = _ref.editing,
      close = _ref.close,
      inventory = _ref.inventory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Receive Scrap Report"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ScrapReportReceivedForm__["a" /* default */], {
      close: close,
      initialValues: inventory.toJS(),
      enableReinitialize: true
    })
  );
}

ScrapReportReceived.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* unused harmony export ScrapReportReceivedForm */








function ScrapReportReceivedForm(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
        name: "scrap_report",
        component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["k" /* FileInput */],
        label: "Upload Attachment"
      })
    )
  );
}

ScrapReportReceivedForm.propTypes = __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["o" /* FormTypes */].modalForm;

function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_validate_this__["a" /* validator */])(values, function (f) {
    f.validate("scrap_report").satisfies(__WEBPACK_IMPORTED_MODULE_5__lib_validation_rules__["a" /* required */]);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_4__actions__["h" /* upload */](data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: "scrapReportReceivedForm",
  validate: validate
})(ScrapReportReceivedForm)));

/***/ }),
/* 2082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrapReportReceived__ = __webpack_require__(2080);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ScrapReportReceived__["a"]; });



/***/ }),
/* 2083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validate__ = __webpack_require__(2086);








function Form(props) {
  var inventoryQuantity = props.inventoryQuantity,
      change = props.change;

  var handleQtyChange = function handleQtyChange(qty) {
    var remaining = qty >= 0 ? inventoryQuantity - qty : inventoryQuantity;
    change("remaining_quantity", remaining);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "remaining_quantity",
            label: "Remaining QTY",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["h" /* NumberInput */],
            roundDigits: 0,
            readOnly: true,
            disabled: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "quantity",
            label: "QTY",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["h" /* NumberInput */],
            roundDigits: 0,
            inputProps: { min: 0 },
            onChange: function onChange(ev, val) {
              return handleQtyChange(val);
            },
            required: true
          })
        )
      )
    )
  );
}

Form.propTypes = {
  change: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inventoryQuantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    inventoryQuantity: state.inventoryDetail.getIn(["inventory", "quantity"])
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(ownProps.submitAction(data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: "splitInventory",
  validate: __WEBPACK_IMPORTED_MODULE_6__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 2084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(2083);
/* harmony export (immutable) */ __webpack_exports__["a"] = SplitInventory;






function SplitInventory(_ref) {
  var editing = _ref.editing,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Split Inventory"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], {
      close: close,
      submitAction: __WEBPACK_IMPORTED_MODULE_3__actions__["g" /* splitInventory */],
      enableReinitialize: true
    })
  );
}

SplitInventory.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SplitInventory__ = __webpack_require__(2084);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SplitInventory__["a"]; });



/***/ }),
/* 2086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;



function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    var totalQty = parseInt(values.quantity, 10) + parseInt(values.remaining_quantity, 10) - 1;
    var maxQty = totalQty > 0 ? totalQty : values.remaining_quantity;

    if (values.quantity <= 0) {
      v.validate("quantity").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["f" /* isGreaterThan */](0));
    } else {
      v.validate("quantity").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["h" /* isBetween */](1, maxQty));
    }
  });
}

/***/ }),
/* 2087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shipping_constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormRow__ = __webpack_require__(26);













var formName = "transferInventory";

function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_6__constants__["_28" /* TRANSFER_TO_LOCATION_ID */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
            label: "Transfer To Location",
            options: props.locations,
            prompt: false
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_8__Shipping_constants__["g" /* OUTGOING_AWB_NUMBER */],
            label: "Outgoing AWB #",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */]
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__["d" /* SPECIAL_INSTRUCTIONS */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["l" /* TextArea */],
            label: "Special Instructions (For shipping team)",
            rows: "5",
            cols: "50"
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components__["n" /* Warning */],
        null,
        "Warning: Entering AWB # will automatically ship item."
      )
    )
  );
}

Form.propTypes = {
  locations: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* transfer */])(data.id, data.transfer_to_location_id, data.outgoing_awb_number, data.special_instructions));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: formName
})(Form)));

/***/ }),
/* 2088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(2087);
/* harmony export (immutable) */ __webpack_exports__["a"] = Transfer;








function Transfer(_ref) {
  var editing = _ref.editing,
      close = _ref.close,
      inventory = _ref.inventory;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hooks_useCurrentUser__["a" /* default */])();
  var locations = currentUser.locations.filter(function (l) {
    return l.id !== inventory.get(__WEBPACK_IMPORTED_MODULE_4__constants__["_27" /* STORE_LOCATION_ID */]);
  }).map(function (l) {
    return {
      text: l.name,
      value: l.id
    };
  });

  var initialValues = {
    id: inventory.get(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]),
    transfer_to_location_id: locations[0].value
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    {
      key: inventory.get(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */]),
      open: editing,
      close: close,
      dialogClass: "modal-sm"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Transfer Inventory"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Form__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      enableReinitialize: true,
      locations: locations
    })
  );
}

Transfer.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Transfer__ = __webpack_require__(2088);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Transfer__["a"]; });



/***/ }),
/* 2090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(12);







function UndoScrap(_ref) {
  var editing = _ref.editing,
      close = _ref.close,
      onSubmit = _ref.onSubmit,
      inventory = _ref.inventory;

  var canUndoScrap = [__WEBPACK_IMPORTED_MODULE_5__constants__["_22" /* AWAITING_SCRAP_REPORT_AT_SHOP */], __WEBPACK_IMPORTED_MODULE_5__constants__["_23" /* AWAITING_SCRAP_REPORT_LOCAL */]].includes(inventory.get("status"));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components__["i" /* ConfirmAction */],
    {
      onConfirm: function onConfirm() {
        return onSubmit(inventory.get("id"));
      },
      close: close,
      open: editing,
      icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["k" /* Icon */], { name: "undo", fixed: true }),
      btnText: "Undo Scrap",
      showButton: canUndoScrap
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "strong",
      null,
      "Heads up!"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      null,
      "Are you sure you'd like to undo scrap?"
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* undoScrap */])(id));
    }
  };
})(UndoScrap));

UndoScrap.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

/***/ }),
/* 2091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UndoScrap__ = __webpack_require__(2090);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__UndoScrap__["a"]; });



/***/ }),
/* 2092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UpdateQCStatusForm__ = __webpack_require__(2093);
/* harmony export (immutable) */ __webpack_exports__["a"] = UpdateStatus;





function UpdateStatus(_ref) {
  var editing = _ref.editing,
      close = _ref.close,
      inventory = _ref.inventory;

  var initialValues = {
    id: inventory.get("id"),
    qc_status: inventory.get("qc_status")
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Update QC Status"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UpdateQCStatusForm__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      enableReinitialize: true
    })
  );
}

UpdateStatus.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_removeKey__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__validate__ = __webpack_require__(2095);










function Form(props) {
  var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_removeKey__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__constants__["_32" /* QC_STATUSES */], __WEBPACK_IMPORTED_MODULE_5__constants__["T" /* UNDER_REVIEW */]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        name: "qc_status",
        component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["c" /* Select */],
        options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["a" /* toOptions */])(options),
        label: "QC Status",
        required: true
      })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { onSubmit: __WEBPACK_IMPORTED_MODULE_7__actions__["i" /* update */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: "updateInventoryQCStatus",
  validate: __WEBPACK_IMPORTED_MODULE_8__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 2094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UpdateQCStatus__ = __webpack_require__(2092);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__UpdateQCStatus__["a"]; });



/***/ }),
/* 2095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;



function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validate("qc_status").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
  });
}

/***/ }),
/* 2096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Form__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(741);
/* harmony export (immutable) */ __webpack_exports__["a"] = UpdateSrpStatus;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }












function UpdateSrpStatus(_ref) {
  var editing = _ref.editing,
      close = _ref.close,
      inventory = _ref.inventory;

  var inventories = usePartInventories(inventory.get("part_id"), editing);

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      inventoriesSelected = _useState2[0],
      setInventoriesSelected = _useState2[1];

  var initialValues = {
    inventories: inventories.map(function (i) {
      var _pojo;

      i.display_condition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_6__Receiving_constants__["x" /* CONDITION_TYPES */], i.condition + ".label");
      return (_pojo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_pojos__["a" /* default */])(i)).pick.apply(_pojo, ["id"].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_9__constants__["a" /* displayFields */]))));
    })
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: editing, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Update SRP"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Form__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      inventories: inventories,
      inventoriesSelected: inventoriesSelected,
      setInventoriesSelected: setInventoriesSelected,
      enableReinitialize: true
    })
  );
}

UpdateSrpStatus.propTypes = {
  editing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

// Custom Hooks

function usePartInventories(partId, editing) {
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState4 = _slicedToArray(_useState3, 2),
      inventories = _useState4[0],
      setInventories = _useState4[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].parts.inventories.search(partId, {
      sellable_status: [__WEBPACK_IMPORTED_MODULE_7__constants__["W" /* DO_NOT_LIST */], __WEBPACK_IMPORTED_MODULE_7__constants__["U" /* LIST */]].join(","),
      limit: 1000
    }).then(function (resp) {
      return setInventories(resp.data.results);
    });

    return function cleanup() {};
  }, [editing]);

  return inventories;
}

/***/ }),
/* 2097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Form__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(12);





var meetsMinimumSrp = function meetsMinimumSrp(props) {
  return function (field, values) {
    if (props.inventoriesSelected.includes(values.id)) {
      var inventory = props.inventories.filter(function (i) {
        return i.id === values.id;
      })[0];
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Form__["b" /* shouldShowWarning */])({ inventory: inventory, suggestedRetail: field })) {
        return "SRP must be greater than the estimated repair cost";
      }

      return undefined;
    }

    return undefined;
  };
};

function validateItem(item, props) {
  var isSelectedApplyRule = function isSelectedApplyRule(rule) {
    return function (field, values) {
      if (props.inventoriesSelected.includes(values.id)) {
        return rule(field);
      }

      return undefined;
    };
  };

  item.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["v" /* SUGGESTED_RETAIL */]).satisfies(isSelectedApplyRule(__WEBPACK_IMPORTED_MODULE_0__lib_validation_rules__["a" /* required */]), meetsMinimumSrp(props));

  item.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["u" /* EXCHANGE_SRP */]).satisfies(isSelectedApplyRule(__WEBPACK_IMPORTED_MODULE_0__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](props.minExchangeSrp || 400)));
}

/* harmony default export */ __webpack_exports__["a"] = (function (values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validateChildren("inventories", function (item) {
      return validateItem(item, props);
    });
  });
});

/***/ }),
/* 2098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RMAsAndWarranties_components_Detail_Panel_WarrantyConsideration_WarrantyConsideration__ = __webpack_require__(682);









var lockedStatuses = [__WEBPACK_IMPORTED_MODULE_3__constants__["_33" /* GONE */], __WEBPACK_IMPORTED_MODULE_3__constants__["V" /* RESERVE_FOR_SALE */], __WEBPACK_IMPORTED_MODULE_3__constants__["_34" /* ON_ORDER_FOR_SALE */], __WEBPACK_IMPORTED_MODULE_3__constants__["_35" /* RETURNING_TO_CUSTOMER */]];

var rules = {
  inventoryUnlocked: function inventoryUnlocked(inv) {
    return lockedStatuses.indexOf(inv.status) === -1;
  },
  noActiveRepairOrder: function noActiveRepairOrder(inv) {
    return !inv.repair_status || [__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* REPAIRED */], __WEBPACK_IMPORTED_MODULE_3__constants__["k" /* REPAIR_AND_HOLD */]].includes(inv.repair_status);
  },
  noActiveVendorRma: function noActiveVendorRma(inv) {
    return inv.status !== __WEBPACK_IMPORTED_MODULE_3__constants__["_36" /* VENDOR_RMA_REQUESTED */];
  },
  sellable: function sellable(inv) {
    return inv.sellable_status !== __WEBPACK_IMPORTED_MODULE_3__constants__["X" /* DO_NOT_SELL */] || [__WEBPACK_IMPORTED_MODULE_3__constants__["_37" /* EXCHANGE_GONE_OUTRIGHT */], __WEBPACK_IMPORTED_MODULE_3__constants__["_38" /* INTERNAL_OUTRIGHT */]].includes(inv.repair_status) && inv.condition === __WEBPACK_IMPORTED_MODULE_3__constants__["_39" /* AS_REMOVED */] && inv.status !== __WEBPACK_IMPORTED_MODULE_3__constants__["V" /* RESERVE_FOR_SALE */];
  },
  notManagedRepair: function notManagedRepair(inv) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* isManagedRepair */])(inv);
  },
  canUnreserveSale: function canUnreserveSale(inv) {
    return inv.status === __WEBPACK_IMPORTED_MODULE_3__constants__["V" /* RESERVE_FOR_SALE */] && inv.can_unreserve_sales;
  },
  canUnreserveRepair: function canUnreserveRepair(inv) {
    return [__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* RESERVE_FOR_REPAIR */], __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* RESERVE_FOR_SHOP_ASSIST */]].includes(inv.repair_status) && inv.can_unreserve_repair && !inv.managed_repair_in_progress && inv.status !== __WEBPACK_IMPORTED_MODULE_3__constants__["_40" /* RMA_RECEIVED */];
  },
  awaitingScrap: function awaitingScrap(inv) {
    return [__WEBPACK_IMPORTED_MODULE_3__constants__["_22" /* AWAITING_SCRAP_REPORT_AT_SHOP */], __WEBPACK_IMPORTED_MODULE_3__constants__["_23" /* AWAITING_SCRAP_REPORT_LOCAL */]].includes(inv.status);
  },
  canRemoveEma: function canRemoveEma(inv) {
    return inv.consignment_type === __WEBPACK_IMPORTED_MODULE_4__Receiving_constants__["s" /* EMA */];
  },
  notGone: function notGone(inv) {
    return inv.status !== __WEBPACK_IMPORTED_MODULE_3__constants__["_33" /* GONE */];
  },
  canReturnCore: function canReturnCore(inv) {
    return inv.status === __WEBPACK_IMPORTED_MODULE_3__constants__["_41" /* CORE_RETURN_RECEIVED */] && inv.qc_status === __WEBPACK_IMPORTED_MODULE_3__constants__["S" /* QC_HOLD */] || inv.exchange_eval_in_progress && inv.status === __WEBPACK_IMPORTED_MODULE_3__constants__["_42" /* DISCREPANCY_REPORTED */];
  },
  canReturnToCustomerV1: function canReturnToCustomerV1(inv) {
    return inv.condition === __WEBPACK_IMPORTED_MODULE_4__Receiving_constants__["g" /* BEYOND_ECON_REPAIR */] && inv.status === __WEBPACK_IMPORTED_MODULE_3__constants__["_43" /* IN_STOCK */] && Number(inv.cost_per_unit) === 0 && inv.sales_order_line_items && inv.sales_order_line_items.some(function (s) {
      return !s.cancelled && s.exchange_sale;
    });
  },
  canScrapLocally: function canScrapLocally(inv) {
    return inv.can_scrap_local;
  },
  canScrapAtShop: function canScrapAtShop(inv) {
    return inv.can_scrap_at_shop;
  },
  canSplit: function canSplit(inv) {
    return inv.quantity > 1;
  },
  canTransfer: function canTransfer(inv, currentUser) {
    return inv.transferrable && currentUser.locations.length > 1 && !inv.managed_repair_repaired && !inv.managed_repair_in_progress;
  },
  dummyDoesNotExist: function dummyDoesNotExist(inv) {
    return !inv.dummy;
  },
  canReturnCoreToStock: function canReturnCoreToStock(inv) {
    return inv.status === __WEBPACK_IMPORTED_MODULE_3__constants__["_41" /* CORE_RETURN_RECEIVED */];
  },
  canReturnRmaRequestToStock: function canReturnRmaRequestToStock(inv) {
    return inv.status === __WEBPACK_IMPORTED_MODULE_3__constants__["_40" /* RMA_RECEIVED */] && (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(inv, "most_recent_customer_rma.warranty_consideration") || inv.most_recent_customer_rma && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__RMAsAndWarranties_components_Detail_Panel_WarrantyConsideration_WarrantyConsideration__["a" /* finalWarrantyApproval */])(inv.most_recent_customer_rma));
  },
  canRemoveModTo: function canRemoveModTo(inv) {
    return inv.mod_to_id && [null, "repaired"].includes(inv.repair_status);
  },
  canCancelTransfer: function canCancelTransfer(inv) {
    return inv.active_transfer && inv.active_transfer.cancellable;
  },
  canDownload: function canDownload(inv) {
    return inv.active_transfer;
  },
  undoScrap: function undoScrap(inv) {
    return [__WEBPACK_IMPORTED_MODULE_3__constants__["_22" /* AWAITING_SCRAP_REPORT_AT_SHOP */], __WEBPACK_IMPORTED_MODULE_3__constants__["_23" /* AWAITING_SCRAP_REPORT_LOCAL */]].includes(inv.status);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  applyLotCost: {
    dropDownText: "Apply Lot Cost",
    rules: [function (inv) {
      return Number(inv.cost_per_unit) === 0 && ["LotLineItem", "Lot"].includes(inv.receiving_line_item_type);
    }],
    iconName: "dollar",
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_3" /* APPLY_LOT_COST */]
  },
  assignExchange: {
    dropDownText: "Assign as Core Return",
    rules: [function (inv) {
      return inv.requires_assigned_core_return && inv.status === "in_stock";
    }],
    iconName: "undo",
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_4" /* ASSIGN_EXCHANGE */],
    authorized: function authorized(user) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["c" /* hasAnyOfRoles */])(user, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */]]);
    }
  },
  cancelModTo: {
    text: "Are you sure you want to cancel this Mod To?",
    confirmText: "Yes",
    cancelText: "No",
    rules: [rules.canRemoveModTo],
    authorized: function authorized(user) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["c" /* hasAnyOfRoles */])(user, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["j" /* WAREHOUSE */]]);
    },
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_44" /* CANCEL_MOD_TO */],
    dropDownText: "Cancel Mod To",
    iconName: "ban",
    btnClass: "btn-danger",
    action: function action(inv) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actions__["j" /* cancelModTo */])(inv.id, {
        suggested_retail: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(inv, "purchase_order_line_items[0].suggested_retail")
      });
    }
  },
  cancelTransfer: {
    text: "Are you sure you want to cancel this transfer?",
    confirmText: "Yes",
    cancelText: "No",
    rules: [rules.canCancelTransfer],
    authorized: function authorized(user) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["c" /* hasAnyOfRoles */])(user, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["j" /* WAREHOUSE */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */]]);
    },
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_45" /* CANCEL_TRANSFER */],
    dropDownText: "Cancel Transfer",
    iconName: "ban",
    btnClass: "btn-danger",
    action: function action(inv) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actions__["k" /* cancelTransfer */])(inv.id, inv.active_transfer.id);
    }
  },
  createDummy: {
    iconName: "copy",
    rules: [rules.dummyDoesNotExist, rules.notGone],
    dropDownText: "Create Dummy",
    authorized: function authorized(user, inv) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["d" /* hasRole */])(user, __WEBPACK_IMPORTED_MODULE_2__users_constants__["k" /* SALES */]) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* isManagedRepair */])(inv);
    },
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_13" /* CREATE_DUMMY_RECORD */]
  },
  deleteInventory: {
    dropDownText: "Delete Inventory",
    rules: [function (inv, user) {
      return inv.imported && inv.status !== __WEBPACK_IMPORTED_MODULE_3__constants__["_33" /* GONE */] || Number(inv.cost_per_unit) === 0 && user.role === __WEBPACK_IMPORTED_MODULE_2__users_constants__["i" /* ADMIN */];
    }],
    iconName: "trash",
    action: __WEBPACK_IMPORTED_MODULE_1__actions__["l" /* deleteInventory */],
    text: "Are you sure you want to permanently delete this inventory?",
    authorized: function authorized(user, inv) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["a" /* hasAnyOfSubroles */])(user, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["_2" /* ACCOUNTING_MANAGER */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["n" /* QUALITY_CONTROL_MANAGER */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["S" /* SALES_MANAGER */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["s" /* WAREHOUSE_MANAGER */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]) || inv.buyer_id === user.id;
    }
  },
  createCommercialInvoice: {
    iconName: "file",
    rules: [rules.canDownload],
    dropDownText: "Download Commercial Invoice",
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_19" /* CREATE_COMMERCIAL_INVOICE */]
  },
  print: {
    rules: [],
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_20" /* PRINT */],
    dropDownText: "Print Inventory Label",
    iconName: "gears"
  },
  unreserveForSale: {
    text: "Are you sure you want to return this item to stock?",
    iconName: "plus-circle",
    rules: [rules.canUnreserveSale],
    dropDownText: "Return To Stock",
    action: __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* unreserveForSale */], // over here!
    authorized: function authorized(user) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["c" /* hasAnyOfRoles */])(user, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["k" /* SALES */]]);
    },
    confirmText: "Yes, Return To Stock",
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_46" /* RETURN_TO_STOCK */]
  },
  reclaimInventory: {
    text: "You're reclaiming abandoned inventory, are you sure?",
    iconName: "superpowers",
    rules: [function (inv) {
      return (inv.status === __WEBPACK_IMPORTED_MODULE_3__constants__["_33" /* GONE */] || inv.repair_status === __WEBPACK_IMPORTED_MODULE_3__constants__["_37" /* EXCHANGE_GONE_OUTRIGHT */]) && inv.repair_status !== __WEBPACK_IMPORTED_MODULE_3__constants__["_47" /* CORE_RETURNED_TO_CUSTOMER */] && inv.exchange_gone_outright && !inv.reclaimed;
    }],
    action: __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* reclaim */],
    dropDownText: "Reclaim",
    confirmText: "Yes, Reclaim Inventory"
  },
  returnCoreToCustomer: {
    text: "Are you sure you want to return the core to the customer?",
    iconName: "warning",
    rules: [rules.canReturnCore],
    dropDownText: "Reject Core Return - Return Core To Customer",
    action: __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* returnCoreToCustomer */],
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_48" /* RETURN_CORE_TO_CUSTOMER */]
  },
  updateEma: {
    text: "Are you sure you want to remove this EMA?",
    iconName: "trash",
    rules: [rules.canRemoveEma],
    dropDownText: "Remove EMA",
    action: function action() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actions__["i" /* update */])({ status: __WEBPACK_IMPORTED_MODULE_3__constants__["_33" /* GONE */] });
    },
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_49" /* REMOVE_EMA */]
  },
  reserveForRepair: {
    iconName: "wrench",
    rules: [rules.inventoryUnlocked, rules.noActiveRepairOrder, rules.noActiveVendorRma, function (inv) {
      return !inv.managed_repair_repaired;
    }],
    dropDownText: "Reserve For Repair",
    authorized: function authorized(user) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["c" /* hasAnyOfRoles */])(user, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["l" /* REPAIR */]]);
    },
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_8" /* RESERVE_INV_FOR_REPAIR */]
  },
  reserveForSale: {
    text: "Are you sure you want to reserve for sale",
    iconName: "dollar",
    rules: [rules.inventoryUnlocked, rules.notManagedRepair, rules.sellable],
    dropDownText: "Reserve For Sale",
    authorized: function authorized(user, inv) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["d" /* hasRole */])(user, __WEBPACK_IMPORTED_MODULE_2__users_constants__["k" /* SALES */]) || inv.reserve_for_seller_id === user.id;
    },
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_7" /* RESERVE_INV_FOR_SALE */]
  },
  cancelConsignment: {
    dropDownText: "Return to Consignor",
    rules: [function (inv) {
      return inv.consignment_type === __WEBPACK_IMPORTED_MODULE_4__Receiving_constants__["t" /* CONSIGNMENT */] && inv.status === __WEBPACK_IMPORTED_MODULE_3__constants__["_43" /* IN_STOCK */];
    }],
    iconName: "ban",
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_5" /* CANCEL_CONSIGNMENT */],
    authorized: function authorized(user) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["c" /* hasAnyOfRoles */])(user, __WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */]);
    }
  },
  returnToCustomer: {
    dropDownText: "Return To Customer",
    text: "Are you sure you want to return this item to the customer?",
    iconName: "undo",
    rules: [rules.canReturnToCustomerV1],
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_9" /* RETURN_TO_CUSTOMER */],
    confirmText: "Yes, Return To Customer"
  },
  returnToCustomerV2: {
    dropDownText: "Return To Customer",
    text: "Are you sure you want to return this item to the customer?",
    iconName: "undo",
    rules: [function (inv) {
      return inv.eligible_to_return_to_customer && !rules.canReturnToCustomerV1(inv) && inv.most_recent_customer_rma && inv.status === __WEBPACK_IMPORTED_MODULE_3__constants__["_43" /* IN_STOCK */];
    }],
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_10" /* RETURN_TO_CUSTOMER_V2 */],
    confirmText: "Yes, Return To Customer"
  },
  returnToStock: {
    text: "Are you sure you want to return this item to stock?",
    iconName: "plus-circle",
    rules: [function (inv) {
      return rules.canReturnCoreToStock(inv) || rules.canReturnRmaRequestToStock(inv);
    }],
    dropDownText: "Return To Stock",
    action: function action() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actions__["i" /* update */])({ status: __WEBPACK_IMPORTED_MODULE_3__constants__["_43" /* IN_STOCK */] });
    },
    authorized: function authorized(user, inv) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["c" /* hasAnyOfRoles */])(user, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["m" /* ACCOUNTING */]]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["a" /* hasAnyOfSubroles */])(user, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["S" /* SALES_MANAGER */]]) || [inv.reserved_by_id, inv.reserve_for_seller_id].includes(user.id);
    },
    confirmText: "Yes, Return To Stock",
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_46" /* RETURN_TO_STOCK */]
  },
  requestScrapAtShop: {
    text: "Are you sure you want to scrap this item?",
    iconName: "trash",
    rules: [rules.canScrapAtShop],
    authorized: function authorized(user) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["c" /* hasAnyOfRoles */])(user, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["l" /* REPAIR */]]);
    },
    dropDownText: "Request Scrap At Shop",
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_14" /* REQUEST_SCRAP_AT_SHOP */]
  },
  scrapAtShop: {
    text: "Are you sure you want to scrap this item?",
    iconName: "trash",
    rules: [rules.canScrapAtShop],
    authorized: function authorized(user) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["c" /* hasAnyOfRoles */])(user, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["l" /* REPAIR */]]);
    },
    action: function action() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actions__["i" /* update */])({ status: __WEBPACK_IMPORTED_MODULE_3__constants__["_22" /* AWAITING_SCRAP_REPORT_AT_SHOP */] });
    },
    dropDownText: "Scrap At Shop",
    confirmText: "Yes, Scrap Item",
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_50" /* SCRAP_AT_SHOP */]
  },
  scrapLocally: {
    text: "Are you sure you want to scrap this item?",
    iconName: "trash",
    rules: [rules.canScrapLocally],
    authorized: function authorized(user) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["c" /* hasAnyOfRoles */])(user, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["j" /* WAREHOUSE */]]);
    },
    dropDownText: "Scrap Locally",
    action: function action() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__actions__["i" /* update */])({ status: __WEBPACK_IMPORTED_MODULE_3__constants__["_23" /* AWAITING_SCRAP_REPORT_LOCAL */] });
    },
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_51" /* SCRAP_INV_LOCALLY */]
  },
  scrapReportDownload: {
    authorized: function authorized(user) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["c" /* hasAnyOfRoles */])(user, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["j" /* WAREHOUSE */]]);
    },
    iconName: "cloud-download",
    dropDownText: "Download Scrap Cert",
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_6" /* DOWNLOAD_SCRAP_CERT */],
    rules: [function (inv) {
      return inv.condition === __WEBPACK_IMPORTED_MODULE_3__constants__["_52" /* SCRAP */];
    }]
  },
  scrapReportReceived: {
    iconName: "cloud-download",
    rules: [rules.inventoryUnlocked, rules.awaitingScrap],
    dropDownText: "Scrap Report Received",
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_15" /* SCRAP_REPORT_RECEIVED */]
  },
  splitInventory: {
    iconName: "code-fork",
    rules: [rules.canSplit],
    dropDownText: "Split Inventory",
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_16" /* SPLIT_INVENTORY */]
  },
  transfer: {
    rules: [rules.canTransfer],
    authorized: function authorized(user) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["c" /* hasAnyOfRoles */])(user, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["j" /* WAREHOUSE */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */]]);
    },
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_18" /* TRANSFER_INVENTORY */],
    dropDownText: "Transfer Inventory",
    iconName: "plane"
  },
  undoScrap: {
    text: "Are you sure you want to undo scrap?",
    iconName: "dollar",
    rules: [rules.undoScrap],
    dropDownText: "Undo Scrap",
    authorized: function authorized(user) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["c" /* hasAnyOfRoles */])(user, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["l" /* REPAIR */]]);
    },
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_52" /* SCRAP */]
  },
  unreserveForRepair: {
    text: "Are you sure you want to return this item to stock?",
    iconName: "plus-circle",
    rules: [rules.canUnreserveRepair],
    dropDownText: "Unreserve For Repair",
    authorized: function authorized(user) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["c" /* hasAnyOfRoles */])(user, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["l" /* REPAIR */]]);
    },
    action: __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* unreserveForRepair */],
    confirmText: "Yes, Return To Stock",
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_53" /* UNRESERVE_REPAIR */]
  },
  updateQCStatus: {
    iconName: "pause-circle",
    rules: [],
    dropDownText: "Update QC Status",
    authorized: function authorized(user, inv) {
      return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["e" /* hasPermission */])(user, __WEBPACK_IMPORTED_MODULE_2__users_constants__["_3" /* CAN_RELEASE_QC_HOLD */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["d" /* hasRole */])(user, __WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */]) || inv.receiving_line_item_type === "RepairOrderLineItem" && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["d" /* hasRole */])(user, __WEBPACK_IMPORTED_MODULE_2__users_constants__["l" /* REPAIR */])) && !inv.managed_repair_in_progress;
    },
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_11" /* UPDATE_QC_STATUS */]
  },
  updateSrp: {
    iconName: "dollar",
    rules: [function (inv) {
      return inv.status !== __WEBPACK_IMPORTED_MODULE_3__constants__["_33" /* GONE */];
    }],
    dropDownText: "Update SRP",
    authorized: function authorized(user, inv) {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["d" /* isManagedRepair */])(inv);
    },
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_12" /* UPDATE_SRP */]
  },
  vendorRmaRequest: {
    iconName: "shield",
    rules: [rules.notGone, function (inv) {
      return ![__WEBPACK_IMPORTED_MODULE_3__constants__["R" /* CUSTOMER_RMA_REQUESTED */], __WEBPACK_IMPORTED_MODULE_3__constants__["_36" /* VENDOR_RMA_REQUESTED */], __WEBPACK_IMPORTED_MODULE_3__constants__["_40" /* RMA_RECEIVED */], __WEBPACK_IMPORTED_MODULE_3__constants__["_35" /* RETURNING_TO_CUSTOMER */]].includes(inv.status) && !inv.managed_repair_repaired && !inv.managed_repair_in_progress;
    }],
    authorized: function authorized(user) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["d" /* hasRole */])(user, __WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__users_helpers__["e" /* hasPermission */])(user, __WEBPACK_IMPORTED_MODULE_2__users_constants__["_4" /* CREATE_VENDOR_RMAS */]);
    },
    key: __WEBPACK_IMPORTED_MODULE_3__constants__["_17" /* CREATE_VENDOR_RMA */],
    dropDownText: "RMA/Partial Credit Request"
  }
});

/***/ }),
/* 2099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_RecordPager_RecordPager__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Warnings__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InventoryDropdown__ = __webpack_require__(2100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PartLabel__ = __webpack_require__(2101);
/* unused harmony export Header */














function Header(_ref) {
  var inventory = _ref.inventory,
      location = _ref.location;

  var append = location.pathname.includes("/all");
  var getUrl = function getUrl(baseUrl, id) {
    return append ? baseUrl + "/" + id + "/all" : baseUrl + "/" + id;
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "page-header page-header-bar with-padding" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h1",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "btn-group pull-right", style: { marginLeft: 20 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__InventoryDropdown__["a" /* default */], { inventory: inventory })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_RecordPager_RecordPager__["a" /* default */], {
        getUrl: getUrl,
        baseUrl: "/inventories",
        record: inventory
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__PartLabel__["a" /* default */], { part: inventory.get(__WEBPACK_IMPORTED_MODULE_7__parts_constants__["B" /* PART */]) }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["E" /* ClipboardCopy */], { name: inventory.getIn([__WEBPACK_IMPORTED_MODULE_7__parts_constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_7__parts_constants__["w" /* PART_NUMBER */]]), type: "PN" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "small text-muted" },
        inventory.getIn([__WEBPACK_IMPORTED_MODULE_7__parts_constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_7__parts_constants__["u" /* DESCRIPTION */]])
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "pull-right" },
        "SRP: ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(inventory.get(__WEBPACK_IMPORTED_MODULE_8__constants__["v" /* SUGGESTED_RETAIL */]))
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "alert-group pull-right" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Warnings__["b" /* default */], { inventory: inventory.toJS() })
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router__["withRouter"])(Header));

Header.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pathname: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired
};

/***/ }),
/* 2100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Authorized__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_ActionDropDown_ActionDropDown__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DropdownActions__ = __webpack_require__(464);
/* harmony export (immutable) */ __webpack_exports__["a"] = InventoryDropdown;









var renderRows = function renderRows(inventory, config) {
  return Object.keys(config).map(function (key) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DropdownActions__["m" /* default */], { inventory: inventory, config: config[key], key: key });
  });
};

function InventoryDropdown(_ref) {
  var inventory = _ref.inventory;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Authorized__["a" /* default */],
    {
      roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_3__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_3__users_constants__["j" /* WAREHOUSE */]),
      subroles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_3__users_constants__["w" /* SUBROLES */], __WEBPACK_IMPORTED_MODULE_3__users_constants__["r" /* WAREHOUSE_BASIC */]),
      permissions: [__WEBPACK_IMPORTED_MODULE_3__users_constants__["_3" /* CAN_RELEASE_QC_HOLD */], __WEBPACK_IMPORTED_MODULE_3__users_constants__["_4" /* CREATE_VENDOR_RMAS */]]
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components_ActionDropDown_ActionDropDown__["a" /* default */],
      {
        menuClass: "dropdown-menu-right",
        style: { cursor: "pointer" }
      },
      renderRows(inventory, __WEBPACK_IMPORTED_MODULE_7__DropdownActions__["a" /* Config */])
    )
  );
}

InventoryDropdown.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

/***/ }),
/* 2101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_constants__ = __webpack_require__(23);








function PartLabel(_ref) {
  var part = _ref.part;

  var tierType = part.get(__WEBPACK_IMPORTED_MODULE_5__parts_constants__["O" /* TIER_TYPE */]);

  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()("header-content", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_helpers__["a" /* getPartNumberColorClassNameByTierType */])(tierType));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: classes },
    part.get(__WEBPACK_IMPORTED_MODULE_5__parts_constants__["w" /* PART_NUMBER */])
  );
}

PartLabel.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

/* harmony default export */ __webpack_exports__["a"] = (PartLabel);

/***/ }),
/* 2102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(2099);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Header__["a"]; });



/***/ }),
/* 2103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(12);
/* harmony export (immutable) */ __webpack_exports__["a"] = InventoryStatusLabel;




var labelStyle = function labelStyle(status) {
  if (status === __WEBPACK_IMPORTED_MODULE_2__constants__["_43" /* IN_STOCK */]) {
    return { color: "#4caf50" };
  }
  return {};
};

var icon = function icon(status) {
  if (status === __WEBPACK_IMPORTED_MODULE_2__constants__["_43" /* IN_STOCK */]) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check" });
  }
  return null;
};

var UNIFIED_INVENTORY_STATUSES = Object.assign({}, __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* STATUSES */], __WEBPACK_IMPORTED_MODULE_2__constants__["_84" /* REPAIR_STATUSES */]);

var formatRepairAndHold = function formatRepairAndHold(items) {
  return items[0].repair_and_hold_lead_time === 0 ? "Repair & Hold" : "Repair & Hold - LT (" + items[0].repair_and_hold_lead_time + " days)";
};

var getDisplayStatus = function getDisplayStatus(_ref) {
  var inventoryStatus = _ref.inventoryStatus,
      repairStatus = _ref.repairStatus,
      transferStatus = _ref.transferStatus;

  if (__WEBPACK_IMPORTED_MODULE_2__constants__["_83" /* CURRENTLY_REPAIRING_STATUSES */][repairStatus] && ![__WEBPACK_IMPORTED_MODULE_2__constants__["_42" /* DISCREPANCY_REPORTED */], __WEBPACK_IMPORTED_MODULE_2__constants__["_33" /* GONE */], __WEBPACK_IMPORTED_MODULE_2__constants__["V" /* RESERVE_FOR_SALE */], __WEBPACK_IMPORTED_MODULE_2__constants__["_30" /* SALES_ORDER_CREATED */], __WEBPACK_IMPORTED_MODULE_2__constants__["_36" /* VENDOR_RMA_REQUESTED */]].includes(inventoryStatus) || repairStatus === __WEBPACK_IMPORTED_MODULE_2__constants__["_47" /* CORE_RETURNED_TO_CUSTOMER */]) {
    return repairStatus;
  } else if (inventoryStatus === __WEBPACK_IMPORTED_MODULE_2__constants__["_43" /* IN_STOCK */] && __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* CURRENTLY_TRANSFERRING_STATUSES */].includes(transferStatus)) {
    return transferStatus;
  }

  return inventoryStatus;
};

function InventoryStatusLabel(_ref2) {
  var _ref2$inventory = _ref2.inventory,
      inventoryStatus = _ref2$inventory.status,
      repairStatus = _ref2$inventory.repair_status,
      repairOrderLineItems = _ref2$inventory.repair_order_line_items,
      transferStatus = _ref2$inventory.transfer_status;

  var status = getDisplayStatus({
    inventoryStatus: inventoryStatus,
    repairStatus: repairStatus,
    transferStatus: transferStatus
  });

  if (repairStatus === __WEBPACK_IMPORTED_MODULE_2__constants__["k" /* REPAIR_AND_HOLD */] && [__WEBPACK_IMPORTED_MODULE_2__constants__["_60" /* REPAIRING */], __WEBPACK_IMPORTED_MODULE_2__constants__["_43" /* IN_STOCK */]].includes(inventoryStatus)) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      null,
      formatRepairAndHold(repairOrderLineItems)
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { style: labelStyle(status) },
    icon(status),
    " ",
    UNIFIED_INVENTORY_STATUSES[status].label
  );
}

InventoryStatusLabel.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/***/ }),
/* 2104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = ListingOverrideLabel;



var label = function label(status) {
  switch (status) {
    case true:
      return "List";
    case false:
      return "Do Not List";
    default:
      return "None";
  }
};

function ListingOverrideLabel(_ref) {
  var status = _ref.status;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    label(status)
  );
}

ListingOverrideLabel.propTypes = {
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 2105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);







var MinimumSrpWarning = function MinimumSrpWarning(_ref) {
  var minExchangeSrp = _ref.minExchangeSrp,
      value = _ref.value;

  var minimum = minExchangeSrp || 400;

  if (value && Number(value) < minimum) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components__["n" /* Warning */],
      null,
      "Exchange SRP minimum is ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(minimum),
      "."
    );
  }

  return null;
};

MinimumSrpWarning.propTypes = {
  minExchangeSrp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    minExchangeSrp: state.session.getIn([__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_5__constants__["X" /* MINIMUM_EXCHANGE_SRP */]])
  };
})(MinimumSrpWarning));

/***/ }),
/* 2106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_DetailTable_Detail__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(36);







function PurchaseDetails(_ref) {
  var inventory = _ref.inventory;

  if (inventory.purchase_order_code) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_DetailTable_Detail__["a" /* default */], {
        label: "Recent PO#",
        renderIfPresent: true,
        value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["V" /* PoCode */], { inventory: inventory })
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_DetailTable_Detail__["a" /* default */], {
        label: "Vendor Name",
        renderIfPresent: true,
        value: inventory.po_vendor_name
      })
    );
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(inventory, "lot_details.code")) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_DetailTable_Detail__["a" /* default */], {
        label: "Lot",
        value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],
          { to: "/lots/" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(inventory, "lot_details.uuid") },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(inventory, "lot_details.code")
        ),
        renderIfPresent: true
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_DetailTable_Detail__["a" /* default */], {
        label: "Lot Vendor",
        value: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],
          {
            to: "/companies/" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(inventory, "lot_details.company.uuid")
          },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["get"])(inventory, "lot_details.company.name")
        ),
        renderIfPresent: true
      })
    );
  }

  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (PurchaseDetails);

PurchaseDetails.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = ScrapReportStatusLabel;



var statusText = function statusText(scrapReportStatus) {
  if (scrapReportStatus) {
    return "Received";
  }
  return "Awaiting";
};

var labelStyle = function labelStyle(scrapReportStatus) {
  if (scrapReportStatus) {
    return { color: "#4caf50" };
  }

  return {};
};

var icon = function icon(scrapReportStatus) {
  if (scrapReportStatus) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check" });
  }
  return null;
};

function ScrapReportStatusLabel(_ref) {
  var scrapReportStatus = _ref.scrapReportStatus;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { style: labelStyle(scrapReportStatus) },
    icon(scrapReportStatus),
    " ",
    statusText(scrapReportStatus)
  );
}

ScrapReportStatusLabel.propTypes = {
  scrapReportStatus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 2108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Detail__ = __webpack_require__(2045);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Detail__["a"]; });



/***/ }),
/* 2109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Form__ = __webpack_require__(2110);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditInventory;















function EditInventory(_ref) {
  var open = _ref.open,
      close = _ref.close,
      inventory = _ref.inventory,
      lockInventory = _ref.lockInventory;

  var jsInventory = inventory.toJS();
  var initialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["pick"])(jsInventory, ["revision_number", __WEBPACK_IMPORTED_MODULE_4__constants__["_85" /* AIRCRAFT_REFERENCE_NUMBER */], __WEBPACK_IMPORTED_MODULE_4__constants__["_86" /* AIRCRAFT_TAIL_NUMBER */], __WEBPACK_IMPORTED_MODULE_4__constants__["_87" /* ASA */], __WEBPACK_IMPORTED_MODULE_5__constants__["G" /* BUYER_CREDIT_PCT */], __WEBPACK_IMPORTED_MODULE_4__constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_9__users_constants__["z" /* CO_BUYER_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_4__constants__["_71" /* CONSIGNMENT_TYPE */], __WEBPACK_IMPORTED_MODULE_6__Receiving_constants__["I" /* CONSIGNOR_PERCENTAGE */], __WEBPACK_IMPORTED_MODULE_6__Receiving_constants__["F" /* CONSIGNMENT_REFERENCE */], "correct_serial_number", __WEBPACK_IMPORTED_MODULE_7__companies_constants__["t" /* DER */], __WEBPACK_IMPORTED_MODULE_8__parts_constants__["G" /* DOM */], __WEBPACK_IMPORTED_MODULE_4__constants__["_88" /* DO_NOT_EXCHANGE */], "do_not_sell_reason", __WEBPACK_IMPORTED_MODULE_4__constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* EXCHANGE_SRP */], __WEBPACK_IMPORTED_MODULE_4__constants__["y" /* EXPIRATION */], __WEBPACK_IMPORTED_MODULE_4__constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_4__constants__["_89" /* FREIGHT_COMPLETE */], __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ID */], __WEBPACK_IMPORTED_MODULE_7__companies_constants__["u" /* IMPERFECT_TRACE */], __WEBPACK_IMPORTED_MODULE_7__companies_constants__["a" /* IMPERFECT_TRACE_REASON */], __WEBPACK_IMPORTED_MODULE_10__PurchaseOrders_constants__["a" /* INCIDENT */], __WEBPACK_IMPORTED_MODULE_4__constants__["_90" /* LAST_SRP_REASON_CHANGED */], __WEBPACK_IMPORTED_MODULE_4__constants__["_91" /* LISTING_OVERRIDE */], __WEBPACK_IMPORTED_MODULE_4__constants__["_0" /* LOCATION */], __WEBPACK_IMPORTED_MODULE_4__constants__["N" /* OTHER_TAG_TYPE */], __WEBPACK_IMPORTED_MODULE_4__constants__["q" /* PART_ID */], __WEBPACK_IMPORTED_MODULE_8__parts_constants__["_32" /* PMA */], __WEBPACK_IMPORTED_MODULE_5__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* RESERVE_FOR_REPAIR */], __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* UNSELLABLE_PER_USER */], __WEBPACK_IMPORTED_MODULE_4__constants__["o" /* SERIAL_NUMBER */], "serial_number_correction_required", __WEBPACK_IMPORTED_MODULE_4__constants__["C" /* SRP_CONDITION */], __WEBPACK_IMPORTED_MODULE_4__constants__["_27" /* STORE_LOCATION_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["_64" /* STORE_OWNER_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["v" /* SUGGESTED_RETAIL */], __WEBPACK_IMPORTED_MODULE_4__constants__["x" /* TAG_DATE */], __WEBPACK_IMPORTED_MODULE_4__constants__["p" /* TAGGED_BY */], __WEBPACK_IMPORTED_MODULE_4__constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_9__users_constants__["y" /* THIRD_BUYER_ID */], __WEBPACK_IMPORTED_MODULE_8__parts_constants__["F" /* TOTAL_CYCLES */], __WEBPACK_IMPORTED_MODULE_8__parts_constants__["E" /* TOTAL_HOURS */], __WEBPACK_IMPORTED_MODULE_4__constants__["E" /* TRACE_TYPE */], __WEBPACK_IMPORTED_MODULE_4__constants__["F" /* TRACED_TO */], __WEBPACK_IMPORTED_MODULE_4__constants__["L" /* UK_CAA */], __WEBPACK_IMPORTED_MODULE_4__constants__["_61" /* WARRANTY_OVERRIDE */], "ware_house_id", __WEBPACK_IMPORTED_MODULE_4__constants__["_2" /* MODIFIED */]]);

  initialValues[__WEBPACK_IMPORTED_MODULE_4__constants__["M" /* OTHER */]] = initialValues[__WEBPACK_IMPORTED_MODULE_4__constants__["N" /* OTHER_TAG_TYPE */]] && initialValues[__WEBPACK_IMPORTED_MODULE_4__constants__["N" /* OTHER_TAG_TYPE */]].length > 0;

  initialValues[__WEBPACK_IMPORTED_MODULE_4__constants__["s" /* TOTAL_HOURS_REMAINING */]] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers__["a" /* totalHoursRemaining */])(jsInventory.part, Number(jsInventory.total_hours));

  initialValues[__WEBPACK_IMPORTED_MODULE_4__constants__["t" /* TOTAL_CYCLES_REMAINING */]] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers__["b" /* totalCyclesRemaining */])(jsInventory.part, Number(jsInventory.total_cycles));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Inventory Details"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Form__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      inventory: inventory,
      lockInventory: lockInventory,
      enableReinitialize: true
    })
  );
}

EditInventory.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  lockInventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 2110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_shared__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_shared_BuyerStoreField__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__shared_components_Forms_MonthYearField_MonthYearField__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_components_NoteTooltip_AuditedNoteTooltip__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Locations_components_BuyingStoreRadioField__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__PurchaseOrders_shared_CoBuyersFields_CoBuyersFields__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__helpers__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__PurchaseOrders_shared_TierTypeExchangeSrpWarning__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ConditionWarning__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__validate__ = __webpack_require__(2112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__TagTypes__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__PurchaseOrders_shared_PreviousSrpConditionWarning__ = __webpack_require__(445);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







































var FORM_NAME = "editPart";

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedPart: {},
      selectedBuyer: {},
      selectedCoBuyer: {},
      selectedThirdBuyer: {},
      selectedInventory: {},
      passFailWarning: false
    }, _this.handlePartSelected = function (part) {
      _this.setState({ selectedPart: part });
    }, _this.handlePassFailWarning = function () {
      _this.setState({ passFailWarning: !_this.state.passFailWarning });
    }, _this.searchCompanies = function (filter) {
      if (filter && filter.match("N/A") && [__WEBPACK_IMPORTED_MODULE_13__constants__["_39" /* AS_REMOVED */], __WEBPACK_IMPORTED_MODULE_13__constants__["g" /* NEW_ITEM */]].includes(_this.props.getField(__WEBPACK_IMPORTED_MODULE_13__constants__["n" /* CONDITION */]))) {
        return Promise.resolve([{ name: "N/A" }]);
      }
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].companies.search({
        filter: filter,
        status: [__WEBPACK_IMPORTED_MODULE_22__companies_constants__["c" /* ACTIVE */], __WEBPACK_IMPORTED_MODULE_22__companies_constants__["d" /* CREDIT_HOLD */]].join(","),
        page: 1,
        limit: 20
      }).then(function (resp) {
        return resp.data.results;
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.inventory) {
        var inv = this.props.inventory.toJS();
        this.setState({
          selectedBuyer: inv.buyer,
          selectedCoBuyer: inv.co_buyer,
          selectedThirdBuyer: inv.third_buyer,
          selectedInventory: inv,
          selectedPart: inv.part,
          selectedRepairStatus: inv.repair_status
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          currentUser = _props.currentUser,
          getField = _props.getField,
          searchParts = _props.searchParts,
          inventory = _props.inventory,
          quantity = _props.quantity,
          condition = _props.condition,
          lockInventory = _props.lockInventory,
          searchBuyers = _props.searchBuyers,
          setField = _props.setField;
      var _state = this.state,
          selectedBuyer = _state.selectedBuyer,
          selectedCoBuyer = _state.selectedCoBuyer,
          selectedThirdBuyer = _state.selectedThirdBuyer,
          selectedInventory = _state.selectedInventory,
          selectedPart = _state.selectedPart,
          selectedRepairStatus = _state.selectedRepairStatus;


      var isNonBasicWarehouseUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_13__constants__["_92" /* WAREHOUSE */]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["a" /* hasAnyOfSubroles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_15__users_constants__["t" /* WAREHOUSE_EXPERT */], __WEBPACK_IMPORTED_MODULE_15__users_constants__["s" /* WAREHOUSE_MANAGER */], __WEBPACK_IMPORTED_MODULE_15__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]);

      var isAdminUser = currentUser.role === __WEBPACK_IMPORTED_MODULE_15__users_constants__["i" /* ADMIN */];
      var isRepairUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_15__users_constants__["l" /* REPAIR */]);
      var isQCUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_15__users_constants__["p" /* QUALITY_CONTROL */]);
      var isAccountingUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_15__users_constants__["m" /* ACCOUNTING */]);
      var isLLP = selectedPart && selectedPart.llp;

      var canEditFreightComplete = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_15__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_15__users_constants__["p" /* QUALITY_CONTROL */]]);

      var canOverrideListing = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["e" /* hasPermission */])(currentUser, __WEBPACK_IMPORTED_MODULE_15__users_constants__["_25" /* CAN_OVERRIDE_LISTING */]);

      var canReidentifySerial = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["a" /* hasAnyOfSubroles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_15__users_constants__["n" /* QUALITY_CONTROL_MANAGER */], __WEBPACK_IMPORTED_MODULE_15__users_constants__["o" /* QUALITY_CONTROL_ADMIN */]]);

      var disableFields = lockInventory && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_15__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_15__users_constants__["l" /* REPAIR */]]) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["g" /* hasSubRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_15__users_constants__["t" /* WAREHOUSE_EXPERT */]) && currentUser.role !== __WEBPACK_IMPORTED_MODULE_15__users_constants__["i" /* ADMIN */];

      var canEditTraceAndTagFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_15__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_15__users_constants__["l" /* REPAIR */]]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["a" /* hasAnyOfSubroles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_15__users_constants__["s" /* WAREHOUSE_MANAGER */], __WEBPACK_IMPORTED_MODULE_15__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */], __WEBPACK_IMPORTED_MODULE_15__users_constants__["t" /* WAREHOUSE_EXPERT */]]);

      var canEditFlags = isAdminUser || isNonBasicWarehouseUser || isRepairUser || isQCUser;

      var toggleBuyer = function toggleBuyer(buyer) {
        return _this2.setState(buyer);
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["q" /* PART_ID */],
                label: "Part #",
                placeholder: "Type a part's number...",
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["n" /* AutoCompleteField */],
                search: searchParts,
                selectedItem: selectedPart,
                formatItem: function formatItem(result) {
                  return result && result.part_number;
                },
                onItemSelected: function onItemSelected(i) {
                  return i && _this2.handlePartSelected(i);
                },
                disabled: disableFields || !isAdminUser && !isNonBasicWarehouseUser && !isRepairUser && !isQCUser,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["o" /* SERIAL_NUMBER */],
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                label: "Serial #",
                required: quantity > 1,
                disabled: disableFields || !isAdminUser && !isNonBasicWarehouseUser && !isRepairUser && !isQCUser
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_35__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Locations_components_BuyingStoreRadioField__["a" /* default */], {
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["_73" /* STORE_OWNER */]),
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["_64" /* STORE_OWNER_ID */],
                disabled: disableFields || !isAdminUser && !isAccountingUser && !isNonBasicWarehouseUser && !isRepairUser && !isQCUser,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Locations_components_BuyingStoreRadioField__["a" /* default */], {
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["_27" /* STORE_LOCATION_ID */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["_74" /* STORE_LOCATION */]),
                component: __WEBPACK_IMPORTED_MODULE_19__PurchaseOrders_shared_BuyerStoreField__["a" /* default */],
                disabled: disableFields || !isAdminUser && !isAccountingUser && !isNonBasicWarehouseUser && !isRepairUser && !isQCUser,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["_0" /* LOCATION */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["_0" /* LOCATION */]),
                disabled: disableFields || !isAdminUser && !isNonBasicWarehouseUser && !isRepairUser && !isQCUser,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_31_lodash___default.a.size(__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(currentUser, "tenant.ware_houses")) > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: "ware_house_id",
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                options: __WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(currentUser, "tenant.ware_houses", []).map(function (wareHouse) {
                  return {
                    value: wareHouse.id,
                    text: wareHouse.name
                  };
                }),
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["_92" /* WAREHOUSE */]),
                disabled: disableFields || !isAdminUser && !isNonBasicWarehouseUser && !isRepairUser && !isQCUser
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_18__shared_components__["b" /* Authorized */],
            {
              authorizedIf: function authorizedIf(user) {
                return user.get(__WEBPACK_IMPORTED_MODULE_15__users_constants__["h" /* ROLE */]) === __WEBPACK_IMPORTED_MODULE_15__users_constants__["i" /* ADMIN */] && inventory.get(__WEBPACK_IMPORTED_MODULE_13__constants__["_31" /* STATUS */]) !== __WEBPACK_IMPORTED_MODULE_13__constants__["_33" /* GONE */];
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_8__constants__["G" /* BUYER_CREDIT_PCT */],
                    className: "text-right",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: __WEBPACK_IMPORTED_MODULE_27__PurchaseOrders_constants__["_4" /* BUYER_CREDIT_PCT_OPTIONS */],
                    onChange: function onChange(_ev, val) {
                      if (["25.0", "50.0", null].includes(val)) {
                        setField(__WEBPACK_IMPORTED_MODULE_15__users_constants__["y" /* THIRD_BUYER_ID */])(null);
                        toggleBuyer({ selectedThirdBuyer: null });
                      }
                    },
                    label: "Buyer Credit",
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_shared__["c" /* BuyerField */], {
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_15__users_constants__["P" /* BUYER */]),
                    name: __WEBPACK_IMPORTED_MODULE_15__users_constants__["x" /* BUYER_ID */],
                    searchBuyers: searchBuyers,
                    selectedBuyer: selectedBuyer
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__PurchaseOrders_shared_CoBuyersFields_CoBuyersFields__["a" /* default */], {
                  buyerCreditPct: getField(__WEBPACK_IMPORTED_MODULE_8__constants__["G" /* BUYER_CREDIT_PCT */]),
                  selectedCoBuyer: selectedCoBuyer,
                  selectedThirdBuyer: selectedThirdBuyer,
                  colSize: 3,
                  searchBuyers: searchBuyers,
                  toggleBuyer: toggleBuyer,
                  numberOfBuyers: [getField(__WEBPACK_IMPORTED_MODULE_15__users_constants__["z" /* CO_BUYER_ID */]), getField(__WEBPACK_IMPORTED_MODULE_15__users_constants__["y" /* THIRD_BUYER_ID */])].filter(function (s) {
                    return s;
                  }).length + 1
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__PurchaseOrders_shared_TierTypeExchangeSrpWarning__["a" /* default */], {
            part: selectedPart,
            srp: getField(__WEBPACK_IMPORTED_MODULE_13__constants__["v" /* SUGGESTED_RETAIL */]),
            exchangeSrp: getField(__WEBPACK_IMPORTED_MODULE_13__constants__["u" /* EXCHANGE_SRP */])
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__PurchaseOrders_shared_PreviousSrpConditionWarning__["a" /* PreviousSrpConditionWarning */], {
            displayInventory: true,
            partId: selectedPart.id,
            srpCondition: getField(__WEBPACK_IMPORTED_MODULE_13__constants__["C" /* SRP_CONDITION */]),
            srp: getField(__WEBPACK_IMPORTED_MODULE_13__constants__["v" /* SUGGESTED_RETAIL */]),
            excludeInventoryId: this.props.inventory.get(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* ID */])
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["n" /* CONDITION */],
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_13__constants__["r" /* INVENTORIES */].condition),
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["n" /* CONDITION */]),
                disabled: disableFields || !isAdminUser && !isNonBasicWarehouseUser && !isRepairUser && !isQCUser,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["C" /* SRP_CONDITION */],
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_13__constants__["r" /* INVENTORIES */].condition),
                label: "SRP Condition",
                disabled: disableFields && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_15__users_constants__["k" /* SALES */]),
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["v" /* SUGGESTED_RETAIL */],
                label: ["SRP", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], {
                  field: __WEBPACK_IMPORTED_MODULE_13__constants__["v" /* SUGGESTED_RETAIL */],
                  obj: inventory.toJS()
                })],
                disabled: disableFields && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_15__users_constants__["k" /* SALES */])
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["u" /* EXCHANGE_SRP */],
                label: "Exchange SRP",
                disabled: disableFields && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_15__users_constants__["k" /* SALES */]) || getField(__WEBPACK_IMPORTED_MODULE_22__companies_constants__["k" /* DO_NOT_EXCHANGE */]),
                onFocus: this.handlePassFailWarning,
                onBlur: this.handlePassFailWarning
              })
            ),
            isLLP && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_26__parts_constants__["E" /* TOTAL_HOURS */],
                label: "Time Since New (Hours)",
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["h" /* NumberInput */],
                roundDigits: 0,
                onChange: function onChange(_e, val) {
                  return _this2.props.change(__WEBPACK_IMPORTED_MODULE_13__constants__["s" /* TOTAL_HOURS_REMAINING */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__helpers__["a" /* totalHoursRemaining */])(selectedPart, val));
                }
              })
            ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["s" /* TOTAL_HOURS_REMAINING */],
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["h" /* NumberInput */],
                roundDigits: 0,
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["s" /* TOTAL_HOURS_REMAINING */]),
                disabled: true
              })
            ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_26__parts_constants__["F" /* TOTAL_CYCLES */],
                label: "Cycles Since New",
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                onChange: function onChange(_e, val) {
                  return _this2.props.change(__WEBPACK_IMPORTED_MODULE_13__constants__["t" /* TOTAL_CYCLES_REMAINING */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__helpers__["b" /* totalCyclesRemaining */])(selectedPart, val));
                }
              })
            ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["t" /* TOTAL_CYCLES_REMAINING */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["t" /* TOTAL_CYCLES_REMAINING */]),
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                disabled: true
              })
            )]
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["E" /* TRACE_TYPE */],
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                required: getField(__WEBPACK_IMPORTED_MODULE_13__constants__["F" /* TRACED_TO */]),
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_14__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes),
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["E" /* TRACE_TYPE */]),
                disabled: disableFields || !canEditTraceAndTagFields
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["F" /* TRACED_TO */],
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["F" /* TRACED_TO */]),
                disabled: disableFields || !canEditTraceAndTagFields
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__shared_components_Forms_MonthYearField_MonthYearField__["a" /* default */], {
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["x" /* TAG_DATE */],
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["x" /* TAG_DATE */]),
                disabled: disableFields || !canEditTraceAndTagFields,
                required: [__WEBPACK_IMPORTED_MODULE_13__constants__["i" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_13__constants__["P" /* INSPECTED */], __WEBPACK_IMPORTED_MODULE_13__constants__["h" /* REPAIRED */]].includes(condition) && ![__WEBPACK_IMPORTED_MODULE_13__constants__["k" /* REPAIR_AND_HOLD */]].includes(selectedRepairStatus)
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["p" /* TAGGED_BY */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["p" /* TAGGED_BY */]),
                placeholder: "Search by a company's name",
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["s" /* AutoCompleteUserInputField */],
                search: this.searchCompanies,
                selectedItem: selectedInventory,
                handleTaggedBy: function handleTaggedBy() {
                  return null;
                },
                formatItem: function formatItem(result) {
                  return result && result.name || result.tagged_by;
                },
                disabled: disableFields || !canEditTraceAndTagFields
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["_85" /* AIRCRAFT_REFERENCE_NUMBER */],
                label: "Aircraft or Engine Ref # (MSN,ESN,etc.)"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["_86" /* AIRCRAFT_TAIL_NUMBER */],
                label: "Aircraft Tail #"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_35__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__shared_components_Forms_MonthYearField_MonthYearField__["a" /* default */], {
                disabled: disableFields || !isAdminUser && !isNonBasicWarehouseUser && !isRepairUser && !isQCUser,
                name: "dom",
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                label: "DOM"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["y" /* EXPIRATION */],
                type: "date",
                label: "exp",
                disabled: disableFields || !isAdminUser && !isNonBasicWarehouseUser && !isRepairUser && !isQCUser
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                { justified: true, title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["_93" /* FINAL_FREIGHT_CONFIRMED */]) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_13__constants__["_89" /* FREIGHT_COMPLETE */],
                  component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["_89" /* FREIGHT_COMPLETE */]),
                  disabled: !canEditFreightComplete
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_35__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: getField(__WEBPACK_IMPORTED_MODULE_22__companies_constants__["u" /* IMPERFECT_TRACE */]) ? 9 : 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                { justified: true, title: "Flags" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_22__companies_constants__["u" /* IMPERFECT_TRACE */],
                  component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_22__companies_constants__["u" /* IMPERFECT_TRACE */]),
                  disabled: !canEditFlags
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: "der",
                  component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                  label: "DER",
                  disabled: !canEditFlags
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: "pma",
                  component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                  label: "PMA",
                  disabled: !canEditFlags
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: "modified",
                  component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                  label: "Modified",
                  disabled: !canEditFlags
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_27__PurchaseOrders_constants__["a" /* INCIDENT */],
                  component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_27__PurchaseOrders_constants__["a" /* INCIDENT */]),
                  disabled: !canEditFlags
                })
              )
            ),
            getField(__WEBPACK_IMPORTED_MODULE_22__companies_constants__["u" /* IMPERFECT_TRACE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_22__companies_constants__["a" /* IMPERFECT_TRACE_REASON */],
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_13__constants__["_62" /* IMPERFECT_TRACE_REASONS */]),
                label: "Imperfect Trace Reason",
                disabled: disableFields || !canEditTraceAndTagFields
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_35__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Fields"], {
                names: [__WEBPACK_IMPORTED_MODULE_13__constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_13__constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_13__constants__["J" /* CAAC */], __WEBPACK_IMPORTED_MODULE_13__constants__["K" /* TCCA */], __WEBPACK_IMPORTED_MODULE_13__constants__["M" /* OTHER */], __WEBPACK_IMPORTED_MODULE_13__constants__["L" /* UK_CAA */], __WEBPACK_IMPORTED_MODULE_13__constants__["N" /* OTHER_TAG_TYPE */]],
                component: __WEBPACK_IMPORTED_MODULE_34__TagTypes__["a" /* default */],
                formName: FORM_NAME,
                disabled: !(isAdminUser || isNonBasicWarehouseUser || isRepairUser || isQCUser)
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_35__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                { justified: true, title: "SN Re-identification Reqd" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: "serial_number_correction_required",
                  component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                  label: "SN Re-identification Reqd",
                  disabled: !canReidentifySerial
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                name: "correct_serial_number",
                label: "Correct SN (appears to be)",
                disabled: !canReidentifySerial
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["_91" /* LISTING_OVERRIDE */],
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                onChange: function onChange(ev, val) {
                  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31_lodash__["isEmpty"])(val)) {
                    ev.preventDefault();
                    setField(__WEBPACK_IMPORTED_MODULE_13__constants__["_91" /* LISTING_OVERRIDE */])(null);
                  }
                },
                onBlur: function onBlur(ev) {
                  return ev.preventDefault();
                },
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_13__constants__["r" /* INVENTORIES */].listing_override),
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["_91" /* LISTING_OVERRIDE */]),
                disabled: !canOverrideListing
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                { title: "Do Not Exchange", justified: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_22__companies_constants__["k" /* DO_NOT_EXCHANGE */],
                  component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_22__companies_constants__["k" /* DO_NOT_EXCHANGE */]),
                  disabled: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["e" /* hasPermission */])(currentUser, __WEBPACK_IMPORTED_MODULE_15__users_constants__["A" /* CAN_EDIT_DO_NOT_EXCHANGE */]),
                  onChange: function onChange(_ev, val) {
                    if (val) setField(__WEBPACK_IMPORTED_MODULE_13__constants__["u" /* EXCHANGE_SRP */])(null);
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                { title: "Do Not Sell!", justified: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_13__constants__["z" /* UNSELLABLE_PER_USER */],
                  component: function component(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */], _extends({}, props, { icon: "fa-diamond" }));
                  },
                  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["h" /* disableIfHasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_13__constants__["_92" /* WAREHOUSE */]]),
                  label: "Do Not Sell!"
                })
              )
            ),
            getField(__WEBPACK_IMPORTED_MODULE_13__constants__["z" /* UNSELLABLE_PER_USER */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["A" /* DO_NOT_SELL_REASON */],
                label: "Reason for Do Not Sell?",
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                options: __WEBPACK_IMPORTED_MODULE_13__constants__["B" /* DO_NOT_SELL_REASON_OPTIONS */],
                required: true
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_35__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_forms__["f" /* arrayToOptions */])(__WEBPACK_IMPORTED_MODULE_13__constants__["_59" /* WARRANTY_OPTIONS */]),
                name: __WEBPACK_IMPORTED_MODULE_13__constants__["_61" /* WARRANTY_OVERRIDE */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["_61" /* WARRANTY_OVERRIDE */]),
                disabled: currentUser.role !== __WEBPACK_IMPORTED_MODULE_15__users_constants__["i" /* ADMIN */]
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_23__Receiving_constants__["F" /* CONSIGNMENT_REFERENCE */],
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                label: "Consignment #",
                disabled: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__users_helpers__["g" /* hasSubRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_15__users_constants__["n" /* QUALITY_CONTROL_MANAGER */])
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_23__Receiving_constants__["I" /* CONSIGNOR_PERCENTAGE */],
                component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                label: "Consignment Split",
                disabled: true
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__ConditionWarning__["a" /* default */], {
            inventoryCondition: inventory.get(__WEBPACK_IMPORTED_MODULE_13__constants__["n" /* CONDITION */]),
            condition: getField(__WEBPACK_IMPORTED_MODULE_13__constants__["n" /* CONDITION */]),
            canClose: false
          })
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchParts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ toJS: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func }),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  lockInventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["formValueSelector"])(FORM_NAME);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_15__users_constants__["a" /* USER */]).toJS(),
    id: state.partDetail.getIn([__WEBPACK_IMPORTED_MODULE_26__parts_constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_8__constants__["b" /* ID */]]),
    quantity: selector(state, __WEBPACK_IMPORTED_MODULE_8__constants__["j" /* QUANTITY */]),
    condition: selector(state, __WEBPACK_IMPORTED_MODULE_13__constants__["n" /* CONDITION */]),
    reserveForSellerId: selector(state, __WEBPACK_IMPORTED_MODULE_8__constants__["Z" /* RESERVE_FOR_SELLER_ID */]),
    getField: function getField(field) {
      return selector(state, field);
    },
    minExchangeSrp: state.session.getIn([__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_8__constants__["X" /* MINIMUM_EXCHANGE_SRP */]])
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_9__actions__["i" /* update */](data));
    },
    searchParts: function searchParts(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_10__parts_actions__["n" /* searchParts */](filter));
    },
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_actions__["c" /* searchBuyers */](filter));
    },
    setField: function setField(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_redux_form__["change"])(FORM_NAME, field, val));
      };
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_33__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 2111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditInventory__ = __webpack_require__(2109);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EditInventory__["a"]; });



/***/ }),
/* 2112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Detail_Header_DropdownActions_UpdateSrpStatus_Form__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parts_constants__ = __webpack_require__(23);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;








var meetsMinimumSrp = function meetsMinimumSrp(props) {
  return function (value) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Detail_Header_DropdownActions_UpdateSrpStatus_Form__["b" /* shouldShowWarning */])({
      inventory: props.inventory.toJS(),
      suggestedRetail: value
    })) {
      return "SRP must be greater than the estimated repair cost";
    }
    return undefined;
  };
};

function validate(values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["q" /* PART_ID */], __WEBPACK_IMPORTED_MODULE_3__constants__["_64" /* STORE_OWNER_ID */], __WEBPACK_IMPORTED_MODULE_3__constants__["_27" /* STORE_LOCATION_ID */], __WEBPACK_IMPORTED_MODULE_4__constants__["j" /* QUANTITY */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);

    if (values[__WEBPACK_IMPORTED_MODULE_3__constants__["_71" /* CONSIGNMENT_TYPE */]] !== __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__["s" /* EMA */]) {
      v.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["_0" /* LOCATION */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    v.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["o" /* SERIAL_NUMBER */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["w" /* requiredIfFieldGreaterThan */](__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* QUANTITY */], 1));

    if ([__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* OVERHAULED */], __WEBPACK_IMPORTED_MODULE_3__constants__["P" /* INSPECTED */], __WEBPACK_IMPORTED_MODULE_3__constants__["h" /* REPAIRED */]].includes(values.condition) && ![__WEBPACK_IMPORTED_MODULE_3__constants__["k" /* REPAIR_AND_HOLD */], "repair_and_hold_lead_time"].includes(props.inventory.get(__WEBPACK_IMPORTED_MODULE_3__constants__["j" /* REPAIR_STATUS */]))) {
      v.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["x" /* TAG_DATE */]).required();
    }

    if (values.serial_number_correction_required) {
      v.validate("correct_serial_number").required();
    }

    if (values.reserve_for_seller_id) {
      v.validate("received_date").required();
    }

    v.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["v" /* SUGGESTED_RETAIL */]).satisfies(meetsMinimumSrp(props));

    if (values.tagged_by === "N/A" && values.condition !== __WEBPACK_IMPORTED_MODULE_2__Receiving_constants__["R" /* SCRAP */]) {
      v.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["n" /* CONDITION */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["x" /* includesField */]([__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* NEW_ITEM */], __WEBPACK_IMPORTED_MODULE_3__constants__["_39" /* AS_REMOVED */]]));
    }

    if (values.other) {
      v.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["N" /* OTHER_TAG_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["o" /* maxLengthOfText */](30));
    }

    if (props.inventory.getIn([__WEBPACK_IMPORTED_MODULE_6__parts_constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_6__parts_constants__["U" /* PASS_FAIL */]])) {
      v.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["u" /* EXCHANGE_SRP */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["y" /* passFailValidation */]);
    }

    if (values.exchange_srp && props.minExchangeSrp) {
      v.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["u" /* EXCHANGE_SRP */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](props.minExchangeSrp));
    }

    if (values[__WEBPACK_IMPORTED_MODULE_3__constants__["F" /* TRACED_TO */]]) {
      v.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["E" /* TRACE_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if (values[__WEBPACK_IMPORTED_MODULE_3__constants__["z" /* UNSELLABLE_PER_USER */]]) {
      v.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["A" /* DO_NOT_SELL_REASON */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }
  });
}

/***/ }),
/* 2113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);





function BuildLink(_ref) {
  var parentType = _ref.parent_type,
      parentId = _ref.reference_record_id,
      id = _ref.reference_record_line_item_id,
      referenceNumber = _ref.reference_number,
      pushHistory = _ref.pushHistory;

  if (!parentType) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      referenceNumber
    );
  }

  var link = void 0;
  if (parentType === "rma") {
    link = "/rmas/" + id;
  } else if (parentType === "mistake_shipment") {
    link = "/mistake-shipments/" + id;
  } else {
    link = "/" + parentType.replaceAll("_", "-") + "/" + parentId;
  }
  var handleClick = function handleClick(ev) {
    ev.stopPropagation();
    pushHistory(link);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "a",
      { onClick: handleClick },
      referenceNumber
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    pushHistory: function pushHistory(url) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"])(url));
    }
  };
})(BuildLink));

BuildLink.propTypes = {
  parent_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  reference_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  reference_record_line_item_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  reference_record_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 2114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_DetailStat__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_StatsTooltip_format__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_useDebounce__ = __webpack_require__(201);
/* harmony export (immutable) */ __webpack_exports__["a"] = InventoryStats;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








function InventoryStats(_ref) {
  var alwaysDisplayBuyerStats = _ref.alwaysDisplayBuyerStats,
      filters = _ref.filters;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      stats = _useState2[0],
      setStats = _useState2[1];

  var latestRequestRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(0);
  var debouncedSearchArgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks_useDebounce__["a" /* default */])(300, Object.entries(filters).flatMap(function (pair) {
    return pair;
  }).join("-"));

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var currentRequest = latestRequestRef.current + 1;
    latestRequestRef.current = currentRequest;
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].inventories.stats(filters).then(function (res) {
      if (res.data) setStats(res.data);
      return function cleanup() {};
    });
  }, debouncedSearchArgs);

  var total = [stats.total_cost_0_to_6_months_dollars, stats.total_cost_6_to_12_months_dollars, stats.total_cost_12_to_18_months_dollars, stats.total_cost_18_to_INF_months_dollars].reduce(function (agg, v) {
    return agg + Number(v);
  }, 0);

  var totalBuyer = [stats.buyer_credit_0_to_6_months_dollars, stats.buyer_credit_6_to_12_months_dollars, stats.buyer_credit_12_to_18_months_dollars, stats.buyer_credit_18_to_INF_months_dollars].reduce(function (agg, v) {
    return agg + Number(v);
  }, 0);

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_DetailStat__["a" /* default */], { label: "Total", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_StatsTooltip_format__["b" /* dollar */])(total) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_DetailStat__["a" /* default */], {
      label: "Total Unapplied Lot Cost",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_StatsTooltip_format__["b" /* dollar */])(stats.total_unapplied_lot_cost)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_DetailStat__["a" /* default */], {
      label: "<6 mos",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_StatsTooltip_format__["b" /* dollar */])(stats.total_cost_0_to_6_months_dollars)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_DetailStat__["a" /* default */], {
      label: "6 to 12 mos",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_StatsTooltip_format__["b" /* dollar */])(stats.total_cost_6_to_12_months_dollars)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_DetailStat__["a" /* default */], {
      label: "12 to 18 mos",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_StatsTooltip_format__["b" /* dollar */])(stats.total_cost_12_to_18_months_dollars)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_DetailStat__["a" /* default */], {
      label: ">18 mos",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_StatsTooltip_format__["b" /* dollar */])(stats.total_cost_18_to_INF_months_dollars)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 1, sm: 1 },
      "\xA0"
    )
  ), (filters.buyer_id || alwaysDisplayBuyerStats) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 1, sm: 1 },
      "\xA0"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_DetailStat__["a" /* default */], { label: "Total", value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_StatsTooltip_format__["b" /* dollar */])(totalBuyer) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_DetailStat__["a" /* default */], {
      label: "<6 mos Buyer Credit",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_StatsTooltip_format__["b" /* dollar */])(stats.buyer_credit_0_to_6_months_dollars)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_DetailStat__["a" /* default */], {
      label: "6 to 12 mos Buyer Credit",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_StatsTooltip_format__["b" /* dollar */])(stats.buyer_credit_6_to_12_months_dollars)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_DetailStat__["a" /* default */], {
      label: "12 to 18 mos Buyer Credit",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_StatsTooltip_format__["b" /* dollar */])(stats.buyer_credit_12_to_18_months_dollars)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_StatsTooltip_DetailStat__["a" /* default */], {
      label: ">18 mos Buyer Credit",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_StatsTooltip_format__["b" /* dollar */])(stats.buyer_credit_18_to_INF_months_dollars)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 1, sm: 1 },
      "\xA0"
    )
  )];
}

/***/ }),
/* 2115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__InventoryStats__ = __webpack_require__(2114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Table__ = __webpack_require__(2116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Title__ = __webpack_require__(2117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pagination__ = __webpack_require__(465);
/* unused harmony export InventoriesSearch */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var defaultFilters = {
  as_removed: undefined,
  beyond_econ_repair: undefined,
  inspected: undefined,
  sellable_red_status: undefined,
  sellable_green_status: undefined,
  sellable_yellow_status: undefined,
  no_srp: undefined,
  not_gone: undefined,
  has_cost: undefined,
  qc_status: undefined,
  new_item: undefined,
  open_discrepancies: undefined,
  location_at_shop: undefined,
  out_on_exchange: undefined,
  out_of_stock: undefined,
  overhauled: undefined,
  repaired: undefined,
  scrap: undefined,
  date_received_under_6_mos: undefined,
  date_received_6_to_12_mos: undefined,
  date_received_12_to_18_mos: undefined,
  date_received_over_18_mos: undefined,
  repair_and_hold: undefined,
  repair_and_hold_lead_time: undefined,
  status: undefined,
  condition: undefined,
  has_scrap_report: undefined,
  parts_unit: undefined,
  tier_type: undefined,
  transfer: undefined,
  consignment: undefined,
  lot: undefined,
  tag_date: undefined,
  store_owner_id: undefined,
  do_not_sell: undefined,
  do_not_list: undefined,
  do_not_exchange: undefined,
  my_inventory: undefined
};

var baseFilters = [{
  label: "Color Bar = Green",
  filters: { sellable_green_status: __WEBPACK_IMPORTED_MODULE_13__constants__["U" /* LIST */] }
}, {
  label: "Color Bar = Yellow",
  filters: { sellable_yellow_status: __WEBPACK_IMPORTED_MODULE_13__constants__["W" /* DO_NOT_LIST */] }
}, {
  label: "Color Bar = Red",
  filters: { sellable_red_status: __WEBPACK_IMPORTED_MODULE_13__constants__["X" /* DO_NOT_SELL */] }
}, {
  label: "Overhauled",
  filters: { overhauled: true }
}, {
  label: "Repaired",
  filters: { repaired: true }
}, {
  label: "Inspected",
  filters: { inspected: true }
}, {
  label: "New",
  filters: { new_item: true }
}, {
  label: "As Removed",
  filters: { as_removed: true }
}, {
  label: "Beyond Repair",
  filters: { beyond_econ_repair: true }
}, {
  label: "Parts Unit",
  filters: { parts_unit: true }
}, {
  label: "Scrap",
  filters: { scrap: true }
}, {
  label: "No SRP",
  filters: { no_srp: true }
}, {
  label: "Only Remaining Inventory",
  filters: { not_gone: true }
}, {
  label: "Gone from Stock Inventory",
  filters: { out_of_stock: true }
}, {
  label: "Inventory with Remaining Cost",
  filters: { has_cost: true }
}, {
  label: "Inventory with QC Hold",
  filters: { qc_status: __WEBPACK_IMPORTED_MODULE_13__constants__["S" /* QC_HOLD */] }
}, {
  label: "Inventory with Open Discrepancy",
  filters: { open_discrepancies: true }
}, {
  label: "Location @Shop",
  filters: { location_at_shop: true }
}, {
  label: "Out On Exchange",
  filters: { status: __WEBPACK_IMPORTED_MODULE_13__constants__["m" /* OUT_ON_EXCHANGE */] }
}, {
  label: "Date Received - < 6 mos",
  filters: { date_received_under_6_mos: true }
}, {
  label: "Date Received - 6 to 12 mos",
  filters: { date_received_6_to_12_mos: true }
}, {
  label: "Date Received - 12 to 18 mos",
  filters: { date_received_12_to_18_mos: true }
}, {
  label: "Date Received - > 18 mos",
  filters: { date_received_over_18_mos: true }
}, {
  label: "Do Not List",
  filters: { do_not_list: true }
}, {
  label: "Do Not Sell",
  filters: { do_not_sell: true }
}, {
  label: "Do Not Exchange",
  filters: { do_not_exchange: true }
}, {
  label: "Reserved For Sale",
  filters: { status: "reserve_for_sale,on_order_for_sale" }
}, {
  label: "Reserved For Repair",
  filters: { repair_status: "reserve_for_repair" }
}, {
  label: "Sold",
  filters: { sold: true }
}, {
  label: "Tag Date > 5 Years",
  filters: { tag_date: "over_5_years" }
}, {
  label: "All Scrapped Inventory",
  filters: { condition: __WEBPACK_IMPORTED_MODULE_13__constants__["_52" /* SCRAP */], status: __WEBPACK_IMPORTED_MODULE_13__constants__["_33" /* GONE */], has_scrap_report: true }
}, {
  label: "Only 5 Star",
  filters: { tier_type: __WEBPACK_IMPORTED_MODULE_12__parts_constants__["b" /* SATL */] },
  withAuthorization: { roles: [__WEBPACK_IMPORTED_MODULE_10__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["i" /* ADMIN */]] }
}, {
  label: "Only 4 Star",
  filters: { tier_type: __WEBPACK_IMPORTED_MODULE_12__parts_constants__["c" /* ATL */] },
  withAuthorization: { roles: [__WEBPACK_IMPORTED_MODULE_10__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["i" /* ADMIN */]] }
}, {
  label: "Only 3 Star",
  filters: { tier_type: __WEBPACK_IMPORTED_MODULE_12__parts_constants__["e" /* BTL */] },
  withAuthorization: { roles: [__WEBPACK_IMPORTED_MODULE_10__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["i" /* ADMIN */]] }
}, {
  label: "Only 2 Star",
  filters: { tier_type: __WEBPACK_IMPORTED_MODULE_12__parts_constants__["f" /* BBTL */] },
  withAuthorization: { roles: [__WEBPACK_IMPORTED_MODULE_10__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["i" /* ADMIN */]] }
}, {
  label: "Only 1 Star",
  filters: { tier_type: __WEBPACK_IMPORTED_MODULE_12__parts_constants__["d" /* ZTL */] },
  withAuthorization: { roles: [__WEBPACK_IMPORTED_MODULE_10__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["i" /* ADMIN */]] }
}, {
  label: "Non-Qualifiers",
  filters: { tier_type: "" },
  withAuthorization: { roles: [__WEBPACK_IMPORTED_MODULE_10__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["i" /* ADMIN */]] }
}, {
  label: "Active Transfer",
  filters: { transfer: true }
}, {
  label: "Repair & Hold",
  filters: { repair_and_hold: true }
}, {
  label: "Repair & Hold - LT",
  filters: { repair_and_hold_lead_time: true }
}, {
  label: "Consignment Inventory",
  filters: { consignment: __WEBPACK_IMPORTED_MODULE_16__Receiving_constants__["t" /* CONSIGNMENT */], lot: undefined }
}, {
  label: "Lot Inventory",
  filters: { lot: true, consignment: undefined }
}, {
  label: "EMA Inventory",
  filters: { consignment: __WEBPACK_IMPORTED_MODULE_16__Receiving_constants__["s" /* EMA */], lot: undefined }
}, {
  label: "Exclude Cons/EMAs",
  filters: { consignment: undefined, exclude_consignment: true }
}];

var myInventoryFilter = {
  label: "My Inventory",
  filters: { my_inventory: true }
};

var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = searchProps.paginator.get("filters").toJS();
  var inventoryTotalCount = searchProps.paginator.get("totalCount");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        if (inventoryTotalCount > __WEBPACK_IMPORTED_MODULE_10__users_constants__["_6" /* EXPORT_LIMIT */]) {
          __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].info("Processing Report.");
          __WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].inventories.export(params).then(function () {
            __WEBPACK_IMPORTED_MODULE_14__lib_submission__["a" /* SUCCESS */];
          });
        } else {
          window.open(__WEBPACK_IMPORTED_MODULE_7__constants__["d" /* API_BASE */] + "/inventories/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_query_string__["stringify"])(params), "_blank");
          __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].success("Processing Inventory Report. Please wait for the PDF to generate.");
        }
      }
    },
    "Export"
  );
};

ExportButton.propTypes = {
  searchProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    paginator: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map)
  })
};

var meetsExportCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var searchProps = _ref2.searchProps,
      currentUser = _ref2.currentUser;
  return searchProps.paginator.get("totalCount") <= __WEBPACK_IMPORTED_MODULE_10__users_constants__["_6" /* EXPORT_LIMIT */] || currentUser.get(__WEBPACK_IMPORTED_MODULE_10__users_constants__["h" /* ROLE */]) === __WEBPACK_IMPORTED_MODULE_10__users_constants__["i" /* ADMIN */];
});

var DecoratedExportButton = meetsExportCriteria(ExportButton);

var InventoriesSearch = function (_Component) {
  _inherits(InventoriesSearch, _Component);

  function InventoriesSearch() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, InventoriesSearch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = InventoriesSearch.__proto__ || Object.getPrototypeOf(InventoriesSearch)).call.apply(_ref3, [this].concat(args))), _this), _this.state = _extends({
      allSearchedApplications: [],
      applications: [],
      applicationSearch: "",
      applicationSearchOpen: false,
      buyersFilter: [],
      wareHouseFilter: [],
      buyersTags: []
    }, __WEBPACK_IMPORTED_MODULE_17__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]), _this.searchApplications = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lodash__["debounce"])(function (search) {
      if (search && search.length > 1) {
        Promise.all([__WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].engines.search({ limit: 100, filter: search }).then(function (_ref4) {
          var results = _ref4.data.results;
          return results.map(function (e) {
            return e.model_number;
          });
        }), __WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].aircrafts.search({ limit: 100, filter: search }).then(function (_ref5) {
          var results = _ref5.data.results;
          return results.map(function (e) {
            return e.model_number;
          });
        })]).then(function (models) {
          _this.setState({
            allSearchedApplications: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lodash__["uniq"])(_this.state.allSearchedApplications.concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lodash__["flatten"])(models))),
            applications: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lodash__["flatten"])(models)
          });
        });
      }
    }, 500), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InventoriesSearch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_11__api__["a" /* default */].users.search({
        all_buyers: true,
        page: 1,
        sort: __WEBPACK_IMPORTED_MODULE_10__users_constants__["J" /* FIRST_NAME */],
        reverse: false,
        limit: 1000
      }).then(function (resp) {
        var buyers = resp.data.results;
        var buyersOptions = buyers.map(function (b) {
          return {
            label: b.full_name,
            filters: { buyer_id: b.id }
          };
        });
        var buyersTags = buyers.map(function (b) {
          return {
            label: b.full_name,
            key: __WEBPACK_IMPORTED_MODULE_10__users_constants__["x" /* BUYER_ID */],
            matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["a" /* matchesBoolean */])(b.id)
          };
        }).concat([{
          label: "Everyone Combined",
          key: __WEBPACK_IMPORTED_MODULE_10__users_constants__["x" /* BUYER_ID */],
          matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_filters__["b" /* matchesString */])("all")
        }]);

        _this2.setState({
          buyersFilter: [{
            label: "View All",
            filters: { buyer_id: undefined }
          }].concat(buyersOptions),
          wareHouseFilter: [{
            label: "View All",
            filters: { ware_house_id: undefined }
          }].concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lodash__["get"])(_this2.props.currentUser.toJS(), "tenant.ware_houses", []).map(function (w) {
            return { label: w.name, filters: { ware_house_id: w.id } };
          })),
          buyersTags: buyersTags
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var currentUser = this.props.currentUser;
      var _state = this.state,
          applications = _state.applications,
          applicationSearch = _state.applicationSearch,
          applicationSearchOpen = _state.applicationSearchOpen;

      var displayBuyersFilter = ![__WEBPACK_IMPORTED_MODULE_10__users_constants__["k" /* SALES */]].includes(currentUser.get(__WEBPACK_IMPORTED_MODULE_10__users_constants__["h" /* ROLE */]));
      var displayWarehouseFilter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lodash__["get"])(currentUser.toJS(), "tenant.ware_houses", []).length > 0;

      var userPermissions = currentUser.get("permissions", []);

      var shouldShowMyInventory = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__users_helpers__["c" /* hasAnyOfRoles */])(currentUser.toJS(), [__WEBPACK_IMPORTED_MODULE_10__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["p" /* QUALITY_CONTROL */]]) || userPermissions.includes(__WEBPACK_IMPORTED_MODULE_10__users_constants__["_26" /* CAN_VIEW_ALL_INVENTORY */]);

      var finalFilters = [].concat(baseFilters);
      if (shouldShowMyInventory) {
        finalFilters.unshift(myInventoryFilter);
      }

      var filterWithLocations = currentUser.toJS().locations.map(function (l) {
        return {
          label: "Store Owner " + l.name,
          filters: { store_owner_id: l.id }
        };
      });

      var applicationFilters = applications.map(function (k) {
        return {
          label: k,
          filters: _defineProperty({}, ("application_" + k).replace(/-|,|\(|\)| |]/g, "_"), true)
        };
      });

      var applicationTags = this.state.allSearchedApplications.map(function (k) {
        return {
          label: k,
          key: ("application_" + k).replace(/-|,|\(|\)| |]/g, "_")
        };
      });

      var tags = finalFilters.concat(applicationTags);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__shared_components__["c" /* Search */],
        { search: __WEBPACK_IMPORTED_MODULE_22__pagination__["a" /* default */], syncWithUrl: true },
        function (searchProps) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "input-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
                  placeholder: "Search by typing a part #, inv loc, serial #, desc., consignor, cons #, traced to, tagged by, lpo #, A/C ref # or tail #..."
                })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DecoratedExportButton, {
                  searchProps: searchProps,
                  currentUser: currentUser
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["e" /* SearchableFilterSelect */], _extends({}, searchProps, {
                  filters: applicationFilters,
                  right: true,
                  searchValue: applicationSearch,
                  title: "Appl.",
                  visible: applicationSearchOpen,
                  toggle: function toggle() {
                    _this3.setState({
                      applicationSearchOpen: !applicationSearchOpen
                    });
                  },
                  searchFilters: function searchFilters(e) {
                    var val = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lodash__["get"])(e, "target.value", "");
                    _this3.searchApplications(val);
                    _this3.setState({
                      applicationSearch: val
                    });
                  }
                })),
                displayBuyersFilter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
                  title: "Buyer",
                  filters: _this3.state.buyersFilter,
                  right: true
                })),
                displayWarehouseFilter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
                  filters: _this3.state.wareHouseFilter || [],
                  title: "Warehouse",
                  right: true
                })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["b" /* FilterSelect */], _extends({
                  filters: tags.concat(filterWithLocations).concat({
                    label: __WEBPACK_IMPORTED_MODULE_7__constants__["_37" /* CLEAR_FILTERS_TEXT */],
                    filters: _extends({}, defaultFilters)
                  })
                }, searchProps, {
                  right: true
                }))
              )
            ),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__users_helpers__["i" /* hasAnyOfRolesOrSubroles */])(currentUser.toJS(), [__WEBPACK_IMPORTED_MODULE_10__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["l" /* REPAIR */]], [__WEBPACK_IMPORTED_MODULE_10__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__InventoryStats__["a" /* default */], {
              alwaysDisplayBuyerStats: !displayBuyersFilter,
              filters: searchProps.paginator.toJS().filters
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Title__["a" /* default */], {
              applicationTags: applicationTags,
              searchProps: searchProps,
              buyersTags: _this3.state.buyersTags
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Table__["a" /* default */], searchProps),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["d" /* Pagination */], searchProps)
          );
        }
      );
    }
  }]);

  return InventoriesSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return { currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_10__users_constants__["a" /* USER */]) };
})(InventoriesSearch));

/***/ }),
/* 2116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_InventoryStatusCell__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__ = __webpack_require__(11);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















function renderInventoryRow(inventory, i, pushHistory, renderDummyValues) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: renderDummyValues ? "d-" + i : i,
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()("clickable", { "text-muted": renderDummyValues }),
      onClick: function onClick() {
        return pushHistory("/inventories/" + inventory.uuid + "/all");
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      i + 1
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__shared_components_InventoryStatusCell__["a" /* default */],
      { inventory: inventory },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        !renderDummyValues && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_date__["c" /* shortDateYY */])(inventory.date_received)
      )
    ),
    !renderDummyValues && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["h" /* PartNumber */], { part: inventory.part }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      !renderDummyValues && inventory.serial_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      !renderDummyValues && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])(inventory.exchange_serial_number, 14)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      !renderDummyValues && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])(inventory.part.description, 15)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      !renderDummyValues && inventory.buyer && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["d" /* getFirstNameLastInitial */])(inventory.buyer.full_name), 8)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      !renderDummyValues && inventory.co_buyer && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["d" /* getFirstNameLastInitial */])(inventory.co_buyer.full_name), 8)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      !renderDummyValues && inventory.third_buyer && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["d" /* getFirstNameLastInitial */])(inventory.third_buyer.full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      !renderDummyValues && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["o" /* LocationFlag */], {
        location: inventory.store_owner_id,
        consignment_type: inventory.consignment_type,
        inventory: inventory
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      !renderDummyValues && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["o" /* LocationFlag */], { location: inventory.store_location_id })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      !renderDummyValues && (inventory.location === "At Shop" && inventory.most_recent_repair_order ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          to: "/repair-orders/" + (inventory.most_recent_repair_order ? inventory.most_recent_repair_order.uuid : "")
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])("" + inventory.most_recent_repair_order.company.name, 25)
      ) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])(inventory.location, 12))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      renderDummyValues ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_7__constants__["r" /* INVENTORIES */], "condition." + inventory.dummy.condition + ".abbrev") : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_7__constants__["r" /* INVENTORIES */], "condition." + inventory.condition + ".abbrev")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])(inventory.tagged_by, 16)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_date__["g" /* monthYear */])(inventory.tag_date)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["e" /* truncate */])(inventory.traced_to, 15)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      !renderDummyValues && inventory.reserve_for_seller_id && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-lock text-muted" }),
      " ",
      renderDummyValues && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-copy text-muted" }),
      " ",
      renderDummyValues ? inventory.dummy.quantity : inventory.total_quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      !renderDummyValues && inventory.cost_per_unit && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(inventory.cost_per_unit, 0)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      !renderDummyValues && inventory.suggested_retail && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(inventory.suggested_retail, 0)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      !renderDummyValues && inventory.exchange_srp && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(inventory.exchange_srp, 0)
    )
  );
}

function renderRow(inventory, i, pushHistory) {
  if (inventory.dummy) {
    return [renderInventoryRow(inventory, i, pushHistory), renderInventoryRow(inventory, i, pushHistory, true)];
  }
  return renderInventoryRow(inventory, i, pushHistory);
}

function Table(_ref) {
  var pushHistory = _ref.pushHistory,
      isLoading = _ref.isLoading,
      results = _ref.results;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */],
    { loading: isLoading, numbered: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Rec."
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Exchd Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Description"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Buyer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Buyer 2"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Buyer 3"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Store Owner"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Store Loc"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Inv Loc"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "CD"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Tagged By"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Tag Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Traced To"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "QTY"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Cost/Unit"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "SRP"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Exch SRP"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r, i) {
        return renderRow(r, i, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_9__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(Table));

/***/ }),
/* 2117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_helpers__ = __webpack_require__(41);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













var filterTags = [{
  label: "My Inventory",
  key: "my_inventory",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Color Bar = Green",
  key: "sellable_green_status",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_7__constants__["U" /* LIST */])
}, {
  label: "Discrepancies",
  key: "open_discrepancies"
}, {
  label: "Location @Shop",
  key: "location_at_shop"
}, {
  label: "Color Bar = Yellow",
  key: "sellable_yellow_status",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_7__constants__["W" /* DO_NOT_LIST */])
}, {
  label: "Color Bar = Red",
  key: "sellable_red_status",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_7__constants__["X" /* DO_NOT_SELL */])
}, {
  label: "No SRP",
  key: "no_srp"
}, {
  label: "Show Only Remaining Inventory",
  key: "not_gone"
}, {
  label: "Show Inventory with Remaining Cost",
  key: "has_cost"
}, {
  label: "Overhauled",
  key: "overhauled"
}, {
  label: "Repaired",
  key: __WEBPACK_IMPORTED_MODULE_7__constants__["h" /* REPAIRED */]
}, {
  label: "Inspected",
  key: "inspected"
}, {
  label: "New",
  key: "new_item"
}, {
  label: "As Removed",
  key: __WEBPACK_IMPORTED_MODULE_7__constants__["_39" /* AS_REMOVED */]
}, {
  label: "Beyond Repair",
  key: __WEBPACK_IMPORTED_MODULE_8__Receiving_constants__["g" /* BEYOND_ECON_REPAIR */]
}, {
  label: "Parts Unit",
  key: __WEBPACK_IMPORTED_MODULE_7__constants__["_94" /* PARTS_UNIT */]
}, {
  label: "Repair & Hold",
  key: __WEBPACK_IMPORTED_MODULE_7__constants__["k" /* REPAIR_AND_HOLD */]
}, {
  label: "Repair & Hold - LT",
  key: __WEBPACK_IMPORTED_MODULE_7__constants__["_95" /* REPAIR_AND_HOLD_LEAD_TIME */]
}, {
  label: "Scrap",
  key: __WEBPACK_IMPORTED_MODULE_7__constants__["_52" /* SCRAP */]
}, {
  label: "Show Inventory with QC Hold",
  key: "qc_status",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_7__constants__["S" /* QC_HOLD */])
}, {
  label: "Gone From Stock",
  key: "out_of_stock"
}, {
  label: "Sold",
  key: "sold"
}, {
  label: "< 6 mos",
  key: "date_received_under_6_mos",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "6 to 12 mos",
  key: "date_received_6_to_12_mos",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "12 to 18 mos",
  key: "date_received_12_to_18_mos",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "> 18 mos",
  key: "date_received_over_18_mos",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Reserved For Repair",
  key: "repair_status",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("reserve_for_repair")
}, {
  label: "Do Not List",
  key: "do_not_list",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Do Not Sell",
  key: "do_not_sell",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Do Not Exchange",
  key: "do_not_exchange"
}, {
  label: "Reserved For Sale",
  key: "status",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("reserve_for_sale,on_order_for_sale")
}, {
  label: "Tag Date > 5 Years",
  key: "tag_date",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])("over_5_years")
}, {
  label: "Show All Scrapped Inventory",
  key: "condition",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_7__constants__["_52" /* SCRAP */])
}, {
  label: "Gone",
  key: "status",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_7__constants__["_33" /* GONE */])
}, {
  label: "Has Scrap Report",
  key: "has_scrap_report"
}, {
  label: "Tier Type = 4 Star",
  key: __WEBPACK_IMPORTED_MODULE_6__parts_constants__["O" /* TIER_TYPE */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_6__parts_constants__["c" /* ATL */]),
  withAuthorization: { roles: [__WEBPACK_IMPORTED_MODULE_5__users_constants__["P" /* BUYER */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["i" /* ADMIN */]] }
}, {
  label: "Tier Type = 3 Star",
  key: __WEBPACK_IMPORTED_MODULE_6__parts_constants__["O" /* TIER_TYPE */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_6__parts_constants__["e" /* BTL */]),
  withAuthorization: { roles: [__WEBPACK_IMPORTED_MODULE_5__users_constants__["P" /* BUYER */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["i" /* ADMIN */]] }
}, {
  label: "Tier Type = 2 Star",
  key: __WEBPACK_IMPORTED_MODULE_6__parts_constants__["O" /* TIER_TYPE */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_6__parts_constants__["f" /* BBTL */]),
  withAuthorization: { roles: [__WEBPACK_IMPORTED_MODULE_5__users_constants__["P" /* BUYER */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["i" /* ADMIN */]] }
}, {
  label: "Tier Type = 1 Star",
  key: __WEBPACK_IMPORTED_MODULE_6__parts_constants__["O" /* TIER_TYPE */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_6__parts_constants__["d" /* ZTL */]),
  withAuthorization: { roles: [__WEBPACK_IMPORTED_MODULE_5__users_constants__["P" /* BUYER */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["i" /* ADMIN */]] }
}, {
  label: "Tier Type = 5 Star",
  key: __WEBPACK_IMPORTED_MODULE_6__parts_constants__["O" /* TIER_TYPE */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_6__parts_constants__["b" /* SATL */]),
  withAuthorization: { roles: [__WEBPACK_IMPORTED_MODULE_5__users_constants__["P" /* BUYER */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["i" /* ADMIN */]] }
}, {
  label: "Tier Type = Non-Qualifier",
  key: __WEBPACK_IMPORTED_MODULE_6__parts_constants__["O" /* TIER_TYPE */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(""),
  withAuthorization: { roles: [__WEBPACK_IMPORTED_MODULE_5__users_constants__["P" /* BUYER */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["i" /* ADMIN */]] }
}, {
  label: "Active Transfer",
  key: "transfer"
}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__Receiving_constants__["t" /* CONSIGNMENT */]),
  key: __WEBPACK_IMPORTED_MODULE_8__Receiving_constants__["t" /* CONSIGNMENT */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_8__Receiving_constants__["t" /* CONSIGNMENT */])
}, {
  label: __WEBPACK_IMPORTED_MODULE_8__Receiving_constants__["s" /* EMA */].toUpperCase(),
  key: __WEBPACK_IMPORTED_MODULE_8__Receiving_constants__["t" /* CONSIGNMENT */],
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(__WEBPACK_IMPORTED_MODULE_8__Receiving_constants__["s" /* EMA */])
}, {
  label: "Exclude Cons/EMAs",
  key: "exclude_consignment"
}, {
  label: "from lots",
  key: "lot"
}];

var Title = function Title(_ref) {
  var applicationTags = _ref.applicationTags,
      currentUser = _ref.currentUser,
      searchProps = _ref.searchProps,
      buyersTags = _ref.buyersTags;

  var filterTagsWithLocations = currentUser.locations.map(function (l) {
    return {
      label: "Store Owner " + l.name,
      key: __WEBPACK_IMPORTED_MODULE_7__constants__["_64" /* STORE_OWNER_ID */],
      matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_filters__["b" /* matchesString */])(l.id)
    };
  });

  var titleText = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_5__users_constants__["l" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["k" /* SALES */]]) && ![__WEBPACK_IMPORTED_MODULE_5__users_constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["m" /* ACCOUNTING */]].includes(currentUser.role) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__users_helpers__["e" /* hasPermission */])(currentUser, __WEBPACK_IMPORTED_MODULE_5__users_constants__["_26" /* CAN_VIEW_ALL_INVENTORY */]) ? "My Inventory" : "All Inventory";
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
    filters: applicationTags.concat(filterTags).concat(filterTagsWithLocations).concat(buyersTags),
    title: titleText
  }));
};

Title.propTypes = _extends({
  searchProps: __WEBPACK_IMPORTED_MODULE_3__shared_components__["e" /* SearchPropTypes */]
}, __WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__["a" /* WithCurrentUser */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__session_decorators_withCurrentUser__["b" /* default */])(Title));

/***/ }),
/* 2118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(2115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });



/***/ }),
/* 2119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(2118);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Detail__ = __webpack_require__(2108);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Detail__["a"]; });





/***/ }),
/* 2120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parts_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__ = __webpack_require__(20);
/* unused harmony export SelectInventoryTable */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var SelectInventoryTable = function (_Component) {
  _inherits(SelectInventoryTable, _Component);

  function SelectInventoryTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectInventoryTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectInventoryTable.__proto__ || Object.getPrototypeOf(SelectInventoryTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inventories: []
    }, _this.setInventory = function (partId) {
      var addRecord = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _this$props = _this.props,
          searchInventories = _this$props.searchInventories,
          filter = _this$props.filter,
          _this$props$selectedI = _this$props.selectedInventory,
          selectedInventory = _this$props$selectedI === undefined ? {} : _this$props$selectedI;

      searchInventories(partId, filter).then(function (resp) {
        if (selectedInventory.id && addRecord) {
          var containsInv = resp.some(function (inv) {
            return inv.id === selectedInventory.id;
          });
          if (!containsInv) {
            resp.unshift(selectedInventory);
          }
        }
        _this.setState({ inventories: resp });
      });
    }, _this.renderRow = function (inventory, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        { key: i },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          i + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components__["D" /* InventoryStatusCell */],
          { inventory: inventory },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            component: "input",
            type: "radio",
            name: "inventory_id",
            className: "radio-inline",
            value: inventory.id.toString(),
            onChange: function onChange() {
              return _this.props.onInventorySelected(inventory);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          inventory.serial_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          inventory.condition && __WEBPACK_IMPORTED_MODULE_5__constants__["r" /* INVENTORIES */].condition[inventory.condition].abbrev
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          inventory.quantity
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["d" /* alphaMonthYear */])(inventory.tag_date)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["o" /* LocationFlag */], { location: inventory.store_location_id })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          inventory.cost_per_unit && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(inventory.cost_per_unit)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          inventory.exchange_srp && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(inventory.exchange_srp)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          inventory.suggested_retail && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(inventory.suggested_retail)
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectInventoryTable, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.part) {
        this.setInventory(this.props.part.id);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.part && nextProps.part !== this.props.part) {
        this.setInventory(nextProps.part.id, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "table",
        { className: "table table-striped table-hover table-numbered" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Serial Number"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "CD"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "QTY"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Tag Date"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Store Location"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Cost/Unit"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Exch SRP"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "SRP"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tbody",
          null,
          this.state.inventories.map(this.renderRow),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              { className: "text-center" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                component: "input",
                type: "radio",
                name: "inventory_id",
                className: "radio-inline",
                value: "",
                onChange: function onChange() {
                  return _this2.props.onInventorySelected(null);
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              {
                colSpan: "8",
                style: { marginBottom: "2px", verticalAlign: "baseline" }
              },
              "Don't quote from a specific inventory item"
            )
          )
        )
      );
    }
  }]);

  return SelectInventoryTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SelectInventoryTable.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  }),
  onInventorySelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchInventories: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  filter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  selectedInventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    searchInventories: function searchInventories(partId, filter) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__parts_actions__["f" /* searchInventories */])(partId, filter));
    }
  };
})(SelectInventoryTable));

/***/ }),
/* 2121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_reducer__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__ = __webpack_require__(58);
/* unused harmony export initialState */
var _extends2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  inventory: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
}).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["a" /* notesInitialState */]).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["b" /* attachmentsInitialState */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _extends((_extends2 = {}, _defineProperty(_extends2, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* SET */], function (state, action) {
  return state.merge({ inventory: action.inventory });
}), _defineProperty(_extends2, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["c" /* SET_DUMMY */], function (state, action) {
  return state.mergeIn(["inventory"], { dummy: action.dummy });
}), _defineProperty(_extends2, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["d" /* DESTROY_DUMMY */], function (state) {
  return state.mergeIn(["inventory"], { dummy: null });
}), _defineProperty(_extends2, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["b" /* SET_MODAL */], function (state, action) {
  return state.mergeDeep({
    inventory: { displayCommercialInvoiceModal: action.showModal }
  });
}), _extends2), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["c" /* createAttachmentReducer */])(__WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].inventory), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["d" /* createNoteReducer */])(__WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].inventory))));

/***/ }),
/* 2122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pageActions", function() { return pageActions; });


var pageActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["composables"])({
  listId: "part/managedRepairOrderLineItems"
});

/***/ }),
/* 2123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__);
/* unused harmony export pageActions */


var pageActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["composables"])({
  listId: "part/outgoingQuoteLineItems"
});

/***/ }),
/* 2124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pageActions", function() { return pageActions; });


var pageActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["composables"])({ listId: "part/repairOrderLineItems" });

/***/ }),
/* 2125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__);
/* unused harmony export pageActions */


var pageActions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["composables"])({ listId: "part/salesOrderLineItems" });

/***/ }),
/* 2126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(23);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function _default(adapter) {
  return {
    all: function all(partId, page) {
      return adapter.post("/parts/" + partId + "/all", { search: { page: page } });
    },
    bookmarks: {
      search: function search(_search) {
        return adapter.post("/parts/bookmarks/search", { search: _search });
      },
      create: function create(partId) {
        return adapter.post("parts/" + partId + "/bookmarks");
      },
      destroy: function destroy(partId) {
        return adapter.delete("parts/" + partId + "/bookmark");
      }
    },
    create: function create(part) {
      return adapter.post("/parts", { part: part });
    },
    export: function _export(params) {
      return adapter.get("/parts/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_query_string__["stringify"])(params));
    },
    import: function _import(data) {
      return adapter.post("/parts/import", data);
    },
    merge: function merge(partId, params) {
      return adapter.post("/parts/" + partId + "/merge", { part: _extends({}, params) });
    },
    poPartSearch: function poPartSearch(params) {
      return adapter.post("/parts/search", {
        search: _extends({}, params, { sold_recently_status: true })
      });
    },
    rankingStats: function rankingStats(noSellableQty, filter) {
      return adapter.get("/parts/ranking_stats", {
        params: { no_sellable_qty: noSellableQty, filter: filter }
      });
    },
    search: function search(params) {
      return adapter.post("/parts/search", { search: params });
    },
    searchPartsAndAlternates: function searchPartsAndAlternates(params) {
      return adapter.post("/parts/search_parts_and_alternates", { search: params });
    },
    sellableQuantities: function sellableQuantities(id) {
      return adapter.get("/parts/" + id + "/sellable_quantities");
    },
    show: function show(id) {
      return adapter.get("/parts/" + id);
    },
    tierTypeStats: function tierTypeStats() {
      return adapter.get("/parts/tier_type_stats");
    },
    update: function update(id, part) {
      return adapter.put("/parts/" + id, { part: part });
    },
    alternates: {
      create: function create(partId, alternate) {
        return adapter.post("/parts/" + partId + "/alternates", { alternate: alternate });
      },
      search: function search(partId, _search2) {
        return adapter.post("/parts/" + partId + "/alternates/search", { search: _search2 });
      }
    },
    applications: {
      list: function list(id, page, limit) {
        return adapter.get("/parts/" + id + "/applications", { params: { page: page, limit: limit } });
      },
      of: function of(type) {
        var _APPLICATIONS$type = __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* APPLICATIONS */][type],
            applicationResourceName = _APPLICATIONS$type.applicationResourceName,
            applicableResourceName = _APPLICATIONS$type.applicableResourceName,
            formResourceName = _APPLICATIONS$type.formResourceName,
            searchFilterParam = _APPLICATIONS$type.searchFilterParam;


        return {
          applicables: function applicables(partNumber) {
            var _search3;

            return adapter.post("/" + applicableResourceName + "/search", {
              search: (_search3 = {}, _defineProperty(_search3, searchFilterParam, partNumber), _defineProperty(_search3, "limit", 30), _search3)
            });
          },
          create: function create(partId, data) {
            return adapter.post("/parts/" + partId + "/" + applicationResourceName, _defineProperty({}, formResourceName, data));
          }
        };
      }
    },
    incomingQuotes: {
      bulkCreate: function bulkCreate(partId, data) {
        return adapter.post("/parts/" + partId + "/incoming_quotes/bulk_create", {
          incoming_quote: data
        });
      },
      create: function create(partId, data) {
        return adapter.post("/parts/" + partId + "/incoming_quotes", {
          incoming_quote: data
        });
      }
    },
    incomingQuoteLineItems: {
      search: function search(partId, _search4) {
        return adapter.post("/parts/" + partId + "/incoming_quote_line_items/search", {
          search: _search4
        });
      }
    },
    inventories: {
      search: function search(partId) {
        var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return adapter.post("/parts/" + partId + "/inventories/search", {
          search: _extends({}, filters)
        });
      }
    },
    lotLineItems: {
      search: function search(partId, _search5) {
        return adapter.post("/parts/" + partId + "/lot_line_items/search", {
          search: _search5
        });
      }
    },
    managedRepairOrderLineItems: {
      search: function search(partId, _search6) {
        return adapter.post("/parts/" + partId + "/managed_repair_order_line_items/search", {
          search: _search6
        });
      }
    },
    outgoingQuotes: {
      create: function create(partId, data) {
        data.outgoing_quote_line_item.part_id = partId;
        return adapter.post("/outgoing_quotes", { outgoing_quote: data });
      }
    },
    outgoingQuoteLineItems: {
      search: function search(partId, _search7) {
        return adapter.post("/parts/" + partId + "/outgoing_quote_line_items/search", {
          search: _search7
        });
      },
      search_grouped: function search_grouped(partId, search) {
        return adapter.post("/parts/" + partId + "/outgoing_quote_line_items/search_grouped", {
          search: search
        });
      }
    },
    purchaseOrderAndLots: {
      search: function search(partId, _search8) {
        return adapter.post("/parts/" + partId + "/purchase_and_lots/search", {
          search: _search8
        });
      }
    },
    purchaseOrderLineItems: {
      search: function search(partId, _search9) {
        return adapter.post("/parts/" + partId + "/purchase_order_line_items/search", {
          search: _search9
        });
      }
    },
    repairOrderLineItems: {
      search: function search(partId, _search10) {
        return adapter.post("/parts/" + partId + "/repair_order_line_items/search", {
          search: _search10
        });
      },
      stats: function stats(partId) {
        return adapter.post("/parts/" + partId + "/repair_order_line_items/stats");
      }
    },
    repairQuoteLineItems: {
      search: function search(partId, _search11) {
        return adapter.post("/parts/" + partId + "/repair_quote_line_items/search", {
          search: _search11
        });
      }
    },
    salesOrderLineItems: {
      search: function search(partId, _search12) {
        return adapter.post("/parts/" + partId + "/sales_order_line_items/search", {
          search: _search12
        });
      }
    }
  };
}

/***/ }),
/* 2127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateImportParts_ImportParts__ = __webpack_require__(2128);
/* unused harmony export default */




function CreateImportParts(_ref) {
  var open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CreateImportParts_ImportParts__["a" /* default */], { open: open, close: close });
}

CreateImportParts.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ImportPartsForm__ = __webpack_require__(745);
/* harmony export (immutable) */ __webpack_exports__["a"] = ImportParts;





function ImportParts(_ref) {
  var open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Import New Parts CSV"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ImportPartsForm__["a" /* default */], { close: close, enableReinitialize: true })
  );
}

ImportParts.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateImportParts__ = __webpack_require__(2127);
/* unused harmony reexport default */



/***/ }),
/* 2130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Stars_Stars__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_AppForm__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CreateImportParts_ImportPartsForm__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Form__ = __webpack_require__(2131);
/* unused harmony export CreatePart */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();












function CreatePart(_ref) {
  var open = _ref.open,
      close = _ref.close,
      currentUser = _ref.currentUser;

  var initialValues = {
    weight_unit: __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* POUNDS */],
    esd: false,
    hazmat: false,
    bio_hazmat: false,
    llp: false
  };

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      tierType = _useState2[0],
      setTierType = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState4 = _slicedToArray(_useState3, 2),
      importModalOpen = _useState4[0],
      setImportModalOpen = _useState4[1];

  var openImportModal = function openImportModal() {
    close();
    setTimeout(function () {
      setImportModalOpen(true);
    }, 300);
  };

  var closeImportModal = function closeImportModal() {
    return setImportModalOpen(false);
  };

  var handleSubmit = function handleSubmit() {
    close();
  };

  var isAdmin = currentUser && currentUser.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["h" /* ROLE */]) === __WEBPACK_IMPORTED_MODULE_7__users_constants__["i" /* ADMIN */];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { display: "flex", justifyContent: "space-between" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            { className: "modal-title" },
            "Add a Part"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Stars_Stars__["b" /* Stars */], {
            size: "fa-lg",
            tierType: tierType,
            style: { marginRight: 15 },
            updatePart: function updatePart(tier) {
              return setTierType(tier);
            },
            disabled: false
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__Form__["a" /* default */],
        {
          close: close,
          initialValues: initialValues,
          tierType: tierType,
          onSubmit: handleSubmit
        },
        isAdmin && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_AppForm__["b" /* AdditionalButtons */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            {
              type: "button",
              className: "btn btn-primary",
              onClick: openImportModal
            },
            "Import"
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
      { open: importModalOpen, close: closeImportModal },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: closeImportModal }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Import New Parts CSV"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CreateImportParts_ImportPartsForm__["a" /* default */], { close: closeImportModal, enableReinitialize: true })
    )
  );
}

CreatePart.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    get: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  })
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_7__users_constants__["a" /* USER */])
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(CreatePart));

/***/ }),
/* 2131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_countries__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_FormSections_WeightAndDimensionsSection__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_PartNumber__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_Description__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Warnings__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__validate__ = __webpack_require__(2134);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var debounceTimeout = 350;
var FORM_NAME = "createPart";

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      checkingForDuplicates: false,
      hasDuplicates: false
    }, _this.notify = function () {
      return _this.setState({ checkingForDuplicates: true, hasDuplicates: false });
    }, _this.check = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["debounce"])(function (partNumber) {
      _this.props.search(partNumber).then(function (results) {
        _this.setState({ checkingForDuplicates: false });
        _this.setState({ hasDuplicates: results.length > 0 });
      });
    }, debounceTimeout), _this.resetScFee = function (scReq) {
      if (scReq === false) {
        _this.props.change(__WEBPACK_IMPORTED_MODULE_8__constants__["_4" /* SPECIAL_CONTAINER_FEE */], null);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          scReq = _props.scReq,
          submitting = _props.submitting,
          role = _props.role,
          mlp = _props.mlp,
          purchasedAt = _props.purchasedAt,
          dom = _props.dom;

      var countryOptions = __WEBPACK_IMPORTED_MODULE_10__lib_countries__["a" /* default */].map(function (c) {
        return {
          value: c.code,
          text: c.name
        };
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */],
        _extends({}, this.props, {
          submitting: submitting || this.state.checkingForDuplicates
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Body,
          null,
          this.state.hasDuplicates && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "alert alert-warning" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              null,
              "Heads up!"
            ),
            " A base part number matching this part number already exists!"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Fields"], {
                component: __WEBPACK_IMPORTED_MODULE_16__shared_PartNumber__["a" /* default */],
                names: [__WEBPACK_IMPORTED_MODULE_8__constants__["w" /* PART_NUMBER */], __WEBPACK_IMPORTED_MODULE_8__constants__["u" /* DESCRIPTION */]],
                notify: this.notify,
                check: this.check
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Fields"], {
                component: __WEBPACK_IMPORTED_MODULE_17__shared_Description__["a" /* default */],
                names: [__WEBPACK_IMPORTED_MODULE_8__constants__["w" /* PART_NUMBER */], __WEBPACK_IMPORTED_MODULE_8__constants__["u" /* DESCRIPTION */]]
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: __WEBPACK_IMPORTED_MODULE_8__constants__["_9" /* MANUFACTURER */], component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], label: "MFG" })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm margin-top-none" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["u" /* CageField */], {
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["_10" /* CAGE */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_10" /* CAGE */])
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["v" /* ECCNField */], {
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["K" /* EUROPEAN_COMMERCE_CONTROL_NUMBER */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: "ECCN"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["w" /* UNCodeField */], {
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["_6" /* UNITED_NATIONS_CODE */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: "UN Code"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 5 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["x" /* NSNField */], { name: __WEBPACK_IMPORTED_MODULE_8__constants__["_21" /* NSN */], component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], label: "NSN" })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], {
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["_2" /* MLP */],
                label: "Manufacturer List Price",
                required: purchasedAt
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["_3" /* PURCHASED_AT */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: "Date of Price",
                type: "date",
                required: mlp
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 5 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
                options: countryOptions,
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["g" /* COUNTRY_OF_MFG */],
                label: "Ctry of Mfg"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
                { justified: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                  name: __WEBPACK_IMPORTED_MODULE_8__constants__["_7" /* DOM_SENSITIVE */],
                  label: "DOM Sensitive",
                  icon: "fa-calendar"
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 3 },
              dom && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_8__constants__["T" /* DOM_LIFE_YEARS */],
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                  label: "DOM Life Years"
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_FormSections_WeightAndDimensionsSection__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Warnings__["a" /* default */], { formName: FORM_NAME }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "label",
                  { htmlFor: "special-container", className: "control-label" },
                  "Special Container"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    id: "special-container",
                    className: "btn-group btn-group-justified",
                    "data-toggle": "buttons"
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    onChange: function onChange(ev, val) {
                      return _this2.resetScFee(val);
                    },
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                    name: __WEBPACK_IMPORTED_MODULE_8__constants__["_5" /* SPECIAL_CONTAINER_REQ */],
                    label: "Special Container Required",
                    icon: "fa-cube"
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 3 },
              scReq && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], {
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["_4" /* SPECIAL_CONTAINER_FEE */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_4" /* SPECIAL_CONTAINER_FEE */]),
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "label",
                  { htmlFor: "esd", className: "control-label" },
                  "ESD"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    className: "btn-group btn-group-justified",
                    "data-toggle": "buttons"
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                    name: __WEBPACK_IMPORTED_MODULE_8__constants__["_14" /* ESD */],
                    label: __WEBPACK_IMPORTED_MODULE_8__constants__["_14" /* ESD */].toUpperCase()
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__lib_forms__["f" /* arrayToOptions */])(__WEBPACK_IMPORTED_MODULE_15__inventories_constants__["_59" /* WARRANTY_OPTIONS */]),
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["_15" /* WARRANTY_OVERRIDE */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_15" /* WARRANTY_OVERRIDE */]),
                disabled: role !== __WEBPACK_IMPORTED_MODULE_12__users_constants__["i" /* ADMIN */]
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
                { justified: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                  name: __WEBPACK_IMPORTED_MODULE_8__constants__["_18" /* AUTO_ADJUST_SRP_EXCLUSION */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_18" /* AUTO_ADJUST_SRP_EXCLUSION */])
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["_16" /* IMPORTANT_MEMO */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_16" /* IMPORTANT_MEMO */])
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["_17" /* CLASSIFIED_MEMO */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_17" /* CLASSIFIED_MEMO */])
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 6, xs: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["x" /* SCHEDULE_B_OR_HT_CODE */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["x" /* SCHEDULE_B_OR_HT_CODE */])
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 6, xs: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_8__constants__["v" /* HTSUS_CODE */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["v" /* HTSUS_CODE */]).toUpperCase()
              })
            )
          )
        ),
        this.props.children
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  mlp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  scReq: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  purchasedAt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])(FORM_NAME);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    mlp: selector(state, __WEBPACK_IMPORTED_MODULE_8__constants__["_2" /* MLP */]),
    role: state.session.getIn([__WEBPACK_IMPORTED_MODULE_12__users_constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_12__users_constants__["h" /* ROLE */]]),
    scReq: selector(state, __WEBPACK_IMPORTED_MODULE_8__constants__["_5" /* SPECIAL_CONTAINER_REQ */]),
    dom: selector(state, "dom_sensitive"),
    purchasedAt: selector(state, __WEBPACK_IMPORTED_MODULE_8__constants__["_3" /* PURCHASED_AT */])
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      data.tier_type = ownProps.tierType;
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["q" /* create */](data));
    },
    search: function search(partNumber) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["k" /* searchMatchingPartNumbers */](partNumber));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_19__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 2132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_NumberInput_NumberInput__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(23);
/* unused harmony export TotalTimeFields */






function TotalTimeFields() {
  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
    { md: 3 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "form-group" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        name: __WEBPACK_IMPORTED_MODULE_4__constants__["E" /* TOTAL_HOURS */],
        component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_NumberInput_NumberInput__["a" /* default */],
        roundDigits: 0,
        label: "Time Since New (Hours)"
      })
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
    { md: 3 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "form-group" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        name: __WEBPACK_IMPORTED_MODULE_4__constants__["F" /* TOTAL_CYCLES */],
        component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_NumberInput_NumberInput__["a" /* default */],
        roundDigits: 0,
        label: "Cycles Since New"
      })
    )
  )];
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Fields"], { names: ["total_hours", "total_cycles"], component: TotalTimeFields });
});

/***/ }),
/* 2133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreatePart__ = __webpack_require__(2130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CreatePart__["a"]; });



/***/ }),
/* 2134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(23);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;




function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate("manufacturer_list_price", "purchased_at").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["p" /* requiredIfAnyDefined */]("manufacturer_list_price", "purchased_at"));

    v.validate("special_container_fee").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["p" /* requiredIfAnyDefined */]("special_container_req"));

    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["w" /* PART_NUMBER */], __WEBPACK_IMPORTED_MODULE_2__constants__["u" /* DESCRIPTION */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    if (!["EAR99", "SNCHK"].includes(values[__WEBPACK_IMPORTED_MODULE_2__constants__["K" /* EUROPEAN_COMMERCE_CONTROL_NUMBER */]])) {
      v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["K" /* EUROPEAN_COMMERCE_CONTROL_NUMBER */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["l" /* matchesPattern */](/^[0-9][A-Za-z]\d{3}\.?[a-z]?\.?[0-9]?\.?[a-z]?$/));
    }
    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["j" /* WEIGHT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["q" /* isNumeric */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["f" /* isGreaterThan */](0));
    v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* LENGTH */], __WEBPACK_IMPORTED_MODULE_2__constants__["k" /* WIDTH */], __WEBPACK_IMPORTED_MODULE_2__constants__["m" /* HEIGHT */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["p" /* requiredIfAnyDefined */](__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* LENGTH */], __WEBPACK_IMPORTED_MODULE_2__constants__["k" /* WIDTH */], __WEBPACK_IMPORTED_MODULE_2__constants__["m" /* HEIGHT */]), __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["q" /* isNumeric */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["f" /* isGreaterThan */](0));
    v.validate("united_nations_code").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["r" /* isInteger */], __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["s" /* lengthIsEqual */](4));
  });
}

/***/ }),
/* 2135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(2136);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function AllParts(_ref) {
  var partId = _ref.partId;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      parts = _useState2[0],
      setParts = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState4 = _slicedToArray(_useState3, 2),
      initialFetchDone = _useState4[0],
      setInitialFetchDone = _useState4[1];

  var listRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var activePartRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].parts.all(partId, 0).then(function (_ref2) {
      var data = _ref2.data;

      setParts(data.results);
      setInitialFetchDone(true);
    });
    return function cleanup() {};
  }, [partId]);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (initialFetchDone && activePartRef != null && activePartRef.current != null) {
      var activePart = activePartRef.current;
      var list = listRef.current;

      var centerOffset = (__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* LIST_CONTAINER_HEIGHT */] / __WEBPACK_IMPORTED_MODULE_7__constants__["b" /* PART_ITEM_HEIGHT */] - 1) * __WEBPACK_IMPORTED_MODULE_7__constants__["b" /* PART_ITEM_HEIGHT */] / 2;

      list.scrollTop = activePart.offsetTop - list.offsetTop - centerOffset;
    }

    return function cleanup() {};
  }, [partId, initialFetchDone]);

  var className = function className(part) {
    return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_helpers__["a" /* getPartNumberColorClassNameByTierType */])(part.tierType), {
      "text-bold": partId === part.uuid
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      style: { overflow: "scroll", height: __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* LIST_CONTAINER_HEIGHT */] },
      ref: listRef
    },
    parts.map(function (p) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: { width: "100%" },
          ref: p[0] === partId ? activePartRef : null
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],
          {
            className: className({ uuid: p[0], tierType: p[2] }),
            to: "/parts/" + p[0]
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "align-middle" },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["trim"])(p[1])
          )
        )
      );
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (AllParts);

AllParts.propTypes = {
  partId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

/***/ }),
/* 2136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOADED */
/* unused harmony export PARTS_PER_PAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PART_ITEM_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LIST_CONTAINER_HEIGHT; });
/* unused harmony export ITEMS_OFFSET */
/* unused harmony export MAX_COUNT */
var LOADED = 2;
var PARTS_PER_PAGE = 100;
var PART_ITEM_HEIGHT = 20;
var LIST_CONTAINER_HEIGHT = 400;
var ITEMS_OFFSET = 150;
var MAX_COUNT = ITEMS_OFFSET * 2 + 1;

/***/ }),
/* 2137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Edit__ = __webpack_require__(2141);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var AlternateTag = function (_React$Component) {
  _inherits(AlternateTag, _React$Component);

  function AlternateTag() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AlternateTag);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlternateTag.__proto__ || Object.getPrototypeOf(AlternateTag)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      removeModalOpen: false,
      editModalOpen: false
    }, _this.openRemoveModal = function () {
      return _this.setState({ removeModalOpen: true });
    }, _this.closeRemoveModal = function () {
      return _this.setState({ removeModalOpen: false });
    }, _this.openEditModal = function () {
      return _this.setState({ editModalOpen: true });
    }, _this.closeEditModal = function () {
      return _this.setState({ editModalOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AlternateTag, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          alternate = _props.alternate,
          destroy = _props.destroy,
          navToPart = _props.navToPart,
          part = _props.part;

      var onLabelClick = function onLabelClick() {};
      var labelColor = "#FFFFFF";

      if (alternate.alternate_part_id) {
        labelColor = "#FF9800";
        onLabelClick = function onLabelClick() {
          return navToPart(alternate.alternate_part_uuid);
        };
      }

      var labelStyle = {
        cursor: onLabelClick ? "pointer" : "default",
        color: labelColor,
        fontSize: "1.25em"
      };

      var canEdit = !part.master_part_lock || alternate.alternate_type !== "exact" || this.props.user[__WEBPACK_IMPORTED_MODULE_9__users_constants__["h" /* ROLE */]] === __WEBPACK_IMPORTED_MODULE_9__users_constants__["i" /* ADMIN */];

      var DropDowns = function DropDowns() {
        return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown__["a" /* DropDownItem */],
          { onClick: _this2.openEditModal },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["k" /* Icon */], { name: "pencil", fixed: true }),
          " Change Type"
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown__["a" /* DropDownItem */],
          { onClick: _this2.openRemoveModal },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["k" /* Icon */], { name: "close", fixed: true }),
          " Remove"
        )];
      };

      var labelClassName = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-xs btn-default", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_helpers__["a" /* getPartNumberColorClassNameByTierType */])(alternate.tier_type));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "btn-group",
            style: { marginBottom: 4, marginRight: 2, display: "table-cell" }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            {
              style: labelStyle,
              type: "button",
              className: labelClassName,
              onClick: onLabelClick
            },
            alternate.sellable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["j" /* NoteTooltip */], {
              note: "In Stock",
              url: "https://aero-zone-assets.s3.amazonaws.com/inventory.png"
            }),
            alternate.name
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__shared_components__["b" /* Authorized */],
            {
              roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_9__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_9__users_constants__["j" /* WAREHOUSE */]),
              subroles: [__WEBPACK_IMPORTED_MODULE_9__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__shared_components_DropDown__["b" /* default */],
              {
                icon: "fa " + (canEdit ? "fa-ellipsis-v" : "fa-lock"),
                dropdownStyles: { display: "inline" },
                buttonClasses: "btn btn-xs btn-default dropdown-toggle",
                containerClasses: "btn-group",
                iconStyles: { fontSize: "1.5em", paddingTop: "0.2em" }
              },
              canEdit ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropDowns, null) : null
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["E" /* ClipboardCopy */], { name: alternate.name, type: "PN", iconFontSize: "1em" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__shared_components__["q" /* ConfirmDelete */],
          {
            onConfirm: destroy,
            close: this.closeRemoveModal,
            open: this.state.removeModalOpen
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          " Are you sure you want to delete this?"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Edit__["a" /* default */], {
          alternate: alternate,
          close: this.closeEditModal,
          open: this.state.editModalOpen
        })
      );
    }
  }]);

  return AlternateTag;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AlternateTag.propTypes = {
  alternate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  destroy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  navToPart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return { user: state.userDetail.toJS().user };
}, function (dispatch, ownProps) {
  return {
    destroy: function destroy() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_4__actions__["l" /* deleteAlternate */](ownProps.alternate.id));
    },
    navToPart: function navToPart(partId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"])("/parts/" + partId));
    }
  };
})(AlternateTag));

/***/ }),
/* 2138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__New__ = __webpack_require__(2143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Table__ = __webpack_require__(2145);
/* harmony export (immutable) */ __webpack_exports__["a"] = Alternates;







function Alternates() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      "Alternates",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__shared_components__["b" /* Authorized */],
        {
          roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_2__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["j" /* WAREHOUSE */]),
          subroles: [__WEBPACK_IMPORTED_MODULE_2__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__New__["a" /* default */], null)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Table__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null)
  );
}

/***/ }),
/* 2139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreateForm__ = __webpack_require__(2140);
/* harmony export (immutable) */ __webpack_exports__["a"] = Create;







function Create(_ref) {
  var id = _ref.id,
      open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-sm" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Add a New Alternate"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CreateForm__["a" /* default */], { close: close, id: id })
      )
    )
  );
}

Create.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validate__ = __webpack_require__(748);






/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_2__actions__["o" /* createAlternate */](ownProps.id, data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["j" /* form */])({
  form: "createPartAlternate",
  validate: __WEBPACK_IMPORTED_MODULE_4__validate__["a" /* default */]
})(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */])));

/***/ }),
/* 2141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditForm__ = __webpack_require__(2142);
/* harmony export (immutable) */ __webpack_exports__["a"] = Edit;





function Edit(_ref) {
  var alternate = _ref.alternate,
      open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-sm" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Change Alternate Type"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__EditForm__["a" /* default */], { close: close, alternate: alternate, showPartInput: false })
      )
    )
  );
}

Edit.propTypes = {
  alternate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validate__ = __webpack_require__(748);






/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state, props) {
  return {
    initialValues: {
      alternate_type: props.alternate.alternate_type
    }
  };
}, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_2__actions__["m" /* updateAlternate */](ownProps.alternate.id, data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["j" /* form */])({
  form: "editPartAlternate",
  validate: __WEBPACK_IMPORTED_MODULE_4__validate__["a" /* default */]
})(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */])));

/***/ }),
/* 2143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Create__ = __webpack_require__(2139);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    id: state.partDetail.getIn(["part", "id"])
  };
})(function (_ref) {
  var id = _ref.id;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["P" /* LaunchModal */], {
    modal: __WEBPACK_IMPORTED_MODULE_3__Create__["a" /* default */],
    buttonClass: "btn-primary btn-hollow pull-right",
    id: id
  });
}));

/***/ }),
/* 2144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* unused harmony export Search */








function Search(_ref) {
  var search = _ref.search,
      partNumber = _ref.partNumber,
      label = _ref.label,
      alternateId = _ref.alternate_part_id;

  var onSelect = function onSelect(result, _val) {
    var id = result ? result.id : null;
    alternateId.input.onChange(id);
    alternateId.input.onBlur(id);

    var val = result instanceof Object ? null : result;

    label.input.onChange(val);
    label.input.onBlur(val);
  };

  var touched = alternateId.meta.touched || label.meta.touched;
  var invalid = alternateId.meta.invalid || label.meta.invalid;

  var errorClasses = __WEBPACK_IMPORTED_MODULE_6_classnames___default()({ "has-error": touched && invalid });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { htmlFor: "alternate" },
      "Alternate",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "sup",
        { className: "small text-danger" },
        "*"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { id: "alternate", className: "input-group" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "input-group-addon" },
        "Part #",
        partNumber,
        "\xA0\xA0\xA0\xA0\xA0\xA0",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-exchange" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: errorClasses },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["Q" /* AutoComplete */], {
          search: search,
          hasId: alternateId.input.value,
          onSelect: onSelect,
          format: function format(result) {
            return result.part_number;
          },
          allowUserInput: true,
          autoFocus: true
        })
      )
    )
  );
}

var formInput = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  input: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormTypes__["stringInput"].isRequired,
  meta: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms_FormTypes__["meta"].isRequired
});

Search.propTypes = {
  partNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  label: formInput.isRequired,
  alternate_part_id: formInput.isRequired,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    partNumber: state.partDetail.getIn(["part", "part_number"])
  };
}, function (dispatch) {
  return {
    search: function search(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_3__actions__["n" /* searchParts */](filter));
    }
  };
})(Search));

/***/ }),
/* 2145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_arrays__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Alternate__ = __webpack_require__(2137);
/* unused harmony export renderGroup */
/* unused harmony export Table */










function renderHeader(alternateType) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "th",
      { style: { textAlign: "left" } },
      __WEBPACK_IMPORTED_MODULE_4__constants__["_25" /* ALTERNATES */][alternateType].label
    )
  );
}

function renderGroup(records, part) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { width: "100%" },
      records.map(function (r) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Alternate__["a" /* default */], { alternate: r, key: r.id, part: part });
      })
    )
  );
}

function Table(_ref) {
  var results = _ref.results,
      part = _ref.part;

  if (!results.length) {
    return false;
  }

  var groups = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_arrays__["e" /* groupBy */])(results, "alternate_type");
  var header = function header(name) {
    return groups[name] && renderHeader(name);
  };
  var group = function group(name) {
    return groups[name] && renderGroup(groups[name], part);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-condensed" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      header(__WEBPACK_IMPORTED_MODULE_4__constants__["_26" /* EXACT */]),
      group(__WEBPACK_IMPORTED_MODULE_4__constants__["_26" /* EXACT */]),
      header(__WEBPACK_IMPORTED_MODULE_4__constants__["_27" /* FULLY_INTERCHANGEABLE */]),
      group(__WEBPACK_IMPORTED_MODULE_4__constants__["_27" /* FULLY_INTERCHANGEABLE */]),
      header(__WEBPACK_IMPORTED_MODULE_4__constants__["_28" /* REPLACES */]),
      group(__WEBPACK_IMPORTED_MODULE_4__constants__["_28" /* REPLACES */]),
      header(__WEBPACK_IMPORTED_MODULE_4__constants__["_29" /* REPLACED_BY */]),
      group(__WEBPACK_IMPORTED_MODULE_4__constants__["_29" /* REPLACED_BY */]),
      header(__WEBPACK_IMPORTED_MODULE_4__constants__["_30" /* MODIFICATION */]),
      group(__WEBPACK_IMPORTED_MODULE_4__constants__["_30" /* MODIFICATION */]),
      header(__WEBPACK_IMPORTED_MODULE_4__constants__["_31" /* MODEL_NUMBER */]),
      group(__WEBPACK_IMPORTED_MODULE_4__constants__["_31" /* MODEL_NUMBER */]),
      header(__WEBPACK_IMPORTED_MODULE_4__constants__["_32" /* PMA */]),
      group(__WEBPACK_IMPORTED_MODULE_4__constants__["_32" /* PMA */]),
      header(__WEBPACK_IMPORTED_MODULE_4__constants__["_33" /* ANOMALY */]),
      group(__WEBPACK_IMPORTED_MODULE_4__constants__["_33" /* ANOMALY */]),
      header(__WEBPACK_IMPORTED_MODULE_4__constants__["_11" /* NATIONAL_STOCK_NUMBER */]),
      group(__WEBPACK_IMPORTED_MODULE_4__constants__["_11" /* NATIONAL_STOCK_NUMBER */]),
      header(__WEBPACK_IMPORTED_MODULE_4__constants__["_34" /* OEM */]),
      group(__WEBPACK_IMPORTED_MODULE_4__constants__["_34" /* OEM */]),
      header(__WEBPACK_IMPORTED_MODULE_4__constants__["_35" /* UNKNOWN */]),
      group(__WEBPACK_IMPORTED_MODULE_4__constants__["_35" /* UNKNOWN */])
    )
  );
}

Table.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  })),
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

var Decorated = __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__["decorators"].tabulate(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    part: state.partDetail.toJS().part
  };
})(Table));

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Decorated, { listId: "part/alternates" });
});

/***/ }),
/* 2146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Alternates__ = __webpack_require__(2138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Alternates__["a"]; });



/***/ }),
/* 2147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Search__ = __webpack_require__(2148);
/* unused harmony export Applicable */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _config;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var config = (_config = {}, _defineProperty(_config, __WEBPACK_IMPORTED_MODULE_5__constants__["Y" /* HIGHER_ASSEMBLY_APPLICATION */], {
  label: "Higher Assembly"
}), _defineProperty(_config, __WEBPACK_IMPORTED_MODULE_5__constants__["W" /* AIRCRAFT_APPLICATION */], {
  label: "Aircraft"
}), _defineProperty(_config, __WEBPACK_IMPORTED_MODULE_5__constants__["X" /* ENGINE_APPLICATION */], {
  label: "Engine"
}), _defineProperty(_config, __WEBPACK_IMPORTED_MODULE_5__constants__["Z" /* LOWER_ASSEMBLY_APPLICATION */], {
  label: "Lower Assembly"
}), _config);

var Applicable = function (_Component) {
  _inherits(Applicable, _Component);

  function Applicable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Applicable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Applicable.__proto__ || Object.getPrototypeOf(Applicable)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
      _this.props.input.onChange(null);
      _this.props.afterChange(e.target.value);
    }, _this.onSelect = function (result) {
      var _this$props = _this.props,
          input = _this$props.input,
          setFieldValue = _this$props.setFieldValue,
          type = _this$props.type;

      var value = result && result.id || "";
      if (type === __WEBPACK_IMPORTED_MODULE_5__constants__["Z" /* LOWER_ASSEMBLY_APPLICATION */] && [undefined, null, ""].includes(value)) {
        setFieldValue("label")(result);
      }

      input.onChange(value);

      if (value !== input.value) {
        input.onBlur(value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Applicable, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          meta = _props.meta,
          part = _props.part,
          type = _props.type;
      var touched = meta.touched,
          invalid = meta.invalid;

      var errorClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ "has-error": touched && invalid });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "applicable-type" },
            "Type"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "select",
            {
              className: "form-control",
              id: "applicable-type",
              value: type,
              onChange: this.onChange
            },
            [__WEBPACK_IMPORTED_MODULE_5__constants__["W" /* AIRCRAFT_APPLICATION */], __WEBPACK_IMPORTED_MODULE_5__constants__["X" /* ENGINE_APPLICATION */], __WEBPACK_IMPORTED_MODULE_5__constants__["Y" /* HIGHER_ASSEMBLY_APPLICATION */], __WEBPACK_IMPORTED_MODULE_5__constants__["Z" /* LOWER_ASSEMBLY_APPLICATION */]].map(function (f) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "option",
                { value: f },
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["f" /* spaceBetweenCaps */])(f.replace("Application", ""))
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { htmlFor: "applicable" },
            config[type].label,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "sup",
              { className: "small text-danger" },
              "*"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { id: "applicable", className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "input-group-addon" },
              "Part #",
              part.part_number,
              "\xA0\xA0\xA0\xA0\xA0\xA0",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-exchange" })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: errorClasses },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Search__["a" /* default */], {
                type: type,
                onSelect: this.onSelect,
                part: part,
                autoFocus: true
              })
            )
          )
        )
      );
    }
  }]);

  return Applicable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Applicable.propTypes = {
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__["numericInput"], __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__["stringInput"]]).isRequired,
  meta: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormTypes__["meta"].isRequired,
  afterChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    part: state.partDetail.get(__WEBPACK_IMPORTED_MODULE_5__constants__["B" /* PART */]).toJS()
  };
}, function (dispatch, ownProps) {
  return {
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_redux_form__["change"])(ownProps.formName, field, val));
      };
    }
  };
})(Applicable));

/***/ }),
/* 2148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_applications__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(23);
/* unused harmony export Search */







function format(type) {
  return function (result) {
    if ([__WEBPACK_IMPORTED_MODULE_5__constants__["Y" /* HIGHER_ASSEMBLY_APPLICATION */], __WEBPACK_IMPORTED_MODULE_5__constants__["Z" /* LOWER_ASSEMBLY_APPLICATION */]].includes(type)) {
      return result.part_number;
    }

    return result.model_number;
  };
}

function Search(_ref) {
  var type = _ref.type,
      search = _ref.search,
      onSelect = _ref.onSelect,
      autoFocus = _ref.autoFocus;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["Q" /* AutoComplete */], {
    autoFocus: autoFocus,
    search: search,
    onSelect: onSelect,
    format: format(type),
    watch: type,
    allowUserInput: type === __WEBPACK_IMPORTED_MODULE_5__constants__["Z" /* LOWER_ASSEMBLY_APPLICATION */],
    selectOnBlur: false
  });
}

Search.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    search: function search(filter) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions_applications__["c" /* searchApplicables */])(ownProps.type, ownProps.part)(filter));
    }
  };
})(Search));

/***/ }),
/* 2149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Applicable__ = __webpack_require__(2147);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Applicable__["a"]; });



/***/ }),
/* 2150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_applications__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_helpers__ = __webpack_require__(79);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










function ApplicationTag(props) {
  var application = props.application,
      navToPart = props.navToPart;

  var clickableTag = application.type === __WEBPACK_IMPORTED_MODULE_5__constants__["Y" /* HIGHER_ASSEMBLY_APPLICATION */] || application.type === __WEBPACK_IMPORTED_MODULE_5__constants__["Z" /* LOWER_ASSEMBLY_APPLICATION */] && application.applicable_uuid;

  var tierClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_helpers__["a" /* getPartNumberColorClassNameByTierType */])(application.tier_type);

  if (clickableTag) {
    var onLabelClick = function onLabelClick() {
      return navToPart(application.applicable_uuid);
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["O" /* Tag */], _extends({}, props, {
      addOn: application.sellable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["j" /* NoteTooltip */], {
        className: "m-r-5",
        note: "In Stock",
        url: "https://aero-zone-assets.s3.amazonaws.com/inventory.png"
      }),
      label: application.label,
      onLabelClick: onLabelClick,
      className: tierClass
    }));
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components__["O" /* Tag */], _extends({}, props, { label: application.label }));
}

ApplicationTag.propTypes = {
  application: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  navToPart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    destroy: function destroy() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions_applications__["a" /* deleteApplication */])(ownProps.application.id, ownProps.application.part_id));
    },
    navToPart: function navToPart(partId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"])("/parts/" + partId));
    }
  };
})(ApplicationTag));

/***/ }),
/* 2151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__New__ = __webpack_require__(2154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Table__ = __webpack_require__(2155);
/* harmony export (immutable) */ __webpack_exports__["a"] = Applications;







function Applications() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      "Applications",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__shared_components__["b" /* Authorized */],
        {
          roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_2__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["j" /* WAREHOUSE */]),
          subroles: [__WEBPACK_IMPORTED_MODULE_2__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]],
          permissions: [__WEBPACK_IMPORTED_MODULE_2__users_constants__["B" /* CAN_ADD_UPDATE_APPLICATIONS */]]
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__New__["a" /* default */], null)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Table__["a" /* default */], null)
  );
}

/***/ }),
/* 2152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(2153);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Create = function (_Component) {
  _inherits(Create, _Component);

  function Create() {
    _classCallCheck(this, Create);

    var _this = _possibleConstructorReturn(this, (Create.__proto__ || Object.getPrototypeOf(Create)).call(this));

    _this.state = {
      type: __WEBPACK_IMPORTED_MODULE_3__constants__["W" /* AIRCRAFT_APPLICATION */]
    };

    _this.updateType = function (type) {
      return _this.setState({ type: type });
    };

    _this.reset = function () {
      return _this.setState({ type: __WEBPACK_IMPORTED_MODULE_3__constants__["W" /* AIRCRAFT_APPLICATION */] });
    };

    _this.reset = _this.reset.bind(_this);
    return _this;
  }

  _createClass(Create, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          open = _props.open,
          close = _props.close,
          id = _props.id;
      var type = this.state.type;


      var closeAndReset = function closeAndReset() {
        close();
        _this2.reset();
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
          { open: open, close: closeAndReset, dialogClass: "modal-sm" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: closeAndReset }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Add a New Application"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Form__["a" /* default */], {
            close: closeAndReset,
            type: type,
            updateType: this.updateType,
            id: id
          })
        )
      );
    }
  }]);

  return Create;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Create);


Create.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_applications__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Applicable__ = __webpack_require__(2149);
/* unused harmony export Form */











var FORM_NAME = "createPartApplication";

function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
        name: __WEBPACK_IMPORTED_MODULE_8__constants__["_0" /* APPLICABLE_ID */],
        component: __WEBPACK_IMPORTED_MODULE_9__Applicable__["a" /* default */],
        type: props.type,
        afterChange: props.updateType,
        formName: FORM_NAME
      })
    )
  );
}

Form.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  updateType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_4__actions_applications__["b" /* createApplication */](ownProps.id, ownProps.type, data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: function validate(values, ownProps) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_validate_this__["a" /* validator */])(values, function (f) {
      if (ownProps.type !== __WEBPACK_IMPORTED_MODULE_8__constants__["Z" /* LOWER_ASSEMBLY_APPLICATION */]) {
        f.validate(__WEBPACK_IMPORTED_MODULE_8__constants__["_0" /* APPLICABLE_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["a" /* required */]);
      } else {
        f.validate("Reciprocal").satisfies(__WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["n" /* requiresAtLeast */](1, "label", __WEBPACK_IMPORTED_MODULE_8__constants__["_0" /* APPLICABLE_ID */]));
      }
    });
  }
})(Form)));

/***/ }),
/* 2154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Create__ = __webpack_require__(2152);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return {
    id: state.partDetail.getIn(["part", "id"])
  };
})(function (_ref) {
  var id = _ref.id;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["P" /* LaunchModal */], {
    modal: __WEBPACK_IMPORTED_MODULE_3__Create__["a" /* default */],
    buttonClass: "btn-primary btn-hollow pull-right",
    id: id
  });
}));

/***/ }),
/* 2155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_arrays__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Application__ = __webpack_require__(2150);
/* unused harmony export renderGroup */
/* unused harmony export Table */










function renderHeader(applicationType) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "th",
      { style: { textAlign: "left" } },
      __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* APPLICATIONS */][applicationType].label
    )
  );
}

function renderGroup(records) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { width: "100%" },
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(records, [function (r) {
        return r.label;
      }]).map(function (r) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Application__["a" /* default */], { application: r, key: r.id });
      })
    )
  );
}

function Table(_ref) {
  var results = _ref.results;

  if (!results.length) {
    return false;
  }

  var groups = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_arrays__["e" /* groupBy */])(results, "type");
  var header = function header(name) {
    return groups[name] && renderHeader(name);
  };
  var group = function group(name) {
    return groups[name] && renderGroup(groups[name]);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-condensed" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      header(__WEBPACK_IMPORTED_MODULE_4__constants__["W" /* AIRCRAFT_APPLICATION */]),
      group(__WEBPACK_IMPORTED_MODULE_4__constants__["W" /* AIRCRAFT_APPLICATION */]),
      header(__WEBPACK_IMPORTED_MODULE_4__constants__["X" /* ENGINE_APPLICATION */]),
      group(__WEBPACK_IMPORTED_MODULE_4__constants__["X" /* ENGINE_APPLICATION */]),
      header(__WEBPACK_IMPORTED_MODULE_4__constants__["Y" /* HIGHER_ASSEMBLY_APPLICATION */]),
      group(__WEBPACK_IMPORTED_MODULE_4__constants__["Y" /* HIGHER_ASSEMBLY_APPLICATION */]),
      header(__WEBPACK_IMPORTED_MODULE_4__constants__["Z" /* LOWER_ASSEMBLY_APPLICATION */]),
      group(__WEBPACK_IMPORTED_MODULE_4__constants__["Z" /* LOWER_ASSEMBLY_APPLICATION */])
    )
  );
}

Table.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }))
};

var Decorated = __WEBPACK_IMPORTED_MODULE_3__orange_marmalade_paginate_this__["decorators"].tabulate(Table);

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Decorated, { listId: "part/applications" });
});

/***/ }),
/* 2156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Applications__ = __webpack_require__(2151);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Applications__["a"]; });



/***/ }),
/* 2157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_types_resourceTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_SellableQty__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__MergePartModal_MergePartModal__ = __webpack_require__(2175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Catalog__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__RepairQuotes_RepairQuotes__ = __webpack_require__(2194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__RepairOrders__ = __webpack_require__(2190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__LotLineItems_LotLineItems__ = __webpack_require__(2165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ManagedRepairOrders_ManagedRepairOrders__ = __webpack_require__(2173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__RepairQuotes_Send_SendRfqNestedForm__ = __webpack_require__(2196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Pin__ = __webpack_require__(2182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__EditPart__ = __webpack_require__(2208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Applications__ = __webpack_require__(2156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Alternates__ = __webpack_require__(2146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Inventory_Inventories__ = __webpack_require__(2162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__PurchaseOrders_PurchaseOrders__ = __webpack_require__(2187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__SalesOrders__ = __webpack_require__(2200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__IncomingQuotes__ = __webpack_require__(2161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__OutgoingQuotes_OutgoingQuotes__ = __webpack_require__(2179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__IncomingQuotes_Create_Create__ = __webpack_require__(2158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__OutgoingQuotes_Create__ = __webpack_require__(2177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__PurchaseOrders_Create_Create__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__RepairQuotes_Create_Create__ = __webpack_require__(2191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__RepairQuotes_Update_Update__ = __webpack_require__(2197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__ManagedRepairOrders_CreateManagedRepair_CreateManagedRepair__ = __webpack_require__(2167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Table__ = __webpack_require__(2201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__EditPart_EditDimensions__ = __webpack_require__(2205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__WeightAndDims__ = __webpack_require__(2202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__AllParts_AllParts__ = __webpack_require__(2135);
/* unused harmony export Details */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();














































function PartLabel(_ref) {
  var part = _ref.part;

  var tierType = part.get(__WEBPACK_IMPORTED_MODULE_15__constants__["O" /* TIER_TYPE */]);

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("header-content", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__shared_helpers__["a" /* getPartNumberColorClassNameByTierType */])(tierType));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: classes },
    part.get(__WEBPACK_IMPORTED_MODULE_15__constants__["w" /* PART_NUMBER */])
  );
}

PartLabel.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7_immutable__["Map"])
};

function Details(_ref2) {
  var part = _ref2.part,
      subscribeToPart = _ref2.subscribeToPart;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      editPartModalOpen = _useState2[0],
      setEditPartModalOpen = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState4 = _slicedToArray(_useState3, 2),
      editDimModalOpen = _useState4[0],
      setEditDimModalOpen = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState6 = _slicedToArray(_useState5, 2),
      mergePartModalOpen = _useState6[0],
      setMergePartModalOpen = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState8 = _slicedToArray(_useState7, 2),
      activeForm = _useState8[0],
      setActiveForm = _useState8[1];

  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),
      _useState10 = _slicedToArray(_useState9, 2),
      activeRepairQuote = _useState10[0],
      _setActiveRepairQuote = _useState10[1];

  var stats = usePartStats(part.get(__WEBPACK_IMPORTED_MODULE_18__constants__["b" /* ID */]));
  usePartSubscription(part.get(__WEBPACK_IMPORTED_MODULE_18__constants__["b" /* ID */]), subscribeToPart);
  var closeActiveForm = function closeActiveForm() {
    return setActiveForm(null);
  };
  var activateForm = function activateForm(formId) {
    return setActiveForm(formId);
  };

  var militaryPart = part.get(__WEBPACK_IMPORTED_MODULE_15__constants__["R" /* MILITARY */]);
  var hasPmaAlternate = function hasPmaAlternate() {
    var alternates = part.get("alternates").toJS();
    return alternates.some(function (alternate) {
      return alternate.pma;
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "page-header page-header-bar" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h1",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "with-padding" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["J" /* RecordPager */], { baseUrl: "/parts", record: part }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PartLabel, { part: part }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["E" /* ClipboardCopy */], { name: part.get(__WEBPACK_IMPORTED_MODULE_15__constants__["w" /* PART_NUMBER */]), type: "PN" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "small text-muted" },
            part.get(__WEBPACK_IMPORTED_MODULE_15__constants__["u" /* DESCRIPTION */])
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__Pin__["a" /* default */], { partId: part.get(__WEBPACK_IMPORTED_MODULE_18__constants__["b" /* ID */]) }),
          Number(stats.on_order) > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "pull-right" },
            "On Order: ",
            stats.on_order
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_SellableQty__["a" /* default */], { quantities: part.get(__WEBPACK_IMPORTED_MODULE_15__constants__["P" /* SELLABLE_QUANTITIES */]) }),
          militaryPart && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__shared_components__["K" /* StatusTags */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["p" /* StatusTag */], {
              display: "military",
              title: "Military",
              icon: "fighter-jet"
            })
          ),
          hasPmaAlternate() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__shared_components__["K" /* StatusTags */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["p" /* StatusTag */], { display: "warning", title: "PMA", icon: "warning" })
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "row" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "col-md-3 parts-detail-panel-width" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "panel panel-default" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "panel-body" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__Alternates__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              { style: { marginTop: 10 } },
              "Details",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11__shared_components__["b" /* Authorized */],
                {
                  roles: [__WEBPACK_IMPORTED_MODULE_14__users_constants__["k" /* SALES */]],
                  permissions: [__WEBPACK_IMPORTED_MODULE_14__users_constants__["_7" /* CAN_ADD_UPDATE_PARTS */], __WEBPACK_IMPORTED_MODULE_14__users_constants__["_8" /* CAN_MERGE_PART_NUMBERS */]],
                  subroles: [__WEBPACK_IMPORTED_MODULE_14__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */], __WEBPACK_IMPORTED_MODULE_14__users_constants__["t" /* WAREHOUSE_EXPERT */], __WEBPACK_IMPORTED_MODULE_14__users_constants__["s" /* WAREHOUSE_MANAGER */]]
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["y" /* EditButton */], { handleClick: function handleClick() {
                    return setEditPartModalOpen(true);
                  } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__EditPart__["a" /* default */], {
                  part: part.toJS(),
                  open: editPartModalOpen,
                  close: function close() {
                    return setEditPartModalOpen(false);
                  },
                  toggleMergePartModal: setMergePartModalOpen
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__Table__["a" /* default */], { part: part }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Catalog__["a" /* default */], { part: part }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              { style: { letterSpacing: "initial" } },
              "Weight & Dims",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11__shared_components__["b" /* Authorized */],
                { roles: [__WEBPACK_IMPORTED_MODULE_14__users_constants__["j" /* WAREHOUSE */]], allowManagers: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["y" /* EditButton */], { handleClick: function handleClick() {
                    return setEditDimModalOpen(true);
                  } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__EditPart_EditDimensions__["a" /* default */], {
                  part: part.toJS(),
                  open: editDimModalOpen,
                  close: function close() {
                    return setEditDimModalOpen(false);
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11__shared_components__["b" /* Authorized */],
                { permissions: [__WEBPACK_IMPORTED_MODULE_14__users_constants__["_8" /* CAN_MERGE_PART_NUMBERS */]] },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__MergePartModal_MergePartModal__["a" /* default */], {
                  partId: part.get(__WEBPACK_IMPORTED_MODULE_18__constants__["b" /* ID */]),
                  close: function close() {
                    return setMergePartModalOpen(false);
                  },
                  open: mergePartModalOpen
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__WeightAndDims__["a" /* default */], { part: part }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["m" /* DashedSeparator */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__Applications__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["z" /* AuditFields */], { record: part, multiLine: true })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "panel panel-default" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "panel-body" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h2",
              { style: { marginTop: 10 } },
              "Part List"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__AllParts_AllParts__["a" /* default */], { partId: part.get(__WEBPACK_IMPORTED_MODULE_18__constants__["c" /* UUID */]) })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "col-md-9 parts-remaining-width" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["L" /* PartStatsDetail */], { part: part, stats: stats }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__Inventory_Inventories__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { lg: activeForm ? 6 : 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
                { lg: activeForm ? 12 : 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__PurchaseOrders_PurchaseOrders__["a" /* default */], {
                  openForm: function openForm() {
                    return activateForm("po");
                  },
                  showNewButton: !activeForm
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
                { lg: activeForm ? 12 : 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__SalesOrders__["a" /* default */], null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
                { lg: activeForm ? 12 : 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__IncomingQuotes__["a" /* default */], {
                  openForm: function openForm() {
                    return activateForm("iq");
                  },
                  showNewButton: !activeForm
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
                { lg: activeForm ? 12 : 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__OutgoingQuotes_OutgoingQuotes__["a" /* default */], {
                  openForm: function openForm() {
                    return activateForm("oq");
                  },
                  showNewButton: !activeForm
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
                { lg: activeForm ? 12 : 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__RepairQuotes_RepairQuotes__["a" /* default */], {
                  openForm: function openForm() {
                    return activateForm("rq");
                  },
                  showNewButton: !activeForm,
                  setActiveRepairQuote: function setActiveRepairQuote(l) {
                    _setActiveRepairQuote(l);
                    activateForm("editRq");
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
                { lg: activeForm ? 12 : 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__RepairOrders__["a" /* default */], null)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
                { lg: activeForm ? 12 : 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__LotLineItems_LotLineItems__["a" /* default */], null)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
                { lg: activeForm ? 12 : 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__ManagedRepairOrders_ManagedRepairOrders__["a" /* default */], {
                  openForm: function openForm() {
                    return activateForm("mro");
                  },
                  showNewButton: !activeForm
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Row */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
                { lg: activeForm ? 12 : 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["M" /* Notes */], {
                  resource: part,
                  resourceType: __WEBPACK_IMPORTED_MODULE_12__shared_types_resourceTypes__["a" /* default */].part,
                  resourceKey: "part"
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
                { lg: activeForm ? 12 : 6 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components__["N" /* Attachments */], {
                  resource: part,
                  resourceType: __WEBPACK_IMPORTED_MODULE_12__shared_types_resourceTypes__["a" /* default */].part,
                  resourceKey: "part",
                  attachmentTypes: __WEBPACK_IMPORTED_MODULE_15__constants__["S" /* ATTACHMENT_TYPES */],
                  multiple: true
                })
              )
            )
          ),
          activeForm && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            ActiveForm,
            null,
            activeForm === "po" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__PurchaseOrders_Create_Create__["b" /* default */], {
              close: closeActiveForm,
              part: part.toJS()
            }),
            activeForm === "iq" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__IncomingQuotes_Create_Create__["a" /* default */], { close: closeActiveForm }),
            activeForm === "oq" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__OutgoingQuotes_Create__["a" /* default */], {
              part: part.toJS(),
              close: closeActiveForm
            }),
            activeForm === "rq" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__RepairQuotes_Create_Create__["a" /* default */], {
              close: function close(data) {
                if (data.sendRfq) {
                  _setActiveRepairQuote(data.repair_quote_line_item);
                  setActiveForm("sendRfq");
                } else {
                  window.scrollTo(0, 0);
                  setActiveForm(null);
                }
              },
              part: part.toJS()
            }),
            activeForm === "editRq" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__RepairQuotes_Update_Update__["a" /* default */], {
              close: function close(data) {
                if (data.sendRfq) {
                  _setActiveRepairQuote(data.repair_quote_line_item);
                  setActiveForm("sendRfq");
                } else {
                  window.scrollTo(0, 0);
                  setActiveForm(null);
                }
              },
              lineItem: activeRepairQuote
            }),
            activeForm === "mro" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__ManagedRepairOrders_CreateManagedRepair_CreateManagedRepair__["a" /* default */], {
              part: part.toJS(),
              close: closeActiveForm
            }),
            activeForm === "sendRfq" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__RepairQuotes_Send_SendRfqNestedForm__["a" /* default */], {
              close: closeActiveForm,
              lineItem: activeRepairQuote
            })
          )
        )
      )
    )
  );
}

Details.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7_immutable__["Map"]),
  subscribeToPart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    part: state.partDetail.get("part")
  };
}, function (dispatch) {
  return {
    subscribeToPart: function subscribeToPart(part) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__actions__["i" /* subscribe */])(part));
    },
    pushHistory: function pushHistory(url) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__["push"])(url));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__shared_decorators__["h" /* loadRecord */])({
  reducer: "partDetail",
  name: "part",
  action: __WEBPACK_IMPORTED_MODULE_10__actions__["b" /* show */]
})(Details)));

function ActiveForm(_ref3) {
  var children = _ref3.children;

  var scrollToRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__hooks__["c" /* useScrollToOnMount */])();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
    { lg: 6, ref: scrollToRef },
    children
  );
}

ActiveForm.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)])
};

// Custom hooks
function usePartSubscription(partId, subscribeTo) {
  var _useState11 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState12 = _slicedToArray(_useState11, 2),
      subscription = _useState12[0],
      setSubscription = _useState12[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!subscription) {
      setSubscription(subscribeTo(partId));
    }
    return function cleanup() {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, []);

  return subscription;
}

function usePartStats(partId) {
  var _useState13 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState14 = _slicedToArray(_useState13, 2),
      stats = _useState14[0],
      setStats = _useState14[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].reports.part_stats.search(partId).then(function (res) {
      return setStats(res.data);
    });
    return function cleanup() {};
  }, []);

  return stats;
}

/***/ }),
/* 2158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_incomingQuotes__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Form__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles__ = __webpack_require__(150);
/* harmony export (immutable) */ __webpack_exports__["a"] = Create;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }












var _INCOMING_LINE_ITEMS$ = __WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].quoteType,
    _ = _INCOMING_LINE_ITEMS$[__WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__["t" /* NOT_AWAITING_REPLY */]],
    __ = _INCOMING_LINE_ITEMS$[__WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__["c" /* AS_IS */]],
    quoteTypes = _objectWithoutProperties(_INCOMING_LINE_ITEMS$, [__WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__["t" /* NOT_AWAITING_REPLY */], __WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__["c" /* AS_IS */]]);

function Create(_ref) {
  var close = _ref.close;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCompany = _useState2[0],
      setSelectedCompany = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedEmail = _useState4[0],
      setSelectedEmail = _useState4[1];

  var _useOnSubmit = useOnSubmit(close),
      onSubmit = _useOnSubmit.onSubmit,
      setSubmittedWith = _useOnSubmit.setSubmittedWith;

  var initialValues = {
    buyer_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__hooks__["a" /* useCurrentUser */])().id,
    incoming_quote_line_item: {
      quote_type: __WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__["k" /* STANDARD */],
      cost: ""
    }
  };

  var _unused = quoteTypes[__WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__["l" /* INCIDENT_RELATED */]],
      newIQQuoteTypes = _objectWithoutProperties(quoteTypes, [__WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__["l" /* INCIDENT_RELATED */]]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "panel panel-default", style: __WEBPACK_IMPORTED_MODULE_9__styles__["a" /* default */].container },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "panel-body" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { className: "close", type: "button", onClick: close },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title", style: __WEBPACK_IMPORTED_MODULE_9__styles__["a" /* default */].title },
        "Create a New Incoming Quote"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Form__["a" /* default */], {
        close: close,
        initialValues: initialValues,
        onSubmit: onSubmit,
        setSubmittedWith: setSubmittedWith,
        quoteTypes: newIQQuoteTypes,
        selectedCompany: selectedCompany,
        selectedEmail: selectedEmail,
        setSelectedCompany: setSelectedCompany,
        setSelectedEmail: setSelectedEmail,
        modal: false
      })
    )
  );
}

Create.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

// Custom hooks
function useOnSubmit(close) {
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState6 = _slicedToArray(_useState5, 2),
      submittedWith = _useState6[0],
      setSubmittedWith = _useState6[1];

  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__hooks__["b" /* useDispatch */])();

  var afterCreate = function afterCreate(quote, sendQuote) {
    if (sendQuote) {
      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].incomingQuotes.send(quote.id, quote).then(function () {
        __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__["toastr"].success("Success", "RFQ successfully sent.");
      });
    }
    if (submittedWith === "save-and-go") {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["push"])({ pathname: "/incoming-quotes/" + quote.uuid }));
    } else {
      window.scrollTo(0, 0);
      close();
    }
  };

  var onSubmit = function onSubmit(data) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__actions_incomingQuotes__["b" /* createIncomingQuote */])(data, afterCreate));
  };

  return { onSubmit: onSubmit, setSubmittedWith: setSubmittedWith };
}

/***/ }),
/* 2159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IncomingQuotes_Parts_validate__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_constants__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;








function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    if (!values.contact_id && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(values, "company.website") || values.contact && [__WEBPACK_IMPORTED_MODULE_4__constants__["S" /* NAME */], __WEBPACK_IMPORTED_MODULE_4__constants__["T" /* EMAIL */]].some(function (f) {
      return values.contact[f];
    })) {
      form.validateChild(__WEBPACK_IMPORTED_MODULE_5__companies_constants__["g" /* CONTACT */], function (contactForm) {
        contactForm.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["S" /* NAME */], __WEBPACK_IMPORTED_MODULE_4__constants__["T" /* EMAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
        contactForm.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["T" /* EMAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["b" /* isValidEmail */]);
      });
    } else if (values.company_id) {
      form.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["O" /* CONTACT_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    }

    if (values.company_id) {
      form.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["N" /* COMPANY_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    } else {
      form.validateChild(__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* COMPANY */], function (company) {
        company.validate(__WEBPACK_IMPORTED_MODULE_4__constants__["S" /* NAME */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
      });
    }

    form.validate(__WEBPACK_IMPORTED_MODULE_6__users_constants__["x" /* BUYER_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    form.validateChild("incoming_quote_line_item", function (lineItem) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__IncomingQuotes_Parts_validate__["a" /* validateLineItem */])(lineItem, values, "incoming_quote_line_item");
    });
  });
}

/***/ }),
/* 2160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ErrorBoundary__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_arrays__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LineItemsTable__ = __webpack_require__(467);










function IncomingQuotes(_ref) {
  var location = _ref.location,
      openForm = _ref.openForm,
      showNewButton = _ref.showNewButton;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
        { to: location.pathname + "/incoming-quote-line-items" },
        "Incoming Quotes ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-fw fa-list-ol" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components__["b" /* Authorized */],
        {
          roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_arrays__["d" /* remove */])(__WEBPACK_IMPORTED_MODULE_5__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["j" /* WAREHOUSE */]),
          permissions: [__WEBPACK_IMPORTED_MODULE_5__users_constants__["_9" /* CREATE_IQS_OQS */]]
        },
        showNewButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            onClick: openForm,
            className: "btn btn-primary btn-hollow pull-right",
            type: "button"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
          "Create Quote"
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ErrorBoundary__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LineItemsTable__["b" /* default */], null)
    )
  );
}

IncomingQuotes.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pathname: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  openForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  showNewButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(IncomingQuotes));

/***/ }),
/* 2161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IncomingQuotes__ = __webpack_require__(2160);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__IncomingQuotes__["a"]; });



/***/ }),
/* 2162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table__ = __webpack_require__(2163);
/* harmony export (immutable) */ __webpack_exports__["a"] = Inventory;




function Inventory() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      { style: { marginTop: 0 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
        { to: location.pathname + "/inventories" },
        "Inventory ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-fw fa-list-ol" })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Table__["a" /* default */], null)
  );
}

/***/ }),
/* 2163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_InventoryQuantityCell__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_InventoryStatusCell__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_InventoryTagDateCell__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_InventoryListingOverrideCell__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Subscription_withSubscription__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__inventories_components_Controls__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ModifiedFlag__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_components_LocationFlag_LocationFlag__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__inventories_helpers__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__shared_components_NoteTooltip_AuditedNoteTooltip__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__helpers__ = __webpack_require__(766);
/* unused harmony export Table */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



























var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.renderInventoryRow = function (inventory, i, renderDummyValues) {
      var activeFlags = Object.keys(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_1" /* FLAG_TYPES */]).filter(function (t) {
        return inventory[t];
      });
      var hasModifiedFlag = activeFlags.includes(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_2" /* MODIFIED */]);
      var onlyModifiedFlag = activeFlags.length === 1 && hasModifiedFlag;

      var flagTypes = activeFlags.map(function (t) {
        return __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_1" /* FLAG_TYPES */][t].label;
      }).join(", ");

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13__shared_components__["A" /* LinkedTableRow */],
        {
          to: "/inventories/" + inventory.uuid,
          key: renderDummyValues ? "d-" + i : i,
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()({ "text-muted": renderDummyValues })
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          renderDummyValues ? i + 1 + "D" : i + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__shared_components_InventoryStatusCell__["a" /* default */],
          { inventory: inventory },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_InventoryListingOverrideCell__["a" /* default */], {
            inventory: inventory,
            renderDummyValues: renderDummyValues
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_date__["c" /* shortDateYY */])(inventory.date_received)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && inventory.buyer && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["e" /* truncate */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["d" /* getFirstNameLastInitial */])(inventory.buyer.full_name), 14)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          !renderDummyValues && inventory.serial_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          !renderDummyValues && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__shared_components_LocationFlag_LocationFlag__["a" /* default */], {
            inventory: inventory,
            location: inventory.store_owner_id,
            consignment_type: inventory.consignment_type
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          !renderDummyValues && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__shared_components_LocationFlag_LocationFlag__["a" /* default */], {
            inventory: inventory,
            location: inventory.store_location_id,
            wareHouseId: inventory.ware_house_id
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          flagTypes && !onlyModifiedFlag && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
            icon: "fa-flag",
            placement: "top",
            note: flagTypes,
            color: "red"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["_26" /* TRACE_TYPES */], inventory.trace_type + ".abbrev")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && inventory.traced_to && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib_formatters_text__["e" /* truncate */])(inventory.traced_to, 20)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_InventoryTagDateCell__["a" /* default */], {
          inventory: inventory,
          renderDummyValues: renderDummyValues
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__inventories_helpers__["c" /* inventoryTaggedBy */])(inventory)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: __WEBPACK_IMPORTED_MODULE_20__ModifiedFlag__["a" /* columnStyle */].flagColumn },
          hasModifiedFlag && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__ModifiedFlag__["b" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: __WEBPACK_IMPORTED_MODULE_20__ModifiedFlag__["a" /* columnStyle */].conditionColumn },
          renderDummyValues ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["r" /* INVENTORIES */], "condition." + inventory.dummy.condition + ".label") : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_7__inventories_constants__["r" /* INVENTORIES */], "condition." + inventory.condition + ".label")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          inventory.release_type
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_InventoryQuantityCell__["a" /* default */], {
          inventory: inventory,
          renderDummyValues: renderDummyValues,
          alignment: "center"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          !renderDummyValues && inventory.cost_per_unit && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib_formatters_currency__["a" /* dollars */])(inventory.cost_per_unit)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { display: "flex", alignItems: "center" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__helpers__["a" /* displaySrp */])(renderDummyValues, inventory)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], { field: __WEBPACK_IMPORTED_MODULE_7__inventories_constants__["v" /* SUGGESTED_RETAIL */], obj: inventory })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], {
          note: renderDummyValues ? inventory.dummy.note : inventory.important_note,
          color: inventory.important_note && "#f44336"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__inventories_components_Controls__["a" /* default */], { inventory: inventory })
        )
      );
    }, _this.renderRow = function (inventory, i) {
      if (inventory.dummy) {
        return [_this.renderInventoryRow(inventory, i), _this.renderInventoryRow(inventory, i, true)];
      }
      return _this.renderInventoryRow(inventory, i);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          currentPartId = _props.currentPartId,
          results = _props.results;

      var partMismatch = currentPartId && results.some(function (i) {
        return i.part_id.toString() !== currentPartId.toString();
      });

      // NOTE: This guard was put in place after Aero-Zone reported multiple occurrences of this table
      // showing records for the incorrect part.
      if (partMismatch) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { color: "red" } },
          "Error loading inventory, please reload page."
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13__shared_components__["s" /* DataTable */].Mini,
        { loading: false, numbered: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__shared_components__["s" /* DataTable */].Head,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Date Rec"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Buyer"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "Serial #"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "Store Owner"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "Store Loc"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "Flag"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Trace"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Trace To"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "Tag Date"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Tagged By"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Condition"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "Release"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "QTY"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Cost/Unit"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "SRP"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-center" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__shared_components__["s" /* DataTable */].Body,
          null,
          results.slice(0, 5).map(this.renderRow)
        )
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Table.propTypes = {
  currentPartId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  results: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
    condition: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    date_received: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    suggested_retail: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    quantity: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
    sellable_status: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    store_owner_id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    status: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    store_location_id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    tag_date: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    traced_to: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    tagged_by: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    repair_order_tagged_by: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
  })).isRequired
};
var withResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__shared_decorators__["n" /* miniTable */])(function (_ref2) {
  var match = _ref2.match;
  return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].parts.inventories.search(match.params.id);
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    currentPartId: state.partDetail.getIn(["part", "id"])
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router__["withRouter"])(withResults(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__Subscription_withSubscription__["a" /* default */])("Inventory")(Table)))));

/***/ }),
/* 2164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Subscription_withSubscription__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__IncomingQuotes_shared_AsIsFlag__ = __webpack_require__(113);
/* unused harmony export Table */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.rowClasses = function (lineItem) {
      return __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
        "text-muted": lineItem.cancelled || lineItem.shipped && lineItem.return_to_customer_without_repairing
      });
    }, _this.renderRow = function (lineItem, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components__["A" /* LinkedTableRow */],
        {
          to: "/lots/" + lineItem.lot.uuid,
          className: _this.rowClasses(lineItem),
          key: i
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          i + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["c" /* shortDateYY */])(lineItem.created_at)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["w" /* CompanyName */], { flattenedCompany: lineItem, truncateAt: 18 })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.created_by.full_name)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.serial_number === "Various" || !lineItem.serial_number && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(lineItem.expected_serial_number) ? lineItem.serial_number || lineItem.expected_serial_number : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13_react_router_dom__["a" /* Link */],
            { to: "/inventories/" + lineItem.inventory_link_id },
            lineItem.serial_number
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-left" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__RepairOrders_constants__["p" /* getConditionAbbrev */])(lineItem.condition),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__IncomingQuotes_shared_AsIsFlag__["a" /* AsIsFlag */], { lineItem: lineItem, className: "m-l-5" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          lineItem.quantity
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(lineItem.cost)
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          results = _props.results;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Mini,
        { loading: loading, numbered: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Head,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Date"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Vendor"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Buyer"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "SN"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "CD"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "QTY"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "COST/UNIT"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Body,
          null,
          results.map(this.renderRow)
        )
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Table.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    created_at: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
    company: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({ name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string }),
    buyer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({ full_name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string }),
    condition: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
    quantity: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    cost: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
  })).isRequired,
  loading: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired
};
var withResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators__["n" /* miniTable */])(function (_ref2, params) {
  var match = _ref2.match;
  return __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].parts.lotLineItems.search(match.params.id, params);
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_router__["withRouter"])(withResults(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__Subscription_withSubscription__["a" /* default */])("LotLineItem")(Table))));

/***/ }),
/* 2165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ErrorBoundary__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LineItemsTable__ = __webpack_require__(2164);







function LotLineItems(_ref) {
  var location = _ref.location;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
        { to: location.pathname + "/lot-line-items" },
        "Lot Line Items ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-fw fa-list-ol" })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ErrorBoundary__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LineItemsTable__["a" /* default */], null)
    )
  );
}

LotLineItems.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pathname: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(LotLineItems));

/***/ }),
/* 2166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ManagedRepairOrders_actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LineItemForm__ = __webpack_require__(2170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ManagedRepairOrders_helpers__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles__ = __webpack_require__(150);
/* harmony export (immutable) */ __webpack_exports__["a"] = CreateLineItem;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();














function CreateLineItem(_ref) {
  var close = _ref.close,
      part = _ref.part,
      managedRepairOrder = _ref.managedRepairOrder;

  var scrollToRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["c" /* useScrollToOnMount */])();
  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["a" /* useCurrentUser */])();

  var _useOnSubmit = useOnSubmit(managedRepairOrder, close),
      onSubmit = _useOnSubmit.onSubmit,
      onCancel = _useOnSubmit.onCancel,
      setSubmittedWith = _useOnSubmit.setSubmittedWith;

  var lineItem = part && { part: part, part_id: part.id };

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(part),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPart = _useState2[0],
      setSelectedPart = _useState2[1];

  var domLifeYears = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(part, __WEBPACK_IMPORTED_MODULE_9__constants__["T" /* DOM_LIFE_YEARS */]);
  var llp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(part, __WEBPACK_IMPORTED_MODULE_9__constants__["D" /* LLP */]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      className: "panel panel-default",
      style: __WEBPACK_IMPORTED_MODULE_11__styles__["a" /* default */].container,
      ref: scrollToRef
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "panel-body" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { className: "close", type: "button", onClick: close },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title", style: __WEBPACK_IMPORTED_MODULE_11__styles__["a" /* default */].title },
        "Add Part to Managed Repair"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LineItemForm__["a" /* default */], {
        close: close,
        initialValues: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__ManagedRepairOrders_helpers__["a" /* initialValues */])(lineItem, currentUser, managedRepairOrder),
        managedRepairOrder: managedRepairOrder,
        selectedPart: selectedPart,
        setSelectedPart: setSelectedPart,
        showBuyers: false,
        domLifeYears: domLifeYears,
        llp: llp,
        lineItem: lineItem,
        id: managedRepairOrder.id,
        shippingType: managedRepairOrder.ship_to_type,
        onSubmit: onSubmit,
        modalMode: false,
        renderFooter: function renderFooter(formProps) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Footer,
            null,
            formProps.submitFailed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["i" /* Errors */], { errors: formProps.errorMessages }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Cancel, { close: onCancel, editable: true }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Submit, {
              disabled: false,
              editable: true,
              submitting: formProps.submitting,
              onClick: function onClick() {
                return setSubmittedWith("save");
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Submit, {
              disabled: false,
              editable: true,
              submitting: formProps.submitting,
              text: "Save and Go To Managed Repair",
              onClick: function onClick() {
                return setSubmittedWith("save-and-go");
              }
            })
          );
        }
      })
    )
  );
}

CreateLineItem.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  part: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

// Custom hooks
function useOnSubmit(mro, close) {
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["b" /* useDispatch */])();

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      submittedWith = _useState4[0],
      setSubmittedWith = _useState4[1];

  var onCancel = function onCancel() {
    close();
    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].managedRepairOrders.cancel(mro.id, "cancelled_by_tenant");
  };

  var onSubmit = function onSubmit(data) {
    return dispatch(__WEBPACK_IMPORTED_MODULE_7__ManagedRepairOrders_actions__["c" /* addLineItem */](data, mro.id, function () {
      if (submittedWith === "save-and-go") {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["push"])({ pathname: "/managed-repair-orders/" + mro.uuid }));
      } else {
        window.scrollTo(0, 0);
        close();
      }
    }));
  };

  return {
    onSubmit: onSubmit,
    onCancel: onCancel,
    setSubmittedWith: setSubmittedWith
  };
}

/***/ }),
/* 2167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreateOrderForm__ = __webpack_require__(2168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreateLineItem__ = __webpack_require__(2166);
/* harmony export (immutable) */ __webpack_exports__["a"] = Create;
/* unused harmony export modifyFormDataForContact */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









function Create(_ref) {
  var close = _ref.close,
      part = _ref.part;

  var _useCreateOnSubmit = useCreateOnSubmit(),
      onSubmit = _useCreateOnSubmit.onSubmit,
      managedRepairOrder = _useCreateOnSubmit.managedRepairOrder;

  if (managedRepairOrder) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CreateLineItem__["a" /* default */], {
      close: close,
      part: part,
      managedRepairOrder: managedRepairOrder
    });
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CreateOrderForm__["a" /* default */], { part: part, close: close, onSubmit: onSubmit });
}

Create.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

// Custom hooks
function useCreateOnSubmit() {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      managedRepairOrder = _useState2[0],
      setManagedRepairOrder = _useState2[1];

  var onSubmit = function onSubmit(formData) {
    modifyFormDataForContact(formData);

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].managedRepairOrders.create(formData).then(function (resp) {
      setManagedRepairOrder(resp.data);
    });
  };

  return {
    onSubmit: onSubmit,
    managedRepairOrder: managedRepairOrder
  };
}

function modifyFormDataForContact(formData) {
  if (formData.contact_id === __WEBPACK_IMPORTED_MODULE_3__constants__["F" /* ADD */]) {
    formData.contact_id = null;
    formData.portal_purchase = false;
  }

  if (formData.contact_id === __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */]) {
    formData.contact_id = null;
    formData.portal_purchase = true;
  }

  if (formData.contact_id) {
    formData.portal_purchase = false;
  }
}

/***/ }),
/* 2168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(2169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(150);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function CreateOrder(_ref) {
  var buyerCreditPct = _ref.buyerCreditPct,
      close = _ref.close,
      onSubmit = _ref.onSubmit,
      part = _ref.part;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      company = _useState2[0],
      setCompany = _useState2[1];

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hooks__["a" /* useCurrentUser */])();

  var initialValues = {
    buying_store_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks_useCurrentUser__["c" /* defaultStoreLocation */])(currentUser),
    buyer_id: currentUser.id,
    buyer_credit_pct: buyerCreditPct,
    persistPart: true
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "panel panel-default", style: __WEBPACK_IMPORTED_MODULE_7__styles__["a" /* default */].container },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "panel-body" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { className: "close", type: "button", onClick: close },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title", style: __WEBPACK_IMPORTED_MODULE_7__styles__["a" /* default */].title },
        "Create a New Managed Repair Order"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Form__["a" /* default */], {
        close: close,
        initialValues: initialValues,
        onSubmit: onSubmit,
        part: part,
        selectedBuyer: currentUser,
        company: company,
        setCompany: setCompany
      })
    )
  );
}

CreateOrder.propTypes = {
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    buyerCreditPct: state.session.getIn([__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_3__constants__["G" /* BUYER_CREDIT_PCT */]])
  };
})(CreateOrder));

/***/ }),
/* 2169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__companies_shared_components_DoNotDoBusinessWarning__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Orders_shared_ShippingFields__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ManagedRepairOrders_shared_DetailFields__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_CompanyAddressWarning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__companies_shared_components_ActiveDemeritCompanyWarning__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_shared_BioHazmatWarning__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__validate__ = __webpack_require__(2171);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var FORM_NAME = "createManagedRepair";

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.setPaymentTerms = function (val) {
      _this.props.setPaymentTerms(val);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          selectedBuyer = _props.selectedBuyer,
          company = _props.company,
          getFieldValue = _props.getFieldValue,
          part = _props.part,
          setCompany = _props.setCompany;

      var invalidCompany = company && (!company.primary_physical_address || !company.billing_address);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
        _extends({}, this.props, { disabled: invalidCompany, modal: false }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__companies_shared_components_DoNotDoBusinessWarning__["a" /* default */], { company: company }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_CompanyAddressWarning__["a" /* default */], { company: company }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__companies_shared_components_ActiveDemeritCompanyWarning__["a" /* default */], { company: company }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ManagedRepairOrders_shared_DetailFields__["a" /* default */], {
            companyType: "Customer",
            setPaymentTerms: this.setPaymentTerms,
            selectedBuyer: selectedBuyer,
            formName: FORM_NAME,
            setSelectedCompany: setCompany
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h2",
            null,
            "Shipping"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_12__constants__["H" /* FOB */],
                  component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                  label: __WEBPACK_IMPORTED_MODULE_12__constants__["H" /* FOB */].toUpperCase(),
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: "ship_date",
                  component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                  type: "date",
                  label: "Ship Date"
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__Orders_shared_ShippingFields__["a" /* default */],
            {
              formName: FORM_NAME,
              shippingAddressField: __WEBPACK_IMPORTED_MODULE_12__constants__["_17" /* SHIP_TO_SHIPPING_ADDRESS */],
              shippingFields: [__WEBPACK_IMPORTED_MODULE_12__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_12__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_12__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */]],
              setTenantAccount: true,
              shippingMethod: __WEBPACK_IMPORTED_MODULE_12__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */]
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_shared_BioHazmatWarning__["a" /* default */], {
              parts: [part],
              shippingType: getFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["o" /* SHIPPING_TYPE */])
            })
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  setPaymentTerms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  setCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    setPaymentTerms: function setPaymentTerms(val) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])(FORM_NAME, __WEBPACK_IMPORTED_MODULE_12__constants__["M" /* PAYMENT_TERMS */], val));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_16__validate__["a" /* default */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 2170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ManagedRepairOrders_Detail_LineItemsTable_validate__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_shared__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ManagedRepairOrders_shared_PartSummary__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Orders_shared_InvoiceSection__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ManagedRepairOrders_constants__ = __webpack_require__(240);
/* unused harmony export SRP_CONDITION_OPTIONS */
/* unused harmony export exchangeSrpNotAllowed */
/* unused harmony export DOMIsRequiredWarning */
/* unused harmony export UnauthorizedRepairStationSelectedWarning */
/* unused harmony export UnauthorizedPreferredRepairStationSelectedWarning */
/* unused harmony export AsIsField */
/* unused harmony export Form */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
































var formName = "mroLineItemForm";

var SRP_CONDITION_OPTIONS = [{ value: "overhauled", text: "Overhauled" }, { value: "repaired", text: "Repaired" }, { value: "inspected", text: "Inspected" }, { value: "new_item", text: "New" }, { value: "as_removed", text: "As Removed" }, { value: "beyond_econ_repair", text: "Beyond Econ Repair" }];

function InsuranceTypeField(_ref) {
  var amountInsured = _ref.amount_insured,
      percentInsured = _ref.percent_insured,
      insuranceType = _ref.insurance_type,
      disabled = _ref.disabled;

  var activePercent = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "Percent"
  });
  var activeAmount = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "Amount"
  });
  var activeNone = __WEBPACK_IMPORTED_MODULE_7_classnames___default()("btn btn-default", {
    active: insuranceType.input.value === "None"
  });

  var handleInsuranceTypeChange = function handleInsuranceTypeChange(newVal) {
    return function () {
      if (disabled) return;
      insuranceType.input.onChange(newVal);
      if (newVal === "Amount") {
        percentInsured.input.onChange(null);
      } else if (newVal === "Percent") {
        amountInsured.input.onChange(null);
      } else {
        amountInsured.input.onChange(null);
        percentInsured.input.onChange(null);
      }
    };
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "form-group", style: { marginBottom: 20 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "label",
      { className: "control-label", htmlFor: "insurance_type" },
      "Insurance"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "btn-group btn-group-justified", role: "group" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activeNone,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("None")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Do Not Insure"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activeAmount,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("Amount")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Amount"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activePercent,
          disabled: disabled,
          onClick: handleInsuranceTypeChange("Percent")
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0Percent"
      )
    )
  );
}

InsuranceTypeField.propTypes = {
  amount_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  percent_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  insurance_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function AmountInsuredFields(_ref2) {
  var amount = _ref2.amount,
      disabled = _ref2.disabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
    { md: 4 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
      name: amount.input.name,
      label: "Insurance Amount",
      disabled: disabled,
      required: true
    })
  );
}

AmountInsuredFields.propTypes = {
  amount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function exchangeSrpNotAllowed(part) {
  return part && part.pass_fail;
}

function DOMIsRequiredWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_28__shared_components__["n" /* Warning */],
    null,
    "Part is DOM Sensitive. DOM Required."
  );
}

function UnauthorizedRepairStationSelectedWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_28__shared_components__["n" /* Warning */],
    null,
    "Note: This Repair Station is not approved. Unless you are reserving this unit for repair to a different repair station, PO will require management approval before you are able to send PO."
  );
}

function UnauthorizedPreferredRepairStationSelectedWarning() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_28__shared_components__["n" /* Warning */],
    null,
    "Note: This Repair Station is not approved. PO will require management approval before you are able to send PO."
  );
}

function PercentInsuredFields(_ref3) {
  var percent = _ref3.percent,
      cost = _ref3.cost,
      quantity = _ref3.quantity,
      disabled = _ref3.disabled;

  var costValue = cost.input.value || 0;
  var quantityValue = quantity.input.value || 0;
  var percentValue = percent.input.value || 0;
  var subtotal = parseFloat(costValue) * parseFloat(quantityValue);
  var insuranceAmount = Math.ceil(subtotal * percentValue) / 100;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
    { md: 12 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
          name: percent.input.name,
          label: "Insurance Percent",
          component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["h" /* NumberInput */],
          parse: function parse(value) {
            return value && parseInt(value, 10);
          },
          addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-percent" }),
          disabled: disabled,
          required: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: "insurance_type" },
            "Insurance Amount"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "input-group-addon" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-dollar" })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
              className: "form-control",
              type: "text",
              value: insuranceAmount,
              disabled: true,
              readOnly: true
            })
          )
        )
      )
    )
  );
}

PercentInsuredFields.propTypes = {
  percent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function InsuranceFields(_ref4) {
  var amountInsured = _ref4.amount_insured,
      percentInsured = _ref4.percent_insured,
      insuranceType = _ref4.insurance_type,
      cost = _ref4.cost,
      quantity = _ref4.quantity,
      disabled = _ref4.disabled;

  if (insuranceType.input.value === "Amount") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AmountInsuredFields, { amount: amountInsured, disabled: disabled });
  } else if (insuranceType.input.value === "Percent") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PercentInsuredFields, {
      insuranceType: insuranceType,
      percent: percentInsured,
      cost: cost,
      quantity: quantity,
      disabled: disabled
    });
  }

  return null;
}

InsuranceFields.propTypes = {
  amount_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  percent_insured: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  insurance_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

function LineHazmatFields(_ref5) {
  var hazmat = _ref5.hazmat,
      bio_hazmat = _ref5.bio_hazmat,
      disabled = _ref5.disabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group btn-group-justified", "data-toggle": "buttons" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */], {
      input: hazmat.input,
      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["h" /* HAZMAT */]),
      icon: "fa-warning",
      disabled: disabled
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */], {
      input: bio_hazmat.input,
      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["i" /* BIO_HAZMAT */]),
      icon: "fa-flask",
      disabled: disabled
    })
  );
}

LineHazmatFields.propTypes = {
  hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  bio_hazmat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

function AsIsField(_ref6) {
  var asIs = _ref6.as_is,
      evaluationPeriod = _ref6.evaluation_period,
      disabled = _ref6.disabled;

  var handleChange = function handleChange(val) {
    asIs.input.onChange(val);
    if (val === true) {
      evaluationPeriod.input.onChange(0);
    } else {
      evaluationPeriod.input.onChange(30);
    }
  };

  var input = _extends({}, asIs.input, { onChange: handleChange });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group btn-group-justified", "data-toggle": "buttons" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */], {
      input: input,
      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["c" /* AS_IS */]),
      icon: "fa-check-circle",
      disabled: disabled
    })
  );
}

AsIsField.propTypes = {
  as_is: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  evaluation_period: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref7;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref7 = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref7, [this].concat(args))), _this), _this.state = {
      alternateOptions: []
    }, _this.fetchAlternates = function (partId) {
      if (!partId) return;
      _this.props.searchAlternates(partId).then(function (results) {
        return _this.setState({
          alternateOptions: results.map(function (item) {
            return {
              text: item.name,
              value: item.id
            };
          })
        });
      });
    }, _this.handlePartSelected = function (part) {
      _this.props.setSelectedPart(part);
      _this.props.resetAlternatePartField();
      if (part) {
        _this.props.setHazardFields(part);
        _this.props.setHeavyPackage(part);
        _this.fetchAlternates(part.id);
      }
    }, _this.searchCompanies = function (filter) {
      return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].companies.search({
        repair_station: true,
        filter: filter,
        status: [__WEBPACK_IMPORTED_MODULE_24__companies_constants__["c" /* ACTIVE */], __WEBPACK_IMPORTED_MODULE_24__companies_constants__["d" /* CREDIT_HOLD */]].join(","),
        page: 1,
        limit: 20
      }).then(function (resp) {
        return resp.data.results;
      });
    }, _this.handleTaggedBy = function (company) {
      var _this$props = _this.props,
          setTaggedById = _this$props.setTaggedById,
          setTaggedByHold = _this$props.setTaggedByHold;


      if (company && company.id) {
        setTaggedById(company.id);
        setTaggedByHold(company.repair_station_status !== __WEBPACK_IMPORTED_MODULE_24__companies_constants__["j" /* APPROVED */]);
      } else {
        setTaggedByHold(false);
      }
    }, _this.handlePreferredRepairStation = function (company) {
      var setPreferredRepairStationHold = _this.props.setPreferredRepairStationHold;


      if (company && company.id) {
        setPreferredRepairStationHold(company.repair_station_status !== __WEBPACK_IMPORTED_MODULE_24__companies_constants__["j" /* APPROVED */]);
      }
    }, _this.resetPreferredRepairStation = function () {
      var resetPreferredRepairStation = _this.props.resetPreferredRepairStation;


      resetPreferredRepairStation();

      _this.setState({ selectedPreferredRepairStation: null });
    }, _this.toggleBuyer = function (buyer) {
      return _this.setState(buyer);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      if (this.props.lineItem) {
        var id = this.props.lineItem.part_id;
        var part = this.props.lineItem.part;
        var coBuyer = this.props.lineItem.co_buyer;
        var thirdBuyer = this.props.lineItem.third_buyer;

        if (part) {
          this.props.setHazardFields(part);
          this.props.setHeavyPackage(part);
          this.fetchAlternates(part.id);
        }

        this.props.setPartId(id);
        this.props.setSelectedPart(part);
        this.setState({
          selectedCoBuyer: coBuyer,
          selectedThirdBuyer: thirdBuyer
        });
      }

      if (this.props.selectedLineItem) {
        var _props$selectedLineIt = this.props.selectedLineItem,
            _part = _props$selectedLineIt.part,
            modTo = _props$selectedLineIt.mod_to,
            co_buyer = _props$selectedLineIt.co_buyer,
            third_buyer = _props$selectedLineIt.third_buyer,
            preferredRepairStation = _props$selectedLineIt.preferred_repair_station;


        this.setState({
          selectedModTo: modTo,
          selectedPart: _part,
          selectedCoBuyer: co_buyer,
          selectedThirdBuyer: third_buyer,
          selectedPreferredRepairStation: preferredRepairStation
        });

        this.props.setSelectedPart(_part);
        this.fetchAlternates(_part.id);
      }

      if (this.props.shippingType === __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* COMPANY */] && this.props.managedRepairOrder.ship_to_company && this.props.managedRepairOrder.ship_to_company.repair_station_status === __WEBPACK_IMPORTED_MODULE_24__companies_constants__["j" /* APPROVED */]) {
        var selectedPreferredRepairStation = this.props.managedRepairOrder.ship_to_company;
        this.setState({
          selectedPreferredRepairStation: selectedPreferredRepairStation
        }, function () {
          return _this2.handlePreferredRepairStation(selectedPreferredRepairStation);
        });
      }
    }
  }, {
    key: "inventoryLocked",
    value: function inventoryLocked(field) {
      var _QUANTITY$SUGGESTED_R;

      var _props = this.props,
          currentUser = _props.currentUser,
          selectedLineItem = _props.selectedLineItem;

      if (!selectedLineItem) return false;

      var buyerId = selectedLineItem.buyer.id,
          coBuyerId = selectedLineItem.co_buyer_id;


      var userCanEdit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_20__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_20__users_constants__["m" /* ACCOUNTING */]]) || [buyerId, coBuyerId].includes(currentUser.id);

      var received = selectedLineItem.received || selectedLineItem.quantity_received > 0;

      var defaultPermission = received || !userCanEdit || selectedLineItem.cancelled;
      if (!field || selectedLineItem.cancelled) {
        return defaultPermission;
      }

      return (_QUANTITY$SUGGESTED_R = {}, _defineProperty(_QUANTITY$SUGGESTED_R, __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */], selectedLineItem.cancelled || !userCanEdit), _defineProperty(_QUANTITY$SUGGESTED_R, __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["v" /* SUGGESTED_RETAIL */], !(userCanEdit || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_20__users_constants__["k" /* SALES */])) || selectedLineItem.received), _defineProperty(_QUANTITY$SUGGESTED_R, __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */], selectedLineItem.consignment_type !== __WEBPACK_IMPORTED_MODULE_18__Receiving_constants__["t" /* CONSIGNMENT */] && defaultPermission), _QUANTITY$SUGGESTED_R)[field];
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          getFieldValue = _props2.getFieldValue,
          buyerCreditPct = _props2.buyerCreditPct,
          currentUser = _props2.currentUser,
          capType = _props2.capType,
          condition = _props2.condition,
          containerFee = _props2.containerFee,
          cost = _props2.cost,
          quantity = _props2.quantity,
          searchBuyers = _props2.searchBuyers,
          searchParts = _props2.searchParts,
          searchRepairStations = _props2.searchRepairStations,
          selectedLineItem = _props2.selectedLineItem,
          setFieldValue = _props2.setFieldValue,
          hazmatFee = _props2.hazmatFee,
          markedHazardous = _props2.markedHazardous,
          modalMode = _props2.modalMode,
          renderFooter = _props2.renderFooter,
          selectedPart = _props2.selectedPart,
          domLifeYears = _props2.domLifeYears,
          llp = _props2.llp,
          modTo = _props2.modTo,
          dom = _props2.dom;


      var buyerCreditPctOptions = [{ text: "75%", value: "75.0" }, { text: "50%", value: "50.0" }, { text: "25%", value: "25.0" }];
      var cancelled = selectedLineItem && selectedLineItem.cancelled;
      var _state = this.state,
          selectedModTo = _state.selectedModTo,
          selectedCoBuyer = _state.selectedCoBuyer,
          selectedThirdBuyer = _state.selectedThirdBuyer,
          selectedPreferredRepairStation = _state.selectedPreferredRepairStation,
          alternateOptions = _state.alternateOptions;


      var locked = this.inventoryLocked();
      var leadTimeLocked = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_20__users_constants__["p" /* QUALITY_CONTROL */]) ? false : locked;
      var formProps = _extends({}, this.props, {
        editable: !(locked && this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]) && this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_22__inventories_constants__["v" /* SUGGESTED_RETAIL */])) || cancelled
      });

      var taggedByHold = getFieldValue("tagged_by_hold");
      var preferredRepairStationHold = getFieldValue("preferred_repair_station_hold");

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["e" /* Form */],
        _extends({}, formProps, { modal: modalMode }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: modalMode ? 8 : 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: "row row-col-gutters-half",
                  style: { marginTop: "26px" }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["q" /* PART_ID */],
                    label: "Part #",
                    placeholder: "Type a part's number...",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["n" /* AutoCompleteField */],
                    search: searchParts,
                    selectedItem: selectedPart,
                    formatItem: function formatItem(result) {
                      return result && result.part_number;
                    },
                    onItemSelected: function onItemSelected(i) {
                      return i && _this3.handlePartSelected(i);
                    },
                    disabled: locked,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["o" /* ALTERNATE_ID */],
                    label: "Buy As Alternate",
                    placeholder: "Type a part's number...",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: alternateOptions,
                    addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-exchange" }),
                    disabled: alternateOptions.length === 0
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__shared_components__["m" /* DashedSeparator */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["n" /* CONDITION */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: SRP_CONDITION_OPTIONS,
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_22__inventories_constants__["n" /* CONDITION */]),
                    disabled: locked,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    label: "QTY",
                    type: "number",
                    disabled: this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]),
                    required: true,
                    onBlur: function onBlur(_ev, qty) {
                      if (Number(qty) !== 1) {
                        setFieldValue(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["b" /* EXPECTED_SERIAL_NUMBER */])(null);
                      }
                    },
                    inputProps: {
                      min: 0
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["_28" /* MARKUP */]),
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["_28" /* MARKUP */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["h" /* NumberInput */],
                    addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-percent" }),
                    type: "number",
                    inputProps: {
                      min: 0,
                      max: 100
                    },
                    disabled: this.inventoryLocked(__WEBPACK_IMPORTED_MODULE_6__constants__["_28" /* MARKUP */]),
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["y" /* EXPIRATION */],
                    label: "Expiration Date",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    type: "date",
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__shared_components__["m" /* DashedSeparator */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 5 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "label",
                      { htmlFor: "warnings", className: "control-label" },
                      "Line Hazmat"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Fields"], {
                      names: [__WEBPACK_IMPORTED_MODULE_13__constants__["h" /* HAZMAT */], __WEBPACK_IMPORTED_MODULE_13__constants__["i" /* BIO_HAZMAT */]],
                      component: LineHazmatFields,
                      disabled: locked
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 2 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "label",
                      { htmlFor: __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["c" /* AS_IS */], className: "control-label" },
                      "As Is"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Fields"], {
                      names: [__WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["c" /* AS_IS */], __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["u" /* EVALUATION_PERIOD */]],
                      component: AsIsField,
                      disabled: locked
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 5 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                    { title: "Heavy Package / DIM Weight", justified: true },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["v" /* DIM_WEIGHT */],
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                      label: "Hvy Pkg / DIM Weight",
                      icon: "fa-check-circle",
                      disabled: locked
                    })
                  )
                )
              ),
              selectedModTo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_28__shared_components__["n" /* Warning */],
                null,
                "SRP Info will be applied to PN ",
                selectedModTo.part_number
              ),
              taggedByHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnauthorizedRepairStationSelectedWarning, null),
              selectedPart.dom_sensitive && __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(dom) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DOMIsRequiredWarning, null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["r" /* MonthYearField */], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["x" /* TAG_DATE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_22__inventories_constants__["x" /* TAG_DATE */]),
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    required: __WEBPACK_IMPORTED_MODULE_18__Receiving_constants__["u" /* TAG_DATE_CONDITIONS */].includes(condition),
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["p" /* TAGGED_BY */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_22__inventories_constants__["p" /* TAGGED_BY */]),
                    placeholder: "Search by a company's name",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["s" /* AutoCompleteUserInputField */],
                    required: __WEBPACK_IMPORTED_MODULE_18__Receiving_constants__["u" /* TAG_DATE_CONDITIONS */].includes(condition),
                    search: this.searchCompanies,
                    selectedItem: selectedLineItem && selectedLineItem.tagged_by,
                    handleTaggedBy: function handleTaggedBy(result) {
                      return _this3.handleTaggedBy(result);
                    },
                    formatItem: function formatItem(result) {
                      return ((typeof result === "undefined" ? "undefined" : _typeof(result)) === "object" ? result.name : result) || "";
                    },
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["r" /* MonthYearField */], {
                    name: "dom",
                    label: "DOM",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    required: domLifeYears && llp || selectedPart.dom_sensitive,
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["E" /* TRACE_TYPE */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes),
                    label: "Expected Trace Type",
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["F" /* TRACED_TO */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    label: "Expected Trace To",
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["G" /* LEAD_TIME */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    label: "Lead Time (Days)",
                    disabled: leadTimeLocked,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 4 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["b" /* EXPECTED_SERIAL_NUMBER */],
                    label: "Expected Serial #",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    disabled: selectedLineItem && selectedLineItem.received || Number(quantity) !== 1
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["a" /* CheckGroup */],
                    { justified: true, title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_25__RepairOrders_constants__["h" /* MOD_TO */]) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_25__RepairOrders_constants__["h" /* MOD_TO */],
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_25__RepairOrders_constants__["h" /* MOD_TO */]),
                      icon: "fa-check-circle",
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["b" /* Check */],
                      disabled: locked
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
                  { "in": modTo || false, unmountOnExit: true },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                    { md: 4 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_25__RepairOrders_constants__["i" /* MOD_TO_ID */],
                      label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_25__RepairOrders_constants__["h" /* MOD_TO */]),
                      placeholder: "Type a part's number...",
                      selectedItem: selectedModTo,
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["n" /* AutoCompleteField */],
                      onItemSelected: function onItemSelected(item) {
                        return item && _this3.setState({ selectedModTo: item });
                      },
                      search: searchParts,
                      formatItem: function formatItem(result) {
                        return result && result.part_number;
                      },
                      disabled: locked
                    })
                  )
                )
              ),
              selectedPart && selectedPart.llp && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_13__constants__["E" /* TOTAL_HOURS */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["E" /* TOTAL_HOURS */]),
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["h" /* NumberInput */],
                    roundDigits: 0
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_13__constants__["F" /* TOTAL_CYCLES */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_13__constants__["F" /* TOTAL_CYCLES */]),
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["h" /* NumberInput */],
                    roundDigits: 0
                  })
                )
              ),
              this.props.showBuyers && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__shared_components__["m" /* DashedSeparator */], null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h4",
                  null,
                  "Buyers"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                    { md: 5 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                      name: "read_only_buyer",
                      label: "Buyer",
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                      disabled: true,
                      required: true
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                    { md: 3 },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                      name: __WEBPACK_IMPORTED_MODULE_6__constants__["G" /* BUYER_CREDIT_PCT */],
                      className: "text-right",
                      component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                      options: buyerCreditPctOptions,
                      prompt: false,
                      label: "Buyer Credit",
                      disabled: locked,
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__PurchaseOrders_shared__["b" /* CoBuyersFields */], {
                    toggleBuyer: this.toggleBuyer,
                    buyerCreditPct: buyerCreditPct,
                    selectedCoBuyer: selectedCoBuyer,
                    selectedThirdBuyer: selectedThirdBuyer,
                    numberOfBuyers: [getFieldValue(__WEBPACK_IMPORTED_MODULE_20__users_constants__["z" /* CO_BUYER_ID */]), getFieldValue(__WEBPACK_IMPORTED_MODULE_20__users_constants__["y" /* THIRD_BUYER_ID */])].filter(function (s) {
                      return s;
                    }).length + 1,
                    searchBuyers: searchBuyers,
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Orders_shared_InvoiceSection__["a" /* default */], {
                hidden: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_20__users_constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_20__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_20__users_constants__["l" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_20__users_constants__["k" /* SALES */]]),
                disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_20__users_constants__["k" /* SALES */], __WEBPACK_IMPORTED_MODULE_20__users_constants__["l" /* REPAIR */]]),
                orderType: __WEBPACK_IMPORTED_MODULE_29__ManagedRepairOrders_constants__["a" /* MANAGED_REPAIR_ORDER */]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__shared_components__["m" /* DashedSeparator */], null),
              preferredRepairStationHold && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnauthorizedPreferredRepairStationSelectedWarning, null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Shipping & Repairs"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                selectedLineItem && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_6__constants__["W" /* AWB_NUMBER */],
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    label: "AWB #",
                    disabled: selectedLineItem.received
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["y" /* CONTAINER_FEE */],
                    label: "Container/Crate Fee",
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 3 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["z" /* HAZMAT_FEE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]),
                    disabled: locked,
                    required: markedHazardous
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["w" /* PREFERRED_REPAIR_STATION_ID */],
                    label: "Suggested Repair Station",
                    placeholder: "Type a vendor's name or code...",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["n" /* AutoCompleteField */],
                    search: searchRepairStations,
                    selectedItem: selectedPreferredRepairStation,
                    formatItem: function formatItem(result) {
                      return result && result.name;
                    },
                    disabled: locked,
                    required: true,
                    watch: selectedPreferredRepairStation,
                    onItemSelected: this.handlePreferredRepairStation
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["u" /* EVALUATION_PERIOD */],
                    type: "number",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["d" /* FormInput */],
                    disabled: locked,
                    label: "Eval. Period"
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["A" /* CAP_TYPE */],
                    className: "text-right",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["B" /* CAP_TYPES */]),
                    label: "Repair/Overhaul Cap"
                  })
                ),
                capType && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["f" /* CurrencyField */], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["C" /* CAP_AMOUNT */],
                    label: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["B" /* CAP_TYPES */][capType].label + " Cap Amount",
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 12 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Fields"], {
                    names: [__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["D" /* AMOUNT_INSURED */], __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["E" /* PERCENT_INSURED */], __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["F" /* INSURANCE_TYPE */]],
                    component: InsuranceTypeField,
                    disabled: locked
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Fields"], {
                  names: [__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["D" /* AMOUNT_INSURED */], __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["E" /* PERCENT_INSURED */], __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["F" /* INSURANCE_TYPE */], __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */], __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]],
                  component: InsuranceFields,
                  disabled: locked
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__shared_components__["m" /* DashedSeparator */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                null,
                "Notes"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["G" /* INTERNAL_NOTE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["G" /* INTERNAL_NOTE */]),
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["l" /* TextArea */],
                    rows: 5,
                    disabled: locked
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */]),
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["l" /* TextArea */],
                    rows: 5,
                    disabled: locked
                  })
                )
              ),
              cancelled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["q" /* FormRow */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                  { md: 6 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["H" /* CANCELLATION_REASON */],
                    className: "text-right",
                    component: __WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["c" /* Select */],
                    options: __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["I" /* CANCELLATION_REASONS */],
                    prompt: false,
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["H" /* CANCELLATION_REASON */])
                  })
                )
              )
            ),
            modalMode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ManagedRepairOrders_shared_PartSummary__["a" /* default */], {
                part: selectedPart,
                cost: cost,
                quantity: quantity,
                lineItem: this.props.selectedLineItem,
                hazmatFee: hazmatFee,
                containerFee: containerFee
              })
            )
          )
        ),
        renderFooter && renderFooter(formProps)
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setTaggedById: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setTaggedByHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  showBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cap_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    co_buyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    third_buyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
    part_id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  renderFooter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  resetAlternatePartField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchAlternates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedLineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchParts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchRepairStations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setHeavyPackage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setHazardFields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setPartId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  shippingType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  domLifeYears: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  llp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  managedRepairOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  selectedPart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  setSelectedPart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setPreferredRepairStationHold: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resetPreferredRepairStation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
Form.defaultProps = {
  modalMode: true,
  showBuyers: true
};
var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    getFieldValue: function getFieldValue(field) {
      return selector(state, field);
    },
    getInitialFieldValue: function getInitialFieldValue(field) {
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["getFormInitialValues"])(formName)(state), field);
    },
    buyerCreditPct: selector(state, __WEBPACK_IMPORTED_MODULE_6__constants__["G" /* BUYER_CREDIT_PCT */]),
    capType: selector(state, __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["A" /* CAP_TYPE */]),
    cost: selector(state, __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* COST */]),
    quantity: selector(state, __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* QUANTITY */]),
    condition: selector(state, __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["n" /* CONDITION */]),
    minExchangeSrp: state.session.getIn([__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_6__constants__["X" /* MINIMUM_EXCHANGE_SRP */]]),
    exchangeSRP: selector(state, __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["u" /* EXCHANGE_SRP */]),
    asIs: selector(state, __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_constants__["c" /* AS_IS */]),
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_20__users_constants__["a" /* USER */]).toJS(),
    hazmatFee: selector(state, __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]),
    containerFee: selector(state, __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["y" /* CONTAINER_FEE */]),
    markedHazardous: selector(state, __WEBPACK_IMPORTED_MODULE_13__constants__["h" /* HAZMAT */]),
    modTo: selector(state, __WEBPACK_IMPORTED_MODULE_25__RepairOrders_constants__["h" /* MOD_TO */]),
    dom: selector(state, __WEBPACK_IMPORTED_MODULE_13__constants__["G" /* DOM */]),
    getField: function getField(field) {
      return selector(state, field);
    }
  };
}, function (dispatch) {
  return {
    resetAlternatePartField: function resetAlternatePartField() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["o" /* ALTERNATE_ID */], null));
    },
    setPartId: function setPartId(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["q" /* PART_ID */], id));
    },
    setHazardFields: function setHazardFields(part) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_13__constants__["i" /* BIO_HAZMAT */], part.bio_hazmat));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_13__constants__["h" /* HAZMAT */], part.hazmat));
    },
    setHeavyPackage: function setHeavyPackage(part) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_constants__["v" /* DIM_WEIGHT */], part.dim_weight));
    },
    searchAlternates: function searchAlternates(partId) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_actions__["e" /* searchAlternates */](partId));
    },
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_actions__["c" /* searchBuyers */](filter));
    },
    searchParts: function searchParts(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_16__actions__["a" /* searchPoParts */](filter));
    },
    searchRepairStations: function searchRepairStations(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_15__PurchaseOrders_actions__["f" /* searchRepairStations */](filter));
    },
    resetForm: function resetForm(id) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["replace"])("/managed-repair-orders/" + id));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, field, val));
      };
    },
    setTaggedById: function setTaggedById(id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_22__inventories_constants__["O" /* TAGGED_BY_ID */], id));
    },
    setTaggedByHold: function setTaggedByHold(hold) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, "tagged_by_hold", hold));
    },
    setPreferredRepairStationHold: function setPreferredRepairStationHold(hold) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, "preferred_repair_station_hold", hold));
    },
    resetPreferredRepairStation: function resetPreferredRepairStation() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, "preferred_repair_station_id", ""));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_11__ManagedRepairOrders_Detail_LineItemsTable_validate__["a" /* default */]
})(Form)));

/***/ }),
/* 2171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__companies_constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;







function validate(values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate(__WEBPACK_IMPORTED_MODULE_4__users_constants__["x" /* BUYER_ID */], __WEBPACK_IMPORTED_MODULE_3__constants__["G" /* BUYER_CREDIT_PCT */], __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["g" /* BUYING_STORE_ID */], __WEBPACK_IMPORTED_MODULE_3__constants__["N" /* COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_3__constants__["O" /* CONTACT_ID */], __WEBPACK_IMPORTED_MODULE_3__constants__["q" /* SHIP_TO_TYPE */], __WEBPACK_IMPORTED_MODULE_3__constants__["M" /* PAYMENT_TERMS */], __WEBPACK_IMPORTED_MODULE_3__constants__["H" /* FOB */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);

    if (values.ship_to_type === __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["d" /* DO_NOT_SHIP */]) {
      v.validate("_error").satisfies(function () {
        if (!__WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["e" /* DO_NOT_SHIP_REASONS */].some(function (field) {
          return values[field];
        })) {
          return "At least 1 DO NOT SHIP REASON selection is required";
        }

        return null;
      });
    } else {
      v.validateChild(__WEBPACK_IMPORTED_MODULE_3__constants__["_16" /* SHIP_TO_SHIPPING_METHOD */], function (shippingForm) {
        shippingForm.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* CARRIER */], __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* SHIPPING_METHOD */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      });
    }

    if (values.contact_id === __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */]) {
      v.validateChild(__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* COMPANY */], function (companyForm) {
        companyForm.validate(__WEBPACK_IMPORTED_MODULE_5__companies_constants__["e" /* WEBSITE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      });
    }

    if (props.company) {
      v.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["N" /* COMPANY_ID */]).satisfies(function () {
        return __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["d" /* validateCompanyStatus */](props.company);
      });
    }
  });
}

/***/ }),
/* 2172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Subscription_withSubscription__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(36);
/* unused harmony export Table */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.rowClasses = function (lineItem) {
      return __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
        "text-muted": lineItem.cancelled || lineItem.shipped && lineItem.return_to_customer_without_repairing
      });
    }, _this.renderRow = function (lineItem, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components__["A" /* LinkedTableRow */],
        {
          to: "/managed-repair-orders/" + lineItem.managed_repair_order.uuid,
          className: _this.rowClasses(lineItem),
          key: i
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          i + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["c" /* shortDateYY */])(lineItem.created_at)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["w" /* CompanyName */], { flattenedCompany: lineItem, truncateAt: 18 })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.created_by.full_name)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.inventory ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13_react_router_dom__["a" /* Link */],
            { to: "/inventories/" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "inventory.uuid") },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(lineItem, "inventory.serial_number")
          ) : lineItem.expected_serial_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__RepairOrders_constants__["p" /* getConditionAbbrev */])(lineItem.condition)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(lineItem.price)
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          results = _props.results;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Mini,
        { loading: loading, numbered: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Head,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Date"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Company"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Created By"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Serial #"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-center" },
            "Condition"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Total"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components__["s" /* DataTable */].Body,
          null,
          results.map(this.renderRow)
        )
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Table.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    created_at: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
    company: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({ name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string }),
    buyer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({ full_name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string }),
    condition: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
    quantity: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    cost: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
  })).isRequired,
  loading: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired
};
var withResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators__["n" /* miniTable */])(function (_ref2, params) {
  var match = _ref2.match;
  return __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].parts.managedRepairOrderLineItems.search(match.params.id, params);
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_router__["withRouter"])(withResults(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__Subscription_withSubscription__["a" /* default */])("ManagedRepairOrderLineItem")(Table))));

/***/ }),
/* 2173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ErrorBoundary__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_arrays__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LineItemsTable__ = __webpack_require__(2172);










function ManagedRepairOrders(_ref) {
  var location = _ref.location,
      openForm = _ref.openForm,
      showNewButton = _ref.showNewButton;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
        { to: location.pathname + "/managed-repair-order-line-items" },
        "Managed Repair Orders ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-fw fa-list-ol" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components__["b" /* Authorized */],
        { roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_arrays__["d" /* remove */])(__WEBPACK_IMPORTED_MODULE_5__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["j" /* WAREHOUSE */]) },
        showNewButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            onClick: openForm,
            className: "btn btn-primary btn-hollow pull-right",
            type: "button"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
          "Create Managed Repair"
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ErrorBoundary__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LineItemsTable__["a" /* default */], null)
    )
  );
}

ManagedRepairOrders.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pathname: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  openForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  showNewButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(ManagedRepairOrders));

/***/ }),
/* 2174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__ = __webpack_require__(26);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









function Form(props) {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPart = _useState2[0],
      setSelectedPart = _useState2[1];

  var searchParts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (filter) {
    return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].parts.search({ search_type: "search", part_number: filter }).then(function (_ref) {
      var results = _ref.data.results;
      return results.filter(function (p) {
        return p.id !== props.partId;
      });
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "To which existing Part Number would you like to merge data?"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 6, mdOffset: 3 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: "merge_part_id",
            label: "Part #",
            placeholder: "Type a part's number...",
            component: __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["n" /* AutoCompleteField */],
            search: searchParts,
            selectedItem: selectedPart,
            formatItem: function formatItem(result) {
              return result && result.part_number;
            },
            onItemSelected: function onItemSelected(i) {
              return i && setSelectedPart(i);
            },
            required: true
          })
        )
      )
    )
  );
}

Form.propTypes = {
  partId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
  showPartInput: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

var FORM_NAME = "mergePart";

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME
})(Form));

/***/ }),
/* 2175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Form__ = __webpack_require__(2174);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }











var MergePartModal = function MergePartModal(_ref) {
  var close = _ref.close,
      open = _ref.open,
      partId = _ref.partId;

  var onSubmit = useCreateOnSubmit(partId, close);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components__["C" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Merge Parts"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Form__["a" /* default */], { close: close, onSubmit: onSubmit, partId: partId })
  );
};

MergePartModal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  partId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MergePartModal);

// Custom hooks
function useCreateOnSubmit(partId, close) {
  var _this = this;

  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["b" /* useDispatch */])();
  var onSubmit = function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(formData) {
      var _ref3, part;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].parts.merge(partId, formData);

            case 2:
              _ref3 = _context.sent;
              part = _ref3.data;

              __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__["toastr"].success("Success", part.part_number + " was successfully merged.");
              close();
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["push"])({ pathname: "/parts/" + part.id }));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return onSubmit;
}

/***/ }),
/* 2176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Search_Dimensions__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_weight__ = __webpack_require__(238);
/* harmony export (immutable) */ __webpack_exports__["a"] = NetWeightAndDimsPopUp;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var hasValues = function hasValues(part, values) {
  return values.every(function (f) {
    return ![undefined, null, ""].includes(part[f]);
  });
};

function NetWeightAndDimsPopUp(_ref) {
  var _translatedPart;

  var part = _ref.part;

  var hasNetDimsAndWeight = hasValues(part, [__WEBPACK_IMPORTED_MODULE_2__constants__["p" /* NET_LENGTH */], __WEBPACK_IMPORTED_MODULE_2__constants__["q" /* NET_WIDTH */], __WEBPACK_IMPORTED_MODULE_2__constants__["r" /* NET_HEIGHT */], __WEBPACK_IMPORTED_MODULE_2__constants__["o" /* NET_WEIGHT */]]);

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      copying = _useState2[0],
      setCopying = _useState2[1];

  if (!hasNetDimsAndWeight) {
    return null;
  }

  var translatedPart = (_translatedPart = {}, _defineProperty(_translatedPart, __WEBPACK_IMPORTED_MODULE_2__constants__["l" /* LENGTH */], part[__WEBPACK_IMPORTED_MODULE_2__constants__["p" /* NET_LENGTH */]]), _defineProperty(_translatedPart, __WEBPACK_IMPORTED_MODULE_2__constants__["k" /* WIDTH */], part[__WEBPACK_IMPORTED_MODULE_2__constants__["q" /* NET_WIDTH */]]), _defineProperty(_translatedPart, __WEBPACK_IMPORTED_MODULE_2__constants__["m" /* HEIGHT */], part[__WEBPACK_IMPORTED_MODULE_2__constants__["r" /* NET_HEIGHT */]]), _translatedPart);

  var dimsText = hasValues(part, [__WEBPACK_IMPORTED_MODULE_2__constants__["p" /* NET_LENGTH */], __WEBPACK_IMPORTED_MODULE_2__constants__["q" /* NET_WIDTH */], __WEBPACK_IMPORTED_MODULE_2__constants__["r" /* NET_HEIGHT */]]) ? "Net Dm: " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__Search_Dimensions__["b" /* partDimsText */])({ part: translatedPart }) + " | " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__Search_Dimensions__["c" /* partDimsCMText */])({
    part: translatedPart
  }) : "";

  var oz = part[__WEBPACK_IMPORTED_MODULE_2__constants__["t" /* NET_WEIGHT_UNIT */]] === __WEBPACK_IMPORTED_MODULE_2__constants__["z" /* POUNDS */] ? " " + part.net_weight_oz + " oz" : "";

  var weightText = hasValues(part, [__WEBPACK_IMPORTED_MODULE_2__constants__["t" /* NET_WEIGHT_UNIT */], __WEBPACK_IMPORTED_MODULE_2__constants__["o" /* NET_WEIGHT */]]) ? "Net Wt: " + part[__WEBPACK_IMPORTED_MODULE_2__constants__["o" /* NET_WEIGHT */]] + " " + part[__WEBPACK_IMPORTED_MODULE_2__constants__["t" /* NET_WEIGHT_UNIT */]] + oz + " | " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_weight__["a" /* calculateNetValue */])(part[__WEBPACK_IMPORTED_MODULE_2__constants__["t" /* NET_WEIGHT_UNIT */]], part[__WEBPACK_IMPORTED_MODULE_2__constants__["o" /* NET_WEIGHT */]], part[__WEBPACK_IMPORTED_MODULE_2__constants__["s" /* NET_WEIGHT_OZ */]]) + " " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_weight__["d" /* conversionUnitAbbrev */])(part[__WEBPACK_IMPORTED_MODULE_2__constants__["t" /* NET_WEIGHT_UNIT */]]) : "";

  var note = dimsText + "\n" + weightText;

  /* eslint-disable no-unused-expressions */
  var copy = function copy() {
    navigator.clipboard && navigator.clipboard.writeText(note).then(function () {
      setCopying(true);
      setTimeout(function () {
        setCopying(false);
      }, 900);
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_NoteTooltip__["a" /* NoteTooltip */], {
    icon: "fa-cog",
    placement: "right",
    className: "clickable",
    onClick: copy,
    note: copying ? "Copied!" : note
  });
}

NetWeightAndDimsPopUp.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Form__ = __webpack_require__(2178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SendQuote__ = __webpack_require__(2180);
/* harmony export (immutable) */ __webpack_exports__["a"] = Create;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }













function Create(_ref) {
  var part = _ref.part,
      close = _ref.close;

  var _useCreateOnSubmit = useCreateOnSubmit(part.id, close),
      onSubmit = _useCreateOnSubmit.onSubmit,
      setSubmittedWith = _useCreateOnSubmit.setSubmittedWith,
      createdQuote = _useCreateOnSubmit.createdQuote;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["a" /* useCurrentUser */])();

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCompany = _useState2[0],
      setSelectedCompany = _useState2[1];

  if (createdQuote) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SendQuote__["a" /* default */], { close: close, quote: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(createdQuote) });
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Form__["a" /* default */], {
    close: close,
    onSubmit: onSubmit,
    setSubmittedWith: setSubmittedWith,
    currentUser: currentUser,
    selectedCompany: selectedCompany,
    setSelectedCompany: setSelectedCompany
  });
}

Create.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  })
};

// Custom hooks
function useCreateOnSubmit(partId, close) {
  var _this = this;

  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["b" /* useDispatch */])();

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      createdQuote = _useState4[0],
      setCreatedQuote = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState6 = _slicedToArray(_useState5, 2),
      submittedWith = _useState6[0],
      setSubmittedWith = _useState6[1];

  var onSubmit = function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(formData) {
      var _ref3, quote;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              modifyFormDataForContactAdd(formData);

              formData.outgoing_quote_line_item = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_helpers__["c" /* transformOQOutputValues */])(formData.outgoing_quote_line_item);

              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].parts.outgoingQuotes.create(partId, formData);

            case 4:
              _ref3 = _context.sent;
              quote = _ref3.data;

              __WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__["toastr"].success("Success", quote.code + " successfully created.");

              if (!(submittedWith === "send")) {
                _context.next = 11;
                break;
              }

              setCreatedQuote(quote);
              _context.next = 17;
              break;

            case 11:
              if (!formData.send_quote) {
                _context.next = 16;
                break;
              }

              modifyFormDataForSendQuote(formData, quote);
              _context.next = 15;
              return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].outgoingQuotes.send(quote.id, formData);

            case 15:
              __WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__["toastr"].success("Success", "Quote successfully sent.");

            case 16:

              if (submittedWith === "save-and-go") {
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"])({ pathname: "/outgoing-quotes/" + quote.uuid }));
              } else {
                window.scrollTo(0, 0);
                close();
              }

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return {
    onSubmit: onSubmit,
    setSubmittedWith: setSubmittedWith,
    createdQuote: createdQuote
  };
}

function modifyFormDataForContactAdd(formData) {
  formData.contact_id = formData.contact_id === "Add" ? null : formData.contact_id;
}

function modifyFormDataForSendQuote(formData, quote) {
  formData.line_items = JSON.parse(JSON.stringify(quote.outgoing_quote_line_items));
  formData.line_items.forEach(function (item) {
    if (formData.attach_traceability) {
      item.attach_traceability = true;
    }
    if (formData.attach_tag_copies) {
      item.attach_tag_copies = true;
    }
    if (formData.show_hazmat_warning) {
      item.show_hazmat_warning = true;
    }

    item.inventory_attachment_ids = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(formData, "outgoing_quote_line_item.inventory_attachment_ids");
  });
}

/***/ }),
/* 2178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__companies_shared_components_DoNotDoBusinessWarning__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__companies_shared_components_DoNotQuoteWarning__ = __webpack_require__(2039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SalesOrders_components_ConvertFromCartForm_Warnings__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__companies_actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_shared_PartDetails__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__OutgoingQuotes_shared_OutgoingQuoteTypeSelect__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__OutgoingQuotes_shared_warnings__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shared_components_CompanyAddressWarning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__companies_shared_FindOrCreateCompanyToggle_FormToggle__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_time__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__OutgoingQuotes_shared_SelectInventoryTable__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__OutgoingQuotes_shared_helpers__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__shared_constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Receiving_constants__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__LineItemsTable__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__SelectImages__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__shared_PartHazmatWarning__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__lib_formatters_number__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__companies_shared_components_DoNotExchangeWarning__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__shared_components_Forms_NumberInput_NumberInput__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__validate__ = __webpack_require__(2181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__styles__ = __webpack_require__(150);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















































function within72BusinessHours(date) {
  if (!date) return false;
  var now = new Date();
  var created = new Date(date);

  var hoursPassed = 0;
  var dayMillis = 24 * 60 * 60 * 1000;
  var cursor = new Date(created);

  while (cursor < now) {
    var day = cursor.getDay(); // 0=Sun,1=Mon,...6=Sat
    // Add 24 hours only if weekday
    if (day !== 0 && day !== 6) {
      hoursPassed += 24;
    }
    cursor = new Date(cursor.getTime() + dayMillis);
    if (hoursPassed > 72) break;
  }
  return hoursPassed <= 72;
}

function AirlineEndUser72HrWarning(_ref) {
  var recentQuotes = _ref.recentQuotes,
      part = _ref.part,
      quoteType = _ref.quoteType;

  if (![__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["i" /* STANDARD */], __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["j" /* EXCHANGE_ONLY */], __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["k" /* AOG */]].includes(quoteType)) return null;

  var interestingTypes = [__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["i" /* STANDARD */], __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["j" /* EXCHANGE_ONLY */], __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["k" /* AOG */], __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["l" /* EXCHANGE */]];
  var airlineQuotes = recentQuotes.filter(function (rq) {
    if (!rq.company) return false;
    var ct = rq.company.company_type;
    var typeMatches = interestingTypes.includes(rq.quote_type.toLowerCase());
    var isAirlineEndUser = ct === "airline" || ct === "end_user";
    return typeMatches && isAirlineEndUser && within72BusinessHours(rq.created_at);
  });

  if (!airlineQuotes.length) return null;

  // Show the first or most recent quote
  var lastOne = airlineQuotes[0];

  var partNumber = part && part.get("part_number") || "this part";
  var companyName = lastOne.company.name || "airline/end-user";
  var quotedByUser = lastOne.created_by_user ? lastOne.created_by_user.first_name + " " + lastOne.created_by_user.last_name : "(Backend System)";
  var contactName = lastOne.contact ? lastOne.contact.name : "(Backend System)";
  var quotedDate = new Date(lastOne.created_at).toLocaleString();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_40__shared_components__["n" /* Warning */],
    null,
    "The part number (" + partNumber + ") has been quoted to " + companyName + " within the last 72 hours.",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
    "It was quoted by " + quotedByUser + " to " + contactName + " on " + quotedDate + ".",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
    "If you think it might be for the same order, please reconsider quoting prior to discussing with " + quotedByUser + "."
  );
}

var formName = "partDetailNewOutgoingQuote";
var FORM_SECTION = "outgoing_quote_line_item";

var getNameFromSection = function getNameFromSection(field) {
  return FORM_SECTION + "." + field;
};

var TraceabilityWarning = function TraceabilityWarning(_ref2) {
  var company = _ref2.company;

  if (!company) return null;
  if (!company.vendor_trace_preapproval_required) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_40__shared_components__["n" /* Warning */],
    null,
    "Warning: This customer is flagged for trace approval being required in advance. Please consider attaching traceabliity to quote."
  );
};

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this));

    _this.state = {
      companyToggleType: "existing",
      company: {},
      companyQuotes: [],
      contacts: [],
      recentQuotes: [],
      companyPartHistory: {},
      quantityChanged: false,
      inventoryPrice: null,
      invalidCompany: false,
      selectedInventories: [],
      showAttachTraceability: false,
      showAttachTagCopies: false
    };

    _this.setWarrantyField = function (val) {
      _this.props.change(getNameFromSection(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["g" /* WARRANTY */]), val);
    };

    _this.setSending = function () {
      _this.setState({
        showAttachTraceability: _this.state.selectedInventories.some(function (i) {
          return i.attachments.some(function (a) {
            return a.attachment_type === __WEBPACK_IMPORTED_MODULE_25__inventories_constants__["d" /* TRACEABILITY */];
          });
        }),
        showAttachTagCopies: _this.state.selectedInventories.some(function (i) {
          return i.attachments.some(function (a) {
            return a.attachment_type === __WEBPACK_IMPORTED_MODULE_25__inventories_constants__["c" /* TAG_COPIES */] && (!i.last_exchange_received || new Date(a.created_at) > new Date(i.last_exchange_received));
          }) && i.repair_status !== __WEBPACK_IMPORTED_MODULE_29__RepairOrders_constants__["n" /* REPAIR_AND_HOLD */] && i.status !== __WEBPACK_IMPORTED_MODULE_25__inventories_constants__["_60" /* REPAIRING */];
        })
      }, function () {
        _this.props.change(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["m" /* ATTACH_TAG_COPIES */], _this.state.showAttachTagCopies && _this.state.selectedInventories.every(function (i) {
          return i.condition !== __WEBPACK_IMPORTED_MODULE_25__inventories_constants__["_39" /* AS_REMOVED */];
        }));
      });
    };

    _this.notifyForm = function (company) {
      if (company && (!company.primary_physical_address || !company.billing_address)) {
        return _this.setState({ invalidCompany: true, company: company });
      }
      return _this.setState({ invalidCompany: false });
    };

    _this.copyInventoryFields = function (inventory) {
      return Object.keys(__WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_shared_PartDetails__["a" /* copyFromInventoryFieldsOnOQ */]).forEach(function (field) {
        return _this.props.change(getNameFromSection(field), __WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_shared_PartDetails__["a" /* copyFromInventoryFieldsOnOQ */][field](inventory, _this.props.quoteType, _this.props.part.toJS(), _this.props.canExchange && !__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(_this.props.selectedCompany, __WEBPACK_IMPORTED_MODULE_37__companies_constants__["k" /* DO_NOT_EXCHANGE */]) && !inventory.do_not_exchange && !inventory.do_not_exchange_due_to_outright_value));
      });
    };

    _this.clearFieldsCopiedFromInventory = function () {
      Object.keys(__WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_shared_PartDetails__["a" /* copyFromInventoryFieldsOnOQ */]).forEach(function (field) {
        if (field === __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["g" /* WARRANTY */] && _this.props.quoteType === __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["n" /* AS_IS */] && _this.state.inventoryIds && _this.state.inventoryIds.length <= 1) {
          _this.props.change(getNameFromSection(field), "No Warranty, unit sold as-is.");
        } else {
          _this.props.change(getNameFromSection(field), null);
        }
      });

      [__WEBPACK_IMPORTED_MODULE_25__inventories_constants__["H" /* FAA */], __WEBPACK_IMPORTED_MODULE_25__inventories_constants__["I" /* EASA */], __WEBPACK_IMPORTED_MODULE_25__inventories_constants__["L" /* UK_CAA */]].forEach(function (f) {
        return _this.props.change(getNameFromSection(f), true);
      });
    };

    _this.handleCompanySelected = function (company) {
      _this.props.setSelectedCompany(company);

      if (company.do_not_quote) {
        _this.props.setFieldValue(getNameFromSection(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */]))(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["o" /* MAKE_OFFER */]);
      }

      if (company[__WEBPACK_IMPORTED_MODULE_37__companies_constants__["k" /* DO_NOT_EXCHANGE */]]) {
        _this.props.setFieldValue(getNameFromSection(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */]))(null);
      }

      var partId = _this.props.part.get(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* ID */]);

      __WEBPACK_IMPORTED_MODULE_12__api__["a" /* default */].companies.parts.history(company.id, [partId]).then(function (_ref3) {
        var data = _ref3.data;

        _this.setState({
          companyPartHistory: data.results[0] || {},
          company: company
        });
      });

      __WEBPACK_IMPORTED_MODULE_12__api__["a" /* default */].parts.outgoingQuoteLineItems.search(partId, {
        limit: 5,
        company_id: company.id,
        created_after: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_time__["c" /* monthsAgo */])(18)
      }).then(function (res) {
        _this.setState({ companyQuotes: res.data.results });
      });
    };

    _this.handleInventorySelected = function (inventory) {
      var inventoryIds = _this.props.inventoryIds;
      var selectedInventories = _this.state.selectedInventories;


      if (inventory === null) {
        _this.props.change(getNameFromSection(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["p" /* INVENTORY_IDS */]), []);
        _this.clearFieldsCopiedFromInventory();
        _this.setState({
          selectedInventories: []
        }, function () {
          _this.setSending();
        });
        return;
      }

      if (inventoryIds.includes(inventory.id)) {
        var index = inventoryIds.indexOf(inventory.id);
        inventoryIds.splice(index, 1);
        _this.props.change([FORM_SECTION, __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["p" /* INVENTORY_IDS */]].join("."), inventoryIds);
        _this.setState({
          selectedInventories: selectedInventories.filter(function (i) {
            return i.id !== inventory.id;
          })
        }, function () {
          _this.setSending();
        });

        if (inventoryIds.length === 0) {
          _this.clearFieldsCopiedFromInventory();
        }
      } else {
        inventoryIds.push(inventory.id);
        _this.props.change([FORM_SECTION, __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["p" /* INVENTORY_IDS */]].join("."), inventoryIds);
        _this.setState({
          selectedInventories: selectedInventories.concat([inventory])
        }, function () {
          _this.setSending();
        });

        if (_this.state.inventory !== inventory && inventoryIds.length === 1) {
          _this.copyInventoryFields(inventory);
          __WEBPACK_IMPORTED_MODULE_12__api__["a" /* default */].inventories.show(inventory.id).then(function (res) {
            _this.setState({ inventoryDetails: res.data }, function () {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__OutgoingQuotes_shared_helpers__["a" /* handleRepairItem */])({
                inventoryDetails: res.data,
                change: _this.props.change,
                getNameFromSection: getNameFromSection
              });
            });
          });
        }

        if (inventoryIds.length > 1) {
          _this.clearFieldsCopiedFromInventory();
        }
      }

      _this.setState({
        quantityChanged: false,
        inventoryPrice: inventory && inventory.suggested_retail
      });
    };

    _this.handleQuantityChanged = function () {
      if (!_this.state.quantityChanged) _this.props.change(getNameFromSection(__WEBPACK_IMPORTED_MODULE_25__inventories_constants__["o" /* SERIAL_NUMBER */]), "");
      _this.setState({ quantityChanged: true });
    };

    _this.handleEmail = function (email) {
      if (email !== "Add") {
        _this.props.change("to", email);
      }
    };

    _this.notifyForm = _this.notifyForm.bind(_this);
    return _this;
  }

  _createClass(Form, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.part) {
        return __WEBPACK_IMPORTED_MODULE_12__api__["a" /* default */].parts.outgoingQuoteLineItems.search(this.props.part.get(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* ID */]), { limit: 30 }).then(function (res) {
          _this2.setState({ recentQuotes: res.data.results });
        });
      }

      return null;
    }
  }, {
    key: "getInventoriesFilter",
    value: function getInventoriesFilter() {
      var quoteType = this.props.quoteType;


      var inventoriesFilter = {
        limit: "10",
        sellable_status: [__WEBPACK_IMPORTED_MODULE_25__inventories_constants__["U" /* LIST */], __WEBPACK_IMPORTED_MODULE_25__inventories_constants__["W" /* DO_NOT_LIST */]].join(",")
      };

      if (quoteType === __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["q" /* OFFER */]) {
        inventoriesFilter.or_in_condition = __WEBPACK_IMPORTED_MODULE_30__Receiving_constants__["g" /* BEYOND_ECON_REPAIR */];
      }

      return inventoriesFilter;
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          canExchange = _props.canExchange,
          currentUser = _props.currentUser,
          getField = _props.getField,
          submitting = _props.submitting,
          companyId = _props.companyId,
          getFieldWithSection = _props.getFieldWithSection,
          inventoryIds = _props.inventoryIds,
          part = _props.part,
          quoteType = _props.quoteType,
          warranty = _props.warranty,
          setSubmittedWith = _props.setSubmittedWith,
          submitFailed = _props.submitFailed,
          errorMessages = _props.errorMessages,
          close = _props.close,
          change = _props.change,
          _resetFields = _props.resetFields,
          selectedCompany = _props.selectedCompany,
          setFieldValue = _props.setFieldValue;
      var _state = this.state,
          inventoryPrice = _state.inventoryPrice,
          company = _state.company,
          companyQuotes = _state.companyQuotes,
          invalidCompany = _state.invalidCompany,
          companyPartHistory = _state.companyPartHistory,
          recentQuotes = _state.recentQuotes,
          selectedInventories = _state.selectedInventories,
          showAttachTraceability = _state.showAttachTraceability,
          showAttachTagCopies = _state.showAttachTagCopies;


      var mostRecentQuotes = recentQuotes.filter(function (quote) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_time__["b" /* isLessThan36HoursAgo */])(quote.created_at) && companyId === quote.company_id;
      });

      var showSendButton = !inventoryIds || inventoryIds.length > 1;

      var showSendQuoteCheck = quoteType !== __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["q" /* OFFER */];
      var canSendQuote = showSendQuoteCheck && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_31__users_constants__["k" /* SALES */]);

      var showSendQuoteForm = (!inventoryIds || inventoryIds.length < 2) && canSendQuote;
      /* eslint-disable */

      var _OUTGOING_LINE_ITEMS$ = __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["c" /* OUTGOING_LINE_ITEMS */].quoteType,
          exchange = _OUTGOING_LINE_ITEMS$.exchange,
          filteredQuoteTypes = _objectWithoutProperties(_OUTGOING_LINE_ITEMS$, ["exchange"]);
      /* eslint-enable */


      filteredQuoteTypes = part.get(__WEBPACK_IMPORTED_MODULE_28__constants__["U" /* PASS_FAIL */]) ? __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.omit(filteredQuoteTypes, [__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["j" /* EXCHANGE_ONLY */]]) : filteredQuoteTypes;

      var altOptions = part.get("alternates").toJS().map(function (a) {
        return {
          value: a.id,
          text: a.name
        };
      });

      var passFail = part.get(__WEBPACK_IMPORTED_MODULE_28__constants__["U" /* PASS_FAIL */]);

      var inventoriesFilter = this.getInventoriesFilter();
      var partObject = part.toJS();
      var isBERMaterialSelected = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.some(selectedInventories, function (item) {
        return item.condition === __WEBPACK_IMPORTED_MODULE_30__Receiving_constants__["g" /* BEYOND_ECON_REPAIR */];
      });

      var minOutrightVal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__hooks_useCurrentUser__["b" /* useSettings */])()[__WEBPACK_IMPORTED_MODULE_2__constants__["_22" /* MIN_OUTRIGHT_VALUE_FOR_EXCHANGE_CONSIDERATION */]];

      var disablePartFields = {
        price_per_unit: isBERMaterialSelected && getField(FORM_SECTION + "." + __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["q" /* OFFER */]) === __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["r" /* NO_INTEREST */],
        exchange_fee: isBERMaterialSelected || selectedCompany && selectedCompany[__WEBPACK_IMPORTED_MODULE_37__companies_constants__["k" /* DO_NOT_EXCHANGE */]] || minOutrightVal && Number(minOutrightVal) > getField(FORM_SECTION + ".price_per_unit")
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "panel panel-default form-panel", style: __WEBPACK_IMPORTED_MODULE_44__styles__["a" /* default */].container },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "panel-body" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            { className: "close", type: "button", onClick: close },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            { className: "modal-title", style: __WEBPACK_IMPORTED_MODULE_44__styles__["a" /* default */].title },
            "Create a New Outgoing Quote"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["e" /* Form */],
            _extends({}, this.props, {
              editable: !invalidCompany,
              submitting: submitting,
              modal: false
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["e" /* Form */].Body,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AirlineEndUser72HrWarning, {
                recentQuotes: recentQuotes,
                part: part,
                quoteType: quoteType
              }),
              passFail && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_40__shared_components__["n" /* Warning */],
                null,
                "Due to the Pass / Fail nature of this item. Exchange Only is not available as a Quote Type."
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__companies_shared_components_DoNotQuoteWarning__["a" /* default */], { company: selectedCompany }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__companies_shared_components_DoNotDoBusinessWarning__["a" /* default */], { company: selectedCompany }),
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__OutgoingQuotes_shared_warnings__["a" /* default */])(mostRecentQuotes, companyPartHistory),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SalesOrders_components_ConvertFromCartForm_Warnings__["a" /* NoPmaNoDerWarning */], {
                inventories: selectedInventories,
                company: company
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SalesOrders_components_ConvertFromCartForm_Warnings__["b" /* TraceTypeWarning */], {
                inventories: selectedInventories,
                company: company
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SalesOrders_components_ConvertFromCartForm_Warnings__["c" /* StrictTraceWarning */], {
                inventories: selectedInventories,
                company: company
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SalesOrders_components_ConvertFromCartForm_Warnings__["d" /* WarrantyMinimumWarning */], {
                company: company,
                lineItems: [{ warranty: warranty }]
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "row" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                  { md: 12 },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["q" /* FormRow */],
                    { style: { marginTop: "26px" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                      { md: 6 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_8_redux_form__["FormSection"],
                        { name: FORM_SECTION },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Fields"], {
                          change: change,
                          fieldName: __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */],
                          names: [__WEBPACK_IMPORTED_MODULE_25__inventories_constants__["n" /* CONDITION */], __WEBPACK_IMPORTED_MODULE_2__constants__["_21" /* INVENTORY_ID */], __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["b" /* PRICE_PER_UNIT */], __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_25__inventories_constants__["p" /* TAGGED_BY */], __WEBPACK_IMPORTED_MODULE_25__inventories_constants__["x" /* TAG_DATE */], __WEBPACK_IMPORTED_MODULE_25__inventories_constants__["E" /* TRACE_TYPE */], __WEBPACK_IMPORTED_MODULE_25__inventories_constants__["F" /* TRACED_TO */], __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */], __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["g" /* WARRANTY */]],
                          component: __WEBPACK_IMPORTED_MODULE_16__OutgoingQuotes_shared_OutgoingQuoteTypeSelect__["a" /* default */],
                          quoteTypes: filteredQuoteTypes,
                          price: inventoryPrice
                        })
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
                  invalidCompany && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__shared_components_CompanyAddressWarning__["a" /* default */], { company: company }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__companies_shared_components_DoNotExchangeWarning__["a" /* default */], { company: company }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__companies_shared_FindOrCreateCompanyToggle_FormToggle__["a" /* default */], {
                    formName: formName,
                    type: "outgoingQuote",
                    companySearch: __WEBPACK_IMPORTED_MODULE_24__actions__["h" /* searchQuoteCompanies */],
                    handleEmail: this.handleEmail,
                    onCompanySelected: this.handleCompanySelected,
                    setPrimaryContact: false
                  }),
                  companyQuotes && companyQuotes.length > 0 && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "h4",
                    { className: "margin-bottom-30 line-height-2" },
                    "Most Recent Quotes"
                  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "reset-panel-table" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__LineItemsTable__["a" /* LineItemsTable */], {
                      results: companyQuotes,
                      limitResults: true,
                      loading: false,
                      inForm: true
                    })
                  )],
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "h4",
                    null,
                    "Select From Inventory"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_8_redux_form__["FormSection"],
                      { name: FORM_SECTION },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__OutgoingQuotes_shared_SelectInventoryTable__["a" /* default */], {
                        key: quoteType,
                        filter: inventoriesFilter,
                        part: partObject,
                        inventoryIds: inventoryIds,
                        onInventorySelected: this.handleInventorySelected,
                        modal: false,
                        change: change,
                        quoteType: quoteType
                      })
                    )
                  ),
                  selectedInventories.length === 1 && __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(selectedInventories, "0.condition") !== getFieldWithSection(__WEBPACK_IMPORTED_MODULE_25__inventories_constants__["n" /* CONDITION */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_40__shared_components__["n" /* Warning */],
                    null,
                    "SRP Condition does not match actual condition."
                  ),
                  quoteType !== __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["h" /* NO_QUOTE */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "h4",
                      null,
                      "Part Details"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_8_redux_form__["FormSection"],
                      { name: FORM_SECTION },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_shared_PartDetails__["b" /* default */],
                        {
                          canExchange: canExchange,
                          disableTagType: inventoryIds && inventoryIds.length === 1,
                          disabled: disablePartFields,
                          formName: formName,
                          formSection: FORM_SECTION,
                          getFieldValue: getFieldWithSection,
                          handleQuantityChanged: this.handleQuantityChanged,
                          inventoryIds: inventoryIds,
                          setWarrantyField: this.setWarrantyField,
                          part: partObject,
                          passFail: part.get(__WEBPACK_IMPORTED_MODULE_28__constants__["U" /* PASS_FAIL */]),
                          quoteType: quoteType,
                          setFieldValue: setFieldValue,
                          selectedInventories: selectedInventories,
                          resetFields: function resetFields() {
                            return _resetFields(change);
                          },
                          doNotExchangeInventoryLineItem: selectedInventories.length > 0 && selectedInventories.some(function (i) {
                            return i.do_not_exchange;
                          })
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__shared_PartHazmatWarning__["a" /* default */], {
                          hazmat: part.get(__WEBPACK_IMPORTED_MODULE_28__constants__["h" /* HAZMAT */]),
                          hazmatFee: getFieldWithSection(__WEBPACK_IMPORTED_MODULE_27__PurchaseOrders_constants__["z" /* HAZMAT_FEE */])
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["q" /* FormRow */],
                          null,
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                            { md: 4 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              "div",
                              { className: "form-group" },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                                name: __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["s" /* SELL_AS_ALT_ID */],
                                component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["c" /* Select */],
                                label: "Quote As Alt",
                                options: altOptions
                              })
                            )
                          ),
                          part.get(__WEBPACK_IMPORTED_MODULE_28__constants__["D" /* LLP */]) && [getFieldWithSection(__WEBPACK_IMPORTED_MODULE_25__inventories_constants__["s" /* TOTAL_HOURS_REMAINING */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                            { md: 4 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                              component: __WEBPACK_IMPORTED_MODULE_39__shared_components_Forms_NumberInput_NumberInput__["a" /* default */],
                              roundDigits: 0,
                              name: __WEBPACK_IMPORTED_MODULE_25__inventories_constants__["s" /* TOTAL_HOURS_REMAINING */],
                              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_25__inventories_constants__["s" /* TOTAL_HOURS_REMAINING */]),
                              disabled: true
                            })
                          ), getFieldWithSection(__WEBPACK_IMPORTED_MODULE_25__inventories_constants__["t" /* TOTAL_CYCLES_REMAINING */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                            { md: 4 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                              component: __WEBPACK_IMPORTED_MODULE_39__shared_components_Forms_NumberInput_NumberInput__["a" /* default */],
                              roundDigits: 0,
                              name: __WEBPACK_IMPORTED_MODULE_25__inventories_constants__["t" /* TOTAL_CYCLES_REMAINING */],
                              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_25__inventories_constants__["t" /* TOTAL_CYCLES_REMAINING */]),
                              disabled: true
                            })
                          )],
                          part.get(__WEBPACK_IMPORTED_MODULE_28__constants__["h" /* HAZMAT */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                            { md: 4 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              "div",
                              { className: "form-group" },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                                name: __WEBPACK_IMPORTED_MODULE_27__PurchaseOrders_constants__["z" /* HAZMAT_FEE */],
                                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_27__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]),
                                component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["d" /* FormInput */],
                                type: "number",
                                step: 0.01,
                                onBlur: function onBlur(ev, val) {
                                  ev.preventDefault();
                                  setFieldValue(getNameFromSection(__WEBPACK_IMPORTED_MODULE_27__PurchaseOrders_constants__["z" /* HAZMAT_FEE */]))(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36__lib_formatters_number__["d" /* decimalField */])(val));
                                }
                              })
                            )
                          ),
                          quoteType === __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["j" /* EXCHANGE_ONLY */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                            { md: 4 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                              label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_29__RepairOrders_constants__["e" /* CORE_DUE_DAYS */]),
                              name: __WEBPACK_IMPORTED_MODULE_29__RepairOrders_constants__["e" /* CORE_DUE_DAYS */],
                              type: "number",
                              step: 1,
                              component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["d" /* FormInput */]
                            })
                          )
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
                    " "
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "form-group" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_8_redux_form__["FormSection"],
                      { name: FORM_SECTION },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["q" /* FormRow */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                          { md: 6 },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                            name: __WEBPACK_IMPORTED_MODULE_26__shared_constants__["c" /* INTERNAL_NOTE */],
                            rows: 5,
                            cols: 50,
                            component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["l" /* TextArea */],
                            label: "Internal Note (Applied to the line item)"
                          })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                          { md: 6 },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                            name: __WEBPACK_IMPORTED_MODULE_27__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */],
                            rows: 5,
                            cols: 50,
                            component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["l" /* TextArea */],
                            label: "External Note (*visible to Customer*)"
                          })
                        )
                      ),
                      " "
                    ),
                    " "
                  )
                )
              ),
              showSendQuoteForm && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TraceabilityWarning, { company: selectedCompany }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "well" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["d" /* Row */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                      { md: 6 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "h4",
                        { style: { marginTop: 0 } },
                        "Send Quote"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["d" /* FormInput */],
                        name: "to",
                        label: "To:",
                        disabled: !canSendQuote
                      }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["d" /* FormInput */],
                        name: "cc",
                        label: "CC:",
                        disabled: !canSendQuote
                      }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                        component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["d" /* FormInput */],
                        name: "bcc",
                        label: "BCC:",
                        disabled: !canSendQuote
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                      { md: 6 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "div",
                        { style: { marginTop: "33px" } },
                        showAttachTraceability && ![__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["h" /* NO_QUOTE */], __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["q" /* OFFER */]].includes(quoteType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["a" /* CheckGroup */],
                          {
                            checkGroupStyles: { marginBottom: 0 },
                            justified: true
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                            name: __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["t" /* ATTACH_TRACEABILITY */],
                            component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["b" /* Check */],
                            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["t" /* ATTACH_TRACEABILITY */])
                          })
                        ),
                        showAttachTagCopies && ![__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["h" /* NO_QUOTE */], __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["q" /* OFFER */]].includes(quoteType) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["a" /* CheckGroup */],
                          {
                            checkGroupStyles: { marginBottom: 0 },
                            justified: true
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                            name: __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["m" /* ATTACH_TAG_COPIES */],
                            component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["b" /* Check */],
                            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["m" /* ATTACH_TAG_COPIES */])
                          })
                        ),
                        showSendQuoteCheck && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["a" /* CheckGroup */],
                          {
                            checkGroupStyles: { marginBottom: 0 },
                            justified: true
                          },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                            name: __WEBPACK_IMPORTED_MODULE_42__IncomingQuotes_constants__["o" /* SEND_QUOTE */],
                            component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["b" /* Check */],
                            label: "Send Quote",
                            onChange: function onChange(_ev, val) {
                              if (!val) {
                                setFieldValue(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["u" /* AUTO_FOLLOWUP */])(false);
                                setFieldValue(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["v" /* AUTO_FOLLOWUP_DAYS */])(null);
                              }
                            }
                          })
                        ), getField(__WEBPACK_IMPORTED_MODULE_42__IncomingQuotes_constants__["o" /* SEND_QUOTE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["q" /* FormRow */],
                          null,
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                            { md: 6 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["a" /* CheckGroup */],
                              {
                                checkGroupStyles: { marginBottom: 0 },
                                justified: true
                              },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                                name: __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["u" /* AUTO_FOLLOWUP */],
                                component: __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["b" /* Check */],
                                label: "Auto Follow Up"
                              })
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
                            { md: 6 },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_form__["Field"], {
                              label: ["# of Days ", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__shared_components__["j" /* NoteTooltip */], {
                                placement: "right",
                                icon: "fa-info-circle",
                                color: "rgba(255, 255, 255, 0.25)",
                                note: "Range: 1 to 14"
                              })],
                              name: __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["v" /* AUTO_FOLLOWUP_DAYS */],
                              disabled: !getField(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["u" /* AUTO_FOLLOWUP */]),
                              component: __WEBPACK_IMPORTED_MODULE_39__shared_components_Forms_NumberInput_NumberInput__["a" /* default */],
                              roundDigits: 0,
                              type: "number"
                            })
                          )
                        )]
                      )
                    )
                  ),
                  selectedInventories.length === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__SelectImages__["a" /* default */], {
                    formSection: FORM_SECTION,
                    formName: formName,
                    inventory: selectedInventories[0]
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["e" /* Form */].Footer,
              null,
              submitFailed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["i" /* Errors */], { errors: errorMessages }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["e" /* Form */].Cancel, { close: close, editable: true }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["e" /* Form */].Submit, {
                disabled: false,
                editable: true,
                submitting: submitting,
                onClick: function onClick() {
                  return setSubmittedWith("save");
                }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["e" /* Form */].Submit, {
                disabled: false,
                editable: true,
                text: "Save and Go To Quote",
                submitting: submitting,
                onClick: function onClick() {
                  return setSubmittedWith("save-and-go");
                }
              }),
              showSendButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["e" /* Form */].Submit, {
                disabled: canSendQuote,
                editable: true,
                text: "Send",
                submitting: submitting,
                onClick: function onClick() {
                  return setSubmittedWith("send");
                }
              })
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  getFieldWithSection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  pricePerUnit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  quoteType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  change: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  companyId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  inventoryIds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  setSubmittedWith: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  setSelectedCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function (state, props) {
  return {
    initialValues: {
      bcc: props.currentUser.email,
      attach_tag_copies: false,
      show_hazmat_warning: state.partDetail.getIn([__WEBPACK_IMPORTED_MODULE_28__constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_28__constants__["h" /* HAZMAT */]]),
      outgoing_quote_line_item: {
        inventory_attachment_ids: [],
        cost: "",
        condition: state.partDetail.getIn([__WEBPACK_IMPORTED_MODULE_28__constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_28__constants__["H" /* TOOLING_PART_TYPE */]]) ? __WEBPACK_IMPORTED_MODULE_2__constants__["U" /* SERVICEABLE_TOOLING */] : undefined,
        hazmat_fee: state.partDetail.getIn([__WEBPACK_IMPORTED_MODULE_28__constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_28__constants__["h" /* HAZMAT */]]) ? state.session.getIn([__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_2__constants__["_34" /* DEFAULT_HAZMAT_FEE */]]) : undefined,
        inventory_ids: [],
        include_dom: false,
        quote_type: __WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["i" /* STANDARD */],
        faa: true,
        easa: true,
        uk_caa: true,
        external_note: state.partDetail.getIn([__WEBPACK_IMPORTED_MODULE_28__constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_28__constants__["V" /* PERMANENT_EXTERNAL_NOTE_FOR_OQ */]]),
        warranty: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__OutgoingQuotes_shared_PartDetails__["c" /* warrantyForCondition */])(null, state.partDetail.get(__WEBPACK_IMPORTED_MODULE_28__constants__["B" /* PART */]).toJS()) || state.partDetail.getIn([__WEBPACK_IMPORTED_MODULE_28__constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_25__inventories_constants__["_61" /* WARRANTY_OVERRIDE */]])
      }
    },
    canExchange: state.session.getIn([__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_2__constants__["_35" /* CAN_EXCHANGE */]]),
    companyId: selector(state, __WEBPACK_IMPORTED_MODULE_2__constants__["N" /* COMPANY_ID */]),
    getFieldWithSection: function getFieldWithSection(field) {
      return selector(state, FORM_SECTION + "." + field);
    },
    inventoryIds: selector(state, getNameFromSection(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["p" /* INVENTORY_IDS */])),
    getField: function getField(name) {
      return selector(state, name);
    },
    part: state.partDetail.get(__WEBPACK_IMPORTED_MODULE_28__constants__["B" /* PART */]),
    pricePerUnit: selector(state, getNameFromSection(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["b" /* PRICE_PER_UNIT */])),
    quantity: selector(state, getNameFromSection(__WEBPACK_IMPORTED_MODULE_2__constants__["j" /* QUANTITY */])),
    quoteType: selector(state, getNameFromSection(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */])),
    warranty: selector(state, getNameFromSection(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["g" /* WARRANTY */]))
  };
}, function (dispatch) {
  return {
    resetFields: function resetFields(change) {
      dispatch(change(getNameFromSection(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["b" /* PRICE_PER_UNIT */]), ""));
      dispatch(change(getNameFromSection(__WEBPACK_IMPORTED_MODULE_22__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */]), ""));
    },
    setFieldValue: function setFieldValue(field) {
      return function (value) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_redux_form__["change"])(formName, field, value));
      };
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_43__validate__["a" /* default */],
  asyncValidate: __WEBPACK_IMPORTED_MODULE_14__companies_actions__["b" /* validateContact */],
  asyncBlurFields: ["contact.email"]
})(Form)));

/***/ }),
/* 2179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ErrorBoundary__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LineItemsTable__ = __webpack_require__(335);









function OutgoingQuotes(_ref) {
  var location = _ref.location,
      openForm = _ref.openForm,
      showNewButton = _ref.showNewButton;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
        { to: location.pathname + "/outgoing-quote-line-items" },
        "Outgoing Quotes ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-fw fa-list-ol" })
      ),
      showNewButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components__["b" /* Authorized */],
        { roles: [__WEBPACK_IMPORTED_MODULE_5__users_constants__["l" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_5__users_constants__["k" /* SALES */]], permissions: [__WEBPACK_IMPORTED_MODULE_5__users_constants__["_9" /* CREATE_IQS_OQS */]] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            onClick: openForm,
            className: "btn btn-primary btn-hollow pull-right",
            type: "button"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
          "Create Quote"
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ErrorBoundary__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LineItemsTable__["b" /* default */], null)
    )
  );
}

OutgoingQuotes.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pathname: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  openForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  showNewButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(OutgoingQuotes));

/***/ }),
/* 2180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OutgoingQuotes_Detail_Send_Form__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(150);
/* harmony export (immutable) */ __webpack_exports__["a"] = SendQuote;







function SendQuote(_ref) {
  var quote = _ref.quote,
      close = _ref.close;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hooks__["a" /* useCurrentUser */])();
  var scrollToRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hooks__["c" /* useScrollToOnMount */])();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      className: "panel panel-default form-panel",
      style: __WEBPACK_IMPORTED_MODULE_5__styles__["a" /* default */].container,
      ref: scrollToRef
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "panel-body" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title", style: __WEBPACK_IMPORTED_MODULE_5__styles__["a" /* default */].title },
        "Send Outgoing Quote"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__OutgoingQuotes_Detail_Send_Form__["a" /* default */], {
        close: close,
        quote: quote,
        currentUser: currentUser,
        modal: false,
        smallForm: true
      })
    )
  );
}

SendQuote.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  quote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired
};

/***/ }),
/* 2181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OutgoingQuotes_shared_Parts_validate__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;






function validate(values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(values.contact)) {
      form.validateChild("contact", function (contactForm) {
        contactForm.validate("name", "email").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
        contactForm.validate("email").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["b" /* isValidEmail */]);
      });
    } else {
      form.validate("contact_id").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(values.company)) {
      form.validateChild("company", function (company) {
        company.validate("name").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      });
    } else {
      form.validate("company_id").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    }

    if (values.auto_followup) {
      form.validate(__WEBPACK_IMPORTED_MODULE_4__OutgoingQuotes_constants__["v" /* AUTO_FOLLOWUP_DAYS */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      form.validate(__WEBPACK_IMPORTED_MODULE_4__OutgoingQuotes_constants__["v" /* AUTO_FOLLOWUP_DAYS */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](1), __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["k" /* isLessThanOrEqualTo */](14));
    }

    if (props.selectedCompany) {
      form.validate("company_id").satisfies(function () {
        return __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["d" /* validateCompanyStatus */](props.selectedCompany);
      });
    }

    form.validateChild("outgoing_quote_line_item", function (lineItem) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__OutgoingQuotes_shared_Parts_validate__["a" /* validateLineItem */])(lineItem, values, "outgoing_quote_line_item");
    });
  });
}

/***/ }),
/* 2182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Nav_BookmarkedParts_actions__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();









function Pin(_ref) {
  var bookmarks = _ref.bookmarks,
      createBookmark = _ref.createBookmark,
      partId = _ref.partId,
      removeBookmark = _ref.removeBookmark;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();

  var isPinned = bookmarks.map(function (p) {
    return p.part.id;
  }).includes(partId);

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),
      _useState4 = _slicedToArray(_useState3, 2),
      text = _useState4[0],
      setText = _useState4[1];

  var handleTooltip = function handleTooltip() {
    var method = isPinned ? removeBookmark : createBookmark;
    setText(isPinned ? "Removed!" : "Bookmarked!");
    method(partId).then(function () {
      setShow(true);
    });
  };

  var handleCloseTooltip = function handleCloseTooltip() {
    setTimeout(function () {
      setShow(false);
    }, 900);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
      className: "fa fa-thumb-tack fa-xs pointer",
      style: {
        transform: "rotate(45deg)",
        margin: "0px 5px",
        color: isPinned ? "#3d8b40" : ""
      },
      ref: ref,
      onClick: handleTooltip
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* Overlay */],
      {
        target: ref.current,
        show: show,
        placement: "top",
        onEntered: handleCloseTooltip
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["b" /* Tooltip */],
        null,
        text
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  var bookmarks = state.session.get(__WEBPACK_IMPORTED_MODULE_5__users_constants__["d" /* BOOKMARKS */]).toJS();
  return {
    bookmarks: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["isArray"])(bookmarks) ? bookmarks : []
  };
}, function (dispatch) {
  return {
    createBookmark: function createBookmark(partId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__Nav_BookmarkedParts_actions__["a" /* create */])(partId));
    },
    removeBookmark: function removeBookmark(partId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__Nav_BookmarkedParts_actions__["b" /* destroy */])(partId));
    }
  };
})(Pin));

Pin.propTypes = {
  bookmarks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
  createBookmark: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  removeBookmark: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  partId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

/***/ }),
/* 2183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PurchaseOrders_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_components_Detail_LineItemsTable_Form__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles__ = __webpack_require__(150);
/* harmony export (immutable) */ __webpack_exports__["a"] = CreateLineItem;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();














function CreateLineItem(_ref) {
  var close = _ref.close,
      part = _ref.part,
      purchaseOrder = _ref.purchaseOrder;

  var scrollToRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["c" /* useScrollToOnMount */])();
  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["a" /* useCurrentUser */])();

  var _useOnSubmit = useOnSubmit(purchaseOrder, close),
      onSubmit = _useOnSubmit.onSubmit,
      onCancel = _useOnSubmit.onCancel,
      setSubmittedWith = _useOnSubmit.setSubmittedWith;

  var lineItem = part && {
    part: part,
    part_id: part.id,
    dom_sensitive: part.dom_sensitive
  };

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPart = _useState2[0],
      setSelectedPart = _useState2[1];

  var domLifeYears = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(part, "dom_life_years");
  var llp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(part, __WEBPACK_IMPORTED_MODULE_10__constants__["D" /* LLP */]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    {
      className: "panel panel-default",
      style: __WEBPACK_IMPORTED_MODULE_11__styles__["a" /* default */].container,
      ref: scrollToRef
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "panel-body" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { className: "close", type: "button", onClick: close },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title", style: __WEBPACK_IMPORTED_MODULE_11__styles__["a" /* default */].title },
        "Add Part to Purchase Order"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_components_Detail_LineItemsTable_Form__["a" /* default */], {
        close: close,
        initialValues: initialValues(lineItem, currentUser, purchaseOrder),
        selectedPart: selectedPart,
        setSelectedPart: setSelectedPart,
        showBuyers: false,
        domLifeYears: domLifeYears,
        llp: llp,
        lineItem: lineItem,
        id: purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["b" /* ID */]),
        shippingType: purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["o" /* SHIPPING_TYPE */]),
        onSubmit: onSubmit,
        modalMode: false,
        renderFooter: function renderFooter(formProps) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Footer,
            null,
            formProps.submitFailed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["i" /* Errors */], { errors: formProps.errorMessages }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Cancel, { close: onCancel, editable: true }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Submit, {
              disabled: false,
              editable: true,
              submitting: formProps.submitting,
              onClick: function onClick() {
                return setSubmittedWith("save");
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Submit, {
              disabled: false,
              editable: true,
              submitting: formProps.submitting,
              text: "Save and Go To PO",
              onClick: function onClick() {
                return setSubmittedWith("save-and-go");
              }
            })
          );
        }
      })
    )
  );
}

CreateLineItem.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  part: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  purchaseOrder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

// TODO: The code below is a direct copy of AddPart.jsx. Need to figure out a way to share form initialization!
function initialValues(lineItem, currentUser, purchaseOrder) {
  var values = {
    buyer_credit_pct: 75,
    condition: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, "part.tooling_part_type") ? __WEBPACK_IMPORTED_MODULE_9__constants__["U" /* SERVICEABLE_TOOLING */] : undefined,
    request_vendor_approval: false,
    request_shop_approval: false,
    same_as_billing: true,
    evaluation_period: 30,
    reserve_for_seller_id: currentUser.id,
    read_only_buyer: purchaseOrder.getIn(["buyer", "full_name"]),
    insurance_type: "None",
    cancelled: false,
    part: {
      pass_fail: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, "part.pass_fail")
    },
    purchase_for_sale: false,
    purchase_for_stock: false,
    purchase_for_repair: false,
    purchase_for_repair_assist: false,
    quantity: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, "part.dom_sensitive") ? 1 : undefined,
    tagged_by: undefined,
    tagged_by_id: undefined,
    tagged_by_hold: false
  };

  if (!purchaseOrder.get("buyers_discrepancy")) {
    values.buyer_credit_pct = purchaseOrder.get("buyer_credit_pct");
    values.co_buyer_id = purchaseOrder.get("co_buyer_id");
    values.third_buyer_id = purchaseOrder.get("third_buyer_id");
    if (lineItem) {
      lineItem.co_buyer = purchaseOrder.get("co_buyer") && purchaseOrder.get("co_buyer").toJS();
      lineItem.third_buyer = purchaseOrder.get("third_buyer") && purchaseOrder.get("third_buyer").toJS();
    }
  }

  return values;
}

// Custom hooks
function useOnSubmit(purchaseOrder, close) {
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["b" /* useDispatch */])();

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState4 = _slicedToArray(_useState3, 2),
      submittedWith = _useState4[0],
      setSubmittedWith = _useState4[1];

  var onCancel = function onCancel() {
    close();
    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].purchaseOrders.cancel(purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["b" /* ID */]), "cancelled_by_tenant");
  };

  var onSubmit = function onSubmit(data) {
    return dispatch(__WEBPACK_IMPORTED_MODULE_7__PurchaseOrders_actions__["d" /* addLineItem */](data, purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["b" /* ID */]), function () {
      if (submittedWith === "save-and-go") {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["push"])({ pathname: "/purchase-orders/" + purchaseOrder.get(__WEBPACK_IMPORTED_MODULE_9__constants__["c" /* UUID */]) }));
      } else {
        window.scrollTo(0, 0);
        close();
      }
    }));
  };

  return {
    onSubmit: onSubmit,
    onCancel: onCancel,
    setSubmittedWith: setSubmittedWith
  };
}

/***/ }),
/* 2184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(2185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(150);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function CreateOrder(_ref) {
  var buyerCreditPct = _ref.buyerCreditPct,
      close = _ref.close,
      onSubmit = _ref.onSubmit,
      part = _ref.part;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      company = _useState2[0],
      setCompany = _useState2[1];

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hooks__["a" /* useCurrentUser */])();

  var initialValues = {
    buying_store_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks_useCurrentUser__["c" /* defaultStoreLocation */])(currentUser),
    buyer_id: currentUser.id,
    buyer_credit_pct: buyerCreditPct,
    persistPart: true
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "panel panel-default", style: __WEBPACK_IMPORTED_MODULE_7__styles__["a" /* default */].container },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "panel-body" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { className: "close", type: "button", onClick: close },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title", style: __WEBPACK_IMPORTED_MODULE_7__styles__["a" /* default */].title },
        "Create a New Purchase Order"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Form__["a" /* default */], {
        close: close,
        initialValues: initialValues,
        onSubmit: onSubmit,
        part: part,
        selectedBuyer: currentUser,
        company: company,
        setCompany: setCompany
      })
    )
  );
}

CreateOrder.propTypes = {
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    buyerCreditPct: state.session.getIn([__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* SETTINGS */], __WEBPACK_IMPORTED_MODULE_3__constants__["G" /* BUYER_CREDIT_PCT */]])
  };
})(CreateOrder));

/***/ }),
/* 2185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__companies_shared_components_DoNotDoBusinessWarning__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Orders_shared_ShippingFields__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_shared_DetailFields__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_CompanyAddressWarning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__companies_shared_components_ActiveDemeritCompanyWarning__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_shared_BioHazmatWarning__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__validate__ = __webpack_require__(2186);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var FORM_NAME = "createPurchaseOrder";

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.setPaymentTerms = function (val) {
      _this.props.setPurchaseOrder(val);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          selectedBuyer = _props.selectedBuyer,
          company = _props.company,
          getFieldValue = _props.getFieldValue,
          part = _props.part,
          setCompany = _props.setCompany;

      var invalidCompany = company && (!company.primary_physical_address || !company.billing_address);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
        _extends({}, this.props, { disabled: invalidCompany, modal: false }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__companies_shared_components_DoNotDoBusinessWarning__["a" /* default */], { company: company }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_CompanyAddressWarning__["a" /* default */], { company: company }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__companies_shared_components_ActiveDemeritCompanyWarning__["a" /* default */], { company: company }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_shared_DetailFields__["a" /* default */], {
            setPaymentTerms: this.setPaymentTerms,
            selectedBuyer: selectedBuyer,
            formName: FORM_NAME,
            setSelectedCompany: setCompany
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h2",
            null,
            "Shipping"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row row-col-gutters-half" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_12__constants__["H" /* FOB */],
                  component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                  label: __WEBPACK_IMPORTED_MODULE_12__constants__["H" /* FOB */].toUpperCase(),
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                  name: "ship_date",
                  component: __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["d" /* FormInput */],
                  type: "date",
                  label: "Ship Date"
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__Orders_shared_ShippingFields__["a" /* default */],
            {
              formName: FORM_NAME,
              path: __WEBPACK_IMPORTED_MODULE_12__constants__["I" /* SHIPPING_ADDRESS */],
              shippingFields: [__WEBPACK_IMPORTED_MODULE_12__constants__["o" /* SHIPPING_TYPE */], __WEBPACK_IMPORTED_MODULE_12__constants__["J" /* SHIP_TO_COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_12__constants__["K" /* SHIP_TO_COMPANY_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_12__constants__["L" /* SHIP_TO_ADDRESS_PHONE */]],
              setTenantAccount: true,
              shippingMethod: __WEBPACK_IMPORTED_MODULE_12__constants__["g" /* SHIPPING_METHOD */],
              shippingAddressField: __WEBPACK_IMPORTED_MODULE_12__constants__["I" /* SHIPPING_ADDRESS */]
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__PurchaseOrders_shared_BioHazmatWarning__["a" /* default */], {
              parts: [part],
              shippingType: getFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["o" /* SHIPPING_TYPE */])
            })
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Form.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  setPurchaseOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  setCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    setPurchaseOrder: function setPurchaseOrder(val) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["change"])(FORM_NAME, __WEBPACK_IMPORTED_MODULE_12__constants__["M" /* PAYMENT_TERMS */], val));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: FORM_NAME,
  validate: __WEBPACK_IMPORTED_MODULE_15__validate__["a" /* default */]
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Form))));

/***/ }),
/* 2186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__companies_constants__ = __webpack_require__(22);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;







function validate(values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate(__WEBPACK_IMPORTED_MODULE_4__users_constants__["x" /* BUYER_ID */], __WEBPACK_IMPORTED_MODULE_3__constants__["G" /* BUYER_CREDIT_PCT */], __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["g" /* BUYING_STORE_ID */], __WEBPACK_IMPORTED_MODULE_3__constants__["N" /* COMPANY_ID */], __WEBPACK_IMPORTED_MODULE_3__constants__["O" /* CONTACT_ID */], __WEBPACK_IMPORTED_MODULE_3__constants__["o" /* SHIPPING_TYPE */], __WEBPACK_IMPORTED_MODULE_3__constants__["M" /* PAYMENT_TERMS */], __WEBPACK_IMPORTED_MODULE_3__constants__["H" /* FOB */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);

    if (values.shipping_type === __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["d" /* DO_NOT_SHIP */]) {
      v.validate("_error").satisfies(function () {
        if (!__WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["e" /* DO_NOT_SHIP_REASONS */].some(function (field) {
          return values[field];
        })) {
          return "At least 1 DO NOT SHIP REASON selection is required";
        }

        return null;
      });
    } else {
      v.validateChild(__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* SHIPPING_METHOD */], function (shippingForm) {
        shippingForm.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* CARRIER */], __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* SHIPPING_METHOD */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      });
    }

    if (values.contact_id === __WEBPACK_IMPORTED_MODULE_2__PurchaseOrders_constants__["f" /* PORTAL_PURCHASE */]) {
      v.validateChild(__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* COMPANY */], function (companyForm) {
        companyForm.validate(__WEBPACK_IMPORTED_MODULE_5__companies_constants__["e" /* WEBSITE */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
      });
    }

    if (props.company) {
      v.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["N" /* COMPANY_ID */]).satisfies(function () {
        return __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["d" /* validateCompanyStatus */](props.company);
      });
    }
  });
}

/***/ }),
/* 2187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ErrorBoundary__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_arrays__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Table__ = __webpack_require__(754);










function PurchaseOrders(_ref) {
  var location = _ref.location,
      showNewButton = _ref.showNewButton,
      openForm = _ref.openForm;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
        { to: location.pathname + "/purchase-order-line-items" },
        "Purchase Orders ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-fw fa-list-ol" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__shared_components__["b" /* Authorized */],
        { roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_arrays__["d" /* remove */])(__WEBPACK_IMPORTED_MODULE_7__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_7__users_constants__["j" /* WAREHOUSE */]), permissions: [__WEBPACK_IMPORTED_MODULE_7__users_constants__["_10" /* CREATE_POS */]] },
        showNewButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            onClick: openForm,
            className: "btn btn-primary btn-hollow pull-right",
            type: "button"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
          "Create PO"
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ErrorBoundary__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Table__["a" /* default */], null)
    )
  );
}

PurchaseOrders.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pathname: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  openForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  showNewButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(PurchaseOrders));

/***/ }),
/* 2188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_ErrorBoundary__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Table__ = __webpack_require__(2189);
/* harmony export (immutable) */ __webpack_exports__["a"] = RepairOrders;





function RepairOrders() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
        { to: location.pathname + "/repair-order-line-items" },
        "Repair Orders ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-fw fa-list-ol" })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_ErrorBoundary__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Table__["a" /* default */], null)
    )
  );
}

/***/ }),
/* 2189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Subscription_withSubscription__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RepairOrders_components_Detail_LineItems_StatusBadges__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RepairOrders_helpers__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_formatters_currency__ = __webpack_require__(20);
/* unused harmony export Table */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.renderRow = function (lineItem, i) {
      var cap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__RepairOrders_helpers__["a" /* getCap */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_immutable__["fromJS"])(lineItem));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components__["A" /* LinkedTableRow */],
        {
          to: "/repair-orders/" + lineItem.repair_order_uuid,
          key: i
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          i + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: cap },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__["c" /* shortDateYY */])(lineItem.created_at)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["w" /* CompanyName */], { flattenedCompany: lineItem, truncateAt: 18 })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          lineItem.original_serial_number || lineItem.serial_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RepairOrders_constants__["p" /* getConditionAbbrev */])(lineItem.condition_received || lineItem.condition_sent)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__RepairOrders_components_Detail_LineItems_StatusBadges__["a" /* default */], { lineItem: lineItem, shouldAbbrev: true }),
          lineItem.inventory && lineItem.inventory.status === "sales_order_created" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components__["j" /* NoteTooltip */], {
            placement: "right",
            icon: "fa-paper-plane",
            note: "Pending Sale"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_date__["c" /* shortDateYY */])(lineItem.expected_date)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_formatters_currency__["a" /* dollars */])(lineItem.subtotal)
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          results = _props.results;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */].Mini,
        { loading: loading, numbered: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */].Head,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Date"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Repair Station"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Serial #"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "CD"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Status"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            null,
            "Exp Date"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Total"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__shared_components__["s" /* DataTable */].Body,
          null,
          results.map(this.renderRow)
        )
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Table.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    created_at: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string }),
    buyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ full_name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string }),
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })).isRequired,
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
var withResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["n" /* miniTable */])(function (_ref2, params) {
  var match = _ref2.match;
  return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].parts.repairOrderLineItems.search(match.params.id, params);
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_router__["withRouter"])(withResults(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__Subscription_withSubscription__["a" /* default */])("RepairOrderLineItem")(Table))));

/***/ }),
/* 2190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RepairOrders__ = __webpack_require__(2188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RepairOrders__["a"]; });



/***/ }),
/* 2191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(755);
/* harmony export (immutable) */ __webpack_exports__["a"] = Create;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }









function Create(_ref) {
  var close = _ref.close,
      part = _ref.part;

  var _useOnSubmit = useOnSubmit(close),
      onSubmit = _useOnSubmit.onSubmit;

  var initialValues = {
    repair_quote_line_item: {
      part_id: part.id,
      quote_type: __WEBPACK_IMPORTED_MODULE_1__IncomingQuotes_constants__["k" /* STANDARD */]
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "panel panel-default", style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "panel-body" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { className: "close", type: "button", onClick: close },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title", style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].title },
        "Create a New Repair Station Quote"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Form__["a" /* default */], {
        close: close,
        initialValues: initialValues,
        onSubmit: onSubmit,
        modal: false
      })
    )
  );
}

Create.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  part: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({ id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number })
};

function useOnSubmit(close) {
  var _this = this;

  var onSubmit = function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data) {
      var _ref3, quote;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].repairQuotes.create(data);

            case 2:
              _ref3 = _context.sent;
              quote = _ref3.data;


              __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].success("Success", quote.code + " successfully created.");

              close(_extends({ sendRfq: data.sendRfq }, quote));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return { onSubmit: onSubmit };
}

/***/ }),
/* 2192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inventories_constants__ = __webpack_require__(12);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;







function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    if (values.company) {
      v.validateChild(__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* COMPANY */], function (company) {
        company.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["S" /* NAME */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
      });
    } else {
      v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["N" /* COMPANY_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
    }

    v.validateChild(__WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["m" /* REPAIR_QUOTE_LINE_ITEM */], function (quote) {
      quote.validate(__WEBPACK_IMPORTED_MODULE_5__inventories_constants__["q" /* PART_ID */], __WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["n" /* QUOTE_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(values, "repair_quote_line_item.quote_type") === __WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["p" /* STANDARD */]) {
        quote.validate("Repair Quote").satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["n" /* requiresAtLeast */](1, __WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["j" /* AVG_TEST */], __WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["h" /* AVG_OVERHAUL */], __WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["i" /* AVG_REPAIR */], __WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["k" /* EVALUATION_FEE */]));
      }

      quote.validate(__WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["l" /* BER_RATE */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["k" /* isLessThanOrEqualTo */](100), __WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0));

      quote.validate(__WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["a" /* OVERHAUL_TAT */], __WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["b" /* REPAIR_TAT */], __WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["c" /* TEST_TAT */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](1), __WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["k" /* isLessThanOrEqualTo */](999));
    });
  });
}

/***/ }),
/* 2193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Subscription_withSubscription__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RepairQuotes_styles__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RepairQuotes_constants__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RepairQuoteLineItems_Table__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_StatsTooltip_format__ = __webpack_require__(144);
/* unused harmony export LineItemsTable */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var LineItemsTable = function (_Component) {
  _inherits(LineItemsTable, _Component);

  function LineItemsTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LineItemsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LineItemsTable.__proto__ || Object.getPrototypeOf(LineItemsTable)).call.apply(_ref, [this].concat(args))), _this), _this.renderRow = function (lineItem, i) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        "tr",
        {
          key: lineItem.id,
          className: "clickable",
          onClick: function onClick() {
            return _this.props.setActiveRepairQuote(lineItem);
          }
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "div",
            { style: { whiteSpace: "nowrap" } },
            i + 1
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__RepairQuotes_styles__["a" /* default */],
          { lineItem: lineItem },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "span",
            {
              className: lineItem.updated_at !== lineItem.created_at && "text-yellow"
            },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["c" /* shortDateYY */])(lineItem.updated_at || lineItem.created_at)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["w" /* CompanyName */], { flattenedCompany: lineItem, truncateAt: 14 })
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          { className: "text-nowrap" },
          lineItem.created_by && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.created_by.full_name)
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_11__RepairQuotes_constants__["g" /* QUOTE_TYPES_ABBREV */][lineItem.quote_type]
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RepairQuoteLineItems_Table__["b" /* RenderQuoteField */], { lineItem: lineItem, field: __WEBPACK_IMPORTED_MODULE_11__RepairQuotes_constants__["h" /* AVG_OVERHAUL */] }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RepairQuoteLineItems_Table__["b" /* RenderQuoteField */], { lineItem: lineItem, field: __WEBPACK_IMPORTED_MODULE_11__RepairQuotes_constants__["i" /* AVG_REPAIR */] }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RepairQuoteLineItems_Table__["b" /* RenderQuoteField */], { lineItem: lineItem, field: __WEBPACK_IMPORTED_MODULE_11__RepairQuotes_constants__["j" /* AVG_TEST */] }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RepairQuoteLineItems_Table__["b" /* RenderQuoteField */], { lineItem: lineItem, field: __WEBPACK_IMPORTED_MODULE_11__RepairQuotes_constants__["f" /* TURNAROUND_TIME */] }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RepairQuoteLineItems_Table__["b" /* RenderQuoteField */], { lineItem: lineItem, field: __WEBPACK_IMPORTED_MODULE_11__RepairQuotes_constants__["k" /* EVALUATION_FEE */] }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RepairQuoteLineItems_Table__["b" /* RenderQuoteField */], {
          lineItem: lineItem,
          field: __WEBPACK_IMPORTED_MODULE_11__RepairQuotes_constants__["l" /* BER_RATE */],
          formatter: function formatter(f) {
            return f && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__shared_components_StatsTooltip_format__["f" /* percentFormatter */])(f);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["G" /* NoteTooltipTableCell */], { note: lineItem.notes })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LineItemsTable, [{
    key: "render",
    value: function render() {
      var results = this.props.results;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__shared_components__["s" /* DataTable */].Mini,
        { loading: this.props.loading, numbered: true },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__shared_components__["s" /* DataTable */].Head,
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("th", null),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "th",
            null,
            "Date"
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "th",
            null,
            "Repair Station"
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "th",
            null,
            "Created By"
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "th",
            null,
            "Type"
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Avg OH"
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Avg SV"
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Avg BT"
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "TAT"
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Eval Fee"
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "BER %"
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("th", null)
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__shared_components__["s" /* DataTable */].Body,
          null,
          results.map(this.renderRow)
        )
      );
    }
  }]);

  return LineItemsTable;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

LineItemsTable.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number.isRequired,
    incoming_quote_id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number.isRequired,
    quote_type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
    condition: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    company_name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    legacy_company_name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    cost: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
  })).isRequired,
  setActiveRepairQuote: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  loading: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired
};
var withResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_decorators__["n" /* miniTable */])(function (_ref2, params) {
  var match = _ref2.match;
  return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].parts.repairQuoteLineItems.search(match.params.id, Object.assign(params, { sort: __WEBPACK_IMPORTED_MODULE_2__constants__["_7" /* CREATED_AT */] }));
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router__["withRouter"])(withResults(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__Subscription_withSubscription__["a" /* default */])("RepairQuoteLineItem")(LineItemsTable))));

/***/ }),
/* 2194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_ErrorBoundary__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Authorized_Forbidden__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LineItemsTable__ = __webpack_require__(2193);









function RepairQuotes(_ref) {
  var location = _ref.location,
      openForm = _ref.openForm,
      setActiveRepairQuote = _ref.setActiveRepairQuote,
      showNewButton = _ref.showNewButton;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
        { to: location.pathname + "/repair-quote-line-items" },
        "Repair Quotes ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-fw fa-list-ol" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Authorized_Forbidden__["a" /* default */],
        { roles: [__WEBPACK_IMPORTED_MODULE_5__users_constants__["j" /* WAREHOUSE */]] },
        showNewButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            onClick: openForm,
            className: "btn btn-primary btn-hollow pull-right",
            type: "button"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
          "Create Quote"
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_ErrorBoundary__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LineItemsTable__["a" /* default */], { setActiveRepairQuote: setActiveRepairQuote })
    )
  );
}

RepairQuotes.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pathname: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  openForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setActiveRepairQuote: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  showNewButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router__["withRouter"])(RepairQuotes));

/***/ }),
/* 2195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(756);
/* harmony export (immutable) */ __webpack_exports__["a"] = SendRfqModal;





function SendRfqModal(_ref) {
  var lineItem = _ref.lineItem,
      open = _ref.open,
      close = _ref.close,
      _ref$modal = _ref.modal,
      modal = _ref$modal === undefined ? true : _ref$modal;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, modal: modal, dialogClass: "modal-md" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Request For Repair Quote"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close, lineItem: lineItem })
  );
}

SendRfqModal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  modal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 2196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(756);
/* harmony export (immutable) */ __webpack_exports__["a"] = SendRfqNestedForm;





SendRfqNestedForm.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

function SendRfqNestedForm(_ref) {
  var close = _ref.close,
      lineItem = _ref.lineItem;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "panel panel-default", style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].container },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "panel-body" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { className: "close", type: "button", onClick: close },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title", style: __WEBPACK_IMPORTED_MODULE_2__styles__["a" /* default */].title },
        "Request for Repair Quote"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close, lineItem: lineItem, modal: false })
    )
  );
}

/***/ }),
/* 2197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form__ = __webpack_require__(757);
/* harmony export (immutable) */ __webpack_exports__["a"] = Update;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function Update(_ref) {
  var close = _ref.close,
      lineItem = _ref.lineItem;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      repairQuote = _useState2[0],
      setRepairQuote = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairQuotes.show(lineItem.repair_quote_id).then(function (_ref2) {
      var data = _ref2.data;

      setRepairQuote(data);
    });
  }, [lineItem.repair_quote_id]);

  if (!repairQuote) return null;

  var _useOnSubmit = useOnSubmit(close, repairQuote),
      onSubmit = _useOnSubmit.onSubmit;

  var _company = repairQuote.company,
      _contact = repairQuote.contact,
      initialValues = _objectWithoutProperties(repairQuote, ["company", "contact"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "panel panel-default", style: __WEBPACK_IMPORTED_MODULE_1__styles__["a" /* default */].container },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "panel-body" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { className: "close", type: "button", onClick: close },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title", style: __WEBPACK_IMPORTED_MODULE_1__styles__["a" /* default */].title },
        "Update Repair Station Quote"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Form__["a" /* default */], {
        close: close,
        initialValues: initialValues,
        repairQuote: repairQuote,
        onSubmit: onSubmit,
        modal: false
      })
    )
  );
}

Update.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  lineItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  repairQuote: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    company: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
    contact: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
  })
};

function useOnSubmit(close, repairQuote) {
  var _this = this;

  var onSubmit = function () {
    var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data) {
      var _ref4, quote;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].repairQuotes.update(repairQuote.id, data);

            case 2:
              _ref4 = _context.sent;
              quote = _ref4.data;


              __WEBPACK_IMPORTED_MODULE_4_react_redux_toastr__["toastr"].success("Success", quote.code + " successfully updated.");

              close(_extends({ sendRfq: data.sendRfq }, quote));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function onSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return { onSubmit: onSubmit };
}

/***/ }),
/* 2198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__ = __webpack_require__(101);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;






function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    if (values.company) {
      v.validateChild(__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* COMPANY */], function (company) {
        company.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["S" /* NAME */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
      });
    } else {
      v.validate(__WEBPACK_IMPORTED_MODULE_2__constants__["N" /* COMPANY_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);
    }

    v.validateChild(__WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["m" /* REPAIR_QUOTE_LINE_ITEM */], function (quote) {
      quote.validate(__WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["n" /* QUOTE_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["a" /* required */]);

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(values, "repair_quote_line_item.quote_type") === __WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["p" /* STANDARD */]) {
        quote.validate("Repair Quote").satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["n" /* requiresAtLeast */](1, __WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["j" /* AVG_TEST */], __WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["h" /* AVG_OVERHAUL */], __WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["i" /* AVG_REPAIR */], __WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["k" /* EVALUATION_FEE */], __WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["f" /* TURNAROUND_TIME */]));

        quote.validate(__WEBPACK_IMPORTED_MODULE_4__RepairQuotes_constants__["l" /* BER_RATE */]).satisfies(__WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["k" /* isLessThanOrEqualTo */](100), __WEBPACK_IMPORTED_MODULE_3__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0));
      }
    });
  });
}

/***/ }),
/* 2199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_ErrorBoundary__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Table__ = __webpack_require__(337);
/* harmony export (immutable) */ __webpack_exports__["a"] = SalesOrders;





function SalesOrders() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
        { to: location.pathname + "/sales-order-line-items" },
        "Sales Orders ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-fw fa-list-ol" })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_ErrorBoundary__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Table__["a" /* default */], null)
    )
  );
}

/***/ }),
/* 2200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SalesOrders__ = __webpack_require__(2199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SalesOrders__["a"]; });



/***/ }),
/* 2201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_countries__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_NoteTooltip_AuditedNoteTooltip__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Icon_Icon__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Search_Warnings__ = __webpack_require__(760);
/* harmony export (immutable) */ __webpack_exports__["a"] = Table;












function Table(_ref) {
  var part = _ref.part;

  var UNCode = part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_6" /* UNITED_NATIONS_CODE */]);
  var record = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return part.toJS();
  }, [part]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed parts-details-table" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Description"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["u" /* DESCRIPTION */]),
            " ",
            record.description_audit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], { obj: record, field: "description" })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "MFG"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_9" /* MANUFACTURER */])
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "List Price"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_2" /* MLP */]), 2, true)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "DOP"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_3" /* PURCHASED_AT */])
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Cage"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_10" /* CAGE */])
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Ctry of Mfg"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["g" /* COUNTRY_OF_MFG */]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_countries__["d" /* countryName */])(part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["g" /* COUNTRY_OF_MFG */]))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: "ECCN",
          value: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["K" /* EUROPEAN_COMMERCE_CONTROL_NUMBER */]),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: "UN Code",
          value: UNCode && "UN-" + UNCode,
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: "NSN",
          value: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_11" /* NATIONAL_STOCK_NUMBER */]),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: "Warnings",
          value: [__WEBPACK_IMPORTED_MODULE_8__constants__["i" /* BIO_HAZMAT */], __WEBPACK_IMPORTED_MODULE_8__constants__["h" /* HAZMAT */], __WEBPACK_IMPORTED_MODULE_8__constants__["D" /* LLP */], __WEBPACK_IMPORTED_MODULE_8__constants__["_12" /* SHELF_LIFE */], __WEBPACK_IMPORTED_MODULE_8__constants__["_13" /* EXPORT_COMPLIANCE */]].some(function (f) {
            return part.get(f);
          }) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Search_Warnings__["a" /* default */], { part: part.toJS() }),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["E" /* TOTAL_HOURS */]),
          value: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["E" /* TOTAL_HOURS */]),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["F" /* TOTAL_CYCLES */]),
          value: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["F" /* TOTAL_CYCLES */]),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: "Container",
          value: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_5" /* SPECIAL_CONTAINER_REQ */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "label label-danger" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cube" }),
            "\xA0\xA0SC Req: ",
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_currency__["a" /* dollars */])(part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_4" /* SPECIAL_CONTAINER_FEE */]))
          ),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: "Pass / Fail",
          value: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["U" /* PASS_FAIL */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "label label-primary" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-graduation-cap" }),
            "\xA0\xA0Pass / Fail"
          ),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: __WEBPACK_IMPORTED_MODULE_8__constants__["_14" /* ESD */].toUpperCase(),
          value: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_14" /* ESD */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "label label-default" },
            "ESD"
          ),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: "DOM Sensitive",
          value: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_7" /* DOM_SENSITIVE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "label label-primary" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-calendar" }),
            "\xA0\xA0DOM Sensitive"
          ),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_15" /* WARRANTY_OVERRIDE */]),
          value: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_15" /* WARRANTY_OVERRIDE */]),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: "Imp Memo",
          value: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_16" /* IMPORTANT_MEMO */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: { color: "#F44336" } },
              part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_16" /* IMPORTANT_MEMO */])
            ),
            " ",
            record[__WEBPACK_IMPORTED_MODULE_8__constants__["_16" /* IMPORTANT_MEMO */] + "_audit"] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], { obj: record, field: __WEBPACK_IMPORTED_MODULE_8__constants__["_16" /* IMPORTANT_MEMO */] })
          ),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: "Permanent OQ note",
          value: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["V" /* PERMANENT_EXTERNAL_NOTE_FOR_OQ */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["V" /* PERMANENT_EXTERNAL_NOTE_FOR_OQ */]),
            " ",
            record[__WEBPACK_IMPORTED_MODULE_8__constants__["V" /* PERMANENT_EXTERNAL_NOTE_FOR_OQ */] + "_audit"] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], {
              obj: record,
              field: __WEBPACK_IMPORTED_MODULE_8__constants__["V" /* PERMANENT_EXTERNAL_NOTE_FOR_OQ */]
            })
          ),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: "Clsfd Memo",
          value: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_17" /* CLASSIFIED_MEMO */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
            null,
            part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_17" /* CLASSIFIED_MEMO */]),
            " ",
            record[__WEBPACK_IMPORTED_MODULE_8__constants__["_17" /* CLASSIFIED_MEMO */] + "_audit"] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], { obj: record, field: __WEBPACK_IMPORTED_MODULE_8__constants__["_17" /* CLASSIFIED_MEMO */] })
          ),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: "Sched B or HT Code",
          value: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["x" /* SCHEDULE_B_OR_HT_CODE */]),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["v" /* HTSUS_CODE */]).toUpperCase(),
          value: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["v" /* HTSUS_CODE */]),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: "Auto SRP Exclusion",
          value: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["_18" /* AUTO_ADJUST_SRP_EXCLUSION */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "text-red" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_Icon_Icon__["a" /* default */], { name: "check" })
          ),
          renderIfPresent: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_DetailTable__["b" /* Detail */], {
          label: "Part Type",
          value: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["H" /* TOOLING_PART_TYPE */]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["H" /* TOOLING_PART_TYPE */])),
          renderIfPresent: true
        })
      )
    )
  );
}

Table.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])
};

/***/ }),
/* 2202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_weight__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Search_Dimensions__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NetWeightAndDimsPopUp__ = __webpack_require__(2176);
/* harmony export (immutable) */ __webpack_exports__["a"] = WeightAndDims;









function WeightAndDims(_ref) {
  var immutablePart = _ref.part;

  var part = immutablePart.toJS();

  var weightUnit = part[__WEBPACK_IMPORTED_MODULE_6__constants__["n" /* WEIGHT_UNIT */]];
  var weight = part[__WEBPACK_IMPORTED_MODULE_6__constants__["j" /* WEIGHT */]];
  var weightClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
    "text-highlight": part.overweight
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "table",
    { className: "table table-condensed parts-details-table" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "tbody",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "DM"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Search_Dimensions__["a" /* default */], { part: part, showWarning: part.large_dimensions }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__NetWeightAndDimsPopUp__["a" /* NetWeightAndDimsPopUp */], { part: part })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "WT"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: weightClass },
            part.overweight && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["k" /* Icon */], { name: "warning" }),
              "\xA0\xA0"
            ),
            weight,
            " ",
            weightUnit,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_weight__["c" /* calculateValue */])(weightUnit, weight),
            " ",
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_weight__["d" /* conversionUnitAbbrev */])(weightUnit)
          )
        )
      ),
      part.calculated_dim_weight && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tr",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          { className: "text-right" },
          "DM WT"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          Math.ceil(part.calculated_dim_weight),
          " ",
          __WEBPACK_IMPORTED_MODULE_6__constants__["z" /* POUNDS */],
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
          Math.ceil(part.calculated_dim_weight * __WEBPACK_IMPORTED_MODULE_6__constants__["_1" /* KG_PER_LB */]),
          " ",
          __WEBPACK_IMPORTED_MODULE_6__constants__["A" /* KILOS */]
        )
      )
    )
  );
}

WeightAndDims.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Map)
};

/***/ }),
/* 2203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Detail__ = __webpack_require__(2157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Detail__["a"]; });



/***/ }),
/* 2204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_weight__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_NetWeightAndDimsFormRow_NetWeightAndDimsFormRow__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_CentimeterDimensions__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_Dimensions__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__validate__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_Weight__ = __webpack_require__(473);
/* unused harmony export DimensionsForm */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var EDIT_DIMENSIONS_FORM = "editDimensions";

var DimensionsForm = function (_Component) {
  _inherits(DimensionsForm, _Component);

  function DimensionsForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DimensionsForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DimensionsForm.__proto__ || Object.getPrototypeOf(DimensionsForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      checkingForDuplicates: false,
      hasDuplicates: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DimensionsForm, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          getField = _props.getField,
          width = _props.width,
          height = _props.height,
          length = _props.length,
          weight = _props.weight,
          unit = _props.unit;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */],
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["e" /* Form */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            null,
            "Gross (Package) Weight & Dims"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_Weight__["a" /* default */], null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: "control-label", htmlFor: "read_only_conversion" },
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_weight__["b" /* conversionUnit */])(unit)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "input-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
                  name: "read_only_conversion",
                  className: "form-control",
                  type: "text",
                  value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_weight__["c" /* calculateValue */])(unit, weight),
                  disabled: true,
                  readOnly: true
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { className: "input-group-addon" },
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_weight__["d" /* conversionUnitAbbrev */])(unit)
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_Dimensions__["b" /* default */], null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_CentimeterDimensions__["a" /* default */], {
                width: width,
                height: height,
                length: length
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_Forms_NetWeightAndDimsFormRow_NetWeightAndDimsFormRow__["a" /* default */], { getField: getField })
        )
      );
    }
  }]);

  return DimensionsForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DimensionsForm.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  length: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  weight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  net_width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  net_height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  net_length: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  net_weight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  net_weight_unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(EDIT_DIMENSIONS_FORM);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return _extends({
    getField: function getField(field) {
      return selector(state, field);
    },
    unit: selector(state, __WEBPACK_IMPORTED_MODULE_8__constants__["n" /* WEIGHT_UNIT */])
  }, [__WEBPACK_IMPORTED_MODULE_8__constants__["k" /* WIDTH */], __WEBPACK_IMPORTED_MODULE_8__constants__["m" /* HEIGHT */], __WEBPACK_IMPORTED_MODULE_8__constants__["l" /* LENGTH */], __WEBPACK_IMPORTED_MODULE_8__constants__["j" /* WEIGHT */]].reduce(function (prev, current) {
    return _extends({}, prev, _defineProperty({}, current, selector(state, current)));
  }, {}));
}, { onSubmit: __WEBPACK_IMPORTED_MODULE_5__actions__["j" /* update */], search: __WEBPACK_IMPORTED_MODULE_5__actions__["k" /* searchMatchingPartNumbers */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_components_Forms__["j" /* form */])({
  form: EDIT_DIMENSIONS_FORM,
  validate: __WEBPACK_IMPORTED_MODULE_13__validate__["a" /* default */]
})(DimensionsForm)));

/***/ }),
/* 2205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DimensionsForm__ = __webpack_require__(2204);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditDimensions;







function EditDimensions(_ref) {
  var open = _ref.open,
      close = _ref.close,
      part = _ref.part;

  var overrides = {
    weight: part.weight,
    length: part.length,
    width: part.width,
    height: part.height,
    net_weight_unit: (part.net_weight_unit || "lb").toString(),
    net_weight_oz: part.net_weight_oz
  };

  var initialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_pojos__["a" /* default */])(part).pick(__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* WEIGHT */], __WEBPACK_IMPORTED_MODULE_4__constants__["n" /* WEIGHT_UNIT */], __WEBPACK_IMPORTED_MODULE_4__constants__["o" /* NET_WEIGHT */], __WEBPACK_IMPORTED_MODULE_4__constants__["s" /* NET_WEIGHT_OZ */], __WEBPACK_IMPORTED_MODULE_4__constants__["t" /* NET_WEIGHT_UNIT */], __WEBPACK_IMPORTED_MODULE_4__constants__["k" /* WIDTH */], __WEBPACK_IMPORTED_MODULE_4__constants__["l" /* LENGTH */], __WEBPACK_IMPORTED_MODULE_4__constants__["m" /* HEIGHT */], __WEBPACK_IMPORTED_MODULE_4__constants__["q" /* NET_WIDTH */], __WEBPACK_IMPORTED_MODULE_4__constants__["p" /* NET_LENGTH */], __WEBPACK_IMPORTED_MODULE_4__constants__["r" /* NET_HEIGHT */]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-lg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Dimension & Weight Details"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DimensionsForm__["a" /* default */], {
      close: close,
      initialValues: Object.assign(initialValues, overrides),
      enableReinitialize: true
    })
  );
}

EditDimensions.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Stars_Stars__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_pojos__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Form__ = __webpack_require__(2207);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditPart;









function EditPart(_ref) {
  var open = _ref.open,
      close = _ref.close,
      part = _ref.part,
      toggleMergePartModal = _ref.toggleMergePartModal;

  var initialValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_pojos__["a" /* default */])(part).pick(__WEBPACK_IMPORTED_MODULE_4__constants__["_18" /* AUTO_ADJUST_SRP_EXCLUSION */], __WEBPACK_IMPORTED_MODULE_4__constants__["i" /* BIO_HAZMAT */], __WEBPACK_IMPORTED_MODULE_4__constants__["_10" /* CAGE */], __WEBPACK_IMPORTED_MODULE_4__constants__["_8" /* CATALOG_URL */], __WEBPACK_IMPORTED_MODULE_4__constants__["_17" /* CLASSIFIED_MEMO */], __WEBPACK_IMPORTED_MODULE_4__constants__["g" /* COUNTRY_OF_MFG */], __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* DESCRIPTION */], __WEBPACK_IMPORTED_MODULE_4__constants__["_7" /* DOM_SENSITIVE */], __WEBPACK_IMPORTED_MODULE_4__constants__["T" /* DOM_LIFE_YEARS */], __WEBPACK_IMPORTED_MODULE_4__constants__["y" /* ECCN */], __WEBPACK_IMPORTED_MODULE_4__constants__["_14" /* ESD */], __WEBPACK_IMPORTED_MODULE_4__constants__["_13" /* EXPORT_COMPLIANCE */], __WEBPACK_IMPORTED_MODULE_4__constants__["h" /* HAZMAT */], __WEBPACK_IMPORTED_MODULE_4__constants__["v" /* HTSUS_CODE */], __WEBPACK_IMPORTED_MODULE_4__constants__["_16" /* IMPORTANT_MEMO */], __WEBPACK_IMPORTED_MODULE_4__constants__["D" /* LLP */], __WEBPACK_IMPORTED_MODULE_4__constants__["_9" /* MANUFACTURER */], __WEBPACK_IMPORTED_MODULE_4__constants__["_19" /* MASTER_PART_LOCK */], __WEBPACK_IMPORTED_MODULE_4__constants__["_2" /* MLP */], __WEBPACK_IMPORTED_MODULE_4__constants__["R" /* MILITARY */], __WEBPACK_IMPORTED_MODULE_4__constants__["w" /* PART_NUMBER */], __WEBPACK_IMPORTED_MODULE_4__constants__["U" /* PASS_FAIL */], __WEBPACK_IMPORTED_MODULE_4__constants__["V" /* PERMANENT_EXTERNAL_NOTE_FOR_OQ */], __WEBPACK_IMPORTED_MODULE_4__constants__["_3" /* PURCHASED_AT */], __WEBPACK_IMPORTED_MODULE_4__constants__["x" /* SCHEDULE_B_OR_HT_CODE */], __WEBPACK_IMPORTED_MODULE_4__constants__["_12" /* SHELF_LIFE */], __WEBPACK_IMPORTED_MODULE_4__constants__["_4" /* SPECIAL_CONTAINER_FEE */], __WEBPACK_IMPORTED_MODULE_4__constants__["_5" /* SPECIAL_CONTAINER_REQ */], __WEBPACK_IMPORTED_MODULE_4__constants__["H" /* TOOLING_PART_TYPE */], __WEBPACK_IMPORTED_MODULE_4__constants__["F" /* TOTAL_CYCLES */], __WEBPACK_IMPORTED_MODULE_4__constants__["E" /* TOTAL_HOURS */], __WEBPACK_IMPORTED_MODULE_4__constants__["_6" /* UNITED_NATIONS_CODE */], __WEBPACK_IMPORTED_MODULE_4__constants__["_20" /* UPDATED_AT */], __WEBPACK_IMPORTED_MODULE_4__constants__["_15" /* WARRANTY_OVERRIDE */]);

  initialValues.locations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["a" /* useCurrentUser */])().locations.map(function (l) {
    var account = part.quickbooks_account[l.id] || {};

    return { id: l.id, quickbooks_account: account };
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { display: "flex", justifyContent: "space-between" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Edit Part Details"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Stars_Stars__["a" /* default */], {
          size: "fa-lg",
          tierType: part.tier_type,
          style: { marginRight: 15 },
          disabled: false
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Form__["a" /* default */], {
      close: close,
      enableReinitialize: true,
      initialValues: initialValues,
      part: part,
      toggleMergePartModal: toggleMergePartModal
    })
  );
}

EditPart.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  toggleMergePartModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/***/ }),
/* 2207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_NoteTooltip_AuditedNoteTooltip__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_countries__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_Authorized__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_components_IconText_IconText__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__shared_PartNumber__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__shared_Description__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__CreatePart_Warnings__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__validate__ = __webpack_require__(758);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





























var debounceTimeout = 350;
var formName = "editPart";

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      checkingForDuplicates: false,
      hasDuplicates: false
    }, _this.onCancel = function () {
      _this.props.close();
      _this.props.reset();
    }, _this.onDrop = function (e) {
      _this.preventDefault(e);
      var dt = e.dataTransfer;
      var files = dt.files;

      _this.setPreviewFile(files[0]);

      _this.props.setFieldValue("file")(files[0]);
    }, _this.setPreviewFile = function (file) {
      if (!file) return null;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        _this.setState({
          previewFile: reader.result
        });
      };

      return reader;
    }, _this.search = function (locationId) {
      return function (params) {
        return __WEBPACK_IMPORTED_MODULE_22__api__["a" /* default */].locations.quickbooks.items.search(locationId, params).then(function (_ref2) {
          var data = _ref2.data;
          return data.results;
        });
      };
    }, _this.preventDefault = function (e) {
      e.preventDefault();
      e.stopPropagation();
    }, _this.removeCatalog = function () {
      _this.setPreviewFile(null);
      _this.props.setFieldValue("file")(null);
      _this.props.setFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["_8" /* CATALOG_URL */])(null);
      _this.props.setFieldValue(__WEBPACK_IMPORTED_MODULE_12__constants__["C" /* CATALOG */])(null);
    }, _this.check = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["debounce"])(function (partNumber) {
      var _this$props = _this.props,
          search = _this$props.search,
          id = _this$props.id;

      _this.setState({ checkingForDuplicates: true });

      search(partNumber).then(function (results) {
        var hasDuplicates = results.length > 1 || results.length === 1 && results[0].id !== id;

        _this.setState({ checkingForDuplicates: false, hasDuplicates: hasDuplicates });
      });
    }, debounceTimeout), _this.notify = function () {
      return _this.setState({ hasDuplicates: false });
    }, _this.resetScFee = function (scReq) {
      if (scReq === false) {
        _this.props.change(__WEBPACK_IMPORTED_MODULE_12__constants__["_4" /* SPECIAL_CONTAINER_FEE */], null);
      }
    }, _this.submit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_submission__["b" /* onSuccess */])(_this.props.handleSubmit, _this.onCancel, _this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          mlpOnBlur = _props.mlpOnBlur,
          currentUser = _props.currentUser,
          domSensitive = _props.domSensitive,
          getField = _props.getField,
          part = _props.part,
          scReq = _props.scReq,
          setFieldValue = _props.setFieldValue,
          submitting = _props.submitting,
          toggleMergePartModal = _props.toggleMergePartModal;

      var catalogUrl = getField(__WEBPACK_IMPORTED_MODULE_12__constants__["_8" /* CATALOG_URL */]);
      var _state = this.state,
          hasDuplicates = _state.hasDuplicates,
          previewFile = _state.previewFile;
      var role = currentUser.role,
          subrole = currentUser.subrole;

      var disabledIfWhDirector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__users_helpers__["f" /* disableIfHasAnyOfSubroles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_10__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]);
      var disabledIfWhManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__users_helpers__["f" /* disableIfHasAnyOfSubroles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_10__users_constants__["t" /* WAREHOUSE_EXPERT */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["s" /* WAREHOUSE_MANAGER */]]);
      var allowedToEdit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_10__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_10__users_constants__["i" /* ADMIN */]]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__users_helpers__["g" /* hasSubRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_10__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__users_helpers__["e" /* hasPermission */])(currentUser, __WEBPACK_IMPORTED_MODULE_10__users_constants__["_7" /* CAN_ADD_UPDATE_PARTS */]);

      var allowedToEditWarrantyOptions = role === __WEBPACK_IMPORTED_MODULE_10__users_constants__["i" /* ADMIN */] || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_10__users_constants__["k" /* SALES */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__users_helpers__["e" /* hasPermission */])(currentUser, __WEBPACK_IMPORTED_MODULE_10__users_constants__["_7" /* CAN_ADD_UPDATE_PARTS */]);

      var allowedToEditDescription = allowedToEdit || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_10__users_constants__["k" /* SALES */]);

      var countryOptions = __WEBPACK_IMPORTED_MODULE_11__lib_countries__["a" /* default */].map(function (c) {
        return {
          value: c.code,
          text: c.name
        };
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */],
        _extends({}, this.props, {
          submit: this.submit,
          submitting: submitting || this.state.checkingForDuplicates
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].Body,
          null,
          hasDuplicates && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "alert alert-warning" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              null,
              "Heads up!"
            ),
            " A base part number matching this part number already exists!"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], {
                component: __WEBPACK_IMPORTED_MODULE_23__shared_PartNumber__["a" /* default */],
                names: [__WEBPACK_IMPORTED_MODULE_12__constants__["w" /* PART_NUMBER */], __WEBPACK_IMPORTED_MODULE_12__constants__["u" /* DESCRIPTION */]],
                notify: this.notify,
                check: this.check,
                disabled: !allowedToEdit || disabledIfWhManager || disabledIfWhDirector
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Fields"], {
                component: __WEBPACK_IMPORTED_MODULE_24__shared_Description__["a" /* default */],
                names: [__WEBPACK_IMPORTED_MODULE_12__constants__["w" /* PART_NUMBER */], __WEBPACK_IMPORTED_MODULE_12__constants__["u" /* DESCRIPTION */]],
                disabled: !allowedToEditDescription
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: __WEBPACK_IMPORTED_MODULE_12__constants__["_9" /* MANUFACTURER */], component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], label: "MFG" })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm margin-top-none" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["u" /* CageField */], { name: __WEBPACK_IMPORTED_MODULE_12__constants__["_10" /* CAGE */], component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], label: __WEBPACK_IMPORTED_MODULE_12__constants__["_10" /* CAGE */] })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["v" /* ECCNField */], { name: __WEBPACK_IMPORTED_MODULE_12__constants__["y" /* ECCN */], component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */], label: "ECCN" })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["w" /* UNCodeField */], {
                name: __WEBPACK_IMPORTED_MODULE_12__constants__["_6" /* UNITED_NATIONS_CODE */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: "UN Code"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 5 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["x" /* NSNField */], {
                name: __WEBPACK_IMPORTED_MODULE_12__constants__["_21" /* NSN */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: "NSN",
                disabled: disabledIfWhManager
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 6, xs: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["y" /* ScheduleBOrHTCodeField */], {
                name: __WEBPACK_IMPORTED_MODULE_12__constants__["x" /* SCHEDULE_B_OR_HT_CODE */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: "Schedule B or HT Code"
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 6, xs: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_12__constants__["v" /* HTSUS_CODE */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: __WEBPACK_IMPORTED_MODULE_12__constants__["_22" /* HTSUS_CODE_LABEL */],
                format: function format(value) {
                  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["trim"])(value);
                }
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], {
                name: __WEBPACK_IMPORTED_MODULE_12__constants__["_2" /* MLP */],
                label: "Manufacturer List Price",
                onBlur: function onBlur(evt, val) {
                  return mlpOnBlur(evt, val);
                },
                required: getField(__WEBPACK_IMPORTED_MODULE_12__constants__["_3" /* PURCHASED_AT */]),
                disabled: disabledIfWhManager
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_12__constants__["_3" /* PURCHASED_AT */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: "Date of Price",
                type: "date",
                required: getField(__WEBPACK_IMPORTED_MODULE_12__constants__["_2" /* MLP */]),
                disabled: disabledIfWhManager
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 5 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
                options: countryOptions,
                name: __WEBPACK_IMPORTED_MODULE_12__constants__["g" /* COUNTRY_OF_MFG */],
                label: "Ctry of Mfg"
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__CreatePart_Warnings__["a" /* default */], { subrole: subrole, formName: formName }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
                {
                  justified: true,
                  title: __WEBPACK_IMPORTED_MODULE_12__constants__["_23" /* SPECIAL_CONTAINER_REQ_LABEL */],
                  info: "A special container fee note will be added to outgoing quote and sales order confirmation emails."
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  onChange: function onChange(ev, val) {
                    return _this2.resetScFee(val);
                  },
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                  name: __WEBPACK_IMPORTED_MODULE_12__constants__["_5" /* SPECIAL_CONTAINER_REQ */],
                  label: __WEBPACK_IMPORTED_MODULE_12__constants__["_23" /* SPECIAL_CONTAINER_REQ_LABEL */],
                  icon: "fa-cube"
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              scReq && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["f" /* CurrencyField */], {
                name: __WEBPACK_IMPORTED_MODULE_12__constants__["_4" /* SPECIAL_CONTAINER_FEE */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["_4" /* SPECIAL_CONTAINER_FEE */]),
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
                {
                  justified: true,
                  title: __WEBPACK_IMPORTED_MODULE_12__constants__["_14" /* ESD */].toUpperCase(),
                  info: "Notifies receiving dept"
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */], name: __WEBPACK_IMPORTED_MODULE_12__constants__["_14" /* ESD */], label: __WEBPACK_IMPORTED_MODULE_12__constants__["_14" /* ESD */].toUpperCase() })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__lib_forms__["f" /* arrayToOptions */])(__WEBPACK_IMPORTED_MODULE_18__inventories_constants__["_59" /* WARRANTY_OPTIONS */]),
                name: __WEBPACK_IMPORTED_MODULE_12__constants__["_15" /* WARRANTY_OVERRIDE */],
                label: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["_15" /* WARRANTY_OVERRIDE */]), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_IconText_IconText__["a" /* default */], {
                  iconSize: "fa-stack-1x",
                  icon: "fa-info",
                  note: "Choose default warranty period for this part number."
                })],
                disabled: !allowedToEditWarrantyOptions
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "label",
                  {
                    htmlFor: __WEBPACK_IMPORTED_MODULE_12__constants__["_18" /* AUTO_ADJUST_SRP_EXCLUSION */],
                    className: "control-label"
                  },
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["_18" /* AUTO_ADJUST_SRP_EXCLUSION */]),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_IconText_IconText__["a" /* default */], {
                    iconSize: "fa-stack-1x",
                    icon: "fa-info",
                    note: "Excludes part from auto-adjusting SRP on anniversary dates.  Notifications for review will remain in place."
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    className: "btn-group btn-group-justified",
                    "data-toggle": "buttons"
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["_18" /* AUTO_ADJUST_SRP_EXCLUSION */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["_18" /* AUTO_ADJUST_SRP_EXCLUSION */])
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
                {
                  justified: true,
                  title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["_19" /* MASTER_PART_LOCK */]),
                  info: "Disallows EXACT alternates from being added as main part numbers."
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                  name: __WEBPACK_IMPORTED_MODULE_12__constants__["_19" /* MASTER_PART_LOCK */],
                  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["_19" /* MASTER_PART_LOCK */]),
                  disabled: role !== __WEBPACK_IMPORTED_MODULE_10__users_constants__["i" /* ADMIN */]
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
                { justified: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "form-group" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
                    name: __WEBPACK_IMPORTED_MODULE_12__constants__["_7" /* DOM_SENSITIVE */],
                    label: "DOM Sensitive",
                    icon: "fa-calendar"
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 4 },
              domSensitive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_12__constants__["T" /* DOM_LIFE_YEARS */],
                  component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                  label: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["T" /* DOM_LIFE_YEARS */]), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_IconText_IconText__["a" /* default */], {
                    iconSize: "fa-stack-1x",
                    icon: "fa-info",
                    note: "For POs, manager approval required if less than 60% life remaining."
                  })],
                  required: domSensitive
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components__["m" /* DashedSeparator */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_12__constants__["V" /* PERMANENT_EXTERNAL_NOTE_FOR_OQ */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: "Permanent External Note For OQ",
                disabled: disabledIfWhManager
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_12__constants__["_16" /* IMPORTANT_MEMO */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["_16" /* IMPORTANT_MEMO */]),
                disabled: disabledIfWhManager
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_12__constants__["_17" /* CLASSIFIED_MEMO */],
                component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_12__constants__["_17" /* CLASSIFIED_MEMO */]),
                disabled: disabledIfWhManager
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
              { md: 12 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_12__constants__["_8" /* CATALOG_URL */] },
                "Catalog Photo",
                catalogUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_IconText_IconText__["a" /* default */], {
                  iconSize: "fa-stack-1x",
                  icon: "fa-info",
                  note: "To Replace, Drag & Drop New Image"
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  style: {
                    border: "1px dashed #FF9800",
                    height: "200px",
                    position: "relative"
                  },
                  onDrop: this.onDrop,
                  onDragOver: this.preventDefault
                },
                (previewFile || catalogUrl) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    style: {
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translateX(-50%) translateY(-50%)"
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { style: { position: "relative" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
                      className: "fa fa-times clickable",
                      onClick: this.removeCatalog,
                      style: {
                        position: "absolute",
                        right: "-13px",
                        top: "-13px"
                      }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
                      alt: __WEBPACK_IMPORTED_MODULE_12__constants__["C" /* CATALOG */],
                      src: previewFile || catalogUrl,
                      style: {
                        maxHeight: "140px"
                      }
                    })
                  )
                ) || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "p",
                  {
                    style: {
                      maxHeight: "140px",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translateX(-50%) translateY(-50%)",
                      color: "#FF9800"
                    }
                  },
                  "Drop an Image"
                )
              ),
              (previewFile || catalogUrl) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  "Catalog:"
                ),
                part.catalog_audit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_NoteTooltip_AuditedNoteTooltip__["a" /* default */], { obj: part, field: "catalog" })
              )
            )
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__users_helpers__["d" /* hasRole */])(currentUser, __WEBPACK_IMPORTED_MODULE_10__users_constants__["m" /* ACCOUNTING */]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__hooks__["a" /* useCurrentUser */])().locations.filter(function (f) {
            return f.quickbook_realm_id;
          }).map(function (l, idx) {
            return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["q" /* FormRow */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                { sm: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_redux_form__["FormSection"],
                  { name: "locations[" + idx + "]" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
                    name: "id",
                    type: "hidden",
                    style: { height: 0 }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    name: "quickbooks_account",
                    label: "Quickbooks Account - " + l.entity_name,
                    placeholder: "Search by typing an account's name",
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["n" /* AutoCompleteField */],
                    onItemSelected: function onItemSelected(item) {
                      return setFieldValue("locations[" + idx + "].quickbooks_account")(item);
                    },
                    selectedItem: part.quickbooks_account[l.id],
                    search: _this2.search(l.id),
                    formatItem: function formatItem(result) {
                      return result && result.name;
                    }
                  })
                )
              )
            )];
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["e" /* Form */].AdditionalButtons,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__shared_components_Authorized__["a" /* default */],
            { permissions: [__WEBPACK_IMPORTED_MODULE_10__users_constants__["_8" /* CAN_MERGE_PART_NUMBERS */]] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["i" /* Button */],
              {
                onClick: function onClick() {
                  toggleMergePartModal(true);
                  _this2.props.close();
                },
                className: "pull-left btn-danger"
              },
              "Merge Part"
            )
          )
        )
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  domSensitive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    subrole: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }),
  mlpOnBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scReq: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    id: state.partDetail.getIn([__WEBPACK_IMPORTED_MODULE_12__constants__["B" /* PART */], __WEBPACK_IMPORTED_MODULE_14__constants__["b" /* ID */]]),
    getField: function getField(name) {
      return selector(state, name);
    },
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_10__users_constants__["a" /* USER */]).toJS(),
    scReq: selector(state, __WEBPACK_IMPORTED_MODULE_12__constants__["_5" /* SPECIAL_CONTAINER_REQ */]),
    domSensitive: selector(state, __WEBPACK_IMPORTED_MODULE_12__constants__["_7" /* DOM_SENSITIVE */])
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["j" /* update */](data));
    },
    search: function search(partNumber) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions__["k" /* searchMatchingPartNumbers */](partNumber));
    },
    mlpOnBlur: function mlpOnBlur(evt, val) {
      if (parseFloat(val) <= 0) {
        evt.preventDefault();
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_12__constants__["_3" /* PURCHASED_AT */], null));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(formName, __WEBPACK_IMPORTED_MODULE_12__constants__["_2" /* MLP */], null));
      }
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])(formName, field, val));
      };
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_26__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 2208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditPart__ = __webpack_require__(2206);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EditPart__["a"]; });



/***/ }),
/* 2209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




var HoverFlag = function HoverFlag(_ref) {
  var text = _ref.text,
      abbr = _ref.abbr,
      inline = _ref.inline,
      className = _ref.className;

  var firstLetter = String(text).substr(0, 1);
  var abbrText = String(abbr || firstLetter).substr(0, 2);
  var composedClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("hover-flag", className, {
    "hover-flag--inline": inline,
    "hover-flag--double-size-drop": abbrText.length > 1
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: composedClassName },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "hover-flag__abbr" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        abbrText
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        text
      )
    )
  );
};

HoverFlag.propTypes = {
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  abbr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.className,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

HoverFlag.defaultProps = {
  abbr: "",
  className: "",
  inline: false
};

/* harmony default export */ __webpack_exports__["a"] = (HoverFlag);

/***/ }),
/* 2210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_incomingQuotes__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Detail_IncomingQuotes_Create_Form__ = __webpack_require__(752);
/* harmony export (immutable) */ __webpack_exports__["a"] = Create;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }











var _INCOMING_LINE_ITEMS$ = __WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].quoteType,
    _ = _INCOMING_LINE_ITEMS$[__WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__["t" /* NOT_AWAITING_REPLY */]],
    quoteTypes = _objectWithoutProperties(_INCOMING_LINE_ITEMS$, [__WEBPACK_IMPORTED_MODULE_5__IncomingQuotes_constants__["t" /* NOT_AWAITING_REPLY */]]);

function Create(_ref) {
  var open = _ref.open,
      close = _ref.close;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCompany = _useState2[0],
      setSelectedCompany = _useState2[1];

  var _useOnSubmit = useOnSubmit(close),
      onSubmit = _useOnSubmit.onSubmit;

  var setSubmittedWith = function setSubmittedWith() {};

  var initialValues = {
    buyer_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__hooks__["a" /* useCurrentUser */])().id,
    incoming_quote_line_item: {
      quote_type: "standard",
      cost: ""
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Create a New Incoming Quote"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Detail_IncomingQuotes_Create_Form__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      onSubmit: onSubmit,
      setSubmittedWith: setSubmittedWith,
      quoteTypes: quoteTypes,
      selectedCompany: selectedCompany,
      setSelectedCompany: setSelectedCompany,
      modal: true
    })
  );
}

Create.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

function useOnSubmit(close) {
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__hooks__["b" /* useDispatch */])();
  var afterCreate = function afterCreate(quote, sendQuote) {
    if (sendQuote) {
      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].incomingQuotes.send(quote.id, quote).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_react_redux_toastr__["toastr"].success("Success", "RFQ successfully sent.");
      });
    }
    close();
  };
  var onSubmit = function onSubmit(data) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__actions_incomingQuotes__["b" /* createIncomingQuote */])(data, afterCreate));
  };
  return { onSubmit: onSubmit };
}

/***/ }),
/* 2211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Detail_IncomingQuotes_Create_DoNotDoBusinessWarning__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_uuid__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_AutoComplete__ = __webpack_require__(769);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();














function CompanyRow(_ref) {
  var getFieldValue = _ref.getFieldValue,
      item = _ref.item,
      idx = _ref.idx,
      remove = _ref.remove,
      setFieldValue = _ref.setFieldValue;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCompany = _useState2[0],
      setSelectedCompany = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useState"])([]),
      _useState4 = _slicedToArray(_useState3, 2),
      contacts = _useState4[0],
      setContacts = _useState4[1];

  var contact = getFieldValue(item + "." + __WEBPACK_IMPORTED_MODULE_4__constants__["O" /* CONTACT_ID */]);

  var fetchContacts = function fetchContacts(value) {
    if (!value) {
      return null;
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions__["g" /* searchContacts */])(value).then(function () {
      var vals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      setContacts(vals);

      var primaryContact = vals.find(function (con) {
        return con.primary;
      });

      if (primaryContact) {
        setFieldValue(item + "." + __WEBPACK_IMPORTED_MODULE_4__constants__["O" /* CONTACT_ID */])(primaryContact.id);
      }
    });
  };

  var handleCompanySelected = function handleCompanySelected(result) {
    setFieldValue(item + "." + __WEBPACK_IMPORTED_MODULE_4__constants__["N" /* COMPANY_ID */])(result ? result.id : null);
    setSelectedCompany(result);
    fetchContacts(result && result.id);
  };

  var addContact = contact === "Add";

  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Detail_IncomingQuotes_Create_DoNotDoBusinessWarning__["a" /* default */], { company: selectedCompany }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 5 },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "label",
          { className: "control-label", htmlFor: "company" },
          "Company"
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_AutoComplete__["a" /* default */], {
          name: item + "." + __WEBPACK_IMPORTED_MODULE_4__constants__["N" /* COMPANY_ID */],
          value: selectedCompany ? selectedCompany.name : "",
          search: function search(filter) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__PurchaseOrders_actions__["a" /* searchCompanies */])(filter)();
          },
          onSelect: handleCompanySelected,
          format: function format(result) {
            return result.name;
          },
          placeholder: "Search by typing a company's name or code"
        })
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 5 },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: item + "." + __WEBPACK_IMPORTED_MODULE_4__constants__["O" /* CONTACT_ID */],
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["c" /* Select */],
            options: contacts.map(function (r) {
              return { value: r.id, text: r.name };
            }),
            label: "Contact",
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 2 },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span", {
          className: "fa fa-times red",
          onClick: function onClick() {
            setTimeout(function () {
              return remove(idx);
            }, 0);
          }
        })
      )
    ),
    addContact && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: item + ".contact.name",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: "Contact Name",
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
            name: item + ".contact.email",
            component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
            label: "Contact Email",
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["p" /* PhoneNumberField */], {
          name: item + ".contact.phone1",
          component: __WEBPACK_IMPORTED_MODULE_5__shared_components_Forms__["d" /* FormInput */],
          label: "Phone Number 1",
          type: "tel"
        })
      )
    )
  );
}

function CompanyRows(_ref2) {
  var fields = _ref2.fields,
      getFieldValue = _ref2.getFieldValue,
      setFieldValue = _ref2.setFieldValue;

  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
    "div",
    null,
    fields.map(function (item, idx) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CompanyRow, {
        key: getFieldValue(item + ".id"),
        idx: idx,
        item: item,
        getFieldValue: getFieldValue,
        setFieldValue: setFieldValue,
        remove: fields.remove
      });
    }),
    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
      null,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "button",
          {
            type: "button",
            className: "btn btn-default  btn-hollow",
            onClick: function onClick() {
              return fields.push({
                id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_uuid__["a" /* generateUUID */])(),
                contact_id: null,
                company_id: null
              });
            }
          },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span", { className: "fa fa-plus" }),
          " Add Company"
        )
      )
    )
  );
}

CompanyRows.propTypes = {
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (CompanyRows);

/***/ }),
/* 2212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_incomingQuotes__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RepairQuotes_constants__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_uuid__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Form__ = __webpack_require__(2213);
/* harmony export (immutable) */ __webpack_exports__["a"] = Create;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











function Create(_ref) {
  var open = _ref.open,
      close = _ref.close;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCompany = _useState2[0],
      setSelectedCompany = _useState2[1];

  var _useOnSubmit = useOnSubmit(close),
      onSubmit = _useOnSubmit.onSubmit;

  var setSubmittedWith = function setSubmittedWith() {};

  var initialValues = {
    incoming_quote_line_item: {
      quote_type: "awaiting_reply",
      cost: ""
    },
    buyer_id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["a" /* useCurrentUser */])().id,
    companies: [{ id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_uuid__["a" /* generateUUID */])() }]
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Create a Multi-Vendor Incoming Quote"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Form__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      onSubmit: onSubmit,
      setSubmittedWith: setSubmittedWith,
      quoteTypes: _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__RepairQuotes_constants__["e" /* AWAITING_REPLY */], __WEBPACK_IMPORTED_MODULE_4__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].quoteType[__WEBPACK_IMPORTED_MODULE_6__RepairQuotes_constants__["e" /* AWAITING_REPLY */]]),
      selectedCompany: selectedCompany,
      setSelectedCompany: setSelectedCompany
    })
  );
}

Create.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

function useOnSubmit() {
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["b" /* useDispatch */])();
  var onSubmit = function onSubmit(data) {
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions_incomingQuotes__["a" /* bulkCreateIncomingQuote */])(data));
  };
  return { onSubmit: onSubmit };
}

/***/ }),
/* 2213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__companies_actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_PartDetails__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__IncomingQuotes_IncomingQuoteTypeSelect__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OutgoingQuotes_shared_SelectInventoryTable__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_SellableQty__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__CompanyRow__ = __webpack_require__(2211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__validate__ = __webpack_require__(2214);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();




























var formName = "partDetailNewIncomingQuote";

function Form(props) {
  var getFieldValue = props.getFieldValue,
      part = props.part,
      quoteType = props.quoteType,
      quoteTypes = props.quoteTypes,
      setFieldValue = props.setFieldValue;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__hooks__["a" /* useCurrentUser */])()),
      _useState2 = _slicedToArray(_useState, 2),
      selectedBuyer = _useState2[0],
      setSelectedBuyer = _useState2[1];

  var filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return {
      limit: "5",
      sellable_status: [__WEBPACK_IMPORTED_MODULE_19__inventories_constants__["U" /* LIST */], __WEBPACK_IMPORTED_MODULE_19__inventories_constants__["W" /* DO_NOT_LIST */]].join(",")
    };
  }, []);
  var partAsJson = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return part.toJS();
  }, [part]);

  var notesColumnClassName = __WEBPACK_IMPORTED_MODULE_7_classnames___default()({
    "col-md-12": quoteType !== __WEBPACK_IMPORTED_MODULE_15__IncomingQuotes_constants__["n" /* AWAITING_REPLY */],
    "col-md-6": quoteType === __WEBPACK_IMPORTED_MODULE_15__IncomingQuotes_constants__["n" /* AWAITING_REPLY */]
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["e" /* Form */],
    _extends({}, props, { modal: true }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["FieldArray"], {
        name: "companies",
        component: __WEBPACK_IMPORTED_MODULE_22__CompanyRow__["a" /* default */],
        getFieldValue: getFieldValue,
        setFieldValue: setFieldValue
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* Row */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_redux_form__["FormSection"],
                { name: "incoming_quote_line_item" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Fields"], {
                  fieldName: __WEBPACK_IMPORTED_MODULE_17__OutgoingQuotes_constants__["f" /* QUOTE_TYPE */],
                  names: [__WEBPACK_IMPORTED_MODULE_18__constants__["V" /* COST */], __WEBPACK_IMPORTED_MODULE_18__constants__["j" /* QUANTITY */], __WEBPACK_IMPORTED_MODULE_17__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */]],
                  component: __WEBPACK_IMPORTED_MODULE_12__IncomingQuotes_IncomingQuoteTypeSelect__["a" /* default */],
                  quoteTypes: quoteTypes,
                  setFieldValue: setFieldValue
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 6 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                name: __WEBPACK_IMPORTED_MODULE_23__users_constants__["x" /* BUYER_ID */],
                label: "Buyer",
                placeholder: "Search by name...",
                component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["n" /* AutoCompleteField */],
                search: props.searchBuyers,
                selectedItem: selectedBuyer,
                onItemSelected: function onItemSelected(item) {
                  return setSelectedBuyer(item);
                },
                formatItem: function formatItem(result) {
                  return result && result.full_name;
                },
                required: true
              })
            )
          ),
          quoteType === __WEBPACK_IMPORTED_MODULE_15__IncomingQuotes_constants__["n" /* AWAITING_REPLY */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
              { md: 4 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["a" /* CheckGroup */],
                { checkGroupStyles: { marginTop: 0 }, justified: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                  name: __WEBPACK_IMPORTED_MODULE_15__IncomingQuotes_constants__["o" /* SEND_QUOTE */],
                  component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["b" /* Check */],
                  label: "Send RFQ"
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_SellableQty__["a" /* default */], {
            quantities: part.get(__WEBPACK_IMPORTED_MODULE_16__constants__["P" /* SELLABLE_QUANTITIES */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({})),
            style: { marginTop: 20 }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            { className: "margin-bottom-30 line-height-2" },
            "Next Available Inventory"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "row reset-panel-table" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_redux_form__["FormSection"],
              { name: "ingoing_quote_line_item" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__OutgoingQuotes_shared_SelectInventoryTable__["a" /* default */], {
                filter: filter,
                part: partAsJson,
                choosable: false,
                modal: false,
                displayQuantity: false
              })
            )
          ),
          quoteType !== __WEBPACK_IMPORTED_MODULE_15__IncomingQuotes_constants__["j" /* NO_QUOTE */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              null,
              "Part Details"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_redux_form__["FormSection"],
              { name: "incoming_quote_line_item" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_PartDetails__["a" /* default */], { quoteType: quoteType, part: part })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-xs hr-dashed" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: notesColumnClassName },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_redux_form__["FormSection"],
                  { name: "incoming_quote_line_item" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_18__constants__["_18" /* NOTES */],
                    component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["l" /* TextArea */],
                    label: "Note (Applied to the line item)",
                    rows: 5
                  })
                )
              )
            ),
            quoteType === __WEBPACK_IMPORTED_MODULE_15__IncomingQuotes_constants__["n" /* AWAITING_REPLY */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: notesColumnClassName },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "form-group" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_redux_form__["FormSection"],
                  { name: "incoming_quote_line_item" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_20__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */],
                    component: __WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["l" /* TextArea */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_20__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */]),
                    rows: 5
                  })
                )
              )
            )
          )
        )
      )
    )
  );
}

Form.propTypes = {
  quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  quoteType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  quoteTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  companyId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  selectedCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  selectedEmail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setSelectedCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setSelectedEmail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var selector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_form__["formValueSelector"])(formName);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function (state) {
  return {
    quantity: selector(state, "incoming_quote_line_item.quantity"),
    companyId: selector(state, __WEBPACK_IMPORTED_MODULE_18__constants__["N" /* COMPANY_ID */]),
    cost: selector(state, "incoming_quote_line_item.cost"),
    getFieldValue: function getFieldValue(field) {
      return selector(state, field);
    },
    quoteType: selector(state, "incoming_quote_line_item.quote_type"),
    part: state.partDetail.get(__WEBPACK_IMPORTED_MODULE_16__constants__["B" /* PART */]),
    contact: selector(state, __WEBPACK_IMPORTED_MODULE_18__constants__["O" /* CONTACT_ID */])
  };
}, function (dispatch) {
  return {
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_10__users_actions__["h" /* searchUsers */](filter));
    },
    setFieldValue: function setFieldValue(field) {
      return function (val) {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux_form__["change"])(formName, field, val));
      };
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_25__validate__["a" /* default */],
  asyncValidate: __WEBPACK_IMPORTED_MODULE_9__companies_actions__["b" /* validateContact */],
  asyncBlurFields: ["contact.email"]
})(Form)));

/***/ }),
/* 2214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IncomingQuotes_Parts_validate__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* unused harmony export validateCompany */
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;





function validateCompany(company) {
  company.validate(__WEBPACK_IMPORTED_MODULE_3__constants__["O" /* CONTACT_ID */], __WEBPACK_IMPORTED_MODULE_3__constants__["N" /* COMPANY_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
}

function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (form) {
    form.validateChildren("companies", validateCompany);

    form.validateChild("incoming_quote_line_item", function (lineItem) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__IncomingQuotes_Parts_validate__["a" /* validateLineItem */])(lineItem, values, "incoming_quote_line_item");
    });
  });
}

/***/ }),
/* 2215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_BackToPart__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__IncomingQuotes_Search_IncomingQuotes__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Table__ = __webpack_require__(2216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pagination__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CreateMultiVendorQuote_CreateMultiVendorQuote__ = __webpack_require__(2212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Create_Create__ = __webpack_require__(2210);
/* unused harmony export IncomingQuoteLineItems */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
















function IncomingQuoteLineItems(_ref) {
  var part = _ref.part;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalOpen = _useState2[0],
      setModalOpen = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState4 = _slicedToArray(_useState3, 2),
      vendorModalOpen = _useState4[0],
      setVendorModalOpen = _useState4[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_11__pagination__["h" /* incomingQuotesPagination */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_BackToPart__["a" /* default */], { part: part }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "form-group form-group-searchbar has-feedback has-feedback-left",
            style: { margin: "-15px -30px 30px -30px" }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a Company Name..."
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
              filters: __WEBPACK_IMPORTED_MODULE_9__IncomingQuotes_Search_IncomingQuotes__["b" /* INCOMING_QUOTE_FILTERS */].filter(function (f) {
                return !f.exclude_parts_view;
              }),
              right: true
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "input-group-btn" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "button",
                {
                  onClick: function onClick() {
                    return setModalOpen(true);
                  },
                  className: "btn btn-primary pull-right",
                  type: "button"
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
                "Create Quote"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "input-group-btn" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "button",
                {
                  onClick: function onClick() {
                    return setVendorModalOpen(true);
                  },
                  className: "btn btn-success pull-right",
                  type: "button"
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
                "Create Multi-Vendor Quote"
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Create_Create__["a" /* default */], { open: modalOpen, close: function close() {
            return setModalOpen(false);
          } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__CreateMultiVendorQuote_CreateMultiVendorQuote__["a" /* default */], {
          open: vendorModalOpen,
          close: function close() {
            return setVendorModalOpen(false);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "Incoming Quote History",
          filters: __WEBPACK_IMPORTED_MODULE_9__IncomingQuotes_Search_IncomingQuotes__["c" /* INCOMING_QUOTE_FILTER_TAGS */]
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

IncomingQuoteLineItems.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    part: state.partDetail.get("part")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["h" /* loadRecord */])({
  reducer: "partDetail",
  name: "part",
  action: __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* show */]
})(IncomingQuoteLineItems)));

/***/ }),
/* 2216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_LineItemStatusCell__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ModifiedFlag__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__IncomingQuotes_shared_IncidentRelatedFlag__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__IncomingQuotes_shared_AsIsFlag__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components_LineItemQtyCell_LineItemQtyCell__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash__);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


















function renderRow(lineItem, i, pushHistory) {
  var handleMailto = function handleMailto(e) {
    e.stopPropagation();
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: lineItem.id,
      className: "clickable",
      onClick: function onClick() {
        return pushHistory("/incoming-quotes/" + lineItem.quote_id);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { whiteSpace: "nowrap" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { textAlign: "right" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_components_LineItemQtyCell_LineItemQtyCell__["a" /* default */], { lineItem: lineItem, showFull: true, type: "IQ" }),
          i + 1
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_LineItemStatusCell__["a" /* default */],
      { lineItem: lineItem },
      lineItem.quote_code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: lineItem.updated_tracked_fields_at && "text-yellow" },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["c" /* shortDateYY */])(lineItem.updated_tracked_fields_at || lineItem.created_at)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["e" /* truncate */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["d" /* getFirstNameLastInitial */])(__WEBPACK_IMPORTED_MODULE_15_lodash___default.a.get(lineItem, "buyer.full_name")), 14)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_7__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].quoteType[lineItem.quote_type].abbrev
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["w" /* CompanyName */], {
        company: {
          id: lineItem.company_id,
          name: lineItem.company_name || lineItem.legacy_company_name,
          company_type: lineItem.company_company_type
        },
        truncateAt: 25
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.expected_serial_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.contact_name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        { href: "mailto:" + lineItem.contact_email, onClick: handleMailto },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["e" /* truncate */])(lineItem.contact_email, 15)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      lineItem.trace_type && __WEBPACK_IMPORTED_MODULE_7__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].traceTypes[lineItem.trace_type].abbrev
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      lineItem.tag_date && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["g" /* monthYear */])(lineItem.tag_date)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["e" /* truncate */])(lineItem.tagged_by, 15)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.modified && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ModifiedFlag__["b" /* default */], null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.condition && lineItem.quote_type !== __WEBPACK_IMPORTED_MODULE_7__IncomingQuotes_constants__["j" /* NO_QUOTE */] && __WEBPACK_IMPORTED_MODULE_7__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].condition[lineItem.condition].abbrev,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__IncomingQuotes_shared_IncidentRelatedFlag__["a" /* IncidentRelatedFlag */], { lineItem: lineItem }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__IncomingQuotes_shared_AsIsFlag__["a" /* AsIsFlag */], { lineItem: lineItem, className: "m-l-5" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      lineItem.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["e" /* truncate */])(lineItem.lead_time)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      lineItem.exchange_fee && lineItem.exchange_fee > 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(lineItem.exchange_fee)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      lineItem.cost && lineItem.cost > 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(lineItem.cost)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["e" /* truncate */])(lineItem.warranty, 15)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], { note: lineItem.notes })
  );
}

function Table(props) {
  var pushHistory = props.pushHistory,
      isLoading = props.isLoading,
      results = props.results;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_10__shared_components__["s" /* DataTable */],
    { loading: isLoading, numbered: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Quote #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Buyer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Type"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Vendor"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Contact"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Email"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Trace"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Tag Date"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Tagged By"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Cond"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "QTY"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "LT"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Exch"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Cost per Unit"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Warranty"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r, i) {
        return renderRow(r, i, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_10__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(Table));

/***/ }),
/* 2217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IncomingQuoteLineItems__ = __webpack_require__(2215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__IncomingQuoteLineItems__["a"]; });



/***/ }),
/* 2218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_BackToPart__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table__ = __webpack_require__(2219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pagination__ = __webpack_require__(108);
/* unused harmony export Inventories */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













function Inventories(_ref) {
  var part = _ref.part;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_10__pagination__["c" /* partInventories */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_BackToPart__["a" /* default */], { part: part }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, { title: "Full Inventory List" })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

Inventories.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    part: state.partDetail.get("part")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators__["h" /* loadRecord */])({
  reducer: "partDetail",
  name: "part",
  action: __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* show */]
})(Inventories)));

/***/ }),
/* 2219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__inventories_components_Controls__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components_InventoryListingOverrideCell__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_InventoryQuantityCell__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_InventoryStatusCell__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_InventoryTagDateCell__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__inventories_components_Detail_Warnings__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ModifiedFlag__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__inventories_helpers__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__helpers__ = __webpack_require__(766);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
























var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.renderInventoryRow = function (r, i, pushHistory, renderDummyValues) {
      var activeFlags = Object.keys(__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_1" /* FLAG_TYPES */]).filter(function (t) {
        return r[t];
      });
      var hasModifiedFlag = activeFlags.includes(__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_2" /* MODIFIED */]);
      var onlyModifiedFlag = activeFlags.length === 1 && hasModifiedFlag;

      var flagTypes = activeFlags.map(function (t) {
        return __WEBPACK_IMPORTED_MODULE_8__inventories_constants__["_1" /* FLAG_TYPES */][t].label;
      }).join(", ");

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16__shared_components__["A" /* LinkedTableRow */],
        {
          to: "/inventories/" + r.uuid,
          key: renderDummyValues ? "d-" + i : i,
          className: __WEBPACK_IMPORTED_MODULE_15_classnames___default()({ "text-muted": renderDummyValues })
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          renderDummyValues ? i + 1 + "D" : i + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__shared_components_InventoryStatusCell__["a" /* default */],
          { inventory: r },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components_InventoryListingOverrideCell__["a" /* default */], {
            inventory: r,
            renderDummyValues: renderDummyValues
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(r.date_received)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__lib_formatters_text__["d" /* getFirstNameLastInitial */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(r, "buyer.full_name"))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__lib_formatters_text__["d" /* getFirstNameLastInitial */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(r, "co_buyer.full_name"))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__lib_formatters_text__["d" /* getFirstNameLastInitial */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(r, "third_buyer.full_name"))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && r.serial_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_18__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            !renderDummyValues && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components__["o" /* LocationFlag */], { location: r.store_owner_id })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            !renderDummyValues && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components__["o" /* LocationFlag */], { location: r.store_location_id })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          flagTypes && !onlyModifiedFlag && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
            title: flagTypes,
            className: "fa fa-fw fa-flag",
            style: { color: "red" }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && r.location === "Shipped To Customer" ? "Shipped To Cust." : r.location
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__inventories_components_Detail_Warnings__["b" /* default */], { inventory: r })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__lib_formatters_text__["e" /* truncate */])(r.traced_to, 24)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_InventoryTagDateCell__["a" /* default */], {
          inventory: r,
          renderDummyValues: renderDummyValues
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__inventories_helpers__["c" /* inventoryTaggedBy */])(r)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__lib_formatters_text__["d" /* getFirstNameLastInitial */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(r, "reserve_for_seller.full_name"))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && r.reserved_for_sale_on && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["c" /* shortDateYY */])(r.reserved_for_sale_on)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__lib_formatters_text__["d" /* getFirstNameLastInitial */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(r, "reserved_by.full_name"))
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { style: __WEBPACK_IMPORTED_MODULE_17__ModifiedFlag__["a" /* columnStyle */].flagColumn },
          hasModifiedFlag && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ModifiedFlag__["b" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center", style: __WEBPACK_IMPORTED_MODULE_17__ModifiedFlag__["a" /* columnStyle */].conditionColumn },
          renderDummyValues ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["r" /* INVENTORIES */], "condition." + r.dummy.condition + ".abbrev") : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8__inventories_constants__["r" /* INVENTORIES */], "condition." + r.condition + ".abbrev")
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          r.release_type
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_components_InventoryQuantityCell__["a" /* default */], {
          inventory: r,
          renderDummyValues: renderDummyValues
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-right" },
          !renderDummyValues && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(r.cost_per_unit)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          { className: "text-center" },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers__["a" /* displaySrp */])(renderDummyValues, r)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], {
          note: renderDummyValues ? r.dummy.note : r.important_note,
          color: r.important_note && "#f44336"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "td",
          null,
          !renderDummyValues && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__inventories_components_Controls__["a" /* default */], { inventory: r })
        )
      );
    }, _this.renderRow = function (inventory, i, pushHistory) {
      if (inventory.dummy) {
        return [_this.renderInventoryRow(inventory, i, pushHistory), _this.renderInventoryRow(inventory, i, pushHistory, true)];
      }
      return _this.renderInventoryRow(inventory, i, pushHistory);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          pushHistory = _props.pushHistory,
          results = _props.results;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "table-responsive", style: { whiteSpace: "nowrap" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "table",
          { className: "table table-striped table-hover table-numbered" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "thead",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "tr",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Date Received"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Buyer"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Co-Buyer"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Third Buyer"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Serial #"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_18__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Store Owner"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "th",
                  null,
                  "Store Loc"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Flag"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "LOC"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Status"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Trace To"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Tag Date"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Tagged By"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Res. For"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Res. Date"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Res. By"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-center" },
                "CD"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                null,
                "Release"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "QTY"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-right" },
                "Cost"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-center" },
                "SRP"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-center" }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", { className: "text-center" })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tbody",
            null,
            results.map(function (r, i) {
              return _this2.renderRow(r, i, pushHistory);
            })
          )
        )
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_16__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"] })(Table));

/***/ }),
/* 2220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Inventories__ = __webpack_require__(2218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Inventories__["a"]; });



/***/ }),
/* 2221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_BackToPart__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table__ = __webpack_require__(2222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pagination__ = __webpack_require__(108);
/* unused harmony export LotLineItems */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













function LotLineItems(_ref) {
  var part = _ref.part;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_10__pagination__["i" /* lotsPagination */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_BackToPart__["a" /* default */], { part: part }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          aggregateField: "cost",
          title: "Lot Order History"
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

LotLineItems.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    part: state.partDetail.get("part")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["h" /* loadRecord */])({
  reducer: "partDetail",
  name: "part",
  action: __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* show */]
})(LotLineItems)));

/***/ }),
/* 2222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_shared_AsIsFlag__ = __webpack_require__(113);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













function renderRow(lineItem, i) {
  var handleMailto = function handleMailto(e) {
    e.stopPropagation();
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components__["A" /* LinkedTableRow */],
    { to: "/lots/" + lineItem.lot.uuid, key: i },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { whiteSpace: "nowrap" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { textAlign: "right" } },
          i + 1
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.lot.code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      " ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["b" /* shortDate */])(lineItem.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["w" /* CompanyName */], { company: lineItem.company })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.buyer.full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.co_buyer && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.co_buyer.full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.serial_number || lineItem.expected_serial_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["e" /* truncate */])(lineItem.contact.name, 25)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        { href: "mailto:" + lineItem.contact.email, onClick: handleMailto },
        lineItem.contact.email
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_7__IncomingQuotes_constants__["b" /* INCOMING_LINE_ITEMS */].condition[lineItem.condition].abbrev,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__IncomingQuotes_shared_AsIsFlag__["a" /* AsIsFlag */], { lineItem: lineItem, className: "m-l-5" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      lineItem.quantity_received
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.lead_time
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(lineItem.cost)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], { note: lineItem.internal_note })
  );
}

function Table(props) {
  var pushHistory = props.pushHistory,
      isLoading = props.isLoading,
      results = props.results;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */],
    { loading: isLoading, numbered: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "PO #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Created"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Vendor"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Buyer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Co-Buyer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Contact"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Email"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "CD"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "QTY"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "QTY Rec"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "LT"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Cost Ea"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r, i) {
        return renderRow(r, i, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_9__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(Table));

/***/ }),
/* 2223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_BackToPart__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Table__ = __webpack_require__(2224);
/* unused harmony export ManagedRepairOrderLineItems */










var listId = "part/managedRepairOrderLineItems";

function Title() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      "Managed Repair Order History"
    )
  );
}

var TitleWithFilters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["k" /* withFilters */])(Title);

function ManagedRepairOrderLineItems(_ref) {
  var part = _ref.part;

  var paginator = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__["Paginator"], { listId: listId });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_BackToPart__["a" /* default */], { part: part }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TitleWithFilters, { listId: listId }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Table__["a" /* default */], null),
    paginator
  );
}

ManagedRepairOrderLineItems.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    part: state.partDetail.get("part")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["h" /* loadRecord */])({
  reducer: "partDetail",
  name: "part",
  action: __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* show */]
})(ManagedRepairOrderLineItems)));

/***/ }),
/* 2224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ManagedRepairOrders_constants__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_formatters_number__ = __webpack_require__(72);
/* unused harmony export Table */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















function renderRow(lineItem, i, pushHistory) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: lineItem.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */]),
      className: "clickable",
      onClick: function onClick() {
        return pushHistory("/managed-repair-orders/" + lineItem.getIn([__WEBPACK_IMPORTED_MODULE_14__ManagedRepairOrders_constants__["a" /* MANAGED_REPAIR_ORDER */], __WEBPACK_IMPORTED_MODULE_11__constants__["c" /* UUID */]]));
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      i + 1
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.getIn([__WEBPACK_IMPORTED_MODULE_14__ManagedRepairOrders_constants__["a" /* MANAGED_REPAIR_ORDER */], __WEBPACK_IMPORTED_MODULE_11__constants__["z" /* CODE */]])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["b" /* shortDate */])(lineItem.get("created_at"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["w" /* CompanyName */], {
        flattenedCompany: lineItem.toJS(),
        context: "repair",
        truncateAt: 25
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.get("contact_name")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.getIn([__WEBPACK_IMPORTED_MODULE_15__users_constants__["P" /* BUYER */], __WEBPACK_IMPORTED_MODULE_15__users_constants__["f" /* FULL_NAME */]])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.getIn([__WEBPACK_IMPORTED_MODULE_15__users_constants__["_5" /* CO_BUYER */], __WEBPACK_IMPORTED_MODULE_15__users_constants__["f" /* FULL_NAME */]])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      lineItem.get(__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["G" /* LEAD_TIME */])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.get(__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["o" /* SERIAL_NUMBER */])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__RepairOrders_constants__["p" /* getConditionAbbrev */])(lineItem.getIn([__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["n" /* CONDITION */]]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-center" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["o" /* LocationFlag */], {
          location: lineItem.get(__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["_27" /* STORE_LOCATION_ID */]),
          unknownFlag: false
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.get(__WEBPACK_IMPORTED_MODULE_11__constants__["j" /* QUANTITY */])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_11__constants__["V" /* COST */]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__lib_formatters_number__["a" /* percent */])(parseFloat(lineItem.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_28" /* MARKUP */])), 100)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.get("price"))
    )
  );
}

var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    _classCallCheck(this, Table);

    return _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
  }

  _createClass(Table, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.setPageSize(25);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          pushHistory = _props.pushHistory,
          results = _props.results;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "table",
        { className: "table table-striped table-hover table-numbered" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "MR #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Date Created"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Customer"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Contact"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Buyer"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Co Buyer"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Lead Time (Days)"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Serial #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "CD"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-center" },
                "Store Location"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Qty"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Cost"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Markup"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Price"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tbody",
          null,
          results.map(function (r, i) {
            return renderRow(r, i, pushHistory);
          })
        )
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Table.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  setPageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  results: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"]).isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function () {
  return {
    listId: "part/managedRepairOrderLineItems"
  };
}, {
  pushHistory: __WEBPACK_IMPORTED_MODULE_4_react_router_redux__["push"],
  setPageSize: __WEBPACK_IMPORTED_MODULE_6__actions__["e" /* managedRepairOrderActions */].pageActions.setPageSize
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["l" /* tabulateImmutable */])(Table)));

/***/ }),
/* 2225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ManagedRepairOrderLineItems__ = __webpack_require__(2223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ManagedRepairOrderLineItems__["a"]; });



/***/ }),
/* 2226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HoverFlag__ = __webpack_require__(209);



var ModifiedFlag = function ModifiedFlag() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__HoverFlag__["a" /* default */], { text: "Modified" });
};

/* harmony default export */ __webpack_exports__["a"] = (ModifiedFlag);

/***/ }),
/* 2227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  flagColumn: {
    paddingRight: 0
  },
  conditionColumn: {
    paddingLeft: 2
  }
});

/***/ }),
/* 2228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_BackToPart__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table__ = __webpack_require__(2229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pagination__ = __webpack_require__(108);
/* unused harmony export OutgoingQuoteLineItems */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













function OutgoingQuoteLineItems(_ref) {
  var part = _ref.part;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_10__pagination__["g" /* outgoingQuotesPagination */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_BackToPart__["a" /* default */], { part: part }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "form-group form-group-searchbar has-feedback has-feedback-left",
            style: { margin: "-15px -30px 30px -30px" }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a Company Name..."
            }))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, { title: "Outgoing Quote History" })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

OutgoingQuoteLineItems.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    part: state.partDetail.get("part")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_decorators__["h" /* loadRecord */])({
  reducer: "partDetail",
  name: "part",
  action: __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* show */]
})(OutgoingQuoteLineItems)));

/***/ }),
/* 2229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_LineItemStatusCell__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OutgoingQuotes_shared_OutgoingQuoteNote__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OutgoingQuotes_shared_LookingForFlags__ = __webpack_require__(320);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















function renderRow(lineItem, i, pushHistory) {
  var handleMailto = function handleMailto(e) {
    e.stopPropagation();
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: lineItem.id,
      className: "clickable",
      onClick: function onClick() {
        return pushHistory("/outgoing-quotes/" + lineItem.quote_uuid);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      i + 1
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_LineItemStatusCell__["a" /* default */],
      { lineItem: lineItem },
      lineItem.quote_code
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["b" /* shortDate */])(lineItem.created_at)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: lineItem.updated_tracked_fields_at && "text-yellow" },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_date__["b" /* shortDate */])(lineItem.updated_tracked_fields_at || lineItem.created_at)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_7__OutgoingQuotes_constants__["c" /* OUTGOING_LINE_ITEMS */].quoteType[lineItem.quote_type].label
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.created_by && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.created_by.full_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components__["w" /* CompanyName */], { flattenedCompany: lineItem, truncateAt: 16 })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.contact_name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__OutgoingQuotes_shared_LookingForFlags__["a" /* LookingForFlags */], { lineItem: lineItem })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        { href: "mailto:" + lineItem.contact_email, onClick: handleMailto },
        "" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["e" /* truncate */])(lineItem.contact_email, 12)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.serial_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      lineItem.trace_type && __WEBPACK_IMPORTED_MODULE_7__OutgoingQuotes_constants__["c" /* OUTGOING_LINE_ITEMS */].traceTypes[lineItem.trace_type].abbrev
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      lineItem.condition && __WEBPACK_IMPORTED_MODULE_11__constants__["_27" /* CONDITIONS_WITH_SERVICEABLE */][lineItem.condition].abbrev
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      lineItem.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      lineItem.price_per_unit && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(lineItem.price_per_unit)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__OutgoingQuotes_shared_OutgoingQuoteNote__["a" /* default */], { lineItem: lineItem })
  );
}

function Table(props) {
  var pushHistory = props.pushHistory,
      isLoading = props.isLoading,
      results = props.results;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */],
    { loading: isLoading, numbered: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Quote #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Created"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Updated"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Type"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Created By"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Customer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Contact"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Email"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Trace"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Cond"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "QTY"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Price Per Unit"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r, i) {
        return renderRow(r, i, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_9__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"] })(Table));

/***/ }),
/* 2230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OutgoingQuoteLineItems__ = __webpack_require__(2228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__OutgoingQuoteLineItems__["a"]; });



/***/ }),
/* 2231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();





var PartsCount = function PartsCount() {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].dashboard().then(function (_ref) {
      var data = _ref.data;
      return setCount(data.parts_count);
    });
  }, []);

  if (count === null) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "h5",
    null,
    "PN Count: ",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "b",
      null,
      count
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PartsCount);

/***/ }),
/* 2232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PartsCount__ = __webpack_require__(2231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PartsCount__["a"]; });


/***/ }),
/* 2233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_BackToPart__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table__ = __webpack_require__(2234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pagination__ = __webpack_require__(108);
/* unused harmony export PurchaseOrderLineItems */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













function PurchaseOrderLineItems(_ref) {
  var part = _ref.part;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_10__pagination__["f" /* purchaseOrdersPagination */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_BackToPart__["a" /* default */], { part: part }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          aggregateField: "non_cancelled_subtotal",
          title: "Purchase Order History"
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

PurchaseOrderLineItems.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    part: state.partDetail.get("part")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["h" /* loadRecord */])({
  reducer: "partDetail",
  name: "part",
  action: __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* show */]
})(PurchaseOrderLineItems)));

/***/ }),
/* 2234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_PurchaseOrderLineItemStatusCell__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_shared_AsIsFlag__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_shared_ExchangeIcon__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_shared_helpers__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__inventories_constants__ = __webpack_require__(12);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

















function renderRow(lineItem, i) {
  var handleMailto = function handleMailto(e) {
    e.stopPropagation();
  };

  var link = function link(type, uuid) {
    if (type === "PurchaseOrder") {
      return "/purchase-orders/" + uuid;
    } else if (type === "Lot") {
      return "/lots/" + uuid;
    }

    return null;
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_10__shared_components__["A" /* LinkedTableRow */],
    {
      to: link(lineItem.type, lineItem.parent_uuid),
      key: i,
      cancelled: lineItem.cancelled
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { whiteSpace: "nowrap" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { textAlign: "right" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["I" /* LineItemQtyCell */], { lineItem: lineItem }),
          i + 1
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_PurchaseOrderLineItemStatusCell__["a" /* default */],
      { lineItem: lineItem },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        lineItem.code
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      " ",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(lineItem.created_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["w" /* CompanyName */], { flattenedCompany: lineItem })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.buyer_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.co_buyer_name && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.co_buyer_name)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.serial_number || lineItem.expected_serial_number
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_text__["e" /* truncate */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, "contact_name", 25))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.contact_email && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        {
          href: "mailto:" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, "contact_email"),
          onClick: handleMailto
        },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(lineItem, "contact_email")
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.condition && __WEBPACK_IMPORTED_MODULE_14__inventories_constants__["r" /* INVENTORIES */].condition[lineItem.condition].abbrev,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__IncomingQuotes_shared_AsIsFlag__["a" /* AsIsFlag */], { lineItem: lineItem, className: "m-l-5" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.quantity
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      lineItem.quantity_received
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__PurchaseOrders_shared_ExchangeIcon__["a" /* ExchangeIcon */], { lineItem: lineItem })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.lead_time
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_shared_helpers__["a" /* displayCost */])(lineItem) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__PurchaseOrders_shared_helpers__["a" /* displayCost */])(lineItem))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      lineItem.purchase_for_exchange && !lineItem.outright && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(lineItem.cost)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(lineItem.subtotal)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_components_NoteTooltip__["b" /* NoteTooltipTableCell */], { note: lineItem.internal_note })
  );
}

function Table(props) {
  var pushHistory = props.pushHistory,
      isLoading = props.isLoading,
      results = props.results;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_10__shared_components__["s" /* DataTable */],
    { loading: isLoading, numbered: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "PO #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Created"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Vendor"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Buyer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Co-Buyer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Serial #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Contact"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Email"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "CD"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "QTY"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "QTY Rec"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Exch"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "LT"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Exch Fee/Cost Ea"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Outright Value"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Total"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r, i) {
        return renderRow(r, i, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_10__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_4_react_router_redux__["push"] })(Table));

/***/ }),
/* 2235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PurchaseOrderLineItems__ = __webpack_require__(2233);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PurchaseOrderLineItems__["a"]; });



/***/ }),
/* 2236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_BackToPart__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Stats__ = __webpack_require__(2237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Table__ = __webpack_require__(2238);
/* unused harmony export RepairOrderLineItems */












var listId = "part/repairOrderLineItems";

function Title() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      "Repair Order History"
    )
  );
}

var TitleWithFilters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["k" /* withFilters */])(Title);

function RepairOrderLineItems(_ref) {
  var part = _ref.part;

  var paginator = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__["Paginator"], { listId: listId });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_BackToPart__["a" /* default */], { part: part }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TitleWithFilters, { listId: listId }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Stats__["a" /* default */], { partId: part.get(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* ID */]) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Table__["a" /* default */], null),
    paginator
  );
}

RepairOrderLineItems.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    part: state.partDetail.get("part")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["h" /* loadRecord */])({
  reducer: "partDetail",
  name: "part",
  action: __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* show */]
})(RepairOrderLineItems)));

/***/ }),
/* 2237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(7);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








function Count(_ref) {
  var data = _ref.data,
      dataLabel = _ref.dataLabel,
      type = _ref.type,
      _ref$format = _ref.format,
      format = _ref$format === undefined ? "$(0,0)" : _ref$format;

  if (!data) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
    { md: 3 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components__["H" /* Stat */], { label: dataLabel, value: __WEBPACK_IMPORTED_MODULE_4_numeral___default()(data[type]).format(format) })
  );
}

Count.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  dataLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

function Stats(_ref2) {
  var partId = _ref2.partId;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),
      _useState2 = _slicedToArray(_useState, 2),
      stats = _useState2[0],
      setStats = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].parts.repairOrderLineItems.stats(partId).then(function (resp) {
      setStats(resp.data);
    });
  }, []);

  if (!stats) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Count, {
      dataLabel: "AVERAGE OVERHAUL",
      data: stats,
      type: "overhaul_average"
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Count, { dataLabel: "AVERAGE REPAIR", data: stats, type: "repair_average" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Count, { dataLabel: "AVERAGE TEST", data: stats, type: "test_average" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Count, {
      dataLabel: "PASS RATE",
      data: stats,
      type: "pass_rate",
      format: "0.0%"
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Count, { dataLabel: "AVERAGE TAT", data: stats, type: "tat", format: "0 Days" })
  );
}

Stats.propTypes = {};

/* harmony default export */ __webpack_exports__["a"] = (Stats);

/***/ }),
/* 2238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RepairOrders_components_Detail_LineItems_StatusBadges__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__RepairOrders_helpers__ = __webpack_require__(168);
/* unused harmony export Table */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















function renderRow(lineItem, i, pushHistory) {
  var cap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__RepairOrders_helpers__["a" /* getCap */])(lineItem);

  var exchangeGoneOutright = lineItem.get("exchange_gone_outright");
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: lineItem.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */]),
      className: "clickable",
      onClick: function onClick() {
        return pushHistory("/repair-orders/" + lineItem.get("repair_order_uuid"));
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      i + 1
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: cap },
      lineItem.get("repair_order_code")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      exchangeGoneOutright && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__RepairOrders_helpers__["b" /* ExchangeIcon */], { lineItem: lineItem.toJS() })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["b" /* shortDate */])(lineItem.get("created_at"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["w" /* CompanyName */], {
        flattenedCompany: lineItem.toJS(),
        context: "repair",
        truncateAt: 25
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.get("contact_name")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.get("original_serial_number")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.getIn([__WEBPACK_IMPORTED_MODULE_9__RepairOrders_constants__["h" /* MOD_TO */], __WEBPACK_IMPORTED_MODULE_14__constants__["w" /* PART_NUMBER */]])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.get(__WEBPACK_IMPORTED_MODULE_11__constants__["j" /* QUANTITY */])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_24" /* QUANTITY_RECEIVED */])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__RepairOrders_constants__["p" /* getConditionAbbrev */])(lineItem.get("condition_sent"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__RepairOrders_constants__["p" /* getConditionAbbrev */])(lineItem.getIn([__WEBPACK_IMPORTED_MODULE_12__inventories_constants__["_24" /* INVENTORY */], __WEBPACK_IMPORTED_MODULE_12__inventories_constants__["n" /* CONDITION */]]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-success text-center" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__RepairOrders_helpers__["c" /* getExchange */])(lineItem)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_16__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        { className: "text-center" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["o" /* LocationFlag */], {
          location: lineItem.get(__WEBPACK_IMPORTED_MODULE_11__constants__["_25" /* RETURN_TO_LOCATION_ID */]),
          unknownFlag: false
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__RepairOrders_components_Detail_LineItems_StatusBadges__["a" /* default */], { lineItem: lineItem.toJS() }),
      lineItem.toJS().inventory && lineItem.toJS().inventory.status === "sales_order_created" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["j" /* NoteTooltip */], {
        placement: "right",
        icon: "fa-paper-plane",
        note: "Pending Sale"
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_date__["b" /* shortDate */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_13__SalesOrders_constants__["n" /* EXPECTED_DATE */]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_13__SalesOrders_constants__["o" /* PART_COST */]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_13__SalesOrders_constants__["p" /* LABOR_COST */]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.get("outside_labor_cost"))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.get("subtotal"))
    )
  );
}

var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    _classCallCheck(this, Table);

    return _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
  }

  _createClass(Table, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.setPageSize(25);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          pushHistory = _props.pushHistory,
          results = _props.results;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "table",
        { className: "table table-striped table-hover table-numbered" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "thead",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "RO #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Exchange Gone Outright"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Date Created"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Repair Station"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Contact"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Serial #"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Mod To"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "QTY"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Rec"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "CD Sent"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Inv CD"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-center" },
              "Exch"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_16__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "th",
                { className: "text-center" },
                "Return Store"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Status"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              null,
              "Expected Date"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Parts"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Labor"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Out. Labor"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Total"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tbody",
          null,
          results.map(function (r, i) {
            return renderRow(r, i, pushHistory);
          })
        )
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Table.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  setPageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  results: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"]).isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function () {
  return {
    listId: "part/repairOrderLineItems"
  };
}, {
  pushHistory: __WEBPACK_IMPORTED_MODULE_4_react_router_redux__["push"],
  setPageSize: __WEBPACK_IMPORTED_MODULE_6__actions__["c" /* repairOrderActions */].pageActions.setPageSize
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["l" /* tabulateImmutable */])(Table)));

/***/ }),
/* 2239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RepairOrderLineItems__ = __webpack_require__(2236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RepairOrderLineItems__["a"]; });



/***/ }),
/* 2240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Detail_RepairQuotes_Create_Form__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pagination__ = __webpack_require__(108);
/* harmony export (immutable) */ __webpack_exports__["a"] = Create;
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }











function Create(_ref) {
  var open = _ref.open,
      close = _ref.close,
      part = _ref.part,
      sendRfq = _ref.sendRfq;

  var _useOnSubmit = useOnSubmit(close, sendRfq),
      onSubmit = _useOnSubmit.onSubmit;

  var initialValues = {
    repair_quote_line_item: {
      part_id: part.id,
      quote_type: __WEBPACK_IMPORTED_MODULE_1__IncomingQuotes_constants__["k" /* STANDARD */]
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Create a New Incoming Quote"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Detail_RepairQuotes_Create_Form__["a" /* default */], {
      close: close,
      initialValues: initialValues,
      onSubmit: onSubmit,
      modal: true
    })
  );
}

Create.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  part: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({ id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number }),
  sendRfq: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
};

function useOnSubmit(close, sendRfq) {
  var _this = this;

  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__hooks__["b" /* useDispatch */])();

  var onSubmit = function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data) {
      var _ref3, quote;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].repairQuotes.create(data);

            case 2:
              _ref3 = _context.sent;
              quote = _ref3.data;

              __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__["toastr"].success("Success", quote.code + " successfully created.");
              dispatch(__WEBPACK_IMPORTED_MODULE_8__pagination__["e" /* repairQuotesPagination */].pageActions.expire());

              window.scrollTo(0, 0);

              if (data.sendRfq) {
                sendRfq(quote.repair_quote_line_item);
              }

              close();

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return { onSubmit: onSubmit };
}

/***/ }),
/* 2241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_BackToPart__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Update_Update__ = __webpack_require__(2242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Create_Create__ = __webpack_require__(2240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Detail_RepairQuotes_Send_SendRfqModal__ = __webpack_require__(2195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Table__ = __webpack_require__(759);
/* unused harmony export RepairQuoteLineItems */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();















var listId = "part/repairQuoteLineItems";

function Title() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      "Repair Quote History"
    )
  );
}

var TitleWithFilters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["k" /* withFilters */])(Title);

function RepairQuoteLineItems(_ref) {
  var part = _ref.part;

  var paginator = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__orange_marmalade_paginate_this__["Paginator"], { listId: listId });

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalOpen = _useState2[0],
      setModalOpen = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState4 = _slicedToArray(_useState3, 2),
      updateModalOpen = _useState4[0],
      setUpdateModalOpen = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState6 = _slicedToArray(_useState5, 2),
      sendModalOpen = _useState6[0],
      setSendModalOpen = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState8 = _slicedToArray(_useState7, 2),
      lineItem = _useState8[0],
      setLineItem = _useState8[1];

  var sendRfq = function sendRfq(l) {
    setLineItem(l);
    setSendModalOpen(true);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_BackToPart__["a" /* default */], { part: part }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        onClick: function onClick() {
          return setModalOpen(true);
        },
        className: "btn btn-primary btn-hollow pull-right",
        type: "button"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
      "Create Quote"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Create_Create__["a" /* default */], {
      open: modalOpen,
      close: function close() {
        return setModalOpen(false);
      },
      sendRfq: sendRfq,
      part: part.toJS()
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Update_Update__["a" /* default */], {
      open: updateModalOpen,
      close: function close() {
        return setUpdateModalOpen(false);
      },
      lineItem: lineItem,
      setLineItem: setLineItem,
      sendRfq: sendRfq
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Detail_RepairQuotes_Send_SendRfqModal__["a" /* default */], {
      lineItem: lineItem,
      open: sendModalOpen,
      close: function close() {
        return setSendModalOpen(false);
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TitleWithFilters, { listId: listId }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Table__["a" /* default */], { openEditModal: setUpdateModalOpen, setLineItem: setLineItem }),
    paginator
  );
}

RepairQuoteLineItems.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    part: state.partDetail.get(__WEBPACK_IMPORTED_MODULE_7__constants__["B" /* PART */])
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["h" /* loadRecord */])({
  reducer: "partDetail",
  name: __WEBPACK_IMPORTED_MODULE_7__constants__["B" /* PART */],
  action: __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* show */]
})(RepairQuoteLineItems)));

/***/ }),
/* 2242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Detail_RepairQuotes_Update_Form__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pagination__ = __webpack_require__(108);
/* harmony export (immutable) */ __webpack_exports__["a"] = Update;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }











function Update(_ref) {
  var open = _ref.open,
      close = _ref.close,
      lineItem = _ref.lineItem,
      sendRfq = _ref.sendRfq,
      setLineItem = _ref.setLineItem;

  if (!lineItem) return null;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      _useState2 = _slicedToArray(_useState, 2),
      repairQuote = _useState2[0],
      setRepairQuote = _useState2[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].repairQuotes.show(lineItem.repair_quote_id).then(function (_ref2) {
      var data = _ref2.data;

      setRepairQuote(data);
    });
  }, [lineItem.repair_quote_id]);

  if (!repairQuote) return null;

  var _useOnSubmit = useOnSubmit(repairQuote, close, sendRfq),
      onSubmit = _useOnSubmit.onSubmit;

  var _company = repairQuote.company,
      _contact = repairQuote.contact,
      initialValues = _objectWithoutProperties(repairQuote, ["company", "contact"]);

  var closeAndClear = function closeAndClear() {
    setLineItem(null);
    close();
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components__["C" /* Modal */],
    { open: open, close: closeAndClear },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: closeAndClear }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Update Quote"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Detail_RepairQuotes_Update_Form__["a" /* default */], {
      close: closeAndClear,
      repairQuote: repairQuote,
      initialValues: initialValues,
      onSubmit: onSubmit,
      modal: true
    })
  );
}

Update.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  lineItem: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({ id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number }),
  sendRfq: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  setLineItem: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

function useOnSubmit(repairQuote, close, sendRfq) {
  var _this = this;

  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__hooks__["b" /* useDispatch */])();

  var onSubmit = function () {
    var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data) {
      var _ref4, quote;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].repairQuotes.update(repairQuote.id, data);

            case 2:
              _ref4 = _context.sent;
              quote = _ref4.data;


              __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].success("Success", quote.code + " successfully updated.");
              dispatch(__WEBPACK_IMPORTED_MODULE_8__pagination__["e" /* repairQuotesPagination */].pageActions.expire());

              window.scrollTo(0, 0);

              if (data.sendRfq) {
                sendRfq(quote.repair_quote_line_item);
              }

              close();

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function onSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return { onSubmit: onSubmit };
}

/***/ }),
/* 2243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RepairQuoteLineItems__ = __webpack_require__(2241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RepairQuoteLineItems__["a"]; });



/***/ }),
/* 2244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_BackToPart__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table__ = __webpack_require__(2245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pagination__ = __webpack_require__(108);
/* unused harmony export SalesOrderLineItems */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













function SalesOrderLineItems(_ref) {
  var part = _ref.part;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_10__pagination__["d" /* salesOrdersPagination */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_BackToPart__["a" /* default */], { part: part }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          aggregateField: "non_cancelled_subtotal",
          title: "Sales Order History"
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

SalesOrderLineItems.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    part: state.partDetail.get("part")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_decorators__["h" /* loadRecord */])({
  reducer: "partDetail",
  name: "part",
  action: __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* show */]
})(SalesOrderLineItems)));

/***/ }),
/* 2245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_components_SalesOrderLineItemStatusCell__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OutgoingQuotes_constants__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RepairOrders_constants__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_components_LocationFlag_LocationFlag__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SalesOrders_helpers__ = __webpack_require__(103);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




















function renderRow(result, i, pushHistory) {
  var handleMailto = function handleMailto(e) {
    e.stopPropagation();
  };
  var lineItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(result);
  var exchangeSale = lineItem.get("exchange_sale");
  var afterHoursIcon = lineItem.get("after_hours") && !lineItem.get("internal_outright") ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["F" /* IconText */], { note: "After Hours", margin: "5px", icon: "fa-clock-o" }) : null;
  var internalOutrightIcon = lineItem.get("internal_outright") ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["F" /* IconText */], { text: "io", note: "Internal Outright" }) : null;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()("clickable", {
    "text-muted": lineItem.get(__WEBPACK_IMPORTED_MODULE_15__RepairOrders_constants__["o" /* CANCELLED */]) || lineItem.get(__WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__["j" /* CREDIT_EXCHANGE */])
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: lineItem.get(__WEBPACK_IMPORTED_MODULE_12__constants__["b" /* ID */]),
      className: classes,
      onClick: function onClick() {
        return pushHistory("/sales-orders/" + lineItem.get("sales_order_uuid"));
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      i + 1
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__shared_components_SalesOrderLineItemStatusCell__["a" /* default */],
      {
        shipped: lineItem.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_23" /* SHIPPED */]),
        cancelled: lineItem.get(__WEBPACK_IMPORTED_MODULE_15__RepairOrders_constants__["o" /* CANCELLED */])
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        afterHoursIcon,
        internalOutrightIcon
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.get("sales_order_code")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_date__["b" /* shortDate */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_12__constants__["_7" /* CREATED_AT */]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shared_components__["w" /* CompanyName */], { flattenedCompany: lineItem.toJS() })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.get("contact_name")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        {
          href: "mailto:" + lineItem.get("contact_email"),
          onClick: handleMailto
        },
        lineItem.get("contact_email")
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.get("buyer") && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.getIn(["buyer", "full_name"]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.get("co_buyer") && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.getIn(["co_buyer", "full_name"]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_text__["d" /* getFirstNameLastInitial */])(lineItem.getIn(["seller", "full_name"]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      lineItem.get(__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["o" /* SERIAL_NUMBER */])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__["h" /* CONDITIONS */][lineItem.get("condition")].abbrev
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__shared_components_LocationFlag_LocationFlag__["a" /* default */], {
        location: lineItem.get("store_location_id"),
        transferStatus: lineItem.getIn([__WEBPACK_IMPORTED_MODULE_14__inventories_constants__["_24" /* INVENTORY */], "transfer_status"])
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__SalesOrders_helpers__["a" /* ExchangeIcon */], { lineItem: lineItem.toJS() })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-left" },
      lineItem.get(__WEBPACK_IMPORTED_MODULE_12__constants__["j" /* QUANTITY */])
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      exchangeSale ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_13__OutgoingQuotes_constants__["a" /* EXCHANGE_FEE */])) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_13__OutgoingQuotes_constants__["b" /* PRICE_PER_UNIT */]))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_formatters_currency__["a" /* dollars */])(lineItem.get(__WEBPACK_IMPORTED_MODULE_9__SalesOrders_constants__["k" /* CUSTOMER_DISPLAYED_SUBTOTAL */]))
    )
  );
}

function Table(props) {
  var pushHistory = props.pushHistory,
      isLoading = props.isLoading,
      results = props.results;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_10__shared_components__["s" /* DataTable */],
    { loading: isLoading, numbered: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "SO #"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Date Created"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Customer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Contact"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Email"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Buyer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Co-Buyer"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Seller"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "SN"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "CD"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Store Loc"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Exch"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-left" },
        "QTY"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Price Per Unit"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Total"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r, i) {
        return renderRow(r, i, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_10__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["push"] })(Table));

/***/ }),
/* 2246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SalesOrderLineItems__ = __webpack_require__(2244);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SalesOrderLineItems__["a"]; });



/***/ }),
/* 2247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(761);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_decorators__["j" /* createNew */])(function (open, close) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["k" /* CreatePart */], { open: open, close: close });
}));

/***/ }),
/* 2248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hooks_useDebounce__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TitleWithFilters__ = __webpack_require__(2250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Table__ = __webpack_require__(2249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__NewPart__ = __webpack_require__(2247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pagination__ = __webpack_require__(108);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
























var defaultFilters = [{
  label: "No Sellable Qty",
  filters: {
    sellable_qty: false
  }
}];

var filterTags = [{
  label: "Active Parts",
  key: "active"
}, {
  label: "Sellable Qty",
  key: "sellable_qty",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "No Sellable Qty",
  key: "sellable_qty",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_filters__["a" /* matchesBoolean */])(false)
}];

var ExportButton = function ExportButton(_ref) {
  var searchProps = _ref.searchProps;

  var params = searchProps.paginator.get("filters").toJS();
  var partsTotalCount = searchProps.paginator.get("totalCount");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components__["x" /* Button */],
    {
      onClick: function onClick() {
        if (partsTotalCount > __WEBPACK_IMPORTED_MODULE_9__users_constants__["_6" /* EXPORT_LIMIT */]) {
          __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__["toastr"].info("Processing", "Please check your notifications for completion.");
          __WEBPACK_IMPORTED_MODULE_15__api__["a" /* default */].parts.export(params).then(function () {
            return __WEBPACK_IMPORTED_MODULE_11__lib_submission__["a" /* SUCCESS */];
          });
        } else {
          window.open(__WEBPACK_IMPORTED_MODULE_17__constants__["d" /* API_BASE */] + "/parts/export?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_query_string__["stringify"])(params), "_blank");
          __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__["toastr"].success("Processing Parts Report. Please wait for the PDF to generate.");
        }
      }
    },
    "Export"
  );
};

ExportButton.propTypes = {
  searchProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    paginator: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])
  })
};

var meetsExportCriteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__shared_decorators__["a" /* renderIf */])(function (_ref2) {
  var searchProps = _ref2.searchProps,
      currentUser = _ref2.currentUser;
  return !searchProps.isLoading && (searchProps.paginator.get("totalCount") <= 150 || currentUser.get(__WEBPACK_IMPORTED_MODULE_9__users_constants__["h" /* ROLE */]) === __WEBPACK_IMPORTED_MODULE_9__users_constants__["i" /* ADMIN */]);
});

var DecoratedExportButton = meetsExportCriteria(ExportButton);

function PartsSearch(_ref3) {
  var currentUser = _ref3.currentUser,
      pushHistory = _ref3.pushHistory;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState2 = _slicedToArray(_useState, 2),
      applications = _useState2[0],
      setApplications = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""),
      _useState4 = _slicedToArray(_useState3, 2),
      applicationSearch = _useState4[0],
      setApplicationSearch = _useState4[1];

  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState6 = _slicedToArray(_useState5, 2),
      applicationSearchOpen = _useState6[0],
      setApplicationSearchOpen = _useState6[1];

  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
      _useState8 = _slicedToArray(_useState7, 2),
      allSearchedApplications = _useState8[0],
      setAllSearchedApplications = _useState8[1];

  var args = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__hooks_useDebounce__["a" /* default */])(500, applicationSearch);
  var itHasPermission = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__users_helpers__["e" /* hasPermission */])(currentUser.toJS(), "can_view_active_parts");
  var showActiveParts = itHasPermission;

  var filterOptions = [].concat(defaultFilters);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (applicationSearch.length > 1) {
      Promise.all([__WEBPACK_IMPORTED_MODULE_15__api__["a" /* default */].engines.search({ limit: 100, filter: applicationSearch }).then(function (_ref4) {
        var results = _ref4.data.results;
        return results.map(function (e) {
          return e.model_number;
        });
      }), __WEBPACK_IMPORTED_MODULE_15__api__["a" /* default */].aircrafts.search({ limit: 100, filter: applicationSearch }).then(function (_ref5) {
        var results = _ref5.data.results;
        return results.map(function (e) {
          return e.model_number;
        });
      })]).then(function (models) {
        setAllSearchedApplications(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["uniq"])(allSearchedApplications.concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["flatten"])(models))));

        setApplications(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["flatten"])(models));
      });
    }
  }, [args]);

  var applicationFilters = applications.map(function (k) {
    return {
      label: k,
      filters: _defineProperty({}, ("application_" + k).replace(/-|,|\(|\)| |]/g, "_"), true)
    };
  });

  var applicationTags = allSearchedApplications.map(function (k) {
    return {
      label: k,
      key: ("application_" + k).replace(/-|,|\(|\)| |]/g, "_")
    };
  });

  var tags = filterTags.concat(applicationTags);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_21__pagination__["b" /* partsPagination */], syncWithUrl: true },
    function (searchProps) {
      var filters = searchProps.paginator.toJS().filters;
      var filter = filters.filter;
      var meetsConditions = !!filter && filter.length > 3 || Object.keys(filters).some(function (f) {
        return f.includes("application") && filters[f];
      });

      if (showActiveParts || meetsConditions) {
        filterOptions = [{
          label: "Active Parts",
          filters: {
            active: true
          }
        }, {
          label: "Sellable Qty",
          filters: {
            sellable_qty: true
          }
        }].concat(defaultFilters);
      } else {
        filterOptions = [].concat(defaultFilters);
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Search by typing a Part Number, Part Description, MFG or Cage Code...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/parts/" + r.uuid);
              },
              filters: tags
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DecoratedExportButton, {
              searchProps: searchProps,
              currentUser: currentUser
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["e" /* SearchableFilterSelect */], _extends({}, searchProps, {
              filters: applicationFilters.filter(function (f) {
                return !Object.keys(filters).includes(Object.keys(f.filters)[0]);
              }),
              right: true,
              searchValue: applicationSearch,
              title: "Appl.",
              visible: applicationSearchOpen,
              toggle: function toggle() {
                setApplicationSearchOpen(!applicationSearchOpen);
              },
              searchFilters: function searchFilters(e) {
                return setApplicationSearch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(e, "target.value", ""));
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, {
              filters: filterOptions,
              right: true,
              display: true
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__shared_components__["b" /* Authorized */],
              { permissions: [__WEBPACK_IMPORTED_MODULE_9__users_constants__["_7" /* CAN_ADD_UPDATE_PARTS */]] },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__NewPart__["a" /* default */], null)
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__TitleWithFilters__["a" /* default */], _extends({}, searchProps, { title: "Parts", filters: tags })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

PartsSearch.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function (state) {
  return {
    currentUser: state.session.get(__WEBPACK_IMPORTED_MODULE_9__users_constants__["a" /* USER */])
  };
}, { pushHistory: __WEBPACK_IMPORTED_MODULE_5_react_router_redux__["push"] })(PartsSearch));

/***/ }),
/* 2249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_helpers__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Warnings__ = __webpack_require__(760);
/* unused harmony export Table */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












function renderRow(r, pushHistory) {
  var className = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared_helpers__["a" /* getPartNumberColorClassNameByTierType */])(r.tier_type);
  var engineApplications = r.applications.filter(function (a) {
    return a.type === "EngineApplication";
  });
  var aircraftApplications = r.applications.filter(function (a) {
    return a.type === "AircraftApplication";
  });

  var truncatedAircraftApplications = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["truncate"])(aircraftApplications.map(function (a) {
    return a.label;
  }).join(", "), { length: 40 } // Specify the maximum length explicitly
  );
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: r.id,
      className: "clickable",
      onClick: function onClick() {
        return pushHistory("/parts/" + r.uuid);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["h" /* PartNumber */], { part: r, className: className, showIcon: true })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.description
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.alternate_part_numbers
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.manufacturer
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Warnings__["a" /* default */], { part: r }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.cage
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      truncatedAircraftApplications
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      engineApplications.map(function (a) {
        return a.label;
      }).join(", ")
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_date__["b" /* shortDate */])(r.purchased_at)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_formatters_currency__["a" /* dollars */])(r.manufacturer_list_price, 2, true)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-right" },
      r.sellable_quantity
    )
  );
}

function Table(_ref) {
  var pushHistory = _ref.pushHistory,
      isLoading = _ref.isLoading,
      results = _ref.results;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */],
    { loading: isLoading },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Part Number"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Description"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Alternates"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "MFG"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Warnings"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Cage"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Aircraft Applications"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Engine Applications"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "DOP"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "MLP"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-right" },
        "Sellable Qty"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, pushHistory);
      })
    )
  );
}

Table.propTypes = _extends({
  pushHistory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_7__shared_components__["e" /* SearchPropTypes */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"] })(Table));

/***/ }),
/* 2250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* unused harmony export createFilters */
/* harmony export (immutable) */ __webpack_exports__["a"] = TitleWithFilters;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function createFilters(filters, paginator) {
  return filters.reduce(function (active, f) {
    var value = paginator.getIn(["filters", f.key]);

    var filterActive = f.matchesTarget ? f.matchesTarget(value) : value !== undefined;

    if (filterActive) {
      return active.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])({
        key: f.key,
        label: f.label,
        value: value,
        withAuthorization: f.withAuthorization
      }));
    }

    return active;
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])());
}

function TitleWithFilters(_ref) {
  var children = _ref.children,
      _ref$filters = _ref.filters,
      filters = _ref$filters === undefined ? [] : _ref$filters,
      title = _ref.title,
      paginator = _ref.paginator,
      results = _ref.results,
      pageActions = _ref.pageActions,
      aggregateField = _ref.aggregateField;

  var aggregateReducer = function aggregateReducer(total, currentValue) {
    return total + parseFloat(typeof aggregateField === "function" ? aggregateField(currentValue) : __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(currentValue, aggregateField));
  };

  var activeFilters = createFilters(filters, paginator);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      title,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "small" },
        "\xA0Showing ",
        paginator.get("totalCount"),
        " Item(s)\xA0\xA0"
      ),
      activeFilters.map(function (f, index) {
        var filterTag = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          { key: index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components__["d" /* FilterTag */], {
            label: f.get("label"),
            clear: function clear() {
              if (f.get("key").includes("application") && activeFilters.every(function (a) {
                return [f.get("key"), "active", "sellable_qty"].includes(a.get("key"));
              })) {
                pageActions.setFilter("sellable_qty", undefined);
                pageActions.setFilter("active", undefined);
              }
              pageActions.setFilter(f.get("key"), undefined);
            }
          }),
          "\xA0"
        );

        var withAuthorization = f.get("withAuthorization");

        if (withAuthorization) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__shared_components__["b" /* Authorized */],
            withAuthorization,
            filterTag
          );
        }

        return filterTag;
      }),
      aggregateField && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "float-right" },
        "\xA0Page Total:",
        " ",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(results.reduce(aggregateReducer, 0).toFixed(2)),
        " ",
        "\xA0\xA0",
        __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(paginator.toJS(), "data.sum") !== undefined && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "/\xA0\xA0",
          __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(paginator.toJS(), "data.sum")
        )
      ),
      children
    )
  );
}

TitleWithFilters.propTypes = _extends({
  aggregateField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    matchesTarget: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  })),
  setFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, __WEBPACK_IMPORTED_MODULE_4__shared_components__["e" /* SearchPropTypes */]);

/***/ }),
/* 2251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(2248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });



/***/ }),
/* 2252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_reducer__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__ = __webpack_require__(58);
/* unused harmony export initialState */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  part: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
}).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["a" /* notesInitialState */]).merge(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["b" /* attachmentsInitialState */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _extends(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* SET */], function (state, action) {
  return state.merge({ part: action.part });
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["c" /* createAttachmentReducer */])(__WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].part), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_reducer__["d" /* createNoteReducer */])(__WEBPACK_IMPORTED_MODULE_4__shared_types_resourceTypes__["a" /* default */].part))));

/***/ }),
/* 2253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_decorators__ = __webpack_require__(17);






function AwaitingMfa() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "h1",
    { className: "text-center margin-top-none" },
    "Please Authenticate with your MFA Provider"
  );
}

AwaitingMfa.propTypes = {};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function () {
  return { refreshRate: 5000 };
}, function (dispatch, ownProps) {
  return {
    refresh: function refresh() {
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].session.verifyPush({
        email: ownProps.email,
        password: ownProps.password,
        pushIds: ownProps.pushIds
      }).then(function (_ref) {
        var data = _ref.data;

        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions__["authenticate"])({
          password: ownProps.password,
          email: ownProps.email,
          push_id: data.push_id
        }));
      }).catch(function () {});
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_decorators__["u" /* withPolling */])(AwaitingMfa)));

/***/ }),
/* 2254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__users_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Submitted__ = __webpack_require__(2255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_submission__ = __webpack_require__(49);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }















function ForgotPassword(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      tenant = _useState2[0],
      setTenant = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].session.tenant().then(function (_ref2) {
      var data = _ref2.data;

      setTenant(data);

      return function cleanup() {};
    });
  }, []);

  var success = function success() {
    return setOpen(true);
  };

  var submit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__lib_submission__["b" /* onSuccess */])(props.handleSubmit, success, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "login" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Submitted__["a" /* default */], {
      open: open,
      close: function close() {
        return setOpen(false);
      },
      logoUrl: tenant && tenant.logo_url
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "container-fluid" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "main" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
            { md: 4, mdOffset: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "panel panel-default" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "panel-body" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "text-center" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: tenant && tenant.logo_url, alt: "Logo" })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h1",
                  { className: "text-center margin-top-none" },
                  "Forgot Password?"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "p",
                  { className: "text-center" },
                  "Please enter your email to reset your password."
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "form",
                  { onSubmit: submit },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_8__constants__["T" /* EMAIL */],
                    component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["t" /* LargeInput */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["T" /* EMAIL */]),
                    required: true
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
                      { md: 6, mdOffset: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["B" /* Save */], _extends({}, props, { icon: "fa-unlock", text: "Reset" }))
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_9__users_actions__["k" /* forgot */](data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["reduxForm"])({
  form: "forgotPassword",
  validate: function validate(values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_validate_this__["a" /* validator */])(values, function (f) {
      f.validate(__WEBPACK_IMPORTED_MODULE_8__constants__["T" /* EMAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_7__lib_validation_rules__["a" /* required */]);
    });
  }
})(ForgotPassword)));

/***/ }),
/* 2255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal_Body__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(6);







function Submitted(_ref) {
  var open = _ref.open,
      close = _ref.close,
      logoUrl = _ref.logoUrl;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components_Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: "modal-sm" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components_Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__shared_components_Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Password Reset"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal_Body__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["e" /* Col */],
            { md: 12 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "text-center" },
              logoUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
                src: logoUrl,
                alt: "Logo",
                height: "50px",
                style: { marginBottom: 20 }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "well well-lg" },
              "If we found an account associated with that email address, you will find an email from us in your inbox shortly."
            )
          )
        )
      )
    )
  );
}

Submitted.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  logoUrl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Submitted);

/***/ }),
/* 2256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AwaitingMfa_AwaitingMfa__ = __webpack_require__(2253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* unused harmony export Login */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

















function Login(_ref) {
  var getFieldValue = _ref.getFieldValue,
      loginError = _ref.loginError,
      pushIds = _ref.pushIds,
      props = _objectWithoutProperties(_ref, ["getFieldValue", "loginError", "pushIds"]);

  var alert = loginError && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "alert alert-danger" },
    loginError
  );

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      tenant = _useState2[0],
      setTenant = _useState2[1];

  var passwordField = document.querySelector("#password");
  var handleClickPassword = function handleClickPassword() {
    var type = passwordField.getAttribute("type") === "password" ? "text" : "password";
    passwordField.setAttribute("type", type);
  };

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].session.tenant().then(function (_ref2) {
      var data = _ref2.data;

      setTenant(data);

      return function cleanup() {};
    });
  }, []);

  var loginStyle = { display: pushIds ? "none" : "block" };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "login" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "container-fluid" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "main" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
            { md: 4, mdOffset: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "panel panel-default" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "panel-body" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "text-center" },
                  tenant && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: tenant.logo_url, alt: "Logo" })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h1",
                  {
                    className: "text-center margin-top-none",
                    style: loginStyle
                  },
                  "Sign in to get started"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "form",
                  { onSubmit: props.handleSubmit, style: loginStyle },
                  alert,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    name: "email",
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["t" /* LargeInput */],
                    label: "Email",
                    required: true
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    name: "password",
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["t" /* LargeInput */],
                    label: "Password",
                    addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
                      className: "fa fa-fw fa-eye",
                      onClick: handleClickPassword
                    }),
                    type: "password",
                    required: true
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* Link */],
                    { to: "/forgot-password" },
                    "Forgot Password?"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["e" /* Col */],
                      { md: 6, mdOffset: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["B" /* Save */], _extends({}, props, { icon: "fa-unlock", text: "Sign In" }))
                    )
                  )
                ),
                pushIds && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__AwaitingMfa_AwaitingMfa__["a" /* default */], {
                  pushIds: pushIds,
                  email: getFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["T" /* EMAIL */]),
                  password: getFieldValue(__WEBPACK_IMPORTED_MODULE_8__constants__["_11" /* PASSWORD */])
                })
              )
            )
          )
        )
      )
    )
  );
}

Login.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  loginError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Login.defaultProps = { loginError: null };

var actions = { onSubmit: __WEBPACK_IMPORTED_MODULE_6__actions__["authenticate"] };

var validate = function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate(__WEBPACK_IMPORTED_MODULE_8__constants__["T" /* EMAIL */], __WEBPACK_IMPORTED_MODULE_8__constants__["_11" /* PASSWORD */]).satisfies(__WEBPACK_IMPORTED_MODULE_5__lib_validation_rules__["a" /* required */]);
  });
};

var select = function select(state) {
  return {
    loginError: state.session.get("loginError"),
    pushIds: state.session.get("pushId")
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(select, actions)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reduxForm"])({
  form: "login",
  validate: validate
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(Login))));

/***/ }),
/* 2257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Login__ = __webpack_require__(2256);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Login__["a"]; });



/***/ }),
/* 2258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(131);
/* unused harmony export Logout */





function Logout(_ref) {
  var logout = _ref.logout;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "a",
    { onClick: logout, type: "button", role: "button" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-btn fa-sign-out" }),
    "Logout"
  );
}

Logout.propTypes = {
  logout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, __WEBPACK_IMPORTED_MODULE_3__actions__)(Logout));

/***/ }),
/* 2259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logout__ = __webpack_require__(2258);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Logout__["a"]; });



/***/ }),
/* 2260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users_constants__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
















function ResetPassword(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
      _useState2 = _slicedToArray(_useState, 2),
      tenant = _useState2[0],
      setTenant = _useState2[1];

  var passwordField = document.querySelector("#password");
  var passwordConfirmationField = document.querySelector("#password_confirmation");
  var handleClickPassword = function handleClickPassword() {
    var type = passwordField.getAttribute("type") === __WEBPACK_IMPORTED_MODULE_8__constants__["_11" /* PASSWORD */] ? "text" : __WEBPACK_IMPORTED_MODULE_8__constants__["_11" /* PASSWORD */];
    passwordField.setAttribute("type", type);
  };

  var handleClickPasswordConfirmation = function handleClickPasswordConfirmation() {
    var type = passwordConfirmationField.getAttribute("type") === __WEBPACK_IMPORTED_MODULE_8__constants__["_11" /* PASSWORD */] ? "text" : __WEBPACK_IMPORTED_MODULE_8__constants__["_11" /* PASSWORD */];
    passwordConfirmationField.setAttribute("type", type);
  };

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].session.tenant().then(function (_ref2) {
      var data = _ref2.data;

      setTenant(data);

      return function cleanup() {};
    });
  }, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "login" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "container-fluid" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "main" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
            { md: 4, mdOffset: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "panel panel-default" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "panel-body" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "text-center" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: tenant && tenant.logo_url, alt: "Logo" })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h1",
                  { className: "text-center margin-top-none" },
                  "Enter New Password"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "form",
                  { onSubmit: props.handleSubmit },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_8__constants__["_11" /* PASSWORD */],
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["t" /* LargeInput */],
                    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["_11" /* PASSWORD */]),
                    addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
                      className: "fa fa-fw fa-eye",
                      onClick: handleClickPassword
                    }),
                    type: __WEBPACK_IMPORTED_MODULE_8__constants__["_11" /* PASSWORD */],
                    required: true
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                    name: __WEBPACK_IMPORTED_MODULE_8__constants__["_100" /* PASSWORD_CONFIRMATION */],
                    component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["t" /* LargeInput */],
                    label: "Confirm Password",
                    addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
                      className: "fa fa-fw fa-eye",
                      onClick: handleClickPasswordConfirmation
                    }),
                    type: __WEBPACK_IMPORTED_MODULE_8__constants__["_11" /* PASSWORD */],
                    required: true
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "div",
                    { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
                      { md: 6, mdOffset: 3 },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["B" /* Save */], _extends({}, props, { icon: "fa-unlock", text: "Reset" }))
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  );
}

ResetPassword.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  loginError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var actions = { onSubmit: __WEBPACK_IMPORTED_MODULE_6__users_actions__["j" /* reset */] };

var validate = function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate(__WEBPACK_IMPORTED_MODULE_8__constants__["_11" /* PASSWORD */], __WEBPACK_IMPORTED_MODULE_8__constants__["_100" /* PASSWORD_CONFIRMATION */]).satisfies(__WEBPACK_IMPORTED_MODULE_5__lib_validation_rules__["a" /* required */]);
    v.validate(__WEBPACK_IMPORTED_MODULE_8__constants__["_100" /* PASSWORD_CONFIRMATION */]).satisfies(__WEBPACK_IMPORTED_MODULE_5__lib_validation_rules__["i" /* matches */](__WEBPACK_IMPORTED_MODULE_8__constants__["_11" /* PASSWORD */]));
  });
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state, props) {
  var searchParams = new URLSearchParams(props.location.search);

  return {
    initialValues: {
      reset_password_token: searchParams.get(__WEBPACK_IMPORTED_MODULE_12__users_constants__["_31" /* RESET_PASSWORD_TOKEN */]),
      email: searchParams.get(__WEBPACK_IMPORTED_MODULE_8__constants__["T" /* EMAIL */])
    }
  };
}, actions)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["reduxForm"])({
  form: "resetPassword",
  validate: validate
})(ResetPassword)));

/***/ }),
/* 2261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Login__ = __webpack_require__(2257);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Login__["a"]; });



/***/ }),
/* 2262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__session__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(276);
/* unused harmony export initialState */
/* unused harmony export setLocations */
/* unused harmony export refreshSalesCart */
var _Map, _resolveEach;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])((_Map = {
  user: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  settings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  loginError: null,
  pushId: null
}, _defineProperty(_Map, __WEBPACK_IMPORTED_MODULE_2__users_constants__["d" /* BOOKMARKS */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()), _defineProperty(_Map, __WEBPACK_IMPORTED_MODULE_2__users_constants__["c" /* REPAIR_CART_ITEMS */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()), _defineProperty(_Map, __WEBPACK_IMPORTED_MODULE_2__users_constants__["b" /* SALES_CART_ITEMS */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()), _defineProperty(_Map, __WEBPACK_IMPORTED_MODULE_2__users_constants__["_29" /* CACHED_SALES_CART */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()), _Map));

function login(state, action) {
  return state.merge({
    user: action.user,
    settings: action.settings
  });
}

function update(state, action) {
  return state.merge({
    user: action.user
  });
}

function refreshCart(state, action) {
  var _action$user = action.user,
      bookmarks = _action$user.bookmarks,
      repairCartItems = _action$user.repair_order_cart_items,
      salesCartItems = _action$user.sales_order_cart_items,
      cachedSalesCart = _action$user.cached_sales_cart;


  __WEBPACK_IMPORTED_MODULE_3__session__["a" /* default */].setRepairCartItems(repairCartItems);
  __WEBPACK_IMPORTED_MODULE_3__session__["a" /* default */].setSalesCartItems(salesCartItems);
  __WEBPACK_IMPORTED_MODULE_3__session__["a" /* default */].setBookmarks(bookmarks);

  return state.merge({
    bookmarks: bookmarks,
    cachedSalesCart: cachedSalesCart,
    repairCartItems: repairCartItems,
    salesCartItems: salesCartItems
  });
}

function setCarts(state, action) {
  var bookmarks = action.bookmarks,
      repairCartItems = action.repairCartItems,
      salesCartItems = action.salesCartItems;


  __WEBPACK_IMPORTED_MODULE_3__session__["a" /* default */].setRepairCartItems(repairCartItems);
  __WEBPACK_IMPORTED_MODULE_3__session__["a" /* default */].setSalesCartItems(salesCartItems);
  __WEBPACK_IMPORTED_MODULE_3__session__["a" /* default */].setBookmarks(bookmarks);

  return state.merge({
    bookmarks: bookmarks,
    repairCartItems: repairCartItems,
    salesCartItems: salesCartItems
  });
}

function loginError(state, action) {
  return state.set("loginError", action.message);
}

function setPushId(state, action) {
  return state.set("pushId", action.pushId);
}

function setSettings(state, action) {
  var user = state.get(__WEBPACK_IMPORTED_MODULE_2__users_constants__["a" /* USER */]).toJS();
  user.locations = action.locations;
  __WEBPACK_IMPORTED_MODULE_3__session__["a" /* default */].login(user);
  return state.merge({ settings: action.settings, user: user });
}

function setLocations(state, action) {
  var user = state.get(__WEBPACK_IMPORTED_MODULE_2__users_constants__["a" /* USER */]).toJS();
  user.locations = action.locations;
  __WEBPACK_IMPORTED_MODULE_3__session__["a" /* default */].login(user);
  return state.merge({ user: user });
}

function refreshSalesCart(state, action) {
  __WEBPACK_IMPORTED_MODULE_3__session__["a" /* default */].setSalesCartItems(action.salesCartItems);

  return state.merge({
    cachedSalesCart: action.cachedSalesCart,
    salesCartItems: action.salesCartItems
  });
}

function clear() {
  return initialState;
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, (_resolveEach = {}, _defineProperty(_resolveEach, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* LOGIN */], login), _defineProperty(_resolveEach, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["f" /* LOGIN_ERROR */], loginError), _defineProperty(_resolveEach, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["c" /* CLEAR */], clear), _defineProperty(_resolveEach, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["g" /* PUSH_ID */], setPushId), _defineProperty(_resolveEach, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["d" /* REFRESH_CARTS */], refreshCart), _defineProperty(_resolveEach, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["h" /* REFRESH_CACHED_SALES_CARTS */], refreshSalesCart), _defineProperty(_resolveEach, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["j" /* SET_LOCATIONS */], setLocations), _defineProperty(_resolveEach, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["i" /* SET_SETTINGS */], setSettings), _defineProperty(_resolveEach, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["e" /* SET_CARTS */], setCarts), _defineProperty(_resolveEach, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["b" /* UPDATE */], update), _resolveEach)));

/***/ }),
/* 2263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionDropDown__ = __webpack_require__(109);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ActionDropDown__["a"]; });



/***/ }),
/* 2264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* unused harmony export APPROVED */
/* unused harmony export DENIED */
/* harmony export (immutable) */ __webpack_exports__["a"] = ApprovalLabel;
var _STATUS_COMPONENTS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var APPROVED = "approved";
var DENIED = "denied";

function Approved() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "text-success" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-check" }),
    "\xA0Approved"
  );
}

function Denied() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "text-danger" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" }),
    "\xA0Denied"
  );
}

var STATUS_COMPONENTS = (_STATUS_COMPONENTS = {}, _defineProperty(_STATUS_COMPONENTS, APPROVED, Approved), _defineProperty(_STATUS_COMPONENTS, DENIED, Denied), _STATUS_COMPONENTS);

function ApprovalLabel(_ref) {
  var status = _ref.status;

  return status ? STATUS_COMPONENTS[status]() : null;
}

/***/ }),
/* 2265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ApprovalLabel__ = __webpack_require__(2264);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ApprovalLabel__["a"]; });



/***/ }),
/* 2266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Create__ = __webpack_require__(2269);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AddAttachment = function (_Component) {
  _inherits(AddAttachment, _Component);

  function AddAttachment() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddAttachment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddAttachment.__proto__ || Object.getPrototypeOf(AddAttachment)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false,
      type: "attachment",
      dropdownOpen: false
    }, _this.close = function () {
      return _this.setState({ open: false });
    }, _this.toggleDropdown = function () {
      return _this.setState(function (state) {
        return {
          dropdownOpen: !state.dropdownOpen
        };
      });
    }, _this.close = function () {
      return _this.setState({ open: false });
    }, _this.updateType = function (type) {
      return function () {
        return _this.setState({ type: type, open: true, dropdownOpen: false });
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddAttachment, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          multiple = _props.multiple,
          resourceId = _props.resourceId,
          attachmentTypes = _props.attachmentTypes,
          resourceType = _props.resourceType;
      var _state = this.state,
          type = _state.type,
          open = _state.open,
          dropdownOpen = _state.dropdownOpen;

      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn-group pull-right dropdown", {
        open: dropdownOpen
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: classes },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            onClick: this.updateType("attachment"),
            className: "btn btn-primary btn-hollow"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
          "Add",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Create__["a" /* default */], {
            resourceId: resourceId,
            resourceType: resourceType,
            type: type,
            open: open,
            close: this.close,
            multiple: multiple,
            attachmentTypes: attachmentTypes,
            referenceOptions: this.props.referenceOptions
          })
        )
      );
    }
  }]);

  return AddAttachment;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AddAttachment.propTypes = {
  attachmentTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  referenceOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})),
  resourceId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  resourceType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (AddAttachment);

/***/ }),
/* 2267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Lots_constants__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_attachments__ = __webpack_require__(247);
/* unused harmony export AttachmentForm */
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }















function AttachmentForm(props) {
  var attachmentTypes = props.attachmentTypes;
  // Filtering out the 'external_link' key from the attachmentTypes since
  // we need the label for display purposes but do not want it to show up in
  // the dropdown for file-type attachments.
  /* eslint-disable no-unused-vars */

  var external_link = attachmentTypes.external_link,
      filteredAttachmentTypes = _objectWithoutProperties(attachmentTypes, ["external_link"]);
  /* eslint-enable no-unused-vars */


  var orderedAttachments = Object.keys(filteredAttachmentTypes).sort(function (a, b) {
    return filteredAttachmentTypes[a].label.localeCompare(filteredAttachmentTypes[b].label);
  }).reduce(function (obj, key) {
    obj[key] = filteredAttachmentTypes[key];
    return obj;
  }, {});

  var attachmentOptions = ["incoming_quotes", "outgoing_quotes", "inventories", "companies", "sales_orders", "purchase_orders", "outgoing_quotes", "incoming_quotes", "rmas"].includes(props.resourceType) ? filteredAttachmentTypes : orderedAttachments;

  var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_forms__["a" /* toOptions */])(Object.assign(attachmentOptions, {
    other: {
      label: "Other"
    }
  }));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
        name: __WEBPACK_IMPORTED_MODULE_6__constants__["n" /* ATTACHMENT_TYPE */],
        component: __WEBPACK_IMPORTED_MODULE_5__Forms__["c" /* Select */],
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["n" /* ATTACHMENT_TYPE */]),
        options: options,
        required: true
      }),
      props.getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["n" /* ATTACHMENT_TYPE */]) === __WEBPACK_IMPORTED_MODULE_9__Lots_constants__["e" /* OTHER */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
        name: __WEBPACK_IMPORTED_MODULE_7__parts_constants__["u" /* DESCRIPTION */],
        component: __WEBPACK_IMPORTED_MODULE_5__Forms__["d" /* FormInput */],
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_7__parts_constants__["u" /* DESCRIPTION */]),
        required: true
      }),
      props.referenceOptions && props.referenceOptions.length > 2 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
        name: __WEBPACK_IMPORTED_MODULE_6__constants__["_6" /* REFERENCE_NUMBER */],
        component: __WEBPACK_IMPORTED_MODULE_5__Forms__["c" /* Select */],
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["_6" /* REFERENCE_NUMBER */]),
        options: props.referenceOptions,
        required: true
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
        name: "file",
        component: __WEBPACK_IMPORTED_MODULE_5__Forms__["k" /* FileInput */],
        label: "Upload Attachment",
        multiple: props.multiple,
        required: true
      })
    )
  );
}

AttachmentForm.propTypes = __WEBPACK_IMPORTED_MODULE_5__Forms__["o" /* FormTypes */].modalForm;

function validate(values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_validate_this__["a" /* validator */])(values, function (f) {
    f.validate("file", __WEBPACK_IMPORTED_MODULE_6__constants__["n" /* ATTACHMENT_TYPE */]).satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["a" /* required */]);
    if (props.referenceOptions && props.referenceOptions.length > 2) {
      f.validate(__WEBPACK_IMPORTED_MODULE_6__constants__["_6" /* REFERENCE_NUMBER */]).satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["a" /* required */]);
    }
    if (values.attachment_type === __WEBPACK_IMPORTED_MODULE_9__Lots_constants__["e" /* OTHER */]) {
      f.validate(__WEBPACK_IMPORTED_MODULE_7__parts_constants__["u" /* DESCRIPTION */]).satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["a" /* required */]);
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      if (ownProps.multiple) {
        return dispatch(__WEBPACK_IMPORTED_MODULE_12__actions_attachments__["c" /* multiUpload */](ownProps.resourceId, ownProps.resourceType, data)).then(function () {
          return ownProps.close();
        });
      }
      return dispatch(__WEBPACK_IMPORTED_MODULE_12__actions_attachments__["d" /* upload */](ownProps.resourceId, ownProps.resourceType, data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Forms__["j" /* form */])({
  form: "attachmentForm",
  validate: validate
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__decorators_withFieldAccessors__["a" /* withFieldAccessors */])(AttachmentForm))));

/***/ }),
/* 2268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_attachments__ = __webpack_require__(247);
/* unused harmony export AttachmentType */
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









function AttachmentType(props) {
  var attachmentTypes = props.attachmentTypes;
  // Filtering out the 'external_link' key from the attachmentTypes since
  // we need the label for display purposes but do not want it to show up in
  // the dropdown for file-type attachments.
  /* eslint-disable no-unused-vars */

  var external_link = attachmentTypes.external_link,
      filteredAttachmentTypes = _objectWithoutProperties(attachmentTypes, ["external_link"]);
  /* eslint-enable no-unused-vars */


  var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_forms__["a" /* toOptions */])(Object.assign(filteredAttachmentTypes, {
    other: {
      label: "Other"
    }
  }));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
        name: __WEBPACK_IMPORTED_MODULE_4__constants__["n" /* ATTACHMENT_TYPE */],
        component: __WEBPACK_IMPORTED_MODULE_3__Forms__["c" /* Select */],
        label: "Attachment Type",
        options: options,
        required: true
      })
    )
  );
}

AttachmentType.propTypes = __WEBPACK_IMPORTED_MODULE_3__Forms__["o" /* FormTypes */].modalForm;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions_attachments__["e" /* update */](ownProps.id, ownProps.resourceType, data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Forms__["j" /* form */])({
  form: "attachmentForm"
})(AttachmentType)));

/***/ }),
/* 2269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AttachmentForm__ = __webpack_require__(2267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LinkForm__ = __webpack_require__(2272);
/* harmony export (immutable) */ __webpack_exports__["a"] = Create;







var forms = {
  attachment: __WEBPACK_IMPORTED_MODULE_3__AttachmentForm__["a" /* default */],
  link: __WEBPACK_IMPORTED_MODULE_4__LinkForm__["a" /* default */]
};

function Create(_ref) {
  var attachmentTypes = _ref.attachmentTypes,
      close = _ref.close,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === undefined ? false : _ref$multiple,
      open = _ref.open,
      referenceOptions = _ref.referenceOptions,
      resourceId = _ref.resourceId,
      resourceType = _ref.resourceType,
      type = _ref.type;

  var Form = forms[type];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-sm" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Add a ",
          type === "link" ? "Link" : "File"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Form, {
        resourceType: resourceType,
        resourceId: resourceId,
        close: close,
        attachmentTypes: attachmentTypes,
        multiple: multiple,
        referenceOptions: referenceOptions
      })
    )
  );
}

Create.propTypes = {
  attachmentTypes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  referenceOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  resourceId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  resourceType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 2270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_attachments__ = __webpack_require__(247);
/* unused harmony export Delete */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Delete = function (_Component) {
  _inherits(Delete, _Component);

  function Delete() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Delete);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Delete.__proto__ || Object.getPrototypeOf(Delete)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.open = function () {
      return _this.setState({ open: true });
    }, _this.close = function () {
      return _this.setState({ open: false });
    }, _this.destroy = function () {
      var _this$props = _this.props,
          attachment = _this$props.attachment,
          destroy = _this$props.destroy,
          resourceType = _this$props.resourceType;

      destroy(attachment.get("id"), resourceType);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Delete, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          { className: "btn-link", onClick: this.open },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "text-danger" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-close" }),
            this.props.label
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4____["q" /* ConfirmDelete */],
          {
            onConfirm: this.destroy,
            close: this.close,
            open: this.state.open
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          " Are you sure you want to delete this?"
        )
      );
    }
  }]);

  return Delete;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Delete.propTypes = {
  attachment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired,
  destroy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resourceType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, { destroy: __WEBPACK_IMPORTED_MODULE_5__actions_attachments__["f" /* destroyAttachment */] })(Delete));

/***/ }),
/* 2271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AttachmentType__ = __webpack_require__(2268);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var EditAttachment = function (_Component) {
  _inherits(EditAttachment, _Component);

  function EditAttachment() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EditAttachment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditAttachment.__proto__ || Object.getPrototypeOf(EditAttachment)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.close = function () {
      return _this.setState({ open: false });
    }, _this.openModal = function () {
      return _this.setState({ open: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditAttachment, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          attachmentType = _props.attachmentType,
          id = _props.id,
          resourceType = _props.resourceType,
          attachmentTypes = _props.attachmentTypes;
      var open = this.state.open;

      var initialValues = {
        attachment_type: attachmentType
      };

      var attachmentTypeOptions = resourceType === "companies" ? attachmentTypes : __WEBPACK_IMPORTED_MODULE_3__inventories_constants__["Z" /* ATTACHMENT_TYPES */];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          { className: "btn-link", onClick: this.openModal },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["k" /* Icon */], { name: "pencil", fixed: true }),
          "Edit Attachment Type",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__Modal__["a" /* Modal */],
            { open: open, close: this.close, dialogClass: "modal-sm" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__Modal__["b" /* Header */],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modal__["c" /* Close */], { close: this.close }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "h4",
                { className: "modal-title" },
                "Edit Attachment Type"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AttachmentType__["a" /* default */], {
              id: id,
              close: this.close,
              resourceType: resourceType,
              attachmentTypes: attachmentTypeOptions,
              initialValues: initialValues
            })
          )
        )
      );
    }
  }]);

  return EditAttachment;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

EditAttachment.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  resourceType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  attachmentType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (EditAttachment);

/***/ }),
/* 2272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_attachments__ = __webpack_require__(247);
/* unused harmony export LinkForm */








function LinkForm(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: "link_url", component: __WEBPACK_IMPORTED_MODULE_5__Forms__["d" /* FormInput */], label: "Link URL" })
    )
  );
}

LinkForm.propTypes = __WEBPACK_IMPORTED_MODULE_5__Forms__["o" /* FormTypes */].modalForm;

function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_validate_this__["a" /* validator */])(values, function (f) {
    f.validate("link_url").satisfies(__WEBPACK_IMPORTED_MODULE_4__lib_validation_rules__["a" /* required */]);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions_attachments__["b" /* link */](ownProps.resourceId, ownProps.resourceType, data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Forms__["j" /* form */])({
  form: "attachmentForm",
  validate: validate
})(LinkForm)));

/***/ }),
/* 2273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AuditFields__ = __webpack_require__(477);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AuditFields__["a"]; });



/***/ }),
/* 2274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__users_constants__ = __webpack_require__(13);



function AuthorizedOwner(_ref) {
  var user = _ref.user,
      admin = _ref.admin,
      record = _ref.record,
      children = _ref.children;

  var authorized = admin || record.getIn(["created_by", "id"]) === user.get("id");

  return authorized ? children : false;
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
  var user = state.session.getIn(["user"]);
  return {
    user: user,
    admin: __WEBPACK_IMPORTED_MODULE_1__users_constants__["i" /* ADMIN */] === user.get("role")
  };
})(AuthorizedOwner));

/***/ }),
/* 2275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = Button;



function Button(_ref) {
  var _ref$buttonClass = _ref.buttonClass,
      buttonClass = _ref$buttonClass === undefined ? "btn-info" : _ref$buttonClass,
      children = _ref.children,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      _ref$spanClass = _ref.spanClass,
      spanClass = _ref$spanClass === undefined ? "input-group-btn" : _ref$spanClass;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: spanClass },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      { className: "btn " + buttonClass, onClick: onClick },
      children
    )
  );
}

Button.propTypes = {
  buttonClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)]),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  spanClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 2276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(2275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["a"]; });


/***/ }),
/* 2277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_clipboard_js__ = __webpack_require__(3046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ClipboardCopy = function (_React$Component) {
  _inherits(ClipboardCopy, _React$Component);

  function ClipboardCopy(props) {
    _classCallCheck(this, ClipboardCopy);

    var _this = _possibleConstructorReturn(this, (ClipboardCopy.__proto__ || Object.getPrototypeOf(ClipboardCopy)).call(this, props));

    _this.getTarget = _this.getTarget.bind(_this);
    _this.handleTooltip = _this.handleTooltip.bind(_this);
    _this.handleCloseTooltip = _this.handleCloseTooltip.bind(_this);
    _this.state = {
      show: false
    };
    return _this;
  }

  _createClass(ClipboardCopy, [{
    key: "getTarget",
    value: function getTarget() {
      return this.target;
    }
  }, {
    key: "handleTooltip",
    value: function handleTooltip() {
      if (this.props.handleClick) {
        this.props.handleClick();
      }

      this.setState({ show: true });
    }
  }, {
    key: "handleCloseTooltip",
    value: function handleCloseTooltip() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({ show: false });
      }, 900);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          name = _props.name,
          type = _props.type,
          iconFontSize = _props.iconFontSize;


      if (!name) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_clipboard_js___default.a,
        {
          "data-clipboard-text": name,
          "button-title": "Copy " + type + " to Clipboard",
          style: { background: "none", border: "none" },
          onClick: this.handleTooltip
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
          className: "fa fa-clipboard fa-xs",
          style: { fontSize: iconFontSize },
          ref: function ref(button) {
            _this3.target = button;
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* Overlay */],
          {
            target: this.getTarget,
            show: this.state.show,
            placement: "top",
            onEntered: this.handleCloseTooltip
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["b" /* Tooltip */],
            null,
            "Copied!"
          )
        )
      );
    }
  }]);

  return ClipboardCopy;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ClipboardCopy);


ClipboardCopy.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  iconFontSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  handleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

ClipboardCopy.defaultProps = {
  iconFontSize: ".75em"
};

/***/ }),
/* 2278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_number__ = __webpack_require__(72);
/* harmony export (immutable) */ __webpack_exports__["a"] = CoBuyerField;







function CoBuyerField(_ref) {
  var buyerCreditPct = _ref.buyerCreditPct,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      numberOfBuyers = _ref.numberOfBuyers,
      searchBuyers = _ref.searchBuyers,
      selectedCoBuyer = _ref.selectedCoBuyer,
      toggleBuyer = _ref.toggleBuyer;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_4__users_constants__["z" /* CO_BUYER_ID */],
    label: "Co-Buyer and Credit",
    placeholder: "Search by name...",
    component: __WEBPACK_IMPORTED_MODULE_3__Forms__["n" /* AutoCompleteField */],
    search: searchBuyers,
    selectedItem: selectedCoBuyer,
    onItemSelected: function onItemSelected(item) {
      return toggleBuyer({ selectedCoBuyer: item });
    },
    formatItem: function formatItem(result) {
      return result && result.full_name;
    },
    append: selectedCoBuyer ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_number__["c" /* displayDecimal */])(buyerCreditPct / numberOfBuyers, 100),
      "%"
    ) : null,
    disabled: disabled
  });
}

CoBuyerField.propTypes = {
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  numberOfBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedCoBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  toggleBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 2279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CoBuyerField__ = __webpack_require__(2278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThirdBuyerField__ = __webpack_require__(2280);
/* unused harmony export createBuyersContext */








var createBuyersContext = function createBuyersContext(selectedCoBuyer, selectedThirdBuyer, toggleBuyer) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({
    selectedCoBuyer: selectedCoBuyer,
    selectedThirdBuyer: selectedThirdBuyer,
    toggleBuyer: toggleBuyer
  });
};

function CoBuyersFields(_ref) {
  var buyerCreditPct = _ref.buyerCreditPct,
      _ref$colSize = _ref.colSize,
      colSize = _ref$colSize === undefined ? 6 : _ref$colSize,
      disabled = _ref.disabled,
      numberOfBuyers = _ref.numberOfBuyers,
      searchBuyers = _ref.searchBuyers,
      selectedCoBuyer = _ref.selectedCoBuyer,
      selectedThirdBuyer = _ref.selectedThirdBuyer,
      toggleBuyer = _ref.toggleBuyer;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
    { md: colSize },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CoBuyerField__["a" /* default */], {
      buyerCreditPct: buyerCreditPct,
      searchBuyers: searchBuyers,
      selectedCoBuyer: selectedCoBuyer,
      selectedThirdBuyer: selectedThirdBuyer,
      disabled: disabled,
      numberOfBuyers: numberOfBuyers,
      toggleBuyer: toggleBuyer
    })
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
    { md: colSize },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ThirdBuyerField__["a" /* default */], {
      buyerCreditPct: buyerCreditPct,
      disabled: disabled,
      numberOfBuyers: numberOfBuyers,
      searchBuyers: searchBuyers,
      selectedCoBuyer: selectedCoBuyer,
      selectedThirdBuyer: selectedThirdBuyer,
      toggleBuyer: toggleBuyer
    })
  )];
}

CoBuyersFields.propTypes = {
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  numberOfBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedCoBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  selectedThirdBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, function (dispatch) {
  return {
    searchBuyers: function searchBuyers(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_actions__["c" /* searchBuyers */](filter));
    }
  };
})(CoBuyersFields));

/***/ }),
/* 2280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_constants__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = ThirdBuyerField;






function ThirdBuyerField(_ref) {
  var buyerCreditPct = _ref.buyerCreditPct,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      numberOfBuyers = _ref.numberOfBuyers,
      searchBuyers = _ref.searchBuyers,
      selectedThirdBuyer = _ref.selectedThirdBuyer,
      toggleBuyer = _ref.toggleBuyer;

  if ([25, 50].includes(parseFloat(buyerCreditPct)) || numberOfBuyers < 2) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_4__users_constants__["y" /* THIRD_BUYER_ID */],
    label: "Third Buyer and Credit",
    placeholder: "Search by name...",
    component: __WEBPACK_IMPORTED_MODULE_3__Forms__["n" /* AutoCompleteField */],
    search: searchBuyers,
    selectedItem: selectedThirdBuyer,
    onItemSelected: function onItemSelected(item) {
      return toggleBuyer({ selectedThirdBuyer: item });
    },
    formatItem: function formatItem(result) {
      return result && result.full_name;
    },
    append: selectedThirdBuyer ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      null,
      parseInt(buyerCreditPct / numberOfBuyers, 10),
      "%"
    ) : null,
    disabled: disabled
  });
}

ThirdBuyerField.propTypes = {
  buyerCreditPct: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  numberOfBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  searchBuyers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedThirdBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  toggleBuyer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_countries__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_states__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ManagedRepairOrders_actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Contact__ = __webpack_require__(482);
/* unused harmony export countryOptions */
/* unused harmony export FreightForwarderAddressFields */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var countryOptions = __WEBPACK_IMPORTED_MODULE_7__lib_countries__["a" /* default */].map(function (c) {
  return {
    value: c.code,
    text: c.name
  };
});

var renderStateField = function renderStateField(country, path) {
  var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return country === "US" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
    name: path + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["v" /* STATE */],
    component: __WEBPACK_IMPORTED_MODULE_6__Forms__["c" /* Select */],
    options: __WEBPACK_IMPORTED_MODULE_8__lib_states__["a" /* states */],
    label: "State/Province",
    required: required
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
    name: path + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["v" /* STATE */],
    component: __WEBPACK_IMPORTED_MODULE_6__Forms__["d" /* FormInput */],
    label: "State/Province",
    required: required
  });
};

var FreightForwarderAddressFields = function (_React$Component) {
  _inherits(FreightForwarderAddressFields, _React$Component);

  function FreightForwarderAddressFields() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FreightForwarderAddressFields);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FreightForwarderAddressFields.__proto__ || Object.getPrototypeOf(FreightForwarderAddressFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      newCompany: false,
      existingCompany: true,
      activeCompany: "existing",
      selectedCompany: _this.props.freightForwarder
    }, _this.handleNewCompany = function () {
      _this.setState({
        activeCompany: "new",
        newCompany: true,
        existingCompany: false,
        selectedCompany: null
      });
      _this.props.clearFreightForwarderFields();
    }, _this.handleExistingCompany = function () {
      _this.setState({
        activeCompany: "existing",
        newCompany: false,
        existingCompany: true,
        selectedCompany: null
      });
      _this.props.clearFreightForwarderFields();
    }, _this.handleCompanySelection = function (selectedCompany) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          formName = _this$props.formName,
          path = _this$props.path;

      _this.setState({ selectedCompany: selectedCompany });

      if (selectedCompany) {
        var fields = [__WEBPACK_IMPORTED_MODULE_10__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_10__constants__["t" /* LINE2 */], __WEBPACK_IMPORTED_MODULE_10__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_10__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_10__constants__["w" /* POSTAL_CODE */], __WEBPACK_IMPORTED_MODULE_10__constants__["r" /* COUNTRY */]];
        var addressObj = selectedCompany.primary_physical_address || selectedCompany.billing_address;

        fields.forEach(function (field) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(formName, path + "." + field, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(addressObj, field, "") // fallback to ""
          ));
        });
      }
    }, _this.formatItem = function (result) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(result, "name", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(result, "company_name"))) return null;
      var label = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_11__companies_constants__["h" /* APPROVAL_STATUSES */], result.vendor_status + ".label");
      return "" + (result.name || result.company_name || "") + (label ? " (" + label + ")" : "");
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FreightForwarderAddressFields, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.country && nextProps.country !== this.props.country) {
        this.props.resetStateField();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          path = _props.path,
          country = _props.country,
          required = _props.required;
      var _state = this.state,
          newCompany = _state.newCompany,
          selectedCompany = _state.selectedCompany;


      var activeExistingCompany = __WEBPACK_IMPORTED_MODULE_13_classnames___default()("btn btn-default", {
        active: this.state.activeCompany === "existing"
      });
      var activeNewCompany = __WEBPACK_IMPORTED_MODULE_13_classnames___default()("btn btn-default", {
        active: this.state.activeCompany === "new"
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "form-group" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  className: "btn-group btn-group-justified",
                  "data-toggle": "buttons",
                  role: "group"
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    className: activeExistingCompany,
                    onClick: this.handleExistingCompany
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
                  "\xA0\xA0Existing Company"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  {
                    className: activeNewCompany,
                    onClick: this.handleNewCompany
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
                  "\xA0\xA0New Company"
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              null,
              "Physical Address"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 6 },
            newCompany ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["x" /* COMPANY_NAME */],
              label: "New Company Name",
              placeholder: "New Company Name",
              component: __WEBPACK_IMPORTED_MODULE_6__Forms__["d" /* FormInput */],
              required: true
            }) : null,
            this.state.existingCompany && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["N" /* COMPANY_ID */],
              label: "Existing Company Name",
              placeholder: "Search by typing a company's name or code",
              component: __WEBPACK_IMPORTED_MODULE_6__Forms__["n" /* AutoCompleteField */],
              search: this.props.searchCompanies,
              selectedItem: selectedCompany,
              formatItem: this.formatItem,
              required: required,
              onItemSelected: this.handleCompanySelection
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["r" /* COUNTRY */],
              component: __WEBPACK_IMPORTED_MODULE_6__Forms__["c" /* Select */],
              label: "Country",
              options: countryOptions,
              required: true
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["s" /* LINE1 */],
              component: __WEBPACK_IMPORTED_MODULE_6__Forms__["d" /* FormInput */],
              label: "Address Line 1",
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 6 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["t" /* LINE2 */],
              component: __WEBPACK_IMPORTED_MODULE_6__Forms__["d" /* FormInput */],
              label: "Address Line 2"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 5 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["u" /* CITY */],
              component: __WEBPACK_IMPORTED_MODULE_6__Forms__["d" /* FormInput */],
              label: "City",
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 4 },
            renderStateField(country, path, country === "US")
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
            { md: 3 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["Field"], {
              name: path + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["w" /* POSTAL_CODE */],
              component: __WEBPACK_IMPORTED_MODULE_6__Forms__["d" /* FormInput */],
              label: "Zip/Postal Code",
              required: country === "US"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Contact__["a" /* default */], { path: "freight_forwarder", required: false })
      );
    }
  }]);

  return FreightForwarderAddressFields;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

FreightForwarderAddressFields.propTypes = {
  path: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
  country: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  resetStateField: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  required: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    dispatch: dispatch,

    resetStateField: function resetStateField() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(ownProps.formName, ownProps.path + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["v" /* STATE */], ""));
    },

    searchCompanies: function searchCompanies(filter) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_12__ManagedRepairOrders_actions__["a" /* searchCompanies */](filter));
    },

    /**
       * Clears ALL freight-forwarder fields (company + address).
       * Called whenever the user toggles to "New Company" or "Existing Company."
       */
    clearFreightForwarderFields: function clearFreightForwarderFields() {
      var p = ownProps.path;
      var f = ownProps.formName;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(f, p + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["N" /* COMPANY_ID */], null));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(f, p + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["x" /* COMPANY_NAME */], ""));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(f, p + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["s" /* LINE1 */], ""));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(f, p + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["t" /* LINE2 */], ""));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(f, p + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["u" /* CITY */], ""));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(f, p + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["v" /* STATE */], ""));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(f, p + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["w" /* POSTAL_CODE */], ""));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux_form__["change"])(f, p + "." + __WEBPACK_IMPORTED_MODULE_10__constants__["r" /* COUNTRY */], ""));
    }
  };
})(FreightForwarderAddressFields));

/***/ }),
/* 2282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__decorators_withFormFields__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_components_shared_Weight__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_components_shared_ConvertedWeight__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parts_constants__ = __webpack_require__(23);
/* unused harmony export InvoiceWeight */









function InvoiceWeight(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === undefined ? "Weight" : _ref$label,
      weight = _ref.weight,
      weight_unit = _ref.weight_unit,
      _ref$required = _ref.required,
      required = _ref$required === undefined ? true : _ref$required;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
    { md: 3 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__parts_components_shared_Weight__["a" /* default */], { required: required, label: label })
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
    { md: 2 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__parts_components_shared_ConvertedWeight__["a" /* default */], {
      unit: weight_unit.input.value,
      weight: weight.input.value
    })
  )];
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__decorators_withFormFields__["a" /* default */])(InvoiceWeight, [__WEBPACK_IMPORTED_MODULE_7__parts_constants__["j" /* WEIGHT */], __WEBPACK_IMPORTED_MODULE_7__parts_constants__["n" /* WEIGHT_UNIT */]]));

InvoiceWeight.propTypes = {
  weight: __WEBPACK_IMPORTED_MODULE_2__Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_2__Forms_FormTypes__["malleable"]).isRequired,
  weight_unit: __WEBPACK_IMPORTED_MODULE_2__Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_2__Forms_FormTypes__["stringInput"]).isRequired,
  required: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

/***/ }),
/* 2283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__decorators_withFormFields__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parts_components_shared_NetWeight__ = __webpack_require__(764);
/* unused harmony export NetInvoiceWeight */








function NetInvoiceWeight(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === undefined ? "Weight" : _ref$label,
      weight = _ref.weight,
      weightOz = _ref.weight_oz,
      weightUnit = _ref.weight_unit;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
    { md: 3 },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__parts_components_shared_NetWeight__["b" /* NetWeight */], {
      required: false,
      label: label,
      net_weight: weight,
      net_weight_oz: weightOz,
      net_weight_unit: weightUnit
    })
  )];
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__decorators_withFormFields__["a" /* default */])(NetInvoiceWeight, [__WEBPACK_IMPORTED_MODULE_5__parts_constants__["j" /* WEIGHT */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["N" /* WEIGHT_OZ */], __WEBPACK_IMPORTED_MODULE_5__parts_constants__["n" /* WEIGHT_UNIT */]]));

NetInvoiceWeight.propTypes = {
  weight: __WEBPACK_IMPORTED_MODULE_2__Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_2__Forms_FormTypes__["malleable"]).isRequired,
  weight_oz: __WEBPACK_IMPORTED_MODULE_2__Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_2__Forms_FormTypes__["malleable"]).isRequired,
  weight_unit: __WEBPACK_IMPORTED_MODULE_2__Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_2__Forms_FormTypes__["stringInput"]).isRequired,
  required: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

/***/ }),
/* 2284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shipping_constants__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AddressFields__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NetInvoiceWeight__ = __webpack_require__(2283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_components_DashedSeparator_DashedSeparator__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_components_Forms_CurrencyField_CurrencyField__ = __webpack_require__(347);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var ECCNS = ["7A994", "9A991.C", "9A991.D", "9A991"];

var ECCNWarning = function ECCNWarning(_ref) {
  var lineItem = _ref.lineItem,
      getField = _ref.getField;

  var eccnValue = (getField(lineItem + ".european_commerce_control_number") || "").toUpperCase();

  if (ECCNS.concat(["", undefined, null]).includes(eccnValue)) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_13__shared_components_Warning_Warning__["a" /* default */],
    null,
    "Warning: Not a standard ECCN. Please confirm if license is reqd."
  );
};

ECCNWarning.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var PartDetails = function (_React$Component) {
  _inherits(PartDetails, _React$Component);

  function PartDetails() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, PartDetails);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = PartDetails.__proto__ || Object.getPrototypeOf(PartDetails)).call.apply(_ref2, [this].concat(args))), _this), _this.normalizeCode = function (value) {
      if (!value) {
        return value;
      }

      var onlyNums = value.replace(/[^\d]/g, "");
      if (onlyNums.length <= 4) {
        return onlyNums;
      }
      if (onlyNums.length <= 6) {
        return onlyNums.slice(0, 4) + "." + onlyNums.slice(4);
      }
      return onlyNums.slice(0, 4) + "." + onlyNums.slice(4, 6) + "." + onlyNums.slice(6, 10);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PartDetails, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var options = [{ value: true, text: "Yes" }, { value: false, text: "No" }];
      var fields = this.props.fields;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        fields.map(function (lineItem) {
          return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: lineItem + ".part_number",
                label: "PN",
                component: __WEBPACK_IMPORTED_MODULE_3__Forms__["d" /* FormInput */],
                disabled: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: lineItem + ".description",
                label: "Desc",
                component: __WEBPACK_IMPORTED_MODULE_3__Forms__["d" /* FormInput */],
                disabled: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: lineItem + ".serial_number",
                label: "Serial #",
                component: __WEBPACK_IMPORTED_MODULE_3__Forms__["d" /* FormInput */],
                disabled: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: lineItem + ".condition",
                component: __WEBPACK_IMPORTED_MODULE_3__Forms__["c" /* Select */],
                options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_7__Shipping_constants__["r" /* CONDITION_TYPES */]),
                label: "Condition Received",
                disabled: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
              { md: 2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                type: "number",
                name: lineItem + ".quantity",
                label: "Qty",
                component: __WEBPACK_IMPORTED_MODULE_3__Forms__["d" /* FormInput */],
                disabled: true
              })
            )
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_redux_form__["FormSection"],
              { name: lineItem },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NetInvoiceWeight__["a" /* default */], { lineItem: lineItem, label: "Net (Part) Weight" })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: lineItem + ".country_of_mfg",
                label: "Country of Mfg.",
                component: __WEBPACK_IMPORTED_MODULE_3__Forms__["c" /* Select */],
                options: __WEBPACK_IMPORTED_MODULE_10__AddressFields__["b" /* countryOptions */],
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: lineItem + "." + __WEBPACK_IMPORTED_MODULE_8__parts_constants__["x" /* SCHEDULE_B_OR_HT_CODE */],
                label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__parts_constants__["x" /* SCHEDULE_B_OR_HT_CODE */]),
                component: __WEBPACK_IMPORTED_MODULE_3__Forms__["d" /* FormInput */],
                normalize: _this2.normalizeCode,
                required: true
              })
            )
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Forms_FormRow__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: lineItem + ".license_required",
                label: "Lic Reqd",
                component: __WEBPACK_IMPORTED_MODULE_3__Forms__["c" /* Select */],
                options: options,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: lineItem + ".european_commerce_control_number",
                label: "Eccn",
                component: __WEBPACK_IMPORTED_MODULE_3__Forms__["d" /* FormInput */],
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["e" /* Col */],
              { md: 3 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
                name: lineItem + ".price",
                label: "Price Per Unit",
                component: __WEBPACK_IMPORTED_MODULE_14__shared_components_Forms_CurrencyField_CurrencyField__["a" /* default */],
                disabled: true
              })
            )
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ECCNWarning, { lineItem: lineItem, getField: _this2.props.getField }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shared_components_DashedSeparator_DashedSeparator__["a" /* default */], null)];
        })
      );
    }
  }]);

  return PartDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (PartDetails);


PartDetails.propTypes = {
  fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  receivingRecord: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shipping_actions__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(173);








var Save = function Save(props) {
  if (!props.salesOrderId) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    {
      disabled: props.submitting,
      type: "button",
      className: "btn btn-primary",
      style: { paddingLeft: "5px", paddingRight: "5px" },
      onClick: function onClick(e) {
        e.preventDefault();
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].salesOrders.commercialInvoice.save(props.salesOrderId, props.values).then(function () {
          props.setCurrentForm ? props.setCurrentForm(__WEBPACK_IMPORTED_MODULE_6__helpers__["c" /* SHIPPING_CHECKLIST */]) : props.close();
          props.reload && props.reload();
        });
      }
    },
    props.submitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cog fa-spin fa-fw fa-lg" }) : "Save"
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state, ownProps) {
  return {
    values: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["getFormValues"])(ownProps.formName)(state)
  };
}, function (dispatch, ownProps) {
  return {
    reload: function reload() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Shipping_actions__["d" /* reloadSilent */])(ownProps.salesOrderDetail));
    }
  };
})(Save));

Save.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  salesOrderId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  setCurrentForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  values: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Warning_Warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(17);
/* unused harmony export CompanyAddressWarning */





function CompanyAddressWarning(_ref) {
  var company = _ref.company;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__Warning_Warning__["a" /* default */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "a",
      { href: "/companies/" + (company && company.id) },
      company && company.name
    ),
    "\xA0does not have a primary shipping and/or billing address. \xA0Please update company information in order to proceed."
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["a" /* renderIf */])(function (_ref2) {
  var company = _ref2.company;
  return company && (!company.primary_physical_address || !company.billing_address);
})(CompanyAddressWarning));

CompanyAddressWarning.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  })
};

/***/ }),
/* 2287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = CompanyName;







// Converts flattened company data into a company object.
//
// Example
// Original data: { id: 1, company_id: 99, company_name: 'Foo Bar', company_company_type: 'repair_station' }
// Returned data: { id: 99, name: 'Foo Bar', company_type: 'repair_station' }
function enhanceCompany(flattenedCompany) {
  return Object.keys(flattenedCompany || {}).filter(function (key) {
    return key.startsWith("company_");
  }).reduce(function (result, key) {
    result[__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.replace(key, /^company_/, "")] = flattenedCompany[key];
    return result;
  }, {});
}

function CompanyName(_ref) {
  var company = _ref.company,
      flattenedCompany = _ref.flattenedCompany,
      statsTooltip = _ref.statsTooltip,
      context = _ref.context,
      truncateAt = _ref.truncateAt;

  var enhancedCompany = company || enhanceCompany(flattenedCompany);

  if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(enhancedCompany)) {
    return false;
  }

  var companyName = truncateAt ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_text__["e" /* truncate */])(enhancedCompany.name, truncateAt) : enhancedCompany.name;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    enhancedCompany.id || enhancedCompany.uuid ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],
      {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        to: "/companies/" + (enhancedCompany.uuid || enhancedCompany.id)
      },
      companyName
    ) : companyName,
    enhancedCompany.id && statsTooltip && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
      null,
      "\xA0",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["g" /* CompanyStatsTooltip */], { company: enhancedCompany, context: context })
    )
  );
}

CompanyName.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    company_type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
  }).isRequired,
  flattenedCompany: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  statsTooltip: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  context: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["standard", "repair"]),
  truncateAt: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
};

CompanyName.defaultProps = {
  statsTooltip: true,
  context: "standard"
};

/***/ }),
/* 2288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CompanyName__ = __webpack_require__(2287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CompanyName__["a"]; });


/***/ }),
/* 2289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon__ = __webpack_require__(792);
/* harmony export (immutable) */ __webpack_exports__["a"] = CheckColumn;




function CheckColumn(_ref) {
  var checked = _ref.checked,
      children = _ref.children,
      icon = _ref.icon,
      text = _ref.text,
      _ref$colorClass = _ref.colorClass,
      colorClass = _ref$colorClass === undefined ? "text-success" : _ref$colorClass,
      _ref$wrapped = _ref.wrapped,
      wrapped = _ref$wrapped === undefined ? true : _ref$wrapped;

  if (!checked) {
    return wrapped ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", null) : null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: colorClass },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon__["a" /* default */], { name: icon, fixed: true }),
    " ",
    text,
    " ",
    children
  );
}

CheckColumn.propTypes = {
  wrapped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)]),
  colorClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 2290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_strings__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NoteTooltip__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Detail__ = __webpack_require__(152);
/* harmony export (immutable) */ __webpack_exports__["a"] = SpecialInstructions;







function SpecialInstructions(_ref) {
  var note = _ref.note,
      _ref$placement = _ref.placement,
      placement = _ref$placement === undefined ? "right" : _ref$placement;

  var display = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_strings__["a" /* default */])(note).empty() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: "text-success" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["k" /* Icon */], { name: "check" }),
    "Yes ",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NoteTooltip__["a" /* NoteTooltip */], { note: note, placement: placement })
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Detail__["a" /* default */], { label: "Special Instructions", value: display });
}

SpecialInstructions.propTypes = {
  note: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 2291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_Icon__ = __webpack_require__(491);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditButton;




function EditButton(_ref) {
  var handleClick = _ref.handleClick;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    {
      type: "button",
      className: "btn btn-primary btn-hollow pull-right",
      onClick: handleClick
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icon_Icon__["a" /* default */], { name: "pencil" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "edit-button-padding" },
      "Edit"
    )
  );
}

EditButton.propTypes = {
  handleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditButton__ = __webpack_require__(2291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EditButton__["a"]; });



/***/ }),
/* 2293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = EmailLink;



function EmailLink(_ref) {
  var email = _ref.email;

  var handleMailto = function handleMailto(e) {
    e.stopPropagation();
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "a",
    { href: "mailto:" + email, onClick: handleMailto },
    email
  );
}

EmailLink.propTypes = {
  email: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 2294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ErrorBoundary = function (_Component) {
  _inherits(ErrorBoundary, _Component);

  function ErrorBoundary(props) {
    _classCallCheck(this, ErrorBoundary);

    var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

    _this.state = { error: null };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      this.setState({ error: error });
      if (true) {
        // eslint-disable-next-line
        Rollbar.error(error);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.error) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "alert alert-danger", style: { marginTop: "20px" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            { style: { textTransform: "none" } },
            "An unexpected error occurred.",
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "a",
              {
                href: "",
                onClick: function onClick() {
                  return location.reload();
                },
                style: { color: "yellow" }
              },
              "Try refreshing."
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            null,
            "Error: ",
            this.state.error.message
          )
        );
      }

      return this.props.children;
    }
  }]);

  return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ErrorBoundary.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element)])
};

/* harmony default export */ __webpack_exports__["a"] = (ErrorBoundary);

/***/ }),
/* 2295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FilterOption__ = __webpack_require__(781);
/* unused harmony export FilterSelect */






function FilterSelect(_ref) {
  var children = _ref.children,
      _ref$display = _ref.display,
      display = _ref$display === undefined ? true : _ref$display,
      filters = _ref.filters,
      right = _ref.right,
      setFilters = _ref.setFilters,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? "Filter" : _ref$title,
      toggle = _ref.toggle,
      visible = _ref.visible;

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("input-group-btn", { open: visible });
  var menuClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("dropdown-menu", {
    "dropdown-menu-right": right
  });

  if (!display) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: classes },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      { className: "btn btn-default dropdown-toggle", onClick: toggle },
      title,
      " ",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-f2 fa-caret-down" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "ul",
      { className: menuClasses },
      filters.map(function (filter) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FilterOption__["a" /* default */], {
          filter: filter,
          onClick: function onClick(selectedFilters) {
            return setFilters(selectedFilters);
          }
        });
      })
    ),
    children
  );
}

FilterSelect.propTypes = {
  display: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(),
    withAuthorization: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      roles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
      authorizedIf: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
    })
  }).isRequired).isRequired,
  setFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators__["c" /* dropdown */])(FilterSelect));

/***/ }),
/* 2296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FilterOption__ = __webpack_require__(781);
/* unused harmony export SearchableFilterSelect */





function SearchableFilterSelect(_ref) {
  var _ref$display = _ref.display,
      display = _ref$display === undefined ? true : _ref$display,
      visible = _ref.visible,
      toggle = _ref.toggle,
      filters = _ref.filters,
      searchFilters = _ref.searchFilters,
      _ref$searchValue = _ref.searchValue,
      searchValue = _ref$searchValue === undefined ? "" : _ref$searchValue,
      setFilters = _ref.setFilters,
      right = _ref.right,
      children = _ref.children,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? "Filter" : _ref$title;

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("input-group-btn", { open: visible });
  var menuClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("dropdown-menu", {
    "dropdown-menu-right": right
  });

  if (!display) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    { className: classes },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      { className: "btn btn-default dropdown-toggle", onClick: toggle },
      title,
      " ",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-f2 fa-caret-down" })
    ),
    visible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      onClick: toggle,
      style: {
        position: "fixed",
        top: "0px",
        left: "0px",
        backgroundColor: "transparent",
        height: "100vh",
        width: "100vw",
        zIndex: 5
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "ul",
      { className: menuClasses, style: { zIndex: 10 } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "li",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          key: "application-search",
          className: "form-control",
          onChange: searchFilters,
          value: searchValue,
          autoFocus: true,
          style: {
            paddingRight: "10px",
            paddingLeft: "10px",
            height: "40px"
          }
        })
      ),
      filters.map(function (filter) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FilterOption__["a" /* default */], {
          filter: filter,
          onClick: function onClick(selectedFilters) {
            setFilters(selectedFilters);
            toggle();
          }
        });
      })
    ),
    children
  );
}

SearchableFilterSelect.propTypes = {
  display: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(),
    withAuthorization: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      roles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
      authorizedIf: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
    })
  }).isRequired).isRequired,
  searchFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  searchValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  setFilters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (SearchableFilterSelect);

/***/ }),
/* 2297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FilterSelect__ = __webpack_require__(2295);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FilterSelect__["a"]; });



/***/ }),
/* 2298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = FilterTag;



function FilterTag(_ref) {
  var label = _ref.label,
      clear = _ref.clear;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    { className: "btn btn-xs btn-default", onClick: clear },
    label,
    " ",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-close" })
  );
}

FilterTag.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  clear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FilterTag__ = __webpack_require__(2298);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FilterTag__["a"]; });



/***/ }),
/* 2300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["a"] = FinalDestinationDetails;




var finalDestinationField = function finalDestinationField(fieldName) {
  return "final_destination_" + fieldName;
};

function FinalDestinationDetails(_ref) {
  var record = _ref.record;

  var finalDestinationAddress = record.get(finalDestinationField(__WEBPACK_IMPORTED_MODULE_2__constants__["_56" /* ADDRESS */]));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h3",
      { style: { marginTop: 10 } },
      "Final Destination"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "table",
      { className: "table table-condensed" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "tbody",
        null,
        finalDestinationAddress && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Company Name"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              record.get(finalDestinationField(__WEBPACK_IMPORTED_MODULE_2__constants__["x" /* COMPANY_NAME */]))
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Address Line"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              finalDestinationAddress.get(__WEBPACK_IMPORTED_MODULE_2__constants__["s" /* LINE1 */]),
              finalDestinationAddress.get(__WEBPACK_IMPORTED_MODULE_2__constants__["t" /* LINE2 */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
              finalDestinationAddress.get(__WEBPACK_IMPORTED_MODULE_2__constants__["t" /* LINE2 */]) && finalDestinationAddress.get(__WEBPACK_IMPORTED_MODULE_2__constants__["t" /* LINE2 */])
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "City"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              finalDestinationAddress.get(__WEBPACK_IMPORTED_MODULE_2__constants__["u" /* CITY */])
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "State/ Province/ Region"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              finalDestinationAddress.get(__WEBPACK_IMPORTED_MODULE_2__constants__["v" /* STATE */])
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "ZIP/ Postal Code"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              finalDestinationAddress.get(__WEBPACK_IMPORTED_MODULE_2__constants__["w" /* POSTAL_CODE */])
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "tr",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "th",
              { className: "text-right" },
              "Country"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "td",
              null,
              finalDestinationAddress.get(__WEBPACK_IMPORTED_MODULE_2__constants__["r" /* COUNTRY */])
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Contact Name"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            record.get(finalDestinationField("name"))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Contact Phone"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            record.get(finalDestinationField("phone"))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Contact Email"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            record.get(finalDestinationField("email"))
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tr",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "th",
            { className: "text-right" },
            "Ref#"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "td",
            null,
            record.get(finalDestinationField("reference"))
          )
        )
      )
    )
  );
}

FinalDestinationDetails.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object)
};

/***/ }),
/* 2301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FinalDestinationDetails__ = __webpack_require__(2300);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FinalDestinationDetails__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FinalDestinationWarning__ = __webpack_require__(782);
/* unused harmony reexport FinalDestinationWarning */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FinalDestinationFields__ = __webpack_require__(343);
/* unused harmony reexport default */





/***/ }),
/* 2302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AsyncField = function (_Component) {
  _inherits(AsyncField, _Component);

  function AsyncField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AsyncField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AsyncField.__proto__ || Object.getPrototypeOf(AsyncField)).call.apply(_ref, [this].concat(args))), _this), _this.onBlur = function (e) {
      var _this$props = _this.props,
          input = _this$props.input,
          check = _this$props.check,
          checkOnChange = _this$props.checkOnChange;


      input.onBlur(e.target.value);
      if (!checkOnChange) check(e.target.value);
    }, _this.onChange = function (e) {
      var _this$props2 = _this.props,
          input = _this$props2.input,
          notify = _this$props2.notify,
          check = _this$props2.check,
          checkOnChange = _this$props2.checkOnChange;


      input.onChange(e);

      if (checkOnChange) {
        check(e.target.value);
      } else {
        notify();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AsyncField, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          input = _props.input,
          FormComponent = _props.formComponent,
          rest = _objectWithoutProperties(_props, ["input", "formComponent"]);

      var field = _extends({}, input, { onBlur: this.onBlur, onChange: this.onChange });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormComponent, _extends({ input: field }, rest));
    }
  }]);

  return AsyncField;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AsyncField.propTypes = {
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  }).isRequired,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  notify: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  formComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  checkOnChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
AsyncField.defaultProps = {
  checkOnChange: false
};
/* harmony default export */ __webpack_exports__["a"] = (AsyncField);

/***/ }),
/* 2303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncField__ = __webpack_require__(2302);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AsyncField__["a"]; });



/***/ }),
/* 2304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoCompleteField__ = __webpack_require__(192);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AutoCompleteField__["a"]; });



/***/ }),
/* 2305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AutoComplete_AutoComplete__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formField__ = __webpack_require__(142);
/* unused harmony export AutoCompleteUserInput */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AutoCompleteUserInput = function (_React$Component) {
  _inherits(AutoCompleteUserInput, _React$Component);

  function AutoCompleteUserInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AutoCompleteUserInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AutoCompleteUserInput.__proto__ || Object.getPrototypeOf(AutoCompleteUserInput)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function () {
      _this.props.input.onChange(null);
    }, _this.onSelect = function (item) {
      var input = _this.props.input;

      var hasName = item instanceof Object && item && item.name;
      var value = hasName ? item.name : item;

      // Tagged By used to be a text value,
      // We have since changed it to a reference so this will disable selecting
      // a non company.

      if (hasName || _this.props.allowUserInput) {
        if (_this.props.handleTaggedBy) _this.props.handleTaggedBy(item);
        input.onChange(value);
        input.onBlur(value);
      } else {
        if (_this.props.handleTaggedBy) _this.props.handleTaggedBy(null);
        input.onChange(null);
        input.onBlur(null);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AutoCompleteUserInput, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          addon = _props.addon,
          _props$allowUserInput = _props.allowUserInput,
          allowUserInput = _props$allowUserInput === undefined ? false : _props$allowUserInput,
          _props$required = _props.required,
          required = _props$required === undefined ? false : _props$required,
          search = _props.search,
          selectedItem = _props.selectedItem,
          _props$formatItem = _props.formatItem,
          formatItem = _props$formatItem === undefined ? function (item) {
        return item && item.name;
      } : _props$formatItem,
          _props$placeholder = _props.placeholder,
          placeholder = _props$placeholder === undefined ? "" : _props$placeholder,
          input = _props.input,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled,
          forceClear = _props.forceClear;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AutoComplete_AutoComplete__["a" /* default */], {
        search: search,
        onSelect: this.onSelect,
        format: formatItem,
        hasId: !!input.value,
        value: selectedItem ? formatItem(selectedItem) : "",
        placeholder: placeholder,
        disabled: disabled,
        addon: addon,
        allowUserInput: allowUserInput,
        required: required,
        forceClear: forceClear
      });
    }
  }]);

  return AutoCompleteUserInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formField__["a" /* default */])(AutoCompleteUserInput));

AutoCompleteUserInput.propTypes = {
  allowUserInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object).isRequired,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectedItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  forceClear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  formatItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  handleTaggedBy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/***/ }),
/* 2306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoCompleteUserInputField__ = __webpack_require__(2305);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AutoCompleteUserInputField__["a"]; });



/***/ }),
/* 2307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shortid__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shortid__);
/* unused harmony export default */




function BaseErrors(_ref) {
  var errors = _ref.errors;

  if (errors && errors.length > 0) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "alert alert-danger text-left" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        { style: { fontWeight: "bold" } },
        "One or more errors were encountered:"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "ul",
        null,
        errors.map(function (e) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            { key: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shortid__["generate"])() },
            e
          );
        })
      )
    );
  }

  return null;
}

BaseErrors.propTypes = {
  errors: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
};

/***/ }),
/* 2308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseErrors__ = __webpack_require__(2307);
/* unused harmony reexport default */



/***/ }),
/* 2309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony export (immutable) */ __webpack_exports__["a"] = CageField;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var format = function format(value) {
  if (!value) {
    return "";
  }

  return value.replace(/[^\w]|_/g, "").slice(0, 5);
};

function CageField(props) {
  var rest = _objectWithoutProperties(props, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], _extends({ type: "text", format: format }, rest));
}

/***/ }),
/* 2310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CageField__ = __webpack_require__(2309);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CageField__["a"]; });



/***/ }),
/* 2311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony export (immutable) */ __webpack_exports__["a"] = ECCNField;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var formatValue = function formatValue(value) {
  if (!value) {
    return "";
  }

  var strin = value.split("");
  for (var i = 0; i < strin.length; i += 1) {
    if (i === 6) {
      strin[i] = strin[i].substring(0, 2).toLowerCase();
    } else if (i === 1) {
      strin[i] = strin[i].toUpperCase();
    }
  }
  return strin.join("");
};

function ECCNField(props) {
  var rest = _objectWithoutProperties(props, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], _extends({ type: "text", format: formatValue }, rest));
}

/***/ }),
/* 2312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ECCNField__ = __webpack_require__(2311);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ECCNField__["a"]; });



/***/ }),
/* 2313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formField__ = __webpack_require__(142);
/* unused harmony export FileInput */
function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }





function FileInput(_ref) {
  var input = _ref.input,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === undefined ? false : _ref$multiple;

  var onChange = function onChange(e) {
    var _e$target$files = _toArray(e.target.files),
        files = _e$target$files.slice(0);

    if (multiple) {
      input.onChange(files || null);
      input.onBlur(files || null);
      return;
    }
    input.onChange(files[0] || null);
    input.onBlur(files[0] || null);
  };

  var onBlur = function onBlur(e) {
    if (!e.target.value) {
      input.onBlur(null);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    type: "file",
    id: input.name,
    className: "form-control",
    onChange: onChange,
    onBlur: onBlur,
    multiple: multiple
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formField__["a" /* default */])(FileInput));

FileInput.propTypes = {
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired }).isRequired,
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 2314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FileInput__ = __webpack_require__(2313);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FileInput__["a"]; });



/***/ }),
/* 2315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(16);
/* unused harmony export default */




function Footer(_ref) {
  var close = _ref.close,
      submitting = _ref.submitting;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__Modal__["d" /* Footer */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      { type: "button", className: "btn btn-default", onClick: close },
      "Cancel"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      { disabled: submitting, type: "submit", className: "btn btn-primary" },
      "Save"
    )
  );
}

Footer.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 2316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormInput__ = __webpack_require__(488);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__FormInput__["a" /* default */], _extends({}, props, { className: "input-lg" }));
});

/***/ }),
/* 2317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formField__ = __webpack_require__(142);
/* unused harmony export TextArea */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





function TextArea(_ref) {
  var input = _ref.input,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? "text" : _ref$type,
      className = _ref.className,
      _ref$rows = _ref.rows,
      rows = _ref$rows === undefined ? "10" : _ref$rows,
      _ref$cols = _ref.cols,
      cols = _ref$cols === undefined ? "40" : _ref$cols,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === undefined ? 1000 : _ref$maxLength,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === undefined ? false : _ref$autoFocus,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", _extends({
    type: type,
    id: input.name,
    rows: rows,
    cols: cols,
    maxLength: maxLength,
    autoFocus: autoFocus,
    className: "form-control " + className,
    disabled: disabled,
    style: { resize: "none" }
  }, input));
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formField__["a" /* default */])(TextArea));

TextArea.propTypes = {
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired }).isRequired,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  rows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  cols: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 2318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function FormLink(_ref) {
  var children = _ref.children,
      label = _ref.label,
      _ref$addons = _ref.addons,
      addons = _ref$addons === undefined ? [] : _ref$addons;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "label",
    { className: "control-label", htmlFor: label },
    label.toUpperCase(),
    addons
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "input-group full-width" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "form-control", disabled: true },
      children
    )
  )];
}

FormLink.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)])
};

/* harmony default export */ __webpack_exports__["a"] = (FormLink);

/***/ }),
/* 2319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6____ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__decorators_withFormFields__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Shipping_components_Dashboard_Create_Form__ = __webpack_require__(455);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

















function ShippingMethod(_ref) {
  var accountNumber = _ref.account_number,
      carrier = _ref.carrier,
      doNotShip = _ref.doNotShip,
      required = _ref.required,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      setTenantAccount = _ref.setTenantAccount,
      shippingMethod = _ref.shipping_method,
      wtDimsReq = _ref.wtDimsReq,
      selectedCarrier = _ref.selectedCarrier,
      selectedShippingMethod = _ref.selectedShippingMethod,
      selectedAccountNumber = _ref.selectedAccountNumber;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (selectedCarrier) {
      carrier.input.onChange(selectedCarrier);
    }
    if (selectedShippingMethod) {
      shippingMethod.input.onChange(selectedShippingMethod);
    }
    if (selectedAccountNumber) {
      accountNumber.input.onChange(selectedAccountNumber);
    }
  }, [selectedCarrier, selectedShippingMethod, selectedAccountNumber, carrier, shippingMethod, accountNumber]);

  var addCurrentMethod = function addCurrentMethod(availMethods) {
    return shippingMethod && shippingMethod.input.value && __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* CARRIERS */][carrier.input.value].shippingMethods[shippingMethod.input.value] && !availMethods.includes(shippingMethod.input.value);
  };

  var shippingCarriers = function shippingCarriers() {
    if (!wtDimsReq && carrier.input.value !== __WEBPACK_IMPORTED_MODULE_7__constants__["b" /* TBD */]) {
      // eslint-disable-next-line
      var tbd = __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* CARRIERS */].tbd,
          filteredCarriers = _objectWithoutProperties(__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* CARRIERS */], ["tbd"]);

      return filteredCarriers;
    }
    return __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* CARRIERS */];
  };

  var shippingMethods = function shippingMethods() {
    if (!carrier.input.value) {
      return [];
    }
    if (carrier.input.value === __WEBPACK_IMPORTED_MODULE_7__constants__["b" /* TBD */]) {
      shippingMethod.input.onChange("dim_weight");
    }
    var methods = __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* CARRIERS */][carrier.input.value].shippingMethods;

    var availMethods = Object.keys(methods).filter(function (t) {
      return !methods[t].deprecated;
    });
    var activeShippingMethods = availMethods.map(function (t) {
      return {
        value: t,
        text: methods[t].label
      };
    });
    return addCurrentMethod(availMethods) ? [].concat(_toConsumableArray(activeShippingMethods), [{
      value: shippingMethod.input.value,
      text: __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* CARRIERS */][carrier.input.value].shippingMethods[shippingMethod.input.value].label
    }]) : activeShippingMethods;
  };

  var settings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__hooks_useCurrentUser__["b" /* useSettings */])();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_12__FormRow__["a" /* default */],
      null,
      wtDimsReq && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6____["a" /* CheckGroup */],
          { title: "Req Wt & Dims from Warehouse", justified: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], { name: "request_weight_dims", component: __WEBPACK_IMPORTED_MODULE_6____["b" /* Check */], label: "Yes" })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 3 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_10__constants__["e" /* CARRIER */],
          component: __WEBPACK_IMPORTED_MODULE_6____["c" /* Select */],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_10__constants__["e" /* CARRIER */]),
          onChange: function onChange(_, val) {
            if (!setTenantAccount) return null;
            var defaultAcct = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(settings, __WEBPACK_IMPORTED_MODULE_10__constants__["f" /* SHIPPING_OPTIONS */] + "." + val + ".default_account");
            if (defaultAcct) {
              accountNumber.input.onChange(defaultAcct);
            }

            return null;
          },
          options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_forms__["a" /* toOptions */])(shippingCarriers()),
          required: required && !doNotShip,
          disabled: disabled || doNotShip
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_10__constants__["g" /* SHIPPING_METHOD */],
          component: __WEBPACK_IMPORTED_MODULE_6____["c" /* Select */],
          label: "Method",
          options: shippingMethods(),
          disabled: !carrier.input.value || disabled || doNotShip,
          required: required && !doNotShip
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_12__FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
        { md: 4 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_10__constants__["h" /* ACCOUNT_NUMBER */],
          component: __WEBPACK_IMPORTED_MODULE_6____["d" /* FormInput */],
          disabled: disabled,
          label: ["Account #", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Shipping_components_Dashboard_Create_Form__["a" /* SimpleCopy */], { value: accountNumber.input.value, bottom: "25px" })]
        })
      )
    )
  );
}

ShippingMethod.propTypes = {
  account_number: __WEBPACK_IMPORTED_MODULE_9__FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_9__FormTypes__["stringInput"]).isRequired,
  carrier: __WEBPACK_IMPORTED_MODULE_9__FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_9__FormTypes__["stringInput"]).isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  doNotShip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  setTenantAccount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shipping_method: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    })
  }),
  wtDimsReq: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  selectedCarrier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectedShippingMethod: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  selectedAccountNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};

ShippingMethod.defaultProps = {
  required: true
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__decorators_withFormFields__["a" /* default */])(ShippingMethod, [__WEBPACK_IMPORTED_MODULE_10__constants__["h" /* ACCOUNT_NUMBER */], __WEBPACK_IMPORTED_MODULE_10__constants__["e" /* CARRIER */], __WEBPACK_IMPORTED_MODULE_10__constants__["g" /* SHIPPING_METHOD */]]));

/***/ }),
/* 2320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_formik__ = __webpack_require__(296);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var FormikCheck = function (_Component) {
  _inherits(FormikCheck, _Component);

  function FormikCheck() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FormikCheck);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormikCheck.__proto__ || Object.getPrototypeOf(FormikCheck)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false
    }, _this.onFocus = function () {
      _this.setState({ focused: true });
    }, _this.onBlur = function () {
      _this.setState({ focused: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FormikCheck, [{
    key: "render",
    value: function render() {
      var focused = this.state.focused;
      var _props = this.props,
          label = _props.label,
          name = _props.name,
          icon = _props.icon,
          disabled = _props.disabled,
          parse = _props.parse;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_formik__["a" /* Field */],
        { name: name },
        function (_ref2) {
          var field = _ref2.field,
              _meta = _ref2._meta;

          // Handle parsing on change
          var handleChange = function handleChange(ev) {
            var parsedValue = parse ? parse(ev.target.checked) : ev.target.checked;
            // Create a new event object with the same properties as the original event
            var newEvent = _extends({}, ev, {
              target: _extends({}, ev.target, {
                value: parsedValue,
                name: name // Ensure the name attribute is included
              })
            });
            field.onChange(newEvent); // Pass the new event object to field.onChange
          };

          var labelClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn btn-default", {
            active: field.value,
            focus: focused,
            disabled: disabled
          });

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: labelClasses, htmlFor: field.name },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
              type: "checkbox",
              id: field.name,
              checked: field.value,
              onChange: handleChange,
              onBlur: field.onBlur,
              disabled: disabled
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg " + icon }),
            "\xA0\xA0",
            label
          );
        }
      );
    }
  }]);

  return FormikCheck;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FormikCheck.propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  }).isRequired
};
FormikCheck.defaultProps = {
  icon: "fa-check-circle",
  onChange: function onChange() {
    return null;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (FormikCheck);

/***/ }),
/* 2321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_formik__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FormField__ = __webpack_require__(787);
/* harmony export (immutable) */ __webpack_exports__["a"] = FormSelect;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function renderOption(o) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "option",
    { key: o.value, value: o.value },
    o.text
  );
}

function Select(_ref) {
  var field = _ref.field,
      options = _ref.options,
      _ref$prompt = _ref.prompt,
      prompt = _ref$prompt === undefined ? "(Select one)" : _ref$prompt,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === undefined ? false : _ref$multiple;

  var blank = prompt && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "option",
    { value: "" },
    prompt
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "select",
    _extends({
      className: "form-control"
    }, field, {
      disabled: disabled,
      multiple: multiple
    }),
    blank,
    options.map(renderOption)
  );
}

function FormSelect(_ref2) {
  var label = _ref2.label,
      name = _ref2.name,
      options = _ref2.options,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === undefined ? false : _ref2$disabled,
      _ref2$inputProps = _ref2.inputProps,
      inputProps = _ref2$inputProps === undefined ? {} : _ref2$inputProps;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_formik__["a" /* Field */],
    _extends({ name: name }, inputProps),
    function (_ref3) {
      var field = _ref3.field,
          childProps = _objectWithoutProperties(_ref3, ["field"]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__FormField__["a" /* default */],
        _extends({}, childProps, {
          field: Object.assign(field, inputProps.field || {}),
          label: label
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Select, _extends({
          field: field
        }, childProps, {
          options: options,
          value: field.value,
          disabled: disabled
        }))
      );
    }
  );
}

Select.propTypes = {
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired }).isRequired,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired
  })).isRequired,
  prompt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 2322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony export (immutable) */ __webpack_exports__["a"] = NSNField;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var format = function format(value) {
  if (!value) {
    return "";
  }

  var onlyNums = value.replace(/[^\d]/g, "");

  if (onlyNums.length <= 4) {
    return onlyNums;
  }
  if (onlyNums.length <= 6) {
    return onlyNums.slice(0, 4) + "-" + onlyNums.slice(4);
  }
  if (onlyNums.length <= 9) {
    return onlyNums.slice(0, 4) + "-" + onlyNums.slice(4, 6) + "-" + onlyNums.slice(6, 9);
  }

  return onlyNums.slice(0, 4) + "-" + onlyNums.slice(4, 6) + "-" + onlyNums.slice(6, 9) + "-" + onlyNums.slice(9, 13);
};

function NSNField(props) {
  var rest = _objectWithoutProperties(props, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], _extends({ type: "text", format: format }, rest));
}

/***/ }),
/* 2323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NSNField__ = __webpack_require__(2322);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__NSNField__["a"]; });



/***/ }),
/* 2324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NumberInput__ = __webpack_require__(141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__NumberInput__["a"]; });



/***/ }),
/* 2325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony export (immutable) */ __webpack_exports__["a"] = PhoneNumberField;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




function format(value) {
  return value ? value.replace(/[()]/g, "") : "";
}

function PhoneNumberField(props) {
  var rest = _objectWithoutProperties(props, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], _extends({ type: "text", format: format }, rest));
}

/***/ }),
/* 2326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhoneNumberField__ = __webpack_require__(2325);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PhoneNumberField__["a"]; });



/***/ }),
/* 2327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formField__ = __webpack_require__(142);
/* unused harmony export RadioGroupField */





function RadioGroupField(_ref) {
  var disabled = _ref.disabled,
      input = _ref.input,
      _ref$options = _ref.options,
      options = _ref$options === undefined ? [] : _ref$options;

  var activeClass = function activeClass(type, option) {
    return __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn btn-default", {
      active: input.value === type,
      disabled: disabled || option.disabled
    });
  };

  var handleChange = function handleChange(newVal) {
    return function () {
      return input.onChange(newVal);
    };
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "btn-group btn-group-justified", role: "group" },
    options.map(function (option) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: activeClass(option.value, option),
          onClick: disabled || option.disabled ? undefined : handleChange(option.value),
          key: option.value
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
        "\xA0\xA0",
        option.text
      );
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formField__["a" /* default */])(RadioGroupField));

RadioGroupField.propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }))
};

/***/ }),
/* 2328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RadioGroupField__ = __webpack_require__(2327);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RadioGroupField__["a"]; });



/***/ }),
/* 2329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = Save;



function Save(_ref) {
  var submitting = _ref.submitting,
      _ref$icon = _ref.icon,
      icon = _ref$icon === undefined ? "fa-check" : _ref$icon,
      _ref$text = _ref.text,
      text = _ref$text === undefined ? "Save" : _ref$text,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? "lg" : _ref$size;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    {
      disabled: submitting,
      type: "submit",
      className: "btn btn-block btn-" + size + " btn-primary"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw " + icon }),
    text
  );
}

Save.propTypes = {
  submitting: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 2330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Save__ = __webpack_require__(2329);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Save__["a"]; });



/***/ }),
/* 2331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony export (immutable) */ __webpack_exports__["a"] = ScheduleBOrHTCodeField;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var format = function format(value) {
  if (!value) {
    return "";
  }

  var newValue = value.replace(/\D/g, "").match(/(\d{0,4})(\d{0,2})(\d{0,4})/);

  newValue = !newValue[2] ? newValue[1] : newValue[1] + "." + newValue[2] + ("" + (newValue[3] ? "." + newValue[3] : ""));

  return newValue;
};

function ScheduleBOrHTCodeField(props) {
  var rest = _objectWithoutProperties(props, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], _extends({ type: "text", format: format }, rest));
}

/***/ }),
/* 2332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScheduleBOrHTCodeField__ = __webpack_require__(2331);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ScheduleBOrHTCodeField__["a"]; });



/***/ }),
/* 2333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(790);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Select__["a"]; });



/***/ }),
/* 2334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony export (immutable) */ __webpack_exports__["a"] = UNCodeField;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




function format(value) {
  return value ? value.replace(/[^\d]/g, "").slice(0, 4) : "";
}

function UNCodeField(props) {
  var rest = _objectWithoutProperties(props, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], _extends({ addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      null,
      "UN-"
    ), type: "text", format: format }, rest));
}

/***/ }),
/* 2335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UNCodeField__ = __webpack_require__(2334);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__UNCodeField__["a"]; });



/***/ }),
/* 2336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony export (immutable) */ __webpack_exports__["a"] = disabledInputs;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function disabledInputs(components) {
  return function (disabled) {
    return Object.entries(components).reduce(function (enhanced, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          name = _ref2[0],
          C = _ref2[1];

      return _extends({}, enhanced, _defineProperty({}, name, function (props) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(C, _extends({}, props, { disabled: disabled }));
      }));
    }, {});
  };
}

/***/ }),
/* 2337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = IconReceived;





function IconReceived(_ref) {
  var placement = _ref.placement;

  var tooltip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["b" /* Tooltip */],
    null,
    "Received"
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* OverlayTrigger */],
    { placement: placement, overlay: tooltip },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "text-muted" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["k" /* Icon */], { name: "cloud-download" })
    )
  );
}

IconReceived.defaultProps = {
  placement: "top"
};

IconReceived.propTypes = {
  placement: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

/***/ }),
/* 2338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IconReceived__ = __webpack_require__(2337);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__IconReceived__["a"]; });



/***/ }),
/* 2339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IconText__ = __webpack_require__(349);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__IconText__["a"]; });



/***/ }),
/* 2340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = InventoryQuantityCell;



function InventoryQuantityCell(_ref) {
  var inventory = _ref.inventory,
      renderDummyValues = _ref.renderDummyValues,
      _ref$alignment = _ref.alignment,
      alignment = _ref$alignment === undefined ? "right" : _ref$alignment;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-" + alignment },
    renderDummyValues ? inventory.dummy.quantity : inventory.total_quantity
  );
}

InventoryQuantityCell.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  renderDummyValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  alignment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 2341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventories_components_Detail_Warnings__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RepairOrders_constants__ = __webpack_require__(28);
/* harmony export (immutable) */ __webpack_exports__["a"] = InventoryTagDateCell;






function repairAndHoldLeadTime(inventory) {
  return Number.isInteger(inventory.repair_and_hold_lead_time) && parseInt(inventory.repair_and_hold_lead_time, 10) !== 0;
}

function repairAndHold(inventory) {
  return inventory.repair_status === __WEBPACK_IMPORTED_MODULE_4__RepairOrders_constants__["n" /* REPAIR_AND_HOLD */];
}

function InventoryTagDateCell(_ref) {
  var inventory = _ref.inventory,
      renderDummyValues = _ref.renderDummyValues;

  var tagCell = function () {
    if (renderDummyValues) {
      return "";
    } else if (repairAndHold(inventory) && repairAndHoldLeadTime(inventory)) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__inventories_components_Detail_Warnings__["a" /* RepairAndHold */], { inventory: inventory, label: "R&H-LT" });
    } else if (repairAndHold(inventory)) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__inventories_components_Detail_Warnings__["a" /* RepairAndHold */], { inventory: inventory });
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_date__["f" /* monthFullYearHyphen */])(inventory.tag_date);
  }();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: "text-center" },
    tagCell
  );
}

InventoryTagDateCell.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired,
  renderDummyValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 2342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decorators__ = __webpack_require__(17);
/* harmony export (immutable) */ __webpack_exports__["a"] = LaunchModal;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





function LaunchModal(_ref) {
  var Modal = _ref.modal,
      buttonClass = _ref.buttonClass,
      _ref$buttonIcon = _ref.buttonIcon,
      buttonIcon = _ref$buttonIcon === undefined ? "fa-plus" : _ref$buttonIcon,
      text = _ref.text,
      rest = _objectWithoutProperties(_ref, ["modal", "buttonClass", "buttonIcon", "text"]);

  var Button = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decorators__["f" /* launchModal */])(function (open, close) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Modal, _extends({ open: open, close: close }, rest));
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, { buttonClass: buttonClass, text: text, buttonIcon: buttonIcon });
}

LaunchModal.propTypes = {
  modal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  buttonClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  buttonIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 2343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LaunchModal__ = __webpack_require__(2342);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LaunchModal__["a"]; });



/***/ }),
/* 2344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LineItemQtyCell__ = __webpack_require__(350);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LineItemQtyCell__["a"]; });



/***/ }),
/* 2345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IncomingQuotes_constants__ = __webpack_require__(40);
/* harmony export (immutable) */ __webpack_exports__["a"] = LineItemStatusCell;




var quoteStyle = function quoteStyle(lineItem) {
  if (lineItem.incident_related || lineItem.quote_type === __WEBPACK_IMPORTED_MODULE_2__IncomingQuotes_constants__["l" /* INCIDENT_RELATED */]) {
    return { borderLeft: "3px solid #f44336" };
  }

  switch (lineItem.quote_type) {
    case __WEBPACK_IMPORTED_MODULE_2__IncomingQuotes_constants__["c" /* AS_IS */]:
      return { borderLeft: "3px solid #f44336" };
    case __WEBPACK_IMPORTED_MODULE_2__IncomingQuotes_constants__["m" /* OFFER */]:
      return { borderLeft: "3px solid #18b5fc" };
    default:
      return {};
  }
};

function LineItemStatusCell(_ref) {
  var lineItem = _ref.lineItem,
      children = _ref.children;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { style: quoteStyle(lineItem) },
    children
  );
}

LineItemStatusCell.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    cost: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    quote_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)])
};

/***/ }),
/* 2346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* unused harmony export LinkedTableRow */





function LinkedTableRow(_ref) {
  var cancelled = _ref.cancelled,
      transition = _ref.transition,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? "" : _ref$className,
      disabled = _ref.disabled;

  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
    "text-muted": cancelled,
    clickable: !disabled
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    { className: classes, onClick: disabled ? undefined : transition },
    children
  );
}

LinkedTableRow.propTypes = {
  cancelled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  transition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)]),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decorators__["b" /* linkTo */])(function (_ref2) {
  var to = _ref2.to;
  return to;
})(LinkedTableRow));

/***/ }),
/* 2347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LinkedTableRow__ = __webpack_require__(2346);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LinkedTableRow__["a"]; });



/***/ }),
/* 2348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = Close;



function Close(_ref) {
  var close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    { onClick: close, className: "close", type: "button" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" })
    )
  );
}

Close.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bootstrap__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_bootstrap__["g" /* Modal */].Footer);

/***/ }),
/* 2350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_bootstrap__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_bootstrap__["g" /* Modal */].Header);

/***/ }),
/* 2351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony export (immutable) */ __webpack_exports__["a"] = Modal;




function Modal(_ref) {
  var open = _ref.open,
      children = _ref.children,
      dialogClass = _ref.dialogClass,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["g" /* Modal */],
    {
      dialogClassName: dialogClass,
      show: open,
      onHide: close,
      backdrop: "static",
      keyboard: false
    },
    children
  );
}

Modal.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)]),
  dialogClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Modal.defaultProps = {
  open: false,
  dialogClass: ""
};

/***/ }),
/* 2352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_overlays__ = __webpack_require__(3056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_overlays___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_overlays__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* eslint-disable */

// This shim can be removed once react-bootstrap is updated for React 16.
// More info: https://github.com/react-bootstrap/react-bootstrap/issues/2812



var focus = function focus() {};
var cDU = __WEBPACK_IMPORTED_MODULE_0_react_overlays__["Modal"].prototype.componentDidUpdate;
var cDM = __WEBPACK_IMPORTED_MODULE_0_react_overlays__["Modal"].prototype.componentDidMount;

__WEBPACK_IMPORTED_MODULE_0_react_overlays__["Modal"].prototype.componentDidUpdate = function (prevProps) {
  if (this.focus !== focus) {
    this.focus = focus;
  }
  cDU.call(this, prevProps);
};

__WEBPACK_IMPORTED_MODULE_0_react_overlays__["Modal"].prototype.componentDidMount = function () {
  if (this.focus !== focus) {
    this.focus = focus;
  }
  cDM.call(this);
};

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["g" /* Modal */]);

/***/ }),
/* 2353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_throttle__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MonthSelect = function (_Component) {
  _inherits(MonthSelect, _Component);

  function MonthSelect(props) {
    _classCallCheck(this, MonthSelect);

    var _this = _possibleConstructorReturn(this, (MonthSelect.__proto__ || Object.getPrototypeOf(MonthSelect)).call(this, props));

    _this.updateDate = function (e) {
      var date = e.target.value && __WEBPACK_IMPORTED_MODULE_3_moment___default()(e.target.value).startOf("month").format("YYYY-MM-DD");

      _this.onChange(date);
    };

    _this.onChange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_throttle__["a" /* default */])(props.onSubmit, 300);
    return _this;
  }

  _createClass(MonthSelect, [{
    key: "render",
    value: function render() {
      var initialDate = this.props.initialDate;

      var initialDateFormatted = initialDate && __WEBPACK_IMPORTED_MODULE_3_moment___default()(initialDate).format("YYYY-MM");
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        {
          className: "input-group-btn",
          style: { backgroundColor: "#4f4f4f", paddingRight: "5px" }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          style: {
            fontWeight: "normal",
            fontSize: "13px",
            paddingLeft: "15px",
            paddingRight: "10px",
            textTransform: "uppercase",
            backgroundColor: "#4f4f4f",
            height: "34px",
            boxShadow: "none"
          },
          type: "month",
          name: "month_filter",
          className: "form-control",
          placeholder: "Month/Year",
          defaultValue: initialDateFormatted,
          onChange: this.updateDate
        })
      );
    }
  }]);

  return MonthSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MonthSelect.propTypes = _extends({
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_4____["e" /* SearchPropTypes */]);
/* harmony default export */ __webpack_exports__["a"] = (MonthSelect);

/***/ }),
/* 2354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MonthSelect__ = __webpack_require__(2353);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MonthSelect__["a"]; });



/***/ }),
/* 2355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(6);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function navLink(active, path, icon, title, reset, svg, hoverSvg, isHovered, setIsHovered) {
  var classes = __WEBPACK_IMPORTED_MODULE_6_classnames___default()({ active: active });
  var tooltip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["b" /* Tooltip */],
    { id: path },
    title
  );

  var showHeader = screen.width <= 750;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["a" /* OverlayTrigger */],
    { placement: "right", overlay: tooltip, animation: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "li",
      {
        className: classes,
        onMouseEnter: function onMouseEnter() {
          return setIsHovered(true);
        },
        onMouseLeave: function onMouseLeave() {
          return setIsHovered(false);
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],
        {
          onClick: function onClick() {
            if (reset) reset();
          },
          to: path
        },
        svg ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
          src: isHovered && hoverSvg ? hoverSvg : svg,
          style: { maxWidth: "35px", fill: "white" },
          alt: title
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-lg " + icon }),
        showHeader && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { style: { marginLeft: 5 } },
          title
        )
      )
    )
  );
}

function NavLink(props) {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["Route"], {
    path: props.path,
    children: function children(_ref) {
      var match = _ref.match;
      return navLink(match, props.path, props.icon, props.title, props.reset, props.svg, props.hoverSvg, isHovered, setIsHovered);
    }
  });
}

var ConnectedNavLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    reset: function reset() {
      if (ownProps.listId) {
        var reset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__["composables"])({ listId: ownProps.listId }).reset;
        return dispatch(reset());
      }
      return null;
    }
  };
})(NavLink);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_router__["withRouter"])(ConnectedNavLink));

NavLink.propTypes = {
  path: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  svg: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 2356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NavLink__ = __webpack_require__(2355);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__NavLink__["a"]; });



/***/ }),
/* 2357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_CreateNew__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal__ = __webpack_require__(2359);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditInternalNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EditExternalNote; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var EditInternalNote = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decorators__["j" /* createNew */])(function (open, close, props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Modal__["a" /* default */], _extends({ open: open, close: close, type: __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* INTERNAL_NOTE */] }, props));
}, function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__containers_CreateNew__["a" /* default */], props);
});

var EditExternalNote = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__decorators__["j" /* createNew */])(function (open, close, props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Modal__["a" /* default */], _extends({ open: open, close: close, type: __WEBPACK_IMPORTED_MODULE_4__PurchaseOrders_constants__["c" /* EXTERNAL_NOTE */] }, props));
}, function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__containers_CreateNew__["a" /* default */], props);
});

/***/ }),
/* 2358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Forms__ = __webpack_require__(8);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function Form(props) {
  var close = props.close,
      handleSubmit = props.handleSubmit,
      reset = props.reset;

  var onCancel = function onCancel() {
    close();
    reset();
  };
  var submit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_submission__["b" /* onSuccess */])(handleSubmit, onCancel, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__Forms__["e" /* Form */],
    _extends({}, props, { onSubmit: submit }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: props.type, component: __WEBPACK_IMPORTED_MODULE_5__Forms__["l" /* TextArea */], label: "note", autoFocus: true })
    )
  );
}

Form.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    initialValues: {
      internal_note: ownProps.record.internal_note,
      external_note: ownProps.record.external_note
    },
    onSubmit: function onSubmit(data) {
      return dispatch(ownProps.update(data));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Forms__["j" /* form */])({
  form: "updateNote",
  destroyOnUnmount: true
})(Form)));

/***/ }),
/* 2359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(2358);





function Modal(_ref) {
  var open = _ref.open,
      close = _ref.close,
      type = _ref.type,
      record = _ref.record,
      update = _ref.update;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-md" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Add a Note"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close, record: record, type: type, update: update })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (Modal);

Modal.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  update: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  record: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    internal_note: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    external_note: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 2360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Note__ = __webpack_require__(799);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Note__["a"]; });



/***/ }),
/* 2361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(2362);
/* harmony export (immutable) */ __webpack_exports__["a"] = CreateNote;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function CreateNote(_ref) {
  var open = _ref.open,
      close = _ref.close,
      resourceID = _ref.resourceID,
      resourceType = _ref.resourceType,
      important = _ref.important,
      _ref$initialValues = _ref.initialValues,
      initialValues = _ref$initialValues === undefined ? {} : _ref$initialValues,
      minor = _ref.minor,
      trace = _ref.trace,
      notesType = _ref.notesType;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-md" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Add a Note"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], {
        open: open,
        close: close,
        resourceID: resourceID,
        resourceType: resourceType,
        notesType: notesType,
        initialValues: _extends({ important: important, minor: minor, trace: trace }, initialValues)
      })
    )
  );
}

CreateNote.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  important: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  initialValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  minor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  trace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  resourceID: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  resourceType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  notesType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 2362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_notes__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Forms__ = __webpack_require__(8);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









function Form(props) {
  var close = props.close,
      handleSubmit = props.handleSubmit,
      reset = props.reset;

  var onCancel = function onCancel() {
    close();
    reset();
  };
  var submit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_submission__["b" /* onSuccess */])(handleSubmit, onCancel, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__Forms__["e" /* Form */],
    _extends({}, props, { onSubmit: submit }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
        name: "body",
        component: __WEBPACK_IMPORTED_MODULE_6__Forms__["l" /* TextArea */],
        label: "note",
        required: true,
        autoFocus: true
      })
    )
  );
}

Form.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  notesType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_notes__["e" /* createNote */](ownProps.resourceID, ownProps.resourceType, data, ownProps.notesType));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__Forms__["j" /* form */])({
  form: "createNote"
})(Form)));

/***/ }),
/* 2363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditNote_Form__ = __webpack_require__(2364);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditNote;







function EditNote(_ref) {
  var open = _ref.open,
      close = _ref.close,
      note = _ref.note,
      resourceID = _ref.resourceID,
      resourceType = _ref.resourceType,
      notesType = _ref.notesType;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Edit Note Details"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EditNote_Form__["a" /* default */], {
      close: close,
      initialValues: note.toJS(),
      resourceID: resourceID,
      resourceType: resourceType,
      enableReinitialize: true,
      notesType: notesType
    })
  );
}

EditNote.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  resourceID: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  resourceType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  note: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  notesType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 2364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_submission__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_notes__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getNoteBodyFieldName__ = __webpack_require__(801);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












function Form(props) {
  var close = props.close,
      handleSubmit = props.handleSubmit,
      reset = props.reset;

  var onCancel = function onCancel() {
    close();
    reset();
  };

  var submit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_submission__["b" /* onSuccess */])(handleSubmit, onCancel, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__Forms__["e" /* Form */],
    _extends({}, props, { onSubmit: submit }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: "body", component: __WEBPACK_IMPORTED_MODULE_8__Forms__["l" /* TextArea */], label: "note", required: true })
    )
  );
}

Form.propTypes = {
  handleSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  reset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  notesType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, function (dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(data) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_7__actions_notes__["d" /* editNote */](ownProps.resourceID, ownProps.resourceType, data, ownProps.notesType));
    }
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__Forms__["j" /* form */])({
  form: "editNote",
  validate: function validate(values, props) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_validate_this__["a" /* validator */])(values, function (f) {
      var notesField = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__getNoteBodyFieldName__["a" /* default */])(props.notesType);

      f.validate(notesField).satisfies(__WEBPACK_IMPORTED_MODULE_6__lib_validation_rules__["a" /* required */]);
    });
  }
})(Form)));

/***/ }),
/* 2365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateNote_NewNote__ = __webpack_require__(353);
/* harmony export (immutable) */ __webpack_exports__["a"] = Header;



function Header(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      props.headerLabel || "Notes",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CreateNote_NewNote__["a" /* default */], props)
    )
  );
}

/***/ }),
/* 2366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateNote_NewNote__ = __webpack_require__(353);
/* harmony export (immutable) */ __webpack_exports__["a"] = HeaderImportant;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





function HeaderImportant(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      "Important Note",
      props.important || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CreateNote_NewNote__["a" /* default */], _extends({}, props, { important: true }))
    )
  );
}

HeaderImportant.propTypes = {
  important: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 2367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateNote_NewNote__ = __webpack_require__(353);
/* harmony export (immutable) */ __webpack_exports__["a"] = HeaderMinor;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





function HeaderMinor(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      "Minor Notes",
      props.minor || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CreateNote_NewNote__["a" /* default */], _extends({}, props, { minor: true }))
    )
  );
}

HeaderMinor.propTypes = {
  minor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 2368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hooks_useCurrentUser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreateNote_NewNote__ = __webpack_require__(353);
/* harmony export (immutable) */ __webpack_exports__["a"] = HeaderTrace;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function HeaderTrace(props) {
  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hooks_useCurrentUser__["a" /* default */])();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-dashed trace-header" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      "Trace Notes",
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__users_helpers__["c" /* hasAnyOfRoles */])(currentUser, [__WEBPACK_IMPORTED_MODULE_2__users_constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_2__users_constants__["m" /* ACCOUNTING */]]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CreateNote_NewNote__["a" /* default */], _extends({}, props, { trace: true }))
    )
  );
}

HeaderTrace.propTypes = {
  trace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 2369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AuthorizedOwner__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AuditFields_AuditFields__ = __webpack_require__(477);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/* eslint react/no-danger: 0 */

var Note = function (_React$Component) {
  _inherits(Note, _React$Component);

  function Note() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Note);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Note.__proto__ || Object.getPrototypeOf(Note)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expanded: false
    }, _this.openDropdown = function () {
      _this.addListener();
      _this.setState({ expanded: true });
    }, _this.closeDropdown = function () {
      _this.removeListener();
      _this.setState({ expanded: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Note, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.closeDropdown();
    }
  }, {
    key: "addListener",
    value: function addListener() {
      document.addEventListener("click", this.closeDropdown);
    }
  }, {
    key: "removeListener",
    value: function removeListener() {
      document.removeEventListener("click", this.closeDropdown);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          additionalActions = _props.additionalActions,
          note = _props.note,
          onViewNote = _props.onViewNote,
          onEditNote = _props.onEditNote,
          onDeleteNote = _props.onDeleteNote,
          toggleAction = _props.toggleAction;
      var expanded = this.state.expanded;

      var buttonClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()("btn-group", { open: expanded });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "panel panel-default panel-note",
          style: { marginBottom: 2 }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            className: "panel-heading",
            role: "tab",
            id: "headingOne",
            style: { padding: "8px 15px" }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "pull-right" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: buttonClasses, onClick: this.openDropdown },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "button",
                {
                  type: "button",
                  className: "btn btn-default btn-hollow dropdown-toggle"
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-chevron-down" })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "ul",
                { className: "dropdown-menu dropdown-menu-right" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "li",
                  {
                    style: { cursor: "Pointer" },
                    onClick: function onClick() {
                      return onViewNote(note);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "a",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-eye" }),
                    "\xA0View"
                  )
                ),
                note.get("important") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "li",
                  {
                    style: { cursor: "Pointer" },
                    onClick: function onClick() {
                      return onEditNote(note);
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "a",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-pencil" }),
                    "\xA0Edit"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4__AuthorizedOwner__["a" /* default */],
                  { record: note },
                  !note.get("important") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "li",
                    {
                      style: { cursor: "Pointer" },
                      onClick: function onClick() {
                        return onEditNote(note);
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "a",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-pencil" }),
                      "\xA0Edit"
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "li",
                    {
                      style: { cursor: "Pointer" },
                      onClick: function onClick() {
                        return onDeleteNote(note);
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "a",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-close" }),
                      "\xA0Delete"
                    )
                  )
                ),
                additionalActions && additionalActions.map(function (action) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "li",
                    {
                      style: { cursor: "pointer" },
                      onClick: function onClick() {
                        toggleAction(note, action.key);
                      }
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "a",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-pencil" }),
                      "\xA0",
                      action.label
                    )
                  );
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AuditFields_AuditFields__["a" /* default */], { record: note })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            id: "collapseOne",
            className: "panel-collapse collapse in",
            role: "tabpanel",
            "aria-labelledby": "headingOne"
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "panel-body", style: { padding: "8px 15px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
              dangerouslySetInnerHTML: {
                __html: note.get("body").replace(/\n/g, "<br />")
              }
            })
          )
        )
      );
    }
  }]);

  return Note;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Note.propTypes = {
  additionalActions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})),
  note: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]).isRequired,
  onViewNote: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  onEditNote: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  onDeleteNote: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  toggleAction: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Note);

/***/ }),
/* 2370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Forms__ = __webpack_require__(8);
/* unused harmony export Form */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function Form(props) {
  var close = props.close;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__Forms__["e" /* Form */],
    _extends({}, props, { onSubmit: close }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], { name: "body", component: __WEBPACK_IMPORTED_MODULE_4__Forms__["l" /* TextArea */], label: "note", required: true })
    )
  );
}

Form.propTypes = {
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, undefined)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__Forms__["j" /* form */])({
  form: "viewNote"
})(Form)));

/***/ }),
/* 2371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewNote_Form__ = __webpack_require__(2370);
/* harmony export (immutable) */ __webpack_exports__["a"] = ViewNote;







function ViewNote(_ref) {
  var open = _ref.open,
      close = _ref.close,
      note = _ref.note,
      notesType = _ref.notesType;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__Modal__["a" /* Modal */],
    { open: open, close: close },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "View Note Details"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ViewNote_Form__["a" /* default */], {
      close: close,
      initialValues: note.toJS(),
      disabled: true,
      notesType: notesType
    })
  );
}

ViewNote.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  note: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  notesType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 2372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(undefined, function (dispatch, _ref) {
  var search = _ref.search;
  return {
    setFilters: function setFilters(filters) {
      return dispatch(search.setFilters(filters));
    }
  };
})(__WEBPACK_IMPORTED_MODULE_1____["v" /* FilterSelect */]));

/***/ }),
/* 2373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);




/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function () {
  return {
    initialDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_query_string__["parse"])(location.search).month_filter
  };
}, function (dispatch, _ref) {
  var search = _ref.search;
  return {
    onSubmit: function onSubmit(filter) {
      return dispatch(search.setFilter("month_filter", filter));
    }
  };
})(__WEBPACK_IMPORTED_MODULE_1____["u" /* MonthSelect */]));

/***/ }),
/* 2374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = Pagination;




function Pagination(_ref) {
  var listId = _ref.listId;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__orange_marmalade_paginate_this__["Paginator"], { listId: listId });
}

Pagination.propTypes = {
  listId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
};

/***/ }),
/* 2375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function () {
  return {
    initialFilter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_query_string__["parse"])(location.search).filter
  };
}, function (dispatch, _ref) {
  var search = _ref.search;
  return {
    onSubmit: function onSubmit(filter) {
      return dispatch(search.setFilter("filter", filter));
    }
  };
})(__WEBPACK_IMPORTED_MODULE_1____["t" /* SearchFilter */]));

/***/ }),
/* 2376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FilterSelect_SearchableFilterSelect__ = __webpack_require__(2296);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(undefined, function (dispatch, _ref) {
  var search = _ref.search;
  return {
    setFilters: function setFilters(filters) {
      return dispatch(search.setFilters(filters));
    }
  };
})(__WEBPACK_IMPORTED_MODULE_1__FilterSelect_SearchableFilterSelect__["a" /* default */]));

/***/ }),
/* 2377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* unused harmony export createFilters */
/* harmony export (immutable) */ __webpack_exports__["a"] = TitleWithFilters;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function createFilters(filters, paginator) {
  return filters.reduce(function (active, f) {
    var value = paginator.getIn(["filters", f.key]);

    var filterActive = f.matchesTarget ? f.matchesTarget(value) : value !== undefined;

    if (filterActive) {
      return active.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])({
        key: f.key,
        label: f.label,
        value: value,
        withAuthorization: f.withAuthorization
      }));
    }

    return active;
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])());
}

function TitleWithFilters(_ref) {
  var children = _ref.children,
      _ref$filters = _ref.filters,
      filters = _ref$filters === undefined ? [] : _ref$filters,
      title = _ref.title,
      paginator = _ref.paginator,
      results = _ref.results,
      pageActions = _ref.pageActions,
      aggregateField = _ref.aggregateField,
      Sum = _ref.Sum;

  var aggregateReducer = function aggregateReducer(total, currentValue) {
    return total + parseFloat(typeof aggregateField === "function" ? aggregateField(currentValue) : __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(currentValue, aggregateField));
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h2",
      null,
      title,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "small" },
        "\xA0Showing ",
        paginator.get("totalCount"),
        " Item(s)\xA0\xA0"
      ),
      createFilters(filters, paginator).map(function (f, index) {
        var filterTag = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
          { key: index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["d" /* FilterTag */], {
            label: f.get("label"),
            clear: function clear() {
              return pageActions.setFilter(f.get("key"), undefined);
            }
          }),
          "\xA0"
        );

        var withAuthorization = f.get("withAuthorization");

        if (withAuthorization) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4____["b" /* Authorized */],
            withAuthorization,
            filterTag
          );
        }

        return filterTag;
      }),
      aggregateField && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "float-right" },
        "\xA0Page Total:",
        " ",
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_formatters_currency__["a" /* dollars */])(results.reduce(aggregateReducer, 0).toFixed(2)),
        " ",
        "\xA0\xA0",
        ![null, undefined].includes(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(paginator.toJS(), "data.sum")) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          "/\xA0\xA0",
          __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(paginator.toJS(), "data.sum")
        ),
        Sum && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Sum, { paginator: paginator })
      ),
      children
    )
  );
}

TitleWithFilters.propTypes = _extends({
  aggregateField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  filters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    matchesTarget: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  })),
  setFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, __WEBPACK_IMPORTED_MODULE_4____["e" /* SearchPropTypes */]);

/***/ }),
/* 2378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parts_constants__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__decorators_withFieldAccessors__ = __webpack_require__(48);








function PartTypes(_ref) {
  var getInitialFieldValue = _ref.getInitialFieldValue;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hooks__["a" /* useCurrentUser */])();
  var partTypes = currentUser.tenant.part_types || __WEBPACK_IMPORTED_MODULE_5__parts_constants__["_24" /* TOOLING_PART_TYPES */];
  var initialValue = getInitialFieldValue ? getInitialFieldValue(__WEBPACK_IMPORTED_MODULE_5__parts_constants__["H" /* TOOLING_PART_TYPE */]) : null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["Field"], {
    name: __WEBPACK_IMPORTED_MODULE_5__parts_constants__["H" /* TOOLING_PART_TYPE */],
    component: __WEBPACK_IMPORTED_MODULE_2__Forms__["c" /* Select */],
    label: "Part Type",
    options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["d" /* arrayToProperCasedOptionsWithCurrentValue */])(partTypes, initialValue)
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__decorators_withFieldAccessors__["a" /* withFieldAccessors */])(PartTypes));

/***/ }),
/* 2379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony export (immutable) */ __webpack_exports__["a"] = PoCode;





function PoCode(_ref) {
  var inventory = _ref.inventory;

  // If there is no inventory object at all, don’t render anything:
  if (!inventory) return null;

  var purchaseOrderCode = inventory.purchase_order_code,
      most_recent_purchase_order = inventory.most_recent_purchase_order,
      purchaseOrderId = inventory.purchase_order_id,
      lotId = inventory.lot_id;


  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["isEmpty"])(most_recent_purchase_order) && purchaseOrderCode) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
      { to: "/purchase-orders/" + most_recent_purchase_order.uuid },
      purchaseOrderCode
    );
  }

  if (lotId) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
      { to: "/lots/" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(inventory, "lot_details.uuid") },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(inventory, "lot_details.code")
    );
  }

  return purchaseOrderId ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],
    { to: "/purchase-orders/" + purchaseOrderId },
    purchaseOrderCode
  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    null,
    purchaseOrderCode
  );
}

PoCode.propTypes = {
  inventory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    purchase_order_code: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    purchase_order_id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    most_recent_purchase_order: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    lot_id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  })
};

/***/ }),
/* 2380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PoCode__ = __webpack_require__(2379);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PoCode__["a"]; });



/***/ }),
/* 2381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony export (immutable) */ __webpack_exports__["a"] = PurchaseOrderLineItemStatusCell;




var getClass = function getClass(_ref) {
  var cancelled = _ref.cancelled,
      qtyReceived = _ref.quantity_received,
      quantity = _ref.quantity;
  return __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
    "green-table-cap": !cancelled && quantity === qtyReceived,
    "warning-table-cap": !cancelled && quantity !== qtyReceived,
    "danger-table-cap": cancelled
  });
};

function PurchaseOrderLineItemStatusCell(_ref2) {
  var lineItem = _ref2.lineItem,
      children = _ref2.children;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: getClass(lineItem) },
    children
  );
}

PurchaseOrderLineItemStatusCell.propTypes = {
  lineItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    cancelled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.boolean,
    quantity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  }).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)])
};

/***/ }),
/* 2382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DropDown_DropDownItem__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmAction_ConfirmAction__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PurchaseOrders_constants__ = __webpack_require__(19);
/* harmony export (immutable) */ __webpack_exports__["a"] = RemoveFromQCHold;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function RemoveFromQCHold(_ref) {
  var order = _ref.order,
      onConfirm = _ref.onConfirm,
      orderType = _ref.orderType;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      confirmationIsVisible = _useState2[0],
      setConfirmationVisibility = _useState2[1];

  if (!order.get(__WEBPACK_IMPORTED_MODULE_6__PurchaseOrders_constants__["R" /* QC_HOLD */])) {
    return false;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__DropDown_DropDownItem__["a" /* default */],
    { onClick: function onClick() {
        return setConfirmationVisibility(true);
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["k" /* Icon */], { name: "pause", fixed: true }),
    "\xA0Remove QC Hold",
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__ConfirmAction_ConfirmAction__["a" /* default */],
      {
        onConfirm: onConfirm,
        close: function close() {
          return setConfirmationVisibility(false);
        },
        open: confirmationIsVisible,
        btnClass: "btn-danger",
        btnText: "Yes, Remove from QC Hold",
        cancelText: "Cancel",
        icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "strong",
        null,
        "Heads up!"
      ),
      "\xA0 Are you sure you want to remove QC Hold from the ",
      orderType,
      "?"
    )
  );
}

RemoveFromQCHold.propTypes = {
  order: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired,
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  orderType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

RemoveFromQCHold.defaultProps = {
  orderType: "PO"
};

/***/ }),
/* 2383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony export (immutable) */ __webpack_exports__["a"] = SalesOrderLineItemStatusCell;




var getClass = function getClass(shipped, cancelled) {
  return __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
    "warning-table-cap": !shipped && !cancelled,
    "danger-table-cap": cancelled
  });
};

function SalesOrderLineItemStatusCell(_ref) {
  var cancelled = _ref.cancelled,
      shipped = _ref.shipped,
      children = _ref.children;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "td",
    { className: getClass(shipped, cancelled) },
    children
  );
}

SalesOrderLineItemStatusCell.propTypes = {
  cancelled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shipped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)])
};

/***/ }),
/* 2384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(808);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["b"]; });





/***/ }),
/* 2385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_throttle__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var SearchFilter = function (_Component) {
  _inherits(SearchFilter, _Component);

  function SearchFilter(props) {
    _classCallCheck(this, SearchFilter);

    var _this = _possibleConstructorReturn(this, (SearchFilter.__proto__ || Object.getPrototypeOf(SearchFilter)).call(this, props));

    _this.handleChange = function (e) {
      var value = e.target.value;

      _this.onChange(e.target.value);
      _this.setState({ value: value }, function () {
        // This callback function is executed after the state is updated
        if (_this.props.onValueChange) {
          _this.props.onValueChange(value); // Inform parent component of the new input value
        }
      });
      _this.props.onSubmit(value);
    };

    _this.handleSubmit = function (e) {
      var _this$props = _this.props,
          submitOnSingleResult = _this$props.submitOnSingleResult,
          results = _this$props.results;


      if (submitOnSingleResult && results.length === 1 && e.keyCode === 13) {
        submitOnSingleResult(results[0]);
      }
    };

    _this.state = {
      value: props.initialFilter || "" // Initialize the state with the initialFilter prop or an empty string
    };
    _this.onChange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_throttle__["a" /* default */])(props.onSubmit, 300);
    return _this;
  }

  _createClass(SearchFilter, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          initialFilter = _props.initialFilter,
          placeholder = _props.placeholder;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        autoFocus: true,
        className: "form-control input-lg",
        type: "search",
        onKeyUp: this.handleSubmit,
        onChange: this.handleChange,
        defaultValue: initialFilter,
        placeholder: placeholder
      });
    }
  }]);

  return SearchFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SearchFilter.propTypes = _extends({
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  initialFilter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  submitOnSingleResult: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onValueChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
}, __WEBPACK_IMPORTED_MODULE_3____["e" /* SearchPropTypes */]);
SearchFilter.defaultProps = {
  placeholder: ""
};
/* harmony default export */ __webpack_exports__["a"] = (SearchFilter);

/***/ }),
/* 2386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchFilter__ = __webpack_require__(2385);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SearchFilter__["a"]; });



/***/ }),
/* 2387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(16);
/* unused harmony export Section */




function Section(_ref) {
  var title = _ref.title,
      children = _ref.children,
      modal = _ref.modal,
      open = _ref.open,
      forceOpen = _ref.forceOpen,
      setForceOpen = _ref.setForceOpen,
      visible = _ref.visible,
      close = _ref.close,
      _ref$editable = _ref.editable,
      editable = _ref$editable === undefined ? true : _ref$editable;

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "h2",
    { style: { marginTop: 10 }, key: "heading" },
    title,
    editable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        type: "button",
        className: "btn btn-primary btn-hollow pull-right",
        onClick: open
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "i",
        { className: "fa fa-fw fa-pencil" },
        "\xA0"
      ),
      "Edit",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__Modal__["a" /* Modal */],
        {
          open: visible || forceOpen,
          close: close,
          dialogClass: modal.dialogClass
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__Modal__["b" /* Header */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modal__["c" /* Close */], { close: close }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h4",
            { className: "modal-title" },
            modal.title,
            modal.subtitle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "small",
                null,
                modal.subtitle
              )
            )
          )
        ),
        modal.content(function () {
          close();
          setForceOpen && setForceOpen(false);
        })
      )
    )
  ), children];
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__decorators__["e" /* toggleSwitch */])("visible")(Section));

/***/ }),
/* 2388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SendEmail__ = __webpack_require__(810);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SendEmail__["a"]; });


/***/ }),
/* 2389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DetailTable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(73);
/* harmony export (immutable) */ __webpack_exports__["a"] = ShippingAddressTable;







var shippingAddressLine = function shippingAddressLine(address) {
  var line1 = address.line1,
      line2 = address.line2;


  if (line2) {
    return line1 + ", " + line2;
  }

  return line1;
};

function ShippingAddressTable(_ref) {
  var address = _ref.address,
      fob = _ref.fob,
      shippingMethod = _ref.shippingMethod,
      _ref$renderCarrier = _ref.renderCarrier,
      renderCarrier = _ref$renderCarrier === undefined ? true : _ref$renderCarrier;

  var method = shippingMethod || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();
  var carrier = __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* CARRIERS */][method.get("carrier")] || {};

  return address && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__DetailTable__["a" /* DetailTable */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DetailTable__["b" /* Detail */], { label: "FOB", value: fob }),
      address.get("company_name") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DetailTable__["b" /* Detail */], { label: "Company Name", value: address.get("company_name") }),
      address.get("care_of") && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DetailTable__["b" /* Detail */], { label: "C/O", value: address.get("care_of") }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DetailTable__["b" /* Detail */], {
        label: "Address Line",
        value: shippingAddressLine(address.toJS())
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DetailTable__["b" /* Detail */], { label: "City", value: address.get("city") }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DetailTable__["b" /* Detail */], {
        label: "State/ Province/ Region",
        value: address.get("state")
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DetailTable__["b" /* Detail */], { label: "Zip/ Postal Code", value: address.get("postal_code") }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DetailTable__["b" /* Detail */], { label: "Country", value: address.get("country") })
    ),
    renderCarrier && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { key: "carrier-header", className: "hr-xs hr-dashed" }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__DetailTable__["a" /* DetailTable */],
      { key: "carrier-table" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DetailTable__["b" /* Detail */], { label: "Carrier", value: carrier.label }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DetailTable__["b" /* Detail */], {
        label: "Method",
        value: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(carrier.shippingMethods, method.get("shipping_method") + ".label")
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DetailTable__["b" /* Detail */], { label: "Account #", value: method.get("account_number") })
    )]
  );
}

ShippingAddressTable.propTypes = {
  address: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),
  shippingMethod: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])
};

/***/ }),
/* 2390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__decorators_withFormFields__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Orders_shared_ShippingFields_CompanyAddress__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Forms_FormTypes__ = __webpack_require__(78);







function ShipToCompany(props) {
  var company = props.company,
      setFOB = props.setFOB,
      shippingType = props.ship_to_type,
      companyId = props.ship_to_company_id,
      addressId = props.ship_to_company_address_id,
      addressPh = props.ship_to_address_phone,
      onChangeAddress = props.onChangeAddress;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Orders_shared_ShippingFields_CompanyAddress__["a" /* default */], {
    shippingType: shippingType,
    companyId: companyId,
    setFOB: setFOB,
    addressId: addressId,
    addressPh: addressPh,
    selectedCompany: !company || company.isEmpty() ? null : company.toJS(),
    onChangeAddress: onChangeAddress
  });
}

ShipToCompany.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),
  setFOB: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChangeAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ship_to_type: __WEBPACK_IMPORTED_MODULE_5__Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_5__Forms_FormTypes__["stringInput"]).isRequired,
  ship_to_company_id: __WEBPACK_IMPORTED_MODULE_5__Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_5__Forms_FormTypes__["malleable"]).isRequired,
  ship_to_company_address_id: __WEBPACK_IMPORTED_MODULE_5__Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_5__Forms_FormTypes__["malleable"]).isRequired,
  ship_to_address_phone: __WEBPACK_IMPORTED_MODULE_5__Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_5__Forms_FormTypes__["malleable"])
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__decorators_withFormFields__["a" /* default */])(ShipToCompany, ["ship_to_type", "ship_to_company_id", "ship_to_company_address_id", "ship_to_address_phone"]));

/***/ }),
/* 2391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isFunction__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_address__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__decorators_withFormFields__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Forms_FormTypes__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__companies_constants__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__companies_components_AddressFields__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RestictedAddressWarning_RestrictedAddressWarning__ = __webpack_require__(494);
/* unused harmony export ShipToCustomerAddress */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



















var addressLine = function addressLine(_ref) {
  var line1 = _ref.line1,
      line2 = _ref.line2,
      city = _ref.city,
      state = _ref.state,
      address = _objectWithoutProperties(_ref, ["line1", "line2", "city", "state"]);

  var parts = [line1, line2, city, state].filter(function (p) {
    return p;
  });

  return parts.join(", ") + " " + address.postal_code;
};

var NewAddress = function NewAddress(_ref2) {
  var copyBillingAddress = _ref2.copyBillingAddress,
      getField = _ref2.getField,
      setFieldValue = _ref2.setFieldValue;

  var addressFields = [__WEBPACK_IMPORTED_MODULE_13__constants__["s" /* LINE1 */], __WEBPACK_IMPORTED_MODULE_13__constants__["u" /* CITY */], __WEBPACK_IMPORTED_MODULE_13__constants__["v" /* STATE */], __WEBPACK_IMPORTED_MODULE_13__constants__["w" /* POSTAL_CODE */], __WEBPACK_IMPORTED_MODULE_13__constants__["r" /* COUNTRY */]].reduce(function (final, f) {
    return _extends({}, final, _defineProperty({}, f, getField(__WEBPACK_IMPORTED_MODULE_11__companies_constants__["l" /* PHYSICAL_ADDRESS */] + "." + f)));
  }, {});
  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_10__Forms_FormRow__["a" /* default */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
      { md: 12 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          className: "btn btn-success btn-sm btn-hollow",
          onClick: function onClick(ev) {
            ev.preventDefault();
            copyBillingAddress();
          }
        },
        "Same As Billing Address"
      )
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__companies_components_AddressFields__["b" /* AddressFields */], {
    path: __WEBPACK_IMPORTED_MODULE_11__companies_constants__["l" /* PHYSICAL_ADDRESS */],
    setFieldValue: setFieldValue,
    country: getField([__WEBPACK_IMPORTED_MODULE_11__companies_constants__["l" /* PHYSICAL_ADDRESS */], __WEBPACK_IMPORTED_MODULE_13__constants__["r" /* COUNTRY */]].join(".")),
    showRegion: true
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__RestictedAddressWarning_RestrictedAddressWarning__["a" /* default */], addressFields)];
};

NewAddress.propTypes = {
  copyBillingAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var ShipToCustomerAddress = function (_React$Component) {
  _inherits(ShipToCustomerAddress, _React$Component);

  function ShipToCustomerAddress() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, ShipToCustomerAddress);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = ShipToCustomerAddress.__proto__ || Object.getPrototypeOf(ShipToCustomerAddress)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
      addresses: []
    }, _this.onChangeAddress = function (address) {
      var onChangeAddress = _this.props.onChangeAddress;


      if (__WEBPACK_IMPORTED_MODULE_5_lodash_isFunction___default()(onChangeAddress)) {
        onChangeAddress(address);
      }
    }, _this.setCustomerAddressForRestrictedCheck = function (id) {
      var address = _this.state.addresses.find(function (a) {
        return Number(a.id) === Number(id);
      });
      if (address) {
        _this.setState({ selectedAddress: address });
      } else {
        _this.setState({ selectedAddress: {} });
      }
    }, _this.fetchAddresses = function (companyId) {
      var _this$props = _this.props,
          setFOB = _this$props.setFOB,
          ship_to_customer_address_id = _this$props.ship_to_customer_address_id;


      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].companies.physicalAddresses.search(companyId, {
        page: 1,
        limit: 100
      }).then(function (resp) {
        _this.setState({ addresses: resp.data.results }, function () {
          if (resp.data.results.length > 0) {
            var primaryAddress = resp.data.results.find(function (a) {
              return a.primary;
            });
            if (!ship_to_customer_address_id.input.value) {
              // set to default address if not set
              ship_to_customer_address_id.input.onChange(primaryAddress.id);
              _this.setCustomerAddressForRestrictedCheck(primaryAddress.id);
            }

            _this.onChangeAddress(primaryAddress);

            return setFOB && setFOB(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_address__["a" /* fobFormat */])(primaryAddress));
          }

          _this.onChangeAddress(null);

          return ship_to_customer_address_id.input.onChange(null);
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ShipToCustomerAddress, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var company = this.props.company;


      if (company && company.id) {
        this.fetchAddresses(company.id);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.company && !this.props.company || nextProps.company && nextProps.company.id && nextProps.company.id !== this.props.company.id) {
        this.onChangeAddress(null);

        this.fetchAddresses(nextProps.company.id);
      } else if (!nextProps.company) {
        this.setState({ addresses: [] });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          addresses = _state.addresses,
          selectedAddress = _state.selectedAddress;
      var _props = this.props,
          copyBillingAddress = _props.copyBillingAddress,
          getField = _props.getField,
          setFieldValue = _props.setFieldValue;


      if (addresses.length === 0 && copyBillingAddress) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewAddress, {
          copyBillingAddress: copyBillingAddress,
          setFieldValue: setFieldValue,
          getField: getField
        });
      }

      var options = addresses.map(function (a) {
        return {
          text: addressLine(a),
          value: a.id
        };
      });

      if (copyBillingAddress && options.length > 0) {
        options.push({
          text: "+ Add An Address",
          value: "other"
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
            { md: 8 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: __WEBPACK_IMPORTED_MODULE_13__constants__["_2" /* SHIP_TO_CUSTOMER_ADDRESS_ID */],
              component: __WEBPACK_IMPORTED_MODULE_6__Forms__["c" /* Select */],
              label: "Customer Address",
              required: true,
              options: options,
              prompt: false,
              onChange: function onChange(ev, val) {
                return _this2.setCustomerAddressForRestrictedCheck(val);
              }
            })
          )
        ),
        getField && getField(__WEBPACK_IMPORTED_MODULE_13__constants__["_2" /* SHIP_TO_CUSTOMER_ADDRESS_ID */]) === __WEBPACK_IMPORTED_MODULE_14__constants__["d" /* OTHER */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewAddress, {
          getField: getField,
          copyBillingAddress: copyBillingAddress,
          setFieldValue: setFieldValue
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__Forms_FormRow__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Col */],
            { md: 12 },
            selectedAddress && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__RestictedAddressWarning_RestrictedAddressWarning__["a" /* default */], selectedAddress)
          )
        )
      );
    }
  }]);

  return ShipToCustomerAddress;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ShipToCustomerAddress.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }),
  copyBillingAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getField: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setFOB: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChangeAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ship_to_customer_address_id: __WEBPACK_IMPORTED_MODULE_9__Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_9__Forms_FormTypes__["malleable"]).isRequired
};

ShipToCustomerAddress.defaultProps = {
  onChangeAddress: function onChangeAddress() {
    return null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__decorators_withFormFields__["a" /* default */])(ShipToCustomerAddress, [__WEBPACK_IMPORTED_MODULE_13__constants__["_2" /* SHIP_TO_CUSTOMER_ADDRESS_ID */]]));

/***/ }),
/* 2392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shippingTypes__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ShipToCustomerAddress__ = __webpack_require__(2391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ShipToCompany__ = __webpack_require__(2390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ShipToOther__ = __webpack_require__(811);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShipToFields; });











function ShipToFields(_ref) {
  var copyBillingAddress = _ref.copyBillingAddress,
      getFieldValue = _ref.getFieldValue,
      shipToCustomer = _ref.shipToCustomer,
      _setFieldValue = _ref.setFieldValue,
      setFOB = _ref.setFOB,
      shipToCompany = _ref.shipToCompany,
      shipToType = _ref.shipToType,
      setShippingToAddress = _ref.setShippingToAddress;

  var onChangeAddress = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (allowedShipToType) {
    return function (address) {
      if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(setShippingToAddress) && shipToType === allowedShipToType) {
        var onChange = setShippingToAddress(shipToType);

        onChange(address);
      }
    };
  }, [shipToType, setShippingToAddress]);

  if (!shipToType) {
    return [];
  }

  return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
    { "in": shipToType === __WEBPACK_IMPORTED_MODULE_4__shippingTypes__["b" /* CUSTOMER */], key: __WEBPACK_IMPORTED_MODULE_4__shippingTypes__["b" /* CUSTOMER */] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ShipToCustomerAddress__["a" /* default */], {
        copyBillingAddress: copyBillingAddress,
        company: shipToCustomer,
        setFieldValue: function setFieldValue(field, val) {
          return _setFieldValue(field)(val);
        },
        getField: getFieldValue,
        setFOB: setFOB,
        onChangeAddress: onChangeAddress(__WEBPACK_IMPORTED_MODULE_4__shippingTypes__["b" /* CUSTOMER */])
      })
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
    { "in": shipToType === __WEBPACK_IMPORTED_MODULE_4__shippingTypes__["d" /* COMPANY */], key: __WEBPACK_IMPORTED_MODULE_4__shippingTypes__["d" /* COMPANY */] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ShipToCompany__["a" /* default */], {
        company: shipToCompany,
        setFOB: setFOB,
        getField: getFieldValue,
        onChangeAddress: onChangeAddress(__WEBPACK_IMPORTED_MODULE_4__shippingTypes__["d" /* COMPANY */])
      })
    )
  ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
    { "in": shipToType === __WEBPACK_IMPORTED_MODULE_4__shippingTypes__["e" /* DROPSHIP */], key: __WEBPACK_IMPORTED_MODULE_4__shippingTypes__["e" /* DROPSHIP */] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ShipToOther__["a" /* default */], {
        key: shipToType,
        setFOB: setFOB,
        getField: getFieldValue
      })
    )
  )];
}
ShipToFields.propTypes = {
  getFieldValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  shipToCompany: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  shipToCustomer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Object),
  setFOB: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  setShippingToAddress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  shipToType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 2393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_states__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Forms_FormTypes__ = __webpack_require__(78);
/* harmony export (immutable) */ __webpack_exports__["a"] = State;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function State(_ref) {
  var country = _ref.country,
      state = _ref.state,
      props = _objectWithoutProperties(_ref, ["country", "state"]);

  if (country.input.value === "US") {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Forms__["c" /* Select */], _extends({
      options: __WEBPACK_IMPORTED_MODULE_1__lib_states__["a" /* states */],
      label: "State/Province/Region"
    }, state, props));
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Forms__["d" /* FormInput */], _extends({ label: "State/Province/Region" }, state, props));
}

State.propTypes = {
  country: __WEBPACK_IMPORTED_MODULE_3__Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_3__Forms_FormTypes__["stringInput"]).isRequired,
  state: __WEBPACK_IMPORTED_MODULE_3__Forms_FormTypes__["formField"](__WEBPACK_IMPORTED_MODULE_3__Forms_FormTypes__["stringInput"]).isRequired
};

/***/ }),
/* 2394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stat__ = __webpack_require__(497);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Stat__["a"]; });



/***/ }),
/* 2395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_formatters_number__ = __webpack_require__(72);
/* harmony export (immutable) */ __webpack_exports__["a"] = CancellationStatsTooltip;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();







function CancellationStatsTooltip(_ref) {
  var stats = _ref.stats;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var buttonRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);

  var handleMouseEnter = function handleMouseEnter() {
    setOpen(true);
  };
  var handleMouseLeave = function handleMouseLeave() {
    setOpen(false);
  };

  if (!stats) return null;
  if (!stats.cancellations) return null;
  if (Number(stats.purchase_items_cancelled_6_months_count) === 0) return null;

  var cancellationData = stats && stats.cancellations.map(function (c) {
    return [c.cancellation_reason === "cancelled_by_tenant" ? "Cancelled By Us" : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_formatters_text__["c" /* properCase */])(c.cancellation_reason), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_formatters_number__["a" /* percent */])(Number(c.count) / Number(stats.purchase_items_cancelled_6_months_count), 1)];
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
      className: "fa fa-info-circle",
      style: {
        cursor: "pointer",
        color: "rgba(255, 255, 255, 0.25)",
        fontSize: 12
      },
      ref: buttonRef,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* Overlay */],
      { target: buttonRef.current, show: open, placement: "right" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["b" /* Tooltip */],
        { id: "stat-tooltip", style: { cursor: "pointer" } },
        cancellationData && cancellationData.map(function (c) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            null,
            c[0],
            ": ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              null,
              c[1]
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)
          );
        })
      )
    )
  );
}

CancellationStatsTooltip.propTypes = {
  stats: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StatTooltip__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Detail__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Summary__ = __webpack_require__(2397);
/* harmony export (immutable) */ __webpack_exports__["a"] = CompanyStatsTooltip;







function CompanyStatsTooltip(_ref) {
  var company = _ref.company,
      context = _ref.context;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__StatTooltip__["a" /* default */], {
    entityId: company.id,
    fetchStats: function fetchStats() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reports.company_stats.search(company.id).then(function (res) {
        return res.data;
      });
    },
    renderStats: function renderStats(stats) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Summary__["a" /* default */], { stats: stats, context: context });
    },
    renderModal: function renderModal(stats) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Detail__["a" /* default */], { company: company, stats: stats, context: context });
    },
    modalTitle: company.name
  });
}

CompanyStatsTooltip.propTypes = {
  company: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }),
  context: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["standard", "repair"])
};

/***/ }),
/* 2397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SummaryStat__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__format__ = __webpack_require__(144);
/* harmony export (immutable) */ __webpack_exports__["a"] = Summary;







function Summary(_ref) {
  var stats = _ref.stats,
      context = _ref.context;

  return context === "repair" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RepairStationStatsSummary, { stats: stats }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StandardCompanyStatsSummary, { stats: stats });
}

Summary.propTypes = {
  stats: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}),
  context: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["standard", "repair"])
};

function StandardCompanyStatsSummary(_ref2) {
  var stats = _ref2.stats;

  var year = __WEBPACK_IMPORTED_MODULE_3_moment___default()().year();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "IQs - 6 mos",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["a" /* number */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "purchases.iqs_6_months_count"))
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "OQs - 6 mos",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["a" /* number */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "sales.oqs_6_months_count"))
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "POs - 6 mos",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["a" /* number */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "purchases.purchases_6_months_count"))
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "SOs - 6 mos",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["a" /* number */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "sales.sales_6_months_count"))
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "PO/IQ - 6 mos",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["d" /* percent */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "purchases.po_to_iq_6_months_percent"))
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "SO/OQ - 6 mos",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["d" /* percent */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "sales.so_to_oq_6_months_percent"))
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "Purchases - " + year,
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["b" /* dollar */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "purchases.purchases_current_year_dollars"))
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "Sales - " + year,
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["b" /* dollar */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "sales.sales_current_year_dollars"))
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "Purchases - " + (year - 1),
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["b" /* dollar */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "purchases.purchases_last_year_dollars"))
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "Sales - " + (year - 1),
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["b" /* dollar */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "sales.sales_last_year_dollars"))
    })
  );
}

StandardCompanyStatsSummary.propTypes = {
  stats: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

function RepairStationStatsSummary(_ref3) {
  var stats = _ref3.stats;

  var year = __WEBPACK_IMPORTED_MODULE_3_moment___default()().year();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "# Repairs Sent - " + year,
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["a" /* number */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "repairs.repairs_current_year_count"))
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "$ Repairs Sent - " + year,
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["b" /* dollar */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "repairs.repairs_current_year_dollars"))
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "# Repairs Sent - " + (year - 1),
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["a" /* number */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "repairs.repairs_last_year_count"))
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "$ Repairs Sent - " + (year - 1),
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["b" /* dollar */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "repairs.repairs_last_year_dollars"))
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "# Total Warranties - 12 mos.",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["c" /* numberAndPercent */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "repairs.warranties_12_months_count"), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "repairs.warranties_12_months_percent"))
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "# Warranties Accepted - 12 mos.",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["c" /* numberAndPercent */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "repairs.warranties_approved_12_months_count"), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "repairs.warranties_approved_12_months_percent"))
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "# Warranties Denied - 12 mos.",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["c" /* numberAndPercent */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "repairs.warranties_denied_12_months_count"), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "repairs.warranties_denied_12_months_percent"))
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "# Units in Stock Tagged By",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["a" /* number */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "repairs.units_in_stock_tagged_by_qty")),
      offset: 4
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SummaryStat__["a" /* default */], {
      label: "# Units At Shop",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["a" /* number */])(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(stats, "repairs.units_at_shop_qty"))
    })
  );
}

RepairStationStatsSummary.propTypes = {
  stats: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({})
};

/***/ }),
/* 2398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailStat__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__format__ = __webpack_require__(144);
/* unused harmony export default */






function Detail(_ref) {
  var stats = _ref.stats;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["d" /* Row */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 3, sm: 3 },
      "\xA0"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DetailStat__["a" /* default */], {
      label: "<12 mos",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__format__["b" /* dollar */])(stats.total_cost_0_to_12_months_dollars)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DetailStat__["a" /* default */], {
      label: "12 to 18 mos",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__format__["b" /* dollar */])(stats.total_cost_12_to_18_months_dollars)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DetailStat__["a" /* default */], {
      label: ">18 mos",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__format__["b" /* dollar */])(stats.total_cost_18_to_INF_months_dollars)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* Col */],
      { md: 3, sm: 3 },
      "\xA0"
    )
  );
}

Detail.propTypes = {
  stats: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StatTooltip__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Detail__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Summary__ = __webpack_require__(2400);
/* harmony export (immutable) */ __webpack_exports__["a"] = PartStatsTooltip;







function PartStatsTooltip(_ref) {
  var part = _ref.part;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__StatTooltip__["a" /* default */], {
    fetchStats: function fetchStats() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reports.part_stats.search(part.id).then(function (res) {
        return res.data;
      });
    },
    renderStats: function renderStats(stats) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Summary__["a" /* default */], { stats: stats });
    },
    renderModal: function renderModal(stats) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Detail__["a" /* default */], { stats: stats });
    },
    modalTitle: part.part_number
  });
}

PartStatsTooltip.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    part_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired
};

/***/ }),
/* 2400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SummaryStat__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__format__ = __webpack_require__(144);
/* harmony export (immutable) */ __webpack_exports__["a"] = Summary;





function Summary(_ref) {
  var stats = _ref.stats;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SummaryStat__["a" /* default */], {
      label: "Sold in 12 Mos",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__format__["a" /* number */])(stats.sold_in_12_months)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SummaryStat__["a" /* default */], {
      label: "Sold in 4 Mos",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__format__["a" /* number */])(stats.sold_in_4_months)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SummaryStat__["a" /* default */], {
      label: "Avg #Days in Stk",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__format__["a" /* number */])(stats.average_days_in_stock)
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SummaryStat__["a" /* default */], {
      label: "Avg #Times OQ pr/mo",
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__format__["a" /* number */])(stats.average_oq_per_month)
    })
  );
}

Summary.propTypes = {
  stats: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = StatusTag;




function StatusTag(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      onClick = _ref.onClick,
      _ref$display = _ref.display,
      display = _ref$display === undefined ? "danger" : _ref$display;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "span",
    {
      className: "label label-" + display,
      role: onClick && "button",
      onClick: onClick
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["k" /* Icon */], { name: icon }),
    "\xA0\xA0",
    title
  );
}

StatusTag.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  display: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 2402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = StatusTags;



function StatusTags(_ref) {
  var children = _ref.children;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "status-tags alert-group pull-right" },
    children
  );
}

StatusTags.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element)]).isRequired
};

/***/ }),
/* 2403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Tag = function (_Component) {
  _inherits(Tag, _Component);

  function Tag() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tag);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tag.__proto__ || Object.getPrototypeOf(Tag)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.onLabelClick = function (label) {
      return _this.props.onLabelClick && _this.props.onLabelClick(label);
    }, _this.open = function () {
      return _this.setState({ open: true });
    }, _this.close = function () {
      return _this.setState({ open: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tag, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          addOn = _props.addOn,
          className = _props.className,
          color = _props.color,
          label = _props.label,
          destroy = _props.destroy,
          onLabelClick = _props.onLabelClick;


      var labelColor = void 0;

      if (onLabelClick) {
        labelColor = color || "#FF9800";
      } else {
        labelColor = "#FFFFFF";
      }

      var labelStyle = {
        cursor: onLabelClick ? "pointer" : "default",
        color: labelColor
      };

      var labelClasses = __WEBPACK_IMPORTED_MODULE_4_classnames___default()("btn btn-xs btn-default", className);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "btn-group", style: { marginBottom: 4, marginRight: 2 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            style: labelStyle,
            type: "button",
            className: labelClasses,
            onClick: this.onLabelClick
          },
          addOn,
          label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2____["b" /* Authorized */],
          {
            permissions: [__WEBPACK_IMPORTED_MODULE_3__users_constants__["B" /* CAN_ADD_UPDATE_APPLICATIONS */]],
            roles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["without"])(__WEBPACK_IMPORTED_MODULE_3__users_constants__["v" /* ROLES */], __WEBPACK_IMPORTED_MODULE_3__users_constants__["j" /* WAREHOUSE */]),
            subroles: [__WEBPACK_IMPORTED_MODULE_3__users_constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */]]
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "button",
            {
              type: "button",
              className: "btn btn-xs btn-default",
              onClick: this.open
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-close" })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2____["q" /* ConfirmDelete */],
            {
              onConfirm: destroy,
              close: this.close,
              open: this.state.open
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              null,
              "Heads up!"
            ),
            " Are you sure you want to delete this?"
          )
        )
      );
    }
  }]);

  return Tag;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Tag.propTypes = {
  addOn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  destroy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onLabelClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (Tag);

/***/ }),
/* 2404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tag__ = __webpack_require__(2403);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Tag__["a"]; });



/***/ }),
/* 2405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_superman_s_symbol_svg__ = __webpack_require__(2752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_superman_s_symbol_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_superman_s_symbol_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parts_constants__ = __webpack_require__(23);







var TierTypeIcon = function TierTypeIcon(_ref) {
  var part = _ref.part,
      keepWhiteSpace = _ref.keepWhiteSpace,
      size = _ref.size,
      position = _ref.position,
      inline = _ref.inline,
      tier_type_key = _ref.tier_type_key;

  var hasIcon = [__WEBPACK_IMPORTED_MODULE_4__parts_constants__["b" /* SATL */]].includes(part[tier_type_key]);

  var inlineClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ "align-middle": !inline });
  var className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("tier-type-icon", inlineClassName, {
    "tier-type-icon--small": size === "small",
    "tier-type-icon--left": position === "left",
    "tier-type-icon--right": position === "right"
  });

  if (!keepWhiteSpace && !hasIcon) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: className },
    part[tier_type_key] === __WEBPACK_IMPORTED_MODULE_4__parts_constants__["b" /* SATL */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_3__assets_images_superman_s_symbol_svg___default.a, alt: __WEBPACK_IMPORTED_MODULE_4__parts_constants__["b" /* SATL */], className: inlineClassName })
  );
};

TierTypeIcon.propTypes = {
  part: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    part_number: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  keepWhiteSpace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tier_type_key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["small", "normal"]),
  position: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["left", "right"])
};

TierTypeIcon.defaultProps = {
  keepWhiteSpace: true,
  inline: false,
  size: "normal",
  position: "left",
  tier_type_key: "tier_type"
};

/* unused harmony default export */ var _unused_webpack_default_export = (TierTypeIcon);

/***/ }),
/* 2406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TierTypeIcon__ = __webpack_require__(2405);
/* unused harmony reexport default */


/***/ }),
/* 2407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony export (immutable) */ __webpack_exports__["a"] = ToggleButton;




function ToggleButton(_ref) {
  var toggled = _ref.toggled,
      handleClick = _ref.handleClick,
      _ref$canRemove = _ref.canRemove,
      canRemove = _ref$canRemove === undefined ? false : _ref$canRemove,
      _ref$text = _ref.text,
      text = _ref$text === undefined ? "Toggle" : _ref$text,
      _ref$toggledText = _ref.toggledText,
      toggledText = _ref$toggledText === undefined ? "Untoggle" : _ref$toggledText;

  var label = toggled ? toggledText : text;
  var style = {
    color: "#fff",
    borderColor: "#0398db",
    minWidth: "60px"
  };
  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()("btn btn-xs", __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
    "text-muted": toggled,
    "btn btn-primary": !toggled,
    "btn-default": toggled
  }));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "button",
    {
      type: "submit",
      onClick: handleClick,
      style: style,
      disabled: !canRemove,
      className: classes
    },
    label
  );
}

ToggleButton.propTypes = {
  toggled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  handleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  canRemove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggledText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 2408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ToggleButton__ = __webpack_require__(2407);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ToggleButton__["a"]; });



/***/ }),
/* 2409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Warning_Warning__ = __webpack_require__(53);
/* harmony export (immutable) */ __webpack_exports__["a"] = TransitionConfirmAction;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();






function TransitionConfirmAction(_ref) {
  var onConfirm = _ref.onConfirm,
      open = _ref.open,
      close = _ref.close,
      children = _ref.children,
      _ref$warningWrapper = _ref.warningWrapper,
      warningWrapper = _ref$warningWrapper === undefined ? true : _ref$warningWrapper,
      _ref$btnClass = _ref.btnClass,
      btnClass = _ref$btnClass === undefined ? "btn-primary" : _ref$btnClass,
      _ref$btnText = _ref.btnText,
      btnText = _ref$btnText === undefined ? "Okay" : _ref$btnText,
      _ref$showButton = _ref.showButton,
      showButton = _ref$showButton === undefined ? true : _ref$showButton,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === undefined ? "Cancel" : _ref$cancelText,
      _ref$icon = _ref.icon,
      icon = _ref$icon === undefined ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-check" }) : _ref$icon,
      _ref$message = _ref.message,
      message = _ref$message === undefined ? "Are you sure you want to do this?" : _ref$message,
      _ref$modalSize = _ref.modalSize,
      modalSize = _ref$modalSize === undefined ? "modal-sm" : _ref$modalSize;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState2 = _slicedToArray(_useState, 2),
      disabled = _useState2[0],
      setDisabled = _useState2[1];

  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isSubmitting = _useState4[0],
      setIsSubmitting = _useState4[1];

  var confirm = function confirm() {
    setDisabled(true);
    setIsSubmitting(true);

    onConfirm().finally(function () {
      setIsSubmitting(false);
      close();
      setDisabled(false);
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__Modal__["a" /* Modal */],
    { open: open, close: close, dialogClass: modalSize },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modal__["b" /* Header */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modal__["c" /* Close */], { close: close }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h4",
        { className: "modal-title" },
        "Are You Sure?"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modal__["e" /* Body */],
      null,
      warningWrapper ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__Warning_Warning__["a" /* default */],
        null,
        children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          " ",
          message
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "strong",
            null,
            "Heads up!"
          ),
          " ",
          message
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__Modal__["d" /* Footer */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        { type: "button", className: "btn btn-default", onClick: close },
        cancelText
      ),
      showButton && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "button",
        {
          type: "button",
          className: "btn " + btnClass,
          onClick: confirm,
          disabled: disabled
        },
        isSubmitting ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-cog fa-spin fa-fw fa-lg" }) : icon,
        " ",
        isSubmitting ? "Saving" : btnText
      )
    )
  );
}

TransitionConfirmAction.propTypes = {
  onConfirm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  warningWrapper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  btnClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  btnText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cancelText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)]),
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modalSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 2410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AgnosticLoader = function (_Component) {
  _inherits(AgnosticLoader, _Component);

  function AgnosticLoader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AgnosticLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AgnosticLoader.__proto__ || Object.getPrototypeOf(AgnosticLoader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loading: true,
      id: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AgnosticLoader, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      this.setState({ loading: true });
      var _props = this.props,
          id = _props.id,
          fetch = _props.fetch;

      fetch(id).then(function () {
        return _this2.setState({ loading: false });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(_extends({}, this.state));
    }
  }]);

  return AgnosticLoader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AgnosticLoader.propTypes = {
  fetch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (AgnosticLoader);

/***/ }),
/* 2411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgnosticLoader__ = __webpack_require__(2410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AgnosticLoader__["a"]; });



/***/ }),
/* 2412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Container = function (_Component) {
  _inherits(Container, _Component);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  _createClass(Container, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "setState",
    value: function setState() {
      if (this.mounted) {
        var _get2;

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        (_get2 = _get(Container.prototype.__proto__ || Object.getPrototypeOf(Container.prototype), "setState", this)).call.apply(_get2, [this].concat(args));
      }
    }
  }]);

  return Container;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 2413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__);
/* unused harmony export DataTable */
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





function DataTable(_ref) {
  var Table = _ref.component,
      props = _objectWithoutProperties(_ref, ["component"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Table, props);
}

DataTable.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__orange_marmalade_paginate_this__["decorators"].tabulate(DataTable));

/***/ }),
/* 2414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataTable__ = __webpack_require__(2413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DataTable__["a"]; });



/***/ }),
/* 2415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_domHelpers__ = __webpack_require__(625);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Dismissible = function (_Component) {
  _inherits(Dismissible, _Component);

  function Dismissible() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dismissible);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dismissible.__proto__ || Object.getPrototypeOf(Dismissible)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      visible: _this.props.show
    }, _this.onClickAway = function (e) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_domHelpers__["a" /* default */])(_this.content).contains(e.target)) {
        _this.close();
      }
    }, _this.toggle = function (e) {
      e.stopPropagation();
      _this.setState(function (state) {
        return { visible: _this.listen(!state.visible) };
      });
    }, _this.open = function () {
      return _this.setState({ visible: _this.listen(true) });
    }, _this.close = function () {
      return _this.setState({ visible: _this.listen(false) });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dismissible, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("click", this.onClickAway);
    }
  }, {
    key: "listen",
    value: function listen() {
      var on = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (on) {
        document.addEventListener("click", this.onClickAway);
      } else {
        document.removeEventListener("click", this.onClickAway);
      }

      return on;
    }
  }]);

  return Dismissible;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Dismissible.propTypes = {
  show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Dismissible.defaultProps = {
  show: false
};
/* harmony default export */ __webpack_exports__["a"] = (Dismissible);

/***/ }),
/* 2416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dismissible__ = __webpack_require__(2415);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dismissible__["a"]; });



/***/ }),
/* 2417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalLauncher__ = __webpack_require__(355);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ImportNew = function (_ModalLauncher) {
  _inherits(ImportNew, _ModalLauncher);

  function ImportNew() {
    _classCallCheck(this, ImportNew);

    return _possibleConstructorReturn(this, (ImportNew.__proto__ || Object.getPrototypeOf(ImportNew)).apply(this, arguments));
  }

  _createClass(ImportNew, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: this.props.spanClass },
        this.button()
      );
    }
  }]);

  return ImportNew;
}(__WEBPACK_IMPORTED_MODULE_1__ModalLauncher__["a" /* default */]);

ImportNew.defaultProps = {
  text: "  Import Part",
  buttonClass: "btn-info",
  spanClass: "input-group-btn"
};
/* harmony default export */ __webpack_exports__["a"] = (ImportNew);

/***/ }),
/* 2418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal(props) {
    _classCallCheck(this, Portal);

    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this, props));

    _this.portalRoot = document.getElementById("modal-root");
    _this.el = document.createElement("div");
    return _this;
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.portalRoot.appendChild(this.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.portalRoot.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react_dom__["createPortal"](this.props.children, this.el);
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node)])
};

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 2419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var RecordLoader = function (_Component) {
  _inherits(RecordLoader, _Component);

  function RecordLoader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RecordLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RecordLoader.__proto__ || Object.getPrototypeOf(RecordLoader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loading: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RecordLoader, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      var _props = this.props,
          fetch = _props.fetch,
          id = _props.id;


      this.setState({ loading: true });
      fetch(id).then(function () {
        return _this2.setState({ loading: false });
      });
    }

    // Required for us to navigate to another record when only the ID in the path is changing.
    // Eg: /users/10 -> /users/11

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref2) {
      var _this3 = this;

      var match = _ref2.match;
      var _props2 = this.props,
          fetch = _props2.fetch,
          id = _props2.id;

      var newId = match.params.id;

      if (newId !== id) {
        this.setState({ loading: true });
        fetch(newId).then(function () {
          return _this3.setState({ loading: false });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.loading) {
        return false;
      }

      return this.props.children;
    }
  }]);

  return RecordLoader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

RecordLoader.propTypes = {
  fetch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,
  match: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};
/* harmony default export */ __webpack_exports__["a"] = (RecordLoader);

/***/ }),
/* 2420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RecordLoader__ = __webpack_require__(2419);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RecordLoader__["a"]; });



/***/ }),
/* 2421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Toggle = function (_Component) {
  _inherits(Toggle, _Component);

  function Toggle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Toggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      toggling: false,
      opening: false,
      closing: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Toggle, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.open && nextProps.open) {
        this.fadeIn();
      }

      if (this.props.open && !nextProps.open) {
        this.fadeOut();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        this.setState({ opening: true });
      } else if (prevProps.open && !this.props.open) {
        this.setState({ closing: true });
      }
    }
  }, {
    key: "fadeIn",
    value: function fadeIn() {
      var _this2 = this;

      this.setState({ toggling: true });
      setTimeout(function () {
        _this2.setState({ toggling: false, opening: false });
      }, 300);
    }
  }, {
    key: "fadeOut",
    value: function fadeOut() {
      var _this3 = this;

      this.setState({ toggling: true });
      setTimeout(function () {
        _this3.setState({ toggling: false, closing: false });
      }, 300);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          open = _props.open,
          children = _props.children;
      var _state = this.state,
          toggling = _state.toggling,
          opening = _state.opening,
          closing = _state.closing;


      var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        collapse: !toggling,
        in: open && !toggling,
        collapsing: toggling
      });

      var styles = {};

      if (closing) {
        styles.height = "0px";
      } else if (opening || toggling && !open) {
        var _childContainer$getBo = this.childContainer.getBoundingClientRect(),
            height = _childContainer$getBo.height;

        styles.height = height + "px";
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: classes, style: styles },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            ref: function ref(node) {
              _this4.childContainer = node;
            }
          },
          (open || toggling) && children
        )
      );
    }
  }]);

  return Toggle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Toggle.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element
};
/* unused harmony default export */ var _unused_webpack_default_export = (Toggle);

/***/ }),
/* 2422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Container__ = __webpack_require__(2412);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ToggleSwitch = function (_Container) {
  _inherits(ToggleSwitch, _Container);

  function ToggleSwitch() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ToggleSwitch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToggleSwitch.__proto__ || Object.getPrototypeOf(ToggleSwitch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      visible: _this.props.visible
    }, _this.open = function () {
      return _this.setState({ visible: true });
    }, _this.close = function () {
      return _this.setState({ visible: false });
    }, _this.toggle = function () {
      return _this.setState(function (state) {
        return { visible: !state.visible };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ToggleSwitch, [{
    key: "render",
    value: function render() {
      return this.props.children(this.state.visible, this.open, this.close, this.toggle);
    }
  }]);

  return ToggleSwitch;
}(__WEBPACK_IMPORTED_MODULE_0__Container__["a" /* default */]);

ToggleSwitch.defaultProps = {
  visible: false
};
/* harmony default export */ __webpack_exports__["a"] = (ToggleSwitch);

/***/ }),
/* 2423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wire__ = __webpack_require__(821);
/* harmony export (immutable) */ __webpack_exports__["a"] = authorized;


function Authorized(_ref) {
  var children = _ref.children,
      canView = _ref.canView;

  if (canView) {
    return children;
  }

  return false;
}

function authorized() {
  for (var _len = arguments.length, allowedRoles = Array(_len), _key = 0; _key < _len; _key++) {
    allowedRoles[_key] = arguments[_key];
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wire__["a" /* default */])(allowedRoles, "canView", Authorized);
}

/***/ }),
/* 2424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wireIf__ = __webpack_require__(822);
/* unused harmony export default */


function Authorized(_ref) {
  var children = _ref.children,
      canView = _ref.canView;

  if (canView) {
    return children;
  }

  return false;
}

function authorized(lambda) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wireIf__["a" /* default */])(lambda, "canView", Authorized);
}

/***/ }),
/* 2425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wire__ = __webpack_require__(821);
/* unused harmony export default */



function Disabled(_ref) {
  var children = _ref.children,
      authorized = _ref.authorized;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, { disabled: !authorized });
}

function disabled() {
  for (var _len = arguments.length, allowedRoles = Array(_len), _key = 0; _key < _len; _key++) {
    allowedRoles[_key] = arguments[_key];
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wire__["a" /* default */])(allowedRoles.concat("admin"), "authorized", Disabled);
}

/***/ }),
/* 2426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wireIf__ = __webpack_require__(822);
/* harmony export (immutable) */ __webpack_exports__["a"] = disabledUnless;



function Disabled(_ref) {
  var children = _ref.children,
      authorized = _ref.authorized;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, { disabled: !authorized });
}

function disabledUnless(lambda) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wireIf__["a" /* default */])(lambda, "authorized", Disabled);
}

/***/ }),
/* 2427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authorized__ = __webpack_require__(2423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__authorized__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__authorizedIf__ = __webpack_require__(2424);
/* unused harmony reexport authorizedIf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__disabled__ = __webpack_require__(2425);
/* unused harmony reexport disabled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__disabledUnless__ = __webpack_require__(2426);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__disabledUnless__["a"]; });









/***/ }),
/* 2428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_CreateNew__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__launchModal__ = __webpack_require__(499);
/* harmony export (immutable) */ __webpack_exports__["a"] = createNew;



function createNew(modal) {
  var New = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0__containers_CreateNew__["a" /* default */];

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__launchModal__["a" /* default */])(modal, New);
}

/***/ }),
/* 2429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dismissible__ = __webpack_require__(825);
/* harmony export (immutable) */ __webpack_exports__["a"] = dropdown;
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





function dropdown(DropDown) {
  var _class, _temp;

  var Container = (_temp = _class = function (_Component) {
    _inherits(Container, _Component);

    function Container() {
      _classCallCheck(this, Container);

      return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
    }

    _createClass(Container, [{
      key: "getChildContext",
      value: function getChildContext() {
        return { close: this.props.close };
      }
    }, {
      key: "render",
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropDown, this.props);
      }
    }]);

    return Container;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = {
    close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  }, _class.childContextTypes = {
    close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }, _temp);

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dismissible__["a" /* dismissibleChild */])(Container);
}

/***/ }),
/* 2430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_ImportNew__ = __webpack_require__(2417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__launchModal__ = __webpack_require__(499);
/* unused harmony export default */



function importNew(modal) {
  var New = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0__containers_ImportNew__["a" /* default */];

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__launchModal__["a" /* default */])(modal, New);
}

/***/ }),
/* 2431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(36);
/* harmony export (immutable) */ __webpack_exports__["a"] = linkTo;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




function linkTo(path) {
  return function (Component) {
    return function (_React$Component) {
      _inherits(_class2, _React$Component);

      function _class2() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, _class2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          clicked: false
        }, _this.click = function () {
          return _this.setState({ clicked: true });
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(_class2, [{
        key: "render",
        value: function render() {
          if (this.state.clicked) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */], { to: path(this.props), push: true });
          }

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, this.props, { transition: this.click }));
        }
      }]);

      return _class2;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
  };
}

/***/ }),
/* 2432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony export (immutable) */ __webpack_exports__["a"] = manageFields;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



function manageFields(fields) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return {};
  };

  return function (Component) {
    return function (_React$Component) {
      _inherits(_class2, _React$Component);

      function _class2() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, _class2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class2.__proto__ || Object.getPrototypeOf(_class2)).call.apply(_ref, [this].concat(args))), _this), _this.state = fields, _this.updateField = function (field) {
          return function (val) {
            return _this.setState(_defineProperty({}, field, val));
          };
        }, _this.toggleField = function (field) {
          return function () {
            return _this.setState(function (state) {
              return _defineProperty({}, field, !state[field]);
            });
          };
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(_class2, [{
        key: "render",
        value: function render() {
          var props = _extends({}, this.props, this.state, {
            updateField: this.updateField,
            toggleField: this.toggleField
          });

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, props, selector(props)));
        }
      }]);

      return _class2;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
  };
}

/***/ }),
/* 2433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dataManager__ = __webpack_require__(824);
/* harmony export (immutable) */ __webpack_exports__["a"] = miniTable;
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



function miniTable(api) {
  var _this = this;

  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dataManager__["a" /* default */])("results", function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(props) {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api(props, { limit: limit });

            case 2:
              response = _context.sent;
              return _context.abrupt("return", response.data.results);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x2) {
      return _ref.apply(this, arguments);
    };
  }(), []);
}

/***/ }),
/* 2434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony export (immutable) */ __webpack_exports__["a"] = onChange;
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



function onChange(handler) {
  return function (Component) {
    return function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
          handler(this.props, nextProps);
        }
      }, {
        key: "render",
        value: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, this.props);
        }
      }]);

      return _class;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
  };
}

/***/ }),
/* 2435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__);
/* harmony export (immutable) */ __webpack_exports__["a"] = tabulateImmutable;


function tabulateImmutable(Component) {
  return __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["decorators"].decorate(Component, function (_ref) {
    var paginator = _ref.paginator;
    return {
      results: paginator.get("results"),
      isLoading: paginator.get("isLoading")
    };
  });
}

/***/ }),
/* 2436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(6);
/* harmony export (immutable) */ __webpack_exports__["a"] = toggle;
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





function toggle(Component) {
  var Container = function Container(_ref) {
    var open = _ref.open,
        rest = _objectWithoutProperties(_ref, ["open"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */],
      { "in": open },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, rest)
      )
    );
  };

  Container.propTypes = {
    open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  };

  return Container;
}

/***/ }),
/* 2437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers__ = __webpack_require__(74);
/* harmony export (immutable) */ __webpack_exports__["a"] = toggleSwitch;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function toggleSwitch(propName) {
  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return function (Component) {
    return function (props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__containers__["a" /* ToggleSwitch */],
        { visible: initialValue },
        function (visible, open, close, toggle) {
          var childProps = _extends({}, props, _defineProperty({}, propName, visible));

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, childProps, {
            open: open,
            close: close,
            toggle: toggle
          }));
        }
      );
    };
  };
}

/***/ }),
/* 2438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(2);
/* unused harmony export default */
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




function withErrorBoundary(Comp) {
  function WithErrorBoundary(_ref) {
    var rest = _objectWithoutProperties(_ref, []);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__components__["a" /* ErrorBoundary */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Comp, rest)
    );
  }

  return WithErrorBoundary;
}

/***/ }),
/* 2439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__);
/* harmony export (immutable) */ __webpack_exports__["a"] = withFilters;


function withFilters(Component) {
  return __WEBPACK_IMPORTED_MODULE_0__orange_marmalade_paginate_this__["decorators"].decorate(Component, function (_ref) {
    var paginator = _ref.paginator;
    return {
      totalCount: paginator.get("totalCount"),
      filters: paginator.get("filters").toJS()
    };
  });
}

/***/ }),
/* 2440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var withPolling = function withPolling(WrappedComponent) {
  var WithPolling = function (_React$Component) {
    _inherits(WithPolling, _React$Component);

    function WithPolling() {
      _classCallCheck(this, WithPolling);

      return _possibleConstructorReturn(this, (WithPolling.__proto__ || Object.getPrototypeOf(WithPolling)).apply(this, arguments));
    }

    _createClass(WithPolling, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _props = this.props,
            refresh = _props.refresh,
            _props$refreshRate = _props.refreshRate,
            refreshRate = _props$refreshRate === undefined ? 30000 : _props$refreshRate;

        if (refresh) {
          this.intervalId = window.setInterval(refresh.bind(this), refreshRate);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        clearInterval(this.intervalId);
      }
    }, {
      key: "render",
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, this.props);
      }
    }]);

    return WithPolling;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  WithPolling.propTypes = {
    refresh: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    refreshRate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  };

  return WithPolling;
};

/* harmony default export */ __webpack_exports__["a"] = (withPolling);

/***/ }),
/* 2441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(95);
/* unused harmony export ActivateUser */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ActivateUser = function (_Component) {
  _inherits(ActivateUser, _Component);

  function ActivateUser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ActivateUser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivateUser.__proto__ || Object.getPrototypeOf(ActivateUser)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      modalOpen: false
    }, _this.openModal = function () {
      return _this.setState({ modalOpen: true });
    }, _this.closeModal = function () {
      return _this.setState({ modalOpen: false });
    }, _this.activateUser = function () {
      _this.props.updateUser({ active: true });
      _this.closeModal();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ActivateUser, [{
    key: "render",
    value: function render() {
      var modalOpen = this.state.modalOpen;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            className: "btn btn-success pull-right",
            style: { marginLeft: "20px" },
            onClick: this.openModal
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
          " Activate User"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
          { open: modalOpen, close: this.closeModal, dialogClass: "modal-sm" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: this.closeModal }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Are You Sure?"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["e" /* Body */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "alert alert-warning margin-bottom-none" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "media" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "media-left" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-warning text-warning" })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "media-body" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    "Heads up!"
                  ),
                  " Are you sure you want to activate this user?"
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["d" /* Footer */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              {
                type: "button",
                className: "btn btn-default",
                onClick: this.closeModal
              },
              "Cancel"
            ),
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              {
                type: "submit",
                className: "btn btn-success",
                onClick: this.activateUser
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
              " Yes, Activate User"
            )
          )
        )
      );
    }
  }]);

  return ActivateUser;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ActivateUser.propTypes = {
  updateUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { updateUser: __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* update */] })(ActivateUser));

/***/ }),
/* 2442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActivateUser__ = __webpack_require__(2441);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ActivateUser__["a"]; });



/***/ }),
/* 2443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Fields__ = __webpack_require__(2444);
/* unused harmony export adminFields */







var select = function select(state, ownProps) {
  return {
    canEdit: ownProps.isNew || state.session.getIn([__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ID */]]) !== state.userDetail.getIn([__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* USER */], __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ID */]])
  };
};

function adminFields(Component) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_decorators__["i" /* authorized */])()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(select)(Component));
}

/* harmony default export */ __webpack_exports__["a"] = (adminFields(__WEBPACK_IMPORTED_MODULE_4__Fields__["a" /* default */]));

/***/ }),
/* 2444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_forms__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_DashedSeparator__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_decorators_withFieldAccessors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_components_NoteTooltip_NoteTooltip__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TeamMembers__ = __webpack_require__(2445);
/* unused harmony export AdminFields */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();


















function AdminFields(_ref) {
  var canEdit = _ref.canEdit,
      role = _ref.role,
      getFieldValue = _ref.getFieldValue,
      setFieldValue = _ref.setFieldValue,
      user = _ref.user;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__hooks__["a" /* useCurrentUser */])();

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(Number(getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["Q" /* COMMISSION_CREDIT_PERCENT */])) > 0 || Number(getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["N" /* TEAM_LEADER_CREDIT_PERCENT */])) > 0),
      _useState2 = _slicedToArray(_useState, 2),
      hasCommission = _useState2[0],
      setHasCommission = _useState2[1];

  var labelClasses = __WEBPACK_IMPORTED_MODULE_12_classnames___default()("btn btn-default", {
    active: hasCommission
  });

  var disablePermissions = function disablePermissions() {
    setFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["D" /* PERMISSIONS */])([]);
    setFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["C" /* SUBROLE */])(null);
  };

  return canEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_DashedSeparator__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
      name: __WEBPACK_IMPORTED_MODULE_6__constants__["h" /* ROLE */],
      component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
      label: "Role & Permissions",
      options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_6__constants__["L" /* USER_ROLES */]),
      onChange: disablePermissions,
      required: true
    }),
    [__WEBPACK_IMPORTED_MODULE_6__constants__["p" /* QUALITY_CONTROL */], __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* WAREHOUSE */], __WEBPACK_IMPORTED_MODULE_6__constants__["m" /* ACCOUNTING */], __WEBPACK_IMPORTED_MODULE_6__constants__["k" /* SALES */]].includes(role) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["h" /* FormGroup */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
        name: __WEBPACK_IMPORTED_MODULE_6__constants__["C" /* SUBROLE */],
        component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
        label: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["C" /* SUBROLE */]), getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["C" /* SUBROLE */]) === __WEBPACK_IMPORTED_MODULE_6__constants__["S" /* SALES_MANAGER */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_NoteTooltip_NoteTooltip__["a" /* default */], {
          color: "rgba(255, 255, 255, 0.25)",
          icon: "fa-info-circle",
          note: "Can set Tier-Types for Inventory.  Can delete Legacy Inventory"
        })],
        options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_6__constants__["T" /* SUBROLES_BY_ROLE */][role])
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
        { sm: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              className: "btn-group btn-group-justified btn-group-vertical",
              "data-toggle": "buttons"
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: "can_sign_electronically",
              component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
              label: "QC Auth Rep Digital Signature"
            })
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["U" /* NOTIFICATION_ROLES */] },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["U" /* NOTIFICATION_ROLES */]),
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_NoteTooltip_NoteTooltip__["a" /* default */], {
              color: "rgba(255, 255, 255, 0.25)",
              icon: "fa-info-circle",
              note: "Choose additional roles you'd like this user to receive notifications for."
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              id: "notification_roles",
              className: "btn-group btn-group-vertical btn-group-justified",
              "data-toggle": "buttons"
            },
            __WEBPACK_IMPORTED_MODULE_6__constants__["V" /* NOTIFICATION_ROLES_ARRAY */].map(function (f) {
              var roles = getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["U" /* NOTIFICATION_ROLES */]) || [];
              var hasRole = roles.includes(f);
              var roleHasNotification = getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["h" /* ROLE */]) === f;
              var subRoleHasNotification = getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["C" /* SUBROLE */]) === f;
              var active = __WEBPACK_IMPORTED_MODULE_12_classnames___default()("btn btn-default", {
                active: hasRole || roleHasNotification || subRoleHasNotification
              });
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                {
                  className: active,
                  htmlFor: f,
                  onClick: function onClick() {
                    if (hasRole) {
                      var index = roles.indexOf(f);
                      roles.splice(index, 1);
                      setFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["U" /* NOTIFICATION_ROLES */])(roles);
                    } else {
                      setFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["U" /* NOTIFICATION_ROLES */])(roles.concat(f));
                    }
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
                "\xA0\xA0",
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(f)
              );
            })
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
        { md: 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { className: "control-label", htmlFor: __WEBPACK_IMPORTED_MODULE_6__constants__["D" /* PERMISSIONS */] },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["D" /* PERMISSIONS */]),
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_NoteTooltip_NoteTooltip__["a" /* default */], {
              color: "rgba(255, 255, 255, 0.25)",
              icon: "fa-info-circle",
              note: "Override role permissions."
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              id: __WEBPACK_IMPORTED_MODULE_6__constants__["D" /* PERMISSIONS */],
              className: "btn-group btn-group-vertical btn-group-justified",
              "data-toggle": "buttons"
            },
            Object.keys(__WEBPACK_IMPORTED_MODULE_6__constants__["F" /* PERMISSIONS_OPTIONS */]).map(function (f) {
              var permissions = getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["D" /* PERMISSIONS */]) || [];
              var hasPermission = permissions.includes(f);
              var roleHasPermission = __WEBPACK_IMPORTED_MODULE_6__constants__["G" /* ROLES_WITH_PERMISSION */][f] && __WEBPACK_IMPORTED_MODULE_6__constants__["G" /* ROLES_WITH_PERMISSION */][f].includes(getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["h" /* ROLE */]));
              var subroleHasPermission = __WEBPACK_IMPORTED_MODULE_6__constants__["W" /* SUBROLES_WITH_PERMISSION */][f] && __WEBPACK_IMPORTED_MODULE_6__constants__["W" /* SUBROLES_WITH_PERMISSION */][f].includes(getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["C" /* SUBROLE */]));

              var active = __WEBPACK_IMPORTED_MODULE_12_classnames___default()("btn btn-default", {
                active: hasPermission || roleHasPermission || subroleHasPermission
              });
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "label",
                {
                  className: active,
                  htmlFor: f,
                  onClick: function onClick() {
                    if (hasPermission) {
                      var index = permissions.indexOf(f);
                      permissions.splice(index, 1);
                      setFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["D" /* PERMISSIONS */])(permissions);
                    } else {
                      setFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["D" /* PERMISSIONS */])(permissions.concat(f));
                    }
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
                "\xA0\xA0",
                __WEBPACK_IMPORTED_MODULE_6__constants__["F" /* PERMISSIONS_OPTIONS */][f].text
              );
            })
          )
        )
      )
    ),
    (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers__["c" /* hasAnyOfRoles */])({
      role: getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["h" /* ROLE */]),
      permissions: getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["D" /* PERMISSIONS */])
    }, [__WEBPACK_IMPORTED_MODULE_6__constants__["i" /* ADMIN */], __WEBPACK_IMPORTED_MODULE_6__constants__["l" /* REPAIR */], __WEBPACK_IMPORTED_MODULE_6__constants__["k" /* SALES */]]) || __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* WAREHOUSE_LOGISTICS_DIRECTOR */] === getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["C" /* SUBROLE */])) && currentUser.role === __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* ADMIN */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
        { md: hasCommission ? 6 : 12 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["h" /* FormGroup */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              id: "has_commission",
              className: "btn-group btn-group-justified",
              "data-toggle": "buttons",
              style: { marginTop: 21 }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "label",
              {
                className: labelClasses,
                htmlFor: "has_commissions",
                onClick: function onClick() {
                  if (hasCommission) {
                    setFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["Q" /* COMMISSION_CREDIT_PERCENT */])(0);
                  }
                  setHasCommission(!hasCommission);
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-check-circle" }),
              "\xA0\xA0Enable Commissions"
            )
          )
        )
      ),
      hasCommission && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_6__constants__["Q" /* COMMISSION_CREDIT_PERCENT */],
          component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
          type: "number",
          label: "Commission Percent"
        })
      )
    ),
    hasCommission && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
          { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["X" /* TEAM_LEADER_COMMISSION_ENABLED */]) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_6__constants__["X" /* TEAM_LEADER_COMMISSION_ENABLED */],
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
            label: "Team Leader Commission"
          })
        )
      )
    ), getFieldValue(__WEBPACK_IMPORTED_MODULE_6__constants__["X" /* TEAM_LEADER_COMMISSION_ENABLED */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["FieldArray"], {
      name: "team_members",
      component: __WEBPACK_IMPORTED_MODULE_15__TeamMembers__["a" /* default */],
      teamMembers: user.team_members
    })],
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__shared_components_Forms_FormRow__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: "po_approval_role",
          component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["c" /* Select */],
          label: "PO Approval Permissions",
          options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_forms__["a" /* toOptions */])(__WEBPACK_IMPORTED_MODULE_6__constants__["Y" /* PO_APPROVAL_ROLES */]),
          prompt: false,
          required: true
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_react_bootstrap__["e" /* Col */],
        { md: 6 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["a" /* CheckGroup */],
          { title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["Z" /* AIRLINE_SERVICES_NOTIFICATION */]) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_6__constants__["Z" /* AIRLINE_SERVICES_NOTIFICATION */],
            component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
            label: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["Z" /* AIRLINE_SERVICES_NOTIFICATION */]), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_NoteTooltip_NoteTooltip__["a" /* default */], {
              color: "rgba(255, 255, 255, 0.25)",
              icon: "fa-info-circle",
              note: "Sends Notification when an OQ meet these criteria:\n\n1. Customer Type = Airline; and\n\n2. OQ = Offer; and\n\n3. Offer Type=LookingFor; and 4. Company has Sellable Stock"
            })]
          })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "form-group" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "btn-group btn-group-justified btn-group-vertical",
          "data-toggle": "buttons"
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_6__constants__["_0" /* HIGH_CONFIDENCE_BUYER */],
          component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
          label: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["_0" /* HIGH_CONFIDENCE_BUYER */]), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_NoteTooltip_NoteTooltip__["a" /* default */], {
            note: "No Tier Type Restrictions",
            icon: "fa-info-circle",
            color: "rgba(255, 255, 255, 0.25)"
          })]
        }),
        role === __WEBPACK_IMPORTED_MODULE_6__constants__["m" /* ACCOUNTING */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_6__constants__["_1" /* EXCHANGE_COMMISSIONS */],
          component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["b" /* Check */],
          label: ["Receives Exchange Commission", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_components_NoteTooltip_NoteTooltip__["a" /* default */], {
            note: "For 2nd and 3rd exchanges only",
            icon: "fa-info-circle",
            color: "rgba(255, 255, 255, 0.25)"
          })]
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
          name: __WEBPACK_IMPORTED_MODULE_6__constants__["O" /* BUYING_LIMIT */],
          component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms__["d" /* FormInput */],
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_6__constants__["O" /* BUYING_LIMIT */]),
          type: "number",
          inputProps: { min: "0" }
        })
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state, ownProps) {
  return {
    role: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_form__["formValueSelector"])(ownProps.formName)(state, __WEBPACK_IMPORTED_MODULE_6__constants__["h" /* ROLE */])
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__shared_decorators_withFieldAccessors__["a" /* withFieldAccessors */])(AdminFields)));

/***/ }),
/* 2445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_NumberInput_NumberInput__ = __webpack_require__(141);
/* harmony export (immutable) */ __webpack_exports__["a"] = TeamMembers;









function TeamMembers(_ref) {
  var fields = _ref.fields,
      teamMembers = _ref.teamMembers;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    fields.map(function (field, index) {
      var teamMember = teamMembers[index];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { key: "team-member-" + (field + index) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
            { md: 4 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: field + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["M" /* USER_ID */],
              label: "Seller",
              placeholder: "Type a user's name...",
              component: __WEBPACK_IMPORTED_MODULE_3__shared_components_Forms__["n" /* AutoCompleteField */],
              search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__actions__["c" /* searchRoleUsers */])([__WEBPACK_IMPORTED_MODULE_6__constants__["k" /* SALES */]]),
              formatItem: function formatItem(result) {
                return result && result.full_name;
              },
              selectedItem: teamMember,
              required: true
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
            { md: 5 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["Field"], {
              name: field + "." + __WEBPACK_IMPORTED_MODULE_6__constants__["N" /* TEAM_LEADER_CREDIT_PERCENT */],
              component: __WEBPACK_IMPORTED_MODULE_7__shared_components_Forms_NumberInput_NumberInput__["a" /* default */],
              roundDigits: 1,
              required: true,
              label: "Commission Percent"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["e" /* Col */],
            { md: 2 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              {
                type: "button",
                className: "btn btn-xs btn-default btn-hollow",
                style: { marginTop: 10 },
                onClick: function onClick() {
                  return fields.remove(index);
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
              " \xA0Remove"
            )
          )
        )
      );
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        type: "button",
        onClick: function onClick() {
          return fields.push({});
        },
        className: "btn btn-primary btn-hollow",
        style: { marginTop: 5, marginBottom: 15 }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-plus" }),
      " Add Team Member"
    )
  );
}

TeamMembers.defaultProps = {
  fields: []
};

TeamMembers.propTypes = {
  fields: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    length: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    push: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
  })
};

/***/ }),
/* 2446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(2447);
/* harmony export (immutable) */ __webpack_exports__["a"] = CreateUser;





function CreateUser(_ref) {
  var open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-sm" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Add a User"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close, initialValues: { manager: false } })
    )
  );
}

CreateUser.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Admin__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Locations_components_ReduxFormLocationsDropdown__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__validate__ = __webpack_require__(2449);
/* unused harmony export Form */









var formName = "createUser";

function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "row row-col-gutters-half" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "first_name",
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["t" /* LargeInput */],
            label: "First Name",
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "last_name",
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["t" /* LargeInput */],
            label: "Last Name",
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], { name: "email", component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["t" /* LargeInput */], label: "Email", required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "row row-col-gutters-half" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "password",
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["t" /* LargeInput */],
            type: "password",
            label: "Password",
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "col-md-6" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: "confirm",
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["t" /* LargeInput */],
            type: "password",
            label: "Retype Password",
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Locations_components_ReduxFormLocationsDropdown__["a" /* default */], { required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Admin__["a" /* default */], { isNew: true, formName: formName })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { onSubmit: __WEBPACK_IMPORTED_MODULE_3__actions__["g" /* create */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_7__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 2448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateUser__ = __webpack_require__(2446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CreateUser__["a"]; });



/***/ }),
/* 2449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Locations_constants__ = __webpack_require__(264);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;




function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate("first_name", "last_name", "email", "password", "confirm", "role", __WEBPACK_IMPORTED_MODULE_2__Locations_constants__["a" /* LOCATION_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["a" /* required */]);
    v.validate("confirm").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["i" /* matches */]("password"));
    v.validate("email").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["b" /* isValidEmail */]);
  });
}

/***/ }),
/* 2450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(95);
/* unused harmony export DeactivateUser */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DeactivateUser = function (_Component) {
  _inherits(DeactivateUser, _Component);

  function DeactivateUser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DeactivateUser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeactivateUser.__proto__ || Object.getPrototypeOf(DeactivateUser)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      modalOpen: false
    }, _this.openModal = function () {
      return _this.setState({ modalOpen: true });
    }, _this.closeModal = function () {
      return _this.setState({ modalOpen: false });
    }, _this.deactivateUser = function () {
      _this.props.updateUser({ active: false });
      _this.closeModal();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DeactivateUser, [{
    key: "render",
    value: function render() {
      var modalOpen = this.state.modalOpen;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            className: "btn btn-danger pull-right",
            style: { marginLeft: "20px" },
            onClick: this.openModal
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
          " Deactivate User"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
          { open: modalOpen, close: this.closeModal, dialogClass: "modal-sm" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: this.closeModal }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Are You Sure?"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["e" /* Body */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "alert alert-warning margin-bottom-none" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "media" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "media-left" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-warning text-warning" })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "media-body" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "strong",
                    null,
                    "Heads up!"
                  ),
                  " Deactivating a user will prevent them from being able to log into the system. Users can be re-activeate at any time by users with administration privileges."
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["d" /* Footer */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              {
                type: "button",
                className: "btn btn-default",
                onClick: this.closeModal
              },
              "Cancel"
            ),
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "button",
              {
                type: "submit",
                className: "btn btn-danger",
                onClick: this.deactivateUser
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-ban" }),
              " Yes, Deactivate User"
            )
          )
        )
      );
    }
  }]);

  return DeactivateUser;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DeactivateUser.propTypes = {
  updateUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { updateUser: __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* update */] })(DeactivateUser));

/***/ }),
/* 2451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DeactivateUser__ = __webpack_require__(2450);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DeactivateUser__["a"]; });



/***/ }),
/* 2452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_decorators__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_RecordPager__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inventories_constants__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__VerifyEmail_VerifyEmail__ = __webpack_require__(2469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__EnableMfa_EnableMfa__ = __webpack_require__(2458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EditUser__ = __webpack_require__(2456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__UpdatePassword__ = __webpack_require__(2466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ActivateUser__ = __webpack_require__(2442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DeactivateUser__ = __webpack_require__(2451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers__ = __webpack_require__(41);
/* unused harmony export Detail */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var Detail = function (_Component) {
  _inherits(Detail, _Component);

  function Detail() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Detail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Detail.__proto__ || Object.getPrototypeOf(Detail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editUserModalOpen: false,
      updatePasswordModalOpen: false
    }, _this.openEditUserModal = function () {
      _this.setState({ editUserModalOpen: true });
    }, _this.closeEditUserModal = function () {
      return _this.setState({ editUserModalOpen: false });
    }, _this.openUpdatePasswordModal = function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_form__["reset"])("updatePassword");
      _this.setState({ updatePasswordModalOpen: true });
    }, _this.closeUpdatePasswordModal = function () {
      return _this.setState({ updatePasswordModalOpen: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Detail, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          currentUser = _props.currentUser,
          user = _props.user;
      var _state = this.state,
          editUserModalOpen = _state.editUserModalOpen,
          updatePasswordModalOpen = _state.updatePasswordModalOpen;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "page-header page-header-bar" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h1",
            null,
            user.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */]) !== currentUser.get(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ID */]) && (user.get(__WEBPACK_IMPORTED_MODULE_9__constants__["I" /* ACTIVE */]) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__DeactivateUser__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ActivateUser__["a" /* default */], null)),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__EnableMfa_EnableMfa__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__VerifyEmail_VerifyEmail__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "with-padding" },
              currentUser.get(__WEBPACK_IMPORTED_MODULE_9__constants__["h" /* ROLE */]) === __WEBPACK_IMPORTED_MODULE_9__constants__["i" /* ADMIN */] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_components_RecordPager__["a" /* default */], { baseUrl: "/users", record: user }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
                  className: "img-circle",
                  src: "/assets/images/profile-blank.jpg",
                  alt: "profile"
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                null,
                user.get(__WEBPACK_IMPORTED_MODULE_9__constants__["J" /* FIRST_NAME */]),
                " ",
                user.get(__WEBPACK_IMPORTED_MODULE_9__constants__["K" /* LAST_NAME */])
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "col-md-4 col-lg-3" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "panel panel-default panel-sidebar" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "panel-body" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h2",
                  { style: { marginTop: "10px" } },
                  "Details",
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["y" /* EditButton */], { handleClick: this.openEditUserModal }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__EditUser__["a" /* default */], {
                    user: user.toJS(),
                    open: editUserModalOpen,
                    close: this.closeEditUserModal
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "table",
                  { className: "table table-condensed" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "tbody",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tr",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "th",
                        null,
                        "Name"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        user.get("first_name"),
                        " ",
                        user.get("last_name")
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tr",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "th",
                        null,
                        "Email"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          "a",
                          { href: "mailto:" + user.get("email") },
                          user.get("email")
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tr",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "th",
                        null,
                        "Role"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        __WEBPACK_IMPORTED_MODULE_9__constants__["L" /* USER_ROLES */][user.get(__WEBPACK_IMPORTED_MODULE_9__constants__["h" /* ROLE */])] && __WEBPACK_IMPORTED_MODULE_9__constants__["L" /* USER_ROLES */][user.get(__WEBPACK_IMPORTED_MODULE_9__constants__["h" /* ROLE */])].label
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tr",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "th",
                        null,
                        "Subrole"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__helpers__["b" /* subroleLabel */])(user.get(__WEBPACK_IMPORTED_MODULE_9__constants__["h" /* ROLE */]), user.get(__WEBPACK_IMPORTED_MODULE_9__constants__["C" /* SUBROLE */]))
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "tr",
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "th",
                        null,
                        "Location"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "td",
                        null,
                        user.getIn([__WEBPACK_IMPORTED_MODULE_10__inventories_constants__["_0" /* LOCATION */], __WEBPACK_IMPORTED_MODULE_11__constants__["S" /* NAME */]]) || ""
                      )
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", { className: "hr-sm" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "h2",
                  null,
                  "Password",
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "button",
                    {
                      type: "button",
                      className: "btn btn-primary btn-hollow pull-right",
                      onClick: this.openUpdatePasswordModal
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      "i",
                      { className: "fa fa-fw fa-refresh" },
                      "\xA0"
                    ),
                    "Update"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__UpdatePassword__["a" /* default */], {
                    open: updatePasswordModalOpen,
                    close: this.closeUpdatePasswordModal
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["z" /* AuditFields */], { record: user, multiLine: true })
              )
            )
          )
        )
      );
    }
  }]);

  return Detail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Detail.propTypes = {
  currentUser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    user: state.userDetail.get("user"),
    currentUser: state.session.get("user")
  };
})(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_decorators__["h" /* loadRecord */])({
  reducer: "userDetail",
  name: "user",
  action: __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* show */]
})(Detail)));

/***/ }),
/* 2453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Detail__ = __webpack_require__(2452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Detail__["a"]; });



/***/ }),
/* 2454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(2455);
/* harmony export (immutable) */ __webpack_exports__["a"] = EditUser;





function EditUser(_ref) {
  var open = _ref.open,
      close = _ref.close,
      user = _ref.user;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-md" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Update Details"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], {
        close: close,
        initialValues: user,
        user: user,
        enableReinitialize: true
      })
    )
  );
}

EditUser.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};

/***/ }),
/* 2455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Admin__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Locations_components_ReduxFormLocationsDropdown__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__validate__ = __webpack_require__(2457);
/* unused harmony export Form */














var formName = "editUser";

function Form(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_5__constants__["J" /* FIRST_NAME */],
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_5__constants__["J" /* FIRST_NAME */]),
            required: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Col */],
          { md: 6 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
            name: __WEBPACK_IMPORTED_MODULE_5__constants__["K" /* LAST_NAME */],
            component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_5__constants__["K" /* LAST_NAME */]),
            required: true
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        name: __WEBPACK_IMPORTED_MODULE_8__constants__["T" /* EMAIL */],
        component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
        label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib_formatters_text__["c" /* properCase */])(__WEBPACK_IMPORTED_MODULE_8__constants__["T" /* EMAIL */]),
        required: true
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Locations_components_ReduxFormLocationsDropdown__["a" /* default */], { required: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Admin__["a" /* default */], { formName: formName, user: props.user })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { onSubmit: __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* update */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: __WEBPACK_IMPORTED_MODULE_12__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 2456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditUser__ = __webpack_require__(2454);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EditUser__["a"]; });



/***/ }),
/* 2457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Locations_constants__ = __webpack_require__(264);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;





function validateItem(item) {
  item.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["M" /* USER_ID */], __WEBPACK_IMPORTED_MODULE_1__constants__["N" /* TEAM_LEADER_CREDIT_PERCENT */]).required();
}

function validate(values, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["J" /* FIRST_NAME */], __WEBPACK_IMPORTED_MODULE_1__constants__["K" /* LAST_NAME */], __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* EMAIL */], __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* ROLE */], __WEBPACK_IMPORTED_MODULE_3__Locations_constants__["a" /* LOCATION_ID */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["a" /* required */]);
    v.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* EMAIL */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["b" /* isValidEmail */]);

    v.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["O" /* BUYING_LIMIT */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["g" /* requiredAllowZero */]);

    if ([__WEBPACK_IMPORTED_MODULE_1__constants__["P" /* BUYER */], __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* SALES */]].includes(props.values.role)) {
      v.validate(__WEBPACK_IMPORTED_MODULE_1__constants__["Q" /* COMMISSION_CREDIT_PERCENT */]).satisfies(__WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["g" /* requiredAllowZero */], __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["e" /* isGreaterThanOrEqualTo */](0), __WEBPACK_IMPORTED_MODULE_2__lib_validation_rules__["k" /* isLessThanOrEqualTo */](100));
    }

    v.validateChildren(__WEBPACK_IMPORTED_MODULE_1__constants__["R" /* TEAM_MEMBERS */], validateItem);
  });
}

/***/ }),
/* 2458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks__ = __webpack_require__(38);






function EnableMfa(props) {
  var user = props.user;

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__hooks__["a" /* useCurrentUser */])();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    user.id === currentUser.id && currentUser.tenant.mfa_enabled && !user.mfa_enabled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        className: "btn btn-primary pull-right",
        style: { marginLeft: "20px" },
        onClick: props.enableMfa
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-phone" }),
      " Enable Mfa"
    )
  );
}

EnableMfa.propTypes = {
  enableMfa: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return { user: state.userDetail.toJS().user };
}, {
  enableMfa: __WEBPACK_IMPORTED_MODULE_3__actions__["f" /* enableMfa */]
})(EnableMfa));

/***/ }),
/* 2459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_decorators__ = __webpack_require__(17);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_decorators__["j" /* createNew */])(function (open, close) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["c" /* CreateUser */], { open: open, close: close });
}));

/***/ }),
/* 2460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_filters__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hooks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Table__ = __webpack_require__(2462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NewUser__ = __webpack_require__(2459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pagination__ = __webpack_require__(500);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();















var filters = [{
  label: "Show All Users",
  filters: { all_roles: true, active: true }
}, {
  label: "Show Admin",
  filters: { admin_role: true }
}, {
  label: "Show Accounting",
  filters: { accounting_role: true }
}, {
  label: "Show Quality Control",
  filters: { quality_control_role: true }
}, {
  label: "Show Repair",
  filters: { repair_role: true }
}, {
  label: "Show Sales",
  filters: { sales_role: true }
}, {
  label: "Show Warehouse",
  filters: { warehouse_role: true }
}, {
  label: "Show Active",
  filters: { active: true }
}, {
  label: "Show Deactivated",
  filters: { active: false }
}];

var Note = function Note() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_components__["j" /* NoteTooltip */], {
    note: "You have reached your seat limit.",
    icon: "fa-info-circle",
    color: "#545454"
  });
};

var filterTags = [{
  label: "All Roles",
  key: "all_roles",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Admin",
  key: "admin_role",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Active",
  key: "active",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Accounting",
  key: "accounting_role",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Deactivated",
  key: "active",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(false)
}, {
  label: "Quality Control",
  key: "quality_control_role",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Repair",
  key: "repair_role",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Sales",
  key: "sales_role",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}, {
  label: "Warehouse",
  key: "warehouse_role",
  matchesTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_filters__["a" /* matchesBoolean */])(true)
}];

function UsersSearch(_ref) {
  var pushHistory = _ref.pushHistory;

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeUsers = _useState2[0],
      setActiveUsers = _useState2[1];

  var currentUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__hooks__["a" /* useCurrentUser */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].users.search({ active: true }).then(function (_ref2) {
      var count = _ref2.data.total_count;

      setActiveUsers(count);
    });
  });

  var disableNewUsers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(currentUser, "tenant.seats", 0) <= activeUsers;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__shared_components__["c" /* Search */],
    { search: __WEBPACK_IMPORTED_MODULE_12__pagination__["a" /* pagination */], syncWithUrl: true },
    function (searchProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "form-group form-group-searchbar has-feedback has-feedback-left" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "text-muted fa fa-search form-control-feedback form-control-feedback-left" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "input-group" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__["a" /* SearchFilter */], _extends({}, searchProps, {
              placeholder: "Type a user's name or email address...",
              submitOnSingleResult: function submitOnSingleResult(r) {
                return pushHistory("/users/" + r.uuid);
              }
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__["b" /* FilterSelect */], _extends({}, searchProps, { filters: filters, right: true })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NewUser__["a" /* default */], {
              disabled: disableNewUsers,
              text: disableNewUsers ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Note, null), "Create New"] : "  Create New"
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__["c" /* TitleWithFilters */], _extends({}, searchProps, {
          title: "Users",
          filters: filterTags
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Table__["a" /* default */], searchProps),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_components_Pagination__["d" /* Pagination */], searchProps)
      );
    }
  );
}

UsersSearch.propTypes = {
  pushHistory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_4_react_router_redux__["push"] })(UsersSearch));

/***/ }),
/* 2461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony export (immutable) */ __webpack_exports__["a"] = Status;



function Status(_ref) {
  var active = _ref.active;

  if (!active) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "label label-danger" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-warning" }),
      "\xA0\xA0Deactivated"
    );
  }

  return false;
}

Status.propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 2462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_components_MultiLocationFeature_MultiLocationFeature__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_ExchangeCommissionIcon__ = __webpack_require__(2470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Status__ = __webpack_require__(2461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers__ = __webpack_require__(41);
/* unused harmony export Table */













function renderRow(r, pushHistory) {
  var classes = __WEBPACK_IMPORTED_MODULE_4_classnames___default()("clickable", { deactivated: !r.active });
  var handleMailto = function handleMailto(e) {
    e.stopPropagation();
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "tr",
    {
      key: r.id,
      className: classes,
      onClick: function onClick() {
        return pushHistory("/users/" + r.uuid);
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.first_name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.last_name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        { href: "mailto:" + r.email, onClick: handleMailto },
        r.email
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "td",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["o" /* LocationFlag */], { location: r.location_id }),
        " "
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_6__constants__["L" /* USER_ROLES */][r.role] && __WEBPACK_IMPORTED_MODULE_6__constants__["L" /* USER_ROLES */][r.role].label,
      r.exchange_commissions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__shared_ExchangeCommissionIcon__["a" /* default */], null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers__["b" /* subroleLabel */])(r.role, r.subrole)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      r.buying_limit > 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_formatters_currency__["a" /* dollars */])(r.buying_limit)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      { className: "text-center" },
      r.po_approval_role === "super_approver" && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_components__["k" /* Icon */], { name: "check text-success" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "td",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Status__["a" /* default */], { active: r.active })
    )
  );
}

function Table(_ref) {
  var results = _ref.results,
      pushHistory = _ref.pushHistory,
      isLoading = _ref.isLoading,
      pageActions = _ref.pageActions;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */],
    { loading: isLoading, refresh: pageActions.expire },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Head,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "First Name"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Last Name"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Email"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__shared_components_MultiLocationFeature_MultiLocationFeature__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "th",
          null,
          "Location"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Role"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Subrole"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Buyer Credit Limit"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        { className: "text-center" },
        "Super approver"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "th",
        null,
        "Status"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__shared_components__["s" /* DataTable */].Body,
      null,
      results.map(function (r) {
        return renderRow(r, pushHistory);
      })
    )
  );
}

Table.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    first_name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired
  })).isRequired,
  pushHistory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
  pageActions: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(undefined, { pushHistory: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"] })(Table));

/***/ }),
/* 2463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(2460);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });



/***/ }),
/* 2464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validate__ = __webpack_require__(2467);
/* unused harmony export Form */








function Form(props) {
  var password = document.querySelector("#password");
  var confirm = document.querySelector("#confirm");

  var handleClickPassword = function handleClickPassword() {
    var type = password.getAttribute("type") === __WEBPACK_IMPORTED_MODULE_5__constants__["_11" /* PASSWORD */] ? "text" : __WEBPACK_IMPORTED_MODULE_5__constants__["_11" /* PASSWORD */];
    password.setAttribute("type", type);
  };

  var handleClickConfirmation = function handleClickConfirmation() {
    var type = confirm.getAttribute("type") === __WEBPACK_IMPORTED_MODULE_5__constants__["_11" /* PASSWORD */] ? "text" : __WEBPACK_IMPORTED_MODULE_5__constants__["_11" /* PASSWORD */];
    confirm.setAttribute("type", type);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */],
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        name: "password",
        component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
        type: "password",
        addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
          style: { cursor: "pointer" },
          className: "fa fa-fw fa-eye",
          onClick: handleClickPassword
        }),
        label: "Password",
        required: true
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["Field"], {
        name: "confirm",
        component: __WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["d" /* FormInput */],
        type: "password",
        addon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
          style: { cursor: "pointer" },
          className: "fa fa-fw fa-eye",
          onClick: handleClickConfirmation
        }),
        label: "Retype Password",
        required: true
      })
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(undefined, { onSubmit: __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* update */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_components_Forms__["j" /* form */])({
  form: "updatePassword",
  validate: __WEBPACK_IMPORTED_MODULE_6__validate__["a" /* default */]
})(Form)));

/***/ }),
/* 2465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(2464);
/* harmony export (immutable) */ __webpack_exports__["a"] = UpdatePassword;





function UpdatePassword(_ref) {
  var open = _ref.open,
      close = _ref.close;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["a" /* Modal */],
      { open: open, close: close, dialogClass: "modal-sm" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["b" /* Header */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_components_Modal__["c" /* Close */], { close: close }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          { className: "modal-title" },
          "Update Password"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], { close: close })
    )
  );
}

UpdatePassword.propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  close: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/***/ }),
/* 2466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UpdatePassword__ = __webpack_require__(2465);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__UpdatePassword__["a"]; });



/***/ }),
/* 2467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__ = __webpack_require__(25);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;



function validate(values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_validate_this__["a" /* validator */])(values, function (v) {
    v.validate("confirm").satisfies(__WEBPACK_IMPORTED_MODULE_1__lib_validation_rules__["i" /* matches */]("password"));
  });
}

/***/ }),
/* 2468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms_FormRow__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_validate_this__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_validation_rules__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_submission__ = __webpack_require__(49);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













var formName = "verifyEmail";

function Form(props) {
  var submit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_submission__["b" /* onSuccess */])(props.handleSubmit, props.close, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["e" /* Form */],
    _extends({}, props, { onSubmit: submit }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["e" /* Form */].Body,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__shared_components_Forms_FormRow__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Col */],
          { md: 12 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["Field"], {
            name: "token",
            component: __WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["d" /* FormInput */],
            label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_formatters_text__["c" /* properCase */])("token"),
            required: true
          })
        )
      )
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(undefined, { onSubmit: __WEBPACK_IMPORTED_MODULE_7__actions__["e" /* verify */] })(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_components_Forms__["j" /* form */])({
  form: formName,
  validate: function validate(values) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib_validate_this__["a" /* validator */])(values, function (f) {
      f.validate("token").satisfies(__WEBPACK_IMPORTED_MODULE_9__lib_validation_rules__["a" /* required */]);
    });
  }
})(Form)));

/***/ }),
/* 2469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form__ = __webpack_require__(2468);
/* unused harmony export VerifyEmail */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var VerifyEmail = function (_Component) {
  _inherits(VerifyEmail, _Component);

  function VerifyEmail() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, VerifyEmail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VerifyEmail.__proto__ || Object.getPrototypeOf(VerifyEmail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      modalOpen: false
    }, _this.openModal = function () {
      return _this.setState({ modalOpen: true });
    }, _this.closeModal = function () {
      return _this.setState({ modalOpen: false });
    }, _this.requestVerification = function () {
      _this.props.requestVerification({ active: false });
      _this.closeModal();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VerifyEmail, [{
    key: "render",
    value: function render() {
      var modalOpen = this.state.modalOpen;
      var user = this.props.user;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        !user.verification_sent && !user.email_verified && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            className: "btn btn-primary pull-right",
            style: { marginLeft: "20px" },
            onClick: this.requestVerification
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-envelope" }),
          " Validate Email"
        ),
        user.verification_sent && !user.email_verified && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            className: "btn btn-primary pull-right",
            style: { marginLeft: "20px" },
            onClick: this.openModal
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-fw fa-envelope" }),
          " Verify Email"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["a" /* Modal */],
          { open: modalOpen, close: this.closeModal, dialogClass: "modal-sm" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["b" /* Header */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__shared_components_Modal__["c" /* Close */], { close: this.closeModal }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h4",
              { className: "modal-title" },
              "Enter Token Sent To Email"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Form__["a" /* default */], { close: this.closeModal })
        )
      );
    }
  }]);

  return VerifyEmail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

VerifyEmail.propTypes = {
  requestVerification: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return { user: state.userDetail.toJS().user };
}, {
  requestVerification: __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* sendVerificationRequest */]
})(VerifyEmail));

/***/ }),
/* 2470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(6);
/* harmony export (immutable) */ __webpack_exports__["a"] = ExchangeCommissionsIcon;



function ExchangeCommissionsIcon() {
  /* eslint react/no-danger: 0 */
  var tooltip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["b" /* Tooltip */],
    { className: "in" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { dangerouslySetInnerHTML: { __html: "Exchange Manager" } })
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* OverlayTrigger */],
    { placement: "top", overlay: tooltip },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "span",
      { className: "fa-stack fa-1x", style: { marginLeft: "10px" } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "fa fa-lg fa-circle text-success" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        {
          className: "fa fa-stack-1x exchange-circle-text",
          style: { left: "-5px" }
        },
        "E"
      )
    )
  );
}

/***/ }),
/* 2471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(827);
/* unused harmony export initialState */
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var initialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  user: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
});

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_resolver__["resolveEach"])(initialState, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__actionTypes__["a" /* SET */], function (state, action) {
  return state.merge({ user: action.user });
})));

/***/ }),
/* 2472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_session_reducer__ = __webpack_require__(2262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_AccountingLogs_pagination__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_Commissions_pagination__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_companies_pagination__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_Consignments_pagination__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_PurchasesReport_pagination__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_SalesDashboard_pagination__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_CustomerRmas_pagination__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_parts_pagination__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_users_pagination__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_users_reducer__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_parts_reducer__ = __webpack_require__(2252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_companies_reducer__ = __webpack_require__(2034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_Consignments_reducer__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Nav_Notifications_reducer__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_IncomingQuotes_pagination__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_IncomingQuotes_incomingQuoteWithAllLineItemsReducer__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_IncomingQuotes_reducer__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_OutgoingQuotes_reducer__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_OutgoingQuotes_pagination__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modules_PurchaseOrders_pagination__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_PurchaseOrders_reducer__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modules_Receiving_reducer__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__modules_Receiving_pagination__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__modules_RejectedCores_reducer__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__modules_RejectedCores_pagination__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__modules_RepairOrders_pagination__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__modules_RepairOrders_reducer__ = __webpack_require__(1762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__modules_Admin_Reports_pagination__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__modules_inventories_pagination__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__modules_inventories_reducer__ = __webpack_require__(2121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__modules_Lots_pagination__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__modules_Lots_reducer__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__modules_ManagedRepairOrders_reducer__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__modules_ManagedRepairOrders_pagination__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__modules_MistakeShipments_pagination__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__modules_MistakeShipments_reducer__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__modules_Receiving_Dashboard_pagination__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__modules_SalesOrders_pagination__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__modules_SalesOrders_reducer__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__modules_SalesOrders_salesOrderWithAllLineItemsReducer__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__modules_Shipping_pagination__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__modules_OutgoingShipments_pagination__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__modules_OutgoingShipments_reducer__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__modules_RMAsAndWarranties_pagination__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__modules_RMAsAndWarranties_reducer__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__modules_Notifications_pagination__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__modules_VendorRmas_pagination__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__modules_Upgrade_reducer__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__modules_Subscription_reducer__ = __webpack_require__(1942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__modules_ApprovedVendors_pagination__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__modules_ApprovedRepairStations_pagination__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__modules_MyShoppingList_pagination__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__modules_Admin_ConsignmentReportCard_pagination__ = __webpack_require__(633);



























































/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  router: __WEBPACK_IMPORTED_MODULE_2_react_router_redux__["routerReducer"],
  form: __WEBPACK_IMPORTED_MODULE_1_redux_form__["reducer"],
  toastr: __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__["reducer"],
  session: __WEBPACK_IMPORTED_MODULE_4__modules_session_reducer__["a" /* default */],
  commissions: __WEBPACK_IMPORTED_MODULE_6__modules_Commissions_pagination__["a" /* default */].paginator,
  companyDetail: __WEBPACK_IMPORTED_MODULE_16__modules_companies_reducer__["a" /* default */],
  companyPagination: __WEBPACK_IMPORTED_MODULE_7__modules_companies_pagination__["b" /* default */],
  consignmentReports: __WEBPACK_IMPORTED_MODULE_57__modules_Admin_ConsignmentReportCard_pagination__["a" /* default */].paginator,
  consignments: __WEBPACK_IMPORTED_MODULE_8__modules_Consignments_pagination__["d" /* default */],
  consignmentDetail: __WEBPACK_IMPORTED_MODULE_17__modules_Consignments_reducer__["a" /* default */],
  customerRmas: __WEBPACK_IMPORTED_MODULE_11__modules_CustomerRmas_pagination__["a" /* default */].paginator,
  purchasesReport: __WEBPACK_IMPORTED_MODULE_9__modules_PurchasesReport_pagination__["a" /* default */].paginator,
  discrepancies: __WEBPACK_IMPORTED_MODULE_27__modules_Receiving_pagination__["b" /* discrepancies */],
  incomingQuotes: __WEBPACK_IMPORTED_MODULE_19__modules_IncomingQuotes_pagination__["c" /* default */],
  incomingQuoteDetail: __WEBPACK_IMPORTED_MODULE_21__modules_IncomingQuotes_reducer__["a" /* default */],
  incomingQuoteWithAllLineItemsDetail: __WEBPACK_IMPORTED_MODULE_20__modules_IncomingQuotes_incomingQuoteWithAllLineItemsReducer__["a" /* default */],
  lots: __WEBPACK_IMPORTED_MODULE_35__modules_Lots_pagination__["d" /* default */],
  lotDetail: __WEBPACK_IMPORTED_MODULE_36__modules_Lots_reducer__["a" /* default */],
  notifications: __WEBPACK_IMPORTED_MODULE_18__Nav_Notifications_reducer__["a" /* default */],
  searchAccountingLogs: __WEBPACK_IMPORTED_MODULE_5__modules_AccountingLogs_pagination__["a" /* default */].paginator,
  searchNotifications: __WEBPACK_IMPORTED_MODULE_50__modules_Notifications_pagination__["a" /* default */].paginator,
  managedRepairOrderLineItems: __WEBPACK_IMPORTED_MODULE_38__modules_ManagedRepairOrders_pagination__["a" /* managedRepairOrderLineItems */],
  mistakeShipments: __WEBPACK_IMPORTED_MODULE_39__modules_MistakeShipments_pagination__["a" /* default */].paginator,
  mistakeShipmentDetail: __WEBPACK_IMPORTED_MODULE_40__modules_MistakeShipments_reducer__["a" /* default */],
  mroDetail: __WEBPACK_IMPORTED_MODULE_37__modules_ManagedRepairOrders_reducer__["a" /* default */],
  managedRepairOrders: __WEBPACK_IMPORTED_MODULE_38__modules_ManagedRepairOrders_pagination__["b" /* default */].paginator,
  outgoingQuotes: __WEBPACK_IMPORTED_MODULE_23__modules_OutgoingQuotes_pagination__["a" /* default */].paginator,
  outgoingQuoteDetail: __WEBPACK_IMPORTED_MODULE_22__modules_OutgoingQuotes_reducer__["a" /* default */],
  partPagination: __WEBPACK_IMPORTED_MODULE_12__modules_parts_pagination__["j" /* default */],
  purchaseOrdersPagination: __WEBPACK_IMPORTED_MODULE_24__modules_PurchaseOrders_pagination__["d" /* default */],
  purchaseOrderDetail: __WEBPACK_IMPORTED_MODULE_25__modules_PurchaseOrders_reducer__["a" /* default */],
  purchaseOrderLineItems: __WEBPACK_IMPORTED_MODULE_24__modules_PurchaseOrders_pagination__["a" /* purchaseOrderLineItems */],
  partDetail: __WEBPACK_IMPORTED_MODULE_15__modules_parts_reducer__["a" /* default */],
  receivingRecords: __WEBPACK_IMPORTED_MODULE_27__modules_Receiving_pagination__["c" /* default */],
  receivingRecordDetail: __WEBPACK_IMPORTED_MODULE_26__modules_Receiving_reducer__["a" /* default */],
  receivingDashboardOrders: __WEBPACK_IMPORTED_MODULE_41__modules_Receiving_Dashboard_pagination__["b" /* receivingDashboardOrders */].paginator,
  rejectedCoreDetail: __WEBPACK_IMPORTED_MODULE_28__modules_RejectedCores_reducer__["a" /* default */],
  rejectedCores: __WEBPACK_IMPORTED_MODULE_29__modules_RejectedCores_pagination__["a" /* default */].paginator,
  virtualReceivingDashboardOrders: __WEBPACK_IMPORTED_MODULE_41__modules_Receiving_Dashboard_pagination__["a" /* virtualReceivingDashboardOrders */].paginator,
  repairOrders: __WEBPACK_IMPORTED_MODULE_30__modules_RepairOrders_pagination__["a" /* default */],
  repairOrderDetail: __WEBPACK_IMPORTED_MODULE_31__modules_RepairOrders_reducer__["a" /* default */],
  repairOrderLineItems: __WEBPACK_IMPORTED_MODULE_30__modules_RepairOrders_pagination__["b" /* repairOrderLineItems */].paginator,
  reports: __WEBPACK_IMPORTED_MODULE_32__modules_Admin_Reports_pagination__["b" /* default */],
  reservedForRepairInventory: __WEBPACK_IMPORTED_MODULE_30__modules_RepairOrders_pagination__["c" /* reservedForRepairInventory */].paginator,
  reservedForSaleInventory: __WEBPACK_IMPORTED_MODULE_42__modules_SalesOrders_pagination__["a" /* reservedForSaleInventory */].paginator,
  salesReport: __WEBPACK_IMPORTED_MODULE_10__modules_SalesDashboard_pagination__["a" /* default */].paginator,
  users: __WEBPACK_IMPORTED_MODULE_13__modules_users_pagination__["b" /* default */],
  userDetail: __WEBPACK_IMPORTED_MODULE_14__modules_users_reducer__["a" /* default */],
  inventoryPagination: __WEBPACK_IMPORTED_MODULE_33__modules_inventories_pagination__["a" /* default */].paginator,
  inventoryDetail: __WEBPACK_IMPORTED_MODULE_34__modules_inventories_reducer__["a" /* default */],
  salesOrders: __WEBPACK_IMPORTED_MODULE_42__modules_SalesOrders_pagination__["c" /* default */],
  salesOrderDetail: __WEBPACK_IMPORTED_MODULE_43__modules_SalesOrders_reducer__["a" /* default */],
  salesOrderWithAllLineItemsDetail: __WEBPACK_IMPORTED_MODULE_44__modules_SalesOrders_salesOrderWithAllLineItemsReducer__["a" /* default */],
  outboundOrders: __WEBPACK_IMPORTED_MODULE_45__modules_Shipping_pagination__["a" /* default */].paginator,
  shipmentsPagination: __WEBPACK_IMPORTED_MODULE_46__modules_OutgoingShipments_pagination__["b" /* default */],
  shipmentDetail: __WEBPACK_IMPORTED_MODULE_47__modules_OutgoingShipments_reducer__["a" /* default */],
  rmas: __WEBPACK_IMPORTED_MODULE_48__modules_RMAsAndWarranties_pagination__["a" /* default */].paginator,
  rmaDetail: __WEBPACK_IMPORTED_MODULE_49__modules_RMAsAndWarranties_reducer__["a" /* default */],
  subscriptions: __WEBPACK_IMPORTED_MODULE_53__modules_Subscription_reducer__["a" /* default */],
  upgrade: __WEBPACK_IMPORTED_MODULE_52__modules_Upgrade_reducer__["a" /* default */],
  approvedVendors: __WEBPACK_IMPORTED_MODULE_54__modules_ApprovedVendors_pagination__["a" /* default */].paginator,
  approvedRepairStations: __WEBPACK_IMPORTED_MODULE_55__modules_ApprovedRepairStations_pagination__["a" /* default */].paginator,
  shoppingLists: __WEBPACK_IMPORTED_MODULE_56__modules_MyShoppingList_pagination__["a" /* default */].paginator,
  residentExpertSearch: __WEBPACK_IMPORTED_MODULE_56__modules_MyShoppingList_pagination__["b" /* residentExpertSearch */].paginator,
  vendorRmas: __WEBPACK_IMPORTED_MODULE_51__modules_VendorRmas_pagination__["a" /* default */].paginator
}));

/***/ }),
/* 2473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_client__ = __webpack_require__(1148);


/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(2718);

__webpack_require__(3211);

__webpack_require__(2477);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127)))

/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
* @version: 3.1
* @author: Dan Grossman http://www.dangrossman.info/
* @copyright: Copyright (c) 2012-2019 Dan Grossman. All rights reserved.
* @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
* @website: http://www.daterangepicker.com/
*/
// Following the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
(function (root, factory) {
    if (true) {
        // AMD. Make globaly available as well
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14), __webpack_require__(885)], __WEBPACK_AMD_DEFINE_RESULT__ = function (moment, jquery) {
            if (!jquery.fn) jquery.fn = {}; // webpack server rendering
            if (typeof moment !== 'function' && moment.hasOwnProperty('default')) moment = moment['default']
            return factory(moment, jquery);
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        // Node / Browserify
        //isomorphic issue
        var jQuery = (typeof window != 'undefined') ? window.jQuery : undefined;
        if (!jQuery) {
            jQuery = require('jquery');
            if (!jQuery.fn) jQuery.fn = {};
        }
        var moment = (typeof window != 'undefined' && typeof window.moment != 'undefined') ? window.moment : require('moment');
        module.exports = factory(moment, jQuery);
    } else {
        // Browser globals
        root.daterangepicker = factory(root.moment, root.jQuery);
    }
}(this, function(moment, $) {
    var DateRangePicker = function(element, options, cb) {

        //default settings for options
        this.parentEl = 'body';
        this.element = $(element);
        this.startDate = moment().startOf('day');
        this.endDate = moment().endOf('day');
        this.minDate = false;
        this.maxDate = false;
        this.maxSpan = false;
        this.autoApply = false;
        this.singleDatePicker = false;
        this.showDropdowns = false;
        this.minYear = moment().subtract(100, 'year').format('YYYY');
        this.maxYear = moment().add(100, 'year').format('YYYY');
        this.showWeekNumbers = false;
        this.showISOWeekNumbers = false;
        this.showCustomRangeLabel = true;
        this.timePicker = false;
        this.timePicker24Hour = false;
        this.timePickerIncrement = 1;
        this.timePickerSeconds = false;
        this.linkedCalendars = true;
        this.autoUpdateInput = true;
        this.alwaysShowCalendars = false;
        this.ranges = {};

        this.opens = 'right';
        if (this.element.hasClass('pull-right'))
            this.opens = 'left';

        this.drops = 'down';
        if (this.element.hasClass('dropup'))
            this.drops = 'up';

        this.buttonClasses = 'btn btn-sm';
        this.applyButtonClasses = 'btn-primary';
        this.cancelButtonClasses = 'btn-default';

        this.locale = {
            direction: 'ltr',
            format: moment.localeData().longDateFormat('L'),
            separator: ' - ',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: moment.weekdaysMin(),
            monthNames: moment.monthsShort(),
            firstDay: moment.localeData().firstDayOfWeek()
        };

        this.callback = function() { };

        //some state information
        this.isShowing = false;
        this.leftCalendar = {};
        this.rightCalendar = {};

        //custom options from user
        if (typeof options !== 'object' || options === null)
            options = {};

        //allow setting options with data attributes
        //data-api options will be overwritten with custom javascript options
        options = $.extend(this.element.data(), options);

        //html template for the picker UI
        if (typeof options.template !== 'string' && !(options.template instanceof $))
            options.template =
            '<div class="daterangepicker">' +
                '<div class="ranges"></div>' +
                '<div class="drp-calendar left">' +
                    '<div class="calendar-table"></div>' +
                    '<div class="calendar-time"></div>' +
                '</div>' +
                '<div class="drp-calendar right">' +
                    '<div class="calendar-table"></div>' +
                    '<div class="calendar-time"></div>' +
                '</div>' +
                '<div class="drp-buttons">' +
                    '<span class="drp-selected"></span>' +
                    '<button class="cancelBtn" type="button"></button>' +
                    '<button class="applyBtn" disabled="disabled" type="button"></button> ' +
                '</div>' +
            '</div>';

        this.parentEl = (options.parentEl && $(options.parentEl).length) ? $(options.parentEl) : $(this.parentEl);
        this.container = $(options.template).appendTo(this.parentEl);

        //
        // handle all the possible options overriding defaults
        //

        if (typeof options.locale === 'object') {

            if (typeof options.locale.direction === 'string')
                this.locale.direction = options.locale.direction;

            if (typeof options.locale.format === 'string')
                this.locale.format = options.locale.format;

            if (typeof options.locale.separator === 'string')
                this.locale.separator = options.locale.separator;

            if (typeof options.locale.daysOfWeek === 'object')
                this.locale.daysOfWeek = options.locale.daysOfWeek.slice();

            if (typeof options.locale.monthNames === 'object')
              this.locale.monthNames = options.locale.monthNames.slice();

            if (typeof options.locale.firstDay === 'number')
              this.locale.firstDay = options.locale.firstDay;

            if (typeof options.locale.applyLabel === 'string')
              this.locale.applyLabel = options.locale.applyLabel;

            if (typeof options.locale.cancelLabel === 'string')
              this.locale.cancelLabel = options.locale.cancelLabel;

            if (typeof options.locale.weekLabel === 'string')
              this.locale.weekLabel = options.locale.weekLabel;

            if (typeof options.locale.customRangeLabel === 'string'){
                //Support unicode chars in the custom range name.
                var elem = document.createElement('textarea');
                elem.innerHTML = options.locale.customRangeLabel;
                var rangeHtml = elem.value;
                this.locale.customRangeLabel = rangeHtml;
            }
        }
        this.container.addClass(this.locale.direction);

        if (typeof options.startDate === 'string')
            this.startDate = moment(options.startDate, this.locale.format);

        if (typeof options.endDate === 'string')
            this.endDate = moment(options.endDate, this.locale.format);

        if (typeof options.minDate === 'string')
            this.minDate = moment(options.minDate, this.locale.format);

        if (typeof options.maxDate === 'string')
            this.maxDate = moment(options.maxDate, this.locale.format);

        if (typeof options.startDate === 'object')
            this.startDate = moment(options.startDate);

        if (typeof options.endDate === 'object')
            this.endDate = moment(options.endDate);

        if (typeof options.minDate === 'object')
            this.minDate = moment(options.minDate);

        if (typeof options.maxDate === 'object')
            this.maxDate = moment(options.maxDate);

        // sanity check for bad options
        if (this.minDate && this.startDate.isBefore(this.minDate))
            this.startDate = this.minDate.clone();

        // sanity check for bad options
        if (this.maxDate && this.endDate.isAfter(this.maxDate))
            this.endDate = this.maxDate.clone();

        if (typeof options.applyButtonClasses === 'string')
            this.applyButtonClasses = options.applyButtonClasses;

        if (typeof options.applyClass === 'string') //backwards compat
            this.applyButtonClasses = options.applyClass;

        if (typeof options.cancelButtonClasses === 'string')
            this.cancelButtonClasses = options.cancelButtonClasses;

        if (typeof options.cancelClass === 'string') //backwards compat
            this.cancelButtonClasses = options.cancelClass;

        if (typeof options.maxSpan === 'object')
            this.maxSpan = options.maxSpan;

        if (typeof options.dateLimit === 'object') //backwards compat
            this.maxSpan = options.dateLimit;

        if (typeof options.opens === 'string')
            this.opens = options.opens;

        if (typeof options.drops === 'string')
            this.drops = options.drops;

        if (typeof options.showWeekNumbers === 'boolean')
            this.showWeekNumbers = options.showWeekNumbers;

        if (typeof options.showISOWeekNumbers === 'boolean')
            this.showISOWeekNumbers = options.showISOWeekNumbers;

        if (typeof options.buttonClasses === 'string')
            this.buttonClasses = options.buttonClasses;

        if (typeof options.buttonClasses === 'object')
            this.buttonClasses = options.buttonClasses.join(' ');

        if (typeof options.showDropdowns === 'boolean')
            this.showDropdowns = options.showDropdowns;

        if (typeof options.minYear === 'number')
            this.minYear = options.minYear;

        if (typeof options.maxYear === 'number')
            this.maxYear = options.maxYear;

        if (typeof options.showCustomRangeLabel === 'boolean')
            this.showCustomRangeLabel = options.showCustomRangeLabel;

        if (typeof options.singleDatePicker === 'boolean') {
            this.singleDatePicker = options.singleDatePicker;
            if (this.singleDatePicker)
                this.endDate = this.startDate.clone();
        }

        if (typeof options.timePicker === 'boolean')
            this.timePicker = options.timePicker;

        if (typeof options.timePickerSeconds === 'boolean')
            this.timePickerSeconds = options.timePickerSeconds;

        if (typeof options.timePickerIncrement === 'number')
            this.timePickerIncrement = options.timePickerIncrement;

        if (typeof options.timePicker24Hour === 'boolean')
            this.timePicker24Hour = options.timePicker24Hour;

        if (typeof options.autoApply === 'boolean')
            this.autoApply = options.autoApply;

        if (typeof options.autoUpdateInput === 'boolean')
            this.autoUpdateInput = options.autoUpdateInput;

        if (typeof options.linkedCalendars === 'boolean')
            this.linkedCalendars = options.linkedCalendars;

        if (typeof options.isInvalidDate === 'function')
            this.isInvalidDate = options.isInvalidDate;

        if (typeof options.isCustomDate === 'function')
            this.isCustomDate = options.isCustomDate;

        if (typeof options.alwaysShowCalendars === 'boolean')
            this.alwaysShowCalendars = options.alwaysShowCalendars;

        // update day names order to firstDay
        if (this.locale.firstDay != 0) {
            var iterator = this.locale.firstDay;
            while (iterator > 0) {
                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
                iterator--;
            }
        }

        var start, end, range;

        //if no start/end dates set, check if an input element contains initial values
        if (typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined') {
            if ($(this.element).is(':text')) {
                var val = $(this.element).val(),
                    split = val.split(this.locale.separator);

                start = end = null;

                if (split.length == 2) {
                    start = moment(split[0], this.locale.format);
                    end = moment(split[1], this.locale.format);
                } else if (this.singleDatePicker && val !== "") {
                    start = moment(val, this.locale.format);
                    end = moment(val, this.locale.format);
                }
                if (start !== null && end !== null) {
                    this.setStartDate(start);
                    this.setEndDate(end);
                }
            }
        }

        if (typeof options.ranges === 'object') {
            for (range in options.ranges) {

                if (typeof options.ranges[range][0] === 'string')
                    start = moment(options.ranges[range][0], this.locale.format);
                else
                    start = moment(options.ranges[range][0]);

                if (typeof options.ranges[range][1] === 'string')
                    end = moment(options.ranges[range][1], this.locale.format);
                else
                    end = moment(options.ranges[range][1]);

                // If the start or end date exceed those allowed by the minDate or maxSpan
                // options, shorten the range to the allowable period.
                if (this.minDate && start.isBefore(this.minDate))
                    start = this.minDate.clone();

                var maxDate = this.maxDate;
                if (this.maxSpan && maxDate && start.clone().add(this.maxSpan).isAfter(maxDate))
                    maxDate = start.clone().add(this.maxSpan);
                if (maxDate && end.isAfter(maxDate))
                    end = maxDate.clone();

                // If the end of the range is before the minimum or the start of the range is
                // after the maximum, don't display this range option at all.
                if ((this.minDate && end.isBefore(this.minDate, this.timepicker ? 'minute' : 'day'))
                  || (maxDate && start.isAfter(maxDate, this.timepicker ? 'minute' : 'day')))
                    continue;

                //Support unicode chars in the range names.
                var elem = document.createElement('textarea');
                elem.innerHTML = range;
                var rangeHtml = elem.value;

                this.ranges[rangeHtml] = [start, end];
            }

            var list = '<ul>';
            for (range in this.ranges) {
                list += '<li data-range-key="' + range + '">' + range + '</li>';
            }
            if (this.showCustomRangeLabel) {
                list += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + '</li>';
            }
            list += '</ul>';
            this.container.find('.ranges').prepend(list);
        }

        if (typeof cb === 'function') {
            this.callback = cb;
        }

        if (!this.timePicker) {
            this.startDate = this.startDate.startOf('day');
            this.endDate = this.endDate.endOf('day');
            this.container.find('.calendar-time').hide();
        }

        //can't be used together for now
        if (this.timePicker && this.autoApply)
            this.autoApply = false;

        if (this.autoApply) {
            this.container.addClass('auto-apply');
        }

        if (typeof options.ranges === 'object')
            this.container.addClass('show-ranges');

        if (this.singleDatePicker) {
            this.container.addClass('single');
            this.container.find('.drp-calendar.left').addClass('single');
            this.container.find('.drp-calendar.left').show();
            this.container.find('.drp-calendar.right').hide();
            if (!this.timePicker && this.autoApply) {
                this.container.addClass('auto-apply');
            }
        }

        if ((typeof options.ranges === 'undefined' && !this.singleDatePicker) || this.alwaysShowCalendars) {
            this.container.addClass('show-calendar');
        }

        this.container.addClass('opens' + this.opens);

        //apply CSS classes and labels to buttons
        this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
        if (this.applyButtonClasses.length)
            this.container.find('.applyBtn').addClass(this.applyButtonClasses);
        if (this.cancelButtonClasses.length)
            this.container.find('.cancelBtn').addClass(this.cancelButtonClasses);
        this.container.find('.applyBtn').html(this.locale.applyLabel);
        this.container.find('.cancelBtn').html(this.locale.cancelLabel);

        //
        // event listeners
        //

        this.container.find('.drp-calendar')
            .on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this))
            .on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
            .on('mousedown.daterangepicker', 'td.available', $.proxy(this.clickDate, this))
            .on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this))
            .on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this))
            .on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this))
            .on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this));

        this.container.find('.ranges')
            .on('click.daterangepicker', 'li', $.proxy(this.clickRange, this));

        this.container.find('.drp-buttons')
            .on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this))
            .on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this));

        if (this.element.is('input') || this.element.is('button')) {
            this.element.on({
                'click.daterangepicker': $.proxy(this.show, this),
                'focus.daterangepicker': $.proxy(this.show, this),
                'keyup.daterangepicker': $.proxy(this.elementChanged, this),
                'keydown.daterangepicker': $.proxy(this.keydown, this) //IE 11 compatibility
            });
        } else {
            this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
            this.element.on('keydown.daterangepicker', $.proxy(this.toggle, this));
        }

        //
        // if attached to a text input, set the initial value
        //

        this.updateElement();

    };

    DateRangePicker.prototype = {

        constructor: DateRangePicker,

        setStartDate: function(startDate) {
            if (typeof startDate === 'string')
                this.startDate = moment(startDate, this.locale.format);

            if (typeof startDate === 'object')
                this.startDate = moment(startDate);

            if (!this.timePicker)
                this.startDate = this.startDate.startOf('day');

            if (this.timePicker && this.timePickerIncrement)
                this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

            if (this.minDate && this.startDate.isBefore(this.minDate)) {
                this.startDate = this.minDate.clone();
                if (this.timePicker && this.timePickerIncrement)
                    this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }

            if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
                this.startDate = this.maxDate.clone();
                if (this.timePicker && this.timePickerIncrement)
                    this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }

            if (!this.isShowing)
                this.updateElement();

            this.updateMonthsInView();
        },

        setEndDate: function(endDate) {
            if (typeof endDate === 'string')
                this.endDate = moment(endDate, this.locale.format);

            if (typeof endDate === 'object')
                this.endDate = moment(endDate);

            if (!this.timePicker)
                this.endDate = this.endDate.endOf('day');

            if (this.timePicker && this.timePickerIncrement)
                this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

            if (this.endDate.isBefore(this.startDate))
                this.endDate = this.startDate.clone();

            if (this.maxDate && this.endDate.isAfter(this.maxDate))
                this.endDate = this.maxDate.clone();

            if (this.maxSpan && this.startDate.clone().add(this.maxSpan).isBefore(this.endDate))
                this.endDate = this.startDate.clone().add(this.maxSpan);

            this.previousRightTime = this.endDate.clone();

            this.container.find('.drp-selected').html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));

            if (!this.isShowing)
                this.updateElement();

            this.updateMonthsInView();
        },

        isInvalidDate: function() {
            return false;
        },

        isCustomDate: function() {
            return false;
        },

        updateView: function() {
            if (this.timePicker) {
                this.renderTimePicker('left');
                this.renderTimePicker('right');
                if (!this.endDate) {
                    this.container.find('.right .calendar-time select').prop('disabled', true).addClass('disabled');
                } else {
                    this.container.find('.right .calendar-time select').prop('disabled', false).removeClass('disabled');
                }
            }
            if (this.endDate)
                this.container.find('.drp-selected').html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
            this.updateMonthsInView();
            this.updateCalendars();
            this.updateFormInputs();
        },

        updateMonthsInView: function() {
            if (this.endDate) {

                //if both dates are visible already, do nothing
                if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month &&
                    (this.startDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
                    &&
                    (this.endDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
                    ) {
                    return;
                }

                this.leftCalendar.month = this.startDate.clone().date(2);
                if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) {
                    this.rightCalendar.month = this.endDate.clone().date(2);
                } else {
                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
                }

            } else {
                if (this.leftCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM')) {
                    this.leftCalendar.month = this.startDate.clone().date(2);
                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
                }
            }
            if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
              this.rightCalendar.month = this.maxDate.clone().date(2);
              this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
            }
        },

        updateCalendars: function() {

            if (this.timePicker) {
                var hour, minute, second;
                if (this.endDate) {
                    hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                    minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                    if (isNaN(minute)) {
                        minute = parseInt(this.container.find('.left .minuteselect option:last').val(), 10);
                    }
                    second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.left .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                } else {
                    hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                    minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                    if (isNaN(minute)) {
                        minute = parseInt(this.container.find('.right .minuteselect option:last').val(), 10);
                    }
                    second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.right .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                }
                this.leftCalendar.month.hour(hour).minute(minute).second(second);
                this.rightCalendar.month.hour(hour).minute(minute).second(second);
            }

            this.renderCalendar('left');
            this.renderCalendar('right');

            //highlight any predefined range matching the current start and end dates
            this.container.find('.ranges li').removeClass('active');
            if (this.endDate == null) return;

            this.calculateChosenLabel();
        },

        renderCalendar: function(side) {

            //
            // Build the matrix of dates that will populate the calendar
            //

            var calendar = side == 'left' ? this.leftCalendar : this.rightCalendar;
            var month = calendar.month.month();
            var year = calendar.month.year();
            var hour = calendar.month.hour();
            var minute = calendar.month.minute();
            var second = calendar.month.second();
            var daysInMonth = moment([year, month]).daysInMonth();
            var firstDay = moment([year, month, 1]);
            var lastDay = moment([year, month, daysInMonth]);
            var lastMonth = moment(firstDay).subtract(1, 'month').month();
            var lastYear = moment(firstDay).subtract(1, 'month').year();
            var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
            var dayOfWeek = firstDay.day();

            //initialize a 6 rows x 7 columns array for the calendar
            var calendar = [];
            calendar.firstDay = firstDay;
            calendar.lastDay = lastDay;

            for (var i = 0; i < 6; i++) {
                calendar[i] = [];
            }

            //populate the calendar with date objects
            var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
            if (startDay > daysInLastMonth)
                startDay -= 7;

            if (dayOfWeek == this.locale.firstDay)
                startDay = daysInLastMonth - 6;

            var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);

            var col, row;
            for (var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')) {
                if (i > 0 && col % 7 === 0) {
                    col = 0;
                    row++;
                }
                calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
                curDate.hour(12);

                if (this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side == 'left') {
                    calendar[row][col] = this.minDate.clone();
                }

                if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side == 'right') {
                    calendar[row][col] = this.maxDate.clone();
                }

            }

            //make the calendar object available to hoverDate/clickDate
            if (side == 'left') {
                this.leftCalendar.calendar = calendar;
            } else {
                this.rightCalendar.calendar = calendar;
            }

            //
            // Display the calendar
            //

            var minDate = side == 'left' ? this.minDate : this.startDate;
            var maxDate = this.maxDate;
            var selected = side == 'left' ? this.startDate : this.endDate;
            var arrow = this.locale.direction == 'ltr' ? {left: 'chevron-left', right: 'chevron-right'} : {left: 'chevron-right', right: 'chevron-left'};

            var html = '<table class="table-condensed">';
            html += '<thead>';
            html += '<tr>';

            // add empty cell for week number
            if (this.showWeekNumbers || this.showISOWeekNumbers)
                html += '<th></th>';

            if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == 'left')) {
                html += '<th class="prev available"><span></span></th>';
            } else {
                html += '<th></th>';
            }

            var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");

            if (this.showDropdowns) {
                var currentMonth = calendar[1][1].month();
                var currentYear = calendar[1][1].year();
                var maxYear = (maxDate && maxDate.year()) || (this.maxYear);
                var minYear = (minDate && minDate.year()) || (this.minYear);
                var inMinYear = currentYear == minYear;
                var inMaxYear = currentYear == maxYear;

                var monthHtml = '<select class="monthselect">';
                for (var m = 0; m < 12; m++) {
                    if ((!inMinYear || (minDate && m >= minDate.month())) && (!inMaxYear || (maxDate && m <= maxDate.month()))) {
                        monthHtml += "<option value='" + m + "'" +
                            (m === currentMonth ? " selected='selected'" : "") +
                            ">" + this.locale.monthNames[m] + "</option>";
                    } else {
                        monthHtml += "<option value='" + m + "'" +
                            (m === currentMonth ? " selected='selected'" : "") +
                            " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
                    }
                }
                monthHtml += "</select>";

                var yearHtml = '<select class="yearselect">';
                for (var y = minYear; y <= maxYear; y++) {
                    yearHtml += '<option value="' + y + '"' +
                        (y === currentYear ? ' selected="selected"' : '') +
                        '>' + y + '</option>';
                }
                yearHtml += '</select>';

                dateHtml = monthHtml + yearHtml;
            }

            html += '<th colspan="5" class="month">' + dateHtml + '</th>';
            if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == 'right' || this.singleDatePicker)) {
                html += '<th class="next available"><span></span></th>';
            } else {
                html += '<th></th>';
            }

            html += '</tr>';
            html += '<tr>';

            // add week number label
            if (this.showWeekNumbers || this.showISOWeekNumbers)
                html += '<th class="week">' + this.locale.weekLabel + '</th>';

            $.each(this.locale.daysOfWeek, function(index, dayOfWeek) {
                html += '<th>' + dayOfWeek + '</th>';
            });

            html += '</tr>';
            html += '</thead>';
            html += '<tbody>';

            //adjust maxDate to reflect the maxSpan setting in order to
            //grey out end dates beyond the maxSpan
            if (this.endDate == null && this.maxSpan) {
                var maxLimit = this.startDate.clone().add(this.maxSpan).endOf('day');
                if (!maxDate || maxLimit.isBefore(maxDate)) {
                    maxDate = maxLimit;
                }
            }

            for (var row = 0; row < 6; row++) {
                html += '<tr>';

                // add week number
                if (this.showWeekNumbers)
                    html += '<td class="week">' + calendar[row][0].week() + '</td>';
                else if (this.showISOWeekNumbers)
                    html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';

                for (var col = 0; col < 7; col++) {

                    var classes = [];

                    //highlight today's date
                    if (calendar[row][col].isSame(new Date(), "day"))
                        classes.push('today');

                    //highlight weekends
                    if (calendar[row][col].isoWeekday() > 5)
                        classes.push('weekend');

                    //grey out the dates in other months displayed at beginning and end of this calendar
                    if (calendar[row][col].month() != calendar[1][1].month())
                        classes.push('off', 'ends');

                    //don't allow selection of dates before the minimum date
                    if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day'))
                        classes.push('off', 'disabled');

                    //don't allow selection of dates after the maximum date
                    if (maxDate && calendar[row][col].isAfter(maxDate, 'day'))
                        classes.push('off', 'disabled');

                    //don't allow selection of date if a custom function decides it's invalid
                    if (this.isInvalidDate(calendar[row][col]))
                        classes.push('off', 'disabled');

                    //highlight the currently selected start date
                    if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD'))
                        classes.push('active', 'start-date');

                    //highlight the currently selected end date
                    if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD'))
                        classes.push('active', 'end-date');

                    //highlight dates in-between the selected dates
                    if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate)
                        classes.push('in-range');

                    //apply custom classes for this date
                    var isCustom = this.isCustomDate(calendar[row][col]);
                    if (isCustom !== false) {
                        if (typeof isCustom === 'string')
                            classes.push(isCustom);
                        else
                            Array.prototype.push.apply(classes, isCustom);
                    }

                    var cname = '', disabled = false;
                    for (var i = 0; i < classes.length; i++) {
                        cname += classes[i] + ' ';
                        if (classes[i] == 'disabled')
                            disabled = true;
                    }
                    if (!disabled)
                        cname += 'available';

                    html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';

                }
                html += '</tr>';
            }

            html += '</tbody>';
            html += '</table>';

            this.container.find('.drp-calendar.' + side + ' .calendar-table').html(html);

        },

        renderTimePicker: function(side) {

            // Don't bother updating the time picker if it's currently disabled
            // because an end date hasn't been clicked yet
            if (side == 'right' && !this.endDate) return;

            var html, selected, minDate, maxDate = this.maxDate;

            if (this.maxSpan && (!this.maxDate || this.startDate.clone().add(this.maxSpan).isBefore(this.maxDate)))
                maxDate = this.startDate.clone().add(this.maxSpan);

            if (side == 'left') {
                selected = this.startDate.clone();
                minDate = this.minDate;
            } else if (side == 'right') {
                selected = this.endDate.clone();
                minDate = this.startDate;

                //Preserve the time already selected
                var timeSelector = this.container.find('.drp-calendar.right .calendar-time');
                if (timeSelector.html() != '') {

                    selected.hour(!isNaN(selected.hour()) ? selected.hour() : timeSelector.find('.hourselect option:selected').val());
                    selected.minute(!isNaN(selected.minute()) ? selected.minute() : timeSelector.find('.minuteselect option:selected').val());
                    selected.second(!isNaN(selected.second()) ? selected.second() : timeSelector.find('.secondselect option:selected').val());

                    if (!this.timePicker24Hour) {
                        var ampm = timeSelector.find('.ampmselect option:selected').val();
                        if (ampm === 'PM' && selected.hour() < 12)
                            selected.hour(selected.hour() + 12);
                        if (ampm === 'AM' && selected.hour() === 12)
                            selected.hour(0);
                    }

                }

                if (selected.isBefore(this.startDate))
                    selected = this.startDate.clone();

                if (maxDate && selected.isAfter(maxDate))
                    selected = maxDate.clone();

            }

            //
            // hours
            //

            html = '<select class="hourselect">';

            var start = this.timePicker24Hour ? 0 : 1;
            var end = this.timePicker24Hour ? 23 : 12;

            for (var i = start; i <= end; i++) {
                var i_in_24 = i;
                if (!this.timePicker24Hour)
                    i_in_24 = selected.hour() >= 12 ? (i == 12 ? 12 : i + 12) : (i == 12 ? 0 : i);

                var time = selected.clone().hour(i_in_24);
                var disabled = false;
                if (minDate && time.minute(59).isBefore(minDate))
                    disabled = true;
                if (maxDate && time.minute(0).isAfter(maxDate))
                    disabled = true;

                if (i_in_24 == selected.hour() && !disabled) {
                    html += '<option value="' + i + '" selected="selected">' + i + '</option>';
                } else if (disabled) {
                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
                } else {
                    html += '<option value="' + i + '">' + i + '</option>';
                }
            }

            html += '</select> ';

            //
            // minutes
            //

            html += ': <select class="minuteselect">';

            for (var i = 0; i < 60; i += this.timePickerIncrement) {
                var padded = i < 10 ? '0' + i : i;
                var time = selected.clone().minute(i);

                var disabled = false;
                if (minDate && time.second(59).isBefore(minDate))
                    disabled = true;
                if (maxDate && time.second(0).isAfter(maxDate))
                    disabled = true;

                if (selected.minute() == i && !disabled) {
                    html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
                } else if (disabled) {
                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
                } else {
                    html += '<option value="' + i + '">' + padded + '</option>';
                }
            }

            html += '</select> ';

            //
            // seconds
            //

            if (this.timePickerSeconds) {
                html += ': <select class="secondselect">';

                for (var i = 0; i < 60; i++) {
                    var padded = i < 10 ? '0' + i : i;
                    var time = selected.clone().second(i);

                    var disabled = false;
                    if (minDate && time.isBefore(minDate))
                        disabled = true;
                    if (maxDate && time.isAfter(maxDate))
                        disabled = true;

                    if (selected.second() == i && !disabled) {
                        html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
                    } else if (disabled) {
                        html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
                    } else {
                        html += '<option value="' + i + '">' + padded + '</option>';
                    }
                }

                html += '</select> ';
            }

            //
            // AM/PM
            //

            if (!this.timePicker24Hour) {
                html += '<select class="ampmselect">';

                var am_html = '';
                var pm_html = '';

                if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate))
                    am_html = ' disabled="disabled" class="disabled"';

                if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate))
                    pm_html = ' disabled="disabled" class="disabled"';

                if (selected.hour() >= 12) {
                    html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
                } else {
                    html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
                }

                html += '</select>';
            }

            this.container.find('.drp-calendar.' + side + ' .calendar-time').html(html);

        },

        updateFormInputs: function() {

            if (this.singleDatePicker || (this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate)))) {
                this.container.find('button.applyBtn').prop('disabled', false);
            } else {
                this.container.find('button.applyBtn').prop('disabled', true);
            }

        },

        move: function() {
            var parentOffset = { top: 0, left: 0 },
                containerTop,
                drops = this.drops;

            var parentRightEdge = $(window).width();
            if (!this.parentEl.is('body')) {
                parentOffset = {
                    top: this.parentEl.offset().top - this.parentEl.scrollTop(),
                    left: this.parentEl.offset().left - this.parentEl.scrollLeft()
                };
                parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
            }

            switch (drops) {
            case 'auto':
                containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
                if (containerTop + this.container.outerHeight() >= this.parentEl[0].scrollHeight) {
                    containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
                    drops = 'up';
                }
                break;
            case 'up':
                containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
                break;
            default:
                containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
                break;
            }

            // Force the container to it's actual width
            this.container.css({
              top: 0,
              left: 0,
              right: 'auto'
            });
            var containerWidth = this.container.outerWidth();

            this.container.toggleClass('drop-up', drops == 'up');

            if (this.opens == 'left') {
                var containerRight = parentRightEdge - this.element.offset().left - this.element.outerWidth();
                if (containerWidth + containerRight > $(window).width()) {
                    this.container.css({
                        top: containerTop,
                        right: 'auto',
                        left: 9
                    });
                } else {
                    this.container.css({
                        top: containerTop,
                        right: containerRight,
                        left: 'auto'
                    });
                }
            } else if (this.opens == 'center') {
                var containerLeft = this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2
                                        - containerWidth / 2;
                if (containerLeft < 0) {
                    this.container.css({
                        top: containerTop,
                        right: 'auto',
                        left: 9
                    });
                } else if (containerLeft + containerWidth > $(window).width()) {
                    this.container.css({
                        top: containerTop,
                        left: 'auto',
                        right: 0
                    });
                } else {
                    this.container.css({
                        top: containerTop,
                        left: containerLeft,
                        right: 'auto'
                    });
                }
            } else {
                var containerLeft = this.element.offset().left - parentOffset.left;
                if (containerLeft + containerWidth > $(window).width()) {
                    this.container.css({
                        top: containerTop,
                        left: 'auto',
                        right: 0
                    });
                } else {
                    this.container.css({
                        top: containerTop,
                        left: containerLeft,
                        right: 'auto'
                    });
                }
            }
        },

        show: function(e) {
            if (this.isShowing) return;

            // Create a click proxy that is private to this instance of datepicker, for unbinding
            this._outsideClickProxy = $.proxy(function(e) { this.outsideClick(e); }, this);

            // Bind global datepicker mousedown for hiding and
            $(document)
              .on('mousedown.daterangepicker', this._outsideClickProxy)
              // also support mobile devices
              .on('touchend.daterangepicker', this._outsideClickProxy)
              // also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
              .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)
              // and also close when focus changes to outside the picker (eg. tabbing between controls)
              .on('focusin.daterangepicker', this._outsideClickProxy);

            // Reposition the picker if the window is resized while it's open
            $(window).on('resize.daterangepicker', $.proxy(function(e) { this.move(e); }, this));

            this.oldStartDate = this.startDate.clone();
            this.oldEndDate = this.endDate.clone();
            this.previousRightTime = this.endDate.clone();

            this.updateView();
            this.container.show();
            this.move();
            this.element.trigger('show.daterangepicker', this);
            this.isShowing = true;
        },

        hide: function(e) {
            if (!this.isShowing) return;

            //incomplete date selection, revert to last values
            if (!this.endDate) {
                this.startDate = this.oldStartDate.clone();
                this.endDate = this.oldEndDate.clone();
            }

            //if a new date range was selected, invoke the user callback function
            if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
                this.callback(this.startDate.clone(), this.endDate.clone(), this.chosenLabel);

            //if picker is attached to a text input, update it
            this.updateElement();

            $(document).off('.daterangepicker');
            $(window).off('.daterangepicker');
            this.container.hide();
            this.element.trigger('hide.daterangepicker', this);
            this.isShowing = false;
        },

        toggle: function(e) {
            if (this.isShowing) {
                this.hide();
            } else {
                this.show();
            }
        },

        outsideClick: function(e) {
            var target = $(e.target);
            // if the page is clicked anywhere except within the daterangerpicker/button
            // itself then call this.hide()
            if (
                // ie modal dialog fix
                e.type == "focusin" ||
                target.closest(this.element).length ||
                target.closest(this.container).length ||
                target.closest('.calendar-table').length
                ) return;
            this.hide();
            this.element.trigger('outsideClick.daterangepicker', this);
        },

        showCalendars: function() {
            this.container.addClass('show-calendar');
            this.move();
            this.element.trigger('showCalendar.daterangepicker', this);
        },

        hideCalendars: function() {
            this.container.removeClass('show-calendar');
            this.element.trigger('hideCalendar.daterangepicker', this);
        },

        clickRange: function(e) {
            var label = e.target.getAttribute('data-range-key');
            this.chosenLabel = label;
            if (label == this.locale.customRangeLabel) {
                this.showCalendars();
            } else {
                var dates = this.ranges[label];
                this.startDate = dates[0];
                this.endDate = dates[1];

                if (!this.timePicker) {
                    this.startDate.startOf('day');
                    this.endDate.endOf('day');
                }

                if (!this.alwaysShowCalendars)
                    this.hideCalendars();
                this.clickApply();
            }
        },

        clickPrev: function(e) {
            var cal = $(e.target).parents('.drp-calendar');
            if (cal.hasClass('left')) {
                this.leftCalendar.month.subtract(1, 'month');
                if (this.linkedCalendars)
                    this.rightCalendar.month.subtract(1, 'month');
            } else {
                this.rightCalendar.month.subtract(1, 'month');
            }
            this.updateCalendars();
        },

        clickNext: function(e) {
            var cal = $(e.target).parents('.drp-calendar');
            if (cal.hasClass('left')) {
                this.leftCalendar.month.add(1, 'month');
            } else {
                this.rightCalendar.month.add(1, 'month');
                if (this.linkedCalendars)
                    this.leftCalendar.month.add(1, 'month');
            }
            this.updateCalendars();
        },

        hoverDate: function(e) {

            //ignore dates that can't be selected
            if (!$(e.target).hasClass('available')) return;

            var title = $(e.target).attr('data-title');
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents('.drp-calendar');
            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];

            //highlight the dates between the start date and the date being hovered as a potential end date
            var leftCalendar = this.leftCalendar;
            var rightCalendar = this.rightCalendar;
            var startDate = this.startDate;
            if (!this.endDate) {
                this.container.find('.drp-calendar tbody td').each(function(index, el) {

                    //skip week numbers, only look at dates
                    if ($(el).hasClass('week')) return;

                    var title = $(el).attr('data-title');
                    var row = title.substr(1, 1);
                    var col = title.substr(3, 1);
                    var cal = $(el).parents('.drp-calendar');
                    var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];

                    if ((dt.isAfter(startDate) && dt.isBefore(date)) || dt.isSame(date, 'day')) {
                        $(el).addClass('in-range');
                    } else {
                        $(el).removeClass('in-range');
                    }

                });
            }

        },

        clickDate: function(e) {

            if (!$(e.target).hasClass('available')) return;

            var title = $(e.target).attr('data-title');
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents('.drp-calendar');
            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];

            //
            // this function needs to do a few things:
            // * alternate between selecting a start and end date for the range,
            // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
            // * if autoapply is enabled, and an end date was chosen, apply the selection
            // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
            // * if one of the inputs above the calendars was focused, cancel that manual input
            //

            if (this.endDate || date.isBefore(this.startDate, 'day')) { //picking start
                if (this.timePicker) {
                    var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.left .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                    var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                    if (isNaN(minute)) {
                        minute = parseInt(this.container.find('.left .minuteselect option:last').val(), 10);
                    }
                    var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.endDate = null;
                this.setStartDate(date.clone());
            } else if (!this.endDate && date.isBefore(this.startDate)) {
                //special case: clicking the same date for start/end,
                //but the time of the end date is before the start date
                this.setEndDate(this.startDate.clone());
            } else { // picking end
                if (this.timePicker) {
                    var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.right .ampmselect').val();
                        if (ampm === 'PM' && hour < 12)
                            hour += 12;
                        if (ampm === 'AM' && hour === 12)
                            hour = 0;
                    }
                    var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                    if (isNaN(minute)) {
                        minute = parseInt(this.container.find('.right .minuteselect option:last').val(), 10);
                    }
                    var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.setEndDate(date.clone());
                if (this.autoApply) {
                  this.calculateChosenLabel();
                  this.clickApply();
                }
            }

            if (this.singleDatePicker) {
                this.setEndDate(this.startDate);
                if (!this.timePicker && this.autoApply)
                    this.clickApply();
            }

            this.updateView();

            //This is to cancel the blur event handler if the mouse was in one of the inputs
            e.stopPropagation();

        },

        calculateChosenLabel: function () {
            var customRange = true;
            var i = 0;
            for (var range in this.ranges) {
              if (this.timePicker) {
                    var format = this.timePickerSeconds ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm";
                    //ignore times when comparing dates if time picker seconds is not enabled
                    if (this.startDate.format(format) == this.ranges[range][0].format(format) && this.endDate.format(format) == this.ranges[range][1].format(format)) {
                        customRange = false;
                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').attr('data-range-key');
                        break;
                    }
                } else {
                    //ignore times when comparing dates if time picker is not enabled
                    if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
                        customRange = false;
                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').attr('data-range-key');
                        break;
                    }
                }
                i++;
            }
            if (customRange) {
                if (this.showCustomRangeLabel) {
                    this.chosenLabel = this.container.find('.ranges li:last').addClass('active').attr('data-range-key');
                } else {
                    this.chosenLabel = null;
                }
                this.showCalendars();
            }
        },

        clickApply: function(e) {
            this.hide();
            this.element.trigger('apply.daterangepicker', this);
        },

        clickCancel: function(e) {
            this.startDate = this.oldStartDate;
            this.endDate = this.oldEndDate;
            this.hide();
            this.element.trigger('cancel.daterangepicker', this);
        },

        monthOrYearChanged: function(e) {
            var isLeft = $(e.target).closest('.drp-calendar').hasClass('left'),
                leftOrRight = isLeft ? 'left' : 'right',
                cal = this.container.find('.drp-calendar.'+leftOrRight);

            // Month must be Number for new moment versions
            var month = parseInt(cal.find('.monthselect').val(), 10);
            var year = cal.find('.yearselect').val();

            if (!isLeft) {
                if (year < this.startDate.year() || (year == this.startDate.year() && month < this.startDate.month())) {
                    month = this.startDate.month();
                    year = this.startDate.year();
                }
            }

            if (this.minDate) {
                if (year < this.minDate.year() || (year == this.minDate.year() && month < this.minDate.month())) {
                    month = this.minDate.month();
                    year = this.minDate.year();
                }
            }

            if (this.maxDate) {
                if (year > this.maxDate.year() || (year == this.maxDate.year() && month > this.maxDate.month())) {
                    month = this.maxDate.month();
                    year = this.maxDate.year();
                }
            }

            if (isLeft) {
                this.leftCalendar.month.month(month).year(year);
                if (this.linkedCalendars)
                    this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
            } else {
                this.rightCalendar.month.month(month).year(year);
                if (this.linkedCalendars)
                    this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
            }
            this.updateCalendars();
        },

        timeChanged: function(e) {

            var cal = $(e.target).closest('.drp-calendar'),
                isLeft = cal.hasClass('left');

            var hour = parseInt(cal.find('.hourselect').val(), 10);
            var minute = parseInt(cal.find('.minuteselect').val(), 10);
            if (isNaN(minute)) {
                minute = parseInt(cal.find('.minuteselect option:last').val(), 10);
            }
            var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;

            if (!this.timePicker24Hour) {
                var ampm = cal.find('.ampmselect').val();
                if (ampm === 'PM' && hour < 12)
                    hour += 12;
                if (ampm === 'AM' && hour === 12)
                    hour = 0;
            }

            if (isLeft) {
                var start = this.startDate.clone();
                start.hour(hour);
                start.minute(minute);
                start.second(second);
                this.setStartDate(start);
                if (this.singleDatePicker) {
                    this.endDate = this.startDate.clone();
                } else if (this.endDate && this.endDate.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
                    this.setEndDate(start.clone());
                }
            } else if (this.endDate) {
                var end = this.endDate.clone();
                end.hour(hour);
                end.minute(minute);
                end.second(second);
                this.setEndDate(end);
            }

            //update the calendars so all clickable dates reflect the new time component
            this.updateCalendars();

            //update the form inputs above the calendars with the new time
            this.updateFormInputs();

            //re-render the time pickers because changing one selection can affect what's enabled in another
            this.renderTimePicker('left');
            this.renderTimePicker('right');

        },

        elementChanged: function() {
            if (!this.element.is('input')) return;
            if (!this.element.val().length) return;

            var dateString = this.element.val().split(this.locale.separator),
                start = null,
                end = null;

            if (dateString.length === 2) {
                start = moment(dateString[0], this.locale.format);
                end = moment(dateString[1], this.locale.format);
            }

            if (this.singleDatePicker || start === null || end === null) {
                start = moment(this.element.val(), this.locale.format);
                end = start;
            }

            if (!start.isValid() || !end.isValid()) return;

            this.setStartDate(start);
            this.setEndDate(end);
            this.updateView();
        },

        keydown: function(e) {
            //hide on tab or enter
            if ((e.keyCode === 9) || (e.keyCode === 13)) {
                this.hide();
            }

            //hide on esc and prevent propagation
            if (e.keyCode === 27) {
                e.preventDefault();
                e.stopPropagation();

                this.hide();
            }
        },

        updateElement: function() {
            if (this.element.is('input') && this.autoUpdateInput) {
                var newValue = this.startDate.format(this.locale.format);
                if (!this.singleDatePicker) {
                    newValue += this.locale.separator + this.endDate.format(this.locale.format);
                }
                if (newValue !== this.element.val()) {
                    this.element.val(newValue).trigger('change');
                }
            }
        },

        remove: function() {
            this.container.remove();
            this.element.off('.daterangepicker');
            this.element.removeData();
        }

    };

    $.fn.daterangepicker = function(options, callback) {
        var implementOptions = $.extend(true, {}, $.fn.daterangepicker.defaultOptions, options);
        this.each(function() {
            var el = $(this);
            if (el.data('daterangepicker'))
                el.data('daterangepicker').remove();
            el.data('daterangepicker', new DateRangePicker(el, implementOptions, callback));
        });
        return this;
    };

    return DateRangePicker;

}));


/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * clipboard.js v2.0.4
 * https://zenorocha.github.io/clipboard.js
 * 
 * Licensed MIT © Zeno Rocha
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ClipboardJS"] = factory();
	else
		root["ClipboardJS"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboardAction = __webpack_require__(1);

var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

var _tinyEmitter = __webpack_require__(3);

var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

var _goodListener = __webpack_require__(4);

var _goodListener2 = _interopRequireDefault(_goodListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */
var Clipboard = function (_Emitter) {
    _inherits(Clipboard, _Emitter);

    /**
     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
     * @param {Object} options
     */
    function Clipboard(trigger, options) {
        _classCallCheck(this, Clipboard);

        var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

        _this.resolveOptions(options);
        _this.listenClick(trigger);
        return _this;
    }

    /**
     * Defines if attributes would be resolved using internal setter functions
     * or custom functions that were passed in the constructor.
     * @param {Object} options
     */


    _createClass(Clipboard, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
            this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
            this.text = typeof options.text === 'function' ? options.text : this.defaultText;
            this.container = _typeof(options.container) === 'object' ? options.container : document.body;
        }

        /**
         * Adds a click event listener to the passed trigger.
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         */

    }, {
        key: 'listenClick',
        value: function listenClick(trigger) {
            var _this2 = this;

            this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                return _this2.onClick(e);
            });
        }

        /**
         * Defines a new `ClipboardAction` on each click event.
         * @param {Event} e
         */

    }, {
        key: 'onClick',
        value: function onClick(e) {
            var trigger = e.delegateTarget || e.currentTarget;

            if (this.clipboardAction) {
                this.clipboardAction = null;
            }

            this.clipboardAction = new _clipboardAction2.default({
                action: this.action(trigger),
                target: this.target(trigger),
                text: this.text(trigger),
                container: this.container,
                trigger: trigger,
                emitter: this
            });
        }

        /**
         * Default `action` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultAction',
        value: function defaultAction(trigger) {
            return getAttributeValue('action', trigger);
        }

        /**
         * Default `target` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultTarget',
        value: function defaultTarget(trigger) {
            var selector = getAttributeValue('target', trigger);

            if (selector) {
                return document.querySelector(selector);
            }
        }

        /**
         * Returns the support of the given action, or all actions if no action is
         * given.
         * @param {String} [action]
         */

    }, {
        key: 'defaultText',


        /**
         * Default `text` lookup function.
         * @param {Element} trigger
         */
        value: function defaultText(trigger) {
            return getAttributeValue('text', trigger);
        }

        /**
         * Destroy lifecycle.
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            this.listener.destroy();

            if (this.clipboardAction) {
                this.clipboardAction.destroy();
                this.clipboardAction = null;
            }
        }
    }], [{
        key: 'isSupported',
        value: function isSupported() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

            var actions = typeof action === 'string' ? [action] : action;
            var support = !!document.queryCommandSupported;

            actions.forEach(function (action) {
                support = support && !!document.queryCommandSupported(action);
            });

            return support;
        }
    }]);

    return Clipboard;
}(_tinyEmitter2.default);

/**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */


function getAttributeValue(suffix, element) {
    var attribute = 'data-clipboard-' + suffix;

    if (!element.hasAttribute(attribute)) {
        return;
    }

    return element.getAttribute(attribute);
}

module.exports = Clipboard;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _select = __webpack_require__(2);

var _select2 = _interopRequireDefault(_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Inner class which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 */
var ClipboardAction = function () {
    /**
     * @param {Object} options
     */
    function ClipboardAction(options) {
        _classCallCheck(this, ClipboardAction);

        this.resolveOptions(options);
        this.initSelection();
    }

    /**
     * Defines base properties passed from constructor.
     * @param {Object} options
     */


    _createClass(ClipboardAction, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = options.action;
            this.container = options.container;
            this.emitter = options.emitter;
            this.target = options.target;
            this.text = options.text;
            this.trigger = options.trigger;

            this.selectedText = '';
        }

        /**
         * Decides which selection strategy is going to be applied based
         * on the existence of `text` and `target` properties.
         */

    }, {
        key: 'initSelection',
        value: function initSelection() {
            if (this.text) {
                this.selectFake();
            } else if (this.target) {
                this.selectTarget();
            }
        }

        /**
         * Creates a fake textarea element, sets its value from `text` property,
         * and makes a selection on it.
         */

    }, {
        key: 'selectFake',
        value: function selectFake() {
            var _this = this;

            var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

            this.removeFake();

            this.fakeHandlerCallback = function () {
                return _this.removeFake();
            };
            this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

            this.fakeElem = document.createElement('textarea');
            // Prevent zooming on iOS
            this.fakeElem.style.fontSize = '12pt';
            // Reset box model
            this.fakeElem.style.border = '0';
            this.fakeElem.style.padding = '0';
            this.fakeElem.style.margin = '0';
            // Move element out of screen horizontally
            this.fakeElem.style.position = 'absolute';
            this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
            // Move element to the same position vertically
            var yPosition = window.pageYOffset || document.documentElement.scrollTop;
            this.fakeElem.style.top = yPosition + 'px';

            this.fakeElem.setAttribute('readonly', '');
            this.fakeElem.value = this.text;

            this.container.appendChild(this.fakeElem);

            this.selectedText = (0, _select2.default)(this.fakeElem);
            this.copyText();
        }

        /**
         * Only removes the fake element after another click event, that way
         * a user can hit `Ctrl+C` to copy because selection still exists.
         */

    }, {
        key: 'removeFake',
        value: function removeFake() {
            if (this.fakeHandler) {
                this.container.removeEventListener('click', this.fakeHandlerCallback);
                this.fakeHandler = null;
                this.fakeHandlerCallback = null;
            }

            if (this.fakeElem) {
                this.container.removeChild(this.fakeElem);
                this.fakeElem = null;
            }
        }

        /**
         * Selects the content from element passed on `target` property.
         */

    }, {
        key: 'selectTarget',
        value: function selectTarget() {
            this.selectedText = (0, _select2.default)(this.target);
            this.copyText();
        }

        /**
         * Executes the copy operation based on the current selection.
         */

    }, {
        key: 'copyText',
        value: function copyText() {
            var succeeded = void 0;

            try {
                succeeded = document.execCommand(this.action);
            } catch (err) {
                succeeded = false;
            }

            this.handleResult(succeeded);
        }

        /**
         * Fires an event based on the copy operation result.
         * @param {Boolean} succeeded
         */

    }, {
        key: 'handleResult',
        value: function handleResult(succeeded) {
            this.emitter.emit(succeeded ? 'success' : 'error', {
                action: this.action,
                text: this.selectedText,
                trigger: this.trigger,
                clearSelection: this.clearSelection.bind(this)
            });
        }

        /**
         * Moves focus away from `target` and back to the trigger, removes current selection.
         */

    }, {
        key: 'clearSelection',
        value: function clearSelection() {
            if (this.trigger) {
                this.trigger.focus();
            }

            window.getSelection().removeAllRanges();
        }

        /**
         * Sets the `action` to be performed which can be either 'copy' or 'cut'.
         * @param {String} action
         */

    }, {
        key: 'destroy',


        /**
         * Destroy lifecycle.
         */
        value: function destroy() {
            this.removeFake();
        }
    }, {
        key: 'action',
        set: function set() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

            this._action = action;

            if (this._action !== 'copy' && this._action !== 'cut') {
                throw new Error('Invalid "action" value, use either "copy" or "cut"');
            }
        }

        /**
         * Gets the `action` property.
         * @return {String}
         */
        ,
        get: function get() {
            return this._action;
        }

        /**
         * Sets the `target` property using an element
         * that will be have its content copied.
         * @param {Element} target
         */

    }, {
        key: 'target',
        set: function set(target) {
            if (target !== undefined) {
                if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                    if (this.action === 'copy' && target.hasAttribute('disabled')) {
                        throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                    }

                    if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                        throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                    }

                    this._target = target;
                } else {
                    throw new Error('Invalid "target" value, use a valid Element');
                }
            }
        }

        /**
         * Gets the `target` property.
         * @return {String|HTMLElement}
         */
        ,
        get: function get() {
            return this._target;
        }
    }]);

    return ClipboardAction;
}();

module.exports = ClipboardAction;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(5);
var delegate = __webpack_require__(6);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(7);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ })
/******/ ]);
});

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2526);
module.exports = __webpack_require__(156).RegExp.escape;


/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(840);
__webpack_require__(2508);
module.exports = __webpack_require__(153).Array.from;


/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2510);
module.exports = __webpack_require__(153).Object.assign;


/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2511);
var $Object = __webpack_require__(153).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2515);
module.exports = __webpack_require__(153).Object.entries;


/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2512);
module.exports = __webpack_require__(153).Object.setPrototypeOf;


/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2516);
module.exports = __webpack_require__(153).Object.values;


/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2514);
__webpack_require__(2513);
__webpack_require__(2517);
__webpack_require__(2518);
module.exports = __webpack_require__(153).Symbol;


/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(840);
__webpack_require__(2519);
module.exports = __webpack_require__(516).f('iterator');


/***/ }),
/* 2486 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 2487 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(217);
var toLength = __webpack_require__(839);
var toAbsoluteIndex = __webpack_require__(2506);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(502);
var TAG = __webpack_require__(154)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(216);
var createDesc = __webpack_require__(290);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(288);
var gOPS = __webpack_require__(508);
var pIE = __webpack_require__(289);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(195).document;
module.exports = document && document.documentElement;


/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(287);
var ITERATOR = __webpack_require__(154)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(502);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(249);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(507);
var descriptor = __webpack_require__(290);
var setToStringTag = __webpack_require__(509);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(251)(IteratorPrototype, __webpack_require__(154)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(154)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 2498 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(357)('meta');
var isObject = __webpack_require__(252);
var has = __webpack_require__(215);
var setDesc = __webpack_require__(216).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(286)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(288);
var gOPS = __webpack_require__(508);
var pIE = __webpack_require__(289);
var toObject = __webpack_require__(513);
var IObject = __webpack_require__(832);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(286)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 2501 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(216);
var anObject = __webpack_require__(249);
var getKeys = __webpack_require__(288);

module.exports = __webpack_require__(250) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(217);
var gOPN = __webpack_require__(835).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 2503 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(215);
var toObject = __webpack_require__(513);
var IE_PROTO = __webpack_require__(510)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 2504 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(252);
var anObject = __webpack_require__(249);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(503)(Function.call, __webpack_require__(834).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 2505 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(512);
var defined = __webpack_require__(504);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 2506 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(512);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 2507 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(2489);
var ITERATOR = __webpack_require__(154)('iterator');
var Iterators = __webpack_require__(287);
module.exports = __webpack_require__(153).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(503);
var $export = __webpack_require__(194);
var toObject = __webpack_require__(513);
var call = __webpack_require__(2495);
var isArrayIter = __webpack_require__(2493);
var toLength = __webpack_require__(839);
var createProperty = __webpack_require__(2490);
var getIterFn = __webpack_require__(2507);

$export($export.S + $export.F * !__webpack_require__(2497)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 2509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(2487);
var step = __webpack_require__(2498);
var Iterators = __webpack_require__(287);
var toIObject = __webpack_require__(217);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(833)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(194);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(2500) });


/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(194);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(507) });


/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(194);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(2504).set });


/***/ }),
/* 2513 */
/***/ (function(module, exports) {



/***/ }),
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(195);
var has = __webpack_require__(215);
var DESCRIPTORS = __webpack_require__(250);
var $export = __webpack_require__(194);
var redefine = __webpack_require__(838);
var META = __webpack_require__(2499).KEY;
var $fails = __webpack_require__(286);
var shared = __webpack_require__(511);
var setToStringTag = __webpack_require__(509);
var uid = __webpack_require__(357);
var wks = __webpack_require__(154);
var wksExt = __webpack_require__(516);
var wksDefine = __webpack_require__(515);
var enumKeys = __webpack_require__(2491);
var isArray = __webpack_require__(2494);
var anObject = __webpack_require__(249);
var isObject = __webpack_require__(252);
var toIObject = __webpack_require__(217);
var toPrimitive = __webpack_require__(514);
var createDesc = __webpack_require__(290);
var _create = __webpack_require__(507);
var gOPNExt = __webpack_require__(2502);
var $GOPD = __webpack_require__(834);
var $DP = __webpack_require__(216);
var $keys = __webpack_require__(288);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(835).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(289).f = $propertyIsEnumerable;
  __webpack_require__(508).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(506)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(251)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(194);
var $entries = __webpack_require__(837)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(194);
var $values = __webpack_require__(837)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 2517 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(515)('asyncIterator');


/***/ }),
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(515)('observable');


/***/ }),
/* 2519 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2509);
var global = __webpack_require__(195);
var hide = __webpack_require__(251);
var Iterators = __webpack_require__(287);
var TO_STRING_TAG = __webpack_require__(154)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 2520 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(68);
var isArray = __webpack_require__(362);
var SPECIES = __webpack_require__(81)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 2521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(66);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 2522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(57);
var toPrimitive = __webpack_require__(160);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(223);
var gOPS = __webpack_require__(366);
var pIE = __webpack_require__(293);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 2524 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 2525 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 2526 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(18);
var $re = __webpack_require__(2524)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(18);

$export($export.P, 'Array', { copyWithin: __webpack_require__(842) });

__webpack_require__(196)('copyWithin');


/***/ }),
/* 2528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var $every = __webpack_require__(155)(4);

$export($export.P + $export.F * !__webpack_require__(147)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2529 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(18);

$export($export.P, 'Array', { fill: __webpack_require__(517) });

__webpack_require__(196)('fill');


/***/ }),
/* 2530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var $filter = __webpack_require__(155)(2);

$export($export.P + $export.F * !__webpack_require__(147)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(18);
var $find = __webpack_require__(155)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(196)(KEY);


/***/ }),
/* 2532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(18);
var $find = __webpack_require__(155)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(196)(KEY);


/***/ }),
/* 2533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var $forEach = __webpack_require__(155)(0);
var STRICT = __webpack_require__(147)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(146);
var $export = __webpack_require__(18);
var toObject = __webpack_require__(97);
var call = __webpack_require__(853);
var isArrayIter = __webpack_require__(525);
var toLength = __webpack_require__(91);
var createProperty = __webpack_require__(519);
var getIterFn = __webpack_require__(542);

$export($export.S + $export.F * !__webpack_require__(364)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 2535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var $indexOf = __webpack_require__(358)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(147)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 2536 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(18);

$export($export.S, 'Array', { isArray: __webpack_require__(362) });


/***/ }),
/* 2537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(18);
var toIObject = __webpack_require__(134);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(292) != Object || !__webpack_require__(147)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 2538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var toIObject = __webpack_require__(134);
var toInteger = __webpack_require__(159);
var toLength = __webpack_require__(91);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(147)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var $map = __webpack_require__(155)(1);

$export($export.P + $export.F * !__webpack_require__(147)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var createProperty = __webpack_require__(519);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(66)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var $reduce = __webpack_require__(844);

$export($export.P + $export.F * !__webpack_require__(147)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var $reduce = __webpack_require__(844);

$export($export.P + $export.F * !__webpack_require__(147)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var html = __webpack_require__(523);
var cof = __webpack_require__(145);
var toAbsoluteIndex = __webpack_require__(227);
var toLength = __webpack_require__(91);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(66)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 2544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var $some = __webpack_require__(155)(3);

$export($export.P + $export.F * !__webpack_require__(147)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var aFunction = __webpack_require__(111);
var toObject = __webpack_require__(97);
var fails = __webpack_require__(66);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(147)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(226)('Array');


/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(18);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(18);
var toISOString = __webpack_require__(2521);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var toObject = __webpack_require__(97);
var toPrimitive = __webpack_require__(160);

$export($export.P + $export.F * __webpack_require__(66)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(81)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(123)(proto, TO_PRIMITIVE, __webpack_require__(2522));


/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(124)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(18);

$export($export.P, 'Function', { bind: __webpack_require__(845) });


/***/ }),
/* 2553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(68);
var getPrototypeOf = __webpack_require__(133);
var HAS_INSTANCE = __webpack_require__(81)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(90).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 2554 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(90).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(89) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 2555 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(18);
var log1p = __webpack_require__(856);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(18);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(18);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(18);
var sign = __webpack_require__(529);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 2559 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(18);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 2560 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(18);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(18);
var $expm1 = __webpack_require__(528);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 2562 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(18);

$export($export.S, 'Math', { fround: __webpack_require__(855) });


/***/ }),
/* 2563 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(18);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 2564 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(18);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(66)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 2565 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(18);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 2566 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(18);

$export($export.S, 'Math', { log1p: __webpack_require__(856) });


/***/ }),
/* 2567 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(18);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 2568 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(18);

$export($export.S, 'Math', { sign: __webpack_require__(529) });


/***/ }),
/* 2569 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(18);
var expm1 = __webpack_require__(528);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(66)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 2570 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(18);
var expm1 = __webpack_require__(528);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 2571 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(18);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 2572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(60);
var has = __webpack_require__(122);
var cof = __webpack_require__(145);
var inheritIfRequired = __webpack_require__(524);
var toPrimitive = __webpack_require__(160);
var fails = __webpack_require__(66);
var gOPN = __webpack_require__(222).f;
var gOPD = __webpack_require__(132).f;
var dP = __webpack_require__(90).f;
var $trim = __webpack_require__(255).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(221)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(89) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(124)(global, NUMBER, $Number);
}


/***/ }),
/* 2573 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(18);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 2574 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(18);
var _isFinite = __webpack_require__(60).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 2575 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(18);

$export($export.S, 'Number', { isInteger: __webpack_require__(852) });


/***/ }),
/* 2576 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(18);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 2577 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(18);
var isInteger = __webpack_require__(852);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 2578 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(18);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 2579 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(18);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 2580 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
var $parseFloat = __webpack_require__(864);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 2581 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
var $parseInt = __webpack_require__(865);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 2582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var toInteger = __webpack_require__(159);
var aNumberValue = __webpack_require__(841);
var repeat = __webpack_require__(536);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(66)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 2583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var $fails = __webpack_require__(66);
var aNumberValue = __webpack_require__(841);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 2584 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(18);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(858) });


/***/ }),
/* 2585 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(221) });


/***/ }),
/* 2586 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(89), 'Object', { defineProperties: __webpack_require__(859) });


/***/ }),
/* 2587 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(89), 'Object', { defineProperty: __webpack_require__(90).f });


/***/ }),
/* 2588 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(68);
var meta = __webpack_require__(197).onFreeze;

__webpack_require__(158)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 2589 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(134);
var $getOwnPropertyDescriptor = __webpack_require__(132).f;

__webpack_require__(158)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 2590 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(158)('getOwnPropertyNames', function () {
  return __webpack_require__(860).f;
});


/***/ }),
/* 2591 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(97);
var $getPrototypeOf = __webpack_require__(133);

__webpack_require__(158)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(68);

__webpack_require__(158)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 2593 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(68);

__webpack_require__(158)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 2594 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(68);

__webpack_require__(158)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 2595 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(18);
$export($export.S, 'Object', { is: __webpack_require__(2525) });


/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(97);
var $keys = __webpack_require__(223);

__webpack_require__(158)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 2597 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(68);
var meta = __webpack_require__(197).onFreeze;

__webpack_require__(158)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 2598 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(68);
var meta = __webpack_require__(197).onFreeze;

__webpack_require__(158)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 2599 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(18);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(532).set });


/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(291);
var test = {};
test[__webpack_require__(81)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(124)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
var $parseFloat = __webpack_require__(864);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
var $parseInt = __webpack_require__(865);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 2603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(220);
var global = __webpack_require__(60);
var ctx = __webpack_require__(146);
var classof = __webpack_require__(291);
var $export = __webpack_require__(18);
var isObject = __webpack_require__(68);
var aFunction = __webpack_require__(111);
var anInstance = __webpack_require__(218);
var forOf = __webpack_require__(219);
var speciesConstructor = __webpack_require__(370);
var task = __webpack_require__(538).set;
var microtask = __webpack_require__(530)();
var newPromiseCapabilityModule = __webpack_require__(531);
var perform = __webpack_require__(866);
var promiseResolve = __webpack_require__(867);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(81)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(225)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(254)($Promise, PROMISE);
__webpack_require__(226)(PROMISE);
Wrapper = __webpack_require__(156)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(364)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 2604 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(18);
var aFunction = __webpack_require__(111);
var anObject = __webpack_require__(57);
var rApply = (__webpack_require__(60).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(66)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 2605 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(18);
var create = __webpack_require__(221);
var aFunction = __webpack_require__(111);
var anObject = __webpack_require__(57);
var isObject = __webpack_require__(68);
var fails = __webpack_require__(66);
var bind = __webpack_require__(845);
var rConstruct = (__webpack_require__(60).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 2606 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(90);
var $export = __webpack_require__(18);
var anObject = __webpack_require__(57);
var toPrimitive = __webpack_require__(160);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(66)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 2607 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(18);
var gOPD = __webpack_require__(132).f;
var anObject = __webpack_require__(57);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 2608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(18);
var anObject = __webpack_require__(57);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(526)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 2609 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(132);
var $export = __webpack_require__(18);
var anObject = __webpack_require__(57);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 2610 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(18);
var getProto = __webpack_require__(133);
var anObject = __webpack_require__(57);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 2611 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(132);
var getPrototypeOf = __webpack_require__(133);
var has = __webpack_require__(122);
var $export = __webpack_require__(18);
var isObject = __webpack_require__(68);
var anObject = __webpack_require__(57);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 2612 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(18);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 2613 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(18);
var anObject = __webpack_require__(57);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(18);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(863) });


/***/ }),
/* 2615 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(18);
var anObject = __webpack_require__(57);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 2616 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(18);
var setProto = __webpack_require__(532);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 2617 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(90);
var gOPD = __webpack_require__(132);
var getPrototypeOf = __webpack_require__(133);
var has = __webpack_require__(122);
var $export = __webpack_require__(18);
var createDesc = __webpack_require__(224);
var anObject = __webpack_require__(57);
var isObject = __webpack_require__(68);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(60);
var inheritIfRequired = __webpack_require__(524);
var dP = __webpack_require__(90).f;
var gOPN = __webpack_require__(222).f;
var isRegExp = __webpack_require__(363);
var $flags = __webpack_require__(361);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(89) && (!CORRECT_NEW || __webpack_require__(66)(function () {
  re2[__webpack_require__(81)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(124)(global, 'RegExp', $RegExp);
}

__webpack_require__(226)('RegExp');


/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(360)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(360)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(360)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(360)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(363);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 2623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(872);
var anObject = __webpack_require__(57);
var $flags = __webpack_require__(361);
var DESCRIPTORS = __webpack_require__(89);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(124)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(66)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(125)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(125)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(125)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(125)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var $at = __webpack_require__(534)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(18);
var toLength = __webpack_require__(91);
var context = __webpack_require__(535);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(522)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 2630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(125)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 2631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(125)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 2632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(125)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 2633 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
var toAbsoluteIndex = __webpack_require__(227);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 2634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(18);
var context = __webpack_require__(535);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(522)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(125)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 2636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(534)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(527)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(125)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 2638 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
var toIObject = __webpack_require__(134);
var toLength = __webpack_require__(91);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 2639 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(536)
});


/***/ }),
/* 2640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(125)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 2641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(18);
var toLength = __webpack_require__(91);
var context = __webpack_require__(535);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(522)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 2642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(125)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(125)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(125)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(255)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(60);
var has = __webpack_require__(122);
var DESCRIPTORS = __webpack_require__(89);
var $export = __webpack_require__(18);
var redefine = __webpack_require__(124);
var META = __webpack_require__(197).KEY;
var $fails = __webpack_require__(66);
var shared = __webpack_require__(369);
var setToStringTag = __webpack_require__(254);
var uid = __webpack_require__(228);
var wks = __webpack_require__(81);
var wksExt = __webpack_require__(870);
var wksDefine = __webpack_require__(541);
var enumKeys = __webpack_require__(2523);
var isArray = __webpack_require__(362);
var anObject = __webpack_require__(57);
var isObject = __webpack_require__(68);
var toIObject = __webpack_require__(134);
var toPrimitive = __webpack_require__(160);
var createDesc = __webpack_require__(224);
var _create = __webpack_require__(221);
var gOPNExt = __webpack_require__(860);
var $GOPD = __webpack_require__(132);
var $DP = __webpack_require__(90);
var $keys = __webpack_require__(223);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(222).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(293).f = $propertyIsEnumerable;
  __webpack_require__(366).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(220)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(123)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var $typed = __webpack_require__(371);
var buffer = __webpack_require__(539);
var anObject = __webpack_require__(57);
var toAbsoluteIndex = __webpack_require__(227);
var toLength = __webpack_require__(91);
var isObject = __webpack_require__(68);
var ArrayBuffer = __webpack_require__(60).ArrayBuffer;
var speciesConstructor = __webpack_require__(370);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(66)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(226)(ARRAY_BUFFER);


/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
$export($export.G + $export.W + $export.F * !__webpack_require__(371).ABV, {
  DataView: __webpack_require__(539).DataView
});


/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2656 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(848);
var validate = __webpack_require__(256);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(359)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(18);
var flattenIntoArray = __webpack_require__(849);
var toObject = __webpack_require__(97);
var toLength = __webpack_require__(91);
var aFunction = __webpack_require__(111);
var arraySpeciesCreate = __webpack_require__(518);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(196)('flatMap');


/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(18);
var flattenIntoArray = __webpack_require__(849);
var toObject = __webpack_require__(97);
var toLength = __webpack_require__(91);
var toInteger = __webpack_require__(159);
var arraySpeciesCreate = __webpack_require__(518);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(196)('flatten');


/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(18);
var $includes = __webpack_require__(358)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(196)('includes');


/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(18);
var microtask = __webpack_require__(530)();
var process = __webpack_require__(60).process;
var isNode = __webpack_require__(145)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 2663 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(18);
var cof = __webpack_require__(145);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(18);

$export($export.G, { global: __webpack_require__(60) });


/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(367)('Map');


/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(368)('Map');


/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(18);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(847)('Map') });


/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(18);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(18);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(18);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(18);
var scale = __webpack_require__(857);
var fround = __webpack_require__(855);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(18);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(18);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(18);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(18);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(18);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(18);

$export($export.S, 'Math', { scale: __webpack_require__(857) });


/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(18);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 2679 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(18);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var toObject = __webpack_require__(97);
var aFunction = __webpack_require__(111);
var $defineProperty = __webpack_require__(90);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(89) && $export($export.P + __webpack_require__(365), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var toObject = __webpack_require__(97);
var aFunction = __webpack_require__(111);
var $defineProperty = __webpack_require__(90);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(89) && $export($export.P + __webpack_require__(365), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(18);
var $entries = __webpack_require__(862)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(18);
var ownKeys = __webpack_require__(863);
var toIObject = __webpack_require__(134);
var gOPD = __webpack_require__(132);
var createProperty = __webpack_require__(519);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var toObject = __webpack_require__(97);
var toPrimitive = __webpack_require__(160);
var getPrototypeOf = __webpack_require__(133);
var getOwnPropertyDescriptor = __webpack_require__(132).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(89) && $export($export.P + __webpack_require__(365), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var toObject = __webpack_require__(97);
var toPrimitive = __webpack_require__(160);
var getPrototypeOf = __webpack_require__(133);
var getOwnPropertyDescriptor = __webpack_require__(132).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(89) && $export($export.P + __webpack_require__(365), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(18);
var $values = __webpack_require__(862)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(18);
var global = __webpack_require__(60);
var core = __webpack_require__(156);
var microtask = __webpack_require__(530)();
var OBSERVABLE = __webpack_require__(81)('observable');
var aFunction = __webpack_require__(111);
var anObject = __webpack_require__(57);
var anInstance = __webpack_require__(218);
var redefineAll = __webpack_require__(225);
var hide = __webpack_require__(123);
var forOf = __webpack_require__(219);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(226)('Observable');


/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(18);
var core = __webpack_require__(156);
var global = __webpack_require__(60);
var speciesConstructor = __webpack_require__(370);
var promiseResolve = __webpack_require__(867);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(18);
var newPromiseCapability = __webpack_require__(531);
var perform = __webpack_require__(866);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(179);
var anObject = __webpack_require__(57);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(179);
var anObject = __webpack_require__(57);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(873);
var from = __webpack_require__(843);
var metadata = __webpack_require__(179);
var anObject = __webpack_require__(57);
var getPrototypeOf = __webpack_require__(133);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(179);
var anObject = __webpack_require__(57);
var getPrototypeOf = __webpack_require__(133);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(179);
var anObject = __webpack_require__(57);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(179);
var anObject = __webpack_require__(57);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(179);
var anObject = __webpack_require__(57);
var getPrototypeOf = __webpack_require__(133);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 2697 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(179);
var anObject = __webpack_require__(57);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(179);
var anObject = __webpack_require__(57);
var aFunction = __webpack_require__(111);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 2699 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(367)('Set');


/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(368)('Set');


/***/ }),
/* 2701 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(18);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(847)('Set') });


/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(18);
var $at = __webpack_require__(534)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 2703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(18);
var defined = __webpack_require__(157);
var toLength = __webpack_require__(91);
var isRegExp = __webpack_require__(363);
var getFlags = __webpack_require__(361);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(526)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 2704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(18);
var $pad = __webpack_require__(868);
var userAgent = __webpack_require__(540);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 2705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(18);
var $pad = __webpack_require__(868);
var userAgent = __webpack_require__(540);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(255)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(255)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(541)('asyncIterator');


/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(541)('observable');


/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(18);

$export($export.S, 'System', { global: __webpack_require__(60) });


/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(367)('WeakMap');


/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(368)('WeakMap');


/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(367)('WeakSet');


/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(368)('WeakSet');


/***/ }),
/* 2715 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(543);
var getKeys = __webpack_require__(223);
var redefine = __webpack_require__(124);
var global = __webpack_require__(60);
var hide = __webpack_require__(123);
var Iterators = __webpack_require__(253);
var wks = __webpack_require__(81);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 2716 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
var $task = __webpack_require__(538);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 2717 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(60);
var $export = __webpack_require__(18);
var userAgent = __webpack_require__(540);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2646);
__webpack_require__(2585);
__webpack_require__(2587);
__webpack_require__(2586);
__webpack_require__(2589);
__webpack_require__(2591);
__webpack_require__(2596);
__webpack_require__(2590);
__webpack_require__(2588);
__webpack_require__(2598);
__webpack_require__(2597);
__webpack_require__(2593);
__webpack_require__(2594);
__webpack_require__(2592);
__webpack_require__(2584);
__webpack_require__(2595);
__webpack_require__(2599);
__webpack_require__(2600);
__webpack_require__(2552);
__webpack_require__(2554);
__webpack_require__(2553);
__webpack_require__(2602);
__webpack_require__(2601);
__webpack_require__(2572);
__webpack_require__(2582);
__webpack_require__(2583);
__webpack_require__(2573);
__webpack_require__(2574);
__webpack_require__(2575);
__webpack_require__(2576);
__webpack_require__(2577);
__webpack_require__(2578);
__webpack_require__(2579);
__webpack_require__(2580);
__webpack_require__(2581);
__webpack_require__(2555);
__webpack_require__(2556);
__webpack_require__(2557);
__webpack_require__(2558);
__webpack_require__(2559);
__webpack_require__(2560);
__webpack_require__(2561);
__webpack_require__(2562);
__webpack_require__(2563);
__webpack_require__(2564);
__webpack_require__(2565);
__webpack_require__(2566);
__webpack_require__(2567);
__webpack_require__(2568);
__webpack_require__(2569);
__webpack_require__(2570);
__webpack_require__(2571);
__webpack_require__(2633);
__webpack_require__(2638);
__webpack_require__(2645);
__webpack_require__(2636);
__webpack_require__(2628);
__webpack_require__(2629);
__webpack_require__(2634);
__webpack_require__(2639);
__webpack_require__(2641);
__webpack_require__(2624);
__webpack_require__(2625);
__webpack_require__(2626);
__webpack_require__(2627);
__webpack_require__(2630);
__webpack_require__(2631);
__webpack_require__(2632);
__webpack_require__(2635);
__webpack_require__(2637);
__webpack_require__(2640);
__webpack_require__(2642);
__webpack_require__(2643);
__webpack_require__(2644);
__webpack_require__(2547);
__webpack_require__(2549);
__webpack_require__(2548);
__webpack_require__(2551);
__webpack_require__(2550);
__webpack_require__(2536);
__webpack_require__(2534);
__webpack_require__(2540);
__webpack_require__(2537);
__webpack_require__(2543);
__webpack_require__(2545);
__webpack_require__(2533);
__webpack_require__(2539);
__webpack_require__(2530);
__webpack_require__(2544);
__webpack_require__(2528);
__webpack_require__(2542);
__webpack_require__(2541);
__webpack_require__(2535);
__webpack_require__(2538);
__webpack_require__(2527);
__webpack_require__(2529);
__webpack_require__(2532);
__webpack_require__(2531);
__webpack_require__(2546);
__webpack_require__(543);
__webpack_require__(2618);
__webpack_require__(2623);
__webpack_require__(872);
__webpack_require__(2619);
__webpack_require__(2620);
__webpack_require__(2621);
__webpack_require__(2622);
__webpack_require__(2603);
__webpack_require__(871);
__webpack_require__(873);
__webpack_require__(874);
__webpack_require__(2658);
__webpack_require__(2647);
__webpack_require__(2648);
__webpack_require__(2653);
__webpack_require__(2656);
__webpack_require__(2657);
__webpack_require__(2651);
__webpack_require__(2654);
__webpack_require__(2652);
__webpack_require__(2655);
__webpack_require__(2649);
__webpack_require__(2650);
__webpack_require__(2604);
__webpack_require__(2605);
__webpack_require__(2606);
__webpack_require__(2607);
__webpack_require__(2608);
__webpack_require__(2611);
__webpack_require__(2609);
__webpack_require__(2610);
__webpack_require__(2612);
__webpack_require__(2613);
__webpack_require__(2614);
__webpack_require__(2615);
__webpack_require__(2617);
__webpack_require__(2616);
__webpack_require__(2661);
__webpack_require__(2659);
__webpack_require__(2660);
__webpack_require__(2702);
__webpack_require__(2705);
__webpack_require__(2704);
__webpack_require__(2706);
__webpack_require__(2707);
__webpack_require__(2703);
__webpack_require__(2708);
__webpack_require__(2709);
__webpack_require__(2683);
__webpack_require__(2686);
__webpack_require__(2682);
__webpack_require__(2680);
__webpack_require__(2681);
__webpack_require__(2684);
__webpack_require__(2685);
__webpack_require__(2667);
__webpack_require__(2701);
__webpack_require__(2666);
__webpack_require__(2700);
__webpack_require__(2712);
__webpack_require__(2714);
__webpack_require__(2665);
__webpack_require__(2699);
__webpack_require__(2711);
__webpack_require__(2713);
__webpack_require__(2664);
__webpack_require__(2710);
__webpack_require__(2663);
__webpack_require__(2668);
__webpack_require__(2669);
__webpack_require__(2670);
__webpack_require__(2671);
__webpack_require__(2672);
__webpack_require__(2674);
__webpack_require__(2673);
__webpack_require__(2675);
__webpack_require__(2676);
__webpack_require__(2677);
__webpack_require__(2679);
__webpack_require__(2678);
__webpack_require__(2688);
__webpack_require__(2689);
__webpack_require__(2690);
__webpack_require__(2691);
__webpack_require__(2693);
__webpack_require__(2692);
__webpack_require__(2695);
__webpack_require__(2694);
__webpack_require__(2696);
__webpack_require__(2697);
__webpack_require__(2698);
__webpack_require__(2662);
__webpack_require__(2687);
__webpack_require__(2717);
__webpack_require__(2716);
__webpack_require__(2715);
module.exports = __webpack_require__(156);


/***/ }),
/* 2719 */
/***/ (function(module, exports) {

module.exports = {
	"AED": {
		"code": "AED",
		"symbol": "د.إ.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"AFN": {
		"code": "AFN",
		"symbol": "؋",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"ALL": {
		"code": "ALL",
		"symbol": "Lek",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"AMD": {
		"code": "AMD",
		"symbol": "֏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"ANG": {
		"code": "ANG",
		"symbol": "ƒ",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"AOA": {
		"code": "AOA",
		"symbol": "Kz",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"ARS": {
		"code": "ARS",
		"symbol": "$",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"AUD": {
		"code": "AUD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"AWG": {
		"code": "AWG",
		"symbol": "ƒ",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"AZN": {
		"code": "AZN",
		"symbol": "₼",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"BAM": {
		"code": "BAM",
		"symbol": "КМ",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"BBD": {
		"code": "BBD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"BDT": {
		"code": "BDT",
		"symbol": "৳",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 0
	},
	"BGN": {
		"code": "BGN",
		"symbol": "лв.",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"BHD": {
		"code": "BHD",
		"symbol": "د.ب.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 3
	},
	"BIF": {
		"code": "BIF",
		"symbol": "FBu",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"BMD": {
		"code": "BMD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"BND": {
		"code": "BND",
		"symbol": "$",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"BOB": {
		"code": "BOB",
		"symbol": "Bs",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"BRL": {
		"code": "BRL",
		"symbol": "R$",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"BSD": {
		"code": "BSD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"BTC": {
		"code": "BTC",
		"symbol": "Ƀ",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"BTN": {
		"code": "BTN",
		"symbol": "Nu.",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 1
	},
	"BWP": {
		"code": "BWP",
		"symbol": "P",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"BYR": {
		"code": "BYR",
		"symbol": "р.",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"BZD": {
		"code": "BZD",
		"symbol": "BZ$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"CAD": {
		"code": "CAD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"CDF": {
		"code": "CDF",
		"symbol": "FC",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"CHF": {
		"code": "CHF",
		"symbol": "CHF",
		"thousandsSeparator": "'",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"CLP": {
		"code": "CLP",
		"symbol": "$",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"CNY": {
		"code": "CNY",
		"symbol": "¥",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"COP": {
		"code": "COP",
		"symbol": "$",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"CRC": {
		"code": "CRC",
		"symbol": "₡",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"CUC": {
		"code": "CUC",
		"symbol": "CUC",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"CUP": {
		"code": "CUP",
		"symbol": "$MN",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"CVE": {
		"code": "CVE",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"CZK": {
		"code": "CZK",
		"symbol": "Kč",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"DJF": {
		"code": "DJF",
		"symbol": "Fdj",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"DKK": {
		"code": "DKK",
		"symbol": "kr.",
		"thousandsSeparator": "",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"DOP": {
		"code": "DOP",
		"symbol": "RD$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"DZD": {
		"code": "DZD",
		"symbol": "د.ج.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"EGP": {
		"code": "EGP",
		"symbol": "ج.م.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"ERN": {
		"code": "ERN",
		"symbol": "Nfk",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"ETB": {
		"code": "ETB",
		"symbol": "ETB",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"EUR": {
		"code": "EUR",
		"symbol": "€",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"FJD": {
		"code": "FJD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"FKP": {
		"code": "FKP",
		"symbol": "£",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"GBP": {
		"code": "GBP",
		"symbol": "£",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"GEL": {
		"code": "GEL",
		"symbol": "Lari",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"GHS": {
		"code": "GHS",
		"symbol": "₵",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"GIP": {
		"code": "GIP",
		"symbol": "£",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"GMD": {
		"code": "GMD",
		"symbol": "D",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"GNF": {
		"code": "GNF",
		"symbol": "FG",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"GTQ": {
		"code": "GTQ",
		"symbol": "Q",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"GYD": {
		"code": "GYD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"HKD": {
		"code": "HKD",
		"symbol": "HK$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"HNL": {
		"code": "HNL",
		"symbol": "L.",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"HRK": {
		"code": "HRK",
		"symbol": "kn",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"HTG": {
		"code": "HTG",
		"symbol": "G",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"HUF": {
		"code": "HUF",
		"symbol": "Ft",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"IDR": {
		"code": "IDR",
		"symbol": "Rp",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"ILS": {
		"code": "ILS",
		"symbol": "₪",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"INR": {
		"code": "INR",
		"symbol": "₹",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"IQD": {
		"code": "IQD",
		"symbol": "د.ع.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"IRR": {
		"code": "IRR",
		"symbol": "﷼",
		"thousandsSeparator": ",",
		"decimalSeparator": "/",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"ISK": {
		"code": "ISK",
		"symbol": "kr.",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 0
	},
	"JMD": {
		"code": "JMD",
		"symbol": "J$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"JOD": {
		"code": "JOD",
		"symbol": "د.ا.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 3
	},
	"JPY": {
		"code": "JPY",
		"symbol": "¥",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"KES": {
		"code": "KES",
		"symbol": "S",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"KGS": {
		"code": "KGS",
		"symbol": "сом",
		"thousandsSeparator": " ",
		"decimalSeparator": "-",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"KHR": {
		"code": "KHR",
		"symbol": "៛",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"KMF": {
		"code": "KMF",
		"symbol": "CF",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"KPW": {
		"code": "KPW",
		"symbol": "₩",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"KRW": {
		"code": "KRW",
		"symbol": "₩",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"KWD": {
		"code": "KWD",
		"symbol": "د.ك.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 3
	},
	"KYD": {
		"code": "KYD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"KZT": {
		"code": "KZT",
		"symbol": "₸",
		"thousandsSeparator": " ",
		"decimalSeparator": "-",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"LAK": {
		"code": "LAK",
		"symbol": "₭",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"LBP": {
		"code": "LBP",
		"symbol": "ل.ل.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"LKR": {
		"code": "LKR",
		"symbol": "₨",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 0
	},
	"LRD": {
		"code": "LRD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"LSL": {
		"code": "LSL",
		"symbol": "M",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"LYD": {
		"code": "LYD",
		"symbol": "د.ل.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 3
	},
	"MAD": {
		"code": "MAD",
		"symbol": "د.م.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"MDL": {
		"code": "MDL",
		"symbol": "lei",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"MGA": {
		"code": "MGA",
		"symbol": "Ar",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"MKD": {
		"code": "MKD",
		"symbol": "ден.",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"MMK": {
		"code": "MMK",
		"symbol": "K",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MNT": {
		"code": "MNT",
		"symbol": "₮",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MOP": {
		"code": "MOP",
		"symbol": "MOP$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MRO": {
		"code": "MRO",
		"symbol": "UM",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MTL": {
		"code": "MTL",
		"symbol": "₤",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MUR": {
		"code": "MUR",
		"symbol": "₨",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MVR": {
		"code": "MVR",
		"symbol": "MVR",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 1
	},
	"MWK": {
		"code": "MWK",
		"symbol": "MK",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MXN": {
		"code": "MXN",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MYR": {
		"code": "MYR",
		"symbol": "RM",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MZN": {
		"code": "MZN",
		"symbol": "MT",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"NAD": {
		"code": "NAD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"NGN": {
		"code": "NGN",
		"symbol": "₦",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"NIO": {
		"code": "NIO",
		"symbol": "C$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"NOK": {
		"code": "NOK",
		"symbol": "kr",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"NPR": {
		"code": "NPR",
		"symbol": "₨",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"NZD": {
		"code": "NZD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"OMR": {
		"code": "OMR",
		"symbol": "﷼",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 3
	},
	"PAB": {
		"code": "PAB",
		"symbol": "B/.",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"PEN": {
		"code": "PEN",
		"symbol": "S/.",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"PGK": {
		"code": "PGK",
		"symbol": "K",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"PHP": {
		"code": "PHP",
		"symbol": "₱",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"PKR": {
		"code": "PKR",
		"symbol": "₨",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"PLN": {
		"code": "PLN",
		"symbol": "zł",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"PYG": {
		"code": "PYG",
		"symbol": "₲",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"QAR": {
		"code": "QAR",
		"symbol": "﷼",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"RON": {
		"code": "RON",
		"symbol": "lei",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"RSD": {
		"code": "RSD",
		"symbol": "Дин.",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"RUB": {
		"code": "RUB",
		"symbol": "₽",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"RWF": {
		"code": "RWF",
		"symbol": "RWF",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"SAR": {
		"code": "SAR",
		"symbol": "﷼",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"SBD": {
		"code": "SBD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SCR": {
		"code": "SCR",
		"symbol": "₨",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SDD": {
		"code": "SDD",
		"symbol": "LSd",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SDG": {
		"code": "SDG",
		"symbol": "£‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SEK": {
		"code": "SEK",
		"symbol": "kr",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"SGD": {
		"code": "SGD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SHP": {
		"code": "SHP",
		"symbol": "£",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SLL": {
		"code": "SLL",
		"symbol": "Le",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SOS": {
		"code": "SOS",
		"symbol": "S",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SRD": {
		"code": "SRD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"STD": {
		"code": "STD",
		"symbol": "Db",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SVC": {
		"code": "SVC",
		"symbol": "₡",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SYP": {
		"code": "SYP",
		"symbol": "£",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"SZL": {
		"code": "SZL",
		"symbol": "E",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"THB": {
		"code": "THB",
		"symbol": "฿",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"TJS": {
		"code": "TJS",
		"symbol": "TJS",
		"thousandsSeparator": " ",
		"decimalSeparator": ";",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"TMT": {
		"code": "TMT",
		"symbol": "m",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"TND": {
		"code": "TND",
		"symbol": "د.ت.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 3
	},
	"TOP": {
		"code": "TOP",
		"symbol": "T$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"TRY": {
		"code": "TRY",
		"symbol": "TL",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"TTD": {
		"code": "TTD",
		"symbol": "TT$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"TVD": {
		"code": "TVD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"TWD": {
		"code": "TWD",
		"symbol": "NT$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"TZS": {
		"code": "TZS",
		"symbol": "TSh",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"UAH": {
		"code": "UAH",
		"symbol": "₴",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"UGX": {
		"code": "UGX",
		"symbol": "USh",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"USD": {
		"code": "USD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"UYU": {
		"code": "UYU",
		"symbol": "$U",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"UZS": {
		"code": "UZS",
		"symbol": "сўм",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"VEB": {
		"code": "VEB",
		"symbol": "Bs.",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"VEF": {
		"code": "VEF",
		"symbol": "Bs. F.",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"VND": {
		"code": "VND",
		"symbol": "₫",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 1
	},
	"VUV": {
		"code": "VUV",
		"symbol": "VT",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"WST": {
		"code": "WST",
		"symbol": "WS$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"XAF": {
		"code": "XAF",
		"symbol": "F",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"XCD": {
		"code": "XCD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"XOF": {
		"code": "XOF",
		"symbol": "F",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"XPF": {
		"code": "XPF",
		"symbol": "F",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"YER": {
		"code": "YER",
		"symbol": "﷼",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"ZAR": {
		"code": "ZAR",
		"symbol": "R",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"ZMW": {
		"code": "ZMW",
		"symbol": "ZK",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"WON": {
		"code": "WON",
		"symbol": "₩",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	}
};

/***/ }),
/* 2720 */
/***/ (function(module, exports, __webpack_require__) {

var accounting = __webpack_require__(1179)
var assign = __webpack_require__(391)
var localeCurrency = __webpack_require__(2762)
var currencies = __webpack_require__(2719)
var localeFormats = __webpack_require__(2721)

var defaultCurrency = {
  symbol: '',
  thousandsSeparator: ',',
  decimalSeparator: '.',
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
}

var defaultLocaleFormat = {}

var formatMapping = [
  {
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: false,
    format: {
      pos: '%s%v',
      neg: '-%s%v',
      zero: '%s%v'
    }
  },
  {
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: true,
    format: {
      pos: '%s %v',
      neg: '-%s %v',
      zero: '%s %v'
    }
  },
  {
    symbolOnLeft: false,
    spaceBetweenAmountAndSymbol: false,
    format: {
      pos: '%v%s',
      neg: '-%v%s',
      zero: '%v%s'
    }
  },
  {
    symbolOnLeft: false,
    spaceBetweenAmountAndSymbol: true,
    format: {
      pos: '%v %s',
      neg: '-%v %s',
      zero: '%v %s'
    }
  }
]

function format(value, options) {
  var code = options.code || (options.locale && localeCurrency.getCurrency(options.locale))
  var localeFormat = localeFormats[options.locale] || defaultLocaleFormat
  var currency = assign({}, defaultCurrency, findCurrency(code), localeFormat)
  
  var symbolOnLeft = currency.symbolOnLeft
  var spaceBetweenAmountAndSymbol = currency.spaceBetweenAmountAndSymbol

  var format = formatMapping.filter(function(f) {
    return f.symbolOnLeft == symbolOnLeft && f.spaceBetweenAmountAndSymbol == spaceBetweenAmountAndSymbol
  })[0].format

  return accounting.formatMoney(value, {
    symbol: isUndefined(options.symbol)
              ? currency.symbol
              : options.symbol,

    decimal: isUndefined(options.decimal)
              ? currency.decimalSeparator
              : options.decimal,

    thousand: isUndefined(options.thousand)
              ? currency.thousandsSeparator
              : options.thousand,

    precision: typeof options.precision === 'number'
              ? options.precision
              : currency.decimalDigits,

    format: ['string', 'object'].indexOf(typeof options.format) > -1
              ? options.format
              : format
  })
}

function findCurrency (currencyCode) {
  return currencies[currencyCode]
}

function isUndefined (val) {
  return typeof val === 'undefined'
}

module.exports = {
  defaultCurrency: defaultCurrency,
  get currencies() {
    // In favor of backwards compatibility, the currencies map is converted to an array here
    return Object.keys(currencies).map(function(key) {
      return currencies[key]
    })
  },
  findCurrency: findCurrency,
  format: format
}

/***/ }),
/* 2721 */
/***/ (function(module, exports) {

module.exports = {
	"de-AT": {
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"el-GR": {
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"decimalDigits": 2
	},
	"en-IE": {
		"symbolOnLeft": true,
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"es-ES": {
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"it-IT": {
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"decimalDigits": 2
	},
	"nl-NL": {
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"decimalDigits": 2
	},
	"nl-BE": {
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"decimalDigits": 2
	}
};

/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str, sep) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	sep = typeof sep === 'undefined' ? '_' : sep;

	return str
		.replace(/([a-z\d])([A-Z])/g, '$1' + sep + '$2')
		.replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + sep + '$2')
		.toLowerCase();
};


/***/ }),
/* 2723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 2724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["a"] = (deepmerge_1);


/***/ }),
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(876);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
}
module.exports = exports['default'];

/***/ }),
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasClass = exports.removeClass = exports.addClass = undefined;

var _addClass = __webpack_require__(2725);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(2727);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _hasClass = __webpack_require__(876);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.addClass = _addClass2.default;
exports.removeClass = _removeClass2.default;
exports.hasClass = _hasClass2.default;
exports.default = { addClass: _addClass2.default, removeClass: _removeClass2.default, hasClass: _hasClass2.default };

/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};

/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filterEvents;

var _contains = __webpack_require__(257);

var _contains2 = _interopRequireDefault(_contains);

var _querySelectorAll = __webpack_require__(2734);

var _querySelectorAll2 = _interopRequireDefault(_querySelectorAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll2.default)(top, selector);

    if (matches.some(function (match) {
      return (0, _contains2.default)(match, target);
    })) handler.call(this, e);
  };
}
module.exports = exports['default'];

/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listen = exports.filter = exports.off = exports.on = undefined;

var _on = __webpack_require__(372);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(544);

var _off2 = _interopRequireDefault(_off);

var _filter = __webpack_require__(2728);

var _filter2 = _interopRequireDefault(_filter);

var _listen = __webpack_require__(2730);

var _listen2 = _interopRequireDefault(_listen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.on = _on2.default;
exports.off = _off2.default;
exports.filter = _filter2.default;
exports.listen = _listen2.default;
exports.default = { on: _on2.default, off: _off2.default, filter: _filter2.default, listen: _listen2.default };

/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(181);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _on = __webpack_require__(372);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(544);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var listen = function listen() {};

if (_inDOM2.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on2.default)(node, eventName, handler, capture);
    return function () {
      (0, _off2.default)(node, eventName, handler, capture);
    };
  };
}

exports.default = listen;
module.exports = exports['default'];

/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerWindow;

var _ownerDocument = __webpack_require__(229);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownerWindow(node) {
  var doc = (0, _ownerDocument2.default)(node);
  return doc && doc.defaultView || doc.parentWindow;
}
module.exports = exports['default'];

/***/ }),
/* 2732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = height;

var _offset = __webpack_require__(295);

var _offset2 = _interopRequireDefault(_offset);

var _isWindow = __webpack_require__(294);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function height(node, client) {
  var win = (0, _isWindow2.default)(node);
  return win ? win.innerHeight : client ? node.clientHeight : (0, _offset2.default)(node).height;
}
module.exports = exports['default'];

/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = position;

var _offset = __webpack_require__(295);

var _offset2 = _interopRequireDefault(_offset);

var _offsetParent = __webpack_require__(877);

var _offsetParent2 = _interopRequireDefault(_offsetParent);

var _scrollTop = __webpack_require__(545);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _scrollLeft = __webpack_require__(2735);

var _scrollLeft2 = _interopRequireDefault(_scrollLeft);

var _style = __webpack_require__(373);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = { top: 0, left: 0 },
      offset;

  // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent
  if ((0, _style2.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent2.default)(node);
    offset = (0, _offset2.default)(node);

    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset2.default)(offsetParent);

    parentOffset.top += parseInt((0, _style2.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop2.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style2.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft2.default)(offsetParent) || 0;
  }

  // Subtract parent offsets and node margins
  return _extends({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style2.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style2.default)(node, 'marginLeft'), 10) || 0)
  });
}
module.exports = exports['default'];

/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));

    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}
module.exports = exports['default'];

/***/ }),
/* 2735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(294);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;

  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}
module.exports = exports['default'];

/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _getComputedStyle;

var _camelizeStyle = __webpack_require__(879);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;

  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;

      prop = (0, _camelizeStyle2.default)(prop);

      if (prop == 'float') prop = 'styleFloat';

      var current = node.currentStyle[prop] || null;

      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left;

        // Put in the new values to get a computed value out
        if (rsLeft) runStyle.left = node.currentStyle.left;

        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px';

        // Revert the changed values
        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeStyle;
function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}
module.exports = exports['default'];

/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}
module.exports = exports["default"];

/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
module.exports = exports["default"];

/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenate;

var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
module.exports = exports['default'];

/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateStyleName;

var _hyphenate = __webpack_require__(2740);

var _hyphenate2 = _interopRequireDefault(_hyphenate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^ms-/; /**
                         * Copyright 2013-2014, Facebook, Inc.
                         * All rights reserved.
                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
                         */

function hyphenateStyleName(string) {
  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
}
module.exports = exports['default'];

/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2743);


/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(2744);

function scrollIntoView(elem, container, config) {
  config = config || {};
  // document 归一化到 window
  if (container.nodeType === 9) {
    container = util.getWindow(container);
  }

  var allowHorizontalScroll = config.allowHorizontalScroll;
  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
  var alignWithTop = config.alignWithTop;
  var alignWithLeft = config.alignWithLeft;

  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;

  var isWin = util.isWindow(container);
  var elemOffset = util.offset(elem);
  var eh = util.outerHeight(elem);
  var ew = util.outerWidth(elem);
  var containerOffset, ch, cw, containerScroll,
    diffTop, diffBottom, win,
    winScroll, ww, wh;

  if (isWin) {
    win = container;
    wh = util.height(win);
    ww = util.width(win);
    winScroll = {
      left: util.scrollLeft(win),
      top: util.scrollTop(win)
    };
    // elem 相对 container 可视视窗的距离
    diffTop = {
      left: elemOffset.left - winScroll.left,
      top: elemOffset.top - winScroll.top
    };
    diffBottom = {
      left: elemOffset.left + ew - (winScroll.left + ww),
      top: elemOffset.top + eh - (winScroll.top + wh)
    };
    containerScroll = winScroll;
  } else {
    containerOffset = util.offset(container);
    ch = container.clientHeight;
    cw = container.clientWidth;
    containerScroll = {
      left: container.scrollLeft,
      top: container.scrollTop
    };
    // elem 相对 container 可视视窗的距离
    // 注意边框, offset 是边框到根节点
    diffTop = {
      left: elemOffset.left - (containerOffset.left +
      (parseFloat(util.css(container, 'borderLeftWidth')) || 0)),
      top: elemOffset.top - (containerOffset.top +
      (parseFloat(util.css(container, 'borderTopWidth')) || 0))
    };
    diffBottom = {
      left: elemOffset.left + ew -
      (containerOffset.left + cw +
      (parseFloat(util.css(container, 'borderRightWidth')) || 0)),
      top: elemOffset.top + eh -
      (containerOffset.top + ch +
      (parseFloat(util.css(container, 'borderBottomWidth')) || 0))
    };
  }

  if (diffTop.top < 0 || diffBottom.top > 0) {
    // 强制向上
    if (alignWithTop === true) {
      util.scrollTop(container, containerScroll.top + diffTop.top);
    } else if (alignWithTop === false) {
      util.scrollTop(container, containerScroll.top + diffBottom.top);
    } else {
      // 自动调整
      if (diffTop.top < 0) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  } else {
    if (!onlyScrollIfNeeded) {
      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
      if (alignWithTop) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  }

  if (allowHorizontalScroll) {
    if (diffTop.left < 0 || diffBottom.left > 0) {
      // 强制向上
      if (alignWithLeft === true) {
        util.scrollLeft(container, containerScroll.left + diffTop.left);
      } else if (alignWithLeft === false) {
        util.scrollLeft(container, containerScroll.left + diffBottom.left);
      } else {
        // 自动调整
        if (diffTop.left < 0) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    } else {
      if (!onlyScrollIfNeeded) {
        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
        if (alignWithLeft) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    }
  }
}

module.exports = scrollIntoView;


/***/ }),
/* 2744 */
/***/ (function(module, exports) {

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

function getClientPosition(elem) {
  var box, x, y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {left: x, top: y};
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    //ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      //quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
function _getComputedStyle(elem, name, computedStyle) {
  var val = '';
  var d = elem.ownerDocument;

  // https://github.com/kissyteam/kissy/issues/61
  if ((computedStyle = (computedStyle || d.defaultView.getComputedStyle(elem, null)))) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/,
  CURRENT_STYLE = 'currentStyle',
  RUNTIME_STYLE = 'runtimeStyle',
  LEFT = 'left',
  PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style,
      left = style[LEFT],
      rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : (ret || 0);
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

var getComputedStyleX;
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setOffset(elem, offset) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var old = getOffset(elem),
    ret = {},
    current, key;

  for (key in offset) {
    current = parseFloat(css(elem, key)) || 0;
    ret[key] = current + offset[key] - old[key];
  }
  css(elem, ret);
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'],
  CONTENT_INDEX = -1,
  PADDING_INDEX = 2,
  BORDER_INDEX = 1,
  MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {},
    style = elem.style,
    name;

  // Remember the old values, and insert the new ones
  for (name in options) {
    old[name] = style[name];
    style[name] = options[name];
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    style[name] = old[name];
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0, prop, j, i;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp;
        if (prop === 'border') {
          cssProp = prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /*jshint eqeqeq:false*/
  return obj != null && obj == obj.window;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
      //firefox chrome documentElement.scrollHeight< body.scrollHeight
      //ie standard mode : documentElement.scrollHeight> body.scrollHeight
      d.documentElement['scroll' + name],
      //quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
      d.body['scroll' + name],
      domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name,
      doc = win.document,
      body = doc.body,
      documentElement = doc.documentElement,
      documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp ||
      body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, extra) {
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'],
    borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue == null || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue == null || (Number(cssBoxValue)) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'],
          which, computedStyle);
    } else {
      return cssBoxValue;
    }
  } else if (borderBoxValueOrIsBorderBox) {
    return val + (extra === BORDER_INDEX ? 0 :
        (extra === PADDING_INDEX ?
          -getPBMWidth(elem, ['border'], which, computedStyle) :
          getPBMWidth(elem, ['margin'], which, computedStyle)));
  } else {
    return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra),
        which, computedStyle);
  }
}

var cssShow = {position: 'absolute', visibility: 'hidden', display: 'block'};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay(elem) {
  var val, args = arguments;
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, val) {
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function css(el, name, value) {
  if (typeof name === 'object') {
    for (var i in name) {
      css(el, i, name[i]);
    }
    return;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = value + 'px';
    }
    el.style[name] = value;
  } else {
    return getComputedStyleX(el, name);
  }
}

function mix(to, from) {
  for (var i in from) {
    to[i] = from[i];
  }
  return to;
}

var utils = module.exports = {
  getWindow: function (node) {
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  offset: function (el, value) {
    if (typeof value !== 'undefined') {
      setOffset(el, value);
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function (obj) {
    var ret = {};
    for (var i in obj) {
      ret[i] = obj[i];
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        ret.overflow[i] = obj.overflow[i];
      }
    }
    return ret;
  },
  mix: mix,
  scrollLeft: function (w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollLeft(w);
      } else {
        window.scrollTo(v, getScrollTop(w));
      }
    } else {
      if (v === undefined) {
        return w.scrollLeft;
      } else {
        w.scrollLeft = v;
      }
    }
  },
  scrollTop: function (w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollTop(w);
      } else {
        window.scrollTo(getScrollLeft(w), v);
      }
    } else {
      if (v === undefined) {
        return w.scrollTop;
      } else {
        w.scrollTop = v;
      }
    }
  },
  merge: function () {
    var ret = {};
    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, arguments[i]);
    }
    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};

mix(utils, domUtils);


/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var exporter = {};

var tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
// Thanks to:
// http://fightingforalostcause.net/misc/2006/compare-email-regex.php
// http://thedailywtf.com/Articles/Validating_Email_Addresses.aspx
// http://stackoverflow.com/questions/201323/what-is-the-best-regular-expression-for-validating-email-addresses/201378#201378
function validate(email)
{
	if (!email)
		return false;
		
	if(email.length>254)
		return false;

	var valid = tester.test(email);
	if(!valid)
		return false;

	// Further checking of some things regex can't handle
	var parts = email.split("@");
	if(parts[0].length>64)
		return false;

	var domainParts = parts[1].split(".");
	if(domainParts.some(function(part) { return part.length>63; }))
		return false;

	return true;
}
exporter.validate = validate;

function validate_async(email, callback)
{
    var isValidEmail = false;
    try {
        isValidEmail = exporter.validate(email);
        callback(null, isValidEmail);
    }
    catch(err) {
        callback(err, isValidEmail)
    }
}
exporter.validate_async = validate_async;

module.exports = exporter;

/***/ }),
/* 2746 */,
/* 2747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 2750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "971a768dac142dd8a2ea2a409dac8bb0.png";

/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2124527c61096a683cd985ee8f543129.svg";

/***/ }),
/* 2752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9b1206aa19fabb73e9fa63884be5fa4b.svg";

/***/ }),
/* 2753 */
/***/ (function(module, exports, __webpack_require__) {

var isBuffer = __webpack_require__(2760)

module.exports = flatten
flatten.flatten = flatten
flatten.unflatten = unflatten

function flatten (target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var maxDepth = opts.maxDepth
  var output = {}

  function step (object, prev, currentDepth) {
    currentDepth = currentDepth || 1
    Object.keys(object).forEach(function (key) {
      var value = object[key]
      var isarray = opts.safe && Array.isArray(value)
      var type = Object.prototype.toString.call(value)
      var isbuffer = isBuffer(value)
      var isobject = (
        type === '[object Object]' ||
        type === '[object Array]'
      )

      var newKey = prev
        ? prev + delimiter + key
        : key

      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
        (!opts.maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1)
      }

      output[newKey] = value
    })
  }

  step(target)

  return output
}

function unflatten (target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var overwrite = opts.overwrite || false
  var result = {}

  var isbuffer = isBuffer(target)
  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
    return target
  }

  // safely ensure that the key is
  // an integer.
  function getkey (key) {
    var parsedKey = Number(key)

    return (
      isNaN(parsedKey) ||
      key.indexOf('.') !== -1 ||
      opts.object
    ) ? key
      : parsedKey
  }

  var sortedKeys = Object.keys(target).sort(function (keyA, keyB) {
    return keyA.length - keyB.length
  })

  sortedKeys.forEach(function (key) {
    var split = key.split(delimiter)
    var key1 = getkey(split.shift())
    var key2 = getkey(split[0])
    var recipient = result

    while (key2 !== undefined) {
      var type = Object.prototype.toString.call(recipient[key1])
      var isobject = (
        type === '[object Object]' ||
        type === '[object Array]'
      )

      // do not write over falsey, non-undefined values if overwrite is false
      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
        return
      }

      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
        recipient[key1] = (
          typeof key2 === 'number' &&
          !opts.object ? [] : {}
        )
      }

      recipient = recipient[key1]
      if (split.length > 0) {
        key1 = getkey(split.shift())
        key2 = getkey(split[0])
      }
    }

    // unflatten again for 'messy objects'
    recipient[key1] = unflatten(target[key], opts)
  })

  return result
}


/***/ }),
/* 2754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 2755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(3212);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(3227);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(546);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 2756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(69);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(105);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(2755);

var _PathUtils = __webpack_require__(546);

var _createTransitionManager = __webpack_require__(2757);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(2754);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 2757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(69);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 2758 */,
/* 2759 */,
/* 2760 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 2761 */,
/* 2762 */
/***/ (function(module, exports, __webpack_require__) {

var map = __webpack_require__(2763);

var getCountryCode = function(localeString) {
    var components = localeString.split("_");
    if (components.length == 2) {
        return components.pop();
    }
    components = localeString.split("-");
    if (components.length == 2) {
        return components.pop();
    }
    return localeString;
}

exports.getCurrency = function(locale) {
    var countryCode = getCountryCode(locale).toUpperCase();
    if (countryCode in map) {
        return map[countryCode];
    }
    return null;
}

exports.getLocales = function(currencyCode) {
    currencyCode = currencyCode.toUpperCase();
    var locales = [];
    for (countryCode in map) {
        if (map[countryCode] === currencyCode) {
            locales.push(countryCode);
        }
    }
    return locales;
}

/***/ }),
/* 2763 */
/***/ (function(module, exports) {

// Generated using ShowCurrencies.java
var map = {
AD: 'EUR',
AE: 'AED',
AF: 'AFN',
AG: 'XCD',
AI: 'XCD',
AL: 'ALL',
AM: 'AMD',
AN: 'ANG',
AO: 'AOA',
AR: 'ARS',
AS: 'USD',
AT: 'EUR',
AU: 'AUD',
AW: 'AWG',
AX: 'EUR',
AZ: 'AZN',
BA: 'BAM',
BB: 'BBD',
BD: 'BDT',
BE: 'EUR',
BF: 'XOF',
BG: 'BGN',
BH: 'BHD',
BI: 'BIF',
BJ: 'XOF',
BL: 'EUR',
BM: 'BMD',
BN: 'BND',
BO: 'BOB',
BQ: 'USD',
BR: 'BRL',
BS: 'BSD',
BT: 'BTN',
BV: 'NOK',
BW: 'BWP',
BY: 'BYR',
BZ: 'BZD',
CA: 'CAD',
CC: 'AUD',
CD: 'CDF',
CF: 'XAF',
CG: 'XAF',
CH: 'CHF',
CI: 'XOF',
CK: 'NZD',
CL: 'CLP',
CM: 'XAF',
CN: 'CNY',
CO: 'COP',
CR: 'CRC',
CU: 'CUP',
CV: 'CVE',
CW: 'ANG',
CX: 'AUD',
CY: 'EUR',
CZ: 'CZK',
DE: 'EUR',
DJ: 'DJF',
DK: 'DKK',
DM: 'XCD',
DO: 'DOP',
DZ: 'DZD',
EC: 'USD',
EE: 'EUR',
EG: 'EGP',
EH: 'MAD',
ER: 'ERN',
ES: 'EUR',
ET: 'ETB',
FI: 'EUR',
FJ: 'FJD',
FK: 'FKP',
FM: 'USD',
FO: 'DKK',
FR: 'EUR',
GA: 'XAF',
GB: 'GBP',
GD: 'XCD',
GE: 'GEL',
GF: 'EUR',
GG: 'GBP',
GH: 'GHS',
GI: 'GIP',
GL: 'DKK',
GM: 'GMD',
GN: 'GNF',
GP: 'EUR',
GQ: 'XAF',
GR: 'EUR',
GS: 'GBP',
GT: 'GTQ',
GU: 'USD',
GW: 'XOF',
GY: 'GYD',
HK: 'HKD',
HM: 'AUD',
HN: 'HNL',
HR: 'HRK',
HT: 'HTG',
HU: 'HUF',
ID: 'IDR',
IE: 'EUR',
IL: 'ILS',
IM: 'GBP',
IN: 'INR',
IO: 'USD',
IQ: 'IQD',
IR: 'IRR',
IS: 'ISK',
IT: 'EUR',
JE: 'GBP',
JM: 'JMD',
JO: 'JOD',
JP: 'JPY',
KE: 'KES',
KG: 'KGS',
KH: 'KHR',
KI: 'AUD',
KM: 'KMF',
KN: 'XCD',
KP: 'KPW',
KR: 'KRW',
KW: 'KWD',
KY: 'KYD',
KZ: 'KZT',
LA: 'LAK',
LB: 'LBP',
LC: 'XCD',
LI: 'CHF',
LK: 'LKR',
LR: 'LRD',
LS: 'LSL',
LT: 'LTL',
LU: 'EUR',
LV: 'LVL',
LY: 'LYD',
MA: 'MAD',
MC: 'EUR',
MD: 'MDL',
ME: 'EUR',
MF: 'EUR',
MG: 'MGA',
MH: 'USD',
MK: 'MKD',
ML: 'XOF',
MM: 'MMK',
MN: 'MNT',
MO: 'MOP',
MP: 'USD',
MQ: 'EUR',
MR: 'MRO',
MS: 'XCD',
MT: 'EUR',
MU: 'MUR',
MV: 'MVR',
MW: 'MWK',
MX: 'MXN',
MY: 'MYR',
MZ: 'MZN',
NA: 'NAD',
NC: 'XPF',
NE: 'XOF',
NF: 'AUD',
NG: 'NGN',
NI: 'NIO',
NL: 'EUR',
NO: 'NOK',
NP: 'NPR',
NR: 'AUD',
NU: 'NZD',
NZ: 'NZD',
OM: 'OMR',
PA: 'PAB',
PE: 'PEN',
PF: 'XPF',
PG: 'PGK',
PH: 'PHP',
PK: 'PKR',
PL: 'PLN',
PM: 'EUR',
PN: 'NZD',
PR: 'USD',
PS: 'ILS',
PT: 'EUR',
PW: 'USD',
PY: 'PYG',
QA: 'QAR',
RE: 'EUR',
RO: 'RON',
RS: 'RSD',
RU: 'RUB',
RW: 'RWF',
SA: 'SAR',
SB: 'SBD',
SC: 'SCR',
SD: 'SDG',
SE: 'SEK',
SG: 'SGD',
SH: 'SHP',
SI: 'EUR',
SJ: 'NOK',
SK: 'EUR',
SL: 'SLL',
SM: 'EUR',
SN: 'XOF',
SO: 'SOS',
SR: 'SRD',
ST: 'STD',
SV: 'SVC',
SX: 'ANG',
SY: 'SYP',
SZ: 'SZL',
TC: 'USD',
TD: 'XAF',
TF: 'EUR',
TG: 'XOF',
TH: 'THB',
TJ: 'TJS',
TK: 'NZD',
TL: 'USD',
TM: 'TMT',
TN: 'TND',
TO: 'TOP',
TR: 'TRY',
TT: 'TTD',
TV: 'AUD',
TW: 'TWD',
TZ: 'TZS',
UA: 'UAH',
UG: 'UGX',
UM: 'USD',
US: 'USD',
UY: 'UYU',
UZ: 'UZS',
VA: 'EUR',
VC: 'XCD',
VE: 'VEF',
VG: 'USD',
VI: 'USD',
VN: 'VND',
VU: 'VUV',
WF: 'XPF',
WS: 'WST',
YE: 'YER',
YT: 'EUR',
ZA: 'ZAR',
ZM: 'ZMK',
ZW: 'ZWL'
};

module.exports = map;

/***/ }),
/* 2764 */,
/* 2765 */,
/* 2766 */,
/* 2767 */,
/* 2768 */,
/* 2769 */,
/* 2770 */,
/* 2771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayEach);


/***/ }),
/* 2772 */,
/* 2773 */,
/* 2774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(304);



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssign);


/***/ }),
/* 2775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(305);



/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignIn);


/***/ }),
/* 2776 */,
/* 2777 */,
/* 2778 */,
/* 2779 */,
/* 2780 */,
/* 2781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTag_js__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(183);



/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getTag_js__["a" /* default */])(value) == mapTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMap);


/***/ }),
/* 2782 */,
/* 2783 */,
/* 2784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTag_js__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(183);



/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getTag_js__["a" /* default */])(value) == setTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsSet);


/***/ }),
/* 2785 */,
/* 2786 */,
/* 2787 */,
/* 2788 */,
/* 2789 */,
/* 2790 */,
/* 2791 */,
/* 2792 */,
/* 2793 */,
/* 2794 */,
/* 2795 */,
/* 2796 */,
/* 2797 */,
/* 2798 */,
/* 2799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(552);


/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneDataView);


/***/ }),
/* 2800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneRegExp);


/***/ }),
/* 2801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(297);


/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/* harmony default export */ __webpack_exports__["a"] = (cloneSymbol);


/***/ }),
/* 2802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(555);



/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (copySymbols);


/***/ }),
/* 2803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__ = __webpack_require__(904);



/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (copySymbolsIn);


/***/ }),
/* 2804 */,
/* 2805 */,
/* 2806 */,
/* 2807 */,
/* 2808 */,
/* 2809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keysIn_js__ = __webpack_require__(305);




/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keysIn_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeysIn);


/***/ }),
/* 2810 */,
/* 2811 */,
/* 2812 */,
/* 2813 */,
/* 2814 */,
/* 2815 */,
/* 2816 */,
/* 2817 */,
/* 2818 */,
/* 2819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneArray);


/***/ }),
/* 2820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneDataView_js__ = __webpack_require__(2799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneRegExp_js__ = __webpack_require__(2800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cloneSymbol_js__ = __webpack_require__(2801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cloneTypedArray_js__ = __webpack_require__(899);






/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cloneDataView_js__["a" /* default */])(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cloneTypedArray_js__["a" /* default */])(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cloneRegExp_js__["a" /* default */])(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cloneSymbol_js__["a" /* default */])(object);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneByTag);


/***/ }),
/* 2821 */,
/* 2822 */,
/* 2823 */,
/* 2824 */,
/* 2825 */,
/* 2826 */,
/* 2827 */,
/* 2828 */,
/* 2829 */,
/* 2830 */,
/* 2831 */,
/* 2832 */,
/* 2833 */,
/* 2834 */,
/* 2835 */,
/* 2836 */,
/* 2837 */,
/* 2838 */,
/* 2839 */,
/* 2840 */,
/* 2841 */,
/* 2842 */,
/* 2843 */,
/* 2844 */,
/* 2845 */,
/* 2846 */,
/* 2847 */,
/* 2848 */,
/* 2849 */,
/* 2850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClone_js__ = __webpack_require__(892);


/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseClone_js__["a" /* default */])(value, CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ __webpack_exports__["a"] = (clone);


/***/ }),
/* 2851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClone_js__ = __webpack_require__(892);


/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseClone_js__["a" /* default */])(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneDeep);


/***/ }),
/* 2852 */,
/* 2853 */,
/* 2854 */,
/* 2855 */,
/* 2856 */,
/* 2857 */,
/* 2858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMap_js__ = __webpack_require__(2781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(558);




/* Node.js helper references. */
var nodeIsMap = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsMap) : __WEBPACK_IMPORTED_MODULE_0__baseIsMap_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isMap);


/***/ }),
/* 2859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsSet_js__ = __webpack_require__(2784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(558);




/* Node.js helper references. */
var nodeIsSet = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsSet) : __WEBPACK_IMPORTED_MODULE_0__baseIsSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isSet);


/***/ }),
/* 2860 */,
/* 2861 */,
/* 2862 */,
/* 2863 */,
/* 2864 */,
/* 2865 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(231),
    root = __webpack_require__(162);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 2866 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(2905),
    hashDelete = __webpack_require__(2906),
    hashGet = __webpack_require__(2907),
    hashHas = __webpack_require__(2908),
    hashSet = __webpack_require__(2909);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 2867 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(231),
    root = __webpack_require__(162);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 2868 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(231),
    root = __webpack_require__(162);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 2869 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(385),
    stackClear = __webpack_require__(2936),
    stackDelete = __webpack_require__(2937),
    stackGet = __webpack_require__(2938),
    stackHas = __webpack_require__(2939),
    stackSet = __webpack_require__(2940);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 2870 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(162);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 2871 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(231),
    root = __webpack_require__(162);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 2872 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 2873 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 2874 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 2875 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(308),
    keys = __webpack_require__(575);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 2876 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(308),
    keysIn = __webpack_require__(935);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 2877 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(2869),
    arrayEach = __webpack_require__(2873),
    assignValue = __webpack_require__(919),
    baseAssign = __webpack_require__(2875),
    baseAssignIn = __webpack_require__(2876),
    cloneBuffer = __webpack_require__(2891),
    copyArray = __webpack_require__(2896),
    copySymbols = __webpack_require__(2897),
    copySymbolsIn = __webpack_require__(2898),
    getAllKeys = __webpack_require__(2902),
    getAllKeysIn = __webpack_require__(926),
    getTag = __webpack_require__(570),
    initCloneArray = __webpack_require__(2910),
    initCloneByTag = __webpack_require__(2911),
    initCloneObject = __webpack_require__(2912),
    isArray = __webpack_require__(232),
    isBuffer = __webpack_require__(933),
    isMap = __webpack_require__(2946),
    isObject = __webpack_require__(233),
    isSet = __webpack_require__(2948),
    keys = __webpack_require__(575);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 2878 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(233);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 2879 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(564),
    isFlattenable = __webpack_require__(2913);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 2880 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(259),
    isObjectLike = __webpack_require__(234);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 2881 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(570),
    isObjectLike = __webpack_require__(234);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 2882 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(389),
    isMasked = __webpack_require__(2917),
    isObject = __webpack_require__(233),
    toSource = __webpack_require__(931);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 2883 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(570),
    isObjectLike = __webpack_require__(234);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 2884 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(259),
    isLength = __webpack_require__(934),
    isObjectLike = __webpack_require__(234);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 2885 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(571),
    nativeKeys = __webpack_require__(2929);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 2886 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(233),
    isPrototype = __webpack_require__(571),
    nativeKeysIn = __webpack_require__(2930);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 2887 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(2943),
    defineProperty = __webpack_require__(924),
    identity = __webpack_require__(2945);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 2888 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 2889 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(307),
    arrayMap = __webpack_require__(918),
    isArray = __webpack_require__(232),
    isSymbol = __webpack_require__(390);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 2890 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(566),
    last = __webpack_require__(2950),
    parent = __webpack_require__(2933),
    toKey = __webpack_require__(930);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 2891 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(162);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(262)(module)))

/***/ }),
/* 2892 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(567);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 2893 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 2894 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(307);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 2895 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(567);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 2896 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 2897 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(308),
    getSymbols = __webpack_require__(569);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 2898 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(308),
    getSymbolsIn = __webpack_require__(927);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 2899 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(162);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 2900 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(2947);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 2901 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(2944),
    overRest = __webpack_require__(2932),
    setToString = __webpack_require__(2934);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(922),
    getSymbols = __webpack_require__(569),
    keys = __webpack_require__(575);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 2903 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(307);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 2904 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 2905 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(388);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 2906 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 2907 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(388);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 2908 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(388);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 2909 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(388);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 2910 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 2911 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(567),
    cloneDataView = __webpack_require__(2892),
    cloneRegExp = __webpack_require__(2893),
    cloneSymbol = __webpack_require__(2894),
    cloneTypedArray = __webpack_require__(2895);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 2912 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(2878),
    getPrototype = __webpack_require__(568),
    isPrototype = __webpack_require__(571);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 2913 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(307),
    isArguments = __webpack_require__(932),
    isArray = __webpack_require__(232);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 2914 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(573),
    isArrayLike = __webpack_require__(574),
    isIndex = __webpack_require__(928),
    isObject = __webpack_require__(233);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 2915 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(232),
    isSymbol = __webpack_require__(390);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 2916 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 2917 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(2899);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 2918 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 2919 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(386);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 2920 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(386);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 2921 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(386);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 2922 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(386);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 2923 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(2866),
    ListCache = __webpack_require__(385),
    Map = __webpack_require__(563);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 2924 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(387);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 2925 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(387);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 2926 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(387);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 2927 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(387);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 2928 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(2951);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 2929 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(929);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 2930 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 2931 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 2932 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(2872);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 2933 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(921),
    baseSlice = __webpack_require__(923);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 2934 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(2887),
    shortOut = __webpack_require__(2935);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 2935 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 2936 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(385);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 2937 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 2938 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 2939 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 2940 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(385),
    Map = __webpack_require__(563),
    MapCache = __webpack_require__(916);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 2941 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(2928);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 2942 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(923),
    isIterateeCall = __webpack_require__(2914),
    toInteger = __webpack_require__(2955);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),
/* 2943 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 2944 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(2879);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 2945 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 2946 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(2881),
    baseUnary = __webpack_require__(565),
    nodeUtil = __webpack_require__(572);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 2947 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(259),
    getPrototype = __webpack_require__(568),
    isObjectLike = __webpack_require__(234);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 2948 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(2883),
    baseUnary = __webpack_require__(565),
    nodeUtil = __webpack_require__(572);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 2949 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(2884),
    baseUnary = __webpack_require__(565),
    nodeUtil = __webpack_require__(572);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 2950 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 2951 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(916);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 2952 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(918),
    baseClone = __webpack_require__(2877),
    baseUnset = __webpack_require__(2890),
    castPath = __webpack_require__(566),
    copyObject = __webpack_require__(308),
    customOmitClone = __webpack_require__(2900),
    flatRest = __webpack_require__(2901),
    getAllKeysIn = __webpack_require__(926);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 2953 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 2954 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(2956);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 2955 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(2954);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 2956 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(233),
    isSymbol = __webpack_require__(390);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 2957 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(2889);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 2958 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 937,
	"./af.js": 937,
	"./ar": 944,
	"./ar-dz": 938,
	"./ar-dz.js": 938,
	"./ar-kw": 939,
	"./ar-kw.js": 939,
	"./ar-ly": 940,
	"./ar-ly.js": 940,
	"./ar-ma": 941,
	"./ar-ma.js": 941,
	"./ar-sa": 942,
	"./ar-sa.js": 942,
	"./ar-tn": 943,
	"./ar-tn.js": 943,
	"./ar.js": 944,
	"./az": 945,
	"./az.js": 945,
	"./be": 946,
	"./be.js": 946,
	"./bg": 947,
	"./bg.js": 947,
	"./bm": 948,
	"./bm.js": 948,
	"./bn": 950,
	"./bn-bd": 949,
	"./bn-bd.js": 949,
	"./bn.js": 950,
	"./bo": 951,
	"./bo.js": 951,
	"./br": 952,
	"./br.js": 952,
	"./bs": 953,
	"./bs.js": 953,
	"./ca": 954,
	"./ca.js": 954,
	"./cs": 955,
	"./cs.js": 955,
	"./cv": 956,
	"./cv.js": 956,
	"./cy": 957,
	"./cy.js": 957,
	"./da": 958,
	"./da.js": 958,
	"./de": 961,
	"./de-at": 959,
	"./de-at.js": 959,
	"./de-ch": 960,
	"./de-ch.js": 960,
	"./de.js": 961,
	"./dv": 962,
	"./dv.js": 962,
	"./el": 963,
	"./el.js": 963,
	"./en-au": 964,
	"./en-au.js": 964,
	"./en-ca": 965,
	"./en-ca.js": 965,
	"./en-gb": 966,
	"./en-gb.js": 966,
	"./en-ie": 967,
	"./en-ie.js": 967,
	"./en-il": 968,
	"./en-il.js": 968,
	"./en-in": 969,
	"./en-in.js": 969,
	"./en-nz": 970,
	"./en-nz.js": 970,
	"./en-sg": 971,
	"./en-sg.js": 971,
	"./eo": 972,
	"./eo.js": 972,
	"./es": 976,
	"./es-do": 973,
	"./es-do.js": 973,
	"./es-mx": 974,
	"./es-mx.js": 974,
	"./es-us": 975,
	"./es-us.js": 975,
	"./es.js": 976,
	"./et": 977,
	"./et.js": 977,
	"./eu": 978,
	"./eu.js": 978,
	"./fa": 979,
	"./fa.js": 979,
	"./fi": 980,
	"./fi.js": 980,
	"./fil": 981,
	"./fil.js": 981,
	"./fo": 982,
	"./fo.js": 982,
	"./fr": 985,
	"./fr-ca": 983,
	"./fr-ca.js": 983,
	"./fr-ch": 984,
	"./fr-ch.js": 984,
	"./fr.js": 985,
	"./fy": 986,
	"./fy.js": 986,
	"./ga": 987,
	"./ga.js": 987,
	"./gd": 988,
	"./gd.js": 988,
	"./gl": 989,
	"./gl.js": 989,
	"./gom-deva": 990,
	"./gom-deva.js": 990,
	"./gom-latn": 991,
	"./gom-latn.js": 991,
	"./gu": 992,
	"./gu.js": 992,
	"./he": 993,
	"./he.js": 993,
	"./hi": 994,
	"./hi.js": 994,
	"./hr": 995,
	"./hr.js": 995,
	"./hu": 996,
	"./hu.js": 996,
	"./hy-am": 997,
	"./hy-am.js": 997,
	"./id": 998,
	"./id.js": 998,
	"./is": 999,
	"./is.js": 999,
	"./it": 1001,
	"./it-ch": 1000,
	"./it-ch.js": 1000,
	"./it.js": 1001,
	"./ja": 1002,
	"./ja.js": 1002,
	"./jv": 1003,
	"./jv.js": 1003,
	"./ka": 1004,
	"./ka.js": 1004,
	"./kk": 1005,
	"./kk.js": 1005,
	"./km": 1006,
	"./km.js": 1006,
	"./kn": 1007,
	"./kn.js": 1007,
	"./ko": 1008,
	"./ko.js": 1008,
	"./ku": 1009,
	"./ku.js": 1009,
	"./ky": 1010,
	"./ky.js": 1010,
	"./lb": 1011,
	"./lb.js": 1011,
	"./lo": 1012,
	"./lo.js": 1012,
	"./lt": 1013,
	"./lt.js": 1013,
	"./lv": 1014,
	"./lv.js": 1014,
	"./me": 1015,
	"./me.js": 1015,
	"./mi": 1016,
	"./mi.js": 1016,
	"./mk": 1017,
	"./mk.js": 1017,
	"./ml": 1018,
	"./ml.js": 1018,
	"./mn": 1019,
	"./mn.js": 1019,
	"./mr": 1020,
	"./mr.js": 1020,
	"./ms": 1022,
	"./ms-my": 1021,
	"./ms-my.js": 1021,
	"./ms.js": 1022,
	"./mt": 1023,
	"./mt.js": 1023,
	"./my": 1024,
	"./my.js": 1024,
	"./nb": 1025,
	"./nb.js": 1025,
	"./ne": 1026,
	"./ne.js": 1026,
	"./nl": 1028,
	"./nl-be": 1027,
	"./nl-be.js": 1027,
	"./nl.js": 1028,
	"./nn": 1029,
	"./nn.js": 1029,
	"./oc-lnc": 1030,
	"./oc-lnc.js": 1030,
	"./pa-in": 1031,
	"./pa-in.js": 1031,
	"./pl": 1032,
	"./pl.js": 1032,
	"./pt": 1034,
	"./pt-br": 1033,
	"./pt-br.js": 1033,
	"./pt.js": 1034,
	"./ro": 1035,
	"./ro.js": 1035,
	"./ru": 1036,
	"./ru.js": 1036,
	"./sd": 1037,
	"./sd.js": 1037,
	"./se": 1038,
	"./se.js": 1038,
	"./si": 1039,
	"./si.js": 1039,
	"./sk": 1040,
	"./sk.js": 1040,
	"./sl": 1041,
	"./sl.js": 1041,
	"./sq": 1042,
	"./sq.js": 1042,
	"./sr": 1044,
	"./sr-cyrl": 1043,
	"./sr-cyrl.js": 1043,
	"./sr.js": 1044,
	"./ss": 1045,
	"./ss.js": 1045,
	"./sv": 1046,
	"./sv.js": 1046,
	"./sw": 1047,
	"./sw.js": 1047,
	"./ta": 1048,
	"./ta.js": 1048,
	"./te": 1049,
	"./te.js": 1049,
	"./tet": 1050,
	"./tet.js": 1050,
	"./tg": 1051,
	"./tg.js": 1051,
	"./th": 1052,
	"./th.js": 1052,
	"./tk": 1053,
	"./tk.js": 1053,
	"./tl-ph": 1054,
	"./tl-ph.js": 1054,
	"./tlh": 1055,
	"./tlh.js": 1055,
	"./tr": 1056,
	"./tr.js": 1056,
	"./tzl": 1057,
	"./tzl.js": 1057,
	"./tzm": 1059,
	"./tzm-latn": 1058,
	"./tzm-latn.js": 1058,
	"./tzm.js": 1059,
	"./ug-cn": 1060,
	"./ug-cn.js": 1060,
	"./uk": 1061,
	"./uk.js": 1061,
	"./ur": 1062,
	"./ur.js": 1062,
	"./uz": 1064,
	"./uz-latn": 1063,
	"./uz-latn.js": 1063,
	"./uz.js": 1064,
	"./vi": 1065,
	"./vi.js": 1065,
	"./x-pseudo": 1066,
	"./x-pseudo.js": 1066,
	"./yo": 1067,
	"./yo.js": 1067,
	"./zh-cn": 1068,
	"./zh-cn.js": 1068,
	"./zh-hk": 1069,
	"./zh-hk.js": 1069,
	"./zh-mo": 1070,
	"./zh-mo.js": 1070,
	"./zh-tw": 1071,
	"./zh-tw.js": 1071
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2958;

/***/ }),
/* 2959 */,
/* 2960 */,
/* 2961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(2748);
var invariant = __webpack_require__(2749);

module.exports = function() {
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  function shim() {
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function RavenConfigError(message) {
    this.name = 'RavenConfigError';
    this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),
/* 2963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wrapMethod = function(console, level, callback) {
    var originalConsoleLevel = console[level];
    var originalConsole = console;

    if (!(level in console)) {
        return;
    }

    var sentryLevel = level === 'warn'
        ? 'warning'
        : level;

    console[level] = function () {
        var args = [].slice.call(arguments);

        var msg = '' + args.join(' ');
        var data = {level: sentryLevel, logger: 'console', extra: {'arguments': args}};
        callback && callback(msg, data);

        // this fails for some browsers. :(
        if (originalConsoleLevel) {
            // IE9 doesn't allow calling apply on console functions directly
            // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
            Function.prototype.apply.call(
                originalConsoleLevel,
                originalConsole,
                args
            );
        }
    };
};

module.exports = {
    wrapMethod: wrapMethod
};


/***/ }),
/* 2964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false, __DEV__:false*/


var TraceKit = __webpack_require__(2966);
var stringify = __webpack_require__(2967);
var RavenConfigError = __webpack_require__(2962);
var utils = __webpack_require__(1072);

var isError = utils.isError,
    isObject = utils.isObject;

var wrapConsoleMethod = __webpack_require__(2963).wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
    dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
    return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window
            : typeof global !== 'undefined' ? global
            : typeof self !== 'undefined' ? self
            : {};
var _document = _window.document;
var _navigator = _window.navigator;

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
    this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
    // Raven can run in contexts where there's no document (react-native)
    this._hasDocument = !isUndefined(_document);
    this._hasNavigator = !isUndefined(_navigator);
    this._lastCapturedException = null;
    this._lastData = null;
    this._lastEventId = null;
    this._globalServer = null;
    this._globalKey = null;
    this._globalProject = null;
    this._globalContext = {};
    this._globalOptions = {
        logger: 'javascript',
        ignoreErrors: [],
        ignoreUrls: [],
        whitelistUrls: [],
        includePaths: [],
        crossOrigin: 'anonymous',
        collectWindowErrors: true,
        maxMessageLength: 0,

        // By default, truncates URL values to 250 chars
        maxUrlLength: 250,
        stackTraceLimit: 50,
        autoBreadcrumbs: true,
        instrument: true,
        sampleRate: 1
    };
    this._ignoreOnError = 0;
    this._isRavenInstalled = false;
    this._originalErrorStackTraceLimit = Error.stackTraceLimit;
    // capture references to window.console *and* all its methods first
    // before the console plugin has a chance to monkey patch
    this._originalConsole = _window.console || {};
    this._originalConsoleMethods = {};
    this._plugins = [];
    this._startTime = now();
    this._wrappedBuiltIns = [];
    this._breadcrumbs = [];
    this._lastCapturedEvent = null;
    this._keypressTimeout;
    this._location = _window.location;
    this._lastHref = this._location && this._location.href;
    this._resetBackoff();

    for (var method in this._originalConsole) {  // eslint-disable-line guard-for-in
      this._originalConsoleMethods[method] = this._originalConsole[method];
    }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
    // Hardcode version string so that raven source can be loaded directly via
    // webpack (using a build step causes webpack #1617). Grunt verifies that
    // this value matches package.json during build.
    //   See: https://github.com/getsentry/raven-js/issues/465
    VERSION: '3.15.0',

    debug: false,

    TraceKit: TraceKit, // alias to TraceKit

    /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Optional set of of global options [optional]
     * @return {Raven}
     */
    config: function(dsn, options) {
        var self = this;

        if (self._globalServer) {
                this._logDebug('error', 'Error: Raven has already been configured');
            return self;
        }
        if (!dsn) return self;

        var globalOptions = self._globalOptions;

        // merge in options
        if (options) {
            each(options, function(key, value){
                // tags and extra are special and need to be put into context
                if (key === 'tags' || key === 'extra' || key === 'user') {
                    self._globalContext[key] = value;
                } else {
                    globalOptions[key] = value;
                }
            });
        }

        self.setDSN(dsn);

        // "Script error." is hard coded into browsers for errors that it can't read.
        // this is the result of a script being pulled in from an external domain and CORS.
        globalOptions.ignoreErrors.push(/^Script error\.?$/);
        globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

        // join regexp rules into one big rule
        globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
        globalOptions.ignoreUrls = globalOptions.ignoreUrls.length ? joinRegExp(globalOptions.ignoreUrls) : false;
        globalOptions.whitelistUrls = globalOptions.whitelistUrls.length ? joinRegExp(globalOptions.whitelistUrls) : false;
        globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
        globalOptions.maxBreadcrumbs = Math.max(0, Math.min(globalOptions.maxBreadcrumbs || 100, 100)); // default and hard limit is 100

        var autoBreadcrumbDefaults = {
            xhr: true,
            console: true,
            dom: true,
            location: true
        };

        var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
        if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
            autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
        } else if (autoBreadcrumbs !== false) {
            autoBreadcrumbs = autoBreadcrumbDefaults;
        }
        globalOptions.autoBreadcrumbs = autoBreadcrumbs;

        var instrumentDefaults = {
            tryCatch: true
        };

        var instrument = globalOptions.instrument;
        if ({}.toString.call(instrument) === '[object Object]') {
            instrument = objectMerge(instrumentDefaults, instrument);
        } else if (instrument !== false) {
            instrument = instrumentDefaults;
        }
        globalOptions.instrument = instrument;

        TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

        // return for chaining
        return self;
    },

    /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
    install: function() {
        var self = this;
        if (self.isSetup() && !self._isRavenInstalled) {
            TraceKit.report.subscribe(function () {
                self._handleOnErrorStackInfo.apply(self, arguments);
            });
            if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
              self._instrumentTryCatch();
            }

            if (self._globalOptions.autoBreadcrumbs)
                self._instrumentBreadcrumbs();

            // Install all of the plugins
            self._drainPlugins();

            self._isRavenInstalled = true;
        }

        Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
        return this;
    },

    /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
    setDSN: function(dsn) {
        var self = this,
            uri = self._parseDSN(dsn),
          lastSlash = uri.path.lastIndexOf('/'),
          path = uri.path.substr(1, lastSlash);

        self._dsn = dsn;
        self._globalKey = uri.user;
        self._globalSecret = uri.pass && uri.pass.substr(1);
        self._globalProject = uri.path.substr(lastSlash + 1);

        self._globalServer = self._getGlobalServer(uri);

        self._globalEndpoint = self._globalServer +
            '/' + path + 'api/' + self._globalProject + '/store/';

        // Reset backoff state since we may be pointing at a
        // new project/server
        this._resetBackoff();
    },

    /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
    context: function(options, func, args) {
        if (isFunction(options)) {
            args = func || [];
            func = options;
            options = undefined;
        }

        return this.wrap(options, func).apply(this, args);
    },

    /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} func A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
    wrap: function(options, func, _before) {
        var self = this;
        // 1 argument has been passed, and it's not a function
        // so just return it
        if (isUndefined(func) && !isFunction(options)) {
            return options;
        }

        // options is optional
        if (isFunction(options)) {
            func = options;
            options = undefined;
        }

        // At this point, we've passed along 2 arguments, and the second one
        // is not a function either, so we'll just return the second argument.
        if (!isFunction(func)) {
            return func;
        }

        // We don't wanna wrap it twice!
        try {
            if (func.__raven__) {
                return func;
            }

            // If this has already been wrapped in the past, return that
            if (func.__raven_wrapper__ ){
                return func.__raven_wrapper__ ;
            }
        } catch (e) {
            // Just accessing custom props in some Selenium environments
            // can cause a "Permission denied" exception (see raven-js#495).
            // Bail on wrapping and return the function as-is (defers to window.onerror).
            return func;
        }

        function wrapped() {
            var args = [], i = arguments.length,
                deep = !options || options && options.deep !== false;

            if (_before && isFunction(_before)) {
                _before.apply(this, arguments);
            }

            // Recursively wrap all of a function's arguments that are
            // functions themselves.
            while(i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

            try {
                // Attempt to invoke user-land function
                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
                //       means Raven caught an error invoking your application code. This is
                //       expected behavior and NOT indicative of a bug with Raven.js.
                return func.apply(this, args);
            } catch(e) {
                self._ignoreNextOnError();
                self.captureException(e, options);
                throw e;
            }
        }

        // copy over properties of the old function
        for (var property in func) {
            if (hasKey(func, property)) {
                wrapped[property] = func[property];
            }
        }
        wrapped.prototype = func.prototype;

        func.__raven_wrapper__ = wrapped;
        // Signal that this function has been wrapped already
        // for both debugging and to prevent it to being wrapped twice
        wrapped.__raven__ = true;
        wrapped.__inner__ = func;

        return wrapped;
    },

    /*
     * Uninstalls the global error handler.
     *
     * @return {Raven}
     */
    uninstall: function() {
        TraceKit.report.uninstall();

        this._restoreBuiltIns();

        Error.stackTraceLimit = this._originalErrorStackTraceLimit;
        this._isRavenInstalled = false;

        return this;
    },

    /*
     * Manually capture an exception and send it over to Sentry
     *
     * @param {error} ex An exception to be logged
     * @param {object} options A specific set of options for this error [optional]
     * @return {Raven}
     */
    captureException: function(ex, options) {
        // If not an Error is passed through, recall as a message instead
        if (!isError(ex)) {
            return this.captureMessage(ex, objectMerge({
                trimHeadFrames: 1,
                stacktrace: true // if we fall back to captureMessage, default to attempting a new trace
            }, options));
        }

        // Store the raw exception object for potential debugging and introspection
        this._lastCapturedException = ex;

        // TraceKit.report will re-raise any exception passed to it,
        // which means you have to wrap it in try/catch. Instead, we
        // can wrap it here and only re-raise if TraceKit.report
        // raises an exception different from the one we asked to
        // report on.
        try {
            var stack = TraceKit.computeStackTrace(ex);
            this._handleStackInfo(stack, options);
        } catch(ex1) {
            if(ex !== ex1) {
                throw ex1;
            }
        }

        return this;
    },

    /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
    captureMessage: function(msg, options) {
        // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
        // early call; we'll error on the side of logging anything called before configuration since it's
        // probably something you should see:
        if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(msg)) {
            return;
        }

        options = options || {};

        var data = objectMerge({
            message: msg + ''  // Make sure it's actually a string
        }, options);

        if (this._globalOptions.stacktrace || (options && options.stacktrace)) {
            var ex;
            // Generate a "synthetic" stack trace from this point.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
            //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
            //       or if it catches a thrown object without a "stack" property.
            try {
                throw new Error(msg);
            } catch (ex1) {
                ex = ex1;
            }

            // null exception name so `Error` isn't prefixed to msg
            ex.name = null;

            options = objectMerge({
                // fingerprint on msg, not stack trace (legacy behavior, could be
                // revisited)
                fingerprint: msg,
                // since we know this is a synthetic trace, the top N-most frames
                // MUST be from Raven.js, so mark them as in_app later by setting
                // trimHeadFrames
                trimHeadFrames: (options.trimHeadFrames || 0) + 1
            }, options);

            var stack = TraceKit.computeStackTrace(ex);
            var frames = this._prepareFrames(stack, options);
            data.stacktrace = {
                // Sentry expects frames oldest to newest
                frames: frames.reverse()
            }
        }

        // Fire away!
        this._send(data);

        return this;
    },

    captureBreadcrumb: function (obj) {
        var crumb = objectMerge({
            timestamp: now() / 1000
        }, obj);

        if (isFunction(this._globalOptions.breadcrumbCallback)) {
            var result = this._globalOptions.breadcrumbCallback(crumb);

            if (isObject(result) && !isEmptyObject(result)) {
                crumb = result;
            } else if (result === false) {
                return this;
            }
        }

        this._breadcrumbs.push(crumb);
        if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
            this._breadcrumbs.shift();
        }
        return this;
    },

    addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
        var pluginArgs = [].slice.call(arguments, 1);

        this._plugins.push([plugin, pluginArgs]);
        if (this._isRavenInstalled) {
            this._drainPlugins();
        }

        return this;
    },

    /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
    setUserContext: function(user) {
        // Intentionally do not merge here since that's an unexpected behavior.
        this._globalContext.user = user;

        return this;
    },

    /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
    setExtraContext: function(extra) {
        this._mergeContext('extra', extra);

        return this;
    },

    /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
    setTagsContext: function(tags) {
        this._mergeContext('tags', tags);

        return this;
    },

    /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
    clearContext: function() {
        this._globalContext = {};

        return this;
    },

    /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
    getContext: function() {
        // lol javascript
        return JSON.parse(stringify(this._globalContext));
    },


    /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
    setEnvironment: function(environment) {
        this._globalOptions.environment = environment;

        return this;
    },

    /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
    setRelease: function(release) {
        this._globalOptions.release = release;

        return this;
    },

    /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
    setDataCallback: function(callback) {
        var original = this._globalOptions.dataCallback;
        this._globalOptions.dataCallback = isFunction(callback)
          ? function (data) { return callback(data, original); }
          : callback;

        return this;
    },

    /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
    setBreadcrumbCallback: function(callback) {
        var original = this._globalOptions.breadcrumbCallback;
        this._globalOptions.breadcrumbCallback = isFunction(callback)
          ? function (data) { return callback(data, original); }
          : callback;

        return this;
    },

    /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
    setShouldSendCallback: function(callback) {
        var original = this._globalOptions.shouldSendCallback;
        this._globalOptions.shouldSendCallback = isFunction(callback)
            ? function (data) { return callback(data, original); }
            : callback;

        return this;
    },

    /**
     * Override the default HTTP transport mechanism that transmits data
     * to the Sentry server.
     *
     * @param {function} transport Function invoked instead of the default
     *                             `makeRequest` handler.
     *
     * @return {Raven}
     */
    setTransport: function(transport) {
        this._globalOptions.transport = transport;

        return this;
    },

    /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
    lastException: function() {
        return this._lastCapturedException;
    },

    /*
     * Get the last event id
     *
     * @return {string}
     */
    lastEventId: function() {
        return this._lastEventId;
    },

    /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
    isSetup: function() {
        if (!this._hasJSON) return false;  // needs JSON support
        if (!this._globalServer) {
            if (!this.ravenNotConfiguredError) {
              this.ravenNotConfiguredError = true;
              this._logDebug('error', 'Error: Raven has not been configured.');
            }
            return false;
        }
        return true;
    },

    afterLoad: function () {
        // TODO: remove window dependence?

        // Attempt to initialize Raven on load
        var RavenConfig = _window.RavenConfig;
        if (RavenConfig) {
            this.config(RavenConfig.dsn, RavenConfig.config).install();
        }
    },

    showReportDialog: function (options) {
        if (!_document) // doesn't work without a document (React native)
            return;

        options = options || {};

        var lastEventId = options.eventId || this.lastEventId();
        if (!lastEventId) {
            throw new RavenConfigError('Missing eventId');
        }

        var dsn = options.dsn || this._dsn;
        if (!dsn) {
            throw new RavenConfigError('Missing DSN');
        }

        var encode = encodeURIComponent;
        var qs = '';
        qs += '?eventId=' + encode(lastEventId);
        qs += '&dsn=' + encode(dsn);

        var user = options.user || this._globalContext.user;
        if (user) {
            if (user.name)  qs += '&name=' + encode(user.name);
            if (user.email) qs += '&email=' + encode(user.email);
        }

        var globalServer = this._getGlobalServer(this._parseDSN(dsn));

        var script = _document.createElement('script');
        script.async = true;
        script.src = globalServer + '/api/embed/error-page/' + qs;
        (_document.head || _document.body).appendChild(script);
    },

    /**** Private functions ****/
    _ignoreNextOnError: function () {
        var self = this;
        this._ignoreOnError += 1;
        setTimeout(function () {
            // onerror should trigger before setTimeout
            self._ignoreOnError -= 1;
        });
    },

    _triggerEvent: function(eventType, options) {
        // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
        var evt, key;

        if (!this._hasDocument)
            return;

        options = options || {};

        eventType = 'raven' + eventType.substr(0,1).toUpperCase() + eventType.substr(1);

        if (_document.createEvent) {
            evt = _document.createEvent('HTMLEvents');
            evt.initEvent(eventType, true, true);
        } else {
            evt = _document.createEventObject();
            evt.eventType = eventType;
        }

        for (key in options) if (hasKey(options, key)) {
            evt[key] = options[key];
        }

        if (_document.createEvent) {
            // IE9 if standards
            _document.dispatchEvent(evt);
        } else {
            // IE8 regardless of Quirks or Standards
            // IE9 if quirks
            try {
                _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
            } catch(e) {
                // Do nothing
            }
        }
    },

    /**
     * Wraps addEventListener to capture UI breadcrumbs
     * @param evtName the event name (e.g. "click")
     * @returns {Function}
     * @private
     */
    _breadcrumbEventHandler: function(evtName) {
        var self = this;
        return function (evt) {
            // reset keypress timeout; e.g. triggering a 'click' after
            // a 'keypress' will reset the keypress debounce so that a new
            // set of keypresses can be recorded
            self._keypressTimeout = null;

            // It's possible this handler might trigger multiple times for the same
            // event (e.g. event propagation through node ancestors). Ignore if we've
            // already captured the event.
            if (self._lastCapturedEvent === evt)
                return;

            self._lastCapturedEvent = evt;

            // try/catch both:
            // - accessing evt.target (see getsentry/raven-js#838, #768)
            // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
            //   can throw an exception in some circumstances.
            var target;
            try {
                target = htmlTreeAsString(evt.target);
            } catch (e) {
                target = '<unknown>';
            }

            self.captureBreadcrumb({
                category: 'ui.' + evtName, // e.g. ui.click, ui.input
                message: target
            });
        };
    },

    /**
     * Wraps addEventListener to capture keypress UI events
     * @returns {Function}
     * @private
     */
    _keypressEventHandler: function() {
        var self = this,
            debounceDuration = 1000; // milliseconds

        // TODO: if somehow user switches keypress target before
        //       debounce timeout is triggered, we will only capture
        //       a single breadcrumb from the FIRST target (acceptable?)
        return function (evt) {
            var target;
            try {
                target = evt.target;
            } catch (e) {
                // just accessing event properties can throw an exception in some rare circumstances
                // see: https://github.com/getsentry/raven-js/issues/838
                return;
            }
            var tagName = target && target.tagName;

            // only consider keypress events on actual input elements
            // this will disregard keypresses targeting body (e.g. tabbing
            // through elements, hotkeys, etc)
            if (!tagName || tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
                return;

            // record first keypress in a series, but ignore subsequent
            // keypresses until debounce clears
            var timeout = self._keypressTimeout;
            if (!timeout) {
                self._breadcrumbEventHandler('input')(evt);
            }
            clearTimeout(timeout);
            self._keypressTimeout = setTimeout(function () {
                self._keypressTimeout = null;
            }, debounceDuration);
        };
    },

    /**
     * Captures a breadcrumb of type "navigation", normalizing input URLs
     * @param to the originating URL
     * @param from the target URL
     * @private
     */
    _captureUrlChange: function(from, to) {
        var parsedLoc = parseUrl(this._location.href);
        var parsedTo = parseUrl(to);
        var parsedFrom = parseUrl(from);

        // because onpopstate only tells you the "new" (to) value of location.href, and
        // not the previous (from) value, we need to track the value of the current URL
        // state ourselves
        this._lastHref = to;

        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
            to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
            from = parsedFrom.relative;

        this.captureBreadcrumb({
            category: 'navigation',
            data: {
                to: to,
                from: from
            }
        });
    },

    /**
     * Wrap timer functions and event targets to catch errors and provide
     * better metadata.
     */
    _instrumentTryCatch: function() {
        var self = this;

        var wrappedBuiltIns = self._wrappedBuiltIns;

        function wrapTimeFn(orig) {
            return function (fn, t) { // preserve arity
                // Make a copy of the arguments to prevent deoptimization
                // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
                var args = new Array(arguments.length);
                for(var i = 0; i < args.length; ++i) {
                    args[i] = arguments[i];
                }
                var originalCallback = args[0];
                if (isFunction(originalCallback)) {
                    args[0] = self.wrap(originalCallback);
                }

                // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
                // also supports only two arguments and doesn't care what this is, so we
                // can just call the original function directly.
                if (orig.apply) {
                    return orig.apply(this, args);
                } else {
                    return orig(args[0], args[1]);
                }
            };
        }

        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

        function wrapEventTarget(global) {
            var proto = _window[global] && _window[global].prototype;
            if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
                fill(proto, 'addEventListener', function(orig) {
                    return function (evtName, fn, capture, secure) { // preserve arity
                        try {
                            if (fn && fn.handleEvent) {
                                fn.handleEvent = self.wrap(fn.handleEvent);
                            }
                        } catch (err) {
                            // can sometimes get 'Permission denied to access property "handle Event'
                        }

                        // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
                        // so that we don't have more than one wrapper function
                        var before,
                            clickHandler,
                            keypressHandler;

                        if (autoBreadcrumbs && autoBreadcrumbs.dom && (global === 'EventTarget' || global === 'Node')) {
                            // NOTE: generating multiple handlers per addEventListener invocation, should
                            //       revisit and verify we can just use one (almost certainly)
                            clickHandler = self._breadcrumbEventHandler('click');
                            keypressHandler = self._keypressEventHandler();
                            before = function (evt) {
                                // need to intercept every DOM event in `before` argument, in case that
                                // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                                // see #724
                                if (!evt) return;

                                var eventType;
                                try {
                                    eventType = evt.type
                                } catch (e) {
                                    // just accessing event properties can throw an exception in some rare circumstances
                                    // see: https://github.com/getsentry/raven-js/issues/838
                                    return;
                                }
                                if (eventType === 'click')
                                    return clickHandler(evt);
                                else if (eventType === 'keypress')
                                    return keypressHandler(evt);
                            };
                        }
                        return orig.call(this, evtName, self.wrap(fn, undefined, before), capture, secure);
                    };
                }, wrappedBuiltIns);
                fill(proto, 'removeEventListener', function (orig) {
                    return function (evt, fn, capture, secure) {
                        try {
                            fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__  : fn);
                        } catch (e) {
                            // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
                        }
                        return orig.call(this, evt, fn, capture, secure);
                    };
                }, wrappedBuiltIns);
            }
        }

        fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
        fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
        if (_window.requestAnimationFrame) {
            fill(_window, 'requestAnimationFrame', function (orig) {
                return function (cb) {
                    return orig(self.wrap(cb));
                };
            }, wrappedBuiltIns);
        }

        // event targets borrowed from bugsnag-js:
        // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
        var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
        for (var i = 0; i < eventTargets.length; i++) {
            wrapEventTarget(eventTargets[i]);
        }
    },


    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - XMLHttpRequests
     *  - DOM interactions (click/typing)
     *  - window.location changes
     *  - console
     *
     * Can be disabled or individually configured via the `autoBreadcrumbs` config option
     */
    _instrumentBreadcrumbs: function () {
        var self = this;
        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

        var wrappedBuiltIns = self._wrappedBuiltIns;

        function wrapProp(prop, xhr) {
            if (prop in xhr && isFunction(xhr[prop])) {
                fill(xhr, prop, function (orig) {
                    return self.wrap(orig);
                }); // intentionally don't track filled methods on XHR instances
            }
        }

        if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
            var xhrproto = XMLHttpRequest.prototype;
            fill(xhrproto, 'open', function(origOpen) {
                return function (method, url) { // preserve arity

                    // if Sentry key appears in URL, don't capture
                    if (isString(url) && url.indexOf(self._globalKey) === -1) {
                        this.__raven_xhr = {
                            method: method,
                            url: url,
                            status_code: null
                        };
                    }

                    return origOpen.apply(this, arguments);
                };
            }, wrappedBuiltIns);

            fill(xhrproto, 'send', function(origSend) {
                return function (data) { // preserve arity
                    var xhr = this;

                    function onreadystatechangeHandler() {
                        if (xhr.__raven_xhr && (xhr.readyState === 1 || xhr.readyState === 4)) {
                            try {
                                // touching statusCode in some platforms throws
                                // an exception
                                xhr.__raven_xhr.status_code = xhr.status;
                            } catch (e) { /* do nothing */ }
                            self.captureBreadcrumb({
                                type: 'http',
                                category: 'xhr',
                                data: xhr.__raven_xhr
                            });
                        }
                    }

                    var props = ['onload', 'onerror', 'onprogress'];
                    for (var j = 0; j < props.length; j++) {
                        wrapProp(props[j], xhr);
                    }

                    if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
                        fill(xhr, 'onreadystatechange', function (orig) {
                            return self.wrap(orig, undefined, onreadystatechangeHandler);
                        } /* intentionally don't track this instrumentation */);
                    } else {
                        // if onreadystatechange wasn't actually set by the page on this xhr, we
                        // are free to set our own and capture the breadcrumb
                        xhr.onreadystatechange = onreadystatechangeHandler;
                    }

                    return origSend.apply(this, arguments);
                };
            }, wrappedBuiltIns);
        }

        if (autoBreadcrumbs.xhr && 'fetch' in _window) {
            fill(_window, 'fetch', function(origFetch) {
                return function (fn, t) { // preserve arity
                    // Make a copy of the arguments to prevent deoptimization
                    // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
                    var args = new Array(arguments.length);
                    for (var i = 0; i < args.length; ++i) {
                        args[i] = arguments[i];
                    }

                    var fetchInput = args[0];
                    var method = 'GET';
                    var url;

                    if (typeof fetchInput === 'string') {
                        url = fetchInput;
                    } else {
                        url = fetchInput.url;
                        if (fetchInput.method) {
                            method = fetchInput.method;
                        }
                    }

                    if (args[1] && args[1].method) {
                        method = args[1].method;
                    }

                    var fetchData = {
                        method: method,
                        url: url,
                        status_code: null
                    };

                    self.captureBreadcrumb({
                        type: 'http',
                        category: 'fetch',
                        data: fetchData
                    });

                    return origFetch.apply(this, args).then(function (response) {
                        fetchData.status_code = response.status;

                        return response;
                    });
                };
            }, wrappedBuiltIns);
        }

        // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
        // to the document. Do this before we instrument addEventListener.
        if (autoBreadcrumbs.dom && this._hasDocument) {
            if (_document.addEventListener) {
                _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
                _document.addEventListener('keypress', self._keypressEventHandler(), false);
            }
            else {
                // IE8 Compatibility
                _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
                _document.attachEvent('onkeypress', self._keypressEventHandler());
            }
        }

        // record navigation (URL) changes
        // NOTE: in Chrome App environment, touching history.pushState, *even inside
        //       a try/catch block*, will cause Chrome to output an error to console.error
        // borrowed from: https://github.com/angular/angular.js/pull/13945/files
        var chrome = _window.chrome;
        var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
        var hasPushState = !isChromePackagedApp && _window.history && history.pushState;
        if (autoBreadcrumbs.location && hasPushState) {
            // TODO: remove onpopstate handler on uninstall()
            var oldOnPopState = _window.onpopstate;
            _window.onpopstate = function () {
                var currentHref = self._location.href;
                self._captureUrlChange(self._lastHref, currentHref);

                if (oldOnPopState) {
                    return oldOnPopState.apply(this, arguments);
                }
            };

            fill(history, 'pushState', function (origPushState) {
                // note history.pushState.length is 0; intentionally not declaring
                // params to preserve 0 arity
                return function (/* state, title, url */) {
                    var url = arguments.length > 2 ? arguments[2] : undefined;

                    // url argument is optional
                    if (url) {
                        // coerce to string (this is what pushState does)
                        self._captureUrlChange(self._lastHref, url + '');
                    }

                    return origPushState.apply(this, arguments);
                };
            }, wrappedBuiltIns);
        }

        if (autoBreadcrumbs.console && 'console' in _window && console.log) {
            // console
            var consoleMethodCallback = function (msg, data) {
                self.captureBreadcrumb({
                    message: msg,
                    level: data.level,
                    category: 'console'
                });
            };

            each(['debug', 'info', 'warn', 'error', 'log'], function (_, level) {
                wrapConsoleMethod(console, level, consoleMethodCallback);
            });
        }

    },

    _restoreBuiltIns: function () {
        // restore any wrapped builtins
        var builtin;
        while (this._wrappedBuiltIns.length) {
            builtin = this._wrappedBuiltIns.shift();

            var obj = builtin[0],
              name = builtin[1],
              orig = builtin[2];

            obj[name] = orig;
        }
    },

    _drainPlugins: function() {
        var self = this;

        // FIX ME TODO
        each(this._plugins, function(_, plugin) {
            var installer = plugin[0];
            var args = plugin[1];
            installer.apply(self, [self].concat(args));
        });
    },

    _parseDSN: function(str) {
        var m = dsnPattern.exec(str),
            dsn = {},
            i = 7;

        try {
            while (i--) dsn[dsnKeys[i]] = m[i] || '';
        } catch(e) {
            throw new RavenConfigError('Invalid DSN: ' + str);
        }

        if (dsn.pass && !this._globalOptions.allowSecretKey) {
            throw new RavenConfigError('Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key');
        }

        return dsn;
    },

    _getGlobalServer: function(uri) {
        // assemble the endpoint from the uri pieces
        var globalServer = '//' + uri.host +
            (uri.port ? ':' + uri.port : '');

        if (uri.protocol) {
            globalServer = uri.protocol + ':' + globalServer;
        }
        return globalServer;
    },

    _handleOnErrorStackInfo: function() {
        // if we are intentionally ignoring errors via onerror, bail out
        if (!this._ignoreOnError) {
            this._handleStackInfo.apply(this, arguments);
        }
    },

    _handleStackInfo: function(stackInfo, options) {
        var frames = this._prepareFrames(stackInfo, options);

        this._triggerEvent('handle', {
            stackInfo: stackInfo,
            options: options
        });

        this._processException(
            stackInfo.name,
            stackInfo.message,
            stackInfo.url,
            stackInfo.lineno,
            frames,
            options
        );
    },

    _prepareFrames: function(stackInfo, options) {
        var self = this;
        var frames = [];
        if (stackInfo.stack && stackInfo.stack.length) {
            each(stackInfo.stack, function(i, stack) {
                var frame = self._normalizeFrame(stack);
                if (frame) {
                    frames.push(frame);
                }
            });

            // e.g. frames captured via captureMessage throw
            if (options && options.trimHeadFrames) {
                for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
                    frames[j].in_app = false;
                }
            }
        }
        frames = frames.slice(0, this._globalOptions.stackTraceLimit);
        return frames;
    },


    _normalizeFrame: function(frame) {
        if (!frame.url) return;

        // normalize the frames data
        var normalized = {
            filename:   frame.url,
            lineno:     frame.line,
            colno:      frame.column,
            'function': frame.func || '?'
        };

        normalized.in_app = !( // determine if an exception came from outside of our app
            // first we check the global includePaths list.
            !!this._globalOptions.includePaths.test && !this._globalOptions.includePaths.test(normalized.filename) ||
            // Now we check for fun, if the function name is Raven or TraceKit
            /(Raven|TraceKit)\./.test(normalized['function']) ||
            // finally, we do a last ditch effort and check for raven.min.js
            /raven\.(min\.)?js$/.test(normalized.filename)
        );

        return normalized;
    },

    _processException: function(type, message, fileurl, lineno, frames, options) {
        var stacktrace;
        if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(message)) return;

        message += '';

        if (frames && frames.length) {
            fileurl = frames[0].filename || fileurl;
            // Sentry expects frames oldest to newest
            // and JS sends them as newest to oldest
            frames.reverse();
            stacktrace = {frames: frames};
        } else if (fileurl) {
            stacktrace = {
                frames: [{
                    filename: fileurl,
                    lineno: lineno,
                    in_app: true
                }]
            };
        }

        if (!!this._globalOptions.ignoreUrls.test && this._globalOptions.ignoreUrls.test(fileurl)) return;
        if (!!this._globalOptions.whitelistUrls.test && !this._globalOptions.whitelistUrls.test(fileurl)) return;

        var data = objectMerge({
            // sentry.interfaces.Exception
            exception: {
                values: [{
                    type: type,
                    value: message,
                    stacktrace: stacktrace
                }]
            },
            culprit: fileurl
        }, options);

        // Fire away!
        this._send(data);
    },

    _trimPacket: function(data) {
        // For now, we only want to truncate the two different messages
        // but this could/should be expanded to just trim everything
        var max = this._globalOptions.maxMessageLength;
        if (data.message) {
            data.message = truncate(data.message, max);
        }
        if (data.exception) {
            var exception = data.exception.values[0];
            exception.value = truncate(exception.value, max);
        }

        var request = data.request;
        if (request) {
            if (request.url) {
                request.url = truncate(request.url, this._globalOptions.maxUrlLength);
            }
            if (request.Referer) {
                request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
            }
        }

        if (data.breadcrumbs && data.breadcrumbs.values)
            this._trimBreadcrumbs(data.breadcrumbs);

        return data;
    },

    /**
     * Truncate breadcrumb values (right now just URLs)
     */
    _trimBreadcrumbs: function (breadcrumbs) {
        // known breadcrumb properties with urls
        // TODO: also consider arbitrary prop values that start with (https?)?://
        var urlProps = ['to', 'from', 'url'],
            urlProp,
            crumb,
            data;

        for (var i = 0; i < breadcrumbs.values.length; ++i) {
            crumb = breadcrumbs.values[i];
            if (!crumb.hasOwnProperty('data') || !isObject(crumb.data))
                continue;

            data = crumb.data;
            for (var j = 0; j < urlProps.length; ++j) {
                urlProp = urlProps[j];
                if (data.hasOwnProperty(urlProp)) {
                    data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
                }
            }
        }
    },

    _getHttpData: function() {
        if (!this._hasNavigator && !this._hasDocument) return;
        var httpData = {};

        if (this._hasNavigator && _navigator.userAgent) {
            httpData.headers = {
              'User-Agent': navigator.userAgent
            };
        }

        if (this._hasDocument) {
            if (_document.location && _document.location.href) {
                httpData.url = _document.location.href;
            }
            if (_document.referrer) {
                if (!httpData.headers) httpData.headers = {};
                httpData.headers.Referer = _document.referrer;
            }
        }

        return httpData;
    },

    _resetBackoff: function() {
        this._backoffDuration = 0;
        this._backoffStart = null;
    },

    _shouldBackoff: function() {
        return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
    },

    /**
     * Returns true if the in-process data payload matches the signature
     * of the previously-sent data
     *
     * NOTE: This has to be done at this level because TraceKit can generate
     *       data from window.onerror WITHOUT an exception object (IE8, IE9,
     *       other old browsers). This can take the form of an "exception"
     *       data object with a single frame (derived from the onerror args).
     */
    _isRepeatData: function (current) {
        var last = this._lastData;

        if (!last ||
            current.message !== last.message || // defined for captureMessage
            current.culprit !== last.culprit)   // defined for captureException/onerror
            return false;

        // Stacktrace interface (i.e. from captureMessage)
        if (current.stacktrace || last.stacktrace) {
            return isSameStacktrace(current.stacktrace, last.stacktrace);
        }
        // Exception interface (i.e. from captureException/onerror)
        else if (current.exception || last.exception) {
            return isSameException(current.exception, last.exception);
        }

        return true;
    },

    _setBackoffState: function(request) {
        // If we are already in a backoff state, don't change anything
        if (this._shouldBackoff()) {
            return;
        }

        var status = request.status;

        // 400 - project_id doesn't exist or some other fatal
        // 401 - invalid/revoked dsn
        // 429 - too many requests
        if (!(status === 400 || status === 401 || status === 429))
            return;

        var retry;
        try {
            // If Retry-After is not in Access-Control-Expose-Headers, most
            // browsers will throw an exception trying to access it
            retry = request.getResponseHeader('Retry-After');
            retry = parseInt(retry, 10) * 1000; // Retry-After is returned in seconds
        } catch (e) {
            /* eslint no-empty:0 */
        }


        this._backoffDuration = retry
            // If Sentry server returned a Retry-After value, use it
            ? retry
            // Otherwise, double the last backoff duration (starts at 1 sec)
            : this._backoffDuration * 2 || 1000;

        this._backoffStart = now();
    },

    _send: function(data) {
        var globalOptions = this._globalOptions;

        var baseData = {
            project: this._globalProject,
            logger: globalOptions.logger,
            platform: 'javascript'
        }, httpData = this._getHttpData();

        if (httpData) {
            baseData.request = httpData;
        }

        // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
        if (data.trimHeadFrames) delete data.trimHeadFrames;

        data = objectMerge(baseData, data);

        // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
        data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
        data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

        // Send along our own collected metadata with extra
        data.extra['session:duration'] = now() - this._startTime;

        if (this._breadcrumbs && this._breadcrumbs.length > 0) {
            // intentionally make shallow copy so that additions
            // to breadcrumbs aren't accidentally sent in this request
            data.breadcrumbs = {
                values: [].slice.call(this._breadcrumbs, 0)
            };
        }

        // If there are no tags/extra, strip the key from the payload alltogther.
        if (isEmptyObject(data.tags)) delete data.tags;

        if (this._globalContext.user) {
            // sentry.interfaces.User
            data.user = this._globalContext.user;
        }

        // Include the environment if it's defined in globalOptions
        if (globalOptions.environment) data.environment = globalOptions.environment;

        // Include the release if it's defined in globalOptions
        if (globalOptions.release) data.release = globalOptions.release;

        // Include server_name if it's defined in globalOptions
        if (globalOptions.serverName) data.server_name = globalOptions.serverName;

        if (isFunction(globalOptions.dataCallback)) {
            data = globalOptions.dataCallback(data) || data;
        }

        // Why??????????
        if (!data || isEmptyObject(data)) {
            return;
        }

        // Check if the request should be filtered or not
        if (isFunction(globalOptions.shouldSendCallback) && !globalOptions.shouldSendCallback(data)) {
            return;
        }

        // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
        // so drop requests until "cool-off" period has elapsed.
        if (this._shouldBackoff()) {
            this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
            return;
        }

        if (typeof globalOptions.sampleRate === 'number') {
            if (Math.random() < globalOptions.sampleRate) {
                this._sendProcessedPayload(data);
            }
        } else {
            this._sendProcessedPayload(data);
        }
    },

    _getUuid: function () {
      return uuid4();
    },

    _sendProcessedPayload: function(data, callback) {
        var self = this;
        var globalOptions = this._globalOptions;

        if (!this.isSetup()) return;

        // Send along an event_id if not explicitly passed.
        // This event_id can be used to reference the error within Sentry itself.
        // Set lastEventId after we know the error should actually be sent
        this._lastEventId = data.event_id || (data.event_id = this._getUuid());

        // Try and clean up the packet before sending by truncating long values
        data = this._trimPacket(data);

        // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
        // but this would require copying an un-truncated copy of the data packet, which can be
        // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
        if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
            this._logDebug('warn', 'Raven dropped repeat event: ', data);
            return;
        }

        // Store outbound payload after trim
        this._lastData = data;

        this._logDebug('debug', 'Raven about to send:', data);

        var auth = {
            sentry_version: '7',
            sentry_client: 'raven-js/' + this.VERSION,
            sentry_key: this._globalKey
        };
        if (this._globalSecret) {
            auth.sentry_secret = this._globalSecret;
        }

        var exception = data.exception && data.exception.values[0];
        this.captureBreadcrumb({
            category: 'sentry',
            message: exception
                ? (exception.type ? exception.type + ': ' : '') + exception.value
                : data.message,
            event_id: data.event_id,
            level: data.level || 'error' // presume error unless specified
        });

        var url = this._globalEndpoint;
        (globalOptions.transport || this._makeRequest).call(this, {
            url: url,
            auth: auth,
            data: data,
            options: globalOptions,
            onSuccess: function success() {
                self._resetBackoff();

                self._triggerEvent('success', {
                    data: data,
                    src: url
                });
                callback && callback();
            },
            onError: function failure(error) {
                self._logDebug('error', 'Raven transport failed to send: ', error);

                if (error.request) {
                    self._setBackoffState(error.request);
                }

                self._triggerEvent('failure', {
                    data: data,
                    src: url
                });
                error = error || new Error('Raven send failed (no additional details provided)');
                callback && callback(error);
            }
        });
    },

    _makeRequest: function(opts) {
        var request = new XMLHttpRequest();

        // if browser doesn't support CORS (e.g. IE7), we are out of luck
        var hasCORS =
            'withCredentials' in request ||
            typeof XDomainRequest !== 'undefined';

        if (!hasCORS) return;

        var url = opts.url;

        if ('withCredentials' in request) {
            request.onreadystatechange = function () {
                if (request.readyState !== 4) {
                    return;
                } else if (request.status === 200) {
                    opts.onSuccess && opts.onSuccess();
                } else if (opts.onError) {
                    var err = new Error('Sentry error code: ' + request.status);
                    err.request = request;
                    opts.onError(err);
                }
            };
        } else {
            request = new XDomainRequest();
            // xdomainrequest cannot go http -> https (or vice versa),
            // so always use protocol relative
            url = url.replace(/^https?:/, '');

            // onreadystatechange not supported by XDomainRequest
            if (opts.onSuccess) {
                request.onload = opts.onSuccess;
            }
            if (opts.onError) {
                request.onerror = function () {
                    var err = new Error('Sentry error code: XDomainRequest');
                    err.request = request;
                    opts.onError(err);
                }
            }
        }

        // NOTE: auth is intentionally sent as part of query string (NOT as custom
        //       HTTP header) so as to avoid preflight CORS requests
        request.open('POST', url + '?' + urlencode(opts.auth));
        request.send(stringify(opts.data));
    },

    _logDebug: function(level) {
        if (this._originalConsoleMethods[level] && this.debug) {
            // In IE<10 console methods do not have their own 'apply' method
            Function.prototype.apply.call(
                this._originalConsoleMethods[level],
                this._originalConsole,
                [].slice.call(arguments, 1)
            );
        }
    },

    _mergeContext: function(key, context) {
        if (isUndefined(context)) {
            delete this._globalContext[key];
        } else {
            this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
        }
    }
};

/*------------------------------------------------
 * utils
 *
 * conditionally exported for test via Raven.utils
 =================================================
 */
var objectPrototype = Object.prototype;

function isUndefined(what) {
    return what === void 0;
}

function isFunction(what) {
    return typeof what === 'function';
}

function isString(what) {
    return objectPrototype.toString.call(what) === '[object String]';
}


function isEmptyObject(what) {
    for (var _ in what) return false;  // eslint-disable-line guard-for-in, no-unused-vars
    return true;
}

function each(obj, callback) {
    var i, j;

    if (isUndefined(obj.length)) {
        for (i in obj) {
            if (hasKey(obj, i)) {
                callback.call(null, i, obj[i]);
            }
        }
    } else {
        j = obj.length;
        if (j) {
            for (i = 0; i < j; i++) {
                callback.call(null, i, obj[i]);
            }
        }
    }
}

function objectMerge(obj1, obj2) {
    if (!obj2) {
        return obj1;
    }
    each(obj2, function(key, value){
        obj1[key] = value;
    });
    return obj1;
}

function truncate(str, max) {
    return !max || str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
    return objectPrototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
    // Combine an array of regular expressions and strings into one large regexp
    // Be mad.
    var sources = [],
        i = 0, len = patterns.length,
        pattern;

    for (; i < len; i++) {
        pattern = patterns[i];
        if (isString(pattern)) {
            // If it's a string, we need to escape it
            // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
            sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
        } else if (pattern && pattern.source) {
            // If it's a regexp already, we want to extract the source
            sources.push(pattern.source);
        }
        // Intentionally skip other cases
    }
    return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
    var pairs = [];
    each(o, function(key, value) {
        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    });
    return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};

    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        protocol: match[2],
        host: match[4],
        path: match[5],
        relative: match[5] + query + fragment // everything minus origin
    };
}
function uuid4() {
    var crypto = _window.crypto || _window.msCrypto;

    if (!isUndefined(crypto) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);

        // set 4 in byte 7
        arr[3] = arr[3] & 0xFFF | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        arr[4] = arr[4] & 0x3FFF | 0x8000;

        var pad = function(num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = '0' + v;
            }
            return v;
        };

        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) +
        pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    } else {
        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0,
                v = c === 'x' ? r : r&0x3|0x8;
            return v.toString(16);
        });
    }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
    /* eslint no-extra-parens:0*/
    var MAX_TRAVERSE_HEIGHT = 5,
        MAX_OUTPUT_LEN = 80,
        out = [],
        height = 0,
        len = 0,
        separator = ' > ',
        sepLength = separator.length,
        nextStr;

    while (elem && height++ < MAX_TRAVERSE_HEIGHT) {

        nextStr = htmlElementAsString(elem);
        // bail out if
        // - nextStr is the 'html' element
        // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
        //   (ignore this limit if we are on the first iteration)
        if (nextStr === 'html' || height > 1 && len + (out.length * sepLength) + nextStr.length >= MAX_OUTPUT_LEN) {
            break;
        }

        out.push(nextStr);

        len += nextStr.length;
        elem = elem.parentNode;
    }

    return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
    var out = [],
        className,
        classes,
        key,
        attr,
        i;

    if (!elem || !elem.tagName) {
        return '';
    }

    out.push(elem.tagName.toLowerCase());
    if (elem.id) {
        out.push('#' + elem.id);
    }

    className = elem.className;
    if (className && isString(className)) {
        classes = className.split(/\s+/);
        for (i = 0; i < classes.length; i++) {
            out.push('.' + classes[i]);
        }
    }
    var attrWhitelist = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < attrWhitelist.length; i++) {
        key = attrWhitelist[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push('[' + key + '="' + attr + '"]');
        }
    }
    return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
    return !!(!!a ^ !!b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
    if (isOnlyOneTruthy(ex1, ex2))
        return false;

    ex1 = ex1.values[0];
    ex2 = ex2.values[0];

    if (ex1.type !== ex2.type ||
        ex1.value !== ex2.value)
        return false;

    return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
    if (isOnlyOneTruthy(stack1, stack2))
        return false;

    var frames1 = stack1.frames;
    var frames2 = stack2.frames;

    // Exit early if frame count differs
    if (frames1.length !== frames2.length)
        return false;

    // Iterate through every frame; bail out if anything differs
    var a, b;
    for (var i = 0; i < frames1.length; i++) {
        a = frames1[i];
        b = frames2[i];
        if (a.filename !== b.filename ||
            a.lineno !== b.lineno ||
            a.colno !== b.colno ||
            a['function'] !== b['function'])
            return false;
    }
    return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
    var orig = obj[name];
    obj[name] = replacement(orig);
    if (track) {
        track.push([obj, name, orig]);
    }
}

if (typeof __DEV__ !== 'undefined' && __DEV__) {
    Raven.utils = {
        isUndefined: isUndefined,
        isFunction: isFunction,
        isString: isString,
        isObject: isObject,
        isEmptyObject: isEmptyObject,
        isError: isError,
        each: each,
        objectMerge: objectMerge,
        truncate: truncate,
        hasKey: hasKey,
        joinRegExp: joinRegExp,
        urlencode: urlencode,
        uuid4: uuid4,
        htmlTreeAsString: htmlTreeAsString,
        htmlElementAsString: htmlElementAsString,
        parseUrl: parseUrl,
        fill: fill
    };
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127)))

/***/ }),
/* 2965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/



var RavenConstructor = __webpack_require__(2964);

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window
            : typeof global !== 'undefined' ? global
            : typeof self !== 'undefined' ? self
            : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function () {
	_window.Raven = _Raven;
	return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127)))

/***/ }),
/* 2966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var utils = __webpack_require__(1072);

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
    collectWindowErrors: true,
    debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window
            : typeof global !== 'undefined' ? global
            : typeof self !== 'undefined' ? self
            : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
    if (typeof document === 'undefined' || typeof document.location === 'undefined')
        return '';

    return document.location.href;
}


/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
    var handlers = [],
        lastArgs = null,
        lastException = null,
        lastExceptionStack = null;

    /**
     * Add a crash handler.
     * @param {Function} handler
     */
    function subscribe(handler) {
        installGlobalHandler();
        handlers.push(handler);
    }

    /**
     * Remove a crash handler.
     * @param {Function} handler
     */
    function unsubscribe(handler) {
        for (var i = handlers.length - 1; i >= 0; --i) {
            if (handlers[i] === handler) {
                handlers.splice(i, 1);
            }
        }
    }

    /**
     * Remove all crash handlers.
     */
    function unsubscribeAll() {
        uninstallGlobalHandler();
        handlers = [];
    }

    /**
     * Dispatch stack information to all handlers.
     * @param {Object.<string, *>} stack
     */
    function notifyHandlers(stack, isWindowError) {
        var exception = null;
        if (isWindowError && !TraceKit.collectWindowErrors) {
          return;
        }
        for (var i in handlers) {
            if (handlers.hasOwnProperty(i)) {
                try {
                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
                } catch (inner) {
                    exception = inner;
                }
            }
        }

        if (exception) {
            throw exception;
        }
    }

    var _oldOnerrorHandler, _onErrorHandlerInstalled;

    /**
     * Ensures all global unhandled exceptions are recorded.
     * Supported by Gecko and IE.
     * @param {string} message Error message.
     * @param {string} url URL of script that generated the exception.
     * @param {(number|string)} lineNo The line number at which the error
     * occurred.
     * @param {?(number|string)} colNo The column number at which the error
     * occurred.
     * @param {?Error} ex The actual Error object.
     */
    function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
        var stack = null;

        if (lastExceptionStack) {
            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
            processLastException();
        } else if (ex && utils.isError(ex)) {
            // non-string `ex` arg; attempt to extract stack trace

            // New chrome and blink send along a real error object
            // Let's just report that like a normal error.
            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
            stack = TraceKit.computeStackTrace(ex);
            notifyHandlers(stack, true);
        } else {
            var location = {
                'url': url,
                'line': lineNo,
                'column': colNo
            };

            var name = undefined;
            var msg = message; // must be new var or will modify original `arguments`
            var groups;
            if ({}.toString.call(message) === '[object String]') {
                var groups = message.match(ERROR_TYPES_RE);
                if (groups) {
                    name = groups[1];
                    msg = groups[2];
                }
            }

            location.func = UNKNOWN_FUNCTION;

            stack = {
                'name': name,
                'message': msg,
                'url': getLocationHref(),
                'stack': [location]
            };
            notifyHandlers(stack, true);
        }

        if (_oldOnerrorHandler) {
            return _oldOnerrorHandler.apply(this, arguments);
        }

        return false;
    }

    function installGlobalHandler ()
    {
        if (_onErrorHandlerInstalled) {
            return;
        }
        _oldOnerrorHandler = _window.onerror;
        _window.onerror = traceKitWindowOnError;
        _onErrorHandlerInstalled = true;
    }

    function uninstallGlobalHandler ()
    {
        if (!_onErrorHandlerInstalled) {
            return;
        }
        _window.onerror = _oldOnerrorHandler;
        _onErrorHandlerInstalled = false;
        _oldOnerrorHandler = undefined;
    }

    function processLastException() {
        var _lastExceptionStack = lastExceptionStack,
            _lastArgs = lastArgs;
        lastArgs = null;
        lastExceptionStack = null;
        lastException = null;
        notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
    }

    /**
     * Reports an unhandled Error to TraceKit.
     * @param {Error} ex
     * @param {?boolean} rethrow If false, do not re-throw the exception.
     * Only used for window.onerror to not cause an infinite loop of
     * rethrowing.
     */
    function report(ex, rethrow) {
        var args = _slice.call(arguments, 1);
        if (lastExceptionStack) {
            if (lastException === ex) {
                return; // already caught by an inner catch block, ignore
            } else {
              processLastException();
            }
        }

        var stack = TraceKit.computeStackTrace(ex);
        lastExceptionStack = stack;
        lastException = ex;
        lastArgs = args;

        // If the stack trace is incomplete, wait for 2 seconds for
        // slow slow IE to see if onerror occurs or not before reporting
        // this exception; otherwise, we will end up with an incomplete
        // stack trace
        setTimeout(function () {
            if (lastException === ex) {
                processLastException();
            }
        }, (stack.incomplete ? 2000 : 0));

        if (rethrow !== false) {
            throw ex; // re-throw to propagate to the top level (and cause window.onerror)
        }
    }

    report.subscribe = subscribe;
    report.unsubscribe = unsubscribe;
    report.uninstall = unsubscribeAll;
    return report;
}());

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
    // Contents of Exception in various browsers.
    //
    // SAFARI:
    // ex.message = Can't find variable: qq
    // ex.line = 59
    // ex.sourceId = 580238192
    // ex.sourceURL = http://...
    // ex.expressionBeginOffset = 96
    // ex.expressionCaretOffset = 98
    // ex.expressionEndOffset = 98
    // ex.name = ReferenceError
    //
    // FIREFOX:
    // ex.message = qq is not defined
    // ex.fileName = http://...
    // ex.lineNumber = 59
    // ex.columnNumber = 69
    // ex.stack = ...stack trace... (see the example below)
    // ex.name = ReferenceError
    //
    // CHROME:
    // ex.message = qq is not defined
    // ex.name = ReferenceError
    // ex.type = not_defined
    // ex.arguments = ['aa']
    // ex.stack = ...stack trace...
    //
    // INTERNET EXPLORER:
    // ex.message = ...
    // ex.name = ReferenceError
    //
    // OPERA:
    // ex.message = ...message... (see the example below)
    // ex.name = ReferenceError
    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

    /**
     * Computes stack trace information from the stack property.
     * Chrome and Gecko use this property.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
    function computeStackTraceFromStackProp(ex) {
        if (typeof ex.stack === 'undefined' || !ex.stack) return;

        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
            gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,

            // Used to additionally parse URL/line/column from eval frames
            geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i,
            chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/,

            lines = ex.stack.split('\n'),
            stack = [],
            submatch,
            parts,
            element,
            reference = /^(.*) is undefined$/.exec(ex.message);

        for (var i = 0, j = lines.length; i < j; ++i) {
            if ((parts = chrome.exec(lines[i]))) {
                var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
                var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
                if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                    // throw out eval line/column and use top-most line/column number
                    parts[2] = submatch[1]; // url
                    parts[3] = submatch[2]; // line
                    parts[4] = submatch[3]; // column
                }
                element = {
                    'url': !isNative ? parts[2] : null,
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': isNative ? [parts[2]] : [],
                    'line': parts[3] ? +parts[3] : null,
                    'column': parts[4] ? +parts[4] : null
                };
            } else if ( parts = winjs.exec(lines[i]) ) {
                element = {
                    'url': parts[2],
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': [],
                    'line': +parts[3],
                    'column': parts[4] ? +parts[4] : null
                };
            } else if ((parts = gecko.exec(lines[i]))) {
                var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
                if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                    // throw out eval line/column and use top-most line number
                    parts[3] = submatch[1];
                    parts[4] = submatch[2];
                    parts[5] = null; // no column when eval
                } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
                    // FireFox uses this awesome columnNumber property for its top frame
                    // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                    // so adding 1
                    // NOTE: this hack doesn't work if top-most frame is eval
                    stack[0].column = ex.columnNumber + 1;
                }
                element = {
                    'url': parts[3],
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': parts[2] ? parts[2].split(',') : [],
                    'line': parts[4] ? +parts[4] : null,
                    'column': parts[5] ? +parts[5] : null
                };
            } else {
                continue;
            }

            if (!element.func && element.line) {
                element.func = UNKNOWN_FUNCTION;
            }

            stack.push(element);
        }

        if (!stack.length) {
            return null;
        }

        return {
            'name': ex.name,
            'message': ex.message,
            'url': getLocationHref(),
            'stack': stack
        };
    }

    /**
     * Adds information about the first frame to incomplete stack traces.
     * Safari and IE require this to get complete data on the first frame.
     * @param {Object.<string, *>} stackInfo Stack trace information from
     * one of the compute* methods.
     * @param {string} url The URL of the script that caused an error.
     * @param {(number|string)} lineNo The line number of the script that
     * caused an error.
     * @param {string=} message The error generated by the browser, which
     * hopefully contains the name of the object that caused the error.
     * @return {boolean} Whether or not the stack information was
     * augmented.
     */
    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
        var initial = {
            'url': url,
            'line': lineNo
        };

        if (initial.url && initial.line) {
            stackInfo.incomplete = false;

            if (!initial.func) {
                initial.func = UNKNOWN_FUNCTION;
            }

            if (stackInfo.stack.length > 0) {
                if (stackInfo.stack[0].url === initial.url) {
                    if (stackInfo.stack[0].line === initial.line) {
                        return false; // already in stack trace
                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
                        stackInfo.stack[0].line = initial.line;
                        return false;
                    }
                }
            }

            stackInfo.stack.unshift(initial);
            stackInfo.partial = true;
            return true;
        } else {
            stackInfo.incomplete = true;
        }

        return false;
    }

    /**
     * Computes stack trace information by walking the arguments.caller
     * chain at the time the exception occurred. This will cause earlier
     * frames to be missed but is the only way to get any stack trace in
     * Safari and IE. The top frame is restored by
     * {@link augmentStackTraceWithInitialElement}.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
    function computeStackTraceByWalkingCallerChain(ex, depth) {
        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
            stack = [],
            funcs = {},
            recursion = false,
            parts,
            item,
            source;

        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
            if (curr === computeStackTrace || curr === TraceKit.report) {
                // console.log('skipping internal function');
                continue;
            }

            item = {
                'url': null,
                'func': UNKNOWN_FUNCTION,
                'line': null,
                'column': null
            };

            if (curr.name) {
                item.func = curr.name;
            } else if ((parts = functionName.exec(curr.toString()))) {
                item.func = parts[1];
            }

            if (typeof item.func === 'undefined') {
              try {
                item.func = parts.input.substring(0, parts.input.indexOf('{'));
              } catch (e) { }
            }

            if (funcs['' + curr]) {
                recursion = true;
            }else{
                funcs['' + curr] = true;
            }

            stack.push(item);
        }

        if (depth) {
            // console.log('depth is ' + depth);
            // console.log('stack is ' + stack.length);
            stack.splice(0, depth);
        }

        var result = {
            'name': ex.name,
            'message': ex.message,
            'url': getLocationHref(),
            'stack': stack
        };
        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
        return result;
    }

    /**
     * Computes a stack trace for an exception.
     * @param {Error} ex
     * @param {(string|number)=} depth
     */
    function computeStackTrace(ex, depth) {
        var stack = null;
        depth = (depth == null ? 0 : +depth);

        try {
            stack = computeStackTraceFromStackProp(ex);
            if (stack) {
                return stack;
            }
        } catch (e) {
            if (TraceKit.debug) {
                throw e;
            }
        }

        try {
            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
            if (stack) {
                return stack;
            }
        } catch (e) {
            if (TraceKit.debug) {
                throw e;
            }
        }
        return {
            'name': ex.name,
            'message': ex.message,
            'url': getLocationHref()
        };
    }

    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

    return computeStackTrace;
}());

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127)))

/***/ }),
/* 2967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified for IE8 compatibility.
 Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify
exports.getSerialize = serializer

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return '[Circular ~]'
    return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']'
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~indexOf(stack, value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}


/***/ }),
/* 2968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 2970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(2968);
var invariant = __webpack_require__(2969);
var ReactPropTypesSecret = __webpack_require__(2972);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2971 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2970)();
}


/***/ }),
/* 2972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelGroup__ = __webpack_require__(1089);








var Accordion = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Accordion, _React$Component);

  function Accordion() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Accordion);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Accordion.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__PanelGroup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, { accordion: true }),
      this.props.children
    );
  };

  return Accordion;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Accordion);

/***/ }),
/* 2974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CloseButton__ = __webpack_require__(579);














var propTypes = {
  onDismiss: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  closeLabel: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  closeLabel: 'Close alert'
};

var Alert = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Alert, _React$Component);

  function Alert() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Alert);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Alert.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        onDismiss = _props.onDismiss,
        closeLabel = _props.closeLabel,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onDismiss', 'closeLabel', 'className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var dismissable = !!onDismiss;
    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'dismissable')] = dismissable, _extends2));

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'alert',
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
      }),
      dismissable && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CloseButton__["a" /* default */], {
        onClick: onDismiss,
        label: closeLabel
      }),
      children
    );
  };

  return Alert;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* State */]), __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* State */].INFO, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('alert', Alert)));

/***/ }),
/* 2975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











// TODO: `pullRight` doesn't belong here. There's no special handling here.

var propTypes = {
  pullRight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  pullRight: false
};

var Badge = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Badge, _React$Component);

  function Badge() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Badge);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Badge.prototype.hasContent = function hasContent(children) {
    var result = false;

    __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });

    return result;
  };

  Badge.prototype.render = function render() {
    var _props = this.props,
        pullRight = _props.pullRight,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['pullRight', 'className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {
      'pull-right': pullRight,

      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      children
    );
  };

  return Badge;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('badge', Badge));

/***/ }),
/* 2976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BreadcrumbItem__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











var Breadcrumb = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Breadcrumb, _React$Component);

  function Breadcrumb() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Breadcrumb);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Breadcrumb.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ol', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'navigation',
      'aria-label': 'breadcrumbs',
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Breadcrumb;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Breadcrumb.Item = __WEBPACK_IMPORTED_MODULE_7__BreadcrumbItem__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('breadcrumb', Breadcrumb));

/***/ }),
/* 2977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(39);










var ButtonToolbar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ButtonToolbar, _React$Component);

  function ButtonToolbar() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ButtonToolbar);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ButtonToolbar.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'toolbar',
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ButtonToolbar;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsClass */])('btn-toolbar', ButtonToolbar));

/***/ }),
/* 2978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CarouselCaption__ = __webpack_require__(2979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Glyphicon__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__ = __webpack_require__(116);
















// TODO: `slide` should be `animate`.

// TODO: Use uncontrollable.

var propTypes = {
  slide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  indicators: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * The amount of time to delay between automatically cycling an item.
   * If `null`, carousel will not automatically cycle.
   */
  interval: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  controls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  pauseOnHover: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  wrap: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Callback fired when the active item changes.
   *
   * ```js
   * (eventKey: any) => any | (eventKey: any, event: Object) => any
   * ```
   *
   * If this callback takes two or more arguments, the second argument will
   * be a persisted event object with `direction` set to the direction of the
   * transition.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSlideEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  activeIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  defaultActiveIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  direction: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['prev', 'next']),
  prevIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * Label shown to screen readers only, can be used to show the previous element
   * in the carousel.
   * Set to null to deactivate.
   */
  prevLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  nextIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * Label shown to screen readers only, can be used to show the next element
   * in the carousel.
   * Set to null to deactivate.
   */
  nextLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  slide: true,
  interval: 5000,
  pauseOnHover: true,
  wrap: true,
  indicators: true,
  controls: true,
  prevIcon: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Glyphicon__["a" /* default */], { glyph: 'chevron-left' }),
  prevLabel: 'Previous',
  nextIcon: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Glyphicon__["a" /* default */], { glyph: 'chevron-right' }),
  nextLabel: 'Next'
};

var Carousel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Carousel, _React$Component);

  function Carousel(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Carousel);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
    _this.handlePrev = _this.handlePrev.bind(_this);
    _this.handleNext = _this.handleNext.bind(_this);
    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);

    var defaultActiveIndex = props.defaultActiveIndex;


    _this.state = {
      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
      previousActiveIndex: null,
      direction: null
    };

    _this.isUnmounted = false;
    return _this;
  }

  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var activeIndex = this.getActiveIndex();

    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
      clearTimeout(this.timeout);

      this.setState({
        previousActiveIndex: activeIndex,
        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
      });
    }
  };

  Carousel.prototype.componentDidMount = function componentDidMount() {
    this.waitForNext();
  };

  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeout);
    this.isUnmounted = true;
  };

  Carousel.prototype.handleMouseOver = function handleMouseOver() {
    if (this.props.pauseOnHover) {
      this.pause();
    }
  };

  Carousel.prototype.handleMouseOut = function handleMouseOut() {
    if (this.isPaused) {
      this.play();
    }
  };

  Carousel.prototype.handlePrev = function handlePrev(e) {
    var index = this.getActiveIndex() - 1;

    if (index < 0) {
      if (!this.props.wrap) {
        return;
      }
      index = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(this.props.children) - 1;
    }

    this.select(index, e, 'prev');
  };

  Carousel.prototype.handleNext = function handleNext(e) {
    var index = this.getActiveIndex() + 1;
    var count = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(this.props.children);

    if (index > count - 1) {
      if (!this.props.wrap) {
        return;
      }
      index = 0;
    }

    this.select(index, e, 'next');
  };

  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
    var _this2 = this;

    this.setState({
      previousActiveIndex: null,
      direction: null
    }, function () {
      _this2.waitForNext();

      if (_this2.props.onSlideEnd) {
        _this2.props.onSlideEnd();
      }
    });
  };

  Carousel.prototype.getActiveIndex = function getActiveIndex() {
    var activeIndexProp = this.props.activeIndex;
    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
  };

  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
    if (prevIndex === index) {
      return null;
    }

    return prevIndex > index ? 'prev' : 'next';
  };

  Carousel.prototype.select = function select(index, e, direction) {
    clearTimeout(this.timeout);

    // TODO: Is this necessary? Seems like the only risk is if the component
    // unmounts while handleItemAnimateOutEnd fires.
    if (this.isUnmounted) {
      return;
    }

    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
    direction = direction || this.getDirection(previousActiveIndex, index);

    var onSelect = this.props.onSelect;


    if (onSelect) {
      if (onSelect.length > 1) {
        // React SyntheticEvents are pooled, so we need to remove this event
        // from the pool to add a custom property. To avoid unnecessarily
        // removing objects from the pool, only do this when the listener
        // actually wants the event.
        if (e) {
          e.persist();
          e.direction = direction;
        } else {
          e = { direction: direction };
        }

        onSelect(index, e);
      } else {
        onSelect(index);
      }
    }

    if (this.props.activeIndex == null && index !== previousActiveIndex) {
      if (this.state.previousActiveIndex != null) {
        // If currently animating don't activate the new index.
        // TODO: look into queueing this canceled call and
        // animating after the current animation has ended.
        return;
      }

      this.setState({
        activeIndex: index,
        previousActiveIndex: previousActiveIndex,
        direction: direction
      });
    }
  };

  Carousel.prototype.waitForNext = function waitForNext() {
    var _props = this.props,
        slide = _props.slide,
        interval = _props.interval,
        activeIndexProp = _props.activeIndex;


    if (!this.isPaused && slide && interval && activeIndexProp == null) {
      this.timeout = setTimeout(this.handleNext, interval);
    }
  };

  // This might be a public API.


  Carousel.prototype.pause = function pause() {
    this.isPaused = true;
    clearTimeout(this.timeout);
  };

  // This might be a public API.


  Carousel.prototype.play = function play() {
    this.isPaused = false;
    this.waitForNext();
  };

  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
    var _this3 = this;

    var indicators = [];

    __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child, index) {
      indicators.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', {
        key: index,
        className: index === activeIndex ? 'active' : null,
        onClick: function onClick(e) {
          return _this3.select(index, e);
        }
      }),

      // Force whitespace between indicator elements. Bootstrap requires
      // this for correct spacing of elements.
      ' ');
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ol',
      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'indicators') },
      indicators
    );
  };

  Carousel.prototype.renderControls = function renderControls(properties) {
    var wrap = properties.wrap,
        children = properties.children,
        activeIndex = properties.activeIndex,
        prevIcon = properties.prevIcon,
        nextIcon = properties.nextIcon,
        bsProps = properties.bsProps,
        prevLabel = properties.prevLabel,
        nextLabel = properties.nextLabel;

    var controlClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'control');
    var count = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(children);

    return [(wrap || activeIndex !== 0) && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__["a" /* default */],
      {
        key: 'prev',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(controlClassName, 'left'),
        onClick: this.handlePrev
      },
      prevIcon,
      prevLabel && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        prevLabel
      )
    ), (wrap || activeIndex !== count - 1) && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__["a" /* default */],
      {
        key: 'next',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(controlClassName, 'right'),
        onClick: this.handleNext
      },
      nextIcon,
      nextLabel && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        nextLabel
      )
    )];
  };

  Carousel.prototype.render = function render() {
    var _this4 = this;

    var _props2 = this.props,
        slide = _props2.slide,
        indicators = _props2.indicators,
        controls = _props2.controls,
        wrap = _props2.wrap,
        prevIcon = _props2.prevIcon,
        prevLabel = _props2.prevLabel,
        nextIcon = _props2.nextIcon,
        nextLabel = _props2.nextLabel,
        className = _props2.className,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);

    var _state = this.state,
        previousActiveIndex = _state.previousActiveIndex,
        direction = _state.direction;

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
    'defaultActiveIndex', 'direction']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeIndex = this.getActiveIndex();

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {
      slide: slide
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut
      }),
      indicators && this.renderIndicators(children, activeIndex, bsProps),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inner') },
        __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].map(children, function (child, index) {
          var active = index === activeIndex;
          var previousActive = slide && index === previousActiveIndex;

          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, {
            active: active,
            index: index,
            animateOut: previousActive,
            animateIn: active && previousActiveIndex != null && slide,
            direction: direction,
            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
          });
        })
      ),
      controls && this.renderControls({
        wrap: wrap,
        children: children,
        activeIndex: activeIndex,
        prevIcon: prevIcon,
        prevLabel: prevLabel,
        nextIcon: nextIcon,
        nextLabel: nextLabel,
        bsProps: bsProps
      })
    );
  };

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;

Carousel.Caption = __WEBPACK_IMPORTED_MODULE_8__CarouselCaption__["a" /* default */];
Carousel.Item = __WEBPACK_IMPORTED_MODULE_9__CarouselItem__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["c" /* bsClass */])('carousel', Carousel));

/***/ }),
/* 2979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var CarouselCaption = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CarouselCaption, _React$Component);

  function CarouselCaption() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CarouselCaption);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  CarouselCaption.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return CarouselCaption;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CarouselCaption.propTypes = propTypes;
CarouselCaption.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('carousel-caption', CarouselCaption));

/***/ }),
/* 2980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);












var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Checkbox inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Checkbox = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Checkbox, _React$Component);

  function Checkbox() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Checkbox.prototype.render = function render() {
    var _props = this.props,
        inline = _props.inline,
        disabled = _props.disabled,
        validationState = _props.validationState,
        inputRef = _props.inputRef,
        className = _props.className,
        style = _props.style,
        title = _props.title,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      ref: inputRef,
      type: 'checkbox',
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);

      // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.
       false ? warning(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, _classes), style: style, title: title },
        input,
        children
      );
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {
      disabled: disabled
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes), style: style },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { title: title },
        input,
        children
      )
    );
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('checkbox', Checkbox));

/***/ }),
/* 2981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(106);














var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,

  /**
   * Apply clearfix
   *
   * on Extra small devices Phones
   *
   * adds class `visible-xs-block`
   */
  visibleXsBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Small devices Tablets
   *
   * adds class `visible-sm-block`
   */
  visibleSmBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Medium devices Desktops
   *
   * adds class `visible-md-block`
   */
  visibleMdBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Large devices Desktops
   *
   * adds class `visible-lg-block`
   */
  visibleLgBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  componentClass: 'div'
};

var Clearfix = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Clearfix, _React$Component);

  function Clearfix() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Clearfix);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Clearfix.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* DEVICE_SIZES */].forEach(function (size) {
      var propName = 'visible' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(size) + 'Block';
      if (elementProps[propName]) {
        classes['visible-' + size + '-block'] = true;
      }

      delete elementProps[propName];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Clearfix;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Clearfix.propTypes = propTypes;
Clearfix.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('clearfix', Clearfix));

/***/ }),
/* 2982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(106);













var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,

  /**
   * The number of columns you wish to span
   *
   * for Extra small devices Phones (<768px)
   *
   * class-prefix `col-xs-`
   */
  xs: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Small devices Tablets (≥768px)
   *
   * class-prefix `col-sm-`
   */
  sm: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Medium devices Desktops (≥992px)
   *
   * class-prefix `col-md-`
   */
  md: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Large devices Desktops (≥1200px)
   *
   * class-prefix `col-lg-`
   */
  lg: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Hide column
   *
   * on Extra small devices Phones
   *
   * adds class `hidden-xs`
   */
  xsHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Small devices Tablets
   *
   * adds class `hidden-sm`
   */
  smHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Medium devices Desktops
   *
   * adds class `hidden-md`
   */
  mdHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Large devices Desktops
   *
   * adds class `hidden-lg`
   */
  lgHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Move columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-offset-`
   */
  xsOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-offset-`
   */
  smOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-offset-`
   */
  mdOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-offset-`
   */
  lgOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-push-`
   */
  xsPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-push-`
   */
  smPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-push-`
   */
  mdPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-push-`
   */
  lgPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-pull-`
   */
  xsPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-pull-`
   */
  smPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-pull-`
   */
  mdPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-pull-`
   */
  lgPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number
};

var defaultProps = {
  componentClass: 'div'
};

var Col = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Col, _React$Component);

  function Col() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Col);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Col.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];

    __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["e" /* DEVICE_SIZES */].forEach(function (size) {
      function popProp(propSuffix, modifier) {
        var propName = '' + size + propSuffix;
        var propValue = elementProps[propName];

        if (propValue != null) {
          classes.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '' + size + modifier + '-' + propValue));
        }

        delete elementProps[propName];
      }

      popProp('', '');
      popProp('Offset', '-offset');
      popProp('Push', '-push');
      popProp('Pull', '-pull');

      var hiddenPropName = size + 'Hidden';
      if (elementProps[hiddenPropName]) {
        classes.push('hidden-' + size);
      }
      delete elementProps[hiddenPropName];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Col;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('col', Col));

/***/ }),
/* 2983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);












var propTypes = {
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  htmlFor: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  srOnly: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  srOnly: false
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var ControlLabel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ControlLabel, _React$Component);

  function ControlLabel() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ControlLabel);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ControlLabel.prototype.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        _props$htmlFor = _props.htmlFor,
        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
        srOnly = _props.srOnly,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['htmlFor', 'srOnly', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {
      'sr-only': srOnly
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      htmlFor: htmlFor,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ControlLabel;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ControlLabel.propTypes = propTypes;
ControlLabel.defaultProps = defaultProps;
ControlLabel.contextTypes = contextTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('control-label', ControlLabel));

/***/ }),
/* 2984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Dropdown__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__ = __webpack_require__(396);











var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
});

var DropdownButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DropdownButton, _React$Component);

  function DropdownButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DropdownButton);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DropdownButton.prototype.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        bsStyle = _props.bsStyle,
        title = _props.title,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['bsSize', 'bsStyle', 'title', 'children']);

    var _splitComponentProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, {
        bsSize: bsSize,
        bsStyle: bsStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].Toggle,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, toggleProps, {
          bsSize: bsSize,
          bsStyle: bsStyle
        }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].Menu,
        null,
        children
      )
    );
  };

  return DropdownButton;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DropdownButton.propTypes = propTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (DropdownButton);

/***/ }),
/* 2985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(3037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(116);

















var propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  pullRight: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  onClose: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  labelledBy: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number]),
  onSelect: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(['click', 'mousedown'])
};

var defaultProps = {
  bsRole: 'menu',
  pullRight: false
};

var DropdownMenu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, DropdownMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.handleRootClose = _this.handleRootClose.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
    this.props.onClose(event, { source: 'rootClose' });
  };

  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.down:
        this.focusNext();
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.up:
        this.focusPrevious();
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.tab:
        this.props.onClose(event, { source: 'keydown' });
        break;
      default:
    }
  };

  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
    var items = this.getFocusableMenuItems();
    var activeIndex = items.indexOf(document.activeElement);

    return { items: items, activeIndex: activeIndex };
  };

  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
    var node = __WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(this);
    if (!node) {
      return [];
    }

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(node.querySelectorAll('[tabIndex="-1"]'));
  };

  DropdownMenu.prototype.focusNext = function focusNext() {
    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd.items,
        activeIndex = _getItemsAndActiveInd.activeIndex;

    if (items.length === 0) {
      return;
    }

    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    items[nextIndex].focus();
  };

  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd2.items,
        activeIndex = _getItemsAndActiveInd2.activeIndex;

    if (items.length === 0) {
      return;
    }

    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    items[prevIndex].focus();
  };

  DropdownMenu.prototype.render = function render() {
    var _extends2,
        _this2 = this;

    var _props = this.props,
        open = _props.open,
        pullRight = _props.pullRight,
        labelledBy = _props.labelledBy,
        onSelect = _props.onSelect,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['onClose']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'right')] = pullRight, _extends2));

    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper___default.a,
      {
        disabled: !open,
        onRootClose: this.handleRootClose,
        event: rootCloseEvent
      },
      __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'ul',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
          role: 'menu',
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes),
          'aria-labelledby': labelledBy
        }),
        __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.cloneElement(child, {
            onKeyDown: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, _this2.handleKeyDown),
            onSelect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
          });
        })
      )
    );
  };

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["c" /* bsClass */])('dropdown-menu', DropdownMenu));

/***/ }),
/* 2986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);












var propTypes = {
  horizontal: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  horizontal: false,
  inline: false,
  componentClass: 'form'
};

var Form = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Form, _React$Component);

  function Form() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Form);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Form.prototype.render = function render() {
    var _props = this.props,
        horizontal = _props.horizontal,
        inline = _props.inline,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['horizontal', 'inline', 'componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];
    if (horizontal) {
      classes.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'horizontal'));
    }
    if (inline) {
      classes.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline'));
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Form;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('form', Form));

/***/ }),
/* 2987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FormControlFeedback__ = __webpack_require__(2988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FormControlStatic__ = __webpack_require__(2989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__ = __webpack_require__(106);

















var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
  /**
   * Only relevant if `componentClass` is `'input'`.
   */
  type: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <FormControl inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  componentClass: 'input'
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var FormControl = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControl, _React$Component);

  function FormControl() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControl);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControl.prototype.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        Component = _props.componentClass,
        type = _props.type,
        _props$id = _props.id,
        id = _props$id === undefined ? controlId : _props$id,
        inputRef = _props.inputRef,
        className = _props.className,
        bsSize = _props.bsSize,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;

    // input[type="file"] should not have .form-control.
    var classes = void 0;
    if (type !== 'file') {
      classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);
    }

    // If user provides a size, make sure to append it to classes as input-
    // e.g. if bsSize is small, it will append input-sm
    if (bsSize) {
      var size = __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["a" /* SIZE_MAP */][bsSize] || bsSize;
      classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])({ bsClass: 'input' }, size)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      type: type,
      id: id,
      ref: inputRef,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return FormControl;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControl.propTypes = propTypes;
FormControl.defaultProps = defaultProps;
FormControl.contextTypes = contextTypes;

FormControl.Feedback = __WEBPACK_IMPORTED_MODULE_10__FormControlFeedback__["a" /* default */];
FormControl.Static = __WEBPACK_IMPORTED_MODULE_11__FormControlStatic__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["c" /* bsClass */])('form-control', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["d" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["b" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["b" /* Size */].LARGE], FormControl)));

/***/ }),
/* 2988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Glyphicon__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);












var defaultProps = {
  bsRole: 'feedback'
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var FormControlFeedback = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControlFeedback, _React$Component);

  function FormControlFeedback() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControlFeedback);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
    switch (validationState) {
      case 'success':
        return 'ok';
      case 'warning':
        return 'warning-sign';
      case 'error':
        return 'remove';
      default:
        return null;
    }
  };

  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
    var glyph = this.getGlyph(formGroup && formGroup.validationState);
    if (!glyph) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Glyphicon__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
      glyph: glyph,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  FormControlFeedback.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    if (!children) {
      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
    }

    var child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(child.props.className, className, classes)
    }));
  };

  return FormControlFeedback;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControlFeedback.defaultProps = defaultProps;
FormControlFeedback.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('form-control-feedback', FormControlFeedback));

/***/ }),
/* 2989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'p'
};

var FormControlStatic = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControlStatic, _React$Component);

  function FormControlStatic() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControlStatic);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControlStatic.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return FormControlStatic;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControlStatic.propTypes = propTypes;
FormControlStatic.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('form-control-static', FormControlStatic));

/***/ }),
/* 2990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(116);













var propTypes = {
  /**
   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
   */
  controlId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null])
};

var childContextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
};

var FormGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormGroup, _React$Component);

  function FormGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormGroup.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        controlId = _props.controlId,
        validationState = _props.validationState;


    return {
      $bs_formGroup: {
        controlId: controlId,
        validationState: validationState
      }
    };
  };

  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
    });
  };

  FormGroup.prototype.render = function render() {
    var _props2 = this.props,
        validationState = _props2.validationState,
        className = _props2.className,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['validationState', 'className', 'children']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['controlId']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {
      'has-feedback': this.hasFeedback(children)
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      children
    );
  };

  return FormGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormGroup.propTypes = propTypes;
FormGroup.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('form-group', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["b" /* Size */].SMALL], FormGroup)));

/***/ }),
/* 2991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(39);










var HelpBlock = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(HelpBlock, _React$Component);

  function HelpBlock() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, HelpBlock);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  HelpBlock.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return HelpBlock;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsClass */])('help-block', HelpBlock));

/***/ }),
/* 2992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











var propTypes = {
  /**
   * Sets image as responsive image
   */
  responsive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as rounded
   */
  rounded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as circle
   */
  circle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as thumbnail
   */
  thumbnail: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  responsive: false,
  rounded: false,
  circle: false,
  thumbnail: false
};

var Image = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Image, _React$Component);

  function Image() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Image);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Image.prototype.render = function render() {
    var _classes;

    var _props = this.props,
        responsive = _props.responsive,
        rounded = _props.rounded,
        circle = _props.circle,
        thumbnail = _props.thumbnail,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (_classes = {}, _classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'responsive')] = responsive, _classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'rounded')] = rounded, _classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'circle')] = circle, _classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'thumbnail')] = thumbnail, _classes);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Image;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('img', Image));

/***/ }),
/* 2993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputGroupAddon__ = __webpack_require__(2994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InputGroupButton__ = __webpack_require__(2995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(106);













var InputGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroup, _React$Component);

  function InputGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroup.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return InputGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

InputGroup.Addon = __WEBPACK_IMPORTED_MODULE_7__InputGroupAddon__["a" /* default */];
InputGroup.Button = __WEBPACK_IMPORTED_MODULE_8__InputGroupButton__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('input-group', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["b" /* Size */].SMALL], InputGroup)));

/***/ }),
/* 2994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(39);










var InputGroupAddon = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroupAddon, _React$Component);

  function InputGroupAddon() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroupAddon);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroupAddon.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return InputGroupAddon;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsClass */])('input-group-addon', InputGroupAddon));

/***/ }),
/* 2995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(39);










var InputGroupButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroupButton, _React$Component);

  function InputGroupButton() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroupButton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroupButton.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return InputGroupButton;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsClass */])('input-group-btn', InputGroupButton));

/***/ }),
/* 2996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Jumbotron = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Jumbotron, _React$Component);

  function Jumbotron() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Jumbotron);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Jumbotron.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
    }));
  };

  return Jumbotron;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Jumbotron.propTypes = propTypes;
Jumbotron.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('jumbotron', Jumbotron));

/***/ }),
/* 2997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(106);












var Label = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Label, _React$Component);

  function Label() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Label);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Label.prototype.hasContent = function hasContent(children) {
    var result = false;

    __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });

    return result;
  };

  Label.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {

      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
      }),
      children
    );
  };

  return Label;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('label', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* bsStyles */])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* State */]), [__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["d" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["d" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["d" /* Style */].DEFAULT, Label)));

/***/ }),
/* 2998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(116);













var propTypes = {
  /**
   * You can use a custom element type for this component.
   *
   * If not specified, it will be treated as `'li'` if every child is a
   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

function getDefaultComponent(children) {
  if (!children) {
    // FIXME: This is the old behavior. Is this right?
    return 'div';
  }

  if (__WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
    return child.type !== __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__["a" /* default */] || child.props.href || child.props.onClick;
  })) {
    return 'div';
  }

  return 'ul';
}

var ListGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ListGroup, _React$Component);

  function ListGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ListGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ListGroup.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        _props$componentClass = _props.componentClass,
        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    var useListItem = Component === 'ul' && __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].every(children, function (child) {
      return child.type === __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__["a" /* default */];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      useListItem ? __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, { listItem: true });
      }) : children
    );
  };

  return ListGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ListGroup.propTypes = propTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('list-group', ListGroup));

/***/ }),
/* 2999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var MediaBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaBody, _React$Component);

  function MediaBody() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaBody);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaBody.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaBody;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaBody.propTypes = propTypes;
MediaBody.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('media-body', MediaBody));

/***/ }),
/* 3000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'h4'
};

var MediaHeading = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaHeading, _React$Component);

  function MediaHeading() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaHeading);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaHeading.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaHeading;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaHeading.propTypes = propTypes;
MediaHeading.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('media-heading', MediaHeading));

/***/ }),
/* 3001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Media__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);












var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaLeft = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaLeft, _React$Component);

  function MediaLeft() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaLeft);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaLeft.prototype.render = function render() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['align', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_8__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaLeft;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaLeft.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('media-left', MediaLeft));

/***/ }),
/* 3002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(39);










var MediaList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaList, _React$Component);

  function MediaList() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaList);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaList.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ul', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaList;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsClass */])('media-list', MediaList));

/***/ }),
/* 3003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(39);










var MediaListItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaListItem, _React$Component);

  function MediaListItem() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaListItem);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaListItem.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaListItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsClass */])('media', MediaListItem));

/***/ }),
/* 3004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Media__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);












var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaRight = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaRight, _React$Component);

  function MediaRight() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaRight);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaRight.prototype.render = function render() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['align', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-right-top`.
      classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_8__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaRight;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaRight.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('media-right', MediaRight));

/***/ }),
/* 3005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(98);














var propTypes = {
  /**
   * Highlight the menu item as active.
   */
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Disable the menu item, making it unselectable.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Styles the menu item as a horizontal rule, providing visual separation between
   * groups of menu items.
   */
  divider: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, function (_ref) {
    var divider = _ref.divider,
        children = _ref.children;
    return divider && children ? new Error('Children will not be rendered for dividers') : null;
  }),

  /**
   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,

  /**
   * Styles the menu item as a header label, useful for describing a group of menu items.
   */
  header: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * HTML `href` attribute corresponding to `a.href`.
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * Callback fired when the menu item is clicked.
   */
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired when the menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  divider: false,
  disabled: false,
  header: false
};

var MenuItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MenuItem, _React$Component);

  function MenuItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MenuItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  MenuItem.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        href = _props.href,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (!href || disabled) {
      event.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  MenuItem.prototype.render = function render() {
    var _props2 = this.props,
        active = _props2.active,
        disabled = _props2.disabled,
        divider = _props2.divider,
        header = _props2.header,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (divider) {
      // Forcibly blank out the children; separators shouldn't render any.
      elementProps.children = undefined;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'separator',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, 'divider'),
        style: style
      }));
    }

    if (header) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'heading',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'header')),
        style: style
      }));
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        role: 'presentation',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'menuitem',
        tabIndex: '-1',
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
      }))
    );
  };

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsClass */])('dropdown', MenuItem));

/***/ }),
/* 3006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events__ = __webpack_require__(2729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Fade__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ModalBody__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ModalDialog__ = __webpack_require__(3007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ModalFooter__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ModalHeader__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ModalTitle__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_splitComponentProps__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__ = __webpack_require__(106);




























var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.propTypes, __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */].propTypes, {

  /**
   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
   * trigger an "onHide" when clicked.
   */
  backdrop: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.oneOf(['static', true, false]),

  /**
   * Add an optional extra class name to .modal-backdrop
   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
   */
  backdropClassName: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * Open and close the Modal with a slide and fade animation.
   */
  animation: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * A Component type that provides the modal content Markup. This is a useful
   * prop when you want to use your own styles and markup to create a custom
   * modal component.
   */
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType___default.a,

  /**
   * When `true` The modal will automatically shift focus to itself when it
   * opens, and replace it to the last focused element when it closes.
   * Generally this should never be set to false as it makes the Modal less
   * accessible to assistive technologies, like screen-readers.
   */
  autoFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while
   * open. Consider leaving the default value here, as it is necessary to make
   * the Modal work well with assistive technologies, such as screen readers.
   */
  enforceFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will show itself.
   */
  show: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * A callback fired when the header closeButton or non-static backdrop is
   * clicked. Required if either are specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * @private
   */
  container: __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.propTypes.container
});

var defaultProps = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.defaultProps, {
  animation: true,
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */]
});

var childContextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func
  })
};

var Modal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Modal, _React$Component);

  function Modal(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Modal);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleEntering = _this.handleEntering.bind(_this);
    _this.handleExited = _this.handleExited.bind(_this);
    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
    _this.handleDialogClick = _this.handleDialogClick.bind(_this);

    _this.state = {
      style: {}
    };
    return _this;
  }

  Modal.prototype.getChildContext = function getChildContext() {
    return {
      $bs_modal: {
        onHide: this.props.onHide
      }
    };
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    // Clean up the listener if we need to.
    this.handleExited();
  };

  Modal.prototype.handleEntering = function handleEntering() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default.a.on(window, 'resize', this.handleWindowResize);
    this.updateStyle();
  };

  Modal.prototype.handleExited = function handleExited() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default.a.off(window, 'resize', this.handleWindowResize);
  };

  Modal.prototype.handleWindowResize = function handleWindowResize() {
    this.updateStyle();
  };

  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    this.props.onHide();
  };

  Modal.prototype.updateStyle = function updateStyle() {
    if (!__WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM___default.a) {
      return;
    }

    var dialogNode = this._modal.getDialogElement();
    var dialogHeight = dialogNode.scrollHeight;

    var document = __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument___default()(dialogNode);
    var bodyIsOverflowing = __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing___default()(__WEBPACK_IMPORTED_MODULE_12_react_dom___default.a.findDOMNode(this.props.container || document.body));
    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;

    this.setState({
      style: {
        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default()() : undefined,
        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default()() : undefined
      }
    });
  };

  Modal.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        backdrop = _props.backdrop,
        backdropClassName = _props.backdropClassName,
        animation = _props.animation,
        show = _props.show,
        Dialog = _props.dialogComponentClass,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        onEntering = _props.onEntering,
        onExited = _props.onExited,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['backdrop', 'backdropClassName', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);

    var _splitComponentProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a),
        baseModalProps = _splitComponentProps[0],
        dialogProps = _splitComponentProps[1];

    var inClassName = show && !animation && 'in';

    return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a,
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, baseModalProps, {
        ref: function ref(c) {
          _this2._modal = c;
        },
        show: show,
        onEntering: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__["a" /* default */])(onEntering, this.handleEntering),
        onExited: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__["a" /* default */])(onExited, this.handleExited),
        backdrop: backdrop,
        backdropClassName: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["e" /* prefix */])(props, 'backdrop'), backdropClassName, inClassName),
        containerClassName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["e" /* prefix */])(props, 'open'),
        transition: animation ? __WEBPACK_IMPORTED_MODULE_16__Fade__["a" /* default */] : undefined,
        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
      }),
      __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
        Dialog,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dialogProps, {
          style: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.state.style, style),
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, inClassName),
          onClick: backdrop === true ? this.handleDialogClick : null
        }),
        children
      )
    );
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.childContextTypes = childContextTypes;

Modal.Body = __WEBPACK_IMPORTED_MODULE_17__ModalBody__["a" /* default */];
Modal.Header = __WEBPACK_IMPORTED_MODULE_20__ModalHeader__["a" /* default */];
Modal.Title = __WEBPACK_IMPORTED_MODULE_21__ModalTitle__["a" /* default */];
Modal.Footer = __WEBPACK_IMPORTED_MODULE_19__ModalFooter__["a" /* default */];

Modal.Dialog = __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */];

Modal.TRANSITION_DURATION = 300;
Modal.BACKDROP_TRANSITION_DURATION = 150;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["c" /* bsClass */])('modal', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["d" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__["b" /* Size */].SMALL], Modal)));

/***/ }),
/* 3007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(106);












var propTypes = {
  /**
   * A css class to apply to the Modal dialog DOM node.
   */
  dialogClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var ModalDialog = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalDialog, _React$Component);

  function ModalDialog() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalDialog);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalDialog.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        dialogClassName = _props.dialogClassName,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['dialogClassName', 'className', 'style', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var bsClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps);

    var modalStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ display: 'block' }, style);

    var dialogClasses = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'dialog')] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        tabIndex: '-1',
        role: 'dialog',
        style: modalStyle,
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(dialogClassName, dialogClasses) },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content'), role: 'document' },
          children
        )
      )
    );
  };

  return ModalDialog;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalDialog.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('modal', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["b" /* Size */].SMALL], ModalDialog)));

/***/ }),
/* 3008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dropdown__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_splitComponentProps__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(116);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
});

var NavDropdown = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NavDropdown, _React$Component);

  function NavDropdown() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NavDropdown);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
    var props = _ref.props;

    var _this2 = this;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    if (__WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    })) {
      return true;
    }

    return props.active;
  };

  NavDropdown.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        title = _props.title,
        activeKey = _props.activeKey,
        activeHref = _props.activeHref,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);

    var active = this.isActive(this, activeKey, activeHref);
    delete props.active; // Accessed via this.isActive().
    delete props.eventKey; // Accessed via this.isActive().

    var _splitComponentProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
    // rather than the `<Dropdown.Toggle>`.

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, {
        componentClass: 'li',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active }),
        style: style
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Toggle,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, toggleProps, { useAnchor: true }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Menu,
        null,
        __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
            active: _this3.isActive(child, activeKey, activeHref)
          });
        })
      )
    );
  };

  return NavDropdown;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavDropdown.propTypes = propTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (NavDropdown);

/***/ }),
/* 3009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uncontrollable__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Grid__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NavbarBrand__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NavbarCollapse__ = __webpack_require__(3010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NavbarHeader__ = __webpack_require__(3011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NavbarToggle__ = __webpack_require__(3012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_createChainedFunction__ = __webpack_require__(98);





// TODO: Remove this pragma once we upgrade eslint-config-airbnb.
/* eslint-disable react/no-multi-comp */
















var propTypes = {
  /**
   * Create a fixed navbar along the top of the screen, that scrolls with the
   * page
   */
  fixedTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Create a fixed navbar along the bottom of the screen, that scrolls with
   * the page
   */
  fixedBottom: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Create a full-width navbar that scrolls away with the page
   */
  staticTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * An alternative dark visual style for the Navbar
   */
  inverse: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Allow the Navbar to fluidly adjust to the page or container width, instead
   * of at the predefined screen breakpoints
   */
  fluid: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Set a custom element for this component.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
  /**
   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
   * a `<Navbar.Toggle>` is clicked and called with the new `navExpanded`
   * boolean value.
   *
   * @controllable navExpanded
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * A callback fired when a descendant of a child `<Nav>` is selected. Should
   * be used to execute complex closing or other miscellaneous actions desired
   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
   * descendants exist. The callback is called with an eventKey, which is a
   * prop from the selected `<Nav>` descendant, and an event.
   *
   * ```js
   * function (
   * 	Any eventKey,
   * 	SyntheticEvent event?
   * )
   * ```
   *
   * For basic closing behavior after all `<Nav>` descendant onSelect events in
   * mobile viewports, try using collapseOnSelect.
   *
   * Note: If you are manually closing the navbar using this `OnSelect` prop,
   * ensure that you are setting `expanded` to false and not *toggling* between
   * true and false.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * Sets `expanded` to `false` after the onSelect event of a descendant of a
   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
   *
   * The onSelect callback should be used instead for more complex operations
   * that need to be executed after the `select` event of `<Nav>` descendants.
   */
  collapseOnSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Explicitly set the visiblity of the navbar body
   *
   * @controllable onToggle
   */
  expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  componentClass: 'nav',
  fixedTop: false,
  fixedBottom: false,
  staticTop: false,
  inverse: false,
  fluid: false,
  collapseOnSelect: false
};

var childContextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  })
};

var Navbar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Navbar, _React$Component);

  function Navbar(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Navbar);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleCollapse = _this.handleCollapse.bind(_this);
    return _this;
  }

  Navbar.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        expanded = _props.expanded,
        onSelect = _props.onSelect,
        collapseOnSelect = _props.collapseOnSelect;


    return {
      $bs_navbar: {
        bsClass: bsClass,
        expanded: expanded,
        onToggle: this.handleToggle,
        onSelect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_createChainedFunction__["a" /* default */])(onSelect, collapseOnSelect ? this.handleCollapse : null)
      }
    };
  };

  Navbar.prototype.handleCollapse = function handleCollapse() {
    var _props2 = this.props,
        onToggle = _props2.onToggle,
        expanded = _props2.expanded;


    if (expanded) {
      onToggle(false);
    }
  };

  Navbar.prototype.handleToggle = function handleToggle() {
    var _props3 = this.props,
        onToggle = _props3.onToggle,
        expanded = _props3.expanded;


    onToggle(!expanded);
  };

  Navbar.prototype.render = function render() {
    var _extends2;

    var _props4 = this.props,
        Component = _props4.componentClass,
        fixedTop = _props4.fixedTop,
        fixedBottom = _props4.fixedBottom,
        staticTop = _props4.staticTop,
        inverse = _props4.inverse,
        fluid = _props4.fluid,
        className = _props4.className,
        children = _props4.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one


    if (elementProps.role === undefined && Component !== 'nav') {
      elementProps.role = 'navigation';
    }

    if (inverse) {
      bsProps.bsStyle = __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["d" /* Style */].INVERSE;
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'fixed-top')] = fixedTop, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'static-top')] = staticTop, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Grid__["a" /* default */],
        { fluid: fluid },
        children
      )
    );
  };

  return Navbar;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;
Navbar.childContextTypes = childContextTypes;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["c" /* bsClass */])('navbar', Navbar);

var UncontrollableNavbar = __WEBPACK_IMPORTED_MODULE_9_uncontrollable___default()(Navbar, { expanded: 'onToggle' });

function createSimpleWrapper(tag, suffix, displayName) {
  var Wrapper = function Wrapper(_ref, _ref2) {
    var _ref2$$bs_navbar = _ref2.$bs_navbar,
        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;

    var Component = _ref.componentClass,
        className = _ref.className,
        pullRight = _ref.pullRight,
        pullLeft = _ref.pullLeft,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, suffix), pullRight && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'right'), pullLeft && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'left'))
    }));
  };

  Wrapper.displayName = displayName;

  Wrapper.propTypes = {
    componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
    pullRight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    pullLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
  };

  Wrapper.defaultProps = {
    componentClass: tag,
    pullRight: false,
    pullLeft: false
  };

  Wrapper.contextTypes = {
    $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
      bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
    })
  };

  return Wrapper;
}

UncontrollableNavbar.Brand = __WEBPACK_IMPORTED_MODULE_11__NavbarBrand__["a" /* default */];
UncontrollableNavbar.Header = __WEBPACK_IMPORTED_MODULE_13__NavbarHeader__["a" /* default */];
UncontrollableNavbar.Toggle = __WEBPACK_IMPORTED_MODULE_14__NavbarToggle__["a" /* default */];
UncontrollableNavbar.Collapse = __WEBPACK_IMPORTED_MODULE_12__NavbarCollapse__["a" /* default */];

UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');

// Set bsStyles here so they can be overridden.
/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["f" /* bsStyles */])([__WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["d" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["d" /* Style */].INVERSE], __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["d" /* Style */].DEFAULT, UncontrollableNavbar));

/***/ }),
/* 3010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Collapse__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
  })
};

var NavbarCollapse = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarCollapse, _React$Component);

  function NavbarCollapse() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarCollapse);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarCollapse.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'collapse');

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Collapse__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ 'in': navbarProps.expanded }, props),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: bsClassName },
        children
      )
    );
  };

  return NavbarCollapse;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

NavbarCollapse.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarCollapse);

/***/ }),
/* 3011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
  })
};

var NavbarHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarHeader, _React$Component);

  function NavbarHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'header');

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName) }));
  };

  return NavbarHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarHeader.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarHeader);

/***/ }),
/* 3012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(98);












var propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * The toggle content, if left empty it will render the default toggle (seen above).
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};

var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
  })
};

var NavbarToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarToggle, _React$Component);

  function NavbarToggle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarToggle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarToggle.prototype.render = function render() {
    var _props = this.props,
        onClick = _props.onClick,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onClick', 'className', 'children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var buttonProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      type: 'button'
    }, props, {
      onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, navbarProps.onToggle),
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
    });

    if (children) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'button',
        buttonProps,
        children
      );
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'button',
      buttonProps,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        'Toggle navigation'
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' })
    );
  };

  return NavbarToggle;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarToggle.propTypes = propTypes;
NavbarToggle.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarToggle);

/***/ }),
/* 3013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Overlay__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(98);















/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */
function isOneOf(one, of) {
  if (Array.isArray(of)) {
    return of.indexOf(one) >= 0;
  }
  return one === of;
}

var triggerType = __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['click', 'hover', 'focus']);

var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */].propTypes, {

  /**
  * Specify which action or actions trigger Overlay visibility
  */
  trigger: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([triggerType, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(triggerType)]),

  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * A millisecond delay amount before showing the Overlay once triggered.
   */
  delayShow: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * A millisecond delay amount before hiding the Overlay once triggered.
   */
  delayHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  // FIXME: This should be `defaultShow`.
  /**
   * The initial visibility state of the Overlay. For more nuanced visibility
   * control, consider using the Overlay component directly.
   */
  defaultOverlayShown: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * An element or text to overlay next to the target.
   */
  overlay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,

  /**
   * @private
   */
  onBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onFocus: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseOut: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseOver: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  // Overridden props from `<Overlay>`.
  /**
   * @private
   */
  target: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),
  /**
  * @private
  */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),
  /**
   * @private
   */
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null])
});

var defaultProps = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus']
};

var OverlayTrigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(OverlayTrigger, _React$Component);

  function OverlayTrigger(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OverlayTrigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
    _this.handleHide = _this.handleHide.bind(_this);

    _this.handleMouseOver = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
    };
    _this.handleMouseOut = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
    };

    _this._mountNode = null;

    _this.state = {
      show: props.defaultOverlayShown
    };
    return _this;
  }

  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
    this._mountNode = document.createElement('div');
    this.renderOverlay();
  };

  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
    this.renderOverlay();
  };

  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unmountComponentAtNode(this._mountNode);
    this._mountNode = null;

    clearTimeout(this._hoverShowDelay);
    clearTimeout(this._hoverHideDelay);
  };

  OverlayTrigger.prototype.handleToggle = function handleToggle() {
    if (this.state.show) {
      this.hide();
    } else {
      this.show();
    }
  };

  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
    var _this2 = this;

    if (this._hoverHideDelay != null) {
      clearTimeout(this._hoverHideDelay);
      this._hoverHideDelay = null;
      return;
    }

    if (this.state.show || this._hoverShowDelay != null) {
      return;
    }

    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;

    if (!delay) {
      this.show();
      return;
    }

    this._hoverShowDelay = setTimeout(function () {
      _this2._hoverShowDelay = null;
      _this2.show();
    }, delay);
  };

  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
    var _this3 = this;

    if (this._hoverShowDelay != null) {
      clearTimeout(this._hoverShowDelay);
      this._hoverShowDelay = null;
      return;
    }

    if (!this.state.show || this._hoverHideDelay != null) {
      return;
    }

    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;

    if (!delay) {
      this.hide();
      return;
    }

    this._hoverHideDelay = setTimeout(function () {
      _this3._hoverHideDelay = null;
      _this3.hide();
    }, delay);
  };

  // Simple implementation of mouseEnter and mouseLeave.
  // React's built version is broken: https://github.com/facebook/react/issues/4251
  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
  // moving from one child element to another.


  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent.toElement;

    if (!related || related !== target && !__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default()(target, related)) {
      handler(e);
    }
  };

  OverlayTrigger.prototype.handleHide = function handleHide() {
    this.hide();
  };

  OverlayTrigger.prototype.show = function show() {
    this.setState({ show: true });
  };

  OverlayTrigger.prototype.hide = function hide() {
    this.setState({ show: false });
  };

  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, {
        show: this.state.show,
        onHide: this.handleHide,
        target: this
      }),
      overlay
    );
  };

  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
  };

  OverlayTrigger.prototype.render = function render() {
    var _props = this.props,
        trigger = _props.trigger,
        overlay = _props.overlay,
        children = _props.children,
        onBlur = _props.onBlur,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onMouseOut = _props.onMouseOut,
        onMouseOver = _props.onMouseOver,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);

    delete props.delay;
    delete props.delayShow;
    delete props.delayHide;
    delete props.defaultOverlayShown;

    var child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    var childProps = child.props;
    var triggerProps = {};

    if (this.state.show) {
      triggerProps['aria-describedby'] = overlay.props.id;
    }

    // FIXME: The logic here for passing through handlers on this component is
    // inconsistent. We shouldn't be passing any of these props through.

    triggerProps.onClick = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onClick, onClick);

    if (isOneOf('click', trigger)) {
      triggerProps.onClick = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(triggerProps.onClick, this.handleToggle);
    }

    if (isOneOf('hover', trigger)) {
       false ? warning(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;

      triggerProps.onMouseOver = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
      triggerProps.onMouseOut = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
    }

    if (isOneOf('focus', trigger)) {
      triggerProps.onFocus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onFocus, onFocus, this.handleDelayedShow);
      triggerProps.onBlur = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onBlur, onBlur, this.handleDelayedHide);
    }

    this._overlay = this.makeOverlay(overlay, props);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, triggerProps);
  };

  return OverlayTrigger;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

OverlayTrigger.propTypes = propTypes;
OverlayTrigger.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (OverlayTrigger);

/***/ }),
/* 3014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(39);










var PageHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PageHeader, _React$Component);

  function PageHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PageHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  PageHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'h1',
        null,
        children
      )
    );
  };

  return PageHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsClass */])('page-header', PageHeader));

/***/ }),
/* 3015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PagerItem__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__ = __webpack_require__(3035);



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__["a" /* default */].wrapper(__WEBPACK_IMPORTED_MODULE_0__PagerItem__["a" /* default */], '`<PageItem>`', '`<Pager.Item>`'));

/***/ }),
/* 3016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PagerItem__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__ = __webpack_require__(116);














var propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var Pager = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Pager, _React$Component);

  function Pager() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Pager);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Pager.prototype.render = function render() {
    var _props = this.props,
        onSelect = _props.onSelect,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onSelect', 'className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, {
          onSelect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
        });
      })
    );
  };

  return Pager;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Pager.propTypes = propTypes;

Pager.Item = __WEBPACK_IMPORTED_MODULE_8__PagerItem__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('pager', Pager));

/***/ }),
/* 3017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaginationButton__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(39);













var propTypes = {
  activePage: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  items: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  maxButtons: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  /**
   * When `true`, will display the first and the last button page when
   * displaying ellipsis.
   */
  boundaryLinks: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * When `true`, will display the default node value ('&hellip;').
   * Otherwise, will display provided node (when specified).
   */
  ellipsis: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  /**
   * When `true`, will display the default node value ('&laquo;').
   * Otherwise, will display provided node (when specified).
   */
  first: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  /**
   * When `true`, will display the default node value ('&raquo;').
   * Otherwise, will display provided node (when specified).
   */
  last: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  /**
   * When `true`, will display the default node value ('&lsaquo;').
   * Otherwise, will display provided node (when specified).
   */
  prev: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  /**
   * When `true`, will display the default node value ('&rsaquo;').
   * Otherwise, will display provided node (when specified).
   */
  next: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * You can use a custom element for the buttons
   */
  buttonComponentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  activePage: 1,
  items: 1,
  maxButtons: 0,
  first: false,
  last: false,
  prev: false,
  next: false,
  ellipsis: true,
  boundaryLinks: false
};

var Pagination = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Pagination, _React$Component);

  function Pagination() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Pagination);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
    var pageButtons = [];

    var startPage = void 0;
    var endPage = void 0;

    if (maxButtons && maxButtons < items) {
      startPage = Math.max(Math.min(activePage - Math.floor(maxButtons / 2, 10), items - maxButtons + 1), 1);
      endPage = startPage + maxButtons - 1;
    } else {
      startPage = 1;
      endPage = items;
    }

    for (var page = startPage; page <= endPage; ++page) {
      pageButtons.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          key: page,
          eventKey: page,
          active: page === activePage
        }),
        page
      ));
    }

    if (ellipsis && boundaryLinks && startPage > 1) {
      if (startPage > 2) {
        pageButtons.unshift(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
          {
            key: 'ellipsisFirst',
            disabled: true,
            componentClass: buttonProps.componentClass
          },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'span',
            { 'aria-label': 'More' },
            ellipsis === true ? '\u2026' : ellipsis
          )
        ));
      }

      pageButtons.unshift(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          key: 1,
          eventKey: 1,
          active: false
        }),
        '1'
      ));
    }

    if (ellipsis && endPage < items) {
      if (!boundaryLinks || endPage < items - 1) {
        pageButtons.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
          {
            key: 'ellipsis',
            disabled: true,
            componentClass: buttonProps.componentClass
          },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'span',
            { 'aria-label': 'More' },
            ellipsis === true ? '\u2026' : ellipsis
          )
        ));
      }

      if (boundaryLinks) {
        pageButtons.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
            key: items,
            eventKey: items,
            active: false
          }),
          items
        ));
      }
    }

    return pageButtons;
  };

  Pagination.prototype.render = function render() {
    var _props = this.props,
        activePage = _props.activePage,
        items = _props.items,
        maxButtons = _props.maxButtons,
        boundaryLinks = _props.boundaryLinks,
        ellipsis = _props.ellipsis,
        first = _props.first,
        last = _props.last,
        prev = _props.prev,
        next = _props.next,
        onSelect = _props.onSelect,
        buttonComponentClass = _props.buttonComponentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    var buttonProps = {
      onSelect: onSelect,
      componentClass: buttonComponentClass
    };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      first && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          eventKey: 1,
          disabled: activePage === 1
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'span',
          { 'aria-label': 'First' },
          first === true ? '\xAB' : first
        )
      ),
      prev && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          eventKey: activePage - 1,
          disabled: activePage === 1
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'span',
          { 'aria-label': 'Previous' },
          prev === true ? '\u2039' : prev
        )
      ),
      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
      next && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          eventKey: activePage + 1,
          disabled: activePage >= items
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'span',
          { 'aria-label': 'Next' },
          next === true ? '\u203A' : next
        )
      ),
      last && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          eventKey: items,
          disabled: activePage >= items
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'span',
          { 'aria-label': 'Last' },
          last === true ? '\xBB' : last
        )
      )
    );
  };

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsClass */])('pagination', Pagination));

/***/ }),
/* 3018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Collapse__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(106);














// TODO: Use uncontrollable.

var propTypes = {
  collapsible: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  header: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  footer: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  defaultExpanded: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  expanded: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  eventKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  headerRole: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  panelRole: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

  // From Collapse.
  onEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onEntering: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onEntered: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onExit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onExiting: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onExited: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
};

var defaultProps = {
  defaultExpanded: false
};

var Panel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Panel, _React$Component);

  function Panel(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Panel);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClickTitle = _this.handleClickTitle.bind(_this);

    _this.state = {
      expanded: _this.props.defaultExpanded
    };
    return _this;
  }

  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
    // FIXME: What the heck? This API is horrible. This needs to go away!
    e.persist();
    e.selected = true;

    if (this.props.onSelect) {
      this.props.onSelect(this.props.eventKey, e);
    } else {
      e.preventDefault();
    }

    if (e.selected) {
      this.setState({ expanded: !this.state.expanded });
    }
  };

  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
    var titleClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'title');

    if (!collapsible) {
      if (!__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(header)) {
        return header;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(header, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(header.props.className, titleClassName)
      });
    }

    if (!__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(header)) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'h4',
        { role: 'presentation', className: titleClassName },
        this.renderAnchor(header, id, role, expanded)
      );
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(header, {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(header.props.className, titleClassName),
      children: this.renderAnchor(header.props.children, id, role, expanded)
    });
  };

  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'a',
      {
        role: role,
        href: id && '#' + id,
        onClick: this.handleClickTitle,
        'aria-controls': id,
        'aria-expanded': expanded,
        'aria-selected': expanded,
        className: expanded ? null : 'collapsed'
      },
      header
    );
  };

  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__Collapse__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ 'in': expanded }, animationHooks),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        {
          id: id,
          role: role,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'collapse'),
          'aria-hidden': !expanded
        },
        this.renderBody(children, bsProps)
      )
    );
  };

  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
    var children = [];
    var bodyChildren = [];

    var bodyClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'body');

    function maybeAddBody() {
      if (!bodyChildren.length) {
        return;
      }

      // Derive the key from the index here, since we need to make one up.
      children.push(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { key: children.length, className: bodyClassName },
        bodyChildren
      ));

      bodyChildren = [];
    }

    // Convert to array so we can re-use keys.
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.toArray(rawChildren).forEach(function (child) {
      if (__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(child) && child.props.fill) {
        maybeAddBody();

        // Remove the child's unknown `fill` prop.
        children.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, { fill: undefined }));

        return;
      }

      bodyChildren.push(child);
    });

    maybeAddBody();

    return children;
  };

  Panel.prototype.render = function render() {
    var _props = this.props,
        collapsible = _props.collapsible,
        header = _props.header,
        id = _props.id,
        footer = _props.footer,
        propsExpanded = _props.expanded,
        headerRole = _props.headerRole,
        panelRole = _props.panelRole,
        className = _props.className,
        children = _props.children,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onExited = _props.onExited,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['defaultExpanded', 'eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes),
        id: collapsible ? null : id
      }),
      header && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'heading') },
        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
      ),
      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
      footer && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'footer') },
        footer
      )
    );
  };

  return Panel;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Panel.propTypes = propTypes;
Panel.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsClass */])('panel', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* bsStyles */])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* State */]), [__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].DEFAULT, Panel)));

/***/ }),
/* 3019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);












var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number])),

  /**
   * Sets the direction the Popover is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Popover.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Popover.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * The "top" position value for the Popover arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Popover arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * Title content
   */
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};

var defaultProps = {
  placement: 'right'
};

var Popover = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Popover, _React$Component);

  function Popover() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Popover);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Popover.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        title = _props.title,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      display: 'block',
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'tooltip',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        style: outerStyle
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'arrow', style: arrowStyle }),
      title && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'h3',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'title') },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content') },
        children
      )
    );
  };

  return Popover;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('popover', Popover));

/***/ }),
/* 3020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__ = __webpack_require__(116);














var ROUND_PRECISION = 1000;

/**
 * Validate that children, if any, are instances of `<ProgressBar>`.
 */
function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];
  if (!children) {
    return null;
  }

  var error = null;

  __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(children, function (child) {
    if (error) {
      return;
    }

    if (child.type === ProgressBar) {
      // eslint-disable-line no-use-before-define
      return;
    }

    var childIdentifier = __WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
  });

  return error;
}

var propTypes = {
  min: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  now: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  label: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  srOnly: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  children: onlyProgressBar,

  /**
   * @private
   */
  isChild: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};

var defaultProps = {
  min: 0,
  max: 100,
  active: false,
  isChild: false,
  srOnly: false,
  striped: false
};

function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

var ProgressBar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ProgressBar, _React$Component);

  function ProgressBar() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ProgressBar);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
    var _extends2;

    var min = _ref.min,
        now = _ref.now,
        max = _ref.max,
        label = _ref.label,
        srOnly = _ref.srOnly,
        striped = _ref.striped,
        active = _ref.active,
        className = _ref.className,
        style = _ref.style,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {
      active: active
    }, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'striped')] = active || striped, _extends2));

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'progressbar',
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes),
        style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ width: getPercentage(now, min, max) + '%' }, style),
        'aria-valuenow': now,
        'aria-valuemin': min,
        'aria-valuemax': max
      }),
      srOnly ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        label
      ) : label
    );
  };

  ProgressBar.prototype.render = function render() {
    var _props = this.props,
        isChild = _props.isChild,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['isChild']);

    if (isChild) {
      return this.renderProgressBar(props);
    }

    var min = props.min,
        now = props.now,
        max = props.max,
        label = props.label,
        srOnly = props.srOnly,
        striped = props.striped,
        active = props.active,
        bsClass = props.bsClass,
        bsStyle = props.bsStyle,
        className = props.className,
        children = props.children,
        wrapperProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, wrapperProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, 'progress')
      }),
      children ? __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, { isChild: true });
      }) : this.renderProgressBar({
        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
      })
    );
  };

  return ProgressBar;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

ProgressBar.propTypes = propTypes;
ProgressBar.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('progress-bar', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* State */]), ProgressBar)));

/***/ }),
/* 3021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);












var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Radio inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Radio = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Radio, _React$Component);

  function Radio() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Radio);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Radio.prototype.render = function render() {
    var _props = this.props,
        inline = _props.inline,
        disabled = _props.disabled,
        validationState = _props.validationState,
        inputRef = _props.inputRef,
        className = _props.className,
        style = _props.style,
        title = _props.title,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      ref: inputRef,
      type: 'radio',
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);

      // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.
       false ? warning(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, _classes), style: style, title: title },
        input,
        children
      );
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {
      disabled: disabled
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes), style: style },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { title: title },
        input,
        children
      )
    );
  };

  return Radio;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('radio', Radio));

/***/ }),
/* 3022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);












// TODO: This should probably take a single `aspectRatio` prop.

var propTypes = {
  /**
   * This component requires a single child element
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.element.isRequired,
  /**
   * 16by9 aspect ratio
   */
  a16by9: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * 4by3 aspect ratio
   */
  a4by3: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  a16by9: false,
  a4by3: false
};

var ResponsiveEmbed = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ResponsiveEmbed, _React$Component);

  function ResponsiveEmbed() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ResponsiveEmbed);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ResponsiveEmbed.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        a16by9 = _props.a16by9,
        a4by3 = _props.a4by3,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['a16by9', 'a4by3', 'className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
     false ? warning(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '16by9')] = a16by9, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '4by3')] = a4by3, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes) },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(children, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'item'))
      }))
    );
  };

  return ResponsiveEmbed;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ResponsiveEmbed.propTypes = propTypes;
ResponsiveEmbed.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('embed-responsive', ResponsiveEmbed));

/***/ }),
/* 3023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Row = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Row, _React$Component);

  function Row() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Row);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Row.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Row;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('row', Row));

/***/ }),
/* 3024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dropdown__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SplitToggle__ = __webpack_require__(3025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_splitComponentProps__ = __webpack_require__(396);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * The content of the split button.
   */
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  /**
   * Accessible label for the toggle; the value of `title` if not specified.
   */
  toggleLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
});

var SplitButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SplitButton, _React$Component);

  function SplitButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SplitButton);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  SplitButton.prototype.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        bsStyle = _props.bsStyle,
        title = _props.title,
        toggleLabel = _props.toggleLabel,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);

    var _splitComponentProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        buttonProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, {
        bsSize: bsSize,
        bsStyle: bsStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, buttonProps, {
          disabled: props.disabled,
          bsSize: bsSize,
          bsStyle: bsStyle
        }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SplitToggle__["a" /* default */], {
        'aria-label': toggleLabel || title,
        bsSize: bsSize,
        bsStyle: bsStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Menu,
        null,
        children
      )
    );
  };

  return SplitButton;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SplitButton.propTypes = propTypes;

SplitButton.Toggle = __WEBPACK_IMPORTED_MODULE_9__SplitToggle__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (SplitButton);

/***/ }),
/* 3025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DropdownToggle__ = __webpack_require__(1076);








var SplitToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SplitToggle, _React$Component);

  function SplitToggle() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SplitToggle);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  SplitToggle.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DropdownToggle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
      useAnchor: false,
      noCaret: false
    }));
  };

  return SplitToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

SplitToggle.defaultProps = __WEBPACK_IMPORTED_MODULE_5__DropdownToggle__["a" /* default */].defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (SplitToggle);

/***/ }),
/* 3026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TabContainer__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TabContent__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TabPane__ = __webpack_require__(1090);











var propTypes = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */].propTypes, {

  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,

  /**
   * tabClassName is used as className for the associated NavItem
   */
  tabClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
});

var Tab = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Tab, _React$Component);

  function Tab() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Tab);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tab.prototype.render = function render() {
    var props = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.props);

    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
    delete props.title;
    delete props.disabled;
    delete props.tabClassName;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */], props);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Tab.propTypes = propTypes;

Tab.Container = __WEBPACK_IMPORTED_MODULE_6__TabContainer__["a" /* default */];
Tab.Content = __WEBPACK_IMPORTED_MODULE_7__TabContent__["a" /* default */];
Tab.Pane = __WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (Tab);

/***/ }),
/* 3027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(39);











var propTypes = {
  striped: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  bordered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  condensed: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  bordered: false,
  condensed: false,
  hover: false,
  responsive: false,
  striped: false
};

var Table = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Table, _React$Component);

  function Table() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Table);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Table.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        striped = _props.striped,
        bordered = _props.bordered,
        condensed = _props.condensed,
        hover = _props.hover,
        responsive = _props.responsive,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'striped')] = striped, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'bordered')] = bordered, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'condensed')] = condensed, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'hover')] = hover, _extends2));

    var table = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('table', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));

    if (responsive) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'responsive') },
        table
      );
    }

    return table;
  };

  return Table;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('table', Table));

/***/ }),
/* 3028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Nav__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavItem__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TabContainer__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TabContent__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(116);

















var TabContainer = __WEBPACK_IMPORTED_MODULE_11__TabContainer__["a" /* default */].ControlledComponent;

var propTypes = {
  /**
   * Mark the Tab with a matching `eventKey` as active.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Navigation style
   */
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['tabs', 'pills']),

  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  id: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number])),

  /**
   * Callback fired when a Tab is selected.
   *
   * ```js
   * function (
   * 	Any eventKey,
   * 	SyntheticEvent event?
   * )
   * ```
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

var defaultProps = {
  bsStyle: 'tabs',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  var defaultActiveKey = void 0;
  __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });

  return defaultActiveKey;
}

var Tabs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tabs, _React$Component);

  function Tabs() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tabs);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tabs.prototype.renderTab = function renderTab(child) {
    var _child$props = child.props,
        title = _child$props.title,
        eventKey = _child$props.eventKey,
        disabled = _child$props.disabled,
        tabClassName = _child$props.tabClassName;

    if (title == null) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__NavItem__["a" /* default */],
      {
        eventKey: eventKey,
        disabled: disabled,
        className: tabClassName
      },
      title
    );
  };

  Tabs.prototype.render = function render() {
    var _props = this.props,
        id = _props.id,
        onSelect = _props.onSelect,
        animation = _props.animation,
        mountOnEnter = _props.mountOnEnter,
        unmountOnExit = _props.unmountOnExit,
        bsClass = _props.bsClass,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        _props$activeKey = _props.activeKey,
        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      TabContainer,
      {
        id: id,
        activeKey: activeKey,
        onSelect: onSelect,
        className: className,
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__Nav__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
            role: 'tablist'
          }),
          __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, this.renderTab)
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__TabContent__["a" /* default */],
          {
            bsClass: bsClass,
            animation: animation,
            mountOnEnter: mountOnEnter,
            unmountOnExit: unmountOnExit
          },
          children
        )
      )
    );
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_bootstrapUtils__["c" /* bsClass */])('tab', Tabs);

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(Tabs, { activeKey: 'onSelect' }));

/***/ }),
/* 3029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);












var propTypes = {
  /**
   * src property that is passed down to the image inside this component
   */
  src: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * alt property that is passed down to the image inside this component
   */
  alt: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * href property that is passed down to the image inside this component
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * onError callback that is passed down to the image inside this component
   */
  onError: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * onLoad callback that is passed down to the image inside this component
   */
  onLoad: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var Thumbnail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Thumbnail, _React$Component);

  function Thumbnail() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Thumbnail);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Thumbnail.prototype.render = function render() {
    var _props = this.props,
        src = _props.src,
        alt = _props.alt,
        onError = _props.onError,
        onLoad = _props.onLoad,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['src', 'alt', 'onError', 'onLoad', 'className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var Component = elementProps.href ? __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */] : 'div';
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { src: src, alt: alt, onError: onError, onLoad: onLoad }),
      children && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: 'caption' },
        children
      )
    );
  };

  return Thumbnail;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Thumbnail.propTypes = propTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('thumbnail', Thumbnail));

/***/ }),
/* 3030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_invariant__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ButtonGroup__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ToggleButton__ = __webpack_require__(1091);















var propTypes = {
  /**
   * An HTML `<input>` name for each child button.
   *
   * __Required if `type` is set to `'radio'`__
   */
  name: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * The value, or array of values, of the active (pressed) buttons
   *
   * @controllable onChange
   */
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,

  /**
   * Callback fired when a button is pressed, depending on whether the `type`
   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
   * array of active values
   *
   * @controllable values
   */
  onChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * The input `type` of the rendered buttons, determines the toggle behavior
   * of the buttons
   */
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['checkbox', 'radio']).isRequired
};

var defaultProps = {
  type: 'radio'
};

var ToggleButtonGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ToggleButtonGroup, _React$Component);

  function ToggleButtonGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ToggleButtonGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ToggleButtonGroup.prototype.getValues = function getValues() {
    var value = this.props.value;

    return value == null ? [] : [].concat(value);
  };

  ToggleButtonGroup.prototype.handleToggle = function handleToggle(value) {
    var _props = this.props,
        type = _props.type,
        onChange = _props.onChange;

    var values = this.getValues();
    var isActive = values.indexOf(value) !== -1;

    if (type === 'radio') {
      if (!isActive) {
        onChange(value);
      }
      return;
    }

    if (isActive) {
      onChange(values.filter(function (n) {
        return n !== value;
      }));
    } else {
      onChange([].concat(values, [value]));
    }
  };

  ToggleButtonGroup.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        children = _props2.children,
        type = _props2.type,
        name = _props2.name,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['children', 'type', 'name']);

    var values = this.getValues();

    !(type !== 'radio' || !!name) ?  false ? invariant(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : __WEBPACK_IMPORTED_MODULE_7_invariant___default()(false) : void 0;

    delete props.onChange;
    delete props.value;

    // the data attribute is required b/c twbs css uses it in the selector
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__ButtonGroup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { 'data-toggle': 'buttons' }),
      __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        var _child$props = child.props,
            value = _child$props.value,
            onChange = _child$props.onChange;

        var handler = function handler() {
          return _this2.handleToggle(value);
        };

        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
          type: type,
          name: child.name || name,
          checked: values.indexOf(value) !== -1,
          onChange: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onChange, handler)
        });
      })
    );
  };

  return ToggleButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ToggleButtonGroup.propTypes = propTypes;
ToggleButtonGroup.defaultProps = defaultProps;

var UncontrolledToggleButtonGroup = __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(ToggleButtonGroup, {
  value: 'onChange'
});

UncontrolledToggleButtonGroup.Button = __WEBPACK_IMPORTED_MODULE_12__ToggleButton__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledToggleButtonGroup);

/***/ }),
/* 3031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(39);












var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number])),

  /**
   * Sets the direction the Tooltip is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Tooltip.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Tooltip.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * The "top" position value for the Tooltip arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Tooltip arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string])
};

var defaultProps = {
  placement: 'right'
};

var Tooltip = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _React$Component);

  function Tooltip() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tooltip.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'tooltip',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        style: outerStyle
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'arrow'), style: arrowStyle }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inner') },
        children
      )
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('tooltip', Tooltip));

/***/ }),
/* 3032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(106);











var Well = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Well, _React$Component);

  function Well() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Well);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Well.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Well;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsClass */])('well', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["b" /* Size */].SMALL], Well)));

/***/ }),
/* 3033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types_extra_lib_utils_createChainableTypeChecker__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types_extra_lib_utils_createChainableTypeChecker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types_extra_lib_utils_createChainableTypeChecker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValidComponentChildren__ = __webpack_require__(116);
/* harmony export (immutable) */ __webpack_exports__["a"] = requiredRoles;
/* harmony export (immutable) */ __webpack_exports__["b"] = exclusiveRoles;




function requiredRoles() {
  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
    roles[_key] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_0_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var missing = void 0;

    roles.every(function (role) {
      if (!__WEBPACK_IMPORTED_MODULE_1__ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
        return child.props.bsRole === role;
      })) {
        missing = role;
        return false;
      }

      return true;
    });

    if (missing) {
      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
    }

    return null;
  });
}

function exclusiveRoles() {
  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    roles[_key2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_0_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var duplicate = void 0;

    roles.every(function (role) {
      var childrenWithRole = __WEBPACK_IMPORTED_MODULE_1__ValidComponentChildren__["a" /* default */].filter(props.children, function (child) {
        return child.props.bsRole === role;
      });

      if (childrenWithRole.length > 1) {
        duplicate = role;
        return false;
      }

      return true;
    });

    if (duplicate) {
      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
    }

    return null;
  });
}

/***/ }),
/* 3034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 *
 * This file contains a modified version of:
 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
 *
 * This source code is licensed under the BSD-style license found here:
 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
 * An additional grant of patent rights can be found here:
 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
 */

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * EVENT_NAME_MAP is used to determine which event fired when a
 * transition/animation ends, based on the style property used to
 * define that event.
 */
var EVENT_NAME_MAP = {
  transitionend: {
    'transition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd',
    'MozTransition': 'mozTransitionEnd',
    'OTransition': 'oTransitionEnd',
    'msTransition': 'MSTransitionEnd'
  },

  animationend: {
    'animation': 'animationend',
    'WebkitAnimation': 'webkitAnimationEnd',
    'MozAnimation': 'mozAnimationEnd',
    'OAnimation': 'oAnimationEnd',
    'msAnimation': 'MSAnimationEnd'
  }
};

var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are useable, and if not remove them
  // from the map
  if (!('AnimationEvent' in window)) {
    delete EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete EVENT_NAME_MAP.transitionend.transition;
  }

  for (var baseEventName in EVENT_NAME_MAP) {
    // eslint-disable-line guard-for-in
    var baseEvents = EVENT_NAME_MAP[baseEventName];
    for (var styleName in baseEvents) {
      if (styleName in style) {
        endEvents.push(baseEvents[styleName]);
        break;
      }
    }
  }
}

if (canUseDOM) {
  detectEvents();
}

// We use the raw {add|remove}EventListener() call because EventListener
// does not know how to remove event listeners and we really should
// clean up. Also, these events are not triggered in older browsers
// so we should be A-OK here.

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var ReactTransitionEvents = {
  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      // If CSS transitions are not supported, trigger an "end animation"
      // event immediately.
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ReactTransitionEvents);

/***/ }),
/* 3035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_warning__);
/* unused harmony export _resetWarned */






var warned = {};

function deprecationWarning(oldname, newname, link) {
  var message = void 0;

  if ((typeof oldname === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(oldname)) === 'object') {
    message = oldname.message;
  } else {
    message = oldname + ' is deprecated. Use ' + newname + ' instead.';

    if (link) {
      message += '\nYou can read more about it at ' + link;
    }
  }

  if (warned[message]) {
    return;
  }

   false ? warning(false, message) : void 0;
  warned[message] = true;
}

deprecationWarning.wrapper = function (Component) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return function (_Component) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeprecatedComponent, _Component);

    function DeprecatedComponent() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeprecatedComponent);

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
    }

    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
      deprecationWarning.apply(undefined, args);

      if (_Component.prototype.componentWillMount) {
        var _Component$prototype$;

        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          methodArgs[_key2] = arguments[_key2];
        }

        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
      }
    };

    return DeprecatedComponent;
  }(Component);
};

/* harmony default export */ __webpack_exports__["a"] = (deprecationWarning);

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 3036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootstrapUtils__ = __webpack_require__(39);
/* unused harmony reexport bootstrapUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__ = __webpack_require__(98);
/* unused harmony reexport createChainedFunction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__ = __webpack_require__(116);
/* unused harmony reexport ValidComponentChildren */







/***/ }),
/* 3037 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2478), __esModule: true };

/***/ }),
/* 3038 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2480), __esModule: true };

/***/ }),
/* 3039 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2482), __esModule: true };

/***/ }),
/* 3040 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2484), __esModule: true };

/***/ }),
/* 3041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2485), __esModule: true };

/***/ }),
/* 3042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 3043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 3044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(3042);
var invariant = __webpack_require__(3043);
var ReactPropTypesSecret = __webpack_require__(3045);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 3045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 3046 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(3048), __webpack_require__(2476));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "clipboard"], factory);
	else if(typeof exports === 'object')
		exports["ReactClipboard"] = factory(require("react"), require("prop-types"), require("clipboard"));
	else
		root["ReactClipboard"] = factory(root["React"], root["PropTypes"], root["ClipboardJS"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClipboardButton = function (_React$Component) {
  _inherits(ClipboardButton, _React$Component);

  function ClipboardButton() {
    _classCallCheck(this, ClipboardButton);

    return _possibleConstructorReturn(this, (ClipboardButton.__proto__ || Object.getPrototypeOf(ClipboardButton)).apply(this, arguments));
  }

  _createClass(ClipboardButton, [{
    key: 'propsWith',


    /* Returns a object with all props that fulfill a certain naming pattern
     *
     * @param {RegExp} regexp - Regular expression representing which pattern
     *                          you'll be searching for.
     * @param {Boolean} remove - Determines if the regular expression should be
     *                           removed when transmitting the key from the props
     *                           to the new object.
     *
     * e.g:
     *
     * // Considering:
     * // this.props = {option-foo: 1, onBar: 2, data-foobar: 3 data-baz: 4};
     *
     * // *RegExps not using // so that this comment doesn't break up
     * this.propsWith(option-*, true); // returns {foo: 1}
     * this.propsWith(on*, true); // returns {Bar: 2}
     * this.propsWith(data-*); // returns {data-foobar: 1, data-baz: 4}
     */
    value: function propsWith(regexp) {
      var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var object = {};

      Object.keys(this.props).forEach(function (key) {
        if (key.search(regexp) !== -1) {
          var objectKey = remove ? key.replace(regexp, '') : key;
          object[objectKey] = this.props[key];
        }
      }, this);

      return object;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clipboard && this.clipboard.destroy();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Support old API by trying to assign this.props.options first;
      var options = this.props.options || this.propsWith(/^option-/, true);
      var element = _react2.default.version.match(/0\.13(.*)/) ? this.refs.element.getDOMNode() : this.element;
      var Clipboard = __webpack_require__(3);
      this.clipboard = new Clipboard(element, options);

      var callbacks = this.propsWith(/^on/, true);
      Object.keys(callbacks).forEach(function (callback) {
        this.clipboard.on(callback.toLowerCase(), this.props['on' + callback]);
      }, this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var attributes = _extends({
        type: this.getType(),
        className: this.props.className || '',
        style: this.props.style || {},
        ref: function ref(element) {
          _this2.element = element;
        },
        onClick: this.props.onClick
      }, this.propsWith(/^data-/), this.propsWith(/^button-/, true));

      return _react2.default.createElement(this.getComponent(), attributes, this.props.children);
    }
  }, {
    key: 'getType',
    value: function getType() {
      if (this.getComponent() === 'button' || this.getComponent() === 'input') {
        return this.props.type || 'button';
      } else {
        return undefined;
      }
    }
  }, {
    key: 'getComponent',
    value: function getComponent() {
      return this.props.component || 'button';
    }
  }]);

  return ClipboardButton;
}(_react2.default.Component);

ClipboardButton.propTypes = {
  options: function options(props, propName, componentName) {
    var options = props[propName];
    if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object' || Array.isArray(options)) {
      return new Error('Invalid props \'' + propName + '\' supplied to \'' + componentName + '\'. ' + ('\'' + propName + '\' is not an object.'));
    }

    if (props['option-text'] !== undefined) {
      var optionText = props['option-text'];
      if (typeof optionText !== 'function') {
        return new Error('Invalid props \'option-text\' supplied to \'' + componentName + '\'. ' + '\'option-text\' is not a function.');
      }
    }
  },
  type: _propTypes2.default.string,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  component: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element), _propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object])
};
ClipboardButton.defaultProps = {
  onClick: function onClick() {} };
exports.default = ClipboardButton;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ })
/******/ ]);
});

/***/ }),
/* 3047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(3049);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 3048 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(3047)();
}


/***/ }),
/* 3049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 3050 */,
/* 3051 */,
/* 3052 */,
/* 3053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 3054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _offset = __webpack_require__(295);

var _offset2 = _interopRequireDefault(_offset);

var _requestAnimationFrame = __webpack_require__(880);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(399);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _Affix = __webpack_require__(1095);

var _Affix2 = _interopRequireDefault(_Affix);

var _addEventListener = __webpack_require__(397);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _getContainer = __webpack_require__(398);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _getDocumentHeight = __webpack_require__(1099);

var _getDocumentHeight2 = _interopRequireDefault(_getDocumentHeight);

var _ownerDocument = __webpack_require__(235);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _ownerWindow = __webpack_require__(1101);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<AutoAffix/>` component wraps `<Affix/>` to automatically calculate
 * offsets in many common cases.
 */
var AutoAffix = function (_React$Component) {
  _inherits(AutoAffix, _React$Component);

  function AutoAffix(props, context) {
    _classCallCheck(this, AutoAffix);

    var _this = _possibleConstructorReturn(this, (AutoAffix.__proto__ || Object.getPrototypeOf(AutoAffix)).call(this, props, context));

    _this.onWindowScroll = function () {
      _this.onUpdate();
    };

    _this.onWindowResize = function () {
      if (_this.props.autoWidth) {
        (0, _requestAnimationFrame2.default)(function () {
          return _this.onUpdate();
        });
      }
    };

    _this.onDocumentClick = function () {
      (0, _requestAnimationFrame2.default)(function () {
        return _this.onUpdate();
      });
    };

    _this.onUpdate = function () {
      if (!_this._isMounted) {
        return;
      }

      var _getOffset = (0, _offset2.default)(_this.refs.positioner);

      var offsetTop = _getOffset.top;
      var width = _getOffset.width;


      var container = (0, _getContainer2.default)(_this.props.container);
      var offsetBottom = void 0;
      if (container) {
        var documentHeight = (0, _getDocumentHeight2.default)((0, _ownerDocument2.default)(_this));

        var _getOffset2 = (0, _offset2.default)(container);

        var top = _getOffset2.top;
        var height = _getOffset2.height;

        offsetBottom = documentHeight - top - height;
      } else {
        offsetBottom = null;
      }

      _this.updateState(offsetTop, offsetBottom, width);
    };

    _this.updateState = function (offsetTop, offsetBottom, width) {
      if (offsetTop === _this.state.offsetTop && offsetBottom === _this.state.offsetBottom && width === _this.state.width) {
        return;
      }

      _this.setState({ offsetTop: offsetTop, offsetBottom: offsetBottom, width: width });
    };

    _this.state = {
      offsetTop: null,
      offsetBottom: null,
      width: null
    };
    return _this;
  }

  _createClass(AutoAffix, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;

      this._windowScrollListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'scroll', function () {
        return _this2.onWindowScroll();
      });

      this._windowResizeListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'resize', function () {
        return _this2.onWindowResize();
      });

      this._documentClickListener = (0, _addEventListener2.default)((0, _ownerDocument2.default)(this), 'click', function () {
        return _this2.onDocumentClick();
      });

      this.onUpdate();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this._needPositionUpdate = true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this._needPositionUpdate) {
        this._needPositionUpdate = false;
        this.onUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;

      if (this._windowScrollListener) {
        this._windowScrollListener.remove();
      }
      if (this._documentClickListener) {
        this._documentClickListener.remove();
      }
      if (this._windowResizeListener) {
        this._windowResizeListener.remove();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var autoWidth = _props.autoWidth;
      var viewportOffsetTop = _props.viewportOffsetTop;
      var children = _props.children;

      var props = _objectWithoutProperties(_props, ['autoWidth', 'viewportOffsetTop', 'children']);

      var _state = this.state;
      var offsetTop = _state.offsetTop;
      var offsetBottom = _state.offsetBottom;
      var width = _state.width;


      delete props.container;

      var effectiveOffsetTop = Math.max(offsetTop, viewportOffsetTop || 0);

      var _props2 = this.props;
      var affixStyle = _props2.affixStyle;
      var bottomStyle = _props2.bottomStyle;

      if (autoWidth) {
        affixStyle = _extends({ width: width }, affixStyle);
        bottomStyle = _extends({ width: width }, bottomStyle);
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { ref: 'positioner' }),
        _react2.default.createElement(
          _Affix2.default,
          _extends({}, props, {
            offsetTop: effectiveOffsetTop,
            viewportOffsetTop: viewportOffsetTop,
            offsetBottom: offsetBottom,
            affixStyle: affixStyle,
            bottomStyle: bottomStyle
          }),
          children
        )
      );
    }
  }]);

  return AutoAffix;
}(_react2.default.Component);

AutoAffix.propTypes = _extends({}, _Affix2.default.propTypes, {
  /**
   * The logical container node or component for determining offset from bottom
   * of viewport, or a function that returns it
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Automatically set width when affixed
   */
  autoWidth: _propTypes2.default.bool
});

// This intentionally doesn't inherit default props from `<Affix>`, so that the
// auto-calculated offsets can apply.
AutoAffix.defaultProps = {
  viewportOffsetTop: 0,
  autoWidth: true
};

exports.default = AutoAffix;
module.exports = exports['default'];

/***/ }),
/* 3055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(373);

var _style2 = _interopRequireDefault(_style);

var _class = __webpack_require__(2726);

var _class2 = _interopRequireDefault(_class);

var _scrollbarSize = __webpack_require__(881);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(1100);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(3059);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function findIndexOf(arr, cb) {
  var idx = -1;
  arr.some(function (d, i) {
    if (cb(d, i)) {
      idx = i;
      return true;
    }
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (d) {
    return d.modals.indexOf(modal) !== -1;
  });
}

function setContainerStyle(state, container) {
  var style = { overflow: 'hidden' };

  // we are only interested in the actual `style` here
  // becasue we will override it
  state.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (state.overflowing) {
    // use computed style, here to get the real padding
    // to add our scrollbar width
    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
  }

  (0, _style2.default)(container, style);
}

function removeContainerStyle(_ref, container) {
  var style = _ref.style;


  Object.keys(style).forEach(function (key) {
    return container.style[key] = style[key];
  });
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function ModalManager() {
  var _this = this;

  var _ref2 = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var _ref2$hideSiblingNode = _ref2.hideSiblingNodes;
  var hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode;
  var _ref2$handleContainer = _ref2.handleContainerOverflow;
  var handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;

  _classCallCheck(this, ModalManager);

  this.add = function (modal, container, className) {
    var modalIdx = _this.modals.indexOf(modal);
    var containerIdx = _this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = _this.modals.length;
    _this.modals.push(modal);

    if (_this.hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
    }

    if (containerIdx !== -1) {
      _this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      //right now only the first modal of a container will have its classes applied
      classes: className ? className.split(/\s+/) : [],

      overflowing: (0, _isOverflowing2.default)(container)
    };

    if (_this.handleContainerOverflow) {
      setContainerStyle(data, container);
    }

    data.classes.forEach(_class2.default.addClass.bind(null, container));

    _this.containers.push(container);
    _this.data.push(data);

    return modalIdx;
  };

  this.remove = function (modal) {
    var modalIdx = _this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    var containerIdx = findContainer(_this.data, modal);
    var data = _this.data[containerIdx];
    var container = _this.containers[containerIdx];

    data.modals.splice(data.modals.indexOf(modal), 1);

    _this.modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (data.modals.length === 0) {
      data.classes.forEach(_class2.default.removeClass.bind(null, container));

      if (_this.handleContainerOverflow) {
        removeContainerStyle(data, container);
      }

      if (_this.hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
      }
      _this.containers.splice(containerIdx, 1);
      _this.data.splice(containerIdx, 1);
    } else if (_this.hideSiblingNodes) {
      //otherwise make sure the next top modal is visible to a SR
      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
    }
  };

  this.isTopModal = function (modal) {
    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
  };

  this.hideSiblingNodes = hideSiblingNodes;
  this.handleContainerOverflow = handleContainerOverflow;
  this.modals = [];
  this.containers = [];
  this.data = [];
};

exports.default = ModalManager;
module.exports = exports['default'];

/***/ }),
/* 3056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RootCloseWrapper = exports.Transition = exports.Position = exports.Portal = exports.Overlay = exports.Modal = exports.AutoAffix = exports.Affix = undefined;

var _Affix2 = __webpack_require__(1095);

var _Affix3 = _interopRequireDefault(_Affix2);

var _AutoAffix2 = __webpack_require__(3054);

var _AutoAffix3 = _interopRequireDefault(_AutoAffix2);

var _Modal2 = __webpack_require__(1096);

var _Modal3 = _interopRequireDefault(_Modal2);

var _Overlay2 = __webpack_require__(1097);

var _Overlay3 = _interopRequireDefault(_Overlay2);

var _Portal2 = __webpack_require__(586);

var _Portal3 = _interopRequireDefault(_Portal2);

var _Position2 = __webpack_require__(1098);

var _Position3 = _interopRequireDefault(_Position2);

var _Transition2 = __webpack_require__(588);

var _Transition3 = _interopRequireDefault(_Transition2);

var _RootCloseWrapper2 = __webpack_require__(587);

var _RootCloseWrapper3 = _interopRequireDefault(_RootCloseWrapper2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Affix = _Affix3.default;
exports.AutoAffix = _AutoAffix3.default;
exports.Modal = _Modal3.default;
exports.Overlay = _Overlay3.default;
exports.Portal = _Portal3.default;
exports.Position = _Position3.default;
exports.Transition = _Transition3.default;
exports.RootCloseWrapper = _RootCloseWrapper3.default;

/***/ }),
/* 3057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addFocusListener;
/**
 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
 *
 * We only allow one Listener at a time to avoid stack overflows
 */
function addFocusListener(handler) {
  var useFocusin = !document.addEventListener;
  var remove = void 0;

  if (useFocusin) {
    document.attachEvent('onfocusin', handler);
    remove = function remove() {
      return document.detachEvent('onfocusin', handler);
    };
  } else {
    document.addEventListener('focus', handler, true);
    remove = function remove() {
      return document.removeEventListener('focus', handler, true);
    };
  }

  return { remove: remove };
}
module.exports = exports['default'];

/***/ }),
/* 3058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calculatePosition;

var _offset = __webpack_require__(295);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(2733);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(545);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(235);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode);

  var overlayHeight = _getOffset2.height;
  var overlayWidth = _getOffset2.width;


  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 3059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;

var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType;
  var tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, mount, cb) {
  mount = [].concat(mount);

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 3060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
  return _react2.default.createElement(
    'button',
    { type: 'button', onClick: function onClick() {
        return props.onClick();
      }, className: 'rrt-button ' + props.className },
    props.children
  );
};

Button.displayName = 'ReduxConfirmButton';

exports.default = Button;

/***/ }),
/* 3061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = __webpack_require__(3066);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Icon = function (_React$Component) {
  _inherits(Icon, _React$Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Icon.prototype.render = function render() {
    var size = this.props.size;

    var styles = {
      width: size,
      height: size
    };

    return _react2.default.createElement(
      'svg',
      {
        className: (0, _classnames2.default)(this.props.className, 'toastr-icon'),
        xmlns: 'http://www.w3.org/2000/svg',
        preserveAspectRatio: 'xMidYMid meet',
        viewBox: '0 0 ' + this.props.size + ' ' + this.props.size,
        style: styles
      },
      (0, _icons2.default)(this.props.name)
    );
  };

  return Icon;
}(_react2.default.Component);

Icon.displayName = 'ReduxToastrIcon';
Icon.defaultProps = {
  size: 32
};
exports.default = Icon;

/***/ }),
/* 3062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(400);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var ProgressBar = function (_React$Component) {
  _inherits(ProgressBar, _React$Component);

  function ProgressBar(props) {
    _classCallCheck(this, ProgressBar);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = { percent: 100 };
    _this.intervalId = null;
    return _this;
  }

  ProgressBar.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var distance = 100 / (this.props.duration / 10);
    this.intervalId = setInterval(function () {
      var percent = _this2.state.percent - distance;

      _this2.setState({ percent: percent > 0 ? percent : 0 });
    }, 10);
  };

  ProgressBar.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.state.percent <= 0 && this.intervalId) {
      clearTimeout(this.intervalId);
    }
  };

  ProgressBar.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.intervalId) {
      clearTimeout(this.intervalId);
    }
  };

  ProgressBar.prototype.render = function render() {
    var percent = this.state.percent;


    return _react2.default.createElement(
      'div',
      { className: 'rrt-progress-container' },
      _react2.default.createElement('div', { className: 'rrt-progressbar', style: { width: percent + '%' } })
    );
  };

  return ProgressBar;
}(_react2.default.Component);

ProgressBar.displayName = 'ProgressBar';
ProgressBar.propTypes = {
  duration: _propTypes2.default.number.isRequired
};
exports.default = ProgressBar;

/***/ }),
/* 3063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReduxToastr = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(400);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(3);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _ToastrBox = __webpack_require__(3064);

var _ToastrBox2 = _interopRequireDefault(_ToastrBox);

var _ToastrConfirm = __webpack_require__(3065);

var _ToastrConfirm2 = _interopRequireDefault(_ToastrConfirm);

var _actions = __webpack_require__(1104);

var actions = _interopRequireWildcard(_actions);

var _toastrEmitter = __webpack_require__(1106);

var _utils = __webpack_require__(261);

var _constants = __webpack_require__(590);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var ReduxToastr = exports.ReduxToastr = function (_React$Component) {
  _inherits(ReduxToastr, _React$Component);

  function ReduxToastr(props) {
    _classCallCheck(this, ReduxToastr);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.toastrFired = {};
    _this.toastrPositions = ['top-left', 'top-right', 'top-center', 'bottom-left', 'bottom-right', 'bottom-center'];

    (0, _utils.updateConfig)(props);
    return _this;
  }

  ReduxToastr.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        add = _props.add,
        showConfirm = _props.showConfirm,
        clean = _props.clean,
        removeByType = _props.removeByType;

    _toastrEmitter.EE.on('toastr/confirm', showConfirm);
    _toastrEmitter.EE.on('add/toastr', add);
    _toastrEmitter.EE.on('clean/toastr', clean);
    _toastrEmitter.EE.on('removeByType/toastr', removeByType);
  };

  ReduxToastr.prototype.componentWillUnmount = function componentWillUnmount() {
    _toastrEmitter.EE.removeListener('toastr/confirm');
    _toastrEmitter.EE.removeListener('add/toastr');
    _toastrEmitter.EE.removeListener('clean/toastr');
    _toastrEmitter.EE.removeListener('removeByType/toastr');
    this.toastrFired = {};
  };

  ReduxToastr.prototype._addToMemory = function _addToMemory(id) {
    this.toastrFired[id] = true;
  };

  ReduxToastr.prototype._renderToastrForPosition = function _renderToastrForPosition(position) {
    var _this2 = this;

    var toastrs = this.props.toastr.toastrs;


    if (toastrs) {
      return toastrs.filter(function (item) {
        return item.position === position;
      }).map(function (item) {
        var mergedItem = _extends({}, item, {
          options: _extends({
            progressBar: _this2.props.progressBar,
            transitionIn: _this2.props.transitionIn,
            transitionOut: _this2.props.transitionOut
          }, item.options)
        });

        return _react2.default.createElement(
          'span',
          { key: item.id },
          _react2.default.createElement(_ToastrBox2.default, _extends({
            inMemory: _this2.toastrFired,
            addToMemory: function addToMemory() {
              return _this2._addToMemory(item.id);
            },
            item: mergedItem
          }, _this2.props)),
          item.options && item.options.attention && _react2.default.createElement('div', { onClick: function onClick() {
              return _this2.props.remove(item.id);
            }, className: 'toastr-attention' })
        );
      });
    }
  };

  ReduxToastr.prototype._renderToastrs = function _renderToastrs() {
    var _this3 = this;

    var toastr = this.props.toastr;

    var width = toastr.toastrs && toastr.toastrs[0] && toastr.toastrs[0].options && toastr.toastrs[0].options.width;
    var style = width ? { width: width } : {};
    return _react2.default.createElement(
      'span',
      null,
      this.toastrPositions.map(function (position) {
        return _react2.default.createElement(
          'div',
          { key: position, className: position, style: style },
          _this3._renderToastrForPosition(position)
        );
      })
    );
  };

  ReduxToastr.prototype.render = function render() {
    var _props2 = this.props,
        className = _props2.className,
        toastr = _props2.toastr;

    return _react2.default.createElement(
      'span',
      { className: (0, _classnames2.default)('redux-toastr', className), 'aria-live': 'assertive' },
      toastr.confirm && _react2.default.createElement(_ToastrConfirm2.default, _extends({
        confirm: toastr.confirm
      }, this.props)),
      this._renderToastrs()
    );
  };

  return ReduxToastr;
}(_react2.default.Component);

ReduxToastr.displayName = 'ReduxToastr';
ReduxToastr.propTypes = {
  toastr: _propTypes2.default.object,
  position: _propTypes2.default.string,
  newestOnTop: _propTypes2.default.bool,
  timeOut: _propTypes2.default.number,
  confirmOptions: _propTypes2.default.object,
  progressBar: _propTypes2.default.bool,
  transitionIn: _propTypes2.default.oneOf(_constants.TRANSITIONS.in),
  transitionOut: _propTypes2.default.oneOf(_constants.TRANSITIONS.out),
  preventDuplicates: _propTypes2.default.bool
};
ReduxToastr.defaultProps = {
  position: 'top-right',
  newestOnTop: true,
  timeOut: 5000,
  progressBar: false,
  transitionIn: _constants.TRANSITIONS.in[0],
  transitionOut: _constants.TRANSITIONS.out[0],
  preventDuplicates: false,
  confirmOptions: {
    okText: 'ok',
    cancelText: 'cancel'
  }
};
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    toastr: state.toastr ? state.toastr : state.get('toastr')
  };
}, actions)(ReduxToastr);

/***/ }),
/* 3064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(400);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _ProgressBar = __webpack_require__(3062);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Icon = __webpack_require__(3061);

var _Icon2 = _interopRequireDefault(_Icon);

var _utils = __webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); } //  eslint-disable-line no-unused-vars


var ToastrBox = function (_React$Component) {
  _inherits(ToastrBox, _React$Component);

  function ToastrBox(props) {
    _classCallCheck(this, ToastrBox);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    var _props$item$options = props.item.options,
        transitionIn = _props$item$options.transitionIn,
        transitionOut = _props$item$options.transitionOut;


    _this.isHiding = false;
    _this.shouldClose = false;
    _this.intervalId = null;
    _this.ignoreIsHiding = false;

    _this.transitionIn = transitionIn || _this.props.transitionIn;
    _this.transitionOut = transitionOut || _this.props.transitionOut;

    _this.state = { progressBar: null };

    (0, _utils._bind)(['renderSubComponent', 'renderIcon', 'renderToastr', 'renderCloseButton', 'renderMessage', '_onAnimationComplete', '_removeToastr', '_setTransition', '_clearTransition', '_setIntervalId', '_setIsHiding', '_setShouldClose'], _this);
    return _this;
  }

  ToastrBox.prototype.componentDidMount = function componentDidMount() {
    var item = this.props.item;

    if (this.props.inMemory[item.id]) return;

    var timeOut = this._getItemTimeOut();

    if (timeOut) {
      this._setIntervalId(setTimeout(this._removeToastr, timeOut));
    }

    if (timeOut && item.options.progressBar) {
      this.setState({ progressBar: { duration: this._getItemTimeOut() } });
    }

    this._setTransition();
    (0, _utils.onCSSTransitionEnd)(this.toastrBoxElement, this._onAnimationComplete);
    this.props.addToMemory(item.id);
  };

  ToastrBox.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.intervalId) {
      clearTimeout(this.intervalId);
    }
  };

  ToastrBox.prototype.handleClick = function handleClick() {
    var onCloseButtonClick = this.props.item.options.onCloseButtonClick;

    this.ignoreIsHiding = true;

    if (onCloseButtonClick) {
      onCloseButtonClick();
    }

    this._setShouldClose(true);
    this._removeToastr();
  };

  ToastrBox.prototype.mouseEnter = function mouseEnter() {
    clearTimeout(this.intervalId);

    this._setIntervalId(null);
    this._setIsHiding(false);

    var progressBar = this.props.item.options.progressBar;

    var timeOut = this._getItemTimeOut();

    if (timeOut && progressBar) {
      this.setState({ progressBar: null });
    }
  };

  ToastrBox.prototype.mouseLeave = function mouseLeave() {
    var removeOnHover = this.props.item.options.removeOnHover;


    if (!this.isHiding && (removeOnHover || this.shouldClose)) {
      var interval = removeOnHover === true ? 1000 : removeOnHover;
      this._setIntervalId(setTimeout(this._removeToastr, interval));

      var progressBar = this.props.item.options.progressBar;

      var timeOut = this._getItemTimeOut();

      if (timeOut && progressBar) {
        this.setState({ progressBar: { duration: interval } });
      }
    }
  };

  ToastrBox.prototype.renderSubComponent = function renderSubComponent() {
    var _this2 = this;

    var _props$item = this.props.item,
        id = _props$item.id,
        options = _props$item.options;


    var removeCurrentToastrFunc = function removeCurrentToastrFunc() {
      return _this2.props.remove(id);
    };

    if ((0, _react.isValidElement)(options.component)) {
      return _react2.default.cloneElement(options.component, {
        remove: removeCurrentToastrFunc
      });
    }

    return _react2.default.createElement(options.component, { remove: removeCurrentToastrFunc });
  };

  ToastrBox.prototype.renderIcon = function renderIcon() {
    var _props$item2 = this.props.item,
        type = _props$item2.type,
        options = _props$item2.options;


    if ((0, _react.isValidElement)(options.icon)) {
      return _react2.default.cloneElement(options.icon);
    }

    var iconName = type === 'light' ? options.icon : type;
    return _react2.default.createElement(_Icon2.default, { name: iconName });
  };

  ToastrBox.prototype.renderCloseButton = function renderCloseButton() {
    return _react2.default.createElement(
      'button',
      {
        type: 'button',
        className: 'close-toastr',
        onClick: this.handleClick.bind(this)
      },
      '\u2715'
    );
  };

  ToastrBox.prototype.renderToastr = function renderToastr() {
    var _props$item3 = this.props.item,
        type = _props$item3.type,
        options = _props$item3.options,
        message = _props$item3.message,
        title = _props$item3.title;


    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: 'rrt-left-container' },
        _react2.default.createElement(
          'div',
          { className: 'rrt-holder' },
          this.renderIcon()
        )
      ),
      options.status && type === 'light' && _react2.default.createElement('div', { className: (0, _classnames2.default)('toastr-status', options.status) }),
      _react2.default.createElement(
        'div',
        { className: 'rrt-middle-container' },
        title && _react2.default.createElement(
          'div',
          { className: 'rrt-title' },
          title
        ),
        message && _react2.default.createElement(
          'div',
          { className: 'rrt-text' },
          message
        ),
        options.component && this.renderSubComponent()
      ),
      _react2.default.createElement(
        'div',
        { className: 'rrt-right-container' },
        options.showCloseButton && this.renderCloseButton()
      ),
      this.state.progressBar ? _react2.default.createElement(_ProgressBar2.default, this.state.progressBar) : null
    );
  };

  ToastrBox.prototype.renderMessage = function renderMessage() {
    var _props$item4 = this.props.item,
        title = _props$item4.title,
        message = _props$item4.message,
        options = _props$item4.options;


    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: 'rrt-title' },
        title,
        this.renderCloseButton()
      ),
      _react2.default.createElement(
        'div',
        { className: 'rrt-text' },
        message,
        options.component && this.renderSubComponent()
      )
    );
  };

  ToastrBox.prototype.toastr = function toastr() {
    if (this.props.item.type === 'message') {
      return this.renderMessage();
    }

    return this.renderToastr();
  };

  ToastrBox.prototype._getItemTimeOut = function _getItemTimeOut() {
    var item = this.props.item;
    var timeOut = item.options.timeOut;

    if (typeof timeOut === 'undefined') {
      timeOut = this.props.timeOut;
    }

    return timeOut;
  };

  ToastrBox.prototype._onAnimationComplete = function _onAnimationComplete() {
    var _props = this.props,
        remove = _props.remove,
        item = _props.item;
    var options = item.options,
        id = item.id;


    if (this.isHiding || this.ignoreIsHiding) {
      this._setIsHiding(false);
      this.ignoreIsHiding = false;
      remove(id);
      if (options.onHideComplete) {
        options.onHideComplete();
      }
    } else if (!this.isHiding && options.onShowComplete) {
      options.onShowComplete();
    }
  };

  ToastrBox.prototype._removeToastr = function _removeToastr() {
    if (!this.isHiding) {
      this._setIsHiding(true);
      this._setTransition(true);
      (0, _utils.onCSSTransitionEnd)(this.toastrBoxElement, this._onAnimationComplete);
    }
  };

  ToastrBox.prototype._setTransition = function _setTransition(hide) {
    var _this3 = this;

    var animationType = hide ? this.transitionOut : this.transitionIn;

    var onEndListener = function onEndListener(e) {
      if (e && e.target == _this3.toastrBoxElement) {
        _this3.toastrBoxElement.classList.remove(animationType);
      }
    };

    (0, _utils.onCSSTransitionEnd)(this.toastrBoxElement, onEndListener);
    this.toastrBoxElement.classList.add(animationType);
  };

  ToastrBox.prototype._clearTransition = function _clearTransition() {
    this.toastrBoxElement.classList.remove(this.transitionIn, this.transitionOut);
  };

  ToastrBox.prototype._setIntervalId = function _setIntervalId(intervalId) {
    this.intervalId = intervalId;
  };

  ToastrBox.prototype._setIsHiding = function _setIsHiding(val) {
    this.isHiding = val;
  };

  ToastrBox.prototype._setShouldClose = function _setShouldClose(val) {
    this.shouldClose = val;
  };

  ToastrBox.prototype.render = function render() {
    var _this4 = this;

    var _props$item5 = this.props.item,
        options = _props$item5.options,
        type = _props$item5.type;


    return _react2.default.createElement(
      'div',
      {
        ref: function ref(_ref) {
          return _this4.toastrBoxElement = _ref;
        },
        className: (0, _classnames2.default)('toastr', 'animated', 'rrt-' + type, options.className),
        onMouseEnter: this.mouseEnter.bind(this),
        onMouseLeave: this.mouseLeave.bind(this)
      },
      this.toastr()
    );
  };

  return ToastrBox;
}(_react2.default.Component);

ToastrBox.displayName = 'ToastrBox';
ToastrBox.propTypes = {
  item: _propTypes2.default.shape({
    options: _propTypes2.default.shape({
      transitionIn: _propTypes2.default.string,
      transitionOut: _propTypes2.default.string
    })
  })
};
exports.default = ToastrBox;

/***/ }),
/* 3065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(400);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(261);

var _Button = __webpack_require__(3060);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var ENTER = 13;
var ESC = 27;

var ToastrConfirm = function (_React$Component) {
  _inherits(ToastrConfirm, _React$Component);

  function ToastrConfirm(props) {
    _classCallCheck(this, ToastrConfirm);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    var _this$props = _this.props,
        confirmOptions = _this$props.confirmOptions,
        confirm = _this$props.confirm;
    var _confirm$options = confirm.options,
        okText = _confirm$options.okText,
        cancelText = _confirm$options.cancelText,
        transitionIn = _confirm$options.transitionIn,
        transitionOut = _confirm$options.transitionOut,
        disableCancel = _confirm$options.disableCancel;


    _this.okText = okText || confirmOptions.okText;
    _this.cancelText = cancelText || confirmOptions.cancelText;
    _this.transitionIn = transitionIn || confirmOptions.transitionIn || props.transitionIn;
    _this.transitionOut = transitionOut || confirmOptions.transitionOut || props.transitionOut;
    _this.disableCancel = disableCancel || confirmOptions.disableCancel;
    (0, _utils._bind)('setTransition removeConfirm handleOnKeyUp handleOnKeyDown', _this);
    _this.isKeyDown = false;
    return _this;
  }

  ToastrConfirm.prototype.componentDidMount = function componentDidMount() {
    this.isHiding = false;
    this.hasClicked = false;
    this.confirmHolderElement.focus();

    if (this.props.confirm.show) {
      this.setTransition(true);
    }
  };

  ToastrConfirm.prototype.handleOnKeyDown = function handleOnKeyDown(e) {
    if ((0, _utils.keyCode)(e) == ENTER) {
      e.preventDefault();
    }
    this.isKeyDown = true;
  };

  ToastrConfirm.prototype.handleButtonClick = function handleButtonClick(callback) {
    var _this2 = this;

    if (this.hasClicked) return;
    this.hasClicked = true;

    var onAnimationEnd = function onAnimationEnd() {
      _this2.removeConfirm();
      if (callback) {
        callback();
      }
    };

    this.setTransition();
    (0, _utils.onCSSTransitionEnd)(this.confirmElement, onAnimationEnd);
  };

  ToastrConfirm.prototype.handleConfirmClick = function handleConfirmClick() {
    var callback = this.props.confirm.options ? this.props.confirm.options.onOk : null;
    this.handleButtonClick(callback);
  };

  ToastrConfirm.prototype.handleCancelClick = function handleCancelClick() {
    var callback = this.props.confirm.options ? this.props.confirm.options.onCancel : null;
    this.handleButtonClick(callback);
  };

  ToastrConfirm.prototype.setTransition = function setTransition(add) {
    if (add) {
      this.isHiding = false;
      this.confirmElement.classList.add(this.transitionIn);
      if ((0, _utils.isBrowser)()) return document.querySelector('body').classList.add('toastr-confirm-active');
    }

    this.isHiding = true;
    this.confirmElement.classList.remove(this.transitionIn);
    this.confirmElement.classList.add(this.transitionOut);
  };

  ToastrConfirm.prototype.removeConfirm = function removeConfirm() {
    this.isHiding = false;
    this.props.hideConfirm();
    if ((0, _utils.isBrowser)()) return document.querySelector('body').classList.remove('toastr-confirm-active');
  };

  ToastrConfirm.prototype.handleOnKeyUp = function handleOnKeyUp(e) {
    var code = (0, _utils.keyCode)(e);
    if (code == ESC && !this.disableCancel) {
      this.handleCancelClick();
    } else if (code == ESC && this.disableCancel) {
      this.handleConfirmClick();
    } else if (code == ENTER && this.isKeyDown) {
      this.isKeyDown = false;
      this.handleConfirmClick();
    }
  };

  ToastrConfirm.prototype.containsOkButton = function containsOkButton(buttons) {
    return buttons && buttons.filter(function (button) {
      return button.ok === true;
    }).length > 0;
  };

  ToastrConfirm.prototype.containsCancelButton = function containsCancelButton(buttons) {
    return buttons && buttons.filter(function (button) {
      return button.cancel === true;
    }).length > 0;
  };

  ToastrConfirm.prototype.getCustomButtonHandler = function getCustomButtonHandler(config) {
    var _this3 = this;

    if (config.ok === true) {
      return this.handleConfirmClick.bind(this);
    }
    if (config.cancel === true) {
      return this.handleCancelClick.bind(this);
    }
    return function () {
      return _this3.handleButtonClick(config.handler);
    };
  };

  ToastrConfirm.prototype.getCustomButtonText = function getCustomButtonText(config) {
    if (config.ok === true) {
      return this.okText;
    }
    if (config.cancel === true) {
      return this.cancelText;
    }
    return config.text;
  };

  ToastrConfirm.prototype.getCustomButtonClassName = function getCustomButtonClassName(config) {
    if (config.ok === true) {
      return 'rrt-ok-btn';
    }
    if (config.cancel === true) {
      return 'rrt-cancel-btn';
    }
    return config.className;
  };

  ToastrConfirm.prototype.render = function render() {
    var _this4 = this;

    var _props$confirm = this.props.confirm,
        options = _props$confirm.options,
        message = _props$confirm.message;


    return _react2.default.createElement(
      'div',
      {
        className: 'rrt-confirm-holder',
        tabIndex: '-1',
        ref: function ref(_ref2) {
          return _this4.confirmHolderElement = _ref2;
        },
        onKeyDown: this.handleOnKeyDown,
        onKeyUp: this.handleOnKeyUp,
        role: 'alert'
      },
      _react2.default.createElement(
        'div',
        { className: 'rrt-confirm animated', ref: function ref(_ref) {
            return _this4.confirmElement = _ref;
          } },
        message && _react2.default.createElement(
          'div',
          { className: 'rrt-message' },
          message
        ),
        options.component && _react2.default.createElement(options.component, null),
        _react2.default.createElement(
          'div',
          { className: 'rrt-buttons-holder' },
          !this.containsOkButton(options.buttons) && _react2.default.createElement(
            _Button2.default,
            { className: 'rrt-ok-btn', onClick: function onClick() {
                return _this4.handleConfirmClick();
              } },
            this.okText
          ),
          !this.disableCancel && !this.containsCancelButton(options.buttons) && _react2.default.createElement(
            _Button2.default,
            { className: 'rrt-cancel-btn', onClick: this.handleCancelClick.bind(this) },
            this.cancelText
          ),
          options.buttons && options.buttons.map(function (button, index) {
            if (button.cancel === true && _this4.disableCancel) {
              return null;
            }

            var handler = _this4.getCustomButtonHandler(button);
            var text = _this4.getCustomButtonText(button);
            var className = _this4.getCustomButtonClassName(button);

            return _react2.default.createElement(
              _Button2.default,
              { className: className, onClick: handler, key: index },
              text
            );
          })
        )
      ),
      _react2.default.createElement('div', { className: 'shadow' })
    );
  };

  return ToastrConfirm;
}(_react2.default.Component);

ToastrConfirm.displayName = 'ToastrConfirm';
ToastrConfirm.propTypes = {
  confirm: _propTypes2.default.shape({
    options: _propTypes2.default.shape({
      transitionIn: _propTypes2.default.string,
      transitionOut: _propTypes2.default.string
    })
  })
};
exports.default = ToastrConfirm;

/***/ }),
/* 3066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (name) {
  switch (name) {
    case 'success':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'M27 4l-15 15-7-7-5 5 12 12 20-20z' })
      );
    case 'info':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'M14 9.5c0-0.825 0.675-1.5 1.5-1.5h1c0.825 0 1.5 0.675 1.5 1.5v1c0 0.825-0.675 1.5-1.5 1.5h-1c-0.825 0-1.5-0.675-1.5-1.5v-1z' }),
        _react2.default.createElement('path', { d: 'M20 24h-8v-2h2v-6h-2v-2h6v8h2z' }),
        _react2.default.createElement('path', { d: 'M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13z' })
      );
    case 'warning':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'M16 2.899l13.409 26.726h-26.819l13.409-26.726zM16 0c-0.69 0-1.379 0.465-1.903 1.395l-13.659 27.222c-1.046 1.86-0.156 3.383 1.978 3.383h27.166c2.134 0 3.025-1.522 1.978-3.383h0l-13.659-27.222c-0.523-0.93-1.213-1.395-1.903-1.395v0z' }),
        _react2.default.createElement('path', { d: 'M18 26c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z' }),
        _react2.default.createElement('path', { d: 'M16 22c-1.105 0-2-0.895-2-2v-6c0-1.105 0.895-2 2-2s2 0.895 2 2v6c0 1.105-0.895 2-2 2z' })
      );
    case 'error':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'M12,0C5.373,0,0,5.373,0,12s5.373,12,12,12s12-5.373,12-12S18.627,0,12,0z M12,19.66 c-0.938,0-1.58-0.723-1.58-1.66c0-0.964,0.669-1.66,1.58-1.66c0.963,0,1.58,0.696,1.58,1.66C13.58,18.938,12.963,19.66,12,19.66z M12.622,13.321c-0.239,0.815-0.992,0.829-1.243,0c-0.289-0.956-1.316-4.585-1.316-6.942c0-3.11,3.891-3.125,3.891,0 C13.953,8.75,12.871,12.473,12.622,13.321z' })
      );
    default:
      return null;
  }
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 3067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),
/* 3068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(3069);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 3069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 3070 */,
/* 3071 */,
/* 3072 */,
/* 3073 */,
/* 3074 */,
/* 3075 */,
/* 3076 */,
/* 3077 */,
/* 3078 */,
/* 3079 */,
/* 3080 */,
/* 3081 */,
/* 3082 */,
/* 3083 */,
/* 3084 */,
/* 3085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(3097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(592);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 3086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(3098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(592);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 3087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(1119);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 3088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(1112);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 3089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(1120);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 3090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(1121);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 3091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(1122);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 3092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(1123);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 3093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(403);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 3094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(1124);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 3095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 3096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 3097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(69);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(105);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(1115);

var _PathUtils = __webpack_require__(593);

var _createTransitionManager = __webpack_require__(1116);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(1114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 3098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(69);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(105);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(1115);

var _PathUtils = __webpack_require__(593);

var _createTransitionManager = __webpack_require__(1116);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(1114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 3099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(3095);
var invariant = __webpack_require__(3096);
var ReactPropTypesSecret = __webpack_require__(3100);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 3100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 3101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 3102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 3103 */,
/* 3104 */,
/* 3105 */,
/* 3106 */,
/* 3107 */,
/* 3108 */,
/* 3109 */,
/* 3110 */,
/* 3111 */,
/* 3112 */,
/* 3113 */,
/* 3114 */,
/* 3115 */,
/* 3116 */,
/* 3117 */,
/* 3118 */,
/* 3119 */,
/* 3120 */,
/* 3121 */,
/* 3122 */,
/* 3123 */,
/* 3124 */,
/* 3125 */,
/* 3126 */,
/* 3127 */,
/* 3128 */,
/* 3129 */,
/* 3130 */,
/* 3131 */,
/* 3132 */,
/* 3133 */,
/* 3134 */,
/* 3135 */,
/* 3136 */,
/* 3137 */,
/* 3138 */,
/* 3139 */,
/* 3140 */,
/* 3141 */,
/* 3142 */,
/* 3143 */,
/* 3144 */,
/* 3145 */,
/* 3146 */,
/* 3147 */,
/* 3148 */,
/* 3149 */,
/* 3150 */,
/* 3151 */,
/* 3152 */,
/* 3153 */,
/* 3154 */,
/* 3155 */,
/* 3156 */,
/* 3157 */,
/* 3158 */,
/* 3159 */,
/* 3160 */,
/* 3161 */,
/* 3162 */,
/* 3163 */,
/* 3164 */,
/* 3165 */,
/* 3166 */,
/* 3167 */,
/* 3168 */,
/* 3169 */,
/* 3170 */,
/* 3171 */,
/* 3172 */,
/* 3173 */,
/* 3174 */,
/* 3175 */,
/* 3176 */,
/* 3177 */,
/* 3178 */,
/* 3179 */,
/* 3180 */,
/* 3181 */,
/* 3182 */,
/* 3183 */,
/* 3184 */,
/* 3185 */,
/* 3186 */,
/* 3187 */,
/* 3188 */,
/* 3189 */,
/* 3190 */,
/* 3191 */,
/* 3192 */,
/* 3193 */,
/* 3194 */,
/* 3195 */,
/* 3196 */,
/* 3197 */,
/* 3198 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127)))

/***/ }),
/* 3199 */,
/* 3200 */,
/* 3201 */,
/* 3202 */,
/* 3203 */,
/* 3204 */,
/* 3205 */,
/* 3206 */,
/* 3207 */,
/* 3208 */,
/* 3209 */,
/* 3210 */,
/* 3211 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127)))

/***/ }),
/* 3212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsolute = function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
};

// About 1.5x faster than the two-arg version of Array#splice()
var spliceOne = function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }list.pop();
};

// This implementation is based heavily on node's url.parse
var resolvePathname = function resolvePathname(to) {
  var from = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
};

module.exports = resolvePathname;

/***/ }),
/* 3213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var encode = __webpack_require__(1147);
var alphabet = __webpack_require__(405);

// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var REDUCE_TIME = 1459707606518;

// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var version = 6;

// Counter is used when shortid is called multiple times in one second.
var counter;

// Remember the last time shortid was called in case counter is needed.
var previousSeconds;

/**
 * Generate unique id
 * Returns string id
 */
function build(clusterWorkerId) {

    var str = '';

    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);

    if (seconds === previousSeconds) {
        counter++;
    } else {
        counter = 0;
        previousSeconds = seconds;
    }

    str = str + encode(alphabet.lookup, version);
    str = str + encode(alphabet.lookup, clusterWorkerId);
    if (counter > 0) {
        str = str + encode(alphabet.lookup, counter);
    }
    str = str + encode(alphabet.lookup, seconds);

    return str;
}

module.exports = build;


/***/ }),
/* 3214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(405);

/**
 * Decode the id to get the version and worker
 * Mainly for debugging and testing.
 * @param id - the shortid-generated id.
 */
function decode(id) {
    var characters = alphabet.shuffled();
    return {
        version: characters.indexOf(id.substr(0, 1)) & 0x0f,
        worker: characters.indexOf(id.substr(1, 1)) & 0x0f
    };
}

module.exports = decode;


/***/ }),
/* 3215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(405);
var encode = __webpack_require__(1147);
var decode = __webpack_require__(3214);
var build = __webpack_require__(3213);
var isValid = __webpack_require__(3216);

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var clusterWorkerId = __webpack_require__(3219) || 0;

/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */
function seed(seedValue) {
    alphabet.seed(seedValue);
    return module.exports;
}

/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */
function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
}

/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */
function characters(newCharacters) {
    if (newCharacters !== undefined) {
        alphabet.characters(newCharacters);
    }

    return alphabet.shuffled();
}

/**
 * Generate unique id
 * Returns string id
 */
function generate() {
  return build(clusterWorkerId);
}

// Export all other functions as properties of the generate function
module.exports = generate;
module.exports.generate = generate;
module.exports.seed = seed;
module.exports.worker = worker;
module.exports.characters = characters;
module.exports.decode = decode;
module.exports.isValid = isValid;


/***/ }),
/* 3216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(405);

function isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6 ) {
        return false;
    }

    var characters = alphabet.characters();
    var len = id.length;
    for(var i = 0; i < len;i++) {
        if (characters.indexOf(id[i]) === -1) {
            return false;
        }
    }
    return true;
}

module.exports = isShortId;


/***/ }),
/* 3217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

function randomByte() {
    if (!crypto || !crypto.getRandomValues) {
        return Math.floor(Math.random() * 256) & 0x30;
    }
    var dest = new Uint8Array(1);
    crypto.getRandomValues(dest);
    return dest[0] & 0x30;
}

module.exports = randomByte;


/***/ }),
/* 3218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)

var seed = 1;

/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */
function getNextValue() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed/(233280.0);
}

function setSeed(_seed_) {
    seed = _seed_;
}

module.exports = {
    nextValue: getNextValue,
    seed: setSeed
};


/***/ }),
/* 3219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = 0;


/***/ }),
/* 3220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 3221 */,
/* 3222 */,
/* 3223 */,
/* 3224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["a"] = (warning);


/***/ }),
/* 3225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createUncontrollable;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(105);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(3226);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createUncontrollable(mixin, set) {

  return uncontrollable;

  function uncontrollable(Component, controlledValues) {
    var _class, _temp;

    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var displayName = Component.displayName || Component.name || 'Component',
        basePropTypes = utils.getType(Component).propTypes,
        isCompositeComponent = utils.isReactComponent(Component),
        controlledProps = Object.keys(controlledValues),
        propTypes;

    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));

    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);

    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));

    methods = utils.transform(methods, function (obj, method) {
      obj[method] = function () {
        var _refs$inner;

        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
      };
    }, {});

    var component = (_temp = _class = function (_React$Component) {
      _inherits(component, _React$Component);

      function component() {
        _classCallCheck(this, component);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
      }

      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
      };

      component.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        var props = this.props;

        this._values = {};

        controlledProps.forEach(function (key) {
          _this2._values[key] = props[utils.defaultKey(key)];
        });
      };

      /**
       * If a prop switches from controlled to Uncontrolled
       * reset its value to the defaultValue
       */


      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;

        var props = this.props;

        if (mixin.componentWillReceiveProps) {
          mixin.componentWillReceiveProps.call(this, nextProps);
        }

        controlledProps.forEach(function (key) {
          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
            _this3._values[key] = nextProps[utils.defaultKey(key)];
          }
        });
      };

      component.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounted = true;
      };

      component.prototype.getControlledInstance = function getControlledInstance() {
        return this.refs.inner;
      };

      component.prototype.render = function render() {
        var _this4 = this;

        var newProps = {},
            props = omitProps(this.props);

        utils.each(controlledValues, function (handle, propName) {
          var linkPropName = utils.getLinkName(propName),
              prop = _this4.props[propName];

          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
            prop = _this4.props[linkPropName].value;
          }

          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];

          newProps[handle] = setAndNotify.bind(_this4, propName);
        });

        newProps = _extends({}, props, newProps, {
          ref: isCompositeComponent ? 'inner' : null
        });

        return _react2.default.createElement(Component, newProps);
      };

      return component;
    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);

    _extends(component.prototype, methods);

    component.ControlledComponent = Component;

    /**
     * useful when wrapping a Component and you want to control
     * everything
     */
    component.deferControlTo = function (newComponent) {
      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var nextMethods = arguments[2];

      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
    };

    return component;

    function setAndNotify(propName, value) {
      var linkName = utils.getLinkName(propName),
          handler = this.props[controlledValues[propName]];

      if (linkName && isProp(this.props, linkName) && !handler) {
        handler = this.props[linkName].requestChange;
      }

      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      set(this, propName, handler, value, args);
    }

    function isProp(props, prop) {
      return props[prop] !== undefined;
    }

    function omitProps(props) {
      var result = {};

      utils.each(props, function (value, key) {
        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
      });

      return result;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 3226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.version = undefined;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.getType = getType;
exports.getValue = getValue;
exports.getLinkName = getLinkName;
exports.defaultKey = defaultKey;
exports.chain = chain;
exports.transform = transform;
exports.each = each;
exports.has = has;
exports.isReactComponent = isReactComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(105);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
  var propTypes = {};

  if (false) {
    transform(controlledValues, function (obj, handler, prop) {
      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);

      obj[prop] = readOnlyPropType(handler, displayName);
    }, propTypes);
  }

  return propTypes;
}

var version = exports.version = _react2.default.version.split('.').map(parseFloat);

function getType(component) {
  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;

  return component.type;
}

function getValue(props, name) {
  var linkPropName = getLinkName(name);

  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;

  return props[name];
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function getLinkName(name) {
  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}

function chain(thisArg, a, b) {
  return function chainedFunction() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    a && a.call.apply(a, [thisArg].concat(args));
    b && b.call.apply(b, [thisArg].concat(args));
  };
}

function transform(obj, cb, seed) {
  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
  return seed;
}

function each(obj, cb, thisArg) {
  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);

  for (var key in obj) {
    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
  }
}

function has(o, k) {
  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
function isReactComponent(component) {
  return !!(component && component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 3227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var valueEqual = function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    if (!Array.isArray(b) || a.length !== b.length) return false;

    return a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
};

exports.default = valueEqual;

/***/ })
],[2473]);


// WEBPACK FOOTER //
// bundle.js